/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		3:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + ({}[chunkId]||chunkId) + ".bundle.js?" + "5515a08466bd22608a65" + "";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "app/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _app = __webpack_require__(1);
	
	var _routes = __webpack_require__(1537);
	
	var _reducersMain = __webpack_require__(2097);
	
	var _reducersMain2 = _interopRequireDefault(_reducersMain);
	
	var _api = __webpack_require__(584);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _app2 = __webpack_require__(864);
	
	var _user = __webpack_require__(862);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// we shouldn't redirect these URLs because we want to handle them differently
	var WHITELIST_FORBIDDEN_URLS = [
	// on dashboards, we show permission errors for individual cards we don't have access to
	/api\/card\/\d+\/query$/,
	// metadata endpoints should not cause redirects
	// we should gracefully handle cases where we don't have access to metadata
	/api\/database\/\d+\/metadata$/, /api\/database\/\d+\/fields/, /api\/field\/\d+\/values/, /api\/table\/\d+\/query_metadata$/, /api\/table\/\d+\/fks$/];
	
	(0, _app.init)(_reducersMain2.default, _routes.getRoutes, function (store) {
	    // received a 401 response
	    _api2.default.on("401", function (url) {
	        if (url.indexOf("/api/user/current") >= 0) {
	            return;
	        }
	        store.dispatch((0, _user.clearCurrentUser)());
	        store.dispatch((0, _reactRouterRedux.push)("/auth/login"));
	    });
	
	    // received a 403 response
	    _api2.default.on("403", function (url) {
	        if (url) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = WHITELIST_FORBIDDEN_URLS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var regex = _step.value;
	
	                    if (regex.test(url)) {
	                        return;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	        store.dispatch((0, _app2.setErrorPage)({ status: 403 }));
	    });
	});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.init = init;
	
	__webpack_require__(2);
	
	__webpack_require__(299);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(467);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _api = __webpack_require__(584);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _store = __webpack_require__(588);
	
	var _settings3 = __webpack_require__(656);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _history = __webpack_require__(1183);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// remove trailing slash
	var BASENAME = window.MetabaseRoot.replace(/\/+$/, ""); /*  weak */
	
	_api2.default.basename = BASENAME;
	
	var browserHistory = (0, _reactRouter.useRouterHistory)(_history.createHistory)({
	    basename: BASENAME
	});
	
	function _init(reducers, getRoutes, callback) {
	    var store = (0, _store.getStore)(reducers, browserHistory);
	    var routes = getRoutes(store);
	    var history = (0, _reactRouterRedux.syncHistoryWithStore)(browserHistory, store);
	
	    _reactDom2.default.render(_react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store },
	        _react2.default.createElement(
	            _reactRouter.Router,
	            { history: history },
	            routes
	        )
	    ), document.getElementById('root'));
	
	    // listen for location changes and use that as a trigger for page view tracking
	    history.listen(function (location) {
	        _analytics2.default.trackPageView(location.pathname);
	    });
	
	    (0, _analytics.registerAnalyticsClickListener)();
	
	    store.dispatch((0, _settings3.refreshSiteSettings)());
	
	    // enable / disable GA based on opt-out of anonymous tracking
	    _settings2.default.on("anon_tracking_enabled", function () {
	        window['ga-disable-' + _settings2.default.get('ga_code')] = _settings2.default.isTrackingEnabled() ? null : true;
	    });
	
	    if (callback) {
	        callback(store);
	    }
	}
	
	function init() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	    }
	
	    if (document.readyState != 'loading') {
	        _init.apply(undefined, args);
	    } else {
	        document.addEventListener('DOMContentLoaded', function () {
	            return _init.apply(undefined, args);
	        });
	    }
	}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(3);
	
	__webpack_require__(294);
	
	__webpack_require__(296);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(56);
	__webpack_require__(58);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(69);
	__webpack_require__(71);
	__webpack_require__(73);
	__webpack_require__(75);
	__webpack_require__(77);
	__webpack_require__(80);
	__webpack_require__(81);
	__webpack_require__(82);
	__webpack_require__(86);
	__webpack_require__(88);
	__webpack_require__(90);
	__webpack_require__(93);
	__webpack_require__(94);
	__webpack_require__(95);
	__webpack_require__(96);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(104);
	__webpack_require__(106);
	__webpack_require__(107);
	__webpack_require__(108);
	__webpack_require__(110);
	__webpack_require__(111);
	__webpack_require__(112);
	__webpack_require__(114);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(132);
	__webpack_require__(133);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(140);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(160);
	__webpack_require__(161);
	__webpack_require__(167);
	__webpack_require__(168);
	__webpack_require__(170);
	__webpack_require__(171);
	__webpack_require__(172);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(188);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(194);
	__webpack_require__(196);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(200);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(205);
	__webpack_require__(212);
	__webpack_require__(215);
	__webpack_require__(216);
	__webpack_require__(218);
	__webpack_require__(219);
	__webpack_require__(222);
	__webpack_require__(223);
	__webpack_require__(225);
	__webpack_require__(226);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(277);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(289);
	__webpack_require__(292);
	__webpack_require__(293);
	module.exports = __webpack_require__(10);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(5)
	  , has            = __webpack_require__(6)
	  , DESCRIPTORS    = __webpack_require__(7)
	  , $export        = __webpack_require__(9)
	  , redefine       = __webpack_require__(19)
	  , META           = __webpack_require__(23).KEY
	  , $fails         = __webpack_require__(8)
	  , shared         = __webpack_require__(24)
	  , setToStringTag = __webpack_require__(25)
	  , uid            = __webpack_require__(20)
	  , wks            = __webpack_require__(26)
	  , wksExt         = __webpack_require__(27)
	  , wksDefine      = __webpack_require__(28)
	  , keyOf          = __webpack_require__(30)
	  , enumKeys       = __webpack_require__(43)
	  , isArray        = __webpack_require__(46)
	  , anObject       = __webpack_require__(13)
	  , toIObject      = __webpack_require__(33)
	  , toPrimitive    = __webpack_require__(17)
	  , createDesc     = __webpack_require__(18)
	  , _create        = __webpack_require__(47)
	  , gOPNExt        = __webpack_require__(50)
	  , $GOPD          = __webpack_require__(52)
	  , $DP            = __webpack_require__(12)
	  , $keys          = __webpack_require__(31)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(51).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(45).f  = $propertyIsEnumerable;
	  __webpack_require__(44).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(29)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(11)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(8)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(5)
	  , core      = __webpack_require__(10)
	  , hide      = __webpack_require__(11)
	  , redefine  = __webpack_require__(19)
	  , ctx       = __webpack_require__(21)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(12)
	  , createDesc = __webpack_require__(18);
	module.exports = __webpack_require__(7) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(13)
	  , IE8_DOM_DEFINE = __webpack_require__(15)
	  , toPrimitive    = __webpack_require__(17)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(7) && !__webpack_require__(8)(function(){
	  return Object.defineProperty(__webpack_require__(16)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14)
	  , document = __webpack_require__(5).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(14);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(5)
	  , hide      = __webpack_require__(11)
	  , has       = __webpack_require__(6)
	  , SRC       = __webpack_require__(20)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(10).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(22);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(20)('meta')
	  , isObject = __webpack_require__(14)
	  , has      = __webpack_require__(6)
	  , setDesc  = __webpack_require__(12).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(8)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(12).f
	  , has = __webpack_require__(6)
	  , TAG = __webpack_require__(26)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(24)('wks')
	  , uid        = __webpack_require__(20)
	  , Symbol     = __webpack_require__(5).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(26);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(5)
	  , core           = __webpack_require__(10)
	  , LIBRARY        = __webpack_require__(29)
	  , wksExt         = __webpack_require__(27)
	  , defineProperty = __webpack_require__(12).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = false;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(31)
	  , toIObject = __webpack_require__(33);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(32)
	  , enumBugKeys = __webpack_require__(42);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(6)
	  , toIObject    = __webpack_require__(33)
	  , arrayIndexOf = __webpack_require__(37)(false)
	  , IE_PROTO     = __webpack_require__(41)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(34)
	  , defined = __webpack_require__(36);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(35);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(33)
	  , toLength  = __webpack_require__(38)
	  , toIndex   = __webpack_require__(40);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(39)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(24)('keys')
	  , uid    = __webpack_require__(20);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(31)
	  , gOPS    = __webpack_require__(44)
	  , pIE     = __webpack_require__(45);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(35);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(13)
	  , dPs         = __webpack_require__(48)
	  , enumBugKeys = __webpack_require__(42)
	  , IE_PROTO    = __webpack_require__(41)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(16)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(49).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(12)
	  , anObject = __webpack_require__(13)
	  , getKeys  = __webpack_require__(31);
	
	module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(5).document && document.documentElement;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(33)
	  , gOPN      = __webpack_require__(51).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(32)
	  , hiddenKeys = __webpack_require__(42).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(45)
	  , createDesc     = __webpack_require__(18)
	  , toIObject      = __webpack_require__(33)
	  , toPrimitive    = __webpack_require__(17)
	  , has            = __webpack_require__(6)
	  , IE8_DOM_DEFINE = __webpack_require__(15)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(7) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(47)});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(7), 'Object', {defineProperty: __webpack_require__(12).f});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(7), 'Object', {defineProperties: __webpack_require__(48)});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(33)
	  , $getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	__webpack_require__(57)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(9)
	  , core    = __webpack_require__(10)
	  , fails   = __webpack_require__(8);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(59)
	  , $getPrototypeOf = __webpack_require__(60);
	
	__webpack_require__(57)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(36);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(6)
	  , toObject    = __webpack_require__(59)
	  , IE_PROTO    = __webpack_require__(41)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(59)
	  , $keys    = __webpack_require__(31);
	
	__webpack_require__(57)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(57)('getOwnPropertyNames', function(){
	  return __webpack_require__(50).f;
	});

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(23).onFreeze;
	
	__webpack_require__(57)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(23).onFreeze;
	
	__webpack_require__(57)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(23).onFreeze;
	
	__webpack_require__(57)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(57)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(57)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(57)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(9);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(70)});

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(31)
	  , gOPS     = __webpack_require__(44)
	  , pIE      = __webpack_require__(45)
	  , toObject = __webpack_require__(59)
	  , IObject  = __webpack_require__(34)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(8)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(9);
	$export($export.S, 'Object', {is: __webpack_require__(72)});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(9);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(74).set});

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(14)
	  , anObject = __webpack_require__(13);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(21)(Function.call, __webpack_require__(52).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(76)
	  , test    = {};
	test[__webpack_require__(26)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(19)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(35)
	  , TAG = __webpack_require__(26)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Function', {bind: __webpack_require__(78)});

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(22)
	  , isObject   = __webpack_require__(14)
	  , invoke     = __webpack_require__(79)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(12).f
	  , createDesc = __webpack_require__(18)
	  , has        = __webpack_require__(6)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(7) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(14)
	  , getPrototypeOf = __webpack_require__(60)
	  , HAS_INSTANCE   = __webpack_require__(26)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(12).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(9)
	  , $parseInt = __webpack_require__(83);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(5).parseInt
	  , $trim     = __webpack_require__(84).trim
	  , ws        = __webpack_require__(85)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9)
	  , defined = __webpack_require__(36)
	  , fails   = __webpack_require__(8)
	  , spaces  = __webpack_require__(85)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(9)
	  , $parseFloat = __webpack_require__(87);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(5).parseFloat
	  , $trim       = __webpack_require__(84).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(85) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(5)
	  , has               = __webpack_require__(6)
	  , cof               = __webpack_require__(35)
	  , inheritIfRequired = __webpack_require__(89)
	  , toPrimitive       = __webpack_require__(17)
	  , fails             = __webpack_require__(8)
	  , gOPN              = __webpack_require__(51).f
	  , gOPD              = __webpack_require__(52).f
	  , dP                = __webpack_require__(12).f
	  , $trim             = __webpack_require__(84).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(47)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(7) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(19)(global, NUMBER, $Number);
	}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(14)
	  , setPrototypeOf = __webpack_require__(74).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(9)
	  , toInteger    = __webpack_require__(39)
	  , aNumberValue = __webpack_require__(91)
	  , repeat       = __webpack_require__(92)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(8)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(35);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(39)
	  , defined   = __webpack_require__(36);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(9)
	  , $fails       = __webpack_require__(8)
	  , aNumberValue = __webpack_require__(91)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(9)
	  , _isFinite = __webpack_require__(5).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(97)});

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(14)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(9)
	  , isInteger = __webpack_require__(97)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(9)
	  , $parseFloat = __webpack_require__(87);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(9)
	  , $parseInt = __webpack_require__(83);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(9)
	  , log1p   = __webpack_require__(105)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(9)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(9)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(9)
	  , sign    = __webpack_require__(109);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(9)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(9)
	  , $expm1  = __webpack_require__(113);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(9)
	  , sign      = __webpack_require__(109)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(9)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(9)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(105)});

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {sign: __webpack_require__(109)});

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(9)
	  , expm1   = __webpack_require__(113)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(9)
	  , expm1   = __webpack_require__(113)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(9)
	  , toIndex        = __webpack_require__(40)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(9)
	  , toIObject = __webpack_require__(33)
	  , toLength  = __webpack_require__(38);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(84)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(128)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(129)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39)
	  , defined   = __webpack_require__(36);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(29)
	  , $export        = __webpack_require__(9)
	  , redefine       = __webpack_require__(19)
	  , hide           = __webpack_require__(11)
	  , has            = __webpack_require__(6)
	  , Iterators      = __webpack_require__(130)
	  , $iterCreate    = __webpack_require__(131)
	  , setToStringTag = __webpack_require__(25)
	  , getPrototypeOf = __webpack_require__(60)
	  , ITERATOR       = __webpack_require__(26)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(47)
	  , descriptor     = __webpack_require__(18)
	  , setToStringTag = __webpack_require__(25)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(11)(IteratorPrototype, __webpack_require__(26)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $at     = __webpack_require__(128)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(9)
	  , toLength  = __webpack_require__(38)
	  , context   = __webpack_require__(134)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(135)
	  , defined  = __webpack_require__(36);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(14)
	  , cof      = __webpack_require__(35)
	  , MATCH    = __webpack_require__(26)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(26)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(9)
	  , context  = __webpack_require__(134)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(136)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(92)
	});

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(9)
	  , toLength    = __webpack_require__(38)
	  , context     = __webpack_require__(134)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(141)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9)
	  , fails   = __webpack_require__(8)
	  , defined = __webpack_require__(36)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(141)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(141)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(141)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(141)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(141)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(141)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(141)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(141)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(141)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(141)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(141)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(141)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(9)
	  , toObject    = __webpack_require__(59)
	  , toPrimitive = __webpack_require__(17);
	
	$export($export.P + $export.F * __webpack_require__(8)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(9)
	  , fails   = __webpack_require__(8)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(19)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(26)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(11)(proto, TO_PRIMITIVE, __webpack_require__(159));

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(13)
	  , toPrimitive = __webpack_require__(17)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(46)});

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(21)
	  , $export        = __webpack_require__(9)
	  , toObject       = __webpack_require__(59)
	  , call           = __webpack_require__(162)
	  , isArrayIter    = __webpack_require__(163)
	  , toLength       = __webpack_require__(38)
	  , createProperty = __webpack_require__(164)
	  , getIterFn      = __webpack_require__(165);
	
	$export($export.S + $export.F * !__webpack_require__(166)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(13);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(130)
	  , ITERATOR   = __webpack_require__(26)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(12)
	  , createDesc      = __webpack_require__(18);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(76)
	  , ITERATOR  = __webpack_require__(26)('iterator')
	  , Iterators = __webpack_require__(130);
	module.exports = __webpack_require__(10).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(26)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(9)
	  , createProperty = __webpack_require__(164);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(9)
	  , toIObject = __webpack_require__(33)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(34) != Object || !__webpack_require__(169)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(8);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(9)
	  , html       = __webpack_require__(49)
	  , cof        = __webpack_require__(35)
	  , toIndex    = __webpack_require__(40)
	  , toLength   = __webpack_require__(38)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(8)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(9)
	  , aFunction = __webpack_require__(22)
	  , toObject  = __webpack_require__(59)
	  , fails     = __webpack_require__(8)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(169)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(9)
	  , $forEach = __webpack_require__(173)(0)
	  , STRICT   = __webpack_require__(169)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(21)
	  , IObject  = __webpack_require__(34)
	  , toObject = __webpack_require__(59)
	  , toLength = __webpack_require__(38)
	  , asc      = __webpack_require__(174);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(175);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14)
	  , isArray  = __webpack_require__(46)
	  , SPECIES  = __webpack_require__(26)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $map    = __webpack_require__(173)(1);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $filter = __webpack_require__(173)(2);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $some   = __webpack_require__(173)(3);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $every  = __webpack_require__(173)(4);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $reduce = __webpack_require__(181);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(22)
	  , toObject  = __webpack_require__(59)
	  , IObject   = __webpack_require__(34)
	  , toLength  = __webpack_require__(38);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $reduce = __webpack_require__(181);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(9)
	  , $indexOf      = __webpack_require__(37)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(169)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(9)
	  , toIObject     = __webpack_require__(33)
	  , toInteger     = __webpack_require__(39)
	  , toLength      = __webpack_require__(38)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(169)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(186)});
	
	__webpack_require__(187)('copyWithin');

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(59)
	  , toIndex  = __webpack_require__(40)
	  , toLength = __webpack_require__(38);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(26)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(11)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Array', {fill: __webpack_require__(189)});
	
	__webpack_require__(187)('fill');

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(59)
	  , toIndex  = __webpack_require__(40)
	  , toLength = __webpack_require__(38);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(9)
	  , $find   = __webpack_require__(173)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(187)(KEY);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(9)
	  , $find   = __webpack_require__(173)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(187)(KEY);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(193)('Array');

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(5)
	  , dP          = __webpack_require__(12)
	  , DESCRIPTORS = __webpack_require__(7)
	  , SPECIES     = __webpack_require__(26)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(187)
	  , step             = __webpack_require__(195)
	  , Iterators        = __webpack_require__(130)
	  , toIObject        = __webpack_require__(33);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(129)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 195 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(5)
	  , inheritIfRequired = __webpack_require__(89)
	  , dP                = __webpack_require__(12).f
	  , gOPN              = __webpack_require__(51).f
	  , isRegExp          = __webpack_require__(135)
	  , $flags            = __webpack_require__(197)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(7) && (!CORRECT_NEW || __webpack_require__(8)(function(){
	  re2[__webpack_require__(26)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(19)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(193)('RegExp');

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(13);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(199);
	var anObject    = __webpack_require__(13)
	  , $flags      = __webpack_require__(197)
	  , DESCRIPTORS = __webpack_require__(7)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(19)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(8)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(7) && /./g.flags != 'g')__webpack_require__(12).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(197)
	});

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(201)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(11)
	  , redefine = __webpack_require__(19)
	  , fails    = __webpack_require__(8)
	  , defined  = __webpack_require__(36)
	  , wks      = __webpack_require__(26);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(201)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(201)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(201)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(135)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(29)
	  , global             = __webpack_require__(5)
	  , ctx                = __webpack_require__(21)
	  , classof            = __webpack_require__(76)
	  , $export            = __webpack_require__(9)
	  , isObject           = __webpack_require__(14)
	  , aFunction          = __webpack_require__(22)
	  , anInstance         = __webpack_require__(206)
	  , forOf              = __webpack_require__(207)
	  , speciesConstructor = __webpack_require__(208)
	  , task               = __webpack_require__(209).set
	  , microtask          = __webpack_require__(210)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(26)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(211)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(25)($Promise, PROMISE);
	__webpack_require__(193)(PROMISE);
	Wrapper = __webpack_require__(10)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(166)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(21)
	  , call        = __webpack_require__(162)
	  , isArrayIter = __webpack_require__(163)
	  , anObject    = __webpack_require__(13)
	  , toLength    = __webpack_require__(38)
	  , getIterFn   = __webpack_require__(165)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(13)
	  , aFunction = __webpack_require__(22)
	  , SPECIES   = __webpack_require__(26)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(21)
	  , invoke             = __webpack_require__(79)
	  , html               = __webpack_require__(49)
	  , cel                = __webpack_require__(16)
	  , global             = __webpack_require__(5)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(35)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(5)
	  , macrotask = __webpack_require__(209).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(35)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(19);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(213);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(214)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(12).f
	  , create      = __webpack_require__(47)
	  , redefineAll = __webpack_require__(211)
	  , ctx         = __webpack_require__(21)
	  , anInstance  = __webpack_require__(206)
	  , defined     = __webpack_require__(36)
	  , forOf       = __webpack_require__(207)
	  , $iterDefine = __webpack_require__(129)
	  , step        = __webpack_require__(195)
	  , setSpecies  = __webpack_require__(193)
	  , DESCRIPTORS = __webpack_require__(7)
	  , fastKey     = __webpack_require__(23).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(5)
	  , $export           = __webpack_require__(9)
	  , redefine          = __webpack_require__(19)
	  , redefineAll       = __webpack_require__(211)
	  , meta              = __webpack_require__(23)
	  , forOf             = __webpack_require__(207)
	  , anInstance        = __webpack_require__(206)
	  , isObject          = __webpack_require__(14)
	  , fails             = __webpack_require__(8)
	  , $iterDetect       = __webpack_require__(166)
	  , setToStringTag    = __webpack_require__(25)
	  , inheritIfRequired = __webpack_require__(89);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(213);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(214)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(173)(0)
	  , redefine     = __webpack_require__(19)
	  , meta         = __webpack_require__(23)
	  , assign       = __webpack_require__(70)
	  , weak         = __webpack_require__(217)
	  , isObject     = __webpack_require__(14)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(214)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(211)
	  , getWeak           = __webpack_require__(23).getWeak
	  , anObject          = __webpack_require__(13)
	  , isObject          = __webpack_require__(14)
	  , anInstance        = __webpack_require__(206)
	  , forOf             = __webpack_require__(207)
	  , createArrayMethod = __webpack_require__(173)
	  , $has              = __webpack_require__(6)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(217);
	
	// 23.4 WeakSet Objects
	__webpack_require__(214)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(9)
	  , $typed       = __webpack_require__(220)
	  , buffer       = __webpack_require__(221)
	  , anObject     = __webpack_require__(13)
	  , toIndex      = __webpack_require__(40)
	  , toLength     = __webpack_require__(38)
	  , isObject     = __webpack_require__(14)
	  , ArrayBuffer  = __webpack_require__(5).ArrayBuffer
	  , speciesConstructor = __webpack_require__(208)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(8)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(193)(ARRAY_BUFFER);

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5)
	  , hide   = __webpack_require__(11)
	  , uid    = __webpack_require__(20)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(5)
	  , DESCRIPTORS    = __webpack_require__(7)
	  , LIBRARY        = __webpack_require__(29)
	  , $typed         = __webpack_require__(220)
	  , hide           = __webpack_require__(11)
	  , redefineAll    = __webpack_require__(211)
	  , fails          = __webpack_require__(8)
	  , anInstance     = __webpack_require__(206)
	  , toInteger      = __webpack_require__(39)
	  , toLength       = __webpack_require__(38)
	  , gOPN           = __webpack_require__(51).f
	  , dP             = __webpack_require__(12).f
	  , arrayFill      = __webpack_require__(189)
	  , setToStringTag = __webpack_require__(25)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	$export($export.G + $export.W + $export.F * !__webpack_require__(220).ABV, {
	  DataView: __webpack_require__(221).DataView
	});

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(7)){
	  var LIBRARY             = __webpack_require__(29)
	    , global              = __webpack_require__(5)
	    , fails               = __webpack_require__(8)
	    , $export             = __webpack_require__(9)
	    , $typed              = __webpack_require__(220)
	    , $buffer             = __webpack_require__(221)
	    , ctx                 = __webpack_require__(21)
	    , anInstance          = __webpack_require__(206)
	    , propertyDesc        = __webpack_require__(18)
	    , hide                = __webpack_require__(11)
	    , redefineAll         = __webpack_require__(211)
	    , toInteger           = __webpack_require__(39)
	    , toLength            = __webpack_require__(38)
	    , toIndex             = __webpack_require__(40)
	    , toPrimitive         = __webpack_require__(17)
	    , has                 = __webpack_require__(6)
	    , same                = __webpack_require__(72)
	    , classof             = __webpack_require__(76)
	    , isObject            = __webpack_require__(14)
	    , toObject            = __webpack_require__(59)
	    , isArrayIter         = __webpack_require__(163)
	    , create              = __webpack_require__(47)
	    , getPrototypeOf      = __webpack_require__(60)
	    , gOPN                = __webpack_require__(51).f
	    , getIterFn           = __webpack_require__(165)
	    , uid                 = __webpack_require__(20)
	    , wks                 = __webpack_require__(26)
	    , createArrayMethod   = __webpack_require__(173)
	    , createArrayIncludes = __webpack_require__(37)
	    , speciesConstructor  = __webpack_require__(208)
	    , ArrayIterators      = __webpack_require__(194)
	    , Iterators           = __webpack_require__(130)
	    , $iterDetect         = __webpack_require__(166)
	    , setSpecies          = __webpack_require__(193)
	    , arrayFill           = __webpack_require__(189)
	    , arrayCopyWithin     = __webpack_require__(186)
	    , $DP                 = __webpack_require__(12)
	    , $GOPD               = __webpack_require__(52)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(9)
	  , aFunction = __webpack_require__(22)
	  , anObject  = __webpack_require__(13)
	  , rApply    = (__webpack_require__(5).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(8)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(9)
	  , create     = __webpack_require__(47)
	  , aFunction  = __webpack_require__(22)
	  , anObject   = __webpack_require__(13)
	  , isObject   = __webpack_require__(14)
	  , fails      = __webpack_require__(8)
	  , bind       = __webpack_require__(78)
	  , rConstruct = (__webpack_require__(5).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(12)
	  , $export     = __webpack_require__(9)
	  , anObject    = __webpack_require__(13)
	  , toPrimitive = __webpack_require__(17);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(9)
	  , gOPD     = __webpack_require__(52).f
	  , anObject = __webpack_require__(13);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(9)
	  , anObject = __webpack_require__(13);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(131)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(52)
	  , getPrototypeOf = __webpack_require__(60)
	  , has            = __webpack_require__(6)
	  , $export        = __webpack_require__(9)
	  , isObject       = __webpack_require__(14)
	  , anObject       = __webpack_require__(13);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(52)
	  , $export  = __webpack_require__(9)
	  , anObject = __webpack_require__(13);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(9)
	  , getProto = __webpack_require__(60)
	  , anObject = __webpack_require__(13);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(9)
	  , anObject      = __webpack_require__(13)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(244)});

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(51)
	  , gOPS     = __webpack_require__(44)
	  , anObject = __webpack_require__(13)
	  , Reflect  = __webpack_require__(5).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(9)
	  , anObject           = __webpack_require__(13)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(12)
	  , gOPD           = __webpack_require__(52)
	  , getPrototypeOf = __webpack_require__(60)
	  , has            = __webpack_require__(6)
	  , $export        = __webpack_require__(9)
	  , createDesc     = __webpack_require__(18)
	  , anObject       = __webpack_require__(13)
	  , isObject       = __webpack_require__(14);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(9)
	  , setProto = __webpack_require__(74);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(9)
	  , $includes = __webpack_require__(37)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(187)('includes');

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(9)
	  , $at     = __webpack_require__(128)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(9)
	  , $pad    = __webpack_require__(251);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(38)
	  , repeat   = __webpack_require__(92)
	  , defined  = __webpack_require__(36);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(9)
	  , $pad    = __webpack_require__(251);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(84)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(84)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(9)
	  , defined     = __webpack_require__(36)
	  , toLength    = __webpack_require__(38)
	  , isRegExp    = __webpack_require__(135)
	  , getFlags    = __webpack_require__(197)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(131)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('asyncIterator');

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('observable');

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(9)
	  , ownKeys        = __webpack_require__(244)
	  , toIObject      = __webpack_require__(33)
	  , gOPD           = __webpack_require__(52)
	  , createProperty = __webpack_require__(164);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(9)
	  , $values = __webpack_require__(260)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(31)
	  , toIObject = __webpack_require__(33)
	  , isEnum    = __webpack_require__(45).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(9)
	  , $entries = __webpack_require__(260)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(9)
	  , toObject        = __webpack_require__(59)
	  , aFunction       = __webpack_require__(22)
	  , $defineProperty = __webpack_require__(12);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(29)|| !__webpack_require__(8)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(5)[K];
	});

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(9)
	  , toObject        = __webpack_require__(59)
	  , aFunction       = __webpack_require__(22)
	  , $defineProperty = __webpack_require__(12);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(9)
	  , toObject                 = __webpack_require__(59)
	  , toPrimitive              = __webpack_require__(17)
	  , getPrototypeOf           = __webpack_require__(60)
	  , getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(9)
	  , toObject                 = __webpack_require__(59)
	  , toPrimitive              = __webpack_require__(17)
	  , getPrototypeOf           = __webpack_require__(60)
	  , getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(9);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(268)('Map')});

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(76)
	  , from    = __webpack_require__(269);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(207);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(9);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(268)('Set')});

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(9);
	
	$export($export.S, 'System', {global: __webpack_require__(5)});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(9)
	  , cof     = __webpack_require__(35);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(278)
	  , anObject                  = __webpack_require__(13)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(212)
	  , $export = __webpack_require__(9)
	  , shared  = __webpack_require__(24)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(216)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , getPrototypeOf         = __webpack_require__(60)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(215)
	  , from                    = __webpack_require__(269)
	  , metadata                = __webpack_require__(278)
	  , anObject                = __webpack_require__(13)
	  , getPrototypeOf          = __webpack_require__(60)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(278)
	  , anObject                = __webpack_require__(13)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , getPrototypeOf         = __webpack_require__(60)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(278)
	  , anObject                  = __webpack_require__(13)
	  , aFunction                 = __webpack_require__(22)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(9)
	  , microtask = __webpack_require__(210)()
	  , process   = __webpack_require__(5).process
	  , isNode    = __webpack_require__(35)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(9)
	  , global      = __webpack_require__(5)
	  , core        = __webpack_require__(10)
	  , microtask   = __webpack_require__(210)()
	  , OBSERVABLE  = __webpack_require__(26)('observable')
	  , aFunction   = __webpack_require__(22)
	  , anObject    = __webpack_require__(13)
	  , anInstance  = __webpack_require__(206)
	  , redefineAll = __webpack_require__(211)
	  , hide        = __webpack_require__(11)
	  , forOf       = __webpack_require__(207)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(193)('Observable');

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(5)
	  , $export    = __webpack_require__(9)
	  , invoke     = __webpack_require__(79)
	  , partial    = __webpack_require__(290)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(291)
	  , invoke    = __webpack_require__(79)
	  , aFunction = __webpack_require__(22);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(5);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9)
	  , $task   = __webpack_require__(209);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(194)
	  , redefine      = __webpack_require__(19)
	  , global        = __webpack_require__(5)
	  , hide          = __webpack_require__(11)
	  , Iterators     = __webpack_require__(130)
	  , wks           = __webpack_require__(26)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(295)))

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(297);
	module.exports = __webpack_require__(10).RegExp.escape;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(9)
	  , $re     = __webpack_require__(298)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	// polyfill.number.toLocaleDateString
	/*jshint sub:true*/
	
	(function() {
	    'use strict';
	
	    // Got this from MDN:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString#Example:_Checking_for_support_for_locales_and_options_arguments
	    function toLocaleStringSupportsLocales() {
	        var number = 0;
	        try {
	            number.toLocaleString("i");
	        } catch (e) {
	            return e.name === "RangeError";
	        }
	        return false;
	    }
	
	    if (!toLocaleStringSupportsLocales()) {
	        var replaceSeparators = function(sNum, separators) {
	            var sNumParts = sNum.split('.');
	            if (separators && separators.thousands) {
	                sNumParts[0] = sNumParts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + separators.thousands);
	            }
	            sNum = sNumParts.join(separators.decimal);
	
	            return sNum;
	        };
	
	        var renderFormat = function(template, props) {
	            for (var prop in props) {
	                template = template.replace("{{" + prop + "}}", props[prop]);
	            }
	
	            return template;
	        };
	
	        var mapMatch = function(map, locale) {
	            var match = locale;
	            var language = locale && locale.toLowerCase().match(/^\w+/);
	
	            if (!map.hasOwnProperty(locale)) {
	                if (map.hasOwnProperty(language)) {
	                    match = language;
	                } else {
	                    match = "en";
	                }
	            }
	
	            return map[match];
	        };
	
	        var dotThousCommaDec = function(sNum) {
	            var separators = {
	                decimal: ',',
	                thousands: '.'
	            };
	
	            return replaceSeparators(sNum, separators);
	        };
	
	        var commaThousDotDec = function(sNum) {
	            var separators = {
	                decimal: '.',
	                thousands: ','
	            };
	
	            return replaceSeparators(sNum, separators);
	        };
	
	        var spaceThousCommaDec = function(sNum) {
	            var seperators = {
	                decimal: ',',
	                thousands: '\u00A0'
	            };
	
	            return replaceSeparators(sNum, seperators);
	        };
	        
	        var apostrophThousDotDec = function(sNum) {
	            var seperators = {
	                decimal: '.',
	                thousands: '\u0027'
	            };
	            
	            return replaceSeparators(sNum, seperators);
	        };
	
	        var transformForLocale = {
	            en: commaThousDotDec,
	            it: dotThousCommaDec,
	            fr: spaceThousCommaDec,
	            de: dotThousCommaDec,
	            "de-DE": dotThousCommaDec,
	            "de-AT": dotThousCommaDec,
	            "de-CH": apostrophThousDotDec,
	            "de-LI": apostrophThousDotDec,
	            "de-BE": dotThousCommaDec,
	            ro: dotThousCommaDec,
	            "ro-RO": dotThousCommaDec,
	            hu: spaceThousCommaDec,
	            "hu-HU": spaceThousCommaDec,
	            "da-DK": dotThousCommaDec,
	            "nb-NO": spaceThousCommaDec
	        };
	
	        var currencyFormatMap = {
	            en: "pre",
	            it: "post",
	            fr: "post",
	            de: "post",
	            "de-DE": "post",
	            "de-AT": "prespace",
	            "de-CH": "prespace",
	            "de-LI": "post",
	            "de-BE": "post",
	            ro: "post",
	            "ro-RO": "post",
	            hu: "post",
	            "hu-HU": "post",
	            "da-DK": "post",
	            "nb-NO": "post"
	        };
	
	        var currencySymbols = {
	            "afn": "؋",
	            "ars": "$",
	            "awg": "ƒ",
	            "aud": "$",
	            "azn": "₼",
	            "bsd": "$",
	            "bbd": "$",
	            "byr": "p.",
	            "bzd": "BZ$",
	            "bmd": "$",
	            "bob": "Bs.",
	            "bam": "KM",
	            "bwp": "P",
	            "bgn": "лв",
	            "brl": "R$",
	            "bnd": "$",
	            "khr": "៛",
	            "cad": "$",
	            "kyd": "$",
	            "clp": "$",
	            "cny": "¥",
	            "cop": "$",
	            "crc": "₡",
	            "hrk": "kn",
	            "cup": "₱",
	            "czk": "Kč",
	            "dkk": "kr",
	            "dop": "RD$",
	            "xcd": "$",
	            "egp": "£",
	            "svc": "$",
	            "eek": "kr",
	            "eur": "€",
	            "fkp": "£",
	            "fjd": "$",
	            "ghc": "¢",
	            "gip": "£",
	            "gtq": "Q",
	            "ggp": "£",
	            "gyd": "$",
	            "hnl": "L",
	            "hkd": "$",
	            "huf": "Ft",
	            "isk": "kr",
	            "inr": "₹",
	            "idr": "Rp",
	            "irr": "﷼",
	            "imp": "£",
	            "ils": "₪",
	            "jmd": "J$",
	            "jpy": "¥",
	            "jep": "£",
	            "kes": "KSh",
	            "kzt": "лв",
	            "kpw": "₩",
	            "krw": "₩",
	            "kgs": "лв",
	            "lak": "₭",
	            "lvl": "Ls",
	            "lbp": "£",
	            "lrd": "$",
	            "ltl": "Lt",
	            "mkd": "ден",
	            "myr": "RM",
	            "mur": "₨",
	            "mxn": "$",
	            "mnt": "₮",
	            "mzn": "MT",
	            "nad": "$",
	            "npr": "₨",
	            "ang": "ƒ",
	            "nzd": "$",
	            "nio": "C$",
	            "ngn": "₦",
	            "nok": "kr",
	            "omr": "﷼",
	            "pkr": "₨",
	            "pab": "B/.",
	            "pyg": "Gs",
	            "pen": "S/.",
	            "php": "₱",
	            "pln": "zł",
	            "qar": "﷼",
	            "ron": "lei",
	            "rub": "₽",
	            "shp": "£",
	            "sar": "﷼",
	            "rsd": "Дин.",
	            "scr": "₨",
	            "sgd": "$",
	            "sbd": "$",
	            "sos": "S",
	            "zar": "R",
	            "lkr": "₨",
	            "sek": "kr",
	            "chf": "CHF",
	            "srd": "$",
	            "syp": "£",
	            "tzs": "TSh",
	            "twd": "NT$",
	            "thb": "฿",
	            "ttd": "TT$",
	            "try": "",
	            "trl": "₤",
	            "tvd": "$",
	            "ugx": "USh",
	            "uah": "₴",
	            "gbp": "£",
	            "usd": "$",
	            "uyu": "$U",
	            "uzs": "лв",
	            "vef": "Bs",
	            "vnd": "₫",
	            "yer": "﷼",
	            "zwd": "Z$"
	        };
	
	        var currencyFormats = {
	            pre: "{{code}}{{num}}",
	            post: "{{num}} {{code}}",
	            prespace: "{{code}} {{num}}"
	        };
	
	        Number.prototype.toLocaleString = function(locale, options) {
	            if (locale && locale.length < 2)
	                throw new RangeError("Invalid language tag: " + locale);
	
	            var sNum;
	
	            if (options && options.minimumFractionDigits) {
	                sNum = this.toFixed(options.minimumFractionDigits);
	            } else {
	                sNum = this.toString();
	            }
	
	            sNum = mapMatch(transformForLocale, locale)(sNum, options);
	
	            if(options && options.currency && options.style === "currency") {
	                var format = currencyFormats[mapMatch(currencyFormatMap, locale)];
	                if(options.currencyDisplay === "code") {
	                    sNum = renderFormat(format, {
	                        num: sNum,
	                        code: options.currency.toUpperCase()
	                    });
	                } else {
	                    sNum = renderFormat(format, {
	                        num: sNum,
	                        code: currencySymbols[options.currency.toLowerCase()]
	                    });
	                }
	            }
	
	            return sNum;
	        };
	    }
	
	}());


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(301);


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var ReactChildren = __webpack_require__(303);
	var ReactComponent = __webpack_require__(316);
	var ReactPureComponent = __webpack_require__(319);
	var ReactClass = __webpack_require__(320);
	var ReactDOMFactories = __webpack_require__(322);
	var ReactElement = __webpack_require__(307);
	var ReactPropTypes = __webpack_require__(323);
	var ReactVersion = __webpack_require__(328);
	
	var onlyChild = __webpack_require__(329);
	var warning = __webpack_require__(309);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(304);
	var ReactElement = __webpack_require__(307);
	
	var emptyFunction = __webpack_require__(310);
	var traverseAllChildren = __webpack_require__(313);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(305);
	
	var invariant = __webpack_require__(306);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var ReactCurrentOwner = __webpack_require__(308);
	
	var warning = __webpack_require__(309);
	var canDefineProperty = __webpack_require__(311);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(312);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(310);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(305);
	
	var ReactCurrentOwner = __webpack_require__(308);
	var REACT_ELEMENT_TYPE = __webpack_require__(312);
	
	var getIteratorFn = __webpack_require__(314);
	var invariant = __webpack_require__(306);
	var KeyEscapeUtils = __webpack_require__(315);
	var warning = __webpack_require__(309);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(305);
	
	var ReactNoopUpdateQueue = __webpack_require__(317);
	
	var canDefineProperty = __webpack_require__(311);
	var emptyObject = __webpack_require__(318);
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(309);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var ReactComponent = __webpack_require__(316);
	var ReactNoopUpdateQueue = __webpack_require__(317);
	
	var emptyObject = __webpack_require__(318);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(305),
	    _assign = __webpack_require__(302);
	
	var ReactComponent = __webpack_require__(316);
	var ReactElement = __webpack_require__(307);
	var ReactPropTypeLocationNames = __webpack_require__(321);
	var ReactNoopUpdateQueue = __webpack_require__(317);
	
	var emptyObject = __webpack_require__(318);
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(307);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(307),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(324);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(325);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(310);
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	var ReactPropTypesSecret = __webpack_require__(326);
	var checkPropTypes = __webpack_require__(327);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 326 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(305);
	
	var ReactElement = __webpack_require__(307);
	
	var invariant = __webpack_require__(306);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(331);


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactDefaultInjection = __webpack_require__(336);
	var ReactMount = __webpack_require__(458);
	var ReactReconciler = __webpack_require__(357);
	var ReactUpdates = __webpack_require__(354);
	var ReactVersion = __webpack_require__(463);
	
	var findDOMNode = __webpack_require__(464);
	var getHostComponentFromComposite = __webpack_require__(465);
	var renderSubtreeIntoContainer = __webpack_require__(466);
	var warning = __webpack_require__(309);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var DOMProperty = __webpack_require__(334);
	var ReactDOMComponentFlags = __webpack_require__(335);
	
	var invariant = __webpack_require__(306);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var invariant = __webpack_require__(306);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(337);
	var BeforeInputEventPlugin = __webpack_require__(338);
	var ChangeEventPlugin = __webpack_require__(353);
	var DefaultEventPluginOrder = __webpack_require__(365);
	var EnterLeaveEventPlugin = __webpack_require__(366);
	var HTMLDOMPropertyConfig = __webpack_require__(371);
	var ReactComponentBrowserEnvironment = __webpack_require__(372);
	var ReactDOMComponent = __webpack_require__(385);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactDOMEmptyComponent = __webpack_require__(429);
	var ReactDOMTreeTraversal = __webpack_require__(430);
	var ReactDOMTextComponent = __webpack_require__(431);
	var ReactDefaultBatchingStrategy = __webpack_require__(432);
	var ReactEventListener = __webpack_require__(433);
	var ReactInjection = __webpack_require__(436);
	var ReactReconcileTransaction = __webpack_require__(437);
	var SVGDOMPropertyConfig = __webpack_require__(445);
	var SelectEventPlugin = __webpack_require__(446);
	var SimpleEventPlugin = __webpack_require__(447);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(339);
	var ExecutionEnvironment = __webpack_require__(346);
	var FallbackCompositionState = __webpack_require__(347);
	var SyntheticCompositionEvent = __webpack_require__(350);
	var SyntheticInputEvent = __webpack_require__(352);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(340);
	var EventPluginUtils = __webpack_require__(342);
	
	var accumulateInto = __webpack_require__(344);
	var forEachAccumulated = __webpack_require__(345);
	var warning = __webpack_require__(309);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var EventPluginRegistry = __webpack_require__(341);
	var EventPluginUtils = __webpack_require__(342);
	var ReactErrorUtils = __webpack_require__(343);
	
	var accumulateInto = __webpack_require__(344);
	var forEachAccumulated = __webpack_require__(345);
	var invariant = __webpack_require__(306);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var invariant = __webpack_require__(306);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var ReactErrorUtils = __webpack_require__(343);
	
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var invariant = __webpack_require__(306);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var PooledClass = __webpack_require__(348);
	
	var getTextContentAccessor = __webpack_require__(349);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var invariant = __webpack_require__(306);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(346);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(351);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var PooledClass = __webpack_require__(348);
	
	var emptyFunction = __webpack_require__(310);
	var warning = __webpack_require__(309);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(351);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(340);
	var EventPropagators = __webpack_require__(339);
	var ExecutionEnvironment = __webpack_require__(346);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactUpdates = __webpack_require__(354);
	var SyntheticEvent = __webpack_require__(351);
	
	var getEventTarget = __webpack_require__(362);
	var isEventSupported = __webpack_require__(363);
	var isTextInputElement = __webpack_require__(364);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333),
	    _assign = __webpack_require__(302);
	
	var CallbackQueue = __webpack_require__(355);
	var PooledClass = __webpack_require__(348);
	var ReactFeatureFlags = __webpack_require__(356);
	var ReactReconciler = __webpack_require__(357);
	var Transaction = __webpack_require__(361);
	
	var invariant = __webpack_require__(306);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(348);
	
	var invariant = __webpack_require__(306);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(358);
	var ReactInstrumentation = __webpack_require__(360);
	
	var warning = __webpack_require__(309);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(359);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var invariant = __webpack_require__(306);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var invariant = __webpack_require__(306);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(346);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(339);
	var ReactDOMComponentTree = __webpack_require__(332);
	var SyntheticMouseEvent = __webpack_require__(367);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(368);
	var ViewportMetrics = __webpack_require__(369);
	
	var getEventModifierState = __webpack_require__(370);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(351);
	
	var getEventTarget = __webpack_require__(362);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(334);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(373);
	var ReactDOMIDOperations = __webpack_require__(384);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(374);
	var Danger = __webpack_require__(380);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactInstrumentation = __webpack_require__(360);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(377);
	var setInnerHTML = __webpack_require__(376);
	var setTextContent = __webpack_require__(378);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(375);
	var setInnerHTML = __webpack_require__(376);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(377);
	var setTextContent = __webpack_require__(378);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(346);
	var DOMNamespaces = __webpack_require__(375);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(377);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(346);
	var escapeTextContentForBrowser = __webpack_require__(379);
	var setInnerHTML = __webpack_require__(376);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var DOMLazyTree = __webpack_require__(374);
	var ExecutionEnvironment = __webpack_require__(346);
	
	var createNodesFromMarkup = __webpack_require__(381);
	var emptyFunction = __webpack_require__(310);
	var invariant = __webpack_require__(306);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(346);
	
	var createArrayFromMixed = __webpack_require__(382);
	var getMarkupWrap = __webpack_require__(383);
	var invariant = __webpack_require__(306);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(306);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(346);
	
	var invariant = __webpack_require__(306);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(373);
	var ReactDOMComponentTree = __webpack_require__(332);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333),
	    _assign = __webpack_require__(302);
	
	var AutoFocusUtils = __webpack_require__(386);
	var CSSPropertyOperations = __webpack_require__(388);
	var DOMLazyTree = __webpack_require__(374);
	var DOMNamespaces = __webpack_require__(375);
	var DOMProperty = __webpack_require__(334);
	var DOMPropertyOperations = __webpack_require__(396);
	var EventPluginHub = __webpack_require__(340);
	var EventPluginRegistry = __webpack_require__(341);
	var ReactBrowserEventEmitter = __webpack_require__(398);
	var ReactDOMComponentFlags = __webpack_require__(335);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactDOMInput = __webpack_require__(401);
	var ReactDOMOption = __webpack_require__(404);
	var ReactDOMSelect = __webpack_require__(405);
	var ReactDOMTextarea = __webpack_require__(406);
	var ReactInstrumentation = __webpack_require__(360);
	var ReactMultiChild = __webpack_require__(407);
	var ReactServerRenderingTransaction = __webpack_require__(425);
	
	var emptyFunction = __webpack_require__(310);
	var escapeTextContentForBrowser = __webpack_require__(379);
	var invariant = __webpack_require__(306);
	var isEventSupported = __webpack_require__(363);
	var shallowEqual = __webpack_require__(414);
	var validateDOMNesting = __webpack_require__(428);
	var warning = __webpack_require__(309);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(332);
	
	var focusNode = __webpack_require__(387);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(389);
	var ExecutionEnvironment = __webpack_require__(346);
	var ReactInstrumentation = __webpack_require__(360);
	
	var camelizeStyleName = __webpack_require__(390);
	var dangerousStyleValue = __webpack_require__(392);
	var hyphenateStyleName = __webpack_require__(393);
	var memoizeStringOnly = __webpack_require__(395);
	var warning = __webpack_require__(309);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(391);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(389);
	var warning = __webpack_require__(309);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(394);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(334);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactInstrumentation = __webpack_require__(360);
	
	var quoteAttributeValueForBrowser = __webpack_require__(397);
	var warning = __webpack_require__(309);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(379);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var EventPluginRegistry = __webpack_require__(341);
	var ReactEventEmitterMixin = __webpack_require__(399);
	var ViewportMetrics = __webpack_require__(369);
	
	var getVendorPrefixedEventName = __webpack_require__(400);
	var isEventSupported = __webpack_require__(363);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(340);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(346);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333),
	    _assign = __webpack_require__(302);
	
	var DOMPropertyOperations = __webpack_require__(396);
	var LinkedValueUtils = __webpack_require__(402);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactUpdates = __webpack_require__(354);
	
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        // eslint-disable-next-line
	        if (value != valueAsNumber) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	        // eslint-disable-next-line
	      } else if (value != node.value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var ReactPropTypesSecret = __webpack_require__(403);
	var propTypesFactory = __webpack_require__(324);
	
	var React = __webpack_require__(301);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var React = __webpack_require__(301);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactDOMSelect = __webpack_require__(405);
	
	var warning = __webpack_require__(309);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var LinkedValueUtils = __webpack_require__(402);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactUpdates = __webpack_require__(354);
	
	var warning = __webpack_require__(309);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333),
	    _assign = __webpack_require__(302);
	
	var LinkedValueUtils = __webpack_require__(402);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactUpdates = __webpack_require__(354);
	
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var ReactComponentEnvironment = __webpack_require__(408);
	var ReactInstanceMap = __webpack_require__(409);
	var ReactInstrumentation = __webpack_require__(360);
	
	var ReactCurrentOwner = __webpack_require__(308);
	var ReactReconciler = __webpack_require__(357);
	var ReactChildReconciler = __webpack_require__(410);
	
	var emptyFunction = __webpack_require__(310);
	var flattenChildren = __webpack_require__(424);
	var invariant = __webpack_require__(306);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var invariant = __webpack_require__(306);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(357);
	
	var instantiateReactComponent = __webpack_require__(411);
	var KeyEscapeUtils = __webpack_require__(419);
	var shouldUpdateReactComponent = __webpack_require__(415);
	var traverseAllChildren = __webpack_require__(420);
	var warning = __webpack_require__(309);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(423);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333),
	    _assign = __webpack_require__(302);
	
	var ReactCompositeComponent = __webpack_require__(412);
	var ReactEmptyComponent = __webpack_require__(416);
	var ReactHostComponent = __webpack_require__(417);
	
	var getNextDebugID = __webpack_require__(418);
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333),
	    _assign = __webpack_require__(302);
	
	var React = __webpack_require__(301);
	var ReactComponentEnvironment = __webpack_require__(408);
	var ReactCurrentOwner = __webpack_require__(308);
	var ReactErrorUtils = __webpack_require__(343);
	var ReactInstanceMap = __webpack_require__(409);
	var ReactInstrumentation = __webpack_require__(360);
	var ReactNodeTypes = __webpack_require__(413);
	var ReactReconciler = __webpack_require__(357);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(318);
	var invariant = __webpack_require__(306);
	var shallowEqual = __webpack_require__(414);
	var shouldUpdateReactComponent = __webpack_require__(415);
	var warning = __webpack_require__(309);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var React = __webpack_require__(301);
	
	var invariant = __webpack_require__(306);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var invariant = __webpack_require__(306);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var ReactCurrentOwner = __webpack_require__(308);
	var REACT_ELEMENT_TYPE = __webpack_require__(421);
	
	var getIteratorFn = __webpack_require__(422);
	var invariant = __webpack_require__(306);
	var KeyEscapeUtils = __webpack_require__(419);
	var warning = __webpack_require__(309);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(305);
	
	var ReactCurrentOwner = __webpack_require__(308);
	
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(419);
	var traverseAllChildren = __webpack_require__(420);
	var warning = __webpack_require__(309);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(423);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var PooledClass = __webpack_require__(348);
	var Transaction = __webpack_require__(361);
	var ReactInstrumentation = __webpack_require__(360);
	var ReactServerUpdateQueue = __webpack_require__(426);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(427);
	
	var warning = __webpack_require__(309);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var ReactCurrentOwner = __webpack_require__(308);
	var ReactInstanceMap = __webpack_require__(409);
	var ReactInstrumentation = __webpack_require__(360);
	var ReactUpdates = __webpack_require__(354);
	
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var emptyFunction = __webpack_require__(310);
	var warning = __webpack_require__(309);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var DOMLazyTree = __webpack_require__(374);
	var ReactDOMComponentTree = __webpack_require__(332);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var invariant = __webpack_require__(306);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333),
	    _assign = __webpack_require__(302);
	
	var DOMChildrenOperations = __webpack_require__(373);
	var DOMLazyTree = __webpack_require__(374);
	var ReactDOMComponentTree = __webpack_require__(332);
	
	var escapeTextContentForBrowser = __webpack_require__(379);
	var invariant = __webpack_require__(306);
	var validateDOMNesting = __webpack_require__(428);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var ReactUpdates = __webpack_require__(354);
	var Transaction = __webpack_require__(361);
	
	var emptyFunction = __webpack_require__(310);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var EventListener = __webpack_require__(434);
	var ExecutionEnvironment = __webpack_require__(346);
	var PooledClass = __webpack_require__(348);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactUpdates = __webpack_require__(354);
	
	var getEventTarget = __webpack_require__(362);
	var getUnboundedScrollPosition = __webpack_require__(435);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(310);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(334);
	var EventPluginHub = __webpack_require__(340);
	var EventPluginUtils = __webpack_require__(342);
	var ReactComponentEnvironment = __webpack_require__(408);
	var ReactEmptyComponent = __webpack_require__(416);
	var ReactBrowserEventEmitter = __webpack_require__(398);
	var ReactHostComponent = __webpack_require__(417);
	var ReactUpdates = __webpack_require__(354);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var CallbackQueue = __webpack_require__(355);
	var PooledClass = __webpack_require__(348);
	var ReactBrowserEventEmitter = __webpack_require__(398);
	var ReactInputSelection = __webpack_require__(438);
	var ReactInstrumentation = __webpack_require__(360);
	var Transaction = __webpack_require__(361);
	var ReactUpdateQueue = __webpack_require__(427);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(439);
	
	var containsNode = __webpack_require__(441);
	var focusNode = __webpack_require__(387);
	var getActiveElement = __webpack_require__(444);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(346);
	
	var getNodeForCharacterOffset = __webpack_require__(440);
	var getTextContentAccessor = __webpack_require__(349);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(442);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(443);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(339);
	var ExecutionEnvironment = __webpack_require__(346);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactInputSelection = __webpack_require__(438);
	var SyntheticEvent = __webpack_require__(351);
	
	var getActiveElement = __webpack_require__(444);
	var isTextInputElement = __webpack_require__(364);
	var shallowEqual = __webpack_require__(414);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var EventListener = __webpack_require__(434);
	var EventPropagators = __webpack_require__(339);
	var ReactDOMComponentTree = __webpack_require__(332);
	var SyntheticAnimationEvent = __webpack_require__(448);
	var SyntheticClipboardEvent = __webpack_require__(449);
	var SyntheticEvent = __webpack_require__(351);
	var SyntheticFocusEvent = __webpack_require__(450);
	var SyntheticKeyboardEvent = __webpack_require__(451);
	var SyntheticMouseEvent = __webpack_require__(367);
	var SyntheticDragEvent = __webpack_require__(454);
	var SyntheticTouchEvent = __webpack_require__(455);
	var SyntheticTransitionEvent = __webpack_require__(456);
	var SyntheticUIEvent = __webpack_require__(368);
	var SyntheticWheelEvent = __webpack_require__(457);
	
	var emptyFunction = __webpack_require__(310);
	var getEventCharCode = __webpack_require__(452);
	var invariant = __webpack_require__(306);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(351);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(351);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(368);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(368);
	
	var getEventCharCode = __webpack_require__(452);
	var getEventKey = __webpack_require__(453);
	var getEventModifierState = __webpack_require__(370);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(452);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(367);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(368);
	
	var getEventModifierState = __webpack_require__(370);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(351);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(367);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var DOMLazyTree = __webpack_require__(374);
	var DOMProperty = __webpack_require__(334);
	var React = __webpack_require__(301);
	var ReactBrowserEventEmitter = __webpack_require__(398);
	var ReactCurrentOwner = __webpack_require__(308);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactDOMContainerInfo = __webpack_require__(459);
	var ReactDOMFeatureFlags = __webpack_require__(460);
	var ReactFeatureFlags = __webpack_require__(356);
	var ReactInstanceMap = __webpack_require__(409);
	var ReactInstrumentation = __webpack_require__(360);
	var ReactMarkupChecksum = __webpack_require__(461);
	var ReactReconciler = __webpack_require__(357);
	var ReactUpdateQueue = __webpack_require__(427);
	var ReactUpdates = __webpack_require__(354);
	
	var emptyObject = __webpack_require__(318);
	var instantiateReactComponent = __webpack_require__(411);
	var invariant = __webpack_require__(306);
	var setInnerHTML = __webpack_require__(376);
	var shouldUpdateReactComponent = __webpack_require__(415);
	var warning = __webpack_require__(309);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(428);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(462);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 462 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(333);
	
	var ReactCurrentOwner = __webpack_require__(308);
	var ReactDOMComponentTree = __webpack_require__(332);
	var ReactInstanceMap = __webpack_require__(409);
	
	var getHostComponentFromComposite = __webpack_require__(465);
	var invariant = __webpack_require__(306);
	var warning = __webpack_require__(309);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(413);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(458);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(468);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(473);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(477);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(300);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(471);
	
	var _warning = __webpack_require__(472);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store, storeSubscription: null };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports.default = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _PropTypes.storeShape.isRequired,
	  children: _propTypes2.default.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _PropTypes.storeShape.isRequired,
	  storeSubscription: _PropTypes.subscriptionShape
	};
	Provider.displayName = 'Provider';

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(470)();
	}


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(310);
	var invariant = __webpack_require__(306);
	
	module.exports = function() {
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  function shim() {
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),
/* 472 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(474);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(300);
	
	var _Subscription = __webpack_require__(476);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(471);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          if (this.subscription) this.subscription.tryUnsubscribe();
	          this.initSubscription();
	          if (shouldHandleStateChanges) this.subscription.trySubscribe();
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 476 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(473);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(478);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(479);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(513);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(514);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(515);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(480);
	
	var _wrapMapToProps = __webpack_require__(501);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(481);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(496);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(498);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(499);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(500);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(482);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(492);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(483),
	    getPrototype = __webpack_require__(489),
	    isObjectLike = __webpack_require__(491);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(484),
	    getRawTag = __webpack_require__(487),
	    objectToString = __webpack_require__(488);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(485);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(486);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(484);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 488 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(490);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 490 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 491 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(493);


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(495);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(494)(module)))

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 495 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(481);
	
	var _isPlainObject = __webpack_require__(482);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(497);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(500);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(502);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(503);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(472);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(504),
	    getPrototype = __webpack_require__(510),
	    isObjectLike = __webpack_require__(512);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(505),
	    getRawTag = __webpack_require__(508),
	    objectToString = __webpack_require__(509);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(506);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(507);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 507 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(505);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 509 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(511);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 511 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 512 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(501);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(502);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(516);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(472);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.registerAnalyticsClickListener = registerAnalyticsClickListener;
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _debug = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*global ga*/
	
	
	// Simple module for in-app analytics.  Currently sends data to GA but could be extended to anything else.
	var MetabaseAnalytics = {
	    // track a pageview (a.k.a. route change)
	    trackPageView: function trackPageView(url) {
	        if (url) {
	            // scrub query builder urls to remove serialized json queries from path
	            url = url.lastIndexOf('/q/', 0) === 0 ? '/q/' : url;
	
	            var _MetabaseSettings$get = _settings2.default.get('version'),
	                tag = _MetabaseSettings$get.tag;
	
	            // $FlowFixMe
	
	
	            ga('set', 'dimension1', tag);
	            ga('set', 'page', url);
	            ga('send', 'pageview', url);
	        }
	    },
	
	    // track an event
	    trackEvent: function trackEvent(category, action, label, value) {
	        var _MetabaseSettings$get2 = _settings2.default.get('version'),
	            tag = _MetabaseSettings$get2.tag;
	
	        // category & action are required, rest are optional
	
	
	        if (category && action) {
	            // $FlowFixMe
	            ga('set', 'dimension1', tag);
	            ga('send', 'event', category, action, label, value);
	        }
	        if (_debug.DEBUG) {
	            console.log("trackEvent", { category: category, action: action, label: label, value: value });
	        }
	    }
	};
	
	exports.default = MetabaseAnalytics;
	function registerAnalyticsClickListener() {
	    // $FlowFixMe
	    document.body.addEventListener("click", function (e) {
	        var node = e.target;
	
	        // check the target and all parent elements
	        while (node) {
	            if (node.dataset && node.dataset.metabaseEvent) {
	                // we expect our event to be a semicolon delimited string
	                var parts = node.dataset.metabaseEvent.split(";").map(function (p) {
	                    return p.trim();
	                });
	                MetabaseAnalytics.trackEvent.apply(MetabaseAnalytics, _toConsumableArray(parts));
	            }
	            node = node.parentNode;
	        }
	    }, true);
	}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _inflection = __webpack_require__(520);
	
	var _inflection2 = _interopRequireDefault(_inflection);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mb_settings = _underscore2.default.clone(window.MetabaseBootstrap);
	
	var settingListeners = {};
	
	// provides access to Metabase application settings
	var MetabaseSettings = {
	
	    get: function get(propName) {
	        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	        return mb_settings[propName] !== undefined ? mb_settings[propName] : defaultValue;
	    },
	
	    set: function set(key, value) {
	        if (mb_settings[key] !== value) {
	            mb_settings[key] = value;
	            if (settingListeners[key]) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    var _loop = function _loop() {
	                        var listener = _step.value;
	
	                        setTimeout(function () {
	                            return listener(value);
	                        });
	                    };
	
	                    for (var _iterator = settingListeners[key][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        _loop();
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	        }
	    },
	
	    setAll: function setAll(settings) {
	        for (var key in settings) {
	            MetabaseSettings.set(key, settings[key]);
	        }
	    },
	
	    // these are all special accessors which provide a lookup of a property plus some additional help
	    adminEmail: function adminEmail() {
	        return mb_settings.admin_email;
	    },
	
	    isEmailConfigured: function isEmailConfigured() {
	        return mb_settings.email_configured;
	    },
	
	    isTrackingEnabled: function isTrackingEnabled() {
	        return mb_settings.anon_tracking_enabled || false;
	    },
	
	    hasSetupToken: function hasSetupToken() {
	        return mb_settings.setup_token !== undefined && mb_settings.setup_token !== null;
	    },
	
	    ssoEnabled: function ssoEnabled() {
	        return mb_settings.google_auth_client_id != null;
	    },
	
	    ldapEnabled: function ldapEnabled() {
	        return mb_settings.ldap_configured;
	    },
	
	    newVersionAvailable: function newVersionAvailable(settings) {
	        var versionInfo = _underscore2.default.findWhere(settings, { key: "version-info" }),
	            currentVersion = MetabaseSettings.get("version").tag;
	
	        if (versionInfo) versionInfo = versionInfo.value;
	
	        return versionInfo && _utils2.default.compareVersions(currentVersion, versionInfo.latest.version) < 0;
	    },
	
	    passwordComplexity: function passwordComplexity(capitalize) {
	        var complexity = this.get('password_complexity');
	
	        var clauseDescription = function clauseDescription(clause) {
	            switch (clause) {
	                case "lower":
	                    return "lower case letter";
	                case "upper":
	                    return "upper case letter";
	                case "digit":
	                    return "number";
	                case "special":
	                    return "special character";
	            }
	        };
	
	        var description = capitalize === false ? "must be " + complexity.total + " characters long" : "Must be " + complexity.total + " characters long",
	            clauses = [];
	
	        ["lower", "upper", "digit", "special"].forEach(function (clause) {
	            if (clause in complexity) {
	                var desc = complexity[clause] > 1 ? _inflection2.default.pluralize(clauseDescription(clause)) : clauseDescription(clause);
	                clauses.push(_utils2.default.numberToWord(complexity[clause]) + " " + desc);
	            }
	        });
	
	        if (clauses.length > 0) {
	            return description + " and include " + clauses.join(", ");
	        } else {
	            return description;
	        }
	    },
	
	    on: function on(setting, callback) {
	        settingListeners[setting] = settingListeners[setting] || [];
	        settingListeners[setting].push(callback);
	    }
	};
	
	exports.default = MetabaseSettings;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * inflection
	 * Copyright(c) 2011 Ben Lin <ben@dreamerslab.com>
	 * MIT Licensed
	 *
	 * @fileoverview
	 * A port of inflection-js to node.js module.
	 */
	
	( function ( root, factory ){
	  if( true ){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }else if( typeof exports === 'object' ){
	    module.exports = factory();
	  }else{
	    root.inflection = factory();
	  }
	}( this, function (){
	
	  /**
	   * @description This is a list of nouns that use the same form for both singular and plural.
	   *              This list should remain entirely in lower case to correctly match Strings.
	   * @private
	   */
	  var uncountable_words = [
	    // 'access',
	    'accommodation',
	    'adulthood',
	    'advertising',
	    'advice',
	    'aggression',
	    'aid',
	    'air',
	    'aircraft',
	    'alcohol',
	    'anger',
	    'applause',
	    'arithmetic',
	    // 'art',
	    'assistance',
	    'athletics',
	    // 'attention',
	
	    'bacon',
	    'baggage',
	    // 'ballet',
	    // 'beauty',
	    'beef',
	    // 'beer',
	    // 'behavior',
	    'biology',
	    // 'billiards',
	    'blood',
	    'botany',
	    // 'bowels',
	    'bread',
	    // 'business',
	    'butter',
	
	    'carbon',
	    'cardboard',
	    'cash',
	    'chalk',
	    'chaos',
	    'chess',
	    'crossroads',
	    'countryside',
	
	    // 'damage',
	    'dancing',
	    // 'danger',
	    'deer',
	    // 'delight',
	    // 'dessert',
	    'dignity',
	    'dirt',
	    // 'distribution',
	    'dust',
	
	    'economics',
	    'education',
	    'electricity',
	    // 'employment',
	    // 'energy',
	    'engineering',
	    'enjoyment',
	    // 'entertainment',
	    'envy',
	    'equipment',
	    'ethics',
	    'evidence',
	    'evolution',
	
	    // 'failure',
	    // 'faith',
	    'fame',
	    'fiction',
	    // 'fish',
	    'flour',
	    'flu',
	    'food',
	    // 'freedom',
	    // 'fruit',
	    'fuel',
	    'fun',
	    // 'funeral',
	    'furniture',
	
	    'gallows',
	    'garbage',
	    'garlic',
	    // 'gas',
	    'genetics',
	    // 'glass',
	    'gold',
	    'golf',
	    'gossip',
	    'grammar',
	    // 'grass',
	    'gratitude',
	    'grief',
	    // 'ground',
	    'guilt',
	    'gymnastics',
	
	    // 'hair',
	    'happiness',
	    'hardware',
	    'harm',
	    'hate',
	    'hatred',
	    'health',
	    'heat',
	    // 'height',
	    'help',
	    'homework',
	    'honesty',
	    'honey',
	    'hospitality',
	    'housework',
	    'humour',
	    'hunger',
	    'hydrogen',
	
	    'ice',
	    'importance',
	    'inflation',
	    'information',
	    // 'injustice',
	    'innocence',
	    // 'intelligence',
	    'iron',
	    'irony',
	
	    'jam',
	    // 'jealousy',
	    // 'jelly',
	    'jewelry',
	    // 'joy',
	    'judo',
	    // 'juice',
	    // 'justice',
	
	    'karate',
	    // 'kindness',
	    'knowledge',
	
	    // 'labour',
	    'lack',
	    // 'land',
	    'laughter',
	    'lava',
	    'leather',
	    'leisure',
	    'lightning',
	    'linguine',
	    'linguini',
	    'linguistics',
	    'literature',
	    'litter',
	    'livestock',
	    'logic',
	    'loneliness',
	    // 'love',
	    'luck',
	    'luggage',
	
	    'macaroni',
	    'machinery',
	    'magic',
	    // 'mail',
	    'management',
	    'mankind',
	    'marble',
	    'mathematics',
	    'mayonnaise',
	    'measles',
	    // 'meat',
	    // 'metal',
	    'methane',
	    'milk',
	    'minus',
	    'money',
	    // 'moose',
	    'mud',
	    'music',
	    'mumps',
	
	    'nature',
	    'news',
	    'nitrogen',
	    'nonsense',
	    'nurture',
	    'nutrition',
	
	    'obedience',
	    'obesity',
	    // 'oil',
	    'oxygen',
	
	    // 'paper',
	    // 'passion',
	    'pasta',
	    'patience',
	    // 'permission',
	    'physics',
	    'poetry',
	    'pollution',
	    'poverty',
	    // 'power',
	    'pride',
	    // 'production',
	    // 'progress',
	    // 'pronunciation',
	    'psychology',
	    'publicity',
	    'punctuation',
	
	    // 'quality',
	    // 'quantity',
	    'quartz',
	
	    'racism',
	    // 'rain',
	    // 'recreation',
	    'relaxation',
	    'reliability',
	    'research',
	    'respect',
	    'revenge',
	    'rice',
	    'rubbish',
	    'rum',
	
	    'safety',
	    // 'salad',
	    // 'salt',
	    // 'sand',
	    // 'satire',
	    'scenery',
	    'seafood',
	    'seaside',
	    'series',
	    'shame',
	    'sheep',
	    'shopping',
	    // 'silence',
	    'sleep',
	    // 'slang'
	    'smoke',
	    'smoking',
	    'snow',
	    'soap',
	    'software',
	    'soil',
	    // 'sorrow',
	    // 'soup',
	    'spaghetti',
	    // 'speed',
	    'species',
	    // 'spelling',
	    // 'sport',
	    'steam',
	    // 'strength',
	    'stuff',
	    'stupidity',
	    // 'success',
	    // 'sugar',
	    'sunshine',
	    'symmetry',
	
	    // 'tea',
	    'tennis',
	    'thirst',
	    'thunder',
	    'timber',
	    // 'time',
	    // 'toast',
	    // 'tolerance',
	    // 'trade',
	    'traffic',
	    'transportation',
	    // 'travel',
	    'trust',
	
	    // 'understanding',
	    'underwear',
	    'unemployment',
	    'unity',
	    // 'usage',
	
	    'validity',
	    'veal',
	    'vegetation',
	    'vegetarianism',
	    'vengeance',
	    'violence',
	    // 'vision',
	    'vitality',
	
	    'warmth',
	    // 'water',
	    'wealth',
	    'weather',
	    // 'weight',
	    'welfare',
	    'wheat',
	    // 'whiskey',
	    // 'width',
	    'wildlife',
	    // 'wine',
	    'wisdom',
	    // 'wood',
	    // 'wool',
	    // 'work',
	
	    // 'yeast',
	    'yoga',
	
	    'zinc',
	    'zoology'
	  ];
	
	  /**
	   * @description These rules translate from the singular form of a noun to its plural form.
	   * @private
	   */
	
	  var regex = {
	    plural : {
	      men       : new RegExp( '^(m|wom)en$'                    , 'gi' ),
	      people    : new RegExp( '(pe)ople$'                      , 'gi' ),
	      children  : new RegExp( '(child)ren$'                    , 'gi' ),
	      tia       : new RegExp( '([ti])a$'                       , 'gi' ),
	      analyses  : new RegExp( '((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$','gi' ),
	      hives     : new RegExp( '(hi|ti)ves$'                    , 'gi' ),
	      curves    : new RegExp( '(curve)s$'                      , 'gi' ),
	      lrves     : new RegExp( '([lr])ves$'                     , 'gi' ),
	      aves      : new RegExp( '([a])ves$'                      , 'gi' ),
	      foves     : new RegExp( '([^fo])ves$'                    , 'gi' ),
	      movies    : new RegExp( '(m)ovies$'                      , 'gi' ),
	      aeiouyies : new RegExp( '([^aeiouy]|qu)ies$'             , 'gi' ),
	      series    : new RegExp( '(s)eries$'                      , 'gi' ),
	      xes       : new RegExp( '(x|ch|ss|sh)es$'                , 'gi' ),
	      mice      : new RegExp( '([m|l])ice$'                    , 'gi' ),
	      buses     : new RegExp( '(bus)es$'                       , 'gi' ),
	      oes       : new RegExp( '(o)es$'                         , 'gi' ),
	      shoes     : new RegExp( '(shoe)s$'                       , 'gi' ),
	      crises    : new RegExp( '(cris|ax|test)es$'              , 'gi' ),
	      octopi    : new RegExp( '(octop|vir)i$'                  , 'gi' ),
	      aliases   : new RegExp( '(alias|canvas|status|campus)es$', 'gi' ),
	      summonses : new RegExp( '^(summons)es$'                  , 'gi' ),
	      oxen      : new RegExp( '^(ox)en'                        , 'gi' ),
	      matrices  : new RegExp( '(matr)ices$'                    , 'gi' ),
	      vertices  : new RegExp( '(vert|ind)ices$'                , 'gi' ),
	      feet      : new RegExp( '^feet$'                         , 'gi' ),
	      teeth     : new RegExp( '^teeth$'                        , 'gi' ),
	      geese     : new RegExp( '^geese$'                        , 'gi' ),
	      quizzes   : new RegExp( '(quiz)zes$'                     , 'gi' ),
	      whereases : new RegExp( '^(whereas)es$'                  , 'gi' ),
	      criteria  : new RegExp( '^(criteri)a$'                   , 'gi' ),
	      genera    : new RegExp( '^genera$'                       , 'gi' ),
	      ss        : new RegExp( 'ss$'                            , 'gi' ),
	      s         : new RegExp( 's$'                             , 'gi' )
	    },
	
	    singular : {
	      man       : new RegExp( '^(m|wom)an$'                  , 'gi' ),
	      person    : new RegExp( '(pe)rson$'                    , 'gi' ),
	      child     : new RegExp( '(child)$'                     , 'gi' ),
	      ox        : new RegExp( '^(ox)$'                       , 'gi' ),
	      axis      : new RegExp( '(ax|test)is$'                 , 'gi' ),
	      octopus   : new RegExp( '(octop|vir)us$'               , 'gi' ),
	      alias     : new RegExp( '(alias|status|canvas|campus)$', 'gi' ),
	      summons   : new RegExp( '^(summons)$'                  , 'gi' ),
	      bus       : new RegExp( '(bu)s$'                       , 'gi' ),
	      buffalo   : new RegExp( '(buffal|tomat|potat)o$'       , 'gi' ),
	      tium      : new RegExp( '([ti])um$'                    , 'gi' ),
	      sis       : new RegExp( 'sis$'                         , 'gi' ),
	      ffe       : new RegExp( '(?:([^f])fe|([lr])f)$'        , 'gi' ),
	      hive      : new RegExp( '(hi|ti)ve$'                   , 'gi' ),
	      aeiouyy   : new RegExp( '([^aeiouy]|qu)y$'             , 'gi' ),
	      x         : new RegExp( '(x|ch|ss|sh)$'                , 'gi' ),
	      matrix    : new RegExp( '(matr)ix$'                    , 'gi' ),
	      vertex    : new RegExp( '(vert|ind)ex$'                , 'gi' ),
	      mouse     : new RegExp( '([m|l])ouse$'                 , 'gi' ),
	      foot      : new RegExp( '^foot$'                       , 'gi' ),
	      tooth     : new RegExp( '^tooth$'                      , 'gi' ),
	      goose     : new RegExp( '^goose$'                      , 'gi' ),
	      quiz      : new RegExp( '(quiz)$'                      , 'gi' ),
	      whereas   : new RegExp( '^(whereas)$'                  , 'gi' ),
	      criterion : new RegExp( '^(criteri)on$'                , 'gi' ),
	      genus     : new RegExp( '^genus$'                      , 'gi' ),
	      s         : new RegExp( 's$'                           , 'gi' ),
	      common    : new RegExp( '$'                            , 'gi' )
	    }
	  };
	
	  var plural_rules = [
	
	    // do not replace if its already a plural word
	    [ regex.plural.men       ],
	    [ regex.plural.people    ],
	    [ regex.plural.children  ],
	    [ regex.plural.tia       ],
	    [ regex.plural.analyses  ],
	    [ regex.plural.hives     ],
	    [ regex.plural.curves    ],
	    [ regex.plural.lrves     ],
	    [ regex.plural.foves     ],
	    [ regex.plural.aeiouyies ],
	    [ regex.plural.series    ],
	    [ regex.plural.movies    ],
	    [ regex.plural.xes       ],
	    [ regex.plural.mice      ],
	    [ regex.plural.buses     ],
	    [ regex.plural.oes       ],
	    [ regex.plural.shoes     ],
	    [ regex.plural.crises    ],
	    [ regex.plural.octopi    ],
	    [ regex.plural.aliases   ],
	    [ regex.plural.summonses ],
	    [ regex.plural.oxen      ],
	    [ regex.plural.matrices  ],
	    [ regex.plural.feet      ],
	    [ regex.plural.teeth     ],
	    [ regex.plural.geese     ],
	    [ regex.plural.quizzes   ],
	    [ regex.plural.whereases ],
	    [ regex.plural.criteria  ],
	    [ regex.plural.genera    ],
	
	    // original rule
	    [ regex.singular.man      , '$1en' ],
	    [ regex.singular.person   , '$1ople' ],
	    [ regex.singular.child    , '$1ren' ],
	    [ regex.singular.ox       , '$1en' ],
	    [ regex.singular.axis     , '$1es' ],
	    [ regex.singular.octopus  , '$1i' ],
	    [ regex.singular.alias    , '$1es' ],
	    [ regex.singular.summons  , '$1es' ],
	    [ regex.singular.bus      , '$1ses' ],
	    [ regex.singular.buffalo  , '$1oes' ],
	    [ regex.singular.tium     , '$1a' ],
	    [ regex.singular.sis      , 'ses' ],
	    [ regex.singular.ffe      , '$1$2ves' ],
	    [ regex.singular.hive     , '$1ves' ],
	    [ regex.singular.aeiouyy  , '$1ies' ],
	    [ regex.singular.matrix   , '$1ices' ],
	    [ regex.singular.vertex   , '$1ices' ],
	    [ regex.singular.x        , '$1es' ],
	    [ regex.singular.mouse    , '$1ice' ],
	    [ regex.singular.foot     , 'feet' ],
	    [ regex.singular.tooth    , 'teeth' ],
	    [ regex.singular.goose    , 'geese' ],
	    [ regex.singular.quiz     , '$1zes' ],
	    [ regex.singular.whereas  , '$1es' ],
	    [ regex.singular.criterion, '$1a' ],
	    [ regex.singular.genus    , 'genera' ],
	
	    [ regex.singular.s     , 's' ],
	    [ regex.singular.common, 's' ]
	  ];
	
	  /**
	   * @description These rules translate from the plural form of a noun to its singular form.
	   * @private
	   */
	  var singular_rules = [
	
	    // do not replace if its already a singular word
	    [ regex.singular.man     ],
	    [ regex.singular.person  ],
	    [ regex.singular.child   ],
	    [ regex.singular.ox      ],
	    [ regex.singular.axis    ],
	    [ regex.singular.octopus ],
	    [ regex.singular.alias   ],
	    [ regex.singular.summons ],
	    [ regex.singular.bus     ],
	    [ regex.singular.buffalo ],
	    [ regex.singular.tium    ],
	    [ regex.singular.sis     ],
	    [ regex.singular.ffe     ],
	    [ regex.singular.hive    ],
	    [ regex.singular.aeiouyy ],
	    [ regex.singular.x       ],
	    [ regex.singular.matrix  ],
	    [ regex.singular.mouse   ],
	    [ regex.singular.foot    ],
	    [ regex.singular.tooth   ],
	    [ regex.singular.goose   ],
	    [ regex.singular.quiz    ],
	    [ regex.singular.whereas ],
	    [ regex.singular.criterion ],
	    [ regex.singular.genus ],
	
	    // original rule
	    [ regex.plural.men      , '$1an' ],
	    [ regex.plural.people   , '$1rson' ],
	    [ regex.plural.children , '$1' ],
	    [ regex.plural.genera   , 'genus'],
	    [ regex.plural.criteria , '$1on'],
	    [ regex.plural.tia      , '$1um' ],
	    [ regex.plural.analyses , '$1$2sis' ],
	    [ regex.plural.hives    , '$1ve' ],
	    [ regex.plural.curves   , '$1' ],
	    [ regex.plural.lrves    , '$1f' ],
	    [ regex.plural.aves     , '$1ve' ],
	    [ regex.plural.foves    , '$1fe' ],
	    [ regex.plural.movies   , '$1ovie' ],
	    [ regex.plural.aeiouyies, '$1y' ],
	    [ regex.plural.series   , '$1eries' ],
	    [ regex.plural.xes      , '$1' ],
	    [ regex.plural.mice     , '$1ouse' ],
	    [ regex.plural.buses    , '$1' ],
	    [ regex.plural.oes      , '$1' ],
	    [ regex.plural.shoes    , '$1' ],
	    [ regex.plural.crises   , '$1is' ],
	    [ regex.plural.octopi   , '$1us' ],
	    [ regex.plural.aliases  , '$1' ],
	    [ regex.plural.summonses, '$1' ],
	    [ regex.plural.oxen     , '$1' ],
	    [ regex.plural.matrices , '$1ix' ],
	    [ regex.plural.vertices , '$1ex' ],
	    [ regex.plural.feet     , 'foot' ],
	    [ regex.plural.teeth    , 'tooth' ],
	    [ regex.plural.geese    , 'goose' ],
	    [ regex.plural.quizzes  , '$1' ],
	    [ regex.plural.whereases, '$1' ],
	
	    [ regex.plural.ss, 'ss' ],
	    [ regex.plural.s , '' ]
	  ];
	
	  /**
	   * @description This is a list of words that should not be capitalized for title case.
	   * @private
	   */
	  var non_titlecased_words = [
	    'and', 'or', 'nor', 'a', 'an', 'the', 'so', 'but', 'to', 'of', 'at','by',
	    'from', 'into', 'on', 'onto', 'off', 'out', 'in', 'over', 'with', 'for'
	  ];
	
	  /**
	   * @description These are regular expressions used for converting between String formats.
	   * @private
	   */
	  var id_suffix         = new RegExp( '(_ids|_id)$', 'g' );
	  var underbar          = new RegExp( '_', 'g' );
	  var space_or_underbar = new RegExp( '[\ _]', 'g' );
	  var uppercase         = new RegExp( '([A-Z])', 'g' );
	  var underbar_prefix   = new RegExp( '^_' );
	
	  var inflector = {
	
	  /**
	   * A helper method that applies rules based replacement to a String.
	   * @private
	   * @function
	   * @param {String} str String to modify and return based on the passed rules.
	   * @param {Array: [RegExp, String]} rules Regexp to match paired with String to use for replacement
	   * @param {Array: [String]} skip Strings to skip if they match
	   * @param {String} override String to return as though this method succeeded (used to conform to APIs)
	   * @returns {String} Return passed String modified by passed rules.
	   * @example
	   *
	   *     this._apply_rules( 'cows', singular_rules ); // === 'cow'
	   */
	    _apply_rules : function ( str, rules, skip, override ){
	      if( override ){
	        str = override;
	      }else{
	        var ignore = ( inflector.indexOf( skip, str.toLowerCase()) > -1 );
	
	        if( !ignore ){
	          var i = 0;
	          var j = rules.length;
	
	          for( ; i < j; i++ ){
	            if( str.match( rules[ i ][ 0 ])){
	              if( rules[ i ][ 1 ] !== undefined ){
	                str = str.replace( rules[ i ][ 0 ], rules[ i ][ 1 ]);
	              }
	              break;
	            }
	          }
	        }
	      }
	
	      return str;
	    },
	
	
	
	  /**
	   * This lets us detect if an Array contains a given element.
	   * @public
	   * @function
	   * @param {Array} arr The subject array.
	   * @param {Object} item Object to locate in the Array.
	   * @param {Number} from_index Starts checking from this position in the Array.(optional)
	   * @param {Function} compare_func Function used to compare Array item vs passed item.(optional)
	   * @returns {Number} Return index position in the Array of the passed item.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.indexOf([ 'hi','there' ], 'guys' ); // === -1
	   *     inflection.indexOf([ 'hi','there' ], 'hi' ); // === 0
	   */
	    indexOf : function ( arr, item, from_index, compare_func ){
	      if( !from_index ){
	        from_index = -1;
	      }
	
	      var index = -1;
	      var i     = from_index;
	      var j     = arr.length;
	
	      for( ; i < j; i++ ){
	        if( arr[ i ]  === item || compare_func && compare_func( arr[ i ], item )){
	          index = i;
	          break;
	        }
	      }
	
	      return index;
	    },
	
	
	
	  /**
	   * This function adds pluralization support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @param {String} plural Overrides normal output with said String.(optional)
	   * @returns {String} Singular English language nouns are returned in plural form.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.pluralize( 'person' ); // === 'people'
	   *     inflection.pluralize( 'octopus' ); // === 'octopi'
	   *     inflection.pluralize( 'Hat' ); // === 'Hats'
	   *     inflection.pluralize( 'person', 'guys' ); // === 'guys'
	   */
	    pluralize : function ( str, plural ){
	      return inflector._apply_rules( str, plural_rules, uncountable_words, plural );
	    },
	
	
	
	  /**
	   * This function adds singularization support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @param {String} singular Overrides normal output with said String.(optional)
	   * @returns {String} Plural English language nouns are returned in singular form.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.singularize( 'people' ); // === 'person'
	   *     inflection.singularize( 'octopi' ); // === 'octopus'
	   *     inflection.singularize( 'Hats' ); // === 'Hat'
	   *     inflection.singularize( 'guys', 'person' ); // === 'person'
	   */
	    singularize : function ( str, singular ){
	      return inflector._apply_rules( str, singular_rules, uncountable_words, singular );
	    },
	
	
	  /**
	   * This function will pluralize or singularlize a String appropriately based on an integer value
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @param {Number} count The number to base pluralization off of.
	   * @param {String} singular Overrides normal output with said String.(optional)
	   * @param {String} plural Overrides normal output with said String.(optional)
	   * @returns {String} English language nouns are returned in the plural or singular form based on the count.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.inflect( 'people' 1 ); // === 'person'
	   *     inflection.inflect( 'octopi' 1 ); // === 'octopus'
	   *     inflection.inflect( 'Hats' 1 ); // === 'Hat'
	   *     inflection.inflect( 'guys', 1 , 'person' ); // === 'person'
	   *     inflection.inflect( 'person', 2 ); // === 'people'
	   *     inflection.inflect( 'octopus', 2 ); // === 'octopi'
	   *     inflection.inflect( 'Hat', 2 ); // === 'Hats'
	   *     inflection.inflect( 'person', 2, null, 'guys' ); // === 'guys'
	   */
	    inflect : function ( str, count, singular, plural ){
	      count = parseInt( count, 10 );
	
	      if( isNaN( count )) return str;
	
	      if( count === 0 || count > 1 ){
	        return inflector._apply_rules( str, plural_rules, uncountable_words, plural );
	      }else{
	        return inflector._apply_rules( str, singular_rules, uncountable_words, singular );
	      }
	    },
	
	
	
	  /**
	   * This function adds camelization support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @param {Boolean} low_first_letter Default is to capitalize the first letter of the results.(optional)
	   *                                 Passing true will lowercase it.
	   * @returns {String} Lower case underscored words will be returned in camel case.
	   *                  additionally '/' is translated to '::'
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.camelize( 'message_properties' ); // === 'MessageProperties'
	   *     inflection.camelize( 'message_properties', true ); // === 'messageProperties'
	   */
	    camelize : function ( str, low_first_letter ){
	      var str_path = str.split( '/' );
	      var i        = 0;
	      var j        = str_path.length;
	      var str_arr, init_x, k, l, first;
	
	      for( ; i < j; i++ ){
	        str_arr = str_path[ i ].split( '_' );
	        k       = 0;
	        l       = str_arr.length;
	
	        for( ; k < l; k++ ){
	          if( k !== 0 ){
	            str_arr[ k ] = str_arr[ k ].toLowerCase();
	          }
	
	          first = str_arr[ k ].charAt( 0 );
	          first = low_first_letter && i === 0 && k === 0
	            ? first.toLowerCase() : first.toUpperCase();
	          str_arr[ k ] = first + str_arr[ k ].substring( 1 );
	        }
	
	        str_path[ i ] = str_arr.join( '' );
	      }
	
	      return str_path.join( '::' );
	    },
	
	
	
	  /**
	   * This function adds underscore support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @param {Boolean} all_upper_case Default is to lowercase and add underscore prefix.(optional)
	   *                  Passing true will return as entered.
	   * @returns {String} Camel cased words are returned as lower cased and underscored.
	   *                  additionally '::' is translated to '/'.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.underscore( 'MessageProperties' ); // === 'message_properties'
	   *     inflection.underscore( 'messageProperties' ); // === 'message_properties'
	   *     inflection.underscore( 'MP', true ); // === 'MP'
	   */
	    underscore : function ( str, all_upper_case ){
	      if( all_upper_case && str === str.toUpperCase()) return str;
	
	      var str_path = str.split( '::' );
	      var i        = 0;
	      var j        = str_path.length;
	
	      for( ; i < j; i++ ){
	        str_path[ i ] = str_path[ i ].replace( uppercase, '_$1' );
	        str_path[ i ] = str_path[ i ].replace( underbar_prefix, '' );
	      }
	
	      return str_path.join( '/' ).toLowerCase();
	    },
	
	
	
	  /**
	   * This function adds humanize support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @param {Boolean} low_first_letter Default is to capitalize the first letter of the results.(optional)
	   *                                 Passing true will lowercase it.
	   * @returns {String} Lower case underscored words will be returned in humanized form.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.humanize( 'message_properties' ); // === 'Message properties'
	   *     inflection.humanize( 'message_properties', true ); // === 'message properties'
	   */
	    humanize : function ( str, low_first_letter ){
	      str = str.toLowerCase();
	      str = str.replace( id_suffix, '' );
	      str = str.replace( underbar, ' ' );
	
	      if( !low_first_letter ){
	        str = inflector.capitalize( str );
	      }
	
	      return str;
	    },
	
	
	
	  /**
	   * This function adds capitalization support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @returns {String} All characters will be lower case and the first will be upper.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.capitalize( 'message_properties' ); // === 'Message_properties'
	   *     inflection.capitalize( 'message properties', true ); // === 'Message properties'
	   */
	    capitalize : function ( str ){
	      str = str.toLowerCase();
	
	      return str.substring( 0, 1 ).toUpperCase() + str.substring( 1 );
	    },
	
	
	
	  /**
	   * This function replaces underscores with dashes in the string.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @returns {String} Replaces all spaces or underscores with dashes.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.dasherize( 'message_properties' ); // === 'message-properties'
	   *     inflection.dasherize( 'Message Properties' ); // === 'Message-Properties'
	   */
	    dasherize : function ( str ){
	      return str.replace( space_or_underbar, '-' );
	    },
	
	
	
	  /**
	   * This function adds titleize support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @returns {String} Capitalizes words as you would for a book title.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.titleize( 'message_properties' ); // === 'Message Properties'
	   *     inflection.titleize( 'message properties to keep' ); // === 'Message Properties to Keep'
	   */
	    titleize : function ( str ){
	      str         = str.toLowerCase().replace( underbar, ' ' );
	      var str_arr = str.split( ' ' );
	      var i       = 0;
	      var j       = str_arr.length;
	      var d, k, l;
	
	      for( ; i < j; i++ ){
	        d = str_arr[ i ].split( '-' );
	        k = 0;
	        l = d.length;
	
	        for( ; k < l; k++){
	          if( inflector.indexOf( non_titlecased_words, d[ k ].toLowerCase()) < 0 ){
	            d[ k ] = inflector.capitalize( d[ k ]);
	          }
	        }
	
	        str_arr[ i ] = d.join( '-' );
	      }
	
	      str = str_arr.join( ' ' );
	      str = str.substring( 0, 1 ).toUpperCase() + str.substring( 1 );
	
	      return str;
	    },
	
	
	
	  /**
	   * This function adds demodulize support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @returns {String} Removes module names leaving only class names.(Ruby style)
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.demodulize( 'Message::Bus::Properties' ); // === 'Properties'
	   */
	    demodulize : function ( str ){
	      var str_arr = str.split( '::' );
	
	      return str_arr[ str_arr.length - 1 ];
	    },
	
	
	
	  /**
	   * This function adds tableize support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @returns {String} Return camel cased words into their underscored plural form.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.tableize( 'MessageBusProperty' ); // === 'message_bus_properties'
	   */
	    tableize : function ( str ){
	      str = inflector.underscore( str );
	      str = inflector.pluralize( str );
	
	      return str;
	    },
	
	
	
	  /**
	   * This function adds classification support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @returns {String} Underscored plural nouns become the camel cased singular form.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.classify( 'message_bus_properties' ); // === 'MessageBusProperty'
	   */
	    classify : function ( str ){
	      str = inflector.camelize( str );
	      str = inflector.singularize( str );
	
	      return str;
	    },
	
	
	
	  /**
	   * This function adds foreign key support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @param {Boolean} drop_id_ubar Default is to seperate id with an underbar at the end of the class name,
	                                 you can pass true to skip it.(optional)
	   * @returns {String} Underscored plural nouns become the camel cased singular form.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.foreign_key( 'MessageBusProperty' ); // === 'message_bus_property_id'
	   *     inflection.foreign_key( 'MessageBusProperty', true ); // === 'message_bus_propertyid'
	   */
	    foreign_key : function ( str, drop_id_ubar ){
	      str = inflector.demodulize( str );
	      str = inflector.underscore( str ) + (( drop_id_ubar ) ? ( '' ) : ( '_' )) + 'id';
	
	      return str;
	    },
	
	
	
	  /**
	   * This function adds ordinalize support to every String object.
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @returns {String} Return all found numbers their sequence like '22nd'.
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.ordinalize( 'the 1 pitch' ); // === 'the 1st pitch'
	   */
	    ordinalize : function ( str ){
	      var str_arr = str.split( ' ' );
	      var i       = 0;
	      var j       = str_arr.length;
	
	      for( ; i < j; i++ ){
	        var k = parseInt( str_arr[ i ], 10 );
	
	        if( !isNaN( k )){
	          var ltd = str_arr[ i ].substring( str_arr[ i ].length - 2 );
	          var ld  = str_arr[ i ].substring( str_arr[ i ].length - 1 );
	          var suf = 'th';
	
	          if( ltd != '11' && ltd != '12' && ltd != '13' ){
	            if( ld === '1' ){
	              suf = 'st';
	            }else if( ld === '2' ){
	              suf = 'nd';
	            }else if( ld === '3' ){
	              suf = 'rd';
	            }
	          }
	
	          str_arr[ i ] += suf;
	        }
	      }
	
	      return str_arr.join( ' ' );
	    },
	
	  /**
	   * This function performs multiple inflection methods on a string
	   * @public
	   * @function
	   * @param {String} str The subject string.
	   * @param {Array} arr An array of inflection methods.
	   * @returns {String}
	   * @example
	   *
	   *     var inflection = require( 'inflection' );
	   *
	   *     inflection.transform( 'all job', [ 'pluralize', 'capitalize', 'dasherize' ]); // === 'All-jobs'
	   */
	    transform : function ( str, arr ){
	      var i = 0;
	      var j = arr.length;
	
	      for( ;i < j; i++ ){
	        var method = arr[ i ];
	
	        if( inflector.hasOwnProperty( method )){
	          str = inflector[ method ]( str );
	        }
	      }
	
	      return str;
	    }
	  };
	
	/**
	 * @public
	 */
	  inflector.version = '1.12.0';
	
	  return inflector;
	}));


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _passwordGenerator = __webpack_require__(522);
	
	var _passwordGenerator2 = _interopRequireDefault(_passwordGenerator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	}
	
	// provides functions for building urls to things we care about
	var MetabaseUtils = {
	    generatePassword: function generatePassword(length, complexity) {
	        var len = length || 14;
	
	        if (!complexity) {
	            return (0, _passwordGenerator2.default)(len, false);
	        } else {
	            var password = "";
	            var tries = 0;
	            while (!isStrongEnough(password) && tries < 100) {
	                password = (0, _passwordGenerator2.default)(len, false, /[\w\d\?\-]/);
	                tries++;
	            }
	            return password;
	        }
	
	        function isStrongEnough(password) {
	            var uc = password.match(/([A-Z])/g);
	            var lc = password.match(/([a-z])/g);
	            var di = password.match(/([\d])/g);
	            var sc = password.match(/([!@#\$%\^\&*\)\(+=._-{}])/g);
	
	            return uc && uc.length >= (complexity.upper || 0) && lc && lc.length >= (complexity.lower || 0) && di && di.length >= (complexity.digit || 0) && sc && sc.length >= (complexity.special || 0);
	        }
	    },
	
	    isEmpty: function isEmpty(str) {
	        return str == null || 0 === str.length;
	    },
	
	    // pretty limited.  just does 0-9 for right now.
	    numberToWord: function numberToWord(num) {
	        var names = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];
	
	        if (num >= 0 && num <= 9) {
	            return names[num];
	        } else {
	            return "" + num;
	        }
	    },
	
	    uuid: function uuid() {
	        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	    },
	
	    isUUID: function isUUID(uuid) {
	        return typeof uuid === "string" && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(uuid);
	    },
	    isBase64: function isBase64(string) {
	        return typeof string === "string" && /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
	    },
	    isJWT: function isJWT(string) {
	        return typeof string === "string" && /^[A-Za-z0-9]+\.[A-Za-z0-9]+\.[A-Za-z0-9_-]+$/.test(string);
	    },
	
	
	    validEmail: function validEmail(email) {
	        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        return re.test(email);
	    },
	
	    equals: function equals(a, b) {
	        // FIXME: ugghhhhhhhhh
	        return JSON.stringify(a) === JSON.stringify(b);
	    },
	
	    copy: function copy(a) {
	        // FIXME: ugghhhhhhhhh
	        return JSON.parse(JSON.stringify(a));
	    },
	
	    // this should correctly compare all version formats Metabase uses, e.x.
	    // 0.0.9, 0.0.10-snapshot, 0.0.10-alpha1, 0.0.10-rc1, 0.0.10-rc2, 0.0.10-rc10
	    // 0.0.10, 0.1.0, 0.2.0, 0.10.0, 1.1.0
	    compareVersions: function compareVersions(aVersion, bVersion) {
	        var SPECIAL_COMPONENTS = {
	            "snapshot": -4,
	            "alpha": -3,
	            "beta": -2,
	            "rc": -1
	        };
	
	        var getComponents = function getComponents(x) {
	            return (
	                // v1.2.3-BETA1
	                x.toLowerCase()
	                // v1.2.3-beta1
	                .replace(/^v/, "")
	                // 1.2.3-beta1
	                .split(/[.-]*([0-9]+)[.-]*/).filter(function (c) {
	                    return c;
	                })
	                // ["1", "2", "3", "beta", "1"]
	                .map(function (c) {
	                    return SPECIAL_COMPONENTS[c] || parseInt(c, 10);
	                })
	            );
	        };
	        // [1, 2, 3, -2, 1]
	
	        var aComponents = getComponents(aVersion);
	        var bComponents = getComponents(bVersion);
	        for (var i = 0; i < Math.max(aComponents.length, bComponents.length); i++) {
	            var a = aComponents[i];
	            var b = bComponents[i];
	            if (b == undefined || a < b) {
	                return -1;
	            } else if (a == undefined || b < a) {
	                return 1;
	            }
	        }
	        return 0;
	    }
	};
	
	exports.default = MetabaseUtils;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(523);

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * password-generator
	 * Copyright(c) 2011-2015 Bermi Ferrer <bermi@bermilabs.com>
	 * MIT Licensed
	 */
	(function (root) {
	
	  var localName, consonant, letter, password, vowel;
	  letter = /[a-z]$/i;
	  vowel = /[aeiou]$/i;
	  consonant = /[bcdfghjklmnpqrstvwxyz]$/i;
	
	
	  // Defines the name of the local variable the passwordGenerator library will use
	  // this is specially useful if window.passwordGenerator is already being used
	  // by your application and you want a different name. For example:
	  //    // Declare before including the passwordGenerator library
	  //    var localPasswordGeneratorLibraryName = 'pass';
	  localName = root.localPasswordGeneratorLibraryName || "generatePassword",
	
	  password = function (length, memorable, pattern, prefix) {
	    var char = "", n, i, validChars = [];
	    if (length == null) {
	      length = 10;
	    }
	    if (memorable == null) {
	      memorable = true;
	    }
	    if (pattern == null) {
	      pattern = /\w/;
	    }
	    if (prefix == null) {
	      prefix = '';
	    }
	
	    // Non memorable passwords will pick characters from a pre-generated
	    // list of characters
	    if (!memorable) {
	      for (i = 33; 126 > i; i += 1) {
	        char = String.fromCharCode(i);
	        if (char.match(pattern)) {
	          validChars.push(char);
	        }
	      }
	
	      if (!validChars.length) {
	        throw new Error("Could not find characters that match the " +
	          "password pattern " + pattern + ". Patterns must match individual " +
	          "characters, not the password as a whole.");
	      }
	    }
	
	
	    while (prefix.length < length) {
	      if (memorable) {
	        if (prefix.match(consonant)) {
	          pattern = vowel;
	        } else {
	          pattern = consonant;
	        }
	        n = rand(33, 126);
	        char = String.fromCharCode(n);
	      } else {
	        char = validChars[rand(0, validChars.length)];
	      }
	
	      if (memorable) {
	        char = char.toLowerCase();
	      }
	      if (char.match(pattern)) {
	        prefix = "" + prefix + char;
	      }
	    }
	    return prefix;
	  };
	
	
	  function rand(min, max) {
	    var key, value, arr = new Uint8Array(max);
	    getRandomValues(arr);
	    for (key in arr) {
	      if (arr.hasOwnProperty(key)) {
	        value = arr[key];
	        if (value > min && value < max) {
	          return value;
	        }
	      }
	    }
	    return rand(min, max);
	  }
	
	
	  function getRandomValues(buf) {
	    if (root.crypto && root.crypto.getRandomValues) {
	      root.crypto.getRandomValues(buf);
	    } else if (typeof root.msCrypto === "object" && typeof root.msCrypto.getRandomValues === 'function') {
	      root.msCrypto.getRandomValues(buf);
	    } else if (module.exports === password && "function" !== "undefined") {
	      var bytes = __webpack_require__(524).randomBytes(buf.length);
	      buf.set(bytes);
	    } else {
	      throw new Error("No secure random number generator available.");
	    }
	  }
	
	
	  (( true) ? exports : root)[localName] = password;
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      module.exports = password;
	    }
	  }
	
	  // Establish the root object, `window` in the browser, or `global` on the server.
	}(this));


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(529)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(531)
	
	exports.createHmac = __webpack_require__(543)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(544)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(546)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(526)
	var ieee754 = __webpack_require__(527)
	var isArray = __webpack_require__(528)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return b64.length * 3 / 4 - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, j, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr(len * 3 / 4 - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0, j = 0; i < l; i += 4, j += 3) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 528 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(530)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(525).Buffer))

/***/ }),
/* 530 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(532)
	
	var md5 = toConstructor(__webpack_require__(540))
	var rmd160 = toConstructor(__webpack_require__(542))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(525).Buffer
	var Hash   = __webpack_require__(533)(Buffer)
	
	exports.sha1 = __webpack_require__(534)(Buffer, Hash)
	exports.sha256 = __webpack_require__(538)(Buffer, Hash)
	exports.sha512 = __webpack_require__(539)(Buffer, Hash)


/***/ }),
/* 533 */
/***/ (function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(535).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(536);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(537);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(295)))

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(535).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(535).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(541);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(531)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(545)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(547)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(582)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(573);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(548);
	var Transform = __webpack_require__(549);
	var inherits = __webpack_require__(552);
	var modes = __webpack_require__(573);
	var ebtk = __webpack_require__(574);
	var StreamCipher = __webpack_require__(575);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(576),
	  CBC: __webpack_require__(577),
	  CFB: __webpack_require__(579),
	  OFB: __webpack_require__(580),
	  CTR: __webpack_require__(581)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(550).Transform;
	var inherits = __webpack_require__(552);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(551).EventEmitter;
	var inherits = __webpack_require__(552);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(553);
	Stream.Writable = __webpack_require__(569);
	Stream.Duplex = __webpack_require__(570);
	Stream.Transform = __webpack_require__(571);
	Stream.PassThrough = __webpack_require__(572);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 551 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 552 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(554);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(562);
	exports.Duplex = __webpack_require__(561);
	exports.Transform = __webpack_require__(567);
	exports.PassThrough = __webpack_require__(568);


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	module.exports = Readable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(555);
	/*</replacement>*/
	
	/*<replacement>*/
	var isArray = __webpack_require__(528);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(551).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(556);
	/*</replacement>*/
	
	var Buffer = __webpack_require__(525).Buffer;
	/*<replacement>*/
	var bufferShim = __webpack_require__(557);
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(558);
	util.inherits = __webpack_require__(552);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(559);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(560);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') {
	    return emitter.prependListener(event, fn);
	  } else {
	    // This is a hack to make sure that our error handler is attached before any
	    // userland ones.  NEVER DO THIS. This is here only because this code needs
	    // to continue to work with older versions of Node.js that do not include
	    // the prependListener() method. The goal is to eventually remove this hack.
	    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	  }
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(561);
	
	  options = options || {};
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // when piping, we only care about 'readable' events that happen
	  // after read()ing all the bytes and not getting any pushback.
	  this.ranOut = false;
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(566).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(561);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options && typeof options.read === 'function') this._read = options.read;
	
	  Stream.call(this);
	}
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	
	  if (!state.objectMode && typeof chunk === 'string') {
	    encoding = encoding || state.defaultEncoding;
	    if (encoding !== state.encoding) {
	      chunk = bufferShim.from(chunk, encoding);
	      encoding = '';
	    }
	  }
	
	  return readableAddChunk(this, state, chunk, encoding, false);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  var state = this._readableState;
	  return readableAddChunk(this, state, chunk, '', true);
	};
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	function readableAddChunk(stream, state, chunk, encoding, addToFront) {
	  var er = chunkInvalid(state, chunk);
	  if (er) {
	    stream.emit('error', er);
	  } else if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else if (state.objectMode || chunk && chunk.length > 0) {
	    if (state.ended && !addToFront) {
	      var e = new Error('stream.push() after EOF');
	      stream.emit('error', e);
	    } else if (state.endEmitted && addToFront) {
	      var _e = new Error('stream.unshift() after end event');
	      stream.emit('error', _e);
	    } else {
	      var skipAdd;
	      if (state.decoder && !addToFront && !encoding) {
	        chunk = state.decoder.write(chunk);
	        skipAdd = !state.objectMode && chunk.length === 0;
	      }
	
	      if (!addToFront) state.reading = false;
	
	      // Don't add to the buffer if we've decoded to an empty string chunk and
	      // we're not in object mode
	      if (!skipAdd) {
	        // if we want the data now, just emit it.
	        if (state.flowing && state.length === 0 && !state.sync) {
	          stream.emit('data', chunk);
	          stream.read(0);
	        } else {
	          // update the buffer info.
	          state.length += state.objectMode ? 1 : chunk.length;
	          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	          if (state.needReadable) emitReadable(stream);
	        }
	      }
	
	      maybeReadMore(stream, state);
	    }
	  } else if (!addToFront) {
	    state.reading = false;
	  }
	
	  return needMoreData(state);
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(566).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function chunkInvalid(state, chunk) {
	  var er = null;
	  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : cleanup;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable) {
	    debug('onunpipe');
	    if (readable === src) {
	      cleanup();
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', cleanup);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this, state);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = bufferShim.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = nextTick;
	} else {
	  module.exports = process.nextTick;
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(551).EventEmitter;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var buffer = __webpack_require__(525);
	var Buffer = buffer.Buffer;
	var SlowBuffer = buffer.SlowBuffer;
	var MAX_LEN = buffer.kMaxLength || 2147483647;
	exports.alloc = function alloc(size, fill, encoding) {
	  if (typeof Buffer.alloc === 'function') {
	    return Buffer.alloc(size, fill, encoding);
	  }
	  if (typeof encoding === 'number') {
	    throw new TypeError('encoding must not be number');
	  }
	  if (typeof size !== 'number') {
	    throw new TypeError('size must be a number');
	  }
	  if (size > MAX_LEN) {
	    throw new RangeError('size is too large');
	  }
	  var enc = encoding;
	  var _fill = fill;
	  if (_fill === undefined) {
	    enc = undefined;
	    _fill = 0;
	  }
	  var buf = new Buffer(size);
	  if (typeof _fill === 'string') {
	    var fillBuf = new Buffer(_fill, enc);
	    var flen = fillBuf.length;
	    var i = -1;
	    while (++i < size) {
	      buf[i] = fillBuf[i % flen];
	    }
	  } else {
	    buf.fill(_fill);
	  }
	  return buf;
	}
	exports.allocUnsafe = function allocUnsafe(size) {
	  if (typeof Buffer.allocUnsafe === 'function') {
	    return Buffer.allocUnsafe(size);
	  }
	  if (typeof size !== 'number') {
	    throw new TypeError('size must be a number');
	  }
	  if (size > MAX_LEN) {
	    throw new RangeError('size is too large');
	  }
	  return new Buffer(size);
	}
	exports.from = function from(value, encodingOrOffset, length) {
	  if (typeof Buffer.from === 'function' && (!global.Uint8Array || Uint8Array.from !== Buffer.from)) {
	    return Buffer.from(value, encodingOrOffset, length);
	  }
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number');
	  }
	  if (typeof value === 'string') {
	    return new Buffer(value, encodingOrOffset);
	  }
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    var offset = encodingOrOffset;
	    if (arguments.length === 1) {
	      return new Buffer(value);
	    }
	    if (typeof offset === 'undefined') {
	      offset = 0;
	    }
	    var len = length;
	    if (typeof len === 'undefined') {
	      len = value.byteLength - offset;
	    }
	    if (offset >= value.byteLength) {
	      throw new RangeError('\'offset\' is out of bounds');
	    }
	    if (len > value.byteLength - offset) {
	      throw new RangeError('\'length\' is out of bounds');
	    }
	    return new Buffer(value.slice(offset, offset + len));
	  }
	  if (Buffer.isBuffer(value)) {
	    var out = new Buffer(value.length);
	    value.copy(out, 0, 0, value.length);
	    return out;
	  }
	  if (value) {
	    if (Array.isArray(value) || (typeof ArrayBuffer !== 'undefined' && value.buffer instanceof ArrayBuffer) || 'length' in value) {
	      return new Buffer(value);
	    }
	    if (value.type === 'Buffer' && Array.isArray(value.data)) {
	      return new Buffer(value.data);
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ' + 'ArrayBuffer, Array, or array-like object.');
	}
	exports.allocUnsafeSlow = function allocUnsafeSlow(size) {
	  if (typeof Buffer.allocUnsafeSlow === 'function') {
	    return Buffer.allocUnsafeSlow(size);
	  }
	  if (typeof size !== 'number') {
	    throw new TypeError('size must be a number');
	  }
	  if (size >= MAX_LEN) {
	    throw new RangeError('size is too large');
	  }
	  return new SlowBuffer(size);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(525).Buffer;
	/*<replacement>*/
	var bufferShim = __webpack_require__(557);
	/*</replacement>*/
	
	module.exports = BufferList;
	
	function BufferList() {
	  this.head = null;
	  this.tail = null;
	  this.length = 0;
	}
	
	BufferList.prototype.push = function (v) {
	  var entry = { data: v, next: null };
	  if (this.length > 0) this.tail.next = entry;else this.head = entry;
	  this.tail = entry;
	  ++this.length;
	};
	
	BufferList.prototype.unshift = function (v) {
	  var entry = { data: v, next: this.head };
	  if (this.length === 0) this.tail = entry;
	  this.head = entry;
	  ++this.length;
	};
	
	BufferList.prototype.shift = function () {
	  if (this.length === 0) return;
	  var ret = this.head.data;
	  if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	  --this.length;
	  return ret;
	};
	
	BufferList.prototype.clear = function () {
	  this.head = this.tail = null;
	  this.length = 0;
	};
	
	BufferList.prototype.join = function (s) {
	  if (this.length === 0) return '';
	  var p = this.head;
	  var ret = '' + p.data;
	  while (p = p.next) {
	    ret += s + p.data;
	  }return ret;
	};
	
	BufferList.prototype.concat = function (n) {
	  if (this.length === 0) return bufferShim.alloc(0);
	  if (this.length === 1) return this.head.data;
	  var ret = bufferShim.allocUnsafe(n >>> 0);
	  var p = this.head;
	  var i = 0;
	  while (p) {
	    p.data.copy(ret, i);
	    i += p.data.length;
	    p = p.next;
	  }
	  return ret;
	};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(555);
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(558);
	util.inherits = __webpack_require__(552);
	/*</replacement>*/
	
	var Readable = __webpack_require__(554);
	var Writable = __webpack_require__(562);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	module.exports = Writable;
	
	/*<replacement>*/
	var processNextTick = __webpack_require__(555);
	/*</replacement>*/
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(558);
	util.inherits = __webpack_require__(552);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(565)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(556);
	/*</replacement>*/
	
	var Buffer = __webpack_require__(525).Buffer;
	/*<replacement>*/
	var bufferShim = __webpack_require__(557);
	/*</replacement>*/
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(561);
	
	  options = options || {};
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = ~~this.highWaterMark;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(561);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = Buffer.isBuffer(chunk);
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = bufferShim.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    chunk = decodeChunk(state, chunk, encoding);
	    if (Buffer.isBuffer(chunk)) encoding = 'buffer';
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	  if (sync) processNextTick(cb, er);else cb(er);
	
	  stream._writableState.errorEmitted = true;
	  stream.emit('error', er);
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    while (entry) {
	      buffer[count] = entry;
	      entry = entry.next;
	      count += 1;
	    }
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	
	function prefinish(stream, state) {
	  if (!state.prefinished) {
	    state.prefinished = true;
	    stream.emit('prefinish');
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    if (state.pendingcb === 0) {
	      prefinish(stream, state);
	      state.finished = true;
	      stream.emit('finish');
	    } else {
	      prefinish(stream, state);
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function (err) {
	    var entry = _this.entry;
	    _this.entry = null;
	    while (entry) {
	      var cb = entry.callback;
	      state.pendingcb--;
	      cb(err);
	      entry = entry.next;
	    }
	    if (state.corkedRequestsFree) {
	      state.corkedRequestsFree.next = _this;
	    } else {
	      state.corkedRequestsFree = _this;
	    }
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295), __webpack_require__(563).setImmediate))

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(564);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(295)))

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(525).Buffer;
	var bufferShim = __webpack_require__(557);
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = bufferShim.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return -1;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd'.repeat(p);
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd'.repeat(p + 1);
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd'.repeat(p + 2);
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character for each buffered byte of a (partial)
	// character needs to be added to the output.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(561);
	
	/*<replacement>*/
	var util = __webpack_require__(558);
	util.inherits = __webpack_require__(552);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(this);
	
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er, data) {
	      done(stream, er, data);
	    });else done(stream);
	  });
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (ts.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(567);
	
	/*<replacement>*/
	var util = __webpack_require__(558);
	util.inherits = __webpack_require__(552);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(562);


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(561);


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(553).Transform


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(553).PassThrough


/***/ }),
/* 573 */
/***/ (function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(548);
	var Transform = __webpack_require__(549);
	var inherits = __webpack_require__(552);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(578);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(578);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(578);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(578);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(548);
	var Transform = __webpack_require__(549);
	var inherits = __webpack_require__(552);
	var modes = __webpack_require__(573);
	var StreamCipher = __webpack_require__(575);
	var ebtk = __webpack_require__(574);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(576),
	  CBC: __webpack_require__(577),
	  CFB: __webpack_require__(579),
	  OFB: __webpack_require__(580),
	  CTR: __webpack_require__(581)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var debug = void 0;
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (window.location && window.location.hash === "#debug" || window.localStorage && window.localStorage.getItem("debug"))) {
	    debug = true;
	} else {
	    debug = false;
	}
	
	var DEBUG = exports.DEBUG = debug;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _querystring = __webpack_require__(585);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _events = __webpack_require__(551);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	var DEFAULT_OPTIONS = {
	    noEvent: false,
	    transformResponse: function transformResponse(o) {
	        return o;
	    }
	};
	
	var Api = function (_EventEmitter) {
	    _inherits(Api, _EventEmitter);
	
	    function Api() {
	        _classCallCheck(this, Api);
	
	        var _this = _possibleConstructorReturn(this, (Api.__proto__ || Object.getPrototypeOf(Api)).call(this));
	
	        _this.GET = _this._makeMethod("GET").bind(_this);
	        _this.DELETE = _this._makeMethod("DELETE").bind(_this);
	        _this.POST = _this._makeMethod("POST", true).bind(_this);
	        _this.PUT = _this._makeMethod("PUT", true).bind(_this);
	        return _this;
	    }
	
	    _createClass(Api, [{
	        key: "_makeMethod",
	        value: function _makeMethod(method) {
	            var _this2 = this;
	
	            var hasBody = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            return function (urlTemplate) {
	                var methodOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	                if (typeof methodOptions === "function") {
	                    methodOptions = { transformResponse: methodOptions };
	                }
	                var defaultOptions = _extends({}, DEFAULT_OPTIONS, methodOptions);
	                return function (data) {
	                    var invocationOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	                    var options = _extends({}, defaultOptions, invocationOptions);
	                    var url = urlTemplate;
	                    data = _extends({}, data);
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                        for (var _iterator = (url.match(/:\w+/g) || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            var tag = _step.value;
	
	                            var value = data[tag.slice(1)];
	                            if (value === undefined) {
	                                console.warn("Warning: calling", method, "without", tag);
	                                value = "";
	                            }
	                            url = url.replace(tag, encodeURIComponent(data[tag.slice(1)]));
	                            delete data[tag.slice(1)];
	                        }
	                    } catch (err) {
	                        _didIteratorError = true;
	                        _iteratorError = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	                        } finally {
	                            if (_didIteratorError) {
	                                throw _iteratorError;
	                            }
	                        }
	                    }
	
	                    var headers = {
	                        "Accept": "application/json"
	                    };
	
	                    var body = void 0;
	                    if (hasBody) {
	                        headers["Content-Type"] = "application/json";
	                        body = JSON.stringify(data);
	                    } else {
	                        var qs = _querystring2.default.stringify(data);
	                        if (qs) {
	                            url += (url.indexOf("?") >= 0 ? "&" : "?") + qs;
	                        }
	                    }
	
	                    return _this2._makeRequest(method, url, headers, body, data, options);
	                };
	            };
	        }
	
	        // TODO Atte Keinänen 6/26/17: Replacing this with isomorphic-fetch could simplify the implementation
	
	    }, {
	        key: "_makeRequest",
	        value: function _makeRequest(method, url, headers, body, data, options) {
	            var _this3 = this;
	
	            return new Promise(function (resolve, reject) {
	                var isCancelled = false;
	                var xhr = new XMLHttpRequest();
	                xhr.open(method, _this3.basename + url);
	                for (var headerName in headers) {
	                    xhr.setRequestHeader(headerName, headers[headerName]);
	                }
	                xhr.onreadystatechange = function () {
	                    // $FlowFixMe
	                    if (xhr.readyState === XMLHttpRequest.DONE) {
	                        var _body = xhr.responseText;
	                        try {
	                            _body = JSON.parse(_body);
	                        } catch (e) {}
	                        if (xhr.status >= 200 && xhr.status <= 299) {
	                            if (options.transformResponse) {
	                                _body = options.transformResponse(_body, { data: data });
	                            }
	                            resolve(_body);
	                        } else {
	                            reject({
	                                status: xhr.status,
	                                data: _body,
	                                isCancelled: isCancelled
	                            });
	                        }
	                        if (!options.noEvent) {
	                            _this3.emit(xhr.status, url);
	                        }
	                    }
	                };
	                xhr.send(body);
	
	                if (options.cancelled) {
	                    options.cancelled.then(function () {
	                        isCancelled = true;
	                        xhr.abort();
	                    });
	                }
	            });
	        }
	    }]);
	
	    return Api;
	}(_events2.default);
	
	exports.default = new Api();

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(586);
	exports.encode = exports.stringify = __webpack_require__(587);


/***/ }),
/* 586 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 587 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	exports.getStore = getStore;
	
	var _redux = __webpack_require__(480);
	
	var _reduxForm = __webpack_require__(589);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _reduxPromise = __webpack_require__(643);
	
	var _reduxPromise2 = _interopRequireDefault(_reduxPromise);
	
	var _reduxLogger = __webpack_require__(650);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _debug = __webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Provides the same functionality as redux-thunk and augments the dispatch method with
	 * `dispatch.action(type, payload)` which creates an action that adheres to Flux Standard Action format.
	 */
	var thunkWithDispatchAction = function thunkWithDispatchAction(_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	        return function (action) {
	            if (typeof action === 'function') {
	                var dispatchAugmented = Object.assign(dispatch, {
	                    action: function action(type, payload) {
	                        return dispatch({ type: type, payload: payload });
	                    }
	                });
	
	                return action(dispatchAugmented, getState);
	            }
	            return next(action);
	        };
	    };
	};
	
	var devToolsExtension = window.devToolsExtension ? window.devToolsExtension() : function (f) {
	    return f;
	};
	
	function getStore(reducers, history, intialState) {
	    var enhancer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (a) {
	        return a;
	    };
	
	
	    var reducer = (0, _redux.combineReducers)(_extends({}, reducers, {
	        form: _reduxForm.reducer,
	        routing: _reactRouterRedux.routerReducer
	    }));
	
	    var middleware = [thunkWithDispatchAction, _reduxPromise2.default].concat(_toConsumableArray(_debug.DEBUG ? [_reduxLogger2.default] : []), [(0, _reactRouterRedux.routerMiddleware)(history)]);
	
	    return (0, _redux.createStore)(reducer, intialState, (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, _toConsumableArray(middleware)), devToolsExtension, enhancer));
	}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouchWithKey = exports.untouch = exports.touchWithKey = exports.touch = exports.swapArrayValues = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.propTypes = exports.initializeWithKey = exports.initialize = exports.getValues = exports.removeArrayValue = exports.reduxForm = exports.reducer = exports.focus = exports.destroy = exports.changeWithKey = exports.change = exports.blur = exports.autofillWithKey = exports.autofill = exports.addArrayValue = exports.actionTypes = undefined;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _createAll2 = __webpack_require__(590);
	
	var _createAll3 = _interopRequireDefault(_createAll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	var _createAll = (0, _createAll3.default)(isNative, _react2.default, _reactRedux.connect);
	
	var actionTypes = _createAll.actionTypes,
	    addArrayValue = _createAll.addArrayValue,
	    autofill = _createAll.autofill,
	    autofillWithKey = _createAll.autofillWithKey,
	    blur = _createAll.blur,
	    change = _createAll.change,
	    changeWithKey = _createAll.changeWithKey,
	    destroy = _createAll.destroy,
	    focus = _createAll.focus,
	    reducer = _createAll.reducer,
	    reduxForm = _createAll.reduxForm,
	    removeArrayValue = _createAll.removeArrayValue,
	    getValues = _createAll.getValues,
	    initialize = _createAll.initialize,
	    initializeWithKey = _createAll.initializeWithKey,
	    propTypes = _createAll.propTypes,
	    reset = _createAll.reset,
	    startAsyncValidation = _createAll.startAsyncValidation,
	    startSubmit = _createAll.startSubmit,
	    stopAsyncValidation = _createAll.stopAsyncValidation,
	    stopSubmit = _createAll.stopSubmit,
	    swapArrayValues = _createAll.swapArrayValues,
	    touch = _createAll.touch,
	    touchWithKey = _createAll.touchWithKey,
	    untouch = _createAll.untouch,
	    untouchWithKey = _createAll.untouchWithKey;
	exports.actionTypes = actionTypes;
	exports.addArrayValue = addArrayValue;
	exports.autofill = autofill;
	exports.autofillWithKey = autofillWithKey;
	exports.blur = blur;
	exports.change = change;
	exports.changeWithKey = changeWithKey;
	exports.destroy = destroy;
	exports.focus = focus;
	exports.reducer = reducer;
	exports.reduxForm = reduxForm;
	exports.removeArrayValue = removeArrayValue;
	exports.getValues = getValues;
	exports.initialize = initialize;
	exports.initializeWithKey = initializeWithKey;
	exports.propTypes = propTypes;
	exports.reset = reset;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.swapArrayValues = swapArrayValues;
	exports.touch = touch;
	exports.touchWithKey = touchWithKey;
	exports.untouch = untouch;
	exports.untouchWithKey = untouchWithKey;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createAll;
	
	var _reducer = __webpack_require__(591);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _createReduxForm = __webpack_require__(603);
	
	var _createReduxForm2 = _interopRequireDefault(_createReduxForm);
	
	var _mapValues = __webpack_require__(593);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _bindActionData = __webpack_require__(613);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _actions = __webpack_require__(612);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actionTypes = __webpack_require__(592);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _createPropTypes = __webpack_require__(637);
	
	var _createPropTypes2 = _interopRequireDefault(_createPropTypes);
	
	var _getValuesFromState = __webpack_require__(596);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// bind form as first parameter of action creators
	var boundActions = _extends({}, (0, _mapValues2.default)(_extends({}, actions, {
	  autofillWithKey: function autofillWithKey(key) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _bindActionData2.default)(actions.autofill, { key: key }).apply(undefined, args);
	  },
	  changeWithKey: function changeWithKey(key) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    return (0, _bindActionData2.default)(actions.change, { key: key }).apply(undefined, args);
	  },
	  initializeWithKey: function initializeWithKey(key) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    return (0, _bindActionData2.default)(actions.initialize, { key: key }).apply(undefined, args);
	  },
	  reset: function reset(key) {
	    return (0, _bindActionData2.default)(actions.reset, { key: key })();
	  },
	  touchWithKey: function touchWithKey(key) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	      args[_key4 - 1] = arguments[_key4];
	    }
	
	    return (0, _bindActionData2.default)(actions.touch, { key: key }).apply(undefined, args);
	  },
	  untouchWithKey: function untouchWithKey(key) {
	    for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	      args[_key5 - 1] = arguments[_key5];
	    }
	
	    return (0, _bindActionData2.default)(actions.untouch, { key: key }).apply(undefined, args);
	  },
	  destroy: function destroy(key) {
	    return (0, _bindActionData2.default)(actions.destroy, { key: key })();
	  }
	}), function (action) {
	  return function (form) {
	    for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	      args[_key6 - 1] = arguments[_key6];
	    }
	
	    return (0, _bindActionData2.default)(action, { form: form }).apply(undefined, args);
	  };
	}));
	
	var addArrayValue = boundActions.addArrayValue;
	var autofill = boundActions.autofill;
	var autofillWithKey = boundActions.autofillWithKey;
	var blur = boundActions.blur;
	var change = boundActions.change;
	var changeWithKey = boundActions.changeWithKey;
	var destroy = boundActions.destroy;
	var focus = boundActions.focus;
	var initialize = boundActions.initialize;
	var initializeWithKey = boundActions.initializeWithKey;
	var removeArrayValue = boundActions.removeArrayValue;
	var reset = boundActions.reset;
	var startAsyncValidation = boundActions.startAsyncValidation;
	var startSubmit = boundActions.startSubmit;
	var stopAsyncValidation = boundActions.stopAsyncValidation;
	var stopSubmit = boundActions.stopSubmit;
	var submitFailed = boundActions.submitFailed;
	var swapArrayValues = boundActions.swapArrayValues;
	var touch = boundActions.touch;
	var touchWithKey = boundActions.touchWithKey;
	var untouch = boundActions.untouch;
	var untouchWithKey = boundActions.untouchWithKey;
	
	function createAll(isReactNative, React, connect) {
	  return {
	    actionTypes: actionTypes,
	    addArrayValue: addArrayValue,
	    autofill: autofill,
	    autofillWithKey: autofillWithKey,
	    blur: blur,
	    change: change,
	    changeWithKey: changeWithKey,
	    destroy: destroy,
	    focus: focus,
	    getValues: _getValuesFromState2.default,
	    initialize: initialize,
	    initializeWithKey: initializeWithKey,
	    propTypes: (0, _createPropTypes2.default)(React),
	    reduxForm: (0, _createReduxForm2.default)(isReactNative, React, connect),
	    reducer: _reducer2.default,
	    removeArrayValue: removeArrayValue,
	    reset: reset,
	    startAsyncValidation: startAsyncValidation,
	    startSubmit: startSubmit,
	    stopAsyncValidation: stopAsyncValidation,
	    stopSubmit: stopSubmit,
	    submitFailed: submitFailed,
	    swapArrayValues: swapArrayValues,
	    touch: touch,
	    touchWithKey: touchWithKey,
	    untouch: untouch,
	    untouchWithKey: untouchWithKey
	  };
	}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.initialState = exports.globalErrorKey = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _initialState, _behaviors;
	
	var _actionTypes = __webpack_require__(592);
	
	var _mapValues = __webpack_require__(593);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _read = __webpack_require__(594);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _write = __webpack_require__(595);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValuesFromState = __webpack_require__(596);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	var _initializeState = __webpack_require__(598);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	var _resetState = __webpack_require__(599);
	
	var _resetState2 = _interopRequireDefault(_resetState);
	
	var _setErrors = __webpack_require__(600);
	
	var _setErrors2 = _interopRequireDefault(_setErrors);
	
	var _fieldValue = __webpack_require__(597);
	
	var _normalizeFields = __webpack_require__(601);
	
	var _normalizeFields2 = _interopRequireDefault(_normalizeFields);
	
	var _createInitialState = __webpack_require__(602);
	
	var _createInitialState2 = _interopRequireDefault(_createInitialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var globalErrorKey = exports.globalErrorKey = '_error';
	
	var initialState = exports.initialState = (_initialState = {
	  _active: undefined,
	  _asyncValidating: false
	}, _initialState[globalErrorKey] = undefined, _initialState._initialized = false, _initialState._submitting = false, _initialState._submitFailed = false, _initialState);
	
	var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ADD_ARRAY_VALUE] = function (state, _ref) {
	  var path = _ref.path,
	      index = _ref.index,
	      value = _ref.value,
	      fields = _ref.fields;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  var newValue = value !== null && typeof value === 'object' ? (0, _initializeState2.default)(value, fields || Object.keys(value)) : (0, _fieldValue.makeFieldValue)({ value: value });
	  if (index === undefined) {
	    arrayCopy.push(newValue);
	  } else {
	    arrayCopy.splice(index, 0, newValue);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref2) {
	  var field = _ref2.field,
	      value = _ref2.value;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value$autof = _extends({}, previous, { value: value, autofilled: true }),
	        asyncError = _previous$value$autof.asyncError,
	        submitError = _previous$value$autof.submitError,
	        result = _objectWithoutProperties(_previous$value$autof, ['asyncError', 'submitError']);
	
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.BLUR] = function (state, _ref3) {
	  var field = _ref3.field,
	      value = _ref3.value,
	      touch = _ref3.touch;
	
	  var _active = state._active,
	      stateCopy = _objectWithoutProperties(state, ['_active']);
	
	  if (_active && _active !== field) {
	    // remove _active from state
	    stateCopy._active = _active;
	  }
	  return (0, _write2.default)(field, function (previous) {
	    var result = _extends({}, previous);
	    if (value !== undefined) {
	      result.value = value;
	    }
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, stateCopy);
	}, _behaviors[_actionTypes.CHANGE] = function (state, _ref4) {
	  var field = _ref4.field,
	      value = _ref4.value,
	      touch = _ref4.touch;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value = _extends({}, previous, { value: value }),
	        asyncError = _previous$value.asyncError,
	        submitError = _previous$value.submitError,
	        autofilled = _previous$value.autofilled,
	        result = _objectWithoutProperties(_previous$value, ['asyncError', 'submitError', 'autofilled']);
	
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.DESTROY] = function () {
	  return undefined;
	}, _behaviors[_actionTypes.FOCUS] = function (state, _ref5) {
	  var field = _ref5.field;
	
	  var stateCopy = (0, _write2.default)(field, function (previous) {
	    return (0, _fieldValue.makeFieldValue)(_extends({}, previous, { visited: true }));
	  }, state);
	  stateCopy._active = field;
	  return stateCopy;
	}, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref6) {
	  var data = _ref6.data,
	      fields = _ref6.fields,
	      overwriteValues = _ref6.overwriteValues;
	
	  return (0, _createInitialState2.default)(data, fields, state, overwriteValues);
	}, _behaviors[_actionTypes.REMOVE_ARRAY_VALUE] = function (state, _ref7) {
	  var path = _ref7.path,
	      index = _ref7.index;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  if (index === undefined) {
	    arrayCopy.pop();
	  } else if (isNaN(index)) {
	    delete arrayCopy[index];
	  } else {
	    arrayCopy.splice(index, 1);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.RESET] = function (state) {
	  var _extends2;
	
	  return _extends({}, (0, _resetState2.default)(state), (_extends2 = {
	    _active: undefined,
	    _asyncValidating: false
	  }, _extends2[globalErrorKey] = undefined, _extends2._initialized = state._initialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	}, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref8) {
	  var field = _ref8.field;
	
	  return _extends({}, state, {
	    _asyncValidating: field || true
	  });
	}, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
	  return _extends({}, state, {
	    _submitting: true
	  });
	}, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref9) {
	  var _extends3;
	
	  var errors = _ref9.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'asyncError'), (_extends3 = {
	    _asyncValidating: false
	  }, _extends3[globalErrorKey] = errors && errors[globalErrorKey], _extends3));
	}, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref10) {
	  var _extends4;
	
	  var errors = _ref10.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'submitError'), (_extends4 = {}, _extends4[globalErrorKey] = errors && errors[globalErrorKey], _extends4._submitting = false, _extends4._submitFailed = !!(errors && Object.keys(errors).length), _extends4));
	}, _behaviors[_actionTypes.SUBMIT_FAILED] = function (state) {
	  return _extends({}, state, {
	    _submitFailed: true
	  });
	}, _behaviors[_actionTypes.SWAP_ARRAY_VALUES] = function (state, _ref11) {
	  var path = _ref11.path,
	      indexA = _ref11.indexA,
	      indexB = _ref11.indexB;
	
	  var array = (0, _read2.default)(path, state);
	  var arrayLength = array.length;
	  if (indexA === indexB || isNaN(indexA) || isNaN(indexB) || indexA >= arrayLength || indexB >= arrayLength) {
	    return state; // do nothing
	  }
	  var stateCopy = _extends({}, state);
	  var arrayCopy = [].concat(array);
	  arrayCopy[indexA] = array[indexB];
	  arrayCopy[indexB] = array[indexA];
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.TOUCH] = function (state, _ref12) {
	  var fields = _ref12.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      return (0, _fieldValue.makeFieldValue)(_extends({}, value, { touched: true }));
	    }, accumulator);
	  }, state));
	}, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref13) {
	  var fields = _ref13.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      if (value) {
	        var touched = value.touched,
	            rest = _objectWithoutProperties(value, ['touched']);
	
	        return (0, _fieldValue.makeFieldValue)(rest);
	      }
	      return (0, _fieldValue.makeFieldValue)(value);
	    }, accumulator);
	  }, state));
	}, _behaviors);
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var behavior = behaviors[action.type];
	  return behavior ? behavior(state, action) : state;
	};
	
	function formReducer() {
	  var _extends10;
	
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var form = action.form,
	      key = action.key,
	      rest = _objectWithoutProperties(action, ['form', 'key']); // eslint-disable-line no-redeclare
	
	
	  if (!form) {
	    return state;
	  }
	  if (key) {
	    var _extends7, _extends8;
	
	    if (action.type === _actionTypes.DESTROY) {
	      var _extends6;
	
	      return _extends({}, state, (_extends6 = {}, _extends6[form] = state[form] && Object.keys(state[form]).reduce(function (accumulator, stateKey) {
	        var _extends5;
	
	        return stateKey === key ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[stateKey] = state[form][stateKey], _extends5));
	      }, {}), _extends6));
	    }
	    return _extends({}, state, (_extends8 = {}, _extends8[form] = _extends({}, state[form], (_extends7 = {}, _extends7[key] = reducer((state[form] || {})[key], rest), _extends7)), _extends8));
	  }
	  if (action.type === _actionTypes.DESTROY) {
	    return Object.keys(state).reduce(function (accumulator, formName) {
	      var _extends9;
	
	      return formName === form ? accumulator : _extends({}, accumulator, (_extends9 = {}, _extends9[formName] = state[formName], _extends9));
	    }, {});
	  }
	  return _extends({}, state, (_extends10 = {}, _extends10[form] = reducer(state[form], rest), _extends10));
	}
	
	/**
	 * Adds additional functionality to the reducer
	 */
	function decorate(target) {
	  target.plugin = function plugin(reducers) {
	    var _this = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var result = _this(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(reducers, function (pluginReducer, key) {
	        return pluginReducer(result[key] || initialState, action);
	      }));
	    });
	  };
	
	  target.normalize = function normalize(normalizers) {
	    var _this2 = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var result = _this2(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(normalizers, function (formNormalizers, form) {
	        var runNormalize = function runNormalize(previous, currentResult) {
	          var previousValues = (0, _getValuesFromState2.default)(_extends({}, initialState, previous));
	          var formResult = _extends({}, initialState, currentResult);
	          var values = (0, _getValuesFromState2.default)(formResult);
	          return (0, _normalizeFields2.default)(formNormalizers, formResult, previous, values, previousValues);
	        };
	        if (action.key) {
	          var _extends11;
	
	          return _extends({}, result[form], (_extends11 = {}, _extends11[action.key] = runNormalize(state[form][action.key], result[form][action.key]), _extends11));
	        }
	        return runNormalize(state[form], result[form]);
	      }));
	    });
	  };
	
	  return target;
	}
	
	exports.default = decorate(formReducer);

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ADD_ARRAY_VALUE = exports.ADD_ARRAY_VALUE = 'redux-form/ADD_ARRAY_VALUE';
	var AUTOFILL = exports.AUTOFILL = 'redux-form/AUTOFILL';
	var BLUR = exports.BLUR = 'redux-form/BLUR';
	var CHANGE = exports.CHANGE = 'redux-form/CHANGE';
	var DESTROY = exports.DESTROY = 'redux-form/DESTROY';
	var FOCUS = exports.FOCUS = 'redux-form/FOCUS';
	var INITIALIZE = exports.INITIALIZE = 'redux-form/INITIALIZE';
	var REMOVE_ARRAY_VALUE = exports.REMOVE_ARRAY_VALUE = 'redux-form/REMOVE_ARRAY_VALUE';
	var RESET = exports.RESET = 'redux-form/RESET';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = 'redux-form/START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = 'redux-form/START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = 'redux-form/STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = 'redux-form/STOP_SUBMIT';
	var SUBMIT_FAILED = exports.SUBMIT_FAILED = 'redux-form/SUBMIT_FAILED';
	var SWAP_ARRAY_VALUES = exports.SWAP_ARRAY_VALUES = 'redux-form/SWAP_ARRAY_VALUES';
	var TOUCH = exports.TOUCH = 'redux-form/TOUCH';
	var UNTOUCH = exports.UNTOUCH = 'redux-form/UNTOUCH';

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapValues;
	/**
	 * Maps all the values in the given object through the given function and saves them, by key, to a result object
	 */
	function mapValues(obj, fn) {
	  return obj ? Object.keys(obj).reduce(function (accumulator, key) {
	    var _extends2;
	
	    return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = fn(obj[key], key), _extends2));
	  }, {}) : obj;
	}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Reads any potentially deep value from an object using dot and array syntax
	 */
	var read = function read(path, object) {
	  if (!path || !object) {
	    return object;
	  }
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return read(path.substring(1), object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    // iterate down object tree
	    return read(path.substring(dotIndex + 1), object[path.substring(0, dotIndex)]);
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    if (closeIndex < 0) {
	      throw new Error('found [ but no ]');
	    }
	    var key = path.substring(0, openIndex);
	    var index = path.substring(openIndex + 1, closeIndex);
	    if (!index.length) {
	      return object[key];
	    }
	    if (openIndex === 0) {
	      return read(path.substring(closeIndex + 1), object[index]);
	    }
	    if (!object[key]) {
	      return undefined;
	    }
	    return read(path.substring(closeIndex + 1), object[key][index]);
	  }
	  return object[path];
	};
	
	exports.default = read;

/***/ }),
/* 595 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Writes any potentially deep value from an object using dot and array syntax,
	 * and returns a new copy of the object.
	 */
	var write = function write(path, value, object) {
	  var _extends7;
	
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return write(path.substring(1), value, object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    var _extends2;
	
	    // is dot notation
	    var key = path.substring(0, dotIndex);
	    return _extends({}, object, (_extends2 = {}, _extends2[key] = write(path.substring(dotIndex + 1), value, object[key] || {}), _extends2));
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _ret = function () {
	      var _extends6;
	
	      // is array notation
	      if (closeIndex < 0) {
	        throw new Error('found [ but no ]');
	      }
	      var key = path.substring(0, openIndex);
	      var index = path.substring(openIndex + 1, closeIndex);
	      var array = object[key] || [];
	      var rest = path.substring(closeIndex + 1);
	      if (index) {
	        var _extends4;
	
	        // indexed array
	        if (rest.length) {
	          var _extends3;
	
	          // need to keep recursing
	          var dest = array[index] || {};
	          var arrayCopy = [].concat(array);
	          arrayCopy[index] = write(rest, value, dest);
	          return {
	            v: _extends({}, object || {}, (_extends3 = {}, _extends3[key] = arrayCopy, _extends3))
	          };
	        }
	        var copy = [].concat(array);
	        copy[index] = typeof value === 'function' ? value(copy[index]) : value;
	        return {
	          v: _extends({}, object || {}, (_extends4 = {}, _extends4[key] = copy, _extends4))
	        };
	      }
	      // indexless array
	      if (rest.length) {
	        var _extends5;
	
	        // need to keep recursing
	        if ((!array || !array.length) && typeof value === 'function') {
	          return {
	            v: object
	          }; // don't even set a value under [key]
	        }
	        var _arrayCopy = array.map(function (dest) {
	          return write(rest, value, dest);
	        });
	        return {
	          v: _extends({}, object || {}, (_extends5 = {}, _extends5[key] = _arrayCopy, _extends5))
	        };
	      }
	      var result = void 0;
	      if (Array.isArray(value)) {
	        result = value;
	      } else if (object[key]) {
	        result = array.map(function (dest) {
	          return typeof value === 'function' ? value(dest) : value;
	        });
	      } else if (typeof value === 'function') {
	        return {
	          v: object
	        }; // don't even set a value under [key]
	      } else {
	        result = value;
	      }
	      return {
	        v: _extends({}, object || {}, (_extends6 = {}, _extends6[key] = result, _extends6))
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	  return _extends({}, object, (_extends7 = {}, _extends7[path] = typeof value === 'function' ? value(object[path]) : value, _extends7));
	};
	
	exports.default = write;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(597);
	
	/**
	 * A different version of getValues() that does not need the fields array
	 */
	var getValuesFromState = function getValuesFromState(state) {
	  if (!state) {
	    return state;
	  }
	  var keys = Object.keys(state);
	  if (!keys.length) {
	    return undefined;
	  }
	  return keys.reduce(function (accumulator, key) {
	    var field = state[key];
	    if (field) {
	      if ((0, _fieldValue.isFieldValue)(field)) {
	        if (field.value !== undefined) {
	          accumulator[key] = field.value;
	        }
	      } else if (Array.isArray(field)) {
	        accumulator[key] = field.map(function (arrayField) {
	          return (0, _fieldValue.isFieldValue)(arrayField) ? arrayField.value : getValuesFromState(arrayField);
	        });
	      } else if (typeof field === 'object') {
	        var result = getValuesFromState(field);
	
	        if (result && Object.keys(result).length > 0) {
	          accumulator[key] = result;
	        }
	      }
	    }
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValuesFromState;

/***/ }),
/* 597 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.makeFieldValue = makeFieldValue;
	exports.isFieldValue = isFieldValue;
	var flag = '_isFieldValue';
	var isObject = function isObject(object) {
	  return typeof object === 'object';
	};
	
	function makeFieldValue(object) {
	  if (object && isObject(object)) {
	    // This flag has to be enumerable, because otherwise it is not possible
	    // to serialize object with this field.
	    // The consequence is you lose information that particular field is
	    // field or nested group of fields, so you're not able to fetch
	    // field value from state when it has been affected in some way
	    // by serializing/using immutable and so on.
	    // @fixme marking field as leaf should be made in other way
	    Object.defineProperty(object, flag, { value: true, enumerable: true });
	  }
	  return object;
	}
	
	function isFieldValue(object) {
	  return !!(object && isObject(object) && object[flag]);
	}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(597);
	
	var makeEntry = function makeEntry(value, previousValue, overwriteValues) {
	  if (value === undefined && previousValue === undefined) return (0, _fieldValue.makeFieldValue)({});
	  return (0, _fieldValue.makeFieldValue)({
	    initial: value,
	    value: overwriteValues ? value : previousValue
	  });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var initializeState = function initializeState(values, fields) {
	  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  if (!fields) {
	    throw new Error('fields must be passed when initializing state');
	  }
	  if (!values || !fields.length) {
	    return state;
	  }
	  var initializeField = function initializeField(path, src, dest) {
	    var dotIndex = path.indexOf('.');
	    if (dotIndex === 0) {
	      return initializeField(path.substring(1), src, dest);
	    }
	    var openIndex = path.indexOf('[');
	    var closeIndex = path.indexOf(']');
	    var result = _extends({}, dest) || {};
	    if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	      // is dot notation
	      var key = path.substring(0, dotIndex);
	      result[key] = src[key] && initializeField(path.substring(dotIndex + 1), src[key], result[key] || {});
	    } else if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	      (function () {
	        // is array notation
	        if (closeIndex < 0) {
	          throw new Error('found \'[\' but no \']\': \'' + path + '\'');
	        }
	        var key = path.substring(0, openIndex);
	        var srcArray = src[key];
	        var destArray = result[key];
	        var rest = path.substring(closeIndex + 1);
	        if (Array.isArray(srcArray)) {
	          if (rest.length) {
	            // need to keep recursing
	            result[key] = srcArray.map(function (srcValue, srcIndex) {
	              return initializeField(rest, srcValue, destArray && destArray[srcIndex]);
	            });
	          } else {
	            result[key] = srcArray.map(function (srcValue, srcIndex) {
	              return makeEntry(srcValue, destArray && destArray[srcIndex] && destArray[srcIndex].value, overwriteValues);
	            });
	          }
	        } else {
	          result[key] = [];
	        }
	      })();
	    } else {
	      result[path] = makeEntry(src && src[path], dest && dest[path] && dest[path].value, overwriteValues);
	    }
	    return result;
	  };
	  return fields.reduce(function (accumulator, field) {
	    return initializeField(field, values, accumulator);
	  }, _extends({}, state));
	};
	
	exports.default = initializeState;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(597);
	
	var reset = function reset(value) {
	  return (0, _fieldValue.makeFieldValue)(value === undefined || value && value.initial === undefined ? {} : { initial: value.initial, value: value.initial });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var resetState = function resetState(values) {
	  return values ? Object.keys(values).reduce(function (accumulator, key) {
	    var value = values[key];
	    if (Array.isArray(value)) {
	      accumulator[key] = value.map(function (item) {
	        return (0, _fieldValue.isFieldValue)(item) ? reset(item) : resetState(item);
	      });
	    } else if (value) {
	      if ((0, _fieldValue.isFieldValue)(value)) {
	        accumulator[key] = reset(value);
	      } else if (typeof value === 'object' && value !== null) {
	        accumulator[key] = resetState(value);
	      } else {
	        accumulator[key] = value;
	      }
	    }
	    return accumulator;
	  }, {}) : values;
	};
	
	exports.default = resetState;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(597);
	
	var isMetaKey = function isMetaKey(key) {
	  return key[0] === '_';
	};
	
	/**
	 * Sets an error on a field deep in the tree, returning a new copy of the state
	 */
	var setErrors = function setErrors(state, errors, destKey) {
	  var clear = function clear() {
	    if (Array.isArray(state)) {
	      return state.map(function (stateItem, index) {
	        return setErrors(stateItem, errors && errors[index], destKey);
	      });
	    }
	    if (state && typeof state === 'object') {
	      var result = Object.keys(state).reduce(function (accumulator, key) {
	        var _extends2;
	
	        return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends2 = {}, _extends2[key] = setErrors(state[key], errors && errors[key], destKey), _extends2));
	      }, state);
	      if ((0, _fieldValue.isFieldValue)(state)) {
	        (0, _fieldValue.makeFieldValue)(result);
	      }
	      return result;
	    }
	    return (0, _fieldValue.makeFieldValue)(state);
	  };
	  if (typeof File !== 'undefined' && state instanceof File) {
	    return state;
	  }
	  if (!errors) {
	    if (!state) {
	      return state;
	    }
	    if (state[destKey]) {
	      var copy = _extends({}, state);
	      delete copy[destKey];
	      return (0, _fieldValue.makeFieldValue)(copy);
	    }
	    return clear();
	  }
	  if (typeof errors === 'string') {
	    var _extends3;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends3 = {}, _extends3[destKey] = errors, _extends3)));
	  }
	  if (Array.isArray(errors)) {
	    if (!state || Array.isArray(state)) {
	      var _ret = function () {
	        var copy = (state || []).map(function (stateItem, index) {
	          return setErrors(stateItem, errors[index], destKey);
	        });
	        errors.forEach(function (errorItem, index) {
	          return copy[index] = setErrors(copy[index], errorItem, destKey);
	        });
	        return {
	          v: copy
	        };
	      }();
	
	      if (typeof _ret === "object") return _ret.v;
	    }
	    return setErrors(state, errors[0], destKey); // use first error
	  }
	  if ((0, _fieldValue.isFieldValue)(state)) {
	    var _extends4;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends4 = {}, _extends4[destKey] = errors, _extends4)));
	  }
	  var errorKeys = Object.keys(errors);
	  if (!errorKeys.length && !state) {
	    return state;
	  }
	  return errorKeys.reduce(function (accumulator, key) {
	    var _extends5;
	
	    return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[key] = setErrors(state && state[key], errors[key], destKey), _extends5));
	  }, clear() || {});
	};
	
	exports.default = setErrors;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = normalizeFields;
	
	var _fieldValue = __webpack_require__(597);
	
	function extractKey(field) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  var isArray = openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex);
	  var key = void 0;
	  var nestedPath = void 0;
	
	  if (isArray) {
	    key = field.substring(0, openIndex);
	    nestedPath = field.substring(closeIndex + 1);
	
	    if (nestedPath[0] === '.') {
	      nestedPath = nestedPath.substring(1);
	    }
	  } else if (dotIndex > 0) {
	    key = field.substring(0, dotIndex);
	    nestedPath = field.substring(dotIndex + 1);
	  } else {
	    key = field;
	  }
	
	  return { isArray: isArray, key: key, nestedPath: nestedPath };
	}
	
	function normalizeField(field, fullFieldPath, state, previousState, values, previousValues, normalizers) {
	  if (field.isArray) {
	    if (field.nestedPath) {
	      var _ret = function () {
	        var array = state && state[field.key] || [];
	        var previousArray = previousState && previousState[field.key] || [];
	        var nestedField = extractKey(field.nestedPath);
	
	        return {
	          v: array.map(function (nestedState, i) {
	            nestedState[nestedField.key] = normalizeField(nestedField, fullFieldPath, nestedState, previousArray[i], values, previousValues, normalizers);
	
	            return nestedState;
	          })
	        };
	      }();
	
	      if (typeof _ret === "object") return _ret.v;
	    }
	
	    var _normalizer = normalizers[fullFieldPath];
	
	    var result = _normalizer(state && state[field.key], previousState && previousState[field.key], values, previousValues);
	    return field.isArray ? result && result.map(_fieldValue.makeFieldValue) : result;
	  } else if (field.nestedPath) {
	    var nestedState = state && state[field.key] || {};
	    var nestedField = extractKey(field.nestedPath);
	
	    nestedState[nestedField.key] = normalizeField(nestedField, fullFieldPath, nestedState, previousState && previousState[field.key], values, previousValues, normalizers);
	
	    return nestedState;
	  }
	
	  var finalField = state && Object.assign({}, state[field.key] || {});
	  var normalizer = normalizers[fullFieldPath];
	
	  finalField.value = normalizer(finalField.value, previousState && previousState[field.key] && previousState[field.key].value, values, previousValues);
	
	  return (0, _fieldValue.makeFieldValue)(finalField);
	}
	
	function normalizeFields(normalizers, state, previousState, values, previousValues) {
	  var newState = Object.keys(normalizers).reduce(function (accumulator, field) {
	    var extracted = extractKey(field);
	
	    accumulator[extracted.key] = normalizeField(extracted, field, state, previousState, values, previousValues, normalizers);
	
	    return accumulator;
	  }, {});
	
	  return _extends({}, state, newState);
	}

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reducer = __webpack_require__(591);
	
	var _initializeState = __webpack_require__(598);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createInitialState = function createInitialState(data, fields, state) {
	  var _extends2;
	
	  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	  var markInitialized = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	  return _extends({}, (0, _initializeState2.default)(data, fields, state, overwriteValues), (_extends2 = {
	    _asyncValidating: false,
	    _active: undefined
	  }, _extends2[_reducer.globalErrorKey] = undefined, _extends2._initialized = markInitialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	};
	
	exports.default = createInitialState;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createReduxFormConnector = __webpack_require__(604);
	
	var _createReduxFormConnector2 = _interopRequireDefault(_createReduxFormConnector);
	
	var _hoistNonReactStatics = __webpack_require__(474);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(isReactNative, React, connect) {
	  var Component = React.Component;
	
	  var reduxFormConnector = (0, _createReduxFormConnector2.default)(isReactNative, React, connect);
	  return function (config, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    return function (WrappedComponent) {
	      var ReduxFormConnector = reduxFormConnector(WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options);
	
	      var _ref = options || {},
	          _ref$withRef = _ref.withRef,
	          withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	      var configWithDefaults = _extends({
	        overwriteOnInitialValuesChange: true,
	        touchOnBlur: true,
	        touchOnChange: false,
	        destroyOnUnmount: true
	      }, config);
	
	      var ConnectedForm = function (_Component) {
	        _inherits(ConnectedForm, _Component);
	
	        function ConnectedForm(props) {
	          _classCallCheck(this, ConnectedForm);
	
	          var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	          _this.handleSubmitPassback = _this.handleSubmitPassback.bind(_this);
	          return _this;
	        }
	
	        ConnectedForm.prototype.getWrappedInstance = function getWrappedInstance() {
	          (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	          return this.refs.wrappedInstance.refs.wrappedInstance.getWrappedInstance().refs.wrappedInstance;
	        };
	
	        ConnectedForm.prototype.handleSubmitPassback = function handleSubmitPassback(submit) {
	          this.submit = submit;
	        };
	
	        ConnectedForm.prototype.render = function render() {
	          if (withRef) {
	            return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	              ref: 'wrappedInstance',
	              submitPassback: this.handleSubmitPassback }));
	          }
	          return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	            submitPassback: this.handleSubmitPassback }));
	        };
	
	        return ConnectedForm;
	      }(Component);
	
	      return (0, _hoistNonReactStatics2.default)(ConnectedForm, WrappedComponent);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _noGetters = __webpack_require__(605);
	
	var _noGetters2 = _interopRequireDefault(_noGetters);
	
	var _getDisplayName = __webpack_require__(610);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _createHigherOrderComponent = __webpack_require__(611);
	
	var _createHigherOrderComponent2 = _interopRequireDefault(_createHigherOrderComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component tracks props that affect how the form is mounted to the store. Normally these should not change,
	 * but if they do, the connected components below it need to be redefined.
	 */
	var createReduxFormConnector = function createReduxFormConnector(isReactNative, React, connect) {
	  return function (WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    var Component = React.Component,
	        PropTypes = React.PropTypes;
	
	    var _ref = options || {},
	        _ref$withRef = _ref.withRef,
	        withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	    var ReduxFormConnector = function (_Component) {
	      _inherits(ReduxFormConnector, _Component);
	
	      function ReduxFormConnector(props) {
	        _classCallCheck(this, ReduxFormConnector);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.cache = new _noGetters2.default(_this, {
	          ReduxForm: {
	            params: [
	            // props that effect how redux-form connects to the redux store
	            'reduxMountPoint', 'form', 'formKey', 'getFormState'],
	            fn: (0, _createHigherOrderComponent2.default)(props, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options)
	          }
	        });
	        return _this;
	      }
	
	      ReduxFormConnector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.cache.componentWillReceiveProps(nextProps);
	      };
	
	      ReduxFormConnector.prototype.render = function render() {
	        var ReduxForm = this.cache.get('ReduxForm');
	        // remove some redux-form config-only props
	
	        var _props = this.props,
	            reduxMountPoint = _props.reduxMountPoint,
	            destroyOnUnmount = _props.destroyOnUnmount,
	            form = _props.form,
	            getFormState = _props.getFormState,
	            touchOnBlur = _props.touchOnBlur,
	            touchOnChange = _props.touchOnChange,
	            passableProps = _objectWithoutProperties(_props, ['reduxMountPoint', 'destroyOnUnmount', 'form', 'getFormState', 'touchOnBlur', 'touchOnChange']); // eslint-disable-line no-redeclare
	
	
	        if (withRef) {
	          return React.createElement(ReduxForm, _extends({}, passableProps, { ref: 'wrappedInstance' }));
	        }
	        return React.createElement(ReduxForm, passableProps);
	      };
	
	      return ReduxFormConnector;
	    }(Component);
	
	    ReduxFormConnector.displayName = 'ReduxFormConnector(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxFormConnector.WrappedComponent = WrappedComponent;
	    ReduxFormConnector.propTypes = {
	      destroyOnUnmount: PropTypes.bool,
	      reduxMountPoint: PropTypes.string,
	      form: PropTypes.string.isRequired,
	      formKey: PropTypes.string,
	      getFormState: PropTypes.func,
	      touchOnBlur: PropTypes.bool,
	      touchOnChange: PropTypes.bool
	    };
	    ReduxFormConnector.defaultProps = {
	      reduxMountPoint: 'form',
	      getFormState: function getFormState(state, reduxMountPoint) {
	        return state[reduxMountPoint];
	      }
	    };
	    return ReduxFormConnector;
	  };
	};
	
	exports.default = createReduxFormConnector;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(606);


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _deepEqual = __webpack_require__(607);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function intersects(array1, array2) {
	  return !!(array1 && array2 && array1.some(function (item) {
	    return ~array2.indexOf(item);
	  }));
	}
	
	var LazyCache = (function () {
	  function LazyCache(component, calculators) {
	    var _this = this;
	
	    _classCallCheck(this, LazyCache);
	
	    this.component = component;
	    this.allProps = [];
	    this.cache = Object.keys(calculators).reduce(function (accumulator, key) {
	      var _extends2;
	
	      var calculator = calculators[key];
	      var fn = calculator.fn;
	      var paramNames = calculator.params;
	      paramNames.forEach(function (param) {
	        if (! ~_this.allProps.indexOf(param)) {
	          _this.allProps.push(param);
	        }
	      });
	      return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = {
	        value: undefined,
	        props: paramNames,
	        fn: fn
	      }, _extends2));
	    }, {});
	  }
	
	  LazyCache.prototype.get = function get(key) {
	    var component = this.component;
	    var _cache$key = this.cache[key];
	    var value = _cache$key.value;
	    var fn = _cache$key.fn;
	    var props = _cache$key.props;
	
	    if (value !== undefined) {
	      return value;
	    }
	    var params = props.map(function (prop) {
	      return component.props[prop];
	    });
	    var result = fn.apply(undefined, params);
	    this.cache[key].value = result;
	    return result;
	  };
	
	  LazyCache.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var component = this.component;
	
	    var diffProps = [];
	    this.allProps.forEach(function (prop) {
	      if (!_deepEqual2['default'](component.props[prop], nextProps[prop])) {
	        diffProps.push(prop);
	      }
	    });
	    if (diffProps.length) {
	      Object.keys(this.cache).forEach(function (key) {
	        if (intersects(diffProps, _this2.cache[key].props)) {
	          delete _this2.cache[key].value; // uncache value
	        }
	      });
	    }
	  };
	
	  return LazyCache;
	})();
	
	exports['default'] = LazyCache;
	module.exports = exports['default'];

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(608);
	var isArguments = __webpack_require__(609);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 608 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 609 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 610 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getDisplayName;
	function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actions = __webpack_require__(612);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _getDisplayName = __webpack_require__(610);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _reducer = __webpack_require__(591);
	
	var _deepEqual = __webpack_require__(607);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _bindActionData = __webpack_require__(613);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _getValues = __webpack_require__(614);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _isValid = __webpack_require__(615);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _readFields = __webpack_require__(616);
	
	var _readFields2 = _interopRequireDefault(_readFields);
	
	var _handleSubmit2 = __webpack_require__(631);
	
	var _handleSubmit3 = _interopRequireDefault(_handleSubmit2);
	
	var _asyncValidation = __webpack_require__(632);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _silenceEvents = __webpack_require__(633);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _silenceEvent = __webpack_require__(634);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _wrapMapDispatchToProps = __webpack_require__(635);
	
	var _wrapMapDispatchToProps2 = _interopRequireDefault(_wrapMapDispatchToProps);
	
	var _wrapMapStateToProps = __webpack_require__(636);
	
	var _wrapMapStateToProps2 = _interopRequireDefault(_wrapMapStateToProps);
	
	var _createInitialState = __webpack_require__(602);
	
	var _createInitialState2 = _interopRequireDefault(_createInitialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Creates a HOC that knows how to create redux-connected sub-components.
	 */
	var createHigherOrderComponent = function createHigherOrderComponent(config, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	  var Component = React.Component,
	      PropTypes = React.PropTypes;
	
	  return function (reduxMountPoint, formName, formKey, getFormState) {
	    var _ref = options || {},
	        _ref$withRef = _ref.withRef,
	        withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	    var ReduxForm = function (_Component) {
	      _inherits(ReduxForm, _Component);
	
	      function ReduxForm(props) {
	        _classCallCheck(this, ReduxForm);
	
	        // bind functions
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.asyncValidate = _this.asyncValidate.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        var _this$props = _this.props,
	            initialValues = _this$props.initialValues,
	            submitPassback = _this$props.submitPassback;
	        // Check if form state was initialized, if not, initialize it.
	
	        var form = (0, _deepEqual2.default)(props.form, _reducer.initialState) ? (0, _createInitialState2.default)(initialValues, config.fields, {}, true, false) : props.form;
	        _this.fields = (0, _readFields2.default)(_extends({}, props, { form: form }), {}, {}, _this.asyncValidate, isReactNative);
	        submitPassback(function () {
	          return _this.handleSubmit();
	        }); // wrapped in function to disallow params
	        return _this;
	      }
	
	      ReduxForm.prototype.componentWillMount = function componentWillMount() {
	        var _props = this.props,
	            fields = _props.fields,
	            form = _props.form,
	            initialize = _props.initialize,
	            initialValues = _props.initialValues;
	
	        if (initialValues && !form._initialized) {
	          initialize(initialValues, fields);
	        }
	      };
	
	      ReduxForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!(0, _deepEqual2.default)(this.props.fields, nextProps.fields) || !(0, _deepEqual2.default)(this.props.form, nextProps.form, { strict: true })) {
	          this.fields = (0, _readFields2.default)(nextProps, this.props, this.fields, this.asyncValidate, isReactNative);
	        }
	        if (!(0, _deepEqual2.default)(this.props.initialValues, nextProps.initialValues)) {
	          this.props.initialize(nextProps.initialValues, nextProps.fields, this.props.overwriteOnInitialValuesChange || !this.props.form._initialized);
	        }
	      };
	
	      ReduxForm.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (config.destroyOnUnmount) {
	          this.props.destroy();
	        }
	      };
	
	      ReduxForm.prototype.asyncValidate = function asyncValidate(name, value) {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            alwaysAsyncValidate = _props2.alwaysAsyncValidate,
	            asyncValidate = _props2.asyncValidate,
	            dispatch = _props2.dispatch,
	            fields = _props2.fields,
	            form = _props2.form,
	            startAsyncValidation = _props2.startAsyncValidation,
	            stopAsyncValidation = _props2.stopAsyncValidation,
	            validate = _props2.validate;
	
	        var isSubmitting = !name;
	        if (asyncValidate) {
	          var _ret = function () {
	            var values = (0, _getValues2.default)(fields, form);
	            if (name) {
	              values[name] = value;
	            }
	            var syncErrors = validate(values, _this2.props);
	            var allPristine = _this2.fields._meta.allPristine;
	
	            var initialized = form._initialized;
	
	            // if blur validating, only run async validate if sync validation passes
	            // and submitting (not blur validation) or form is dirty or form was never initialized
	            // unless alwaysAsyncValidate is true
	            var syncValidationPasses = isSubmitting || (0, _isValid2.default)(syncErrors[name]);
	            if (alwaysAsyncValidate || syncValidationPasses && (isSubmitting || !allPristine || !initialized)) {
	              return {
	                v: (0, _asyncValidation2.default)(function () {
	                  return asyncValidate(values, dispatch, _this2.props);
	                }, startAsyncValidation, stopAsyncValidation, name)
	              };
	            }
	          }();
	
	          if (typeof _ret === "object") return _ret.v;
	        }
	      };
	
	      ReduxForm.prototype.handleSubmit = function handleSubmit(submitOrEvent) {
	        var _this3 = this;
	
	        var _props3 = this.props,
	            onSubmit = _props3.onSubmit,
	            fields = _props3.fields,
	            form = _props3.form;
	
	        var check = function check(submit) {
	          if (!submit || typeof submit !== 'function') {
	            throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	          }
	          return submit;
	        };
	        return !submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent) ?
	        // submitOrEvent is an event: fire submit
	        (0, _handleSubmit3.default)(check(onSubmit), (0, _getValues2.default)(fields, form), this.props, this.asyncValidate) :
	        // submitOrEvent is the submit function: return deferred submit thunk
	        (0, _silenceEvents2.default)(function () {
	          return (0, _handleSubmit3.default)(check(submitOrEvent), (0, _getValues2.default)(fields, form), _this3.props, _this3.asyncValidate);
	        });
	      };
	
	      ReduxForm.prototype.render = function render() {
	        var _this4 = this,
	            _ref2;
	
	        var allFields = this.fields;
	
	        var _props4 = this.props,
	            addArrayValue = _props4.addArrayValue,
	            asyncBlurFields = _props4.asyncBlurFields,
	            autofill = _props4.autofill,
	            blur = _props4.blur,
	            change = _props4.change,
	            destroy = _props4.destroy,
	            focus = _props4.focus,
	            fields = _props4.fields,
	            form = _props4.form,
	            initialValues = _props4.initialValues,
	            initialize = _props4.initialize,
	            onSubmit = _props4.onSubmit,
	            propNamespace = _props4.propNamespace,
	            reset = _props4.reset,
	            removeArrayValue = _props4.removeArrayValue,
	            returnRejectedSubmitPromise = _props4.returnRejectedSubmitPromise,
	            startAsyncValidation = _props4.startAsyncValidation,
	            startSubmit = _props4.startSubmit,
	            stopAsyncValidation = _props4.stopAsyncValidation,
	            stopSubmit = _props4.stopSubmit,
	            submitFailed = _props4.submitFailed,
	            swapArrayValues = _props4.swapArrayValues,
	            touch = _props4.touch,
	            untouch = _props4.untouch,
	            validate = _props4.validate,
	            passableProps = _objectWithoutProperties(_props4, ['addArrayValue', 'asyncBlurFields', 'autofill', 'blur', 'change', 'destroy', 'focus', 'fields', 'form', 'initialValues', 'initialize', 'onSubmit', 'propNamespace', 'reset', 'removeArrayValue', 'returnRejectedSubmitPromise', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitFailed', 'swapArrayValues', 'touch', 'untouch', 'validate']); // eslint-disable-line no-redeclare
	
	
	        var _allFields$_meta = allFields._meta,
	            allPristine = _allFields$_meta.allPristine,
	            allValid = _allFields$_meta.allValid,
	            errors = _allFields$_meta.errors,
	            formError = _allFields$_meta.formError,
	            values = _allFields$_meta.values;
	
	
	        var props = {
	          // State:
	          active: form._active,
	          asyncValidating: form._asyncValidating,
	          dirty: !allPristine,
	          error: formError,
	          errors: errors,
	          fields: allFields,
	          formKey: formKey,
	          invalid: !allValid,
	          pristine: allPristine,
	          submitting: form._submitting,
	          submitFailed: form._submitFailed,
	          valid: allValid,
	          values: values,
	
	          // Actions:
	          asyncValidate: (0, _silenceEvents2.default)(function () {
	            return _this4.asyncValidate();
	          }),
	          // ^ doesn't just pass this.asyncValidate to disallow values passing
	          destroyForm: (0, _silenceEvents2.default)(destroy),
	          handleSubmit: this.handleSubmit,
	          initializeForm: (0, _silenceEvents2.default)(function (initValues) {
	            return initialize(initValues, fields);
	          }),
	          resetForm: (0, _silenceEvents2.default)(reset),
	          touch: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, arguments);
	          }),
	          touchAll: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, fields);
	          }),
	          untouch: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, arguments);
	          }),
	          untouchAll: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, fields);
	          })
	        };
	        var passedProps = propNamespace ? (_ref2 = {}, _ref2[propNamespace] = props, _ref2) : props;
	        if (withRef) {
	          return React.createElement(WrappedComponent, _extends({}, _extends({}, passableProps, passedProps), { ref: 'wrappedInstance' }));
	        }
	        return React.createElement(WrappedComponent, _extends({}, passableProps, passedProps));
	      };
	
	      return ReduxForm;
	    }(Component);
	
	    ReduxForm.displayName = 'ReduxForm(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxForm.WrappedComponent = WrappedComponent;
	    ReduxForm.propTypes = {
	      // props:
	      alwaysAsyncValidate: PropTypes.bool,
	      asyncBlurFields: PropTypes.arrayOf(PropTypes.string),
	      asyncValidate: PropTypes.func,
	      dispatch: PropTypes.func.isRequired,
	      fields: PropTypes.arrayOf(PropTypes.string).isRequired,
	      form: PropTypes.object,
	      initialValues: PropTypes.any,
	      onSubmit: PropTypes.func,
	      onSubmitSuccess: PropTypes.func,
	      onSubmitFail: PropTypes.func,
	      overwriteOnInitialValuesChange: PropTypes.bool.isRequired,
	      propNamespace: PropTypes.string,
	      readonly: PropTypes.bool,
	      returnRejectedSubmitPromise: PropTypes.bool,
	      submitPassback: PropTypes.func.isRequired,
	      validate: PropTypes.func,
	
	      // actions:
	      addArrayValue: PropTypes.func.isRequired,
	      autofill: PropTypes.func.isRequired,
	      blur: PropTypes.func.isRequired,
	      change: PropTypes.func.isRequired,
	      destroy: PropTypes.func.isRequired,
	      focus: PropTypes.func.isRequired,
	      initialize: PropTypes.func.isRequired,
	      removeArrayValue: PropTypes.func.isRequired,
	      reset: PropTypes.func.isRequired,
	      startAsyncValidation: PropTypes.func.isRequired,
	      startSubmit: PropTypes.func.isRequired,
	      stopAsyncValidation: PropTypes.func.isRequired,
	      stopSubmit: PropTypes.func.isRequired,
	      submitFailed: PropTypes.func.isRequired,
	      swapArrayValues: PropTypes.func.isRequired,
	      touch: PropTypes.func.isRequired,
	      untouch: PropTypes.func.isRequired
	    };
	    ReduxForm.defaultProps = {
	      asyncBlurFields: [],
	      form: _reducer.initialState,
	      readonly: false,
	      returnRejectedSubmitPromise: false,
	      validate: function validate() {
	        return {};
	      }
	    };
	
	    // bind touch flags to blur and change
	    var unboundActions = _extends({}, importedActions, {
	      blur: (0, _bindActionData2.default)(importedActions.blur, {
	        touch: !!config.touchOnBlur
	      }),
	      change: (0, _bindActionData2.default)(importedActions.change, {
	        touch: !!config.touchOnChange
	      })
	    });
	
	    // make redux connector with or without form key
	    var decorate = formKey !== undefined && formKey !== null ? connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName] && formState[formName][formKey];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, {
	      form: formName,
	      key: formKey
	    })), mergeProps, options) : connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, { form: formName })), mergeProps, options);
	
	    return decorate(ReduxForm);
	  };
	};
	
	exports.default = createHigherOrderComponent;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouch = exports.touch = exports.swapArrayValues = exports.submitFailed = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.removeArrayValue = exports.initialize = exports.focus = exports.destroy = exports.change = exports.blur = exports.autofill = exports.addArrayValue = undefined;
	
	var _actionTypes = __webpack_require__(592);
	
	var addArrayValue = exports.addArrayValue = function addArrayValue(path, value, index, fields) {
	  return { type: _actionTypes.ADD_ARRAY_VALUE, path: path, value: value, index: index, fields: fields };
	};
	
	var autofill = exports.autofill = function autofill(field, value) {
	  return { type: _actionTypes.AUTOFILL, field: field, value: value };
	};
	
	var blur = exports.blur = function blur(field, value) {
	  return { type: _actionTypes.BLUR, field: field, value: value };
	};
	
	var change = exports.change = function change(field, value) {
	  return { type: _actionTypes.CHANGE, field: field, value: value };
	};
	
	var destroy = exports.destroy = function destroy() {
	  return { type: _actionTypes.DESTROY };
	};
	
	var focus = exports.focus = function focus(field) {
	  return { type: _actionTypes.FOCUS, field: field };
	};
	
	var initialize = exports.initialize = function initialize(data, fields) {
	  var overwriteValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!Array.isArray(fields)) {
	    throw new Error('must provide fields array to initialize() action creator');
	  }
	  return { type: _actionTypes.INITIALIZE, data: data, fields: fields, overwriteValues: overwriteValues };
	};
	
	var removeArrayValue = exports.removeArrayValue = function removeArrayValue(path, index) {
	  return { type: _actionTypes.REMOVE_ARRAY_VALUE, path: path, index: index };
	};
	
	var reset = exports.reset = function reset() {
	  return { type: _actionTypes.RESET };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(field) {
	  return { type: _actionTypes.START_ASYNC_VALIDATION, field: field };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit() {
	  return { type: _actionTypes.START_SUBMIT };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(errors) {
	  return { type: _actionTypes.STOP_ASYNC_VALIDATION, errors: errors };
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(errors) {
	  return { type: _actionTypes.STOP_SUBMIT, errors: errors };
	};
	
	var submitFailed = exports.submitFailed = function submitFailed() {
	  return { type: _actionTypes.SUBMIT_FAILED };
	};
	
	var swapArrayValues = exports.swapArrayValues = function swapArrayValues(path, indexA, indexB) {
	  return { type: _actionTypes.SWAP_ARRAY_VALUES, path: path, indexA: indexA, indexB: indexB };
	};
	
	var touch = exports.touch = function touch() {
	  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
	    fields[_key] = arguments[_key];
	  }
	
	  return { type: _actionTypes.TOUCH, fields: fields };
	};
	
	var untouch = exports.untouch = function untouch() {
	  for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    fields[_key2] = arguments[_key2];
	  }
	
	  return { type: _actionTypes.UNTOUCH, fields: fields };
	};

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = bindActionData;
	
	var _mapValues = __webpack_require__(593);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds additional properties to the results of the function or map of functions passed
	 */
	function bindActionData(action, data) {
	  if (typeof action === 'function') {
	    return function () {
	      return _extends({}, action.apply(undefined, arguments), data);
	    };
	  }
	  if (typeof action === 'object') {
	    return (0, _mapValues2.default)(action, function (value) {
	      return bindActionData(value, data);
	    });
	  }
	  return action;
	}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Given a state[field], get the value.
	 *  Fallback to .initialValue when .value is undefined to prevent double render/initialize cycle.
	 *  See {@link https://github.com/erikras/redux-form/issues/621}.
	 */
	var itemToValue = function itemToValue(_ref) {
	  var value = _ref.value,
	      initialValue = _ref.initialValue;
	  return typeof value !== 'undefined' ? value : initialValue;
	};
	
	var getValue = function getValue(field, state, dest) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    (function () {
	      // array field
	      var key = field.substring(0, openIndex);
	      var rest = field.substring(closeIndex + 1);
	      if (rest[0] === '.') {
	        rest = rest.substring(1);
	      }
	      var array = state && state[key] || [];
	      if (rest) {
	        if (!dest[key]) {
	          dest[key] = [];
	        }
	        array.forEach(function (item, index) {
	          if (!dest[key][index]) {
	            dest[key][index] = {};
	          }
	          getValue(rest, item, dest[key][index]);
	        });
	      } else {
	        dest[key] = array.map(itemToValue);
	      }
	    })();
	  } else if (dotIndex > 0) {
	    // subobject field
	    var key = field.substring(0, dotIndex);
	    var rest = field.substring(dotIndex + 1);
	    if (!dest[key]) {
	      dest[key] = {};
	    }
	    getValue(rest, state && state[key] || {}, dest[key]);
	  } else {
	    dest[field] = state[field] && itemToValue(state[field]);
	  }
	};
	
	var getValues = function getValues(fields, state) {
	  return fields.reduce(function (accumulator, field) {
	    getValue(field, state, accumulator);
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValues;

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isValid;
	function isValid(error) {
	  if (Array.isArray(error)) {
	    return error.reduce(function (valid, errorValue) {
	      return valid && isValid(errorValue);
	    }, true);
	  }
	  if (error && typeof error === 'object') {
	    return Object.keys(error).reduce(function (valid, key) {
	      return valid && isValid(error[key]);
	    }, true);
	  }
	  return !error;
	}

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _readField = __webpack_require__(617);
	
	var _readField2 = _interopRequireDefault(_readField);
	
	var _write = __webpack_require__(595);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValues = __webpack_require__(614);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _removeField = __webpack_require__(630);
	
	var _removeField2 = _interopRequireDefault(_removeField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Reads props and generates (or updates) field structure
	 */
	var readFields = function readFields(props, previousProps, myFields, asyncValidate, isReactNative) {
	  var fields = props.fields,
	      form = props.form,
	      validate = props.validate;
	
	  var previousFields = previousProps.fields;
	  var values = (0, _getValues2.default)(fields, form);
	  var syncErrors = validate(values, props) || {};
	  var errors = {};
	  var formError = syncErrors._error || form._error;
	  var allValid = !formError;
	  var allPristine = true;
	  var tally = function tally(field) {
	    if (field.error) {
	      errors = (0, _write2.default)(field.name, field.error, errors);
	      allValid = false;
	    }
	    if (field.dirty) {
	      allPristine = false;
	    }
	  };
	  var fieldObjects = previousFields ? previousFields.reduce(function (accumulator, previousField) {
	    return ~fields.indexOf(previousField) ? accumulator : (0, _removeField2.default)(accumulator, previousField);
	  }, _extends({}, myFields)) : _extends({}, myFields);
	  fields.forEach(function (name) {
	    (0, _readField2.default)(form, name, undefined, fieldObjects, syncErrors, asyncValidate, isReactNative, props, tally);
	  });
	  Object.defineProperty(fieldObjects, '_meta', {
	    value: {
	      allPristine: allPristine,
	      allValid: allValid,
	      values: values,
	      errors: errors,
	      formError: formError
	    }
	  });
	  return fieldObjects;
	};
	exports.default = readFields;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createOnBlur = __webpack_require__(618);
	
	var _createOnBlur2 = _interopRequireDefault(_createOnBlur);
	
	var _createOnChange = __webpack_require__(621);
	
	var _createOnChange2 = _interopRequireDefault(_createOnChange);
	
	var _createOnDragStart = __webpack_require__(622);
	
	var _createOnDragStart2 = _interopRequireDefault(_createOnDragStart);
	
	var _createOnDrop = __webpack_require__(623);
	
	var _createOnDrop2 = _interopRequireDefault(_createOnDrop);
	
	var _createOnFocus = __webpack_require__(624);
	
	var _createOnFocus2 = _interopRequireDefault(_createOnFocus);
	
	var _silencePromise = __webpack_require__(625);
	
	var _silencePromise2 = _interopRequireDefault(_silencePromise);
	
	var _read = __webpack_require__(594);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _updateField = __webpack_require__(627);
	
	var _updateField2 = _interopRequireDefault(_updateField);
	
	var _isChecked = __webpack_require__(629);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSuffix(input, closeIndex) {
	  var suffix = input.substring(closeIndex + 1);
	  if (suffix[0] === '.') {
	    suffix = suffix.substring(1);
	  }
	  return suffix;
	}
	
	var getNextKey = function getNextKey(path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    return path.substring(0, openIndex);
	  }
	  return dotIndex > 0 ? path.substring(0, dotIndex) : path;
	};
	
	var shouldAsyncValidate = function shouldAsyncValidate(name, asyncBlurFields) {
	  return (
	    // remove array indices
	    ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'))
	  );
	};
	
	var readField = function readField(state, fieldName) {
	  var pathToHere = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var fields = arguments[3];
	  var syncErrors = arguments[4];
	  var asyncValidate = arguments[5];
	  var isReactNative = arguments[6];
	  var props = arguments[7];
	  var callback = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : function () {
	    return null;
	  };
	  var prefix = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
	  var asyncBlurFields = props.asyncBlurFields,
	      autofill = props.autofill,
	      blur = props.blur,
	      change = props.change,
	      focus = props.focus,
	      form = props.form,
	      initialValues = props.initialValues,
	      readonly = props.readonly,
	      addArrayValue = props.addArrayValue,
	      removeArrayValue = props.removeArrayValue,
	      swapArrayValues = props.swapArrayValues;
	
	  var dotIndex = fieldName.indexOf('.');
	  var openIndex = fieldName.indexOf('[');
	  var closeIndex = fieldName.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _ret = function () {
	      // array field
	      var key = fieldName.substring(0, openIndex);
	      var rest = getSuffix(fieldName, closeIndex);
	      var stateArray = state && state[key] || [];
	      var fullPrefix = prefix + fieldName.substring(0, closeIndex + 1);
	      var subfields = props.fields.reduce(function (accumulator, field) {
	        if (field.indexOf(fullPrefix) === 0) {
	          accumulator.push(field);
	        }
	        return accumulator;
	      }, []).map(function (field) {
	        return getSuffix(field, prefix.length + closeIndex);
	      });
	      var addMethods = function addMethods(dest) {
	        Object.defineProperty(dest, 'addField', {
	          value: function value(_value, index) {
	            return addArrayValue(pathToHere + key, _value, index, subfields);
	          }
	        });
	        Object.defineProperty(dest, 'removeField', {
	          value: function value(index) {
	            return removeArrayValue(pathToHere + key, index);
	          }
	        });
	        Object.defineProperty(dest, 'swapFields', {
	          value: function value(indexA, indexB) {
	            return swapArrayValues(pathToHere + key, indexA, indexB);
	          }
	        });
	        return dest;
	      };
	      if (!fields[key] || fields[key].length !== stateArray.length) {
	        fields[key] = fields[key] ? [].concat(fields[key]) : [];
	        addMethods(fields[key]);
	      }
	      var fieldArray = fields[key];
	      var changed = false;
	      stateArray.forEach(function (fieldState, index) {
	        if (rest && !fieldArray[index]) {
	          fieldArray[index] = {};
	          changed = true;
	        }
	        var dest = rest ? fieldArray[index] : {};
	        var nextPath = '' + pathToHere + key + '[' + index + ']' + (rest ? '.' : '');
	        var nextPrefix = '' + prefix + key + '[]' + (rest ? '.' : '');
	
	        var result = readField(fieldState, rest, nextPath, dest, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	        if (fieldArray[index] !== result) {
	          if (rest) {
	            // if something's after [] in field name, the array item is an object field
	            // we need it to compare !== to the original (so react re-renders appropriately)
	            result = _extends({}, dest);
	          }
	          fieldArray[index] = result;
	          changed = true;
	        }
	      });
	      if (fieldArray.length > stateArray.length) {
	        // remove extra items that aren't in state array
	        fieldArray.splice(stateArray.length, fieldArray.length - stateArray.length);
	      }
	      return {
	        v: changed ? addMethods([].concat(fieldArray)) : fieldArray
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	  if (dotIndex > 0) {
	    // subobject field
	    var key = fieldName.substring(0, dotIndex);
	    var rest = fieldName.substring(dotIndex + 1);
	    var subobject = fields[key] || {};
	    var nextPath = pathToHere + key + '.';
	    var nextKey = getNextKey(rest);
	    var nextPrefix = prefix + key + '.';
	    var previous = subobject[nextKey];
	    var result = readField(state[key] || {}, rest, nextPath, subobject, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	    if (result !== previous) {
	      var _extends2;
	
	      subobject = _extends({}, subobject, (_extends2 = {}, _extends2[nextKey] = result, _extends2));
	    }
	    fields[key] = subobject;
	    return subobject;
	  }
	  var name = pathToHere + fieldName;
	  var field = fields[fieldName] || {};
	  if (field.name !== name) {
	    var onChange = (0, _createOnChange2.default)(name, change, isReactNative);
	    var initialFormValue = (0, _read2.default)(name + '.initial', form);
	    var initialValue = initialFormValue || (0, _read2.default)(name, initialValues);
	    initialValue = initialValue === undefined ? '' : initialValue;
	    field.name = name;
	    field.checked = (0, _isChecked2.default)(initialValue);
	    field.value = initialValue;
	    field.initialValue = initialValue;
	    if (!readonly) {
	      field.autofill = function (value) {
	        return autofill(name, value);
	      };
	      field.onBlur = (0, _createOnBlur2.default)(name, blur, isReactNative, shouldAsyncValidate(name, asyncBlurFields) && function (blurName, blurValue) {
	        return (0, _silencePromise2.default)(asyncValidate(blurName, blurValue));
	      });
	      field.onChange = onChange;
	      field.onDragStart = (0, _createOnDragStart2.default)(name, function () {
	        return field.value;
	      });
	      field.onDrop = (0, _createOnDrop2.default)(name, change);
	      field.onFocus = (0, _createOnFocus2.default)(name, focus);
	      field.onUpdate = onChange; // alias to support belle. https://github.com/nikgraf/belle/issues/58
	    }
	    field.valid = true;
	    field.invalid = false;
	    Object.defineProperty(field, '_isField', { value: true });
	  }
	
	  var fieldState = (fieldName ? state[fieldName] : state) || {};
	  var syncError = (0, _read2.default)(name, syncErrors);
	  var updated = (0, _updateField2.default)(field, fieldState, name === form._active, syncError);
	  if (fieldName || fields[fieldName] !== updated) {
	    fields[fieldName] = updated;
	  }
	  callback(updated);
	  return updated;
	};
	
	exports.default = readField;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(619);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnBlur = function createOnBlur(name, blur, isReactNative, afterBlur) {
	  return function (event) {
	    var value = (0, _getValue2.default)(event, isReactNative);
	    blur(name, value);
	    if (afterBlur) {
	      afterBlur(name, value);
	    }
	  };
	};
	exports.default = createOnBlur;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(620);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target,
	        type = _event$target.type,
	        value = _event$target.value,
	        checked = _event$target.checked,
	        files = _event$target.files,
	        dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked;
	    }
	    if (type === 'radio') {
	      return checked ? value : '';
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    if (value !== '' && (type === 'number' || type === 'range')) {
	      return parseFloat(value);
	    }
	    return value;
	  }
	  // not an event, so must be either our value or an object containing our value in the 'value' key
	  return event && typeof event === 'object' && event.value !== undefined ? event.value : // extract value from { value: value } structure. https://github.com/nikgraf/belle/issues/58
	  event;
	};
	
	exports.default = getValue;

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(619);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnChange = function createOnChange(name, change, isReactNative) {
	  return function (event) {
	    return change(name, (0, _getValue2.default)(event, isReactNative));
	  };
	};
	exports.default = createOnChange;

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var dataKey = exports.dataKey = 'value';
	var createOnDragStart = function createOnDragStart(name, getValue) {
	  return function (event) {
	    event.dataTransfer.setData(dataKey, getValue());
	  };
	};
	
	exports.default = createOnDragStart;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createOnDragStart = __webpack_require__(622);
	
	var createOnDrop = function createOnDrop(name, change) {
	  return function (event) {
	    change(name, event.dataTransfer.getData(_createOnDragStart.dataKey));
	  };
	};
	exports.default = createOnDrop;

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var createOnFocus = function createOnFocus(name, focus) {
	  return function () {
	    return focus(name);
	  };
	};
	exports.default = createOnFocus;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(626);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noop = function noop() {
	  return undefined;
	};
	
	var silencePromise = function silencePromise(promise) {
	  return (0, _isPromise2.default)(promise) ? promise.then(noop, noop) : promise;
	};
	
	exports.default = silencePromise;

/***/ }),
/* 626 */
/***/ (function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isPristine = __webpack_require__(628);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _isValid = __webpack_require__(615);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isChecked = __webpack_require__(629);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Updates a field object from the store values
	 */
	var updateField = function updateField(field, formField, active, syncError) {
	  var diff = {};
	  var formFieldValue = formField.value === undefined ? '' : formField.value;
	
	  // update field value
	  if (field.value !== formFieldValue) {
	    diff.value = formFieldValue;
	    diff.checked = (0, _isChecked2.default)(formFieldValue);
	  }
	
	  // update dirty/pristine
	  var pristine = (0, _isPristine2.default)(formFieldValue, formField.initial);
	  if (field.pristine !== pristine) {
	    diff.dirty = !pristine;
	    diff.pristine = pristine;
	  }
	
	  // update field error
	  var error = syncError || formField.submitError || formField.asyncError;
	  if (error !== field.error) {
	    diff.error = error;
	  }
	  var valid = (0, _isValid2.default)(error);
	  if (field.valid !== valid) {
	    diff.invalid = !valid;
	    diff.valid = valid;
	  }
	
	  if (active !== field.active) {
	    diff.active = active;
	  }
	  var touched = !!formField.touched;
	  if (touched !== field.touched) {
	    diff.touched = touched;
	  }
	  var visited = !!formField.visited;
	  if (visited !== field.visited) {
	    diff.visited = visited;
	  }
	  var autofilled = !!formField.autofilled;
	  if (autofilled !== field.autofilled) {
	    diff.autofilled = autofilled;
	  }
	
	  if ('initial' in formField && formField.initial !== field.initialValue) {
	    field.initialValue = formField.initial;
	  }
	
	  return Object.keys(diff).length ? _extends({}, field, diff) : field;
	};
	exports.default = updateField;

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isPristine;
	function isPristine(initial, data) {
	  if (initial === data) {
	    return true;
	  }
	  if (typeof initial === 'boolean' || typeof data === 'boolean') {
	    return initial === data;
	  } else if (initial instanceof Date && data instanceof Date) {
	    return initial.getTime() === data.getTime();
	  } else if (initial && typeof initial === 'object') {
	    if (!data || typeof data !== 'object') {
	      return false;
	    }
	    var initialKeys = Object.keys(initial);
	    var dataKeys = Object.keys(data);
	    if (initialKeys.length !== dataKeys.length) {
	      return false;
	    }
	    for (var index = 0; index < dataKeys.length; index++) {
	      var key = dataKeys[index];
	      if (!isPristine(initial[key], data[key])) {
	        return false;
	      }
	    }
	  } else if (initial || data) {
	    // allow '' to equate to undefined or null
	    return initial === data;
	  } else if (initial === null && data === 0 || initial === 0 && data === null) {
	    return false;
	  }
	  return true;
	}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isChecked = function isChecked(value) {
	  if (typeof value === 'boolean') {
	    return value;
	  }
	  if (typeof value === 'string') {
	    var lower = value.toLowerCase();
	    if (lower === 'true') {
	      return true;
	    }
	    if (lower === 'false') {
	      return false;
	    }
	  }
	  return undefined;
	};
	
	exports.default = isChecked;

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var without = function without(object, key) {
	  var copy = _extends({}, object);
	  delete copy[key];
	  return copy;
	};
	
	var removeField = function removeField(fields, path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _ret = function () {
	      // array field
	      var key = path.substring(0, openIndex);
	      if (!Array.isArray(fields[key])) {
	        return {
	          v: without(fields, key)
	        };
	      }
	      var rest = path.substring(closeIndex + 1);
	      if (rest[0] === '.') {
	        rest = rest.substring(1);
	      }
	      if (rest) {
	        var _ret2 = function () {
	          var _extends2;
	
	          var copy = [];
	          fields[key].forEach(function (item, index) {
	            var result = removeField(item, rest);
	            if (Object.keys(result).length) {
	              copy[index] = result;
	            }
	          });
	          return {
	            v: {
	              v: copy.length ? _extends({}, fields, (_extends2 = {}, _extends2[key] = copy, _extends2)) : without(fields, key)
	            }
	          };
	        }();
	
	        if (typeof _ret2 === "object") return _ret2.v;
	      }
	      return {
	        v: without(fields, key)
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	  if (dotIndex > 0) {
	    var _extends3;
	
	    // subobject field
	    var key = path.substring(0, dotIndex);
	    var rest = path.substring(dotIndex + 1);
	    if (!fields[key]) {
	      return fields;
	    }
	    var result = removeField(fields[key], rest);
	    return Object.keys(result).length ? _extends({}, fields, (_extends3 = {}, _extends3[key] = removeField(fields[key], rest), _extends3)) : without(fields, key);
	  }
	  return without(fields, path);
	};
	
	exports.default = removeField;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(626);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(615);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleSubmit = function handleSubmit(submit, values, props, asyncValidate) {
	  var dispatch = props.dispatch,
	      fields = props.fields,
	      onSubmitSuccess = props.onSubmitSuccess,
	      onSubmitFail = props.onSubmitFail,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      submitFailed = props.submitFailed,
	      returnRejectedSubmitPromise = props.returnRejectedSubmitPromise,
	      touch = props.touch,
	      validate = props.validate;
	
	  var syncErrors = validate(values, props);
	  touch.apply(undefined, fields); // touch all fields
	  if ((0, _isValid2.default)(syncErrors)) {
	    var doSubmit = function doSubmit() {
	      var result = submit(values, dispatch, props);
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult);
	          }
	          return submitResult;
	        }, function (submitError) {
	          stopSubmit(submitError);
	          if (onSubmitFail) {
	            onSubmitFail(submitError);
	          }
	          if (returnRejectedSubmitPromise) {
	            return Promise.reject(submitError);
	          }
	        });
	      }
	      if (onSubmitSuccess) {
	        onSubmitSuccess(result);
	      }
	      return result;
	    };
	    var asyncValidateResult = asyncValidate();
	    return (0, _isPromise2.default)(asyncValidateResult) ?
	    // asyncValidateResult will be rejected if async validation failed
	    asyncValidateResult.then(doSubmit, function () {
	      submitFailed();
	      if (onSubmitFail) {
	        onSubmitFail();
	      }
	      return returnRejectedSubmitPromise ? Promise.reject() : Promise.resolve();
	    }) : doSubmit(); // no async validation, so submit
	  }
	  submitFailed();
	
	  if (onSubmitFail) {
	    onSubmitFail(syncErrors);
	  }
	
	  if (returnRejectedSubmitPromise) {
	    return Promise.reject(syncErrors);
	  }
	};
	
	exports.default = handleSubmit;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(626);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(615);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (!(0, _isValid2.default)(errors)) {
	        stop(errors);
	        return Promise.reject();
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _silenceEvent = __webpack_require__(634);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(620);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(480);
	
	var wrapMapDispatchToProps = function wrapMapDispatchToProps(mapDispatchToProps, actionCreators) {
	  if (mapDispatchToProps) {
	    if (typeof mapDispatchToProps === 'function') {
	      if (mapDispatchToProps.length > 1) {
	        return function (dispatch, ownProps) {
	          return _extends({
	            dispatch: dispatch
	          }, mapDispatchToProps(dispatch, ownProps), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	        };
	      }
	      return function (dispatch) {
	        return _extends({
	          dispatch: dispatch
	        }, mapDispatchToProps(dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	      };
	    }
	    return function (dispatch) {
	      return _extends({
	        dispatch: dispatch
	      }, (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	    };
	  }
	  return function (dispatch) {
	    return _extends({
	      dispatch: dispatch
	    }, (0, _redux.bindActionCreators)(actionCreators, dispatch));
	  };
	};
	
	exports.default = wrapMapDispatchToProps;

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var wrapMapStateToProps = function wrapMapStateToProps(mapStateToProps, getForm) {
	  if (mapStateToProps) {
	    if (typeof mapStateToProps !== 'function') {
	      throw new Error('mapStateToProps must be a function');
	    }
	    if (mapStateToProps.length > 1) {
	      return function (state, ownProps) {
	        return _extends({}, mapStateToProps(state, ownProps), {
	          form: getForm(state)
	        });
	      };
	    }
	    return function (state) {
	      return _extends({}, mapStateToProps(state), {
	        form: getForm(state)
	      });
	    };
	  }
	  return function (state) {
	    return {
	      form: getForm(state)
	    };
	  };
	};
	
	exports.default = wrapMapStateToProps;

/***/ }),
/* 637 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var createPropTypes = function createPropTypes(_ref) {
	  var _ref$PropTypes = _ref.PropTypes,
	      any = _ref$PropTypes.any,
	      bool = _ref$PropTypes.bool,
	      string = _ref$PropTypes.string,
	      func = _ref$PropTypes.func,
	      object = _ref$PropTypes.object;
	  return {
	    // State:
	    active: string, // currently active field
	    asyncValidating: bool.isRequired, // true if async validation is running
	    autofilled: bool, // true if set programmatically by autofill
	    dirty: bool.isRequired, // true if any values are different from initialValues
	    error: any, // form-wide error from '_error' key in validation result
	    errors: object, // a map of errors corresponding to structure of form data (result of validation)
	    fields: object.isRequired, // the map of fields
	    formKey: any, // the form key if one was provided (used when doing multirecord forms)
	    invalid: bool.isRequired, // true if there are any validation errors
	    pristine: bool.isRequired, // true if the values are the same as initialValues
	    submitting: bool.isRequired, // true if the form is in the process of being submitted
	    submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
	    valid: bool.isRequired, // true if there are no validation errors
	    values: object.isRequired, // the values of the form as they will be submitted
	
	    // Actions:
	    asyncValidate: func.isRequired, // function to trigger async validation
	    destroyForm: func.isRequired, // action to destroy the form's data in Redux
	    handleSubmit: func.isRequired, // function to submit the form
	    initializeForm: func.isRequired, // action to initialize form data
	    resetForm: func.isRequired, // action to reset the form data to previously initialized values
	    touch: func.isRequired, // action to mark fields as touched
	    touchAll: func.isRequired, // action to mark ALL fields as touched
	    untouch: func.isRequired, // action to mark fields as untouched
	    untouchAll: func.isRequired // action to mark ALL fields as untouched
	  };
	};
	
	exports.default = createPropTypes;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(639);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(640);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(641);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(642);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(639);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(640);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = promiseMiddleware;
	
	var _fluxStandardAction = __webpack_require__(644);
	
	function isPromise(val) {
	  return val && typeof val.then === 'function';
	}
	
	function promiseMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	
	  return function (next) {
	    return function (action) {
	      if (!_fluxStandardAction.isFSA(action)) {
	        return isPromise(action) ? action.then(dispatch) : next(action);
	      }
	
	      return isPromise(action.payload) ? action.payload.then(function (result) {
	        return dispatch(_extends({}, action, { payload: result }));
	      }, function (error) {
	        return dispatch(_extends({}, action, { payload: error, error: true }));
	      }) : next(action);
	    };
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isFSA = isFSA;
	exports.isError = isError;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashIsplainobject = __webpack_require__(645);
	
	var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);
	
	var validKeys = ['type', 'payload', 'error', 'meta'];
	
	function isValidKey(key) {
	  return validKeys.indexOf(key) > -1;
	}
	
	function isFSA(action) {
	  return _lodashIsplainobject2['default'](action) && typeof action.type !== 'undefined' && Object.keys(action).every(isValidKey);
	}
	
	function isError(action) {
	  return action.error === true;
	}

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(646),
	    isArguments = __webpack_require__(647),
	    keysIn = __webpack_require__(648);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 646 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ }),
/* 647 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(647),
	    isArray = __webpack_require__(649);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ }),
/* 649 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logger = exports.createLogger = exports.defaults = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _core = __webpack_require__(651);
	
	var _helpers = __webpack_require__(652);
	
	var _defaults = __webpack_require__(655);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger,
	      stateTransformer = loggerOptions.stateTransformer,
	      errorTransformer = loggerOptions.errorTransformer,
	      predicate = loggerOptions.predicate,
	      logErrors = loggerOptions.logErrors,
	      diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
	  if (options.getState && options.dispatch) {
	    // eslint-disable-next-line no-console
	    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');
	
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = void 0;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	var defaultLogger = function defaultLogger() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      dispatch = _ref2.dispatch,
	      getState = _ref2.getState;
	
	  if (typeof dispatch === 'function' || typeof getState === 'function') {
	    return createLogger()({ dispatch: dispatch, getState: getState });
	  } else {
	    // eslint-disable-next-line no-console
	    console.error('\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from \'redux-logger\'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from \'redux-logger\'\n');
	  }
	};
	
	exports.defaults = _defaults2.default;
	exports.createLogger = createLogger;
	exports.logger = defaultLogger;
	exports.default = defaultLogger;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(652);
	
	var _diff = __webpack_require__(653);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp,
	      duration = options.duration;
	
	
	  return function (action, time, took) {
	    var parts = ['action'];
	
	    parts.push('%c' + String(action.type));
	    if (timestamp) parts.push('%c@ ' + time);
	    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');
	
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger,
	      actionTransformer = options.actionTransformer,
	      _options$titleFormatt = options.titleFormatter,
	      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
	      collapsed = options.collapsed,
	      colors = options.colors,
	      level = options.level,
	      diff = options.diff;
	
	
	  var isUsingDefaultFormatter = typeof options.titleFormatter === 'undefined';
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started,
	        startedTime = logEntry.startedTime,
	        action = logEntry.action,
	        prevState = logEntry.prevState,
	        error = logEntry.error;
	    var took = logEntry.took,
	        nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action, logEntry) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
	    var headerCSS = ['color: gray; font-weight: lighter;'];
	    headerCSS.push(titleCSS);
	    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
	    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title && isUsingDefaultFormatter) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
	      } else {
	        if (colors.title && isUsingDefaultFormatter) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('\u2014\u2014 log end \u2014\u2014');
	    }
	  });
	}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(654);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind,
	      path = diff.path,
	      lhs = diff.lhs,
	      rhs = diff.rhs,
	      index = diff.index,
	      item = diff.item;
	
	
	  switch (kind) {
	    case 'E':
	      return [path.join('.'), lhs, '\u2192', rhs];
	    case 'N':
	      return [path.join('.'), rhs];
	    case 'D':
	      return [path.join('.')];
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return [];
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
	    });
	  } else {
	    logger.log('\u2014\u2014 no diff \u2014\u2014');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports["default"];

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.refreshSettingsList = exports.refreshSiteSettings = exports.REFRESH_SITE_SETTINGS = undefined;
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _redux = __webpack_require__(657);
	
	var _services = __webpack_require__(857);
	
	var _user = __webpack_require__(862);
	
	var _user2 = __webpack_require__(1127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /*  weak */
	
	var REFRESH_SITE_SETTINGS = exports.REFRESH_SITE_SETTINGS = "metabase/settings/REFRESH_SITE_SETTINGS";
	var REFRESH_SETTINGS_LIST = "metabase/settings/REFRESH_SETTINGS_LIST";
	
	var refreshSiteSettings = exports.refreshSiteSettings = (0, _redux.createThunkAction)(REFRESH_SITE_SETTINGS, function () {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var settings;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return _services.SessionApi.properties();
	
	                        case 2:
	                            settings = _context.sent;
	
	                            _settings2.default.setAll(settings);
	
	                            // also load admin-only settings, if user is an admin
	                            _context.next = 6;
	                            return dispatch((0, _user.loadCurrentUser)());
	
	                        case 6:
	                            if (!(0, _user2.getUserIsAdmin)(getState())) {
	                                _context.next = 9;
	                                break;
	                            }
	
	                            _context.next = 9;
	                            return dispatch(refreshSettingsList());
	
	                        case 9:
	                            return _context.abrupt("return", settings);
	
	                        case 10:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var refreshSettingsList = exports.refreshSettingsList = (0, _redux.createAction)(REFRESH_SETTINGS_LIST, _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	    var settingsList;
	    return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	            switch (_context2.prev = _context2.next) {
	                case 0:
	                    _context2.next = 2;
	                    return _services.SettingsApi.list();
	
	                case 2:
	                    settingsList = _context2.sent;
	
	                    _settings2.default.setAll(collectSettingsValues(settingsList));
	                    return _context2.abrupt("return", settingsList.map(function (setting) {
	                        setting.originalValue = setting.value;
	                        return setting;
	                    }));
	
	                case 5:
	                case "end":
	                    return _context2.stop();
	            }
	        }
	    }, _callee2, undefined);
	})));
	
	var collectSettingsValues = function collectSettingsValues(settingsList) {
	    var settings = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = settingsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var setting = _step.value;
	
	            settings[setting.key] = setting.value;
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return settings;
	};
	
	var values = (0, _redux.handleActions)((_handleActions = {}, _defineProperty(_handleActions, REFRESH_SITE_SETTINGS, { next: function next(state, _ref3) {
	        var payload = _ref3.payload;
	        return _extends({}, state, payload);
	    } }), _defineProperty(_handleActions, REFRESH_SETTINGS_LIST, { next: function next(state, _ref4) {
	        var payload = _ref4.payload;
	        return _extends({}, state, collectSettingsValues(payload));
	    } }), _handleActions), {});
	
	var settings = (0, _redux.handleActions)(_defineProperty({}, REFRESH_SETTINGS_LIST, { next: function next(state, _ref5) {
	        var payload = _ref5.payload;
	        return payload;
	    } }), []);
	
	exports.default = (0, _redux.combineReducers)({
	    values: values,
	    settings: settings
	});

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.formDomOnlyProps = exports.updateData = exports.fetchData = exports.resourceListToMap = exports.createAction = exports.handleActions = exports.combineReducers = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(480);
	
	Object.defineProperty(exports, "combineReducers", {
	    enumerable: true,
	    get: function get() {
	        return _redux.combineReducers;
	    }
	});
	
	var _reduxActions = __webpack_require__(658);
	
	Object.defineProperty(exports, "handleActions", {
	    enumerable: true,
	    get: function get() {
	        return _reduxActions.handleActions;
	    }
	});
	Object.defineProperty(exports, "createAction", {
	    enumerable: true,
	    get: function get() {
	        return _reduxActions.createAction;
	    }
	});
	exports.createThunkAction = createThunkAction;
	exports.momentifyTimestamps = momentifyTimestamps;
	exports.momentifyObjectsTimestamps = momentifyObjectsTimestamps;
	exports.momentifyArraysTimestamps = momentifyArraysTimestamps;
	exports.mergeEntities = mergeEntities;
	exports.handleEntities = handleEntities;
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	var _requests = __webpack_require__(856);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// similar to createAction but accepts a (redux-thunk style) thunk and dispatches based on whether
	// the promise returned from the thunk resolves or rejects, similar to redux-promise
	function createThunkAction(actionType, actionThunkCreator) {
	    function fn() {
	        var thunk = actionThunkCreator.apply(undefined, arguments);
	        return function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	                var payload, dispatchValue;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return thunk(dispatch, getState);
	
	                            case 3:
	                                payload = _context.sent;
	                                dispatchValue = { type: actionType, payload: payload };
	
	                                dispatch(dispatchValue);
	
	                                return _context.abrupt("return", dispatchValue);
	
	                            case 9:
	                                _context.prev = 9;
	                                _context.t0 = _context["catch"](0);
	
	                                dispatch({ type: actionType, payload: _context.t0, error: true });
	                                throw _context.t0;
	
	                            case 13:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 9]]);
	            }));
	
	            return function (_x, _x2) {
	                return _ref.apply(this, arguments);
	            };
	        }();
	    }
	    fn.toString = function () {
	        return actionType;
	    };
	    return fn;
	}
	
	// turns string timestamps into moment objects
	function momentifyTimestamps(object) {
	    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ["created_at", "updated_at"];
	
	    object = _extends({}, object);
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var timestamp = _step.value;
	
	            if (timestamp in object) {
	                object[timestamp] = (0, _moment2.default)(object[timestamp]);
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return object;
	}
	
	function momentifyObjectsTimestamps(objects, keys) {
	    return _underscore2.default.mapObject(objects, function (o) {
	        return momentifyTimestamps(o, keys);
	    });
	}
	
	function momentifyArraysTimestamps(array, keys) {
	    return _underscore2.default.map(array, function (o) {
	        return momentifyTimestamps(o, keys);
	    });
	}
	
	// turns into id indexed map
	var resourceListToMap = exports.resourceListToMap = function resourceListToMap(resources) {
	    return resources.reduce(function (map, resource) {
	        return _extends({}, map, _defineProperty({}, resource.id, resource));
	    }, {});
	};
	
	var fetchData = exports.fetchData = function () {
	    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_ref3) {
	        var dispatch = _ref3.dispatch,
	            getState = _ref3.getState,
	            requestStatePath = _ref3.requestStatePath,
	            existingStatePath = _ref3.existingStatePath,
	            getData = _ref3.getData,
	            reload = _ref3.reload;
	        var existingData, statePath, requestState, data;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        existingData = (0, _icepick.getIn)(getState(), existingStatePath);
	                        statePath = requestStatePath.concat(['fetch']);
	                        _context2.prev = 2;
	                        requestState = (0, _icepick.getIn)(getState(), ["requests", "states"].concat(_toConsumableArray(statePath)));
	
	                        if (!(!requestState || requestState.error || reload)) {
	                            _context2.next = 11;
	                            break;
	                        }
	
	                        dispatch((0, _requests.setRequestState)({ statePath: statePath, state: "LOADING" }));
	                        _context2.next = 8;
	                        return getData();
	
	                    case 8:
	                        data = _context2.sent;
	
	
	                        // NOTE Atte Keinänen 8/23/17:
	                        // Dispatch `setRequestState` after clearing the call stack because we want to the actual data to be updated
	                        // before we notify components via `state.requests.fetches` that fetching the data is completed
	                        setTimeout(function () {
	                            return dispatch((0, _requests.setRequestState)({ statePath: statePath, state: "LOADED" }));
	                        }, 0);
	
	                        return _context2.abrupt("return", data);
	
	                    case 11:
	                        return _context2.abrupt("return", existingData);
	
	                    case 14:
	                        _context2.prev = 14;
	                        _context2.t0 = _context2["catch"](2);
	
	                        dispatch((0, _requests.setRequestState)({ statePath: statePath, error: _context2.t0 }));
	                        console.error(_context2.t0);
	                        return _context2.abrupt("return", existingData);
	
	                    case 19:
	                    case "end":
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, undefined, [[2, 14]]);
	    }));
	
	    return function fetchData(_x4) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var updateData = exports.updateData = function () {
	    var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(_ref5) {
	        var dispatch = _ref5.dispatch,
	            getState = _ref5.getState,
	            requestStatePath = _ref5.requestStatePath,
	            existingStatePath = _ref5.existingStatePath,
	            dependentRequestStatePaths = _ref5.dependentRequestStatePaths,
	            putData = _ref5.putData;
	        var existingData, statePath, data;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        existingData = (0, _icepick.getIn)(getState(), existingStatePath);
	                        statePath = requestStatePath.concat(['update']);
	                        _context3.prev = 2;
	
	                        dispatch((0, _requests.setRequestState)({ statePath: statePath, state: "LOADING" }));
	                        _context3.next = 6;
	                        return putData();
	
	                    case 6:
	                        data = _context3.sent;
	
	                        dispatch((0, _requests.setRequestState)({ statePath: statePath, state: "LOADED" }));
	
	                        (dependentRequestStatePaths || []).forEach(function (statePath) {
	                            return dispatch((0, _requests.clearRequestState)({ statePath: statePath }));
	                        });
	
	                        return _context3.abrupt("return", data);
	
	                    case 12:
	                        _context3.prev = 12;
	                        _context3.t0 = _context3["catch"](2);
	
	                        dispatch((0, _requests.setRequestState)({ statePath: statePath, error: _context3.t0 }));
	                        console.error(_context3.t0);
	                        return _context3.abrupt("return", existingData);
	
	                    case 17:
	                    case "end":
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, undefined, [[2, 12]]);
	    }));
	
	    return function updateData(_x5) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	
	// helper for working with normalizr
	// merge each entity from newEntities with existing entity, if any
	// this ensures partial entities don't overwrite existing entities with more properties
	function mergeEntities(entities, newEntities) {
	    entities = _extends({}, entities);
	    for (var id in newEntities) {
	        if (id in entities) {
	            entities[id] = _extends({}, entities[id], newEntities[id]);
	        } else {
	            entities[id] = newEntities[id];
	        }
	    }
	    return entities;
	}
	
	// helper for working with normalizr
	// reducer that merges payload.entities
	function handleEntities(actionPattern, entityType, reducer) {
	    return function (state, action) {
	        if (state === undefined) {
	            state = {};
	        }
	        var entities = (0, _icepick.getIn)(action, ["payload", "entities", entityType]);
	        if (actionPattern.test(action.type) && entities) {
	            state = mergeEntities(state, entities);
	        }
	        return reducer(state, action);
	    };
	}
	
	// for filtering non-DOM props from redux-form field objects
	// https://github.com/erikras/redux-form/issues/1441
	var formDomOnlyProps = function formDomOnlyProps(_ref6) {
	    var initialValue = _ref6.initialValue,
	        autofill = _ref6.autofill,
	        onUpdate = _ref6.onUpdate,
	        valid = _ref6.valid,
	        invalid = _ref6.invalid,
	        dirty = _ref6.dirty,
	        pristine = _ref6.pristine,
	        active = _ref6.active,
	        touched = _ref6.touched,
	        visited = _ref6.visited,
	        autofilled = _ref6.autofilled,
	        error = _ref6.error,
	        defaultValue = _ref6.defaultValue,
	        domProps = _objectWithoutProperties(_ref6, ["initialValue", "autofill", "onUpdate", "valid", "invalid", "dirty", "pristine", "active", "touched", "visited", "autofilled", "error", "defaultValue"]);
	
	    return domProps;
	};
	exports.formDomOnlyProps = formDomOnlyProps;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combineActions = exports.handleActions = exports.handleAction = exports.createActions = exports.createAction = undefined;
	
	var _createAction = __webpack_require__(659);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _handleAction = __webpack_require__(671);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _handleActions = __webpack_require__(724);
	
	var _handleActions2 = _interopRequireDefault(_handleActions);
	
	var _combineActions = __webpack_require__(708);
	
	var _combineActions2 = _interopRequireDefault(_combineActions);
	
	var _createActions = __webpack_require__(727);
	
	var _createActions2 = _interopRequireDefault(_createActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createAction = _createAction2.default;
	exports.createActions = _createActions2.default;
	exports.handleAction = _handleAction2.default;
	exports.handleActions = _handleActions2.default;
	exports.combineActions = _combineActions2.default;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAction;
	
	var _identity = __webpack_require__(660);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isFunction = __webpack_require__(661);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isUndefined = __webpack_require__(669);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _isNull = __webpack_require__(670);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createAction(type) {
	  var payloadCreator = arguments.length <= 1 || arguments[1] === undefined ? _identity2.default : arguments[1];
	  var metaCreator = arguments[2];
	
	  (0, _invariant2.default)((0, _isFunction2.default)(payloadCreator) || (0, _isNull2.default)(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');
	
	  var finalPayloadCreator = (0, _isNull2.default)(payloadCreator) ? _identity2.default : payloadCreator;
	
	  var actionCreator = function actionCreator() {
	    var hasError = (arguments.length <= 0 ? undefined : arguments[0]) instanceof Error;
	
	    var action = {
	      type: type
	    };
	
	    var payload = hasError ? arguments.length <= 0 ? undefined : arguments[0] : finalPayloadCreator.apply(undefined, arguments);
	    if (!(0, _isUndefined2.default)(payload)) {
	      action.payload = payload;
	    }
	
	    if (hasError || payload instanceof Error) {
	      // Handle FSA errors where the payload is an Error object. Set error.
	      action.error = true;
	    }
	
	    if ((0, _isFunction2.default)(metaCreator)) {
	      action.meta = metaCreator.apply(undefined, arguments);
	    }
	
	    return action;
	  };
	
	  actionCreator.toString = function () {
	    return type.toString();
	  };
	
	  return actionCreator;
	}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(662),
	    isObject = __webpack_require__(668);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(663),
	    getRawTag = __webpack_require__(666),
	    objectToString = __webpack_require__(667);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(664);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(665);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 665 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(663);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 667 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 668 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 669 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ }),
/* 670 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = handleAction;
	
	var _isFunction = __webpack_require__(661);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isPlainObject = __webpack_require__(672);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _identity = __webpack_require__(660);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isNil = __webpack_require__(676);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _isUndefined = __webpack_require__(669);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _includes = __webpack_require__(677);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _combineActions = __webpack_require__(708);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleAction(type) {
	  var reducer = arguments.length <= 1 || arguments[1] === undefined ? _identity2.default : arguments[1];
	  var defaultState = arguments[2];
	
	  var types = type.toString().split(_combineActions.ACTION_TYPE_DELIMITER);
	  (0, _invariant2.default)(!(0, _isUndefined2.default)(defaultState), 'defaultState for reducer handling ' + types.join(', ') + ' should be defined');
	  (0, _invariant2.default)((0, _isFunction2.default)(reducer) || (0, _isPlainObject2.default)(reducer), 'Expected reducer to be a function or object with next and throw reducers');
	
	  var _ref = (0, _isFunction2.default)(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
	    return (0, _isNil2.default)(aReducer) ? _identity2.default : aReducer;
	  });
	
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var nextReducer = _ref2[0];
	  var throwReducer = _ref2[1];
	
	
	  return function () {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	    var action = arguments[1];
	    var actionType = action.type;
	
	    if (!actionType || !(0, _includes2.default)(types, actionType.toString())) {
	      return state;
	    }
	
	    return (action.error === true ? throwReducer : nextReducer)(state, action);
	  };
	}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(662),
	    getPrototype = __webpack_require__(673),
	    isObjectLike = __webpack_require__(675);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(674);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 674 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 675 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 676 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(678),
	    isArrayLike = __webpack_require__(682),
	    isString = __webpack_require__(684),
	    toInteger = __webpack_require__(686),
	    values = __webpack_require__(690);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(679),
	    baseIsNaN = __webpack_require__(680),
	    strictIndexOf = __webpack_require__(681);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 679 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 680 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 681 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(661),
	    isLength = __webpack_require__(683);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 683 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(662),
	    isArray = __webpack_require__(685),
	    isObjectLike = __webpack_require__(675);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 685 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(687);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(688);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(668),
	    isSymbol = __webpack_require__(689);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(662),
	    isObjectLike = __webpack_require__(675);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(691),
	    keys = __webpack_require__(693);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(692);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 692 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(694),
	    baseKeys = __webpack_require__(705),
	    isArrayLike = __webpack_require__(682);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(695),
	    isArguments = __webpack_require__(696),
	    isArray = __webpack_require__(685),
	    isBuffer = __webpack_require__(698),
	    isIndex = __webpack_require__(700),
	    isTypedArray = __webpack_require__(701);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 695 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(697),
	    isObjectLike = __webpack_require__(675);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(662),
	    isObjectLike = __webpack_require__(675);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(664),
	    stubFalse = __webpack_require__(699);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(494)(module)))

/***/ }),
/* 699 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 700 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(702),
	    baseUnary = __webpack_require__(703),
	    nodeUtil = __webpack_require__(704);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(662),
	    isLength = __webpack_require__(683),
	    isObjectLike = __webpack_require__(675);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 703 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(665);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(494)(module)))

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(706),
	    nativeKeys = __webpack_require__(707);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 706 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(674);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ACTION_TYPE_DELIMITER = undefined;
	exports.default = combineActions;
	
	var _isString = __webpack_require__(684);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isFunction = __webpack_require__(661);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isEmpty = __webpack_require__(709);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _toString = __webpack_require__(722);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	var _isSymbol = __webpack_require__(689);
	
	var _isSymbol2 = _interopRequireDefault(_isSymbol);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTION_TYPE_DELIMITER = exports.ACTION_TYPE_DELIMITER = '||';
	
	function isValidActionType(type) {
	  return (0, _isString2.default)(type) || (0, _isFunction2.default)(type) || (0, _isSymbol2.default)(type);
	}
	
	function isValidActionTypes(types) {
	  if ((0, _isEmpty2.default)(types)) {
	    return false;
	  }
	  return types.every(isValidActionType);
	}
	
	function combineActions() {
	  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
	    actionsTypes[_key] = arguments[_key];
	  }
	
	  (0, _invariant2.default)(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
	  var combinedActionType = actionsTypes.map(_toString2.default).join(ACTION_TYPE_DELIMITER);
	  return { toString: function toString() {
	      return combinedActionType;
	    } };
	}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(705),
	    getTag = __webpack_require__(710),
	    isArguments = __webpack_require__(696),
	    isArray = __webpack_require__(685),
	    isArrayLike = __webpack_require__(682),
	    isBuffer = __webpack_require__(698),
	    isPrototype = __webpack_require__(706),
	    isTypedArray = __webpack_require__(701);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(711),
	    Map = __webpack_require__(718),
	    Promise = __webpack_require__(719),
	    Set = __webpack_require__(720),
	    WeakMap = __webpack_require__(721),
	    baseGetTag = __webpack_require__(662),
	    toSource = __webpack_require__(716);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(712),
	    root = __webpack_require__(664);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(713),
	    getValue = __webpack_require__(717);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(661),
	    isMasked = __webpack_require__(714),
	    isObject = __webpack_require__(668),
	    toSource = __webpack_require__(716);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(715);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(664);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 716 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 717 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(712),
	    root = __webpack_require__(664);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(712),
	    root = __webpack_require__(664);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(712),
	    root = __webpack_require__(664);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(712),
	    root = __webpack_require__(664);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(723);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(663),
	    arrayMap = __webpack_require__(692),
	    isArray = __webpack_require__(685),
	    isSymbol = __webpack_require__(689);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleActions;
	
	var _handleAction = __webpack_require__(671);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _ownKeys = __webpack_require__(725);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	var _reduceReducers = __webpack_require__(726);
	
	var _reduceReducers2 = _interopRequireDefault(_reduceReducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function handleActions(handlers, defaultState) {
	  var reducers = (0, _ownKeys2.default)(handlers).map(function (type) {
	    return (0, _handleAction2.default)(type, handlers[type], defaultState);
	  });
	  var reducer = _reduceReducers2.default.apply(undefined, _toConsumableArray(reducers));
	  return function (state, action) {
	    return reducer(state, action);
	  };
	}

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownKeys;
	function ownKeys(object) {
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    return Reflect.ownKeys(object);
	  }
	
	  var keys = Object.getOwnPropertyNames(object);
	
	  if (typeof Object.getOwnPropertySymbols === 'function') {
	    keys = keys.concat(Object.getOwnPropertySymbols(object));
	  }
	
	  return keys;
	}

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = reduceReducers;
	
	function reduceReducers() {
	  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
	    reducers[_key] = arguments[_key];
	  }
	
	  return function (previous, current) {
	    return reducers.reduce(function (p, r) {
	      return r(p, current);
	    }, previous);
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createActions;
	
	var _camelCase = __webpack_require__(728);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _identity = __webpack_require__(660);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isPlainObject = __webpack_require__(672);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isArray = __webpack_require__(685);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _last = __webpack_require__(729);
	
	var _last2 = _interopRequireDefault(_last);
	
	var _isString = __webpack_require__(684);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _defaults = __webpack_require__(730);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	var _isFunction = __webpack_require__(661);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _createAction = __webpack_require__(659);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _arrayToObject = __webpack_require__(750);
	
	var _arrayToObject2 = _interopRequireDefault(_arrayToObject);
	
	var _namespaceActions = __webpack_require__(751);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function createActions(actionMap) {
	  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    identityActions[_key - 1] = arguments[_key];
	  }
	
	  function getFullOptions() {
	    var partialOptions = (0, _isPlainObject2.default)((0, _last2.default)(identityActions)) ? identityActions.pop() : {};
	    return (0, _defaults2.default)(partialOptions, { namespace: _namespaceActions.defaultNamespace });
	  }
	
	  var _getFullOptions = getFullOptions();
	
	  var namespace = _getFullOptions.namespace;
	
	  (0, _invariant2.default)(identityActions.every(_isString2.default) && ((0, _isString2.default)(actionMap) || (0, _isPlainObject2.default)(actionMap)), 'Expected optional object followed by string action types');
	  if ((0, _isString2.default)(actionMap)) {
	    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions));
	  }
	  return _extends({}, actionCreatorsFromActionMap(actionMap, namespace), actionCreatorsFromIdentityActions(identityActions));
	}
	
	function actionCreatorsFromActionMap(actionMap, namespace) {
	  var flatActionMap = (0, _namespaceActions.flattenActionMap)(actionMap, namespace);
	  var flatActionCreators = actionMapToActionCreators(flatActionMap);
	  return (0, _namespaceActions.unflattenActionCreators)(flatActionCreators, namespace);
	}
	
	function actionMapToActionCreators(actionMap) {
	  function isValidActionMapValue(actionMapValue) {
	    if ((0, _isFunction2.default)(actionMapValue)) {
	      return true;
	    } else if ((0, _isArray2.default)(actionMapValue)) {
	      var _actionMapValue = _slicedToArray(actionMapValue, 2);
	
	      var _actionMapValue$ = _actionMapValue[0];
	      var payload = _actionMapValue$ === undefined ? _identity2.default : _actionMapValue$;
	      var meta = _actionMapValue[1];
	
	      return (0, _isFunction2.default)(payload) && (0, _isFunction2.default)(meta);
	    }
	    return false;
	  }
	
	  return (0, _arrayToObject2.default)(Object.keys(actionMap), function (partialActionCreators, type) {
	    var actionMapValue = actionMap[type];
	    (0, _invariant2.default)(isValidActionMapValue(actionMapValue), 'Expected function, undefined, or array with payload and meta ' + ('functions for ' + type));
	    var actionCreator = (0, _isArray2.default)(actionMapValue) ? _createAction2.default.apply(undefined, [type].concat(_toConsumableArray(actionMapValue))) : (0, _createAction2.default)(type, actionMapValue);
	    return _extends({}, partialActionCreators, _defineProperty({}, type, actionCreator));
	  });
	}
	
	function actionCreatorsFromIdentityActions(identityActions) {
	  var actionMap = (0, _arrayToObject2.default)(identityActions, function (partialActionMap, type) {
	    return _extends({}, partialActionMap, _defineProperty({}, type, _identity2.default));
	  });
	  var actionCreators = actionMapToActionCreators(actionMap);
	  return (0, _arrayToObject2.default)(Object.keys(actionCreators), function (partialActionCreators, type) {
	    return _extends({}, partialActionCreators, _defineProperty({}, (0, _camelCase2.default)(type), actionCreators[type]));
	  });
	}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// based on https://github.com/lodash/lodash/blob/4.17.2/lodash.js#L14100
	// eslint-disable-next-line max-len
	var wordPattern = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:(?:1ST|2ND|3RD|(?![123])\dTH)\b)|\d*(?:(?:1st|2nd|3rd|(?![123])\dth)\b)|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
	var namespacer = '/';
	
	function camelCase(string) {
	  return string.match(wordPattern).reduce(function (camelCased, word, index) {
	    return camelCased + (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
	  }, '');
	}
	
	exports.default = function (type) {
	  return type.split(namespacer).map(camelCase).join(namespacer);
	};

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(731),
	    assignInWith = __webpack_require__(732),
	    baseRest = __webpack_require__(739),
	    customDefaultsAssignIn = __webpack_require__(749);
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(args) {
	  args.push(undefined, customDefaultsAssignIn);
	  return apply(assignInWith, undefined, args);
	});
	
	module.exports = defaults;


/***/ }),
/* 731 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(733),
	    createAssigner = __webpack_require__(738),
	    keysIn = __webpack_require__(746);
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	module.exports = assignInWith;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(734),
	    baseAssignValue = __webpack_require__(735);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(735),
	    eq = __webpack_require__(737);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(736);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(712);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 737 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(739),
	    isIterateeCall = __webpack_require__(745);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(660),
	    overRest = __webpack_require__(740),
	    setToString = __webpack_require__(741);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(731);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(742),
	    shortOut = __webpack_require__(744);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(743),
	    defineProperty = __webpack_require__(736),
	    identity = __webpack_require__(660);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 743 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 744 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(737),
	    isArrayLike = __webpack_require__(682),
	    isIndex = __webpack_require__(700),
	    isObject = __webpack_require__(668);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(694),
	    baseKeysIn = __webpack_require__(747),
	    isArrayLike = __webpack_require__(682);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(668),
	    isPrototype = __webpack_require__(706),
	    nativeKeysIn = __webpack_require__(748);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 748 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(737);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	 * of source objects to the destination object for all destination properties
	 * that resolve to `undefined`.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsAssignIn(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsAssignIn;


/***/ }),
/* 750 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (array, callback) {
	  return array.reduce(function (partialObject, element) {
	    return callback(partialObject, element);
	  }, {});
	};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultNamespace = exports.unflattenActionCreators = exports.flattenActionMap = undefined;
	
	var _camelCase = __webpack_require__(728);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _isPlainObject = __webpack_require__(672);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultNamespace = '/';
	
	function flattenActionMap(actionMap) {
	  var namespace = arguments.length <= 1 || arguments[1] === undefined ? defaultNamespace : arguments[1];
	  var partialFlatActionMap = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	  var partialFlatActionType = arguments.length <= 3 || arguments[3] === undefined ? '' : arguments[3];
	
	  function connectNamespace(type) {
	    return partialFlatActionType ? '' + partialFlatActionType + namespace + type : type;
	  }
	
	  Object.getOwnPropertyNames(actionMap).forEach(function (type) {
	    var nextNamespace = connectNamespace(type);
	    var actionMapValue = actionMap[type];
	
	    if (!(0, _isPlainObject2.default)(actionMapValue)) {
	      partialFlatActionMap[nextNamespace] = actionMap[type];
	    } else {
	      flattenActionMap(actionMap[type], namespace, partialFlatActionMap, nextNamespace);
	    }
	  });
	  return partialFlatActionMap;
	}
	
	function unflattenActionCreators(flatActionCreators) {
	  var namespace = arguments.length <= 1 || arguments[1] === undefined ? defaultNamespace : arguments[1];
	
	  function unflatten(flatActionType) {
	    var partialNestedActionCreators = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    var partialFlatActionTypePath = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	    var nextNamespace = (0, _camelCase2.default)(partialFlatActionTypePath.shift());
	    if (partialFlatActionTypePath.length) {
	      if (!partialNestedActionCreators[nextNamespace]) {
	        partialNestedActionCreators[nextNamespace] = {};
	      }
	      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
	    } else {
	      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
	    }
	  }
	
	  var partialNestedActionCreators = {};
	  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
	    return unflatten(type, partialNestedActionCreators, type.split(namespace));
	  });
	  return partialNestedActionCreators;
	}
	
	exports.flattenActionMap = flattenActionMap;
	exports.unflattenActionCreators = unflattenActionCreators;
	exports.defaultNamespace = defaultNamespace;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.14.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        return Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        var k;
	        for (k in obj) {
	            // even if its not own property I'd still call it non-empty
	            return false;
	        }
	        return true;
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (utils_hooks__hooks.deprecationHandler != null) {
	                utils_hooks__hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (utils_hooks__hooks.deprecationHandler != null) {
	            utils_hooks__hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	    utils_hooks__hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function get_set__set (mom, unit, value) {
	        if (mom.isValid()) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function units_month__handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = create_utc__createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return units_month__handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (typeof value !== 'number') {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        //the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function day_of_week__handleStrictParse(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = create_utc__createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        ordinalParse: defaultOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(753)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    // treat as if there is no base config
	                    deprecateSimple('parentLocaleUndefined',
	                            'specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/');
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, parentConfig = baseConfig;
	            // MERGE
	            if (locales[name] != null) {
	                parentConfig = locales[name]._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function locale_locales__listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(utils_hooks__hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!valid__isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date(utils_hooks__hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = ((string || '').match(matcher) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	            } else if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(matchOffset, this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = utils_hooks__hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            delta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if (isFunction(Date.prototype.toISOString)) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIOROITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add               = add_subtract__add;
	    momentPrototype__proto.calendar          = moment_calendar__calendar;
	    momentPrototype__proto.clone             = clone;
	    momentPrototype__proto.diff              = diff;
	    momentPrototype__proto.endOf             = endOf;
	    momentPrototype__proto.format            = format;
	    momentPrototype__proto.from              = from;
	    momentPrototype__proto.fromNow           = fromNow;
	    momentPrototype__proto.to                = to;
	    momentPrototype__proto.toNow             = toNow;
	    momentPrototype__proto.get               = stringGet;
	    momentPrototype__proto.invalidAt         = invalidAt;
	    momentPrototype__proto.isAfter           = isAfter;
	    momentPrototype__proto.isBefore          = isBefore;
	    momentPrototype__proto.isBetween         = isBetween;
	    momentPrototype__proto.isSame            = isSame;
	    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
	    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
	    momentPrototype__proto.isValid           = moment_valid__isValid;
	    momentPrototype__proto.lang              = lang;
	    momentPrototype__proto.locale            = locale;
	    momentPrototype__proto.localeData        = localeData;
	    momentPrototype__proto.max               = prototypeMax;
	    momentPrototype__proto.min               = prototypeMin;
	    momentPrototype__proto.parsingFlags      = parsingFlags;
	    momentPrototype__proto.set               = stringSet;
	    momentPrototype__proto.startOf           = startOf;
	    momentPrototype__proto.subtract          = add_subtract__subtract;
	    momentPrototype__proto.toArray           = toArray;
	    momentPrototype__proto.toObject          = toObject;
	    momentPrototype__proto.toDate            = toDate;
	    momentPrototype__proto.toISOString       = moment_format__toISOString;
	    momentPrototype__proto.toJSON            = toJSON;
	    momentPrototype__proto.toString          = toString;
	    momentPrototype__proto.unix              = unix;
	    momentPrototype__proto.valueOf           = to_type__valueOf;
	    momentPrototype__proto.creationData      = creationData;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    momentPrototype__proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months            =        localeMonths;
	    prototype__proto.monthsShort       =        localeMonthsShort;
	    prototype__proto.monthsParse       =        localeMonthsParse;
	    prototype__proto.monthsRegex       = monthsRegex;
	    prototype__proto.monthsShortRegex  = monthsShortRegex;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    prototype__proto.weekdaysRegex       =        weekdaysRegex;
	    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
	    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = lists__get(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = locale_locales__getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return lists__get(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function lists__listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function lists__listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function lists__listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes <= 1           && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   <= 1           && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    <= 1           && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  <= 1           && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   <= 1           && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function duration_humanize__getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.14.1';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.now                   = now;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.updateLocale          = updateLocale;
	    utils_hooks__hooks.locales               = locale_locales__listLocales;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	    utils_hooks__hooks.calendarFormat        = getCalendarFormat;
	    utils_hooks__hooks.prototype             = momentPrototype;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(494)(module)))

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 754,
		"./af.js": 754,
		"./ar": 755,
		"./ar-ma": 756,
		"./ar-ma.js": 756,
		"./ar-sa": 757,
		"./ar-sa.js": 757,
		"./ar-tn": 758,
		"./ar-tn.js": 758,
		"./ar.js": 755,
		"./az": 759,
		"./az.js": 759,
		"./be": 760,
		"./be.js": 760,
		"./bg": 761,
		"./bg.js": 761,
		"./bn": 762,
		"./bn.js": 762,
		"./bo": 763,
		"./bo.js": 763,
		"./br": 764,
		"./br.js": 764,
		"./bs": 765,
		"./bs.js": 765,
		"./ca": 766,
		"./ca.js": 766,
		"./cs": 767,
		"./cs.js": 767,
		"./cv": 768,
		"./cv.js": 768,
		"./cy": 769,
		"./cy.js": 769,
		"./da": 770,
		"./da.js": 770,
		"./de": 771,
		"./de-at": 772,
		"./de-at.js": 772,
		"./de.js": 771,
		"./dv": 773,
		"./dv.js": 773,
		"./el": 774,
		"./el.js": 774,
		"./en-au": 775,
		"./en-au.js": 775,
		"./en-ca": 776,
		"./en-ca.js": 776,
		"./en-gb": 777,
		"./en-gb.js": 777,
		"./en-ie": 778,
		"./en-ie.js": 778,
		"./en-nz": 779,
		"./en-nz.js": 779,
		"./eo": 780,
		"./eo.js": 780,
		"./es": 781,
		"./es-do": 782,
		"./es-do.js": 782,
		"./es.js": 781,
		"./et": 783,
		"./et.js": 783,
		"./eu": 784,
		"./eu.js": 784,
		"./fa": 785,
		"./fa.js": 785,
		"./fi": 786,
		"./fi.js": 786,
		"./fo": 787,
		"./fo.js": 787,
		"./fr": 788,
		"./fr-ca": 789,
		"./fr-ca.js": 789,
		"./fr-ch": 790,
		"./fr-ch.js": 790,
		"./fr.js": 788,
		"./fy": 791,
		"./fy.js": 791,
		"./gd": 792,
		"./gd.js": 792,
		"./gl": 793,
		"./gl.js": 793,
		"./he": 794,
		"./he.js": 794,
		"./hi": 795,
		"./hi.js": 795,
		"./hr": 796,
		"./hr.js": 796,
		"./hu": 797,
		"./hu.js": 797,
		"./hy-am": 798,
		"./hy-am.js": 798,
		"./id": 799,
		"./id.js": 799,
		"./is": 800,
		"./is.js": 800,
		"./it": 801,
		"./it.js": 801,
		"./ja": 802,
		"./ja.js": 802,
		"./jv": 803,
		"./jv.js": 803,
		"./ka": 804,
		"./ka.js": 804,
		"./kk": 805,
		"./kk.js": 805,
		"./km": 806,
		"./km.js": 806,
		"./ko": 807,
		"./ko.js": 807,
		"./ky": 808,
		"./ky.js": 808,
		"./lb": 809,
		"./lb.js": 809,
		"./lo": 810,
		"./lo.js": 810,
		"./lt": 811,
		"./lt.js": 811,
		"./lv": 812,
		"./lv.js": 812,
		"./me": 813,
		"./me.js": 813,
		"./mk": 814,
		"./mk.js": 814,
		"./ml": 815,
		"./ml.js": 815,
		"./mr": 816,
		"./mr.js": 816,
		"./ms": 817,
		"./ms-my": 818,
		"./ms-my.js": 818,
		"./ms.js": 817,
		"./my": 819,
		"./my.js": 819,
		"./nb": 820,
		"./nb.js": 820,
		"./ne": 821,
		"./ne.js": 821,
		"./nl": 822,
		"./nl.js": 822,
		"./nn": 823,
		"./nn.js": 823,
		"./pa-in": 824,
		"./pa-in.js": 824,
		"./pl": 825,
		"./pl.js": 825,
		"./pt": 826,
		"./pt-br": 827,
		"./pt-br.js": 827,
		"./pt.js": 826,
		"./ro": 828,
		"./ro.js": 828,
		"./ru": 829,
		"./ru.js": 829,
		"./se": 830,
		"./se.js": 830,
		"./si": 831,
		"./si.js": 831,
		"./sk": 832,
		"./sk.js": 832,
		"./sl": 833,
		"./sl.js": 833,
		"./sq": 834,
		"./sq.js": 834,
		"./sr": 835,
		"./sr-cyrl": 836,
		"./sr-cyrl.js": 836,
		"./sr.js": 835,
		"./ss": 837,
		"./ss.js": 837,
		"./sv": 838,
		"./sv.js": 838,
		"./sw": 839,
		"./sw.js": 839,
		"./ta": 840,
		"./ta.js": 840,
		"./te": 841,
		"./te.js": 841,
		"./th": 842,
		"./th.js": 842,
		"./tl-ph": 843,
		"./tl-ph.js": 843,
		"./tlh": 844,
		"./tlh.js": 844,
		"./tr": 845,
		"./tr.js": 845,
		"./tzl": 846,
		"./tzl.js": 846,
		"./tzm": 847,
		"./tzm-latn": 848,
		"./tzm-latn.js": 848,
		"./tzm.js": 847,
		"./uk": 849,
		"./uk.js": 849,
		"./uz": 850,
		"./uz.js": 850,
		"./vi": 851,
		"./vi.js": 851,
		"./x-pseudo": 852,
		"./x-pseudo.js": 852,
		"./zh-cn": 853,
		"./zh-cn.js": 853,
		"./zh-tw": 854,
		"./zh-tw.js": 854
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 753;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	}));

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! changes in months, weekdays: Ahmed Elkhatib
	//! Native plural forms: forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	}));

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	
	}));

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	
	}));

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	
	}));

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	}));

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	}));

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	}));

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রব_সম_মঙ্গ_বু_ব্রিহ_শু_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	}));

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	}));

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	}));

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	}));

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	}));

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	}));

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	}));

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	}));

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	}));

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	}));

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	
	}));

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	}));

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	}));

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_au = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	
	}));

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	
	}));

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	
	}));

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ie = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_ie;
	
	}));

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_nz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_nz;
	
	}));

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	}));

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	}));

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es_do = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es_do;
	
	}));

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	}));

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	}));

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	}));

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	}));

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	}));

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	
	}));

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ch = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr_ch;
	
	}));

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	}));

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        ordinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	}));

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	        monthsShort : 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str === 'uns segundos') {
	                    return 'nuns segundos';
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gl;
	
	}));

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	}));

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	}));

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	}));

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	
	}));

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	
	}));

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	}));

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	}));

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	}));

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        ordinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	}));

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	}));

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	}));

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	}));

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	}));

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//!
	//! authors
	//!
	//! - Kyungwook, Park : https://github.com/kyungw00k
	//! - Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	}));

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	}));

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch, David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	}));

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        ordinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	}));

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?|MMMM?(\[[^\[\]]*\]|\s+)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	}));

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	}));

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	}));

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	}));

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	}));

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	}));

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	}));

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	
	}));

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	}));

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	}));

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	}));

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jjupiter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	}));

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	}));

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var pa_in = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return pa_in;
	
	}));

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	}));

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	}));

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return pt_br;
	
	}));

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	}));

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	
	}));

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	}));

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	}));

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	}));

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	}));

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author: Menelion Elensúle: https://github.com/Oire (tests)
	//! author : Oerd Cukalla : https://github.com/oerd (fixes)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	}));

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	}));

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	
	}));

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swazi [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	}));

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	}));

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	}));

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	}));

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        ordinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	}));

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H นาฬิกา m นาที',
	            LTS : 'H นาฬิกา m นาที s วินาที',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H นาฬิกา m นาที',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	}));

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	
	}));

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	}));

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	}));

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v with the help of Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	}));

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	}));

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	
	}));

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	}));

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	}));

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	}));

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var x_pseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return x_pseudo;
	
	}));

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	
	}));

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(752)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zh_tw;
	
	}));

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * This allows you to work with object hierarchies that have been frozen
	 * with Object.freeze().  "get" operations can use the normal JS syntax,
	 * but operations that modify the data will have to return partial copies of
	 * the structure. The portions of the structure that did not change will
	 * === their previous values.
	 *
	 * Inspired by clojure/mori and Immutable.js
	 */
	
	"use strict";
	
	var i = exports;
	
	// we only care about objects or arrays for now
	function weCareAbout(val) {
	  return null !== val &&
	    (Array.isArray(val) ||
	      // This will skip objects created with `new Foo()`
	      // and objects created with `Object.create(proto)`
	      // The benefit is ignoring DOM elements and event emitters,
	      // which are often circular.
	      isObjectLike(val));
	}
	
	function isObjectLike(val) {
	  return typeof val === "object" &&
	    val.constructor === Object &&
	    Object.getPrototypeOf(val) === Object.prototype;
	}
	
	
	function arrayClone(arr) {
	  var index = 0,
	    length = arr.length,
	    result = Array(length);
	
	  for (; index < length; index += 1) {
	    result[index] = arr[index];
	  }
	  return result;
	}
	
	function objClone(obj) {
	  var index = 0,
	    keys = Object.keys(obj),
	    length = keys.length,
	    key,
	    result = {};
	
	  for (; index < length; index += 1) {
	    key = keys[index];
	    result[key] = obj[key];
	  }
	  return result;
	}
	
	function clone(coll) {
	  if (Array.isArray(coll)) {
	    return arrayClone(coll);
	  } else {
	    return objClone(coll);
	  }
	}
	
	function freezeIfNeeded(coll) {
	  if (
	      weCareAbout(coll) &&
	      (
	        !Object.isFrozen(coll) &&
	        ("production") !== "production"
	      )) {
	    return baseFreeze(coll, []);
	  }
	  return coll;
	}
	
	function _freeze(coll) {
	  if (true) {
	    return coll;
	  }
	  if (typeof coll === "object") {
	    return Object.freeze(coll);
	  } else {
	    return coll;
	  }
	}
	
	function baseFreeze(coll, prevNodes) {
	  if (prevNodes.some(function (node) { return node === coll; })) {
	    throw new Error("object has a reference cycle");
	  }
	
	  Object.freeze(coll);
	  prevNodes.push(coll);
	  Object.keys(coll).forEach(function (key) {
	    var prop = coll[key];
	    if (weCareAbout(prop)) {
	      baseFreeze(prop, prevNodes);
	    }
	  });
	  prevNodes.pop();
	
	  return coll;
	}
	
	/**
	 * recrursively freeze an object and all its child objects
	 * @param  {Object|Array} coll
	 * @return {Object|Array}
	 */
	exports.freeze = function freeze(coll) {
	  if (true) {
	    return coll;
	  }
	  return baseFreeze(coll, []);
	};
	
	/**
	 * recursively un-freeze an object, by cloning frozen collections
	 * @param  {[type]} coll [description]
	 * @return {[type]}      [description]
	 */
	exports.thaw = function thaw(coll) {
	  if (weCareAbout(coll) && Object.isFrozen(coll)) {
	    var newColl = clone(coll);
	    Object.keys(newColl).forEach(function (key) {
	      newColl[key] = thaw(newColl[key]);
	    });
	    return newColl;
	  }
	  return coll;
	};
	
	/**
	 * set a value on an object or array
	 * @param  {Object|Array}  coll
	 * @param  {String|Number} key   Key or index
	 * @param  {Object}        value
	 * @return {Object|Array}        new object hierarchy with modifications
	 */
	exports.assoc = function assoc(coll, key, value) {
	  if (coll[key] === value) {
	    return _freeze(coll);
	  }
	
	  var newObj = clone(coll);
	
	  newObj[key] = freezeIfNeeded(value);
	
	  return _freeze(newObj);
	
	};
	exports.set = exports.assoc;
	
	/**
	 * un-set a value on an object or array
	 * @param  {Object|Array}  coll
	 * @param  {String|Number} key  Key or Index
	 * @return {Object|Array}       New object or array
	 */
	exports.dissoc = function dissoc(coll, key) {
	  var newObj = clone(coll);
	
	  delete newObj[key];
	
	  return _freeze(newObj);
	};
	exports.unset = exports.dissoc;
	
	/**
	 * set a value deep in a hierarchical structure
	 * @param  {Object|Array} coll
	 * @param  {Array}        path    A list of keys to traverse
	 * @param  {Object}       value
	 * @return {Object|Array}       new object hierarchy with modifications
	 */
	exports.assocIn = function assocIn(coll, path, value) {
	  var key0 = path[0];
	  if (path.length === 1) {
	    // simplest case is a 1-element array.  Just a simple assoc.
	    return i.assoc(coll, key0, value);
	  } else {
	    // break the problem down.  Assoc this object with the first key
	    // and the result of assocIn with the rest of the keys
	    return i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
	  }
	};
	exports.setIn = exports.assocIn;
	
	/**
	 * get an object from a hierachy based on an array of keys
	 * @param  {Object|Array} coll
	 * @param  {Array}        path    list of keys
	 * @return {Object}       value, or undefined
	 */
	function baseGet(coll, path) {
	  return (path || []).reduce(function (curr, key) {
	    if (!curr) { return; }
	    return curr[key];
	  }, coll);
	}
	
	exports.getIn = baseGet;
	
	/**
	 * Update a value in a hierarchy
	 * @param  {Object|Array}   coll
	 * @param  {Array}          path     list of keys
	 * @param  {Function} callback The existing value with be passed to this.
	 *                             Return the new value to set
	 * @return {Object|Array}      new object hierarchy with modifications
	 */
	exports.updateIn = function updateIn(coll, path, callback) {
	  var existingVal = baseGet(coll, path);
	  return i.assocIn(coll, path, callback(existingVal));
	};
	
	
	// generate wrappers for the mutative array methods
	["push", "unshift", "pop", "shift", "reverse", "sort"]
	.forEach(function (methodName) {
	  exports[methodName] = function (arr, val) {
	    var newArr = arrayClone(arr);
	
	    newArr[methodName](freezeIfNeeded(val));
	
	    return _freeze(newArr);
	  };
	
	  exports[methodName].displayName = "icepick." + methodName;
	});
	
	// splice is special because it is variadic
	exports.splice = function splice(arr/*, args*/) {
	  var newArr = arrayClone(arr),
	    args = rest(arguments).map(freezeIfNeeded);
	
	  newArr.splice.apply(newArr, args);
	
	  return _freeze(newArr);
	};
	
	// slice is non-mutative
	exports.slice = function slice(arr, arg1, arg2) {
	  var newArr = arr.slice(arg1, arg2);
	
	  return _freeze(newArr);
	};
	
	["map", "filter"].forEach(function (methodName) {
	  exports[methodName] = function (fn, arr) {
	    var newArr = arr[methodName](fn);
	
	    return _freeze(newArr);
	  };
	
	  exports[methodName].displayName = "icepick." + methodName;
	});
	
	exports.extend =
	exports.assign = function assign(/*...objs*/) {
	  var newObj = rest(arguments).reduce(singleAssign, arguments[0]);
	
	  return _freeze(newObj);
	};
	
	function singleAssign(obj1, obj2) {
	  return Object.keys(obj2).reduce(function (obj, key) {
	    return i.assoc(obj, key, obj2[key]);
	  }, obj1);
	}
	
	exports.merge = merge;
	function merge(target, source, resolver) {
	  if (target == null || source == null) {
	    return target;
	  }
	  return Object.keys(source).reduce(function (obj, key) {
	    var sourceVal = source[key];
	    var targetVal = obj[key];
	
	    var resolvedSourceVal =
	      resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
	
	    if (weCareAbout(sourceVal) && weCareAbout(targetVal)) {
	      // if they are both frozen and reference equal, assume they are deep equal
	      if ((
	            (Object.isFrozen(resolvedSourceVal) &&
	              Object.isFrozen(targetVal)) ||
	            ("production") === "production"
	          ) &&
	          resolvedSourceVal === targetVal) {
	        return obj;
	      }
	      if (Array.isArray(sourceVal)) {
	        return i.assoc(obj, key, resolvedSourceVal);
	      }
	      // recursively merge pairs of objects
	      return assocIfDifferent(obj, key,
	        merge(targetVal, resolvedSourceVal, resolver));
	    }
	
	    // primitive values, stuff with prototypes
	    return assocIfDifferent(obj, key, resolvedSourceVal);
	  }, target);
	}
	
	function assocIfDifferent(target, key, value) {
	  if (target[key] === value) {
	    return target;
	  }
	  return i.assoc(target, key, value);
	}
	
	function _slice(array, start) {
	  var begin = start || 0;
	  var len = array.length;
	  len -= begin;
	  len = len < 0 ? 0 : len;
	  var result = new Array(len);
	  for (var i = 0; i < len; i += 1) {
	    result[i] = array[i + begin];
	  }
	  return result;
	}
	
	
	function rest(args) {
	  return _slice(args, 1);
	}
	
	
	var chainProto = {
	  value: function value() {
	    return this.val;
	  },
	  thru: function thru(fn) {
	    this.val = freezeIfNeeded(fn(this.val));
	    return this;
	  }
	};
	
	Object.keys(exports).forEach(function (methodName) {
	  chainProto[methodName] = function (/*...args*/) {
	    var args = _slice(arguments);
	    args.unshift(this.val);
	    this.val = exports[methodName].apply(null, args);
	    return this;
	  };
	});
	
	exports.chain = function chain(val) {
	  var wrapped = Object.create(chainProto);
	  wrapped.val = val;
	  return wrapped;
	};
	
	// for testing
	exports._weCareAbout = weCareAbout;
	exports._slice = _slice;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetched = exports.states = exports.clearRequestState = exports.setRequestState = exports.SET_REQUEST_STATE = undefined;
	
	var _handleActions;
	
	var _redux = __webpack_require__(657);
	
	var _icepick = __webpack_require__(855);
	
	var _redux2 = __webpack_require__(480);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*  weak */
	
	var SET_REQUEST_STATE = exports.SET_REQUEST_STATE = "metabase/requests/SET_REQUEST_STATE";
	var CLEAR_REQUEST_STATE = "metabase/requests/CLEAR_REQUEST_STATE";
	
	var setRequestState = exports.setRequestState = (0, _redux.createAction)(SET_REQUEST_STATE);
	var clearRequestState = exports.clearRequestState = (0, _redux.createAction)(CLEAR_REQUEST_STATE);
	
	// For a given state path, returns the current request state ("LOADING", "LOADED" or a request error)
	var states = exports.states = (0, _redux.handleActions)((_handleActions = {}, _defineProperty(_handleActions, SET_REQUEST_STATE, {
	    next: function next(state, _ref) {
	        var payload = _ref.payload;
	        return (0, _icepick.assocIn)(state, payload.statePath, { state: payload.state, error: payload.error });
	    }
	}), _defineProperty(_handleActions, CLEAR_REQUEST_STATE, {
	    next: function next(state, _ref2) {
	        var payload = _ref2.payload;
	        return (0, _icepick.assocIn)(state, payload.statePath, undefined);
	    }
	}), _handleActions), {});
	
	// For given state path, returns true if the data has been successfully fetched at least once
	var fetched = exports.fetched = (0, _redux.handleActions)(_defineProperty({}, SET_REQUEST_STATE, {
	    next: function next(state, _ref3) {
	        var payload = _ref3.payload;
	
	        var isFetch = payload.statePath[payload.statePath.length - 1] === "fetch";
	
	        if (isFetch) {
	            var statePathWithoutFetch = payload.statePath.slice(0, -1);
	            return (0, _icepick.assocIn)(state, statePathWithoutFetch, (0, _icepick.getIn)(state, statePathWithoutFetch) || payload.state === "LOADED");
	        } else {
	            return state;
	        }
	    }
	}), {});
	
	exports.default = (0, _redux2.combineReducers)({ states: states, fetched: fetched });

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GeoJSONApi = exports.UtilApi = exports.UserApi = exports.SetupApi = exports.GettingStartedApi = exports.PermissionsApi = exports.SettingsApi = exports.SessionApi = exports.LabelApi = exports.RevisionsApi = exports.RevisionApi = exports.MetricApi = exports.SegmentApi = exports.PulseApi = exports.XRayApi = exports.MetabaseApi = exports.LdapApi = exports.SlackApi = exports.EmailApi = exports.EmbedApi = exports.PublicApi = exports.CollectionsApi = exports.DashboardApi = exports.CardApi = exports.ActivityApi = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _api = __webpack_require__(584);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _embed = __webpack_require__(858);
	
	var _gaMetadata = __webpack_require__(860);
	
	var _gaMetadata2 = _interopRequireDefault(_gaMetadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var GET = _api2.default.GET,
	    PUT = _api2.default.PUT,
	    POST = _api2.default.POST,
	    DELETE = _api2.default.DELETE;
	
	
	// use different endpoints for embed previews
	var embedBase = _embed.IS_EMBED_PREVIEW ? "/api/preview_embed" : "/api/embed";
	
	// $FlowFixMe: Flow doesn't understand webpack loader syntax
	// eslint-disable-line import/default
	
	var ActivityApi = exports.ActivityApi = {
	    list: GET("/api/activity"),
	    recent_views: GET("/api/activity/recent_views")
	};
	
	var CardApi = exports.CardApi = {
	    list: GET("/api/card", function (cards, _ref) {
	        var data = _ref.data;
	        return (
	            // HACK: support for the "q" query param until backend implements it
	            cards.filter(function (card) {
	                return !data.q || card.name.toLowerCase().indexOf(data.q.toLowerCase()) >= 0;
	            })
	        );
	    }),
	    create: POST("/api/card"),
	    get: GET("/api/card/:cardId"),
	    update: PUT("/api/card/:id"),
	    delete: DELETE("/api/card/:cardId"),
	    query: POST("/api/card/:cardId/query"),
	    // isfavorite:                  GET("/api/card/:cardId/favorite"),
	    favorite: POST("/api/card/:cardId/favorite"),
	    unfavorite: DELETE("/api/card/:cardId/favorite"),
	    updateLabels: POST("/api/card/:cardId/labels"),
	
	    listPublic: GET("/api/card/public"),
	    listEmbeddable: GET("/api/card/embeddable"),
	    createPublicLink: POST("/api/card/:id/public_link"),
	    deletePublicLink: DELETE("/api/card/:id/public_link")
	};
	
	var DashboardApi = exports.DashboardApi = {
	    list: GET("/api/dashboard"),
	    create: POST("/api/dashboard"),
	    get: GET("/api/dashboard/:dashId"),
	    update: PUT("/api/dashboard/:id"),
	    delete: DELETE("/api/dashboard/:dashId"),
	    addcard: POST("/api/dashboard/:dashId/cards"),
	    removecard: DELETE("/api/dashboard/:dashId/cards"),
	    reposition_cards: PUT("/api/dashboard/:dashId/cards"),
	    favorite: POST("/api/dashboard/:dashId/favorite"),
	    unfavorite: DELETE("/api/dashboard/:dashId/favorite"),
	
	    listPublic: GET("/api/dashboard/public"),
	    listEmbeddable: GET("/api/dashboard/embeddable"),
	    createPublicLink: POST("/api/dashboard/:id/public_link"),
	    deletePublicLink: DELETE("/api/dashboard/:id/public_link")
	};
	
	var CollectionsApi = exports.CollectionsApi = {
	    list: GET("/api/collection"),
	    create: POST("/api/collection"),
	    get: GET("/api/collection/:id"),
	    update: PUT("/api/collection/:id"),
	    delete: DELETE("/api/collection/:id"),
	    graph: GET("/api/collection/graph"),
	    updateGraph: PUT("/api/collection/graph")
	};
	
	var PublicApi = exports.PublicApi = {
	    card: GET("/api/public/card/:uuid"),
	    cardQuery: GET("/api/public/card/:uuid/query"),
	    dashboard: GET("/api/public/dashboard/:uuid"),
	    dashboardCardQuery: GET("/api/public/dashboard/:uuid/card/:cardId")
	};
	
	var EmbedApi = exports.EmbedApi = {
	    card: GET(embedBase + "/card/:token"),
	    cardQuery: GET(embedBase + "/card/:token/query"),
	    dashboard: GET(embedBase + "/dashboard/:token"),
	    dashboardCardQuery: GET(embedBase + "/dashboard/:token/dashcard/:dashcardId/card/:cardId")
	};
	
	var EmailApi = exports.EmailApi = {
	    updateSettings: PUT("/api/email"),
	    sendTest: POST("/api/email/test")
	};
	
	var SlackApi = exports.SlackApi = {
	    updateSettings: PUT("/api/slack/settings")
	};
	
	var LdapApi = exports.LdapApi = {
	    updateSettings: PUT("/api/ldap/settings")
	};
	
	var MetabaseApi = exports.MetabaseApi = {
	    db_list: GET("/api/database"),
	    db_list_with_tables: GET("/api/database?include_tables=true&include_cards=true"),
	    db_real_list_with_tables: GET("/api/database?include_tables=true&include_cards=false"),
	    db_create: POST("/api/database"),
	    db_validate: POST("/api/database/validate"),
	    db_add_sample_dataset: POST("/api/database/sample_dataset"),
	    db_get: GET("/api/database/:dbId"),
	    db_update: PUT("/api/database/:id"),
	    db_delete: DELETE("/api/database/:dbId"),
	    db_metadata: GET("/api/database/:dbId/metadata"),
	    // db_tables:                   GET("/api/database/:dbId/tables"),
	    db_fields: GET("/api/database/:dbId/fields"),
	    db_idfields: GET("/api/database/:dbId/idfields"),
	    db_autocomplete_suggestions: GET("/api/database/:dbId/autocomplete_suggestions?prefix=:prefix"),
	    db_sync_schema: POST("/api/database/:dbId/sync_schema"),
	    db_rescan_values: POST("/api/database/:dbId/rescan_values"),
	    db_discard_values: POST("/api/database/:dbId/discard_values"),
	    table_list: GET("/api/table"),
	    // table_get:                   GET("/api/table/:tableId"),
	    table_update: PUT("/api/table/:id"),
	    // table_fields:                GET("/api/table/:tableId/fields"),
	    table_fks: GET("/api/table/:tableId/fks"),
	    // table_reorder_fields:       POST("/api/table/:tableId/reorder"),
	    table_query_metadata: GET("/api/table/:tableId/query_metadata", function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(table) {
	            var _table$metrics, _table$segments, GA, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, field;
	
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(table && table.db && table.db.engine === "googleanalytics")) {
	                                _context.next = 7;
	                                break;
	                            }
	
	                            _context.next = 3;
	                            return (0, _gaMetadata2.default)();
	
	                        case 3:
	                            GA = _context.sent;
	
	                            table.fields = table.fields.map(function (f) {
	                                return _extends({}, f, GA.fields[f.name]);
	                            });
	                            (_table$metrics = table.metrics).push.apply(_table$metrics, _toConsumableArray(GA.metrics));
	                            (_table$segments = table.segments).push.apply(_table$segments, _toConsumableArray(GA.segments));
	
	                        case 7:
	                            if (!(table && table.fields)) {
	                                _context.next = 27;
	                                break;
	                            }
	
	                            // replace dimension_options IDs with objects
	                            _iteratorNormalCompletion = true;
	                            _didIteratorError = false;
	                            _iteratorError = undefined;
	                            _context.prev = 11;
	                            for (_iterator = table.fields[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                field = _step.value;
	
	                                if (field.dimension_options) {
	                                    field.dimension_options = field.dimension_options.map(function (id) {
	                                        return table.dimension_options[id];
	                                    });
	                                }
	                                if (field.default_dimension_option) {
	                                    field.default_dimension_option = table.dimension_options[field.default_dimension_option];
	                                }
	                            }
	                            _context.next = 19;
	                            break;
	
	                        case 15:
	                            _context.prev = 15;
	                            _context.t0 = _context["catch"](11);
	                            _didIteratorError = true;
	                            _iteratorError = _context.t0;
	
	                        case 19:
	                            _context.prev = 19;
	                            _context.prev = 20;
	
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	
	                        case 22:
	                            _context.prev = 22;
	
	                            if (!_didIteratorError) {
	                                _context.next = 25;
	                                break;
	                            }
	
	                            throw _iteratorError;
	
	                        case 25:
	                            return _context.finish(22);
	
	                        case 26:
	                            return _context.finish(19);
	
	                        case 27:
	                            return _context.abrupt("return", table);
	
	                        case 28:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[11, 15, 19, 27], [20,, 22, 26]]);
	        }));
	
	        return function (_x) {
	            return _ref2.apply(this, arguments);
	        };
	    }()),
	    // table_sync_metadata:        POST("/api/table/:tableId/sync"),
	    table_rescan_values: POST("/api/table/:tableId/rescan_values"),
	    table_discard_values: POST("/api/table/:tableId/discard_values"),
	    // field_get:                   GET("/api/field/:fieldId"),
	    // field_summary:               GET("/api/field/:fieldId/summary"),
	    field_values: GET("/api/field/:fieldId/values"),
	    field_values_update: POST("/api/field/:fieldId/values"),
	    field_update: PUT("/api/field/:id"),
	    field_dimension_update: POST("/api/field/:fieldId/dimension"),
	    field_dimension_delete: DELETE("/api/field/:fieldId/dimension"),
	    field_rescan_values: POST("/api/field/:fieldId/rescan_values"),
	    field_discard_values: POST("/api/field/:fieldId/discard_values"),
	    dataset: POST("/api/dataset"),
	    dataset_duration: POST("/api/dataset/duration")
	};
	
	var XRayApi = exports.XRayApi = {
	    // X-Rays
	    field_xray: GET("/api/x-ray/field/:fieldId"),
	    table_xray: GET("/api/x-ray/table/:tableId"),
	    segment_xray: GET("/api/x-ray/segment/:segmentId"),
	    card_xray: GET("/api/x-ray/card/:cardId"),
	
	    field_compare: GET("/api/x-ray/compare/fields/:fieldId1/:fieldId2"),
	    table_compare: GET("/api/x-ray/compare/tables/:tableId1/:tableId2"),
	    segment_compare: GET("/api/x-ray/compare/segments/:segmentId1/:segmentId2"),
	    segment_table_compare: GET("/api/x-ray/compare/segment/:segmentId/table/:tableId"),
	    segment_field_compare: GET("/api/x-ray/compare/segments/:segmentId1/:segmentId2/field/:fieldName"),
	    segment_table_field_compare: GET("/api/x-ray/compare/segment/:segmentId/table/:tableId/field/:fieldName"),
	    card_compare: GET("/api/x-ray/compare/cards/:cardId1/:cardId2")
	};
	
	var PulseApi = exports.PulseApi = {
	    list: GET("/api/pulse"),
	    create: POST("/api/pulse"),
	    get: GET("/api/pulse/:pulseId"),
	    update: PUT("/api/pulse/:id"),
	    delete: DELETE("/api/pulse/:pulseId"),
	    test: POST("/api/pulse/test"),
	    form_input: GET("/api/pulse/form_input"),
	    preview_card: GET("/api/pulse/preview_card_info/:id")
	};
	
	var SegmentApi = exports.SegmentApi = {
	    list: GET("/api/segment"),
	    create: POST("/api/segment"),
	    get: GET("/api/segment/:segmentId"),
	    update: PUT("/api/segment/:id"),
	    delete: DELETE("/api/segment/:segmentId")
	};
	
	var MetricApi = exports.MetricApi = {
	    list: GET("/api/metric"),
	    create: POST("/api/metric"),
	    get: GET("/api/metric/:metricId"),
	    update: PUT("/api/metric/:id"),
	    update_important_fields: PUT("/api/metric/:metricId/important_fields"),
	    delete: DELETE("/api/metric/:metricId")
	};
	
	var RevisionApi = exports.RevisionApi = {
	    list: GET("/api/revision"),
	    revert: POST("/api/revision/revert")
	};
	
	var RevisionsApi = exports.RevisionsApi = {
	    get: GET("/api/:entity/:id/revisions")
	};
	
	var LabelApi = exports.LabelApi = {
	    list: GET("/api/label"),
	    create: POST("/api/label"),
	    update: PUT("/api/label/:id"),
	    delete: DELETE("/api/label/:id")
	};
	
	var SessionApi = exports.SessionApi = {
	    create: POST("/api/session"),
	    createWithGoogleAuth: POST("/api/session/google_auth"),
	    delete: DELETE("/api/session"),
	    properties: GET("/api/session/properties"),
	    forgot_password: POST("/api/session/forgot_password"),
	    reset_password: POST("/api/session/reset_password"),
	    password_reset_token_valid: GET("/api/session/password_reset_token_valid")
	};
	
	var SettingsApi = exports.SettingsApi = {
	    list: GET("/api/setting"),
	    put: PUT("/api/setting/:key")
	};
	
	var PermissionsApi = exports.PermissionsApi = {
	    groups: GET("/api/permissions/group"),
	    groupDetails: GET("/api/permissions/group/:id"),
	    graph: GET("/api/permissions/graph"),
	    updateGraph: PUT("/api/permissions/graph"),
	    createGroup: POST("/api/permissions/group"),
	    memberships: GET("/api/permissions/membership"),
	    createMembership: POST("/api/permissions/membership"),
	    deleteMembership: DELETE("/api/permissions/membership/:id"),
	    updateGroup: PUT("/api/permissions/group/:id"),
	    deleteGroup: DELETE("/api/permissions/group/:id")
	};
	
	var GettingStartedApi = exports.GettingStartedApi = {
	    get: GET("/api/getting_started")
	};
	
	var SetupApi = exports.SetupApi = {
	    create: POST("/api/setup"),
	    validate_db: POST("/api/setup/validate"),
	    admin_checklist: GET("/api/setup/admin_checklist")
	};
	
	var UserApi = exports.UserApi = {
	    create: POST("/api/user"),
	    list: GET("/api/user"),
	    current: GET("/api/user/current"),
	    // get:                         GET("/api/user/:userId"),
	    update: PUT("/api/user/:id"),
	    update_password: PUT("/api/user/:id/password"),
	    update_qbnewb: PUT("/api/user/:id/qbnewb"),
	    delete: DELETE("/api/user/:userId"),
	    send_invite: POST("/api/user/:id/send_invite")
	};
	
	var UtilApi = exports.UtilApi = {
	    password_check: POST("/api/util/password_check"),
	    random_token: GET("/api/util/random_token"),
	    logs: GET("/api/util/logs")
	};
	
	var GeoJSONApi = exports.GeoJSONApi = {
	    get: GET("/api/geojson/:id")
	};
	
	global.services = exports;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_EMBED_PREVIEW = undefined;
	
	var _dom = __webpack_require__(859);
	
	// detect if this page is embedded in itself, i.e. it's a embed preview
	// will need to do something different if we ever embed metabase in itself for another reason
	var IS_EMBED_PREVIEW = exports.IS_EMBED_PREVIEW = _dom.IFRAMED_IN_SELF;

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.isObscured = isObscured;
	exports.findPosition = findPosition;
	exports.elementIsInView = elementIsInView;
	exports.getSelectionPosition = getSelectionPosition;
	exports.setSelectionPosition = setSelectionPosition;
	exports.saveSelection = saveSelection;
	exports.getCaretPosition = getCaretPosition;
	exports.setCaretPosition = setCaretPosition;
	exports.saveCaretPosition = saveCaretPosition;
	exports.addCSSRule = addCSSRule;
	exports.constrainToScreen = constrainToScreen;
	exports.forceRedraw = forceRedraw;
	exports.moveToBack = moveToBack;
	exports.moveToFront = moveToFront;
	exports.clipPathReference = clipPathReference;
	
	// IE doesn't support scrollX/scrollY:
	var getScrollX = exports.getScrollX = function getScrollX() {
	    return typeof window.scrollX === "undefined" ? window.pageXOffset : window.scrollX;
	};
	var getScrollY = exports.getScrollY = function getScrollY() {
	    return typeof window.scrollY === "undefined" ? window.pageYOffset : window.scrollY;
	};
	
	// denotes whether the current page is loaded in an iframe or not
	var IFRAMED = exports.IFRAMED = function () {
	    try {
	        return window.self !== window.top;
	    } catch (e) {
	        return true;
	    }
	}();
	
	// add a global so we can check if the parent iframe is Metabase
	window.METABASE = true;
	
	// check that we're both iframed, and the parent is a Metabase instance
	// used for detecting if we're previewing an embed
	var IFRAMED_IN_SELF = exports.IFRAMED_IN_SELF = function () {
	    try {
	        return window.self !== window.top && window.top.METABASE;
	    } catch (e) {
	        return false;
	    }
	}();
	
	function isObscured(element, offset) {
	    // default to the center of the element
	    offset = offset || {
	        top: Math.round(element.offsetHeight / 2),
	        left: Math.round(element.offsetWidth / 2)
	    };
	    var position = findPosition(element, true);
	    var elem = document.elementFromPoint(position.left + offset.left, position.top + offset.top);
	    return !element.contains(elem);
	}
	
	// get the position of an element on the page
	function findPosition(element) {
	    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var offset = { top: 0, left: 0 };
	    var scroll = { top: 0, left: 0 };
	    var offsetParent = element;
	    while (offsetParent) {
	        // we need to check every element for scrollTop/scrollLeft
	        scroll.left += element.scrollLeft || 0;
	        scroll.top += element.scrollTop || 0;
	        // but only the original element and offsetParents for offsetTop/offsetLeft
	        if (offsetParent === element) {
	            offset.left += element.offsetLeft;
	            offset.top += element.offsetTop;
	            offsetParent = element.offsetParent;
	        }
	        element = element.parentNode;
	    }
	    if (excludeScroll) {
	        offset.left -= scroll.left;
	        offset.top -= scroll.top;
	    }
	    return offset;
	}
	
	// based on http://stackoverflow.com/a/38039019/113
	function elementIsInView(element) {
	    var percentX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	    var percentY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	    var tolerance = 0.01; //needed because the rects returned by getBoundingClientRect provide the position up to 10 decimals
	
	    var elementRect = element.getBoundingClientRect();
	    var parentRects = [];
	
	    while (element.parentElement != null) {
	        parentRects.push(element.parentElement.getBoundingClientRect());
	        element = element.parentElement;
	    }
	
	    return parentRects.every(function (parentRect) {
	        var visiblePixelX = Math.min(elementRect.right, parentRect.right) - Math.max(elementRect.left, parentRect.left);
	        var visiblePixelY = Math.min(elementRect.bottom, parentRect.bottom) - Math.max(elementRect.top, parentRect.top);
	        var visiblePercentageX = visiblePixelX / elementRect.width;
	        var visiblePercentageY = visiblePixelY / elementRect.height;
	        return visiblePercentageX + tolerance > percentX && visiblePercentageY + tolerance > percentY;
	    });
	}
	
	function getSelectionPosition(element) {
	    // input, textarea, IE
	    if (element.setSelectionRange || element.createTextRange) {
	        return [element.selectionStart, element.selectionEnd];
	    }
	    // contenteditable
	    else {
	            try {
	                var selection = window.getSelection();
	                // Clone the Range otherwise setStart/setEnd will mutate the actual selection in Chrome 58+ and Firefox!
	                var range = selection.getRangeAt(0).cloneRange();
	                var startContainer = range.startContainer,
	                    startOffset = range.startOffset;
	
	                range.setStart(element, 0);
	                var end = range.toString().length;
	                range.setEnd(startContainer, startOffset);
	                var start = range.toString().length;
	
	                return [start, end];
	            } catch (e) {
	                return [0, 0];
	            }
	        }
	}
	
	function setSelectionPosition(element, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        start = _ref2[0],
	        end = _ref2[1];
	
	    // input, textarea
	    if (element.setSelectionRange) {
	        element.focus();
	        element.setSelectionRange(start, end);
	    }
	    // IE
	    else if (element.createTextRange) {
	            var range = element.createTextRange();
	            range.collapse(true);
	            range.moveEnd("character", end);
	            range.moveStart("character", start);
	            range.select();
	        }
	        // contenteditable
	        else {
	                var selection = window.getSelection();
	                var startPos = getTextNodeAtPosition(element, start);
	                var endPos = getTextNodeAtPosition(element, end);
	                selection.removeAllRanges();
	                var _range = new Range();
	                _range.setStart(startPos.node, startPos.position);
	                _range.setEnd(endPos.node, endPos.position);
	                selection.addRange(_range);
	            }
	}
	
	function saveSelection(element) {
	    var range = getSelectionPosition(element);
	    return function () {
	        return setSelectionPosition(element, range);
	    };
	}
	
	function getCaretPosition(element) {
	    return getSelectionPosition(element)[1];
	}
	
	function setCaretPosition(element, position) {
	    setSelectionPosition(element, [position, position]);
	}
	
	function saveCaretPosition(element) {
	    var position = getCaretPosition(element);
	    return function () {
	        return setCaretPosition(element, position);
	    };
	}
	
	function getTextNodeAtPosition(root, index) {
	    var treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, function (elem) {
	        if (index > elem.textContent.length) {
	            index -= elem.textContent.length;
	            return NodeFilter.FILTER_REJECT;
	        }
	        return NodeFilter.FILTER_ACCEPT;
	    });
	    var c = treeWalker.nextNode();
	    return {
	        node: c ? c : root,
	        position: c ? index : 0
	    };
	}
	
	// https://davidwalsh.name/add-rules-stylesheets
	var STYLE_SHEET = function () {
	    // Create the <style> tag
	    var style = document.createElement("style");
	
	    // WebKit hack :(
	    style.appendChild(document.createTextNode("/* dynamic stylesheet */"));
	
	    // Add the <style> element to the page
	    document.head.appendChild(style);
	
	    return style.sheet;
	}();
	
	function addCSSRule(selector, rules) {
	    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	    if ("insertRule" in STYLE_SHEET) {
	        STYLE_SHEET.insertRule(selector + "{" + rules + "}", index);
	    } else if ("addRule" in STYLE_SHEET) {
	        STYLE_SHEET.addRule(selector, rules, index);
	    }
	}
	
	function constrainToScreen(element, direction, padding) {
	    if (direction === "bottom") {
	        var screenBottom = window.innerHeight + getScrollY();
	        var overflowY = element.getBoundingClientRect().bottom - screenBottom;
	        if (overflowY + padding > 0) {
	            element.style.maxHeight = element.getBoundingClientRect().height - overflowY - padding + "px";
	            return true;
	        }
	    } else if (direction === "top") {
	        var screenTop = getScrollY();
	        var _overflowY = screenTop - element.getBoundingClientRect().top;
	        if (_overflowY + padding > 0) {
	            element.style.maxHeight = element.getBoundingClientRect().height - _overflowY - padding + "px";
	            return true;
	        }
	    } else {
	        throw new Error("Direction " + direction + " not implemented");
	    }
	    return false;
	}
	
	// Used for tackling Safari rendering issues
	// http://stackoverflow.com/a/3485654
	function forceRedraw(domNode) {
	    domNode.style.display = 'none';
	    domNode.offsetHeight;
	    domNode.style.display = '';
	}
	
	function moveToBack(element) {
	    if (element && element.parentNode) {
	        element.parentNode.insertBefore(element, element.parentNode.firstChild);
	    }
	}
	
	function moveToFront(element) {
	    if (element && element.parentNode) {
	        element.parentNode.appendChild(element);
	    }
	}
	
	/**
	 * @returns the clip-path CSS property referencing the clip path in the current document, taking into account the <base> tag.
	 */
	function clipPathReference(id) {
	    // add the current page URL (with fragment removed) to support pages with <base> tag.
	    // https://stackoverflow.com/questions/18259032/using-base-tag-on-a-page-that-contains-svg-marker-elements-fails-to-render-marke
	    var url = window.location.href.replace(/#.*$/, "") + "#" + id;
	    return "url(" + url + ")";
	}

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(1, function (require) {
	      resolve(__webpack_require__(861));
	    });
	  });
	}

/***/ }),
/* 861 */,
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.currentUser = exports.clearCurrentUser = exports.CLEAR_CURRENT_USER = exports.loadCurrentUser = exports.LOAD_CURRENT_USER = exports.refreshCurrentUser = exports.REFRESH_CURRENT_USER = undefined;
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(657);
	
	var _actions = __webpack_require__(863);
	
	var _auth = __webpack_require__(1123);
	
	var _services = __webpack_require__(857);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var REFRESH_CURRENT_USER = exports.REFRESH_CURRENT_USER = "metabase/user/REFRESH_CURRENT_USER";
	var refreshCurrentUser = exports.refreshCurrentUser = (0, _redux.createAction)(REFRESH_CURRENT_USER, function () {
	    try {
	        return _services.UserApi.current();
	    } catch (e) {
	        return null;
	    }
	});
	
	var LOAD_CURRENT_USER = exports.LOAD_CURRENT_USER = "metabase/user/LOAD_CURRENT_USER";
	var loadCurrentUser = exports.loadCurrentUser = (0, _redux.createThunkAction)(LOAD_CURRENT_USER, function () {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (getState().currentUser) {
	                                _context.next = 3;
	                                break;
	                            }
	
	                            _context.next = 3;
	                            return dispatch(refreshCurrentUser());
	
	                        case 3:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var CLEAR_CURRENT_USER = exports.CLEAR_CURRENT_USER = "metabase/user/CLEAR_CURRENT_USER";
	var clearCurrentUser = exports.clearCurrentUser = (0, _redux.createAction)(CLEAR_CURRENT_USER);
	
	var currentUser = exports.currentUser = (0, _redux.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _auth.LOGOUT, { next: function next(state, _ref2) {
	        var payload = _ref2.payload;
	        return null;
	    } }), _defineProperty(_handleActions, CLEAR_CURRENT_USER, { next: function next(state, payload) {
	        return null;
	    } }), _defineProperty(_handleActions, REFRESH_CURRENT_USER, { next: function next(state, _ref3) {
	        var payload = _ref3.payload;
	        return payload;
	    } }), _defineProperty(_handleActions, _actions.CLOSE_QB_NEWB_MODAL, { next: function next(state, _ref4) {
	        var payload = _ref4.payload;
	        return _extends({}, state, { is_qbnewb: false });
	    } }), _handleActions), null);

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.onReplaceAllVisualizationSettings = exports.onUpdateVisualizationSettings = exports.onRestoreOriginalQuery = exports.reloadCardFn = exports.onSetCardAttribute = exports.setDisplayFn = exports.setSourceTableFn = exports.setDatabaseFn = exports.setQueryModeFn = exports.onCancelEditing = exports.onBeginEditing = exports.toggleDataReferenceFn = exports.viewPreviousObjectDetail = exports.VIEW_PREVIOUS_OBJECT_DETAIL = exports.viewNextObjectDetail = exports.VIEW_NEXT_OBJECT_DETAIL = exports.archiveQuestion = exports.ARCHIVE_QUESTION = exports.loadObjectDetailFKReferences = exports.LOAD_OBJECT_DETAIL_FK_REFERENCES = exports.followForeignKey = undefined;
	exports.FOLLOW_FOREIGN_KEY = exports.cancelQuery = exports.CANCEL_QUERY = exports.queryErrored = exports.QUERY_ERRORED = exports.queryCompleted = exports.QUERY_COMPLETED = exports.getDisplayTypeForCard = exports.runQuestionQuery = exports.RUN_QUERY = exports.removeQueryExpression = exports.updateQueryExpression = exports.addQueryExpression = exports.updateQueryLimit = exports.removeQueryOrderBy = exports.updateQueryOrderBy = exports.addQueryOrderBy = exports.removeQueryAggregation = exports.updateQueryAggregation = exports.addQueryAggregation = exports.removeQueryFilter = exports.REMOVE_QUERY_FILTER = exports.updateQueryFilter = exports.UPDATE_QUERY_FILTER = exports.addQueryFilter = exports.ADD_QUERY_FILTER = exports.removeQueryBreakout = exports.updateQueryBreakout = exports.addQueryBreakout = exports.setQuerySourceTable = exports.SET_QUERY_SOURCE_TABLE = exports.setQueryDatabase = exports.SET_QUERY_DATABASE = exports.setQueryMode = exports.SET_QUERY_MODE = exports.setDatasetQuery = exports.SET_DATASET_QUERY = exports.updateQuestion = exports.UPDATE_QUESTION = exports.navigateToNewCardInsideQB = exports.NAVIGATE_TO_NEW_CARD = exports.setCardAndRun = exports.SET_CARD_AND_RUN = exports.reloadCard = exports.RELOAD_CARD = exports.notifyCardUpdatedFn = exports.NOTIFY_CARD_UPDATED = exports.notifyCardCreatedFn = exports.NOTIFY_CARD_CREATED = exports.setParameterValue = exports.SET_PARAMETER_VALUE = exports.updateTemplateTag = exports.UPDATE_TEMPLATE_TAG = exports.replaceAllCardVisualizationSettings = exports.REPLACE_ALL_CARD_VISUALIZATION_SETTINGS = exports.updateCardVisualizationSettings = exports.UPDATE_CARD_VISUALIZATION_SETTINGS = exports.setCardVisualization = exports.SET_CARD_VISUALIZATION = exports.setCardAttribute = exports.SET_CARD_ATTRIBUTE = exports.loadDatabaseFields = exports.LOAD_DATABASE_FIELDS = exports.loadTableMetadata = exports.LOAD_TABLE_METADATA = exports.loadMetadataForCard = exports.LOAD_METADATA_FOR_CARD = exports.cancelEditing = exports.CANCEL_EDITING = exports.beginEditing = exports.BEGIN_EDITING = exports.closeQbNewbModal = exports.CLOSE_QB_NEWB_MODAL = exports.closeQbTutorial = exports.CLOSE_QB_TUTORIAL = exports.setIsShowingTemplateTagsEditor = exports.SET_IS_SHOWING_TEMPLATE_TAGS_EDITOR = exports.toggleTemplateTagsEditor = exports.TOGGLE_TEMPLATE_TAGS_EDITOR = exports.toggleDataReference = exports.TOGGLE_DATA_REFERENCE = exports.initializeQB = exports.INITIALIZE_QB = exports.resetQB = exports.RESET_QB = exports.redirectToNewQuestionFlow = exports.REDIRECT_TO_NEW_QUESTION_FLOW = exports.updateUrl = exports.UPDATE_URL = exports.updateEmbeddingParams = exports.UPDATE_EMBEDDING_PARAMS = exports.updateEnableEmbedding = exports.UPDATE_ENABLE_EMBEDDING = exports.deletePublicLink = exports.DELETE_PUBLIC_LINK = exports.createPublicLink = exports.CREATE_PUBLIC_LINK = exports.popState = exports.POP_STATE = exports.SET_CURRENT_STATE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxActions = __webpack_require__(658);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	var _redux = __webpack_require__(657);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _app = __webpack_require__(864);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _card = __webpack_require__(865);
	
	var _formatting = __webpack_require__(872);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _types = __webpack_require__(868);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _engine = __webpack_require__(956);
	
	var _promise = __webpack_require__(1069);
	
	var _undo = __webpack_require__(1070);
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _Card = __webpack_require__(957);
	
	var _selectors = __webpack_require__(1071);
	
	var _metadata = __webpack_require__(1073);
	
	var _metadata2 = __webpack_require__(1110);
	
	var _services = __webpack_require__(857);
	
	var _url = __webpack_require__(1120);
	
	var _querystring = __webpack_require__(585);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _utils3 = __webpack_require__(878);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	var _NativeQuery = __webpack_require__(954);
	
	var _NativeQuery2 = _interopRequireDefault(_NativeQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* weak*/
	
	
	var getTemplateTagCount = function getTemplateTagCount(question) {
	    var query = question.query();
	    return query instanceof _NativeQuery2.default ? query.templateTags().length : 0;
	};
	
	var SET_CURRENT_STATE = exports.SET_CURRENT_STATE = "metabase/qb/SET_CURRENT_STATE";var setCurrentState = (0, _reduxActions.createAction)(SET_CURRENT_STATE);
	
	var POP_STATE = exports.POP_STATE = "metabase/qb/POP_STATE";
	var popState = exports.popState = (0, _redux.createThunkAction)(POP_STATE, function (location) {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var card;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            card = getState().qb.card;
	
	                            if (location.state && location.state.card) {
	                                if (!_utils2.default.equals(card, location.state.card)) {
	                                    dispatch(setCardAndRun(location.state.card, false));
	                                    dispatch(setCurrentState(location.state));
	                                }
	                            }
	
	                        case 2:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var CREATE_PUBLIC_LINK = exports.CREATE_PUBLIC_LINK = "metabase/card/CREATE_PUBLIC_LINK";
	var createPublicLink = exports.createPublicLink = (0, _reduxActions.createAction)(CREATE_PUBLIC_LINK, function (_ref2) {
	    var id = _ref2.id;
	    return _services.CardApi.createPublicLink({ id: id });
	});
	
	var DELETE_PUBLIC_LINK = exports.DELETE_PUBLIC_LINK = "metabase/card/DELETE_PUBLIC_LINK";
	var deletePublicLink = exports.deletePublicLink = (0, _reduxActions.createAction)(DELETE_PUBLIC_LINK, function (_ref3) {
	    var id = _ref3.id;
	    return _services.CardApi.deletePublicLink({ id: id });
	});
	
	var UPDATE_ENABLE_EMBEDDING = exports.UPDATE_ENABLE_EMBEDDING = "metabase/card/UPDATE_ENABLE_EMBEDDING";
	var updateEnableEmbedding = exports.updateEnableEmbedding = (0, _reduxActions.createAction)(UPDATE_ENABLE_EMBEDDING, function (_ref4, enable_embedding) {
	    var id = _ref4.id;
	    return _services.CardApi.update({ id: id, enable_embedding: enable_embedding });
	});
	
	var UPDATE_EMBEDDING_PARAMS = exports.UPDATE_EMBEDDING_PARAMS = "metabase/card/UPDATE_EMBEDDING_PARAMS";
	var updateEmbeddingParams = exports.updateEmbeddingParams = (0, _reduxActions.createAction)(UPDATE_EMBEDDING_PARAMS, function (_ref5, embedding_params) {
	    var id = _ref5.id;
	    return _services.CardApi.update({ id: id, embedding_params: embedding_params });
	});
	
	// TODO Atte Keinänen 6/8/17: Should use the stored question by default instead of requiring an explicit `card` parameter
	var UPDATE_URL = exports.UPDATE_URL = "metabase/qb/UPDATE_URL";
	var updateUrl = exports.updateUrl = (0, _redux.createThunkAction)(UPDATE_URL, function (card, _ref6) {
	    var _ref6$dirty = _ref6.dirty,
	        dirty = _ref6$dirty === undefined ? false : _ref6$dirty,
	        _ref6$replaceState = _ref6.replaceState,
	        replaceState = _ref6$replaceState === undefined ? false : _ref6$replaceState,
	        _ref6$preserveParamet = _ref6.preserveParameters,
	        preserveParameters = _ref6$preserveParamet === undefined ? true : _ref6$preserveParamet;
	    return function (dispatch, getState) {
	        if (!card) {
	            return;
	        }
	        var copy = (0, _card.cleanCopyCard)(card);
	        var newState = {
	            card: copy,
	            cardId: copy.id,
	            serializedCard: (0, _card.serializeCardForUrl)(copy)
	        };
	
	        var currentState = getState().qb.currentState;
	
	
	        if (_utils2.default.equals(currentState, newState)) {
	            return;
	        }
	
	        var url = (0, _card.urlForCardState)(newState, dirty);
	
	        // if the serialized card is identical replace the previous state instead of adding a new one
	        // e.x. when saving a new card we want to replace the state and URL with one with the new card ID
	        replaceState = replaceState || currentState && currentState.serializedCard === newState.serializedCard;
	
	        var urlParsed = (0, _url.parse)(url);
	        var locationDescriptor = {
	            pathname: urlParsed.pathname,
	            search: preserveParameters ? window.location.search : "",
	            hash: urlParsed.hash,
	            state: newState
	        };
	
	        if (locationDescriptor.pathname === window.location.pathname && (locationDescriptor.search || "") === (window.location.search || "") && (locationDescriptor.hash || "") === (window.location.hash || "")) {
	            replaceState = true;
	        }
	
	        // this is necessary because we can't get the state from history.state
	        dispatch(setCurrentState(newState));
	        if (replaceState) {
	            dispatch((0, _reactRouterRedux.replace)(locationDescriptor));
	        } else {
	            dispatch((0, _reactRouterRedux.push)(locationDescriptor));
	        }
	    };
	});
	
	var REDIRECT_TO_NEW_QUESTION_FLOW = exports.REDIRECT_TO_NEW_QUESTION_FLOW = "metabase/qb/REDIRECT_TO_NEW_QUESTION_FLOW";
	var redirectToNewQuestionFlow = exports.redirectToNewQuestionFlow = (0, _redux.createThunkAction)(REDIRECT_TO_NEW_QUESTION_FLOW, function () {
	    return function (dispatch, getState) {
	        return dispatch((0, _reactRouterRedux.replace)("/question/new"));
	    };
	});
	
	var RESET_QB = exports.RESET_QB = "metabase/qb/RESET_QB";
	var resetQB = exports.resetQB = (0, _reduxActions.createAction)(RESET_QB);
	
	var INITIALIZE_QB = exports.INITIALIZE_QB = "metabase/qb/INITIALIZE_QB";
	var initializeQB = exports.initializeQB = function initializeQB(location, params) {
	    return function () {
	        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var _getState, currentUser, card, databasesList, originalCard, uiControls, options, serializedCard, hash, sampleDataset, preserveParameters, databaseId, question, originalQuestion;
	
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	
	                            // do this immediately to ensure old state is cleared before the user sees it
	                            dispatch(resetQB());
	                            dispatch(cancelQuery());
	
	                            _getState = getState(), currentUser = _getState.currentUser;
	                            card = void 0, databasesList = void 0, originalCard = void 0;
	                            uiControls = {
	                                isEditing: false,
	                                isShowingTemplateTagsEditor: false
	                            };
	
	                            // always start the QB by loading up the databases for the application
	
	                            _context2.prev = 5;
	                            _context2.next = 8;
	                            return dispatch((0, _metadata2.fetchDatabases)());
	
	                        case 8:
	                            databasesList = (0, _metadata.getDatabasesList)(getState());
	                            _context2.next = 16;
	                            break;
	
	                        case 11:
	                            _context2.prev = 11;
	                            _context2.t0 = _context2["catch"](5);
	
	                            console.error("error fetching dbs", _context2.t0);
	
	                            // if we can't actually get the databases list then bail now
	                            dispatch((0, _app.setErrorPage)(_context2.t0));
	
	                            return _context2.abrupt("return", { uiControls: uiControls });
	
	                        case 16:
	
	                            // load up or initialize the card we'll be working on
	                            options = {};
	                            serializedCard = void 0;
	                            // hash can contain either query params starting with ? or a base64 serialized card
	
	                            if (location.hash) {
	                                hash = location.hash.replace(/^#/, "");
	
	                                if (hash.charAt(0) === "?") {
	                                    options = _querystring2.default.parse(hash.substring(1));
	                                } else {
	                                    serializedCard = hash;
	                                }
	                            }
	                            sampleDataset = _underscore2.default.findWhere(databasesList, { is_sample: true });
	                            preserveParameters = false;
	
	                            if (!(params.cardId || serializedCard)) {
	                                _context2.next = 51;
	                                break;
	                            }
	
	                            _context2.prev = 22;
	
	                            // if we have a serialized card then unpack it and use it
	                            card = serializedCard ? (0, _card.deserializeCardFromUrl)(serializedCard) : {};
	
	                            // load the card either from `cardId` parameter or the serialized card
	
	                            if (!params.cardId) {
	                                _context2.next = 32;
	                                break;
	                            }
	
	                            _context2.next = 27;
	                            return (0, _card.loadCard)(params.cardId);
	
	                        case 27:
	                            card = _context2.sent;
	
	                            // when we are loading from a card id we want an explicit clone of the card we loaded which is unmodified
	                            originalCard = _utils2.default.copy(card);
	                            // for showing the "started from" lineage correctly when adding filters/breakouts and when going back and forth
	                            // in browser history, the original_card_id has to be set for the current card (simply the id of card itself for now)
	                            card.original_card_id = card.id;
	                            _context2.next = 37;
	                            break;
	
	                        case 32:
	                            if (!card.original_card_id) {
	                                _context2.next = 37;
	                                break;
	                            }
	
	                            _context2.next = 35;
	                            return (0, _card.loadCard)(card.original_card_id);
	
	                        case 35:
	                            originalCard = _context2.sent;
	
	                            // if the cards are equal then show the original
	                            if ((0, _Card.cardIsEquivalent)(card, originalCard)) {
	                                card = _utils2.default.copy(originalCard);
	                            }
	
	                        case 37:
	
	                            _analytics2.default.trackEvent("QueryBuilder", "Query Loaded", card.dataset_query.type);
	
	                            // if we have deserialized card from the url AND loaded a card by id then the user should be dropped into edit mode
	                            uiControls.isEditing = !!options.edit;
	
	                            // if this is the users first time loading a saved card on the QB then show them the newb modal
	                            if (params.cardId && currentUser.is_qbnewb) {
	                                uiControls.isShowingNewbModal = true;
	                                _analytics2.default.trackEvent("QueryBuilder", "Show Newb Modal");
	                            }
	
	                            if (card.archived) {
	                                // use the error handler in App.jsx for showing "This question has been archived" message
	                                dispatch((0, _app.setErrorPage)({
	                                    data: {
	                                        error_code: "archived"
	                                    },
	                                    context: "query-builder"
	                                }));
	                                card = null;
	                            }
	
	                            preserveParameters = true;
	                            _context2.next = 49;
	                            break;
	
	                        case 44:
	                            _context2.prev = 44;
	                            _context2.t1 = _context2["catch"](22);
	
	                            console.warn('initializeQb failed because of an error:', _context2.t1);
	                            card = null;
	                            dispatch((0, _app.setErrorPage)(_context2.t1));
	
	                        case 49:
	                            _context2.next = 67;
	                            break;
	
	                        case 51:
	                            if (!(options.tutorial !== undefined && sampleDataset)) {
	                                _context2.next = 57;
	                                break;
	                            }
	
	                            // we are launching the QB tutorial
	                            card = (0, _card.startNewCard)("query", sampleDataset.id);
	
	                            uiControls.isShowingTutorial = true;
	                            _analytics2.default.trackEvent("QueryBuilder", "Tutorial Start", true);
	
	                            _context2.next = 67;
	                            break;
	
	                        case 57:
	                            if (!(!options.db && !options.table && !options.segment && !options.metric)) {
	                                _context2.next = 61;
	                                break;
	                            }
	
	                            _context2.next = 60;
	                            return dispatch(redirectToNewQuestionFlow());
	
	                        case 60:
	                            return _context2.abrupt("return");
	
	                        case 61:
	                            databaseId = options.db ? parseInt(options.db) : undefined;
	
	                            card = (0, _card.startNewCard)("query", databaseId);
	
	                            // initialize parts of the query based on optional parameters supplied
	                            if (options.table != undefined && card.dataset_query.query) {
	                                card.dataset_query.query.source_table = parseInt(options.table);
	                            }
	
	                            if (options.segment != undefined && card.dataset_query.query) {
	                                card.dataset_query.query.filter = ["AND", ["SEGMENT", parseInt(options.segment)]];
	                            }
	
	                            if (options.metric != undefined && card.dataset_query.query) {
	                                card.dataset_query.query.aggregation = ["METRIC", parseInt(options.metric)];
	                            }
	
	                            _analytics2.default.trackEvent("QueryBuilder", "Query Started", card.dataset_query.type);
	
	                        case 67:
	
	                            /**** All actions are dispatched here ****/
	
	                            // Update the question to Redux state together with the initial state of UI controls
	                            dispatch.action(INITIALIZE_QB, {
	                                card: card,
	                                originalCard: originalCard,
	                                uiControls: uiControls
	                            });
	
	                            // Fetch the question metadata
	                            card && dispatch(loadMetadataForCard(card));
	
	                            question = card && new _Question2.default((0, _metadata.getMetadata)(getState()), card);
	
	                            // if we have loaded up a card that we can run then lets kick that off as well
	
	                            if (question) {
	                                if (question.canRun()) {
	                                    // NOTE: timeout to allow Parameters widget to set parameterValues
	                                    setTimeout(function () {
	                                        return (
	                                            // TODO Atte Keinänen 5/31/17: Check if it is dangerous to create a question object without metadata
	                                            dispatch(runQuestionQuery({ shouldUpdateUrl: false }))
	                                        );
	                                    }, 0);
	                                }
	
	                                // clean up the url and make sure it reflects our card state
	                                originalQuestion = originalCard && new _Question2.default((0, _metadata.getMetadata)(getState()), originalCard);
	
	                                dispatch(updateUrl(card, {
	                                    dirty: !originalQuestion || originalQuestion && question.isDirtyComparedTo(originalQuestion),
	                                    replaceState: true,
	                                    preserveParameters: preserveParameters
	                                }));
	                            }
	
	                        case 71:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[5, 11], [22, 44]]);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref7.apply(this, arguments);
	        };
	    }();
	};
	
	var TOGGLE_DATA_REFERENCE = exports.TOGGLE_DATA_REFERENCE = "metabase/qb/TOGGLE_DATA_REFERENCE";
	var toggleDataReference = exports.toggleDataReference = (0, _reduxActions.createAction)(TOGGLE_DATA_REFERENCE, function () {
	    _analytics2.default.trackEvent("QueryBuilder", "Toggle Data Reference");
	});
	
	var TOGGLE_TEMPLATE_TAGS_EDITOR = exports.TOGGLE_TEMPLATE_TAGS_EDITOR = "metabase/qb/TOGGLE_TEMPLATE_TAGS_EDITOR";
	var toggleTemplateTagsEditor = exports.toggleTemplateTagsEditor = (0, _reduxActions.createAction)(TOGGLE_TEMPLATE_TAGS_EDITOR, function () {
	    _analytics2.default.trackEvent("QueryBuilder", "Toggle Template Tags Editor");
	});
	
	var SET_IS_SHOWING_TEMPLATE_TAGS_EDITOR = exports.SET_IS_SHOWING_TEMPLATE_TAGS_EDITOR = "metabase/qb/SET_IS_SHOWING_TEMPLATE_TAGS_EDITOR";
	var setIsShowingTemplateTagsEditor = exports.setIsShowingTemplateTagsEditor = function setIsShowingTemplateTagsEditor(isShowingTemplateTagsEditor) {
	    return {
	        type: SET_IS_SHOWING_TEMPLATE_TAGS_EDITOR,
	        isShowingTemplateTagsEditor: isShowingTemplateTagsEditor
	    };
	};
	
	var CLOSE_QB_TUTORIAL = exports.CLOSE_QB_TUTORIAL = "metabase/qb/CLOSE_QB_TUTORIAL";
	var closeQbTutorial = exports.closeQbTutorial = (0, _reduxActions.createAction)(CLOSE_QB_TUTORIAL, function () {
	    _analytics2.default.trackEvent("QueryBuilder", "Tutorial Close");
	});
	
	var CLOSE_QB_NEWB_MODAL = exports.CLOSE_QB_NEWB_MODAL = "metabase/qb/CLOSE_QB_NEWB_MODAL";
	var closeQbNewbModal = exports.closeQbNewbModal = (0, _redux.createThunkAction)(CLOSE_QB_NEWB_MODAL, function () {
	    return function () {
	        var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            var _getState2, currentUser;
	
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            // persist the fact that this user has seen the NewbModal
	                            _getState2 = getState(), currentUser = _getState2.currentUser;
	                            _context3.next = 3;
	                            return _services.UserApi.update_qbnewb({ id: currentUser.id });
	
	                        case 3:
	                            _analytics2.default.trackEvent('QueryBuilder', 'Close Newb Modal');
	
	                        case 4:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref8.apply(this, arguments);
	        };
	    }();
	});
	
	var BEGIN_EDITING = exports.BEGIN_EDITING = "metabase/qb/BEGIN_EDITING";
	var beginEditing = exports.beginEditing = (0, _reduxActions.createAction)(BEGIN_EDITING, function () {
	    _analytics2.default.trackEvent("QueryBuilder", "Edit Begin");
	});
	
	var CANCEL_EDITING = exports.CANCEL_EDITING = "metabase/qb/CANCEL_EDITING";
	var cancelEditing = exports.cancelEditing = (0, _redux.createThunkAction)(CANCEL_EDITING, function () {
	    return function (dispatch, getState) {
	        // clone
	        var card = _utils2.default.copy((0, _selectors.getOriginalCard)(getState()));
	
	        dispatch(loadMetadataForCard(card));
	
	        // we do this to force the indication of the fact that the card should not be considered dirty when the url is updated
	        dispatch(runQuestionQuery({ overrideWithCard: card, shouldUpdateUrl: false }));
	        dispatch(updateUrl(card, { dirty: false }));
	
	        _analytics2.default.trackEvent("QueryBuilder", "Edit Cancel");
	        return card;
	    };
	});
	
	// TODO Atte Keinänen 6/8/17: Could (should?) use the stored question by default instead of always requiring the explicit `card` parameter
	var LOAD_METADATA_FOR_CARD = exports.LOAD_METADATA_FOR_CARD = "metabase/qb/LOAD_METADATA_FOR_CARD";
	var loadMetadataForCard = exports.loadMetadataForCard = (0, _redux.createThunkAction)(LOAD_METADATA_FOR_CARD, function (card) {
	    return function () {
	        var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
	            var loadMetadataForAtomicQuery = function () {
	                var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(singleQuery) {
	                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                        while (1) {
	                            switch (_context4.prev = _context4.next) {
	                                case 0:
	                                    if (!(singleQuery instanceof _StructuredQuery2.default && singleQuery.tableId() != null)) {
	                                        _context4.next = 3;
	                                        break;
	                                    }
	
	                                    _context4.next = 3;
	                                    return dispatch(loadTableMetadata(singleQuery.tableId()));
	
	                                case 3:
	                                    if (!(singleQuery instanceof _NativeQuery2.default && singleQuery.databaseId() != null)) {
	                                        _context4.next = 6;
	                                        break;
	                                    }
	
	                                    _context4.next = 6;
	                                    return dispatch(loadDatabaseFields(singleQuery.databaseId()));
	
	                                case 6:
	                                case "end":
	                                    return _context4.stop();
	                            }
	                        }
	                    }, _callee4, this);
	                }));
	
	                return function loadMetadataForAtomicQuery(_x9) {
	                    return _ref10.apply(this, arguments);
	                };
	            }();
	
	            var query;
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            if (!(!card && !card.dataset_query)) {
	                                _context5.next = 2;
	                                break;
	                            }
	
	                            return _context5.abrupt("return");
	
	                        case 2:
	                            query = card && new _Question2.default((0, _metadata.getMetadata)(getState()), card).query();
	
	                            if (!query) {
	                                _context5.next = 6;
	                                break;
	                            }
	
	                            _context5.next = 6;
	                            return loadMetadataForAtomicQuery(query);
	
	                        case 6:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, undefined);
	        }));
	
	        return function (_x7, _x8) {
	            return _ref9.apply(this, arguments);
	        };
	    }();
	});
	
	var LOAD_TABLE_METADATA = exports.LOAD_TABLE_METADATA = "metabase/qb/LOAD_TABLE_METADATA";
	var loadTableMetadata = exports.loadTableMetadata = (0, _redux.createThunkAction)(LOAD_TABLE_METADATA, function (tableId) {
	    return function () {
	        var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
	            var foreignKeys;
	            return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            _context6.prev = 0;
	                            _context6.next = 3;
	                            return dispatch((0, _metadata2.fetchTableMetadata)(tableId));
	
	                        case 3:
	                            _context6.next = 5;
	                            return _services.MetabaseApi.table_fks({ tableId: tableId });
	
	                        case 5:
	                            foreignKeys = _context6.sent;
	                            return _context6.abrupt("return", { foreignKeys: foreignKeys });
	
	                        case 9:
	                            _context6.prev = 9;
	                            _context6.t0 = _context6["catch"](0);
	
	                            console.error('error getting table metadata', _context6.t0);
	                            return _context6.abrupt("return", {});
	
	                        case 13:
	                        case "end":
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, undefined, [[0, 9]]);
	        }));
	
	        return function (_x10, _x11) {
	            return _ref11.apply(this, arguments);
	        };
	    }();
	});
	
	// TODO Atte Keinänen 7/5/17: Move the API call to redux/metadata for being able to see the db fields in the new metadata object
	var LOAD_DATABASE_FIELDS = exports.LOAD_DATABASE_FIELDS = "metabase/qb/LOAD_DATABASE_FIELDS";
	var loadDatabaseFields = exports.loadDatabaseFields = (0, _redux.createThunkAction)(LOAD_DATABASE_FIELDS, function (dbId) {
	    return function () {
	        var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
	            var _getState3, databaseFields, fields;
	
	            return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            // if we already have the metadata loaded for the given table then we are done
	                            _getState3 = getState(), databaseFields = _getState3.qb.databaseFields;
	                            _context7.prev = 1;
	                            fields = void 0;
	
	                            if (!databaseFields[dbId]) {
	                                _context7.next = 7;
	                                break;
	                            }
	
	                            fields = databaseFields[dbId];
	                            _context7.next = 10;
	                            break;
	
	                        case 7:
	                            _context7.next = 9;
	                            return _services.MetabaseApi.db_fields({ dbId: dbId });
	
	                        case 9:
	                            fields = _context7.sent;
	
	                        case 10:
	                            return _context7.abrupt("return", {
	                                id: dbId,
	                                fields: fields
	                            });
	
	                        case 13:
	                            _context7.prev = 13;
	                            _context7.t0 = _context7["catch"](1);
	
	                            console.error('error getting database fields', _context7.t0);
	                            return _context7.abrupt("return", {});
	
	                        case 17:
	                        case "end":
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, undefined, [[1, 13]]);
	        }));
	
	        return function (_x12, _x13) {
	            return _ref12.apply(this, arguments);
	        };
	    }();
	});
	
	function updateVisualizationSettings(card, isEditing, display, vizSettings) {
	    // don't need to store undefined
	    vizSettings = _utils2.default.copy(vizSettings);
	    for (var name in vizSettings) {
	        if (vizSettings[name] === undefined) {
	            delete vizSettings[name];
	        }
	    }
	
	    // make sure that something actually changed
	    if (card.display === display && _underscore2.default.isEqual(card.visualization_settings, vizSettings)) return card;
	
	    var updatedCard = _utils2.default.copy(card);
	
	    // when the visualization changes on saved card we change this into a new card w/ a known starting point
	    if (!isEditing && updatedCard.id) {
	        delete updatedCard.id;
	        delete updatedCard.name;
	        delete updatedCard.description;
	    }
	
	    updatedCard.display = display;
	    updatedCard.visualization_settings = vizSettings;
	
	    return updatedCard;
	}
	
	var SET_CARD_ATTRIBUTE = exports.SET_CARD_ATTRIBUTE = "metabase/qb/SET_CARD_ATTRIBUTE";
	var setCardAttribute = exports.setCardAttribute = (0, _reduxActions.createAction)(SET_CARD_ATTRIBUTE, function (attr, value) {
	    return { attr: attr, value: value };
	});
	
	var SET_CARD_VISUALIZATION = exports.SET_CARD_VISUALIZATION = "metabase/qb/SET_CARD_VISUALIZATION";
	var setCardVisualization = exports.setCardVisualization = (0, _redux.createThunkAction)(SET_CARD_VISUALIZATION, function (display) {
	    return function (dispatch, getState) {
	        var _getState4 = getState(),
	            _getState4$qb = _getState4.qb,
	            card = _getState4$qb.card,
	            uiControls = _getState4$qb.uiControls;
	
	        var updatedCard = updateVisualizationSettings(card, uiControls.isEditing, display, card.visualization_settings);
	        dispatch(updateUrl(updatedCard, { dirty: true }));
	        return updatedCard;
	    };
	});
	
	var UPDATE_CARD_VISUALIZATION_SETTINGS = exports.UPDATE_CARD_VISUALIZATION_SETTINGS = "metabase/qb/UPDATE_CARD_VISUALIZATION_SETTINGS";
	var updateCardVisualizationSettings = exports.updateCardVisualizationSettings = (0, _redux.createThunkAction)(UPDATE_CARD_VISUALIZATION_SETTINGS, function (settings) {
	    return function (dispatch, getState) {
	        var _getState5 = getState(),
	            _getState5$qb = _getState5.qb,
	            card = _getState5$qb.card,
	            uiControls = _getState5$qb.uiControls;
	
	        var updatedCard = updateVisualizationSettings(card, uiControls.isEditing, card.display, _extends({}, card.visualization_settings, settings));
	        dispatch(updateUrl(updatedCard, { dirty: true }));
	        return updatedCard;
	    };
	});
	
	var REPLACE_ALL_CARD_VISUALIZATION_SETTINGS = exports.REPLACE_ALL_CARD_VISUALIZATION_SETTINGS = "metabase/qb/REPLACE_ALL_CARD_VISUALIZATION_SETTINGS";
	var replaceAllCardVisualizationSettings = exports.replaceAllCardVisualizationSettings = (0, _redux.createThunkAction)(REPLACE_ALL_CARD_VISUALIZATION_SETTINGS, function (settings) {
	    return function (dispatch, getState) {
	        var _getState6 = getState(),
	            _getState6$qb = _getState6.qb,
	            card = _getState6$qb.card,
	            uiControls = _getState6$qb.uiControls;
	
	        var updatedCard = updateVisualizationSettings(card, uiControls.isEditing, card.display, settings);
	        dispatch(updateUrl(updatedCard, { dirty: true }));
	        return updatedCard;
	    };
	});
	
	var UPDATE_TEMPLATE_TAG = exports.UPDATE_TEMPLATE_TAG = "metabase/qb/UPDATE_TEMPLATE_TAG";
	var updateTemplateTag = exports.updateTemplateTag = (0, _redux.createThunkAction)(UPDATE_TEMPLATE_TAG, function (templateTag) {
	    return function (dispatch, getState) {
	        var _getState7 = getState(),
	            _getState7$qb = _getState7.qb,
	            card = _getState7$qb.card,
	            uiControls = _getState7$qb.uiControls;
	
	        var updatedCard = _utils2.default.copy(card);
	
	        // when the query changes on saved card we change this into a new query w/ a known starting point
	        if (!uiControls.isEditing && updatedCard.id) {
	            delete updatedCard.id;
	            delete updatedCard.name;
	            delete updatedCard.description;
	        }
	
	        return (0, _icepick.assocIn)(updatedCard, ["dataset_query", "native", "template_tags", templateTag.name], templateTag);
	    };
	});
	
	var SET_PARAMETER_VALUE = exports.SET_PARAMETER_VALUE = "metabase/qb/SET_PARAMETER_VALUE";
	var setParameterValue = exports.setParameterValue = (0, _reduxActions.createAction)(SET_PARAMETER_VALUE, function (parameterId, value) {
	    return { id: parameterId, value: value };
	});
	
	var NOTIFY_CARD_CREATED = exports.NOTIFY_CARD_CREATED = "metabase/qb/NOTIFY_CARD_CREATED";
	var notifyCardCreatedFn = exports.notifyCardCreatedFn = (0, _redux.createThunkAction)(NOTIFY_CARD_CREATED, function (card) {
	    return function (dispatch, getState) {
	        dispatch(updateUrl(card, { dirty: false }));
	
	        _analytics2.default.trackEvent("QueryBuilder", "Create Card", card.dataset_query.type);
	
	        return card;
	    };
	});
	
	var NOTIFY_CARD_UPDATED = exports.NOTIFY_CARD_UPDATED = "metabase/qb/NOTIFY_CARD_UPDATED";
	var notifyCardUpdatedFn = exports.notifyCardUpdatedFn = (0, _redux.createThunkAction)(NOTIFY_CARD_UPDATED, function (card) {
	    return function (dispatch, getState) {
	        dispatch(updateUrl(card, { dirty: false }));
	
	        _analytics2.default.trackEvent("QueryBuilder", "Update Card", card.dataset_query.type);
	
	        return card;
	    };
	});
	
	// reloadCard
	var RELOAD_CARD = exports.RELOAD_CARD = "metabase/qb/RELOAD_CARD";
	var reloadCard = exports.reloadCard = (0, _redux.createThunkAction)(RELOAD_CARD, function () {
	    return function () {
	        var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(dispatch, getState) {
	            var card;
	            return regeneratorRuntime.wrap(function _callee8$(_context8) {
	                while (1) {
	                    switch (_context8.prev = _context8.next) {
	                        case 0:
	                            // clone
	                            card = _utils2.default.copy((0, _selectors.getOriginalCard)(getState()));
	
	
	                            dispatch(loadMetadataForCard(card));
	
	                            // we do this to force the indication of the fact that the card should not be considered dirty when the url is updated
	                            dispatch(runQuestionQuery({ overrideWithCard: card, shouldUpdateUrl: false }));
	                            dispatch(updateUrl(card, { dirty: false }));
	
	                            return _context8.abrupt("return", card);
	
	                        case 5:
	                        case "end":
	                            return _context8.stop();
	                    }
	                }
	            }, _callee8, undefined);
	        }));
	
	        return function (_x14, _x15) {
	            return _ref13.apply(this, arguments);
	        };
	    }();
	});
	
	/**
	 * `setCardAndRun` is used when:
	 *     - navigating browser history
	 *     - clicking in the entity details view
	 *     - `navigateToNewCardInsideQB` is being called (see below)
	 */
	var SET_CARD_AND_RUN = exports.SET_CARD_AND_RUN = "metabase/qb/SET_CARD_AND_RUN";
	var setCardAndRun = exports.setCardAndRun = function setCardAndRun(nextCard) {
	    var shouldUpdateUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    return function () {
	        var _ref14 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState) {
	            var card, originalCard;
	            return regeneratorRuntime.wrap(function _callee9$(_context9) {
	                while (1) {
	                    switch (_context9.prev = _context9.next) {
	                        case 0:
	                            // clone
	                            card = _utils2.default.copy(nextCard);
	
	                            if (!card.original_card_id) {
	                                _context9.next = 7;
	                                break;
	                            }
	
	                            _context9.next = 4;
	                            return (0, _card.loadCard)(card.original_card_id);
	
	                        case 4:
	                            _context9.t0 = _context9.sent;
	                            _context9.next = 8;
	                            break;
	
	                        case 7:
	                            _context9.t0 =
	                            // Otherwise, use a current card as the original card if the card has been saved
	                            // This is needed for checking whether the card is in dirty state or not
	                            card.id ? card : null;
	
	                        case 8:
	                            originalCard = _context9.t0;
	
	
	                            // Update the card and originalCard before running the actual query
	                            dispatch.action(SET_CARD_AND_RUN, { card: card, originalCard: originalCard });
	                            dispatch(runQuestionQuery({ shouldUpdateUrl: shouldUpdateUrl }));
	
	                            // Load table & database metadata for the current question
	                            dispatch(loadMetadataForCard(card));
	
	                        case 12:
	                        case "end":
	                            return _context9.stop();
	                    }
	                }
	            }, _callee9, undefined);
	        }));
	
	        return function (_x17, _x18) {
	            return _ref14.apply(this, arguments);
	        };
	    }();
	};
	
	/**
	 * User-triggered events that are handled with this action:
	 *     - clicking a legend:
	 *         * series legend (multi-aggregation, multi-breakout, multiple questions)
	 *     - clicking the visualization itself
	 *         * drill-through (single series, multi-aggregation, multi-breakout, multiple questions)
	 *         * (not in 0.24.2 yet: drag on line/area/bar visualization)
	 *     - clicking an action widget action
	 *
	 * All these events can be applied either for an unsaved question or a saved question.
	 */
	var NAVIGATE_TO_NEW_CARD = exports.NAVIGATE_TO_NEW_CARD = "metabase/qb/NAVIGATE_TO_NEW_CARD";
	var navigateToNewCardInsideQB = exports.navigateToNewCardInsideQB = (0, _redux.createThunkAction)(NAVIGATE_TO_NEW_CARD, function (_ref15) {
	    var nextCard = _ref15.nextCard,
	        previousCard = _ref15.previousCard;
	
	    return function () {
	        var _ref16 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(dispatch, getState) {
	            var nextCardIsClean;
	            return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                while (1) {
	                    switch (_context10.prev = _context10.next) {
	                        case 0:
	                            nextCardIsClean = _underscore2.default.isEqual(previousCard.dataset_query, nextCard.dataset_query) && previousCard.display === nextCard.display;
	
	                            if (!nextCardIsClean) {
	                                _context10.next = 11;
	                                break;
	                            }
	
	                            _context10.t0 = dispatch;
	                            _context10.t1 = setCardAndRun;
	                            _context10.next = 6;
	                            return (0, _card.loadCard)(nextCard.id);
	
	                        case 6:
	                            _context10.t2 = _context10.sent;
	                            _context10.t3 = (0, _context10.t1)(_context10.t2);
	                            (0, _context10.t0)(_context10.t3);
	                            _context10.next = 12;
	                            break;
	
	                        case 11:
	                            dispatch(setCardAndRun((0, _utils3.getCardAfterVisualizationClick)(nextCard, previousCard)));
	
	                        case 12:
	                        case "end":
	                            return _context10.stop();
	                    }
	                }
	            }, _callee10, undefined);
	        }));
	
	        return function (_x19, _x20) {
	            return _ref16.apply(this, arguments);
	        };
	    }();
	});
	
	// TODO Atte Keinänen 6/2/2017 See if we should stick to `updateX` naming convention instead of `setX` in all Redux actions
	// We talked with Tom that `setX` method names could be reserved to metabase-lib classes
	
	/**
	 * Replaces the currently actived question with the given Question object.
	 * Also shows/hides the template tag editor if the number of template tags has changed.
	 */
	var UPDATE_QUESTION = exports.UPDATE_QUESTION = "metabase/qb/UPDATE_QUESTION";
	var updateQuestion = exports.updateQuestion = function updateQuestion(newQuestion) {
	    return function (dispatch, getState) {
	        // TODO Atte Keinänen 6/2/2017 Ways to have this happen automatically when modifying a question?
	        // Maybe the Question class or a QB-specific question wrapper class should know whether it's being edited or not?
	        if (!(0, _selectors.getIsEditing)(getState()) && newQuestion.isSaved()) {
	            newQuestion = newQuestion.withoutNameAndId();
	        }
	
	        // Replace the current question with a new one
	        dispatch.action(UPDATE_QUESTION, { card: newQuestion.card() });
	
	        // See if the template tags editor should be shown/hidden
	        var oldQuestion = (0, _selectors.getQuestion)(getState());
	        var oldTagCount = getTemplateTagCount(oldQuestion);
	        var newTagCount = getTemplateTagCount(newQuestion);
	
	        if (newTagCount > oldTagCount) {
	            dispatch(setIsShowingTemplateTagsEditor(true));
	        } else if (newTagCount === 0 && !(0, _selectors.getIsShowingDataReference)(getState())) {
	            dispatch(setIsShowingTemplateTagsEditor(false));
	        }
	    };
	};
	
	// setDatasetQuery
	// TODO Atte Keinänen 6/1/17: Deprecated, superseded by updateQuestion
	var SET_DATASET_QUERY = exports.SET_DATASET_QUERY = "metabase/qb/SET_DATASET_QUERY";
	var setDatasetQuery = exports.setDatasetQuery = (0, _redux.createThunkAction)(SET_DATASET_QUERY, function (dataset_query) {
	    var run = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return function (dispatch, getState) {
	        var _getState8 = getState(),
	            uiControls = _getState8.qb.uiControls;
	
	        var question = (0, _selectors.getQuestion)(getState());
	
	        var newQuestion = question;
	
	        // when the query changes on saved card we change this into a new query w/ a known starting point
	        if (!uiControls.isEditing && question.isSaved()) {
	            newQuestion = newQuestion.withoutNameAndId();
	        }
	
	        newQuestion = newQuestion.setDatasetQuery(dataset_query);
	
	        var oldTagCount = getTemplateTagCount(question);
	        var newTagCount = getTemplateTagCount(newQuestion);
	
	        var openTemplateTagsEditor = uiControls.isShowingTemplateTagsEditor;
	        if (newTagCount > oldTagCount) {
	            openTemplateTagsEditor = true;
	        } else if (newTagCount === 0) {
	            openTemplateTagsEditor = false;
	        }
	
	        // run updated query
	        if (run) {
	            dispatch(runQuestionQuery({ overrideWithCard: newQuestion.card() }));
	        }
	
	        return {
	            card: newQuestion.card(),
	            openTemplateTagsEditor: openTemplateTagsEditor
	        };
	    };
	});
	
	// setQueryMode
	var SET_QUERY_MODE = exports.SET_QUERY_MODE = "metabase/qb/SET_QUERY_MODE";
	var setQueryMode = exports.setQueryMode = (0, _redux.createThunkAction)(SET_QUERY_MODE, function (type) {
	    return function (dispatch, getState) {
	        // TODO Atte Keinänen 6/1/17: Should use `queryResults` instead
	        var _getState9 = getState(),
	            _getState9$qb = _getState9.qb,
	            card = _getState9$qb.card,
	            queryResult = _getState9$qb.queryResult,
	            uiControls = _getState9$qb.uiControls;
	
	        var tableMetadata = (0, _selectors.getTableMetadata)(getState());
	
	        // if the type didn't actually change then nothing has been modified
	        if (type === card.dataset_query.type) {
	            return card;
	        }
	
	        // if we are going from MBQL -> Native then attempt to carry over the query
	        if (type === "native" && queryResult && queryResult.data && queryResult.data.native_form) {
	            var updatedCard = _utils2.default.copy(card);
	            var datasetQuery = updatedCard.dataset_query;
	            var nativeQuery = _underscore2.default.pick(queryResult.data.native_form, "query", "collection");
	
	            // when the driver requires JSON we need to stringify it because it's been parsed already
	            if ((0, _engine.getEngineNativeType)(tableMetadata.db.engine) === "json") {
	                nativeQuery.query = (0, _engine.formatJsonQuery)(queryResult.data.native_form.query, tableMetadata.db.engine);
	            } else {
	                nativeQuery.query = (0, _formatting.formatSQL)(nativeQuery.query);
	            }
	
	            datasetQuery.type = "native";
	            datasetQuery.native = nativeQuery;
	            delete datasetQuery.query;
	
	            // when the query changes on saved card we change this into a new query w/ a known starting point
	            if (!uiControls.isEditing && updatedCard.id) {
	                delete updatedCard.id;
	                delete updatedCard.name;
	                delete updatedCard.description;
	            }
	
	            updatedCard.dataset_query = datasetQuery;
	
	            dispatch(loadMetadataForCard(updatedCard));
	
	            _analytics2.default.trackEvent("QueryBuilder", "MBQL->Native");
	
	            return updatedCard;
	
	            // we are translating an empty query
	        } else {
	            var databaseId = card.dataset_query.database;
	
	            // only carry over the database id if the user can write native queries
	            if (type === "native") {
	                var nativeDatabases = (0, _selectors.getNativeDatabases)(getState());
	                if (!_underscore2.default.findWhere(nativeDatabases, { id: databaseId })) {
	                    databaseId = nativeDatabases.length > 0 ? nativeDatabases[0].id : null;
	                }
	            }
	
	            var newCard = (0, _card.startNewCard)(type, databaseId);
	
	            dispatch(loadMetadataForCard(newCard));
	
	            return newCard;
	        }
	    };
	});
	
	// TODO Atte Keinänen: The heavy lifting should be moved to StructuredQuery and NativeQuery
	// Question.js could possibly provide a helper method like `Question.setDatabaseId` that delegates it to respective query classes
	
	// setQueryDatabase
	var SET_QUERY_DATABASE = exports.SET_QUERY_DATABASE = "metabase/qb/SET_QUERY_DATABASE";
	var setQueryDatabase = exports.setQueryDatabase = (0, _redux.createThunkAction)(SET_QUERY_DATABASE, function (databaseId) {
	    return function () {
	        var _ref17 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(dispatch, getState) {
	            var _getState10, _getState10$qb, card, uiControls, databases, existingQuery, updatedCard, database, tables, table, _updatedCard;
	
	            return regeneratorRuntime.wrap(function _callee11$(_context11) {
	                while (1) {
	                    switch (_context11.prev = _context11.next) {
	                        case 0:
	                            _getState10 = getState(), _getState10$qb = _getState10.qb, card = _getState10$qb.card, uiControls = _getState10$qb.uiControls;
	                            databases = (0, _metadata.getDatabases)(getState());
	
	                            // picking the same database doesn't change anything
	
	                            if (!(databaseId === card.dataset_query.database)) {
	                                _context11.next = 4;
	                                break;
	                            }
	
	                            return _context11.abrupt("return", card);
	
	                        case 4:
	                            existingQuery = card.dataset_query.native ? card.dataset_query.native.query : undefined;
	
	                            if (uiControls.isEditing) {
	                                _context11.next = 13;
	                                break;
	                            }
	
	                            updatedCard = (0, _card.startNewCard)(card.dataset_query.type, databaseId);
	
	                            if (existingQuery) {
	                                updatedCard.dataset_query.native.query = existingQuery;
	                                updatedCard.dataset_query.native.template_tags = card.dataset_query.native.template_tags;
	                            }
	
	                            // set the initial collection for the query if this is a native query
	                            // this is only used for Mongo queries which need to be ran against a specific collection
	                            if (updatedCard.dataset_query.type === 'native') {
	                                database = databases[databaseId], tables = database ? database.tables : [], table = tables.length > 0 ? tables[0] : null;
	
	                                if (table) updatedCard.dataset_query.native.collection = table.name;
	                            }
	
	                            dispatch(loadMetadataForCard(updatedCard));
	
	                            return _context11.abrupt("return", updatedCard);
	
	                        case 13:
	                            // if we are editing a saved query we don't want to replace the card, so just start a fresh query only
	                            // TODO: should this clear the visualization as well?
	                            _updatedCard = _utils2.default.copy(card);
	
	                            _updatedCard.dataset_query = (0, _query.createQuery)(card.dataset_query.type, databaseId);
	                            if (existingQuery) {
	                                _updatedCard.dataset_query.native.query = existingQuery;
	                                _updatedCard.dataset_query.native.template_tags = card.dataset_query.native.template_tags;
	                            }
	
	                            dispatch(loadMetadataForCard(_updatedCard));
	
	                            return _context11.abrupt("return", _updatedCard);
	
	                        case 18:
	                        case "end":
	                            return _context11.stop();
	                    }
	                }
	            }, _callee11, undefined);
	        }));
	
	        return function (_x22, _x23) {
	            return _ref17.apply(this, arguments);
	        };
	    }();
	});
	
	// TODO Atte Keinänen: The heavy lifting should be moved to StructuredQuery and NativeQuery
	// Question.js could possibly provide a helper method like `Question.setSourceTable` that delegates it to respective query classes
	
	// setQuerySourceTable
	var SET_QUERY_SOURCE_TABLE = exports.SET_QUERY_SOURCE_TABLE = "metabase/qb/SET_QUERY_SOURCE_TABLE";
	var setQuerySourceTable = exports.setQuerySourceTable = (0, _redux.createThunkAction)(SET_QUERY_SOURCE_TABLE, function (sourceTable) {
	    return function () {
	        var _ref18 = _asyncToGenerator(regeneratorRuntime.mark(function _callee12(dispatch, getState) {
	            var _getState11, _getState11$qb, card, uiControls, tableId, databaseId, table, query, updatedCard;
	
	            return regeneratorRuntime.wrap(function _callee12$(_context12) {
	                while (1) {
	                    switch (_context12.prev = _context12.next) {
	                        case 0:
	                            _getState11 = getState(), _getState11$qb = _getState11.qb, card = _getState11$qb.card, uiControls = _getState11$qb.uiControls;
	
	                            // this will either be the id or an object with an id
	
	                            tableId = sourceTable.id || sourceTable;
	
	                            // if the table didn't actually change then nothing is modified
	
	                            if (!(tableId === card.dataset_query.query.source_table)) {
	                                _context12.next = 4;
	                                break;
	                            }
	
	                            return _context12.abrupt("return", card);
	
	                        case 4:
	
	                            // load up all the table metadata via the api
	                            dispatch(loadTableMetadata(tableId));
	
	                            // find the database associated with this table
	                            databaseId = void 0;
	
	                            if (_underscore2.default.isObject(sourceTable)) {
	                                databaseId = sourceTable.db_id;
	                            } else {
	                                table = (0, _metadata.getTables)(getState())[tableId];
	
	                                if (table) {
	                                    databaseId = table.db_id;
	                                }
	                            }
	
	                            if (uiControls.isEditing) {
	                                _context12.next = 11;
	                                break;
	                            }
	
	                            return _context12.abrupt("return", (0, _card.startNewCard)(card.dataset_query.type, databaseId, tableId));
	
	                        case 11:
	                            // if we are editing a saved query we don't want to replace the card, so just start a fresh query only
	                            // TODO: should this clear the visualization as well?
	                            query = (0, _query.createQuery)(card.dataset_query.type, databaseId, tableId);
	                            updatedCard = _utils2.default.copy(card);
	
	                            updatedCard.dataset_query = query;
	                            return _context12.abrupt("return", updatedCard);
	
	                        case 15:
	                        case "end":
	                            return _context12.stop();
	                    }
	                }
	            }, _callee12, undefined);
	        }));
	
	        return function (_x24, _x25) {
	            return _ref18.apply(this, arguments);
	        };
	    }();
	});
	
	function createQueryAction(action, updaterFunction, event) {
	    return (0, _redux.createThunkAction)(action, function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return function (dispatch, getState) {
	            var _getState12 = getState(),
	                card = _getState12.qb.card;
	
	            if (card.dataset_query.type === "query") {
	                var datasetQuery = _utils2.default.copy(card.dataset_query);
	                updaterFunction.apply(undefined, [datasetQuery.query].concat(args));
	                dispatch(setDatasetQuery(datasetQuery));
	                _analytics2.default.trackEvent.apply(_analytics2.default, _toConsumableArray(typeof event === "function" ? event.apply(undefined, args) : event));
	            }
	            return null;
	        };
	    });
	}
	
	var addQueryBreakout = exports.addQueryBreakout = createQueryAction("metabase/qb/ADD_QUERY_BREAKOUT", _query2.default.addBreakout, ["QueryBuilder", "Add GroupBy"]);
	var updateQueryBreakout = exports.updateQueryBreakout = createQueryAction("metabase/qb/UPDATE_QUERY_BREAKOUT", _query2.default.updateBreakout, ["QueryBuilder", "Modify GroupBy"]);
	var removeQueryBreakout = exports.removeQueryBreakout = createQueryAction("metabase/qb/REMOVE_QUERY_BREAKOUT", _query2.default.removeBreakout, ["QueryBuilder", "Remove GroupBy"]);
	// Exported for integration tests
	var ADD_QUERY_FILTER = exports.ADD_QUERY_FILTER = "metabase/qb/ADD_QUERY_FILTER";
	var addQueryFilter = exports.addQueryFilter = createQueryAction(ADD_QUERY_FILTER, _query2.default.addFilter, ["QueryBuilder", "Add Filter"]);
	var UPDATE_QUERY_FILTER = exports.UPDATE_QUERY_FILTER = "metabase/qb/UPDATE_QUERY_FILTER";
	var updateQueryFilter = exports.updateQueryFilter = createQueryAction(UPDATE_QUERY_FILTER, _query2.default.updateFilter, ["QueryBuilder", "Modify Filter"]);
	var REMOVE_QUERY_FILTER = exports.REMOVE_QUERY_FILTER = "metabase/qb/REMOVE_QUERY_FILTER";
	var removeQueryFilter = exports.removeQueryFilter = createQueryAction(REMOVE_QUERY_FILTER, _query2.default.removeFilter, ["QueryBuilder", "Remove Filter"]);
	var addQueryAggregation = exports.addQueryAggregation = createQueryAction("metabase/qb/ADD_QUERY_AGGREGATION", _query2.default.addAggregation, ["QueryBuilder", "Add Aggregation"]);
	var updateQueryAggregation = exports.updateQueryAggregation = createQueryAction("metabase/qb/UPDATE_QUERY_AGGREGATION", _query2.default.updateAggregation, ["QueryBuilder", "Set Aggregation"]);
	var removeQueryAggregation = exports.removeQueryAggregation = createQueryAction("metabase/qb/REMOVE_QUERY_AGGREGATION", _query2.default.removeAggregation, ["QueryBuilder", "Remove Aggregation"]);
	var addQueryOrderBy = exports.addQueryOrderBy = createQueryAction("metabase/qb/ADD_QUERY_ORDER_BY", _query2.default.addOrderBy, ["QueryBuilder", "Add OrderBy"]);
	var updateQueryOrderBy = exports.updateQueryOrderBy = createQueryAction("metabase/qb/UPDATE_QUERY_ORDER_BY", _query2.default.updateOrderBy, ["QueryBuilder", "Set OrderBy"]);
	var removeQueryOrderBy = exports.removeQueryOrderBy = createQueryAction("metabase/qb/REMOVE_QUERY_ORDER_BY", _query2.default.removeOrderBy, ["QueryBuilder", "Remove OrderBy"]);
	var updateQueryLimit = exports.updateQueryLimit = createQueryAction("metabase/qb/UPDATE_QUERY_LIMIT", _query2.default.updateLimit, ["QueryBuilder", "Update Limit"]);
	var addQueryExpression = exports.addQueryExpression = createQueryAction("metabase/qb/ADD_QUERY_EXPRESSION", _query2.default.addExpression, ["QueryBuilder", "Add Expression"]);
	var updateQueryExpression = exports.updateQueryExpression = createQueryAction("metabase/qb/UPDATE_QUERY_EXPRESSION", _query2.default.updateExpression, ["QueryBuilder", "Set Expression"]);
	var removeQueryExpression = exports.removeQueryExpression = createQueryAction("metabase/qb/REMOVE_QUERY_EXPRESSION", _query2.default.removeExpression, ["QueryBuilder", "Remove Expression"]);
	
	/**
	 * Queries the result for the currently active question or alternatively for the card provided in `overrideWithCard`.
	 * The API queries triggered by this action creator can be cancelled using the deferred provided in RUN_QUERY action.
	 */
	var RUN_QUERY = exports.RUN_QUERY = "metabase/qb/RUN_QUERY";
	var runQuestionQuery = exports.runQuestionQuery = function runQuestionQuery() {
	    var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref19$shouldUpdateUr = _ref19.shouldUpdateUrl,
	        shouldUpdateUrl = _ref19$shouldUpdateUr === undefined ? true : _ref19$shouldUpdateUr,
	        _ref19$ignoreCache = _ref19.ignoreCache,
	        ignoreCache = _ref19$ignoreCache === undefined ? false : _ref19$ignoreCache,
	        overrideWithCard = _ref19.overrideWithCard;
	
	    return function () {
	        var _ref20 = _asyncToGenerator(regeneratorRuntime.mark(function _callee13(dispatch, getState) {
	            var questionFromCard, question, originalQuestion, cardIsDirty, startTime, cancelQueryDeferred;
	            return regeneratorRuntime.wrap(function _callee13$(_context13) {
	                while (1) {
	                    switch (_context13.prev = _context13.next) {
	                        case 0:
	                            questionFromCard = function questionFromCard(c) {
	                                return c && new _Question2.default((0, _metadata.getMetadata)(getState()), c);
	                            };
	
	                            question = overrideWithCard ? questionFromCard(overrideWithCard) : (0, _selectors.getQuestion)(getState());
	                            originalQuestion = (0, _selectors.getOriginalQuestion)(getState());
	                            cardIsDirty = originalQuestion ? question.isDirtyComparedTo(originalQuestion) : true;
	
	
	                            if (shouldUpdateUrl) {
	                                dispatch(updateUrl(question.card(), { dirty: cardIsDirty }));
	                            }
	
	                            startTime = new Date();
	                            cancelQueryDeferred = (0, _promise.defer)();
	
	
	                            question.getResults({ cancelDeferred: cancelQueryDeferred, isDirty: cardIsDirty }).then(function (queryResults) {
	                                return dispatch(queryCompleted(question.card(), queryResults));
	                            }).catch(function (error) {
	                                return dispatch(queryErrored(startTime, error));
	                            });
	
	                            _analytics2.default.trackEvent("QueryBuilder", "Run Query", question.query().datasetQuery().type);
	
	                            // TODO Move this out from Redux action asap
	                            // HACK: prevent SQL editor from losing focus
	                            try {
	                                ace.edit("id_sql").focus();
	                            } catch (e) {}
	
	                            dispatch.action(RUN_QUERY, { cancelQueryDeferred: cancelQueryDeferred });
	
	                        case 11:
	                        case "end":
	                            return _context13.stop();
	                    }
	                }
	            }, _callee13, undefined);
	        }));
	
	        return function (_x27, _x28) {
	            return _ref20.apply(this, arguments);
	        };
	    }();
	};
	
	var getDisplayTypeForCard = exports.getDisplayTypeForCard = function getDisplayTypeForCard(card, queryResults) {
	    // TODO Atte Keinänen 6/1/17: Make a holistic decision based on all queryResults, not just one
	    // This method seems to has been a candidate for a rewrite anyway
	    var queryResult = queryResults[0];
	
	    var cardDisplay = card.display;
	
	    // try a little logic to pick a smart display for the data
	    // TODO: less hard-coded rules for picking chart type
	    var isScalarVisualization = card.display === "scalar" || card.display === "progress";
	    if (!isScalarVisualization && queryResult.data.rows && queryResult.data.rows.length === 1 && queryResult.data.cols.length === 1) {
	        // if we have a 1x1 data result then this should always be viewed as a scalar
	        cardDisplay = "scalar";
	    } else if (isScalarVisualization && queryResult.data.rows && (queryResult.data.rows.length > 1 || queryResult.data.cols.length > 1)) {
	        // any time we were a scalar and now have more than 1x1 data switch to table view
	        cardDisplay = "table";
	    } else if (!card.display) {
	        // if our query aggregation is "rows" then ALWAYS set the display to "table"
	        cardDisplay = "table";
	    }
	
	    return cardDisplay;
	};
	
	var QUERY_COMPLETED = exports.QUERY_COMPLETED = "metabase/qb/QUERY_COMPLETED";
	var queryCompleted = exports.queryCompleted = (0, _redux.createThunkAction)(QUERY_COMPLETED, function (card, queryResults) {
	    return function () {
	        var _ref21 = _asyncToGenerator(regeneratorRuntime.mark(function _callee14(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee14$(_context14) {
	                while (1) {
	                    switch (_context14.prev = _context14.next) {
	                        case 0:
	                            return _context14.abrupt("return", {
	                                card: card,
	                                cardDisplay: getDisplayTypeForCard(card, queryResults),
	                                queryResults: queryResults
	                            });
	
	                        case 1:
	                        case "end":
	                            return _context14.stop();
	                    }
	                }
	            }, _callee14, undefined);
	        }));
	
	        return function (_x29, _x30) {
	            return _ref21.apply(this, arguments);
	        };
	    }();
	});
	
	var QUERY_ERRORED = exports.QUERY_ERRORED = "metabase/qb/QUERY_ERRORED";
	var queryErrored = exports.queryErrored = (0, _redux.createThunkAction)(QUERY_ERRORED, function (startTime, error) {
	    return function () {
	        var _ref22 = _asyncToGenerator(regeneratorRuntime.mark(function _callee15(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee15$(_context15) {
	                while (1) {
	                    switch (_context15.prev = _context15.next) {
	                        case 0:
	                            if (!(error && error.isCancelled)) {
	                                _context15.next = 4;
	                                break;
	                            }
	
	                            return _context15.abrupt("return", null);
	
	                        case 4:
	                            return _context15.abrupt("return", { error: error, duration: new Date() - startTime });
	
	                        case 5:
	                        case "end":
	                            return _context15.stop();
	                    }
	                }
	            }, _callee15, undefined);
	        }));
	
	        return function (_x31, _x32) {
	            return _ref22.apply(this, arguments);
	        };
	    }();
	});
	
	// cancelQuery
	var CANCEL_QUERY = exports.CANCEL_QUERY = "metabase/qb/CANCEL_QUERY";
	var cancelQuery = exports.cancelQuery = (0, _redux.createThunkAction)(CANCEL_QUERY, function () {
	    return function () {
	        var _ref23 = _asyncToGenerator(regeneratorRuntime.mark(function _callee16(dispatch, getState) {
	            var _getState13, _getState13$qb, uiControls, cancelQueryDeferred;
	
	            return regeneratorRuntime.wrap(function _callee16$(_context16) {
	                while (1) {
	                    switch (_context16.prev = _context16.next) {
	                        case 0:
	                            _getState13 = getState(), _getState13$qb = _getState13.qb, uiControls = _getState13$qb.uiControls, cancelQueryDeferred = _getState13$qb.cancelQueryDeferred;
	
	
	                            if (uiControls.isRunning && cancelQueryDeferred) {
	                                cancelQueryDeferred.resolve();
	                            }
	
	                        case 2:
	                        case "end":
	                            return _context16.stop();
	                    }
	                }
	            }, _callee16, undefined);
	        }));
	
	        return function (_x33, _x34) {
	            return _ref23.apply(this, arguments);
	        };
	    }();
	});
	
	var FOLLOW_FOREIGN_KEY = exports.FOLLOW_FOREIGN_KEY = "metabase/qb/FOLLOW_FOREIGN_KEY";
	var followForeignKey = exports.followForeignKey = (0, _redux.createThunkAction)(FOLLOW_FOREIGN_KEY, function (fk) {
	    return function () {
	        var _ref24 = _asyncToGenerator(regeneratorRuntime.mark(function _callee17(dispatch, getState) {
	            var _getState14, _getState14$qb, card, queryResult, originValue, i, newCard;
	
	            return regeneratorRuntime.wrap(function _callee17$(_context17) {
	                while (1) {
	                    switch (_context17.prev = _context17.next) {
	                        case 0:
	                            // TODO Atte Keinänen 6/1/17: Should use `queryResults` instead
	                            _getState14 = getState(), _getState14$qb = _getState14.qb, card = _getState14$qb.card, queryResult = _getState14$qb.queryResult;
	
	                            if (!(!queryResult || !fk)) {
	                                _context17.next = 3;
	                                break;
	                            }
	
	                            return _context17.abrupt("return", false);
	
	                        case 3:
	                            for (i = 0; i < queryResult.data.cols.length; i++) {
	                                if ((0, _types.isPK)(queryResult.data.cols[i].special_type)) {
	                                    originValue = queryResult.data.rows[0][i];
	                                }
	                            }
	
	                            // action is on an FK column
	                            newCard = (0, _card.startNewCard)("query", card.dataset_query.database);
	
	
	                            newCard.dataset_query.query.source_table = fk.origin.table.id;
	                            newCard.dataset_query.query.aggregation = ["rows"];
	                            newCard.dataset_query.query.filter = ["AND", ["=", fk.origin.id, originValue]];
	
	                            // run it
	                            dispatch(setCardAndRun(newCard));
	
	                        case 9:
	                        case "end":
	                            return _context17.stop();
	                    }
	                }
	            }, _callee17, undefined);
	        }));
	
	        return function (_x35, _x36) {
	            return _ref24.apply(this, arguments);
	        };
	    }();
	});
	
	var LOAD_OBJECT_DETAIL_FK_REFERENCES = exports.LOAD_OBJECT_DETAIL_FK_REFERENCES = "metabase/qb/LOAD_OBJECT_DETAIL_FK_REFERENCES";
	var loadObjectDetailFKReferences = exports.loadObjectDetailFKReferences = (0, _redux.createThunkAction)(LOAD_OBJECT_DETAIL_FK_REFERENCES, function () {
	    return function () {
	        var _ref25 = _asyncToGenerator(regeneratorRuntime.mark(function _callee19(dispatch, getState) {
	            var getFKCount = function () {
	                var _ref26 = _asyncToGenerator(regeneratorRuntime.mark(function _callee18(card, queryResult, fk) {
	                    var fkQuery, info, result;
	                    return regeneratorRuntime.wrap(function _callee18$(_context18) {
	                        while (1) {
	                            switch (_context18.prev = _context18.next) {
	                                case 0:
	                                    fkQuery = (0, _query.createQuery)("query");
	
	                                    fkQuery.database = card.dataset_query.database;
	                                    fkQuery.query.source_table = fk.origin.table_id;
	                                    fkQuery.query.aggregation = ["count"];
	                                    fkQuery.query.filter = ["AND", ["=", fk.origin.id, getObjectDetailIdValue(queryResult.data)]];
	
	                                    info = { "status": 0, "value": null };
	                                    _context18.prev = 6;
	                                    _context18.next = 9;
	                                    return _services.MetabaseApi.dataset(fkQuery);
	
	                                case 9:
	                                    result = _context18.sent;
	
	                                    if (result && result.status === "completed" && result.data.rows.length > 0) {
	                                        info["value"] = result.data.rows[0][0];
	                                    } else {
	                                        // $FlowFixMe
	                                        info["value"] = "Unknown";
	                                    }
	                                    _context18.next = 16;
	                                    break;
	
	                                case 13:
	                                    _context18.prev = 13;
	                                    _context18.t0 = _context18["catch"](6);
	
	                                    console.error("error getting fk count", _context18.t0, fkQuery);
	
	                                case 16:
	                                    _context18.prev = 16;
	
	                                    info["status"] = 1;
	                                    return _context18.finish(16);
	
	                                case 19:
	                                    return _context18.abrupt("return", info);
	
	                                case 20:
	                                case "end":
	                                    return _context18.stop();
	                            }
	                        }
	                    }, _callee18, this, [[6, 13, 16, 19]]);
	                }));
	
	                return function getFKCount(_x39, _x40, _x41) {
	                    return _ref26.apply(this, arguments);
	                };
	            }();
	
	            // TODO: there are possible cases where running a query would not require refreshing this data, but
	            // skipping that for now because it's easier to just run this each time
	
	            // run a query on FK origin table where FK origin field = objectDetailIdValue
	
	
	            var _getState15, _getState15$qb, card, queryResult, tableForeignKeys, getObjectDetailIdValue, fkReferences, i, fk, info;
	
	            return regeneratorRuntime.wrap(function _callee19$(_context19) {
	                while (1) {
	                    switch (_context19.prev = _context19.next) {
	                        case 0:
	                            getObjectDetailIdValue = function getObjectDetailIdValue(data) {
	                                for (var i = 0; i < data.cols.length; i++) {
	                                    var coldef = data.cols[i];
	                                    if ((0, _types.isPK)(coldef.special_type)) {
	                                        return data.rows[0][i];
	                                    }
	                                }
	                            };
	
	                            // TODO Atte Keinänen 6/1/17: Should use `queryResults` instead
	                            _getState15 = getState(), _getState15$qb = _getState15.qb, card = _getState15$qb.card, queryResult = _getState15$qb.queryResult, tableForeignKeys = _getState15$qb.tableForeignKeys;
	                            fkReferences = {};
	                            i = 0;
	
	                        case 4:
	                            if (!(i < tableForeignKeys.length)) {
	                                _context19.next = 13;
	                                break;
	                            }
	
	                            fk = tableForeignKeys[i];
	                            _context19.next = 8;
	                            return getFKCount(card, queryResult, fk);
	
	                        case 8:
	                            info = _context19.sent;
	
	                            fkReferences[fk.origin.id] = info;
	
	                        case 10:
	                            i++;
	                            _context19.next = 4;
	                            break;
	
	                        case 13:
	                            return _context19.abrupt("return", fkReferences);
	
	                        case 14:
	                        case "end":
	                            return _context19.stop();
	                    }
	                }
	            }, _callee19, undefined);
	        }));
	
	        return function (_x37, _x38) {
	            return _ref25.apply(this, arguments);
	        };
	    }();
	});
	
	// TODO - this is pretty much a duplicate of SET_ARCHIVED in questions/questions.js
	// unfortunately we have to do this because that action relies on its part of the store
	// for the card lookup
	// A simplified version of a similar method in questions/questions.js
	function createUndo(type, action) {
	    return {
	        type: type,
	        count: 1,
	        message: function message(undo) {
	            return (// eslint-disable-line react/display-name
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    " ",
	                    "Question  was " + type + ".",
	                    " "
	                )
	            );
	        },
	        actions: [action]
	    };
	}
	
	var ARCHIVE_QUESTION = exports.ARCHIVE_QUESTION = 'metabase/qb/ARCHIVE_QUESTION';
	var archiveQuestion = exports.archiveQuestion = (0, _redux.createThunkAction)(ARCHIVE_QUESTION, function (questionId) {
	    var archived = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    return function () {
	        var _ref27 = _asyncToGenerator(regeneratorRuntime.mark(function _callee20(dispatch, getState) {
	            var card, response;
	            return regeneratorRuntime.wrap(function _callee20$(_context20) {
	                while (1) {
	                    switch (_context20.prev = _context20.next) {
	                        case 0:
	                            card = _extends({}, getState().qb.card, { // grab the current card
	                                archived: archived
	                            });
	                            _context20.next = 3;
	                            return _services.CardApi.update(card);
	
	                        case 3:
	                            response = _context20.sent;
	
	
	                            dispatch((0, _undo.addUndo)(createUndo(archived ? "archived" : "unarchived", archiveQuestion(card.id, !archived))));
	
	                            dispatch((0, _reactRouterRedux.push)('/questions'));
	                            return _context20.abrupt("return", response);
	
	                        case 7:
	                        case "end":
	                            return _context20.stop();
	                    }
	                }
	            }, _callee20, undefined);
	        }));
	
	        return function (_x43, _x44) {
	            return _ref27.apply(this, arguments);
	        };
	    }();
	});
	
	var VIEW_NEXT_OBJECT_DETAIL = exports.VIEW_NEXT_OBJECT_DETAIL = 'metabase/qb/VIEW_NEXT_OBJECT_DETAIL';
	var viewNextObjectDetail = exports.viewNextObjectDetail = function viewNextObjectDetail() {
	    return function (dispatch, getState) {
	        var question = (0, _selectors.getQuestion)(getState());
	        var filter = question.query().filters()[0];
	
	        var newFilter = ["=", filter[1], filter[2] + 1];
	
	        dispatch.action(VIEW_NEXT_OBJECT_DETAIL);
	
	        dispatch(updateQuestion(question.query().updateFilter(0, newFilter).question()));
	
	        dispatch(runQuestionQuery());
	    };
	};
	
	var VIEW_PREVIOUS_OBJECT_DETAIL = exports.VIEW_PREVIOUS_OBJECT_DETAIL = 'metabase/qb/VIEW_PREVIOUS_OBJECT_DETAIL';
	
	var viewPreviousObjectDetail = exports.viewPreviousObjectDetail = function viewPreviousObjectDetail() {
	    return function (dispatch, getState) {
	        var question = (0, _selectors.getQuestion)(getState());
	        var filter = question.query().filters()[0];
	
	        if (filter[2] === 1) {
	            return false;
	        }
	
	        var newFilter = ["=", filter[1], filter[2] - 1];
	
	        dispatch.action(VIEW_PREVIOUS_OBJECT_DETAIL);
	
	        dispatch(updateQuestion(question.query().updateFilter(0, newFilter).question()));
	
	        dispatch(runQuestionQuery());
	    };
	};
	
	// these are just temporary mappings to appease the existing QB code and it's naming prefs
	var toggleDataReferenceFn = exports.toggleDataReferenceFn = toggleDataReference;
	var onBeginEditing = exports.onBeginEditing = beginEditing;
	var onCancelEditing = exports.onCancelEditing = cancelEditing;
	var setQueryModeFn = exports.setQueryModeFn = setQueryMode;
	var setDatabaseFn = exports.setDatabaseFn = setQueryDatabase;
	var setSourceTableFn = exports.setSourceTableFn = setQuerySourceTable;
	var setDisplayFn = exports.setDisplayFn = setCardVisualization;
	var onSetCardAttribute = exports.onSetCardAttribute = setCardAttribute;
	var reloadCardFn = exports.reloadCardFn = reloadCard;
	var onRestoreOriginalQuery = exports.onRestoreOriginalQuery = reloadCard;
	var onUpdateVisualizationSettings = exports.onUpdateVisualizationSettings = updateCardVisualizationSettings;
	var onReplaceAllVisualizationSettings = exports.onReplaceAllVisualizationSettings = replaceAllCardVisualizationSettings;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setErrorPage = exports.SET_ERROR_PAGE = undefined;
	
	var _handleActions;
	
	var _redux = __webpack_require__(657);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SET_ERROR_PAGE = exports.SET_ERROR_PAGE = "metabase/app/SET_ERROR_PAGE";
	
	var setErrorPage = exports.setErrorPage = (0, _redux.createAction)(SET_ERROR_PAGE, function (error) {
	    console.error("Error:", error);
	    return error;
	});
	
	var errorPage = (0, _redux.handleActions)((_handleActions = {}, _defineProperty(_handleActions, SET_ERROR_PAGE, function (state, _ref) {
	    var payload = _ref.payload;
	    return payload;
	}), _defineProperty(_handleActions, _reactRouterRedux.LOCATION_CHANGE, function () {
	    return null;
	}), _handleActions), null);
	
	exports.default = (0, _redux.combineReducers)({
	    errorPage: errorPage
	});

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loadCard = undefined;
	
	// load a card either by ID or from a base64 serialization.  if both are present then they are merged, which the serialized version taking precedence
	// TODO: move to redux
	var loadCard = exports.loadCard = function () {
	    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(cardId) {
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	                        _context.next = 3;
	                        return _services.CardApi.get({ "cardId": cardId });
	
	                    case 3:
	                        return _context.abrupt("return", _context.sent);
	
	                    case 6:
	                        _context.prev = 6;
	                        _context.t0 = _context["catch"](0);
	
	                        console.log("error loading card", _context.t0);
	                        throw _context.t0;
	
	                    case 10:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, this, [[0, 6]]);
	    }));
	
	    return function loadCard(_x2) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	// TODO Atte Keinänen 5/31/17 Deprecated, we should migrate existing references to this method to `question.isCardDirty`
	// predicate function that dermines if a given card is "dirty" compared to the last known version of the card
	
	
	exports.createCard = createCard;
	exports.startNewCard = startNewCard;
	exports.isCardDirty = isCardDirty;
	exports.isCardRunnable = isCardRunnable;
	exports.serializeCardForUrl = serializeCardForUrl;
	exports.deserializeCardFromUrl = deserializeCardFromUrl;
	exports.utf8_to_b64 = utf8_to_b64;
	exports.b64_to_utf8 = b64_to_utf8;
	exports.utf8_to_b64url = utf8_to_b64url;
	exports.b64url_to_utf8 = b64url_to_utf8;
	exports.urlForCardState = urlForCardState;
	exports.cleanCopyCard = cleanCopyCard;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function createCard() {
	    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    return {
	        name: name,
	        display: "table",
	        visualization_settings: {},
	        dataset_query: {}
	    };
	}
	
	// start a new card using the given query type and optional database and table selections
	function startNewCard(type, databaseId, tableId) {
	    // create a brand new card to work from
	    var card = createCard();
	    card.dataset_query = (0, _query.createQuery)(type, databaseId, tableId);
	
	    return card;
	}function isCardDirty(card, originalCard) {
	    // The rules:
	    //   - if it's new, then it's dirty when
	    //       1) there is a database/table chosen or
	    //       2) when there is any content on the native query
	    //   - if it's saved, then it's dirty when
	    //       1) the current card doesn't match the last saved version
	
	    if (!card) {
	        return false;
	    } else if (!card.id) {
	        if (card.dataset_query.query && card.dataset_query.query.source_table) {
	            return true;
	        } else if (card.dataset_query.native && !_underscore2.default.isEmpty(card.dataset_query.native.query)) {
	            return true;
	        } else {
	            return false;
	        }
	    } else {
	        var origCardSerialized = originalCard ? serializeCardForUrl(originalCard) : null;
	        var newCardSerialized = card ? serializeCardForUrl(_underscore2.default.omit(card, 'original_card_id')) : null;
	        return newCardSerialized !== origCardSerialized;
	    }
	}
	
	function isCardRunnable(card, tableMetadata) {
	    if (!card) {
	        return false;
	    }
	    var datasetQuery = card.dataset_query;
	    if (datasetQuery.query) {
	        return _query2.default.canRun(datasetQuery.query, tableMetadata);
	    } else {
	        return datasetQuery.database != undefined && datasetQuery.native.query !== "";
	    }
	}
	
	// TODO Atte Keinänen 5/31/17 Deprecated, we should move tests to Questions.spec.js
	function serializeCardForUrl(card) {
	    var dataset_query = _utils2.default.copy(card.dataset_query);
	    if (dataset_query.query) {
	        dataset_query.query = _query2.default.cleanQuery(dataset_query.query);
	    }
	
	    var cardCopy = {
	        name: card.name,
	        description: card.description,
	        dataset_query: dataset_query,
	        display: card.display,
	        parameters: card.parameters,
	        visualization_settings: card.visualization_settings,
	        original_card_id: card.original_card_id
	    };
	
	    return utf8_to_b64url(JSON.stringify(cardCopy));
	}
	
	function deserializeCardFromUrl(serialized) {
	    serialized = serialized.replace(/^#/, "");
	    return JSON.parse(b64url_to_utf8(serialized));
	}
	
	// escaping before base64 encoding is necessary for non-ASCII characters
	// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/btoa
	function utf8_to_b64(str) {
	    return window.btoa(unescape(encodeURIComponent(str)));
	}
	function b64_to_utf8(b64) {
	    return decodeURIComponent(escape(window.atob(b64)));
	}
	
	// for "URL safe" base64, replace "+" with "-" and "/" with "_" as per RFC 4648
	function utf8_to_b64url(str) {
	    return utf8_to_b64(str).replace(/\+/g, "-").replace(/\//g, "_");
	}
	function b64url_to_utf8(b64url) {
	    return b64_to_utf8(b64url.replace(/-/g, "+").replace(/_/g, "/"));
	}
	
	function urlForCardState(state, dirty) {
	    return Urls.question(state.cardId, state.serializedCard && dirty ? state.serializedCard : "");
	}
	
	function cleanCopyCard(card) {
	    var cardCopy = {};
	    for (var name in card) {
	        if (name.charAt(0) !== "$") {
	            cardCopy[name] = card[name];
	        }
	    }
	    return cardCopy;
	}

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BreakoutClause = exports.AggregationClause = exports.NamedClause = exports.NEW_QUERY_TEMPLATES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.createQuery = createQuery;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inflection = __webpack_require__(520);
	
	var _inflection2 = _interopRequireDefault(_inflection);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _table = __webpack_require__(871);
	
	var _types = __webpack_require__(868);
	
	var _formatting = __webpack_require__(872);
	
	var _formatter = __webpack_require__(883);
	
	var _table2 = __webpack_require__(886);
	
	var Table = _interopRequireWildcard(_table2);
	
	var _query = __webpack_require__(887);
	
	var Q = _interopRequireWildcard(_query);
	
	var _field = __webpack_require__(869);
	
	var F = _interopRequireWildcard(_field);
	
	var _util = __webpack_require__(870);
	
	var _expressions = __webpack_require__(884);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var NEW_QUERY_TEMPLATES = exports.NEW_QUERY_TEMPLATES = {
	    query: {
	        database: null,
	        type: "query",
	        query: {
	            source_table: null
	        }
	    },
	    native: {
	        database: null,
	        type: "native",
	        native: {
	            query: ""
	        }
	    }
	};
	
	function createQuery() {
	    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "query";
	    var databaseId = arguments[1];
	    var tableId = arguments[2];
	
	    var dataset_query = _utils2.default.copy(NEW_QUERY_TEMPLATES[type]);
	
	    if (databaseId) {
	        dataset_query.database = databaseId;
	    }
	
	    if (type === "query" && databaseId && tableId) {
	        dataset_query.query.source_table = tableId;
	    }
	
	    return dataset_query;
	}
	
	var METRIC_NAME_BY_AGGREGATION = {
	    "count": "count",
	    "cum_count": "count",
	    "sum": "sum",
	    "cum_sum": "sum",
	    "distinct": "count",
	    "avg": "avg",
	    "min": "min",
	    "max": "max"
	};
	
	var METRIC_TYPE_BY_AGGREGATION = {
	    "count": _types.TYPE.Integer,
	    "cum_count": _types.TYPE.Integer,
	    "sum": _types.TYPE.Float,
	    "cum_sum": _types.TYPE.Float,
	    "distinct": _types.TYPE.Integer,
	    "avg": _types.TYPE.Float,
	    "min": _types.TYPE.Float,
	    "max": _types.TYPE.Float
	};
	
	var SORTABLE_AGGREGATION_TYPES = new Set(["avg", "count", "distinct", "stddev", "sum", "min", "max"]);
	
	var Query = {
	    isStructured: function isStructured(dataset_query) {
	        return dataset_query && dataset_query.type === "query";
	    },
	    isNative: function isNative(dataset_query) {
	        return dataset_query && dataset_query.type === "native";
	    },
	    canRun: function canRun(query, tableMetadata) {
	        if (!query || query.source_table == null || !Query.hasValidAggregation(query)) {
	            return false;
	        }
	        // check that the table supports this aggregation, if we have tableMetadata
	        if (tableMetadata) {
	            var aggs = Query.getAggregations(query);
	            if (aggs.length === 0) {
	                if (!_underscore2.default.findWhere(tableMetadata.aggregation_options, { short: "rows" })) {
	                    return false;
	                }
	            } else {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = aggs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var _step$value = _slicedToArray(_step.value, 1),
	                            agg = _step$value[0];
	
	                        if (!(0, _util.mbqlEq)(agg, "metric") && !_underscore2.default.findWhere(tableMetadata.aggregation_options, { short: agg })) {
	                            // return false;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	        }
	        return true;
	    },
	    cleanQuery: function cleanQuery(query) {
	        if (!query) {
	            return query;
	        }
	
	        // it's possible the user left some half-done parts of the query on screen when they hit the run button, so find those
	        // things now and clear them out so that we have a nice clean set of valid clauses in our query
	
	        // aggregations
	        query.aggregation = Query.getAggregations(query);
	        if (query.aggregation.length === 0) {
	            delete query.aggregation;
	        }
	
	        // breakouts
	        query.breakout = Query.getBreakouts(query);
	        if (query.breakout.length === 0) {
	            delete query.breakout;
	        }
	
	        // filters
	        var filters = Query.getFilters(query).filter(function (filter) {
	            return _underscore2.default.all(filter, function (a) {
	                return a != null;
	            });
	        });
	        if (filters.length > 0) {
	            query.filter = ["AND"].concat(_toConsumableArray(filters));
	        } else {
	            delete query.filter;
	        }
	
	        if (query.order_by) {
	            query.order_by = query.order_by.map(function (s) {
	                var field = s[0];
	
	                // remove incomplete sorts
	                if (!Query.isValidField(field) || s[1] == null) {
	                    return null;
	                }
	
	                if (Query.isAggregateField(field)) {
	                    // remove aggregation sort if we can't sort by this aggregation
	                    if (Query.canSortByAggregateField(query, field[1])) {
	                        return s;
	                    }
	                } else if (Query.hasValidBreakout(query)) {
	                    var exactMatches = query.breakout.filter(function (b) {
	                        return Query.isSameField(b, field, true);
	                    });
	                    if (exactMatches.length > 0) {
	                        return s;
	                    }
	                    var targetMatches = query.breakout.filter(function (b) {
	                        return Query.isSameField(b, field, false);
	                    });
	                    if (targetMatches.length > 0) {
	                        // query processor expect the order_by clause to match the breakout's datetime-field unit or fk-> target,
	                        // so just replace it with the one that matches the target field
	                        // NOTE: if we have more than one breakout for the same target field this could match the wrong one
	                        if (targetMatches.length > 1) {
	                            console.warn("Sort clause matches more than one breakout field", s[0], targetMatches);
	                        }
	                        return [targetMatches[0], s[1]];
	                    }
	                } else if (Query.isBareRows(query)) {
	                    return s;
	                }
	
	                // otherwise remove sort if it doesn't have a breakout but isn't a bare rows aggregation
	                return null;
	            }).filter(function (s) {
	                return s != null;
	            });
	
	            if (query.order_by.length === 0) {
	                delete query.order_by;
	            }
	        }
	
	        if (typeof query.limit !== "number") {
	            delete query.limit;
	        }
	
	        if (query.expressions) delete query.expressions['']; // delete any empty expressions
	
	        return query;
	    },
	    canAddDimensions: function canAddDimensions(query) {
	        var MAX_DIMENSIONS = 2;
	        return query && query.breakout && query.breakout.length < MAX_DIMENSIONS;
	    },
	    numDimensions: function numDimensions(query) {
	        if (query && query.breakout) {
	            return query.breakout.filter(function (b) {
	                return b !== null;
	            }).length;
	        }
	
	        return 0;
	    },
	    hasValidBreakout: function hasValidBreakout(query) {
	        return query && query.breakout && query.breakout.length > 0 && query.breakout[0] !== null;
	    },
	    canSortByAggregateField: function canSortByAggregateField(query, index) {
	        if (!Query.hasValidBreakout(query)) {
	            return false;
	        }
	        var aggregations = Query.getAggregations(query);
	        return aggregations[index] && aggregations[index][0] && SORTABLE_AGGREGATION_TYPES.has((0, _util.mbql)(aggregations[index][0]));
	    },
	    isSegmentFilter: function isSegmentFilter(filter) {
	        return Array.isArray(filter) && filter[0] === "SEGMENT";
	    },
	    canAddLimitAndSort: function canAddLimitAndSort(query) {
	        if (Query.isBareRows(query)) {
	            return true;
	        } else if (Query.hasValidBreakout(query)) {
	            return true;
	        } else {
	            return false;
	        }
	    },
	    getSortableFields: function getSortableFields(query, fields) {
	        // in bare rows all fields are sortable, otherwise we only sort by our breakout columns
	        if (Query.isBareRows(query)) {
	            return fields;
	        } else if (Query.hasValidBreakout(query)) {
	            // further filter field list down to only fields in our breakout clause
	            var breakoutFieldList = [];
	
	            var breakouts = Query.getBreakouts(query);
	            breakouts.map(function (breakoutField) {
	                var fieldId = Query.getFieldTargetId(breakoutField);
	                var field = _underscore2.default.findWhere(fields, { id: fieldId });
	                if (field) {
	                    breakoutFieldList.push(field);
	                }
	            });
	
	            var aggregations = Query.getAggregations(query);
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = aggregations.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _step2$value = _slicedToArray(_step2.value, 2),
	                        index = _step2$value[0],
	                        aggregation = _step2$value[1];
	
	                    if (Query.canSortByAggregateField(query, index)) {
	                        breakoutFieldList.push({
	                            id: ["aggregation", index],
	                            name: aggregation[0], // e.g. "sum"
	                            display_name: aggregation[0]
	                        });
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            return breakoutFieldList;
	        } else {
	            return [];
	        }
	    },
	    canAddSort: function canAddSort(query) {
	        // TODO: allow for multiple sorting choices
	        return false;
	    },
	    getExpressions: function getExpressions(query) {
	        return query.expressions || {};
	    },
	    setExpression: function setExpression(query, name, expression) {
	        if (name && expression) {
	            var expressions = query.expressions || {};
	            expressions[name] = expression;
	            query.expressions = expressions;
	        }
	
	        return query;
	    },
	
	
	    // remove an expression with NAME. Returns scrubbed QUERY with all references to expression removed.
	    removeExpression: function removeExpression(query, name) {
	        if (!query.expressions) return query;
	
	        delete query.expressions[name];
	
	        if (_underscore2.default.isEmpty(query.expressions)) delete query.expressions;
	
	        // ok, now "scrub" the query to remove any references to the expression
	        function isExpressionReference(obj) {
	            return obj && obj.constructor === Array && obj.length === 2 && obj[0] === 'expression' && obj[1] === name;
	        }
	
	        function removeExpressionReferences(obj) {
	            return isExpressionReference(obj) ? null : obj.constructor === Array ? _underscore2.default.map(obj, removeExpressionReferences) : (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === 'object' ? _underscore2.default.mapObject(obj, removeExpressionReferences) : obj;
	        }
	
	        return this.cleanQuery(removeExpressionReferences(query));
	    },
	    isRegularField: function isRegularField(field) {
	        return typeof field === "number";
	    },
	    isLocalField: function isLocalField(field) {
	        return Array.isArray(field) && (0, _util.mbqlEq)(field[0], "field-id");
	    },
	    isForeignKeyField: function isForeignKeyField(field) {
	        return Array.isArray(field) && (0, _util.mbqlEq)(field[0], "fk->");
	    },
	    isDatetimeField: function isDatetimeField(field) {
	        return Array.isArray(field) && (0, _util.mbqlEq)(field[0], "datetime-field");
	    },
	
	
	    isBinningStrategy: F.isBinningStrategy,
	
	    isExpressionField: function isExpressionField(field) {
	        return Array.isArray(field) && field.length === 2 && (0, _util.mbqlEq)(field[0], "expression");
	    },
	    isAggregateField: function isAggregateField(field) {
	        return Array.isArray(field) && (0, _util.mbqlEq)(field[0], "aggregation");
	    },
	
	
	    // field literal has the formal ["field-literal", <field-name>, <field-base-type>]
	    isFieldLiteral: function isFieldLiteral(field) {
	        return Array.isArray(field) && field.length === 3 && (0, _util.mbqlEq)(field[0], "field-literal") && _underscore2.default.isString(field[1]) && _underscore2.default.isString(field[2]);
	    },
	    isValidField: function isValidField(field) {
	        return Query.isRegularField(field) || Query.isLocalField(field) || Query.isForeignKeyField(field) && Query.isRegularField(field[1]) && Query.isRegularField(field[2]) ||
	        // datetime field can  be either 4-item (deprecated): ["datetime-field", <field>, "as", <unit>]
	        // or 3 item (preferred style): ["datetime-field", <field>, <unit>]
	        Query.isDatetimeField(field) && Query.isValidField(field[1]) && (field.length === 4 ? field[2] === "as" && typeof field[3] === "string" : // deprecated
	        typeof field[2] === "string") || Query.isExpressionField(field) && _underscore2.default.isString(field[1]) || Query.isAggregateField(field) && typeof field[1] === "number" || Query.isFieldLiteral(field);
	    },
	
	
	    isSameField: function isSameField(fieldA, fieldB) {
	        var exact = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        if (exact) {
	            return _underscore2.default.isEqual(fieldA, fieldB);
	        } else {
	            return Query.getFieldTargetId(fieldA) === Query.getFieldTargetId(fieldB);
	        }
	    },
	
	    // gets the target field ID (recursively) from any type of field, including raw field ID, fk->, and datetime-field cast.
	    getFieldTargetId: function getFieldTargetId(field) {
	        if (Query.isRegularField(field)) {
	            return field;
	        } else if (Query.isLocalField(field)) {
	            return field[1];
	        } else if (Query.isForeignKeyField(field)) {
	            return Query.getFieldTargetId(field[2]);
	        } else if (Query.isDatetimeField(field)) {
	            return Query.getFieldTargetId(field[1]);
	        } else if (Query.isBinningStrategy(field)) {
	            return Query.getFieldTargetId(field[1]);
	        } else if (Query.isFieldLiteral(field)) {
	            return field;
	        }
	        console.warn("Unknown field type: ", field);
	    },
	
	    // gets the table and field definitions from from a raw, fk->, or datetime-field field
	    getFieldTarget: function getFieldTarget(field, tableDef) {
	        var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	        if (Query.isRegularField(field)) {
	            return { table: tableDef, field: Table.getField(tableDef, field), path: path };
	        } else if (Query.isLocalField(field)) {
	            return Query.getFieldTarget(field[1], tableDef, path);
	        } else if (Query.isForeignKeyField(field)) {
	            var fkFieldDef = Table.getField(tableDef, field[1]);
	            var targetTableDef = fkFieldDef && fkFieldDef.target.table;
	            return Query.getFieldTarget(field[2], targetTableDef, path.concat(fkFieldDef));
	        } else if (Query.isDatetimeField(field)) {
	            return _extends({}, Query.getFieldTarget(field[1], tableDef, path), {
	                unit: Query.getDatetimeUnit(field)
	            });
	        } else if (Query.isBinningStrategy(field)) {
	            return Query.getFieldTarget(field[1], tableDef, path);
	        } else if (Query.isExpressionField(field)) {
	            // hmmm, since this is a dynamic field we'll need to build this here
	            var fieldDef = {
	                display_name: field[1],
	                name: field[1],
	                // TODO: we need to do something better here because filtering depends on knowing a sensible type for the field
	                base_type: _types.TYPE.Integer,
	                operators_lookup: {},
	                operators: [],
	                active: true,
	                fk_target_field_id: null,
	                parent_id: null,
	                preview_display: true,
	                special_type: null,
	                target: null,
	                visibility_type: "normal"
	            };
	            fieldDef.operators = (0, _schema_metadata.getOperators)(fieldDef, tableDef);
	            fieldDef.operators_lookup = (0, _table.createLookupByProperty)(fieldDef.operators, "name");
	
	            return {
	                table: tableDef,
	                field: fieldDef,
	                path: path
	            };
	        } else if (Query.isFieldLiteral(field)) {
	            return { table: tableDef, field: Table.getField(tableDef, field), path: path }; // just pretend it's a normal field
	        }
	
	        console.warn("Unknown field type: ", field);
	    },
	
	    getFieldPath: function getFieldPath(fieldId, tableDef) {
	        var path = [];
	        while (fieldId != null) {
	            var field = Table.getField(tableDef, fieldId);
	            path.unshift(field);
	            fieldId = field && field.parent_id;
	        }
	        return path;
	    },
	    getFieldPathName: function getFieldPathName(fieldId, tableDef) {
	        return Query.getFieldPath(fieldId, tableDef).map(_formatting.formatField).join(": ");
	    },
	    getDatetimeUnit: function getDatetimeUnit(field) {
	        if (field.length === 4) {
	            return field[3]; // deprecated
	        } else {
	            return field[2];
	        }
	    },
	    getFieldOptions: function getFieldOptions(fields) {
	        var includeJoins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var filterFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _underscore2.default.identity;
	        var usedFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	        var results = {
	            count: 0,
	            fields: null,
	            fks: []
	        };
	        // filter based on filterFn, then remove fks if they'll be duplicated in the joins fields
	        results.fields = filterFn(fields).filter(function (f) {
	            return !usedFields[f.id] && (!(0, _types.isFK)(f.special_type) || !includeJoins);
	        });
	        results.count += results.fields.length;
	        if (includeJoins) {
	            results.fks = fields.filter(function (f) {
	                return (0, _types.isFK)(f.special_type) && f.target;
	            }).map(function (joinField) {
	                var targetFields = filterFn(joinField.target.table.fields).filter(function (f) {
	                    return (!Array.isArray(f.id) || f.id[0] !== "aggregation") && !usedFields[f.id];
	                });
	                results.count += targetFields.length;
	                return {
	                    field: joinField,
	                    fields: targetFields
	                };
	            }).filter(function (r) {
	                return r.fields.length > 0;
	            });
	        }
	
	        return results;
	    },
	    formatField: function formatField(fieldDef) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        var name = (0, _formatting.stripId)(fieldDef && (fieldDef.display_name || fieldDef.name));
	        return name;
	    },
	    getFieldName: function getFieldName(tableMetadata, field, options) {
	        try {
	            var target = Query.getFieldTarget(field, tableMetadata);
	            var components = [];
	            if (target.path) {
	                var _iteratorNormalCompletion3 = true;
	                var _didIteratorError3 = false;
	                var _iteratorError3 = undefined;
	
	                try {
	                    for (var _iterator3 = target.path[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                        var fieldDef = _step3.value;
	
	                        components.push(Query.formatField(fieldDef, options), " → ");
	                    }
	                } catch (err) {
	                    _didIteratorError3 = true;
	                    _iteratorError3 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                            _iterator3.return();
	                        }
	                    } finally {
	                        if (_didIteratorError3) {
	                            throw _iteratorError3;
	                        }
	                    }
	                }
	            }
	            components.push(Query.formatField(target.field, options));
	            if (target.unit) {
	                components.push(" (" + target.unit + ")");
	            }
	            return components;
	        } catch (e) {
	            console.warn("Couldn't format field name for field", field, "in table", tableMetadata);
	        }
	        return "[Unknown Field]";
	    },
	    getTableDescription: function getTableDescription(tableMetadata) {
	        return [_inflection2.default.pluralize(tableMetadata.display_name)];
	    },
	    getAggregationDescription: function getAggregationDescription(tableMetadata, query, options) {
	        return conjunctList(Query.getAggregations(query).map(function (aggregation) {
	            if (NamedClause.isNamed(aggregation)) {
	                return [NamedClause.getName(aggregation)];
	            }
	            if (AggregationClause.isMetric(aggregation)) {
	                var metric = _underscore2.default.findWhere(tableMetadata.metrics, { id: AggregationClause.getMetric(aggregation) });
	                var name = metric ? metric.name : "[Unknown Metric]";
	                return [options.jsx ? _react2.default.createElement(
	                    "span",
	                    { className: "text-green text-bold" },
	                    name
	                ) : name];
	            }
	            switch (aggregation[0]) {
	                case "rows":
	                    return ["Raw data"];
	                case "count":
	                    return ["Count"];
	                case "cum_count":
	                    return ["Cumulative count"];
	                case "avg":
	                    return ["Average of ", Query.getFieldName(tableMetadata, aggregation[1], options)];
	                case "distinct":
	                    return ["Distinct values of ", Query.getFieldName(tableMetadata, aggregation[1], options)];
	                case "stddev":
	                    return ["Standard deviation of ", Query.getFieldName(tableMetadata, aggregation[1], options)];
	                case "sum":
	                    return ["Sum of ", Query.getFieldName(tableMetadata, aggregation[1], options)];
	                case "cum_sum":
	                    return ["Cumulative sum of ", Query.getFieldName(tableMetadata, aggregation[1], options)];
	                case "max":
	                    return ["Maximum of ", Query.getFieldName(tableMetadata, aggregation[1], options)];
	                case "min":
	                    return ["Minimum of ", Query.getFieldName(tableMetadata, aggregation[1], options)];
	                default:
	                    return [(0, _formatter.format)(aggregation, { tableMetadata: tableMetadata })];
	            }
	        }), "and");
	    },
	    getBreakoutDescription: function getBreakoutDescription(tableMetadata, _ref, options) {
	        var breakout = _ref.breakout;
	
	        if (breakout && breakout.length > 0) {
	            return ["Grouped by ", joinList(breakout.map(function (b) {
	                return Query.getFieldName(tableMetadata, b, options);
	            }), " and ")];
	        }
	    },
	    getFilterDescription: function getFilterDescription(tableMetadata, query, options) {
	        // getFilters returns list of filters without the implied "AND"
	        var filters = ["AND"].concat(Query.getFilters(query));
	        if (filters && filters.length > 1) {
	            return ["Filtered by ", Query.getFilterClauseDescription(tableMetadata, filters, options)];
	        }
	    },
	    getFilterClauseDescription: function getFilterClauseDescription(tableMetadata, filter, options) {
	        if (filter[0] === "AND" || filter[0] === "OR") {
	            var clauses = filter.slice(1).map(function (f) {
	                return Query.getFilterClauseDescription(tableMetadata, f, options);
	            });
	            return conjunctList(clauses, filter[0].toLowerCase());
	        } else if (filter[0] === "SEGMENT") {
	            var segment = _underscore2.default.findWhere(tableMetadata.segments, { id: filter[1] });
	            var name = segment ? segment.name : "[Unknown Segment]";
	            return options.jsx ? _react2.default.createElement(
	                "span",
	                { className: "text-purple text-bold" },
	                name
	            ) : name;
	        } else {
	            return Query.getFieldName(tableMetadata, filter[1], options);
	        }
	    },
	    getOrderByDescription: function getOrderByDescription(tableMetadata, _ref2, options) {
	        var order_by = _ref2.order_by;
	
	        if (order_by && order_by.length > 0) {
	            return ["Sorted by ", joinList(order_by.map(function (o) {
	                return Query.getFieldName(tableMetadata, o[0], options) + " " + o[1];
	            }), " and ")];
	        }
	    },
	    getLimitDescription: function getLimitDescription(tableMetadata, _ref3) {
	        var limit = _ref3.limit;
	
	        if (limit != null) {
	            return [limit, " ", _inflection2.default.inflect("row", limit)];
	        }
	    },
	    generateQueryDescription: function generateQueryDescription(tableMetadata, query) {
	        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        if (!tableMetadata) {
	            return "";
	        }
	
	        options = _extends({
	            jsx: false,
	            sections: ["table", "aggregation", "breakout", "filter", "order_by", "limit"]
	        }, options);
	
	        var sectionFns = {
	            table: Query.getTableDescription,
	            aggregation: Query.getAggregationDescription,
	            breakout: Query.getBreakoutDescription,
	            filter: Query.getFilterDescription,
	            order_by: Query.getOrderByDescription,
	            limit: Query.getLimitDescription
	        };
	
	        // these array gymnastics are needed to support JSX formatting
	        var sections = options.sections.map(function (section) {
	            return _underscore2.default.flatten(sectionFns[section](tableMetadata, query, options)).filter(function (s) {
	                return !!s;
	            });
	        }).filter(function (s) {
	            return s && s.length > 0;
	        });
	
	        var description = _underscore2.default.flatten(joinList(sections, ", "));
	        if (options.jsx) {
	            return _react2.default.createElement(
	                "span",
	                null,
	                description
	            );
	        } else {
	            return description.join("");
	        }
	    },
	    getDatetimeFieldUnit: function getDatetimeFieldUnit(field) {
	        return field && field[3];
	    },
	    getAggregationType: function getAggregationType(aggregation) {
	        return aggregation && aggregation[0];
	    },
	    getAggregationField: function getAggregationField(aggregation) {
	        return aggregation && aggregation[1];
	    },
	    getQueryColumn: function getQueryColumn(tableMetadata, field) {
	        var target = Query.getFieldTarget(field, tableMetadata);
	        var column = _extends({}, target.field);
	        if (Query.isDatetimeField(field)) {
	            column.unit = Query.getDatetimeFieldUnit(field);
	        }
	        return column;
	    },
	    getQueryColumns: function getQueryColumns(tableMetadata, query) {
	        var columns = Query.getBreakouts(query).map(function (b) {
	            return Query.getQueryColumn(tableMetadata, b);
	        });
	        if (Query.isBareRows(query)) {
	            if (columns.length === 0) {
	                return null;
	            }
	        } else {
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	                for (var _iterator4 = Query.getAggregations(query)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var aggregation = _step4.value;
	
	                    var type = Query.getAggregationType(aggregation);
	                    columns.push({
	                        name: METRIC_NAME_BY_AGGREGATION[type],
	                        base_type: METRIC_TYPE_BY_AGGREGATION[type],
	                        special_type: _types.TYPE.Number
	                    });
	                }
	            } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                        _iterator4.return();
	                    }
	                } finally {
	                    if (_didIteratorError4) {
	                        throw _iteratorError4;
	                    }
	                }
	            }
	        }
	        return columns;
	    }
	};
	
	for (var prop in Q) {
	    // eslint-disable-next-line import/namespace
	    Query[prop] = Q[prop];
	}
	
	var NamedClause = exports.NamedClause = {
	    isNamed: function isNamed(clause) {
	        return Array.isArray(clause) && (0, _util.mbqlEq)(clause[0], "named");
	    },
	    getName: function getName(clause) {
	        return NamedClause.isNamed(clause) ? clause[2] : null;
	    },
	    getContent: function getContent(clause) {
	        return NamedClause.isNamed(clause) ? clause[1] : clause;
	    },
	    setName: function setName(clause, name) {
	        return ["named", NamedClause.getContent(clause), name];
	    },
	    setContent: function setContent(clause, content) {
	        return NamedClause.isNamed(clause) ? ["named", content, NamedClause.getName(clause)] : content;
	    }
	};
	
	var AggregationClause = exports.AggregationClause = {
	
	    // predicate function to test if a given aggregation clause is fully formed
	    isValid: function isValid(aggregation) {
	        if (aggregation && _underscore2.default.isArray(aggregation) && (aggregation.length === 1 && aggregation[0] !== null || aggregation.length === 2 && aggregation[0] !== null && aggregation[1] !== null)) {
	            return true;
	        }
	        return false;
	    },
	
	
	    // predicate function to test if the given aggregation clause represents a Bare Rows aggregation
	    isBareRows: function isBareRows(aggregation) {
	        return AggregationClause.isValid(aggregation) && (0, _util.mbqlEq)(aggregation[0], "rows");
	    },
	
	
	    // predicate function to test if a given aggregation clause represents a standard aggregation
	    isStandard: function isStandard(aggregation) {
	        return AggregationClause.isValid(aggregation) && !(0, _util.mbqlEq)(aggregation[0], "metric");
	    },
	    getAggregation: function getAggregation(aggregation) {
	        return aggregation && (0, _util.mbql)(aggregation[0]);
	    },
	
	
	    // predicate function to test if a given aggregation clause represents a metric
	    isMetric: function isMetric(aggregation) {
	        return AggregationClause.isValid(aggregation) && (0, _util.mbqlEq)(aggregation[0], "metric");
	    },
	
	
	    // get the metricId from a metric aggregation clause
	    getMetric: function getMetric(aggregation) {
	        if (aggregation && AggregationClause.isMetric(aggregation)) {
	            return aggregation[1];
	        } else {
	            return null;
	        }
	    },
	    isCustom: function isCustom(aggregation) {
	        // for now treal all named clauses as custom
	        return aggregation && NamedClause.isNamed(aggregation) || (0, _expressions.isMath)(aggregation) || AggregationClause.isStandard(aggregation) && _underscore2.default.any(aggregation.slice(1), function (arg) {
	            return (0, _expressions.isMath)(arg);
	        });
	    },
	
	
	    // get the operator from a standard aggregation clause
	    getOperator: function getOperator(aggregation) {
	        if (aggregation && aggregation.length > 0 && !(0, _util.mbqlEq)(aggregation[0], "metric")) {
	            return aggregation[0];
	        } else {
	            return null;
	        }
	    },
	
	
	    // get the fieldId from a standard aggregation clause
	    getField: function getField(aggregation) {
	        if (aggregation && aggregation.length > 1 && !(0, _util.mbqlEq)(aggregation[0], "metric")) {
	            return aggregation[1];
	        } else {
	            return null;
	        }
	    },
	
	
	    // set the fieldId on a standard aggregation clause
	    setField: function setField(aggregation, fieldId) {
	        if (aggregation && aggregation.length > 0 && aggregation[0] && aggregation[0] !== "METRIC") {
	            return [aggregation[0], fieldId];
	        } else {
	            // TODO: is there a better failure response than just returning the aggregation unmodified??
	            return aggregation;
	        }
	    }
	};
	
	var BreakoutClause = exports.BreakoutClause = {
	    setBreakout: function setBreakout(breakout, index, value) {
	        if (!breakout) {
	            breakout = [];
	        }
	        return [].concat(_toConsumableArray(breakout.slice(0, index)), [value], _toConsumableArray(breakout.slice(index + 1)));
	    },
	    removeBreakout: function removeBreakout(breakout, index) {
	        if (!breakout) {
	            breakout = [];
	        }
	        return [].concat(_toConsumableArray(breakout.slice(0, index)), _toConsumableArray(breakout.slice(index + 1)));
	    }
	};
	
	function joinList(list, joiner) {
	    return _underscore2.default.flatten(list.map(function (l, i) {
	        return i === list.length - 1 ? [l] : [l, joiner];
	    }), true);
	}
	
	function conjunctList(list, conjunction) {
	    switch (list.length) {
	        case 0:
	            return null;
	        case 1:
	            return list[0];
	        case 2:
	            return [list[0], " ", conjunction, " ", list[1]];
	        default:
	            return [list.slice(0, -1).join(", "), ", ", conjunction, " ", list[list.length - 1]];
	    }
	}
	
	exports.default = Query;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ICON_MAPPING = exports.isCompatibleAggregatorForField = exports.isID = exports.isLongitude = exports.isLatitude = exports.isCoordinate = exports.isCountry = exports.isState = exports.isAddress = exports.isNumber = exports.isNumericBaseType = exports.isAny = exports.isPK = exports.isFK = exports.isMetric = exports.isDimension = exports.isCategory = exports.isSummable = exports.isString = exports.isBoolean = exports.isNumeric = exports.isDate = exports.UNKNOWN = exports.DIMENSION = exports.CATEGORY = exports.SUMMABLE = exports.ENTITY = exports.COORDINATE = exports.LOCATION = exports.DATE_TIME = exports.BOOLEAN = exports.STRING_LIKE = exports.STRING = exports.NUMBER = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _TYPES, _OPERATORS_BY_TYPE_OR, _ICON_MAPPING;
	
	exports.isFieldType = isFieldType;
	exports.getFieldType = getFieldType;
	exports.getOperators = getOperators;
	exports.getAggregators = getAggregators;
	exports.getAggregatorsWithFields = getAggregatorsWithFields;
	exports.getAggregator = getAggregator;
	exports.getBreakouts = getBreakouts;
	exports.addValidOperatorsToFields = addValidOperatorsToFields;
	exports.hasLatitudeAndLongitudeColumns = hasLatitudeAndLongitudeColumns;
	exports.foreignKeyCountsByOriginTable = foreignKeyCountsByOriginTable;
	exports.getIconForField = getIconForField;
	exports.computeMetadataStrength = computeMetadataStrength;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _types = __webpack_require__(868);
	
	var _field = __webpack_require__(869);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// primary field types used for picking operators, etc
	var NUMBER = exports.NUMBER = "NUMBER";
	var STRING = exports.STRING = "STRING";
	var STRING_LIKE = exports.STRING_LIKE = "STRING_LIKE";
	var BOOLEAN = exports.BOOLEAN = "BOOLEAN";
	var DATE_TIME = exports.DATE_TIME = "DATE_TIME";
	var LOCATION = exports.LOCATION = "LOCATION";
	var COORDINATE = exports.COORDINATE = "COORDINATE";
	
	// other types used for various purporses
	var ENTITY = exports.ENTITY = "ENTITY";
	var SUMMABLE = exports.SUMMABLE = "SUMMABLE";
	var CATEGORY = exports.CATEGORY = "CATEGORY";
	var DIMENSION = exports.DIMENSION = "DIMENSION";
	
	var UNKNOWN = exports.UNKNOWN = "UNKNOWN";
	
	// define various type hierarchies
	// NOTE: be sure not to create cycles using the "other" types
	var TYPES = (_TYPES = {}, _defineProperty(_TYPES, DATE_TIME, {
	    base: [_types.TYPE.DateTime],
	    special: [_types.TYPE.DateTime]
	}), _defineProperty(_TYPES, NUMBER, {
	    base: [_types.TYPE.Number],
	    special: [_types.TYPE.Number]
	}), _defineProperty(_TYPES, STRING, {
	    base: [_types.TYPE.Text],
	    special: [_types.TYPE.Text]
	}), _defineProperty(_TYPES, STRING_LIKE, {
	    base: [_types.TYPE.TextLike]
	}), _defineProperty(_TYPES, BOOLEAN, {
	    base: [_types.TYPE.Boolean]
	}), _defineProperty(_TYPES, COORDINATE, {
	    special: [_types.TYPE.Coordinate]
	}), _defineProperty(_TYPES, LOCATION, {
	    special: [_types.TYPE.Address]
	}), _defineProperty(_TYPES, ENTITY, {
	    special: [_types.TYPE.FK, _types.TYPE.PK, _types.TYPE.Name]
	}), _defineProperty(_TYPES, SUMMABLE, {
	    include: [NUMBER],
	    exclude: [ENTITY, LOCATION, DATE_TIME]
	}), _defineProperty(_TYPES, CATEGORY, {
	    base: [_types.TYPE.Boolean],
	    special: [_types.TYPE.Category],
	    include: [LOCATION]
	}), _defineProperty(_TYPES, DIMENSION, {
	    include: [DATE_TIME, CATEGORY, ENTITY]
	}), _TYPES);
	
	function isFieldType(type, field) {
	    if (!field) return false;
	
	    var typeDefinition = TYPES[type];
	    // check to see if it belongs to any of the field types:
	    var _arr = ["base", "special"];
	    for (var _i = 0; _i < _arr.length; _i++) {
	        var prop = _arr[_i];
	        var allowedTypes = typeDefinition[prop];
	        if (!allowedTypes) continue;
	
	        var fieldType = field[prop + "_type"];
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = allowedTypes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var allowedType = _step3.value;
	
	                if ((0, _types.isa)(fieldType, allowedType)) return true;
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	    }
	
	    // recursively check to see if it's NOT another field type:
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (typeDefinition.exclude || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var excludedType = _step.value;
	
	            if (isFieldType(excludedType, field)) return false;
	        }
	
	        // recursively check to see if it's another field type:
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = (typeDefinition.include || [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var includedType = _step2.value;
	
	            if (isFieldType(includedType, field)) return true;
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return false;
	}
	
	function getFieldType(field) {
	    // try more specific types first, then more generic types
	    var _arr2 = [DATE_TIME, LOCATION, COORDINATE, NUMBER, STRING, STRING_LIKE, BOOLEAN];
	    for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
	        var type = _arr2[_i2];
	        if (isFieldType(type, field)) return type;
	    }
	}
	
	var isDate = exports.isDate = isFieldType.bind(null, DATE_TIME);
	var isNumeric = exports.isNumeric = isFieldType.bind(null, NUMBER);
	var isBoolean = exports.isBoolean = isFieldType.bind(null, BOOLEAN);
	var isString = exports.isString = isFieldType.bind(null, STRING);
	var isSummable = exports.isSummable = isFieldType.bind(null, SUMMABLE);
	var isCategory = exports.isCategory = isFieldType.bind(null, CATEGORY);
	
	var isDimension = exports.isDimension = function isDimension(col) {
	    return col && col.source !== "aggregation";
	};
	var isMetric = exports.isMetric = function isMetric(col) {
	    return col && col.source !== "breakout" && isSummable(col);
	};
	
	var isFK = exports.isFK = function isFK(field) {
	    return field && (0, _types.isFK)(field.special_type);
	};
	var isPK = exports.isPK = function isPK(field) {
	    return field && (0, _types.isPK)(field.special_type);
	};
	
	var isAny = exports.isAny = function isAny(col) {
	    return true;
	};
	
	var isNumericBaseType = exports.isNumericBaseType = function isNumericBaseType(field) {
	    return (0, _types.isa)(field && field.base_type, _types.TYPE.Number);
	};
	
	// ZipCode, ID, etc derive from Number but should not be formatted as numbers
	var isNumber = exports.isNumber = function isNumber(field) {
	    return field && isNumericBaseType(field) && (field.special_type == null || field.special_type === _types.TYPE.Number);
	};
	
	var isAddress = exports.isAddress = function isAddress(field) {
	    return (0, _types.isa)(field && field.special_type, _types.TYPE.Address);
	};
	var isState = exports.isState = function isState(field) {
	    return (0, _types.isa)(field && field.special_type, _types.TYPE.State);
	};
	var isCountry = exports.isCountry = function isCountry(field) {
	    return (0, _types.isa)(field && field.special_type, _types.TYPE.Country);
	};
	var isCoordinate = exports.isCoordinate = function isCoordinate(field) {
	    return (0, _types.isa)(field && field.special_type, _types.TYPE.Coordinate);
	};
	var isLatitude = exports.isLatitude = function isLatitude(field) {
	    return (0, _types.isa)(field && field.special_type, _types.TYPE.Latitude);
	};
	var isLongitude = exports.isLongitude = function isLongitude(field) {
	    return (0, _types.isa)(field && field.special_type, _types.TYPE.Longitude);
	};
	
	var isID = exports.isID = function isID(field) {
	    return isFK(field) || isPK(field);
	};
	
	// operator argument constructors:
	
	function freeformArgument(field, table) {
	    return {
	        type: "text"
	    };
	}
	
	function numberArgument(field, table) {
	    return {
	        type: "number"
	    };
	}
	
	function comparableArgument(field, table) {
	    if (isDate(field)) {
	        return {
	            type: "date"
	        };
	    }
	
	    if (isNumeric(field)) {
	        return {
	            type: "number"
	        };
	    }
	
	    return {
	        type: "text"
	    };
	}
	
	function equivalentArgument(field, table) {
	    if (isBoolean(field)) {
	        return {
	            type: "select",
	            values: [{ key: true, name: "True" }, { key: false, name: "False" }]
	        };
	    }
	
	    if (isCategory(field)) {
	        var values = (0, _field.getFieldValues)(field);
	        if (values && values.length > 0) {
	            return {
	                type: "select",
	                values: values.filter(function (_ref) {
	                    var _ref2 = _slicedToArray(_ref, 2),
	                        value = _ref2[0],
	                        displayValue = _ref2[1];
	
	                    return value != null;
	                }).map(function (_ref3) {
	                    var _ref4 = _slicedToArray(_ref3, 2),
	                        value = _ref4[0],
	                        displayValue = _ref4[1];
	
	                    return {
	                        key: value,
	                        // NOTE Atte Keinänen 8/7/17: Similar logic as in getHumanReadableValue of lib/query/field
	                        name: displayValue ? displayValue : String(value)
	                    };
	                }).sort(function (a, b) {
	                    return a.key === b.key ? 0 : a.key < b.key ? -1 : 1;
	                })
	            };
	        }
	    }
	
	    if (isDate(field)) {
	        return {
	            type: "date"
	        };
	    }
	
	    if (isNumeric(field)) {
	        return {
	            type: "number"
	        };
	    }
	
	    return {
	        type: "text"
	    };
	}
	
	function longitudeFieldSelectArgument(field, table) {
	    return {
	        type: "select",
	        values: table.fields.filter(function (field) {
	            return (0, _types.isa)(field.special_type, _types.TYPE.Longitude);
	        }).map(function (field) {
	            return {
	                key: field.id,
	                name: field.display_name
	            };
	        })
	    };
	}
	
	var OPERATORS = {
	    "=": {
	        validArgumentsFilters: [equivalentArgument],
	        multi: true
	    },
	    "!=": {
	        validArgumentsFilters: [equivalentArgument],
	        multi: true
	    },
	    "IS_NULL": {
	        validArgumentsFilters: []
	    },
	    "NOT_NULL": {
	        validArgumentsFilters: []
	    },
	    "<": {
	        validArgumentsFilters: [comparableArgument]
	    },
	    "<=": {
	        validArgumentsFilters: [comparableArgument]
	    },
	    ">": {
	        validArgumentsFilters: [comparableArgument]
	    },
	    ">=": {
	        validArgumentsFilters: [comparableArgument]
	    },
	    "INSIDE": {
	        validArgumentsFilters: [longitudeFieldSelectArgument, numberArgument, numberArgument, numberArgument, numberArgument],
	        placeholders: ["Select longitude field", "Enter upper latitude", "Enter left longitude", "Enter lower latitude", "Enter right longitude"]
	    },
	    "BETWEEN": {
	        validArgumentsFilters: [comparableArgument, comparableArgument]
	    },
	    "STARTS_WITH": {
	        validArgumentsFilters: [freeformArgument]
	    },
	    "ENDS_WITH": {
	        validArgumentsFilters: [freeformArgument]
	    },
	    "CONTAINS": {
	        validArgumentsFilters: [freeformArgument]
	    },
	    "DOES_NOT_CONTAIN": {
	        validArgumentsFilters: [freeformArgument]
	    }
	};
	
	// ordered list of operators and metadata per type
	var OPERATORS_BY_TYPE_ORDERED = (_OPERATORS_BY_TYPE_OR = {}, _defineProperty(_OPERATORS_BY_TYPE_OR, NUMBER, [{ name: "=", verboseName: "Equal" }, { name: "!=", verboseName: "Not equal" }, { name: ">", verboseName: "Greater than" }, { name: "<", verboseName: "Less than" }, { name: "BETWEEN", verboseName: "Between" }, { name: ">=", verboseName: "Greater than or equal to", advanced: true }, { name: "<=", verboseName: "Less than or equal to", advanced: true }, { name: "IS_NULL", verboseName: "Is empty", advanced: true }, { name: "NOT_NULL", verboseName: "Not empty", advanced: true }]), _defineProperty(_OPERATORS_BY_TYPE_OR, STRING, [{ name: "=", verboseName: "Is" }, { name: "!=", verboseName: "Is not" }, { name: "CONTAINS", verboseName: "Contains" }, { name: "DOES_NOT_CONTAIN", verboseName: "Does not contain" }, { name: "IS_NULL", verboseName: "Is empty", advanced: true }, { name: "NOT_NULL", verboseName: "Not empty", advanced: true }, { name: "STARTS_WITH", verboseName: "Starts with", advanced: true }, { name: "ENDS_WITH", verboseName: "Ends with", advanced: true }]), _defineProperty(_OPERATORS_BY_TYPE_OR, STRING_LIKE, [{ name: "=", verboseName: "Is" }, { name: "!=", verboseName: "Is not" }, { name: "IS_NULL", verboseName: "Is empty", advanced: true }, { name: "NOT_NULL", verboseName: "Not empty", advanced: true }]), _defineProperty(_OPERATORS_BY_TYPE_OR, DATE_TIME, [{ name: "=", verboseName: "Is" }, { name: "<", verboseName: "Before" }, { name: ">", verboseName: "After" }, { name: "BETWEEN", verboseName: "Between" }, { name: "IS_NULL", verboseName: "Is empty", advanced: true }, { name: "NOT_NULL", verboseName: "Not empty", advanced: true }]), _defineProperty(_OPERATORS_BY_TYPE_OR, LOCATION, [{ name: "=", verboseName: "Is" }, { name: "!=", verboseName: "Is not" }, { name: "IS_NULL", verboseName: "Is empty", advanced: true }, { name: "NOT_NULL", verboseName: "Not empty", advanced: true }]), _defineProperty(_OPERATORS_BY_TYPE_OR, COORDINATE, [{ name: "=", verboseName: "Is" }, { name: "!=", verboseName: "Is not" }, { name: "INSIDE", verboseName: "Inside" }]), _defineProperty(_OPERATORS_BY_TYPE_OR, BOOLEAN, [{ name: "=", verboseName: "Is", multi: false, defaults: [true] }, { name: "IS_NULL", verboseName: "Is empty" }, { name: "NOT_NULL", verboseName: "Not empty" }]), _defineProperty(_OPERATORS_BY_TYPE_OR, UNKNOWN, [{ name: "=", verboseName: "Is" }, { name: "!=", verboseName: "Is not" }, { name: "IS_NULL", verboseName: "Is empty", advanced: true }, { name: "NOT_NULL", verboseName: "Not empty", advanced: true }]), _OPERATORS_BY_TYPE_OR);
	
	var MORE_VERBOSE_NAMES = {
	    "equal": "is equal to",
	    "not equal": "is not equal to",
	    "before": "is before",
	    "after": "is after",
	    "not empty": "is not empty",
	    "less than": "is less than",
	    "greater than": "is greater than",
	    "less than or equal to": "is less than or equal to",
	    "greater than or equal to": "is greater than or equal to"
	};
	
	function getOperators(field, table) {
	    var type = getFieldType(field) || UNKNOWN;
	    return OPERATORS_BY_TYPE_ORDERED[type].map(function (operatorForType) {
	        var operator = OPERATORS[operatorForType.name];
	        var verboseNameLower = operatorForType.verboseName.toLowerCase();
	        return _extends({}, operator, operatorForType, {
	            moreVerboseName: MORE_VERBOSE_NAMES[verboseNameLower] || verboseNameLower,
	            fields: operator.validArgumentsFilters.map(function (validArgumentsFilter) {
	                return validArgumentsFilter(field, table);
	            })
	        });
	    });
	}
	
	// Breakouts and Aggregation options
	function allFields(fields) {
	    return fields;
	}
	
	function summableFields(fields) {
	    return _underscore2.default.filter(fields, isSummable);
	}
	
	function dimensionFields(fields) {
	    return _underscore2.default.filter(fields, isDimension);
	}
	
	var Aggregators = [{
	    name: "Raw data",
	    short: "rows",
	    description: "Just a table with the rows in the answer, no additional operations.",
	    validFieldsFilters: [],
	    requiresField: false,
	    requiredDriverFeature: "basic-aggregations"
	}, {
	    name: "Count of rows",
	    short: "count",
	    description: "Total number of rows in the answer.",
	    validFieldsFilters: [],
	    requiresField: false,
	    requiredDriverFeature: "basic-aggregations"
	}, {
	    name: "Sum of ...",
	    short: "sum",
	    description: "Sum of all the values of a column.",
	    validFieldsFilters: [summableFields],
	    requiresField: true,
	    requiredDriverFeature: "basic-aggregations"
	}, {
	    name: "Average of ...",
	    short: "avg",
	    description: "Average of all the values of a column",
	    validFieldsFilters: [summableFields],
	    requiresField: true,
	    requiredDriverFeature: "basic-aggregations"
	}, {
	    name: "Number of distinct values of ...",
	    short: "distinct",
	    description: "Number of unique values of a column among all the rows in the answer.",
	    validFieldsFilters: [allFields],
	    requiresField: true,
	    requiredDriverFeature: "basic-aggregations"
	}, {
	    name: "Cumulative sum of ...",
	    short: "cum_sum",
	    description: "Additive sum of all the values of a column.\ne.x. total revenue over time.",
	    validFieldsFilters: [summableFields],
	    requiresField: true,
	    requiredDriverFeature: "basic-aggregations"
	}, {
	    name: "Cumulative count of rows",
	    short: "cum_count",
	    description: "Additive count of the number of rows.\ne.x. total number of sales over time.",
	    validFieldsFilters: [],
	    requiresField: false,
	    requiredDriverFeature: "basic-aggregations"
	}, {
	    name: "Standard deviation of ...",
	    short: "stddev",
	    description: "Number which expresses how much the values of a column vary among all rows in the answer.",
	    validFieldsFilters: [summableFields],
	    requiresField: true,
	    requiredDriverFeature: "standard-deviation-aggregations"
	}, {
	    name: "Minimum of ...",
	    short: "min",
	    description: "Minimum value of a column",
	    validFieldsFilters: [summableFields],
	    requiresField: true,
	    requiredDriverFeature: "basic-aggregations"
	}, {
	    name: "Maximum of ...",
	    short: "max",
	    description: "Maximum value of a column",
	    validFieldsFilters: [summableFields],
	    requiresField: true,
	    requiredDriverFeature: "basic-aggregations"
	}];
	
	var BreakoutAggregator = {
	    name: "Break out by dimension",
	    short: "breakout",
	    validFieldsFilters: [dimensionFields]
	};
	
	function populateFields(aggregator, fields) {
	    return {
	        name: aggregator.name,
	        short: aggregator.short,
	        description: aggregator.description || '',
	        advanced: aggregator.advanced || false,
	        fields: _underscore2.default.map(aggregator.validFieldsFilters, function (validFieldsFilterFn) {
	            return validFieldsFilterFn(fields);
	        }),
	        validFieldsFilters: aggregator.validFieldsFilters,
	        requiresField: aggregator.requiresField,
	        requiredDriverFeature: aggregator.requiredDriverFeature
	    };
	}
	
	// TODO: unit test
	function getAggregators(table) {
	    var supportedAggregations = Aggregators.filter(function (agg) {
	        return !(agg.requiredDriverFeature && table.db && !_underscore2.default.contains(table.db.features, agg.requiredDriverFeature));
	    });
	    return _underscore2.default.map(supportedAggregations, function (aggregator) {
	        return populateFields(aggregator, table.fields);
	    });
	}
	
	function getAggregatorsWithFields(table) {
	    return getAggregators(table).filter(function (aggregation) {
	        return !aggregation.requiresField || aggregation.fields.reduce(function (ok, fields) {
	            return ok && fields.length > 0;
	        }, true);
	    });
	}
	
	// TODO: unit test
	function getAggregator(short) {
	    return _underscore2.default.findWhere(Aggregators, { short: short });
	}
	
	var isCompatibleAggregatorForField = exports.isCompatibleAggregatorForField = function isCompatibleAggregatorForField(aggregator, field) {
	    return aggregator.validFieldsFilters.every(function (filter) {
	        return filter([field]).length === 1;
	    });
	};
	
	function getBreakouts(fields) {
	    var result = populateFields(BreakoutAggregator, fields);
	    result.fields = result.fields[0];
	    result.validFieldsFilter = result.validFieldsFilters[0];
	    return result;
	}
	
	function addValidOperatorsToFields(table) {
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	        for (var _iterator4 = table.fields[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var field = _step4.value;
	
	            field.operators = getOperators(field, table);
	        }
	    } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                _iterator4.return();
	            }
	        } finally {
	            if (_didIteratorError4) {
	                throw _iteratorError4;
	            }
	        }
	    }
	
	    table.aggregation_options = getAggregatorsWithFields(table);
	    table.breakout_options = getBreakouts(table.fields);
	    return table;
	}
	
	function hasLatitudeAndLongitudeColumns(columnDefs) {
	    var hasLatitude = false;
	    var hasLongitude = false;
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	        for (var _iterator5 = columnDefs[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var col = _step5.value;
	
	            if ((0, _types.isa)(col.special_type, _types.TYPE.Latitude)) {
	                hasLatitude = true;
	            }
	            if ((0, _types.isa)(col.special_type, _types.TYPE.Longitude)) {
	                hasLongitude = true;
	            }
	        }
	    } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	            }
	        } finally {
	            if (_didIteratorError5) {
	                throw _iteratorError5;
	            }
	        }
	    }
	
	    return hasLatitude && hasLongitude;
	}
	
	function foreignKeyCountsByOriginTable(fks) {
	    if (fks === null || !Array.isArray(fks)) {
	        return null;
	    }
	
	    return fks.map(function (fk) {
	        return 'origin' in fk ? fk.origin.table.id : null;
	    }).reduce(function (prev, curr, idx, array) {
	        if (curr in prev) {
	            prev[curr]++;
	        } else {
	            prev[curr] = 1;
	        }
	
	        return prev;
	    }, {});
	}
	
	var ICON_MAPPING = exports.ICON_MAPPING = (_ICON_MAPPING = {}, _defineProperty(_ICON_MAPPING, DATE_TIME, 'calendar'), _defineProperty(_ICON_MAPPING, LOCATION, 'location'), _defineProperty(_ICON_MAPPING, COORDINATE, 'location'), _defineProperty(_ICON_MAPPING, STRING, 'string'), _defineProperty(_ICON_MAPPING, STRING_LIKE, 'string'), _defineProperty(_ICON_MAPPING, NUMBER, 'int'), _defineProperty(_ICON_MAPPING, BOOLEAN, 'io'), _ICON_MAPPING);
	
	function getIconForField(field) {
	    return ICON_MAPPING[getFieldType(field)];
	}
	
	function computeMetadataStrength(table) {
	    var total = 0;
	    var completed = 0;
	    function score(value) {
	        total++;
	        if (value) {
	            completed++;
	        }
	    }
	
	    score(table.description);
	    if (table.fields) {
	        table.fields.forEach(function (field) {
	            score(field.description);
	            score(field.special_type);
	            if (isFK(field)) {
	                score(field.target);
	            }
	        });
	    }
	
	    return completed / total;
	}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TYPE = undefined;
	exports.isa = isa;
	exports.isPK = isPK;
	exports.isFK = isFK;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PARENTS = _settings2.default.get("types");
	
	/// Basically exactly the same as Clojure's isa?
	/// Recurses through the type hierarchy until it can give you an anser.
	/// isa(TYPE.BigInteger, TYPE.Number) -> true
	/// isa(TYPE.Text, TYPE.Boolean) -> false
	function isa(child, ancestor) {
	    if (!child || !ancestor) return false;
	
	    if (child === ancestor) return true;
	
	    var parents = PARENTS[child];
	    if (!parents) {
	        if (child !== "type/*") console.error("Invalid type:", child); // the base type is the only type with no parents, so anything else that gets here is invalid
	        return false;
	    }
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = parents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var parent = _step.value;
	
	            if (isa(parent, ancestor)) return true;
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return false;
	}
	
	// build a pretty sweet dictionary of top-level types, so people can do TYPE.Latitude instead of "type/Latitude" and get error messages / etc.
	// this should also make it easier to keep track of things when we tweak the type hierarchy
	var TYPE = exports.TYPE = {};
	var _iteratorNormalCompletion2 = true;
	var _didIteratorError2 = false;
	var _iteratorError2 = undefined;
	
	try {
	    for (var _iterator2 = _underscore2.default.keys(PARENTS)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var type = _step2.value;
	
	        var key = type.substring(5); // strip off "type/"
	        TYPE[key] = type;
	    }
	
	    // convenience functions since these operations are super-common
	    // this will also make it easier to tweak how these checks work in the future,
	    // e.g. when we add an `is_pk` column and eliminate the PK special type we can just look for places that use isPK
	} catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	} finally {
	    try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	        }
	    } finally {
	        if (_didIteratorError2) {
	            throw _iteratorError2;
	        }
	    }
	}
	
	function isPK(type) {
	    return isa(type, TYPE.PK);
	}
	
	function isFK(type) {
	    return isa(type, TYPE.FK);
	}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getFieldTargetId = getFieldTargetId;
	exports.isRegularField = isRegularField;
	exports.isLocalField = isLocalField;
	exports.isForeignKeyField = isForeignKeyField;
	exports.isDatetimeField = isDatetimeField;
	exports.isBinningStrategy = isBinningStrategy;
	exports.isFieldLiteral = isFieldLiteral;
	exports.isExpressionField = isExpressionField;
	exports.isAggregateField = isAggregateField;
	exports.getFieldValues = getFieldValues;
	exports.getHumanReadableValue = getHumanReadableValue;
	
	var _util = __webpack_require__(870);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// gets the target field ID (recursively) from any type of field, including raw field ID, fk->, and datetime-field cast.
	function getFieldTargetId(field) {
	    if (isRegularField(field)) {
	        // $FlowFixMe
	        return field;
	    } else if (isLocalField(field)) {
	        // $FlowFixMe
	        return field[1];
	    } else if (isForeignKeyField(field)) {
	        // $FlowFixMe
	        return getFieldTargetId(field[2]);
	    } else if (isDatetimeField(field)) {
	        // $FlowFixMe
	        return getFieldTargetId(field[1]);
	    } else if (isBinningStrategy(field)) {
	        // $FlowFixMe
	        return getFieldTargetId(field[1]);
	    } else if (isFieldLiteral(field)) {
	        return field;
	    }
	    console.warn("Unknown field type: ", field);
	}
	
	function isRegularField(field) {
	    return typeof field === "number";
	}
	
	function isLocalField(field) {
	    return Array.isArray(field) && (0, _util.mbqlEq)(field[0], "field-id");
	}
	
	function isForeignKeyField(field) {
	    return Array.isArray(field) && (0, _util.mbqlEq)(field[0], "fk->");
	}
	
	function isDatetimeField(field) {
	    return Array.isArray(field) && (0, _util.mbqlEq)(field[0], "datetime-field");
	}
	
	function isBinningStrategy(field) {
	    return Array.isArray(field) && (0, _util.mbqlEq)(field[0], "binning-strategy");
	}
	
	function isFieldLiteral(field) {
	    return Array.isArray(field) && field.length === 3 && (0, _util.mbqlEq)(field[0], "field-literal");
	}
	
	function isExpressionField(field) {
	    return Array.isArray(field) && field.length === 2 && (0, _util.mbqlEq)(field[0], "expression");
	}
	
	function isAggregateField(field) {
	    return Array.isArray(field) && (0, _util.mbqlEq)(field[0], "aggregation");
	}
	
	// Metadata field "values" type is inconsistent
	// https://github.com/metabase/metabase/issues/3417
	function getFieldValues(field) {
	    var values = field && field.values;
	    if (Array.isArray(values)) {
	        if (values.length === 0 || Array.isArray(values[0])) {
	            return values;
	        } else {
	            // console.warn("deprecated field values array!", values);
	            return values.map(function (value) {
	                return [value];
	            });
	        }
	    } else if (values && Array.isArray(values.values)) {
	        // console.warn("deprecated field values object!", values);
	
	        if (Array.isArray(values.human_readable_values)) {
	            return _underscore2.default.zip(values.values, values.human_readable_values || {});
	        } else if (Array.isArray(values.values)) {
	            // TODO Atte Keinänen 7/12/17: I don't honestly know why we can have a field in `values` property.
	            return getFieldValues(values);
	        } else {
	            // console.warn("missing field values", field);
	            return [];
	        }
	    } else {
	        // console.warn("missing field values", field);
	        return [];
	    }
	}
	
	function getHumanReadableValue(value) {
	    var fieldValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var fieldValue = _underscore2.default.findWhere(fieldValues, _defineProperty({}, 0, value));
	    return fieldValue && fieldValue.length === 2 ? fieldValue[1] : String(value);
	}

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.clear = exports.remove = exports.update = exports.add = exports.args = exports.op = exports.noNullValues = exports.fieldIdsEq = exports.mbqlEq = exports.mbql = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var mbql = exports.mbql = function mbql(a) {
	    return typeof a === "string" ? a.toLowerCase().replace(/_/g, "-") : a;
	};
	
	var mbqlEq = exports.mbqlEq = function mbqlEq(a, b) {
	    return mbql(a) === mbql(b);
	};
	
	// determines whether 2 field IDs are equal. This is needed rather than
	// doing a simple comparison because field IDs are not guaranteed to be numeric:
	// the might be FieldLiterals, e.g. [field-literal <name> <unit>], instead.
	var fieldIdsEq = exports.fieldIdsEq = function fieldIdsEq(a, b) {
	    if ((typeof a === "undefined" ? "undefined" : _typeof(a)) !== (typeof b === "undefined" ? "undefined" : _typeof(b))) return false;
	
	    if (typeof a === "number") return a === b;
	
	    if (a == null && b == null) return true;
	
	    // field literals
	    if (Array.isArray(a) && Array.isArray(b) && a.length === 3 && b.length === 3 && a[0] === "field-literal" && b[0] === "field-literal") {
	        return a[1] === b[1];
	    }
	
	    console.warn("Don't know how to compare these IDs:", a, b);
	    return false;
	};
	
	var noNullValues = exports.noNullValues = function noNullValues(clause) {
	    return _underscore2.default.all(clause, function (c) {
	        return c != null;
	    });
	};
	
	// these are mostly to circumvent Flow type checking :-/
	var op = exports.op = function op(clause) {
	    return clause[0];
	};
	var args = exports.args = function args(clause) {
	    return clause.slice(1);
	};
	
	var add = exports.add = function add(items, item) {
	    return [].concat(_toConsumableArray(items), [item]);
	};
	var update = exports.update = function update(items, index, newItem) {
	    return [].concat(_toConsumableArray(items.slice(0, index)), [newItem], _toConsumableArray(items.slice(index + 1)));
	};
	var remove = exports.remove = function remove(items, index) {
	    return [].concat(_toConsumableArray(items.slice(0, index)), _toConsumableArray(items.slice(index + 1)));
	};
	var clear = exports.clear = function clear() {
	    return [];
	};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.augmentTable = exports.loadTableAndForeignKeys = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var loadTableAndForeignKeys = exports.loadTableAndForeignKeys = function () {
	    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(tableId) {
	        var _ref2, _ref3, table, foreignKeys;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return Promise.all([_services.MetabaseApi.table_query_metadata({ tableId: tableId }), _services.MetabaseApi.table_fks({ tableId: tableId })]);
	
	                    case 2:
	                        _ref2 = _context.sent;
	                        _ref3 = _slicedToArray(_ref2, 2);
	                        table = _ref3[0];
	                        foreignKeys = _ref3[1];
	                        _context.next = 8;
	                        return augmentTable(table);
	
	                    case 8:
	                        return _context.abrupt("return", {
	                            table: table,
	                            foreignKeys: foreignKeys
	                        });
	
	                    case 9:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, this);
	    }));
	
	    return function loadTableAndForeignKeys(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var augmentTable = exports.augmentTable = function () {
	    var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(table) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        table = populateQueryOptions(table);
	                        _context2.next = 3;
	                        return loadForeignKeyTables(table);
	
	                    case 3:
	                        table = _context2.sent;
	                        return _context2.abrupt("return", table);
	
	                    case 5:
	                    case "end":
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, this);
	    }));
	
	    return function augmentTable(_x2) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	
	var loadForeignKeyTables = function () {
	    var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(table) {
	        var _this = this;
	
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	            while (1) {
	                switch (_context4.prev = _context4.next) {
	                    case 0:
	                        _context4.next = 2;
	                        return Promise.all(table.fields.filter(function (f) {
	                            return f.target != null;
	                        }).map(function () {
	                            var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(field) {
	                                var targetTable;
	                                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                                    while (1) {
	                                        switch (_context3.prev = _context3.next) {
	                                            case 0:
	                                                _context3.next = 2;
	                                                return _services.MetabaseApi.table_query_metadata({ tableId: field.target.table_id });
	
	                                            case 2:
	                                                targetTable = _context3.sent;
	
	                                                field.target.table = populateQueryOptions(targetTable);
	
	                                            case 4:
	                                            case "end":
	                                                return _context3.stop();
	                                        }
	                                    }
	                                }, _callee3, _this);
	                            }));
	
	                            return function (_x4) {
	                                return _ref6.apply(this, arguments);
	                            };
	                        }()));
	
	                    case 2:
	                        return _context4.abrupt("return", table);
	
	                    case 3:
	                    case "end":
	                        return _context4.stop();
	                }
	            }
	        }, _callee4, this);
	    }));
	
	    return function loadForeignKeyTables(_x3) {
	        return _ref5.apply(this, arguments);
	    };
	}();
	
	exports.isQueryable = isQueryable;
	exports.augmentDatabase = augmentDatabase;
	exports.createLookupByProperty = createLookupByProperty;
	
	var _schema_metadata = __webpack_require__(867);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function isQueryable(table) {
	    return table.visibility_type == null;
	}
	
	function augmentDatabase(database) {
	    database.tables_lookup = createLookupByProperty(database.tables, "id");
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = database.tables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var table = _step.value;
	
	            (0, _schema_metadata.addValidOperatorsToFields)(table);
	            table.fields_lookup = createLookupByProperty(table.fields, "id");
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = table.fields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var field = _step2.value;
	
	                    addFkTargets(field, database.tables_lookup);
	                    field.operators_lookup = createLookupByProperty(field.operators, "name");
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return database;
	}
	
	function populateQueryOptions(table) {
	    table = (0, _schema_metadata.addValidOperatorsToFields)(table);
	
	    table.fields_lookup = {};
	
	    _underscore2.default.each(table.fields, function (field) {
	        table.fields_lookup[field.id] = field;
	        field.operators_lookup = {};
	        _underscore2.default.each(field.operators, function (operator) {
	            field.operators_lookup[operator.name] = operator;
	        });
	    });
	
	    return table;
	}
	
	function addFkTargets(field, tables) {
	    if (field.target != null) {
	        field.target.table = tables[field.target.table_id];
	    }
	}
	
	function createLookupByProperty(items, property) {
	    return items.reduce(function (lookup, item) {
	        lookup[item[property]] = item;
	        return lookup;
	    }, {});
	}

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.formatNumber = formatNumber;
	exports.formatCoordinate = formatCoordinate;
	exports.formatRange = formatRange;
	exports.formatTimeRangeWithUnit = formatTimeRangeWithUnit;
	exports.formatTimeWithUnit = formatTimeWithUnit;
	exports.formatEmail = formatEmail;
	exports.formatUrl = formatUrl;
	exports.formatValue = formatValue;
	exports.formatColumn = formatColumn;
	exports.formatField = formatField;
	exports.singularize = singularize;
	exports.pluralize = pluralize;
	exports.capitalize = capitalize;
	exports.inflect = inflect;
	exports.titleize = titleize;
	exports.humanize = humanize;
	exports.duration = duration;
	exports.stripId = stripId;
	exports.slugify = slugify;
	exports.assignUserColors = assignUserColors;
	exports.formatSQL = formatSQL;
	
	var _d = __webpack_require__(873);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _inflection = __webpack_require__(520);
	
	var _inflection2 = _interopRequireDefault(_inflection);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _humanizePlus = __webpack_require__(874);
	
	var _humanizePlus2 = _interopRequireDefault(_humanizePlus);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExternalLink = __webpack_require__(875);
	
	var _ExternalLink2 = _interopRequireDefault(_ExternalLink);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _types = __webpack_require__(868);
	
	var _time = __webpack_require__(876);
	
	var _dataset = __webpack_require__(877);
	
	var _utils = __webpack_require__(878);
	
	var _numeric = __webpack_require__(882);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRECISION_NUMBER_FORMATTER = _d2.default.format(".2r");
	var FIXED_NUMBER_FORMATTER = _d2.default.format(",.f");
	var FIXED_NUMBER_FORMATTER_NO_COMMA = _d2.default.format(".f");
	var DECIMAL_DEGREES_FORMATTER = _d2.default.format(".08f");
	var BINNING_DEGREES_FORMATTER = function BINNING_DEGREES_FORMATTER(value, binWidth) {
	    return _d2.default.format(".0" + (0, _numeric.decimalCount)(binWidth) + "f")(value);
	};
	
	// use en dashes, for Maz
	var RANGE_SEPARATOR = " \u2013 ";
	
	function formatNumber(number) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    options = _extends({ comma: true }, options);
	    if (options.compact) {
	        if (number === 0) {
	            // 0 => 0
	            return "0";
	        } else if (number >= -0.01 && number <= 0.01) {
	            // 0.01 => ~0
	            return "~ 0";
	        } else if (number > -1 && number < 1) {
	            // 0.1 => 0.1
	            return PRECISION_NUMBER_FORMATTER(number).replace(/\.?0+$/, "");
	        } else {
	            // 1 => 1
	            // 1000 => 1K
	            return _humanizePlus2.default.compactInteger(number, 1);
	        }
	    } else if (number > -1 && number < 1) {
	        // numbers between 1 and -1 round to 2 significant digits with extra 0s stripped off
	        return PRECISION_NUMBER_FORMATTER(number).replace(/\.?0+$/, "");
	    } else {
	        // anything else rounds to at most 2 decimal points
	        if (options.comma) {
	            return FIXED_NUMBER_FORMATTER(_d2.default.round(number, 2));
	        } else {
	            return FIXED_NUMBER_FORMATTER_NO_COMMA(_d2.default.round(number, 2));
	        }
	    }
	}
	
	function formatCoordinate(value) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var binWidth = options.column && options.column.binning_info && options.column.binning_info.bin_width;
	    var direction = "";
	    if ((0, _schema_metadata.isLatitude)(options.column)) {
	        direction = " " + (value < 0 ? "S" : "N");
	        value = Math.abs(value);
	    } else if ((0, _schema_metadata.isLongitude)(options.column)) {
	        direction = " " + (value < 0 ? "W" : "E");
	        value = Math.abs(value);
	    }
	
	    var formattedValue = binWidth ? BINNING_DEGREES_FORMATTER(value, binWidth) : DECIMAL_DEGREES_FORMATTER(value);
	    return formattedValue + "°" + direction;
	}
	
	function formatRange(range, formatter) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    return range.map(function (value) {
	        return formatter(value, options);
	    }).join(" " + RANGE_SEPARATOR + " ");
	}
	
	function formatMajorMinor(major, minor) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    options = _extends({
	        jsx: false,
	        majorWidth: 3
	    }, options);
	    if (options.jsx) {
	        return _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                "span",
	                { style: { minWidth: options.majorWidth + "em" }, className: "inline-block text-right text-bold" },
	                major
	            ),
	            " - ",
	            _react2.default.createElement(
	                "span",
	                null,
	                minor
	            )
	        );
	    } else {
	        return major + " - " + minor;
	    }
	}
	
	/** This formats a time with unit as a date range */
	function formatTimeRangeWithUnit(value, unit) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var m = (0, _time.parseTimestamp)(value, unit);
	    if (!m.isValid()) {
	        return String(value);
	    }
	
	    // Tooltips should show full month name, but condense "MMMM D, YYYY - MMMM D, YYYY" to "MMMM D - D, YYYY" etc
	    var monthFormat = options.type === "tooltip" ? "MMMM" : "MMM";
	    var condensed = options.type === "tooltip";
	
	    var start = m.clone().startOf(unit);
	    var end = m.clone().endOf(unit);
	    if (start.isValid() && end.isValid()) {
	        if (!condensed || start.year() !== end.year()) {
	            return start.format(monthFormat + " D, YYYY") + RANGE_SEPARATOR + end.format(monthFormat + " D, YYYY");
	        } else if (start.month() !== end.month()) {
	            return start.format(monthFormat + " D") + RANGE_SEPARATOR + end.format(monthFormat + " D, YYYY");
	        } else {
	            return start.format(monthFormat + " D") + RANGE_SEPARATOR + end.format("D, YYYY");
	        }
	    } else {
	        return formatWeek(m, options);
	    }
	}
	
	function formatWeek(m) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    // force 'en' locale for now since our weeks currently always start on Sundays
	    m = m.locale("en");
	    return formatMajorMinor(m.format("wo"), m.format("gggg"), options);
	}
	
	function formatTimeWithUnit(value, unit) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var m = (0, _time.parseTimestamp)(value, unit);
	    if (!m.isValid()) {
	        return String(value);
	    }
	
	    switch (unit) {
	        case "hour":
	            // 12 AM - January 1, 2015
	            return formatMajorMinor(m.format("h A"), m.format("MMMM D, YYYY"), options);
	        case "day":
	            // January 1, 2015
	            return m.format("MMMM D, YYYY");
	        case "week":
	            // 1st - 2015
	            if (options.type === "tooltip") {
	                // tooltip show range like "January 1 - 7, 2017"
	                return formatTimeRangeWithUnit(value, unit, options);
	            } else if (options.type === "cell") {
	                // table cells show range like "Jan 1, 2017 - Jan 7, 2017"
	                return formatTimeRangeWithUnit(value, unit, options);
	            } else if (options.type === "axis") {
	                // axis ticks show start of the week as "Jan 1"
	                return m.clone().startOf(unit).format("MMM D");
	            } else {
	                return formatWeek(m, options);
	            }
	        case "month":
	            // January 2015
	            return options.jsx ? _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "span",
	                    { className: "text-bold" },
	                    m.format("MMMM")
	                ),
	                " ",
	                m.format("YYYY")
	            ) : m.format("MMMM") + " " + m.format("YYYY");
	        case "year":
	            // 2015
	            return m.format("YYYY");
	        case "quarter":
	            // Q1 - 2015
	            return formatMajorMinor(m.format("[Q]Q"), m.format("YYYY"), _extends({}, options, { majorWidth: 0 }));
	        case "hour-of-day":
	            // 12 AM
	            return (0, _moment2.default)().hour(value).format("h A");
	        case "day-of-week":
	            // Sunday
	            // $FlowFixMe:
	            return (0, _moment2.default)().day(value - 1).format("dddd");
	        case "day-of-month":
	            return (0, _moment2.default)().date(value).format("D");
	        case "week-of-year":
	            // 1st
	            return (0, _moment2.default)().week(value).format("wo");
	        case "month-of-year":
	            // January
	            // $FlowFixMe:
	            return (0, _moment2.default)().month(value - 1).format("MMMM");
	        case "quarter-of-year":
	            // January
	            return (0, _moment2.default)().quarter(value).format("[Q]Q");
	        default:
	            return m.format("LLLL");
	    }
	}
	
	// https://github.com/angular/angular.js/blob/v1.6.3/src/ng/directive/input.js#L27
	var EMAIL_WHITELIST_REGEX = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	
	function formatEmail(value) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        jsx = _ref.jsx;
	
	    var email = String(value);
	    if (jsx && EMAIL_WHITELIST_REGEX.test(email)) {
	        return _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "mailto:" + email },
	            email
	        );
	    } else {
	        return email;
	    }
	}
	
	// based on https://github.com/angular/angular.js/blob/v1.6.3/src/ng/directive/input.js#L25
	var URL_WHITELIST_REGEX = /^(https?|mailto):\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	
	function formatUrl(value) {
	    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        jsx = _ref2.jsx;
	
	    var url = String(value);
	    if (jsx && URL_WHITELIST_REGEX.test(url)) {
	        return _react2.default.createElement(
	            _ExternalLink2.default,
	            { className: "link link--wrappable", href: url },
	            url
	        );
	    } else {
	        return url;
	    }
	}
	
	// fallback for formatting a string without a column special_type
	function formatStringFallback(value) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    value = formatUrl(value, options);
	    if (typeof value === 'string') {
	        value = formatEmail(value, options);
	    }
	    return value;
	}
	
	function formatValue(value) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var column = options.column;
	
	    options = _extends({
	        jsx: false,
	        comma: (0, _schema_metadata.isNumber)(column)
	    }, options);
	
	    // "column" may also be a field object
	    // $FlowFixMe: remapping is a special field added by Visualization.jsx or getMetadata selector
	    if (column && column.remapping && column.remapping.size > 0) {
	        // $FlowFixMe
	        var remappedValueSample = column.remapping.values().next().value;
	
	        // Even if the column only has a list of analyzed values without remappings, those values
	        // are keys in `remapping` array with value `undefined`
	        var hasSetRemappings = remappedValueSample !== undefined;
	        if (hasSetRemappings) {
	            // $FlowFixMe
	            if (column.remapping.has(value)) {
	                // $FlowFixMe
	                return column.remapping.get(value);
	            }
	
	            var remappedValueIsString = typeof remappedValueSample === "undefined" ? "undefined" : _typeof(remappedValueSample);
	            if (remappedValueIsString) {
	                // A simple way to hide intermediate ticks for a numeral value that has been remapped to a string
	                return null;
	            }
	        }
	    }
	
	    if (value == undefined) {
	        return null;
	    } else if (column && (0, _types.isa)(column.special_type, _types.TYPE.URL)) {
	        return formatUrl(value, options);
	    } else if (column && (0, _types.isa)(column.special_type, _types.TYPE.Email)) {
	        return formatEmail(value, options);
	    } else if (column && column.unit != null) {
	        return formatTimeWithUnit(value, column.unit, options);
	    } else if ((0, _schema_metadata.isDate)(column) || _moment2.default.isDate(value) || _moment2.default.isMoment(value) || (0, _moment2.default)(value, ["YYYY-MM-DD'T'HH:mm:ss.SSSZ"], true).isValid()) {
	        return (0, _time.parseTimestamp)(value, column && column.unit).format("LLLL");
	    } else if (typeof value === "string") {
	        return formatStringFallback(value, options);
	    } else if (typeof value === "number") {
	        var formatter = (0, _schema_metadata.isCoordinate)(column) ? formatCoordinate : formatNumber;
	        var range = (0, _dataset.rangeForValue)(value, options.column);
	        if (range) {
	            return formatRange(range, formatter, options);
	        } else {
	            return formatter(value, options);
	        }
	    } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
	        // no extra whitespace for table cells
	        return JSON.stringify(value);
	    } else {
	        return String(value);
	    }
	}
	
	function formatColumn(column) {
	    if (!column) {
	        return "";
	    } else if (column.remapped_to_column != null) {
	        // $FlowFixMe: remapped_to_column is a special field added by Visualization.jsx
	        return formatColumn(column.remapped_to_column);
	    } else {
	        var columnTitle = (0, _utils.getFriendlyName)(column);
	        if (column.unit && column.unit !== "default") {
	            columnTitle += ": " + capitalize(column.unit.replace(/-/g, " "));
	        }
	        return columnTitle;
	    }
	}
	
	function formatField(field) {
	    if (!field) {
	        return "";
	    } else if (field.dimensions && field.dimensions.name) {
	        return field.dimensions.name;
	    } else {
	        return field.display_name || field.name;
	    }
	}
	
	// $FlowFixMe
	function singularize() {
	    return _inflection2.default.singularize.apply(_inflection2.default, arguments);
	}
	
	// $FlowFixMe
	function pluralize() {
	    return _inflection2.default.pluralize.apply(_inflection2.default, arguments);
	}
	
	// $FlowFixMe
	function capitalize() {
	    return _inflection2.default.capitalize.apply(_inflection2.default, arguments);
	}
	
	// $FlowFixMe
	function inflect() {
	    return _inflection2.default.inflect.apply(_inflection2.default, arguments);
	}
	
	// $FlowFixMe
	function titleize() {
	    return _inflection2.default.titleize.apply(_inflection2.default, arguments);
	}
	
	// $FlowFixMe
	function humanize() {
	    return _inflection2.default.humanize.apply(_inflection2.default, arguments);
	}
	
	function duration(milliseconds) {
	    if (milliseconds < 60000) {
	        var seconds = Math.round(milliseconds / 1000);
	        return seconds + " " + inflect("second", seconds);
	    } else {
	        var minutes = Math.round(milliseconds / 1000 / 60);
	        return minutes + " " + inflect("minute", minutes);
	    }
	}
	
	// Removes trailing "id" from field names
	function stripId(name) {
	    return name && name.replace(/ id$/i, "");
	}
	
	function slugify(name) {
	    return name && name.toLowerCase().replace(/[^a-z0-9_]/g, "_");
	}
	
	function assignUserColors(userIds, currentUserId) {
	    var colorClasses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['bg-brand', 'bg-purple', 'bg-error', 'bg-green', 'bg-gold', 'bg-grey-2'];
	
	    var assignments = {};
	
	    var currentUserColor = colorClasses[0];
	    var otherUserColors = colorClasses.slice(1);
	    var otherUserColorIndex = 0;
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = userIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var userId = _step.value;
	
	            if (!(userId in assignments)) {
	                if (userId === currentUserId) {
	                    assignments[userId] = currentUserColor;
	                } else if (userId != null) {
	                    assignments[userId] = otherUserColors[otherUserColorIndex++ % otherUserColors.length];
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return assignments;
	}
	
	function formatSQL(sql) {
	    if (typeof sql === "string") {
	        sql = sql.replace(/\sFROM/, "\nFROM");
	        sql = sql.replace(/\sLEFT JOIN/, "\nLEFT JOIN");
	        sql = sql.replace(/\sWHERE/, "\nWHERE");
	        sql = sql.replace(/\sGROUP BY/, "\nGROUP BY");
	        sql = sql.replace(/\sORDER BY/, "\nORDER BY");
	        sql = sql.replace(/\sLIMIT/, "\nLIMIT");
	        sql = sql.replace(/\sAND\s/, "\n   AND ");
	        sql = sql.replace(/\sOR\s/, "\n    OR ");
	
	        return sql;
	    }
	}

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* humanize.js - v1.8.2 */
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	/**
	 * Copyright 2013-2016 HubSpotDev
	 * MIT Licensed
	 *
	 * @module humanize.js
	 */
	
	(function (root, factory) {
	  if (( false ? 'undefined' : _typeof(exports)) === 'object') {
	    module.exports = factory();
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return root.Humanize = factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    root.Humanize = factory();
	  }
	})(this, function () {
	  //------------------------------------------------------------------------------
	  // Constants
	  //------------------------------------------------------------------------------
	
	  var TIME_FORMATS = [{
	    name: 'second',
	    value: 1e3
	  }, {
	    name: 'minute',
	    value: 6e4
	  }, {
	    name: 'hour',
	    value: 36e5
	  }, {
	    name: 'day',
	    value: 864e5
	  }, {
	    name: 'week',
	    value: 6048e5
	  }];
	
	  var LABELS_FOR_POWERS_OF_KILO = {
	    P: Math.pow(2, 50),
	    T: Math.pow(2, 40),
	    G: Math.pow(2, 30),
	    M: Math.pow(2, 20)
	  };
	
	  //------------------------------------------------------------------------------
	  // Helpers
	  //------------------------------------------------------------------------------
	
	  var exists = function exists(maybe) {
	    return typeof maybe !== 'undefined' && maybe !== null;
	  };
	
	  var isNaN = function isNaN(value) {
	    return value !== value;
	  }; // eslint-disable-line
	
	  var isFiniteNumber = function isFiniteNumber(value) {
	    return isFinite(value) && !isNaN(parseFloat(value));
	  };
	
	  var isArray = function isArray(value) {
	    var type = Object.prototype.toString.call(value);
	    return type === '[object Array]';
	  };
	
	  //------------------------------------------------------------------------------
	  // Humanize
	  //------------------------------------------------------------------------------
	
	  var Humanize = {
	
	    // Converts a large integer to a friendly text representation.
	
	    intword: function intword(number, charWidth) {
	      var decimals = arguments.length <= 2 || arguments[2] === undefined ? 2 : arguments[2];
	
	      /*
	      * This method is deprecated. Please use compactInteger instead.
	      * intword will be going away in the next major version.
	      */
	      return Humanize.compactInteger(number, decimals);
	    },
	
	
	    // Converts an integer into its most compact representation
	    compactInteger: function compactInteger(input) {
	      var decimals = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	      decimals = Math.max(decimals, 0);
	      var number = parseInt(input, 10);
	      var signString = number < 0 ? '-' : '';
	      var unsignedNumber = Math.abs(number);
	      var unsignedNumberString = String(unsignedNumber);
	      var numberLength = unsignedNumberString.length;
	      var numberLengths = [13, 10, 7, 4];
	      var bigNumPrefixes = ['T', 'B', 'M', 'k'];
	
	      // small numbers
	      if (unsignedNumber < 1000) {
	        return '' + signString + unsignedNumberString;
	      }
	
	      // really big numbers
	      if (numberLength > numberLengths[0] + 3) {
	        return number.toExponential(decimals).replace('e+', 'x10^');
	      }
	
	      // 999 < unsignedNumber < 999,999,999,999,999
	      var length = void 0;
	      for (var i = 0; i < numberLengths.length; i++) {
	        var _length = numberLengths[i];
	        if (numberLength >= _length) {
	          length = _length;
	          break;
	        }
	      }
	
	      var decimalIndex = numberLength - length + 1;
	      var unsignedNumberCharacterArray = unsignedNumberString.split('');
	
	      var wholePartArray = unsignedNumberCharacterArray.slice(0, decimalIndex);
	      var decimalPartArray = unsignedNumberCharacterArray.slice(decimalIndex, decimalIndex + decimals + 1);
	
	      var wholePart = wholePartArray.join('');
	
	      // pad decimalPart if necessary
	      var decimalPart = decimalPartArray.join('');
	      if (decimalPart.length < decimals) {
	        decimalPart += '' + Array(decimals - decimalPart.length + 1).join('0');
	      }
	
	      var output = void 0;
	      if (decimals === 0) {
	        output = '' + signString + wholePart + bigNumPrefixes[numberLengths.indexOf(length)];
	      } else {
	        var outputNumber = Number(wholePart + '.' + decimalPart).toFixed(decimals);
	        output = '' + signString + outputNumber + bigNumPrefixes[numberLengths.indexOf(length)];
	      }
	
	      return output;
	    },
	
	
	    // Converts an integer to a string containing commas every three digits.
	    intComma: function intComma(number) {
	      var decimals = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	      return Humanize.formatNumber(number, decimals);
	    },
	    intcomma: function intcomma() {
	      return Humanize.intComma.apply(Humanize, arguments);
	    },
	
	
	    // Formats the value like a 'human-readable' file size (i.e. '13 KB', '4.1 MB', '102 bytes', etc).
	    fileSize: function fileSize(filesize) {
	      var precision = arguments.length <= 1 || arguments[1] === undefined ? 2 : arguments[1];
	
	      for (var label in LABELS_FOR_POWERS_OF_KILO) {
	        if (LABELS_FOR_POWERS_OF_KILO.hasOwnProperty(label)) {
	          var minnum = LABELS_FOR_POWERS_OF_KILO[label];
	          if (filesize >= minnum) {
	            return Humanize.formatNumber(filesize / minnum, precision, '') + ' ' + label + 'B';
	          }
	        }
	      }
	      if (filesize >= 1024) {
	        return Humanize.formatNumber(filesize / 1024, 0) + ' KB';
	      }
	
	      return Humanize.formatNumber(filesize, 0) + Humanize.pluralize(filesize, ' byte');
	    },
	    filesize: function filesize() {
	      return Humanize.fileSize.apply(Humanize, arguments);
	    },
	
	
	    // Formats a number to a human-readable string.
	    // Localize by overriding the precision, thousand and decimal arguments.
	    formatNumber: function formatNumber(number) {
	      var precision = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	      var thousand = arguments.length <= 2 || arguments[2] === undefined ? ',' : arguments[2];
	      var decimal = arguments.length <= 3 || arguments[3] === undefined ? '.' : arguments[3];
	
	      // Create some private utility functions to make the computational
	      // code that follows much easier to read.
	      var firstComma = function firstComma(_number, _thousand, _position) {
	        return _position ? _number.substr(0, _position) + _thousand : '';
	      };
	
	      var commas = function commas(_number, _thousand, _position) {
	        return _number.substr(_position).replace(/(\d{3})(?=\d)/g, '$1' + _thousand);
	      };
	
	      var decimals = function decimals(_number, _decimal, usePrecision) {
	        return usePrecision ? _decimal + Humanize.toFixed(Math.abs(_number), usePrecision).split('.')[1] : '';
	      };
	
	      var usePrecision = Humanize.normalizePrecision(precision);
	
	      // Do some calc
	      var negative = number < 0 && '-' || '';
	      var base = String(parseInt(Humanize.toFixed(Math.abs(number || 0), usePrecision), 10));
	      var mod = base.length > 3 ? base.length % 3 : 0;
	
	      // Format the number
	      return negative + firstComma(base, thousand, mod) + commas(base, thousand, mod) + decimals(number, decimal, usePrecision);
	    },
	
	
	    // Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61')
	    toFixed: function toFixed(value, precision) {
	      precision = exists(precision) ? precision : Humanize.normalizePrecision(precision, 0);
	      var power = Math.pow(10, precision);
	
	      // Multiply up by precision, round accurately, then divide and use native toFixed()
	      return (Math.round(value * power) / power).toFixed(precision);
	    },
	
	
	    // Ensures precision value is a positive integer
	    normalizePrecision: function normalizePrecision(value, base) {
	      value = Math.round(Math.abs(value));
	      return isNaN(value) ? base : value;
	    },
	
	
	    // Converts an integer to its ordinal as a string.
	    ordinal: function ordinal(value) {
	      var number = parseInt(value, 10);
	
	      if (number === 0) {
	        return value;
	      }
	
	      var specialCase = number % 100;
	      if ([11, 12, 13].indexOf(specialCase) >= 0) {
	        return number + 'th';
	      }
	
	      var leastSignificant = number % 10;
	
	      var end = void 0;
	      switch (leastSignificant) {
	        case 1:
	          end = 'st';
	          break;
	        case 2:
	          end = 'nd';
	          break;
	        case 3:
	          end = 'rd';
	          break;
	        default:
	          end = 'th';
	      }
	
	      return '' + number + end;
	    },
	
	
	    // Interprets numbers as occurences. Also accepts an optional array/map of overrides.
	    times: function times(value) {
	      var overrides = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      if (isFiniteNumber(value) && value >= 0) {
	        var number = parseFloat(value);
	        var smallTimes = ['never', 'once', 'twice'];
	        if (exists(overrides[number])) {
	          return String(overrides[number]);
	        }
	
	        var numberString = exists(smallTimes[number]) && smallTimes[number].toString();
	        return numberString || number.toString() + ' times';
	      }
	      return null;
	    },
	
	
	    // Returns the plural version of a given word if the value is not 1. The default suffix is 's'.
	    pluralize: function pluralize(number, singular, plural) {
	      if (!(exists(number) && exists(singular))) {
	        return null;
	      }
	
	      plural = exists(plural) ? plural : singular + 's';
	
	      return parseInt(number, 10) === 1 ? singular : plural;
	    },
	
	
	    // Truncates a string if it is longer than the specified number of characters (inclusive).
	    // Truncated strings will end with a translatable ellipsis sequence ("…").
	    truncate: function truncate(str) {
	      var length = arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];
	      var ending = arguments.length <= 2 || arguments[2] === undefined ? '...' : arguments[2];
	
	      if (str.length > length) {
	        return str.substring(0, length - ending.length) + ending;
	      }
	      return str;
	    },
	
	
	    // Truncates a string after a certain number of words.
	    truncateWords: function truncateWords(string, length) {
	      var array = string.split(' ');
	      var result = '';
	      var i = 0;
	
	      while (i < length) {
	        if (exists(array[i])) {
	          result += array[i] + ' ';
	        }
	        i++;
	      }
	
	      if (array.length > length) {
	        return result + '...';
	      }
	
	      return null;
	    },
	    truncatewords: function truncatewords() {
	      return Humanize.truncateWords.apply(Humanize, arguments);
	    },
	
	
	    // Truncates a number to an upper bound.
	    boundedNumber: function boundedNumber(num) {
	      var bound = arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];
	      var ending = arguments.length <= 2 || arguments[2] === undefined ? '+' : arguments[2];
	
	      var result = void 0;
	
	      if (isFiniteNumber(num) && isFiniteNumber(bound)) {
	        if (num > bound) {
	          result = bound + ending;
	        }
	      }
	
	      return (result || num).toString();
	    },
	    truncatenumber: function truncatenumber() {
	      return Humanize.boundedNumber.apply(Humanize, arguments);
	    },
	
	
	    // Converts a list of items to a human readable string with an optional limit.
	    oxford: function oxford(items, limit, limitStr) {
	      var numItems = items.length;
	
	      var limitIndex = void 0;
	      if (numItems < 2) {
	        return String(items);
	      } else if (numItems === 2) {
	        return items.join(' and ');
	      } else if (exists(limit) && numItems > limit) {
	        var extra = numItems - limit;
	        limitIndex = limit;
	        limitStr = exists(limitStr) ? limitStr : ', and ' + extra + ' ' + Humanize.pluralize(extra, 'other');
	      } else {
	        limitIndex = -1;
	        limitStr = ', and ' + items[numItems - 1];
	      }
	
	      return items.slice(0, limitIndex).join(', ') + limitStr;
	    },
	
	
	    // Converts an object to a definition-like string
	    dictionary: function dictionary(object) {
	      var joiner = arguments.length <= 1 || arguments[1] === undefined ? ' is ' : arguments[1];
	      var separator = arguments.length <= 2 || arguments[2] === undefined ? ', ' : arguments[2];
	
	      var result = '';
	
	      if (exists(object) && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && !isArray(object)) {
	        var defs = [];
	        for (var key in object) {
	          if (object.hasOwnProperty(key)) {
	            var val = object[key];
	            defs.push('' + key + joiner + val);
	          }
	        }
	
	        return defs.join(separator);
	      }
	
	      return result;
	    },
	
	
	    // Describes how many times an item appears in a list
	    frequency: function frequency(list, verb) {
	      if (!isArray(list)) {
	        return null;
	      }
	
	      var len = list.length;
	      var times = Humanize.times(len);
	
	      if (len === 0) {
	        return times + ' ' + verb;
	      }
	
	      return verb + ' ' + times;
	    },
	    pace: function pace(value, intervalMs) {
	      var unit = arguments.length <= 2 || arguments[2] === undefined ? 'time' : arguments[2];
	
	      if (value === 0 || intervalMs === 0) {
	        // Needs a better string than this...
	        return 'No ' + Humanize.pluralize(0, unit);
	      }
	
	      // Expose these as overridables?
	      var prefix = 'Approximately';
	      var timeUnit = void 0;
	      var relativePace = void 0;
	
	      var rate = value / intervalMs;
	      for (var i = 0; i < TIME_FORMATS.length; ++i) {
	        // assumes sorted list
	        var f = TIME_FORMATS[i];
	        relativePace = rate * f.value;
	        if (relativePace > 1) {
	          timeUnit = f.name;
	          break;
	        }
	      }
	
	      // Use the last time unit if there is nothing smaller
	      if (!timeUnit) {
	        prefix = 'Less than';
	        relativePace = 1;
	        timeUnit = TIME_FORMATS[TIME_FORMATS.length - 1].name;
	      }
	
	      var roundedPace = Math.round(relativePace);
	      unit = Humanize.pluralize(roundedPace, unit);
	
	      return prefix + ' ' + roundedPace + ' ' + unit + ' per ' + timeUnit;
	    },
	
	
	    // Converts newlines to <br/> tags
	    nl2br: function nl2br(string) {
	      var replacement = arguments.length <= 1 || arguments[1] === undefined ? '<br/>' : arguments[1];
	
	      return string.replace(/\n/g, replacement);
	    },
	
	
	    // Converts <br/> tags to newlines
	    br2nl: function br2nl(string) {
	      var replacement = arguments.length <= 1 || arguments[1] === undefined ? '\r\n' : arguments[1];
	
	      return string.replace(/\<br\s*\/?\>/g, replacement);
	    },
	
	
	    // Capitalizes first letter in a string
	    capitalize: function capitalize(string) {
	      var downCaseTail = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	      return '' + string.charAt(0).toUpperCase() + (downCaseTail ? string.slice(1).toLowerCase() : string.slice(1));
	    },
	
	
	    // Capitalizes the first letter of each word in a string
	    capitalizeAll: function capitalizeAll(string) {
	      return string.replace(/(?:^|\s)\S/g, function (a) {
	        return a.toUpperCase();
	      });
	    },
	
	
	    // Titlecase words in a string.
	    titleCase: function titleCase(string) {
	      var smallWords = /\b(a|an|and|at|but|by|de|en|for|if|in|of|on|or|the|to|via|vs?\.?)\b/i;
	      var internalCaps = /\S+[A-Z]+\S*/;
	      var splitOnWhiteSpaceRegex = /\s+/;
	      var splitOnHyphensRegex = /-/;
	
	      var _doTitleCase = void 0;
	      _doTitleCase = function doTitleCase(_string) {
	        var hyphenated = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	        var firstOrLast = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	        var titleCasedArray = [];
	        var stringArray = _string.split(hyphenated ? splitOnHyphensRegex : splitOnWhiteSpaceRegex);
	
	        for (var index = 0; index < stringArray.length; ++index) {
	          var word = stringArray[index];
	          if (word.indexOf('-') !== -1) {
	            titleCasedArray.push(_doTitleCase(word, true, index === 0 || index === stringArray.length - 1));
	            continue;
	          }
	
	          if (firstOrLast && (index === 0 || index === stringArray.length - 1)) {
	            titleCasedArray.push(internalCaps.test(word) ? word : Humanize.capitalize(word));
	            continue;
	          }
	
	          if (internalCaps.test(word)) {
	            titleCasedArray.push(word);
	          } else if (smallWords.test(word)) {
	            titleCasedArray.push(word.toLowerCase());
	          } else {
	            titleCasedArray.push(Humanize.capitalize(word));
	          }
	        }
	
	        return titleCasedArray.join(hyphenated ? '-' : ' ');
	      };
	
	      return _doTitleCase(string);
	    },
	    titlecase: function titlecase() {
	      return Humanize.titleCase.apply(Humanize, arguments);
	    }
	  };
	
	  return Humanize;
	});

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ExternalLink = function ExternalLink(_ref) {
	    var href = _ref.href,
	        className = _ref.className,
	        children = _ref.children,
	        props = _objectWithoutProperties(_ref, ["href", "className", "children"]);
	
	    return _react2.default.createElement(
	        "a",
	        _extends({
	            href: href,
	            className: className || "link"
	            // open in a new tab
	            , target: "_blank"
	            // prevent malicious pages from navigating us away
	            , rel: "noopener"
	            // disables quickfilter in tables
	            , onClickCapture: function onClickCapture(e) {
	                return e.stopPropagation();
	            }
	        }, props),
	        children
	    );
	};
	
	ExternalLink.displayName = "ExternalLink";
	exports.default = ExternalLink;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseTimestamp = parseTimestamp;
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// only attempt to parse the timezone if we're sure we have one (either Z or ±hh:mm or +-hhmm)
	// moment normally interprets the DD in YYYY-MM-DD as an offset :-/
	function parseTimestamp(value, unit) {
	    if (_moment2.default.isMoment(value)) {
	        return value;
	    } else if (typeof value === "string" && /(Z|[+-]\d\d:?\d\d)$/.test(value)) {
	        return _moment2.default.parseZone(value);
	    } else if (unit === "year") {
	        // workaround for https://github.com/metabase/metabase/issues/1992
	        return (0, _moment2.default)().year(value).startOf("year");
	    } else {
	        return _moment2.default.utc(value);
	    }
	}

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.rangeForValue = exports.datasetContainsNoResults = undefined;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Many aggregations result in [[null]] if there are no rows to aggregate after filters
	var datasetContainsNoResults = exports.datasetContainsNoResults = function datasetContainsNoResults(data) {
	    return data.rows.length === 0 || _underscore2.default.isEqual(data.rows, [[null]]);
	};
	
	/**
	 * @returns min and max for a value in a column
	 */
	var rangeForValue = exports.rangeForValue = function rangeForValue(value, column) {
	    if (column && column.binning_info && column.binning_info.bin_width) {
	        return [value, value + column.binning_info.bin_width];
	    }
	};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cardHasBecomeDirty = exports.isDimensionMetricMetric = exports.isDimensionDimensionMetric = exports.isDimensionMetric = exports.DIMENSION_DIMENSION_METRIC = exports.DIMENSION_METRIC_METRIC = exports.DIMENSION_METRIC = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.columnsAreValid = columnsAreValid;
	exports.getAvailableCanvasHeight = getAvailableCanvasHeight;
	exports.getAvailableCanvasWidth = getAvailableCanvasWidth;
	exports.computeSplit = computeSplit;
	exports.getXValues = getXValues;
	exports.getFriendlyName = getFriendlyName;
	exports.getCardColors = getCardColors;
	exports.isSameSeries = isSameSeries;
	exports.colorShades = colorShades;
	exports.colorShade = colorShade;
	exports.getColumnCardinality = getColumnCardinality;
	exports.getChartTypeFromData = getChartTypeFromData;
	exports.enableVisualizationEasterEgg = enableVisualizationEasterEgg;
	exports.getCardAfterVisualizationClick = getCardAfterVisualizationClick;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _d2 = __webpack_require__(873);
	
	var _d3 = _interopRequireDefault(_d2);
	
	var _crossfilter = __webpack_require__(879);
	
	var _crossfilter2 = _interopRequireDefault(_crossfilter);
	
	var _colors = __webpack_require__(881);
	
	var colors = _interopRequireWildcard(_colors);
	
	var _schema_metadata = __webpack_require__(867);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*  weak */
	
	var SPLIT_AXIS_UNSPLIT_COST = -100;
	var SPLIT_AXIS_COST_FACTOR = 2;
	
	// NOTE Atte Keinänen 8/3/17: Moved from settings.js because this way we
	// are able to avoid circular dependency errors in integrated tests
	function columnsAreValid(colNames, data) {
	    var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
	        return true;
	    };
	
	    if (typeof colNames === "string") {
	        colNames = [colNames];
	    }
	    if (!data || !Array.isArray(colNames)) {
	        return false;
	    }
	    var colsByName = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = data.cols[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var col = _step.value;
	
	            colsByName[col.name] = col;
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return colNames.reduce(function (acc, name) {
	        return acc && (name == undefined || colsByName[name] && filter(colsByName[name]));
	    }, true);
	}
	
	// computed size properties (drop 'px' and convert string -> Number)
	function getComputedSizeProperty(prop, element) {
	    var val = document.defaultView.getComputedStyle(element, null).getPropertyValue(prop);
	    return val ? parseFloat(val.replace("px", "")) : null;
	}
	
	/// height available for rendering the card
	function getAvailableCanvasHeight(element) {
	    var parent = element.parentElement,
	        parentHeight = getComputedSizeProperty("height", parent),
	        parentPaddingTop = getComputedSizeProperty("padding-top", parent),
	        parentPaddingBottom = getComputedSizeProperty("padding-bottom", parent);
	
	    // NOTE: if this magic number is not 3 we can get into infinite re-render loops
	    return parentHeight - parentPaddingTop - parentPaddingBottom - 3; // why the magic number :/
	}
	
	/// width available for rendering the card
	function getAvailableCanvasWidth(element) {
	    var parent = element.parentElement,
	        parentWidth = getComputedSizeProperty("width", parent),
	        parentPaddingLeft = getComputedSizeProperty("padding-left", parent),
	        parentPaddingRight = getComputedSizeProperty("padding-right", parent);
	
	    return parentWidth - parentPaddingLeft - parentPaddingRight;
	}
	
	function generateSplits(list) {
	    var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    // NOTE: currently generates all permutations, some of which are equivalent
	    if (list.length === 0) {
	        return [[left, right]];
	    } else {
	        return [].concat(_toConsumableArray(generateSplits(list.slice(1), left.concat([list[0]]), right)), _toConsumableArray(generateSplits(list.slice(1), left, right.concat([list[0]]))));
	    }
	}
	
	function cost(seriesExtents) {
	    var _ref;
	
	    var axisExtent = _d3.default.extent((_ref = []).concat.apply(_ref, _toConsumableArray(seriesExtents))); // concat to flatten the array
	    var axisRange = axisExtent[1] - axisExtent[0];
	    if (seriesExtents.length === 0) {
	        return SPLIT_AXIS_UNSPLIT_COST;
	    } else if (axisRange === 0) {
	        return 0;
	    } else {
	        return seriesExtents.reduce(function (sum, seriesExtent) {
	            return sum + Math.pow(axisRange / (seriesExtent[1] - seriesExtent[0]), SPLIT_AXIS_COST_FACTOR);
	        }, 0);
	    }
	}
	
	function computeSplit(extents) {
	    var best = void 0,
	        bestCost = void 0;
	    var splits = generateSplits(extents.map(function (e, i) {
	        return i;
	    })).map(function (split) {
	        return [split, cost(split[0].map(function (i) {
	            return extents[i];
	        })) + cost(split[1].map(function (i) {
	            return extents[i];
	        }))];
	    });
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = splits[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _step2$value = _slicedToArray(_step2.value, 2),
	                split = _step2$value[0],
	                splitCost = _step2$value[1];
	
	            if (!best || splitCost < bestCost) {
	                best = split;
	                bestCost = splitCost;
	            }
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return best && best.sort(function (a, b) {
	        return a[0] - b[0];
	    });
	}
	
	var FRIENDLY_NAME_MAP = {
	    "avg": "Average",
	    "count": "Count",
	    "sum": "Sum",
	    "distinct": "Distinct",
	    "stddev": "Standard Deviation"
	};
	
	function getXValues(datas, chartType) {
	    var xValues = _underscore2.default.chain(datas).map(function (data) {
	        return _underscore2.default.pluck(data, "0");
	    }).flatten(true).uniq().value();
	
	    // detect if every series' dimension is strictly ascending or descending and use that to sort xValues
	    var isAscending = true;
	    var isDescending = true;
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        outer: for (var _iterator3 = datas[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var rows = _step3.value;
	
	            for (var i = 1; i < rows.length; i++) {
	                isAscending = isAscending && rows[i - 1][0] <= rows[i][0];
	                isDescending = isDescending && rows[i - 1][0] >= rows[i][0];
	                if (!isAscending && !isDescending) {
	                    break outer;
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	
	    if (isDescending) {
	        // JavaScript's .sort() sorts lexicographically by default (e.x. 1, 10, 2)
	        // We could implement a comparator but _.sortBy handles strings, numbers, and dates correctly
	        xValues = _underscore2.default.sortBy(xValues, function (x) {
	            return x;
	        }).reverse();
	    } else if (isAscending) {
	        // default line/area charts to ascending since otherwise lines could be wonky
	        xValues = _underscore2.default.sortBy(xValues, function (x) {
	            return x;
	        });
	    }
	    return xValues;
	}
	
	function getFriendlyName(column) {
	    if (column.display_name && column.display_name !== column.name) {
	        return column.display_name;
	    } else {
	        // NOTE Atte Keinänen 8/7/17:
	        // Values `display_name` and `name` are same for breakout columns so check FRIENDLY_NAME_MAP
	        // before returning either `display_name` or `name`
	        return FRIENDLY_NAME_MAP[column.name.toLowerCase().trim()] || column.display_name || column.name;
	    }
	}
	
	function getCardColors(card) {
	    var settings = card.visualization_settings;
	    var chartColor = void 0,
	        chartColorList = void 0;
	    if (card.display === "bar" && settings.bar) {
	        chartColor = settings.bar.color;
	        chartColorList = settings.bar.colors;
	    } else if (card.display !== "bar" && settings.line) {
	        chartColor = settings.line.lineColor;
	        chartColorList = settings.line.colors;
	    }
	    return _underscore2.default.uniq([chartColor || Object.values(colors.harmony)[0]].concat(chartColorList || Object.values(colors.harmony)));
	}
	
	function isSameSeries(seriesA, seriesB) {
	    return (seriesA && seriesA.length) === (seriesB && seriesB.length) && _underscore2.default.zip(seriesA, seriesB).reduce(function (acc, _ref2) {
	        var _ref3 = _slicedToArray(_ref2, 2),
	            a = _ref3[0],
	            b = _ref3[1];
	
	        var sameData = a.data === b.data;
	        var sameDisplay = (a.card && a.card.display) === (b.card && b.card.display);
	        var sameVizSettings = (a.card && JSON.stringify(a.card.visualization_settings)) === (b.card && JSON.stringify(b.card.visualization_settings));
	        return acc && sameData && sameDisplay && sameVizSettings;
	    }, true);
	}
	
	function colorShades(color, count) {
	    return _underscore2.default.range(count).map(function (i) {
	        return colorShade(color, 1 - Math.min(0.25, 1 / count) * i);
	    });
	}
	
	function colorShade(hex) {
	    var shade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    var match = hex.match(/#(?:(..)(..)(..)|(.)(.)(.))/);
	    if (!match) {
	        return hex;
	    }
	    var components = (match[1] != null ? match.slice(1, 4) : match.slice(4, 7)).map(function (d) {
	        return parseInt(d, 16);
	    });
	    var min = Math.min.apply(Math, _toConsumableArray(components));
	    var max = Math.max.apply(Math, _toConsumableArray(components));
	    return "#" + components.map(function (c) {
	        return Math.round(min + (max - min) * shade * (c / 255)).toString(16);
	    }).join("");
	}
	
	var DIMENSION_METRIC = exports.DIMENSION_METRIC = "DIMENSION_METRIC";
	var DIMENSION_METRIC_METRIC = exports.DIMENSION_METRIC_METRIC = "DIMENSION_METRIC_METRIC";
	var DIMENSION_DIMENSION_METRIC = exports.DIMENSION_DIMENSION_METRIC = "DIMENSION_DIMENSION_METRIC";
	
	// NOTE Atte Keinänen 7/31/17 Commented MAX_SERIES out as it wasn't being used
	// const MAX_SERIES = 10;
	
	var isDimensionMetric = exports.isDimensionMetric = function isDimensionMetric(cols) {
	    var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    return (!strict || cols.length === 2) && (0, _schema_metadata.isDimension)(cols[0]) && (0, _schema_metadata.isMetric)(cols[1]);
	};
	
	var isDimensionDimensionMetric = exports.isDimensionDimensionMetric = function isDimensionDimensionMetric(cols) {
	    var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    return (!strict || cols.length === 3) && (0, _schema_metadata.isDimension)(cols[0]) && (0, _schema_metadata.isDimension)(cols[1]) && (0, _schema_metadata.isMetric)(cols[2]);
	};
	
	var isDimensionMetricMetric = exports.isDimensionMetricMetric = function isDimensionMetricMetric(cols) {
	    var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    return cols.length >= 3 && (0, _schema_metadata.isDimension)(cols[0]) && cols.slice(1).reduce(function (acc, col) {
	        return acc && (0, _schema_metadata.isMetric)(col);
	    }, true);
	};
	
	// cache computed cardinalities in a weak map since they are computationally expensive
	var cardinalityCache = new WeakMap();
	
	function getColumnCardinality(cols, rows, index) {
	    var col = cols[index];
	    if (!cardinalityCache.has(col)) {
	        var dataset = (0, _crossfilter2.default)(rows);
	        cardinalityCache.set(col, dataset.dimension(function (d) {
	            return d[index];
	        }).group().size());
	    }
	    return cardinalityCache.get(col);
	}
	
	function getChartTypeFromData(cols, rows) {
	    var strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    // this should take precendence for backwards compatibilty
	    if (isDimensionMetricMetric(cols, strict)) {
	        return DIMENSION_METRIC_METRIC;
	    } else if (isDimensionDimensionMetric(cols, strict)) {
	        // if (getColumnCardinality(cols, rows, 0) < MAX_SERIES || getColumnCardinality(cols, rows, 1) < MAX_SERIES) {
	        return DIMENSION_DIMENSION_METRIC;
	        // }
	    } else if (isDimensionMetric(cols, strict)) {
	        return DIMENSION_METRIC;
	    }
	    return null;
	}
	
	function enableVisualizationEasterEgg(code, OriginalVisualization, EasterEggVisualization) {
	    if (!code) {
	        code = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];
	    } else if (typeof code === "string") {
	        code = code.split("").map(function (c) {
	            return c.charCodeAt(0);
	        });
	    }
	    wrapMethod(OriginalVisualization.prototype, "componentWillMount", function easterEgg() {
	        var _this = this;
	
	        var keypresses = [];
	        var enabled = false;
	        var render_original = this.render;
	        var render_egg = function render_egg() {
	            return _react2.default.createElement(EasterEggVisualization, this.props);
	        };
	        this._keyListener = function (e) {
	            keypresses = keypresses.concat(e.keyCode).slice(-code.length);
	            if (code.reduce(function (ok, value, index) {
	                return ok && value === keypresses[index];
	            }, true)) {
	                enabled = !enabled;
	                _this.render = enabled ? render_egg : render_original;
	                _this.forceUpdate();
	            }
	        };
	        window.addEventListener("keyup", this._keyListener, false);
	    });
	    wrapMethod(OriginalVisualization.prototype, "componentWillUnmount", function cleanupEasterEgg() {
	        window.removeEventListener("keyup", this._keyListener, false);
	    });
	}
	
	function wrapMethod(object, name, method) {
	    var method_original = object[name];
	    object[name] = function () {
	        method.apply(this, arguments);
	        if (typeof method_original === "function") {
	            return method_original.apply(this, arguments);
	        }
	    };
	}
	// TODO Atte Keinänen 5/30/17 Extract to metabase-lib card/question logic
	var cardHasBecomeDirty = exports.cardHasBecomeDirty = function cardHasBecomeDirty(nextCard, previousCard) {
	    return !_underscore2.default.isEqual(previousCard.dataset_query, nextCard.dataset_query) || previousCard.display !== nextCard.display;
	};
	
	function getCardAfterVisualizationClick(nextCard, previousCard) {
	    if (cardHasBecomeDirty(nextCard, previousCard)) {
	        var isMultiseriesQuestion = !nextCard.id;
	        var alreadyHadLineage = !!previousCard.original_card_id;
	
	        return _extends({}, nextCard, {
	            // Original card id is needed for showing the "started from" lineage in dirty cards.
	            original_card_id: alreadyHadLineage
	            // Just recycle the original card id of previous card if there was one
	            ? previousCard.original_card_id
	            // A multi-aggregation or multi-breakout series legend / drill-through action
	            // should always use the id of underlying/previous card
	            : isMultiseriesQuestion ? previousCard.id : nextCard.id
	        });
	    } else {
	        // Even though the card is currently clean, we might still apply dashboard parameters to it,
	        // so add the original_card_id to ensure a correct behavior in that context
	        return _extends({}, nextCard, {
	            original_card_id: nextCard.id
	        });
	    }
	}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(880).crossfilter;


/***/ }),
/* 880 */
/***/ (function(module, exports) {

	(function(exports){
	crossfilter.version = "1.3.12";
	function crossfilter_identity(d) {
	  return d;
	}
	crossfilter.permute = permute;
	
	function permute(array, index) {
	  for (var i = 0, n = index.length, copy = new Array(n); i < n; ++i) {
	    copy[i] = array[index[i]];
	  }
	  return copy;
	}
	var bisect = crossfilter.bisect = bisect_by(crossfilter_identity);
	
	bisect.by = bisect_by;
	
	function bisect_by(f) {
	
	  // Locate the insertion point for x in a to maintain sorted order. The
	  // arguments lo and hi may be used to specify a subset of the array which
	  // should be considered; by default the entire array is used. If x is already
	  // present in a, the insertion point will be before (to the left of) any
	  // existing entries. The return value is suitable for use as the first
	  // argument to `array.splice` assuming that a is already sorted.
	  //
	  // The returned insertion point i partitions the array a into two halves so
	  // that all v < x for v in a[lo:i] for the left side and all v >= x for v in
	  // a[i:hi] for the right side.
	  function bisectLeft(a, x, lo, hi) {
	    while (lo < hi) {
	      var mid = lo + hi >>> 1;
	      if (f(a[mid]) < x) lo = mid + 1;
	      else hi = mid;
	    }
	    return lo;
	  }
	
	  // Similar to bisectLeft, but returns an insertion point which comes after (to
	  // the right of) any existing entries of x in a.
	  //
	  // The returned insertion point i partitions the array into two halves so that
	  // all v <= x for v in a[lo:i] for the left side and all v > x for v in
	  // a[i:hi] for the right side.
	  function bisectRight(a, x, lo, hi) {
	    while (lo < hi) {
	      var mid = lo + hi >>> 1;
	      if (x < f(a[mid])) hi = mid;
	      else lo = mid + 1;
	    }
	    return lo;
	  }
	
	  bisectRight.right = bisectRight;
	  bisectRight.left = bisectLeft;
	  return bisectRight;
	}
	var heap = crossfilter.heap = heap_by(crossfilter_identity);
	
	heap.by = heap_by;
	
	function heap_by(f) {
	
	  // Builds a binary heap within the specified array a[lo:hi]. The heap has the
	  // property such that the parent a[lo+i] is always less than or equal to its
	  // two children: a[lo+2*i+1] and a[lo+2*i+2].
	  function heap(a, lo, hi) {
	    var n = hi - lo,
	        i = (n >>> 1) + 1;
	    while (--i > 0) sift(a, i, n, lo);
	    return a;
	  }
	
	  // Sorts the specified array a[lo:hi] in descending order, assuming it is
	  // already a heap.
	  function sort(a, lo, hi) {
	    var n = hi - lo,
	        t;
	    while (--n > 0) t = a[lo], a[lo] = a[lo + n], a[lo + n] = t, sift(a, 1, n, lo);
	    return a;
	  }
	
	  // Sifts the element a[lo+i-1] down the heap, where the heap is the contiguous
	  // slice of array a[lo:lo+n]. This method can also be used to update the heap
	  // incrementally, without incurring the full cost of reconstructing the heap.
	  function sift(a, i, n, lo) {
	    var d = a[--lo + i],
	        x = f(d),
	        child;
	    while ((child = i << 1) <= n) {
	      if (child < n && f(a[lo + child]) > f(a[lo + child + 1])) child++;
	      if (x <= f(a[lo + child])) break;
	      a[lo + i] = a[lo + child];
	      i = child;
	    }
	    a[lo + i] = d;
	  }
	
	  heap.sort = sort;
	  return heap;
	}
	var heapselect = crossfilter.heapselect = heapselect_by(crossfilter_identity);
	
	heapselect.by = heapselect_by;
	
	function heapselect_by(f) {
	  var heap = heap_by(f);
	
	  // Returns a new array containing the top k elements in the array a[lo:hi].
	  // The returned array is not sorted, but maintains the heap property. If k is
	  // greater than hi - lo, then fewer than k elements will be returned. The
	  // order of elements in a is unchanged by this operation.
	  function heapselect(a, lo, hi, k) {
	    var queue = new Array(k = Math.min(hi - lo, k)),
	        min,
	        i,
	        x,
	        d;
	
	    for (i = 0; i < k; ++i) queue[i] = a[lo++];
	    heap(queue, 0, k);
	
	    if (lo < hi) {
	      min = f(queue[0]);
	      do {
	        if (x = f(d = a[lo]) > min) {
	          queue[0] = d;
	          min = f(heap(queue, 0, k)[0]);
	        }
	      } while (++lo < hi);
	    }
	
	    return queue;
	  }
	
	  return heapselect;
	}
	var insertionsort = crossfilter.insertionsort = insertionsort_by(crossfilter_identity);
	
	insertionsort.by = insertionsort_by;
	
	function insertionsort_by(f) {
	
	  function insertionsort(a, lo, hi) {
	    for (var i = lo + 1; i < hi; ++i) {
	      for (var j = i, t = a[i], x = f(t); j > lo && f(a[j - 1]) > x; --j) {
	        a[j] = a[j - 1];
	      }
	      a[j] = t;
	    }
	    return a;
	  }
	
	  return insertionsort;
	}
	// Algorithm designed by Vladimir Yaroslavskiy.
	// Implementation based on the Dart project; see lib/dart/LICENSE for details.
	
	var quicksort = crossfilter.quicksort = quicksort_by(crossfilter_identity);
	
	quicksort.by = quicksort_by;
	
	function quicksort_by(f) {
	  var insertionsort = insertionsort_by(f);
	
	  function sort(a, lo, hi) {
	    return (hi - lo < quicksort_sizeThreshold
	        ? insertionsort
	        : quicksort)(a, lo, hi);
	  }
	
	  function quicksort(a, lo, hi) {
	    // Compute the two pivots by looking at 5 elements.
	    var sixth = (hi - lo) / 6 | 0,
	        i1 = lo + sixth,
	        i5 = hi - 1 - sixth,
	        i3 = lo + hi - 1 >> 1,  // The midpoint.
	        i2 = i3 - sixth,
	        i4 = i3 + sixth;
	
	    var e1 = a[i1], x1 = f(e1),
	        e2 = a[i2], x2 = f(e2),
	        e3 = a[i3], x3 = f(e3),
	        e4 = a[i4], x4 = f(e4),
	        e5 = a[i5], x5 = f(e5);
	
	    var t;
	
	    // Sort the selected 5 elements using a sorting network.
	    if (x1 > x2) t = e1, e1 = e2, e2 = t, t = x1, x1 = x2, x2 = t;
	    if (x4 > x5) t = e4, e4 = e5, e5 = t, t = x4, x4 = x5, x5 = t;
	    if (x1 > x3) t = e1, e1 = e3, e3 = t, t = x1, x1 = x3, x3 = t;
	    if (x2 > x3) t = e2, e2 = e3, e3 = t, t = x2, x2 = x3, x3 = t;
	    if (x1 > x4) t = e1, e1 = e4, e4 = t, t = x1, x1 = x4, x4 = t;
	    if (x3 > x4) t = e3, e3 = e4, e4 = t, t = x3, x3 = x4, x4 = t;
	    if (x2 > x5) t = e2, e2 = e5, e5 = t, t = x2, x2 = x5, x5 = t;
	    if (x2 > x3) t = e2, e2 = e3, e3 = t, t = x2, x2 = x3, x3 = t;
	    if (x4 > x5) t = e4, e4 = e5, e5 = t, t = x4, x4 = x5, x5 = t;
	
	    var pivot1 = e2, pivotValue1 = x2,
	        pivot2 = e4, pivotValue2 = x4;
	
	    // e2 and e4 have been saved in the pivot variables. They will be written
	    // back, once the partitioning is finished.
	    a[i1] = e1;
	    a[i2] = a[lo];
	    a[i3] = e3;
	    a[i4] = a[hi - 1];
	    a[i5] = e5;
	
	    var less = lo + 1,   // First element in the middle partition.
	        great = hi - 2;  // Last element in the middle partition.
	
	    // Note that for value comparison, <, <=, >= and > coerce to a primitive via
	    // Object.prototype.valueOf; == and === do not, so in order to be consistent
	    // with natural order (such as for Date objects), we must do two compares.
	    var pivotsEqual = pivotValue1 <= pivotValue2 && pivotValue1 >= pivotValue2;
	    if (pivotsEqual) {
	
	      // Degenerated case where the partitioning becomes a dutch national flag
	      // problem.
	      //
	      // [ |  < pivot  | == pivot | unpartitioned | > pivot  | ]
	      //  ^             ^          ^             ^            ^
	      // left         less         k           great         right
	      //
	      // a[left] and a[right] are undefined and are filled after the
	      // partitioning.
	      //
	      // Invariants:
	      //   1) for x in ]left, less[ : x < pivot.
	      //   2) for x in [less, k[ : x == pivot.
	      //   3) for x in ]great, right[ : x > pivot.
	      for (var k = less; k <= great; ++k) {
	        var ek = a[k], xk = f(ek);
	        if (xk < pivotValue1) {
	          if (k !== less) {
	            a[k] = a[less];
	            a[less] = ek;
	          }
	          ++less;
	        } else if (xk > pivotValue1) {
	
	          // Find the first element <= pivot in the range [k - 1, great] and
	          // put [:ek:] there. We know that such an element must exist:
	          // When k == less, then el3 (which is equal to pivot) lies in the
	          // interval. Otherwise a[k - 1] == pivot and the search stops at k-1.
	          // Note that in the latter case invariant 2 will be violated for a
	          // short amount of time. The invariant will be restored when the
	          // pivots are put into their final positions.
	          while (true) {
	            var greatValue = f(a[great]);
	            if (greatValue > pivotValue1) {
	              great--;
	              // This is the only location in the while-loop where a new
	              // iteration is started.
	              continue;
	            } else if (greatValue < pivotValue1) {
	              // Triple exchange.
	              a[k] = a[less];
	              a[less++] = a[great];
	              a[great--] = ek;
	              break;
	            } else {
	              a[k] = a[great];
	              a[great--] = ek;
	              // Note: if great < k then we will exit the outer loop and fix
	              // invariant 2 (which we just violated).
	              break;
	            }
	          }
	        }
	      }
	    } else {
	
	      // We partition the list into three parts:
	      //  1. < pivot1
	      //  2. >= pivot1 && <= pivot2
	      //  3. > pivot2
	      //
	      // During the loop we have:
	      // [ | < pivot1 | >= pivot1 && <= pivot2 | unpartitioned  | > pivot2  | ]
	      //  ^            ^                        ^              ^             ^
	      // left         less                     k              great        right
	      //
	      // a[left] and a[right] are undefined and are filled after the
	      // partitioning.
	      //
	      // Invariants:
	      //   1. for x in ]left, less[ : x < pivot1
	      //   2. for x in [less, k[ : pivot1 <= x && x <= pivot2
	      //   3. for x in ]great, right[ : x > pivot2
	      for (var k = less; k <= great; k++) {
	        var ek = a[k], xk = f(ek);
	        if (xk < pivotValue1) {
	          if (k !== less) {
	            a[k] = a[less];
	            a[less] = ek;
	          }
	          ++less;
	        } else {
	          if (xk > pivotValue2) {
	            while (true) {
	              var greatValue = f(a[great]);
	              if (greatValue > pivotValue2) {
	                great--;
	                if (great < k) break;
	                // This is the only location inside the loop where a new
	                // iteration is started.
	                continue;
	              } else {
	                // a[great] <= pivot2.
	                if (greatValue < pivotValue1) {
	                  // Triple exchange.
	                  a[k] = a[less];
	                  a[less++] = a[great];
	                  a[great--] = ek;
	                } else {
	                  // a[great] >= pivot1.
	                  a[k] = a[great];
	                  a[great--] = ek;
	                }
	                break;
	              }
	            }
	          }
	        }
	      }
	    }
	
	    // Move pivots into their final positions.
	    // We shrunk the list from both sides (a[left] and a[right] have
	    // meaningless values in them) and now we move elements from the first
	    // and third partition into these locations so that we can store the
	    // pivots.
	    a[lo] = a[less - 1];
	    a[less - 1] = pivot1;
	    a[hi - 1] = a[great + 1];
	    a[great + 1] = pivot2;
	
	    // The list is now partitioned into three partitions:
	    // [ < pivot1   | >= pivot1 && <= pivot2   |  > pivot2   ]
	    //  ^            ^                        ^             ^
	    // left         less                     great        right
	
	    // Recursive descent. (Don't include the pivot values.)
	    sort(a, lo, less - 1);
	    sort(a, great + 2, hi);
	
	    if (pivotsEqual) {
	      // All elements in the second partition are equal to the pivot. No
	      // need to sort them.
	      return a;
	    }
	
	    // In theory it should be enough to call _doSort recursively on the second
	    // partition.
	    // The Android source however removes the pivot elements from the recursive
	    // call if the second partition is too large (more than 2/3 of the list).
	    if (less < i1 && great > i5) {
	      var lessValue, greatValue;
	      while ((lessValue = f(a[less])) <= pivotValue1 && lessValue >= pivotValue1) ++less;
	      while ((greatValue = f(a[great])) <= pivotValue2 && greatValue >= pivotValue2) --great;
	
	      // Copy paste of the previous 3-way partitioning with adaptions.
	      //
	      // We partition the list into three parts:
	      //  1. == pivot1
	      //  2. > pivot1 && < pivot2
	      //  3. == pivot2
	      //
	      // During the loop we have:
	      // [ == pivot1 | > pivot1 && < pivot2 | unpartitioned  | == pivot2 ]
	      //              ^                      ^              ^
	      //            less                     k              great
	      //
	      // Invariants:
	      //   1. for x in [ *, less[ : x == pivot1
	      //   2. for x in [less, k[ : pivot1 < x && x < pivot2
	      //   3. for x in ]great, * ] : x == pivot2
	      for (var k = less; k <= great; k++) {
	        var ek = a[k], xk = f(ek);
	        if (xk <= pivotValue1 && xk >= pivotValue1) {
	          if (k !== less) {
	            a[k] = a[less];
	            a[less] = ek;
	          }
	          less++;
	        } else {
	          if (xk <= pivotValue2 && xk >= pivotValue2) {
	            while (true) {
	              var greatValue = f(a[great]);
	              if (greatValue <= pivotValue2 && greatValue >= pivotValue2) {
	                great--;
	                if (great < k) break;
	                // This is the only location inside the loop where a new
	                // iteration is started.
	                continue;
	              } else {
	                // a[great] < pivot2.
	                if (greatValue < pivotValue1) {
	                  // Triple exchange.
	                  a[k] = a[less];
	                  a[less++] = a[great];
	                  a[great--] = ek;
	                } else {
	                  // a[great] == pivot1.
	                  a[k] = a[great];
	                  a[great--] = ek;
	                }
	                break;
	              }
	            }
	          }
	        }
	      }
	    }
	
	    // The second partition has now been cleared of pivot elements and looks
	    // as follows:
	    // [  *  |  > pivot1 && < pivot2  | * ]
	    //        ^                      ^
	    //       less                  great
	    // Sort the second partition using recursive descent.
	
	    // The second partition looks as follows:
	    // [  *  |  >= pivot1 && <= pivot2  | * ]
	    //        ^                        ^
	    //       less                    great
	    // Simply sort it by recursive descent.
	
	    return sort(a, less, great + 1);
	  }
	
	  return sort;
	}
	
	var quicksort_sizeThreshold = 32;
	var crossfilter_array8 = crossfilter_arrayUntyped,
	    crossfilter_array16 = crossfilter_arrayUntyped,
	    crossfilter_array32 = crossfilter_arrayUntyped,
	    crossfilter_arrayLengthen = crossfilter_arrayLengthenUntyped,
	    crossfilter_arrayWiden = crossfilter_arrayWidenUntyped;
	
	if (typeof Uint8Array !== "undefined") {
	  crossfilter_array8 = function(n) { return new Uint8Array(n); };
	  crossfilter_array16 = function(n) { return new Uint16Array(n); };
	  crossfilter_array32 = function(n) { return new Uint32Array(n); };
	
	  crossfilter_arrayLengthen = function(array, length) {
	    if (array.length >= length) return array;
	    var copy = new array.constructor(length);
	    copy.set(array);
	    return copy;
	  };
	
	  crossfilter_arrayWiden = function(array, width) {
	    var copy;
	    switch (width) {
	      case 16: copy = crossfilter_array16(array.length); break;
	      case 32: copy = crossfilter_array32(array.length); break;
	      default: throw new Error("invalid array width!");
	    }
	    copy.set(array);
	    return copy;
	  };
	}
	
	function crossfilter_arrayUntyped(n) {
	  var array = new Array(n), i = -1;
	  while (++i < n) array[i] = 0;
	  return array;
	}
	
	function crossfilter_arrayLengthenUntyped(array, length) {
	  var n = array.length;
	  while (n < length) array[n++] = 0;
	  return array;
	}
	
	function crossfilter_arrayWidenUntyped(array, width) {
	  if (width > 32) throw new Error("invalid array width!");
	  return array;
	}
	function crossfilter_filterExact(bisect, value) {
	  return function(values) {
	    var n = values.length;
	    return [bisect.left(values, value, 0, n), bisect.right(values, value, 0, n)];
	  };
	}
	
	function crossfilter_filterRange(bisect, range) {
	  var min = range[0],
	      max = range[1];
	  return function(values) {
	    var n = values.length;
	    return [bisect.left(values, min, 0, n), bisect.left(values, max, 0, n)];
	  };
	}
	
	function crossfilter_filterAll(values) {
	  return [0, values.length];
	}
	function crossfilter_null() {
	  return null;
	}
	function crossfilter_zero() {
	  return 0;
	}
	function crossfilter_reduceIncrement(p) {
	  return p + 1;
	}
	
	function crossfilter_reduceDecrement(p) {
	  return p - 1;
	}
	
	function crossfilter_reduceAdd(f) {
	  return function(p, v) {
	    return p + +f(v);
	  };
	}
	
	function crossfilter_reduceSubtract(f) {
	  return function(p, v) {
	    return p - f(v);
	  };
	}
	exports.crossfilter = crossfilter;
	
	function crossfilter() {
	  var crossfilter = {
	    add: add,
	    remove: removeData,
	    dimension: dimension,
	    groupAll: groupAll,
	    size: size
	  };
	
	  var data = [], // the records
	      n = 0, // the number of records; data.length
	      m = 0, // a bit mask representing which dimensions are in use
	      M = 8, // number of dimensions that can fit in `filters`
	      filters = crossfilter_array8(0), // M bits per record; 1 is filtered out
	      filterListeners = [], // when the filters change
	      dataListeners = [], // when data is added
	      removeDataListeners = []; // when data is removed
	
	  // Adds the specified new records to this crossfilter.
	  function add(newData) {
	    var n0 = n,
	        n1 = newData.length;
	
	    // If there's actually new data to add…
	    // Merge the new data into the existing data.
	    // Lengthen the filter bitset to handle the new records.
	    // Notify listeners (dimensions and groups) that new data is available.
	    if (n1) {
	      data = data.concat(newData);
	      filters = crossfilter_arrayLengthen(filters, n += n1);
	      dataListeners.forEach(function(l) { l(newData, n0, n1); });
	    }
	
	    return crossfilter;
	  }
	
	  // Removes all records that match the current filters.
	  function removeData() {
	    var newIndex = crossfilter_index(n, n),
	        removed = [];
	    for (var i = 0, j = 0; i < n; ++i) {
	      if (filters[i]) newIndex[i] = j++;
	      else removed.push(i);
	    }
	
	    // Remove all matching records from groups.
	    filterListeners.forEach(function(l) { l(0, [], removed); });
	
	    // Update indexes.
	    removeDataListeners.forEach(function(l) { l(newIndex); });
	
	    // Remove old filters and data by overwriting.
	    for (var i = 0, j = 0, k; i < n; ++i) {
	      if (k = filters[i]) {
	        if (i !== j) filters[j] = k, data[j] = data[i];
	        ++j;
	      }
	    }
	    data.length = j;
	    while (n > j) filters[--n] = 0;
	  }
	
	  // Adds a new dimension with the specified value accessor function.
	  function dimension(value) {
	    var dimension = {
	      filter: filter,
	      filterExact: filterExact,
	      filterRange: filterRange,
	      filterFunction: filterFunction,
	      filterAll: filterAll,
	      top: top,
	      bottom: bottom,
	      group: group,
	      groupAll: groupAll,
	      dispose: dispose,
	      remove: dispose // for backwards-compatibility
	    };
	
	    var one = ~m & -~m, // lowest unset bit as mask, e.g., 00001000
	        zero = ~one, // inverted one, e.g., 11110111
	        values, // sorted, cached array
	        index, // value rank ↦ object id
	        newValues, // temporary array storing newly-added values
	        newIndex, // temporary array storing newly-added index
	        sort = quicksort_by(function(i) { return newValues[i]; }),
	        refilter = crossfilter_filterAll, // for recomputing filter
	        refilterFunction, // the custom filter function in use
	        indexListeners = [], // when data is added
	        dimensionGroups = [],
	        lo0 = 0,
	        hi0 = 0;
	
	    // Updating a dimension is a two-stage process. First, we must update the
	    // associated filters for the newly-added records. Once all dimensions have
	    // updated their filters, the groups are notified to update.
	    dataListeners.unshift(preAdd);
	    dataListeners.push(postAdd);
	
	    removeDataListeners.push(removeData);
	
	    // Incorporate any existing data into this dimension, and make sure that the
	    // filter bitset is wide enough to handle the new dimension.
	    m |= one;
	    if (M >= 32 ? !one : m & -(1 << M)) {
	      filters = crossfilter_arrayWiden(filters, M <<= 1);
	    }
	    preAdd(data, 0, n);
	    postAdd(data, 0, n);
	
	    // Incorporates the specified new records into this dimension.
	    // This function is responsible for updating filters, values, and index.
	    function preAdd(newData, n0, n1) {
	
	      // Permute new values into natural order using a sorted index.
	      newValues = newData.map(value);
	      newIndex = sort(crossfilter_range(n1), 0, n1);
	      newValues = permute(newValues, newIndex);
	
	      // Bisect newValues to determine which new records are selected.
	      var bounds = refilter(newValues), lo1 = bounds[0], hi1 = bounds[1], i;
	      if (refilterFunction) {
	        for (i = 0; i < n1; ++i) {
	          if (!refilterFunction(newValues[i], i)) filters[newIndex[i] + n0] |= one;
	        }
	      } else {
	        for (i = 0; i < lo1; ++i) filters[newIndex[i] + n0] |= one;
	        for (i = hi1; i < n1; ++i) filters[newIndex[i] + n0] |= one;
	      }
	
	      // If this dimension previously had no data, then we don't need to do the
	      // more expensive merge operation; use the new values and index as-is.
	      if (!n0) {
	        values = newValues;
	        index = newIndex;
	        lo0 = lo1;
	        hi0 = hi1;
	        return;
	      }
	
	      var oldValues = values,
	          oldIndex = index,
	          i0 = 0,
	          i1 = 0;
	
	      // Otherwise, create new arrays into which to merge new and old.
	      values = new Array(n);
	      index = crossfilter_index(n, n);
	
	      // Merge the old and new sorted values, and old and new index.
	      for (i = 0; i0 < n0 && i1 < n1; ++i) {
	        if (oldValues[i0] < newValues[i1]) {
	          values[i] = oldValues[i0];
	          index[i] = oldIndex[i0++];
	        } else {
	          values[i] = newValues[i1];
	          index[i] = newIndex[i1++] + n0;
	        }
	      }
	
	      // Add any remaining old values.
	      for (; i0 < n0; ++i0, ++i) {
	        values[i] = oldValues[i0];
	        index[i] = oldIndex[i0];
	      }
	
	      // Add any remaining new values.
	      for (; i1 < n1; ++i1, ++i) {
	        values[i] = newValues[i1];
	        index[i] = newIndex[i1] + n0;
	      }
	
	      // Bisect again to recompute lo0 and hi0.
	      bounds = refilter(values), lo0 = bounds[0], hi0 = bounds[1];
	    }
	
	    // When all filters have updated, notify index listeners of the new values.
	    function postAdd(newData, n0, n1) {
	      indexListeners.forEach(function(l) { l(newValues, newIndex, n0, n1); });
	      newValues = newIndex = null;
	    }
	
	    function removeData(reIndex) {
	      for (var i = 0, j = 0, k; i < n; ++i) {
	        if (filters[k = index[i]]) {
	          if (i !== j) values[j] = values[i];
	          index[j] = reIndex[k];
	          ++j;
	        }
	      }
	      values.length = j;
	      while (j < n) index[j++] = 0;
	
	      // Bisect again to recompute lo0 and hi0.
	      var bounds = refilter(values);
	      lo0 = bounds[0], hi0 = bounds[1];
	    }
	
	    // Updates the selected values based on the specified bounds [lo, hi].
	    // This implementation is used by all the public filter methods.
	    function filterIndexBounds(bounds) {
	      var lo1 = bounds[0],
	          hi1 = bounds[1];
	
	      if (refilterFunction) {
	        refilterFunction = null;
	        filterIndexFunction(function(d, i) { return lo1 <= i && i < hi1; });
	        lo0 = lo1;
	        hi0 = hi1;
	        return dimension;
	      }
	
	      var i,
	          j,
	          k,
	          added = [],
	          removed = [];
	
	      // Fast incremental update based on previous lo index.
	      if (lo1 < lo0) {
	        for (i = lo1, j = Math.min(lo0, hi1); i < j; ++i) {
	          filters[k = index[i]] ^= one;
	          added.push(k);
	        }
	      } else if (lo1 > lo0) {
	        for (i = lo0, j = Math.min(lo1, hi0); i < j; ++i) {
	          filters[k = index[i]] ^= one;
	          removed.push(k);
	        }
	      }
	
	      // Fast incremental update based on previous hi index.
	      if (hi1 > hi0) {
	        for (i = Math.max(lo1, hi0), j = hi1; i < j; ++i) {
	          filters[k = index[i]] ^= one;
	          added.push(k);
	        }
	      } else if (hi1 < hi0) {
	        for (i = Math.max(lo0, hi1), j = hi0; i < j; ++i) {
	          filters[k = index[i]] ^= one;
	          removed.push(k);
	        }
	      }
	
	      lo0 = lo1;
	      hi0 = hi1;
	      filterListeners.forEach(function(l) { l(one, added, removed); });
	      return dimension;
	    }
	
	    // Filters this dimension using the specified range, value, or null.
	    // If the range is null, this is equivalent to filterAll.
	    // If the range is an array, this is equivalent to filterRange.
	    // Otherwise, this is equivalent to filterExact.
	    function filter(range) {
	      return range == null
	          ? filterAll() : Array.isArray(range)
	          ? filterRange(range) : typeof range === "function"
	          ? filterFunction(range)
	          : filterExact(range);
	    }
	
	    // Filters this dimension to select the exact value.
	    function filterExact(value) {
	      return filterIndexBounds((refilter = crossfilter_filterExact(bisect, value))(values));
	    }
	
	    // Filters this dimension to select the specified range [lo, hi].
	    // The lower bound is inclusive, and the upper bound is exclusive.
	    function filterRange(range) {
	      return filterIndexBounds((refilter = crossfilter_filterRange(bisect, range))(values));
	    }
	
	    // Clears any filters on this dimension.
	    function filterAll() {
	      return filterIndexBounds((refilter = crossfilter_filterAll)(values));
	    }
	
	    // Filters this dimension using an arbitrary function.
	    function filterFunction(f) {
	      refilter = crossfilter_filterAll;
	
	      filterIndexFunction(refilterFunction = f);
	
	      lo0 = 0;
	      hi0 = n;
	
	      return dimension;
	    }
	
	    function filterIndexFunction(f) {
	      var i,
	          k,
	          x,
	          added = [],
	          removed = [];
	
	      for (i = 0; i < n; ++i) {
	        if (!(filters[k = index[i]] & one) ^ !!(x = f(values[i], i))) {
	          if (x) filters[k] &= zero, added.push(k);
	          else filters[k] |= one, removed.push(k);
	        }
	      }
	      filterListeners.forEach(function(l) { l(one, added, removed); });
	    }
	
	    // Returns the top K selected records based on this dimension's order.
	    // Note: observes this dimension's filter, unlike group and groupAll.
	    function top(k) {
	      var array = [],
	          i = hi0,
	          j;
	
	      while (--i >= lo0 && k > 0) {
	        if (!filters[j = index[i]]) {
	          array.push(data[j]);
	          --k;
	        }
	      }
	
	      return array;
	    }
	
	    // Returns the bottom K selected records based on this dimension's order.
	    // Note: observes this dimension's filter, unlike group and groupAll.
	    function bottom(k) {
	      var array = [],
	          i = lo0,
	          j;
	
	      while (i < hi0 && k > 0) {
	        if (!filters[j = index[i]]) {
	          array.push(data[j]);
	          --k;
	        }
	        i++;
	      }
	
	      return array;
	    }
	
	    // Adds a new group to this dimension, using the specified key function.
	    function group(key) {
	      var group = {
	        top: top,
	        all: all,
	        reduce: reduce,
	        reduceCount: reduceCount,
	        reduceSum: reduceSum,
	        order: order,
	        orderNatural: orderNatural,
	        size: size,
	        dispose: dispose,
	        remove: dispose // for backwards-compatibility
	      };
	
	      // Ensure that this group will be removed when the dimension is removed.
	      dimensionGroups.push(group);
	
	      var groups, // array of {key, value}
	          groupIndex, // object id ↦ group id
	          groupWidth = 8,
	          groupCapacity = crossfilter_capacity(groupWidth),
	          k = 0, // cardinality
	          select,
	          heap,
	          reduceAdd,
	          reduceRemove,
	          reduceInitial,
	          update = crossfilter_null,
	          reset = crossfilter_null,
	          resetNeeded = true,
	          groupAll = key === crossfilter_null;
	
	      if (arguments.length < 1) key = crossfilter_identity;
	
	      // The group listens to the crossfilter for when any dimension changes, so
	      // that it can update the associated reduce values. It must also listen to
	      // the parent dimension for when data is added, and compute new keys.
	      filterListeners.push(update);
	      indexListeners.push(add);
	      removeDataListeners.push(removeData);
	
	      // Incorporate any existing data into the grouping.
	      add(values, index, 0, n);
	
	      // Incorporates the specified new values into this group.
	      // This function is responsible for updating groups and groupIndex.
	      function add(newValues, newIndex, n0, n1) {
	        var oldGroups = groups,
	            reIndex = crossfilter_index(k, groupCapacity),
	            add = reduceAdd,
	            initial = reduceInitial,
	            k0 = k, // old cardinality
	            i0 = 0, // index of old group
	            i1 = 0, // index of new record
	            j, // object id
	            g0, // old group
	            x0, // old key
	            x1, // new key
	            g, // group to add
	            x; // key of group to add
	
	        // If a reset is needed, we don't need to update the reduce values.
	        if (resetNeeded) add = initial = crossfilter_null;
	
	        // Reset the new groups (k is a lower bound).
	        // Also, make sure that groupIndex exists and is long enough.
	        groups = new Array(k), k = 0;
	        groupIndex = k0 > 1 ? crossfilter_arrayLengthen(groupIndex, n) : crossfilter_index(n, groupCapacity);
	
	        // Get the first old key (x0 of g0), if it exists.
	        if (k0) x0 = (g0 = oldGroups[0]).key;
	
	        // Find the first new key (x1), skipping NaN keys.
	        while (i1 < n1 && !((x1 = key(newValues[i1])) >= x1)) ++i1;
	
	        // While new keys remain…
	        while (i1 < n1) {
	
	          // Determine the lesser of the two current keys; new and old.
	          // If there are no old keys remaining, then always add the new key.
	          if (g0 && x0 <= x1) {
	            g = g0, x = x0;
	
	            // Record the new index of the old group.
	            reIndex[i0] = k;
	
	            // Retrieve the next old key.
	            if (g0 = oldGroups[++i0]) x0 = g0.key;
	          } else {
	            g = {key: x1, value: initial()}, x = x1;
	          }
	
	          // Add the lesser group.
	          groups[k] = g;
	
	          // Add any selected records belonging to the added group, while
	          // advancing the new key and populating the associated group index.
	          while (!(x1 > x)) {
	            groupIndex[j = newIndex[i1] + n0] = k;
	            if (!(filters[j] & zero)) g.value = add(g.value, data[j]);
	            if (++i1 >= n1) break;
	            x1 = key(newValues[i1]);
	          }
	
	          groupIncrement();
	        }
	
	        // Add any remaining old groups that were greater than all new keys.
	        // No incremental reduce is needed; these groups have no new records.
	        // Also record the new index of the old group.
	        while (i0 < k0) {
	          groups[reIndex[i0] = k] = oldGroups[i0++];
	          groupIncrement();
	        }
	
	        // If we added any new groups before any old groups,
	        // update the group index of all the old records.
	        if (k > i0) for (i0 = 0; i0 < n0; ++i0) {
	          groupIndex[i0] = reIndex[groupIndex[i0]];
	        }
	
	        // Modify the update and reset behavior based on the cardinality.
	        // If the cardinality is less than or equal to one, then the groupIndex
	        // is not needed. If the cardinality is zero, then there are no records
	        // and therefore no groups to update or reset. Note that we also must
	        // change the registered listener to point to the new method.
	        j = filterListeners.indexOf(update);
	        if (k > 1) {
	          update = updateMany;
	          reset = resetMany;
	        } else {
	          if (!k && groupAll) {
	            k = 1;
	            groups = [{key: null, value: initial()}];
	          }
	          if (k === 1) {
	            update = updateOne;
	            reset = resetOne;
	          } else {
	            update = crossfilter_null;
	            reset = crossfilter_null;
	          }
	          groupIndex = null;
	        }
	        filterListeners[j] = update;
	
	        // Count the number of added groups,
	        // and widen the group index as needed.
	        function groupIncrement() {
	          if (++k === groupCapacity) {
	            reIndex = crossfilter_arrayWiden(reIndex, groupWidth <<= 1);
	            groupIndex = crossfilter_arrayWiden(groupIndex, groupWidth);
	            groupCapacity = crossfilter_capacity(groupWidth);
	          }
	        }
	      }
	
	      function removeData() {
	        if (k > 1) {
	          var oldK = k,
	              oldGroups = groups,
	              seenGroups = crossfilter_index(oldK, oldK);
	
	          // Filter out non-matches by copying matching group index entries to
	          // the beginning of the array.
	          for (var i = 0, j = 0; i < n; ++i) {
	            if (filters[i]) {
	              seenGroups[groupIndex[j] = groupIndex[i]] = 1;
	              ++j;
	            }
	          }
	
	          // Reassemble groups including only those groups that were referred
	          // to by matching group index entries.  Note the new group index in
	          // seenGroups.
	          groups = [], k = 0;
	          for (i = 0; i < oldK; ++i) {
	            if (seenGroups[i]) {
	              seenGroups[i] = k++;
	              groups.push(oldGroups[i]);
	            }
	          }
	
	          if (k > 1) {
	            // Reindex the group index using seenGroups to find the new index.
	            for (var i = 0; i < j; ++i) groupIndex[i] = seenGroups[groupIndex[i]];
	          } else {
	            groupIndex = null;
	          }
	          filterListeners[filterListeners.indexOf(update)] = k > 1
	              ? (reset = resetMany, update = updateMany)
	              : k === 1 ? (reset = resetOne, update = updateOne)
	              : reset = update = crossfilter_null;
	        } else if (k === 1) {
	          if (groupAll) return;
	          for (var i = 0; i < n; ++i) if (filters[i]) return;
	          groups = [], k = 0;
	          filterListeners[filterListeners.indexOf(update)] =
	          update = reset = crossfilter_null;
	        }
	      }
	
	      // Reduces the specified selected or deselected records.
	      // This function is only used when the cardinality is greater than 1.
	      function updateMany(filterOne, added, removed) {
	        if (filterOne === one || resetNeeded) return;
	
	        var i,
	            k,
	            n,
	            g;
	
	        // Add the added values.
	        for (i = 0, n = added.length; i < n; ++i) {
	          if (!(filters[k = added[i]] & zero)) {
	            g = groups[groupIndex[k]];
	            g.value = reduceAdd(g.value, data[k]);
	          }
	        }
	
	        // Remove the removed values.
	        for (i = 0, n = removed.length; i < n; ++i) {
	          if ((filters[k = removed[i]] & zero) === filterOne) {
	            g = groups[groupIndex[k]];
	            g.value = reduceRemove(g.value, data[k]);
	          }
	        }
	      }
	
	      // Reduces the specified selected or deselected records.
	      // This function is only used when the cardinality is 1.
	      function updateOne(filterOne, added, removed) {
	        if (filterOne === one || resetNeeded) return;
	
	        var i,
	            k,
	            n,
	            g = groups[0];
	
	        // Add the added values.
	        for (i = 0, n = added.length; i < n; ++i) {
	          if (!(filters[k = added[i]] & zero)) {
	            g.value = reduceAdd(g.value, data[k]);
	          }
	        }
	
	        // Remove the removed values.
	        for (i = 0, n = removed.length; i < n; ++i) {
	          if ((filters[k = removed[i]] & zero) === filterOne) {
	            g.value = reduceRemove(g.value, data[k]);
	          }
	        }
	      }
	
	      // Recomputes the group reduce values from scratch.
	      // This function is only used when the cardinality is greater than 1.
	      function resetMany() {
	        var i,
	            g;
	
	        // Reset all group values.
	        for (i = 0; i < k; ++i) {
	          groups[i].value = reduceInitial();
	        }
	
	        // Add any selected records.
	        for (i = 0; i < n; ++i) {
	          if (!(filters[i] & zero)) {
	            g = groups[groupIndex[i]];
	            g.value = reduceAdd(g.value, data[i]);
	          }
	        }
	      }
	
	      // Recomputes the group reduce values from scratch.
	      // This function is only used when the cardinality is 1.
	      function resetOne() {
	        var i,
	            g = groups[0];
	
	        // Reset the singleton group values.
	        g.value = reduceInitial();
	
	        // Add any selected records.
	        for (i = 0; i < n; ++i) {
	          if (!(filters[i] & zero)) {
	            g.value = reduceAdd(g.value, data[i]);
	          }
	        }
	      }
	
	      // Returns the array of group values, in the dimension's natural order.
	      function all() {
	        if (resetNeeded) reset(), resetNeeded = false;
	        return groups;
	      }
	
	      // Returns a new array containing the top K group values, in reduce order.
	      function top(k) {
	        var top = select(all(), 0, groups.length, k);
	        return heap.sort(top, 0, top.length);
	      }
	
	      // Sets the reduce behavior for this group to use the specified functions.
	      // This method lazily recomputes the reduce values, waiting until needed.
	      function reduce(add, remove, initial) {
	        reduceAdd = add;
	        reduceRemove = remove;
	        reduceInitial = initial;
	        resetNeeded = true;
	        return group;
	      }
	
	      // A convenience method for reducing by count.
	      function reduceCount() {
	        return reduce(crossfilter_reduceIncrement, crossfilter_reduceDecrement, crossfilter_zero);
	      }
	
	      // A convenience method for reducing by sum(value).
	      function reduceSum(value) {
	        return reduce(crossfilter_reduceAdd(value), crossfilter_reduceSubtract(value), crossfilter_zero);
	      }
	
	      // Sets the reduce order, using the specified accessor.
	      function order(value) {
	        select = heapselect_by(valueOf);
	        heap = heap_by(valueOf);
	        function valueOf(d) { return value(d.value); }
	        return group;
	      }
	
	      // A convenience method for natural ordering by reduce value.
	      function orderNatural() {
	        return order(crossfilter_identity);
	      }
	
	      // Returns the cardinality of this group, irrespective of any filters.
	      function size() {
	        return k;
	      }
	
	      // Removes this group and associated event listeners.
	      function dispose() {
	        var i = filterListeners.indexOf(update);
	        if (i >= 0) filterListeners.splice(i, 1);
	        i = indexListeners.indexOf(add);
	        if (i >= 0) indexListeners.splice(i, 1);
	        i = removeDataListeners.indexOf(removeData);
	        if (i >= 0) removeDataListeners.splice(i, 1);
	        return group;
	      }
	
	      return reduceCount().orderNatural();
	    }
	
	    // A convenience function for generating a singleton group.
	    function groupAll() {
	      var g = group(crossfilter_null), all = g.all;
	      delete g.all;
	      delete g.top;
	      delete g.order;
	      delete g.orderNatural;
	      delete g.size;
	      g.value = function() { return all()[0].value; };
	      return g;
	    }
	
	    // Removes this dimension and associated groups and event listeners.
	    function dispose() {
	      dimensionGroups.forEach(function(group) { group.dispose(); });
	      var i = dataListeners.indexOf(preAdd);
	      if (i >= 0) dataListeners.splice(i, 1);
	      i = dataListeners.indexOf(postAdd);
	      if (i >= 0) dataListeners.splice(i, 1);
	      i = removeDataListeners.indexOf(removeData);
	      if (i >= 0) removeDataListeners.splice(i, 1);
	      m &= zero;
	      return filterAll();
	    }
	
	    return dimension;
	  }
	
	  // A convenience method for groupAll on a dummy dimension.
	  // This implementation can be optimized since it always has cardinality 1.
	  function groupAll() {
	    var group = {
	      reduce: reduce,
	      reduceCount: reduceCount,
	      reduceSum: reduceSum,
	      value: value,
	      dispose: dispose,
	      remove: dispose // for backwards-compatibility
	    };
	
	    var reduceValue,
	        reduceAdd,
	        reduceRemove,
	        reduceInitial,
	        resetNeeded = true;
	
	    // The group listens to the crossfilter for when any dimension changes, so
	    // that it can update the reduce value. It must also listen to the parent
	    // dimension for when data is added.
	    filterListeners.push(update);
	    dataListeners.push(add);
	
	    // For consistency; actually a no-op since resetNeeded is true.
	    add(data, 0, n);
	
	    // Incorporates the specified new values into this group.
	    function add(newData, n0) {
	      var i;
	
	      if (resetNeeded) return;
	
	      // Add the added values.
	      for (i = n0; i < n; ++i) {
	        if (!filters[i]) {
	          reduceValue = reduceAdd(reduceValue, data[i]);
	        }
	      }
	    }
	
	    // Reduces the specified selected or deselected records.
	    function update(filterOne, added, removed) {
	      var i,
	          k,
	          n;
	
	      if (resetNeeded) return;
	
	      // Add the added values.
	      for (i = 0, n = added.length; i < n; ++i) {
	        if (!filters[k = added[i]]) {
	          reduceValue = reduceAdd(reduceValue, data[k]);
	        }
	      }
	
	      // Remove the removed values.
	      for (i = 0, n = removed.length; i < n; ++i) {
	        if (filters[k = removed[i]] === filterOne) {
	          reduceValue = reduceRemove(reduceValue, data[k]);
	        }
	      }
	    }
	
	    // Recomputes the group reduce value from scratch.
	    function reset() {
	      var i;
	
	      reduceValue = reduceInitial();
	
	      for (i = 0; i < n; ++i) {
	        if (!filters[i]) {
	          reduceValue = reduceAdd(reduceValue, data[i]);
	        }
	      }
	    }
	
	    // Sets the reduce behavior for this group to use the specified functions.
	    // This method lazily recomputes the reduce value, waiting until needed.
	    function reduce(add, remove, initial) {
	      reduceAdd = add;
	      reduceRemove = remove;
	      reduceInitial = initial;
	      resetNeeded = true;
	      return group;
	    }
	
	    // A convenience method for reducing by count.
	    function reduceCount() {
	      return reduce(crossfilter_reduceIncrement, crossfilter_reduceDecrement, crossfilter_zero);
	    }
	
	    // A convenience method for reducing by sum(value).
	    function reduceSum(value) {
	      return reduce(crossfilter_reduceAdd(value), crossfilter_reduceSubtract(value), crossfilter_zero);
	    }
	
	    // Returns the computed reduce value.
	    function value() {
	      if (resetNeeded) reset(), resetNeeded = false;
	      return reduceValue;
	    }
	
	    // Removes this group and associated event listeners.
	    function dispose() {
	      var i = filterListeners.indexOf(update);
	      if (i >= 0) filterListeners.splice(i);
	      i = dataListeners.indexOf(add);
	      if (i >= 0) dataListeners.splice(i);
	      return group;
	    }
	
	    return reduceCount();
	  }
	
	  // Returns the number of records in this crossfilter, irrespective of any filters.
	  function size() {
	    return n;
	  }
	
	  return arguments.length
	      ? add(arguments[0])
	      : crossfilter;
	}
	
	// Returns an array of size n, big enough to store ids up to m.
	function crossfilter_index(n, m) {
	  return (m < 0x101
	      ? crossfilter_array8 : m < 0x10001
	      ? crossfilter_array16
	      : crossfilter_array32)(n);
	}
	
	// Constructs a new array of size n, with sequential values from 0 to n - 1.
	function crossfilter_range(n) {
	  var range = crossfilter_index(n, n);
	  for (var i = -1; ++i < n;) range[i] = i;
	  return range;
	}
	
	function crossfilter_capacity(w) {
	  return w === 8
	      ? 0x100 : w === 16
	      ? 0x10000
	      : 0x100000000;
	}
	})(typeof exports !== 'undefined' && exports || this);


/***/ }),
/* 881 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var normal = exports.normal = {
	    blue: '#509EE3',
	    green: '#9CC177',
	    purple: '#A989C5',
	    red: '#EF8C8C',
	    yellow: '#f9d45c',
	    orange: '#F1B556',
	    teal: '#A6E7F3',
	    indigo: '#7172AD',
	    gray: '#7B8797'
	};
	
	var saturated = exports.saturated = {
	    blue: '#2D86D4',
	    green: '#84BB4C',
	    purple: '#885AB1',
	    red: '#ED6E6E',
	    yellow: '#F9CF48'
	};
	
	var desaturated = exports.desaturated = {
	    blue: '#72AFE5',
	    green: '#A8C987',
	    purple: '#B8A2CC',
	    red: '#EEA5A5',
	    yellow: '#F7D97B'
	};
	
	var harmony = exports.harmony = ['#509ee3', '#9cc177', '#a989c5', '#ef8c8c', '#f9d45c', '#F1B556', '#A6E7F3', '#7172AD', '#7B8797', '#6450e3', '#55e350', '#e35850', '#77c183', '#7d77c1', '#c589b9', '#bec589', '#89c3c5', '#c17777', '#899bc5', '#efce8c', '#50e3ae', '#be8cef', '#8cefc6', '#ef8cde', '#b5f95c', '#5cc2f9', '#f95cd0', '#c1a877', '#f95c67'];
	
	var getRandomColor = exports.getRandomColor = function getRandomColor(family) {
	    // $FlowFixMe: Object.values doesn't preserve the type :-/
	    var colors = Object.values(family);
	    return colors[Math.floor(Math.random() * colors.length)];
	};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.dimensionIsNumeric = dimensionIsNumeric;
	exports.precision = precision;
	exports.decimalCount = decimalCount;
	exports.computeNumericDataInverval = computeNumericDataInverval;
	exports.logTickFormat = logTickFormat;
	
	var _schema_metadata = __webpack_require__(867);
	
	function dimensionIsNumeric(_ref) {
	    var cols = _ref.cols,
	        rows = _ref.rows;
	    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    return (0, _schema_metadata.isNumeric)(cols[i]) || typeof (rows[0] && rows[0][i]) === "number";
	} /*  weak */
	
	function precision(a) {
	    if (!isFinite(a)) {
	        return 0;
	    }
	    if (!a) {
	        return 0;
	    }
	    var e = 1;
	    while (Math.round(a / e) !== a / e) {
	        e /= 10;
	    }
	    while (Math.round(a / Math.pow(10, e)) === a / Math.pow(10, e)) {
	        e *= 10;
	    }
	    return e;
	}
	
	function decimalCount(a) {
	    if (!isFinite(a)) return 0;
	    var e = 1,
	        p = 0;
	    while (Math.round(a * e) / e !== a) {
	        e *= 10;p++;
	    }
	    return p;
	}
	
	function computeNumericDataInverval(xValues) {
	    var bestPrecision = Infinity;
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = xValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var value = _step.value;
	
	            var p = precision(value) || 1;
	            if (p < bestPrecision) {
	                bestPrecision = p;
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return bestPrecision;
	}
	
	// logTickFormat(chart.xAxis())
	function logTickFormat(axis) {
	    var superscript = "⁰¹²³⁴⁵⁶⁷⁸⁹";
	    var formatPower = function formatPower(d) {
	        return (d + "").split("").map(function (c) {
	            return superscript[c];
	        }).join("");
	    };
	    var formatTick = function formatTick(d) {
	        return 10 + formatPower(Math.round(Math.log(d) / Math.LN10));
	    };
	    axis.tickFormat(formatTick);
	}

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.format = format;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _expressions = __webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	// convert a MBQL expression back into an expression string
	function format(expr, _ref) {
	    var _ref$tableMetadata = _ref.tableMetadata,
	        tableMetadata = _ref$tableMetadata === undefined ? {} : _ref$tableMetadata,
	        _ref$customFields = _ref.customFields,
	        customFields = _ref$customFields === undefined ? {} : _ref$customFields,
	        _ref$operators = _ref.operators,
	        operators = _ref$operators === undefined ? _expressions.VALID_OPERATORS : _ref$operators,
	        _ref$aggregations = _ref.aggregations,
	        aggregations = _ref$aggregations === undefined ? _expressions.VALID_AGGREGATIONS : _ref$aggregations;
	    var parens = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var info = { tableMetadata: tableMetadata, customFields: customFields, operators: operators, aggregations: aggregations };
	    if (expr == null || _underscore2.default.isEqual(expr, [])) {
	        return "";
	    }
	    if (typeof expr === "number") {
	        return formatLiteral(expr);
	    }
	    if ((0, _expressions.isField)(expr)) {
	        return formatField(expr, info);
	    }
	    if ((0, _expressions.isMetric)(expr)) {
	        return formatMetric(expr, info);
	    }
	    if ((0, _expressions.isMath)(expr)) {
	        return formatMath(expr, info, parens);
	    }
	    if ((0, _expressions.isAggregation)(expr)) {
	        return formatAggregation(expr, info);
	    }
	    if ((0, _expressions.isExpressionReference)(expr)) {
	        return formatExpressionReference(expr, info);
	    }
	    throw new Error("Unknown expression " + JSON.stringify(expr));
	}
	
	function formatLiteral(expr) {
	    return JSON.stringify(expr);
	}
	
	function formatField(_ref2, _ref3) {
	    var _ref4 = _slicedToArray(_ref2, 2),
	        fieldId = _ref4[1];
	
	    var fields = _ref3.tableMetadata.fields;
	
	    var field = _underscore2.default.findWhere(fields, { id: fieldId });
	    if (!field) {
	        throw 'field with ID does not exist: ' + fieldId;
	    }
	    return (0, _expressions.formatFieldName)(field);
	}
	
	function formatMetric(_ref5, _ref6) {
	    var _ref7 = _slicedToArray(_ref5, 2),
	        metricId = _ref7[1];
	
	    var metrics = _ref6.tableMetadata.metrics;
	
	    var metric = _underscore2.default.findWhere(metrics, { id: metricId });
	    if (!metric) {
	        throw 'metric with ID does not exist: ' + metricId;
	    }
	    return (0, _expressions.formatMetricName)(metric);
	}
	
	function formatExpressionReference(_ref8) {
	    var _ref9 = _slicedToArray(_ref8, 2),
	        expressionName = _ref9[1];
	
	    return (0, _expressions.formatExpressionName)(expressionName);
	}
	
	function formatMath(_ref10, info, parens) {
	    var _ref11 = _toArray(_ref10),
	        operator = _ref11[0],
	        args = _ref11.slice(1);
	
	    var formatted = args.map(function (arg) {
	        return format(arg, info, true);
	    }).join(" " + operator + " ");
	    return parens ? "(" + formatted + ")" : formatted;
	}
	
	function formatAggregation(_ref12, info) {
	    var _ref13 = _toArray(_ref12),
	        aggregation = _ref13[0],
	        args = _ref13.slice(1);
	
	    var aggregations = info.aggregations;
	
	    return args.length === 0 ? aggregations.get(aggregation) : aggregations.get(aggregation) + "(" + args.map(function (arg) {
	        return format(arg, info);
	    }).join(", ") + ")";
	}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.VALID_AGGREGATIONS = exports.VALID_OPERATORS = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _config = __webpack_require__(885);
	
	Object.defineProperty(exports, "VALID_OPERATORS", {
	    enumerable: true,
	    get: function get() {
	        return _config.VALID_OPERATORS;
	    }
	});
	Object.defineProperty(exports, "VALID_AGGREGATIONS", {
	    enumerable: true,
	    get: function get() {
	        return _config.VALID_AGGREGATIONS;
	    }
	});
	exports.getAggregationFromName = getAggregationFromName;
	exports.isReservedWord = isReservedWord;
	exports.formatAggregationName = formatAggregationName;
	exports.formatMetricName = formatMetricName;
	exports.formatFieldName = formatFieldName;
	exports.formatExpressionName = formatExpressionName;
	exports.isExpression = isExpression;
	exports.isField = isField;
	exports.isMetric = isMetric;
	exports.isMath = isMath;
	exports.isAggregation = isAggregation;
	exports.isExpressionReference = isExpressionReference;
	exports.isValidArg = isValidArg;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _util = __webpack_require__(870);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AGG_NAMES_MAP = new Map(Array.from(_config.VALID_AGGREGATIONS).map(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        short = _ref2[0],
	        displayName = _ref2[1];
	
	    return (
	        // case-insensitive
	        [displayName.toLowerCase(), short]
	    );
	}));
	
	function getAggregationFromName(name) {
	    // case-insensitive
	    return AGG_NAMES_MAP.get(name.toLowerCase());
	}
	
	function isReservedWord(word) {
	    return !!getAggregationFromName(word);
	}
	
	function formatAggregationName(aggregationOption) {
	    return _config.VALID_AGGREGATIONS.get(aggregationOption.short);
	}
	
	function formatIdentifier(name) {
	    return (/^\w+$/.test(name) && !isReservedWord(name) ? name : JSON.stringify(name)
	    );
	}
	
	function formatMetricName(metric) {
	    return formatIdentifier(metric.name);
	}
	
	function formatFieldName(field) {
	    return formatIdentifier(field.display_name);
	}
	
	function formatExpressionName(name) {
	    return formatIdentifier(name);
	}
	
	// move to query lib
	
	function isExpression(expr) {
	    return isMath(expr) || isAggregation(expr) || isField(expr) || isMetric(expr) || isExpressionReference(expr);
	}
	
	function isField(expr) {
	    return Array.isArray(expr) && expr.length === 2 && (0, _util.mbqlEq)(expr[0], 'field-id') && typeof expr[1] === 'number';
	}
	
	function isMetric(expr) {
	    // case sensitive, unlike most mbql
	    return Array.isArray(expr) && expr.length === 2 && expr[0] === "METRIC" && typeof expr[1] === 'number';
	}
	
	function isMath(expr) {
	    return Array.isArray(expr) && _config.VALID_OPERATORS.has(expr[0]) && _underscore2.default.all(expr.slice(1), isValidArg);
	}
	
	function isAggregation(expr) {
	    return Array.isArray(expr) && _config.VALID_AGGREGATIONS.has(expr[0]) && _underscore2.default.all(expr.slice(1), isValidArg);
	}
	
	function isExpressionReference(expr) {
	    return Array.isArray(expr) && expr.length === 2 && (0, _util.mbqlEq)(expr[0], 'expression') && typeof expr[1] === 'string';
	}
	
	function isValidArg(arg) {
	    return isExpression(arg) || isField(arg) || typeof arg === 'number';
	}

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var VALID_OPERATORS = exports.VALID_OPERATORS = new Set(['+', '-', '*', '/']);
	
	var VALID_AGGREGATIONS = exports.VALID_AGGREGATIONS = new Map(Object.entries({
	    "count": "Count",
	    "cum_count": "CumulativeCount",
	    "sum": "Sum",
	    "cum_sum": "CumulativeSum",
	    "distinct": "Distinct",
	    "stddev": "StandardDeviation",
	    "avg": "Average",
	    "min": "Min",
	    "max": "Max"
	}));
	
	var NULLARY_AGGREGATIONS = exports.NULLARY_AGGREGATIONS = ["count", "cum_count"];
	var UNARY_AGGREGATIONS = exports.UNARY_AGGREGATIONS = ["sum", "cum_sum", "distinct", "stddev", "avg", "min", "max"];

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getField = getField;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getField(table, fieldId) {
	    if (table) {
	        // sometimes we populate fields_lookup, sometimes we don't :(
	        if (table.fields_lookup) {
	            return table.fields_lookup[fieldId];
	        } else {
	            return _underscore2.default.findWhere(table.fields, { id: fieldId });
	        }
	    }
	} /*  weak */

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.clearExpression = exports.removeExpression = exports.updateExpression = exports.addExpression = exports.getExpressionsList = exports.getExpressions = exports.clearLimit = exports.updateLimit = exports.getLimit = exports.clearOrderBy = exports.removeOrderBy = exports.updateOrderBy = exports.addOrderBy = exports.getOrderBys = exports.canAddFilter = exports.clearFilters = exports.removeFilter = exports.updateFilter = exports.addFilter = exports.getFilters = exports.getBreakoutFields = exports.clearBreakouts = exports.removeBreakout = exports.updateBreakout = exports.addBreakout = exports.getBreakouts = exports.hasValidAggregation = exports.hasEmptyAggregation = exports.isBareRows = exports.clearAggregations = exports.removeAggregation = exports.updateAggregation = exports.addAggregation = exports.getAggregations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _aggregation = __webpack_require__(888);
	
	var A = _interopRequireWildcard(_aggregation);
	
	var _breakout = __webpack_require__(889);
	
	var B = _interopRequireWildcard(_breakout);
	
	var _filter = __webpack_require__(890);
	
	var F = _interopRequireWildcard(_filter);
	
	var _limit = __webpack_require__(891);
	
	var L = _interopRequireWildcard(_limit);
	
	var _order_by = __webpack_require__(892);
	
	var O = _interopRequireWildcard(_order_by);
	
	var _expression = __webpack_require__(893);
	
	var E = _interopRequireWildcard(_expression);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// AGGREGATION
	
	var getAggregations = exports.getAggregations = function getAggregations(query) {
	    return A.getAggregations(query.aggregation);
	};
	var addAggregation = exports.addAggregation = function addAggregation(query, aggregation) {
	    return setAggregationClause(query, A.addAggregation(query.aggregation, aggregation));
	};
	var updateAggregation = exports.updateAggregation = function updateAggregation(query, index, aggregation) {
	    return setAggregationClause(query, A.updateAggregation(query.aggregation, index, aggregation));
	};
	var removeAggregation = exports.removeAggregation = function removeAggregation(query, index) {
	    return setAggregationClause(query, A.removeAggregation(query.aggregation, index));
	};
	var clearAggregations = exports.clearAggregations = function clearAggregations(query) {
	    return setAggregationClause(query, A.clearAggregations(query.aggregation));
	};
	
	var isBareRows = exports.isBareRows = function isBareRows(query) {
	    return A.isBareRows(query.aggregation);
	};
	var hasEmptyAggregation = exports.hasEmptyAggregation = function hasEmptyAggregation(query) {
	    return A.hasEmptyAggregation(query.aggregation);
	};
	var hasValidAggregation = exports.hasValidAggregation = function hasValidAggregation(query) {
	    return A.hasValidAggregation(query.aggregation);
	};
	
	// BREAKOUT
	
	var getBreakouts = exports.getBreakouts = function getBreakouts(query) {
	    return B.getBreakouts(query.breakout);
	};
	var addBreakout = exports.addBreakout = function addBreakout(query, breakout) {
	    return setBreakoutClause(query, B.addBreakout(query.breakout, breakout));
	};
	var updateBreakout = exports.updateBreakout = function updateBreakout(query, index, breakout) {
	    return setBreakoutClause(query, B.updateBreakout(query.breakout, index, breakout));
	};
	var removeBreakout = exports.removeBreakout = function removeBreakout(query, index) {
	    return setBreakoutClause(query, B.removeBreakout(query.breakout, index));
	};
	var clearBreakouts = exports.clearBreakouts = function clearBreakouts(query) {
	    return setBreakoutClause(query, B.clearBreakouts(query.breakout));
	};
	
	var getBreakoutFields = exports.getBreakoutFields = function getBreakoutFields(query, tableMetadata) {
	    return B.getBreakoutFields(query.breakout, tableMetadata);
	};
	
	// FILTER
	
	var getFilters = exports.getFilters = function getFilters(query) {
	    return F.getFilters(query.filter);
	};
	var addFilter = exports.addFilter = function addFilter(query, filter) {
	    return setFilterClause(query, F.addFilter(query.filter, filter));
	};
	var updateFilter = exports.updateFilter = function updateFilter(query, index, filter) {
	    return setFilterClause(query, F.updateFilter(query.filter, index, filter));
	};
	var removeFilter = exports.removeFilter = function removeFilter(query, index) {
	    return setFilterClause(query, F.removeFilter(query.filter, index));
	};
	var clearFilters = exports.clearFilters = function clearFilters(query) {
	    return setFilterClause(query, F.clearFilters(query.filter));
	};
	
	var canAddFilter = exports.canAddFilter = function canAddFilter(query) {
	    return F.canAddFilter(query.filter);
	};
	
	// ORDER_BY
	
	var getOrderBys = exports.getOrderBys = function getOrderBys(query) {
	    return O.getOrderBys(query.order_by);
	};
	var addOrderBy = exports.addOrderBy = function addOrderBy(query, order_by) {
	    return setOrderByClause(query, O.addOrderBy(query.order_by, order_by));
	};
	var updateOrderBy = exports.updateOrderBy = function updateOrderBy(query, index, order_by) {
	    return setOrderByClause(query, O.updateOrderBy(query.order_by, index, order_by));
	};
	var removeOrderBy = exports.removeOrderBy = function removeOrderBy(query, index) {
	    return setOrderByClause(query, O.removeOrderBy(query.order_by, index));
	};
	var clearOrderBy = exports.clearOrderBy = function clearOrderBy(query) {
	    return setOrderByClause(query, O.clearOrderBy(query.order_by));
	};
	
	// LIMIT
	
	var getLimit = exports.getLimit = function getLimit(query) {
	    return L.getLimit(query.limit);
	};
	var updateLimit = exports.updateLimit = function updateLimit(query, limit) {
	    return setLimitClause(query, L.updateLimit(query.limit, limit));
	};
	var clearLimit = exports.clearLimit = function clearLimit(query) {
	    return setLimitClause(query, L.clearLimit(query.limit));
	};
	
	// EXPRESSIONS
	
	var getExpressions = exports.getExpressions = function getExpressions(query) {
	    return E.getExpressions(query.expressions);
	};
	var getExpressionsList = exports.getExpressionsList = function getExpressionsList(query) {
	    return E.getExpressionsList(query.expressions);
	};
	var addExpression = exports.addExpression = function addExpression(query, name, expression) {
	    return setExpressionClause(query, E.addExpression(query.expressions, name, expression));
	};
	var updateExpression = exports.updateExpression = function updateExpression(query, name, expression, oldName) {
	    return setExpressionClause(query, E.updateExpression(query.expressions, name, expression, oldName));
	};
	var removeExpression = exports.removeExpression = function removeExpression(query, name) {
	    return setExpressionClause(query, E.removeExpression(query.expressions, name));
	};
	var clearExpression = exports.clearExpression = function clearExpression(query) {
	    return setExpressionClause(query, E.clearExpressions(query.expressions));
	};
	
	// we can enforce various constraints in these functions:
	
	function setAggregationClause(query, aggregationClause) {
	    var wasBareRows = A.isBareRows(query.aggregation);
	    var isBareRows = A.isBareRows(aggregationClause);
	    // when switching to or from bare rows clear out any sorting clauses
	    if (isBareRows !== wasBareRows) {
	        clearOrderBy(query);
	    }
	    // for bare rows we always clear out any dimensions because they don't make sense
	    if (isBareRows) {
	        clearBreakouts(query);
	    }
	    return setClause("aggregation", query, aggregationClause);
	}
	function setBreakoutClause(query, breakoutClause) {
	    var breakoutIds = B.getBreakouts(breakoutClause).filter(function (id) {
	        return id != null;
	    });
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = getOrderBys(query).entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var _step$value = _slicedToArray(_step.value, 2),
	                index = _step$value[0],
	                sort = _step$value[1];
	
	            var sortId = _query2.default.getFieldTargetId(sort[0]);
	            if (sortId != null && !_underscore2.default.contains(breakoutIds, sortId)) {
	                query = removeOrderBy(query, index);
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return setClause("breakout", query, breakoutClause);
	}
	function setFilterClause(query, filterClause) {
	    return setClause("filter", query, filterClause);
	}
	function setOrderByClause(query, orderByClause) {
	    return setClause("order_by", query, orderByClause);
	}
	function setLimitClause(query, limitClause) {
	    return setClause("limit", query, limitClause);
	}
	function setExpressionClause(query, expressionClause) {
	    if (expressionClause && Object.keys(expressionClause).length === 0) {
	        expressionClause = null;
	    }
	    return setClause("expressions", query, expressionClause);
	}
	
	function setClause(clauseName, query, clause) {
	    query = _extends({}, query);
	    if (clause == null) {
	        delete query[clauseName];
	    } else {
	        query[clauseName] = clause;
	    }
	    return query;
	}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAggregations = getAggregations;
	exports.addAggregation = addAggregation;
	exports.updateAggregation = updateAggregation;
	exports.removeAggregation = removeAggregation;
	exports.clearAggregations = clearAggregations;
	exports.isBareRows = isBareRows;
	exports.hasEmptyAggregation = hasEmptyAggregation;
	exports.hasValidAggregation = hasValidAggregation;
	
	var _util = __webpack_require__(870);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// returns canonical list of Aggregations, i.e. with deprecated "rows" removed
	function getAggregations(aggregation) {
	    var aggregations = void 0;
	    if (Array.isArray(aggregation) && Array.isArray(aggregation[0])) {
	        aggregations = aggregation;
	    } else if (Array.isArray(aggregation) && typeof aggregation[0] === "string") {
	        // legacy
	        aggregations = [aggregation];
	    } else {
	        aggregations = [];
	    }
	    return aggregations.filter(function (agg) {
	        return agg && agg[0] && !(0, _util.mbqlEq)(agg[0], "rows");
	    });
	}
	
	// turns a list of Aggregations into the canonical AggregationClause
	function getAggregationClause(aggregations) {
	    aggregations = getAggregations(aggregations);
	    if (aggregations.length === 0) {
	        return undefined;
	    } else {
	        return aggregations;
	    }
	}
	
	function addAggregation(aggregation, newAggregation) {
	    return getAggregationClause((0, _util.add)(getAggregations(aggregation), newAggregation));
	}
	function updateAggregation(aggregation, index, updatedAggregation) {
	    return getAggregationClause((0, _util.update)(getAggregations(aggregation), index, updatedAggregation));
	}
	function removeAggregation(aggregation, index) {
	    return getAggregationClause((0, _util.remove)(getAggregations(aggregation), index));
	}
	function clearAggregations(ac) {
	    return getAggregationClause((0, _util.clear)());
	}
	
	// MISC
	
	function isBareRows(ac) {
	    return getAggregations(ac).length === 0;
	}
	
	function hasEmptyAggregation(ac) {
	    return _underscore2.default.any(getAggregations(ac), function (aggregation) {
	        return !(0, _util.noNullValues)(aggregation);
	    });
	}
	
	function hasValidAggregation(ac) {
	    return _underscore2.default.all(getAggregations(ac), function (aggregation) {
	        return (0, _util.noNullValues)(aggregation);
	    });
	}

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getBreakouts = getBreakouts;
	exports.getBreakoutFields = getBreakoutFields;
	exports.getBreakoutClause = getBreakoutClause;
	exports.addBreakout = addBreakout;
	exports.updateBreakout = updateBreakout;
	exports.removeBreakout = removeBreakout;
	exports.clearBreakouts = clearBreakouts;
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _util = __webpack_require__(870);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// returns canonical list of Breakouts, with nulls removed
	function getBreakouts(breakouts) {
	    return (breakouts || []).filter(function (b) {
	        return b != null;
	    });
	}
	
	function getBreakoutFields(breakouts, tableMetadata) {
	    return getBreakouts(breakouts).map(function (breakout) {
	        return (_query2.default.getFieldTarget(breakout, tableMetadata) || {}).field;
	    });
	}
	
	// turns a list of Breakouts into the canonical BreakoutClause
	function getBreakoutClause(breakouts) {
	    breakouts = getBreakouts(breakouts);
	    if (breakouts.length === 0) {
	        return undefined;
	    } else {
	        return breakouts;
	    }
	}
	
	function addBreakout(breakout, newBreakout) {
	    return getBreakoutClause((0, _util.add)(getBreakouts(breakout), newBreakout));
	}
	function updateBreakout(breakout, index, updatedBreakout) {
	    return getBreakoutClause((0, _util.update)(getBreakouts(breakout), index, updatedBreakout));
	}
	function removeBreakout(breakout, index) {
	    return getBreakoutClause((0, _util.remove)(getBreakouts(breakout), index));
	}
	function clearBreakouts(breakout) {
	    return getBreakoutClause((0, _util.clear)());
	}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getFilters = getFilters;
	exports.addFilter = addFilter;
	exports.updateFilter = updateFilter;
	exports.removeFilter = removeFilter;
	exports.clearFilters = clearFilters;
	exports.canAddFilter = canAddFilter;
	exports.isSegmentFilter = isSegmentFilter;
	exports.isCompoundFilter = isCompoundFilter;
	exports.isFieldFilter = isFieldFilter;
	
	var _util = __webpack_require__(870);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// returns canonical list of Filters
	function getFilters(filter) {
	    if (!filter || Array.isArray(filter) && filter.length === 0) {
	        return [];
	    } else if ((0, _util.mbqlEq)((0, _util.op)(filter), "and")) {
	        return (0, _util.args)(filter);
	    } else {
	        return [filter];
	    }
	}
	
	// turns a list of Filters into the canonical FilterClause, either `undefined`, `filter`, or `["and", filter...]`
	function getFilterClause(filters) {
	    if (filters.length === 0) {
	        return undefined;
	    } else if (filters.length === 1) {
	        return filters[0];
	    } else {
	        return ["and"].concat(_toConsumableArray(filters));
	    }
	}
	
	function addFilter(filter, newFilter) {
	    return getFilterClause((0, _util.add)(getFilters(filter), newFilter));
	}
	function updateFilter(filter, index, updatedFilter) {
	    return getFilterClause((0, _util.update)(getFilters(filter), index, updatedFilter));
	}
	function removeFilter(filter, index) {
	    return getFilterClause((0, _util.remove)(getFilters(filter), index));
	}
	function clearFilters(filter) {
	    return getFilterClause((0, _util.clear)());
	}
	
	// MISC
	
	function canAddFilter(filter) {
	    var filters = getFilters(filter);
	    if (filters.length > 0) {
	        return (0, _util.noNullValues)(filters[filters.length - 1]);
	    }
	    return true;
	}
	
	function isSegmentFilter(filter) {
	    return Array.isArray(filter) && (0, _util.mbqlEq)(filter[0], "segment");
	}
	
	function isCompoundFilter(filter) {
	    return Array.isArray(filter) && ((0, _util.mbqlEq)(filter[0], "and") || (0, _util.mbqlEq)(filter[0], "or"));
	}
	
	function isFieldFilter(filter) {
	    return !isSegmentFilter(filter) && !isCompoundFilter(filter);
	}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getLimit = getLimit;
	exports.updateLimit = updateLimit;
	exports.clearLimit = clearLimit;
	function getLimit(lc) {
	    return lc;
	}
	
	function updateLimit(lc, limit) {
	    return limit;
	}
	
	function clearLimit(lc) {
	    return undefined;
	}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getOrderBys = getOrderBys;
	exports.getOrderByClause = getOrderByClause;
	exports.addOrderBy = addOrderBy;
	exports.updateOrderBy = updateOrderBy;
	exports.removeOrderBy = removeOrderBy;
	exports.clearOrderBy = clearOrderBy;
	
	var _util = __webpack_require__(870);
	
	// returns canonical list of OrderBys, with nulls removed
	function getOrderBys(breakout) {
	    return (breakout || []).filter(function (b) {
	        return b != null;
	    });
	}
	
	// turns a list of OrderBys into the canonical OrderByClause
	function getOrderByClause(breakouts) {
	    breakouts = getOrderBys(breakouts);
	    if (breakouts.length === 0) {
	        return undefined;
	    } else {
	        return breakouts;
	    }
	}
	
	function addOrderBy(breakout, newOrderBy) {
	    return getOrderByClause((0, _util.add)(getOrderBys(breakout), newOrderBy));
	}
	function updateOrderBy(breakout, index, updatedOrderBy) {
	    return getOrderByClause((0, _util.update)(getOrderBys(breakout), index, updatedOrderBy));
	}
	function removeOrderBy(breakout, index) {
	    return getOrderByClause((0, _util.remove)(getOrderBys(breakout), index));
	}
	function clearOrderBy(breakout) {
	    return getOrderByClause((0, _util.clear)());
	}

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getExpressions = getExpressions;
	exports.getExpressionsList = getExpressionsList;
	exports.addExpression = addExpression;
	exports.updateExpression = updateExpression;
	exports.removeExpression = removeExpression;
	exports.clearExpressions = clearExpressions;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getExpressions() {
	    var expressions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return expressions;
	}
	
	function getExpressionsList() {
	    var expressions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return Object.entries(expressions).map(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            name = _ref2[0],
	            expression = _ref2[1];
	
	        return { name: name, expression: expression };
	    });
	}
	
	function addExpression() {
	    var expressions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var name = arguments[1];
	    var expression = arguments[2];
	
	    return _extends({}, expressions, _defineProperty({}, name, expression));
	}
	function updateExpression() {
	    var expressions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var name = arguments[1];
	    var expression = arguments[2];
	    var oldName = arguments[3];
	
	    if (oldName != null) {
	        expressions = removeExpression(expressions, oldName);
	    }
	    return addExpression(expressions, name, expression);
	}
	function removeExpression() {
	    var expressions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var name = arguments[1];
	
	    return _underscore2.default.omit(expressions, name);
	}
	function clearExpressions(expressions) {
	    return {};
	}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.newQuestion = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.question = question;
	exports.plainQuestion = plainQuestion;
	exports.dashboard = dashboard;
	exports.modelToUrl = modelToUrl;
	exports.pulse = pulse;
	exports.tableRowsQuery = tableRowsQuery;
	exports.collection = collection;
	exports.label = label;
	exports.publicCard = publicCard;
	exports.publicDashboard = publicDashboard;
	exports.embedCard = embedCard;
	
	var _card = __webpack_require__(865);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// provides functions for building urls to things we care about
	
	var newQuestion = exports.newQuestion = function newQuestion() {
	    return "/question/new";
	};
	function question(cardId) {
	    var hash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	    var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	
	    if (hash && (typeof hash === "undefined" ? "undefined" : _typeof(hash)) === "object") {
	        hash = (0, _card.serializeCardForUrl)(hash);
	    }
	    if (query && (typeof query === "undefined" ? "undefined" : _typeof(query)) === "object") {
	        query = Object.entries(query).map(function (kv) {
	            return kv.map(encodeURIComponent).join("=");
	        }).join("&");
	    }
	    if (hash && hash.charAt(0) !== "#") {
	        hash = "#" + hash;
	    }
	    if (query && query.charAt(0) !== "?") {
	        query = "?" + query;
	    }
	    // NOTE that this is for an ephemeral card link, not an editable card
	    return cardId != null ? "/question/" + cardId + query + hash : "/question" + query + hash;
	}
	
	function plainQuestion() {
	    return _Question2.default.create({ metadata: null }).getUrl();
	}
	
	function dashboard(dashboardId) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        addCardWithId = _ref.addCardWithId;
	
	    return addCardWithId != null ? "/dashboard/" + dashboardId + "#add=" + addCardWithId : "/dashboard/" + dashboardId;
	}
	
	function modelToUrl(model, modelId) {
	    switch (model) {
	        case "card":
	            return question(modelId);
	        case "dashboard":
	            return dashboard(modelId);
	        case "pulse":
	            return pulse(modelId);
	        default:
	            return null;
	    }
	}
	
	function pulse(pulseId) {
	    return "/pulse/#" + pulseId;
	}
	
	function tableRowsQuery(databaseId, tableId, metricId, segmentId) {
	    var query = "?db=" + databaseId + "&table=" + tableId;
	
	    if (metricId) {
	        query += "&metric=" + metricId;
	    }
	
	    if (segmentId) {
	        query += "&segment=" + segmentId;
	    }
	
	    return question(null, query);
	}
	
	function collection(collection) {
	    return "/questions/collections/" + collection.slug;
	}
	
	function label(label) {
	    return "/questions/search?label=" + encodeURIComponent(label.slug);
	}
	
	function publicCard(uuid) {
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    var siteUrl = _settings2.default.get("site_url");
	    return siteUrl + "/public/question/" + uuid + (type ? "." + type : "");
	}
	
	function publicDashboard(uuid) {
	    var siteUrl = _settings2.default.get("site_url");
	    return siteUrl + "/public/dashboard/" + uuid;
	}
	
	function embedCard(token) {
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    return "/embed/question/" + token + (type ? "." + type : "");
	}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class; /*  weak */
	
	var _Query = __webpack_require__(896);
	
	var _Query2 = _interopRequireDefault(_Query);
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Field = __webpack_require__(900);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	var _NativeQuery = __webpack_require__(954);
	
	var _NativeQuery2 = _interopRequireDefault(_NativeQuery);
	
	var _utils = __webpack_require__(946);
	
	var _utils2 = __webpack_require__(521);
	
	var _utils3 = _interopRequireDefault(_utils2);
	
	var _card = __webpack_require__(865);
	
	var Card_DEPRECATED = _interopRequireWildcard(_card);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _Card = __webpack_require__(957);
	
	var _actions = __webpack_require__(959);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	var _services = __webpack_require__(857);
	
	var _AtomicQuery = __webpack_require__(948);
	
	var _AtomicQuery2 = _interopRequireDefault(_AtomicQuery);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _Mode = __webpack_require__(961);
	
	var _Mode2 = _interopRequireDefault(_Mode);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	    var desc = {};
	    Object['ke' + 'ys'](descriptor).forEach(function (key) {
	        desc[key] = descriptor[key];
	    });
	    desc.enumerable = !!desc.enumerable;
	    desc.configurable = !!desc.configurable;
	
	    if ('value' in desc || desc.initializer) {
	        desc.writable = true;
	    }
	
	    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	        return decorator(target, property, desc) || desc;
	    }, desc);
	
	    if (context && desc.initializer !== void 0) {
	        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	        desc.initializer = undefined;
	    }
	
	    if (desc.initializer === void 0) {
	        Object['define' + 'Property'](target, property, desc);
	        desc = null;
	    }
	
	    return desc;
	}
	
	/**
	 * This is a wrapper around a question/card object, which may contain one or more Query objects
	 */
	var Question = (_class = function () {
	
	    /**
	     * Question constructor
	     */
	
	
	    /**
	     * The plain object presentation of this question, equal to the format that Metabase REST API understands.
	     * It is called `card` for both historical reasons and to make a clear distinction to this class.
	     */
	    function Question(metadata, card, parameterValues) {
	        _classCallCheck(this, Question);
	
	        this._metadata = metadata;
	        this._card = card;
	        this._parameterValues = parameterValues || {};
	    }
	
	    /**
	     * TODO Atte Keinänen 6/13/17: Discussed with Tom that we could use the default Question constructor instead,
	     * but it would require changing the constructor signature so that `card` is an optional parameter and has a default value
	     */
	
	
	    /**
	     * Parameter values mean either the current values of dashboard filters or SQL editor template parameters.
	     * They are in the grey area between UI state and question state, but having them in Question wrapper is convenient.
	     */
	
	    /**
	     * The Question wrapper requires a metadata object because the queries it contains (like {@link StructuredQuery))
	     * need metadata for accessing databases, tables and metrics.
	     */
	
	
	    _createClass(Question, [{
	        key: "metadata",
	        value: function metadata() {
	            return this._metadata;
	        }
	    }, {
	        key: "card",
	        value: function card() {
	            return this._card;
	        }
	    }, {
	        key: "setCard",
	        value: function setCard(card) {
	            return new Question(this._metadata, card, this._parameterValues);
	        }
	    }, {
	        key: "withoutNameAndId",
	        value: function withoutNameAndId() {
	            return this.setCard((0, _icepick.chain)(this.card()).dissoc("id").dissoc("name").dissoc("description").value());
	        }
	
	        /**
	         * A question contains either a:
	         * - StructuredQuery for queries written in MBQL
	         * - NativeQuery for queries written in data source's native query language
	         *
	         * This is just a wrapper object, the data is stored in `this._card.dataset_query` in a format specific to the query type.
	         */
	
	    }, {
	        key: "query",
	        value: function query() {
	            var datasetQuery = this._card.dataset_query;
	
	            var _arr = [_StructuredQuery2.default, _NativeQuery2.default];
	            for (var _i = 0; _i < _arr.length; _i++) {
	                var QueryClass = _arr[_i];
	                if (QueryClass.isDatasetQueryType(datasetQuery)) {
	                    return new QueryClass(this, datasetQuery);
	                }
	            }
	
	            throw new Error("Unknown query type: " + datasetQuery.type);
	        }
	
	        /**
	         * Returns a new Question object with an updated query.
	         * The query is saved to the `dataset_query` field of the Card object.
	         */
	
	    }, {
	        key: "setQuery",
	        value: function setQuery(newQuery) {
	            if (this._card.dataset_query !== newQuery.datasetQuery()) {
	                return this.setCard((0, _icepick.assoc)(this.card(), "dataset_query", newQuery.datasetQuery()));
	            }
	            return this;
	        }
	    }, {
	        key: "setDatasetQuery",
	        value: function setDatasetQuery(newDatasetQuery) {
	            return this.setCard((0, _icepick.assoc)(this.card(), "dataset_query", newDatasetQuery));
	        }
	
	        /**
	         * Returns a list of atomic queries (NativeQuery or StructuredQuery) contained in this question
	         */
	
	    }, {
	        key: "atomicQueries",
	        value: function atomicQueries() {
	            var query = this.query();
	            if (query instanceof _AtomicQuery2.default) return [query];
	            return [];
	        }
	
	        /**
	         * The visualization type of the question
	         */
	
	    }, {
	        key: "display",
	        value: function display() {
	            return this._card && this._card.display;
	        }
	    }, {
	        key: "setDisplay",
	        value: function setDisplay(display) {
	            return this.setCard((0, _icepick.assoc)(this.card(), "display", display));
	        }
	    }, {
	        key: "isEmpty",
	        value: function isEmpty() {
	            return this.query().isEmpty();
	        }
	        /**
	         * Question is valid (as far as we know) and can be executed
	         */
	
	    }, {
	        key: "canRun",
	        value: function canRun() {
	            return this.query().canRun();
	        }
	    }, {
	        key: "canWrite",
	        value: function canWrite() {
	            return this._card && this._card.can_write;
	        }
	
	        /**
	         * Visualization drill-through and action widget actions
	         *
	         * Although most of these are essentially a way to modify the current query, having them as a part
	         * of Question interface instead of Query interface makes it more convenient to also change the current visualization
	         */
	
	    }, {
	        key: "summarize",
	        value: function summarize(aggregation) {
	            var tableMetadata = this.tableMetadata();
	            return this.setCard((0, _actions.summarize)(this.card(), aggregation, tableMetadata));
	        }
	    }, {
	        key: "breakout",
	        value: function breakout(b) {
	            return this.setCard((0, _actions.breakout)(this.card(), b));
	        }
	    }, {
	        key: "pivot",
	        value: function pivot() {
	            var breakouts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	            var dimensions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	            var tableMetadata = this.tableMetadata();
	            return this.setCard(
	            // $FlowFixMe: tableMetadata could be null
	            (0, _actions.pivot)(this.card(), tableMetadata, breakouts, dimensions));
	        }
	    }, {
	        key: "filter",
	        value: function filter(operator, column, value) {
	            return this.setCard((0, _actions.filter)(this.card(), operator, column, value));
	        }
	    }, {
	        key: "drillUnderlyingRecords",
	        value: function drillUnderlyingRecords(dimensions) {
	            return this.setCard((0, _actions.drillUnderlyingRecords)(this.card(), dimensions));
	        }
	    }, {
	        key: "toUnderlyingRecords",
	        value: function toUnderlyingRecords() {
	            var newCard = (0, _actions.toUnderlyingRecords)(this.card());
	            if (newCard) {
	                return this.setCard(newCard);
	            }
	        }
	    }, {
	        key: "toUnderlyingData",
	        value: function toUnderlyingData() {
	            return this.setDisplay("table");
	        }
	    }, {
	        key: "composeThisQuery",
	        value: function composeThisQuery() {
	            var SAVED_QUESTIONS_FAUX_DATABASE = -1337;
	
	            if (this.id()) {
	                var card = {
	                    display: "table",
	                    dataset_query: {
	                        type: "query",
	                        database: SAVED_QUESTIONS_FAUX_DATABASE,
	                        query: {
	                            source_table: "card__" + this.id()
	                        }
	                    }
	                };
	                return this.setCard(card);
	            }
	        }
	    }, {
	        key: "drillPK",
	        value: function drillPK(field, value) {
	            var query = this.query();
	            if (query instanceof _StructuredQuery2.default) {
	                return query.reset().setTable(field.table).addFilter(["=", ["field-id", field.id], value]).question();
	            }
	        }
	
	        // deprecated
	
	    }, {
	        key: "tableMetadata",
	        value: function tableMetadata() {
	            var query = this.query();
	            if (query instanceof _StructuredQuery2.default) {
	                return query.table();
	            } else {
	                return null;
	            }
	        }
	    }, {
	        key: "mode",
	        value: function mode() {
	            return _Mode2.default.forQuestion(this);
	        }
	
	        /**
	         * A user-defined name for the question
	         */
	
	    }, {
	        key: "displayName",
	        value: function displayName() {
	            return this._card && this._card.name;
	        }
	    }, {
	        key: "setDisplayName",
	        value: function setDisplayName(name) {
	            return this.setCard((0, _icepick.assoc)(this.card(), "name", name));
	        }
	    }, {
	        key: "id",
	        value: function id() {
	            return this._card && this._card.id;
	        }
	    }, {
	        key: "isSaved",
	        value: function isSaved() {
	            return !!this.id();
	        }
	    }, {
	        key: "publicUUID",
	        value: function publicUUID() {
	            return this._card && this._card.public_uuid;
	        }
	    }, {
	        key: "getUrl",
	        value: function getUrl(originalQuestion) {
	            var isDirty = !originalQuestion || this.isDirtyComparedTo(originalQuestion);
	
	            return isDirty ? Urls.question(null, this._serializeForUrl()) : Urls.question(this.id(), "");
	        }
	
	        /**
	         * Runs the query and returns an array containing results for each single query.
	         *
	         * If we have a saved and clean single-query question, we use `CardApi.query` instead of a ad-hoc dataset query.
	         * This way we benefit from caching and query optimizations done by Metabase backend.
	         */
	
	    }, {
	        key: "getResults",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                    cancelDeferred = _ref2.cancelDeferred,
	                    _ref2$isDirty = _ref2.isDirty,
	                    isDirty = _ref2$isDirty === undefined ? false : _ref2$isDirty,
	                    _ref2$ignoreCache = _ref2.ignoreCache,
	                    ignoreCache = _ref2$ignoreCache === undefined ? false : _ref2$ignoreCache;
	
	                var canUseCardApiEndpoint, parameters, queryParams, getDatasetQueryResult, datasetQueries;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                // TODO Atte Keinänen 7/5/17: Should we clean this query with Query.cleanQuery(query) before executing it?
	
	                                canUseCardApiEndpoint = !isDirty && this.isSaved();
	                                parameters = this.parametersList()
	                                // include only parameters that have a value applied
	                                .filter(function (param) {
	                                    return _underscore2.default.has(param, "value");
	                                })
	                                // only the superset of parameters object that API expects
	                                .map(function (param) {
	                                    return _underscore2.default.pick(param, "type", "target", "value");
	                                });
	
	                                if (!canUseCardApiEndpoint) {
	                                    _context.next = 10;
	                                    break;
	                                }
	
	                                queryParams = {
	                                    cardId: this.id(),
	                                    ignore_cache: ignoreCache,
	                                    parameters: parameters
	                                };
	                                _context.next = 6;
	                                return _services.CardApi.query(queryParams, {
	                                    cancelled: cancelDeferred.promise
	                                });
	
	                            case 6:
	                                _context.t0 = _context.sent;
	                                return _context.abrupt("return", [_context.t0]);
	
	                            case 10:
	                                getDatasetQueryResult = function getDatasetQueryResult(datasetQuery) {
	                                    var datasetQueryWithParameters = _extends({}, datasetQuery, {
	                                        parameters: parameters
	                                    });
	
	                                    return _services.MetabaseApi.dataset(datasetQueryWithParameters, cancelDeferred ? { cancelled: cancelDeferred.promise } : {});
	                                };
	
	                                datasetQueries = this.atomicQueries().map(function (query) {
	                                    return query.datasetQuery();
	                                });
	                                return _context.abrupt("return", Promise.all(datasetQueries.map(getDatasetQueryResult)));
	
	                            case 13:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getResults() {
	                return _ref.apply(this, arguments);
	            }
	
	            return getResults;
	        }()
	
	        // TODO: Fix incorrect Flow signature
	
	    }, {
	        key: "parameters",
	        value: function parameters() {
	            return (0, _Card.getParametersWithExtras)(this.card(), this._parameterValues);
	        }
	    }, {
	        key: "parametersList",
	        value: function parametersList() {
	            // $FlowFixMe
	            return Object.values(this.parameters());
	        }
	
	        // predicate function that dermines if the question is "dirty" compared to the given question
	
	    }, {
	        key: "isDirtyComparedTo",
	        value: function isDirtyComparedTo(originalQuestion) {
	            // TODO Atte Keinänen 6/8/17: Reconsider these rules because they don't completely match
	            // the current implementation which uses original_card_id for indicating that question has a lineage
	
	            // The rules:
	            //   - if it's new, then it's dirty when
	            //       1) there is a database/table chosen or
	            //       2) when there is any content on the native query
	            //   - if it's saved, then it's dirty when
	            //       1) the current card doesn't match the last saved version
	
	            if (!this._card) {
	                return false;
	            } else if (!this._card.id) {
	                if (this._card.dataset_query.query && this._card.dataset_query.query.source_table) {
	                    return true;
	                } else if (this._card.dataset_query.type === "native" && !_underscore2.default.isEmpty(this._card.dataset_query.native.query)) {
	                    return true;
	                } else {
	                    return false;
	                }
	            } else {
	                var origCardSerialized = originalQuestion._serializeForUrl({
	                    includeOriginalCardId: false
	                });
	                var currentCardSerialized = this._serializeForUrl({
	                    includeOriginalCardId: false
	                });
	                return currentCardSerialized !== origCardSerialized;
	            }
	        }
	
	        // Internal methods
	
	    }, {
	        key: "_serializeForUrl",
	        value: function _serializeForUrl() {
	            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                _ref3$includeOriginal = _ref3.includeOriginalCardId,
	                includeOriginalCardId = _ref3$includeOriginal === undefined ? true : _ref3$includeOriginal;
	
	            // TODO Atte Keinänen 5/31/17: Remove code mutation and unnecessary copying
	            var dataset_query = _utils3.default.copy(this._card.dataset_query);
	            if (dataset_query.query) {
	                dataset_query.query = _query2.default.cleanQuery(dataset_query.query);
	            }
	
	            var cardCopy = _extends({
	                name: this._card.name,
	                description: this._card.description,
	                dataset_query: dataset_query,
	                display: this._card.display,
	                parameters: this._card.parameters,
	                visualization_settings: this._card.visualization_settings
	            }, includeOriginalCardId ? { original_card_id: this._card.original_card_id } : {});
	
	            return Card_DEPRECATED.utf8_to_b64url(JSON.stringify(cardCopy));
	        }
	    }], [{
	        key: "create",
	        value: function create(_ref4) {
	            var databaseId = _ref4.databaseId,
	                tableId = _ref4.tableId,
	                metadata = _ref4.metadata,
	                parameterValues = _ref4.parameterValues,
	                cardProps = _objectWithoutProperties(_ref4, ["databaseId", "tableId", "metadata", "parameterValues"]);
	
	            // $FlowFixMe
	            var card = {
	                name: cardProps.name || null,
	                display: cardProps.display || "table",
	                visualization_settings: cardProps.visualization_settings || {},
	                dataset_query: _StructuredQuery.STRUCTURED_QUERY_TEMPLATE // temporary placeholder
	            };
	
	            var initialQuestion = new Question(metadata, card, parameterValues);
	            var query = _StructuredQuery2.default.newStucturedQuery({
	                question: initialQuestion,
	                databaseId: databaseId,
	                tableId: tableId
	            });
	
	            return initialQuestion.setQuery(query);
	        }
	    }]);
	
	    return Question;
	}(), (_applyDecoratedDescriptor(_class.prototype, "query", [_utils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, "query"), _class.prototype)), _class);
	exports.default = Question;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class; /*  weak */
	
	var _Database = __webpack_require__(897);
	
	var _Database2 = _interopRequireDefault(_Database);
	
	var _utils = __webpack_require__(946);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	    var desc = {};
	    Object['ke' + 'ys'](descriptor).forEach(function (key) {
	        desc[key] = descriptor[key];
	    });
	    desc.enumerable = !!desc.enumerable;
	    desc.configurable = !!desc.configurable;
	
	    if ('value' in desc || desc.initializer) {
	        desc.writable = true;
	    }
	
	    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	        return decorator(target, property, desc) || desc;
	    }, desc);
	
	    if (context && desc.initializer !== void 0) {
	        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	        desc.initializer = undefined;
	    }
	
	    if (desc.initializer === void 0) {
	        Object['define' + 'Property'](target, property, desc);
	        desc = null;
	    }
	
	    return desc;
	}
	
	/**
	 * An abstract class for all query types (StructuredQuery & NativeQuery)
	 */
	var Query = (_class = function () {
	
	    /**
	     * Note that Question is not always in sync with _datasetQuery,
	     * calling question() will always merge the latest _datasetQuery to the question object
	     */
	    function Query(question, datasetQuery) {
	        _classCallCheck(this, Query);
	
	        this._metadata = question._metadata;
	        this._datasetQuery = datasetQuery;
	        this._originalQuestion = question;
	    }
	
	    /**
	     * Returns a question updated with the current dataset query.
	     * Can only be applied to query that is a direct child of the question.
	     */
	
	
	    _createClass(Query, [{
	        key: "question",
	        value: function question() {
	            var isDirectChildOfQuestion = _typeof(this._originalQuestion.query()) === _typeof(this);
	
	            if (isDirectChildOfQuestion) {
	                return this._originalQuestion.setQuery(this);
	            } else {
	                throw new Error("Can't derive a question from a query that is a child of other query");
	            }
	        }
	
	        /**
	         * Convenience method for accessing the global metadata
	         */
	
	    }, {
	        key: "metadata",
	        value: function metadata() {
	            return this._metadata;
	        }
	
	        /**
	         * Does this query have the sufficient metadata for editing it?
	         */
	
	    }, {
	        key: "isEditable",
	        value: function isEditable() {
	            return true;
	        }
	
	        /**
	         * Returns the dataset_query object underlying this Query
	         */
	
	    }, {
	        key: "datasetQuery",
	        value: function datasetQuery() {
	            return this._datasetQuery;
	        }
	
	        /**
	         * Query is considered empty, i.e. it is in a plain state with no properties / query clauses set
	         */
	
	    }, {
	        key: "isEmpty",
	        value: function isEmpty() {
	            return false;
	        }
	
	        /**
	         * Query is valid (as far as we know) and can be executed
	         */
	
	    }, {
	        key: "canRun",
	        value: function canRun() {
	            return false;
	        }
	
	        /**
	         * Databases this query could use
	         */
	
	    }, {
	        key: "databases",
	        value: function databases() {
	            return this._metadata.databasesList();
	        }
	
	        /**
	         * Helper for updating with functions that expect a DatasetQuery object
	         */
	
	    }, {
	        key: "update",
	        value: function update(fn) {
	            return fn(this.datasetQuery());
	        }
	    }]);
	
	    return Query;
	}(), (_applyDecoratedDescriptor(_class.prototype, "question", [_utils.memoize], Object.getOwnPropertyDescriptor(_class.prototype, "question"), _class.prototype)), _class);
	exports.default = Query;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _Base2 = __webpack_require__(898);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Schema = __webpack_require__(945);
	
	var _Schema2 = _interopRequireDefault(_Schema);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	/**
	 * Wrapper class for database metadata objects. Contains {@link Schema}s, {@link Table}s, {@link Metric}s, {@link Segment}s.
	 *
	 * Backed by types/Database data structure which matches the backend API contract
	 */
	var Database = function (_Base) {
	    _inherits(Database, _Base);
	
	    function Database() {
	        _classCallCheck(this, Database);
	
	        return _possibleConstructorReturn(this, (Database.__proto__ || Object.getPrototypeOf(Database)).apply(this, arguments));
	    }
	
	    _createClass(Database, [{
	        key: "tablesInSchema",
	
	        // TODO Atte Keinänen 6/11/17: List all fields here (currently only in types/Database)
	
	        value: function tablesInSchema(schemaName) {
	            return this.tables.filter(function (table) {
	                return table.schema === schemaName;
	            });
	        }
	    }, {
	        key: "schemaNames",
	        value: function schemaNames() {
	            return _underscore2.default.uniq(this.tables.map(function (table) {
	                return table.schema;
	            }).filter(function (schemaName) {
	                return schemaName != null;
	            }));
	        }
	    }, {
	        key: "newQuestion",
	        value: function newQuestion() {
	            // $FlowFixMe
	            return new _Question2.default();
	        }
	    }]);
	
	    return Database;
	}(_Base3.default);
	
	exports.default = Database;

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Base = function () {
	    function Base() {
	        var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        _classCallCheck(this, Base);
	
	        this._plainObject = null;
	
	        this._plainObject = object;
	        for (var property in object) {
	            this[property] = object[property];
	        }
	    }
	
	    /**
	     * Get the plain metadata object without hydrated fields.
	     * Useful for situations where you want serialize the metadata object.
	     */
	
	
	    _createClass(Base, [{
	        key: "getPlainObject",
	        value: function getPlainObject() {
	            return this._plainObject;
	        }
	    }]);
	
	    return Base;
	}();
	
	exports.default = Base;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _Base2 = __webpack_require__(898);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _Database = __webpack_require__(897);
	
	var _Database2 = _interopRequireDefault(_Database);
	
	var _Field = __webpack_require__(900);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Dimension = __webpack_require__(901);
	
	var _Dimension2 = _interopRequireDefault(_Dimension);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	/** This is the primary way people interact with tables */
	var Table = function (_Base) {
	    _inherits(Table, _Base);
	
	    function Table() {
	        _classCallCheck(this, Table);
	
	        return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
	    }
	
	    _createClass(Table, [{
	        key: "newQuestion",
	        value: function newQuestion() {
	            // $FlowFixMe
	            return new _Question2.default();
	        }
	    }, {
	        key: "dimensions",
	        value: function dimensions() {
	            return this.fields.map(function (field) {
	                return field.dimension();
	            });
	        }
	    }, {
	        key: "dateFields",
	        value: function dateFields() {
	            return this.fields.filter(function (field) {
	                return field.isDate();
	            });
	        }
	    }, {
	        key: "aggregations",
	        value: function aggregations() {
	            return this.aggregation_options || [];
	        }
	    }, {
	        key: "aggregation",
	        value: function aggregation(agg) {
	            return _underscore2.default.findWhere(this.aggregations(), { short: agg });
	        }
	    }, {
	        key: "database",
	
	
	        // $FlowFixMe Could be replaced with hydrated database property in selectors/metadata.js (instead / in addition to `table.db`)
	        get: function get() {
	            return this.db;
	        }
	    }]);
	
	    return Table;
	}(_Base3.default);
	
	exports.default = Table;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Base2 = __webpack_require__(898);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Dimension = __webpack_require__(901);
	
	var _field = __webpack_require__(869);
	
	var _schema_metadata = __webpack_require__(867);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	/**
	 * Wrapper class for field metadata objects. Belongs to a Table.
	 */
	var Field = function (_Base) {
	    _inherits(Field, _Base);
	
	    function Field() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Field);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Field.__proto__ || Object.getPrototypeOf(Field)).call.apply(_ref, [this].concat(args))), _this), _this.getDefaultBreakout = function () {
	            var fieldIdDimension = _this.dimension();
	            var defaultSubDimension = fieldIdDimension.defaultDimension();
	            if (defaultSubDimension) {
	                return defaultSubDimension.mbql();
	            } else {
	                return fieldIdDimension.mbql();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Field, [{
	        key: "fieldType",
	        value: function fieldType() {
	            return (0, _schema_metadata.getFieldType)(this);
	        }
	    }, {
	        key: "isDate",
	        value: function isDate() {
	            return (0, _schema_metadata.isDate)(this);
	        }
	    }, {
	        key: "isNumber",
	        value: function isNumber() {
	            return (0, _schema_metadata.isNumber)(this);
	        }
	    }, {
	        key: "isNumeric",
	        value: function isNumeric() {
	            return (0, _schema_metadata.isNumeric)(this);
	        }
	    }, {
	        key: "isBoolean",
	        value: function isBoolean() {
	            return (0, _schema_metadata.isBoolean)(this);
	        }
	    }, {
	        key: "isString",
	        value: function isString() {
	            return (0, _schema_metadata.isString)(this);
	        }
	    }, {
	        key: "isSummable",
	        value: function isSummable() {
	            return (0, _schema_metadata.isSummable)(this);
	        }
	    }, {
	        key: "isCategory",
	        value: function isCategory() {
	            return (0, _schema_metadata.isCategory)(this);
	        }
	    }, {
	        key: "isMetric",
	        value: function isMetric() {
	            return (0, _schema_metadata.isMetric)(this);
	        }
	    }, {
	        key: "isCompatibleWith",
	        value: function isCompatibleWith(field) {
	            return this.isDate() === field.isDate() || this.isNumeric() === field.isNumeric() || this.id === field.id;
	        }
	
	        /**
	         * Tells if this column can be used in a breakout
	         * Currently returns `true` for everything expect for aggregation columns
	         */
	
	    }, {
	        key: "isDimension",
	        value: function isDimension() {
	            return (0, _schema_metadata.isDimension)(this);
	        }
	    }, {
	        key: "isID",
	        value: function isID() {
	            return (0, _schema_metadata.isPK)(this) || (0, _schema_metadata.isFK)(this);
	        }
	    }, {
	        key: "isPK",
	        value: function isPK() {
	            return (0, _schema_metadata.isPK)(this);
	        }
	    }, {
	        key: "isFK",
	        value: function isFK() {
	            return (0, _schema_metadata.isFK)(this);
	        }
	    }, {
	        key: "isCoordinate",
	        value: function isCoordinate() {
	            return (0, _schema_metadata.isCoordinate)(this);
	        }
	    }, {
	        key: "fieldValues",
	        value: function fieldValues() {
	            return (0, _field.getFieldValues)(this._object);
	        }
	    }, {
	        key: "icon",
	        value: function icon() {
	            return (0, _schema_metadata.getIconForField)(this);
	        }
	    }, {
	        key: "dimension",
	        value: function dimension() {
	            return new _Dimension.FieldIDDimension(null, [this.id], this.metadata);
	        }
	    }, {
	        key: "operator",
	        value: function operator(op) {
	            if (this.operators_lookup) {
	                return this.operators_lookup[op];
	            }
	        }
	
	        /**
	         * Returns a default breakout MBQL clause for this field
	         *
	         * Tries to look up a default subdimension (like "Created At: Day" for "Created At" field)
	         * and if it isn't found, uses the plain field id dimension (like "Product ID") as a fallback.
	         */
	
	    }]);
	
	    return Field;
	}(_Base3.default);
	
	exports.default = Field;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AggregationDimension = exports.ExpressionDimension = exports.BinnedDimension = exports.DatetimeFieldDimension = exports.FKDimension = exports.FieldIDDimension = exports.FieldDimension = exports.default = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _formatting = __webpack_require__(872);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _util = __webpack_require__(870);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Field = __webpack_require__(900);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _query_time = __webpack_require__(944);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Dimension base class, represents an MBQL field reference.
	 *
	 * Used for displaying fields (like Created At) and their "sub-dimensions" (like Created At by Day)
	 * in field lists and active value widgets for filters, aggregations and breakouts.
	 *
	 * @abstract
	 */
	
	
	/**
	 * A dimension option returned by the query_metadata API
	 */
	var Dimension = function () {
	
	    /**
	     * Dimension constructor
	     */
	
	
	    // Display names provided by the backend
	    function Dimension(parent, args, metadata) {
	        _classCallCheck(this, Dimension);
	
	        this._parent = parent;
	        this._args = args;
	        this._metadata = metadata || parent && parent._metadata;
	    }
	
	    /**
	     * Parses an MBQL expression into an appropriate Dimension subclass, if possible.
	     * Metadata should be provided if you intend to use the display name or render methods.
	     */
	
	
	    _createClass(Dimension, [{
	        key: "dimensions",
	
	
	        /**
	         * Returns "sub-dimensions" of this dimension.
	         * @abstract
	         */
	        // TODO Atte Keinänen 5/21/17: Rename either this or the static method with the same name
	        // Also making it clear in the method name that we're working with sub-dimensions would be good
	        value: function dimensions(DimensionTypes) {
	            var _this = this;
	
	            var dimensionOptions = this.field().dimension_options;
	            if (!DimensionTypes && dimensionOptions) {
	                return dimensionOptions.map(function (option) {
	                    return _this._dimensionForOption(option);
	                });
	            } else {
	                var _ref;
	
	                return (_ref = []).concat.apply(_ref, _toConsumableArray((DimensionTypes || []).map(function (DimensionType) {
	                    return DimensionType.dimensions(_this);
	                })));
	            }
	        }
	
	        /**
	         * Returns the default sub-dimension of this dimension, if any.
	         * @abstract
	         */
	
	    }, {
	        key: "defaultDimension",
	        value: function defaultDimension() {
	            var DimensionTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DIMENSION_TYPES;
	
	            var defaultDimensionOption = this.field().default_dimension_option;
	            if (defaultDimensionOption) {
	                return this._dimensionForOption(defaultDimensionOption);
	            } else {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = DimensionTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var DimensionType = _step.value;
	
	                        var defaultDimension = DimensionType.defaultDimension(this);
	                        if (defaultDimension) {
	                            return defaultDimension;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	
	            return null;
	        }
	
	        // Internal method gets a Dimension from a DimensionOption
	
	    }, {
	        key: "_dimensionForOption",
	        value: function _dimensionForOption(option) {
	            // fill in the parent field ref
	            var fieldRef = this.baseDimension().mbql();
	            var mbql = option.mbql;
	            if (mbql) {
	                mbql = [mbql[0], fieldRef].concat(_toConsumableArray(mbql.slice(2)));
	            } else {
	                mbql = fieldRef;
	            }
	            var dimension = Dimension.parseMBQL(mbql, this._metadata);
	            if (option.name) {
	                dimension._subDisplayName = option.name;
	                dimension._subTriggerDisplayName = option.name;
	            }
	            return dimension;
	        }
	
	        /**
	         * Is this dimension idential to another dimension or MBQL clause
	         */
	
	    }, {
	        key: "isEqual",
	        value: function isEqual(other) {
	            if (other == null) {
	                return false;
	            }
	
	            var otherDimension = other instanceof Dimension ? other : Dimension.parseMBQL(other, this._metadata);
	            if (!otherDimension) {
	                return false;
	            }
	            // must be instace of the same class
	            if (this.constructor !== otherDimension.constructor) {
	                return false;
	            }
	            // must both or neither have a parent
	            if (!this._parent !== !otherDimension._parent) {
	                return false;
	            }
	            // parents must be equal
	            if (this._parent && !this._parent.isEqual(otherDimension._parent)) {
	                return false;
	            }
	            // args must be equal
	            if (!_underscore2.default.isEqual(this._args, otherDimension._args)) {
	                return false;
	            }
	            return true;
	        }
	
	        /**
	         * Does this dimension have the same underlying base dimension, typically a field
	         */
	
	    }, {
	        key: "isSameBaseDimension",
	        value: function isSameBaseDimension(other) {
	            if (other == null) {
	                return false;
	            }
	
	            var otherDimension = other instanceof Dimension ? other : Dimension.parseMBQL(other, this._metadata);
	
	            var baseDimensionA = this.baseDimension();
	            var baseDimensionB = otherDimension && otherDimension.baseDimension();
	
	            return !!baseDimensionA && !!baseDimensionB && baseDimensionA.isEqual(baseDimensionB);
	        }
	
	        /**
	         * The base dimension of this dimension, typically a field. May return itself.
	         */
	
	    }, {
	        key: "baseDimension",
	        value: function baseDimension() {
	            return this;
	        }
	
	        /**
	         * The underlying field for this dimension
	         */
	
	    }, {
	        key: "field",
	        value: function field() {
	            return new _Field2.default();
	        }
	
	        /**
	         * Valid operators on this dimension
	         */
	
	    }, {
	        key: "operators",
	        value: function operators() {
	            return this.field().operators || [];
	        }
	
	        /**
	         * The operator with the provided operator name (e.x. `=`, `<`, etc)
	         */
	
	    }, {
	        key: "operator",
	        value: function operator(op) {
	            return this.field().operator(op);
	        }
	
	        /**
	         * The display name of this dimension, e.x. the field's display_name
	         * @abstract
	         */
	
	    }, {
	        key: "displayName",
	        value: function displayName() {
	            return "";
	        }
	
	        /**
	         * The name to be shown when this dimension is being displayed as a sub-dimension of another
	         * @abstract
	         */
	
	    }, {
	        key: "subDisplayName",
	        value: function subDisplayName() {
	            return this._subDisplayName || "";
	        }
	
	        /**
	         * A shorter version of subDisplayName, e.x. to be shown in the dimension picker trigger
	         * @abstract
	         */
	
	    }, {
	        key: "subTriggerDisplayName",
	        value: function subTriggerDisplayName() {
	            return this._subTriggerDisplayName || "";
	        }
	
	        /**
	         * An icon name representing this dimension's type, to be used in the <Icon> component.
	         * @abstract
	         */
	
	    }, {
	        key: "icon",
	        value: function icon() {
	            return null;
	        }
	
	        /**
	         * Renders a dimension to React
	         */
	
	    }, {
	        key: "render",
	        value: function render() {
	            return [this.displayName()];
	        }
	    }], [{
	        key: "parseMBQL",
	        value: function parseMBQL(mbql, metadata) {
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = DIMENSION_TYPES[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var D = _step2.value;
	
	                    var dimension = D.parseMBQL(mbql, metadata);
	                    if (dimension != null) {
	                        return dimension;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            return null;
	        }
	
	        /**
	         * Returns true if these two dimensions are identical to one another.
	         */
	
	    }, {
	        key: "isEqual",
	        value: function isEqual(a, b) {
	            var dimensionA = a instanceof Dimension ? a : // $FlowFixMe
	            Dimension.parseMBQL(a, this._metadata);
	            var dimensionB = b instanceof Dimension ? b : // $FlowFixMe
	            Dimension.parseMBQL(b, this._metadata);
	            return !!dimensionA && !!dimensionB && dimensionA.isEqual(dimensionB);
	        }
	
	        /**
	         * Sub-dimensions for the provided dimension of this type.
	         * @abstract
	         */
	        // TODO Atte Keinänen 5/21/17: Rename either this or the instance method with the same name
	        // Also making it clear in the method name that we're working with sub-dimensions would be good
	
	    }, {
	        key: "dimensions",
	        value: function dimensions(parent) {
	            return [];
	        }
	
	        /**
	         * The default sub-dimension for the provided dimension of this type, if any.
	         * @abstract
	         */
	
	    }, {
	        key: "defaultDimension",
	        value: function defaultDimension(parent) {
	            return null;
	        }
	    }]);
	
	    return Dimension;
	}();
	
	Dimension.displayName = "Dimension";
	exports.default = Dimension;
	
	/**
	 * Field based dimension, abstract class for `field-id`, `fk->`, `datetime-field`, etc
	 * @abstract
	 */
	var FieldDimension = exports.FieldDimension = function (_Dimension) {
	    _inherits(FieldDimension, _Dimension);
	
	    function FieldDimension() {
	        _classCallCheck(this, FieldDimension);
	
	        return _possibleConstructorReturn(this, (FieldDimension.__proto__ || Object.getPrototypeOf(FieldDimension)).apply(this, arguments));
	    }
	
	    _createClass(FieldDimension, [{
	        key: "field",
	        value: function field() {
	            if (this._parent instanceof FieldDimension) {
	                return this._parent.field();
	            }
	            return new _Field2.default();
	        }
	    }, {
	        key: "displayName",
	        value: function displayName() {
	            return (0, _formatting.stripId)(_query2.default.getFieldPathName(this.field().id, this.field().table));
	        }
	    }, {
	        key: "subDisplayName",
	        value: function subDisplayName() {
	            if (this._subDisplayName) {
	                return this._subTriggerDisplayName;
	            } else if (this._parent) {
	                // TODO Atte Keinänen 8/1/17: Is this used at all?
	                // foreign key, show the field name
	                return this.field().display_name;
	            } else {
	                // TODO Atte Keinänen 8/1/17: Is this used at all?
	                return "Default";
	            }
	        }
	    }, {
	        key: "subTriggerDisplayName",
	        value: function subTriggerDisplayName() {
	            if (this.defaultDimension() instanceof BinnedDimension) {
	                return "Unbinned";
	            } else {
	                return "";
	            }
	        }
	    }, {
	        key: "icon",
	        value: function icon() {
	            return this.field().icon();
	        }
	    }]);
	
	    return FieldDimension;
	}(Dimension);
	
	/**
	 * Field ID-based dimension, `["field-id", field-id]`
	 */
	
	
	var FieldIDDimension = exports.FieldIDDimension = function (_FieldDimension) {
	    _inherits(FieldIDDimension, _FieldDimension);
	
	    function FieldIDDimension() {
	        _classCallCheck(this, FieldIDDimension);
	
	        return _possibleConstructorReturn(this, (FieldIDDimension.__proto__ || Object.getPrototypeOf(FieldIDDimension)).apply(this, arguments));
	    }
	
	    _createClass(FieldIDDimension, [{
	        key: "mbql",
	        value: function mbql() {
	            return ["field-id", this._args[0]];
	        }
	    }, {
	        key: "field",
	        value: function field() {
	            return this._metadata && this._metadata.fields[this._args[0]] || new _Field2.default();
	        }
	    }], [{
	        key: "parseMBQL",
	        value: function parseMBQL(mbql, metadata) {
	            if (typeof mbql === "number") {
	                // DEPRECATED: bare field id
	                return new FieldIDDimension(null, [mbql], metadata);
	            } else if (Array.isArray(mbql) && (0, _util.mbqlEq)(mbql[0], "field-id")) {
	                return new FieldIDDimension(null, mbql.slice(1), metadata);
	            }
	            return null;
	        }
	    }]);
	
	    return FieldIDDimension;
	}(FieldDimension);
	
	/**
	 * Foreign key-based dimension, `["fk->", fk-field-id, dest-field-id]`
	 */
	
	
	var FKDimension = exports.FKDimension = function (_FieldDimension2) {
	    _inherits(FKDimension, _FieldDimension2);
	
	    function FKDimension() {
	        _classCallCheck(this, FKDimension);
	
	        return _possibleConstructorReturn(this, (FKDimension.__proto__ || Object.getPrototypeOf(FKDimension)).apply(this, arguments));
	    }
	
	    _createClass(FKDimension, [{
	        key: "mbql",
	        value: function mbql() {
	            // TODO: not sure `this._parent._args[0]` is the best way to handle this?
	            // we don't want the `["field-id", ...]` wrapper from the `this._parent.mbql()`
	            return ["fk->", this._parent._args[0], this._args[0]];
	        }
	    }, {
	        key: "field",
	        value: function field() {
	            return this._metadata && this._metadata.fields[this._args[0]] || new _Field2.default();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return [(0, _formatting.stripId)(this._parent.field().display_name), _react2.default.createElement(_Icon2.default, { name: "connections", className: "px1", size: 10 }), this.field().display_name];
	        }
	    }], [{
	        key: "parseMBQL",
	        value: function parseMBQL(mbql, metadata) {
	            if (Array.isArray(mbql) && (0, _util.mbqlEq)(mbql[0], "fk->")) {
	                // $FlowFixMe
	                var fkRef = mbql;
	                var parent = Dimension.parseMBQL(fkRef[1], metadata);
	                return new FKDimension(parent, fkRef.slice(2));
	            }
	            return null;
	        }
	    }, {
	        key: "dimensions",
	        value: function dimensions(parent) {
	            if (parent instanceof FieldDimension) {
	                var field = parent.field();
	                if (field.target && field.target.table) {
	                    return field.target.table.fields.map(function (field) {
	                        return new FKDimension(parent, [field.id]);
	                    });
	                }
	            }
	            return [];
	        }
	    }]);
	
	    return FKDimension;
	}(FieldDimension);
	
	FKDimension.displayName = "FKDimension";
	
	
	var isFieldDimension = function isFieldDimension(dimension) {
	    return dimension instanceof FieldIDDimension || dimension instanceof FKDimension;
	};
	
	/**
	 * DatetimeField dimension, `["datetime-field", field-reference, datetime-unit]`
	 */
	
	var DatetimeFieldDimension = exports.DatetimeFieldDimension = function (_FieldDimension3) {
	    _inherits(DatetimeFieldDimension, _FieldDimension3);
	
	    function DatetimeFieldDimension() {
	        _classCallCheck(this, DatetimeFieldDimension);
	
	        return _possibleConstructorReturn(this, (DatetimeFieldDimension.__proto__ || Object.getPrototypeOf(DatetimeFieldDimension)).apply(this, arguments));
	    }
	
	    _createClass(DatetimeFieldDimension, [{
	        key: "mbql",
	        value: function mbql() {
	            return ["datetime-field", this._parent.mbql(), this._args[0]];
	        }
	    }, {
	        key: "baseDimension",
	        value: function baseDimension() {
	            return this._parent.baseDimension();
	        }
	    }, {
	        key: "bucketing",
	        value: function bucketing() {
	            return this._args[0];
	        }
	    }, {
	        key: "subDisplayName",
	        value: function subDisplayName() {
	            return (0, _query_time.formatBucketing)(this._args[0]);
	        }
	    }, {
	        key: "subTriggerDisplayName",
	        value: function subTriggerDisplayName() {
	            return "by " + (0, _query_time.formatBucketing)(this._args[0]).toLowerCase();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return [].concat(_toConsumableArray(_get(DatetimeFieldDimension.prototype.__proto__ || Object.getPrototypeOf(DatetimeFieldDimension.prototype), "render", this).call(this)), [": ", this.subDisplayName()]);
	        }
	    }], [{
	        key: "parseMBQL",
	        value: function parseMBQL(mbql, metadata) {
	            if (Array.isArray(mbql) && (0, _util.mbqlEq)(mbql[0], "datetime-field")) {
	                var parent = Dimension.parseMBQL(mbql[1], metadata);
	                // DEPRECATED: ["datetime-field", id, "of", unit]
	                if (mbql.length === 4) {
	                    return new DatetimeFieldDimension(parent, mbql.slice(3));
	                } else {
	                    return new DatetimeFieldDimension(parent, mbql.slice(2));
	                }
	            }
	            return null;
	        }
	    }, {
	        key: "dimensions",
	        value: function dimensions(parent) {
	            if (isFieldDimension(parent) && parent.field().isDate()) {
	                return _query_time.DATETIME_UNITS.map(function (unit) {
	                    return new DatetimeFieldDimension(parent, [unit]);
	                });
	            }
	            return [];
	        }
	    }, {
	        key: "defaultDimension",
	        value: function defaultDimension(parent) {
	            if (isFieldDimension(parent) && parent.field().isDate()) {
	                return new DatetimeFieldDimension(parent, ["day"]);
	            }
	            return null;
	        }
	    }]);
	
	    return DatetimeFieldDimension;
	}(FieldDimension);
	
	DatetimeFieldDimension.displayName = "DatetimeFieldDimension";
	
	/**
	 * Binned dimension, `["binning-strategy", field-reference, strategy, ...args]`
	 */
	var BinnedDimension = exports.BinnedDimension = function (_FieldDimension4) {
	    _inherits(BinnedDimension, _FieldDimension4);
	
	    function BinnedDimension() {
	        _classCallCheck(this, BinnedDimension);
	
	        return _possibleConstructorReturn(this, (BinnedDimension.__proto__ || Object.getPrototypeOf(BinnedDimension)).apply(this, arguments));
	    }
	
	    _createClass(BinnedDimension, [{
	        key: "mbql",
	        value: function mbql() {
	            return ["binning-strategy", this._parent.mbql()].concat(_toConsumableArray(this._args));
	        }
	    }, {
	        key: "baseDimension",
	        value: function baseDimension() {
	            return this._parent.baseDimension();
	        }
	    }, {
	        key: "subTriggerDisplayName",
	        value: function subTriggerDisplayName() {
	            if (this._args[0] === "num-bins") {
	                return this._args[1] + " " + (0, _formatting.inflect)("bins", this._args[1]);
	            } else if (this._args[0] === "bin-width") {
	                var binWidth = this._args[1];
	                var units = this.field().isCoordinate() ? "°" : "";
	                return "" + binWidth + units;
	            } else {
	                return "Auto binned";
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return [].concat(_toConsumableArray(_get(BinnedDimension.prototype.__proto__ || Object.getPrototypeOf(BinnedDimension.prototype), "render", this).call(this)), [": ", this.subTriggerDisplayName()]);
	        }
	    }], [{
	        key: "parseMBQL",
	        value: function parseMBQL(mbql, metadata) {
	            if (Array.isArray(mbql) && (0, _util.mbqlEq)(mbql[0], "binning-strategy")) {
	                var parent = Dimension.parseMBQL(mbql[1], metadata);
	                return new BinnedDimension(parent, mbql.slice(2));
	            }
	            return null;
	        }
	    }, {
	        key: "dimensions",
	        value: function dimensions(parent) {
	            // Subdimensions are are provided by the backend through the dimension_options field property
	            return [];
	        }
	    }]);
	
	    return BinnedDimension;
	}(FieldDimension);
	
	BinnedDimension.displayName = "BinnedDimension";
	
	/**
	 * Expression reference, `["expression", expression-name]`
	 */
	var ExpressionDimension = exports.ExpressionDimension = function (_Dimension2) {
	    _inherits(ExpressionDimension, _Dimension2);
	
	    function ExpressionDimension() {
	        var _ref2;
	
	        var _temp, _this7, _ret;
	
	        _classCallCheck(this, ExpressionDimension);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this7 = _possibleConstructorReturn(this, (_ref2 = ExpressionDimension.__proto__ || Object.getPrototypeOf(ExpressionDimension)).call.apply(_ref2, [this].concat(args))), _this7), _this7.tag = "Custom", _temp), _possibleConstructorReturn(_this7, _ret);
	    }
	
	    _createClass(ExpressionDimension, [{
	        key: "mbql",
	        value: function mbql() {
	            return ["expression", this._args[0]];
	        }
	    }, {
	        key: "displayName",
	        value: function displayName() {
	            return this._args[0];
	        }
	    }, {
	        key: "icon",
	        value: function icon() {
	            // TODO: eventually will need to get the type from the return type of the expression
	            return "int";
	        }
	    }], [{
	        key: "parseMBQL",
	        value: function parseMBQL(mbql, metadata) {
	            if (Array.isArray(mbql) && (0, _util.mbqlEq)(mbql[0], "expression")) {
	                return new ExpressionDimension(null, mbql.slice(1));
	            }
	        }
	    }]);
	
	    return ExpressionDimension;
	}(Dimension);
	
	/**
	 * Aggregation reference, `["aggregation", aggregation-index]`
	 */
	
	
	var AggregationDimension = exports.AggregationDimension = function (_Dimension3) {
	    _inherits(AggregationDimension, _Dimension3);
	
	    _createClass(AggregationDimension, null, [{
	        key: "parseMBQL",
	        value: function parseMBQL(mbql, metadata) {
	            if (Array.isArray(mbql) && (0, _util.mbqlEq)(mbql[0], "aggregation")) {
	                return new AggregationDimension(null, mbql.slice(1));
	            }
	        }
	    }]);
	
	    function AggregationDimension(parent, args, metadata, displayName) {
	        _classCallCheck(this, AggregationDimension);
	
	        var _this8 = _possibleConstructorReturn(this, (AggregationDimension.__proto__ || Object.getPrototypeOf(AggregationDimension)).call(this, parent, args, metadata));
	
	        _this8._displayName = displayName;
	        return _this8;
	    }
	
	    _createClass(AggregationDimension, [{
	        key: "displayName",
	        value: function displayName() {
	            return this._displayName;
	        }
	    }, {
	        key: "aggregationIndex",
	        value: function aggregationIndex() {
	            return this._args[0];
	        }
	    }, {
	        key: "mbql",
	        value: function mbql() {
	            return ["aggregation", this._args[0]];
	        }
	    }, {
	        key: "icon",
	        value: function icon() {
	            return "int";
	        }
	    }]);
	
	    return AggregationDimension;
	}(Dimension);
	
	var DIMENSION_TYPES = [FieldIDDimension, FKDimension, DatetimeFieldDimension, ExpressionDimension, BinnedDimension, AggregationDimension];

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class; /*eslint-disable react/no-danger */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRetinaImage = __webpack_require__(903);
	
	var _reactRetinaImage2 = _interopRequireDefault(_reactRetinaImage);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icon_paths = __webpack_require__(909);
	
	var _Tooltipify = __webpack_require__(910);
	
	var _Tooltipify2 = _interopRequireDefault(_Tooltipify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Icon = (0, _Tooltipify2.default)(_class = function (_Component) {
	    _inherits(Icon, _Component);
	
	    function Icon() {
	        _classCallCheck(this, Icon);
	
	        return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	    }
	
	    _createClass(Icon, [{
	        key: "render",
	        value: function render() {
	            var icon = (0, _icon_paths.loadIcon)(this.props.name);
	            if (!icon) {
	                return null;
	            }
	            var className = (0, _classnames2.default)(icon.attrs && icon.attrs.className, this.props.className);
	            var props = _extends({}, icon.attrs, this.props, { className: className });
	            var _arr = ["width", "height", "size", "scale"];
	            for (var _i = 0; _i < _arr.length; _i++) {
	                var prop = _arr[_i];
	                if (typeof props[prop] === "string") {
	                    props[prop] = parseInt(props[prop], 10);
	                }
	            }
	            if (props.size != null) {
	                props.width = props.size;
	                props.height = props.size;
	            }
	            if (props.scale != null && props.width != null && props.height != null) {
	                props.width *= props.scale;
	                props.height *= props.scale;
	            }
	
	            if (icon.img) {
	                return _react2.default.createElement(_reactRetinaImage2.default, _extends({ forceOriginalDimensions: false }, props, { src: icon.img }));
	            } else if (icon.svg) {
	                return _react2.default.createElement("svg", _extends({}, props, { dangerouslySetInnerHTML: { __html: icon.svg } }));
	            } else {
	                return _react2.default.createElement(
	                    "svg",
	                    props,
	                    _react2.default.createElement("path", { d: icon.path })
	                );
	            }
	        }
	    }]);
	
	    return Icon;
	}(_react.Component)) || _class;
	
	Icon.displayName = "Icon";
	exports.default = Icon;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.5
	var PropTypes, React, RetinaImage, arrayEqual, assign, imageExists, isRetina, path,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	React = __webpack_require__(300);
	
	PropTypes = __webpack_require__(469);
	
	isRetina = __webpack_require__(904);
	
	imageExists = __webpack_require__(905);
	
	path = __webpack_require__(906);
	
	assign = __webpack_require__(302);
	
	arrayEqual = __webpack_require__(907);
	
	module.exports = RetinaImage = (function(superClass) {
	  extend(RetinaImage, superClass);
	
	  RetinaImage.propTypes = {
	    src: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
	    checkIfRetinaImgExists: PropTypes.bool,
	    forceOriginalDimensions: PropTypes.bool,
	    retinaImageSuffix: PropTypes.string,
	    handleOnLoad: PropTypes.func,
	    onLoad: PropTypes.func,
	    onError: PropTypes.func
	  };
	
	  RetinaImage.defaultProps = {
	    checkIfRetinaImgExists: true,
	    forceOriginalDimensions: true,
	    retinaImageSuffix: '@2x',
	    onError: function() {}
	  };
	
	  function RetinaImage(props) {
	    this.handleOnLoad = bind(this.handleOnLoad, this);
	    RetinaImage.__super__.constructor.call(this, props);
	    this.state = this.wrangleProps();
	  }
	
	  RetinaImage.prototype.componentWillReceiveProps = function(nextProps) {
	    var isEqual;
	    isEqual = true;
	    if (Array.isArray(this.props.src) && Array.isArray(nextProps.src)) {
	      isEqual = arrayEqual(this.props.src, nextProps.src);
	    } else {
	      isEqual = this.props.src === nextProps.src;
	    }
	    if (!isEqual) {
	      return this.setState(assign(this.wrangleProps(nextProps), {
	        width: null,
	        height: null,
	        imgLoaded: null,
	        retinaImgExists: null,
	        retinaCheckComplete: null
	      }));
	    }
	  };
	
	  RetinaImage.prototype.componentDidMount = function() {
	    this.checkForRetina();
	    return this.checkLoaded();
	  };
	
	  RetinaImage.prototype.componentDidUpdate = function() {
	    return this.checkForRetina();
	  };
	
	  RetinaImage.prototype.render = function() {
	    var imgProps;
	    imgProps = assign({}, this.props);
	    delete imgProps.src;
	    delete imgProps.checkIfRetinaImgExists;
	    delete imgProps.forceOriginalDimensions;
	    delete imgProps.retinaImageSuffix;
	    delete imgProps.handleOnLoad;
	    delete imgProps.onLoad;
	    delete imgProps.onError;
	    imgProps.src = this.state.src;
	    imgProps.onLoad = this.handleOnLoad;
	    imgProps.onError = this.props.onError;
	    if (this.state.width >= 0) {
	      imgProps.width = this.state.width;
	    }
	    if (this.state.height >= 0) {
	      imgProps.height = this.state.height;
	    }
	    return React.createElement("img", Object.assign({}, imgProps, {
	      "ref": "img"
	    }));
	  };
	
	  RetinaImage.prototype.wrangleProps = function(props) {
	    if (props == null) {
	      props = this.props;
	    }
	    if (Array.isArray(props.src)) {
	      return {
	        src: props.src[0],
	        srcIsArray: true
	      };
	    } else {
	      return {
	        src: props.src,
	        srcIsArray: false
	      };
	    }
	  };
	
	  RetinaImage.prototype.checkForRetina = function() {
	    if (this.state.retinaCheckComplete) {
	      return;
	    }
	    if (isRetina() && this.props.checkIfRetinaImgExists) {
	      return imageExists(this.getRetinaPath(), (function(_this) {
	        return function(exists) {
	          var ref;
	          if (exists && ((ref = _this.state) != null ? ref.imgLoaded : void 0)) {
	            _this.setState({
	              src: _this.getRetinaPath()
	            });
	          } else if (exists) {
	            _this.setState({
	              retinaImgExists: true
	            });
	          }
	          return _this.setState({
	            retinaCheckComplete: true
	          });
	        };
	      })(this));
	    } else if (isRetina() && !this.props.checkIfRetinaImgExists) {
	      this.setState({
	        src: this.getRetinaPath()
	      });
	      return this.setState({
	        retinaCheckComplete: true
	      });
	    }
	  };
	
	  RetinaImage.prototype.checkLoaded = function() {
	    var el;
	    el = this.refs.img;
	    if (!el.complete) {
	      return false;
	    }
	    if (el.naturalWidth === 0) {
	      return false;
	    }
	    return this.handleOnLoad();
	  };
	
	  RetinaImage.prototype.handleOnLoad = function(e) {
	    var ref;
	    if (this.props.onLoad != null) {
	      this.props.onLoad(e);
	    }
	    if (this.props.handleOnLoad != null) {
	      this.props.handleOnLoad(e);
	    }
	    if (this.props.forceOriginalDimensions) {
	      this.setState({
	        width: this.refs.img.clientWidth,
	        height: this.refs.img.clientHeight
	      });
	    }
	    this.setState({
	      imgLoaded: true
	    });
	    if (((ref = this.state) != null ? ref.retinaImgExists : void 0) || !this.props.checkIfRetinaImgExists) {
	      return this.setState({
	        src: this.getRetinaPath()
	      });
	    }
	  };
	
	  RetinaImage.prototype.getRetinaPath = function() {
	    var basename, src;
	    if (this.state.srcIsArray) {
	      return this.props.src[1];
	    } else {
	      basename = path.basename(this.props.src, path.extname(this.props.src));
	      basename = basename + this.props.retinaImageSuffix + path.extname(this.props.src);
	      src = this.props.src.replace(path.basename(this.props.src), basename);
	      return src;
	    }
	  };
	
	  return RetinaImage;
	
	})(React.Component);


/***/ }),
/* 904 */
/***/ (function(module, exports) {

	module.exports = function() {
	  var mediaQuery;
	  if (typeof window !== "undefined" && window !== null) {
	    mediaQuery = "(-webkit-min-device-pixel-ratio: 1.25), (min--moz-device-pixel-ratio: 1.25), (-o-min-device-pixel-ratio: 5/4), (min-resolution: 1.25dppx)";
	    if (window.devicePixelRatio > 1.25) {
	      return true;
	    }
	    if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
	      return true;
	    }
	  }
	  return false;
	};


/***/ }),
/* 905 */
/***/ (function(module, exports) {

	var checks = {};
	
	module.exports = function(src, callback) {
	  if (src in checks) {
	    return callback(checks[src]);
	  }
	
	  var img = new Image();
	
	  img.onload = function() {
	    checks[src] = true;
	    callback(true);
	  };
	
	  img.onerror = function() {
	    checks[src] = false;
	    callback(false);
	  };
	
	  img.src = src;
	};


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ }),
/* 907 */
/***/ (function(module, exports) {

	
	module.exports = function equal(arr1, arr2) {
	  var length = arr1.length
	  if (length !== arr2.length) return false
	  for (var i = 0; i < length; i++)
	    if (arr1[i] !== arr2[i])
	      return false
	  return true
	}


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 909 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.loadIcon = loadIcon;
	/*  weak */
	
	/*
	    Metabase Icon Paths
	    -----
	
	    These paths represent the current canonical icon set for Metabase.
	*/
	
	var ICON_PATHS = exports.ICON_PATHS = {
	    add: 'M19,13 L19,2 L14,2 L14,13 L2,13 L2,18 L14,18 L14,30 L19,30 L19,18 L30,18 L30,13 L19,13 Z',
	    addtodash: {
	        path: 'M21,23 L16,23 L16,27 L21,27 L21,32 L25,32 L25,27 L30,27 L30,23 L25,23 L25,18 L21,18 L21,23 Z M32,7 L32,14 L28,14 L28,8 L0,8 L0,4 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 L4,0 L28,0 C30.209139,-4.05812251e-16 32,1.790861 32,4 L32,7 Z M0,8 L4,8 L4,28 L0,28 L0,8 Z M0,28 L12,28 L12,32 L4,32 C1.790861,32 2.705415e-16,30.209139 0,28 Z',
	        attrs: { fillRule: "evenodd" }
	    },
	    all: 'M30.595 13.536c1.85.755 1.879 2.05.053 2.9l-11.377 5.287c-1.82.846-4.763.858-6.583.022L1.344 16.532c-1.815-.835-1.785-2.131.05-2.89l1.637-.677 8.977 4.125c2.194 1.009 5.74.994 7.934-.026l9.022-4.193 1.63.665zm-1.63 7.684l1.63.666c1.85.755 1.879 2.05.053 2.898l-11.377 5.288c-1.82.847-4.763.859-6.583.022L1.344 24.881c-1.815-.834-1.785-2.131.05-2.89l1.637-.677 8.977 4.126c2.194 1.008 5.74.993 7.934-.026l9.022-4.194zM12.686 1.576c1.843-.762 4.834-.77 6.687-.013l11.22 4.578c1.85.755 1.88 2.05.054 2.899l-11.377 5.288c-1.82.846-4.763.858-6.583.022L1.344 9.136c-1.815-.834-1.785-2.13.05-2.89l11.293-4.67z',
	    archive: {
	        path: 'M32 10V8H0v23h32V10zm-5 2H5v15h22V12zM3 2h26v3H3V2zm11 12v5h-4l6 7 6-7h-4v-5h-4z',
	        attrs: { fillRule: "evenodd" }
	    },
	    area: 'M31.154 28.846l.852.004V8.64l-1.15 2.138-6.818 6.37c-.13.122-9.148 1.622-9.148 1.622l-.545.096-.383.4-7.93 8.31-1.016 1.146 2.227.017 23.91.107L7.25 28.74l7.93-8.31 9.615-1.684 7.211-6.737v15.984a.855.855 0 0 1-.852.854zM0 28.74l11.79-13.362 11.788-3.369 8.077-8.07c.194-.193.351-.128.351.15V28.85L0 28.74z',
	    backArrow: 'M11.7416687,19.0096 L18.8461178,26.4181004 L14.2696969,30.568 L0.38960831,16.093881 L0,15.6875985 L0.49145276,15.241949 L14.6347557,1 L19.136,5.22693467 L11.3214393,13.096 L32,13.096 L32,19.0096 L11.7416687,19.0096 Z',
	    bar: 'M2 23.467h6.4V32H2v-8.533zm10.667-12.8h6.4V32h-6.4V10.667zM23.333 0h6.4v32h-6.4V0z',
	    beaker: 'M4.31736354,31.1631075 C3.93810558,30.6054137 3.89343681,29.6635358 4.20559962,29.0817181 L11.806982,14.9140486 L11.8069821,10.5816524 L10.7015144,10.4653256 C10.0309495,10.394763 9.48734928,9.78799739 9.48734928,9.12166999 L9.48734928,7.34972895 C9.48734928,6.67821106 10.0368737,6.13383825 10.7172248,6.13383825 L21.8462005,6.13383825 C22.525442,6.13383825 23.0760761,6.68340155 23.0760761,7.34972895 L23.0760761,9.12166999 C23.0760761,9.79318788 22.5250158,10.3375607 21.856025,10.3375607 L20.9787023,10.3375607 L20.9787024,14.9281806 L28.77277,29.0827118 C29.0983515,29.6739888 29.0709073,30.6193105 28.7174156,31.1846409 L28.852457,30.9686726 C28.4963041,31.538259 27.6541076,32 26.9865771,32 L6.10749779,32 C5.43315365,32 4.58248747,31.5529687 4.19978245,30.9902061 L4.31736354,31.1631075 Z M15.5771418,17.6040443 C16.5170398,17.6040443 17.2789777,16.8377777 17.2789777,15.89254 C17.2789777,14.9473023 16.5170398,14.1810358 15.5771418,14.1810358 C14.6372438,14.1810358 13.8753059,14.9473023 13.8753059,15.89254 C13.8753059,16.8377777 14.6372438,17.6040443 15.5771418,17.6040443 Z M16.5496195,12.8974079 C17.8587633,12.8974079 18.9200339,11.830108 18.9200339,10.5135268 C18.9200339,9.1969457 17.8587633,8.1296458 16.5496195,8.1296458 C15.2404758,8.1296458 14.1792052,9.1969457 14.1792052,10.5135268 C14.1792052,11.830108 15.2404758,12.8974079 16.5496195,12.8974079 Z M5.71098553,30.2209651 L10.9595331,20.5151267 C10.9595331,20.5151267 12.6834557,21.2672852 14.3734184,21.2672852 C16.0633811,21.2672852 16.8198616,19.2872624 17.588452,18.6901539 C18.3570425,18.0930453 19.9467191,17.1113296 19.9467191,17.1113296 L27.0506095,30.1110325 L5.71098553,30.2209651 Z M13.6608671,4.37817079 C14.4114211,4.37817079 15.0198654,3.78121712 15.0198654,3.04483745 C15.0198654,2.30845779 14.4114211,1.71150412 13.6608671,1.71150412 C12.9103132,1.71150412 12.3018689,2.30845779 12.3018689,3.04483745 C12.3018689,3.78121712 12.9103132,4.37817079 13.6608671,4.37817079 Z M17.9214578,2.45333328 C18.6119674,2.45333328 19.1717361,1.90413592 19.1717361,1.22666664 C19.1717361,0.549197362 18.6119674,0 17.9214578,0 C17.2309481,0 16.6711794,0.549197362 16.6711794,1.22666664 C16.6711794,1.90413592 17.2309481,2.45333328 17.9214578,2.45333328 Z',
	    breakout: 'M24.47 1H32v7.53h-7.53V1zm0 11.294H32v7.53h-7.53v-7.53zm0 11.294H32v7.53h-7.53v-7.53zM0 1h9.412v30.118H0V1zm11.731 13.714c.166-.183.452-.177.452-.177h6.475s-1.601-2.053-2.07-2.806c-.469-.753-.604-1.368 0-1.905.603-.536 1.226-.281 1.878.497.652.779 2.772 3.485 3.355 4.214.583.73.65 1.965 0 2.835-.65.87-2.65 4.043-3.163 4.65-.514.607-1.123.713-1.732.295-.609-.419-.838-1.187-.338-1.872.5-.684 2.07-3.073 2.07-3.073h-6.475s-.27 0-.46-.312-.151-.612-.151-.612l.007-1.246s-.014-.306.152-.488z',
	    bubble: 'M18.155 20.882c-5.178-.638-9.187-5.051-9.187-10.402C8.968 4.692 13.66 0 19.448 0c5.789 0 10.48 4.692 10.48 10.48 0 3.05-1.302 5.797-3.383 7.712a7.127 7.127 0 1 1-8.39 2.69zm-6.392 10.14a2.795 2.795 0 1 1 0-5.59 2.795 2.795 0 0 1 0 5.59zm-6.079-6.288a4.541 4.541 0 1 1 0-9.083 4.541 4.541 0 0 1 0 9.083z',
	    cards: 'M16.5,11 C16.1340991,11 15.7865579,10.9213927 15.4733425,10.7801443 L7.35245972,21.8211652 C7.7548404,22.264891 8,22.8538155 8,23.5 C8,24.8807119 6.88071187,26 5.5,26 C4.11928813,26 3,24.8807119 3,23.5 C3,22.1192881 4.11928813,21 5.5,21 C5.87370843,21 6.22826528,21.0819977 6.5466604,21.2289829 L14.6623495,10.1950233 C14.2511829,9.74948188 14,9.15407439 14,8.5 C14,7.11928813 15.1192881,6 16.5,6 C17.8807119,6 19,7.11928813 19,8.5 C19,8.96980737 18.8704088,9.4093471 18.6450228,9.78482291 L25.0405495,15.4699905 C25.4512188,15.1742245 25.9552632,15 26.5,15 C27.8807119,15 29,16.1192881 29,17.5 C29,18.8807119 27.8807119,20 26.5,20 C25.1192881,20 24,18.8807119 24,17.5 C24,17.0256697 24.1320984,16.5821926 24.3615134,16.2043506 L17.9697647,10.5225413 C17.5572341,10.8228405 17.0493059,11 16.5,11 Z M5.5,25 C6.32842712,25 7,24.3284271 7,23.5 C7,22.6715729 6.32842712,22 5.5,22 C4.67157288,22 4,22.6715729 4,23.5 C4,24.3284271 4.67157288,25 5.5,25 Z M26.5,19 C27.3284271,19 28,18.3284271 28,17.5 C28,16.6715729 27.3284271,16 26.5,16 C25.6715729,16 25,16.6715729 25,17.5 C25,18.3284271 25.6715729,19 26.5,19 Z M16.5,10 C17.3284271,10 18,9.32842712 18,8.5 C18,7.67157288 17.3284271,7 16.5,7 C15.6715729,7 15,7.67157288 15,8.5 C15,9.32842712 15.6715729,10 16.5,10 Z',
	    calendar: {
	        path: 'M21,2 L21,0 L18,0 L18,2 L6,2 L6,0 L3,0 L3,2 L2.99109042,2 C1.34177063,2 0,3.34314575 0,5 L0,6.99502651 L0,20.009947 C0,22.2157067 1.78640758,24 3.99005301,24 L20.009947,24 C22.2157067,24 24,22.2135924 24,20.009947 L24,6.99502651 L24,5 C24,3.34651712 22.6608432,2 21.0089096,2 L21,2 L21,2 Z M22,8 L22,20.009947 C22,21.1099173 21.1102431,22 20.009947,22 L3.99005301,22 C2.89008272,22 2,21.1102431 2,20.009947 L2,8 L22,8 L22,8 Z M6,12 L10,12 L10,16 L6,16 L6,12 Z',
	        attrs: { viewBox: '0 0 24 24' }
	    },
	    check: 'M1 14 L5 10 L13 18 L27 4 L31 8 L13 26 z ',
	    chevrondown: 'M1 12 L16 26 L31 12 L27 8 L16 18 L5 8 z ',
	    chevronleft: 'M20 1 L24 5 L14 16 L24 27 L20 31 L6 16 z',
	    chevronright: 'M12 1 L26 16 L12 31 L8 27 L18 16 L8 5 z ',
	    chevronup: 'M1 20 L16 6 L31 20 L27 24 L16 14 L5 24 z',
	    clipboard: 'M8.54667751,5.50894675 L6.00494659,5.50894675 C4.89702623,5.50894675 4,6.40070914 4,7.50075379 L4,30.0171397 C4,31.1120596 4.89764516,32.0089468 6.00494659,32.0089468 L25.9950534,32.0089468 C27.1029738,32.0089468 28,31.1171844 28,30.0171397 L28,7.50075379 C28,6.40583387 27.1023548,5.50894675 25.9950534,5.50894675 L23.5373296,5.50894675 L23.5373296,3.0446713 L19.9106557,3.0446713 C19.9106557,3.0446713 19.6485834,8.05825522e-08 16.0837607,0 C12.518938,-8.05825523e-08 12.1644547,3.04776207 12.1644547,3.04776207 L8.57253264,3.04776207 L8.54667751,5.50894675 Z M23.5373296,7.50894675 L26,7.50894675 L26,30.0089468 L6,30.0089468 L6,7.50894675 L8.52566721,7.50894675 L8.4996301,9.98745456 L23.5373296,9.98745456 L23.5373296,7.50894675 Z M10.573037,5.01478303 L13.9861608,5.01478303 L13.9861608,3.76128231 C13.9861608,3.76128231 14.0254332,1.94834752 16.0135743,1.94834752 C18.0017155,1.94834752 18.0017156,3.7055821 18.0017156,3.7055821 L18.0017156,4.94060459 L21.4955568,4.94060459 L21.4955568,8.03924122 L10.5173901,8.03924122 L10.573037,5.01478303 Z M16,5.00894675 C16.5522847,5.00894675 17,4.5612315 17,4.00894675 C17,3.456662 16.5522847,3.00894675 16,3.00894675 C15.4477153,3.00894675 15,3.456662 15,4.00894675 C15,4.5612315 15.4477153,5.00894675 16,5.00894675 Z M8.5,18.0089468 L8.5,21.0082323 L11.5,21.0082323 L11.5,18.0446111 L8.5,18.0089468 Z M8.5,23.0089468 L8.5,26.0082323 L11.5,26.0082323 L11.5,23.0446111 L8.5,23.0089468 Z M8.5,13.0089468 L8.5,16.0082323 L11.5,16.0082323 L11.5,13.0446111 L8.5,13.0089468 Z M13.5,13.0193041 L13.5,16 L23.5,16 L23.5,13 L13.5,13.0193041 Z M13.5,23.0193041 L13.5,26 L23.5,26 L23.5,23 L13.5,23.0193041 Z M13.5,18.0193041 L13.5,21 L23.5,21 L23.5,18 L13.5,18.0193041 Z',
	    clock: 'M16 0 A16 16 0 0 0 0 16 A16 16 0 0 0 16 32 A16 16 0 0 0 32 16 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 28 16 A12 12 0 0 1 16 28 A12 12 0 0 1 4 16 A12 12 0 0 1 16 4 M14 6 L14 17.25 L22 22 L24.25 18.5 L18 14.75 L18 6z',
	    clone: {
	        path: 'M12,11 L16,11 L16,0 L5,0 L5,3 L12,3 L12,11 L12,11 Z M0,4 L11,4 L11,15 L0,15 L0,4 Z',
	        attrs: { viewBox: '0 0 16 15' }
	    },
	    close: 'M4 8 L8 4 L16 12 L24 4 L28 8 L20 16 L28 24 L24 28 L16 20 L8 28 L4 24 L12 16 z ',
	    collection: 'M16.5695046,2.82779686 L15.5639388,2.83217072 L30.4703127,11.5065092 L30.4818076,9.80229623 L15.5754337,18.2115855 L16.5436335,18.2077098 L1.65289961,9.96407638 L1.67877073,11.6677911 L16.5695046,2.82779686 Z M0.691634577,11.6826271 L15.5823685,19.9262606 C15.8836872,20.0930731 16.2506087,20.0916044 16.5505684,19.9223849 L31.4569423,11.5130957 C32.1196316,11.1392458 32.1260238,10.1915465 31.4684372,9.80888276 L16.5620632,1.1345443 C16.2511162,0.953597567 15.8658421,0.955273376 15.5564974,1.13891816 L0.665763463,9.97891239 C0.0118284022,10.3671258 0.0262104889,11.3142428 0.691634577,11.6826271 Z M15.5699489,25.798061 L16.0547338,26.0652615 L16.536759,25.7931643 L31.4991818,17.3470627 C31.973977,17.0790467 32.1404815,16.4788587 31.8710802,16.0065052 C31.6016788,15.5341517 30.9983884,15.3685033 30.5235933,15.6365193 L15.5611705,24.0826209 L16.5279806,24.0777242 L1.46763754,15.7768642 C0.99012406,15.5136715 0.388560187,15.6854222 0.124007019,16.16048 C-0.14054615,16.6355379 0.0320922897,17.2340083 0.509605765,17.497201 L15.5699489,25.798061 Z M15.5699489,31.7327994 L16.0547338,32 L16.536759,31.7279028 L31.4991818,23.2818011 C31.973977,23.0137852 32.1404815,22.4135972 31.8710802,21.9412437 C31.6016788,21.4688901 30.9983884,21.3032418 30.5235933,21.5712578 L15.5611705,30.0173594 L16.5279806,30.0124627 L1.46763754,21.7116027 C0.99012406,21.44841 0.388560187,21.6201606 0.124007019,22.0952185 C-0.14054615,22.5702764 0.0320922897,23.1687467 0.509605765,23.4319394 L15.5699489,31.7327994 Z',
	    compare: {
	        path: 'M8.514 23.486C3.587 21.992 0 17.416 0 12 0 5.373 5.373 0 12 0c5.415 0 9.992 3.587 11.486 8.514C28.413 10.008 32 14.584 32 20c0 6.627-5.373 12-12 12-5.415 0-9.992-3.587-11.486-8.514zm2.293.455A10.003 10.003 0 0 0 20 30c5.523 0 10-4.477 10-10 0-4.123-2.496-7.664-6.059-9.193.04.392.059.79.059 1.193 0 6.627-5.373 12-12 12-.403 0-.8-.02-1.193-.059z',
	        attrs: {
	            fillRule: 'nonzero'
	        }
	    },
	    compass_needle: {
	        path: 'M0 32l10.706-21.064L32 0 21.22 20.89 0 32zm16.092-12.945a3.013 3.013 0 0 0 3.017-3.009 3.013 3.013 0 0 0-3.017-3.008 3.013 3.013 0 0 0-3.017 3.008 3.013 3.013 0 0 0 3.017 3.009z'
	    },
	    connections: {
	        path: 'M5.37815706,11.5570815 C5.55061975,11.1918363 5.64705882,10.783651 5.64705882,10.3529412 C5.64705882,9.93118218 5.55458641,9.53102128 5.38881053,9.1716274 L11.1846365,4.82475792 C11.6952189,5.33295842 12.3991637,5.64705882 13.1764706,5.64705882 C14.7358628,5.64705882 16,4.38292165 16,2.82352941 C16,1.26413718 14.7358628,0 13.1764706,0 C11.6170784,0 10.3529412,1.26413718 10.3529412,2.82352941 C10.3529412,3.2452884 10.4454136,3.64544931 10.6111895,4.00484319 L10.6111895,4.00484319 L4.81536351,8.35171266 C4.3047811,7.84351217 3.60083629,7.52941176 2.82352941,7.52941176 C1.26413718,7.52941176 0,8.79354894 0,10.3529412 C0,11.9123334 1.26413718,13.1764706 2.82352941,13.1764706 C3.59147157,13.1764706 4.28780867,12.8698929 4.79682555,12.3724528 L10.510616,16.0085013 C10.408473,16.3004758 10.3529412,16.6143411 10.3529412,16.9411765 C10.3529412,18.5005687 11.6170784,19.7647059 13.1764706,19.7647059 C14.7358628,19.7647059 16,18.5005687 16,16.9411765 C16,15.3817842 14.7358628,14.1176471 13.1764706,14.1176471 C12.3029783,14.1176471 11.5221273,14.5142917 11.0042049,15.1372938 L5.37815706,11.5570815 Z',
	        attrs: { viewBox: '0 0 16 19.7647' }
	    },
	    contract: 'M18.0015892,0.327942852 L18.0015892,14 L31.6736463,14 L26.6544389,8.98079262 L32,3.63523156 L28.3647684,0 L23.0192074,5.34556106 L18.0015892,0.327942852 Z M14,31.6720571 L14,18 L0.327942852,18 L5.34715023,23.0192074 L0.00158917013,28.3647684 L3.63682073,32 L8.98238179,26.6544389 L14,31.6720571 Z',
	    copy: {
	        path: "M10.329 6.4h-3.33c-.95 0-1.72.77-1.72 1.72v.413h17.118V8.12c0-.941-.77-1.719-1.72-1.719h-3.31l-1.432-1.705a2.137 2.137 0 0 0-2.097-2.562 2.137 2.137 0 0 0-2.054 2.73L10.329 6.4zm12.808 4.267h1.4v8.557h-4.42l.111-4.188-5.981 6.064 5.805 6.264v-3.966h4.485v6.469H3.14v-19.2h19.997zm3.54 12.731v6.888c0 .947-.769 1.714-1.725 1.714H2.725C1.772 32 1 31.23 1 30.286V5.981c0-.947.768-1.714 1.725-1.714h6.834A4.273 4.273 0 0 1 13.839 0c2.363 0 4.279 1.91 4.279 4.267h6.834c.953 0 1.725.77 1.725 1.714v13.243H31v4.174h-4.323zM5.279 12.8h10.7v2.133h-10.7V12.8zm0 4.267h5.564V19.2H5.279v-2.133zm0 4.266h5.564v2.134H5.279v-2.134zm0 4.267h8.56v2.133h-8.56V25.6z",
	        attrs: { fillRule: "evenodd" }
	    },
	    cursor_move: 'M14.8235294,14.8235294 L14.8235294,6.58823529 L17.1764706,6.58823529 L17.1764706,14.8235294 L25.4117647,14.8235294 L25.4117647,17.1764706 L17.1764706,17.1764706 L17.1764706,25.4117647 L14.8235294,25.4117647 L14.8235294,17.1764706 L6.58823529,17.1764706 L6.58823529,14.8235294 L14.8235294,14.8235294 L14.8235294,14.8235294 Z M16,0 L20.1176471,6.58823529 L11.8823529,6.58823529 L16,0 Z M11.8823529,25.4117647 L20.1176471,25.4117647 L16,32 L11.8823529,25.4117647 Z M32,16 L25.4117647,20.1176471 L25.4117647,11.8823529 L32,16 Z M6.58823529,11.8823529 L6.58823529,20.1176471 L0,16 L6.58823529,11.8823529 Z',
	    cursor_resize: 'M17.4017952,6.81355995 L15.0488541,6.81355995 L15.0488541,25.6370894 L17.4017952,25.6370894 L17.4017952,6.81355995 Z M16.2253247,0.225324657 L20.3429717,6.81355995 L12.1076776,6.81355995 L16.2253247,0.225324657 Z M12.1076776,25.6370894 L20.3429717,25.6370894 L16.2253247,32.2253247 L12.1076776,25.6370894 Z',
	    costapproximate: 'M27 19a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM16 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 22a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM5 19a3 3 0 1 1 0-6 3 3 0 0 1 0 6z',
	    costexact: 'M27 19a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM16 8a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 22a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM5 19a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm11 0a3 3 0 1 1 0-6 3 3 0 0 1 0 6z',
	    costextended: 'M27,19 C25.3431458,19 24,17.6568542 24,16 C24,14.3431458 25.3431458,13 27,13 C28.6568542,13 30,14.3431458 30,16 C30,17.6568542 28.6568542,19 27,19 Z M16,8 C14.3431458,8 13,6.65685425 13,5 C13,3.34314575 14.3431458,2 16,2 C17.6568542,2 19,3.34314575 19,5 C19,6.65685425 17.6568542,8 16,8 Z M16,30 C14.3431458,30 13,28.6568542 13,27 C13,25.3431458 14.3431458,24 16,24 C17.6568542,24 19,25.3431458 19,27 C19,28.6568542 17.6568542,30 16,30 Z M5,19 C3.34314575,19 2,17.6568542 2,16 C2,14.3431458 3.34314575,13 5,13 C6.65685425,13 8,14.3431458 8,16 C8,17.6568542 6.65685425,19 5,19 Z M16,19 C14.3431458,19 13,17.6568542 13,16 C13,14.3431458 14.3431458,13 16,13 C17.6568542,13 19,14.3431458 19,16 C19,17.6568542 17.6568542,19 16,19 Z M10,12 C8.8954305,12 8,11.1045695 8,10 C8,8.8954305 8.8954305,8 10,8 C11.1045695,8 12,8.8954305 12,10 C12,11.1045695 11.1045695,12 10,12 Z M22,12 C20.8954305,12 20,11.1045695 20,10 C20,8.8954305 20.8954305,8 22,8 C23.1045695,8 24,8.8954305 24,10 C24,11.1045695 23.1045695,12 22,12 Z M22,24 C20.8954305,24 20,23.1045695 20,22 C20,20.8954305 20.8954305,20 22,20 C23.1045695,20 24,20.8954305 24,22 C24,23.1045695 23.1045695,24 22,24 Z M10,24 C8.8954305,24 8,23.1045695 8,22 C8,20.8954305 8.8954305,20 10,20 C11.1045695,20 12,20.8954305 12,22 C12,23.1045695 11.1045695,24 10,24 Z',
	    database: 'M1.18285296e-08,10.5127919 C-1.47856568e-08,7.95412848 1.18285298e-08,4.57337284 1.18285298e-08,4.57337284 C1.18285298e-08,4.57337284 1.58371041,5.75351864e-10 15.6571342,0 C29.730558,-5.7535027e-10 31.8900148,4.13849684 31.8900148,4.57337284 L31.8900148,10.4843058 C31.8900148,10.4843058 30.4448001,15.1365942 16.4659751,15.1365944 C2.48715012,15.1365947 2.14244494e-08,11.4353349 1.18285296e-08,10.5127919 Z M0.305419478,21.1290071 C0.305419478,21.1290071 0.0405133833,21.2033291 0.0405133833,21.8492606 L0.0405133833,27.3032816 C0.0405133833,27.3032816 1.46515486,31.941655 15.9641228,31.941655 C30.4630908,31.941655 32,27.3446712 32,27.3446712 C32,27.3446712 32,21.7986104 32,21.7986105 C32,21.2073557 31.6620557,21.0987647 31.6620557,21.0987647 C31.6620557,21.0987647 29.7146434,25.22314 16.0318829,25.22314 C2.34912233,25.22314 0.305419478,21.1290071 0.305419478,21.1290071 Z M0.305419478,12.656577 C0.305419478,12.656577 0.0405133833,12.730899 0.0405133833,13.3768305 L0.0405133833,18.8308514 C0.0405133833,18.8308514 1.46515486,23.4692249 15.9641228,23.4692249 C30.4630908,23.4692249 32,18.8722411 32,18.8722411 C32,18.8722411 32,13.3261803 32,13.3261803 C32,12.7349256 31.6620557,12.6263346 31.6620557,12.6263346 C31.6620557,12.6263346 29.7146434,16.7507099 16.0318829,16.7507099 C2.34912233,16.7507099 0.305419478,12.656577 0.305419478,12.656577 Z',
	    dashboard: 'M32,29 L32,4 L32,0 L0,0 L0,8 L28,8 L28,28 L4,28 L4,8 L0,8 L0,29.5 L0,32 L32,32 L32,29 Z M7.27272727,18.9090909 L17.4545455,18.9090909 L17.4545455,23.2727273 L7.27272727,23.2727273 L7.27272727,18.9090909 Z M7.27272727,12.0909091 L24.7272727,12.0909091 L24.7272727,16.4545455 L7.27272727,16.4545455 L7.27272727,12.0909091 Z M20.3636364,18.9090909 L24.7272727,18.9090909 L24.7272727,23.2727273 L20.3636364,23.2727273 L20.3636364,18.9090909 Z',
	    dashboards: 'M17,5.49100518 L17,10.5089948 C17,10.7801695 17.2276528,11 17.5096495,11 L26.4903505,11 C26.7718221,11 27,10.7721195 27,10.5089948 L27,5.49100518 C27,5.21983051 26.7723472,5 26.4903505,5 L17.5096495,5 C17.2281779,5 17,5.22788048 17,5.49100518 Z M18.5017326,14 C18.225722,14 18,13.77328 18,13.4982674 L18,26.5017326 C18,26.225722 18.22672,26 18.5017326,26 L5.49826741,26 C5.77427798,26 6,26.22672 6,26.5017326 L6,13.4982674 C6,13.774278 5.77327997,14 5.49826741,14 L18.5017326,14 Z M14.4903505,6 C14.2278953,6 14,5.78028538 14,5.49100518 L14,10.5089948 C14,10.2167107 14.2224208,10 14.4903505,10 L5.50964952,10 C5.77210473,10 6,10.2197146 6,10.5089948 L6,5.49100518 C6,5.78328929 5.77757924,6 5.50964952,6 L14.4903505,6 Z M26.5089948,22 C26.2251201,22 26,21.7774008 26,21.4910052 L26,26.5089948 C26,26.2251201 26.2225992,26 26.5089948,26 L21.4910052,26 C21.7748799,26 22,26.2225992 22,26.5089948 L22,21.4910052 C22,21.7748799 21.7774008,22 21.4910052,22 L26.5089948,22 Z M26.5089948,14 C26.2251201,14 26,13.7774008 26,13.4910052 L26,18.5089948 C26,18.2251201 26.2225992,18 26.5089948,18 L21.4910052,18 C21.7748799,18 22,18.2225992 22,18.5089948 L22,13.4910052 C22,13.7748799 21.7774008,14 21.4910052,14 L26.5089948,14 Z M26.4903505,6 C26.2278953,6 26,5.78028538 26,5.49100518 L26,10.5089948 C26,10.2167107 26.2224208,10 26.4903505,10 L17.5096495,10 C17.7721047,10 18,10.2197146 18,10.5089948 L18,5.49100518 C18,5.78328929 17.7775792,6 17.5096495,6 L26.4903505,6 Z M5,13.4982674 L5,26.5017326 C5,26.7769181 5.21990657,27 5.49826741,27 L18.5017326,27 C18.7769181,27 19,26.7800934 19,26.5017326 L19,13.4982674 C19,13.2230819 18.7800934,13 18.5017326,13 L5.49826741,13 C5.22308192,13 5,13.2199066 5,13.4982674 Z M5,5.49100518 L5,10.5089948 C5,10.7801695 5.22765279,11 5.50964952,11 L14.4903505,11 C14.7718221,11 15,10.7721195 15,10.5089948 L15,5.49100518 C15,5.21983051 14.7723472,5 14.4903505,5 L5.50964952,5 C5.22817786,5 5,5.22788048 5,5.49100518 Z M21,21.4910052 L21,26.5089948 C21,26.7801695 21.2278805,27 21.4910052,27 L26.5089948,27 C26.7801695,27 27,26.7721195 27,26.5089948 L27,21.4910052 C27,21.2198305 26.7721195,21 26.5089948,21 L21.4910052,21 C21.2198305,21 21,21.2278805 21,21.4910052 Z M21,13.4910052 L21,18.5089948 C21,18.7801695 21.2278805,19 21.4910052,19 L26.5089948,19 C26.7801695,19 27,18.7721195 27,18.5089948 L27,13.4910052 C27,13.2198305 26.7721195,13 26.5089948,13 L21.4910052,13 C21.2198305,13 21,13.2278805 21,13.4910052 Z',
	    curve: 'M3.033 3.791v22.211H31.09c.403 0 .882.872.882 1.59 0 .717-.48 1.408-.882 1.408H0V3.791c0-.403.875-.914 1.487-.914.612 0 1.546.511 1.546.914zm3.804 17.912C5.714 21.495 5 20.318 5 19.355c0-.963.831-2.296 1.837-2.296 2.093 0 2.965-1.207 4.204-5.242l.148-.482C12.798 6.077 14.18 3 17.968 3c3.792 0 5.17 3.08 6.765 8.343l.145.478c1.227 4.034 2.093 5.238 4.181 5.238 1.006 0 1.875 1.29 1.875 2.296 0 1.007-.898 2.184-1.875 2.348-3.656.612-6.004-2.364-7.665-7.821l-.146-.482c-1.14-3.76-1.8-6.754-3.28-6.754-1.483 0-2.147 2.995-3.297 6.754l-.148.486c-1.675 5.454-3.93 8.514-7.686 7.817z',
	    document: 'M29,10.1052632 L29,28.8325291 C29,30.581875 27.5842615,32 25.8337327,32 L7.16626728,32 C5.41758615,32 4,30.5837102 4,28.8441405 L4,3.15585953 C4,1.41292644 5.42339685,9.39605581e-15 7.15970573,8.42009882e-15 L20.713352,8.01767853e-16 L20.713352,8.42105263 L22.3846872,8.42105263 L22.3846872,0.310375032 L28.7849894,8.42105263 L20.713352,8.42105263 L20.713352,10.1052632 L29,10.1052632 Z M7.3426704,12.8000006 L25.7273576,12.8000006 L25.7273576,14.4842112 L7.3426704,14.4842112 L7.3426704,12.8000006 Z M7.3426704,17.3473687 L25.7273576,17.3473687 L25.7273576,19.0315793 L7.3426704,19.0315793 L7.3426704,17.3473687 Z M7.3426704,21.8947352 L25.7273576,21.8947352 L25.7273576,23.5789458 L7.3426704,23.5789458 L7.3426704,21.8947352 Z M7.43137255,26.2736849 L16.535014,26.2736849 L16.535014,27.9578954 L7.43137255,27.9578954 L7.43137255,26.2736849 Z',
	    downarrow: 'M12.2782161,19.3207547 L12.2782161,0 L19.5564322,0 L19.5564322,19.3207547 L26.8346484,19.3207547 L15.9173242,32 L5,19.3207547 L12.2782161,19.3207547 Z',
	    download: {
	        path: 'M4,8 L4,0 L7,0 L7,8 L10,8 L5.5,13.25 L1,8 L4,8 Z M11,14 L0,14 L0,17 L11,17 L11,14 Z',
	        attrs: { viewBox: '0 0 11 17' }
	    },
	    ellipsis: {
	        path: 'M26.1111111,19 C27.7066004,19 29,17.6568542 29,16 C29,14.3431458 27.7066004,13 26.1111111,13 C24.5156218,13 23.2222222,14.3431458 23.2222222,16 C23.2222222,17.6568542 24.5156218,19 26.1111111,19 Z M5.88888889,19 C7.48437817,19 8.77777778,17.6568542 8.77777778,16 C8.77777778,14.3431458 7.48437817,13 5.88888889,13 C4.29339961,13 3,14.3431458 3,16 C3,17.6568542 4.29339961,19 5.88888889,19 Z M16,19 C17.5954893,19 18.8888889,17.6568542 18.8888889,16 C18.8888889,14.3431458 17.5954893,13 16,13 C14.4045107,13 13.1111111,14.3431458 13.1111111,16 C13.1111111,17.6568542 14.4045107,19 16,19 Z',
	        attrs: { width: 32, height: 32 }
	    },
	    emojiactivity: 'M4.58360576,27.9163942 C7.44354038,30.7763289 17.5452495,30.2077351 24.1264923,23.6264923 C30.7077351,17.0452495 31.2763289,6.94354038 28.4163942,4.08360576 C25.5564596,1.22367115 15.4547505,1.79226488 8.87350769,8.37350769 C2.29226488,14.9547505 1.72367115,25.0564596 4.58360576,27.9163942 Z M18.0478143,6.51491123 C17.0327353,6.95492647 16.0168474,7.462507 15.0611336,8.03487206 C13.9504884,8.70002358 12.9907793,9.41185633 12.2241295,10.1785061 C11.6753609,10.7272747 11.1524326,11.3411471 10.6544469,12.0086598 C9.95174829,12.950575 9.33131183,13.9528185 8.79588947,14.9547475 C8.47309082,15.5587964 8.24755055,16.0346972 8.12501633,16.3206104 L10.6033735,17.3827634 C10.6970997,17.1640688 10.8900635,16.7569059 11.1739957,16.2255873 C11.6497914,15.335237 12.2007659,14.4452012 12.8156543,13.6209891 C13.2395954,13.0527276 13.6791325,12.5367492 14.1307526,12.0851292 C14.7228522,11.4930296 15.5113715,10.9081712 16.4465129,10.3481268 C17.2918299,9.84187694 18.205618,9.38530978 19.1202149,8.98885142 C19.6674377,8.75164195 20.0881481,8.58915552 20.3167167,8.50897949 L19.4242138,5.96460106 C19.1382021,6.06492664 18.6583971,6.25023653 18.0478143,6.51491123 Z',
	    emojifood: 'M14.9166667,8.71296296 L14.9166667,4.85648148 L14.9636504,4.84865086 L18.8123012,1 L21.149682,3.33738075 L18.2222222,6.26484052 L18.2222222,8.71296296 L27.037037,8.71296296 L27.037037,10.9166667 L24.6968811,10.9166667 L22.2407407,30.75 L10.3148148,30.75 L7.36744639,10.9166667 L5,10.9166667 L5,8.71296296 L14.9166667,8.71296296 Z',
	    emojiflags: 'M14.4,17.8888889 L7.9,17.8888889 L7.9,28.9485494 C7.9,30.0201693 7.0344636,30.8888889 5.95,30.8888889 C4.87304474,30.8888889 4,30.0243018 4,28.9485494 L4,2.99442095 C4,2.44521742 4.44737959,2 5.00434691,2 L7.25,2 L19.1921631,2 C20.8138216,2 22.135741,3.27793211 22.1977269,4.88888889 L29.0004187,4.88888889 C29.5524722,4.88888889 30,5.33043204 30,5.88281005 L30,17.7705198 C30,19.4313825 28.6564509,20.7777778 26.9921631,20.7777778 L14.4,20.7777778 L14.4,17.8888889 Z',
	    emojinature: 'M19.0364085,24.2897898 L29.4593537,24.2897898 C30.0142087,24.2897898 30.2190588,23.9075249 29.9310364,23.4359772 L17.0209996,2.29978531 C16.7300287,1.82341061 16.2660004,1.82823762 15.9779779,2.29978531 L3.06794114,23.4359772 C2.77697033,23.9123519 2.9910982,24.2897898 3.53962381,24.2897898 L13.962569,24.2897898 L13.962569,31.5582771 L16.5093674,31.5582771 L19.0364085,31.5582771 L19.0364085,24.2897898 Z',
	    emojiobjects: 'M10.4444444,25.2307692 L10.4444444,20.0205203 C7.76447613,18.1576095 6,14.9850955 6,11.3846154 C6,5.64935068 10.4771525,1 16,1 C21.5228475,1 26,5.64935068 26,11.3846154 C26,14.9850955 24.2355239,18.1576095 21.5555556,20.0205203 L21.5555556,25.2307692 C21.5555556,28.4170274 19.0682486,31 16,31 C12.9317514,31 10.4444444,28.4170274 10.4444444,25.2307692 Z',
	    emojipeople: 'M16,31 C24.2842712,31 31,24.2842712 31,16 C31,7.71572875 24.2842712,1 16,1 C7.71572875,1 1,7.71572875 1,16 C1,24.2842712 7.71572875,31 16,31 Z M22.9642857,19.2142857 C22.9642857,22.3818012 19.8462688,24.9495798 16,24.9495798 C12.1537312,24.9495798 9.03571429,22.3818012 9.03571429,19.2142857 L22.9642857,19.2142857 Z M19.75,14.9285714 C20.6376005,14.9285714 21.3571429,13.2496392 21.3571429,11.1785714 C21.3571429,9.10750362 20.6376005,7.42857143 19.75,7.42857143 C18.8623995,7.42857143 18.1428571,9.10750362 18.1428571,11.1785714 C18.1428571,13.2496392 18.8623995,14.9285714 19.75,14.9285714 Z M12.25,14.9285714 C13.1376005,14.9285714 13.8571429,13.2496392 13.8571429,11.1785714 C13.8571429,9.10750362 13.1376005,7.42857143 12.25,7.42857143 C11.3623995,7.42857143 10.6428571,9.10750362 10.6428571,11.1785714 C10.6428571,13.2496392 11.3623995,14.9285714 12.25,14.9285714 Z',
	    emojisymbols: 'M15.915,6.8426232 L13.8540602,4.78168347 C10.8078936,1.73551684 5.86858639,1.73495294 2.82246208,4.78107725 C-0.217463984,7.82100332 -0.223390824,12.7662163 2.82306829,15.8126754 L15.6919527,28.6815598 L15.915,28.4585125 L16.1380473,28.6815598 L29.0069316,15.8126754 C32.0533907,12.7662163 32.0474639,7.82100332 29.0075378,4.78107725 C25.9614135,1.73495294 21.0221063,1.73551684 17.9759397,4.78168347 L15.915,6.8426232 Z',
	    emojitravel: 'M21.5273864,25.0150018 L21.5273864,1.91741484 C21.5273864,0.0857778237 20.049926,-1.38499821 18.2273864,-1.38499821 C16.4085552,-1.38499821 14.9273864,0.0935424793 14.9273864,1.91741484 L14.9273864,25.0150018 L11.6273864,28.3150018 L24.8273864,28.3150018 L21.5273864,25.0150018 Z M1.72738636,18.4150018 L14.9273864,5.21500179 L14.9273864,15.7750018 L1.72738636,23.6950018 L1.72738636,18.4150018 Z M34.7273864,18.4150018 L21.5273864,5.21500179 L21.5273864,15.7750018 L34.7273864,23.6950018 L34.7273864,18.4150018 Z',
	    empty: ' ',
	    enterorreturn: 'M6.81 16.784l6.14-4.694a1.789 1.789 0 0 0 .341-2.49 1.748 1.748 0 0 0-2.464-.344L.697 17a1.788 1.788 0 0 0-.01 2.826l10.058 7.806c.77.598 1.875.452 2.467-.326a1.79 1.79 0 0 0-.323-2.492l-5.766-4.475h23.118c.971 0 1.759-.796 1.759-1.777V6.777C32 5.796 31.212 5 30.24 5c-.971 0-1.759.796-1.759 1.777v10.007H6.811z',
	    expand: 'M29,13.6720571 L29,8.26132482e-16 L15.3279429,8.64083276e-16 L20.3471502,5.01920738 L15.0015892,10.3647684 L18.6368207,14 L23.9823818,8.65443894 L29,13.6720571 Z M0.00158917013,15.3279429 L0.00158917013,29 L13.6736463,29 L8.65443894,23.9807926 L14,18.6352316 L10.3647684,15 L5.01920738,20.3455611 L0.00158917013,15.3279429 Z',
	    expandarrow: 'M16.429 28.429L.429 5.57h32z',
	    explore: 'M16.4796545,16.298957 L16.4802727,23.0580389 L16.4802727,23.0580389 C17.3528782,23.2731238 18,24.0609902 18,25 C18,26.1045695 17.1045695,27 16,27 C14.8954305,27 14,26.1045695 14,25 C14,24.0751922 14.6276951,23.2969904 15.4802906,23.0681896 L15.4796772,16.3617812 L15.4796772,16.3617812 L9.42693239,19.2936488 C9.54250354,19.9090101 9.36818637,20.5691625 8.90013616,21.0538426 C8.13283771,21.8484034 6.86670062,21.8705039 6.07213982,21.1032055 C5.27757902,20.335907 5.25547851,19.06977 6.02277696,18.2752092 C6.79007541,17.4806484 8.0562125,17.4585478 8.8507733,18.2258463 C8.90464955,18.277874 8.95497425,18.3321952 9.00174214,18.3885073 L14.8957415,15.5335339 L8.95698016,12.663638 C8.54316409,13.1288103 7.91883307,13.3945629 7.25239963,13.3245179 C6.15388108,13.2090589 5.35695382,12.2249357 5.47241277,11.1264172 C5.58787172,10.0278986 6.57199493,9.23097136 7.67051349,9.34643031 C8.76903204,9.46188927 9.5659593,10.4460125 9.45050035,11.544531 C9.44231425,11.6224166 9.42976147,11.6987861 9.41311084,11.7734218 L15.4795257,14.705006 L15.4789062,7.93143834 C14.6270158,7.70216703 14,6.9243072 14,6 C14,4.8954305 14.8954305,4 16,4 C17.1045695,4 18,4.8954305 18,6 C18,6.93950562 17.3521946,7.72770818 16.4788902,7.94230133 L16.4795143,14.7663758 L22.5940736,11.8045661 C22.4397082,11.1620316 22.6068068,10.4567329 23.0998638,9.94615736 C23.8671623,9.15159656 25.1332994,9.12949606 25.9278602,9.8967945 C26.722421,10.664093 26.7445215,11.93023 25.977223,12.7247908 C25.2099246,13.5193516 23.9437875,13.5414522 23.1492267,12.7741537 C23.120046,12.7459743 23.0919072,12.717122 23.0648111,12.687645 L17.1917924,15.5324558 L23.0283963,18.3529842 C23.4420438,17.8775358 24.073269,17.604607 24.7476004,17.6754821 C25.8461189,17.7909411 26.6430462,18.7750643 26.5275872,19.8735828 C26.4121283,20.9721014 25.4280051,21.7690286 24.3294865,21.6535697 C23.230968,21.5381107 22.4340407,20.5539875 22.5494996,19.455469 C22.5569037,19.3850239 22.56788,19.315819 22.5822296,19.2480155 L16.4796545,16.298957 Z M16.0651172,6.99791382 C16.5870517,6.96436642 17,6.53040783 17,6 C17,5.44771525 16.5522847,5 16,5 C15.4477153,5 15,5.44771525 15,6 C15,6.53446591 15.4192913,6.9710011 15.9468816,6.99861337 L16.0651172,6.99791382 L16.0651172,6.99791382 Z M16,26 C16.5522847,26 17,25.5522847 17,25 C17,24.4477153 16.5522847,24 16,24 C15.4477153,24 15,24.4477153 15,25 C15,25.5522847 15.4477153,26 16,26 Z M6.56266251,20.102897 C6.80476821,20.5992873 7.40343746,20.8054256 7.89982771,20.5633199 C8.39621795,20.3212142 8.60235631,19.722545 8.36025061,19.2261547 C8.11814491,18.7297645 7.51947566,18.5236261 7.02308541,18.7657318 C6.52669517,19.0078375 6.32055681,19.6065068 6.56266251,20.102897 Z M23.6397494,11.7738453 C23.8818551,12.2702355 24.4805243,12.4763739 24.9769146,12.2342682 C25.4733048,11.9921625 25.6794432,11.3934932 25.4373375,10.897103 C25.1952318,10.4007127 24.5965625,10.1945744 24.1001723,10.4366801 C23.603782,10.6787858 23.3976437,11.277455 23.6397494,11.7738453 Z M25.4373375,20.102897 C25.6794432,19.6065068 25.4733048,19.0078375 24.9769146,18.7657318 C24.4805243,18.5236261 23.8818551,18.7297645 23.6397494,19.2261547 C23.3976437,19.722545 23.603782,20.3212142 24.1001723,20.5633199 C24.5965625,20.8054256 25.1952318,20.5992873 25.4373375,20.102897 Z M8.36025061,11.7738453 C8.60235631,11.277455 8.39621795,10.6787858 7.89982771,10.4366801 C7.40343746,10.1945744 6.80476821,10.4007127 6.56266251,10.897103 C6.32055681,11.3934932 6.52669517,11.9921625 7.02308541,12.2342682 C7.51947566,12.4763739 8.11814491,12.2702355 8.36025061,11.7738453 Z',
	    external: 'M13.7780693,4.44451732 L5.1588494,4.44451732 C2.32615959,4.44451732 0,6.75504816 0,9.60367661 L0,25.1192379 C0,27.9699171 2.30950226,30.2783972 5.1588494,30.2783972 L18.9527718,30.2783972 C21.7854617,30.2783972 24.1116212,27.9678664 24.1116212,25.1192379 L24.1116212,19.9448453 L20.6671039,19.9448453 L20.6671039,25.1192379 C20.6671039,26.0662085 19.882332,26.8338799 18.9527718,26.8338799 L5.1588494,26.8338799 C4.21204994,26.8338799 3.44451732,26.0677556 3.44451732,25.1192379 L3.44451732,9.60367661 C3.44451732,8.656706 4.22928927,7.88903464 5.1588494,7.88903464 L13.7780693,7.88903464 L13.7780693,4.44451732 L13.7780693,4.44451732 Z M30.9990919,14.455325 L30.9990919,1 L17.5437669,1 L22.4834088,5.93964193 L17.2225866,11.2004641 L20.8001918,14.7780693 L26.061014,9.51724709 L30.9990919,14.455325 L30.9990919,14.455325 L30.9990919,14.455325 Z',
	    everything: {
	        path: 'M26.656 17.273a400.336 400.336 0 0 1 2.632.017l.895.008-2.824-9.56c-.122-.411.1-.848.495-.975a.743.743 0 0 1 .936.516l3.177 10.752.033.23V31H0V17.994L3.303 7.212a.743.743 0 0 1 .94-.507c.394.132.611.57.486.982L1.763 17.37h3.486V9.758c0-.865.669-1.558 1.505-1.558h18.398c.83 0 1.504.69 1.504 1.56v7.513zm-1.497 0h-.176c-.362.002-.648.006-.853.012a7.264 7.264 0 0 0-.272.011c-.056.004-.056.004-.117.011-.058-.001-.058-.001-.355.135-.233.164-.344.37-.452.68-.05.147-.236.807-.287.97-.132.419-.279.775-.469 1.108-.43.752-1.048 1.322-1.959 1.693-.15.062-2.005.093-4.356.056-1.561-.024-4.056-.096-4.053-.095-.92-.185-1.634-.826-2.173-1.818a7.023 7.023 0 0 1-.566-1.4 5.72 5.72 0 0 1-.147-.614.758.758 0 0 0-.738-.652h-1.44V9.76l18.406.002c.003 0 .006 4.98.007 7.51zM1.497 18.931v10.507h29.006V18.863a780.193 780.193 0 0 0-3.023-.025 233.572 233.572 0 0 0-2.489-.003c-.287.001-.524.004-.706.008-.067.23-.17.59-.216.736-.164.52-.352.977-.605 1.42-.594 1.042-1.468 1.846-2.7 2.349-.681.278-8.668.153-9.236.04-1.407-.283-2.456-1.225-3.194-2.582a8.596 8.596 0 0 1-.74-1.874H1.498zM6.982 5.828h18.074c.375 0 .679-.35.679-.78 0-.432-.304-.782-.679-.782H6.982c-.375 0-.678.35-.678.781 0 .431.303.781.678.781zm1.38-3.267h15.28c.369 0 .668-.35.668-.78 0-.431-.299-.781-.668-.781H8.362c-.37 0-.668.35-.668.78 0 .432.299.781.668.781z',
	        attrs: { fillRule: 'evenodd' }
	    },
	    eye: 'M30.622 18.49c-.549.769-1.46 1.86-2.737 3.273-1.276 1.414-2.564 2.614-3.866 3.602-2.297 1.757-4.963 2.635-8 2.635-3.062 0-5.741-.878-8.038-2.635-1.302-.988-2.59-2.188-3.866-3.602-1.276-1.413-2.188-2.504-2.737-3.272-.549-.769-.9-1.277-1.053-1.524-.433-.63-.433-1.276 0-1.934.128-.247.472-.755 1.034-1.524.561-.768 1.48-1.852 2.756-3.252 1.276-1.4 2.564-2.593 3.866-3.581C10.303 4.892 12.982 4 16.019 4c3.011 0 5.678.892 8 2.676 1.302.988 2.59 2.182 3.866 3.581 1.276 1.4 2.195 2.484 2.756 3.252.562.769.906 1.277 1.034 1.524.433.63.433 1.276 0 1.934-.153.247-.504.755-1.053 1.524zm-1.516-3.214c-.248.376-.248 1.089.034 1.499l-.11-.16-.088-.17a21.93 21.93 0 0 0-.784-1.121c-.483-.66-1.338-1.67-2.546-2.995-1.154-1.266-2.306-2.333-3.466-3.214-1.781-1.368-3.788-2.04-6.127-2.04-2.365 0-4.385.673-6.179 2.05-1.146.87-2.298 1.938-3.452 3.204-1.208 1.325-2.063 2.334-2.546 2.995a21.93 21.93 0 0 0-.784 1.12l-.075.145-.09.135c.249-.376.249-1.089-.033-1.499l.08.122c.105.17.432.644.941 1.356.466.653 1.313 1.666 2.517 3 1.152 1.275 2.3 2.346 3.451 3.22 1.752 1.339 3.773 2.001 6.17 2.001 2.37 0 4.379-.661 6.14-2.008 1.143-.867 2.291-1.938 3.443-3.214 1.204-1.333 2.05-2.346 2.517-2.999.509-.712.836-1.186.942-1.356l.045-.071zm-17.353 5.663C10.584 19.709 10 18.237 10 16.522c0-1.744.584-3.224 1.753-4.439 1.168-1.215 2.59-1.822 4.268-1.822 1.65 0 3.058.607 4.226 1.822C21.416 13.298 22 14.778 22 16.522c0 1.715-.584 3.187-1.753 4.417-1.168 1.229-2.577 1.844-4.226 1.844-1.677 0-3.1-.615-4.268-1.844zm6.265-2.12c.624-.655.906-1.368.906-2.297 0-.957-.281-1.67-.893-2.307-.592-.616-1.203-.879-2.01-.879-.84 0-1.462.266-2.052.88-.612.636-.893 1.35-.893 2.306 0 .929.282 1.642.906 2.298.59.62 1.207.887 2.039.887.8 0 1.405-.264 1.997-.887z',
	    field: 'M10,1 L22,1 L22,4 L10,4 L10,1 Z M10,6 L22,6 L22,12 L10,12 L10,6 Z M10,14 L22,14 L22,20 L10,20 L10,14 Z M10,22 L22,22 L22,28 L16.1421494,32 L10,28 L10,22 Z',
	    fields: 'M0,0 L7.51851852,0 L7.51851852,3.2 L0,3.2 L0,0 Z M10.7407407,0 L18.2592593,0 L18.2592593,3.2 L10.7407407,3.2 L10.7407407,0 Z M21.4814815,0 L29,0 L29,3.2 L21.4814815,3.2 L21.4814815,0 Z M0,5.33333333 L7.51851852,5.33333333 L7.51851852,29.8666667 L3.85540334,32 L0,29.8666667 L0,5.33333333 Z M10.7407407,5.33333333 L18.2592593,5.33333333 L18.2592593,29.8666667 L14.5690136,32 L10.7407407,29.8666667 L10.7407407,5.33333333 Z M21.4814815,5.33333333 L29,5.33333333 L29,29.8666667 L25.2114718,32 L21.4814815,29.8666667 L21.4814815,5.33333333 Z',
	    filter: {
	        svg: '<g><path d="M1,12 L17,12 L17,14 L1,14 L1,12 Z M1,7 L17,7 L17,9 L1,9 L1,7 Z M1,2 L17,2 L17,4 L1,4 L1,2 Z" fill="currentcolor"></path><path d="M9,15.5 C10.3807119,15.5 11.5,14.3807119 11.5,13 C11.5,11.6192881 10.3807119,10.5 9,10.5 C7.61928813,10.5 6.5,11.6192881 6.5,13 C6.5,14.3807119 7.61928813,15.5 9,15.5 Z M13,5.5 C14.3807119,5.5 15.5,4.38071187 15.5,3 C15.5,1.61928813 14.3807119,0.5 13,0.5 C11.6192881,0.5 10.5,1.61928813 10.5,3 C10.5,4.38071187 11.6192881,5.5 13,5.5 Z M3,10.5 C4.38071187,10.5 5.5,9.38071187 5.5,8 C5.5,6.61928813 4.38071187,5.5 3,5.5 C1.61928813,5.5 0.5,6.61928813 0.5,8 C0.5,9.38071187 1.61928813,10.5 3,10.5 Z" id="Path" fill="currentcolor"></path><path d="M13,4.5 C12.1715729,4.5 11.5,3.82842712 11.5,3 C11.5,2.17157288 12.1715729,1.5 13,1.5 C13.8284271,1.5 14.5,2.17157288 14.5,3 C14.5,3.82842712 13.8284271,4.5 13,4.5 Z M9,14.5 C8.17157288,14.5 7.5,13.8284271 7.5,13 C7.5,12.1715729 8.17157288,11.5 9,11.5 C9.82842712,11.5 10.5,12.1715729 10.5,13 C10.5,13.8284271 9.82842712,14.5 9,14.5 Z M3,9.5 C2.17157288,9.5 1.5,8.82842712 1.5,8 C1.5,7.17157288 2.17157288,6.5 3,6.5 C3.82842712,6.5 4.5,7.17157288 4.5,8 C4.5,8.82842712 3.82842712,9.5 3,9.5 Z" fill="#FFFFFF"></path></g>',
	        attrs: { viewBox: '0 0 19 16' }
	    },
	    funnel: 'M3.18586974,3.64621479 C2.93075885,3.28932022 3.08031197,3 3.5066208,3 L28.3780937,3 C28.9190521,3 29.0903676,3.34981042 28.7617813,3.77995708 L18.969764,16.5985181 L18.969764,24.3460671 C18.969764,24.8899179 18.5885804,25.5564176 18.133063,25.8254534 C18.133063,25.8254534 12.5698889,29.1260709 12.5673818,28.9963552 C12.4993555,25.4767507 12.5749031,16.7812673 12.5749031,16.7812673 L3.18586974,3.64621479 Z',
	    funneladd: 'M22.5185184,5.27947653 L17.2510286,5.27947653 L17.2510286,9.50305775 L22.5185184,9.50305775 L22.5185184,14.7825343 L26.7325102,14.7825343 L26.7325102,9.50305775 L32,9.50305775 L32,5.27947653 L26.7325102,5.27947653 L26.7325102,0 L22.5185184,0 L22.5185184,5.27947653 Z M14.9369872,0.791920724 C14.9369872,0.791920724 2.77552871,0.83493892 1.86648164,0.83493892 C0.957434558,0.83493892 0.45215388,1.50534608 0.284450368,1.77831828 C0.116746855,2.05129048 -0.317642562,2.91298361 0.398382661,3.9688628 C1.11440788,5.024742 9.74577378,17.8573356 9.74577378,17.8573356 C9.74577378,17.8573356 9.74577394,28.8183645 9.74577378,29.6867194 C9.74577362,30.5550744 9.83306175,31.1834301 10.7557323,31.6997692 C11.6784029,32.2161084 12.4343349,31.9564284 12.7764933,31.7333621 C13.1186517,31.5102958 19.6904355,27.7639669 20.095528,27.4682772 C20.5006204,27.1725875 20.7969652,26.5522071 20.7969651,25.7441659 C20.7969649,24.9361247 20.7969651,18.2224765 20.7969651,18.2224765 L21.6163131,16.9859755 L18.152048,15.0670739 C18.152048,15.0670739 17.3822517,16.199685 17.2562629,16.4000338 C17.1302741,16.6003826 16.8393552,16.9992676 16.8393551,17.7062886 C16.8393549,18.4133095 16.8393551,24.9049733 16.8393551,24.9049733 L13.7519708,26.8089871 C13.7519708,26.8089871 13.7318369,18.3502323 13.7318367,17.820601 C13.7318366,17.2909696 13.8484216,16.6759061 13.2410236,15.87149 C12.6336257,15.0670739 5.59381579,4.76288686 5.59381579,4.76288686 L14.9359238,4.76288686 L14.9369872,0.791920724 Z',
	    funneloutline: {
	        path: 'M3.186 3.646C2.93 3.29 3.08 3 3.506 3h24.872c.541 0 .712.35.384.78L18.97 16.599v7.747c0 .544-.381 1.21-.837 1.48 0 0-5.563 3.3-5.566 3.17-.068-3.52.008-12.215.008-12.215L3.185 3.646z',
	        attrs: {
	            stroke: "currentcolor",
	            strokeWidth: "4",
	            fill: "none",
	            fillRule: "evenodd"
	        }
	    },
	    folder: "M3.96901618e-15,5.41206355 L0.00949677904,29 L31.8821132,29 L31.8821132,10.8928571 L18.2224205,10.8928571 L15.0267944,5.41206355 L3.96901618e-15,5.41206355 Z M16.8832349,5.42402804 L16.8832349,4.52140947 C16.8832349,3.68115822 17.5639241,3 18.4024298,3 L27.7543992,3 L30.36417,3 C31.2031259,3 31.8832341,3.67669375 31.8832341,4.51317691 L31.8832341,7.86669975 L31.8832349,8.5999999 L18.793039,8.5999999 L16.8832349,5.42402804 Z",
	    gear: 'M14 0 H18 L19 6 L20.707 6.707 L26 3.293 L28.707 6 L25.293 11.293 L26 13 L32 14 V18 L26 19 L25.293 20.707 L28.707 26 L26 28.707 L20.707 25.293 L19 26 L18 32 L14 32 L13 26 L11.293 25.293 L6 28.707 L3.293 26 L6.707 20.707 L6 19 L0 18 L0 14 L6 13 L6.707 11.293 L3.293 6 L6 3.293 L11.293 6.707 L13 6 L14 0 z M16 10 A6 6 0 0 0 16 22 A6 6 0 0 0 16 10',
	    grabber: 'M0,5 L32,5 L32,9.26666667 L0,9.26666667 L0,5 Z M0,13.5333333 L32,13.5333333 L32,17.8 L0,17.8 L0,13.5333333 Z M0,22.0666667 L32,22.0666667 L32,26.3333333 L0,26.3333333 L0,22.0666667 Z',
	    grid: 'M2 2 L10 2 L10 10 L2 10z M12 2 L20 2 L20 10 L12 10z M22 2 L30 2 L30 10 L22 10z M2 12 L10 12 L10 20 L2 20z M12 12 L20 12 L20 20 L12 20z M22 12 L30 12 L30 20 L22 20z M2 22 L10 22 L10 30 L2 30z M12 22 L20 22 L20 30 L12 30z M22 22 L30 22 L30 30 L22 30z',
	    google: {
	        svg: '<g fill="none" fill-rule="evenodd"><path d="M16 32c4.32 0 7.947-1.422 10.596-3.876l-5.05-3.91c-1.35.942-3.164 1.6-5.546 1.6-4.231 0-7.822-2.792-9.102-6.65l-5.174 4.018C4.356 28.41 9.742 32 16 32z" fill="#34A853"/><path d="M6.898 19.164A9.85 9.85 0 0 1 6.364 16c0-1.102.196-2.169.516-3.164L1.707 8.818A16.014 16.014 0 0 0 0 16c0 2.578.622 5.013 1.707 7.182l5.19-4.018z" fill="#FBBC05"/><path d="M31.36 16.356c0-1.316-.107-2.276-.338-3.272H16v5.938h8.818c-.178 1.476-1.138 3.698-3.271 5.191l5.049 3.911c3.022-2.79 4.764-6.897 4.764-11.768z" fill="#4285F4"/><path d="M16 6.187c3.004 0 5.031 1.297 6.187 2.382l4.515-4.409C23.93 1.582 20.32 0 16 0 9.742 0 4.338 3.591 1.707 8.818l5.173 4.018c1.298-3.858 4.889-6.65 9.12-6.65z" fill="#EA4335"/></g>'
	    },
	    history: {
	        path: 'M4.03074198,15 C4.54693838,6.62927028 11.4992947,0 20,0 C28.836556,0 36,7.163444 36,16 C36,24.836556 28.836556,32 20,32 C16.9814511,32 14.1581361,31.164104 11.7489039,29.7111608 L14.1120194,26.4586113 C15.8515127,27.4400159 17.8603607,28 20,28 C26.627417,28 32,22.627417 32,16 C32,9.372583 26.627417,4 20,4 C13.7093362,4 8.54922468,8.84046948 8.04107378,15 L11,15 L6,22 L1.34313965,15 L4.03074198,15 Z M22,15.2218254 L24.5913352,17.8131606 L24.5913352,17.8131606 C25.3723838,18.5942092 25.3723838,19.8605392 24.5913352,20.6415878 C23.8176686,21.4152544 22.5633071,21.4152544 21.7896404,20.6415878 C21.7852062,20.6371536 21.7807931,20.6326983 21.7764012,20.6282222 L18.8194549,17.6145768 C18.3226272,17.2506894 18,16.6630215 18,16 L18,10 C18,8.8954305 18.8954305,8 20,8 C21.1045695,8 22,8.8954305 22,10 L22,15.2218254 Z',
	        attrs: { viewBox: "0 0 36 33" }
	    },
	    info: 'M16 0 A16 16 0 0 1 16 32 A16 16 0 0 1 16 0 M19 15 L13 15 L13 26 L19 26 z M16 6 A3 3 0 0 0 16 12 A3 3 0 0 0 16 6',
	    infooutlined: 'M16 29c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16s5.82 13 13 13zm0 3C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm1.697-20h-4.185v14h4.185V12zm.432-3.834c0-.342-.067-.661-.203-.958a2.527 2.527 0 0 0-1.37-1.31 2.613 2.613 0 0 0-.992-.188c-.342 0-.661.062-.959.189a2.529 2.529 0 0 0-1.33 1.309c-.13.297-.195.616-.195.958 0 .334.065.646.196.939.13.292.31.549.54.77.23.22.492.395.79.526.297.13.616.196.958.196.351 0 .682-.066.992-.196.31-.13.583-.306.817-.527a2.47 2.47 0 0 0 .553-.77c.136-.292.203-.604.203-.938z',
	    int: {
	        path: 'M15.141,15.512 L14.294,20 L13.051,20 C12.8309989,20 12.6403341,19.9120009 12.479,19.736 C12.3176659,19.5599991 12.237,19.343668 12.237,19.087 C12.237,19.0503332 12.2388333,19.0155002 12.2425,18.9825 C12.2461667,18.9494998 12.2516666,18.9146668 12.259,18.878 L12.908,15.512 L10.653,15.512 L10.015,19.01 C9.94899967,19.3620018 9.79866784,19.6149992 9.564,19.769 C9.32933216,19.9230008 9.06900143,20 8.783,20 L7.584,20 L8.42,15.512 L7.155,15.512 C6.92033216,15.512 6.74066729,15.4551672 6.616,15.3415 C6.49133271,15.2278328 6.429,15.0390013 6.429,14.775 C6.429,14.6723328 6.43999989,14.5550007 6.462,14.423 L6.605,13.554 L8.695,13.554 L9.267,10.518 L6.913,10.518 L7.122,9.385 C7.17333359,9.10633194 7.28699912,8.89916734 7.463,8.7635 C7.63900088,8.62783266 7.92499802,8.56 8.321,8.56 L9.542,8.56 L10.224,5.018 C10.282667,4.7246652 10.4183323,4.49733414 10.631,4.336 C10.8436677,4.17466586 11.0929986,4.094 11.379,4.094 L12.611,4.094 L11.775,8.56 L14.019,8.56 L14.866,4.094 L16.076,4.094 C16.3326679,4.094 16.5416659,4.1673326 16.703,4.314 C16.8643341,4.4606674 16.945,4.64766553 16.945,4.875 C16.945,4.9483337 16.9413334,5.00333315 16.934,5.04 L16.252,8.56 L18.485,8.56 L18.276,9.693 C18.2246664,9.97166806 18.1091676,10.1788327 17.9295,10.3145 C17.7498324,10.4501673 17.4656686,10.518 17.077,10.518 L15.977,10.518 L15.416,13.554 L16.978,13.554 C17.2126678,13.554 17.3904994,13.6108328 17.5115,13.7245 C17.6325006,13.8381672 17.693,14.0306653 17.693,14.302 C17.693,14.4046672 17.6820001,14.5219993 17.66,14.654 L17.528,15.512 L15.141,15.512 Z M10.928,13.554 L13.183,13.554 L13.744,10.518 L11.5,10.518 L10.928,13.554 Z',
	        attrs: { viewBox: '0 0 24, 24' }
	    },
	    io: 'M1,9 L6,9 L6,24 L1,24 L1,9 Z M31,16 C31,11.581722 27.418278,8 23,8 C18.581722,8 15,11.581722 15,16 C15,20.418278 18.581722,24 23,24 C27.418278,24 31,20.418278 31,16 Z M19,16 C19,13.790861 20.790861,12 23,12 C25.209139,12 27,13.790861 27,16 C27,18.209139 25.209139,20 23,20 C20.790861,20 19,18.209139 19,16 Z M15.3815029,9 L13.4537572,9 L7,23.5 L8.92774566,23.5 L15.3815029,9 Z',
	    key: {
	        path: 'M11.5035746,7.9975248 C10.8617389,5.26208051 13.0105798,1.44695394 16.9897081,1.44695394 C20.919315,1.44695394 23.1811258,5.37076315 22.2565255,8.42469226 C21.3223229,7.86427598 20.2283376,7.54198814 19.0589133,7.54198814 C17.3567818,7.54198814 15.8144729,8.22477622 14.6920713,9.33083544 C14.4930673,9.31165867 14.2913185,9.30184676 14.087273,9.30184676 C10.654935,9.30184676 7.87247532,12.0782325 7.87247532,15.5030779 C7.87247532,17.1058665 8.48187104,18.5666337 9.48208198,19.6672763 L8.98356958,20.658345 L9.19925633,22.7713505 L7.5350473,23.4587525 C7.37507672,23.5248284 7.30219953,23.707739 7.37031308,23.8681037 L7.95501877,25.2447188 L6.28291833,25.7863476 C6.10329817,25.8445303 6.01548404,26.0233452 6.06755757,26.1919683 L6.54426059,27.7356153 L5.02460911,28.2609385 C4.86686602,28.3154681 4.7743984,28.501653 4.83652351,28.6704172 L6.04508836,31.95351 C6.10987939,32.1295162 6.29662279,32.2151174 6.46814592,32.160881 L9.48965349,31.2054672 C9.66187554,31.1510098 9.86840241,30.9790422 9.95250524,30.8208731 L14.8228902,21.6613229 C15.8820565,21.5366928 16.8596786,21.1462953 17.6869404,20.558796 C17.5652123,20.567429 17.4424042,20.5718139 17.318643,20.5718139 C14.2753735,20.5718139 11.8083161,17.9204625 11.8083161,14.6498548 C11.8083161,12.518229 12.8562751,10.6496514 14.428709,9.60671162 C13.4433608,10.7041074 12.8441157,12.1538355 12.8441157,13.7432193 C12.8441157,16.9974306 15.3562245,19.6661883 18.5509945,19.9240384 L19.1273026,21.5699573 L20.7971002,22.8826221 L20.1355191,24.5572635 C20.0719252,24.7182369 20.1528753,24.8977207 20.3155476,24.9601226 L21.7119724,25.4957977 L20.9400489,27.0748531 C20.8571275,27.2444782 20.9247553,27.4318616 21.082226,27.5115385 L22.5237784,28.2409344 L21.8460256,29.6990003 C21.7756734,29.8503507 21.8453702,30.0462011 22.0099247,30.1187455 L25.2111237,31.5300046 C25.3827397,31.6056621 25.5740388,31.5307937 25.6541745,31.3697345 L27.0658228,28.5325576 C27.1462849,28.3708422 27.1660474,28.1028205 27.1106928,27.9324485 L23.8023823,17.7500271 C24.7201964,16.6692906 25.273711,15.270754 25.273711,13.7432193 C25.273711,12.0364592 24.582689,10.4907436 23.4645818,9.36943333 C25.0880384,5.38579616 22.187534,0 16.9897081,0 C12.1196563,0 9.42801686,4.46934651 10.0266074,7.9975248 L11.5035746,7.9975248 Z M19.0589133,14.7767578 C20.203026,14.7767578 21.1305126,13.8512959 21.1305126,12.7096808 C21.1305126,11.5680656 20.203026,10.6426037 19.0589133,10.6426037 C17.9148007,10.6426037 16.9873141,11.5680656 16.9873141,12.7096808 C16.9873141,13.8512959 17.9148007,14.7767578 19.0589133,14.7767578 Z',
	        attrs: { fillRule: "evenodd" }
	    },
	    label: 'M14.577 31.042a2.005 2.005 0 0 1-2.738-.733L1.707 12.759c-.277-.477-.298-1.265-.049-1.757L6.45 1.537C6.7 1.044 7.35.67 7.9.7l10.593.582c.551.03 1.22.44 1.498.921l10.132 17.55a2.002 2.002 0 0 1-.734 2.737l-14.812 8.552zm.215-22.763a3.016 3.016 0 1 0-5.224 3.016 3.016 3.016 0 0 0 5.224-3.016z',
	    ldap: {
	        path: 'M1.006 3h13.702c.554 0 1.178.41 1.39.915l.363.874c.21.504.827.915 1.376.915h13.169c.54 0 .994.448.994 1.001v20.952a.99.99 0 0 1-.992 1H1.002c-.54 0-.993-.45-.993-1.005l-.01-23.646C0 3.446.45 3 1.007 3zM16.5 19.164c1.944 0 3.52-1.828 3.52-4.082 0-2.254-1.576-4.082-3.52-4.082-1.945 0-3.52 1.828-3.52 4.082 0 2.254 1.575 4.082 3.52 4.082zm6.5 4.665c0-1.872-1.157-3.521-2.913-4.484-.927.97-2.192 1.568-3.587 1.568s-2.66-.597-3.587-1.568C11.157 20.308 10 21.957 10 23.83h13z',
	        attrs: { fillRule: 'evenodd' }
	    },
	    left: "M21,0 L5,16 L21,32 L21,5.47117907e-13 L21,0 Z",
	    link: "M12.56 17.04c-1.08 1.384-1.303 1.963 1.755 4.04 3.058 2.076 7.29.143 8.587-1.062 1.404-1.304 4.81-4.697 7.567-7.842 2.758-3.144 1.338-8.238-.715-9.987-5.531-4.71-9.5-.554-11.088.773-2.606 2.176-5.207 5.144-5.207 5.144s1.747-.36 2.784 0c1.036.36 2.102.926 2.102.926l4.003-3.969s2.367-1.907 4.575 0 .674 4.404 0 5.189c-.674.784-6.668 6.742-6.668 6.742s-1.52.811-2.37.811c-.85 0-2.582-.528-2.582-.932 0-.405-1.665-1.22-2.744.166zm7.88-2.08c1.08-1.384 1.303-1.963-1.755-4.04-3.058-2.076-7.29-.143-8.587 1.062-1.404 1.304-4.81 4.697-7.567 7.842-2.758 3.144-1.338 8.238.715 9.987 5.531 4.71 9.5.554 11.088-.773 2.606-2.176 5.207-5.144 5.207-5.144s-1.747.36-2.784 0a17.379 17.379 0 0 1-2.102-.926l-4.003 3.969s-2.367 1.907-4.575 0-.674-4.404 0-5.189c.674-.784 6.668-6.742 6.668-6.742s1.52-.811 2.37-.811c.85 0 2.582.528 2.582.932 0 .405 1.665 1.22 2.744-.166z",
	    line: 'M18.867 16.377l-3.074-3.184-.08.077-.002-.002.01-.01-.53-.528-.066-.07-.001.002-2.071-2.072L-.002 23.645l2.668 2.668 10.377-10.377 3.074 3.183.08-.076.001.003-.008.008.5.501.094.097.002-.001 2.072 2.072L31.912 8.669 29.244 6 18.867 16.377z',
	    list: 'M3 8 A3 3 0 0 0 9 8 A3 3 0 0 0 3 8 M12 6 L28 6 L28 10 L12 10z M3 16 A3 3 0 0 0 9 16 A3 3 0 0 0 3 16 M12 14 L28 14 L28 18 L12 18z M3 24 A3 3 0 0 0 9 24 A3 3 0 0 0 3 24 M12 22 L28 22 L28 26 L12 26z',
	    location: {
	        path: 'M19.4917776,13.9890373 C20.4445763,12.5611169 21,10.8454215 21,9 C21,4.02943725 16.9705627,0 12,0 C7.02943725,0 3,4.02943725 3,9 C3,10.8454215 3.5554237,12.5611168 4.50822232,13.9890371 L4.49999986,14.0000004 L4.58010869,14.0951296 C4.91305602,14.5790657 5.29212089,15.0288088 5.71096065,15.4380163 L12.5,23.5 L19.4999993,13.9999996 L19.4917776,13.9890373 L19.4917776,13.9890373 Z M12,12 C13.6568542,12 15,10.6568542 15,9 C15,7.34314575 13.6568542,6 12,6 C10.3431458,6 9,7.34314575 9,9 C9,10.6568542 10.3431458,12 12,12 Z',
	        attrs: { viewBox: '0 0 24 24' }
	    },
	    lock: {
	        path: 'M7.30894737,12.4444444 L4.91725192,12.4444444 C3.2943422,12.4444444 2,13.7457504 2,15.3509926 L2,29.0934518 C2,30.7017608 3.30609817,32 4.91725192,32 L27.0827481,32 C28.7056578,32 30,30.6986941 30,29.0934518 L30,15.3509926 C30,13.7426837 28.6939018,12.4444444 27.0827481,12.4444444 L24.6910526,12.4444444 L24.6910526,7.44176009 C24.6910526,3.33441301 21.3568185,0 17.2438323,0 L14.7561677,0 C10.6398254,0 7.30894737,3.33178948 7.30894737,7.44176009 L7.30894737,12.4444444 Z M10.8678947,8.21027479 C10.8678947,5.65010176 12.9450109,3.57467145 15.5045167,3.57467145 L16.4954833,3.57467145 C19.0562189,3.57467145 21.1321053,5.65531119 21.1321053,8.21027479 L21.1321053,12.8458781 L10.8678947,12.8458781 L10.8678947,8.21027479 Z M16,26.6666667 C17.9329966,26.6666667 19.5,25.0747902 19.5,23.1111111 C19.5,21.147432 17.9329966,19.5555556 16,19.5555556 C14.0670034,19.5555556 12.5,21.147432 12.5,23.1111111 C12.5,25.0747902 14.0670034,26.6666667 16,26.6666667 Z',
	        attrs: { fillRule: "evenodd" }
	    },
	    lockoutline: 'M7 12H5.546A3.548 3.548 0 0 0 2 15.553v12.894A3.547 3.547 0 0 0 5.546 32h20.908C28.414 32 30 30.41 30 28.447V15.553A3.547 3.547 0 0 0 26.454 12H25V8.99C25 4.029 20.97 0 16 0c-4.972 0-9 4.025-9 8.99V12zm4-3.766c0-2.338 1.89-4.413 4.219-4.634L16 3.525l.781.075C19.111 3.82 21 5.896 21 8.234V12H11V8.234zm-5 9.537C6 16.793 6.796 16 7.775 16h16.45c.98 0 1.775.787 1.775 1.77v8.46c0 .977-.796 1.77-1.775 1.77H7.775A1.77 1.77 0 0 1 6 26.23v-8.46zM16 25a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
	    mail: {
	        path: 'M0 6 L16 16 L32 6 z M0 9 L0 26 L32 26 L32 9 L16 19 z',
	        attrs: { viewBox: '0 0 32 32' }
	    },
	    mine: 'M28.4907419,50 C25.5584999,53.6578499 21.0527692,56 16,56 C10.9472308,56 6.44150015,53.6578499 3.50925809,50 L28.4907419,50 Z M29.8594823,31.9999955 C27.0930063,27.217587 21.922257,24 16,24 C10.077743,24 4.9069937,27.217587 2.1405177,31.9999955 L29.8594849,32 Z M16,21 C19.8659932,21 23,17.1944204 23,12.5 C23,7.80557963 22,3 16,3 C10,3 9,7.80557963 9,12.5 C9,17.1944204 12.1340068,21 16,21 Z',
	    moon: 'M11.6291702,1.84239429e-11 C19.1234093,1.22958025 24.8413559,7.73631246 24.8413559,15.5785426 C24.8413559,24.2977683 17.7730269,31.3660972 9.05380131,31.3660972 C7.28632096,31.3660972 5.58667863,31.0756481 4,30.5398754 C11.5007933,28.2096945 16.9475786,21.2145715 16.9475786,12.9472835 C16.9475786,7.90001143 14.9174312,3.32690564 11.6291702,1.70246039e-11 L11.6291702,1.84239429e-11 Z',
	    move: 'M23.1253175,22.0483871 L15.3935224,22.0483871 L15.3935224,26.9516129 L23.1253175,26.9516129 L23.1253175,30.8741935 L31,24.0096774 L23.1253175,18.1258065 L23.1253175,22.0483871 L23.1253175,22.0483871 Z M17.5148597,5 L5.82641829,5 L5.82641829,27 L12.5834039,27 L12.5834039,32 L1,32 L1,0 L19.3006581,0 L28.0949312,9.19424889 L28.0949312,16.0165421 L23.2603172,16.0165421 L23.2603172,10.9520924 L17.5148597,5 Z',
	    number: 'M0 .503A.5.5 0 0 1 .503 0h30.994A.5.5 0 0 1 32 .503v30.994a.5.5 0 0 1-.503.503H.503A.5.5 0 0 1 0 31.497V.503zM8.272 22V10.8H6.464c-.064.427-.197.784-.4 1.072-.203.288-.45.52-.744.696a2.984 2.984 0 0 1-.992.368c-.368.07-.75.099-1.144.088v1.712H6V22h2.272zm2.96-5.648c0 1.12.11 2.056.328 2.808.219.752.515 1.352.888 1.8.373.448.808.768 1.304.96a4.327 4.327 0 0 0 1.576.288c.565 0 1.096-.096 1.592-.288a3.243 3.243 0 0 0 1.312-.96c.379-.448.677-1.048.896-1.8.219-.752.328-1.688.328-2.808 0-1.088-.11-2.003-.328-2.744-.219-.741-.517-1.336-.896-1.784a3.243 3.243 0 0 0-1.312-.96 4.371 4.371 0 0 0-1.592-.288c-.555 0-1.08.096-1.576.288-.496.192-.93.512-1.304.96-.373.448-.67 1.043-.888 1.784-.219.741-.328 1.656-.328 2.744zm2.272 0c0-.192.003-.424.008-.696.005-.272.024-.552.056-.84.032-.288.085-.573.16-.856a2.95 2.95 0 0 1 .312-.76 1.67 1.67 0 0 1 .512-.544c.208-.139.467-.208.776-.208.31 0 .57.07.784.208.213.139.39.32.528.544.139.224.243.477.312.76a7.8 7.8 0 0 1 .224 1.696 25.247 25.247 0 0 1-.024 1.856c-.021.453-.088.89-.2 1.312a2.754 2.754 0 0 1-.544 1.08c-.25.299-.61.448-1.08.448-.459 0-.81-.15-1.056-.448a2.815 2.815 0 0 1-.536-1.08 6.233 6.233 0 0 1-.2-1.312c-.021-.453-.032-.84-.032-1.16zm6.624 0c0 1.12.11 2.056.328 2.808.219.752.515 1.352.888 1.8.373.448.808.768 1.304.96a4.327 4.327 0 0 0 1.576.288c.565 0 1.096-.096 1.592-.288a3.243 3.243 0 0 0 1.312-.96c.379-.448.677-1.048.896-1.8.219-.752.328-1.688.328-2.808 0-1.088-.11-2.003-.328-2.744-.219-.741-.517-1.336-.896-1.784a3.243 3.243 0 0 0-1.312-.96 4.371 4.371 0 0 0-1.592-.288c-.555 0-1.08.096-1.576.288-.496.192-.93.512-1.304.96-.373.448-.67 1.043-.888 1.784-.219.741-.328 1.656-.328 2.744zm2.272 0c0-.192.003-.424.008-.696.005-.272.024-.552.056-.84.032-.288.085-.573.16-.856a2.95 2.95 0 0 1 .312-.76 1.67 1.67 0 0 1 .512-.544c.208-.139.467-.208.776-.208.31 0 .57.07.784.208.213.139.39.32.528.544.139.224.243.477.312.76a7.8 7.8 0 0 1 .224 1.696 25.247 25.247 0 0 1-.024 1.856c-.021.453-.088.89-.2 1.312a2.754 2.754 0 0 1-.544 1.08c-.25.299-.61.448-1.08.448-.459 0-.81-.15-1.056-.448a2.815 2.815 0 0 1-.536-1.08 6.233 6.233 0 0 1-.2-1.312c-.021-.453-.032-.84-.032-1.16z',
	    pencil: 'M4.7352182,19.1979208 L11.3429107,25.5873267 L24.069853,12.5293069 L17.4624587,6.1419802 L4.7352182,19.1979208 Z M9.63604523,27.3406931 L3.02805455,20.9509901 L0.238146568,29.9610891 L9.63604523,27.3406931 Z M23.4499066,0 L19.1734989,4.38653465 L25.7811914,10.7759406 L30.0575991,6.38732673 L23.4499066,0 Z',
	    permissionsLimited: 'M0,16 C0,7.163444 7.163444,0 16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 Z M29,16 C29,8.82029825 23.1797017,3 16,3 C8.82029825,3 3,8.82029825 3,16 C3,23.1797017 8.82029825,29 16,29 C23.1797017,29 29,23.1797017 29,16 Z M16,5 C11.0100706,5.11743299 5.14533409,7.90852303 5,15.5 C4.85466591,23.091477 11.0100706,26.882567 16,27 L16,5 Z',
	    pie: 'M15.181 15.435V.021a15.94 15.94 0 0 1 11.42 3.995l-11.42 11.42zm1.131 1.384H31.98a15.941 15.941 0 0 0-4.114-11.553L16.312 16.819zm15.438 2.013H13.168V.25C5.682 1.587 0 8.13 0 16c0 8.837 7.163 16 16 16 7.87 0 14.413-5.682 15.75-13.168z',
	    pinmap: 'M13.4 18.987v8.746L15.533 32l2.134-4.25v-8.763a10.716 10.716 0 0 1-4.267 0zm2.133-1.92a8.533 8.533 0 1 0 0-17.067 8.533 8.533 0 0 0 0 17.067z',
	    popular: 'M23.29 11.224l-7.067 7.067-2.658-2.752.007-.007-.386-.385-.126-.131-.003.002-1.789-1.79L.705 23.793A.994.994 0 0 0 .704 25.2l.896.897a1 1 0 0 0 1.408-.002l8.253-8.252 2.654 2.748.226-.218-.161.161 1.152 1.152c.64.64 1.668.636 2.304 0l8.158-8.159L32 19.933V5H17.067l6.223 6.224z',
	    recents: 'M15.689 17.292l-.689.344V6.992c0-.55.448-.992 1.001-.992h.907c.547 0 1.001.445 1.001.995v9.187l-.372.186 4.362 5.198a1.454 1.454 0 1 1-2.228 1.87L15 17.87l.689-.578zM16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z',
	    share: "M24.571 28.632H7.43V13.474h3.428v-3.369H4V32h24V10.105h-6.857v3.369h3.428v15.158zm-10.285-6.316h3.428V7.158h-3.428v15.158zm6.857-15.158H10.857L16 .42l5.143 6.737z",
	    sql: {
	        path: 'M4,0 L28,0 C30.209139,-4.05812251e-16 32,1.790861 32,4 L32,28 C32,30.209139 30.209139,32 28,32 L4,32 C1.790861,32 2.705415e-16,30.209139 0,28 L0,4 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 L4,0 Z M6,6 C4.8954305,6 4,6.8954305 4,8 L4,26 C4,27.1045695 4.8954305,28 6,28 L26,28 C27.1045695,28 28,27.1045695 28,26 L28,8 C28,6.8954305 27.1045695,6 26,6 L6,6 Z M14,20 L25,20 L25,24 L14,24 L14,20 Z M14,13.5 L8,17 L8,10 L14,13.5 Z',
	        attrs: { fillRule: 'evenodd' }
	    },
	    progress: {
	        path: 'M0 11.996A3.998 3.998 0 0 1 4.004 8h23.992A4 4 0 0 1 32 11.996v8.008A3.998 3.998 0 0 1 27.996 24H4.004A4 4 0 0 1 0 20.004v-8.008zM22 11h3.99A3.008 3.008 0 0 1 29 14v4c0 1.657-1.35 3-3.01 3H22V11z',
	        attrs: { fillRule: 'evenodd' }
	    },
	    sort: 'M14.615.683c.765-.926 2.002-.93 2.77 0L26.39 11.59c.765.927.419 1.678-.788 1.678H6.398c-1.2 0-1.557-.747-.788-1.678L14.615.683zm2.472 30.774c-.6.727-1.578.721-2.174 0l-9.602-11.63c-.6-.727-.303-1.316.645-1.316h20.088c.956 0 1.24.595.645 1.316l-9.602 11.63z',
	    sum: 'M3 27.41l1.984 4.422L27.895 32l.04-5.33-17.086-.125 8.296-9.457-.08-3.602L11.25 5.33H27.43V0H5.003L3.08 4.51l10.448 10.9z',
	    sync: 'M16 2 A14 14 0 0 0 2 16 A14 14 0 0 0 16 30 A14 14 0 0 0 26 26 L 23.25 23 A10 10 0 0 1 16 26 A10 10 0 0 1 6 16 A10 10 0 0 1 16 6 A10 10 0 0 1 23.25 9 L19 13 L30 13 L30 2 L26 6 A14 14 0 0 0 16 2',
	    question: "M16,32 C24.836556,32 32,24.836556 32,16 C32,7.163444 24.836556,0 16,0 C7.163444,0 0,7.163444 0,16 C0,24.836556 7.163444,32 16,32 L16,32 Z M16,29.0909091 C8.77009055,29.0909091 2.90909091,23.2299095 2.90909091,16 C2.90909091,8.77009055 8.77009055,2.90909091 16,2.90909091 C23.2299095,2.90909091 29.0909091,8.77009055 29.0909091,16 C29.0909091,23.2299095 23.2299095,29.0909091 16,29.0909091 Z M12,9.56020942 C12.2727286,9.34380346 12.5694087,9.1413622 12.8900491,8.95287958 C13.2106896,8.76439696 13.5552807,8.59860455 13.9238329,8.45549738 C14.2923851,8.31239021 14.6885728,8.20069848 15.1124079,8.12041885 C15.5362429,8.04013921 15.9950835,8 16.4889435,8 C17.1818216,8 17.8065083,8.08725916 18.3630221,8.2617801 C18.919536,8.43630105 19.3931184,8.68586225 19.7837838,9.0104712 C20.1744491,9.33508016 20.4748147,9.7260012 20.6848894,10.1832461 C20.8949642,10.6404909 21,11.1483393 21,11.7068063 C21,12.2373499 20.9226052,12.6963331 20.7678133,13.0837696 C20.6130213,13.4712061 20.4176916,13.8080265 20.1818182,14.0942408 C19.9459448,14.3804552 19.6861194,14.6282712 19.4023342,14.8376963 C19.1185489,15.0471215 18.8495099,15.2408368 18.5952088,15.4188482 C18.3409078,15.5968595 18.1197798,15.773123 17.9318182,15.947644 C17.7438566,16.1221649 17.6240789,16.3176254 17.5724816,16.5340314 L17.2628993,18 L14.9189189,18 L14.6756757,16.3141361 C14.6167073,15.9720751 14.653562,15.6736487 14.7862408,15.4188482 C14.9189196,15.1640476 15.1013502,14.9336834 15.3335381,14.7277487 C15.565726,14.521814 15.8255514,14.3263535 16.1130221,14.1413613 C16.4004928,13.9563691 16.6695319,13.7574182 16.9201474,13.5445026 C17.1707629,13.3315871 17.3826773,13.0942421 17.5558968,12.8324607 C17.7291163,12.5706793 17.8157248,12.2582915 17.8157248,11.895288 C17.8157248,11.4764377 17.6701489,11.1431077 17.3789926,10.895288 C17.0878364,10.6474682 16.6879632,10.5235602 16.1793612,10.5235602 C15.7886958,10.5235602 15.462532,10.5619542 15.20086,10.6387435 C14.9391879,10.7155327 14.7143744,10.8010466 14.5264128,10.895288 C14.3384511,10.9895293 14.1744479,11.0750432 14.034398,11.1518325 C13.8943482,11.2286217 13.7543005,11.2670157 13.6142506,11.2670157 C13.2972957,11.2670157 13.0614258,11.1378721 12.9066339,10.8795812 L12,9.56020942 Z M14,22 C14,21.7192968 14.0511359,21.4580909 14.1534091,21.2163743 C14.2556823,20.9746577 14.3958324,20.7641335 14.5738636,20.5847953 C14.7518948,20.4054572 14.96212,20.2631584 15.2045455,20.1578947 C15.4469709,20.0526311 15.7121198,20 16,20 C16.2803044,20 16.5416655,20.0526311 16.7840909,20.1578947 C17.0265164,20.2631584 17.2386355,20.4054572 17.4204545,20.5847953 C17.6022736,20.7641335 17.7443177,20.9746577 17.8465909,21.2163743 C17.9488641,21.4580909 18,21.7192968 18,22 C18,22.2807032 17.9488641,22.5438584 17.8465909,22.7894737 C17.7443177,23.0350889 17.6022736,23.2475625 17.4204545,23.4269006 C17.2386355,23.6062387 17.0265164,23.7465882 16.7840909,23.8479532 C16.5416655,23.9493182 16.2803044,24 16,24 C15.7121198,24 15.4469709,23.9493182 15.2045455,23.8479532 C14.96212,23.7465882 14.7518948,23.6062387 14.5738636,23.4269006 C14.3958324,23.2475625 14.2556823,23.0350889 14.1534091,22.7894737 C14.0511359,22.5438584 14,22.2807032 14,22 Z",
	    return: 'M15.3040432,11.8500793 C22.1434689,13.0450349 27.291257,18.2496116 27.291257,24.4890512 C27.291257,25.7084278 27.0946472,26.8882798 26.7272246,28.0064033 L26.7272246,28.0064033 C25.214579,22.4825472 20.8068367,18.2141694 15.3040432,17.0604596 L15.3040432,25.1841972 L4.70874296,14.5888969 L15.3040432,3.99359668 L15.3040432,3.99359668 L15.3040432,11.8500793 Z',
	    reference: {
	        path: 'M32 27.5V2a2 2 0 0 0-2-2H4a4 4 0 0 0-4 4v26a2 2 0 0 0 2 2h22V8H4V6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v19h4v2.5z',
	        attrs: { fillRule: 'evenodd' }
	    },
	    refresh: 'M16 2 A14 14 0 0 0 2 16 A14 14 0 0 0 16 30 A14 14 0 0 0 26 26 L 23.25 23 A10 10 0 0 1 16 26 A10 10 0 0 1 6 16 A10 10 0 0 1 16 6 A10 10 0 0 1 23.25 9 L19 13 L30 13 L30 2 L26 6 A14 14 0 0 0 16 2',
	    right: "M9,0 L25,16 L9,32 L9,5.47117907e-13 L9,0 Z",
	    ruler: 'M0.595961814,24.9588734 C-0.196619577,24.166292 -0.200005392,22.8846495 0.593926984,22.0907171 L22.0908075,0.593836573 C22.8822651,-0.197621013 24.1641442,-0.198948234 24.9589638,0.595871404 L31.4040382,7.04094576 C32.1966196,7.83352715 32.2000054,9.11516967 31.406073,9.90910205 L9.90919246,31.4059826 C9.11773487,32.1974402 7.83585581,32.1987674 7.04103617,31.4039478 L0.595961814,24.9588734 Z M17.8319792,7.8001489 L16.3988585,9.23326963 L18.548673,11.3830842 C18.9443414,11.7787526 18.9470387,12.4175604 18.5485351,12.816064 C18.1527906,13.2118086 17.5140271,13.2146738 17.1155553,12.816202 L14.9657407,10.6663874 L13.5326229,12.0995052 L15.6824375,14.2493198 C16.0781059,14.6449881 16.0808032,15.283796 15.6822996,15.6822996 C15.286555,16.0780441 14.6477916,16.0809094 14.2493198,15.6824375 L12.0995052,13.5326229 L10.6663845,14.9657436 C10.6670858,14.9664411 10.6677865,14.9671398 10.6684864,14.9678397 L14.2470828,18.5464361 C14.6439866,18.9433399 14.6476854,19.5831493 14.2491818,19.9816529 C13.8534373,20.3773974 13.2188552,20.384444 12.813965,19.9795538 L9.23536867,16.4009575 C9.23466875,16.4002576 9.23397006,16.3995569 9.2332726,16.3988555 L7.80015186,17.8319762 L9.94996646,19.9817908 C10.3456348,20.3774592 10.3483321,21.016267 9.94982851,21.4147706 C9.55408397,21.8105152 8.91532053,21.8133804 8.51684869,21.4149086 L6.3670341,19.265094 L4.93391633,20.6982118 L7.08373093,22.8480263 C7.47939928,23.2436947 7.48209658,23.8825026 7.08359298,24.2810062 C6.68784844,24.6767507 6.049085,24.6796159 5.65061316,24.2811441 L3.50079857,22.1313295 L2.02673458,23.6053935 L8.47576453,30.0544235 L30.0544235,8.47576453 L23.6053935,2.02673458 L22.1313295,3.50079857 L24.2811441,5.65061316 C24.6768125,6.04628152 24.6795098,6.68508938 24.2810062,7.08359298 C23.8852616,7.47933752 23.2464982,7.48220276 22.8480263,7.08373093 L20.6982118,4.93391633 L19.2650911,6.36703697 C19.2657924,6.36773446 19.2664931,6.36843318 19.267193,6.36913314 L22.8457894,9.94772948 C23.2426932,10.3446333 23.246392,10.9844427 22.8478884,11.3829463 C22.4521439,11.7786908 21.8175617,11.7857374 21.4126716,11.3808472 L17.8340753,7.8022509 C17.8333753,7.80155099 17.8326767,7.80085032 17.8319792,7.8001489 Z',
	    search: 'M12 0 A12 12 0 0 0 0 12 A12 12 0 0 0 12 24 A12 12 0 0 0 18.5 22.25 L28 32 L32 28 L22.25 18.5 A12 12 0 0 0 24 12 A12 12 0 0 0 12 0 M12 4 A8 8 0 0 1 12 20 A8 8 0 0 1 12 4  ',
	    segment: 'M2.99631547,14.0294075 L2.99631579,1.99517286 C2.99631582,0.893269315 3.89614282,0 4.98985651,0 L30.0064593,0 C31.1074614,0 32,0.895880847 32,2.00761243 L32,26.8688779 C32,27.9776516 31.1071386,28.8764903 30.0003242,28.8764903 L17.7266598,28.8764903 L17.7266594,14.0294075 L2.99631547,14.0294075 Z M-7.10651809e-15,16.9955967 L-7.10651809e-15,30.0075311 C-7.10651809e-15,31.1079413 0.900469916,32 2.00155906,32 L14.3949712,32 L14.3949712,16.9955967 L-7.10651809e-15,16.9955967 Z',
	    star: 'M16 0 L21 11 L32 12 L23 19 L26 31 L16 25 L6 31 L9 19 L0 12 L11 11',
	    staroutline: "M16 21.935l5.967 3.14-1.14-6.653 4.828-4.712-6.671-.97L16 6.685l-2.984 6.053-6.67.971 4.827 4.712-1.14 6.654L16 21.935zm-9.892 8.547l1.89-11.029L0 11.647l11.053-1.609L16 0l4.947 10.038L32 11.647l-7.997 7.806 1.889 11.03L16 25.274l-9.892 5.207z",
	    string: {
	        path: 'M14.022,18 L11.533,18 C11.2543319,18 11.0247509,17.935084 10.84425,17.80525 C10.6637491,17.675416 10.538667,17.5091677 10.469,17.3065 L9.652,14.8935 L4.389,14.8935 L3.572,17.3065 C3.50866635,17.4838342 3.38516758,17.6437493 3.2015,17.78625 C3.01783241,17.9287507 2.79300133,18 2.527,18 L0.019,18 L5.377,4.1585 L8.664,4.1585 L14.022,18 Z M5.13,12.7085 L8.911,12.7085 L7.638,8.918 C7.55566626,8.67733213 7.45908389,8.3939183 7.34825,8.06775 C7.23741611,7.7415817 7.12816721,7.3885019 7.0205,7.0085 C6.91916616,7.39483527 6.8146672,7.75266502 6.707,8.082 C6.5993328,8.41133498 6.49800047,8.69633213 6.403,8.937 L5.13,12.7085 Z M21.945,18 C21.6663319,18 21.4557507,17.9620004 21.31325,17.886 C21.1707493,17.8099996 21.0520005,17.6516679 20.957,17.411 L20.748,16.8695 C20.5009988,17.078501 20.2635011,17.2621659 20.0355,17.4205 C19.8074989,17.5788341 19.5715846,17.7134161 19.32775,17.82425 C19.0839154,17.9350839 18.8242514,18.0174164 18.54875,18.07125 C18.2732486,18.1250836 17.9676683,18.152 17.632,18.152 C17.1823311,18.152 16.7738352,18.0934173 16.4065,17.97625 C16.0391648,17.8590827 15.7272513,17.6865011 15.47075,17.4585 C15.2142487,17.2304989 15.016334,16.947085 14.877,16.60825 C14.737666,16.269415 14.668,15.8783355 14.668,15.435 C14.668,15.0866649 14.7566658,14.7288352 14.934,14.3615 C15.1113342,13.9941648 15.4184978,13.6600848 15.8555,13.35925 C16.2925022,13.0584152 16.8814963,12.8066677 17.6225,12.604 C18.3635037,12.4013323 19.297661,12.2873335 20.425,12.262 L20.425,11.844 C20.425,11.2676638 20.3062512,10.8512513 20.06875,10.59475 C19.8312488,10.3382487 19.4940022,10.21 19.057,10.21 C18.7086649,10.21 18.4236678,10.2479996 18.202,10.324 C17.9803322,10.4000004 17.7824175,10.4854995 17.60825,10.5805 C17.4340825,10.6755005 17.2646675,10.7609996 17.1,10.837 C16.9353325,10.9130004 16.7390011,10.951 16.511,10.951 C16.3083323,10.951 16.1357507,10.9019172 15.99325,10.80375 C15.8507493,10.7055828 15.7383337,10.5836674 15.656,10.438 L15.124,9.5165 C15.7193363,8.99083071 16.3795797,8.59975128 17.10475,8.34325 C17.8299203,8.08674872 18.6073292,7.9585 19.437,7.9585 C20.0323363,7.9585 20.5690809,8.05508237 21.04725,8.24825 C21.5254191,8.44141763 21.9307483,8.71058161 22.26325,9.05575 C22.5957517,9.40091839 22.8506658,9.81099763 23.028,10.286 C23.2053342,10.7610024 23.294,11.2803305 23.294,11.844 L23.294,18 L21.945,18 Z M18.563,16.2045 C18.9430019,16.2045 19.2754986,16.1380007 19.5605,16.005 C19.8455014,15.8719993 20.1336652,15.6566682 20.425,15.359 L20.425,13.991 C19.8359971,14.0163335 19.3515019,14.0669996 18.9715,14.143 C18.5914981,14.2190004 18.2906678,14.3139994 18.069,14.428 C17.8473322,14.5420006 17.6937504,14.6718326 17.60825,14.8175 C17.5227496,14.9631674 17.48,15.1214991 17.48,15.2925 C17.48,15.6281683 17.5718324,15.8640827 17.7555,16.00025 C17.9391676,16.1364173 18.2083316,16.2045 18.563,16.2045 L18.563,16.2045 Z',
	        attrs: { viewBox: '0 0 24 24' }
	    },
	    sun: 'M18.2857143,27.1999586 L18.2857143,29.7130168 C18.2857143,30.9760827 17.2711661,32 16,32 C14.7376349,32 13.7142857,30.9797942 13.7142857,29.7130168 L13.7142857,27.1999586 C14.4528227,27.3498737 15.2172209,27.4285714 16,27.4285714 C16.7827791,27.4285714 17.5471773,27.3498737 18.2857143,27.1999586 Z M13.7142857,4.80004141 L13.7142857,2.28698322 C13.7142857,1.02391726 14.7288339,0 16,0 C17.2623651,0 18.2857143,1.02020582 18.2857143,2.28698322 L18.2857143,4.80004141 C17.5471773,4.65012631 16.7827791,4.57142857 16,4.57142857 C15.2172209,4.57142857 14.4528227,4.65012631 13.7142857,4.80004141 Z M10.5518048,26.0488463 L8.93640145,27.9740091 C8.1245183,28.9415738 6.68916799,29.0738009 5.71539825,28.2567111 C4.74837044,27.4452784 4.62021518,26.0059593 5.43448399,25.0355515 L7.05102836,23.1090289 C8.00526005,24.3086326 9.1956215,25.3120077 10.5518048,26.0488463 Z M21.4481952,5.95115366 L23.0635986,4.02599087 C23.8754817,3.05842622 25.310832,2.92619908 26.2846018,3.74328891 C27.2516296,4.55472158 27.3797848,5.99404073 26.565516,6.96444852 L24.9489716,8.89097108 C23.9947399,7.69136735 22.8043785,6.68799226 21.4481952,5.95115366 Z M7.05102836,8.89097108 L5.43448399,6.96444852 C4.62260085,5.99688386 4.7416285,4.56037874 5.71539825,3.74328891 C6.68242605,2.93185624 8.12213263,3.05558308 8.93640145,4.02599087 L10.5518048,5.95115366 C9.1956215,6.68799226 8.00526005,7.69136735 7.05102836,8.89097108 Z M24.9489716,23.1090289 L26.565516,25.0355515 C27.3773992,26.0031161 27.2583715,27.4396213 26.2846018,28.2567111 C25.317574,29.0681438 23.8778674,28.9444169 23.0635986,27.9740091 L21.4481952,26.0488463 C22.8043785,25.3120077 23.9947399,24.3086326 24.9489716,23.1090289 Z M27.1999586,13.7142857 L29.7130168,13.7142857 C30.9760827,13.7142857 32,14.7288339 32,16 C32,17.2623651 30.9797942,18.2857143 29.7130168,18.2857143 L27.1999586,18.2857143 C27.3498737,17.5471773 27.4285714,16.7827791 27.4285714,16 C27.4285714,15.2172209 27.3498737,14.4528227 27.1999586,13.7142857 Z M4.80004141,18.2857143 L2.28698322,18.2857143 C1.02391726,18.2857143 2.7533531e-14,17.2711661 2.84217094e-14,16 C2.84217094e-14,14.7376349 1.02020582,13.7142857 2.28698322,13.7142857 L4.80004141,13.7142857 C4.65012631,14.4528227 4.57142857,15.2172209 4.57142857,16 C4.57142857,16.7827791 4.65012631,17.5471773 4.80004141,18.2857143 Z M16,22.8571429 C19.7870954,22.8571429 22.8571429,19.7870954 22.8571429,16 C22.8571429,12.2129046 19.7870954,9.14285714 16,9.14285714 C12.2129046,9.14285714 9.14285714,12.2129046 9.14285714,16 C9.14285714,19.7870954 12.2129046,22.8571429 16,22.8571429 Z',
	    table: 'M11.077 11.077h9.846v9.846h-9.846v-9.846zm11.077 11.077H32V32h-9.846v-9.846zm-11.077 0h9.846V32h-9.846v-9.846zM0 22.154h9.846V32H0v-9.846zM0 0h9.846v9.846H0V0zm0 11.077h9.846v9.846H0v-9.846zM22.154 0H32v9.846h-9.846V0zm0 11.077H32v9.846h-9.846v-9.846zM11.077 0h9.846v9.846h-9.846V0z',
	    table2: {
	        svg: '<g fill="currentcolor" fill-rule="evenodd"><path d="M10,19 L10,15 L3,15 L3,13 L10,13 L10,9 L12,9 L12,13 L20,13 L20,9 L22,9 L22,13 L29,13 L29,15 L22,15 L22,19 L29,19 L29,21 L22,21 L22,25 L20,25 L20,21 L12,21 L12,25 L10,25 L10,21 L3,21 L3,19 L10,19 L10,19 Z M12,19 L12,15 L20,15 L20,19 L12,19 Z M30.5,0 L32,0 L32,28 L30.5,28 L1.5,28 L0,28 L0,0 L1.5,0 L30.5,0 Z M29,3 L29,25 L3,25 L3,3 L29,3 Z M3,7 L29,7 L29,9 L3,9 L3,7 Z"></path></g>',
	        attrs: { viewBox: '0 0 32 28' }
	    },
	    tilde: 'M.018 22.856s-.627-7.417 5.456-10.293c6.416-3.033 12.638 2.01 15.885 2.01 2.09 0 4.067-1.105 4.067-4.483 0-.118 6.563-.086 6.563-.086s.338 5.151-2.756 8.403c-3.095 3.251-7.314 2.899-7.314 2.899s-2.686 0-6.353-1.543c-4.922-2.07-6.494-1.348-7.095-.969-.6.38-1.863 1.04-1.863 4.062H.018z',
	    trash: 'M4.31904507,29.7285487 C4.45843264,30.9830366 5.59537721,32 6.85726914,32 L20.5713023,32 C21.8337371,32 22.9701016,30.9833707 23.1095264,29.7285487 L25.1428571,11.4285714 L2.28571429,11.4285714 L4.31904507,29.7285487 L4.31904507,29.7285487 Z M6.85714286,4.57142857 L8.57142857,0 L18.8571429,0 L20.5714286,4.57142857 L25.1428571,4.57142857 C27.4285714,4.57142857 27.4285714,9.14285714 27.4285714,9.14285714 L13.7142857,9.14285714 L-1.0658141e-14,9.14285714 C-1.0658141e-14,9.14285714 -1.0658141e-14,4.57142857 2.28571429,4.57142857 L6.85714286,4.57142857 L6.85714286,4.57142857 Z M9.14285714,4.57142857 L18.2857143,4.57142857 L17.1428571,2.28571429 L10.2857143,2.28571429 L9.14285714,4.57142857 L9.14285714,4.57142857 Z',
	    unarchive: 'M18,7.95916837 L22.98085,7.97386236 L15.9779702,-0.00230793315 L9.02202984,7.93268248 L14,7.94736798 L14,22.8635899 L18,22.8635899 L18,7.95916837 Z M7,12.1176568 L0,12.1176568 L0,17.0882426 L3,17.0882426 L3,32 L29,32 L29,17.0882426 L32,17.0882426 L32,12.1176568 L25,12.1176568 L25,27.8341757 L7,27.8341757 L7,12.1176568 Z',
	    unknown: 'M16.5,26.5 C22.0228475,26.5 26.5,22.0228475 26.5,16.5 C26.5,10.9771525 22.0228475,6.5 16.5,6.5 C10.9771525,6.5 6.5,10.9771525 6.5,16.5 C6.5,22.0228475 10.9771525,26.5 16.5,26.5 L16.5,26.5 Z M16.5,23.5 C12.6340068,23.5 9.5,20.3659932 9.5,16.5 C9.5,12.6340068 12.6340068,9.5 16.5,9.5 C20.3659932,9.5 23.5,12.6340068 23.5,16.5 C23.5,20.3659932 20.3659932,23.5 16.5,23.5 L16.5,23.5 Z',
	    variable: 'M32,3.85760518 C32,5.35923081 31.5210404,6.55447236 30.5631068,7.4433657 C29.6051732,8.33225903 28.4358214,8.77669903 27.0550162,8.77669903 C26.2265331,8.77669903 25.4110072,8.67314019 24.6084142,8.46601942 C23.8058212,8.25889864 23.111114,8.05178097 22.5242718,7.84466019 C22.2481108,8.03452091 21.8425054,8.44875625 21.3074434,9.08737864 C20.7723814,9.72600104 20.1682882,10.5026923 19.4951456,11.4174757 C20.116508,14.0582656 20.6170423,15.9352695 20.9967638,17.0485437 C21.3764852,18.1618179 21.7389411,19.2880202 22.0841424,20.4271845 C22.3775635,21.3419679 22.8090586,22.0582498 23.3786408,22.5760518 C23.9482229,23.0938537 24.8457328,23.3527508 26.0711974,23.3527508 C26.5199591,23.3527508 27.0809028,23.2664518 27.7540453,23.0938511 C28.4271878,22.9212505 28.9795016,22.7486524 29.4110032,22.5760518 L28.8414239,24.9061489 C27.1326775,25.6310716 25.6397043,26.1574957 24.3624595,26.4854369 C23.0852148,26.8133781 21.9460676,26.9773463 20.9449838,26.9773463 C20.2200611,26.9773463 19.5037792,26.9083071 18.7961165,26.7702265 C18.0884539,26.632146 17.4412111,26.3818788 16.8543689,26.0194175 C16.2157465,25.6396961 15.6763776,25.1650514 15.236246,24.5954693 C14.7961143,24.0258871 14.4207135,23.2319361 14.1100324,22.2135922 C13.9029116,21.5749698 13.7130537,20.850058 13.5404531,20.038835 C13.3678524,19.2276119 13.1952544,18.51133 13.0226537,17.8899676 C12.5221118,18.6321504 12.1596559,19.1844642 11.9352751,19.5469256 C11.7108942,19.9093869 11.3829579,20.4185512 10.9514563,21.0744337 C9.5879112,23.1629015 8.4056145,24.6515597 7.40453074,25.5404531 C6.40344699,26.4293464 5.20389049,26.8737864 3.80582524,26.8737864 C2.75296129,26.8737864 1.85545139,26.5199604 1.11326861,25.8122977 C0.371085825,25.1046351 0,24.1812355 0,23.0420712 C0,21.5059254 0.478959612,20.2934241 1.4368932,19.4045307 C2.3948268,18.5156374 3.56417864,18.0711974 4.94498382,18.0711974 C5.77346693,18.0711974 6.56741799,18.1704413 7.32686084,18.368932 C8.08630369,18.5674228 8.80258563,18.7874853 9.47572816,19.0291262 C9.73462913,18.8220054 10.1359196,18.4164 10.6796117,17.8122977 C11.2233037,17.2081955 11.814452,16.4573939 12.4530744,15.5598706 C11.8834923,13.2470219 11.4174775,11.5037815 11.0550162,10.3300971 C10.6925548,9.15641269 10.321469,7.99137579 9.94174757,6.83495146 C9.63106641,5.90290796 9.18231146,5.18231107 8.59546926,4.67313916 C8.00862706,4.16396725 7.12837696,3.90938511 5.95469256,3.90938511 C5.43689061,3.90938511 4.85868712,3.99999909 4.22006472,4.18122977 C3.58144233,4.36246045 3.04638835,4.53074356 2.61488673,4.68608414 L3.18446602,2.35598706 C4.73787184,1.66558447 6.20927029,1.14779029 7.5987055,0.802588997 C8.98814071,0.457387702 10.1488627,0.284789644 11.0809061,0.284789644 C11.9266493,0.284789644 12.6515612,0.345198964 13.2556634,0.466019417 C13.8597657,0.586839871 14.4983785,0.845736958 15.171521,1.24271845 C15.7928834,1.62243987 16.3322523,2.10139948 16.789644,2.67961165 C17.2470357,3.25782382 17.6224365,4.04745994 17.9158576,5.04854369 C18.1229784,5.73894628 18.3128362,6.45522822 18.4854369,7.197411 C18.6580375,7.93959379 18.8047459,8.5782066 18.9255663,9.11326861 C19.2880277,8.56094654 19.6634285,7.99137294 20.0517799,7.40453074 C20.4401314,6.81768854 20.7723827,6.29989437 21.0485437,5.85113269 C22.3775687,3.76266485 23.5684953,2.2653767 24.6213592,1.3592233 C25.6742232,0.453069903 26.8651498,0 28.1941748,0 C29.2815588,0 30.1876986,0.358140971 30.9126214,1.07443366 C31.6375441,1.79072634 32,2.71844091 32,3.85760518 L32,3.85760518 Z',
	    viewArchive: {
	        path: 'M2.783 12.8h26.434V29H2.783V12.8zm6.956 3.4h12.522v2.6H9.739v-2.6zM0 4h32v6.4H0V4z',
	        attrs: { fillRule: "evenodd" }
	    },
	    warning: {
	        svg: '<g fill="currentcolor" fill-rule="evenodd"><path d="M10.9665007,4.7224988 C11.5372866,3.77118898 12.455761,3.75960159 13.0334993,4.7224988 L22.9665007,21.2775012 C23.5372866,22.228811 23.1029738,23 21.9950534,23 L2.00494659,23 C0.897645164,23 0.455760956,22.2403984 1.03349928,21.2775012 L10.9665007,4.7224988 Z M13.0184348,11.258 L13.0184348,14.69 C13.0184348,15.0580018 12.996435,15.4229982 12.9524348,15.785 C12.9084346,16.1470018 12.8504351,16.5159981 12.7784348,16.892 L11.5184348,16.892 C11.4464344,16.5159981 11.388435,16.1470018 11.3444348,15.785 C11.3004346,15.4229982 11.2784348,15.0580018 11.2784348,14.69 L11.2784348,11.258 L13.0184348,11.258 Z M11.0744348,19.058 C11.0744348,18.9139993 11.1014345,18.7800006 11.1554348,18.656 C11.2094351,18.5319994 11.2834343,18.4240005 11.3774348,18.332 C11.4714353,18.2399995 11.5824341,18.1670003 11.7104348,18.113 C11.8384354,18.0589997 11.978434,18.032 12.1304348,18.032 C12.2784355,18.032 12.4164341,18.0589997 12.5444348,18.113 C12.6724354,18.1670003 12.7844343,18.2399995 12.8804348,18.332 C12.9764353,18.4240005 13.0514345,18.5319994 13.1054348,18.656 C13.1594351,18.7800006 13.1864348,18.9139993 13.1864348,19.058 C13.1864348,19.2020007 13.1594351,19.3369994 13.1054348,19.463 C13.0514345,19.5890006 12.9764353,19.6979995 12.8804348,19.79 C12.7844343,19.8820005 12.6724354,19.9539997 12.5444348,20.006 C12.4164341,20.0580003 12.2784355,20.084 12.1304348,20.084 C11.978434,20.084 11.8384354,20.0580003 11.7104348,20.006 C11.5824341,19.9539997 11.4714353,19.8820005 11.3774348,19.79 C11.2834343,19.6979995 11.2094351,19.5890006 11.1554348,19.463 C11.1014345,19.3369994 11.0744348,19.2020007 11.0744348,19.058 Z"></path></g>',
	        attrs: { viewBox: '0 0 23 23' }
	    },
	    warning2: {
	        path: 'M12.3069589,4.52260192 C14.3462632,1.2440969 17.653446,1.24541073 19.691933,4.52260192 L31.2249413,23.0637415 C33.2642456,26.3422466 31.7889628,29 27.9115531,29 L4.08733885,29 C0.218100769,29 -1.26453645,26.3409327 0.77395061,23.0637415 L12.3069589,4.52260192 Z M18.0499318,23.0163223 C18.0499772,23.0222378 18.05,23.0281606 18.05,23.0340907 C18.05,23.3266209 17.9947172,23.6030345 17.8840476,23.8612637 C17.7737568,24.1186089 17.6195847,24.3426723 17.4224081,24.5316332 C17.2266259,24.7192578 16.998292,24.8660439 16.7389806,24.9713892 C16.4782454,25.0773129 16.1979962,25.1301134 15.9,25.1301134 C15.5950083,25.1301134 15.3111795,25.0774024 15.0502239,24.9713892 C14.7901813,24.8657469 14.5629613,24.7183609 14.3703047,24.5298034 C14.177545,24.3411449 14.0258626,24.1177208 13.9159524,23.8612637 C13.8052827,23.6030345 13.75,23.3266209 13.75,23.0340907 C13.75,22.7411889 13.8054281,22.4661013 13.9165299,22.2109786 C14.0264627,21.9585404 14.1779817,21.7374046 14.3703047,21.5491736 C14.5621821,21.3613786 14.7883231,21.2126553 15.047143,21.1034656 C15.3089445,20.9930181 15.593871,20.938068 15.9,20.938068 C16.1991423,20.938068 16.4804862,20.9931136 16.7420615,21.1034656 C17.0001525,21.2123478 17.2274115,21.360472 17.4224081,21.5473437 C17.6191428,21.7358811 17.7731504,21.957652 17.88347,22.2109786 C17.9124619,22.2775526 17.9376628,22.3454862 17.9590769,22.414741 C18.0181943,22.5998533 18.05,22.7963729 18.05,23 C18.05,23.0054459 18.0499772,23.0108867 18.0499318,23.0163223 L18.0499318,23.0163223 Z M17.7477272,14.1749999 L17.7477272,8.75 L14.1170454,8.75 L14.1170454,14.1749999 C14.1170454,14.8471841 14.1572355,15.5139742 14.2376219,16.1753351 C14.3174838,16.8323805 14.4227217,17.5019113 14.5533248,18.1839498 L14.5921937,18.3869317 L17.272579,18.3869317 L17.3114479,18.1839498 C17.442051,17.5019113 17.5472889,16.8323805 17.6271507,16.1753351 C17.7075371,15.5139742 17.7477272,14.8471841 17.7477272,14.1749999 Z',
	        attrs: { fillRule: "evenodd" }
	    },
	    x: 'm11.271709,16 l-3.19744231e-13,4.728291 l4.728291,0 l16,11.271709 l27.271709,2.39808173e-13 l32,4.728291 l20.728291,16 l31.1615012,26.4332102 l26.4332102,31.1615012 l16,20.728291 l5.56678976,31.1615012 l0.838498756,26.4332102 l11.271709,16 z',
	    zoom: 'M12.416 12.454V8.37h3.256v4.083h4.07v3.266h-4.07v4.083h-3.256V15.72h-4.07v-3.266h4.07zm10.389 13.28c-5.582 4.178-13.543 3.718-18.632-1.37-5.58-5.581-5.595-14.615-.031-20.179 5.563-5.563 14.597-5.55 20.178.031 5.068 5.068 5.545 12.985 1.422 18.563l5.661 5.661a2.08 2.08 0 0 1 .003 2.949 2.085 2.085 0 0 1-2.95-.003l-5.651-5.652zm-1.486-4.371c3.895-3.895 3.885-10.218-.021-14.125-3.906-3.906-10.23-3.916-14.125-.021-3.894 3.894-3.885 10.218.022 14.124 3.906 3.907 10.23 3.916 14.124.022z',
	    "slack": {
	        img: "app/assets/img/slack.png"
	    }
	};
	
	// $FlowFixMe
	ICON_PATHS["horizontal_bar"] = {
	    path: ICON_PATHS["bar"],
	    attrs: {
	        style: { transform: "rotate(90deg) scaleX(-1)" }
	    }
	};
	
	// $FlowFixMe
	ICON_PATHS["forwardArrow"] = {
	    path: ICON_PATHS["backArrow"],
	    attrs: {
	        style: { transform: "rotate(-180deg)" }
	    }
	};
	
	// $FlowFixMe
	ICON_PATHS["scalar"] = ICON_PATHS["number"];
	
	function loadIcon(name) {
	    var def = ICON_PATHS[name];
	    if (!def) {
	        console.warn('Icon "' + name + '" does not exist.');
	        return;
	    }
	
	    if (def.img) {
	        return _extends({}, def, { attrs: _extends({}, def.attrs, { className: 'Icon Icon-' + name }) });
	    }
	
	    var icon = {
	        attrs: {
	            className: 'Icon Icon-' + name,
	            width: '16px',
	            height: '16px',
	            viewBox: '0 0 32 32',
	            fill: 'currentcolor'
	        },
	        svg: undefined,
	        path: undefined
	    };
	
	    if (typeof def === 'string') {
	        icon.path = def;
	    } else if (def != null) {
	        var svg = def.svg,
	            path = def.path,
	            attrs = def.attrs;
	
	        for (var attr in attrs) {
	            icon.attrs[attr] = attrs[attr];
	        }
	        icon.path = path;
	        icon.svg = svg;
	    }
	
	    return icon;
	}

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tooltipify = function Tooltipify(ComposedComponent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_Component) {
	        _inherits(_class, _Component);
	
	        function _class() {
	            _classCallCheck(this, _class);
	
	            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	            key: "render",
	            value: function render() {
	                var _props = this.props,
	                    tooltip = _props.tooltip,
	                    props = _objectWithoutProperties(_props, ["tooltip"]);
	
	                if (tooltip) {
	                    return _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: tooltip },
	                        _react2.default.createElement(ComposedComponent, props)
	                    );
	                } else {
	                    return _react2.default.createElement(ComposedComponent, props);
	                }
	            }
	        }]);
	
	        return _class;
	    }(_react.Component), _class.displayName = "Tooltipify[" + (ComposedComponent.displayName || ComposedComponent.name) + "]", _temp;
	};
	
	exports.default = Tooltipify;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TestTooltipContent = exports.TestTooltipTarget = exports.TestTooltip = exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _class2, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TooltipPopover = __webpack_require__(912);
	
	var _TooltipPopover2 = _interopRequireDefault(_TooltipPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tooltip = (_temp = _class = function (_Component) {
	    _inherits(Tooltip, _Component);
	
	    function Tooltip(props, context) {
	        _classCallCheck(this, Tooltip);
	
	        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props, context));
	
	        _this._onMouseEnter = function (e) {
	            _this.setState({ isOpen: true, isHovered: true });
	        };
	
	        _this._onMouseLeave = function (e) {
	            _this.setState({ isOpen: false, isHovered: false });
	        };
	
	        _this._onMouseDown = function (e) {
	            _this.setState({ isOpen: false });
	        };
	
	        _this._onMouseUp = function (e) {
	            // This is in a timeout to ensure the component has a chance to fully unmount
	            _this.timer = setTimeout(function () {
	                return _this.setState({ isOpen: _this.state.isHovered });
	            }, 0);
	        };
	
	        _this.state = {
	            isOpen: false,
	            isHovered: false
	        };
	        return _this;
	    }
	
	    _createClass(Tooltip, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var elem = _reactDom2.default.findDOMNode(this);
	
	            elem.addEventListener("mouseenter", this._onMouseEnter, false);
	            elem.addEventListener("mouseleave", this._onMouseLeave, false);
	
	            // HACK: These two event listeners ensure that if a click on the child causes the tooltip to
	            // unmount (e.x. navigating away) then the popover is removed by the time this component
	            // unmounts. Previously we were seeing difficult to debug error messages like
	            // "Cannot read property 'componentDidUpdate' of null"
	            elem.addEventListener("mousedown", this._onMouseDown, true);
	            elem.addEventListener("mouseup", this._onMouseUp, true);
	
	            this._element = document.createElement('div');
	            this.componentDidUpdate();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var _props = this.props,
	                isEnabled = _props.isEnabled,
	                tooltip = _props.tooltip;
	
	            var isOpen = this.props.isOpen != null ? this.props.isOpen : this.state.isOpen;
	            if (tooltip && isEnabled && isOpen) {
	                _reactDom2.default.render(_react2.default.createElement(_TooltipPopover2.default, _extends({ isOpen: true, target: this }, this.props, { children: this.props.tooltip })), this._element);
	            } else {
	                _reactDom2.default.unmountComponentAtNode(this._element);
	            }
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            var elem = _reactDom2.default.findDOMNode(this);
	            elem.removeEventListener("mouseenter", this._onMouseEnter, false);
	            elem.removeEventListener("mouseleave", this._onMouseLeave, false);
	            elem.removeEventListener("mousedown", this._onMouseDown, true);
	            elem.removeEventListener("mouseup", this._onMouseUp, true);
	            _reactDom2.default.unmountComponentAtNode(this._element);
	            clearTimeout(this.timer);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.Children.only(this.props.children);
	        }
	    }]);
	
	    return Tooltip;
	}(_react.Component), _class.propTypes = {
	    tooltip: _propTypes2.default.node,
	    children: _propTypes2.default.element.isRequired,
	    isEnabled: _propTypes2.default.bool,
	    verticalAttachments: _propTypes2.default.array,
	    isOpen: _propTypes2.default.bool
	}, _class.defaultProps = {
	    isEnabled: true,
	    verticalAttachments: ["top", "bottom"]
	}, _temp);
	Tooltip.displayName = "Tooltip";
	exports.default = Tooltip;
	
	
	/**
	 * Modified version of Tooltip for Jest/Enzyme tests. Instead of manipulating the document root it
	 * renders the tooltip content (in TestTooltipContent) next to "children" / hover area (TestTooltipHoverArea).
	 *
	 * The test tooltip can only be toggled with `jestWrapper.simulate("mouseenter")` and `jestWrapper.simulate("mouseleave")`.
	 */
	var TestTooltip = exports.TestTooltip = (_temp2 = _class2 = function (_Component2) {
	    _inherits(TestTooltip, _Component2);
	
	    function TestTooltip(props, context) {
	        _classCallCheck(this, TestTooltip);
	
	        var _this2 = _possibleConstructorReturn(this, (TestTooltip.__proto__ || Object.getPrototypeOf(TestTooltip)).call(this, props, context));
	
	        _this2._onMouseEnter = function (e) {
	            _this2.setState({ isOpen: true, isHovered: true });
	        };
	
	        _this2._onMouseLeave = function (e) {
	            _this2.setState({ isOpen: false, isHovered: false });
	        };
	
	        _this2.state = {
	            isOpen: false,
	            isHovered: false
	        };
	        return _this2;
	    }
	
	    _createClass(TestTooltip, [{
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                isEnabled = _props2.isEnabled,
	                tooltip = _props2.tooltip;
	
	            var isOpen = this.props.isOpen != null ? this.props.isOpen : this.state.isOpen;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    TestTooltipTarget,
	                    {
	                        onMouseEnter: this._onMouseEnter,
	                        onMouseLeave: this._onMouseLeave
	                    },
	                    this.props.children
	                ),
	                tooltip && isEnabled && isOpen && _react2.default.createElement(
	                    TestTooltipContent,
	                    null,
	                    _react2.default.createElement(_TooltipPopover2.default, _extends({ isOpen: true, target: this }, this.props, { children: this.props.tooltip })),
	                    this.props.tooltip
	                )
	            );
	        }
	    }]);
	
	    return TestTooltip;
	}(_react.Component), _class2.propTypes = {
	    tooltip: _propTypes2.default.node,
	    children: _propTypes2.default.element.isRequired,
	    isEnabled: _propTypes2.default.bool,
	    verticalAttachments: _propTypes2.default.array,
	    isOpen: _propTypes2.default.bool
	}, _class2.defaultProps = {
	    isEnabled: true,
	    verticalAttachments: ["top", "bottom"]
	}, _temp2);
	TestTooltip.displayName = "TestTooltip";
	var TestTooltipTarget = exports.TestTooltipTarget = function TestTooltipTarget(_ref) {
	    var children = _ref.children,
	        onMouseEnter = _ref.onMouseEnter,
	        onMouseLeave = _ref.onMouseLeave;
	    return _react2.default.createElement(
	        "div",
	        { className: "test-tooltip-hover-area", onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
	        children
	    );
	};
	
	TestTooltipTarget.displayName = "TestTooltipTarget";
	var TestTooltipContent = exports.TestTooltipContent = function TestTooltipContent(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	        "div",
	        { className: "test-tooltip-content" },
	        children
	    );
	};
	TestTooltipContent.displayName = "TestTooltipContent";

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// if the tooltip is passed a long description we'll want to conditionally
	// format it to make it easier to read.
	// we use the number of words as an approximation
	var CONDITIONAL_WORD_COUNT = 10;
	
	var wordCount = function wordCount(string) {
	    return string.split(' ').length;
	};
	
	var TooltipPopover = function TooltipPopover(_ref) {
	    var children = _ref.children,
	        maxWidth = _ref.maxWidth,
	        props = _objectWithoutProperties(_ref, ["children", "maxWidth"]);
	
	    var popoverContent = void 0;
	
	    if (typeof children === "string") {
	        var needsSpace = wordCount(children) > CONDITIONAL_WORD_COUNT;
	        popoverContent = _react2.default.createElement(
	            "div",
	            {
	                className: (0, _classnames2.default)({ 'py1 px2': !needsSpace }, { 'py2 px3': needsSpace }),
	                style: {
	                    maxWidth: maxWidth || "12em",
	                    lineHeight: needsSpace ? 1.54 : 1
	                }
	            },
	            children
	        );
	    } else {
	        popoverContent = children;
	    }
	
	    return _react2.default.createElement(
	        _Popover2.default,
	        _extends({
	            className: "PopoverBody--tooltip",
	            targetOffsetY: 10
	        }, props),
	        popoverContent
	    );
	};
	
	TooltipPopover.displayName = "TooltipPopover";
	exports.default = (0, _pure2.default)(TooltipPopover);

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(914);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(922);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
	  return !(0, _shallowEqual2.default)(props, nextProps);
	});
	
	exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _class.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return _class;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _wrapDisplayName = __webpack_require__(916);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHelper = function createHelper(func, helperName) {
	  var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (false) {
	    if (noArgs) {
	      return function (BaseComponent) {
	        var Component = func(BaseComponent);
	        Component.displayName = (0, _wrapDisplayName2.default)(BaseComponent, helperName);
	        return Component;
	      };
	    }
	
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return function (BaseComponent) {
	        var Component = func.apply(undefined, args)(BaseComponent);
	        Component.displayName = (0, _wrapDisplayName2.default)(BaseComponent, helperName);
	        return Component;
	      };
	    };
	  }
	
	  return func;
	};
	
	exports.default = createHelper;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(917);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ }),
/* 917 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(919);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(920);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(921);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && (("production") === 'production' || !Component.propTypes));
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),
/* 921 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	};
	
	exports.default = isClassComponent;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(414);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TestPopover = exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(924);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _OnClickOutsideWrapper = __webpack_require__(933);
	
	var _OnClickOutsideWrapper2 = _interopRequireDefault(_OnClickOutsideWrapper);
	
	var _tether = __webpack_require__(935);
	
	var _tether2 = _interopRequireDefault(_tether);
	
	var _dom = __webpack_require__(859);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(936);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var POPOVER_TRANSITION_ENTER = 100;
	var POPOVER_TRANSITION_LEAVE = 100;
	
	var Popover = (_temp = _class = function (_Component) {
	    _inherits(Popover, _Component);
	
	    function Popover(props, context) {
	        _classCallCheck(this, Popover);
	
	        var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props, context));
	
	        _this.state = {
	            width: null,
	            height: null
	        };
	
	        _this.handleDismissal = _this.handleDismissal.bind(_this);
	        return _this;
	    }
	
	    _createClass(Popover, [{
	        key: "_getPopoverElement",
	        value: function _getPopoverElement() {
	            var _this2 = this;
	
	            if (!this._popoverElement) {
	                this._popoverElement = document.createElement('span');
	                this._popoverElement.className = 'PopoverContainer';
	                document.body.appendChild(this._popoverElement);
	                this._timer = setInterval(function () {
	                    var _popoverElement$getBo = _this2._popoverElement.getBoundingClientRect(),
	                        width = _popoverElement$getBo.width,
	                        height = _popoverElement$getBo.height;
	
	                    if (_this2.state.width !== width || _this2.state.height !== height) {
	                        _this2.setState({ width: width, height: height });
	                    }
	                }, 100);
	            }
	            return this._popoverElement;
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this._renderPopover(this.props.isOpen);
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this._renderPopover(this.props.isOpen);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            var _this3 = this;
	
	            if (this._tether) {
	                this._tether.destroy();
	                delete this._tether;
	            }
	            if (this._popoverElement) {
	                this._renderPopover(false);
	                setTimeout(function () {
	                    _reactDom2.default.unmountComponentAtNode(_this3._popoverElement);
	                    if (_this3._popoverElement.parentNode) {
	                        _this3._popoverElement.parentNode.removeChild(_this3._popoverElement);
	                    }
	                    clearInterval(_this3._timer);
	                    delete _this3._popoverElement, _this3._timer;
	                }, POPOVER_TRANSITION_LEAVE);
	            }
	        }
	    }, {
	        key: "handleDismissal",
	        value: function handleDismissal() {
	            if (this.props.onClose) {
	                var _props;
	
	                (_props = this.props).onClose.apply(_props, arguments);
	            }
	        }
	    }, {
	        key: "_popoverComponent",
	        value: function _popoverComponent() {
	            return _react2.default.createElement(
	                _OnClickOutsideWrapper2.default,
	                { handleDismissal: this.handleDismissal, dismissOnEscape: this.props.dismissOnEscape, dismissOnClickOutside: this.props.dismissOnClickOutside },
	                _react2.default.createElement(
	                    "div",
	                    {
	                        id: this.props.id,
	                        className: (0, _classnames2.default)("PopoverBody", { "PopoverBody--withArrow": this.props.hasArrow }, this.props.className),
	                        style: this.props.style
	                    },
	                    typeof this.props.children === "function" ? this.props.children() : this.props.children
	                )
	            );
	        }
	    }, {
	        key: "_setTetherOptions",
	        value: function _setTetherOptions(tetherOptions, o) {
	            if (o) {
	                tetherOptions = _extends({}, tetherOptions, {
	                    attachment: o.attachmentY + " " + o.attachmentX,
	                    targetAttachment: o.targetAttachmentY + " " + o.targetAttachmentX,
	                    targetOffset: o.offsetY + "px " + o.offsetX + "px"
	                });
	            }
	            if (this._tether) {
	                this._tether.setOptions(tetherOptions);
	            } else {
	                this._tether = new _tether2.default(tetherOptions);
	            }
	        }
	    }, {
	        key: "_getBestAttachmentOptions",
	        value: function _getBestAttachmentOptions(tetherOptions, options, attachments, offscreenProps, getAttachmentOptions) {
	            var _this4 = this;
	
	            var best = _extends({}, options);
	            var bestOffScreen = -Infinity;
	            // try each attachment until one is entirely on screen, or pick the least bad one
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                var _loop = function _loop() {
	                    var attachment = _step.value;
	
	                    // compute the options for this attachment position then set it
	                    var options = getAttachmentOptions(best, attachment);
	                    _this4._setTetherOptions(tetherOptions, options);
	
	                    // get bounds within *document*
	                    var elementRect = _tether2.default.Utils.getBounds(tetherOptions.element);
	
	                    // get bounds within *window*
	                    var doc = document.documentElement;
	                    var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
	                    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
	                    elementRect.top -= top;
	                    elementRect.bottom += top;
	                    elementRect.left -= left;
	                    elementRect.right += left;
	
	                    // test to see how much of the popover is off-screen
	                    var offScreen = offscreenProps.map(function (prop) {
	                        return Math.min(elementRect[prop], 0);
	                    }).reduce(function (a, b) {
	                        return a + b;
	                    });
	                    // if none then we're done, otherwise check to see if it's the best option so far
	                    if (offScreen === 0) {
	                        best = options;
	                        return "break";
	                    } else if (offScreen > bestOffScreen) {
	                        best = options;
	                        bestOffScreen = offScreen;
	                    }
	                };
	
	                for (var _iterator = attachments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _ret = _loop();
	
	                    if (_ret === "break") break;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return best;
	        }
	    }, {
	        key: "_renderPopover",
	        value: function _renderPopover(isOpen) {
	            var _this5 = this;
	
	            // popover is open, lets do this!
	            var popoverElement = this._getPopoverElement();
	            _reactDom2.default.unstable_renderSubtreeIntoContainer(this, _react2.default.createElement(
	                _reactAddonsCssTransitionGroup2.default,
	                {
	                    transitionName: "Popover",
	                    transitionAppear: true,
	                    transitionEnter: true,
	                    transitionLeave: true,
	                    transitionAppearTimeout: POPOVER_TRANSITION_ENTER,
	                    transitionEnterTimeout: POPOVER_TRANSITION_ENTER,
	                    transitionLeaveTimeout: POPOVER_TRANSITION_LEAVE
	                },
	                isOpen ? this._popoverComponent() : null
	            ), popoverElement);
	
	            if (isOpen) {
	                var tetherOptions = {};
	
	                tetherOptions.element = popoverElement;
	
	                if (this.props.targetEvent) {
	                    // create a fake element at the event coordinates
	                    tetherOptions.target = document.getElementById("popover-event-target");
	                    if (!tetherOptions.target) {
	                        tetherOptions.target = document.createElement("div");
	                        tetherOptions.target.id = "popover-event-target";
	                        document.body.appendChild(tetherOptions.target);
	                    }
	                    tetherOptions.target.style.left = this.props.targetEvent.clientX - 3 + "px";
	                    tetherOptions.target.style.top = this.props.targetEvent.clientY - 3 + "px";
	                } else if (this.props.target) {
	                    if (typeof this.props.target === "function") {
	                        tetherOptions.target = _reactDom2.default.findDOMNode(this.props.target());
	                    } else {
	                        tetherOptions.target = _reactDom2.default.findDOMNode(this.props.target);
	                    }
	                }
	                if (tetherOptions.target == null) {
	                    tetherOptions.target = _reactDom2.default.findDOMNode(this).parentNode;
	                }
	
	                if (this.props.tetherOptions) {
	                    this._setTetherOptions(_extends({}, tetherOptions, this.props.tetherOptions));
	                } else {
	                    if (!this._best || !this.props.pinInitialAttachment) {
	                        var best = {
	                            attachmentX: "center",
	                            attachmentY: "top",
	                            targetAttachmentX: "center",
	                            targetAttachmentY: "bottom",
	                            offsetX: 0,
	                            offsetY: 0
	                        };
	
	                        // horizontal
	                        best = this._getBestAttachmentOptions(tetherOptions, best, this.props.horizontalAttachments, ["left", "right"], function (best, attachmentX) {
	                            return _extends({}, best, {
	                                attachmentX: attachmentX,
	                                targetAttachmentX: "center",
	                                offsetX: { "center": 0, "left": -_this5.props.targetOffsetX, "right": _this5.props.targetOffsetX }[attachmentX]
	                            });
	                        });
	
	                        // vertical
	                        best = this._getBestAttachmentOptions(tetherOptions, best, this.props.verticalAttachments, ["top", "bottom"], function (best, attachmentY) {
	                            return _extends({}, best, {
	                                attachmentY: attachmentY,
	                                targetAttachmentY: attachmentY === "top" ? "bottom" : "top",
	                                offsetY: { "top": _this5.props.targetOffsetY, "bottom": -_this5.props.targetOffsetY }[attachmentY]
	                            });
	                        });
	
	                        this._best = best;
	                    }
	
	                    // finally set the best options
	                    this._setTetherOptions(tetherOptions, this._best);
	                }
	
	                if (this.props.sizeToFit) {
	                    var verticalPadding = 5;
	                    var body = tetherOptions.element.querySelector(".PopoverBody");
	                    if (this._tether.attachment.top === "top") {
	                        if ((0, _dom.constrainToScreen)(body, "bottom", verticalPadding)) {
	                            body.classList.add("scroll-y");
	                            body.classList.add("scroll-show");
	                        }
	                    } else if (this._tether.attachment.top === "bottom") {
	                        if ((0, _dom.constrainToScreen)(body, "top", verticalPadding)) {
	                            body.classList.add("scroll-y");
	                            body.classList.add("scroll-show");
	                        }
	                    }
	                }
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement("span", { className: "hide" });
	        }
	    }]);
	
	    return Popover;
	}(_react.Component), _class.propTypes = {
	    id: _propTypes2.default.string,
	    isOpen: _propTypes2.default.bool,
	    hasArrow: _propTypes2.default.bool,
	    // target: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
	    tetherOptions: _propTypes2.default.object,
	    sizeToFit: _propTypes2.default.bool,
	    pinInitialAttachment: _propTypes2.default.bool
	}, _class.defaultProps = {
	    isOpen: true,
	    hasArrow: true,
	    verticalAttachments: ["top", "bottom"],
	    horizontalAttachments: ["center", "left", "right"],
	    targetOffsetX: 24,
	    targetOffsetY: 5,
	    sizeToFit: false
	}, _temp);
	Popover.displayName = "Popover";
	exports.default = Popover;
	
	
	/**
	 * A modified version of TestPopover for Jest/Enzyme tests.
	 * Simply renders the popover body inline instead of mutating DOM root.
	 */
	var TestPopover = exports.TestPopover = function TestPopover(props) {
	    return props.isOpen === undefined || props.isOpen ? _react2.default.createElement(
	        _OnClickOutsideWrapper2.default,
	        {
	            handleDismissal: function handleDismissal() {
	                props.onClose && props.onClose.apply(props, arguments);
	            },
	            dismissOnEscape: props.dismissOnEscape,
	            dismissOnClickOutside: props.dismissOnClickOutside
	        },
	        _react2.default.createElement(
	            "div",
	            {
	                id: props.id,
	                className: (0, _classnames2.default)("TestPopover TestPopoverBody", props.className),
	                style: props.style
	                // because popover is normally directly attached to body element, other elements should not need
	                // to care about clicks that happen inside the popover
	                , onClick: function onClick(e) {
	                    e.stopPropagation();
	                }
	            },
	            typeof props.children === "function" ? props.children() : props.children
	        )
	    ) : null;
	};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(925);

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(301);
	var propTypesFactory = __webpack_require__(324);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var ReactTransitionGroup = __webpack_require__(926);
	var ReactCSSTransitionGroupChild = __webpack_require__(929);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	
	var ReactCSSTransitionGroup = function (_React$Component) {
	  _inherits(ReactCSSTransitionGroup, _React$Component);
	
	  function ReactCSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactCSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      // We need to provide this childFactory so that
	      // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	      // leave while it is leaving.
	      return React.createElement(ReactCSSTransitionGroupChild, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactCSSTransitionGroup.prototype.render = function render() {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return ReactCSSTransitionGroup;
	}(React.Component);
	
	ReactCSSTransitionGroup.displayName = 'ReactCSSTransitionGroup';
	ReactCSSTransitionGroup.propTypes = {
	  transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	  transitionAppear: PropTypes.bool,
	  transitionEnter: PropTypes.bool,
	  transitionLeave: PropTypes.bool,
	  transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	  transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	  transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	};
	ReactCSSTransitionGroup.defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	
	module.exports = ReactCSSTransitionGroup;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(301);
	var ReactTransitionChildMapping = __webpack_require__(927);
	
	var propTypesFactory = __webpack_require__(324);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var emptyFunction = __webpack_require__(310);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	
	var ReactTransitionGroup = function (_React$Component) {
	  _inherits(ReactTransitionGroup, _React$Component);
	
	  function ReactTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
	    }, _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    }, _this._handleDoneAppearing = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    }, _this._handleDoneEntering = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    }, _this._handleDoneLeaving = function (key) {
	      var component = _this.refs[key];
	
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _assign({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  ReactTransitionGroup.prototype.render = function render() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return ReactTransitionGroup;
	}(React.Component);
	
	ReactTransitionGroup.displayName = 'ReactTransitionGroup';
	ReactTransitionGroup.propTypes = {
	  component: PropTypes.any,
	  childFactory: PropTypes.func
	};
	ReactTransitionGroup.defaultProps = {
	  component: 'span',
	  childFactory: emptyFunction.thatReturnsArgument
	};
	
	
	module.exports = ReactTransitionGroup;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(928);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(315);
	var traverseAllChildren = __webpack_require__(313);
	var warning = __webpack_require__(309);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(423);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(301);
	var ReactAddonsDOMDependencies = __webpack_require__(930);
	
	var propTypesFactory = __webpack_require__(324);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var CSSCore = __webpack_require__(931);
	var ReactTransitionEvents = __webpack_require__(932);
	
	var onlyChild = __webpack_require__(329);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = function (_React$Component) {
	  _inherits(ReactCSSTransitionGroupChild, _React$Component);
	
	  function ReactCSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactCSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._isMounted = false, _this.transition = function (animationType, finishCallback, userSpecifiedDelay) {
	      var node = ReactAddonsDOMDependencies.getReactDOM().findDOMNode(_this);
	
	      if (!node) {
	        if (finishCallback) {
	          finishCallback();
	        }
	        return;
	      }
	
	      var className = _this.props.name[animationType] || _this.props.name + '-' + animationType;
	      var activeClassName = _this.props.name[animationType + 'Active'] || className + '-active';
	      var timeout = null;
	
	      var endListener = function (e) {
	        if (e && e.target !== node) {
	          return;
	        }
	
	        clearTimeout(timeout);
	
	        CSSCore.removeClass(node, className);
	        CSSCore.removeClass(node, activeClassName);
	
	        ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	        // Usually this optional callback is used for informing an owner of
	        // a leave animation and telling it to remove the child.
	        if (finishCallback) {
	          finishCallback();
	        }
	      };
	
	      CSSCore.addClass(node, className);
	
	      // Need to do this to actually trigger a transition.
	      _this.queueClassAndNode(activeClassName, node);
	
	      // If the user specified a timeout delay.
	      if (userSpecifiedDelay) {
	        // Clean-up the animation after the specified delay
	        timeout = setTimeout(endListener, userSpecifiedDelay);
	        _this.transitionTimeouts.push(timeout);
	      } else {
	        // DEPRECATED: this listener will be removed in a future version of react
	        ReactTransitionEvents.addEndEventListener(node, endListener);
	      }
	    }, _this.queueClassAndNode = function (className, node) {
	      _this.classNameAndNodeQueue.push({
	        className: className,
	        node: node
	      });
	
	      if (!_this.timeout) {
	        _this.timeout = setTimeout(_this.flushClassNameAndNodeQueue, TICK);
	      }
	    }, _this.flushClassNameAndNodeQueue = function () {
	      if (_this._isMounted) {
	        _this.classNameAndNodeQueue.forEach(function (obj) {
	          CSSCore.addClass(obj.node, obj.className);
	        });
	      }
	      _this.classNameAndNodeQueue.length = 0;
	      _this.timeout = null;
	    }, _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactCSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  ReactCSSTransitionGroupChild.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	  };
	
	  ReactCSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  ReactCSSTransitionGroupChild.prototype.render = function render() {
	    return onlyChild(this.props.children);
	  };
	
	  return ReactCSSTransitionGroupChild;
	}(React.Component);
	
	ReactCSSTransitionGroupChild.propTypes = {
	  name: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
	    enter: PropTypes.string,
	    leave: PropTypes.string,
	    active: PropTypes.string
	  }), PropTypes.shape({
	    enter: PropTypes.string,
	    enterActive: PropTypes.string,
	    leave: PropTypes.string,
	    leaveActive: PropTypes.string,
	    appear: PropTypes.string,
	    appearActive: PropTypes.string
	  })]).isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: PropTypes.bool,
	  enter: PropTypes.bool,
	  leave: PropTypes.bool,
	  appearTimeout: PropTypes.number,
	  enterTimeout: PropTypes.number,
	  leaveTimeout: PropTypes.number
	};
	
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(331);
	
	exports.getReactDOM = function () {
	  return ReactDOM;
	};
	
	if (false) {
	  var ReactPerf;
	  var ReactTestUtils;
	
	  exports.getReactPerf = function () {
	    if (!ReactPerf) {
	      ReactPerf = require('react-dom/lib/ReactPerf');
	    }
	    return ReactPerf;
	  };
	
	  exports.getReactTestUtils = function () {
	    if (!ReactTestUtils) {
	      ReactTestUtils = require('react-dom/lib/ReactTestUtils');
	    }
	    return ReactTestUtils;
	  };
	}

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(306);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(346);
	
	var getVendorPrefixedEventName = __webpack_require__(400);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keyboard = __webpack_require__(934);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// keep track of the order popovers were opened so we only close the last one when clicked outside
	var popoverStack = [];
	
	var OnClickOutsideWrapper = (_temp2 = _class = function (_Component) {
	    _inherits(OnClickOutsideWrapper, _Component);
	
	    function OnClickOutsideWrapper() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, OnClickOutsideWrapper);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OnClickOutsideWrapper.__proto__ || Object.getPrototypeOf(OnClickOutsideWrapper)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	            if (!_reactDom2.default.findDOMNode(_this).contains(e.target)) {
	                setTimeout(_this._handleDismissal, 0);
	            }
	        }, _this._handleKeyPress = function (e) {
	            if (e.keyCode === _keyboard.KEYCODE_ESCAPE) {
	                e.preventDefault();
	                _this._handleDismissal();
	            }
	        }, _this._handleDismissal = function (e) {
	            // only propagate event for the popover on top of the stack
	            if (_this === popoverStack[popoverStack.length - 1]) {
	                _this.props.handleDismissal(e);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(OnClickOutsideWrapper, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            // necessary to ignore click events that fire immediately, causing modals/popovers to close prematurely
	            this._timeout = setTimeout(function () {
	                popoverStack.push(_this2);
	
	                // HACK: set the z-index of the parent element to ensure it"s always on top
	                // NOTE: this actually doesn"t seem to be working correctly for popovers since PopoverBody creates a stacking context
	                _reactDom2.default.findDOMNode(_this2).parentNode.style.zIndex = popoverStack.length + 2; // HACK: add 2 to ensure it"s in front of main and nav elements
	
	                if (_this2.props.dismissOnEscape) {
	                    document.addEventListener("keydown", _this2._handleKeyPress, false);
	                }
	                if (_this2.props.dismissOnClickOutside) {
	                    window.addEventListener("mousedown", _this2._handleClick, true);
	                }
	            }, 0);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            var _this3 = this;
	
	            document.removeEventListener("keydown", this._handleKeyPress, false);
	            window.removeEventListener("mousedown", this._handleClick, true);
	            clearTimeout(this._timeout);
	
	            // remove from the stack after a delay, if it is removed through some other
	            // means this will happen too early causing parent modal to close
	            setTimeout(function () {
	                var index = popoverStack.indexOf(_this3);
	                if (index >= 0) {
	                    popoverStack.splice(index, 1);
	                }
	            }, 0);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.Children.only(this.props.children);
	        }
	    }]);
	
	    return OnClickOutsideWrapper;
	}(_react.Component), _class.propTypes = {
	    handleDismissal: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	    dismissOnClickOutside: true,
	    dismissOnEscape: true
	}, _temp2);
	OnClickOutsideWrapper.displayName = "OnClickOutsideWrapper";
	exports.default = OnClickOutsideWrapper;

/***/ }),
/* 934 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var KEYCODE_BACKSPACE = exports.KEYCODE_BACKSPACE = 8;
	var KEYCODE_TAB = exports.KEYCODE_TAB = 9;
	var KEYCODE_ENTER = exports.KEYCODE_ENTER = 13;
	var KEYCODE_ESCAPE = exports.KEYCODE_ESCAPE = 27;
	
	var KEYCODE_LEFT = exports.KEYCODE_LEFT = 37;
	var KEYCODE_UP = exports.KEYCODE_UP = 38;
	var KEYCODE_RIGHT = exports.KEYCODE_RIGHT = 39;
	var KEYCODE_DOWN = exports.KEYCODE_DOWN = 40;
	
	var KEYCODE_COMMA = exports.KEYCODE_COMMA = 188;
	var KEYCODE_FORWARD_SLASH = exports.KEYCODE_FORWARD_SLASH = 191;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! tether 1.4.0 */
	
	(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory(require, exports, module);
	  } else {
	    root.Tether = factory();
	  }
	}(this, function(require, exports, module) {
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var TetherBase = undefined;
	if (typeof TetherBase === 'undefined') {
	  TetherBase = { modules: [] };
	}
	
	var zeroElement = null;
	
	// Same as native getBoundingClientRect, except it takes into account parent <frame> offsets
	// if the element lies within a nested document (<frame> or <iframe>-like).
	function getActualBoundingClientRect(node) {
	  var boundingRect = node.getBoundingClientRect();
	
	  // The original object returned by getBoundingClientRect is immutable, so we clone it
	  // We can't use extend because the properties are not considered part of the object by hasOwnProperty in IE9
	  var rect = {};
	  for (var k in boundingRect) {
	    rect[k] = boundingRect[k];
	  }
	
	  if (node.ownerDocument !== document) {
	    var _frameElement = node.ownerDocument.defaultView.frameElement;
	    if (_frameElement) {
	      var frameRect = getActualBoundingClientRect(_frameElement);
	      rect.top += frameRect.top;
	      rect.bottom += frameRect.top;
	      rect.left += frameRect.left;
	      rect.right += frameRect.left;
	    }
	  }
	
	  return rect;
	}
	
	function getScrollParents(el) {
	  // In firefox if the el is inside an iframe with display: none; window.getComputedStyle() will return null;
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	  var computedStyle = getComputedStyle(el) || {};
	  var position = computedStyle.position;
	  var parents = [];
	
	  if (position === 'fixed') {
	    return [el];
	  }
	
	  var parent = el;
	  while ((parent = parent.parentNode) && parent && parent.nodeType === 1) {
	    var style = undefined;
	    try {
	      style = getComputedStyle(parent);
	    } catch (err) {}
	
	    if (typeof style === 'undefined' || style === null) {
	      parents.push(parent);
	      return parents;
	    }
	
	    var _style = style;
	    var overflow = _style.overflow;
	    var overflowX = _style.overflowX;
	    var overflowY = _style.overflowY;
	
	    if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
	      if (position !== 'absolute' || ['relative', 'absolute', 'fixed'].indexOf(style.position) >= 0) {
	        parents.push(parent);
	      }
	    }
	  }
	
	  parents.push(el.ownerDocument.body);
	
	  // If the node is within a frame, account for the parent window scroll
	  if (el.ownerDocument !== document) {
	    parents.push(el.ownerDocument.defaultView);
	  }
	
	  return parents;
	}
	
	var uniqueId = (function () {
	  var id = 0;
	  return function () {
	    return ++id;
	  };
	})();
	
	var zeroPosCache = {};
	var getOrigin = function getOrigin() {
	  // getBoundingClientRect is unfortunately too accurate.  It introduces a pixel or two of
	  // jitter as the user scrolls that messes with our ability to detect if two positions
	  // are equivilant or not.  We place an element at the top left of the page that will
	  // get the same jitter, so we can cancel the two out.
	  var node = zeroElement;
	  if (!node || !document.body.contains(node)) {
	    node = document.createElement('div');
	    node.setAttribute('data-tether-id', uniqueId());
	    extend(node.style, {
	      top: 0,
	      left: 0,
	      position: 'absolute'
	    });
	
	    document.body.appendChild(node);
	
	    zeroElement = node;
	  }
	
	  var id = node.getAttribute('data-tether-id');
	  if (typeof zeroPosCache[id] === 'undefined') {
	    zeroPosCache[id] = getActualBoundingClientRect(node);
	
	    // Clear the cache when this position call is done
	    defer(function () {
	      delete zeroPosCache[id];
	    });
	  }
	
	  return zeroPosCache[id];
	};
	
	function removeUtilElements() {
	  if (zeroElement) {
	    document.body.removeChild(zeroElement);
	  }
	  zeroElement = null;
	};
	
	function getBounds(el) {
	  var doc = undefined;
	  if (el === document) {
	    doc = document;
	    el = document.documentElement;
	  } else {
	    doc = el.ownerDocument;
	  }
	
	  var docEl = doc.documentElement;
	
	  var box = getActualBoundingClientRect(el);
	
	  var origin = getOrigin();
	
	  box.top -= origin.top;
	  box.left -= origin.left;
	
	  if (typeof box.width === 'undefined') {
	    box.width = document.body.scrollWidth - box.left - box.right;
	  }
	  if (typeof box.height === 'undefined') {
	    box.height = document.body.scrollHeight - box.top - box.bottom;
	  }
	
	  box.top = box.top - docEl.clientTop;
	  box.left = box.left - docEl.clientLeft;
	  box.right = doc.body.clientWidth - box.width - box.left;
	  box.bottom = doc.body.clientHeight - box.height - box.top;
	
	  return box;
	}
	
	function getOffsetParent(el) {
	  return el.offsetParent || document.documentElement;
	}
	
	var _scrollBarSize = null;
	function getScrollBarSize() {
	  if (_scrollBarSize) {
	    return _scrollBarSize;
	  }
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  inner.style.height = '200px';
	
	  var outer = document.createElement('div');
	  extend(outer.style, {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    pointerEvents: 'none',
	    visibility: 'hidden',
	    width: '200px',
	    height: '150px',
	    overflow: 'hidden'
	  });
	
	  outer.appendChild(inner);
	
	  document.body.appendChild(outer);
	
	  var widthContained = inner.offsetWidth;
	  outer.style.overflow = 'scroll';
	  var widthScroll = inner.offsetWidth;
	
	  if (widthContained === widthScroll) {
	    widthScroll = outer.clientWidth;
	  }
	
	  document.body.removeChild(outer);
	
	  var width = widthContained - widthScroll;
	
	  _scrollBarSize = { width: width, height: width };
	  return _scrollBarSize;
	}
	
	function extend() {
	  var out = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  var args = [];
	
	  Array.prototype.push.apply(args, arguments);
	
	  args.slice(1).forEach(function (obj) {
	    if (obj) {
	      for (var key in obj) {
	        if (({}).hasOwnProperty.call(obj, key)) {
	          out[key] = obj[key];
	        }
	      }
	    }
	  });
	
	  return out;
	}
	
	function removeClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    name.split(' ').forEach(function (cls) {
	      if (cls.trim()) {
	        el.classList.remove(cls);
	      }
	    });
	  } else {
	    var regex = new RegExp('(^| )' + name.split(' ').join('|') + '( |$)', 'gi');
	    var className = getClassName(el).replace(regex, ' ');
	    setClassName(el, className);
	  }
	}
	
	function addClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    name.split(' ').forEach(function (cls) {
	      if (cls.trim()) {
	        el.classList.add(cls);
	      }
	    });
	  } else {
	    removeClass(el, name);
	    var cls = getClassName(el) + (' ' + name);
	    setClassName(el, cls);
	  }
	}
	
	function hasClass(el, name) {
	  if (typeof el.classList !== 'undefined') {
	    return el.classList.contains(name);
	  }
	  var className = getClassName(el);
	  return new RegExp('(^| )' + name + '( |$)', 'gi').test(className);
	}
	
	function getClassName(el) {
	  // Can't use just SVGAnimatedString here since nodes within a Frame in IE have
	  // completely separately SVGAnimatedString base classes
	  if (el.className instanceof el.ownerDocument.defaultView.SVGAnimatedString) {
	    return el.className.baseVal;
	  }
	  return el.className;
	}
	
	function setClassName(el, className) {
	  el.setAttribute('class', className);
	}
	
	function updateClasses(el, add, all) {
	  // Of the set of 'all' classes, we need the 'add' classes, and only the
	  // 'add' classes to be set.
	  all.forEach(function (cls) {
	    if (add.indexOf(cls) === -1 && hasClass(el, cls)) {
	      removeClass(el, cls);
	    }
	  });
	
	  add.forEach(function (cls) {
	    if (!hasClass(el, cls)) {
	      addClass(el, cls);
	    }
	  });
	}
	
	var deferred = [];
	
	var defer = function defer(fn) {
	  deferred.push(fn);
	};
	
	var flush = function flush() {
	  var fn = undefined;
	  while (fn = deferred.pop()) {
	    fn();
	  }
	};
	
	var Evented = (function () {
	  function Evented() {
	    _classCallCheck(this, Evented);
	  }
	
	  _createClass(Evented, [{
	    key: 'on',
	    value: function on(event, handler, ctx) {
	      var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	      if (typeof this.bindings === 'undefined') {
	        this.bindings = {};
	      }
	      if (typeof this.bindings[event] === 'undefined') {
	        this.bindings[event] = [];
	      }
	      this.bindings[event].push({ handler: handler, ctx: ctx, once: once });
	    }
	  }, {
	    key: 'once',
	    value: function once(event, handler, ctx) {
	      this.on(event, handler, ctx, true);
	    }
	  }, {
	    key: 'off',
	    value: function off(event, handler) {
	      if (typeof this.bindings === 'undefined' || typeof this.bindings[event] === 'undefined') {
	        return;
	      }
	
	      if (typeof handler === 'undefined') {
	        delete this.bindings[event];
	      } else {
	        var i = 0;
	        while (i < this.bindings[event].length) {
	          if (this.bindings[event][i].handler === handler) {
	            this.bindings[event].splice(i, 1);
	          } else {
	            ++i;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'trigger',
	    value: function trigger(event) {
	      if (typeof this.bindings !== 'undefined' && this.bindings[event]) {
	        var i = 0;
	
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        while (i < this.bindings[event].length) {
	          var _bindings$event$i = this.bindings[event][i];
	          var handler = _bindings$event$i.handler;
	          var ctx = _bindings$event$i.ctx;
	          var once = _bindings$event$i.once;
	
	          var context = ctx;
	          if (typeof context === 'undefined') {
	            context = this;
	          }
	
	          handler.apply(context, args);
	
	          if (once) {
	            this.bindings[event].splice(i, 1);
	          } else {
	            ++i;
	          }
	        }
	      }
	    }
	  }]);
	
	  return Evented;
	})();
	
	TetherBase.Utils = {
	  getActualBoundingClientRect: getActualBoundingClientRect,
	  getScrollParents: getScrollParents,
	  getBounds: getBounds,
	  getOffsetParent: getOffsetParent,
	  extend: extend,
	  addClass: addClass,
	  removeClass: removeClass,
	  hasClass: hasClass,
	  updateClasses: updateClasses,
	  defer: defer,
	  flush: flush,
	  uniqueId: uniqueId,
	  Evented: Evented,
	  getScrollBarSize: getScrollBarSize,
	  removeUtilElements: removeUtilElements
	};
	/* globals TetherBase, performance */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x6, _x7, _x8) { var _again = true; _function: while (_again) { var object = _x6, property = _x7, receiver = _x8; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x6 = parent; _x7 = property; _x8 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (typeof TetherBase === 'undefined') {
	  throw new Error('You must include the utils.js file before tether.js');
	}
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getScrollParents = _TetherBase$Utils.getScrollParents;
	var getBounds = _TetherBase$Utils.getBounds;
	var getOffsetParent = _TetherBase$Utils.getOffsetParent;
	var extend = _TetherBase$Utils.extend;
	var addClass = _TetherBase$Utils.addClass;
	var removeClass = _TetherBase$Utils.removeClass;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	var flush = _TetherBase$Utils.flush;
	var getScrollBarSize = _TetherBase$Utils.getScrollBarSize;
	var removeUtilElements = _TetherBase$Utils.removeUtilElements;
	
	function within(a, b) {
	  var diff = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];
	
	  return a + diff >= b && b >= a - diff;
	}
	
	var transformKey = (function () {
	  if (typeof document === 'undefined') {
	    return '';
	  }
	  var el = document.createElement('div');
	
	  var transforms = ['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform'];
	  for (var i = 0; i < transforms.length; ++i) {
	    var key = transforms[i];
	    if (el.style[key] !== undefined) {
	      return key;
	    }
	  }
	})();
	
	var tethers = [];
	
	var position = function position() {
	  tethers.forEach(function (tether) {
	    tether.position(false);
	  });
	  flush();
	};
	
	function now() {
	  if (typeof performance !== 'undefined' && typeof performance.now !== 'undefined') {
	    return performance.now();
	  }
	  return +new Date();
	}
	
	(function () {
	  var lastCall = null;
	  var lastDuration = null;
	  var pendingTimeout = null;
	
	  var tick = function tick() {
	    if (typeof lastDuration !== 'undefined' && lastDuration > 16) {
	      // We voluntarily throttle ourselves if we can't manage 60fps
	      lastDuration = Math.min(lastDuration - 16, 250);
	
	      // Just in case this is the last event, remember to position just once more
	      pendingTimeout = setTimeout(tick, 250);
	      return;
	    }
	
	    if (typeof lastCall !== 'undefined' && now() - lastCall < 10) {
	      // Some browsers call events a little too frequently, refuse to run more than is reasonable
	      return;
	    }
	
	    if (pendingTimeout != null) {
	      clearTimeout(pendingTimeout);
	      pendingTimeout = null;
	    }
	
	    lastCall = now();
	    position();
	    lastDuration = now() - lastCall;
	  };
	
	  if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined') {
	    ['resize', 'scroll', 'touchmove'].forEach(function (event) {
	      window.addEventListener(event, tick);
	    });
	  }
	})();
	
	var MIRROR_LR = {
	  center: 'center',
	  left: 'right',
	  right: 'left'
	};
	
	var MIRROR_TB = {
	  middle: 'middle',
	  top: 'bottom',
	  bottom: 'top'
	};
	
	var OFFSET_MAP = {
	  top: 0,
	  left: 0,
	  middle: '50%',
	  center: '50%',
	  bottom: '100%',
	  right: '100%'
	};
	
	var autoToFixedAttachment = function autoToFixedAttachment(attachment, relativeToAttachment) {
	  var left = attachment.left;
	  var top = attachment.top;
	
	  if (left === 'auto') {
	    left = MIRROR_LR[relativeToAttachment.left];
	  }
	
	  if (top === 'auto') {
	    top = MIRROR_TB[relativeToAttachment.top];
	  }
	
	  return { left: left, top: top };
	};
	
	var attachmentToOffset = function attachmentToOffset(attachment) {
	  var left = attachment.left;
	  var top = attachment.top;
	
	  if (typeof OFFSET_MAP[attachment.left] !== 'undefined') {
	    left = OFFSET_MAP[attachment.left];
	  }
	
	  if (typeof OFFSET_MAP[attachment.top] !== 'undefined') {
	    top = OFFSET_MAP[attachment.top];
	  }
	
	  return { left: left, top: top };
	};
	
	function addOffset() {
	  var out = { top: 0, left: 0 };
	
	  for (var _len = arguments.length, offsets = Array(_len), _key = 0; _key < _len; _key++) {
	    offsets[_key] = arguments[_key];
	  }
	
	  offsets.forEach(function (_ref) {
	    var top = _ref.top;
	    var left = _ref.left;
	
	    if (typeof top === 'string') {
	      top = parseFloat(top, 10);
	    }
	    if (typeof left === 'string') {
	      left = parseFloat(left, 10);
	    }
	
	    out.top += top;
	    out.left += left;
	  });
	
	  return out;
	}
	
	function offsetToPx(offset, size) {
	  if (typeof offset.left === 'string' && offset.left.indexOf('%') !== -1) {
	    offset.left = parseFloat(offset.left, 10) / 100 * size.width;
	  }
	  if (typeof offset.top === 'string' && offset.top.indexOf('%') !== -1) {
	    offset.top = parseFloat(offset.top, 10) / 100 * size.height;
	  }
	
	  return offset;
	}
	
	var parseOffset = function parseOffset(value) {
	  var _value$split = value.split(' ');
	
	  var _value$split2 = _slicedToArray(_value$split, 2);
	
	  var top = _value$split2[0];
	  var left = _value$split2[1];
	
	  return { top: top, left: left };
	};
	var parseAttachment = parseOffset;
	
	var TetherClass = (function (_Evented) {
	  _inherits(TetherClass, _Evented);
	
	  function TetherClass(options) {
	    var _this = this;
	
	    _classCallCheck(this, TetherClass);
	
	    _get(Object.getPrototypeOf(TetherClass.prototype), 'constructor', this).call(this);
	    this.position = this.position.bind(this);
	
	    tethers.push(this);
	
	    this.history = [];
	
	    this.setOptions(options, false);
	
	    TetherBase.modules.forEach(function (module) {
	      if (typeof module.initialize !== 'undefined') {
	        module.initialize.call(_this);
	      }
	    });
	
	    this.position();
	  }
	
	  _createClass(TetherClass, [{
	    key: 'getClass',
	    value: function getClass() {
	      var key = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	      var classes = this.options.classes;
	
	      if (typeof classes !== 'undefined' && classes[key]) {
	        return this.options.classes[key];
	      } else if (this.options.classPrefix) {
	        return this.options.classPrefix + '-' + key;
	      } else {
	        return key;
	      }
	    }
	  }, {
	    key: 'setOptions',
	    value: function setOptions(options) {
	      var _this2 = this;
	
	      var pos = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	      var defaults = {
	        offset: '0 0',
	        targetOffset: '0 0',
	        targetAttachment: 'auto auto',
	        classPrefix: 'tether'
	      };
	
	      this.options = extend(defaults, options);
	
	      var _options = this.options;
	      var element = _options.element;
	      var target = _options.target;
	      var targetModifier = _options.targetModifier;
	
	      this.element = element;
	      this.target = target;
	      this.targetModifier = targetModifier;
	
	      if (this.target === 'viewport') {
	        this.target = document.body;
	        this.targetModifier = 'visible';
	      } else if (this.target === 'scroll-handle') {
	        this.target = document.body;
	        this.targetModifier = 'scroll-handle';
	      }
	
	      ['element', 'target'].forEach(function (key) {
	        if (typeof _this2[key] === 'undefined') {
	          throw new Error('Tether Error: Both element and target must be defined');
	        }
	
	        if (typeof _this2[key].jquery !== 'undefined') {
	          _this2[key] = _this2[key][0];
	        } else if (typeof _this2[key] === 'string') {
	          _this2[key] = document.querySelector(_this2[key]);
	        }
	      });
	
	      addClass(this.element, this.getClass('element'));
	      if (!(this.options.addTargetClasses === false)) {
	        addClass(this.target, this.getClass('target'));
	      }
	
	      if (!this.options.attachment) {
	        throw new Error('Tether Error: You must provide an attachment');
	      }
	
	      this.targetAttachment = parseAttachment(this.options.targetAttachment);
	      this.attachment = parseAttachment(this.options.attachment);
	      this.offset = parseOffset(this.options.offset);
	      this.targetOffset = parseOffset(this.options.targetOffset);
	
	      if (typeof this.scrollParents !== 'undefined') {
	        this.disable();
	      }
	
	      if (this.targetModifier === 'scroll-handle') {
	        this.scrollParents = [this.target];
	      } else {
	        this.scrollParents = getScrollParents(this.target);
	      }
	
	      if (!(this.options.enabled === false)) {
	        this.enable(pos);
	      }
	    }
	  }, {
	    key: 'getTargetBounds',
	    value: function getTargetBounds() {
	      if (typeof this.targetModifier !== 'undefined') {
	        if (this.targetModifier === 'visible') {
	          if (this.target === document.body) {
	            return { top: pageYOffset, left: pageXOffset, height: innerHeight, width: innerWidth };
	          } else {
	            var bounds = getBounds(this.target);
	
	            var out = {
	              height: bounds.height,
	              width: bounds.width,
	              top: bounds.top,
	              left: bounds.left
	            };
	
	            out.height = Math.min(out.height, bounds.height - (pageYOffset - bounds.top));
	            out.height = Math.min(out.height, bounds.height - (bounds.top + bounds.height - (pageYOffset + innerHeight)));
	            out.height = Math.min(innerHeight, out.height);
	            out.height -= 2;
	
	            out.width = Math.min(out.width, bounds.width - (pageXOffset - bounds.left));
	            out.width = Math.min(out.width, bounds.width - (bounds.left + bounds.width - (pageXOffset + innerWidth)));
	            out.width = Math.min(innerWidth, out.width);
	            out.width -= 2;
	
	            if (out.top < pageYOffset) {
	              out.top = pageYOffset;
	            }
	            if (out.left < pageXOffset) {
	              out.left = pageXOffset;
	            }
	
	            return out;
	          }
	        } else if (this.targetModifier === 'scroll-handle') {
	          var bounds = undefined;
	          var target = this.target;
	          if (target === document.body) {
	            target = document.documentElement;
	
	            bounds = {
	              left: pageXOffset,
	              top: pageYOffset,
	              height: innerHeight,
	              width: innerWidth
	            };
	          } else {
	            bounds = getBounds(target);
	          }
	
	          var style = getComputedStyle(target);
	
	          var hasBottomScroll = target.scrollWidth > target.clientWidth || [style.overflow, style.overflowX].indexOf('scroll') >= 0 || this.target !== document.body;
	
	          var scrollBottom = 0;
	          if (hasBottomScroll) {
	            scrollBottom = 15;
	          }
	
	          var height = bounds.height - parseFloat(style.borderTopWidth) - parseFloat(style.borderBottomWidth) - scrollBottom;
	
	          var out = {
	            width: 15,
	            height: height * 0.975 * (height / target.scrollHeight),
	            left: bounds.left + bounds.width - parseFloat(style.borderLeftWidth) - 15
	          };
	
	          var fitAdj = 0;
	          if (height < 408 && this.target === document.body) {
	            fitAdj = -0.00011 * Math.pow(height, 2) - 0.00727 * height + 22.58;
	          }
	
	          if (this.target !== document.body) {
	            out.height = Math.max(out.height, 24);
	          }
	
	          var scrollPercentage = this.target.scrollTop / (target.scrollHeight - height);
	          out.top = scrollPercentage * (height - out.height - fitAdj) + bounds.top + parseFloat(style.borderTopWidth);
	
	          if (this.target === document.body) {
	            out.height = Math.max(out.height, 24);
	          }
	
	          return out;
	        }
	      } else {
	        return getBounds(this.target);
	      }
	    }
	  }, {
	    key: 'clearCache',
	    value: function clearCache() {
	      this._cache = {};
	    }
	  }, {
	    key: 'cache',
	    value: function cache(k, getter) {
	      // More than one module will often need the same DOM info, so
	      // we keep a cache which is cleared on each position call
	      if (typeof this._cache === 'undefined') {
	        this._cache = {};
	      }
	
	      if (typeof this._cache[k] === 'undefined') {
	        this._cache[k] = getter.call(this);
	      }
	
	      return this._cache[k];
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var _this3 = this;
	
	      var pos = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	      if (!(this.options.addTargetClasses === false)) {
	        addClass(this.target, this.getClass('enabled'));
	      }
	      addClass(this.element, this.getClass('enabled'));
	      this.enabled = true;
	
	      this.scrollParents.forEach(function (parent) {
	        if (parent !== _this3.target.ownerDocument) {
	          parent.addEventListener('scroll', _this3.position);
	        }
	      });
	
	      if (pos) {
	        this.position();
	      }
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      var _this4 = this;
	
	      removeClass(this.target, this.getClass('enabled'));
	      removeClass(this.element, this.getClass('enabled'));
	      this.enabled = false;
	
	      if (typeof this.scrollParents !== 'undefined') {
	        this.scrollParents.forEach(function (parent) {
	          parent.removeEventListener('scroll', _this4.position);
	        });
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      var _this5 = this;
	
	      this.disable();
	
	      tethers.forEach(function (tether, i) {
	        if (tether === _this5) {
	          tethers.splice(i, 1);
	        }
	      });
	
	      // Remove any elements we were using for convenience from the DOM
	      if (tethers.length === 0) {
	        removeUtilElements();
	      }
	    }
	  }, {
	    key: 'updateAttachClasses',
	    value: function updateAttachClasses(elementAttach, targetAttach) {
	      var _this6 = this;
	
	      elementAttach = elementAttach || this.attachment;
	      targetAttach = targetAttach || this.targetAttachment;
	      var sides = ['left', 'top', 'bottom', 'right', 'middle', 'center'];
	
	      if (typeof this._addAttachClasses !== 'undefined' && this._addAttachClasses.length) {
	        // updateAttachClasses can be called more than once in a position call, so
	        // we need to clean up after ourselves such that when the last defer gets
	        // ran it doesn't add any extra classes from previous calls.
	        this._addAttachClasses.splice(0, this._addAttachClasses.length);
	      }
	
	      if (typeof this._addAttachClasses === 'undefined') {
	        this._addAttachClasses = [];
	      }
	      var add = this._addAttachClasses;
	
	      if (elementAttach.top) {
	        add.push(this.getClass('element-attached') + '-' + elementAttach.top);
	      }
	      if (elementAttach.left) {
	        add.push(this.getClass('element-attached') + '-' + elementAttach.left);
	      }
	      if (targetAttach.top) {
	        add.push(this.getClass('target-attached') + '-' + targetAttach.top);
	      }
	      if (targetAttach.left) {
	        add.push(this.getClass('target-attached') + '-' + targetAttach.left);
	      }
	
	      var all = [];
	      sides.forEach(function (side) {
	        all.push(_this6.getClass('element-attached') + '-' + side);
	        all.push(_this6.getClass('target-attached') + '-' + side);
	      });
	
	      defer(function () {
	        if (!(typeof _this6._addAttachClasses !== 'undefined')) {
	          return;
	        }
	
	        updateClasses(_this6.element, _this6._addAttachClasses, all);
	        if (!(_this6.options.addTargetClasses === false)) {
	          updateClasses(_this6.target, _this6._addAttachClasses, all);
	        }
	
	        delete _this6._addAttachClasses;
	      });
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      var _this7 = this;
	
	      var flushChanges = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	      // flushChanges commits the changes immediately, leave true unless you are positioning multiple
	      // tethers (in which case call Tether.Utils.flush yourself when you're done)
	
	      if (!this.enabled) {
	        return;
	      }
	
	      this.clearCache();
	
	      // Turn 'auto' attachments into the appropriate corner or edge
	      var targetAttachment = autoToFixedAttachment(this.targetAttachment, this.attachment);
	
	      this.updateAttachClasses(this.attachment, targetAttachment);
	
	      var elementPos = this.cache('element-bounds', function () {
	        return getBounds(_this7.element);
	      });
	
	      var width = elementPos.width;
	      var height = elementPos.height;
	
	      if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
	        var _lastSize = this.lastSize;
	
	        // We cache the height and width to make it possible to position elements that are
	        // getting hidden.
	        width = _lastSize.width;
	        height = _lastSize.height;
	      } else {
	        this.lastSize = { width: width, height: height };
	      }
	
	      var targetPos = this.cache('target-bounds', function () {
	        return _this7.getTargetBounds();
	      });
	      var targetSize = targetPos;
	
	      // Get an actual px offset from the attachment
	      var offset = offsetToPx(attachmentToOffset(this.attachment), { width: width, height: height });
	      var targetOffset = offsetToPx(attachmentToOffset(targetAttachment), targetSize);
	
	      var manualOffset = offsetToPx(this.offset, { width: width, height: height });
	      var manualTargetOffset = offsetToPx(this.targetOffset, targetSize);
	
	      // Add the manually provided offset
	      offset = addOffset(offset, manualOffset);
	      targetOffset = addOffset(targetOffset, manualTargetOffset);
	
	      // It's now our goal to make (element position + offset) == (target position + target offset)
	      var left = targetPos.left + targetOffset.left - offset.left;
	      var top = targetPos.top + targetOffset.top - offset.top;
	
	      for (var i = 0; i < TetherBase.modules.length; ++i) {
	        var _module2 = TetherBase.modules[i];
	        var ret = _module2.position.call(this, {
	          left: left,
	          top: top,
	          targetAttachment: targetAttachment,
	          targetPos: targetPos,
	          elementPos: elementPos,
	          offset: offset,
	          targetOffset: targetOffset,
	          manualOffset: manualOffset,
	          manualTargetOffset: manualTargetOffset,
	          scrollbarSize: scrollbarSize,
	          attachment: this.attachment
	        });
	
	        if (ret === false) {
	          return false;
	        } else if (typeof ret === 'undefined' || typeof ret !== 'object') {
	          continue;
	        } else {
	          top = ret.top;
	          left = ret.left;
	        }
	      }
	
	      // We describe the position three different ways to give the optimizer
	      // a chance to decide the best possible way to position the element
	      // with the fewest repaints.
	      var next = {
	        // It's position relative to the page (absolute positioning when
	        // the element is a child of the body)
	        page: {
	          top: top,
	          left: left
	        },
	
	        // It's position relative to the viewport (fixed positioning)
	        viewport: {
	          top: top - pageYOffset,
	          bottom: pageYOffset - top - height + innerHeight,
	          left: left - pageXOffset,
	          right: pageXOffset - left - width + innerWidth
	        }
	      };
	
	      var doc = this.target.ownerDocument;
	      var win = doc.defaultView;
	
	      var scrollbarSize = undefined;
	      if (win.innerHeight > doc.documentElement.clientHeight) {
	        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
	        next.viewport.bottom -= scrollbarSize.height;
	      }
	
	      if (win.innerWidth > doc.documentElement.clientWidth) {
	        scrollbarSize = this.cache('scrollbar-size', getScrollBarSize);
	        next.viewport.right -= scrollbarSize.width;
	      }
	
	      if (['', 'static'].indexOf(doc.body.style.position) === -1 || ['', 'static'].indexOf(doc.body.parentElement.style.position) === -1) {
	        // Absolute positioning in the body will be relative to the page, not the 'initial containing block'
	        next.page.bottom = doc.body.scrollHeight - top - height;
	        next.page.right = doc.body.scrollWidth - left - width;
	      }
	
	      if (typeof this.options.optimizations !== 'undefined' && this.options.optimizations.moveElement !== false && !(typeof this.targetModifier !== 'undefined')) {
	        (function () {
	          var offsetParent = _this7.cache('target-offsetparent', function () {
	            return getOffsetParent(_this7.target);
	          });
	          var offsetPosition = _this7.cache('target-offsetparent-bounds', function () {
	            return getBounds(offsetParent);
	          });
	          var offsetParentStyle = getComputedStyle(offsetParent);
	          var offsetParentSize = offsetPosition;
	
	          var offsetBorder = {};
	          ['Top', 'Left', 'Bottom', 'Right'].forEach(function (side) {
	            offsetBorder[side.toLowerCase()] = parseFloat(offsetParentStyle['border' + side + 'Width']);
	          });
	
	          offsetPosition.right = doc.body.scrollWidth - offsetPosition.left - offsetParentSize.width + offsetBorder.right;
	          offsetPosition.bottom = doc.body.scrollHeight - offsetPosition.top - offsetParentSize.height + offsetBorder.bottom;
	
	          if (next.page.top >= offsetPosition.top + offsetBorder.top && next.page.bottom >= offsetPosition.bottom) {
	            if (next.page.left >= offsetPosition.left + offsetBorder.left && next.page.right >= offsetPosition.right) {
	              // We're within the visible part of the target's scroll parent
	              var scrollTop = offsetParent.scrollTop;
	              var scrollLeft = offsetParent.scrollLeft;
	
	              // It's position relative to the target's offset parent (absolute positioning when
	              // the element is moved to be a child of the target's offset parent).
	              next.offset = {
	                top: next.page.top - offsetPosition.top + scrollTop - offsetBorder.top,
	                left: next.page.left - offsetPosition.left + scrollLeft - offsetBorder.left
	              };
	            }
	          }
	        })();
	      }
	
	      // We could also travel up the DOM and try each containing context, rather than only
	      // looking at the body, but we're gonna get diminishing returns.
	
	      this.move(next);
	
	      this.history.unshift(next);
	
	      if (this.history.length > 3) {
	        this.history.pop();
	      }
	
	      if (flushChanges) {
	        flush();
	      }
	
	      return true;
	    }
	
	    // THE ISSUE
	  }, {
	    key: 'move',
	    value: function move(pos) {
	      var _this8 = this;
	
	      if (!(typeof this.element.parentNode !== 'undefined')) {
	        return;
	      }
	
	      var same = {};
	
	      for (var type in pos) {
	        same[type] = {};
	
	        for (var key in pos[type]) {
	          var found = false;
	
	          for (var i = 0; i < this.history.length; ++i) {
	            var point = this.history[i];
	            if (typeof point[type] !== 'undefined' && !within(point[type][key], pos[type][key])) {
	              found = true;
	              break;
	            }
	          }
	
	          if (!found) {
	            same[type][key] = true;
	          }
	        }
	      }
	
	      var css = { top: '', left: '', right: '', bottom: '' };
	
	      var transcribe = function transcribe(_same, _pos) {
	        var hasOptimizations = typeof _this8.options.optimizations !== 'undefined';
	        var gpu = hasOptimizations ? _this8.options.optimizations.gpu : null;
	        if (gpu !== false) {
	          var yPos = undefined,
	              xPos = undefined;
	          if (_same.top) {
	            css.top = 0;
	            yPos = _pos.top;
	          } else {
	            css.bottom = 0;
	            yPos = -_pos.bottom;
	          }
	
	          if (_same.left) {
	            css.left = 0;
	            xPos = _pos.left;
	          } else {
	            css.right = 0;
	            xPos = -_pos.right;
	          }
	
	          if (window.matchMedia) {
	            // HubSpot/tether#207
	            var retina = window.matchMedia('only screen and (min-resolution: 1.3dppx)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3)').matches;
	            if (!retina) {
	              xPos = Math.round(xPos);
	              yPos = Math.round(yPos);
	            }
	          }
	
	          css[transformKey] = 'translateX(' + xPos + 'px) translateY(' + yPos + 'px)';
	
	          if (transformKey !== 'msTransform') {
	            // The Z transform will keep this in the GPU (faster, and prevents artifacts),
	            // but IE9 doesn't support 3d transforms and will choke.
	            css[transformKey] += " translateZ(0)";
	          }
	        } else {
	          if (_same.top) {
	            css.top = _pos.top + 'px';
	          } else {
	            css.bottom = _pos.bottom + 'px';
	          }
	
	          if (_same.left) {
	            css.left = _pos.left + 'px';
	          } else {
	            css.right = _pos.right + 'px';
	          }
	        }
	      };
	
	      var moved = false;
	      if ((same.page.top || same.page.bottom) && (same.page.left || same.page.right)) {
	        css.position = 'absolute';
	        transcribe(same.page, pos.page);
	      } else if ((same.viewport.top || same.viewport.bottom) && (same.viewport.left || same.viewport.right)) {
	        css.position = 'fixed';
	        transcribe(same.viewport, pos.viewport);
	      } else if (typeof same.offset !== 'undefined' && same.offset.top && same.offset.left) {
	        (function () {
	          css.position = 'absolute';
	          var offsetParent = _this8.cache('target-offsetparent', function () {
	            return getOffsetParent(_this8.target);
	          });
	
	          if (getOffsetParent(_this8.element) !== offsetParent) {
	            defer(function () {
	              _this8.element.parentNode.removeChild(_this8.element);
	              offsetParent.appendChild(_this8.element);
	            });
	          }
	
	          transcribe(same.offset, pos.offset);
	          moved = true;
	        })();
	      } else {
	        css.position = 'absolute';
	        transcribe({ top: true, left: true }, pos.page);
	      }
	
	      if (!moved) {
	        if (this.options.bodyElement) {
	          this.options.bodyElement.appendChild(this.element);
	        } else {
	          var offsetParentIsBody = true;
	          var currentNode = this.element.parentNode;
	          while (currentNode && currentNode.nodeType === 1 && currentNode.tagName !== 'BODY') {
	            if (getComputedStyle(currentNode).position !== 'static') {
	              offsetParentIsBody = false;
	              break;
	            }
	
	            currentNode = currentNode.parentNode;
	          }
	
	          if (!offsetParentIsBody) {
	            this.element.parentNode.removeChild(this.element);
	            this.element.ownerDocument.body.appendChild(this.element);
	          }
	        }
	      }
	
	      // Any css change will trigger a repaint, so let's avoid one if nothing changed
	      var writeCSS = {};
	      var write = false;
	      for (var key in css) {
	        var val = css[key];
	        var elVal = this.element.style[key];
	
	        if (elVal !== val) {
	          write = true;
	          writeCSS[key] = val;
	        }
	      }
	
	      if (write) {
	        defer(function () {
	          extend(_this8.element.style, writeCSS);
	          _this8.trigger('repositioned');
	        });
	      }
	    }
	  }]);
	
	  return TetherClass;
	})(Evented);
	
	TetherClass.modules = [];
	
	TetherBase.position = position;
	
	var Tether = extend(TetherClass, TetherBase);
	/* globals TetherBase */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getBounds = _TetherBase$Utils.getBounds;
	var extend = _TetherBase$Utils.extend;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	
	var BOUNDS_FORMAT = ['left', 'top', 'right', 'bottom'];
	
	function getBoundingRect(tether, to) {
	  if (to === 'scrollParent') {
	    to = tether.scrollParents[0];
	  } else if (to === 'window') {
	    to = [pageXOffset, pageYOffset, innerWidth + pageXOffset, innerHeight + pageYOffset];
	  }
	
	  if (to === document) {
	    to = to.documentElement;
	  }
	
	  if (typeof to.nodeType !== 'undefined') {
	    (function () {
	      var node = to;
	      var size = getBounds(to);
	      var pos = size;
	      var style = getComputedStyle(to);
	
	      to = [pos.left, pos.top, size.width + pos.left, size.height + pos.top];
	
	      // Account any parent Frames scroll offset
	      if (node.ownerDocument !== document) {
	        var win = node.ownerDocument.defaultView;
	        to[0] += win.pageXOffset;
	        to[1] += win.pageYOffset;
	        to[2] += win.pageXOffset;
	        to[3] += win.pageYOffset;
	      }
	
	      BOUNDS_FORMAT.forEach(function (side, i) {
	        side = side[0].toUpperCase() + side.substr(1);
	        if (side === 'Top' || side === 'Left') {
	          to[i] += parseFloat(style['border' + side + 'Width']);
	        } else {
	          to[i] -= parseFloat(style['border' + side + 'Width']);
	        }
	      });
	    })();
	  }
	
	  return to;
	}
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var _this = this;
	
	    var top = _ref.top;
	    var left = _ref.left;
	    var targetAttachment = _ref.targetAttachment;
	
	    if (!this.options.constraints) {
	      return true;
	    }
	
	    var _cache = this.cache('element-bounds', function () {
	      return getBounds(_this.element);
	    });
	
	    var height = _cache.height;
	    var width = _cache.width;
	
	    if (width === 0 && height === 0 && typeof this.lastSize !== 'undefined') {
	      var _lastSize = this.lastSize;
	
	      // Handle the item getting hidden as a result of our positioning without glitching
	      // the classes in and out
	      width = _lastSize.width;
	      height = _lastSize.height;
	    }
	
	    var targetSize = this.cache('target-bounds', function () {
	      return _this.getTargetBounds();
	    });
	
	    var targetHeight = targetSize.height;
	    var targetWidth = targetSize.width;
	
	    var allClasses = [this.getClass('pinned'), this.getClass('out-of-bounds')];
	
	    this.options.constraints.forEach(function (constraint) {
	      var outOfBoundsClass = constraint.outOfBoundsClass;
	      var pinnedClass = constraint.pinnedClass;
	
	      if (outOfBoundsClass) {
	        allClasses.push(outOfBoundsClass);
	      }
	      if (pinnedClass) {
	        allClasses.push(pinnedClass);
	      }
	    });
	
	    allClasses.forEach(function (cls) {
	      ['left', 'top', 'right', 'bottom'].forEach(function (side) {
	        allClasses.push(cls + '-' + side);
	      });
	    });
	
	    var addClasses = [];
	
	    var tAttachment = extend({}, targetAttachment);
	    var eAttachment = extend({}, this.attachment);
	
	    this.options.constraints.forEach(function (constraint) {
	      var to = constraint.to;
	      var attachment = constraint.attachment;
	      var pin = constraint.pin;
	
	      if (typeof attachment === 'undefined') {
	        attachment = '';
	      }
	
	      var changeAttachX = undefined,
	          changeAttachY = undefined;
	      if (attachment.indexOf(' ') >= 0) {
	        var _attachment$split = attachment.split(' ');
	
	        var _attachment$split2 = _slicedToArray(_attachment$split, 2);
	
	        changeAttachY = _attachment$split2[0];
	        changeAttachX = _attachment$split2[1];
	      } else {
	        changeAttachX = changeAttachY = attachment;
	      }
	
	      var bounds = getBoundingRect(_this, to);
	
	      if (changeAttachY === 'target' || changeAttachY === 'both') {
	        if (top < bounds[1] && tAttachment.top === 'top') {
	          top += targetHeight;
	          tAttachment.top = 'bottom';
	        }
	
	        if (top + height > bounds[3] && tAttachment.top === 'bottom') {
	          top -= targetHeight;
	          tAttachment.top = 'top';
	        }
	      }
	
	      if (changeAttachY === 'together') {
	        if (tAttachment.top === 'top') {
	          if (eAttachment.top === 'bottom' && top < bounds[1]) {
	            top += targetHeight;
	            tAttachment.top = 'bottom';
	
	            top += height;
	            eAttachment.top = 'top';
	          } else if (eAttachment.top === 'top' && top + height > bounds[3] && top - (height - targetHeight) >= bounds[1]) {
	            top -= height - targetHeight;
	            tAttachment.top = 'bottom';
	
	            eAttachment.top = 'bottom';
	          }
	        }
	
	        if (tAttachment.top === 'bottom') {
	          if (eAttachment.top === 'top' && top + height > bounds[3]) {
	            top -= targetHeight;
	            tAttachment.top = 'top';
	
	            top -= height;
	            eAttachment.top = 'bottom';
	          } else if (eAttachment.top === 'bottom' && top < bounds[1] && top + (height * 2 - targetHeight) <= bounds[3]) {
	            top += height - targetHeight;
	            tAttachment.top = 'top';
	
	            eAttachment.top = 'top';
	          }
	        }
	
	        if (tAttachment.top === 'middle') {
	          if (top + height > bounds[3] && eAttachment.top === 'top') {
	            top -= height;
	            eAttachment.top = 'bottom';
	          } else if (top < bounds[1] && eAttachment.top === 'bottom') {
	            top += height;
	            eAttachment.top = 'top';
	          }
	        }
	      }
	
	      if (changeAttachX === 'target' || changeAttachX === 'both') {
	        if (left < bounds[0] && tAttachment.left === 'left') {
	          left += targetWidth;
	          tAttachment.left = 'right';
	        }
	
	        if (left + width > bounds[2] && tAttachment.left === 'right') {
	          left -= targetWidth;
	          tAttachment.left = 'left';
	        }
	      }
	
	      if (changeAttachX === 'together') {
	        if (left < bounds[0] && tAttachment.left === 'left') {
	          if (eAttachment.left === 'right') {
	            left += targetWidth;
	            tAttachment.left = 'right';
	
	            left += width;
	            eAttachment.left = 'left';
	          } else if (eAttachment.left === 'left') {
	            left += targetWidth;
	            tAttachment.left = 'right';
	
	            left -= width;
	            eAttachment.left = 'right';
	          }
	        } else if (left + width > bounds[2] && tAttachment.left === 'right') {
	          if (eAttachment.left === 'left') {
	            left -= targetWidth;
	            tAttachment.left = 'left';
	
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (eAttachment.left === 'right') {
	            left -= targetWidth;
	            tAttachment.left = 'left';
	
	            left += width;
	            eAttachment.left = 'left';
	          }
	        } else if (tAttachment.left === 'center') {
	          if (left + width > bounds[2] && eAttachment.left === 'left') {
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (left < bounds[0] && eAttachment.left === 'right') {
	            left += width;
	            eAttachment.left = 'left';
	          }
	        }
	      }
	
	      if (changeAttachY === 'element' || changeAttachY === 'both') {
	        if (top < bounds[1] && eAttachment.top === 'bottom') {
	          top += height;
	          eAttachment.top = 'top';
	        }
	
	        if (top + height > bounds[3] && eAttachment.top === 'top') {
	          top -= height;
	          eAttachment.top = 'bottom';
	        }
	      }
	
	      if (changeAttachX === 'element' || changeAttachX === 'both') {
	        if (left < bounds[0]) {
	          if (eAttachment.left === 'right') {
	            left += width;
	            eAttachment.left = 'left';
	          } else if (eAttachment.left === 'center') {
	            left += width / 2;
	            eAttachment.left = 'left';
	          }
	        }
	
	        if (left + width > bounds[2]) {
	          if (eAttachment.left === 'left') {
	            left -= width;
	            eAttachment.left = 'right';
	          } else if (eAttachment.left === 'center') {
	            left -= width / 2;
	            eAttachment.left = 'right';
	          }
	        }
	      }
	
	      if (typeof pin === 'string') {
	        pin = pin.split(',').map(function (p) {
	          return p.trim();
	        });
	      } else if (pin === true) {
	        pin = ['top', 'left', 'right', 'bottom'];
	      }
	
	      pin = pin || [];
	
	      var pinned = [];
	      var oob = [];
	
	      if (top < bounds[1]) {
	        if (pin.indexOf('top') >= 0) {
	          top = bounds[1];
	          pinned.push('top');
	        } else {
	          oob.push('top');
	        }
	      }
	
	      if (top + height > bounds[3]) {
	        if (pin.indexOf('bottom') >= 0) {
	          top = bounds[3] - height;
	          pinned.push('bottom');
	        } else {
	          oob.push('bottom');
	        }
	      }
	
	      if (left < bounds[0]) {
	        if (pin.indexOf('left') >= 0) {
	          left = bounds[0];
	          pinned.push('left');
	        } else {
	          oob.push('left');
	        }
	      }
	
	      if (left + width > bounds[2]) {
	        if (pin.indexOf('right') >= 0) {
	          left = bounds[2] - width;
	          pinned.push('right');
	        } else {
	          oob.push('right');
	        }
	      }
	
	      if (pinned.length) {
	        (function () {
	          var pinnedClass = undefined;
	          if (typeof _this.options.pinnedClass !== 'undefined') {
	            pinnedClass = _this.options.pinnedClass;
	          } else {
	            pinnedClass = _this.getClass('pinned');
	          }
	
	          addClasses.push(pinnedClass);
	          pinned.forEach(function (side) {
	            addClasses.push(pinnedClass + '-' + side);
	          });
	        })();
	      }
	
	      if (oob.length) {
	        (function () {
	          var oobClass = undefined;
	          if (typeof _this.options.outOfBoundsClass !== 'undefined') {
	            oobClass = _this.options.outOfBoundsClass;
	          } else {
	            oobClass = _this.getClass('out-of-bounds');
	          }
	
	          addClasses.push(oobClass);
	          oob.forEach(function (side) {
	            addClasses.push(oobClass + '-' + side);
	          });
	        })();
	      }
	
	      if (pinned.indexOf('left') >= 0 || pinned.indexOf('right') >= 0) {
	        eAttachment.left = tAttachment.left = false;
	      }
	      if (pinned.indexOf('top') >= 0 || pinned.indexOf('bottom') >= 0) {
	        eAttachment.top = tAttachment.top = false;
	      }
	
	      if (tAttachment.top !== targetAttachment.top || tAttachment.left !== targetAttachment.left || eAttachment.top !== _this.attachment.top || eAttachment.left !== _this.attachment.left) {
	        _this.updateAttachClasses(eAttachment, tAttachment);
	        _this.trigger('update', {
	          attachment: eAttachment,
	          targetAttachment: tAttachment
	        });
	      }
	    });
	
	    defer(function () {
	      if (!(_this.options.addTargetClasses === false)) {
	        updateClasses(_this.target, addClasses, allClasses);
	      }
	      updateClasses(_this.element, addClasses, allClasses);
	    });
	
	    return { top: top, left: left };
	  }
	});
	/* globals TetherBase */
	
	'use strict';
	
	var _TetherBase$Utils = TetherBase.Utils;
	var getBounds = _TetherBase$Utils.getBounds;
	var updateClasses = _TetherBase$Utils.updateClasses;
	var defer = _TetherBase$Utils.defer;
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var _this = this;
	
	    var top = _ref.top;
	    var left = _ref.left;
	
	    var _cache = this.cache('element-bounds', function () {
	      return getBounds(_this.element);
	    });
	
	    var height = _cache.height;
	    var width = _cache.width;
	
	    var targetPos = this.getTargetBounds();
	
	    var bottom = top + height;
	    var right = left + width;
	
	    var abutted = [];
	    if (top <= targetPos.bottom && bottom >= targetPos.top) {
	      ['left', 'right'].forEach(function (side) {
	        var targetPosSide = targetPos[side];
	        if (targetPosSide === left || targetPosSide === right) {
	          abutted.push(side);
	        }
	      });
	    }
	
	    if (left <= targetPos.right && right >= targetPos.left) {
	      ['top', 'bottom'].forEach(function (side) {
	        var targetPosSide = targetPos[side];
	        if (targetPosSide === top || targetPosSide === bottom) {
	          abutted.push(side);
	        }
	      });
	    }
	
	    var allClasses = [];
	    var addClasses = [];
	
	    var sides = ['left', 'top', 'right', 'bottom'];
	    allClasses.push(this.getClass('abutted'));
	    sides.forEach(function (side) {
	      allClasses.push(_this.getClass('abutted') + '-' + side);
	    });
	
	    if (abutted.length) {
	      addClasses.push(this.getClass('abutted'));
	    }
	
	    abutted.forEach(function (side) {
	      addClasses.push(_this.getClass('abutted') + '-' + side);
	    });
	
	    defer(function () {
	      if (!(_this.options.addTargetClasses === false)) {
	        updateClasses(_this.target, addClasses, allClasses);
	      }
	      updateClasses(_this.element, addClasses, allClasses);
	    });
	
	    return true;
	  }
	});
	/* globals TetherBase */
	
	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	TetherBase.modules.push({
	  position: function position(_ref) {
	    var top = _ref.top;
	    var left = _ref.left;
	
	    if (!this.options.shift) {
	      return;
	    }
	
	    var shift = this.options.shift;
	    if (typeof this.options.shift === 'function') {
	      shift = this.options.shift.call(this, { top: top, left: left });
	    }
	
	    var shiftTop = undefined,
	        shiftLeft = undefined;
	    if (typeof shift === 'string') {
	      shift = shift.split(' ');
	      shift[1] = shift[1] || shift[0];
	
	      var _shift = shift;
	
	      var _shift2 = _slicedToArray(_shift, 2);
	
	      shiftTop = _shift2[0];
	      shiftLeft = _shift2[1];
	
	      shiftTop = parseFloat(shiftTop, 10);
	      shiftLeft = parseFloat(shiftLeft, 10);
	    } else {
	      shiftTop = shift.top;
	      shiftLeft = shift.left;
	    }
	
	    top += shiftTop;
	    left += shiftLeft;
	
	    return { top: top, left: left };
	  }
	});
	return Tether;
	
	}));


/***/ }),
/* 936 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 937 */,
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap) {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
	  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
	  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
	  return '/*# ' + data + ' */';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			// Test for IE <= 9 as proposed by Browserhacks
			// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
			// Tests for existence of standard globals is to allow style-loader 
			// to operate correctly into non-standard environments
			// @see https://github.com/webpack-contrib/style-loader/issues/177
			return window && document && document.all && !window.atob;
		}),
		getElement = (function(fn) {
			var memo = {};
			return function(selector) {
				if (typeof memo[selector] === "undefined") {
					memo[selector] = fn.call(this, selector);
				}
				return memo[selector]
			};
		})(function (styleTarget) {
			return document.querySelector(styleTarget)
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [],
		fixUrls = __webpack_require__(940);
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		options.attrs = typeof options.attrs === "object" ? options.attrs : {};
	
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the <head> element
		if (typeof options.insertInto === "undefined") options.insertInto = "head";
	
		// By default, add <style> tags to the bottom of the target
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	};
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var styleTarget = getElement(options.insertInto)
		if (!styleTarget) {
			throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
		}
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				styleTarget.insertBefore(styleElement, styleTarget.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				styleTarget.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			styleTarget.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		options.attrs.type = "text/css";
	
		attachTagAttrs(styleElement, options.attrs);
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		options.attrs.type = "text/css";
		options.attrs.rel = "stylesheet";
	
		attachTagAttrs(linkElement, options.attrs);
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function attachTagAttrs(element, attrs) {
		Object.keys(attrs).forEach(function (key) {
			element.setAttribute(key, attrs[key]);
		});
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement, options);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, options, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
		*/
		var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;
	
		if (options.convertToAbsoluteUrls || autoFixUrls){
			css = fixUrls(css);
		}
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 940 */
/***/ (function(module, exports) {

	
	/**
	 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
	 * embed the css on the page. This breaks all relative urls because now they are relative to a
	 * bundle instead of the current page.
	 *
	 * One solution is to only use full urls, but that may be impossible.
	 *
	 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
	 *
	 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
	 *
	 */
	
	module.exports = function (css) {
	  // get current location
	  var location = typeof window !== "undefined" && window.location;
	
	  if (!location) {
	    throw new Error("fixUrls requires window.location");
	  }
	
		// blank or null?
		if (!css || typeof css !== "string") {
		  return css;
	  }
	
	  var baseUrl = location.protocol + "//" + location.host;
	  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");
	
		// convert each url(...)
		/*
		This regular expression is just a way to recursively match brackets within
		a string.
	
		 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
		   (  = Start a capturing group
		     (?:  = Start a non-capturing group
		         [^)(]  = Match anything that isn't a parentheses
		         |  = OR
		         \(  = Match a start parentheses
		             (?:  = Start another non-capturing groups
		                 [^)(]+  = Match anything that isn't a parentheses
		                 |  = OR
		                 \(  = Match a start parentheses
		                     [^)(]*  = Match anything that isn't a parentheses
		                 \)  = Match a end parentheses
		             )  = End Group
	              *\) = Match anything and then a close parens
	          )  = Close non-capturing group
	          *  = Match anything
	       )  = Close capturing group
		 \)  = Match a close parens
	
		 /gi  = Get all matches, not the first.  Be case insensitive.
		 */
		var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
			// strip quotes (if they exist)
			var unquotedOrigUrl = origUrl
				.trim()
				.replace(/^"(.*)"$/, function(o, $1){ return $1; })
				.replace(/^'(.*)'$/, function(o, $1){ return $1; });
	
			// already a full url? no change
			if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			  return fullMatch;
			}
	
			// convert the url to a full url
			var newUrl;
	
			if (unquotedOrigUrl.indexOf("//") === 0) {
			  	//TODO: should we add protocol?
				newUrl = unquotedOrigUrl;
			} else if (unquotedOrigUrl.indexOf("/") === 0) {
				// path should be relative to the base url
				newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
			} else {
				// path should be relative to current directory
				newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
			}
	
			// send back the fixed url(...)
			return "url(" + JSON.stringify(newUrl) + ")";
		});
	
		// send back the fixed css
		return fixedCss;
	};


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Base2 = __webpack_require__(898);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _Database = __webpack_require__(897);
	
	var _Database2 = _interopRequireDefault(_Database);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Field = __webpack_require__(900);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Segment = __webpack_require__(942);
	
	var _Segment2 = _interopRequireDefault(_Segment);
	
	var _Metric = __webpack_require__(943);
	
	var _Metric2 = _interopRequireDefault(_Metric);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	/**
	 * Wrapper class for the entire metadata store
	 */
	var Metadata = function (_Base) {
	    _inherits(Metadata, _Base);
	
	    function Metadata() {
	        _classCallCheck(this, Metadata);
	
	        return _possibleConstructorReturn(this, (Metadata.__proto__ || Object.getPrototypeOf(Metadata)).apply(this, arguments));
	    }
	
	    _createClass(Metadata, [{
	        key: "databasesList",
	        value: function databasesList() {
	            // $FlowFixMe
	            return Object.values(this.databases);
	        }
	    }, {
	        key: "tablesList",
	        value: function tablesList() {
	            // $FlowFixMe
	            return Object.values(this.tables);
	        }
	    }, {
	        key: "metricsList",
	        value: function metricsList() {
	            // $FlowFixMe
	            return Object.values(this.metrics);
	        }
	    }, {
	        key: "segmentsList",
	        value: function segmentsList() {
	            // $FlowFixMe
	            return Object.values(this.segments);
	        }
	    }]);
	
	    return Metadata;
	}(_Base3.default);
	
	exports.default = Metadata;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Base2 = __webpack_require__(898);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _Database = __webpack_require__(897);
	
	var _Database2 = _interopRequireDefault(_Database);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	/**
	 * Wrapper class for a segment. Belongs to a {@link Database} and possibly a {@link Table}
	 */
	var Segment = function (_Base) {
	    _inherits(Segment, _Base);
	
	    function Segment() {
	        _classCallCheck(this, Segment);
	
	        return _possibleConstructorReturn(this, (Segment.__proto__ || Object.getPrototypeOf(Segment)).apply(this, arguments));
	    }
	
	    _createClass(Segment, [{
	        key: "filterClause",
	        value: function filterClause() {
	            return ["SEGMENT", this.id];
	        }
	    }, {
	        key: "isActive",
	        value: function isActive() {
	            return !!this.is_active;
	        }
	    }]);
	
	    return Segment;
	}(_Base3.default);
	
	exports.default = Segment;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Base2 = __webpack_require__(898);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _Database = __webpack_require__(897);
	
	var _Database2 = _interopRequireDefault(_Database);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	/**
	 * Wrapper class for a metric. Belongs to a {@link Database} and possibly a {@link Table}
	 */
	var Metric = function (_Base) {
	    _inherits(Metric, _Base);
	
	    function Metric() {
	        _classCallCheck(this, Metric);
	
	        return _possibleConstructorReturn(this, (Metric.__proto__ || Object.getPrototypeOf(Metric)).apply(this, arguments));
	    }
	
	    _createClass(Metric, [{
	        key: "aggregationClause",
	        value: function aggregationClause() {
	            return ["METRIC", this.id];
	        }
	    }, {
	        key: "isActive",
	        value: function isActive() {
	            return !!this.is_active;
	        }
	    }]);
	
	    return Metric;
	}(_Base3.default);
	
	exports.default = Metric;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DATETIME_UNITS = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.computeFilterTimeRange = computeFilterTimeRange;
	exports.expandTimeIntervalFilter = expandTimeIntervalFilter;
	exports.generateTimeFilterValuesDescriptions = generateTimeFilterValuesDescriptions;
	exports.generateTimeIntervalDescription = generateTimeIntervalDescription;
	exports.generateTimeValueDescription = generateTimeValueDescription;
	exports.formatBucketing = formatBucketing;
	exports.absolute = absolute;
	exports.parseFieldBucketing = parseFieldBucketing;
	exports.parseFieldTarget = parseFieldTarget;
	exports.parseFieldTargetId = parseFieldTargetId;
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _inflection = __webpack_require__(520);
	
	var _inflection2 = _interopRequireDefault(_inflection);
	
	var _util = __webpack_require__(870);
	
	var _formatting = __webpack_require__(872);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	var DATETIME_UNITS = exports.DATETIME_UNITS = [
	// "default",
	"minute", "hour", "day", "week", "month", "quarter", "year",
	// "minute-of-hour",
	"hour-of-day", "day-of-week", "day-of-month",
	// "day-of-year",
	"week-of-year", "month-of-year", "quarter-of-year"];
	
	function computeFilterTimeRange(filter) {
	    var expandedFilter = void 0;
	    if ((0, _util.mbqlEq)(filter[0], "time-interval")) {
	        expandedFilter = expandTimeIntervalFilter(filter);
	    } else {
	        expandedFilter = filter;
	    }
	
	    var _expandedFilter = expandedFilter,
	        _expandedFilter2 = _toArray(_expandedFilter),
	        operator = _expandedFilter2[0],
	        field = _expandedFilter2[1],
	        values = _expandedFilter2.slice(2);
	
	    var bucketing = parseFieldBucketing(field, "day");
	
	    var start = void 0,
	        end = void 0;
	    if (operator === "=" && values[0]) {
	        var point = absolute(values[0]);
	        start = point.clone().startOf(bucketing);
	        end = point.clone().endOf(bucketing);
	    } else if (operator === ">" && values[0]) {
	        start = absolute(values[0]).endOf(bucketing);
	        end = max();
	    } else if (operator === "<" && values[0]) {
	        start = min();
	        end = absolute(values[0]).startOf(bucketing);
	    } else if (operator === "BETWEEN" && values[0] && values[1]) {
	        start = absolute(values[0]).startOf(bucketing);
	        end = absolute(values[1]).endOf(bucketing);
	    }
	
	    return [start, end];
	}
	
	function expandTimeIntervalFilter(filter) {
	    var _filter = _slicedToArray(filter, 4),
	        operator = _filter[0],
	        field = _filter[1],
	        n = _filter[2],
	        unit = _filter[3];
	
	    if (!(0, _util.mbqlEq)(operator, "time-interval")) {
	        throw new Error("translateTimeInterval expects operator 'time-interval'");
	    }
	
	    if (n === "current") {
	        n = 0;
	    } else if (n === "last") {
	        n = -1;
	    } else if (n === "next") {
	        n = 1;
	    }
	
	    field = ["datetime-field", field, "as", unit];
	
	    if (n < -1) {
	        return ["BETWEEN", field, ["relative-datetime", n - 1, unit], ["relative-datetime", -1, unit]];
	    } else if (n > 1) {
	        return ["BETWEEN", field, ["relative-datetime", 1, unit], ["relative-datetime", n, unit]];
	    } else if (n === 0) {
	        return ["=", field, ["relative-datetime", "current"]];
	    } else {
	        return ["=", field, ["relative-datetime", n, unit]];
	    }
	}
	
	function generateTimeFilterValuesDescriptions(filter) {
	    var _filter2 = _toArray(filter),
	        operator = _filter2[0],
	        field = _filter2[1],
	        values = _filter2.slice(2);
	
	    var bucketing = parseFieldBucketing(field);
	
	    if ((0, _util.mbqlEq)(operator, "time-interval")) {
	        var _values = _slicedToArray(values, 2),
	            n = _values[0],
	            unit = _values[1];
	
	        return generateTimeIntervalDescription(n, unit);
	    } else {
	        return values.map(function (value) {
	            return generateTimeValueDescription(value, bucketing);
	        });
	    }
	}
	
	function generateTimeIntervalDescription(n, unit) {
	    if (unit === "day") {
	        switch (n) {
	            case "current":
	            case 0:
	                return ["Today"];
	            case "next":
	            case 1:
	                return ["Tomorrow"];
	            case "last":
	            case -1:
	                return ["Yesterday"];
	        }
	    }
	
	    if (!unit && n === 0) return "Today"; // ['relative-datetime', 'current'] is a legal MBQL form but has no unit
	
	    unit = _inflection2.default.capitalize(unit);
	    if (typeof n === "string") {
	        if (n === "current") {
	            n = "this";
	        }
	        return [_inflection2.default.capitalize(n) + " " + unit];
	    } else {
	        if (n < 0) {
	            return ["Past " + -n + " " + _inflection2.default.inflect(unit, -n)];
	        } else if (n > 0) {
	            return ["Next " + n + " " + _inflection2.default.inflect(unit, n)];
	        } else {
	            return ["This " + unit];
	        }
	    }
	}
	
	function generateTimeValueDescription(value, bucketing) {
	    if (typeof value === "string") {
	        var m = (0, _moment2.default)(value);
	        if (bucketing) {
	            return (0, _formatting.formatTimeWithUnit)(value, bucketing);
	        } else if (m.hours() || m.minutes()) {
	            return m.format("MMMM D, YYYY hh:mm a");
	        } else {
	            return m.format("MMMM D, YYYY");
	        }
	    } else if (Array.isArray(value) && (0, _util.mbqlEq)(value[0], "relative-datetime")) {
	        var n = value[1];
	        var unit = value[2];
	
	        if (n === "current") {
	            n = 0;
	            unit = bucketing;
	        }
	
	        if (bucketing === unit) {
	            return generateTimeIntervalDescription(n, unit);
	        } else {
	            // FIXME: what to do if the bucketing and unit don't match?
	            if (n === 0) {
	                return "Now";
	            } else {
	                return Math.abs(n) + " " + _inflection2.default.inflect(unit, Math.abs(n)) + (n < 0 ? " ago" : " from now");
	            }
	        }
	    } else {
	        console.warn("Unknown datetime format", value);
	        return "[Unknown]";
	    }
	}
	
	function formatBucketing() {
	    var bucketing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	    var words = bucketing.split("-");
	    words[0] = _inflection2.default.capitalize(words[0]);
	    return words.join(" ");
	}
	
	function absolute(date) {
	    if (typeof date === "string") {
	        return (0, _moment2.default)(date);
	    } else if (Array.isArray(date) && (0, _util.mbqlEq)(date[0], "relative-datetime")) {
	        return (0, _moment2.default)().add(date[1], date[2]);
	    } else {
	        console.warn("Unknown datetime format", date);
	    }
	}
	
	function parseFieldBucketing(field) {
	    var defaultUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    if (Array.isArray(field)) {
	        if ((0, _util.mbqlEq)(field[0], "datetime-field")) {
	            if (field.length === 4) {
	                // Deprecated legacy format [datetime-field field "as" unit], see DatetimeFieldDimension for more info
	                return field[3];
	            } else {
	                // Current format [datetime-field field unit]
	                return field[2];
	            }
	        }if ((0, _util.mbqlEq)(field[0], "fk->") || (0, _util.mbqlEq)(field[0], "field-id")) {
	            return defaultUnit;
	        }if ((0, _util.mbqlEq)(field[0], "field-literal")) {
	            return defaultUnit;
	        } else {
	            console.warn("Unknown field format", field);
	        }
	    }
	    return defaultUnit;
	}
	
	// returns field with "datetime-field" removed
	function parseFieldTarget(field) {
	    if ((0, _util.mbqlEq)(field[0], "datetime-field")) {
	        return field[1];
	    } else {
	        return field;
	    }
	}
	
	function parseFieldTargetId(field) {
	    if (Number.isInteger(field)) return field;
	
	    if (Array.isArray(field)) {
	        if ((0, _util.mbqlEq)(field[0], "field-id")) return field[1];
	        if ((0, _util.mbqlEq)(field[0], "fk->")) return field[1];
	        if ((0, _util.mbqlEq)(field[0], "datetime-field")) return parseFieldTargetId(field[1]);
	        if ((0, _util.mbqlEq)(field[0], "field-literal")) return field;
	    }
	
	    console.warn("Unknown field format", field);
	    return field;
	}
	
	// 271821 BC and 275760 AD and should be far enough in the past/future
	function max() {
	    return (0, _moment2.default)(new Date(864000000000000));
	}
	function min() {
	    return (0, _moment2.default)(new Date(-864000000000000));
	}

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _Base2 = __webpack_require__(898);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _Database = __webpack_require__(897);
	
	var _Database2 = _interopRequireDefault(_Database);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	/**
	 * Wrapper class for a {@link Database} schema. Contains {@link Table}s.
	 */
	var Schema = function (_Base) {
	    _inherits(Schema, _Base);
	
	    function Schema() {
	        _classCallCheck(this, Schema);
	
	        return _possibleConstructorReturn(this, (Schema.__proto__ || Object.getPrototypeOf(Schema)).apply(this, arguments));
	    }
	
	    return Schema;
	}(_Base3.default);
	
	exports.default = Schema;

/***/ }),
/* 946 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.nyi = nyi;
	exports.memoize = memoize;
	function nyi(target, key, descriptor) {
	    var method = descriptor.value;
	    descriptor.value = function () {
	        console.warn("Method not yet implemented: " + target.constructor.name + "::" + key);
	        return method.apply(this, arguments);
	    };
	    return descriptor;
	}
	
	var memoized = new WeakMap();
	
	function getWithFallback(map, key, fallback) {
	    if (!map.has(key)) {
	        map.set(key, fallback());
	    }
	    return map.get(key);
	}
	
	function memoize(target, name, descriptor) {
	    var method = target[name];
	    descriptor.value = function () {
	        var _this = this;
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        var path = [this, method].concat(args);
	        var last = path.pop();
	        var map = path.reduce(function (map, key) {
	            return getWithFallback(map, key, function () {
	                return new Map();
	            });
	        }, memoized);
	        return getWithFallback(map, last, function () {
	            return method.apply(_this, args);
	        });
	    };
	}

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.STRUCTURED_QUERY_TEMPLATE = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(887);
	
	var Q = _interopRequireWildcard(_query);
	
	var _query2 = __webpack_require__(866);
	
	var _query3 = _interopRequireDefault(_query2);
	
	var _formatter = __webpack_require__(883);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	var _Dimension = __webpack_require__(901);
	
	var _Dimension2 = _interopRequireDefault(_Dimension);
	
	var _AtomicQuery2 = __webpack_require__(948);
	
	var _AtomicQuery3 = _interopRequireDefault(_AtomicQuery2);
	
	var _Aggregation = __webpack_require__(949);
	
	var _Aggregation2 = _interopRequireDefault(_Aggregation);
	
	var _AggregationOption = __webpack_require__(953);
	
	var _AggregationOption2 = _interopRequireDefault(_AggregationOption);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	/**
	 * Represents a structured MBQL query.
	 */
	
	var STRUCTURED_QUERY_TEMPLATE = exports.STRUCTURED_QUERY_TEMPLATE = {
	    database: null,
	    type: "query",
	    query: {
	        source_table: null
	    }
	};
	
	/**
	 * A wrapper around an MBQL (`query` type @type {DatasetQuery}) object
	 */
	
	var StructuredQuery = function (_AtomicQuery) {
	    _inherits(StructuredQuery, _AtomicQuery);
	
	    _createClass(StructuredQuery, null, [{
	        key: "isDatasetQueryType",
	        value: function isDatasetQueryType(datasetQuery) {
	            return datasetQuery.type === STRUCTURED_QUERY_TEMPLATE.type;
	        }
	
	        // For Flow type completion
	
	    }]);
	
	    /**
	     * Creates a new StructuredQuery based on the provided DatasetQuery object
	     */
	    function StructuredQuery(question) {
	        var datasetQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : STRUCTURED_QUERY_TEMPLATE;
	
	        _classCallCheck(this, StructuredQuery);
	
	        var _this = _possibleConstructorReturn(this, (StructuredQuery.__proto__ || Object.getPrototypeOf(StructuredQuery)).call(this, question, datasetQuery));
	
	        _this._structuredDatasetQuery = datasetQuery;
	        return _this;
	    }
	
	    _createClass(StructuredQuery, [{
	        key: "isEmpty",
	
	
	        /* Query superclass methods */
	
	        /**
	         * @returns true if this is new query that hasn't been modified yet.
	         */
	        value: function isEmpty() {
	            return !this.databaseId();
	        }
	
	        /**
	         * @returns true if this query is in a state where it can be run.
	         */
	
	    }, {
	        key: "canRun",
	        value: function canRun() {
	            return _query3.default.canRun(this.query());
	        }
	
	        /**
	         * @returns true if this query is in a state where it can be edited. Must have database and table set, and metadata for the table loaded.
	         */
	
	    }, {
	        key: "isEditable",
	        value: function isEditable() {
	            return !!this.tableMetadata();
	        }
	
	        /* AtomicQuery superclass methods */
	
	        /**
	         * @returns all tables in the currently selected database that can be used.
	         */
	
	    }, {
	        key: "tables",
	        value: function tables() {
	            var database = this.database();
	            return database && database.tables || null;
	        }
	
	        /**
	         * @returns the currently selected database ID, if any is selected.
	         */
	
	    }, {
	        key: "databaseId",
	        value: function databaseId() {
	            // same for both structured and native
	            return this._structuredDatasetQuery.database;
	        }
	
	        /**
	         * @returns the currently selected database metadata, if a database is selected and loaded.
	         */
	
	    }, {
	        key: "database",
	        value: function database() {
	            var databaseId = this.databaseId();
	            return databaseId != null ? this._metadata.databases[databaseId] : null;
	        }
	
	        /**
	         * @returns the database engine object, if a database is selected and loaded.
	         */
	
	    }, {
	        key: "engine",
	        value: function engine() {
	            var database = this.database();
	            return database && database.engine;
	        }
	
	        /* Methods unique to this query type */
	
	        /**
	         * @returns a new reset @type {StructuredQuery} with the same parent @type {Question}
	         */
	
	    }, {
	        key: "reset",
	        value: function reset() {
	            return new StructuredQuery(this._originalQuestion);
	        }
	
	        /**
	         * @returns the underlying MBQL query object
	         */
	
	    }, {
	        key: "query",
	        value: function query() {
	            return this._structuredDatasetQuery.query;
	        }
	
	        /**
	         * @returns a new query with the provided Database set.
	         */
	
	    }, {
	        key: "setDatabase",
	        value: function setDatabase(database) {
	            if (database.id !== this.databaseId()) {
	                // TODO: this should reset the rest of the query?
	                return new StructuredQuery(this._originalQuestion, (0, _icepick.assoc)(this.datasetQuery(), "database", database.id));
	            } else {
	                return this;
	            }
	        }
	
	        /**
	         * @returns a new query with the provided Table set.
	         */
	
	    }, {
	        key: "setTable",
	        value: function setTable(table) {
	            if (table.id !== this.tableId()) {
	                return new StructuredQuery(this._originalQuestion, (0, _icepick.chain)(this.datasetQuery()).assoc("database", table.database.id).assocIn(["query", "source_table"], table.id).value());
	            } else {
	                return this;
	            }
	        }
	
	        /**
	         * @returns the table ID, if a table is selected.
	         */
	
	    }, {
	        key: "tableId",
	        value: function tableId() {
	            return this.query().source_table;
	        }
	
	        /**
	         * @returns the table object, if a table is selected and loaded.
	         * FIXME: actual return type should be `?Table`
	         */
	
	    }, {
	        key: "table",
	        value: function table() {
	            return this._metadata.tables[this.tableId()];
	        }
	
	        /**
	         * @deprecated Alias of `table()`. Use only when partially porting old code that uses @type {TableMetadata} object.
	         */
	
	    }, {
	        key: "tableMetadata",
	        value: function tableMetadata() {
	            return this.table();
	        }
	
	        // AGGREGATIONS
	
	        /**
	         * @returns an array of MBQL @type {Aggregation}s.
	         */
	
	    }, {
	        key: "aggregations",
	        value: function aggregations() {
	            return Q.getAggregations(this.query());
	        }
	
	        /**
	         * @returns an array of aggregation wrapper objects
	         * TODO Atte Keinänen 6/11/17: Make the wrapper objects the standard format for aggregations
	         */
	
	    }, {
	        key: "aggregationsWrapped",
	        value: function aggregationsWrapped() {
	            var _this2 = this;
	
	            return this.aggregations().map(function (agg) {
	                return new _Aggregation2.default(_this2, agg);
	            });
	        }
	
	        /**
	         * @returns an array of aggregation options for the currently selected table
	         */
	
	    }, {
	        key: "aggregationOptions",
	        value: function aggregationOptions() {
	            // TODO Should `aggregation_options` be wrapped already in selectors/metadata.js?
	            var optionObjects = this.table() && this.table().aggregations();
	            return optionObjects ? optionObjects.map(function (agg) {
	                return new _AggregationOption2.default(agg);
	            }) : [];
	        }
	
	        /**
	         * @returns an array of aggregation options for the currently selected table, excluding the "rows" pseudo-aggregation
	         */
	
	    }, {
	        key: "aggregationOptionsWithoutRows",
	        value: function aggregationOptionsWithoutRows() {
	            return this.aggregationOptions().filter(function (option) {
	                return option.short !== "rows";
	            });
	        }
	
	        /**
	         * @returns the field options for the provided aggregation
	         */
	
	    }, {
	        key: "aggregationFieldOptions",
	        value: function aggregationFieldOptions(agg) {
	            var aggregation = this.table().aggregation(agg);
	            if (aggregation) {
	                var fieldOptions = this.fieldOptions(function (field) {
	                    return aggregation.validFieldsFilters[0]([field]).length === 1;
	                });
	
	                // HACK Atte Keinänen 6/18/17: Using `fieldOptions` with a field filter function
	                // ends up often omitting all expressions because the field object of ExpressionDimension is empty.
	                // Expressions can be applied to all aggregations so we can simply add all expressions to the
	                // dimensions list in this hack.
	                //
	                // A real solution would have a `dimensionOptions` method instead of `fieldOptions` which would
	                // enable filtering based on dimension properties.
	                return _extends({}, fieldOptions, {
	                    dimensions: _underscore2.default.uniq([].concat(_toConsumableArray(this.expressionDimensions()), _toConsumableArray(fieldOptions.dimensions.filter(function (d) {
	                        return !(d instanceof _Dimension.ExpressionDimension);
	                    }))))
	                });
	            } else {
	                return { count: 0, fks: [], dimensions: [] };
	            }
	        }
	
	        /**
	         * @returns true if the aggregation can be removed
	         */
	
	    }, {
	        key: "canRemoveAggregation",
	        value: function canRemoveAggregation() {
	            return this.aggregations().length > 1;
	        }
	
	        /**
	         * @returns true if the query has no aggregation
	         */
	
	    }, {
	        key: "isBareRows",
	        value: function isBareRows() {
	            return Q.isBareRows(this.query());
	        }
	
	        /**
	         * @returns the formatted named of the aggregation at the provided index.
	         */
	
	    }, {
	        key: "aggregationName",
	        value: function aggregationName() {
	            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	            var aggregation = this.aggregations()[index];
	            if (_query2.NamedClause.isNamed(aggregation)) {
	                return _query2.NamedClause.getName(aggregation);
	            } else if (_query2.AggregationClause.isCustom(aggregation)) {
	                return (0, _formatter.format)(aggregation, {
	                    tableMetadata: this.tableMetadata(),
	                    customFields: this.expressions()
	                });
	            } else if (_query2.AggregationClause.isMetric(aggregation)) {
	                var metricId = _query2.AggregationClause.getMetric(aggregation);
	                var metric = this._metadata.metrics[metricId];
	                if (metric) {
	                    return metric.name;
	                }
	            } else {
	                var selectedAggregation = (0, _schema_metadata.getAggregator)(_query2.AggregationClause.getOperator(aggregation));
	                if (selectedAggregation) {
	                    var aggregationName = selectedAggregation.name.replace(" of ...", "");
	                    var fieldId = _query3.default.getFieldTargetId(_query2.AggregationClause.getField(aggregation));
	                    var field = fieldId && this._metadata.fields[fieldId];
	                    if (field) {
	                        aggregationName += " of " + field.display_name;
	                    }
	                    return aggregationName;
	                }
	            }
	            return null;
	        }
	
	        /**
	         * @returns {StructuredQuery} new query with the provided MBQL @type {Aggregation} added.
	         */
	
	    }, {
	        key: "addAggregation",
	        value: function addAggregation(aggregation) {
	            return this._updateQuery(Q.addAggregation, arguments);
	        }
	
	        /**
	         * @returns {StructuredQuery} new query with the MBQL @type {Aggregation} updated at the provided index.
	         */
	
	    }, {
	        key: "updateAggregation",
	        value: function updateAggregation(index, aggregation) {
	            return this._updateQuery(Q.updateAggregation, arguments);
	        }
	
	        /**
	         * @returns {StructuredQuery} new query with the aggregation at the provided index removed.
	         */
	
	    }, {
	        key: "removeAggregation",
	        value: function removeAggregation(index) {
	            return this._updateQuery(Q.removeAggregation, arguments);
	        }
	
	        /**
	         * @returns {StructuredQuery} new query with all aggregations removed.
	         */
	
	    }, {
	        key: "clearAggregations",
	        value: function clearAggregations() {
	            return this._updateQuery(Q.clearAggregations, arguments);
	        }
	
	        // BREAKOUTS
	
	        /**
	         * @returns An array of MBQL @type {Breakout}s.
	         */
	
	    }, {
	        key: "breakouts",
	        value: function breakouts() {
	            return Q.getBreakouts(this.query());
	        }
	
	        /**
	         * @param includedBreakout The breakout to include even if it's already used
	         * @param fieldFilter An option @type {Field} predicate to filter out options
	         * @returns @type {DimensionOptions} that can be used as breakouts, excluding used breakouts, unless @param {breakout} is provided.
	         */
	
	    }, {
	        key: "breakoutOptions",
	        value: function breakoutOptions(includedBreakout) {
	            var fieldFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	                return true;
	            };
	
	            // the set of field ids being used by other breakouts
	            var usedFields = new Set(this.breakouts().filter(function (b) {
	                return !_underscore2.default.isEqual(b, includedBreakout);
	            }).map(function (b) {
	                return _query3.default.getFieldTargetId(b);
	            }));
	
	            return this.fieldOptions(function (field) {
	                return fieldFilter(field) && !usedFields.has(field.id);
	            });
	        }
	
	        /**
	         * @returns whether a new breakout can be added or not
	         */
	
	    }, {
	        key: "canAddBreakout",
	        value: function canAddBreakout() {
	            return this.breakoutOptions().count > 0;
	        }
	
	        /**
	         * @returns whether the current query has a valid breakout
	         */
	
	    }, {
	        key: "hasValidBreakout",
	        value: function hasValidBreakout() {
	            return _query3.default.hasValidBreakout(this.query());
	        }
	
	        /**
	         * @returns {StructuredQuery} new query with the provided MBQL @type {Breakout} added.
	         */
	
	    }, {
	        key: "addBreakout",
	        value: function addBreakout(breakout) {
	            return this._updateQuery(Q.addBreakout, arguments);
	        }
	
	        /**
	         * @returns {StructuredQuery} new query with the MBQL @type {Breakout} updated at the provided index.
	         */
	
	    }, {
	        key: "updateBreakout",
	        value: function updateBreakout(index, breakout) {
	            return this._updateQuery(Q.updateBreakout, arguments);
	        }
	
	        /**
	         * @returns {StructuredQuery} new query with the breakout at the provided index removed.
	         */
	
	    }, {
	        key: "removeBreakout",
	        value: function removeBreakout(index) {
	            return this._updateQuery(Q.removeBreakout, arguments);
	        }
	        /**
	         * @returns {StructuredQuery} new query with all breakouts removed.
	         */
	
	    }, {
	        key: "clearBreakouts",
	        value: function clearBreakouts() {
	            return this._updateQuery(Q.clearBreakouts, arguments);
	        }
	
	        // FILTERS
	
	        /**
	         * @returns An array of MBQL @type {Filter}s.
	         */
	
	    }, {
	        key: "filters",
	        value: function filters() {
	            return Q.getFilters(this.query());
	        }
	
	        /**
	         * @returns @type {DimensionOptions} that can be used in filters.
	         */
	
	    }, {
	        key: "filterFieldOptions",
	        value: function filterFieldOptions() {
	            return this.fieldOptions();
	        }
	
	        /**
	         * @returns @type {Segment}s that can be used as filters.
	         * TODO: exclude used segments
	         */
	
	    }, {
	        key: "filterSegmentOptions",
	        value: function filterSegmentOptions() {
	            return this.table().segments.filter(function (sgmt) {
	                return sgmt.is_active === true;
	            });
	        }
	
	        /**
	         * @returns whether a new filter can be added or not
	         */
	
	    }, {
	        key: "canAddFilter",
	        value: function canAddFilter() {
	            return Q.canAddFilter(this.query()) && (this.filterFieldOptions().count > 0 || this.filterSegmentOptions().length > 0);
	        }
	
	        /**
	         * @returns {StructuredQuery} new query with the provided MBQL @type {Filter} added.
	         */
	
	    }, {
	        key: "addFilter",
	        value: function addFilter(filter) {
	            return this._updateQuery(Q.addFilter, arguments);
	        }
	
	        /**
	         * @returns {StructuredQuery} new query with the MBQL @type {Filter} updated at the provided index.
	         */
	
	    }, {
	        key: "updateFilter",
	        value: function updateFilter(index, filter) {
	            return this._updateQuery(Q.updateFilter, arguments);
	        }
	
	        /**
	         * @returns {StructuredQuery} new query with the filter at the provided index removed.
	         */
	
	    }, {
	        key: "removeFilter",
	        value: function removeFilter(index) {
	            return this._updateQuery(Q.removeFilter, arguments);
	        }
	
	        /**
	         * @returns {StructuredQuery} new query with all filters removed.
	         */
	
	    }, {
	        key: "clearFilters",
	        value: function clearFilters() {
	            return this._updateQuery(Q.clearFilters, arguments);
	        }
	
	        // SORTS
	
	        // TODO: standardize SORT vs ORDER_BY terminology
	
	    }, {
	        key: "sorts",
	        value: function sorts() {
	            return Q.getOrderBys(this.query());
	        }
	    }, {
	        key: "sortOptions",
	        value: function sortOptions(sort) {
	            var sortOptions = { count: 0, dimensions: [], fks: [] };
	            // in bare rows all fields are sortable, otherwise we only sort by our breakout columns
	            if (this.isBareRows()) {
	                var usedFields = new Set(this.sorts().filter(function (b) {
	                    return !_underscore2.default.isEqual(b, sort);
	                }).map(function (b) {
	                    return _query3.default.getFieldTargetId(b[0]);
	                }));
	
	                return this.fieldOptions(function (field) {
	                    return !usedFields.has(field.id);
	                });
	            } else if (this.hasValidBreakout()) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = this.breakouts()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var breakout = _step.value;
	
	                        sortOptions.dimensions.push(_Dimension2.default.parseMBQL(breakout, this._metadata));
	                        sortOptions.count++;
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = this.aggregations().entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var _step2$value = _slicedToArray(_step2.value, 2),
	                            index = _step2$value[0],
	                            aggregation = _step2$value[1];
	
	                        if (_query3.default.canSortByAggregateField(this.query(), index)) {
	                            sortOptions.dimensions.push(new _Dimension.AggregationDimension(null, [index], this._metadata, aggregation[0]));
	                            sortOptions.count++;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	            }
	            return sortOptions;
	        }
	    }, {
	        key: "canAddSort",
	        value: function canAddSort() {
	            var sorts = this.sorts();
	            return this.sortOptions().count > 0 && (sorts.length === 0 || sorts[sorts.length - 1][0] != null);
	        }
	    }, {
	        key: "addSort",
	        value: function addSort(order_by) {
	            return this._updateQuery(Q.addOrderBy, arguments);
	        }
	    }, {
	        key: "updateSort",
	        value: function updateSort(index, order_by) {
	            return this._updateQuery(Q.updateOrderBy, arguments);
	        }
	    }, {
	        key: "removeSort",
	        value: function removeSort(index) {
	            return this._updateQuery(Q.removeOrderBy, arguments);
	        }
	    }, {
	        key: "clearSort",
	        value: function clearSort() {
	            return this._updateQuery(Q.clearOrderBy, arguments);
	        }
	    }, {
	        key: "replaceSort",
	        value: function replaceSort(order_by) {
	            return this.clearSort().addSort(order_by);
	        }
	
	        // LIMIT
	
	    }, {
	        key: "limit",
	        value: function limit() {
	            return Q.getLimit(this.query());
	        }
	    }, {
	        key: "updateLimit",
	        value: function updateLimit(limit) {
	            return this._updateQuery(Q.updateLimit, arguments);
	        }
	    }, {
	        key: "clearLimit",
	        value: function clearLimit() {
	            return this._updateQuery(Q.clearLimit, arguments);
	        }
	
	        // EXPRESSIONS
	
	    }, {
	        key: "expressions",
	        value: function expressions() {
	            return Q.getExpressions(this.query());
	        }
	    }, {
	        key: "updateExpression",
	        value: function updateExpression(name, expression, oldName) {
	            return this._updateQuery(Q.updateExpression, arguments);
	        }
	    }, {
	        key: "removeExpression",
	        value: function removeExpression(name) {
	            return this._updateQuery(Q.removeExpression, arguments);
	        }
	
	        // FIELD OPTIONS
	
	        // TODO Atte Keinänen 6/18/17: Refactor to dimensionOptions which takes a dimensionFilter
	        // See aggregationFieldOptions for an explanation why that covers more use cases
	
	    }, {
	        key: "fieldOptions",
	        value: function fieldOptions() {
	            var fieldFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
	                return true;
	            };
	
	            var fieldOptions = {
	                count: 0,
	                fks: [],
	                dimensions: []
	            };
	
	            var table = this.tableMetadata();
	            if (table) {
	                var dimensionFilter = function dimensionFilter(dimension) {
	                    var field = dimension.field && dimension.field();
	                    return !field || field.isDimension() && fieldFilter(field);
	                };
	
	                var dimensionIsFKReference = function dimensionIsFKReference(dimension) {
	                    return dimension.field && dimension.field() && dimension.field().isFK();
	                };
	
	                var filteredNonFKDimensions = this.dimensions().filter(dimensionFilter).filter(function (d) {
	                    return !dimensionIsFKReference(d);
	                });
	
	                var _iteratorNormalCompletion3 = true;
	                var _didIteratorError3 = false;
	                var _iteratorError3 = undefined;
	
	                try {
	                    for (var _iterator3 = filteredNonFKDimensions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                        var dimension = _step3.value;
	
	                        fieldOptions.count++;
	                        fieldOptions.dimensions.push(dimension);
	                    }
	                } catch (err) {
	                    _didIteratorError3 = true;
	                    _iteratorError3 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                            _iterator3.return();
	                        }
	                    } finally {
	                        if (_didIteratorError3) {
	                            throw _iteratorError3;
	                        }
	                    }
	                }
	
	                var fkDimensions = this.dimensions().filter(dimensionIsFKReference);
	                var _iteratorNormalCompletion4 = true;
	                var _didIteratorError4 = false;
	                var _iteratorError4 = undefined;
	
	                try {
	                    for (var _iterator4 = fkDimensions[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                        var _dimension = _step4.value;
	
	                        var _fkDimensions = _dimension.dimensions([_Dimension.FKDimension]).filter(dimensionFilter);
	
	                        if (_fkDimensions.length > 0) {
	                            fieldOptions.count += _fkDimensions.length;
	                            fieldOptions.fks.push({
	                                field: _dimension.field(),
	                                dimension: _dimension,
	                                dimensions: _fkDimensions
	                            });
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError4 = true;
	                    _iteratorError4 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                            _iterator4.return();
	                        }
	                    } finally {
	                        if (_didIteratorError4) {
	                            throw _iteratorError4;
	                        }
	                    }
	                }
	            }
	
	            return fieldOptions;
	        }
	
	        // DIMENSIONS
	
	    }, {
	        key: "dimensions",
	        value: function dimensions() {
	            return [].concat(_toConsumableArray(this.expressionDimensions()), _toConsumableArray(this.tableDimensions()));
	        }
	    }, {
	        key: "tableDimensions",
	        value: function tableDimensions() {
	            var table = this.table();
	            return table ? table.dimensions() : [];
	        }
	    }, {
	        key: "expressionDimensions",
	        value: function expressionDimensions() {
	            return Object.entries(this.expressions()).map(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    expressionName = _ref2[0],
	                    expression = _ref2[1];
	
	                return new _Dimension.ExpressionDimension(null, [expressionName]);
	            });
	        }
	    }, {
	        key: "aggregationDimensions",
	        value: function aggregationDimensions() {
	            var _this3 = this;
	
	            return this.breakouts().map(function (breakout) {
	                return _Dimension2.default.parseMBQL(breakout, _this3._metadata);
	            });
	        }
	    }, {
	        key: "metricDimensions",
	        value: function metricDimensions() {
	            var _this4 = this;
	
	            return this.aggregations().map(function (aggregation, index) {
	                return new _Dimension.AggregationDimension(null, [index], _this4._metadata, aggregation[0]);
	            });
	        }
	    }, {
	        key: "fieldReferenceForColumn",
	        value: function fieldReferenceForColumn(column) {
	            if (column.fk_field_id != null) {
	                return ["fk->", column.fk_field_id, column.id];
	            } else if (column.id != null) {
	                return ["field-id", column.id];
	            } else if (column["expression-name"] != null) {
	                return ["expression", column["expression-name"]];
	            } else if (column.source === "aggregation") {
	                // FIXME: aggregations > 0?
	                return ["aggregation", 0];
	            }
	        }
	    }, {
	        key: "parseFieldReference",
	        value: function parseFieldReference(fieldRef) {
	            var dimension = _Dimension2.default.parseMBQL(fieldRef, this._metadata);
	            if (dimension) {
	                // HACK
	                if (dimension instanceof _Dimension.AggregationDimension) {
	                    dimension._displayName = this.aggregations()[dimension._args[0]][0];
	                }
	                return dimension;
	            }
	        }
	    }, {
	        key: "setDatasetQuery",
	        value: function setDatasetQuery(datasetQuery) {
	            return new StructuredQuery(this._originalQuestion, datasetQuery);
	        }
	
	        // INTERNAL
	
	    }, {
	        key: "_updateQuery",
	        value: function _updateQuery(updateFunction, args) {
	            return this.setDatasetQuery((0, _icepick.updateIn)(this._datasetQuery, ["query"], function (query) {
	                return updateFunction.apply(undefined, [query].concat(_toConsumableArray(args)));
	            }));
	        }
	    }], [{
	        key: "newStucturedQuery",
	        value: function newStucturedQuery(_ref3) {
	            var question = _ref3.question,
	                databaseId = _ref3.databaseId,
	                tableId = _ref3.tableId;
	
	            var datasetQuery = _extends({}, STRUCTURED_QUERY_TEMPLATE, {
	                database: databaseId || null,
	                query: {
	                    source_table: tableId || null
	                }
	            });
	
	            return new StructuredQuery(question, datasetQuery);
	        }
	    }]);
	
	    return StructuredQuery;
	}(_AtomicQuery3.default);
	
	exports.default = StructuredQuery;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Query2 = __webpack_require__(896);
	
	var _Query3 = _interopRequireDefault(_Query2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A query type for queries that are attached to a specific database table
	 * and form a single MBQL / native query clause
	 */
	var AtomicQuery = function (_Query) {
	    _inherits(AtomicQuery, _Query);
	
	    function AtomicQuery() {
	        _classCallCheck(this, AtomicQuery);
	
	        return _possibleConstructorReturn(this, (AtomicQuery.__proto__ || Object.getPrototypeOf(AtomicQuery)).apply(this, arguments));
	    }
	
	    _createClass(AtomicQuery, [{
	        key: "tables",
	
	        /**
	         * Tables this query could use, if the database is set
	         */
	        value: function tables() {
	            return null;
	        }
	    }, {
	        key: "databaseId",
	        value: function databaseId() {
	            return null;
	        }
	    }, {
	        key: "database",
	        value: function database() {
	            return null;
	        }
	    }, {
	        key: "engine",
	        value: function engine() {
	            return null;
	        }
	    }]);
	
	    return AtomicQuery;
	}(_Query3.default);
	
	exports.default = AtomicQuery;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _query = __webpack_require__(866);
	
	var _Metric = __webpack_require__(950);
	
	var _Metadata = __webpack_require__(951);
	
	var _Field = __webpack_require__(952);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Wrapper for an aggregation contained by a {@link StructuredQuery}
	 */
	var Aggregation = function () {
	    function Aggregation(query, clause) {
	        _classCallCheck(this, Aggregation);
	
	        this._query = query;
	        this.clause = clause;
	    }
	
	    /**
	     * Gets the aggregation option matching this aggregation
	     * Returns `null` if the clause isn't in a standard format
	     */
	
	
	    _createClass(Aggregation, [{
	        key: "getOption",
	        value: function getOption() {
	            if (this._query == null) return null;
	
	            var operator = this.getOperator();
	            return operator ? this._query.aggregationOptions().find(function (option) {
	                return option.short === operator;
	            }) : null;
	        }
	
	        /**
	         * Predicate function to test if a given aggregation clause is fully formed
	         */
	
	    }, {
	        key: "isValid",
	        value: function isValid() {
	            return _query.AggregationClause.isValid(this.clause);
	        }
	
	        /**
	         * Predicate function to test if the given aggregation clause represents a Bare Rows aggregation
	         */
	
	    }, {
	        key: "isBareRows",
	        value: function isBareRows() {
	            return _query.AggregationClause.isBareRows(this.clause);
	        }
	
	        /**
	         * Predicate function to test if a given aggregation clause represents a standard aggregation
	         */
	
	    }, {
	        key: "isStandard",
	        value: function isStandard() {
	            return _query.AggregationClause.isStandard(this.clause);
	        }
	    }, {
	        key: "getAggregation",
	        value: function getAggregation() {
	            return _query.AggregationClause.getAggregation(this.clause);
	        }
	
	        /**
	         * Predicate function to test if a given aggregation clause represents a metric
	         */
	
	    }, {
	        key: "isMetric",
	        value: function isMetric() {
	            return _query.AggregationClause.isMetric(this.clause);
	        }
	
	        /**
	         * Get metricId from a metric aggregation clause
	         * Returns `null` if the clause doesn't represent a metric
	         */
	
	    }, {
	        key: "getMetric",
	        value: function getMetric() {
	            return _query.AggregationClause.getMetric(this.clause);
	        }
	
	        /**
	         * Is a custom expression created with the expression editor
	         */
	
	    }, {
	        key: "isCustom",
	        value: function isCustom() {
	            return _query.AggregationClause.isCustom(this.clause);
	        }
	
	        /**
	         * Get the operator from a standard aggregation clause
	         * Returns `null` if the clause isn't in a standard format
	         */
	
	    }, {
	        key: "getOperator",
	        value: function getOperator() {
	            return _query.AggregationClause.getOperator(this.clause);
	        }
	
	        /**
	         * Get the fieldId from a standard aggregation clause
	         * Returns `null` if the clause isn't in a standard format
	         */
	
	    }, {
	        key: "getField",
	        value: function getField() {
	            return _query.AggregationClause.getField(this.clause);
	        }
	
	        /**
	         * Set the fieldId on a standard aggregation clause.
	         * If the clause isn't in a standard format, no modifications are done.
	         */
	
	    }, {
	        key: "setField",
	        value: function setField(fieldId) {
	            return new Aggregation(this._query, _query.AggregationClause.setField(this.clause, fieldId));
	        }
	    }]);
	
	    return Aggregation;
	}();
	
	exports.default = Aggregation;

/***/ }),
/* 950 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Dimension = __webpack_require__(901);
	
	var _Dimension2 = _interopRequireDefault(_Dimension);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 952 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Base2 = __webpack_require__(898);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _Aggregation = __webpack_require__(949);
	
	var _Aggregation2 = _interopRequireDefault(_Aggregation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Wrapper class for an aggregation object
	 */
	var AggregationOption = function (_Base) {
	    _inherits(AggregationOption, _Base);
	
	    function AggregationOption() {
	        _classCallCheck(this, AggregationOption);
	
	        return _possibleConstructorReturn(this, (AggregationOption.__proto__ || Object.getPrototypeOf(AggregationOption)).apply(this, arguments));
	    }
	
	    _createClass(AggregationOption, [{
	        key: "hasFields",
	
	
	        /**
	         * Aggregation has one or more required fields
	         */
	
	        // TODO: Now just a plain object; wrap to a Field wrapper class
	        value: function hasFields() {
	            return this.validFieldsFilters.length > 0;
	        }
	    }, {
	        key: "toAggregation",
	        value: function toAggregation() {
	            return new _Aggregation2.default(null, [this.short].concat(this.fields.map(function (field) {
	                return null;
	            })));
	        }
	    }]);
	
	    return AggregationOption;
	}(_Base3.default);
	
	exports.default = AggregationOption;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.NATIVE_QUERY_TEMPLATE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _Query = __webpack_require__(896);
	
	var _Query2 = _interopRequireDefault(_Query);
	
	var _Database = __webpack_require__(897);
	
	var _Database2 = _interopRequireDefault(_Database);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _string = __webpack_require__(955);
	
	var _formatting = __webpack_require__(872);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _engine = __webpack_require__(956);
	
	var _icepick = __webpack_require__(855);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _AtomicQuery2 = __webpack_require__(948);
	
	var _AtomicQuery3 = _interopRequireDefault(_AtomicQuery2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	var NATIVE_QUERY_TEMPLATE = exports.NATIVE_QUERY_TEMPLATE = {
	    database: null,
	    type: "native",
	    native: {
	        query: "",
	        template_tags: {}
	    }
	};
	
	var NativeQuery = function (_AtomicQuery) {
	    _inherits(NativeQuery, _AtomicQuery);
	
	    function NativeQuery(question) {
	        var datasetQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NATIVE_QUERY_TEMPLATE;
	
	        _classCallCheck(this, NativeQuery);
	
	        var _this = _possibleConstructorReturn(this, (NativeQuery.__proto__ || Object.getPrototypeOf(NativeQuery)).call(this, question, datasetQuery));
	
	        _this._nativeDatasetQuery = datasetQuery;
	        return _this;
	    }
	    // For Flow type completion
	
	
	    _createClass(NativeQuery, [{
	        key: "canRun",
	
	
	        /* Query superclass methods */
	
	        value: function canRun() {
	            return this.databaseId() != null && this.queryText().length > 0 && (!this.requiresTable() || this.collection());
	        }
	    }, {
	        key: "isEmpty",
	        value: function isEmpty() {
	            return this.databaseId() == null || this.queryText().length == 0;
	        }
	    }, {
	        key: "databases",
	        value: function databases() {
	            return _get(NativeQuery.prototype.__proto__ || Object.getPrototypeOf(NativeQuery.prototype), "databases", this).call(this).filter(function (database) {
	                return database.native_permissions === "write";
	            });
	        }
	
	        /* AtomicQuery superclass methods */
	
	    }, {
	        key: "tables",
	        value: function tables() {
	            var database = this.database();
	            return database && database.tables || null;
	        }
	    }, {
	        key: "databaseId",
	        value: function databaseId() {
	            // same for both structured and native
	            return this._nativeDatasetQuery.database;
	        }
	    }, {
	        key: "database",
	        value: function database() {
	            var databaseId = this.databaseId();
	            return databaseId != null ? this._metadata.databases[databaseId] : null;
	        }
	    }, {
	        key: "engine",
	        value: function engine() {
	            var database = this.database();
	            return database && database.engine;
	        }
	
	        /* Methods unique to this query type */
	
	        /**
	         * @returns a new query with the provided Database set.
	         */
	
	    }, {
	        key: "setDatabase",
	        value: function setDatabase(database) {
	            if (database.id !== this.databaseId()) {
	                // TODO: this should reset the rest of the query?
	                return new NativeQuery(this._originalQuestion, (0, _icepick.assoc)(this.datasetQuery(), "database", database.id));
	            } else {
	                return this;
	            }
	        }
	    }, {
	        key: "hasWritePermission",
	        value: function hasWritePermission() {
	            var database = this.database();
	            return database != null && database.native_permissions === "write";
	        }
	    }, {
	        key: "supportsNativeParameters",
	        value: function supportsNativeParameters() {
	            var database = this.database();
	            return database != null && _underscore2.default.contains(database.features, "native-parameters");
	        }
	    }, {
	        key: "table",
	        value: function table() {
	            var database = this.database();
	            var collection = this.collection();
	            if (!database || !collection) {
	                return null;
	            }
	            return _underscore2.default.findWhere(database.tables, { name: collection }) || null;
	        }
	    }, {
	        key: "queryText",
	        value: function queryText() {
	            return (0, _icepick.getIn)(this.datasetQuery(), ["native", "query"]) || "";
	        }
	    }, {
	        key: "updateQueryText",
	        value: function updateQueryText(newQueryText) {
	            return new NativeQuery(this._originalQuestion, (0, _icepick.chain)(this._datasetQuery).assocIn(["native", "query"], newQueryText).assocIn(["native", "template_tags"], this._getUpdatedTemplateTags(newQueryText)).value());
	        }
	    }, {
	        key: "collection",
	        value: function collection() {
	            return (0, _icepick.getIn)(this.datasetQuery(), ["native", "collection"]);
	        }
	    }, {
	        key: "updateCollection",
	        value: function updateCollection(newCollection) {
	            return new NativeQuery(this._originalQuestion, (0, _icepick.assocIn)(this._datasetQuery, ["native", "collection"], newCollection));
	        }
	    }, {
	        key: "lineCount",
	        value: function lineCount() {
	            var queryText = this.queryText();
	            return queryText ? (0, _string.countLines)(queryText) : 0;
	        }
	
	        /**
	         * The ACE Editor mode name, e.g. 'ace/mode/json'
	         */
	
	    }, {
	        key: "aceMode",
	        value: function aceMode() {
	            return (0, _engine.getEngineNativeAceMode)(this.engine());
	        }
	
	        /**
	         * Name used to describe the text written in that mode, e.g. 'JSON'. Used to fill in the blank in 'This question is written in _______'.
	         */
	
	    }, {
	        key: "nativeQueryLanguage",
	        value: function nativeQueryLanguage() {
	            return (0, _engine.getEngineNativeType)(this.engine()).toUpperCase();
	        }
	
	        /**
	         * Whether the DB selector should be a DB + Table selector. Mongo needs both DB + Table.
	         */
	
	    }, {
	        key: "requiresTable",
	        value: function requiresTable() {
	            return (0, _engine.getEngineNativeRequiresTable)(this.engine());
	        }
	
	        // $FlowFixMe
	
	    }, {
	        key: "templateTags",
	        value: function templateTags() {
	            return Object.values(this.templateTagsMap());
	        }
	    }, {
	        key: "templateTagsMap",
	        value: function templateTagsMap() {
	            return (0, _icepick.getIn)(this.datasetQuery(), ["native", "template_tags"]) || {};
	        }
	
	        /**
	         * special handling for NATIVE cards to automatically detect parameters ... {{varname}}
	         */
	
	    }, {
	        key: "_getUpdatedTemplateTags",
	        value: function _getUpdatedTemplateTags(queryText) {
	            if (queryText && this.supportsNativeParameters()) {
	                var tags = [];
	
	                // look for variable usage in the query (like '{{varname}}').  we only allow alphanumeric characters for the variable name
	                // a variable name can optionally end with :start or :end which is not considered part of the actual variable name
	                // expected pattern is like mustache templates, so we are looking for something like {{category}} or {{date:start}}
	                // anything that doesn't match our rule is ignored, so {{&foo!}} would simply be ignored
	                var match = void 0,
	                    re = /\{\{([A-Za-z0-9_]+?)\}\}/g;
	                while ((match = re.exec(queryText)) != null) {
	                    tags.push(match[1]);
	                }
	
	                // eliminate any duplicates since it's allowed for a user to reference the same variable multiple times
	                var existingTemplateTags = this.templateTagsMap();
	
	                tags = _underscore2.default.uniq(tags);
	                var existingTags = Object.keys(existingTemplateTags);
	
	                // if we ended up with any variables in the query then update the card parameters list accordingly
	                if (tags.length > 0 || existingTags.length > 0) {
	                    var newTags = _underscore2.default.difference(tags, existingTags);
	                    var oldTags = _underscore2.default.difference(existingTags, tags);
	
	                    var templateTags = _extends({}, existingTemplateTags);
	                    if (oldTags.length === 1 && newTags.length === 1) {
	                        // renaming
	                        templateTags[newTags[0]] = _extends({}, templateTags[oldTags[0]]);
	
	                        if (templateTags[newTags[0]].display_name === (0, _formatting.humanize)(oldTags[0])) {
	                            templateTags[newTags[0]].display_name = (0, _formatting.humanize)(newTags[0]);
	                        }
	
	                        templateTags[newTags[0]].name = newTags[0];
	                        delete templateTags[oldTags[0]];
	                    } else {
	                        // remove old vars
	                        var _iteratorNormalCompletion = true;
	                        var _didIteratorError = false;
	                        var _iteratorError = undefined;
	
	                        try {
	                            for (var _iterator = oldTags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                var name = _step.value;
	
	                                delete templateTags[name];
	                            }
	
	                            // create new vars
	                        } catch (err) {
	                            _didIteratorError = true;
	                            _iteratorError = err;
	                        } finally {
	                            try {
	                                if (!_iteratorNormalCompletion && _iterator.return) {
	                                    _iterator.return();
	                                }
	                            } finally {
	                                if (_didIteratorError) {
	                                    throw _iteratorError;
	                                }
	                            }
	                        }
	
	                        var _iteratorNormalCompletion2 = true;
	                        var _didIteratorError2 = false;
	                        var _iteratorError2 = undefined;
	
	                        try {
	                            for (var _iterator2 = newTags[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                                var tagName = _step2.value;
	
	                                templateTags[tagName] = {
	                                    id: _utils2.default.uuid(),
	                                    name: tagName,
	                                    display_name: (0, _formatting.humanize)(tagName),
	                                    type: null
	                                };
	                            }
	                        } catch (err) {
	                            _didIteratorError2 = true;
	                            _iteratorError2 = err;
	                        } finally {
	                            try {
	                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                    _iterator2.return();
	                                }
	                            } finally {
	                                if (_didIteratorError2) {
	                                    throw _iteratorError2;
	                                }
	                            }
	                        }
	                    }
	
	                    // ensure all tags have an id since we need it for parameter values to work
	                    // $FlowFixMe
	                    var _iteratorNormalCompletion3 = true;
	                    var _didIteratorError3 = false;
	                    var _iteratorError3 = undefined;
	
	                    try {
	                        for (var _iterator3 = Object.values(templateTags)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                            var tag = _step3.value;
	
	                            if (tag.id == undefined) {
	                                tag.id = _utils2.default.uuid();
	                            }
	                        }
	                    } catch (err) {
	                        _didIteratorError3 = true;
	                        _iteratorError3 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                                _iterator3.return();
	                            }
	                        } finally {
	                            if (_didIteratorError3) {
	                                throw _iteratorError3;
	                            }
	                        }
	                    }
	
	                    return templateTags;
	                }
	            }
	            return {};
	        }
	    }], [{
	        key: "isDatasetQueryType",
	        value: function isDatasetQueryType(datasetQuery) {
	            return datasetQuery.type === NATIVE_QUERY_TEMPLATE.type;
	        }
	    }]);
	
	    return NativeQuery;
	}(_AtomicQuery3.default);
	
	exports.default = NativeQuery;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.countLines = undefined;
	exports.createMultiwordSearchRegex = createMultiwordSearchRegex;
	exports.caseInsensitiveSearch = caseInsensitiveSearch;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Creates a regex that will find an order dependent, case insensitive substring. All whitespace will be rendered as ".*" in the regex, to create a fuzzy search.
	function createMultiwordSearchRegex(input) {
	    if (input) {
	        return new RegExp(_underscore2.default.map(input.split(/\s+/), function (word) {
	            return RegExp.escape(word);
	        }).join(".*"), "i");
	    }
	}
	
	var countLines = exports.countLines = function countLines(str) {
	    return str.split(/\n/g).length;
	};
	
	function caseInsensitiveSearch(haystack, needle) {
	    return !needle || haystack != null && haystack.toLowerCase().indexOf(needle.toLowerCase()) >= 0;
	}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getEngineNativeType = getEngineNativeType;
	exports.getEngineNativeAceMode = getEngineNativeAceMode;
	exports.getEngineNativeRequiresTable = getEngineNativeRequiresTable;
	exports.formatJsonQuery = formatJsonQuery;
	function getEngineNativeType(engine) {
	    switch (engine) {
	        case "mongo":
	        case "druid":
	        case "googleanalytics":
	            return "json";
	        default:
	            return "sql";
	    }
	}
	
	function getEngineNativeAceMode(engine) {
	    switch (engine) {
	        case "mongo":
	        case "druid":
	        case "googleanalytics":
	            return "ace/mode/json";
	        case "mysql":
	            return "ace/mode/mysql";
	        case "postgres":
	            return "ace/mode/pgsql";
	        case "sqlserver":
	            return "ace/mode/sqlserver";
	        default:
	            return "ace/mode/sql";
	    }
	}
	
	function getEngineNativeRequiresTable(engine) {
	    return engine === "mongo";
	}
	
	function formatJsonQuery(query, engine) {
	    if (engine === "googleanalytics") {
	        return formatGAQuery(query);
	    } else {
	        return JSON.stringify(query);
	    }
	}
	
	var GA_ORDERED_PARAMS = ["ids", "start-date", "end-date", "metrics", "dimensions", "sort", "filters", "segment", "samplingLevel", "include-empty-rows", "start-index", "max-results"];
	
	// does 3 things: removes null values, sorts the keys by the order in the documentation, and formats with 2 space indents
	function formatGAQuery(query) {
	    var object = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = GA_ORDERED_PARAMS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var param = _step.value;
	
	            if (query[param] != null) {
	                object[param] = query[param];
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return JSON.stringify(object, null, 2);
	}

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NATIVE_QUERY_TEMPLATE = exports.STRUCTURED_QUERY_TEMPLATE = undefined;
	exports.isStructured = isStructured;
	exports.isNative = isNative;
	exports.canRun = canRun;
	exports.cardIsEquivalent = cardIsEquivalent;
	exports.getQuery = getQuery;
	exports.getTableMetadata = getTableMetadata;
	exports.getTemplateTags = getTemplateTags;
	exports.getParameters = getParameters;
	exports.getParametersWithExtras = getParametersWithExtras;
	exports.applyParameters = applyParameters;
	exports.questionUrlWithParameters = questionUrlWithParameters;
	
	var _Parameter = __webpack_require__(958);
	
	var _query = __webpack_require__(887);
	
	var Query = _interopRequireWildcard(_query);
	
	var _query2 = __webpack_require__(866);
	
	var _query3 = _interopRequireDefault(_query2);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// TODO Atte Keinänen 6/5/17 Should these be moved to corresponding metabase-lib classes?
	// Is there any reason behind keeping them in a central place?
	
	// legacy
	var STRUCTURED_QUERY_TEMPLATE = exports.STRUCTURED_QUERY_TEMPLATE = {
	    type: "query",
	    database: null,
	    query: {
	        source_table: null,
	        aggregation: undefined,
	        breakout: undefined,
	        filter: undefined
	    }
	};
	
	var NATIVE_QUERY_TEMPLATE = exports.NATIVE_QUERY_TEMPLATE = {
	    type: "native",
	    database: null,
	    native: {
	        query: "",
	        template_tags: {}
	    }
	};
	
	function isStructured(card) {
	    return card.dataset_query.type === "query";
	}
	
	function isNative(card) {
	    return card.dataset_query.type === "native";
	}
	
	function canRun(card) {
	    if (card.dataset_query.type === "query") {
	        var query = getQuery(card);
	        return query != null && query.source_table != undefined && Query.hasValidAggregation(query);
	    } else if (card.dataset_query.type === "native") {
	        var native = card.dataset_query.native;
	        return native && card.dataset_query.database != undefined && native.query !== "";
	    } else {
	        return false;
	    }
	}
	
	function cardIsEquivalent(cardA, cardB) {
	    cardA = (0, _icepick.updateIn)(cardA, ["dataset_query", "parameters"], function (parameters) {
	        return parameters || [];
	    });
	    cardB = (0, _icepick.updateIn)(cardB, ["dataset_query", "parameters"], function (parameters) {
	        return parameters || [];
	    });
	    cardA = _underscore2.default.pick(cardA, "dataset_query", "display", "visualization_settings");
	    cardB = _underscore2.default.pick(cardB, "dataset_query", "display", "visualization_settings");
	    return _underscore2.default.isEqual(cardA, cardB);
	}
	
	function getQuery(card) {
	    if (card.dataset_query.type === "query") {
	        return card.dataset_query.query;
	    } else {
	        return null;
	    }
	}
	
	function getTableMetadata(card, metadata) {
	    var query = getQuery(card);
	    if (query && query.source_table != null) {
	        return metadata.tables[query.source_table] || null;
	    }
	    return null;
	}
	
	function getTemplateTags(card) {
	    return card && card.dataset_query && card.dataset_query.type === "native" && card.dataset_query.native.template_tags ? Object.values(card.dataset_query.native.template_tags) : [];
	}
	
	function getParameters(card) {
	    if (card && card.parameters) {
	        return card.parameters;
	    }
	
	    var tags = getTemplateTags(card);
	    return (0, _Parameter.getTemplateTagParameters)(tags);
	}
	
	function getParametersWithExtras(card, parameterValues) {
	    return getParameters(card).map(function (parameter) {
	        // if we have a parameter value for this parameter, set "value"
	        if (parameterValues && parameter.id in parameterValues) {
	            parameter = (0, _icepick.assoc)(parameter, "value", parameterValues[parameter.id]);
	        }
	        // if we have a field id for this parameter, set "field_id"
	        var fieldId = (0, _Parameter.getParameterTargetFieldId)(parameter.target, card.dataset_query);
	        if (fieldId != null) {
	            parameter = (0, _icepick.assoc)(parameter, "field_id", fieldId);
	        }
	        return parameter;
	    });
	}
	
	// NOTE Atte Keinänen 7/5/17: Still used in dashboards and public questions.
	// Query builder uses `Question.getResults` which contains similar logic.
	function applyParameters(card, parameters) {
	    var parameterValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var parameterMappings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	    var datasetQuery = _utils2.default.copy(card.dataset_query);
	    // clean the query
	    if (datasetQuery.type === "query") {
	        datasetQuery.query = _query3.default.cleanQuery(datasetQuery.query);
	    }
	    datasetQuery.parameters = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (parameters || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var parameter = _step.value;
	
	            var value = parameterValues[parameter.id];
	            if (value == null) {
	                continue;
	            }
	
	            var mapping = _underscore2.default.findWhere(parameterMappings, {
	                card_id: card.id || card.original_card_id,
	                parameter_id: parameter.id
	            });
	            if (mapping) {
	                // mapped target, e.x. on a dashboard
	                datasetQuery.parameters.push({
	                    type: parameter.type,
	                    target: mapping.target,
	                    value: value
	                });
	            } else if (parameter.target) {
	                // inline target, e.x. on a card
	                datasetQuery.parameters.push({
	                    type: parameter.type,
	                    target: parameter.target,
	                    value: value
	                });
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return datasetQuery;
	}
	
	/** returns a question URL with parameters added to query string or MBQL filters */
	function questionUrlWithParameters(card, metadata, parameters) {
	    var parameterValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var parameterMappings = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	    var cardIsDirty = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
	
	    if (!card.dataset_query) {
	        return Urls.question(card.id);
	    }
	
	    card = _utils2.default.copy(card);
	
	    var cardParameters = getParameters(card);
	    var datasetQuery = applyParameters(card, parameters, parameterValues, parameterMappings);
	
	    // If we have a clean question without parameters applied, don't add the dataset query hash
	    if (!cardIsDirty && datasetQuery.parameters && datasetQuery.parameters.length === 0) {
	        return Urls.question(card.id);
	    }
	
	    var query = {};
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        var _loop = function _loop() {
	            var datasetParameter = _step2.value;
	
	            var cardParameter = _underscore2.default.find(cardParameters, function (p) {
	                return _utils2.default.equals(p.target, datasetParameter.target);
	            });
	            if (cardParameter) {
	                // if the card has a real parameter we can use, use that
	                query[cardParameter.slug] = datasetParameter.value;
	            } else if (isStructured(card)) {
	                // if the card is structured, try converting the parameter to an MBQL filter clause
	                var filter = (0, _Parameter.parameterToMBQLFilter)(datasetParameter, metadata);
	                if (filter) {
	                    card = (0, _icepick.updateIn)(card, ["dataset_query", "query"], function (query) {
	                        return Query.addFilter(query, filter);
	                    });
	                } else {
	                    console.warn("UNHANDLED PARAMETER", datasetParameter);
	                }
	            } else {
	                console.warn("UNHANDLED PARAMETER", datasetParameter);
	            }
	        };
	
	        for (var _iterator2 = (datasetQuery.parameters || [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            _loop();
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return Urls.question(null, card.dataset_query ? card : undefined, query);
	}

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getParametersBySlug = undefined;
	exports.getTemplateTagParameters = getTemplateTagParameters;
	exports.getParameterTargetFieldId = getParameterTargetFieldId;
	exports.dateParameterValueToMBQL = dateParameterValueToMBQL;
	exports.stringParameterValueToMBQL = stringParameterValueToMBQL;
	exports.numberParameterValueToMBQL = numberParameterValueToMBQL;
	exports.parameterToMBQLFilter = parameterToMBQLFilter;
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _util = __webpack_require__(870);
	
	var _schema_metadata = __webpack_require__(867);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NOTE: this should mirror `template-tag-parameters` in src/metabase/api/embed.clj
	function getTemplateTagParameters(tags) {
	    return tags.filter(function (tag) {
	        return tag.type != null && (tag.widget_type || tag.type !== "dimension");
	    }).map(function (tag) {
	        return {
	            id: tag.id,
	            type: tag.widget_type || (tag.type === "date" ? "date/single" : "category"),
	            target: tag.type === "dimension" ? ["dimension", ["template-tag", tag.name]] : ["variable", ["template-tag", tag.name]],
	            name: tag.display_name,
	            slug: tag.name,
	            default: tag.default
	        };
	    });
	}
	
	var getParametersBySlug = exports.getParametersBySlug = function getParametersBySlug(parameters, parameterValues) {
	    var result = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = parameters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var parameter = _step.value;
	
	            if (parameterValues[parameter.id] != undefined) {
	                result[parameter.slug] = parameterValues[parameter.id];
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return result;
	};
	
	/** Returns the field ID that this parameter target points to, or null if it's not a dimension target. */
	function getParameterTargetFieldId(target, datasetQuery) {
	    if (target && target[0] === "dimension") {
	        var dimension = target[1];
	        if (Array.isArray(dimension) && (0, _util.mbqlEq)(dimension[0], "template-tag")) {
	            if (datasetQuery.type === "native") {
	                var templateTag = datasetQuery.native.template_tags[String(dimension[1])];
	                if (templateTag && templateTag.type === "dimension") {
	                    return _query2.default.getFieldTargetId(templateTag.dimension);
	                }
	            }
	        } else {
	            return _query2.default.getFieldTargetId(dimension);
	        }
	    }
	    return null;
	}
	
	var timeParameterValueDeserializers = [{ testRegex: /^past([0-9]+)([a-z]+)s$/, deserialize: function deserialize(matches, fieldRef) {
	        return ["time-interval", fieldRef, -parseInt(matches[0]), matches[1]];
	    }
	}, { testRegex: /^next([0-9]+)([a-z]+)s$/, deserialize: function deserialize(matches, fieldRef) {
	        return ["time-interval", fieldRef, parseInt(matches[0]), matches[1]];
	    }
	}, { testRegex: /^this([a-z]+)$/, deserialize: function deserialize(matches, fieldRef) {
	        return ["time-interval", fieldRef, "current", matches[0]];
	    }
	}, { testRegex: /^~([0-9-T:]+)$/, deserialize: function deserialize(matches, fieldRef) {
	        return ["<", fieldRef, matches[0]];
	    }
	}, { testRegex: /^([0-9-T:]+)~$/, deserialize: function deserialize(matches, fieldRef) {
	        return [">", fieldRef, matches[0]];
	    }
	}, { testRegex: /^(\d{4}-\d{2})$/, deserialize: function deserialize(matches, fieldRef) {
	        return ["=", ["datetime-field", fieldRef, "month"], (0, _moment2.default)(matches[0], "YYYY-MM").format("YYYY-MM-DD")];
	    }
	}, { testRegex: /^(Q\d-\d{4})$/, deserialize: function deserialize(matches, fieldRef) {
	        return ["=", ["datetime-field", fieldRef, "quarter"], (0, _moment2.default)(matches[0], "[Q]Q-YYYY").format("YYYY-MM-DD")];
	    }
	}, { testRegex: /^([0-9-T:]+)$/, deserialize: function deserialize(matches, fieldRef) {
	        return ["=", fieldRef, matches[0]];
	    }
	},
	// TODO 3/27/17 Atte Keinänen
	// Unify BETWEEN -> between, IS_NULL -> is-null, NOT_NULL -> not-null throughout the codebase
	{ testRegex: /^([0-9-T:]+)~([0-9-T:]+)$/, deserialize: function deserialize(matches, fieldRef) {
	        return (
	            // $FlowFixMe
	            ["BETWEEN", fieldRef, matches[0], matches[1]]
	        );
	    }
	}];
	
	function dateParameterValueToMBQL(parameterValue, fieldRef) {
	    var deserializer = timeParameterValueDeserializers.find(function (des) {
	        return des.testRegex.test(parameterValue);
	    });
	
	    if (deserializer) {
	        var substringMatches = deserializer.testRegex.exec(parameterValue).splice(1);
	        return deserializer.deserialize(substringMatches, fieldRef);
	    } else {
	        return null;
	    }
	}
	
	function stringParameterValueToMBQL(parameterValue, fieldRef) {
	    return ["=", fieldRef, parameterValue];
	}
	
	function numberParameterValueToMBQL(parameterValue, fieldRef) {
	    return ["=", fieldRef, parseFloat(parameterValue)];
	}
	
	/** compiles a parameter with value to an MBQL clause */
	function parameterToMBQLFilter(parameter, metadata) {
	    if (!parameter.target || parameter.target[0] !== "dimension" || !Array.isArray(parameter.target[1]) || parameter.target[1][0] === "template-tag") {
	        return null;
	    }
	
	    // $FlowFixMe: doesn't understand parameter.target[1] is a field reference
	    var fieldRef = parameter.target[1];
	
	    if (parameter.type.indexOf("date/") === 0) {
	        return dateParameterValueToMBQL(parameter.value, fieldRef);
	    } else {
	        var fieldId = _query2.default.getFieldTargetId(fieldRef);
	        var field = metadata.fields[fieldId];
	        // if the field is numeric, parse the value as a number
	        if ((0, _schema_metadata.isNumericBaseType)(field)) {
	            return numberParameterValueToMBQL(parameter.value, fieldRef);
	        } else {
	            return stringParameterValueToMBQL(parameter.value, fieldRef);
	        }
	    }
	}

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.pivot = exports.updateDateTimeFilter = exports.breakout = exports.summarize = exports.plotSegmentField = exports.drillRecord = exports.drillUnderlyingRecords = exports.drillDownForDimensions = exports.addOrUpdateBreakout = exports.addOrUpdateFilter = exports.filter = exports.getFieldRefFromColumn = exports.toUnderlyingRecords = exports.toUnderlyingData = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*  weak */
	
	// legacy query lib
	
	
	var _drilldown = __webpack_require__(960);
	
	Object.defineProperty(exports, "drillDownForDimensions", {
	    enumerable: true,
	    get: function get() {
	        return _drilldown.drillDownForDimensions;
	    }
	});
	exports.updateLatLonFilter = updateLatLonFilter;
	exports.updateNumericFilter = updateNumericFilter;
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _util = __webpack_require__(870);
	
	var _Card = __webpack_require__(957);
	
	var Card = _interopRequireWildcard(_Card);
	
	var _query3 = __webpack_require__(887);
	
	var Query = _interopRequireWildcard(_query3);
	
	var _field = __webpack_require__(869);
	
	var Field = _interopRequireWildcard(_field);
	
	var _filter = __webpack_require__(890);
	
	var Filter = _interopRequireWildcard(_filter);
	
	var _card = __webpack_require__(865);
	
	var _dataset = __webpack_require__(877);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _time = __webpack_require__(876);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: use icepick instead of mutation, make they handle frozen cards
	
	var toUnderlyingData = exports.toUnderlyingData = function toUnderlyingData(card) {
	    var newCard = (0, _card.startNewCard)("query");
	    newCard.dataset_query = _utils2.default.copy(card.dataset_query);
	    newCard.display = "table";
	    newCard.original_card_id = card.id;
	    return newCard;
	};
	
	var toUnderlyingRecords = exports.toUnderlyingRecords = function toUnderlyingRecords(card) {
	    if (card.dataset_query.type === "query") {
	        var query = _utils2.default.copy(card.dataset_query).query;
	        var newCard = (0, _card.startNewCard)("query", card.dataset_query.database, query.source_table);
	        newCard.dataset_query.query.filter = query.filter;
	        return newCard;
	    }
	};
	
	var getFieldRefFromColumn = exports.getFieldRefFromColumn = function getFieldRefFromColumn(col) {
	    var fieldId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : col.id;
	
	    if (col.fk_field_id != null) {
	        return ["fk->", col.fk_field_id, fieldId];
	    } else {
	        return ["field-id", fieldId];
	    }
	};
	
	var clone = function clone(card) {
	    var newCard = (0, _card.startNewCard)("query");
	
	    newCard.display = card.display;
	    newCard.dataset_query = _utils2.default.copy(card.dataset_query);
	
	    // The Question lib doesn't always set a viz setting. Placing a check here, but we should probably refactor this
	    // into a separate test + clean up the question lib.
	    if (card.visualization_settings) {
	        newCard.visualization_settings = _utils2.default.copy(card.visualization_settings);
	    }
	
	    return newCard;
	};
	
	// Adds a new filter with the specified operator, column, and value
	var filter = exports.filter = function filter(card, operator, column, value) {
	    var newCard = clone(card);
	
	    // $FlowFixMe:
	    var filter = [operator, getFieldRefFromColumn(column), value];
	    newCard.dataset_query.query = Query.addFilter(newCard.dataset_query.query, filter);
	    return newCard;
	};
	
	var drillFilter = function drillFilter(card, value, column) {
	    var filter = void 0;
	    if ((0, _schema_metadata.isDate)(column)) {
	        filter = ["=", ["datetime-field", getFieldRefFromColumn(column), "as", column.unit], (0, _time.parseTimestamp)(value, column.unit).toISOString()];
	    } else {
	        var range = (0, _dataset.rangeForValue)(value, column);
	        if (range) {
	            filter = ["BETWEEN", getFieldRefFromColumn(column), range[0], range[1]];
	        } else {
	            filter = ["=", getFieldRefFromColumn(column), value];
	        }
	    }
	
	    return addOrUpdateFilter(card, filter);
	};
	
	var addOrUpdateFilter = exports.addOrUpdateFilter = function addOrUpdateFilter(card, filter) {
	    var newCard = clone(card);
	    // replace existing filter, if it exists
	    var filters = Query.getFilters(newCard.dataset_query.query);
	    for (var index = 0; index < filters.length; index++) {
	        if (Filter.isFieldFilter(filters[index]) && Field.getFieldTargetId(filters[index][1]) === Field.getFieldTargetId(filter[1])) {
	            newCard.dataset_query.query = Query.updateFilter(newCard.dataset_query.query, index, filter);
	            return newCard;
	        }
	    }
	
	    // otherwise add a new filter
	    newCard.dataset_query.query = Query.addFilter(newCard.dataset_query.query, filter);
	    return newCard;
	};
	
	var addOrUpdateBreakout = exports.addOrUpdateBreakout = function addOrUpdateBreakout(card, breakout) {
	    var newCard = clone(card);
	    // replace existing breakout, if it exists
	    var breakouts = Query.getBreakouts(newCard.dataset_query.query);
	    for (var index = 0; index < breakouts.length; index++) {
	        if ((0, _util.fieldIdsEq)(Field.getFieldTargetId(breakouts[index]), Field.getFieldTargetId(breakout))) {
	            newCard.dataset_query.query = Query.updateBreakout(newCard.dataset_query.query, index, breakout);
	            return newCard;
	        }
	    }
	
	    // otherwise add a new breakout
	    newCard.dataset_query.query = Query.addBreakout(newCard.dataset_query.query, breakout);
	    return newCard;
	};
	
	var UNITS = ["minute", "hour", "day", "week", "month", "quarter", "year"];
	var getNextUnit = function getNextUnit(unit) {
	    return UNITS[Math.max(0, UNITS.indexOf(unit) - 1)];
	};
	
	var drillUnderlyingRecords = exports.drillUnderlyingRecords = function drillUnderlyingRecords(card, dimensions) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = dimensions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var dimension = _step.value;
	
	            card = drillFilter(card, dimension.value, dimension.column);
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return toUnderlyingRecords(card);
	};
	
	var drillRecord = exports.drillRecord = function drillRecord(databaseId, tableId, fieldId, value) {
	    var newCard = (0, _card.startNewCard)("query", databaseId, tableId);
	    newCard.dataset_query.query = Query.addFilter(newCard.dataset_query.query, ["=", ["field-id", fieldId], value]);
	    return newCard;
	};
	
	var plotSegmentField = exports.plotSegmentField = function plotSegmentField(card) {
	    var newCard = (0, _card.startNewCard)("query");
	    newCard.display = "scatter";
	    newCard.dataset_query = _utils2.default.copy(card.dataset_query);
	    return newCard;
	};
	
	var summarize = exports.summarize = function summarize(card, aggregation, tableMetadata) {
	    var newCard = (0, _card.startNewCard)("query");
	    newCard.dataset_query = _utils2.default.copy(card.dataset_query);
	    newCard.dataset_query.query = Query.addAggregation(newCard.dataset_query.query, aggregation);
	    guessVisualization(newCard, tableMetadata);
	    return newCard;
	};
	
	var breakout = exports.breakout = function breakout(card, _breakout, tableMetadata) {
	    var newCard = (0, _card.startNewCard)("query");
	    newCard.dataset_query = _utils2.default.copy(card.dataset_query);
	    newCard.dataset_query.query = Query.addBreakout(newCard.dataset_query.query, _breakout);
	    guessVisualization(newCard, tableMetadata);
	    return newCard;
	};
	
	// min number of points when switching units
	var MIN_INTERVALS = 4;
	
	var updateDateTimeFilter = exports.updateDateTimeFilter = function updateDateTimeFilter(card, column, start, end) {
	    var newCard = clone(card);
	
	    var fieldRef = getFieldRefFromColumn(column);
	    start = (0, _moment2.default)(start);
	    end = (0, _moment2.default)(end);
	    if (column.unit) {
	        // start with the existing breakout unit
	        var unit = column.unit;
	
	        // clamp range to unit to ensure we select exactly what's represented by the dots/bars
	        start = start.add(1, unit).startOf(unit);
	        end = end.endOf(unit);
	
	        // find the largest unit with at least MIN_INTERVALS
	        while (unit !== getNextUnit(unit) && end.diff(start, unit) < MIN_INTERVALS) {
	            unit = getNextUnit(unit);
	        }
	
	        // update the breakout
	        newCard = addOrUpdateBreakout(newCard, ["datetime-field", fieldRef, "as", unit]);
	
	        // round to start of the original unit
	        start = start.startOf(column.unit);
	        end = end.startOf(column.unit);
	
	        if (start.isAfter(end)) {
	            return card;
	        }
	        if (start.isSame(end, column.unit)) {
	            // is the start and end are the same (in whatever the original unit was) then just do an "="
	            return addOrUpdateFilter(newCard, ["=", ["datetime-field", fieldRef, "as", column.unit], start.format()]);
	        } else {
	            // otherwise do a BETWEEN
	            return addOrUpdateFilter(newCard, ["BETWEEN", ["datetime-field", fieldRef, "as", column.unit], start.format(), end.format()]);
	        }
	    } else {
	        return addOrUpdateFilter(newCard, ["BETWEEN", fieldRef, start.format(), end.format()]);
	    }
	};
	
	function updateLatLonFilter(card, latitudeColumn, longitudeColumn, bounds) {
	    return addOrUpdateFilter(card, ["INSIDE", latitudeColumn.id, longitudeColumn.id, bounds.getNorth(), bounds.getWest(), bounds.getSouth(), bounds.getEast()]);
	}
	
	function updateNumericFilter(card, column, start, end) {
	    var fieldRef = getFieldRefFromColumn(column);
	    return addOrUpdateFilter(card, ["BETWEEN", fieldRef, start, end]);
	}
	
	var pivot = exports.pivot = function pivot(card, tableMetadata) {
	    var breakouts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var dimensions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	    if (card.dataset_query.type !== "query") {
	        return null;
	    }
	
	    var newCard = (0, _card.startNewCard)("query");
	    newCard.dataset_query = _utils2.default.copy(card.dataset_query);
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = dimensions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var dimension = _step2.value;
	
	            newCard = drillFilter(newCard, dimension.value, dimension.column);
	            var breakoutFields = Query.getBreakoutFields(newCard.dataset_query.query, tableMetadata);
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	                for (var _iterator4 = breakoutFields.entries()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var _step4$value = _slicedToArray(_step4.value, 2),
	                        index = _step4$value[0],
	                        field = _step4$value[1];
	
	                    if (field && (0, _util.fieldIdsEq)(field.id, dimension.column.id)) {
	                        newCard.dataset_query.query = Query.removeBreakout(newCard.dataset_query.query, index);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                        _iterator4.return();
	                    }
	                } finally {
	                    if (_didIteratorError4) {
	                        throw _iteratorError4;
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        for (var _iterator3 = breakouts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var _breakout2 = _step3.value;
	
	            newCard.dataset_query.query = Query.addBreakout(newCard.dataset_query.query, _breakout2);
	        }
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	
	    guessVisualization(newCard, tableMetadata);
	
	    return newCard;
	};
	
	// const VISUALIZATIONS_ONE_BREAKOUTS = new Set([
	//     "bar",
	//     "line",
	//     "area",
	//     "row",
	//     "pie",
	//     "map"
	// ]);
	var VISUALIZATIONS_TWO_BREAKOUTS = new Set(["bar", "line", "area"]);
	
	var guessVisualization = function guessVisualization(card, tableMetadata) {
	    var query = Card.getQuery(card);
	    if (!query) {
	        return;
	    }
	    var aggregations = Query.getAggregations(query);
	    var breakoutFields = Query.getBreakouts(query).map(function (breakout) {
	        return (_query2.default.getFieldTarget(breakout, tableMetadata) || {}).field;
	    });
	    if (aggregations.length === 0 && breakoutFields.length === 0) {
	        card.display = "table";
	    } else if (aggregations.length === 1 && breakoutFields.length === 0) {
	        card.display = "scalar";
	    } else if (aggregations.length === 1 && breakoutFields.length === 1) {
	        if ((0, _schema_metadata.isState)(breakoutFields[0])) {
	            card.display = "map";
	            card.visualization_settings["map.type"] = "region";
	            card.visualization_settings["map.region"] = "us_states";
	        } else if ((0, _schema_metadata.isCountry)(breakoutFields[0])) {
	            card.display = "map";
	            card.visualization_settings["map.type"] = "region";
	            card.visualization_settings["map.region"] = "world_countries";
	        } else if ((0, _schema_metadata.isDate)(breakoutFields[0])) {
	            card.display = "line";
	        } else {
	            card.display = "bar";
	        }
	    } else if (aggregations.length === 1 && breakoutFields.length === 2) {
	        if (!VISUALIZATIONS_TWO_BREAKOUTS.has(card.display)) {
	            if ((0, _schema_metadata.isDate)(breakoutFields[0])) {
	                card.display = "line";
	            } else if (_underscore2.default.all(breakoutFields, _schema_metadata.isCoordinate)) {
	                card.display = "map";
	                // NOTE Atte Keinänen 8/2/17: Heat/grid maps disabled in the first merged version of binning
	                // Currently show a pin map instead of heat map for double coordinate breakout
	                // This way the binning drill-through works in a somewhat acceptable way (although it is designed for heat maps)
	                card.visualization_settings["map.type"] = "pin";
	                // card.visualization_settings["map.type"] = "grid";
	            } else {
	                card.display = "bar";
	            }
	        }
	    } else {
	        console.warn("Couldn't guess visualization", card);
	        card.display = "table";
	    }
	};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.drillDownForDimensions = drillDownForDimensions;
	
	var _types = __webpack_require__(868);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _actions = __webpack_require__(959);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// Helpers for defining drill-down progressions
	var CategoryDrillDown = function CategoryDrillDown(type) {
	    return [function (field) {
	        return (0, _types.isa)(field.special_type, type);
	    }];
	};
	var DateTimeDrillDown = function DateTimeDrillDown(unit) {
	    return [["datetime-field", _schema_metadata.isDate, unit]];
	};
	var LatLonDrillDown = function LatLonDrillDown(binWidth) {
	    return [["binning-strategy", _schema_metadata.isLatitude, "bin-width", binWidth], ["binning-strategy", _schema_metadata.isLongitude, "bin-width", binWidth]];
	};
	
	/**
	 * Defines the built-in drill-down progressions
	 */
	var DEFAULT_DRILL_DOWN_PROGRESSIONS = [
	// DateTime drill downs
	[DateTimeDrillDown("year"), DateTimeDrillDown("quarter"), DateTimeDrillDown("month"), DateTimeDrillDown("week"), DateTimeDrillDown("day"), DateTimeDrillDown("hour"), DateTimeDrillDown("minute")],
	// Country => State => City
	[CategoryDrillDown(_types.TYPE.Country), CategoryDrillDown(_types.TYPE.State)
	// CategoryDrillDown(TYPE.City)
	],
	// Country, State, or City => LatLon
	[CategoryDrillDown(_types.TYPE.Country), LatLonDrillDown(10)], [CategoryDrillDown(_types.TYPE.State), LatLonDrillDown(1)], [CategoryDrillDown(_types.TYPE.City), LatLonDrillDown(0.1)],
	// LatLon drill downs
	[LatLonDrillDown(30), LatLonDrillDown(10), LatLonDrillDown(1), LatLonDrillDown(0.1), LatLonDrillDown(0.01)], [[["binning-strategy", _schema_metadata.isLatitude, "num-bins", function () {
	    return true;
	}], ["binning-strategy", _schema_metadata.isLongitude, "num-bins", function () {
	    return true;
	}]], LatLonDrillDown(1)],
	// generic num-bins drill down
	[[["binning-strategy", _schema_metadata.isAny, "num-bins", function () {
	    return true;
	}]], [["binning-strategy", _schema_metadata.isAny, "default"]]],
	// generic bin-width drill down
	[[["binning-strategy", _schema_metadata.isAny, "bin-width", function () {
	    return true;
	}]], [["binning-strategy", _schema_metadata.isAny, "bin-width", function (previous) {
	    return previous / 10;
	}]]]];
	
	/**
	 * Returns the next drill down for the current dimension objects
	 */
	function drillDownForDimensions(dimensions, metadata) {
	    var table = metadata && tableForDimensions(dimensions, metadata);
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = DEFAULT_DRILL_DOWN_PROGRESSIONS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var drillProgression = _step.value;
	
	            for (var index = 0; index < drillProgression.length - 1; index++) {
	                var currentDrillBreakoutTemplates = drillProgression[index];
	                var nextDrillBreakoutTemplates = drillProgression[index + 1];
	                if (breakoutTemplatesMatchDimensions(currentDrillBreakoutTemplates, dimensions)) {
	                    var breakouts = breakoutsForBreakoutTemplates(nextDrillBreakoutTemplates, dimensions, table);
	                    if (breakouts) {
	                        return {
	                            breakouts: breakouts
	                        };
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return null;
	}
	
	// Returns true if the supplied dimension object matches the supplied breakout template.
	function breakoutTemplateMatchesDimension(breakoutTemplate, dimension) {
	    var breakout = columnToBreakout(dimension.column);
	    if (Array.isArray(breakoutTemplate) !== Array.isArray(breakout)) {
	        return false;
	    }
	    if (Array.isArray(breakoutTemplate)) {
	        if (!breakoutTemplate[1](dimension.column)) {
	            return false;
	        }
	        for (var i = 2; i < breakoutTemplate.length; i++) {
	            if (typeof breakoutTemplate[i] === "function") {
	                // $FlowFixMe
	                if (!breakoutTemplate[i](breakout[i])) {
	                    return false;
	                }
	            } else {
	                // $FlowFixMe
	                if (breakoutTemplate[i] !== breakout[i]) {
	                    return false;
	                }
	            }
	        }
	        return true;
	    } else {
	        return breakoutTemplate(dimension.column);
	    }
	}
	
	// Returns true if all breakout templates having a matching dimension object, but disregarding order
	function breakoutTemplatesMatchDimensions(breakoutTemplates, dimensions) {
	    dimensions = [].concat(_toConsumableArray(dimensions));
	    return _underscore2.default.all(breakoutTemplates, function (breakoutTemplate) {
	        var index = _underscore2.default.findIndex(dimensions, function (dimension) {
	            return breakoutTemplateMatchesDimension(breakoutTemplate, dimension);
	        });
	        if (index >= 0) {
	            dimensions.splice(index, 1);
	            return true;
	        } else {
	            return false;
	        }
	    });
	}
	
	// Evaluates a breakout template, returning a completed breakout clause
	function breakoutForBreakoutTemplate(breakoutTemplate, dimensions, table) {
	    var fieldFilter = Array.isArray(breakoutTemplate) ? breakoutTemplate[1] : breakoutTemplate;
	    var dimensionColumns = dimensions.map(function (d) {
	        return d.column;
	    });
	    var field = _underscore2.default.find(dimensionColumns, fieldFilter) || _underscore2.default.find(table.fields, fieldFilter);
	    if (!field) {
	        return null;
	    }
	    var fieldRef = (0, _actions.getFieldRefFromColumn)(dimensions[0].column, field.id);
	    if (Array.isArray(breakoutTemplate)) {
	        var prevDimension = _underscore2.default.find(dimensions, function (dimension) {
	            return breakoutTemplateMatchesDimension(breakoutTemplate, dimension);
	        });
	        var breakout = [breakoutTemplate[0], fieldRef];
	        for (var i = 2; i < breakoutTemplate.length; i++) {
	            var arg = breakoutTemplate[i];
	            if (typeof arg === "function") {
	                if (!prevDimension) {
	                    return null;
	                }
	                var prevBreakout = columnToBreakout(prevDimension.column);
	                // $FlowFixMe
	                breakout.push(arg(prevBreakout[i]));
	            } else {
	                breakout.push(arg);
	            }
	        }
	        return breakout;
	    } else {
	        return fieldRef;
	    }
	}
	
	// Evaluates all the breakout templates of a drill
	function breakoutsForBreakoutTemplates(breakoutTemplates, dimensions, table) {
	    var breakouts = [];
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = breakoutTemplates[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var breakoutTemplate = _step2.value;
	
	            var breakout = breakoutForBreakoutTemplate(breakoutTemplate, dimensions, table);
	            if (!breakout) {
	                return null;
	            }
	            breakouts.push(breakout);
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return breakouts;
	}
	
	// Guesses the breakout corresponding to the provided columm object
	function columnToBreakout(column) {
	    if (column.unit) {
	        return ["datetime-field", column.id, column.unit];
	    } else if (column.binning_info) {
	        var binningStrategy = column.binning_info.binning_strategy;
	
	        switch (binningStrategy) {
	            case "bin-width":
	                return ["binning-strategy", column.id, "bin-width", column.binning_info.bin_width];
	            case "num-bins":
	                return ["binning-strategy", column.id, "num-bins", column.binning_info.num_bins];
	            default:
	                return null;
	        }
	    } else {
	        return column.id;
	    }
	}
	
	// returns the table metadata for a dimension
	function tableForDimensions(dimensions, metadata) {
	    var fieldId = (0, _icepick.getIn)(dimensions, [0, "column", "id"]);
	    var field = metadata.fields[fieldId];
	    return field && field.table;
	}

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _modes = __webpack_require__(962);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Mode = function () {
	    function Mode(question, queryMode) {
	        _classCallCheck(this, Mode);
	
	        this._question = question;
	        this._queryMode = queryMode;
	    }
	
	    _createClass(Mode, [{
	        key: "queryMode",
	        value: function queryMode() {
	            return this._queryMode;
	        }
	    }, {
	        key: "name",
	        value: function name() {
	            return this._queryMode.name;
	        }
	    }, {
	        key: "actions",
	        value: function actions(settings) {
	            var _this = this;
	
	            return _underscore2.default.flatten(this._queryMode.actions.map(function (actionCreator) {
	                return actionCreator({ question: _this._question, settings: settings });
	            }));
	        }
	    }, {
	        key: "actionsForClick",
	        value: function actionsForClick(clicked, settings) {
	            var _this2 = this;
	
	            return _underscore2.default.flatten(this._queryMode.drills.map(function (actionCreator) {
	                return actionCreator({ question: _this2._question, settings: settings, clicked: clicked });
	            }));
	        }
	    }], [{
	        key: "forQuestion",
	        value: function forQuestion(question) {
	            // TODO Atte Keinänen 6/22/17: Move getMode here and refactor it after writing tests
	            var card = question.card();
	            var tableMetadata = question.tableMetadata();
	            var queryMode = (0, _modes.getMode)(card, tableMetadata);
	
	            if (queryMode) {
	                return new Mode(question, queryMode);
	            } else {
	                return null;
	            }
	        }
	    }]);
	
	    return Mode;
	}();
	
	exports.default = Mode;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getMode = getMode;
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _query3 = __webpack_require__(887);
	
	var Query = _interopRequireWildcard(_query3);
	
	var _Card = __webpack_require__(957);
	
	var Card = _interopRequireWildcard(_Card);
	
	var _ObjectMode = __webpack_require__(963);
	
	var _ObjectMode2 = _interopRequireDefault(_ObjectMode);
	
	var _SegmentMode = __webpack_require__(965);
	
	var _SegmentMode2 = _interopRequireDefault(_SegmentMode);
	
	var _MetricMode = __webpack_require__(1046);
	
	var _MetricMode2 = _interopRequireDefault(_MetricMode);
	
	var _TimeseriesMode = __webpack_require__(1055);
	
	var _TimeseriesMode2 = _interopRequireDefault(_TimeseriesMode);
	
	var _GeoMode = __webpack_require__(1064);
	
	var _GeoMode2 = _interopRequireDefault(_GeoMode);
	
	var _PivotMode = __webpack_require__(1065);
	
	var _PivotMode2 = _interopRequireDefault(_PivotMode);
	
	var _NativeMode = __webpack_require__(1066);
	
	var _NativeMode2 = _interopRequireDefault(_NativeMode);
	
	var _DefaultMode = __webpack_require__(1068);
	
	var _DefaultMode2 = _interopRequireDefault(_DefaultMode);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// legacy query lib
	function getMode(card, tableMetadata) {
	    if (!card) {
	        return null;
	    }
	
	    if (Card.isNative(card)) {
	        return _NativeMode2.default;
	    }
	
	    var query = Card.getQuery(card);
	    if (Card.isStructured(card) && query) {
	        if (!tableMetadata) {
	            return null;
	        }
	
	        var aggregations = Query.getAggregations(query);
	        var breakouts = Query.getBreakouts(query);
	        var filters = Query.getFilters(query);
	
	        if (aggregations.length === 0 && breakouts.length === 0) {
	            var isPKFilter = function isPKFilter(filter) {
	                if (tableMetadata && Array.isArray(filter) && filter[0] === "=") {
	                    var fieldId = _query2.default.getFieldTargetId(filter[1]);
	                    var field = tableMetadata.fields_lookup[fieldId];
	                    if (field && field.table.id === query.source_table && (0, _schema_metadata.isPK)(field)) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	            if (_underscore2.default.any(filters, isPKFilter)) {
	                return _ObjectMode2.default;
	            } else {
	                return _SegmentMode2.default;
	            }
	        }
	        if (aggregations.length > 0 && breakouts.length === 0) {
	            return _MetricMode2.default;
	        }
	        if (aggregations.length > 0 && breakouts.length > 0) {
	            var breakoutFields = breakouts.map(function (breakout) {
	                return (_query2.default.getFieldTarget(breakout, tableMetadata) || {}).field;
	            });
	            if (breakoutFields.length === 1 && (0, _schema_metadata.isDate)(breakoutFields[0]) || breakoutFields.length === 2 && (0, _schema_metadata.isDate)(breakoutFields[0]) && (0, _schema_metadata.isCategory)(breakoutFields[1])) {
	                return _TimeseriesMode2.default;
	            }
	            if (breakoutFields.length === 1 && (0, _schema_metadata.isAddress)(breakoutFields[0])) {
	                return _GeoMode2.default;
	            }
	            if (breakoutFields.length === 1 && (0, _schema_metadata.isCategory)(breakoutFields[0]) || breakoutFields.length === 2 && (0, _schema_metadata.isCategory)(breakoutFields[0]) && (0, _schema_metadata.isCategory)(breakoutFields[1])) {
	                return _PivotMode2.default;
	            }
	        }
	    }
	
	    return _DefaultMode2.default;
	} /*  weak */

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ObjectDetailDrill = __webpack_require__(964);
	
	var _ObjectDetailDrill2 = _interopRequireDefault(_ObjectDetailDrill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ObjectMode = {
	    name: "object",
	    actions: [],
	    drills: [_ObjectDetailDrill2.default]
	};
	
	exports.default = ObjectMode;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _schema_metadata = __webpack_require__(867);
	
	exports.default = function (_ref) {
	    var _question = _ref.question,
	        clicked = _ref.clicked;
	
	    if (!clicked || !clicked.column || clicked.value === undefined || !((0, _schema_metadata.isFK)(clicked.column) || (0, _schema_metadata.isPK)(clicked.column))) {
	        return [];
	    }
	
	    // $FlowFixMe
	    var field = _question.metadata().fields[clicked.column.id];
	    if (!field) {
	        return [];
	    }
	
	    if (field.target) {
	        field = field.target;
	    }
	
	    if (!clicked) {
	        return [];
	    }
	
	    return [{
	        name: "object-detail",
	        section: "details",
	        title: "View details",
	        default: true,
	        question: function question() {
	            return _question.drillPK(field, clicked && clicked.value);
	        }
	    }];
	};

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(966);
	
	var _drill = __webpack_require__(969);
	
	var _SummarizeBySegmentMetricAction = __webpack_require__(974);
	
	var _SummarizeBySegmentMetricAction2 = _interopRequireDefault(_SummarizeBySegmentMetricAction);
	
	var _CommonMetricsAction = __webpack_require__(1040);
	
	var _CommonMetricsAction2 = _interopRequireDefault(_CommonMetricsAction);
	
	var _CountByTimeAction = __webpack_require__(1041);
	
	var _CountByTimeAction2 = _interopRequireDefault(_CountByTimeAction);
	
	var _XRaySegment = __webpack_require__(1042);
	
	var _XRaySegment2 = _interopRequireDefault(_XRaySegment);
	
	var _SummarizeColumnDrill = __webpack_require__(1043);
	
	var _SummarizeColumnDrill2 = _interopRequireDefault(_SummarizeColumnDrill);
	
	var _SummarizeColumnByTimeDrill = __webpack_require__(1044);
	
	var _SummarizeColumnByTimeDrill2 = _interopRequireDefault(_SummarizeColumnByTimeDrill);
	
	var _CountByColumnDrill = __webpack_require__(1045);
	
	var _CountByColumnDrill2 = _interopRequireDefault(_CountByColumnDrill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// import PlotSegmentField from "../actions/PlotSegmentField";
	
	var SegmentMode = {
	    name: "segment",
	    actions: [].concat(_toConsumableArray(_actions.DEFAULT_ACTIONS), [_CommonMetricsAction2.default, _CountByTimeAction2.default, _XRaySegment2.default, _SummarizeBySegmentMetricAction2.default
	    // commenting this out until we sort out viz settings in QB2
	    // PlotSegmentField
	    ]),
	    drills: [].concat(_toConsumableArray(_drill.DEFAULT_DRILLS), [_SummarizeColumnDrill2.default, _SummarizeColumnByTimeDrill2.default, _CountByColumnDrill2.default])
	};
	
	exports.default = SegmentMode;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_ACTIONS = undefined;
	
	var _UnderlyingDataAction = __webpack_require__(967);
	
	var _UnderlyingDataAction2 = _interopRequireDefault(_UnderlyingDataAction);
	
	var _UnderlyingRecordsAction = __webpack_require__(968);
	
	var _UnderlyingRecordsAction2 = _interopRequireDefault(_UnderlyingRecordsAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_ACTIONS = exports.DEFAULT_ACTIONS = [_UnderlyingDataAction2.default, _UnderlyingRecordsAction2.default];

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var _question = _ref.question;
	
	    if (_question.display() !== "table" && _question.display() !== "scalar") {
	        return [{
	            name: "underlying-data",
	            title: "View this as a table",
	            icon: "table",
	            question: function question() {
	                return _question.toUnderlyingData();
	            }
	        }];
	    }
	    return [];
	};

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var _question = _ref.question;
	
	    var query = _question.query();
	    if (!(query instanceof _StructuredQuery2.default) || query.isBareRows()) {
	        return [];
	    }
	
	    return [{
	        name: "underlying-records",
	        title: _react2.default.createElement(
	            "span",
	            null,
	            "View the underlying",
	            " ",
	            _react2.default.createElement(
	                "span",
	                { className: "text-dark" },
	                query.table().display_name
	            ),
	            " ",
	            "records"
	        ),
	        icon: "table2",
	        question: function question() {
	            return _question.toUnderlyingRecords();
	        }
	    }];
	};

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DEFAULT_DRILLS = undefined;
	
	var _SortAction = __webpack_require__(970);
	
	var _SortAction2 = _interopRequireDefault(_SortAction);
	
	var _ObjectDetailDrill = __webpack_require__(964);
	
	var _ObjectDetailDrill2 = _interopRequireDefault(_ObjectDetailDrill);
	
	var _QuickFilterDrill = __webpack_require__(971);
	
	var _QuickFilterDrill2 = _interopRequireDefault(_QuickFilterDrill);
	
	var _UnderlyingRecordsDrill = __webpack_require__(972);
	
	var _UnderlyingRecordsDrill2 = _interopRequireDefault(_UnderlyingRecordsDrill);
	
	var _ZoomDrill = __webpack_require__(973);
	
	var _ZoomDrill2 = _interopRequireDefault(_ZoomDrill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_DRILLS = exports.DEFAULT_DRILLS = [_ZoomDrill2.default, _SortAction2.default, _ObjectDetailDrill2.default, _QuickFilterDrill2.default, _UnderlyingRecordsDrill2.default];

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var question = _ref.question,
	        clicked = _ref.clicked;
	
	    var query = question.query();
	    if (!(query instanceof _StructuredQuery2.default)) {
	        return [];
	    }
	
	    if (!clicked || !clicked.column || clicked.value !== undefined || !clicked.column.source) {
	        return [];
	    }
	    var column = clicked.column;
	
	
	    var fieldRef = query.fieldReferenceForColumn(column);
	    if (!fieldRef) {
	        return [];
	    }
	
	    var _ref2 = query.sorts()[0] || [],
	        _ref3 = _slicedToArray(_ref2, 2),
	        sortFieldRef = _ref3[0],
	        sortDirection = _ref3[1];
	
	    var isAlreadySorted = sortFieldRef != null && _query2.default.isSameField(sortFieldRef, fieldRef);
	
	    var actions = [];
	    if (!isAlreadySorted || sortDirection === "descending" || sortDirection === "desc") {
	        actions.push({
	            name: "sort-ascending",
	            section: "sort",
	            title: "Ascending",
	            question: function question() {
	                return query.replaceSort([fieldRef, "ascending"]).question();
	            }
	        });
	    }
	    if (!isAlreadySorted || sortDirection === "ascending" || sortDirection === "asc") {
	        actions.push({
	            name: "sort-descending",
	            section: "sort",
	            title: "Descending",
	            question: function question() {
	                return query.replaceSort([fieldRef, "descending"]).question();
	            }
	        });
	    }
	    return actions;
	};

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _types = __webpack_require__(868);
	
	var _formatting = __webpack_require__(872);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFiltersForColumn(column) {
	    if ((0, _types.isa)(column.base_type, _types.TYPE.Number) || (0, _types.isa)(column.base_type, _types.TYPE.DateTime)) {
	        return [{ name: "<", operator: "<" }, { name: "=", operator: "=" }, { name: "≠", operator: "!=" }, { name: ">", operator: ">" }];
	    } else {
	        return [{ name: "=", operator: "=" }, { name: "≠", operator: "!=" }];
	    }
	}
	
	exports.default = function (_ref) {
	    var _question = _ref.question,
	        clicked = _ref.clicked;
	
	    var query = _question.query();
	    if (!(query instanceof _StructuredQuery2.default) || !clicked || !clicked.column || clicked.column.id == null || clicked.value == undefined) {
	        return [];
	    }
	
	    var value = clicked.value,
	        column = clicked.column;
	
	
	    if ((0, _types.isPK)(column.special_type)) {
	        return [];
	    }
	    if ((0, _types.isFK)(column.special_type)) {
	        return [{
	            name: "view-fks",
	            section: "filter",
	            title: _react2.default.createElement(
	                "span",
	                null,
	                "View this",
	                " ",
	                (0, _formatting.singularize)((0, _formatting.stripId)(column.display_name)),
	                "'s",
	                " ",
	                (0, _formatting.pluralize)(query.table().display_name)
	            ),
	            question: function question() {
	                return _question.filter("=", column, value);
	            }
	        }];
	    }
	
	    var operators = getFiltersForColumn(column) || [];
	    return operators.map(function (_ref2) {
	        var name = _ref2.name,
	            operator = _ref2.operator;
	        return {
	            name: operator,
	            section: "filter",
	            title: _react2.default.createElement(
	                "span",
	                { className: "h2" },
	                name
	            ),
	            question: function question() {
	                return _question.filter(operator, column, value);
	            }
	        };
	    });
	};

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _formatting = __webpack_require__(872);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var _question = _ref.question,
	        clicked = _ref.clicked;
	
	    var query = _question.query();
	    if (!(query instanceof _StructuredQuery2.default)) {
	        return [];
	    }
	
	    var dimensions = clicked && clicked.dimensions || [];
	    if (!clicked || dimensions.length === 0) {
	        return [];
	    }
	
	    // the metric value should be the number of rows that will be displayed
	    var count = typeof clicked.value === "number" ? clicked.value : 2;
	
	    return [{
	        name: "underlying-records",
	        section: "records",
	        title: "View " + (0, _formatting.inflect)("these", count, "this", "these") + " " + (0, _formatting.inflect)(query.table().display_name, count),
	        question: function question() {
	            return _question.drillUnderlyingRecords(dimensions);
	        }
	    }];
	};

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(959);
	
	exports.default = function (_ref) {
	    var _question = _ref.question,
	        clicked = _ref.clicked,
	        settings = _ref.settings;
	
	    var dimensions = clicked && clicked.dimensions || [];
	    var drilldown = (0, _actions.drillDownForDimensions)(dimensions, _question.metadata());
	    if (!drilldown) {
	        return [];
	    }
	
	    return [{
	        name: "timeseries-zoom",
	        section: "zoom",
	        title: "Zoom in",
	        question: function question() {
	            return _question.pivot(drilldown.breakouts, dimensions);
	        }
	    }];
	};

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	var _AggregationPopover = __webpack_require__(975);
	
	var _AggregationPopover2 = _interopRequireDefault(_AggregationPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var omittedAggregations = ["rows", "cum_sum", "cum_count", "stddev"];
	
	var getAggregationOptionsForSummarize = function getAggregationOptionsForSummarize(query) {
	    return query.table().aggregations().filter(function (aggregation) {
	        return !omittedAggregations.includes(aggregation.short);
	    });
	};
	
	exports.default = function (_ref) {
	    var question = _ref.question;
	
	    var query = question.query();
	    if (!(query instanceof _StructuredQuery2.default)) {
	        return [];
	    }
	
	    var tableMetadata = query.table();
	
	    return [{
	        name: "summarize",
	        title: "Summarize this segment",
	        icon: "sum",
	        // eslint-disable-next-line react/display-name
	        popover: function popover(_ref2) {
	            var onChangeCardAndRun = _ref2.onChangeCardAndRun,
	                onClose = _ref2.onClose;
	            return _react2.default.createElement(_AggregationPopover2.default, {
	                query: query,
	                tableMetadata: tableMetadata,
	                customFields: query.expressions(),
	                availableAggregations: getAggregationOptionsForSummarize(query),
	                onCommitAggregation: function onCommitAggregation(aggregation) {
	                    onChangeCardAndRun({
	                        nextCard: question.summarize(aggregation).card()
	                    });
	                    onClose && onClose();
	                },
	                onClose: onClose,
	                showOnlyProvidedAggregations: true
	            });
	        }
	    }];
	};

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AggregationPopover = __webpack_require__(976);
	
	var _AggregationPopover2 = _interopRequireDefault(_AggregationPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AggregationPopover = function AggregationPopover(props) {
	    return _react2.default.createElement(_AggregationPopover2.default, _extends({}, props, { aggregation: props.aggregation || [] }));
	};
	
	AggregationPopover.displayName = "AggregationPopover";
	exports.default = AggregationPopover;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AccordianList = __webpack_require__(977);
	
	var _AccordianList2 = _interopRequireDefault(_AccordianList);
	
	var _FieldList = __webpack_require__(979);
	
	var _FieldList2 = _interopRequireDefault(_FieldList);
	
	var _QueryDefinitionTooltip = __webpack_require__(982);
	
	var _QueryDefinitionTooltip2 = _interopRequireDefault(_QueryDefinitionTooltip);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _ExpressionEditorTextfield = __webpack_require__(1008);
	
	var _ExpressionEditorTextfield2 = _interopRequireDefault(_ExpressionEditorTextfield);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CUSTOM_SECTION_NAME = "Custom Expression";
	var METRICS_SECTION_NAME = "Common Metrics";
	
	var AggregationPopover = (_temp = _class = function (_Component) {
	    _inherits(AggregationPopover, _Component);
	
	    function AggregationPopover(props, context) {
	        _classCallCheck(this, AggregationPopover);
	
	        var _this = _possibleConstructorReturn(this, (AggregationPopover.__proto__ || Object.getPrototypeOf(AggregationPopover)).call(this, props, context));
	
	        _this.state = {
	            aggregation: props.isNew ? [] : props.aggregation,
	            choosingField: props.aggregation && props.aggregation.length > 1 && _query.AggregationClause.isStandard(props.aggregation),
	            editingAggregation: props.aggregation && props.aggregation.length > 1 && _query.AggregationClause.isCustom(props.aggregation)
	        };
	
	        _underscore2.default.bindAll(_this, "commitAggregation", "onPickAggregation", "onPickField", "onClearAggregation");
	        return _this;
	    }
	
	    _createClass(AggregationPopover, [{
	        key: "commitAggregation",
	        value: function commitAggregation(aggregation) {
	            this.props.onCommitAggregation(aggregation);
	            this.props.onClose();
	        }
	    }, {
	        key: "onPickAggregation",
	        value: function onPickAggregation(agg) {
	            // check if this aggregation requires a field, if so then force user to pick that now, otherwise we are done
	            if (agg.custom) {
	                this.setState({
	                    aggregation: agg.value,
	                    editingAggregation: true
	                });
	            } else if (agg.aggregation && agg.aggregation.requiresField) {
	                this.setState({
	                    aggregation: agg.value,
	                    choosingField: true
	                });
	            } else {
	                // this includse picking a METRIC or picking an aggregation which doesn't require a field
	                this.commitAggregation(agg.value);
	            }
	        }
	    }, {
	        key: "onPickField",
	        value: function onPickField(fieldId) {
	            this.commitAggregation(_query.AggregationClause.setField(this.state.aggregation, fieldId));
	        }
	    }, {
	        key: "onClearAggregation",
	        value: function onClearAggregation() {
	            this.setState({
	                choosingField: false,
	                editingAggregation: false
	            });
	        }
	    }, {
	        key: "getAvailableAggregations",
	        value: function getAvailableAggregations() {
	            var _props = this.props,
	                availableAggregations = _props.availableAggregations,
	                query = _props.query;
	
	            return availableAggregations || query.table().aggregations();
	        }
	    }, {
	        key: "getCustomFields",
	        value: function getCustomFields() {
	            var _props2 = this.props,
	                customFields = _props2.customFields,
	                datasetQuery = _props2.datasetQuery;
	
	            return customFields || datasetQuery && _query2.default.getExpressions(datasetQuery.query);
	        }
	    }, {
	        key: "itemIsSelected",
	        value: function itemIsSelected(item) {
	            var aggregation = this.props.aggregation;
	
	            return item.isSelected(_query.NamedClause.getContent(aggregation));
	        }
	    }, {
	        key: "renderItemExtra",
	        value: function renderItemExtra(item, itemIndex) {
	            if (item.aggregation && item.aggregation.description) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "p1" },
	                    _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: item.aggregation.description },
	                        _react2.default.createElement("span", { className: "QuestionTooltipTarget" })
	                    )
	                );
	            } else if (item.metric) {
	                return this.renderMetricTooltip(item.metric);
	            }
	        }
	    }, {
	        key: "renderMetricTooltip",
	        value: function renderMetricTooltip(metric) {
	            var tableMetadata = this.props.tableMetadata;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "p1" },
	                _react2.default.createElement(
	                    _Tooltip2.default,
	                    { tooltip: _react2.default.createElement(_QueryDefinitionTooltip2.default, { type: "metric", object: metric, tableMetadata: tableMetadata }) },
	                    _react2.default.createElement("span", { className: "QuestionTooltipTarget" })
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props3 = this.props,
	                query = _props3.query,
	                tableMetadata = _props3.tableMetadata,
	                showOnlyProvidedAggregations = _props3.showOnlyProvidedAggregations;
	
	
	            var customFields = this.getCustomFields();
	            var availableAggregations = this.getAvailableAggregations();
	
	            var _state = this.state,
	                choosingField = _state.choosingField,
	                editingAggregation = _state.editingAggregation;
	
	            var aggregation = _query.NamedClause.getContent(this.state.aggregation);
	
	            var selectedAggregation = void 0;
	            if (_query.AggregationClause.isMetric(aggregation)) {
	                selectedAggregation = _underscore2.default.findWhere(tableMetadata.metrics, { id: _query.AggregationClause.getMetric(aggregation) });
	            } else if (_query.AggregationClause.getOperator(aggregation)) {
	                selectedAggregation = _underscore2.default.findWhere(availableAggregations, { short: _query.AggregationClause.getOperator(aggregation) });
	            }
	
	            var sections = [];
	            var customExpressionIndex = null;
	
	            if (availableAggregations.length > 0) {
	                sections.push({
	                    name: showOnlyProvidedAggregations ? null : "Metabasics",
	                    items: availableAggregations.map(function (aggregation) {
	                        return {
	                            name: aggregation.name,
	                            value: [aggregation.short].concat(aggregation.fields.map(function (field) {
	                                return null;
	                            })),
	                            isSelected: function isSelected(agg) {
	                                return !_query.AggregationClause.isCustom(agg) && _query.AggregationClause.getAggregation(agg) === aggregation.short;
	                            },
	                            aggregation: aggregation
	                        };
	                    }),
	                    icon: showOnlyProvidedAggregations ? null : "table2"
	                });
	            }
	
	            if (!showOnlyProvidedAggregations) {
	                // we only want to consider active metrics, with the ONE exception that if the currently selected aggregation is a
	                // retired metric then we include it in the list to maintain continuity
	                var metrics = tableMetadata.metrics && tableMetadata.metrics.filter(function (mtrc) {
	                    return mtrc.is_active === true || selectedAggregation && selectedAggregation.id === mtrc.id;
	                });
	                if (metrics && metrics.length > 0) {
	                    sections.push({
	                        name: METRICS_SECTION_NAME,
	                        items: metrics.map(function (metric) {
	                            return {
	                                name: metric.name,
	                                value: ["METRIC", metric.id],
	                                isSelected: function isSelected(aggregation) {
	                                    return _query.AggregationClause.getMetric(aggregation) === metric.id;
	                                },
	                                metric: metric
	                            };
	                        }),
	                        icon: "staroutline"
	                    });
	                }
	
	                customExpressionIndex = sections.length;
	                if (tableMetadata.db.features.indexOf("expression-aggregations") >= 0) {
	                    sections.push({
	                        name: CUSTOM_SECTION_NAME,
	                        icon: "staroutline"
	                    });
	                }
	            }
	
	            if (sections.length === 1) {
	                sections[0].name = null;
	            }
	
	            if (editingAggregation) {
	                return _react2.default.createElement(
	                    "div",
	                    { style: { width: editingAggregation ? 500 : 300 } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "text-grey-3 p1 py2 border-bottom flex align-center" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "cursor-pointer flex align-center", onClick: this.onClearAggregation },
	                            _react2.default.createElement(_Icon2.default, { name: "chevronleft", size: 18 }),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "inline-block pl1" },
	                                CUSTOM_SECTION_NAME
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "p1" },
	                        _react2.default.createElement(_ExpressionEditorTextfield2.default, {
	                            startRule: "aggregation",
	                            expression: aggregation,
	                            tableMetadata: tableMetadata,
	                            customFields: customFields,
	                            onChange: function onChange(parsedExpression) {
	                                return _this2.setState({
	                                    aggregation: _query.NamedClause.setContent(_this2.state.aggregation, parsedExpression),
	                                    error: null
	                                });
	                            },
	                            onError: function onError(errorMessage) {
	                                return _this2.setState({
	                                    error: errorMessage
	                                });
	                            }
	                        }),
	                        this.state.error != null && (Array.isArray(this.state.error) ? this.state.error.map(function (error) {
	                            return _react2.default.createElement(
	                                "div",
	                                { className: "text-error mb1", style: { whiteSpace: "pre-wrap" } },
	                                error.message
	                            );
	                        }) : _react2.default.createElement(
	                            "div",
	                            { className: "text-error mb1" },
	                            this.state.error.message
	                        )),
	                        _react2.default.createElement("input", {
	                            className: "input block full my1",
	                            value: _query.NamedClause.getName(this.state.aggregation),
	                            onChange: function onChange(e) {
	                                return _this2.setState({
	                                    aggregation: e.target.value ? _query.NamedClause.setName(aggregation, e.target.value) : aggregation
	                                });
	                            },
	                            placeholder: "Name (optional)"
	                        }),
	                        _react2.default.createElement(
	                            _Button2.default,
	                            { className: "full", primary: true, disabled: this.state.error, onClick: function onClick() {
	                                    return _this2.commitAggregation(_this2.state.aggregation);
	                                } },
	                            "Done"
	                        )
	                    )
	                );
	            } else if (choosingField) {
	                var _aggregation = _slicedToArray(aggregation, 2),
	                    agg = _aggregation[0],
	                    fieldId = _aggregation[1];
	
	                return _react2.default.createElement(
	                    "div",
	                    { style: { minWidth: 300 } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "text-grey-3 p1 py2 border-bottom flex align-center" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "cursor-pointer flex align-center", onClick: this.onClearAggregation },
	                            _react2.default.createElement(_Icon2.default, { name: "chevronleft", size: 18 }),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "inline-block pl1" },
	                                selectedAggregation.name
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_FieldList2.default, {
	                        className: "text-green",
	                        tableMetadata: tableMetadata,
	                        field: fieldId,
	                        fieldOptions: query.aggregationFieldOptions(agg),
	                        customFieldOptions: customFields,
	                        onFieldChange: this.onPickField,
	                        enableSubDimensions: false
	                    })
	                );
	            } else {
	                return _react2.default.createElement(_AccordianList2.default, {
	                    className: "text-green",
	                    sections: sections,
	                    onChange: this.onPickAggregation,
	                    itemIsSelected: this.itemIsSelected.bind(this),
	                    renderSectionIcon: function renderSectionIcon(s) {
	                        return _react2.default.createElement(_Icon2.default, { name: s.icon, size: 18 });
	                    },
	                    renderItemExtra: this.renderItemExtra.bind(this),
	                    getItemClasses: function getItemClasses(item) {
	                        return item.metric && !item.metric.is_active ? "text-grey-3" : null;
	                    },
	                    onChangeSection: function onChangeSection(index) {
	                        if (index === customExpressionIndex) {
	                            _this2.onPickAggregation({
	                                custom: true,
	                                value: aggregation !== "rows" && !_underscore2.default.isEqual(aggregation, ["rows"]) ? aggregation : null
	                            });
	                        }
	                    }
	                });
	            }
	        }
	    }]);
	
	    return AggregationPopover;
	}(_react.Component), _class.propTypes = {
	    isNew: _propTypes2.default.bool,
	    aggregation: _propTypes2.default.array,
	    onCommitAggregation: _propTypes2.default.func.isRequired,
	    onClose: _propTypes2.default.func.isRequired,
	    tableMetadata: _propTypes2.default.object.isRequired,
	    datasetQuery: _propTypes2.default.object,
	    customFields: _propTypes2.default.object,
	    availableAggregations: _propTypes2.default.array,
	    // Restricts the shown options to contents of `availableActions` only
	    showOnlyProvidedAggregations: _propTypes2.default.boolean
	}, _temp);
	AggregationPopover.displayName = "AggregationPopover";
	exports.default = AggregationPopover;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _dom = __webpack_require__(859);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ListSearchField = __webpack_require__(978);
	
	var _ListSearchField2 = _interopRequireDefault(_ListSearchField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccordianList = (_temp = _class = function (_Component) {
	    _inherits(AccordianList, _Component);
	
	    function AccordianList(props, context) {
	        _classCallCheck(this, AccordianList);
	
	        var _this = _possibleConstructorReturn(this, (AccordianList.__proto__ || Object.getPrototypeOf(AccordianList)).call(this, props, context));
	
	        var openSection = void 0;
	        // use initiallyOpenSection prop if present
	        if (props.initiallyOpenSection !== undefined) {
	            openSection = props.initiallyOpenSection;
	        }
	        // otherwise try to find the selected section, if any
	        if (openSection === undefined) {
	            openSection = _underscore2.default.findIndex(props.sections, function (section, index) {
	                return _this.sectionIsSelected(section, index);
	            });
	            if (openSection === -1) {
	                openSection = undefined;
	            }
	        }
	        // default to the first section
	        if (openSection === undefined) {
	            openSection = 0;
	        }
	
	        _this.state = {
	            openSection: openSection,
	            searchText: ""
	        };
	        return _this;
	    }
	
	    _createClass(AccordianList, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            // when the component is mounted and an item is selected then scroll to it
	            var element = this.refs.selected && _reactDom2.default.findDOMNode(this.refs.selected);
	            if (element && element.scrollIntoView && !(0, _dom.elementIsInView)(element)) {
	                element.scrollIntoView();
	            }
	        }
	    }, {
	        key: "toggleSection",
	        value: function toggleSection(sectionIndex) {
	            if (this.props.onChangeSection) {
	                if (this.props.onChangeSection(sectionIndex) === false) {
	                    return;
	                }
	            }
	
	            var openSection = this.getOpenSection();
	            if (openSection === sectionIndex) {
	                sectionIndex = null;
	            }
	            this.setState({ openSection: sectionIndex });
	        }
	    }, {
	        key: "getOpenSection",
	        value: function getOpenSection() {
	            if (this.props.sections.length === 1) {
	                return 0;
	            }
	
	            var openSection = this.state.openSection;
	
	            if (openSection === undefined) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = this.props.sections.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var _step$value = _slicedToArray(_step.value, 2),
	                            index = _step$value[0],
	                            section = _step$value[1];
	
	                        if (this.sectionIsSelected(section, index)) {
	                            openSection = index;
	                            break;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	            return openSection;
	        }
	    }, {
	        key: "sectionIsSelected",
	        value: function sectionIsSelected(section, sectionIndex) {
	            var _this2 = this;
	
	            var sections = this.props.sections;
	
	            var selectedSection = null;
	            for (var i = 0; i < sections.length; i++) {
	                if (_underscore2.default.some(sections[i].items, function (item) {
	                    return _this2.itemIsSelected(item);
	                })) {
	                    selectedSection = i;
	                    break;
	                }
	            }
	            return selectedSection === sectionIndex;
	        }
	    }, {
	        key: "itemIsClickable",
	        value: function itemIsClickable(item) {
	            if (this.props.itemIsClickable) {
	                return this.props.itemIsClickable(item);
	            } else {
	                return true;
	            }
	        }
	    }, {
	        key: "itemIsSelected",
	        value: function itemIsSelected(item) {
	            if (this.props.itemIsSelected) {
	                return this.props.itemIsSelected(item);
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: "onChange",
	        value: function onChange(item) {
	            if (this.props.onChange) {
	                this.props.onChange(item);
	            }
	        }
	    }, {
	        key: "renderItemExtra",
	        value: function renderItemExtra(item, itemIndex) {
	            if (this.props.renderItemExtra) {
	                return this.props.renderItemExtra(item, itemIndex);
	            } else {
	                return null;
	            }
	        }
	    }, {
	        key: "renderItemIcon",
	        value: function renderItemIcon(item, itemIndex) {
	            if (this.props.renderItemIcon) {
	                return this.props.renderItemIcon(item, itemIndex);
	            } else {
	                return null;
	            }
	        }
	    }, {
	        key: "renderSectionIcon",
	        value: function renderSectionIcon(section, sectionIndex) {
	            if (this.props.renderSectionIcon) {
	                return _react2.default.createElement(
	                    "span",
	                    { className: "List-section-icon mr2" },
	                    this.props.renderSectionIcon(section, sectionIndex)
	                );
	            } else {
	                return null;
	            }
	        }
	    }, {
	        key: "getItemClasses",
	        value: function getItemClasses(item, itemIndex) {
	            return this.props.getItemClasses && this.props.getItemClasses(item, itemIndex);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                id = _props.id,
	                searchable = _props.searchable,
	                searchPlaceholder = _props.searchPlaceholder,
	                sections = _props.sections,
	                showItemArrows = _props.showItemArrows,
	                alwaysTogglable = _props.alwaysTogglable,
	                alwaysExpanded = _props.alwaysExpanded,
	                hideSingleSectionTitle = _props.hideSingleSectionTitle,
	                style = _props.style;
	            var searchText = this.state.searchText;
	
	
	            var openSection = this.getOpenSection();
	            var sectionIsOpen = function sectionIsOpen(sectionIndex) {
	                return alwaysExpanded || openSection === sectionIndex;
	            };
	            var sectionIsSearchable = function sectionIsSearchable(sectionIndex) {
	                return searchable && (typeof searchable !== "function" || searchable(sections[sectionIndex]));
	            };
	
	            return _react2.default.createElement(
	                "div",
	                { id: id, className: this.props.className, style: _extends({ minWidth: '300px' }, style) },
	                sections.map(function (section, sectionIndex) {
	                    return _react2.default.createElement(
	                        "section",
	                        { key: sectionIndex, className: (0, _classnames2.default)("List-section", section.className, { "List-section--open": sectionIsOpen(sectionIndex) }) },
	                        section.name && alwaysExpanded ? (!hideSingleSectionTitle || sections.length > 1 || alwaysTogglable) && _react2.default.createElement(
	                            "div",
	                            { className: "px2 pt2 h6 text-grey-2 text-uppercase text-bold" },
	                            section.name
	                        ) : section.name ? _react2.default.createElement(
	                            "div",
	                            { className: "p1 border-bottom" },
	                            !hideSingleSectionTitle || sections.length > 1 || alwaysTogglable ? _react2.default.createElement(
	                                "div",
	                                { className: "List-section-header px1 py1 cursor-pointer full flex align-center", onClick: function onClick() {
	                                        return _this3.toggleSection(sectionIndex);
	                                    } },
	                                _this3.renderSectionIcon(section, sectionIndex),
	                                _react2.default.createElement(
	                                    "h3",
	                                    { className: "List-section-title" },
	                                    section.name
	                                ),
	                                sections.length > 1 && section.items && section.items.length > 0 && _react2.default.createElement(
	                                    "span",
	                                    { className: "flex-align-right" },
	                                    _react2.default.createElement(_Icon2.default, { name: sectionIsOpen(sectionIndex) ? "chevronup" : "chevrondown", size: 12 })
	                                )
	                            ) : _react2.default.createElement(
	                                "div",
	                                { className: "px1 py1 flex align-center" },
	                                _this3.renderSectionIcon(section, sectionIndex),
	                                _react2.default.createElement(
	                                    "h3",
	                                    { className: "text-default" },
	                                    section.name
	                                )
	                            )
	                        ) : null,
	                        sectionIsSearchable(sectionIndex) && sectionIsOpen(sectionIndex) && section.items && section.items.length > 0 &&
	                        /* NOTE: much of this structure is here just to match strange stuff in 'List-item' below so things align properly */
	                        _react2.default.createElement(
	                            "div",
	                            { className: "px1 pt1" },
	                            _react2.default.createElement(
	                                "div",
	                                { style: { border: "2px solid transparent", borderRadius: "6px" } },
	                                _react2.default.createElement(_ListSearchField2.default, {
	                                    onChange: function onChange(val) {
	                                        return _this3.setState({ searchText: val });
	                                    },
	                                    searchText: _this3.state.searchText,
	                                    placeholder: searchPlaceholder,
	                                    autoFocus: true
	                                })
	                            )
	                        ),
	                        sectionIsOpen(sectionIndex) && section.items && section.items.length > 0 && _react2.default.createElement(
	                            "ul",
	                            {
	                                style: { maxHeight: alwaysExpanded ? undefined : 400 },
	                                className: (0, _classnames2.default)("p1", { "border-bottom scroll-y scroll-show": !alwaysExpanded })
	                            },
	                            section.items.filter(function (i) {
	                                return searchText ? i.name.toLowerCase().includes(searchText.toLowerCase()) : true;
	                            }).map(function (item, itemIndex) {
	                                return _react2.default.createElement(
	                                    "li",
	                                    {
	                                        key: itemIndex,
	                                        ref: _this3.itemIsSelected(item, itemIndex) ? "selected" : null,
	                                        className: (0, _classnames2.default)("List-item flex", { 'List-item--selected': _this3.itemIsSelected(item, itemIndex), 'List-item--disabled': !_this3.itemIsClickable(item) }, _this3.getItemClasses(item, itemIndex))
	                                    },
	                                    _react2.default.createElement(
	                                        "a",
	                                        {
	                                            className: (0, _classnames2.default)("p1 flex-full flex align-center", _this3.itemIsClickable(item) ? "cursor-pointer" : "cursor-default"),
	                                            onClick: _this3.itemIsClickable(item) && _this3.onChange.bind(_this3, item)
	                                        },
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: "flex align-center" },
	                                            _this3.renderItemIcon(item, itemIndex)
	                                        ),
	                                        _react2.default.createElement(
	                                            "h4",
	                                            { className: "List-item-title ml1" },
	                                            item.name
	                                        )
	                                    ),
	                                    _this3.renderItemExtra(item, itemIndex),
	                                    showItemArrows && _react2.default.createElement(
	                                        "div",
	                                        { className: "List-item-arrow flex align-center px1" },
	                                        _react2.default.createElement(_Icon2.default, { name: "chevronright", size: 8 })
	                                    )
	                                );
	                            })
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return AccordianList;
	}(_react.Component), _class.propTypes = {
	    id: _propTypes2.default.string,
	    sections: _propTypes2.default.array.isRequired,
	    searchable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
	    initiallyOpenSection: _propTypes2.default.number,
	    openSection: _propTypes2.default.number,
	    onChange: _propTypes2.default.func,
	    onChangeSection: _propTypes2.default.func,
	    itemIsSelected: _propTypes2.default.func,
	    itemIsClickable: _propTypes2.default.func,
	    renderItem: _propTypes2.default.func,
	    renderSectionIcon: _propTypes2.default.func,
	    getItemClasses: _propTypes2.default.func,
	    alwaysTogglable: _propTypes2.default.bool,
	    alwaysExpanded: _propTypes2.default.bool,
	    hideSingleSectionTitle: _propTypes2.default.bool
	}, _class.defaultProps = {
	    style: {},
	    searchable: function searchable(section) {
	        return section.items && section.items.length > 10;
	    },
	    alwaysTogglable: false,
	    alwaysExpanded: false,
	    hideSingleSectionTitle: false
	}, _temp);
	AccordianList.displayName = "AccordianList";
	exports.default = AccordianList;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListSearchField = (_temp = _class = function (_Component) {
	    _inherits(ListSearchField, _Component);
	
	    function ListSearchField() {
	        _classCallCheck(this, ListSearchField);
	
	        return _possibleConstructorReturn(this, (ListSearchField.__proto__ || Object.getPrototypeOf(ListSearchField)).apply(this, arguments));
	    }
	
	    _createClass(ListSearchField, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            if (this.props.autoFocus) {
	                // Call focus() with a small delay because instant input focus causes an abrupt scroll to top of page
	                // when ListSearchField is used inside a popover. It seems that it takes a while for Tether library
	                // to correctly position the popover.
	                setTimeout(function () {
	                    return _this2.refs.input.focus();
	                }, 50);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                inputClassName = _props.inputClassName,
	                _onChange = _props.onChange,
	                placeholder = _props.placeholder,
	                searchText = _props.searchText;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: className },
	                _react2.default.createElement(
	                    "span",
	                    { className: "px1" },
	                    _react2.default.createElement(_Icon2.default, { name: "search", size: 16 })
	                ),
	                _react2.default.createElement("input", {
	                    className: inputClassName,
	                    type: "text",
	                    placeholder: placeholder,
	                    value: searchText,
	                    onChange: function onChange(e) {
	                        return _onChange(e.target.value);
	                    },
	                    ref: "input"
	                })
	            );
	        }
	    }]);
	
	    return ListSearchField;
	}(_react.Component), _class.propTypes = {
	    onChange: _propTypes2.default.func.isRequired,
	    placeholder: _propTypes2.default.string,
	    searchText: _propTypes2.default.string,
	    autoFocus: _propTypes2.default.bool
	}, _class.defaultProps = {
	    className: "bordered rounded text-grey-2 flex flex-full align-center",
	    inputClassName: "p1 h4 input--borderless text-default flex-full",
	    placeholder: "Find...",
	    searchText: "",
	    autoFocus: false
	}, _temp);
	ListSearchField.displayName = "ListSearchField";
	exports.default = ListSearchField;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DimensionPicker = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AccordianList = __webpack_require__(977);
	
	var _AccordianList2 = _interopRequireDefault(_AccordianList);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _QueryDefinitionTooltip = __webpack_require__(982);
	
	var _QueryDefinitionTooltip2 = _interopRequireDefault(_QueryDefinitionTooltip);
	
	var _formatting = __webpack_require__(872);
	
	var _Dimension = __webpack_require__(901);
	
	var _Dimension2 = _interopRequireDefault(_Dimension);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	// import type { Section } from "metabase/components/AccordianList";
	var FieldList = function (_Component) {
	    _inherits(FieldList, _Component);
	
	    function FieldList() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, FieldList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FieldList.__proto__ || Object.getPrototypeOf(FieldList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            sections: []
	        }, _this.itemIsSelected = function (item) {
	            return item.dimension && item.dimension.isSameBaseDimension(_this.props.field);
	        }, _this.renderItemExtra = function (item) {
	            var _this$props = _this.props,
	                field = _this$props.field,
	                enableSubDimensions = _this$props.enableSubDimensions,
	                metadata = _this$props.tableMetadata.metadata;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "Field-extra flex align-center" },
	                item.segment && _this.renderSegmentTooltip(item.segment),
	                item.dimension && item.dimension.tag && _react2.default.createElement(
	                    "span",
	                    { className: "h5 text-grey-2 px1" },
	                    item.dimension.tag
	                ),
	                enableSubDimensions && item.dimension && item.dimension.dimensions().length > 0 ? _react2.default.createElement(
	                    _PopoverWithTrigger2.default,
	                    {
	                        className: _this.props.className,
	                        hasArrow: false,
	                        triggerElement: _this.renderSubDimensionTrigger(item.dimension),
	                        tetherOptions: {
	                            attachment: 'top left',
	                            targetAttachment: 'top right',
	                            targetOffset: '0 0',
	                            constraints: [{ to: 'window', attachment: 'together', pin: ['left', 'right'] }]
	                        }
	                    },
	                    _react2.default.createElement(DimensionPicker, {
	                        dimension: _Dimension2.default.parseMBQL(field, metadata),
	                        dimensions: item.dimension.dimensions(),
	                        onChangeDimension: function onChangeDimension(dimension) {
	                            return _this.props.onFieldChange(dimension.mbql());
	                        }
	                    })
	                ) : null
	            );
	        }, _this.renderItemIcon = function (item) {
	            var name = void 0;
	            if (item.segment) {
	                name = "staroutline";
	            } else if (item.dimension) {
	                name = item.dimension.icon();
	            }
	            return _react2.default.createElement(_Icon2.default, { name: name || 'unknown', size: 18 });
	        }, _this.getItemClasses = function (item, itemIndex) {
	            if (item.segment) {
	                return "List-item--segment";
	            } else {
	                return null;
	            }
	        }, _this.renderSectionIcon = function (section, sectionIndex) {
	            if (sectionIndex > 0) {
	                return _react2.default.createElement(_Icon2.default, { name: "connections", size: 18 });
	            } else {
	                return _react2.default.createElement(_Icon2.default, { name: "table2", size: 18 });
	            }
	        }, _this.onChange = function (item) {
	            var _this$props2 = _this.props,
	                field = _this$props2.field,
	                enableSubDimensions = _this$props2.enableSubDimensions,
	                onFilterChange = _this$props2.onFilterChange,
	                onFieldChange = _this$props2.onFieldChange;
	
	            if (item.segment && onFilterChange) {
	                onFilterChange(item.value);
	            } else if (field != null && _this.itemIsSelected(item)) {
	                // ensure if we select the same item we don't reset datetime-field's unit
	                onFieldChange(field);
	            } else {
	                var dimension = item.dimension.defaultDimension() || item.dimension;
	                var shouldExcludeBinning = !enableSubDimensions && dimension instanceof _Dimension.BinnedDimension;
	
	                if (shouldExcludeBinning) {
	                    // If we don't let user choose the sub-dimension, we don't want to treat the field
	                    // as a binned field (which would use the default binning)
	                    // Let's unwrap the base field of the binned field instead
	                    onFieldChange(dimension.baseDimension().mbql());
	                } else {
	                    onFieldChange(dimension.mbql());
	                }
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(FieldList, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.componentWillReceiveProps(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            var tableMetadata = newProps.tableMetadata,
	                fieldOptions = newProps.fieldOptions,
	                segmentOptions = newProps.segmentOptions,
	                hideSectionHeader = newProps.hideSectionHeader;
	
	            var tableName = tableMetadata.display_name;
	
	            var specialOptions = [];
	            if (segmentOptions) {
	                specialOptions = segmentOptions.map(function (segment) {
	                    return {
	                        name: segment.name,
	                        value: ["SEGMENT", segment.id],
	                        segment: segment
	                    };
	                });
	            }
	
	            var getSectionItems = function getSectionItems(sectionOptions) {
	                return sectionOptions.dimensions.map(function (dimension) {
	                    return {
	                        name: dimension.displayName(),
	                        dimension: dimension
	                    };
	                });
	            };
	
	            var mainSection = {
	                name: hideSectionHeader ? null : (0, _formatting.singularize)(tableName),
	                items: specialOptions.concat(getSectionItems(fieldOptions))
	            };
	
	            var fkSections = fieldOptions.fks.map(function (fkOptions) {
	                return {
	                    name: hideSectionHeader ? null : (0, _formatting.stripId)(fkOptions.field.display_name),
	                    items: getSectionItems(fkOptions)
	                };
	            });
	
	            var sections = [];
	            if (mainSection.items.length > 0) {
	                sections.push(mainSection);
	            }
	            sections.push.apply(sections, _toConsumableArray(fkSections));
	
	            this.setState({ sections: sections });
	        }
	    }, {
	        key: "renderSubDimensionTrigger",
	        value: function renderSubDimensionTrigger(dimension) {
	            var _props = this.props,
	                field = _props.field,
	                metadata = _props.tableMetadata.metadata;
	
	            var subDimension = dimension.isSameBaseDimension(field) ? _Dimension2.default.parseMBQL(field, metadata) : dimension.defaultDimension();
	            var name = subDimension ? subDimension.subTriggerDisplayName() : null;
	            return _react2.default.createElement(
	                "div",
	                { className: "FieldList-grouping-trigger flex align-center p1 cursor-pointer" },
	                name && _react2.default.createElement(
	                    "h4",
	                    { className: "mr1" },
	                    name
	                ),
	                _react2.default.createElement(_Icon2.default, { name: "chevronright", size: 16 })
	            );
	        }
	    }, {
	        key: "renderSegmentTooltip",
	        value: function renderSegmentTooltip(segment) {
	            var tableMetadata = this.props.tableMetadata;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "p1" },
	                _react2.default.createElement(
	                    _Tooltip2.default,
	                    { tooltip: _react2.default.createElement(_QueryDefinitionTooltip2.default, { object: segment, tableMetadata: tableMetadata }) },
	                    _react2.default.createElement("span", { className: "QuestionTooltipTarget" })
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_AccordianList2.default, {
	                className: this.props.className,
	                sections: this.state.sections,
	                onChange: this.onChange,
	                itemIsSelected: this.itemIsSelected,
	                renderSectionIcon: this.renderSectionIcon,
	                renderItemExtra: this.renderItemExtra,
	                renderItemIcon: this.renderItemIcon,
	                getItemClasses: this.getItemClasses,
	                alwaysExpanded: this.props.alwaysExpanded
	            });
	        }
	    }]);
	
	    return FieldList;
	}(_react.Component);
	
	FieldList.displayName = "FieldList";
	exports.default = FieldList;
	var DimensionPicker = exports.DimensionPicker = function DimensionPicker(_ref2) {
	    var className = _ref2.className,
	        dimension = _ref2.dimension,
	        dimensions = _ref2.dimensions,
	        onChangeDimension = _ref2.onChangeDimension;
	
	    return _react2.default.createElement(
	        "ul",
	        { className: "px2 py1" },
	        dimensions.map(function (d, index) {
	            return _react2.default.createElement(
	                "li",
	                {
	                    key: index,
	                    className: (0, _classnames2.default)("List-item", { "List-item--selected": d.isEqual(dimension) })
	                },
	                _react2.default.createElement(
	                    "a",
	                    { className: "List-item-title full px2 py1 cursor-pointer", onClick: function onClick() {
	                            return onChangeDimension(d);
	                        } },
	                    d.subDisplayName()
	                )
	            );
	        })
	    );
	};
	DimensionPicker.displayName = "DimensionPicker";

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Triggerable = __webpack_require__(981);
	
	var _Triggerable2 = _interopRequireDefault(_Triggerable);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _Triggerable2.default)(_Popover2.default);

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _dom = __webpack_require__(859);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// higher order component that takes a component which takes props "isOpen" and optionally "onClose"
	// and returns a component that renders a <a> element "trigger", and tracks whether that component is open or not
	exports.default = function (ComposedComponent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_Component) {
	        _inherits(_class, _Component);
	
	        function _class(props, context) {
	            _classCallCheck(this, _class);
	
	            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));
	
	            _this.state = {
	                isOpen: props.isInitiallyOpen || false
	            };
	
	            _this._startCheckObscured = _this._startCheckObscured.bind(_this);
	            _this._stopCheckObscured = _this._stopCheckObscured.bind(_this);
	            _this.onClose = _this.onClose.bind(_this);
	            return _this;
	        }
	
	        _createClass(_class, [{
	            key: "open",
	            value: function open() {
	                this.toggle(true);
	            }
	        }, {
	            key: "close",
	            value: function close() {
	                this.toggle(false);
	            }
	        }, {
	            key: "toggle",
	            value: function toggle() {
	                var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.state.isOpen;
	
	                this.setState({ isOpen: isOpen });
	            }
	        }, {
	            key: "onClose",
	            value: function onClose(e) {
	                // don't close if clicked the actual trigger, it will toggle
	                if (e && e.target && _reactDom2.default.findDOMNode(this.refs.trigger).contains(e.target)) {
	                    return;
	                }
	
	                if (this.props.onClose) {
	                    this.props.onClose(e);
	                }
	
	                this.close();
	            }
	        }, {
	            key: "target",
	            value: function target() {
	                if (this.props.target) {
	                    return this.props.target();
	                } else {
	                    return this.refs.trigger;
	                }
	            }
	        }, {
	            key: "componentDidMount",
	            value: function componentDidMount() {
	                this.componentDidUpdate();
	            }
	        }, {
	            key: "componentDidUpdate",
	            value: function componentDidUpdate() {
	                if (this.state.isOpen && this.props.closeOnObscuredTrigger) {
	                    this._startCheckObscured();
	                } else {
	                    this._stopCheckObscured();
	                }
	            }
	        }, {
	            key: "componentWillUnmount",
	            value: function componentWillUnmount() {
	                this._stopCheckObscured();
	            }
	        }, {
	            key: "_startCheckObscured",
	            value: function _startCheckObscured() {
	                var _this2 = this;
	
	                if (this._offscreenTimer == null) {
	                    this._offscreenTimer = setInterval(function () {
	                        var trigger = _reactDom2.default.findDOMNode(_this2.refs.trigger);
	                        if ((0, _dom.isObscured)(trigger)) {
	                            _this2.close();
	                        }
	                    }, 250);
	                }
	            }
	        }, {
	            key: "_stopCheckObscured",
	            value: function _stopCheckObscured() {
	                if (this._offscreenTimer != null) {
	                    clearInterval(this._offscreenTimer);
	                    this._offscreenTimer = null;
	                }
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                var _this3 = this;
	
	                var _props = this.props,
	                    triggerId = _props.triggerId,
	                    triggerClasses = _props.triggerClasses,
	                    triggerStyle = _props.triggerStyle,
	                    triggerClassesOpen = _props.triggerClassesOpen;
	                var isOpen = this.state.isOpen;
	                var triggerElement = this.props.triggerElement;
	
	                if (triggerElement && triggerElement.type === _Tooltip2.default) {
	                    // Disables tooltip when open:
	                    triggerElement = _react2.default.cloneElement(triggerElement, { isEnabled: triggerElement.props.isEnabled && !isOpen });
	                }
	
	                // if we have a single child which isn't an HTML element and doesn't have an onClose prop go ahead and inject it directly
	                var children = this.props.children;
	
	                if (_react2.default.Children.count(children) === 1 && _react2.default.Children.only(children).props.onClose === undefined && typeof _react2.default.Children.only(children).type !== "string") {
	                    children = _react2.default.cloneElement(children, { onClose: this.onClose });
	                }
	
	                return _react2.default.createElement(
	                    "a",
	                    {
	                        id: triggerId,
	                        ref: "trigger",
	                        onClick: function onClick(event) {
	                            event.preventDefault();
	                            !_this3.props.disabled && _this3.toggle();
	                        },
	                        className: (0, _classnames2.default)(triggerClasses, isOpen && triggerClassesOpen, "no-decoration", {
	                            'cursor-default': this.props.disabled
	                        }),
	                        style: triggerStyle
	                    },
	                    triggerElement,
	                    _react2.default.createElement(ComposedComponent, _extends({}, this.props, {
	                        children: children,
	                        isOpen: isOpen,
	                        onClose: this.onClose,
	                        target: function target() {
	                            return _this3.target();
	                        }
	                    }))
	                );
	            }
	        }]);
	
	        return _class;
	    }(_react.Component), _class.displayName = "Triggerable[" + (ComposedComponent.displayName || ComposedComponent.name) + "]", _class.defaultProps = {
	        closeOnObscuredTrigger: false
	    }, _temp;
	};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FilterList = __webpack_require__(983);
	
	var _FilterList2 = _interopRequireDefault(_FilterList);
	
	var _AggregationWidget = __webpack_require__(1005);
	
	var _AggregationWidget2 = _interopRequireDefault(_AggregationWidget);
	
	var _FieldSet = __webpack_require__(1006);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QueryDefinitionTooltip = (_temp = _class = function (_Component) {
	    _inherits(QueryDefinitionTooltip, _Component);
	
	    function QueryDefinitionTooltip() {
	        _classCallCheck(this, QueryDefinitionTooltip);
	
	        return _possibleConstructorReturn(this, (QueryDefinitionTooltip.__proto__ || Object.getPrototypeOf(QueryDefinitionTooltip)).apply(this, arguments));
	    }
	
	    _createClass(QueryDefinitionTooltip, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                type = _props.type,
	                object = _props.object,
	                tableMetadata = _props.tableMetadata;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "p2", style: { width: 250 } },
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    type && type === "metric" && !object.is_active ? "This metric has been retired.  It's no longer available for use." : object.description
	                ),
	                object.definition && _react2.default.createElement(
	                    "div",
	                    { className: "mt2" },
	                    _react2.default.createElement(
	                        _FieldSet2.default,
	                        { legend: "Definition", className: "border-light" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "TooltipFilterList" },
	                            _query2.default.getAggregations(object.definition).map(function (aggregation) {
	                                return _react2.default.createElement(_AggregationWidget2.default, {
	                                    aggregation: aggregation,
	                                    tableMetadata: tableMetadata
	                                });
	                            }),
	                            _react2.default.createElement(_FilterList2.default, {
	                                filters: _query2.default.getFilters(object.definition),
	                                tableMetadata: tableMetadata,
	                                maxDisplayValues: Infinity
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return QueryDefinitionTooltip;
	}(_react.Component), _class.propTypes = {
	    type: _propTypes2.default.string,
	    object: _propTypes2.default.object.isRequired,
	    tableMetadata: _propTypes2.default.object.isRequired
	}, _temp);
	QueryDefinitionTooltip.displayName = "QueryDefinitionTooltip";
	exports.default = QueryDefinitionTooltip;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _FilterWidget = __webpack_require__(984);
	
	var _FilterWidget2 = _interopRequireDefault(_FilterWidget);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	var _Dimension = __webpack_require__(901);
	
	var _Dimension2 = _interopRequireDefault(_Dimension);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterList = function (_Component) {
	    _inherits(FilterList, _Component);
	
	    function FilterList(props) {
	        _classCallCheck(this, FilterList);
	
	        var _this = _possibleConstructorReturn(this, (FilterList.__proto__ || Object.getPrototypeOf(FilterList)).call(this, props));
	
	        _this.state = {
	            shouldScroll: false
	        };
	        return _this;
	    }
	
	    _createClass(FilterList, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.state.shouldScroll ? (0, _reactDom.findDOMNode)(this).scrollLeft = (0, _reactDom.findDOMNode)(this).scrollWidth : null;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // only scroll when a filter is added
	            if (nextProps.filters.length > this.props.filters.length) {
	                this.setState({ shouldScroll: true });
	            } else {
	                this.setState({ shouldScroll: false });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.componentDidUpdate();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                query = _props.query,
	                filters = _props.filters,
	                tableMetadata = _props.tableMetadata;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'Query-filterList scroll-x scroll-show scroll-show--horizontal' },
	                filters.map(function (filter, index) {
	                    return _react2.default.createElement(_FilterWidget2.default, {
	                        key: index,
	                        placeholder: 'Item'
	                        // TODO: update widgets that are still passing tableMetadata instead of query
	                        , query: query || {
	                            table: function table() {
	                                return tableMetadata;
	                            },
	                            parseFieldReference: function parseFieldReference(fieldRef) {
	                                return _Dimension2.default.parseMBQL(fieldRef, tableMetadata);
	                            }
	                        },
	                        filter: filter,
	                        index: index,
	                        removeFilter: _this2.props.removeFilter,
	                        updateFilter: _this2.props.updateFilter,
	                        maxDisplayValues: _this2.props.maxDisplayValues
	                    });
	                })
	            );
	        }
	    }]);
	
	    return FilterList;
	}(_react.Component);
	
	FilterList.displayName = 'FilterList';
	exports.default = FilterList;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _FieldName = __webpack_require__(985);
	
	var _FieldName2 = _interopRequireDefault(_FieldName);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _FilterPopover = __webpack_require__(987);
	
	var _FilterPopover2 = _interopRequireDefault(_FilterPopover);
	
	var _query_time = __webpack_require__(944);
	
	var _formatting = __webpack_require__(872);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterWidget = (_temp = _class = function (_Component) {
	    _inherits(FilterWidget, _Component);
	
	    function FilterWidget(props) {
	        _classCallCheck(this, FilterWidget);
	
	        var _this = _possibleConstructorReturn(this, (FilterWidget.__proto__ || Object.getPrototypeOf(FilterWidget)).call(this, props));
	
	        _this.open = function () {
	            _this.setState({ isOpen: true });
	        };
	
	        _this.close = function () {
	            _this.setState({ isOpen: false });
	        };
	
	        _this.state = {
	            isOpen: _this.props.filter[0] == undefined
	        };
	        return _this;
	    }
	
	    _createClass(FilterWidget, [{
	        key: "renderOperatorFilter",
	        value: function renderOperatorFilter() {
	            var _props = this.props,
	                query = _props.query,
	                filter = _props.filter,
	                maxDisplayValues = _props.maxDisplayValues;
	
	            var _filter = _toArray(filter),
	                op = _filter[0],
	                field = _filter[1],
	                values = _filter.slice(2);
	
	            var dimension = query.parseFieldReference(field);
	            if (!dimension) {
	                return null;
	            }
	
	            var operator = dimension.operator(op);
	
	            var formattedValues = void 0;
	            // $FlowFixMe: not understanding maxDisplayValues is provided by defaultProps
	            if (operator && operator.multi && values.length > maxDisplayValues) {
	                formattedValues = [values.length + " selections"];
	            } else if (dimension.field().isDate()) {
	                formattedValues = (0, _query_time.generateTimeFilterValuesDescriptions)(filter);
	            } else {
	                // TODO Atte Keinänen 7/16/17: Move formatValue to metabase-lib
	                formattedValues = values.filter(function (value) {
	                    return value !== undefined;
	                }).map(function (value) {
	                    return (0, _formatting.formatValue)(value, { column: dimension.field() });
	                });
	            }
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: "flex flex-column justify-center",
	                    onClick: this.open
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center", style: { padding: "0.5em", paddingTop: "0.3em", paddingBottom: "0.3em", paddingLeft: 0 } },
	                    _react2.default.createElement(_FieldName2.default, {
	                        className: "Filter-section Filter-section-field",
	                        field: field,
	                        tableMetadata: query.table()
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Filter-section Filter-section-operator" },
	                        "\xA0",
	                        _react2.default.createElement(
	                            "a",
	                            { className: "QueryOption flex align-center" },
	                            operator && operator.moreVerboseName
	                        )
	                    )
	                ),
	                formattedValues.length > 0 && _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center flex-wrap" },
	                    formattedValues.map(function (formattedValue, valueIndex) {
	                        return _react2.default.createElement(
	                            "div",
	                            { key: valueIndex, className: "Filter-section Filter-section-value" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "QueryOption" },
	                                formattedValue
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: "renderSegmentFilter",
	        value: function renderSegmentFilter() {
	            var _props2 = this.props,
	                query = _props2.query,
	                filter = _props2.filter;
	
	            var segment = _underscore2.default.find(query.table().segments, function (s) {
	                return s.id === filter[1];
	            });
	            return _react2.default.createElement(
	                "div",
	                { onClick: this.open },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center", style: { padding: "0.5em", paddingTop: "0.3em", paddingBottom: "0.3em", paddingLeft: 0 } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Filter-section Filter-section-field" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "QueryOption" },
	                            "Matches"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center flex-wrap" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Filter-section Filter-section-value" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "QueryOption" },
	                            segment && segment.name
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: "renderPopover",
	        value: function renderPopover() {
	            var _this2 = this;
	
	            if (this.state.isOpen) {
	                var _props3 = this.props,
	                    _query = _props3.query,
	                    _filter2 = _props3.filter;
	
	                return _react2.default.createElement(
	                    _Popover2.default,
	                    {
	                        id: "FilterPopover",
	                        ref: "filterPopover",
	                        className: "FilterPopover",
	                        isInitiallyOpen: this.props.filter[1] === null,
	                        onClose: this.close,
	                        horizontalAttachments: ["left"]
	                    },
	                    _react2.default.createElement(_FilterPopover2.default, {
	                        query: _query,
	                        filter: _filter2,
	                        onCommitFilter: function onCommitFilter(filter) {
	                            return _this2.props.updateFilter && _this2.props.updateFilter(_this2.props.index, filter);
	                        },
	                        onClose: this.close
	                    })
	                );
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props4 = this.props,
	                filter = _props4.filter,
	                index = _props4.index,
	                removeFilter = _props4.removeFilter;
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("Query-filter p1 pl2", { "selected": this.state.isOpen }) },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex justify-center" },
	                    filter[0] === "SEGMENT" ? this.renderSegmentFilter() : this.renderOperatorFilter(),
	                    this.renderPopover()
	                ),
	                removeFilter && _react2.default.createElement(
	                    "a",
	                    { className: "text-grey-2 no-decoration px1 flex align-center", onClick: function onClick() {
	                            return removeFilter(index);
	                        } },
	                    _react2.default.createElement(_Icon2.default, { name: "close", size: 14 })
	                )
	            );
	        }
	    }]);
	
	    return FilterWidget;
	}(_react.Component), _class.defaultProps = {
	    maxDisplayValues: 1
	}, _temp);
	FilterWidget.displayName = "FilterWidget";
	exports.default = FilterWidget;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Clearable = __webpack_require__(986);
	
	var _Clearable2 = _interopRequireDefault(_Clearable);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _Dimension = __webpack_require__(901);
	
	var _Dimension2 = _interopRequireDefault(_Dimension);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FieldName = (_temp = _class = function (_Component) {
	    _inherits(FieldName, _Component);
	
	    function FieldName() {
	        _classCallCheck(this, FieldName);
	
	        return _possibleConstructorReturn(this, (FieldName.__proto__ || Object.getPrototypeOf(FieldName)).apply(this, arguments));
	    }
	
	    _createClass(FieldName, [{
	        key: "displayNameForFieldLiteral",
	        value: function displayNameForFieldLiteral(tableMetadata, fieldLiteral) {
	            // see if we can find an entry in the table metadata that matches the field literal
	            var matchingField = _underscore2.default.find(tableMetadata.fields, function (field) {
	                return _query2.default.isFieldLiteral(field.id) && field.id[1] === fieldLiteral[1];
	            }); // check whether names of field literals match
	
	            return matchingField && matchingField.display_name || fieldLiteral[1];
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                field = _props.field,
	                tableMetadata = _props.tableMetadata,
	                query = _props.query,
	                className = _props.className;
	
	
	            var parts = [];
	
	            if (field) {
	                var dimension = _Dimension2.default.parseMBQL(field, tableMetadata && tableMetadata.metadata);
	                if (dimension) {
	                    if (dimension instanceof _Dimension.AggregationDimension) {
	                        // Aggregation dimension doesn't know about its relation to the current query
	                        // so we have to infer the display name of aggregation here
	                        parts = _react2.default.createElement(
	                            "span",
	                            { key: "field" },
	                            query.aggregations()[dimension.aggregationIndex()][0]
	                        );
	                    } else {
	                        parts = _react2.default.createElement(
	                            "span",
	                            { key: "field" },
	                            dimension.render()
	                        );
	                    }
	                }
	                // TODO Atte Keinänen 6/23/17: Move nested queries logic to Dimension subclasses
	                // if the Field in question is a field literal, e.g. ["field-literal", <name>, <type>] just use name as-is
	                else if (_query2.default.isFieldLiteral(field)) {
	                        parts.push(_react2.default.createElement(
	                            "span",
	                            { key: "field" },
	                            this.displayNameForFieldLiteral(tableMetadata, field)
	                        ));
	                    }
	                    // otherwise if for some weird reason we wound up with a Field Literal inside a field ID,
	                    // e.g. ["field-id", ["field-literal", <name>, <type>], still just use the name as-is
	                    else if (_query2.default.isLocalField(field) && _query2.default.isFieldLiteral(field[1])) {
	                            parts.push(_react2.default.createElement(
	                                "span",
	                                { key: "field" },
	                                this.displayNameForFieldLiteral(tableMetadata, field[1])
	                            ));
	                        } else {
	                            parts.push(_react2.default.createElement(
	                                "span",
	                                { key: "field" },
	                                "Unknown Field"
	                            ));
	                        }
	            } else {
	                parts.push(_react2.default.createElement(
	                    "span",
	                    { key: "field", className: "text-grey-2" },
	                    "field"
	                ));
	            }
	
	            return _react2.default.createElement(
	                _Clearable2.default,
	                { onClear: this.props.removeField },
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)(className, { selected: _query2.default.isValidField(field) }), onClick: this.props.onClick },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "QueryOption" },
	                        parts
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FieldName;
	}(_react.Component), _class.propTypes = {
	    field: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	    onClick: _propTypes2.default.func,
	    removeField: _propTypes2.default.func,
	    tableMetadata: _propTypes2.default.object.isRequired,
	    query: _propTypes2.default.object
	}, _class.defaultProps = {
	    className: ""
	}, _temp);
	FieldName.displayName = "FieldName";
	exports.default = FieldName;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Clearable = function Clearable(_ref) {
	    var onClear = _ref.onClear,
	        children = _ref.children,
	        className = _ref.className;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("flex align-center", className) },
	        children,
	        onClear && _react2.default.createElement(
	            "a",
	            { className: "text-grey-2 no-decoration pr1 flex align-center", onClick: onClear },
	            _react2.default.createElement(_Icon2.default, { name: "close", size: 14 })
	        )
	    );
	};
	
	Clearable.displayName = "Clearable";
	exports.default = Clearable;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FieldList = __webpack_require__(979);
	
	var _FieldList2 = _interopRequireDefault(_FieldList);
	
	var _OperatorSelector = __webpack_require__(988);
	
	var _OperatorSelector2 = _interopRequireDefault(_OperatorSelector);
	
	var _DatePicker = __webpack_require__(989);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _NumberPicker = __webpack_require__(999);
	
	var _NumberPicker2 = _interopRequireDefault(_NumberPicker);
	
	var _SelectPicker = __webpack_require__(1003);
	
	var _SelectPicker2 = _interopRequireDefault(_SelectPicker);
	
	var _TextPicker = __webpack_require__(1000);
	
	var _TextPicker2 = _interopRequireDefault(_TextPicker);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _formatting = __webpack_require__(872);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterPopover = function (_Component) {
	    _inherits(FilterPopover, _Component);
	
	    function FilterPopover(props) {
	        _classCallCheck(this, FilterPopover);
	
	        var _this = _possibleConstructorReturn(this, (FilterPopover.__proto__ || Object.getPrototypeOf(FilterPopover)).call(this, props));
	
	        _this.commitOnEnter = function (event) {
	            if (_this.isValid() && event.key === "Enter") {
	                _this.commitFilter(_this.state.filter);
	            }
	        };
	
	        _this.commitFilter = function (filter) {
	            _this.props.onCommitFilter(filter);
	            _this.props.onClose();
	        };
	
	        _this.setField = function (fieldId) {
	            var query = _this.props.query;
	            var filter = _this.state.filter;
	
	            if (filter[1] !== fieldId) {
	                // different field, reset the filter
	                filter = [];
	
	                // update the field
	                filter[1] = fieldId;
	
	                // default to the first operator
	
	                var _Query$getFieldTarget = _query2.default.getFieldTarget(filter[1], query.table()),
	                    field = _Query$getFieldTarget.field;
	
	                // let the DatePicker choose the default operator, otherwise use the first one
	
	
	                var operator = (0, _schema_metadata.isDate)(field) ? null : field.operators[0].name;
	
	                // $FlowFixMe
	                filter = _this._updateOperator(filter, operator);
	            }
	            _this.setState({ filter: filter });
	        };
	
	        _this.setFilter = function (filter) {
	            _this.setState({ filter: filter });
	        };
	
	        _this.setOperator = function (operator) {
	            var filter = _this.state.filter;
	
	            if (filter[0] !== operator) {
	                filter = _this._updateOperator(filter, operator);
	                _this.setState({ filter: filter });
	            }
	        };
	
	        _this.setValues = function (values) {
	            var filter = _this.state.filter;
	            // $FlowFixMe
	
	            _this.setState({ filter: filter.slice(0, 2).concat(values) });
	        };
	
	        _this.clearField = function () {
	            var filter = _this.state.filter;
	            // $FlowFixMe
	
	            _this.setState({ filter: [].concat(_toConsumableArray(filter.slice(0, 1)), [null], _toConsumableArray(filter.slice(2))) });
	        };
	
	        _this.onCommit = function () {
	            if (_this.isValid()) {
	                _this.commitFilter(_this.state.filter);
	            }
	        };
	
	        _this.state = {
	            // $FlowFixMe
	            filter: props.filter || []
	        };
	        return _this;
	    }
	
	    _createClass(FilterPopover, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            window.addEventListener('keydown', this.commitOnEnter);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            window.removeEventListener('keydown', this.commitOnEnter);
	        }
	    }, {
	        key: "setValue",
	        value: function setValue(index, value) {
	            var filter = this.state.filter;
	            // $FlowFixMe Flow doesn't like spread operator
	
	            var newFilter = [].concat(_toConsumableArray(filter));
	            newFilter[index + 2] = value;
	            this.setState({ filter: newFilter });
	        }
	    }, {
	        key: "_updateOperator",
	        value: function _updateOperator(oldFilter, operatorName) {
	            var query = this.props.query;
	
	            var _Query$getFieldTarget2 = _query2.default.getFieldTarget(oldFilter[1], query.table()),
	                field = _Query$getFieldTarget2.field;
	
	            var operator = field.operators_lookup[operatorName];
	            var oldOperator = field.operators_lookup[oldFilter[0]];
	
	            // update the operator
	            // $FlowFixMe
	            var filter = [operatorName, oldFilter[1]];
	
	            if (operator) {
	                for (var i = 0; i < operator.fields.length; i++) {
	                    if (operator.defaults && operator.defaults[i] !== undefined) {
	                        filter.push(operator.defaults[i]);
	                    } else {
	                        filter.push(undefined);
	                    }
	                }
	                if (oldOperator) {
	                    // copy over values of the same type
	                    for (var _i = 0; _i < oldFilter.length - 2; _i++) {
	                        var _field = operator.multi ? operator.fields[0] : operator.fields[_i];
	                        var oldField = oldOperator.multi ? oldOperator.fields[0] : oldOperator.fields[_i];
	                        if (_field && oldField && _field.type === oldField.type && oldFilter[_i + 2] !== undefined) {
	                            filter[_i + 2] = oldFilter[_i + 2];
	                        }
	                    }
	                }
	            }
	            return filter;
	        }
	    }, {
	        key: "isValid",
	        value: function isValid() {
	            var query = this.props.query;
	            var filter = this.state.filter;
	            // has an operator name and field id
	
	            if (filter[0] == null || !_query2.default.isValidField(filter[1])) {
	                return false;
	            }
	            // field/operator combo is valid
	
	            var _Query$getFieldTarget3 = _query2.default.getFieldTarget(filter[1], query.table()),
	                field = _Query$getFieldTarget3.field;
	
	            var operator = field.operators_lookup[filter[0]];
	            if (operator) {
	                // has the mininum number of arguments
	                if (filter.length - 2 < operator.fields.length) {
	                    return false;
	                }
	            }
	            // arguments are non-null/undefined
	            for (var i = 2; i < filter.length; i++) {
	                if (filter[i] == null) {
	                    return false;
	                }
	            }
	
	            return true;
	        }
	    }, {
	        key: "renderPicker",
	        value: function renderPicker(filter, field) {
	            var _this2 = this;
	
	            var operator = field.operators_lookup[filter[0]];
	            return operator && operator.fields.map(function (operatorField, index) {
	                if (!operator) {
	                    return;
	                }
	                var values = void 0,
	                    onValuesChange = void 0;
	                var placeholder = operator && operator.placeholders && operator.placeholders[index] || undefined;
	                if (operator.multi) {
	                    values = _this2.state.filter.slice(2);
	                    onValuesChange = function onValuesChange(values) {
	                        return _this2.setValues(values);
	                    };
	                } else {
	                    values = [_this2.state.filter[2 + index]];
	                    onValuesChange = function onValuesChange(values) {
	                        return _this2.setValue(index, values[0]);
	                    };
	                }
	                if (operatorField.type === "select") {
	                    return _react2.default.createElement(_SelectPicker2.default, {
	                        options: operatorField.values
	                        // $FlowFixMe
	                        , values: values,
	                        onValuesChange: onValuesChange,
	                        placeholder: placeholder,
	                        multi: operator.multi,
	                        onCommit: _this2.onCommit
	                    });
	                } else if (operatorField.type === "text") {
	                    return _react2.default.createElement(_TextPicker2.default
	                    // $FlowFixMe
	                    , { values: values,
	                        onValuesChange: onValuesChange,
	                        placeholder: placeholder,
	                        multi: operator.multi,
	                        onCommit: _this2.onCommit
	                    });
	                } else if (operatorField.type === "number") {
	                    return _react2.default.createElement(_NumberPicker2.default
	                    // $FlowFixMe
	                    , { values: values,
	                        onValuesChange: onValuesChange,
	                        placeholder: placeholder,
	                        multi: operator.multi,
	                        onCommit: _this2.onCommit
	                    });
	                }
	                return _react2.default.createElement(
	                    "span",
	                    null,
	                    "not implemented ",
	                    operatorField.type,
	                    " ",
	                    operator.multi ? "true" : "false"
	                );
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var query = this.props.query;
	            var filter = this.state.filter;
	
	            var _filter = _slicedToArray(filter, 2),
	                operator = _filter[0],
	                field = _filter[1];
	
	            if (operator === "SEGMENT" || field == undefined) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "FilterPopover" },
	                    _react2.default.createElement(_FieldList2.default, {
	                        className: "text-purple",
	                        field: field,
	                        fieldOptions: query.filterFieldOptions(filter),
	                        segmentOptions: query.filterSegmentOptions(filter),
	                        tableMetadata: query.table(),
	                        onFieldChange: this.setField,
	                        onFilterChange: this.commitFilter
	                    })
	                );
	            } else {
	                var _Query$getFieldTarget4 = _query2.default.getFieldTarget(filter[1], query.table()),
	                    table = _Query$getFieldTarget4.table,
	                    _field2 = _Query$getFieldTarget4.field;
	
	                return _react2.default.createElement(
	                    "div",
	                    { style: {
	                            minWidth: 300
	                        } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "FilterPopover-header text-grey-3 p1 mt1 flex align-center" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "cursor-pointer text-purple-hover transition-color flex align-center", onClick: this.clearField },
	                            _react2.default.createElement(_Icon2.default, { name: "chevronleft", size: 18 }),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "inline-block" },
	                                (0, _formatting.singularize)(table.display_name)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            { className: "mx1" },
	                            "-"
	                        ),
	                        _react2.default.createElement(
	                            "h3",
	                            { className: "text-default" },
	                            (0, _formatting.formatField)(_field2)
	                        )
	                    ),
	                    (0, _schema_metadata.isDate)(_field2) ? _react2.default.createElement(_DatePicker2.default, {
	                        className: "mt1 border-top",
	                        filter: filter,
	                        onFilterChange: this.setFilter
	                    }) : _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_OperatorSelector2.default, {
	                            operator: filter[0],
	                            operators: _field2.operators,
	                            onOperatorChange: this.setOperator
	                        }),
	                        this.renderPicker(filter, _field2)
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "FilterPopover-footer p1" },
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                "data-ui-tag": "add-filter",
	                                className: (0, _classnames2.default)("Button Button--purple full", { "disabled": !this.isValid() }),
	                                onClick: function onClick() {
	                                    return _this3.commitFilter(_this3.state.filter);
	                                }
	                            },
	                            !this.props.filter ? "Add filter" : "Update filter"
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return FilterPopover;
	}(_react.Component);
	
	FilterPopover.displayName = "FilterPopover";
	exports.default = FilterPopover;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _dom = __webpack_require__(859);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OperatorSelector = (_temp = _class = function (_Component) {
	    _inherits(OperatorSelector, _Component);
	
	    function OperatorSelector(props) {
	        _classCallCheck(this, OperatorSelector);
	
	        // if the initial operator is "advanced" expand the list
	        var _this = _possibleConstructorReturn(this, (OperatorSelector.__proto__ || Object.getPrototypeOf(OperatorSelector)).call(this, props));
	
	        _this.expandOperators = function () {
	            _this.setState({ expanded: true }, function () {
	                // HACK: Address Safari rendering bug which causes https://github.com/metabase/metabase/issues/5075
	                (0, _dom.forceRedraw)(_reactDom2.default.findDOMNode(_this));
	            });
	        };
	
	        var operator = _underscore2.default.find(props.operators, function (o) {
	            return o.name === props.operator;
	        });
	        _this.state = {
	            expanded: !!(operator && operator.advanced)
	        };
	        return _this;
	    }
	
	    _createClass(OperatorSelector, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                operator = _props.operator,
	                operators = _props.operators;
	            var expanded = this.state.expanded;
	
	
	            var defaultOperators = operators.filter(function (o) {
	                return !o.advanced;
	            });
	            var expandedOperators = operators.filter(function (o) {
	                return o.advanced;
	            });
	
	            var visibleOperators = defaultOperators;
	            if (expanded) {
	                visibleOperators = visibleOperators.concat(expandedOperators);
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { id: "OperatorSelector", className: "border-bottom p1", style: {
	                        maxWidth: 300
	                    } },
	                visibleOperators.map(function (o) {
	                    return _react2.default.createElement(
	                        "button",
	                        {
	                            key: o.name,
	                            className: (0, _classnames2.default)("Button Button-normal Button--medium mr1 mb1", { "Button--purple": o.name === operator }),
	                            onClick: function onClick() {
	                                return _this2.props.onOperatorChange(o.name);
	                            }
	                        },
	                        o.verboseName
	                    );
	                }),
	                !expanded && expandedOperators.length > 0 ? _react2.default.createElement(
	                    "div",
	                    { className: "text-grey-3 text-purple-hover transition-color cursor-pointer", onClick: this.expandOperators },
	                    _react2.default.createElement(_Icon2.default, { className: "px1", name: "chevrondown", size: 14 }),
	                    "More Options"
	                ) : null
	            );
	        }
	    }]);
	
	    return OperatorSelector;
	}(_react.Component), _class.propTypes = {
	    operator: _propTypes2.default.string,
	    operators: _propTypes2.default.array.isRequired,
	    onOperatorChange: _propTypes2.default.func.isRequired
	}, _temp);
	OperatorSelector.displayName = "OperatorSelector";
	exports.default = OperatorSelector;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.ALL_OPERATORS = exports.EMPTINESS_OPERATORS = exports.DATE_OPERATORS = undefined;
	
	var _class, _temp2;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SpecificDatePicker = __webpack_require__(990);
	
	var _SpecificDatePicker2 = _interopRequireDefault(_SpecificDatePicker);
	
	var _RelativeDatePicker = __webpack_require__(997);
	
	var _RelativeDatePicker2 = _interopRequireDefault(_RelativeDatePicker);
	
	var _DateOperatorSelector = __webpack_require__(998);
	
	var _DateOperatorSelector2 = _interopRequireDefault(_DateOperatorSelector);
	
	var _Calendar = __webpack_require__(991);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _util = __webpack_require__(870);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SingleDatePicker = function SingleDatePicker(_ref) {
	    var _ref$filter = _slicedToArray(_ref.filter, 3),
	        op = _ref$filter[0],
	        field = _ref$filter[1],
	        value = _ref$filter[2],
	        onFilterChange = _ref.onFilterChange,
	        hideTimeSelectors = _ref.hideTimeSelectors;
	
	    return _react2.default.createElement(_SpecificDatePicker2.default, {
	        value: value,
	        onChange: function onChange(value) {
	            return onFilterChange([op, field, value]);
	        },
	        hideTimeSelectors: hideTimeSelectors,
	        calendar: true });
	};
	
	SingleDatePicker.displayName = "SingleDatePicker";
	var MultiDatePicker = function MultiDatePicker(_ref2) {
	    var _ref2$filter = _slicedToArray(_ref2.filter, 4),
	        op = _ref2$filter[0],
	        field = _ref2$filter[1],
	        startValue = _ref2$filter[2],
	        endValue = _ref2$filter[3],
	        onFilterChange = _ref2.onFilterChange,
	        hideTimeSelectors = _ref2.hideTimeSelectors;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "mx2 mb1" },
	        _react2.default.createElement(
	            "div",
	            { className: "flex" },
	            _react2.default.createElement(_SpecificDatePicker2.default, {
	                value: startValue,
	                hideTimeSelectors: hideTimeSelectors,
	                onChange: function onChange(value) {
	                    return onFilterChange([op, field, value, endValue]);
	                } }),
	            _react2.default.createElement(
	                "span",
	                { className: "mx2 mt2" },
	                "\u2013"
	            ),
	            _react2.default.createElement(_SpecificDatePicker2.default, {
	                value: endValue,
	                hideTimeSelectors: hideTimeSelectors,
	                onChange: function onChange(value) {
	                    return onFilterChange([op, field, startValue, value]);
	                } })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "Calendar--noContext" },
	            _react2.default.createElement(_Calendar2.default, {
	                initial: startValue ? (0, _moment2.default)(startValue) : (0, _moment2.default)(),
	                selected: startValue && (0, _moment2.default)(startValue),
	                selectedEnd: endValue && (0, _moment2.default)(endValue),
	                onChange: function onChange(startValue, endValue) {
	                    return onFilterChange([op, field, startValue, endValue]);
	                },
	                isDual: true
	            })
	        )
	    );
	};
	
	MultiDatePicker.displayName = "MultiDatePicker";
	var PreviousPicker = function PreviousPicker(props) {
	    return _react2.default.createElement(_RelativeDatePicker2.default, _extends({}, props, { formatter: function formatter(value) {
	            return value * -1;
	        } }));
	};
	
	PreviousPicker.displayName = "PreviousPicker";
	var NextPicker = function NextPicker(props) {
	    return _react2.default.createElement(_RelativeDatePicker2.default, props);
	};
	
	NextPicker.displayName = "NextPicker";
	
	var CurrentPicker = function (_Component) {
	    _inherits(CurrentPicker, _Component);
	
	    function CurrentPicker(props) {
	        _classCallCheck(this, CurrentPicker);
	
	        var _this = _possibleConstructorReturn(this, (CurrentPicker.__proto__ || Object.getPrototypeOf(CurrentPicker)).call(this, props));
	
	        _this.state = { showUnits: false };
	        return _this;
	    }
	
	    _createClass(CurrentPicker, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$filter = _slicedToArray(_props.filter, 4),
	                operator = _props$filter[0],
	                field = _props$filter[1],
	                intervals = _props$filter[2],
	                unit = _props$filter[3],
	                onFilterChange = _props.onFilterChange;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "mx2" },
	                _react2.default.createElement(_RelativeDatePicker.UnitPicker, {
	                    value: unit,
	                    open: this.state.showUnits,
	                    onChange: function onChange(value) {
	                        onFilterChange([operator, field, intervals, value]);
	                        _this2.setState({ showUnits: false });
	                    },
	                    togglePicker: function togglePicker() {
	                        return _this2.setState({ showUnits: !_this2.state.showUnits });
	                    },
	                    formatter: function formatter(val) {
	                        return val;
	                    },
	                    periods: _RelativeDatePicker.DATE_PERIODS
	                })
	            );
	        }
	    }]);
	
	    return CurrentPicker;
	}(_react.Component);
	
	CurrentPicker.displayName = "CurrentPicker";
	
	
	var getIntervals = function getIntervals(_ref3) {
	    var _ref4 = _slicedToArray(_ref3, 4),
	        op = _ref4[0],
	        field = _ref4[1],
	        value = _ref4[2],
	        unit = _ref4[3];
	
	    return (0, _util.mbqlEq)(op, "time-interval") && typeof value === "number" ? Math.abs(value) : 30;
	};
	var getUnit = function getUnit(_ref5) {
	    var _ref6 = _slicedToArray(_ref5, 4),
	        op = _ref6[0],
	        field = _ref6[1],
	        value = _ref6[2],
	        unit = _ref6[3];
	
	    return (0, _util.mbqlEq)(op, "time-interval") && unit ? unit : "day";
	};
	
	var getDate = function getDate(value) {
	    if (typeof value !== "string" || !(0, _moment2.default)(value).isValid()) {
	        value = (0, _moment2.default)().format("YYYY-MM-DD");
	    }
	    return value;
	};
	
	var hasTime = function hasTime(value) {
	    return typeof value === "string" && /T\d{2}:\d{2}:\d{2}$/.test(value);
	};
	
	function getDateTimeField(field, bucketing) {
	    var target = getDateTimeFieldTarget(field);
	    if (bucketing) {
	        // $FlowFixMe
	        return ["datetime-field", target, bucketing];
	    } else {
	        return target;
	    }
	}
	
	function getDateTimeFieldTarget(field) {
	    if (_query2.default.isDatetimeField(field)) {
	        // $FlowFixMe:
	        return field[1];
	    } else {
	        // $FlowFixMe
	        return field;
	    }
	}
	
	// wraps values in "datetime-field" is any of them have a time component
	function getDateTimeFieldAndValues(filter, count) {
	    var values = filter.slice(2, 2 + count).map(function (value) {
	        return value && getDate(value);
	    });
	    var bucketing = _underscore2.default.any(values, hasTime) ? "minute" : null;
	    var field = getDateTimeField(filter[1], bucketing);
	    // $FlowFixMe
	    return [field].concat(_toConsumableArray(values));
	}
	
	var ALL_TIME_OPERATOR = {
	    name: "All Time",
	    init: function init() {
	        return null;
	    },
	    test: function test(op) {
	        return op === null;
	    }
	};
	
	var DATE_OPERATORS = exports.DATE_OPERATORS = [{
	    name: "Previous",
	    init: function init(filter) {
	        return ["time-interval", getDateTimeField(filter[1]), -getIntervals(filter), getUnit(filter)];
	    },
	    // $FlowFixMe
	    test: function test(_ref7) {
	        var _ref8 = _slicedToArray(_ref7, 3),
	            op = _ref8[0],
	            field = _ref8[1],
	            value = _ref8[2];
	
	        return (0, _util.mbqlEq)(op, "time-interval") && value < 0 || Object.is(value, -0);
	    },
	    widget: PreviousPicker
	}, {
	    name: "Next",
	    init: function init(filter) {
	        return ["time-interval", getDateTimeField(filter[1]), getIntervals(filter), getUnit(filter)];
	    },
	    // $FlowFixMe
	    test: function test(_ref9) {
	        var _ref10 = _slicedToArray(_ref9, 3),
	            op = _ref10[0],
	            field = _ref10[1],
	            value = _ref10[2];
	
	        return (0, _util.mbqlEq)(op, "time-interval") && value >= 0;
	    },
	    widget: NextPicker
	}, {
	    name: "Current",
	    init: function init(filter) {
	        return ["time-interval", getDateTimeField(filter[1]), "current", getUnit(filter)];
	    },
	    test: function test(_ref11) {
	        var _ref12 = _slicedToArray(_ref11, 3),
	            op = _ref12[0],
	            field = _ref12[1],
	            value = _ref12[2];
	
	        return (0, _util.mbqlEq)(op, "time-interval") && value === "current";
	    },
	    widget: CurrentPicker
	}, {
	    name: "Before",
	    init: function init(filter) {
	        return ["<"].concat(_toConsumableArray(getDateTimeFieldAndValues(filter, 1)));
	    },
	    test: function test(_ref13) {
	        var _ref14 = _slicedToArray(_ref13, 1),
	            op = _ref14[0];
	
	        return op === "<";
	    },
	    widget: SingleDatePicker
	}, {
	    name: "After",
	    init: function init(filter) {
	        return [">"].concat(_toConsumableArray(getDateTimeFieldAndValues(filter, 1)));
	    },
	    test: function test(_ref15) {
	        var _ref16 = _slicedToArray(_ref15, 1),
	            op = _ref16[0];
	
	        return op === ">";
	    },
	    widget: SingleDatePicker
	}, {
	    name: "On",
	    init: function init(filter) {
	        return ["="].concat(_toConsumableArray(getDateTimeFieldAndValues(filter, 1)));
	    },
	    test: function test(_ref17) {
	        var _ref18 = _slicedToArray(_ref17, 1),
	            op = _ref18[0];
	
	        return op === "=";
	    },
	    widget: SingleDatePicker
	}, {
	    name: "Between",
	    init: function init(filter) {
	        return ["BETWEEN"].concat(_toConsumableArray(getDateTimeFieldAndValues(filter, 2)));
	    },
	    test: function test(_ref19) {
	        var _ref20 = _slicedToArray(_ref19, 1),
	            op = _ref20[0];
	
	        return (0, _util.mbqlEq)(op, "between");
	    },
	    widget: MultiDatePicker
	}];
	
	var EMPTINESS_OPERATORS = exports.EMPTINESS_OPERATORS = [{
	    name: "Is Empty",
	    init: function init(filter) {
	        return ["IS_NULL", getDateTimeField(filter[1])];
	    },
	    test: function test(_ref21) {
	        var _ref22 = _slicedToArray(_ref21, 1),
	            op = _ref22[0];
	
	        return op === "IS_NULL";
	    }
	}, {
	    name: "Not Empty",
	    init: function init(filter) {
	        return ["NOT_NULL", getDateTimeField(filter[1])];
	    },
	    test: function test(_ref23) {
	        var _ref24 = _slicedToArray(_ref23, 1),
	            op = _ref24[0];
	
	        return op === "NOT_NULL";
	    }
	}];
	
	var ALL_OPERATORS = exports.ALL_OPERATORS = DATE_OPERATORS.concat(EMPTINESS_OPERATORS);
	
	var DatePicker = (_temp2 = _class = function (_Component2) {
	    _inherits(DatePicker, _Component2);
	
	    function DatePicker() {
	        var _ref25;
	
	        var _temp, _this3, _ret;
	
	        _classCallCheck(this, DatePicker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref25 = DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call.apply(_ref25, [this].concat(args))), _this3), _this3.state = {
	            operators: []
	        }, _temp), _possibleConstructorReturn(_this3, _ret);
	    }
	
	    _createClass(DatePicker, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            var operators = this.props.hideEmptinessOperators ? DATE_OPERATORS : ALL_OPERATORS;
	
	            var operator = this._getOperator(operators) || operators[0];
	            this.props.onFilterChange(operator.init(this.props.filter));
	
	            this.setState({ operators: operators });
	        }
	    }, {
	        key: "_getOperator",
	        value: function _getOperator(operators) {
	            var _this4 = this;
	
	            return _underscore2.default.find(operators, function (o) {
	                return o.test(_this4.props.filter);
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                filter = _props2.filter,
	                onFilterChange = _props2.onFilterChange,
	                className = _props2.className,
	                includeAllTime = _props2.includeAllTime;
	            var operators = this.state.operators;
	
	            if (includeAllTime) {
	                operators = [ALL_TIME_OPERATOR].concat(_toConsumableArray(operators));
	            }
	
	            var operator = this._getOperator(operators);
	            var Widget = operator && operator.widget;
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("pt2", className) },
	                _react2.default.createElement(_DateOperatorSelector2.default, {
	                    operator: operator && operator.name,
	                    operators: operators,
	                    onOperatorChange: function onOperatorChange(operator) {
	                        return onFilterChange(operator.init(filter));
	                    }
	                }),
	                Widget && _react2.default.createElement(Widget, _extends({}, this.props, {
	                    filter: filter,
	                    hideHoursAndMinutes: this.props.hideTimeSelectors,
	                    onFilterChange: function (_onFilterChange) {
	                        function onFilterChange(_x) {
	                            return _onFilterChange.apply(this, arguments);
	                        }
	
	                        onFilterChange.toString = function () {
	                            return _onFilterChange.toString();
	                        };
	
	                        return onFilterChange;
	                    }(function (filter) {
	                        if (operator && operator.init) {
	                            onFilterChange(operator.init(filter));
	                        } else {
	                            onFilterChange(filter);
	                        }
	                    })
	                }))
	            );
	        }
	    }]);
	
	    return DatePicker;
	}(_react.Component), _class.propTypes = {
	    filter: _propTypes2.default.array.isRequired,
	    onFilterChange: _propTypes2.default.func.isRequired,
	    className: _propTypes2.default.string,
	    hideEmptinessOperators: _propTypes2.default.bool,
	    hideTimeSelectors: _propTypes2.default.bool
	}, _temp2);
	DatePicker.displayName = "DatePicker";
	exports.default = DatePicker;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Calendar = __webpack_require__(991);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ExpandingContent = __webpack_require__(995);
	
	var _ExpandingContent2 = _interopRequireDefault(_ExpandingContent);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _NumericInput = __webpack_require__(996);
	
	var _NumericInput2 = _interopRequireDefault(_NumericInput);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DATE_FORMAT = "YYYY-MM-DD";
	var DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";
	
	var SpecificDatePicker = (_temp = _class = function (_Component) {
	    _inherits(SpecificDatePicker, _Component);
	
	    function SpecificDatePicker(props) {
	        _classCallCheck(this, SpecificDatePicker);
	
	        var _this = _possibleConstructorReturn(this, (SpecificDatePicker.__proto__ || Object.getPrototypeOf(SpecificDatePicker)).call(this, props));
	
	        _this.onChange = function (date, hours, minutes) {
	            var m = (0, _moment2.default)(date);
	            if (!m.isValid()) {
	                _this.props.onChange(null);
	            }
	
	            var hasTime = false;
	            if (hours != null) {
	                m.hours(hours);
	                hasTime = true;
	            }
	            if (minutes != null) {
	                m.minutes(minutes);
	                hasTime = true;
	            }
	
	            if (hasTime) {
	                _this.props.onChange(m.format(DATE_TIME_FORMAT));
	            } else {
	                _this.props.onChange(m.format(DATE_FORMAT));
	            }
	        };
	
	        _this.state = {
	            showCalendar: true
	        };
	        return _this;
	    }
	
	    _createClass(SpecificDatePicker, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                value = _props.value,
	                calendar = _props.calendar,
	                hideTimeSelectors = _props.hideTimeSelectors;
	            var showCalendar = this.state.showCalendar;
	
	
	            var date = void 0,
	                hours = void 0,
	                minutes = void 0;
	            if ((0, _moment2.default)(value, DATE_TIME_FORMAT, true).isValid()) {
	                date = (0, _moment2.default)(value, DATE_TIME_FORMAT, true);
	                hours = date.hours();
	                minutes = date.minutes();
	                date.startOf("day");
	            } else if ((0, _moment2.default)(value, DATE_FORMAT, true).isValid()) {
	                date = (0, _moment2.default)(value, DATE_FORMAT, true);
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "px1" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center mb1" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: (0, _classnames2.default)('border-top border-bottom full border-left', { 'border-right': !calendar }) },
	                        _react2.default.createElement(_Input2.default, {
	                            placeholder: (0, _moment2.default)().format("MM/DD/YYYY"),
	                            className: "borderless full p2 h3",
	                            style: {
	                                outline: 'none'
	                            },
	                            value: date ? date.format("MM/DD/YYYY") : "",
	                            onBlurChange: function onBlurChange(_ref) {
	                                var value = _ref.target.value;
	
	                                var date = (0, _moment2.default)(value, "MM/DD/YYYY");
	                                if (date.isValid()) {
	                                    _this2.onChange(date, hours, minutes);
	                                } else {
	                                    _this2.onChange(null);
	                                }
	                            },
	                            ref: "value"
	                        })
	                    ),
	                    calendar && _react2.default.createElement(
	                        "div",
	                        { className: "border-right border-bottom border-top p2" },
	                        _react2.default.createElement(_Tooltip2.default, {
	                            tooltip: showCalendar ? "Hide calendar" : "Show calendar",
	                            children: _react2.default.createElement(_Icon2.default, {
	                                className: "text-purple-hover cursor-pointer",
	                                name: "calendar",
	                                onClick: function onClick() {
	                                    return _this2.setState({ showCalendar: !_this2.state.showCalendar });
	                                }
	                            })
	                        })
	                    )
	                ),
	                calendar && _react2.default.createElement(
	                    _ExpandingContent2.default,
	                    { open: showCalendar },
	                    _react2.default.createElement(_Calendar2.default, {
	                        selected: date,
	                        initial: date || (0, _moment2.default)(),
	                        onChange: function onChange(value) {
	                            return _this2.onChange(value, hours, minutes);
	                        },
	                        isRangePicker: false
	                    })
	                ),
	                !hideTimeSelectors && _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)({ 'py2': calendar }, { 'mb3': !calendar }) },
	                    hours == null || minutes == null ? _react2.default.createElement(
	                        "div",
	                        {
	                            className: "text-purple-hover cursor-pointer flex align-center",
	                            onClick: function onClick() {
	                                return _this2.onChange(date, 12, 30);
	                            }
	                        },
	                        _react2.default.createElement(_Icon2.default, {
	                            className: "mr1",
	                            name: "clock"
	                        }),
	                        "Add a time"
	                    ) : _react2.default.createElement(HoursMinutes, {
	                        clear: function clear() {
	                            return _this2.onChange(date, null, null);
	                        },
	                        hours: hours,
	                        minutes: minutes,
	                        onChangeHours: function onChangeHours(hours) {
	                            return _this2.onChange(date, hours, minutes);
	                        },
	                        onChangeMinutes: function onChangeMinutes(minutes) {
	                            return _this2.onChange(date, hours, minutes);
	                        }
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SpecificDatePicker;
	}(_react.Component), _class.propTypes = {
	    value: _propTypes2.default.string,
	    onChange: _propTypes2.default.func.isRequired
	}, _temp);
	SpecificDatePicker.displayName = "SpecificDatePicker";
	exports.default = SpecificDatePicker;
	
	
	var HoursMinutes = function HoursMinutes(_ref2) {
	    var hours = _ref2.hours,
	        minutes = _ref2.minutes,
	        onChangeHours = _ref2.onChangeHours,
	        onChangeMinutes = _ref2.onChangeMinutes,
	        clear = _ref2.clear;
	    return _react2.default.createElement(
	        "div",
	        { className: "flex align-center" },
	        _react2.default.createElement(_NumericInput2.default, {
	            className: "input",
	            size: 2,
	            maxLength: 2,
	            value: hours % 12 === 0 ? "12" : String(hours % 12),
	            onChange: function onChange(value) {
	                return onChangeHours((hours >= 12 ? 12 : 0) + value);
	            }
	        }),
	        _react2.default.createElement(
	            "span",
	            { className: "px1" },
	            ":"
	        ),
	        _react2.default.createElement(_NumericInput2.default, {
	            className: "input",
	            size: 2,
	            maxLength: 2,
	            value: minutes,
	            onChange: function onChange(value) {
	                return onChangeMinutes(value);
	            }
	        }),
	        _react2.default.createElement(
	            "div",
	            { className: "flex align-center pl1" },
	            _react2.default.createElement(
	                "span",
	                { className: (0, _classnames2.default)("text-purple-hover mr1", { "text-purple": hours < 12, "cursor-pointer": hours >= 12 }), onClick: hours >= 12 ? function () {
	                        return onChangeHours(hours - 12);
	                    } : null },
	                "AM"
	            ),
	            _react2.default.createElement(
	                "span",
	                { className: (0, _classnames2.default)("text-purple-hover mr1", { "text-purple": hours >= 12, "cursor-pointer": hours < 12 }), onClick: hours < 12 ? function () {
	                        return onChangeHours(hours + 12);
	                    } : null },
	                "PM"
	            )
	        ),
	        _react2.default.createElement(_Icon2.default, {
	            className: "text-grey-2 cursor-pointer text-grey-4-hover ml-auto",
	            name: "close",
	            onClick: function onClick() {
	                return clear();
	            }
	        })
	    );
	};
	HoursMinutes.displayName = "HoursMinutes";

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _class2, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(992);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Calendar = (_temp = _class = function (_Component) {
	    _inherits(Calendar, _Component);
	
	    function Calendar(props) {
	        _classCallCheck(this, Calendar);
	
	        var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));
	
	        _this.state = {
	            current: (0, _moment2.default)(props.initial || undefined)
	        };
	
	        _this.previous = _this.previous.bind(_this);
	        _this.next = _this.next.bind(_this);
	        _this.onClickDay = _this.onClickDay.bind(_this);
	        return _this;
	    }
	
	    _createClass(Calendar, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            var resetCurrent = false;
	            if (nextProps.selected && nextProps.selectedEnd) {
	                resetCurrent = nextProps.selected.isAfter(this.state.current, "month") && nextProps.selectedEnd.isBefore(this.state.current, "month");
	            } else if (nextProps.selected) {
	                resetCurrent = nextProps.selected.isAfter(this.state.current, "month") || nextProps.selected.isBefore(this.state.current, "month");
	            }
	            if (resetCurrent) {
	                this.setState({ current: nextProps.selected });
	            }
	        }
	    }, {
	        key: "onClickDay",
	        value: function onClickDay(date, e) {
	            var _props = this.props,
	                selected = _props.selected,
	                selectedEnd = _props.selectedEnd,
	                isRangePicker = _props.isRangePicker;
	
	            if (!isRangePicker || !selected || selectedEnd) {
	                this.props.onChange(date.format("YYYY-MM-DD"), null);
	            } else if (!selectedEnd) {
	                if (date.isAfter(selected)) {
	                    this.props.onChange(selected.format("YYYY-MM-DD"), date.format("YYYY-MM-DD"));
	                } else {
	                    this.props.onChange(date.format("YYYY-MM-DD"), selected.format("YYYY-MM-DD"));
	                }
	            }
	        }
	    }, {
	        key: "previous",
	        value: function previous() {
	            var month = this.state.current;
	            month.add(-1, "M");
	            this.setState({ month: month });
	        }
	    }, {
	        key: "next",
	        value: function next() {
	            var month = this.state.current;
	            month.add(1, "M");
	            this.setState({ month: month });
	        }
	    }, {
	        key: "renderMonthHeader",
	        value: function renderMonthHeader(current, side) {
	            return _react2.default.createElement(
	                "div",
	                { className: "Calendar-header flex align-center" },
	                side !== "right" && _react2.default.createElement(
	                    "div",
	                    { className: "bordered rounded p1 cursor-pointer transition-border border-hover px1", onClick: this.previous },
	                    _react2.default.createElement(_Icon2.default, { name: "chevronleft", size: 10 })
	                ),
	                _react2.default.createElement("span", { className: "flex-full" }),
	                _react2.default.createElement(
	                    "h4",
	                    { className: "cursor-pointer rounded p1" },
	                    current.format("MMMM YYYY")
	                ),
	                _react2.default.createElement("span", { className: "flex-full" }),
	                side !== "left" && _react2.default.createElement(
	                    "div",
	                    { className: "bordered border-hover rounded p1 transition-border cursor-pointer px1", onClick: this.next },
	                    _react2.default.createElement(_Icon2.default, { name: "chevronright", size: 10 })
	                )
	            );
	        }
	    }, {
	        key: "renderDayNames",
	        value: function renderDayNames() {
	            var names = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
	            return _react2.default.createElement(
	                "div",
	                { className: "Calendar-day-names Calendar-week py1" },
	                names.map(function (name) {
	                    return _react2.default.createElement(
	                        "span",
	                        { key: name, className: "Calendar-day-name text-centered" },
	                        name
	                    );
	                })
	            );
	        }
	    }, {
	        key: "renderWeeks",
	        value: function renderWeeks(current) {
	            var weeks = [],
	                done = false,
	                date = (0, _moment2.default)(current).startOf("month").add("w" - 1).day("Sunday"),
	                monthIndex = date.month(),
	                count = 0;
	
	            while (!done) {
	                weeks.push(_react2.default.createElement(Week, {
	                    key: date.toString(),
	                    date: (0, _moment2.default)(date),
	                    month: current,
	                    onClickDay: this.onClickDay,
	                    selected: this.props.selected,
	                    selectedEnd: this.props.selectedEnd
	                }));
	                date.add(1, "w");
	                done = count++ > 2 && monthIndex !== date.month();
	                monthIndex = date.month();
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "Calendar-weeks relative" },
	                weeks
	            );
	        }
	    }, {
	        key: "renderCalender",
	        value: function renderCalender(current, side) {
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("Calendar", { "Calendar--range": this.props.selected && this.props.selectedEnd }) },
	                this.renderMonthHeader(current, side),
	                this.renderDayNames(current),
	                this.renderWeeks(current)
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var current = this.state.current;
	
	            if (this.props.isDual) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "flex" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "mr3" },
	                        this.renderCalender(current, "left")
	                    ),
	                    this.renderCalender((0, _moment2.default)(current).add(1, "month"), "right")
	                );
	            } else {
	                return this.renderCalender(current);
	            }
	        }
	    }]);
	
	    return Calendar;
	}(_react.Component), _class.propTypes = {
	    selected: _propTypes2.default.object,
	    onChange: _propTypes2.default.func.isRequired,
	    onAfterClick: _propTypes2.default.func,
	    onBeforeClick: _propTypes2.default.func,
	    isRangePicker: _propTypes2.default.bool,
	    isDual: _propTypes2.default.bool
	}, _class.defaultProps = {
	    isRangePicker: true
	}, _temp);
	Calendar.displayName = "Calendar";
	exports.default = Calendar;
	var Week = (_temp2 = _class2 = function (_Component2) {
	    _inherits(Week, _Component2);
	
	    function Week() {
	        _classCallCheck(this, Week);
	
	        return _possibleConstructorReturn(this, (Week.__proto__ || Object.getPrototypeOf(Week)).apply(this, arguments));
	    }
	
	    _createClass(Week, [{
	        key: "render",
	        value: function render() {
	            var days = [];
	            var _props2 = this.props,
	                date = _props2.date,
	                month = _props2.month,
	                selected = _props2.selected,
	                selectedEnd = _props2.selectedEnd;
	
	
	            for (var i = 0; i < 7; i++) {
	                var classes = (0, _classnames2.default)({
	                    'p1': true,
	                    'cursor-pointer': true,
	                    'text-centered': true,
	                    "Calendar-day": true,
	                    "Calendar-day--today": date.isSame(new Date(), "day"),
	                    "Calendar-day--this-month": date.month() === month.month(),
	                    "Calendar-day--selected": selected && date.isSame(selected, "day"),
	                    "Calendar-day--selected-end": selectedEnd && date.isSame(selectedEnd, "day"),
	                    "Calendar-day--week-start": i === 0,
	                    "Calendar-day--week-end": i === 6,
	                    "Calendar-day--in-range": !(date.isSame(selected, "day") || date.isSame(selectedEnd, "day")) && (date.isSame(selected, "day") || date.isSame(selectedEnd, "day") || selectedEnd && selectedEnd.isAfter(date, "day") && date.isAfter(selected, "day"))
	                });
	                days.push(_react2.default.createElement(
	                    "span",
	                    { key: date.toString(), className: classes, onClick: this.props.onClickDay.bind(null, date) },
	                    date.date()
	                ));
	                date = (0, _moment2.default)(date);
	                date.add(1, "d");
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "Calendar-week", key: days[0].toString() },
	                days
	            );
	        }
	    }]);
	
	    return Week;
	}(_react.Component), _class2.propTypes = {
	    selected: _propTypes2.default.object,
	    selectedEnd: _propTypes2.default.object,
	    onClickDay: _propTypes2.default.func.isRequired
	}, _temp2);
	Week.displayName = "Week";

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */,
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = (_temp = _class = function (_Component) {
	    _inherits(Input, _Component);
	
	    function Input(props, context) {
	        _classCallCheck(this, Input);
	
	        var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props, context));
	
	        _this.onBlur = _this.onBlur.bind(_this);
	        _this.onChange = _this.onChange.bind(_this);
	        _this.state = { value: props.value };
	        return _this;
	    }
	
	    _createClass(Input, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            this.setState({ value: newProps.value });
	        }
	    }, {
	        key: "onChange",
	        value: function onChange(event) {
	            this.setState({ value: event.target.value });
	            if (this.props.onChange) {
	                this.props.onChange(event);
	            }
	        }
	    }, {
	        key: "onBlur",
	        value: function onBlur(event) {
	            if (this.props.onBlurChange && (this.props.value || "") !== event.target.value) {
	                this.props.onBlurChange(event);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var props = _underscore2.default.omit(this.props, "onBlurChange", "value", "onBlur", "onChange");
	            return _react2.default.createElement("input", _extends({}, props, { value: this.state.value, onBlur: this.onBlur, onChange: this.onChange }));
	        }
	    }]);
	
	    return Input;
	}(_react.Component), _class.propTypes = {
	    type: _propTypes2.default.string,
	    value: _propTypes2.default.string,
	    placeholder: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    onBlurChange: _propTypes2.default.func
	}, _class.defaultProps = {
	    type: "text"
	}, _temp);
	Input.displayName = "Input";
	exports.default = Input;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandingContent = function (_Component) {
	    _inherits(ExpandingContent, _Component);
	
	    function ExpandingContent() {
	        _classCallCheck(this, ExpandingContent);
	
	        var _this = _possibleConstructorReturn(this, (ExpandingContent.__proto__ || Object.getPrototypeOf(ExpandingContent)).call(this));
	
	        _this.state = { open: false };
	        return _this;
	    }
	
	    _createClass(ExpandingContent, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                open = _props.open;
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    style: {
	                        maxHeight: open ? 'none' : 0,
	                        overflow: 'hidden',
	                        transition: 'max-height 0.3s ease'
	                    }
	                },
	                children
	            );
	        }
	    }]);
	
	    return ExpandingContent;
	}(_react.Component);
	
	ExpandingContent.displayName = 'ExpandingContent';
	exports.default = ExpandingContent;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NumericInput = function NumericInput(_ref) {
	    var value = _ref.value,
	        onChange = _ref.onChange,
	        props = _objectWithoutProperties(_ref, ["value", "onChange"]);
	
	    return _react2.default.createElement(_Input2.default, _extends({
	        value: value == null ? "" : String(value),
	        onBlurChange: function onBlurChange(_ref2) {
	            var value = _ref2.target.value;
	
	            value = value ? parseInt(value, 10) : null;
	            if (!isNaN(value)) {
	                onChange(value);
	            }
	        }
	    }, props));
	};
	
	NumericInput.displayName = "NumericInput";
	exports.default = NumericInput;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UnitPicker = exports.default = exports.DATE_PERIODS = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _humanizePlus = __webpack_require__(874);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _NumericInput = __webpack_require__(996);
	
	var _NumericInput2 = _interopRequireDefault(_NumericInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DATE_PERIODS = exports.DATE_PERIODS = ["day", "week", "month", "year"];
	
	var TIME_PERIODS = ["minute", "hour"];
	
	var ALL_PERIODS = DATE_PERIODS.concat(TIME_PERIODS);
	
	var RelativeDatePicker = (_temp = _class = function (_Component) {
	    _inherits(RelativeDatePicker, _Component);
	
	    function RelativeDatePicker(props) {
	        _classCallCheck(this, RelativeDatePicker);
	
	        var _this = _possibleConstructorReturn(this, (RelativeDatePicker.__proto__ || Object.getPrototypeOf(RelativeDatePicker)).call(this, props));
	
	        _this.state = {
	            showUnits: false
	        };
	        return _this;
	    }
	
	    _createClass(RelativeDatePicker, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$filter = _slicedToArray(_props.filter, 4),
	                op = _props$filter[0],
	                field = _props$filter[1],
	                intervals = _props$filter[2],
	                unit = _props$filter[3],
	                onFilterChange = _props.onFilterChange,
	                formatter = _props.formatter;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "px2" },
	                _react2.default.createElement(_NumericInput2.default, {
	                    className: "input h3 mb2 border-purple",
	                    "data-ui-tag": "relative-date-input",
	                    value: typeof intervals === "number" ? Math.abs(intervals) : intervals,
	                    onChange: function onChange(value) {
	                        return onFilterChange([op, field, formatter(value), unit]);
	                    },
	                    placeholder: "30"
	                }),
	                _react2.default.createElement(UnitPicker, {
	                    open: this.state.showUnits,
	                    value: unit,
	                    onChange: function onChange(value) {
	                        onFilterChange([op, field, intervals, value]);
	                        _this2.setState({ showUnits: false });
	                    },
	                    togglePicker: function togglePicker() {
	                        return _this2.setState({ showUnits: !_this2.state.showUnits });
	                    }
	                    // $FlowFixMe: intervals could be a string like "current" "next"
	                    , intervals: intervals,
	                    formatter: formatter,
	                    periods: this.props.hideTimeSelectors ? DATE_PERIODS : ALL_PERIODS
	                })
	            );
	        }
	    }]);
	
	    return RelativeDatePicker;
	}(_react.Component), _class.propTypes = {
	    filter: _propTypes2.default.array.isRequired,
	    onFilterChange: _propTypes2.default.func.isRequired,
	    formatter: _propTypes2.default.func.isRequired,
	    hideTimeSelectors: _propTypes2.default.bool
	}, _class.defaultProps = {
	    formatter: function formatter(value) {
	        return value;
	    }
	}, _temp);
	RelativeDatePicker.displayName = "RelativeDatePicker";
	exports.default = RelativeDatePicker;
	var UnitPicker = exports.UnitPicker = function UnitPicker(_ref) {
	    var open = _ref.open,
	        value = _ref.value,
	        onChange = _ref.onChange,
	        togglePicker = _ref.togglePicker,
	        intervals = _ref.intervals,
	        formatter = _ref.formatter,
	        periods = _ref.periods;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            {
	                onClick: function onClick() {
	                    return togglePicker();
	                },
	                className: "flex align-center cursor-pointer text-purple-hover mb2"
	            },
	            _react2.default.createElement(
	                "h3",
	                null,
	                (0, _humanizePlus.pluralize)(formatter(intervals) || 1, (0, _humanizePlus.titleCase)(value))
	            ),
	            _react2.default.createElement(_Icon2.default, {
	                name: open ? 'chevronup' : 'chevrondown',
	                width: "12",
	                height: "12",
	                className: "ml1"
	            })
	        ),
	        _react2.default.createElement(
	            "ol",
	            {
	                className: "text-purple",
	                style: {
	                    maxHeight: open ? 'none' : 0,
	                    overflow: 'hidden'
	                }
	            },
	            periods.map(function (unit, index) {
	                return _react2.default.createElement(
	                    "li",
	                    {
	                        className: (0, _classnames2.default)('List-item cursor-pointer p1', { 'List-item--selected': unit === value }),
	                        key: index,
	                        onClick: function onClick() {
	                            return onChange(unit);
	                        }
	                    },
	                    _react2.default.createElement(
	                        "h4",
	                        { className: "List-item-title" },
	                        (0, _humanizePlus.capitalize)((0, _humanizePlus.pluralize)(formatter(intervals) || 1, unit))
	                    )
	                );
	            })
	        )
	    );
	};
	UnitPicker.displayName = "UnitPicker";

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _humanizePlus = __webpack_require__(874);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateOperatorSelector = (_temp = _class = function (_Component) {
	    _inherits(DateOperatorSelector, _Component);
	
	    function DateOperatorSelector() {
	        _classCallCheck(this, DateOperatorSelector);
	
	        var _this = _possibleConstructorReturn(this, (DateOperatorSelector.__proto__ || Object.getPrototypeOf(DateOperatorSelector)).call(this));
	
	        _this.toggleExpanded = function () {
	            _this.setState({ expanded: !_this.state.expanded });
	        };
	
	        _this.state = {
	            expanded: false
	        };
	        return _this;
	    }
	
	    _createClass(DateOperatorSelector, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                operator = _props.operator,
	                operators = _props.operators,
	                onOperatorChange = _props.onOperatorChange;
	            var expanded = this.state.expanded;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "mx2" },
	                _react2.default.createElement(
	                    "div",
	                    {
	                        className: "flex align-center cursor-pointer text-purple-hover mb2",
	                        onClick: function onClick() {
	                            return _this2.toggleExpanded();
	                        }
	                    },
	                    _react2.default.createElement(
	                        "h3",
	                        null,
	                        operator && (0, _humanizePlus.titleCase)(operator)
	                    ),
	                    _react2.default.createElement(_Icon2.default, {
	                        name: expanded ? 'chevronup' : 'chevrondown',
	                        width: "12",
	                        height: "12",
	                        className: "ml1"
	                    })
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    {
	                        className: "text-purple",
	                        style: {
	                            height: expanded ? 'auto' : 0,
	                            overflow: 'hidden',
	                            display: 'block'
	                        }
	                    },
	                    operators.map(function (o) {
	                        return _react2.default.createElement(
	                            "li",
	                            {
	                                className: (0, _classnames2.default)('List-item cursor-pointer p1', {
	                                    'List-item--selected': o.name === operator
	                                }),
	                                key: o.name,
	                                onClick: function onClick() {
	                                    onOperatorChange(o);
	                                    _this2.toggleExpanded();
	                                }
	                            },
	                            _react2.default.createElement(
	                                "h4",
	                                { className: "List-item-title" },
	                                o.name
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return DateOperatorSelector;
	}(_react.Component), _class.propTypes = {
	    operator: _propTypes2.default.string,
	    operators: _propTypes2.default.array.isRequired,
	    onOperatorChange: _propTypes2.default.func.isRequired
	}, _temp);
	DateOperatorSelector.displayName = "DateOperatorSelector";
	exports.default = DateOperatorSelector;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextPicker = __webpack_require__(1000);
	
	var _TextPicker2 = _interopRequireDefault(_TextPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NumberPicker = (_temp = _class = function (_Component) {
	    _inherits(NumberPicker, _Component);
	
	    function NumberPicker(props) {
	        _classCallCheck(this, NumberPicker);
	
	        var _this = _possibleConstructorReturn(this, (NumberPicker.__proto__ || Object.getPrototypeOf(NumberPicker)).call(this, props));
	
	        _this.state = {
	            stringValues: props.values.map(function (v) {
	                if (typeof v === 'number') {
	                    return String(v);
	                } else {
	                    return String(v || "");
	                }
	            }),
	            validations: _this._validate(props.values)
	        };
	        return _this;
	    }
	
	    _createClass(NumberPicker, [{
	        key: "_validate",
	        value: function _validate(values) {
	            return values.map(function (v) {
	                return v === undefined || !isNaN(v);
	            });
	        }
	    }, {
	        key: "onValuesChange",
	        value: function onValuesChange(stringValues) {
	            var values = stringValues.map(function (v) {
	                return parseFloat(v);
	            });
	            this.props.onValuesChange(values.map(function (v) {
	                return isNaN(v) ? null : v;
	            }));
	            this.setState({
	                stringValues: stringValues,
	                validations: this._validate(values)
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            // $FlowFixMe
	            var values = this.state.stringValues.slice(0, this.props.values.length);
	            return _react2.default.createElement(_TextPicker2.default, _extends({}, this.props, {
	                values: values,
	                validations: this.state.validations,
	                onValuesChange: function onValuesChange(values) {
	                    return _this2.onValuesChange(values);
	                }
	            }));
	        }
	    }]);
	
	    return NumberPicker;
	}(_react.Component), _class.propTypes = {
	    values: _propTypes2.default.array.isRequired,
	    onValuesChange: _propTypes2.default.func.isRequired,
	    placeholder: _propTypes2.default.string,
	    multi: _propTypes2.default.bool
	}, _class.defaultProps = {
	    placeholder: "Enter desired number"
	}, _temp);
	NumberPicker.displayName = "NumberPicker";
	exports.default = NumberPicker;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactTextareaAutosize = __webpack_require__(1001);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextPicker = (_temp = _class = function (_Component) {
	    _inherits(TextPicker, _Component);
	
	    function TextPicker(props) {
	        _classCallCheck(this, TextPicker);
	
	        var _this = _possibleConstructorReturn(this, (TextPicker.__proto__ || Object.getPrototypeOf(TextPicker)).call(this, props));
	
	        _this.state = {
	            fieldString: props.values.join(', ')
	        };
	        return _this;
	    }
	
	    _createClass(TextPicker, [{
	        key: "setValue",
	        value: function setValue(fieldString) {
	            if (fieldString != null) {
	                // Only strip newlines from field string to not interfere with copy-pasting
	                var newLineRegex = /\r?\n|\r/g;
	                var newFieldString = fieldString.replace(newLineRegex, '');
	                this.setState({ fieldString: newFieldString });
	
	                // Construct the values array for real-time validation
	                // Trim values to prevent confusing problems with leading/trailing whitespaces
	                var newValues = newFieldString.split(',').map(function (v) {
	                    return v.trim();
	                }).filter(function (v) {
	                    return v !== "";
	                });
	                this.props.onValuesChange(newValues);
	            } else {
	                this.props.onValuesChange([]);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                validations = _props.validations,
	                multi = _props.multi,
	                onCommit = _props.onCommit;
	
	            var hasInvalidValues = _underscore2.default.some(validations, function (v) {
	                return v === false;
	            });
	
	            var commitOnEnter = function commitOnEnter(e) {
	                if (e.key === "Enter" && onCommit) {
	                    onCommit();
	                }
	            };
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: "FilterInput px1 pt1 relative" },
	                    _react2.default.createElement(_reactTextareaAutosize2.default, {
	                        className: (0, _classnames2.default)("input block full border-purple", { "border-error": hasInvalidValues }),
	                        type: "text",
	                        value: this.state.fieldString,
	                        onChange: function onChange(e) {
	                            return _this2.setValue(e.target.value);
	                        },
	                        onKeyPress: commitOnEnter,
	                        placeholder: this.props.placeholder,
	                        autoFocus: true,
	                        style: { resize: "none" },
	                        maxRows: 8
	                    })
	                ),
	                multi ? _react2.default.createElement(
	                    "div",
	                    { className: "p1 text-small" },
	                    "You can enter multiple values separated by commas"
	                ) : null
	            );
	        }
	    }]);
	
	    return TextPicker;
	}(_react.Component), _class.propTypes = {
	    values: _propTypes2.default.array.isRequired,
	    onValuesChange: _propTypes2.default.func.isRequired,
	    placeholder: _propTypes2.default.string,
	    validations: _propTypes2.default.array,
	    multi: _propTypes2.default.bool,
	    onCommit: _propTypes2.default.func
	}, _class.defaultProps = {
	    validations: [],
	    placeholder: "Enter desired text"
	}, _temp);
	TextPicker.displayName = "TextPicker";
	exports.default = TextPicker;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * <TextareaAutosize />
	                    */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _calculateNodeHeight = __webpack_require__(1002);
	
	var _calculateNodeHeight2 = _interopRequireDefault(_calculateNodeHeight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyFunction = function emptyFunction() {};
	
	var TextareaAutosize = (_temp = _class = function (_React$Component) {
	  _inherits(TextareaAutosize, _React$Component);
	
	  function TextareaAutosize(props) {
	    _classCallCheck(this, TextareaAutosize);
	
	    var _this = _possibleConstructorReturn(this, (TextareaAutosize.__proto__ || Object.getPrototypeOf(TextareaAutosize)).call(this, props));
	
	    _this.state = {
	      height: null,
	      minHeight: -Infinity,
	      maxHeight: Infinity
	    };
	    _this._onNextFrameActionId = null;
	    _this._rootDOMNode = null;
	    _this._onChange = _this._onChange.bind(_this);
	    _this._resizeComponent = _this._resizeComponent.bind(_this);
	    _this._onRootDOMNode = _this._onRootDOMNode.bind(_this);
	    return _this;
	  }
	
	  _createClass(TextareaAutosize, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var valueLink = _props.valueLink;
	      var _minRows = _props.minRows;
	      var _maxRows = _props.maxRows;
	      var _onHeightChange = _props.onHeightChange;
	      var _useCacheForDOMMeasurements = _props.useCacheForDOMMeasurements;
	
	      var props = _objectWithoutProperties(_props, ['valueLink', 'minRows', 'maxRows', 'onHeightChange', 'useCacheForDOMMeasurements']);
	
	      if ((typeof valueLink === 'undefined' ? 'undefined' : _typeof(valueLink)) === 'object') {
	        props.value = valueLink.value;
	      }
	      props.style = _extends({}, props.style, {
	        height: this.state.height || 0
	      });
	      var maxHeight = Math.max(props.style.maxHeight ? props.style.maxHeight : Infinity, this.state.maxHeight);
	      if (maxHeight < this.state.height) {
	        props.style.overflow = 'hidden';
	      }
	      return _react2.default.createElement('textarea', _extends({}, props, {
	        onChange: this._onChange,
	        ref: this._onRootDOMNode
	      }));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._resizeComponent();
	      window.addEventListener('resize', this._resizeComponent);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      // Re-render with the new content then recalculate the height as required.
	      this._clearNextFrame();
	      this._onNextFrameActionId = onNextFrame(this._resizeComponent);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // Invoke callback when old height does not equal to new one.
	      if (this.state.height !== prevState.height) {
	        this.props.onHeightChange(this.state.height);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Remove any scheduled events to prevent manipulating the node after it's
	      // been unmounted.
	      this._clearNextFrame();
	      window.removeEventListener('resize', this._resizeComponent);
	    }
	  }, {
	    key: '_clearNextFrame',
	    value: function _clearNextFrame() {
	      if (this._onNextFrameActionId) {
	        clearNextFrameAction(this._onNextFrameActionId);
	      }
	    }
	  }, {
	    key: '_onRootDOMNode',
	    value: function _onRootDOMNode(node) {
	      this._rootDOMNode = node;
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(e) {
	      this._resizeComponent();
	      var _props2 = this.props;
	      var valueLink = _props2.valueLink;
	      var onChange = _props2.onChange;
	
	      if (valueLink) {
	        valueLink.requestChange(e.target.value);
	      } else {
	        onChange(e);
	      }
	    }
	  }, {
	    key: '_resizeComponent',
	    value: function _resizeComponent() {
	      var useCacheForDOMMeasurements = this.props.useCacheForDOMMeasurements;
	
	      this.setState((0, _calculateNodeHeight2.default)(this._rootDOMNode, useCacheForDOMMeasurements, this.props.rows || this.props.minRows, this.props.maxRows));
	    }
	
	    /**
	     * Read the current value of <textarea /> from DOM.
	     */
	
	  }, {
	    key: 'focus',
	
	
	    /**
	     * Put focus on a <textarea /> DOM element.
	     */
	    value: function focus() {
	      this._rootDOMNode.focus();
	    }
	
	    /**
	     * Shifts focus away from a <textarea /> DOM element.
	     */
	
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this._rootDOMNode.blur();
	    }
	  }, {
	    key: 'value',
	    get: function get() {
	      return this._rootDOMNode.value;
	    }
	
	    /**
	     * Set the current value of <textarea /> DOM node.
	     */
	    ,
	    set: function set(val) {
	      this._rootDOMNode.value = val;
	    }
	
	    /**
	     * Read the current selectionStart of <textarea /> from DOM.
	     */
	
	  }, {
	    key: 'selectionStart',
	    get: function get() {
	      return this._rootDOMNode.selectionStart;
	    }
	
	    /**
	     * Set the current selectionStart of <textarea /> DOM node.
	     */
	    ,
	    set: function set(selectionStart) {
	      this._rootDOMNode.selectionStart = selectionStart;
	    }
	
	    /**
	     * Read the current selectionEnd of <textarea /> from DOM.
	     */
	
	  }, {
	    key: 'selectionEnd',
	    get: function get() {
	      return this._rootDOMNode.selectionEnd;
	    }
	
	    /**
	     * Set the current selectionEnd of <textarea /> DOM node.
	     */
	    ,
	    set: function set(selectionEnd) {
	      this._rootDOMNode.selectionEnd = selectionEnd;
	    }
	  }]);
	
	  return TextareaAutosize;
	}(_react2.default.Component), _class.propTypes = {
	  /**
	   * Current textarea value.
	   */
	  value: _react2.default.PropTypes.string,
	
	  /**
	   * Callback on value change.
	   */
	  onChange: _react2.default.PropTypes.func,
	
	  /**
	   * Callback on height changes.
	   */
	  onHeightChange: _react2.default.PropTypes.func,
	
	  /**
	   * Try to cache DOM measurements performed by component so that we don't
	   * touch DOM when it's not needed.
	   *
	   * This optimization doesn't work if we dynamically style <textarea />
	   * component.
	   */
	  useCacheForDOMMeasurements: _react2.default.PropTypes.bool,
	
	  /**
	   * Minimal numbder of rows to show.
	   */
	  rows: _react2.default.PropTypes.number,
	
	  /**
	   * Alias for `rows`.
	   */
	  minRows: _react2.default.PropTypes.number,
	
	  /**
	   * Maximum number of rows to show.
	   */
	  maxRows: _react2.default.PropTypes.number
	}, _class.defaultProps = {
	  onChange: emptyFunction,
	  onHeightChange: emptyFunction,
	  useCacheForDOMMeasurements: false
	}, _temp);
	exports.default = TextareaAutosize;
	
	
	function onNextFrame(cb) {
	  if (window.requestAnimationFrame) {
	    return window.requestAnimationFrame(cb);
	  }
	  return window.setTimeout(cb, 1);
	}
	
	function clearNextFrameAction(nextFrameId) {
	  if (window.cancelAnimationFrame) {
	    window.cancelAnimationFrame(nextFrameId);
	  } else {
	    window.clearTimeout(nextFrameId);
	  }
	}


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateNodeHeight;
	/**
	 * calculateNodeHeight(uiTextNode, useCache = false)
	 */
	
	var HIDDEN_TEXTAREA_STYLE = '\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	
	var computedStyleCache = {};
	var hiddenTextarea = void 0;
	
	function calculateNodeHeight(uiTextNode) {
	  var useCache = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	  var minRows = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	  var maxRows = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache);
	
	  var paddingSize = _calculateNodeStyling.paddingSize;
	  var borderSize = _calculateNodeStyling.borderSize;
	  var boxSizing = _calculateNodeStyling.boxSizing;
	  var sizingStyle = _calculateNodeStyling.sizingStyle;
	
	  // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	
	  hiddenTextarea.setAttribute('style', sizingStyle + ';' + HIDDEN_TEXTAREA_STYLE);
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
	
	  var minHeight = -Infinity;
	  var maxHeight = Infinity;
	  var height = hiddenTextarea.scrollHeight;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height = height - paddingSize;
	  }
	
	  if (minRows !== null || maxRows !== null) {
	    // measure height of a textarea with a single row
	    hiddenTextarea.value = 'x';
	    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	    if (minRows !== null) {
	      minHeight = singleRowHeight * minRows;
	      if (boxSizing === 'border-box') {
	        minHeight = minHeight + paddingSize + borderSize;
	      }
	      height = Math.max(minHeight, height);
	    }
	    if (maxRows !== null) {
	      maxHeight = singleRowHeight * maxRows;
	      if (boxSizing === 'border-box') {
	        maxHeight = maxHeight + paddingSize + borderSize;
	      }
	      height = Math.min(maxHeight, height);
	    }
	  }
	  return { height: height, minHeight: minHeight, maxHeight: maxHeight };
	}
	
	function calculateNodeStyling(node) {
	  var useCache = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
	
	  if (useCache && computedStyleCache[nodeRef]) {
	    return computedStyleCache[nodeRef];
	  }
	
	  var style = window.getComputedStyle(node);
	
	  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
	
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	
	  var sizingStyle = SIZING_STYLE.map(function (name) {
	    return name + ':' + style.getPropertyValue(name);
	  }).join(';');
	
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache && nodeRef) {
	    computedStyleCache[nodeRef] = nodeInfo;
	  }
	
	  return nodeInfo;
	}


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CheckBox = __webpack_require__(1004);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _ListSearchField = __webpack_require__(978);
	
	var _ListSearchField2 = _interopRequireDefault(_ListSearchField);
	
	var _formatting = __webpack_require__(872);
	
	var _string = __webpack_require__(955);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectPicker = (_temp = _class = function (_Component) {
	    _inherits(SelectPicker, _Component);
	
	    function SelectPicker(props) {
	        _classCallCheck(this, SelectPicker);
	
	        var _this = _possibleConstructorReturn(this, (SelectPicker.__proto__ || Object.getPrototypeOf(SelectPicker)).call(this, props));
	
	        _this.updateSearchText = function (value) {
	            var regex = null;
	
	            if (value) {
	                regex = (0, _string.createMultiwordSearchRegex)(value);
	            }
	
	            _this.setState({
	                searchText: value,
	                searchRegex: regex
	            });
	        };
	
	        _this.state = {
	            searchText: "",
	            searchRegex: null
	        };
	        return _this;
	    }
	
	    _createClass(SelectPicker, [{
	        key: "selectValue",
	        value: function selectValue(key, selected) {
	            var values = void 0;
	            if (this.props.multi) {
	                values = this.props.values.slice().filter(function (v) {
	                    return v != null;
	                });
	            } else {
	                values = [];
	            }
	            if (selected) {
	                values.push(key);
	            } else {
	                values = values.filter(function (v) {
	                    return v !== key;
	                });
	            }
	            this.props.onValuesChange(values);
	        }
	    }, {
	        key: "nameForOption",
	        value: function nameForOption(option) {
	            if (option.name === "") {
	                return "Empty";
	            } else if (typeof option.name === "string") {
	                return option.name;
	            } else {
	                return (0, _formatting.capitalize)(String(option.name));
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                values = _props.values,
	                options = _props.options,
	                placeholder = _props.placeholder,
	                multi = _props.multi;
	
	
	            var checked = new Set(values);
	
	            var validOptions = [];
	            var regex = this.state.searchRegex;
	
	            if (regex) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var option = _step.value;
	
	                        if (regex.test(option.key) || regex.test(option.name)) {
	                            validOptions.push(option);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            } else {
	                validOptions = options.slice();
	            }
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                validOptions.length <= 10 && !regex ? null : _react2.default.createElement(
	                    "div",
	                    { className: "px1 pt1" },
	                    _react2.default.createElement(_ListSearchField2.default, {
	                        onChange: this.updateSearchText,
	                        searchText: this.state.searchText,
	                        placeholder: "Find a value",
	                        autoFocus: true
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "px1 pt1", style: { maxHeight: '400px', overflowY: 'scroll' } },
	                    placeholder ? _react2.default.createElement(
	                        "h5",
	                        null,
	                        placeholder
	                    ) : null,
	                    multi ? _react2.default.createElement(
	                        "ul",
	                        null,
	                        validOptions.map(function (option, index) {
	                            return _react2.default.createElement(
	                                "li",
	                                { key: index },
	                                _react2.default.createElement(
	                                    "label",
	                                    { className: "flex align-center cursor-pointer p1", onClick: function onClick() {
	                                            return _this2.selectValue(option.key, !checked.has(option.key));
	                                        } },
	                                    _react2.default.createElement(_CheckBox2.default, {
	                                        checked: checked.has(option.key),
	                                        color: "purple"
	                                    }),
	                                    _react2.default.createElement(
	                                        "h4",
	                                        { className: "ml1" },
	                                        _this2.nameForOption(option)
	                                    )
	                                )
	                            );
	                        })
	                    ) : _react2.default.createElement(
	                        "div",
	                        { className: "flex flex-wrap py1" },
	                        validOptions.map(function (option, index) {
	                            return _react2.default.createElement(
	                                "div",
	                                { className: "half", style: { padding: "0.15em" } },
	                                _react2.default.createElement(
	                                    "button",
	                                    {
	                                        style: { height: "95px" },
	                                        className: (0, _classnames2.default)("full rounded bordered border-purple text-centered text-bold", {
	                                            "text-purple bg-white": values[0] !== option.key,
	                                            "text-white bg-purple": values[0] === option.key
	                                        }),
	                                        onClick: function onClick() {
	                                            return _this2.selectValue(option.key, true);
	                                        }
	                                    },
	                                    _this2.nameForOption(option)
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SelectPicker;
	}(_react.Component), _class.propTypes = {
	    options: _propTypes2.default.object.isRequired,
	    values: _propTypes2.default.array.isRequired,
	    onValuesChange: _propTypes2.default.func.isRequired,
	    placeholder: _propTypes2.default.string,
	    multi: _propTypes2.default.bool
	}, _temp);
	SelectPicker.displayName = "SelectPicker";
	exports.default = SelectPicker;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _colors = __webpack_require__(881);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckBox = (_temp = _class = function (_Component) {
	    _inherits(CheckBox, _Component);
	
	    function CheckBox() {
	        _classCallCheck(this, CheckBox);
	
	        return _possibleConstructorReturn(this, (CheckBox.__proto__ || Object.getPrototypeOf(CheckBox)).apply(this, arguments));
	    }
	
	    _createClass(CheckBox, [{
	        key: "onClick",
	        value: function onClick() {
	            if (this.props.onChange) {
	                // TODO: use a proper event object?
	                this.props.onChange({ target: { checked: !this.props.checked } });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                checked = _props.checked,
	                color = _props.color,
	                padding = _props.padding,
	                size = _props.size;
	
	
	            var themeColor = _colors.normal[color];
	
	            var checkboxStyle = {
	                width: size,
	                height: size,
	                backgroundColor: checked ? themeColor : "white",
	                border: "2px solid " + (checked ? themeColor : '#ddd')
	            };
	            return _react2.default.createElement(
	                "div",
	                { className: "cursor-pointer", onClick: function onClick() {
	                        return _this2.onClick();
	                    } },
	                _react2.default.createElement(
	                    "div",
	                    { style: checkboxStyle, className: "flex align-center justify-center rounded" },
	                    checked && _react2.default.createElement(_Icon2.default, {
	                        style: { color: checked ? 'white' : themeColor },
	                        name: "check",
	                        size: size - padding * 2
	                    })
	                )
	            );
	        }
	    }]);
	
	    return CheckBox;
	}(_react.Component), _class.propTypes = {
	    checked: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func.isRequired,
	    color: _propTypes2.default.oneOf(_colors.normal),
	    size: _propTypes2.default.number, // TODO - this should probably be a concrete set of options
	    padding: _propTypes2.default.number // TODO - the component should pad itself properly based on the size
	}, _class.defaultProps = {
	    size: 16,
	    padding: 2,
	    color: 'blue'
	}, _temp);
	CheckBox.displayName = "CheckBox";
	exports.default = CheckBox;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AggregationPopover = __webpack_require__(976);
	
	var _AggregationPopover2 = _interopRequireDefault(_AggregationPopover);
	
	var _FieldName = __webpack_require__(985);
	
	var _FieldName2 = _interopRequireDefault(_FieldName);
	
	var _Clearable = __webpack_require__(986);
	
	var _Clearable2 = _interopRequireDefault(_Clearable);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _formatter = __webpack_require__(883);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AggregationWidget = (_temp = _class = function (_Component) {
	    _inherits(AggregationWidget, _Component);
	
	    function AggregationWidget(props, context) {
	        _classCallCheck(this, AggregationWidget);
	
	        var _this = _possibleConstructorReturn(this, (AggregationWidget.__proto__ || Object.getPrototypeOf(AggregationWidget)).call(this, props, context));
	
	        _this.state = {
	            isOpen: false
	        };
	
	        _underscore2.default.bindAll(_this, "open", "close", "setAggregation");
	        return _this;
	    }
	
	    _createClass(AggregationWidget, [{
	        key: "setAggregation",
	        value: function setAggregation(aggregation) {
	            this.props.updateAggregation(aggregation);
	        }
	    }, {
	        key: "open",
	        value: function open() {
	            this.setState({ isOpen: true });
	        }
	    }, {
	        key: "close",
	        value: function close() {
	            this.setState({ isOpen: false });
	        }
	    }, {
	        key: "renderStandardAggregation",
	        value: function renderStandardAggregation() {
	            var _props = this.props,
	                aggregation = _props.aggregation,
	                tableMetadata = _props.tableMetadata;
	
	            var fieldId = _query.AggregationClause.getField(aggregation);
	
	            var selectedAggregation = (0, _schema_metadata.getAggregator)(_query.AggregationClause.getOperator(aggregation));
	            // if this table doesn't support the selected aggregation, prompt the user to select a different one
	            if (selectedAggregation && _underscore2.default.findWhere(tableMetadata.aggregation_options, { short: selectedAggregation.short })) {
	                return _react2.default.createElement(
	                    "span",
	                    { className: "flex align-center" },
	                    selectedAggregation.name.replace(" of ...", ""),
	                    fieldId && _react2.default.createElement(
	                        "span",
	                        { style: { paddingRight: "4px", paddingLeft: "4px" }, className: "text-bold" },
	                        "of"
	                    ),
	                    fieldId && _react2.default.createElement(_FieldName2.default, {
	                        className: "View-section-aggregation-target SelectionModule py1",
	                        tableMetadata: tableMetadata,
	                        field: fieldId,
	                        fieldOptions: _query2.default.getFieldOptions(tableMetadata.fields, true),
	                        customFieldOptions: this.props.customFields
	                    })
	                );
	            }
	        }
	    }, {
	        key: "renderMetricAggregation",
	        value: function renderMetricAggregation() {
	            var _props2 = this.props,
	                aggregation = _props2.aggregation,
	                tableMetadata = _props2.tableMetadata;
	
	            var metricId = _query.AggregationClause.getMetric(aggregation);
	
	            var selectedMetric = _underscore2.default.findWhere(tableMetadata.metrics, { id: metricId });
	            if (selectedMetric) {
	                return selectedMetric.name.replace(" of ...", "");
	            }
	        }
	    }, {
	        key: "renderCustomAggregation",
	        value: function renderCustomAggregation() {
	            var _props3 = this.props,
	                aggregation = _props3.aggregation,
	                tableMetadata = _props3.tableMetadata,
	                customFields = _props3.customFields;
	
	            return (0, _formatter.format)(aggregation, { tableMetadata: tableMetadata, customFields: customFields });
	        }
	    }, {
	        key: "renderPopover",
	        value: function renderPopover() {
	            var _props4 = this.props,
	                query = _props4.query,
	                aggregation = _props4.aggregation,
	                tableMetadata = _props4.tableMetadata;
	
	
	            if (this.state.isOpen) {
	                return _react2.default.createElement(
	                    _Popover2.default,
	                    {
	                        id: "AggregationPopover",
	                        ref: "aggregationPopover",
	                        className: "FilterPopover",
	                        isInitiallyOpen: true,
	                        onClose: this.close,
	                        dismissOnEscape: false // disable for expression editor
	                    },
	                    _react2.default.createElement(_AggregationPopover2.default, {
	                        query: query,
	                        aggregation: aggregation,
	                        availableAggregations: tableMetadata.aggregation_options,
	                        tableMetadata: tableMetadata,
	                        customFields: this.props.customFields,
	                        onCommitAggregation: this.setAggregation,
	                        onClose: this.close
	                    })
	                );
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props5 = this.props,
	                aggregation = _props5.aggregation,
	                addButton = _props5.addButton,
	                name = _props5.name;
	
	            if (aggregation && aggregation.length > 0) {
	                var aggregationName = _query.NamedClause.isNamed(aggregation) ? _query.NamedClause.getName(aggregation) : _query.AggregationClause.isCustom(aggregation) ? this.renderCustomAggregation() : _query.AggregationClause.isMetric(aggregation) ? this.renderMetricAggregation() : this.renderStandardAggregation();
	
	                return _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)("Query-section Query-section-aggregation", { "selected": this.state.isOpen }) },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            _Clearable2.default,
	                            { onClear: this.props.removeAggregation },
	                            _react2.default.createElement(
	                                "div",
	                                { id: "Query-section-aggregation", onClick: this.open, className: "Query-section Query-section-aggregation cursor-pointer" },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "View-section-aggregation QueryOption py1 mx1" },
	                                    aggregationName == null ? "Choose an aggregation" : name ? name : aggregationName
	                                )
	                            )
	                        ),
	                        this.renderPopover()
	                    )
	                );
	            } else if (addButton) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)("Query-section Query-section-aggregation"), onClick: this.open },
	                    addButton,
	                    this.renderPopover()
	                );
	            } else {
	                return null;
	            }
	        }
	    }]);
	
	    return AggregationWidget;
	}(_react.Component), _class.propTypes = {
	    aggregation: _propTypes2.default.array,
	    tableMetadata: _propTypes2.default.object.isRequired,
	    customFields: _propTypes2.default.object,
	    updateAggregation: _propTypes2.default.func.isRequired,
	    removeAggregation: _propTypes2.default.func
	}, _temp);
	AggregationWidget.displayName = "AggregationWidget";
	exports.default = AggregationWidget;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = FieldSet;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FieldSet(_ref) {
	    var _ref$className = _ref.className,
	        className = _ref$className === undefined ? "border-brand" : _ref$className,
	        legend = _ref.legend,
	        noPadding = _ref.noPadding,
	        children = _ref.children;
	
	    var fieldSetClassName = (0, _classnames2.default)("bordered rounded", { "px2 pb2": !noPadding });
	
	    return _react2.default.createElement(
	        "fieldset",
	        { className: (0, _classnames2.default)(className, fieldSetClassName) },
	        legend && _react2.default.createElement(
	            "legend",
	            { className: "h5 text-bold text-uppercase px1 text-nowrap text-grey-4" },
	            legend
	        ),
	        _react2.default.createElement(
	            "div",
	            null,
	            children
	        )
	    );
	}
	FieldSet.displayName = "FieldSet";

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var BUTTON_VARIANTS = ["small", "medium", "large", "primary", "warning", "cancel", "success", "purple", "borderless", "onlyIcon"];
	
	var Button = function Button(_ref) {
	    var className = _ref.className,
	        icon = _ref.icon,
	        iconSize = _ref.iconSize,
	        children = _ref.children,
	        props = _objectWithoutProperties(_ref, ["className", "icon", "iconSize", "children"]);
	
	    var variantClasses = BUTTON_VARIANTS.filter(function (variant) {
	        return props[variant];
	    }).map(function (variant) {
	        return "Button--" + variant;
	    });
	
	    return _react2.default.createElement(
	        "button",
	        _extends({}, _underscore2.default.omit.apply(_underscore2.default, [props].concat(BUTTON_VARIANTS)), {
	            className: (0, _classnames2.default)("Button", className, variantClasses)
	        }),
	        _react2.default.createElement(
	            "div",
	            { className: "flex layout-centered" },
	            icon && _react2.default.createElement(_Icon2.default, { name: icon, size: iconSize ? iconSize : 14, className: (0, _classnames2.default)({ "mr1": !props.onlyIcon }) }),
	            _react2.default.createElement(
	                "div",
	                null,
	                children
	            )
	        )
	    );
	};
	
	Button.displayName = "Button";
	Button.propTypes = {
	    className: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    iconSize: _propTypes2.default.number,
	    children: _propTypes2.default.any,
	
	    small: _propTypes2.default.bool,
	    medium: _propTypes2.default.bool,
	    large: _propTypes2.default.bool,
	
	    primary: _propTypes2.default.bool,
	    warning: _propTypes2.default.bool,
	    cancel: _propTypes2.default.bool,
	    purple: _propTypes2.default.bool,
	
	    borderless: _propTypes2.default.bool,
	    onlyIcon: _propTypes2.default.bool
	};
	
	exports.default = Button;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ExpressionEditorTextfield = __webpack_require__(1009);
	
	var _ExpressionEditorTextfield2 = _interopRequireDefault(_ExpressionEditorTextfield);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _parser = __webpack_require__(1011);
	
	var _formatter = __webpack_require__(883);
	
	var _dom = __webpack_require__(859);
	
	var _keyboard = __webpack_require__(934);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _TokenizedInput = __webpack_require__(1036);
	
	var _TokenizedInput2 = _interopRequireDefault(_TokenizedInput);
	
	var _expressions = __webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SUGGESTIONS = 30;
	
	var ExpressionEditorTextfield = (_temp = _class = function (_Component) {
	    _inherits(ExpressionEditorTextfield, _Component);
	
	    function ExpressionEditorTextfield(props, context) {
	        _classCallCheck(this, ExpressionEditorTextfield);
	
	        var _this = _possibleConstructorReturn(this, (ExpressionEditorTextfield.__proto__ || Object.getPrototypeOf(ExpressionEditorTextfield)).call(this, props, context));
	
	        _this.onInputClick = function () {
	            _this._triggerAutosuggest();
	        };
	
	        _this._triggerAutosuggest = function () {
	            _this.onExpressionChange(_this.state.expressionString);
	        };
	
	        _this._setCaretPosition = function (position, autosuggest) {
	            (0, _dom.setCaretPosition)(_reactDom2.default.findDOMNode(_this.refs.input), position);
	            if (autosuggest) {
	                setTimeout(function () {
	                    return _this._triggerAutosuggest();
	                });
	            }
	        };
	
	        _underscore2.default.bindAll(_this, '_triggerAutosuggest', 'onInputKeyDown', 'onInputBlur', 'onSuggestionAccepted', 'onSuggestionMouseDown');
	        return _this;
	    }
	
	    _createClass(ExpressionEditorTextfield, [{
	        key: "_getParserInfo",
	        value: function _getParserInfo() {
	            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	            return {
	                tableMetadata: props.tableMetadata,
	                customFields: props.customFields || {},
	                startRule: props.startRule
	            };
	        }
	    }, {
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.componentWillReceiveProps(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            // we only refresh our state if we had no previous state OR if our expression or table has changed
	            if (!this.state || this.props.expression != newProps.expression || this.props.tableMetadata != newProps.tableMetadata) {
	                var parserInfo = this._getParserInfo(newProps);
	                var parsedExpression = newProps.expression;
	                var expressionString = (0, _formatter.format)(newProps.expression, parserInfo);
	                var expressionErrorMessage = null;
	                var suggestions = [];
	                try {
	                    if (expressionString) {
	                        (0, _parser.compile)(expressionString, parserInfo);
	                    }
	                } catch (e) {
	                    expressionErrorMessage = e;
	                }
	
	                this.setState({
	                    parsedExpression: parsedExpression,
	                    expressionString: expressionString,
	                    expressionErrorMessage: expressionErrorMessage,
	                    suggestions: suggestions,
	                    highlightedSuggestion: 0
	                });
	            }
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this._setCaretPosition(this.state.expressionString.length, this.state.expressionString.length === 0);
	        }
	    }, {
	        key: "onSuggestionAccepted",
	        value: function onSuggestionAccepted() {
	            var _this2 = this;
	
	            var expressionString = this.state.expressionString;
	
	            var suggestion = this.state.suggestions[this.state.highlightedSuggestion];
	
	            if (suggestion) {
	                var prefix = expressionString.slice(0, suggestion.index);
	                if (suggestion.prefixTrim) {
	                    prefix = prefix.replace(suggestion.prefixTrim, "");
	                }
	                var postfix = expressionString.slice(suggestion.index);
	                if (suggestion.postfixTrim) {
	                    postfix = postfix.replace(suggestion.postfixTrim, "");
	                }
	                if (!postfix && suggestion.postfixText) {
	                    postfix = suggestion.postfixText;
	                }
	
	                this.onExpressionChange(prefix + suggestion.text + postfix);
	                setTimeout(function () {
	                    return _this2._setCaretPosition((prefix + suggestion.text).length, true);
	                });
	            }
	
	            this.setState({
	                highlightedSuggestion: 0
	            });
	        }
	    }, {
	        key: "onSuggestionMouseDown",
	        value: function onSuggestionMouseDown(event, index) {
	            // when a suggestion is clicked, we'll highlight the clicked suggestion and then hand off to the same code that deals with ENTER / TAB keydowns
	            event.preventDefault();
	            event.stopPropagation();
	            this.setState({ highlightedSuggestion: index }, this.onSuggestionAccepted);
	        }
	    }, {
	        key: "onInputKeyDown",
	        value: function onInputKeyDown(e) {
	            var _this3 = this;
	
	            var _state = this.state,
	                suggestions = _state.suggestions,
	                highlightedSuggestion = _state.highlightedSuggestion;
	
	
	            if (e.keyCode === _keyboard.KEYCODE_LEFT || e.keyCode === _keyboard.KEYCODE_RIGHT) {
	                setTimeout(function () {
	                    return _this3._triggerAutosuggest();
	                });
	                return;
	            }
	            if (e.keyCode === _keyboard.KEYCODE_ESCAPE) {
	                e.stopPropagation();
	                e.preventDefault();
	                this.clearSuggestions();
	                return;
	            }
	
	            if (!suggestions.length) {
	                return;
	            }
	            if (e.keyCode === _keyboard.KEYCODE_ENTER) {
	                this.onSuggestionAccepted();
	                e.preventDefault();
	            } else if (e.keyCode === _keyboard.KEYCODE_UP) {
	                this.setState({
	                    highlightedSuggestion: (highlightedSuggestion + suggestions.length - 1) % suggestions.length
	                });
	                e.preventDefault();
	            } else if (e.keyCode === _keyboard.KEYCODE_DOWN) {
	                this.setState({
	                    highlightedSuggestion: (highlightedSuggestion + suggestions.length + 1) % suggestions.length
	                });
	                e.preventDefault();
	            }
	        }
	    }, {
	        key: "clearSuggestions",
	        value: function clearSuggestions() {
	            this.setState({
	                suggestions: [],
	                highlightedSuggestion: 0
	            });
	        }
	    }, {
	        key: "onInputBlur",
	        value: function onInputBlur() {
	            this.clearSuggestions();
	
	            // whenever our input blurs we push the updated expression to our parent if valid
	            if ((0, _expressions.isExpression)(this.state.parsedExpression)) {
	                this.props.onChange(this.state.parsedExpression);
	            } else if (this.state.expressionErrorMessage) {
	                this.props.onError(this.state.expressionErrorMessage);
	            } else {
	                this.props.onError({ message: "Invalid expression" });
	            }
	        }
	    }, {
	        key: "onExpressionChange",
	        value: function onExpressionChange(expressionString) {
	            var inputElement = _reactDom2.default.findDOMNode(this.refs.input);
	            if (!inputElement) {
	                return;
	            }
	
	            var parserInfo = this._getParserInfo();
	
	            var expressionErrorMessage = null;
	            var suggestions = [];
	            var parsedExpression = void 0;
	
	            try {
	                parsedExpression = (0, _parser.compile)(expressionString, parserInfo);
	            } catch (e) {
	                expressionErrorMessage = e;
	                console.error("expression error:", expressionErrorMessage);
	            }
	
	            var isValid = parsedExpression && parsedExpression.length > 0;
	
	            var _getSelectionPosition = (0, _dom.getSelectionPosition)(inputElement),
	                _getSelectionPosition2 = _slicedToArray(_getSelectionPosition, 2),
	                selectionStart = _getSelectionPosition2[0],
	                selectionEnd = _getSelectionPosition2[1];
	
	            var hasSelection = selectionStart !== selectionEnd;
	            var isAtEnd = selectionEnd === expressionString.length;
	            var endsWithWhitespace = /\s$/.test(expressionString);
	
	            // don't show suggestions if
	            // * there's a section
	            // * we're at the end of a valid expression, unless the user has typed another space
	            if (!hasSelection && !(isValid && isAtEnd && !endsWithWhitespace)) {
	                try {
	                    suggestions = (0, _parser.suggest)(expressionString, _extends({}, parserInfo, {
	                        index: selectionEnd
	                    }));
	                } catch (e) {
	                    console.error("suggest error:", e);
	                }
	            }
	
	            this.setState({
	                expressionErrorMessage: expressionErrorMessage,
	                expressionString: expressionString,
	                parsedExpression: parsedExpression,
	                suggestions: suggestions
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var errorMessage = this.state.expressionErrorMessage;
	            if (errorMessage && !errorMessage.length) errorMessage = 'unknown error';
	
	            var placeholder = this.props.placeholder;
	            var suggestions = this.state.suggestions;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(_ExpressionEditorTextfield2.default.editor, "relative") },
	                _react2.default.createElement(_TokenizedInput2.default, {
	                    ref: "input",
	                    className: (0, _classnames2.default)(_ExpressionEditorTextfield2.default.input, "my1 input block full", { "border-error": errorMessage }),
	                    type: "text",
	                    placeholder: placeholder,
	                    value: this.state.expressionString,
	                    onChange: function onChange(e) {
	                        return _this4.onExpressionChange(e.target.value);
	                    },
	                    onKeyDown: this.onInputKeyDown,
	                    onBlur: this.onInputBlur,
	                    onFocus: function onFocus(e) {
	                        return _this4._triggerAutosuggest();
	                    },
	                    onClick: this.onInputClick,
	                    autoFocus: true,
	                    parserInfo: this._getParserInfo()
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)(_ExpressionEditorTextfield2.default.equalSign, "spread flex align-center h4 text-dark", _defineProperty({}, _ExpressionEditorTextfield2.default.placeholder, !this.state.expressionString)) },
	                    "="
	                ),
	                suggestions.length ? _react2.default.createElement(
	                    _Popover2.default,
	                    {
	                        className: "pb1 not-rounded border-dark",
	                        hasArrow: false,
	                        tetherOptions: {
	                            attachment: 'top left',
	                            targetAttachment: 'bottom left'
	                        }
	                    },
	                    _react2.default.createElement(
	                        "ul",
	                        { style: { minWidth: 150, overflow: "hidden" } },
	                        suggestions.slice(0, MAX_SUGGESTIONS).map(function (suggestion, i) {
	                            return (
	                                // insert section title. assumes they're sorted by type
	                                [(i === 0 || suggestion.type !== suggestions[i - 1].type) && _react2.default.createElement(
	                                    "li",
	                                    { ref: "header-" + i, className: "mx2 h6 text-uppercase text-bold text-grey-3 py1 pt2" },
	                                    suggestion.type
	                                ), _react2.default.createElement(
	                                    "li",
	                                    { ref: i, style: { paddingTop: 5, paddingBottom: 5 },
	                                        className: (0, _classnames2.default)("px2 cursor-pointer text-white-hover bg-brand-hover", { "text-white bg-brand": i === _this4.state.highlightedSuggestion }),
	                                        onMouseDownCapture: function onMouseDownCapture(e) {
	                                            return _this4.onSuggestionMouseDown(e, i);
	                                        }
	                                    },
	                                    suggestion.prefixLength ? _react2.default.createElement(
	                                        "span",
	                                        null,
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: (0, _classnames2.default)("text-brand text-bold", { "text-white bg-brand": i === _this4.state.highlightedSuggestion }) },
	                                            suggestion.name.slice(0, suggestion.prefixLength)
	                                        ),
	                                        _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            suggestion.name.slice(suggestion.prefixLength)
	                                        )
	                                    ) : suggestion.name
	                                )]
	                            );
	                        }),
	                        suggestions.length >= MAX_SUGGESTIONS && _react2.default.createElement(
	                            "li",
	                            { style: { paddingTop: 5, paddingBottom: 5 }, className: "px2 text-italic text-grey-3" },
	                            "and ",
	                            suggestions.length - MAX_SUGGESTIONS,
	                            " more"
	                        )
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return ExpressionEditorTextfield;
	}(_react.Component), _class.propTypes = {
	    expression: _propTypes2.default.array, // should be an array like [parsedExpressionObj, expressionString]
	    tableMetadata: _propTypes2.default.object.isRequired,
	    customFields: _propTypes2.default.object,
	    onChange: _propTypes2.default.func.isRequired,
	    onError: _propTypes2.default.func.isRequired,
	    startRule: _propTypes2.default.string.isRequired
	}, _class.defaultProps = {
	    expression: [null, ""],
	    startRule: "expression",
	    placeholder: "write some math!"
	}, _temp);
	ExpressionEditorTextfield.displayName = "ExpressionEditorTextfield";
	exports.default = ExpressionEditorTextfield;

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"editor":"_1EO7U","input":"_2t1vE","equalSign":"_1zbWs","placeholder":"_33wM1"};

/***/ }),
/* 1010 */,
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.compile = compile;
	exports.parse = parse;
	exports.suggest = suggest;
	
	var _chevrotain = __webpack_require__(1012);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _expressions = __webpack_require__(884);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _tokens = __webpack_require__(1035);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpressionsLexer = new _chevrotain.Lexer(_tokens.allTokens);
	
	var ExpressionsParser = function (_Parser) {
	    _inherits(ExpressionsParser, _Parser);
	
	    function ExpressionsParser(input) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _classCallCheck(this, ExpressionsParser);
	
	        var parserOptions = {
	            // recoveryEnabled: false,
	            ignoredIssues: {
	                // uses GATE to disambiguate fieldName and metricName
	                atomicExpression: { OR1: true }
	            }
	        };
	
	        var _this = _possibleConstructorReturn(this, (ExpressionsParser.__proto__ || Object.getPrototypeOf(ExpressionsParser)).call(this, input, _tokens.allTokens, parserOptions));
	
	        var $ = _this;
	
	        _this._options = options;
	
	        // an expression without aggregations in it
	        $.RULE("expression", function () {
	            var outsideAggregation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	            return $.SUBRULE($.additionExpression, [outsideAggregation]);
	        });
	
	        // an expression with aggregations in it
	        $.RULE("aggregation", function () {
	            return $.SUBRULE($.additionExpression, [true]);
	        });
	
	        // Lowest precedence thus it is first in the rule chain
	        // The precedence of binary expressions is determined by
	        // how far down the Parse Tree the binary expression appears.
	        $.RULE("additionExpression", function (outsideAggregation) {
	            var initial = $.SUBRULE($.multiplicationExpression, [outsideAggregation]);
	            var operations = $.MANY(function () {
	                var op = $.CONSUME(_tokens.AdditiveOperator);
	                var rhsVal = $.SUBRULE2($.multiplicationExpression, [outsideAggregation]);
	                return [op, rhsVal];
	            });
	            return _this._math(initial, operations);
	        });
	
	        $.RULE("multiplicationExpression", function (outsideAggregation) {
	            var initial = $.SUBRULE($.atomicExpression, [outsideAggregation]);
	            var operations = $.MANY(function () {
	                var op = $.CONSUME(_tokens.MultiplicativeOperator);
	                var rhsVal = $.SUBRULE2($.atomicExpression, [outsideAggregation]);
	                return [op, rhsVal];
	            });
	            return _this._math(initial, operations);
	        });
	
	        $.RULE("nullaryCall", function () {
	            return {
	                lParen: $.CONSUME(_tokens.LParen),
	                rParen: $.CONSUME(_tokens.RParen)
	            };
	        });
	        $.RULE("unaryCall", function () {
	            return {
	                lParen: $.CONSUME(_tokens.LParen),
	                arg: $.SUBRULE($.expression, [false]),
	                rParen: $.CONSUME(_tokens.RParen)
	            };
	        });
	
	        $.RULE("aggregationExpression", function (outsideAggregation) {
	            var _$$OR = $.OR([{ ALT: function ALT() {
	                    return _extends({
	                        aggregation: $.CONSUME(_tokens.NullaryAggregation)
	                    }, $.OPTION(function () {
	                        return $.SUBRULE($.nullaryCall);
	                    }));
	                } }, { ALT: function ALT() {
	                    return _extends({
	                        aggregation: $.CONSUME(_tokens.UnaryAggregation)
	                    }, $.SUBRULE($.unaryCall));
	                } }]),
	                aggregation = _$$OR.aggregation,
	                lParen = _$$OR.lParen,
	                arg = _$$OR.arg,
	                rParen = _$$OR.rParen;
	
	            return _this._aggregation(aggregation, lParen, arg, rParen);
	        });
	
	        $.RULE("metricExpression", function () {
	            var metricName = $.OR([{ ALT: function ALT() {
	                    return $.SUBRULE($.stringLiteral);
	                } }, { ALT: function ALT() {
	                    return $.SUBRULE($.identifier);
	                } }]);
	
	            var metric = _this.getMetricForName(_this._toString(metricName));
	            if (metric != null) {
	                return _this._metricReference(metricName, metric.id);
	            }
	            return _this._unknownMetric(metricName);
	        });
	
	        $.RULE("fieldExpression", function () {
	            var fieldName = $.OR([{ ALT: function ALT() {
	                    return $.SUBRULE($.stringLiteral);
	                } }, { ALT: function ALT() {
	                    return $.SUBRULE($.identifier);
	                } }]);
	
	            var field = _this.getFieldForName(_this._toString(fieldName));
	            if (field != null) {
	                return _this._fieldReference(fieldName, field.id);
	            }
	            var expression = _this.getExpressionForName(_this._toString(fieldName));
	            if (expression != null) {
	                return _this._expressionReference(fieldName, expression);
	            }
	            return _this._unknownField(fieldName);
	        });
	
	        $.RULE("identifier", function () {
	            var identifier = $.CONSUME(_tokens.Identifier);
	            return _this._identifier(identifier);
	        });
	
	        $.RULE("stringLiteral", function () {
	            var stringLiteral = $.CONSUME(_tokens.StringLiteral);
	            return _this._stringLiteral(stringLiteral);
	        });
	
	        $.RULE("numberLiteral", function () {
	            var minus = $.OPTION(function () {
	                return $.CONSUME(_tokens.Minus);
	            });
	            var numberLiteral = $.CONSUME(_tokens.NumberLiteral);
	            return _this._numberLiteral(minus, numberLiteral);
	        });
	
	        $.RULE("atomicExpression", function (outsideAggregation) {
	            return $.OR([
	            // aggregations are not allowed inside other aggregations
	            { GATE: function GATE() {
	                    return outsideAggregation;
	                }, ALT: function ALT() {
	                    return $.SUBRULE($.aggregationExpression, [false]);
	                } },
	
	            // NOTE: DISABLE METRICS
	            // {GATE: () => outsideAggregation, ALT: () => $.SUBRULE($.metricExpression) },
	
	            // fields are not allowed outside aggregations
	            { GATE: function GATE() {
	                    return !outsideAggregation;
	                }, ALT: function ALT() {
	                    return $.SUBRULE($.fieldExpression);
	                } }, { ALT: function ALT() {
	                    return $.SUBRULE($.parenthesisExpression, [outsideAggregation]);
	                } }, { ALT: function ALT() {
	                    return $.SUBRULE($.numberLiteral);
	                } }], (outsideAggregation ? "aggregation" : "field name") + ", number, or expression");
	        });
	
	        $.RULE("parenthesisExpression", function (outsideAggregation) {
	            var lParen = $.CONSUME(_tokens.LParen);
	            var expValue = $.SUBRULE($.expression, [outsideAggregation]);
	            var rParen = $.CONSUME(_tokens.RParen);
	            return _this._parens(lParen, expValue, rParen);
	        });
	
	        _chevrotain.Parser.performSelfAnalysis(_this);
	        return _this;
	    }
	
	    _createClass(ExpressionsParser, [{
	        key: "getFieldForName",
	        value: function getFieldForName(fieldName) {
	            var fields = this._options.tableMetadata && this._options.tableMetadata.fields;
	            return _underscore2.default.findWhere(fields, { display_name: fieldName });
	        }
	    }, {
	        key: "getExpressionForName",
	        value: function getExpressionForName(expressionName) {
	            var customFields = this._options && this._options.customFields;
	            return customFields[expressionName];
	        }
	    }, {
	        key: "getMetricForName",
	        value: function getMetricForName(metricName) {
	            var metrics = this._options.tableMetadata && this._options.tableMetadata.metrics;
	            return _underscore2.default.find(metrics, function (metric) {
	                return metric.name.toLowerCase() === metricName.toLowerCase();
	            });
	        }
	    }]);
	
	    return ExpressionsParser;
	}(_chevrotain.Parser);
	
	var ExpressionsParserMBQL = function (_ExpressionsParser) {
	    _inherits(ExpressionsParserMBQL, _ExpressionsParser);
	
	    function ExpressionsParserMBQL() {
	        _classCallCheck(this, ExpressionsParserMBQL);
	
	        return _possibleConstructorReturn(this, (ExpressionsParserMBQL.__proto__ || Object.getPrototypeOf(ExpressionsParserMBQL)).apply(this, arguments));
	    }
	
	    _createClass(ExpressionsParserMBQL, [{
	        key: "_math",
	        value: function _math(initial, operations) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = operations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _step$value = _slicedToArray(_step.value, 2),
	                        op = _step$value[0],
	                        rhsVal = _step$value[1];
	
	                    // collapse multiple consecutive operators into a single MBQL statement
	                    if (Array.isArray(initial) && initial[0] === op.image) {
	                        initial.push(rhsVal);
	                    } else {
	                        initial = [op.image, initial, rhsVal];
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return initial;
	        }
	    }, {
	        key: "_aggregation",
	        value: function _aggregation(aggregation, lParen, arg, rParen) {
	            var agg = (0, _expressions.getAggregationFromName)((0, _chevrotain.getImage)(aggregation));
	            return arg == null ? [agg] : [agg, arg];
	        }
	    }, {
	        key: "_metricReference",
	        value: function _metricReference(metricName, metricId) {
	            return ["METRIC", metricId];
	        }
	    }, {
	        key: "_fieldReference",
	        value: function _fieldReference(fieldName, fieldId) {
	            return ["field-id", fieldId];
	        }
	    }, {
	        key: "_expressionReference",
	        value: function _expressionReference(fieldName) {
	            return ["expression", fieldName];
	        }
	    }, {
	        key: "_unknownField",
	        value: function _unknownField(fieldName) {
	            throw new Error("Unknown field \"" + fieldName + "\"");
	        }
	    }, {
	        key: "_unknownMetric",
	        value: function _unknownMetric(metricName) {
	            throw new Error("Unknown metric \"" + metricName + "\"");
	        }
	    }, {
	        key: "_identifier",
	        value: function _identifier(identifier) {
	            return identifier.image;
	        }
	    }, {
	        key: "_stringLiteral",
	        value: function _stringLiteral(stringLiteral) {
	            return JSON.parse(stringLiteral.image);
	        }
	    }, {
	        key: "_numberLiteral",
	        value: function _numberLiteral(minus, numberLiteral) {
	            return parseFloat(numberLiteral.image) * (minus ? -1 : 1);
	        }
	    }, {
	        key: "_parens",
	        value: function _parens(lParen, expValue, rParen) {
	            return expValue;
	        }
	    }, {
	        key: "_toString",
	        value: function _toString(x) {
	            return x;
	        }
	    }]);
	
	    return ExpressionsParserMBQL;
	}(ExpressionsParser);
	
	var syntax = function syntax(type) {
	    for (var _len = arguments.length, children = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        children[_key - 1] = arguments[_key];
	    }
	
	    return {
	        type: type,
	        children: children.filter(function (child) {
	            return child;
	        })
	    };
	};
	var token = function token(_token) {
	    return _token && {
	        type: "token",
	        text: _token.image,
	        start: _token.startOffset,
	        end: _token.endOffset
	    };
	};
	
	var ExpressionsParserSyntax = function (_ExpressionsParser2) {
	    _inherits(ExpressionsParserSyntax, _ExpressionsParser2);
	
	    function ExpressionsParserSyntax() {
	        _classCallCheck(this, ExpressionsParserSyntax);
	
	        return _possibleConstructorReturn(this, (ExpressionsParserSyntax.__proto__ || Object.getPrototypeOf(ExpressionsParserSyntax)).apply(this, arguments));
	    }
	
	    _createClass(ExpressionsParserSyntax, [{
	        key: "_math",
	        value: function _math(initial, operations) {
	            var _ref;
	
	            return syntax.apply(undefined, ["math"].concat(_toConsumableArray((_ref = [initial]).concat.apply(_ref, _toConsumableArray(operations.map(function (_ref2) {
	                var _ref3 = _slicedToArray(_ref2, 2),
	                    op = _ref3[0],
	                    arg = _ref3[1];
	
	                return [token(op), arg];
	            }))))));
	        }
	    }, {
	        key: "_aggregation",
	        value: function _aggregation(aggregation, lParen, arg, rParen) {
	            return syntax("aggregation", token(aggregation), token(lParen), arg, token(rParen));
	        }
	    }, {
	        key: "_metricReference",
	        value: function _metricReference(metricName, metricId) {
	            return syntax("metric", metricName);
	        }
	    }, {
	        key: "_fieldReference",
	        value: function _fieldReference(fieldName, fieldId) {
	            return syntax("field", fieldName);
	        }
	    }, {
	        key: "_expressionReference",
	        value: function _expressionReference(fieldName) {
	            return syntax("expression-reference", token(fieldName));
	        }
	    }, {
	        key: "_unknownField",
	        value: function _unknownField(fieldName) {
	            return syntax("unknown", fieldName);
	        }
	    }, {
	        key: "_unknownMetric",
	        value: function _unknownMetric(metricName) {
	            return syntax("unknown", metricName);
	        }
	    }, {
	        key: "_identifier",
	        value: function _identifier(identifier) {
	            return syntax("identifier", token(identifier));
	        }
	    }, {
	        key: "_stringLiteral",
	        value: function _stringLiteral(stringLiteral) {
	            return syntax("string", token(stringLiteral));
	        }
	    }, {
	        key: "_numberLiteral",
	        value: function _numberLiteral(minus, numberLiteral) {
	            return syntax("number", token(minus), token(numberLiteral));
	        }
	    }, {
	        key: "_parens",
	        value: function _parens(lParen, expValue, rParen) {
	            return syntax("group", token(lParen), expValue, token(rParen));
	        }
	    }, {
	        key: "_toString",
	        value: function _toString(x) {
	            if (typeof x === "string") {
	                return x;
	            } else if (x.type === "string") {
	                return JSON.parse(x.children[0].text);
	            } else if (x.type === "identifier") {
	                return x.children[0].text;
	            }
	        }
	    }]);
	
	    return ExpressionsParserSyntax;
	}(ExpressionsParser);
	
	function getSubTokenTypes(TokenClass) {
	    return TokenClass.extendingTokenTypes.map(function (tokenType) {
	        return _underscore2.default.findWhere(_tokens.allTokens, { tokenType: tokenType });
	    });
	}
	
	function getTokenSource(TokenClass) {
	    // strip regex escaping, e.x. "\+" -> "+"
	    return TokenClass.PATTERN.source.replace(/^\\/, "");
	}
	
	function run(Parser, source, options) {
	    if (!source) {
	        return [];
	    }
	    var startRule = options.startRule;
	
	    var parser = new Parser(ExpressionsLexer.tokenize(source).tokens, options);
	    var expression = parser[startRule]();
	    if (parser.errors.length > 0) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = parser.errors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var error = _step2.value;
	
	                // clean up error messages
	                error.message = error.message && error.message.replace(/^Expecting:?\s+/, "Expected ").replace(/--> (.*?) <--/g, "$1").replace(/(\n|\s)*but found:?/, " but found ").replace(/\s*but found\s+''$/, "");
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        throw parser.errors;
	    }
	    return expression;
	}
	
	function compile(source) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return run(ExpressionsParserMBQL, source, options);
	}
	
	function parse(source) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return run(ExpressionsParserSyntax, source, options);
	}
	
	// No need for more than one instance.
	var parserInstance = new ExpressionsParser([]);
	function suggest(source) {
	    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        tableMetadata = _ref4.tableMetadata,
	        customFields = _ref4.customFields,
	        startRule = _ref4.startRule,
	        _ref4$index = _ref4.index,
	        index = _ref4$index === undefined ? source.length : _ref4$index;
	
	    var partialSource = source.slice(0, index);
	    var lexResult = ExpressionsLexer.tokenize(partialSource);
	    if (lexResult.errors.length > 0) {
	        throw new Error("sad sad panda, lexing errors detected");
	    }
	
	    var lastInputToken = _underscore2.default.last(lexResult.tokens);
	    var partialSuggestionMode = false;
	    var assistanceTokenVector = lexResult.tokens;
	
	    // we have requested assistance while inside an Identifier
	    if (lastInputToken instanceof _tokens.Identifier && /\w/.test(partialSource[partialSource.length - 1])) {
	        assistanceTokenVector = assistanceTokenVector.slice(0, -1);
	        partialSuggestionMode = true;
	    }
	
	    var finalSuggestions = [];
	
	    // TODO: is there a better way to figure out which aggregation we're inside of?
	    var currentAggregationToken = _underscore2.default.find(assistanceTokenVector.slice().reverse(), function (t) {
	        return t instanceof _tokens.Aggregation;
	    });
	
	    var syntacticSuggestions = parserInstance.computeContentAssist(startRule, assistanceTokenVector);
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        for (var _iterator3 = syntacticSuggestions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var _suggestion = _step3.value;
	            var nextTokenType = _suggestion.nextTokenType,
	                ruleStack = _suggestion.ruleStack;
	            // no nesting of aggregations or field references outside of aggregations
	            // we have a predicate in the grammar to prevent nested aggregations but chevrotain
	            // doesn't support predicates in content-assist mode, so we need this extra check
	
	            var outsideAggregation = startRule === "aggregation" && ruleStack.slice(0, -1).indexOf("aggregationExpression") < 0;
	
	            if (nextTokenType === _tokens.MultiplicativeOperator || nextTokenType === _tokens.AdditiveOperator) {
	                var _finalSuggestions;
	
	                var tokens = getSubTokenTypes(nextTokenType);
	                (_finalSuggestions = finalSuggestions).push.apply(_finalSuggestions, _toConsumableArray(tokens.map(function (token) {
	                    return {
	                        type: "operators",
	                        name: getTokenSource(token),
	                        text: " " + getTokenSource(token) + " ",
	                        prefixTrim: /\s*$/,
	                        postfixTrim: /^\s*[*/+-]?\s*/
	                    };
	                })));
	            } else if (nextTokenType === _tokens.LParen) {
	                finalSuggestions.push({
	                    type: "other",
	                    name: "(",
	                    text: " (",
	                    postfixText: ")",
	                    prefixTrim: /\s*$/,
	                    postfixTrim: /^\s*\(?\s*/
	                });
	            } else if (nextTokenType === _tokens.RParen) {
	                finalSuggestions.push({
	                    type: "other",
	                    name: ")",
	                    text: ") ",
	                    prefixTrim: /\s*$/,
	                    postfixTrim: /^\s*\)?\s*/
	                });
	            } else if (nextTokenType === _tokens.Identifier || nextTokenType === _tokens.StringLiteral) {
	                if (!outsideAggregation) {
	                    var _finalSuggestions2, _finalSuggestions3;
	
	                    var fields = [];
	                    if (startRule === "aggregation" && currentAggregationToken) {
	                        var aggregationShort = (0, _expressions.getAggregationFromName)((0, _chevrotain.getImage)(currentAggregationToken));
	                        var aggregationOption = _underscore2.default.findWhere(tableMetadata.aggregation_options, { short: aggregationShort });
	                        fields = aggregationOption && aggregationOption.fields && aggregationOption.fields[0] || [];
	                    } else if (startRule === "expression") {
	                        fields = tableMetadata.fields.filter(_schema_metadata.isNumeric);
	                    }
	                    (_finalSuggestions2 = finalSuggestions).push.apply(_finalSuggestions2, _toConsumableArray(fields.map(function (field) {
	                        return {
	                            type: "fields",
	                            name: field.display_name,
	                            text: (0, _expressions.formatFieldName)(field) + " ",
	                            prefixTrim: /\w+$/,
	                            postfixTrim: /^\w+\s*/
	                        };
	                    })));
	                    (_finalSuggestions3 = finalSuggestions).push.apply(_finalSuggestions3, _toConsumableArray(Object.keys(customFields || {}).map(function (expressionName) {
	                        return {
	                            type: "fields",
	                            name: expressionName,
	                            text: (0, _expressions.formatExpressionName)(expressionName) + " ",
	                            prefixTrim: /\w+$/,
	                            postfixTrim: /^\w+\s*/
	                        };
	                    })));
	                }
	            } else if (nextTokenType === _tokens.Aggregation || nextTokenType === _tokens.NullaryAggregation || nextTokenType === _tokens.UnaryAggregation || nextTokenType === _tokens.Identifier || nextTokenType === _tokens.StringLiteral) {
	                if (outsideAggregation) {
	                    var _finalSuggestions4;
	
	                    (_finalSuggestions4 = finalSuggestions).push.apply(_finalSuggestions4, _toConsumableArray(tableMetadata.aggregation_options.filter(function (a) {
	                        return (0, _expressions.formatAggregationName)(a);
	                    }).map(function (aggregationOption) {
	                        var arity = aggregationOption.fields.length;
	                        return {
	                            type: "aggregations",
	                            name: (0, _expressions.formatAggregationName)(aggregationOption),
	                            text: (0, _expressions.formatAggregationName)(aggregationOption) + (arity > 0 ? "(" : " "),
	                            postfixText: arity > 0 ? ")" : " ",
	                            prefixTrim: /\w+$/,
	                            postfixTrim: arity > 0 ? /^\w+(\(\)?|$)/ : /^\w+\s*/
	                        };
	                    })));
	                    // NOTE: DISABLE METRICS
	                    // finalSuggestions.push(...tableMetadata.metrics.map(metric => ({
	                    //     type: "metrics",
	                    //     name: metric.name,
	                    //     text: formatMetricName(metric),
	                    //     prefixTrim: /\w+$/,
	                    //     postfixTrim: /^\w+\s*/
	                    // })))
	                }
	            } else if (nextTokenType === _tokens.NumberLiteral) {
	                // skip number literal
	            } else {
	                console.warn("non exhaustive match", nextTokenType.name, _suggestion);
	            }
	        }
	
	        // throw away any suggestion that is not a suffix of the last partialToken.
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	
	    if (partialSuggestionMode) {
	        var partial = (0, _chevrotain.getImage)(lastInputToken).toLowerCase();
	        finalSuggestions = _underscore2.default.filter(finalSuggestions, function (suggestion) {
	            return suggestion.text && suggestion.text.toLowerCase().startsWith(partial) || suggestion.name && suggestion.name.toLowerCase().startsWith(partial);
	        });
	
	        var prefixLength = partial.length;
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = finalSuggestions[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var suggestion = _step4.value;
	
	                suggestion.prefixLength = prefixLength;
	            }
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                    _iterator4.return();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	    }
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	        for (var _iterator5 = finalSuggestions[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var _suggestion2 = _step5.value;
	
	            _suggestion2.index = index;
	            if (!_suggestion2.name) {
	                _suggestion2.name = _suggestion2.text;
	            }
	        }
	
	        // deduplicate suggestions and sort by type then name
	    } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	            }
	        } finally {
	            if (_didIteratorError5) {
	                throw _iteratorError5;
	            }
	        }
	    }
	
	    return _underscore2.default.chain(finalSuggestions).uniq(function (suggestion) {
	        return suggestion.text;
	    }).sortBy("name").sortBy("type").value();
	}

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var parser_public_1 = __webpack_require__(1013);
	var lexer_public_1 = __webpack_require__(1021);
	var tokens_public_1 = __webpack_require__(1020);
	var exceptions_public_1 = __webpack_require__(1017);
	var gast_public_1 = __webpack_require__(1019);
	var cache_public_1 = __webpack_require__(1034);
	var interpreter_1 = __webpack_require__(1028);
	/**
	 * defines the public API of
	 * changes here may require major version change. (semVer)
	 */
	var API = {};
	// semantic version
	API.VERSION = "0.21.0";
	// runtime API
	API.Parser = parser_public_1.Parser;
	API.ParserDefinitionErrorType = parser_public_1.ParserDefinitionErrorType;
	API.Lexer = lexer_public_1.Lexer;
	API.LexerDefinitionErrorType = lexer_public_1.LexerDefinitionErrorType;
	API.Token = tokens_public_1.Token;
	API.LazyToken = tokens_public_1.LazyToken;
	API.SimpleLazyToken = tokens_public_1.SimpleLazyToken;
	// TODO: remove this, does not belong on the API.
	API.VirtualToken = tokens_public_1.VirtualToken;
	API.EOF = tokens_public_1.EOF;
	// Tokens utilities
	API.extendToken = tokens_public_1.extendToken;
	API.extendLazyToken = tokens_public_1.extendLazyToken;
	API.extendSimpleLazyToken = tokens_public_1.extendSimpleLazyToken;
	API.tokenName = tokens_public_1.tokenName;
	API.tokenLabel = tokens_public_1.tokenLabel;
	API.tokenMatcher = tokens_public_1.tokenMatcher;
	API.createToken = tokens_public_1.createToken;
	API.createLazyToken = tokens_public_1.createLazyToken;
	API.createSimpleLazyToken = tokens_public_1.createSimpleLazyToken;
	// Tokens getters
	API.getImage = tokens_public_1.getImage;
	API.getStartOffset = tokens_public_1.getStartOffset;
	API.getStartLine = tokens_public_1.getStartLine;
	API.getStartColumn = tokens_public_1.getStartColumn;
	API.getEndOffset = tokens_public_1.getEndOffset;
	API.getEndLine = tokens_public_1.getEndLine;
	API.getEndColumn = tokens_public_1.getEndColumn;
	API.getTokenConstructor = tokens_public_1.getTokenConstructor;
	// Other Utilities
	API.EMPTY_ALT = parser_public_1.EMPTY_ALT;
	API.exceptions = {};
	API.exceptions.isRecognitionException = exceptions_public_1.exceptions.isRecognitionException;
	API.exceptions.EarlyExitException = exceptions_public_1.exceptions.EarlyExitException;
	API.exceptions.MismatchedTokenException = exceptions_public_1.exceptions.MismatchedTokenException;
	API.exceptions.NotAllInputParsedException = exceptions_public_1.exceptions.NotAllInputParsedException;
	API.exceptions.NoViableAltException = exceptions_public_1.exceptions.NoViableAltException;
	// grammar reflection API
	API.gast = {};
	API.gast.GAstVisitor = gast_public_1.gast.GAstVisitor;
	API.gast.Flat = gast_public_1.gast.Flat;
	API.gast.Repetition = gast_public_1.gast.Repetition;
	API.gast.RepetitionWithSeparator = gast_public_1.gast.RepetitionWithSeparator;
	API.gast.RepetitionMandatory = gast_public_1.gast.RepetitionMandatory;
	API.gast.RepetitionMandatoryWithSeparator = gast_public_1.gast.RepetitionMandatoryWithSeparator;
	API.gast.Option = gast_public_1.gast.Option;
	API.gast.Alternation = gast_public_1.gast.Alternation;
	API.gast.NonTerminal = gast_public_1.gast.NonTerminal;
	API.gast.Terminal = gast_public_1.gast.Terminal;
	API.gast.Rule = gast_public_1.gast.Rule;
	API.gast.serializeGrammar = gast_public_1.gast.serializeGrammar;
	API.gast.serializeProduction = gast_public_1.gast.serializeProduction;
	API.interperter = {};
	API.interperter.NextAfterTokenWalker = interpreter_1.NextAfterTokenWalker;
	API.clearCache = cache_public_1.clearCache;
	module.exports = API;
	//# sourceMappingURL=api.js.map

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var cache = __webpack_require__(1014);
	var exceptions_public_1 = __webpack_require__(1017);
	var lang_extensions_1 = __webpack_require__(1015);
	var resolver_1 = __webpack_require__(1018);
	var checks_1 = __webpack_require__(1024);
	var utils_1 = __webpack_require__(1016);
	var follow_1 = __webpack_require__(1030);
	var tokens_public_1 = __webpack_require__(1020);
	var lookahead_1 = __webpack_require__(1027);
	var gast_builder_1 = __webpack_require__(1032);
	var interpreter_1 = __webpack_require__(1028);
	var constants_1 = __webpack_require__(1031);
	var gast_public_1 = __webpack_require__(1019);
	var gast_1 = __webpack_require__(1025);
	var tokens_1 = __webpack_require__(1023);
	var serializeGrammar = gast_public_1.gast.serializeGrammar;
	var ParserDefinitionErrorType;
	(function (ParserDefinitionErrorType) {
	    ParserDefinitionErrorType[ParserDefinitionErrorType["INVALID_RULE_NAME"] = 0] = "INVALID_RULE_NAME";
	    ParserDefinitionErrorType[ParserDefinitionErrorType["DUPLICATE_RULE_NAME"] = 1] = "DUPLICATE_RULE_NAME";
	    ParserDefinitionErrorType[ParserDefinitionErrorType["INVALID_RULE_OVERRIDE"] = 2] = "INVALID_RULE_OVERRIDE";
	    ParserDefinitionErrorType[ParserDefinitionErrorType["DUPLICATE_PRODUCTIONS"] = 3] = "DUPLICATE_PRODUCTIONS";
	    ParserDefinitionErrorType[ParserDefinitionErrorType["UNRESOLVED_SUBRULE_REF"] = 4] = "UNRESOLVED_SUBRULE_REF";
	    ParserDefinitionErrorType[ParserDefinitionErrorType["LEFT_RECURSION"] = 5] = "LEFT_RECURSION";
	    ParserDefinitionErrorType[ParserDefinitionErrorType["NONE_LAST_EMPTY_ALT"] = 6] = "NONE_LAST_EMPTY_ALT";
	    ParserDefinitionErrorType[ParserDefinitionErrorType["AMBIGUOUS_ALTS"] = 7] = "AMBIGUOUS_ALTS";
	})(ParserDefinitionErrorType = exports.ParserDefinitionErrorType || (exports.ParserDefinitionErrorType = {}));
	var IN_RULE_RECOVERY_EXCEPTION = "InRuleRecoveryException";
	var END_OF_FILE = new tokens_public_1.EOF();
	END_OF_FILE.tokenType = tokens_public_1.EOF.tokenType;
	Object.freeze(END_OF_FILE);
	// Lookahead keys are 32Bit integers in the form
	// ZZZZZZZZZZZZZZZZZZZZZZZZ-YYYY-XXXX
	// XXXX -> Occurrence Index bitmap.
	// YYYY -> DSL Method Name bitmap.
	// ZZZZZZZZZZZZZZZZZZZZZZZZ -> Rule short Index bitmap.
	var BITS_FOR_METHOD_IDX = 4;
	var BITS_FOR_OCCURRENCE_IDX = 4;
	// short string used as part of mapping keys.
	// being short improves the performance when composing KEYS for maps out of these
	// The 4 - 7 bits (16 possible values, are reserved for the DSL method indices)
	/* tslint:disable */
	var OR_IDX = 1 << BITS_FOR_METHOD_IDX;
	var OPTION_IDX = 2 << BITS_FOR_METHOD_IDX;
	var MANY_IDX = 3 << BITS_FOR_METHOD_IDX;
	var AT_LEAST_ONE_IDX = 4 << BITS_FOR_METHOD_IDX;
	var MANY_SEP_IDX = 5 << BITS_FOR_METHOD_IDX;
	var AT_LEAST_ONE_SEP_IDX = 6 << BITS_FOR_METHOD_IDX;
	var DEFAULT_PARSER_CONFIG = Object.freeze({
	    recoveryEnabled: false,
	    maxLookahead: 5,
	    ignoredIssues: {},
	    dynamicTokensEnabled: false
	});
	var DEFAULT_RULE_CONFIG = Object.freeze({
	    recoveryValueFunc: function () { return undefined; },
	    resyncEnabled: true
	});
	/**
	 * Convenience used to express an empty alternative in an OR (alternation).
	 * can be used to more clearly describe the intent in a case of empty alternation.
	 *
	 * For example:
	 *
	 * 1. without using EMPTY_ALT:
	 *
	 *    this.OR([
	 *      {ALT: () => {
	 *        this.CONSUME1(OneTok)
	 *        return "1"
	 *      }},
	 *      {ALT: () => {
	 *        this.CONSUME1(TwoTok)
	 *        return "2"
	 *      }},
	 *      {ALT: () => { // implicitly empty because there are no invoked grammar rules (OR/MANY/CONSUME...) inside this alternative.
	 *        return "666"
	 *      }},
	 *    ])
	 *
	 *
	 * 2. using EMPTY_ALT:
	 *
	 *    this.OR([
	 *      {ALT: () => {
	 *        this.CONSUME1(OneTok)
	 *        return "1"
	 *      }},
	 *      {ALT: () => {
	 *        this.CONSUME1(TwoTok)
	 *        return "2"
	 *      }},
	 *      {ALT: EMPTY_ALT("666")}, // explicitly empty, clearer intent
	 *    ])
	 *
	 */
	function EMPTY_ALT(value) {
	    if (value === void 0) { value = undefined; }
	    return function () {
	        return value;
	    };
	}
	exports.EMPTY_ALT = EMPTY_ALT;
	var EOF_FOLLOW_KEY = {};
	/**
	 * A Recognizer capable of self analysis to determine it's grammar structure
	 * This is used for more advanced features requiring such information.
	 * For example: Error Recovery, Automatic lookahead calculation.
	 */
	var Parser = (function () {
	    function Parser(input, tokensMapOrArr, config) {
	        if (config === void 0) { config = DEFAULT_PARSER_CONFIG; }
	        this._errors = [];
	        this._input = [];
	        this.inputIdx = -1;
	        this.savedTokenIdx = -1;
	        this.isBackTrackingStack = [];
	        this.RULE_STACK = [];
	        this.RULE_OCCURRENCE_STACK = [];
	        this.tokensMap = undefined;
	        this.definedRulesNames = [];
	        this.shortRuleNameToFull = new lang_extensions_1.HashTable();
	        this.ruleShortNameIdx = 1;
	        /**
	         * Only used internally for storing productions as they are built for the first time.
	         * The final productions should be accessed from the static cache.
	         */
	        this._productions = new lang_extensions_1.HashTable();
	        this._input = input;
	        // configuration
	        this.recoveryEnabled = utils_1.has(config, "recoveryEnabled") ?
	            config.recoveryEnabled :
	            DEFAULT_PARSER_CONFIG.recoveryEnabled;
	        // performance optimization, NOOP will be inlined which
	        // effectively means that this optional feature does not exist
	        // when not used.
	        if (!this.recoveryEnabled) {
	            this.attemptInRepetitionRecovery = utils_1.NOOP;
	        }
	        this.dynamicTokensEnabled = utils_1.has(config, "dynamicTokensEnabled") ?
	            config.dynamicTokensEnabled :
	            DEFAULT_PARSER_CONFIG.dynamicTokensEnabled;
	        this.maxLookahead = utils_1.has(config, "maxLookahead") ?
	            config.maxLookahead :
	            DEFAULT_PARSER_CONFIG.maxLookahead;
	        this.ignoredIssues = utils_1.has(config, "ignoredIssues") ?
	            config.ignoredIssues :
	            DEFAULT_PARSER_CONFIG.ignoredIssues;
	        this.className = lang_extensions_1.classNameFromInstance(this);
	        this.firstAfterRepMap = cache.getFirstAfterRepForClass(this.className);
	        this.classLAFuncs = cache.getLookaheadFuncsForClass(this.className);
	        if (!cache.CLASS_TO_DEFINITION_ERRORS.containsKey(this.className)) {
	            this.definitionErrors = [];
	            cache.CLASS_TO_DEFINITION_ERRORS.put(this.className, this.definitionErrors);
	        }
	        else {
	            this.definitionErrors = cache.CLASS_TO_DEFINITION_ERRORS.get(this.className);
	        }
	        if (utils_1.isArray(tokensMapOrArr)) {
	            this.tokensMap = utils_1.reduce(tokensMapOrArr, function (acc, tokenClazz) {
	                acc[tokens_public_1.tokenName(tokenClazz)] = tokenClazz;
	                return acc;
	            }, {});
	        }
	        else if (utils_1.isObject(tokensMapOrArr)) {
	            this.tokensMap = utils_1.cloneObj(tokensMapOrArr);
	        }
	        else {
	            throw new Error("'tokensMapOrArr' argument must be An Array of Token constructors or a Dictionary of Tokens.");
	        }
	        var allTokens = utils_1.values(this.tokensMap);
	        var areAllStructuredTokens = utils_1.every(allTokens, function (currTokType) {
	            return tokens_1.isSimpleTokenType(currTokType);
	        });
	        if (areAllStructuredTokens) {
	            this.tokenMatcher = tokens_1.tokenStructuredMatcher;
	            this.tokenClassIdentityFunc = tokens_1.tokenStructuredIdentity;
	            // same IdentityFunc used in structured Mode
	            this.tokenInstanceIdentityFunc = tokens_1.tokenStructuredIdentity;
	        }
	        else {
	            this.tokenMatcher = tokens_1.tokenInstanceofMatcher;
	            this.tokenClassIdentityFunc = tokens_1.tokenClassIdentity;
	            this.tokenInstanceIdentityFunc = tokens_1.tokenInstanceIdentity;
	        }
	        // always add EOF to the tokenNames -> constructors map. it is useful to assure all the input has been
	        // parsed with a clear error message ("expecting EOF but found ...")
	        /* tslint:disable */
	        this.tokensMap["EOF"] = tokens_public_1.EOF;
	        /* tslint:enable */
	        // Because ES2015+ syntax should be supported for creating Token classes
	        // We cannot assume that the Token classes were created using the "extendToken" utilities
	        // Therefore we must augment the Token classes both on Lexer initialization and on Parser initialization
	        tokens_1.augmentTokenClasses(utils_1.values(this.tokensMap));
	    }
	    Parser.performSelfAnalysis = function (parserInstance) {
	        var definitionErrors = [];
	        var defErrorsMsgs;
	        var className = lang_extensions_1.classNameFromInstance(parserInstance);
	        if (className === "") {
	            // just a simple "throw Error" without any fancy "definition error" because the logic below relies on a unique parser name to
	            // save/access those definition errors...
	            throw Error("A Parser's constructor may not be an anonymous Function, it must be a named function\n" +
	                "The constructor's name is used at runtime for performance (caching) purposes.");
	        }
	        // this information should only be computed once
	        if (!cache.CLASS_TO_SELF_ANALYSIS_DONE.containsKey(className)) {
	            cache.CLASS_TO_SELF_ANALYSIS_DONE.put(className, true);
	            var orgProductions_1 = parserInstance._productions;
	            var clonedProductions_1 = new lang_extensions_1.HashTable();
	            // clone the grammar productions to support grammar inheritance. requirements:
	            // 1. We want to avoid rebuilding the grammar every time so a cache for the productions is used.
	            // 2. We need to collect the production from multiple grammars in an inheritance scenario during constructor invocation
	            //    so the myGast variable is used.
	            // 3. If a Production has been overridden references to it in the GAST must also be updated.
	            utils_1.forEach(orgProductions_1.keys(), function (key) {
	                var value = orgProductions_1.get(key);
	                clonedProductions_1.put(key, gast_1.cloneProduction(value));
	            });
	            cache.getProductionsForClass(className).putAll(clonedProductions_1);
	            // assumes this cache has been initialized (in the relevant parser's constructor)
	            // TODO: consider making the self analysis a member method to resolve this.
	            // that way it won't be callable before the constructor has been invoked...
	            definitionErrors = cache.CLASS_TO_DEFINITION_ERRORS.get(className);
	            var resolverErrors = resolver_1.resolveGrammar(clonedProductions_1);
	            definitionErrors.push.apply(definitionErrors, resolverErrors); // mutability for the win?
	            // only perform additional grammar validations IFF no resolving errors have occurred.
	            // as unresolved grammar may lead to unhandled runtime exceptions in the follow up validations.
	            if (utils_1.isEmpty(resolverErrors)) {
	                var validationErrors = checks_1.validateGrammar(clonedProductions_1.values(), parserInstance.maxLookahead, parserInstance.ignoredIssues);
	                definitionErrors.push.apply(definitionErrors, validationErrors); // mutability for the win?
	            }
	            if (!utils_1.isEmpty(definitionErrors) && !Parser.DEFER_DEFINITION_ERRORS_HANDLING) {
	                defErrorsMsgs = utils_1.map(definitionErrors, function (defError) { return defError.message; });
	                throw new Error("Parser Definition Errors detected\n: " + defErrorsMsgs.join("\n-------------------------------\n"));
	            }
	            if (utils_1.isEmpty(definitionErrors)) {
	                var allFollows = follow_1.computeAllProdsFollows(clonedProductions_1.values());
	                cache.setResyncFollowsForClass(className, allFollows);
	            }
	        }
	        // reThrow the validation errors each time an erroneous parser is instantiated
	        if (!utils_1.isEmpty(cache.CLASS_TO_DEFINITION_ERRORS.get(className)) && !Parser.DEFER_DEFINITION_ERRORS_HANDLING) {
	            defErrorsMsgs = utils_1.map(cache.CLASS_TO_DEFINITION_ERRORS.get(className), function (defError) { return defError.message; });
	            throw new Error("Parser Definition Errors detected\n: " + defErrorsMsgs.join("\n-------------------------------\n"));
	        }
	    };
	    Object.defineProperty(Parser.prototype, "errors", {
	        get: function () {
	            return utils_1.cloneArr(this._errors);
	        },
	        set: function (newErrors) {
	            this._errors = newErrors;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Parser.prototype, "input", {
	        get: function () {
	            return utils_1.cloneArr(this._input);
	        },
	        set: function (newInput) {
	            this.reset();
	            this._input = newInput;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Resets the parser state, should be overridden for custom parsers which "carry" additional state.
	     * When overriding, remember to also invoke the super implementation!
	     */
	    Parser.prototype.reset = function () {
	        this.resetLexerState();
	        this.isBackTrackingStack = [];
	        this.errors = [];
	        this._input = [];
	        this.RULE_STACK = [];
	        this.RULE_OCCURRENCE_STACK = [];
	    };
	    Parser.prototype.isAtEndOfInput = function () {
	        return this.tokenMatcher(this.LA(1), tokens_public_1.EOF);
	    };
	    Parser.prototype.getGAstProductions = function () {
	        return cache.getProductionsForClass(this.className);
	    };
	    // This is more than a convenience method.
	    // It is mostly used to draw the diagrams and having this method present on the parser instance
	    // can avoid certain situations in which the serialization logic would fail due to multiple versions of chevrotain
	    // bundled (due to multiple prototype chains and "instanceof" usage).
	    Parser.prototype.getSerializedGastProductions = function () {
	        return serializeGrammar(cache.getProductionsForClass(this.className).values());
	    };
	    /**
	     * @param startRuleName {string}
	     * @param precedingInput {ISimpleTokenOrIToken[]} - The token vector up to (not including) the content assist point
	     * @returns {ISyntacticContentAssistPath[]}
	     */
	    Parser.prototype.computeContentAssist = function (startRuleName, precedingInput) {
	        var startRuleGast = cache.getProductionsForClass(this.className).get(startRuleName);
	        if (utils_1.isUndefined(startRuleGast)) {
	            throw Error("Rule ->" + startRuleName + "<- does not exist in this grammar.");
	        }
	        return interpreter_1.nextPossibleTokensAfter([startRuleGast], precedingInput, this.tokenMatcher, this.maxLookahead);
	    };
	    Parser.prototype.isBackTracking = function () {
	        return !(utils_1.isEmpty(this.isBackTrackingStack));
	    };
	    Parser.prototype.getCurrRuleFullName = function () {
	        var shortName = utils_1.last(this.RULE_STACK);
	        return this.shortRuleNameToFull.get(shortName);
	    };
	    Parser.prototype.shortRuleNameToFullName = function (shortName) {
	        return this.shortRuleNameToFull.get(shortName);
	    };
	    Parser.prototype.getHumanReadableRuleStack = function () {
	        var _this = this;
	        return utils_1.map(this.RULE_STACK, function (currShortName) { return _this.shortRuleNameToFullName(currShortName); });
	    };
	    Parser.prototype.SAVE_ERROR = function (error) {
	        if (exceptions_public_1.exceptions.isRecognitionException(error)) {
	            error.context = {
	                ruleStack: this.getHumanReadableRuleStack(),
	                ruleOccurrenceStack: utils_1.cloneArr(this.RULE_OCCURRENCE_STACK)
	            };
	            this._errors.push(error);
	            return error;
	        }
	        else {
	            throw Error("Trying to save an Error which is not a RecognitionException");
	        }
	    };
	    /**
	     * @param grammarRule - The rule to try and parse in backtracking mode.
	     * @param isValid - A predicate that given the result of the parse attempt will "decide" if the parse was successfully or not.
	     *
	     * @return {Function():boolean} a lookahead function that will try to parse the given grammarRule and will return true if succeed.
	     */
	    Parser.prototype.BACKTRACK = function (grammarRule, isValid) {
	        return function () {
	            // save org state
	            this.isBackTrackingStack.push(1);
	            var orgState = this.saveRecogState();
	            try {
	                var ruleResult = grammarRule.call(this);
	                return isValid(ruleResult);
	            }
	            catch (e) {
	                if (exceptions_public_1.exceptions.isRecognitionException(e)) {
	                    return false;
	                }
	                else {
	                    throw e;
	                }
	            }
	            finally {
	                this.reloadRecogState(orgState);
	                this.isBackTrackingStack.pop();
	            }
	        };
	    };
	    // skips a token and returns the next token
	    Parser.prototype.SKIP_TOKEN = function () {
	        // example: assume 45 tokens in the input, if input index is 44 it means that NEXT_TOKEN will return
	        // input[45] which is the 46th item and no longer exists,
	        // so in this case the largest valid input index is 43 (input.length - 2 )
	        if (this.inputIdx <= this._input.length - 2) {
	            this.consumeToken();
	            return this.LA(1);
	        }
	        else {
	            return END_OF_FILE;
	        }
	    };
	    // Parsing DSL
	    /**
	     * Convenience method equivalent to CONSUME1.
	     * @see CONSUME1
	     */
	    Parser.prototype.CONSUME = function (tokClass) {
	        return this.CONSUME1(tokClass);
	    };
	    /**
	     *
	     * A Parsing DSL method use to consume a single terminal Token.
	     * a Token will be consumed, IFF the next token in the token vector is an instanceof tokClass.
	     * otherwise the parser will attempt to perform error recovery.
	     *
	     * The index in the method name indicates the unique occurrence of a terminal consumption
	     * inside a the top level rule. What this means is that if a terminal appears
	     * more than once in a single rule, each appearance must have a difference index.
	     *
	     * for example:
	     *
	     * function parseQualifiedName() {
	     *    this.CONSUME1(Identifier);
	     *    this.MANY(()=> {
	     *       this.CONSUME1(Dot);
	     *       this.CONSUME2(Identifier); // <-- here we use CONSUME2 because the terminal
	     *    });                           //     'Identifier' has already appeared previously in the
	     *                                  //     the rule 'parseQualifiedName'
	     * }
	     *
	     * @param {Function} tokClass - A constructor function specifying the type of token to be consumed.
	     *
	     * @returns {Token} - The consumed token.
	     */
	    // TODO: what is the returned type? ISimpleTokenOrIToken or IToken? or || ?
	    Parser.prototype.CONSUME1 = function (tokClass) {
	        return this.consumeInternal(tokClass, 1);
	    };
	    /**
	     * @see CONSUME1
	     */
	    Parser.prototype.CONSUME2 = function (tokClass) {
	        return this.consumeInternal(tokClass, 2);
	    };
	    /**
	     * @see CONSUME1
	     */
	    Parser.prototype.CONSUME3 = function (tokClass) {
	        return this.consumeInternal(tokClass, 3);
	    };
	    /**
	     * @see CONSUME1
	     */
	    Parser.prototype.CONSUME4 = function (tokClass) {
	        return this.consumeInternal(tokClass, 4);
	    };
	    /**
	     * @see CONSUME1
	     */
	    Parser.prototype.CONSUME5 = function (tokClass) {
	        return this.consumeInternal(tokClass, 5);
	    };
	    /**
	     * Convenience method equivalent to SUBRULE1
	     * @see SUBRULE1
	     */
	    Parser.prototype.SUBRULE = function (ruleToCall, args) {
	        if (args === void 0) { args = []; }
	        return this.SUBRULE1(ruleToCall, args);
	    };
	    /**
	     * The Parsing DSL Method is used by one rule to call another.
	     *
	     * This may seem redundant as it does not actually do much.
	     * However using it is mandatory for all sub rule invocations.
	     * calling another rule without wrapping in SUBRULE(...)
	     * will cause errors/mistakes in the Recognizer's self analysis,
	     * which will lead to errors in error recovery/automatic lookahead calculation
	     * and any other functionality relying on the Recognizer's self analysis
	     * output.
	     *
	     * As in CONSUME the index in the method name indicates the occurrence
	     * of the sub rule invocation in its rule.
	     *
	     * @param {Function} ruleToCall - The rule to invoke.
	     * @param {*[]} args - The arguments to pass to the invoked subrule.
	     * @returns {*} - The result of invoking ruleToCall.
	     */
	    Parser.prototype.SUBRULE1 = function (ruleToCall, args) {
	        if (args === void 0) { args = []; }
	        return ruleToCall.call(this, 1, args);
	    };
	    /**
	     * @see SUBRULE1
	     */
	    Parser.prototype.SUBRULE2 = function (ruleToCall, args) {
	        if (args === void 0) { args = []; }
	        return ruleToCall.call(this, 2, args);
	    };
	    /**
	     * @see SUBRULE1
	     */
	    Parser.prototype.SUBRULE3 = function (ruleToCall, args) {
	        if (args === void 0) { args = []; }
	        return ruleToCall.call(this, 3, args);
	    };
	    /**
	     * @see SUBRULE1
	     */
	    Parser.prototype.SUBRULE4 = function (ruleToCall, args) {
	        if (args === void 0) { args = []; }
	        return ruleToCall.call(this, 4, args);
	    };
	    /**
	     * @see SUBRULE1
	     */
	    Parser.prototype.SUBRULE5 = function (ruleToCall, args) {
	        if (args === void 0) { args = []; }
	        return ruleToCall.call(this, 5, args);
	    };
	    /**
	     * Convenience method equivalent to OPTION1.
	     * @see OPTION1
	     */
	    Parser.prototype.OPTION = function (predicateOrAction, action) {
	        return this.OPTION1.call(this, predicateOrAction, action);
	    };
	    /**
	     * Parsing DSL Method that Indicates an Optional production
	     * in EBNF notation: [...].
	     *
	     * Note that the 'action' param is optional. so both of the following forms are valid:
	     *
	     * - short: this.OPTION(()=>{ this.CONSUME(Digit});
	     * - long: this.OPTION(predicateFunc, ()=>{ this.CONSUME(Digit});
	     *
	     * The 'predicateFunc' in the long form can be used to add constraints (none grammar related)
	     * to optionally invoking the grammar action.
	     *
	     * As in CONSUME the index in the method name indicates the occurrence
	     * of the optional production in it's top rule.
	     *
	     * @param {Function} predicateOrAction - The predicate / gate function that implements the constraint on the grammar
	     *                                       or the grammar action to optionally invoke once.
	     * @param {Function} [action] - The action to optionally invoke.
	     *
	     * @returns {OUT}
	     */
	    Parser.prototype.OPTION1 = function (predicateOrAction, action) {
	        return this.optionInternal(predicateOrAction, action, 1);
	    };
	    /**
	     * @see OPTION1
	     */
	    Parser.prototype.OPTION2 = function (predicateOrAction, action) {
	        return this.optionInternal(predicateOrAction, action, 2);
	    };
	    /**
	     * @see OPTION1
	     */
	    Parser.prototype.OPTION3 = function (predicateOrAction, action) {
	        return this.optionInternal(predicateOrAction, action, 3);
	    };
	    /**
	     * @see OPTION1
	     */
	    Parser.prototype.OPTION4 = function (predicateOrAction, action) {
	        return this.optionInternal(predicateOrAction, action, 4);
	    };
	    /**
	     * @see OPTION1
	     */
	    Parser.prototype.OPTION5 = function (predicateOrAction, action) {
	        return this.optionInternal(predicateOrAction, action, 5);
	    };
	    /**
	     * Convenience method equivalent to OR1.
	     * @see OR1
	     */
	    Parser.prototype.OR = function (alts, errMsgTypes) {
	        return this.OR1(alts, errMsgTypes);
	    };
	    /**
	     * Parsing DSL method that indicates a choice between a set of alternatives must be made.
	     * This is equivalent to EBNF alternation (A | B | C | D ...)
	     *
	     * There are two forms:
	     *
	     * - short: this.OR([
	     *           {ALT:()=>{this.CONSUME(One)}},
	     *           {ALT:()=>{this.CONSUME(Two)}},
	     *           {ALT:()=>{this.CONSUME(Three)}},
	     *        ], "a number")
	     *
	     * - long: this.OR([
	     *           {GATE: predicateFunc1, ALT:()=>{this.CONSUME(One)}},
	     *           {GATE: predicateFuncX, ALT:()=>{this.CONSUME(Two)}},
	     *           {GATE: predicateFuncX, ALT:()=>{this.CONSUME(Three)}},
	     *        ], "a number")
	     *
	     * They can also be mixed:
	     * mixed: this.OR([
	     *           {GATE: predicateFunc1, ALT:()=>{this.CONSUME(One)}},
	     *           {ALT:()=>{this.CONSUME(Two)}},
	     *           {ALT:()=>{this.CONSUME(Three)}}
	     *        ], "a number")
	     *
	     * The 'predicateFuncX' in the long form can be used to add constraints (none grammar related) to choosing the alternative.
	     *
	     * As in CONSUME the index in the method name indicates the occurrence
	     * of the alternation production in it's top rule.
	     *
	     * @param {{ALT:Function}[] | {GATE:Function, ALT:Function}[]} alts - An array of alternatives.
	     *
	     * @param {string} [errMsgTypes] - A description for the alternatives used in error messages
	     *                                 If none is provided, the error message will include the names of the expected
	     *                                 Tokens sequences which may start each alternative.
	     *
	     * @returns {*} - The result of invoking the chosen alternative.
	     */
	    Parser.prototype.OR1 = function (alts, errMsgTypes) {
	        return this.orInternal(alts, errMsgTypes, 1);
	    };
	    /**
	     * @see OR1
	     */
	    Parser.prototype.OR2 = function (alts, errMsgTypes) {
	        return this.orInternal(alts, errMsgTypes, 2);
	    };
	    /**
	     * @see OR1
	     */
	    Parser.prototype.OR3 = function (alts, errMsgTypes) {
	        return this.orInternal(alts, errMsgTypes, 3);
	    };
	    /**
	     * @see OR1
	     */
	    Parser.prototype.OR4 = function (alts, errMsgTypes) {
	        return this.orInternal(alts, errMsgTypes, 4);
	    };
	    /**
	     * @see OR1
	     */
	    Parser.prototype.OR5 = function (alts, errMsgTypes) {
	        return this.orInternal(alts, errMsgTypes, 5);
	    };
	    /**
	     * Convenience method equivalent to MANY1.
	     * @see MANY1
	     */
	    Parser.prototype.MANY = function (predicateOrAction, action) {
	        return this.MANY1.call(this, predicateOrAction, action);
	    };
	    /**
	     * Parsing DSL method, that indicates a repetition of zero or more.
	     * This is equivalent to EBNF repetition {...}.
	     *
	     * Note that the 'action' param is optional. so both of the following forms are valid:
	     *
	     * short: this.MANY(()=>{
	     *                       this.CONSUME(Comma};
	     *                       this.CONSUME(Digit});
	     *
	     * long: this.MANY(predicateFunc, () => {
	     *                       this.CONSUME(Comma};
	     *                       this.CONSUME(Digit});
	     *
	     * The 'predicateFunc' in the long form can be used to add constraints (none grammar related) taking another iteration.
	     *
	     * As in CONSUME the index in the method name indicates the occurrence
	     * of the repetition production in it's top rule.
	     *
	     * @param {Function} predicateOrAction - The predicate / gate function that implements the constraint on the grammar
	     *                                   or the grammar action to optionally invoke multiple times.
	     * @param {Function} [action] - The action to optionally invoke multiple times.
	     *
	     * @returns {OUT[]}
	     */
	    Parser.prototype.MANY1 = function (predicateOrAction, action) {
	        return this.manyInternal(1, predicateOrAction, action, []);
	    };
	    /**
	     * @see MANY1
	     */
	    Parser.prototype.MANY2 = function (predicateOrAction, action) {
	        return this.manyInternal(2, predicateOrAction, action, []);
	    };
	    /**
	     * @see MANY1
	     */
	    Parser.prototype.MANY3 = function (predicateOrAction, action) {
	        return this.manyInternal(3, predicateOrAction, action, []);
	    };
	    /**
	     * @see MANY1
	     */
	    Parser.prototype.MANY4 = function (predicateOrAction, action) {
	        return this.manyInternal(4, predicateOrAction, action, []);
	    };
	    /**
	     * @see MANY1
	     */
	    Parser.prototype.MANY5 = function (predicateOrAction, action) {
	        return this.manyInternal(5, predicateOrAction, action, []);
	    };
	    /**
	     * Convenience method equivalent to MANY_SEP1.
	     * @see MANY_SEP1
	     */
	    Parser.prototype.MANY_SEP = function (separator, action) {
	        return this.MANY_SEP1.call(this, separator, action);
	    };
	    /**
	     * Parsing DSL method, that indicates a repetition of zero or more with a separator
	     * Token between the repetitions.
	     *
	     * Example:
	     *
	     * this.MANY_SEP(Comma, () => {
	     *                     this.CONSUME(Number};
	     *                     ...
	     *                   );
	     *
	     * Note that for the purposes of deciding on whether or not another iteration exists
	     * Only a single Token is examined (The separator). Therefore if the grammar being implemented is
	     * so "crazy" to require multiple tokens to identify an item separator please use the basic DSL methods
	     * to implement it.
	     *
	     * As in CONSUME the index in the method name indicates the occurrence
	     * of the repetition production in it's top rule.
	     *
	     * @param {TokenConstructor} separator - The Token class which will be used as a separator between repetitions.
	     * @param {Function} [action] - The action to optionally invoke.
	     *
	     * @return {ISeparatedIterationResult<OUT>}
	     */
	    Parser.prototype.MANY_SEP1 = function (separator, action) {
	        return this.manySepFirstInternal(1, separator, action, { values: [], separators: [] });
	    };
	    /**
	     * @see MANY_SEP1
	     */
	    Parser.prototype.MANY_SEP2 = function (separator, action) {
	        return this.manySepFirstInternal(2, separator, action, { values: [], separators: [] });
	    };
	    /**
	     * @see MANY_SEP1
	     */
	    Parser.prototype.MANY_SEP3 = function (separator, action) {
	        return this.manySepFirstInternal(3, separator, action, { values: [], separators: [] });
	    };
	    /**
	     * @see MANY_SEP1
	     */
	    Parser.prototype.MANY_SEP4 = function (separator, action) {
	        return this.manySepFirstInternal(4, separator, action, { values: [], separators: [] });
	    };
	    /**
	     * @see MANY_SEP1
	     */
	    Parser.prototype.MANY_SEP5 = function (separator, action) {
	        return this.manySepFirstInternal(5, separator, action, { values: [], separators: [] });
	    };
	    /**
	     * Convenience method equivalent to AT_LEAST_ONE1.
	     * @see AT_LEAST_ONE1
	     */
	    Parser.prototype.AT_LEAST_ONE = function (predicateOrAction, action, errMsg) {
	        return this.AT_LEAST_ONE1.call(this, predicateOrAction, action, errMsg);
	    };
	    /**
	     * Convenience method, same as MANY but the repetition is of one or more.
	     * failing to match at least one repetition will result in a parsing error and
	     * cause the parser to attempt error recovery.
	     *
	     * @see MANY1
	     *
	     * @param {Function} predicateOrAction  - The predicate / gate function that implements the constraint on the grammar
	     *                                        or the grammar action to invoke at least once.
	     * @param {Function} [action] - The action to optionally invoke.
	     * @param {string} [errMsg] - Short title/classification to what is being matched.
	     *
	     * @return {OUT[]}
	     */
	    Parser.prototype.AT_LEAST_ONE1 = function (predicateOrAction, action, errMsg) {
	        return this.atLeastOneInternal(1, predicateOrAction, action, errMsg, []);
	    };
	    /**
	     * @see AT_LEAST_ONE1
	     */
	    Parser.prototype.AT_LEAST_ONE2 = function (predicateOrAction, action, errMsg) {
	        return this.atLeastOneInternal(2, predicateOrAction, action, errMsg, []);
	    };
	    /**
	     * @see AT_LEAST_ONE1
	     */
	    Parser.prototype.AT_LEAST_ONE3 = function (predicateOrAction, action, errMsg) {
	        return this.atLeastOneInternal(3, predicateOrAction, action, errMsg, []);
	    };
	    /**
	     * @see AT_LEAST_ONE1
	     */
	    Parser.prototype.AT_LEAST_ONE4 = function (predicateOrAction, action, errMsg) {
	        return this.atLeastOneInternal(4, predicateOrAction, action, errMsg, []);
	    };
	    /**
	     * @see AT_LEAST_ONE1
	     */
	    Parser.prototype.AT_LEAST_ONE5 = function (predicateOrAction, action, errMsg) {
	        return this.atLeastOneInternal(5, predicateOrAction, action, errMsg, []);
	    };
	    /**
	     * Convenience method equivalent to AT_LEAST_ONE_SEP1.
	     * @see AT_LEAST_ONE1
	     */
	    Parser.prototype.AT_LEAST_ONE_SEP = function (separator, action, errMsg) {
	        return this.AT_LEAST_ONE_SEP1.call(this, separator, action, errMsg);
	    };
	    /**
	     *
	     * Convenience method, same as MANY_SEP but the repetition is of one or more.
	     * failing to match at least one repetition will result in a parsing error and
	     * cause the parser to attempt error recovery.
	     *
	     * @see MANY_SEP1
	     *
	     * @param {TokenConstructor} separator - The Token class which will be used as a separator between repetitions.
	     * @param {Function} [action] - The action to optionally invoke.
	     * @param {string} [errMsg] - Short title/classification to what is being matched.
	     *
	     * @return {ISeparatedIterationResult<OUT>}
	     */
	    Parser.prototype.AT_LEAST_ONE_SEP1 = function (separator, action, errMsg) {
	        return this.atLeastOneSepFirstInternal(1, separator, action, errMsg, { values: [], separators: [] });
	    };
	    /**
	     * @see AT_LEAST_ONE_SEP1
	     */
	    Parser.prototype.AT_LEAST_ONE_SEP2 = function (separator, action, errMsg) {
	        return this.atLeastOneSepFirstInternal(2, separator, action, errMsg, { values: [], separators: [] });
	    };
	    /**
	     * @see AT_LEAST_ONE_SEP1
	     */
	    Parser.prototype.AT_LEAST_ONE_SEP3 = function (separator, action, errMsg) {
	        return this.atLeastOneSepFirstInternal(3, separator, action, errMsg, { values: [], separators: [] });
	    };
	    /**
	     * @see AT_LEAST_ONE_SEP1
	     */
	    Parser.prototype.AT_LEAST_ONE_SEP4 = function (separator, action, errMsg) {
	        return this.atLeastOneSepFirstInternal(4, separator, action, errMsg, { values: [], separators: [] });
	    };
	    /**
	     * @see AT_LEAST_ONE_SEP1
	     */
	    Parser.prototype.AT_LEAST_ONE_SEP5 = function (separator, action, errMsg) {
	        return this.atLeastOneSepFirstInternal(5, separator, action, errMsg, { values: [], separators: [] });
	    };
	    /**
	     *
	     * @param {string} name - The name of the rule.
	     * @param {Function} implementation - The implementation of the rule.
	     * @param {IRuleConfig} [config] - The rule's optional configuration.
	     *
	     * @returns {Function} - The parsing rule which is the production implementation wrapped with the parsing logic that handles
	     *                     Parser state / error recovery&reporting/ ...
	     */
	    Parser.prototype.RULE = function (name, implementation, config) {
	        if (config === void 0) { config = DEFAULT_RULE_CONFIG; }
	        var ruleErrors = checks_1.validateRuleName(name, this.className);
	        ruleErrors = ruleErrors.concat(checks_1.validateRuleDoesNotAlreadyExist(name, this.definedRulesNames, this.className));
	        this.definedRulesNames.push(name);
	        this.definitionErrors.push.apply(this.definitionErrors, ruleErrors); // mutability for the win
	        // only build the gast representation once.
	        if (!(this._productions.containsKey(name))) {
	            var gastProduction = gast_builder_1.buildTopProduction(implementation.toString(), name, this.tokensMap);
	            this._productions.put(name, gastProduction);
	        }
	        else {
	            var parserClassProductions = cache.getProductionsForClass(this.className);
	            var cachedProduction = parserClassProductions.get(name);
	            // in case of duplicate rules the cache will not be filled at this point.
	            if (!utils_1.isUndefined(cachedProduction)) {
	                // filling up the _productions is always needed to inheriting grammars can access it (as an instance member)
	                // otherwise they will be unaware of productions defined in super grammars.
	                this._productions.put(name, cachedProduction);
	            }
	        }
	        var ruleImplementation = this.defineRule(name, implementation, config);
	        this[name] = ruleImplementation;
	        return ruleImplementation;
	    };
	    /**
	     * @See RULE
	     * Same as RULE, but should only be used in "extending" grammars to override rules/productions
	     * from the super grammar.
	     */
	    Parser.prototype.OVERRIDE_RULE = function (name, impl, config) {
	        if (config === void 0) { config = DEFAULT_RULE_CONFIG; }
	        var ruleErrors = checks_1.validateRuleName(name, this.className);
	        ruleErrors = ruleErrors.concat(checks_1.validateRuleIsOverridden(name, this.definedRulesNames, this.className));
	        this.definitionErrors.push.apply(this.definitionErrors, ruleErrors); // mutability for the win
	        var alreadyOverridden = cache.getProductionOverriddenForClass(this.className);
	        // only build the GAST of an overridden rule once.
	        if (!alreadyOverridden.containsKey(name)) {
	            alreadyOverridden.put(name, true);
	            var gastProduction = gast_builder_1.buildTopProduction(impl.toString(), name, this.tokensMap);
	            this._productions.put(name, gastProduction);
	        }
	        else {
	            var parserClassProductions = cache.getProductionsForClass(this.className);
	            // filling up the _productions is always needed to inheriting grammars can access it (as an instance member)
	            // otherwise they will be unaware of productions defined in super grammars.
	            this._productions.put(name, parserClassProductions.get(name));
	        }
	        return this.defineRule(name, impl, config);
	    };
	    Parser.prototype.ruleInvocationStateUpdate = function (shortName, idxInCallingRule) {
	        this.RULE_OCCURRENCE_STACK.push(idxInCallingRule);
	        this.RULE_STACK.push(shortName);
	    };
	    Parser.prototype.ruleFinallyStateUpdate = function () {
	        this.RULE_STACK.pop();
	        this.RULE_OCCURRENCE_STACK.pop();
	        if ((this.RULE_STACK.length === 0) && !this.isAtEndOfInput()) {
	            var firstRedundantTok = this.LA(1);
	            this.SAVE_ERROR(new exceptions_public_1.exceptions.NotAllInputParsedException("Redundant input, expecting EOF but found: " + tokens_public_1.getImage(firstRedundantTok), firstRedundantTok));
	        }
	    };
	    /**
	     * Returns an "imaginary" Token to insert when Single Token Insertion is done
	     * Override this if you require special behavior in your grammar.
	     * For example if an IntegerToken is required provide one with the image '0' so it would be valid syntactically.
	     */
	    Parser.prototype.getTokenToInsert = function (tokClass) {
	        var tokToInsert;
	        if (tokens_public_1.LazyToken.prototype.isPrototypeOf(tokClass.prototype)) {
	            tokToInsert = new tokClass(NaN, NaN, {
	                orgText: "",
	                lineToOffset: []
	            });
	        }
	        else if (tokens_public_1.SimpleLazyToken.prototype.isPrototypeOf(tokClass.prototype)) {
	            tokToInsert = {
	                startOffset: NaN,
	                endOffset: NaN,
	                cacheData: {
	                    orgText: "",
	                    lineToOffset: []
	                }
	            };
	        }/* istanbul ignore else */ 
	        else if (tokens_public_1.Token.prototype.isPrototypeOf(tokClass.prototype)) {
	            tokToInsert = new tokClass("", NaN, NaN, NaN, NaN, NaN);
	        }
	        else {
	            /* istanbul ignore next */ throw Error("non exhaustive match");
	        }
	        tokToInsert.isInsertedInRecovery = true;
	        return tokToInsert;
	    };
	    /**
	     * By default all tokens type may be inserted. This behavior may be overridden in inheriting Recognizers
	     * for example: One may decide that only punctuation tokens may be inserted automatically as they have no additional
	     * semantic value. (A mandatory semicolon has no additional semantic meaning, but an Integer may have additional meaning
	     * depending on its int value and context (Inserting an integer 0 in cardinality: "[1..]" will cause semantic issues
	     * as the max of the cardinality will be greater than the min value (and this is a false error!).
	     */
	    Parser.prototype.canTokenTypeBeInsertedInRecovery = function (tokClass) {
	        return true;
	    };
	    /**
	     * @param {Token} actualToken - The actual unexpected (mismatched) Token instance encountered.
	     * @param {Function} expectedTokType - The Class of the expected Token.
	     * @returns {string} - The error message saved as part of a MismatchedTokenException.
	     */
	    Parser.prototype.getMisMatchTokenErrorMessage = function (expectedTokType, actualToken) {
	        var hasLabel = tokens_public_1.hasTokenLabel(expectedTokType);
	        var expectedMsg = hasLabel ?
	            "--> " + tokens_public_1.tokenLabel(expectedTokType) + " <--" :
	            "token of type --> " + tokens_public_1.tokenName(expectedTokType) + " <--";
	        var msg = "Expecting " + expectedMsg + " but found --> '" + tokens_public_1.getImage(actualToken) + "' <--";
	        return msg;
	    };
	    Parser.prototype.getCurrentGrammarPath = function (tokClass, tokIdxInRule) {
	        var pathRuleStack = this.getHumanReadableRuleStack();
	        var pathOccurrenceStack = utils_1.cloneArr(this.RULE_OCCURRENCE_STACK);
	        var grammarPath = {
	            ruleStack: pathRuleStack,
	            occurrenceStack: pathOccurrenceStack,
	            lastTok: tokClass,
	            lastTokOccurrence: tokIdxInRule
	        };
	        return grammarPath;
	    };
	    // TODO: should this be a member method or a utility? it does not have any state or usage of 'this'...
	    // TODO: should this be more explicitly part of the public API?
	    Parser.prototype.getNextPossibleTokenTypes = function (grammarPath) {
	        var topRuleName = utils_1.first(grammarPath.ruleStack);
	        var gastProductions = this.getGAstProductions();
	        var topProduction = gastProductions.get(topRuleName);
	        var nextPossibleTokenTypes = new interpreter_1.NextAfterTokenWalker(topProduction, grammarPath).startWalking();
	        return nextPossibleTokenTypes;
	    };
	    /**
	     * @param tokClass - The Type of Token we wish to consume (Reference to its constructor function).
	     * @param idx - Occurrence index of consumed token in the invoking parser rule text
	     *         for example:
	     *         IDENT (DOT IDENT)*
	     *         the first ident will have idx 1 and the second one idx 2
	     *         * note that for the second ident the idx is always 2 even if its invoked 30 times in the same rule
	     *           the idx is about the position in grammar (source code) and has nothing to do with a specific invocation
	     *           details.
	     *
	     * @returns {Token} - The consumed Token.
	     */
	    Parser.prototype.consumeInternal = function (tokClass, idx) {
	        // TODO: this is an hack to avoid try catch block in V8, should be removed once V8 supports try/catch optimizations.
	        // as the IF/ELSE itself has some overhead.
	        if (!this.recoveryEnabled) {
	            return this.consumeInternalOptimized(tokClass);
	        }
	        else {
	            return this.consumeInternalWithTryCatch(tokClass, idx);
	        }
	    };
	    Parser.prototype.consumeInternalWithTryCatch = function (tokClass, idx) {
	        try {
	            return this.consumeInternalOptimized(tokClass);
	        }
	        catch (eFromConsumption) {
	            // no recovery allowed during backtracking, otherwise backtracking may recover invalid syntax and accept it
	            // but the original syntax could have been parsed successfully without any backtracking + recovery
	            if (this.recoveryEnabled &&
	                // TODO: more robust checking of the exception type. Perhaps Typescript extending expressions?
	                eFromConsumption.name === "MismatchedTokenException" && !this.isBackTracking()) {
	                var follows = this.getFollowsForInRuleRecovery(tokClass, idx);
	                try {
	                    return this.tryInRuleRecovery(tokClass, follows);
	                }
	                catch (eFromInRuleRecovery) {
	                    if (eFromInRuleRecovery.name === IN_RULE_RECOVERY_EXCEPTION) {
	                        // failed in RuleRecovery.
	                        // throw the original error in order to trigger reSync error recovery
	                        throw eFromConsumption;
	                    }
	                    else {
	                        throw eFromInRuleRecovery;
	                    }
	                }
	            }
	            else {
	                throw eFromConsumption;
	            }
	        }
	    };
	    /**
	     * Convenience method equivalent to LA(1)
	     * It is no longer used directly in chevrotain due to
	     * performance considerations (avoid the need for inlining optimizations).
	     *
	     * But it is maintained for backward compatibility reasons.
	     *
	     * @deprecated
	     */
	    Parser.prototype.NEXT_TOKEN = function () {
	        return this.LA(1);
	    };
	    // Lexer (accessing Token vector) related methods which can be overridden to implement lazy lexers
	    // or lexers dependent on parser context.
	    Parser.prototype.LA = function (howMuch) {
	        if (this._input.length <= this.inputIdx + howMuch) {
	            return END_OF_FILE;
	        }
	        else {
	            return this._input[this.inputIdx + howMuch];
	        }
	    };
	    Parser.prototype.consumeToken = function () {
	        this.inputIdx++;
	    };
	    Parser.prototype.saveLexerState = function () {
	        this.savedTokenIdx = this.inputIdx;
	    };
	    Parser.prototype.restoreLexerState = function () {
	        this.inputIdx = this.savedTokenIdx;
	    };
	    Parser.prototype.resetLexerState = function () {
	        this.inputIdx = -1;
	    };
	    Parser.prototype.moveLexerStateToEnd = function () {
	        this.inputIdx = this.input.length - 1;
	    };
	    // other functionality
	    Parser.prototype.saveRecogState = function () {
	        // errors is a getter which will clone the errors array
	        var savedErrors = this.errors;
	        var savedRuleStack = utils_1.cloneArr(this.RULE_STACK);
	        return {
	            errors: savedErrors,
	            lexerState: this.inputIdx,
	            RULE_STACK: savedRuleStack
	        };
	    };
	    Parser.prototype.reloadRecogState = function (newState) {
	        this.errors = newState.errors;
	        this.inputIdx = newState.lexerState;
	        this.RULE_STACK = newState.RULE_STACK;
	    };
	    Parser.prototype.defineRule = function (ruleName, impl, config) {
	        var resyncEnabled = utils_1.has(config, "resyncEnabled") ?
	            config.resyncEnabled :
	            DEFAULT_RULE_CONFIG.resyncEnabled;
	        var recoveryValueFunc = utils_1.has(config, "recoveryValueFunc") ?
	            config.recoveryValueFunc :
	            DEFAULT_RULE_CONFIG.recoveryValueFunc;
	        // performance optimization: Use small integers as keys for the longer human readable "full" rule names.
	        // this greatly improves Map access time (as much as 8% for some performance benchmarks).
	        /* tslint:disable */
	        var shortName = this.ruleShortNameIdx << (BITS_FOR_METHOD_IDX + BITS_FOR_OCCURRENCE_IDX);
	        /* tslint:enable */
	        this.ruleShortNameIdx++;
	        this.shortRuleNameToFull.put(shortName, ruleName);
	        function invokeRuleNoTry(args) {
	            var result = impl.apply(this, args);
	            this.ruleFinallyStateUpdate();
	            return result;
	        }
	        function invokeRuleWithTry(args, isFirstRule) {
	            try {
	                // actual parsing happens here
	                return impl.apply(this, args);
	            }
	            catch (e) {
	                // TODO: this is part of a Performance hack for V8 due to lack of support
	                // of try/catch optimizations. Should be removed once V8 supports that.
	                // This is needed because in case of an error during a nested subRule
	                // there will be no "finally" block to perform the "ruleFinallyStateUpdate"
	                // So this block properly rewinds the parser's state in the case error recovery is disabled.
	                if (isFirstRule) {
	                    for (var i = this.RULE_STACK.length; i > 1; i--) {
	                        this.ruleFinallyStateUpdate();
	                    }
	                }
	                var isFirstInvokedRule = (this.RULE_STACK.length === 1);
	                // note the reSync is always enabled for the first rule invocation, because we must always be able to
	                // reSync with EOF and just output some INVALID ParseTree
	                // during backtracking reSync recovery is disabled, otherwise we can't be certain the backtracking
	                // path is really the most valid one
	                var reSyncEnabled = resyncEnabled && !this.isBackTracking() && this.recoveryEnabled;
	                if (exceptions_public_1.exceptions.isRecognitionException(e)) {
	                    if (reSyncEnabled) {
	                        var reSyncTokType = this.findReSyncTokenType();
	                        if (this.isInCurrentRuleReSyncSet(reSyncTokType)) {
	                            e.resyncedTokens = this.reSyncTo(reSyncTokType);
	                            return recoveryValueFunc();
	                        }
	                        else {
	                            // to be handled farther up the call stack
	                            throw e;
	                        }
	                    }
	                    else if (isFirstInvokedRule) {
	                        // otherwise a Redundant input error will be created as well and we cannot guarantee that this is indeed the case
	                        this.moveLexerStateToEnd();
	                        // the parser should never throw one of its own errors outside its flow.
	                        // even if error recovery is disabled
	                        return recoveryValueFunc();
	                    }
	                    else {
	                        // to be handled farther up the call stack
	                        throw e;
	                    }
	                }
	                else {
	                    // some other Error type which we don't know how to handle (for example a built in JavaScript Error)
	                    throw e;
	                }
	            }
	            finally {
	                this.ruleFinallyStateUpdate();
	            }
	        }
	        var wrappedGrammarRule = function (idxInCallingRule, args) {
	            if (idxInCallingRule === void 0) { idxInCallingRule = 1; }
	            this.ruleInvocationStateUpdate(shortName, idxInCallingRule);
	            // TODO: performance hack due to V8 lack of try/catch optimizations.
	            // should be removed once V8 support those.
	            var isFirstRule = this.RULE_STACK.length === 1;
	            if (!this.recoveryEnabled && !isFirstRule) {
	                return invokeRuleNoTry.call(this, args);
	            }
	            else {
	                return invokeRuleWithTry.call(this, args, isFirstRule);
	            }
	        };
	        var ruleNamePropName = "ruleName";
	        wrappedGrammarRule[ruleNamePropName] = ruleName;
	        return wrappedGrammarRule;
	    };
	    Parser.prototype.tryInRepetitionRecovery = function (grammarRule, grammarRuleArgs, lookAheadFunc, expectedTokType) {
	        var _this = this;
	        // TODO: can the resyncTokenType be cached?
	        var reSyncTokType = this.findReSyncTokenType();
	        this.saveLexerState();
	        var resyncedTokens = [];
	        var passedResyncPoint = false;
	        var nextTokenWithoutResync = this.LA(1);
	        var currToken = this.LA(1);
	        var generateErrorMessage = function () {
	            // we are preemptively re-syncing before an error has been detected, therefor we must reproduce
	            // the error that would have been thrown
	            var msg = _this.getMisMatchTokenErrorMessage(expectedTokType, nextTokenWithoutResync);
	            var error = new exceptions_public_1.exceptions.MismatchedTokenException(msg, nextTokenWithoutResync);
	            // the first token here will be the original cause of the error, this is not part of the resyncedTokens property.
	            error.resyncedTokens = utils_1.dropRight(resyncedTokens);
	            _this.SAVE_ERROR(error);
	        };
	        while (!passedResyncPoint) {
	            // re-synced to a point where we can safely exit the repetition/
	            if (this.tokenMatcher(currToken, expectedTokType)) {
	                generateErrorMessage();
	                return; // must return here to avoid reverting the inputIdx
	            }
	            else if (lookAheadFunc.call(this)) {
	                generateErrorMessage();
	                // recursive invocation in other to support multiple re-syncs in the same top level repetition grammar rule
	                grammarRule.apply(this, grammarRuleArgs);
	                return; // must return here to avoid reverting the inputIdx
	            }
	            else if (this.tokenMatcher(currToken, reSyncTokType)) {
	                passedResyncPoint = true;
	            }
	            else {
	                currToken = this.SKIP_TOKEN();
	                this.addToResyncTokens(currToken, resyncedTokens);
	            }
	        }
	        // we were unable to find a CLOSER point to resync inside the Repetition, reset the state.
	        // The parsing exception we were trying to prevent will happen in the NEXT parsing step. it may be handled by
	        // "between rules" resync recovery later in the flow.
	        this.restoreLexerState();
	    };
	    Parser.prototype.shouldInRepetitionRecoveryBeTried = function (expectTokAfterLastMatch, nextTokIdx) {
	        // arguments to try and perform resync into the next iteration of the many are missing
	        if (expectTokAfterLastMatch === undefined || nextTokIdx === undefined) {
	            return false;
	        }
	        // no need to recover, next token is what we expect...
	        if (this.tokenMatcher(this.LA(1), expectTokAfterLastMatch)) {
	            return false;
	        }
	        // error recovery is disabled during backtracking as it can make the parser ignore a valid grammar path
	        // and prefer some backtracking path that includes recovered errors.
	        if (this.isBackTracking()) {
	            return false;
	        }
	        // if we can perform inRule recovery (single token insertion or deletion) we always prefer that recovery algorithm
	        // because if it works, it makes the least amount of changes to the input stream (greedy algorithm)
	        //noinspection RedundantIfStatementJS
	        if (this.canPerformInRuleRecovery(expectTokAfterLastMatch, this.getFollowsForInRuleRecovery(expectTokAfterLastMatch, nextTokIdx))) {
	            return false;
	        }
	        return true;
	    };
	    // Error Recovery functionality
	    Parser.prototype.getFollowsForInRuleRecovery = function (tokClass, tokIdxInRule) {
	        var grammarPath = this.getCurrentGrammarPath(tokClass, tokIdxInRule);
	        var follows = this.getNextPossibleTokenTypes(grammarPath);
	        return follows;
	    };
	    Parser.prototype.tryInRuleRecovery = function (expectedTokType, follows) {
	        if (this.canRecoverWithSingleTokenInsertion(expectedTokType, follows)) {
	            var tokToInsert = this.getTokenToInsert(expectedTokType);
	            return tokToInsert;
	        }
	        if (this.canRecoverWithSingleTokenDeletion(expectedTokType)) {
	            var nextTok = this.SKIP_TOKEN();
	            this.consumeToken();
	            return nextTok;
	        }
	        throw new InRuleRecoveryException("sad sad panda");
	    };
	    Parser.prototype.canPerformInRuleRecovery = function (expectedToken, follows) {
	        return this.canRecoverWithSingleTokenInsertion(expectedToken, follows) ||
	            this.canRecoverWithSingleTokenDeletion(expectedToken);
	    };
	    Parser.prototype.canRecoverWithSingleTokenInsertion = function (expectedTokType, follows) {
	        var _this = this;
	        if (!this.canTokenTypeBeInsertedInRecovery(expectedTokType)) {
	            return false;
	        }
	        // must know the possible following tokens to perform single token insertion
	        if (utils_1.isEmpty(follows)) {
	            return false;
	        }
	        var mismatchedTok = this.LA(1);
	        var isMisMatchedTokInFollows = utils_1.find(follows, function (possibleFollowsTokType) {
	            return _this.tokenMatcher(mismatchedTok, possibleFollowsTokType);
	        }) !== undefined;
	        return isMisMatchedTokInFollows;
	    };
	    Parser.prototype.canRecoverWithSingleTokenDeletion = function (expectedTokType) {
	        var isNextTokenWhatIsExpected = this.tokenMatcher(this.LA(2), expectedTokType);
	        return isNextTokenWhatIsExpected;
	    };
	    Parser.prototype.isInCurrentRuleReSyncSet = function (tokenType) {
	        var followKey = this.getCurrFollowKey();
	        var currentRuleReSyncSet = this.getFollowSetFromFollowKey(followKey);
	        return utils_1.contains(currentRuleReSyncSet, tokenType);
	    };
	    Parser.prototype.findReSyncTokenType = function () {
	        var allPossibleReSyncTokTypes = this.flattenFollowSet();
	        // this loop will always terminate as EOF is always in the follow stack and also always (virtually) in the input
	        var nextToken = this.LA(1);
	        var k = 2;
	        while (true) {
	            var nextTokenType = tokens_public_1.getTokenConstructor(nextToken);
	            if (utils_1.contains(allPossibleReSyncTokTypes, nextTokenType)) {
	                return nextTokenType;
	            }
	            nextToken = this.LA(k);
	            k++;
	        }
	    };
	    Parser.prototype.getCurrFollowKey = function () {
	        // the length is at least one as we always add the ruleName to the stack before invoking the rule.
	        if (this.RULE_STACK.length === 1) {
	            return EOF_FOLLOW_KEY;
	        }
	        var currRuleIdx = this.RULE_STACK.length - 1;
	        var currRuleOccIdx = currRuleIdx;
	        var prevRuleIdx = currRuleIdx - 1;
	        return {
	            ruleName: this.shortRuleNameToFullName(this.RULE_STACK[currRuleIdx]),
	            idxInCallingRule: this.RULE_OCCURRENCE_STACK[currRuleOccIdx],
	            inRule: this.shortRuleNameToFullName(this.RULE_STACK[prevRuleIdx])
	        };
	    };
	    Parser.prototype.buildFullFollowKeyStack = function () {
	        var _this = this;
	        return utils_1.map(this.RULE_STACK, function (ruleName, idx) {
	            if (idx === 0) {
	                return EOF_FOLLOW_KEY;
	            }
	            return {
	                ruleName: _this.shortRuleNameToFullName(ruleName),
	                idxInCallingRule: _this.RULE_OCCURRENCE_STACK[idx],
	                inRule: _this.shortRuleNameToFullName(_this.RULE_STACK[idx - 1])
	            };
	        });
	    };
	    Parser.prototype.flattenFollowSet = function () {
	        var _this = this;
	        var followStack = utils_1.map(this.buildFullFollowKeyStack(), function (currKey) {
	            return _this.getFollowSetFromFollowKey(currKey);
	        });
	        return utils_1.flatten(followStack);
	    };
	    Parser.prototype.getFollowSetFromFollowKey = function (followKey) {
	        if (followKey === EOF_FOLLOW_KEY) {
	            return [tokens_public_1.EOF];
	        }
	        var followName = followKey.ruleName + followKey.idxInCallingRule + constants_1.IN + followKey.inRule;
	        return cache.getResyncFollowsForClass(this.className).get(followName);
	    };
	    // It does not make any sense to include a virtual EOF token in the list of resynced tokens
	    // as EOF does not really exist and thus does not contain any useful information (line/column numbers)
	    Parser.prototype.addToResyncTokens = function (token, resyncTokens) {
	        if (!this.tokenMatcher(token, tokens_public_1.EOF)) {
	            resyncTokens.push(token);
	        }
	        return resyncTokens;
	    };
	    Parser.prototype.reSyncTo = function (tokClass) {
	        var resyncedTokens = [];
	        var nextTok = this.LA(1);
	        while ((this.tokenMatcher(nextTok, tokClass)) === false) {
	            nextTok = this.SKIP_TOKEN();
	            this.addToResyncTokens(nextTok, resyncedTokens);
	        }
	        // the last token is not part of the error.
	        return utils_1.dropRight(resyncedTokens);
	    };
	    Parser.prototype.attemptInRepetitionRecovery = function (prodFunc, args, lookaheadFunc, dslMethodIdx, prodOccurrence, nextToksWalker) {
	        var key = this.getKeyForAutomaticLookahead(dslMethodIdx, prodOccurrence);
	        var firstAfterRepInfo = this.firstAfterRepMap.get(key);
	        if (firstAfterRepInfo === undefined) {
	            var currRuleName = this.getCurrRuleFullName();
	            var ruleGrammar = this.getGAstProductions().get(currRuleName);
	            var walker = new nextToksWalker(ruleGrammar, prodOccurrence);
	            firstAfterRepInfo = walker.startWalking();
	            this.firstAfterRepMap.put(key, firstAfterRepInfo);
	        }
	        var expectTokAfterLastMatch = firstAfterRepInfo.token;
	        var nextTokIdx = firstAfterRepInfo.occurrence;
	        var isEndOfRule = firstAfterRepInfo.isEndOfRule;
	        // special edge case of a TOP most repetition after which the input should END.
	        // this will force an attempt for inRule recovery in that scenario.
	        if (this.RULE_STACK.length === 1 &&
	            isEndOfRule &&
	            expectTokAfterLastMatch === undefined) {
	            expectTokAfterLastMatch = tokens_public_1.EOF;
	            nextTokIdx = 1;
	        }
	        if (this.shouldInRepetitionRecoveryBeTried(expectTokAfterLastMatch, nextTokIdx)) {
	            // TODO: performance optimization: instead of passing the original args here, we modify
	            // the args param (or create a new one) and make sure the lookahead func is explicitly provided
	            // to avoid searching the cache for it once more.
	            this.tryInRepetitionRecovery(prodFunc, args, lookaheadFunc, expectTokAfterLastMatch);
	        }
	    };
	    // Implementation of parsing DSL
	    Parser.prototype.optionInternal = function (predicateOrAction, action, occurrence) {
	        var lookAheadFunc = this.getLookaheadFuncForOption(occurrence);
	        if (action === undefined) {
	            action = predicateOrAction;
	        } // predicate present
	        else if (!predicateOrAction.call(this)) {
	            return undefined;
	        }
	        if ((lookAheadFunc).call(this)) {
	            return action.call(this);
	        }
	        return undefined;
	    };
	    Parser.prototype.atLeastOneInternal = function (prodOccurrence, predicate, action, userDefinedErrMsg, result) {
	        var _this = this;
	        var lookAheadFunc = this.getLookaheadFuncForAtLeastOne(prodOccurrence);
	        if (!utils_1.isFunction(action)) {
	            userDefinedErrMsg = action;
	            action = predicate;
	        }
	        else {
	            var orgLookAheadFunc_1 = lookAheadFunc;
	            lookAheadFunc = function () {
	                return predicate.call(_this) &&
	                    orgLookAheadFunc_1.call(_this);
	            };
	        }
	        if (lookAheadFunc.call(this)) {
	            result.push(action.call(this));
	            while (lookAheadFunc.call(this)) {
	                result.push(action.call(this));
	            }
	        }
	        else {
	            throw this.raiseEarlyExitException(prodOccurrence, lookahead_1.PROD_TYPE.REPETITION_MANDATORY, userDefinedErrMsg);
	        }
	        // note that while it may seem that this can cause an error because by using a recursive call to
	        // AT_LEAST_ONE we change the grammar to AT_LEAST_TWO, AT_LEAST_THREE ... , the possible recursive call
	        // from the tryInRepetitionRecovery(...) will only happen IFF there really are TWO/THREE/.... items.
	        // Performance optimization: "attemptInRepetitionRecovery" will be defined as NOOP unless recovery is enabled
	        this.attemptInRepetitionRecovery(this.atLeastOneInternal, [prodOccurrence, lookAheadFunc, action, userDefinedErrMsg, result], lookAheadFunc, AT_LEAST_ONE_IDX, prodOccurrence, interpreter_1.NextTerminalAfterAtLeastOneWalker);
	        return result;
	    };
	    Parser.prototype.atLeastOneSepFirstInternal = function (prodOccurrence, separator, action, userDefinedErrMsg, result) {
	        var _this = this;
	        var firstIterationLookaheadFunc = this.getLookaheadFuncForAtLeastOneSep(prodOccurrence);
	        var values = result.values;
	        var separators = result.separators;
	        // 1st iteration
	        if (firstIterationLookaheadFunc.call(this)) {
	            values.push(action.call(this));
	            var separatorLookAheadFunc = function () { return _this.tokenMatcher(_this.LA(1), separator); };
	            // 2nd..nth iterations
	            while (this.tokenMatcher(this.LA(1), separator)) {
	                // note that this CONSUME will never enter recovery because
	                // the separatorLookAheadFunc checks that the separator really does exist.
	                separators.push(this.CONSUME(separator));
	                values.push(action.call(this));
	            }
	            // Performance optimization: "attemptInRepetitionRecovery" will be defined as NOOP unless recovery is enabled
	            this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [prodOccurrence, separator, separatorLookAheadFunc, action, interpreter_1.NextTerminalAfterAtLeastOneSepWalker, result], separatorLookAheadFunc, AT_LEAST_ONE_SEP_IDX, prodOccurrence, interpreter_1.NextTerminalAfterAtLeastOneSepWalker);
	        }
	        else {
	            throw this.raiseEarlyExitException(prodOccurrence, lookahead_1.PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR, userDefinedErrMsg);
	        }
	        return result;
	    };
	    Parser.prototype.manyInternal = function (prodOccurrence, predicate, action, result) {
	        var _this = this;
	        var lookaheadFunction = this.getLookaheadFuncForMany(prodOccurrence);
	        if (action === undefined) {
	            action = predicate;
	        }
	        else {
	            var orgLookaheadFunction_1 = lookaheadFunction;
	            lookaheadFunction = function () {
	                return predicate.call(_this) &&
	                    orgLookaheadFunction_1.call(_this);
	            };
	        }
	        while (lookaheadFunction.call(this)) {
	            result.push(action.call(this));
	        }
	        // Performance optimization: "attemptInRepetitionRecovery" will be defined as NOOP unless recovery is enabled
	        this.attemptInRepetitionRecovery(this.manyInternal, [prodOccurrence, lookaheadFunction, action, result], lookaheadFunction, MANY_IDX, prodOccurrence, interpreter_1.NextTerminalAfterManyWalker);
	        return result;
	    };
	    Parser.prototype.manySepFirstInternal = function (prodOccurrence, separator, action, result) {
	        var _this = this;
	        var firstIterationLaFunc = this.getLookaheadFuncForManySep(prodOccurrence);
	        var values = result.values;
	        var separators = result.separators;
	        // 1st iteration
	        if (firstIterationLaFunc.call(this)) {
	            values.push(action.call(this));
	            var separatorLookAheadFunc = function () { return _this.tokenMatcher(_this.LA(1), separator); };
	            // 2nd..nth iterations
	            while (this.tokenMatcher(this.LA(1), separator)) {
	                // note that this CONSUME will never enter recovery because
	                // the separatorLookAheadFunc checks that the separator really does exist.
	                separators.push(this.CONSUME(separator));
	                values.push(action.call(this));
	            }
	            // Performance optimization: "attemptInRepetitionRecovery" will be defined as NOOP unless recovery is enabled
	            this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [prodOccurrence, separator, separatorLookAheadFunc, action, interpreter_1.NextTerminalAfterManySepWalker, result], separatorLookAheadFunc, MANY_SEP_IDX, prodOccurrence, interpreter_1.NextTerminalAfterManySepWalker);
	        }
	        return result;
	    };
	    Parser.prototype.repetitionSepSecondInternal = function (prodOccurrence, separator, separatorLookAheadFunc, action, nextTerminalAfterWalker, result) {
	        while (separatorLookAheadFunc()) {
	            // note that this CONSUME will never enter recovery because
	            // the separatorLookAheadFunc checks that the separator really does exist.
	            result.separators.push(this.CONSUME(separator));
	            result.values.push(action.call(this));
	        }
	        // we can only arrive to this function after an error
	        // has occurred (hence the name 'second') so the following
	        // IF will always be entered, its possible to remove it...
	        // however it is kept to avoid confusion and be consistent.
	        // Performance optimization: "attemptInRepetitionRecovery" will be defined as NOOP unless recovery is enabled
	        /* istanbul ignore else */
	        this.attemptInRepetitionRecovery(this.repetitionSepSecondInternal, [prodOccurrence, separator, separatorLookAheadFunc, action, nextTerminalAfterWalker, result], separatorLookAheadFunc, AT_LEAST_ONE_SEP_IDX, prodOccurrence, nextTerminalAfterWalker);
	    };
	    Parser.prototype.orInternal = function (alts, errMsgTypes, occurrence) {
	        var laFunc = this.getLookaheadFuncForOr(occurrence, alts);
	        var altToTake = laFunc.call(this, alts);
	        if (altToTake !== undefined) {
	            var chosenAlternative = alts[altToTake];
	            return chosenAlternative.ALT.call(this);
	        }
	        this.raiseNoAltException(occurrence, errMsgTypes);
	    };
	    // to enable optimizations this logic has been extract to a method as its invoker contains try/catch
	    Parser.prototype.consumeInternalOptimized = function (expectedTokClass) {
	        var nextToken = this.LA(1);
	        if (this.tokenMatcher(nextToken, expectedTokClass)) {
	            this.consumeToken();
	            return nextToken;
	        }
	        else {
	            var msg = this.getMisMatchTokenErrorMessage(expectedTokClass, nextToken);
	            throw this.SAVE_ERROR(new exceptions_public_1.exceptions.MismatchedTokenException(msg, nextToken));
	        }
	    };
	    // this actually returns a number, but it is always used as a string (object prop key)
	    Parser.prototype.getKeyForAutomaticLookahead = function (dslMethodIdx, occurrence) {
	        var ruleStack = this.RULE_STACK;
	        var currRuleShortName = ruleStack[ruleStack.length - 1];
	        /* tslint:disable */
	        return occurrence | dslMethodIdx | currRuleShortName;
	        /* tslint:enable */
	    };
	    Parser.prototype.getLookaheadFuncForOr = function (occurrence, alts) {
	        var key = this.getKeyForAutomaticLookahead(OR_IDX, occurrence);
	        var laFunc = this.classLAFuncs.get(key);
	        if (laFunc === undefined) {
	            var ruleName = this.getCurrRuleFullName();
	            var ruleGrammar = this.getGAstProductions().get(ruleName);
	            // note that hasPredicates is only computed once.
	            var hasPredicates = utils_1.some(alts, function (currAlt) { return utils_1.isFunction(currAlt.GATE); });
	            laFunc = lookahead_1.buildLookaheadFuncForOr(occurrence, ruleGrammar, this.maxLookahead, hasPredicates, this.tokenMatcher, this.tokenClassIdentityFunc, this.tokenInstanceIdentityFunc, this.dynamicTokensEnabled);
	            this.classLAFuncs.put(key, laFunc);
	            return laFunc;
	        }
	        else {
	            return laFunc;
	        }
	    };
	    // Automatic lookahead calculation
	    Parser.prototype.getLookaheadFuncForOption = function (occurrence) {
	        var key = this.getKeyForAutomaticLookahead(OPTION_IDX, occurrence);
	        return this.getLookaheadFuncFor(key, occurrence, lookahead_1.buildLookaheadForOption, this.maxLookahead);
	    };
	    Parser.prototype.getLookaheadFuncForMany = function (occurrence) {
	        var key = this.getKeyForAutomaticLookahead(MANY_IDX, occurrence);
	        return this.getLookaheadFuncFor(key, occurrence, lookahead_1.buildLookaheadForMany, this.maxLookahead);
	    };
	    Parser.prototype.getLookaheadFuncForManySep = function (occurrence) {
	        var key = this.getKeyForAutomaticLookahead(MANY_SEP_IDX, occurrence);
	        return this.getLookaheadFuncFor(key, occurrence, lookahead_1.buildLookaheadForManySep, this.maxLookahead);
	    };
	    Parser.prototype.getLookaheadFuncForAtLeastOne = function (occurrence) {
	        var key = this.getKeyForAutomaticLookahead(AT_LEAST_ONE_IDX, occurrence);
	        return this.getLookaheadFuncFor(key, occurrence, lookahead_1.buildLookaheadForAtLeastOne, this.maxLookahead);
	    };
	    Parser.prototype.getLookaheadFuncForAtLeastOneSep = function (occurrence) {
	        var key = this.getKeyForAutomaticLookahead(AT_LEAST_ONE_SEP_IDX, occurrence);
	        return this.getLookaheadFuncFor(key, occurrence, lookahead_1.buildLookaheadForAtLeastOneSep, this.maxLookahead);
	    };
	    // TODO: consider caching the error message computed information
	    Parser.prototype.raiseNoAltException = function (occurrence, errMsgTypes) {
	        var errSuffix = "\nbut found: '" + tokens_public_1.getImage(this.LA(1)) + "'";
	        if (errMsgTypes === undefined) {
	            var ruleName = this.getCurrRuleFullName();
	            var ruleGrammar = this.getGAstProductions().get(ruleName);
	            // TODO: getLookaheadPathsForOr can be slow for large enough maxLookahead and certain grammars, consider caching ?
	            var lookAheadPathsPerAlternative = lookahead_1.getLookaheadPathsForOr(occurrence, ruleGrammar, this.maxLookahead);
	            var allLookAheadPaths = utils_1.reduce(lookAheadPathsPerAlternative, function (result, currAltPaths) { return result.concat(currAltPaths); }, []);
	            var nextValidTokenSequences = utils_1.map(allLookAheadPaths, function (currPath) {
	                return "[" + utils_1.map(currPath, function (currTokenClass) { return tokens_public_1.tokenLabel(currTokenClass); }).join(", ") + "]";
	            });
	            var nextValidSequenceItems = utils_1.map(nextValidTokenSequences, function (itemMsg, idx) { return "  " + (idx + 1) + ". " + itemMsg; });
	            errMsgTypes = "one of these possible Token sequences:\n" + nextValidSequenceItems.join("\n");
	        }
	        throw this.SAVE_ERROR(new exceptions_public_1.exceptions.NoViableAltException("Expecting: " + errMsgTypes + errSuffix, this.LA(1)));
	    };
	    Parser.prototype.getLookaheadFuncFor = function (key, occurrence, laFuncBuilder, maxLookahead) {
	        var laFunc = this.classLAFuncs.get(key);
	        if (laFunc === undefined) {
	            var ruleName = this.getCurrRuleFullName();
	            var ruleGrammar = this.getGAstProductions().get(ruleName);
	            laFunc = laFuncBuilder.apply(null, 
	            //TODO: change
	            [occurrence, ruleGrammar, maxLookahead, this.tokenMatcher,
	                this.tokenClassIdentityFunc, this.tokenInstanceIdentityFunc, this.dynamicTokensEnabled]);
	            this.classLAFuncs.put(key, laFunc);
	            return laFunc;
	        }
	        else {
	            return laFunc;
	        }
	    };
	    // TODO: consider caching the error message computed information
	    Parser.prototype.raiseEarlyExitException = function (occurrence, prodType, userDefinedErrMsg) {
	        var errSuffix = " but found: '" + tokens_public_1.getImage(this.LA(1)) + "'";
	        if (userDefinedErrMsg === undefined) {
	            var ruleName = this.getCurrRuleFullName();
	            var ruleGrammar = this.getGAstProductions().get(ruleName);
	            var lookAheadPathsPerAlternative = lookahead_1.getLookaheadPathsForOptionalProd(occurrence, ruleGrammar, prodType, this.maxLookahead);
	            var insideProdPaths = lookAheadPathsPerAlternative[0];
	            var nextValidTokenSequences = utils_1.map(insideProdPaths, function (currPath) {
	                return "[" + utils_1.map(currPath, function (currTokenClass) { return tokens_public_1.tokenLabel(currTokenClass); }).join(",") + "]";
	            });
	            userDefinedErrMsg = "expecting at least one iteration which starts with one of these possible Token sequences::\n  " +
	                ("<" + nextValidTokenSequences.join(" ,") + ">");
	        }
	        else {
	            userDefinedErrMsg = "Expecting at least one " + userDefinedErrMsg;
	        }
	        throw this.SAVE_ERROR(new exceptions_public_1.exceptions.EarlyExitException(userDefinedErrMsg + errSuffix, this.LA(1)));
	    };
	    return Parser;
	}());
	Parser.NO_RESYNC = false;
	// Set this flag to true if you don't want the Parser to throw error when problems in it's definition are detected.
	// (normally during the parser's constructor).
	// This is a design time flag, it will not affect the runtime error handling of the parser, just design time errors,
	// for example: duplicate rule names, referencing an unresolved subrule, ect...
	// This flag should not be enabled during normal usage, it is used in special situations, for example when
	// needing to display the parser definition errors in some GUI(online playground).
	Parser.DEFER_DEFINITION_ERRORS_HANDLING = false;
	exports.Parser = Parser;
	function InRuleRecoveryException(message) {
	    this.name = IN_RULE_RECOVERY_EXCEPTION;
	    this.message = message;
	}
	InRuleRecoveryException.prototype = Error.prototype;
	//# sourceMappingURL=parser_public.js.map

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * module used to cache static information about parsers,
	 */
	"use strict";
	var lang_extensions_1 = __webpack_require__(1015);
	var utils_1 = __webpack_require__(1016);
	exports.CLASS_TO_DEFINITION_ERRORS = new lang_extensions_1.HashTable();
	exports.CLASS_TO_SELF_ANALYSIS_DONE = new lang_extensions_1.HashTable();
	exports.CLASS_TO_GRAMMAR_PRODUCTIONS = new lang_extensions_1.HashTable();
	function getProductionsForClass(className) {
	    return getFromNestedHashTable(className, exports.CLASS_TO_GRAMMAR_PRODUCTIONS);
	}
	exports.getProductionsForClass = getProductionsForClass;
	exports.CLASS_TO_RESYNC_FOLLOW_SETS = new lang_extensions_1.HashTable();
	function getResyncFollowsForClass(className) {
	    return getFromNestedHashTable(className, exports.CLASS_TO_RESYNC_FOLLOW_SETS);
	}
	exports.getResyncFollowsForClass = getResyncFollowsForClass;
	function setResyncFollowsForClass(className, followSet) {
	    exports.CLASS_TO_RESYNC_FOLLOW_SETS.put(className, followSet);
	}
	exports.setResyncFollowsForClass = setResyncFollowsForClass;
	exports.CLASS_TO_LOOKAHEAD_FUNCS = new lang_extensions_1.HashTable();
	function getLookaheadFuncsForClass(className) {
	    return getFromNestedHashTable(className, exports.CLASS_TO_LOOKAHEAD_FUNCS);
	}
	exports.getLookaheadFuncsForClass = getLookaheadFuncsForClass;
	exports.CLASS_TO_FIRST_AFTER_REPETITION = new lang_extensions_1.HashTable();
	function getFirstAfterRepForClass(className) {
	    return getFromNestedHashTable(className, exports.CLASS_TO_FIRST_AFTER_REPETITION);
	}
	exports.getFirstAfterRepForClass = getFirstAfterRepForClass;
	exports.CLASS_TO_PRODUCTION_OVERRIDEN = new lang_extensions_1.HashTable();
	function getProductionOverriddenForClass(className) {
	    return getFromNestedHashTable(className, exports.CLASS_TO_PRODUCTION_OVERRIDEN);
	}
	exports.getProductionOverriddenForClass = getProductionOverriddenForClass;
	// TODO reflective test to verify this has not changed, for example (OPTION6 added)
	exports.MAX_OCCURRENCE_INDEX = 5;
	function getFromNestedHashTable(className, hashTable) {
	    var result = hashTable.get(className);
	    if (result === undefined) {
	        hashTable.put(className, new lang_extensions_1.HashTable());
	        result = hashTable.get(className);
	    }
	    return result;
	}
	function clearCache() {
	    var hasTables = utils_1.filter(utils_1.values(module.exports), function (currHashTable) { return currHashTable instanceof lang_extensions_1.HashTable; });
	    utils_1.forEach(hasTables, function (currHashTable) { return currHashTable.clear(); });
	}
	exports.clearCache = clearCache;
	//# sourceMappingURL=cache.js.map

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var utils = __webpack_require__(1016);
	var utils_1 = __webpack_require__(1016);
	function classNameFromInstance(instance) {
	    return functionName(instance.constructor);
	}
	exports.classNameFromInstance = classNameFromInstance;
	var FUNC_NAME_REGEXP = /^\s*function\s*(\S*)\s*\(/;
	var NAME = "name";
	exports.SPECIAL_NAME_CACHE_KEY = "CHEV_FUNC_NAME_CACHE666";
	/**
	 * Will Modify the func argument and define a 'name' property if none exists.
	 */
	/* istanbul ignore next too many hacks for IE/old versions of node.js here*/
	function functionName(func) {
	    // Engines that support Function.prototype.name OR the nth (n>1) time after
	    // the name has been computed in the following else block.
	    var existingNameProp = func.name;
	    if (existingNameProp) {
	        return existingNameProp;
	    }
	    // hack for IE and engines that do not support Object.defineProperty on function.name (Node.js 0.10 && 0.12)
	    var existingSpecialCacheNameProp = func[exports.SPECIAL_NAME_CACHE_KEY];
	    if (existingSpecialCacheNameProp) {
	        return existingSpecialCacheNameProp;
	    }
	    var computedName = func.toString().match(FUNC_NAME_REGEXP)[1];
	    if (!defineNameProp(func, computedName)) {
	        func[exports.SPECIAL_NAME_CACHE_KEY] = computedName;
	    }
	    return computedName;
	}
	exports.functionName = functionName;
	/**
	 * @returns {boolean} - has the property been successfully defined
	 */
	function defineNameProp(obj, nameValue) {
	    var namePropDescriptor = Object.getOwnPropertyDescriptor(obj, NAME);
	    /* istanbul ignore else -> will only run in old versions of node.js */
	    if (utils_1.isUndefined(namePropDescriptor) ||
	        namePropDescriptor.configurable) {
	        Object.defineProperty(obj, NAME, {
	            enumerable: false,
	            configurable: true,
	            writable: false,
	            value: nameValue
	        });
	        return true;
	    }
	    /* istanbul ignore next -> will only run in old versions of node.js */
	    return false;
	}
	exports.defineNameProp = defineNameProp;
	/**
	 * simple Hashtable between a string and some generic value
	 * this should be removed once typescript supports ES6 style Hashtable
	 */
	var HashTable = (function () {
	    function HashTable() {
	        this._state = {};
	    }
	    HashTable.prototype.keys = function () {
	        return utils.keys(this._state);
	    };
	    HashTable.prototype.values = function () {
	        return utils.values(this._state);
	    };
	    HashTable.prototype.put = function (key, value) {
	        this._state[key] = value;
	    };
	    HashTable.prototype.putAll = function (other) {
	        this._state = utils.assign(this._state, other._state);
	    };
	    HashTable.prototype.get = function (key) {
	        // To avoid edge case with a key called "hasOwnProperty" we need to perform the commented out check below
	        // -> if (Object.prototype.hasOwnProperty.call(this._state, key)) { ... } <-
	        // however this costs nearly 25% of the parser's runtime.
	        // if someone decides to name their Parser class "hasOwnProperty" they deserve what they will get :)
	        return this._state[key];
	    };
	    HashTable.prototype.containsKey = function (key) {
	        return utils.has(this._state, key);
	    };
	    HashTable.prototype.clear = function () {
	        this._state = {};
	    };
	    return HashTable;
	}());
	exports.HashTable = HashTable;
	//# sourceMappingURL=lang_extensions.js.map

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 Utils using lodash style API. (not necessarily 100% compliant) for functional and other utils.
	 These utils should replace usage of lodash in the production code base. not because they are any better...
	 but for the purpose of being a dependency free library.
	
	 The hotspots in the code are already written in imperative style for performance reasons.
	 so writing several dozen utils which may be slower than the original lodash, does not matter as much
	 considering they will not be invoked in hotspots...
	 */
	function isEmpty(arr) {
	    return arr && arr.length === 0;
	}
	exports.isEmpty = isEmpty;
	function keys(obj) {
	    return Object.keys(obj);
	}
	exports.keys = keys;
	function values(obj) {
	    var vals = [];
	    var keys = Object.keys(obj);
	    for (var i = 0; i < keys.length; i++) {
	        vals.push(obj[keys[i]]);
	    }
	    return vals;
	}
	exports.values = values;
	function mapValues(obj, callback) {
	    var result = [];
	    var objKeys = keys(obj);
	    for (var idx = 0; idx < objKeys.length; idx++) {
	        var currKey = objKeys[idx];
	        result.push(callback.call(null, obj[currKey], currKey));
	    }
	    return result;
	}
	exports.mapValues = mapValues;
	function map(arr, callback) {
	    var result = [];
	    for (var idx = 0; idx < arr.length; idx++) {
	        result.push(callback.call(null, arr[idx], idx));
	    }
	    return result;
	}
	exports.map = map;
	function flatten(arr) {
	    var result = [];
	    for (var idx = 0; idx < arr.length; idx++) {
	        var currItem = arr[idx];
	        if (Array.isArray(currItem)) {
	            result = result.concat(flatten(currItem));
	        }
	        else {
	            result.push(currItem);
	        }
	    }
	    return result;
	}
	exports.flatten = flatten;
	function first(arr) {
	    return isEmpty(arr) ? undefined : arr[0];
	}
	exports.first = first;
	function last(arr) {
	    var len = arr && arr.length;
	    return len ? arr[len - 1] : undefined;
	}
	exports.last = last;
	function forEach(collection, iteratorCallback) {
	    if (Array.isArray(collection)) {
	        for (var i = 0; i < collection.length; i++) {
	            iteratorCallback.call(null, collection[i], i);
	        }
	    }
	    else if (isObject(collection)) {
	        var colKeys = keys(collection);
	        for (var i = 0; i < colKeys.length; i++) {
	            var key = colKeys[i];
	            var value = collection[key];
	            iteratorCallback.call(null, value, key);
	        }
	    }
	    else {
	        /* istanbul ignore next */ throw Error("non exhaustive match");
	    }
	}
	exports.forEach = forEach;
	function isString(item) {
	    return typeof item === "string";
	}
	exports.isString = isString;
	function isUndefined(item) {
	    return item === undefined;
	}
	exports.isUndefined = isUndefined;
	function isFunction(item) {
	    return item instanceof Function;
	}
	exports.isFunction = isFunction;
	function drop(arr, howMuch) {
	    if (howMuch === void 0) { howMuch = 1; }
	    return arr.slice(howMuch, arr.length);
	}
	exports.drop = drop;
	function dropRight(arr, howMuch) {
	    if (howMuch === void 0) { howMuch = 1; }
	    return arr.slice(0, arr.length - howMuch);
	}
	exports.dropRight = dropRight;
	function filter(arr, predicate) {
	    var result = [];
	    if (Array.isArray(arr)) {
	        for (var i = 0; i < arr.length; i++) {
	            var item = arr[i];
	            if (predicate.call(null, item)) {
	                result.push(item);
	            }
	        }
	    }
	    return result;
	}
	exports.filter = filter;
	function reject(arr, predicate) {
	    return filter(arr, function (item) { return !predicate(item); });
	}
	exports.reject = reject;
	function pick(obj, predicate) {
	    var keys = Object.keys(obj);
	    var result = {};
	    for (var i = 0; i < keys.length; i++) {
	        var currKey = keys[i];
	        var currItem = obj[currKey];
	        if (predicate(currItem)) {
	            result[currKey] = currItem;
	        }
	    }
	    return result;
	}
	exports.pick = pick;
	function has(obj, prop) {
	    if (isObject(obj)) {
	        return obj.hasOwnProperty(prop);
	    }
	    return false;
	}
	exports.has = has;
	function contains(arr, item) {
	    return find(arr, function (currItem) { return currItem === item; }) !== undefined ? true : false;
	}
	exports.contains = contains;
	/**
	 * shallow clone
	 */
	function cloneArr(arr) {
	    var newArr = [];
	    for (var i = 0; i < arr.length; i++) {
	        newArr.push(arr[i]);
	    }
	    return newArr;
	}
	exports.cloneArr = cloneArr;
	/**
	 * shallow clone
	 */
	function cloneObj(obj) {
	    var clonedObj = {};
	    for (var key in obj) {
	        /* istanbul ignore else */
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            clonedObj[key] = obj[key];
	        }
	    }
	    return clonedObj;
	}
	exports.cloneObj = cloneObj;
	function find(arr, predicate) {
	    for (var i = 0; i < arr.length; i++) {
	        var item = arr[i];
	        if (predicate.call(null, item)) {
	            return item;
	        }
	    }
	    return undefined;
	}
	exports.find = find;
	function reduce(arrOrObj, iterator, initial) {
	    var vals = Array.isArray(arrOrObj) ? arrOrObj : values(arrOrObj);
	    var accumulator = initial;
	    for (var i = 0; i < vals.length; i++) {
	        accumulator = iterator.call(null, accumulator, vals[i], i);
	    }
	    return accumulator;
	}
	exports.reduce = reduce;
	function compact(arr) {
	    return reject(arr, function (item) { return item === null || item === undefined; });
	}
	exports.compact = compact;
	function uniq(arr, identity) {
	    if (identity === void 0) { identity = function (item) { return item; }; }
	    var identities = [];
	    return reduce(arr, function (result, currItem) {
	        var currIdentity = identity(currItem);
	        if (contains(identities, currIdentity)) {
	            return result;
	        }
	        else {
	            identities.push(currIdentity);
	            return result.concat(currItem);
	        }
	    }, []);
	}
	exports.uniq = uniq;
	function partial(func) {
	    var restArgs = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        restArgs[_i - 1] = arguments[_i];
	    }
	    var firstArg = [null];
	    var allArgs = firstArg.concat(restArgs);
	    return Function.bind.apply(func, allArgs);
	}
	exports.partial = partial;
	function isArray(obj) {
	    return Array.isArray(obj);
	}
	exports.isArray = isArray;
	function isRegExp(obj) {
	    return obj instanceof RegExp;
	}
	exports.isRegExp = isRegExp;
	function isObject(obj) {
	    return obj instanceof Object;
	}
	exports.isObject = isObject;
	function every(arr, predicate) {
	    for (var i = 0; i < arr.length; i++) {
	        if (!predicate(arr[i], i)) {
	            return false;
	        }
	    }
	    return true;
	}
	exports.every = every;
	function difference(arr, values) {
	    return reject(arr, function (item) { return contains(values, item); });
	}
	exports.difference = difference;
	function some(arr, predicate) {
	    for (var i = 0; i < arr.length; i++) {
	        if (predicate(arr[i])) {
	            return true;
	        }
	    }
	    return false;
	}
	exports.some = some;
	function indexOf(arr, value) {
	    for (var i = 0; i < arr.length; i++) {
	        if (arr[i] === value) {
	            return i;
	        }
	    }
	    return -1;
	}
	exports.indexOf = indexOf;
	function sortBy(arr, orderFunc) {
	    var result = cloneArr(arr);
	    result.sort(function (a, b) { return orderFunc(a) - orderFunc(b); });
	    return result;
	}
	exports.sortBy = sortBy;
	function zipObject(keys, values) {
	    if (keys.length !== values.length) {
	        throw Error("can't zipObject with different number of keys and values!");
	    }
	    var result = {};
	    for (var i = 0; i < keys.length; i++) {
	        result[keys[i]] = values[i];
	    }
	    return result;
	}
	exports.zipObject = zipObject;
	/**
	 * mutates! (and returns) target
	 */
	function assign(target) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    for (var i = 0; i < sources.length; i++) {
	        var curSource = sources[i];
	        var currSourceKeys = keys(curSource);
	        for (var j = 0; j < currSourceKeys.length; j++) {
	            var currKey = currSourceKeys[j];
	            target[currKey] = curSource[currKey];
	        }
	    }
	    return target;
	}
	exports.assign = assign;
	/**
	 * mutates! (and returns) target
	 */
	function assignNoOverwrite(target) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    for (var i = 0; i < sources.length; i++) {
	        var curSource = sources[i];
	        var currSourceKeys = keys(curSource);
	        for (var j = 0; j < currSourceKeys.length; j++) {
	            var currKey = currSourceKeys[j];
	            if (!has(target, currKey)) {
	                target[currKey] = curSource[currKey];
	            }
	        }
	    }
	    return target;
	}
	exports.assignNoOverwrite = assignNoOverwrite;
	function groupBy(arr, groupKeyFunc) {
	    var result = {};
	    forEach(arr, function (item) {
	        var currGroupKey = groupKeyFunc(item);
	        var currGroupArr = result[currGroupKey];
	        if (currGroupArr) {
	            currGroupArr.push(item);
	        }
	        else {
	            result[currGroupKey] = [item];
	        }
	    });
	    return result;
	}
	exports.groupBy = groupBy;
	/**
	 * Merge obj2 into obj1.
	 * Will overwrite existing properties with the same name
	 */
	function merge(obj1, obj2) {
	    var result = cloneObj(obj1);
	    var keys2 = keys(obj2);
	    for (var i = 0; i < keys2.length; i++) {
	        var key = keys2[i];
	        var value = obj2[key];
	        result[key] = value;
	    }
	    return result;
	}
	exports.merge = merge;
	function NOOP() { }
	exports.NOOP = NOOP;
	function getSuperClass(clazz) {
	    return Object.getPrototypeOf(clazz.prototype).constructor;
	}
	exports.getSuperClass = getSuperClass;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var utils_1 = __webpack_require__(1016);
	var exceptions;
	(function (exceptions) {
	    var MISMATCHED_TOKEN_EXCEPTION = "MismatchedTokenException";
	    var NO_VIABLE_ALT_EXCEPTION = "NoViableAltException";
	    var EARLY_EXIT_EXCEPTION = "EarlyExitException";
	    var NOT_ALL_INPUT_PARSED_EXCEPTION = "NotAllInputParsedException";
	    var RECOGNITION_EXCEPTION_NAMES = [
	        MISMATCHED_TOKEN_EXCEPTION,
	        NO_VIABLE_ALT_EXCEPTION,
	        EARLY_EXIT_EXCEPTION,
	        NOT_ALL_INPUT_PARSED_EXCEPTION
	    ];
	    Object.freeze(RECOGNITION_EXCEPTION_NAMES);
	    // hacks to bypass no support for custom Errors in javascript/typescript
	    function isRecognitionException(error) {
	        // can't do instanceof on hacked custom js exceptions
	        return utils_1.contains(RECOGNITION_EXCEPTION_NAMES, error.name);
	    }
	    exceptions.isRecognitionException = isRecognitionException;
	    function MismatchedTokenException(message, token) {
	        this.name = MISMATCHED_TOKEN_EXCEPTION;
	        this.message = message;
	        this.token = token;
	        this.resyncedTokens = [];
	    }
	    exceptions.MismatchedTokenException = MismatchedTokenException;
	    // must use the "Error.prototype" instead of "new Error"
	    // because the stack trace points to where "new Error" was invoked"
	    MismatchedTokenException.prototype = Error.prototype;
	    function NoViableAltException(message, token) {
	        this.name = NO_VIABLE_ALT_EXCEPTION;
	        this.message = message;
	        this.token = token;
	        this.resyncedTokens = [];
	    }
	    exceptions.NoViableAltException = NoViableAltException;
	    NoViableAltException.prototype = Error.prototype;
	    function NotAllInputParsedException(message, token) {
	        this.name = NOT_ALL_INPUT_PARSED_EXCEPTION;
	        this.message = message;
	        this.token = token;
	        this.resyncedTokens = [];
	    }
	    exceptions.NotAllInputParsedException = NotAllInputParsedException;
	    NotAllInputParsedException.prototype = Error.prototype;
	    function EarlyExitException(message, token) {
	        this.name = EARLY_EXIT_EXCEPTION;
	        this.message = message;
	        this.token = token;
	        this.resyncedTokens = [];
	    }
	    exceptions.EarlyExitException = EarlyExitException;
	    EarlyExitException.prototype = Error.prototype;
	})(exceptions = exports.exceptions || (exports.exceptions = {}));
	//# sourceMappingURL=exceptions_public.js.map

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) /* istanbul ignore next */  if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    /* istanbul ignore next */  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var parser_public_1 = __webpack_require__(1013);
	var gast_public_1 = __webpack_require__(1019);
	var utils_1 = __webpack_require__(1016);
	function resolveGrammar(topLevels) {
	    var refResolver = new GastRefResolverVisitor(topLevels);
	    refResolver.resolveRefs();
	    return refResolver.errors;
	}
	exports.resolveGrammar = resolveGrammar;
	var GastRefResolverVisitor = (function (_super) {
	    __extends(GastRefResolverVisitor, _super);
	    function GastRefResolverVisitor(nameToTopRule) {
	        var _this = _super.call(this) || this;
	        _this.nameToTopRule = nameToTopRule;
	        _this.errors = [];
	        return _this;
	    }
	    GastRefResolverVisitor.prototype.resolveRefs = function () {
	        var _this = this;
	        utils_1.forEach(this.nameToTopRule.values(), function (prod) {
	            _this.currTopLevel = prod;
	            prod.accept(_this);
	        });
	    };
	    GastRefResolverVisitor.prototype.visitNonTerminal = function (node) {
	        var ref = this.nameToTopRule.get(node.nonTerminalName);
	        if (!ref) {
	            var msg = "Invalid grammar, reference to a rule which is not defined: ->" + node.nonTerminalName + "<-\n" +
	                "inside top level rule: ->" + this.currTopLevel.name + "<-";
	            this.errors.push({
	                message: msg,
	                type: parser_public_1.ParserDefinitionErrorType.UNRESOLVED_SUBRULE_REF,
	                ruleName: this.currTopLevel.name,
	                unresolvedRefName: node.nonTerminalName
	            });
	        }
	        else {
	            node.referencedRule = ref;
	        }
	    };
	    return GastRefResolverVisitor;
	}(gast_public_1.gast.GAstVisitor));
	exports.GastRefResolverVisitor = GastRefResolverVisitor;
	//# sourceMappingURL=resolver.js.map

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) /* istanbul ignore next */  if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    /* istanbul ignore next */  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var utils_1 = __webpack_require__(1016);
	var tokens_public_1 = __webpack_require__(1020);
	var gast;
	(function (gast) {
	    var AbstractProduction = (function () {
	        function AbstractProduction(definition) {
	            this.definition = definition;
	            this.implicitOccurrenceIndex = false;
	        }
	        AbstractProduction.prototype.accept = function (visitor) {
	            visitor.visit(this);
	            utils_1.forEach(this.definition, function (prod) {
	                prod.accept(visitor);
	            });
	        };
	        return AbstractProduction;
	    }());
	    gast.AbstractProduction = AbstractProduction;
	    var NonTerminal = (function (_super) {
	        __extends(NonTerminal, _super);
	        function NonTerminal(nonTerminalName, referencedRule, occurrenceInParent) {
	            if (referencedRule === void 0) { referencedRule = undefined; }
	            if (occurrenceInParent === void 0) { occurrenceInParent = 1; }
	            var _this = _super.call(this, []) /* istanbul ignore next */ || this;
	            _this.nonTerminalName = nonTerminalName;
	            _this.referencedRule = referencedRule;
	            _this.occurrenceInParent = occurrenceInParent;
	            return _this;
	        }
	        Object.defineProperty(NonTerminal.prototype, "definition", {
	            get: function () {
	                if (this.referencedRule !== undefined) {
	                    return this.referencedRule.definition;
	                }
	                return [];
	            },
	            set: function (definition) {
	                // immutable
	            },
	            enumerable: true,
	            configurable: true
	        });
	        NonTerminal.prototype.accept = function (visitor) {
	            visitor.visit(this);
	            // don't visit children of a reference, we will get cyclic infinite loops if we do so
	        };
	        return NonTerminal;
	    }(AbstractProduction));
	    gast.NonTerminal = NonTerminal;
	    var Rule = (function (_super) {
	        __extends(Rule, _super);
	        function Rule(name, definition, orgText) {
	            if (orgText === void 0) { orgText = ""; }
	            var _this = _super.call(this, definition) /* istanbul ignore next */ || this;
	            _this.name = name;
	            _this.orgText = orgText;
	            return _this;
	        }
	        return Rule;
	    }(AbstractProduction));
	    gast.Rule = Rule;
	    var Flat = (function (_super) {
	        __extends(Flat, _super);
	        function Flat(definition) {
	            return _super.call(this, definition) /* istanbul ignore next */ || this;
	        }
	        return Flat;
	    }(AbstractProduction));
	    gast.Flat = Flat;
	    var Option = (function (_super) {
	        __extends(Option, _super);
	        function Option(definition, occurrenceInParent) {
	            if (occurrenceInParent === void 0) { occurrenceInParent = 1; }
	            var _this = _super.call(this, definition) /* istanbul ignore next */ || this;
	            _this.occurrenceInParent = occurrenceInParent;
	            return _this;
	        }
	        return Option;
	    }(AbstractProduction));
	    gast.Option = Option;
	    var RepetitionMandatory = (function (_super) {
	        __extends(RepetitionMandatory, _super);
	        function RepetitionMandatory(definition, occurrenceInParent) {
	            if (occurrenceInParent === void 0) { occurrenceInParent = 1; }
	            var _this = _super.call(this, definition) /* istanbul ignore next */ || this;
	            _this.occurrenceInParent = occurrenceInParent;
	            return _this;
	        }
	        return RepetitionMandatory;
	    }(AbstractProduction));
	    gast.RepetitionMandatory = RepetitionMandatory;
	    var RepetitionMandatoryWithSeparator = (function (_super) {
	        __extends(RepetitionMandatoryWithSeparator, _super);
	        function RepetitionMandatoryWithSeparator(definition, separator, occurrenceInParent) {
	            if (occurrenceInParent === void 0) { occurrenceInParent = 1; }
	            var _this = _super.call(this, definition) /* istanbul ignore next */ || this;
	            _this.separator = separator;
	            _this.occurrenceInParent = occurrenceInParent;
	            return _this;
	        }
	        return RepetitionMandatoryWithSeparator;
	    }(AbstractProduction));
	    gast.RepetitionMandatoryWithSeparator = RepetitionMandatoryWithSeparator;
	    var Repetition = (function (_super) {
	        __extends(Repetition, _super);
	        function Repetition(definition, occurrenceInParent) {
	            if (occurrenceInParent === void 0) { occurrenceInParent = 1; }
	            var _this = _super.call(this, definition) /* istanbul ignore next */ || this;
	            _this.occurrenceInParent = occurrenceInParent;
	            return _this;
	        }
	        return Repetition;
	    }(AbstractProduction));
	    gast.Repetition = Repetition;
	    var RepetitionWithSeparator = (function (_super) {
	        __extends(RepetitionWithSeparator, _super);
	        function RepetitionWithSeparator(definition, separator, occurrenceInParent) {
	            if (occurrenceInParent === void 0) { occurrenceInParent = 1; }
	            var _this = _super.call(this, definition) /* istanbul ignore next */ || this;
	            _this.separator = separator;
	            _this.occurrenceInParent = occurrenceInParent;
	            return _this;
	        }
	        return RepetitionWithSeparator;
	    }(AbstractProduction));
	    gast.RepetitionWithSeparator = RepetitionWithSeparator;
	    var Alternation = (function (_super) {
	        __extends(Alternation, _super);
	        function Alternation(definition, occurrenceInParent) {
	            if (occurrenceInParent === void 0) { occurrenceInParent = 1; }
	            var _this = _super.call(this, definition) /* istanbul ignore next */ || this;
	            _this.occurrenceInParent = occurrenceInParent;
	            return _this;
	        }
	        return Alternation;
	    }(AbstractProduction));
	    gast.Alternation = Alternation;
	    var Terminal = (function () {
	        function Terminal(terminalType, occurrenceInParent) {
	            if (occurrenceInParent === void 0) { occurrenceInParent = 1; }
	            this.terminalType = terminalType;
	            this.occurrenceInParent = occurrenceInParent;
	            this.implicitOccurrenceIndex = false;
	        }
	        Terminal.prototype.accept = function (visitor) {
	            visitor.visit(this);
	        };
	        return Terminal;
	    }());
	    gast.Terminal = Terminal;
	    var GAstVisitor = (function () {
	        function GAstVisitor() {
	        }
	        GAstVisitor.prototype.visit = function (node) {
	            if (node instanceof NonTerminal) {
	                return this.visitNonTerminal(node);
	            }
	            else if (node instanceof Flat) {
	                return this.visitFlat(node);
	            }
	            else if (node instanceof Option) {
	                return this.visitOption(node);
	            }
	            else if (node instanceof RepetitionMandatory) {
	                return this.visitRepetitionMandatory(node);
	            }
	            else if (node instanceof RepetitionMandatoryWithSeparator) {
	                return this.visitRepetitionMandatoryWithSeparator(node);
	            }
	            else if (node instanceof RepetitionWithSeparator) {
	                return this.visitRepetitionWithSeparator(node);
	            }
	            else if (node instanceof Repetition) {
	                return this.visitRepetition(node);
	            }
	            else if (node instanceof Alternation) {
	                return this.visitAlternation(node);
	            }
	            else if (node instanceof Terminal) {
	                return this.visitTerminal(node);
	            }/* istanbul ignore else */ 
	            else if (node instanceof Rule) {
	                return this.visitRule(node);
	            }
	            else {
	                /* istanbul ignore next */ throw Error("non exhaustive match");
	            }
	        };
	        GAstVisitor.prototype.visitNonTerminal = function (node) { };
	        GAstVisitor.prototype.visitFlat = function (node) { };
	        GAstVisitor.prototype.visitOption = function (node) { };
	        GAstVisitor.prototype.visitRepetition = function (node) { };
	        GAstVisitor.prototype.visitRepetitionMandatory = function (node) { };
	        GAstVisitor.prototype.visitRepetitionMandatoryWithSeparator = function (node) { };
	        GAstVisitor.prototype.visitRepetitionWithSeparator = function (node) { };
	        GAstVisitor.prototype.visitAlternation = function (node) { };
	        GAstVisitor.prototype.visitTerminal = function (node) { };
	        GAstVisitor.prototype.visitRule = function (node) { };
	        return GAstVisitor;
	    }());
	    gast.GAstVisitor = GAstVisitor;
	    function serializeGrammar(topRules) {
	        return utils_1.map(topRules, serializeProduction);
	    }
	    gast.serializeGrammar = serializeGrammar;
	    function serializeProduction(node) {
	        function convertDefinition(definition) {
	            return utils_1.map(definition, serializeProduction);
	        }
	        if (node instanceof NonTerminal) {
	            return {
	                type: "NonTerminal",
	                name: node.nonTerminalName,
	                occurrenceInParent: node.occurrenceInParent
	            };
	        }
	        else if (node instanceof Flat) {
	            return {
	                type: "Flat",
	                definition: convertDefinition(node.definition)
	            };
	        }
	        else if (node instanceof Option) {
	            return {
	                type: "Option",
	                definition: convertDefinition(node.definition)
	            };
	        }
	        else if (node instanceof RepetitionMandatory) {
	            return {
	                type: "RepetitionMandatory",
	                definition: convertDefinition(node.definition)
	            };
	        }
	        else if (node instanceof RepetitionMandatoryWithSeparator) {
	            return {
	                type: "RepetitionMandatoryWithSeparator",
	                separator: serializeProduction(new Terminal(node.separator)),
	                definition: convertDefinition(node.definition)
	            };
	        }
	        else if (node instanceof RepetitionWithSeparator) {
	            return {
	                type: "RepetitionWithSeparator",
	                separator: serializeProduction(new Terminal(node.separator)),
	                definition: convertDefinition(node.definition)
	            };
	        }
	        else if (node instanceof Repetition) {
	            return {
	                type: "Repetition",
	                definition: convertDefinition(node.definition)
	            };
	        }
	        else if (node instanceof Alternation) {
	            return {
	                type: "Alternation",
	                definition: convertDefinition(node.definition)
	            };
	        }
	        else if (node instanceof Terminal) {
	            var serializedTerminal = {
	                type: "Terminal",
	                name: tokens_public_1.tokenName(node.terminalType),
	                label: tokens_public_1.tokenLabel(node.terminalType),
	                occurrenceInParent: node.occurrenceInParent
	            };
	            if (node.terminalType.PATTERN) {
	                serializedTerminal.pattern = node.terminalType.PATTERN.source;
	            }
	            return serializedTerminal;
	        }/* istanbul ignore else */ 
	        else if (node instanceof Rule) {
	            return { type: "Rule", name: node.name, definition: convertDefinition(node.definition) };
	        }
	        else {
	            /* istanbul ignore next */ throw Error("non exhaustive match");
	        }
	    }
	    gast.serializeProduction = serializeProduction;
	})(gast = exports.gast || (exports.gast = {}));
	//# sourceMappingURL=gast_public.js.map

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) /* istanbul ignore next */  if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    /* istanbul ignore next */  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var utils_1 = __webpack_require__(1016);
	var lang_extensions_1 = __webpack_require__(1015);
	var lexer_public_1 = __webpack_require__(1021);
	var tokens_1 = __webpack_require__(1023);
	/**
	 *  This can be used to improve the quality/readability of error messages or syntax diagrams.
	 *
	 * @param {Function} clazz - A constructor for a Token subclass
	 * @returns {string} - The Human readable label for a Token if it exists.
	 */
	function tokenLabel(clazz) {
	    if (hasTokenLabel(clazz)) {
	        return clazz.LABEL;
	    }
	    else {
	        return tokenName(clazz);
	    }
	}
	exports.tokenLabel = tokenLabel;
	function hasTokenLabel(clazz) {
	    return utils_1.isString(clazz.LABEL) && clazz.LABEL !== "";
	}
	exports.hasTokenLabel = hasTokenLabel;
	function tokenName(clazz) {
	    // The tokenName property is needed under some old versions of node.js (0.10/0.12)
	    // where the Function.prototype.name property is not defined as a 'configurable' property
	    // enable producing readable error messages.
	    /* istanbul ignore if -> will only run in old versions of node.js */
	    if (utils_1.isString(clazz.tokenName)) {
	        return clazz.tokenName;
	    }
	    else {
	        return lang_extensions_1.functionName(clazz);
	    }
	}
	exports.tokenName = tokenName;
	var PARENT = "parent";
	var LABEL = "label";
	var GROUP = "group";
	var PUSH_MODE = "push_mode";
	var POP_MODE = "pop_mode";
	var LONGER_ALT = "longer_alt";
	/**
	 * @param {ITokenConfig} config - The configuration for
	 * @returns {TokenConstructor} - A constructor for the new Token subclass
	 */
	function createToken(config) {
	    if (!utils_1.has(config, PARENT)) {
	        config.parent = Token;
	    }
	    return createTokenInternal(config);
	}
	exports.createToken = createToken;
	/**
	 * Convenience method equivalent to: createToken({parent:LazyToken})
	 * @see createToken
	 */
	function createLazyToken(config) {
	    if (!utils_1.has(config, PARENT)) {
	        config.parent = LazyToken;
	    }
	    return createTokenInternal(config);
	}
	exports.createLazyToken = createLazyToken;
	/**
	 * Convenience method equivalent to: createToken({parent:SimpleLazyToken})
	 * @see createToken
	 */
	function createSimpleLazyToken(config) {
	    if (!utils_1.has(config, PARENT)) {
	        config.parent = SimpleLazyToken;
	    }
	    return createTokenInternal(config);
	}
	exports.createSimpleLazyToken = createSimpleLazyToken;
	/**
	 * @deprecated - - Use the new CreateSimpleLazyToken API
	 */
	function extendLazyToken(tokenName, patternOrParent, parentConstructor) {
	    if (patternOrParent === void 0) { patternOrParent = undefined; }
	    if (parentConstructor === void 0) { parentConstructor = LazyToken; }
	    return extendToken(tokenName, patternOrParent, parentConstructor);
	}
	exports.extendLazyToken = extendLazyToken;
	/**
	 * @deprecated - Use the new CreateSimpleLazyToken API
	 */
	function extendSimpleLazyToken(tokenName, patternOrParent, parentConstructor) {
	    if (patternOrParent === void 0) { patternOrParent = undefined; }
	    if (parentConstructor === void 0) { parentConstructor = SimpleLazyToken; }
	    return extendToken(tokenName, patternOrParent, parentConstructor);
	}
	exports.extendSimpleLazyToken = extendSimpleLazyToken;
	/**
	 *
	 * @deprecated - Use the new CreateToken API
	 *
	 * utility to help the poor souls who are still stuck writing pure javascript 5.1
	 * extend and create Token subclasses in a less verbose manner
	 *
	 * @param {string} tokenName - The name of the new TokenClass
	 * @param {RegExp|CustomPatternMatcherFunc|Function} patternOrParent - RegExp Pattern or Parent Token Constructor
	 * @param {Function} parentConstructor - The Token class to be extended
	 * @returns {Function} - A constructor for the new extended Token subclass
	 */
	function extendToken(tokenName, patternOrParent, parentConstructor) {
	    if (patternOrParent === void 0) { patternOrParent = undefined; }
	    if (parentConstructor === void 0) { parentConstructor = Token; }
	    var pattern;
	    if (utils_1.isRegExp(patternOrParent) ||
	        patternOrParent === lexer_public_1.Lexer.SKIPPED ||
	        patternOrParent === lexer_public_1.Lexer.NA) {
	        pattern = patternOrParent;
	    }
	    else if (utils_1.isFunction(patternOrParent)) {
	        parentConstructor = patternOrParent;
	        pattern = undefined;
	    }
	    return createTokenInternal({ name: tokenName, parent: parentConstructor, pattern: pattern });
	}
	exports.extendToken = extendToken;
	function createTokenInternal(config) {
	    var tokenName = config.name;
	    var parentConstructor = config.parent;
	    var pattern = config.pattern;
	    var derivedConstructor = function () {
	        parentConstructor.apply(this, arguments);
	    };
	    // can be overwritten according to:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/
	    // name?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FFunction%2Fname
	    /* istanbul ignore if -> will only run in old versions of node.js */
	    if (!lang_extensions_1.defineNameProp(derivedConstructor, tokenName)) {
	        // hack to save the tokenName in situations where the constructor's name property cannot be reconfigured
	        derivedConstructor.tokenName = tokenName;
	    }
	    derivedConstructor.prototype = Object.create(parentConstructor.prototype);
	    derivedConstructor.prototype.constructor = derivedConstructor;
	    if (!utils_1.isUndefined(pattern)) {
	        derivedConstructor.PATTERN = pattern;
	    }
	    tokens_1.augmentTokenClasses([derivedConstructor]);
	    // static properties mixing
	    derivedConstructor = utils_1.assignNoOverwrite(derivedConstructor, parentConstructor);
	    if (utils_1.has(config, LABEL)) {
	        derivedConstructor.LABEL = config[LABEL];
	    }
	    if (utils_1.has(config, GROUP)) {
	        derivedConstructor.GROUP = config[GROUP];
	    }
	    if (utils_1.has(config, POP_MODE)) {
	        derivedConstructor.POP_MODE = config[POP_MODE];
	    }
	    if (utils_1.has(config, PUSH_MODE)) {
	        derivedConstructor.PUSH_MODE = config[PUSH_MODE];
	    }
	    if (utils_1.has(config, LONGER_ALT)) {
	        derivedConstructor.LONGER_ALT = config[LONGER_ALT];
	    }
	    return derivedConstructor;
	}
	var Token = (function () {
	    /**
	     * @param {string} image - The textual representation of the Token as it appeared in the text.
	     * @param {number} startOffset - Offset of the first character of the Token.
	     * @param {number} startLine - Line of the first character of the Token.
	     * @param {number} startColumn - Column of the first character of the Token.
	     * @param {number} endLine - Line of the last character of the Token.
	     * @param {number} endColumn - Column of the last character of the Token.
	     */
	    function Token(image, startOffset, startLine, startColumn, endLine, endColumn) {
	        if (endLine === void 0) { endLine = startLine; }
	        if (endColumn === void 0) { endColumn = startColumn + image.length - 1; }
	        this.image = image;
	        this.startOffset = startOffset;
	        this.startLine = startLine;
	        this.startColumn = startColumn;
	        this.endLine = endLine;
	        this.endColumn = endColumn;
	        // this marks if a Token does not really exist and has been inserted "artificially" during parsing in rule error recovery
	        this.isInsertedInRecovery = false;
	    }
	    Object.defineProperty(Token.prototype, "endOffset", {
	        get: function () {
	            return this.startOffset + this.image.length - 1;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Token.prototype, "offset", {
	        /**
	         * @deprecated
	         * An Alias for getting the startOffset. this is deprecated and remains only to be backwards compatiable.
	         * This API will be removed in future version of Chevrotain.
	         */
	        get: function () {
	            return this.startOffset;
	        },
	        /**
	         * @deprecated
	         * An Alias for setting the startOffset. this is deprecated and remains only to be backwards compatiable.
	         * This API will be removed in future version of Chevrotain.
	         */
	        set: function (newOffset) {
	            this.startOffset = newOffset;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Token;
	}());
	/**
	 * A "human readable" Label for a Token.
	 * Subclasses of Token may define their own static LABEL property.
	 * This label will be used in error messages and drawing syntax diagrams.
	 *
	 * For example a Token constructor may be called LCurly, which is short for LeftCurlyBrackets, These names are either too short
	 * or too unwieldy to be used in error messages.
	 *
	 * Imagine : "expecting LCurly but found ')'" or "expecting LeftCurlyBrackets but found ')'"
	 *
	 * However if a static property LABEL with the value '{' exists on LCurly class, that error message will be:
	 * "expecting '{' but found ')'"
	 */
	Token.LABEL = undefined;
	exports.Token = Token;
	/**
	 * @see IToken
	 * @see Token
	 *
	 * Same API as a IToken, using a Lazy implementation, with most properties being immutable.
	 * See related doc in: https://github.com/SAP/chevrotain/blob/startO/docs/faq.md#-how-do-i-maximize-my-parsers-performance
	 * ("Use Lazy Tokens" section)
	 */
	var LazyToken = (function () {
	    function LazyToken(startOffset, endOffset, cacheData) {
	        this.startOffset = startOffset;
	        this.endOffset = endOffset;
	        this.cacheData = cacheData;
	    }
	    Object.defineProperty(LazyToken.prototype, "image", {
	        get: function () {
	            return tokens_1.getImageFromLazyToken(this);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(LazyToken.prototype, "startLine", {
	        get: function () {
	            return tokens_1.getStartLineFromLazyToken(this);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(LazyToken.prototype, "startColumn", {
	        get: function () {
	            return tokens_1.getStartColumnFromLazyToken(this);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(LazyToken.prototype, "endLine", {
	        get: function () {
	            return tokens_1.getEndLineFromLazyToken(this);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(LazyToken.prototype, "endColumn", {
	        get: function () {
	            return tokens_1.getEndColumnFromLazyToken(this);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return LazyToken;
	}());
	/**
	 * A "human readable" Label for a Token.
	 * Subclasses of Token may define their own static LABEL property.
	 * This label will be used in error messages and drawing syntax diagrams.
	 *
	 * For example a Token constructor may be called LCurly, which is short for LeftCurlyBrackets, These names are either too short
	 * or too unwieldy to be used in error messages.
	 *
	 * Imagine : "expecting LCurly but found ')'" or "expecting LeftCurlyBrackets but found ')'"
	 *
	 * However if a static property LABEL with the value '{' exists on LCurly class, that error message will be:
	 * "expecting '{' but found ')'"
	 */
	LazyToken.LABEL = undefined;
	exports.LazyToken = LazyToken;
	/**
	 * @see IToken
	 * @see LazyToken
	 *
	 * A Less complex LazyToken used to increase performance.
	 * Instances of SimpleLazyToken will not actually inherit from it using prototype inheritance.
	 * Instead they will be simple JS Objects (Simple Structures)
	 * {
	 *    startOffset : 10,
	 *    endOffset   : 16,
	 *    tokenType   : 66,
	 *    cacheData   : cacheData
	 * }
	 *
	 * The additional computed properties (startLine/StartColumn/...) of the IToken interface can be computed using
	 * The provided Utility methods (getImage, getStartColumn, getEndLine, ...)
	 *
	 * This makes SimpleLazyTokens slightly less convenient, however this can produce a substantial increase in performance
	 * which may be relevant in certain use cases where performance is of paramount concern.
	 */
	var SimpleLazyToken = (function () {
	    // This constructor is never actually called as simpleLazyToken are just a Structure.
	    // However this class must still exist as the definition and hierarchy of the SimpleLazyTokens
	    // still uses the standard prototype chain.
	    /* istanbul ignore next */
	    function SimpleLazyToken(startOffset, endOffset, tokenType, cacheData) {
	        this.startOffset = startOffset;
	        this.endOffset = endOffset;
	        this.tokenType = tokenType;
	        this.cacheData = cacheData;
	    }
	    return SimpleLazyToken;
	}());
	/**
	 * A "human readable" Label for a Token.
	 * Subclasses of Token may define their own static LABEL property.
	 * This label will be used in error messages and drawing syntax diagrams.
	 *
	 * For example a Token constructor may be called LCurly, which is short for LeftCurlyBrackets, These names are either too short
	 * or too unwieldy to be used in error messages.
	 *
	 * Imagine : "expecting LCurly but found ')'" or "expecting LeftCurlyBrackets but found ')'"
	 *
	 * However if a static property LABEL with the value '{' exists on LCurly class, that error message will be:
	 * "expecting '{' but found ')'"
	 */
	SimpleLazyToken.LABEL = undefined;
	exports.SimpleLazyToken = SimpleLazyToken;
	/**
	 * A special kind of Token which does not really exist in the input
	 * (hence the 'Virtual' prefix). These type of Tokens can be used as special markers:
	 * for example, EOF (end-of-file).
	 */
	var VirtualToken = (function (_super) {
	    __extends(VirtualToken, _super);
	    function VirtualToken() {
	        return _super.call(this, "", NaN, NaN, NaN, NaN, NaN) /* istanbul ignore next */ || this;
	    }
	    return VirtualToken;
	}(Token));
	exports.VirtualToken = VirtualToken;
	var EOF = (function (_super) {
	    __extends(EOF, _super);
	    function EOF() {
	        return _super.apply(this, arguments) /* istanbul ignore next */ || this;
	    }
	    return EOF;
	}(VirtualToken));
	exports.EOF = EOF;
	tokens_1.augmentTokenClasses([EOF]);
	// Token Getter Utilities
	function getImage(token) {
	    return tokens_1.isInheritanceBasedToken(token) ?
	        token.image :
	        tokens_1.getImageFromLazyToken(token);
	}
	exports.getImage = getImage;
	function getStartOffset(token) {
	    return token.startOffset;
	}
	exports.getStartOffset = getStartOffset;
	function getStartLine(token) {
	    return tokens_1.isInheritanceBasedToken(token) ?
	        token.startLine :
	        tokens_1.getStartLineFromLazyToken(token);
	}
	exports.getStartLine = getStartLine;
	function getStartColumn(token) {
	    return tokens_1.isInheritanceBasedToken(token) ?
	        token.startColumn :
	        tokens_1.getStartColumnFromLazyToken(token);
	}
	exports.getStartColumn = getStartColumn;
	function getEndOffset(token) {
	    return token.endOffset;
	}
	exports.getEndOffset = getEndOffset;
	function getEndLine(token) {
	    return tokens_1.isInheritanceBasedToken(token) ?
	        token.endLine :
	        tokens_1.getEndLineFromLazyToken(token);
	}
	exports.getEndLine = getEndLine;
	function getEndColumn(token) {
	    return tokens_1.isInheritanceBasedToken(token) ?
	        token.endColumn :
	        tokens_1.getEndColumnFromLazyToken(token);
	}
	exports.getEndColumn = getEndColumn;
	/**
	 * Given a Token instance, will return the Token Constructor.
	 * Note that this function is not just for convenience, Because a SimpleLazyToken "instance'
	 * Does not use standard prototype inheritance and thus it's constructor cannot be accessed
	 * by traversing the prototype chain.
	 *
	 * @param tokenInstance {ISimpleTokenOrIToken}
	 * @returns {TokenConstructor}
	 */
	function getTokenConstructor(tokenInstance) {
	    var tokenIdx;
	    if (tokens_1.isInheritanceBasedToken(tokenInstance)) {
	        tokenIdx = tokenInstance.constructor.tokenType;
	    }
	    else {
	        tokenIdx = tokenInstance.tokenType;
	    }
	    return tokens_1.tokenIdxToClass.get(tokenIdx);
	}
	exports.getTokenConstructor = getTokenConstructor;
	/**
	 * A Utility method to check if a token instance of of the type of a specific Token class.
	 * Simply using instanceof is not enough because SimpleLazyToken Implementation does not use
	 * ECMAScript's built-in prototype inheritance.
	 *
	 * @param tokInstance {ISimpleTokenOrIToken}
	 * @param tokClass {TokenConstructor}
	 * @returns {boolean}
	 */
	function tokenMatcher(tokInstance, tokClass) {
	    if (LazyToken.prototype.isPrototypeOf(tokClass.prototype) ||
	        Token.prototype.isPrototypeOf(tokClass.prototype)) {
	        return tokens_1.tokenInstanceofMatcher(tokInstance, tokClass);
	    }/* istanbul ignore else */ 
	    else if (SimpleLazyToken.prototype.isPrototypeOf(tokClass.prototype)) {
	        return tokens_1.tokenStructuredMatcher(tokInstance, tokClass);
	    }
	    else {
	        /* istanbul ignore next */ throw Error("non exhaustive match");
	    }
	}
	exports.tokenMatcher = tokenMatcher;
	//# sourceMappingURL=tokens_public.js.map

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var tokens_public_1 = __webpack_require__(1020);
	var lexer_1 = __webpack_require__(1022);
	var utils_1 = __webpack_require__(1016);
	var tokens_1 = __webpack_require__(1023);
	var LexerDefinitionErrorType;
	(function (LexerDefinitionErrorType) {
	    LexerDefinitionErrorType[LexerDefinitionErrorType["MISSING_PATTERN"] = 0] = "MISSING_PATTERN";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["INVALID_PATTERN"] = 1] = "INVALID_PATTERN";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["EOI_ANCHOR_FOUND"] = 2] = "EOI_ANCHOR_FOUND";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["UNSUPPORTED_FLAGS_FOUND"] = 3] = "UNSUPPORTED_FLAGS_FOUND";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["DUPLICATE_PATTERNS_FOUND"] = 4] = "DUPLICATE_PATTERNS_FOUND";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["INVALID_GROUP_TYPE_FOUND"] = 5] = "INVALID_GROUP_TYPE_FOUND";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["PUSH_MODE_DOES_NOT_EXIST"] = 6] = "PUSH_MODE_DOES_NOT_EXIST";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE"] = 7] = "MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY"] = 8] = "MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST"] = 9] = "MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED"] = 10] = "LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["LEXER_DEFINITION_CANNOT_MIX_LAZY_AND_NOT_LAZY"] = 11] = "LEXER_DEFINITION_CANNOT_MIX_LAZY_AND_NOT_LAZY";
	    LexerDefinitionErrorType[LexerDefinitionErrorType["LEXER_DEFINITION_CANNOT_MIX_SIMPLE_AND_NOT_SIMPLE"] = 12] = "LEXER_DEFINITION_CANNOT_MIX_SIMPLE_AND_NOT_SIMPLE";
	})(LexerDefinitionErrorType = exports.LexerDefinitionErrorType || (exports.LexerDefinitionErrorType = {}));
	var Lexer = (function () {
	    /**
	     * @param {SingleModeLexerDefinition | IMultiModeLexerDefinition} lexerDefinition -
	     *  Structure composed of constructor functions for the Tokens types this lexer will support.
	     *
	     *  In the case of {SingleModeLexerDefinition} the structure is simply an array of Token constructors.
	     *  In the case of {IMultiModeLexerDefinition} the structure is an object with two properties:
	     *    1. a "modes" property where each value is an array of Token.
	     *    2. a "defaultMode" property specifying the initial lexer mode.
	     *
	     *  constructors.
	     *
	     *  for example:
	     *  {
	     *     "modes" : {
	     *     "modeX" : [Token1, Token2]
	     *     "modeY" : [Token3, Token4]
	     *     }
	     *
	     *     "defaultMode" : "modeY"
	     *  }
	     *
	     *  A lexer with {MultiModesDefinition} is simply multiple Lexers where only one (mode) can be active at the same time.
	     *  This is useful for lexing languages where there are different lexing rules depending on context.
	     *
	     *  The current lexing mode is selected via a "mode stack".
	     *  The last (peek) value in the stack will be the current mode of the lexer.
	     *
	     *  Each Token class can define that it will cause the Lexer to (after consuming an instance of the Token):
	     *  1. PUSH_MODE : push a new mode to the "mode stack"
	     *  2. POP_MODE  : pop the last mode from the "mode stack"
	     *
	     *  Examples:
	     *       export class Attribute extends Token {
	     *          static PATTERN = ...
	     *          static PUSH_MODE = "modeY"
	     *       }
	     *
	     *       export class EndAttribute extends Token {
	     *          static PATTERN = ...
	     *          static POP_MODE = true
	     *       }
	     *
	     *  The Token constructors must be in one of these forms:
	     *
	     *  1. With a PATTERN property that has a RegExp value for tokens to match:
	     *     example: -->class Integer extends Token { static PATTERN = /[1-9]\d }<--
	     *
	     *  2. With a PATTERN property that has the value of the var Lexer.NA defined above.
	     *     This is a convenience form used to avoid matching Token classes that only act as categories.
	     *     example: -->class Keyword extends Token { static PATTERN = NA }<--
	     *
	     *
	     *   The following RegExp patterns are not supported:
	     *   a. '$' for match at end of input
	     *   b. /b global flag
	     *   c. /m multi-line flag
	     *
	     *   The Lexer will identify the first pattern that matches, Therefor the order of Token Constructors may be significant.
	     *   For example when one pattern may match a prefix of another pattern.
	     *
	     *   Note that there are situations in which we may wish to order the longer pattern after the shorter one.
	     *   For example: keywords vs Identifiers.
	     *   'do'(/do/) and 'donald'(/w+)
	     *
	     *   * If the Identifier pattern appears before the 'do' pattern, both 'do' and 'donald'
	     *     will be lexed as an Identifier.
	     *
	     *   * If the 'do' pattern appears before the Identifier pattern 'do' will be lexed correctly as a keyword.
	     *     however 'donald' will be lexed as TWO separate tokens: keyword 'do' and identifier 'nald'.
	     *
	     *   To resolve this problem, add a static property on the keyword's constructor named: LONGER_ALT
	     *   example:
	     *
	     *       export class Identifier extends Keyword { static PATTERN = /[_a-zA-Z][_a-zA-Z0-9]/ }
	     *       export class Keyword extends Token {
	     *          static PATTERN = lex.NA
	     *          static LONGER_ALT = Identifier
	     *       }
	     *       export class Do extends Keyword { static PATTERN = /do/ }
	     *       export class While extends Keyword { static PATTERN = /while/ }
	     *       export class Return extends Keyword { static PATTERN = /return/ }
	     *
	     *   The lexer will then also attempt to match a (longer) Identifier each time a keyword is matched.
	     *
	     *
	     * @param {boolean} [deferDefinitionErrorsHandling=false] -
	     *                  An optional flag indicating that lexer definition errors
	     *                  should not automatically cause an error to be raised.
	     *                  This can be useful when wishing to indicate lexer errors in another manner
	     *                  than simply throwing an error (for example in an online playground).
	     */
	    function Lexer(lexerDefinition, deferDefinitionErrorsHandling) {
	        if (deferDefinitionErrorsHandling === void 0) { deferDefinitionErrorsHandling = false; }
	        var _this = this;
	        this.lexerDefinition = lexerDefinition;
	        this.lexerDefinitionErrors = [];
	        this.modes = [];
	        this.allPatterns = {};
	        this.patternIdxToClass = {};
	        this.patternIdxToGroup = {};
	        this.patternIdxToLongerAltIdx = {};
	        this.patternIdxToCanLineTerminator = {};
	        this.patternIdxToPushMode = {};
	        this.patternIdxToPopMode = {};
	        this.emptyGroups = {};
	        var actualDefinition;
	        // Convert SingleModeLexerDefinition into a IMultiModeLexerDefinition.
	        if (utils_1.isArray(lexerDefinition)) {
	            actualDefinition = { modes: {} };
	            actualDefinition.modes[lexer_1.DEFAULT_MODE] = utils_1.cloneArr(lexerDefinition);
	            actualDefinition[lexer_1.DEFAULT_MODE] = lexer_1.DEFAULT_MODE;
	        }
	        else {
	            actualDefinition = utils_1.cloneObj(lexerDefinition);
	        }
	        this.lexerDefinitionErrors = this.lexerDefinitionErrors.concat(lexer_1.performRuntimeChecks(actualDefinition));
	        // for extra robustness to avoid throwing an none informative error message
	        actualDefinition.modes = actualDefinition.modes ? actualDefinition.modes : {};
	        // an error of undefined TokenClasses will be detected in "performRuntimeChecks" above.
	        // this transformation is to increase robustness in the case of partially invalid lexer definition.
	        utils_1.forEach(actualDefinition.modes, function (currModeValue, currModeName) {
	            actualDefinition.modes[currModeName] = utils_1.reject(currModeValue, function (currTokClass) { return utils_1.isUndefined(currTokClass); });
	        });
	        var allModeNames = utils_1.keys(actualDefinition.modes);
	        utils_1.forEach(actualDefinition.modes, function (currModDef, currModName) {
	            _this.modes.push(currModName);
	            _this.lexerDefinitionErrors = _this.lexerDefinitionErrors.concat(lexer_1.validatePatterns(currModDef, allModeNames));
	            // If definition errors were encountered, the analysis phase may fail unexpectedly/
	            // Considering a lexer with definition errors may never be used, there is no point
	            // to performing the analysis anyhow...
	            if (utils_1.isEmpty(_this.lexerDefinitionErrors)) {
	                tokens_1.augmentTokenClasses(currModDef);
	                var currAnalyzeResult = lexer_1.analyzeTokenClasses(currModDef);
	                _this.allPatterns[currModName] = currAnalyzeResult.allPatterns;
	                _this.patternIdxToClass[currModName] = currAnalyzeResult.patternIdxToClass;
	                _this.patternIdxToGroup[currModName] = currAnalyzeResult.patternIdxToGroup;
	                _this.patternIdxToLongerAltIdx[currModName] = currAnalyzeResult.patternIdxToLongerAltIdx;
	                _this.patternIdxToCanLineTerminator[currModName] = currAnalyzeResult.patternIdxToCanLineTerminator;
	                _this.patternIdxToPushMode[currModName] = currAnalyzeResult.patternIdxToPushMode;
	                _this.patternIdxToPopMode[currModName] = currAnalyzeResult.patternIdxToPopMode;
	                _this.emptyGroups = utils_1.merge(_this.emptyGroups, currAnalyzeResult.emptyGroups);
	            }
	        });
	        this.defaultMode = actualDefinition.defaultMode;
	        var allTokensTypes = utils_1.flatten(utils_1.mapValues(actualDefinition.modes, function (currModDef) { return currModDef; }));
	        // Lazy Mode handling
	        var lazyCheckResult = lexer_1.checkLazyMode(allTokensTypes);
	        this.isLazyTokenMode = lazyCheckResult.isLazy;
	        this.lexerDefinitionErrors = this.lexerDefinitionErrors.concat(lazyCheckResult.errors);
	        // Simple Mode handling
	        var simpleCheckResult = lexer_1.checkSimpleMode(allTokensTypes);
	        this.isSimpleTokenMode = simpleCheckResult.isSimple;
	        this.lexerDefinitionErrors = this.lexerDefinitionErrors.concat(simpleCheckResult.errors);
	        if (!utils_1.isEmpty(this.lexerDefinitionErrors) && !deferDefinitionErrorsHandling) {
	            var allErrMessages = utils_1.map(this.lexerDefinitionErrors, function (error) {
	                return error.message;
	            });
	            var allErrMessagesString = allErrMessages.join("-----------------------\n");
	            throw new Error("Errors detected in definition of Lexer:\n" + allErrMessagesString);
	        }
	    }
	    /**
	     * Will lex(Tokenize) a string.
	     * Note that this can be called repeatedly on different strings as this method
	     * does not modify the state of the Lexer.
	     *
	     * @param {string} text - The string to lex
	     * @param {string} [initialMode] - The initial Lexer Mode to start with, by default this will be the first mode in the lexer's
	     *                                 definition. If the lexer has no explicit modes it will be the implicit single 'default_mode' mode.
	     *
	     * @returns {ILexingResult}
	     */
	    Lexer.prototype.tokenize = function (text, initialMode) {
	        if (initialMode === void 0) { initialMode = this.defaultMode; }
	        if (!utils_1.isEmpty(this.lexerDefinitionErrors)) {
	            var allErrMessages = utils_1.map(this.lexerDefinitionErrors, function (error) {
	                return error.message;
	            });
	            var allErrMessagesString = allErrMessages.join("-----------------------\n");
	            throw new Error("Unable to Tokenize because Errors detected in definition of Lexer:\n" + allErrMessagesString);
	        }
	        if (this.isLazyTokenMode) {
	            if (this.isSimpleTokenMode) {
	                return this.tokenizeInternalLazy(text, initialMode, tokens_1.createSimpleLazyToken);
	            }
	            else {
	                return this.tokenizeInternalLazy(text, initialMode, tokens_1.createLazyTokenInstance);
	            }
	        }
	        else {
	            return this.tokenizeInternal(text, initialMode);
	        }
	    };
	    // There is quite a bit of duplication between this and "tokenizeInternalLazy"
	    // This is intentional due to performance considerations.
	    Lexer.prototype.tokenizeInternal = function (text, initialMode) {
	        var _this = this;
	        var match, i, j, matchAlt, longerAltIdx, matchedImage, imageLength, group, tokClass, newToken, errLength, fixForEndingInLT, c, droppedChar, lastLTIdx, msg, lastCharIsLT;
	        var orgInput = text;
	        var offset = 0;
	        var matchedTokens = [];
	        var errors = [];
	        var line = 1;
	        var column = 1;
	        var groups = lexer_1.cloneEmptyGroups(this.emptyGroups);
	        var currModePatterns = [];
	        var currModePatternsLength = 0;
	        var currModePatternIdxToLongerAltIdx = [];
	        var currModePatternIdxToGroup = [];
	        var currModePatternIdxToClass = [];
	        var currModePatternIdxToCanLineTerminator = [];
	        var patternIdxToPushMode = [];
	        var patternIdxToPopMode = [];
	        var modeStack = [];
	        var pop_mode = function (popToken) {
	            // TODO: perhaps avoid this error in the edge case there is no more input?
	            if (modeStack.length === 1) {
	                // if we try to pop the last mode there lexer will no longer have ANY mode.
	                // thus the pop is ignored, an error will be created and the lexer will continue parsing in the previous mode.
	                var msg_1 = "Unable to pop Lexer Mode after encountering Token ->" + tokens_public_1.getImage(popToken) + "<- The Mode Stack is empty";
	                errors.push({
	                    line: tokens_public_1.getStartLine(popToken),
	                    column: tokens_public_1.getStartColumn(popToken),
	                    length: tokens_public_1.getImage(popToken).length,
	                    message: msg_1
	                });
	            }
	            else {
	                modeStack.pop();
	                var newMode = utils_1.last(modeStack);
	                currModePatterns = _this.allPatterns[newMode];
	                currModePatternsLength = currModePatterns.length;
	                currModePatternIdxToLongerAltIdx = _this.patternIdxToLongerAltIdx[newMode];
	                currModePatternIdxToGroup = _this.patternIdxToGroup[newMode];
	                currModePatternIdxToClass = _this.patternIdxToClass[newMode];
	                currModePatternIdxToCanLineTerminator = _this.patternIdxToCanLineTerminator[newMode];
	                patternIdxToPushMode = _this.patternIdxToPushMode[newMode];
	                patternIdxToPopMode = _this.patternIdxToPopMode[newMode];
	            }
	        };
	        function push_mode(newMode) {
	            modeStack.push(newMode);
	            currModePatterns = this.allPatterns[newMode];
	            currModePatternsLength = currModePatterns.length;
	            currModePatternIdxToLongerAltIdx = this.patternIdxToLongerAltIdx[newMode];
	            currModePatternIdxToGroup = this.patternIdxToGroup[newMode];
	            currModePatternIdxToClass = this.patternIdxToClass[newMode];
	            currModePatternIdxToCanLineTerminator = this.patternIdxToCanLineTerminator[newMode];
	            patternIdxToPushMode = this.patternIdxToPushMode[newMode];
	            patternIdxToPopMode = this.patternIdxToPopMode[newMode];
	        }
	        // this pattern seems to avoid a V8 de-optimization, although that de-optimization does not
	        // seem to matter performance wise.
	        push_mode.call(this, initialMode);
	        while (text.length > 0) {
	            match = null;
	            for (i = 0; i < currModePatternsLength; i++) {
	                match = currModePatterns[i].exec(text);
	                if (match !== null) {
	                    // even though this pattern matched we must try a another longer alternative.
	                    // this can be used to prioritize keywords over identifiers
	                    longerAltIdx = currModePatternIdxToLongerAltIdx[i];
	                    if (longerAltIdx) {
	                        matchAlt = currModePatterns[longerAltIdx].exec(text);
	                        if (matchAlt && matchAlt[0].length > match[0].length) {
	                            match = matchAlt;
	                            i = longerAltIdx;
	                        }
	                    }
	                    break;
	                }
	            }
	            // successful match
	            if (match !== null) {
	                matchedImage = match[0];
	                imageLength = matchedImage.length;
	                group = currModePatternIdxToGroup[i];
	                if (group !== undefined) {
	                    tokClass = currModePatternIdxToClass[i];
	                    newToken = new tokClass(matchedImage, offset, line, column);
	                    if (group === "default") {
	                        matchedTokens.push(newToken);
	                    }
	                    else {
	                        groups[group].push(newToken);
	                    }
	                }
	                text = text.slice(imageLength);
	                offset = offset + imageLength;
	                column = column + imageLength; // TODO: with newlines the column may be assigned twice
	                if (currModePatternIdxToCanLineTerminator[i]) {
	                    var lineTerminatorsInMatch = lexer_1.countLineTerminators(matchedImage);
	                    // TODO: identify edge case of one token ending in '\r' and another one starting with '\n'
	                    if (lineTerminatorsInMatch !== 0) {
	                        line = line + lineTerminatorsInMatch;
	                        lastLTIdx = imageLength - 1;
	                        while (lastLTIdx >= 0) {
	                            c = matchedImage.charCodeAt(lastLTIdx);
	                            // scan in reverse to find last lineTerminator in image
	                            if (c === 13 || c === 10) {
	                                break;
	                            }
	                            lastLTIdx--;
	                        }
	                        column = imageLength - lastLTIdx;
	                        if (group !== undefined) {
	                            lastCharIsLT = lastLTIdx === imageLength - 1;
	                            fixForEndingInLT = lastCharIsLT ?
	                                -1 :
	                                0;
	                            if (!(lineTerminatorsInMatch === 1 && lastCharIsLT)) {
	                                // if a token ends in a LT that last LT only affects the line numbering of following Tokens
	                                newToken.endLine = line + fixForEndingInLT;
	                                // the last LT in a token does not affect the endColumn either as the [columnStart ... columnEnd)
	                                // inclusive to exclusive range.
	                                newToken.endColumn = column - 1 + -fixForEndingInLT;
	                            }
	                        }
	                    }
	                }
	                // mode handling, must pop before pushing if a Token both acts as both
	                // otherwise it would be a NO-OP
	                if (patternIdxToPopMode[i]) {
	                    pop_mode(newToken);
	                }
	                if (patternIdxToPushMode[i]) {
	                    push_mode.call(this, patternIdxToPushMode[i]);
	                }
	            }
	            else {
	                var errorStartOffset = offset;
	                var errorLine = line;
	                var errorColumn = column;
	                var foundResyncPoint = false;
	                while (!foundResyncPoint && text.length > 0) {
	                    // drop chars until we succeed in matching something
	                    droppedChar = text.charCodeAt(0);
	                    if (droppedChar === 10 ||
	                        (droppedChar === 13 &&
	                            (text.length === 1 || (text.length > 1 && text.charCodeAt(1) !== 10)))) {
	                        line++;
	                        column = 1;
	                    }
	                    else {
	                        // either when skipping the next char, or when consuming the following pattern
	                        // (which will have to start in a '\n' if we manage to consume it)
	                        column++;
	                    }
	                    text = text.substr(1);
	                    offset++;
	                    for (j = 0; j < currModePatterns.length; j++) {
	                        foundResyncPoint = currModePatterns[j].exec(text);
	                        if (foundResyncPoint !== null) {
	                            break;
	                        }
	                    }
	                }
	                errLength = offset - errorStartOffset;
	                // at this point we either re-synced or reached the end of the input text
	                msg = "unexpected character: ->" + orgInput.charAt(errorStartOffset) + "<- at offset: " + errorStartOffset + "," +
	                    (" skipped " + (offset - errorStartOffset) + " characters.");
	                errors.push({ line: errorLine, column: errorColumn, length: errLength, message: msg });
	            }
	        }
	        return { tokens: matchedTokens, groups: groups, errors: errors };
	    };
	    Lexer.prototype.tokenizeInternalLazy = function (text, initialMode, tokenCreator) {
	        var _this = this;
	        var match, i, j, matchAlt, longerAltIdx, matchedImage, imageLength, group, tokClass, newToken, errLength, droppedChar, msg;
	        var orgInput = text;
	        var offset = 0;
	        var matchedTokens = [];
	        var errors = [];
	        var groups = lexer_1.cloneEmptyGroups(this.emptyGroups);
	        var currModePatterns = [];
	        var currModePatternsLength = 0;
	        var currModePatternIdxToLongerAltIdx = [];
	        var currModePatternIdxToGroup = [];
	        var currModePatternIdxToClass = [];
	        var patternIdxToPushMode = [];
	        var patternIdxToPopMode = [];
	        var lazyCacheData = {
	            orgText: text,
	            lineToOffset: []
	        };
	        var modeStack = [];
	        var pop_mode = function (popToken) {
	            // TODO: perhaps avoid this error in the edge case there is no more input?
	            if (modeStack.length === 1) {
	                // if we try to pop the last mode there lexer will no longer have ANY mode.
	                // thus the pop is ignored, an error will be created and the lexer will continue parsing in the previous mode.
	                var msg_2 = "Unable to pop Lexer Mode after encountering Token ->" + tokens_public_1.getImage(popToken) + "<- The Mode Stack is empty";
	                errors.push({
	                    line: tokens_public_1.getStartLine(popToken),
	                    column: tokens_public_1.getStartColumn(popToken),
	                    length: tokens_public_1.getImage(popToken).length,
	                    message: msg_2
	                });
	            }
	            else {
	                modeStack.pop();
	                var newMode = utils_1.last(modeStack);
	                currModePatterns = _this.allPatterns[newMode];
	                currModePatternsLength = currModePatterns.length;
	                currModePatternIdxToLongerAltIdx = _this.patternIdxToLongerAltIdx[newMode];
	                currModePatternIdxToGroup = _this.patternIdxToGroup[newMode];
	                currModePatternIdxToClass = _this.patternIdxToClass[newMode];
	                patternIdxToPushMode = _this.patternIdxToPushMode[newMode];
	                patternIdxToPopMode = _this.patternIdxToPopMode[newMode];
	            }
	        };
	        function push_mode(newMode) {
	            modeStack.push(newMode);
	            currModePatterns = this.allPatterns[newMode];
	            currModePatternsLength = currModePatterns.length;
	            currModePatternIdxToLongerAltIdx = this.patternIdxToLongerAltIdx[newMode];
	            currModePatternIdxToGroup = this.patternIdxToGroup[newMode];
	            currModePatternIdxToClass = this.patternIdxToClass[newMode];
	            patternIdxToPushMode = this.patternIdxToPushMode[newMode];
	            patternIdxToPopMode = this.patternIdxToPopMode[newMode];
	        }
	        // this pattern seems to avoid a V8 de-optimization, although that de-optimization does not
	        // seem to matter performance wise.
	        push_mode.call(this, initialMode);
	        while (text.length > 0) {
	            match = null;
	            for (i = 0; i < currModePatternsLength; i++) {
	                match = currModePatterns[i].exec(text);
	                if (match !== null) {
	                    // even though this pattern matched we must try a another longer alternative.
	                    // this can be used to prioritize keywords over identifiers
	                    longerAltIdx = currModePatternIdxToLongerAltIdx[i];
	                    if (longerAltIdx) {
	                        matchAlt = currModePatterns[longerAltIdx].exec(text);
	                        if (matchAlt && matchAlt[0].length > match[0].length) {
	                            match = matchAlt;
	                            i = longerAltIdx;
	                        }
	                    }
	                    break;
	                }
	            }
	            // successful match
	            if (match !== null) {
	                matchedImage = match[0];
	                imageLength = matchedImage.length;
	                group = currModePatternIdxToGroup[i];
	                if (group !== undefined) {
	                    tokClass = currModePatternIdxToClass[i];
	                    // the end offset is non inclusive.
	                    newToken = tokenCreator(offset, offset + imageLength - 1, tokClass, lazyCacheData);
	                    if (group === "default") {
	                        matchedTokens.push(newToken);
	                    }
	                    else {
	                        groups[group].push(newToken);
	                    }
	                }
	                text = text.slice(imageLength);
	                offset = offset + imageLength;
	                // mode handling, must pop before pushing if a Token both acts as both
	                // otherwise it would be a NO-OP
	                if (patternIdxToPopMode[i]) {
	                    pop_mode(newToken);
	                }
	                if (patternIdxToPushMode[i]) {
	                    push_mode.call(this, patternIdxToPushMode[i]);
	                }
	            }
	            else {
	                var errorStartOffset = offset;
	                var foundResyncPoint = false;
	                while (!foundResyncPoint && text.length > 0) {
	                    // drop chars until we succeed in matching something
	                    droppedChar = text.charCodeAt(0);
	                    text = text.substr(1);
	                    offset++;
	                    for (j = 0; j < currModePatterns.length; j++) {
	                        foundResyncPoint = currModePatterns[j].exec(text);
	                        if (foundResyncPoint !== null) {
	                            break;
	                        }
	                    }
	                }
	                errLength = offset - errorStartOffset;
	                // at this point we either re-synced or reached the end of the input text
	                msg = "unexpected character: ->" + orgInput.charAt(errorStartOffset) + "<- at offset: " + errorStartOffset + "," +
	                    (" skipped " + (offset - errorStartOffset) + " characters.");
	                if (utils_1.isEmpty(lazyCacheData.lineToOffset)) {
	                    tokens_1.fillUpLineToOffset(lazyCacheData.lineToOffset, lazyCacheData.orgText);
	                }
	                var errorLine = tokens_1.getStartLineFromLineToOffset(errorStartOffset, lazyCacheData.lineToOffset);
	                var errorColumn = tokens_1.getStartColumnFromLineToOffset(errorStartOffset, lazyCacheData.lineToOffset);
	                errors.push({ line: errorLine, column: errorColumn, length: errLength, message: msg });
	            }
	        }
	        return { tokens: matchedTokens, groups: groups, errors: errors };
	    };
	    return Lexer;
	}());
	Lexer.SKIPPED = "This marks a skipped Token pattern, this means each token identified by it will" +
	    "be consumed and then thrown into oblivion, this can be used to for example to completely ignore whitespace.";
	Lexer.NA = /NOT_APPLICABLE/;
	exports.Lexer = Lexer;
	//# sourceMappingURL=lexer_public.js.map

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var tokens_public_1 = __webpack_require__(1020);
	var lexer_public_1 = __webpack_require__(1021);
	var utils_1 = __webpack_require__(1016);
	var tokens_1 = __webpack_require__(1023);
	var PATTERN = "PATTERN";
	exports.DEFAULT_MODE = "defaultMode";
	exports.MODES = "modes";
	var CONTAINS_LINE_TERMINATOR = "containsLineTerminator";
	function analyzeTokenClasses(tokenClasses) {
	    var onlyRelevantClasses = utils_1.reject(tokenClasses, function (currClass) {
	        return currClass[PATTERN] === lexer_public_1.Lexer.NA;
	    });
	    var allTransformedPatterns = utils_1.map(onlyRelevantClasses, function (currClass) {
	        var currPattern = currClass[PATTERN];
	        if (utils_1.isRegExp(currPattern)) {
	            return addStartOfInput(currPattern);
	        }
	        else if (utils_1.isFunction(currPattern)) {
	            return { exec: currPattern };
	        }/* istanbul ignore else */ 
	        else if (utils_1.has(currPattern, "exec")) {
	            return currPattern;
	        }
	        else {
	            /* istanbul ignore next */ throw Error("non exhaustive match");
	        }
	    });
	    var patternIdxToClass = onlyRelevantClasses;
	    var patternIdxToGroup = utils_1.map(onlyRelevantClasses, function (clazz) {
	        var groupName = clazz.GROUP;
	        if (groupName === lexer_public_1.Lexer.SKIPPED) {
	            return undefined;
	        }
	        else if (utils_1.isString(groupName)) {
	            return groupName;
	        }/* istanbul ignore else */ 
	        else if (utils_1.isUndefined(groupName)) {
	            return "default";
	        }
	        else {
	            /* istanbul ignore next */ throw Error("non exhaustive match");
	        }
	    });
	    var patternIdxToLongerAltIdx = utils_1.map(onlyRelevantClasses, function (clazz) {
	        var longerAltClass = clazz.LONGER_ALT;
	        if (longerAltClass) {
	            var longerAltIdx = utils_1.indexOf(onlyRelevantClasses, longerAltClass);
	            return longerAltIdx;
	        }
	    });
	    var patternIdxToPushMode = utils_1.map(onlyRelevantClasses, function (clazz) { return clazz.PUSH_MODE; });
	    var patternIdxToPopMode = utils_1.map(onlyRelevantClasses, function (clazz) { return utils_1.has(clazz, "POP_MODE"); });
	    var patternIdxToCanLineTerminator = utils_1.map(allTransformedPatterns, function (pattern) {
	        if (utils_1.isRegExp(pattern)) {
	            // TODO: unicode escapes of line terminators too?
	            return /\\n|\\r|\\s/g.test(pattern.source);
	        }
	        else {
	            if (utils_1.has(pattern, CONTAINS_LINE_TERMINATOR)) {
	                return pattern[CONTAINS_LINE_TERMINATOR];
	            }
	            return false;
	        }
	    });
	    var emptyGroups = utils_1.reduce(onlyRelevantClasses, function (acc, clazz) {
	        var groupName = clazz.GROUP;
	        if (utils_1.isString(groupName) && !(groupName === lexer_public_1.Lexer.SKIPPED)) {
	            acc[groupName] = [];
	        }
	        return acc;
	    }, {});
	    return {
	        allPatterns: allTransformedPatterns,
	        patternIdxToClass: patternIdxToClass,
	        patternIdxToGroup: patternIdxToGroup,
	        patternIdxToLongerAltIdx: patternIdxToLongerAltIdx,
	        patternIdxToCanLineTerminator: patternIdxToCanLineTerminator,
	        patternIdxToPushMode: patternIdxToPushMode,
	        patternIdxToPopMode: patternIdxToPopMode,
	        emptyGroups: emptyGroups
	    };
	}
	exports.analyzeTokenClasses = analyzeTokenClasses;
	function validatePatterns(tokenClasses, validModesNames) {
	    var errors = [];
	    var missingResult = findMissingPatterns(tokenClasses);
	    errors = errors.concat(missingResult.errors);
	    var invalidResult = findInvalidPatterns(missingResult.valid);
	    var validTokenClasses = invalidResult.valid;
	    errors = errors.concat(invalidResult.errors);
	    errors = errors.concat(validateRegExpPattern(validTokenClasses));
	    errors = errors.concat(findInvalidGroupType(validTokenClasses));
	    errors = errors.concat(findModesThatDoNotExist(validTokenClasses, validModesNames));
	    return errors;
	}
	exports.validatePatterns = validatePatterns;
	function validateRegExpPattern(tokenClasses) {
	    var errors = [];
	    var withRegExpPatterns = utils_1.filter(tokenClasses, function (currTokClass) { return utils_1.isRegExp(currTokClass[PATTERN]); });
	    errors = errors.concat(findEndOfInputAnchor(withRegExpPatterns));
	    errors = errors.concat(findUnsupportedFlags(withRegExpPatterns));
	    errors = errors.concat(findDuplicatePatterns(withRegExpPatterns));
	    return errors;
	}
	function findMissingPatterns(tokenClasses) {
	    var tokenClassesWithMissingPattern = utils_1.filter(tokenClasses, function (currClass) {
	        return !utils_1.has(currClass, PATTERN);
	    });
	    var errors = utils_1.map(tokenClassesWithMissingPattern, function (currClass) {
	        return {
	            message: "Token class: ->" + tokens_public_1.tokenName(currClass) + "<- missing static 'PATTERN' property",
	            type: lexer_public_1.LexerDefinitionErrorType.MISSING_PATTERN,
	            tokenClasses: [currClass]
	        };
	    });
	    var valid = utils_1.difference(tokenClasses, tokenClassesWithMissingPattern);
	    return { errors: errors, valid: valid };
	}
	exports.findMissingPatterns = findMissingPatterns;
	function findInvalidPatterns(tokenClasses) {
	    var tokenClassesWithInvalidPattern = utils_1.filter(tokenClasses, function (currClass) {
	        var pattern = currClass[PATTERN];
	        return !utils_1.isRegExp(pattern) && !utils_1.isFunction(pattern) && !utils_1.has(pattern, "exec");
	    });
	    var errors = utils_1.map(tokenClassesWithInvalidPattern, function (currClass) {
	        return {
	            message: "Token class: ->" + tokens_public_1.tokenName(currClass) + "<- static 'PATTERN' can only be a RegExp, a" +
	                " Function matching the {CustomPatternMatcherFunc} type or an Object matching the {ICustomPattern} interface.",
	            type: lexer_public_1.LexerDefinitionErrorType.INVALID_PATTERN,
	            tokenClasses: [currClass]
	        };
	    });
	    var valid = utils_1.difference(tokenClasses, tokenClassesWithInvalidPattern);
	    return { errors: errors, valid: valid };
	}
	exports.findInvalidPatterns = findInvalidPatterns;
	var end_of_input = /[^\\][\$]/;
	function findEndOfInputAnchor(tokenClasses) {
	    var invalidRegex = utils_1.filter(tokenClasses, function (currClass) {
	        var pattern = currClass[PATTERN];
	        return end_of_input.test(pattern.source);
	    });
	    var errors = utils_1.map(invalidRegex, function (currClass) {
	        return {
	            message: "Token class: ->" + tokens_public_1.tokenName(currClass) + "<- static 'PATTERN' cannot contain end of input anchor '$'",
	            type: lexer_public_1.LexerDefinitionErrorType.EOI_ANCHOR_FOUND,
	            tokenClasses: [currClass]
	        };
	    });
	    return errors;
	}
	exports.findEndOfInputAnchor = findEndOfInputAnchor;
	function findUnsupportedFlags(tokenClasses) {
	    var invalidFlags = utils_1.filter(tokenClasses, function (currClass) {
	        var pattern = currClass[PATTERN];
	        return pattern instanceof RegExp && (pattern.multiline || pattern.global);
	    });
	    var errors = utils_1.map(invalidFlags, function (currClass) {
	        return {
	            message: "Token class: ->" + tokens_public_1.tokenName(currClass) +
	                "<- static 'PATTERN' may NOT contain global('g') or multiline('m')",
	            type: lexer_public_1.LexerDefinitionErrorType.UNSUPPORTED_FLAGS_FOUND,
	            tokenClasses: [currClass]
	        };
	    });
	    return errors;
	}
	exports.findUnsupportedFlags = findUnsupportedFlags;
	// This can only test for identical duplicate RegExps, not semantically equivalent ones.
	function findDuplicatePatterns(tokenClasses) {
	    var found = [];
	    var identicalPatterns = utils_1.map(tokenClasses, function (outerClass) {
	        return utils_1.reduce(tokenClasses, function (result, innerClass) {
	            if ((outerClass.PATTERN.source === innerClass.PATTERN.source) && !utils_1.contains(found, innerClass) &&
	                innerClass.PATTERN !== lexer_public_1.Lexer.NA) {
	                // this avoids duplicates in the result, each class may only appear in one "set"
	                // in essence we are creating Equivalence classes on equality relation.
	                found.push(innerClass);
	                result.push(innerClass);
	                return result;
	            }
	            return result;
	        }, []);
	    });
	    identicalPatterns = utils_1.compact(identicalPatterns);
	    var duplicatePatterns = utils_1.filter(identicalPatterns, function (currIdenticalSet) {
	        return currIdenticalSet.length > 1;
	    });
	    var errors = utils_1.map(duplicatePatterns, function (setOfIdentical) {
	        var classNames = utils_1.map(setOfIdentical, function (currClass) {
	            return tokens_public_1.tokenName(currClass);
	        });
	        var dupPatternSrc = utils_1.first(setOfIdentical).PATTERN;
	        return {
	            message: "The same RegExp pattern ->" + dupPatternSrc + "<-" +
	                ("has been used in all the following classes: " + classNames.join(", ") + " <-"),
	            type: lexer_public_1.LexerDefinitionErrorType.DUPLICATE_PATTERNS_FOUND,
	            tokenClasses: setOfIdentical
	        };
	    });
	    return errors;
	}
	exports.findDuplicatePatterns = findDuplicatePatterns;
	function findInvalidGroupType(tokenClasses) {
	    var invalidTypes = utils_1.filter(tokenClasses, function (clazz) {
	        if (!utils_1.has(clazz, "GROUP")) {
	            return false;
	        }
	        var group = clazz.GROUP;
	        return group !== lexer_public_1.Lexer.SKIPPED &&
	            group !== lexer_public_1.Lexer.NA && !utils_1.isString(group);
	    });
	    var errors = utils_1.map(invalidTypes, function (currClass) {
	        return {
	            message: "Token class: ->" + tokens_public_1.tokenName(currClass) + "<- static 'GROUP' can only be Lexer.SKIPPED/Lexer.NA/A String",
	            type: lexer_public_1.LexerDefinitionErrorType.INVALID_GROUP_TYPE_FOUND,
	            tokenClasses: [currClass]
	        };
	    });
	    return errors;
	}
	exports.findInvalidGroupType = findInvalidGroupType;
	function findModesThatDoNotExist(tokenClasses, validModes) {
	    var invalidModes = utils_1.filter(tokenClasses, function (clazz) {
	        return clazz.PUSH_MODE !== undefined && !utils_1.contains(validModes, clazz.PUSH_MODE);
	    });
	    var errors = utils_1.map(invalidModes, function (clazz) {
	        var msg = "Token class: ->" + tokens_public_1.tokenName(clazz) + "<- static 'PUSH_MODE' value cannot refer to a Lexer Mode ->" + clazz.PUSH_MODE + "<-" +
	            "which does not exist";
	        return {
	            message: msg,
	            type: lexer_public_1.LexerDefinitionErrorType.PUSH_MODE_DOES_NOT_EXIST,
	            tokenClasses: [clazz]
	        };
	    });
	    return errors;
	}
	exports.findModesThatDoNotExist = findModesThatDoNotExist;
	function addStartOfInput(pattern) {
	    var flags = pattern.ignoreCase ?
	        "i" :
	        "";
	    // always wrapping in a none capturing group preceded by '^' to make sure matching can only work on start of input.
	    // duplicate/redundant start of input markers have no meaning (/^^^^A/ === /^A/)
	    return new RegExp("^(?:" + pattern.source + ")", flags);
	}
	exports.addStartOfInput = addStartOfInput;
	function countLineTerminators(text) {
	    var lineTerminators = 0;
	    var currOffset = 0;
	    while (currOffset < text.length) {
	        var c = text.charCodeAt(currOffset);
	        if (c === 10) {
	            lineTerminators++;
	        }
	        else if (c === 13) {
	            if (currOffset !== text.length - 1 &&
	                text.charCodeAt(currOffset + 1) === 10) {
	            }
	            else {
	                lineTerminators++;
	            }
	        }
	        currOffset++;
	    }
	    return lineTerminators;
	}
	exports.countLineTerminators = countLineTerminators;
	function performRuntimeChecks(lexerDefinition) {
	    var errors = [];
	    // some run time checks to help the end users.
	    if (!utils_1.has(lexerDefinition, exports.DEFAULT_MODE)) {
	        errors.push({
	            message: "A MultiMode Lexer cannot be initialized without a <" + exports.DEFAULT_MODE + "> property in its definition\n",
	            type: lexer_public_1.LexerDefinitionErrorType.MULTI_MODE_LEXER_WITHOUT_DEFAULT_MODE
	        });
	    }
	    if (!utils_1.has(lexerDefinition, exports.MODES)) {
	        errors.push({
	            message: "A MultiMode Lexer cannot be initialized without a <" + exports.MODES + "> property in its definition\n",
	            type: lexer_public_1.LexerDefinitionErrorType.MULTI_MODE_LEXER_WITHOUT_MODES_PROPERTY
	        });
	    }
	    if (utils_1.has(lexerDefinition, exports.MODES) &&
	        utils_1.has(lexerDefinition, exports.DEFAULT_MODE) && !utils_1.has(lexerDefinition.modes, lexerDefinition.defaultMode)) {
	        errors.push({
	            message: "A MultiMode Lexer cannot be initialized with a " + exports.DEFAULT_MODE + ": <" + lexerDefinition.defaultMode + ">"
	                + "which does not exist\n",
	            type: lexer_public_1.LexerDefinitionErrorType.MULTI_MODE_LEXER_DEFAULT_MODE_VALUE_DOES_NOT_EXIST
	        });
	    }
	    if (utils_1.has(lexerDefinition, exports.MODES)) {
	        utils_1.forEach(lexerDefinition.modes, function (currModeValue, currModeName) {
	            utils_1.forEach(currModeValue, function (currTokClass, currIdx) {
	                if (utils_1.isUndefined(currTokClass)) {
	                    errors.push({
	                        message: "A Lexer cannot be initialized using an undefined Token Class. Mode:" +
	                            ("<" + currModeName + "> at index: <" + currIdx + ">\n"),
	                        type: lexer_public_1.LexerDefinitionErrorType.LEXER_DEFINITION_CANNOT_CONTAIN_UNDEFINED
	                    });
	                }
	            });
	        });
	    }
	    return errors;
	}
	exports.performRuntimeChecks = performRuntimeChecks;
	function checkLazyMode(allTokenTypes) {
	    var errors = [];
	    var allTokensTypeSet = utils_1.uniq(allTokenTypes, function (currTokType) { return tokens_public_1.tokenName(currTokType); });
	    var areAllLazy = utils_1.every(allTokensTypeSet, function (currTokType) { return tokens_1.isLazyTokenType(currTokType); });
	    // TODO: why is this second check required?
	    var areAllNotLazy = utils_1.every(allTokensTypeSet, function (currTokType) { return !tokens_1.isLazyTokenType(currTokType); });
	    if (!areAllLazy && !areAllNotLazy) {
	        var lazyTokens = utils_1.filter(allTokensTypeSet, function (currTokType) { return tokens_1.isLazyTokenType(currTokType); });
	        var lazyTokensNames = utils_1.map(lazyTokens, tokens_public_1.tokenName);
	        var lazyTokensString = lazyTokensNames.join("\n\t");
	        var notLazyTokens = utils_1.filter(allTokensTypeSet, function (currTokType) { return !tokens_1.isLazyTokenType(currTokType); });
	        var notLazyTokensNames = utils_1.map(notLazyTokens, tokens_public_1.tokenName);
	        var notLazyTokensString = notLazyTokensNames.join("\n\t");
	        errors.push({
	            message: "A Lexer cannot be defined using a mix of both Lazy and Non-Lazy Tokens:\n" +
	                "Lazy Tokens:\n\t" +
	                lazyTokensString +
	                "\nNon-Lazy Tokens:\n\t" +
	                notLazyTokensString,
	            type: lexer_public_1.LexerDefinitionErrorType.LEXER_DEFINITION_CANNOT_MIX_LAZY_AND_NOT_LAZY
	        });
	    }
	    return {
	        isLazy: areAllLazy,
	        errors: errors
	    };
	}
	exports.checkLazyMode = checkLazyMode;
	function checkSimpleMode(allTokenTypes) {
	    var errors = [];
	    var allTokensTypeSet = utils_1.uniq(allTokenTypes, function (currTokType) { return tokens_public_1.tokenName(currTokType); });
	    var areAllSimple = utils_1.every(allTokensTypeSet, function (currTokType) { return tokens_1.isSimpleTokenType(currTokType); });
	    // TODO: why is the second check required?
	    var areAllNotSimple = utils_1.every(allTokensTypeSet, function (currTokType) { return !tokens_1.isSimpleTokenType(currTokType); });
	    if (!areAllSimple && !areAllNotSimple) {
	        var simpleTokens = utils_1.filter(allTokensTypeSet, function (currTokType) { return tokens_1.isSimpleTokenType(currTokType); });
	        var simpleTokensNames = utils_1.map(simpleTokens, tokens_public_1.tokenName);
	        var simpleTokensString = simpleTokensNames.join("\n\t");
	        var notSimpleTokens = utils_1.filter(allTokensTypeSet, function (currTokType) { return !tokens_1.isSimpleTokenType(currTokType); });
	        var notSimpleTokensNames = utils_1.map(notSimpleTokens, tokens_public_1.tokenName);
	        var notSimpleTokensString = notSimpleTokensNames.join("\n\t");
	        errors.push({
	            message: "A Lexer cannot be defined using a mix of both Simple and Non-Simple Tokens:\n" +
	                "Simple Tokens:\n\t" +
	                simpleTokensString +
	                "\nNon-Simple Tokens:\n\t" +
	                notSimpleTokensString,
	            type: lexer_public_1.LexerDefinitionErrorType.LEXER_DEFINITION_CANNOT_MIX_SIMPLE_AND_NOT_SIMPLE
	        });
	    }
	    return {
	        isSimple: areAllSimple,
	        errors: errors
	    };
	}
	exports.checkSimpleMode = checkSimpleMode;
	function cloneEmptyGroups(emptyGroups) {
	    var clonedResult = {};
	    var groupKeys = utils_1.keys(emptyGroups);
	    utils_1.forEach(groupKeys, function (currKey) {
	        var currGroupValue = emptyGroups[currKey];
	        /* istanbul ignore else */
	        if (utils_1.isArray(currGroupValue)) {
	            clonedResult[currKey] = [];
	        }
	        else {
	            /* istanbul ignore next */ throw Error("non exhaustive match");
	        }
	    });
	    return clonedResult;
	}
	exports.cloneEmptyGroups = cloneEmptyGroups;
	//# sourceMappingURL=lexer.js.map

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var utils_1 = __webpack_require__(1016);
	var tokens_public_1 = __webpack_require__(1020);
	var lang_extensions_1 = __webpack_require__(1015);
	function fillUpLineToOffset(lineToOffset, text) {
	    var currLine = 0;
	    var currOffset = 0;
	    // line 1 (idx 0 in the array) always starts at offset 0
	    lineToOffset.push(0);
	    while (currOffset < text.length) {
	        var c = text.charCodeAt(currOffset);
	        if (c === 10) {
	            currLine++;
	            // +1 because the next line starts only AFTER the "\n"
	            lineToOffset.push(currOffset + 1);
	        }
	        else if (c === 13) {
	            if (currOffset !== text.length - 1 &&
	                text.charCodeAt(currOffset + 1) === 10) {
	                // +2 because the next line starts only AFTER the "\r\n"
	                lineToOffset.push(currOffset + 2);
	                // "consume" two chars
	                currOffset++;
	            }
	            else {
	                currLine++;
	                // +1 because the next line starts only AFTER the "\r"
	                lineToOffset.push(currOffset + 1);
	            }
	        }
	        currOffset++;
	    }
	    // to make the data structure consistent
	    lineToOffset.push(Infinity);
	}
	exports.fillUpLineToOffset = fillUpLineToOffset;
	function getStartLineFromLineToOffset(startOffset, lineToOffset) {
	    return findLineOfOffset(startOffset, lineToOffset);
	}
	exports.getStartLineFromLineToOffset = getStartLineFromLineToOffset;
	function getEndLineFromLineToOffset(endOffset, lineToOffset) {
	    return findLineOfOffset(endOffset, lineToOffset);
	}
	exports.getEndLineFromLineToOffset = getEndLineFromLineToOffset;
	function getStartColumnFromLineToOffset(startOffset, lineToOffset) {
	    return findColumnOfOffset(startOffset, lineToOffset);
	}
	exports.getStartColumnFromLineToOffset = getStartColumnFromLineToOffset;
	function getEndColumnFromLineToOffset(endOffset, lineToOffset) {
	    // none inclusive
	    return findColumnOfOffset(endOffset, lineToOffset);
	}
	exports.getEndColumnFromLineToOffset = getEndColumnFromLineToOffset;
	/**
	 *  Modification of a binary search to seek
	 */
	function findLineOfOffset(targetOffset, lineToOffset) {
	    var lowIdx = 0;
	    var highIdx = lineToOffset.length - 1;
	    var found = false;
	    var line = -1;
	    while (!found) {
	        var middleIdx = Math.floor((highIdx + lowIdx) / 2);
	        var middleOffset = lineToOffset[middleIdx];
	        var middleNextOffset = lineToOffset[middleIdx + 1];
	        if (middleOffset <= targetOffset &&
	            middleNextOffset > targetOffset) {
	            found = true;
	            line = middleIdx;
	        }
	        else if (middleOffset > targetOffset) {
	            highIdx = middleIdx;
	        }
	        else if (middleNextOffset < targetOffset) {
	            lowIdx = middleIdx;
	        }/* istanbul ignore else */ 
	        else if (middleNextOffset === targetOffset) {
	            found = true;
	            line = middleIdx + 1;
	        }
	        else {
	            /* istanbul ignore next */ throw Error("non exhaustive match");
	        }
	    }
	    // +1 because lines are counted from 1 while array indices are zero based.
	    return line + 1;
	}
	function findColumnOfOffset(offset, lineToOffset) {
	    var line = findLineOfOffset(offset, lineToOffset);
	    // +1 because columns always start at 1
	    return offset - lineToOffset[line - 1] + 1;
	}
	function tokenStructuredMatcher(tokInstance, tokConstructor) {
	    if (tokInstance.tokenType === tokConstructor.tokenType) {
	        return true;
	    }
	    else if (tokConstructor.extendingTokenTypes.length > 0) {
	        var extendingTokenTypes = tokConstructor.extendingTokenTypes;
	        var extendingTokenTypesLength = extendingTokenTypes.length;
	        for (var i = 0; i < extendingTokenTypesLength; i++) {
	            if (extendingTokenTypes[i] === tokInstance.tokenType) {
	                return true;
	            }
	        }
	        return false;
	    }
	    else {
	        return false;
	    }
	}
	exports.tokenStructuredMatcher = tokenStructuredMatcher;
	function tokenInstanceofMatcher(tokInstance, tokConstructor) {
	    return tokInstance instanceof tokConstructor;
	}
	exports.tokenInstanceofMatcher = tokenInstanceofMatcher;
	function tokenClassIdentity(tokenConstructor) {
	    // return tokenName(tokenConstructor)
	    return tokenConstructor.tokenType;
	}
	exports.tokenClassIdentity = tokenClassIdentity;
	function tokenInstanceIdentity(tokenInstance) {
	    return tokenInstance.constructor.tokenType;
	}
	exports.tokenInstanceIdentity = tokenInstanceIdentity;
	function tokenStructuredIdentity(token) {
	    return token.tokenType;
	}
	exports.tokenStructuredIdentity = tokenStructuredIdentity;
	function isBaseTokenOrObject(tokClass) {
	    return isBaseTokenClass(tokClass) || tokClass === Object;
	}
	exports.isBaseTokenOrObject = isBaseTokenOrObject;
	function isBaseTokenClass(tokClass) {
	    return tokClass === tokens_public_1.Token || tokClass === tokens_public_1.LazyToken || tokClass === tokens_public_1.SimpleLazyToken;
	}
	exports.isBaseTokenClass = isBaseTokenClass;
	exports.tokenShortNameIdx = 1;
	exports.tokenIdxToClass = new lang_extensions_1.HashTable();
	function augmentTokenClasses(tokenClasses) {
	    // 1. collect the parent Token classes as well.
	    var tokenClassesAndParents = expandTokenHierarchy(tokenClasses);
	    // 2. add required tokenType and extendingTokenTypes properties
	    assignTokenDefaultProps(tokenClassesAndParents);
	    // 3. fill up the extendingTokenTypes
	    assignExtendingTokensProp(tokenClassesAndParents);
	}
	exports.augmentTokenClasses = augmentTokenClasses;
	function expandTokenHierarchy(tokenClasses) {
	    var tokenClassesAndParents = utils_1.cloneArr(tokenClasses);
	    utils_1.forEach(tokenClasses, function (currTokClass) {
	        var currParentClass = utils_1.getSuperClass(currTokClass);
	        while (!isBaseTokenOrObject(currParentClass)) {
	            if (!utils_1.contains(tokenClassesAndParents, currParentClass)) {
	                tokenClassesAndParents.push(currParentClass);
	            }
	            currParentClass = utils_1.getSuperClass(currParentClass);
	        }
	    });
	    return tokenClassesAndParents;
	}
	exports.expandTokenHierarchy = expandTokenHierarchy;
	function assignTokenDefaultProps(tokenClasses) {
	    utils_1.forEach(tokenClasses, function (currTokClass) {
	        if (!hasShortKeyProperty(currTokClass)) {
	            exports.tokenIdxToClass.put(exports.tokenShortNameIdx, currTokClass);
	            currTokClass.tokenType = exports.tokenShortNameIdx++;
	        }
	        if (!hasExtendingTokensTypesProperty(currTokClass)) {
	            currTokClass.extendingTokenTypes = [];
	        }
	    });
	}
	exports.assignTokenDefaultProps = assignTokenDefaultProps;
	function assignExtendingTokensProp(tokenClasses) {
	    utils_1.forEach(tokenClasses, function (currTokClass) {
	        var currSubClassesExtendingTypes = [currTokClass.tokenType];
	        var currParentClass = utils_1.getSuperClass(currTokClass);
	        while (!isBaseTokenClass(currParentClass) && currParentClass !== Object) {
	            var newExtendingTypes = utils_1.difference(currSubClassesExtendingTypes, currParentClass.extendingTokenTypes);
	            currParentClass.extendingTokenTypes = currParentClass.extendingTokenTypes.concat(newExtendingTypes);
	            currSubClassesExtendingTypes.push(currParentClass.tokenType);
	            currParentClass = utils_1.getSuperClass(currParentClass);
	        }
	    });
	}
	exports.assignExtendingTokensProp = assignExtendingTokensProp;
	function hasShortKeyProperty(tokClass) {
	    return utils_1.has(tokClass, "tokenType");
	}
	exports.hasShortKeyProperty = hasShortKeyProperty;
	function hasExtendingTokensTypesProperty(tokClass) {
	    return utils_1.has(tokClass, "extendingTokenTypes");
	}
	exports.hasExtendingTokensTypesProperty = hasExtendingTokensTypesProperty;
	function createSimpleLazyToken(startOffset, endOffset, tokClass, cacheData) {
	    return {
	        startOffset: startOffset,
	        endOffset: endOffset,
	        tokenType: tokClass.tokenType,
	        cacheData: cacheData
	    };
	}
	exports.createSimpleLazyToken = createSimpleLazyToken;
	function createLazyTokenInstance(startOffset, endOffset, tokClass, cacheData) {
	    return new tokClass(startOffset, endOffset, cacheData);
	}
	exports.createLazyTokenInstance = createLazyTokenInstance;
	function isInheritanceBasedToken(token) {
	    return token instanceof tokens_public_1.Token || token instanceof tokens_public_1.LazyToken;
	}
	exports.isInheritanceBasedToken = isInheritanceBasedToken;
	function getImageFromLazyToken(lazyToken) {
	    if (lazyToken.isInsertedInRecovery) {
	        return "";
	    }
	    return lazyToken.cacheData.orgText.substring(lazyToken.startOffset, lazyToken.endOffset + 1);
	}
	exports.getImageFromLazyToken = getImageFromLazyToken;
	function getStartLineFromLazyToken(lazyToken) {
	    if (lazyToken.isInsertedInRecovery) {
	        return NaN;
	    }
	    ensureLineDataProcessing(lazyToken.cacheData);
	    return getStartLineFromLineToOffset(lazyToken.startOffset, lazyToken.cacheData.lineToOffset);
	}
	exports.getStartLineFromLazyToken = getStartLineFromLazyToken;
	function getStartColumnFromLazyToken(lazyToken) {
	    if (lazyToken.isInsertedInRecovery) {
	        return NaN;
	    }
	    ensureLineDataProcessing(lazyToken.cacheData);
	    return getStartColumnFromLineToOffset(lazyToken.startOffset, lazyToken.cacheData.lineToOffset);
	}
	exports.getStartColumnFromLazyToken = getStartColumnFromLazyToken;
	function getEndLineFromLazyToken(lazyToken) {
	    if (lazyToken.isInsertedInRecovery) {
	        return NaN;
	    }
	    ensureLineDataProcessing(lazyToken.cacheData);
	    return getEndLineFromLineToOffset(lazyToken.endOffset, lazyToken.cacheData.lineToOffset);
	}
	exports.getEndLineFromLazyToken = getEndLineFromLazyToken;
	function getEndColumnFromLazyToken(lazyToken) {
	    if (lazyToken.isInsertedInRecovery) {
	        return NaN;
	    }
	    ensureLineDataProcessing(lazyToken.cacheData);
	    return getEndColumnFromLineToOffset(lazyToken.endOffset, lazyToken.cacheData.lineToOffset);
	}
	exports.getEndColumnFromLazyToken = getEndColumnFromLazyToken;
	function ensureLineDataProcessing(cacheData) {
	    if (utils_1.isEmpty(cacheData.lineToOffset)) {
	        fillUpLineToOffset(cacheData.lineToOffset, cacheData.orgText);
	    }
	}
	exports.ensureLineDataProcessing = ensureLineDataProcessing;
	function isLazyTokenType(tokType) {
	    return tokens_public_1.LazyToken.prototype.isPrototypeOf(tokType.prototype) ||
	        tokens_public_1.SimpleLazyToken.prototype.isPrototypeOf(tokType.prototype);
	}
	exports.isLazyTokenType = isLazyTokenType;
	function isSimpleTokenType(tokType) {
	    return tokens_public_1.SimpleLazyToken.prototype.isPrototypeOf(tokType.prototype);
	}
	exports.isSimpleTokenType = isSimpleTokenType;
	//# sourceMappingURL=tokens.js.map

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) /* istanbul ignore next */  if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    /* istanbul ignore next */  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var utils = __webpack_require__(1016);
	var utils_1 = __webpack_require__(1016);
	var parser_public_1 = __webpack_require__(1013);
	var gast_public_1 = __webpack_require__(1019);
	var gast_1 = __webpack_require__(1025);
	var tokens_public_1 = __webpack_require__(1020);
	var first_1 = __webpack_require__(1026);
	var lookahead_1 = __webpack_require__(1027);
	function validateGrammar(topLevels, maxLookahead, ignoredIssues) {
	    var duplicateErrors = utils.map(topLevels, validateDuplicateProductions);
	    var leftRecursionErrors = utils.map(topLevels, function (currTopRule) { return validateNoLeftRecursion(currTopRule, currTopRule); });
	    var emptyAltErrors = utils_1.map(topLevels, validateEmptyOrAlternative);
	    var ambiguousAltsErrors = utils_1.map(topLevels, function (currTopRule) {
	        return validateAmbiguousAlternationAlternatives(currTopRule, maxLookahead, ignoredIssues);
	    });
	    return utils.flatten(duplicateErrors.concat(leftRecursionErrors, emptyAltErrors, ambiguousAltsErrors));
	}
	exports.validateGrammar = validateGrammar;
	function validateDuplicateProductions(topLevelRule) {
	    var collectorVisitor = new OccurrenceValidationCollector();
	    topLevelRule.accept(collectorVisitor);
	    var allRuleProductions = collectorVisitor.allProductions;
	    var productionGroups = utils.groupBy(allRuleProductions, identifyProductionForDuplicates);
	    var duplicates = utils.pick(productionGroups, function (currGroup) {
	        return currGroup.length > 1;
	    });
	    var errors = utils.map(utils.values(duplicates), function (currDuplicates) {
	        var firstProd = utils.first(currDuplicates);
	        var msg = createDuplicatesErrorMessage(currDuplicates, topLevelRule.name);
	        var dslName = gast_1.getProductionDslName(firstProd);
	        var defError = {
	            message: msg,
	            type: parser_public_1.ParserDefinitionErrorType.DUPLICATE_PRODUCTIONS,
	            ruleName: topLevelRule.name,
	            dslName: dslName,
	            occurrence: firstProd.occurrenceInParent
	        };
	        var param = getExtraProductionArgument(firstProd);
	        if (param) {
	            defError.parameter = param;
	        }
	        return defError;
	    });
	    return errors;
	}
	function createDuplicatesErrorMessage(duplicateProds, topLevelName) {
	    var firstProd = utils.first(duplicateProds);
	    var index = firstProd.occurrenceInParent;
	    var dslName = gast_1.getProductionDslName(firstProd);
	    var extraArgument = getExtraProductionArgument(firstProd);
	    var msg = "->" + dslName + "<- with occurrence index: ->" + index + "<-\n                  " + (extraArgument ? "and argument: " + extraArgument : "") + "\n                  appears more than once (" + duplicateProds.length + " times) in the top level rule: " + topLevelName + ".\n                  " + (index === 1 ? "note that " + dslName + " and " + dslName + "1 both have the same occurrence index 1}" : "") + "}\n                  to fix this make sure each usage of " + dslName + " " + (extraArgument ? "with the argument: " + extraArgument : "") + "\n                  in the rule " + topLevelName + " has a different occurrence index (1-5), as that combination acts as a unique\n                  position key in the grammar, which is needed by the parsing engine.";
	    // white space trimming time! better to trim afterwards as it allows to use WELL formatted multi line template strings...
	    msg = msg.replace(/[ \t]+/g, " ");
	    msg = msg.replace(/\s\s+/g, "\n");
	    return msg;
	}
	function identifyProductionForDuplicates(prod) {
	    return gast_1.getProductionDslName(prod) + "_#_" + prod.occurrenceInParent + "_#_" + getExtraProductionArgument(prod);
	}
	exports.identifyProductionForDuplicates = identifyProductionForDuplicates;
	function getExtraProductionArgument(prod) {
	    if (prod instanceof gast_public_1.gast.Terminal) {
	        return tokens_public_1.tokenName(prod.terminalType);
	    }
	    else if (prod instanceof gast_public_1.gast.NonTerminal) {
	        return prod.nonTerminalName;
	    }
	    else {
	        return "";
	    }
	}
	var OccurrenceValidationCollector = (function (_super) {
	    __extends(OccurrenceValidationCollector, _super);
	    function OccurrenceValidationCollector() {
	        var _this = _super.apply(this, arguments) /* istanbul ignore next */ || this;
	        _this.allProductions = [];
	        return _this;
	    }
	    OccurrenceValidationCollector.prototype.visitNonTerminal = function (subrule) {
	        this.allProductions.push(subrule);
	    };
	    OccurrenceValidationCollector.prototype.visitOption = function (option) {
	        this.allProductions.push(option);
	    };
	    OccurrenceValidationCollector.prototype.visitRepetitionWithSeparator = function (manySep) {
	        this.allProductions.push(manySep);
	    };
	    OccurrenceValidationCollector.prototype.visitRepetitionMandatory = function (atLeastOne) {
	        this.allProductions.push(atLeastOne);
	    };
	    OccurrenceValidationCollector.prototype.visitRepetitionMandatoryWithSeparator = function (atLeastOneSep) {
	        this.allProductions.push(atLeastOneSep);
	    };
	    OccurrenceValidationCollector.prototype.visitRepetition = function (many) {
	        this.allProductions.push(many);
	    };
	    OccurrenceValidationCollector.prototype.visitAlternation = function (or) {
	        this.allProductions.push(or);
	    };
	    OccurrenceValidationCollector.prototype.visitTerminal = function (terminal) {
	        this.allProductions.push(terminal);
	    };
	    return OccurrenceValidationCollector;
	}(gast_public_1.gast.GAstVisitor));
	exports.OccurrenceValidationCollector = OccurrenceValidationCollector;
	var ruleNamePattern = /^[a-zA-Z_]\w*$/;
	function validateRuleName(ruleName, className) {
	    var errors = [];
	    var errMsg;
	    if (!ruleName.match(ruleNamePattern)) {
	        errMsg = "Invalid Grammar rule name: ->" + ruleName + "<- it must match the pattern: ->" + ruleNamePattern.toString() + "<-";
	        errors.push({
	            message: errMsg,
	            type: parser_public_1.ParserDefinitionErrorType.INVALID_RULE_NAME,
	            ruleName: ruleName
	        });
	    }
	    return errors;
	}
	exports.validateRuleName = validateRuleName;
	function validateRuleDoesNotAlreadyExist(ruleName, definedRulesNames, className) {
	    var errors = [];
	    var errMsg;
	    if ((utils.contains(definedRulesNames, ruleName))) {
	        errMsg = "Duplicate definition, rule: ->" + ruleName + "<- is already defined in the grammar: ->" + className + "<-";
	        errors.push({
	            message: errMsg,
	            type: parser_public_1.ParserDefinitionErrorType.DUPLICATE_RULE_NAME,
	            ruleName: ruleName
	        });
	    }
	    return errors;
	}
	exports.validateRuleDoesNotAlreadyExist = validateRuleDoesNotAlreadyExist;
	// TODO: is there anyway to get only the rule names of rules inherited from the super grammars?
	function validateRuleIsOverridden(ruleName, definedRulesNames, className) {
	    var errors = [];
	    var errMsg;
	    if (!(utils.contains(definedRulesNames, ruleName))) {
	        errMsg = "Invalid rule override, rule: ->" + ruleName + "<- cannot be overridden in the grammar: ->" + className + "<-" +
	            "as it is not defined in any of the super grammars ";
	        errors.push({
	            message: errMsg,
	            type: parser_public_1.ParserDefinitionErrorType.INVALID_RULE_OVERRIDE,
	            ruleName: ruleName
	        });
	    }
	    return errors;
	}
	exports.validateRuleIsOverridden = validateRuleIsOverridden;
	function validateNoLeftRecursion(topRule, currRule, path) {
	    if (path === void 0) { path = []; }
	    var errors = [];
	    var nextNonTerminals = getFirstNoneTerminal(currRule.definition);
	    if (utils.isEmpty(nextNonTerminals)) {
	        return [];
	    }
	    else {
	        var ruleName = topRule.name;
	        var foundLeftRecursion = utils.contains(nextNonTerminals, topRule);
	        var pathNames = utils.map(path, function (currRule) { return currRule.name; });
	        var leftRecursivePath = ruleName + " --> " + pathNames.concat([ruleName]).join(" --> ");
	        if (foundLeftRecursion) {
	            var errMsg = "Left Recursion found in grammar.\n" +
	                ("rule: <" + ruleName + "> can be invoked from itself (directly or indirectly)\n") +
	                ("without consuming any Tokens. The grammar path that causes this is: \n " + leftRecursivePath + "\n") +
	                " To fix this refactor your grammar to remove the left recursion.\n" +
	                "see: https://en.wikipedia.org/wiki/LL_parser#Left_Factoring.";
	            errors.push({
	                message: errMsg,
	                type: parser_public_1.ParserDefinitionErrorType.LEFT_RECURSION,
	                ruleName: ruleName
	            });
	        }
	        // we are only looking for cyclic paths leading back to the specific topRule
	        // other cyclic paths are ignored, we still need this difference to avoid infinite loops...
	        var validNextSteps = utils.difference(nextNonTerminals, path.concat([topRule]));
	        var errorsFromNextSteps = utils.map(validNextSteps, function (currRefRule) {
	            var newPath = utils.cloneArr(path);
	            newPath.push(currRefRule);
	            return validateNoLeftRecursion(topRule, currRefRule, newPath);
	        });
	        return errors.concat(utils.flatten(errorsFromNextSteps));
	    }
	}
	exports.validateNoLeftRecursion = validateNoLeftRecursion;
	function getFirstNoneTerminal(definition) {
	    var result = [];
	    if (utils.isEmpty(definition)) {
	        return result;
	    }
	    var firstProd = utils.first(definition);
	    if (firstProd instanceof gast_public_1.gast.NonTerminal) {
	        result.push(firstProd.referencedRule);
	    }
	    else if (firstProd instanceof gast_public_1.gast.Flat ||
	        firstProd instanceof gast_public_1.gast.Option ||
	        firstProd instanceof gast_public_1.gast.RepetitionMandatory ||
	        firstProd instanceof gast_public_1.gast.RepetitionMandatoryWithSeparator ||
	        firstProd instanceof gast_public_1.gast.RepetitionWithSeparator ||
	        firstProd instanceof gast_public_1.gast.Repetition) {
	        result = result.concat(getFirstNoneTerminal(firstProd.definition));
	    }
	    else if (firstProd instanceof gast_public_1.gast.Alternation) {
	        // each sub definition in alternation is a FLAT
	        result = utils.flatten(utils.map(firstProd.definition, function (currSubDef) { return getFirstNoneTerminal(currSubDef.definition); }));
	    }/* istanbul ignore else */ 
	    else if (firstProd instanceof gast_public_1.gast.Terminal) {
	    }
	    else {
	        /* istanbul ignore next */ throw Error("non exhaustive match");
	    }
	    var isFirstOptional = gast_1.isOptionalProd(firstProd);
	    var hasMore = definition.length > 1;
	    if (isFirstOptional && hasMore) {
	        var rest = utils.drop(definition);
	        return result.concat(getFirstNoneTerminal(rest));
	    }
	    else {
	        return result;
	    }
	}
	exports.getFirstNoneTerminal = getFirstNoneTerminal;
	var OrCollector = (function (_super) {
	    __extends(OrCollector, _super);
	    function OrCollector() {
	        var _this = _super.apply(this, arguments) /* istanbul ignore next */ || this;
	        _this.alternations = [];
	        return _this;
	    }
	    OrCollector.prototype.visitAlternation = function (node) {
	        this.alternations.push(node);
	    };
	    return OrCollector;
	}(gast_public_1.gast.GAstVisitor));
	function validateEmptyOrAlternative(topLevelRule) {
	    var orCollector = new OrCollector();
	    topLevelRule.accept(orCollector);
	    var ors = orCollector.alternations;
	    var errors = utils.reduce(ors, function (errors, currOr) {
	        var exceptLast = utils.dropRight(currOr.definition);
	        var currErrors = utils.map(exceptLast, function (currAlternative, currAltIdx) {
	            if (utils.isEmpty(first_1.first(currAlternative))) {
	                return {
	                    message: "Ambiguous empty alternative: <" + (currAltIdx + 1) + ">" +
	                        (" in <OR" + currOr.occurrenceInParent + "> inside <" + topLevelRule.name + "> Rule.\n") +
	                        "Only the last alternative may be an empty alternative.",
	                    type: parser_public_1.ParserDefinitionErrorType.NONE_LAST_EMPTY_ALT,
	                    ruleName: topLevelRule.name,
	                    occurrence: currOr.occurrenceInParent,
	                    alternative: currAltIdx + 1
	                };
	            }
	            else {
	                return null;
	            }
	        });
	        return errors.concat(utils.compact(currErrors));
	    }, []);
	    return errors;
	}
	exports.validateEmptyOrAlternative = validateEmptyOrAlternative;
	function validateAmbiguousAlternationAlternatives(topLevelRule, maxLookahead, ignoredIssues) {
	    var orCollector = new OrCollector();
	    topLevelRule.accept(orCollector);
	    var ors = orCollector.alternations;
	    var ignoredIssuesForCurrentRule = ignoredIssues[topLevelRule.name];
	    if (ignoredIssuesForCurrentRule) {
	        ors = utils_1.reject(ors, function (currOr) { return ignoredIssuesForCurrentRule[gast_1.getProductionDslName(currOr) + currOr.occurrenceInParent]; });
	    }
	    var errors = utils.reduce(ors, function (result, currOr) {
	        var currOccurrence = currOr.occurrenceInParent;
	        var alternatives = lookahead_1.getLookaheadPathsForOr(currOccurrence, topLevelRule, maxLookahead);
	        var altsAmbiguityErrors = checkAlternativesAmbiguities(alternatives);
	        var currErrors = utils.map(altsAmbiguityErrors, function (currAmbDescriptor) {
	            var ambgIndices = utils_1.map(currAmbDescriptor.alts, function (currAltIdx) { return currAltIdx + 1; });
	            var pathMsg = utils_1.map(currAmbDescriptor.path, function (currtok) { return tokens_public_1.tokenLabel(currtok); }).join(", ");
	            var currMessage = "Ambiguous alternatives: <" + ambgIndices.join(" ,") + "> in <OR" + currOccurrence + ">" +
	                (" inside <" + topLevelRule.name + "> Rule,\n") +
	                ("<" + pathMsg + "> may appears as a prefix path in all these alternatives.\n");
	            // Should this information be on the error message or in some common errors docs?
	            currMessage = currMessage + "To Resolve this, try one of of the following: \n" +
	                "1. Refactor your grammar to be LL(K) for the current value of k (by default k=5)\n" +
	                "2. Increase the value of K for your grammar by providing a larger 'maxLookahead' value in the parser's config\n" +
	                "3. This issue can be ignored (if you know what you are doing...), see" +
	                " http://sap.github.io/chevrotain/documentation/0_9_0/interfaces/iparserconfig.html for\n";
	            return {
	                message: currMessage,
	                type: parser_public_1.ParserDefinitionErrorType.AMBIGUOUS_ALTS,
	                ruleName: topLevelRule.name,
	                occurrence: currOr.occurrenceInParent,
	                alternatives: [currAmbDescriptor.alts]
	            };
	        });
	        return result.concat(currErrors);
	    }, []);
	    return errors;
	}
	exports.validateAmbiguousAlternationAlternatives = validateAmbiguousAlternationAlternatives;
	function checkAlternativesAmbiguities(alternatives) {
	    var foundAmbiguousPaths = [];
	    var identicalAmbiguities = utils_1.reduce(alternatives, function (result, currAlt, currAltIdx) {
	        utils_1.forEach(currAlt, function (currPath) {
	            var altsCurrPathAppearsIn = [currAltIdx];
	            utils_1.forEach(alternatives, function (currOtherAlt, currOtherAltIdx) {
	                if (currAltIdx !== currOtherAltIdx && lookahead_1.containsPath(currOtherAlt, currPath)) {
	                    altsCurrPathAppearsIn.push(currOtherAltIdx);
	                }
	            });
	            if (altsCurrPathAppearsIn.length > 1 && !lookahead_1.containsPath(foundAmbiguousPaths, currPath)) {
	                foundAmbiguousPaths.push(currPath);
	                result.push({
	                    alts: altsCurrPathAppearsIn,
	                    path: currPath
	                });
	            }
	        });
	        return result;
	    }, []);
	    return identicalAmbiguities;
	}
	//# sourceMappingURL=checks.js.map

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) /* istanbul ignore next */  if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    /* istanbul ignore next */  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var gast_public_1 = __webpack_require__(1019);
	var utils_1 = __webpack_require__(1016);
	function isSequenceProd(prod) {
	    return prod instanceof gast_public_1.gast.Flat ||
	        prod instanceof gast_public_1.gast.Option ||
	        prod instanceof gast_public_1.gast.Repetition ||
	        prod instanceof gast_public_1.gast.RepetitionMandatory ||
	        prod instanceof gast_public_1.gast.RepetitionMandatoryWithSeparator ||
	        prod instanceof gast_public_1.gast.RepetitionWithSeparator ||
	        prod instanceof gast_public_1.gast.Terminal ||
	        prod instanceof gast_public_1.gast.Rule;
	}
	exports.isSequenceProd = isSequenceProd;
	function isOptionalProd(prod, alreadyVisited) {
	    if (alreadyVisited === void 0) { alreadyVisited = []; }
	    var isDirectlyOptional = prod instanceof gast_public_1.gast.Option ||
	        prod instanceof gast_public_1.gast.Repetition ||
	        prod instanceof gast_public_1.gast.RepetitionWithSeparator;
	    if (isDirectlyOptional) {
	        return true;
	    }
	    // note that this can cause infinite loop if one optional empty TOP production has a cyclic dependency with another
	    // empty optional top rule
	    // may be indirectly optional ((A?B?C?) | (D?E?F?))
	    if (prod instanceof gast_public_1.gast.Alternation) {
	        // for OR its enough for just one of the alternatives to be optional
	        return utils_1.some(prod.definition, function (subProd) {
	            return isOptionalProd(subProd, alreadyVisited);
	        });
	    }
	    else if (prod instanceof gast_public_1.gast.NonTerminal && utils_1.contains(alreadyVisited, prod)) {
	        // avoiding stack overflow due to infinite recursion
	        return false;
	    }
	    else if (prod instanceof gast_public_1.gast.AbstractProduction) {
	        if (prod instanceof gast_public_1.gast.NonTerminal) {
	            alreadyVisited.push(prod);
	        }
	        return utils_1.every(prod.definition, function (subProd) {
	            return isOptionalProd(subProd, alreadyVisited);
	        });
	    }
	    else {
	        return false;
	    }
	}
	exports.isOptionalProd = isOptionalProd;
	function isBranchingProd(prod) {
	    return prod instanceof gast_public_1.gast.Alternation;
	}
	exports.isBranchingProd = isBranchingProd;
	function getProductionDslName(prod) {
	    if (prod instanceof gast_public_1.gast.NonTerminal) {
	        return "SUBRULE";
	    }
	    else if (prod instanceof gast_public_1.gast.Option) {
	        return "OPTION";
	    }
	    else if (prod instanceof gast_public_1.gast.Alternation) {
	        return "OR";
	    }
	    else if (prod instanceof gast_public_1.gast.RepetitionMandatory) {
	        return "AT_LEAST_ONE";
	    }
	    else if (prod instanceof gast_public_1.gast.RepetitionMandatoryWithSeparator) {
	        return "AT_LEAST_ONE_SEP";
	    }
	    else if (prod instanceof gast_public_1.gast.RepetitionWithSeparator) {
	        return "MANY_SEP";
	    }
	    else if (prod instanceof gast_public_1.gast.Repetition) {
	        return "MANY";
	    }/* istanbul ignore else */ 
	    else if (prod instanceof gast_public_1.gast.Terminal) {
	        return "CONSUME";
	    }
	    else {
	        /* istanbul ignore next */ throw Error("non exhaustive match");
	    }
	}
	exports.getProductionDslName = getProductionDslName;
	var GastCloneVisitor = (function (_super) {
	    __extends(GastCloneVisitor, _super);
	    function GastCloneVisitor() {
	        return _super.apply(this, arguments) /* istanbul ignore next */ || this;
	    }
	    GastCloneVisitor.prototype.visitNonTerminal = function (node) {
	        return new gast_public_1.gast.NonTerminal(node.nonTerminalName, undefined, node.occurrenceInParent);
	    };
	    GastCloneVisitor.prototype.visitFlat = function (node) {
	        var _this = this;
	        var definition = utils_1.map(node.definition, function (currSubDef) { return _this.visit(currSubDef); });
	        return new gast_public_1.gast.Flat(definition);
	    };
	    GastCloneVisitor.prototype.visitOption = function (node) {
	        var _this = this;
	        var definition = utils_1.map(node.definition, function (currSubDef) { return _this.visit(currSubDef); });
	        return new gast_public_1.gast.Option(definition, node.occurrenceInParent);
	    };
	    GastCloneVisitor.prototype.visitRepetition = function (node) {
	        var _this = this;
	        var definition = utils_1.map(node.definition, function (currSubDef) { return _this.visit(currSubDef); });
	        return new gast_public_1.gast.Repetition(definition, node.occurrenceInParent);
	    };
	    GastCloneVisitor.prototype.visitRepetitionMandatory = function (node) {
	        var _this = this;
	        var definition = utils_1.map(node.definition, function (currSubDef) { return _this.visit(currSubDef); });
	        return new gast_public_1.gast.RepetitionMandatory(definition, node.occurrenceInParent);
	    };
	    GastCloneVisitor.prototype.visitRepetitionMandatoryWithSeparator = function (node) {
	        var _this = this;
	        var definition = utils_1.map(node.definition, function (currSubDef) { return _this.visit(currSubDef); });
	        return new gast_public_1.gast.RepetitionMandatoryWithSeparator(definition, node.separator, node.occurrenceInParent);
	    };
	    GastCloneVisitor.prototype.visitRepetitionWithSeparator = function (node) {
	        var _this = this;
	        var definition = utils_1.map(node.definition, function (currSubDef) { return _this.visit(currSubDef); });
	        return new gast_public_1.gast.RepetitionWithSeparator(definition, node.separator, node.occurrenceInParent);
	    };
	    GastCloneVisitor.prototype.visitAlternation = function (node) {
	        var _this = this;
	        var definition = utils_1.map(node.definition, function (currSubDef) { return _this.visit(currSubDef); });
	        return new gast_public_1.gast.Alternation(definition, node.occurrenceInParent);
	    };
	    GastCloneVisitor.prototype.visitTerminal = function (node) {
	        return new gast_public_1.gast.Terminal(node.terminalType, node.occurrenceInParent);
	    };
	    GastCloneVisitor.prototype.visitRule = function (node) {
	        var _this = this;
	        var definition = utils_1.map(node.definition, function (currSubDef) { return _this.visit(currSubDef); });
	        return new gast_public_1.gast.Rule(node.name, definition, node.orgText);
	    };
	    return GastCloneVisitor;
	}(gast_public_1.gast.GAstVisitor));
	function cloneProduction(prod) {
	    var cloningVisitor = new GastCloneVisitor();
	    return cloningVisitor.visit(prod);
	}
	exports.cloneProduction = cloneProduction;
	//# sourceMappingURL=gast.js.map

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var gast_public_1 = __webpack_require__(1019);
	var gast_1 = __webpack_require__(1025);
	var utils_1 = __webpack_require__(1016);
	function first(prod) {
	    if (prod instanceof gast_public_1.gast.NonTerminal) {
	        // this could in theory cause infinite loops if
	        // (1) prod A refs prod B.
	        // (2) prod B refs prod A
	        // (3) AB can match the empty set
	        // in other words a cycle where everything is optional so the first will keep
	        // looking ahead for the next optional part and will never exit
	        // currently there is no safeguard for this unique edge case because
	        // (1) not sure a grammar in which this can happen is useful for anything (productive)
	        return first(prod.referencedRule);
	    }
	    else if (prod instanceof gast_public_1.gast.Terminal) {
	        return firstForTerminal(prod);
	    }
	    else if (gast_1.isSequenceProd(prod)) {
	        return firstForSequence(prod);
	    }/* istanbul ignore else */ 
	    else if (gast_1.isBranchingProd(prod)) {
	        return firstForBranching(prod);
	    }
	    else {
	        /* istanbul ignore next */ throw Error("non exhaustive match");
	    }
	}
	exports.first = first;
	function firstForSequence(prod) {
	    var firstSet = [];
	    var seq = prod.definition;
	    var nextSubProdIdx = 0;
	    var hasInnerProdsRemaining = seq.length > nextSubProdIdx;
	    var currSubProd;
	    // so we enter the loop at least once (if the definition is not empty
	    var isLastInnerProdOptional = true;
	    // scan a sequence until it's end or until we have found a NONE optional production in it
	    while (hasInnerProdsRemaining && isLastInnerProdOptional) {
	        currSubProd = seq[nextSubProdIdx];
	        isLastInnerProdOptional = gast_1.isOptionalProd(currSubProd);
	        firstSet = firstSet.concat(first(currSubProd));
	        nextSubProdIdx = nextSubProdIdx + 1;
	        hasInnerProdsRemaining = seq.length > nextSubProdIdx;
	    }
	    return utils_1.uniq(firstSet);
	}
	exports.firstForSequence = firstForSequence;
	function firstForBranching(prod) {
	    var allAlternativesFirsts = utils_1.map(prod.definition, function (innerProd) {
	        return first(innerProd);
	    });
	    return utils_1.uniq(utils_1.flatten(allAlternativesFirsts));
	}
	exports.firstForBranching = firstForBranching;
	function firstForTerminal(terminal) {
	    return [terminal.terminalType];
	}
	exports.firstForTerminal = firstForTerminal;
	//# sourceMappingURL=first.js.map

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) /* istanbul ignore next */  if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    /* istanbul ignore next */  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var utils_1 = __webpack_require__(1016);
	var gast_public_1 = __webpack_require__(1019);
	var interpreter_1 = __webpack_require__(1028);
	var rest_1 = __webpack_require__(1029);
	var PROD_TYPE;
	(function (PROD_TYPE) {
	    PROD_TYPE[PROD_TYPE["OPTION"] = 0] = "OPTION";
	    PROD_TYPE[PROD_TYPE["REPETITION"] = 1] = "REPETITION";
	    PROD_TYPE[PROD_TYPE["REPETITION_MANDATORY"] = 2] = "REPETITION_MANDATORY";
	    PROD_TYPE[PROD_TYPE["REPETITION_MANDATORY_WITH_SEPARATOR"] = 3] = "REPETITION_MANDATORY_WITH_SEPARATOR";
	    PROD_TYPE[PROD_TYPE["REPETITION_WITH_SEPARATOR"] = 4] = "REPETITION_WITH_SEPARATOR";
	    PROD_TYPE[PROD_TYPE["ALTERNATION"] = 5] = "ALTERNATION";
	})(PROD_TYPE = exports.PROD_TYPE || (exports.PROD_TYPE = {}));
	function buildLookaheadFuncForOr(occurrence, ruleGrammar, k, hasPredicates, tokenMatcher, tokenClassIdentityFunc, tokenIdentityFunc, dynamicTokensEnabled) {
	    var lookAheadPaths = getLookaheadPathsForOr(occurrence, ruleGrammar, k);
	    return buildAlternativesLookAheadFunc(lookAheadPaths, hasPredicates, tokenMatcher, tokenClassIdentityFunc, tokenIdentityFunc, dynamicTokensEnabled);
	}
	exports.buildLookaheadFuncForOr = buildLookaheadFuncForOr;
	/**
	 *  When dealing with an Optional production (OPTION/MANY/2nd iteration of AT_LEAST_ONE/...) we need to compare
	 *  the lookahead "inside" the production and the lookahead immediately "after" it in the same top level rule (context free).
	 *
	 *  Example: given a production:
	 *  ABC(DE)?DF
	 *
	 *  The optional '(DE)?' should only be entered if we see 'DE'. a single Token 'D' is not sufficient to distinguish between the two
	 *  alternatives.
	 *
	 *  @returns A Lookahead function which will return true IFF the parser should parse the Optional production.
	 */
	function buildLookaheadFuncForOptionalProd(occurrence, ruleGrammar, prodType, k, tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled) {
	    var lookAheadPaths = getLookaheadPathsForOptionalProd(occurrence, ruleGrammar, prodType, k);
	    return buildSingleAlternativeLookaheadFunction(lookAheadPaths[0], tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled);
	}
	exports.buildLookaheadFuncForOptionalProd = buildLookaheadFuncForOptionalProd;
	function buildLookaheadForOption(optionOccurrence, ruleGrammar, k, tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled) {
	    return buildLookaheadFuncForOptionalProd(optionOccurrence, ruleGrammar, PROD_TYPE.OPTION, k, tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled);
	}
	exports.buildLookaheadForOption = buildLookaheadForOption;
	function buildLookaheadForMany(optionOccurrence, ruleGrammar, k, tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled) {
	    return buildLookaheadFuncForOptionalProd(optionOccurrence, ruleGrammar, PROD_TYPE.REPETITION, k, tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled);
	}
	exports.buildLookaheadForMany = buildLookaheadForMany;
	function buildLookaheadForManySep(optionOccurrence, ruleGrammar, k, tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled) {
	    return buildLookaheadFuncForOptionalProd(optionOccurrence, ruleGrammar, PROD_TYPE.REPETITION_WITH_SEPARATOR, k, tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled);
	}
	exports.buildLookaheadForManySep = buildLookaheadForManySep;
	function buildLookaheadForAtLeastOne(optionOccurrence, ruleGrammar, k, tokenMatcher, tokenIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled) {
	    return buildLookaheadFuncForOptionalProd(optionOccurrence, ruleGrammar, PROD_TYPE.REPETITION_MANDATORY, k, tokenMatcher, tokenIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled);
	}
	exports.buildLookaheadForAtLeastOne = buildLookaheadForAtLeastOne;
	function buildLookaheadForAtLeastOneSep(optionOccurrence, ruleGrammar, k, tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled) {
	    return buildLookaheadFuncForOptionalProd(optionOccurrence, ruleGrammar, PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR, k, tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled);
	}
	exports.buildLookaheadForAtLeastOneSep = buildLookaheadForAtLeastOneSep;
	function buildAlternativesLookAheadFunc(alts, hasPredicates, tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled) {
	    var numOfAlts = alts.length;
	    var areAllOneTokenLookahead = utils_1.every(alts, function (currAlt) {
	        return utils_1.every(currAlt, function (currPath) {
	            return currPath.length === 1;
	        });
	    });
	    // This version takes into account the predicates as well.
	    if (hasPredicates) {
	        /**
	         * @returns {number} - The chosen alternative index
	         */
	        return function (orAlts) {
	            // unfortunately the predicates must be extracted every single time
	            // as they cannot be cached due to keep references to parameters(vars) which are no longer valid.
	            // note that in the common case of no predicates, no cpu time will be wasted on this (see else block)
	            var predicates = utils_1.map(orAlts, function (currAlt) { return currAlt.GATE; });
	            for (var t = 0; t < numOfAlts; t++) {
	                var currAlt = alts[t];
	                var currNumOfPaths = currAlt.length;
	                var currPredicate = predicates[t];
	                if (currPredicate && !currPredicate.call(this)) {
	                    // if the predicate does not match there is no point in checking the paths
	                    continue;
	                }
	                nextPath: for (var j = 0; j < currNumOfPaths; j++) {
	                    var currPath = currAlt[j];
	                    var currPathLength = currPath.length;
	                    for (var i = 0; i < currPathLength; i++) {
	                        var nextToken = this.LA(i + 1);
	                        if (!tokenMatcher(nextToken, currPath[i])) {
	                            // mismatch in current path
	                            // try the next pth
	                            continue nextPath;
	                        }
	                    }
	                    // found a full path that matches.
	                    // this will also work for an empty ALT as the loop will be skipped
	                    return t;
	                }
	            }
	            // none of the alternatives could be matched
	            return undefined;
	        };
	    }
	    else if (areAllOneTokenLookahead && !dynamicTokensEnabled) {
	        var singleTokenAlts = utils_1.map(alts, function (currAlt) {
	            return utils_1.flatten(currAlt);
	        });
	        var choiceToAlt_1 = utils_1.reduce(singleTokenAlts, function (result, currAlt, idx) {
	            utils_1.forEach(currAlt, function (currTokClass) {
	                if (!utils_1.has(result, tokenClassIdentityFunc(currTokClass))) {
	                    result[tokenClassIdentityFunc(currTokClass)] = idx;
	                }
	                utils_1.forEach(currTokClass.extendingTokenTypes, function (currExtendingType) {
	                    if (!utils_1.has(result, currExtendingType)) {
	                        result[currExtendingType] = idx;
	                    }
	                });
	            });
	            return result;
	        }, {});
	        /**
	         * @returns {number} - The chosen alternative index
	         */
	        return function () {
	            var nextToken = this.LA(1);
	            return choiceToAlt_1[tokenInstanceIdentityFunc(nextToken)];
	        };
	    }
	    else {
	        /**
	         * @returns {number} - The chosen alternative index
	         */
	        return function () {
	            for (var t = 0; t < numOfAlts; t++) {
	                var currAlt = alts[t];
	                var currNumOfPaths = currAlt.length;
	                nextPath: for (var j = 0; j < currNumOfPaths; j++) {
	                    var currPath = currAlt[j];
	                    var currPathLength = currPath.length;
	                    for (var i = 0; i < currPathLength; i++) {
	                        var nextToken = this.LA(i + 1);
	                        if (!(tokenMatcher(nextToken, currPath[i]))) {
	                            // mismatch in current path
	                            // try the next pth
	                            continue nextPath;
	                        }
	                    }
	                    // found a full path that matches.
	                    // this will also work for an empty ALT as the loop will be skipped
	                    return t;
	                }
	            }
	            // none of the alternatives could be matched
	            return undefined;
	        };
	    }
	}
	exports.buildAlternativesLookAheadFunc = buildAlternativesLookAheadFunc;
	function buildSingleAlternativeLookaheadFunction(alt, tokenMatcher, tokenClassIdentityFunc, tokenInstanceIdentityFunc, dynamicTokensEnabled) {
	    var areAllOneTokenLookahead = utils_1.every(alt, function (currPath) {
	        return currPath.length === 1;
	    });
	    var numOfPaths = alt.length;
	    // optimized (common) case of all the lookaheads paths requiring only
	    // a single token lookahead.
	    if (areAllOneTokenLookahead && !dynamicTokensEnabled) {
	        var singleTokensClasses = utils_1.flatten(alt);
	        if (singleTokensClasses.length === 1 && utils_1.isEmpty(singleTokensClasses[0].extendingTokenTypes)) {
	            var expectedTokenType = singleTokensClasses[0];
	            var expectedTokenUniqueKey_1 = tokenClassIdentityFunc(expectedTokenType);
	            return function () {
	                return tokenInstanceIdentityFunc(this.LA(1)) === expectedTokenUniqueKey_1;
	            };
	        }
	        else {
	            var choiceToAlt_2 = utils_1.reduce(singleTokensClasses, function (result, currTokClass, idx) {
	                result[tokenClassIdentityFunc(currTokClass)] = true;
	                utils_1.forEach(currTokClass.extendingTokenTypes, function (currExtendingType) {
	                    result[currExtendingType] = true;
	                });
	                return result;
	            }, {});
	            return function () {
	                var nextToken = this.LA(1);
	                return choiceToAlt_2[tokenInstanceIdentityFunc(nextToken)] === true ? true : false;
	            };
	        }
	    }
	    else {
	        return function () {
	            nextPath: for (var j = 0; j < numOfPaths; j++) {
	                var currPath = alt[j];
	                var currPathLength = currPath.length;
	                for (var i = 0; i < currPathLength; i++) {
	                    var nextToken = this.LA(i + 1);
	                    if (!(tokenMatcher(nextToken, currPath[i]))) {
	                        // mismatch in current path
	                        // try the next pth
	                        continue nextPath;
	                    }
	                }
	                // found a full path that matches.
	                return true;
	            }
	            // none of the paths matched
	            return false;
	        };
	    }
	}
	exports.buildSingleAlternativeLookaheadFunction = buildSingleAlternativeLookaheadFunction;
	var RestDefinitionFinderWalker = (function (_super) {
	    __extends(RestDefinitionFinderWalker, _super);
	    function RestDefinitionFinderWalker(topProd, targetOccurrence, targetProdType) {
	        var _this = _super.call(this) || this;
	        _this.topProd = topProd;
	        _this.targetOccurrence = targetOccurrence;
	        _this.targetProdType = targetProdType;
	        return _this;
	    }
	    RestDefinitionFinderWalker.prototype.startWalking = function () {
	        this.walk(this.topProd);
	        return this.restDef;
	    };
	    RestDefinitionFinderWalker.prototype.checkIsTarget = function (node, expectedProdType, currRest, prevRest) {
	        if (node.occurrenceInParent === this.targetOccurrence &&
	            this.targetProdType === expectedProdType) {
	            this.restDef = currRest.concat(prevRest);
	            return true;
	        }
	        // performance optimization, do not iterate over the entire Grammar ast after we have found the target
	        return false;
	    };
	    RestDefinitionFinderWalker.prototype.walkOption = function (optionProd, currRest, prevRest) {
	        if (!this.checkIsTarget(optionProd, PROD_TYPE.OPTION, currRest, prevRest)) {
	            _super.prototype.walkOption.call(this, optionProd, currRest, prevRest);
	        }
	    };
	    RestDefinitionFinderWalker.prototype.walkAtLeastOne = function (atLeastOneProd, currRest, prevRest) {
	        if (!this.checkIsTarget(atLeastOneProd, PROD_TYPE.REPETITION_MANDATORY, currRest, prevRest)) {
	            _super.prototype.walkOption.call(this, atLeastOneProd, currRest, prevRest);
	        }
	    };
	    RestDefinitionFinderWalker.prototype.walkAtLeastOneSep = function (atLeastOneSepProd, currRest, prevRest) {
	        if (!this.checkIsTarget(atLeastOneSepProd, PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR, currRest, prevRest)) {
	            _super.prototype.walkOption.call(this, atLeastOneSepProd, currRest, prevRest);
	        }
	    };
	    RestDefinitionFinderWalker.prototype.walkMany = function (manyProd, currRest, prevRest) {
	        if (!this.checkIsTarget(manyProd, PROD_TYPE.REPETITION, currRest, prevRest)) {
	            _super.prototype.walkOption.call(this, manyProd, currRest, prevRest);
	        }
	    };
	    RestDefinitionFinderWalker.prototype.walkManySep = function (manySepProd, currRest, prevRest) {
	        if (!this.checkIsTarget(manySepProd, PROD_TYPE.REPETITION_WITH_SEPARATOR, currRest, prevRest)) {
	            _super.prototype.walkOption.call(this, manySepProd, currRest, prevRest);
	        }
	    };
	    return RestDefinitionFinderWalker;
	}(rest_1.RestWalker));
	/**
	 * Returns the definition of a target production in a top level level rule.
	 */
	var InsideDefinitionFinderVisitor = (function (_super) {
	    __extends(InsideDefinitionFinderVisitor, _super);
	    function InsideDefinitionFinderVisitor(targetOccurrence, targetProdType) {
	        var _this = _super.call(this) || this;
	        _this.targetOccurrence = targetOccurrence;
	        _this.targetProdType = targetProdType;
	        _this.result = [];
	        return _this;
	    }
	    InsideDefinitionFinderVisitor.prototype.checkIsTarget = function (node, expectedProdName) {
	        if (node.occurrenceInParent === this.targetOccurrence &&
	            this.targetProdType === expectedProdName) {
	            this.result = node.definition;
	        }
	    };
	    InsideDefinitionFinderVisitor.prototype.visitOption = function (node) {
	        this.checkIsTarget(node, PROD_TYPE.OPTION);
	    };
	    InsideDefinitionFinderVisitor.prototype.visitRepetition = function (node) {
	        this.checkIsTarget(node, PROD_TYPE.REPETITION);
	    };
	    InsideDefinitionFinderVisitor.prototype.visitRepetitionMandatory = function (node) {
	        this.checkIsTarget(node, PROD_TYPE.REPETITION_MANDATORY);
	    };
	    InsideDefinitionFinderVisitor.prototype.visitRepetitionMandatoryWithSeparator = function (node) {
	        this.checkIsTarget(node, PROD_TYPE.REPETITION_MANDATORY_WITH_SEPARATOR);
	    };
	    InsideDefinitionFinderVisitor.prototype.visitRepetitionWithSeparator = function (node) {
	        this.checkIsTarget(node, PROD_TYPE.REPETITION_WITH_SEPARATOR);
	    };
	    InsideDefinitionFinderVisitor.prototype.visitAlternation = function (node) {
	        this.checkIsTarget(node, PROD_TYPE.ALTERNATION);
	    };
	    return InsideDefinitionFinderVisitor;
	}(gast_public_1.gast.GAstVisitor));
	function lookAheadSequenceFromAlternatives(altsDefs, k) {
	    function getOtherPaths(pathsAndSuffixes, filterIdx) {
	        return utils_1.reduce(pathsAndSuffixes, function (result, currPathsAndSuffixes, currIdx) {
	            if (currIdx !== filterIdx) {
	                var currPartialPaths = utils_1.map(currPathsAndSuffixes, function (singlePathAndSuffix) { return singlePathAndSuffix.partialPath; });
	                return result.concat(currPartialPaths);
	            }
	            return result;
	        }, []);
	    }
	    function isUniquePrefix(arr, item) {
	        return utils_1.find(arr, function (currOtherPath) {
	            return utils_1.every(item, function (currPathTok, idx) {
	                return currPathTok === currOtherPath[idx];
	            });
	        }) === undefined;
	    }
	    function initializeArrayOfArrays(size) {
	        var result = [];
	        for (var i = 0; i < size; i++) {
	            result.push([]);
	        }
	        return result;
	    }
	    var partialAlts = utils_1.map(altsDefs, function (currAlt) { return interpreter_1.possiblePathsFrom([currAlt], 1); });
	    var finalResult = initializeArrayOfArrays(partialAlts.length);
	    var newData = partialAlts;
	    // maxLookahead loop
	    for (var pathLength = 1; pathLength <= k; pathLength++) {
	        var currDataset = newData;
	        newData = initializeArrayOfArrays(currDataset.length);
	        // alternatives loop
	        for (var resultIdx = 0; resultIdx < currDataset.length; resultIdx++) {
	            var currAltPathsAndSuffixes = currDataset[resultIdx];
	            var otherPaths = getOtherPaths(currDataset, resultIdx);
	            // paths in current alternative loop
	            for (var currPathIdx = 0; currPathIdx < currAltPathsAndSuffixes.length; currPathIdx++) {
	                var currPathPrefix = currAltPathsAndSuffixes[currPathIdx].partialPath;
	                var suffixDef = currAltPathsAndSuffixes[currPathIdx].suffixDef;
	                var isUnique = isUniquePrefix(otherPaths, currPathPrefix);
	                // even if a path is not unique, but there are no longer alternatives to try
	                // or if we have reached the maximum lookahead (k) permitted.
	                if (isUnique ||
	                    utils_1.isEmpty(suffixDef) ||
	                    currPathPrefix.length === k) {
	                    var currAltResult = finalResult[resultIdx];
	                    if (!containsPath(currAltResult, currPathPrefix)) {
	                        currAltResult.push(currPathPrefix);
	                    }
	                }
	                else {
	                    var newPartialPathsAndSuffixes = interpreter_1.possiblePathsFrom(suffixDef, pathLength + 1, currPathPrefix);
	                    newData[resultIdx] = newData[resultIdx].concat(newPartialPathsAndSuffixes);
	                }
	            }
	        }
	    }
	    return finalResult;
	}
	exports.lookAheadSequenceFromAlternatives = lookAheadSequenceFromAlternatives;
	function getLookaheadPathsForOr(occurrence, ruleGrammar, k) {
	    var visitor = new InsideDefinitionFinderVisitor(occurrence, PROD_TYPE.ALTERNATION);
	    ruleGrammar.accept(visitor);
	    return lookAheadSequenceFromAlternatives(visitor.result, k);
	}
	exports.getLookaheadPathsForOr = getLookaheadPathsForOr;
	function getLookaheadPathsForOptionalProd(occurrence, ruleGrammar, prodType, k) {
	    var insideDefVisitor = new InsideDefinitionFinderVisitor(occurrence, prodType);
	    ruleGrammar.accept(insideDefVisitor);
	    var insideDef = insideDefVisitor.result;
	    var afterDefWalker = new RestDefinitionFinderWalker(ruleGrammar, occurrence, prodType);
	    var afterDef = afterDefWalker.startWalking();
	    var insideFlat = new gast_public_1.gast.Flat(insideDef);
	    var afterFlat = new gast_public_1.gast.Flat(afterDef);
	    return lookAheadSequenceFromAlternatives([insideFlat, afterFlat], k);
	}
	exports.getLookaheadPathsForOptionalProd = getLookaheadPathsForOptionalProd;
	function containsPath(alternative, path) {
	    var found = utils_1.find(alternative, function (otherPath) {
	        return path.length === otherPath.length &&
	            utils_1.every(path, function (targetItem, idx) {
	                return targetItem === otherPath[idx];
	            });
	    });
	    return found !== undefined;
	}
	exports.containsPath = containsPath;
	//# sourceMappingURL=lookahead.js.map

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) /* istanbul ignore next */  if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    /* istanbul ignore next */  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/* tslint:disable:no-use-before-declare */
	var rest_1 = __webpack_require__(1029);
	var gast_public_1 = __webpack_require__(1019);
	var utils_1 = __webpack_require__(1016);
	var tokens_public_1 = __webpack_require__(1020);
	var first_1 = __webpack_require__(1026);
	/* tslint:enable:no-use-before-declare */
	var AbstractNextPossibleTokensWalker = (function (_super) {
	    __extends(AbstractNextPossibleTokensWalker, _super);
	    function AbstractNextPossibleTokensWalker(topProd, path) {
	        var _this = _super.call(this) || this;
	        _this.topProd = topProd;
	        _this.path = path;
	        _this.possibleTokTypes = [];
	        _this.nextProductionName = "";
	        _this.nextProductionOccurrence = 0;
	        _this.found = false;
	        _this.isAtEndOfPath = false;
	        return _this;
	    }
	    AbstractNextPossibleTokensWalker.prototype.startWalking = function () {
	        this.found = false;
	        if (this.path.ruleStack[0] !== this.topProd.name) {
	            throw Error("The path does not start with the walker's top Rule!");
	        }
	        // immutable for the win
	        this.ruleStack = (utils_1.cloneArr(this.path.ruleStack)).reverse(); // intelij bug requires assertion
	        this.occurrenceStack = (utils_1.cloneArr(this.path.occurrenceStack)).reverse(); // intelij bug requires assertion
	        // already verified that the first production is valid, we now seek the 2nd production
	        this.ruleStack.pop();
	        this.occurrenceStack.pop();
	        this.updateExpectedNext();
	        this.walk(this.topProd);
	        return this.possibleTokTypes;
	    };
	    AbstractNextPossibleTokensWalker.prototype.walk = function (prod, prevRest) {
	        if (prevRest === void 0) { prevRest = []; }
	        // stop scanning once we found the path
	        if (!this.found) {
	            _super.prototype.walk.call(this, prod, prevRest);
	        }
	    };
	    AbstractNextPossibleTokensWalker.prototype.walkProdRef = function (refProd, currRest, prevRest) {
	        // found the next production, need to keep walking in it
	        if (refProd.referencedRule.name === this.nextProductionName &&
	            refProd.occurrenceInParent === this.nextProductionOccurrence) {
	            var fullRest = currRest.concat(prevRest);
	            this.updateExpectedNext();
	            this.walk(refProd.referencedRule, fullRest);
	        }
	    };
	    AbstractNextPossibleTokensWalker.prototype.updateExpectedNext = function () {
	        // need to consume the Terminal
	        if (utils_1.isEmpty(this.ruleStack)) {
	            // must reset nextProductionXXX to avoid walking down another Top Level production while what we are
	            // really seeking is the last Terminal...
	            this.nextProductionName = "";
	            this.nextProductionOccurrence = 0;
	            this.isAtEndOfPath = true;
	        }
	        else {
	            this.nextProductionName = this.ruleStack.pop();
	            this.nextProductionOccurrence = this.occurrenceStack.pop();
	        }
	    };
	    return AbstractNextPossibleTokensWalker;
	}(rest_1.RestWalker));
	exports.AbstractNextPossibleTokensWalker = AbstractNextPossibleTokensWalker;
	var NextAfterTokenWalker = (function (_super) {
	    __extends(NextAfterTokenWalker, _super);
	    function NextAfterTokenWalker(topProd, path) {
	        var _this = _super.call(this, topProd, path) /* istanbul ignore next */ || this;
	        _this.path = path;
	        _this.nextTerminalName = "";
	        _this.nextTerminalOccurrence = 0;
	        _this.nextTerminalName = tokens_public_1.tokenName(_this.path.lastTok);
	        _this.nextTerminalOccurrence = _this.path.lastTokOccurrence;
	        return _this;
	    }
	    NextAfterTokenWalker.prototype.walkTerminal = function (terminal, currRest, prevRest) {
	        if (this.isAtEndOfPath && tokens_public_1.tokenName(terminal.terminalType) === this.nextTerminalName &&
	            terminal.occurrenceInParent === this.nextTerminalOccurrence && !(this.found)) {
	            var fullRest = currRest.concat(prevRest);
	            var restProd = new gast_public_1.gast.Flat(fullRest);
	            this.possibleTokTypes = first_1.first(restProd);
	            this.found = true;
	        }
	    };
	    return NextAfterTokenWalker;
	}(AbstractNextPossibleTokensWalker));
	exports.NextAfterTokenWalker = NextAfterTokenWalker;
	/**
	 * This walker only "walks" a single "TOP" level in the Grammar Ast, this means
	 * it never "follows" production refs
	 */
	var AbstractNextTerminalAfterProductionWalker = (function (_super) {
	    __extends(AbstractNextTerminalAfterProductionWalker, _super);
	    function AbstractNextTerminalAfterProductionWalker(topRule, occurrence) {
	        var _this = _super.call(this) || this;
	        _this.topRule = topRule;
	        _this.occurrence = occurrence;
	        _this.result = { token: undefined, occurrence: undefined, isEndOfRule: undefined };
	        return _this;
	    }
	    AbstractNextTerminalAfterProductionWalker.prototype.startWalking = function () {
	        this.walk(this.topRule);
	        return this.result;
	    };
	    return AbstractNextTerminalAfterProductionWalker;
	}(rest_1.RestWalker));
	exports.AbstractNextTerminalAfterProductionWalker = AbstractNextTerminalAfterProductionWalker;
	var NextTerminalAfterManyWalker = (function (_super) {
	    __extends(NextTerminalAfterManyWalker, _super);
	    function NextTerminalAfterManyWalker() {
	        return _super.apply(this, arguments) /* istanbul ignore next */ || this;
	    }
	    NextTerminalAfterManyWalker.prototype.walkMany = function (manyProd, currRest, prevRest) {
	        if (manyProd.occurrenceInParent === this.occurrence) {
	            var firstAfterMany = utils_1.first(currRest.concat(prevRest));
	            this.result.isEndOfRule = firstAfterMany === undefined;
	            if (firstAfterMany instanceof gast_public_1.gast.Terminal) {
	                this.result.token = firstAfterMany.terminalType;
	                this.result.occurrence = firstAfterMany.occurrenceInParent;
	            }
	        }
	        else {
	            _super.prototype.walkMany.call(this, manyProd, currRest, prevRest);
	        }
	    };
	    return NextTerminalAfterManyWalker;
	}(AbstractNextTerminalAfterProductionWalker));
	exports.NextTerminalAfterManyWalker = NextTerminalAfterManyWalker;
	var NextTerminalAfterManySepWalker = (function (_super) {
	    __extends(NextTerminalAfterManySepWalker, _super);
	    function NextTerminalAfterManySepWalker() {
	        return _super.apply(this, arguments) /* istanbul ignore next */ || this;
	    }
	    NextTerminalAfterManySepWalker.prototype.walkManySep = function (manySepProd, currRest, prevRest) {
	        if (manySepProd.occurrenceInParent === this.occurrence) {
	            var firstAfterManySep = utils_1.first(currRest.concat(prevRest));
	            this.result.isEndOfRule = firstAfterManySep === undefined;
	            if (firstAfterManySep instanceof gast_public_1.gast.Terminal) {
	                this.result.token = firstAfterManySep.terminalType;
	                this.result.occurrence = firstAfterManySep.occurrenceInParent;
	            }
	        }
	        else {
	            _super.prototype.walkManySep.call(this, manySepProd, currRest, prevRest);
	        }
	    };
	    return NextTerminalAfterManySepWalker;
	}(AbstractNextTerminalAfterProductionWalker));
	exports.NextTerminalAfterManySepWalker = NextTerminalAfterManySepWalker;
	var NextTerminalAfterAtLeastOneWalker = (function (_super) {
	    __extends(NextTerminalAfterAtLeastOneWalker, _super);
	    function NextTerminalAfterAtLeastOneWalker() {
	        return _super.apply(this, arguments) /* istanbul ignore next */ || this;
	    }
	    NextTerminalAfterAtLeastOneWalker.prototype.walkAtLeastOne = function (atLeastOneProd, currRest, prevRest) {
	        if (atLeastOneProd.occurrenceInParent === this.occurrence) {
	            var firstAfterAtLeastOne = utils_1.first(currRest.concat(prevRest));
	            this.result.isEndOfRule = firstAfterAtLeastOne === undefined;
	            if (firstAfterAtLeastOne instanceof gast_public_1.gast.Terminal) {
	                this.result.token = firstAfterAtLeastOne.terminalType;
	                this.result.occurrence = firstAfterAtLeastOne.occurrenceInParent;
	            }
	        }
	        else {
	            _super.prototype.walkAtLeastOne.call(this, atLeastOneProd, currRest, prevRest);
	        }
	    };
	    return NextTerminalAfterAtLeastOneWalker;
	}(AbstractNextTerminalAfterProductionWalker));
	exports.NextTerminalAfterAtLeastOneWalker = NextTerminalAfterAtLeastOneWalker;
	// TODO: reduce code duplication in the AfterWalkers
	var NextTerminalAfterAtLeastOneSepWalker = (function (_super) {
	    __extends(NextTerminalAfterAtLeastOneSepWalker, _super);
	    function NextTerminalAfterAtLeastOneSepWalker() {
	        return _super.apply(this, arguments) /* istanbul ignore next */ || this;
	    }
	    NextTerminalAfterAtLeastOneSepWalker.prototype.walkAtLeastOneSep = function (atleastOneSepProd, currRest, prevRest) {
	        if (atleastOneSepProd.occurrenceInParent === this.occurrence) {
	            var firstAfterfirstAfterAtLeastOneSep = utils_1.first(currRest.concat(prevRest));
	            this.result.isEndOfRule = firstAfterfirstAfterAtLeastOneSep === undefined;
	            if (firstAfterfirstAfterAtLeastOneSep instanceof gast_public_1.gast.Terminal) {
	                this.result.token = firstAfterfirstAfterAtLeastOneSep.terminalType;
	                this.result.occurrence = firstAfterfirstAfterAtLeastOneSep.occurrenceInParent;
	            }
	        }
	        else {
	            _super.prototype.walkAtLeastOneSep.call(this, atleastOneSepProd, currRest, prevRest);
	        }
	    };
	    return NextTerminalAfterAtLeastOneSepWalker;
	}(AbstractNextTerminalAfterProductionWalker));
	exports.NextTerminalAfterAtLeastOneSepWalker = NextTerminalAfterAtLeastOneSepWalker;
	function possiblePathsFrom(targetDef, maxLength, currPath) {
	    if (currPath === void 0) { currPath = []; }
	    // avoid side effects
	    currPath = utils_1.cloneArr(currPath);
	    var result = [];
	    var i = 0;
	    function remainingPathWith(nextDef) {
	        return nextDef.concat(utils_1.drop(targetDef, i + 1));
	    }
	    function getAlternativesForProd(prod) {
	        var alternatives = possiblePathsFrom(remainingPathWith(prod.definition), maxLength, currPath);
	        return result.concat(alternatives);
	    }
	    /**
	     * Mandatory productions will halt the loop as the paths computed from their recursive calls will already contain the
	     * following (rest) of the targetDef.
	     *
	     * For optional productions (Option/Repetition/...) the loop will continue to represent the paths that do not include the
	     * the optional production.
	     */
	    while (currPath.length < maxLength && i < targetDef.length) {
	        var prod = targetDef[i];
	        if (prod instanceof gast_public_1.gast.Flat) {
	            return getAlternativesForProd(prod);
	        }
	        else if (prod instanceof gast_public_1.gast.NonTerminal) {
	            return getAlternativesForProd(prod);
	        }
	        else if (prod instanceof gast_public_1.gast.Option) {
	            result = getAlternativesForProd(prod);
	        }
	        else if (prod instanceof gast_public_1.gast.RepetitionMandatory) {
	            return getAlternativesForProd(prod);
	        }
	        else if (prod instanceof gast_public_1.gast.RepetitionMandatoryWithSeparator) {
	            return getAlternativesForProd(prod);
	        }
	        else if (prod instanceof gast_public_1.gast.RepetitionWithSeparator) {
	            result = getAlternativesForProd(prod);
	        }
	        else if (prod instanceof gast_public_1.gast.Repetition) {
	            result = getAlternativesForProd(prod);
	        }
	        else if (prod instanceof gast_public_1.gast.Alternation) {
	            utils_1.forEach(prod.definition, function (currAlt) {
	                result = getAlternativesForProd(currAlt);
	            });
	            return result;
	        }/* istanbul ignore else */ 
	        else if (prod instanceof gast_public_1.gast.Terminal) {
	            currPath.push(prod.terminalType);
	        }
	        else {
	            /* istanbul ignore next */ throw Error("non exhaustive match");
	        }
	        i++;
	    }
	    result.push({
	        partialPath: currPath,
	        suffixDef: utils_1.drop(targetDef, 1)
	    });
	    return result;
	}
	exports.possiblePathsFrom = possiblePathsFrom;
	function nextPossibleTokensAfter(initialDef, tokenVector, tokMatcher, maxLookAhead) {
	    var EXIT_NON_TERMINAL = "EXIT_NONE_TERMINAL";
	    // to avoid creating a new Array each time.
	    var EXIT_NON_TERMINAL_ARR = [EXIT_NON_TERMINAL];
	    var EXIT_ALTERNATIVE = "EXIT_ALTERNATIVE";
	    var foundCompletePath = false;
	    var tokenVectorLength = tokenVector.length;
	    var minimalAlternativesIndex = tokenVectorLength - maxLookAhead - 1;
	    var result = [];
	    var possiblePaths = [];
	    possiblePaths.push({ idx: -1, def: initialDef, ruleStack: [], occurrenceStack: [] });
	    while (!utils_1.isEmpty(possiblePaths)) {
	        var currPath = possiblePaths.pop();
	        // skip alternatives if no more results can be found (assuming deterministic grammar with fixed lookahead)
	        if (currPath === EXIT_ALTERNATIVE) {
	            if (foundCompletePath &&
	                utils_1.last(possiblePaths).idx <= minimalAlternativesIndex) {
	                // remove irrelevant alternative
	                possiblePaths.pop();
	            }
	            continue;
	        }
	        var currDef = currPath.def;
	        var currIdx = currPath.idx;
	        var currRuleStack = currPath.ruleStack;
	        var currOccurrenceStack = currPath.occurrenceStack;
	        // For Example: an empty path could exist in a valid grammar in the case of an EMPTY_ALT
	        if (utils_1.isEmpty(currDef)) {
	            continue;
	        }
	        var prod = currDef[0];
	        if (prod === EXIT_NON_TERMINAL) {
	            var nextPath = {
	                idx: currIdx,
	                def: utils_1.drop(currDef),
	                ruleStack: utils_1.dropRight(currRuleStack),
	                occurrenceStack: utils_1.dropRight(currOccurrenceStack)
	            };
	            possiblePaths.push(nextPath);
	        }
	        else if (prod instanceof gast_public_1.gast.Terminal) {
	            if (currIdx < tokenVectorLength - 1) {
	                var nextIdx = currIdx + 1;
	                var actualToken = tokenVector[nextIdx];
	                if (tokMatcher(actualToken, prod.terminalType)) {
	                    var nextPath = {
	                        idx: nextIdx,
	                        def: utils_1.drop(currDef),
	                        ruleStack: currRuleStack,
	                        occurrenceStack: currOccurrenceStack
	                    };
	                    possiblePaths.push(nextPath);
	                }
	            }/* istanbul ignore else */ 
	            else if (currIdx === tokenVectorLength - 1) {
	                
	                result.push({
	                    nextTokenType: prod.terminalType,
	                    nextTokenOccurrence: prod.occurrenceInParent,
	                    ruleStack: currRuleStack,
	                    occurrenceStack: currOccurrenceStack
	                });
	                foundCompletePath = true;
	            }
	            else {
	                /* istanbul ignore next */ throw Error("non exhaustive match");
	            }
	        }
	        else if (prod instanceof gast_public_1.gast.NonTerminal) {
	            var newRuleStack = utils_1.cloneArr(currRuleStack);
	            newRuleStack.push(prod.nonTerminalName);
	            var newOccurrenceStack = utils_1.cloneArr(currOccurrenceStack);
	            newOccurrenceStack.push(prod.occurrenceInParent);
	            var nextPath = {
	                idx: currIdx,
	                def: prod.definition.concat(EXIT_NON_TERMINAL_ARR, utils_1.drop(currDef)),
	                ruleStack: newRuleStack,
	                occurrenceStack: newOccurrenceStack
	            };
	            possiblePaths.push(nextPath);
	        }
	        else if (prod instanceof gast_public_1.gast.Option) {
	            // the order of alternatives is meaningful, FILO (Last path will be traversed first).
	            var nextPathWithout = {
	                idx: currIdx,
	                def: utils_1.drop(currDef),
	                ruleStack: currRuleStack,
	                occurrenceStack: currOccurrenceStack
	            };
	            possiblePaths.push(nextPathWithout);
	            // required marker to avoid backtracking paths whose higher priority alternatives already matched
	            possiblePaths.push(EXIT_ALTERNATIVE);
	            var nextPathWith = {
	                idx: currIdx,
	                def: prod.definition.concat(utils_1.drop(currDef)),
	                ruleStack: currRuleStack,
	                occurrenceStack: currOccurrenceStack
	            };
	            possiblePaths.push(nextPathWith);
	        }
	        else if (prod instanceof gast_public_1.gast.RepetitionMandatory) {
	            // TODO:(THE NEW operators here take a while...) (convert once?)
	            var secondIteration = new gast_public_1.gast.Repetition(prod.definition, prod.occurrenceInParent);
	            var nextDef = prod.definition.concat([secondIteration], utils_1.drop(currDef));
	            var nextPath = {
	                idx: currIdx,
	                def: nextDef,
	                ruleStack: currRuleStack,
	                occurrenceStack: currOccurrenceStack
	            };
	            possiblePaths.push(nextPath);
	        }
	        else if (prod instanceof gast_public_1.gast.RepetitionMandatoryWithSeparator) {
	            // TODO:(THE NEW operators here take a while...) (convert once?)
	            var separatorGast = new gast_public_1.gast.Terminal(prod.separator);
	            var secondIteration = new gast_public_1.gast.Repetition([separatorGast].concat(prod.definition), prod.occurrenceInParent);
	            var nextDef = prod.definition.concat([secondIteration], utils_1.drop(currDef));
	            var nextPath = {
	                idx: currIdx,
	                def: nextDef,
	                ruleStack: currRuleStack,
	                occurrenceStack: currOccurrenceStack
	            };
	            possiblePaths.push(nextPath);
	        }
	        else if (prod instanceof gast_public_1.gast.RepetitionWithSeparator) {
	            // the order of alternatives is meaningful, FILO (Last path will be traversed first).
	            var nextPathWithout = {
	                idx: currIdx,
	                def: utils_1.drop(currDef),
	                ruleStack: currRuleStack,
	                occurrenceStack: currOccurrenceStack
	            };
	            possiblePaths.push(nextPathWithout);
	            // required marker to avoid backtracking paths whose higher priority alternatives already matched
	            possiblePaths.push(EXIT_ALTERNATIVE);
	            var separatorGast = new gast_public_1.gast.Terminal(prod.separator);
	            var nthRepetition = new gast_public_1.gast.Repetition([separatorGast].concat(prod.definition), prod.occurrenceInParent);
	            var nextDef = prod.definition.concat([nthRepetition], utils_1.drop(currDef));
	            var nextPathWith = {
	                idx: currIdx,
	                def: nextDef,
	                ruleStack: currRuleStack,
	                occurrenceStack: currOccurrenceStack
	            };
	            possiblePaths.push(nextPathWith);
	        }
	        else if (prod instanceof gast_public_1.gast.Repetition) {
	            // the order of alternatives is meaningful, FILO (Last path will be traversed first).
	            var nextPathWithout = {
	                idx: currIdx,
	                def: utils_1.drop(currDef),
	                ruleStack: currRuleStack,
	                occurrenceStack: currOccurrenceStack
	            };
	            possiblePaths.push(nextPathWithout);
	            // required marker to avoid backtracking paths whose higher priority alternatives already matched
	            possiblePaths.push(EXIT_ALTERNATIVE);
	            // TODO: an empty repetition will cause infinite loops here, will the parser detect this in selfAnalysis?
	            var nthRepetition = new gast_public_1.gast.Repetition(prod.definition, prod.occurrenceInParent);
	            var nextDef = prod.definition.concat([nthRepetition], utils_1.drop(currDef));
	            var nextPathWith = {
	                idx: currIdx, def: nextDef,
	                ruleStack: currRuleStack,
	                occurrenceStack: currOccurrenceStack
	            };
	            possiblePaths.push(nextPathWith);
	        }
	        else if (prod instanceof gast_public_1.gast.Alternation) {
	            // the order of alternatives is meaningful, FILO (Last path will be traversed first).
	            for (var i = prod.definition.length - 1; i >= 0; i--) {
	                var currAlt = prod.definition[i];
	                var currAltPath = {
	                    idx: currIdx,
	                    def: currAlt.definition.concat(utils_1.drop(currDef)),
	                    ruleStack: currRuleStack,
	                    occurrenceStack: currOccurrenceStack
	                };
	                possiblePaths.push(currAltPath);
	                possiblePaths.push(EXIT_ALTERNATIVE);
	            }
	        }
	        else if (prod instanceof gast_public_1.gast.Flat) {
	            possiblePaths.push({
	                idx: currIdx,
	                def: prod.definition.concat(utils_1.drop(currDef)),
	                ruleStack: currRuleStack,
	                occurrenceStack: currOccurrenceStack
	            });
	        }/* istanbul ignore else */ 
	        else if (prod instanceof gast_public_1.gast.Rule) {
	            possiblePaths.push(expandTopLevelRule(prod, currIdx, currRuleStack, currOccurrenceStack));
	        }
	        else {
	            /* istanbul ignore next */ throw Error("non exhaustive match");
	        }
	    }
	    return result;
	}
	exports.nextPossibleTokensAfter = nextPossibleTokensAfter;
	function expandTopLevelRule(topRule, currIdx, currRuleStack, currOccurrenceStack) {
	    var newRuleStack = utils_1.cloneArr(currRuleStack);
	    newRuleStack.push(topRule.name);
	    var newCurrOccurrenceStack = utils_1.cloneArr(currOccurrenceStack);
	    // top rule is always assumed to have been called with occurrence index 1
	    newCurrOccurrenceStack.push(1);
	    return {
	        idx: currIdx,
	        def: topRule.definition,
	        ruleStack: newRuleStack,
	        occurrenceStack: newCurrOccurrenceStack
	    };
	}
	//# sourceMappingURL=interpreter.js.map

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var gast_public_1 = __webpack_require__(1019);
	var utils_1 = __webpack_require__(1016);
	/**
	 *  A Grammar Walker that computes the "remaining" grammar "after" a productions in the grammar.
	 */
	var RestWalker = (function () {
	    function RestWalker() {
	    }
	    RestWalker.prototype.walk = function (prod, prevRest) {
	        var _this = this;
	        if (prevRest === void 0) { prevRest = []; }
	        utils_1.forEach(prod.definition, function (subProd, index) {
	            var currRest = utils_1.drop(prod.definition, index + 1);
	            if (subProd instanceof gast_public_1.gast.NonTerminal) {
	                _this.walkProdRef(subProd, currRest, prevRest);
	            }
	            else if (subProd instanceof gast_public_1.gast.Terminal) {
	                _this.walkTerminal(subProd, currRest, prevRest);
	            }
	            else if (subProd instanceof gast_public_1.gast.Flat) {
	                _this.walkFlat(subProd, currRest, prevRest);
	            }
	            else if (subProd instanceof gast_public_1.gast.Option) {
	                _this.walkOption(subProd, currRest, prevRest);
	            }
	            else if (subProd instanceof gast_public_1.gast.RepetitionMandatory) {
	                _this.walkAtLeastOne(subProd, currRest, prevRest);
	            }
	            else if (subProd instanceof gast_public_1.gast.RepetitionMandatoryWithSeparator) {
	                _this.walkAtLeastOneSep(subProd, currRest, prevRest);
	            }
	            else if (subProd instanceof gast_public_1.gast.RepetitionWithSeparator) {
	                _this.walkManySep(subProd, currRest, prevRest);
	            }
	            else if (subProd instanceof gast_public_1.gast.Repetition) {
	                _this.walkMany(subProd, currRest, prevRest);
	            }/* istanbul ignore else */ 
	            else if (subProd instanceof gast_public_1.gast.Alternation) {
	                _this.walkOr(subProd, currRest, prevRest);
	            }
	            else {
	                /* istanbul ignore next */ throw Error("non exhaustive match");
	            }
	        });
	    };
	    RestWalker.prototype.walkTerminal = function (terminal, currRest, prevRest) { };
	    RestWalker.prototype.walkProdRef = function (refProd, currRest, prevRest) { };
	    RestWalker.prototype.walkFlat = function (flatProd, currRest, prevRest) {
	        // ABCDEF => after the D the rest is EF
	        var fullOrRest = currRest.concat(prevRest);
	        this.walk(flatProd, fullOrRest);
	    };
	    RestWalker.prototype.walkOption = function (optionProd, currRest, prevRest) {
	        // ABC(DE)?F => after the (DE)? the rest is F
	        var fullOrRest = currRest.concat(prevRest);
	        this.walk(optionProd, fullOrRest);
	    };
	    RestWalker.prototype.walkAtLeastOne = function (atLeastOneProd, currRest, prevRest) {
	        // ABC(DE)+F => after the (DE)+ the rest is (DE)?F
	        var fullAtLeastOneRest = [new gast_public_1.gast.Option(atLeastOneProd.definition)].concat(currRest, prevRest);
	        this.walk(atLeastOneProd, fullAtLeastOneRest);
	    };
	    RestWalker.prototype.walkAtLeastOneSep = function (atLeastOneSepProd, currRest, prevRest) {
	        // ABC DE(,DE)* F => after the (,DE)+ the rest is (,DE)?F
	        var fullAtLeastOneSepRest = restForRepetitionWithSeparator(atLeastOneSepProd, currRest, prevRest);
	        this.walk(atLeastOneSepProd, fullAtLeastOneSepRest);
	    };
	    RestWalker.prototype.walkMany = function (manyProd, currRest, prevRest) {
	        // ABC(DE)*F => after the (DE)* the rest is (DE)?F
	        var fullManyRest = [new gast_public_1.gast.Option(manyProd.definition)].concat(currRest, prevRest);
	        this.walk(manyProd, fullManyRest);
	    };
	    RestWalker.prototype.walkManySep = function (manySepProd, currRest, prevRest) {
	        // ABC (DE(,DE)*)? F => after the (,DE)* the rest is (,DE)?F
	        var fullManySepRest = restForRepetitionWithSeparator(manySepProd, currRest, prevRest);
	        this.walk(manySepProd, fullManySepRest);
	    };
	    RestWalker.prototype.walkOr = function (orProd, currRest, prevRest) {
	        var _this = this;
	        // ABC(D|E|F)G => when finding the (D|E|F) the rest is G
	        var fullOrRest = currRest.concat(prevRest);
	        // walk all different alternatives
	        utils_1.forEach(orProd.definition, function (alt) {
	            // wrapping each alternative in a single definition wrapper
	            // to avoid errors in computing the rest of that alternative in the invocation to computeInProdFollows
	            // (otherwise for OR([alt1,alt2]) alt2 will be considered in 'rest' of alt1
	            var prodWrapper = new gast_public_1.gast.Flat([alt]);
	            _this.walk(prodWrapper, fullOrRest);
	        });
	    };
	    return RestWalker;
	}());
	exports.RestWalker = RestWalker;
	function restForRepetitionWithSeparator(repSepProd, currRest, prevRest) {
	    var repSepRest = [new gast_public_1.gast.Option([new gast_public_1.gast.Terminal(repSepProd.separator)].concat(repSepProd.definition))];
	    var fullRepSepRest = repSepRest.concat(currRest, prevRest);
	    return fullRepSepRest;
	}
	//# sourceMappingURL=rest.js.map

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) /* istanbul ignore next */  if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    /* istanbul ignore next */  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var rest_1 = __webpack_require__(1029);
	var lang_extensions_1 = __webpack_require__(1015);
	var gast_public_1 = __webpack_require__(1019);
	var first_1 = __webpack_require__(1026);
	var utils_1 = __webpack_require__(1016);
	var constants_1 = __webpack_require__(1031);
	var tokens_public_1 = __webpack_require__(1020);
	// This ResyncFollowsWalker computes all of the follows required for RESYNC
	// (skipping reference production).
	var ResyncFollowsWalker = (function (_super) {
	    __extends(ResyncFollowsWalker, _super);
	    function ResyncFollowsWalker(topProd) {
	        var _this = _super.call(this) || this;
	        _this.topProd = topProd;
	        _this.follows = new lang_extensions_1.HashTable();
	        return _this;
	    }
	    ResyncFollowsWalker.prototype.startWalking = function () {
	        this.walk(this.topProd);
	        return this.follows;
	    };
	    ResyncFollowsWalker.prototype.walkTerminal = function (terminal, currRest, prevRest) {
	        // do nothing! just like in the public sector after 13:00
	    };
	    ResyncFollowsWalker.prototype.walkProdRef = function (refProd, currRest, prevRest) {
	        var followName = buildBetweenProdsFollowPrefix(refProd.referencedRule, refProd.occurrenceInParent) + this.topProd.name;
	        var fullRest = currRest.concat(prevRest);
	        var restProd = new gast_public_1.gast.Flat(fullRest);
	        var t_in_topProd_follows = first_1.first(restProd);
	        this.follows.put(followName, t_in_topProd_follows);
	    };
	    return ResyncFollowsWalker;
	}(rest_1.RestWalker));
	exports.ResyncFollowsWalker = ResyncFollowsWalker;
	function computeAllProdsFollows(topProductions) {
	    var reSyncFollows = new lang_extensions_1.HashTable();
	    utils_1.forEach(topProductions, function (topProd) {
	        var currRefsFollow = new ResyncFollowsWalker(topProd).startWalking();
	        reSyncFollows.putAll(currRefsFollow);
	    });
	    return reSyncFollows;
	}
	exports.computeAllProdsFollows = computeAllProdsFollows;
	function buildBetweenProdsFollowPrefix(inner, occurenceInParent) {
	    return inner.name + occurenceInParent + constants_1.IN;
	}
	exports.buildBetweenProdsFollowPrefix = buildBetweenProdsFollowPrefix;
	function buildInProdFollowPrefix(terminal) {
	    var terminalName = tokens_public_1.tokenName(terminal.terminalType);
	    return terminalName + terminal.occurrenceInParent + constants_1.IN;
	}
	exports.buildInProdFollowPrefix = buildInProdFollowPrefix;
	//# sourceMappingURL=follow.js.map

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	"use strict";
	// TODO: can this be removed? where is it used?
	exports.IN = "_~IN~_";
	//# sourceMappingURL=constants.js.map

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var range_1 = __webpack_require__(1033);
	var gast_public_1 = __webpack_require__(1019);
	var utils_1 = __webpack_require__(1016);
	var ProdType;
	(function (ProdType) {
	    ProdType[ProdType["OPTION"] = 0] = "OPTION";
	    ProdType[ProdType["OR"] = 1] = "OR";
	    ProdType[ProdType["MANY"] = 2] = "MANY";
	    ProdType[ProdType["MANY_SEP"] = 3] = "MANY_SEP";
	    ProdType[ProdType["AT_LEAST_ONE"] = 4] = "AT_LEAST_ONE";
	    ProdType[ProdType["AT_LEAST_ONE_SEP"] = 5] = "AT_LEAST_ONE_SEP";
	    ProdType[ProdType["REF"] = 6] = "REF";
	    ProdType[ProdType["TERMINAL"] = 7] = "TERMINAL";
	    ProdType[ProdType["FLAT"] = 8] = "FLAT";
	})(ProdType = exports.ProdType || (exports.ProdType = {}));
	// TODO: this regexp creates a constraint on names of Terminals (Tokens).
	// TODO: document and consider reducing the constraint by expanding the regexp
	var terminalRegEx = /\.\s*CONSUME(\d)?\s*\(\s*(?:[a-zA-Z_$]\w*\s*\.\s*)*([a-zA-Z_$]\w*)/;
	var terminalRegGlobal = new RegExp(terminalRegEx.source, "g");
	var refRegEx = /\.\s*SUBRULE(\d)?\s*\(\s*(?:[a-zA-Z_$]\w*\s*\.\s*)*([a-zA-Z_$]\w*)/;
	var refRegExGlobal = new RegExp(refRegEx.source, "g");
	var optionRegEx = /\.\s*OPTION(\d)?\s*\(/;
	var optionRegExGlobal = new RegExp(optionRegEx.source, "g");
	var manyRegEx = /\.\s*MANY(\d)?\s*\(/;
	var manyRegExGlobal = new RegExp(manyRegEx.source, "g");
	var manyWithSeparatorRegEx = /\.\s*MANY_SEP(\d)?\s*\(\s*(?:[a-zA-Z_$]\w*\s*\.\s*)*([a-zA-Z_$]\w*)/;
	var manyWithSeparatorRegExGlobal = new RegExp(manyWithSeparatorRegEx.source, "g");
	var atLeastOneWithSeparatorRegEx = /\.\s*AT_LEAST_ONE_SEP(\d)?\s*\(\s*(?:[a-zA-Z_$]\w*\s*\.\s*)*([a-zA-Z_$]\w*)/;
	var atLeastOneWithSeparatorRegExGlobal = new RegExp(atLeastOneWithSeparatorRegEx.source, "g");
	var atLeastOneRegEx = /\.\s*AT_LEAST_ONE(\d)?\s*\(/;
	var atLeastOneRegExGlobal = new RegExp(atLeastOneRegEx.source, "g");
	var orRegEx = /\.\s*OR(\d)?\s*\(/;
	var orRegExGlobal = new RegExp(orRegEx.source, "g");
	var orPartRegEx = /\s*(ALT)\s*:/g;
	exports.terminalNameToConstructor = {};
	function buildTopProduction(impelText, name, terminals) {
	    // pseudo state. so little state does not yet mandate the complexity of wrapping in a class...
	    // TODO: this is confusing, might be time to create a class..
	    exports.terminalNameToConstructor = terminals;
	    // the top most range must strictly contain all the other ranges
	    // which is why we prefix the text with " " (curr Range impel is only for positive ranges)
	    var spacedImpelText = " " + impelText;
	    // TODO: why do we add whitespace twice?
	    var txtWithoutComments = removeComments(" " + spacedImpelText);
	    var textWithoutCommentsAndStrings = removeStringLiterals(txtWithoutComments);
	    var prodRanges = createRanges(textWithoutCommentsAndStrings);
	    var topRange = new range_1.Range(0, impelText.length + 2);
	    return buildTopLevel(name, topRange, prodRanges, impelText);
	}
	exports.buildTopProduction = buildTopProduction;
	function buildTopLevel(name, topRange, allRanges, orgText) {
	    var topLevelProd = new gast_public_1.gast.Rule(name, [], orgText);
	    return buildAbstractProd(topLevelProd, topRange, allRanges);
	}
	function buildProdGast(prodRange, allRanges) {
	    "use strict";
	    switch (prodRange.type) {
	        case ProdType.AT_LEAST_ONE:
	            return buildAtLeastOneProd(prodRange, allRanges);
	        case ProdType.AT_LEAST_ONE_SEP:
	            return buildAtLeastOneSepProd(prodRange, allRanges);
	        case ProdType.MANY_SEP:
	            return buildManySepProd(prodRange, allRanges);
	        case ProdType.MANY:
	            return buildManyProd(prodRange, allRanges);
	        case ProdType.OPTION:
	            return buildOptionProd(prodRange, allRanges);
	        case ProdType.OR:
	            return buildOrProd(prodRange, allRanges);
	        case ProdType.FLAT:
	            return buildAbstractProd(new gast_public_1.gast.Flat([]), prodRange.range, allRanges);
	        case ProdType.REF:
	            return buildRefProd(prodRange);
	        case ProdType.TERMINAL:
	            return buildTerminalProd(prodRange);
	        /* istanbul ignore next */
	        default:
	            /* istanbul ignore next */ throw Error("non exhaustive match");
	    }
	}
	exports.buildProdGast = buildProdGast;
	function buildRefProd(prodRange) {
	    var reResult = refRegEx.exec(prodRange.text);
	    var isImplicitOccurrenceIdx = reResult[1] === undefined;
	    var refOccurrence = isImplicitOccurrenceIdx ? 1 : parseInt(reResult[1], 10);
	    var refProdName = reResult[2];
	    var newRef = new gast_public_1.gast.NonTerminal(refProdName, undefined, refOccurrence);
	    newRef.implicitOccurrenceIndex = isImplicitOccurrenceIdx;
	    return newRef;
	}
	function buildTerminalProd(prodRange) {
	    var reResult = terminalRegEx.exec(prodRange.text);
	    var isImplicitOccurrenceIdx = reResult[1] === undefined;
	    var terminalOccurrence = isImplicitOccurrenceIdx ? 1 : parseInt(reResult[1], 10);
	    var terminalName = reResult[2];
	    var terminalType = exports.terminalNameToConstructor[terminalName];
	    if (!terminalType) {
	        throw Error("Terminal Token name: " + terminalName + " not found");
	    }
	    var newTerminal = new gast_public_1.gast.Terminal(terminalType, terminalOccurrence);
	    newTerminal.implicitOccurrenceIndex = isImplicitOccurrenceIdx;
	    return newTerminal;
	}
	function buildProdWithOccurrence(regEx, prodInstance, prodRange, allRanges) {
	    var reResult = regEx.exec(prodRange.text);
	    var isImplicitOccurrenceIdx = reResult[1] === undefined;
	    prodInstance.occurrenceInParent = isImplicitOccurrenceIdx ? 1 : parseInt(reResult[1], 10);
	    prodInstance.implicitOccurrenceIndex = isImplicitOccurrenceIdx;
	    // <any> due to intellij bugs
	    return buildAbstractProd(prodInstance, prodRange.range, allRanges);
	}
	function buildAtLeastOneProd(prodRange, allRanges) {
	    return buildProdWithOccurrence(atLeastOneRegEx, new gast_public_1.gast.RepetitionMandatory([]), prodRange, allRanges);
	}
	function buildAtLeastOneSepProd(prodRange, allRanges) {
	    return buildRepetitionWithSep(prodRange, allRanges, gast_public_1.gast.RepetitionMandatoryWithSeparator, atLeastOneWithSeparatorRegEx);
	}
	function buildManyProd(prodRange, allRanges) {
	    return buildProdWithOccurrence(manyRegEx, new gast_public_1.gast.Repetition([]), prodRange, allRanges);
	}
	function buildManySepProd(prodRange, allRanges) {
	    return buildRepetitionWithSep(prodRange, allRanges, gast_public_1.gast.RepetitionWithSeparator, manyWithSeparatorRegEx);
	}
	function buildRepetitionWithSep(prodRange, allRanges, repConstructor, regExp) {
	    var reResult = regExp.exec(prodRange.text);
	    var isImplicitOccurrenceIdx = reResult[1] === undefined;
	    var occurrenceIdx = isImplicitOccurrenceIdx ? 1 : parseInt(reResult[1], 10);
	    var sepName = reResult[2];
	    var separatorType = exports.terminalNameToConstructor[sepName];
	    if (!separatorType) {
	        throw Error("Separator Terminal Token name: " + sepName + " not found");
	    }
	    var repetitionInstance = new repConstructor([], separatorType, occurrenceIdx);
	    repetitionInstance.implicitOccurrenceIndex = isImplicitOccurrenceIdx;
	    return buildAbstractProd(repetitionInstance, prodRange.range, allRanges);
	}
	function buildOptionProd(prodRange, allRanges) {
	    return buildProdWithOccurrence(optionRegEx, new gast_public_1.gast.Option([]), prodRange, allRanges);
	}
	function buildOrProd(prodRange, allRanges) {
	    return buildProdWithOccurrence(orRegEx, new gast_public_1.gast.Alternation([]), prodRange, allRanges);
	}
	function buildAbstractProd(prod, topLevelRange, allRanges) {
	    var secondLevelProds = getDirectlyContainedRanges(topLevelRange, allRanges);
	    var secondLevelInOrder = utils_1.sortBy(secondLevelProds, function (prodRng) { return prodRng.range.start; });
	    var definition = [];
	    utils_1.forEach(secondLevelInOrder, function (prodRng) {
	        definition.push(buildProdGast(prodRng, allRanges));
	    });
	    prod.definition = definition;
	    return prod;
	}
	function getDirectlyContainedRanges(y, prodRanges) {
	    return utils_1.filter(prodRanges, function (x) {
	        var isXDescendantOfY = y.strictlyContainsRange(x.range);
	        var xDoesNotHaveAnyAncestorWhichIsDecendantOfY = utils_1.every(prodRanges, function (maybeAnotherParent) {
	            var isParentOfX = maybeAnotherParent.range.strictlyContainsRange(x.range);
	            var isChildOfY = maybeAnotherParent.range.isStrictlyContainedInRange(y);
	            return !(isParentOfX && isChildOfY);
	        });
	        return isXDescendantOfY && xDoesNotHaveAnyAncestorWhichIsDecendantOfY;
	    });
	}
	exports.getDirectlyContainedRanges = getDirectlyContainedRanges;
	var singleLineCommentRegEx = /\/\/.*/g;
	var multiLineCommentRegEx = /\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\//g;
	var doubleQuoteStringLiteralRegEx = /"([^\\"]+|\\([bfnrtv"\\/]|u[0-9a-fA-F]{4}))*"/g;
	var singleQuoteStringLiteralRegEx = /'([^\\']+|\\([bfnrtv'\\/]|u[0-9a-fA-F]{4}))*'/g;
	function removeComments(text) {
	    var noSingleLine = text.replace(singleLineCommentRegEx, "");
	    var noComments = noSingleLine.replace(multiLineCommentRegEx, "");
	    return noComments;
	}
	exports.removeComments = removeComments;
	function removeStringLiterals(text) {
	    var noDoubleQuotes = text.replace(doubleQuoteStringLiteralRegEx, "");
	    var noSingleQuotes = noDoubleQuotes.replace(singleQuoteStringLiteralRegEx, "");
	    return noSingleQuotes;
	}
	exports.removeStringLiterals = removeStringLiterals;
	function createRanges(text) {
	    var terminalRanges = createTerminalRanges(text);
	    var refsRanges = createRefsRanges(text);
	    var atLeastOneRanges = createAtLeastOneRanges(text);
	    var atLeastOneSepRanges = createAtLeastOneSepRanges(text);
	    var manyRanges = createManyRanges(text);
	    var manySepRanges = createManySepRanges(text);
	    var optionRanges = createOptionRanges(text);
	    var orRanges = createOrRanges(text);
	    return [].concat(terminalRanges, refsRanges, atLeastOneRanges, atLeastOneSepRanges, manyRanges, manySepRanges, optionRanges, orRanges);
	}
	exports.createRanges = createRanges;
	function createTerminalRanges(text) {
	    return createRefOrTerminalProdRangeInternal(text, ProdType.TERMINAL, terminalRegGlobal);
	}
	exports.createTerminalRanges = createTerminalRanges;
	function createRefsRanges(text) {
	    return createRefOrTerminalProdRangeInternal(text, ProdType.REF, refRegExGlobal);
	}
	exports.createRefsRanges = createRefsRanges;
	function createAtLeastOneRanges(text) {
	    return createOperatorProdRangeParenthesis(text, ProdType.AT_LEAST_ONE, atLeastOneRegExGlobal);
	}
	exports.createAtLeastOneRanges = createAtLeastOneRanges;
	function createAtLeastOneSepRanges(text) {
	    return createOperatorProdRangeParenthesis(text, ProdType.AT_LEAST_ONE_SEP, atLeastOneWithSeparatorRegExGlobal);
	}
	exports.createAtLeastOneSepRanges = createAtLeastOneSepRanges;
	function createManyRanges(text) {
	    return createOperatorProdRangeParenthesis(text, ProdType.MANY, manyRegExGlobal);
	}
	exports.createManyRanges = createManyRanges;
	function createManySepRanges(text) {
	    return createOperatorProdRangeParenthesis(text, ProdType.MANY_SEP, manyWithSeparatorRegExGlobal);
	}
	exports.createManySepRanges = createManySepRanges;
	function createOptionRanges(text) {
	    return createOperatorProdRangeParenthesis(text, ProdType.OPTION, optionRegExGlobal);
	}
	exports.createOptionRanges = createOptionRanges;
	function createOrRanges(text) {
	    var orRanges = createOperatorProdRangeParenthesis(text, ProdType.OR, orRegExGlobal);
	    // have to split up the OR cases into separate FLAT productions
	    // (A |BB | CDE) ==> or.def[0] --> FLAT(A) , or.def[1] --> FLAT(BB) , or.def[2] --> FLAT(CCDE)
	    var orSubPartsRanges = createOrPartRanges(orRanges);
	    return orRanges.concat(orSubPartsRanges);
	}
	exports.createOrRanges = createOrRanges;
	var findClosingCurly = utils_1.partial(findClosingOffset, "{", "}");
	var findClosingParen = utils_1.partial(findClosingOffset, "(", ")");
	function createOrPartRanges(orRanges) {
	    var orPartRanges = [];
	    utils_1.forEach(orRanges, function (orRange) {
	        var currOrParts = createOperatorProdRangeInternal(orRange.text, ProdType.FLAT, orPartRegEx, findClosingCurly);
	        var currOrRangeStart = orRange.range.start;
	        // fix offsets as we are working on a subset of the text
	        utils_1.forEach(currOrParts, function (orPart) {
	            orPart.range.start += currOrRangeStart;
	            orPart.range.end += currOrRangeStart;
	        });
	        orPartRanges = orPartRanges.concat(currOrParts);
	    });
	    var uniqueOrPartRanges = utils_1.uniq(orPartRanges, function (prodRange) {
	        // using "~" as a separator for the identify function as its not a valid char in javascript
	        return prodRange.type + "~" + prodRange.range.start + "~" + prodRange.range.end + "~" + prodRange.text;
	    });
	    return uniqueOrPartRanges;
	}
	exports.createOrPartRanges = createOrPartRanges;
	function createRefOrTerminalProdRangeInternal(text, prodType, pattern) {
	    var prodRanges = [];
	    var matched;
	    while (matched = pattern.exec(text)) {
	        var start = matched.index;
	        var stop = pattern.lastIndex;
	        var currRange = new range_1.Range(start, stop);
	        var currText = matched[0];
	        prodRanges.push({ range: currRange, text: currText, type: prodType });
	    }
	    return prodRanges;
	}
	function createOperatorProdRangeParenthesis(text, prodType, pattern) {
	    return createOperatorProdRangeInternal(text, prodType, pattern, findClosingParen);
	}
	function createOperatorProdRangeInternal(text, prodType, pattern, findTerminatorOffSet) {
	    var operatorRanges = [];
	    var matched;
	    while (matched = pattern.exec(text)) {
	        var start = matched.index;
	        // note that (start + matched[0].length) is the first character AFTER the match
	        var stop = findTerminatorOffSet(start + matched[0].length, text);
	        var currRange = new range_1.Range(start, stop);
	        var currText = text.substr(start, stop - start + 1);
	        operatorRanges.push({ range: currRange, text: currText, type: prodType });
	    }
	    return operatorRanges;
	}
	function findClosingOffset(opening, closing, start, text) {
	    var parenthesisStack = [1];
	    var i = -1;
	    while (!(utils_1.isEmpty(parenthesisStack)) && i + start < text.length) {
	        i++;
	        var nextChar = text.charAt(start + i);
	        if (nextChar === opening) {
	            parenthesisStack.push(1);
	        }
	        else if (nextChar === closing) {
	            parenthesisStack.pop();
	        }
	    }
	    // valid termination of the search loop
	    if (utils_1.isEmpty(parenthesisStack)) {
	        return i + start;
	    }
	    else {
	        throw new Error("INVALID INPUT TEXT, UNTERMINATED PARENTHESIS");
	    }
	}
	exports.findClosingOffset = findClosingOffset;
	//# sourceMappingURL=gast_builder.js.map

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	"use strict";
	var Range = (function () {
	    function Range(start, end) {
	        this.start = start;
	        this.end = end;
	        if (!isValidRange(start, end)) {
	            throw new Error("INVALID RANGE");
	        }
	    }
	    Range.prototype.contains = function (num) {
	        return this.start <= num && this.end >= num;
	    };
	    Range.prototype.containsRange = function (other) {
	        return this.start <= other.start && this.end >= other.end;
	    };
	    Range.prototype.isContainedInRange = function (other) {
	        return other.containsRange(this);
	    };
	    Range.prototype.strictlyContainsRange = function (other) {
	        return this.start < other.start && this.end > other.end;
	    };
	    Range.prototype.isStrictlyContainedInRange = function (other) {
	        return other.strictlyContainsRange(this);
	    };
	    return Range;
	}());
	exports.Range = Range;
	function isValidRange(start, end) {
	    return !(start < 0 || end < start);
	}
	exports.isValidRange = isValidRange;
	//# sourceMappingURL=range.js.map

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var cache_1 = __webpack_require__(1014);
	/**
	 * Clears the chevrotain internal cache.
	 * This should not be used in regular work flows, This is intended for
	 * unique use cases for example: online playground where the a parser with the same name is initialized with
	 * different implementations multiple times.
	 */
	function clearCache() {
	    cache_1.clearCache();
	}
	exports.clearCache = clearCache;
	//# sourceMappingURL=cache_public.js.map

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.allTokens = exports.WhiteSpace = exports.RParen = exports.LParen = exports.Comma = exports.StringLiteral = exports.NumberLiteral = exports.Identifier = exports.UnaryAggregation = exports.NullaryAggregation = exports.Aggregation = exports.Div = exports.Multi = exports.MultiplicativeOperator = exports.Minus = exports.Plus = exports.AdditiveOperator = undefined;
	
	var _chevrotain = __webpack_require__(1012);
	
	var _config = __webpack_require__(885);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Note: this file is imported by webpack.config.js
	
	var AdditiveOperator = exports.AdditiveOperator = (0, _chevrotain.extendToken)("AdditiveOperator", _chevrotain.Lexer.NA);
	var Plus = exports.Plus = (0, _chevrotain.extendToken)("Plus", /\+/, AdditiveOperator);
	var Minus = exports.Minus = (0, _chevrotain.extendToken)("Minus", /-/, AdditiveOperator);
	
	var MultiplicativeOperator = exports.MultiplicativeOperator = (0, _chevrotain.extendToken)("MultiplicativeOperator", _chevrotain.Lexer.NA);
	var Multi = exports.Multi = (0, _chevrotain.extendToken)("Multi", /\*/, MultiplicativeOperator);
	var Div = exports.Div = (0, _chevrotain.extendToken)("Div", /\//, MultiplicativeOperator);
	
	var Aggregation = exports.Aggregation = (0, _chevrotain.extendToken)("Aggregation", _chevrotain.Lexer.NA);
	
	var NullaryAggregation = exports.NullaryAggregation = (0, _chevrotain.extendToken)("NullaryAggregation", Aggregation);
	var nullaryAggregationTokens = _config.NULLARY_AGGREGATIONS.map(function (short) {
	    return (0, _chevrotain.extendToken)(_config.VALID_AGGREGATIONS.get(short), new RegExp(_config.VALID_AGGREGATIONS.get(short), "i"), NullaryAggregation);
	});
	
	var UnaryAggregation = exports.UnaryAggregation = (0, _chevrotain.extendToken)("UnaryAggregation", Aggregation);
	var unaryAggregationTokens = _config.UNARY_AGGREGATIONS.map(function (short) {
	    return (0, _chevrotain.extendToken)(_config.VALID_AGGREGATIONS.get(short), new RegExp(_config.VALID_AGGREGATIONS.get(short), "i"), UnaryAggregation);
	});
	
	var Identifier = exports.Identifier = (0, _chevrotain.extendToken)('Identifier', /\w+/);
	var NumberLiteral = exports.NumberLiteral = (0, _chevrotain.extendToken)("NumberLiteral", /-?(0|[1-9]\d*)(\.\d+)?([eE][+-]?\d+)?/);
	var StringLiteral = exports.StringLiteral = (0, _chevrotain.extendToken)("StringLiteral", /"(?:[^\\"]+|\\(?:[bfnrtv"\\/]|u[0-9a-fA-F]{4}))*"/);
	
	var Comma = exports.Comma = (0, _chevrotain.extendToken)('Comma', /,/);
	Comma.LABEL = "comma";
	
	var LParen = exports.LParen = (0, _chevrotain.extendToken)('LParen', /\(/);
	LParen.LABEL = "opening parenthesis";
	
	var RParen = exports.RParen = (0, _chevrotain.extendToken)('RParen', /\)/);
	RParen.LABEL = "closing parenthesis";
	
	var WhiteSpace = exports.WhiteSpace = (0, _chevrotain.extendToken)("WhiteSpace", /\s+/);
	WhiteSpace.GROUP = _chevrotain.Lexer.SKIPPED;
	
	// whitespace is normally very common so it is placed first to speed up the lexer
	var allTokens = exports.allTokens = [WhiteSpace, LParen, RParen, Comma, Plus, Minus, Multi, Div, AdditiveOperator, MultiplicativeOperator, Aggregation, NullaryAggregation].concat(_toConsumableArray(nullaryAggregationTokens), [UnaryAggregation], _toConsumableArray(unaryAggregationTokens), [StringLiteral, NumberLiteral, Identifier]);

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TokenizedExpression = __webpack_require__(1037);
	
	var _TokenizedExpression2 = _interopRequireDefault(_TokenizedExpression);
	
	var _dom = __webpack_require__(859);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODE_BACKSPACE = 8;
	var KEYCODE_LEFT = 37;
	var KEYCODE_RIGHT = 39;
	var KEYCODE_FORWARD_DELETE = 46;
	
	var TokenizedInput = function (_Component) {
	    _inherits(TokenizedInput, _Component);
	
	    function TokenizedInput(props) {
	        _classCallCheck(this, TokenizedInput);
	
	        var _this = _possibleConstructorReturn(this, (TokenizedInput.__proto__ || Object.getPrototypeOf(TokenizedInput)).call(this, props));
	
	        _this.onSelectionChange = function (e) {
	            _reactDom2.default.findDOMNode(_this).selectionStart = (0, _dom.getCaretPosition)(_reactDom2.default.findDOMNode(_this));
	        };
	
	        _this.onClick = function (e) {
	            _this._isTyping = false;
	            return _this.props.onClick(e);
	        };
	
	        _this.onInput = function (e) {
	            _this._setValue(e.target.textContent);
	        };
	
	        _this.onKeyDown = function (e) {
	            // isTyping signals whether the user is typing characters (keyCode >= 65) vs. deleting / navigating with arrows / clicking to select
	            var isTyping = _this._isTyping;
	            // also keep isTyping same when deleting
	            _this._isTyping = e.keyCode >= 65 || e.keyCode === KEYCODE_BACKSPACE && isTyping;
	
	            var input = _reactDom2.default.findDOMNode(_this);
	
	            var _getSelectionPosition = (0, _dom.getSelectionPosition)(input),
	                _getSelectionPosition2 = _slicedToArray(_getSelectionPosition, 2),
	                start = _getSelectionPosition2[0],
	                end = _getSelectionPosition2[1];
	
	            if (start !== end) {
	                return;
	            }
	
	            var element = window.getSelection().focusNode;
	            while (element && element !== input) {
	                // check ancestors of the focused node for "Expression-tokenized"
	                // if the element is marked as "tokenized" we might want to intercept keypresses
	                if (element.classList && element.classList.contains("Expression-tokenized")) {
	                    var positionInElement = (0, _dom.getCaretPosition)(element);
	                    var atStart = positionInElement === 0;
	                    var atEnd = positionInElement === element.textContent.length;
	                    var isSelected = element.classList.contains("Expression-selected");
	                    if (!isSelected && !isTyping && (atEnd && e.keyCode === KEYCODE_BACKSPACE || atStart && e.keyCode === KEYCODE_FORWARD_DELETE)) {
	                        // not selected, not "typging", and hit backspace, so mark as "selected"
	                        element.classList.add("Expression-selected");
	                        e.stopPropagation();
	                        e.preventDefault();
	                        return;
	                    } else if (isSelected && (atEnd && e.keyCode === KEYCODE_BACKSPACE || atStart && e.keyCode === KEYCODE_FORWARD_DELETE)) {
	                        // selected and hit backspace, so delete it
	                        element.parentNode.removeChild(element);
	                        _this._setValue(input.textContent);
	                        e.stopPropagation();
	                        e.preventDefault();
	                        return;
	                    } else if (isSelected && (atEnd && e.keyCode === KEYCODE_LEFT || atStart && e.keyCode === KEYCODE_RIGHT)) {
	                        // selected and hit left arrow, so enter "typing" mode and unselect it
	                        element.classList.remove("Expression-selected");
	                        _this._isTyping = true;
	                        e.stopPropagation();
	                        e.preventDefault();
	                        return;
	                    }
	                }
	                // nada, try the next ancestor
	                element = element.parentNode;
	            }
	
	            // if we haven't handled the event yet, pass it on to our parent
	            _this.props.onKeyDown(e);
	        };
	
	        _this.state = {
	            value: ""
	        };
	        return _this;
	    }
	
	    _createClass(TokenizedInput, [{
	        key: "_getValue",
	        value: function _getValue() {
	            if (this.props.value != undefined) {
	                return this.props.value;
	            } else {
	                return this.state.value;
	            }
	        }
	    }, {
	        key: "_setValue",
	        value: function _setValue(value) {
	            _reactDom2.default.findDOMNode(this).value = value;
	            if (typeof this.props.onChange === "function") {
	                this.props.onChange({ target: { value: value } });
	            } else {
	                this.setState({ value: value });
	            }
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            _reactDom2.default.findDOMNode(this).focus();
	            this.componentDidUpdate();
	
	            document.addEventListener("selectionchange", this.onSelectionChange, false);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            document.removeEventListener("selectionchange", this.onSelectionChange, false);
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var inputNode = _reactDom2.default.findDOMNode(this);
	            var restore = (0, _dom.saveSelection)(inputNode);
	
	            _reactDom2.default.unmountComponentAtNode(inputNode);
	            while (inputNode.firstChild) {
	                inputNode.removeChild(inputNode.firstChild);
	            }
	            _reactDom2.default.render(_react2.default.createElement(_TokenizedExpression2.default, { source: this._getValue(), parserInfo: this.props.parserInfo }), inputNode);
	
	            if (document.activeElement === inputNode) {
	                restore();
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                onFocus = _props.onFocus,
	                onBlur = _props.onBlur;
	
	            return _react2.default.createElement("div", {
	                className: className,
	                style: { whiteSpace: "pre-wrap" },
	                contentEditable: true,
	                onKeyDown: this.onKeyDown,
	                onInput: this.onInput,
	                onFocus: onFocus,
	                onBlur: onBlur,
	                onClick: this.onClick
	            });
	        }
	    }]);
	
	    return TokenizedInput;
	}(_react.Component);
	
	TokenizedInput.displayName = "TokenizedInput";
	exports.default = TokenizedInput;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1038);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TokenizedExpression = function (_React$Component) {
	    _inherits(TokenizedExpression, _React$Component);
	
	    function TokenizedExpression() {
	        _classCallCheck(this, TokenizedExpression);
	
	        return _possibleConstructorReturn(this, (TokenizedExpression.__proto__ || Object.getPrototypeOf(TokenizedExpression)).apply(this, arguments));
	    }
	
	    _createClass(TokenizedExpression, [{
	        key: "render",
	        value: function render() {
	            // TODO: use the Chevrotain parser or tokenizer
	            // let parsed = parse(this.props.source, this.props.parserInfo);
	            var parsed = parse(this.props.source);
	            return renderSyntaxTree(parsed);
	        }
	    }]);
	
	    return TokenizedExpression;
	}(_react2.default.Component);
	
	TokenizedExpression.displayName = "TokenizedExpression";
	exports.default = TokenizedExpression;
	
	
	var renderSyntaxTree = function renderSyntaxTree(node, index) {
	    return _react2.default.createElement(
	        "span",
	        { key: index, className: (0, _classnames2.default)("Expression-node", "Expression-" + node.type, { "Expression-tokenized": node.tokenized }) },
	        node.text != null ? node.text : node.children ? node.children.map(renderSyntaxTree) : null
	    );
	};
	
	renderSyntaxTree.displayName = "renderSyntaxTree";
	function nextNonWhitespace(tokens, index) {
	    while (index < tokens.length && /^\s+$/.test(tokens[++index])) {}
	    return tokens[index];
	}
	
	function parse(expressionString) {
	    var tokens = (expressionString || " ").match(/[a-zA-Z]\w*|"(?:[^\\"]+|\\(?:[bfnrtv"\\/]|u[0-9a-fA-F]{4}))*"|\(|\)|\d+|\s+|[*/+-]|.+/g);
	
	    var root = { type: "group", children: [] };
	    var current = root;
	    var outsideAggregation = true;
	    var stack = [];
	    var push = function push(element) {
	        current.children.push(element);
	        stack.push(current);
	        current = element;
	    };
	    var pop = function pop() {
	        if (stack.length === 0) {
	            return;
	        }
	        current = stack.pop();
	    };
	    for (var i = 0; i < tokens.length; i++) {
	        var token = tokens[i];
	        if (/^[a-zA-Z]\w*$/.test(token)) {
	            if (nextNonWhitespace(tokens, i) === "(") {
	                outsideAggregation = false;
	                push({
	                    type: "aggregation",
	                    tokenized: true,
	                    children: []
	                });
	                current.children.push({
	                    type: "aggregation-name",
	                    text: token
	                });
	            } else {
	                current.children.push({
	                    type: outsideAggregation ? "metric" : "field",
	                    tokenized: true,
	                    text: token
	                });
	            }
	        } else if (/^"(?:[^\\"]+|\\(?:[bfnrtv"\\/]|u[0-9a-fA-F]{4}))*"$/.test(token)) {
	            current.children.push({
	                type: "string-literal",
	                tokenized: true,
	                children: [{ type: "open-quote", text: "\"" }, { type: outsideAggregation ? "metric" : "field", text: JSON.parse(token) }, { type: "close-quote", text: "\"" }]
	            });
	        } else if (token === "(") {
	            push({ type: "group", children: [] });
	            current.children.push({ type: "open-paren", text: "(" });
	        } else if (token === ")") {
	            current.children.push({ type: "close-paren", text: ")" });
	            pop();
	            if (current.type === "aggregation") {
	                outsideAggregation = true;
	                pop();
	            }
	        } else {
	            // special handling for unclosed string literals
	            if (i === tokens.length - 1 && /^".+[^"]$/.test(token)) {
	                current.children.push({
	                    type: "string-literal",
	                    tokenized: true,
	                    children: [{ type: "open-quote", text: "\"" }, { type: outsideAggregation ? "metric" : "field", text: JSON.parse(token + "\"") }]
	                });
	            } else {
	                current.children.push({ type: "token", text: token });
	            }
	        }
	    }
	    return root;
	}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1039 */,
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var _question = _ref.question;
	
	    var query = _question.query();
	    if (!(query instanceof _StructuredQuery2.default)) {
	        return [];
	    }
	
	    return query.table().metrics.slice(0, 5).map(function (metric) {
	        return {
	            name: "common-metric",
	            title: _react2.default.createElement(
	                "span",
	                null,
	                "View ",
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    metric.name
	                )
	            ),
	            question: function question() {
	                return _question.summarize(["METRIC", metric.id]);
	            }
	        };
	    });
	};

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	var _schema_metadata = __webpack_require__(867);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var _question = _ref.question;
	
	    var query = _question.query();
	    if (!(query instanceof _StructuredQuery2.default)) {
	        return [];
	    }
	
	    var dateField = query.table().fields.filter(_schema_metadata.isDate)[0];
	    if (!dateField) {
	        return [];
	    }
	
	    return [{
	        name: "count-by-time",
	        section: "sum",
	        title: _react2.default.createElement(
	            "span",
	            null,
	            "Count of rows by time"
	        ),
	        icon: "line",
	        question: function question() {
	            return _question.summarize(["count"]).breakout(["datetime-field", ["field-id", dateField.id], "as", "day"]);
	        }
	    }];
	};

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _filter = __webpack_require__(890);
	
	/* eslint-disable flowtype/require-valid-file-annotation */
	
	exports.default = function (_ref) {
	    var question = _ref.question,
	        settings = _ref.settings;
	
	    if (question.card().id && settings["enable_xrays"]) {
	        return question.query().filters().filter(function (filter) {
	            return (0, _filter.isSegmentFilter)(filter);
	        }).map(function (filter) {
	            var id = filter[1];
	            var segment = question.metadata().segments[id];
	            return {
	                name: "xray-segment",
	                title: "X-ray " + (segment && segment.name),
	                icon: "beaker",
	                url: function url() {
	                    return "/xray/segment/" + id + "/approximate";
	                }
	            };
	        });
	    } else {
	        return [];
	    }
	};

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _actions = __webpack_require__(959);
	
	var _schema_metadata = __webpack_require__(867);
	
	var AGGREGATIONS = {
	    sum: {
	        section: "sum",
	        title: "Sum"
	    },
	    avg: {
	        section: "averages",
	        title: "Avg"
	    },
	    min: {
	        section: "averages",
	        title: "Min"
	    },
	    max: {
	        section: "averages",
	        title: "Max"
	    },
	    distinct: {
	        section: "averages",
	        title: "Distincts"
	    }
	};
	
	exports.default = function (_ref) {
	    var _question = _ref.question,
	        clicked = _ref.clicked;
	
	    if (!clicked || !clicked.column || clicked.value !== undefined || clicked.column.source !== "fields") {
	        // TODO Atte Keinänen 7/21/17: Does it slow down the drill-through option calculations remarkably
	        // that I removed the `isSummable` condition from here and use `isCompatibleAggregator` method below instead?
	        return [];
	    }
	    var column = clicked.column;
	
	
	    return Object.entries(AGGREGATIONS).map(function (_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 2),
	            aggregationShort = _ref3[0],
	            action = _ref3[1];
	
	        return [(0, _schema_metadata.getAggregator)(aggregationShort), action];
	    }).filter(function (_ref4) {
	        var _ref5 = _slicedToArray(_ref4, 1),
	            aggregator = _ref5[0];
	
	        return (0, _schema_metadata.isCompatibleAggregatorForField)(aggregator, column);
	    })
	    // $FlowFixMe
	    .map(function (_ref6) {
	        var _ref7 = _slicedToArray(_ref6, 2),
	            aggregator = _ref7[0],
	            action = _ref7[1];
	
	        return _extends({
	            name: action.title.toLowerCase()
	        }, action, {
	            question: function question() {
	                return _question.summarize([aggregator.short, (0, _actions.getFieldRefFromColumn)(column)]);
	            }
	        });
	    });
	};

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	var _actions = __webpack_require__(959);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _formatting = __webpack_require__(872);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var _question = _ref.question,
	        clicked = _ref.clicked;
	
	    var query = _question.query();
	    if (!(query instanceof _StructuredQuery2.default)) {
	        return [];
	    }
	
	    var dateField = query.table().fields.filter(_schema_metadata.isDate)[0];
	    if (!dateField || !clicked || !clicked.column || clicked.value !== undefined) {
	        return [];
	    }
	    var column = clicked.column;
	
	
	    return ["sum", "count"].map(_schema_metadata.getAggregator).filter(function (aggregator) {
	        return (0, _schema_metadata.isCompatibleAggregatorForField)(aggregator, column);
	    }).map(function (aggregator) {
	        return {
	            name: "summarize-by-time",
	            section: "sum",
	            title: _react2.default.createElement(
	                "span",
	                null,
	                (0, _formatting.capitalize)(aggregator.short),
	                " by time"
	            ),
	            question: function question() {
	                return _question.summarize(aggregator.requiresField ? [aggregator.short, (0, _actions.getFieldRefFromColumn)(column)] : [aggregator.short]).pivot([["datetime-field", (0, _actions.getFieldRefFromColumn)(dateField), "as", "day"]]);
	            }
	        };
	    });
	};

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actions = __webpack_require__(959);
	
	var _schema_metadata = __webpack_require__(867);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var _question = _ref.question,
	        clicked = _ref.clicked;
	
	    if (!clicked || !clicked.column || clicked.value !== undefined || clicked.column.source !== "fields" || !(0, _schema_metadata.isCategory)(clicked.column)) {
	        return [];
	    }
	    var column = clicked.column;
	
	
	    return [{
	        name: "count-by-column",
	        section: "distribution",
	        title: _react2.default.createElement(
	            "span",
	            null,
	            "Distribution"
	        ),
	        question: function question() {
	            return _question.summarize(["count"]).pivot([(0, _actions.getFieldRefFromColumn)(column)]);
	        }
	    }];
	};

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(966);
	
	var _drill = __webpack_require__(969);
	
	var _PivotByCategoryAction = __webpack_require__(1047);
	
	var _PivotByCategoryAction2 = _interopRequireDefault(_PivotByCategoryAction);
	
	var _PivotByLocationAction = __webpack_require__(1050);
	
	var _PivotByLocationAction2 = _interopRequireDefault(_PivotByLocationAction);
	
	var _PivotByTimeAction = __webpack_require__(1051);
	
	var _PivotByTimeAction2 = _interopRequireDefault(_PivotByTimeAction);
	
	var _PivotByCategoryDrill = __webpack_require__(1052);
	
	var _PivotByCategoryDrill2 = _interopRequireDefault(_PivotByCategoryDrill);
	
	var _PivotByLocationDrill = __webpack_require__(1053);
	
	var _PivotByLocationDrill2 = _interopRequireDefault(_PivotByLocationDrill);
	
	var _PivotByTimeDrill = __webpack_require__(1054);
	
	var _PivotByTimeDrill2 = _interopRequireDefault(_PivotByTimeDrill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var MetricMode = {
	    name: "metric",
	    actions: [].concat(_toConsumableArray(_actions.DEFAULT_ACTIONS), [_PivotByCategoryAction2.default, _PivotByLocationAction2.default, _PivotByTimeAction2.default]),
	    drills: [].concat(_toConsumableArray(_drill.DEFAULT_DRILLS), [_PivotByCategoryDrill2.default, _PivotByLocationDrill2.default, _PivotByTimeDrill2.default])
	};
	
	exports.default = MetricMode;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _schema_metadata = __webpack_require__(867);
	
	var _PivotByAction = __webpack_require__(1048);
	
	var _PivotByAction2 = _interopRequireDefault(_PivotByAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _PivotByAction2.default)("Category", "label", function (field) {
	    return (0, _schema_metadata.isCategory)(field) && !(0, _schema_metadata.isAddress)(field);
	});

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreakoutPopover = __webpack_require__(1049);
	
	var _BreakoutPopover2 = _interopRequireDefault(_BreakoutPopover);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// PivotByAction displays a breakout picker, and optionally filters by the
	// clicked dimesion values (and removes corresponding breakouts)
	exports.default = function (name, icon, fieldFilter) {
	    return function (_ref) {
	        var question = _ref.question,
	            clicked = _ref.clicked;
	
	        var query = question.query();
	        if (!(query instanceof _StructuredQuery2.default)) {
	            return [];
	        }
	
	        // $FlowFixMe
	        var tableMetadata = query.table();
	
	        // Click target types: metric value
	        if (clicked && (clicked.value === undefined ||
	        // $FlowFixMe
	        clicked.column.source !== "aggregation")) {
	            return [];
	        }
	
	        var dimensions = clicked && clicked.dimensions || [];
	
	        var breakoutOptions = query.breakoutOptions(null, fieldFilter);
	        if (breakoutOptions.count === 0) {
	            return [];
	        }
	
	        return [{
	            name: "pivot-by-" + name.toLowerCase(),
	            section: "breakout",
	            title: clicked ? name : _react2.default.createElement(
	                "span",
	                null,
	                "Break out by",
	                " ",
	                _react2.default.createElement(
	                    "span",
	                    { className: "text-dark" },
	                    name.toLowerCase()
	                )
	            ),
	            icon: icon,
	            // eslint-disable-next-line react/display-name
	            popover: function popover(_ref2) {
	                var onChangeCardAndRun = _ref2.onChangeCardAndRun,
	                    onClose = _ref2.onClose;
	                return _react2.default.createElement(_BreakoutPopover2.default, {
	                    tableMetadata: tableMetadata,
	                    fieldOptions: breakoutOptions,
	                    onCommitBreakout: function onCommitBreakout(breakout) {
	                        var nextCard = question.pivot([breakout], dimensions).card();
	
	                        if (nextCard) {
	                            onChangeCardAndRun({ nextCard: nextCard });
	                        }
	                    },
	                    onClose: onClose
	                });
	            }
	        }];
	    };
	};

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FieldList = __webpack_require__(979);
	
	var _FieldList2 = _interopRequireDefault(_FieldList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BreakoutPopover = function BreakoutPopover(_ref) {
	    var breakout = _ref.breakout,
	        tableMetadata = _ref.tableMetadata,
	        fieldOptions = _ref.fieldOptions,
	        onCommitBreakout = _ref.onCommitBreakout,
	        onClose = _ref.onClose;
	    return _react2.default.createElement(_FieldList2.default, {
	        className: "text-green",
	        tableMetadata: tableMetadata,
	        field: breakout,
	        fieldOptions: fieldOptions,
	        onFieldChange: function onFieldChange(field) {
	            onCommitBreakout(field);
	            if (onClose) {
	                onClose();
	            }
	        },
	        enableSubDimensions: true,
	        alwaysExpanded: true
	    });
	};
	
	BreakoutPopover.displayName = "BreakoutPopover";
	exports.default = BreakoutPopover;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _schema_metadata = __webpack_require__(867);
	
	var _PivotByAction = __webpack_require__(1048);
	
	var _PivotByAction2 = _interopRequireDefault(_PivotByAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _PivotByAction2.default)("Location", "location", function (field) {
	  return (0, _schema_metadata.isAddress)(field);
	});

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _schema_metadata = __webpack_require__(867);
	
	var _PivotByAction = __webpack_require__(1048);
	
	var _PivotByAction2 = _interopRequireDefault(_PivotByAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _PivotByAction2.default)("Time", "clock", function (field) {
	  return (0, _schema_metadata.isDate)(field);
	});

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PivotByCategoryAction = __webpack_require__(1047);
	
	var _PivotByCategoryAction2 = _interopRequireDefault(_PivotByCategoryAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return (0, _PivotByCategoryAction2.default)(props);
	};

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PivotByLocationAction = __webpack_require__(1050);
	
	var _PivotByLocationAction2 = _interopRequireDefault(_PivotByLocationAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return (0, _PivotByLocationAction2.default)(props);
	};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PivotByTimeAction = __webpack_require__(1051);
	
	var _PivotByTimeAction2 = _interopRequireDefault(_PivotByTimeAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return (0, _PivotByTimeAction2.default)(props);
	};

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TimeseriesModeFooter = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// import TimeseriesGroupingWidget
	//     from "metabase/qb/components/TimeseriesGroupingWidget";
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimeseriesFilterWidget = __webpack_require__(1056);
	
	var _TimeseriesFilterWidget2 = _interopRequireDefault(_TimeseriesFilterWidget);
	
	var _actions = __webpack_require__(966);
	
	var _drill = __webpack_require__(969);
	
	var _PivotByCategoryAction = __webpack_require__(1047);
	
	var _PivotByCategoryAction2 = _interopRequireDefault(_PivotByCategoryAction);
	
	var _PivotByLocationAction = __webpack_require__(1050);
	
	var _PivotByLocationAction2 = _interopRequireDefault(_PivotByLocationAction);
	
	var _XRayCard = __webpack_require__(1061);
	
	var _XRayCard2 = _interopRequireDefault(_XRayCard);
	
	var _PivotByCategoryDrill = __webpack_require__(1052);
	
	var _PivotByCategoryDrill2 = _interopRequireDefault(_PivotByCategoryDrill);
	
	var _PivotByLocationDrill = __webpack_require__(1053);
	
	var _PivotByLocationDrill2 = _interopRequireDefault(_PivotByLocationDrill);
	
	var _TimeseriesGroupingWidget = __webpack_require__(1062);
	
	var _TimeseriesGroupingWidget2 = _interopRequireDefault(_TimeseriesGroupingWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var TimeseriesModeFooter = exports.TimeseriesModeFooter = function TimeseriesModeFooter(props) {
	    return _react2.default.createElement(
	        "div",
	        { className: "flex layout-centered" },
	        _react2.default.createElement(
	            "span",
	            { className: "mr1" },
	            "View"
	        ),
	        _react2.default.createElement(_TimeseriesFilterWidget2.default, _extends({}, props, { card: props.lastRunCard })),
	        _react2.default.createElement(
	            "span",
	            { className: "mx1" },
	            "by"
	        ),
	        _react2.default.createElement(_TimeseriesGroupingWidget2.default, _extends({}, props, { card: props.lastRunCard }))
	    );
	};
	
	TimeseriesModeFooter.displayName = "TimeseriesModeFooter";
	var TimeseriesMode = {
	    name: "timeseries",
	    actions: [_PivotByCategoryAction2.default, _PivotByLocationAction2.default, _XRayCard2.default].concat(_toConsumableArray(_actions.DEFAULT_ACTIONS)),
	    drills: [_PivotByCategoryDrill2.default, _PivotByLocationDrill2.default].concat(_toConsumableArray(_drill.DEFAULT_DRILLS)),
	    ModeFooter: TimeseriesModeFooter
	};
	
	exports.default = TimeseriesMode;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DatePicker = __webpack_require__(989);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _Select = __webpack_require__(1057);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _query = __webpack_require__(887);
	
	var Query = _interopRequireWildcard(_query);
	
	var _filter2 = __webpack_require__(890);
	
	var Filter = _interopRequireWildcard(_filter2);
	
	var _field = __webpack_require__(869);
	
	var Field = _interopRequireWildcard(_field);
	
	var _Card = __webpack_require__(957);
	
	var Card = _interopRequireWildcard(_Card);
	
	var _query_time = __webpack_require__(944);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	var TimeseriesFilterWidget = function (_Component) {
	    _inherits(TimeseriesFilterWidget, _Component);
	
	    function TimeseriesFilterWidget() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TimeseriesFilterWidget);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimeseriesFilterWidget.__proto__ || Object.getPrototypeOf(TimeseriesFilterWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            // $FlowFixMe
	            filter: null,
	            filterIndex: -1,
	            currentFilter: null
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TimeseriesFilterWidget, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.componentWillReceiveProps(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            var query = Card.getQuery(nextProps.card);
	            if (query) {
	                var breakouts = Query.getBreakouts(query);
	                var filters = Query.getFilters(query);
	
	                var timeFieldId = (0, _query_time.parseFieldTargetId)(breakouts[0]);
	                var timeField = (0, _query_time.parseFieldTarget)(breakouts[0]);
	
	                var _filterIndex = _underscore2.default.findIndex(filters, function (filter) {
	                    return Filter.isFieldFilter(filter) && Field.getFieldTargetId(filter[1]) === timeFieldId;
	                });
	
	                var _filter = void 0,
	                    _currentFilter = void 0;
	                if (_filterIndex >= 0) {
	                    _filter = _currentFilter = filters[_filterIndex];
	                } else {
	                    _filter = ["time-interval", timeField, -30, "day"];
	                }
	
	                // $FlowFixMe
	                this.setState({ filter: _filter, filterIndex: _filterIndex, currentFilter: _currentFilter });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                card = _props.card,
	                tableMetadata = _props.tableMetadata,
	                setDatasetQuery = _props.setDatasetQuery;
	            var _state = this.state,
	                filter = _state.filter,
	                filterIndex = _state.filterIndex,
	                currentFilter = _state.currentFilter;
	
	            var currentDescription = void 0;
	
	            if (currentFilter) {
	                currentDescription = (0, _query_time.generateTimeFilterValuesDescriptions)(currentFilter).join(" - ");
	                if (currentFilter[0] === ">") {
	                    currentDescription = "After " + currentDescription;
	                } else if (currentFilter[0] === "<") {
	                    currentDescription = "Before " + currentDescription;
	                } else if (currentFilter[0] === "IS_NULL") {
	                    currentDescription = "Is Empty";
	                } else if (currentFilter[0] === "NOT_NULL") {
	                    currentDescription = "Not Empty";
	                }
	            } else {
	                currentDescription = "All Time";
	            }
	
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                {
	                    triggerElement: _react2.default.createElement(
	                        _Select.SelectButton,
	                        { hasValue: true },
	                        currentDescription
	                    ),
	                    triggerClasses: (0, _classnames2.default)(className, "my2"),
	                    ref: function ref(_ref2) {
	                        return _this2._popover = _ref2;
	                    },
	                    sizeToFit: true
	                },
	                _react2.default.createElement(_DatePicker2.default, {
	                    filter: this.state.filter,
	                    onFilterChange: function onFilterChange(newFilter) {
	                        _this2.setState({ filter: newFilter });
	                    },
	                    tableMetadata: tableMetadata,
	                    includeAllTime: true
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "p1" },
	                    _react2.default.createElement(
	                        _Button2.default,
	                        {
	                            purple: true,
	                            className: "full",
	                            onClick: function onClick() {
	                                var query = Card.getQuery(card);
	                                if (query) {
	                                    if (filterIndex >= 0) {
	                                        query = Query.updateFilter(query, filterIndex, filter);
	                                    } else {
	                                        query = Query.addFilter(query, filter);
	                                    }
	                                    var _datasetQuery = _extends({}, card.dataset_query, {
	                                        query: query
	                                    });
	                                    setDatasetQuery(_datasetQuery, { run: true });
	                                }
	                                if (_this2._popover) {
	                                    _this2._popover.close();
	                                }
	                            }
	                        },
	                        "Apply"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TimeseriesFilterWidget;
	}(_react.Component);
	
	TimeseriesFilterWidget.displayName = "TimeseriesFilterWidget";
	exports.default = TimeseriesFilterWidget;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Option = exports.SelectButton = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _class2, _temp2, _class3, _temp3, _class4, _temp4; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ColumnarSelector = __webpack_require__(1058);
	
	var _ColumnarSelector2 = _interopRequireDefault(_ColumnarSelector);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Select = (_temp = _class = function (_Component) {
	    _inherits(Select, _Component);
	
	    function Select() {
	        _classCallCheck(this, Select);
	
	        return _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));
	    }
	
	    _createClass(Select, [{
	        key: "render",
	        value: function render() {
	            if (this.props.children) {
	                return _react2.default.createElement(BrowserSelect, this.props);
	            } else {
	                return _react2.default.createElement(LegacySelect, this.props);
	            }
	        }
	    }]);
	
	    return Select;
	}(_react.Component), _class.propTypes = {
	    children: _propTypes2.default.any
	}, _temp);
	Select.displayName = "Select";
	exports.default = Select;
	var BrowserSelect = (_temp2 = _class2 = function (_Component2) {
	    _inherits(BrowserSelect, _Component2);
	
	    function BrowserSelect(props, context) {
	        _classCallCheck(this, BrowserSelect);
	
	        var _this2 = _possibleConstructorReturn(this, (BrowserSelect.__proto__ || Object.getPrototypeOf(BrowserSelect)).call(this, props, context));
	
	        _this2.state = {
	            inputValue: ""
	        };
	        return _this2;
	    }
	
	    _createClass(BrowserSelect, [{
	        key: "isSelected",
	        value: function isSelected(otherValue) {
	            var value = this.props.value;
	
	            return value === otherValue || (value == null || value === "") && (otherValue == null || otherValue === "");
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                children = _props.children,
	                value = _props.value,
	                onChange = _props.onChange,
	                searchProp = _props.searchProp,
	                searchCaseInsensitive = _props.searchCaseInsensitive,
	                isInitiallyOpen = _props.isInitiallyOpen,
	                placeholder = _props.placeholder;
	
	
	            var selectedName = void 0;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var child = _step.value;
	
	                    if (this.isSelected(child.props.value)) {
	                        selectedName = child.props.children;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            if (selectedName == null && placeholder) {
	                selectedName = placeholder;
	            }
	
	            var inputValue = this.state.inputValue;
	
	            var filter = function filter() {
	                return true;
	            };
	            if (searchProp && inputValue) {
	                filter = function filter(child) {
	                    var childValue = String(child.props[searchProp] || "");
	                    if (!inputValue) {
	                        return false;
	                    } else if (searchCaseInsensitive) {
	                        return childValue.toLowerCase().startsWith(inputValue.toLowerCase());
	                    } else {
	                        return childValue.startsWith(inputValue);
	                    }
	                };
	            }
	
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                {
	                    ref: "popover",
	                    className: className,
	                    triggerElement: _react2.default.createElement(
	                        SelectButton,
	                        { hasValue: !!value },
	                        selectedName
	                    ),
	                    triggerClasses: className,
	                    verticalAttachments: ["top"],
	                    isInitiallyOpen: isInitiallyOpen
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex flex-column" },
	                    searchProp && _react2.default.createElement("input", {
	                        className: "AdminSelect m1 flex-full",
	                        value: inputValue,
	                        onChange: function onChange(e) {
	                            return _this3.setState({ inputValue: e.target.value });
	                        },
	                        autoFocus: true
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ColumnarSelector-column scroll-y", onClick: function onClick(e) {
	                                return e.stopPropagation();
	                            } },
	                        children.filter(filter).map(function (child) {
	                            return _react2.default.cloneElement(child, {
	                                selected: _this3.isSelected(child.props.value),
	                                onClick: function onClick() {
	                                    if (!child.props.disabled) {
	                                        onChange({ target: { value: child.props.value } });
	                                    }
	                                    _this3.refs.popover.close();
	                                }
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return BrowserSelect;
	}(_react.Component), _class2.propTypes = {
	    children: _propTypes2.default.array.isRequired,
	    className: _propTypes2.default.string,
	    value: _propTypes2.default.any,
	    onChange: _propTypes2.default.func.isRequired,
	    searchProp: _propTypes2.default.string,
	    searchCaseInsensitive: _propTypes2.default.bool,
	    isInitiallyOpen: _propTypes2.default.bool,
	    placeholder: _propTypes2.default.string
	}, _class2.defaultProps = {
	    className: ""
	}, _temp2);
	BrowserSelect.displayName = "BrowserSelect";
	var SelectButton = exports.SelectButton = function SelectButton(_ref) {
	    var hasValue = _ref.hasValue,
	        children = _ref.children;
	    return _react2.default.createElement(
	        "div",
	        { className: "AdminSelect flex align-center " + (!hasValue ? " text-grey-3" : "") },
	        _react2.default.createElement(
	            "span",
	            { className: "AdminSelect-content mr1" },
	            children
	        ),
	        _react2.default.createElement(_Icon2.default, { className: "AdminSelect-chevron flex-align-right", name: "chevrondown", size: 12 })
	    );
	};
	
	SelectButton.displayName = "SelectButton";
	SelectButton.propTypes = {
	    hasValue: _propTypes2.default.bool,
	    children: _propTypes2.default.any
	};
	
	var Option = exports.Option = (_temp3 = _class3 = function (_Component3) {
	    _inherits(Option, _Component3);
	
	    function Option() {
	        _classCallCheck(this, Option);
	
	        return _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).apply(this, arguments));
	    }
	
	    _createClass(Option, [{
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                children = _props2.children,
	                selected = _props2.selected,
	                disabled = _props2.disabled,
	                icon = _props2.icon,
	                iconColor = _props2.iconColor,
	                iconSize = _props2.iconSize,
	                onClick = _props2.onClick;
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    onClick: onClick,
	                    className: (0, _classnames2.default)("ColumnarSelector-row flex align-center cursor-pointer no-decoration relative", {
	                        "ColumnarSelector-row--selected": selected,
	                        "disabled": disabled
	                    })
	                },
	                _react2.default.createElement(_Icon2.default, { name: "check", size: 14, style: { position: 'absolute' } }),
	                icon && _react2.default.createElement(_Icon2.default, {
	                    name: icon,
	                    size: iconSize,
	                    style: {
	                        position: 'absolute',
	                        color: iconColor,
	                        visibility: !selected ? "visible" : "hidden"
	                    }
	                }),
	                _react2.default.createElement(
	                    "span",
	                    { className: "ml4" },
	                    children
	                )
	            );
	        }
	    }]);
	
	    return Option;
	}(_react.Component), _class3.propTypes = {
	    children: _propTypes2.default.any,
	    selected: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func,
	    icon: _propTypes2.default.string,
	    iconColor: _propTypes2.default.string,
	    iconSize: _propTypes2.default.number
	}, _temp3);
	Option.displayName = "Option";
	var LegacySelect = (_temp4 = _class4 = function (_Component4) {
	    _inherits(LegacySelect, _Component4);
	
	    function LegacySelect() {
	        _classCallCheck(this, LegacySelect);
	
	        return _possibleConstructorReturn(this, (LegacySelect.__proto__ || Object.getPrototypeOf(LegacySelect)).apply(this, arguments));
	    }
	
	    _createClass(LegacySelect, [{
	        key: "toggle",
	        value: function toggle() {
	            this.refs.popover.toggle();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this6 = this;
	
	            var _props3 = this.props,
	                className = _props3.className,
	                value = _props3.value,
	                values = _props3.values,
	                onChange = _props3.onChange,
	                options = _props3.options,
	                disabledOptionIds = _props3.disabledOptionIds,
	                optionNameFn = _props3.optionNameFn,
	                optionValueFn = _props3.optionValueFn,
	                placeholder = _props3.placeholder,
	                emptyPlaceholder = _props3.emptyPlaceholder,
	                isInitiallyOpen = _props3.isInitiallyOpen,
	                disabled = _props3.disabled;
	
	
	            var selectedName = value ? optionNameFn(value) : options && options.length > 0 ? placeholder : emptyPlaceholder;
	
	            var triggerElement = _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("flex align-center", !value && (!values || values.length === 0) ? " text-grey-2" : "") },
	                values && values.length !== 0 ? values.map(function (value) {
	                    return optionNameFn(value);
	                }).sort().map(function (name, index) {
	                    return _react2.default.createElement(
	                        "span",
	                        { key: index, className: "mr1" },
	                        "" + name + (index !== values.length - 1 ? ',   ' : '')
	                    );
	                }) : _react2.default.createElement(
	                    "span",
	                    { className: "mr1" },
	                    selectedName
	                ),
	                _react2.default.createElement(_Icon2.default, { className: "flex-align-right", name: "chevrondown", size: 12 })
	            );
	
	            var sections = {};
	            options.forEach(function (option) {
	                var sectionName = option.section || "";
	                sections[sectionName] = sections[sectionName] || { title: sectionName || undefined, items: [] };
	                sections[sectionName].items.push(option);
	            });
	            sections = Object.keys(sections).map(function (sectionName) {
	                return sections[sectionName];
	            });
	
	            var columns = [{
	                selectedItem: value,
	                selectedItems: values,
	                sections: sections,
	                disabledOptionIds: disabledOptionIds,
	                itemTitleFn: optionNameFn,
	                itemDescriptionFn: function itemDescriptionFn(item) {
	                    return item.description;
	                },
	                itemSelectFn: function itemSelectFn(item) {
	                    onChange(optionValueFn(item));
	                    if (!values) {
	                        _this6.toggle();
	                    }
	                }
	            }];
	
	            var disablePopover = disabled || !options || options.length === 0;
	
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                {
	                    ref: "popover",
	                    className: className,
	                    triggerElement: triggerElement,
	                    triggerClasses: this.props.triggerClasses || (0, _classnames2.default)("AdminSelect", this.props.className),
	                    isInitiallyOpen: isInitiallyOpen,
	                    disabled: disablePopover
	                },
	                _react2.default.createElement(
	                    "div",
	                    { onClick: function onClick(e) {
	                            return e.stopPropagation();
	                        } },
	                    _react2.default.createElement(_ColumnarSelector2.default, {
	                        columns: columns
	                    })
	                )
	            );
	        }
	    }]);
	
	    return LegacySelect;
	}(_react.Component), _class4.propTypes = {
	    value: _propTypes2.default.any,
	    values: _propTypes2.default.array,
	    options: _propTypes2.default.array.isRequired,
	    disabledOptionIds: _propTypes2.default.array,
	    placeholder: _propTypes2.default.string,
	    emptyPlaceholder: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    optionNameFn: _propTypes2.default.func,
	    optionValueFn: _propTypes2.default.func,
	    className: _propTypes2.default.string,
	    isInitiallyOpen: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    //TODO: clean up hardcoded "AdminSelect" class on trigger to avoid this workaround
	    triggerClasses: _propTypes2.default.string
	}, _class4.defaultProps = {
	    placeholder: "",
	    emptyPlaceholder: "Nothing to select",
	    disabledOptionIds: [],
	    optionNameFn: function optionNameFn(option) {
	        return option.name;
	    },
	    optionValueFn: function optionValueFn(option) {
	        return option;
	    },
	    isInitiallyOpen: false
	}, _temp4);
	LegacySelect.displayName = "LegacySelect";

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1059);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColumnarSelector = (_temp = _class = function (_Component) {
	    _inherits(ColumnarSelector, _Component);
	
	    function ColumnarSelector() {
	        _classCallCheck(this, ColumnarSelector);
	
	        return _possibleConstructorReturn(this, (ColumnarSelector.__proto__ || Object.getPrototypeOf(ColumnarSelector)).apply(this, arguments));
	    }
	
	    _createClass(ColumnarSelector, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var isItemSelected = function isItemSelected(item, column) {
	                return column.selectedItems ? column.selectedItems.includes(item) : column.selectedItem === item;
	            };
	            var isItemDisabled = function isItemDisabled(item, column) {
	                return column.disabledOptionIds ? column.disabledOptionIds.includes(item.id) : false;
	            };
	
	            var columns = this.props.columns.map(function (column, columnIndex) {
	                var sectionElements;
	                if (column) {
	                    var lastColumn = columnIndex === _this2.props.columns.length - 1;
	                    var sections = column.sections || [column];
	                    sectionElements = sections.map(function (section, sectionIndex) {
	                        var title = section.title;
	                        var items = section.items.map(function (item, rowIndex) {
	                            var itemClasses = (0, _classnames2.default)({
	                                'ColumnarSelector-row': true,
	                                'ColumnarSelector-row--selected': isItemSelected(item, column),
	                                'ColumnarSelector-row--disabled': isItemDisabled(item, column),
	                                'flex': true,
	                                'no-decoration': true,
	                                'cursor-default': isItemDisabled(item, column)
	                            });
	                            var checkIcon = lastColumn ? _react2.default.createElement(_Icon2.default, { name: "check", size: 14 }) : null;
	                            var descriptionElement;
	                            var description = column.itemDescriptionFn && column.itemDescriptionFn(item);
	                            if (description) {
	                                descriptionElement = _react2.default.createElement(
	                                    "div",
	                                    { className: "ColumnarSelector-description" },
	                                    description
	                                );
	                            }
	                            return _react2.default.createElement(
	                                "li",
	                                { key: rowIndex },
	                                _react2.default.createElement(
	                                    "a",
	                                    { className: itemClasses, onClick: !isItemDisabled(item, column) && column.itemSelectFn.bind(null, item) },
	                                    checkIcon,
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "flex flex-column ml1" },
	                                        column.itemTitleFn(item),
	                                        descriptionElement
	                                    )
	                                )
	                            );
	                        });
	                        var titleElement;
	                        if (title) {
	                            titleElement = _react2.default.createElement(
	                                "div",
	                                { className: "ColumnarSelector-title" },
	                                title
	                            );
	                        }
	                        return _react2.default.createElement(
	                            "section",
	                            { key: sectionIndex, className: "ColumnarSelector-section" },
	                            titleElement,
	                            _react2.default.createElement(
	                                "ul",
	                                { className: "ColumnarSelector-rows" },
	                                items
	                            )
	                        );
	                    });
	                }
	
	                return _react2.default.createElement(
	                    "div",
	                    { key: columnIndex, className: "ColumnarSelector-column scroll-y scroll-show" },
	                    sectionElements
	                );
	            });
	
	            return _react2.default.createElement(
	                "div",
	                { className: "ColumnarSelector" },
	                columns
	            );
	        }
	    }]);
	
	    return ColumnarSelector;
	}(_react.Component), _class.propTypes = {
	    columns: _propTypes2.default.array.isRequired
	}, _temp);
	ColumnarSelector.displayName = "ColumnarSelector";
	exports.default = ColumnarSelector;

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */,
/* 1061 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var question = _ref.question,
	        settings = _ref.settings;
	
	    // currently time series xrays require the maximum fidelity
	    if (question.card().id && settings["enable_xrays"] && settings["xray_max_cost"] === "extended") {
	        return [{
	            name: "xray-card",
	            title: "X-ray this question",
	            icon: "beaker",
	            url: function url() {
	                return "/xray/card/" + question.card().id + "/extended";
	            }
	        }];
	    } else {
	        return [];
	    }
	};

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimeGroupingPopover = __webpack_require__(1063);
	
	var _TimeGroupingPopover2 = _interopRequireDefault(_TimeGroupingPopover);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _Select = __webpack_require__(1057);
	
	var _query = __webpack_require__(887);
	
	var Query = _interopRequireWildcard(_query);
	
	var _Card = __webpack_require__(957);
	
	var Card = _interopRequireWildcard(_Card);
	
	var _query_time = __webpack_require__(944);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	var TimeseriesGroupingWidget = function (_Component) {
	    _inherits(TimeseriesGroupingWidget, _Component);
	
	    function TimeseriesGroupingWidget() {
	        _classCallCheck(this, TimeseriesGroupingWidget);
	
	        return _possibleConstructorReturn(this, (TimeseriesGroupingWidget.__proto__ || Object.getPrototypeOf(TimeseriesGroupingWidget)).apply(this, arguments));
	    }
	
	    _createClass(TimeseriesGroupingWidget, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                card = _props.card,
	                setDatasetQuery = _props.setDatasetQuery;
	
	
	            if (Card.isStructured(card)) {
	                var query = Card.getQuery(card);
	                var breakouts = query && Query.getBreakouts(query);
	
	                if (!breakouts || breakouts.length === 0) {
	                    return null;
	                }
	
	                return _react2.default.createElement(
	                    _PopoverWithTrigger2.default,
	                    {
	                        triggerElement: _react2.default.createElement(
	                            _Select.SelectButton,
	                            { hasValue: true },
	                            (0, _query_time.formatBucketing)((0, _query_time.parseFieldBucketing)(breakouts[0]))
	                        ),
	                        triggerClasses: "my2",
	                        ref: function ref(_ref) {
	                            return _this2._popover = _ref;
	                        }
	                    },
	                    _react2.default.createElement(_TimeGroupingPopover2.default, {
	                        className: "text-brand",
	                        field: breakouts[0],
	                        onFieldChange: function onFieldChange(breakout) {
	                            var query = Card.getQuery(card);
	                            if (query) {
	                                query = Query.updateBreakout(query, 0, breakout);
	                                var _datasetQuery = _extends({}, card.dataset_query, {
	                                    query: query
	                                });
	                                setDatasetQuery(_datasetQuery, { run: true });
	                                if (_this2._popover) {
	                                    _this2._popover.close();
	                                }
	                            }
	                        },
	                        title: null,
	                        groupingOptions: ["minute", "hour", "day", "week", "month", "quarter", "year"]
	                    })
	                );
	            } else {
	                return null;
	            }
	        }
	    }]);
	
	    return TimeseriesGroupingWidget;
	}(_react.Component);
	
	TimeseriesGroupingWidget.displayName = "TimeseriesGroupingWidget";
	exports.default = TimeseriesGroupingWidget;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _query_time = __webpack_require__(944);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BUCKETINGS = ["default", "minute", "hour", "day", "week", "month", "quarter", "year", null, "minute-of-hour", "hour-of-day", "day-of-week", "day-of-month", "day-of-year", "week-of-year", "month-of-year", "quarter-of-year"];
	
	var TimeGroupingPopover = (_temp = _class = function (_Component) {
	    _inherits(TimeGroupingPopover, _Component);
	
	    function TimeGroupingPopover(props, context) {
	        _classCallCheck(this, TimeGroupingPopover);
	
	        var _this = _possibleConstructorReturn(this, (TimeGroupingPopover.__proto__ || Object.getPrototypeOf(TimeGroupingPopover)).call(this, props, context));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(TimeGroupingPopover, [{
	        key: "setField",
	        value: function setField(bucketing) {
	            this.props.onFieldChange(["datetime-field", this.props.field[1], "as", bucketing]);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                title = _props.title,
	                field = _props.field,
	                className = _props.className,
	                groupingOptions = _props.groupingOptions;
	
	            var enabledOptions = new Set(groupingOptions);
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(className, "px2 py1"), style: { width: "250px" } },
	                title && _react2.default.createElement(
	                    "h3",
	                    { className: "List-section-header pt1 mx2" },
	                    title
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "py1" },
	                    BUCKETINGS.filter(function (o) {
	                        return o == null || enabledOptions.has(o);
	                    }).map(function (bucketing, bucketingIndex) {
	                        return bucketing == null ? _react2.default.createElement("hr", { key: bucketingIndex, style: { "border": "none" } }) : _react2.default.createElement(
	                            "li",
	                            { key: bucketingIndex, className: (0, _classnames2.default)("List-item", { "List-item--selected": (0, _query_time.parseFieldBucketing)(field) === bucketing }) },
	                            _react2.default.createElement(
	                                "a",
	                                { className: "List-item-title full px2 py1 cursor-pointer", onClick: _this2.setField.bind(_this2, bucketing) },
	                                (0, _query_time.formatBucketing)(bucketing)
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TimeGroupingPopover;
	}(_react.Component), _class.propTypes = {
	    field: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	    onFieldChange: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	    title: "Group time by",
	    groupingOptions: [
	    // "default",
	    "minute", "hour", "day", "week", "month", "quarter", "year",
	    // "minute-of-hour",
	    "hour-of-day", "day-of-week", "day-of-month",
	    // "day-of-year",
	    "week-of-year", "month-of-year", "quarter-of-year"]
	}, _temp);
	TimeGroupingPopover.displayName = "TimeGroupingPopover";
	exports.default = TimeGroupingPopover;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(966);
	
	var _drill = __webpack_require__(969);
	
	var _PivotByCategoryAction = __webpack_require__(1047);
	
	var _PivotByCategoryAction2 = _interopRequireDefault(_PivotByCategoryAction);
	
	var _PivotByTimeAction = __webpack_require__(1051);
	
	var _PivotByTimeAction2 = _interopRequireDefault(_PivotByTimeAction);
	
	var _PivotByCategoryDrill = __webpack_require__(1052);
	
	var _PivotByCategoryDrill2 = _interopRequireDefault(_PivotByCategoryDrill);
	
	var _PivotByTimeDrill = __webpack_require__(1054);
	
	var _PivotByTimeDrill2 = _interopRequireDefault(_PivotByTimeDrill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var GeoMode = {
	    name: "geo",
	    actions: [].concat(_toConsumableArray(_actions.DEFAULT_ACTIONS), [_PivotByCategoryAction2.default, _PivotByTimeAction2.default]),
	    drills: [].concat(_toConsumableArray(_drill.DEFAULT_DRILLS), [_PivotByCategoryDrill2.default, _PivotByTimeDrill2.default])
	};
	
	exports.default = GeoMode;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(966);
	
	var _drill = __webpack_require__(969);
	
	var _PivotByCategoryAction = __webpack_require__(1047);
	
	var _PivotByCategoryAction2 = _interopRequireDefault(_PivotByCategoryAction);
	
	var _PivotByLocationAction = __webpack_require__(1050);
	
	var _PivotByLocationAction2 = _interopRequireDefault(_PivotByLocationAction);
	
	var _PivotByTimeAction = __webpack_require__(1051);
	
	var _PivotByTimeAction2 = _interopRequireDefault(_PivotByTimeAction);
	
	var _PivotByCategoryDrill = __webpack_require__(1052);
	
	var _PivotByCategoryDrill2 = _interopRequireDefault(_PivotByCategoryDrill);
	
	var _PivotByLocationDrill = __webpack_require__(1053);
	
	var _PivotByLocationDrill2 = _interopRequireDefault(_PivotByLocationDrill);
	
	var _PivotByTimeDrill = __webpack_require__(1054);
	
	var _PivotByTimeDrill2 = _interopRequireDefault(_PivotByTimeDrill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var PivotMode = {
	    name: "pivot",
	    actions: [].concat(_toConsumableArray(_actions.DEFAULT_ACTIONS), [_PivotByCategoryAction2.default, _PivotByLocationAction2.default, _PivotByTimeAction2.default]),
	    drills: [].concat(_toConsumableArray(_drill.DEFAULT_DRILLS), [_PivotByCategoryDrill2.default, _PivotByLocationDrill2.default, _PivotByTimeDrill2.default])
	};
	
	exports.default = PivotMode;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _CompoundQueryAction = __webpack_require__(1067);
	
	var _CompoundQueryAction2 = _interopRequireDefault(_CompoundQueryAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NativeMode = {
	    name: "native",
	    actions: [_CompoundQueryAction2.default],
	    drills: []
	};
	
	exports.default = NativeMode;

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var _question = _ref.question;
	
	    if (_question.id()) {
	        return [{
	            name: "nest-query",
	            title: "Analyze the results of this Query",
	            icon: "table",
	            question: function question() {
	                return _question.composeThisQuery();
	            }
	        }];
	    }
	    return [];
	};

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _actions = __webpack_require__(966);
	
	var _drill = __webpack_require__(969);
	
	var DefaultMode = {
	    name: "default",
	    actions: _actions.DEFAULT_ACTIONS,
	    drills: _drill.DEFAULT_DRILLS
	};
	
	exports.default = DefaultMode;

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cancelable = cancelable;
	exports.timeout = timeout;
	exports.delay = delay;
	exports.defer = defer;
	// return a promise wrapping the provided one but with a "cancel" method
	function cancelable(promise) {
	    var canceled = false;
	
	    var wrappedPromise = new Promise(function (resolve, reject) {
	        promise.then(function (value) {
	            return canceled ? reject({ isCanceled: true }) : resolve(value);
	        }, function (error) {
	            return canceled ? reject({ isCanceled: true }) : reject(error);
	        });
	    });
	
	    wrappedPromise.cancel = function () {
	        canceled = true;
	    };
	
	    return wrappedPromise;
	}
	
	// if a promise doesn't resolve/reject within a given duration it will reject
	function timeout(promise, duration, error) {
	    return new Promise(function (resolve, reject) {
	        promise.then(resolve, reject);
	        setTimeout(function () {
	            return reject(error || new Error("Operation timed out"));
	        }, duration);
	    });
	}
	
	// returns a promise that resolves after a given duration
	function delay(duration) {
	    return new Promise(function (resolve, reject) {
	        return setTimeout(resolve, duration);
	    });
	}
	
	function defer() {
	    var deferrred = {};
	    deferrred.promise = new Promise(function (resolve, reject) {
	        deferrred.resolve = resolve;
	        deferrred.reject = reject;
	    });
	    return deferrred;
	}

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.performUndo = exports.dismissUndo = exports.addUndo = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var _ref = arguments[1];
	    var type = _ref.type,
	        payload = _ref.payload,
	        error = _ref.error;
	
	    switch (type) {
	        case ADD_UNDO:
	            if (error) {
	                console.warn("ADD_UNDO", payload);
	                return state;
	            }
	            var previous = state[state.length - 1];
	            // if last undo was same type then merge them
	            if (previous && payload.type != null && payload.type === previous.type) {
	                return state.slice(0, -1).concat(_extends({}, payload, {
	                    count: previous.count + payload.count,
	                    actions: [].concat(_toConsumableArray(previous.actions), _toConsumableArray(payload.actions)),
	                    _domId: previous._domId // use original _domId so we don't get funky animations swapping for the new one
	                }));
	            } else {
	                return state.concat(payload);
	            }
	        case DISMISS_UNDO:
	            if (error) {
	                console.warn("DISMISS_UNDO", payload);
	                return state;
	            }
	            return state.filter(function (undo) {
	                return undo.id !== payload;
	            });
	    }
	    return state;
	};
	
	var _redux = __webpack_require__(657);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ADD_UNDO = 'metabase/questions/ADD_UNDO';
	var DISMISS_UNDO = 'metabase/questions/DISMISS_UNDO';
	var PERFORM_UNDO = 'metabase/questions/PERFORM_UNDO';
	
	var nextUndoId = 0;
	
	var addUndo = exports.addUndo = (0, _redux.createThunkAction)(ADD_UNDO, function (undo) {
	    return function (dispatch, getState) {
	        var id = nextUndoId++;
	        setTimeout(function () {
	            return dispatch(dismissUndo(id, false));
	        }, 5000);
	        return _extends({}, undo, { id: id, _domId: id });
	    };
	});
	
	var dismissUndo = exports.dismissUndo = (0, _redux.createAction)(DISMISS_UNDO, function (undoId) {
	    var track = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (track) {
	        _analytics2.default.trackEvent("Undo", "Dismiss Undo");
	    }
	    return undoId;
	});
	
	var performUndo = exports.performUndo = (0, _redux.createThunkAction)(PERFORM_UNDO, function (undoId) {
	    return function (dispatch, getState) {
	        _analytics2.default.trackEvent("Undo", "Perform Undo");
	        var undo = _underscore2.default.findWhere(getState().undo, { id: undoId });
	        if (undo) {
	            undo.actions.map(function (action) {
	                return dispatch(action);
	            });
	            dispatch(dismissUndo(undoId, false));
	        }
	    };
	});

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getIsRunnable = exports.getQuery = exports.getOriginalQuestion = exports.getLastRunQuestion = exports.getQuestion = exports.getIsResultDirty = exports.getParameters = exports.getIsObjectDetail = exports.getMode = exports.getDatabaseFields = exports.getSampleDatasetId = exports.getTableMetadata = exports.getNativeDatabases = exports.getTables = exports.getTableForeignKeyReferences = exports.getTableForeignKeys = exports.getTableId = exports.getDatabaseId = exports.getIsNew = exports.getIsDirty = exports.getSettings = exports.getQueryResults = exports.getQueryResult = exports.getParameterValues = exports.getLastRunCard = exports.getOriginalCard = exports.getCard = exports.getIsRunning = exports.getIsEditing = exports.getIsShowingTutorial = exports.getIsShowingDataReference = exports.getIsShowingTemplateTagsEditor = exports.getUiControls = undefined;
	
	var _reselect = __webpack_require__(1072);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Card = __webpack_require__(957);
	
	var _card = __webpack_require__(865);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _icepick = __webpack_require__(855);
	
	var _metadata = __webpack_require__(1073);
	
	var _modes = __webpack_require__(962);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getUiControls = exports.getUiControls = function getUiControls(state) {
	    return state.qb.uiControls;
	};
	
	var getIsShowingTemplateTagsEditor = exports.getIsShowingTemplateTagsEditor = function getIsShowingTemplateTagsEditor(state) {
	    return getUiControls(state).isShowingTemplateTagsEditor;
	};
	var getIsShowingDataReference = exports.getIsShowingDataReference = function getIsShowingDataReference(state) {
	    return getUiControls(state).isShowingDataReference;
	};
	var getIsShowingTutorial = exports.getIsShowingTutorial = function getIsShowingTutorial(state) {
	    return getUiControls(state).isShowingTutorial;
	};
	var getIsEditing = exports.getIsEditing = function getIsEditing(state) {
	    return getUiControls(state).isEditing;
	};
	var getIsRunning = exports.getIsRunning = function getIsRunning(state) {
	    return getUiControls(state).isRunning;
	};
	
	var getCard = exports.getCard = function getCard(state) {
	    return state.qb.card;
	};
	var getOriginalCard = exports.getOriginalCard = function getOriginalCard(state) {
	    return state.qb.originalCard;
	};
	var getLastRunCard = exports.getLastRunCard = function getLastRunCard(state) {
	    return state.qb.lastRunCard;
	};
	
	var getParameterValues = exports.getParameterValues = function getParameterValues(state) {
	    return state.qb.parameterValues;
	};
	var getQueryResult = exports.getQueryResult = function getQueryResult(state) {
	    return state.qb.queryResult;
	};
	var getQueryResults = exports.getQueryResults = function getQueryResults(state) {
	    return state.qb.queryResults;
	};
	
	// get instance settings, used for determining whether to display certain actions,
	// currently used only for xrays
	var getSettings = exports.getSettings = function getSettings(state) {
	    return state.settings.values;
	};
	
	var getIsDirty = exports.getIsDirty = (0, _reselect.createSelector)([getCard, getOriginalCard], function (card, originalCard) {
	    return (0, _card.isCardDirty)(card, originalCard);
	});
	
	var getIsNew = exports.getIsNew = function getIsNew(state) {
	    return state.qb.card && !state.qb.card.id;
	};
	
	var getDatabaseId = exports.getDatabaseId = (0, _reselect.createSelector)([getCard], function (card) {
	    return card && card.dataset_query && card.dataset_query.database;
	});
	
	var getTableId = exports.getTableId = (0, _reselect.createSelector)([getCard], function (card) {
	    return (0, _icepick.getIn)(card, ["dataset_query", "query", "source_table"]);
	});
	
	var getTableForeignKeys = exports.getTableForeignKeys = function getTableForeignKeys(state) {
	    return state.qb.tableForeignKeys;
	};
	var getTableForeignKeyReferences = exports.getTableForeignKeyReferences = function getTableForeignKeyReferences(state) {
	    return state.qb.tableForeignKeyReferences;
	};
	
	var getTables = exports.getTables = (0, _reselect.createSelector)([getDatabaseId, _metadata.getDatabasesList], function (databaseId, databases) {
	    if (databaseId != null && databases && databases.length > 0) {
	        var db = _underscore2.default.findWhere(databases, { id: databaseId });
	        if (db && db.tables) {
	            return db.tables;
	        }
	    }
	
	    return [];
	});
	
	var getNativeDatabases = exports.getNativeDatabases = (0, _reselect.createSelector)([_metadata.getDatabasesList], function (databases) {
	    return databases && databases.filter(function (db) {
	        return db.native_permissions === "write";
	    });
	});
	
	var getTableMetadata = exports.getTableMetadata = (0, _reselect.createSelector)([getTableId, _metadata.getMetadata], function (tableId, metadata) {
	    return metadata.tables[tableId];
	});
	
	var getSampleDatasetId = exports.getSampleDatasetId = (0, _reselect.createSelector)([_metadata.getDatabasesList], function (databases) {
	    var sampleDataset = _underscore2.default.findWhere(databases, { is_sample: true });
	    return sampleDataset && sampleDataset.id;
	});
	
	var getDatabaseFields = exports.getDatabaseFields = (0, _reselect.createSelector)([getDatabaseId, function (state) {
	    return state.qb.databaseFields;
	}], function (databaseId, databaseFields) {
	    return databaseFields[databaseId];
	});
	
	var getMode = exports.getMode = (0, _reselect.createSelector)([getLastRunCard, getTableMetadata], function (card, tableMetadata) {
	    return (0, _modes.getMode)(card, tableMetadata);
	});
	
	var getIsObjectDetail = exports.getIsObjectDetail = (0, _reselect.createSelector)([getMode], function (mode) {
	    return mode && mode.name === "object";
	});
	
	var getParameters = exports.getParameters = (0, _reselect.createSelector)([getCard, getParameterValues], function (card, parameterValues) {
	    return (0, _Card.getParametersWithExtras)(card, parameterValues);
	});
	
	var getLastRunDatasetQuery = (0, _reselect.createSelector)([getLastRunCard], function (card) {
	    return card && card.dataset_query;
	});
	var getNextRunDatasetQuery = (0, _reselect.createSelector)([getCard], function (card) {
	    return card && card.dataset_query;
	});
	
	var getLastRunParameters = (0, _reselect.createSelector)([getQueryResult], function (queryResult) {
	    return queryResult && queryResult.json_query && queryResult.json_query.parameters || [];
	});
	var getLastRunParameterValues = (0, _reselect.createSelector)([getLastRunParameters], function (parameters) {
	    return parameters.map(function (parameter) {
	        return parameter.value;
	    });
	});
	var getNextRunParameterValues = (0, _reselect.createSelector)([getParameters], function (parameters) {
	    return parameters.map(function (parameter) {
	        return parameter.value;
	    }).filter(function (p) {
	        return p !== undefined;
	    });
	});
	
	var getIsResultDirty = exports.getIsResultDirty = (0, _reselect.createSelector)([getLastRunDatasetQuery, getNextRunDatasetQuery, getLastRunParameterValues, getNextRunParameterValues], function (lastDatasetQuery, nextDatasetQuery, lastParameters, nextParameters) {
	    return !_utils2.default.equals(lastDatasetQuery, nextDatasetQuery) || !_utils2.default.equals(lastParameters, nextParameters);
	});
	
	var getQuestion = exports.getQuestion = (0, _reselect.createSelector)([_metadata.getMetadata, getCard, getParameterValues], function (metadata, card, parameterValues) {
	    return metadata && card && new _Question2.default(metadata, card, parameterValues);
	});
	
	var getLastRunQuestion = exports.getLastRunQuestion = (0, _reselect.createSelector)([_metadata.getMetadata, getLastRunCard, getParameterValues], function (metadata, getLastRunCard, parameterValues) {
	    return metadata && getLastRunCard && new _Question2.default(metadata, getLastRunCard, parameterValues);
	});
	
	var getOriginalQuestion = exports.getOriginalQuestion = (0, _reselect.createSelector)([_metadata.getMetadata, getOriginalCard], function (metadata, card) {
	    // NOTE Atte Keinänen 5/31/17 Should the originalQuestion object take parameterValues or not? (currently not)
	    return metadata && card && new _Question2.default(metadata, card);
	});
	
	var getQuery = exports.getQuery = (0, _reselect.createSelector)([getQuestion], function (question) {
	    return question && question.query();
	});
	
	var getIsRunnable = exports.getIsRunnable = (0, _reselect.createSelector)([getQuestion], function (question) {
	    return question && question.canRun();
	});

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.makeGetMergedParameterFieldValues = exports.getSegments = exports.getMetrics = exports.getFields = exports.getTables = exports.getDatabasesList = exports.getDatabases = exports.getMetadata = exports.getShallowSegments = exports.getShallowMetrics = exports.getShallowFields = exports.getShallowTables = exports.getShallowDatabases = exports.getMetadataFetched = exports.getNormalizedSegments = exports.getNormalizedMetrics = exports.getNormalizedFields = exports.getNormalizedTables = exports.getNormalizedDatabases = exports.getNormalizedMetadata = undefined;
	exports.copyObjects = copyObjects;
	
	var _reselect = __webpack_require__(1072);
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _Database = __webpack_require__(897);
	
	var _Database2 = _interopRequireDefault(_Database);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Field = __webpack_require__(900);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Metric = __webpack_require__(943);
	
	var _Metric2 = _interopRequireDefault(_Metric);
	
	var _Segment = __webpack_require__(942);
	
	var _Segment2 = _interopRequireDefault(_Segment);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _recompose = __webpack_require__(1074);
	
	var _field = __webpack_require__(869);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _icepick = __webpack_require__(855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*  weak */
	
	var getNormalizedMetadata = exports.getNormalizedMetadata = function getNormalizedMetadata(state) {
	    return state.metadata;
	};
	
	// fully denomalized, raw "entities"
	var getNormalizedDatabases = exports.getNormalizedDatabases = function getNormalizedDatabases(state) {
	    return state.metadata.databases;
	};
	var getNormalizedTables = exports.getNormalizedTables = function getNormalizedTables(state) {
	    return state.metadata.tables;
	};
	var getNormalizedFields = exports.getNormalizedFields = function getNormalizedFields(state) {
	    return state.metadata.fields;
	};
	var getNormalizedMetrics = exports.getNormalizedMetrics = function getNormalizedMetrics(state) {
	    return state.metadata.metrics;
	};
	var getNormalizedSegments = exports.getNormalizedSegments = function getNormalizedSegments(state) {
	    return state.metadata.segments;
	};
	
	var getMetadataFetched = exports.getMetadataFetched = function getMetadataFetched(state) {
	    return state.requests.fetched.metadata || {};
	};
	
	// TODO: these should be denomalized but non-cylical, and only to the same "depth" previous "tableMetadata" was, e.x.
	//
	// TABLE:
	//
	// {
	//     db: {
	//         tables: undefined,
	//     }
	//     fields: [{
	//         table: undefined,
	//         target: {
	//             table: {
	//                 fields: undefined
	//             }
	//         }
	//     }]
	// }
	//
	var getShallowDatabases = exports.getShallowDatabases = getNormalizedDatabases;
	var getShallowTables = exports.getShallowTables = getNormalizedTables;
	var getShallowFields = exports.getShallowFields = getNormalizedFields;
	var getShallowMetrics = exports.getShallowMetrics = getNormalizedMetrics;
	var getShallowSegments = exports.getShallowSegments = getNormalizedSegments;
	
	// fully connected graph of all databases, tables, fields, segments, and metrics
	var getMetadata = exports.getMetadata = (0, _reselect.createSelector)([getNormalizedDatabases, getNormalizedTables, getNormalizedFields, getNormalizedSegments, getNormalizedMetrics], function (databases, tables, fields, segments, metrics) {
	    var meta = new _Metadata2.default();
	    meta.databases = copyObjects(meta, databases, _Database2.default);
	    meta.tables = copyObjects(meta, tables, _Table2.default);
	    meta.fields = copyObjects(meta, fields, _Field2.default);
	    meta.segments = copyObjects(meta, segments, _Segment2.default);
	    meta.metrics = copyObjects(meta, metrics, _Metric2.default);
	    // meta.loaded    = getLoadedStatuses(requestStates)
	
	    hydrateList(meta.databases, "tables", meta.tables);
	
	    hydrateList(meta.tables, "fields", meta.fields);
	    hydrateList(meta.tables, "segments", meta.segments);
	    hydrateList(meta.tables, "metrics", meta.metrics);
	
	    hydrate(meta.tables, "db", function (t) {
	        return meta.databases[t.db_id || t.db];
	    });
	
	    hydrate(meta.segments, "table", function (s) {
	        return meta.tables[s.table_id];
	    });
	    hydrate(meta.metrics, "table", function (m) {
	        return meta.tables[m.table_id];
	    });
	    hydrate(meta.fields, "table", function (f) {
	        return meta.tables[f.table_id];
	    });
	
	    hydrate(meta.fields, "target", function (f) {
	        return meta.fields[f.fk_target_field_id];
	    });
	
	    hydrate(meta.fields, "operators", function (f) {
	        return (0, _schema_metadata.getOperators)(f, f.table);
	    });
	    hydrate(meta.tables, "aggregation_options", function (t) {
	        return (0, _schema_metadata.getAggregatorsWithFields)(t);
	    });
	    hydrate(meta.tables, "breakout_options", function (t) {
	        return (0, _schema_metadata.getBreakouts)(t.fields);
	    });
	
	    hydrate(meta.fields, "remapping", function (f) {
	        return new Map((0, _field.getFieldValues)(f));
	    });
	
	    hydrateLookup(meta.databases, "tables", "id");
	    hydrateLookup(meta.tables, "fields", "id");
	    hydrateLookup(meta.fields, "operators", "name");
	
	    return meta;
	});
	
	var getDatabases = exports.getDatabases = (0, _reselect.createSelector)([getMetadata], function (_ref) {
	    var databases = _ref.databases;
	    return databases;
	});
	
	var getDatabasesList = exports.getDatabasesList = (0, _reselect.createSelector)([getDatabases, function (state) {
	    return state.metadata.databasesList;
	}], function (databases, ids) {
	    return ids.map(function (id) {
	        return databases[id];
	    });
	});
	
	var getTables = exports.getTables = (0, _reselect.createSelector)([getMetadata], function (_ref2) {
	    var tables = _ref2.tables;
	    return tables;
	});
	
	var getFields = exports.getFields = (0, _reselect.createSelector)([getMetadata], function (_ref3) {
	    var fields = _ref3.fields;
	    return fields;
	});
	var getMetrics = exports.getMetrics = (0, _reselect.createSelector)([getMetadata], function (_ref4) {
	    var metrics = _ref4.metrics;
	    return metrics;
	});
	
	var getSegments = exports.getSegments = (0, _reselect.createSelector)([getMetadata], function (_ref5) {
	    var segments = _ref5.segments;
	    return segments;
	});
	
	// FIELD VALUES FOR DASHBOARD FILTERS / SQL QUESTION PARAMETERS
	
	// Returns a dictionary of field id:s mapped to matching field values
	// Currently this assumes that you are passing the props of <ParameterValueWidget> which contain the
	// `field_ids` array inside `parameter` prop.
	var getParameterFieldValuesByFieldId = function getParameterFieldValuesByFieldId(state, props) {
	    var _$chain;
	
	    // NOTE Atte Keinänen 9/14/17: Reading the state directly instead of using `getFields` selector
	    // because `getMetadata` doesn't currently work with fields of public dashboards
	    return (_$chain = _underscore2.default.chain((0, _icepick.getIn)(state, ["metadata", "fields"]))
	    // SQL template tags provide `field_id` instead of `field_ids`
	    ).pick.apply(_$chain, _toConsumableArray(props.parameter.field_ids || [props.parameter.field_id])).mapObject(_field.getFieldValues).value();
	};
	
	// Custom equality selector for checking if two field value dictionaries contain same fields and field values
	// Currently we simply check if fields match and the lengths of field value arrays are equal which makes the comparison fast
	// See https://github.com/reactjs/reselect#customize-equalitycheck-for-defaultmemoize
	var createFieldValuesEqualSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, function (a, b) {
	    // TODO: Why can't we use plain shallowEqual, i.e. why the field value arrays change very often?
	    return (0, _recompose.shallowEqual)(_underscore2.default.mapObject(a, function (values) {
	        return values.length;
	    }), _underscore2.default.mapObject(b, function (values) {
	        return values.length;
	    }));
	});
	
	// HACK Atte Keinänen 7/27/17: Currently the field value analysis code only returns a single value for booleans,
	// this will be addressed in analysis sync refactor
	var patchBooleanFieldValues_HACK = function patchBooleanFieldValues_HACK(valueArray) {
	    var isBooleanFieldValues = valueArray && valueArray.length === 1 && valueArray[0] && typeof valueArray[0][0] === "boolean";
	
	    if (isBooleanFieldValues) {
	        return [[true], [false]];
	    } else {
	        return valueArray;
	    }
	};
	
	// Merges the field values of fields linked to a parameter and removes duplicates
	// We want that we have a distinct selector for each field id combination, and for that reason
	// we export a method that creates a new selector; see
	// https://github.com/reactjs/reselect#sharing-selectors-with-props-across-multiple-components
	// TODO Atte Keinänen 7/20/17: Should we have any thresholds if the count of field values is high or we have many (>2?) fields?
	var makeGetMergedParameterFieldValues = exports.makeGetMergedParameterFieldValues = function makeGetMergedParameterFieldValues() {
	    return createFieldValuesEqualSelector(getParameterFieldValuesByFieldId, function (fieldValues) {
	        var fieldIds = Object.keys(fieldValues);
	
	        if (fieldIds.length === 0) {
	            // If we have no fields for the parameter, don't return any field values
	            return [];
	        } else if (fieldIds.length === 1) {
	            // We have just a single field so we can return the field values almost as-is,
	            // only address the boolean bug for now
	            var singleFieldValues = fieldValues[fieldIds[0]];
	            return patchBooleanFieldValues_HACK(singleFieldValues);
	        } else {
	            // We have multiple fields, so let's merge their values to a single array
	            var sortedMergedValues = _underscore2.default.chain(Object.values(fieldValues)).flatten(true).sortBy(function (fieldValue) {
	                var valueIsRemapped = fieldValue.length === 2;
	                return valueIsRemapped ? fieldValue[1] : fieldValue[0];
	            }).value();
	
	            // run the uniqueness comparision always against a non-remapped value
	            return _underscore2.default.uniq(sortedMergedValues, false, function (fieldValue) {
	                return fieldValue[0];
	            });
	        }
	    });
	};
	
	// UTILS:
	
	// clone each object in the provided mapping of objects
	function copyObjects(metadata, objects, Klass) {
	    var copies = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = Object.values(objects)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var object = _step.value;
	
	            // $FlowFixMe
	            copies[object.id] = new Klass(object);
	            // $FlowFixMe
	            copies[object.id].metadata = metadata;
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return copies;
	}
	
	// calls a function to derive the value of a property for every object
	function hydrate(objects, property, getPropertyValue) {
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = Object.values(objects)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var object = _step2.value;
	
	            // $FlowFixMe
	            object[property] = getPropertyValue(object);
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	}
	
	// replaces lists of ids with the actual objects
	function hydrateList(objects, property, targetObjects) {
	    hydrate(objects, property, function (object) {
	        return (object[property] || []).map(function (id) {
	            return targetObjects[id];
	        });
	    });
	}
	
	// creates a *_lookup object for a previously hydrated list
	function hydrateLookup(objects, property) {
	    var idProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "id";
	
	    hydrate(objects, property + "_lookup", function (object) {
	        var lookup = {};
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = (object[property] || [])[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var item = _step3.value;
	
	                lookup[item[idProperty]] = item;
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	
	        return lookup;
	    });
	}

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.setObservableConfig = exports.createEventHandler = exports.mapPropsStream = exports.componentFromStream = exports.hoistStatics = exports.nest = exports.componentFromProp = exports.createSink = exports.createEagerFactory = exports.createEagerElement = exports.isClassComponent = exports.shallowEqual = exports.wrapDisplayName = exports.getDisplayName = exports.compose = exports.setDisplayName = exports.setPropTypes = exports.setStatic = exports.toClass = exports.lifecycle = exports.getContext = exports.withContext = exports.onlyUpdateForPropTypes = exports.onlyUpdateForKeys = exports.pure = exports.shouldUpdate = exports.renderNothing = exports.renderComponent = exports.branch = exports.withReducer = exports.withState = exports.flattenProp = exports.renameProps = exports.renameProp = exports.defaultProps = exports.withHandlers = exports.withPropsOnChange = exports.withProps = exports.mapProps = undefined;
	
	var _mapProps2 = __webpack_require__(1075);
	
	var _mapProps3 = _interopRequireDefault(_mapProps2);
	
	var _withProps2 = __webpack_require__(1076);
	
	var _withProps3 = _interopRequireDefault(_withProps2);
	
	var _withPropsOnChange2 = __webpack_require__(1077);
	
	var _withPropsOnChange3 = _interopRequireDefault(_withPropsOnChange2);
	
	var _withHandlers2 = __webpack_require__(1079);
	
	var _withHandlers3 = _interopRequireDefault(_withHandlers2);
	
	var _defaultProps2 = __webpack_require__(1080);
	
	var _defaultProps3 = _interopRequireDefault(_defaultProps2);
	
	var _renameProp2 = __webpack_require__(1081);
	
	var _renameProp3 = _interopRequireDefault(_renameProp2);
	
	var _renameProps2 = __webpack_require__(1083);
	
	var _renameProps3 = _interopRequireDefault(_renameProps2);
	
	var _flattenProp2 = __webpack_require__(1084);
	
	var _flattenProp3 = _interopRequireDefault(_flattenProp2);
	
	var _withState2 = __webpack_require__(1085);
	
	var _withState3 = _interopRequireDefault(_withState2);
	
	var _withReducer2 = __webpack_require__(1086);
	
	var _withReducer3 = _interopRequireDefault(_withReducer2);
	
	var _branch2 = __webpack_require__(1087);
	
	var _branch3 = _interopRequireDefault(_branch2);
	
	var _renderComponent2 = __webpack_require__(1088);
	
	var _renderComponent3 = _interopRequireDefault(_renderComponent2);
	
	var _renderNothing2 = __webpack_require__(1089);
	
	var _renderNothing3 = _interopRequireDefault(_renderNothing2);
	
	var _shouldUpdate2 = __webpack_require__(914);
	
	var _shouldUpdate3 = _interopRequireDefault(_shouldUpdate2);
	
	var _pure2 = __webpack_require__(913);
	
	var _pure3 = _interopRequireDefault(_pure2);
	
	var _onlyUpdateForKeys2 = __webpack_require__(1090);
	
	var _onlyUpdateForKeys3 = _interopRequireDefault(_onlyUpdateForKeys2);
	
	var _onlyUpdateForPropTypes2 = __webpack_require__(1091);
	
	var _onlyUpdateForPropTypes3 = _interopRequireDefault(_onlyUpdateForPropTypes2);
	
	var _withContext2 = __webpack_require__(1092);
	
	var _withContext3 = _interopRequireDefault(_withContext2);
	
	var _getContext2 = __webpack_require__(1093);
	
	var _getContext3 = _interopRequireDefault(_getContext2);
	
	var _lifecycle2 = __webpack_require__(1094);
	
	var _lifecycle3 = _interopRequireDefault(_lifecycle2);
	
	var _toClass2 = __webpack_require__(1095);
	
	var _toClass3 = _interopRequireDefault(_toClass2);
	
	var _setStatic2 = __webpack_require__(1096);
	
	var _setStatic3 = _interopRequireDefault(_setStatic2);
	
	var _setPropTypes2 = __webpack_require__(1097);
	
	var _setPropTypes3 = _interopRequireDefault(_setPropTypes2);
	
	var _setDisplayName2 = __webpack_require__(1098);
	
	var _setDisplayName3 = _interopRequireDefault(_setDisplayName2);
	
	var _compose2 = __webpack_require__(1099);
	
	var _compose3 = _interopRequireDefault(_compose2);
	
	var _getDisplayName2 = __webpack_require__(917);
	
	var _getDisplayName3 = _interopRequireDefault(_getDisplayName2);
	
	var _wrapDisplayName2 = __webpack_require__(916);
	
	var _wrapDisplayName3 = _interopRequireDefault(_wrapDisplayName2);
	
	var _shallowEqual2 = __webpack_require__(922);
	
	var _shallowEqual3 = _interopRequireDefault(_shallowEqual2);
	
	var _isClassComponent2 = __webpack_require__(921);
	
	var _isClassComponent3 = _interopRequireDefault(_isClassComponent2);
	
	var _createEagerElement2 = __webpack_require__(1100);
	
	var _createEagerElement3 = _interopRequireDefault(_createEagerElement2);
	
	var _createEagerFactory2 = __webpack_require__(918);
	
	var _createEagerFactory3 = _interopRequireDefault(_createEagerFactory2);
	
	var _createSink2 = __webpack_require__(1101);
	
	var _createSink3 = _interopRequireDefault(_createSink2);
	
	var _componentFromProp2 = __webpack_require__(1102);
	
	var _componentFromProp3 = _interopRequireDefault(_componentFromProp2);
	
	var _nest2 = __webpack_require__(1103);
	
	var _nest3 = _interopRequireDefault(_nest2);
	
	var _hoistStatics2 = __webpack_require__(1104);
	
	var _hoistStatics3 = _interopRequireDefault(_hoistStatics2);
	
	var _componentFromStream2 = __webpack_require__(1105);
	
	var _componentFromStream3 = _interopRequireDefault(_componentFromStream2);
	
	var _mapPropsStream2 = __webpack_require__(1108);
	
	var _mapPropsStream3 = _interopRequireDefault(_mapPropsStream2);
	
	var _createEventHandler2 = __webpack_require__(1109);
	
	var _createEventHandler3 = _interopRequireDefault(_createEventHandler2);
	
	var _setObservableConfig2 = __webpack_require__(1107);
	
	var _setObservableConfig3 = _interopRequireDefault(_setObservableConfig2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.mapProps = _mapProps3.default; // Higher-order component helpers
	
	exports.withProps = _withProps3.default;
	exports.withPropsOnChange = _withPropsOnChange3.default;
	exports.withHandlers = _withHandlers3.default;
	exports.defaultProps = _defaultProps3.default;
	exports.renameProp = _renameProp3.default;
	exports.renameProps = _renameProps3.default;
	exports.flattenProp = _flattenProp3.default;
	exports.withState = _withState3.default;
	exports.withReducer = _withReducer3.default;
	exports.branch = _branch3.default;
	exports.renderComponent = _renderComponent3.default;
	exports.renderNothing = _renderNothing3.default;
	exports.shouldUpdate = _shouldUpdate3.default;
	exports.pure = _pure3.default;
	exports.onlyUpdateForKeys = _onlyUpdateForKeys3.default;
	exports.onlyUpdateForPropTypes = _onlyUpdateForPropTypes3.default;
	exports.withContext = _withContext3.default;
	exports.getContext = _getContext3.default;
	exports.lifecycle = _lifecycle3.default;
	exports.toClass = _toClass3.default;
	
	// Static property helpers
	
	exports.setStatic = _setStatic3.default;
	exports.setPropTypes = _setPropTypes3.default;
	exports.setDisplayName = _setDisplayName3.default;
	
	// Composition function
	
	exports.compose = _compose3.default;
	
	// Other utils
	
	exports.getDisplayName = _getDisplayName3.default;
	exports.wrapDisplayName = _wrapDisplayName3.default;
	exports.shallowEqual = _shallowEqual3.default;
	exports.isClassComponent = _isClassComponent3.default;
	exports.createEagerElement = _createEagerElement3.default;
	exports.createEagerFactory = _createEagerFactory3.default;
	exports.createSink = _createSink3.default;
	exports.componentFromProp = _componentFromProp3.default;
	exports.nest = _nest3.default;
	exports.hoistStatics = _hoistStatics3.default;
	
	// Observable helpers
	
	exports.componentFromStream = _componentFromStream3.default;
	exports.mapPropsStream = _mapPropsStream3.default;
	exports.createEventHandler = _createEventHandler3.default;
	exports.setObservableConfig = _setObservableConfig3.default;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (props) {
	      return factory(propsMapper(props));
	    };
	  };
	};
	
	exports.default = (0, _createHelper2.default)(mapProps, 'mapProps');

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _mapProps = __webpack_require__(1075);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withProps = function withProps(input) {
	  return (0, _mapProps2.default)(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	};
	
	exports.default = (0, _createHelper2.default)(withProps, 'withProps');

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _pick = __webpack_require__(1078);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _shallowEqual = __webpack_require__(922);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !(0, _shallowEqual2.default)((0, _pick2.default)(props, shouldMapOrKeys), (0, _pick2.default)(nextProps, shouldMapOrKeys));
	    };
	
	    return function (_Component) {
	      _inherits(_class2, _Component);
	
	      function _class2() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _class2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (shouldMap(this.props, nextProps)) {
	          this.computedProps = propsMapper(nextProps);
	        }
	      };
	
	      _class2.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.computedProps));
	      };
	
	      return _class2;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withPropsOnChange, 'withPropsOnChange');

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var pick = function pick(obj, keys) {
	  var result = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	  return result;
	};
	
	exports.default = pick;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	  return result;
	};
	
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var _class, _temp2, _initialiseProps;
	
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return _temp2 = _class = function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _class.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	        this.cachedHandlers = {};
	      };
	
	      _class.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return _class;
	    }(_react.Component), _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.cachedHandlers = {};
	      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
	        return function () {
	          var cachedHandler = _this2.cachedHandlers[handlerName];
	          if (cachedHandler) {
	            return cachedHandler.apply(undefined, arguments);
	          }
	
	          var handler = createHandler(_this2.props);
	          _this2.cachedHandlers[handlerName] = handler;
	
	          if (false) {
	            console.error( // eslint-disable-line no-console
	            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	          }
	
	          return handler.apply(undefined, arguments);
	        };
	      });
	    }, _temp2;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withHandlers, 'withHandlers');

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	    DefaultProps.defaultProps = props;
	    return DefaultProps;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(defaultProps, 'defaultProps');

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _omit = __webpack_require__(1082);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _mapProps = __webpack_require__(1075);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renameProp = function renameProp(oldName, newName) {
	  return (0, _mapProps2.default)(function (props) {
	    var _extends2;
	
	    return _extends({}, (0, _omit2.default)(props, [oldName]), (_extends2 = {}, _extends2[newName] = props[oldName], _extends2));
	  });
	};
	
	exports.default = (0, _createHelper2.default)(renameProp, 'renameProp');

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var omit = function omit(obj, keys) {
	  var rest = _objectWithoutProperties(obj, []);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	  return rest;
	};
	
	exports.default = omit;

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _omit = __webpack_require__(1082);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _pick = __webpack_require__(1078);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _mapProps = __webpack_require__(1075);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var keys = Object.keys;
	
	
	var mapKeys = function mapKeys(obj, func) {
	  return keys(obj).reduce(function (result, key) {
	    var val = obj[key];
	    /* eslint-disable no-param-reassign */
	    result[func(val, key)] = val;
	    /* eslint-enable no-param-reassign */
	    return result;
	  }, {});
	};
	
	var renameProps = function renameProps(nameMap) {
	  return (0, _mapProps2.default)(function (props) {
	    return _extends({}, (0, _omit2.default)(props, keys(nameMap)), mapKeys((0, _pick2.default)(props, keys(nameMap)), function (_, oldName) {
	      return nameMap[oldName];
	    }));
	  });
	};
	
	exports.default = (0, _createHelper2.default)(renameProps, 'renameProps');

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flattenProp = function flattenProp(propName) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (props) {
	      return factory(_extends({}, props, props[propName]));
	    };
	  };
	};
	
	exports.default = (0, _createHelper2.default)(flattenProp, 'flattenProp');

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class2, _Component);
	
	      function _class2() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _class2.prototype.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return _class2;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withState, 'withState');

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class2, _Component);
	
	      function _class2() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class2);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: _this.initializeStateValue()
	        }, _this.dispatch = function (action) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: reducer(stateValue, action)
	            };
	          });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _class2.prototype.initializeStateValue = function initializeStateValue() {
	        if (initialState !== undefined) {
	          return typeof initialState === 'function' ? initialState(this.props) : initialState;
	        }
	        return reducer(undefined, { type: '@@recompose/INIT' });
	      };
	
	      _class2.prototype.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[dispatchName] = this.dispatch, _extends2)));
	      };
	
	      return _class2;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withReducer, 'withReducer');

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var identity = function identity(Component) {
	  return Component;
	};
	
	var branch = function branch(test, left) {
	  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
	  return function (BaseComponent) {
	    var leftFactory = void 0;
	    var rightFactory = void 0;
	    return function (props) {
	      if (test(props)) {
	        leftFactory = leftFactory || (0, _createEagerFactory2.default)(left(BaseComponent));
	        return leftFactory(props);
	      }
	      rightFactory = rightFactory || (0, _createEagerFactory2.default)(right(BaseComponent));
	      return rightFactory(props);
	    };
	  };
	};
	
	exports.default = (0, _createHelper2.default)(branch, 'branch');

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _wrapDisplayName = __webpack_require__(916);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderComponent = function renderComponent(Component) {
	  return function (_) {
	    var factory = (0, _createEagerFactory2.default)(Component);
	    var RenderComponent = function RenderComponent(props) {
	      return factory(props);
	    };
	    if (false) {
	      RenderComponent.displayName = (0, _wrapDisplayName2.default)(Component, 'renderComponent');
	    }
	    return RenderComponent;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(renderComponent, 'renderComponent', false);

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nothing = function (_Component) {
	  _inherits(Nothing, _Component);
	
	  function Nothing() {
	    _classCallCheck(this, Nothing);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Nothing.prototype.render = function render() {
	    return null;
	  };
	
	  return Nothing;
	}(_react.Component);
	
	Nothing.displayName = 'Nothing';
	
	var renderNothing = function renderNothing(_) {
	  return Nothing;
	};
	
	exports.default = (0, _createHelper2.default)(renderNothing, 'renderNothing', false, true);

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(914);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(922);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _pick = __webpack_require__(1078);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
	  return (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)((0, _pick2.default)(nextProps, propKeys), (0, _pick2.default)(props, propKeys));
	  });
	};
	
	exports.default = (0, _createHelper2.default)(onlyUpdateForKeys, 'onlyUpdateForKeys');

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _onlyUpdateForKeys = __webpack_require__(1090);
	
	var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _getDisplayName = __webpack_require__(917);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
	  var propTypes = BaseComponent.propTypes;
	
	  if (false) {
	    if (!propTypes) {
	      /* eslint-disable */
	      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + (0, _getDisplayName2.default)(BaseComponent) + '".'));
	      /* eslint-enable */
	    }
	  }
	
	  var propKeys = Object.keys(propTypes || {});
	  var OnlyUpdateForPropTypes = (0, _onlyUpdateForKeys2.default)(propKeys)(BaseComponent);
	
	  return OnlyUpdateForPropTypes;
	};
	
	exports.default = (0, _createHelper2.default)(onlyUpdateForPropTypes, 'onlyUpdateForPropTypes', true, true);

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withContext = function withContext(childContextTypes, getChildContext) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var WithContext = function (_Component) {
	      _inherits(WithContext, _Component);
	
	      function WithContext() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithContext);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
	          return getChildContext(_this.props);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithContext.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return WithContext;
	    }(_react.Component);
	
	    WithContext.childContextTypes = childContextTypes;
	
	    return WithContext;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(withContext, 'withContext');

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getContext = function getContext(contextTypes) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    var GetContext = function GetContext(ownerProps, context) {
	      return factory(_extends({}, ownerProps, context));
	    };
	
	    GetContext.contextTypes = contextTypes;
	
	    return GetContext;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(getContext, 'getContext');

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    return function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args)));
	
	        Object.assign(_this, spec);
	        return _this;
	      }
	
	      _class.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state));
	      };
	
	      return _class;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(lifecycle, 'lifecycle');

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getDisplayName = __webpack_require__(917);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _isClassComponent = __webpack_require__(921);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var toClass = function toClass(baseComponent) {
	  if ((0, _isClassComponent2.default)(baseComponent)) {
	    return baseComponent;
	  }
	
	  var ToClass = function (_Component) {
	    _inherits(ToClass, _Component);
	
	    function ToClass() {
	      _classCallCheck(this, ToClass);
	
	      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ToClass.prototype.render = function render() {
	      if (typeof baseComponent === 'string') {
	        return _react2.default.createElement(baseComponent, this.props);
	      }
	      return baseComponent(this.props, this.context);
	    };
	
	    return ToClass;
	  }(_react.Component);
	
	  ToClass.displayName = (0, _getDisplayName2.default)(baseComponent);
	  ToClass.propTypes = baseComponent.propTypes;
	  ToClass.contextTypes = baseComponent.contextTypes;
	  ToClass.defaultProps = baseComponent.defaultProps;
	
	  return ToClass;
	};
	
	exports.default = toClass;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = (0, _createHelper2.default)(setStatic, 'setStatic', false);

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(1096);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setPropTypes = function setPropTypes(propTypes) {
	  return (0, _setStatic2.default)('propTypes', propTypes);
	};
	
	exports.default = (0, _createHelper2.default)(setPropTypes, 'setPropTypes', false);

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(1096);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = (0, _createHelper2.default)(setDisplayName, 'setDisplayName', false);

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(919);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(920);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElement = function createEagerElement(type, props, children) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  /* eslint-disable */
	  var hasKey = props && props.hasOwnProperty('key');
	  /* eslint-enable */
	  return (0, _createEagerElementUtil2.default)(hasKey, isReferentiallyTransparent, type, props, children);
	};
	
	exports.default = createEagerElement;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(300);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createSink = function createSink(callback) {
	  return function (_Component) {
	    _inherits(Sink, _Component);
	
	    function Sink() {
	      _classCallCheck(this, Sink);
	
	      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Sink.prototype.componentWillMount = function componentWillMount() {
	      callback(this.props);
	    };
	
	    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      callback(nextProps);
	    };
	
	    Sink.prototype.render = function render() {
	      return null;
	    };
	
	    return Sink;
	  }(_react.Component);
	};
	
	exports.default = createSink;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _omit = __webpack_require__(1082);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _createEagerElement = __webpack_require__(1100);
	
	var _createEagerElement2 = _interopRequireDefault(_createEagerElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentFromProp = function componentFromProp(propName) {
	  var Component = function Component(props) {
	    return (0, _createEagerElement2.default)(props[propName], (0, _omit2.default)(props, [propName]));
	  };
	  Component.displayName = 'componentFromProp(' + propName + ')';
	  return Component;
	};
	
	exports.default = componentFromProp;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _getDisplayName = __webpack_require__(917);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var nest = function nest() {
	  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
	    Components[_key] = arguments[_key];
	  }
	
	  var factories = Components.map(_createEagerFactory2.default);
	  var Nest = function Nest(_ref) {
	    var props = _objectWithoutProperties(_ref, []),
	        children = _ref.children;
	
	    return factories.reduceRight(function (child, factory) {
	      return factory(props, child);
	    }, children);
	  };
	
	  if (false) {
	    var displayNames = Components.map(_getDisplayName2.default);
	    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
	  }
	
	  return Nest;
	};
	
	exports.default = nest;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _hoistNonReactStatics = __webpack_require__(474);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hoistStatics = function hoistStatics(higherOrderComponent) {
	  return function (BaseComponent) {
	    var NewComponent = higherOrderComponent(BaseComponent);
	    (0, _hoistNonReactStatics2.default)(NewComponent, BaseComponent);
	    return NewComponent;
	  };
	};
	
	exports.default = hoistStatics;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.componentFromStreamWithConfig = undefined;
	
	var _react = __webpack_require__(300);
	
	var _changeEmitter = __webpack_require__(1106);
	
	var _symbolObservable = __webpack_require__(492);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	var _setObservableConfig = __webpack_require__(1107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var componentFromStreamWithConfig = exports.componentFromStreamWithConfig = function componentFromStreamWithConfig(config) {
	  return function (propsToVdom) {
	    return function (_Component) {
	      _inherits(ComponentFromStream, _Component);
	
	      function ComponentFromStream() {
	        var _config$fromESObserva;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ComponentFromStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = (0, _changeEmitter.createChangeEmitter)(), _this.props$ = config.fromESObservable((_config$fromESObserva = {
	          subscribe: function subscribe(observer) {
	            var unsubscribe = _this.propsEmitter.listen(function (props) {
	              if (props) {
	                observer.next(props);
	              } else {
	                observer.complete();
	              }
	            });
	            return { unsubscribe: unsubscribe };
	          }
	        }, _config$fromESObserva[_symbolObservable2.default] = function () {
	          return this;
	        }, _config$fromESObserva)), _this.vdom$ = config.toESObservable(propsToVdom(_this.props$)), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      // Stream of props
	
	
	      // Stream of vdom
	
	
	      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        // Subscribe to child prop changes so we know when to re-render
	        this.subscription = this.vdom$.subscribe({
	          next: function next(vdom) {
	            _this2.setState({ vdom: vdom });
	          }
	        });
	        this.propsEmitter.emit(this.props);
	      };
	
	      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        // Receive new props from the owner
	        this.propsEmitter.emit(nextProps);
	      };
	
	      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        return nextState.vdom !== this.state.vdom;
	      };
	
	      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
	        // Call without arguments to complete stream
	        this.propsEmitter.emit();
	
	        // Clean-up subscription before un-mounting
	        this.subscription.unsubscribe();
	      };
	
	      ComponentFromStream.prototype.render = function render() {
	        return this.state.vdom;
	      };
	
	      return ComponentFromStream;
	    }(_react.Component);
	  };
	};
	
	var componentFromStream = componentFromStreamWithConfig(_setObservableConfig.config);
	
	exports.default = componentFromStream;

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  function listen(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function () {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  function emit() {
	    currentListeners = nextListeners;
	    var listeners = currentListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i].apply(listeners, arguments);
	    }
	  }
	
	  return {
	    listen: listen,
	    emit: emit
	  };
	};

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var _config = {
	  fromESObservable: null,
	  toESObservable: null
	};
	
	var configureObservable = function configureObservable(c) {
	  _config = c;
	};
	
	var config = exports.config = {
	  fromESObservable: function fromESObservable(observable) {
	    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
	  },
	  toESObservable: function toESObservable(stream) {
	    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
	  }
	};
	
	exports.default = configureObservable;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.mapPropsStreamWithConfig = undefined;
	
	var _symbolObservable = __webpack_require__(492);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	var _createEagerFactory = __webpack_require__(918);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _createHelper = __webpack_require__(915);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _componentFromStream = __webpack_require__(1105);
	
	var _setObservableConfig = __webpack_require__(1107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var identity = function identity(t) {
	  return t;
	};
	var componentFromStream = (0, _componentFromStream.componentFromStreamWithConfig)({
	  fromESObservable: identity,
	  toESObservable: identity
	});
	
	var mapPropsStreamWithConfig = exports.mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config) {
	  return function (transform) {
	    return function (BaseComponent) {
	      var factory = (0, _createEagerFactory2.default)(BaseComponent);
	      var fromESObservable = config.fromESObservable,
	          toESObservable = config.toESObservable;
	
	      return componentFromStream(function (props$) {
	        var _ref;
	
	        return _ref = {
	          subscribe: function subscribe(observer) {
	            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
	              next: function next(childProps) {
	                return observer.next(factory(childProps));
	              }
	            });
	            return {
	              unsubscribe: function unsubscribe() {
	                return subscription.unsubscribe();
	              }
	            };
	          }
	        }, _ref[_symbolObservable2.default] = function () {
	          return this;
	        }, _ref;
	      });
	    };
	  };
	};
	
	var mapPropsStream = mapPropsStreamWithConfig(_setObservableConfig.config);
	
	exports.default = (0, _createHelper2.default)(mapPropsStream, 'mapPropsStream');

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createEventHandlerWithConfig = undefined;
	
	var _symbolObservable = __webpack_require__(492);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	var _changeEmitter = __webpack_require__(1106);
	
	var _setObservableConfig = __webpack_require__(1107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEventHandlerWithConfig = exports.createEventHandlerWithConfig = function createEventHandlerWithConfig(config) {
	  return function () {
	    var _config$fromESObserva;
	
	    var emitter = (0, _changeEmitter.createChangeEmitter)();
	    var stream = config.fromESObservable((_config$fromESObserva = {
	      subscribe: function subscribe(observer) {
	        var unsubscribe = emitter.listen(function (value) {
	          return observer.next(value);
	        });
	        return { unsubscribe: unsubscribe };
	      }
	    }, _config$fromESObserva[_symbolObservable2.default] = function () {
	      return this;
	    }, _config$fromESObserva));
	    return {
	      handler: emitter.emit,
	      stream: stream
	    };
	  };
	};
	
	var createEventHandler = createEventHandlerWithConfig(_setObservableConfig.config);
	
	exports.default = createEventHandler;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchDatabasesWithMetadata = exports.fetchSegmentRevisions = exports.FETCH_SEGMENT_REVISIONS = exports.fetchSegmentTable = exports.FETCH_SEGMENT_TABLE = exports.fetchSegmentFields = exports.FETCH_SEGMENT_FIELDS = exports.fetchMetricRevisions = exports.FETCH_METRIC_REVISIONS = exports.fetchMetricTable = exports.FETCH_METRIC_TABLE = exports.fetchRevisions = exports.FETCH_REVISIONS = exports.updateFieldDimension = exports.UPDATE_FIELD_DIMENSION = exports.deleteFieldDimension = exports.DELETE_FIELD_DIMENSION = exports.updateField = exports.UPDATE_FIELD = exports.addParamValues = exports.ADD_PARAM_VALUES = exports.updateFieldValues = exports.UPDATE_FIELD_VALUES = exports.fetchFieldValues = exports.FETCH_FIELD_VALUES = exports.fetchTableMetadata = exports.FETCH_TABLE_METADATA = exports.fetchTables = exports.updateTable = exports.updateDatabase = exports.fetchDatabaseMetadata = exports.FETCH_DATABASE_METADATA = exports.fetchRealDatabases = exports.FETCH_REAL_DATABASES = exports.fetchDatabases = exports.FETCH_DATABASES = exports.updateSegment = exports.fetchSegments = exports.FETCH_SEGMENTS = exports.updateMetricImportantFields = exports.updateMetric = exports.fetchMetrics = exports.FETCH_METRICS = undefined;
	
	var _handleActions2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(657);
	
	var _normalizr = __webpack_require__(1111);
	
	var _schema = __webpack_require__(1119);
	
	var _icepick = __webpack_require__(855);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var FETCH_METRICS = exports.FETCH_METRICS = "metabase/metadata/FETCH_METRICS";
	var fetchMetrics = exports.fetchMetrics = (0, _redux.createThunkAction)(FETCH_METRICS, function () {
	    var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var requestStatePath, existingStatePath, getData;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "metrics"];
	                            existingStatePath = requestStatePath;
	
	                            getData = function () {
	                                var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                                    var metrics;
	                                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                                        while (1) {
	                                            switch (_context.prev = _context.next) {
	                                                case 0:
	                                                    _context.next = 2;
	                                                    return _services.MetricApi.list();
	
	                                                case 2:
	                                                    metrics = _context.sent;
	                                                    return _context.abrupt("return", (0, _normalizr.normalize)(metrics, [_schema.MetricSchema]));
	
	                                                case 4:
	                                                case "end":
	                                                    return _context.stop();
	                                            }
	                                        }
	                                    }, _callee, undefined);
	                                }));
	
	                                return function getData() {
	                                    return _ref2.apply(this, arguments);
	                                };
	                            }();
	
	                            _context2.next = 5;
	                            return (0, _redux.fetchData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                getData: getData,
	                                reload: reload
	                            });
	
	                        case 5:
	                            return _context2.abrupt("return", _context2.sent);
	
	                        case 6:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined);
	        }));
	
	        return function (_x2, _x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var UPDATE_METRIC = "metabase/metadata/UPDATE_METRIC";
	var updateMetric = exports.updateMetric = (0, _redux.createThunkAction)(UPDATE_METRIC, function (metric) {
	    var _this = this;
	
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
	            var requestStatePath, existingStatePath, dependentRequestStatePaths, putData;
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "metrics", metric.id];
	                            existingStatePath = ["metadata", "metrics"];
	                            dependentRequestStatePaths = [['metadata', 'revisions', 'metric', metric.id]];
	
	                            putData = function () {
	                                var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
	                                    var updatedMetric;
	                                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                                        while (1) {
	                                            switch (_context3.prev = _context3.next) {
	                                                case 0:
	                                                    _context3.next = 2;
	                                                    return _services.MetricApi.update(metric);
	
	                                                case 2:
	                                                    updatedMetric = _context3.sent;
	                                                    return _context3.abrupt("return", (0, _normalizr.normalize)(updatedMetric, _schema.MetricSchema));
	
	                                                case 4:
	                                                case "end":
	                                                    return _context3.stop();
	                                            }
	                                        }
	                                    }, _callee3, _this);
	                                }));
	
	                                return function putData() {
	                                    return _ref4.apply(this, arguments);
	                                };
	                            }();
	
	                            _context4.next = 6;
	                            return (0, _redux.updateData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                dependentRequestStatePaths: dependentRequestStatePaths,
	                                putData: putData
	                            });
	
	                        case 6:
	                            return _context4.abrupt("return", _context4.sent);
	
	                        case 7:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, _this);
	        }));
	
	        return function (_x4, _x5) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	});
	
	var UPDATE_METRIC_IMPORTANT_FIELDS = "metabase/guide/UPDATE_METRIC_IMPORTANT_FIELDS";
	var updateMetricImportantFields = exports.updateMetricImportantFields = (0, _redux.createThunkAction)(UPDATE_METRIC_IMPORTANT_FIELDS, function (metricId, importantFieldIds) {
	    var _this2 = this;
	
	    return function () {
	        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
	            var requestStatePath, existingStatePath, dependentRequestStatePaths, putData;
	            return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            requestStatePath = ["reference", "guide", "metric_important_fields", metricId];
	                            existingStatePath = requestStatePath;
	                            dependentRequestStatePaths = [['reference', 'guide']];
	
	                            putData = function () {
	                                var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5() {
	                                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                                        while (1) {
	                                            switch (_context5.prev = _context5.next) {
	                                                case 0:
	                                                    _context5.next = 2;
	                                                    return _services.MetricApi.update_important_fields({ metricId: metricId, important_field_ids: importantFieldIds });
	
	                                                case 2:
	                                                case "end":
	                                                    return _context5.stop();
	                                            }
	                                        }
	                                    }, _callee5, _this2);
	                                }));
	
	                                return function putData() {
	                                    return _ref6.apply(this, arguments);
	                                };
	                            }();
	
	                            _context6.next = 6;
	                            return (0, _redux.updateData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                dependentRequestStatePaths: dependentRequestStatePaths,
	                                putData: putData
	                            });
	
	                        case 6:
	                            return _context6.abrupt("return", _context6.sent);
	
	                        case 7:
	                        case "end":
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, _this2);
	        }));
	
	        return function (_x6, _x7) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_SEGMENTS = exports.FETCH_SEGMENTS = "metabase/metadata/FETCH_SEGMENTS";
	var fetchSegments = exports.fetchSegments = (0, _redux.createThunkAction)(FETCH_SEGMENTS, function () {
	    var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return function () {
	        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(dispatch, getState) {
	            var requestStatePath, existingStatePath, getData;
	            return regeneratorRuntime.wrap(function _callee8$(_context8) {
	                while (1) {
	                    switch (_context8.prev = _context8.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "segments"];
	                            existingStatePath = requestStatePath;
	
	                            getData = function () {
	                                var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7() {
	                                    var segments;
	                                    return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                                        while (1) {
	                                            switch (_context7.prev = _context7.next) {
	                                                case 0:
	                                                    _context7.next = 2;
	                                                    return _services.SegmentApi.list();
	
	                                                case 2:
	                                                    segments = _context7.sent;
	                                                    return _context7.abrupt("return", (0, _normalizr.normalize)(segments, [_schema.SegmentSchema]));
	
	                                                case 4:
	                                                case "end":
	                                                    return _context7.stop();
	                                            }
	                                        }
	                                    }, _callee7, undefined);
	                                }));
	
	                                return function getData() {
	                                    return _ref8.apply(this, arguments);
	                                };
	                            }();
	
	                            _context8.next = 5;
	                            return (0, _redux.fetchData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                getData: getData,
	                                reload: reload
	                            });
	
	                        case 5:
	                            return _context8.abrupt("return", _context8.sent);
	
	                        case 6:
	                        case "end":
	                            return _context8.stop();
	                    }
	                }
	            }, _callee8, undefined);
	        }));
	
	        return function (_x9, _x10) {
	            return _ref7.apply(this, arguments);
	        };
	    }();
	});
	
	var UPDATE_SEGMENT = "metabase/metadata/UPDATE_SEGMENT";
	var updateSegment = exports.updateSegment = (0, _redux.createThunkAction)(UPDATE_SEGMENT, function (segment) {
	    var _this3 = this;
	
	    return function () {
	        var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(dispatch, getState) {
	            var requestStatePath, existingStatePath, dependentRequestStatePaths, putData;
	            return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                while (1) {
	                    switch (_context10.prev = _context10.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "segments", segment.id];
	                            existingStatePath = ["metadata", "segments"];
	                            dependentRequestStatePaths = [['metadata', 'revisions', 'segment', segment.id]];
	
	                            putData = function () {
	                                var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9() {
	                                    var updatedSegment;
	                                    return regeneratorRuntime.wrap(function _callee9$(_context9) {
	                                        while (1) {
	                                            switch (_context9.prev = _context9.next) {
	                                                case 0:
	                                                    _context9.next = 2;
	                                                    return _services.SegmentApi.update(segment);
	
	                                                case 2:
	                                                    updatedSegment = _context9.sent;
	                                                    return _context9.abrupt("return", (0, _normalizr.normalize)(updatedSegment, _schema.SegmentSchema));
	
	                                                case 4:
	                                                case "end":
	                                                    return _context9.stop();
	                                            }
	                                        }
	                                    }, _callee9, _this3);
	                                }));
	
	                                return function putData() {
	                                    return _ref10.apply(this, arguments);
	                                };
	                            }();
	
	                            _context10.next = 6;
	                            return (0, _redux.updateData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                dependentRequestStatePaths: dependentRequestStatePaths,
	                                putData: putData
	                            });
	
	                        case 6:
	                            return _context10.abrupt("return", _context10.sent);
	
	                        case 7:
	                        case "end":
	                            return _context10.stop();
	                    }
	                }
	            }, _callee10, _this3);
	        }));
	
	        return function (_x11, _x12) {
	            return _ref9.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_DATABASES = exports.FETCH_DATABASES = "metabase/metadata/FETCH_DATABASES";
	var fetchDatabases = exports.fetchDatabases = (0, _redux.createThunkAction)(FETCH_DATABASES, function () {
	    var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return function () {
	        var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee12(dispatch, getState) {
	            var requestStatePath, existingStatePath, getData;
	            return regeneratorRuntime.wrap(function _callee12$(_context12) {
	                while (1) {
	                    switch (_context12.prev = _context12.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "databases"];
	                            existingStatePath = requestStatePath;
	
	                            getData = function () {
	                                var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11() {
	                                    var databases;
	                                    return regeneratorRuntime.wrap(function _callee11$(_context11) {
	                                        while (1) {
	                                            switch (_context11.prev = _context11.next) {
	                                                case 0:
	                                                    _context11.next = 2;
	                                                    return _services.MetabaseApi.db_list_with_tables();
	
	                                                case 2:
	                                                    databases = _context11.sent;
	                                                    return _context11.abrupt("return", (0, _normalizr.normalize)(databases, [_schema.DatabaseSchema]));
	
	                                                case 4:
	                                                case "end":
	                                                    return _context11.stop();
	                                            }
	                                        }
	                                    }, _callee11, undefined);
	                                }));
	
	                                return function getData() {
	                                    return _ref12.apply(this, arguments);
	                                };
	                            }();
	
	                            _context12.next = 5;
	                            return (0, _redux.fetchData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                getData: getData,
	                                reload: reload
	                            });
	
	                        case 5:
	                            return _context12.abrupt("return", _context12.sent);
	
	                        case 6:
	                        case "end":
	                            return _context12.stop();
	                    }
	                }
	            }, _callee12, undefined);
	        }));
	
	        return function (_x14, _x15) {
	            return _ref11.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_REAL_DATABASES = exports.FETCH_REAL_DATABASES = "metabase/metadata/FETCH_REAL_DATABASES";
	var fetchRealDatabases = exports.fetchRealDatabases = (0, _redux.createThunkAction)(FETCH_REAL_DATABASES, function () {
	    var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return function () {
	        var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee14(dispatch, getState) {
	            var requestStatePath, existingStatePath, getData;
	            return regeneratorRuntime.wrap(function _callee14$(_context14) {
	                while (1) {
	                    switch (_context14.prev = _context14.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "databases"];
	                            existingStatePath = requestStatePath;
	
	                            getData = function () {
	                                var _ref14 = _asyncToGenerator(regeneratorRuntime.mark(function _callee13() {
	                                    var databases;
	                                    return regeneratorRuntime.wrap(function _callee13$(_context13) {
	                                        while (1) {
	                                            switch (_context13.prev = _context13.next) {
	                                                case 0:
	                                                    _context13.next = 2;
	                                                    return _services.MetabaseApi.db_real_list_with_tables();
	
	                                                case 2:
	                                                    databases = _context13.sent;
	                                                    return _context13.abrupt("return", (0, _normalizr.normalize)(databases, [_schema.DatabaseSchema]));
	
	                                                case 4:
	                                                case "end":
	                                                    return _context13.stop();
	                                            }
	                                        }
	                                    }, _callee13, undefined);
	                                }));
	
	                                return function getData() {
	                                    return _ref14.apply(this, arguments);
	                                };
	                            }();
	
	                            _context14.next = 5;
	                            return (0, _redux.fetchData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                getData: getData,
	                                reload: reload
	                            });
	
	                        case 5:
	                            return _context14.abrupt("return", _context14.sent);
	
	                        case 6:
	                        case "end":
	                            return _context14.stop();
	                    }
	                }
	            }, _callee14, undefined);
	        }));
	
	        return function (_x17, _x18) {
	            return _ref13.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_DATABASE_METADATA = exports.FETCH_DATABASE_METADATA = "metabase/metadata/FETCH_DATABASE_METADATA";
	var fetchDatabaseMetadata = exports.fetchDatabaseMetadata = (0, _redux.createThunkAction)(FETCH_DATABASE_METADATA, function (dbId) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return function () {
	        var _ref15 = _asyncToGenerator(regeneratorRuntime.mark(function _callee16(dispatch, getState) {
	            var _this4 = this;
	
	            var requestStatePath, existingStatePath, getData;
	            return regeneratorRuntime.wrap(function _callee16$(_context16) {
	                while (1) {
	                    switch (_context16.prev = _context16.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "databases", dbId];
	                            existingStatePath = ["metadata"];
	
	                            getData = function () {
	                                var _ref16 = _asyncToGenerator(regeneratorRuntime.mark(function _callee15() {
	                                    var databaseMetadata;
	                                    return regeneratorRuntime.wrap(function _callee15$(_context15) {
	                                        while (1) {
	                                            switch (_context15.prev = _context15.next) {
	                                                case 0:
	                                                    _context15.next = 2;
	                                                    return _services.MetabaseApi.db_metadata({ dbId: dbId });
	
	                                                case 2:
	                                                    databaseMetadata = _context15.sent;
	                                                    return _context15.abrupt("return", (0, _normalizr.normalize)(databaseMetadata, _schema.DatabaseSchema));
	
	                                                case 4:
	                                                case "end":
	                                                    return _context15.stop();
	                                            }
	                                        }
	                                    }, _callee15, _this4);
	                                }));
	
	                                return function getData() {
	                                    return _ref16.apply(this, arguments);
	                                };
	                            }();
	
	                            _context16.next = 5;
	                            return (0, _redux.fetchData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                getData: getData,
	                                reload: reload
	                            });
	
	                        case 5:
	                            return _context16.abrupt("return", _context16.sent);
	
	                        case 6:
	                        case "end":
	                            return _context16.stop();
	                    }
	                }
	            }, _callee16, this);
	        }));
	
	        return function (_x20, _x21) {
	            return _ref15.apply(this, arguments);
	        };
	    }();
	});
	
	var UPDATE_DATABASE = "metabase/metadata/UPDATE_DATABASE";
	var updateDatabase = exports.updateDatabase = (0, _redux.createThunkAction)(UPDATE_DATABASE, function (database) {
	    var _this5 = this;
	
	    return function () {
	        var _ref17 = _asyncToGenerator(regeneratorRuntime.mark(function _callee18(dispatch, getState) {
	            var requestStatePath, existingStatePath, putData;
	            return regeneratorRuntime.wrap(function _callee18$(_context18) {
	                while (1) {
	                    switch (_context18.prev = _context18.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "databases", database.id];
	                            existingStatePath = ["metadata", "databases"];
	
	                            putData = function () {
	                                var _ref18 = _asyncToGenerator(regeneratorRuntime.mark(function _callee17() {
	                                    var slimDatabase, updatedDatabase;
	                                    return regeneratorRuntime.wrap(function _callee17$(_context17) {
	                                        while (1) {
	                                            switch (_context17.prev = _context17.next) {
	                                                case 0:
	                                                    // make sure we don't send all the computed metadata
	                                                    // there may be more that I'm missing?
	                                                    slimDatabase = _underscore2.default.omit(database, "tables", "tables_lookup");
	                                                    _context17.next = 3;
	                                                    return _services.MetabaseApi.db_update(slimDatabase);
	
	                                                case 3:
	                                                    updatedDatabase = _context17.sent;
	                                                    return _context17.abrupt("return", (0, _normalizr.normalize)(updatedDatabase, _schema.DatabaseSchema));
	
	                                                case 5:
	                                                case "end":
	                                                    return _context17.stop();
	                                            }
	                                        }
	                                    }, _callee17, _this5);
	                                }));
	
	                                return function putData() {
	                                    return _ref18.apply(this, arguments);
	                                };
	                            }();
	
	                            _context18.next = 5;
	                            return (0, _redux.updateData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                putData: putData
	                            });
	
	                        case 5:
	                            return _context18.abrupt("return", _context18.sent);
	
	                        case 6:
	                        case "end":
	                            return _context18.stop();
	                    }
	                }
	            }, _callee18, _this5);
	        }));
	
	        return function (_x22, _x23) {
	            return _ref17.apply(this, arguments);
	        };
	    }();
	});
	
	var UPDATE_TABLE = "metabase/metadata/UPDATE_TABLE";
	var updateTable = exports.updateTable = (0, _redux.createThunkAction)(UPDATE_TABLE, function (table) {
	    var _this6 = this;
	
	    return function () {
	        var _ref19 = _asyncToGenerator(regeneratorRuntime.mark(function _callee20(dispatch, getState) {
	            var requestStatePath, existingStatePath, putData;
	            return regeneratorRuntime.wrap(function _callee20$(_context20) {
	                while (1) {
	                    switch (_context20.prev = _context20.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "tables", table.id];
	                            existingStatePath = ["metadata", "tables"];
	
	                            putData = function () {
	                                var _ref20 = _asyncToGenerator(regeneratorRuntime.mark(function _callee19() {
	                                    var slimTable, updatedTable;
	                                    return regeneratorRuntime.wrap(function _callee19$(_context19) {
	                                        while (1) {
	                                            switch (_context19.prev = _context19.next) {
	                                                case 0:
	                                                    // make sure we don't send all the computed metadata
	                                                    slimTable = _underscore2.default.omit(table, "fields", "fields_lookup", "aggregation_options", "breakout_options", "metrics", "segments");
	                                                    _context19.next = 3;
	                                                    return _services.MetabaseApi.table_update(slimTable);
	
	                                                case 3:
	                                                    updatedTable = _context19.sent;
	                                                    return _context19.abrupt("return", (0, _normalizr.normalize)(updatedTable, _schema.TableSchema));
	
	                                                case 5:
	                                                case "end":
	                                                    return _context19.stop();
	                                            }
	                                        }
	                                    }, _callee19, _this6);
	                                }));
	
	                                return function putData() {
	                                    return _ref20.apply(this, arguments);
	                                };
	                            }();
	
	                            _context20.next = 5;
	                            return (0, _redux.updateData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                putData: putData
	                            });
	
	                        case 5:
	                            return _context20.abrupt("return", _context20.sent);
	
	                        case 6:
	                        case "end":
	                            return _context20.stop();
	                    }
	                }
	            }, _callee20, _this6);
	        }));
	
	        return function (_x24, _x25) {
	            return _ref19.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_TABLES = "metabase/metadata/FETCH_TABLES";
	var fetchTables = exports.fetchTables = (0, _redux.createThunkAction)(FETCH_TABLES, function () {
	    var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return function () {
	        var _ref21 = _asyncToGenerator(regeneratorRuntime.mark(function _callee22(dispatch, getState) {
	            var requestStatePath, existingStatePath, getData;
	            return regeneratorRuntime.wrap(function _callee22$(_context22) {
	                while (1) {
	                    switch (_context22.prev = _context22.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "tables"];
	                            existingStatePath = requestStatePath;
	
	                            getData = function () {
	                                var _ref22 = _asyncToGenerator(regeneratorRuntime.mark(function _callee21() {
	                                    var tables;
	                                    return regeneratorRuntime.wrap(function _callee21$(_context21) {
	                                        while (1) {
	                                            switch (_context21.prev = _context21.next) {
	                                                case 0:
	                                                    _context21.next = 2;
	                                                    return _services.MetabaseApi.table_list();
	
	                                                case 2:
	                                                    tables = _context21.sent;
	                                                    return _context21.abrupt("return", (0, _normalizr.normalize)(tables, [_schema.TableSchema]));
	
	                                                case 4:
	                                                case "end":
	                                                    return _context21.stop();
	                                            }
	                                        }
	                                    }, _callee21, undefined);
	                                }));
	
	                                return function getData() {
	                                    return _ref22.apply(this, arguments);
	                                };
	                            }();
	
	                            _context22.next = 5;
	                            return (0, _redux.fetchData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                getData: getData,
	                                reload: reload
	                            });
	
	                        case 5:
	                            return _context22.abrupt("return", _context22.sent);
	
	                        case 6:
	                        case "end":
	                            return _context22.stop();
	                    }
	                }
	            }, _callee22, undefined);
	        }));
	
	        return function (_x27, _x28) {
	            return _ref21.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_TABLE_METADATA = exports.FETCH_TABLE_METADATA = "metabase/metadata/FETCH_TABLE_METADATA";
	var fetchTableMetadata = exports.fetchTableMetadata = (0, _redux.createThunkAction)(FETCH_TABLE_METADATA, function (tableId) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return function () {
	        var _ref23 = _asyncToGenerator(regeneratorRuntime.mark(function _callee24(dispatch, getState) {
	            var _this7 = this;
	
	            var requestStatePath, existingStatePath, getData;
	            return regeneratorRuntime.wrap(function _callee24$(_context24) {
	                while (1) {
	                    switch (_context24.prev = _context24.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "tables", tableId];
	                            existingStatePath = ["metadata"];
	
	                            getData = function () {
	                                var _ref24 = _asyncToGenerator(regeneratorRuntime.mark(function _callee23() {
	                                    var tableMetadata, fkTableIds, fkTables;
	                                    return regeneratorRuntime.wrap(function _callee23$(_context23) {
	                                        while (1) {
	                                            switch (_context23.prev = _context23.next) {
	                                                case 0:
	                                                    _context23.next = 2;
	                                                    return _services.MetabaseApi.table_query_metadata({ tableId: tableId });
	
	                                                case 2:
	                                                    tableMetadata = _context23.sent;
	                                                    fkTableIds = _underscore2.default.chain(tableMetadata.fields).filter(function (field) {
	                                                        return field.target;
	                                                    }).map(function (field) {
	                                                        return field.target.table_id;
	                                                    }).uniq().value();
	                                                    _context23.next = 6;
	                                                    return Promise.all(fkTableIds.map(function (tableId) {
	                                                        return _services.MetabaseApi.table_query_metadata({ tableId: tableId });
	                                                    }));
	
	                                                case 6:
	                                                    fkTables = _context23.sent;
	                                                    return _context23.abrupt("return", (0, _normalizr.normalize)([tableMetadata].concat(fkTables), [_schema.TableSchema]));
	
	                                                case 8:
	                                                case "end":
	                                                    return _context23.stop();
	                                            }
	                                        }
	                                    }, _callee23, _this7);
	                                }));
	
	                                return function getData() {
	                                    return _ref24.apply(this, arguments);
	                                };
	                            }();
	
	                            _context24.next = 5;
	                            return (0, _redux.fetchData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                getData: getData,
	                                reload: reload
	                            });
	
	                        case 5:
	                            return _context24.abrupt("return", _context24.sent);
	
	                        case 6:
	                        case "end":
	                            return _context24.stop();
	                    }
	                }
	            }, _callee24, this);
	        }));
	
	        return function (_x30, _x31) {
	            return _ref23.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_FIELD_VALUES = exports.FETCH_FIELD_VALUES = "metabase/metadata/FETCH_FIELD_VALUES";
	var fetchFieldValues = exports.fetchFieldValues = (0, _redux.createThunkAction)(FETCH_FIELD_VALUES, function (fieldId, reload) {
	    return function () {
	        var _ref25 = _asyncToGenerator(regeneratorRuntime.mark(function _callee25(dispatch, getState) {
	            var requestStatePath, existingStatePath, getData;
	            return regeneratorRuntime.wrap(function _callee25$(_context25) {
	                while (1) {
	                    switch (_context25.prev = _context25.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "fields", fieldId];
	                            existingStatePath = requestStatePath;
	
	                            getData = function getData() {
	                                return _services.MetabaseApi.field_values({ fieldId: fieldId });
	                            };
	
	                            _context25.next = 5;
	                            return (0, _redux.fetchData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                getData: getData,
	                                reload: reload
	                            });
	
	                        case 5:
	                            return _context25.abrupt("return", _context25.sent);
	
	                        case 6:
	                        case "end":
	                            return _context25.stop();
	                    }
	                }
	            }, _callee25, this);
	        }));
	
	        return function (_x32, _x33) {
	            return _ref25.apply(this, arguments);
	        };
	    }();
	});
	
	// Docstring from m.api.field:
	// Update the human-readable values for a `Field` whose special type is
	// `category`/`city`/`state`/`country` or whose base type is `type/Boolean`."
	var UPDATE_FIELD_VALUES = exports.UPDATE_FIELD_VALUES = "metabase/metadata/UPDATE_FIELD_VALUES";
	var updateFieldValues = exports.updateFieldValues = (0, _redux.createThunkAction)(UPDATE_FIELD_VALUES, function (fieldId, fieldValuePairs) {
	    return function () {
	        var _ref26 = _asyncToGenerator(regeneratorRuntime.mark(function _callee27(dispatch, getState) {
	            var _this8 = this;
	
	            var requestStatePath, existingStatePath, putData;
	            return regeneratorRuntime.wrap(function _callee27$(_context27) {
	                while (1) {
	                    switch (_context27.prev = _context27.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "fields", fieldId, "dimension"];
	                            existingStatePath = ["metadata", "fields", fieldId];
	
	                            putData = function () {
	                                var _ref27 = _asyncToGenerator(regeneratorRuntime.mark(function _callee26() {
	                                    return regeneratorRuntime.wrap(function _callee26$(_context26) {
	                                        while (1) {
	                                            switch (_context26.prev = _context26.next) {
	                                                case 0:
	                                                    _context26.next = 2;
	                                                    return _services.MetabaseApi.field_values_update({ fieldId: fieldId, values: fieldValuePairs });
	
	                                                case 2:
	                                                    return _context26.abrupt("return", _context26.sent);
	
	                                                case 3:
	                                                case "end":
	                                                    return _context26.stop();
	                                            }
	                                        }
	                                    }, _callee26, _this8);
	                                }));
	
	                                return function putData() {
	                                    return _ref27.apply(this, arguments);
	                                };
	                            }();
	
	                            _context27.next = 5;
	                            return (0, _redux.updateData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                putData: putData
	                            });
	
	                        case 5:
	                            return _context27.abrupt("return", _context27.sent);
	
	                        case 6:
	                        case "end":
	                            return _context27.stop();
	                    }
	                }
	            }, _callee27, this);
	        }));
	
	        return function (_x34, _x35) {
	            return _ref26.apply(this, arguments);
	        };
	    }();
	});
	
	var ADD_PARAM_VALUES = exports.ADD_PARAM_VALUES = "metabase/metadata/ADD_PARAM_VALUES";
	var addParamValues = exports.addParamValues = (0, _redux.createAction)(ADD_PARAM_VALUES);
	
	var UPDATE_FIELD = exports.UPDATE_FIELD = "metabase/metadata/UPDATE_FIELD";
	var updateField = exports.updateField = (0, _redux.createThunkAction)(UPDATE_FIELD, function (field) {
	    return function () {
	        var _ref28 = _asyncToGenerator(regeneratorRuntime.mark(function _callee29(dispatch, getState) {
	            var _this9 = this;
	
	            var requestStatePath, existingStatePath, putData;
	            return regeneratorRuntime.wrap(function _callee29$(_context29) {
	                while (1) {
	                    switch (_context29.prev = _context29.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "fields", field.id];
	                            existingStatePath = ["metadata", "fields"];
	
	                            putData = function () {
	                                var _ref29 = _asyncToGenerator(regeneratorRuntime.mark(function _callee28() {
	                                    var slimField, updatedField;
	                                    return regeneratorRuntime.wrap(function _callee28$(_context28) {
	                                        while (1) {
	                                            switch (_context28.prev = _context28.next) {
	                                                case 0:
	                                                    // make sure we don't send all the computed metadata
	                                                    // there may be more that I'm missing?
	                                                    slimField = _underscore2.default.omit(field, "operators_lookup");
	                                                    _context28.next = 3;
	                                                    return _services.MetabaseApi.field_update(slimField);
	
	                                                case 3:
	                                                    updatedField = _context28.sent;
	                                                    return _context28.abrupt("return", (0, _normalizr.normalize)(updatedField, _schema.FieldSchema));
	
	                                                case 5:
	                                                case "end":
	                                                    return _context28.stop();
	                                            }
	                                        }
	                                    }, _callee28, _this9);
	                                }));
	
	                                return function putData() {
	                                    return _ref29.apply(this, arguments);
	                                };
	                            }();
	
	                            _context29.next = 5;
	                            return (0, _redux.updateData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                putData: putData
	                            });
	
	                        case 5:
	                            return _context29.abrupt("return", _context29.sent);
	
	                        case 6:
	                        case "end":
	                            return _context29.stop();
	                    }
	                }
	            }, _callee29, this);
	        }));
	
	        return function (_x36, _x37) {
	            return _ref28.apply(this, arguments);
	        };
	    }();
	});
	
	var DELETE_FIELD_DIMENSION = exports.DELETE_FIELD_DIMENSION = "metabase/metadata/DELETE_FIELD_DIMENSION";
	var deleteFieldDimension = exports.deleteFieldDimension = (0, _redux.createThunkAction)(DELETE_FIELD_DIMENSION, function (fieldId) {
	    return function () {
	        var _ref30 = _asyncToGenerator(regeneratorRuntime.mark(function _callee31(dispatch, getState) {
	            var _this10 = this;
	
	            var requestStatePath, existingStatePath, putData;
	            return regeneratorRuntime.wrap(function _callee31$(_context31) {
	                while (1) {
	                    switch (_context31.prev = _context31.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "fields", fieldId, "dimension"];
	                            existingStatePath = ["metadata", "fields", fieldId];
	
	                            putData = function () {
	                                var _ref31 = _asyncToGenerator(regeneratorRuntime.mark(function _callee30() {
	                                    return regeneratorRuntime.wrap(function _callee30$(_context30) {
	                                        while (1) {
	                                            switch (_context30.prev = _context30.next) {
	                                                case 0:
	                                                    _context30.next = 2;
	                                                    return _services.MetabaseApi.field_dimension_delete({ fieldId: fieldId });
	
	                                                case 2:
	                                                    return _context30.abrupt("return", _context30.sent);
	
	                                                case 3:
	                                                case "end":
	                                                    return _context30.stop();
	                                            }
	                                        }
	                                    }, _callee30, _this10);
	                                }));
	
	                                return function putData() {
	                                    return _ref31.apply(this, arguments);
	                                };
	                            }();
	
	                            _context31.next = 5;
	                            return (0, _redux.updateData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                putData: putData
	                            });
	
	                        case 5:
	                            return _context31.abrupt("return", _context31.sent);
	
	                        case 6:
	                        case "end":
	                            return _context31.stop();
	                    }
	                }
	            }, _callee31, this);
	        }));
	
	        return function (_x38, _x39) {
	            return _ref30.apply(this, arguments);
	        };
	    }();
	});
	
	var UPDATE_FIELD_DIMENSION = exports.UPDATE_FIELD_DIMENSION = "metabase/metadata/UPDATE_FIELD_DIMENSION";
	var updateFieldDimension = exports.updateFieldDimension = (0, _redux.createThunkAction)(UPDATE_FIELD_DIMENSION, function (fieldId, dimension) {
	    return function () {
	        var _ref32 = _asyncToGenerator(regeneratorRuntime.mark(function _callee33(dispatch, getState) {
	            var _this11 = this;
	
	            var requestStatePath, existingStatePath, putData;
	            return regeneratorRuntime.wrap(function _callee33$(_context33) {
	                while (1) {
	                    switch (_context33.prev = _context33.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "fields", fieldId, "dimension"];
	                            existingStatePath = ["metadata", "fields", fieldId];
	
	                            putData = function () {
	                                var _ref33 = _asyncToGenerator(regeneratorRuntime.mark(function _callee32() {
	                                    return regeneratorRuntime.wrap(function _callee32$(_context32) {
	                                        while (1) {
	                                            switch (_context32.prev = _context32.next) {
	                                                case 0:
	                                                    _context32.next = 2;
	                                                    return _services.MetabaseApi.field_dimension_update(_extends({ fieldId: fieldId }, dimension));
	
	                                                case 2:
	                                                    return _context32.abrupt("return", _context32.sent);
	
	                                                case 3:
	                                                case "end":
	                                                    return _context32.stop();
	                                            }
	                                        }
	                                    }, _callee32, _this11);
	                                }));
	
	                                return function putData() {
	                                    return _ref33.apply(this, arguments);
	                                };
	                            }();
	
	                            _context33.next = 5;
	                            return (0, _redux.updateData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                putData: putData
	                            });
	
	                        case 5:
	                            return _context33.abrupt("return", _context33.sent);
	
	                        case 6:
	                        case "end":
	                            return _context33.stop();
	                    }
	                }
	            }, _callee33, this);
	        }));
	
	        return function (_x40, _x41) {
	            return _ref32.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_REVISIONS = exports.FETCH_REVISIONS = "metabase/metadata/FETCH_REVISIONS";
	var fetchRevisions = exports.fetchRevisions = (0, _redux.createThunkAction)(FETCH_REVISIONS, function (type, id) {
	    var reload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    return function () {
	        var _ref34 = _asyncToGenerator(regeneratorRuntime.mark(function _callee35(dispatch, getState) {
	            var requestStatePath, existingStatePath, getData;
	            return regeneratorRuntime.wrap(function _callee35$(_context35) {
	                while (1) {
	                    switch (_context35.prev = _context35.next) {
	                        case 0:
	                            requestStatePath = ["metadata", "revisions", type, id];
	                            existingStatePath = ["metadata", "revisions"];
	
	                            getData = function () {
	                                var _ref35 = _asyncToGenerator(regeneratorRuntime.mark(function _callee34() {
	                                    var revisions, revisionMap, existingRevisions;
	                                    return regeneratorRuntime.wrap(function _callee34$(_context34) {
	                                        while (1) {
	                                            switch (_context34.prev = _context34.next) {
	                                                case 0:
	                                                    _context34.next = 2;
	                                                    return _services.RevisionsApi.get({ id: id, entity: type });
	
	                                                case 2:
	                                                    revisions = _context34.sent;
	                                                    revisionMap = (0, _redux.resourceListToMap)(revisions);
	                                                    existingRevisions = (0, _icepick.getIn)(getState(), existingStatePath);
	                                                    return _context34.abrupt("return", (0, _icepick.assocIn)(existingRevisions, [type, id], revisionMap));
	
	                                                case 6:
	                                                case "end":
	                                                    return _context34.stop();
	                                            }
	                                        }
	                                    }, _callee34, undefined);
	                                }));
	
	                                return function getData() {
	                                    return _ref35.apply(this, arguments);
	                                };
	                            }();
	
	                            _context35.next = 5;
	                            return (0, _redux.fetchData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                getData: getData,
	                                reload: reload
	                            });
	
	                        case 5:
	                            return _context35.abrupt("return", _context35.sent);
	
	                        case 6:
	                        case "end":
	                            return _context35.stop();
	                    }
	                }
	            }, _callee35, undefined);
	        }));
	
	        return function (_x43, _x44) {
	            return _ref34.apply(this, arguments);
	        };
	    }();
	});
	
	// for fetches with data dependencies in /reference
	var FETCH_METRIC_TABLE = exports.FETCH_METRIC_TABLE = "metabase/metadata/FETCH_METRIC_TABLE";
	var fetchMetricTable = exports.fetchMetricTable = (0, _redux.createThunkAction)(FETCH_METRIC_TABLE, function (metricId) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return function () {
	        var _ref36 = _asyncToGenerator(regeneratorRuntime.mark(function _callee36(dispatch, getState) {
	            var metric, tableId;
	            return regeneratorRuntime.wrap(function _callee36$(_context36) {
	                while (1) {
	                    switch (_context36.prev = _context36.next) {
	                        case 0:
	                            _context36.next = 2;
	                            return dispatch(fetchMetrics());
	
	                        case 2:
	                            // FIXME: fetchMetric?
	                            metric = (0, _icepick.getIn)(getState(), ['metadata', 'metrics', metricId]);
	                            tableId = metric.table_id;
	                            _context36.next = 6;
	                            return dispatch(fetchTableMetadata(tableId));
	
	                        case 6:
	                        case "end":
	                            return _context36.stop();
	                    }
	                }
	            }, _callee36, undefined);
	        }));
	
	        return function (_x46, _x47) {
	            return _ref36.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_METRIC_REVISIONS = exports.FETCH_METRIC_REVISIONS = "metabase/metadata/FETCH_METRIC_REVISIONS";
	var fetchMetricRevisions = exports.fetchMetricRevisions = (0, _redux.createThunkAction)(FETCH_METRIC_REVISIONS, function (metricId) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return function () {
	        var _ref37 = _asyncToGenerator(regeneratorRuntime.mark(function _callee37(dispatch, getState) {
	            var metric, tableId;
	            return regeneratorRuntime.wrap(function _callee37$(_context37) {
	                while (1) {
	                    switch (_context37.prev = _context37.next) {
	                        case 0:
	                            _context37.next = 2;
	                            return Promise.all([dispatch(fetchRevisions('metric', metricId)), dispatch(fetchMetrics())]);
	
	                        case 2:
	                            metric = (0, _icepick.getIn)(getState(), ['metadata', 'metrics', metricId]);
	                            tableId = metric.table_id;
	                            _context37.next = 6;
	                            return dispatch(fetchTableMetadata(tableId));
	
	                        case 6:
	                        case "end":
	                            return _context37.stop();
	                    }
	                }
	            }, _callee37, undefined);
	        }));
	
	        return function (_x49, _x50) {
	            return _ref37.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_SEGMENT_FIELDS = exports.FETCH_SEGMENT_FIELDS = "metabase/metadata/FETCH_SEGMENT_FIELDS";
	var fetchSegmentFields = exports.fetchSegmentFields = (0, _redux.createThunkAction)(FETCH_SEGMENT_FIELDS, function (segmentId) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return function () {
	        var _ref38 = _asyncToGenerator(regeneratorRuntime.mark(function _callee38(dispatch, getState) {
	            var segment, tableId, table, databaseId;
	            return regeneratorRuntime.wrap(function _callee38$(_context38) {
	                while (1) {
	                    switch (_context38.prev = _context38.next) {
	                        case 0:
	                            _context38.next = 2;
	                            return dispatch(fetchSegments());
	
	                        case 2:
	                            // FIXME: fetchSegment?
	                            segment = (0, _icepick.getIn)(getState(), ['metadata', 'segments', segmentId]);
	                            tableId = segment.table_id;
	                            _context38.next = 6;
	                            return dispatch(fetchTableMetadata(tableId));
	
	                        case 6:
	                            table = (0, _icepick.getIn)(getState(), ['metadata', 'tables', tableId]);
	                            databaseId = table.db_id;
	                            _context38.next = 10;
	                            return dispatch(fetchDatabaseMetadata(databaseId));
	
	                        case 10:
	                        case "end":
	                            return _context38.stop();
	                    }
	                }
	            }, _callee38, undefined);
	        }));
	
	        return function (_x52, _x53) {
	            return _ref38.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_SEGMENT_TABLE = exports.FETCH_SEGMENT_TABLE = "metabase/metadata/FETCH_SEGMENT_TABLE";
	var fetchSegmentTable = exports.fetchSegmentTable = (0, _redux.createThunkAction)(FETCH_SEGMENT_TABLE, function (segmentId) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return function () {
	        var _ref39 = _asyncToGenerator(regeneratorRuntime.mark(function _callee39(dispatch, getState) {
	            var segment, tableId;
	            return regeneratorRuntime.wrap(function _callee39$(_context39) {
	                while (1) {
	                    switch (_context39.prev = _context39.next) {
	                        case 0:
	                            _context39.next = 2;
	                            return dispatch(fetchSegments());
	
	                        case 2:
	                            // FIXME: fetchSegment?
	                            segment = (0, _icepick.getIn)(getState(), ['metadata', 'segments', segmentId]);
	                            tableId = segment.table_id;
	                            _context39.next = 6;
	                            return dispatch(fetchTableMetadata(tableId));
	
	                        case 6:
	                        case "end":
	                            return _context39.stop();
	                    }
	                }
	            }, _callee39, undefined);
	        }));
	
	        return function (_x55, _x56) {
	            return _ref39.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_SEGMENT_REVISIONS = exports.FETCH_SEGMENT_REVISIONS = "metabase/metadata/FETCH_SEGMENT_REVISIONS";
	var fetchSegmentRevisions = exports.fetchSegmentRevisions = (0, _redux.createThunkAction)(FETCH_SEGMENT_REVISIONS, function (segmentId) {
	    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return function () {
	        var _ref40 = _asyncToGenerator(regeneratorRuntime.mark(function _callee40(dispatch, getState) {
	            var segment, tableId;
	            return regeneratorRuntime.wrap(function _callee40$(_context40) {
	                while (1) {
	                    switch (_context40.prev = _context40.next) {
	                        case 0:
	                            _context40.next = 2;
	                            return Promise.all([dispatch(fetchRevisions('segment', segmentId)), dispatch(fetchSegments())]);
	
	                        case 2:
	                            segment = (0, _icepick.getIn)(getState(), ['metadata', 'segments', segmentId]);
	                            tableId = segment.table_id;
	                            _context40.next = 6;
	                            return dispatch(fetchTableMetadata(tableId));
	
	                        case 6:
	                        case "end":
	                            return _context40.stop();
	                    }
	                }
	            }, _callee40, undefined);
	        }));
	
	        return function (_x58, _x59) {
	            return _ref40.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_DATABASES_WITH_METADATA = "metabase/metadata/FETCH_DATABASES_WITH_METADATA";
	var fetchDatabasesWithMetadata = exports.fetchDatabasesWithMetadata = (0, _redux.createThunkAction)(FETCH_DATABASES_WITH_METADATA, function () {
	    var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return function () {
	        var _ref41 = _asyncToGenerator(regeneratorRuntime.mark(function _callee41(dispatch, getState) {
	            var databases;
	            return regeneratorRuntime.wrap(function _callee41$(_context41) {
	                while (1) {
	                    switch (_context41.prev = _context41.next) {
	                        case 0:
	                            _context41.next = 2;
	                            return dispatch(fetchDatabases());
	
	                        case 2:
	                            databases = (0, _icepick.getIn)(getState(), ['metadata', 'databases']);
	                            _context41.next = 5;
	                            return Promise.all(Object.values(databases).map(function (database) {
	                                return dispatch(fetchDatabaseMetadata(database.id));
	                            }));
	
	                        case 5:
	                        case "end":
	                            return _context41.stop();
	                    }
	                }
	            }, _callee41, undefined);
	        }));
	
	        return function (_x61, _x62) {
	            return _ref41.apply(this, arguments);
	        };
	    }();
	});
	
	var databases = (0, _redux.handleActions)({}, {});
	
	var databasesList = (0, _redux.handleActions)(_defineProperty({}, FETCH_DATABASES, { next: function next(state, _ref42) {
	        var payload = _ref42.payload;
	        return payload && payload.result || state;
	    } }), []);
	
	var tables = (0, _redux.handleActions)({}, {});
	
	var fields = (0, _redux.handleActions)((_handleActions2 = {}, _defineProperty(_handleActions2, FETCH_FIELD_VALUES, { next: function next(state, _ref43) {
	        var fieldValues = _ref43.payload;
	        return fieldValues ? (0, _icepick.assocIn)(state, [fieldValues.field_id, "values"], fieldValues) : state;
	    } }), _defineProperty(_handleActions2, ADD_PARAM_VALUES, { next: function next(state, _ref44) {
	        var paramValues = _ref44.payload;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = Object.values(paramValues)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var fieldValues = _step.value;
	
	                state = (0, _icepick.assocIn)(state, [fieldValues.field_id, "values"], fieldValues);
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        return state;
	    } }), _handleActions2), {});
	
	var metrics = (0, _redux.handleActions)({}, {});
	
	var segments = (0, _redux.handleActions)({}, {});
	
	var revisions = (0, _redux.handleActions)(_defineProperty({}, FETCH_REVISIONS, { next: function next(state, _ref45) {
	        var payload = _ref45.payload;
	        return payload;
	    } }), {});
	
	exports.default = (0, _redux.combineReducers)({
	    metrics: (0, _redux.handleEntities)(/^metabase\/metadata\//, "metrics", metrics),
	    segments: (0, _redux.handleEntities)(/^metabase\/metadata\//, "segments", segments),
	    databases: (0, _redux.handleEntities)(/^metabase\/metadata\//, "databases", databases),
	    tables: (0, _redux.handleEntities)(/^metabase\/metadata\//, "tables", tables),
	    fields: (0, _redux.handleEntities)(/^metabase\/metadata\//, "fields", fields),
	    revisions: revisions,
	    databasesList: databasesList
	});

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.denormalize = exports.normalize = exports.schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Entity = __webpack_require__(1112);
	
	var _Entity2 = _interopRequireDefault(_Entity);
	
	var _Union = __webpack_require__(1114);
	
	var _Union2 = _interopRequireDefault(_Union);
	
	var _Values = __webpack_require__(1116);
	
	var _Values2 = _interopRequireDefault(_Values);
	
	var _Array = __webpack_require__(1117);
	
	var ArrayUtils = _interopRequireWildcard(_Array);
	
	var _Object = __webpack_require__(1118);
	
	var ObjectUtils = _interopRequireWildcard(_Object);
	
	var _ImmutableUtils = __webpack_require__(1113);
	
	var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var visit = function visit(value, parent, key, schema, addEntity) {
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || !value) {
	    return value;
	  }
	
	  if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object' && (!schema.normalize || typeof schema.normalize !== 'function')) {
	    var method = Array.isArray(schema) ? ArrayUtils.normalize : ObjectUtils.normalize;
	    return method(schema, value, parent, key, visit, addEntity);
	  }
	
	  return schema.normalize(value, parent, key, visit, addEntity);
	};
	
	var addEntities = function addEntities(entities) {
	  return function (schema, processedEntity, value, parent, key) {
	    var schemaKey = schema.key;
	    var id = schema.getId(value, parent, key);
	    if (!(schemaKey in entities)) {
	      entities[schemaKey] = {};
	    }
	
	    var existingEntity = entities[schemaKey][id];
	    if (existingEntity) {
	      entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
	    } else {
	      entities[schemaKey][id] = processedEntity;
	    }
	  };
	};
	
	var schema = exports.schema = {
	  Array: ArrayUtils.default,
	  Entity: _Entity2.default,
	  Object: ObjectUtils.default,
	  Union: _Union2.default,
	  Values: _Values2.default
	};
	
	var normalize = exports.normalize = function normalize(input, schema) {
	  if (!input || (typeof input === 'undefined' ? 'undefined' : _typeof(input)) !== 'object') {
	    throw new Error('Unexpected input given to normalize. Expected type to be "object", found "' + (typeof input === 'undefined' ? 'undefined' : _typeof(input)) + '".');
	  }
	
	  var entities = {};
	  var addEntity = addEntities(entities);
	
	  var result = visit(input, input, null, schema, addEntity);
	  return { entities: entities, result: result };
	};
	
	var unvisitEntity = function unvisitEntity(input, schema, unvisit, getEntity, cache) {
	  var entity = getEntity(input, schema);
	  if ((typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) !== 'object' || entity === null) {
	    return entity;
	  }
	
	  var id = schema.getId(entity);
	
	  if (!cache[schema.key]) {
	    cache[schema.key] = {};
	  }
	
	  if (!cache[schema.key][id]) {
	    // Ensure we don't mutate it non-immutable objects
	    var entityCopy = ImmutableUtils.isImmutable(entity) ? entity : _extends({}, entity);
	
	    // Need to set this first so that if it is referenced further within the
	    // denormalization the reference will already exist.
	    cache[schema.key][id] = entityCopy;
	    cache[schema.key][id] = schema.denormalize(entityCopy, unvisit);
	  }
	
	  return cache[schema.key][id];
	};
	
	var getUnvisit = function getUnvisit(entities) {
	  var cache = {};
	  var getEntity = getEntities(entities);
	
	  return function unvisit(input, schema) {
	    if ((typeof schema === 'undefined' ? 'undefined' : _typeof(schema)) === 'object' && (!schema.denormalize || typeof schema.denormalize !== 'function')) {
	      var method = Array.isArray(schema) ? ArrayUtils.denormalize : ObjectUtils.denormalize;
	      return method(schema, input, unvisit);
	    }
	
	    if (input === undefined || input === null) {
	      return input;
	    }
	
	    if (schema instanceof _Entity2.default) {
	      return unvisitEntity(input, schema, unvisit, getEntity, cache);
	    }
	
	    return schema.denormalize(input, unvisit);
	  };
	};
	
	var getEntities = function getEntities(entities) {
	  var isImmutable = ImmutableUtils.isImmutable(entities);
	
	  return function (entityOrId, schema) {
	    var schemaKey = schema.key;
	
	    if ((typeof entityOrId === 'undefined' ? 'undefined' : _typeof(entityOrId)) === 'object') {
	      return entityOrId;
	    }
	
	    return isImmutable ? entities.getIn([schemaKey, entityOrId.toString()]) : entities[schemaKey][entityOrId];
	  };
	};
	
	var denormalize = exports.denormalize = function denormalize(input, schema, entities) {
	  if (!input) {
	    return input;
	  }
	
	  return getUnvisit(entities)(input, schema);
	};

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ImmutableUtils = __webpack_require__(1113);
	
	var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var getDefaultGetId = function getDefaultGetId(idAttribute) {
	  return function (input) {
	    return ImmutableUtils.isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
	  };
	};
	
	var EntitySchema = function () {
	  function EntitySchema(key) {
	    var definition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    _classCallCheck(this, EntitySchema);
	
	    if (!key || typeof key !== 'string') {
	      throw new Error('Expected a string key for Entity, but found ' + key + '.');
	    }
	
	    var _options$idAttribute = options.idAttribute,
	        idAttribute = _options$idAttribute === undefined ? 'id' : _options$idAttribute,
	        _options$mergeStrateg = options.mergeStrategy,
	        mergeStrategy = _options$mergeStrateg === undefined ? function (entityA, entityB) {
	      return _extends({}, entityA, entityB);
	    } : _options$mergeStrateg,
	        _options$processStrat = options.processStrategy,
	        processStrategy = _options$processStrat === undefined ? function (input) {
	      return _extends({}, input);
	    } : _options$processStrat;
	
	
	    this._key = key;
	    this._getId = typeof idAttribute === 'function' ? idAttribute : getDefaultGetId(idAttribute);
	    this._idAttribute = idAttribute;
	    this._mergeStrategy = mergeStrategy;
	    this._processStrategy = processStrategy;
	    this.define(definition);
	  }
	
	  _createClass(EntitySchema, [{
	    key: 'define',
	    value: function define(definition) {
	      this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
	        var schema = definition[key];
	        return _extends({}, entitySchema, _defineProperty({}, key, schema));
	      }, this.schema || {});
	    }
	  }, {
	    key: 'getId',
	    value: function getId(input, parent, key) {
	      return this._getId(input, parent, key);
	    }
	  }, {
	    key: 'merge',
	    value: function merge(entityA, entityB) {
	      return this._mergeStrategy(entityA, entityB);
	    }
	  }, {
	    key: 'normalize',
	    value: function normalize(input, parent, key, visit, addEntity) {
	      var _this = this;
	
	      var processedEntity = this._processStrategy(input, parent, key);
	      Object.keys(this.schema).forEach(function (key) {
	        if (processedEntity.hasOwnProperty(key) && _typeof(processedEntity[key]) === 'object') {
	          var schema = _this.schema[key];
	          processedEntity[key] = visit(processedEntity[key], processedEntity, key, schema, addEntity);
	        }
	      });
	
	      addEntity(this, processedEntity, input, parent, key);
	      return this.getId(input, parent, key);
	    }
	  }, {
	    key: 'denormalize',
	    value: function denormalize(entity, unvisit) {
	      var _this2 = this;
	
	      if (ImmutableUtils.isImmutable(entity)) {
	        return ImmutableUtils.denormalizeImmutable(this.schema, entity, unvisit);
	      }
	
	      Object.keys(this.schema).forEach(function (key) {
	        if (entity.hasOwnProperty(key)) {
	          var schema = _this2.schema[key];
	          entity[key] = unvisit(entity[key], schema);
	        }
	      });
	      return entity;
	    }
	  }, {
	    key: 'key',
	    get: function get() {
	      return this._key;
	    }
	  }, {
	    key: 'idAttribute',
	    get: function get() {
	      return this._idAttribute;
	    }
	  }]);
	
	  return EntitySchema;
	}();
	
	exports.default = EntitySchema;

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isImmutable = isImmutable;
	exports.denormalizeImmutable = denormalizeImmutable;
	/**
	 * Helpers to enable Immutable compatibility *without* bringing in
	 * the 'immutable' package as a dependency.
	 */
	
	/**
	 * Check if an object is immutable by checking if it has a key specific
	 * to the immutable library.
	 *
	 * @param  {any} object
	 * @return {bool}
	 */
	function isImmutable(object) {
	  return !!(object && (object.hasOwnProperty('__ownerID') || // Immutable.Map
	  object._map && object._map.hasOwnProperty('__ownerID') // Immutable.Record
	  ));
	}
	
	/**
	 * Denormalize an immutable entity.
	 *
	 * @param  {Schema} schema
	 * @param  {Immutable.Map|Immutable.Record} input
	 * @param  {function} unvisit
	 * @param  {function} getDenormalizedEntity
	 * @return {Immutable.Map|Immutable.Record}
	 */
	function denormalizeImmutable(schema, input, unvisit) {
	  return Object.keys(schema).reduce(function (object, key) {
	    // Immutable maps cast keys to strings on write so we need to ensure
	    // we're accessing them using string keys.
	    var stringKey = '' + key;
	
	    if (object.has(stringKey)) {
	      return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
	    } else {
	      return object;
	    }
	  }, input);
	}

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Polymorphic = __webpack_require__(1115);
	
	var _Polymorphic2 = _interopRequireDefault(_Polymorphic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UnionSchema = function (_PolymorphicSchema) {
	  _inherits(UnionSchema, _PolymorphicSchema);
	
	  function UnionSchema(definition, schemaAttribute) {
	    _classCallCheck(this, UnionSchema);
	
	    if (!schemaAttribute) {
	      throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
	    }
	    return _possibleConstructorReturn(this, (UnionSchema.__proto__ || Object.getPrototypeOf(UnionSchema)).call(this, definition, schemaAttribute));
	  }
	
	  _createClass(UnionSchema, [{
	    key: 'normalize',
	    value: function normalize(input, parent, key, visit, addEntity) {
	      return this.normalizeValue(input, parent, key, visit, addEntity);
	    }
	  }, {
	    key: 'denormalize',
	    value: function denormalize(input, unvisit) {
	      return this.denormalizeValue(input, unvisit);
	    }
	  }]);
	
	  return UnionSchema;
	}(_Polymorphic2.default);
	
	exports.default = UnionSchema;

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PolymorphicSchema = function () {
	  function PolymorphicSchema(definition, schemaAttribute) {
	    _classCallCheck(this, PolymorphicSchema);
	
	    if (schemaAttribute) {
	      this._schemaAttribute = typeof schemaAttribute === 'string' ? function (input) {
	        return input[schemaAttribute];
	      } : schemaAttribute;
	    }
	    this.define(definition);
	  }
	
	  _createClass(PolymorphicSchema, [{
	    key: 'define',
	    value: function define(definition) {
	      this.schema = definition;
	    }
	  }, {
	    key: 'getSchemaAttribute',
	    value: function getSchemaAttribute(input, parent, key) {
	      return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
	    }
	  }, {
	    key: 'inferSchema',
	    value: function inferSchema(input, parent, key) {
	      if (this.isSingleSchema) {
	        return this.schema;
	      }
	
	      var attr = this.getSchemaAttribute(input, parent, key);
	      return this.schema[attr];
	    }
	  }, {
	    key: 'normalizeValue',
	    value: function normalizeValue(value, parent, key, visit, addEntity) {
	      var schema = this.inferSchema(value, parent, key);
	      if (!schema) {
	        return value;
	      }
	      var normalizedValue = visit(value, parent, key, schema, addEntity);
	      return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : { id: normalizedValue, schema: this.getSchemaAttribute(value, parent, key) };
	    }
	  }, {
	    key: 'denormalizeValue',
	    value: function denormalizeValue(value, unvisit) {
	      if (!this.isSingleSchema && !value.schema) {
	        return value;
	      }
	      var schema = this.isSingleSchema ? this.schema : this.schema[value.schema];
	      return unvisit(value.id || value, schema);
	    }
	  }, {
	    key: 'isSingleSchema',
	    get: function get() {
	      return !this._schemaAttribute;
	    }
	  }]);
	
	  return PolymorphicSchema;
	}();
	
	exports.default = PolymorphicSchema;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Polymorphic = __webpack_require__(1115);
	
	var _Polymorphic2 = _interopRequireDefault(_Polymorphic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ValuesSchema = function (_PolymorphicSchema) {
	  _inherits(ValuesSchema, _PolymorphicSchema);
	
	  function ValuesSchema() {
	    _classCallCheck(this, ValuesSchema);
	
	    return _possibleConstructorReturn(this, (ValuesSchema.__proto__ || Object.getPrototypeOf(ValuesSchema)).apply(this, arguments));
	  }
	
	  _createClass(ValuesSchema, [{
	    key: 'normalize',
	    value: function normalize(input, parent, key, visit, addEntity) {
	      var _this2 = this;
	
	      return Object.keys(input).reduce(function (output, key, index) {
	        var value = input[key];
	        return value !== undefined && value !== null ? _extends({}, output, _defineProperty({}, key, _this2.normalizeValue(value, input, key, visit, addEntity))) : output;
	      }, {});
	    }
	  }, {
	    key: 'denormalize',
	    value: function denormalize(input, unvisit) {
	      var _this3 = this;
	
	      return Object.keys(input).reduce(function (output, key) {
	        var entityOrId = input[key];
	        return _extends({}, output, _defineProperty({}, key, _this3.denormalizeValue(entityOrId, unvisit)));
	      }, {});
	    }
	  }]);
	
	  return ValuesSchema;
	}(_Polymorphic2.default);
	
	exports.default = ValuesSchema;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.denormalize = exports.normalize = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Polymorphic = __webpack_require__(1115);
	
	var _Polymorphic2 = _interopRequireDefault(_Polymorphic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validateSchema = function validateSchema(definition) {
	  var isArray = Array.isArray(definition);
	  if (isArray && definition.length > 1) {
	    throw new Error('Expected schema definition to be a single schema, but found ' + definition.length + '.');
	  }
	
	  return definition[0];
	};
	
	var getValues = function getValues(input) {
	  return Array.isArray(input) ? input : Object.keys(input).map(function (key) {
	    return input[key];
	  });
	};
	
	var normalize = exports.normalize = function normalize(schema, input, parent, key, visit, addEntity) {
	  schema = validateSchema(schema);
	
	  var values = getValues(input);
	
	  // Special case: Arrays pass *their* parent on to their children, since there
	  // is not any special information that can be gathered from themselves directly
	  return values.map(function (value, index) {
	    return visit(value, parent, key, schema, addEntity);
	  });
	};
	
	var denormalize = exports.denormalize = function denormalize(schema, input, unvisit) {
	  schema = validateSchema(schema);
	  return input && input.map ? input.map(function (entityOrId) {
	    return unvisit(entityOrId, schema);
	  }) : input;
	};
	
	var ArraySchema = function (_PolymorphicSchema) {
	  _inherits(ArraySchema, _PolymorphicSchema);
	
	  function ArraySchema() {
	    _classCallCheck(this, ArraySchema);
	
	    return _possibleConstructorReturn(this, (ArraySchema.__proto__ || Object.getPrototypeOf(ArraySchema)).apply(this, arguments));
	  }
	
	  _createClass(ArraySchema, [{
	    key: 'normalize',
	    value: function normalize(input, parent, key, visit, addEntity) {
	      var _this2 = this;
	
	      var values = getValues(input);
	
	      return values.map(function (value, index) {
	        return _this2.normalizeValue(value, parent, key, visit, addEntity);
	      }).filter(function (value) {
	        return value !== undefined && value !== null;
	      });
	    }
	  }, {
	    key: 'denormalize',
	    value: function denormalize(input, unvisit) {
	      var _this3 = this;
	
	      return input && input.map ? input.map(function (value) {
	        return _this3.denormalizeValue(value, unvisit);
	      }) : input;
	    }
	  }]);
	
	  return ArraySchema;
	}(_Polymorphic2.default);
	
	exports.default = ArraySchema;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.denormalize = exports.normalize = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ImmutableUtils = __webpack_require__(1113);
	
	var ImmutableUtils = _interopRequireWildcard(_ImmutableUtils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _normalize = function _normalize(schema, input, parent, key, visit, addEntity) {
	  var object = _extends({}, input);
	  Object.keys(schema).forEach(function (key) {
	    var localSchema = schema[key];
	    var value = visit(input[key], input, key, localSchema, addEntity);
	    if (value === undefined || value === null) {
	      delete object[key];
	    } else {
	      object[key] = value;
	    }
	  });
	  return object;
	};
	
	exports.normalize = _normalize;
	var _denormalize = function _denormalize(schema, input, unvisit) {
	  if (ImmutableUtils.isImmutable(input)) {
	    return ImmutableUtils.denormalizeImmutable(schema, input, unvisit);
	  }
	
	  var object = _extends({}, input);
	  Object.keys(schema).forEach(function (key) {
	    if (object[key]) {
	      object[key] = unvisit(object[key], schema[key]);
	    }
	  });
	  return object;
	};
	
	exports.denormalize = _denormalize;
	
	var ObjectSchema = function () {
	  function ObjectSchema(definition) {
	    _classCallCheck(this, ObjectSchema);
	
	    this.define(definition);
	  }
	
	  _createClass(ObjectSchema, [{
	    key: 'define',
	    value: function define(definition) {
	      this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
	        var schema = definition[key];
	        return _extends({}, entitySchema, _defineProperty({}, key, schema));
	      }, this.schema || {});
	    }
	  }, {
	    key: 'normalize',
	    value: function normalize() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _normalize.apply(undefined, [this.schema].concat(args));
	    }
	  }, {
	    key: 'denormalize',
	    value: function denormalize() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _denormalize.apply(undefined, [this.schema].concat(args));
	    }
	  }]);
	
	  return ObjectSchema;
	}();
	
	exports.default = ObjectSchema;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MetricSchema = exports.SegmentSchema = exports.FieldSchema = exports.TableSchema = exports.DatabaseSchema = undefined;
	
	var _normalizr = __webpack_require__(1111);
	
	var DatabaseSchema = exports.DatabaseSchema = new _normalizr.schema.Entity('databases');
	// normalizr schema for use in actions/reducers
	
	var TableSchema = exports.TableSchema = new _normalizr.schema.Entity('tables');
	var FieldSchema = exports.FieldSchema = new _normalizr.schema.Entity('fields');
	var SegmentSchema = exports.SegmentSchema = new _normalizr.schema.Entity('segments');
	var MetricSchema = exports.MetricSchema = new _normalizr.schema.Entity('metrics');
	
	DatabaseSchema.define({
	    tables: [TableSchema]
	});
	
	TableSchema.define({
	    db: DatabaseSchema,
	    fields: [FieldSchema],
	    segments: [SegmentSchema],
	    metrics: [MetricSchema]
	});
	
	FieldSchema.define({
	    target: FieldSchema,
	    table: TableSchema
	});
	
	SegmentSchema.define({
	    table: TableSchema
	});
	
	MetricSchema.define({
	    table: TableSchema
	});

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var punycode = __webpack_require__(1121);
	var util = __webpack_require__(1122);
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	    portPattern = /:[0-9]*$/,
	
	    // Special case for a simple path URL
	    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
	
	    // RFC 2396: characters reserved for delimiting URLs.
	    // We actually just auto-escape these.
	    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
	
	    // RFC 2396: characters not allowed for various reasons.
	    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
	
	    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	    autoEscape = ['\''].concat(unwise),
	    // Characters that are never ever allowed in a hostname.
	    // Note that any invalid chars are also handled, but these
	    // are the ones that are *expected* to be seen, so we fast-path
	    // them.
	    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
	    hostEndingChars = ['/', '?', '#'],
	    hostnameMaxLen = 255,
	    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	    // protocols that can allow "unsafe" and "unwise" chars.
	    unsafeProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that never have a hostname.
	    hostlessProtocol = {
	      'javascript': true,
	      'javascript:': true
	    },
	    // protocols that always contain a // bit.
	    slashedProtocol = {
	      'http': true,
	      'https': true,
	      'ftp': true,
	      'gopher': true,
	      'file': true,
	      'http:': true,
	      'https:': true,
	      'ftp:': true,
	      'gopher:': true,
	      'file:': true
	    },
	    querystring = __webpack_require__(585);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && util.isObject(url) && url instanceof Url) return url;
	
	  var u = new Url;
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
	  if (!util.isString(url)) {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  // Copy chrome, IE, opera backslash-handling behavior.
	  // Back slashes before the query string get converted to forward slashes
	  // See: https://code.google.com/p/chromium/issues/detail?id=25916
	  var queryIndex = url.indexOf('?'),
	      splitter =
	          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
	      uSplit = url.split(splitter),
	      slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  // trim before proceeding.
	  // This is to support parse stuff like "  http://foo.com  \n"
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  // figure out if it's got a host
	  // user@server is *always* interpreted as a hostname, and url
	  // resolution will treat //foo/bar as host=foo,path=bar because that's
	  // how the browser resolves relative URLs.
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] &&
	      (slashes || (proto && !slashedProtocol[proto]))) {
	
	    // there's a hostname.
	    // the first instance of /, ?, ;, or # ends the host.
	    //
	    // If there is an @ in the hostname, then non-host chars *are* allowed
	    // to the left of the last @ sign, unless some host-ending character
	    // comes *before* the @-sign.
	    // URLs are obnoxious.
	    //
	    // ex:
	    // http://a@b@c/ => user:a@b host:c
	    // http://a@b?@c => user:a host:c path:/?@c
	
	    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
	    // Review our test case against browsers more comprehensively.
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	
	    // at this point, either we have an explicit point where the
	    // auth portion cannot go past, or the last @ char is the decider.
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      // atSign must be in auth portion.
	      // http://a@b/c@d => host:b auth:a path:/c@d
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    // Now we have a portion which is definitely the auth.
	    // Pull that off.
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
	        hostEnd = hec;
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1)
	      hostEnd = rest.length;
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    // we've indicated that there is a hostname,
	    // so even if it's empty, it has to be present.
	    this.hostname = this.hostname || '';
	
	    // if hostname begins with [ and ends with ]
	    // assume that it's an IPv6 address.
	    var ipv6Hostname = this.hostname[0] === '[' &&
	        this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) continue;
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              // we replace non-ASCII char with a temporary placeholder
	              // we need this to make sure size of hostname is not
	              // broken by replacing non-ASCII by nothing
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      // IDNA Support: Returns a punycoded representation of "domain".
	      // It only converts parts of the domain name that
	      // have non-ASCII characters, i.e. it doesn't matter if
	      // you call it with a domain that already is ASCII-only.
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    // strip [ and ] from the hostname
	    // the host field still retains them, though
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  // now rest is set to the post-host stuff.
	  // chop off any delim chars.
	  if (!unsafeProtocol[lowerProto]) {
	
	    // First, make 100% sure that any "autoEscape" chars get
	    // escaped, even if encodeURIComponent doesn't think they
	    // need to be.
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1)
	        continue;
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) this.pathname = rest;
	  if (slashedProtocol[lowerProto] &&
	      this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  //to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  // ensure it's an object, and not a string url.
	  // If it's an obj, this is a no-op.
	  // this way, you can call url_format() on strings
	  // to clean up potentially wonky urls.
	  if (util.isString(obj)) obj = urlParse(obj);
	  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
	  return obj.format();
	}
	
	Url.prototype.format = function() {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	      pathname = this.pathname || '',
	      hash = this.hash || '',
	      host = false,
	      query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ?
	        this.hostname :
	        '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query &&
	      util.isObject(this.query) &&
	      Object.keys(this.query).length) {
	    query = querystring.stringify(this.query);
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') protocol += ':';
	
	  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	  // unless they had them to begin with.
	  if (this.slashes ||
	      (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
	  if (search && search.charAt(0) !== '?') search = '?' + search;
	
	  pathname = pathname.replace(/[?#]/g, function(match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function(relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) return relative;
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function(relative) {
	  if (util.isString(relative)) {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  // hash is always overridden, no matter what.
	  // even href="" will remove it.
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol')
	        result[rkey] = relative[rkey];
	    }
	
	    //urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] &&
	        result.hostname && !result.pathname) {
	      result.path = result.pathname = '/';
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    // if it's a known url protocol, then changing
	    // the protocol does weird things
	    // first, if it's not file:, then we MUST have a host,
	    // and if there was a path
	    // to begin with, then we MUST have a path.
	    // if it is file:, then the host is dropped,
	    // because that's known to be hostless.
	    // anything else is assumed to be absolute.
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift()));
	      if (!relative.host) relative.host = '';
	      if (!relative.hostname) relative.hostname = '';
	      if (relPath[0] !== '') relPath.unshift('');
	      if (relPath.length < 2) relPath.unshift('');
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
	      isRelAbs = (
	          relative.host ||
	          relative.pathname && relative.pathname.charAt(0) === '/'
	      ),
	      mustEndAbs = (isRelAbs || isSourceAbs ||
	                    (result.host && relative.pathname)),
	      removeAllDots = mustEndAbs,
	      srcPath = result.pathname && result.pathname.split('/') || [],
	      relPath = relative.pathname && relative.pathname.split('/') || [],
	      psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  // if the url is a non-slashed url, then relative
	  // links like ../.. should be able
	  // to crawl up to the hostname, as well.  This is strange.
	  // result.protocol has already been set by now.
	  // Later on, put the first path part into the host field.
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') srcPath[0] = result.host;
	      else srcPath.unshift(result.host);
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') relPath[0] = relative.host;
	        else relPath.unshift(relative.host);
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = (relative.host || relative.host === '') ?
	                  relative.host : result.host;
	    result.hostname = (relative.hostname || relative.hostname === '') ?
	                      relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    // it's relative
	    // throw away the existing file, and take the new path instead.
	    if (!srcPath) srcPath = [];
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (!util.isNullOrUndefined(relative.search)) {
	    // just pull out the search.
	    // like href='?foo'.
	    // Put this after the other two cases because it simplifies the booleans
	    if (psychotic) {
	      result.hostname = result.host = srcPath.shift();
	      //occationaly the auth can get stuck only in host
	      //this especially happens in cases like
	      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	      var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                       result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.host = result.hostname = authInHost.shift();
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    //to support http.request
	    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	      result.path = (result.pathname ? result.pathname : '') +
	                    (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    // no path at all.  easy.
	    // we've already handled the other stuff above.
	    result.pathname = null;
	    //to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  // if a url ENDs in . or .., then it must get a trailing slash.
	  // however, if it ends in anything else non-slashy,
	  // then it must NOT get a trailing slash.
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (
	      (result.host || relative.host || srcPath.length > 1) &&
	      (last === '.' || last === '..') || last === '');
	
	  // strip single dots, resolve double dots to parent dir
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' &&
	      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' ||
	      (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = result.host = isAbsolute ? '' :
	                                    srcPath.length ? srcPath.shift() : '';
	    //occationaly the auth can get stuck only in host
	    //this especially happens in cases like
	    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	    var authInHost = result.host && result.host.indexOf('@') > 0 ?
	                     result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.host = result.hostname = authInHost.shift();
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (!srcPath.length) {
	    result.pathname = null;
	    result.path = null;
	  } else {
	    result.pathname = srcPath.join('/');
	  }
	
	  //to support request.http
	  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
	    result.path = (result.pathname ? result.pathname : '') +
	                  (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function() {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) this.hostname = host;
	};


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.3.2 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.3.2',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(494)(module), (function() { return this; }())))

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  isString: function(arg) {
	    return typeof(arg) === 'string';
	  },
	  isObject: function(arg) {
	    return typeof(arg) === 'object' && arg !== null;
	  },
	  isNull: function(arg) {
	    return arg === null;
	  },
	  isNullOrUndefined: function(arg) {
	    return arg == null;
	  }
	};


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.passwordReset = exports.PASSWORD_RESET = exports.logout = exports.LOGOUT = exports.loginGoogle = exports.LOGIN_GOOGLE = exports.login = exports.LOGIN = undefined;
	
	var _handleActions;
	
	var _redux = __webpack_require__(657);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _cookies = __webpack_require__(1124);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _auth = __webpack_require__(1125);
	
	var _user = __webpack_require__(862);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// login
	var LOGIN = exports.LOGIN = "metabase/auth/LOGIN";
	var login = exports.login = (0, _redux.createThunkAction)(LOGIN, function (credentials, redirectUrl) {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var newSession;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(!_settings2.default.ldapEnabled() && !_utils2.default.validEmail(credentials.username))) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt("return", { 'data': { 'errors': { 'email': "Please enter a valid formatted email address." } } });
	
	                        case 2:
	                            _context.prev = 2;
	                            _context.next = 5;
	                            return _services.SessionApi.create(credentials);
	
	                        case 5:
	                            newSession = _context.sent;
	
	
	                            // since we succeeded, lets set the session cookie
	                            _cookies2.default.setSessionCookie(newSession.id);
	
	                            _analytics2.default.trackEvent('Auth', 'Login');
	                            // TODO: redirect after login (carry user to intended destination)
	                            _context.next = 10;
	                            return dispatch((0, _user.refreshCurrentUser)());
	
	                        case 10:
	                            dispatch((0, _reactRouterRedux.push)(redirectUrl || "/"));
	
	                            _context.next = 16;
	                            break;
	
	                        case 13:
	                            _context.prev = 13;
	                            _context.t0 = _context["catch"](2);
	                            return _context.abrupt("return", _context.t0);
	
	                        case 16:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[2, 13]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	// login Google
	var LOGIN_GOOGLE = exports.LOGIN_GOOGLE = "metabase/auth/LOGIN_GOOGLE";
	var loginGoogle = exports.loginGoogle = (0, _redux.createThunkAction)(LOGIN_GOOGLE, function (googleUser, redirectUrl) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var newSession;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _services.SessionApi.createWithGoogleAuth({
	                                token: googleUser.getAuthResponse().id_token
	                            });
	
	                        case 3:
	                            newSession = _context2.sent;
	
	
	                            // since we succeeded, lets set the session cookie
	                            _cookies2.default.setSessionCookie(newSession.id);
	
	                            _analytics2.default.trackEvent('Auth', 'Google Auth Login');
	
	                            // TODO: redirect after login (carry user to intended destination)
	                            _context2.next = 8;
	                            return dispatch((0, _user.refreshCurrentUser)());
	
	                        case 8:
	                            dispatch((0, _reactRouterRedux.push)(redirectUrl || "/"));
	
	                            _context2.next = 19;
	                            break;
	
	                        case 11:
	                            _context2.prev = 11;
	                            _context2.t0 = _context2["catch"](0);
	
	                            (0, _auth.clearGoogleAuthCredentials)();
	                            // If we see a 428 ("Precondition Required") that means we need to show the "No Metabase account exists for this Google Account" page
	
	                            if (!(_context2.t0.status === 428)) {
	                                _context2.next = 18;
	                                break;
	                            }
	
	                            dispatch((0, _reactRouterRedux.push)("/auth/google_no_mb_account"));
	                            _context2.next = 19;
	                            break;
	
	                        case 18:
	                            return _context2.abrupt("return", _context2.t0);
	
	                        case 19:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[0, 11]]);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	// logout
	var LOGOUT = exports.LOGOUT = "metabase/auth/LOGOUT";
	var logout = exports.logout = (0, _redux.createThunkAction)(LOGOUT, function () {
	    return function (dispatch, getState) {
	        // TODO: as part of a logout we want to clear out any saved state that we have about anything
	
	        var sessionId = _cookies2.default.setSessionCookie();
	        if (sessionId) {
	            // actively delete the session
	            _services.SessionApi.delete({ 'session_id': sessionId });
	        }
	        _analytics2.default.trackEvent('Auth', 'Logout');
	
	        dispatch((0, _reactRouterRedux.push)("/auth/login"));
	    };
	});
	
	// passwordReset
	var PASSWORD_RESET = exports.PASSWORD_RESET = "metabase/auth/PASSWORD_RESET";
	var passwordReset = exports.passwordReset = (0, _redux.createThunkAction)(PASSWORD_RESET, function (token, credentials) {
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            var result;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            if (!(credentials.password !== credentials.password2)) {
	                                _context3.next = 2;
	                                break;
	                            }
	
	                            return _context3.abrupt("return", {
	                                success: false,
	                                error: { 'data': { 'errors': { 'password2': "Passwords do not match" } } }
	                            });
	
	                        case 2:
	                            _context3.prev = 2;
	                            _context3.next = 5;
	                            return _services.SessionApi.reset_password({ 'token': token, 'password': credentials.password });
	
	                        case 5:
	                            result = _context3.sent;
	
	
	                            if (result.session_id) {
	                                // we should have a valid session that we can use immediately!
	                                _cookies2.default.setSessionCookie(result.session_id);
	                            }
	
	                            _analytics2.default.trackEvent('Auth', 'Password Reset');
	
	                            return _context3.abrupt("return", {
	                                success: true,
	                                error: null
	                            });
	
	                        case 11:
	                            _context3.prev = 11;
	                            _context3.t0 = _context3["catch"](2);
	                            return _context3.abrupt("return", {
	                                success: false,
	                                error: _context3.t0
	                            });
	
	                        case 14:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[2, 11]]);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	});
	
	// reducers
	
	var loginError = (0, _redux.handleActions)((_handleActions = {}, _defineProperty(_handleActions, LOGIN, { next: function next(state, _ref4) {
	        var payload = _ref4.payload;
	        return payload ? payload : null;
	    } }), _defineProperty(_handleActions, LOGIN_GOOGLE, { next: function next(state, _ref5) {
	        var payload = _ref5.payload;
	        return payload ? payload : null;
	    } }), _handleActions), null);
	
	var resetSuccess = (0, _redux.handleActions)(_defineProperty({}, PASSWORD_RESET, { next: function next(state, _ref6) {
	        var payload = _ref6.payload;
	        return payload.success;
	    } }), false);
	
	var resetError = (0, _redux.handleActions)(_defineProperty({}, PASSWORD_RESET, { next: function next(state, _ref7) {
	        var payload = _ref7.payload;
	        return payload.error;
	    } }), null);
	
	exports.default = (0, _redux.combineReducers)({
	    loginError: loginError,
	    resetError: resetError,
	    resetSuccess: resetSuccess
	});

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.METABASE_SESSION_COOKIE = undefined;
	
	var _auth = __webpack_require__(1125);
	
	var _jsCookie = __webpack_require__(1126);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var METABASE_SESSION_COOKIE = exports.METABASE_SESSION_COOKIE = 'metabase.SESSION_ID';
	
	// Handles management of Metabase cookie work
	var MetabaseCookies = {
	    // set the session cookie.  if sessionId is null, clears the cookie
	    setSessionCookie: function setSessionCookie(sessionId) {
	        var options = {
	            path: window.MetabaseRoot || '/',
	            expires: 14,
	            secure: window.location.protocol === "https:"
	        };
	
	        try {
	            if (sessionId) {
	                // set a session cookie
	                _jsCookie2.default.set(METABASE_SESSION_COOKIE, sessionId, options);
	            } else {
	                sessionId = _jsCookie2.default.get(METABASE_SESSION_COOKIE);
	
	                // delete the current session cookie and Google Auth creds
	                _jsCookie2.default.remove(METABASE_SESSION_COOKIE);
	                (0, _auth.clearGoogleAuthCredentials)();
	
	                return sessionId;
	            }
	        } catch (e) {
	            console.error("setSessionCookie:", e);
	        }
	    }
	};
	
	exports.default = MetabaseCookies;

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.clearGoogleAuthCredentials = clearGoogleAuthCredentials;
	/*global gapi*/
	
	/// clear out Google Auth credentials in browser if present
	function clearGoogleAuthCredentials() {
	    var googleAuth = typeof gapi !== 'undefined' && gapi && gapi.auth2 ? gapi.auth2.getAuthInstance() : undefined;
	    if (!googleAuth) return;
	
	    try {
	        googleAuth.signOut().then(function () {
	            console.log('Cleared Google Auth credentials.');
	        });
	    } catch (error) {
	        console.error('Problem clearing Google Auth credentials', error);
	    }
	}

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.1.4
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 1127 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var getUser = exports.getUser = function getUser(state) {
	    return state.currentUser;
	};
	
	var getUserIsAdmin = exports.getUserIsAdmin = function getUserIsAdmin(state) {
	    return (getUser(state) || {}).is_superuser || false;
	};

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(1129);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(1130);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(1131);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1132);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(1150);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1151);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1152);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1153);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1155);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(1154);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1156);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(1146);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1157);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(1170);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1171);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1172);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1180);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(1159);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(469);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(1133);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(469);
	
	var _createTransitionManager2 = __webpack_require__(1135);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(1145);
	
	var _RouterContext = __webpack_require__(1146);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(1129);
	
	var _RouterUtils = __webpack_require__(1149);
	
	var _routerWarning = __webpack_require__(1136);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(300);
	var factory = __webpack_require__(1134);
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(302);
	
	var emptyObject = __webpack_require__(318);
	var _invariant = __webpack_require__(306);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context',
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @nosideeffects
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function (Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function (Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function (Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	    },
	    contextTypes: function (Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function (Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function (Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function (Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function () {} };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	         false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	      }
	
	      return;
	    }
	
	    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
	    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
	
	      var isInherited = name in Constructor;
	      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function (newThis) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	        } else if (!args.length) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedMixin = {
	    componentDidMount: function () {
	      this.__isMounted = true;
	    },
	    componentWillUnmount: function () {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function (newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function () {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function () {};
	  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedMixin);
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(1136);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1138);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1139);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1141);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1142);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1144);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(1137);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(1131);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(1140);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(1131);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(1140);
	
	var _PromiseUtils = __webpack_require__(1143);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(1140);
	
	var _PromiseUtils = __webpack_require__(1143);
	
	var _PatternUtils = __webpack_require__(1131);
	
	var _routerWarning = __webpack_require__(1136);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(1129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(469);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]);
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(1133);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(469);
	
	var _getRouteParams = __webpack_require__(1147);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(1148);
	
	var _RouteUtils = __webpack_require__(1129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(1131);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	function ContextProvider(name) {
	  var _childContextTypes, _ref2;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  return _ref2 = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _ref2[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _ref2;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _ref4;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  return _ref4 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref3;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _ref4;
	}

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(1133);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(469);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(1130);
	
	var _ContextUtils = __webpack_require__(1148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(1133);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(1150);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(1133);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(474);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(1148);
	
	var _PropTypes = __webpack_require__(1130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(1133);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(469);
	
	var _routerWarning = __webpack_require__(1136);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(1154);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(1145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(1133);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(469);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(1129);
	
	var _PatternUtils = __webpack_require__(1131);
	
	var _InternalPropTypes = __webpack_require__(1145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(1133);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(469);
	
	var _routerWarning = __webpack_require__(1136);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(1129);
	
	var _InternalPropTypes = __webpack_require__(1145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(1133);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(469);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(1129);
	
	var _InternalPropTypes = __webpack_require__(1145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(1158);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(1159);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(1135);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(1129);
	
	var _RouterUtils = __webpack_require__(1149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(1160);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(1166);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1167);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(1161);
	
	var _runTransitionHook = __webpack_require__(1163);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(1164);
	
	var _PathUtils = __webpack_require__(1165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1162);
	var objectAssign = __webpack_require__(302);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
	
					key = key.replace(/\[\]$/, '');
	
					if (!result || accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(1137);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(1137);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(1165);
	
	var _Actions = __webpack_require__(1158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(1137);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(1163);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(1165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(1137);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(1164);
	
	var _PathUtils = __webpack_require__(1165);
	
	var _createHistory = __webpack_require__(1168);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(1158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(1169);
	
	var _PathUtils = __webpack_require__(1165);
	
	var _runTransitionHook = __webpack_require__(1163);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(1158);
	
	var _LocationUtils = __webpack_require__(1164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(1160);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(1166);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(1146);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(1136);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1173);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(1179);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(1174);
	
	var _BrowserProtocol = __webpack_require__(1175);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(1178);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(1176);
	
	var _createHistory = __webpack_require__(1168);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(1164);
	
	var _DOMUtils = __webpack_require__(1176);
	
	var _DOMStateStorage = __webpack_require__(1177);
	
	var _PathUtils = __webpack_require__(1165);
	
	var _ExecutionEnvironment = __webpack_require__(1174);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(1137);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(1175);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(1164);
	
	var _PathUtils = __webpack_require__(1165);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(1170);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(1181);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(1179);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(1137);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(1174);
	
	var _DOMUtils = __webpack_require__(1176);
	
	var _HashProtocol = __webpack_require__(1182);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(1168);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(1175);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(1137);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(1164);
	
	var _DOMUtils = __webpack_require__(1176);
	
	var _DOMStateStorage = __webpack_require__(1177);
	
	var _PathUtils = __webpack_require__(1165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.Actions = exports.useQueries = exports.useBeforeUnload = exports.useBasename = exports.createMemoryHistory = exports.createHashHistory = exports.createHistory = undefined;
	
	var _LocationUtils = __webpack_require__(1164);
	
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _createBrowserHistory = __webpack_require__(1173);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createHashHistory2 = __webpack_require__(1181);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(1167);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	var _useBasename2 = __webpack_require__(1166);
	
	var _useBasename3 = _interopRequireDefault(_useBasename2);
	
	var _useBeforeUnload2 = __webpack_require__(1184);
	
	var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);
	
	var _useQueries2 = __webpack_require__(1160);
	
	var _useQueries3 = _interopRequireDefault(_useQueries2);
	
	var _Actions2 = __webpack_require__(1158);
	
	var _Actions = _interopRequireWildcard(_Actions2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createHistory = _createBrowserHistory2.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;
	exports.useBasename = _useBasename3.default;
	exports.useBeforeUnload = _useBeforeUnload3.default;
	exports.useQueries = _useQueries3.default;
	exports.Actions = _Actions;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(475);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _DOMUtils = __webpack_require__(1176);
	
	var _ExecutionEnvironment = __webpack_require__(1174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var startListener = function startListener(getPromptMessage) {
	  var handleBeforeUnload = function handleBeforeUnload(event) {
	    var message = getPromptMessage();
	
	    if (typeof message === 'string') {
	      (event || window.event).returnValue = message;
	      return message;
	    }
	
	    return undefined;
	  };
	
	  (0, _DOMUtils.addEventListener)(window, 'beforeunload', handleBeforeUnload);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, 'beforeunload', handleBeforeUnload);
	  };
	};
	
	/**
	 * Returns a new createHistory function that can be used to create
	 * history objects that know how to use the beforeunload event in web
	 * browsers to cancel navigation.
	 */
	var useBeforeUnload = function useBeforeUnload(createHistory) {
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'useBeforeUnload only works in DOM environments') : (0, _invariant2.default)(false) : void 0;
	
	  return function (options) {
	    var history = createHistory(options);
	
	    var listeners = [];
	    var stopListener = void 0;
	
	    var getPromptMessage = function getPromptMessage() {
	      var message = void 0;
	      for (var i = 0, len = listeners.length; message == null && i < len; ++i) {
	        message = listeners[i].call();
	      }return message;
	    };
	
	    var listenBeforeUnload = function listenBeforeUnload(listener) {
	      if (listeners.push(listener) === 1) stopListener = startListener(getPromptMessage);
	
	      return function () {
	        listeners = listeners.filter(function (item) {
	          return item !== listener;
	        });
	
	        if (listeners.length === 0 && stopListener) {
	          stopListener();
	          stopListener = null;
	        }
	      };
	    };
	
	    return _extends({}, history, {
	      listenBeforeUnload: listenBeforeUnload
	    });
	  };
	};
	
	exports.default = useBeforeUnload;

/***/ }),
/* 1185 */,
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmbedFrame = __webpack_require__(1187);
	
	var _EmbedFrame2 = _interopRequireDefault(_EmbedFrame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PublicNotFound = function PublicNotFound() {
	    return _react2.default.createElement(
	        _EmbedFrame2.default,
	        { className: "spread" },
	        _react2.default.createElement(
	            "div",
	            { className: "flex layout-centered flex-full flex-column" },
	            _react2.default.createElement("div", { className: "QueryError-image QueryError-image--noRows" }),
	            _react2.default.createElement(
	                "div",
	                { className: "mt1 h4 sm-h3 md-h2 text-bold" },
	                "Not found"
	            )
	        )
	    );
	};
	
	PublicNotFound.displayName = "PublicNotFound";
	exports.default = PublicNotFound;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _dom = __webpack_require__(859);
	
	var _browser = __webpack_require__(1188);
	
	var _Parameters = __webpack_require__(1189);
	
	var _Parameters2 = _interopRequireDefault(_Parameters);
	
	var _LogoBadge = __webpack_require__(1204);
	
	var _LogoBadge2 = _interopRequireDefault(_LogoBadge);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(1206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_OPTIONS = {
	    bordered: _dom.IFRAMED,
	    titled: true
	};
	
	var EmbedFrame = (0, _reactRouter.withRouter)(_class = function (_Component) {
	    _inherits(EmbedFrame, _Component);
	
	    function EmbedFrame() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, EmbedFrame);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmbedFrame.__proto__ || Object.getPrototypeOf(EmbedFrame)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            innerScroll: true
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(EmbedFrame, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            if (window.iFrameResizer) {
	                console.error("iFrameResizer resizer already defined.");
	            } else {
	                window.iFrameResizer = {
	                    autoResize: true,
	                    heightCalculationMethod: "bodyScroll",
	                    readyCallback: function readyCallback() {
	                        _this2.setState({ innerScroll: false });
	                    }
	                };
	                // $FlowFixMe: flow doesn't know about require.ensure
	                __webpack_require__(1208).ensure && __webpack_require__.e/* nsure */(2, function () {
	                    __webpack_require__(1267);
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                children = _props.children,
	                actionButtons = _props.actionButtons,
	                location = _props.location,
	                parameters = _props.parameters,
	                parameterValues = _props.parameterValues,
	                setParameterValue = _props.setParameterValue;
	            var innerScroll = this.state.innerScroll;
	
	
	            var footer = true;
	
	            var _DEFAULT_OPTIONS$pars = _extends({}, DEFAULT_OPTIONS, (0, _browser.parseHashOptions)(location.hash)),
	                bordered = _DEFAULT_OPTIONS$pars.bordered,
	                titled = _DEFAULT_OPTIONS$pars.titled,
	                theme = _DEFAULT_OPTIONS$pars.theme;
	
	            var name = titled ? this.props.name : null;
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("EmbedFrame flex flex-column", className, _defineProperty({
	                        "spread": innerScroll,
	                        "bordered rounded shadowed": bordered
	                    }, "Theme--" + theme, !!theme)) },
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)("flex flex-column flex-full relative", { "scroll-y": innerScroll }) },
	                    name || parameters && parameters.length > 0 ? _react2.default.createElement(
	                        "div",
	                        { className: "EmbedFrame-header flex align-center p1 sm-p2 lg-p3" },
	                        name && _react2.default.createElement(
	                            "div",
	                            { className: "h4 text-bold sm-h3 md-h2" },
	                            name
	                        ),
	                        parameters && parameters.length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "flex ml-auto" },
	                            _react2.default.createElement(_Parameters2.default, {
	                                parameters: parameters.map(function (p) {
	                                    return _extends({}, p, { value: parameterValues && parameterValues[p.id] });
	                                }),
	                                query: location.query,
	                                setParameterValue: setParameterValue,
	                                syncQueryString: true,
	                                isQB: true
	                            })
	                        ) : null
	                    ) : null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex flex-column relative full flex-full" },
	                        children
	                    )
	                ),
	                footer && _react2.default.createElement(
	                    "div",
	                    { className: "EmbedFrame-footer p1 md-p2 lg-p3 border-top flex-no-shrink flex align-center" },
	                    _react2.default.createElement(_LogoBadge2.default, { dark: theme }),
	                    actionButtons && _react2.default.createElement(
	                        "div",
	                        { className: "flex-align-right text-grey-3" },
	                        actionButtons
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EmbedFrame;
	}(_react.Component)) || _class;
	
	EmbedFrame.displayName = "EmbedFrame";
	exports.default = EmbedFrame;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseHashOptions = parseHashOptions;
	exports.stringifyHashOptions = stringifyHashOptions;
	exports.updateQueryString = updateQueryString;
	
	var _querystring = __webpack_require__(585);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseHashOptions(hash) {
	    var options = _querystring2.default.parse(hash.replace(/^#/, ""));
	    for (var name in options) {
	        if (options[name] === "") {
	            options[name] = true;
	        } else if (/^(true|false|-?\d+(\.\d+)?)$/.test(options[name])) {
	            options[name] = JSON.parse(options[name]);
	        }
	    }
	    return options;
	}
	
	function stringifyHashOptions(options) {
	    return _querystring2.default.stringify(options).replace(/=true\b/g, "");
	}
	
	function updateQueryString(location, optionsUpdater) {
	    var currentOptions = parseHashOptions(location.search.substring(1));
	    var queryString = stringifyHashOptions(optionsUpdater(currentOptions));
	
	    return {
	        pathname: location.pathname,
	        hash: location.hash,
	        search: queryString ? "?" + queryString : null
	    };
	}

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ParameterWidget = __webpack_require__(1190);
	
	var _ParameterWidget2 = _interopRequireDefault(_ParameterWidget);
	
	var _querystring = __webpack_require__(585);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Parameters = function (_Component) {
	    _inherits(Parameters, _Component);
	
	    function Parameters() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Parameters);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Parameters.__proto__ || Object.getPrototypeOf(Parameters)).call.apply(_ref, [this].concat(args))), _this), _this.defaultProps = {
	            syncQueryString: false,
	            vertical: false,
	            commitImmediately: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Parameters, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            // sync parameters from URL query string
	            var _props = this.props,
	                parameters = _props.parameters,
	                setParameterValue = _props.setParameterValue,
	                query = _props.query;
	
	            if (setParameterValue) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = parameters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var parameter = _step.value;
	
	                        if (query && query[parameter.slug] != null) {
	                            setParameterValue(parameter.id, query[parameter.slug]);
	                        } else if (parameter.default != null) {
	                            setParameterValue(parameter.id, parameter.default);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            if (this.props.syncQueryString) {
	                // sync parameters to URL query string
	                var queryParams = {};
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = this._parametersWithValues()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var parameter = _step2.value;
	
	                        if (parameter.value) {
	                            queryParams[parameter.slug] = parameter.value;
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	
	                var search = _querystring2.default.stringify(queryParams);
	                search = search ? "?" + search : "";
	
	                if (search !== window.location.search) {
	                    history.replaceState(null, document.title, window.location.pathname + search + window.location.hash);
	                }
	            }
	        }
	    }, {
	        key: "_parametersWithValues",
	        value: function _parametersWithValues() {
	            var _props2 = this.props,
	                parameters = _props2.parameters,
	                parameterValues = _props2.parameterValues;
	
	            if (parameterValues) {
	                return parameters.map(function (p) {
	                    return _extends({}, p, {
	                        value: parameterValues[p.id]
	                    });
	                });
	            } else {
	                return parameters;
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props3 = this.props,
	                className = _props3.className,
	                editingParameter = _props3.editingParameter,
	                setEditingParameter = _props3.setEditingParameter,
	                isEditing = _props3.isEditing,
	                isFullscreen = _props3.isFullscreen,
	                isNightMode = _props3.isNightMode,
	                isQB = _props3.isQB,
	                setParameterName = _props3.setParameterName,
	                setParameterValue = _props3.setParameterValue,
	                setParameterDefaultValue = _props3.setParameterDefaultValue,
	                removeParameter = _props3.removeParameter,
	                vertical = _props3.vertical,
	                commitImmediately = _props3.commitImmediately;
	
	
	            var parameters = this._parametersWithValues();
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(className, "flex align-end flex-wrap", vertical ? "flex-column" : "flex-row", { "mt1": isQB }) },
	                parameters.map(function (parameter) {
	                    return _react2.default.createElement(_ParameterWidget2.default, {
	                        className: vertical ? "mb2" : null,
	                        key: parameter.id,
	
	                        isEditing: isEditing,
	                        isFullscreen: isFullscreen,
	                        isNightMode: isNightMode,
	
	                        parameter: parameter,
	                        parameters: parameters,
	
	                        editingParameter: editingParameter,
	                        setEditingParameter: setEditingParameter,
	
	                        setName: setParameterName && function (name) {
	                            return setParameterName(parameter.id, name);
	                        },
	                        setValue: setParameterValue && function (value) {
	                            return setParameterValue(parameter.id, value);
	                        },
	                        setDefaultValue: setParameterDefaultValue && function (value) {
	                            return setParameterDefaultValue(parameter.id, value);
	                        },
	                        remove: removeParameter && function () {
	                            return removeParameter(parameter.id);
	                        },
	
	                        commitImmediately: commitImmediately
	                    });
	                })
	            );
	        }
	    }]);
	
	    return Parameters;
	}(_react.Component);
	
	Parameters.displayName = "Parameters";
	exports.default = Parameters;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ParameterValueWidget = __webpack_require__(1191);
	
	var _ParameterValueWidget2 = _interopRequireDefault(_ParameterValueWidget);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ParameterWidget = __webpack_require__(1201);
	
	var _ParameterWidget2 = _interopRequireDefault(_ParameterWidget);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _FieldSet = __webpack_require__(1006);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _keyboard = __webpack_require__(934);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParameterWidget = (_temp2 = _class = function (_Component) {
	    _inherits(ParameterWidget, _Component);
	
	    function ParameterWidget() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ParameterWidget);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParameterWidget.__proto__ || Object.getPrototypeOf(ParameterWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isEditingName: false,
	            isFocused: false
	        }, _this.focusChanged = function (isFocused) {
	            _this.setState({ isFocused: isFocused });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ParameterWidget, [{
	        key: "renderPopover",
	        value: function renderPopover(value, setValue, placeholder, isFullscreen) {
	            var _props = this.props,
	                parameter = _props.parameter,
	                editingParameter = _props.editingParameter,
	                commitImmediately = _props.commitImmediately;
	
	            var isEditingParameter = !!(editingParameter && editingParameter.id === parameter.id);
	            return _react2.default.createElement(_ParameterValueWidget2.default, {
	                parameter: parameter,
	                name: name,
	                value: value,
	                setValue: setValue,
	                isEditing: isEditingParameter,
	                placeholder: placeholder,
	                focusChanged: this.focusChanged,
	                isFullscreen: isFullscreen,
	                commitImmediately: commitImmediately
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                className = _props2.className,
	                parameter = _props2.parameter,
	                parameters = _props2.parameters,
	                isEditing = _props2.isEditing,
	                isFullscreen = _props2.isFullscreen,
	                editingParameter = _props2.editingParameter,
	                setEditingParameter = _props2.setEditingParameter,
	                setName = _props2.setName,
	                setValue = _props2.setValue,
	                setDefaultValue = _props2.setDefaultValue,
	                remove = _props2.remove;
	
	
	            var isEditingDashboard = isEditing;
	            var isEditingParameter = editingParameter && editingParameter.id === parameter.id;
	
	            var renderFieldInNormalMode = function renderFieldInNormalMode() {
	                var fieldHasValueOrFocus = parameter.value != null || _this2.state.isFocused;
	                var legend = fieldHasValueOrFocus ? parameter.name : "";
	
	                return _react2.default.createElement(
	                    _FieldSet2.default,
	                    { legend: legend, noPadding: true,
	                        className: (0, _classnames2.default)(className, _ParameterWidget2.default.container, { "border-brand": fieldHasValueOrFocus }) },
	                    _this2.renderPopover(parameter.value, function (value) {
	                        return setValue(value);
	                    }, parameter.name, isFullscreen)
	                );
	            };
	
	            var renderEditFieldNameUI = function renderEditFieldNameUI() {
	                return _react2.default.createElement(
	                    _FieldSet2.default,
	                    { legend: "", noPadding: true, className: (0, _classnames2.default)(className, _ParameterWidget2.default.container) },
	                    _react2.default.createElement("input", {
	                        type: "text",
	                        className: (0, _classnames2.default)(_ParameterWidget2.default.nameInput, { "border-error": _underscore2.default.any(parameters, function (p) {
	                                return p.name === parameter.name && p.id !== parameter.id;
	                            }) }),
	                        value: parameter.name,
	                        onChange: function onChange(e) {
	                            return setName(e.target.value);
	                        },
	                        onBlur: function onBlur() {
	                            return _this2.setState({ isEditingName: false });
	                        },
	                        onKeyUp: function onKeyUp(e) {
	                            if (e.keyCode === _keyboard.KEYCODE_ESCAPE || e.keyCode === _keyboard.KEYCODE_ENTER) {
	                                e.target.blur();
	                            }
	                        },
	                        autoFocus: true
	                    })
	                );
	            };
	
	            var renderSetDefaultFieldValueUI = function renderSetDefaultFieldValueUI() {
	                var editNameButton = _react2.default.createElement(
	                    "span",
	                    { className: _ParameterWidget2.default.editNameIconContainer },
	                    _react2.default.createElement(_Icon2.default, { name: "pencil", size: 12, className: "text-brand cursor-pointer",
	                        onClick: function onClick() {
	                            return _this2.setState({ isEditingName: true });
	                        } })
	                );
	
	                var legend = _react2.default.createElement(
	                    "span",
	                    null,
	                    parameter.name,
	                    " ",
	                    editNameButton
	                );
	
	                return _react2.default.createElement(
	                    _FieldSet2.default,
	                    { legend: legend, noPadding: true, className: (0, _classnames2.default)(className, _ParameterWidget2.default.container) },
	                    _this2.renderPopover(parameter.default, function (value) {
	                        return setDefaultValue(value);
	                    }, parameter.name, isFullscreen)
	                );
	            };
	
	            var renderFieldEditingButtons = function renderFieldEditingButtons() {
	                return _react2.default.createElement(
	                    _FieldSet2.default,
	                    { legend: parameter.name, noPadding: true, className: (0, _classnames2.default)(className, _ParameterWidget2.default.container) },
	                    _react2.default.createElement(
	                        "div",
	                        { className: (0, _classnames2.default)(_ParameterWidget2.default.parameter, _ParameterWidget2.default.parameterButtons) },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _ParameterWidget2.default.editButton, onClick: function onClick() {
	                                    return setEditingParameter(parameter.id);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { name: "pencil" }),
	                            _react2.default.createElement(
	                                "span",
	                                { className: "ml1" },
	                                "Edit"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _ParameterWidget2.default.removeButton, onClick: function onClick() {
	                                    return remove();
	                                } },
	                            _react2.default.createElement(_Icon2.default, { name: "close" }),
	                            _react2.default.createElement(
	                                "span",
	                                { className: "ml1" },
	                                "Remove"
	                            )
	                        )
	                    )
	                );
	            };
	
	            if (isFullscreen) {
	                if (parameter.value != null) {
	                    return _react2.default.createElement(
	                        "div",
	                        { style: { fontSize: "0.833em" } },
	                        renderFieldInNormalMode()
	                    );
	                } else {
	                    return _react2.default.createElement("span", { className: "hide" });
	                }
	            } else if (!isEditingDashboard) {
	                return renderFieldInNormalMode();
	            } else if (isEditingParameter) {
	                if (this.state.isEditingName) {
	                    return renderEditFieldNameUI();
	                } else {
	                    return renderSetDefaultFieldValueUI();
	                }
	            } else {
	                return renderFieldEditingButtons();
	            }
	        }
	    }]);
	
	    return ParameterWidget;
	}(_react.Component), _class.propTypes = {
	    parameter: _propTypes2.default.object,
	    commitImmediately: _propTypes2.default.bool
	}, _class.defaultProps = {
	    parameter: null,
	    commitImmediately: false
	}, _temp2);
	ParameterWidget.displayName = "ParameterWidget";
	exports.default = ParameterWidget;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2; /* eslint "react/prop-types": "warn" */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DateSingleWidget = __webpack_require__(1192);
	
	var _DateSingleWidget2 = _interopRequireDefault(_DateSingleWidget);
	
	var _DateRangeWidget = __webpack_require__(1193);
	
	var _DateRangeWidget2 = _interopRequireDefault(_DateRangeWidget);
	
	var _DateRelativeWidget = __webpack_require__(1194);
	
	var _DateRelativeWidget2 = _interopRequireDefault(_DateRelativeWidget);
	
	var _DateMonthYearWidget = __webpack_require__(1195);
	
	var _DateMonthYearWidget2 = _interopRequireDefault(_DateMonthYearWidget);
	
	var _DateQuarterYearWidget = __webpack_require__(1197);
	
	var _DateQuarterYearWidget2 = _interopRequireDefault(_DateQuarterYearWidget);
	
	var _DateAllOptionsWidget = __webpack_require__(1198);
	
	var _DateAllOptionsWidget2 = _interopRequireDefault(_DateAllOptionsWidget);
	
	var _CategoryWidget = __webpack_require__(1199);
	
	var _CategoryWidget2 = _interopRequireDefault(_CategoryWidget);
	
	var _TextWidget = __webpack_require__(1200);
	
	var _TextWidget2 = _interopRequireDefault(_TextWidget);
	
	var _ParameterWidget = __webpack_require__(1201);
	
	var _ParameterWidget2 = _interopRequireDefault(_ParameterWidget);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _metadata = __webpack_require__(1110);
	
	var _metadata2 = __webpack_require__(1073);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DATE_WIDGETS = {
	    "date/single": _DateSingleWidget2.default,
	    "date/range": _DateRangeWidget2.default,
	    "date/relative": _DateRelativeWidget2.default,
	    "date/month-year": _DateMonthYearWidget2.default,
	    "date/quarter-year": _DateQuarterYearWidget2.default,
	    "date/all-options": _DateAllOptionsWidget2.default
	};
	
	var makeMapStateToProps = function makeMapStateToProps() {
	    var getMergedParameterFieldValues = (0, _metadata2.makeGetMergedParameterFieldValues)();
	    var mapStateToProps = function mapStateToProps(state, props) {
	        return {
	            values: getMergedParameterFieldValues(state, props)
	        };
	    };
	    return mapStateToProps;
	};
	
	var mapDispatchToProps = {
	    fetchFieldValues: _metadata.fetchFieldValues
	};
	
	var ParameterValueWidget = (_dec = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_Component) {
	    _inherits(ParameterValueWidget, _Component);
	
	    function ParameterValueWidget() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ParameterValueWidget);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParameterValueWidget.__proto__ || Object.getPrototypeOf(ParameterValueWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isFocused: false }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ParameterValueWidget, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            // In public dashboards we receive field values before mounting this component and
	            // without need to call `fetchFieldValues` separately
	            if (_underscore2.default.isEmpty(this.props.values)) {
	                this.updateFieldValues(this.props);
	            }
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.parameter.field_id != null && nextProps.parameter.field_id !== this.props.parameter.field_id) {
	                this.updateFieldValues(nextProps);
	            }
	        }
	    }, {
	        key: "updateFieldValues",
	        value: function updateFieldValues(props) {
	            if (props.parameter.field_id != null) {
	                props.fetchFieldValues(props.parameter.field_id);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                parameter = _props.parameter,
	                value = _props.value,
	                values = _props.values,
	                setValue = _props.setValue,
	                isEditing = _props.isEditing,
	                placeholder = _props.placeholder,
	                isFullscreen = _props.isFullscreen,
	                noReset = _props.noReset,
	                commitImmediately = _props.commitImmediately,
	                className = _props.className,
	                parentFocusChanged = _props.focusChanged;
	
	
	            var hasValue = value != null;
	
	            var Widget = ParameterValueWidget.getWidget(parameter, values);
	
	            var focusChanged = function focusChanged(isFocused) {
	                if (parentFocusChanged) {
	                    parentFocusChanged(isFocused);
	                }
	                _this2.setState({ isFocused: isFocused });
	            };
	
	            var getParameterTypeIcon = function getParameterTypeIcon() {
	                if (!isEditing && !hasValue && !_this2.state.isFocused) {
	                    return _react2.default.createElement(_Icon2.default, { name: ParameterValueWidget.getParameterIconName(parameter.type), className: "flex-align-left mr1 flex-no-shrink", size: 14 });
	                } else {
	                    return null;
	                }
	            };
	
	            var getWidgetStatusIcon = function getWidgetStatusIcon() {
	                if (isFullscreen) return null;
	
	                if (hasValue && !noReset) {
	                    return _react2.default.createElement(_Icon2.default, { name: "close", className: "flex-align-right cursor-pointer flex-no-shrink", size: 12, onClick: function onClick(e) {
	                            if (hasValue) {
	                                e.stopPropagation();
	                                setValue(null);
	                            }
	                        } });
	                } else if (Widget.noPopover && _this2.state.isFocused) {
	                    return _react2.default.createElement(_Icon2.default, { name: "enterorreturn", className: "flex-align-right flex-no-shrink", size: 12 });
	                } else if (Widget.noPopover) {
	                    return _react2.default.createElement(_Icon2.default, { name: "empty", className: "flex-align-right cursor-pointer flex-no-shrink", size: 12 });
	                } else if (!Widget.noPopover) {
	                    return _react2.default.createElement(_Icon2.default, { name: "chevrondown", className: "flex-align-right flex-no-shrink", size: 12 });
	                }
	            };
	
	            if (Widget.noPopover) {
	                var _cx;
	
	                return _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)(_ParameterWidget2.default.parameter, _ParameterWidget2.default.noPopover, className, (_cx = {}, _defineProperty(_cx, _ParameterWidget2.default.selected, hasValue), _defineProperty(_cx, _ParameterWidget2.default.isEditing, isEditing), _cx)) },
	                    getParameterTypeIcon(),
	                    _react2.default.createElement(Widget, { placeholder: placeholder, value: value, values: values, setValue: setValue,
	                        isEditing: isEditing, commitImmediately: commitImmediately, focusChanged: focusChanged }),
	                    getWidgetStatusIcon()
	                );
	            } else {
	                var placeholderText = isEditing ? "Select a default value…" : placeholder || "Select…";
	
	                return _react2.default.createElement(
	                    _PopoverWithTrigger2.default,
	                    {
	                        ref: "valuePopover",
	                        triggerElement: _react2.default.createElement(
	                            "div",
	                            { ref: "trigger", className: (0, _classnames2.default)(_ParameterWidget2.default.parameter, className, _defineProperty({}, _ParameterWidget2.default.selected, hasValue)) },
	                            getParameterTypeIcon(),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "mr1 text-nowrap" },
	                                hasValue ? Widget.format(value, values) : placeholderText
	                            ),
	                            getWidgetStatusIcon()
	                        ),
	                        target: function target() {
	                            return _this2.refs.trigger;
	                        } // not sure why this is necessary
	                    },
	                    _react2.default.createElement(Widget, { value: value, values: values, setValue: setValue,
	                        onClose: function onClose() {
	                            return _this2.refs.valuePopover.close();
	                        } })
	                );
	            }
	        }
	    }], [{
	        key: "getWidget",
	        value: function getWidget(parameter, values) {
	            if (DATE_WIDGETS[parameter.type]) {
	                return DATE_WIDGETS[parameter.type];
	            } else if (values && values.length > 0) {
	                return _CategoryWidget2.default;
	            } else {
	                return _TextWidget2.default;
	            }
	        }
	    }, {
	        key: "getParameterIconName",
	        value: function getParameterIconName(parameterType) {
	            if (parameterType.search(/date/) !== -1) return "calendar";
	            if (parameterType.search(/location/) !== -1) return "location";
	            if (parameterType.search(/id/) !== -1) return "label";
	            return "clipboard";
	        }
	    }]);
	
	    return ParameterValueWidget;
	}(_react.Component), _class2.propTypes = {
	    parameter: _propTypes2.default.object.isRequired,
	    name: _propTypes2.default.string,
	    value: _propTypes2.default.any,
	    setValue: _propTypes2.default.func.isRequired,
	    placeholder: _propTypes2.default.string,
	    values: _propTypes2.default.array,
	    isEditing: _propTypes2.default.bool,
	    noReset: _propTypes2.default.bool,
	    commitImmediately: _propTypes2.default.bool,
	    focusChanged: _propTypes2.default.func,
	    isFullscreen: _propTypes2.default.bool,
	    className: _propTypes2.default.string
	}, _class2.defaultProps = {
	    values: [],
	    isEditing: false,
	    noReset: false,
	    commitImmediately: false,
	    className: ""
	}, _temp2)) || _class);
	ParameterValueWidget.displayName = "ParameterValueWidget";
	exports.default = ParameterValueWidget;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Calendar = __webpack_require__(991);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DateSingleWidget = function DateSingleWidget(_ref) {
	    var value = _ref.value,
	        setValue = _ref.setValue,
	        onClose = _ref.onClose;
	    return _react2.default.createElement(
	        "div",
	        { className: "p1" },
	        _react2.default.createElement(_Calendar2.default, {
	            initial: value ? (0, _moment2.default)(value) : null,
	            selected: value ? (0, _moment2.default)(value) : null,
	            selectedEnd: value ? (0, _moment2.default)(value) : null,
	            onChange: function onChange(value) {
	                setValue(value);onClose();
	            }
	        })
	    );
	};
	
	DateSingleWidget.displayName = "DateSingleWidget";
	DateSingleWidget.format = function (value) {
	    return value ? (0, _moment2.default)(value).format("MMMM D, YYYY") : "";
	};
	
	exports.default = DateSingleWidget;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Calendar = __webpack_require__(991);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEPARATOR = "~"; // URL-safe
	
	var DateRangeWidget = (_temp = _class = function (_Component) {
	    _inherits(DateRangeWidget, _Component);
	
	    function DateRangeWidget(props, context) {
	        _classCallCheck(this, DateRangeWidget);
	
	        var _this = _possibleConstructorReturn(this, (DateRangeWidget.__proto__ || Object.getPrototypeOf(DateRangeWidget)).call(this, props, context));
	
	        _this.state = {
	            start: null,
	            end: null
	        };
	        return _this;
	    }
	
	    _createClass(DateRangeWidget, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.componentWillReceiveProps(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            var _split = (nextProps.value || "").split(SEPARATOR),
	                _split2 = _slicedToArray(_split, 2),
	                start = _split2[0],
	                end = _split2[1];
	
	            this.setState({ start: start, end: end });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                start = _state.start,
	                end = _state.end;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "p1" },
	                _react2.default.createElement(_Calendar2.default, {
	                    initial: start ? (0, _moment2.default)(start) : null,
	                    selected: start ? (0, _moment2.default)(start) : null,
	                    selectedEnd: end ? (0, _moment2.default)(end) : null,
	                    onChange: function onChange(start, end) {
	                        if (end == null) {
	                            _this2.setState({ start: start, end: end });
	                        } else {
	                            _this2.props.setValue([start, end].join(SEPARATOR));
	                        }
	                    }
	                })
	            );
	        }
	    }]);
	
	    return DateRangeWidget;
	}(_react.Component), _class.propTypes = {}, _class.defaultProps = {}, _class.format = function (value) {
	    var _split3 = (value || "").split(SEPARATOR),
	        _split4 = _slicedToArray(_split3, 2),
	        start = _split4[0],
	        end = _split4[1];
	
	    return start && end ? (0, _moment2.default)(start).format("MMMM D, YYYY") + " - " + (0, _moment2.default)(end).format("MMMM D, YYYY") : "";
	}, _temp);
	DateRangeWidget.displayName = "DateRangeWidget";
	exports.default = DateRangeWidget;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.PredefinedRelativeDatePicker = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _class2, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SHORTCUTS = [{ name: "Today", operator: ["=", "<", ">"], values: [["relative-datetime", "current"]] }, { name: "Yesterday", operator: ["=", "<", ">"], values: [["relative-datetime", -1, "day"]] }, { name: "Past 7 days", operator: "time-interval", values: [-7, "day"] }, { name: "Past 30 days", operator: "time-interval", values: [-30, "day"] }];
	
	var RELATIVE_SHORTCUTS = {
	    "Last": [{ name: "Week", operator: "time-interval", values: ["last", "week"] }, { name: "Month", operator: "time-interval", values: ["last", "month"] }, { name: "Year", operator: "time-interval", values: ["last", "year"] }],
	    "This": [{ name: "Week", operator: "time-interval", values: ["current", "week"] }, { name: "Month", operator: "time-interval", values: ["current", "month"] }, { name: "Year", operator: "time-interval", values: ["current", "year"] }]
	};
	
	var PredefinedRelativeDatePicker = exports.PredefinedRelativeDatePicker = (_temp = _class = function (_Component) {
	    _inherits(PredefinedRelativeDatePicker, _Component);
	
	    function PredefinedRelativeDatePicker(props, context) {
	        _classCallCheck(this, PredefinedRelativeDatePicker);
	
	        var _this = _possibleConstructorReturn(this, (PredefinedRelativeDatePicker.__proto__ || Object.getPrototypeOf(PredefinedRelativeDatePicker)).call(this, props, context));
	
	        _underscore2.default.bindAll(_this, "isSelectedShortcut", "onSetShortcut");
	        return _this;
	    }
	
	    _createClass(PredefinedRelativeDatePicker, [{
	        key: "isSelectedShortcut",
	        value: function isSelectedShortcut(shortcut) {
	            var filter = this.props.filter;
	
	            return (Array.isArray(shortcut.operator) ? _underscore2.default.contains(shortcut.operator, filter[0]) : filter[0] === shortcut.operator) && _underscore2.default.isEqual(filter.slice(2), shortcut.values);
	        }
	    }, {
	        key: "onSetShortcut",
	        value: function onSetShortcut(shortcut) {
	            var filter = this.props.filter;
	
	            var operator = void 0;
	            if (Array.isArray(shortcut.operator)) {
	                if (_underscore2.default.contains(shortcut.operator, filter[0])) {
	                    operator = filter[0];
	                } else {
	                    operator = shortcut.operator[0];
	                }
	            } else {
	                operator = shortcut.operator;
	            }
	            this.props.onFilterChange([operator, filter[1]].concat(_toConsumableArray(shortcut.values)));
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "p1 pt2" },
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    SHORTCUTS.map(function (s, index) {
	                        return _react2.default.createElement(
	                            "span",
	                            { key: index, className: (0, _classnames2.default)("inline-block half pb1", { "pr1": index % 2 === 0 }) },
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    key: index,
	                                    className: (0, _classnames2.default)("Button Button-normal Button--medium text-normal text-centered full", { "Button--purple": _this2.isSelectedShortcut(s) }),
	                                    onClick: function onClick() {
	                                        return _this2.onSetShortcut(s);
	                                    }
	                                },
	                                s.name
	                            )
	                        );
	                    })
	                ),
	                Object.keys(RELATIVE_SHORTCUTS).map(function (sectionName) {
	                    return _react2.default.createElement(
	                        "section",
	                        { key: sectionName },
	                        _react2.default.createElement(
	                            "div",
	                            { style: {}, className: "border-bottom text-uppercase flex layout-centered mb2" },
	                            _react2.default.createElement(
	                                "h6",
	                                { style: { "position": "relative", "backgroundColor": "white", "top": "6px" }, className: "px2" },
	                                sectionName
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex" },
	                            RELATIVE_SHORTCUTS[sectionName].map(function (s, index) {
	                                return _react2.default.createElement(
	                                    "button",
	                                    {
	                                        key: index,
	                                        "data-ui-tag": "relative-date-shortcut-" + sectionName.toLowerCase() + "-" + s.name.toLowerCase(),
	                                        className: (0, _classnames2.default)("Button Button-normal Button--medium flex-full mb1", { "Button--purple": _this2.isSelectedShortcut(s), "mr1": index !== RELATIVE_SHORTCUTS[sectionName].length - 1 }),
	                                        onClick: function onClick() {
	                                            return _this2.onSetShortcut(s);
	                                        }
	                                    },
	                                    s.name
	                                );
	                            })
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return PredefinedRelativeDatePicker;
	}(_react.Component), _class.propTypes = {
	    filter: _propTypes2.default.array.isRequired,
	    onFilterChange: _propTypes2.default.func.isRequired
	}, _temp);
	PredefinedRelativeDatePicker.displayName = "PredefinedRelativeDatePicker";
	
	
	// HACK: easiest way to get working with RelativeDatePicker
	var FILTERS = {
	    "today": {
	        name: "Today",
	        mapping: ["=", null, ["relative-datetime", "current"]]
	    },
	    "yesterday": {
	        name: "Yesterday",
	        mapping: ["=", null, ["relative-datetime", -1, "day"]]
	    },
	    "past7days": {
	        name: "Past 7 Days",
	        mapping: ["time-interval", null, -7, "day"]
	    },
	    "past30days": {
	        name: "Past 30 Days",
	        mapping: ["time-interval", null, -30, "day"]
	    },
	    "lastweek": {
	        name: "Last Week",
	        mapping: ["time-interval", null, "last", "week"]
	    },
	    "lastmonth": {
	        name: "Last Month",
	        mapping: ["time-interval", null, "last", "month"]
	    },
	    "lastyear": {
	        name: "Last Year",
	        mapping: ["time-interval", null, "last", "year"]
	    },
	    "thisweek": {
	        name: "This Week",
	        mapping: ["time-interval", null, "current", "week"]
	    },
	    "thismonth": {
	        name: "This Month",
	        mapping: ["time-interval", null, "current", "month"]
	    },
	    "thisyear": {
	        name: "This Year",
	        mapping: ["time-interval", null, "current", "year"]
	    }
	};
	
	var DateRelativeWidget = (_temp2 = _class2 = function (_Component2) {
	    _inherits(DateRelativeWidget, _Component2);
	
	    function DateRelativeWidget(props, context) {
	        _classCallCheck(this, DateRelativeWidget);
	
	        var _this3 = _possibleConstructorReturn(this, (DateRelativeWidget.__proto__ || Object.getPrototypeOf(DateRelativeWidget)).call(this, props, context));
	
	        _this3.state = {};
	        return _this3;
	    }
	
	    _createClass(DateRelativeWidget, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                value = _props.value,
	                setValue = _props.setValue,
	                onClose = _props.onClose;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "px1", style: { maxWidth: 300 } },
	                _react2.default.createElement(PredefinedRelativeDatePicker, {
	                    filter: FILTERS[value] ? FILTERS[value].mapping : [null, null],
	                    onFilterChange: function onFilterChange(filter) {
	                        setValue(_underscore2.default.findKey(FILTERS, function (f) {
	                            return _underscore2.default.isEqual(f.mapping, filter);
	                        }));
	                        onClose();
	                    }
	                })
	            );
	        }
	    }]);
	
	    return DateRelativeWidget;
	}(_react.Component), _class2.propTypes = {}, _class2.defaultProps = {}, _class2.format = function (value) {
	    return FILTERS[value] ? FILTERS[value].name : "";
	}, _temp2);
	DateRelativeWidget.displayName = "DateRelativeWidget";
	exports.default = DateRelativeWidget;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _YearPicker = __webpack_require__(1196);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateMonthYearWidget = (_temp = _class = function (_Component) {
	    _inherits(DateMonthYearWidget, _Component);
	
	    function DateMonthYearWidget(props, context) {
	        _classCallCheck(this, DateMonthYearWidget);
	
	        var _this = _possibleConstructorReturn(this, (DateMonthYearWidget.__proto__ || Object.getPrototypeOf(DateMonthYearWidget)).call(this, props, context));
	
	        var initial = (0, _moment2.default)(_this.props.value, "YYYY-MM");
	        if (initial.isValid()) {
	            _this.state = {
	                month: initial.month(),
	                year: initial.year()
	            };
	        } else {
	            _this.state = {
	                month: null,
	                year: (0, _moment2.default)().year()
	            };
	        }
	        return _this;
	    }
	
	    _createClass(DateMonthYearWidget, [{
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            var _state = this.state,
	                month = _state.month,
	                year = _state.year;
	
	            if (month != null && year != null) {
	                var value = (0, _moment2.default)().year(year).month(month).format("YYYY-MM");
	                if (this.props.value !== value) {
	                    this.props.setValue(value);
	                }
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var onClose = this.props.onClose;
	            var _state2 = this.state,
	                month = _state2.month,
	                year = _state2.year;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "py2" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex flex-column align-center px1" },
	                    _react2.default.createElement(_YearPicker2.default, { value: year, onChange: function onChange(year) {
	                            return _this2.setState({ year: year });
	                        } })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex" },
	                    _react2.default.createElement(
	                        "ol",
	                        { className: "flex flex-column" },
	                        _underscore2.default.range(0, 6).map(function (m) {
	                            return _react2.default.createElement(Month, { key: m, month: m, selected: m === month, onClick: function onClick() {
	                                    return _this2.setState({ month: m }, onClose);
	                                } });
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "ol",
	                        { className: "flex flex-column" },
	                        _underscore2.default.range(6, 12).map(function (m) {
	                            return _react2.default.createElement(Month, { key: m, month: m, selected: m === month, onClick: function onClick() {
	                                    return _this2.setState({ month: m }, onClose);
	                                } });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DateMonthYearWidget;
	}(_react.Component), _class.propTypes = {}, _class.defaultProps = {}, _class.format = function (value) {
	    var m = (0, _moment2.default)(value, "YYYY-MM");
	    return m.isValid() ? m.format("MMMM, YYYY") : "";
	}, _temp);
	DateMonthYearWidget.displayName = "DateMonthYearWidget";
	exports.default = DateMonthYearWidget;
	
	
	var Month = function Month(_ref) {
	    var month = _ref.month,
	        selected = _ref.selected,
	        onClick = _ref.onClick;
	    return _react2.default.createElement(
	        "li",
	        {
	            className: (0, _classnames2.default)("cursor-pointer px3 py1 text-bold text-brand-hover", { "text-brand": selected }),
	            onClick: onClick
	        },
	        (0, _moment2.default)().month(month).format("MMMM")
	    );
	};
	Month.displayName = "Month";

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YEARS = _underscore2.default.range(new Date().getFullYear(), 1900, -1);
	
	var YearPicker = function YearPicker(_ref) {
	    var value = _ref.value,
	        onChange = _ref.onChange;
	    return _react2.default.createElement(_Select2.default, {
	        className: "borderless",
	        value: value,
	        options: YEARS,
	        optionNameFn: function optionNameFn(option) {
	            return option;
	        },
	        optionValueFn: function optionValueFn(option) {
	            return option;
	        },
	        onChange: onChange
	    });
	};
	
	YearPicker.displayName = "YearPicker";
	exports.default = YearPicker;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _YearPicker = __webpack_require__(1196);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateQuarterYearWidget = (_temp = _class = function (_Component) {
	    _inherits(DateQuarterYearWidget, _Component);
	
	    function DateQuarterYearWidget(props, context) {
	        _classCallCheck(this, DateQuarterYearWidget);
	
	        var _this = _possibleConstructorReturn(this, (DateQuarterYearWidget.__proto__ || Object.getPrototypeOf(DateQuarterYearWidget)).call(this, props, context));
	
	        var initial = (0, _moment2.default)(_this.props.value, "[Q]Q-YYYY");
	        if (initial.isValid()) {
	            _this.state = {
	                quarter: initial.quarter(),
	                year: initial.year()
	            };
	        } else {
	            _this.state = {
	                quarter: null,
	                year: (0, _moment2.default)().year()
	            };
	        }
	        return _this;
	    }
	
	    _createClass(DateQuarterYearWidget, [{
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            var _state = this.state,
	                quarter = _state.quarter,
	                year = _state.year;
	
	            if (quarter != null && year != null) {
	                var value = (0, _moment2.default)().year(year).quarter(quarter).format("[Q]Q-YYYY");
	                if (this.props.value !== value) {
	                    this.props.setValue(value);
	                }
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var onClose = this.props.onClose;
	            var _state2 = this.state,
	                quarter = _state2.quarter,
	                year = _state2.year;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "py2" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex flex-column align-center px1" },
	                    _react2.default.createElement(_YearPicker2.default, { value: year, onChange: function onChange(year) {
	                            return _this2.setState({ year: year });
	                        } })
	                ),
	                _react2.default.createElement(
	                    "ol",
	                    { className: "flex flex-wrap bordered mx2 text-bold rounded", style: { width: 150 } },
	                    _underscore2.default.range(1, 5).map(function (q) {
	                        return _react2.default.createElement(Quarter, { quarter: q, selected: q === quarter, onClick: function onClick() {
	                                return _this2.setState({ quarter: q }, onClose);
	                            } });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return DateQuarterYearWidget;
	}(_react.Component), _class.propTypes = {}, _class.defaultProps = {}, _class.format = function (value) {
	    var m = (0, _moment2.default)(value, "[Q]Q-YYYY");
	    return m.isValid() ? m.format("[Q]Q, YYYY") : "";
	}, _temp);
	DateQuarterYearWidget.displayName = "DateQuarterYearWidget";
	exports.default = DateQuarterYearWidget;
	
	
	var Quarter = function Quarter(_ref) {
	    var quarter = _ref.quarter,
	        selected = _ref.selected,
	        onClick = _ref.onClick;
	    return _react2.default.createElement(
	        "li",
	        {
	            className: (0, _classnames2.default)("cursor-pointer bg-brand-hover text-white-hover flex layout-centered", { "bg-brand text-white": selected }),
	            style: { width: 75, height: 75 },
	            onClick: onClick
	        },
	        (0, _moment2.default)().quarter(quarter).format("[Q]Q")
	    );
	};
	Quarter.displayName = "Quarter";

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DatePicker = __webpack_require__(989);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	var _query_time = __webpack_require__(944);
	
	var _Parameter = __webpack_require__(958);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Use a placeholder value as field references are not used in dashboard filters
	// $FlowFixMe
	var noopRef = null;
	
	function getFilterValueSerializer(func) {
	    // $FlowFixMe
	    return function (filter) {
	        return func(filter[2], filter[3]);
	    };
	}
	
	var serializersByOperatorName = {
	    // $FlowFixMe
	    "Previous": getFilterValueSerializer(function (value, unit) {
	        return "past" + -value + unit + "s";
	    }),
	    "Next": getFilterValueSerializer(function (value, unit) {
	        return "next" + value + unit + "s";
	    }),
	    "Current": getFilterValueSerializer(function (_, unit) {
	        return "this" + unit;
	    }),
	    "Before": getFilterValueSerializer(function (value) {
	        return "~" + value;
	    }),
	    "After": getFilterValueSerializer(function (value) {
	        return value + "~";
	    }),
	    "On": getFilterValueSerializer(function (value) {
	        return "" + value;
	    }),
	    "Between": getFilterValueSerializer(function (from, to) {
	        return from + "~" + to;
	    })
	};
	
	function getFilterOperator(filter) {
	    return _DatePicker.DATE_OPERATORS.find(function (op) {
	        return op.test(filter);
	    });
	}
	function filterToUrlEncoded(filter) {
	    var operator = getFilterOperator(filter);
	
	    if (operator) {
	        return serializersByOperatorName[operator.name](filter);
	    } else {
	        return null;
	    }
	}
	
	var prefixedOperators = ["Before", "After", "On", "Is Empty", "Not Empty"];
	function getFilterTitle(filter) {
	    var desc = (0, _query_time.generateTimeFilterValuesDescriptions)(filter).join(" - ");
	    var op = getFilterOperator(filter);
	    var prefix = op && prefixedOperators.indexOf(op.name) !== -1 ? op.name + " " : "";
	    return prefix + desc;
	}
	
	var DateAllOptionsWidget = (_temp = _class = function (_Component) {
	    _inherits(DateAllOptionsWidget, _Component);
	
	    function DateAllOptionsWidget(props) {
	        _classCallCheck(this, DateAllOptionsWidget);
	
	        var _this = _possibleConstructorReturn(this, (DateAllOptionsWidget.__proto__ || Object.getPrototypeOf(DateAllOptionsWidget)).call(this, props));
	
	        _this.commitAndClose = function () {
	            _this.props.setValue(filterToUrlEncoded(_this.state.filter));
	            _this.props.onClose();
	        };
	
	        _this.setFilter = function (filter) {
	            _this.setState({ filter: filter });
	        };
	
	        _this.state = {
	            // $FlowFixMe
	            filter: props.value != null ? (0, _Parameter.dateParameterValueToMBQL)(props.value, noopRef) || [] : []
	        };
	        return _this;
	    }
	
	    _createClass(DateAllOptionsWidget, [{
	        key: "isValid",
	        value: function isValid() {
	            var filterValues = this.state.filter.slice(2);
	            return filterValues.every(function (value) {
	                return value != null;
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { style: { minWidth: "300px" } },
	                _react2.default.createElement(_DatePicker2.default, {
	                    filter: this.state.filter,
	                    onFilterChange: this.setFilter,
	                    hideEmptinessOperators: true,
	                    hideTimeSelectors: true
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "FilterPopover-footer p1" },
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: (0, _classnames2.default)("Button Button--purple full", { "disabled": !this.isValid() }),
	                            onClick: this.commitAndClose
	                        },
	                        "Update filter"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DateAllOptionsWidget;
	}(_react.Component), _class.propTypes = {}, _class.defaultProps = {}, _class.format = function (urlEncoded) {
	    if (urlEncoded == null) return null;
	    var filter = (0, _Parameter.dateParameterValueToMBQL)(urlEncoded, noopRef);
	
	    return filter ? getFilterTitle(filter) : null;
	}, _temp);
	DateAllOptionsWidget.displayName = "DateAllOptionsWidget";
	exports.default = DateAllOptionsWidget;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	/* eslint "react/prop-types": "warn" */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _string = __webpack_require__(955);
	
	var _field = __webpack_require__(869);
	
	var _ListSearchField = __webpack_require__(978);
	
	var _ListSearchField2 = _interopRequireDefault(_ListSearchField);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryWidget = (_temp = _class = function (_Component) {
	    _inherits(CategoryWidget, _Component);
	
	    function CategoryWidget(props) {
	        _classCallCheck(this, CategoryWidget);
	
	        var _this = _possibleConstructorReturn(this, (CategoryWidget.__proto__ || Object.getPrototypeOf(CategoryWidget)).call(this, props));
	
	        _this.updateSearchText = function (value) {
	            var regex = null;
	
	            if (value) {
	                regex = (0, _string.createMultiwordSearchRegex)(value);
	            }
	
	            _this.setState({
	                searchText: value,
	                searchRegex: regex
	            });
	        };
	
	        _this.state = {
	            searchText: "",
	            searchRegex: null
	        };
	        return _this;
	    }
	
	    _createClass(CategoryWidget, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                value = _props.value,
	                values = _props.values,
	                setValue = _props.setValue,
	                onClose = _props.onClose;
	
	
	            var filteredValues = [];
	            var regex = this.state.searchRegex;
	
	            if (regex) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var _value = _step.value;
	
	                        if (regex.test(_value[0]) || regex.test(_value[1])) {
	                            filteredValues.push(_value);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            } else {
	                filteredValues = values.slice();
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { style: { maxWidth: 200 } },
	                values.length > 10 && _react2.default.createElement(
	                    "div",
	                    { className: "p1" },
	                    _react2.default.createElement(_ListSearchField2.default, {
	                        onChange: this.updateSearchText,
	                        searchText: this.state.searchText,
	                        placeholder: "Find a value",
	                        autoFocus: true
	                    })
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "scroll-y scroll-show", style: { maxHeight: 300 } },
	                    filteredValues.map(function (_ref) {
	                        var _ref2 = _slicedToArray(_ref, 2),
	                            rawValue = _ref2[0],
	                            humanReadableValue = _ref2[1];
	
	                        return _react2.default.createElement(
	                            "li",
	                            {
	                                key: rawValue,
	                                className: (0, _classnames2.default)("px2 py1 bg-brand-hover text-white-hover cursor-pointer", {
	                                    "text-white bg-brand": rawValue === value
	                                }),
	                                onClick: function onClick() {
	                                    setValue(rawValue);onClose();
	                                }
	                            },
	                            humanReadableValue || String(rawValue)
	                        );
	                    })
	                )
	            );
	        }
	    }], [{
	        key: "format",
	        value: function format(value, fieldValues) {
	            return (0, _field.getHumanReadableValue)(value, fieldValues);
	        }
	    }]);
	
	    return CategoryWidget;
	}(_react.Component), _class.propTypes = {
	    value: _propTypes2.default.any,
	    values: _propTypes2.default.array.isRequired,
	    setValue: _propTypes2.default.func.isRequired,
	    onClose: _propTypes2.default.func.isRequired
	}, _temp);
	CategoryWidget.displayName = "CategoryWidget";
	exports.default = CategoryWidget;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dom = __webpack_require__(859);
	
	var _keyboard = __webpack_require__(934);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextWidget = (_temp = _class = function (_Component) {
	    _inherits(TextWidget, _Component);
	
	    function TextWidget(props, context) {
	        _classCallCheck(this, TextWidget);
	
	        var _this = _possibleConstructorReturn(this, (TextWidget.__proto__ || Object.getPrototypeOf(TextWidget)).call(this, props, context));
	
	        _this.state = {
	            value: props.value,
	            isFocused: false
	        };
	        return _this;
	    }
	
	    _createClass(TextWidget, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (this.props.value !== nextProps.value) {
	                this.setState({ value: nextProps.value }, function () {
	                    // HACK: Address Safari rendering bug which causes https://github.com/metabase/metabase/issues/5335
	                    (0, _dom.forceRedraw)(_reactDom2.default.findDOMNode(_this2));
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                setValue = _props.setValue,
	                className = _props.className,
	                isEditing = _props.isEditing,
	                parentFocusChanged = _props.focusChanged;
	
	            var defaultPlaceholder = this.state.isFocused ? "" : this.props.placeholder || "Enter a value...";
	
	            var focusChanged = function focusChanged(isFocused) {
	                if (parentFocusChanged) parentFocusChanged(isFocused);
	                _this3.setState({ isFocused: isFocused });
	            };
	
	            return _react2.default.createElement("input", {
	                className: className,
	                type: "text",
	                value: this.state.value || "",
	                onChange: function onChange(e) {
	                    _this3.setState({ value: e.target.value });
	                    if (_this3.props.commitImmediately) {
	                        _this3.props.setValue(e.target.value || null);
	                    }
	                },
	                onKeyUp: function onKeyUp(e) {
	                    if (e.keyCode === _keyboard.KEYCODE_ESCAPE) {
	                        e.target.blur();
	                    } else if (e.keyCode === _keyboard.KEYCODE_ENTER) {
	                        setValue(_this3.state.value || null);
	                        e.target.blur();
	                    }
	                },
	                onFocus: function onFocus() {
	                    focusChanged(true);
	                },
	                onBlur: function onBlur() {
	                    focusChanged(false);
	                    _this3.setState({ value: _this3.props.value });
	                },
	                placeholder: isEditing ? "Enter a default value..." : defaultPlaceholder
	            });
	        }
	    }]);
	
	    return TextWidget;
	}(_react.Component), _class.propTypes = {
	    value: _propTypes2.default.any,
	    setValue: _propTypes2.default.func.isRequired,
	    className: _propTypes2.default.string,
	    isEditing: _propTypes2.default.bool,
	    commitImmediately: _propTypes2.default.bool,
	    placeholder: _propTypes2.default.string,
	    focusChanged: _propTypes2.default.func
	}, _class.defaultProps = {
	    commitImmediately: false
	}, _class.noPopover = true, _class.format = function (value) {
	    return value;
	}, _temp);
	TextWidget.displayName = "TextWidget";
	exports.default = TextWidget;

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"tfpVo _38618 _3Dqep","deemphasized":"_2twtF","parameter":"_20z_B _38618 _3Dqep","nameInput":"_2i2x7 _38618 _3Dqep","fullscreen":"_2G87x","name":"_2m475 _3K4no","selected":"_2YcmO","noPopover":"pg3LL","isEditing":"_2AYUY","input":"_38Q_V","parameterButtons":"_2bHbr","editButton":"_3tq8o _38618 _3Dqep _1a-AI","removeButton":"_1kPst _38618 _3Dqep _1a-AI","editNameIconContainer":"_1oJCz"};

/***/ }),
/* 1202 */,
/* 1203 */,
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LogoIcon = __webpack_require__(1205);
	
	var _LogoIcon2 = _interopRequireDefault(_LogoIcon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LogoBadge = function LogoBadge(_ref) {
	    var dark = _ref.dark;
	    return _react2.default.createElement(
	        "a",
	        { href: "http://www.metabase.com/", target: "_blank", className: "h4 flex text-bold align-center no-decoration" },
	        _react2.default.createElement(_LogoIcon2.default, {
	            size: 28,
	            dark: dark
	        }),
	        _react2.default.createElement(
	            "span",
	            { className: "text-small" },
	            _react2.default.createElement(
	                "span",
	                { className: "ml1 text-grey-3" },
	                "Powered by"
	            ),
	            " ",
	            _react2.default.createElement(
	                "span",
	                { className: (0, _classnames2.default)({ "text-brand": !dark }, { "text-white": dark }) },
	                "Metabase"
	            )
	        )
	    );
	};
	
	LogoBadge.displayName = "LogoBadge";
	exports.default = LogoBadge;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogoIcon = (_temp = _class = function (_Component) {
	    _inherits(LogoIcon, _Component);
	
	    function LogoIcon() {
	        _classCallCheck(this, LogoIcon);
	
	        return _possibleConstructorReturn(this, (LogoIcon.__proto__ || Object.getPrototypeOf(LogoIcon)).apply(this, arguments));
	    }
	
	    _createClass(LogoIcon, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                dark = _props.dark,
	                height = _props.height,
	                width = _props.width,
	                size = _props.size;
	
	            return _react2.default.createElement(
	                "svg",
	                { className: (0, _classnames2.default)({ "text-brand": !dark }, { "text-white": dark }), viewBox: "0 0 66 85", width: width || size, height: height || size, fill: "currentcolor" },
	                _react2.default.createElement("path", { d: "M46.8253288,70.4935014 C49.5764899,70.4935014 51.8067467,68.1774705 51.8067467,65.3205017 C51.8067467,62.4635329 49.5764899,60.147502 46.8253288,60.147502 C44.0741676,60.147502 41.8439108,62.4635329 41.8439108,65.3205017 C41.8439108,68.1774705 44.0741676,70.4935014 46.8253288,70.4935014 Z M32.8773585,84.9779005 C35.6285197,84.9779005 37.8587764,82.6618697 37.8587764,79.8049008 C37.8587764,76.947932 35.6285197,74.6319011 32.8773585,74.6319011 C30.1261973,74.6319011 27.8959405,76.947932 27.8959405,79.8049008 C27.8959405,82.6618697 30.1261973,84.9779005 32.8773585,84.9779005 Z M32.8773585,70.4935014 C35.6285197,70.4935014 37.8587764,68.1774705 37.8587764,65.3205017 C37.8587764,62.4635329 35.6285197,60.147502 32.8773585,60.147502 C30.1261973,60.147502 27.8959405,62.4635329 27.8959405,65.3205017 C27.8959405,68.1774705 30.1261973,70.4935014 32.8773585,70.4935014 Z M18.9293882,70.4935014 C21.6805494,70.4935014 23.9108062,68.1774705 23.9108062,65.3205017 C23.9108062,62.4635329 21.6805494,60.147502 18.9293882,60.147502 C16.1782271,60.147502 13.9479703,62.4635329 13.9479703,65.3205017 C13.9479703,68.1774705 16.1782271,70.4935014 18.9293882,70.4935014 Z M46.8253288,56.0091023 C49.5764899,56.0091023 51.8067467,53.6930714 51.8067467,50.8361026 C51.8067467,47.9791337 49.5764899,45.6631029 46.8253288,45.6631029 C44.0741676,45.6631029 41.8439108,47.9791337 41.8439108,50.8361026 C41.8439108,53.6930714 44.0741676,56.0091023 46.8253288,56.0091023 Z M18.9293882,56.0091023 C21.6805494,56.0091023 23.9108062,53.6930714 23.9108062,50.8361026 C23.9108062,47.9791337 21.6805494,45.6631029 18.9293882,45.6631029 C16.1782271,45.6631029 13.9479703,47.9791337 13.9479703,50.8361026 C13.9479703,53.6930714 16.1782271,56.0091023 18.9293882,56.0091023 Z M46.8253288,26.8995984 C49.5764899,26.8995984 51.8067467,24.5835675 51.8067467,21.7265987 C51.8067467,18.8696299 49.5764899,16.553599 46.8253288,16.553599 C44.0741676,16.553599 41.8439108,18.8696299 41.8439108,21.7265987 C41.8439108,24.5835675 44.0741676,26.8995984 46.8253288,26.8995984 Z M32.8773585,41.5247031 C35.6285197,41.5247031 37.8587764,39.2086723 37.8587764,36.3517034 C37.8587764,33.4947346 35.6285197,31.1787037 32.8773585,31.1787037 C30.1261973,31.1787037 27.8959405,33.4947346 27.8959405,36.3517034 C27.8959405,39.2086723 30.1261973,41.5247031 32.8773585,41.5247031 Z M32.8773585,10.3459994 C35.6285197,10.3459994 37.8587764,8.02996853 37.8587764,5.17299969 C37.8587764,2.31603085 35.6285197,0 32.8773585,0 C30.1261973,0 27.8959405,2.31603085 27.8959405,5.17299969 C27.8959405,8.02996853 30.1261973,10.3459994 32.8773585,10.3459994 Z M32.8773585,26.8995984 C35.6285197,26.8995984 37.8587764,24.5835675 37.8587764,21.7265987 C37.8587764,18.8696299 35.6285197,16.553599 32.8773585,16.553599 C30.1261973,16.553599 27.8959405,18.8696299 27.8959405,21.7265987 C27.8959405,24.5835675 30.1261973,26.8995984 32.8773585,26.8995984 Z M18.9293882,26.8995984 C21.6805494,26.8995984 23.9108062,24.5835675 23.9108062,21.7265987 C23.9108062,18.8696299 21.6805494,16.553599 18.9293882,16.553599 C16.1782271,16.553599 13.9479703,18.8696299 13.9479703,21.7265987 C13.9479703,24.5835675 16.1782271,26.8995984 18.9293882,26.8995984 Z", opacity: "0.2" }),
	                _react2.default.createElement("path", { d: "M60.773299,70.4935014 C63.5244602,70.4935014 65.754717,68.1774705 65.754717,65.3205017 C65.754717,62.4635329 63.5244602,60.147502 60.773299,60.147502 C58.0221379,60.147502 55.7918811,62.4635329 55.7918811,65.3205017 C55.7918811,68.1774705 58.0221379,70.4935014 60.773299,70.4935014 Z M4.98141795,70.3527958 C7.73257912,70.3527958 9.96283591,68.0367649 9.96283591,65.1797961 C9.96283591,62.3228273 7.73257912,60.0067964 4.98141795,60.0067964 C2.23025679,60.0067964 0,62.3228273 0,65.1797961 C0,68.0367649 2.23025679,70.3527958 4.98141795,70.3527958 Z M60.773299,56.0091023 C63.5244602,56.0091023 65.754717,53.6930714 65.754717,50.8361026 C65.754717,47.9791337 63.5244602,45.6631029 60.773299,45.6631029 C58.0221379,45.6631029 55.7918811,47.9791337 55.7918811,50.8361026 C55.7918811,53.6930714 58.0221379,56.0091023 60.773299,56.0091023 Z M32.8773585,56.0091023 C35.6285197,56.0091023 37.8587764,53.6930714 37.8587764,50.8361026 C37.8587764,47.9791337 35.6285197,45.6631029 32.8773585,45.6631029 C30.1261973,45.6631029 27.8959405,47.9791337 27.8959405,50.8361026 C27.8959405,53.6930714 30.1261973,56.0091023 32.8773585,56.0091023 Z M4.98141795,55.8683967 C7.73257912,55.8683967 9.96283591,53.5523658 9.96283591,50.695397 C9.96283591,47.8384281 7.73257912,45.5223973 4.98141795,45.5223973 C2.23025679,45.5223973 0,47.8384281 0,50.695397 C0,53.5523658 2.23025679,55.8683967 4.98141795,55.8683967 Z M60.773299,41.5247031 C63.5244602,41.5247031 65.754717,39.2086723 65.754717,36.3517034 C65.754717,33.4947346 63.5244602,31.1787037 60.773299,31.1787037 C58.0221379,31.1787037 55.7918811,33.4947346 55.7918811,36.3517034 C55.7918811,39.2086723 58.0221379,41.5247031 60.773299,41.5247031 Z M46.8253288,41.5247031 C49.5764899,41.5247031 51.8067467,39.2086723 51.8067467,36.3517034 C51.8067467,33.4947346 49.5764899,31.1787037 46.8253288,31.1787037 C44.0741676,31.1787037 41.8439108,33.4947346 41.8439108,36.3517034 C41.8439108,39.2086723 44.0741676,41.5247031 46.8253288,41.5247031 Z M60.773299,26.8995984 C63.5244602,26.8995984 65.754717,24.5835675 65.754717,21.7265987 C65.754717,18.8696299 63.5244602,16.553599 60.773299,16.553599 C58.0221379,16.553599 55.7918811,18.8696299 55.7918811,21.7265987 C55.7918811,24.5835675 58.0221379,26.8995984 60.773299,26.8995984 Z M18.9293882,41.5247031 C21.6805494,41.5247031 23.9108062,39.2086723 23.9108062,36.3517034 C23.9108062,33.4947346 21.6805494,31.1787037 18.9293882,31.1787037 C16.1782271,31.1787037 13.9479703,33.4947346 13.9479703,36.3517034 C13.9479703,39.2086723 16.1782271,41.5247031 18.9293882,41.5247031 Z M4.98141795,41.3839975 C7.73257912,41.3839975 9.96283591,39.0679667 9.96283591,36.2109978 C9.96283591,33.354029 7.73257912,31.0379981 4.98141795,31.0379981 C2.23025679,31.0379981 0,33.354029 0,36.2109978 C0,39.0679667 2.23025679,41.3839975 4.98141795,41.3839975 Z M4.98141795,26.8995984 C7.73257912,26.8995984 9.96283591,24.5835675 9.96283591,21.7265987 C9.96283591,18.8696299 7.73257912,16.553599 4.98141795,16.553599 C2.23025679,16.553599 0,18.8696299 0,21.7265987 C0,24.5835675 2.23025679,26.8995984 4.98141795,26.8995984 Z" })
	            );
	        }
	    }]);
	
	    return LogoIcon;
	}(_react.Component), _class.defaultProps = {
	    size: 32
	}, _class.propTypes = {
	    size: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    dark: _propTypes2.default.bool
	}, _temp);
	LogoIcon.displayName = "LogoIcon";
	exports.default = LogoIcon;

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1207 */,
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./EmbedFrame": 1187,
		"./EmbedFrame.css": 1206,
		"./EmbedFrame.jsx": 1187,
		"./LogoBadge": 1204,
		"./LogoBadge.jsx": 1204,
		"./PublicError": 1209,
		"./PublicError.jsx": 1209,
		"./PublicNotFound": 1186,
		"./PublicNotFound.jsx": 1186,
		"./widgets/AdvancedEmbedPane": 1211,
		"./widgets/AdvancedEmbedPane.jsx": 1211,
		"./widgets/AdvancedSettingsPane": 1214,
		"./widgets/AdvancedSettingsPane.jsx": 1214,
		"./widgets/CodeSample": 1219,
		"./widgets/CodeSample.jsx": 1219,
		"./widgets/DisplayOptionsPane": 1215,
		"./widgets/DisplayOptionsPane.jsx": 1215,
		"./widgets/EmbedCodePane": 1218,
		"./widgets/EmbedCodePane.jsx": 1218,
		"./widgets/EmbedModalContent": 1239,
		"./widgets/EmbedModalContent.jsx": 1239,
		"./widgets/EmbedSelect": 1216,
		"./widgets/EmbedSelect.jsx": 1216,
		"./widgets/EmbedWidget": 1266,
		"./widgets/EmbedWidget.jsx": 1266,
		"./widgets/PreviewPane": 1217,
		"./widgets/PreviewPane.jsx": 1217,
		"./widgets/SharingPane": 1240,
		"./widgets/SharingPane.jsx": 1240
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1208;


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _app = __webpack_require__(1210);
	
	var _EmbedFrame = __webpack_require__(1187);
	
	var _EmbedFrame2 = _interopRequireDefault(_EmbedFrame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        message: (0, _app.getErrorMessage)(state, props)
	    };
	};
	
	var PublicError = function PublicError(_ref) {
	    var _ref$message = _ref.message,
	        message = _ref$message === undefined ? "An error occurred" : _ref$message;
	    return _react2.default.createElement(
	        _EmbedFrame2.default,
	        { className: "spread" },
	        _react2.default.createElement(
	            "div",
	            { className: "flex layout-centered flex-full flex-column" },
	            _react2.default.createElement("div", { className: "QueryError-image QueryError-image--noRows" }),
	            _react2.default.createElement(
	                "div",
	                { className: "mt1 h4 sm-h3 md-h2 text-bold" },
	                message
	            )
	        )
	    );
	};
	
	PublicError.displayName = "PublicError";
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(PublicError);

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var getErrorMessage = exports.getErrorMessage = function getErrorMessage(state) {
	    return state.app.errorPage && state.app.errorPage.data && (state.app.errorPage.data.message || state.app.errorPage.data);
	};

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToggleLarge = __webpack_require__(1212);
	
	var _ToggleLarge2 = _interopRequireDefault(_ToggleLarge);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ActionButton = __webpack_require__(1213);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _AdvancedSettingsPane = __webpack_require__(1214);
	
	var _AdvancedSettingsPane2 = _interopRequireDefault(_AdvancedSettingsPane);
	
	var _PreviewPane = __webpack_require__(1217);
	
	var _PreviewPane2 = _interopRequireDefault(_PreviewPane);
	
	var _EmbedCodePane = __webpack_require__(1218);
	
	var _EmbedCodePane2 = _interopRequireDefault(_EmbedCodePane);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdvancedEmbedPane = function AdvancedEmbedPane(_ref) {
	    var pane = _ref.pane,
	        resource = _ref.resource,
	        resourceType = _ref.resourceType,
	        embedType = _ref.embedType,
	        token = _ref.token,
	        iframeUrl = _ref.iframeUrl,
	        siteUrl = _ref.siteUrl,
	        secretKey = _ref.secretKey,
	        params = _ref.params,
	        displayOptions = _ref.displayOptions,
	        previewParameters = _ref.previewParameters,
	        parameterValues = _ref.parameterValues,
	        resourceParameters = _ref.resourceParameters,
	        embeddingParams = _ref.embeddingParams,
	        onChangeDisplayOptions = _ref.onChangeDisplayOptions,
	        onChangeEmbeddingParameters = _ref.onChangeEmbeddingParameters,
	        onChangeParameterValue = _ref.onChangeParameterValue,
	        onChangePane = _ref.onChangePane,
	        onSave = _ref.onSave,
	        onUnpublish = _ref.onUnpublish,
	        onDiscard = _ref.onDiscard;
	    return _react2.default.createElement(
	        "div",
	        { className: "full flex" },
	        _react2.default.createElement(
	            "div",
	            { className: "flex-full p4 flex flex-column" },
	            !resource.enable_embedding || !_underscore2.default.isEqual(resource.embedding_params, embeddingParams) ? _react2.default.createElement(
	                "div",
	                { className: "mb2 p2 bordered rounded flex align-center flex-no-shrink" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex-full mr1" },
	                    resource.enable_embedding ? "You\u2019ve made changes that need to be published before they will be reflected in your application embed." : "You will need to publish this " + resourceType + " before you can embed it in another application."
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex-no-shrink" },
	                    resource.enable_embedding && !_underscore2.default.isEqual(resource.embedding_params, embeddingParams) ? _react2.default.createElement(
	                        _Button2.default,
	                        { className: "ml1", medium: true, onClick: onDiscard },
	                        "Discard Changes"
	                    ) : null,
	                    _react2.default.createElement(
	                        _ActionButton2.default,
	                        { className: "ml1", primary: true, medium: true, actionFn: onSave, activeText: "Updating...", successText: "Updated", failedText: "Failed!" },
	                        "Publish"
	                    )
	                )
	            ) : null,
	            _react2.default.createElement(_ToggleLarge2.default, {
	                className: "mb2 flex-no-shrink",
	                style: { width: 244, height: 34 },
	                value: pane === "preview",
	                textLeft: "Preview",
	                textRight: "Code",
	                onChange: function onChange() {
	                    return onChangePane(pane === "preview" ? "code" : "preview");
	                }
	            }),
	            pane === "preview" ? _react2.default.createElement(_PreviewPane2.default, {
	                className: "flex-full",
	                previewUrl: iframeUrl
	            }) : pane === "code" ? _react2.default.createElement(_EmbedCodePane2.default, {
	                className: "flex-full",
	                embedType: embedType,
	                resource: resource,
	                resourceType: resourceType,
	                iframeUrl: iframeUrl,
	                token: token,
	                siteUrl: siteUrl,
	                secretKey: secretKey,
	                params: params,
	                displayOptions: displayOptions
	            }) : null
	        ),
	        _react2.default.createElement(_AdvancedSettingsPane2.default, {
	            pane: pane,
	            embedType: embedType,
	            onChangePane: onChangePane,
	            resource: resource,
	            resourceType: resourceType,
	            resourceParameters: resourceParameters,
	            embeddingParams: embeddingParams,
	            onChangeEmbeddingParameters: onChangeEmbeddingParameters,
	            displayOptions: displayOptions,
	            onChangeDisplayOptions: onChangeDisplayOptions,
	            previewParameters: previewParameters,
	            parameterValues: parameterValues,
	            onChangeParameterValue: onChangeParameterValue,
	            onUnpublish: onUnpublish
	        })
	    );
	};
	
	AdvancedEmbedPane.displayName = "AdvancedEmbedPane";
	exports.default = AdvancedEmbedPane;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ToggleLarge = function ToggleLarge(_ref) {
	    var style = _ref.style,
	        className = _ref.className,
	        value = _ref.value,
	        onChange = _ref.onChange,
	        textLeft = _ref.textLeft,
	        textRight = _ref.textRight;
	    return _react2.default.createElement(
	        "div",
	        {
	            className: (0, _classnames2.default)(className, "bg-grey-1 flex relative text-bold", {
	                "cursor-pointer": onChange
	            }),
	            style: _extends({ borderRadius: 8 }, style),
	            onClick: function onClick() {
	                return onChange({ target: { value: !value } });
	            }
	        },
	        _react2.default.createElement("div", {
	            className: "absolute bg-white z1",
	            style: _defineProperty({
	                borderRadius: 6,
	                top: 3, bottom: 3,
	                width: "50%" }, value ? "left" : "right", 3)
	        }),
	        _react2.default.createElement(
	            "div",
	            { className: "flex-full flex layout-centered z2" },
	            textLeft
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "flex-full flex layout-centered z2" },
	            textRight
	        )
	    );
	};
	
	ToggleLarge.displayName = "ToggleLarge";
	exports.default = ToggleLarge;

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _promise = __webpack_require__(1069);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActionButton = (_temp = _class = function (_Component) {
	    _inherits(ActionButton, _Component);
	
	    function ActionButton(props) {
	        _classCallCheck(this, ActionButton);
	
	        var _this = _possibleConstructorReturn(this, (ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).call(this, props));
	
	        _this.resetStateOnTimeout = function () {
	            // clear any previously set timeouts then start a new one
	            clearTimeout(_this.timeout);
	            _this.timeout = setTimeout(function () {
	                return _this.setState({
	                    active: false,
	                    result: null
	                });
	            }, 5000);
	        };
	
	        _this.onClick = function (event) {
	            event.preventDefault();
	
	            // set state to active
	            _this.setState({
	                active: true,
	                result: null
	            });
	
	            // run the function we want bound to this button
	            _this.actionPromise = (0, _promise.cancelable)(_this.props.actionFn());
	            _this.actionPromise.then(function (success) {
	                _this.setState({
	                    active: false,
	                    result: "success"
	                }, _this.resetStateOnTimeout);
	            }, function (error) {
	                if (!error.isCanceled) {
	                    console.error(error);
	                    _this.setState({
	                        active: false,
	                        result: "failed"
	                    }, _this.resetStateOnTimeout);
	                }
	            });
	        };
	
	        _this.state = {
	            active: false,
	            result: null
	        };
	        return _this;
	    }
	
	    _createClass(ActionButton, [{
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            clearTimeout(this.timeout);
	            if (this.actionPromise) {
	                this.actionPromise.cancel();
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            // eslint-disable-next-line no-unused-vars
	            var _props = this.props,
	                normalText = _props.normalText,
	                activeText = _props.activeText,
	                failedText = _props.failedText,
	                successText = _props.successText,
	                actionFn = _props.actionFn,
	                className = _props.className,
	                forceActiveStyle = _props.forceActiveStyle,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["normalText", "activeText", "failedText", "successText", "actionFn", "className", "forceActiveStyle", "children"]);
	
	            var _state = this.state,
	                active = _state.active,
	                result = _state.result;
	
	
	            return _react2.default.createElement(
	                _Button2.default,
	                _extends({}, props, {
	                    className: forceActiveStyle ? (0, _classnames2.default)('Button', 'Button--waiting') : (0, _classnames2.default)(className, {
	                        'Button--waiting pointer-events-none': active,
	                        'Button--success': result === 'success',
	                        'Button--danger': result === 'failed'
	                    }),
	                    onClick: this.onClick
	                }),
	                active ?
	                // TODO: loading spinner
	                activeText : result === "success" ? _react2.default.createElement(
	                    "span",
	                    null,
	                    forceActiveStyle ? null : _react2.default.createElement(_Icon2.default, { name: "check", size: 12 }),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "ml1" },
	                        successText
	                    )
	                ) : result === "failed" ? failedText : children || normalText
	            );
	        }
	    }]);
	
	    return ActionButton;
	}(_react.Component), _class.propTypes = {
	    actionFn: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	    className: "Button",
	    normalText: "Save",
	    activeText: "Saving...",
	    failedText: "Save failed",
	    successText: "Saved",
	    forceActiveStyle: false
	}, _temp);
	ActionButton.displayName = "ActionButton";
	exports.default = ActionButton;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Parameters = __webpack_require__(1189);
	
	var _Parameters2 = _interopRequireDefault(_Parameters);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _DisplayOptionsPane = __webpack_require__(1215);
	
	var _DisplayOptionsPane2 = _interopRequireDefault(_DisplayOptionsPane);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getIconForParameter = function getIconForParameter(parameter) {
	    return parameter.type === "category" ? "string" : parameter.type.indexOf("date/") === 0 ? "calendar" : "unknown";
	};
	
	var AdvancedSettingsPane = function AdvancedSettingsPane(_ref) {
	    var className = _ref.className,
	        embedType = _ref.embedType,
	        resource = _ref.resource,
	        resourceType = _ref.resourceType,
	        resourceParameters = _ref.resourceParameters,
	        embeddingParams = _ref.embeddingParams,
	        onChangeEmbeddingParameters = _ref.onChangeEmbeddingParameters,
	        displayOptions = _ref.displayOptions,
	        onChangeDisplayOptions = _ref.onChangeDisplayOptions,
	        onUnpublish = _ref.onUnpublish,
	        pane = _ref.pane,
	        onChangePane = _ref.onChangePane,
	        previewParameters = _ref.previewParameters,
	        parameterValues = _ref.parameterValues,
	        onChangeParameterValue = _ref.onChangeParameterValue;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(className, "p4 full-height flex flex-column bg-slate-extra-light"), style: { width: 400 } },
	        _react2.default.createElement(
	            Section,
	            { title: "Style" },
	            _react2.default.createElement(_DisplayOptionsPane2.default, {
	                className: "pt1",
	                displayOptions: displayOptions,
	                onChangeDisplayOptions: onChangeDisplayOptions
	            })
	        ),
	        embedType === "application" && _react2.default.createElement(
	            Section,
	            { title: "Parameters" },
	            resourceParameters.length > 0 ? _react2.default.createElement(
	                "p",
	                null,
	                "Which parameters can users of this embed use?"
	            ) : _react2.default.createElement(
	                "p",
	                null,
	                "This ",
	                resourceType,
	                " doesn't have any parameters to configure yet."
	            ),
	            resourceParameters.map(function (parameter) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center my1" },
	                    _react2.default.createElement(_Icon2.default, { name: getIconForParameter(parameter), className: "mr2", style: { color: "#DFE8EA" } }),
	                    _react2.default.createElement(
	                        "h3",
	                        null,
	                        parameter.name
	                    ),
	                    _react2.default.createElement(
	                        _Select2.default,
	                        {
	                            className: "ml-auto bg-white",
	                            value: embeddingParams[parameter.slug] || "disabled",
	                            onChange: function onChange(e) {
	                                return onChangeEmbeddingParameters(_extends({}, embeddingParams, _defineProperty({}, parameter.slug, e.target.value)));
	                            }
	                        },
	                        _react2.default.createElement(
	                            _Select.Option,
	                            { icon: "close", value: "disabled" },
	                            "Disabled"
	                        ),
	                        _react2.default.createElement(
	                            _Select.Option,
	                            { icon: "pencil", value: "enabled" },
	                            "Editable"
	                        ),
	                        _react2.default.createElement(
	                            _Select.Option,
	                            { icon: "lock", value: "locked" },
	                            "Locked"
	                        )
	                    )
	                );
	            })
	        ),
	        embedType === "application" && previewParameters.length > 0 && _react2.default.createElement(
	            Section,
	            { title: "Preview Locked Parameters" },
	            _react2.default.createElement(
	                "p",
	                null,
	                "Try passing some values to your locked parameters here. Your server will have to provide the actual values in the signed token when using this for real."
	            ),
	            _react2.default.createElement(_Parameters2.default, {
	                className: "mt2",
	                vertical: true,
	                parameters: previewParameters,
	                parameterValues: parameterValues,
	                setParameterValue: onChangeParameterValue
	            })
	        ),
	        resource.enable_embedding ? _react2.default.createElement(
	            Section,
	            { title: "Danger zone" },
	            _react2.default.createElement(
	                "p",
	                null,
	                "This will disable embedding for this ",
	                resourceType,
	                "."
	            ),
	            _react2.default.createElement(
	                _Button2.default,
	                { medium: true, warning: true, onClick: onUnpublish },
	                "Unpublish"
	            )
	        ) : null
	    );
	};
	
	AdvancedSettingsPane.displayName = "AdvancedSettingsPane";
	var Section = function Section(_ref2) {
	    var className = _ref2.className,
	        title = _ref2.title,
	        children = _ref2.children;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(className, "mb3 pb4 border-row-divider border-med") },
	        _react2.default.createElement(
	            "h3",
	            null,
	            title
	        ),
	        children
	    );
	};
	
	Section.displayName = "Section";
	exports.default = AdvancedSettingsPane;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmbedSelect = __webpack_require__(1216);
	
	var _EmbedSelect2 = _interopRequireDefault(_EmbedSelect);
	
	var _CheckBox = __webpack_require__(1004);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var THEME_OPTIONS = [{ name: "Light", value: null, icon: "sun" }, { name: "Dark", value: "night", icon: "moon" }];
	
	var DisplayOptionsPane = function DisplayOptionsPane(_ref) {
	    var className = _ref.className,
	        displayOptions = _ref.displayOptions,
	        onChangeDisplayOptions = _ref.onChangeDisplayOptions;
	    return _react2.default.createElement(
	        "div",
	        { className: className },
	        _react2.default.createElement(
	            "div",
	            { className: "flex align-center my1" },
	            _react2.default.createElement(_CheckBox2.default, {
	                checked: displayOptions.bordered,
	                onChange: function onChange(e) {
	                    return onChangeDisplayOptions(_extends({}, displayOptions, { bordered: e.target.checked }));
	                }
	            }),
	            _react2.default.createElement(
	                "span",
	                { className: "ml1" },
	                "Border"
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "flex align-center my1" },
	            _react2.default.createElement(_CheckBox2.default, {
	                checked: displayOptions.titled,
	                onChange: function onChange(e) {
	                    return onChangeDisplayOptions(_extends({}, displayOptions, { titled: e.target.checked }));
	                }
	            }),
	            _react2.default.createElement(
	                "span",
	                { className: "ml1" },
	                "Title"
	            )
	        ),
	        _react2.default.createElement(_EmbedSelect2.default, {
	            value: displayOptions.theme,
	            options: THEME_OPTIONS,
	            onChange: function onChange(value) {
	                return onChangeDisplayOptions(_extends({}, displayOptions, { theme: value }));
	            }
	        })
	    );
	};
	
	DisplayOptionsPane.displayName = "DisplayOptionsPane";
	exports.default = DisplayOptionsPane;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmbedSelect = function EmbedSelect(_ref) {
	    var className = _ref.className,
	        value = _ref.value,
	        onChange = _ref.onChange,
	        options = _ref.options;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(className, "flex") },
	        options.map(function (option) {
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)("flex-full flex layout-centered mx1 p1 border-bottom border-med border-dark-hover", {
	                        "border-dark": value === option.value,
	                        "cursor-pointer": value !== option.value
	                    }),
	                    onClick: function onClick() {
	                        return onChange(option.value);
	                    }
	                },
	                option.icon && _react2.default.createElement(_Icon2.default, { name: option.icon, className: "mr1" }),
	                option.name
	            );
	        }),
	        _react2.default.createElement("div", { className: "hide" })
	    );
	};
	
	EmbedSelect.displayName = "EmbedSelect";
	exports.default = EmbedSelect;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PreviewPane = function (_Component) {
	    _inherits(PreviewPane, _Component);
	
	    function PreviewPane(props) {
	        _classCallCheck(this, PreviewPane);
	
	        var _this = _possibleConstructorReturn(this, (PreviewPane.__proto__ || Object.getPrototypeOf(PreviewPane)).call(this, props));
	
	        _this.state = {
	            loading: true
	        };
	        return _this;
	    }
	
	    _createClass(PreviewPane, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.previewUrl !== this.props.previewUrl) {
	                this.setState({ loading: true });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                previewUrl = _props.previewUrl;
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(className, "flex relative"), style: { minHeight: 280 } },
	                _react2.default.createElement("iframe", {
	                    className: "flex-full",
	                    src: previewUrl,
	                    frameBorder: 0,
	                    allowTransparency: true,
	                    onLoad: function onLoad() {
	                        return _this2.setState({ loading: false });
	                    }
	                })
	            );
	        }
	    }]);
	
	    return PreviewPane;
	}(_react.Component);
	
	PreviewPane.displayName = "PreviewPane";
	exports.default = PreviewPane;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExternalLink = __webpack_require__(875);
	
	var _ExternalLink2 = _interopRequireDefault(_ExternalLink);
	
	var _CodeSample = __webpack_require__(1219);
	
	var _CodeSample2 = _interopRequireDefault(_CodeSample);
	
	var _code = __webpack_require__(1231);
	
	__webpack_require__(1234);
	
	__webpack_require__(1235);
	
	__webpack_require__(1229);
	
	__webpack_require__(1236);
	
	__webpack_require__(1237);
	
	__webpack_require__(1238);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmbedCodePane = function (_Component) {
	    _inherits(EmbedCodePane, _Component);
	
	    function EmbedCodePane() {
	        _classCallCheck(this, EmbedCodePane);
	
	        return _possibleConstructorReturn(this, (EmbedCodePane.__proto__ || Object.getPrototypeOf(EmbedCodePane)).apply(this, arguments));
	    }
	
	    _createClass(EmbedCodePane, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                embedType = _props.embedType,
	                iframeUrl = _props.iframeUrl,
	                siteUrl = _props.siteUrl,
	                secretKey = _props.secretKey,
	                resource = _props.resource,
	                resourceType = _props.resourceType,
	                params = _props.params,
	                displayOptions = _props.displayOptions;
	
	            return _react2.default.createElement(
	                "div",
	                { className: className },
	                embedType === "application" ? _react2.default.createElement(
	                    "div",
	                    { key: "application" },
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "To embed this ",
	                        resourceType,
	                        " in your application:"
	                    ),
	                    _react2.default.createElement(_CodeSample2.default, {
	                        title: "Insert this code snippet in your server code to generate the signed embedding URL ",
	                        options: (0, _code.getSignTokenOptions)({ siteUrl: siteUrl, secretKey: secretKey, resourceType: resourceType, resourceId: resource.id, params: params, displayOptions: displayOptions }),
	                        onChangeOption: function onChangeOption(option) {
	                            if (option && option.embedOption && _this2._embedSample && _this2._embedSample.setOption) {
	                                _this2._embedSample.setOption(option.embedOption);
	                            }
	                        }
	                    }),
	                    _react2.default.createElement(_CodeSample2.default, {
	                        className: "mt2",
	                        ref: function ref(embedSample) {
	                            return _this2._embedSample = embedSample;
	                        },
	                        title: "Then insert this code snippet in your HTML template or single page app.",
	                        options: (0, _code.getSignedEmbedOptions)({ iframeUrl: iframeUrl })
	                    })
	                ) : _react2.default.createElement(
	                    "div",
	                    { key: "public" },
	                    _react2.default.createElement(_CodeSample2.default, {
	                        title: "Embed code snippet for your HTML or Frontend Application",
	                        options: (0, _code.getPublicEmbedOptions)({ iframeUrl: iframeUrl })
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "text-centered my2" },
	                    _react2.default.createElement(
	                        "h4",
	                        null,
	                        "More ",
	                        _react2.default.createElement(
	                            _ExternalLink2.default,
	                            { href: "https://github.com/metabase/embedding_reference_apps" },
	                            "examples on GitHub"
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EmbedCodePane;
	}(_react.Component);
	
	EmbedCodePane.displayName = "EmbedCodePane";
	exports.default = EmbedCodePane;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _CopyButton = __webpack_require__(1220);
	
	var _CopyButton2 = _interopRequireDefault(_CopyButton);
	
	var _TextEditor = __webpack_require__(1225);
	
	var _TextEditor2 = _interopRequireDefault(_TextEditor);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CodeSample = function (_Component) {
	    _inherits(CodeSample, _Component);
	
	    function CodeSample(props) {
	        _classCallCheck(this, CodeSample);
	
	        var _this = _possibleConstructorReturn(this, (CodeSample.__proto__ || Object.getPrototypeOf(CodeSample)).call(this, props));
	
	        _this.state = {
	            name: Array.isArray(props.options) && props.options.length > 0 ? props.options[0].name : null
	        };
	        return _this;
	    }
	
	    _createClass(CodeSample, [{
	        key: "setOption",
	        value: function setOption(name) {
	            this.setState({ name: name });
	        }
	    }, {
	        key: "handleChange",
	        value: function handleChange(name) {
	            var _props = this.props,
	                options = _props.options,
	                onChangeOption = _props.onChangeOption;
	
	            this.setState({ name: name });
	            if (onChangeOption) {
	                onChangeOption(_underscore2.default.findWhere(options, { name: name }));
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                className = _props2.className,
	                title = _props2.title,
	                options = _props2.options;
	            var name = this.state.name;
	
	            var selected = _underscore2.default.findWhere(options, { name: name });
	            var source = selected && selected.source();
	            return _react2.default.createElement(
	                "div",
	                { className: className },
	                (title || options && options.length > 1) && _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center" },
	                    _react2.default.createElement(
	                        "h4",
	                        null,
	                        title
	                    ),
	                    options && options.length > 1 ? _react2.default.createElement(
	                        _Select2.default,
	                        {
	                            className: "AdminSelect--borderless ml-auto pt1 pb1",
	                            value: name,
	                            onChange: function onChange(e) {
	                                return _this2.handleChange(e.target.value);
	                            }
	                        },
	                        options.map(function (option) {
	                            return _react2.default.createElement(
	                                _Select.Option,
	                                { value: option.name },
	                                option.name
	                            );
	                        })
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "bordered rounded shadowed relative" },
	                    _react2.default.createElement(_TextEditor2.default, {
	                        className: "z1",
	                        value: source,
	                        mode: selected && selected.mode,
	                        theme: "ace/theme/metabase",
	                        sizeToFit: true, readOnly: true
	                    }),
	                    source && _react2.default.createElement(
	                        "div",
	                        { className: "absolute top right text-brand-hover cursor-pointer z2" },
	                        _react2.default.createElement(_CopyButton2.default, { className: "p1", value: source })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CodeSample;
	}(_react.Component);
	
	CodeSample.displayName = "CodeSample";
	exports.default = CodeSample;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _reactCopyToClipboard = __webpack_require__(1221);
	
	var _reactCopyToClipboard2 = _interopRequireDefault(_reactCopyToClipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CopyWidget = function (_Component) {
	    _inherits(CopyWidget, _Component);
	
	    function CopyWidget(props) {
	        _classCallCheck(this, CopyWidget);
	
	        var _this = _possibleConstructorReturn(this, (CopyWidget.__proto__ || Object.getPrototypeOf(CopyWidget)).call(this, props));
	
	        _this.onCopy = function () {
	            _this.setState({ copied: true });
	            setTimeout(function () {
	                return _this.setState({ copied: false });
	            }, 2000);
	        };
	
	        _this.state = {
	            copied: false
	        };
	        return _this;
	    }
	
	    _createClass(CopyWidget, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                value = _props.value,
	                className = _props.className,
	                props = _objectWithoutProperties(_props, ["value", "className"]);
	
	            return _react2.default.createElement(
	                _Tooltip2.default,
	                { tooltip: "Copied!", isOpen: this.state.copied },
	                _react2.default.createElement(
	                    _reactCopyToClipboard2.default,
	                    { text: value, onCopy: this.onCopy },
	                    _react2.default.createElement(
	                        "div",
	                        { className: className },
	                        _react2.default.createElement(_Icon2.default, _extends({ name: "copy" }, props))
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CopyWidget;
	}(_react.Component);
	
	CopyWidget.displayName = "CopyWidget";
	exports.default = CopyWidget;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(1222),
	    CopyToClipboard = _require.CopyToClipboard;
	
	module.exports = CopyToClipboard;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CopyToClipboard = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _copyToClipboard = __webpack_require__(1223);
	
	var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CopyToClipboard = _react2.default.createClass({
	  displayName: 'CopyToClipboard',
	
	  propTypes: {
	    text: _react2.default.PropTypes.string.isRequired,
	    children: _react2.default.PropTypes.element.isRequired,
	    onCopy: _react2.default.PropTypes.func,
	    options: _react2.default.PropTypes.shape({
	      debug: _react2.default.PropTypes.bool,
	      message: _react2.default.PropTypes.string
	    })
	  },
	
	  onClick: function onClick(event) {
	    var _props = this.props,
	        text = _props.text,
	        onCopy = _props.onCopy,
	        children = _props.children,
	        options = _props.options;
	
	
	    var elem = _react2.default.Children.only(children);
	
	    var result = (0, _copyToClipboard2.default)(text, options);
	
	    if (onCopy) {
	      onCopy(text, result);
	    }
	
	    // Bypass onClick if it was present
	    if (elem && elem.props && typeof elem.props.onClick === 'function') {
	      elem.props.onClick(event);
	    }
	  },
	  render: function render() {
	    var _props2 = this.props,
	        _text = _props2.text,
	        _onCopy = _props2.onCopy,
	        _options = _props2.options,
	        children = _props2.children,
	        props = _objectWithoutProperties(_props2, ['text', 'onCopy', 'options', 'children']);
	
	    var elem = _react2.default.Children.only(children);
	
	    return _react2.default.cloneElement(elem, _extends({}, props, { onClick: this.onClick }));
	  }
	});
	exports.CopyToClipboard = CopyToClipboard;
	//# sourceMappingURL=Component.js.map

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var deselectCurrent = __webpack_require__(1224);
	
	var defaultMessage = 'Copy to clipboard: #{key}, Enter';
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug, message, reselectPrevious, range, selection, mark, success = false;
	  if (!options) { options = {}; }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement('span');
	    mark.textContent = text;
	    mark.setAttribute('style', [
	      // reset user styles for span element
	      'all: unset',
	      // prevents scrolling to the end of the page
	      'position: fixed',
	      'top: 0',
	      'clip: rect(0, 0, 0, 0)',
	      // used to preserve spaces and line breaks
	      'white-space: pre',
	      // do not inherit user-select (it may be `none`)
	      '-webkit-user-select: text',
	      '-moz-user-select: text',
	      '-ms-user-select: text',
	      'user-select: text',
	    ].join(';'));
	
	    document.body.appendChild(mark);
	
	    range.selectNode(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand('copy');
	    if (!successful) {
	      throw new Error('copy command was unsuccessful');
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error('unable to copy using execCommand: ', err);
	    debug && console.warn('trying IE specific stuff');
	    try {
	      window.clipboardData.setData('text', text);
	      success = true;
	    } catch (err) {
	      debug && console.error('unable to copy using clipboardData: ', err);
	      debug && console.error('falling back to prompt');
	      message = format('message' in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == 'function') {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ }),
/* 1224 */
/***/ (function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; /*global ace*/
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(1226);
	
	__webpack_require__(1228);
	
	__webpack_require__(1229);
	
	__webpack_require__(1230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SCROLL_MARGIN = 8;
	var LINE_HEIGHT = 16;
	
	var TextEditor = (_temp2 = _class = function (_Component) {
	    _inherits(TextEditor, _Component);
	
	    function TextEditor() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TextEditor);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextEditor.__proto__ || Object.getPrototypeOf(TextEditor)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
	            _this._update();
	            if (_this.props.onChange) {
	                _this.props.onChange(_this.value);
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TextEditor, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (this._editor && nextProps.value != null && nextProps.value !== this._editor.getValue()) {
	                this._editor.setValue(nextProps.value);
	                this._editor.clearSelection();
	            }
	        }
	    }, {
	        key: "_update",
	        value: function _update() {
	            var element = _reactDom2.default.findDOMNode(this);
	
	            this._updateValue();
	
	            this._editor.getSession().setMode(this.props.mode);
	            this._editor.setTheme(this.props.theme);
	
	            // read only
	            this._editor.setReadOnly(this.props.readOnly);
	            element.classList[this.props.readOnly ? "add" : "remove"]("read-only");
	
	            this._updateSize();
	        }
	    }, {
	        key: "_updateValue",
	        value: function _updateValue() {
	            if (this._editor) {
	                this.value = this._editor.getValue();
	            }
	        }
	    }, {
	        key: "_updateSize",
	        value: function _updateSize() {
	            var doc = this._editor.getSession().getDocument();
	            var element = _reactDom2.default.findDOMNode(this);
	            element.style.height = 2 * SCROLL_MARGIN + LINE_HEIGHT * doc.getLength() + "px";
	            this._editor.resize();
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var element = _reactDom2.default.findDOMNode(this);
	            this._editor = ace.edit(element);
	
	            window.editor = this._editor;
	
	            // listen to onChange events
	            this._editor.getSession().on("change", this.onChange);
	
	            // misc options, copied from NativeQueryEditor
	            this._editor.setOptions({
	                enableBasicAutocompletion: true,
	                enableSnippets: true,
	                enableLiveAutocompletion: true,
	                showPrintMargin: false,
	                highlightActiveLine: false,
	                highlightGutterLine: false,
	                showLineNumbers: true
	            });
	            this._editor.renderer.setScrollMargin(SCROLL_MARGIN, SCROLL_MARGIN);
	
	            // initialize the content
	            this._editor.setValue((this.props.value != null ? this.props.value : this.props.defaultValue) || "");
	
	            // clear the editor selection, otherwise we start with the whole editor selected
	            this._editor.clearSelection();
	
	            // hmmm, this could be dangerous
	            // this._editor.focus();
	
	            this._update();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this._update();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                style = _props.style;
	
	            return _react2.default.createElement("div", { className: className, style: style });
	        }
	    }]);
	
	    return TextEditor;
	}(_react.Component), _class.propTypes = {
	    mode: _propTypes2.default.string,
	    theme: _propTypes2.default.string,
	    value: _propTypes2.default.string,
	    defaultValue: _propTypes2.default.string,
	    onChange: _propTypes2.default.func
	}, _class.defaultProps = {
	    mode: "ace/mode/plain_text",
	    theme: null
	}, _temp2);
	TextEditor.displayName = "TextEditor";
	exports.default = TextEditor;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	(function(){function o(n){var i=e;n&&(e[n]||(e[n]={}),i=e[n]);if(!i.define||!i.define.packaged)t.original=i.define,i.define=t,i.define.packaged=!0;if(!i.require||!i.require.packaged)r.original=i.require,i.require=r,i.require.packaged=!0}var ACE_NAMESPACE = "ace",e=function(){return this}();!e&&typeof window!="undefined"&&(e=window);if(!ACE_NAMESPACE&&typeof requirejs!="undefined")return;var t=function(e,n,r){if(typeof e!="string"){t.original?t.original.apply(this,arguments):(console.error("dropping module because define wasn't a string."),console.trace());return}arguments.length==2&&(r=n),t.modules[e]||(t.payloads[e]=r,t.modules[e]=null)};t.modules={},t.payloads={};var n=function(e,t,n){if(typeof t=="string"){var i=s(e,t);if(i!=undefined)return n&&n(),i}else if(Object.prototype.toString.call(t)==="[object Array]"){var o=[];for(var u=0,a=t.length;u<a;++u){var f=s(e,t[u]);if(f==undefined&&r.original)return;o.push(f)}return n&&n.apply(null,o)||!0}},r=function(e,t){var i=n("",e,t);return i==undefined&&r.original?r.original.apply(this,arguments):i},i=function(e,t){if(t.indexOf("!")!==-1){var n=t.split("!");return i(e,n[0])+"!"+i(e,n[1])}if(t.charAt(0)=="."){var r=e.split("/").slice(0,-1).join("/");t=r+"/"+t;while(t.indexOf(".")!==-1&&s!=t){var s=t;t=t.replace(/\/\.\//,"/").replace(/[^\/]+\/\.\.\//,"")}}return t},s=function(e,r){r=i(e,r);var s=t.modules[r];if(!s){s=t.payloads[r];if(typeof s=="function"){var o={},u={id:r,uri:"",exports:o,packaged:!0},a=function(e,t){return n(r,e,t)},f=s(a,o,u);o=f||u.exports,t.modules[r]=o,delete t.payloads[r]}s=t.modules[r]=o||s}return s};o(ACE_NAMESPACE)})(),ace.define("ace/lib/regexp",["require","exports","module"],function(e,t,n){"use strict";function o(e){return(e.global?"g":"")+(e.ignoreCase?"i":"")+(e.multiline?"m":"")+(e.extended?"x":"")+(e.sticky?"y":"")}function u(e,t,n){if(Array.prototype.indexOf)return e.indexOf(t,n);for(var r=n||0;r<e.length;r++)if(e[r]===t)return r;return-1}var r={exec:RegExp.prototype.exec,test:RegExp.prototype.test,match:String.prototype.match,replace:String.prototype.replace,split:String.prototype.split},i=r.exec.call(/()??/,"")[1]===undefined,s=function(){var e=/^/g;return r.test.call(e,""),!e.lastIndex}();if(s&&i)return;RegExp.prototype.exec=function(e){var t=r.exec.apply(this,arguments),n,a;if(typeof e=="string"&&t){!i&&t.length>1&&u(t,"")>-1&&(a=RegExp(this.source,r.replace.call(o(this),"g","")),r.replace.call(e.slice(t.index),a,function(){for(var e=1;e<arguments.length-2;e++)arguments[e]===undefined&&(t[e]=undefined)}));if(this._xregexp&&this._xregexp.captureNames)for(var f=1;f<t.length;f++)n=this._xregexp.captureNames[f-1],n&&(t[n]=t[f]);!s&&this.global&&!t[0].length&&this.lastIndex>t.index&&this.lastIndex--}return t},s||(RegExp.prototype.test=function(e){var t=r.exec.call(this,e);return t&&this.global&&!t[0].length&&this.lastIndex>t.index&&this.lastIndex--,!!t})}),ace.define("ace/lib/es5-shim",["require","exports","module"],function(e,t,n){function r(){}function w(e){try{return Object.defineProperty(e,"sentinel",{}),"sentinel"in e}catch(t){}}function H(e){return e=+e,e!==e?e=0:e!==0&&e!==1/0&&e!==-1/0&&(e=(e>0||-1)*Math.floor(Math.abs(e))),e}function B(e){var t=typeof e;return e===null||t==="undefined"||t==="boolean"||t==="number"||t==="string"}function j(e){var t,n,r;if(B(e))return e;n=e.valueOf;if(typeof n=="function"){t=n.call(e);if(B(t))return t}r=e.toString;if(typeof r=="function"){t=r.call(e);if(B(t))return t}throw new TypeError}Function.prototype.bind||(Function.prototype.bind=function(t){var n=this;if(typeof n!="function")throw new TypeError("Function.prototype.bind called on incompatible "+n);var i=u.call(arguments,1),s=function(){if(this instanceof s){var e=n.apply(this,i.concat(u.call(arguments)));return Object(e)===e?e:this}return n.apply(t,i.concat(u.call(arguments)))};return n.prototype&&(r.prototype=n.prototype,s.prototype=new r,r.prototype=null),s});var i=Function.prototype.call,s=Array.prototype,o=Object.prototype,u=s.slice,a=i.bind(o.toString),f=i.bind(o.hasOwnProperty),l,c,h,p,d;if(d=f(o,"__defineGetter__"))l=i.bind(o.__defineGetter__),c=i.bind(o.__defineSetter__),h=i.bind(o.__lookupGetter__),p=i.bind(o.__lookupSetter__);if([1,2].splice(0).length!=2)if(!function(){function e(e){var t=new Array(e+2);return t[0]=t[1]=0,t}var t=[],n;t.splice.apply(t,e(20)),t.splice.apply(t,e(26)),n=t.length,t.splice(5,0,"XXX"),n+1==t.length;if(n+1==t.length)return!0}())Array.prototype.splice=function(e,t){var n=this.length;e>0?e>n&&(e=n):e==void 0?e=0:e<0&&(e=Math.max(n+e,0)),e+t<n||(t=n-e);var r=this.slice(e,e+t),i=u.call(arguments,2),s=i.length;if(e===n)s&&this.push.apply(this,i);else{var o=Math.min(t,n-e),a=e+o,f=a+s-o,l=n-a,c=n-o;if(f<a)for(var h=0;h<l;++h)this[f+h]=this[a+h];else if(f>a)for(h=l;h--;)this[f+h]=this[a+h];if(s&&e===c)this.length=c,this.push.apply(this,i);else{this.length=c+s;for(h=0;h<s;++h)this[e+h]=i[h]}}return r};else{var v=Array.prototype.splice;Array.prototype.splice=function(e,t){return arguments.length?v.apply(this,[e===void 0?0:e,t===void 0?this.length-e:t].concat(u.call(arguments,2))):[]}}Array.isArray||(Array.isArray=function(t){return a(t)=="[object Array]"});var m=Object("a"),g=m[0]!="a"||!(0 in m);Array.prototype.forEach||(Array.prototype.forEach=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=arguments[1],s=-1,o=r.length>>>0;if(a(t)!="[object Function]")throw new TypeError;while(++s<o)s in r&&t.call(i,r[s],s,n)}),Array.prototype.map||(Array.prototype.map=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0,s=Array(i),o=arguments[1];if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");for(var u=0;u<i;u++)u in r&&(s[u]=t.call(o,r[u],u,n));return s}),Array.prototype.filter||(Array.prototype.filter=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0,s=[],o,u=arguments[1];if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");for(var f=0;f<i;f++)f in r&&(o=r[f],t.call(u,o,f,n)&&s.push(o));return s}),Array.prototype.every||(Array.prototype.every=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0,s=arguments[1];if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");for(var o=0;o<i;o++)if(o in r&&!t.call(s,r[o],o,n))return!1;return!0}),Array.prototype.some||(Array.prototype.some=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0,s=arguments[1];if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");for(var o=0;o<i;o++)if(o in r&&t.call(s,r[o],o,n))return!0;return!1}),Array.prototype.reduce||(Array.prototype.reduce=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0;if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");if(!i&&arguments.length==1)throw new TypeError("reduce of empty array with no initial value");var s=0,o;if(arguments.length>=2)o=arguments[1];else do{if(s in r){o=r[s++];break}if(++s>=i)throw new TypeError("reduce of empty array with no initial value")}while(!0);for(;s<i;s++)s in r&&(o=t.call(void 0,o,r[s],s,n));return o}),Array.prototype.reduceRight||(Array.prototype.reduceRight=function(t){var n=F(this),r=g&&a(this)=="[object String]"?this.split(""):n,i=r.length>>>0;if(a(t)!="[object Function]")throw new TypeError(t+" is not a function");if(!i&&arguments.length==1)throw new TypeError("reduceRight of empty array with no initial value");var s,o=i-1;if(arguments.length>=2)s=arguments[1];else do{if(o in r){s=r[o--];break}if(--o<0)throw new TypeError("reduceRight of empty array with no initial value")}while(!0);do o in this&&(s=t.call(void 0,s,r[o],o,n));while(o--);return s});if(!Array.prototype.indexOf||[0,1].indexOf(1,2)!=-1)Array.prototype.indexOf=function(t){var n=g&&a(this)=="[object String]"?this.split(""):F(this),r=n.length>>>0;if(!r)return-1;var i=0;arguments.length>1&&(i=H(arguments[1])),i=i>=0?i:Math.max(0,r+i);for(;i<r;i++)if(i in n&&n[i]===t)return i;return-1};if(!Array.prototype.lastIndexOf||[0,1].lastIndexOf(0,-3)!=-1)Array.prototype.lastIndexOf=function(t){var n=g&&a(this)=="[object String]"?this.split(""):F(this),r=n.length>>>0;if(!r)return-1;var i=r-1;arguments.length>1&&(i=Math.min(i,H(arguments[1]))),i=i>=0?i:r-Math.abs(i);for(;i>=0;i--)if(i in n&&t===n[i])return i;return-1};Object.getPrototypeOf||(Object.getPrototypeOf=function(t){return t.__proto__||(t.constructor?t.constructor.prototype:o)});if(!Object.getOwnPropertyDescriptor){var y="Object.getOwnPropertyDescriptor called on a non-object: ";Object.getOwnPropertyDescriptor=function(t,n){if(typeof t!="object"&&typeof t!="function"||t===null)throw new TypeError(y+t);if(!f(t,n))return;var r,i,s;r={enumerable:!0,configurable:!0};if(d){var u=t.__proto__;t.__proto__=o;var i=h(t,n),s=p(t,n);t.__proto__=u;if(i||s)return i&&(r.get=i),s&&(r.set=s),r}return r.value=t[n],r}}Object.getOwnPropertyNames||(Object.getOwnPropertyNames=function(t){return Object.keys(t)});if(!Object.create){var b;Object.prototype.__proto__===null?b=function(){return{__proto__:null}}:b=function(){var e={};for(var t in e)e[t]=null;return e.constructor=e.hasOwnProperty=e.propertyIsEnumerable=e.isPrototypeOf=e.toLocaleString=e.toString=e.valueOf=e.__proto__=null,e},Object.create=function(t,n){var r;if(t===null)r=b();else{if(typeof t!="object")throw new TypeError("typeof prototype["+typeof t+"] != 'object'");var i=function(){};i.prototype=t,r=new i,r.__proto__=t}return n!==void 0&&Object.defineProperties(r,n),r}}if(Object.defineProperty){var E=w({}),S=typeof document=="undefined"||w(document.createElement("div"));if(!E||!S)var x=Object.defineProperty}if(!Object.defineProperty||x){var T="Property description must be an object: ",N="Object.defineProperty called on non-object: ",C="getters & setters can not be defined on this javascript engine";Object.defineProperty=function(t,n,r){if(typeof t!="object"&&typeof t!="function"||t===null)throw new TypeError(N+t);if(typeof r!="object"&&typeof r!="function"||r===null)throw new TypeError(T+r);if(x)try{return x.call(Object,t,n,r)}catch(i){}if(f(r,"value"))if(d&&(h(t,n)||p(t,n))){var s=t.__proto__;t.__proto__=o,delete t[n],t[n]=r.value,t.__proto__=s}else t[n]=r.value;else{if(!d)throw new TypeError(C);f(r,"get")&&l(t,n,r.get),f(r,"set")&&c(t,n,r.set)}return t}}Object.defineProperties||(Object.defineProperties=function(t,n){for(var r in n)f(n,r)&&Object.defineProperty(t,r,n[r]);return t}),Object.seal||(Object.seal=function(t){return t}),Object.freeze||(Object.freeze=function(t){return t});try{Object.freeze(function(){})}catch(k){Object.freeze=function(t){return function(n){return typeof n=="function"?n:t(n)}}(Object.freeze)}Object.preventExtensions||(Object.preventExtensions=function(t){return t}),Object.isSealed||(Object.isSealed=function(t){return!1}),Object.isFrozen||(Object.isFrozen=function(t){return!1}),Object.isExtensible||(Object.isExtensible=function(t){if(Object(t)===t)throw new TypeError;var n="";while(f(t,n))n+="?";t[n]=!0;var r=f(t,n);return delete t[n],r});if(!Object.keys){var L=!0,A=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],O=A.length;for(var M in{toString:null})L=!1;Object.keys=function I(e){if(typeof e!="object"&&typeof e!="function"||e===null)throw new TypeError("Object.keys called on a non-object");var I=[];for(var t in e)f(e,t)&&I.push(t);if(L)for(var n=0,r=O;n<r;n++){var i=A[n];f(e,i)&&I.push(i)}return I}}Date.now||(Date.now=function(){return(new Date).getTime()});var _="	\n\f\r \u00a0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029\ufeff";if(!String.prototype.trim||_.trim()){_="["+_+"]";var D=new RegExp("^"+_+_+"*"),P=new RegExp(_+_+"*$");String.prototype.trim=function(){return String(this).replace(D,"").replace(P,"")}}var F=function(e){if(e==null)throw new TypeError("can't convert "+e+" to object");return Object(e)}}),ace.define("ace/lib/fixoldbrowsers",["require","exports","module","ace/lib/regexp","ace/lib/es5-shim"],function(e,t,n){"use strict";e("./regexp"),e("./es5-shim")}),ace.define("ace/lib/dom",["require","exports","module"],function(e,t,n){"use strict";var r="http://www.w3.org/1999/xhtml";t.getDocumentHead=function(e){return e||(e=document),e.head||e.getElementsByTagName("head")[0]||e.documentElement},t.createElement=function(e,t){return document.createElementNS?document.createElementNS(t||r,e):document.createElement(e)},t.hasCssClass=function(e,t){var n=(e.className+"").split(/\s+/g);return n.indexOf(t)!==-1},t.addCssClass=function(e,n){t.hasCssClass(e,n)||(e.className+=" "+n)},t.removeCssClass=function(e,t){var n=e.className.split(/\s+/g);for(;;){var r=n.indexOf(t);if(r==-1)break;n.splice(r,1)}e.className=n.join(" ")},t.toggleCssClass=function(e,t){var n=e.className.split(/\s+/g),r=!0;for(;;){var i=n.indexOf(t);if(i==-1)break;r=!1,n.splice(i,1)}return r&&n.push(t),e.className=n.join(" "),r},t.setCssClass=function(e,n,r){r?t.addCssClass(e,n):t.removeCssClass(e,n)},t.hasCssString=function(e,t){var n=0,r;t=t||document;if(t.createStyleSheet&&(r=t.styleSheets)){while(n<r.length)if(r[n++].owningElement.id===e)return!0}else if(r=t.getElementsByTagName("style"))while(n<r.length)if(r[n++].id===e)return!0;return!1},t.importCssString=function(n,r,i){i=i||document;if(r&&t.hasCssString(r,i))return null;var s;r&&(n+="\n/*# sourceURL=ace/css/"+r+" */"),i.createStyleSheet?(s=i.createStyleSheet(),s.cssText=n,r&&(s.owningElement.id=r)):(s=t.createElement("style"),s.appendChild(i.createTextNode(n)),r&&(s.id=r),t.getDocumentHead(i).appendChild(s))},t.importCssStylsheet=function(e,n){if(n.createStyleSheet)n.createStyleSheet(e);else{var r=t.createElement("link");r.rel="stylesheet",r.href=e,t.getDocumentHead(n).appendChild(r)}},t.getInnerWidth=function(e){return parseInt(t.computedStyle(e,"paddingLeft"),10)+parseInt(t.computedStyle(e,"paddingRight"),10)+e.clientWidth},t.getInnerHeight=function(e){return parseInt(t.computedStyle(e,"paddingTop"),10)+parseInt(t.computedStyle(e,"paddingBottom"),10)+e.clientHeight},t.scrollbarWidth=function(e){var n=t.createElement("ace_inner");n.style.width="100%",n.style.minWidth="0px",n.style.height="200px",n.style.display="block";var r=t.createElement("ace_outer"),i=r.style;i.position="absolute",i.left="-10000px",i.overflow="hidden",i.width="200px",i.minWidth="0px",i.height="150px",i.display="block",r.appendChild(n);var s=e.documentElement;s.appendChild(r);var o=n.offsetWidth;i.overflow="scroll";var u=n.offsetWidth;return o==u&&(u=r.clientWidth),s.removeChild(r),o-u};if(typeof document=="undefined"){t.importCssString=function(){};return}window.pageYOffset!==undefined?(t.getPageScrollTop=function(){return window.pageYOffset},t.getPageScrollLeft=function(){return window.pageXOffset}):(t.getPageScrollTop=function(){return document.body.scrollTop},t.getPageScrollLeft=function(){return document.body.scrollLeft}),window.getComputedStyle?t.computedStyle=function(e,t){return t?(window.getComputedStyle(e,"")||{})[t]||"":window.getComputedStyle(e,"")||{}}:t.computedStyle=function(e,t){return t?e.currentStyle[t]:e.currentStyle},t.setInnerHtml=function(e,t){var n=e.cloneNode(!1);return n.innerHTML=t,e.parentNode.replaceChild(n,e),n},"textContent"in document.documentElement?(t.setInnerText=function(e,t){e.textContent=t},t.getInnerText=function(e){return e.textContent}):(t.setInnerText=function(e,t){e.innerText=t},t.getInnerText=function(e){return e.innerText}),t.getParentWindow=function(e){return e.defaultView||e.parentWindow}}),ace.define("ace/lib/oop",["require","exports","module"],function(e,t,n){"use strict";t.inherits=function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})},t.mixin=function(e,t){for(var n in t)e[n]=t[n];return e},t.implement=function(e,n){t.mixin(e,n)}}),ace.define("ace/lib/keys",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/oop"],function(e,t,n){"use strict";e("./fixoldbrowsers");var r=e("./oop"),i=function(){var e={MODIFIER_KEYS:{16:"Shift",17:"Ctrl",18:"Alt",224:"Meta"},KEY_MODS:{ctrl:1,alt:2,option:2,shift:4,"super":8,meta:8,command:8,cmd:8},FUNCTION_KEYS:{8:"Backspace",9:"Tab",13:"Return",19:"Pause",27:"Esc",32:"Space",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"Left",38:"Up",39:"Right",40:"Down",44:"Print",45:"Insert",46:"Delete",96:"Numpad0",97:"Numpad1",98:"Numpad2",99:"Numpad3",100:"Numpad4",101:"Numpad5",102:"Numpad6",103:"Numpad7",104:"Numpad8",105:"Numpad9","-13":"NumpadEnter",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"Numlock",145:"Scrolllock"},PRINTABLE_KEYS:{32:" ",48:"0",49:"1",50:"2",51:"3",52:"4",53:"5",54:"6",55:"7",56:"8",57:"9",59:";",61:"=",65:"a",66:"b",67:"c",68:"d",69:"e",70:"f",71:"g",72:"h",73:"i",74:"j",75:"k",76:"l",77:"m",78:"n",79:"o",80:"p",81:"q",82:"r",83:"s",84:"t",85:"u",86:"v",87:"w",88:"x",89:"y",90:"z",107:"+",109:"-",110:".",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'",111:"/",106:"*"}},t,n;for(n in e.FUNCTION_KEYS)t=e.FUNCTION_KEYS[n].toLowerCase(),e[t]=parseInt(n,10);for(n in e.PRINTABLE_KEYS)t=e.PRINTABLE_KEYS[n].toLowerCase(),e[t]=parseInt(n,10);return r.mixin(e,e.MODIFIER_KEYS),r.mixin(e,e.PRINTABLE_KEYS),r.mixin(e,e.FUNCTION_KEYS),e.enter=e["return"],e.escape=e.esc,e.del=e["delete"],e[173]="-",function(){var t=["cmd","ctrl","alt","shift"];for(var n=Math.pow(2,t.length);n--;)e.KEY_MODS[n]=t.filter(function(t){return n&e.KEY_MODS[t]}).join("-")+"-"}(),e.KEY_MODS[0]="",e.KEY_MODS[-1]="input-",e}();r.mixin(t,i),t.keyCodeToString=function(e){var t=i[e];return typeof t!="string"&&(t=String.fromCharCode(e)),t.toLowerCase()}}),ace.define("ace/lib/useragent",["require","exports","module"],function(e,t,n){"use strict";t.OS={LINUX:"LINUX",MAC:"MAC",WINDOWS:"WINDOWS"},t.getOS=function(){return t.isMac?t.OS.MAC:t.isLinux?t.OS.LINUX:t.OS.WINDOWS};if(typeof navigator!="object")return;var r=(navigator.platform.match(/mac|win|linux/i)||["other"])[0].toLowerCase(),i=navigator.userAgent;t.isWin=r=="win",t.isMac=r=="mac",t.isLinux=r=="linux",t.isIE=navigator.appName=="Microsoft Internet Explorer"||navigator.appName.indexOf("MSAppHost")>=0?parseFloat((i.match(/(?:MSIE |Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]):parseFloat((i.match(/(?:Trident\/[0-9]+[\.0-9]+;.*rv:)([0-9]+[\.0-9]+)/)||[])[1]),t.isOldIE=t.isIE&&t.isIE<9,t.isGecko=t.isMozilla=(window.Controllers||window.controllers)&&window.navigator.product==="Gecko",t.isOldGecko=t.isGecko&&parseInt((i.match(/rv:(\d+)/)||[])[1],10)<4,t.isOpera=window.opera&&Object.prototype.toString.call(window.opera)=="[object Opera]",t.isWebKit=parseFloat(i.split("WebKit/")[1])||undefined,t.isChrome=parseFloat(i.split(" Chrome/")[1])||undefined,t.isAIR=i.indexOf("AdobeAIR")>=0,t.isIPad=i.indexOf("iPad")>=0,t.isTouchPad=i.indexOf("TouchPad")>=0,t.isChromeOS=i.indexOf(" CrOS ")>=0}),ace.define("ace/lib/event",["require","exports","module","ace/lib/keys","ace/lib/useragent"],function(e,t,n){"use strict";function a(e,t,n){var a=u(t);if(!i.isMac&&s){t.getModifierState&&(t.getModifierState("OS")||t.getModifierState("Win"))&&(a|=8);if(s.altGr){if((3&a)==3)return;s.altGr=0}if(n===18||n===17){var f="location"in t?t.location:t.keyLocation;if(n===17&&f===1)s[n]==1&&(o=t.timeStamp);else if(n===18&&a===3&&f===2){var l=t.timeStamp-o;l<50&&(s.altGr=!0)}}}n in r.MODIFIER_KEYS&&(n=-1),a&8&&n>=91&&n<=93&&(n=-1);if(!a&&n===13){var f="location"in t?t.location:t.keyLocation;if(f===3){e(t,a,-n);if(t.defaultPrevented)return}}if(i.isChromeOS&&a&8){e(t,a,n);if(t.defaultPrevented)return;a&=-9}return!!a||n in r.FUNCTION_KEYS||n in r.PRINTABLE_KEYS?e(t,a,n):!1}function f(){s=Object.create(null)}var r=e("./keys"),i=e("./useragent"),s=null,o=0;t.addListener=function(e,t,n){if(e.addEventListener)return e.addEventListener(t,n,!1);if(e.attachEvent){var r=function(){n.call(e,window.event)};n._wrapper=r,e.attachEvent("on"+t,r)}},t.removeListener=function(e,t,n){if(e.removeEventListener)return e.removeEventListener(t,n,!1);e.detachEvent&&e.detachEvent("on"+t,n._wrapper||n)},t.stopEvent=function(e){return t.stopPropagation(e),t.preventDefault(e),!1},t.stopPropagation=function(e){e.stopPropagation?e.stopPropagation():e.cancelBubble=!0},t.preventDefault=function(e){e.preventDefault?e.preventDefault():e.returnValue=!1},t.getButton=function(e){return e.type=="dblclick"?0:e.type=="contextmenu"||i.isMac&&e.ctrlKey&&!e.altKey&&!e.shiftKey?2:e.preventDefault?e.button:{1:0,2:2,4:1}[e.button]},t.capture=function(e,n,r){function i(e){n&&n(e),r&&r(e),t.removeListener(document,"mousemove",n,!0),t.removeListener(document,"mouseup",i,!0),t.removeListener(document,"dragstart",i,!0)}return t.addListener(document,"mousemove",n,!0),t.addListener(document,"mouseup",i,!0),t.addListener(document,"dragstart",i,!0),i},t.addTouchMoveListener=function(e,n){if("ontouchmove"in e){var r,i;t.addListener(e,"touchstart",function(e){var t=e.changedTouches[0];r=t.clientX,i=t.clientY}),t.addListener(e,"touchmove",function(e){var t=1,s=e.changedTouches[0];e.wheelX=-(s.clientX-r)/t,e.wheelY=-(s.clientY-i)/t,r=s.clientX,i=s.clientY,n(e)})}},t.addMouseWheelListener=function(e,n){"onmousewheel"in e?t.addListener(e,"mousewheel",function(e){var t=8;e.wheelDeltaX!==undefined?(e.wheelX=-e.wheelDeltaX/t,e.wheelY=-e.wheelDeltaY/t):(e.wheelX=0,e.wheelY=-e.wheelDelta/t),n(e)}):"onwheel"in e?t.addListener(e,"wheel",function(e){var t=.35;switch(e.deltaMode){case e.DOM_DELTA_PIXEL:e.wheelX=e.deltaX*t||0,e.wheelY=e.deltaY*t||0;break;case e.DOM_DELTA_LINE:case e.DOM_DELTA_PAGE:e.wheelX=(e.deltaX||0)*5,e.wheelY=(e.deltaY||0)*5}n(e)}):t.addListener(e,"DOMMouseScroll",function(e){e.axis&&e.axis==e.HORIZONTAL_AXIS?(e.wheelX=(e.detail||0)*5,e.wheelY=0):(e.wheelX=0,e.wheelY=(e.detail||0)*5),n(e)})},t.addMultiMouseDownListener=function(e,n,r,s){function c(e){t.getButton(e)!==0?o=0:e.detail>1?(o++,o>4&&(o=1)):o=1;if(i.isIE){var c=Math.abs(e.clientX-u)>5||Math.abs(e.clientY-a)>5;if(!f||c)o=1;f&&clearTimeout(f),f=setTimeout(function(){f=null},n[o-1]||600),o==1&&(u=e.clientX,a=e.clientY)}e._clicks=o,r[s]("mousedown",e);if(o>4)o=0;else if(o>1)return r[s](l[o],e)}function h(e){o=2,f&&clearTimeout(f),f=setTimeout(function(){f=null},n[o-1]||600),r[s]("mousedown",e),r[s](l[o],e)}var o=0,u,a,f,l={2:"dblclick",3:"tripleclick",4:"quadclick"};Array.isArray(e)||(e=[e]),e.forEach(function(e){t.addListener(e,"mousedown",c),i.isOldIE&&t.addListener(e,"dblclick",h)})};var u=!i.isMac||!i.isOpera||"KeyboardEvent"in window?function(e){return 0|(e.ctrlKey?1:0)|(e.altKey?2:0)|(e.shiftKey?4:0)|(e.metaKey?8:0)}:function(e){return 0|(e.metaKey?1:0)|(e.altKey?2:0)|(e.shiftKey?4:0)|(e.ctrlKey?8:0)};t.getModifierString=function(e){return r.KEY_MODS[u(e)]},t.addCommandKeyListener=function(e,n){var r=t.addListener;if(i.isOldGecko||i.isOpera&&!("KeyboardEvent"in window)){var o=null;r(e,"keydown",function(e){o=e.keyCode}),r(e,"keypress",function(e){return a(n,e,o)})}else{var u=null;r(e,"keydown",function(e){s[e.keyCode]=(s[e.keyCode]||0)+1;var t=a(n,e,e.keyCode);return u=e.defaultPrevented,t}),r(e,"keypress",function(e){u&&(e.ctrlKey||e.altKey||e.shiftKey||e.metaKey)&&(t.stopEvent(e),u=null)}),r(e,"keyup",function(e){s[e.keyCode]=null}),s||(f(),r(window,"focus",f))}};if(typeof window=="object"&&window.postMessage&&!i.isOldIE){var l=1;t.nextTick=function(e,n){n=n||window;var r="zero-timeout-message-"+l;t.addListener(n,"message",function i(s){s.data==r&&(t.stopPropagation(s),t.removeListener(n,"message",i),e())}),n.postMessage(r,"*")}}t.nextFrame=typeof window=="object"&&(window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||window.msRequestAnimationFrame||window.oRequestAnimationFrame),t.nextFrame?t.nextFrame=t.nextFrame.bind(window):t.nextFrame=function(e){setTimeout(e,17)}}),ace.define("ace/lib/lang",["require","exports","module"],function(e,t,n){"use strict";t.last=function(e){return e[e.length-1]},t.stringReverse=function(e){return e.split("").reverse().join("")},t.stringRepeat=function(e,t){var n="";while(t>0){t&1&&(n+=e);if(t>>=1)e+=e}return n};var r=/^\s\s*/,i=/\s\s*$/;t.stringTrimLeft=function(e){return e.replace(r,"")},t.stringTrimRight=function(e){return e.replace(i,"")},t.copyObject=function(e){var t={};for(var n in e)t[n]=e[n];return t},t.copyArray=function(e){var t=[];for(var n=0,r=e.length;n<r;n++)e[n]&&typeof e[n]=="object"?t[n]=this.copyObject(e[n]):t[n]=e[n];return t},t.deepCopy=function s(e){if(typeof e!="object"||!e)return e;var t;if(Array.isArray(e)){t=[];for(var n=0;n<e.length;n++)t[n]=s(e[n]);return t}if(Object.prototype.toString.call(e)!=="[object Object]")return e;t={};for(var n in e)t[n]=s(e[n]);return t},t.arrayToMap=function(e){var t={};for(var n=0;n<e.length;n++)t[e[n]]=1;return t},t.createMap=function(e){var t=Object.create(null);for(var n in e)t[n]=e[n];return t},t.arrayRemove=function(e,t){for(var n=0;n<=e.length;n++)t===e[n]&&e.splice(n,1)},t.escapeRegExp=function(e){return e.replace(/([.*+?^${}()|[\]\/\\])/g,"\\$1")},t.escapeHTML=function(e){return e.replace(/&/g,"&#38;").replace(/"/g,"&#34;").replace(/'/g,"&#39;").replace(/</g,"&#60;")},t.getMatchOffsets=function(e,t){var n=[];return e.replace(t,function(e){n.push({offset:arguments[arguments.length-2],length:e.length})}),n},t.deferredCall=function(e){var t=null,n=function(){t=null,e()},r=function(e){return r.cancel(),t=setTimeout(n,e||0),r};return r.schedule=r,r.call=function(){return this.cancel(),e(),r},r.cancel=function(){return clearTimeout(t),t=null,r},r.isPending=function(){return t},r},t.delayedCall=function(e,t){var n=null,r=function(){n=null,e()},i=function(e){n==null&&(n=setTimeout(r,e||t))};return i.delay=function(e){n&&clearTimeout(n),n=setTimeout(r,e||t)},i.schedule=i,i.call=function(){this.cancel(),e()},i.cancel=function(){n&&clearTimeout(n),n=null},i.isPending=function(){return n},i}}),ace.define("ace/keyboard/textinput",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/lib/dom","ace/lib/lang"],function(e,t,n){"use strict";var r=e("../lib/event"),i=e("../lib/useragent"),s=e("../lib/dom"),o=e("../lib/lang"),u=i.isChrome<18,a=i.isIE,f=function(e,t){function b(e){if(h)return;h=!0;if(k)t=0,r=e?0:n.value.length-1;else var t=e?2:1,r=2;try{n.setSelectionRange(t,r)}catch(i){}h=!1}function w(){if(h)return;n.value=f,i.isWebKit&&y.schedule()}function R(){clearTimeout(q),q=setTimeout(function(){p&&(n.style.cssText=p,p=""),t.renderer.$keepTextAreaAtCursor==null&&(t.renderer.$keepTextAreaAtCursor=!0,t.renderer.$moveTextAreaToCursor())},i.isOldIE?200:0)}var n=s.createElement("textarea");n.className="ace_text-input",i.isTouchPad&&n.setAttribute("x-palm-disable-auto-cap",!0),n.setAttribute("wrap","off"),n.setAttribute("autocorrect","off"),n.setAttribute("autocapitalize","off"),n.setAttribute("spellcheck",!1),n.style.opacity="0",i.isOldIE&&(n.style.top="-1000px"),e.insertBefore(n,e.firstChild);var f="",l=!1,c=!1,h=!1,p="",d=!0;try{var v=document.activeElement===n}catch(m){}r.addListener(n,"blur",function(e){t.onBlur(e),v=!1}),r.addListener(n,"focus",function(e){v=!0,t.onFocus(e),b()}),this.focus=function(){if(p)return n.focus();var e=n.style.top;n.style.position="fixed",n.style.top="0px",n.focus(),setTimeout(function(){n.style.position="",n.style.top=="0px"&&(n.style.top=e)},0)},this.blur=function(){n.blur()},this.isFocused=function(){return v};var g=o.delayedCall(function(){v&&b(d)}),y=o.delayedCall(function(){h||(n.value=f,v&&b())});i.isWebKit||t.addEventListener("changeSelection",function(){t.selection.isEmpty()!=d&&(d=!d,g.schedule())}),w(),v&&t.onFocus();var E=function(e){return e.selectionStart===0&&e.selectionEnd===e.value.length};!n.setSelectionRange&&n.createTextRange&&(n.setSelectionRange=function(e,t){var n=this.createTextRange();n.collapse(!0),n.moveStart("character",e),n.moveEnd("character",t),n.select()},E=function(e){try{var t=e.ownerDocument.selection.createRange()}catch(n){}return!t||t.parentElement()!=e?!1:t.text==e.value});if(i.isOldIE){var S=!1,x=function(e){if(S)return;var t=n.value;if(h||!t||t==f)return;if(e&&t==f[0])return T.schedule();A(t),S=!0,w(),S=!1},T=o.delayedCall(x);r.addListener(n,"propertychange",x);var N={13:1,27:1};r.addListener(n,"keyup",function(e){h&&(!n.value||N[e.keyCode])&&setTimeout(F,0);if((n.value.charCodeAt(0)||0)<129)return T.call();h?j():B()}),r.addListener(n,"keydown",function(e){T.schedule(50)})}var C=function(e){l?l=!1:E(n)?(t.selectAll(),b()):k&&b(t.selection.isEmpty())},k=null;this.setInputHandler=function(e){k=e},this.getInputHandler=function(){return k};var L=!1,A=function(e){k&&(e=k(e),k=null),c?(b(),e&&t.onPaste(e),c=!1):e==f.charAt(0)?L?t.execCommand("del",{source:"ace"}):t.execCommand("backspace",{source:"ace"}):(e.substring(0,2)==f?e=e.substr(2):e.charAt(0)==f.charAt(0)?e=e.substr(1):e.charAt(e.length-1)==f.charAt(0)&&(e=e.slice(0,-1)),e.charAt(e.length-1)==f.charAt(0)&&(e=e.slice(0,-1)),e&&t.onTextInput(e)),L&&(L=!1)},O=function(e){if(h)return;var t=n.value;A(t),w()},M=function(e,t,n){var r=e.clipboardData||window.clipboardData;if(!r||u)return;var i=a||n?"Text":"text/plain";try{return t?r.setData(i,t)!==!1:r.getData(i)}catch(e){if(!n)return M(e,t,!0)}},_=function(e,i){var s=t.getCopyText();if(!s)return r.preventDefault(e);M(e,s)?(i?t.onCut():t.onCopy(),r.preventDefault(e)):(l=!0,n.value=s,n.select(),setTimeout(function(){l=!1,w(),b(),i?t.onCut():t.onCopy()}))},D=function(e){_(e,!0)},P=function(e){_(e,!1)},H=function(e){var s=M(e);typeof s=="string"?(s&&t.onPaste(s,e),i.isIE&&setTimeout(b),r.preventDefault(e)):(n.value="",c=!0)};r.addCommandKeyListener(n,t.onCommandKey.bind(t)),r.addListener(n,"select",C),r.addListener(n,"input",O),r.addListener(n,"cut",D),r.addListener(n,"copy",P),r.addListener(n,"paste",H),(!("oncut"in n)||!("oncopy"in n)||!("onpaste"in n))&&r.addListener(e,"keydown",function(e){if(i.isMac&&!e.metaKey||!e.ctrlKey)return;switch(e.keyCode){case 67:P(e);break;case 86:H(e);break;case 88:D(e)}});var B=function(e){if(h||!t.onCompositionStart||t.$readOnly)return;h={},h.canUndo=t.session.$undoManager,t.onCompositionStart(),setTimeout(j,0),t.on("mousedown",F),h.canUndo&&!t.selection.isEmpty()&&(t.insert(""),t.session.markUndoGroup(),t.selection.clearSelection()),t.session.markUndoGroup()},j=function(){if(!h||!t.onCompositionUpdate||t.$readOnly)return;var e=n.value.replace(/\x01/g,"");if(h.lastValue===e)return;t.onCompositionUpdate(e),h.lastValue&&t.undo(),h.canUndo&&(h.lastValue=e);if(h.lastValue){var r=t.selection.getRange();t.insert(h.lastValue),t.session.markUndoGroup(),h.range=t.selection.getRange(),t.selection.setRange(r),t.selection.clearSelection()}},F=function(e){if(!t.onCompositionEnd||t.$readOnly)return;var r=h;h=!1;var s=setTimeout(function(){s=null;var e=n.value.replace(/\x01/g,"");if(h)return;e==r.lastValue?w():!r.lastValue&&e&&(w(),A(e))});k=function(n){return s&&clearTimeout(s),n=n.replace(/\x01/g,""),n==r.lastValue?"":(r.lastValue&&s&&t.undo(),n)},t.onCompositionEnd(),t.removeListener("mousedown",F),e.type=="compositionend"&&r.range&&t.selection.setRange(r.range),i.isChrome&&i.isChrome>=53&&O()},I=o.delayedCall(j,50);r.addListener(n,"compositionstart",B),i.isGecko?r.addListener(n,"text",function(){I.schedule()}):(r.addListener(n,"keyup",function(){I.schedule()}),r.addListener(n,"keydown",function(){I.schedule()})),r.addListener(n,"compositionend",F),this.getElement=function(){return n},this.setReadOnly=function(e){n.readOnly=e},this.onContextMenu=function(e){L=!0,b(t.selection.isEmpty()),t._emit("nativecontextmenu",{target:t,domEvent:e}),this.moveToMouse(e,!0)},this.moveToMouse=function(e,o){if(!o&&i.isOldIE)return;p||(p=n.style.cssText),n.style.cssText=(o?"z-index:100000;":"")+"height:"+n.style.height+";"+(i.isIE?"opacity:0.1;":"");var u=t.container.getBoundingClientRect(),a=s.computedStyle(t.container),f=u.top+(parseInt(a.borderTopWidth)||0),l=u.left+(parseInt(u.borderLeftWidth)||0),c=u.bottom-f-n.clientHeight-2,h=function(e){n.style.left=e.clientX-l-2+"px",n.style.top=Math.min(e.clientY-f-2,c)+"px"};h(e);if(e.type!="mousedown")return;t.renderer.$keepTextAreaAtCursor&&(t.renderer.$keepTextAreaAtCursor=null),clearTimeout(q),i.isWin&&!i.isOldIE&&r.capture(t.container,h,R)},this.onContextMenuClose=R;var q,U=function(e){t.textInput.onContextMenu(e),R()};r.addListener(n,"mouseup",U),r.addListener(n,"mousedown",function(e){e.preventDefault(),R()}),r.addListener(t.renderer.scroller,"contextmenu",U),r.addListener(n,"contextmenu",U)};t.TextInput=f}),ace.define("ace/mouse/default_handlers",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"],function(e,t,n){"use strict";function u(e){e.$clickSelection=null;var t=e.editor;t.setDefaultHandler("mousedown",this.onMouseDown.bind(e)),t.setDefaultHandler("dblclick",this.onDoubleClick.bind(e)),t.setDefaultHandler("tripleclick",this.onTripleClick.bind(e)),t.setDefaultHandler("quadclick",this.onQuadClick.bind(e)),t.setDefaultHandler("mousewheel",this.onMouseWheel.bind(e)),t.setDefaultHandler("touchmove",this.onTouchMove.bind(e));var n=["select","startSelect","selectEnd","selectAllEnd","selectByWordsEnd","selectByLinesEnd","dragWait","dragWaitEnd","focusWait"];n.forEach(function(t){e[t]=this[t]},this),e.selectByLines=this.extendSelectionBy.bind(e,"getLineRange"),e.selectByWords=this.extendSelectionBy.bind(e,"getWordRange")}function a(e,t,n,r){return Math.sqrt(Math.pow(n-e,2)+Math.pow(r-t,2))}function f(e,t){if(e.start.row==e.end.row)var n=2*t.column-e.start.column-e.end.column;else if(e.start.row==e.end.row-1&&!e.start.column&&!e.end.column)var n=t.column-4;else var n=2*t.row-e.start.row-e.end.row;return n<0?{cursor:e.start,anchor:e.end}:{cursor:e.end,anchor:e.start}}var r=e("../lib/dom"),i=e("../lib/event"),s=e("../lib/useragent"),o=0;(function(){this.onMouseDown=function(e){var t=e.inSelection(),n=e.getDocumentPosition();this.mousedownEvent=e;var r=this.editor,i=e.getButton();if(i!==0){var s=r.getSelectionRange(),o=s.isEmpty();r.$blockScrolling++,(o||i==1)&&r.selection.moveToPosition(n),r.$blockScrolling--,i==2&&r.textInput.onContextMenu(e.domEvent);return}this.mousedownEvent.time=Date.now();if(t&&!r.isFocused()){r.focus();if(this.$focusTimout&&!this.$clickSelection&&!r.inMultiSelectMode){this.setState("focusWait"),this.captureMouse(e);return}}return this.captureMouse(e),this.startSelect(n,e.domEvent._clicks>1),e.preventDefault()},this.startSelect=function(e,t){e=e||this.editor.renderer.screenToTextCoordinates(this.x,this.y);var n=this.editor;n.$blockScrolling++,this.mousedownEvent.getShiftKey()?n.selection.selectToPosition(e):t||n.selection.moveToPosition(e),t||this.select(),n.renderer.scroller.setCapture&&n.renderer.scroller.setCapture(),n.setStyle("ace_selecting"),this.setState("select"),n.$blockScrolling--},this.select=function(){var e,t=this.editor,n=t.renderer.screenToTextCoordinates(this.x,this.y);t.$blockScrolling++;if(this.$clickSelection){var r=this.$clickSelection.comparePoint(n);if(r==-1)e=this.$clickSelection.end;else if(r==1)e=this.$clickSelection.start;else{var i=f(this.$clickSelection,n);n=i.cursor,e=i.anchor}t.selection.setSelectionAnchor(e.row,e.column)}t.selection.selectToPosition(n),t.$blockScrolling--,t.renderer.scrollCursorIntoView()},this.extendSelectionBy=function(e){var t,n=this.editor,r=n.renderer.screenToTextCoordinates(this.x,this.y),i=n.selection[e](r.row,r.column);n.$blockScrolling++;if(this.$clickSelection){var s=this.$clickSelection.comparePoint(i.start),o=this.$clickSelection.comparePoint(i.end);if(s==-1&&o<=0){t=this.$clickSelection.end;if(i.end.row!=r.row||i.end.column!=r.column)r=i.start}else if(o==1&&s>=0){t=this.$clickSelection.start;if(i.start.row!=r.row||i.start.column!=r.column)r=i.end}else if(s==-1&&o==1)r=i.end,t=i.start;else{var u=f(this.$clickSelection,r);r=u.cursor,t=u.anchor}n.selection.setSelectionAnchor(t.row,t.column)}n.selection.selectToPosition(r),n.$blockScrolling--,n.renderer.scrollCursorIntoView()},this.selectEnd=this.selectAllEnd=this.selectByWordsEnd=this.selectByLinesEnd=function(){this.$clickSelection=null,this.editor.unsetStyle("ace_selecting"),this.editor.renderer.scroller.releaseCapture&&this.editor.renderer.scroller.releaseCapture()},this.focusWait=function(){var e=a(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y),t=Date.now();(e>o||t-this.mousedownEvent.time>this.$focusTimout)&&this.startSelect(this.mousedownEvent.getDocumentPosition())},this.onDoubleClick=function(e){var t=e.getDocumentPosition(),n=this.editor,r=n.session,i=r.getBracketRange(t);i?(i.isEmpty()&&(i.start.column--,i.end.column++),this.setState("select")):(i=n.selection.getWordRange(t.row,t.column),this.setState("selectByWords")),this.$clickSelection=i,this.select()},this.onTripleClick=function(e){var t=e.getDocumentPosition(),n=this.editor;this.setState("selectByLines");var r=n.getSelectionRange();r.isMultiLine()&&r.contains(t.row,t.column)?(this.$clickSelection=n.selection.getLineRange(r.start.row),this.$clickSelection.end=n.selection.getLineRange(r.end.row).end):this.$clickSelection=n.selection.getLineRange(t.row),this.select()},this.onQuadClick=function(e){var t=this.editor;t.selectAll(),this.$clickSelection=t.getSelectionRange(),this.setState("selectAll")},this.onMouseWheel=function(e){if(e.getAccelKey())return;e.getShiftKey()&&e.wheelY&&!e.wheelX&&(e.wheelX=e.wheelY,e.wheelY=0);var t=e.domEvent.timeStamp,n=t-(this.$lastScrollTime||0),r=this.editor,i=r.renderer.isScrollableBy(e.wheelX*e.speed,e.wheelY*e.speed);if(i||n<200)return this.$lastScrollTime=t,r.renderer.scrollBy(e.wheelX*e.speed,e.wheelY*e.speed),e.stop()},this.onTouchMove=function(e){var t=e.domEvent.timeStamp,n=t-(this.$lastScrollTime||0),r=this.editor,i=r.renderer.isScrollableBy(e.wheelX*e.speed,e.wheelY*e.speed);if(i||n<200)return this.$lastScrollTime=t,r.renderer.scrollBy(e.wheelX*e.speed,e.wheelY*e.speed),e.stop()}}).call(u.prototype),t.DefaultHandlers=u}),ace.define("ace/tooltip",["require","exports","module","ace/lib/oop","ace/lib/dom"],function(e,t,n){"use strict";function s(e){this.isOpen=!1,this.$element=null,this.$parentNode=e}var r=e("./lib/oop"),i=e("./lib/dom");(function(){this.$init=function(){return this.$element=i.createElement("div"),this.$element.className="ace_tooltip",this.$element.style.display="none",this.$parentNode.appendChild(this.$element),this.$element},this.getElement=function(){return this.$element||this.$init()},this.setText=function(e){i.setInnerText(this.getElement(),e)},this.setHtml=function(e){this.getElement().innerHTML=e},this.setPosition=function(e,t){this.getElement().style.left=e+"px",this.getElement().style.top=t+"px"},this.setClassName=function(e){i.addCssClass(this.getElement(),e)},this.show=function(e,t,n){e!=null&&this.setText(e),t!=null&&n!=null&&this.setPosition(t,n),this.isOpen||(this.getElement().style.display="block",this.isOpen=!0)},this.hide=function(){this.isOpen&&(this.getElement().style.display="none",this.isOpen=!1)},this.getHeight=function(){return this.getElement().offsetHeight},this.getWidth=function(){return this.getElement().offsetWidth}}).call(s.prototype),t.Tooltip=s}),ace.define("ace/mouse/default_gutter_handler",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/event","ace/tooltip"],function(e,t,n){"use strict";function u(e){function l(){var r=u.getDocumentPosition().row,s=n.$annotations[r];if(!s)return c();var o=t.session.getLength();if(r==o){var a=t.renderer.pixelToScreenCoordinates(0,u.y).row,l=u.$pos;if(a>t.session.documentToScreenRow(l.row,l.column))return c()}if(f==s)return;f=s.text.join("<br/>"),i.setHtml(f),i.show(),t._signal("showGutterTooltip",i),t.on("mousewheel",c);if(e.$tooltipFollowsMouse)h(u);else{var p=u.domEvent.target,d=p.getBoundingClientRect(),v=i.getElement().style;v.left=d.right+"px",v.top=d.bottom+"px"}}function c(){o&&(o=clearTimeout(o)),f&&(i.hide(),f=null,t._signal("hideGutterTooltip",i),t.removeEventListener("mousewheel",c))}function h(e){i.setPosition(e.x,e.y)}var t=e.editor,n=t.renderer.$gutterLayer,i=new a(t.container);e.editor.setDefaultHandler("guttermousedown",function(r){if(!t.isFocused()||r.getButton()!=0)return;var i=n.getRegion(r);if(i=="foldWidgets")return;var s=r.getDocumentPosition().row,o=t.session.selection;if(r.getShiftKey())o.selectTo(s,0);else{if(r.domEvent.detail==2)return t.selectAll(),r.preventDefault();e.$clickSelection=t.selection.getLineRange(s)}return e.setState("selectByLines"),e.captureMouse(r),r.preventDefault()});var o,u,f;e.editor.setDefaultHandler("guttermousemove",function(t){var n=t.domEvent.target||t.domEvent.srcElement;if(r.hasCssClass(n,"ace_fold-widget"))return c();f&&e.$tooltipFollowsMouse&&h(t),u=t;if(o)return;o=setTimeout(function(){o=null,u&&!e.isMousePressed?l():c()},50)}),s.addListener(t.renderer.$gutter,"mouseout",function(e){u=null;if(!f||o)return;o=setTimeout(function(){o=null,c()},50)}),t.on("changeSession",c)}function a(e){o.call(this,e)}var r=e("../lib/dom"),i=e("../lib/oop"),s=e("../lib/event"),o=e("../tooltip").Tooltip;i.inherits(a,o),function(){this.setPosition=function(e,t){var n=window.innerWidth||document.documentElement.clientWidth,r=window.innerHeight||document.documentElement.clientHeight,i=this.getWidth(),s=this.getHeight();e+=15,t+=15,e+i>n&&(e-=e+i-n),t+s>r&&(t-=20+s),o.prototype.setPosition.call(this,e,t)}}.call(a.prototype),t.GutterHandler=u}),ace.define("ace/mouse/mouse_event",["require","exports","module","ace/lib/event","ace/lib/useragent"],function(e,t,n){"use strict";var r=e("../lib/event"),i=e("../lib/useragent"),s=t.MouseEvent=function(e,t){this.domEvent=e,this.editor=t,this.x=this.clientX=e.clientX,this.y=this.clientY=e.clientY,this.$pos=null,this.$inSelection=null,this.propagationStopped=!1,this.defaultPrevented=!1};(function(){this.stopPropagation=function(){r.stopPropagation(this.domEvent),this.propagationStopped=!0},this.preventDefault=function(){r.preventDefault(this.domEvent),this.defaultPrevented=!0},this.stop=function(){this.stopPropagation(),this.preventDefault()},this.getDocumentPosition=function(){return this.$pos?this.$pos:(this.$pos=this.editor.renderer.screenToTextCoordinates(this.clientX,this.clientY),this.$pos)},this.inSelection=function(){if(this.$inSelection!==null)return this.$inSelection;var e=this.editor,t=e.getSelectionRange();if(t.isEmpty())this.$inSelection=!1;else{var n=this.getDocumentPosition();this.$inSelection=t.contains(n.row,n.column)}return this.$inSelection},this.getButton=function(){return r.getButton(this.domEvent)},this.getShiftKey=function(){return this.domEvent.shiftKey},this.getAccelKey=i.isMac?function(){return this.domEvent.metaKey}:function(){return this.domEvent.ctrlKey}}).call(s.prototype)}),ace.define("ace/mouse/dragdrop_handler",["require","exports","module","ace/lib/dom","ace/lib/event","ace/lib/useragent"],function(e,t,n){"use strict";function f(e){function T(e,n){var r=Date.now(),i=!n||e.row!=n.row,s=!n||e.column!=n.column;if(!S||i||s)t.$blockScrolling+=1,t.moveCursorToPosition(e),t.$blockScrolling-=1,S=r,x={x:p,y:d};else{var o=l(x.x,x.y,p,d);o>a?S=null:r-S>=u&&(t.renderer.scrollCursorIntoView(),S=null)}}function N(e,n){var r=Date.now(),i=t.renderer.layerConfig.lineHeight,s=t.renderer.layerConfig.characterWidth,u=t.renderer.scroller.getBoundingClientRect(),a={x:{left:p-u.left,right:u.right-p},y:{top:d-u.top,bottom:u.bottom-d}},f=Math.min(a.x.left,a.x.right),l=Math.min(a.y.top,a.y.bottom),c={row:e.row,column:e.column};f/s<=2&&(c.column+=a.x.left<a.x.right?-3:2),l/i<=1&&(c.row+=a.y.top<a.y.bottom?-1:1);var h=e.row!=c.row,v=e.column!=c.column,m=!n||e.row!=n.row;h||v&&!m?E?r-E>=o&&t.renderer.scrollCursorIntoView(c):E=r:E=null}function C(){var e=g;g=t.renderer.screenToTextCoordinates(p,d),T(g,e),N(g,e)}function k(){m=t.selection.toOrientedRange(),h=t.session.addMarker(m,"ace_selection",t.getSelectionStyle()),t.clearSelection(),t.isFocused()&&t.renderer.$cursorLayer.setBlinking(!1),clearInterval(v),C(),v=setInterval(C,20),y=0,i.addListener(document,"mousemove",O)}function L(){clearInterval(v),t.session.removeMarker(h),h=null,t.$blockScrolling+=1,t.selection.fromOrientedRange(m),t.$blockScrolling-=1,t.isFocused()&&!w&&t.renderer.$cursorLayer.setBlinking(!t.getReadOnly()),m=null,g=null,y=0,E=null,S=null,i.removeListener(document,"mousemove",O)}function O(){A==null&&(A=setTimeout(function(){A!=null&&h&&L()},20))}function M(e){var t=e.types;return!t||Array.prototype.some.call(t,function(e){return e=="text/plain"||e=="Text"})}function _(e){var t=["copy","copymove","all","uninitialized"],n=["move","copymove","linkmove","all","uninitialized"],r=s.isMac?e.altKey:e.ctrlKey,i="uninitialized";try{i=e.dataTransfer.effectAllowed.toLowerCase()}catch(e){}var o="none";return r&&t.indexOf(i)>=0?o="copy":n.indexOf(i)>=0?o="move":t.indexOf(i)>=0&&(o="copy"),o}var t=e.editor,n=r.createElement("img");n.src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",s.isOpera&&(n.style.cssText="width:1px;height:1px;position:fixed;top:0;left:0;z-index:2147483647;opacity:0;");var f=["dragWait","dragWaitEnd","startDrag","dragReadyEnd","onMouseDrag"];f.forEach(function(t){e[t]=this[t]},this),t.addEventListener("mousedown",this.onMouseDown.bind(e));var c=t.container,h,p,d,v,m,g,y=0,b,w,E,S,x;this.onDragStart=function(e){if(this.cancelDrag||!c.draggable){var r=this;return setTimeout(function(){r.startSelect(),r.captureMouse(e)},0),e.preventDefault()}m=t.getSelectionRange();var i=e.dataTransfer;i.effectAllowed=t.getReadOnly()?"copy":"copyMove",s.isOpera&&(t.container.appendChild(n),n.scrollTop=0),i.setDragImage&&i.setDragImage(n,0,0),s.isOpera&&t.container.removeChild(n),i.clearData(),i.setData("Text",t.session.getTextRange()),w=!0,this.setState("drag")},this.onDragEnd=function(e){c.draggable=!1,w=!1,this.setState(null);if(!t.getReadOnly()){var n=e.dataTransfer.dropEffect;!b&&n=="move"&&t.session.remove(t.getSelectionRange()),t.renderer.$cursorLayer.setBlinking(!0)}this.editor.unsetStyle("ace_dragging"),this.editor.renderer.setCursorStyle("")},this.onDragEnter=function(e){if(t.getReadOnly()||!M(e.dataTransfer))return;return p=e.clientX,d=e.clientY,h||k(),y++,e.dataTransfer.dropEffect=b=_(e),i.preventDefault(e)},this.onDragOver=function(e){if(t.getReadOnly()||!M(e.dataTransfer))return;return p=e.clientX,d=e.clientY,h||(k(),y++),A!==null&&(A=null),e.dataTransfer.dropEffect=b=_(e),i.preventDefault(e)},this.onDragLeave=function(e){y--;if(y<=0&&h)return L(),b=null,i.preventDefault(e)},this.onDrop=function(e){if(!g)return;var n=e.dataTransfer;if(w)switch(b){case"move":m.contains(g.row,g.column)?m={start:g,end:g}:m=t.moveText(m,g);break;case"copy":m=t.moveText(m,g,!0)}else{var r=n.getData("Text");m={start:g,end:t.session.insert(g,r)},t.focus(),b=null}return L(),i.preventDefault(e)},i.addListener(c,"dragstart",this.onDragStart.bind(e)),i.addListener(c,"dragend",this.onDragEnd.bind(e)),i.addListener(c,"dragenter",this.onDragEnter.bind(e)),i.addListener(c,"dragover",this.onDragOver.bind(e)),i.addListener(c,"dragleave",this.onDragLeave.bind(e)),i.addListener(c,"drop",this.onDrop.bind(e));var A=null}function l(e,t,n,r){return Math.sqrt(Math.pow(n-e,2)+Math.pow(r-t,2))}var r=e("../lib/dom"),i=e("../lib/event"),s=e("../lib/useragent"),o=200,u=200,a=5;(function(){this.dragWait=function(){var e=Date.now()-this.mousedownEvent.time;e>this.editor.getDragDelay()&&this.startDrag()},this.dragWaitEnd=function(){var e=this.editor.container;e.draggable=!1,this.startSelect(this.mousedownEvent.getDocumentPosition()),this.selectEnd()},this.dragReadyEnd=function(e){this.editor.renderer.$cursorLayer.setBlinking(!this.editor.getReadOnly()),this.editor.unsetStyle("ace_dragging"),this.editor.renderer.setCursorStyle(""),this.dragWaitEnd()},this.startDrag=function(){this.cancelDrag=!1;var e=this.editor,t=e.container;t.draggable=!0,e.renderer.$cursorLayer.setBlinking(!1),e.setStyle("ace_dragging");var n=s.isWin?"default":"move";e.renderer.setCursorStyle(n),this.setState("dragReady")},this.onMouseDrag=function(e){var t=this.editor.container;if(s.isIE&&this.state=="dragReady"){var n=l(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y);n>3&&t.dragDrop()}if(this.state==="dragWait"){var n=l(this.mousedownEvent.x,this.mousedownEvent.y,this.x,this.y);n>0&&(t.draggable=!1,this.startSelect(this.mousedownEvent.getDocumentPosition()))}},this.onMouseDown=function(e){if(!this.$dragEnabled)return;this.mousedownEvent=e;var t=this.editor,n=e.inSelection(),r=e.getButton(),i=e.domEvent.detail||1;if(i===1&&r===0&&n){if(e.editor.inMultiSelectMode&&(e.getAccelKey()||e.getShiftKey()))return;this.mousedownEvent.time=Date.now();var o=e.domEvent.target||e.domEvent.srcElement;"unselectable"in o&&(o.unselectable="on");if(t.getDragDelay()){if(s.isWebKit){this.cancelDrag=!0;var u=t.container;u.draggable=!0}this.setState("dragWait")}else this.startDrag();this.captureMouse(e,this.onMouseDrag.bind(this)),e.defaultPrevented=!0}}}).call(f.prototype),t.DragdropHandler=f}),ace.define("ace/lib/net",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("./dom");t.get=function(e,t){var n=new XMLHttpRequest;n.open("GET",e,!0),n.onreadystatechange=function(){n.readyState===4&&t(n.responseText)},n.send(null)},t.loadScript=function(e,t){var n=r.getDocumentHead(),i=document.createElement("script");i.src=e,n.appendChild(i),i.onload=i.onreadystatechange=function(e,n){if(n||!i.readyState||i.readyState=="loaded"||i.readyState=="complete")i=i.onload=i.onreadystatechange=null,n||t()}},t.qualifyURL=function(e){var t=document.createElement("a");return t.href=e,t.href}}),ace.define("ace/lib/event_emitter",["require","exports","module"],function(e,t,n){"use strict";var r={},i=function(){this.propagationStopped=!0},s=function(){this.defaultPrevented=!0};r._emit=r._dispatchEvent=function(e,t){this._eventRegistry||(this._eventRegistry={}),this._defaultHandlers||(this._defaultHandlers={});var n=this._eventRegistry[e]||[],r=this._defaultHandlers[e];if(!n.length&&!r)return;if(typeof t!="object"||!t)t={};t.type||(t.type=e),t.stopPropagation||(t.stopPropagation=i),t.preventDefault||(t.preventDefault=s),n=n.slice();for(var o=0;o<n.length;o++){n[o](t,this);if(t.propagationStopped)break}if(r&&!t.defaultPrevented)return r(t,this)},r._signal=function(e,t){var n=(this._eventRegistry||{})[e];if(!n)return;n=n.slice();for(var r=0;r<n.length;r++)n[r](t,this)},r.once=function(e,t){var n=this;t&&this.addEventListener(e,function r(){n.removeEventListener(e,r),t.apply(null,arguments)})},r.setDefaultHandler=function(e,t){var n=this._defaultHandlers;n||(n=this._defaultHandlers={_disabled_:{}});if(n[e]){var r=n[e],i=n._disabled_[e];i||(n._disabled_[e]=i=[]),i.push(r);var s=i.indexOf(t);s!=-1&&i.splice(s,1)}n[e]=t},r.removeDefaultHandler=function(e,t){var n=this._defaultHandlers;if(!n)return;var r=n._disabled_[e];if(n[e]==t){var i=n[e];r&&this.setDefaultHandler(e,r.pop())}else if(r){var s=r.indexOf(t);s!=-1&&r.splice(s,1)}},r.on=r.addEventListener=function(e,t,n){this._eventRegistry=this._eventRegistry||{};var r=this._eventRegistry[e];return r||(r=this._eventRegistry[e]=[]),r.indexOf(t)==-1&&r[n?"unshift":"push"](t),t},r.off=r.removeListener=r.removeEventListener=function(e,t){this._eventRegistry=this._eventRegistry||{};var n=this._eventRegistry[e];if(!n)return;var r=n.indexOf(t);r!==-1&&n.splice(r,1)},r.removeAllListeners=function(e){this._eventRegistry&&(this._eventRegistry[e]=[])},t.EventEmitter=r}),ace.define("ace/lib/app_config",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,n){"no use strict";function o(e){typeof console!="undefined"&&console.warn&&console.warn.apply(console,arguments)}function u(e,t){var n=new Error(e);n.data=t,typeof console=="object"&&console.error&&console.error(n),setTimeout(function(){throw n})}var r=e("./oop"),i=e("./event_emitter").EventEmitter,s={setOptions:function(e){Object.keys(e).forEach(function(t){this.setOption(t,e[t])},this)},getOptions:function(e){var t={};return e?Array.isArray(e)||(t=e,e=Object.keys(t)):e=Object.keys(this.$options),e.forEach(function(e){t[e]=this.getOption(e)},this),t},setOption:function(e,t){if(this["$"+e]===t)return;var n=this.$options[e];if(!n)return o('misspelled option "'+e+'"');if(n.forwardTo)return this[n.forwardTo]&&this[n.forwardTo].setOption(e,t);n.handlesSet||(this["$"+e]=t),n&&n.set&&n.set.call(this,t)},getOption:function(e){var t=this.$options[e];return t?t.forwardTo?this[t.forwardTo]&&this[t.forwardTo].getOption(e):t&&t.get?t.get.call(this):this["$"+e]:o('misspelled option "'+e+'"')}},a=function(){this.$defaultOptions={}};(function(){r.implement(this,i),this.defineOptions=function(e,t,n){return e.$options||(this.$defaultOptions[t]=e.$options={}),Object.keys(n).forEach(function(t){var r=n[t];typeof r=="string"&&(r={forwardTo:r}),r.name||(r.name=t),e.$options[r.name]=r,"initialValue"in r&&(e["$"+r.name]=r.initialValue)}),r.implement(e,s),this},this.resetOptions=function(e){Object.keys(e.$options).forEach(function(t){var n=e.$options[t];"value"in n&&e.setOption(t,n.value)})},this.setDefaultValue=function(e,t,n){var r=this.$defaultOptions[e]||(this.$defaultOptions[e]={});r[t]&&(r.forwardTo?this.setDefaultValue(r.forwardTo,t,n):r[t].value=n)},this.setDefaultValues=function(e,t){Object.keys(t).forEach(function(n){this.setDefaultValue(e,n,t[n])},this)},this.warn=o,this.reportError=u}).call(a.prototype),t.AppConfig=a}),ace.define("ace/config",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/lib/net","ace/lib/app_config"],function(e,t,n){"no use strict";function f(r){if(!u||!u.document)return;a.packaged=r||e.packaged||n.packaged||u.define&&__webpack_require__(1227).packaged;var i={},s="",o=document.currentScript||document._currentScript,f=o&&o.ownerDocument||document,c=f.getElementsByTagName("script");for(var h=0;h<c.length;h++){var p=c[h],d=p.src||p.getAttribute("src");if(!d)continue;var v=p.attributes;for(var m=0,g=v.length;m<g;m++){var y=v[m];y.name.indexOf("data-ace-")===0&&(i[l(y.name.replace(/^data-ace-/,""))]=y.value)}var b=d.match(/^(.*)\/ace(\-\w+)?\.js(\?|$)/);b&&(s=b[1])}s&&(i.base=i.base||s,i.packaged=!0),i.basePath=i.base,i.workerPath=i.workerPath||i.base,i.modePath=i.modePath||i.base,i.themePath=i.themePath||i.base,delete i.base;for(var w in i)typeof i[w]!="undefined"&&t.set(w,i[w])}function l(e){return e.replace(/-(.)/g,function(e,t){return t.toUpperCase()})}var r=e("./lib/lang"),i=e("./lib/oop"),s=e("./lib/net"),o=e("./lib/app_config").AppConfig;n.exports=t=new o;var u=function(){return this||typeof window!="undefined"&&window}(),a={packaged:!1,workerPath:null,modePath:null,themePath:null,basePath:"",suffix:".js",$moduleUrls:{}};t.get=function(e){if(!a.hasOwnProperty(e))throw new Error("Unknown config key: "+e);return a[e]},t.set=function(e,t){if(!a.hasOwnProperty(e))throw new Error("Unknown config key: "+e);a[e]=t},t.all=function(){return r.copyObject(a)},t.moduleUrl=function(e,t){if(a.$moduleUrls[e])return a.$moduleUrls[e];var n=e.split("/");t=t||n[n.length-2]||"";var r=t=="snippets"?"/":"-",i=n[n.length-1];if(t=="worker"&&r=="-"){var s=new RegExp("^"+t+"[\\-_]|[\\-_]"+t+"$","g");i=i.replace(s,"")}(!i||i==t)&&n.length>1&&(i=n[n.length-2]);var o=a[t+"Path"];return o==null?o=a.basePath:r=="/"&&(t=r=""),o&&o.slice(-1)!="/"&&(o+="/"),o+t+r+i+this.get("suffix")},t.setModuleUrl=function(e,t){return a.$moduleUrls[e]=t},t.$loading={},t.loadModule=function(n,r){var i,o;Array.isArray(n)&&(o=n[0],n=n[1]);try{i=e(n)}catch(u){}if(i&&!t.$loading[n])return r&&r(i);t.$loading[n]||(t.$loading[n]=[]),t.$loading[n].push(r);if(t.$loading[n].length>1)return;var a=function(){e([n],function(e){t._emit("load.module",{name:n,module:e});var r=t.$loading[n];t.$loading[n]=null,r.forEach(function(t){t&&t(e)})})};if(!t.get("packaged"))return a();s.loadScript(t.moduleUrl(n,o),a)},t.init=f}),ace.define("ace/mouse/mouse_handler",["require","exports","module","ace/lib/event","ace/lib/useragent","ace/mouse/default_handlers","ace/mouse/default_gutter_handler","ace/mouse/mouse_event","ace/mouse/dragdrop_handler","ace/config"],function(e,t,n){"use strict";var r=e("../lib/event"),i=e("../lib/useragent"),s=e("./default_handlers").DefaultHandlers,o=e("./default_gutter_handler").GutterHandler,u=e("./mouse_event").MouseEvent,a=e("./dragdrop_handler").DragdropHandler,f=e("../config"),l=function(e){var t=this;this.editor=e,new s(this),new o(this),new a(this);var n=function(t){var n=!document.hasFocus||!document.hasFocus()||!e.isFocused()&&document.activeElement==(e.textInput&&e.textInput.getElement());n&&window.focus(),e.focus()},u=e.renderer.getMouseEventTarget();r.addListener(u,"click",this.onMouseEvent.bind(this,"click")),r.addListener(u,"mousemove",this.onMouseMove.bind(this,"mousemove")),r.addMultiMouseDownListener([u,e.renderer.scrollBarV&&e.renderer.scrollBarV.inner,e.renderer.scrollBarH&&e.renderer.scrollBarH.inner,e.textInput&&e.textInput.getElement()].filter(Boolean),[400,300,250],this,"onMouseEvent"),r.addMouseWheelListener(e.container,this.onMouseWheel.bind(this,"mousewheel")),r.addTouchMoveListener(e.container,this.onTouchMove.bind(this,"touchmove"));var f=e.renderer.$gutter;r.addListener(f,"mousedown",this.onMouseEvent.bind(this,"guttermousedown")),r.addListener(f,"click",this.onMouseEvent.bind(this,"gutterclick")),r.addListener(f,"dblclick",this.onMouseEvent.bind(this,"gutterdblclick")),r.addListener(f,"mousemove",this.onMouseEvent.bind(this,"guttermousemove")),r.addListener(u,"mousedown",n),r.addListener(f,"mousedown",n),i.isIE&&e.renderer.scrollBarV&&(r.addListener(e.renderer.scrollBarV.element,"mousedown",n),r.addListener(e.renderer.scrollBarH.element,"mousedown",n)),e.on("mousemove",function(n){if(t.state||t.$dragDelay||!t.$dragEnabled)return;var r=e.renderer.screenToTextCoordinates(n.x,n.y),i=e.session.selection.getRange(),s=e.renderer;!i.isEmpty()&&i.insideStart(r.row,r.column)?s.setCursorStyle("default"):s.setCursorStyle("")})};(function(){this.onMouseEvent=function(e,t){this.editor._emit(e,new u(t,this.editor))},this.onMouseMove=function(e,t){var n=this.editor._eventRegistry&&this.editor._eventRegistry.mousemove;if(!n||!n.length)return;this.editor._emit(e,new u(t,this.editor))},this.onMouseWheel=function(e,t){var n=new u(t,this.editor);n.speed=this.$scrollSpeed*2,n.wheelX=t.wheelX,n.wheelY=t.wheelY,this.editor._emit(e,n)},this.onTouchMove=function(e,t){var n=new u(t,this.editor);n.speed=1,n.wheelX=t.wheelX,n.wheelY=t.wheelY,this.editor._emit(e,n)},this.setState=function(e){this.state=e},this.captureMouse=function(e,t){this.x=e.x,this.y=e.y,this.isMousePressed=!0;var n=this.editor.renderer;n.$keepTextAreaAtCursor&&(n.$keepTextAreaAtCursor=null);var s=this,o=function(e){if(!e)return;if(i.isWebKit&&!e.which&&s.releaseMouse)return s.releaseMouse();s.x=e.clientX,s.y=e.clientY,t&&t(e),s.mouseEvent=new u(e,s.editor),s.$mouseMoved=!0},a=function(e){clearInterval(l),f(),s[s.state+"End"]&&s[s.state+"End"](e),s.state="",n.$keepTextAreaAtCursor==null&&(n.$keepTextAreaAtCursor=!0,n.$moveTextAreaToCursor()),s.isMousePressed=!1,s.$onCaptureMouseMove=s.releaseMouse=null,e&&s.onMouseEvent("mouseup",e)},f=function(){s[s.state]&&s[s.state](),s.$mouseMoved=!1};if(i.isOldIE&&e.domEvent.type=="dblclick")return setTimeout(function(){a(e)});s.$onCaptureMouseMove=o,s.releaseMouse=r.capture(this.editor.container,o,a);var l=setInterval(f,20)},this.releaseMouse=null,this.cancelContextMenu=function(){var e=function(t){if(t&&t.domEvent&&t.domEvent.type!="contextmenu")return;this.editor.off("nativecontextmenu",e),t&&t.domEvent&&r.stopEvent(t.domEvent)}.bind(this);setTimeout(e,10),this.editor.on("nativecontextmenu",e)}}).call(l.prototype),f.defineOptions(l.prototype,"mouseHandler",{scrollSpeed:{initialValue:2},dragDelay:{initialValue:i.isMac?150:0},dragEnabled:{initialValue:!0},focusTimout:{initialValue:0},tooltipFollowsMouse:{initialValue:!0}}),t.MouseHandler=l}),ace.define("ace/mouse/fold_handler",["require","exports","module"],function(e,t,n){"use strict";function r(e){e.on("click",function(t){var n=t.getDocumentPosition(),r=e.session,i=r.getFoldAt(n.row,n.column,1);i&&(t.getAccelKey()?r.removeFold(i):r.expandFold(i),t.stop())}),e.on("gutterclick",function(t){var n=e.renderer.$gutterLayer.getRegion(t);if(n=="foldWidgets"){var r=t.getDocumentPosition().row,i=e.session;i.foldWidgets&&i.foldWidgets[r]&&e.session.onFoldWidgetClick(r,t),e.isFocused()||e.focus(),t.stop()}}),e.on("gutterdblclick",function(t){var n=e.renderer.$gutterLayer.getRegion(t);if(n=="foldWidgets"){var r=t.getDocumentPosition().row,i=e.session,s=i.getParentFoldRangeData(r,!0),o=s.range||s.firstRange;if(o){r=o.start.row;var u=i.getFoldAt(r,i.getLine(r).length,1);u?i.removeFold(u):(i.addFold("...",o),e.renderer.scrollCursorIntoView({row:o.start.row,column:0}))}t.stop()}})}t.FoldHandler=r}),ace.define("ace/keyboard/keybinding",["require","exports","module","ace/lib/keys","ace/lib/event"],function(e,t,n){"use strict";var r=e("../lib/keys"),i=e("../lib/event"),s=function(e){this.$editor=e,this.$data={editor:e},this.$handlers=[],this.setDefaultHandler(e.commands)};(function(){this.setDefaultHandler=function(e){this.removeKeyboardHandler(this.$defaultHandler),this.$defaultHandler=e,this.addKeyboardHandler(e,0)},this.setKeyboardHandler=function(e){var t=this.$handlers;if(t[t.length-1]==e)return;while(t[t.length-1]&&t[t.length-1]!=this.$defaultHandler)this.removeKeyboardHandler(t[t.length-1]);this.addKeyboardHandler(e,1)},this.addKeyboardHandler=function(e,t){if(!e)return;typeof e=="function"&&!e.handleKeyboard&&(e.handleKeyboard=e);var n=this.$handlers.indexOf(e);n!=-1&&this.$handlers.splice(n,1),t==undefined?this.$handlers.push(e):this.$handlers.splice(t,0,e),n==-1&&e.attach&&e.attach(this.$editor)},this.removeKeyboardHandler=function(e){var t=this.$handlers.indexOf(e);return t==-1?!1:(this.$handlers.splice(t,1),e.detach&&e.detach(this.$editor),!0)},this.getKeyboardHandler=function(){return this.$handlers[this.$handlers.length-1]},this.getStatusText=function(){var e=this.$data,t=e.editor;return this.$handlers.map(function(n){return n.getStatusText&&n.getStatusText(t,e)||""}).filter(Boolean).join(" ")},this.$callKeyboardHandlers=function(e,t,n,r){var s,o=!1,u=this.$editor.commands;for(var a=this.$handlers.length;a--;){s=this.$handlers[a].handleKeyboard(this.$data,e,t,n,r);if(!s||!s.command)continue;s.command=="null"?o=!0:o=u.exec(s.command,this.$editor,s.args,r),o&&r&&e!=-1&&s.passEvent!=1&&s.command.passEvent!=1&&i.stopEvent(r);if(o)break}return!o&&e==-1&&(s={command:"insertstring"},o=u.exec("insertstring",this.$editor,t)),o&&this.$editor._signal&&this.$editor._signal("keyboardActivity",s),o},this.onCommandKey=function(e,t,n){var i=r.keyCodeToString(n);this.$callKeyboardHandlers(t,i,n,e)},this.onTextInput=function(e){this.$callKeyboardHandlers(-1,e)}}).call(s.prototype),t.KeyBinding=s}),ace.define("ace/range",["require","exports","module"],function(e,t,n){"use strict";var r=function(e,t){return e.row-t.row||e.column-t.column},i=function(e,t,n,r){this.start={row:e,column:t},this.end={row:n,column:r}};(function(){this.isEqual=function(e){return this.start.row===e.start.row&&this.end.row===e.end.row&&this.start.column===e.start.column&&this.end.column===e.end.column},this.toString=function(){return"Range: ["+this.start.row+"/"+this.start.column+"] -> ["+this.end.row+"/"+this.end.column+"]"},this.contains=function(e,t){return this.compare(e,t)==0},this.compareRange=function(e){var t,n=e.end,r=e.start;return t=this.compare(n.row,n.column),t==1?(t=this.compare(r.row,r.column),t==1?2:t==0?1:0):t==-1?-2:(t=this.compare(r.row,r.column),t==-1?-1:t==1?42:0)},this.comparePoint=function(e){return this.compare(e.row,e.column)},this.containsRange=function(e){return this.comparePoint(e.start)==0&&this.comparePoint(e.end)==0},this.intersects=function(e){var t=this.compareRange(e);return t==-1||t==0||t==1},this.isEnd=function(e,t){return this.end.row==e&&this.end.column==t},this.isStart=function(e,t){return this.start.row==e&&this.start.column==t},this.setStart=function(e,t){typeof e=="object"?(this.start.column=e.column,this.start.row=e.row):(this.start.row=e,this.start.column=t)},this.setEnd=function(e,t){typeof e=="object"?(this.end.column=e.column,this.end.row=e.row):(this.end.row=e,this.end.column=t)},this.inside=function(e,t){return this.compare(e,t)==0?this.isEnd(e,t)||this.isStart(e,t)?!1:!0:!1},this.insideStart=function(e,t){return this.compare(e,t)==0?this.isEnd(e,t)?!1:!0:!1},this.insideEnd=function(e,t){return this.compare(e,t)==0?this.isStart(e,t)?!1:!0:!1},this.compare=function(e,t){return!this.isMultiLine()&&e===this.start.row?t<this.start.column?-1:t>this.end.column?1:0:e<this.start.row?-1:e>this.end.row?1:this.start.row===e?t>=this.start.column?0:-1:this.end.row===e?t<=this.end.column?0:1:0},this.compareStart=function(e,t){return this.start.row==e&&this.start.column==t?-1:this.compare(e,t)},this.compareEnd=function(e,t){return this.end.row==e&&this.end.column==t?1:this.compare(e,t)},this.compareInside=function(e,t){return this.end.row==e&&this.end.column==t?1:this.start.row==e&&this.start.column==t?-1:this.compare(e,t)},this.clipRows=function(e,t){if(this.end.row>t)var n={row:t+1,column:0};else if(this.end.row<e)var n={row:e,column:0};if(this.start.row>t)var r={row:t+1,column:0};else if(this.start.row<e)var r={row:e,column:0};return i.fromPoints(r||this.start,n||this.end)},this.extend=function(e,t){var n=this.compare(e,t);if(n==0)return this;if(n==-1)var r={row:e,column:t};else var s={row:e,column:t};return i.fromPoints(r||this.start,s||this.end)},this.isEmpty=function(){return this.start.row===this.end.row&&this.start.column===this.end.column},this.isMultiLine=function(){return this.start.row!==this.end.row},this.clone=function(){return i.fromPoints(this.start,this.end)},this.collapseRows=function(){return this.end.column==0?new i(this.start.row,0,Math.max(this.start.row,this.end.row-1),0):new i(this.start.row,0,this.end.row,0)},this.toScreenRange=function(e){var t=e.documentToScreenPosition(this.start),n=e.documentToScreenPosition(this.end);return new i(t.row,t.column,n.row,n.column)},this.moveBy=function(e,t){this.start.row+=e,this.start.column+=t,this.end.row+=e,this.end.column+=t}}).call(i.prototype),i.fromPoints=function(e,t){return new i(e.row,e.column,t.row,t.column)},i.comparePoints=r,i.comparePoints=function(e,t){return e.row-t.row||e.column-t.column},t.Range=i}),ace.define("ace/selection",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter","ace/range"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/lang"),s=e("./lib/event_emitter").EventEmitter,o=e("./range").Range,u=function(e){this.session=e,this.doc=e.getDocument(),this.clearSelection(),this.lead=this.selectionLead=this.doc.createAnchor(0,0),this.anchor=this.selectionAnchor=this.doc.createAnchor(0,0);var t=this;this.lead.on("change",function(e){t._emit("changeCursor"),t.$isEmpty||t._emit("changeSelection"),!t.$keepDesiredColumnOnChange&&e.old.column!=e.value.column&&(t.$desiredColumn=null)}),this.selectionAnchor.on("change",function(){t.$isEmpty||t._emit("changeSelection")})};(function(){r.implement(this,s),this.isEmpty=function(){return this.$isEmpty||this.anchor.row==this.lead.row&&this.anchor.column==this.lead.column},this.isMultiLine=function(){return this.isEmpty()?!1:this.getRange().isMultiLine()},this.getCursor=function(){return this.lead.getPosition()},this.setSelectionAnchor=function(e,t){this.anchor.setPosition(e,t),this.$isEmpty&&(this.$isEmpty=!1,this._emit("changeSelection"))},this.getSelectionAnchor=function(){return this.$isEmpty?this.getSelectionLead():this.anchor.getPosition()},this.getSelectionLead=function(){return this.lead.getPosition()},this.shiftSelection=function(e){if(this.$isEmpty){this.moveCursorTo(this.lead.row,this.lead.column+e);return}var t=this.getSelectionAnchor(),n=this.getSelectionLead(),r=this.isBackwards();(!r||t.column!==0)&&this.setSelectionAnchor(t.row,t.column+e),(r||n.column!==0)&&this.$moveSelection(function(){this.moveCursorTo(n.row,n.column+e)})},this.isBackwards=function(){var e=this.anchor,t=this.lead;return e.row>t.row||e.row==t.row&&e.column>t.column},this.getRange=function(){var e=this.anchor,t=this.lead;return this.isEmpty()?o.fromPoints(t,t):this.isBackwards()?o.fromPoints(t,e):o.fromPoints(e,t)},this.clearSelection=function(){this.$isEmpty||(this.$isEmpty=!0,this._emit("changeSelection"))},this.selectAll=function(){var e=this.doc.getLength()-1;this.setSelectionAnchor(0,0),this.moveCursorTo(e,this.doc.getLine(e).length)},this.setRange=this.setSelectionRange=function(e,t){t?(this.setSelectionAnchor(e.end.row,e.end.column),this.selectTo(e.start.row,e.start.column)):(this.setSelectionAnchor(e.start.row,e.start.column),this.selectTo(e.end.row,e.end.column)),this.getRange().isEmpty()&&(this.$isEmpty=!0),this.$desiredColumn=null},this.$moveSelection=function(e){var t=this.lead;this.$isEmpty&&this.setSelectionAnchor(t.row,t.column),e.call(this)},this.selectTo=function(e,t){this.$moveSelection(function(){this.moveCursorTo(e,t)})},this.selectToPosition=function(e){this.$moveSelection(function(){this.moveCursorToPosition(e)})},this.moveTo=function(e,t){this.clearSelection(),this.moveCursorTo(e,t)},this.moveToPosition=function(e){this.clearSelection(),this.moveCursorToPosition(e)},this.selectUp=function(){this.$moveSelection(this.moveCursorUp)},this.selectDown=function(){this.$moveSelection(this.moveCursorDown)},this.selectRight=function(){this.$moveSelection(this.moveCursorRight)},this.selectLeft=function(){this.$moveSelection(this.moveCursorLeft)},this.selectLineStart=function(){this.$moveSelection(this.moveCursorLineStart)},this.selectLineEnd=function(){this.$moveSelection(this.moveCursorLineEnd)},this.selectFileEnd=function(){this.$moveSelection(this.moveCursorFileEnd)},this.selectFileStart=function(){this.$moveSelection(this.moveCursorFileStart)},this.selectWordRight=function(){this.$moveSelection(this.moveCursorWordRight)},this.selectWordLeft=function(){this.$moveSelection(this.moveCursorWordLeft)},this.getWordRange=function(e,t){if(typeof t=="undefined"){var n=e||this.lead;e=n.row,t=n.column}return this.session.getWordRange(e,t)},this.selectWord=function(){this.setSelectionRange(this.getWordRange())},this.selectAWord=function(){var e=this.getCursor(),t=this.session.getAWordRange(e.row,e.column);this.setSelectionRange(t)},this.getLineRange=function(e,t){var n=typeof e=="number"?e:this.lead.row,r,i=this.session.getFoldLine(n);return i?(n=i.start.row,r=i.end.row):r=n,t===!0?new o(n,0,r,this.session.getLine(r).length):new o(n,0,r+1,0)},this.selectLine=function(){this.setSelectionRange(this.getLineRange())},this.moveCursorUp=function(){this.moveCursorBy(-1,0)},this.moveCursorDown=function(){this.moveCursorBy(1,0)},this.moveCursorLeft=function(){var e=this.lead.getPosition(),t;if(t=this.session.getFoldAt(e.row,e.column,-1))this.moveCursorTo(t.start.row,t.start.column);else if(e.column===0)e.row>0&&this.moveCursorTo(e.row-1,this.doc.getLine(e.row-1).length);else{var n=this.session.getTabSize();this.session.isTabStop(e)&&this.doc.getLine(e.row).slice(e.column-n,e.column).split(" ").length-1==n?this.moveCursorBy(0,-n):this.moveCursorBy(0,-1)}},this.moveCursorRight=function(){var e=this.lead.getPosition(),t;if(t=this.session.getFoldAt(e.row,e.column,1))this.moveCursorTo(t.end.row,t.end.column);else if(this.lead.column==this.doc.getLine(this.lead.row).length)this.lead.row<this.doc.getLength()-1&&this.moveCursorTo(this.lead.row+1,0);else{var n=this.session.getTabSize(),e=this.lead;this.session.isTabStop(e)&&this.doc.getLine(e.row).slice(e.column,e.column+n).split(" ").length-1==n?this.moveCursorBy(0,n):this.moveCursorBy(0,1)}},this.moveCursorLineStart=function(){var e=this.lead.row,t=this.lead.column,n=this.session.documentToScreenRow(e,t),r=this.session.screenToDocumentPosition(n,0),i=this.session.getDisplayLine(e,null,r.row,r.column),s=i.match(/^\s*/);s[0].length!=t&&!this.session.$useEmacsStyleLineStart&&(r.column+=s[0].length),this.moveCursorToPosition(r)},this.moveCursorLineEnd=function(){var e=this.lead,t=this.session.getDocumentLastRowColumnPosition(e.row,e.column);if(this.lead.column==t.column){var n=this.session.getLine(t.row);if(t.column==n.length){var r=n.search(/\s+$/);r>0&&(t.column=r)}}this.moveCursorTo(t.row,t.column)},this.moveCursorFileEnd=function(){var e=this.doc.getLength()-1,t=this.doc.getLine(e).length;this.moveCursorTo(e,t)},this.moveCursorFileStart=function(){this.moveCursorTo(0,0)},this.moveCursorLongWordRight=function(){var e=this.lead.row,t=this.lead.column,n=this.doc.getLine(e),r=n.substring(t),i;this.session.nonTokenRe.lastIndex=0,this.session.tokenRe.lastIndex=0;var s=this.session.getFoldAt(e,t,1);if(s){this.moveCursorTo(s.end.row,s.end.column);return}if(i=this.session.nonTokenRe.exec(r))t+=this.session.nonTokenRe.lastIndex,this.session.nonTokenRe.lastIndex=0,r=n.substring(t);if(t>=n.length){this.moveCursorTo(e,n.length),this.moveCursorRight(),e<this.doc.getLength()-1&&this.moveCursorWordRight();return}if(i=this.session.tokenRe.exec(r))t+=this.session.tokenRe.lastIndex,this.session.tokenRe.lastIndex=0;this.moveCursorTo(e,t)},this.moveCursorLongWordLeft=function(){var e=this.lead.row,t=this.lead.column,n;if(n=this.session.getFoldAt(e,t,-1)){this.moveCursorTo(n.start.row,n.start.column);return}var r=this.session.getFoldStringAt(e,t,-1);r==null&&(r=this.doc.getLine(e).substring(0,t));var s=i.stringReverse(r),o;this.session.nonTokenRe.lastIndex=0,this.session.tokenRe.lastIndex=0;if(o=this.session.nonTokenRe.exec(s))t-=this.session.nonTokenRe.lastIndex,s=s.slice(this.session.nonTokenRe.lastIndex),this.session.nonTokenRe.lastIndex=0;if(t<=0){this.moveCursorTo(e,0),this.moveCursorLeft(),e>0&&this.moveCursorWordLeft();return}if(o=this.session.tokenRe.exec(s))t-=this.session.tokenRe.lastIndex,this.session.tokenRe.lastIndex=0;this.moveCursorTo(e,t)},this.$shortWordEndIndex=function(e){var t,n=0,r,i=/\s/,s=this.session.tokenRe;s.lastIndex=0;if(t=this.session.tokenRe.exec(e))n=this.session.tokenRe.lastIndex;else{while((r=e[n])&&i.test(r))n++;if(n<1){s.lastIndex=0;while((r=e[n])&&!s.test(r)){s.lastIndex=0,n++;if(i.test(r)){if(n>2){n--;break}while((r=e[n])&&i.test(r))n++;if(n>2)break}}}}return s.lastIndex=0,n},this.moveCursorShortWordRight=function(){var e=this.lead.row,t=this.lead.column,n=this.doc.getLine(e),r=n.substring(t),i=this.session.getFoldAt(e,t,1);if(i)return this.moveCursorTo(i.end.row,i.end.column);if(t==n.length){var s=this.doc.getLength();do e++,r=this.doc.getLine(e);while(e<s&&/^\s*$/.test(r));/^\s+/.test(r)||(r=""),t=0}var o=this.$shortWordEndIndex(r);this.moveCursorTo(e,t+o)},this.moveCursorShortWordLeft=function(){var e=this.lead.row,t=this.lead.column,n;if(n=this.session.getFoldAt(e,t,-1))return this.moveCursorTo(n.start.row,n.start.column);var r=this.session.getLine(e).substring(0,t);if(t===0){do e--,r=this.doc.getLine(e);while(e>0&&/^\s*$/.test(r));t=r.length,/\s+$/.test(r)||(r="")}var s=i.stringReverse(r),o=this.$shortWordEndIndex(s);return this.moveCursorTo(e,t-o)},this.moveCursorWordRight=function(){this.session.$selectLongWords?this.moveCursorLongWordRight():this.moveCursorShortWordRight()},this.moveCursorWordLeft=function(){this.session.$selectLongWords?this.moveCursorLongWordLeft():this.moveCursorShortWordLeft()},this.moveCursorBy=function(e,t){var n=this.session.documentToScreenPosition(this.lead.row,this.lead.column);t===0&&(this.$desiredColumn?n.column=this.$desiredColumn:this.$desiredColumn=n.column);var r=this.session.screenToDocumentPosition(n.row+e,n.column);e!==0&&t===0&&r.row===this.lead.row&&r.column===this.lead.column&&this.session.lineWidgets&&this.session.lineWidgets[r.row]&&(r.row>0||e>0)&&r.row++,this.moveCursorTo(r.row,r.column+t,t===0)},this.moveCursorToPosition=function(e){this.moveCursorTo(e.row,e.column)},this.moveCursorTo=function(e,t,n){var r=this.session.getFoldAt(e,t,1);r&&(e=r.start.row,t=r.start.column),this.$keepDesiredColumnOnChange=!0,this.lead.setPosition(e,t),this.$keepDesiredColumnOnChange=!1,n||(this.$desiredColumn=null)},this.moveCursorToScreen=function(e,t,n){var r=this.session.screenToDocumentPosition(e,t);this.moveCursorTo(r.row,r.column,n)},this.detach=function(){this.lead.detach(),this.anchor.detach(),this.session=this.doc=null},this.fromOrientedRange=function(e){this.setSelectionRange(e,e.cursor==e.start),this.$desiredColumn=e.desiredColumn||this.$desiredColumn},this.toOrientedRange=function(e){var t=this.getRange();return e?(e.start.column=t.start.column,e.start.row=t.start.row,e.end.column=t.end.column,e.end.row=t.end.row):e=t,e.cursor=this.isBackwards()?e.start:e.end,e.desiredColumn=this.$desiredColumn,e},this.getRangeOfMovements=function(e){var t=this.getCursor();try{e(this);var n=this.getCursor();return o.fromPoints(t,n)}catch(r){return o.fromPoints(t,t)}finally{this.moveCursorToPosition(t)}},this.toJSON=function(){if(this.rangeCount)var e=this.ranges.map(function(e){var t=e.clone();return t.isBackwards=e.cursor==e.start,t});else{var e=this.getRange();e.isBackwards=this.isBackwards()}return e},this.fromJSON=function(e){if(e.start==undefined){if(this.rangeList){this.toSingleRange(e[0]);for(var t=e.length;t--;){var n=o.fromPoints(e[t].start,e[t].end);e[t].isBackwards&&(n.cursor=n.start),this.addRange(n,!0)}return}e=e[0]}this.rangeList&&this.toSingleRange(e),this.setSelectionRange(e,e.isBackwards)},this.isEqual=function(e){if((e.length||this.rangeCount)&&e.length!=this.rangeCount)return!1;if(!e.length||!this.ranges)return this.getRange().isEqual(e);for(var t=this.ranges.length;t--;)if(!this.ranges[t].isEqual(e[t]))return!1;return!0}}).call(u.prototype),t.Selection=u}),ace.define("ace/tokenizer",["require","exports","module","ace/config"],function(e,t,n){"use strict";var r=e("./config"),i=2e3,s=function(e){this.states=e,this.regExps={},this.matchMappings={};for(var t in this.states){var n=this.states[t],r=[],i=0,s=this.matchMappings[t]={defaultToken:"text"},o="g",u=[];for(var a=0;a<n.length;a++){var f=n[a];f.defaultToken&&(s.defaultToken=f.defaultToken),f.caseInsensitive&&(o="gi");if(f.regex==null)continue;f.regex instanceof RegExp&&(f.regex=f.regex.toString().slice(1,-1));var l=f.regex,c=(new RegExp("(?:("+l+")|(.))")).exec("a").length-2;Array.isArray(f.token)?f.token.length==1||c==1?f.token=f.token[0]:c-1!=f.token.length?(this.reportError("number of classes and regexp groups doesn't match",{rule:f,groupCount:c-1}),f.token=f.token[0]):(f.tokenArray=f.token,f.token=null,f.onMatch=this.$arrayTokens):typeof f.token=="function"&&!f.onMatch&&(c>1?f.onMatch=this.$applyToken:f.onMatch=f.token),c>1&&(/\\\d/.test(f.regex)?l=f.regex.replace(/\\([0-9]+)/g,function(e,t){return"\\"+(parseInt(t,10)+i+1)}):(c=1,l=this.removeCapturingGroups(f.regex)),!f.splitRegex&&typeof f.token!="string"&&u.push(f)),s[i]=a,i+=c,r.push(l),f.onMatch||(f.onMatch=null)}r.length||(s[0]=0,r.push("$")),u.forEach(function(e){e.splitRegex=this.createSplitterRegexp(e.regex,o)},this),this.regExps[t]=new RegExp("("+r.join(")|(")+")|($)",o)}};(function(){this.$setMaxTokenCount=function(e){i=e|0},this.$applyToken=function(e){var t=this.splitRegex.exec(e).slice(1),n=this.token.apply(this,t);if(typeof n=="string")return[{type:n,value:e}];var r=[];for(var i=0,s=n.length;i<s;i++)t[i]&&(r[r.length]={type:n[i],value:t[i]});return r},this.$arrayTokens=function(e){if(!e)return[];var t=this.splitRegex.exec(e);if(!t)return"text";var n=[],r=this.tokenArray;for(var i=0,s=r.length;i<s;i++)t[i+1]&&(n[n.length]={type:r[i],value:t[i+1]});return n},this.removeCapturingGroups=function(e){var t=e.replace(/\[(?:\\.|[^\]])*?\]|\\.|\(\?[:=!]|(\()/g,function(e,t){return t?"(?:":e});return t},this.createSplitterRegexp=function(e,t){if(e.indexOf("(?=")!=-1){var n=0,r=!1,i={};e.replace(/(\\.)|(\((?:\?[=!])?)|(\))|([\[\]])/g,function(e,t,s,o,u,a){return r?r=u!="]":u?r=!0:o?(n==i.stack&&(i.end=a+1,i.stack=-1),n--):s&&(n++,s.length!=1&&(i.stack=n,i.start=a)),e}),i.end!=null&&/^\)*$/.test(e.substr(i.end))&&(e=e.substring(0,i.start)+e.substr(i.end))}return e.charAt(0)!="^"&&(e="^"+e),e.charAt(e.length-1)!="$"&&(e+="$"),new RegExp(e,(t||"").replace("g",""))},this.getLineTokens=function(e,t){if(t&&typeof t!="string"){var n=t.slice(0);t=n[0],t==="#tmp"&&(n.shift(),t=n.shift())}else var n=[];var r=t||"start",s=this.states[r];s||(r="start",s=this.states[r]);var o=this.matchMappings[r],u=this.regExps[r];u.lastIndex=0;var a,f=[],l=0,c=0,h={type:null,value:""};while(a=u.exec(e)){var p=o.defaultToken,d=null,v=a[0],m=u.lastIndex;if(m-v.length>l){var g=e.substring(l,m-v.length);h.type==p?h.value+=g:(h.type&&f.push(h),h={type:p,value:g})}for(var y=0;y<a.length-2;y++){if(a[y+1]===undefined)continue;d=s[o[y]],d.onMatch?p=d.onMatch(v,r,n):p=d.token,d.next&&(typeof d.next=="string"?r=d.next:r=d.next(r,n),s=this.states[r],s||(this.reportError("state doesn't exist",r),r="start",s=this.states[r]),o=this.matchMappings[r],l=m,u=this.regExps[r],u.lastIndex=m);break}if(v)if(typeof p=="string")!!d&&d.merge===!1||h.type!==p?(h.type&&f.push(h),h={type:p,value:v}):h.value+=v;else if(p){h.type&&f.push(h),h={type:null,value:""};for(var y=0;y<p.length;y++)f.push(p[y])}if(l==e.length)break;l=m;if(c++>i){c>2*e.length&&this.reportError("infinite loop with in ace tokenizer",{startState:t,line:e});while(l<e.length)h.type&&f.push(h),h={value:e.substring(l,l+=2e3),type:"overflow"};r="start",n=[];break}}return h.type&&f.push(h),n.length>1&&n[0]!==r&&n.unshift("#tmp",r),{tokens:f,state:n.length?n:r}},this.reportError=r.reportError}).call(s.prototype),t.Tokenizer=s}),ace.define("ace/mode/text_highlight_rules",["require","exports","module","ace/lib/lang"],function(e,t,n){"use strict";var r=e("../lib/lang"),i=function(){this.$rules={start:[{token:"empty_line",regex:"^$"},{defaultToken:"text"}]}};(function(){this.addRules=function(e,t){if(!t){for(var n in e)this.$rules[n]=e[n];return}for(var n in e){var r=e[n];for(var i=0;i<r.length;i++){var s=r[i];if(s.next||s.onMatch)typeof s.next=="string"&&s.next.indexOf(t)!==0&&(s.next=t+s.next),s.nextState&&s.nextState.indexOf(t)!==0&&(s.nextState=t+s.nextState)}this.$rules[t+n]=r}},this.getRules=function(){return this.$rules},this.embedRules=function(e,t,n,i,s){var o=typeof e=="function"?(new e).getRules():e;if(i)for(var u=0;u<i.length;u++)i[u]=t+i[u];else{i=[];for(var a in o)i.push(t+a)}this.addRules(o,t);if(n){var f=Array.prototype[s?"push":"unshift"];for(var u=0;u<i.length;u++)f.apply(this.$rules[i[u]],r.deepCopy(n))}this.$embeds||(this.$embeds=[]),this.$embeds.push(t)},this.getEmbeds=function(){return this.$embeds};var e=function(e,t){return(e!="start"||t.length)&&t.unshift(this.nextState,e),this.nextState},t=function(e,t){return t.shift(),t.shift()||"start"};this.normalizeRules=function(){function i(s){var o=r[s];o.processed=!0;for(var u=0;u<o.length;u++){var a=o[u],f=null;Array.isArray(a)&&(f=a,a={}),!a.regex&&a.start&&(a.regex=a.start,a.next||(a.next=[]),a.next.push({defaultToken:a.token},{token:a.token+".end",regex:a.end||a.start,next:"pop"}),a.token=a.token+".start",a.push=!0);var l=a.next||a.push;if(l&&Array.isArray(l)){var c=a.stateName;c||(c=a.token,typeof c!="string"&&(c=c[0]||""),r[c]&&(c+=n++)),r[c]=l,a.next=c,i(c)}else l=="pop"&&(a.next=t);a.push&&(a.nextState=a.next||a.push,a.next=e,delete a.push);if(a.rules)for(var h in a.rules)r[h]?r[h].push&&r[h].push.apply(r[h],a.rules[h]):r[h]=a.rules[h];var p=typeof a=="string"?a:typeof a.include=="string"?a.include:"";p&&(f=r[p]);if(f){var d=[u,1].concat(f);a.noEscape&&(d=d.filter(function(e){return!e.next})),o.splice.apply(o,d),u--}a.keywordMap&&(a.token=this.createKeywordMapper(a.keywordMap,a.defaultToken||"text",a.caseInsensitive),delete a.defaultToken)}}var n=0,r=this.$rules;Object.keys(r).forEach(i,this)},this.createKeywordMapper=function(e,t,n,r){var i=Object.create(null);return Object.keys(e).forEach(function(t){var s=e[t];n&&(s=s.toLowerCase());var o=s.split(r||"|");for(var u=o.length;u--;)i[o[u]]=t}),Object.getPrototypeOf(i)&&(i.__proto__=null),this.$keywordList=Object.keys(i),e=null,n?function(e){return i[e.toLowerCase()]||t}:function(e){return i[e]||t}},this.getKeywords=function(){return this.$keywords}}).call(i.prototype),t.TextHighlightRules=i}),ace.define("ace/mode/behaviour",["require","exports","module"],function(e,t,n){"use strict";var r=function(){this.$behaviours={}};(function(){this.add=function(e,t,n){switch(undefined){case this.$behaviours:this.$behaviours={};case this.$behaviours[e]:this.$behaviours[e]={}}this.$behaviours[e][t]=n},this.addBehaviours=function(e){for(var t in e)for(var n in e[t])this.add(t,n,e[t][n])},this.remove=function(e){this.$behaviours&&this.$behaviours[e]&&delete this.$behaviours[e]},this.inherit=function(e,t){if(typeof e=="function")var n=(new e).getBehaviours(t);else var n=e.getBehaviours(t);this.addBehaviours(n)},this.getBehaviours=function(e){if(!e)return this.$behaviours;var t={};for(var n=0;n<e.length;n++)this.$behaviours[e[n]]&&(t[e[n]]=this.$behaviours[e[n]]);return t}}).call(r.prototype),t.Behaviour=r}),ace.define("ace/token_iterator",["require","exports","module"],function(e,t,n){"use strict";var r=function(e,t,n){this.$session=e,this.$row=t,this.$rowTokens=e.getTokens(t);var r=e.getTokenAt(t,n);this.$tokenIndex=r?r.index:-1};(function(){this.stepBackward=function(){this.$tokenIndex-=1;while(this.$tokenIndex<0){this.$row-=1;if(this.$row<0)return this.$row=0,null;this.$rowTokens=this.$session.getTokens(this.$row),this.$tokenIndex=this.$rowTokens.length-1}return this.$rowTokens[this.$tokenIndex]},this.stepForward=function(){this.$tokenIndex+=1;var e;while(this.$tokenIndex>=this.$rowTokens.length){this.$row+=1,e||(e=this.$session.getLength());if(this.$row>=e)return this.$row=e-1,null;this.$rowTokens=this.$session.getTokens(this.$row),this.$tokenIndex=0}return this.$rowTokens[this.$tokenIndex]},this.getCurrentToken=function(){return this.$rowTokens[this.$tokenIndex]},this.getCurrentTokenRow=function(){return this.$row},this.getCurrentTokenColumn=function(){var e=this.$rowTokens,t=this.$tokenIndex,n=e[t].start;if(n!==undefined)return n;n=0;while(t>0)t-=1,n+=e[t].value.length;return n},this.getCurrentTokenPosition=function(){return{row:this.$row,column:this.getCurrentTokenColumn()}}}).call(r.prototype),t.TokenIterator=r}),ace.define("ace/mode/behaviour/cstyle",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("../behaviour").Behaviour,s=e("../../token_iterator").TokenIterator,o=e("../../lib/lang"),u=["text","paren.rparen","punctuation.operator"],a=["text","paren.rparen","punctuation.operator","comment"],f,l={},c=function(e){var t=-1;e.multiSelect&&(t=e.selection.index,l.rangeCount!=e.multiSelect.rangeCount&&(l={rangeCount:e.multiSelect.rangeCount}));if(l[t])return f=l[t];f=l[t]={autoInsertedBrackets:0,autoInsertedRow:-1,autoInsertedLineEnd:"",maybeInsertedBrackets:0,maybeInsertedRow:-1,maybeInsertedLineStart:"",maybeInsertedLineEnd:""}},h=function(e,t,n,r){var i=e.end.row-e.start.row;return{text:n+t+r,selection:[0,e.start.column+1,i,e.end.column+(i?0:1)]}},p=function(){this.add("braces","insertion",function(e,t,n,r,i){var s=n.getCursorPosition(),u=r.doc.getLine(s.row);if(i=="{"){c(n);var a=n.getSelectionRange(),l=r.doc.getTextRange(a);if(l!==""&&l!=="{"&&n.getWrapBehavioursEnabled())return h(a,l,"{","}");if(p.isSaneInsertion(n,r))return/[\]\}\)]/.test(u[s.column])||n.inMultiSelectMode?(p.recordAutoInsert(n,r,"}"),{text:"{}",selection:[1,1]}):(p.recordMaybeInsert(n,r,"{"),{text:"{",selection:[1,1]})}else if(i=="}"){c(n);var d=u.substring(s.column,s.column+1);if(d=="}"){var v=r.$findOpeningBracket("}",{column:s.column+1,row:s.row});if(v!==null&&p.isAutoInsertedClosing(s,u,i))return p.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}else{if(i=="\n"||i=="\r\n"){c(n);var m="";p.isMaybeInsertedClosing(s,u)&&(m=o.stringRepeat("}",f.maybeInsertedBrackets),p.clearMaybeInsertedClosing());var d=u.substring(s.column,s.column+1);if(d==="}"){var g=r.findMatchingBracket({row:s.row,column:s.column+1},"}");if(!g)return null;var y=this.$getIndent(r.getLine(g.row))}else{if(!m){p.clearMaybeInsertedClosing();return}var y=this.$getIndent(u)}var b=y+r.getTabString();return{text:"\n"+b+"\n"+y+m,selection:[1,b.length,1,b.length]}}p.clearMaybeInsertedClosing()}}),this.add("braces","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&s=="{"){c(n);var o=r.doc.getLine(i.start.row),u=o.substring(i.end.column,i.end.column+1);if(u=="}")return i.end.column++,i;f.maybeInsertedBrackets--}}),this.add("parens","insertion",function(e,t,n,r,i){if(i=="("){c(n);var s=n.getSelectionRange(),o=r.doc.getTextRange(s);if(o!==""&&n.getWrapBehavioursEnabled())return h(s,o,"(",")");if(p.isSaneInsertion(n,r))return p.recordAutoInsert(n,r,")"),{text:"()",selection:[1,1]}}else if(i==")"){c(n);var u=n.getCursorPosition(),a=r.doc.getLine(u.row),f=a.substring(u.column,u.column+1);if(f==")"){var l=r.$findOpeningBracket(")",{column:u.column+1,row:u.row});if(l!==null&&p.isAutoInsertedClosing(u,a,i))return p.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}}),this.add("parens","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&s=="("){c(n);var o=r.doc.getLine(i.start.row),u=o.substring(i.start.column+1,i.start.column+2);if(u==")")return i.end.column++,i}}),this.add("brackets","insertion",function(e,t,n,r,i){if(i=="["){c(n);var s=n.getSelectionRange(),o=r.doc.getTextRange(s);if(o!==""&&n.getWrapBehavioursEnabled())return h(s,o,"[","]");if(p.isSaneInsertion(n,r))return p.recordAutoInsert(n,r,"]"),{text:"[]",selection:[1,1]}}else if(i=="]"){c(n);var u=n.getCursorPosition(),a=r.doc.getLine(u.row),f=a.substring(u.column,u.column+1);if(f=="]"){var l=r.$findOpeningBracket("]",{column:u.column+1,row:u.row});if(l!==null&&p.isAutoInsertedClosing(u,a,i))return p.popAutoInsertedClosing(),{text:"",selection:[1,1]}}}}),this.add("brackets","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&s=="["){c(n);var o=r.doc.getLine(i.start.row),u=o.substring(i.start.column+1,i.start.column+2);if(u=="]")return i.end.column++,i}}),this.add("string_dquotes","insertion",function(e,t,n,r,i){if(i=='"'||i=="'"){if(this.lineCommentStart&&this.lineCommentStart.indexOf(i)!=-1)return;c(n);var s=i,o=n.getSelectionRange(),u=r.doc.getTextRange(o);if(u!==""&&u!=="'"&&u!='"'&&n.getWrapBehavioursEnabled())return h(o,u,s,s);if(!u){var a=n.getCursorPosition(),f=r.doc.getLine(a.row),l=f.substring(a.column-1,a.column),p=f.substring(a.column,a.column+1),d=r.getTokenAt(a.row,a.column),v=r.getTokenAt(a.row,a.column+1);if(l=="\\"&&d&&/escape/.test(d.type))return null;var m=d&&/string|escape/.test(d.type),g=!v||/string|escape/.test(v.type),y;if(p==s)y=m!==g,y&&/string\.end/.test(v.type)&&(y=!1);else{if(m&&!g)return null;if(m&&g)return null;var b=r.$mode.tokenRe;b.lastIndex=0;var w=b.test(l);b.lastIndex=0;var E=b.test(l);if(w||E)return null;if(p&&!/[\s;,.})\]\\]/.test(p))return null;y=!0}return{text:y?s+s:"",selection:[1,1]}}}}),this.add("string_dquotes","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&(s=='"'||s=="'")){c(n);var o=r.doc.getLine(i.start.row),u=o.substring(i.start.column+1,i.start.column+2);if(u==s)return i.end.column++,i}})};p.isSaneInsertion=function(e,t){var n=e.getCursorPosition(),r=new s(t,n.row,n.column);if(!this.$matchTokenType(r.getCurrentToken()||"text",u)){var i=new s(t,n.row,n.column+1);if(!this.$matchTokenType(i.getCurrentToken()||"text",u))return!1}return r.stepForward(),r.getCurrentTokenRow()!==n.row||this.$matchTokenType(r.getCurrentToken()||"text",a)},p.$matchTokenType=function(e,t){return t.indexOf(e.type||e)>-1},p.recordAutoInsert=function(e,t,n){var r=e.getCursorPosition(),i=t.doc.getLine(r.row);this.isAutoInsertedClosing(r,i,f.autoInsertedLineEnd[0])||(f.autoInsertedBrackets=0),f.autoInsertedRow=r.row,f.autoInsertedLineEnd=n+i.substr(r.column),f.autoInsertedBrackets++},p.recordMaybeInsert=function(e,t,n){var r=e.getCursorPosition(),i=t.doc.getLine(r.row);this.isMaybeInsertedClosing(r,i)||(f.maybeInsertedBrackets=0),f.maybeInsertedRow=r.row,f.maybeInsertedLineStart=i.substr(0,r.column)+n,f.maybeInsertedLineEnd=i.substr(r.column),f.maybeInsertedBrackets++},p.isAutoInsertedClosing=function(e,t,n){return f.autoInsertedBrackets>0&&e.row===f.autoInsertedRow&&n===f.autoInsertedLineEnd[0]&&t.substr(e.column)===f.autoInsertedLineEnd},p.isMaybeInsertedClosing=function(e,t){return f.maybeInsertedBrackets>0&&e.row===f.maybeInsertedRow&&t.substr(e.column)===f.maybeInsertedLineEnd&&t.substr(0,e.column)==f.maybeInsertedLineStart},p.popAutoInsertedClosing=function(){f.autoInsertedLineEnd=f.autoInsertedLineEnd.substr(1),f.autoInsertedBrackets--},p.clearMaybeInsertedClosing=function(){f&&(f.maybeInsertedBrackets=0,f.maybeInsertedRow=-1)},r.inherits(p,i),t.CstyleBehaviour=p}),ace.define("ace/unicode",["require","exports","module"],function(e,t,n){"use strict";function r(e){var n=/\w{4}/g;for(var r in e)t.packages[r]=e[r].replace(n,"\\u$&")}t.packages={},r({L:"0041-005A0061-007A00AA00B500BA00C0-00D600D8-00F600F8-02C102C6-02D102E0-02E402EC02EE0370-037403760377037A-037D03860388-038A038C038E-03A103A3-03F503F7-0481048A-05250531-055605590561-058705D0-05EA05F0-05F20621-064A066E066F0671-06D306D506E506E606EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA07F407F507FA0800-0815081A082408280904-0939093D09500958-0961097109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E460E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EC60EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10A0-10C510D0-10FA10FC1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317D717DC1820-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541AA71B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C7D1CE9-1CEC1CEE-1CF11D00-1DBF1E00-1F151F18-1F1D1F20-1F451F48-1F4D1F50-1F571F591F5B1F5D1F5F-1F7D1F80-1FB41FB6-1FBC1FBE1FC2-1FC41FC6-1FCC1FD0-1FD31FD6-1FDB1FE0-1FEC1FF2-1FF41FF6-1FFC2071207F2090-209421022107210A-211321152119-211D212421262128212A-212D212F-2139213C-213F2145-2149214E218321842C00-2C2E2C30-2C5E2C60-2CE42CEB-2CEE2D00-2D252D30-2D652D6F2D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE2E2F300530063031-3035303B303C3041-3096309D-309F30A1-30FA30FC-30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A48CA4D0-A4FDA500-A60CA610-A61FA62AA62BA640-A65FA662-A66EA67F-A697A6A0-A6E5A717-A71FA722-A788A78BA78CA7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2A9CFAA00-AA28AA40-AA42AA44-AA4BAA60-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADB-AADDABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB00-FB06FB13-FB17FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF21-FF3AFF41-FF5AFF66-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",Ll:"0061-007A00AA00B500BA00DF-00F600F8-00FF01010103010501070109010B010D010F01110113011501170119011B011D011F01210123012501270129012B012D012F01310133013501370138013A013C013E014001420144014601480149014B014D014F01510153015501570159015B015D015F01610163016501670169016B016D016F0171017301750177017A017C017E-0180018301850188018C018D019201950199-019B019E01A101A301A501A801AA01AB01AD01B001B401B601B901BA01BD-01BF01C601C901CC01CE01D001D201D401D601D801DA01DC01DD01DF01E101E301E501E701E901EB01ED01EF01F001F301F501F901FB01FD01FF02010203020502070209020B020D020F02110213021502170219021B021D021F02210223022502270229022B022D022F02310233-0239023C023F0240024202470249024B024D024F-02930295-02AF037103730377037B-037D039003AC-03CE03D003D103D5-03D703D903DB03DD03DF03E103E303E503E703E903EB03ED03EF-03F303F503F803FB03FC0430-045F04610463046504670469046B046D046F04710473047504770479047B047D047F0481048B048D048F04910493049504970499049B049D049F04A104A304A504A704A904AB04AD04AF04B104B304B504B704B904BB04BD04BF04C204C404C604C804CA04CC04CE04CF04D104D304D504D704D904DB04DD04DF04E104E304E504E704E904EB04ED04EF04F104F304F504F704F904FB04FD04FF05010503050505070509050B050D050F05110513051505170519051B051D051F0521052305250561-05871D00-1D2B1D62-1D771D79-1D9A1E011E031E051E071E091E0B1E0D1E0F1E111E131E151E171E191E1B1E1D1E1F1E211E231E251E271E291E2B1E2D1E2F1E311E331E351E371E391E3B1E3D1E3F1E411E431E451E471E491E4B1E4D1E4F1E511E531E551E571E591E5B1E5D1E5F1E611E631E651E671E691E6B1E6D1E6F1E711E731E751E771E791E7B1E7D1E7F1E811E831E851E871E891E8B1E8D1E8F1E911E931E95-1E9D1E9F1EA11EA31EA51EA71EA91EAB1EAD1EAF1EB11EB31EB51EB71EB91EBB1EBD1EBF1EC11EC31EC51EC71EC91ECB1ECD1ECF1ED11ED31ED51ED71ED91EDB1EDD1EDF1EE11EE31EE51EE71EE91EEB1EED1EEF1EF11EF31EF51EF71EF91EFB1EFD1EFF-1F071F10-1F151F20-1F271F30-1F371F40-1F451F50-1F571F60-1F671F70-1F7D1F80-1F871F90-1F971FA0-1FA71FB0-1FB41FB61FB71FBE1FC2-1FC41FC61FC71FD0-1FD31FD61FD71FE0-1FE71FF2-1FF41FF61FF7210A210E210F2113212F21342139213C213D2146-2149214E21842C30-2C5E2C612C652C662C682C6A2C6C2C712C732C742C76-2C7C2C812C832C852C872C892C8B2C8D2C8F2C912C932C952C972C992C9B2C9D2C9F2CA12CA32CA52CA72CA92CAB2CAD2CAF2CB12CB32CB52CB72CB92CBB2CBD2CBF2CC12CC32CC52CC72CC92CCB2CCD2CCF2CD12CD32CD52CD72CD92CDB2CDD2CDF2CE12CE32CE42CEC2CEE2D00-2D25A641A643A645A647A649A64BA64DA64FA651A653A655A657A659A65BA65DA65FA663A665A667A669A66BA66DA681A683A685A687A689A68BA68DA68FA691A693A695A697A723A725A727A729A72BA72DA72F-A731A733A735A737A739A73BA73DA73FA741A743A745A747A749A74BA74DA74FA751A753A755A757A759A75BA75DA75FA761A763A765A767A769A76BA76DA76FA771-A778A77AA77CA77FA781A783A785A787A78CFB00-FB06FB13-FB17FF41-FF5A",Lu:"0041-005A00C0-00D600D8-00DE01000102010401060108010A010C010E01100112011401160118011A011C011E01200122012401260128012A012C012E01300132013401360139013B013D013F0141014301450147014A014C014E01500152015401560158015A015C015E01600162016401660168016A016C016E017001720174017601780179017B017D018101820184018601870189-018B018E-0191019301940196-0198019C019D019F01A001A201A401A601A701A901AC01AE01AF01B1-01B301B501B701B801BC01C401C701CA01CD01CF01D101D301D501D701D901DB01DE01E001E201E401E601E801EA01EC01EE01F101F401F6-01F801FA01FC01FE02000202020402060208020A020C020E02100212021402160218021A021C021E02200222022402260228022A022C022E02300232023A023B023D023E02410243-02460248024A024C024E03700372037603860388-038A038C038E038F0391-03A103A3-03AB03CF03D2-03D403D803DA03DC03DE03E003E203E403E603E803EA03EC03EE03F403F703F903FA03FD-042F04600462046404660468046A046C046E04700472047404760478047A047C047E0480048A048C048E04900492049404960498049A049C049E04A004A204A404A604A804AA04AC04AE04B004B204B404B604B804BA04BC04BE04C004C104C304C504C704C904CB04CD04D004D204D404D604D804DA04DC04DE04E004E204E404E604E804EA04EC04EE04F004F204F404F604F804FA04FC04FE05000502050405060508050A050C050E05100512051405160518051A051C051E0520052205240531-055610A0-10C51E001E021E041E061E081E0A1E0C1E0E1E101E121E141E161E181E1A1E1C1E1E1E201E221E241E261E281E2A1E2C1E2E1E301E321E341E361E381E3A1E3C1E3E1E401E421E441E461E481E4A1E4C1E4E1E501E521E541E561E581E5A1E5C1E5E1E601E621E641E661E681E6A1E6C1E6E1E701E721E741E761E781E7A1E7C1E7E1E801E821E841E861E881E8A1E8C1E8E1E901E921E941E9E1EA01EA21EA41EA61EA81EAA1EAC1EAE1EB01EB21EB41EB61EB81EBA1EBC1EBE1EC01EC21EC41EC61EC81ECA1ECC1ECE1ED01ED21ED41ED61ED81EDA1EDC1EDE1EE01EE21EE41EE61EE81EEA1EEC1EEE1EF01EF21EF41EF61EF81EFA1EFC1EFE1F08-1F0F1F18-1F1D1F28-1F2F1F38-1F3F1F48-1F4D1F591F5B1F5D1F5F1F68-1F6F1FB8-1FBB1FC8-1FCB1FD8-1FDB1FE8-1FEC1FF8-1FFB21022107210B-210D2110-211221152119-211D212421262128212A-212D2130-2133213E213F214521832C00-2C2E2C602C62-2C642C672C692C6B2C6D-2C702C722C752C7E-2C802C822C842C862C882C8A2C8C2C8E2C902C922C942C962C982C9A2C9C2C9E2CA02CA22CA42CA62CA82CAA2CAC2CAE2CB02CB22CB42CB62CB82CBA2CBC2CBE2CC02CC22CC42CC62CC82CCA2CCC2CCE2CD02CD22CD42CD62CD82CDA2CDC2CDE2CE02CE22CEB2CEDA640A642A644A646A648A64AA64CA64EA650A652A654A656A658A65AA65CA65EA662A664A666A668A66AA66CA680A682A684A686A688A68AA68CA68EA690A692A694A696A722A724A726A728A72AA72CA72EA732A734A736A738A73AA73CA73EA740A742A744A746A748A74AA74CA74EA750A752A754A756A758A75AA75CA75EA760A762A764A766A768A76AA76CA76EA779A77BA77DA77EA780A782A784A786A78BFF21-FF3A",Lt:"01C501C801CB01F21F88-1F8F1F98-1F9F1FA8-1FAF1FBC1FCC1FFC",Lm:"02B0-02C102C6-02D102E0-02E402EC02EE0374037A0559064006E506E607F407F507FA081A0824082809710E460EC610FC17D718431AA71C78-1C7D1D2C-1D611D781D9B-1DBF2071207F2090-20942C7D2D6F2E2F30053031-3035303B309D309E30FC-30FEA015A4F8-A4FDA60CA67FA717-A71FA770A788A9CFAA70AADDFF70FF9EFF9F",Lo:"01BB01C0-01C3029405D0-05EA05F0-05F20621-063F0641-064A066E066F0671-06D306D506EE06EF06FA-06FC06FF07100712-072F074D-07A507B107CA-07EA0800-08150904-0939093D09500958-096109720979-097F0985-098C098F09900993-09A809AA-09B009B209B6-09B909BD09CE09DC09DD09DF-09E109F009F10A05-0A0A0A0F0A100A13-0A280A2A-0A300A320A330A350A360A380A390A59-0A5C0A5E0A72-0A740A85-0A8D0A8F-0A910A93-0AA80AAA-0AB00AB20AB30AB5-0AB90ABD0AD00AE00AE10B05-0B0C0B0F0B100B13-0B280B2A-0B300B320B330B35-0B390B3D0B5C0B5D0B5F-0B610B710B830B85-0B8A0B8E-0B900B92-0B950B990B9A0B9C0B9E0B9F0BA30BA40BA8-0BAA0BAE-0BB90BD00C05-0C0C0C0E-0C100C12-0C280C2A-0C330C35-0C390C3D0C580C590C600C610C85-0C8C0C8E-0C900C92-0CA80CAA-0CB30CB5-0CB90CBD0CDE0CE00CE10D05-0D0C0D0E-0D100D12-0D280D2A-0D390D3D0D600D610D7A-0D7F0D85-0D960D9A-0DB10DB3-0DBB0DBD0DC0-0DC60E01-0E300E320E330E40-0E450E810E820E840E870E880E8A0E8D0E94-0E970E99-0E9F0EA1-0EA30EA50EA70EAA0EAB0EAD-0EB00EB20EB30EBD0EC0-0EC40EDC0EDD0F000F40-0F470F49-0F6C0F88-0F8B1000-102A103F1050-1055105A-105D106110651066106E-10701075-1081108E10D0-10FA1100-1248124A-124D1250-12561258125A-125D1260-1288128A-128D1290-12B012B2-12B512B8-12BE12C012C2-12C512C8-12D612D8-13101312-13151318-135A1380-138F13A0-13F41401-166C166F-167F1681-169A16A0-16EA1700-170C170E-17111720-17311740-17511760-176C176E-17701780-17B317DC1820-18421844-18771880-18A818AA18B0-18F51900-191C1950-196D1970-19741980-19AB19C1-19C71A00-1A161A20-1A541B05-1B331B45-1B4B1B83-1BA01BAE1BAF1C00-1C231C4D-1C4F1C5A-1C771CE9-1CEC1CEE-1CF12135-21382D30-2D652D80-2D962DA0-2DA62DA8-2DAE2DB0-2DB62DB8-2DBE2DC0-2DC62DC8-2DCE2DD0-2DD62DD8-2DDE3006303C3041-3096309F30A1-30FA30FF3105-312D3131-318E31A0-31B731F0-31FF3400-4DB54E00-9FCBA000-A014A016-A48CA4D0-A4F7A500-A60BA610-A61FA62AA62BA66EA6A0-A6E5A7FB-A801A803-A805A807-A80AA80C-A822A840-A873A882-A8B3A8F2-A8F7A8FBA90A-A925A930-A946A960-A97CA984-A9B2AA00-AA28AA40-AA42AA44-AA4BAA60-AA6FAA71-AA76AA7AAA80-AAAFAAB1AAB5AAB6AAB9-AABDAAC0AAC2AADBAADCABC0-ABE2AC00-D7A3D7B0-D7C6D7CB-D7FBF900-FA2DFA30-FA6DFA70-FAD9FB1DFB1F-FB28FB2A-FB36FB38-FB3CFB3EFB40FB41FB43FB44FB46-FBB1FBD3-FD3DFD50-FD8FFD92-FDC7FDF0-FDFBFE70-FE74FE76-FEFCFF66-FF6FFF71-FF9DFFA0-FFBEFFC2-FFC7FFCA-FFCFFFD2-FFD7FFDA-FFDC",M:"0300-036F0483-04890591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DE-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0903093C093E-094E0951-0955096209630981-098309BC09BE-09C409C709C809CB-09CD09D709E209E30A01-0A030A3C0A3E-0A420A470A480A4B-0A4D0A510A700A710A750A81-0A830ABC0ABE-0AC50AC7-0AC90ACB-0ACD0AE20AE30B01-0B030B3C0B3E-0B440B470B480B4B-0B4D0B560B570B620B630B820BBE-0BC20BC6-0BC80BCA-0BCD0BD70C01-0C030C3E-0C440C46-0C480C4A-0C4D0C550C560C620C630C820C830CBC0CBE-0CC40CC6-0CC80CCA-0CCD0CD50CD60CE20CE30D020D030D3E-0D440D46-0D480D4A-0D4D0D570D620D630D820D830DCA0DCF-0DD40DD60DD8-0DDF0DF20DF30E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F3E0F3F0F71-0F840F860F870F90-0F970F99-0FBC0FC6102B-103E1056-1059105E-10601062-10641067-106D1071-10741082-108D108F109A-109D135F1712-17141732-1734175217531772177317B6-17D317DD180B-180D18A91920-192B1930-193B19B0-19C019C819C91A17-1A1B1A55-1A5E1A60-1A7C1A7F1B00-1B041B34-1B441B6B-1B731B80-1B821BA1-1BAA1C24-1C371CD0-1CD21CD4-1CE81CED1CF21DC0-1DE61DFD-1DFF20D0-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66F-A672A67CA67DA6F0A6F1A802A806A80BA823-A827A880A881A8B4-A8C4A8E0-A8F1A926-A92DA947-A953A980-A983A9B3-A9C0AA29-AA36AA43AA4CAA4DAA7BAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE3-ABEAABECABEDFB1EFE00-FE0FFE20-FE26",Mn:"0300-036F0483-04870591-05BD05BF05C105C205C405C505C70610-061A064B-065E067006D6-06DC06DF-06E406E706E806EA-06ED07110730-074A07A6-07B007EB-07F30816-0819081B-08230825-08270829-082D0900-0902093C0941-0948094D0951-095509620963098109BC09C1-09C409CD09E209E30A010A020A3C0A410A420A470A480A4B-0A4D0A510A700A710A750A810A820ABC0AC1-0AC50AC70AC80ACD0AE20AE30B010B3C0B3F0B41-0B440B4D0B560B620B630B820BC00BCD0C3E-0C400C46-0C480C4A-0C4D0C550C560C620C630CBC0CBF0CC60CCC0CCD0CE20CE30D41-0D440D4D0D620D630DCA0DD2-0DD40DD60E310E34-0E3A0E47-0E4E0EB10EB4-0EB90EBB0EBC0EC8-0ECD0F180F190F350F370F390F71-0F7E0F80-0F840F860F870F90-0F970F99-0FBC0FC6102D-10301032-10371039103A103D103E10581059105E-10601071-1074108210851086108D109D135F1712-17141732-1734175217531772177317B7-17BD17C617C9-17D317DD180B-180D18A91920-19221927192819321939-193B1A171A181A561A58-1A5E1A601A621A65-1A6C1A73-1A7C1A7F1B00-1B031B341B36-1B3A1B3C1B421B6B-1B731B801B811BA2-1BA51BA81BA91C2C-1C331C361C371CD0-1CD21CD4-1CE01CE2-1CE81CED1DC0-1DE61DFD-1DFF20D0-20DC20E120E5-20F02CEF-2CF12DE0-2DFF302A-302F3099309AA66FA67CA67DA6F0A6F1A802A806A80BA825A826A8C4A8E0-A8F1A926-A92DA947-A951A980-A982A9B3A9B6-A9B9A9BCAA29-AA2EAA31AA32AA35AA36AA43AA4CAAB0AAB2-AAB4AAB7AAB8AABEAABFAAC1ABE5ABE8ABEDFB1EFE00-FE0FFE20-FE26",Mc:"0903093E-09400949-094C094E0982098309BE-09C009C709C809CB09CC09D70A030A3E-0A400A830ABE-0AC00AC90ACB0ACC0B020B030B3E0B400B470B480B4B0B4C0B570BBE0BBF0BC10BC20BC6-0BC80BCA-0BCC0BD70C01-0C030C41-0C440C820C830CBE0CC0-0CC40CC70CC80CCA0CCB0CD50CD60D020D030D3E-0D400D46-0D480D4A-0D4C0D570D820D830DCF-0DD10DD8-0DDF0DF20DF30F3E0F3F0F7F102B102C10311038103B103C105610571062-10641067-106D108310841087-108C108F109A-109C17B617BE-17C517C717C81923-19261929-192B193019311933-193819B0-19C019C819C91A19-1A1B1A551A571A611A631A641A6D-1A721B041B351B3B1B3D-1B411B431B441B821BA11BA61BA71BAA1C24-1C2B1C341C351CE11CF2A823A824A827A880A881A8B4-A8C3A952A953A983A9B4A9B5A9BAA9BBA9BD-A9C0AA2FAA30AA33AA34AA4DAA7BABE3ABE4ABE6ABE7ABE9ABEAABEC",Me:"0488048906DE20DD-20E020E2-20E4A670-A672",N:"0030-003900B200B300B900BC-00BE0660-066906F0-06F907C0-07C90966-096F09E6-09EF09F4-09F90A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BF20C66-0C6F0C78-0C7E0CE6-0CEF0D66-0D750E50-0E590ED0-0ED90F20-0F331040-10491090-10991369-137C16EE-16F017E0-17E917F0-17F91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C5920702074-20792080-20892150-21822185-21892460-249B24EA-24FF2776-27932CFD30073021-30293038-303A3192-31953220-32293251-325F3280-328932B1-32BFA620-A629A6E6-A6EFA830-A835A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",Nd:"0030-00390660-066906F0-06F907C0-07C90966-096F09E6-09EF0A66-0A6F0AE6-0AEF0B66-0B6F0BE6-0BEF0C66-0C6F0CE6-0CEF0D66-0D6F0E50-0E590ED0-0ED90F20-0F291040-10491090-109917E0-17E91810-18191946-194F19D0-19DA1A80-1A891A90-1A991B50-1B591BB0-1BB91C40-1C491C50-1C59A620-A629A8D0-A8D9A900-A909A9D0-A9D9AA50-AA59ABF0-ABF9FF10-FF19",Nl:"16EE-16F02160-21822185-218830073021-30293038-303AA6E6-A6EF",No:"00B200B300B900BC-00BE09F4-09F90BF0-0BF20C78-0C7E0D70-0D750F2A-0F331369-137C17F0-17F920702074-20792080-20892150-215F21892460-249B24EA-24FF2776-27932CFD3192-31953220-32293251-325F3280-328932B1-32BFA830-A835",P:"0021-00230025-002A002C-002F003A003B003F0040005B-005D005F007B007D00A100AB00B700BB00BF037E0387055A-055F0589058A05BE05C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F3A-0F3D0F850FD0-0FD4104A-104F10FB1361-13681400166D166E169B169C16EB-16ED1735173617D4-17D617D8-17DA1800-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD32010-20272030-20432045-20512053-205E207D207E208D208E2329232A2768-277527C527C627E6-27EF2983-299829D8-29DB29FC29FD2CF9-2CFC2CFE2CFF2E00-2E2E2E302E313001-30033008-30113014-301F3030303D30A030FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFD3EFD3FFE10-FE19FE30-FE52FE54-FE61FE63FE68FE6AFE6BFF01-FF03FF05-FF0AFF0C-FF0FFF1AFF1BFF1FFF20FF3B-FF3DFF3FFF5BFF5DFF5F-FF65",Pd:"002D058A05BE140018062010-20152E172E1A301C303030A0FE31FE32FE58FE63FF0D",Ps:"0028005B007B0F3A0F3C169B201A201E2045207D208D23292768276A276C276E27702772277427C527E627E827EA27EC27EE2983298529872989298B298D298F299129932995299729D829DA29FC2E222E242E262E283008300A300C300E3010301430163018301A301DFD3EFE17FE35FE37FE39FE3BFE3DFE3FFE41FE43FE47FE59FE5BFE5DFF08FF3BFF5BFF5FFF62",Pe:"0029005D007D0F3B0F3D169C2046207E208E232A2769276B276D276F27712773277527C627E727E927EB27ED27EF298429862988298A298C298E2990299229942996299829D929DB29FD2E232E252E272E293009300B300D300F3011301530173019301B301E301FFD3FFE18FE36FE38FE3AFE3CFE3EFE40FE42FE44FE48FE5AFE5CFE5EFF09FF3DFF5DFF60FF63",Pi:"00AB2018201B201C201F20392E022E042E092E0C2E1C2E20",Pf:"00BB2019201D203A2E032E052E0A2E0D2E1D2E21",Pc:"005F203F20402054FE33FE34FE4D-FE4FFF3F",Po:"0021-00230025-0027002A002C002E002F003A003B003F0040005C00A100B700BF037E0387055A-055F058905C005C305C605F305F40609060A060C060D061B061E061F066A-066D06D40700-070D07F7-07F90830-083E0964096509700DF40E4F0E5A0E5B0F04-0F120F850FD0-0FD4104A-104F10FB1361-1368166D166E16EB-16ED1735173617D4-17D617D8-17DA1800-18051807-180A1944194519DE19DF1A1E1A1F1AA0-1AA61AA8-1AAD1B5A-1B601C3B-1C3F1C7E1C7F1CD3201620172020-20272030-2038203B-203E2041-20432047-205120532055-205E2CF9-2CFC2CFE2CFF2E002E012E06-2E082E0B2E0E-2E162E182E192E1B2E1E2E1F2E2A-2E2E2E302E313001-3003303D30FBA4FEA4FFA60D-A60FA673A67EA6F2-A6F7A874-A877A8CEA8CFA8F8-A8FAA92EA92FA95FA9C1-A9CDA9DEA9DFAA5C-AA5FAADEAADFABEBFE10-FE16FE19FE30FE45FE46FE49-FE4CFE50-FE52FE54-FE57FE5F-FE61FE68FE6AFE6BFF01-FF03FF05-FF07FF0AFF0CFF0EFF0FFF1AFF1BFF1FFF20FF3CFF61FF64FF65",S:"0024002B003C-003E005E0060007C007E00A2-00A900AC00AE-00B100B400B600B800D700F702C2-02C502D2-02DF02E5-02EB02ED02EF-02FF03750384038503F604820606-0608060B060E060F06E906FD06FE07F609F209F309FA09FB0AF10B700BF3-0BFA0C7F0CF10CF20D790E3F0F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-139917DB194019E0-19FF1B61-1B6A1B74-1B7C1FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE20442052207A-207C208A-208C20A0-20B8210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B2140-2144214A-214D214F2190-2328232B-23E82400-24262440-244A249C-24E92500-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE27C0-27C427C7-27CA27CC27D0-27E527F0-29822999-29D729DC-29FB29FE-2B4C2B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F309B309C319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A700-A716A720A721A789A78AA828-A82BA836-A839AA77-AA79FB29FDFCFDFDFE62FE64-FE66FE69FF04FF0BFF1C-FF1EFF3EFF40FF5CFF5EFFE0-FFE6FFE8-FFEEFFFCFFFD",Sm:"002B003C-003E007C007E00AC00B100D700F703F60606-060820442052207A-207C208A-208C2140-2144214B2190-2194219A219B21A021A321A621AE21CE21CF21D221D421F4-22FF2308-230B23202321237C239B-23B323DC-23E125B725C125F8-25FF266F27C0-27C427C7-27CA27CC27D0-27E527F0-27FF2900-29822999-29D729DC-29FB29FE-2AFF2B30-2B442B47-2B4CFB29FE62FE64-FE66FF0BFF1C-FF1EFF5CFF5EFFE2FFE9-FFEC",Sc:"002400A2-00A5060B09F209F309FB0AF10BF90E3F17DB20A0-20B8A838FDFCFE69FF04FFE0FFE1FFE5FFE6",Sk:"005E006000A800AF00B400B802C2-02C502D2-02DF02E5-02EB02ED02EF-02FF0375038403851FBD1FBF-1FC11FCD-1FCF1FDD-1FDF1FED-1FEF1FFD1FFE309B309CA700-A716A720A721A789A78AFF3EFF40FFE3",So:"00A600A700A900AE00B000B60482060E060F06E906FD06FE07F609FA0B700BF3-0BF80BFA0C7F0CF10CF20D790F01-0F030F13-0F170F1A-0F1F0F340F360F380FBE-0FC50FC7-0FCC0FCE0FCF0FD5-0FD8109E109F13601390-1399194019E0-19FF1B61-1B6A1B74-1B7C210021012103-21062108210921142116-2118211E-2123212521272129212E213A213B214A214C214D214F2195-2199219C-219F21A121A221A421A521A7-21AD21AF-21CD21D021D121D321D5-21F32300-2307230C-231F2322-2328232B-237B237D-239A23B4-23DB23E2-23E82400-24262440-244A249C-24E92500-25B625B8-25C025C2-25F72600-266E2670-26CD26CF-26E126E326E8-26FF2701-27042706-2709270C-27272729-274B274D274F-27522756-275E2761-276727942798-27AF27B1-27BE2800-28FF2B00-2B2F2B452B462B50-2B592CE5-2CEA2E80-2E992E9B-2EF32F00-2FD52FF0-2FFB300430123013302030363037303E303F319031913196-319F31C0-31E33200-321E322A-32503260-327F328A-32B032C0-32FE3300-33FF4DC0-4DFFA490-A4C6A828-A82BA836A837A839AA77-AA79FDFDFFE4FFE8FFEDFFEEFFFCFFFD",Z:"002000A01680180E2000-200A20282029202F205F3000",Zs:"002000A01680180E2000-200A202F205F3000",Zl:"2028",Zp:"2029",C:"0000-001F007F-009F00AD03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-0605061C061D0620065F06DD070E070F074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17B417B517DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF200B-200F202A-202E2060-206F20722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-F8FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFD-FF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFFBFFFEFFFF",Cc:"0000-001F007F-009F",Cf:"00AD0600-060306DD070F17B417B5200B-200F202A-202E2060-2064206A-206FFEFFFFF9-FFFB",Co:"E000-F8FF",Cs:"D800-DFFF",Cn:"03780379037F-0383038B038D03A20526-05300557055805600588058B-059005C8-05CF05EB-05EF05F5-05FF06040605061C061D0620065F070E074B074C07B2-07BF07FB-07FF082E082F083F-08FF093A093B094F095609570973-097809800984098D098E0991099209A909B109B3-09B509BA09BB09C509C609C909CA09CF-09D609D8-09DB09DE09E409E509FC-0A000A040A0B-0A0E0A110A120A290A310A340A370A3A0A3B0A3D0A43-0A460A490A4A0A4E-0A500A52-0A580A5D0A5F-0A650A76-0A800A840A8E0A920AA90AB10AB40ABA0ABB0AC60ACA0ACE0ACF0AD1-0ADF0AE40AE50AF00AF2-0B000B040B0D0B0E0B110B120B290B310B340B3A0B3B0B450B460B490B4A0B4E-0B550B58-0B5B0B5E0B640B650B72-0B810B840B8B-0B8D0B910B96-0B980B9B0B9D0BA0-0BA20BA5-0BA70BAB-0BAD0BBA-0BBD0BC3-0BC50BC90BCE0BCF0BD1-0BD60BD8-0BE50BFB-0C000C040C0D0C110C290C340C3A-0C3C0C450C490C4E-0C540C570C5A-0C5F0C640C650C70-0C770C800C810C840C8D0C910CA90CB40CBA0CBB0CC50CC90CCE-0CD40CD7-0CDD0CDF0CE40CE50CF00CF3-0D010D040D0D0D110D290D3A-0D3C0D450D490D4E-0D560D58-0D5F0D640D650D76-0D780D800D810D840D97-0D990DB20DBC0DBE0DBF0DC7-0DC90DCB-0DCE0DD50DD70DE0-0DF10DF5-0E000E3B-0E3E0E5C-0E800E830E850E860E890E8B0E8C0E8E-0E930E980EA00EA40EA60EA80EA90EAC0EBA0EBE0EBF0EC50EC70ECE0ECF0EDA0EDB0EDE-0EFF0F480F6D-0F700F8C-0F8F0F980FBD0FCD0FD9-0FFF10C6-10CF10FD-10FF1249124E124F12571259125E125F1289128E128F12B112B612B712BF12C112C612C712D7131113161317135B-135E137D-137F139A-139F13F5-13FF169D-169F16F1-16FF170D1715-171F1737-173F1754-175F176D17711774-177F17DE17DF17EA-17EF17FA-17FF180F181A-181F1878-187F18AB-18AF18F6-18FF191D-191F192C-192F193C-193F1941-1943196E196F1975-197F19AC-19AF19CA-19CF19DB-19DD1A1C1A1D1A5F1A7D1A7E1A8A-1A8F1A9A-1A9F1AAE-1AFF1B4C-1B4F1B7D-1B7F1BAB-1BAD1BBA-1BFF1C38-1C3A1C4A-1C4C1C80-1CCF1CF3-1CFF1DE7-1DFC1F161F171F1E1F1F1F461F471F4E1F4F1F581F5A1F5C1F5E1F7E1F7F1FB51FC51FD41FD51FDC1FF01FF11FF51FFF2065-206920722073208F2095-209F20B9-20CF20F1-20FF218A-218F23E9-23FF2427-243F244B-245F26CE26E226E4-26E727002705270A270B2728274C274E2753-2755275F27602795-279727B027BF27CB27CD-27CF2B4D-2B4F2B5A-2BFF2C2F2C5F2CF2-2CF82D26-2D2F2D66-2D6E2D70-2D7F2D97-2D9F2DA72DAF2DB72DBF2DC72DCF2DD72DDF2E32-2E7F2E9A2EF4-2EFF2FD6-2FEF2FFC-2FFF3040309730983100-3104312E-3130318F31B8-31BF31E4-31EF321F32FF4DB6-4DBF9FCC-9FFFA48D-A48FA4C7-A4CFA62C-A63FA660A661A674-A67BA698-A69FA6F8-A6FFA78D-A7FAA82C-A82FA83A-A83FA878-A87FA8C5-A8CDA8DA-A8DFA8FC-A8FFA954-A95EA97D-A97FA9CEA9DA-A9DDA9E0-A9FFAA37-AA3FAA4EAA4FAA5AAA5BAA7C-AA7FAAC3-AADAAAE0-ABBFABEEABEFABFA-ABFFD7A4-D7AFD7C7-D7CAD7FC-D7FFFA2EFA2FFA6EFA6FFADA-FAFFFB07-FB12FB18-FB1CFB37FB3DFB3FFB42FB45FBB2-FBD2FD40-FD4FFD90FD91FDC8-FDEFFDFEFDFFFE1A-FE1FFE27-FE2FFE53FE67FE6C-FE6FFE75FEFDFEFEFF00FFBF-FFC1FFC8FFC9FFD0FFD1FFD8FFD9FFDD-FFDFFFE7FFEF-FFF8FFFEFFFF"})}),ace.define("ace/mode/text",["require","exports","module","ace/tokenizer","ace/mode/text_highlight_rules","ace/mode/behaviour/cstyle","ace/unicode","ace/lib/lang","ace/token_iterator","ace/range"],function(e,t,n){"use strict";var r=e("../tokenizer").Tokenizer,i=e("./text_highlight_rules").TextHighlightRules,s=e("./behaviour/cstyle").CstyleBehaviour,o=e("../unicode"),u=e("../lib/lang"),a=e("../token_iterator").TokenIterator,f=e("../range").Range,l=function(){this.HighlightRules=i};(function(){this.$defaultBehaviour=new s,this.tokenRe=new RegExp("^["+o.packages.L+o.packages.Mn+o.packages.Mc+o.packages.Nd+o.packages.Pc+"\\$_]+","g"),this.nonTokenRe=new RegExp("^(?:[^"+o.packages.L+o.packages.Mn+o.packages.Mc+o.packages.Nd+o.packages.Pc+"\\$_]|\\s])+","g"),this.getTokenizer=function(){return this.$tokenizer||(this.$highlightRules=this.$highlightRules||new this.HighlightRules(this.$highlightRuleConfig),this.$tokenizer=new r(this.$highlightRules.getRules())),this.$tokenizer},this.lineCommentStart="",this.blockComment="",this.toggleCommentLines=function(e,t,n,r){function w(e){for(var t=n;t<=r;t++)e(i.getLine(t),t)}var i=t.doc,s=!0,o=!0,a=Infinity,f=t.getTabSize(),l=!1;if(!this.lineCommentStart){if(!this.blockComment)return!1;var c=this.blockComment.start,h=this.blockComment.end,p=new RegExp("^(\\s*)(?:"+u.escapeRegExp(c)+")"),d=new RegExp("(?:"+u.escapeRegExp(h)+")\\s*$"),v=function(e,t){if(g(e,t))return;if(!s||/\S/.test(e))i.insertInLine({row:t,column:e.length},h),i.insertInLine({row:t,column:a},c)},m=function(e,t){var n;(n=e.match(d))&&i.removeInLine(t,e.length-n[0].length,e.length),(n=e.match(p))&&i.removeInLine(t,n[1].length,n[0].length)},g=function(e,n){if(p.test(e))return!0;var r=t.getTokens(n);for(var i=0;i<r.length;i++)if(r[i].type==="comment")return!0}}else{if(Array.isArray(this.lineCommentStart))var p=this.lineCommentStart.map(u.escapeRegExp).join("|"),c=this.lineCommentStart[0];else var p=u.escapeRegExp(this.lineCommentStart),c=this.lineCommentStart;p=new RegExp("^(\\s*)(?:"+p+") ?"),l=t.getUseSoftTabs();var m=function(e,t){var n=e.match(p);if(!n)return;var r=n[1].length,s=n[0].length;!b(e,r,s)&&n[0][s-1]==" "&&s--,i.removeInLine(t,r,s)},y=c+" ",v=function(e,t){if(!s||/\S/.test(e))b(e,a,a)?i.insertInLine({row:t,column:a},y):i.insertInLine({row:t,column:a},c)},g=function(e,t){return p.test(e)},b=function(e,t,n){var r=0;while(t--&&e.charAt(t)==" ")r++;if(r%f!=0)return!1;var r=0;while(e.charAt(n++)==" ")r++;return f>2?r%f!=f-1:r%f==0}}var E=Infinity;w(function(e,t){var n=e.search(/\S/);n!==-1?(n<a&&(a=n),o&&!g(e,t)&&(o=!1)):E>e.length&&(E=e.length)}),a==Infinity&&(a=E,s=!1,o=!1),l&&a%f!=0&&(a=Math.floor(a/f)*f),w(o?m:v)},this.toggleBlockComment=function(e,t,n,r){var i=this.blockComment;if(!i)return;!i.start&&i[0]&&(i=i[0]);var s=new a(t,r.row,r.column),o=s.getCurrentToken(),u=t.selection,l=t.selection.toOrientedRange(),c,h;if(o&&/comment/.test(o.type)){var p,d;while(o&&/comment/.test(o.type)){var v=o.value.indexOf(i.start);if(v!=-1){var m=s.getCurrentTokenRow(),g=s.getCurrentTokenColumn()+v;p=new f(m,g,m,g+i.start.length);break}o=s.stepBackward()}var s=new a(t,r.row,r.column),o=s.getCurrentToken();while(o&&/comment/.test(o.type)){var v=o.value.indexOf(i.end);if(v!=-1){var m=s.getCurrentTokenRow(),g=s.getCurrentTokenColumn()+v;d=new f(m,g,m,g+i.end.length);break}o=s.stepForward()}d&&t.remove(d),p&&(t.remove(p),c=p.start.row,h=-i.start.length)}else h=i.start.length,c=n.start.row,t.insert(n.end,i.end),t.insert(n.start,i.start);l.start.row==c&&(l.start.column+=h),l.end.row==c&&(l.end.column+=h),t.selection.fromOrientedRange(l)},this.getNextLineIndent=function(e,t,n){return this.$getIndent(t)},this.checkOutdent=function(e,t,n){return!1},this.autoOutdent=function(e,t,n){},this.$getIndent=function(e){return e.match(/^\s*/)[0]},this.createWorker=function(e){return null},this.createModeDelegates=function(e){this.$embeds=[],this.$modes={};for(var t in e)e[t]&&(this.$embeds.push(t),this.$modes[t]=new e[t]);var n=["toggleBlockComment","toggleCommentLines","getNextLineIndent","checkOutdent","autoOutdent","transformAction","getCompletions"];for(var t=0;t<n.length;t++)(function(e){var r=n[t],i=e[r];e[n[t]]=function(){return this.$delegator(r,arguments,i)}})(this)},this.$delegator=function(e,t,n){var r=t[0];typeof r!="string"&&(r=r[0]);for(var i=0;i<this.$embeds.length;i++){if(!this.$modes[this.$embeds[i]])continue;var s=r.split(this.$embeds[i]);if(!s[0]&&s[1]){t[0]=s[1];var o=this.$modes[this.$embeds[i]];return o[e].apply(o,t)}}var u=n.apply(this,t);return n?u:undefined},this.transformAction=function(e,t,n,r,i){if(this.$behaviour){var s=this.$behaviour.getBehaviours();for(var o in s)if(s[o][t]){var u=s[o][t].apply(this,arguments);if(u)return u}}},this.getKeywords=function(e){if(!this.completionKeywords){var t=this.$tokenizer.rules,n=[];for(var r in t){var i=t[r];for(var s=0,o=i.length;s<o;s++)if(typeof i[s].token=="string")/keyword|support|storage/.test(i[s].token)&&n.push(i[s].regex);else if(typeof i[s].token=="object")for(var u=0,a=i[s].token.length;u<a;u++)if(/keyword|support|storage/.test(i[s].token[u])){var r=i[s].regex.match(/\(.+?\)/g)[u];n.push(r.substr(1,r.length-2))}}this.completionKeywords=n}return e?n.concat(this.$keywordList||[]):this.$keywordList},this.$createKeywordList=function(){return this.$highlightRules||this.getTokenizer(),this.$keywordList=this.$highlightRules.$keywordList||[]},this.getCompletions=function(e,t,n,r){var i=this.$keywordList||this.$createKeywordList();return i.map(function(e){return{name:e,value:e,score:0,meta:"keyword"}})},this.$id="ace/mode/text"}).call(l.prototype),t.Mode=l}),ace.define("ace/apply_delta",["require","exports","module"],function(e,t,n){"use strict";function r(e,t){throw console.log("Invalid Delta:",e),"Invalid Delta: "+t}function i(e,t){return t.row>=0&&t.row<e.length&&t.column>=0&&t.column<=e[t.row].length}function s(e,t){t.action!="insert"&&t.action!="remove"&&r(t,"delta.action must be 'insert' or 'remove'"),t.lines instanceof Array||r(t,"delta.lines must be an Array"),(!t.start||!t.end)&&r(t,"delta.start/end must be an present");var n=t.start;i(e,t.start)||r(t,"delta.start must be contained in document");var s=t.end;t.action=="remove"&&!i(e,s)&&r(t,"delta.end must contained in document for 'remove' actions");var o=s.row-n.row,u=s.column-(o==0?n.column:0);(o!=t.lines.length-1||t.lines[o].length!=u)&&r(t,"delta.range must match delta lines")}t.applyDelta=function(e,t,n){var r=t.start.row,i=t.start.column,s=e[r]||"";switch(t.action){case"insert":var o=t.lines;if(o.length===1)e[r]=s.substring(0,i)+t.lines[0]+s.substring(i);else{var u=[r,1].concat(t.lines);e.splice.apply(e,u),e[r]=s.substring(0,i)+e[r],e[r+t.lines.length-1]+=s.substring(i)}break;case"remove":var a=t.end.column,f=t.end.row;r===f?e[r]=s.substring(0,i)+s.substring(a):e.splice(r,f-r+1,s.substring(0,i)+e[f].substring(a))}}}),ace.define("ace/anchor",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/event_emitter").EventEmitter,s=t.Anchor=function(e,t,n){this.$onChange=this.onChange.bind(this),this.attach(e),typeof n=="undefined"?this.setPosition(t.row,t.column):this.setPosition(t,n)};(function(){function e(e,t,n){var r=n?e.column<=t.column:e.column<t.column;return e.row<t.row||e.row==t.row&&r}function t(t,n,r){var i=t.action=="insert",s=(i?1:-1)*(t.end.row-t.start.row),o=(i?1:-1)*(t.end.column-t.start.column),u=t.start,a=i?u:t.end;return e(n,u,r)?{row:n.row,column:n.column}:e(a,n,!r)?{row:n.row+s,column:n.column+(n.row==a.row?o:0)}:{row:u.row,column:u.column}}r.implement(this,i),this.getPosition=function(){return this.$clipPositionToDocument(this.row,this.column)},this.getDocument=function(){return this.document},this.$insertRight=!1,this.onChange=function(e){if(e.start.row==e.end.row&&e.start.row!=this.row)return;if(e.start.row>this.row)return;var n=t(e,{row:this.row,column:this.column},this.$insertRight);this.setPosition(n.row,n.column,!0)},this.setPosition=function(e,t,n){var r;n?r={row:e,column:t}:r=this.$clipPositionToDocument(e,t);if(this.row==r.row&&this.column==r.column)return;var i={row:this.row,column:this.column};this.row=r.row,this.column=r.column,this._signal("change",{old:i,value:r})},this.detach=function(){this.document.removeEventListener("change",this.$onChange)},this.attach=function(e){this.document=e||this.document,this.document.on("change",this.$onChange)},this.$clipPositionToDocument=function(e,t){var n={};return e>=this.document.getLength()?(n.row=Math.max(0,this.document.getLength()-1),n.column=this.document.getLine(n.row).length):e<0?(n.row=0,n.column=0):(n.row=e,n.column=Math.min(this.document.getLine(n.row).length,Math.max(0,t))),t<0&&(n.column=0),n}}).call(s.prototype)}),ace.define("ace/document",["require","exports","module","ace/lib/oop","ace/apply_delta","ace/lib/event_emitter","ace/range","ace/anchor"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./apply_delta").applyDelta,s=e("./lib/event_emitter").EventEmitter,o=e("./range").Range,u=e("./anchor").Anchor,a=function(e){this.$lines=[""],e.length===0?this.$lines=[""]:Array.isArray(e)?this.insertMergedLines({row:0,column:0},e):this.insert({row:0,column:0},e)};(function(){r.implement(this,s),this.setValue=function(e){var t=this.getLength()-1;this.remove(new o(0,0,t,this.getLine(t).length)),this.insert({row:0,column:0},e)},this.getValue=function(){return this.getAllLines().join(this.getNewLineCharacter())},this.createAnchor=function(e,t){return new u(this,e,t)},"aaa".split(/a/).length===0?this.$split=function(e){return e.replace(/\r\n|\r/g,"\n").split("\n")}:this.$split=function(e){return e.split(/\r\n|\r|\n/)},this.$detectNewLine=function(e){var t=e.match(/^.*?(\r\n|\r|\n)/m);this.$autoNewLine=t?t[1]:"\n",this._signal("changeNewLineMode")},this.getNewLineCharacter=function(){switch(this.$newLineMode){case"windows":return"\r\n";case"unix":return"\n";default:return this.$autoNewLine||"\n"}},this.$autoNewLine="",this.$newLineMode="auto",this.setNewLineMode=function(e){if(this.$newLineMode===e)return;this.$newLineMode=e,this._signal("changeNewLineMode")},this.getNewLineMode=function(){return this.$newLineMode},this.isNewLine=function(e){return e=="\r\n"||e=="\r"||e=="\n"},this.getLine=function(e){return this.$lines[e]||""},this.getLines=function(e,t){return this.$lines.slice(e,t+1)},this.getAllLines=function(){return this.getLines(0,this.getLength())},this.getLength=function(){return this.$lines.length},this.getTextRange=function(e){return this.getLinesForRange(e).join(this.getNewLineCharacter())},this.getLinesForRange=function(e){var t;if(e.start.row===e.end.row)t=[this.getLine(e.start.row).substring(e.start.column,e.end.column)];else{t=this.getLines(e.start.row,e.end.row),t[0]=(t[0]||"").substring(e.start.column);var n=t.length-1;e.end.row-e.start.row==n&&(t[n]=t[n].substring(0,e.end.column))}return t},this.insertLines=function(e,t){return console.warn("Use of document.insertLines is deprecated. Use the insertFullLines method instead."),this.insertFullLines(e,t)},this.removeLines=function(e,t){return console.warn("Use of document.removeLines is deprecated. Use the removeFullLines method instead."),this.removeFullLines(e,t)},this.insertNewLine=function(e){return console.warn("Use of document.insertNewLine is deprecated. Use insertMergedLines(position, ['', '']) instead."),this.insertMergedLines(e,["",""])},this.insert=function(e,t){return this.getLength()<=1&&this.$detectNewLine(t),this.insertMergedLines(e,this.$split(t))},this.insertInLine=function(e,t){var n=this.clippedPos(e.row,e.column),r=this.pos(e.row,e.column+t.length);return this.applyDelta({start:n,end:r,action:"insert",lines:[t]},!0),this.clonePos(r)},this.clippedPos=function(e,t){var n=this.getLength();e===undefined?e=n:e<0?e=0:e>=n&&(e=n-1,t=undefined);var r=this.getLine(e);return t==undefined&&(t=r.length),t=Math.min(Math.max(t,0),r.length),{row:e,column:t}},this.clonePos=function(e){return{row:e.row,column:e.column}},this.pos=function(e,t){return{row:e,column:t}},this.$clipPosition=function(e){var t=this.getLength();return e.row>=t?(e.row=Math.max(0,t-1),e.column=this.getLine(t-1).length):(e.row=Math.max(0,e.row),e.column=Math.min(Math.max(e.column,0),this.getLine(e.row).length)),e},this.insertFullLines=function(e,t){e=Math.min(Math.max(e,0),this.getLength());var n=0;e<this.getLength()?(t=t.concat([""]),n=0):(t=[""].concat(t),e--,n=this.$lines[e].length),this.insertMergedLines({row:e,column:n},t)},this.insertMergedLines=function(e,t){var n=this.clippedPos(e.row,e.column),r={row:n.row+t.length-1,column:(t.length==1?n.column:0)+t[t.length-1].length};return this.applyDelta({start:n,end:r,action:"insert",lines:t}),this.clonePos(r)},this.remove=function(e){var t=this.clippedPos(e.start.row,e.start.column),n=this.clippedPos(e.end.row,e.end.column);return this.applyDelta({start:t,end:n,action:"remove",lines:this.getLinesForRange({start:t,end:n})}),this.clonePos(t)},this.removeInLine=function(e,t,n){var r=this.clippedPos(e,t),i=this.clippedPos(e,n);return this.applyDelta({start:r,end:i,action:"remove",lines:this.getLinesForRange({start:r,end:i})},!0),this.clonePos(r)},this.removeFullLines=function(e,t){e=Math.min(Math.max(0,e),this.getLength()-1),t=Math.min(Math.max(0,t),this.getLength()-1);var n=t==this.getLength()-1&&e>0,r=t<this.getLength()-1,i=n?e-1:e,s=n?this.getLine(i).length:0,u=r?t+1:t,a=r?0:this.getLine(u).length,f=new o(i,s,u,a),l=this.$lines.slice(e,t+1);return this.applyDelta({start:f.start,end:f.end,action:"remove",lines:this.getLinesForRange(f)}),l},this.removeNewLine=function(e){e<this.getLength()-1&&e>=0&&this.applyDelta({start:this.pos(e,this.getLine(e).length),end:this.pos(e+1,0),action:"remove",lines:["",""]})},this.replace=function(e,t){e instanceof o||(e=o.fromPoints(e.start,e.end));if(t.length===0&&e.isEmpty())return e.start;if(t==this.getTextRange(e))return e.end;this.remove(e);var n;return t?n=this.insert(e.start,t):n=e.start,n},this.applyDeltas=function(e){for(var t=0;t<e.length;t++)this.applyDelta(e[t])},this.revertDeltas=function(e){for(var t=e.length-1;t>=0;t--)this.revertDelta(e[t])},this.applyDelta=function(e,t){var n=e.action=="insert";if(n?e.lines.length<=1&&!e.lines[0]:!o.comparePoints(e.start,e.end))return;n&&e.lines.length>2e4&&this.$splitAndapplyLargeDelta(e,2e4),i(this.$lines,e,t),this._signal("change",e)},this.$splitAndapplyLargeDelta=function(e,t){var n=e.lines,r=n.length,i=e.start.row,s=e.start.column,o=0,u=0;do{o=u,u+=t-1;var a=n.slice(o,u);if(u>r){e.lines=a,e.start.row=i+o,e.start.column=s;break}a.push(""),this.applyDelta({start:this.pos(i+o,s),end:this.pos(i+u,s=0),action:e.action,lines:a},!0)}while(!0)},this.revertDelta=function(e){this.applyDelta({start:this.clonePos(e.start),end:this.clonePos(e.end),action:e.action=="insert"?"remove":"insert",lines:e.lines.slice()})},this.indexToPosition=function(e,t){var n=this.$lines||this.getAllLines(),r=this.getNewLineCharacter().length;for(var i=t||0,s=n.length;i<s;i++){e-=n[i].length+r;if(e<0)return{row:i,column:e+n[i].length+r}}return{row:s-1,column:n[s-1].length}},this.positionToIndex=function(e,t){var n=this.$lines||this.getAllLines(),r=this.getNewLineCharacter().length,i=0,s=Math.min(e.row,n.length);for(var o=t||0;o<s;++o)i+=n[o].length+r;return i+e.column}}).call(a.prototype),t.Document=a}),ace.define("ace/background_tokenizer",["require","exports","module","ace/lib/oop","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/event_emitter").EventEmitter,s=function(e,t){this.running=!1,this.lines=[],this.states=[],this.currentLine=0,this.tokenizer=e;var n=this;this.$worker=function(){if(!n.running)return;var e=new Date,t=n.currentLine,r=-1,i=n.doc,s=t;while(n.lines[t])t++;var o=i.getLength(),u=0;n.running=!1;while(t<o){n.$tokenizeRow(t),r=t;do t++;while(n.lines[t]);u++;if(u%5===0&&new Date-e>20){n.running=setTimeout(n.$worker,20);break}}n.currentLine=t,s<=r&&n.fireUpdateEvent(s,r)}};(function(){r.implement(this,i),this.setTokenizer=function(e){this.tokenizer=e,this.lines=[],this.states=[],this.start(0)},this.setDocument=function(e){this.doc=e,this.lines=[],this.states=[],this.stop()},this.fireUpdateEvent=function(e,t){var n={first:e,last:t};this._signal("update",{data:n})},this.start=function(e){this.currentLine=Math.min(e||0,this.currentLine,this.doc.getLength()),this.lines.splice(this.currentLine,this.lines.length),this.states.splice(this.currentLine,this.states.length),this.stop(),this.running=setTimeout(this.$worker,700)},this.scheduleStart=function(){this.running||(this.running=setTimeout(this.$worker,700))},this.$updateOnChange=function(e){var t=e.start.row,n=e.end.row-t;if(n===0)this.lines[t]=null;else if(e.action=="remove")this.lines.splice(t,n+1,null),this.states.splice(t,n+1,null);else{var r=Array(n+1);r.unshift(t,1),this.lines.splice.apply(this.lines,r),this.states.splice.apply(this.states,r)}this.currentLine=Math.min(t,this.currentLine,this.doc.getLength()),this.stop()},this.stop=function(){this.running&&clearTimeout(this.running),this.running=!1},this.getTokens=function(e){return this.lines[e]||this.$tokenizeRow(e)},this.getState=function(e){return this.currentLine==e&&this.$tokenizeRow(e),this.states[e]||"start"},this.$tokenizeRow=function(e){var t=this.doc.getLine(e),n=this.states[e-1],r=this.tokenizer.getLineTokens(t,n,e);return this.states[e]+""!=r.state+""?(this.states[e]=r.state,this.lines[e+1]=null,this.currentLine>e+1&&(this.currentLine=e+1)):this.currentLine==e&&(this.currentLine=e+1),this.lines[e]=r.tokens}}).call(s.prototype),t.BackgroundTokenizer=s}),ace.define("ace/search_highlight",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"],function(e,t,n){"use strict";var r=e("./lib/lang"),i=e("./lib/oop"),s=e("./range").Range,o=function(e,t,n){this.setRegexp(e),this.clazz=t,this.type=n||"text"};(function(){this.MAX_RANGES=500,this.setRegexp=function(e){if(this.regExp+""==e+"")return;this.regExp=e,this.cache=[]},this.update=function(e,t,n,i){if(!this.regExp)return;var o=i.firstRow,u=i.lastRow;for(var a=o;a<=u;a++){var f=this.cache[a];f==null&&(f=r.getMatchOffsets(n.getLine(a),this.regExp),f.length>this.MAX_RANGES&&(f=f.slice(0,this.MAX_RANGES)),f=f.map(function(e){return new s(a,e.offset,a,e.offset+e.length)}),this.cache[a]=f.length?f:"");for(var l=f.length;l--;)t.drawSingleLineMarker(e,f[l].toScreenRange(n),this.clazz,i)}}}).call(o.prototype),t.SearchHighlight=o}),ace.define("ace/edit_session/fold_line",["require","exports","module","ace/range"],function(e,t,n){"use strict";function i(e,t){this.foldData=e,Array.isArray(t)?this.folds=t:t=this.folds=[t];var n=t[t.length-1];this.range=new r(t[0].start.row,t[0].start.column,n.end.row,n.end.column),this.start=this.range.start,this.end=this.range.end,this.folds.forEach(function(e){e.setFoldLine(this)},this)}var r=e("../range").Range;(function(){this.shiftRow=function(e){this.start.row+=e,this.end.row+=e,this.folds.forEach(function(t){t.start.row+=e,t.end.row+=e})},this.addFold=function(e){if(e.sameRow){if(e.start.row<this.startRow||e.endRow>this.endRow)throw new Error("Can't add a fold to this FoldLine as it has no connection");this.folds.push(e),this.folds.sort(function(e,t){return-e.range.compareEnd(t.start.row,t.start.column)}),this.range.compareEnd(e.start.row,e.start.column)>0?(this.end.row=e.end.row,this.end.column=e.end.column):this.range.compareStart(e.end.row,e.end.column)<0&&(this.start.row=e.start.row,this.start.column=e.start.column)}else if(e.start.row==this.end.row)this.folds.push(e),this.end.row=e.end.row,this.end.column=e.end.column;else{if(e.end.row!=this.start.row)throw new Error("Trying to add fold to FoldRow that doesn't have a matching row");this.folds.unshift(e),this.start.row=e.start.row,this.start.column=e.start.column}e.foldLine=this},this.containsRow=function(e){return e>=this.start.row&&e<=this.end.row},this.walk=function(e,t,n){var r=0,i=this.folds,s,o,u,a=!0;t==null&&(t=this.end.row,n=this.end.column);for(var f=0;f<i.length;f++){s=i[f],o=s.range.compareStart(t,n);if(o==-1){e(null,t,n,r,a);return}u=e(null,s.start.row,s.start.column,r,a),u=!u&&e(s.placeholder,s.start.row,s.start.column,r);if(u||o===0)return;a=!s.sameRow,r=s.end.column}e(null,t,n,r,a)},this.getNextFoldTo=function(e,t){var n,r;for(var i=0;i<this.folds.length;i++){n=this.folds[i],r=n.range.compareEnd(e,t);if(r==-1)return{fold:n,kind:"after"};if(r===0)return{fold:n,kind:"inside"}}return null},this.addRemoveChars=function(e,t,n){var r=this.getNextFoldTo(e,t),i,s;if(r){i=r.fold;if(r.kind=="inside"&&i.start.column!=t&&i.start.row!=e)window.console&&window.console.log(e,t,i);else if(i.start.row==e){s=this.folds;var o=s.indexOf(i);o===0&&(this.start.column+=n);for(o;o<s.length;o++){i=s[o],i.start.column+=n;if(!i.sameRow)return;i.end.column+=n}this.end.column+=n}}},this.split=function(e,t){var n=this.getNextFoldTo(e,t);if(!n||n.kind=="inside")return null;var r=n.fold,s=this.folds,o=this.foldData,u=s.indexOf(r),a=s[u-1];this.end.row=a.end.row,this.end.column=a.end.column,s=s.splice(u,s.length-u);var f=new i(o,s);return o.splice(o.indexOf(this)+1,0,f),f},this.merge=function(e){var t=e.folds;for(var n=0;n<t.length;n++)this.addFold(t[n]);var r=this.foldData;r.splice(r.indexOf(e),1)},this.toString=function(){var e=[this.range.toString()+": ["];return this.folds.forEach(function(t){e.push("  "+t.toString())}),e.push("]"),e.join("\n")},this.idxToPosition=function(e){var t=0;for(var n=0;n<this.folds.length;n++){var r=this.folds[n];e-=r.start.column-t;if(e<0)return{row:r.start.row,column:r.start.column+e};e-=r.placeholder.length;if(e<0)return r.start;t=r.end.column}return{row:this.end.row,column:this.end.column+e}}}).call(i.prototype),t.FoldLine=i}),ace.define("ace/range_list",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("./range").Range,i=r.comparePoints,s=function(){this.ranges=[]};(function(){this.comparePoints=i,this.pointIndex=function(e,t,n){var r=this.ranges;for(var s=n||0;s<r.length;s++){var o=r[s],u=i(e,o.end);if(u>0)continue;var a=i(e,o.start);return u===0?t&&a!==0?-s-2:s:a>0||a===0&&!t?s:-s-1}return-s-1},this.add=function(e){var t=!e.isEmpty(),n=this.pointIndex(e.start,t);n<0&&(n=-n-1);var r=this.pointIndex(e.end,t,n);return r<0?r=-r-1:r++,this.ranges.splice(n,r-n,e)},this.addList=function(e){var t=[];for(var n=e.length;n--;)t.push.apply(t,this.add(e[n]));return t},this.substractPoint=function(e){var t=this.pointIndex(e);if(t>=0)return this.ranges.splice(t,1)},this.merge=function(){var e=[],t=this.ranges;t=t.sort(function(e,t){return i(e.start,t.start)});var n=t[0],r;for(var s=1;s<t.length;s++){r=n,n=t[s];var o=i(r.end,n.start);if(o<0)continue;if(o==0&&!r.isEmpty()&&!n.isEmpty())continue;i(r.end,n.end)<0&&(r.end.row=n.end.row,r.end.column=n.end.column),t.splice(s,1),e.push(n),n=r,s--}return this.ranges=t,e},this.contains=function(e,t){return this.pointIndex({row:e,column:t})>=0},this.containsPoint=function(e){return this.pointIndex(e)>=0},this.rangeAtPoint=function(e){var t=this.pointIndex(e);if(t>=0)return this.ranges[t]},this.clipRows=function(e,t){var n=this.ranges;if(n[0].start.row>t||n[n.length-1].start.row<e)return[];var r=this.pointIndex({row:e,column:0});r<0&&(r=-r-1);var i=this.pointIndex({row:t,column:0},r);i<0&&(i=-i-1);var s=[];for(var o=r;o<i;o++)s.push(n[o]);return s},this.removeAll=function(){return this.ranges.splice(0,this.ranges.length)},this.attach=function(e){this.session&&this.detach(),this.session=e,this.onChange=this.$onChange.bind(this),this.session.on("change",this.onChange)},this.detach=function(){if(!this.session)return;this.session.removeListener("change",this.onChange),this.session=null},this.$onChange=function(e){if(e.action=="insert")var t=e.start,n=e.end;else var n=e.start,t=e.end;var r=t.row,i=n.row,s=i-r,o=-t.column+n.column,u=this.ranges;for(var a=0,f=u.length;a<f;a++){var l=u[a];if(l.end.row<r)continue;if(l.start.row>r)break;l.start.row==r&&l.start.column>=t.column&&(l.start.column!=t.column||!this.$insertRight)&&(l.start.column+=o,l.start.row+=s);if(l.end.row==r&&l.end.column>=t.column){if(l.end.column==t.column&&this.$insertRight)continue;l.end.column==t.column&&o>0&&a<f-1&&l.end.column>l.start.column&&l.end.column==u[a+1].start.column&&(l.end.column-=o),l.end.column+=o,l.end.row+=s}}if(s!=0&&a<f)for(;a<f;a++){var l=u[a];l.start.row+=s,l.end.row+=s}}}).call(s.prototype),t.RangeList=s}),ace.define("ace/edit_session/fold",["require","exports","module","ace/range","ace/range_list","ace/lib/oop"],function(e,t,n){"use strict";function u(e,t){e.row-=t.row,e.row==0&&(e.column-=t.column)}function a(e,t){u(e.start,t),u(e.end,t)}function f(e,t){e.row==0&&(e.column+=t.column),e.row+=t.row}function l(e,t){f(e.start,t),f(e.end,t)}var r=e("../range").Range,i=e("../range_list").RangeList,s=e("../lib/oop"),o=t.Fold=function(e,t){this.foldLine=null,this.placeholder=t,this.range=e,this.start=e.start,this.end=e.end,this.sameRow=e.start.row==e.end.row,this.subFolds=this.ranges=[]};s.inherits(o,i),function(){this.toString=function(){return'"'+this.placeholder+'" '+this.range.toString()},this.setFoldLine=function(e){this.foldLine=e,this.subFolds.forEach(function(t){t.setFoldLine(e)})},this.clone=function(){var e=this.range.clone(),t=new o(e,this.placeholder);return this.subFolds.forEach(function(e){t.subFolds.push(e.clone())}),t.collapseChildren=this.collapseChildren,t},this.addSubFold=function(e){if(this.range.isEqual(e))return;if(!this.range.containsRange(e))throw new Error("A fold can't intersect already existing fold"+e.range+this.range);a(e,this.start);var t=e.start.row,n=e.start.column;for(var r=0,i=-1;r<this.subFolds.length;r++){i=this.subFolds[r].range.compare(t,n);if(i!=1)break}var s=this.subFolds[r];if(i==0)return s.addSubFold(e);var t=e.range.end.row,n=e.range.end.column;for(var o=r,i=-1;o<this.subFolds.length;o++){i=this.subFolds[o].range.compare(t,n);if(i!=1)break}var u=this.subFolds[o];if(i==0)throw new Error("A fold can't intersect already existing fold"+e.range+this.range);var f=this.subFolds.splice(r,o-r,e);return e.setFoldLine(this.foldLine),e},this.restoreRange=function(e){return l(e,this.start)}}.call(o.prototype)}),ace.define("ace/edit_session/folding",["require","exports","module","ace/range","ace/edit_session/fold_line","ace/edit_session/fold","ace/token_iterator"],function(e,t,n){"use strict";function u(){this.getFoldAt=function(e,t,n){var r=this.getFoldLine(e);if(!r)return null;var i=r.folds;for(var s=0;s<i.length;s++){var o=i[s];if(o.range.contains(e,t)){if(n==1&&o.range.isEnd(e,t))continue;if(n==-1&&o.range.isStart(e,t))continue;return o}}},this.getFoldsInRange=function(e){var t=e.start,n=e.end,r=this.$foldData,i=[];t.column+=1,n.column-=1;for(var s=0;s<r.length;s++){var o=r[s].range.compareRange(e);if(o==2)continue;if(o==-2)break;var u=r[s].folds;for(var a=0;a<u.length;a++){var f=u[a];o=f.range.compareRange(e);if(o==-2)break;if(o==2)continue;if(o==42)break;i.push(f)}}return t.column-=1,n.column+=1,i},this.getFoldsInRangeList=function(e){if(Array.isArray(e)){var t=[];e.forEach(function(e){t=t.concat(this.getFoldsInRange(e))},this)}else var t=this.getFoldsInRange(e);return t},this.getAllFolds=function(){var e=[],t=this.$foldData;for(var n=0;n<t.length;n++)for(var r=0;r<t[n].folds.length;r++)e.push(t[n].folds[r]);return e},this.getFoldStringAt=function(e,t,n,r){r=r||this.getFoldLine(e);if(!r)return null;var i={end:{column:0}},s,o;for(var u=0;u<r.folds.length;u++){o=r.folds[u];var a=o.range.compareEnd(e,t);if(a==-1){s=this.getLine(o.start.row).substring(i.end.column,o.start.column);break}if(a===0)return null;i=o}return s||(s=this.getLine(o.start.row).substring(i.end.column)),n==-1?s.substring(0,t-i.end.column):n==1?s.substring(t-i.end.column):s},this.getFoldLine=function(e,t){var n=this.$foldData,r=0;t&&(r=n.indexOf(t)),r==-1&&(r=0);for(r;r<n.length;r++){var i=n[r];if(i.start.row<=e&&i.end.row>=e)return i;if(i.end.row>e)return null}return null},this.getNextFoldLine=function(e,t){var n=this.$foldData,r=0;t&&(r=n.indexOf(t)),r==-1&&(r=0);for(r;r<n.length;r++){var i=n[r];if(i.end.row>=e)return i}return null},this.getFoldedRowCount=function(e,t){var n=this.$foldData,r=t-e+1;for(var i=0;i<n.length;i++){var s=n[i],o=s.end.row,u=s.start.row;if(o>=t){u<t&&(u>=e?r-=t-u:r=0);break}o>=e&&(u>=e?r-=o-u:r-=o-e+1)}return r},this.$addFoldLine=function(e){return this.$foldData.push(e),this.$foldData.sort(function(e,t){return e.start.row-t.start.row}),e},this.addFold=function(e,t){var n=this.$foldData,r=!1,o;e instanceof s?o=e:(o=new s(t,e),o.collapseChildren=t.collapseChildren),this.$clipRangeToDocument(o.range);var u=o.start.row,a=o.start.column,f=o.end.row,l=o.end.column;if(u<f||u==f&&a<=l-2){var c=this.getFoldAt(u,a,1),h=this.getFoldAt(f,l,-1);if(c&&h==c)return c.addSubFold(o);c&&!c.range.isStart(u,a)&&this.removeFold(c),h&&!h.range.isEnd(f,l)&&this.removeFold(h);var p=this.getFoldsInRange(o.range);p.length>0&&(this.removeFolds(p),p.forEach(function(e){o.addSubFold(e)}));for(var d=0;d<n.length;d++){var v=n[d];if(f==v.start.row){v.addFold(o),r=!0;break}if(u==v.end.row){v.addFold(o),r=!0;if(!o.sameRow){var m=n[d+1];if(m&&m.start.row==f){v.merge(m);break}}break}if(f<=v.start.row)break}return r||(v=this.$addFoldLine(new i(this.$foldData,o))),this.$useWrapMode?this.$updateWrapData(v.start.row,v.start.row):this.$updateRowLengthCache(v.start.row,v.start.row),this.$modified=!0,this._signal("changeFold",{data:o,action:"add"}),o}throw new Error("The range has to be at least 2 characters width")},this.addFolds=function(e){e.forEach(function(e){this.addFold(e)},this)},this.removeFold=function(e){var t=e.foldLine,n=t.start.row,r=t.end.row,i=this.$foldData,s=t.folds;if(s.length==1)i.splice(i.indexOf(t),1);else if(t.range.isEnd(e.end.row,e.end.column))s.pop(),t.end.row=s[s.length-1].end.row,t.end.column=s[s.length-1].end.column;else if(t.range.isStart(e.start.row,e.start.column))s.shift(),t.start.row=s[0].start.row,t.start.column=s[0].start.column;else if(e.sameRow)s.splice(s.indexOf(e),1);else{var o=t.split(e.start.row,e.start.column);s=o.folds,s.shift(),o.start.row=s[0].start.row,o.start.column=s[0].start.column}this.$updating||(this.$useWrapMode?this.$updateWrapData(n,r):this.$updateRowLengthCache(n,r)),this.$modified=!0,this._signal("changeFold",{data:e,action:"remove"})},this.removeFolds=function(e){var t=[];for(var n=0;n<e.length;n++)t.push(e[n]);t.forEach(function(e){this.removeFold(e)},this),this.$modified=!0},this.expandFold=function(e){this.removeFold(e),e.subFolds.forEach(function(t){e.restoreRange(t),this.addFold(t)},this),e.collapseChildren>0&&this.foldAll(e.start.row+1,e.end.row,e.collapseChildren-1),e.subFolds=[]},this.expandFolds=function(e){e.forEach(function(e){this.expandFold(e)},this)},this.unfold=function(e,t){var n,i;e==null?(n=new r(0,0,this.getLength(),0),t=!0):typeof e=="number"?n=new r(e,0,e,this.getLine(e).length):"row"in e?n=r.fromPoints(e,e):n=e,i=this.getFoldsInRangeList(n);if(t)this.removeFolds(i);else{var s=i;while(s.length)this.expandFolds(s),s=this.getFoldsInRangeList(n)}if(i.length)return i},this.isRowFolded=function(e,t){return!!this.getFoldLine(e,t)},this.getRowFoldEnd=function(e,t){var n=this.getFoldLine(e,t);return n?n.end.row:e},this.getRowFoldStart=function(e,t){var n=this.getFoldLine(e,t);return n?n.start.row:e},this.getFoldDisplayLine=function(e,t,n,r,i){r==null&&(r=e.start.row),i==null&&(i=0),t==null&&(t=e.end.row),n==null&&(n=this.getLine(t).length);var s=this.doc,o="";return e.walk(function(e,t,n,u){if(t<r)return;if(t==r){if(n<i)return;u=Math.max(i,u)}e!=null?o+=e:o+=s.getLine(t).substring(u,n)},t,n),o},this.getDisplayLine=function(e,t,n,r){var i=this.getFoldLine(e);if(!i){var s;return s=this.doc.getLine(e),s.substring(r||0,t||s.length)}return this.getFoldDisplayLine(i,e,t,n,r)},this.$cloneFoldData=function(){var e=[];return e=this.$foldData.map(function(t){var n=t.folds.map(function(e){return e.clone()});return new i(e,n)}),e},this.toggleFold=function(e){var t=this.selection,n=t.getRange(),r,i;if(n.isEmpty()){var s=n.start;r=this.getFoldAt(s.row,s.column);if(r){this.expandFold(r);return}(i=this.findMatchingBracket(s))?n.comparePoint(i)==1?n.end=i:(n.start=i,n.start.column++,n.end.column--):(i=this.findMatchingBracket({row:s.row,column:s.column+1}))?(n.comparePoint(i)==1?n.end=i:n.start=i,n.start.column++):n=this.getCommentFoldRange(s.row,s.column)||n}else{var o=this.getFoldsInRange(n);if(e&&o.length){this.expandFolds(o);return}o.length==1&&(r=o[0])}r||(r=this.getFoldAt(n.start.row,n.start.column));if(r&&r.range.toString()==n.toString()){this.expandFold(r);return}var u="...";if(!n.isMultiLine()){u=this.getTextRange(n);if(u.length<4)return;u=u.trim().substring(0,2)+".."}this.addFold(u,n)},this.getCommentFoldRange=function(e,t,n){var i=new o(this,e,t),s=i.getCurrentToken();if(s&&/^comment|string/.test(s.type)){var u=new r,a=new RegExp(s.type.replace(/\..*/,"\\."));if(n!=1){do s=i.stepBackward();while(s&&a.test(s.type));i.stepForward()}u.start.row=i.getCurrentTokenRow(),u.start.column=i.getCurrentTokenColumn()+2,i=new o(this,e,t);if(n!=-1){do s=i.stepForward();while(s&&a.test(s.type));s=i.stepBackward()}else s=i.getCurrentToken();return u.end.row=i.getCurrentTokenRow(),u.end.column=i.getCurrentTokenColumn()+s.value.length-2,u}},this.foldAll=function(e,t,n){n==undefined&&(n=1e5);var r=this.foldWidgets;if(!r)return;t=t||this.getLength(),e=e||0;for(var i=e;i<t;i++){r[i]==null&&(r[i]=this.getFoldWidget(i));if(r[i]!="start")continue;var s=this.getFoldWidgetRange(i);if(s&&s.isMultiLine()&&s.end.row<=t&&s.start.row>=e){i=s.end.row;try{var o=this.addFold("...",s);o&&(o.collapseChildren=n)}catch(u){}}}},this.$foldStyles={manual:1,markbegin:1,markbeginend:1},this.$foldStyle="markbegin",this.setFoldStyle=function(e){if(!this.$foldStyles[e])throw new Error("invalid fold style: "+e+"["+Object.keys(this.$foldStyles).join(", ")+"]");if(this.$foldStyle==e)return;this.$foldStyle=e,e=="manual"&&this.unfold();var t=this.$foldMode;this.$setFolding(null),this.$setFolding(t)},this.$setFolding=function(e){if(this.$foldMode==e)return;this.$foldMode=e,this.off("change",this.$updateFoldWidgets),this.off("tokenizerUpdate",this.$tokenizerUpdateFoldWidgets),this._signal("changeAnnotation");if(!e||this.$foldStyle=="manual"){this.foldWidgets=null;return}this.foldWidgets=[],this.getFoldWidget=e.getFoldWidget.bind(e,this,this.$foldStyle),this.getFoldWidgetRange=e.getFoldWidgetRange.bind(e,this,this.$foldStyle),this.$updateFoldWidgets=this.updateFoldWidgets.bind(this),this.$tokenizerUpdateFoldWidgets=this.tokenizerUpdateFoldWidgets.bind(this),this.on("change",this.$updateFoldWidgets),this.on("tokenizerUpdate",this.$tokenizerUpdateFoldWidgets)},this.getParentFoldRangeData=function(e,t){var n=this.foldWidgets;if(!n||t&&n[e])return{};var r=e-1,i;while(r>=0){var s=n[r];s==null&&(s=n[r]=this.getFoldWidget(r));if(s=="start"){var o=this.getFoldWidgetRange(r);i||(i=o);if(o&&o.end.row>=e)break}r--}return{range:r!==-1&&o,firstRange:i}},this.onFoldWidgetClick=function(e,t){t=t.domEvent;var n={children:t.shiftKey,all:t.ctrlKey||t.metaKey,siblings:t.altKey},r=this.$toggleFoldWidget(e,n);if(!r){var i=t.target||t.srcElement;i&&/ace_fold-widget/.test(i.className)&&(i.className+=" ace_invalid")}},this.$toggleFoldWidget=function(e,t){if(!this.getFoldWidget)return;var n=this.getFoldWidget(e),r=this.getLine(e),i=n==="end"?-1:1,s=this.getFoldAt(e,i===-1?0:r.length,i);if(s)return t.children||t.all?this.removeFold(s):this.expandFold(s),s;var o=this.getFoldWidgetRange(e,!0);if(o&&!o.isMultiLine()){s=this.getFoldAt(o.start.row,o.start.column,1);if(s&&o.isEqual(s.range))return this.removeFold(s),s}if(t.siblings){var u=this.getParentFoldRangeData(e);if(u.range)var a=u.range.start.row+1,f=u.range.end.row;this.foldAll(a,f,t.all?1e4:0)}else t.children?(f=o?o.end.row:this.getLength(),this.foldAll(e+1,f,t.all?1e4:0)):o&&(t.all&&(o.collapseChildren=1e4),this.addFold("...",o));return o},this.toggleFoldWidget=function(e){var t=this.selection.getCursor().row;t=this.getRowFoldStart(t);var n=this.$toggleFoldWidget(t,{});if(n)return;var r=this.getParentFoldRangeData(t,!0);n=r.range||r.firstRange;if(n){t=n.start.row;var i=this.getFoldAt(t,this.getLine(t).length,1);i?this.removeFold(i):this.addFold("...",n)}},this.updateFoldWidgets=function(e){var t=e.start.row,n=e.end.row-t;if(n===0)this.foldWidgets[t]=null;else if(e.action=="remove")this.foldWidgets.splice(t,n+1,null);else{var r=Array(n+1);r.unshift(t,1),this.foldWidgets.splice.apply(this.foldWidgets,r)}},this.tokenizerUpdateFoldWidgets=function(e){var t=e.data;t.first!=t.last&&this.foldWidgets.length>t.first&&this.foldWidgets.splice(t.first,this.foldWidgets.length)}}var r=e("../range").Range,i=e("./fold_line").FoldLine,s=e("./fold").Fold,o=e("../token_iterator").TokenIterator;t.Folding=u}),ace.define("ace/edit_session/bracket_match",["require","exports","module","ace/token_iterator","ace/range"],function(e,t,n){"use strict";function s(){this.findMatchingBracket=function(e,t){if(e.column==0)return null;var n=t||this.getLine(e.row).charAt(e.column-1);if(n=="")return null;var r=n.match(/([\(\[\{])|([\)\]\}])/);return r?r[1]?this.$findClosingBracket(r[1],e):this.$findOpeningBracket(r[2],e):null},this.getBracketRange=function(e){var t=this.getLine(e.row),n=!0,r,s=t.charAt(e.column-1),o=s&&s.match(/([\(\[\{])|([\)\]\}])/);o||(s=t.charAt(e.column),e={row:e.row,column:e.column+1},o=s&&s.match(/([\(\[\{])|([\)\]\}])/),n=!1);if(!o)return null;if(o[1]){var u=this.$findClosingBracket(o[1],e);if(!u)return null;r=i.fromPoints(e,u),n||(r.end.column++,r.start.column--),r.cursor=r.end}else{var u=this.$findOpeningBracket(o[2],e);if(!u)return null;r=i.fromPoints(u,e),n||(r.start.column++,r.end.column--),r.cursor=r.start}return r},this.$brackets={")":"(","(":")","]":"[","[":"]","{":"}","}":"{"},this.$findOpeningBracket=function(e,t,n){var i=this.$brackets[e],s=1,o=new r(this,t.row,t.column),u=o.getCurrentToken();u||(u=o.stepForward());if(!u)return;n||(n=new RegExp("(\\.?"+u.type.replace(".","\\.").replace("rparen",".paren").replace(/\b(?:end)\b/,"(?:start|begin|end)")+")+"));var a=t.column-o.getCurrentTokenColumn()-2,f=u.value;for(;;){while(a>=0){var l=f.charAt(a);if(l==i){s-=1;if(s==0)return{row:o.getCurrentTokenRow(),column:a+o.getCurrentTokenColumn()}}else l==e&&(s+=1);a-=1}do u=o.stepBackward();while(u&&!n.test(u.type));if(u==null)break;f=u.value,a=f.length-1}return null},this.$findClosingBracket=function(e,t,n){var i=this.$brackets[e],s=1,o=new r(this,t.row,t.column),u=o.getCurrentToken();u||(u=o.stepForward());if(!u)return;n||(n=new RegExp("(\\.?"+u.type.replace(".","\\.").replace("lparen",".paren").replace(/\b(?:start|begin)\b/,"(?:start|begin|end)")+")+"));var a=t.column-o.getCurrentTokenColumn();for(;;){var f=u.value,l=f.length;while(a<l){var c=f.charAt(a);if(c==i){s-=1;if(s==0)return{row:o.getCurrentTokenRow(),column:a+o.getCurrentTokenColumn()}}else c==e&&(s+=1);a+=1}do u=o.stepForward();while(u&&!n.test(u.type));if(u==null)break;a=0}return null}}var r=e("../token_iterator").TokenIterator,i=e("../range").Range;t.BracketMatch=s}),ace.define("ace/edit_session",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/config","ace/lib/event_emitter","ace/selection","ace/mode/text","ace/range","ace/document","ace/background_tokenizer","ace/search_highlight","ace/edit_session/folding","ace/edit_session/bracket_match"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/lang"),s=e("./config"),o=e("./lib/event_emitter").EventEmitter,u=e("./selection").Selection,a=e("./mode/text").Mode,f=e("./range").Range,l=e("./document").Document,c=e("./background_tokenizer").BackgroundTokenizer,h=e("./search_highlight").SearchHighlight,p=function(e,t){this.$breakpoints=[],this.$decorations=[],this.$frontMarkers={},this.$backMarkers={},this.$markerId=1,this.$undoSelect=!0,this.$foldData=[],this.id="session"+ ++p.$uid,this.$foldData.toString=function(){return this.join("\n")},this.on("changeFold",this.onChangeFold.bind(this)),this.$onChange=this.onChange.bind(this);if(typeof e!="object"||!e.getLine)e=new l(e);this.setDocument(e),this.selection=new u(this),s.resetOptions(this),this.setMode(t),s._signal("session",this)};(function(){function m(e){return e<4352?!1:e>=4352&&e<=4447||e>=4515&&e<=4519||e>=4602&&e<=4607||e>=9001&&e<=9002||e>=11904&&e<=11929||e>=11931&&e<=12019||e>=12032&&e<=12245||e>=12272&&e<=12283||e>=12288&&e<=12350||e>=12353&&e<=12438||e>=12441&&e<=12543||e>=12549&&e<=12589||e>=12593&&e<=12686||e>=12688&&e<=12730||e>=12736&&e<=12771||e>=12784&&e<=12830||e>=12832&&e<=12871||e>=12880&&e<=13054||e>=13056&&e<=19903||e>=19968&&e<=42124||e>=42128&&e<=42182||e>=43360&&e<=43388||e>=44032&&e<=55203||e>=55216&&e<=55238||e>=55243&&e<=55291||e>=63744&&e<=64255||e>=65040&&e<=65049||e>=65072&&e<=65106||e>=65108&&e<=65126||e>=65128&&e<=65131||e>=65281&&e<=65376||e>=65504&&e<=65510}r.implement(this,o),this.setDocument=function(e){this.doc&&this.doc.removeListener("change",this.$onChange),this.doc=e,e.on("change",this.$onChange),this.bgTokenizer&&this.bgTokenizer.setDocument(this.getDocument()),this.resetCaches()},this.getDocument=function(){return this.doc},this.$resetRowCache=function(e){if(!e){this.$docRowCache=[],this.$screenRowCache=[];return}var t=this.$docRowCache.length,n=this.$getRowCacheIndex(this.$docRowCache,e)+1;t>n&&(this.$docRowCache.splice(n,t),this.$screenRowCache.splice(n,t))},this.$getRowCacheIndex=function(e,t){var n=0,r=e.length-1;while(n<=r){var i=n+r>>1,s=e[i];if(t>s)n=i+1;else{if(!(t<s))return i;r=i-1}}return n-1},this.resetCaches=function(){this.$modified=!0,this.$wrapData=[],this.$rowLengthCache=[],this.$resetRowCache(0),this.bgTokenizer&&this.bgTokenizer.start(0)},this.onChangeFold=function(e){var t=e.data;this.$resetRowCache(t.start.row)},this.onChange=function(e){this.$modified=!0,this.$resetRowCache(e.start.row);var t=this.$updateInternalDataOnChange(e);!this.$fromUndo&&this.$undoManager&&!e.ignore&&(this.$deltasDoc.push(e),t&&t.length!=0&&this.$deltasFold.push({action:"removeFolds",folds:t}),this.$informUndoManager.schedule()),this.bgTokenizer&&this.bgTokenizer.$updateOnChange(e),this._signal("change",e)},this.setValue=function(e){this.doc.setValue(e),this.selection.moveTo(0,0),this.$resetRowCache(0),this.$deltas=[],this.$deltasDoc=[],this.$deltasFold=[],this.setUndoManager(this.$undoManager),this.getUndoManager().reset()},this.getValue=this.toString=function(){return this.doc.getValue()},this.getSelection=function(){return this.selection},this.getState=function(e){return this.bgTokenizer.getState(e)},this.getTokens=function(e){return this.bgTokenizer.getTokens(e)},this.getTokenAt=function(e,t){var n=this.bgTokenizer.getTokens(e),r,i=0;if(t==null)s=n.length-1,i=this.getLine(e).length;else for(var s=0;s<n.length;s++){i+=n[s].value.length;if(i>=t)break}return r=n[s],r?(r.index=s,r.start=i-r.value.length,r):null},this.setUndoManager=function(e){this.$undoManager=e,this.$deltas=[],this.$deltasDoc=[],this.$deltasFold=[],this.$informUndoManager&&this.$informUndoManager.cancel();if(e){var t=this;this.$syncInformUndoManager=function(){t.$informUndoManager.cancel(),t.$deltasFold.length&&(t.$deltas.push({group:"fold",deltas:t.$deltasFold}),t.$deltasFold=[]),t.$deltasDoc.length&&(t.$deltas.push({group:"doc",deltas:t.$deltasDoc}),t.$deltasDoc=[]),t.$deltas.length>0&&e.execute({action:"aceupdate",args:[t.$deltas,t],merge:t.mergeUndoDeltas}),t.mergeUndoDeltas=!1,t.$deltas=[]},this.$informUndoManager=i.delayedCall(this.$syncInformUndoManager)}},this.markUndoGroup=function(){this.$syncInformUndoManager&&this.$syncInformUndoManager()},this.$defaultUndoManager={undo:function(){},redo:function(){},reset:function(){}},this.getUndoManager=function(){return this.$undoManager||this.$defaultUndoManager},this.getTabString=function(){return this.getUseSoftTabs()?i.stringRepeat(" ",this.getTabSize()):"	"},this.setUseSoftTabs=function(e){this.setOption("useSoftTabs",e)},this.getUseSoftTabs=function(){return this.$useSoftTabs&&!this.$mode.$indentWithTabs},this.setTabSize=function(e){this.setOption("tabSize",e)},this.getTabSize=function(){return this.$tabSize},this.isTabStop=function(e){return this.$useSoftTabs&&e.column%this.$tabSize===0},this.$overwrite=!1,this.setOverwrite=function(e){this.setOption("overwrite",e)},this.getOverwrite=function(){return this.$overwrite},this.toggleOverwrite=function(){this.setOverwrite(!this.$overwrite)},this.addGutterDecoration=function(e,t){this.$decorations[e]||(this.$decorations[e]=""),this.$decorations[e]+=" "+t,this._signal("changeBreakpoint",{})},this.removeGutterDecoration=function(e,t){this.$decorations[e]=(this.$decorations[e]||"").replace(" "+t,""),this._signal("changeBreakpoint",{})},this.getBreakpoints=function(){return this.$breakpoints},this.setBreakpoints=function(e){this.$breakpoints=[];for(var t=0;t<e.length;t++)this.$breakpoints[e[t]]="ace_breakpoint";this._signal("changeBreakpoint",{})},this.clearBreakpoints=function(){this.$breakpoints=[],this._signal("changeBreakpoint",{})},this.setBreakpoint=function(e,t){t===undefined&&(t="ace_breakpoint"),t?this.$breakpoints[e]=t:delete this.$breakpoints[e],this._signal("changeBreakpoint",{})},this.clearBreakpoint=function(e){delete this.$breakpoints[e],this._signal("changeBreakpoint",{})},this.addMarker=function(e,t,n,r){var i=this.$markerId++,s={range:e,type:n||"line",renderer:typeof n=="function"?n:null,clazz:t,inFront:!!r,id:i};return r?(this.$frontMarkers[i]=s,this._signal("changeFrontMarker")):(this.$backMarkers[i]=s,this._signal("changeBackMarker")),i},this.addDynamicMarker=function(e,t){if(!e.update)return;var n=this.$markerId++;return e.id=n,e.inFront=!!t,t?(this.$frontMarkers[n]=e,this._signal("changeFrontMarker")):(this.$backMarkers[n]=e,this._signal("changeBackMarker")),e},this.removeMarker=function(e){var t=this.$frontMarkers[e]||this.$backMarkers[e];if(!t)return;var n=t.inFront?this.$frontMarkers:this.$backMarkers;t&&(delete n[e],this._signal(t.inFront?"changeFrontMarker":"changeBackMarker"))},this.getMarkers=function(e){return e?this.$frontMarkers:this.$backMarkers},this.highlight=function(e){if(!this.$searchHighlight){var t=new h(null,"ace_selected-word","text");this.$searchHighlight=this.addDynamicMarker(t)}this.$searchHighlight.setRegexp(e)},this.highlightLines=function(e,t,n,r){typeof t!="number"&&(n=t,t=e),n||(n="ace_step");var i=new f(e,0,t,Infinity);return i.id=this.addMarker(i,n,"fullLine",r),i},this.setAnnotations=function(e){this.$annotations=e,this._signal("changeAnnotation",{})},this.getAnnotations=function(){return this.$annotations||[]},this.clearAnnotations=function(){this.setAnnotations([])},this.$detectNewLine=function(e){var t=e.match(/^.*?(\r?\n)/m);t?this.$autoNewLine=t[1]:this.$autoNewLine="\n"},this.getWordRange=function(e,t){var n=this.getLine(e),r=!1;t>0&&(r=!!n.charAt(t-1).match(this.tokenRe)),r||(r=!!n.charAt(t).match(this.tokenRe));if(r)var i=this.tokenRe;else if(/^\s+$/.test(n.slice(t-1,t+1)))var i=/\s/;else var i=this.nonTokenRe;var s=t;if(s>0){do s--;while(s>=0&&n.charAt(s).match(i));s++}var o=t;while(o<n.length&&n.charAt(o).match(i))o++;return new f(e,s,e,o)},this.getAWordRange=function(e,t){var n=this.getWordRange(e,t),r=this.getLine(n.end.row);while(r.charAt(n.end.column).match(/[ \t]/))n.end.column+=1;return n},this.setNewLineMode=function(e){this.doc.setNewLineMode(e)},this.getNewLineMode=function(){return this.doc.getNewLineMode()},this.setUseWorker=function(e){this.setOption("useWorker",e)},this.getUseWorker=function(){return this.$useWorker},this.onReloadTokenizer=function(e){var t=e.data;this.bgTokenizer.start(t.first),this._signal("tokenizerUpdate",e)},this.$modes={},this.$mode=null,this.$modeId=null,this.setMode=function(e,t){if(e&&typeof e=="object"){if(e.getTokenizer)return this.$onChangeMode(e);var n=e,r=n.path}else r=e||"ace/mode/text";this.$modes["ace/mode/text"]||(this.$modes["ace/mode/text"]=new a);if(this.$modes[r]&&!n){this.$onChangeMode(this.$modes[r]),t&&t();return}this.$modeId=r,s.loadModule(["mode",r],function(e){if(this.$modeId!==r)return t&&t();this.$modes[r]&&!n?this.$onChangeMode(this.$modes[r]):e&&e.Mode&&(e=new e.Mode(n),n||(this.$modes[r]=e,e.$id=r),this.$onChangeMode(e)),t&&t()}.bind(this)),this.$mode||this.$onChangeMode(this.$modes["ace/mode/text"],!0)},this.$onChangeMode=function(e,t){t||(this.$modeId=e.$id);if(this.$mode===e)return;this.$mode=e,this.$stopWorker(),this.$useWorker&&this.$startWorker();var n=e.getTokenizer();if(n.addEventListener!==undefined){var r=this.onReloadTokenizer.bind(this);n.addEventListener("update",r)}if(!this.bgTokenizer){this.bgTokenizer=new c(n);var i=this;this.bgTokenizer.addEventListener("update",function(e){i._signal("tokenizerUpdate",e)})}else this.bgTokenizer.setTokenizer(n);this.bgTokenizer.setDocument(this.getDocument()),this.tokenRe=e.tokenRe,this.nonTokenRe=e.nonTokenRe,t||(e.attachToSession&&e.attachToSession(this),this.$options.wrapMethod.set.call(this,this.$wrapMethod),this.$setFolding(e.foldingRules),this.bgTokenizer.start(0),this._emit("changeMode"))},this.$stopWorker=function(){this.$worker&&(this.$worker.terminate(),this.$worker=null)},this.$startWorker=function(){try{this.$worker=this.$mode.createWorker(this)}catch(e){s.warn("Could not load worker",e),this.$worker=null}},this.getMode=function(){return this.$mode},this.$scrollTop=0,this.setScrollTop=function(e){if(this.$scrollTop===e||isNaN(e))return;this.$scrollTop=e,this._signal("changeScrollTop",e)},this.getScrollTop=function(){return this.$scrollTop},this.$scrollLeft=0,this.setScrollLeft=function(e){if(this.$scrollLeft===e||isNaN(e))return;this.$scrollLeft=e,this._signal("changeScrollLeft",e)},this.getScrollLeft=function(){return this.$scrollLeft},this.getScreenWidth=function(){return this.$computeWidth(),this.lineWidgets?Math.max(this.getLineWidgetMaxWidth(),this.screenWidth):this.screenWidth},this.getLineWidgetMaxWidth=function(){if(this.lineWidgetsWidth!=null)return this.lineWidgetsWidth;var e=0;return this.lineWidgets.forEach(function(t){t&&t.screenWidth>e&&(e=t.screenWidth)}),this.lineWidgetWidth=e},this.$computeWidth=function(e){if(this.$modified||e){this.$modified=!1;if(this.$useWrapMode)return this.screenWidth=this.$wrapLimit;var t=this.doc.getAllLines(),n=this.$rowLengthCache,r=0,i=0,s=this.$foldData[i],o=s?s.start.row:Infinity,u=t.length;for(var a=0;a<u;a++){if(a>o){a=s.end.row+1;if(a>=u)break;s=this.$foldData[i++],o=s?s.start.row:Infinity}n[a]==null&&(n[a]=this.$getStringScreenWidth(t[a])[0]),n[a]>r&&(r=n[a])}this.screenWidth=r}},this.getLine=function(e){return this.doc.getLine(e)},this.getLines=function(e,t){return this.doc.getLines(e,t)},this.getLength=function(){return this.doc.getLength()},this.getTextRange=function(e){return this.doc.getTextRange(e||this.selection.getRange())},this.insert=function(e,t){return this.doc.insert(e,t)},this.remove=function(e){return this.doc.remove(e)},this.removeFullLines=function(e,t){return this.doc.removeFullLines(e,t)},this.undoChanges=function(e,t){if(!e.length)return;this.$fromUndo=!0;var n=null;for(var r=e.length-1;r!=-1;r--){var i=e[r];i.group=="doc"?(this.doc.revertDeltas(i.deltas),n=this.$getUndoSelection(i.deltas,!0,n)):i.deltas.forEach(function(e){this.addFolds(e.folds)},this)}return this.$fromUndo=!1,n&&this.$undoSelect&&!t&&this.selection.setSelectionRange(n),n},this.redoChanges=function(e,t){if(!e.length)return;this.$fromUndo=!0;var n=null;for(var r=0;r<e.length;r++){var i=e[r];i.group=="doc"&&(this.doc.applyDeltas(i.deltas),n=this.$getUndoSelection(i.deltas,!1,n))}return this.$fromUndo=!1,n&&this.$undoSelect&&!t&&this.selection.setSelectionRange(n),n},this.setUndoSelect=function(e){this.$undoSelect=e},this.$getUndoSelection=function(e,t,n){function r(e){return t?e.action!=="insert":e.action==="insert"}var i=e[0],s,o,u=!1;r(i)?(s=f.fromPoints(i.start,i.end),u=!0):(s=f.fromPoints(i.start,i.start),u=!1);for(var a=1;a<e.length;a++)i=e[a],r(i)?(o=i.start,s.compare(o.row,o.column)==-1&&s.setStart(o),o=i.end,s.compare(o.row,o.column)==1&&s.setEnd(o),u=!0):(o=i.start,s.compare(o.row,o.column)==-1&&(s=f.fromPoints(i.start,i.start)),u=!1);if(n!=null){f.comparePoints(n.start,s.start)===0&&(n.start.column+=s.end.column-s.start.column,n.end.column+=s.end.column-s.start.column);var l=n.compareRange(s);l==1?s.setStart(n.start):l==-1&&s.setEnd(n.end)}return s},this.replace=function(e,t){return this.doc.replace(e,t)},this.moveText=function(e,t,n){var r=this.getTextRange(e),i=this.getFoldsInRange(e),s=f.fromPoints(t,t);if(!n){this.remove(e);var o=e.start.row-e.end.row,u=o?-e.end.column:e.start.column-e.end.column;u&&(s.start.row==e.end.row&&s.start.column>e.end.column&&(s.start.column+=u),s.end.row==e.end.row&&s.end.column>e.end.column&&(s.end.column+=u)),o&&s.start.row>=e.end.row&&(s.start.row+=o,s.end.row+=o)}s.end=this.insert(s.start,r);if(i.length){var a=e.start,l=s.start,o=l.row-a.row,u=l.column-a.column;this.addFolds(i.map(function(e){return e=e.clone(),e.start.row==a.row&&(e.start.column+=u),e.end.row==a.row&&(e.end.column+=u),e.start.row+=o,e.end.row+=o,e}))}return s},this.indentRows=function(e,t,n){n=n.replace(/\t/g,this.getTabString());for(var r=e;r<=t;r++)this.doc.insertInLine({row:r,column:0},n)},this.outdentRows=function(e){var t=e.collapseRows(),n=new f(0,0,0,0),r=this.getTabSize();for(var i=t.start.row;i<=t.end.row;++i){var s=this.getLine(i);n.start.row=i,n.end.row=i;for(var o=0;o<r;++o)if(s.charAt(o)!=" ")break;o<r&&s.charAt(o)=="	"?(n.start.column=o,n.end.column=o+1):(n.start.column=0,n.end.column=o),this.remove(n)}},this.$moveLines=function(e,t,n){e=this.getRowFoldStart(e),t=this.getRowFoldEnd(t);if(n<0){var r=this.getRowFoldStart(e+n);if(r<0)return 0;var i=r-e}else if(n>0){var r=this.getRowFoldEnd(t+n);if(r>this.doc.getLength()-1)return 0;var i=r-t}else{e=this.$clipRowToDocument(e),t=this.$clipRowToDocument(t);var i=t-e+1}var s=new f(e,0,t,Number.MAX_VALUE),o=this.getFoldsInRange(s).map(function(e){return e=e.clone(),e.start.row+=i,e.end.row+=i,e}),u=n==0?this.doc.getLines(e,t):this.doc.removeFullLines(e,t);return this.doc.insertFullLines(e+i,u),o.length&&this.addFolds(o),i},this.moveLinesUp=function(e,t){return this.$moveLines(e,t,-1)},this.moveLinesDown=function(e,t){return this.$moveLines(e,t,1)},this.duplicateLines=function(e,t){return this.$moveLines(e,t,0)},this.$clipRowToDocument=function(e){return Math.max(0,Math.min(e,this.doc.getLength()-1))},this.$clipColumnToRow=function(e,t){return t<0?0:Math.min(this.doc.getLine(e).length,t)},this.$clipPositionToDocument=function(e,t){t=Math.max(0,t);if(e<0)e=0,t=0;else{var n=this.doc.getLength();e>=n?(e=n-1,t=this.doc.getLine(n-1).length):t=Math.min(this.doc.getLine(e).length,t)}return{row:e,column:t}},this.$clipRangeToDocument=function(e){e.start.row<0?(e.start.row=0,e.start.column=0):e.start.column=this.$clipColumnToRow(e.start.row,e.start.column);var t=this.doc.getLength()-1;return e.end.row>t?(e.end.row=t,e.end.column=this.doc.getLine(t).length):e.end.column=this.$clipColumnToRow(e.end.row,e.end.column),e},this.$wrapLimit=80,this.$useWrapMode=!1,this.$wrapLimitRange={min:null,max:null},this.setUseWrapMode=function(e){if(e!=this.$useWrapMode){this.$useWrapMode=e,this.$modified=!0,this.$resetRowCache(0);if(e){var t=this.getLength();this.$wrapData=Array(t),this.$updateWrapData(0,t-1)}this._signal("changeWrapMode")}},this.getUseWrapMode=function(){return this.$useWrapMode},this.setWrapLimitRange=function(e,t){if(this.$wrapLimitRange.min!==e||this.$wrapLimitRange.max!==t)this.$wrapLimitRange={min:e,max:t},this.$modified=!0,this.$useWrapMode&&this._signal("changeWrapMode")},this.adjustWrapLimit=function(e,t){var n=this.$wrapLimitRange;n.max<0&&(n={min:t,max:t});var r=this.$constrainWrapLimit(e,n.min,n.max);return r!=this.$wrapLimit&&r>1?(this.$wrapLimit=r,this.$modified=!0,this.$useWrapMode&&(this.$updateWrapData(0,this.getLength()-1),this.$resetRowCache(0),this._signal("changeWrapLimit")),!0):!1},this.$constrainWrapLimit=function(e,t,n){return t&&(e=Math.max(t,e)),n&&(e=Math.min(n,e)),e},this.getWrapLimit=function(){return this.$wrapLimit},this.setWrapLimit=function(e){this.setWrapLimitRange(e,e)},this.getWrapLimitRange=function(){return{min:this.$wrapLimitRange.min,max:this.$wrapLimitRange.max}},this.$updateInternalDataOnChange=function(e){var t=this.$useWrapMode,n=e.action,r=e.start,i=e.end,s=r.row,o=i.row,u=o-s,a=null;this.$updating=!0;if(u!=0)if(n==="remove"){this[t?"$wrapData":"$rowLengthCache"].splice(s,u);var f=this.$foldData;a=this.getFoldsInRange(e),this.removeFolds(a);var l=this.getFoldLine(i.row),c=0;if(l){l.addRemoveChars(i.row,i.column,r.column-i.column),l.shiftRow(-u);var h=this.getFoldLine(s);h&&h!==l&&(h.merge(l),l=h),c=f.indexOf(l)+1}for(c;c<f.length;c++){var l=f[c];l.start.row>=i.row&&l.shiftRow(-u)}o=s}else{var p=Array(u);p.unshift(s,0);var d=t?this.$wrapData:this.$rowLengthCache;d.splice.apply(d,p);var f=this.$foldData,l=this.getFoldLine(s),c=0;if(l){var v=l.range.compareInside(r.row,r.column);v==0?(l=l.split(r.row,r.column),l&&(l.shiftRow(u),l.addRemoveChars(o,0,i.column-r.column))):v==-1&&(l.addRemoveChars(s,0,i.column-r.column),l.shiftRow(u)),c=f.indexOf(l)+1}for(c;c<f.length;c++){var l=f[c];l.start.row>=s&&l.shiftRow(u)}}else{u=Math.abs(e.start.column-e.end.column),n==="remove"&&(a=this.getFoldsInRange(e),this.removeFolds(a),u=-u);var l=this.getFoldLine(s);l&&l.addRemoveChars(s,r.column,u)}return t&&this.$wrapData.length!=this.doc.getLength()&&console.error("doc.getLength() and $wrapData.length have to be the same!"),this.$updating=!1,t?this.$updateWrapData(s,o):this.$updateRowLengthCache(s,o),a},this.$updateRowLengthCache=function(e,t,n){this.$rowLengthCache[e]=null,this.$rowLengthCache[t]=null},this.$updateWrapData=function(e,t){var r=this.doc.getAllLines(),i=this.getTabSize(),s=this.$wrapData,o=this.$wrapLimit,a,f,l=e;t=Math.min(t,r.length-1);while(l<=t)f=this.getFoldLine(l,f),f?(a=[],f.walk(function(e,t,i,s){var o;if(e!=null){o=this.$getDisplayTokens(e,a.length),o[0]=n;for(var f=1;f<o.length;f++)o[f]=u}else o=this.$getDisplayTokens(r[t].substring(s,i),a.length);a=a.concat(o)}.bind(this),f.end.row,r[f.end.row].length+1),s[f.start.row]=this.$computeWrapSplits(a,o,i),l=f.end.row+1):(a=this.$getDisplayTokens(r[l]),s[l]=this.$computeWrapSplits(a,o,i),l++)};var e=1,t=2,n=3,u=4,l=9,p=10,d=11,v=12;this.$computeWrapSplits=function(e,r,i){function g(){var t=0;if(m===0)return t;if(h)for(var n=0;n<e.length;n++){var r=e[n];if(r==p)t+=1;else{if(r!=d){if(r==v)continue;break}t+=i}}return c&&h!==!1&&(t+=i),Math.min(t,m)}function y(t){var n=e.slice(a,t),r=n.length;n.join("").replace(/12/g,function(){r-=1}).replace(/2/g,function(){r-=1}),s.length||(b=g(),s.indent=b),f+=r,s.push(f),a=t}if(e.length==0)return[];var s=[],o=e.length,a=0,f=0,c=this.$wrapAsCode,h=this.$indentedSoftWrap,m=r<=Math.max(2*i,8)||h===!1?0:Math.floor(r/2),b=0;while(o-a>r-b){var w=a+r-b;if(e[w-1]>=p&&e[w]>=p){y(w);continue}if(e[w]==n||e[w]==u){for(w;w!=a-1;w--)if(e[w]==n)break;if(w>a){y(w);continue}w=a+r;for(w;w<e.length;w++)if(e[w]!=u)break;if(w==e.length)break;y(w);continue}var E=Math.max(w-(r-(r>>2)),a-1);while(w>E&&e[w]<n)w--;if(c){while(w>E&&e[w]<n)w--;while(w>E&&e[w]==l)w--}else while(w>E&&e[w]<p)w--;if(w>E){y(++w);continue}w=a+r,e[w]==t&&w--,y(w-b)}return s},this.$getDisplayTokens=function(n,r){var i=[],s;r=r||0;for(var o=0;o<n.length;o++){var u=n.charCodeAt(o);if(u==9){s=this.getScreenTabSize(i.length+r),i.push(d);for(var a=1;a<s;a++)i.push(v)}else u==32?i.push(p):u>39&&u<48||u>57&&u<64?i.push(l):u>=4352&&m(u)?i.push(e,t):i.push(e)}return i},this.$getStringScreenWidth=function(e,t,n){if(t==0)return[0,0];t==null&&(t=Infinity),n=n||0;var r,i;for(i=0;i<e.length;i++){r=e.charCodeAt(i),r==9?n+=this.getScreenTabSize(n):r>=4352&&m(r)?n+=2:n+=1;if(n>t)break}return[n,i]},this.lineWidgets=null,this.getRowLength=function(e){if(this.lineWidgets)var t=this.lineWidgets[e]&&this.lineWidgets[e].rowCount||0;else t=0;return!this.$useWrapMode||!this.$wrapData[e]?1+t:this.$wrapData[e].length+1+t},this.getRowLineCount=function(e){return!this.$useWrapMode||!this.$wrapData[e]?1:this.$wrapData[e].length+1},this.getRowWrapIndent=function(e){if(this.$useWrapMode){var t=this.screenToDocumentPosition(e,Number.MAX_VALUE),n=this.$wrapData[t.row];return n.length&&n[0]<t.column?n.indent:0}return 0},this.getScreenLastRowColumn=function(e){var t=this.screenToDocumentPosition(e,Number.MAX_VALUE);return this.documentToScreenColumn(t.row,t.column)},this.getDocumentLastRowColumn=function(e,t){var n=this.documentToScreenRow(e,t);return this.getScreenLastRowColumn(n)},this.getDocumentLastRowColumnPosition=function(e,t){var n=this.documentToScreenRow(e,t);return this.screenToDocumentPosition(n,Number.MAX_VALUE/10)},this.getRowSplitData=function(e){return this.$useWrapMode?this.$wrapData[e]:undefined},this.getScreenTabSize=function(e){return this.$tabSize-e%this.$tabSize},this.screenToDocumentRow=function(e,t){return this.screenToDocumentPosition(e,t).row},this.screenToDocumentColumn=function(e,t){return this.screenToDocumentPosition(e,t).column},this.screenToDocumentPosition=function(e,t){if(e<0)return{row:0,column:0};var n,r=0,i=0,s,o=0,u=0,a=this.$screenRowCache,f=this.$getRowCacheIndex(a,e),l=a.length;if(l&&f>=0)var o=a[f],r=this.$docRowCache[f],c=e>a[l-1];else var c=!l;var h=this.getLength()-1,p=this.getNextFoldLine(r),d=p?p.start.row:Infinity;while(o<=e){u=this.getRowLength(r);if(o+u>e||r>=h)break;o+=u,r++,r>d&&(r=p.end.row+1,p=this.getNextFoldLine(r,p),d=p?p.start.row:Infinity),c&&(this.$docRowCache.push(r),this.$screenRowCache.push(o))}if(p&&p.start.row<=r)n=this.getFoldDisplayLine(p),r=p.start.row;else{if(o+u<=e||r>h)return{row:h,column:this.getLine(h).length};n=this.getLine(r),p=null}var v=0;if(this.$useWrapMode){var m=this.$wrapData[r];if(m){var g=Math.floor(e-o);s=m[g],g>0&&m.length&&(v=m.indent,i=m[g-1]||m[m.length-1],n=n.substring(i))}}return i+=this.$getStringScreenWidth(n,t-v)[1],this.$useWrapMode&&i>=s&&(i=s-1),p?p.idxToPosition(i):{row:r,column:i}},this.documentToScreenPosition=function(e,t){if(typeof t=="undefined")var n=this.$clipPositionToDocument(e.row,e.column);else n=this.$clipPositionToDocument(e,t);e=n.row,t=n.column;var r=0,i=null,s=null;s=this.getFoldAt(e,t,1),s&&(e=s.start.row,t=s.start.column);var o,u=0,a=this.$docRowCache,f=this.$getRowCacheIndex(a,e),l=a.length;if(l&&f>=0)var u=a[f],r=this.$screenRowCache[f],c=e>a[l-1];else var c=!l;var h=this.getNextFoldLine(u),p=h?h.start.row:Infinity;while(u<e){if(u>=p){o=h.end.row+1;if(o>e)break;h=this.getNextFoldLine(o,h),p=h?h.start.row:Infinity}else o=u+1;r+=this.getRowLength(u),u=o,c&&(this.$docRowCache.push(u),this.$screenRowCache.push(r))}var d="";h&&u>=p?(d=this.getFoldDisplayLine(h,e,t),i=h.start.row):(d=this.getLine(e).substring(0,t),i=e);var v=0;if(this.$useWrapMode){var m=this.$wrapData[i];if(m){var g=0;while(d.length>=m[g])r++,g++;d=d.substring(m[g-1]||0,d.length),v=g>0?m.indent:0}}return{row:r,column:v+this.$getStringScreenWidth(d)[0]}},this.documentToScreenColumn=function(e,t){return this.documentToScreenPosition(e,t).column},this.documentToScreenRow=function(e,t){return this.documentToScreenPosition(e,t).row},this.getScreenLength=function(){var e=0,t=null;if(!this.$useWrapMode){e=this.getLength();var n=this.$foldData;for(var r=0;r<n.length;r++)t=n[r],e-=t.end.row-t.start.row}else{var i=this.$wrapData.length,s=0,r=0,t=this.$foldData[r++],o=t?t.start.row:Infinity;while(s<i){var u=this.$wrapData[s];e+=u?u.length+1:1,s++,s>o&&(s=t.end.row+1,t=this.$foldData[r++],o=t?t.start.row:Infinity)}}return this.lineWidgets&&(e+=this.$getWidgetScreenLength()),e},this.$setFontMetrics=function(e){if(!this.$enableVarChar)return;this.$getStringScreenWidth=function(t,n,r){if(n===0)return[0,0];n||(n=Infinity),r=r||0;var i,s;for(s=0;s<t.length;s++){i=t.charAt(s),i==="	"?r+=this.getScreenTabSize(r):r+=e.getCharacterWidth(i);if(r>n)break}return[r,s]}},this.destroy=function(){this.bgTokenizer&&(this.bgTokenizer.setDocument(null),this.bgTokenizer=null),this.$stopWorker()}}).call(p.prototype),e("./edit_session/folding").Folding.call(p.prototype),e("./edit_session/bracket_match").BracketMatch.call(p.prototype),s.defineOptions(p.prototype,"session",{wrap:{set:function(e){!e||e=="off"?e=!1:e=="free"?e=!0:e=="printMargin"?e=-1:typeof e=="string"&&(e=parseInt(e,10)||!1);if(this.$wrap==e)return;this.$wrap=e;if(!e)this.setUseWrapMode(!1);else{var t=typeof e=="number"?e:null;this.setWrapLimitRange(t,t),this.setUseWrapMode(!0)}},get:function(){return this.getUseWrapMode()?this.$wrap==-1?"printMargin":this.getWrapLimitRange().min?this.$wrap:"free":"off"},handlesSet:!0},wrapMethod:{set:function(e){e=e=="auto"?this.$mode.type!="text":e!="text",e!=this.$wrapAsCode&&(this.$wrapAsCode=e,this.$useWrapMode&&(this.$modified=!0,this.$resetRowCache(0),this.$updateWrapData(0,this.getLength()-1)))},initialValue:"auto"},indentedSoftWrap:{initialValue:!0},firstLineNumber:{set:function(){this._signal("changeBreakpoint")},initialValue:1},useWorker:{set:function(e){this.$useWorker=e,this.$stopWorker(),e&&this.$startWorker()},initialValue:!0},useSoftTabs:{initialValue:!0},tabSize:{set:function(e){if(isNaN(e)||this.$tabSize===e)return;this.$modified=!0,this.$rowLengthCache=[],this.$tabSize=e,this._signal("changeTabSize")},initialValue:4,handlesSet:!0},overwrite:{set:function(e){this._signal("changeOverwrite")},initialValue:!1},newLineMode:{set:function(e){this.doc.setNewLineMode(e)},get:function(){return this.doc.getNewLineMode()},handlesSet:!0},mode:{set:function(e){this.setMode(e)},get:function(){return this.$modeId}}}),t.EditSession=p}),ace.define("ace/search",["require","exports","module","ace/lib/lang","ace/lib/oop","ace/range"],function(e,t,n){"use strict";function u(e,t){function n(e){return/\w/.test(e)||t.regExp?"\\b":""}return n(e[0])+e+n(e[e.length-1])}var r=e("./lib/lang"),i=e("./lib/oop"),s=e("./range").Range,o=function(){this.$options={}};(function(){this.set=function(e){return i.mixin(this.$options,e),this},this.getOptions=function(){return r.copyObject(this.$options)},this.setOptions=function(e){this.$options=e},this.find=function(e){var t=this.$options,n=this.$matchIterator(e,t);if(!n)return!1;var r=null;return n.forEach(function(e,n,i){if(!e.start){var o=e.offset+(i||0);r=new s(n,o,n,o+e.length);if(!e.length&&t.start&&t.start.start&&t.skipCurrent!=0&&r.isEqual(t.start))return r=null,!1}else r=e;return!0}),r},this.findAll=function(e){var t=this.$options;if(!t.needle)return[];this.$assembleRegExp(t);var n=t.range,i=n?e.getLines(n.start.row,n.end.row):e.doc.getAllLines(),o=[],u=t.re;if(t.$isMultiLine){var a=u.length,f=i.length-a,l;e:for(var c=u.offset||0;c<=f;c++){for(var h=0;h<a;h++)if(i[c+h].search(u[h])==-1)continue e;var p=i[c],d=i[c+a-1],v=p.length-p.match(u[0])[0].length,m=d.match(u[a-1])[0].length;if(l&&l.end.row===c&&l.end.column>v)continue;o.push(l=new s(c,v,c+a-1,m)),a>2&&(c=c+a-2)}}else for(var g=0;g<i.length;g++){var y=r.getMatchOffsets(i[g],u);for(var h=0;h<y.length;h++){var b=y[h];o.push(new s(g,b.offset,g,b.offset+b.length))}}if(n){var w=n.start.column,E=n.start.column,g=0,h=o.length-1;while(g<h&&o[g].start.column<w&&o[g].start.row==n.start.row)g++;while(g<h&&o[h].end.column>E&&o[h].end.row==n.end.row)h--;o=o.slice(g,h+1);for(g=0,h=o.length;g<h;g++)o[g].start.row+=n.start.row,o[g].end.row+=n.start.row}return o},this.replace=function(e,t){var n=this.$options,r=this.$assembleRegExp(n);if(n.$isMultiLine)return t;if(!r)return;var i=r.exec(e);if(!i||i[0].length!=e.length)return null;t=e.replace(r,t);if(n.preserveCase){t=t.split("");for(var s=Math.min(e.length,e.length);s--;){var o=e[s];o&&o.toLowerCase()!=o?t[s]=t[s].toUpperCase():t[s]=t[s].toLowerCase()}t=t.join("")}return t},this.$matchIterator=function(e,t){var n=this.$assembleRegExp(t);if(!n)return!1;var i;if(t.$isMultiLine)var o=n.length,u=function(t,r,u){var a=t.search(n[0]);if(a==-1)return;for(var f=1;f<o;f++){t=e.getLine(r+f);if(t.search(n[f])==-1)return}var l=t.match(n[o-1])[0].length,c=new s(r,a,r+o-1,l);n.offset==1?(c.start.row--,c.start.column=Number.MAX_VALUE):u&&(c.start.column+=u);if(i(c))return!0};else if(t.backwards)var u=function(e,t,s){var o=r.getMatchOffsets(e,n);for(var u=o.length-1;u>=0;u--)if(i(o[u],t,s))return!0};else var u=function(e,t,s){var o=r.getMatchOffsets(e,n);for(var u=0;u<o.length;u++)if(i(o[u],t,s))return!0};var a=this.$lineIterator(e,t);return{forEach:function(e){i=e,a.forEach(u)}}},this.$assembleRegExp=function(e,t){if(e.needle instanceof RegExp)return e.re=e.needle;var n=e.needle;if(!e.needle)return e.re=!1;e.regExp||(n=r.escapeRegExp(n)),e.wholeWord&&(n=u(n,e));var i=e.caseSensitive?"gm":"gmi";e.$isMultiLine=!t&&/[\n\r]/.test(n);if(e.$isMultiLine)return e.re=this.$assembleMultilineRegExp(n,i);try{var s=new RegExp(n,i)}catch(o){s=!1}return e.re=s},this.$assembleMultilineRegExp=function(e,t){var n=e.replace(/\r\n|\r|\n/g,"$\n^").split("\n"),r=[];for(var i=0;i<n.length;i++)try{r.push(new RegExp(n[i],t))}catch(s){return!1}return n[0]==""?(r.shift(),r.offset=1):r.offset=0,r},this.$lineIterator=function(e,t){var n=t.backwards==1,r=t.skipCurrent!=0,i=t.range,s=t.start;s||(s=i?i[n?"end":"start"]:e.selection.getRange()),s.start&&(s=s[r!=n?"end":"start"]);var o=i?i.start.row:0,u=i?i.end.row:e.getLength()-1,a=n?function(n){var r=s.row,i=e.getLine(r).substring(0,s.column);if(n(i,r))return;for(r--;r>=o;r--)if(n(e.getLine(r),r))return;if(t.wrap==0)return;for(r=u,o=s.row;r>=o;r--)if(n(e.getLine(r),r))return}:function(n){var r=s.row,i=e.getLine(r).substr(s.column);if(n(i,r,s.column))return;for(r+=1;r<=u;r++)if(n(e.getLine(r),r))return;if(t.wrap==0)return;for(r=o,u=s.row;r<=u;r++)if(n(e.getLine(r),r))return};return{forEach:a}}}).call(o.prototype),t.Search=o}),ace.define("ace/keyboard/hash_handler",["require","exports","module","ace/lib/keys","ace/lib/useragent"],function(e,t,n){"use strict";function o(e,t){this.platform=t||(i.isMac?"mac":"win"),this.commands={},this.commandKeyBinding={},this.addCommands(e),this.$singleCommand=!0}function u(e,t){o.call(this,e,t),this.$singleCommand=!1}var r=e("../lib/keys"),i=e("../lib/useragent"),s=r.KEY_MODS;u.prototype=o.prototype,function(){function e(e){return typeof e=="object"&&e.bindKey&&e.bindKey.position||0}this.addCommand=function(e){this.commands[e.name]&&this.removeCommand(e),this.commands[e.name]=e,e.bindKey&&this._buildKeyHash(e)},this.removeCommand=function(e,t){var n=e&&(typeof e=="string"?e:e.name);e=this.commands[n],t||delete this.commands[n];var r=this.commandKeyBinding;for(var i in r){var s=r[i];if(s==e)delete r[i];else if(Array.isArray(s)){var o=s.indexOf(e);o!=-1&&(s.splice(o,1),s.length==1&&(r[i]=s[0]))}}},this.bindKey=function(e,t,n){typeof e=="object"&&e&&(n==undefined&&(n=e.position),e=e[this.platform]);if(!e)return;if(typeof t=="function")return this.addCommand({exec:t,bindKey:e,name:t.name||e});e.split("|").forEach(function(e){var r="";if(e.indexOf(" ")!=-1){var i=e.split(/\s+/);e=i.pop(),i.forEach(function(e){var t=this.parseKeys(e),n=s[t.hashId]+t.key;r+=(r?" ":"")+n,this._addCommandToBinding(r,"chainKeys")},this),r+=" "}var o=this.parseKeys(e),u=s[o.hashId]+o.key;this._addCommandToBinding(r+u,t,n)},this)},this._addCommandToBinding=function(t,n,r){var i=this.commandKeyBinding,s;if(!n)delete i[t];else if(!i[t]||this.$singleCommand)i[t]=n;else{Array.isArray(i[t])?(s=i[t].indexOf(n))!=-1&&i[t].splice(s,1):i[t]=[i[t]],typeof r!="number"&&(r||n.isDefault?r=-100:r=e(n));var o=i[t];for(s=0;s<o.length;s++){var u=o[s],a=e(u);if(a>r)break}o.splice(s,0,n)}},this.addCommands=function(e){e&&Object.keys(e).forEach(function(t){var n=e[t];if(!n)return;if(typeof n=="string")return this.bindKey(n,t);typeof n=="function"&&(n={exec:n});if(typeof n!="object")return;n.name||(n.name=t),this.addCommand(n)},this)},this.removeCommands=function(e){Object.keys(e).forEach(function(t){this.removeCommand(e[t])},this)},this.bindKeys=function(e){Object.keys(e).forEach(function(t){this.bindKey(t,e[t])},this)},this._buildKeyHash=function(e){this.bindKey(e.bindKey,e)},this.parseKeys=function(e){var t=e.toLowerCase().split(/[\-\+]([\-\+])?/).filter(function(e){return e}),n=t.pop(),i=r[n];if(r.FUNCTION_KEYS[i])n=r.FUNCTION_KEYS[i].toLowerCase();else{if(!t.length)return{key:n,hashId:-1};if(t.length==1&&t[0]=="shift")return{key:n.toUpperCase(),hashId:-1}}var s=0;for(var o=t.length;o--;){var u=r.KEY_MODS[t[o]];if(u==null)return typeof console!="undefined"&&console.error("invalid modifier "+t[o]+" in "+e),!1;s|=u}return{key:n,hashId:s}},this.findKeyCommand=function(t,n){var r=s[t]+n;return this.commandKeyBinding[r]},this.handleKeyboard=function(e,t,n,r){if(r<0)return;var i=s[t]+n,o=this.commandKeyBinding[i];e.$keyChain&&(e.$keyChain+=" "+i,o=this.commandKeyBinding[e.$keyChain]||o);if(o)if(o=="chainKeys"||o[o.length-1]=="chainKeys")return e.$keyChain=e.$keyChain||i,{command:"null"};if(e.$keyChain)if(!!t&&t!=4||n.length!=1){if(t==-1||r>0)e.$keyChain=""}else e.$keyChain=e.$keyChain.slice(0,-i.length-1);return{command:o}},this.getStatusText=function(e,t){return t.$keyChain||""}}.call(o.prototype),t.HashHandler=o,t.MultiHashHandler=u}),ace.define("ace/commands/command_manager",["require","exports","module","ace/lib/oop","ace/keyboard/hash_handler","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("../keyboard/hash_handler").MultiHashHandler,s=e("../lib/event_emitter").EventEmitter,o=function(e,t){i.call(this,t,e),this.byName=this.commands,this.setDefaultHandler("exec",function(e){return e.command.exec(e.editor,e.args||{})})};r.inherits(o,i),function(){r.implement(this,s),this.exec=function(e,t,n){if(Array.isArray(e)){for(var r=e.length;r--;)if(this.exec(e[r],t,n))return!0;return!1}typeof e=="string"&&(e=this.commands[e]);if(!e)return!1;if(t&&t.$readOnly&&!e.readOnly)return!1;var i={editor:t,command:e,args:n};return i.returnValue=this._emit("exec",i),this._signal("afterExec",i),i.returnValue===!1?!1:!0},this.toggleRecording=function(e){if(this.$inReplay)return;return e&&e._emit("changeStatus"),this.recording?(this.macro.pop(),this.removeEventListener("exec",this.$addCommandToMacro),this.macro.length||(this.macro=this.oldMacro),this.recording=!1):(this.$addCommandToMacro||(this.$addCommandToMacro=function(e){this.macro.push([e.command,e.args])}.bind(this)),this.oldMacro=this.macro,this.macro=[],this.on("exec",this.$addCommandToMacro),this.recording=!0)},this.replay=function(e){if(this.$inReplay||!this.macro)return;if(this.recording)return this.toggleRecording(e);try{this.$inReplay=!0,this.macro.forEach(function(t){typeof t=="string"?this.exec(t,e):this.exec(t[0],e,t[1])},this)}finally{this.$inReplay=!1}},this.trimMacro=function(e){return e.map(function(e){return typeof e[0]!="string"&&(e[0]=e[0].name),e[1]||(e=e[0]),e})}}.call(o.prototype),t.CommandManager=o}),ace.define("ace/commands/default_commands",["require","exports","module","ace/lib/lang","ace/config","ace/range"],function(e,t,n){"use strict";function o(e,t){return{win:e,mac:t}}var r=e("../lib/lang"),i=e("../config"),s=e("../range").Range;t.commands=[{name:"showSettingsMenu",bindKey:o("Ctrl-,","Command-,"),exec:function(e){i.loadModule("ace/ext/settings_menu",function(t){t.init(e),e.showSettingsMenu()})},readOnly:!0},{name:"goToNextError",bindKey:o("Alt-E","F4"),exec:function(e){i.loadModule("ace/ext/error_marker",function(t){t.showErrorMarker(e,1)})},scrollIntoView:"animate",readOnly:!0},{name:"goToPreviousError",bindKey:o("Alt-Shift-E","Shift-F4"),exec:function(e){i.loadModule("ace/ext/error_marker",function(t){t.showErrorMarker(e,-1)})},scrollIntoView:"animate",readOnly:!0},{name:"selectall",bindKey:o("Ctrl-A","Command-A"),exec:function(e){e.selectAll()},readOnly:!0},{name:"centerselection",bindKey:o(null,"Ctrl-L"),exec:function(e){e.centerSelection()},readOnly:!0},{name:"gotoline",bindKey:o("Ctrl-L","Command-L"),exec:function(e){var t=parseInt(prompt("Enter line number:"),10);isNaN(t)||e.gotoLine(t)},readOnly:!0},{name:"fold",bindKey:o("Alt-L|Ctrl-F1","Command-Alt-L|Command-F1"),exec:function(e){e.session.toggleFold(!1)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"unfold",bindKey:o("Alt-Shift-L|Ctrl-Shift-F1","Command-Alt-Shift-L|Command-Shift-F1"),exec:function(e){e.session.toggleFold(!0)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"toggleFoldWidget",bindKey:o("F2","F2"),exec:function(e){e.session.toggleFoldWidget()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"toggleParentFoldWidget",bindKey:o("Alt-F2","Alt-F2"),exec:function(e){e.session.toggleFoldWidget(!0)},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"foldall",bindKey:o(null,"Ctrl-Command-Option-0"),exec:function(e){e.session.foldAll()},scrollIntoView:"center",readOnly:!0},{name:"foldOther",bindKey:o("Alt-0","Command-Option-0"),exec:function(e){e.session.foldAll(),e.session.unfold(e.selection.getAllRanges())},scrollIntoView:"center",readOnly:!0},{name:"unfoldall",bindKey:o("Alt-Shift-0","Command-Option-Shift-0"),exec:function(e){e.session.unfold()},scrollIntoView:"center",readOnly:!0},{name:"findnext",bindKey:o("Ctrl-K","Command-G"),exec:function(e){e.findNext()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"findprevious",bindKey:o("Ctrl-Shift-K","Command-Shift-G"),exec:function(e){e.findPrevious()},multiSelectAction:"forEach",scrollIntoView:"center",readOnly:!0},{name:"selectOrFindNext",bindKey:o("Alt-K","Ctrl-G"),exec:function(e){e.selection.isEmpty()?e.selection.selectWord():e.findNext()},readOnly:!0},{name:"selectOrFindPrevious",bindKey:o("Alt-Shift-K","Ctrl-Shift-G"),exec:function(e){e.selection.isEmpty()?e.selection.selectWord():e.findPrevious()},readOnly:!0},{name:"find",bindKey:o("Ctrl-F","Command-F"),exec:function(e){i.loadModule("ace/ext/searchbox",function(t){t.Search(e)})},readOnly:!0},{name:"overwrite",bindKey:"Insert",exec:function(e){e.toggleOverwrite()},readOnly:!0},{name:"selecttostart",bindKey:o("Ctrl-Shift-Home","Command-Shift-Home|Command-Shift-Up"),exec:function(e){e.getSelection().selectFileStart()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"gotostart",bindKey:o("Ctrl-Home","Command-Home|Command-Up"),exec:function(e){e.navigateFileStart()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"selectup",bindKey:o("Shift-Up","Shift-Up|Ctrl-Shift-P"),exec:function(e){e.getSelection().selectUp()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"golineup",bindKey:o("Up","Up|Ctrl-P"),exec:function(e,t){e.navigateUp(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttoend",bindKey:o("Ctrl-Shift-End","Command-Shift-End|Command-Shift-Down"),exec:function(e){e.getSelection().selectFileEnd()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"gotoend",bindKey:o("Ctrl-End","Command-End|Command-Down"),exec:function(e){e.navigateFileEnd()},multiSelectAction:"forEach",readOnly:!0,scrollIntoView:"animate",aceCommandGroup:"fileJump"},{name:"selectdown",bindKey:o("Shift-Down","Shift-Down|Ctrl-Shift-N"),exec:function(e){e.getSelection().selectDown()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"golinedown",bindKey:o("Down","Down|Ctrl-N"),exec:function(e,t){e.navigateDown(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectwordleft",bindKey:o("Ctrl-Shift-Left","Option-Shift-Left"),exec:function(e){e.getSelection().selectWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotowordleft",bindKey:o("Ctrl-Left","Option-Left"),exec:function(e){e.navigateWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttolinestart",bindKey:o("Alt-Shift-Left","Command-Shift-Left|Ctrl-Shift-A"),exec:function(e){e.getSelection().selectLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotolinestart",bindKey:o("Alt-Left|Home","Command-Left|Home|Ctrl-A"),exec:function(e){e.navigateLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectleft",bindKey:o("Shift-Left","Shift-Left|Ctrl-Shift-B"),exec:function(e){e.getSelection().selectLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotoleft",bindKey:o("Left","Left|Ctrl-B"),exec:function(e,t){e.navigateLeft(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectwordright",bindKey:o("Ctrl-Shift-Right","Option-Shift-Right"),exec:function(e){e.getSelection().selectWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotowordright",bindKey:o("Ctrl-Right","Option-Right"),exec:function(e){e.navigateWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selecttolineend",bindKey:o("Alt-Shift-Right","Command-Shift-Right|Shift-End|Ctrl-Shift-E"),exec:function(e){e.getSelection().selectLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotolineend",bindKey:o("Alt-Right|End","Command-Right|End|Ctrl-E"),exec:function(e){e.navigateLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectright",bindKey:o("Shift-Right","Shift-Right"),exec:function(e){e.getSelection().selectRight()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"gotoright",bindKey:o("Right","Right|Ctrl-F"),exec:function(e,t){e.navigateRight(t.times)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectpagedown",bindKey:"Shift-PageDown",exec:function(e){e.selectPageDown()},readOnly:!0},{name:"pagedown",bindKey:o(null,"Option-PageDown"),exec:function(e){e.scrollPageDown()},readOnly:!0},{name:"gotopagedown",bindKey:o("PageDown","PageDown|Ctrl-V"),exec:function(e){e.gotoPageDown()},readOnly:!0},{name:"selectpageup",bindKey:"Shift-PageUp",exec:function(e){e.selectPageUp()},readOnly:!0},{name:"pageup",bindKey:o(null,"Option-PageUp"),exec:function(e){e.scrollPageUp()},readOnly:!0},{name:"gotopageup",bindKey:"PageUp",exec:function(e){e.gotoPageUp()},readOnly:!0},{name:"scrollup",bindKey:o("Ctrl-Up",null),exec:function(e){e.renderer.scrollBy(0,-2*e.renderer.layerConfig.lineHeight)},readOnly:!0},{name:"scrolldown",bindKey:o("Ctrl-Down",null),exec:function(e){e.renderer.scrollBy(0,2*e.renderer.layerConfig.lineHeight)},readOnly:!0},{name:"selectlinestart",bindKey:"Shift-Home",exec:function(e){e.getSelection().selectLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"selectlineend",bindKey:"Shift-End",exec:function(e){e.getSelection().selectLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"togglerecording",bindKey:o("Ctrl-Alt-E","Command-Option-E"),exec:function(e){e.commands.toggleRecording(e)},readOnly:!0},{name:"replaymacro",bindKey:o("Ctrl-Shift-E","Command-Shift-E"),exec:function(e){e.commands.replay(e)},readOnly:!0},{name:"jumptomatching",bindKey:o("Ctrl-P","Ctrl-P"),exec:function(e){e.jumpToMatching()},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"selecttomatching",bindKey:o("Ctrl-Shift-P","Ctrl-Shift-P"),exec:function(e){e.jumpToMatching(!0)},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"expandToMatching",bindKey:o("Ctrl-Shift-M","Ctrl-Shift-M"),exec:function(e){e.jumpToMatching(!0,!0)},multiSelectAction:"forEach",scrollIntoView:"animate",readOnly:!0},{name:"passKeysToBrowser",bindKey:o(null,null),exec:function(){},passEvent:!0,readOnly:!0},{name:"copy",exec:function(e){},readOnly:!0},{name:"cut",exec:function(e){var t=e.getSelectionRange();e._emit("cut",t),e.selection.isEmpty()||(e.session.remove(t),e.clearSelection())},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"paste",exec:function(e,t){e.$handlePaste(t)},scrollIntoView:"cursor"},{name:"removeline",bindKey:o("Ctrl-D","Command-D"),exec:function(e){e.removeLines()},scrollIntoView:"cursor",multiSelectAction:"forEachLine"},{name:"duplicateSelection",bindKey:o("Ctrl-Shift-D","Command-Shift-D"),exec:function(e){e.duplicateSelection()},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"sortlines",bindKey:o("Ctrl-Alt-S","Command-Alt-S"),exec:function(e){e.sortLines()},scrollIntoView:"selection",multiSelectAction:"forEachLine"},{name:"togglecomment",bindKey:o("Ctrl-/","Command-/"),exec:function(e){e.toggleCommentLines()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"toggleBlockComment",bindKey:o("Ctrl-Shift-/","Command-Shift-/"),exec:function(e){e.toggleBlockComment()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"modifyNumberUp",bindKey:o("Ctrl-Shift-Up","Alt-Shift-Up"),exec:function(e){e.modifyNumber(1)},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"modifyNumberDown",bindKey:o("Ctrl-Shift-Down","Alt-Shift-Down"),exec:function(e){e.modifyNumber(-1)},scrollIntoView:"cursor",multiSelectAction:"forEach"},{name:"replace",bindKey:o("Ctrl-H","Command-Option-F"),exec:function(e){i.loadModule("ace/ext/searchbox",function(t){t.Search(e,!0)})}},{name:"undo",bindKey:o("Ctrl-Z","Command-Z"),exec:function(e){e.undo()}},{name:"redo",bindKey:o("Ctrl-Shift-Z|Ctrl-Y","Command-Shift-Z|Command-Y"),exec:function(e){e.redo()}},{name:"copylinesup",bindKey:o("Alt-Shift-Up","Command-Option-Up"),exec:function(e){e.copyLinesUp()},scrollIntoView:"cursor"},{name:"movelinesup",bindKey:o("Alt-Up","Option-Up"),exec:function(e){e.moveLinesUp()},scrollIntoView:"cursor"},{name:"copylinesdown",bindKey:o("Alt-Shift-Down","Command-Option-Down"),exec:function(e){e.copyLinesDown()},scrollIntoView:"cursor"},{name:"movelinesdown",bindKey:o("Alt-Down","Option-Down"),exec:function(e){e.moveLinesDown()},scrollIntoView:"cursor"},{name:"del",bindKey:o("Delete","Delete|Ctrl-D|Shift-Delete"),exec:function(e){e.remove("right")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"backspace",bindKey:o("Shift-Backspace|Backspace","Ctrl-Backspace|Shift-Backspace|Backspace|Ctrl-H"),exec:function(e){e.remove("left")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"cut_or_delete",bindKey:o("Shift-Delete",null),exec:function(e){if(!e.selection.isEmpty())return!1;e.remove("left")},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolinestart",bindKey:o("Alt-Backspace","Command-Backspace"),exec:function(e){e.removeToLineStart()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removetolineend",bindKey:o("Alt-Delete","Ctrl-K"),exec:function(e){e.removeToLineEnd()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removewordleft",bindKey:o("Ctrl-Backspace","Alt-Backspace|Ctrl-Alt-Backspace"),exec:function(e){e.removeWordLeft()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"removewordright",bindKey:o("Ctrl-Delete","Alt-Delete"),exec:function(e){e.removeWordRight()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"outdent",bindKey:o("Shift-Tab","Shift-Tab"),exec:function(e){e.blockOutdent()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"indent",bindKey:o("Tab","Tab"),exec:function(e){e.indent()},multiSelectAction:"forEach",scrollIntoView:"selectionPart"},{name:"blockoutdent",bindKey:o("Ctrl-[","Ctrl-["),exec:function(e){e.blockOutdent()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"blockindent",bindKey:o("Ctrl-]","Ctrl-]"),exec:function(e){e.blockIndent()},multiSelectAction:"forEachLine",scrollIntoView:"selectionPart"},{name:"insertstring",exec:function(e,t){e.insert(t)},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"inserttext",exec:function(e,t){e.insert(r.stringRepeat(t.text||"",t.times||1))},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"splitline",bindKey:o(null,"Ctrl-O"),exec:function(e){e.splitLine()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"transposeletters",bindKey:o("Ctrl-T","Ctrl-T"),exec:function(e){e.transposeLetters()},multiSelectAction:function(e){e.transposeSelections(1)},scrollIntoView:"cursor"},{name:"touppercase",bindKey:o("Ctrl-U","Ctrl-U"),exec:function(e){e.toUpperCase()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"tolowercase",bindKey:o("Ctrl-Shift-U","Ctrl-Shift-U"),exec:function(e){e.toLowerCase()},multiSelectAction:"forEach",scrollIntoView:"cursor"},{name:"expandtoline",bindKey:o("Ctrl-Shift-L","Command-Shift-L"),exec:function(e){var t=e.selection.getRange();t.start.column=t.end.column=0,t.end.row++,e.selection.setRange(t,!1)},multiSelectAction:"forEach",scrollIntoView:"cursor",readOnly:!0},{name:"joinlines",bindKey:o(null,null),exec:function(e){var t=e.selection.isBackwards(),n=t?e.selection.getSelectionLead():e.selection.getSelectionAnchor(),i=t?e.selection.getSelectionAnchor():e.selection.getSelectionLead(),o=e.session.doc.getLine(n.row).length,u=e.session.doc.getTextRange(e.selection.getRange()),a=u.replace(/\n\s*/," ").length,f=e.session.doc.getLine(n.row);for(var l=n.row+1;l<=i.row+1;l++){var c=r.stringTrimLeft(r.stringTrimRight(e.session.doc.getLine(l)));c.length!==0&&(c=" "+c),f+=c}i.row+1<e.session.doc.getLength()-1&&(f+=e.session.doc.getNewLineCharacter()),e.clearSelection(),e.session.doc.replace(new s(n.row,0,i.row+2,0),f),a>0?(e.selection.moveCursorTo(n.row,n.column),e.selection.selectTo(n.row,n.column+a)):(o=e.session.doc.getLine(n.row).length>o?o+1:o,e.selection.moveCursorTo(n.row,o))},multiSelectAction:"forEach",readOnly:!0},{name:"invertSelection",bindKey:o(null,null),exec:function(e){var t=e.session.doc.getLength()-1,n=e.session.doc.getLine(t).length,r=e.selection.rangeList.ranges,i=[];r.length<1&&(r=[e.selection.getRange()]);for(var o=0;o<r.length;o++)o==r.length-1&&(r[o].end.row!==t||r[o].end.column!==n)&&i.push(new s(r[o].end.row,r[o].end.column,t,n)),o===0?(r[o].start.row!==0||r[o].start.column!==0)&&i.push(new s(0,0,r[o].start.row,r[o].start.column)):i.push(new s(r[o-1].end.row,r[o-1].end.column,r[o].start.row,r[o].start.column));e.exitMultiSelectMode(),e.clearSelection();for(var o=0;o<i.length;o++)e.selection.addRange(i[o],!1)},readOnly:!0,scrollIntoView:"none"}]}),ace.define("ace/editor",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/keyboard/textinput","ace/mouse/mouse_handler","ace/mouse/fold_handler","ace/keyboard/keybinding","ace/edit_session","ace/search","ace/range","ace/lib/event_emitter","ace/commands/command_manager","ace/commands/default_commands","ace/config","ace/token_iterator"],function(e,t,n){"use strict";e("./lib/fixoldbrowsers");var r=e("./lib/oop"),i=e("./lib/dom"),s=e("./lib/lang"),o=e("./lib/useragent"),u=e("./keyboard/textinput").TextInput,a=e("./mouse/mouse_handler").MouseHandler,f=e("./mouse/fold_handler").FoldHandler,l=e("./keyboard/keybinding").KeyBinding,c=e("./edit_session").EditSession,h=e("./search").Search,p=e("./range").Range,d=e("./lib/event_emitter").EventEmitter,v=e("./commands/command_manager").CommandManager,m=e("./commands/default_commands").commands,g=e("./config"),y=e("./token_iterator").TokenIterator,b=function(e,t){var n=e.getContainerElement();this.container=n,this.renderer=e,this.commands=new v(o.isMac?"mac":"win",m),this.textInput=new u(e.getTextAreaContainer(),this),this.renderer.textarea=this.textInput.getElement(),this.keyBinding=new l(this),this.$mouseHandler=new a(this),new f(this),this.$blockScrolling=0,this.$search=(new h).set({wrap:!0}),this.$historyTracker=this.$historyTracker.bind(this),this.commands.on("exec",this.$historyTracker),this.$initOperationListeners(),this._$emitInputEvent=s.delayedCall(function(){this._signal("input",{}),this.session&&this.session.bgTokenizer&&this.session.bgTokenizer.scheduleStart()}.bind(this)),this.on("change",function(e,t){t._$emitInputEvent.schedule(31)}),this.setSession(t||new c("")),g.resetOptions(this),g._signal("editor",this)};(function(){r.implement(this,d),this.$initOperationListeners=function(){function e(e){return e[e.length-1]}this.selections=[],this.commands.on("exec",this.startOperation.bind(this),!0),this.commands.on("afterExec",this.endOperation.bind(this),!0),this.$opResetTimer=s.delayedCall(this.endOperation.bind(this)),this.on("change",function(){this.curOp||this.startOperation(),this.curOp.docChanged=!0}.bind(this),!0),this.on("changeSelection",function(){this.curOp||this.startOperation(),this.curOp.selectionChanged=!0}.bind(this),!0)},this.curOp=null,this.prevOp={},this.startOperation=function(e){if(this.curOp){if(!e||this.curOp.command)return;this.prevOp=this.curOp}e||(this.previousCommand=null,e={}),this.$opResetTimer.schedule(),this.curOp={command:e.command||{},args:e.args,scrollTop:this.renderer.scrollTop},this.curOp.command.name&&this.curOp.command.scrollIntoView!==undefined&&this.$blockScrolling++},this.endOperation=function(e){if(this.curOp){if(e&&e.returnValue===!1)return this.curOp=null;this._signal("beforeEndOperation");var t=this.curOp.command;t.name&&this.$blockScrolling>0&&this.$blockScrolling--;var n=t&&t.scrollIntoView;if(n){switch(n){case"center-animate":n="animate";case"center":this.renderer.scrollCursorIntoView(null,.5);break;case"animate":case"cursor":this.renderer.scrollCursorIntoView();break;case"selectionPart":var r=this.selection.getRange(),i=this.renderer.layerConfig;(r.start.row>=i.lastRow||r.end.row<=i.firstRow)&&this.renderer.scrollSelectionIntoView(this.selection.anchor,this.selection.lead);break;default:}n=="animate"&&this.renderer.animateScrolling(this.curOp.scrollTop)}this.prevOp=this.curOp,this.curOp=null}},this.$mergeableCommands=["backspace","del","insertstring"],this.$historyTracker=function(e){if(!this.$mergeUndoDeltas)return;var t=this.prevOp,n=this.$mergeableCommands,r=t.command&&e.command.name==t.command.name;if(e.command.name=="insertstring"){var i=e.args;this.mergeNextCommand===undefined&&(this.mergeNextCommand=!0),r=r&&this.mergeNextCommand&&(!/\s/.test(i)||/\s/.test(t.args)),this.mergeNextCommand=!0}else r=r&&n.indexOf(e.command.name)!==-1;this.$mergeUndoDeltas!="always"&&Date.now()-this.sequenceStartTime>2e3&&(r=!1),r?this.session.mergeUndoDeltas=!0:n.indexOf(e.command.name)!==-1&&(this.sequenceStartTime=Date.now())},this.setKeyboardHandler=function(e,t){if(e&&typeof e=="string"){this.$keybindingId=e;var n=this;g.loadModule(["keybinding",e],function(r){n.$keybindingId==e&&n.keyBinding.setKeyboardHandler(r&&r.handler),t&&t()})}else this.$keybindingId=null,this.keyBinding.setKeyboardHandler(e),t&&t()},this.getKeyboardHandler=function(){return this.keyBinding.getKeyboardHandler()},this.setSession=function(e){if(this.session==e)return;this.curOp&&this.endOperation(),this.curOp={};var t=this.session;if(t){this.session.off("change",this.$onDocumentChange),this.session.off("changeMode",this.$onChangeMode),this.session.off("tokenizerUpdate",this.$onTokenizerUpdate),this.session.off("changeTabSize",this.$onChangeTabSize),this.session.off("changeWrapLimit",this.$onChangeWrapLimit),this.session.off("changeWrapMode",this.$onChangeWrapMode),this.session.off("changeFold",this.$onChangeFold),this.session.off("changeFrontMarker",this.$onChangeFrontMarker),this.session.off("changeBackMarker",this.$onChangeBackMarker),this.session.off("changeBreakpoint",this.$onChangeBreakpoint),this.session.off("changeAnnotation",this.$onChangeAnnotation),this.session.off("changeOverwrite",this.$onCursorChange),this.session.off("changeScrollTop",this.$onScrollTopChange),this.session.off("changeScrollLeft",this.$onScrollLeftChange);var n=this.session.getSelection();n.off("changeCursor",this.$onCursorChange),n.off("changeSelection",this.$onSelectionChange)}this.session=e,e?(this.$onDocumentChange=this.onDocumentChange.bind(this),e.on("change",this.$onDocumentChange),this.renderer.setSession(e),this.$onChangeMode=this.onChangeMode.bind(this),e.on("changeMode",this.$onChangeMode),this.$onTokenizerUpdate=this.onTokenizerUpdate.bind(this),e.on("tokenizerUpdate",this.$onTokenizerUpdate),this.$onChangeTabSize=this.renderer.onChangeTabSize.bind(this.renderer),e.on("changeTabSize",this.$onChangeTabSize),this.$onChangeWrapLimit=this.onChangeWrapLimit.bind(this),e.on("changeWrapLimit",this.$onChangeWrapLimit),this.$onChangeWrapMode=this.onChangeWrapMode.bind(this),e.on("changeWrapMode",this.$onChangeWrapMode),this.$onChangeFold=this.onChangeFold.bind(this),e.on("changeFold",this.$onChangeFold),this.$onChangeFrontMarker=this.onChangeFrontMarker.bind(this),this.session.on("changeFrontMarker",this.$onChangeFrontMarker),this.$onChangeBackMarker=this.onChangeBackMarker.bind(this),this.session.on("changeBackMarker",this.$onChangeBackMarker),this.$onChangeBreakpoint=this.onChangeBreakpoint.bind(this),this.session.on("changeBreakpoint",this.$onChangeBreakpoint),this.$onChangeAnnotation=this.onChangeAnnotation.bind(this),this.session.on("changeAnnotation",this.$onChangeAnnotation),this.$onCursorChange=this.onCursorChange.bind(this),this.session.on("changeOverwrite",this.$onCursorChange),this.$onScrollTopChange=this.onScrollTopChange.bind(this),this.session.on("changeScrollTop",this.$onScrollTopChange),this.$onScrollLeftChange=this.onScrollLeftChange.bind(this),this.session.on("changeScrollLeft",this.$onScrollLeftChange),this.selection=e.getSelection(),this.selection.on("changeCursor",this.$onCursorChange),this.$onSelectionChange=this.onSelectionChange.bind(this),this.selection.on("changeSelection",this.$onSelectionChange),this.onChangeMode(),this.$blockScrolling+=1,this.onCursorChange(),this.$blockScrolling-=1,this.onScrollTopChange(),this.onScrollLeftChange(),this.onSelectionChange(),this.onChangeFrontMarker(),this.onChangeBackMarker(),this.onChangeBreakpoint(),this.onChangeAnnotation(),this.session.getUseWrapMode()&&this.renderer.adjustWrapLimit(),this.renderer.updateFull()):(this.selection=null,this.renderer.setSession(e)),this._signal("changeSession",{session:e,oldSession:t}),this.curOp=null,t&&t._signal("changeEditor",{oldEditor:this}),e&&e._signal("changeEditor",{editor:this})},this.getSession=function(){return this.session},this.setValue=function(e,t){return this.session.doc.setValue(e),t?t==1?this.navigateFileEnd():t==-1&&this.navigateFileStart():this.selectAll(),e},this.getValue=function(){return this.session.getValue()},this.getSelection=function(){return this.selection},this.resize=function(e){this.renderer.onResize(e)},this.setTheme=function(e,t){this.renderer.setTheme(e,t)},this.getTheme=function(){return this.renderer.getTheme()},this.setStyle=function(e){this.renderer.setStyle(e)},this.unsetStyle=function(e){this.renderer.unsetStyle(e)},this.getFontSize=function(){return this.getOption("fontSize")||i.computedStyle(this.container,"fontSize")},this.setFontSize=function(e){this.setOption("fontSize",e)},this.$highlightBrackets=function(){this.session.$bracketHighlight&&(this.session.removeMarker(this.session.$bracketHighlight),this.session.$bracketHighlight=null);if(this.$highlightPending)return;var e=this;this.$highlightPending=!0,setTimeout(function(){e.$highlightPending=!1;var t=e.session;if(!t||!t.bgTokenizer)return;var n=t.findMatchingBracket(e.getCursorPosition());if(n)var r=new p(n.row,n.column,n.row,n.column+1);else if(t.$mode.getMatching)var r=t.$mode.getMatching(e.session);r&&(t.$bracketHighlight=t.addMarker(r,"ace_bracket","text"))},50)},this.$highlightTags=function(){if(this.$highlightTagPending)return;var e=this;this.$highlightTagPending=!0,setTimeout(function(){e.$highlightTagPending=!1;var t=e.session;if(!t||!t.bgTokenizer)return;var n=e.getCursorPosition(),r=new y(e.session,n.row,n.column),i=r.getCurrentToken();if(!i||!/\b(?:tag-open|tag-name)/.test(i.type)){t.removeMarker(t.$tagHighlight),t.$tagHighlight=null;return}if(i.type.indexOf("tag-open")!=-1){i=r.stepForward();if(!i)return}var s=i.value,o=0,u=r.stepBackward();if(u.value=="<"){do u=i,i=r.stepForward(),i&&i.value===s&&i.type.indexOf("tag-name")!==-1&&(u.value==="<"?o++:u.value==="</"&&o--);while(i&&o>=0)}else{do i=u,u=r.stepBackward(),i&&i.value===s&&i.type.indexOf("tag-name")!==-1&&(u.value==="<"?o++:u.value==="</"&&o--);while(u&&o<=0);r.stepForward()}if(!i){t.removeMarker(t.$tagHighlight),t.$tagHighlight=null;return}var a=r.getCurrentTokenRow(),f=r.getCurrentTokenColumn(),l=new p(a,f,a,f+i.value.length),c=t.$backMarkers[t.$tagHighlight];t.$tagHighlight&&c!=undefined&&l.compareRange(c.range)!==0&&(t.removeMarker(t.$tagHighlight),t.$tagHighlight=null),l&&!t.$tagHighlight&&(t.$tagHighlight=t.addMarker(l,"ace_bracket","text"))},50)},this.focus=function(){var e=this;setTimeout(function(){e.textInput.focus()}),this.textInput.focus()},this.isFocused=function(){return this.textInput.isFocused()},this.blur=function(){this.textInput.blur()},this.onFocus=function(e){if(this.$isFocused)return;this.$isFocused=!0,this.renderer.showCursor(),this.renderer.visualizeFocus(),this._emit("focus",e)},this.onBlur=function(e){if(!this.$isFocused)return;this.$isFocused=!1,this.renderer.hideCursor(),this.renderer.visualizeBlur(),this._emit("blur",e)},this.$cursorChange=function(){this.renderer.updateCursor()},this.onDocumentChange=function(e){var t=this.session.$useWrapMode,n=e.start.row==e.end.row?e.end.row:Infinity;this.renderer.updateLines(e.start.row,n,t),this._signal("change",e),this.$cursorChange(),this.$updateHighlightActiveLine()},this.onTokenizerUpdate=function(e){var t=e.data;this.renderer.updateLines(t.first,t.last)},this.onScrollTopChange=function(){this.renderer.scrollToY(this.session.getScrollTop())},this.onScrollLeftChange=function(){this.renderer.scrollToX(this.session.getScrollLeft())},this.onCursorChange=function(){this.$cursorChange(),this.$blockScrolling||(g.warn("Automatically scrolling cursor into view after selection change","this will be disabled in the next version","set editor.$blockScrolling = Infinity to disable this message"),this.renderer.scrollCursorIntoView()),this.$highlightBrackets(),this.$highlightTags(),this.$updateHighlightActiveLine(),this._signal("changeSelection")},this.$updateHighlightActiveLine=function(){var e=this.getSession(),t;if(this.$highlightActiveLine){if(this.$selectionStyle!="line"||!this.selection.isMultiLine())t=this.getCursorPosition();this.renderer.$maxLines&&this.session.getLength()===1&&!(this.renderer.$minLines>1)&&(t=!1)}if(e.$highlightLineMarker&&!t)e.removeMarker(e.$highlightLineMarker.id),e.$highlightLineMarker=null;else if(!e.$highlightLineMarker&&t){var n=new p(t.row,t.column,t.row,Infinity);n.id=e.addMarker(n,"ace_active-line","screenLine"),e.$highlightLineMarker=n}else t&&(e.$highlightLineMarker.start.row=t.row,e.$highlightLineMarker.end.row=t.row,e.$highlightLineMarker.start.column=t.column,e._signal("changeBackMarker"))},this.onSelectionChange=function(e){var t=this.session;t.$selectionMarker&&t.removeMarker(t.$selectionMarker),t.$selectionMarker=null;if(!this.selection.isEmpty()){var n=this.selection.getRange(),r=this.getSelectionStyle();t.$selectionMarker=t.addMarker(n,"ace_selection",r)}else this.$updateHighlightActiveLine();var i=this.$highlightSelectedWord&&this.$getSelectionHighLightRegexp();this.session.highlight(i),this._signal("changeSelection")},this.$getSelectionHighLightRegexp=function(){var e=this.session,t=this.getSelectionRange();if(t.isEmpty()||t.isMultiLine())return;var n=t.start.column-1,r=t.end.column+1,i=e.getLine(t.start.row),s=i.length,o=i.substring(Math.max(n,0),Math.min(r,s));if(n>=0&&/^[\w\d]/.test(o)||r<=s&&/[\w\d]$/.test(o))return;o=i.substring(t.start.column,t.end.column);if(!/^[\w\d]+$/.test(o))return;var u=this.$search.$assembleRegExp({wholeWord:!0,caseSensitive:!0,needle:o});return u},this.onChangeFrontMarker=function(){this.renderer.updateFrontMarkers()},this.onChangeBackMarker=function(){this.renderer.updateBackMarkers()},this.onChangeBreakpoint=function(){this.renderer.updateBreakpoints()},this.onChangeAnnotation=function(){this.renderer.setAnnotations(this.session.getAnnotations())},this.onChangeMode=function(e){this.renderer.updateText(),this._emit("changeMode",e)},this.onChangeWrapLimit=function(){this.renderer.updateFull()},this.onChangeWrapMode=function(){this.renderer.onResize(!0)},this.onChangeFold=function(){this.$updateHighlightActiveLine(),this.renderer.updateFull()},this.getSelectedText=function(){return this.session.getTextRange(this.getSelectionRange())},this.getCopyText=function(){var e=this.getSelectedText();return this._signal("copy",e),e},this.onCopy=function(){this.commands.exec("copy",this)},this.onCut=function(){this.commands.exec("cut",this)},this.onPaste=function(e,t){var n={text:e,event:t};this.commands.exec("paste",this,n)},this.$handlePaste=function(e){typeof e=="string"&&(e={text:e}),this._signal("paste",e);var t=e.text;if(!this.inMultiSelectMode||this.inVirtualSelectionMode)this.insert(t);else{var n=t.split(/\r\n|\r|\n/),r=this.selection.rangeList.ranges;if(n.length>r.length||n.length<2||!n[1])return this.commands.exec("insertstring",this,t);for(var i=r.length;i--;){var s=r[i];s.isEmpty()||this.session.remove(s),this.session.insert(s.start,n[i])}}},this.execCommand=function(e,t){return this.commands.exec(e,this,t)},this.insert=function(e,t){var n=this.session,r=n.getMode(),i=this.getCursorPosition();if(this.getBehavioursEnabled()&&!t){var s=r.transformAction(n.getState(i.row),"insertion",this,n,e);s&&(e!==s.text&&(this.session.mergeUndoDeltas=!1,this.$mergeNextCommand=!1),e=s.text)}e=="	"&&(e=this.session.getTabString());if(!this.selection.isEmpty()){var o=this.getSelectionRange();i=this.session.remove(o),this.clearSelection()}else if(this.session.getOverwrite()){var o=new p.fromPoints(i,i);o.end.column+=e.length,this.session.remove(o)}if(e=="\n"||e=="\r\n"){var u=n.getLine(i.row);if(i.column>u.search(/\S|$/)){var a=u.substr(i.column).search(/\S|$/);n.doc.removeInLine(i.row,i.column,i.column+a)}}this.clearSelection();var f=i.column,l=n.getState(i.row),u=n.getLine(i.row),c=r.checkOutdent(l,u,e),h=n.insert(i,e);s&&s.selection&&(s.selection.length==2?this.selection.setSelectionRange(new p(i.row,f+s.selection[0],i.row,f+s.selection[1])):this.selection.setSelectionRange(new p(i.row+s.selection[0],s.selection[1],i.row+s.selection[2],s.selection[3])));if(n.getDocument().isNewLine(e)){var d=r.getNextLineIndent(l,u.slice(0,i.column),n.getTabString());n.insert({row:i.row+1,column:0},d)}c&&r.autoOutdent(l,n,i.row)},this.onTextInput=function(e){this.keyBinding.onTextInput(e)},this.onCommandKey=function(e,t,n){this.keyBinding.onCommandKey(e,t,n)},this.setOverwrite=function(e){this.session.setOverwrite(e)},this.getOverwrite=function(){return this.session.getOverwrite()},this.toggleOverwrite=function(){this.session.toggleOverwrite()},this.setScrollSpeed=function(e){this.setOption("scrollSpeed",e)},this.getScrollSpeed=function(){return this.getOption("scrollSpeed")},this.setDragDelay=function(e){this.setOption("dragDelay",e)},this.getDragDelay=function(){return this.getOption("dragDelay")},this.setSelectionStyle=function(e){this.setOption("selectionStyle",e)},this.getSelectionStyle=function(){return this.getOption("selectionStyle")},this.setHighlightActiveLine=function(e){this.setOption("highlightActiveLine",e)},this.getHighlightActiveLine=function(){return this.getOption("highlightActiveLine")},this.setHighlightGutterLine=function(e){this.setOption("highlightGutterLine",e)},this.getHighlightGutterLine=function(){return this.getOption("highlightGutterLine")},this.setHighlightSelectedWord=function(e){this.setOption("highlightSelectedWord",e)},this.getHighlightSelectedWord=function(){return this.$highlightSelectedWord},this.setAnimatedScroll=function(e){this.renderer.setAnimatedScroll(e)},this.getAnimatedScroll=function(){return this.renderer.getAnimatedScroll()},this.setShowInvisibles=function(e){this.renderer.setShowInvisibles(e)},this.getShowInvisibles=function(){return this.renderer.getShowInvisibles()},this.setDisplayIndentGuides=function(e){this.renderer.setDisplayIndentGuides(e)},this.getDisplayIndentGuides=function(){return this.renderer.getDisplayIndentGuides()},this.setShowPrintMargin=function(e){this.renderer.setShowPrintMargin(e)},this.getShowPrintMargin=function(){return this.renderer.getShowPrintMargin()},this.setPrintMarginColumn=function(e){this.renderer.setPrintMarginColumn(e)},this.getPrintMarginColumn=function(){return this.renderer.getPrintMarginColumn()},this.setReadOnly=function(e){this.setOption("readOnly",e)},this.getReadOnly=function(){return this.getOption("readOnly")},this.setBehavioursEnabled=function(e){this.setOption("behavioursEnabled",e)},this.getBehavioursEnabled=function(){return this.getOption("behavioursEnabled")},this.setWrapBehavioursEnabled=function(e){this.setOption("wrapBehavioursEnabled",e)},this.getWrapBehavioursEnabled=function(){return this.getOption("wrapBehavioursEnabled")},this.setShowFoldWidgets=function(e){this.setOption("showFoldWidgets",e)},this.getShowFoldWidgets=function(){return this.getOption("showFoldWidgets")},this.setFadeFoldWidgets=function(e){this.setOption("fadeFoldWidgets",e)},this.getFadeFoldWidgets=function(){return this.getOption("fadeFoldWidgets")},this.remove=function(e){this.selection.isEmpty()&&(e=="left"?this.selection.selectLeft():this.selection.selectRight());var t=this.getSelectionRange();if(this.getBehavioursEnabled()){var n=this.session,r=n.getState(t.start.row),i=n.getMode().transformAction(r,"deletion",this,n,t);if(t.end.column===0){var s=n.getTextRange(t);if(s[s.length-1]=="\n"){var o=n.getLine(t.end.row);/^\s+$/.test(o)&&(t.end.column=o.length)}}i&&(t=i)}this.session.remove(t),this.clearSelection()},this.removeWordRight=function(){this.selection.isEmpty()&&this.selection.selectWordRight(),this.session.remove(this.getSelectionRange()),this.clearSelection()},this.removeWordLeft=function(){this.selection.isEmpty()&&this.selection.selectWordLeft(),this.session.remove(this.getSelectionRange()),this.clearSelection()},this.removeToLineStart=function(){this.selection.isEmpty()&&this.selection.selectLineStart(),this.session.remove(this.getSelectionRange()),this.clearSelection()},this.removeToLineEnd=function(){this.selection.isEmpty()&&this.selection.selectLineEnd();var e=this.getSelectionRange();e.start.column==e.end.column&&e.start.row==e.end.row&&(e.end.column=0,e.end.row++),this.session.remove(e),this.clearSelection()},this.splitLine=function(){this.selection.isEmpty()||(this.session.remove(this.getSelectionRange()),this.clearSelection());var e=this.getCursorPosition();this.insert("\n"),this.moveCursorToPosition(e)},this.transposeLetters=function(){if(!this.selection.isEmpty())return;var e=this.getCursorPosition(),t=e.column;if(t===0)return;var n=this.session.getLine(e.row),r,i;t<n.length?(r=n.charAt(t)+n.charAt(t-1),i=new p(e.row,t-1,e.row,t+1)):(r=n.charAt(t-1)+n.charAt(t-2),i=new p(e.row,t-2,e.row,t)),this.session.replace(i,r)},this.toLowerCase=function(){var e=this.getSelectionRange();this.selection.isEmpty()&&this.selection.selectWord();var t=this.getSelectionRange(),n=this.session.getTextRange(t);this.session.replace(t,n.toLowerCase()),this.selection.setSelectionRange(e)},this.toUpperCase=function(){var e=this.getSelectionRange();this.selection.isEmpty()&&this.selection.selectWord();var t=this.getSelectionRange(),n=this.session.getTextRange(t);this.session.replace(t,n.toUpperCase()),this.selection.setSelectionRange(e)},this.indent=function(){var e=this.session,t=this.getSelectionRange();if(t.start.row<t.end.row){var n=this.$getSelectedRows();e.indentRows(n.first,n.last,"	");return}if(t.start.column<t.end.column){var r=e.getTextRange(t);if(!/^\s+$/.test(r)){var n=this.$getSelectedRows();e.indentRows(n.first,n.last,"	");return}}var i=e.getLine(t.start.row),o=t.start,u=e.getTabSize(),a=e.documentToScreenColumn(o.row,o.column);if(this.session.getUseSoftTabs())var f=u-a%u,l=s.stringRepeat(" ",f);else{var f=a%u;while(i[t.start.column-1]==" "&&f)t.start.column--,f--;this.selection.setSelectionRange(t),l="	"}return this.insert(l)},this.blockIndent=function(){var e=this.$getSelectedRows();this.session.indentRows(e.first,e.last,"	")},this.blockOutdent=function(){var e=this.session.getSelection();this.session.outdentRows(e.getRange())},this.sortLines=function(){var e=this.$getSelectedRows(),t=this.session,n=[];for(i=e.first;i<=e.last;i++)n.push(t.getLine(i));n.sort(function(e,t){return e.toLowerCase()<t.toLowerCase()?-1:e.toLowerCase()>t.toLowerCase()?1:0});var r=new p(0,0,0,0);for(var i=e.first;i<=e.last;i++){var s=t.getLine(i);r.start.row=i,r.end.row=i,r.end.column=s.length,t.replace(r,n[i-e.first])}},this.toggleCommentLines=function(){var e=this.session.getState(this.getCursorPosition().row),t=this.$getSelectedRows();this.session.getMode().toggleCommentLines(e,this.session,t.first,t.last)},this.toggleBlockComment=function(){var e=this.getCursorPosition(),t=this.session.getState(e.row),n=this.getSelectionRange();this.session.getMode().toggleBlockComment(t,this.session,n,e)},this.getNumberAt=function(e,t){var n=/[\-]?[0-9]+(?:\.[0-9]+)?/g;n.lastIndex=0;var r=this.session.getLine(e);while(n.lastIndex<t){var i=n.exec(r);if(i.index<=t&&i.index+i[0].length>=t){var s={value:i[0],start:i.index,end:i.index+i[0].length};return s}}return null},this.modifyNumber=function(e){var t=this.selection.getCursor().row,n=this.selection.getCursor().column,r=new p(t,n-1,t,n),i=this.session.getTextRange(r);if(!isNaN(parseFloat(i))&&isFinite(i)){var s=this.getNumberAt(t,n);if(s){var o=s.value.indexOf(".")>=0?s.start+s.value.indexOf(".")+1:s.end,u=s.start+s.value.length-o,a=parseFloat(s.value);a*=Math.pow(10,u),o!==s.end&&n<o?e*=Math.pow(10,s.end-n-1):e*=Math.pow(10,s.end-n),a+=e,a/=Math.pow(10,u);var f=a.toFixed(u),l=new p(t,s.start,t,s.end);this.session.replace(l,f),this.moveCursorTo(t,Math.max(s.start+1,n+f.length-s.value.length))}}},this.removeLines=function(){var e=this.$getSelectedRows();this.session.removeFullLines(e.first,e.last),this.clearSelection()},this.duplicateSelection=function(){var e=this.selection,t=this.session,n=e.getRange(),r=e.isBackwards();if(n.isEmpty()){var i=n.start.row;t.duplicateLines(i,i)}else{var s=r?n.start:n.end,o=t.insert(s,t.getTextRange(n),!1);n.start=s,n.end=o,e.setSelectionRange(n,r)}},this.moveLinesDown=function(){this.$moveLines(1,!1)},this.moveLinesUp=function(){this.$moveLines(-1,!1)},this.moveText=function(e,t,n){return this.session.moveText(e,t,n)},this.copyLinesUp=function(){this.$moveLines(-1,!0)},this.copyLinesDown=function(){this.$moveLines(1,!0)},this.$moveLines=function(e,t){var n,r,i=this.selection;if(!i.inMultiSelectMode||this.inVirtualSelectionMode){var s=i.toOrientedRange();n=this.$getSelectedRows(s),r=this.session.$moveLines(n.first,n.last,t?0:e),t&&e==-1&&(r=0),s.moveBy(r,0),i.fromOrientedRange(s)}else{var o=i.rangeList.ranges;i.rangeList.detach(this.session),this.inVirtualSelectionMode=!0;var u=0,a=0,f=o.length;for(var l=0;l<f;l++){var c=l;o[l].moveBy(u,0),n=this.$getSelectedRows(o[l]);var h=n.first,p=n.last;while(++l<f){a&&o[l].moveBy(a,0);var d=this.$getSelectedRows(o[l]);if(t&&d.first!=p)break;if(!t&&d.first>p+1)break;p=d.last}l--,u=this.session.$moveLines(h,p,t?0:e),t&&e==-1&&(c=l+1);while(c<=l)o[c].moveBy(u,0),c++;t||(u=0),a+=u}i.fromOrientedRange(i.ranges[0]),i.rangeList.attach(this.session),this.inVirtualSelectionMode=!1}},this.$getSelectedRows=function(e){return e=(e||this.getSelectionRange()).collapseRows(),{first:this.session.getRowFoldStart(e.start.row),last:this.session.getRowFoldEnd(e.end.row)}},this.onCompositionStart=function(e){this.renderer.showComposition(this.getCursorPosition())},this.onCompositionUpdate=function(e){this.renderer.setCompositionText(e)},this.onCompositionEnd=function(){this.renderer.hideComposition()},this.getFirstVisibleRow=function(){return this.renderer.getFirstVisibleRow()},this.getLastVisibleRow=function(){return this.renderer.getLastVisibleRow()},this.isRowVisible=function(e){return e>=this.getFirstVisibleRow()&&e<=this.getLastVisibleRow()},this.isRowFullyVisible=function(e){return e>=this.renderer.getFirstFullyVisibleRow()&&e<=this.renderer.getLastFullyVisibleRow()},this.$getVisibleRowCount=function(){return this.renderer.getScrollBottomRow()-this.renderer.getScrollTopRow()+1},this.$moveByPage=function(e,t){var n=this.renderer,r=this.renderer.layerConfig,i=e*Math.floor(r.height/r.lineHeight);this.$blockScrolling++,t===!0?this.selection.$moveSelection(function(){this.moveCursorBy(i,0)}):t===!1&&(this.selection.moveCursorBy(i,0),this.selection.clearSelection()),this.$blockScrolling--;var s=n.scrollTop;n.scrollBy(0,i*r.lineHeight),t!=null&&n.scrollCursorIntoView(null,.5),n.animateScrolling(s)},this.selectPageDown=function(){this.$moveByPage(1,!0)},this.selectPageUp=function(){this.$moveByPage(-1,!0)},this.gotoPageDown=function(){this.$moveByPage(1,!1)},this.gotoPageUp=function(){this.$moveByPage(-1,!1)},this.scrollPageDown=function(){this.$moveByPage(1)},this.scrollPageUp=function(){this.$moveByPage(-1)},this.scrollToRow=function(e){this.renderer.scrollToRow(e)},this.scrollToLine=function(e,t,n,r){this.renderer.scrollToLine(e,t,n,r)},this.centerSelection=function(){var e=this.getSelectionRange(),t={row:Math.floor(e.start.row+(e.end.row-e.start.row)/2),column:Math.floor(e.start.column+(e.end.column-e.start.column)/2)};this.renderer.alignCursor(t,.5)},this.getCursorPosition=function(){return this.selection.getCursor()},this.getCursorPositionScreen=function(){return this.session.documentToScreenPosition(this.getCursorPosition())},this.getSelectionRange=function(){return this.selection.getRange()},this.selectAll=function(){this.$blockScrolling+=1,this.selection.selectAll(),this.$blockScrolling-=1},this.clearSelection=function(){this.selection.clearSelection()},this.moveCursorTo=function(e,t){this.selection.moveCursorTo(e,t)},this.moveCursorToPosition=function(e){this.selection.moveCursorToPosition(e)},this.jumpToMatching=function(e,t){var n=this.getCursorPosition(),r=new y(this.session,n.row,n.column),i=r.getCurrentToken(),s=i||r.stepForward();if(!s)return;var o,u=!1,a={},f=n.column-s.start,l,c={")":"(","(":"(","]":"[","[":"[","{":"{","}":"{"};do{if(s.value.match(/[{}()\[\]]/g))for(;f<s.value.length&&!u;f++){if(!c[s.value[f]])continue;l=c[s.value[f]]+"."+s.type.replace("rparen","lparen"),isNaN(a[l])&&(a[l]=0);switch(s.value[f]){case"(":case"[":case"{":a[l]++;break;case")":case"]":case"}":a[l]--,a[l]===-1&&(o="bracket",u=!0)}}else s&&s.type.indexOf("tag-name")!==-1&&(isNaN(a[s.value])&&(a[s.value]=0),i.value==="<"?a[s.value]++:i.value==="</"&&a[s.value]--,a[s.value]===-1&&(o="tag",u=!0));u||(i=s,s=r.stepForward(),f=0)}while(s&&!u);if(!o)return;var h,d;if(o==="bracket"){h=this.session.getBracketRange(n);if(!h){h=new p(r.getCurrentTokenRow(),r.getCurrentTokenColumn()+f-1,r.getCurrentTokenRow(),r.getCurrentTokenColumn()+f-1),d=h.start;if(t||d.row===n.row&&Math.abs(d.column-n.column)<2)h=this.session.getBracketRange(d)}}else if(o==="tag"){if(!s||s.type.indexOf("tag-name")===-1)return;var v=s.value;h=new p(r.getCurrentTokenRow(),r.getCurrentTokenColumn()-2,r.getCurrentTokenRow(),r.getCurrentTokenColumn()-2);if(h.compare(n.row,n.column)===0){u=!1;do s=i,i=r.stepBackward(),i&&(i.type.indexOf("tag-close")!==-1&&h.setEnd(r.getCurrentTokenRow(),r.getCurrentTokenColumn()+1),s.value===v&&s.type.indexOf("tag-name")!==-1&&(i.value==="<"?a[v]++:i.value==="</"&&a[v]--,a[v]===0&&(u=!0)));while(i&&!u)}s&&s.type.indexOf("tag-name")&&(d=h.start,d.row==n.row&&Math.abs(d.column-n.column)<2&&(d=h.end))}d=h&&h.cursor||d,d&&(e?h&&t?this.selection.setRange(h):h&&h.isEqual(this.getSelectionRange())?this.clearSelection():this.selection.selectTo(d.row,d.column):this.selection.moveTo(d.row,d.column))},this.gotoLine=function(e,t,n){this.selection.clearSelection(),this.session.unfold({row:e-1,column:t||0}),this.$blockScrolling+=1,this.exitMultiSelectMode&&this.exitMultiSelectMode(),this.moveCursorTo(e-1,t||0),this.$blockScrolling-=1,this.isRowFullyVisible(e-1)||this.scrollToLine(e-1,!0,n)},this.navigateTo=function(e,t){this.selection.moveTo(e,t)},this.navigateUp=function(e){if(this.selection.isMultiLine()&&!this.selection.isBackwards()){var t=this.selection.anchor.getPosition();return this.moveCursorToPosition(t)}this.selection.clearSelection(),this.selection.moveCursorBy(-e||-1,0)},this.navigateDown=function(e){if(this.selection.isMultiLine()&&this.selection.isBackwards()){var t=this.selection.anchor.getPosition();return this.moveCursorToPosition(t)}this.selection.clearSelection(),this.selection.moveCursorBy(e||1,0)},this.navigateLeft=function(e){if(!this.selection.isEmpty()){var t=this.getSelectionRange().start;this.moveCursorToPosition(t)}else{e=e||1;while(e--)this.selection.moveCursorLeft()}this.clearSelection()},this.navigateRight=function(e){if(!this.selection.isEmpty()){var t=this.getSelectionRange().end;this.moveCursorToPosition(t)}else{e=e||1;while(e--)this.selection.moveCursorRight()}this.clearSelection()},this.navigateLineStart=function(){this.selection.moveCursorLineStart(),this.clearSelection()},this.navigateLineEnd=function(){this.selection.moveCursorLineEnd(),this.clearSelection()},this.navigateFileEnd=function(){this.selection.moveCursorFileEnd(),this.clearSelection()},this.navigateFileStart=function(){this.selection.moveCursorFileStart(),this.clearSelection()},this.navigateWordRight=function(){this.selection.moveCursorWordRight(),this.clearSelection()},this.navigateWordLeft=function(){this.selection.moveCursorWordLeft(),this.clearSelection()},this.replace=function(e,t){t&&this.$search.set(t);var n=this.$search.find(this.session),r=0;return n?(this.$tryReplace(n,e)&&(r=1),n!==null&&(this.selection.setSelectionRange(n),this.renderer.scrollSelectionIntoView(n.start,n.end)),r):r},this.replaceAll=function(e,t){t&&this.$search.set(t);var n=this.$search.findAll(this.session),r=0;if(!n.length)return r;this.$blockScrolling+=1;var i=this.getSelectionRange();this.selection.moveTo(0,0);for(var s=n.length-1;s>=0;--s)this.$tryReplace(n[s],e)&&r++;return this.selection.setSelectionRange(i),this.$blockScrolling-=1,r},this.$tryReplace=function(e,t){var n=this.session.getTextRange(e);return t=this.$search.replace(n,t),t!==null?(e.end=this.session.replace(e,t),e):null},this.getLastSearchOptions=function(){return this.$search.getOptions()},this.find=function(e,t,n){t||(t={}),typeof e=="string"||e instanceof RegExp?t.needle=e:typeof e=="object"&&r.mixin(t,e);var i=this.selection.getRange();t.needle==null&&(e=this.session.getTextRange(i)||this.$search.$options.needle,e||(i=this.session.getWordRange(i.start.row,i.start.column),e=this.session.getTextRange(i)),this.$search.set({needle:e})),this.$search.set(t),t.start||this.$search.set({start:i});var s=this.$search.find(this.session);if(t.preventScroll)return s;if(s)return this.revealRange(s,n),s;t.backwards?i.start=i.end:i.end=i.start,this.selection.setRange(i)},this.findNext=function(e,t){this.find({skipCurrent:!0,backwards:!1},e,t)},this.findPrevious=function(e,t){this.find(e,{skipCurrent:!0,backwards:!0},t)},this.revealRange=function(e,t){this.$blockScrolling+=1,this.session.unfold(e),this.selection.setSelectionRange(e),this.$blockScrolling-=1;var n=this.renderer.scrollTop;this.renderer.scrollSelectionIntoView(e.start,e.end,.5),t!==!1&&this.renderer.animateScrolling(n)},this.undo=function(){this.$blockScrolling++,this.session.getUndoManager().undo(),this.$blockScrolling--,this.renderer.scrollCursorIntoView(null,.5)},this.redo=function(){this.$blockScrolling++,this.session.getUndoManager().redo(),this.$blockScrolling--,this.renderer.scrollCursorIntoView(null,.5)},this.destroy=function(){this.renderer.destroy(),this._signal("destroy",this),this.session&&this.session.destroy()},this.setAutoScrollEditorIntoView=function(e){if(!e)return;var t,n=this,r=!1;this.$scrollAnchor||(this.$scrollAnchor=document.createElement("div"));var i=this.$scrollAnchor;i.style.cssText="position:absolute",this.container.insertBefore(i,this.container.firstChild);var s=this.on("changeSelection",function(){r=!0}),o=this.renderer.on("beforeRender",function(){r&&(t=n.renderer.container.getBoundingClientRect())}),u=this.renderer.on("afterRender",function(){if(r&&t&&(n.isFocused()||n.searchBox&&n.searchBox.isFocused())){var e=n.renderer,s=e.$cursorLayer.$pixelPos,o=e.layerConfig,u=s.top-o.offset;s.top>=0&&u+t.top<0?r=!0:s.top<o.height&&s.top+t.top+o.lineHeight>window.innerHeight?r=!1:r=null,r!=null&&(i.style.top=u+"px",i.style.left=s.left+"px",i.style.height=o.lineHeight+"px",i.scrollIntoView(r)),r=t=null}});this.setAutoScrollEditorIntoView=function(e){if(e)return;delete this.setAutoScrollEditorIntoView,this.off("changeSelection",s),this.renderer.off("afterRender",u),this.renderer.off("beforeRender",o)}},this.$resetCursorStyle=function(){var e=this.$cursorStyle||"ace",t=this.renderer.$cursorLayer;if(!t)return;t.setSmoothBlinking(/smooth/.test(e)),t.isBlinking=!this.$readOnly&&e!="wide",i.setCssClass(t.element,"ace_slim-cursors",/slim/.test(e))}}).call(b.prototype),g.defineOptions(b.prototype,"editor",{selectionStyle:{set:function(e){this.onSelectionChange(),this._signal("changeSelectionStyle",{data:e})},initialValue:"line"},highlightActiveLine:{set:function(){this.$updateHighlightActiveLine()},initialValue:!0},highlightSelectedWord:{set:function(e){this.$onSelectionChange()},initialValue:!0},readOnly:{set:function(e){this.$resetCursorStyle()},initialValue:!1},cursorStyle:{set:function(e){this.$resetCursorStyle()},values:["ace","slim","smooth","wide"],initialValue:"ace"},mergeUndoDeltas:{values:[!1,!0,"always"],initialValue:!0},behavioursEnabled:{initialValue:!0},wrapBehavioursEnabled:{initialValue:!0},autoScrollEditorIntoView:{set:function(e){this.setAutoScrollEditorIntoView(e)}},keyboardHandler:{set:function(e){this.setKeyboardHandler(e)},get:function(){return this.keybindingId},handlesSet:!0},hScrollBarAlwaysVisible:"renderer",vScrollBarAlwaysVisible:"renderer",highlightGutterLine:"renderer",animatedScroll:"renderer",showInvisibles:"renderer",showPrintMargin:"renderer",printMarginColumn:"renderer",printMargin:"renderer",fadeFoldWidgets:"renderer",showFoldWidgets:"renderer",showLineNumbers:"renderer",showGutter:"renderer",displayIndentGuides:"renderer",fontSize:"renderer",fontFamily:"renderer",maxLines:"renderer",minLines:"renderer",scrollPastEnd:"renderer",fixedWidthGutter:"renderer",theme:"renderer",scrollSpeed:"$mouseHandler",dragDelay:"$mouseHandler",dragEnabled:"$mouseHandler",focusTimout:"$mouseHandler",tooltipFollowsMouse:"$mouseHandler",firstLineNumber:"session",overwrite:"session",newLineMode:"session",useWorker:"session",useSoftTabs:"session",tabSize:"session",wrap:"session",indentedSoftWrap:"session",foldStyle:"session",mode:"session"}),t.Editor=b}),ace.define("ace/undomanager",["require","exports","module"],function(e,t,n){"use strict";var r=function(){this.reset()};(function(){function e(e){return{action:e.action,start:e.start,end:e.end,lines:e.lines.length==1?null:e.lines,text:e.lines.length==1?e.lines[0]:null}}function t(e){return{action:e.action,start:e.start,end:e.end,lines:e.lines||[e.text]}}function n(e,t){var n=new Array(e.length);for(var r=0;r<e.length;r++){var i=e[r],s={group:i.group,deltas:new Array(i.length)};for(var o=0;o<i.deltas.length;o++){var u=i.deltas[o];s.deltas[o]=t(u)}n[r]=s}return n}this.execute=function(e){var t=e.args[0];this.$doc=e.args[1],e.merge&&this.hasUndo()&&(this.dirtyCounter--,t=this.$undoStack.pop().concat(t)),this.$undoStack.push(t),this.$redoStack=[],this.dirtyCounter<0&&(this.dirtyCounter=NaN),this.dirtyCounter++},this.undo=function(e){var t=this.$undoStack.pop(),n=null;return t&&(n=this.$doc.undoChanges(t,e),this.$redoStack.push(t),this.dirtyCounter--),n},this.redo=function(e){var t=this.$redoStack.pop(),n=null;return t&&(n=this.$doc.redoChanges(this.$deserializeDeltas(t),e),this.$undoStack.push(t),this.dirtyCounter++),n},this.reset=function(){this.$undoStack=[],this.$redoStack=[],this.dirtyCounter=0},this.hasUndo=function(){return this.$undoStack.length>0},this.hasRedo=function(){return this.$redoStack.length>0},this.markClean=function(){this.dirtyCounter=0},this.isClean=function(){return this.dirtyCounter===0},this.$serializeDeltas=function(t){return n(t,e)},this.$deserializeDeltas=function(e){return n(e,t)}}).call(r.prototype),t.UndoManager=r}),ace.define("ace/layer/gutter",["require","exports","module","ace/lib/dom","ace/lib/oop","ace/lib/lang","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("../lib/dom"),i=e("../lib/oop"),s=e("../lib/lang"),o=e("../lib/event_emitter").EventEmitter,u=function(e){this.element=r.createElement("div"),this.element.className="ace_layer ace_gutter-layer",e.appendChild(this.element),this.setShowFoldWidgets(this.$showFoldWidgets),this.gutterWidth=0,this.$annotations=[],this.$updateAnnotations=this.$updateAnnotations.bind(this),this.$cells=[]};(function(){i.implement(this,o),this.setSession=function(e){this.session&&this.session.removeEventListener("change",this.$updateAnnotations),this.session=e,e&&e.on("change",this.$updateAnnotations)},this.addGutterDecoration=function(e,t){window.console&&console.warn&&console.warn("deprecated use session.addGutterDecoration"),this.session.addGutterDecoration(e,t)},this.removeGutterDecoration=function(e,t){window.console&&console.warn&&console.warn("deprecated use session.removeGutterDecoration"),this.session.removeGutterDecoration(e,t)},this.setAnnotations=function(e){this.$annotations=[];for(var t=0;t<e.length;t++){var n=e[t],r=n.row,i=this.$annotations[r];i||(i=this.$annotations[r]={text:[]});var o=n.text;o=o?s.escapeHTML(o):n.html||"",i.text.indexOf(o)===-1&&i.text.push(o);var u=n.type;u=="error"?i.className=" ace_error":u=="warning"&&i.className!=" ace_error"?i.className=" ace_warning":u=="info"&&!i.className&&(i.className=" ace_info")}},this.$updateAnnotations=function(e){if(!this.$annotations.length)return;var t=e.start.row,n=e.end.row-t;if(n!==0)if(e.action=="remove")this.$annotations.splice(t,n+1,null);else{var r=new Array(n+1);r.unshift(t,1),this.$annotations.splice.apply(this.$annotations,r)}},this.update=function(e){var t=this.session,n=e.firstRow,i=Math.min(e.lastRow+e.gutterOffset,t.getLength()-1),s=t.getNextFoldLine(n),o=s?s.start.row:Infinity,u=this.$showFoldWidgets&&t.foldWidgets,a=t.$breakpoints,f=t.$decorations,l=t.$firstLineNumber,c=0,h=t.gutterRenderer||this.$renderer,p=null,d=-1,v=n;for(;;){v>o&&(v=s.end.row+1,s=t.getNextFoldLine(v,s),o=s?s.start.row:Infinity);if(v>i){while(this.$cells.length>d+1)p=this.$cells.pop(),this.element.removeChild(p.element);break}p=this.$cells[++d],p||(p={element:null,textNode:null,foldWidget:null},p.element=r.createElement("div"),p.textNode=document.createTextNode(""),p.element.appendChild(p.textNode),this.element.appendChild(p.element),this.$cells[d]=p);var m="ace_gutter-cell ";a[v]&&(m+=a[v]),f[v]&&(m+=f[v]),this.$annotations[v]&&(m+=this.$annotations[v].className),p.element.className!=m&&(p.element.className=m);var g=t.getRowLength(v)*e.lineHeight+"px";g!=p.element.style.height&&(p.element.style.height=g);if(u){var y=u[v];y==null&&(y=u[v]=t.getFoldWidget(v))}if(y){p.foldWidget||(p.foldWidget=r.createElement("span"),p.element.appendChild(p.foldWidget));var m="ace_fold-widget ace_"+y;y=="start"&&v==o&&v<s.end.row?m+=" ace_closed":m+=" ace_open",p.foldWidget.className!=m&&(p.foldWidget.className=m);var g=e.lineHeight+"px";p.foldWidget.style.height!=g&&(p.foldWidget.style.height=g)}else p.foldWidget&&(p.element.removeChild(p.foldWidget),p.foldWidget=null);var b=c=h?h.getText(t,v):v+l;b!=p.textNode.data&&(p.textNode.data=b),v++}this.element.style.height=e.minHeight+"px";if(this.$fixedWidth||t.$useWrapMode)c=t.getLength()+l;var w=h?h.getWidth(t,c,e):c.toString().length*e.characterWidth,E=this.$padding||this.$computePadding();w+=E.left+E.right,w!==this.gutterWidth&&!isNaN(w)&&(this.gutterWidth=w,this.element.style.width=Math.ceil(this.gutterWidth)+"px",this._emit("changeGutterWidth",w))},this.$fixedWidth=!1,this.$showLineNumbers=!0,this.$renderer="",this.setShowLineNumbers=function(e){this.$renderer=!e&&{getWidth:function(){return""},getText:function(){return""}}},this.getShowLineNumbers=function(){return this.$showLineNumbers},this.$showFoldWidgets=!0,this.setShowFoldWidgets=function(e){e?r.addCssClass(this.element,"ace_folding-enabled"):r.removeCssClass(this.element,"ace_folding-enabled"),this.$showFoldWidgets=e,this.$padding=null},this.getShowFoldWidgets=function(){return this.$showFoldWidgets},this.$computePadding=function(){if(!this.element.firstChild)return{left:0,right:0};var e=r.computedStyle(this.element.firstChild);return this.$padding={},this.$padding.left=parseInt(e.paddingLeft)+1||0,this.$padding.right=parseInt(e.paddingRight)||0,this.$padding},this.getRegion=function(e){var t=this.$padding||this.$computePadding(),n=this.element.getBoundingClientRect();if(e.x<t.left+n.left)return"markers";if(this.$showFoldWidgets&&e.x>n.right-t.right)return"foldWidgets"}}).call(u.prototype),t.Gutter=u}),ace.define("ace/layer/marker",["require","exports","module","ace/range","ace/lib/dom"],function(e,t,n){"use strict";var r=e("../range").Range,i=e("../lib/dom"),s=function(e){this.element=i.createElement("div"),this.element.className="ace_layer ace_marker-layer",e.appendChild(this.element)};(function(){function e(e,t,n,r){return(e?1:0)|(t?2:0)|(n?4:0)|(r?8:0)}this.$padding=0,this.setPadding=function(e){this.$padding=e},this.setSession=function(e){this.session=e},this.setMarkers=function(e){this.markers=e},this.update=function(e){var e=e||this.config;if(!e)return;this.config=e;var t=[];for(var n in this.markers){var r=this.markers[n];if(!r.range){r.update(t,this,this.session,e);continue}var i=r.range.clipRows(e.firstRow,e.lastRow);if(i.isEmpty())continue;i=i.toScreenRange(this.session);if(r.renderer){var s=this.$getTop(i.start.row,e),o=this.$padding+i.start.column*e.characterWidth;r.renderer(t,i,o,s,e)}else r.type=="fullLine"?this.drawFullLineMarker(t,i,r.clazz,e):r.type=="screenLine"?this.drawScreenLineMarker(t,i,r.clazz,e):i.isMultiLine()?r.type=="text"?this.drawTextMarker(t,i,r.clazz,e):this.drawMultiLineMarker(t,i,r.clazz,e):this.drawSingleLineMarker(t,i,r.clazz+" ace_start"+" ace_br15",e)}this.element.innerHTML=t.join("")},this.$getTop=function(e,t){return(e-t.firstRowScreen)*t.lineHeight},this.drawTextMarker=function(t,n,i,s,o){var u=this.session,a=n.start.row,f=n.end.row,l=a,c=0,h=0,p=u.getScreenLastRowColumn(l),d=new r(l,n.start.column,l,h);for(;l<=f;l++)d.start.row=d.end.row=l,d.start.column=l==a?n.start.column:u.getRowWrapIndent(l),d.end.column=p,c=h,h=p,p=l+1<f?u.getScreenLastRowColumn(l+1):l==f?0:n.end.column,this.drawSingleLineMarker(t,d,i+(l==a?" ace_start":"")+" ace_br"+e(l==a||l==a+1&&n.start.column,c<h,h>p,l==f),s,l==f?0:1,o)},this.drawMultiLineMarker=function(e,t,n,r,i){var s=this.$padding,o=r.lineHeight,u=this.$getTop(t.start.row,r),a=s+t.start.column*r.characterWidth;i=i||"",e.push("<div class='",n," ace_br1 ace_start' style='","height:",o,"px;","right:0;","top:",u,"px;","left:",a,"px;",i,"'></div>"),u=this.$getTop(t.end.row,r);var f=t.end.column*r.characterWidth;e.push("<div class='",n," ace_br12' style='","height:",o,"px;","width:",f,"px;","top:",u,"px;","left:",s,"px;",i,"'></div>"),o=(t.end.row-t.start.row-1)*r.lineHeight;if(o<=0)return;u=this.$getTop(t.start.row+1,r);var l=(t.start.column?1:0)|(t.end.column?0:8);e.push("<div class='",n,l?" ace_br"+l:"","' style='","height:",o,"px;","right:0;","top:",u,"px;","left:",s,"px;",i,"'></div>")},this.drawSingleLineMarker=function(e,t,n,r,i,s){var o=r.lineHeight,u=(t.end.column+(i||0)-t.start.column)*r.characterWidth,a=this.$getTop(t.start.row,r),f=this.$padding+t.start.column*r.characterWidth;e.push("<div class='",n,"' style='","height:",o,"px;","width:",u,"px;","top:",a,"px;","left:",f,"px;",s||"","'></div>")},this.drawFullLineMarker=function(e,t,n,r,i){var s=this.$getTop(t.start.row,r),o=r.lineHeight;t.start.row!=t.end.row&&(o+=this.$getTop(t.end.row,r)-s),e.push("<div class='",n,"' style='","height:",o,"px;","top:",s,"px;","left:0;right:0;",i||"","'></div>")},this.drawScreenLineMarker=function(e,t,n,r,i){var s=this.$getTop(t.start.row,r),o=r.lineHeight;e.push("<div class='",n,"' style='","height:",o,"px;","top:",s,"px;","left:0;right:0;",i||"","'></div>")}}).call(s.prototype),t.Marker=s}),ace.define("ace/layer/text",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("../lib/dom"),s=e("../lib/lang"),o=e("../lib/useragent"),u=e("../lib/event_emitter").EventEmitter,a=function(e){this.element=i.createElement("div"),this.element.className="ace_layer ace_text-layer",e.appendChild(this.element),this.$updateEolChar=this.$updateEolChar.bind(this)};(function(){r.implement(this,u),this.EOF_CHAR="\u00b6",this.EOL_CHAR_LF="\u00ac",this.EOL_CHAR_CRLF="\u00a4",this.EOL_CHAR=this.EOL_CHAR_LF,this.TAB_CHAR="\u2014",this.SPACE_CHAR="\u00b7",this.$padding=0,this.$updateEolChar=function(){var e=this.session.doc.getNewLineCharacter()=="\n"?this.EOL_CHAR_LF:this.EOL_CHAR_CRLF;if(this.EOL_CHAR!=e)return this.EOL_CHAR=e,!0},this.setPadding=function(e){this.$padding=e,this.element.style.padding="0 "+e+"px"},this.getLineHeight=function(){return this.$fontMetrics.$characterSize.height||0},this.getCharacterWidth=function(){return this.$fontMetrics.$characterSize.width||0},this.$setFontMetrics=function(e){this.$fontMetrics=e,this.$fontMetrics.on("changeCharacterSize",function(e){this._signal("changeCharacterSize",e)}.bind(this)),this.$pollSizeChanges()},this.checkForSizeChanges=function(){this.$fontMetrics.checkForSizeChanges()},this.$pollSizeChanges=function(){return this.$pollSizeChangesTimer=this.$fontMetrics.$pollSizeChanges()},this.setSession=function(e){this.session=e,e&&this.$computeTabString()},this.showInvisibles=!1,this.setShowInvisibles=function(e){return this.showInvisibles==e?!1:(this.showInvisibles=e,this.$computeTabString(),!0)},this.displayIndentGuides=!0,this.setDisplayIndentGuides=function(e){return this.displayIndentGuides==e?!1:(this.displayIndentGuides=e,this.$computeTabString(),!0)},this.$tabStrings=[],this.onChangeTabSize=this.$computeTabString=function(){var e=this.session.getTabSize();this.tabSize=e;var t=this.$tabStrings=[0];for(var n=1;n<e+1;n++)this.showInvisibles?t.push("<span class='ace_invisible ace_invisible_tab'>"+s.stringRepeat(this.TAB_CHAR,n)+"</span>"):t.push(s.stringRepeat(" ",n));if(this.displayIndentGuides){this.$indentGuideRe=/\s\S| \t|\t |\s$/;var r="ace_indent-guide",i="",o="";if(this.showInvisibles){r+=" ace_invisible",i=" ace_invisible_space",o=" ace_invisible_tab";var u=s.stringRepeat(this.SPACE_CHAR,this.tabSize),a=s.stringRepeat(this.TAB_CHAR,this.tabSize)}else var u=s.stringRepeat(" ",this.tabSize),a=u;this.$tabStrings[" "]="<span class='"+r+i+"'>"+u+"</span>",this.$tabStrings["	"]="<span class='"+r+o+"'>"+a+"</span>"}},this.updateLines=function(e,t,n){(this.config.lastRow!=e.lastRow||this.config.firstRow!=e.firstRow)&&this.scrollLines(e),this.config=e;var r=Math.max(t,e.firstRow),i=Math.min(n,e.lastRow),s=this.element.childNodes,o=0;for(var u=e.firstRow;u<r;u++){var a=this.session.getFoldLine(u);if(a){if(a.containsRow(r)){r=a.start.row;break}u=a.end.row}o++}var u=r,a=this.session.getNextFoldLine(u),f=a?a.start.row:Infinity;for(;;){u>f&&(u=a.end.row+1,a=this.session.getNextFoldLine(u,a),f=a?a.start.row:Infinity);if(u>i)break;var l=s[o++];if(l){var c=[];this.$renderLine(c,u,!this.$useLineGroups(),u==f?a:!1),l.style.height=e.lineHeight*this.session.getRowLength(u)+"px",l.innerHTML=c.join("")}u++}},this.scrollLines=function(e){var t=this.config;this.config=e;if(!t||t.lastRow<e.firstRow)return this.update(e);if(e.lastRow<t.firstRow)return this.update(e);var n=this.element;if(t.firstRow<e.firstRow)for(var r=this.session.getFoldedRowCount(t.firstRow,e.firstRow-1);r>0;r--)n.removeChild(n.firstChild);if(t.lastRow>e.lastRow)for(var r=this.session.getFoldedRowCount(e.lastRow+1,t.lastRow);r>0;r--)n.removeChild(n.lastChild);if(e.firstRow<t.firstRow){var i=this.$renderLinesFragment(e,e.firstRow,t.firstRow-1);n.firstChild?n.insertBefore(i,n.firstChild):n.appendChild(i)}if(e.lastRow>t.lastRow){var i=this.$renderLinesFragment(e,t.lastRow+1,e.lastRow);n.appendChild(i)}},this.$renderLinesFragment=function(e,t,n){var r=this.element.ownerDocument.createDocumentFragment(),s=t,o=this.session.getNextFoldLine(s),u=o?o.start.row:Infinity;for(;;){s>u&&(s=o.end.row+1,o=this.session.getNextFoldLine(s,o),u=o?o.start.row:Infinity);if(s>n)break;var a=i.createElement("div"),f=[];this.$renderLine(f,s,!1,s==u?o:!1),a.innerHTML=f.join("");if(this.$useLineGroups())a.className="ace_line_group",r.appendChild(a),a.style.height=e.lineHeight*this.session.getRowLength(s)+"px";else while(a.firstChild)r.appendChild(a.firstChild);s++}return r},this.update=function(e){this.config=e;var t=[],n=e.firstRow,r=e.lastRow,i=n,s=this.session.getNextFoldLine(i),o=s?s.start.row:Infinity;for(;;){i>o&&(i=s.end.row+1,s=this.session.getNextFoldLine(i,s),o=s?s.start.row:Infinity);if(i>r)break;this.$useLineGroups()&&t.push("<div class='ace_line_group' style='height:",e.lineHeight*this.session.getRowLength(i),"px'>"),this.$renderLine(t,i,!1,i==o?s:!1),this.$useLineGroups()&&t.push("</div>"),i++}this.element.innerHTML=t.join("")},this.$textToken={text:!0,rparen:!0,lparen:!0},this.$renderToken=function(e,t,n,r){var i=this,o=/\t|&|<|>|( +)|([\x00-\x1f\x80-\xa0\xad\u1680\u180E\u2000-\u200f\u2028\u2029\u202F\u205F\u3000\uFEFF\uFFF9-\uFFFC])|[\u1100-\u115F\u11A3-\u11A7\u11FA-\u11FF\u2329-\u232A\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3000-\u303E\u3041-\u3096\u3099-\u30FF\u3105-\u312D\u3131-\u318E\u3190-\u31BA\u31C0-\u31E3\u31F0-\u321E\u3220-\u3247\u3250-\u32FE\u3300-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFAFF\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFF01-\uFF60\uFFE0-\uFFE6]/g,u=function(e,n,r,o,u){if(n)return i.showInvisibles?"<span class='ace_invisible ace_invisible_space'>"+s.stringRepeat(i.SPACE_CHAR,e.length)+"</span>":e;if(e=="&")return"&#38;";if(e=="<")return"&#60;";if(e==">")return"&#62;";if(e=="	"){var a=i.session.getScreenTabSize(t+o);return t+=a-1,i.$tabStrings[a]}if(e=="\u3000"){var f=i.showInvisibles?"ace_cjk ace_invisible ace_invisible_space":"ace_cjk",l=i.showInvisibles?i.SPACE_CHAR:"";return t+=1,"<span class='"+f+"' style='width:"+i.config.characterWidth*2+"px'>"+l+"</span>"}return r?"<span class='ace_invisible ace_invisible_space ace_invalid'>"+i.SPACE_CHAR+"</span>":(t+=1,"<span class='ace_cjk' style='width:"+i.config.characterWidth*2+"px'>"+e+"</span>")},a=r.replace(o,u);if(!this.$textToken[n.type]){var f="ace_"+n.type.replace(/\./g," ace_"),l="";n.type=="fold"&&(l=" style='width:"+n.value.length*this.config.characterWidth+"px;' "),e.push("<span class='",f,"'",l,">",a,"</span>")}else e.push(a);return t+r.length},this.renderIndentGuide=function(e,t,n){var r=t.search(this.$indentGuideRe);return r<=0||r>=n?t:t[0]==" "?(r-=r%this.tabSize,e.push(s.stringRepeat(this.$tabStrings[" "],r/this.tabSize)),t.substr(r)):t[0]=="	"?(e.push(s.stringRepeat(this.$tabStrings["	"],r)),t.substr(r)):t},this.$renderWrappedLine=function(e,t,n,r){var i=0,o=0,u=n[0],a=0;for(var f=0;f<t.length;f++){var l=t[f],c=l.value;if(f==0&&this.displayIndentGuides){i=c.length,c=this.renderIndentGuide(e,c,u);if(!c)continue;i-=c.length}if(i+c.length<u)a=this.$renderToken(e,a,l,c),i+=c.length;else{while(i+c.length>=u)a=this.$renderToken(e,a,l,c.substring(0,u-i)),c=c.substring(u-i),i=u,r||e.push("</div>","<div class='ace_line' style='height:",this.config.lineHeight,"px'>"),e.push(s.stringRepeat("\u00a0",n.indent)),o++,a=0,u=n[o]||Number.MAX_VALUE;c.length!=0&&(i+=c.length,a=this.$renderToken(e,a,l,c))}}},this.$renderSimpleLine=function(e,t){var n=0,r=t[0],i=r.value;this.displayIndentGuides&&(i=this.renderIndentGuide(e,i)),i&&(n=this.$renderToken(e,n,r,i));for(var s=1;s<t.length;s++)r=t[s],i=r.value,n=this.$renderToken(e,n,r,i)},this.$renderLine=function(e,t,n,r){!r&&r!=0&&(r=this.session.getFoldLine(t));if(r)var i=this.$getFoldLineTokens(t,r);else var i=this.session.getTokens(t);n||e.push("<div class='ace_line' style='height:",this.config.lineHeight*(this.$useLineGroups()?1:this.session.getRowLength(t)),"px'>");if(i.length){var s=this.session.getRowSplitData(t);s&&s.length?this.$renderWrappedLine(e,i,s,n):this.$renderSimpleLine(e,i)}this.showInvisibles&&(r&&(t=r.end.row),e.push("<span class='ace_invisible ace_invisible_eol'>",t==this.session.getLength()-1?this.EOF_CHAR:this.EOL_CHAR,"</span>")),n||e.push("</div>")},this.$getFoldLineTokens=function(e,t){function i(e,t,n){var i=0,s=0;while(s+e[i].value.length<t){s+=e[i].value.length,i++;if(i==e.length)return}if(s!=t){var o=e[i].value.substring(t-s);o.length>n-t&&(o=o.substring(0,n-t)),r.push({type:e[i].type,value:o}),s=t+o.length,i+=1}while(s<n&&i<e.length){var o=e[i].value;o.length+s>n?r.push({type:e[i].type,value:o.substring(0,n-s)}):r.push(e[i]),s+=o.length,i+=1}}var n=this.session,r=[],s=n.getTokens(e);return t.walk(function(e,t,o,u,a){e!=null?r.push({type:"fold",value:e}):(a&&(s=n.getTokens(t)),s.length&&i(s,u,o))},t.end.row,this.session.getLine(t.end.row).length),r},this.$useLineGroups=function(){return this.session.getUseWrapMode()},this.destroy=function(){clearInterval(this.$pollSizeChangesTimer),this.$measureNode&&this.$measureNode.parentNode.removeChild(this.$measureNode),delete this.$measureNode}}).call(a.prototype),t.Text=a}),ace.define("ace/layer/cursor",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";var r=e("../lib/dom"),i,s=function(e){this.element=r.createElement("div"),this.element.className="ace_layer ace_cursor-layer",e.appendChild(this.element),i===undefined&&(i=!("opacity"in this.element.style)),this.isVisible=!1,this.isBlinking=!0,this.blinkInterval=1e3,this.smoothBlinking=!1,this.cursors=[],this.cursor=this.addCursor(),r.addCssClass(this.element,"ace_hidden-cursors"),this.$updateCursors=(i?this.$updateVisibility:this.$updateOpacity).bind(this)};(function(){this.$updateVisibility=function(e){var t=this.cursors;for(var n=t.length;n--;)t[n].style.visibility=e?"":"hidden"},this.$updateOpacity=function(e){var t=this.cursors;for(var n=t.length;n--;)t[n].style.opacity=e?"":"0"},this.$padding=0,this.setPadding=function(e){this.$padding=e},this.setSession=function(e){this.session=e},this.setBlinking=function(e){e!=this.isBlinking&&(this.isBlinking=e,this.restartTimer())},this.setBlinkInterval=function(e){e!=this.blinkInterval&&(this.blinkInterval=e,this.restartTimer())},this.setSmoothBlinking=function(e){e!=this.smoothBlinking&&!i&&(this.smoothBlinking=e,r.setCssClass(this.element,"ace_smooth-blinking",e),this.$updateCursors(!0),this.$updateCursors=this.$updateOpacity.bind(this),this.restartTimer())},this.addCursor=function(){var e=r.createElement("div");return e.className="ace_cursor",this.element.appendChild(e),this.cursors.push(e),e},this.removeCursor=function(){if(this.cursors.length>1){var e=this.cursors.pop();return e.parentNode.removeChild(e),e}},this.hideCursor=function(){this.isVisible=!1,r.addCssClass(this.element,"ace_hidden-cursors"),this.restartTimer()},this.showCursor=function(){this.isVisible=!0,r.removeCssClass(this.element,"ace_hidden-cursors"),this.restartTimer()},this.restartTimer=function(){var e=this.$updateCursors;clearInterval(this.intervalId),clearTimeout(this.timeoutId),this.smoothBlinking&&r.removeCssClass(this.element,"ace_smooth-blinking"),e(!0);if(!this.isBlinking||!this.blinkInterval||!this.isVisible)return;this.smoothBlinking&&setTimeout(function(){r.addCssClass(this.element,"ace_smooth-blinking")}.bind(this));var t=function(){this.timeoutId=setTimeout(function(){e(!1)},.6*this.blinkInterval)}.bind(this);this.intervalId=setInterval(function(){e(!0),t()},this.blinkInterval),t()},this.getPixelPosition=function(e,t){if(!this.config||!this.session)return{left:0,top:0};e||(e=this.session.selection.getCursor());var n=this.session.documentToScreenPosition(e),r=this.$padding+n.column*this.config.characterWidth,i=(n.row-(t?this.config.firstRowScreen:0))*this.config.lineHeight;return{left:r,top:i}},this.update=function(e){this.config=e;var t=this.session.$selectionMarkers,n=0,r=0;if(t===undefined||t.length===0)t=[{cursor:null}];for(var n=0,i=t.length;n<i;n++){var s=this.getPixelPosition(t[n].cursor,!0);if((s.top>e.height+e.offset||s.top<0)&&n>1)continue;var o=(this.cursors[r++]||this.addCursor()).style;this.drawCursor?this.drawCursor(o,s,e,t[n],this.session):(o.left=s.left+"px",o.top=s.top+"px",o.width=e.characterWidth+"px",o.height=e.lineHeight+"px")}while(this.cursors.length>r)this.removeCursor();var u=this.session.getOverwrite();this.$setOverwrite(u),this.$pixelPos=s,this.restartTimer()},this.drawCursor=null,this.$setOverwrite=function(e){e!=this.overwrite&&(this.overwrite=e,e?r.addCssClass(this.element,"ace_overwrite-cursors"):r.removeCssClass(this.element,"ace_overwrite-cursors"))},this.destroy=function(){clearInterval(this.intervalId),clearTimeout(this.timeoutId)}}).call(s.prototype),t.Cursor=s}),ace.define("ace/scrollbar",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/event","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/dom"),s=e("./lib/event"),o=e("./lib/event_emitter").EventEmitter,u=32768,a=function(e){this.element=i.createElement("div"),this.element.className="ace_scrollbar ace_scrollbar"+this.classSuffix,this.inner=i.createElement("div"),this.inner.className="ace_scrollbar-inner",this.element.appendChild(this.inner),e.appendChild(this.element),this.setVisible(!1),this.skipEvent=!1,s.addListener(this.element,"scroll",this.onScroll.bind(this)),s.addListener(this.element,"mousedown",s.preventDefault)};(function(){r.implement(this,o),this.setVisible=function(e){this.element.style.display=e?"":"none",this.isVisible=e,this.coeff=1}}).call(a.prototype);var f=function(e,t){a.call(this,e),this.scrollTop=0,this.scrollHeight=0,t.$scrollbarWidth=this.width=i.scrollbarWidth(e.ownerDocument),this.inner.style.width=this.element.style.width=(this.width||15)+5+"px"};r.inherits(f,a),function(){this.classSuffix="-v",this.onScroll=function(){if(!this.skipEvent){this.scrollTop=this.element.scrollTop;if(this.coeff!=1){var e=this.element.clientHeight/this.scrollHeight;this.scrollTop=this.scrollTop*(1-e)/(this.coeff-e)}this._emit("scroll",{data:this.scrollTop})}this.skipEvent=!1},this.getWidth=function(){return this.isVisible?this.width:0},this.setHeight=function(e){this.element.style.height=e+"px"},this.setInnerHeight=this.setScrollHeight=function(e){this.scrollHeight=e,e>u?(this.coeff=u/e,e=u):this.coeff!=1&&(this.coeff=1),this.inner.style.height=e+"px"},this.setScrollTop=function(e){this.scrollTop!=e&&(this.skipEvent=!0,this.scrollTop=e,this.element.scrollTop=e*this.coeff)}}.call(f.prototype);var l=function(e,t){a.call(this,e),this.scrollLeft=0,this.height=t.$scrollbarWidth,this.inner.style.height=this.element.style.height=(this.height||15)+5+"px"};r.inherits(l,a),function(){this.classSuffix="-h",this.onScroll=function(){this.skipEvent||(this.scrollLeft=this.element.scrollLeft,this._emit("scroll",{data:this.scrollLeft})),this.skipEvent=!1},this.getHeight=function(){return this.isVisible?this.height:0},this.setWidth=function(e){this.element.style.width=e+"px"},this.setInnerWidth=function(e){this.inner.style.width=e+"px"},this.setScrollWidth=function(e){this.inner.style.width=e+"px"},this.setScrollLeft=function(e){this.scrollLeft!=e&&(this.skipEvent=!0,this.scrollLeft=this.element.scrollLeft=e)}}.call(l.prototype),t.ScrollBar=f,t.ScrollBarV=f,t.ScrollBarH=l,t.VScrollBar=f,t.HScrollBar=l}),ace.define("ace/renderloop",["require","exports","module","ace/lib/event"],function(e,t,n){"use strict";var r=e("./lib/event"),i=function(e,t){this.onRender=e,this.pending=!1,this.changes=0,this.window=t||window};(function(){this.schedule=function(e){this.changes=this.changes|e;if(!this.pending&&this.changes){this.pending=!0;var t=this;r.nextFrame(function(){t.pending=!1;var e;while(e=t.changes)t.changes=0,t.onRender(e)},this.window)}}}).call(i.prototype),t.RenderLoop=i}),ace.define("ace/layer/font_metrics",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/lib/lang","ace/lib/useragent","ace/lib/event_emitter"],function(e,t,n){var r=e("../lib/oop"),i=e("../lib/dom"),s=e("../lib/lang"),o=e("../lib/useragent"),u=e("../lib/event_emitter").EventEmitter,a=0,f=t.FontMetrics=function(e){this.el=i.createElement("div"),this.$setMeasureNodeStyles(this.el.style,!0),this.$main=i.createElement("div"),this.$setMeasureNodeStyles(this.$main.style),this.$measureNode=i.createElement("div"),this.$setMeasureNodeStyles(this.$measureNode.style),this.el.appendChild(this.$main),this.el.appendChild(this.$measureNode),e.appendChild(this.el),a||this.$testFractionalRect(),this.$measureNode.innerHTML=s.stringRepeat("X",a),this.$characterSize={width:0,height:0},this.checkForSizeChanges()};(function(){r.implement(this,u),this.$characterSize={width:0,height:0},this.$testFractionalRect=function(){var e=i.createElement("div");this.$setMeasureNodeStyles(e.style),e.style.width="0.2px",document.documentElement.appendChild(e);var t=e.getBoundingClientRect().width;t>0&&t<1?a=50:a=100,e.parentNode.removeChild(e)},this.$setMeasureNodeStyles=function(e,t){e.width=e.height="auto",e.left=e.top="0px",e.visibility="hidden",e.position="absolute",e.whiteSpace="pre",o.isIE<8?e["font-family"]="inherit":e.font="inherit",e.overflow=t?"hidden":"visible"},this.checkForSizeChanges=function(){var e=this.$measureSizes();if(e&&(this.$characterSize.width!==e.width||this.$characterSize.height!==e.height)){this.$measureNode.style.fontWeight="bold";var t=this.$measureSizes();this.$measureNode.style.fontWeight="",this.$characterSize=e,this.charSizes=Object.create(null),this.allowBoldFonts=t&&t.width===e.width&&t.height===e.height,this._emit("changeCharacterSize",{data:e})}},this.$pollSizeChanges=function(){if(this.$pollSizeChangesTimer)return this.$pollSizeChangesTimer;var e=this;return this.$pollSizeChangesTimer=setInterval(function(){e.checkForSizeChanges()},500)},this.setPolling=function(e){e?this.$pollSizeChanges():this.$pollSizeChangesTimer&&(clearInterval(this.$pollSizeChangesTimer),this.$pollSizeChangesTimer=0)},this.$measureSizes=function(){if(a===50){var e=null;try{e=this.$measureNode.getBoundingClientRect()}catch(t){e={width:0,height:0}}var n={height:e.height,width:e.width/a}}else var n={height:this.$measureNode.clientHeight,width:this.$measureNode.clientWidth/a};return n.width===0||n.height===0?null:n},this.$measureCharWidth=function(e){this.$main.innerHTML=s.stringRepeat(e,a);var t=this.$main.getBoundingClientRect();return t.width/a},this.getCharacterWidth=function(e){var t=this.charSizes[e];return t===undefined&&(t=this.charSizes[e]=this.$measureCharWidth(e)/this.$characterSize.width),t},this.destroy=function(){clearInterval(this.$pollSizeChangesTimer),this.el&&this.el.parentNode&&this.el.parentNode.removeChild(this.el)}}).call(f.prototype)}),ace.define("ace/virtual_renderer",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/config","ace/lib/useragent","ace/layer/gutter","ace/layer/marker","ace/layer/text","ace/layer/cursor","ace/scrollbar","ace/scrollbar","ace/renderloop","ace/layer/font_metrics","ace/lib/event_emitter"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/dom"),s=e("./config"),o=e("./lib/useragent"),u=e("./layer/gutter").Gutter,a=e("./layer/marker").Marker,f=e("./layer/text").Text,l=e("./layer/cursor").Cursor,c=e("./scrollbar").HScrollBar,h=e("./scrollbar").VScrollBar,p=e("./renderloop").RenderLoop,d=e("./layer/font_metrics").FontMetrics,v=e("./lib/event_emitter").EventEmitter,m='.ace_editor {position: relative;overflow: hidden;font: 12px/normal \'Monaco\', \'Menlo\', \'Ubuntu Mono\', \'Consolas\', \'source-code-pro\', monospace;direction: ltr;text-align: left;}.ace_scroller {position: absolute;overflow: hidden;top: 0;bottom: 0;background-color: inherit;-ms-user-select: none;-moz-user-select: none;-webkit-user-select: none;user-select: none;cursor: text;}.ace_content {position: absolute;-moz-box-sizing: border-box;-webkit-box-sizing: border-box;box-sizing: border-box;min-width: 100%;}.ace_dragging .ace_scroller:before{position: absolute;top: 0;left: 0;right: 0;bottom: 0;content: \'\';background: rgba(250, 250, 250, 0.01);z-index: 1000;}.ace_dragging.ace_dark .ace_scroller:before{background: rgba(0, 0, 0, 0.01);}.ace_selecting, .ace_selecting * {cursor: text !important;}.ace_gutter {position: absolute;overflow : hidden;width: auto;top: 0;bottom: 0;left: 0;cursor: default;z-index: 4;-ms-user-select: none;-moz-user-select: none;-webkit-user-select: none;user-select: none;}.ace_gutter-active-line {position: absolute;left: 0;right: 0;}.ace_scroller.ace_scroll-left {box-shadow: 17px 0 16px -16px rgba(0, 0, 0, 0.4) inset;}.ace_gutter-cell {padding-left: 19px;padding-right: 6px;background-repeat: no-repeat;}.ace_gutter-cell.ace_error {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAABOFBMVEX/////////QRswFAb/Ui4wFAYwFAYwFAaWGAfDRymzOSH/PxswFAb/SiUwFAYwFAbUPRvjQiDllog5HhHdRybsTi3/Tyv9Tir+Syj/UC3////XurebMBIwFAb/RSHbPx/gUzfdwL3kzMivKBAwFAbbvbnhPx66NhowFAYwFAaZJg8wFAaxKBDZurf/RB6mMxb/SCMwFAYwFAbxQB3+RB4wFAb/Qhy4Oh+4QifbNRcwFAYwFAYwFAb/QRzdNhgwFAYwFAbav7v/Uy7oaE68MBK5LxLewr/r2NXewLswFAaxJw4wFAbkPRy2PyYwFAaxKhLm1tMwFAazPiQwFAaUGAb/QBrfOx3bvrv/VC/maE4wFAbRPBq6MRO8Qynew8Dp2tjfwb0wFAbx6eju5+by6uns4uH9/f36+vr/GkHjAAAAYnRSTlMAGt+64rnWu/bo8eAA4InH3+DwoN7j4eLi4xP99Nfg4+b+/u9B/eDs1MD1mO7+4PHg2MXa347g7vDizMLN4eG+Pv7i5evs/v79yu7S3/DV7/498Yv24eH+4ufQ3Ozu/v7+y13sRqwAAADLSURBVHjaZc/XDsFgGIBhtDrshlitmk2IrbHFqL2pvXf/+78DPokj7+Fz9qpU/9UXJIlhmPaTaQ6QPaz0mm+5gwkgovcV6GZzd5JtCQwgsxoHOvJO15kleRLAnMgHFIESUEPmawB9ngmelTtipwwfASilxOLyiV5UVUyVAfbG0cCPHig+GBkzAENHS0AstVF6bacZIOzgLmxsHbt2OecNgJC83JERmePUYq8ARGkJx6XtFsdddBQgZE2nPR6CICZhawjA4Fb/chv+399kfR+MMMDGOQAAAABJRU5ErkJggg==");background-repeat: no-repeat;background-position: 2px center;}.ace_gutter-cell.ace_warning {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAmVBMVEX///8AAAD///8AAAAAAABPSzb/5sAAAAB/blH/73z/ulkAAAAAAAD85pkAAAAAAAACAgP/vGz/rkDerGbGrV7/pkQICAf////e0IsAAAD/oED/qTvhrnUAAAD/yHD/njcAAADuv2r/nz//oTj/p064oGf/zHAAAAA9Nir/tFIAAAD/tlTiuWf/tkIAAACynXEAAAAAAAAtIRW7zBpBAAAAM3RSTlMAABR1m7RXO8Ln31Z36zT+neXe5OzooRDfn+TZ4p3h2hTf4t3k3ucyrN1K5+Xaks52Sfs9CXgrAAAAjklEQVR42o3PbQ+CIBQFYEwboPhSYgoYunIqqLn6/z8uYdH8Vmdnu9vz4WwXgN/xTPRD2+sgOcZjsge/whXZgUaYYvT8QnuJaUrjrHUQreGczuEafQCO/SJTufTbroWsPgsllVhq3wJEk2jUSzX3CUEDJC84707djRc5MTAQxoLgupWRwW6UB5fS++NV8AbOZgnsC7BpEAAAAABJRU5ErkJggg==");background-position: 2px center;}.ace_gutter-cell.ace_info {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAJ0Uk5TAAB2k804AAAAPklEQVQY02NgIB68QuO3tiLznjAwpKTgNyDbMegwisCHZUETUZV0ZqOquBpXj2rtnpSJT1AEnnRmL2OgGgAAIKkRQap2htgAAAAASUVORK5CYII=");background-position: 2px center;}.ace_dark .ace_gutter-cell.ace_info {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAAJFBMVEUAAAChoaGAgIAqKiq+vr6tra1ZWVmUlJSbm5s8PDxubm56enrdgzg3AAAAAXRSTlMAQObYZgAAAClJREFUeNpjYMAPdsMYHegyJZFQBlsUlMFVCWUYKkAZMxZAGdxlDMQBAG+TBP4B6RyJAAAAAElFTkSuQmCC");}.ace_scrollbar {position: absolute;right: 0;bottom: 0;z-index: 6;}.ace_scrollbar-inner {position: absolute;cursor: text;left: 0;top: 0;}.ace_scrollbar-v{overflow-x: hidden;overflow-y: scroll;top: 0;}.ace_scrollbar-h {overflow-x: scroll;overflow-y: hidden;left: 0;}.ace_print-margin {position: absolute;height: 100%;}.ace_text-input {position: absolute;z-index: 0;width: 0.5em;height: 1em;opacity: 0;background: transparent;-moz-appearance: none;appearance: none;border: none;resize: none;outline: none;overflow: hidden;font: inherit;padding: 0 1px;margin: 0 -1px;text-indent: -1em;-ms-user-select: text;-moz-user-select: text;-webkit-user-select: text;user-select: text;white-space: pre!important;}.ace_text-input.ace_composition {background: inherit;color: inherit;z-index: 1000;opacity: 1;text-indent: 0;}.ace_layer {z-index: 1;position: absolute;overflow: hidden;word-wrap: normal;white-space: pre;height: 100%;width: 100%;-moz-box-sizing: border-box;-webkit-box-sizing: border-box;box-sizing: border-box;pointer-events: none;}.ace_gutter-layer {position: relative;width: auto;text-align: right;pointer-events: auto;}.ace_text-layer {font: inherit !important;}.ace_cjk {display: inline-block;text-align: center;}.ace_cursor-layer {z-index: 4;}.ace_cursor {z-index: 4;position: absolute;-moz-box-sizing: border-box;-webkit-box-sizing: border-box;box-sizing: border-box;border-left: 2px solid;transform: translatez(0);}.ace_slim-cursors .ace_cursor {border-left-width: 1px;}.ace_overwrite-cursors .ace_cursor {border-left-width: 0;border-bottom: 1px solid;}.ace_hidden-cursors .ace_cursor {opacity: 0.2;}.ace_smooth-blinking .ace_cursor {-webkit-transition: opacity 0.18s;transition: opacity 0.18s;}.ace_editor.ace_multiselect .ace_cursor {border-left-width: 1px;}.ace_marker-layer .ace_step, .ace_marker-layer .ace_stack {position: absolute;z-index: 3;}.ace_marker-layer .ace_selection {position: absolute;z-index: 5;}.ace_marker-layer .ace_bracket {position: absolute;z-index: 6;}.ace_marker-layer .ace_active-line {position: absolute;z-index: 2;}.ace_marker-layer .ace_selected-word {position: absolute;z-index: 4;-moz-box-sizing: border-box;-webkit-box-sizing: border-box;box-sizing: border-box;}.ace_line .ace_fold {-moz-box-sizing: border-box;-webkit-box-sizing: border-box;box-sizing: border-box;display: inline-block;height: 11px;margin-top: -2px;vertical-align: middle;background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACJJREFUeNpi+P//fxgTAwPDBxDxD078RSX+YeEyDFMCIMAAI3INmXiwf2YAAAAASUVORK5CYII=");background-repeat: no-repeat, repeat-x;background-position: center center, top left;color: transparent;border: 1px solid black;border-radius: 2px;cursor: pointer;pointer-events: auto;}.ace_dark .ace_fold {}.ace_fold:hover{background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAJCAYAAADU6McMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJpJREFUeNpi/P//PwOlgAXGYGRklAVSokD8GmjwY1wasKljQpYACtpCFeADcHVQfQyMQAwzwAZI3wJKvCLkfKBaMSClBlR7BOQikCFGQEErIH0VqkabiGCAqwUadAzZJRxQr/0gwiXIal8zQQPnNVTgJ1TdawL0T5gBIP1MUJNhBv2HKoQHHjqNrA4WO4zY0glyNKLT2KIfIMAAQsdgGiXvgnYAAAAASUVORK5CYII="),url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA3CAYAAADNNiA5AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAACBJREFUeNpi+P//fz4TAwPDZxDxD5X4i5fLMEwJgAADAEPVDbjNw87ZAAAAAElFTkSuQmCC");}.ace_tooltip {background-color: #FFF;background-image: -webkit-linear-gradient(top, transparent, rgba(0, 0, 0, 0.1));background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.1));border: 1px solid gray;border-radius: 1px;box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);color: black;max-width: 100%;padding: 3px 4px;position: fixed;z-index: 999999;-moz-box-sizing: border-box;-webkit-box-sizing: border-box;box-sizing: border-box;cursor: default;white-space: pre;word-wrap: break-word;line-height: normal;font-style: normal;font-weight: normal;letter-spacing: normal;pointer-events: none;}.ace_folding-enabled > .ace_gutter-cell {padding-right: 13px;}.ace_fold-widget {-moz-box-sizing: border-box;-webkit-box-sizing: border-box;box-sizing: border-box;margin: 0 -12px 0 1px;display: none;width: 11px;vertical-align: top;background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42mWKsQ0AMAzC8ixLlrzQjzmBiEjp0A6WwBCSPgKAXoLkqSot7nN3yMwR7pZ32NzpKkVoDBUxKAAAAABJRU5ErkJggg==");background-repeat: no-repeat;background-position: center;border-radius: 3px;border: 1px solid transparent;cursor: pointer;}.ace_folding-enabled .ace_fold-widget {display: inline-block;   }.ace_fold-widget.ace_end {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAANElEQVR42m3HwQkAMAhD0YzsRchFKI7sAikeWkrxwScEB0nh5e7KTPWimZki4tYfVbX+MNl4pyZXejUO1QAAAABJRU5ErkJggg==");}.ace_fold-widget.ace_closed {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAAOUlEQVR42jXKwQkAMAgDwKwqKD4EwQ26sSOkVWjgIIHAzPiCgaqiqnJHZnKICBERHN194O5b9vbLuAVRL+l0YWnZAAAAAElFTkSuQmCCXA==");}.ace_fold-widget:hover {border: 1px solid rgba(0, 0, 0, 0.3);background-color: rgba(255, 255, 255, 0.2);box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);}.ace_fold-widget:active {border: 1px solid rgba(0, 0, 0, 0.4);background-color: rgba(0, 0, 0, 0.05);box-shadow: 0 1px 1px rgba(255, 255, 255, 0.8);}.ace_dark .ace_fold-widget {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHklEQVQIW2P4//8/AzoGEQ7oGCaLLAhWiSwB146BAQCSTPYocqT0AAAAAElFTkSuQmCC");}.ace_dark .ace_fold-widget.ace_end {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAH0lEQVQIW2P4//8/AxQ7wNjIAjDMgC4AxjCVKBirIAAF0kz2rlhxpAAAAABJRU5ErkJggg==");}.ace_dark .ace_fold-widget.ace_closed {background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAFCAYAAACAcVaiAAAAHElEQVQIW2P4//+/AxAzgDADlOOAznHAKgPWAwARji8UIDTfQQAAAABJRU5ErkJggg==");}.ace_dark .ace_fold-widget:hover {box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);background-color: rgba(255, 255, 255, 0.1);}.ace_dark .ace_fold-widget:active {box-shadow: 0 1px 1px rgba(255, 255, 255, 0.2);}.ace_fold-widget.ace_invalid {background-color: #FFB4B4;border-color: #DE5555;}.ace_fade-fold-widgets .ace_fold-widget {-webkit-transition: opacity 0.4s ease 0.05s;transition: opacity 0.4s ease 0.05s;opacity: 0;}.ace_fade-fold-widgets:hover .ace_fold-widget {-webkit-transition: opacity 0.05s ease 0.05s;transition: opacity 0.05s ease 0.05s;opacity:1;}.ace_underline {text-decoration: underline;}.ace_bold {font-weight: bold;}.ace_nobold .ace_bold {font-weight: normal;}.ace_italic {font-style: italic;}.ace_error-marker {background-color: rgba(255, 0, 0,0.2);position: absolute;z-index: 9;}.ace_highlight-marker {background-color: rgba(255, 255, 0,0.2);position: absolute;z-index: 8;}.ace_br1 {border-top-left-radius    : 3px;}.ace_br2 {border-top-right-radius   : 3px;}.ace_br3 {border-top-left-radius    : 3px; border-top-right-radius:    3px;}.ace_br4 {border-bottom-right-radius: 3px;}.ace_br5 {border-top-left-radius    : 3px; border-bottom-right-radius: 3px;}.ace_br6 {border-top-right-radius   : 3px; border-bottom-right-radius: 3px;}.ace_br7 {border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px;}.ace_br8 {border-bottom-left-radius : 3px;}.ace_br9 {border-top-left-radius    : 3px; border-bottom-left-radius:  3px;}.ace_br10{border-top-right-radius   : 3px; border-bottom-left-radius:  3px;}.ace_br11{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-left-radius:  3px;}.ace_br12{border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}.ace_br13{border-top-left-radius    : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}.ace_br14{border-top-right-radius   : 3px; border-bottom-right-radius: 3px; border-bottom-left-radius:  3px;}.ace_br15{border-top-left-radius    : 3px; border-top-right-radius:    3px; border-bottom-right-radius: 3px; border-bottom-left-radius: 3px;}';i.importCssString(m,"ace_editor.css");var g=function(e,t){var n=this;this.container=e||i.createElement("div"),this.$keepTextAreaAtCursor=!o.isOldIE,i.addCssClass(this.container,"ace_editor"),this.setTheme(t),this.$gutter=i.createElement("div"),this.$gutter.className="ace_gutter",this.container.appendChild(this.$gutter),this.scroller=i.createElement("div"),this.scroller.className="ace_scroller",this.container.appendChild(this.scroller),this.content=i.createElement("div"),this.content.className="ace_content",this.scroller.appendChild(this.content),this.$gutterLayer=new u(this.$gutter),this.$gutterLayer.on("changeGutterWidth",this.onGutterResize.bind(this)),this.$markerBack=new a(this.content);var r=this.$textLayer=new f(this.content);this.canvas=r.element,this.$markerFront=new a(this.content),this.$cursorLayer=new l(this.content),this.$horizScroll=!1,this.$vScroll=!1,this.scrollBar=this.scrollBarV=new h(this.container,this),this.scrollBarH=new c(this.container,this),this.scrollBarV.addEventListener("scroll",function(e){n.$scrollAnimation||n.session.setScrollTop(e.data-n.scrollMargin.top)}),this.scrollBarH.addEventListener("scroll",function(e){n.$scrollAnimation||n.session.setScrollLeft(e.data-n.scrollMargin.left)}),this.scrollTop=0,this.scrollLeft=0,this.cursorPos={row:0,column:0},this.$fontMetrics=new d(this.container),this.$textLayer.$setFontMetrics(this.$fontMetrics),this.$textLayer.addEventListener("changeCharacterSize",function(e){n.updateCharacterSize(),n.onResize(!0,n.gutterWidth,n.$size.width,n.$size.height),n._signal("changeCharacterSize",e)}),this.$size={width:0,height:0,scrollerHeight:0,scrollerWidth:0,$dirty:!0},this.layerConfig={width:1,padding:0,firstRow:0,firstRowScreen:0,lastRow:0,lineHeight:0,characterWidth:0,minHeight:1,maxHeight:1,offset:0,height:1,gutterOffset:1},this.scrollMargin={left:0,right:0,top:0,bottom:0,v:0,h:0},this.$loop=new p(this.$renderChanges.bind(this),this.container.ownerDocument.defaultView),this.$loop.schedule(this.CHANGE_FULL),this.updateCharacterSize(),this.setPadding(4),s.resetOptions(this),s._emit("renderer",this)};(function(){this.CHANGE_CURSOR=1,this.CHANGE_MARKER=2,this.CHANGE_GUTTER=4,this.CHANGE_SCROLL=8,this.CHANGE_LINES=16,this.CHANGE_TEXT=32,this.CHANGE_SIZE=64,this.CHANGE_MARKER_BACK=128,this.CHANGE_MARKER_FRONT=256,this.CHANGE_FULL=512,this.CHANGE_H_SCROLL=1024,r.implement(this,v),this.updateCharacterSize=function(){this.$textLayer.allowBoldFonts!=this.$allowBoldFonts&&(this.$allowBoldFonts=this.$textLayer.allowBoldFonts,this.setStyle("ace_nobold",!this.$allowBoldFonts)),this.layerConfig.characterWidth=this.characterWidth=this.$textLayer.getCharacterWidth(),this.layerConfig.lineHeight=this.lineHeight=this.$textLayer.getLineHeight(),this.$updatePrintMargin()},this.setSession=function(e){this.session&&this.session.doc.off("changeNewLineMode",this.onChangeNewLineMode),this.session=e,e&&this.scrollMargin.top&&e.getScrollTop()<=0&&e.setScrollTop(-this.scrollMargin.top),this.$cursorLayer.setSession(e),this.$markerBack.setSession(e),this.$markerFront.setSession(e),this.$gutterLayer.setSession(e),this.$textLayer.setSession(e);if(!e)return;this.$loop.schedule(this.CHANGE_FULL),this.session.$setFontMetrics(this.$fontMetrics),this.scrollBarV.scrollLeft=this.scrollBarV.scrollTop=null,this.onChangeNewLineMode=this.onChangeNewLineMode.bind(this),this.onChangeNewLineMode(),this.session.doc.on("changeNewLineMode",this.onChangeNewLineMode)},this.updateLines=function(e,t,n){t===undefined&&(t=Infinity),this.$changedLines?(this.$changedLines.firstRow>e&&(this.$changedLines.firstRow=e),this.$changedLines.lastRow<t&&(this.$changedLines.lastRow=t)):this.$changedLines={firstRow:e,lastRow:t};if(this.$changedLines.lastRow<this.layerConfig.firstRow){if(!n)return;this.$changedLines.lastRow=this.layerConfig.lastRow}if(this.$changedLines.firstRow>this.layerConfig.lastRow)return;this.$loop.schedule(this.CHANGE_LINES)},this.onChangeNewLineMode=function(){this.$loop.schedule(this.CHANGE_TEXT),this.$textLayer.$updateEolChar()},this.onChangeTabSize=function(){this.$loop.schedule(this.CHANGE_TEXT|this.CHANGE_MARKER),this.$textLayer.onChangeTabSize()},this.updateText=function(){this.$loop.schedule(this.CHANGE_TEXT)},this.updateFull=function(e){e?this.$renderChanges(this.CHANGE_FULL,!0):this.$loop.schedule(this.CHANGE_FULL)},this.updateFontSize=function(){this.$textLayer.checkForSizeChanges()},this.$changes=0,this.$updateSizeAsync=function(){this.$loop.pending?this.$size.$dirty=!0:this.onResize()},this.onResize=function(e,t,n,r){if(this.resizing>2)return;this.resizing>0?this.resizing++:this.resizing=e?1:0;var i=this.container;r||(r=i.clientHeight||i.scrollHeight),n||(n=i.clientWidth||i.scrollWidth);var s=this.$updateCachedSize(e,t,n,r);if(!this.$size.scrollerHeight||!n&&!r)return this.resizing=0;e&&(this.$gutterLayer.$padding=null),e?this.$renderChanges(s|this.$changes,!0):this.$loop.schedule(s|this.$changes),this.resizing&&(this.resizing=0),this.scrollBarV.scrollLeft=this.scrollBarV.scrollTop=null},this.$updateCachedSize=function(e,t,n,r){r-=this.$extraHeight||0;var i=0,s=this.$size,o={width:s.width,height:s.height,scrollerHeight:s.scrollerHeight,scrollerWidth:s.scrollerWidth};r&&(e||s.height!=r)&&(s.height=r,i|=this.CHANGE_SIZE,s.scrollerHeight=s.height,this.$horizScroll&&(s.scrollerHeight-=this.scrollBarH.getHeight()),this.scrollBarV.element.style.bottom=this.scrollBarH.getHeight()+"px",i|=this.CHANGE_SCROLL);if(n&&(e||s.width!=n)){i|=this.CHANGE_SIZE,s.width=n,t==null&&(t=this.$showGutter?this.$gutter.offsetWidth:0),this.gutterWidth=t,this.scrollBarH.element.style.left=this.scroller.style.left=t+"px",s.scrollerWidth=Math.max(0,n-t-this.scrollBarV.getWidth()),this.scrollBarH.element.style.right=this.scroller.style.right=this.scrollBarV.getWidth()+"px",this.scroller.style.bottom=this.scrollBarH.getHeight()+"px";if(this.session&&this.session.getUseWrapMode()&&this.adjustWrapLimit()||e)i|=this.CHANGE_FULL}return s.$dirty=!n||!r,i&&this._signal("resize",o),i},this.onGutterResize=function(){var e=this.$showGutter?this.$gutter.offsetWidth:0;e!=this.gutterWidth&&(this.$changes|=this.$updateCachedSize(!0,e,this.$size.width,this.$size.height)),this.session.getUseWrapMode()&&this.adjustWrapLimit()?this.$loop.schedule(this.CHANGE_FULL):this.$size.$dirty?this.$loop.schedule(this.CHANGE_FULL):(this.$computeLayerConfig(),this.$loop.schedule(this.CHANGE_MARKER))},this.adjustWrapLimit=function(){var e=this.$size.scrollerWidth-this.$padding*2,t=Math.floor(e/this.characterWidth);return this.session.adjustWrapLimit(t,this.$showPrintMargin&&this.$printMarginColumn)},this.setAnimatedScroll=function(e){this.setOption("animatedScroll",e)},this.getAnimatedScroll=function(){return this.$animatedScroll},this.setShowInvisibles=function(e){this.setOption("showInvisibles",e)},this.getShowInvisibles=function(){return this.getOption("showInvisibles")},this.getDisplayIndentGuides=function(){return this.getOption("displayIndentGuides")},this.setDisplayIndentGuides=function(e){this.setOption("displayIndentGuides",e)},this.setShowPrintMargin=function(e){this.setOption("showPrintMargin",e)},this.getShowPrintMargin=function(){return this.getOption("showPrintMargin")},this.setPrintMarginColumn=function(e){this.setOption("printMarginColumn",e)},this.getPrintMarginColumn=function(){return this.getOption("printMarginColumn")},this.getShowGutter=function(){return this.getOption("showGutter")},this.setShowGutter=function(e){return this.setOption("showGutter",e)},this.getFadeFoldWidgets=function(){return this.getOption("fadeFoldWidgets")},this.setFadeFoldWidgets=function(e){this.setOption("fadeFoldWidgets",e)},this.setHighlightGutterLine=function(e){this.setOption("highlightGutterLine",e)},this.getHighlightGutterLine=function(){return this.getOption("highlightGutterLine")},this.$updateGutterLineHighlight=function(){var e=this.$cursorLayer.$pixelPos,t=this.layerConfig.lineHeight;if(this.session.getUseWrapMode()){var n=this.session.selection.getCursor();n.column=0,e=this.$cursorLayer.getPixelPosition(n,!0),t*=this.session.getRowLength(n.row)}this.$gutterLineHighlight.style.top=e.top-this.layerConfig.offset+"px",this.$gutterLineHighlight.style.height=t+"px"},this.$updatePrintMargin=function(){if(!this.$showPrintMargin&&!this.$printMarginEl)return;if(!this.$printMarginEl){var e=i.createElement("div");e.className="ace_layer ace_print-margin-layer",this.$printMarginEl=i.createElement("div"),this.$printMarginEl.className="ace_print-margin",e.appendChild(this.$printMarginEl),this.content.insertBefore(e,this.content.firstChild)}var t=this.$printMarginEl.style;t.left=this.characterWidth*this.$printMarginColumn+this.$padding+"px",t.visibility=this.$showPrintMargin?"visible":"hidden",this.session&&this.session.$wrap==-1&&this.adjustWrapLimit()},this.getContainerElement=function(){return this.container},this.getMouseEventTarget=function(){return this.scroller},this.getTextAreaContainer=function(){return this.container},this.$moveTextAreaToCursor=function(){if(!this.$keepTextAreaAtCursor)return;var e=this.layerConfig,t=this.$cursorLayer.$pixelPos.top,n=this.$cursorLayer.$pixelPos.left;t-=e.offset;var r=this.textarea.style,i=this.lineHeight;if(t<0||t>e.height-i){r.top=r.left="0";return}var s=this.characterWidth;if(this.$composition){var o=this.textarea.value.replace(/^\x01+/,"");s*=this.session.$getStringScreenWidth(o)[0]+2,i+=2}n-=this.scrollLeft,n>this.$size.scrollerWidth-s&&(n=this.$size.scrollerWidth-s),n+=this.gutterWidth,r.height=i+"px",r.width=s+"px",r.left=Math.min(n,this.$size.scrollerWidth-s)+"px",r.top=Math.min(t,this.$size.height-i)+"px"},this.getFirstVisibleRow=function(){return this.layerConfig.firstRow},this.getFirstFullyVisibleRow=function(){return this.layerConfig.firstRow+(this.layerConfig.offset===0?0:1)},this.getLastFullyVisibleRow=function(){var e=this.layerConfig,t=e.lastRow,n=this.session.documentToScreenRow(t,0)*e.lineHeight;return n-this.session.getScrollTop()>e.height-e.lineHeight?t-1:t},this.getLastVisibleRow=function(){return this.layerConfig.lastRow},this.$padding=null,this.setPadding=function(e){this.$padding=e,this.$textLayer.setPadding(e),this.$cursorLayer.setPadding(e),this.$markerFront.setPadding(e),this.$markerBack.setPadding(e),this.$loop.schedule(this.CHANGE_FULL),this.$updatePrintMargin()},this.setScrollMargin=function(e,t,n,r){var i=this.scrollMargin;i.top=e|0,i.bottom=t|0,i.right=r|0,i.left=n|0,i.v=i.top+i.bottom,i.h=i.left+i.right,i.top&&this.scrollTop<=0&&this.session&&this.session.setScrollTop(-i.top),this.updateFull()},this.getHScrollBarAlwaysVisible=function(){return this.$hScrollBarAlwaysVisible},this.setHScrollBarAlwaysVisible=function(e){this.setOption("hScrollBarAlwaysVisible",e)},this.getVScrollBarAlwaysVisible=function(){return this.$vScrollBarAlwaysVisible},this.setVScrollBarAlwaysVisible=function(e){this.setOption("vScrollBarAlwaysVisible",e)},this.$updateScrollBarV=function(){var e=this.layerConfig.maxHeight,t=this.$size.scrollerHeight;!this.$maxLines&&this.$scrollPastEnd&&(e-=(t-this.lineHeight)*this.$scrollPastEnd,this.scrollTop>e-t&&(e=this.scrollTop+t,this.scrollBarV.scrollTop=null)),this.scrollBarV.setScrollHeight(e+this.scrollMargin.v),this.scrollBarV.setScrollTop(this.scrollTop+this.scrollMargin.top)},this.$updateScrollBarH=function(){this.scrollBarH.setScrollWidth(this.layerConfig.width+2*this.$padding+this.scrollMargin.h),this.scrollBarH.setScrollLeft(this.scrollLeft+this.scrollMargin.left)},this.$frozen=!1,this.freeze=function(){this.$frozen=!0},this.unfreeze=function(){this.$frozen=!1},this.$renderChanges=function(e,t){this.$changes&&(e|=this.$changes,this.$changes=0);if(!this.session||!this.container.offsetWidth||this.$frozen||!e&&!t){this.$changes|=e;return}if(this.$size.$dirty)return this.$changes|=e,this.onResize(!0);this.lineHeight||this.$textLayer.checkForSizeChanges(),this._signal("beforeRender");var n=this.layerConfig;if(e&this.CHANGE_FULL||e&this.CHANGE_SIZE||e&this.CHANGE_TEXT||e&this.CHANGE_LINES||e&this.CHANGE_SCROLL||e&this.CHANGE_H_SCROLL){e|=this.$computeLayerConfig();if(n.firstRow!=this.layerConfig.firstRow&&n.firstRowScreen==this.layerConfig.firstRowScreen){var r=this.scrollTop+(n.firstRow-this.layerConfig.firstRow)*this.lineHeight;r>0&&(this.scrollTop=r,e|=this.CHANGE_SCROLL,e|=this.$computeLayerConfig())}n=this.layerConfig,this.$updateScrollBarV(),e&this.CHANGE_H_SCROLL&&this.$updateScrollBarH(),this.$gutterLayer.element.style.marginTop=-n.offset+"px",this.content.style.marginTop=-n.offset+"px",this.content.style.width=n.width+2*this.$padding+"px",this.content.style.height=n.minHeight+"px"}e&this.CHANGE_H_SCROLL&&(this.content.style.marginLeft=-this.scrollLeft+"px",this.scroller.className=this.scrollLeft<=0?"ace_scroller":"ace_scroller ace_scroll-left");if(e&this.CHANGE_FULL){this.$textLayer.update(n),this.$showGutter&&this.$gutterLayer.update(n),this.$markerBack.update(n),this.$markerFront.update(n),this.$cursorLayer.update(n),this.$moveTextAreaToCursor(),this.$highlightGutterLine&&this.$updateGutterLineHighlight(),this._signal("afterRender");return}if(e&this.CHANGE_SCROLL){e&this.CHANGE_TEXT||e&this.CHANGE_LINES?this.$textLayer.update(n):this.$textLayer.scrollLines(n),this.$showGutter&&this.$gutterLayer.update(n),this.$markerBack.update(n),this.$markerFront.update(n),this.$cursorLayer.update(n),this.$highlightGutterLine&&this.$updateGutterLineHighlight(),this.$moveTextAreaToCursor(),this._signal("afterRender");return}e&this.CHANGE_TEXT?(this.$textLayer.update(n),this.$showGutter&&this.$gutterLayer.update(n)):e&this.CHANGE_LINES?(this.$updateLines()||e&this.CHANGE_GUTTER&&this.$showGutter)&&this.$gutterLayer.update(n):(e&this.CHANGE_TEXT||e&this.CHANGE_GUTTER)&&this.$showGutter&&this.$gutterLayer.update(n),e&this.CHANGE_CURSOR&&(this.$cursorLayer.update(n),this.$moveTextAreaToCursor(),this.$highlightGutterLine&&this.$updateGutterLineHighlight()),e&(this.CHANGE_MARKER|this.CHANGE_MARKER_FRONT)&&this.$markerFront.update(n),e&(this.CHANGE_MARKER|this.CHANGE_MARKER_BACK)&&this.$markerBack.update(n),this._signal("afterRender")},this.$autosize=function(){var e=this.session.getScreenLength()*this.lineHeight,t=this.$maxLines*this.lineHeight,n=Math.min(t,Math.max((this.$minLines||1)*this.lineHeight,e))+this.scrollMargin.v+(this.$extraHeight||0);this.$horizScroll&&(n+=this.scrollBarH.getHeight()),this.$maxPixelHeight&&n>this.$maxPixelHeight&&(n=this.$maxPixelHeight);var r=e>t;if(n!=this.desiredHeight||this.$size.height!=this.desiredHeight||r!=this.$vScroll){r!=this.$vScroll&&(this.$vScroll=r,this.scrollBarV.setVisible(r));var i=this.container.clientWidth;this.container.style.height=n+"px",this.$updateCachedSize(!0,this.$gutterWidth,i,n),this.desiredHeight=n,this._signal("autosize")}},this.$computeLayerConfig=function(){var e=this.session,t=this.$size,n=t.height<=2*this.lineHeight,r=this.session.getScreenLength(),i=r*this.lineHeight,s=this.$getLongestLine(),o=!n&&(this.$hScrollBarAlwaysVisible||t.scrollerWidth-s-2*this.$padding<0),u=this.$horizScroll!==o;u&&(this.$horizScroll=o,this.scrollBarH.setVisible(o));var a=this.$vScroll;this.$maxLines&&this.lineHeight>1&&this.$autosize();var f=this.scrollTop%this.lineHeight,l=t.scrollerHeight+this.lineHeight,c=!this.$maxLines&&this.$scrollPastEnd?(t.scrollerHeight-this.lineHeight)*this.$scrollPastEnd:0;i+=c;var h=this.scrollMargin;this.session.setScrollTop(Math.max(-h.top,Math.min(this.scrollTop,i-t.scrollerHeight+h.bottom))),this.session.setScrollLeft(Math.max(-h.left,Math.min(this.scrollLeft,s+2*this.$padding-t.scrollerWidth+h.right)));var p=!n&&(this.$vScrollBarAlwaysVisible||t.scrollerHeight-i+c<0||this.scrollTop>h.top),d=a!==p;d&&(this.$vScroll=p,this.scrollBarV.setVisible(p));var v=Math.ceil(l/this.lineHeight)-1,m=Math.max(0,Math.round((this.scrollTop-f)/this.lineHeight)),g=m+v,y,b,w=this.lineHeight;m=e.screenToDocumentRow(m,0);var E=e.getFoldLine(m);E&&(m=E.start.row),y=e.documentToScreenRow(m,0),b=e.getRowLength(m)*w,g=Math.min(e.screenToDocumentRow(g,0),e.getLength()-1),l=t.scrollerHeight+e.getRowLength(g)*w+b,f=this.scrollTop-y*w;var S=0;this.layerConfig.width!=s&&(S=this.CHANGE_H_SCROLL);if(u||d)S=this.$updateCachedSize(!0,this.gutterWidth,t.width,t.height),this._signal("scrollbarVisibilityChanged"),d&&(s=this.$getLongestLine());return this.layerConfig={width:s,padding:this.$padding,firstRow:m,firstRowScreen:y,lastRow:g,lineHeight:w,characterWidth:this.characterWidth,minHeight:l,maxHeight:i,offset:f,gutterOffset:w?Math.max(0,Math.ceil((f+t.height-t.scrollerHeight)/w)):0,height:this.$size.scrollerHeight},S},this.$updateLines=function(){var e=this.$changedLines.firstRow,t=this.$changedLines.lastRow;this.$changedLines=null;var n=this.layerConfig;if(e>n.lastRow+1)return;if(t<n.firstRow)return;if(t===Infinity){this.$showGutter&&this.$gutterLayer.update(n),this.$textLayer.update(n);return}return this.$textLayer.updateLines(n,e,t),!0},this.$getLongestLine=function(){var e=this.session.getScreenWidth();return this.showInvisibles&&!this.session.$useWrapMode&&(e+=1),Math.max(this.$size.scrollerWidth-2*this.$padding,Math.round(e*this.characterWidth))},this.updateFrontMarkers=function(){this.$markerFront.setMarkers(this.session.getMarkers(!0)),this.$loop.schedule(this.CHANGE_MARKER_FRONT)},this.updateBackMarkers=function(){this.$markerBack.setMarkers(this.session.getMarkers()),this.$loop.schedule(this.CHANGE_MARKER_BACK)},this.addGutterDecoration=function(e,t){this.$gutterLayer.addGutterDecoration(e,t)},this.removeGutterDecoration=function(e,t){this.$gutterLayer.removeGutterDecoration(e,t)},this.updateBreakpoints=function(e){this.$loop.schedule(this.CHANGE_GUTTER)},this.setAnnotations=function(e){this.$gutterLayer.setAnnotations(e),this.$loop.schedule(this.CHANGE_GUTTER)},this.updateCursor=function(){this.$loop.schedule(this.CHANGE_CURSOR)},this.hideCursor=function(){this.$cursorLayer.hideCursor()},this.showCursor=function(){this.$cursorLayer.showCursor()},this.scrollSelectionIntoView=function(e,t,n){this.scrollCursorIntoView(e,n),this.scrollCursorIntoView(t,n)},this.scrollCursorIntoView=function(e,t,n){if(this.$size.scrollerHeight===0)return;var r=this.$cursorLayer.getPixelPosition(e),i=r.left,s=r.top,o=n&&n.top||0,u=n&&n.bottom||0,a=this.$scrollAnimation?this.session.getScrollTop():this.scrollTop;a+o>s?(t&&a+o>s+this.lineHeight&&(s-=t*this.$size.scrollerHeight),s===0&&(s=-this.scrollMargin.top),this.session.setScrollTop(s)):a+this.$size.scrollerHeight-u<s+this.lineHeight&&(t&&a+this.$size.scrollerHeight-u<s-this.lineHeight&&(s+=t*this.$size.scrollerHeight),this.session.setScrollTop(s+this.lineHeight-this.$size.scrollerHeight));var f=this.scrollLeft;f>i?(i<this.$padding+2*this.layerConfig.characterWidth&&(i=-this.scrollMargin.left),this.session.setScrollLeft(i)):f+this.$size.scrollerWidth<i+this.characterWidth?this.session.setScrollLeft(Math.round(i+this.characterWidth-this.$size.scrollerWidth)):f<=this.$padding&&i-f<this.characterWidth&&this.session.setScrollLeft(0)},this.getScrollTop=function(){return this.session.getScrollTop()},this.getScrollLeft=function(){return this.session.getScrollLeft()},this.getScrollTopRow=function(){return this.scrollTop/this.lineHeight},this.getScrollBottomRow=function(){return Math.max(0,Math.floor((this.scrollTop+this.$size.scrollerHeight)/this.lineHeight)-1)},this.scrollToRow=function(e){this.session.setScrollTop(e*this.lineHeight)},this.alignCursor=function(e,t){typeof e=="number"&&(e={row:e,column:0});var n=this.$cursorLayer.getPixelPosition(e),r=this.$size.scrollerHeight-this.lineHeight,i=n.top-r*(t||0);return this.session.setScrollTop(i),i},this.STEPS=8,this.$calcSteps=function(e,t){var n=0,r=this.STEPS,i=[],s=function(e,t,n){return n*(Math.pow(e-1,3)+1)+t};for(n=0;n<r;++n)i.push(s(n/this.STEPS,e,t-e));return i},this.scrollToLine=function(e,t,n,r){var i=this.$cursorLayer.getPixelPosition({row:e,column:0}),s=i.top;t&&(s-=this.$size.scrollerHeight/2);var o=this.scrollTop;this.session.setScrollTop(s),n!==!1&&this.animateScrolling(o,r)},this.animateScrolling=function(e,t){var n=this.scrollTop;if(!this.$animatedScroll)return;var r=this;if(e==n)return;if(this.$scrollAnimation){var i=this.$scrollAnimation.steps;if(i.length){e=i[0];if(e==n)return}}var s=r.$calcSteps(e,n);this.$scrollAnimation={from:e,to:n,steps:s},clearInterval(this.$timer),r.session.setScrollTop(s.shift()),r.session.$scrollTop=n,this.$timer=setInterval(function(){s.length?(r.session.setScrollTop(s.shift()),r.session.$scrollTop=n):n!=null?(r.session.$scrollTop=-1,r.session.setScrollTop(n),n=null):(r.$timer=clearInterval(r.$timer),r.$scrollAnimation=null,t&&t())},10)},this.scrollToY=function(e){this.scrollTop!==e&&(this.$loop.schedule(this.CHANGE_SCROLL),this.scrollTop=e)},this.scrollToX=function(e){this.scrollLeft!==e&&(this.scrollLeft=e),this.$loop.schedule(this.CHANGE_H_SCROLL)},this.scrollTo=function(e,t){this.session.setScrollTop(t),this.session.setScrollLeft(t)},this.scrollBy=function(e,t){t&&this.session.setScrollTop(this.session.getScrollTop()+t),e&&this.session.setScrollLeft(this.session.getScrollLeft()+e)},this.isScrollableBy=function(e,t){if(t<0&&this.session.getScrollTop()>=1-this.scrollMargin.top)return!0;if(t>0&&this.session.getScrollTop()+this.$size.scrollerHeight-this.layerConfig.maxHeight<-1+this.scrollMargin.bottom)return!0;if(e<0&&this.session.getScrollLeft()>=1-this.scrollMargin.left)return!0;if(e>0&&this.session.getScrollLeft()+this.$size.scrollerWidth-this.layerConfig.width<-1+this.scrollMargin.right)return!0},this.pixelToScreenCoordinates=function(e,t){var n=this.scroller.getBoundingClientRect(),r=(e+this.scrollLeft-n.left-this.$padding)/this.characterWidth,i=Math.floor((t+this.scrollTop-n.top)/this.lineHeight),s=Math.round(r);return{row:i,column:s,side:r-s>0?1:-1}},this.screenToTextCoordinates=function(e,t){var n=this.scroller.getBoundingClientRect(),r=Math.round((e+this.scrollLeft-n.left-this.$padding)/this.characterWidth),i=(t+this.scrollTop-n.top)/this.lineHeight;return this.session.screenToDocumentPosition(i,Math.max(r,0))},this.textToScreenCoordinates=function(e,t){var n=this.scroller.getBoundingClientRect(),r=this.session.documentToScreenPosition(e,t),i=this.$padding+Math.round(r.column*this.characterWidth),s=r.row*this.lineHeight;return{pageX:n.left+i-this.scrollLeft,pageY:n.top+s-this.scrollTop}},this.visualizeFocus=function(){i.addCssClass(this.container,"ace_focus")},this.visualizeBlur=function(){i.removeCssClass(this.container,"ace_focus")},this.showComposition=function(e){this.$composition||(this.$composition={keepTextAreaAtCursor:this.$keepTextAreaAtCursor,cssText:this.textarea.style.cssText}),this.$keepTextAreaAtCursor=!0,i.addCssClass(this.textarea,"ace_composition"),this.textarea.style.cssText="",this.$moveTextAreaToCursor()},this.setCompositionText=function(e){this.$moveTextAreaToCursor()},this.hideComposition=function(){if(!this.$composition)return;i.removeCssClass(this.textarea,"ace_composition"),this.$keepTextAreaAtCursor=this.$composition.keepTextAreaAtCursor,this.textarea.style.cssText=this.$composition.cssText,this.$composition=null},this.setTheme=function(e,t){function o(r){if(n.$themeId!=e)return t&&t();if(!r||!r.cssClass)throw new Error("couldn't load module "+e+" or it didn't call define");i.importCssString(r.cssText,r.cssClass,n.container.ownerDocument),n.theme&&i.removeCssClass(n.container,n.theme.cssClass);var s="padding"in r?r.padding:"padding"in(n.theme||{})?4:n.$padding;n.$padding&&s!=n.$padding&&n.setPadding(s),n.$theme=r.cssClass,n.theme=r,i.addCssClass(n.container,r.cssClass),i.setCssClass(n.container,"ace_dark",r.isDark),n.$size&&(n.$size.width=0,n.$updateSizeAsync()),n._dispatchEvent("themeLoaded",{theme:r}),t&&t()}var n=this;this.$themeId=e,n._dispatchEvent("themeChange",{theme:e});if(!e||typeof e=="string"){var r=e||this.$options.theme.initialValue;s.loadModule(["theme",r],o)}else o(e)},this.getTheme=function(){return this.$themeId},this.setStyle=function(e,t){i.setCssClass(this.container,e,t!==!1)},this.unsetStyle=function(e){i.removeCssClass(this.container,e)},this.setCursorStyle=function(e){this.scroller.style.cursor!=e&&(this.scroller.style.cursor=e)},this.setMouseCursor=function(e){this.scroller.style.cursor=e},this.destroy=function(){this.$textLayer.destroy(),this.$cursorLayer.destroy()}}).call(g.prototype),s.defineOptions(g.prototype,"renderer",{animatedScroll:{initialValue:!1},showInvisibles:{set:function(e){this.$textLayer.setShowInvisibles(e)&&this.$loop.schedule(this.CHANGE_TEXT)},initialValue:!1},showPrintMargin:{set:function(){this.$updatePrintMargin()},initialValue:!0},printMarginColumn:{set:function(){this.$updatePrintMargin()},initialValue:80},printMargin:{set:function(e){typeof e=="number"&&(this.$printMarginColumn=e),this.$showPrintMargin=!!e,this.$updatePrintMargin()},get:function(){return this.$showPrintMargin&&this.$printMarginColumn}},showGutter:{set:function(e){this.$gutter.style.display=e?"block":"none",this.$loop.schedule(this.CHANGE_FULL),this.onGutterResize()},initialValue:!0},fadeFoldWidgets:{set:function(e){i.setCssClass(this.$gutter,"ace_fade-fold-widgets",e)},initialValue:!1},showFoldWidgets:{set:function(e){this.$gutterLayer.setShowFoldWidgets(e)},initialValue:!0},showLineNumbers:{set:function(e){this.$gutterLayer.setShowLineNumbers(e),this.$loop.schedule(this.CHANGE_GUTTER)},initialValue:!0},displayIndentGuides:{set:function(e){this.$textLayer.setDisplayIndentGuides(e)&&this.$loop.schedule(this.CHANGE_TEXT)},initialValue:!0},highlightGutterLine:{set:function(e){if(!this.$gutterLineHighlight){this.$gutterLineHighlight=i.createElement("div"),this.$gutterLineHighlight.className="ace_gutter-active-line",this.$gutter.appendChild(this.$gutterLineHighlight);return}this.$gutterLineHighlight.style.display=e?"":"none",this.$cursorLayer.$pixelPos&&this.$updateGutterLineHighlight()},initialValue:!1,value:!0},hScrollBarAlwaysVisible:{set:function(e){(!this.$hScrollBarAlwaysVisible||!this.$horizScroll)&&this.$loop.schedule(this.CHANGE_SCROLL)},initialValue:!1},vScrollBarAlwaysVisible:{set:function(e){(!this.$vScrollBarAlwaysVisible||!this.$vScroll)&&this.$loop.schedule(this.CHANGE_SCROLL)},initialValue:!1},fontSize:{set:function(e){typeof e=="number"&&(e+="px"),this.container.style.fontSize=e,this.updateFontSize()},initialValue:12},fontFamily:{set:function(e){this.container.style.fontFamily=e,this.updateFontSize()}},maxLines:{set:function(e){this.updateFull()}},minLines:{set:function(e){this.updateFull()}},maxPixelHeight:{set:function(e){this.updateFull()},initialValue:0},scrollPastEnd:{set:function(e){e=+e||0;if(this.$scrollPastEnd==e)return;this.$scrollPastEnd=e,this.$loop.schedule(this.CHANGE_SCROLL)},initialValue:0,handlesSet:!0},fixedWidthGutter:{set:function(e){this.$gutterLayer.$fixedWidth=!!e,this.$loop.schedule(this.CHANGE_GUTTER)}},theme:{set:function(e){this.setTheme(e)},get:function(){return this.$themeId||this.theme},initialValue:"./theme/textmate",handlesSet:!0}}),t.VirtualRenderer=g}),ace.define("ace/worker/worker_client",["require","exports","module","ace/lib/oop","ace/lib/net","ace/lib/event_emitter","ace/config"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("../lib/net"),s=e("../lib/event_emitter").EventEmitter,o=e("../config"),u=function(t,n,r,i){this.$sendDeltaQueue=this.$sendDeltaQueue.bind(this),this.changeListener=this.changeListener.bind(this),this.onMessage=this.onMessage.bind(this),e.nameToUrl&&!e.toUrl&&(e.toUrl=e.nameToUrl);if(o.get("packaged")||!e.toUrl)i=i||o.moduleUrl(n,"worker");else{var s=this.$normalizePath;i=i||s(e.toUrl("ace/worker/worker.js",null,"_"));var u={};t.forEach(function(t){u[t]=s(e.toUrl(t,null,"_").replace(/(\.js)?(\?.*)?$/,""))})}try{this.$worker=new Worker(i)}catch(a){if(!(a instanceof window.DOMException))throw a;var f=this.$workerBlob(i),l=window.URL||window.webkitURL,c=l.createObjectURL(f);this.$worker=new Worker(c),l.revokeObjectURL(c)}this.$worker.postMessage({init:!0,tlns:u,module:n,classname:r}),this.callbackId=1,this.callbacks={},this.$worker.onmessage=this.onMessage};(function(){r.implement(this,s),this.onMessage=function(e){var t=e.data;switch(t.type){case"event":this._signal(t.name,{data:t.data});break;case"call":var n=this.callbacks[t.id];n&&(n(t.data),delete this.callbacks[t.id]);break;case"error":this.reportError(t.data);break;case"log":window.console&&console.log&&console.log.apply(console,t.data)}},this.reportError=function(e){window.console&&console.error&&console.error(e)},this.$normalizePath=function(e){return i.qualifyURL(e)},this.terminate=function(){this._signal("terminate",{}),this.deltaQueue=null,this.$worker.terminate(),this.$worker=null,this.$doc&&this.$doc.off("change",this.changeListener),this.$doc=null},this.send=function(e,t){this.$worker.postMessage({command:e,args:t})},this.call=function(e,t,n){if(n){var r=this.callbackId++;this.callbacks[r]=n,t.push(r)}this.send(e,t)},this.emit=function(e,t){try{this.$worker.postMessage({event:e,data:{data:t.data}})}catch(n){console.error(n.stack)}},this.attachToDocument=function(e){this.$doc&&this.terminate(),this.$doc=e,this.call("setValue",[e.getValue()]),e.on("change",this.changeListener)},this.changeListener=function(e){this.deltaQueue||(this.deltaQueue=[],setTimeout(this.$sendDeltaQueue,0)),e.action=="insert"?this.deltaQueue.push(e.start,e.lines):this.deltaQueue.push(e.start,e.end)},this.$sendDeltaQueue=function(){var e=this.deltaQueue;if(!e)return;this.deltaQueue=null,e.length>50&&e.length>this.$doc.getLength()>>1?this.call("setValue",[this.$doc.getValue()]):this.emit("change",{data:e})},this.$workerBlob=function(e){var t="importScripts('"+i.qualifyURL(e)+"');";try{return new Blob([t],{type:"application/javascript"})}catch(n){var r=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder,s=new r;return s.append(t),s.getBlob("application/javascript")}}}).call(u.prototype);var a=function(e,t,n){this.$sendDeltaQueue=this.$sendDeltaQueue.bind(this),this.changeListener=this.changeListener.bind(this),this.callbackId=1,this.callbacks={},this.messageBuffer=[];var r=null,i=!1,u=Object.create(s),a=this;this.$worker={},this.$worker.terminate=function(){},this.$worker.postMessage=function(e){a.messageBuffer.push(e),r&&(i?setTimeout(f):f())},this.setEmitSync=function(e){i=e};var f=function(){var e=a.messageBuffer.shift();e.command?r[e.command].apply(r,e.args):e.event&&u._signal(e.event,e.data)};u.postMessage=function(e){a.onMessage({data:e})},u.callback=function(e,t){this.postMessage({type:"call",id:t,data:e})},u.emit=function(e,t){this.postMessage({type:"event",name:e,data:t})},o.loadModule(["worker",t],function(e){r=new e[n](u);while(a.messageBuffer.length)f()})};a.prototype=u.prototype,t.UIWorkerClient=a,t.WorkerClient=u}),ace.define("ace/placeholder",["require","exports","module","ace/range","ace/lib/event_emitter","ace/lib/oop"],function(e,t,n){"use strict";var r=e("./range").Range,i=e("./lib/event_emitter").EventEmitter,s=e("./lib/oop"),o=function(e,t,n,r,i,s){var o=this;this.length=t,this.session=e,this.doc=e.getDocument(),this.mainClass=i,this.othersClass=s,this.$onUpdate=this.onUpdate.bind(this),this.doc.on("change",this.$onUpdate),this.$others=r,this.$onCursorChange=function(){setTimeout(function(){o.onCursorChange()})},this.$pos=n;var u=e.getUndoManager().$undoStack||e.getUndoManager().$undostack||{length:-1};this.$undoStackDepth=u.length,this.setup(),e.selection.on("changeCursor",this.$onCursorChange)};(function(){s.implement(this,i),this.setup=function(){var e=this,t=this.doc,n=this.session;this.selectionBefore=n.selection.toJSON(),n.selection.inMultiSelectMode&&n.selection.toSingleRange(),this.pos=t.createAnchor(this.$pos.row,this.$pos.column);var i=this.pos;i.$insertRight=!0,i.detach(),i.markerId=n.addMarker(new r(i.row,i.column,i.row,i.column+this.length),this.mainClass,null,!1),this.others=[],this.$others.forEach(function(n){var r=t.createAnchor(n.row,n.column);r.$insertRight=!0,r.detach(),e.others.push(r)}),n.setUndoSelect(!1)},this.showOtherMarkers=function(){if(this.othersActive)return;var e=this.session,t=this;this.othersActive=!0,this.others.forEach(function(n){n.markerId=e.addMarker(new r(n.row,n.column,n.row,n.column+t.length),t.othersClass,null,!1)})},this.hideOtherMarkers=function(){if(!this.othersActive)return;this.othersActive=!1;for(var e=0;e<this.others.length;e++)this.session.removeMarker(this.others[e].markerId)},this.onUpdate=function(e){if(this.$updating)return this.updateAnchors(e);var t=e;if(t.start.row!==t.end.row)return;if(t.start.row!==this.pos.row)return;this.$updating=!0;var n=e.action==="insert"?t.end.column-t.start.column:t.start.column-t.end.column,i=t.start.column>=this.pos.column&&t.start.column<=this.pos.column+this.length+1,s=t.start.column-this.pos.column;this.updateAnchors(e),i&&(this.length+=n);if(i&&!this.session.$fromUndo)if(e.action==="insert")for(var o=this.others.length-1;o>=0;o--){var u=this.others[o],a={row:u.row,column:u.column+s};this.doc.insertMergedLines(a,e.lines)}else if(e.action==="remove")for(var o=this.others.length-1;o>=0;o--){var u=this.others[o],a={row:u.row,column:u.column+s};this.doc.remove(new r(a.row,a.column,a.row,a.column-n))}this.$updating=!1,this.updateMarkers()},this.updateAnchors=function(e){this.pos.onChange(e);for(var t=this.others.length;t--;)this.others[t].onChange(e);this.updateMarkers()},this.updateMarkers=function(){if(this.$updating)return;var e=this,t=this.session,n=function(n,i){t.removeMarker(n.markerId),n.markerId=t.addMarker(new r(n.row,n.column,n.row,n.column+e.length),i,null,!1)};n(this.pos,this.mainClass);for(var i=this.others.length;i--;)n(this.others[i],this.othersClass)},this.onCursorChange=function(e){if(this.$updating||!this.session)return;var t=this.session.selection.getCursor();t.row===this.pos.row&&t.column>=this.pos.column&&t.column<=this.pos.column+this.length?(this.showOtherMarkers(),this._emit("cursorEnter",e)):(this.hideOtherMarkers(),this._emit("cursorLeave",e))},this.detach=function(){this.session.removeMarker(this.pos&&this.pos.markerId),this.hideOtherMarkers(),this.doc.removeEventListener("change",this.$onUpdate),this.session.selection.removeEventListener("changeCursor",this.$onCursorChange),this.session.setUndoSelect(!0),this.session=null},this.cancel=function(){if(this.$undoStackDepth===-1)return;var e=this.session.getUndoManager(),t=(e.$undoStack||e.$undostack).length-this.$undoStackDepth;for(var n=0;n<t;n++)e.undo(!0);this.selectionBefore&&this.session.selection.fromJSON(this.selectionBefore)}}).call(o.prototype),t.PlaceHolder=o}),ace.define("ace/mouse/multi_select_handler",["require","exports","module","ace/lib/event","ace/lib/useragent"],function(e,t,n){function s(e,t){return e.row==t.row&&e.column==t.column}function o(e){var t=e.domEvent,n=t.altKey,o=t.shiftKey,u=t.ctrlKey,a=e.getAccelKey(),f=e.getButton();u&&i.isMac&&(f=t.button);if(e.editor.inMultiSelectMode&&f==2){e.editor.textInput.onContextMenu(e.domEvent);return}if(!u&&!n&&!a){f===0&&e.editor.inMultiSelectMode&&e.editor.exitMultiSelectMode();return}if(f!==0)return;var l=e.editor,c=l.selection,h=l.inMultiSelectMode,p=e.getDocumentPosition(),d=c.getCursor(),v=e.inSelection()||c.isEmpty()&&s(p,d),m=e.x,g=e.y,y=function(e){m=e.clientX,g=e.clientY},b=l.session,w=l.renderer.pixelToScreenCoordinates(m,g),E=w,S;if(l.$mouseHandler.$enableJumpToDef)u&&n||a&&n?S=o?"block":"add":n&&l.$blockSelectEnabled&&(S="block");else if(a&&!n){S="add";if(!h&&o)return}else n&&l.$blockSelectEnabled&&(S="block");S&&i.isMac&&t.ctrlKey&&l.$mouseHandler.cancelContextMenu();if(S=="add"){if(!h&&v)return;if(!h){var x=c.toOrientedRange();l.addSelectionMarker(x)}var T=c.rangeList.rangeAtPoint(p);l.$blockScrolling++,l.inVirtualSelectionMode=!0,o&&(T=null,x=c.ranges[0]||x,l.removeSelectionMarker(x)),l.once("mouseup",function(){var e=c.toOrientedRange();T&&e.isEmpty()&&s(T.cursor,e.cursor)?c.substractPoint(e.cursor):(o?c.substractPoint(x.cursor):x&&(l.removeSelectionMarker(x),c.addRange(x)),c.addRange(e)),l.$blockScrolling--,l.inVirtualSelectionMode=!1})}else if(S=="block"){e.stop(),l.inVirtualSelectionMode=!0;var N,C=[],k=function(){var e=l.renderer.pixelToScreenCoordinates(m,g),t=b.screenToDocumentPosition(e.row,e.column);if(s(E,e)&&s(t,c.lead))return;E=e,l.$blockScrolling++,l.selection.moveToPosition(t),l.renderer.scrollCursorIntoView(),l.removeSelectionMarkers(C),C=c.rectangularRangeBlock(E,w),l.$mouseHandler.$clickSelection&&C.length==1&&C[0].isEmpty()&&(C[0]=l.$mouseHandler.$clickSelection.clone()),C.forEach(l.addSelectionMarker,l),l.updateSelectionMarkers(),l.$blockScrolling--};l.$blockScrolling++,h&&!a?c.toSingleRange():!h&&a&&(N=c.toOrientedRange(),l.addSelectionMarker(N)),o?w=b.documentToScreenPosition(c.lead):c.moveToPosition(p),l.$blockScrolling--,E={row:-1,column:-1};var L=function(e){clearInterval(O),l.removeSelectionMarkers(C),C.length||(C=[c.toOrientedRange()]),l.$blockScrolling++,N&&(l.removeSelectionMarker(N),c.toSingleRange(N));for(var t=0;t<C.length;t++)c.addRange(C[t]);l.inVirtualSelectionMode=!1,l.$mouseHandler.$clickSelection=null,l.$blockScrolling--},A=k;r.capture(l.container,y,L);var O=setInterval(function(){A()},20);return e.preventDefault()}}var r=e("../lib/event"),i=e("../lib/useragent");t.onMouseDown=o}),ace.define("ace/commands/multi_select_commands",["require","exports","module","ace/keyboard/hash_handler"],function(e,t,n){t.defaultCommands=[{name:"addCursorAbove",exec:function(e){e.selectMoreLines(-1)},bindKey:{win:"Ctrl-Alt-Up",mac:"Ctrl-Alt-Up"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorBelow",exec:function(e){e.selectMoreLines(1)},bindKey:{win:"Ctrl-Alt-Down",mac:"Ctrl-Alt-Down"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorAboveSkipCurrent",exec:function(e){e.selectMoreLines(-1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Up",mac:"Ctrl-Alt-Shift-Up"},scrollIntoView:"cursor",readOnly:!0},{name:"addCursorBelowSkipCurrent",exec:function(e){e.selectMoreLines(1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Down",mac:"Ctrl-Alt-Shift-Down"},scrollIntoView:"cursor",readOnly:!0},{name:"selectMoreBefore",exec:function(e){e.selectMore(-1)},bindKey:{win:"Ctrl-Alt-Left",mac:"Ctrl-Alt-Left"},scrollIntoView:"cursor",readOnly:!0},{name:"selectMoreAfter",exec:function(e){e.selectMore(1)},bindKey:{win:"Ctrl-Alt-Right",mac:"Ctrl-Alt-Right"},scrollIntoView:"cursor",readOnly:!0},{name:"selectNextBefore",exec:function(e){e.selectMore(-1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Left",mac:"Ctrl-Alt-Shift-Left"},scrollIntoView:"cursor",readOnly:!0},{name:"selectNextAfter",exec:function(e){e.selectMore(1,!0)},bindKey:{win:"Ctrl-Alt-Shift-Right",mac:"Ctrl-Alt-Shift-Right"},scrollIntoView:"cursor",readOnly:!0},{name:"splitIntoLines",exec:function(e){e.multiSelect.splitIntoLines()},bindKey:{win:"Ctrl-Alt-L",mac:"Ctrl-Alt-L"},readOnly:!0},{name:"alignCursors",exec:function(e){e.alignCursors()},bindKey:{win:"Ctrl-Alt-A",mac:"Ctrl-Alt-A"},scrollIntoView:"cursor"},{name:"findAll",exec:function(e){e.findAll()},bindKey:{win:"Ctrl-Alt-K",mac:"Ctrl-Alt-G"},scrollIntoView:"cursor",readOnly:!0}],t.multiSelectCommands=[{name:"singleSelection",bindKey:"esc",exec:function(e){e.exitMultiSelectMode()},scrollIntoView:"cursor",readOnly:!0,isAvailable:function(e){return e&&e.inMultiSelectMode}}];var r=e("../keyboard/hash_handler").HashHandler;t.keyboardHandler=new r(t.multiSelectCommands)}),ace.define("ace/multi_select",["require","exports","module","ace/range_list","ace/range","ace/selection","ace/mouse/multi_select_handler","ace/lib/event","ace/lib/lang","ace/commands/multi_select_commands","ace/search","ace/edit_session","ace/editor","ace/config"],function(e,t,n){function h(e,t,n){return c.$options.wrap=!0,c.$options.needle=t,c.$options.backwards=n==-1,c.find(e)}function v(e,t){return e.row==t.row&&e.column==t.column}function m(e){if(e.$multiselectOnSessionChange)return;e.$onAddRange=e.$onAddRange.bind(e),e.$onRemoveRange=e.$onRemoveRange.bind(e),e.$onMultiSelect=e.$onMultiSelect.bind(e),e.$onSingleSelect=e.$onSingleSelect.bind(e),e.$multiselectOnSessionChange=t.onSessionChange.bind(e),e.$checkMultiselectChange=e.$checkMultiselectChange.bind(e),e.$multiselectOnSessionChange(e),e.on("changeSession",e.$multiselectOnSessionChange),e.on("mousedown",o),e.commands.addCommands(f.defaultCommands),g(e)}function g(e){function r(t){n&&(e.renderer.setMouseCursor(""),n=!1)}var t=e.textInput.getElement(),n=!1;u.addListener(t,"keydown",function(t){var i=t.keyCode==18&&!(t.ctrlKey||t.shiftKey||t.metaKey);e.$blockSelectEnabled&&i?n||(e.renderer.setMouseCursor("crosshair"),n=!0):n&&r()}),u.addListener(t,"keyup",r),u.addListener(t,"blur",r)}var r=e("./range_list").RangeList,i=e("./range").Range,s=e("./selection").Selection,o=e("./mouse/multi_select_handler").onMouseDown,u=e("./lib/event"),a=e("./lib/lang"),f=e("./commands/multi_select_commands");t.commands=f.defaultCommands.concat(f.multiSelectCommands);var l=e("./search").Search,c=new l,p=e("./edit_session").EditSession;(function(){this.getSelectionMarkers=function(){return this.$selectionMarkers}}).call(p.prototype),function(){this.ranges=null,this.rangeList=null,this.addRange=function(e,t){if(!e)return;if(!this.inMultiSelectMode&&this.rangeCount===0){var n=this.toOrientedRange();this.rangeList.add(n),this.rangeList.add(e);if(this.rangeList.ranges.length!=2)return this.rangeList.removeAll(),t||this.fromOrientedRange(e);this.rangeList.removeAll(),this.rangeList.add(n),this.$onAddRange(n)}e.cursor||(e.cursor=e.end);var r=this.rangeList.add(e);return this.$onAddRange(e),r.length&&this.$onRemoveRange(r),this.rangeCount>1&&!this.inMultiSelectMode&&(this._signal("multiSelect"),this.inMultiSelectMode=!0,this.session.$undoSelect=!1,this.rangeList.attach(this.session)),t||this.fromOrientedRange(e)},this.toSingleRange=function(e){e=e||this.ranges[0];var t=this.rangeList.removeAll();t.length&&this.$onRemoveRange(t),e&&this.fromOrientedRange(e)},this.substractPoint=function(e){var t=this.rangeList.substractPoint(e);if(t)return this.$onRemoveRange(t),t[0]},this.mergeOverlappingRanges=function(){var e=this.rangeList.merge();e.length?this.$onRemoveRange(e):this.ranges[0]&&this.fromOrientedRange(this.ranges[0])},this.$onAddRange=function(e){this.rangeCount=this.rangeList.ranges.length,this.ranges.unshift(e),this._signal("addRange",{range:e})},this.$onRemoveRange=function(e){this.rangeCount=this.rangeList.ranges.length;if(this.rangeCount==1&&this.inMultiSelectMode){var t=this.rangeList.ranges.pop();e.push(t),this.rangeCount=0}for(var n=e.length;n--;){var r=this.ranges.indexOf(e[n]);this.ranges.splice(r,1)}this._signal("removeRange",{ranges:e}),this.rangeCount===0&&this.inMultiSelectMode&&(this.inMultiSelectMode=!1,this._signal("singleSelect"),this.session.$undoSelect=!0,this.rangeList.detach(this.session)),t=t||this.ranges[0],t&&!t.isEqual(this.getRange())&&this.fromOrientedRange(t)},this.$initRangeList=function(){if(this.rangeList)return;this.rangeList=new r,this.ranges=[],this.rangeCount=0},this.getAllRanges=function(){return this.rangeCount?this.rangeList.ranges.concat():[this.getRange()]},this.splitIntoLines=function(){if(this.rangeCount>1){var e=this.rangeList.ranges,t=e[e.length-1],n=i.fromPoints(e[0].start,t.end);this.toSingleRange(),this.setSelectionRange(n,t.cursor==t.start)}else{var n=this.getRange(),r=this.isBackwards(),s=n.start.row,o=n.end.row;if(s==o){if(r)var u=n.end,a=n.start;else var u=n.start,a=n.end;this.addRange(i.fromPoints(a,a)),this.addRange(i.fromPoints(u,u));return}var f=[],l=this.getLineRange(s,!0);l.start.column=n.start.column,f.push(l);for(var c=s+1;c<o;c++)f.push(this.getLineRange(c,!0));l=this.getLineRange(o,!0),l.end.column=n.end.column,f.push(l),f.forEach(this.addRange,this)}},this.toggleBlockSelection=function(){if(this.rangeCount>1){var e=this.rangeList.ranges,t=e[e.length-1],n=i.fromPoints(e[0].start,t.end);this.toSingleRange(),this.setSelectionRange(n,t.cursor==t.start)}else{var r=this.session.documentToScreenPosition(this.selectionLead),s=this.session.documentToScreenPosition(this.selectionAnchor),o=this.rectangularRangeBlock(r,s);o.forEach(this.addRange,this)}},this.rectangularRangeBlock=function(e,t,n){var r=[],s=e.column<t.column;if(s)var o=e.column,u=t.column;else var o=t.column,u=e.column;var a=e.row<t.row;if(a)var f=e.row,l=t.row;else var f=t.row,l=e.row;o<0&&(o=0),f<0&&(f=0),f==l&&(n=!0);for(var c=f;c<=l;c++){var h=i.fromPoints(this.session.screenToDocumentPosition(c,o),this.session.screenToDocumentPosition(c,u));if(h.isEmpty()){if(p&&v(h.end,p))break;var p=h.end}h.cursor=s?h.start:h.end,r.push(h)}a&&r.reverse();if(!n){var d=r.length-1;while(r[d].isEmpty()&&d>0)d--;if(d>0){var m=0;while(r[m].isEmpty())m++}for(var g=d;g>=m;g--)r[g].isEmpty()&&r.splice(g,1)}return r}}.call(s.prototype);var d=e("./editor").Editor;(function(){this.updateSelectionMarkers=function(){this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.addSelectionMarker=function(e){e.cursor||(e.cursor=e.end);var t=this.getSelectionStyle();return e.marker=this.session.addMarker(e,"ace_selection",t),this.session.$selectionMarkers.push(e),this.session.selectionMarkerCount=this.session.$selectionMarkers.length,e},this.removeSelectionMarker=function(e){if(!e.marker)return;this.session.removeMarker(e.marker);var t=this.session.$selectionMarkers.indexOf(e);t!=-1&&this.session.$selectionMarkers.splice(t,1),this.session.selectionMarkerCount=this.session.$selectionMarkers.length},this.removeSelectionMarkers=function(e){var t=this.session.$selectionMarkers;for(var n=e.length;n--;){var r=e[n];if(!r.marker)continue;this.session.removeMarker(r.marker);var i=t.indexOf(r);i!=-1&&t.splice(i,1)}this.session.selectionMarkerCount=t.length},this.$onAddRange=function(e){this.addSelectionMarker(e.range),this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.$onRemoveRange=function(e){this.removeSelectionMarkers(e.ranges),this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.$onMultiSelect=function(e){if(this.inMultiSelectMode)return;this.inMultiSelectMode=!0,this.setStyle("ace_multiselect"),this.keyBinding.addKeyboardHandler(f.keyboardHandler),this.commands.setDefaultHandler("exec",this.$onMultiSelectExec),this.renderer.updateCursor(),this.renderer.updateBackMarkers()},this.$onSingleSelect=function(e){if(this.session.multiSelect.inVirtualMode)return;this.inMultiSelectMode=!1,this.unsetStyle("ace_multiselect"),this.keyBinding.removeKeyboardHandler(f.keyboardHandler),this.commands.removeDefaultHandler("exec",this.$onMultiSelectExec),this.renderer.updateCursor(),this.renderer.updateBackMarkers(),this._emit("changeSelection")},this.$onMultiSelectExec=function(e){var t=e.command,n=e.editor;if(!n.multiSelect)return;if(!t.multiSelectAction){var r=t.exec(n,e.args||{});n.multiSelect.addRange(n.multiSelect.toOrientedRange()),n.multiSelect.mergeOverlappingRanges()}else t.multiSelectAction=="forEach"?r=n.forEachSelection(t,e.args):t.multiSelectAction=="forEachLine"?r=n.forEachSelection(t,e.args,!0):t.multiSelectAction=="single"?(n.exitMultiSelectMode(),r=t.exec(n,e.args||{})):r=t.multiSelectAction(n,e.args||{});return r},this.forEachSelection=function(e,t,n){if(this.inVirtualSelectionMode)return;var r=n&&n.keepOrder,i=n==1||n&&n.$byLines,o=this.session,u=this.selection,a=u.rangeList,f=(r?u:a).ranges,l;if(!f.length)return e.exec?e.exec(this,t||{}):e(this,t||{});var c=u._eventRegistry;u._eventRegistry={};var h=new s(o);this.inVirtualSelectionMode=!0;for(var p=f.length;p--;){if(i)while(p>0&&f[p].start.row==f[p-1].end.row)p--;h.fromOrientedRange(f[p]),h.index=p,this.selection=o.selection=h;var d=e.exec?e.exec(this,t||{}):e(this,t||{});!l&&d!==undefined&&(l=d),h.toOrientedRange(f[p])}h.detach(),this.selection=o.selection=u,this.inVirtualSelectionMode=!1,u._eventRegistry=c,u.mergeOverlappingRanges();var v=this.renderer.$scrollAnimation;return this.onCursorChange(),this.onSelectionChange(),v&&v.from==v.to&&this.renderer.animateScrolling(v.from),l},this.exitMultiSelectMode=function(){if(!this.inMultiSelectMode||this.inVirtualSelectionMode)return;this.multiSelect.toSingleRange()},this.getSelectedText=function(){var e="";if(this.inMultiSelectMode&&!this.inVirtualSelectionMode){var t=this.multiSelect.rangeList.ranges,n=[];for(var r=0;r<t.length;r++)n.push(this.session.getTextRange(t[r]));var i=this.session.getDocument().getNewLineCharacter();e=n.join(i),e.length==(n.length-1)*i.length&&(e="")}else this.selection.isEmpty()||(e=this.session.getTextRange(this.getSelectionRange()));return e},this.$checkMultiselectChange=function(e,t){if(this.inMultiSelectMode&&!this.inVirtualSelectionMode){var n=this.multiSelect.ranges[0];if(this.multiSelect.isEmpty()&&t==this.multiSelect.anchor)return;var r=t==this.multiSelect.anchor?n.cursor==n.start?n.end:n.start:n.cursor;(r.row!=t.row||this.session.$clipPositionToDocument(r.row,r.column).column!=t.column)&&this.multiSelect.toSingleRange(this.multiSelect.toOrientedRange())}},this.findAll=function(e,t,n){t=t||{},t.needle=e||t.needle;if(t.needle==undefined){var r=this.selection.isEmpty()?this.selection.getWordRange():this.selection.getRange();t.needle=this.session.getTextRange(r)}this.$search.set(t);var i=this.$search.findAll(this.session);if(!i.length)return 0;this.$blockScrolling+=1;var s=this.multiSelect;n||s.toSingleRange(i[0]);for(var o=i.length;o--;)s.addRange(i[o],!0);return r&&s.rangeList.rangeAtPoint(r.start)&&s.addRange(r,!0),this.$blockScrolling-=1,i.length},this.selectMoreLines=function(e,t){var n=this.selection.toOrientedRange(),r=n.cursor==n.end,s=this.session.documentToScreenPosition(n.cursor);this.selection.$desiredColumn&&(s.column=this.selection.$desiredColumn);var o=this.session.screenToDocumentPosition(s.row+e,s.column);if(!n.isEmpty())var u=this.session.documentToScreenPosition(r?n.end:n.start),a=this.session.screenToDocumentPosition(u.row+e,u.column);else var a=o;if(r){var f=i.fromPoints(o,a);f.cursor=f.start}else{var f=i.fromPoints(a,o);f.cursor=f.end}f.desiredColumn=s.column;if(!this.selection.inMultiSelectMode)this.selection.addRange(n);else if(t)var l=n.cursor;this.selection.addRange(f),l&&this.selection.substractPoint(l)},this.transposeSelections=function(e){var t=this.session,n=t.multiSelect,r=n.ranges;for(var i=r.length;i--;){var s=r[i];if(s.isEmpty()){var o=t.getWordRange(s.start.row,s.start.column);s.start.row=o.start.row,s.start.column=o.start.column,s.end.row=o.end.row,s.end.column=o.end.column}}n.mergeOverlappingRanges();var u=[];for(var i=r.length;i--;){var s=r[i];u.unshift(t.getTextRange(s))}e<0?u.unshift(u.pop()):u.push(u.shift());for(var i=r.length;i--;){var s=r[i],o=s.clone();t.replace(s,u[i]),s.start.row=o.start.row,s.start.column=o.start.column}},this.selectMore=function(e,t,n){var r=this.session,i=r.multiSelect,s=i.toOrientedRange();if(s.isEmpty()){s=r.getWordRange(s.start.row,s.start.column),s.cursor=e==-1?s.start:s.end,this.multiSelect.addRange(s);if(n)return}var o=r.getTextRange(s),u=h(r,o,e);u&&(u.cursor=e==-1?u.start:u.end,this.$blockScrolling+=1,this.session.unfold(u),this.multiSelect.addRange(u),this.$blockScrolling-=1,this.renderer.scrollCursorIntoView(null,.5)),t&&this.multiSelect.substractPoint(s.cursor)},this.alignCursors=function(){var e=this.session,t=e.multiSelect,n=t.ranges,r=-1,s=n.filter(function(e){if(e.cursor.row==r)return!0;r=e.cursor.row});if(!n.length||s.length==n.length-1){var o=this.selection.getRange(),u=o.start.row,f=o.end.row,l=u==f;if(l){var c=this.session.getLength(),h;do h=this.session.getLine(f);while(/[=:]/.test(h)&&++f<c);do h=this.session.getLine(u);while(/[=:]/.test(h)&&--u>0);u<0&&(u=0),f>=c&&(f=c-1)}var p=this.session.removeFullLines(u,f);p=this.$reAlignText(p,l),this.session.insert({row:u,column:0},p.join("\n")+"\n"),l||(o.start.column=0,o.end.column=p[p.length-1].length),this.selection.setRange(o)}else{s.forEach(function(e){t.substractPoint(e.cursor)});var d=0,v=Infinity,m=n.map(function(t){var n=t.cursor,r=e.getLine(n.row),i=r.substr(n.column).search(/\S/g);return i==-1&&(i=0),n.column>d&&(d=n.column),i<v&&(v=i),i});n.forEach(function(t,n){var r=t.cursor,s=d-r.column,o=m[n]-v;s>o?e.insert(r,a.stringRepeat(" ",s-o)):e.remove(new i(r.row,r.column,r.row,r.column-s+o)),t.start.column=t.end.column=d,t.start.row=t.end.row=r.row,t.cursor=t.end}),t.fromOrientedRange(n[0]),this.renderer.updateCursor(),this.renderer.updateBackMarkers()}},this.$reAlignText=function(e,t){function u(e){return a.stringRepeat(" ",e)}function f(e){return e[2]?u(i)+e[2]+u(s-e[2].length+o)+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}function l(e){return e[2]?u(i+s-e[2].length)+e[2]+u(o," ")+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}function c(e){return e[2]?u(i)+e[2]+u(o)+e[4].replace(/^([=:])\s+/,"$1 "):e[0]}var n=!0,r=!0,i,s,o;return e.map(function(e){var t=e.match(/(\s*)(.*?)(\s*)([=:].*)/);return t?i==null?(i=t[1].length,s=t[2].length,o=t[3].length,t):(i+s+o!=t[1].length+t[2].length+t[3].length&&(r=!1),i!=t[1].length&&(n=!1),i>t[1].length&&(i=t[1].length),s<t[2].length&&(s=t[2].length),o>t[3].length&&(o=t[3].length),t):[e]}).map(t?f:n?r?l:f:c)}}).call(d.prototype),t.onSessionChange=function(e){var t=e.session;t&&!t.multiSelect&&(t.$selectionMarkers=[],t.selection.$initRangeList(),t.multiSelect=t.selection),this.multiSelect=t&&t.multiSelect;var n=e.oldSession;n&&(n.multiSelect.off("addRange",this.$onAddRange),n.multiSelect.off("removeRange",this.$onRemoveRange),n.multiSelect.off("multiSelect",this.$onMultiSelect),n.multiSelect.off("singleSelect",this.$onSingleSelect),n.multiSelect.lead.off("change",this.$checkMultiselectChange),n.multiSelect.anchor.off("change",this.$checkMultiselectChange)),t&&(t.multiSelect.on("addRange",this.$onAddRange),t.multiSelect.on("removeRange",this.$onRemoveRange),t.multiSelect.on("multiSelect",this.$onMultiSelect),t.multiSelect.on("singleSelect",this.$onSingleSelect),t.multiSelect.lead.on("change",this.$checkMultiselectChange),t.multiSelect.anchor.on("change",this.$checkMultiselectChange)),t&&this.inMultiSelectMode!=t.selection.inMultiSelectMode&&(t.selection.inMultiSelectMode?this.$onMultiSelect():this.$onSingleSelect())},t.MultiSelect=m,e("./config").defineOptions(d.prototype,"editor",{enableMultiselect:{set:function(e){m(this),e?(this.on("changeSession",this.$multiselectOnSessionChange),this.on("mousedown",o)):(this.off("changeSession",this.$multiselectOnSessionChange),this.off("mousedown",o))},value:!0},enableBlockSelect:{set:function(e){this.$blockSelectEnabled=e},value:!0}})}),ace.define("ace/mode/folding/fold_mode",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("../../range").Range,i=t.FoldMode=function(){};(function(){this.foldingStartMarker=null,this.foldingStopMarker=null,this.getFoldWidget=function(e,t,n){var r=e.getLine(n);return this.foldingStartMarker.test(r)?"start":t=="markbeginend"&&this.foldingStopMarker&&this.foldingStopMarker.test(r)?"end":""},this.getFoldWidgetRange=function(e,t,n){return null},this.indentationBlock=function(e,t,n){var i=/\S/,s=e.getLine(t),o=s.search(i);if(o==-1)return;var u=n||s.length,a=e.getLength(),f=t,l=t;while(++t<a){var c=e.getLine(t).search(i);if(c==-1)continue;if(c<=o)break;l=t}if(l>f){var h=e.getLine(l).length;return new r(f,u,l,h)}},this.openingBracketBlock=function(e,t,n,i,s){var o={row:n,column:i+1},u=e.$findClosingBracket(t,o,s);if(!u)return;var a=e.foldWidgets[u.row];return a==null&&(a=e.getFoldWidget(u.row)),a=="start"&&u.row>o.row&&(u.row--,u.column=e.getLine(u.row).length),r.fromPoints(o,u)},this.closingBracketBlock=function(e,t,n,i,s){var o={row:n,column:i},u=e.$findOpeningBracket(t,o);if(!u)return;return u.column++,o.column--,r.fromPoints(u,o)}}).call(i.prototype)}),ace.define("ace/theme/textmate",["require","exports","module","ace/lib/dom"],function(e,t,n){"use strict";t.isDark=!1,t.cssClass="ace-tm",t.cssText='.ace-tm .ace_gutter {background: #f0f0f0;color: #333;}.ace-tm .ace_print-margin {width: 1px;background: #e8e8e8;}.ace-tm .ace_fold {background-color: #6B72E6;}.ace-tm {background-color: #FFFFFF;color: black;}.ace-tm .ace_cursor {color: black;}.ace-tm .ace_invisible {color: rgb(191, 191, 191);}.ace-tm .ace_storage,.ace-tm .ace_keyword {color: blue;}.ace-tm .ace_constant {color: rgb(197, 6, 11);}.ace-tm .ace_constant.ace_buildin {color: rgb(88, 72, 246);}.ace-tm .ace_constant.ace_language {color: rgb(88, 92, 246);}.ace-tm .ace_constant.ace_library {color: rgb(6, 150, 14);}.ace-tm .ace_invalid {background-color: rgba(255, 0, 0, 0.1);color: red;}.ace-tm .ace_support.ace_function {color: rgb(60, 76, 114);}.ace-tm .ace_support.ace_constant {color: rgb(6, 150, 14);}.ace-tm .ace_support.ace_type,.ace-tm .ace_support.ace_class {color: rgb(109, 121, 222);}.ace-tm .ace_keyword.ace_operator {color: rgb(104, 118, 135);}.ace-tm .ace_string {color: rgb(3, 106, 7);}.ace-tm .ace_comment {color: rgb(76, 136, 107);}.ace-tm .ace_comment.ace_doc {color: rgb(0, 102, 255);}.ace-tm .ace_comment.ace_doc.ace_tag {color: rgb(128, 159, 191);}.ace-tm .ace_constant.ace_numeric {color: rgb(0, 0, 205);}.ace-tm .ace_variable {color: rgb(49, 132, 149);}.ace-tm .ace_xml-pe {color: rgb(104, 104, 91);}.ace-tm .ace_entity.ace_name.ace_function {color: #0000A2;}.ace-tm .ace_heading {color: rgb(12, 7, 255);}.ace-tm .ace_list {color:rgb(185, 6, 144);}.ace-tm .ace_meta.ace_tag {color:rgb(0, 22, 142);}.ace-tm .ace_string.ace_regex {color: rgb(255, 0, 0)}.ace-tm .ace_marker-layer .ace_selection {background: rgb(181, 213, 255);}.ace-tm.ace_multiselect .ace_selection.ace_start {box-shadow: 0 0 3px 0px white;}.ace-tm .ace_marker-layer .ace_step {background: rgb(252, 255, 0);}.ace-tm .ace_marker-layer .ace_stack {background: rgb(164, 229, 101);}.ace-tm .ace_marker-layer .ace_bracket {margin: -1px 0 0 -1px;border: 1px solid rgb(192, 192, 192);}.ace-tm .ace_marker-layer .ace_active-line {background: rgba(0, 0, 0, 0.07);}.ace-tm .ace_gutter-active-line {background-color : #dcdcdc;}.ace-tm .ace_marker-layer .ace_selected-word {background: rgb(250, 250, 255);border: 1px solid rgb(200, 200, 250);}.ace-tm .ace_indent-guide {background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==") right repeat-y;}';var r=e("../lib/dom");r.importCssString(t.cssText,t.cssClass)}),ace.define("ace/line_widgets",["require","exports","module","ace/lib/oop","ace/lib/dom","ace/range"],function(e,t,n){"use strict";function o(e){this.session=e,this.session.widgetManager=this,this.session.getRowLength=this.getRowLength,this.session.$getWidgetScreenLength=this.$getWidgetScreenLength,this.updateOnChange=this.updateOnChange.bind(this),this.renderWidgets=this.renderWidgets.bind(this),this.measureWidgets=this.measureWidgets.bind(this),this.session._changedWidgets=[],this.$onChangeEditor=this.$onChangeEditor.bind(this),this.session.on("change",this.updateOnChange),this.session.on("changeFold",this.updateOnFold),this.session.on("changeEditor",this.$onChangeEditor)}var r=e("./lib/oop"),i=e("./lib/dom"),s=e("./range").Range;(function(){this.getRowLength=function(e){var t;return this.lineWidgets?t=this.lineWidgets[e]&&this.lineWidgets[e].rowCount||0:t=0,!this.$useWrapMode||!this.$wrapData[e]?1+t:this.$wrapData[e].length+1+t},this.$getWidgetScreenLength=function(){var e=0;return this.lineWidgets.forEach(function(t){t&&t.rowCount&&!t.hidden&&(e+=t.rowCount)}),e},this.$onChangeEditor=function(e){this.attach(e.editor)},this.attach=function(e){e&&e.widgetManager&&e.widgetManager!=this&&e.widgetManager.detach();if(this.editor==e)return;this.detach(),this.editor=e,e&&(e.widgetManager=this,e.renderer.on("beforeRender",this.measureWidgets),e.renderer.on("afterRender",this.renderWidgets))},this.detach=function(e){var t=this.editor;if(!t)return;this.editor=null,t.widgetManager=null,t.renderer.off("beforeRender",this.measureWidgets),t.renderer.off("afterRender",this.renderWidgets);var n=this.session.lineWidgets;n&&n.forEach(function(e){e&&e.el&&e.el.parentNode&&(e._inDocument=!1,e.el.parentNode.removeChild(e.el))})},this.updateOnFold=function(e,t){var n=t.lineWidgets;if(!n||!e.action)return;var r=e.data,i=r.start.row,s=r.end.row,o=e.action=="add";for(var u=i+1;u<s;u++)n[u]&&(n[u].hidden=o);n[s]&&(o?n[i]?n[s].hidden=o:n[i]=n[s]:(n[i]==n[s]&&(n[i]=undefined),n[s].hidden=o))},this.updateOnChange=function(e){var t=this.session.lineWidgets;if(!t)return;var n=e.start.row,r=e.end.row-n;if(r!==0)if(e.action=="remove"){var i=t.splice(n+1,r);i.forEach(function(e){e&&this.removeLineWidget(e)},this),this.$updateRows()}else{var s=new Array(r);s.unshift(n,0),t.splice.apply(t,s),this.$updateRows()}},this.$updateRows=function(){var e=this.session.lineWidgets;if(!e)return;var t=!0;e.forEach(function(e,n){if(e){t=!1,e.row=n;while(e.$oldWidget)e.$oldWidget.row=n,e=e.$oldWidget}}),t&&(this.session.lineWidgets=null)},this.addLineWidget=function(e){this.session.lineWidgets||(this.session.lineWidgets=new Array(this.session.getLength()));var t=this.session.lineWidgets[e.row];t&&(e.$oldWidget=t,t.el&&t.el.parentNode&&(t.el.parentNode.removeChild(t.el),t._inDocument=!1)),this.session.lineWidgets[e.row]=e,e.session=this.session;var n=this.editor.renderer;e.html&&!e.el&&(e.el=i.createElement("div"),e.el.innerHTML=e.html),e.el&&(i.addCssClass(e.el,"ace_lineWidgetContainer"),e.el.style.position="absolute",e.el.style.zIndex=5,n.container.appendChild(e.el),e._inDocument=!0),e.coverGutter||(e.el.style.zIndex=3),e.pixelHeight==null&&(e.pixelHeight=e.el.offsetHeight),e.rowCount==null&&(e.rowCount=e.pixelHeight/n.layerConfig.lineHeight);var r=this.session.getFoldAt(e.row,0);e.$fold=r;if(r){var s=this.session.lineWidgets;e.row==r.end.row&&!s[r.start.row]?s[r.start.row]=e:e.hidden=!0}return this.session._emit("changeFold",{data:{start:{row:e.row}}}),this.$updateRows(),this.renderWidgets(null,n),this.onWidgetChanged(e),e},this.removeLineWidget=function(e){e._inDocument=!1,e.session=null,e.el&&e.el.parentNode&&e.el.parentNode.removeChild(e.el);if(e.editor&&e.editor.destroy)try{e.editor.destroy()}catch(t){}if(this.session.lineWidgets){var n=this.session.lineWidgets[e.row];if(n==e)this.session.lineWidgets[e.row]=e.$oldWidget,e.$oldWidget&&this.onWidgetChanged(e.$oldWidget);else while(n){if(n.$oldWidget==e){n.$oldWidget=e.$oldWidget;break}n=n.$oldWidget}}this.session._emit("changeFold",{data:{start:{row:e.row}}}),this.$updateRows()},this.getWidgetsAtRow=function(e){var t=this.session.lineWidgets,n=t&&t[e],r=[];while(n)r.push(n),n=n.$oldWidget;return r},this.onWidgetChanged=function(e){this.session._changedWidgets.push(e),this.editor&&this.editor.renderer.updateFull()},this.measureWidgets=function(e,t){var n=this.session._changedWidgets,r=t.layerConfig;if(!n||!n.length)return;var i=Infinity;for(var s=0;s<n.length;s++){var o=n[s];if(!o||!o.el)continue;if(o.session!=this.session)continue;if(!o._inDocument){if(this.session.lineWidgets[o.row]!=o)continue;o._inDocument=!0,t.container.appendChild(o.el)}o.h=o.el.offsetHeight,o.fixedWidth||(o.w=o.el.offsetWidth,o.screenWidth=Math.ceil(o.w/r.characterWidth));var u=o.h/r.lineHeight;o.coverLine&&(u-=this.session.getRowLineCount(o.row),u<0&&(u=0)),o.rowCount!=u&&(o.rowCount=u,o.row<i&&(i=o.row))}i!=Infinity&&(this.session._emit("changeFold",{data:{start:{row:i}}}),this.session.lineWidgetWidth=null),this.session._changedWidgets=[]},this.renderWidgets=function(e,t){var n=t.layerConfig,r=this.session.lineWidgets;if(!r)return;var i=Math.min(this.firstRow,n.firstRow),s=Math.max(this.lastRow,n.lastRow,r.length);while(i>0&&!r[i])i--;this.firstRow=n.firstRow,this.lastRow=n.lastRow,t.$cursorLayer.config=n;for(var o=i;o<=s;o++){var u=r[o];if(!u||!u.el)continue;if(u.hidden){u.el.style.top=-100-(u.pixelHeight||0)+"px";continue}u._inDocument||(u._inDocument=!0,t.container.appendChild(u.el));var a=t.$cursorLayer.getPixelPosition({row:o,column:0},!0).top;u.coverLine||(a+=n.lineHeight*this.session.getRowLineCount(u.row)),u.el.style.top=a-n.offset+"px";var f=u.coverGutter?0:t.gutterWidth;u.fixedWidth||(f-=t.scrollLeft),u.el.style.left=f+"px",u.fullWidth&&u.screenWidth&&(u.el.style.minWidth=n.width+2*n.padding+"px"),u.fixedWidth?u.el.style.right=t.scrollBar.getWidth()+"px":u.el.style.right=""}}}).call(o.prototype),t.LineWidgets=o}),ace.define("ace/ext/error_marker",["require","exports","module","ace/line_widgets","ace/lib/dom","ace/range"],function(e,t,n){"use strict";function o(e,t,n){var r=0,i=e.length-1;while(r<=i){var s=r+i>>1,o=n(t,e[s]);if(o>0)r=s+1;else{if(!(o<0))return s;i=s-1}}return-(r+1)}function u(e,t,n){var r=e.getAnnotations().sort(s.comparePoints);if(!r.length)return;var i=o(r,{row:t,column:-1},s.comparePoints);i<0&&(i=-i-1),i>=r.length?i=n>0?0:r.length-1:i===0&&n<0&&(i=r.length-1);var u=r[i];if(!u||!n)return;if(u.row===t){do u=r[i+=n];while(u&&u.row===t);if(!u)return r.slice()}var a=[];t=u.row;do a[n<0?"unshift":"push"](u),u=r[i+=n];while(u&&u.row==t);return a.length&&a}var r=e("../line_widgets").LineWidgets,i=e("../lib/dom"),s=e("../range").Range;t.showErrorMarker=function(e,t){var n=e.session;n.widgetManager||(n.widgetManager=new r(n),n.widgetManager.attach(e));var s=e.getCursorPosition(),o=s.row,a=n.widgetManager.getWidgetsAtRow(o).filter(function(e){return e.type=="errorMarker"})[0];a?a.destroy():o-=t;var f=u(n,o,t),l;if(f){var c=f[0];s.column=(c.pos&&typeof c.column!="number"?c.pos.sc:c.column)||0,s.row=c.row,l=e.renderer.$gutterLayer.$annotations[s.row]}else{if(a)return;l={text:["Looks good!"],className:"ace_ok"}}e.session.unfold(s.row),e.selection.moveToPosition(s);var h={row:s.row,fixedWidth:!0,coverGutter:!0,el:i.createElement("div"),type:"errorMarker"},p=h.el.appendChild(i.createElement("div")),d=h.el.appendChild(i.createElement("div"));d.className="error_widget_arrow "+l.className;var v=e.renderer.$cursorLayer.getPixelPosition(s).left;d.style.left=v+e.renderer.gutterWidth-5+"px",h.el.className="error_widget_wrapper",p.className="error_widget "+l.className,p.innerHTML=l.text.join("<br>"),p.appendChild(i.createElement("div"));var m=function(e,t,n){if(t===0&&(n==="esc"||n==="return"))return h.destroy(),{command:"null"}};h.destroy=function(){if(e.$mouseHandler.isMousePressed)return;e.keyBinding.removeKeyboardHandler(m),n.widgetManager.removeLineWidget(h),e.off("changeSelection",h.destroy),e.off("changeSession",h.destroy),e.off("mouseup",h.destroy),e.off("change",h.destroy)},e.keyBinding.addKeyboardHandler(m),e.on("changeSelection",h.destroy),e.on("changeSession",h.destroy),e.on("mouseup",h.destroy),e.on("change",h.destroy),e.session.widgetManager.addLineWidget(h),h.el.onmousedown=e.focus.bind(e),e.renderer.scrollCursorIntoView(null,.5,{bottom:h.el.offsetHeight})},i.importCssString("    .error_widget_wrapper {        background: inherit;        color: inherit;        border:none    }    .error_widget {        border-top: solid 2px;        border-bottom: solid 2px;        margin: 5px 0;        padding: 10px 40px;        white-space: pre-wrap;    }    .error_widget.ace_error, .error_widget_arrow.ace_error{        border-color: #ff5a5a    }    .error_widget.ace_warning, .error_widget_arrow.ace_warning{        border-color: #F1D817    }    .error_widget.ace_info, .error_widget_arrow.ace_info{        border-color: #5a5a5a    }    .error_widget.ace_ok, .error_widget_arrow.ace_ok{        border-color: #5aaa5a    }    .error_widget_arrow {        position: absolute;        border: solid 5px;        border-top-color: transparent!important;        border-right-color: transparent!important;        border-left-color: transparent!important;        top: -5px;    }","")}),ace.define("ace/ace",["require","exports","module","ace/lib/fixoldbrowsers","ace/lib/dom","ace/lib/event","ace/editor","ace/edit_session","ace/undomanager","ace/virtual_renderer","ace/worker/worker_client","ace/keyboard/hash_handler","ace/placeholder","ace/multi_select","ace/mode/folding/fold_mode","ace/theme/textmate","ace/ext/error_marker","ace/config"],function(e,t,n){"use strict";e("./lib/fixoldbrowsers");var r=e("./lib/dom"),i=e("./lib/event"),s=e("./editor").Editor,o=e("./edit_session").EditSession,u=e("./undomanager").UndoManager,a=e("./virtual_renderer").VirtualRenderer;e("./worker/worker_client"),e("./keyboard/hash_handler"),e("./placeholder"),e("./multi_select"),e("./mode/folding/fold_mode"),e("./theme/textmate"),e("./ext/error_marker"),t.config=e("./config"),t.require=e,"function"=="function"&&(t.define=__webpack_require__(1227)),t.edit=function(e){if(typeof e=="string"){var n=e;e=document.getElementById(n);if(!e)throw new Error("ace.edit can't find div #"+n)}if(e&&e.env&&e.env.editor instanceof s)return e.env.editor;var o="";if(e&&/input|textarea/i.test(e.tagName)){var u=e;o=u.value,e=r.createElement("pre"),u.parentNode.replaceChild(e,u)}else e&&(o=r.getInnerText(e),e.innerHTML="");var f=t.createEditSession(o),l=new s(new a(e));l.setSession(f);var c={document:f,editor:l,onResize:l.resize.bind(l,null)};return u&&(c.textarea=u),i.addListener(window,"resize",c.onResize),l.on("destroy",function(){i.removeListener(window,"resize",c.onResize),c.editor.container.env=null}),l.container.env=l.env=c,l},t.createEditSession=function(e,t){var n=new o(e,t);return n.setUndoManager(new u),n},t.EditSession=o,t.UndoManager=u,t.version="1.2.6"});
	            (function() {
	                ace.require(["ace/ace"], function(a) {
	                    if (a) {
	                        a.config.init(true);
	                        a.define = ace.define;
	                    }
	                    if (!window.ace)
	                        window.ace = a;
	                    for (var key in a) if (a.hasOwnProperty(key))
	                        window.ace[key] = a[key];
	                });
	            })();
	        

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 1228 */
/***/ (function(module, exports) {

	ace.define("ace/mode/plain_text",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/text_highlight_rules","ace/mode/behaviour"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text").Mode,s=e("./text_highlight_rules").TextHighlightRules,o=e("./behaviour").Behaviour,u=function(){this.HighlightRules=s,this.$behaviour=new o};r.inherits(u,i),function(){this.type="text",this.getNextLineIndent=function(e,t,n){return""},this.$id="ace/mode/plain_text"}.call(u.prototype),t.Mode=u})

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){this.$rules={start:[{token:"comment.doc.tag",regex:"@[\\w\\d_]+"},s.getTagRule(),{defaultToken:"comment.doc",caseInsensitive:!0}]}};r.inherits(s,i),s.getTagRule=function(e){return{token:"comment.doc.tag.storage.type",regex:"\\b(?:TODO|FIXME|XXX|HACK)\\b"}},s.getStartRule=function(e){return{token:"comment.doc",regex:"\\/\\*(?=\\*)",next:e}},s.getEndRule=function(e){return{token:"comment.doc",regex:"\\*\\/",next:e}},t.DocCommentHighlightRules=s}),ace.define("ace/mode/javascript_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";function a(){var e=o.replace("\\d","\\d\\-"),t={onMatch:function(e,t,n){var r=e.charAt(1)=="/"?2:1;if(r==1)t!=this.nextState?n.unshift(this.next,this.nextState,0):n.unshift(this.next),n[2]++;else if(r==2&&t==this.nextState){n[1]--;if(!n[1]||n[1]<0)n.shift(),n.shift()}return[{type:"meta.tag.punctuation."+(r==1?"":"end-")+"tag-open.xml",value:e.slice(0,r)},{type:"meta.tag.tag-name.xml",value:e.substr(r)}]},regex:"</?"+e+"",next:"jsxAttributes",nextState:"jsx"};this.$rules.start.unshift(t);var n={regex:"{",token:"paren.quasi.start",push:"start"};this.$rules.jsx=[n,t,{include:"reference"},{defaultToken:"string"}],this.$rules.jsxAttributes=[{token:"meta.tag.punctuation.tag-close.xml",regex:"/?>",onMatch:function(e,t,n){return t==n[0]&&n.shift(),e.length==2&&(n[0]==this.nextState&&n[1]--,(!n[1]||n[1]<0)&&n.splice(0,2)),this.next=n[0]||"start",[{type:this.token,value:e}]},nextState:"jsx"},n,f("jsxAttributes"),{token:"entity.other.attribute-name.xml",regex:e},{token:"keyword.operator.attribute-equals.xml",regex:"="},{token:"text.tag-whitespace.xml",regex:"\\s+"},{token:"string.attribute-value.xml",regex:"'",stateName:"jsx_attr_q",push:[{token:"string.attribute-value.xml",regex:"'",next:"pop"},{include:"reference"},{defaultToken:"string.attribute-value.xml"}]},{token:"string.attribute-value.xml",regex:'"',stateName:"jsx_attr_qq",push:[{token:"string.attribute-value.xml",regex:'"',next:"pop"},{include:"reference"},{defaultToken:"string.attribute-value.xml"}]},t],this.$rules.reference=[{token:"constant.language.escape.reference.xml",regex:"(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"}]}function f(e){return[{token:"comment",regex:/\/\*/,next:[i.getTagRule(),{token:"comment",regex:"\\*\\/",next:e||"pop"},{defaultToken:"comment",caseInsensitive:!0}]},{token:"comment",regex:"\\/\\/",next:[i.getTagRule(),{token:"comment",regex:"$|^",next:e||"pop"},{defaultToken:"comment",caseInsensitive:!0}]}]}var r=e("../lib/oop"),i=e("./doc_comment_highlight_rules").DocCommentHighlightRules,s=e("./text_highlight_rules").TextHighlightRules,o="[a-zA-Z\\$_\u00a1-\uffff][a-zA-Z\\d\\$_\u00a1-\uffff]*",u=function(e){var t=this.createKeywordMapper({"variable.language":"Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|Namespace|QName|XML|XMLList|ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|SyntaxError|TypeError|URIError|decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|isNaN|parseFloat|parseInt|JSON|Math|this|arguments|prototype|window|document",keyword:"const|yield|import|get|set|async|await|break|case|catch|continue|default|delete|do|else|finally|for|function|if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|__parent__|__count__|escape|unescape|with|__proto__|class|enum|extends|super|export|implements|private|public|interface|package|protected|static","storage.type":"const|let|var|function","constant.language":"null|Infinity|NaN|undefined","support.function":"alert","constant.language.boolean":"true|false"},"identifier"),n="case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void",r="\\\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|u{[0-9a-fA-F]{1,6}}|[0-2][0-7]{0,2}|3[0-7][0-7]?|[4-7][0-7]?|.)";this.$rules={no_regex:[i.getStartRule("doc-start"),f("no_regex"),{token:"string",regex:"'(?=.)",next:"qstring"},{token:"string",regex:'"(?=.)',next:"qqstring"},{token:"constant.numeric",regex:/0(?:[xX][0-9a-fA-F]+|[bB][01]+)\b/},{token:"constant.numeric",regex:/[+-]?\d[\d_]*(?:(?:\.\d*)?(?:[eE][+-]?\d+)?)?\b/},{token:["storage.type","punctuation.operator","support.function","punctuation.operator","entity.name.function","text","keyword.operator"],regex:"("+o+")(\\.)(prototype)(\\.)("+o+")(\\s*)(=)",next:"function_arguments"},{token:["storage.type","punctuation.operator","entity.name.function","text","keyword.operator","text","storage.type","text","paren.lparen"],regex:"("+o+")(\\.)("+o+")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:["entity.name.function","text","keyword.operator","text","storage.type","text","paren.lparen"],regex:"("+o+")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:["storage.type","punctuation.operator","entity.name.function","text","keyword.operator","text","storage.type","text","entity.name.function","text","paren.lparen"],regex:"("+o+")(\\.)("+o+")(\\s*)(=)(\\s*)(function)(\\s+)(\\w+)(\\s*)(\\()",next:"function_arguments"},{token:["storage.type","text","entity.name.function","text","paren.lparen"],regex:"(function)(\\s+)("+o+")(\\s*)(\\()",next:"function_arguments"},{token:["entity.name.function","text","punctuation.operator","text","storage.type","text","paren.lparen"],regex:"("+o+")(\\s*)(:)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:["text","text","storage.type","text","paren.lparen"],regex:"(:)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:"keyword",regex:"(?:"+n+")\\b",next:"start"},{token:["support.constant"],regex:/that\b/},{token:["storage.type","punctuation.operator","support.function.firebug"],regex:/(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/},{token:t,regex:o},{token:"punctuation.operator",regex:/[.](?![.])/,next:"property"},{token:"keyword.operator",regex:/--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,next:"start"},{token:"punctuation.operator",regex:/[?:,;.]/,next:"start"},{token:"paren.lparen",regex:/[\[({]/,next:"start"},{token:"paren.rparen",regex:/[\])}]/},{token:"comment",regex:/^#!.*$/}],property:[{token:"text",regex:"\\s+"},{token:["storage.type","punctuation.operator","entity.name.function","text","keyword.operator","text","storage.type","text","entity.name.function","text","paren.lparen"],regex:"("+o+")(\\.)("+o+")(\\s*)(=)(\\s*)(function)(?:(\\s+)(\\w+))?(\\s*)(\\()",next:"function_arguments"},{token:"punctuation.operator",regex:/[.](?![.])/},{token:"support.function",regex:/(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/},{token:"support.function.dom",regex:/(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/},{token:"support.constant",regex:/(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/},{token:"identifier",regex:o},{regex:"",token:"empty",next:"no_regex"}],start:[i.getStartRule("doc-start"),f("start"),{token:"string.regexp",regex:"\\/",next:"regex"},{token:"text",regex:"\\s+|^$",next:"start"},{token:"empty",regex:"",next:"no_regex"}],regex:[{token:"regexp.keyword.operator",regex:"\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"},{token:"string.regexp",regex:"/[sxngimy]*",next:"no_regex"},{token:"invalid",regex:/\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/},{token:"constant.language.escape",regex:/\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/},{token:"constant.language.delimiter",regex:/\|/},{token:"constant.language.escape",regex:/\[\^?/,next:"regex_character_class"},{token:"empty",regex:"$",next:"no_regex"},{defaultToken:"string.regexp"}],regex_character_class:[{token:"regexp.charclass.keyword.operator",regex:"\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"},{token:"constant.language.escape",regex:"]",next:"regex"},{token:"constant.language.escape",regex:"-"},{token:"empty",regex:"$",next:"no_regex"},{defaultToken:"string.regexp.charachterclass"}],function_arguments:[{token:"variable.parameter",regex:o},{token:"punctuation.operator",regex:"[, ]+"},{token:"punctuation.operator",regex:"$"},{token:"empty",regex:"",next:"no_regex"}],qqstring:[{token:"constant.language.escape",regex:r},{token:"string",regex:"\\\\$",next:"qqstring"},{token:"string",regex:'"|$',next:"no_regex"},{defaultToken:"string"}],qstring:[{token:"constant.language.escape",regex:r},{token:"string",regex:"\\\\$",next:"qstring"},{token:"string",regex:"'|$",next:"no_regex"},{defaultToken:"string"}]};if(!e||!e.noES6)this.$rules.no_regex.unshift({regex:"[{}]",onMatch:function(e,t,n){this.next=e=="{"?this.nextState:"";if(e=="{"&&n.length)n.unshift("start",t);else if(e=="}"&&n.length){n.shift(),this.next=n.shift();if(this.next.indexOf("string")!=-1||this.next.indexOf("jsx")!=-1)return"paren.quasi.end"}return e=="{"?"paren.lparen":"paren.rparen"},nextState:"start"},{token:"string.quasi.start",regex:/`/,push:[{token:"constant.language.escape",regex:r},{token:"paren.quasi.start",regex:/\${/,push:"start"},{token:"string.quasi.end",regex:/`/,next:"pop"},{defaultToken:"string.quasi"}]}),(!e||e.jsx!=0)&&a.call(this);this.embedRules(i,"doc-",[i.getEndRule("no_regex")]),this.normalizeRules()};r.inherits(u,s),t.JavaScriptHighlightRules=u}),ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("../range").Range,i=function(){};(function(){this.checkOutdent=function(e,t){return/^\s+$/.test(e)?/^\s*\}/.test(t):!1},this.autoOutdent=function(e,t){var n=e.getLine(t),i=n.match(/^(\s*\})/);if(!i)return 0;var s=i[1].length,o=e.findMatchingBracket({row:t,column:s});if(!o||o.row==t)return 0;var u=this.$getIndent(e.getLine(o.row));e.replace(new r(t,0,t,s-1),u)},this.$getIndent=function(e){return e.match(/^\s*/)[0]}}).call(i.prototype),t.MatchingBraceOutdent=i}),ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("../../range").Range,s=e("./fold_mode").FoldMode,o=t.FoldMode=function(e){e&&(this.foldingStartMarker=new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/,"|"+e.start)),this.foldingStopMarker=new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/,"|"+e.end)))};r.inherits(o,s),function(){this.foldingStartMarker=/(\{|\[)[^\}\]]*$|^\s*(\/\*)/,this.foldingStopMarker=/^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/,this.singleLineBlockCommentRe=/^\s*(\/\*).*\*\/\s*$/,this.tripleStarBlockCommentRe=/^\s*(\/\*\*\*).*\*\/\s*$/,this.startRegionRe=/^\s*(\/\*|\/\/)#?region\b/,this._getFoldWidgetBase=this.getFoldWidget,this.getFoldWidget=function(e,t,n){var r=e.getLine(n);if(this.singleLineBlockCommentRe.test(r)&&!this.startRegionRe.test(r)&&!this.tripleStarBlockCommentRe.test(r))return"";var i=this._getFoldWidgetBase(e,t,n);return!i&&this.startRegionRe.test(r)?"start":i},this.getFoldWidgetRange=function(e,t,n,r){var i=e.getLine(n);if(this.startRegionRe.test(i))return this.getCommentRegionBlock(e,i,n);var s=i.match(this.foldingStartMarker);if(s){var o=s.index;if(s[1])return this.openingBracketBlock(e,s[1],n,o);var u=e.getCommentFoldRange(n,o+s[0].length,1);return u&&!u.isMultiLine()&&(r?u=this.getSectionRange(e,n):t!="all"&&(u=null)),u}if(t==="markbegin")return;var s=i.match(this.foldingStopMarker);if(s){var o=s.index+s[0].length;return s[1]?this.closingBracketBlock(e,s[1],n,o):e.getCommentFoldRange(n,o,-1)}},this.getSectionRange=function(e,t){var n=e.getLine(t),r=n.search(/\S/),s=t,o=n.length;t+=1;var u=t,a=e.getLength();while(++t<a){n=e.getLine(t);var f=n.search(/\S/);if(f===-1)continue;if(r>f)break;var l=this.getFoldWidgetRange(e,"all",t);if(l){if(l.start.row<=s)break;if(l.isMultiLine())t=l.end.row;else if(r==f)break}u=t}return new i(s,o,u,e.getLine(u).length)},this.getCommentRegionBlock=function(e,t,n){var r=t.search(/\s*$/),s=e.getLength(),o=n,u=/^\s*(?:\/\*|\/\/|--)#?(end)?region\b/,a=1;while(++n<s){t=e.getLine(n);var f=u.exec(t);if(!f)continue;f[1]?a--:a++;if(!a)break}var l=n;if(l>o)return new i(o,r,l,t.length)}}.call(o.prototype)}),ace.define("ace/mode/javascript",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/javascript_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text").Mode,s=e("./javascript_highlight_rules").JavaScriptHighlightRules,o=e("./matching_brace_outdent").MatchingBraceOutdent,u=e("../worker/worker_client").WorkerClient,a=e("./behaviour/cstyle").CstyleBehaviour,f=e("./folding/cstyle").FoldMode,l=function(){this.HighlightRules=s,this.$outdent=new o,this.$behaviour=new a,this.foldingRules=new f};r.inherits(l,i),function(){this.lineCommentStart="//",this.blockComment={start:"/*",end:"*/"},this.getNextLineIndent=function(e,t,n){var r=this.$getIndent(t),i=this.getTokenizer().getLineTokens(t,e),s=i.tokens,o=i.state;if(s.length&&s[s.length-1].type=="comment")return r;if(e=="start"||e=="no_regex"){var u=t.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);u&&(r+=n)}else if(e=="doc-start"){if(o=="start"||o=="no_regex")return"";var u=t.match(/^\s*(\/?)\*/);u&&(u[1]&&(r+=" "),r+="* ")}return r},this.checkOutdent=function(e,t,n){return this.$outdent.checkOutdent(t,n)},this.autoOutdent=function(e,t,n){this.$outdent.autoOutdent(t,n)},this.createWorker=function(e){var t=new u(["ace"],"ace/mode/javascript_worker","JavaScriptWorker");return t.attachToDocument(e.getDocument()),t.on("annotate",function(t){e.setAnnotations(t.data)}),t.on("terminate",function(){e.clearAnnotations()}),t},this.$id="ace/mode/javascript"}.call(l.prototype),t.Mode=l})

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

	ace.define("ace/mode/json_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){this.$rules={start:[{token:"variable",regex:'["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'},{token:"string",regex:'"',next:"string"},{token:"constant.numeric",regex:"0[xX][0-9a-fA-F]+\\b"},{token:"constant.numeric",regex:"[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"},{token:"constant.language.boolean",regex:"(?:true|false)\\b"},{token:"invalid.illegal",regex:"['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"},{token:"invalid.illegal",regex:"\\/\\/.*$"},{token:"paren.lparen",regex:"[[({]"},{token:"paren.rparen",regex:"[\\])}]"},{token:"text",regex:"\\s+"}],string:[{token:"constant.language.escape",regex:/\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/},{token:"string",regex:'[^"\\\\]+'},{token:"string",regex:'"',next:"start"},{token:"string",regex:"",next:"start"}]}};r.inherits(s,i),t.JsonHighlightRules=s}),ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("../range").Range,i=function(){};(function(){this.checkOutdent=function(e,t){return/^\s+$/.test(e)?/^\s*\}/.test(t):!1},this.autoOutdent=function(e,t){var n=e.getLine(t),i=n.match(/^(\s*\})/);if(!i)return 0;var s=i[1].length,o=e.findMatchingBracket({row:t,column:s});if(!o||o.row==t)return 0;var u=this.$getIndent(e.getLine(o.row));e.replace(new r(t,0,t,s-1),u)},this.$getIndent=function(e){return e.match(/^\s*/)[0]}}).call(i.prototype),t.MatchingBraceOutdent=i}),ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("../../range").Range,s=e("./fold_mode").FoldMode,o=t.FoldMode=function(e){e&&(this.foldingStartMarker=new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/,"|"+e.start)),this.foldingStopMarker=new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/,"|"+e.end)))};r.inherits(o,s),function(){this.foldingStartMarker=/(\{|\[)[^\}\]]*$|^\s*(\/\*)/,this.foldingStopMarker=/^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/,this.singleLineBlockCommentRe=/^\s*(\/\*).*\*\/\s*$/,this.tripleStarBlockCommentRe=/^\s*(\/\*\*\*).*\*\/\s*$/,this.startRegionRe=/^\s*(\/\*|\/\/)#?region\b/,this._getFoldWidgetBase=this.getFoldWidget,this.getFoldWidget=function(e,t,n){var r=e.getLine(n);if(this.singleLineBlockCommentRe.test(r)&&!this.startRegionRe.test(r)&&!this.tripleStarBlockCommentRe.test(r))return"";var i=this._getFoldWidgetBase(e,t,n);return!i&&this.startRegionRe.test(r)?"start":i},this.getFoldWidgetRange=function(e,t,n,r){var i=e.getLine(n);if(this.startRegionRe.test(i))return this.getCommentRegionBlock(e,i,n);var s=i.match(this.foldingStartMarker);if(s){var o=s.index;if(s[1])return this.openingBracketBlock(e,s[1],n,o);var u=e.getCommentFoldRange(n,o+s[0].length,1);return u&&!u.isMultiLine()&&(r?u=this.getSectionRange(e,n):t!="all"&&(u=null)),u}if(t==="markbegin")return;var s=i.match(this.foldingStopMarker);if(s){var o=s.index+s[0].length;return s[1]?this.closingBracketBlock(e,s[1],n,o):e.getCommentFoldRange(n,o,-1)}},this.getSectionRange=function(e,t){var n=e.getLine(t),r=n.search(/\S/),s=t,o=n.length;t+=1;var u=t,a=e.getLength();while(++t<a){n=e.getLine(t);var f=n.search(/\S/);if(f===-1)continue;if(r>f)break;var l=this.getFoldWidgetRange(e,"all",t);if(l){if(l.start.row<=s)break;if(l.isMultiLine())t=l.end.row;else if(r==f)break}u=t}return new i(s,o,u,e.getLine(u).length)},this.getCommentRegionBlock=function(e,t,n){var r=t.search(/\s*$/),s=e.getLength(),o=n,u=/^\s*(?:\/\*|\/\/|--)#?(end)?region\b/,a=1;while(++n<s){t=e.getLine(n);var f=u.exec(t);if(!f)continue;f[1]?a--:a++;if(!a)break}var l=n;if(l>o)return new i(o,r,l,t.length)}}.call(o.prototype)}),ace.define("ace/mode/json",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/json_highlight_rules","ace/mode/matching_brace_outdent","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle","ace/worker/worker_client"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text").Mode,s=e("./json_highlight_rules").JsonHighlightRules,o=e("./matching_brace_outdent").MatchingBraceOutdent,u=e("./behaviour/cstyle").CstyleBehaviour,a=e("./folding/cstyle").FoldMode,f=e("../worker/worker_client").WorkerClient,l=function(){this.HighlightRules=s,this.$outdent=new o,this.$behaviour=new u,this.foldingRules=new a};r.inherits(l,i),function(){this.getNextLineIndent=function(e,t,n){var r=this.$getIndent(t);if(e=="start"){var i=t.match(/^.*[\{\(\[]\s*$/);i&&(r+=n)}return r},this.checkOutdent=function(e,t,n){return this.$outdent.checkOutdent(t,n)},this.autoOutdent=function(e,t,n){this.$outdent.autoOutdent(t,n)},this.createWorker=function(e){var t=new f(["ace"],"ace/mode/json_worker","JsonWorker");return t.attachToDocument(e.getDocument()),t.on("annotate",function(t){e.setAnnotations(t.data)}),t.on("terminate",function(){e.clearAnnotations()}),t},this.$id="ace/mode/json"}.call(l.prototype),t.Mode=l})

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPublicEmbedHTML = exports.getSignTokenOptions = exports.getSignedEmbedOptions = exports.getPublicEmbedOptions = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _embed = __webpack_require__(1232);
	
	var getPublicEmbedOptions = exports.getPublicEmbedOptions = function getPublicEmbedOptions(_ref) {
	    var iframeUrl = _ref.iframeUrl;
	    return [{ name: "HTML", source: function source() {
	            return html({ iframeUrl: "\"" + iframeUrl + "\"" });
	        }, mode: "ace/mode/html" }];
	};
	
	var getSignedEmbedOptions = exports.getSignedEmbedOptions = function getSignedEmbedOptions() {
	    return [{ name: "Mustache", source: function source() {
	            return html({ iframeUrl: "\"{{iframeUrl}}\"", mode: "ace/mode/html" });
	        } }, { name: "Pug / Jade", source: function source() {
	            return pug({ iframeUrl: "iframeUrl" });
	        } }, { name: "ERB", source: function source() {
	            return html({ iframeUrl: "\"<%= @iframe_url %>\"" });
	        } }, { name: "JSX", source: function source() {
	            return jsx({ iframeUrl: "{iframeUrl}", mode: "ace/mode/jsx" });
	        } }];
	};
	
	var getSignTokenOptions = exports.getSignTokenOptions = function getSignTokenOptions(params) {
	    return [{ name: "Node.js", source: function source() {
	            return node(params);
	        }, mode: "ace/mode/javascript", embedOption: "Pug / Jade" }, { name: "Ruby", source: function source() {
	            return ruby(params);
	        }, mode: "ace/mode/ruby", embedOption: "ERB" }, { name: "Python", source: function source() {
	            return python(params);
	        }, mode: "ace/mode/python" }, { name: "Clojure", source: function source() {
	            return clojure(params);
	        }, mode: "ace/mode/clojure" }];
	};
	
	var getPublicEmbedHTML = exports.getPublicEmbedHTML = function getPublicEmbedHTML(iframeUrl) {
	    return html({ iframeUrl: JSON.stringify(iframeUrl) });
	};
	
	var html = function html(_ref2) {
	    var iframeUrl = _ref2.iframeUrl;
	    return "<iframe\n    src=" + iframeUrl + "\n    frameborder=\"0\"\n    width=\"800\"\n    height=\"600\"\n    allowtransparency\n></iframe>";
	};
	
	var jsx = function jsx(_ref3) {
	    var iframeUrl = _ref3.iframeUrl;
	    return "<iframe\n    src=" + iframeUrl + "\n    frameBorder={0}\n    width={800}\n    height={600}\n    allowTransparency\n/>";
	};
	
	var pug = function pug(_ref4) {
	    var iframeUrl = _ref4.iframeUrl;
	    return "iframe(\n    src=" + iframeUrl + "\n    frameborder=\"0\"\n    width=\"800\"\n    height=\"600\"\n    allowtransparency\n)";
	};
	
	var node = function node(_ref5) {
	    var siteUrl = _ref5.siteUrl,
	        secretKey = _ref5.secretKey,
	        resourceType = _ref5.resourceType,
	        resourceId = _ref5.resourceId,
	        params = _ref5.params,
	        displayOptions = _ref5.displayOptions;
	    return "// you will need to install via 'npm install jsonwebtoken' or in your package.json\n\nvar jwt = require(\"jsonwebtoken\");\n\nvar METABASE_SITE_URL = " + JSON.stringify(siteUrl) + ";\nvar METABASE_SECRET_KEY = " + JSON.stringify(secretKey) + ";\n\nvar payload = {\n  resource: { " + resourceType + ": " + resourceId + " },\n  params: " + JSON.stringify(params, null, 2).split("\n").join("\n  ") + "\n};\nvar token = jwt.sign(payload, METABASE_SECRET_KEY);\n\nvar iframeUrl = METABASE_SITE_URL + \"/embed/" + resourceType + "/\" + token" + ((0, _embed.optionsToHashParams)(displayOptions) ? " + " + JSON.stringify((0, _embed.optionsToHashParams)(displayOptions)) : "") + ";";
	};
	
	var ruby = function ruby(_ref6) {
	    var siteUrl = _ref6.siteUrl,
	        secretKey = _ref6.secretKey,
	        resourceType = _ref6.resourceType,
	        resourceId = _ref6.resourceId,
	        params = _ref6.params,
	        displayOptions = _ref6.displayOptions;
	    return "# you will need to install 'jwt' gem first via 'gem install jwt' or in your project Gemfile\n\nrequire 'jwt'\n\nMETABASE_SITE_URL = " + JSON.stringify(siteUrl) + "\nMETABASE_SECRET_KEY = " + JSON.stringify(secretKey) + "\n\npayload = {\n  :resource => {:" + resourceType + " => " + resourceId + "},\n  :params => {\n    " + Object.entries(params).map(function (_ref7) {
	        var _ref8 = _slicedToArray(_ref7, 2),
	            key = _ref8[0],
	            value = _ref8[1];
	
	        return JSON.stringify(key) + " => " + JSON.stringify(value);
	    }).join(",\n    ") + "\n  }\n}\ntoken = JWT.encode payload, METABASE_SECRET_KEY\n\niframe_url = METABASE_SITE_URL + \"/embed/" + resourceType + "/\" + token" + ((0, _embed.optionsToHashParams)(displayOptions) ? " + " + JSON.stringify((0, _embed.optionsToHashParams)(displayOptions)) : "");
	};
	
	var python = function python(_ref9) {
	    var siteUrl = _ref9.siteUrl,
	        secretKey = _ref9.secretKey,
	        resourceType = _ref9.resourceType,
	        resourceId = _ref9.resourceId,
	        params = _ref9.params,
	        displayOptions = _ref9.displayOptions;
	    return "# You'll need to install PyJWT via pip 'pip install PyJWT' or your project packages file\n\nimport jwt\n\nMETABASE_SITE_URL = " + JSON.stringify(siteUrl) + "\nMETABASE_SECRET_KEY = " + JSON.stringify(secretKey) + "\n\npayload = {\n  \"resource\": {\"" + resourceType + "\": " + resourceId + "},\n  \"params\": {\n    " + Object.entries(params).map(function (_ref10) {
	        var _ref11 = _slicedToArray(_ref10, 2),
	            key = _ref11[0],
	            value = _ref11[1];
	
	        return JSON.stringify(key) + ": " + JSON.stringify(value);
	    }).join(",\n    ") + "\n  }\n}\ntoken = jwt.encode(payload, METABASE_SECRET_KEY, algorithm=\"HS256\")\n\niframeUrl = METABASE_SITE_URL + \"/embed/" + resourceType + "/\" + token" + ((0, _embed.optionsToHashParams)(displayOptions) ? " + " + JSON.stringify((0, _embed.optionsToHashParams)(displayOptions)) : "");
	};
	
	var clojure = function clojure(_ref12) {
	    var siteUrl = _ref12.siteUrl,
	        secretKey = _ref12.secretKey,
	        resourceType = _ref12.resourceType,
	        resourceId = _ref12.resourceId,
	        params = _ref12.params,
	        displayOptions = _ref12.displayOptions;
	    return "(require '[buddy.sign.jwt :as jwt])\n\n(def metabase-site-url   " + JSON.stringify(siteUrl) + ")\n(def metabase-secret-key " + JSON.stringify(secretKey) + ")\n\n(def payload\n  {:resource {:" + resourceType + " " + resourceId + "}\n   :params   {" + Object.entries(params).map(function (_ref13) {
	        var _ref14 = _slicedToArray(_ref13, 2),
	            key = _ref14[0],
	            value = _ref14[1];
	
	        return JSON.stringify(key) + " " + JSON.stringify(value);
	    }).join(",\n              ") + "}})\n\n(def token (jwt/sign payload metabase-secret-key))\n\n(def iframe-url (str metabase-site-url \"/embed/" + resourceType + "/\" token" + ((0, _embed.optionsToHashParams)(displayOptions) ? " " + JSON.stringify((0, _embed.optionsToHashParams)(displayOptions)) : "") + "))";
	};

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getSignedToken = getSignedToken;
	exports.getSignedPreviewUrl = getSignedPreviewUrl;
	exports.getUnsignedPreviewUrl = getUnsignedPreviewUrl;
	exports.optionsToHashParams = optionsToHashParams;
	
	var _querystring = __webpack_require__(585);
	
	var _querystring2 = _interopRequireDefault(_querystring);
	
	var _jsrsasign = __webpack_require__(1233);
	
	var _jsrsasign2 = _interopRequireDefault(_jsrsasign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// using jsrsasign because jsonwebtoken doesn't work on the web :-/
	
	
	function getSignedToken(resourceType, resourceId) {
	    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var secretKey = arguments[3];
	    var previewEmbeddingParams = arguments[4];
	
	    var unsignedToken = {
	        resource: _defineProperty({}, resourceType, resourceId),
	        params: params,
	        iat: Math.round(new Date().getTime() / 1000)
	    };
	    // include the `embedding_params` settings inline in the token for previews
	    if (previewEmbeddingParams) {
	        unsignedToken._embedding_params = previewEmbeddingParams;
	    }
	    return _jsrsasign2.default.jws.JWS.sign(null, { alg: "HS256", typ: "JWT" }, unsignedToken, { utf8: secretKey });
	}
	
	function getSignedPreviewUrl(siteUrl, resourceType, resourceId) {
	    var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var options = arguments[4];
	    var secretKey = arguments[5];
	    var previewEmbeddingParams = arguments[6];
	
	    var token = getSignedToken(resourceType, resourceId, params, secretKey, previewEmbeddingParams);
	    return siteUrl + "/embed/" + resourceType + "/" + token + optionsToHashParams(options);
	}
	
	function getUnsignedPreviewUrl(siteUrl, resourceType, resourceId, options) {
	    return siteUrl + "/public/" + resourceType + "/" + resourceId + optionsToHashParams(options);
	}
	
	function optionsToHashParams() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    options = _extends({}, options);
	    // filter out null, undefined, ""
	    for (var name in options) {
	        if (options[name] == null || options[name] === "") {
	            delete options[name];
	        }
	    }
	    var query = _querystring2.default.stringify(options);
	    return query ? "#" + query : "";
	}

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	var navigator = {};
	navigator.userAgent = false;
	
	var window = {};
	/*
	 * jsrsasign(all) 7.1.2 (2017-03-20) (c) 2010-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	
	/*
	yahoo-min.js
	Copyright (c) 2011, Yahoo! Inc. All rights reserved.
	Code licensed under the BSD License:
	http://developer.yahoo.com/yui/license.html
	version: 2.9.0
	*/
	if(typeof YAHOO=="undefined"||!YAHOO){var YAHOO={};}YAHOO.namespace=function(){var b=arguments,g=null,e,c,f;for(e=0;e<b.length;e=e+1){f=(""+b[e]).split(".");g=YAHOO;for(c=(f[0]=="YAHOO")?1:0;c<f.length;c=c+1){g[f[c]]=g[f[c]]||{};g=g[f[c]];}}return g;};YAHOO.log=function(d,a,c){var b=YAHOO.widget.Logger;if(b&&b.log){return b.log(d,a,c);}else{return false;}};YAHOO.register=function(a,f,e){var k=YAHOO.env.modules,c,j,h,g,d;if(!k[a]){k[a]={versions:[],builds:[]};}c=k[a];j=e.version;h=e.build;g=YAHOO.env.listeners;c.name=a;c.version=j;c.build=h;c.versions.push(j);c.builds.push(h);c.mainClass=f;for(d=0;d<g.length;d=d+1){g[d](c);}if(f){f.VERSION=j;f.BUILD=h;}else{YAHOO.log("mainClass is undefined for module "+a,"warn");}};YAHOO.env=YAHOO.env||{modules:[],listeners:[]};YAHOO.env.getVersion=function(a){return YAHOO.env.modules[a]||null;};YAHOO.env.parseUA=function(d){var e=function(i){var j=0;return parseFloat(i.replace(/\./g,function(){return(j++==1)?"":".";}));},h=navigator,g={ie:0,opera:0,gecko:0,webkit:0,chrome:0,mobile:null,air:0,ipad:0,iphone:0,ipod:0,ios:null,android:0,webos:0,caja:h&&h.cajaVersion,secure:false,os:null},c=d||(navigator&&navigator.userAgent),f=window&&window.location,b=f&&f.href,a;g.secure=b&&(b.toLowerCase().indexOf("https")===0);if(c){if((/windows|win32/i).test(c)){g.os="windows";}else{if((/macintosh/i).test(c)){g.os="macintosh";}else{if((/rhino/i).test(c)){g.os="rhino";}}}if((/KHTML/).test(c)){g.webkit=1;}a=c.match(/AppleWebKit\/([^\s]*)/);if(a&&a[1]){g.webkit=e(a[1]);if(/ Mobile\//.test(c)){g.mobile="Apple";a=c.match(/OS ([^\s]*)/);if(a&&a[1]){a=e(a[1].replace("_","."));}g.ios=a;g.ipad=g.ipod=g.iphone=0;a=c.match(/iPad|iPod|iPhone/);if(a&&a[0]){g[a[0].toLowerCase()]=g.ios;}}else{a=c.match(/NokiaN[^\/]*|Android \d\.\d|webOS\/\d\.\d/);if(a){g.mobile=a[0];}if(/webOS/.test(c)){g.mobile="WebOS";a=c.match(/webOS\/([^\s]*);/);if(a&&a[1]){g.webos=e(a[1]);}}if(/ Android/.test(c)){g.mobile="Android";a=c.match(/Android ([^\s]*);/);if(a&&a[1]){g.android=e(a[1]);}}}a=c.match(/Chrome\/([^\s]*)/);if(a&&a[1]){g.chrome=e(a[1]);}else{a=c.match(/AdobeAIR\/([^\s]*)/);if(a){g.air=a[0];}}}if(!g.webkit){a=c.match(/Opera[\s\/]([^\s]*)/);if(a&&a[1]){g.opera=e(a[1]);a=c.match(/Version\/([^\s]*)/);if(a&&a[1]){g.opera=e(a[1]);}a=c.match(/Opera Mini[^;]*/);if(a){g.mobile=a[0];}}else{a=c.match(/MSIE\s([^;]*)/);if(a&&a[1]){g.ie=e(a[1]);}else{a=c.match(/Gecko\/([^\s]*)/);if(a){g.gecko=1;a=c.match(/rv:([^\s\)]*)/);if(a&&a[1]){g.gecko=e(a[1]);}}}}}}return g;};YAHOO.env.ua=YAHOO.env.parseUA();(function(){YAHOO.namespace("util","widget","example");if("undefined"!==typeof YAHOO_config){var b=YAHOO_config.listener,a=YAHOO.env.listeners,d=true,c;if(b){for(c=0;c<a.length;c++){if(a[c]==b){d=false;break;}}if(d){a.push(b);}}}})();YAHOO.lang=YAHOO.lang||{};(function(){var f=YAHOO.lang,a=Object.prototype,c="[object Array]",h="[object Function]",i="[object Object]",b=[],g={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","/":"&#x2F;","`":"&#x60;"},d=["toString","valueOf"],e={isArray:function(j){return a.toString.apply(j)===c;},isBoolean:function(j){return typeof j==="boolean";},isFunction:function(j){return(typeof j==="function")||a.toString.apply(j)===h;},isNull:function(j){return j===null;},isNumber:function(j){return typeof j==="number"&&isFinite(j);},isObject:function(j){return(j&&(typeof j==="object"||f.isFunction(j)))||false;},isString:function(j){return typeof j==="string";},isUndefined:function(j){return typeof j==="undefined";},_IEEnumFix:(YAHOO.env.ua.ie)?function(l,k){var j,n,m;for(j=0;j<d.length;j=j+1){n=d[j];m=k[n];if(f.isFunction(m)&&m!=a[n]){l[n]=m;}}}:function(){},escapeHTML:function(j){return j.replace(/[&<>"'\/`]/g,function(k){return g[k];});},extend:function(m,n,l){if(!n||!m){throw new Error("extend failed, please check that "+"all dependencies are included.");}var k=function(){},j;k.prototype=n.prototype;m.prototype=new k();m.prototype.constructor=m;m.superclass=n.prototype;if(n.prototype.constructor==a.constructor){n.prototype.constructor=n;}if(l){for(j in l){if(f.hasOwnProperty(l,j)){m.prototype[j]=l[j];}}f._IEEnumFix(m.prototype,l);}},augmentObject:function(n,m){if(!m||!n){throw new Error("Absorb failed, verify dependencies.");}var j=arguments,l,o,k=j[2];if(k&&k!==true){for(l=2;l<j.length;l=l+1){n[j[l]]=m[j[l]];}}else{for(o in m){if(k||!(o in n)){n[o]=m[o];}}f._IEEnumFix(n,m);}return n;},augmentProto:function(m,l){if(!l||!m){throw new Error("Augment failed, verify dependencies.");}var j=[m.prototype,l.prototype],k;for(k=2;k<arguments.length;k=k+1){j.push(arguments[k]);}f.augmentObject.apply(this,j);return m;},dump:function(j,p){var l,n,r=[],t="{...}",k="f(){...}",q=", ",m=" => ";if(!f.isObject(j)){return j+"";}else{if(j instanceof Date||("nodeType" in j&&"tagName" in j)){return j;}else{if(f.isFunction(j)){return k;}}}p=(f.isNumber(p))?p:3;if(f.isArray(j)){r.push("[");for(l=0,n=j.length;l<n;l=l+1){if(f.isObject(j[l])){r.push((p>0)?f.dump(j[l],p-1):t);}else{r.push(j[l]);}r.push(q);}if(r.length>1){r.pop();}r.push("]");}else{r.push("{");for(l in j){if(f.hasOwnProperty(j,l)){r.push(l+m);if(f.isObject(j[l])){r.push((p>0)?f.dump(j[l],p-1):t);}else{r.push(j[l]);}r.push(q);}}if(r.length>1){r.pop();}r.push("}");}return r.join("");},substitute:function(x,y,E,l){var D,C,B,G,t,u,F=[],p,z=x.length,A="dump",r=" ",q="{",m="}",n,w;for(;;){D=x.lastIndexOf(q,z);if(D<0){break;}C=x.indexOf(m,D);if(D+1>C){break;}p=x.substring(D+1,C);G=p;u=null;B=G.indexOf(r);if(B>-1){u=G.substring(B+1);G=G.substring(0,B);}t=y[G];if(E){t=E(G,t,u);}if(f.isObject(t)){if(f.isArray(t)){t=f.dump(t,parseInt(u,10));}else{u=u||"";n=u.indexOf(A);if(n>-1){u=u.substring(4);}w=t.toString();if(w===i||n>-1){t=f.dump(t,parseInt(u,10));}else{t=w;}}}else{if(!f.isString(t)&&!f.isNumber(t)){t="~-"+F.length+"-~";F[F.length]=p;}}x=x.substring(0,D)+t+x.substring(C+1);if(l===false){z=D-1;}}for(D=F.length-1;D>=0;D=D-1){x=x.replace(new RegExp("~-"+D+"-~"),"{"+F[D]+"}","g");}return x;},trim:function(j){try{return j.replace(/^\s+|\s+$/g,"");}catch(k){return j;
	}},merge:function(){var n={},k=arguments,j=k.length,m;for(m=0;m<j;m=m+1){f.augmentObject(n,k[m],true);}return n;},later:function(t,k,u,n,p){t=t||0;k=k||{};var l=u,s=n,q,j;if(f.isString(u)){l=k[u];}if(!l){throw new TypeError("method undefined");}if(!f.isUndefined(n)&&!f.isArray(s)){s=[n];}q=function(){l.apply(k,s||b);};j=(p)?setInterval(q,t):setTimeout(q,t);return{interval:p,cancel:function(){if(this.interval){clearInterval(j);}else{clearTimeout(j);}}};},isValue:function(j){return(f.isObject(j)||f.isString(j)||f.isNumber(j)||f.isBoolean(j));}};f.hasOwnProperty=(a.hasOwnProperty)?function(j,k){return j&&j.hasOwnProperty&&j.hasOwnProperty(k);}:function(j,k){return !f.isUndefined(j[k])&&j.constructor.prototype[k]!==j[k];};e.augmentObject(f,e,true);YAHOO.util.Lang=f;f.augment=f.augmentProto;YAHOO.augment=f.augmentProto;YAHOO.extend=f.extend;})();YAHOO.register("yahoo",YAHOO,{version:"2.9.0",build:"2800"});
	
	/*! CryptoJS v3.1.2 core-fix.js
	 * code.google.com/p/crypto-js
	 * (c) 2009-2013 by Jeff Mott. All rights reserved.
	 * code.google.com/p/crypto-js/wiki/License
	 * THIS IS FIX of 'core.js' to fix Hmac issue.
	 * https://code.google.com/p/crypto-js/issues/detail?id=84
	 * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
	 */
	var CryptoJS=CryptoJS||(function(e,g){var a={};var b=a.lib={};var j=b.Base=(function(){function n(){}return{extend:function(p){n.prototype=this;var o=new n();if(p){o.mixIn(p)}if(!o.hasOwnProperty("init")){o.init=function(){o.$super.init.apply(this,arguments)}}o.init.prototype=o;o.$super=this;return o},create:function(){var o=this.extend();o.init.apply(o,arguments);return o},init:function(){},mixIn:function(p){for(var o in p){if(p.hasOwnProperty(o)){this[o]=p[o]}}if(p.hasOwnProperty("toString")){this.toString=p.toString}},clone:function(){return this.init.prototype.extend(this)}}}());var l=b.WordArray=j.extend({init:function(o,n){o=this.words=o||[];if(n!=g){this.sigBytes=n}else{this.sigBytes=o.length*4}},toString:function(n){return(n||h).stringify(this)},concat:function(t){var q=this.words;var p=t.words;var n=this.sigBytes;var s=t.sigBytes;this.clamp();if(n%4){for(var r=0;r<s;r++){var o=(p[r>>>2]>>>(24-(r%4)*8))&255;q[(n+r)>>>2]|=o<<(24-((n+r)%4)*8)}}else{for(var r=0;r<s;r+=4){q[(n+r)>>>2]=p[r>>>2]}}this.sigBytes+=s;return this},clamp:function(){var o=this.words;var n=this.sigBytes;o[n>>>2]&=4294967295<<(32-(n%4)*8);o.length=e.ceil(n/4)},clone:function(){var n=j.clone.call(this);n.words=this.words.slice(0);return n},random:function(p){var o=[];for(var n=0;n<p;n+=4){o.push((e.random()*4294967296)|0)}return new l.init(o,p)}});var m=a.enc={};var h=m.Hex={stringify:function(p){var r=p.words;var o=p.sigBytes;var q=[];for(var n=0;n<o;n++){var s=(r[n>>>2]>>>(24-(n%4)*8))&255;q.push((s>>>4).toString(16));q.push((s&15).toString(16))}return q.join("")},parse:function(p){var n=p.length;var q=[];for(var o=0;o<n;o+=2){q[o>>>3]|=parseInt(p.substr(o,2),16)<<(24-(o%8)*4)}return new l.init(q,n/2)}};var d=m.Latin1={stringify:function(q){var r=q.words;var p=q.sigBytes;var n=[];for(var o=0;o<p;o++){var s=(r[o>>>2]>>>(24-(o%4)*8))&255;n.push(String.fromCharCode(s))}return n.join("")},parse:function(p){var n=p.length;var q=[];for(var o=0;o<n;o++){q[o>>>2]|=(p.charCodeAt(o)&255)<<(24-(o%4)*8)}return new l.init(q,n)}};var c=m.Utf8={stringify:function(n){try{return decodeURIComponent(escape(d.stringify(n)))}catch(o){throw new Error("Malformed UTF-8 data")}},parse:function(n){return d.parse(unescape(encodeURIComponent(n)))}};var i=b.BufferedBlockAlgorithm=j.extend({reset:function(){this._data=new l.init();this._nDataBytes=0},_append:function(n){if(typeof n=="string"){n=c.parse(n)}this._data.concat(n);this._nDataBytes+=n.sigBytes},_process:function(w){var q=this._data;var x=q.words;var n=q.sigBytes;var t=this.blockSize;var v=t*4;var u=n/v;if(w){u=e.ceil(u)}else{u=e.max((u|0)-this._minBufferSize,0)}var s=u*t;var r=e.min(s*4,n);if(s){for(var p=0;p<s;p+=t){this._doProcessBlock(x,p)}var o=x.splice(0,s);q.sigBytes-=r}return new l.init(o,r)},clone:function(){var n=j.clone.call(this);n._data=this._data.clone();return n},_minBufferSize:0});var f=b.Hasher=i.extend({cfg:j.extend(),init:function(n){this.cfg=this.cfg.extend(n);this.reset()},reset:function(){i.reset.call(this);this._doReset()},update:function(n){this._append(n);this._process();return this},finalize:function(n){if(n){this._append(n)}var o=this._doFinalize();return o},blockSize:512/32,_createHelper:function(n){return function(p,o){return new n.init(o).finalize(p)}},_createHmacHelper:function(n){return function(p,o){return new k.HMAC.init(n,o).finalize(p)}}});var k=a.algo={};return a}(Math));
	/*
	CryptoJS v3.1.2 x64-core-min.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(g){var a=CryptoJS,f=a.lib,e=f.Base,h=f.WordArray,a=a.x64={};a.Word=e.extend({init:function(b,c){this.high=b;this.low=c}});a.WordArray=e.extend({init:function(b,c){b=this.words=b||[];this.sigBytes=c!=g?c:8*b.length},toX32:function(){for(var b=this.words,c=b.length,a=[],d=0;d<c;d++){var e=b[d];a.push(e.high);a.push(e.low)}return h.create(a,this.sigBytes)},clone:function(){for(var b=e.clone.call(this),c=b.words=this.words.slice(0),a=c.length,d=0;d<a;d++)c[d]=c[d].clone();return b}})})();
	
	/*
	CryptoJS v3.1.2 cipher-core.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	CryptoJS.lib.Cipher||function(u){var g=CryptoJS,f=g.lib,k=f.Base,l=f.WordArray,q=f.BufferedBlockAlgorithm,r=g.enc.Base64,v=g.algo.EvpKDF,n=f.Cipher=q.extend({cfg:k.extend(),createEncryptor:function(a,b){return this.create(this._ENC_XFORM_MODE,a,b)},createDecryptor:function(a,b){return this.create(this._DEC_XFORM_MODE,a,b)},init:function(a,b,c){this.cfg=this.cfg.extend(c);this._xformMode=a;this._key=b;this.reset()},reset:function(){q.reset.call(this);this._doReset()},process:function(a){this._append(a);
	return this._process()},finalize:function(a){a&&this._append(a);return this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(a){return{encrypt:function(b,c,d){return("string"==typeof c?s:j).encrypt(a,b,c,d)},decrypt:function(b,c,d){return("string"==typeof c?s:j).decrypt(a,b,c,d)}}}});f.StreamCipher=n.extend({_doFinalize:function(){return this._process(!0)},blockSize:1});var m=g.mode={},t=function(a,b,c){var d=this._iv;d?this._iv=u:d=this._prevBlock;for(var e=
	0;e<c;e++)a[b+e]^=d[e]},h=(f.BlockCipherMode=k.extend({createEncryptor:function(a,b){return this.Encryptor.create(a,b)},createDecryptor:function(a,b){return this.Decryptor.create(a,b)},init:function(a,b){this._cipher=a;this._iv=b}})).extend();h.Encryptor=h.extend({processBlock:function(a,b){var c=this._cipher,d=c.blockSize;t.call(this,a,b,d);c.encryptBlock(a,b);this._prevBlock=a.slice(b,b+d)}});h.Decryptor=h.extend({processBlock:function(a,b){var c=this._cipher,d=c.blockSize,e=a.slice(b,b+d);c.decryptBlock(a,
	b);t.call(this,a,b,d);this._prevBlock=e}});m=m.CBC=h;h=(g.pad={}).Pkcs7={pad:function(a,b){for(var c=4*b,c=c-a.sigBytes%c,d=c<<24|c<<16|c<<8|c,e=[],f=0;f<c;f+=4)e.push(d);c=l.create(e,c);a.concat(c)},unpad:function(a){a.sigBytes-=a.words[a.sigBytes-1>>>2]&255}};f.BlockCipher=n.extend({cfg:n.cfg.extend({mode:m,padding:h}),reset:function(){n.reset.call(this);var a=this.cfg,b=a.iv,a=a.mode;if(this._xformMode==this._ENC_XFORM_MODE)var c=a.createEncryptor;else c=a.createDecryptor,this._minBufferSize=1;
	this._mode=c.call(a,this,b&&b.words)},_doProcessBlock:function(a,b){this._mode.processBlock(a,b)},_doFinalize:function(){var a=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){a.pad(this._data,this.blockSize);var b=this._process(!0)}else b=this._process(!0),a.unpad(b);return b},blockSize:4});var p=f.CipherParams=k.extend({init:function(a){this.mixIn(a)},toString:function(a){return(a||this.formatter).stringify(this)}}),m=(g.format={}).OpenSSL={stringify:function(a){var b=a.ciphertext;a=a.salt;
	return(a?l.create([1398893684,1701076831]).concat(a).concat(b):b).toString(r)},parse:function(a){a=r.parse(a);var b=a.words;if(1398893684==b[0]&&1701076831==b[1]){var c=l.create(b.slice(2,4));b.splice(0,4);a.sigBytes-=16}return p.create({ciphertext:a,salt:c})}},j=f.SerializableCipher=k.extend({cfg:k.extend({format:m}),encrypt:function(a,b,c,d){d=this.cfg.extend(d);var e=a.createEncryptor(c,d);b=e.finalize(b);e=e.cfg;return p.create({ciphertext:b,key:c,iv:e.iv,algorithm:a,mode:e.mode,padding:e.padding,
	blockSize:a.blockSize,formatter:d.format})},decrypt:function(a,b,c,d){d=this.cfg.extend(d);b=this._parse(b,d.format);return a.createDecryptor(c,d).finalize(b.ciphertext)},_parse:function(a,b){return"string"==typeof a?b.parse(a,this):a}}),g=(g.kdf={}).OpenSSL={execute:function(a,b,c,d){d||(d=l.random(8));a=v.create({keySize:b+c}).compute(a,d);c=l.create(a.words.slice(b),4*c);a.sigBytes=4*b;return p.create({key:a,iv:c,salt:d})}},s=f.PasswordBasedCipher=j.extend({cfg:j.cfg.extend({kdf:g}),encrypt:function(a,
	b,c,d){d=this.cfg.extend(d);c=d.kdf.execute(c,a.keySize,a.ivSize);d.iv=c.iv;a=j.encrypt.call(this,a,b,c.key,d);a.mixIn(c);return a},decrypt:function(a,b,c,d){d=this.cfg.extend(d);b=this._parse(b,d.format);c=d.kdf.execute(c,a.keySize,a.ivSize,b.salt);d.iv=c.iv;return j.decrypt.call(this,a,b,c.key,d)}})}();
	
	/*
	CryptoJS v3.1.2 aes.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(){for(var q=CryptoJS,x=q.lib.BlockCipher,r=q.algo,j=[],y=[],z=[],A=[],B=[],C=[],s=[],u=[],v=[],w=[],g=[],k=0;256>k;k++)g[k]=128>k?k<<1:k<<1^283;for(var n=0,l=0,k=0;256>k;k++){var f=l^l<<1^l<<2^l<<3^l<<4,f=f>>>8^f&255^99;j[n]=f;y[f]=n;var t=g[n],D=g[t],E=g[D],b=257*g[f]^16843008*f;z[n]=b<<24|b>>>8;A[n]=b<<16|b>>>16;B[n]=b<<8|b>>>24;C[n]=b;b=16843009*E^65537*D^257*t^16843008*n;s[f]=b<<24|b>>>8;u[f]=b<<16|b>>>16;v[f]=b<<8|b>>>24;w[f]=b;n?(n=t^g[g[g[E^t]]],l^=g[g[l]]):n=l=1}var F=[0,1,2,4,8,
	16,32,64,128,27,54],r=r.AES=x.extend({_doReset:function(){for(var c=this._key,e=c.words,a=c.sigBytes/4,c=4*((this._nRounds=a+6)+1),b=this._keySchedule=[],h=0;h<c;h++)if(h<a)b[h]=e[h];else{var d=b[h-1];h%a?6<a&&4==h%a&&(d=j[d>>>24]<<24|j[d>>>16&255]<<16|j[d>>>8&255]<<8|j[d&255]):(d=d<<8|d>>>24,d=j[d>>>24]<<24|j[d>>>16&255]<<16|j[d>>>8&255]<<8|j[d&255],d^=F[h/a|0]<<24);b[h]=b[h-a]^d}e=this._invKeySchedule=[];for(a=0;a<c;a++)h=c-a,d=a%4?b[h]:b[h-4],e[a]=4>a||4>=h?d:s[j[d>>>24]]^u[j[d>>>16&255]]^v[j[d>>>
	8&255]]^w[j[d&255]]},encryptBlock:function(c,e){this._doCryptBlock(c,e,this._keySchedule,z,A,B,C,j)},decryptBlock:function(c,e){var a=c[e+1];c[e+1]=c[e+3];c[e+3]=a;this._doCryptBlock(c,e,this._invKeySchedule,s,u,v,w,y);a=c[e+1];c[e+1]=c[e+3];c[e+3]=a},_doCryptBlock:function(c,e,a,b,h,d,j,m){for(var n=this._nRounds,f=c[e]^a[0],g=c[e+1]^a[1],k=c[e+2]^a[2],p=c[e+3]^a[3],l=4,t=1;t<n;t++)var q=b[f>>>24]^h[g>>>16&255]^d[k>>>8&255]^j[p&255]^a[l++],r=b[g>>>24]^h[k>>>16&255]^d[p>>>8&255]^j[f&255]^a[l++],s=
	b[k>>>24]^h[p>>>16&255]^d[f>>>8&255]^j[g&255]^a[l++],p=b[p>>>24]^h[f>>>16&255]^d[g>>>8&255]^j[k&255]^a[l++],f=q,g=r,k=s;q=(m[f>>>24]<<24|m[g>>>16&255]<<16|m[k>>>8&255]<<8|m[p&255])^a[l++];r=(m[g>>>24]<<24|m[k>>>16&255]<<16|m[p>>>8&255]<<8|m[f&255])^a[l++];s=(m[k>>>24]<<24|m[p>>>16&255]<<16|m[f>>>8&255]<<8|m[g&255])^a[l++];p=(m[p>>>24]<<24|m[f>>>16&255]<<16|m[g>>>8&255]<<8|m[k&255])^a[l++];c[e]=q;c[e+1]=r;c[e+2]=s;c[e+3]=p},keySize:8});q.AES=x._createHelper(r)})();
	
	/*
	CryptoJS v3.1.2 tripledes-min.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(){function j(b,c){var a=(this._lBlock>>>b^this._rBlock)&c;this._rBlock^=a;this._lBlock^=a<<b}function l(b,c){var a=(this._rBlock>>>b^this._lBlock)&c;this._lBlock^=a;this._rBlock^=a<<b}var h=CryptoJS,e=h.lib,n=e.WordArray,e=e.BlockCipher,g=h.algo,q=[57,49,41,33,25,17,9,1,58,50,42,34,26,18,10,2,59,51,43,35,27,19,11,3,60,52,44,36,63,55,47,39,31,23,15,7,62,54,46,38,30,22,14,6,61,53,45,37,29,21,13,5,28,20,12,4],p=[14,17,11,24,1,5,3,28,15,6,21,10,23,19,12,4,26,8,16,7,27,20,13,2,41,52,31,37,47,
	55,30,40,51,45,33,48,44,49,39,56,34,53,46,42,50,36,29,32],r=[1,2,4,6,8,10,12,14,15,17,19,21,23,25,27,28],s=[{"0":8421888,268435456:32768,536870912:8421378,805306368:2,1073741824:512,1342177280:8421890,1610612736:8389122,1879048192:8388608,2147483648:514,2415919104:8389120,2684354560:33280,2952790016:8421376,3221225472:32770,3489660928:8388610,3758096384:0,4026531840:33282,134217728:0,402653184:8421890,671088640:33282,939524096:32768,1207959552:8421888,1476395008:512,1744830464:8421378,2013265920:2,
	2281701376:8389120,2550136832:33280,2818572288:8421376,3087007744:8389122,3355443200:8388610,3623878656:32770,3892314112:514,4160749568:8388608,1:32768,268435457:2,536870913:8421888,805306369:8388608,1073741825:8421378,1342177281:33280,1610612737:512,1879048193:8389122,2147483649:8421890,2415919105:8421376,2684354561:8388610,2952790017:33282,3221225473:514,3489660929:8389120,3758096385:32770,4026531841:0,134217729:8421890,402653185:8421376,671088641:8388608,939524097:512,1207959553:32768,1476395009:8388610,
	1744830465:2,2013265921:33282,2281701377:32770,2550136833:8389122,2818572289:514,3087007745:8421888,3355443201:8389120,3623878657:0,3892314113:33280,4160749569:8421378},{"0":1074282512,16777216:16384,33554432:524288,50331648:1074266128,67108864:1073741840,83886080:1074282496,100663296:1073758208,117440512:16,134217728:540672,150994944:1073758224,167772160:1073741824,184549376:540688,201326592:524304,218103808:0,234881024:16400,251658240:1074266112,8388608:1073758208,25165824:540688,41943040:16,58720256:1073758224,
	75497472:1074282512,92274688:1073741824,109051904:524288,125829120:1074266128,142606336:524304,159383552:0,176160768:16384,192937984:1074266112,209715200:1073741840,226492416:540672,243269632:1074282496,260046848:16400,268435456:0,285212672:1074266128,301989888:1073758224,318767104:1074282496,335544320:1074266112,352321536:16,369098752:540688,385875968:16384,402653184:16400,419430400:524288,436207616:524304,452984832:1073741840,469762048:540672,486539264:1073758208,503316480:1073741824,520093696:1074282512,
	276824064:540688,293601280:524288,310378496:1074266112,327155712:16384,343932928:1073758208,360710144:1074282512,377487360:16,394264576:1073741824,411041792:1074282496,427819008:1073741840,444596224:1073758224,461373440:524304,478150656:0,494927872:16400,511705088:1074266128,528482304:540672},{"0":260,1048576:0,2097152:67109120,3145728:65796,4194304:65540,5242880:67108868,6291456:67174660,7340032:67174400,8388608:67108864,9437184:67174656,10485760:65792,11534336:67174404,12582912:67109124,13631488:65536,
	14680064:4,15728640:256,524288:67174656,1572864:67174404,2621440:0,3670016:67109120,4718592:67108868,5767168:65536,6815744:65540,7864320:260,8912896:4,9961472:256,11010048:67174400,12058624:65796,13107200:65792,14155776:67109124,15204352:67174660,16252928:67108864,16777216:67174656,17825792:65540,18874368:65536,19922944:67109120,20971520:256,22020096:67174660,23068672:67108868,24117248:0,25165824:67109124,26214400:67108864,27262976:4,28311552:65792,29360128:67174400,30408704:260,31457280:65796,32505856:67174404,
	17301504:67108864,18350080:260,19398656:67174656,20447232:0,21495808:65540,22544384:67109120,23592960:256,24641536:67174404,25690112:65536,26738688:67174660,27787264:65796,28835840:67108868,29884416:67109124,30932992:67174400,31981568:4,33030144:65792},{"0":2151682048,65536:2147487808,131072:4198464,196608:2151677952,262144:0,327680:4198400,393216:2147483712,458752:4194368,524288:2147483648,589824:4194304,655360:64,720896:2147487744,786432:2151678016,851968:4160,917504:4096,983040:2151682112,32768:2147487808,
	98304:64,163840:2151678016,229376:2147487744,294912:4198400,360448:2151682112,425984:0,491520:2151677952,557056:4096,622592:2151682048,688128:4194304,753664:4160,819200:2147483648,884736:4194368,950272:4198464,1015808:2147483712,1048576:4194368,1114112:4198400,1179648:2147483712,1245184:0,1310720:4160,1376256:2151678016,1441792:2151682048,1507328:2147487808,1572864:2151682112,1638400:2147483648,1703936:2151677952,1769472:4198464,1835008:2147487744,1900544:4194304,1966080:64,2031616:4096,1081344:2151677952,
	1146880:2151682112,1212416:0,1277952:4198400,1343488:4194368,1409024:2147483648,1474560:2147487808,1540096:64,1605632:2147483712,1671168:4096,1736704:2147487744,1802240:2151678016,1867776:4160,1933312:2151682048,1998848:4194304,2064384:4198464},{"0":128,4096:17039360,8192:262144,12288:536870912,16384:537133184,20480:16777344,24576:553648256,28672:262272,32768:16777216,36864:537133056,40960:536871040,45056:553910400,49152:553910272,53248:0,57344:17039488,61440:553648128,2048:17039488,6144:553648256,
	10240:128,14336:17039360,18432:262144,22528:537133184,26624:553910272,30720:536870912,34816:537133056,38912:0,43008:553910400,47104:16777344,51200:536871040,55296:553648128,59392:16777216,63488:262272,65536:262144,69632:128,73728:536870912,77824:553648256,81920:16777344,86016:553910272,90112:537133184,94208:16777216,98304:553910400,102400:553648128,106496:17039360,110592:537133056,114688:262272,118784:536871040,122880:0,126976:17039488,67584:553648256,71680:16777216,75776:17039360,79872:537133184,
	83968:536870912,88064:17039488,92160:128,96256:553910272,100352:262272,104448:553910400,108544:0,112640:553648128,116736:16777344,120832:262144,124928:537133056,129024:536871040},{"0":268435464,256:8192,512:270532608,768:270540808,1024:268443648,1280:2097152,1536:2097160,1792:268435456,2048:0,2304:268443656,2560:2105344,2816:8,3072:270532616,3328:2105352,3584:8200,3840:270540800,128:270532608,384:270540808,640:8,896:2097152,1152:2105352,1408:268435464,1664:268443648,1920:8200,2176:2097160,2432:8192,
	2688:268443656,2944:270532616,3200:0,3456:270540800,3712:2105344,3968:268435456,4096:268443648,4352:270532616,4608:270540808,4864:8200,5120:2097152,5376:268435456,5632:268435464,5888:2105344,6144:2105352,6400:0,6656:8,6912:270532608,7168:8192,7424:268443656,7680:270540800,7936:2097160,4224:8,4480:2105344,4736:2097152,4992:268435464,5248:268443648,5504:8200,5760:270540808,6016:270532608,6272:270540800,6528:270532616,6784:8192,7040:2105352,7296:2097160,7552:0,7808:268435456,8064:268443656},{"0":1048576,
	16:33555457,32:1024,48:1049601,64:34604033,80:0,96:1,112:34603009,128:33555456,144:1048577,160:33554433,176:34604032,192:34603008,208:1025,224:1049600,240:33554432,8:34603009,24:0,40:33555457,56:34604032,72:1048576,88:33554433,104:33554432,120:1025,136:1049601,152:33555456,168:34603008,184:1048577,200:1024,216:34604033,232:1,248:1049600,256:33554432,272:1048576,288:33555457,304:34603009,320:1048577,336:33555456,352:34604032,368:1049601,384:1025,400:34604033,416:1049600,432:1,448:0,464:34603008,480:33554433,
	496:1024,264:1049600,280:33555457,296:34603009,312:1,328:33554432,344:1048576,360:1025,376:34604032,392:33554433,408:34603008,424:0,440:34604033,456:1049601,472:1024,488:33555456,504:1048577},{"0":134219808,1:131072,2:134217728,3:32,4:131104,5:134350880,6:134350848,7:2048,8:134348800,9:134219776,10:133120,11:134348832,12:2080,13:0,14:134217760,15:133152,2147483648:2048,2147483649:134350880,2147483650:134219808,2147483651:134217728,2147483652:134348800,2147483653:133120,2147483654:133152,2147483655:32,
	2147483656:134217760,2147483657:2080,2147483658:131104,2147483659:134350848,2147483660:0,2147483661:134348832,2147483662:134219776,2147483663:131072,16:133152,17:134350848,18:32,19:2048,20:134219776,21:134217760,22:134348832,23:131072,24:0,25:131104,26:134348800,27:134219808,28:134350880,29:133120,30:2080,31:134217728,2147483664:131072,2147483665:2048,2147483666:134348832,2147483667:133152,2147483668:32,2147483669:134348800,2147483670:134217728,2147483671:134219808,2147483672:134350880,2147483673:134217760,
	2147483674:134219776,2147483675:0,2147483676:133120,2147483677:2080,2147483678:131104,2147483679:134350848}],t=[4160749569,528482304,33030144,2064384,129024,8064,504,2147483679],m=g.DES=e.extend({_doReset:function(){for(var b=this._key.words,c=[],a=0;56>a;a++){var f=q[a]-1;c[a]=b[f>>>5]>>>31-f%32&1}b=this._subKeys=[];for(f=0;16>f;f++){for(var d=b[f]=[],e=r[f],a=0;24>a;a++)d[a/6|0]|=c[(p[a]-1+e)%28]<<31-a%6,d[4+(a/6|0)]|=c[28+(p[a+24]-1+e)%28]<<31-a%6;d[0]=d[0]<<1|d[0]>>>31;for(a=1;7>a;a++)d[a]>>>=
	4*(a-1)+3;d[7]=d[7]<<5|d[7]>>>27}c=this._invSubKeys=[];for(a=0;16>a;a++)c[a]=b[15-a]},encryptBlock:function(b,c){this._doCryptBlock(b,c,this._subKeys)},decryptBlock:function(b,c){this._doCryptBlock(b,c,this._invSubKeys)},_doCryptBlock:function(b,c,a){this._lBlock=b[c];this._rBlock=b[c+1];j.call(this,4,252645135);j.call(this,16,65535);l.call(this,2,858993459);l.call(this,8,16711935);j.call(this,1,1431655765);for(var f=0;16>f;f++){for(var d=a[f],e=this._lBlock,h=this._rBlock,g=0,k=0;8>k;k++)g|=s[k][((h^
	d[k])&t[k])>>>0];this._lBlock=h;this._rBlock=e^g}a=this._lBlock;this._lBlock=this._rBlock;this._rBlock=a;j.call(this,1,1431655765);l.call(this,8,16711935);l.call(this,2,858993459);j.call(this,16,65535);j.call(this,4,252645135);b[c]=this._lBlock;b[c+1]=this._rBlock},keySize:2,ivSize:2,blockSize:2});h.DES=e._createHelper(m);g=g.TripleDES=e.extend({_doReset:function(){var b=this._key.words;this._des1=m.createEncryptor(n.create(b.slice(0,2)));this._des2=m.createEncryptor(n.create(b.slice(2,4)));this._des3=
	m.createEncryptor(n.create(b.slice(4,6)))},encryptBlock:function(b,c){this._des1.encryptBlock(b,c);this._des2.decryptBlock(b,c);this._des3.encryptBlock(b,c)},decryptBlock:function(b,c){this._des3.decryptBlock(b,c);this._des2.encryptBlock(b,c);this._des1.decryptBlock(b,c)},keySize:6,ivSize:2,blockSize:2});h.TripleDES=e._createHelper(g)})();
	
	/*
	CryptoJS v3.1.2 enc-base64.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(){var h=CryptoJS,j=h.lib.WordArray;h.enc.Base64={stringify:function(b){var e=b.words,f=b.sigBytes,c=this._map;b.clamp();b=[];for(var a=0;a<f;a+=3)for(var d=(e[a>>>2]>>>24-8*(a%4)&255)<<16|(e[a+1>>>2]>>>24-8*((a+1)%4)&255)<<8|e[a+2>>>2]>>>24-8*((a+2)%4)&255,g=0;4>g&&a+0.75*g<f;g++)b.push(c.charAt(d>>>6*(3-g)&63));if(e=c.charAt(64))for(;b.length%4;)b.push(e);return b.join("")},parse:function(b){var e=b.length,f=this._map,c=f.charAt(64);c&&(c=b.indexOf(c),-1!=c&&(e=c));for(var c=[],a=0,d=0;d<
	e;d++)if(d%4){var g=f.indexOf(b.charAt(d-1))<<2*(d%4),h=f.indexOf(b.charAt(d))>>>6-2*(d%4);c[a>>>2]|=(g|h)<<24-8*(a%4);a++}return j.create(c,a)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}})();
	
	/*
	CryptoJS v3.1.2 md5.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(E){function h(a,f,g,j,p,h,k){a=a+(f&g|~f&j)+p+k;return(a<<h|a>>>32-h)+f}function k(a,f,g,j,p,h,k){a=a+(f&j|g&~j)+p+k;return(a<<h|a>>>32-h)+f}function l(a,f,g,j,h,k,l){a=a+(f^g^j)+h+l;return(a<<k|a>>>32-k)+f}function n(a,f,g,j,h,k,l){a=a+(g^(f|~j))+h+l;return(a<<k|a>>>32-k)+f}for(var r=CryptoJS,q=r.lib,F=q.WordArray,s=q.Hasher,q=r.algo,a=[],t=0;64>t;t++)a[t]=4294967296*E.abs(E.sin(t+1))|0;q=q.MD5=s.extend({_doReset:function(){this._hash=new F.init([1732584193,4023233417,2562383102,271733878])},
	_doProcessBlock:function(m,f){for(var g=0;16>g;g++){var j=f+g,p=m[j];m[j]=(p<<8|p>>>24)&16711935|(p<<24|p>>>8)&4278255360}var g=this._hash.words,j=m[f+0],p=m[f+1],q=m[f+2],r=m[f+3],s=m[f+4],t=m[f+5],u=m[f+6],v=m[f+7],w=m[f+8],x=m[f+9],y=m[f+10],z=m[f+11],A=m[f+12],B=m[f+13],C=m[f+14],D=m[f+15],b=g[0],c=g[1],d=g[2],e=g[3],b=h(b,c,d,e,j,7,a[0]),e=h(e,b,c,d,p,12,a[1]),d=h(d,e,b,c,q,17,a[2]),c=h(c,d,e,b,r,22,a[3]),b=h(b,c,d,e,s,7,a[4]),e=h(e,b,c,d,t,12,a[5]),d=h(d,e,b,c,u,17,a[6]),c=h(c,d,e,b,v,22,a[7]),
	b=h(b,c,d,e,w,7,a[8]),e=h(e,b,c,d,x,12,a[9]),d=h(d,e,b,c,y,17,a[10]),c=h(c,d,e,b,z,22,a[11]),b=h(b,c,d,e,A,7,a[12]),e=h(e,b,c,d,B,12,a[13]),d=h(d,e,b,c,C,17,a[14]),c=h(c,d,e,b,D,22,a[15]),b=k(b,c,d,e,p,5,a[16]),e=k(e,b,c,d,u,9,a[17]),d=k(d,e,b,c,z,14,a[18]),c=k(c,d,e,b,j,20,a[19]),b=k(b,c,d,e,t,5,a[20]),e=k(e,b,c,d,y,9,a[21]),d=k(d,e,b,c,D,14,a[22]),c=k(c,d,e,b,s,20,a[23]),b=k(b,c,d,e,x,5,a[24]),e=k(e,b,c,d,C,9,a[25]),d=k(d,e,b,c,r,14,a[26]),c=k(c,d,e,b,w,20,a[27]),b=k(b,c,d,e,B,5,a[28]),e=k(e,b,
	c,d,q,9,a[29]),d=k(d,e,b,c,v,14,a[30]),c=k(c,d,e,b,A,20,a[31]),b=l(b,c,d,e,t,4,a[32]),e=l(e,b,c,d,w,11,a[33]),d=l(d,e,b,c,z,16,a[34]),c=l(c,d,e,b,C,23,a[35]),b=l(b,c,d,e,p,4,a[36]),e=l(e,b,c,d,s,11,a[37]),d=l(d,e,b,c,v,16,a[38]),c=l(c,d,e,b,y,23,a[39]),b=l(b,c,d,e,B,4,a[40]),e=l(e,b,c,d,j,11,a[41]),d=l(d,e,b,c,r,16,a[42]),c=l(c,d,e,b,u,23,a[43]),b=l(b,c,d,e,x,4,a[44]),e=l(e,b,c,d,A,11,a[45]),d=l(d,e,b,c,D,16,a[46]),c=l(c,d,e,b,q,23,a[47]),b=n(b,c,d,e,j,6,a[48]),e=n(e,b,c,d,v,10,a[49]),d=n(d,e,b,c,
	C,15,a[50]),c=n(c,d,e,b,t,21,a[51]),b=n(b,c,d,e,A,6,a[52]),e=n(e,b,c,d,r,10,a[53]),d=n(d,e,b,c,y,15,a[54]),c=n(c,d,e,b,p,21,a[55]),b=n(b,c,d,e,w,6,a[56]),e=n(e,b,c,d,D,10,a[57]),d=n(d,e,b,c,u,15,a[58]),c=n(c,d,e,b,B,21,a[59]),b=n(b,c,d,e,s,6,a[60]),e=n(e,b,c,d,z,10,a[61]),d=n(d,e,b,c,q,15,a[62]),c=n(c,d,e,b,x,21,a[63]);g[0]=g[0]+b|0;g[1]=g[1]+c|0;g[2]=g[2]+d|0;g[3]=g[3]+e|0},_doFinalize:function(){var a=this._data,f=a.words,g=8*this._nDataBytes,j=8*a.sigBytes;f[j>>>5]|=128<<24-j%32;var h=E.floor(g/
	4294967296);f[(j+64>>>9<<4)+15]=(h<<8|h>>>24)&16711935|(h<<24|h>>>8)&4278255360;f[(j+64>>>9<<4)+14]=(g<<8|g>>>24)&16711935|(g<<24|g>>>8)&4278255360;a.sigBytes=4*(f.length+1);this._process();a=this._hash;f=a.words;for(g=0;4>g;g++)j=f[g],f[g]=(j<<8|j>>>24)&16711935|(j<<24|j>>>8)&4278255360;return a},clone:function(){var a=s.clone.call(this);a._hash=this._hash.clone();return a}});r.MD5=s._createHelper(q);r.HmacMD5=s._createHmacHelper(q)})(Math);
	
	/*
	CryptoJS v3.1.2 sha1-min.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(){var k=CryptoJS,b=k.lib,m=b.WordArray,l=b.Hasher,d=[],b=k.algo.SHA1=l.extend({_doReset:function(){this._hash=new m.init([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(n,p){for(var a=this._hash.words,e=a[0],f=a[1],h=a[2],j=a[3],b=a[4],c=0;80>c;c++){if(16>c)d[c]=n[p+c]|0;else{var g=d[c-3]^d[c-8]^d[c-14]^d[c-16];d[c]=g<<1|g>>>31}g=(e<<5|e>>>27)+b+d[c];g=20>c?g+((f&h|~f&j)+1518500249):40>c?g+((f^h^j)+1859775393):60>c?g+((f&h|f&j|h&j)-1894007588):g+((f^h^
	j)-899497514);b=j;j=h;h=f<<30|f>>>2;f=e;e=g}a[0]=a[0]+e|0;a[1]=a[1]+f|0;a[2]=a[2]+h|0;a[3]=a[3]+j|0;a[4]=a[4]+b|0},_doFinalize:function(){var b=this._data,d=b.words,a=8*this._nDataBytes,e=8*b.sigBytes;d[e>>>5]|=128<<24-e%32;d[(e+64>>>9<<4)+14]=Math.floor(a/4294967296);d[(e+64>>>9<<4)+15]=a;b.sigBytes=4*d.length;this._process();return this._hash},clone:function(){var b=l.clone.call(this);b._hash=this._hash.clone();return b}});k.SHA1=l._createHelper(b);k.HmacSHA1=l._createHmacHelper(b)})();
	
	/*
	CryptoJS v3.1.2 sha256-min.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(k){for(var g=CryptoJS,h=g.lib,v=h.WordArray,j=h.Hasher,h=g.algo,s=[],t=[],u=function(q){return 4294967296*(q-(q|0))|0},l=2,b=0;64>b;){var d;a:{d=l;for(var w=k.sqrt(d),r=2;r<=w;r++)if(!(d%r)){d=!1;break a}d=!0}d&&(8>b&&(s[b]=u(k.pow(l,0.5))),t[b]=u(k.pow(l,1/3)),b++);l++}var n=[],h=h.SHA256=j.extend({_doReset:function(){this._hash=new v.init(s.slice(0))},_doProcessBlock:function(q,h){for(var a=this._hash.words,c=a[0],d=a[1],b=a[2],k=a[3],f=a[4],g=a[5],j=a[6],l=a[7],e=0;64>e;e++){if(16>e)n[e]=
	q[h+e]|0;else{var m=n[e-15],p=n[e-2];n[e]=((m<<25|m>>>7)^(m<<14|m>>>18)^m>>>3)+n[e-7]+((p<<15|p>>>17)^(p<<13|p>>>19)^p>>>10)+n[e-16]}m=l+((f<<26|f>>>6)^(f<<21|f>>>11)^(f<<7|f>>>25))+(f&g^~f&j)+t[e]+n[e];p=((c<<30|c>>>2)^(c<<19|c>>>13)^(c<<10|c>>>22))+(c&d^c&b^d&b);l=j;j=g;g=f;f=k+m|0;k=b;b=d;d=c;c=m+p|0}a[0]=a[0]+c|0;a[1]=a[1]+d|0;a[2]=a[2]+b|0;a[3]=a[3]+k|0;a[4]=a[4]+f|0;a[5]=a[5]+g|0;a[6]=a[6]+j|0;a[7]=a[7]+l|0},_doFinalize:function(){var d=this._data,b=d.words,a=8*this._nDataBytes,c=8*d.sigBytes;
	b[c>>>5]|=128<<24-c%32;b[(c+64>>>9<<4)+14]=k.floor(a/4294967296);b[(c+64>>>9<<4)+15]=a;d.sigBytes=4*b.length;this._process();return this._hash},clone:function(){var b=j.clone.call(this);b._hash=this._hash.clone();return b}});g.SHA256=j._createHelper(h);g.HmacSHA256=j._createHmacHelper(h)})(Math);
	
	/*
	CryptoJS v3.1.2 sha224-min.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(){var b=CryptoJS,d=b.lib.WordArray,a=b.algo,c=a.SHA256,a=a.SHA224=c.extend({_doReset:function(){this._hash=new d.init([3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428])},_doFinalize:function(){var a=c._doFinalize.call(this);a.sigBytes-=4;return a}});b.SHA224=c._createHelper(a);b.HmacSHA224=c._createHmacHelper(a)})();
	
	/*
	CryptoJS v3.1.2 sha512-min.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(){function a(){return d.create.apply(d,arguments)}for(var n=CryptoJS,r=n.lib.Hasher,e=n.x64,d=e.Word,T=e.WordArray,e=n.algo,ea=[a(1116352408,3609767458),a(1899447441,602891725),a(3049323471,3964484399),a(3921009573,2173295548),a(961987163,4081628472),a(1508970993,3053834265),a(2453635748,2937671579),a(2870763221,3664609560),a(3624381080,2734883394),a(310598401,1164996542),a(607225278,1323610764),a(1426881987,3590304994),a(1925078388,4068182383),a(2162078206,991336113),a(2614888103,633803317),
	a(3248222580,3479774868),a(3835390401,2666613458),a(4022224774,944711139),a(264347078,2341262773),a(604807628,2007800933),a(770255983,1495990901),a(1249150122,1856431235),a(1555081692,3175218132),a(1996064986,2198950837),a(2554220882,3999719339),a(2821834349,766784016),a(2952996808,2566594879),a(3210313671,3203337956),a(3336571891,1034457026),a(3584528711,2466948901),a(113926993,3758326383),a(338241895,168717936),a(666307205,1188179964),a(773529912,1546045734),a(1294757372,1522805485),a(1396182291,
	2643833823),a(1695183700,2343527390),a(1986661051,1014477480),a(2177026350,1206759142),a(2456956037,344077627),a(2730485921,1290863460),a(2820302411,3158454273),a(3259730800,3505952657),a(3345764771,106217008),a(3516065817,3606008344),a(3600352804,1432725776),a(4094571909,1467031594),a(275423344,851169720),a(430227734,3100823752),a(506948616,1363258195),a(659060556,3750685593),a(883997877,3785050280),a(958139571,3318307427),a(1322822218,3812723403),a(1537002063,2003034995),a(1747873779,3602036899),
	a(1955562222,1575990012),a(2024104815,1125592928),a(2227730452,2716904306),a(2361852424,442776044),a(2428436474,593698344),a(2756734187,3733110249),a(3204031479,2999351573),a(3329325298,3815920427),a(3391569614,3928383900),a(3515267271,566280711),a(3940187606,3454069534),a(4118630271,4000239992),a(116418474,1914138554),a(174292421,2731055270),a(289380356,3203993006),a(460393269,320620315),a(685471733,587496836),a(852142971,1086792851),a(1017036298,365543100),a(1126000580,2618297676),a(1288033470,
	3409855158),a(1501505948,4234509866),a(1607167915,987167468),a(1816402316,1246189591)],v=[],w=0;80>w;w++)v[w]=a();e=e.SHA512=r.extend({_doReset:function(){this._hash=new T.init([new d.init(1779033703,4089235720),new d.init(3144134277,2227873595),new d.init(1013904242,4271175723),new d.init(2773480762,1595750129),new d.init(1359893119,2917565137),new d.init(2600822924,725511199),new d.init(528734635,4215389547),new d.init(1541459225,327033209)])},_doProcessBlock:function(a,d){for(var f=this._hash.words,
	F=f[0],e=f[1],n=f[2],r=f[3],G=f[4],H=f[5],I=f[6],f=f[7],w=F.high,J=F.low,X=e.high,K=e.low,Y=n.high,L=n.low,Z=r.high,M=r.low,$=G.high,N=G.low,aa=H.high,O=H.low,ba=I.high,P=I.low,ca=f.high,Q=f.low,k=w,g=J,z=X,x=K,A=Y,y=L,U=Z,B=M,l=$,h=N,R=aa,C=O,S=ba,D=P,V=ca,E=Q,m=0;80>m;m++){var s=v[m];if(16>m)var j=s.high=a[d+2*m]|0,b=s.low=a[d+2*m+1]|0;else{var j=v[m-15],b=j.high,p=j.low,j=(b>>>1|p<<31)^(b>>>8|p<<24)^b>>>7,p=(p>>>1|b<<31)^(p>>>8|b<<24)^(p>>>7|b<<25),u=v[m-2],b=u.high,c=u.low,u=(b>>>19|c<<13)^(b<<
	3|c>>>29)^b>>>6,c=(c>>>19|b<<13)^(c<<3|b>>>29)^(c>>>6|b<<26),b=v[m-7],W=b.high,t=v[m-16],q=t.high,t=t.low,b=p+b.low,j=j+W+(b>>>0<p>>>0?1:0),b=b+c,j=j+u+(b>>>0<c>>>0?1:0),b=b+t,j=j+q+(b>>>0<t>>>0?1:0);s.high=j;s.low=b}var W=l&R^~l&S,t=h&C^~h&D,s=k&z^k&A^z&A,T=g&x^g&y^x&y,p=(k>>>28|g<<4)^(k<<30|g>>>2)^(k<<25|g>>>7),u=(g>>>28|k<<4)^(g<<30|k>>>2)^(g<<25|k>>>7),c=ea[m],fa=c.high,da=c.low,c=E+((h>>>14|l<<18)^(h>>>18|l<<14)^(h<<23|l>>>9)),q=V+((l>>>14|h<<18)^(l>>>18|h<<14)^(l<<23|h>>>9))+(c>>>0<E>>>0?1:
	0),c=c+t,q=q+W+(c>>>0<t>>>0?1:0),c=c+da,q=q+fa+(c>>>0<da>>>0?1:0),c=c+b,q=q+j+(c>>>0<b>>>0?1:0),b=u+T,s=p+s+(b>>>0<u>>>0?1:0),V=S,E=D,S=R,D=C,R=l,C=h,h=B+c|0,l=U+q+(h>>>0<B>>>0?1:0)|0,U=A,B=y,A=z,y=x,z=k,x=g,g=c+b|0,k=q+s+(g>>>0<c>>>0?1:0)|0}J=F.low=J+g;F.high=w+k+(J>>>0<g>>>0?1:0);K=e.low=K+x;e.high=X+z+(K>>>0<x>>>0?1:0);L=n.low=L+y;n.high=Y+A+(L>>>0<y>>>0?1:0);M=r.low=M+B;r.high=Z+U+(M>>>0<B>>>0?1:0);N=G.low=N+h;G.high=$+l+(N>>>0<h>>>0?1:0);O=H.low=O+C;H.high=aa+R+(O>>>0<C>>>0?1:0);P=I.low=P+D;
	I.high=ba+S+(P>>>0<D>>>0?1:0);Q=f.low=Q+E;f.high=ca+V+(Q>>>0<E>>>0?1:0)},_doFinalize:function(){var a=this._data,d=a.words,f=8*this._nDataBytes,e=8*a.sigBytes;d[e>>>5]|=128<<24-e%32;d[(e+128>>>10<<5)+30]=Math.floor(f/4294967296);d[(e+128>>>10<<5)+31]=f;a.sigBytes=4*d.length;this._process();return this._hash.toX32()},clone:function(){var a=r.clone.call(this);a._hash=this._hash.clone();return a},blockSize:32});n.SHA512=r._createHelper(e);n.HmacSHA512=r._createHmacHelper(e)})();
	
	/*
	CryptoJS v3.1.2 sha384-min.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(){var c=CryptoJS,a=c.x64,b=a.Word,e=a.WordArray,a=c.algo,d=a.SHA512,a=a.SHA384=d.extend({_doReset:function(){this._hash=new e.init([new b.init(3418070365,3238371032),new b.init(1654270250,914150663),new b.init(2438529370,812702999),new b.init(355462360,4144912697),new b.init(1731405415,4290775857),new b.init(2394180231,1750603025),new b.init(3675008525,1694076839),new b.init(1203062813,3204075428)])},_doFinalize:function(){var a=d._doFinalize.call(this);a.sigBytes-=16;return a}});c.SHA384=
	d._createHelper(a);c.HmacSHA384=d._createHmacHelper(a)})();
	
	/*
	CryptoJS v3.1.2 ripemd160-min.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/*
	
	(c) 2012 by Cedric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	(function(){var q=CryptoJS,d=q.lib,n=d.WordArray,p=d.Hasher,d=q.algo,x=n.create([0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13]),y=n.create([5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11]),z=n.create([11,14,15,12,
	5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6]),A=n.create([8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]),B=n.create([0,1518500249,1859775393,2400959708,2840853838]),C=n.create([1352829926,1548603684,1836072691,
	2053994217,0]),d=d.RIPEMD160=p.extend({_doReset:function(){this._hash=n.create([1732584193,4023233417,2562383102,271733878,3285377520])},_doProcessBlock:function(e,v){for(var b=0;16>b;b++){var c=v+b,f=e[c];e[c]=(f<<8|f>>>24)&16711935|(f<<24|f>>>8)&4278255360}var c=this._hash.words,f=B.words,d=C.words,n=x.words,q=y.words,p=z.words,w=A.words,t,g,h,j,r,u,k,l,m,s;u=t=c[0];k=g=c[1];l=h=c[2];m=j=c[3];s=r=c[4];for(var a,b=0;80>b;b+=1)a=t+e[v+n[b]]|0,a=16>b?a+((g^h^j)+f[0]):32>b?a+((g&h|~g&j)+f[1]):48>b?
	a+(((g|~h)^j)+f[2]):64>b?a+((g&j|h&~j)+f[3]):a+((g^(h|~j))+f[4]),a|=0,a=a<<p[b]|a>>>32-p[b],a=a+r|0,t=r,r=j,j=h<<10|h>>>22,h=g,g=a,a=u+e[v+q[b]]|0,a=16>b?a+((k^(l|~m))+d[0]):32>b?a+((k&m|l&~m)+d[1]):48>b?a+(((k|~l)^m)+d[2]):64>b?a+((k&l|~k&m)+d[3]):a+((k^l^m)+d[4]),a|=0,a=a<<w[b]|a>>>32-w[b],a=a+s|0,u=s,s=m,m=l<<10|l>>>22,l=k,k=a;a=c[1]+h+m|0;c[1]=c[2]+j+s|0;c[2]=c[3]+r+u|0;c[3]=c[4]+t+k|0;c[4]=c[0]+g+l|0;c[0]=a},_doFinalize:function(){var e=this._data,d=e.words,b=8*this._nDataBytes,c=8*e.sigBytes;
	d[c>>>5]|=128<<24-c%32;d[(c+64>>>9<<4)+14]=(b<<8|b>>>24)&16711935|(b<<24|b>>>8)&4278255360;e.sigBytes=4*(d.length+1);this._process();e=this._hash;d=e.words;for(b=0;5>b;b++)c=d[b],d[b]=(c<<8|c>>>24)&16711935|(c<<24|c>>>8)&4278255360;return e},clone:function(){var d=p.clone.call(this);d._hash=this._hash.clone();return d}});q.RIPEMD160=p._createHelper(d);q.HmacRIPEMD160=p._createHmacHelper(d)})(Math);
	
	/*
	CryptoJS v3.1.2 hmac.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(){var c=CryptoJS,k=c.enc.Utf8;c.algo.HMAC=c.lib.Base.extend({init:function(a,b){a=this._hasher=new a.init;"string"==typeof b&&(b=k.parse(b));var c=a.blockSize,e=4*c;b.sigBytes>e&&(b=a.finalize(b));b.clamp();for(var f=this._oKey=b.clone(),g=this._iKey=b.clone(),h=f.words,j=g.words,d=0;d<c;d++)h[d]^=1549556828,j[d]^=909522486;f.sigBytes=g.sigBytes=e;this.reset()},reset:function(){var a=this._hasher;a.reset();a.update(this._iKey)},update:function(a){this._hasher.update(a);return this},finalize:function(a){var b=
	this._hasher;a=b.finalize(a);b.reset();return b.finalize(this._oKey.clone().concat(a))}})})();
	
	/*
	CryptoJS v3.1.2 pbkdf2-min.js
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	(function(){var b=CryptoJS,a=b.lib,d=a.Base,m=a.WordArray,a=b.algo,q=a.HMAC,l=a.PBKDF2=d.extend({cfg:d.extend({keySize:4,hasher:a.SHA1,iterations:1}),init:function(a){this.cfg=this.cfg.extend(a)},compute:function(a,b){for(var c=this.cfg,f=q.create(c.hasher,a),g=m.create(),d=m.create([1]),l=g.words,r=d.words,n=c.keySize,c=c.iterations;l.length<n;){var h=f.update(b).finalize(d);f.reset();for(var j=h.words,s=j.length,k=h,p=1;p<c;p++){k=f.finalize(k);f.reset();for(var t=k.words,e=0;e<s;e++)j[e]^=t[e]}g.concat(h);
	r[0]++}g.sigBytes=4*n;return g}});b.PBKDF2=function(a,b,c){return l.create(c).compute(a,b)}})();
	
	/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
	var b64map="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";var b64pad="=";function hex2b64(d){var b;var e;var a="";for(b=0;b+3<=d.length;b+=3){e=parseInt(d.substring(b,b+3),16);a+=b64map.charAt(e>>6)+b64map.charAt(e&63)}if(b+1==d.length){e=parseInt(d.substring(b,b+1),16);a+=b64map.charAt(e<<2)}else{if(b+2==d.length){e=parseInt(d.substring(b,b+2),16);a+=b64map.charAt(e>>2)+b64map.charAt((e&3)<<4)}}if(b64pad){while((a.length&3)>0){a+=b64pad}}return a}function b64tohex(f){var d="";var e;var b=0;var c;var a;for(e=0;e<f.length;++e){if(f.charAt(e)==b64pad){break}a=b64map.indexOf(f.charAt(e));if(a<0){continue}if(b==0){d+=int2char(a>>2);c=a&3;b=1}else{if(b==1){d+=int2char((c<<2)|(a>>4));c=a&15;b=2}else{if(b==2){d+=int2char(c);d+=int2char(a>>2);c=a&3;b=3}else{d+=int2char((c<<2)|(a>>4));d+=int2char(a&15);b=0}}}}if(b==1){d+=int2char(c<<2)}return d}function b64toBA(e){var d=b64tohex(e);var c;var b=new Array();for(c=0;2*c<d.length;++c){b[c]=parseInt(d.substring(2*c,2*c+2),16)}return b};
	/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
	var dbits;var canary=244837814094590;var j_lm=((canary&16777215)==15715070);function BigInteger(e,d,f){if(e!=null){if("number"==typeof e){this.fromNumber(e,d,f)}else{if(d==null&&"string"!=typeof e){this.fromString(e,256)}else{this.fromString(e,d)}}}}function nbi(){return new BigInteger(null)}function am1(f,a,b,e,h,g){while(--g>=0){var d=a*this[f++]+b[e]+h;h=Math.floor(d/67108864);b[e++]=d&67108863}return h}function am2(f,q,r,e,o,a){var k=q&32767,p=q>>15;while(--a>=0){var d=this[f]&32767;var g=this[f++]>>15;var b=p*d+g*k;d=k*d+((b&32767)<<15)+r[e]+(o&1073741823);o=(d>>>30)+(b>>>15)+p*g+(o>>>30);r[e++]=d&1073741823}return o}function am3(f,q,r,e,o,a){var k=q&16383,p=q>>14;while(--a>=0){var d=this[f]&16383;var g=this[f++]>>14;var b=p*d+g*k;d=k*d+((b&16383)<<14)+r[e]+o;o=(d>>28)+(b>>14)+p*g;r[e++]=d&268435455}return o}if(j_lm&&(navigator.appName=="Microsoft Internet Explorer")){BigInteger.prototype.am=am2;dbits=30}else{if(j_lm&&(navigator.appName!="Netscape")){BigInteger.prototype.am=am1;dbits=26}else{BigInteger.prototype.am=am3;dbits=28}}BigInteger.prototype.DB=dbits;BigInteger.prototype.DM=((1<<dbits)-1);BigInteger.prototype.DV=(1<<dbits);var BI_FP=52;BigInteger.prototype.FV=Math.pow(2,BI_FP);BigInteger.prototype.F1=BI_FP-dbits;BigInteger.prototype.F2=2*dbits-BI_FP;var BI_RM="0123456789abcdefghijklmnopqrstuvwxyz";var BI_RC=new Array();var rr,vv;rr="0".charCodeAt(0);for(vv=0;vv<=9;++vv){BI_RC[rr++]=vv}rr="a".charCodeAt(0);for(vv=10;vv<36;++vv){BI_RC[rr++]=vv}rr="A".charCodeAt(0);for(vv=10;vv<36;++vv){BI_RC[rr++]=vv}function int2char(a){return BI_RM.charAt(a)}function intAt(b,a){var d=BI_RC[b.charCodeAt(a)];return(d==null)?-1:d}function bnpCopyTo(b){for(var a=this.t-1;a>=0;--a){b[a]=this[a]}b.t=this.t;b.s=this.s}function bnpFromInt(a){this.t=1;this.s=(a<0)?-1:0;if(a>0){this[0]=a}else{if(a<-1){this[0]=a+this.DV}else{this.t=0}}}function nbv(a){var b=nbi();b.fromInt(a);return b}function bnpFromString(h,c){var e;if(c==16){e=4}else{if(c==8){e=3}else{if(c==256){e=8}else{if(c==2){e=1}else{if(c==32){e=5}else{if(c==4){e=2}else{this.fromRadix(h,c);return}}}}}}this.t=0;this.s=0;var g=h.length,d=false,f=0;while(--g>=0){var a=(e==8)?h[g]&255:intAt(h,g);if(a<0){if(h.charAt(g)=="-"){d=true}continue}d=false;if(f==0){this[this.t++]=a}else{if(f+e>this.DB){this[this.t-1]|=(a&((1<<(this.DB-f))-1))<<f;this[this.t++]=(a>>(this.DB-f))}else{this[this.t-1]|=a<<f}}f+=e;if(f>=this.DB){f-=this.DB}}if(e==8&&(h[0]&128)!=0){this.s=-1;if(f>0){this[this.t-1]|=((1<<(this.DB-f))-1)<<f}}this.clamp();if(d){BigInteger.ZERO.subTo(this,this)}}function bnpClamp(){var a=this.s&this.DM;while(this.t>0&&this[this.t-1]==a){--this.t}}function bnToString(c){if(this.s<0){return"-"+this.negate().toString(c)}var e;if(c==16){e=4}else{if(c==8){e=3}else{if(c==2){e=1}else{if(c==32){e=5}else{if(c==4){e=2}else{return this.toRadix(c)}}}}}var g=(1<<e)-1,l,a=false,h="",f=this.t;var j=this.DB-(f*this.DB)%e;if(f-->0){if(j<this.DB&&(l=this[f]>>j)>0){a=true;h=int2char(l)}while(f>=0){if(j<e){l=(this[f]&((1<<j)-1))<<(e-j);l|=this[--f]>>(j+=this.DB-e)}else{l=(this[f]>>(j-=e))&g;if(j<=0){j+=this.DB;--f}}if(l>0){a=true}if(a){h+=int2char(l)}}}return a?h:"0"}function bnNegate(){var a=nbi();BigInteger.ZERO.subTo(this,a);return a}function bnAbs(){return(this.s<0)?this.negate():this}function bnCompareTo(b){var d=this.s-b.s;if(d!=0){return d}var c=this.t;d=c-b.t;if(d!=0){return(this.s<0)?-d:d}while(--c>=0){if((d=this[c]-b[c])!=0){return d}}return 0}function nbits(a){var c=1,b;if((b=a>>>16)!=0){a=b;c+=16}if((b=a>>8)!=0){a=b;c+=8}if((b=a>>4)!=0){a=b;c+=4}if((b=a>>2)!=0){a=b;c+=2}if((b=a>>1)!=0){a=b;c+=1}return c}function bnBitLength(){if(this.t<=0){return 0}return this.DB*(this.t-1)+nbits(this[this.t-1]^(this.s&this.DM))}function bnpDLShiftTo(c,b){var a;for(a=this.t-1;a>=0;--a){b[a+c]=this[a]}for(a=c-1;a>=0;--a){b[a]=0}b.t=this.t+c;b.s=this.s}function bnpDRShiftTo(c,b){for(var a=c;a<this.t;++a){b[a-c]=this[a]}b.t=Math.max(this.t-c,0);b.s=this.s}function bnpLShiftTo(j,e){var b=j%this.DB;var a=this.DB-b;var g=(1<<a)-1;var f=Math.floor(j/this.DB),h=(this.s<<b)&this.DM,d;for(d=this.t-1;d>=0;--d){e[d+f+1]=(this[d]>>a)|h;h=(this[d]&g)<<b}for(d=f-1;d>=0;--d){e[d]=0}e[f]=h;e.t=this.t+f+1;e.s=this.s;e.clamp()}function bnpRShiftTo(g,d){d.s=this.s;var e=Math.floor(g/this.DB);if(e>=this.t){d.t=0;return}var b=g%this.DB;var a=this.DB-b;var f=(1<<b)-1;d[0]=this[e]>>b;for(var c=e+1;c<this.t;++c){d[c-e-1]|=(this[c]&f)<<a;d[c-e]=this[c]>>b}if(b>0){d[this.t-e-1]|=(this.s&f)<<a}d.t=this.t-e;d.clamp()}function bnpSubTo(d,f){var e=0,g=0,b=Math.min(d.t,this.t);while(e<b){g+=this[e]-d[e];f[e++]=g&this.DM;g>>=this.DB}if(d.t<this.t){g-=d.s;while(e<this.t){g+=this[e];f[e++]=g&this.DM;g>>=this.DB}g+=this.s}else{g+=this.s;while(e<d.t){g-=d[e];f[e++]=g&this.DM;g>>=this.DB}g-=d.s}f.s=(g<0)?-1:0;if(g<-1){f[e++]=this.DV+g}else{if(g>0){f[e++]=g}}f.t=e;f.clamp()}function bnpMultiplyTo(c,e){var b=this.abs(),f=c.abs();var d=b.t;e.t=d+f.t;while(--d>=0){e[d]=0}for(d=0;d<f.t;++d){e[d+b.t]=b.am(0,f[d],e,d,0,b.t)}e.s=0;e.clamp();if(this.s!=c.s){BigInteger.ZERO.subTo(e,e)}}function bnpSquareTo(d){var a=this.abs();var b=d.t=2*a.t;while(--b>=0){d[b]=0}for(b=0;b<a.t-1;++b){var e=a.am(b,a[b],d,2*b,0,1);if((d[b+a.t]+=a.am(b+1,2*a[b],d,2*b+1,e,a.t-b-1))>=a.DV){d[b+a.t]-=a.DV;d[b+a.t+1]=1}}if(d.t>0){d[d.t-1]+=a.am(b,a[b],d,2*b,0,1)}d.s=0;d.clamp()}function bnpDivRemTo(n,h,g){var w=n.abs();if(w.t<=0){return}var k=this.abs();if(k.t<w.t){if(h!=null){h.fromInt(0)}if(g!=null){this.copyTo(g)}return}if(g==null){g=nbi()}var d=nbi(),a=this.s,l=n.s;var v=this.DB-nbits(w[w.t-1]);if(v>0){w.lShiftTo(v,d);k.lShiftTo(v,g)}else{w.copyTo(d);k.copyTo(g)}var p=d.t;var b=d[p-1];if(b==0){return}var o=b*(1<<this.F1)+((p>1)?d[p-2]>>this.F2:0);var A=this.FV/o,z=(1<<this.F1)/o,x=1<<this.F2;var u=g.t,s=u-p,f=(h==null)?nbi():h;d.dlShiftTo(s,f);if(g.compareTo(f)>=0){g[g.t++]=1;g.subTo(f,g)}BigInteger.ONE.dlShiftTo(p,f);f.subTo(d,d);while(d.t<p){d[d.t++]=0}while(--s>=0){var c=(g[--u]==b)?this.DM:Math.floor(g[u]*A+(g[u-1]+x)*z);if((g[u]+=d.am(0,c,g,s,0,p))<c){d.dlShiftTo(s,f);g.subTo(f,g);while(g[u]<--c){g.subTo(f,g)}}}if(h!=null){g.drShiftTo(p,h);if(a!=l){BigInteger.ZERO.subTo(h,h)}}g.t=p;g.clamp();if(v>0){g.rShiftTo(v,g)}if(a<0){BigInteger.ZERO.subTo(g,g)}}function bnMod(b){var c=nbi();this.abs().divRemTo(b,null,c);if(this.s<0&&c.compareTo(BigInteger.ZERO)>0){b.subTo(c,c)}return c}function Classic(a){this.m=a}function cConvert(a){if(a.s<0||a.compareTo(this.m)>=0){return a.mod(this.m)}else{return a}}function cRevert(a){return a}function cReduce(a){a.divRemTo(this.m,null,a)}function cMulTo(a,c,b){a.multiplyTo(c,b);this.reduce(b)}function cSqrTo(a,b){a.squareTo(b);this.reduce(b)}Classic.prototype.convert=cConvert;Classic.prototype.revert=cRevert;Classic.prototype.reduce=cReduce;Classic.prototype.mulTo=cMulTo;Classic.prototype.sqrTo=cSqrTo;function bnpInvDigit(){if(this.t<1){return 0}var a=this[0];if((a&1)==0){return 0}var b=a&3;b=(b*(2-(a&15)*b))&15;b=(b*(2-(a&255)*b))&255;b=(b*(2-(((a&65535)*b)&65535)))&65535;b=(b*(2-a*b%this.DV))%this.DV;return(b>0)?this.DV-b:-b}function Montgomery(a){this.m=a;this.mp=a.invDigit();this.mpl=this.mp&32767;this.mph=this.mp>>15;this.um=(1<<(a.DB-15))-1;this.mt2=2*a.t}function montConvert(a){var b=nbi();a.abs().dlShiftTo(this.m.t,b);b.divRemTo(this.m,null,b);if(a.s<0&&b.compareTo(BigInteger.ZERO)>0){this.m.subTo(b,b)}return b}function montRevert(a){var b=nbi();a.copyTo(b);this.reduce(b);return b}function montReduce(a){while(a.t<=this.mt2){a[a.t++]=0}for(var c=0;c<this.m.t;++c){var b=a[c]&32767;var d=(b*this.mpl+(((b*this.mph+(a[c]>>15)*this.mpl)&this.um)<<15))&a.DM;b=c+this.m.t;a[b]+=this.m.am(0,d,a,c,0,this.m.t);while(a[b]>=a.DV){a[b]-=a.DV;a[++b]++}}a.clamp();a.drShiftTo(this.m.t,a);if(a.compareTo(this.m)>=0){a.subTo(this.m,a)}}function montSqrTo(a,b){a.squareTo(b);this.reduce(b)}function montMulTo(a,c,b){a.multiplyTo(c,b);this.reduce(b)}Montgomery.prototype.convert=montConvert;Montgomery.prototype.revert=montRevert;Montgomery.prototype.reduce=montReduce;Montgomery.prototype.mulTo=montMulTo;Montgomery.prototype.sqrTo=montSqrTo;function bnpIsEven(){return((this.t>0)?(this[0]&1):this.s)==0}function bnpExp(h,j){if(h>4294967295||h<1){return BigInteger.ONE}var f=nbi(),a=nbi(),d=j.convert(this),c=nbits(h)-1;d.copyTo(f);while(--c>=0){j.sqrTo(f,a);if((h&(1<<c))>0){j.mulTo(a,d,f)}else{var b=f;f=a;a=b}}return j.revert(f)}function bnModPowInt(b,a){var c;if(b<256||a.isEven()){c=new Classic(a)}else{c=new Montgomery(a)}return this.exp(b,c)}BigInteger.prototype.copyTo=bnpCopyTo;BigInteger.prototype.fromInt=bnpFromInt;BigInteger.prototype.fromString=bnpFromString;BigInteger.prototype.clamp=bnpClamp;BigInteger.prototype.dlShiftTo=bnpDLShiftTo;BigInteger.prototype.drShiftTo=bnpDRShiftTo;BigInteger.prototype.lShiftTo=bnpLShiftTo;BigInteger.prototype.rShiftTo=bnpRShiftTo;BigInteger.prototype.subTo=bnpSubTo;BigInteger.prototype.multiplyTo=bnpMultiplyTo;BigInteger.prototype.squareTo=bnpSquareTo;BigInteger.prototype.divRemTo=bnpDivRemTo;BigInteger.prototype.invDigit=bnpInvDigit;BigInteger.prototype.isEven=bnpIsEven;BigInteger.prototype.exp=bnpExp;BigInteger.prototype.toString=bnToString;BigInteger.prototype.negate=bnNegate;BigInteger.prototype.abs=bnAbs;BigInteger.prototype.compareTo=bnCompareTo;BigInteger.prototype.bitLength=bnBitLength;BigInteger.prototype.mod=bnMod;BigInteger.prototype.modPowInt=bnModPowInt;BigInteger.ZERO=nbv(0);BigInteger.ONE=nbv(1);
	/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
	function bnClone(){var a=nbi();this.copyTo(a);return a}function bnIntValue(){if(this.s<0){if(this.t==1){return this[0]-this.DV}else{if(this.t==0){return -1}}}else{if(this.t==1){return this[0]}else{if(this.t==0){return 0}}}return((this[1]&((1<<(32-this.DB))-1))<<this.DB)|this[0]}function bnByteValue(){return(this.t==0)?this.s:(this[0]<<24)>>24}function bnShortValue(){return(this.t==0)?this.s:(this[0]<<16)>>16}function bnpChunkSize(a){return Math.floor(Math.LN2*this.DB/Math.log(a))}function bnSigNum(){if(this.s<0){return -1}else{if(this.t<=0||(this.t==1&&this[0]<=0)){return 0}else{return 1}}}function bnpToRadix(c){if(c==null){c=10}if(this.signum()==0||c<2||c>36){return"0"}var f=this.chunkSize(c);var e=Math.pow(c,f);var i=nbv(e),j=nbi(),h=nbi(),g="";this.divRemTo(i,j,h);while(j.signum()>0){g=(e+h.intValue()).toString(c).substr(1)+g;j.divRemTo(i,j,h)}return h.intValue().toString(c)+g}function bnpFromRadix(m,h){this.fromInt(0);if(h==null){h=10}var f=this.chunkSize(h);var g=Math.pow(h,f),e=false,a=0,l=0;for(var c=0;c<m.length;++c){var k=intAt(m,c);if(k<0){if(m.charAt(c)=="-"&&this.signum()==0){e=true}continue}l=h*l+k;if(++a>=f){this.dMultiply(g);this.dAddOffset(l,0);a=0;l=0}}if(a>0){this.dMultiply(Math.pow(h,a));this.dAddOffset(l,0)}if(e){BigInteger.ZERO.subTo(this,this)}}function bnpFromNumber(f,e,h){if("number"==typeof e){if(f<2){this.fromInt(1)}else{this.fromNumber(f,h);if(!this.testBit(f-1)){this.bitwiseTo(BigInteger.ONE.shiftLeft(f-1),op_or,this)}if(this.isEven()){this.dAddOffset(1,0)}while(!this.isProbablePrime(e)){this.dAddOffset(2,0);if(this.bitLength()>f){this.subTo(BigInteger.ONE.shiftLeft(f-1),this)}}}}else{var d=new Array(),g=f&7;d.length=(f>>3)+1;e.nextBytes(d);if(g>0){d[0]&=((1<<g)-1)}else{d[0]=0}this.fromString(d,256)}}function bnToByteArray(){var b=this.t,c=new Array();c[0]=this.s;var e=this.DB-(b*this.DB)%8,f,a=0;if(b-->0){if(e<this.DB&&(f=this[b]>>e)!=(this.s&this.DM)>>e){c[a++]=f|(this.s<<(this.DB-e))}while(b>=0){if(e<8){f=(this[b]&((1<<e)-1))<<(8-e);f|=this[--b]>>(e+=this.DB-8)}else{f=(this[b]>>(e-=8))&255;if(e<=0){e+=this.DB;--b}}if((f&128)!=0){f|=-256}if(a==0&&(this.s&128)!=(f&128)){++a}if(a>0||f!=this.s){c[a++]=f}}}return c}function bnEquals(b){return(this.compareTo(b)==0)}function bnMin(b){return(this.compareTo(b)<0)?this:b}function bnMax(b){return(this.compareTo(b)>0)?this:b}function bnpBitwiseTo(c,h,e){var d,g,b=Math.min(c.t,this.t);for(d=0;d<b;++d){e[d]=h(this[d],c[d])}if(c.t<this.t){g=c.s&this.DM;for(d=b;d<this.t;++d){e[d]=h(this[d],g)}e.t=this.t}else{g=this.s&this.DM;for(d=b;d<c.t;++d){e[d]=h(g,c[d])}e.t=c.t}e.s=h(this.s,c.s);e.clamp()}function op_and(a,b){return a&b}function bnAnd(b){var c=nbi();this.bitwiseTo(b,op_and,c);return c}function op_or(a,b){return a|b}function bnOr(b){var c=nbi();this.bitwiseTo(b,op_or,c);return c}function op_xor(a,b){return a^b}function bnXor(b){var c=nbi();this.bitwiseTo(b,op_xor,c);return c}function op_andnot(a,b){return a&~b}function bnAndNot(b){var c=nbi();this.bitwiseTo(b,op_andnot,c);return c}function bnNot(){var b=nbi();for(var a=0;a<this.t;++a){b[a]=this.DM&~this[a]}b.t=this.t;b.s=~this.s;return b}function bnShiftLeft(b){var a=nbi();if(b<0){this.rShiftTo(-b,a)}else{this.lShiftTo(b,a)}return a}function bnShiftRight(b){var a=nbi();if(b<0){this.lShiftTo(-b,a)}else{this.rShiftTo(b,a)}return a}function lbit(a){if(a==0){return -1}var b=0;if((a&65535)==0){a>>=16;b+=16}if((a&255)==0){a>>=8;b+=8}if((a&15)==0){a>>=4;b+=4}if((a&3)==0){a>>=2;b+=2}if((a&1)==0){++b}return b}function bnGetLowestSetBit(){for(var a=0;a<this.t;++a){if(this[a]!=0){return a*this.DB+lbit(this[a])}}if(this.s<0){return this.t*this.DB}return -1}function cbit(a){var b=0;while(a!=0){a&=a-1;++b}return b}function bnBitCount(){var c=0,a=this.s&this.DM;for(var b=0;b<this.t;++b){c+=cbit(this[b]^a)}return c}function bnTestBit(b){var a=Math.floor(b/this.DB);if(a>=this.t){return(this.s!=0)}return((this[a]&(1<<(b%this.DB)))!=0)}function bnpChangeBit(c,b){var a=BigInteger.ONE.shiftLeft(c);this.bitwiseTo(a,b,a);return a}function bnSetBit(a){return this.changeBit(a,op_or)}function bnClearBit(a){return this.changeBit(a,op_andnot)}function bnFlipBit(a){return this.changeBit(a,op_xor)}function bnpAddTo(d,f){var e=0,g=0,b=Math.min(d.t,this.t);while(e<b){g+=this[e]+d[e];f[e++]=g&this.DM;g>>=this.DB}if(d.t<this.t){g+=d.s;while(e<this.t){g+=this[e];f[e++]=g&this.DM;g>>=this.DB}g+=this.s}else{g+=this.s;while(e<d.t){g+=d[e];f[e++]=g&this.DM;g>>=this.DB}g+=d.s}f.s=(g<0)?-1:0;if(g>0){f[e++]=g}else{if(g<-1){f[e++]=this.DV+g}}f.t=e;f.clamp()}function bnAdd(b){var c=nbi();this.addTo(b,c);return c}function bnSubtract(b){var c=nbi();this.subTo(b,c);return c}function bnMultiply(b){var c=nbi();this.multiplyTo(b,c);return c}function bnSquare(){var a=nbi();this.squareTo(a);return a}function bnDivide(b){var c=nbi();this.divRemTo(b,c,null);return c}function bnRemainder(b){var c=nbi();this.divRemTo(b,null,c);return c}function bnDivideAndRemainder(b){var d=nbi(),c=nbi();this.divRemTo(b,d,c);return new Array(d,c)}function bnpDMultiply(a){this[this.t]=this.am(0,a-1,this,0,0,this.t);++this.t;this.clamp()}function bnpDAddOffset(b,a){if(b==0){return}while(this.t<=a){this[this.t++]=0}this[a]+=b;while(this[a]>=this.DV){this[a]-=this.DV;if(++a>=this.t){this[this.t++]=0}++this[a]}}function NullExp(){}function nNop(a){return a}function nMulTo(a,c,b){a.multiplyTo(c,b)}function nSqrTo(a,b){a.squareTo(b)}NullExp.prototype.convert=nNop;NullExp.prototype.revert=nNop;NullExp.prototype.mulTo=nMulTo;NullExp.prototype.sqrTo=nSqrTo;function bnPow(a){return this.exp(a,new NullExp())}function bnpMultiplyLowerTo(b,f,e){var d=Math.min(this.t+b.t,f);e.s=0;e.t=d;while(d>0){e[--d]=0}var c;for(c=e.t-this.t;d<c;++d){e[d+this.t]=this.am(0,b[d],e,d,0,this.t)}for(c=Math.min(b.t,f);d<c;++d){this.am(0,b[d],e,d,0,f-d)}e.clamp()}function bnpMultiplyUpperTo(b,e,d){--e;var c=d.t=this.t+b.t-e;d.s=0;while(--c>=0){d[c]=0}for(c=Math.max(e-this.t,0);c<b.t;++c){d[this.t+c-e]=this.am(e-c,b[c],d,0,0,this.t+c-e)}d.clamp();d.drShiftTo(1,d)}function Barrett(a){this.r2=nbi();this.q3=nbi();BigInteger.ONE.dlShiftTo(2*a.t,this.r2);this.mu=this.r2.divide(a);this.m=a}function barrettConvert(a){if(a.s<0||a.t>2*this.m.t){return a.mod(this.m)}else{if(a.compareTo(this.m)<0){return a}else{var b=nbi();a.copyTo(b);this.reduce(b);return b}}}function barrettRevert(a){return a}function barrettReduce(a){a.drShiftTo(this.m.t-1,this.r2);if(a.t>this.m.t+1){a.t=this.m.t+1;a.clamp()}this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3);this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);while(a.compareTo(this.r2)<0){a.dAddOffset(1,this.m.t+1)}a.subTo(this.r2,a);while(a.compareTo(this.m)>=0){a.subTo(this.m,a)}}function barrettSqrTo(a,b){a.squareTo(b);this.reduce(b)}function barrettMulTo(a,c,b){a.multiplyTo(c,b);this.reduce(b)}Barrett.prototype.convert=barrettConvert;Barrett.prototype.revert=barrettRevert;Barrett.prototype.reduce=barrettReduce;Barrett.prototype.mulTo=barrettMulTo;Barrett.prototype.sqrTo=barrettSqrTo;function bnModPow(q,f){var o=q.bitLength(),h,b=nbv(1),v;if(o<=0){return b}else{if(o<18){h=1}else{if(o<48){h=3}else{if(o<144){h=4}else{if(o<768){h=5}else{h=6}}}}}if(o<8){v=new Classic(f)}else{if(f.isEven()){v=new Barrett(f)}else{v=new Montgomery(f)}}var p=new Array(),d=3,s=h-1,a=(1<<h)-1;p[1]=v.convert(this);if(h>1){var A=nbi();v.sqrTo(p[1],A);while(d<=a){p[d]=nbi();v.mulTo(A,p[d-2],p[d]);d+=2}}var l=q.t-1,x,u=true,c=nbi(),y;o=nbits(q[l])-1;while(l>=0){if(o>=s){x=(q[l]>>(o-s))&a}else{x=(q[l]&((1<<(o+1))-1))<<(s-o);if(l>0){x|=q[l-1]>>(this.DB+o-s)}}d=h;while((x&1)==0){x>>=1;--d}if((o-=d)<0){o+=this.DB;--l}if(u){p[x].copyTo(b);u=false}else{while(d>1){v.sqrTo(b,c);v.sqrTo(c,b);d-=2}if(d>0){v.sqrTo(b,c)}else{y=b;b=c;c=y}v.mulTo(c,p[x],b)}while(l>=0&&(q[l]&(1<<o))==0){v.sqrTo(b,c);y=b;b=c;c=y;if(--o<0){o=this.DB-1;--l}}}return v.revert(b)}function bnGCD(c){var b=(this.s<0)?this.negate():this.clone();var h=(c.s<0)?c.negate():c.clone();if(b.compareTo(h)<0){var e=b;b=h;h=e}var d=b.getLowestSetBit(),f=h.getLowestSetBit();if(f<0){return b}if(d<f){f=d}if(f>0){b.rShiftTo(f,b);h.rShiftTo(f,h)}while(b.signum()>0){if((d=b.getLowestSetBit())>0){b.rShiftTo(d,b)}if((d=h.getLowestSetBit())>0){h.rShiftTo(d,h)}if(b.compareTo(h)>=0){b.subTo(h,b);b.rShiftTo(1,b)}else{h.subTo(b,h);h.rShiftTo(1,h)}}if(f>0){h.lShiftTo(f,h)}return h}function bnpModInt(e){if(e<=0){return 0}var c=this.DV%e,b=(this.s<0)?e-1:0;if(this.t>0){if(c==0){b=this[0]%e}else{for(var a=this.t-1;a>=0;--a){b=(c*b+this[a])%e}}}return b}function bnModInverse(f){var j=f.isEven();if((this.isEven()&&j)||f.signum()==0){return BigInteger.ZERO}var i=f.clone(),h=this.clone();var g=nbv(1),e=nbv(0),l=nbv(0),k=nbv(1);while(i.signum()!=0){while(i.isEven()){i.rShiftTo(1,i);if(j){if(!g.isEven()||!e.isEven()){g.addTo(this,g);e.subTo(f,e)}g.rShiftTo(1,g)}else{if(!e.isEven()){e.subTo(f,e)}}e.rShiftTo(1,e)}while(h.isEven()){h.rShiftTo(1,h);if(j){if(!l.isEven()||!k.isEven()){l.addTo(this,l);k.subTo(f,k)}l.rShiftTo(1,l)}else{if(!k.isEven()){k.subTo(f,k)}}k.rShiftTo(1,k)}if(i.compareTo(h)>=0){i.subTo(h,i);if(j){g.subTo(l,g)}e.subTo(k,e)}else{h.subTo(i,h);if(j){l.subTo(g,l)}k.subTo(e,k)}}if(h.compareTo(BigInteger.ONE)!=0){return BigInteger.ZERO}if(k.compareTo(f)>=0){return k.subtract(f)}if(k.signum()<0){k.addTo(f,k)}else{return k}if(k.signum()<0){return k.add(f)}else{return k}}var lowprimes=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997];var lplim=(1<<26)/lowprimes[lowprimes.length-1];function bnIsProbablePrime(e){var d,b=this.abs();if(b.t==1&&b[0]<=lowprimes[lowprimes.length-1]){for(d=0;d<lowprimes.length;++d){if(b[0]==lowprimes[d]){return true}}return false}if(b.isEven()){return false}d=1;while(d<lowprimes.length){var a=lowprimes[d],c=d+1;while(c<lowprimes.length&&a<lplim){a*=lowprimes[c++]}a=b.modInt(a);while(d<c){if(a%lowprimes[d++]==0){return false}}}return b.millerRabin(e)}function bnpMillerRabin(f){var g=this.subtract(BigInteger.ONE);var c=g.getLowestSetBit();if(c<=0){return false}var h=g.shiftRight(c);f=(f+1)>>1;if(f>lowprimes.length){f=lowprimes.length}var b=nbi();for(var e=0;e<f;++e){b.fromInt(lowprimes[Math.floor(Math.random()*lowprimes.length)]);var l=b.modPow(h,this);if(l.compareTo(BigInteger.ONE)!=0&&l.compareTo(g)!=0){var d=1;while(d++<c&&l.compareTo(g)!=0){l=l.modPowInt(2,this);if(l.compareTo(BigInteger.ONE)==0){return false}}if(l.compareTo(g)!=0){return false}}}return true}BigInteger.prototype.chunkSize=bnpChunkSize;BigInteger.prototype.toRadix=bnpToRadix;BigInteger.prototype.fromRadix=bnpFromRadix;BigInteger.prototype.fromNumber=bnpFromNumber;BigInteger.prototype.bitwiseTo=bnpBitwiseTo;BigInteger.prototype.changeBit=bnpChangeBit;BigInteger.prototype.addTo=bnpAddTo;BigInteger.prototype.dMultiply=bnpDMultiply;BigInteger.prototype.dAddOffset=bnpDAddOffset;BigInteger.prototype.multiplyLowerTo=bnpMultiplyLowerTo;BigInteger.prototype.multiplyUpperTo=bnpMultiplyUpperTo;BigInteger.prototype.modInt=bnpModInt;BigInteger.prototype.millerRabin=bnpMillerRabin;BigInteger.prototype.clone=bnClone;BigInteger.prototype.intValue=bnIntValue;BigInteger.prototype.byteValue=bnByteValue;BigInteger.prototype.shortValue=bnShortValue;BigInteger.prototype.signum=bnSigNum;BigInteger.prototype.toByteArray=bnToByteArray;BigInteger.prototype.equals=bnEquals;BigInteger.prototype.min=bnMin;BigInteger.prototype.max=bnMax;BigInteger.prototype.and=bnAnd;BigInteger.prototype.or=bnOr;BigInteger.prototype.xor=bnXor;BigInteger.prototype.andNot=bnAndNot;BigInteger.prototype.not=bnNot;BigInteger.prototype.shiftLeft=bnShiftLeft;BigInteger.prototype.shiftRight=bnShiftRight;BigInteger.prototype.getLowestSetBit=bnGetLowestSetBit;BigInteger.prototype.bitCount=bnBitCount;BigInteger.prototype.testBit=bnTestBit;BigInteger.prototype.setBit=bnSetBit;BigInteger.prototype.clearBit=bnClearBit;BigInteger.prototype.flipBit=bnFlipBit;BigInteger.prototype.add=bnAdd;BigInteger.prototype.subtract=bnSubtract;BigInteger.prototype.multiply=bnMultiply;BigInteger.prototype.divide=bnDivide;BigInteger.prototype.remainder=bnRemainder;BigInteger.prototype.divideAndRemainder=bnDivideAndRemainder;BigInteger.prototype.modPow=bnModPow;BigInteger.prototype.modInverse=bnModInverse;BigInteger.prototype.pow=bnPow;BigInteger.prototype.gcd=bnGCD;BigInteger.prototype.isProbablePrime=bnIsProbablePrime;BigInteger.prototype.square=bnSquare;
	/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
	function Arcfour(){this.i=0;this.j=0;this.S=new Array()}function ARC4init(d){var c,a,b;for(c=0;c<256;++c){this.S[c]=c}a=0;for(c=0;c<256;++c){a=(a+this.S[c]+d[c%d.length])&255;b=this.S[c];this.S[c]=this.S[a];this.S[a]=b}this.i=0;this.j=0}function ARC4next(){var a;this.i=(this.i+1)&255;this.j=(this.j+this.S[this.i])&255;a=this.S[this.i];this.S[this.i]=this.S[this.j];this.S[this.j]=a;return this.S[(a+this.S[this.i])&255]}Arcfour.prototype.init=ARC4init;Arcfour.prototype.next=ARC4next;function prng_newstate(){return new Arcfour()}var rng_psize=256;
	/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
	var rng_state;var rng_pool;var rng_pptr;function rng_seed_int(a){rng_pool[rng_pptr++]^=a&255;rng_pool[rng_pptr++]^=(a>>8)&255;rng_pool[rng_pptr++]^=(a>>16)&255;rng_pool[rng_pptr++]^=(a>>24)&255;if(rng_pptr>=rng_psize){rng_pptr-=rng_psize}}function rng_seed_time(){rng_seed_int(new Date().getTime())}if(rng_pool==null){rng_pool=new Array();rng_pptr=0;var t;if(window.crypto&&window.crypto.getRandomValues){var ua=new Uint8Array(32);window.crypto.getRandomValues(ua);for(t=0;t<32;++t){rng_pool[rng_pptr++]=ua[t]}}if(navigator.appName=="Netscape"&&navigator.appVersion<"5"&&window.crypto&&window.crypto.random){var z=window.crypto.random(32);for(t=0;t<z.length;++t){rng_pool[rng_pptr++]=z.charCodeAt(t)&255}}while(rng_pptr<rng_psize){t=Math.floor(65536*Math.random());rng_pool[rng_pptr++]=t>>>8;rng_pool[rng_pptr++]=t&255}rng_pptr=0;rng_seed_time()}function rng_get_byte(){if(rng_state==null){rng_seed_time();rng_state=prng_newstate();rng_state.init(rng_pool);for(rng_pptr=0;rng_pptr<rng_pool.length;++rng_pptr){rng_pool[rng_pptr]=0}rng_pptr=0}return rng_state.next()}function rng_get_bytes(b){var a;for(a=0;a<b.length;++a){b[a]=rng_get_byte()}}function SecureRandom(){}SecureRandom.prototype.nextBytes=rng_get_bytes;
	/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
	function parseBigInt(b,a){return new BigInteger(b,a)}function linebrk(c,d){var a="";var b=0;while(b+d<c.length){a+=c.substring(b,b+d)+"\n";b+=d}return a+c.substring(b,c.length)}function byte2Hex(a){if(a<16){return"0"+a.toString(16)}else{return a.toString(16)}}function pkcs1pad2(e,h){if(h<e.length+11){alert("Message too long for RSA");return null}var g=new Array();var d=e.length-1;while(d>=0&&h>0){var f=e.charCodeAt(d--);if(f<128){g[--h]=f}else{if((f>127)&&(f<2048)){g[--h]=(f&63)|128;g[--h]=(f>>6)|192}else{g[--h]=(f&63)|128;g[--h]=((f>>6)&63)|128;g[--h]=(f>>12)|224}}}g[--h]=0;var b=new SecureRandom();var a=new Array();while(h>2){a[0]=0;while(a[0]==0){b.nextBytes(a)}g[--h]=a[0]}g[--h]=2;g[--h]=0;return new BigInteger(g)}function oaep_mgf1_arr(c,a,e){var b="",d=0;while(b.length<a){b+=e(String.fromCharCode.apply(String,c.concat([(d&4278190080)>>24,(d&16711680)>>16,(d&65280)>>8,d&255])));d+=1}return b}function oaep_pad(q,a,f,l){var c=KJUR.crypto.MessageDigest;var o=KJUR.crypto.Util;var b=null;if(!f){f="sha1"}if(typeof f==="string"){b=c.getCanonicalAlgName(f);l=c.getHashLength(b);f=function(i){return hextorstr(o.hashString(i,b))}}if(q.length+2*l+2>a){throw"Message too long for RSA"}var k="",e;for(e=0;e<a-q.length-2*l-2;e+=1){k+="\x00"}var h=f("")+k+"\x01"+q;var g=new Array(l);new SecureRandom().nextBytes(g);var j=oaep_mgf1_arr(g,h.length,f);var p=[];for(e=0;e<h.length;e+=1){p[e]=h.charCodeAt(e)^j.charCodeAt(e)}var m=oaep_mgf1_arr(p,g.length,f);var d=[0];for(e=0;e<g.length;e+=1){d[e+1]=g[e]^m.charCodeAt(e)}return new BigInteger(d.concat(p))}function RSAKey(){this.n=null;this.e=0;this.d=null;this.p=null;this.q=null;this.dmp1=null;this.dmq1=null;this.coeff=null}function RSASetPublic(b,a){this.isPublic=true;this.isPrivate=false;if(typeof b!=="string"){this.n=b;this.e=a}else{if(b!=null&&a!=null&&b.length>0&&a.length>0){this.n=parseBigInt(b,16);this.e=parseInt(a,16)}else{throw"Invalid RSA public key"}}}function RSADoPublic(a){return a.modPowInt(this.e,this.n)}function RSAEncrypt(d){var a=pkcs1pad2(d,(this.n.bitLength()+7)>>3);if(a==null){return null}var e=this.doPublic(a);if(e==null){return null}var b=e.toString(16);if((b.length&1)==0){return b}else{return"0"+b}}function RSAEncryptOAEP(f,e,b){var a=oaep_pad(f,(this.n.bitLength()+7)>>3,e,b);if(a==null){return null}var g=this.doPublic(a);if(g==null){return null}var d=g.toString(16);if((d.length&1)==0){return d}else{return"0"+d}}RSAKey.prototype.doPublic=RSADoPublic;RSAKey.prototype.setPublic=RSASetPublic;RSAKey.prototype.encrypt=RSAEncrypt;RSAKey.prototype.encryptOAEP=RSAEncryptOAEP;RSAKey.prototype.type="RSA";
	/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
	function pkcs1unpad2(g,j){var a=g.toByteArray();var f=0;while(f<a.length&&a[f]==0){++f}if(a.length-f!=j-1||a[f]!=2){return null}++f;while(a[f]!=0){if(++f>=a.length){return null}}var e="";while(++f<a.length){var h=a[f]&255;if(h<128){e+=String.fromCharCode(h)}else{if((h>191)&&(h<224)){e+=String.fromCharCode(((h&31)<<6)|(a[f+1]&63));++f}else{e+=String.fromCharCode(((h&15)<<12)|((a[f+1]&63)<<6)|(a[f+2]&63));f+=2}}}return e}function oaep_mgf1_str(c,a,e){var b="",d=0;while(b.length<a){b+=e(c+String.fromCharCode.apply(String,[(d&4278190080)>>24,(d&16711680)>>16,(d&65280)>>8,d&255]));d+=1}return b}function oaep_unpad(o,b,g,p){var e=KJUR.crypto.MessageDigest;var r=KJUR.crypto.Util;var c=null;if(!g){g="sha1"}if(typeof g==="string"){c=e.getCanonicalAlgName(g);p=e.getHashLength(c);g=function(d){return hextorstr(r.hashString(d,c))}}o=o.toByteArray();var h;for(h=0;h<o.length;h+=1){o[h]&=255}while(o.length<b){o.unshift(0)}o=String.fromCharCode.apply(String,o);if(o.length<2*p+2){throw"Cipher too short"}var f=o.substr(1,p);var s=o.substr(p+1);var q=oaep_mgf1_str(s,p,g);var k=[],h;for(h=0;h<f.length;h+=1){k[h]=f.charCodeAt(h)^q.charCodeAt(h)}var l=oaep_mgf1_str(String.fromCharCode.apply(String,k),o.length-p,g);var j=[];for(h=0;h<s.length;h+=1){j[h]=s.charCodeAt(h)^l.charCodeAt(h)}j=String.fromCharCode.apply(String,j);if(j.substr(0,p)!==g("")){throw"Hash mismatch"}j=j.substr(p);var a=j.indexOf("\x01");var m=(a!=-1)?j.substr(0,a).lastIndexOf("\x00"):-1;if(m+1!=a){throw"Malformed data"}return j.substr(a+1)}function RSASetPrivate(c,a,b){this.isPrivate=true;if(typeof c!=="string"){this.n=c;this.e=a;this.d=b}else{if(c!=null&&a!=null&&c.length>0&&a.length>0){this.n=parseBigInt(c,16);this.e=parseInt(a,16);this.d=parseBigInt(b,16)}else{alert("Invalid RSA private key")}}}function RSASetPrivateEx(g,d,e,c,b,a,h,f){this.isPrivate=true;this.isPublic=false;if(g==null){throw"RSASetPrivateEx N == null"}if(d==null){throw"RSASetPrivateEx E == null"}if(g.length==0){throw"RSASetPrivateEx N.length == 0"}if(d.length==0){throw"RSASetPrivateEx E.length == 0"}if(g!=null&&d!=null&&g.length>0&&d.length>0){this.n=parseBigInt(g,16);this.e=parseInt(d,16);this.d=parseBigInt(e,16);this.p=parseBigInt(c,16);this.q=parseBigInt(b,16);this.dmp1=parseBigInt(a,16);this.dmq1=parseBigInt(h,16);this.coeff=parseBigInt(f,16)}else{alert("Invalid RSA private key in RSASetPrivateEx")}}function RSAGenerate(b,i){var a=new SecureRandom();var f=b>>1;this.e=parseInt(i,16);var c=new BigInteger(i,16);for(;;){for(;;){this.p=new BigInteger(b-f,1,a);if(this.p.subtract(BigInteger.ONE).gcd(c).compareTo(BigInteger.ONE)==0&&this.p.isProbablePrime(10)){break}}for(;;){this.q=new BigInteger(f,1,a);if(this.q.subtract(BigInteger.ONE).gcd(c).compareTo(BigInteger.ONE)==0&&this.q.isProbablePrime(10)){break}}if(this.p.compareTo(this.q)<=0){var h=this.p;this.p=this.q;this.q=h}var g=this.p.subtract(BigInteger.ONE);var d=this.q.subtract(BigInteger.ONE);var e=g.multiply(d);if(e.gcd(c).compareTo(BigInteger.ONE)==0){this.n=this.p.multiply(this.q);this.d=c.modInverse(e);this.dmp1=this.d.mod(g);this.dmq1=this.d.mod(d);this.coeff=this.q.modInverse(this.p);break}}this.isPrivate=true}function RSADoPrivate(a){if(this.p==null||this.q==null){return a.modPow(this.d,this.n)}var c=a.mod(this.p).modPow(this.dmp1,this.p);var b=a.mod(this.q).modPow(this.dmq1,this.q);while(c.compareTo(b)<0){c=c.add(this.p)}return c.subtract(b).multiply(this.coeff).mod(this.p).multiply(this.q).add(b)}function RSADecrypt(b){var d=parseBigInt(b,16);var a=this.doPrivate(d);if(a==null){return null}return pkcs1unpad2(a,(this.n.bitLength()+7)>>3)}function RSADecryptOAEP(e,d,b){var f=parseBigInt(e,16);var a=this.doPrivate(f);if(a==null){return null}return oaep_unpad(a,(this.n.bitLength()+7)>>3,d,b)}RSAKey.prototype.doPrivate=RSADoPrivate;RSAKey.prototype.setPrivate=RSASetPrivate;RSAKey.prototype.setPrivateEx=RSASetPrivateEx;RSAKey.prototype.generate=RSAGenerate;RSAKey.prototype.decrypt=RSADecrypt;RSAKey.prototype.decryptOAEP=RSADecryptOAEP;
	/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
	 */
	function ECFieldElementFp(b,a){this.x=a;this.q=b}function feFpEquals(a){if(a==this){return true}return(this.q.equals(a.q)&&this.x.equals(a.x))}function feFpToBigInteger(){return this.x}function feFpNegate(){return new ECFieldElementFp(this.q,this.x.negate().mod(this.q))}function feFpAdd(a){return new ECFieldElementFp(this.q,this.x.add(a.toBigInteger()).mod(this.q))}function feFpSubtract(a){return new ECFieldElementFp(this.q,this.x.subtract(a.toBigInteger()).mod(this.q))}function feFpMultiply(a){return new ECFieldElementFp(this.q,this.x.multiply(a.toBigInteger()).mod(this.q))}function feFpSquare(){return new ECFieldElementFp(this.q,this.x.square().mod(this.q))}function feFpDivide(a){return new ECFieldElementFp(this.q,this.x.multiply(a.toBigInteger().modInverse(this.q)).mod(this.q))}ECFieldElementFp.prototype.equals=feFpEquals;ECFieldElementFp.prototype.toBigInteger=feFpToBigInteger;ECFieldElementFp.prototype.negate=feFpNegate;ECFieldElementFp.prototype.add=feFpAdd;ECFieldElementFp.prototype.subtract=feFpSubtract;ECFieldElementFp.prototype.multiply=feFpMultiply;ECFieldElementFp.prototype.square=feFpSquare;ECFieldElementFp.prototype.divide=feFpDivide;function ECPointFp(c,a,d,b){this.curve=c;this.x=a;this.y=d;if(b==null){this.z=BigInteger.ONE}else{this.z=b}this.zinv=null}function pointFpGetX(){if(this.zinv==null){this.zinv=this.z.modInverse(this.curve.q)}return this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q))}function pointFpGetY(){if(this.zinv==null){this.zinv=this.z.modInverse(this.curve.q)}return this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q))}function pointFpEquals(a){if(a==this){return true}if(this.isInfinity()){return a.isInfinity()}if(a.isInfinity()){return this.isInfinity()}var c,b;c=a.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(a.z)).mod(this.curve.q);if(!c.equals(BigInteger.ZERO)){return false}b=a.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(a.z)).mod(this.curve.q);return b.equals(BigInteger.ZERO)}function pointFpIsInfinity(){if((this.x==null)&&(this.y==null)){return true}return this.z.equals(BigInteger.ZERO)&&!this.y.toBigInteger().equals(BigInteger.ZERO)}function pointFpNegate(){return new ECPointFp(this.curve,this.x,this.y.negate(),this.z)}function pointFpAdd(l){if(this.isInfinity()){return l}if(l.isInfinity()){return this}var p=l.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(l.z)).mod(this.curve.q);var o=l.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(l.z)).mod(this.curve.q);if(BigInteger.ZERO.equals(o)){if(BigInteger.ZERO.equals(p)){return this.twice()}return this.curve.getInfinity()}var j=new BigInteger("3");var e=this.x.toBigInteger();var n=this.y.toBigInteger();var c=l.x.toBigInteger();var k=l.y.toBigInteger();var m=o.square();var i=m.multiply(o);var d=e.multiply(m);var g=p.square().multiply(this.z);var a=g.subtract(d.shiftLeft(1)).multiply(l.z).subtract(i).multiply(o).mod(this.curve.q);var h=d.multiply(j).multiply(p).subtract(n.multiply(i)).subtract(g.multiply(p)).multiply(l.z).add(p.multiply(i)).mod(this.curve.q);var f=i.multiply(this.z).multiply(l.z).mod(this.curve.q);return new ECPointFp(this.curve,this.curve.fromBigInteger(a),this.curve.fromBigInteger(h),f)}function pointFpTwice(){if(this.isInfinity()){return this}if(this.y.toBigInteger().signum()==0){return this.curve.getInfinity()}var g=new BigInteger("3");var c=this.x.toBigInteger();var h=this.y.toBigInteger();var e=h.multiply(this.z);var j=e.multiply(h).mod(this.curve.q);var i=this.curve.a.toBigInteger();var k=c.square().multiply(g);if(!BigInteger.ZERO.equals(i)){k=k.add(this.z.square().multiply(i))}k=k.mod(this.curve.q);var b=k.square().subtract(c.shiftLeft(3).multiply(j)).shiftLeft(1).multiply(e).mod(this.curve.q);var f=k.multiply(g).multiply(c).subtract(j.shiftLeft(1)).shiftLeft(2).multiply(j).subtract(k.square().multiply(k)).mod(this.curve.q);var d=e.square().multiply(e).shiftLeft(3).mod(this.curve.q);return new ECPointFp(this.curve,this.curve.fromBigInteger(b),this.curve.fromBigInteger(f),d)}function pointFpMultiply(b){if(this.isInfinity()){return this}if(b.signum()==0){return this.curve.getInfinity()}var g=b;var f=g.multiply(new BigInteger("3"));var l=this.negate();var d=this;var c;for(c=f.bitLength()-2;c>0;--c){d=d.twice();var a=f.testBit(c);var j=g.testBit(c);if(a!=j){d=d.add(a?this:l)}}return d}function pointFpMultiplyTwo(c,a,b){var d;if(c.bitLength()>b.bitLength()){d=c.bitLength()-1}else{d=b.bitLength()-1}var f=this.curve.getInfinity();var e=this.add(a);while(d>=0){f=f.twice();if(c.testBit(d)){if(b.testBit(d)){f=f.add(e)}else{f=f.add(this)}}else{if(b.testBit(d)){f=f.add(a)}}--d}return f}ECPointFp.prototype.getX=pointFpGetX;ECPointFp.prototype.getY=pointFpGetY;ECPointFp.prototype.equals=pointFpEquals;ECPointFp.prototype.isInfinity=pointFpIsInfinity;ECPointFp.prototype.negate=pointFpNegate;ECPointFp.prototype.add=pointFpAdd;ECPointFp.prototype.twice=pointFpTwice;ECPointFp.prototype.multiply=pointFpMultiply;ECPointFp.prototype.multiplyTwo=pointFpMultiplyTwo;function ECCurveFp(e,d,c){this.q=e;this.a=this.fromBigInteger(d);this.b=this.fromBigInteger(c);this.infinity=new ECPointFp(this,null,null)}function curveFpGetQ(){return this.q}function curveFpGetA(){return this.a}function curveFpGetB(){return this.b}function curveFpEquals(a){if(a==this){return true}return(this.q.equals(a.q)&&this.a.equals(a.a)&&this.b.equals(a.b))}function curveFpGetInfinity(){return this.infinity}function curveFpFromBigInteger(a){return new ECFieldElementFp(this.q,a)}function curveFpDecodePointHex(d){switch(parseInt(d.substr(0,2),16)){case 0:return this.infinity;case 2:case 3:return null;case 4:case 6:case 7:var a=(d.length-2)/2;var c=d.substr(2,a);var b=d.substr(a+2,a);return new ECPointFp(this,this.fromBigInteger(new BigInteger(c,16)),this.fromBigInteger(new BigInteger(b,16)));default:return null}}ECCurveFp.prototype.getQ=curveFpGetQ;ECCurveFp.prototype.getA=curveFpGetA;ECCurveFp.prototype.getB=curveFpGetB;ECCurveFp.prototype.equals=curveFpEquals;ECCurveFp.prototype.getInfinity=curveFpGetInfinity;ECCurveFp.prototype.fromBigInteger=curveFpFromBigInteger;ECCurveFp.prototype.decodePointHex=curveFpDecodePointHex;
	/*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
	 */
	ECFieldElementFp.prototype.getByteLength=function(){return Math.floor((this.toBigInteger().bitLength()+7)/8)};ECPointFp.prototype.getEncoded=function(c){var d=function(h,f){var g=h.toByteArrayUnsigned();if(f<g.length){g=g.slice(g.length-f)}else{while(f>g.length){g.unshift(0)}}return g};var a=this.getX().toBigInteger();var e=this.getY().toBigInteger();var b=d(a,32);if(c){if(e.isEven()){b.unshift(2)}else{b.unshift(3)}}else{b.unshift(4);b=b.concat(d(e,32))}return b};ECPointFp.decodeFrom=function(g,c){var f=c[0];var e=c.length-1;var d=c.slice(1,1+e/2);var b=c.slice(1+e/2,1+e);d.unshift(0);b.unshift(0);var a=new BigInteger(d);var h=new BigInteger(b);return new ECPointFp(g,g.fromBigInteger(a),g.fromBigInteger(h))};ECPointFp.decodeFromHex=function(g,c){var f=c.substr(0,2);var e=c.length-2;var d=c.substr(2,e/2);var b=c.substr(2+e/2,e/2);var a=new BigInteger(d,16);var h=new BigInteger(b,16);return new ECPointFp(g,g.fromBigInteger(a),g.fromBigInteger(h))};ECPointFp.prototype.add2D=function(c){if(this.isInfinity()){return c}if(c.isInfinity()){return this}if(this.x.equals(c.x)){if(this.y.equals(c.y)){return this.twice()}return this.curve.getInfinity()}var g=c.x.subtract(this.x);var e=c.y.subtract(this.y);var a=e.divide(g);var d=a.square().subtract(this.x).subtract(c.x);var f=a.multiply(this.x.subtract(d)).subtract(this.y);return new ECPointFp(this.curve,d,f)};ECPointFp.prototype.twice2D=function(){if(this.isInfinity()){return this}if(this.y.toBigInteger().signum()==0){return this.curve.getInfinity()}var b=this.curve.fromBigInteger(BigInteger.valueOf(2));var e=this.curve.fromBigInteger(BigInteger.valueOf(3));var a=this.x.square().multiply(e).add(this.curve.a).divide(this.y.multiply(b));var c=a.square().subtract(this.x.multiply(b));var d=a.multiply(this.x.subtract(c)).subtract(this.y);return new ECPointFp(this.curve,c,d)};ECPointFp.prototype.multiply2D=function(b){if(this.isInfinity()){return this}if(b.signum()==0){return this.curve.getInfinity()}var g=b;var f=g.multiply(new BigInteger("3"));var l=this.negate();var d=this;var c;for(c=f.bitLength()-2;c>0;--c){d=d.twice();var a=f.testBit(c);var j=g.testBit(c);if(a!=j){d=d.add2D(a?this:l)}}return d};ECPointFp.prototype.isOnCurve=function(){var d=this.getX().toBigInteger();var i=this.getY().toBigInteger();var f=this.curve.getA().toBigInteger();var c=this.curve.getB().toBigInteger();var h=this.curve.getQ();var e=i.multiply(i).mod(h);var g=d.multiply(d).multiply(d).add(f.multiply(d)).add(c).mod(h);return e.equals(g)};ECPointFp.prototype.toString=function(){return"("+this.getX().toBigInteger().toString()+","+this.getY().toBigInteger().toString()+")"};ECPointFp.prototype.validate=function(){var c=this.curve.getQ();if(this.isInfinity()){throw new Error("Point is at infinity.")}var a=this.getX().toBigInteger();var b=this.getY().toBigInteger();if(a.compareTo(BigInteger.ONE)<0||a.compareTo(c.subtract(BigInteger.ONE))>0){throw new Error("x coordinate out of bounds")}if(b.compareTo(BigInteger.ONE)<0||b.compareTo(c.subtract(BigInteger.ONE))>0){throw new Error("y coordinate out of bounds")}if(!this.isOnCurve()){throw new Error("Point is not on the curve.")}if(this.multiply(c).isInfinity()){throw new Error("Point is not a scalar multiple of G.")}return true};
	/*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
	 */
	var jsonParse=(function(){var e="(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)";var j='(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))';var i='(?:"'+j+'*")';var d=new RegExp("(?:false|true|null|[\\{\\}\\[\\]]|"+e+"|"+i+")","g");var k=new RegExp("\\\\(?:([^u])|u(.{4}))","g");var g={'"':'"',"/":"/","\\":"\\",b:"\b",f:"\f",n:"\n",r:"\r",t:"\t"};function h(l,m,n){return m?g[m]:String.fromCharCode(parseInt(n,16))}var c=new String("");var a="\\";var f={"{":Object,"[":Array};var b=Object.hasOwnProperty;return function(u,q){var p=u.match(d);var x;var v=p[0];var l=false;if("{"===v){x={}}else{if("["===v){x=[]}else{x=[];l=true}}var t;var r=[x];for(var o=1-l,m=p.length;o<m;++o){v=p[o];var w;switch(v.charCodeAt(0)){default:w=r[0];w[t||w.length]=+(v);t=void 0;break;case 34:v=v.substring(1,v.length-1);if(v.indexOf(a)!==-1){v=v.replace(k,h)}w=r[0];if(!t){if(w instanceof Array){t=w.length}else{t=v||c;break}}w[t]=v;t=void 0;break;case 91:w=r[0];r.unshift(w[t||w.length]=[]);t=void 0;break;case 93:r.shift();break;case 102:w=r[0];w[t||w.length]=false;t=void 0;break;case 110:w=r[0];w[t||w.length]=null;t=void 0;break;case 116:w=r[0];w[t||w.length]=true;t=void 0;break;case 123:w=r[0];r.unshift(w[t||w.length]={});t=void 0;break;case 125:r.shift();break}}if(l){if(r.length!==1){throw new Error()}x=x[0]}else{if(r.length){throw new Error()}}if(q){var s=function(C,B){var D=C[B];if(D&&typeof D==="object"){var n=null;for(var z in D){if(b.call(D,z)&&D!==C){var y=s(D,z);if(y!==void 0){D[z]=y}else{if(!n){n=[]}n.push(z)}}}if(n){for(var A=n.length;--A>=0;){delete D[n[A]]}}}return q.call(C,B,D)};x=s({"":x},"")}return x}})();
	/*! asn1-1.0.12.js (c) 2013-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.asn1=="undefined"||!KJUR.asn1){KJUR.asn1={}}KJUR.asn1.ASN1Util=new function(){this.integerToByteHex=function(a){var b=a.toString(16);if((b.length%2)==1){b="0"+b}return b};this.bigIntToMinTwosComplementsHex=function(j){var f=j.toString(16);if(f.substr(0,1)!="-"){if(f.length%2==1){f="0"+f}else{if(!f.match(/^[0-7]/)){f="00"+f}}}else{var a=f.substr(1);var e=a.length;if(e%2==1){e+=1}else{if(!f.match(/^[0-7]/)){e+=2}}var g="";for(var d=0;d<e;d++){g+="f"}var c=new BigInteger(g,16);var b=c.xor(j).add(BigInteger.ONE);f=b.toString(16).replace(/^-/,"")}return f};this.getPEMStringFromHex=function(a,b){var c=hextob64(a);var d=c.replace(/(.{64})/g,"$1\r\n");d=d.replace(/\r\n$/,"");return"-----BEGIN "+b+"-----\r\n"+d+"\r\n-----END "+b+"-----\r\n"};this.newObject=function(b){var g=KJUR.asn1;var k=Object.keys(b);if(k.length!=1){throw"key of param shall be only one."}var j=k[0];if(":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":"+j+":")==-1){throw"undefined key: "+j}if(j=="bool"){return new g.DERBoolean(b[j])}if(j=="int"){return new g.DERInteger(b[j])}if(j=="bitstr"){return new g.DERBitString(b[j])}if(j=="octstr"){return new g.DEROctetString(b[j])}if(j=="null"){return new g.DERNull(b[j])}if(j=="oid"){return new g.DERObjectIdentifier(b[j])}if(j=="enum"){return new g.DEREnumerated(b[j])}if(j=="utf8str"){return new g.DERUTF8String(b[j])}if(j=="numstr"){return new g.DERNumericString(b[j])}if(j=="prnstr"){return new g.DERPrintableString(b[j])}if(j=="telstr"){return new g.DERTeletexString(b[j])}if(j=="ia5str"){return new g.DERIA5String(b[j])}if(j=="utctime"){return new g.DERUTCTime(b[j])}if(j=="gentime"){return new g.DERGeneralizedTime(b[j])}if(j=="seq"){var m=b[j];var h=[];for(var e=0;e<m.length;e++){var l=g.ASN1Util.newObject(m[e]);h.push(l)}return new g.DERSequence({array:h})}if(j=="set"){var m=b[j];var h=[];for(var e=0;e<m.length;e++){var l=g.ASN1Util.newObject(m[e]);h.push(l)}return new g.DERSet({array:h})}if(j=="tag"){var c=b[j];if(Object.prototype.toString.call(c)==="[object Array]"&&c.length==3){var d=g.ASN1Util.newObject(c[2]);return new g.DERTaggedObject({tag:c[0],explicit:c[1],obj:d})}else{var f={};if(c.explicit!==undefined){f.explicit=c.explicit}if(c.tag!==undefined){f.tag=c.tag}if(c.obj===undefined){throw"obj shall be specified for 'tag'."}f.obj=g.ASN1Util.newObject(c.obj);return new g.DERTaggedObject(f)}}};this.jsonToASN1HEX=function(b){var a=this.newObject(b);return a.getEncodedHex()}};KJUR.asn1.ASN1Util.oidHexToInt=function(a){var j="";var k=parseInt(a.substr(0,2),16);var d=Math.floor(k/40);var c=k%40;var j=d+"."+c;var e="";for(var f=2;f<a.length;f+=2){var g=parseInt(a.substr(f,2),16);var h=("00000000"+g.toString(2)).slice(-8);e=e+h.substr(1,7);if(h.substr(0,1)=="0"){var b=new BigInteger(e,2);j=j+"."+b.toString(10);e=""}}return j};KJUR.asn1.ASN1Util.oidIntToHex=function(f){var e=function(a){var k=a.toString(16);if(k.length==1){k="0"+k}return k};var d=function(o){var n="";var k=new BigInteger(o,10);var a=k.toString(2);var l=7-a.length%7;if(l==7){l=0}var q="";for(var m=0;m<l;m++){q+="0"}a=q+a;for(var m=0;m<a.length-1;m+=7){var p=a.substr(m,7);if(m!=a.length-7){p="1"+p}n+=e(parseInt(p,2))}return n};if(!f.match(/^[0-9.]+$/)){throw"malformed oid string: "+f}var g="";var b=f.split(".");var j=parseInt(b[0])*40+parseInt(b[1]);g+=e(j);b.splice(0,2);for(var c=0;c<b.length;c++){g+=d(b[c])}return g};KJUR.asn1.ASN1Object=function(){var c=true;var b=null;var d="00";var e="00";var a="";this.getLengthHexFromValue=function(){if(typeof this.hV=="undefined"||this.hV==null){throw"this.hV is null or undefined."}if(this.hV.length%2==1){throw"value hex must be even length: n="+a.length+",v="+this.hV}var i=this.hV.length/2;var h=i.toString(16);if(h.length%2==1){h="0"+h}if(i<128){return h}else{var g=h.length/2;if(g>15){throw"ASN.1 length too long to represent by 8x: n = "+i.toString(16)}var f=128+g;return f.toString(16)+h}};this.getEncodedHex=function(){if(this.hTLV==null||this.isModified){this.hV=this.getFreshValueHex();this.hL=this.getLengthHexFromValue();this.hTLV=this.hT+this.hL+this.hV;this.isModified=false}return this.hTLV};this.getValueHex=function(){this.getEncodedHex();return this.hV};this.getFreshValueHex=function(){return""}};KJUR.asn1.DERAbstractString=function(c){KJUR.asn1.DERAbstractString.superclass.constructor.call(this);var b=null;var a=null;this.getString=function(){return this.s};this.setString=function(d){this.hTLV=null;this.isModified=true;this.s=d;this.hV=stohex(this.s)};this.setStringHex=function(d){this.hTLV=null;this.isModified=true;this.s=null;this.hV=d};this.getFreshValueHex=function(){return this.hV};if(typeof c!="undefined"){if(typeof c=="string"){this.setString(c)}else{if(typeof c.str!="undefined"){this.setString(c.str)}else{if(typeof c.hex!="undefined"){this.setStringHex(c.hex)}}}}};YAHOO.lang.extend(KJUR.asn1.DERAbstractString,KJUR.asn1.ASN1Object);KJUR.asn1.DERAbstractTime=function(c){KJUR.asn1.DERAbstractTime.superclass.constructor.call(this);var b=null;var a=null;this.localDateToUTC=function(f){utc=f.getTime()+(f.getTimezoneOffset()*60000);var e=new Date(utc);return e};this.formatDate=function(m,o,e){var g=this.zeroPadding;var n=this.localDateToUTC(m);var p=String(n.getFullYear());if(o=="utc"){p=p.substr(2,2)}var l=g(String(n.getMonth()+1),2);var q=g(String(n.getDate()),2);var h=g(String(n.getHours()),2);var i=g(String(n.getMinutes()),2);var j=g(String(n.getSeconds()),2);var r=p+l+q+h+i+j;if(e===true){var f=n.getMilliseconds();if(f!=0){var k=g(String(f),3);k=k.replace(/[0]+$/,"");r=r+"."+k}}return r+"Z"};this.zeroPadding=function(e,d){if(e.length>=d){return e}return new Array(d-e.length+1).join("0")+e};this.getString=function(){return this.s};this.setString=function(d){this.hTLV=null;this.isModified=true;this.s=d;this.hV=stohex(d)};this.setByDateValue=function(h,j,e,d,f,g){var i=new Date(Date.UTC(h,j-1,e,d,f,g,0));this.setByDate(i)};this.getFreshValueHex=function(){return this.hV}};YAHOO.lang.extend(KJUR.asn1.DERAbstractTime,KJUR.asn1.ASN1Object);KJUR.asn1.DERAbstractStructured=function(b){KJUR.asn1.DERAbstractString.superclass.constructor.call(this);var a=null;this.setByASN1ObjectArray=function(c){this.hTLV=null;this.isModified=true;this.asn1Array=c};this.appendASN1Object=function(c){this.hTLV=null;this.isModified=true;this.asn1Array.push(c)};this.asn1Array=new Array();if(typeof b!="undefined"){if(typeof b.array!="undefined"){this.asn1Array=b.array}}};YAHOO.lang.extend(KJUR.asn1.DERAbstractStructured,KJUR.asn1.ASN1Object);KJUR.asn1.DERBoolean=function(){KJUR.asn1.DERBoolean.superclass.constructor.call(this);this.hT="01";this.hTLV="0101ff"};YAHOO.lang.extend(KJUR.asn1.DERBoolean,KJUR.asn1.ASN1Object);KJUR.asn1.DERInteger=function(a){KJUR.asn1.DERInteger.superclass.constructor.call(this);this.hT="02";this.setByBigInteger=function(b){this.hTLV=null;this.isModified=true;this.hV=KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(b)};this.setByInteger=function(c){var b=new BigInteger(String(c),10);this.setByBigInteger(b)};this.setValueHex=function(b){this.hV=b};this.getFreshValueHex=function(){return this.hV};if(typeof a!="undefined"){if(typeof a.bigint!="undefined"){this.setByBigInteger(a.bigint)}else{if(typeof a["int"]!="undefined"){this.setByInteger(a["int"])}else{if(typeof a=="number"){this.setByInteger(a)}else{if(typeof a.hex!="undefined"){this.setValueHex(a.hex)}}}}}};YAHOO.lang.extend(KJUR.asn1.DERInteger,KJUR.asn1.ASN1Object);KJUR.asn1.DERBitString=function(b){if(b!==undefined&&typeof b.obj!=="undefined"){var a=KJUR.asn1.ASN1Util.newObject(b.obj);b.hex="00"+a.getEncodedHex()}KJUR.asn1.DERBitString.superclass.constructor.call(this);this.hT="03";this.setHexValueIncludingUnusedBits=function(c){this.hTLV=null;this.isModified=true;this.hV=c};this.setUnusedBitsAndHexValue=function(c,e){if(c<0||7<c){throw"unused bits shall be from 0 to 7: u = "+c}var d="0"+c;this.hTLV=null;this.isModified=true;this.hV=d+e};this.setByBinaryString=function(e){e=e.replace(/0+$/,"");var f=8-e.length%8;if(f==8){f=0}for(var g=0;g<=f;g++){e+="0"}var j="";for(var g=0;g<e.length-1;g+=8){var d=e.substr(g,8);var c=parseInt(d,2).toString(16);if(c.length==1){c="0"+c}j+=c}this.hTLV=null;this.isModified=true;this.hV="0"+f+j};this.setByBooleanArray=function(e){var d="";for(var c=0;c<e.length;c++){if(e[c]==true){d+="1"}else{d+="0"}}this.setByBinaryString(d)};this.newFalseArray=function(e){var c=new Array(e);for(var d=0;d<e;d++){c[d]=false}return c};this.getFreshValueHex=function(){return this.hV};if(typeof b!="undefined"){if(typeof b=="string"&&b.toLowerCase().match(/^[0-9a-f]+$/)){this.setHexValueIncludingUnusedBits(b)}else{if(typeof b.hex!="undefined"){this.setHexValueIncludingUnusedBits(b.hex)}else{if(typeof b.bin!="undefined"){this.setByBinaryString(b.bin)}else{if(typeof b.array!="undefined"){this.setByBooleanArray(b.array)}}}}}};YAHOO.lang.extend(KJUR.asn1.DERBitString,KJUR.asn1.ASN1Object);KJUR.asn1.DEROctetString=function(b){if(b!==undefined&&typeof b.obj!=="undefined"){var a=KJUR.asn1.ASN1Util.newObject(b.obj);b.hex=a.getEncodedHex()}KJUR.asn1.DEROctetString.superclass.constructor.call(this,b);this.hT="04"};YAHOO.lang.extend(KJUR.asn1.DEROctetString,KJUR.asn1.DERAbstractString);KJUR.asn1.DERNull=function(){KJUR.asn1.DERNull.superclass.constructor.call(this);this.hT="05";this.hTLV="0500"};YAHOO.lang.extend(KJUR.asn1.DERNull,KJUR.asn1.ASN1Object);KJUR.asn1.DERObjectIdentifier=function(c){var b=function(d){var e=d.toString(16);if(e.length==1){e="0"+e}return e};var a=function(k){var j="";var e=new BigInteger(k,10);var d=e.toString(2);var f=7-d.length%7;if(f==7){f=0}var m="";for(var g=0;g<f;g++){m+="0"}d=m+d;for(var g=0;g<d.length-1;g+=7){var l=d.substr(g,7);if(g!=d.length-7){l="1"+l}j+=b(parseInt(l,2))}return j};KJUR.asn1.DERObjectIdentifier.superclass.constructor.call(this);this.hT="06";this.setValueHex=function(d){this.hTLV=null;this.isModified=true;this.s=null;this.hV=d};this.setValueOidString=function(f){if(!f.match(/^[0-9.]+$/)){throw"malformed oid string: "+f}var g="";var d=f.split(".");var j=parseInt(d[0])*40+parseInt(d[1]);g+=b(j);d.splice(0,2);for(var e=0;e<d.length;e++){g+=a(d[e])}this.hTLV=null;this.isModified=true;this.s=null;this.hV=g};this.setValueName=function(e){var d=KJUR.asn1.x509.OID.name2oid(e);if(d!==""){this.setValueOidString(d)}else{throw"DERObjectIdentifier oidName undefined: "+e}};this.getFreshValueHex=function(){return this.hV};if(c!==undefined){if(typeof c==="string"){if(c.match(/^[0-2].[0-9.]+$/)){this.setValueOidString(c)}else{this.setValueName(c)}}else{if(c.oid!==undefined){this.setValueOidString(c.oid)}else{if(c.hex!==undefined){this.setValueHex(c.hex)}else{if(c.name!==undefined){this.setValueName(c.name)}}}}}};YAHOO.lang.extend(KJUR.asn1.DERObjectIdentifier,KJUR.asn1.ASN1Object);KJUR.asn1.DEREnumerated=function(a){KJUR.asn1.DEREnumerated.superclass.constructor.call(this);this.hT="0a";this.setByBigInteger=function(b){this.hTLV=null;this.isModified=true;this.hV=KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(b)};this.setByInteger=function(c){var b=new BigInteger(String(c),10);this.setByBigInteger(b)};this.setValueHex=function(b){this.hV=b};this.getFreshValueHex=function(){return this.hV};if(typeof a!="undefined"){if(typeof a["int"]!="undefined"){this.setByInteger(a["int"])}else{if(typeof a=="number"){this.setByInteger(a)}else{if(typeof a.hex!="undefined"){this.setValueHex(a.hex)}}}}};YAHOO.lang.extend(KJUR.asn1.DEREnumerated,KJUR.asn1.ASN1Object);KJUR.asn1.DERUTF8String=function(a){KJUR.asn1.DERUTF8String.superclass.constructor.call(this,a);this.hT="0c"};YAHOO.lang.extend(KJUR.asn1.DERUTF8String,KJUR.asn1.DERAbstractString);KJUR.asn1.DERNumericString=function(a){KJUR.asn1.DERNumericString.superclass.constructor.call(this,a);this.hT="12"};YAHOO.lang.extend(KJUR.asn1.DERNumericString,KJUR.asn1.DERAbstractString);KJUR.asn1.DERPrintableString=function(a){KJUR.asn1.DERPrintableString.superclass.constructor.call(this,a);this.hT="13"};YAHOO.lang.extend(KJUR.asn1.DERPrintableString,KJUR.asn1.DERAbstractString);KJUR.asn1.DERTeletexString=function(a){KJUR.asn1.DERTeletexString.superclass.constructor.call(this,a);this.hT="14"};YAHOO.lang.extend(KJUR.asn1.DERTeletexString,KJUR.asn1.DERAbstractString);KJUR.asn1.DERIA5String=function(a){KJUR.asn1.DERIA5String.superclass.constructor.call(this,a);this.hT="16"};YAHOO.lang.extend(KJUR.asn1.DERIA5String,KJUR.asn1.DERAbstractString);KJUR.asn1.DERUTCTime=function(a){KJUR.asn1.DERUTCTime.superclass.constructor.call(this,a);this.hT="17";this.setByDate=function(b){this.hTLV=null;this.isModified=true;this.date=b;this.s=this.formatDate(this.date,"utc");this.hV=stohex(this.s)};this.getFreshValueHex=function(){if(typeof this.date=="undefined"&&typeof this.s=="undefined"){this.date=new Date();this.s=this.formatDate(this.date,"utc");this.hV=stohex(this.s)}return this.hV};if(a!==undefined){if(a.str!==undefined){this.setString(a.str)}else{if(typeof a=="string"&&a.match(/^[0-9]{12}Z$/)){this.setString(a)}else{if(a.hex!==undefined){this.setStringHex(a.hex)}else{if(a.date!==undefined){this.setByDate(a.date)}}}}}};YAHOO.lang.extend(KJUR.asn1.DERUTCTime,KJUR.asn1.DERAbstractTime);KJUR.asn1.DERGeneralizedTime=function(a){KJUR.asn1.DERGeneralizedTime.superclass.constructor.call(this,a);this.hT="18";this.withMillis=false;this.setByDate=function(b){this.hTLV=null;this.isModified=true;this.date=b;this.s=this.formatDate(this.date,"gen",this.withMillis);this.hV=stohex(this.s)};this.getFreshValueHex=function(){if(this.date===undefined&&this.s===undefined){this.date=new Date();this.s=this.formatDate(this.date,"gen",this.withMillis);this.hV=stohex(this.s)}return this.hV};if(a!==undefined){if(a.str!==undefined){this.setString(a.str)}else{if(typeof a=="string"&&a.match(/^[0-9]{14}Z$/)){this.setString(a)}else{if(a.hex!==undefined){this.setStringHex(a.hex)}else{if(a.date!==undefined){this.setByDate(a.date)}}}}if(a.millis===true){this.withMillis=true}}};YAHOO.lang.extend(KJUR.asn1.DERGeneralizedTime,KJUR.asn1.DERAbstractTime);KJUR.asn1.DERSequence=function(a){KJUR.asn1.DERSequence.superclass.constructor.call(this,a);this.hT="30";this.getFreshValueHex=function(){var c="";for(var b=0;b<this.asn1Array.length;b++){var d=this.asn1Array[b];c+=d.getEncodedHex()}this.hV=c;return this.hV}};YAHOO.lang.extend(KJUR.asn1.DERSequence,KJUR.asn1.DERAbstractStructured);KJUR.asn1.DERSet=function(a){KJUR.asn1.DERSet.superclass.constructor.call(this,a);this.hT="31";this.sortFlag=true;this.getFreshValueHex=function(){var b=new Array();for(var c=0;c<this.asn1Array.length;c++){var d=this.asn1Array[c];b.push(d.getEncodedHex())}if(this.sortFlag==true){b.sort()}this.hV=b.join("");return this.hV};if(typeof a!="undefined"){if(typeof a.sortflag!="undefined"&&a.sortflag==false){this.sortFlag=false}}};YAHOO.lang.extend(KJUR.asn1.DERSet,KJUR.asn1.DERAbstractStructured);KJUR.asn1.DERTaggedObject=function(a){KJUR.asn1.DERTaggedObject.superclass.constructor.call(this);this.hT="a0";this.hV="";this.isExplicit=true;this.asn1Object=null;this.setASN1Object=function(b,c,d){this.hT=c;this.isExplicit=b;this.asn1Object=d;if(this.isExplicit){this.hV=this.asn1Object.getEncodedHex();this.hTLV=null;this.isModified=true}else{this.hV=null;this.hTLV=d.getEncodedHex();this.hTLV=this.hTLV.replace(/^../,c);this.isModified=false}};this.getFreshValueHex=function(){return this.hV};if(typeof a!="undefined"){if(typeof a.tag!="undefined"){this.hT=a.tag}if(typeof a.explicit!="undefined"){this.isExplicit=a.explicit}if(typeof a.obj!="undefined"){this.asn1Object=a.obj;this.setASN1Object(this.isExplicit,this.hT,this.asn1Object)}}};YAHOO.lang.extend(KJUR.asn1.DERTaggedObject,KJUR.asn1.ASN1Object);
	/*! asn1hex-1.1.9.js (c) 2012-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	var ASN1HEX=new function(){};ASN1HEX.getByteLengthOfL_AtObj=function(b,c){if(b.substring(c+2,c+3)!="8"){return 1}var a=parseInt(b.substring(c+3,c+4));if(a==0){return -1}if(0<a&&a<10){return a+1}return -2};ASN1HEX.getHexOfL_AtObj=function(b,c){var a=ASN1HEX.getByteLengthOfL_AtObj(b,c);if(a<1){return""}return b.substring(c+2,c+2+a*2)};ASN1HEX.getIntOfL_AtObj=function(c,d){var b=ASN1HEX.getHexOfL_AtObj(c,d);if(b==""){return -1}var a;if(parseInt(b.substring(0,1))<8){a=new BigInteger(b,16)}else{a=new BigInteger(b.substring(2),16)}return a.intValue()};ASN1HEX.getStartPosOfV_AtObj=function(b,c){var a=ASN1HEX.getByteLengthOfL_AtObj(b,c);if(a<0){return a}return c+(a+1)*2};ASN1HEX.getHexOfV_AtObj=function(c,d){var b=ASN1HEX.getStartPosOfV_AtObj(c,d);var a=ASN1HEX.getIntOfL_AtObj(c,d);return c.substring(b,b+a*2)};ASN1HEX.getHexOfTLV_AtObj=function(c,e){var b=c.substr(e,2);var d=ASN1HEX.getHexOfL_AtObj(c,e);var a=ASN1HEX.getHexOfV_AtObj(c,e);return b+d+a};ASN1HEX.getPosOfNextSibling_AtObj=function(c,d){var b=ASN1HEX.getStartPosOfV_AtObj(c,d);var a=ASN1HEX.getIntOfL_AtObj(c,d);return b+a*2};ASN1HEX.getPosArrayOfChildren_AtObj=function(f,j){var c=new Array();var i=ASN1HEX.getStartPosOfV_AtObj(f,j);if(f.substr(j,2)=="03"){c.push(i+2)}else{c.push(i)}var b=ASN1HEX.getIntOfL_AtObj(f,j);var g=i;var d=0;while(1){var e=ASN1HEX.getPosOfNextSibling_AtObj(f,g);if(e==null||(e-i>=(b*2))){break}if(d>=200){break}c.push(e);g=e;d++}return c};ASN1HEX.getNthChildIndex_AtObj=function(d,b,e){var c=ASN1HEX.getPosArrayOfChildren_AtObj(d,b);return c[e]};ASN1HEX.getDecendantIndexByNthList=function(e,d,c){if(c.length==0){return d}var f=c.shift();var b=ASN1HEX.getPosArrayOfChildren_AtObj(e,d);return ASN1HEX.getDecendantIndexByNthList(e,b[f],c)};ASN1HEX.getDecendantHexTLVByNthList=function(d,c,b){var a=ASN1HEX.getDecendantIndexByNthList(d,c,b);return ASN1HEX.getHexOfTLV_AtObj(d,a)};ASN1HEX.getDecendantHexVByNthList=function(d,c,b){var a=ASN1HEX.getDecendantIndexByNthList(d,c,b);return ASN1HEX.getHexOfV_AtObj(d,a)};ASN1HEX.getVbyList=function(d,c,b,e){var a=ASN1HEX.getDecendantIndexByNthList(d,c,b);if(a===undefined){throw"can't find nthList object"}if(e!==undefined){if(d.substr(a,2)!=e){throw"checking tag doesn't match: "+d.substr(a,2)+"!="+e}}return ASN1HEX.getHexOfV_AtObj(d,a)};ASN1HEX.hextooidstr=function(e){var h=function(b,a){if(b.length>=a){return b}return new Array(a-b.length+1).join("0")+b};var l=[];var o=e.substr(0,2);var f=parseInt(o,16);l[0]=new String(Math.floor(f/40));l[1]=new String(f%40);var m=e.substr(2);var k=[];for(var g=0;g<m.length/2;g++){k.push(parseInt(m.substr(g*2,2),16))}var j=[];var d="";for(var g=0;g<k.length;g++){if(k[g]&128){d=d+h((k[g]&127).toString(2),7)}else{d=d+h((k[g]&127).toString(2),7);j.push(new String(parseInt(d,2)));d=""}}var n=l.join(".");if(j.length>0){n=n+"."+j.join(".")}return n};ASN1HEX.dump=function(q,c,k,g){var e=q;if(q instanceof KJUR.asn1.ASN1Object){e=q.getEncodedHex()}var o=function(x,i){if(x.length<=i*2){return x}else{var v=x.substr(0,i)+"..(total "+x.length/2+"bytes).."+x.substr(x.length-i,i);return v}};if(c===undefined){c={ommit_long_octet:32}}if(k===undefined){k=0}if(g===undefined){g=""}var t=c.ommit_long_octet;if(e.substr(k,2)=="01"){var h=ASN1HEX.getHexOfV_AtObj(e,k);if(h=="00"){return g+"BOOLEAN FALSE\n"}else{return g+"BOOLEAN TRUE\n"}}if(e.substr(k,2)=="02"){var h=ASN1HEX.getHexOfV_AtObj(e,k);return g+"INTEGER "+o(h,t)+"\n"}if(e.substr(k,2)=="03"){var h=ASN1HEX.getHexOfV_AtObj(e,k);return g+"BITSTRING "+o(h,t)+"\n"}if(e.substr(k,2)=="04"){var h=ASN1HEX.getHexOfV_AtObj(e,k);if(ASN1HEX.isASN1HEX(h)){var j=g+"OCTETSTRING, encapsulates\n";j=j+ASN1HEX.dump(h,c,0,g+"  ");return j}else{return g+"OCTETSTRING "+o(h,t)+"\n"}}if(e.substr(k,2)=="05"){return g+"NULL\n"}if(e.substr(k,2)=="06"){var l=ASN1HEX.getHexOfV_AtObj(e,k);var a=KJUR.asn1.ASN1Util.oidHexToInt(l);var n=KJUR.asn1.x509.OID.oid2name(a);var b=a.replace(/\./g," ");if(n!=""){return g+"ObjectIdentifier "+n+" ("+b+")\n"}else{return g+"ObjectIdentifier ("+b+")\n"}}if(e.substr(k,2)=="0c"){return g+"UTF8String '"+hextoutf8(ASN1HEX.getHexOfV_AtObj(e,k))+"'\n"}if(e.substr(k,2)=="13"){return g+"PrintableString '"+hextoutf8(ASN1HEX.getHexOfV_AtObj(e,k))+"'\n"}if(e.substr(k,2)=="14"){return g+"TeletexString '"+hextoutf8(ASN1HEX.getHexOfV_AtObj(e,k))+"'\n"}if(e.substr(k,2)=="16"){return g+"IA5String '"+hextoutf8(ASN1HEX.getHexOfV_AtObj(e,k))+"'\n"}if(e.substr(k,2)=="17"){return g+"UTCTime "+hextoutf8(ASN1HEX.getHexOfV_AtObj(e,k))+"\n"}if(e.substr(k,2)=="18"){return g+"GeneralizedTime "+hextoutf8(ASN1HEX.getHexOfV_AtObj(e,k))+"\n"}if(e.substr(k,2)=="30"){if(e.substr(k,4)=="3000"){return g+"SEQUENCE {}\n"}var j=g+"SEQUENCE\n";var d=ASN1HEX.getPosArrayOfChildren_AtObj(e,k);var f=c;if((d.length==2||d.length==3)&&e.substr(d[0],2)=="06"&&e.substr(d[d.length-1],2)=="04"){var u=ASN1HEX.getHexOfV_AtObj(e,d[0]);var a=KJUR.asn1.ASN1Util.oidHexToInt(u);var n=KJUR.asn1.x509.OID.oid2name(a);var p=JSON.parse(JSON.stringify(c));p.x509ExtName=n;f=p}for(var r=0;r<d.length;r++){j=j+ASN1HEX.dump(e,f,d[r],g+"  ")}return j}if(e.substr(k,2)=="31"){var j=g+"SET\n";var d=ASN1HEX.getPosArrayOfChildren_AtObj(e,k);for(var r=0;r<d.length;r++){j=j+ASN1HEX.dump(e,c,d[r],g+"  ")}return j}var w=parseInt(e.substr(k,2),16);if((w&128)!=0){var m=w&31;if((w&32)!=0){var j=g+"["+m+"]\n";var d=ASN1HEX.getPosArrayOfChildren_AtObj(e,k);for(var r=0;r<d.length;r++){j=j+ASN1HEX.dump(e,c,d[r],g+"  ")}return j}else{var h=ASN1HEX.getHexOfV_AtObj(e,k);if(h.substr(0,8)=="68747470"){h=hextoutf8(h)}if(c.x509ExtName==="subjectAltName"&&m==2){h=hextoutf8(h)}var j=g+"["+m+"] "+h+"\n";return j}}return g+"UNKNOWN("+e.substr(k,2)+") "+ASN1HEX.getHexOfV_AtObj(e,k)+"\n"};ASN1HEX.isASN1HEX=function(d){if(d.length%2==1){return false}var c=ASN1HEX.getIntOfL_AtObj(d,0);var b=d.substr(0,2);var e=ASN1HEX.getHexOfL_AtObj(d,0);var a=d.length-b.length-e.length;if(a==c*2){return true}return false};ASN1HEX.pemToHex=function(b,d){if(b.indexOf("-----BEGIN ")==-1){throw"can't find PEM header: "+d}if(d!==undefined){b=b.replace("-----BEGIN "+d+"-----","");b=b.replace("-----END "+d+"-----","")}else{b=b.replace(/-----BEGIN [^-]+-----/,"");b=b.replace(/-----END [^-]+-----/,"")}var c=b.replace(/\s+/g,"");var a=b64tohex(c);return a};
	/*! asn1x509-1.0.22.js (c) 2013-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.asn1=="undefined"||!KJUR.asn1){KJUR.asn1={}}if(typeof KJUR.asn1.x509=="undefined"||!KJUR.asn1.x509){KJUR.asn1.x509={}}KJUR.asn1.x509.Certificate=function(g){KJUR.asn1.x509.Certificate.superclass.constructor.call(this);var b=null;var d=null;var f=null;var c=null;var a=null;var e=null;this.setRsaPrvKeyByPEMandPass=function(i,k){var h=PKCS5PKEY.getDecryptedKeyHex(i,k);var j=new RSAKey();j.readPrivateKeyFromASN1HexString(h);this.prvKey=j};this.sign=function(){this.asn1SignatureAlg=this.asn1TBSCert.asn1SignatureAlg;var i=new KJUR.crypto.Signature({alg:this.asn1SignatureAlg.nameAlg});i.init(this.prvKey);i.updateHex(this.asn1TBSCert.getEncodedHex());this.hexSig=i.sign();this.asn1Sig=new KJUR.asn1.DERBitString({hex:"00"+this.hexSig});var h=new KJUR.asn1.DERSequence({array:[this.asn1TBSCert,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=h.getEncodedHex();this.isModified=false};this.setSignatureHex=function(h){this.asn1SignatureAlg=this.asn1TBSCert.asn1SignatureAlg;this.hexSig=h;this.asn1Sig=new KJUR.asn1.DERBitString({hex:"00"+this.hexSig});var i=new KJUR.asn1.DERSequence({array:[this.asn1TBSCert,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=i.getEncodedHex();this.isModified=false};this.getEncodedHex=function(){if(this.isModified==false&&this.hTLV!=null){return this.hTLV}throw"not signed yet"};this.getPEMString=function(){var j=this.getEncodedHex();var h=CryptoJS.enc.Hex.parse(j);var i=CryptoJS.enc.Base64.stringify(h);var k=i.replace(/(.{64})/g,"$1\r\n");return"-----BEGIN CERTIFICATE-----\r\n"+k+"\r\n-----END CERTIFICATE-----\r\n"};if(g!==undefined){if(g.tbscertobj!==undefined){this.asn1TBSCert=g.tbscertobj}if(g.prvkeyobj!==undefined){this.prvKey=g.prvkeyobj}else{if(g.rsaprvkey!==undefined){this.prvKey=g.rsaprvkey}else{if((g.rsaprvpem!==undefined)&&(g.rsaprvpas!==undefined)){this.setRsaPrvKeyByPEMandPass(g.rsaprvpem,g.rsaprvpas)}}}}};YAHOO.lang.extend(KJUR.asn1.x509.Certificate,KJUR.asn1.ASN1Object);KJUR.asn1.x509.TBSCertificate=function(a){KJUR.asn1.x509.TBSCertificate.superclass.constructor.call(this);this._initialize=function(){this.asn1Array=new Array();this.asn1Version=new KJUR.asn1.DERTaggedObject({obj:new KJUR.asn1.DERInteger({"int":2})});this.asn1SerialNumber=null;this.asn1SignatureAlg=null;this.asn1Issuer=null;this.asn1NotBefore=null;this.asn1NotAfter=null;this.asn1Subject=null;this.asn1SubjPKey=null;this.extensionsArray=new Array()};this.setSerialNumberByParam=function(b){this.asn1SerialNumber=new KJUR.asn1.DERInteger(b)};this.setSignatureAlgByParam=function(b){this.asn1SignatureAlg=new KJUR.asn1.x509.AlgorithmIdentifier(b)};this.setIssuerByParam=function(b){this.asn1Issuer=new KJUR.asn1.x509.X500Name(b)};this.setNotBeforeByParam=function(b){this.asn1NotBefore=new KJUR.asn1.x509.Time(b)};this.setNotAfterByParam=function(b){this.asn1NotAfter=new KJUR.asn1.x509.Time(b)};this.setSubjectByParam=function(b){this.asn1Subject=new KJUR.asn1.x509.X500Name(b)};this.setSubjectPublicKeyByParam=function(b){this.asn1SubjPKey=new KJUR.asn1.x509.SubjectPublicKeyInfo(b)};this.setSubjectPublicKeyByGetKey=function(c){var b=KEYUTIL.getKey(c);this.asn1SubjPKey=new KJUR.asn1.x509.SubjectPublicKeyInfo(b)};this.appendExtension=function(b){this.extensionsArray.push(b)};this.appendExtensionByName=function(c,b){KJUR.asn1.x509.Extension.appendByNameToArray(c,b,this.extensionsArray)};this.getEncodedHex=function(){if(this.asn1NotBefore==null||this.asn1NotAfter==null){throw"notBefore and/or notAfter not set"}var c=new KJUR.asn1.DERSequence({array:[this.asn1NotBefore,this.asn1NotAfter]});this.asn1Array=new Array();this.asn1Array.push(this.asn1Version);this.asn1Array.push(this.asn1SerialNumber);this.asn1Array.push(this.asn1SignatureAlg);this.asn1Array.push(this.asn1Issuer);this.asn1Array.push(c);this.asn1Array.push(this.asn1Subject);this.asn1Array.push(this.asn1SubjPKey);if(this.extensionsArray.length>0){var d=new KJUR.asn1.DERSequence({array:this.extensionsArray});var b=new KJUR.asn1.DERTaggedObject({explicit:true,tag:"a3",obj:d});this.asn1Array.push(b)}var e=new KJUR.asn1.DERSequence({array:this.asn1Array});this.hTLV=e.getEncodedHex();this.isModified=false;return this.hTLV};this._initialize()};YAHOO.lang.extend(KJUR.asn1.x509.TBSCertificate,KJUR.asn1.ASN1Object);KJUR.asn1.x509.Extension=function(b){KJUR.asn1.x509.Extension.superclass.constructor.call(this);var a=null;this.getEncodedHex=function(){var f=new KJUR.asn1.DERObjectIdentifier({oid:this.oid});var e=new KJUR.asn1.DEROctetString({hex:this.getExtnValueHex()});var d=new Array();d.push(f);if(this.critical){d.push(new KJUR.asn1.DERBoolean())}d.push(e);var c=new KJUR.asn1.DERSequence({array:d});return c.getEncodedHex()};this.critical=false;if(typeof b!="undefined"){if(typeof b.critical!="undefined"){this.critical=b.critical}}};YAHOO.lang.extend(KJUR.asn1.x509.Extension,KJUR.asn1.ASN1Object);KJUR.asn1.x509.Extension.appendByNameToArray=function(e,c,b){if(e.toLowerCase()=="basicconstraints"){var d=new KJUR.asn1.x509.BasicConstraints(c);b.push(d)}else{if(e.toLowerCase()=="keyusage"){var d=new KJUR.asn1.x509.KeyUsage(c);b.push(d)}else{if(e.toLowerCase()=="crldistributionpoints"){var d=new KJUR.asn1.x509.CRLDistributionPoints(c);b.push(d)}else{if(e.toLowerCase()=="extkeyusage"){var d=new KJUR.asn1.x509.ExtKeyUsage(c);b.push(d)}else{if(e.toLowerCase()=="authoritykeyidentifier"){var d=new KJUR.asn1.x509.AuthorityKeyIdentifier(c);b.push(d)}else{if(e.toLowerCase()=="authorityinfoaccess"){var d=new KJUR.asn1.x509.AuthorityInfoAccess(c);b.push(d)}else{if(e.toLowerCase()=="subjectaltname"){var d=new KJUR.asn1.x509.SubjectAltName(c);b.push(d)}else{if(e.toLowerCase()=="issueraltname"){var d=new KJUR.asn1.x509.IssuerAltName(c);b.push(d)}else{throw"unsupported extension name: "+e}}}}}}}}};KJUR.asn1.x509.KeyUsage=function(a){KJUR.asn1.x509.KeyUsage.superclass.constructor.call(this,a);this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()};this.oid="2.5.29.15";if(typeof a!="undefined"){if(typeof a.bin!="undefined"){this.asn1ExtnValue=new KJUR.asn1.DERBitString(a)}}};YAHOO.lang.extend(KJUR.asn1.x509.KeyUsage,KJUR.asn1.x509.Extension);KJUR.asn1.x509.BasicConstraints=function(c){KJUR.asn1.x509.BasicConstraints.superclass.constructor.call(this,c);var a=false;var b=-1;this.getExtnValueHex=function(){var e=new Array();if(this.cA){e.push(new KJUR.asn1.DERBoolean())}if(this.pathLen>-1){e.push(new KJUR.asn1.DERInteger({"int":this.pathLen}))}var d=new KJUR.asn1.DERSequence({array:e});this.asn1ExtnValue=d;return this.asn1ExtnValue.getEncodedHex()};this.oid="2.5.29.19";this.cA=false;this.pathLen=-1;if(typeof c!="undefined"){if(typeof c.cA!="undefined"){this.cA=c.cA}if(typeof c.pathLen!="undefined"){this.pathLen=c.pathLen}}};YAHOO.lang.extend(KJUR.asn1.x509.BasicConstraints,KJUR.asn1.x509.Extension);KJUR.asn1.x509.CRLDistributionPoints=function(a){KJUR.asn1.x509.CRLDistributionPoints.superclass.constructor.call(this,a);this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()};this.setByDPArray=function(b){this.asn1ExtnValue=new KJUR.asn1.DERSequence({array:b})};this.setByOneURI=function(e){var b=new KJUR.asn1.x509.GeneralNames([{uri:e}]);var d=new KJUR.asn1.x509.DistributionPointName(b);var c=new KJUR.asn1.x509.DistributionPoint({dpobj:d});this.setByDPArray([c])};this.oid="2.5.29.31";if(typeof a!="undefined"){if(typeof a.array!="undefined"){this.setByDPArray(a.array)}else{if(typeof a.uri!="undefined"){this.setByOneURI(a.uri)}}}};YAHOO.lang.extend(KJUR.asn1.x509.CRLDistributionPoints,KJUR.asn1.x509.Extension);KJUR.asn1.x509.ExtKeyUsage=function(a){KJUR.asn1.x509.ExtKeyUsage.superclass.constructor.call(this,a);this.setPurposeArray=function(b){this.asn1ExtnValue=new KJUR.asn1.DERSequence();for(var c=0;c<b.length;c++){var d=new KJUR.asn1.DERObjectIdentifier(b[c]);this.asn1ExtnValue.appendASN1Object(d)}};this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()};this.oid="2.5.29.37";if(typeof a!="undefined"){if(typeof a.array!="undefined"){this.setPurposeArray(a.array)}}};YAHOO.lang.extend(KJUR.asn1.x509.ExtKeyUsage,KJUR.asn1.x509.Extension);KJUR.asn1.x509.AuthorityKeyIdentifier=function(a){KJUR.asn1.x509.AuthorityKeyIdentifier.superclass.constructor.call(this,a);this.asn1KID=null;this.asn1CertIssuer=null;this.asn1CertSN=null;this.getExtnValueHex=function(){var c=new Array();if(this.asn1KID){c.push(new KJUR.asn1.DERTaggedObject({explicit:false,tag:"80",obj:this.asn1KID}))}if(this.asn1CertIssuer){c.push(new KJUR.asn1.DERTaggedObject({explicit:false,tag:"a1",obj:this.asn1CertIssuer}))}if(this.asn1CertSN){c.push(new KJUR.asn1.DERTaggedObject({explicit:false,tag:"82",obj:this.asn1CertSN}))}var b=new KJUR.asn1.DERSequence({array:c});this.asn1ExtnValue=b;return this.asn1ExtnValue.getEncodedHex()};this.setKIDByParam=function(b){this.asn1KID=new KJUR.asn1.DEROctetString(b)};this.setCertIssuerByParam=function(b){this.asn1CertIssuer=new KJUR.asn1.x509.X500Name(b)};this.setCertSNByParam=function(b){this.asn1CertSN=new KJUR.asn1.DERInteger(b)};this.oid="2.5.29.35";if(typeof a!="undefined"){if(typeof a.kid!="undefined"){this.setKIDByParam(a.kid)}if(typeof a.issuer!="undefined"){this.setCertIssuerByParam(a.issuer)}if(typeof a.sn!="undefined"){this.setCertSNByParam(a.sn)}}};YAHOO.lang.extend(KJUR.asn1.x509.AuthorityKeyIdentifier,KJUR.asn1.x509.Extension);KJUR.asn1.x509.AuthorityInfoAccess=function(a){KJUR.asn1.x509.AuthorityInfoAccess.superclass.constructor.call(this,a);this.setAccessDescriptionArray=function(c){var g=new Array();for(var b=0;b<c.length;b++){var e=new KJUR.asn1.DERObjectIdentifier(c[b].accessMethod);var d=new KJUR.asn1.x509.GeneralName(c[b].accessLocation);var f=new KJUR.asn1.DERSequence({array:[e,d]});g.push(f)}this.asn1ExtnValue=new KJUR.asn1.DERSequence({array:g})};this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()};this.oid="1.3.6.1.5.5.7.1.1";if(typeof a!="undefined"){if(typeof a.array!="undefined"){this.setAccessDescriptionArray(a.array)}}};YAHOO.lang.extend(KJUR.asn1.x509.AuthorityInfoAccess,KJUR.asn1.x509.Extension);KJUR.asn1.x509.SubjectAltName=function(a){KJUR.asn1.x509.SubjectAltName.superclass.constructor.call(this,a);this.setNameArray=function(b){this.asn1ExtnValue=new KJUR.asn1.x509.GeneralNames(b)};this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()};this.oid="2.5.29.17";if(a!==undefined){if(a.array!==undefined){this.setNameArray(a.array)}}};YAHOO.lang.extend(KJUR.asn1.x509.SubjectAltName,KJUR.asn1.x509.Extension);KJUR.asn1.x509.IssuerAltName=function(a){KJUR.asn1.x509.IssuerAltName.superclass.constructor.call(this,a);this.setNameArray=function(b){this.asn1ExtnValue=new KJUR.asn1.x509.GeneralNames(b)};this.getExtnValueHex=function(){return this.asn1ExtnValue.getEncodedHex()};this.oid="2.5.29.18";if(a!==undefined){if(a.array!==undefined){this.setNameArray(a.array)}}};YAHOO.lang.extend(KJUR.asn1.x509.IssuerAltName,KJUR.asn1.x509.Extension);KJUR.asn1.x509.CRL=function(f){KJUR.asn1.x509.CRL.superclass.constructor.call(this);var a=null;var c=null;var e=null;var b=null;var d=null;this.setRsaPrvKeyByPEMandPass=function(h,j){var g=PKCS5PKEY.getDecryptedKeyHex(h,j);var i=new RSAKey();i.readPrivateKeyFromASN1HexString(g);this.rsaPrvKey=i};this.sign=function(){this.asn1SignatureAlg=this.asn1TBSCertList.asn1SignatureAlg;sig=new KJUR.crypto.Signature({alg:"SHA1withRSA",prov:"cryptojs/jsrsa"});sig.initSign(this.rsaPrvKey);sig.updateHex(this.asn1TBSCertList.getEncodedHex());this.hexSig=sig.sign();this.asn1Sig=new KJUR.asn1.DERBitString({hex:"00"+this.hexSig});var g=new KJUR.asn1.DERSequence({array:[this.asn1TBSCertList,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=g.getEncodedHex();this.isModified=false};this.getEncodedHex=function(){if(this.isModified==false&&this.hTLV!=null){return this.hTLV}throw"not signed yet"};this.getPEMString=function(){var i=this.getEncodedHex();var g=CryptoJS.enc.Hex.parse(i);var h=CryptoJS.enc.Base64.stringify(g);var j=h.replace(/(.{64})/g,"$1\r\n");return"-----BEGIN X509 CRL-----\r\n"+j+"\r\n-----END X509 CRL-----\r\n"};if(typeof f!="undefined"){if(typeof f.tbsobj!="undefined"){this.asn1TBSCertList=f.tbsobj}if(typeof f.rsaprvkey!="undefined"){this.rsaPrvKey=f.rsaprvkey}if((typeof f.rsaprvpem!="undefined")&&(typeof f.rsaprvpas!="undefined")){this.setRsaPrvKeyByPEMandPass(f.rsaprvpem,f.rsaprvpas)}}};YAHOO.lang.extend(KJUR.asn1.x509.CRL,KJUR.asn1.ASN1Object);KJUR.asn1.x509.TBSCertList=function(b){KJUR.asn1.x509.TBSCertList.superclass.constructor.call(this);var a=null;this.setSignatureAlgByParam=function(c){this.asn1SignatureAlg=new KJUR.asn1.x509.AlgorithmIdentifier(c)};this.setIssuerByParam=function(c){this.asn1Issuer=new KJUR.asn1.x509.X500Name(c)};this.setThisUpdateByParam=function(c){this.asn1ThisUpdate=new KJUR.asn1.x509.Time(c)};this.setNextUpdateByParam=function(c){this.asn1NextUpdate=new KJUR.asn1.x509.Time(c)};this.addRevokedCert=function(c,d){var f={};if(c!=undefined&&c!=null){f.sn=c}if(d!=undefined&&d!=null){f.time=d}var e=new KJUR.asn1.x509.CRLEntry(f);this.aRevokedCert.push(e)};this.getEncodedHex=function(){this.asn1Array=new Array();if(this.asn1Version!=null){this.asn1Array.push(this.asn1Version)}this.asn1Array.push(this.asn1SignatureAlg);this.asn1Array.push(this.asn1Issuer);this.asn1Array.push(this.asn1ThisUpdate);if(this.asn1NextUpdate!=null){this.asn1Array.push(this.asn1NextUpdate)}if(this.aRevokedCert.length>0){var c=new KJUR.asn1.DERSequence({array:this.aRevokedCert});this.asn1Array.push(c)}var d=new KJUR.asn1.DERSequence({array:this.asn1Array});this.hTLV=d.getEncodedHex();this.isModified=false;return this.hTLV};this._initialize=function(){this.asn1Version=null;this.asn1SignatureAlg=null;this.asn1Issuer=null;this.asn1ThisUpdate=null;this.asn1NextUpdate=null;this.aRevokedCert=new Array()};this._initialize()};YAHOO.lang.extend(KJUR.asn1.x509.TBSCertList,KJUR.asn1.ASN1Object);KJUR.asn1.x509.CRLEntry=function(c){KJUR.asn1.x509.CRLEntry.superclass.constructor.call(this);var b=null;var a=null;this.setCertSerial=function(d){this.sn=new KJUR.asn1.DERInteger(d)};this.setRevocationDate=function(d){this.time=new KJUR.asn1.x509.Time(d)};this.getEncodedHex=function(){var d=new KJUR.asn1.DERSequence({array:[this.sn,this.time]});this.TLV=d.getEncodedHex();return this.TLV};if(typeof c!="undefined"){if(typeof c.time!="undefined"){this.setRevocationDate(c.time)}if(typeof c.sn!="undefined"){this.setCertSerial(c.sn)}}};YAHOO.lang.extend(KJUR.asn1.x509.CRLEntry,KJUR.asn1.ASN1Object);KJUR.asn1.x509.X500Name=function(b){KJUR.asn1.x509.X500Name.superclass.constructor.call(this);this.asn1Array=new Array();this.setByString=function(c){var d=c.split("/");d.shift();for(var e=0;e<d.length;e++){this.asn1Array.push(new KJUR.asn1.x509.RDN({str:d[e]}))}};this.setByLdapString=function(c){var d=KJUR.asn1.x509.X500Name.ldapToOneline(c);this.setByString(d)};this.setByObject=function(e){for(var c in e){if(e.hasOwnProperty(c)){var d=new KJUR.asn1.x509.RDN({str:c+"="+e[c]});this.asn1Array?this.asn1Array.push(d):this.asn1Array=[d]}}};this.getEncodedHex=function(){if(typeof this.hTLV=="string"){return this.hTLV}var c=new KJUR.asn1.DERSequence({array:this.asn1Array});this.hTLV=c.getEncodedHex();return this.hTLV};if(b!==undefined){if(b.str!==undefined){this.setByString(b.str)}else{if(b.ldapstr!==undefined){this.setByLdapString(b.ldapstr)}else{if(typeof b==="object"){this.setByObject(b)}}}if(b.certissuer!==undefined){var a=new X509();a.hex=ASN1HEX.pemToHex(b.certissuer);this.hTLV=a.getIssuerHex()}if(b.certsubject!==undefined){var a=new X509();a.hex=ASN1HEX.pemToHex(b.certsubject);this.hTLV=a.getSubjectHex()}}};YAHOO.lang.extend(KJUR.asn1.x509.X500Name,KJUR.asn1.ASN1Object);KJUR.asn1.x509.X500Name.onelineToLDAP=function(d){if(d.substr(0,1)!=="/"){throw"malformed input"}var b="";d=d.substr(1);var c=d.split("/");c.reverse();c=c.map(function(a){return a.replace(/,/,"\\,")});return c.join(",")};KJUR.asn1.x509.X500Name.ldapToOneline=function(g){var c=g.split(",");var e=false;var b=[];for(var f=0;c.length>0;f++){var h=c.shift();if(e===true){var d=b.pop();var j=(d+","+h).replace(/\\,/g,",");b.push(j);e=false}else{b.push(h)}if(h.substr(-1,1)==="\\"){e=true}}b=b.map(function(a){return a.replace("/","\\/")});b.reverse();return"/"+b.join("/")};KJUR.asn1.x509.RDN=function(a){KJUR.asn1.x509.RDN.superclass.constructor.call(this);this.asn1Array=new Array();this.addByString=function(b){this.asn1Array.push(new KJUR.asn1.x509.AttributeTypeAndValue({str:b}))};this.addByMultiValuedString=function(d){var b=KJUR.asn1.x509.RDN.parseString(d);for(var c=0;c<b.length;c++){this.addByString(b[c])}};this.getEncodedHex=function(){var b=new KJUR.asn1.DERSet({array:this.asn1Array});this.TLV=b.getEncodedHex();return this.TLV};if(typeof a!="undefined"){if(typeof a.str!="undefined"){this.addByMultiValuedString(a.str)}}};YAHOO.lang.extend(KJUR.asn1.x509.RDN,KJUR.asn1.ASN1Object);KJUR.asn1.x509.RDN.parseString=function(m){var j=m.split(/\+/);var h=false;var c=[];for(var g=0;j.length>0;g++){var k=j.shift();if(h===true){var f=c.pop();var d=(f+"+"+k).replace(/\\\+/g,"+");c.push(d);h=false}else{c.push(k)}if(k.substr(-1,1)==="\\"){h=true}}var l=false;var b=[];for(var g=0;c.length>0;g++){var k=c.shift();if(l===true){var e=b.pop();if(k.match(/"$/)){var d=(e+"+"+k).replace(/^([^=]+)="(.*)"$/,"$1=$2");b.push(d);l=false}else{b.push(e+"+"+k)}}else{b.push(k)}if(k.match(/^[^=]+="/)){l=true}}return b};KJUR.asn1.x509.AttributeTypeAndValue=function(b){KJUR.asn1.x509.AttributeTypeAndValue.superclass.constructor.call(this);var d=null;var c=null;var a="utf8";this.setByString=function(f){var e=f.match(/^([^=]+)=(.+)$/);if(e){this.setByAttrTypeAndValueStr(e[1],e[2])}else{throw"malformed attrTypeAndValueStr: "+f}};this.setByAttrTypeAndValueStr=function(g,f){this.typeObj=KJUR.asn1.x509.OID.atype2obj(g);var e=a;if(g=="C"){e="prn"}this.valueObj=this.getValueObj(e,f)};this.getValueObj=function(f,e){if(f=="utf8"){return new KJUR.asn1.DERUTF8String({str:e})}if(f=="prn"){return new KJUR.asn1.DERPrintableString({str:e})}if(f=="tel"){return new KJUR.asn1.DERTeletexString({str:e})}if(f=="ia5"){return new KJUR.asn1.DERIA5String({str:e})}throw"unsupported directory string type: type="+f+" value="+e};this.getEncodedHex=function(){var e=new KJUR.asn1.DERSequence({array:[this.typeObj,this.valueObj]});this.TLV=e.getEncodedHex();return this.TLV};if(typeof b!="undefined"){if(typeof b.str!="undefined"){this.setByString(b.str)}}};YAHOO.lang.extend(KJUR.asn1.x509.AttributeTypeAndValue,KJUR.asn1.ASN1Object);KJUR.asn1.x509.SubjectPublicKeyInfo=function(d){KJUR.asn1.x509.SubjectPublicKeyInfo.superclass.constructor.call(this);var b=null;var c=null;var a=null;this.setRSAKey=function(e){if(!RSAKey.prototype.isPrototypeOf(e)){throw"argument is not RSAKey instance"}this.rsaKey=e;var g=new KJUR.asn1.DERInteger({bigint:e.n});var f=new KJUR.asn1.DERInteger({"int":e.e});var i=new KJUR.asn1.DERSequence({array:[g,f]});var h=i.getEncodedHex();this.asn1AlgId=new KJUR.asn1.x509.AlgorithmIdentifier({name:"rsaEncryption"});this.asn1SubjPKey=new KJUR.asn1.DERBitString({hex:"00"+h})};this.setRSAPEM=function(g){if(g.match(/-----BEGIN PUBLIC KEY-----/)){var n=g;n=n.replace(/^-----[^-]+-----/,"");n=n.replace(/-----[^-]+-----\s*$/,"");var m=n.replace(/\s+/g,"");var f=CryptoJS.enc.Base64.parse(m);var i=CryptoJS.enc.Hex.stringify(f);var k=RSAKey.getHexValueArrayOfChildrenFromHex(i);var h=k[1];var l=h.substr(2);var e=RSAKey.getHexValueArrayOfChildrenFromHex(l);var j=new RSAKey();j.setPublic(e[0],e[1]);this.setRSAKey(j)}else{throw"key not supported"}};this.getASN1Object=function(){if(this.asn1AlgId==null||this.asn1SubjPKey==null){throw"algId and/or subjPubKey not set"}var e=new KJUR.asn1.DERSequence({array:[this.asn1AlgId,this.asn1SubjPKey]});return e};this.getEncodedHex=function(){var e=this.getASN1Object();this.hTLV=e.getEncodedHex();return this.hTLV};this._setRSAKey=function(e){var g=KJUR.asn1.ASN1Util.newObject({seq:[{"int":{bigint:e.n}},{"int":{"int":e.e}}]});var f=g.getEncodedHex();this.asn1AlgId=new KJUR.asn1.x509.AlgorithmIdentifier({name:"rsaEncryption"});this.asn1SubjPKey=new KJUR.asn1.DERBitString({hex:"00"+f})};this._setEC=function(e){var f=new KJUR.asn1.DERObjectIdentifier({name:e.curveName});this.asn1AlgId=new KJUR.asn1.x509.AlgorithmIdentifier({name:"ecPublicKey",asn1params:f});this.asn1SubjPKey=new KJUR.asn1.DERBitString({hex:"00"+e.pubKeyHex})};this._setDSA=function(e){var f=new KJUR.asn1.ASN1Util.newObject({seq:[{"int":{bigint:e.p}},{"int":{bigint:e.q}},{"int":{bigint:e.g}}]});this.asn1AlgId=new KJUR.asn1.x509.AlgorithmIdentifier({name:"dsa",asn1params:f});var g=new KJUR.asn1.DERInteger({bigint:e.y});this.asn1SubjPKey=new KJUR.asn1.DERBitString({hex:"00"+g.getEncodedHex()})};if(typeof d!="undefined"){if(typeof RSAKey!="undefined"&&d instanceof RSAKey){this._setRSAKey(d)}else{if(typeof KJUR.crypto.ECDSA!="undefined"&&d instanceof KJUR.crypto.ECDSA){this._setEC(d)}else{if(typeof KJUR.crypto.DSA!="undefined"&&d instanceof KJUR.crypto.DSA){this._setDSA(d)}else{if(typeof d.rsakey!="undefined"){this.setRSAKey(d.rsakey)}else{if(typeof d.rsapem!="undefined"){this.setRSAPEM(d.rsapem)}}}}}}};YAHOO.lang.extend(KJUR.asn1.x509.SubjectPublicKeyInfo,KJUR.asn1.ASN1Object);KJUR.asn1.x509.Time=function(c){KJUR.asn1.x509.Time.superclass.constructor.call(this);var b=null;var a=null;this.setTimeParams=function(d){this.timeParams=d};this.getEncodedHex=function(){var d=null;if(this.timeParams!=null){if(this.type=="utc"){d=new KJUR.asn1.DERUTCTime(this.timeParams)}else{d=new KJUR.asn1.DERGeneralizedTime(this.timeParams)}}else{if(this.type=="utc"){d=new KJUR.asn1.DERUTCTime()}else{d=new KJUR.asn1.DERGeneralizedTime()}}this.TLV=d.getEncodedHex();return this.TLV};this.type="utc";if(typeof c!="undefined"){if(typeof c.type!="undefined"){this.type=c.type}else{if(typeof c.str!="undefined"){if(c.str.match(/^[0-9]{12}Z$/)){this.type="utc"}if(c.str.match(/^[0-9]{14}Z$/)){this.type="gen"}}}this.timeParams=c}};YAHOO.lang.extend(KJUR.asn1.x509.Time,KJUR.asn1.ASN1Object);KJUR.asn1.x509.AlgorithmIdentifier=function(b){KJUR.asn1.x509.AlgorithmIdentifier.superclass.constructor.call(this);this.nameAlg=null;this.asn1Alg=null;this.asn1Params=null;this.paramEmpty=false;this.getEncodedHex=function(){if(this.nameAlg===null&&this.asn1Alg===null){throw"algorithm not specified"}if(this.nameAlg!==null&&this.asn1Alg===null){this.asn1Alg=KJUR.asn1.x509.OID.name2obj(this.nameAlg)}var c=[this.asn1Alg];if(this.asn1Params!==null){c.push(this.asn1Params)}var d=new KJUR.asn1.DERSequence({array:c});this.hTLV=d.getEncodedHex();return this.hTLV};if(b!==undefined){if(b.name!==undefined){this.nameAlg=b.name}if(b.asn1params!==undefined){this.asn1Params=b.asn1params}if(b.paramempty!==undefined){this.paramEmpty=b.paramempty}}if(this.asn1Params===null&&this.paramEmpty===false&&this.nameAlg!==null){var a=this.nameAlg.toLowerCase();if(a.substr(-7,7)!=="withdsa"&&a.substr(-9,9)!=="withecdsa"){this.asn1Params=new KJUR.asn1.DERNull()}}};YAHOO.lang.extend(KJUR.asn1.x509.AlgorithmIdentifier,KJUR.asn1.ASN1Object);KJUR.asn1.x509.GeneralName=function(d){KJUR.asn1.x509.GeneralName.superclass.constructor.call(this);var c=null;var b=null;var a={rfc822:"81",dns:"82",dn:"a4",uri:"86"};this.explicit=false;this.setByParam=function(k){var j=null;var g=null;if(k===undefined){return}if(k.rfc822!==undefined){this.type="rfc822";g=new KJUR.asn1.DERIA5String({str:k[this.type]})}if(k.dns!==undefined){this.type="dns";g=new KJUR.asn1.DERIA5String({str:k[this.type]})}if(k.uri!==undefined){this.type="uri";g=new KJUR.asn1.DERIA5String({str:k[this.type]})}if(k.dn!==undefined){this.type="dn";g=new KJUR.asn1.x509.X500Name({str:k.dn})}if(k.ldapdn!==undefined){this.type="dn";g=new KJUR.asn1.x509.X500Name({ldapstr:k.ldapdn})}if(k.certissuer!==undefined){this.type="dn";this.explicit=true;var h=k.certissuer;var f=null;if(h.match(/^[0-9A-Fa-f]+$/)){f==h}if(h.indexOf("-----BEGIN ")!=-1){f=ASN1HEX.pemToHex(h)}if(f==null){throw"certissuer param not cert"}var e=new X509();e.hex=f;var i=e.getIssuerHex();g=new KJUR.asn1.ASN1Object();g.hTLV=i}if(k.certsubj!==undefined){this.type="dn";this.explicit=true;var h=k.certsubj;var f=null;if(h.match(/^[0-9A-Fa-f]+$/)){f==h}if(h.indexOf("-----BEGIN ")!=-1){f=ASN1HEX.pemToHex(h)}if(f==null){throw"certsubj param not cert"}var e=new X509();e.hex=f;var i=e.getSubjectHex();g=new KJUR.asn1.ASN1Object();g.hTLV=i}if(this.type==null){throw"unsupported type in params="+k}this.asn1Obj=new KJUR.asn1.DERTaggedObject({explicit:this.explicit,tag:a[this.type],obj:g})};this.getEncodedHex=function(){return this.asn1Obj.getEncodedHex()};if(d!==undefined){this.setByParam(d)}};YAHOO.lang.extend(KJUR.asn1.x509.GeneralName,KJUR.asn1.ASN1Object);KJUR.asn1.x509.GeneralNames=function(b){KJUR.asn1.x509.GeneralNames.superclass.constructor.call(this);var a=null;this.setByParamArray=function(e){for(var c=0;c<e.length;c++){var d=new KJUR.asn1.x509.GeneralName(e[c]);this.asn1Array.push(d)}};this.getEncodedHex=function(){var c=new KJUR.asn1.DERSequence({array:this.asn1Array});return c.getEncodedHex()};this.asn1Array=new Array();if(typeof b!="undefined"){this.setByParamArray(b)}};YAHOO.lang.extend(KJUR.asn1.x509.GeneralNames,KJUR.asn1.ASN1Object);KJUR.asn1.x509.DistributionPointName=function(b){KJUR.asn1.x509.DistributionPointName.superclass.constructor.call(this);var e=null;var c=null;var a=null;var d=null;this.getEncodedHex=function(){if(this.type!="full"){throw"currently type shall be 'full': "+this.type}this.asn1Obj=new KJUR.asn1.DERTaggedObject({explicit:false,tag:this.tag,obj:this.asn1V});this.hTLV=this.asn1Obj.getEncodedHex();return this.hTLV};if(typeof b!="undefined"){if(KJUR.asn1.x509.GeneralNames.prototype.isPrototypeOf(b)){this.type="full";this.tag="a0";this.asn1V=b}else{throw"This class supports GeneralNames only as argument"}}};YAHOO.lang.extend(KJUR.asn1.x509.DistributionPointName,KJUR.asn1.ASN1Object);KJUR.asn1.x509.DistributionPoint=function(b){KJUR.asn1.x509.DistributionPoint.superclass.constructor.call(this);var a=null;this.getEncodedHex=function(){var c=new KJUR.asn1.DERSequence();if(this.asn1DP!=null){var d=new KJUR.asn1.DERTaggedObject({explicit:true,tag:"a0",obj:this.asn1DP});c.appendASN1Object(d)}this.hTLV=c.getEncodedHex();return this.hTLV};if(typeof b!="undefined"){if(typeof b.dpobj!="undefined"){this.asn1DP=b.dpobj}}};YAHOO.lang.extend(KJUR.asn1.x509.DistributionPoint,KJUR.asn1.ASN1Object);KJUR.asn1.x509.OID=new function(a){this.atype2oidList={CN:"2.5.4.3",L:"2.5.4.7",ST:"2.5.4.8",O:"2.5.4.10",OU:"2.5.4.11",C:"2.5.4.6",STREET:"2.5.4.9",DC:"0.9.2342.19200300.100.1.25",UID:"0.9.2342.19200300.100.1.1",SN:"2.5.4.4",DN:"2.5.4.49",E:"1.2.840.113549.1.9.1",businessCategory:"2.5.4.15",postalCode:"2.5.4.17",jurisdictionOfIncorporationL:"1.3.6.1.4.1.311.60.2.1.1",jurisdictionOfIncorporationSP:"1.3.6.1.4.1.311.60.2.1.2",jurisdictionOfIncorporationC:"1.3.6.1.4.1.311.60.2.1.3"};this.name2oidList={sha1:"1.3.14.3.2.26",sha256:"2.16.840.1.101.3.4.2.1",sha384:"2.16.840.1.101.3.4.2.2",sha512:"2.16.840.1.101.3.4.2.3",sha224:"2.16.840.1.101.3.4.2.4",md5:"1.2.840.113549.2.5",md2:"1.3.14.7.2.2.1",ripemd160:"1.3.36.3.2.1",MD2withRSA:"1.2.840.113549.1.1.2",MD4withRSA:"1.2.840.113549.1.1.3",MD5withRSA:"1.2.840.113549.1.1.4",SHA1withRSA:"1.2.840.113549.1.1.5",SHA224withRSA:"1.2.840.113549.1.1.14",SHA256withRSA:"1.2.840.113549.1.1.11",SHA384withRSA:"1.2.840.113549.1.1.12",SHA512withRSA:"1.2.840.113549.1.1.13",SHA1withECDSA:"1.2.840.10045.4.1",SHA224withECDSA:"1.2.840.10045.4.3.1",SHA256withECDSA:"1.2.840.10045.4.3.2",SHA384withECDSA:"1.2.840.10045.4.3.3",SHA512withECDSA:"1.2.840.10045.4.3.4",dsa:"1.2.840.10040.4.1",SHA1withDSA:"1.2.840.10040.4.3",SHA224withDSA:"2.16.840.1.101.3.4.3.1",SHA256withDSA:"2.16.840.1.101.3.4.3.2",rsaEncryption:"1.2.840.113549.1.1.1",commonName:"2.5.4.3",localityName:"2.5.4.7",stateOrProvinceName:"2.5.4.8",organizationName:"2.5.4.10",organizationalUnitName:"2.5.4.11",countryName:"2.5.4.6",streetAddress:"2.5.4.9",domainComponent:"0.9.2342.19200300.100.1.25",userId:"0.9.2342.19200300.100.1.1",surname:"2.5.4.4",distinguishedName:"2.5.4.49",emailAddress:"1.2.840.113549.1.9.1",businessCategory:"2.5.4.15",postalCode:"2.5.4.17",jurisdictionOfIncorporationL:"1.3.6.1.4.1.311.60.2.1.1",jurisdictionOfIncorporationSP:"1.3.6.1.4.1.311.60.2.1.2",jurisdictionOfIncorporationC:"1.3.6.1.4.1.311.60.2.1.3",subjectKeyIdentifier:"2.5.29.14",keyUsage:"2.5.29.15",subjectAltName:"2.5.29.17",issuerAltName:"2.5.29.18",basicConstraints:"2.5.29.19",nameConstraints:"2.5.29.30",cRLDistributionPoints:"2.5.29.31",certificatePolicies:"2.5.29.32",authorityKeyIdentifier:"2.5.29.35",policyConstraints:"2.5.29.36",extKeyUsage:"2.5.29.37",authorityInfoAccess:"1.3.6.1.5.5.7.1.1",ocsp:"1.3.6.1.5.5.7.48.1",caIssuers:"1.3.6.1.5.5.7.48.2",anyExtendedKeyUsage:"2.5.29.37.0",serverAuth:"1.3.6.1.5.5.7.3.1",clientAuth:"1.3.6.1.5.5.7.3.2",codeSigning:"1.3.6.1.5.5.7.3.3",emailProtection:"1.3.6.1.5.5.7.3.4",timeStamping:"1.3.6.1.5.5.7.3.8",ocspSigning:"1.3.6.1.5.5.7.3.9",ecPublicKey:"1.2.840.10045.2.1",secp256r1:"1.2.840.10045.3.1.7",secp256k1:"1.3.132.0.10",secp384r1:"1.3.132.0.34",pkcs5PBES2:"1.2.840.113549.1.5.13",pkcs5PBKDF2:"1.2.840.113549.1.5.12","des-EDE3-CBC":"1.2.840.113549.3.7",data:"1.2.840.113549.1.7.1","signed-data":"1.2.840.113549.1.7.2","enveloped-data":"1.2.840.113549.1.7.3","digested-data":"1.2.840.113549.1.7.5","encrypted-data":"1.2.840.113549.1.7.6","authenticated-data":"1.2.840.113549.1.9.16.1.2",tstinfo:"1.2.840.113549.1.9.16.1.4",extensionRequest:"1.2.840.113549.1.9.14",};this.objCache={};this.name2obj=function(b){if(typeof this.objCache[b]!="undefined"){return this.objCache[b]}if(typeof this.name2oidList[b]=="undefined"){throw"Name of ObjectIdentifier not defined: "+b}var c=this.name2oidList[b];var d=new KJUR.asn1.DERObjectIdentifier({oid:c});this.objCache[b]=d;return d};this.atype2obj=function(b){if(typeof this.objCache[b]!="undefined"){return this.objCache[b]}if(typeof this.atype2oidList[b]=="undefined"){throw"AttributeType name undefined: "+b}var c=this.atype2oidList[b];var d=new KJUR.asn1.DERObjectIdentifier({oid:c});this.objCache[b]=d;return d}};KJUR.asn1.x509.OID.oid2name=function(b){var c=KJUR.asn1.x509.OID.name2oidList;for(var a in c){if(c[a]==b){return a}}return""};KJUR.asn1.x509.OID.oid2atype=function(b){var c=KJUR.asn1.x509.OID.atype2oidList;for(var a in c){if(c[a]==b){return a}}return b};KJUR.asn1.x509.OID.name2oid=function(a){var b=KJUR.asn1.x509.OID.name2oidList;if(b[a]===undefined){return""}return b[a]};KJUR.asn1.x509.X509Util=new function(){this.getPKCS8PubKeyPEMfromRSAKey=function(i){var h=null;var f=KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(i.n);var j=KJUR.asn1.ASN1Util.integerToByteHex(i.e);var a=new KJUR.asn1.DERInteger({hex:f});var g=new KJUR.asn1.DERInteger({hex:j});var l=new KJUR.asn1.DERSequence({array:[a,g]});var c=l.getEncodedHex();var d=new KJUR.asn1.x509.AlgorithmIdentifier({name:"rsaEncryption"});var b=new KJUR.asn1.DERBitString({hex:"00"+c});var k=new KJUR.asn1.DERSequence({array:[d,b]});var e=k.getEncodedHex();var h=KJUR.asn1.ASN1Util.getPEMStringFromHex(e,"PUBLIC KEY");return h}};KJUR.asn1.x509.X509Util.newCertPEM=function(f){var c=KJUR.asn1.x509;var e=new c.TBSCertificate();if(f.serial!==undefined){e.setSerialNumberByParam(f.serial)}else{throw"serial number undefined."}if(typeof f.sigalg.name==="string"){e.setSignatureAlgByParam(f.sigalg)}else{throw"unproper signature algorithm name"}if(f.issuer!==undefined){e.setIssuerByParam(f.issuer)}else{throw"issuer name undefined."}if(f.notbefore!==undefined){e.setNotBeforeByParam(f.notbefore)}else{throw"notbefore undefined."}if(f.notafter!==undefined){e.setNotAfterByParam(f.notafter)}else{throw"notafter undefined."}if(f.subject!==undefined){e.setSubjectByParam(f.subject)}else{throw"subject name undefined."}if(f.sbjpubkey!==undefined){e.setSubjectPublicKeyByGetKey(f.sbjpubkey)}else{throw"subject public key undefined."}if(f.ext!==undefined&&f.ext.length!==undefined){for(var b=0;b<f.ext.length;b++){for(key in f.ext[b]){e.appendExtensionByName(key,f.ext[b][key])}}}if(f.cakey===undefined&&f.sighex===undefined){throw"param cakey and sighex undefined."}var d=null;var a=null;if(f.cakey){if(f.cakey.isPrivate===true){d=f.cakey}else{d=KEYUTIL.getKey.apply(null,f.cakey)}a=new c.Certificate({tbscertobj:e,prvkeyobj:d});a.sign()}if(f.sighex){a=new c.Certificate({tbscertobj:e});a.setSignatureHex(f.sighex)}return a.getPEMString()};
	/*! asn1cms-1.0.3.js (c) 2013-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.asn1=="undefined"||!KJUR.asn1){KJUR.asn1={}}if(typeof KJUR.asn1.cms=="undefined"||!KJUR.asn1.cms){KJUR.asn1.cms={}}KJUR.asn1.cms.Attribute=function(b){KJUR.asn1.cms.Attribute.superclass.constructor.call(this);var a=[];this.getEncodedHex=function(){var f,e,c;f=new KJUR.asn1.DERObjectIdentifier({oid:this.attrTypeOid});e=new KJUR.asn1.DERSet({array:this.valueList});try{e.getEncodedHex()}catch(d){throw"fail valueSet.getEncodedHex in Attribute(1)/"+d}c=new KJUR.asn1.DERSequence({array:[f,e]});try{this.hTLV=c.getEncodedHex()}catch(d){throw"failed seq.getEncodedHex in Attribute(2)/"+d}return this.hTLV}};YAHOO.lang.extend(KJUR.asn1.cms.Attribute,KJUR.asn1.ASN1Object);KJUR.asn1.cms.ContentType=function(b){KJUR.asn1.cms.ContentType.superclass.constructor.call(this);this.attrTypeOid="1.2.840.113549.1.9.3";var a=null;if(typeof b!="undefined"){var a=new KJUR.asn1.DERObjectIdentifier(b);this.valueList=[a]}};YAHOO.lang.extend(KJUR.asn1.cms.ContentType,KJUR.asn1.cms.Attribute);KJUR.asn1.cms.MessageDigest=function(e){KJUR.asn1.cms.MessageDigest.superclass.constructor.call(this);this.attrTypeOid="1.2.840.113549.1.9.4";if(typeof e!="undefined"){if(e.eciObj instanceof KJUR.asn1.cms.EncapsulatedContentInfo&&typeof e.hashAlg=="string"){var b=e.eciObj.eContentValueHex;var a=e.hashAlg;var c=KJUR.crypto.Util.hashHex(b,a);var d=new KJUR.asn1.DEROctetString({hex:c});d.getEncodedHex();this.valueList=[d]}else{var d=new KJUR.asn1.DEROctetString(e);d.getEncodedHex();this.valueList=[d]}}};YAHOO.lang.extend(KJUR.asn1.cms.MessageDigest,KJUR.asn1.cms.Attribute);KJUR.asn1.cms.SigningTime=function(c){KJUR.asn1.cms.SigningTime.superclass.constructor.call(this);this.attrTypeOid="1.2.840.113549.1.9.5";if(typeof c!="undefined"){var a=new KJUR.asn1.x509.Time(c);try{a.getEncodedHex()}catch(b){throw"SigningTime.getEncodedHex() failed/"+b}this.valueList=[a]}};YAHOO.lang.extend(KJUR.asn1.cms.SigningTime,KJUR.asn1.cms.Attribute);KJUR.asn1.cms.SigningCertificate=function(d){KJUR.asn1.cms.SigningCertificate.superclass.constructor.call(this);this.attrTypeOid="1.2.840.113549.1.9.16.2.12";var a=KJUR.asn1;var c=KJUR.asn1.cms;var b=KJUR.crypto;this.setCerts=function(l){var j=[];for(var h=0;h<l.length;h++){var f=ASN1HEX.pemToHex(l[h]);var e=b.Util.hashHex(f,"sha1");var m=new a.DEROctetString({hex:e});m.getEncodedHex();var k=new c.IssuerAndSerialNumber({cert:l[h]});k.getEncodedHex();var n=new a.DERSequence({array:[m,k]});n.getEncodedHex();j.push(n)}var g=new a.DERSequence({array:j});g.getEncodedHex();this.valueList=[g]};if(typeof d!="undefined"){if(typeof d.array=="object"){this.setCerts(d.array)}}};YAHOO.lang.extend(KJUR.asn1.cms.SigningCertificate,KJUR.asn1.cms.Attribute);KJUR.asn1.cms.SigningCertificateV2=function(e){KJUR.asn1.cms.SigningCertificateV2.superclass.constructor.call(this);this.attrTypeOid="1.2.840.113549.1.9.16.2.47";var b=KJUR.asn1;var f=KJUR.asn1.x509;var d=KJUR.asn1.cms;var c=KJUR.crypto;this.setCerts=function(p,h){var n=[];for(var l=0;l<p.length;l++){var j=ASN1HEX.pemToHex(p[l]);var r=[];if(h!="sha256"){r.push(new f.AlgorithmIdentifier({name:h}))}var g=c.Util.hashHex(j,h);var q=new b.DEROctetString({hex:g});q.getEncodedHex();r.push(q);var m=new d.IssuerAndSerialNumber({cert:p[l]});m.getEncodedHex();r.push(m);var o=new b.DERSequence({array:r});o.getEncodedHex();n.push(o)}var k=new b.DERSequence({array:n});k.getEncodedHex();this.valueList=[k]};if(typeof e!="undefined"){if(typeof e.array=="object"){var a="sha256";if(typeof e.hashAlg=="string"){a=e.hashAlg}this.setCerts(e.array,a)}}};YAHOO.lang.extend(KJUR.asn1.cms.SigningCertificateV2,KJUR.asn1.cms.Attribute);KJUR.asn1.cms.IssuerAndSerialNumber=function(c){KJUR.asn1.cms.IssuerAndSerialNumber.superclass.constructor.call(this);var e=null;var b=null;var a=KJUR.asn1;var d=a.x509;this.setByCertPEM=function(i){var g=ASN1HEX.pemToHex(i);var f=new X509();f.hex=g;var j=f.getIssuerHex();this.dIssuer=new d.X500Name();this.dIssuer.hTLV=j;var h=f.getSerialNumberHex();this.dSerial=new a.DERInteger({hex:h})};this.getEncodedHex=function(){var f=new KJUR.asn1.DERSequence({array:[this.dIssuer,this.dSerial]});this.hTLV=f.getEncodedHex();return this.hTLV};if(typeof c!="undefined"){if(typeof c=="string"&&c.indexOf("-----BEGIN ")!=-1){this.setByCertPEM(c)}if(c.issuer&&c.serial){if(c.issuer instanceof KJUR.asn1.x509.X500Name){this.dIssuer=c.issuer}else{this.dIssuer=new KJUR.asn1.x509.X500Name(c.issuer)}if(c.serial instanceof KJUR.asn1.DERInteger){this.dSerial=c.serial}else{this.dSerial=new KJUR.asn1.DERInteger(c.serial)}}if(typeof c.cert=="string"){this.setByCertPEM(c.cert)}}};YAHOO.lang.extend(KJUR.asn1.cms.IssuerAndSerialNumber,KJUR.asn1.ASN1Object);KJUR.asn1.cms.AttributeList=function(a){KJUR.asn1.cms.AttributeList.superclass.constructor.call(this);this.list=new Array();this.sortFlag=true;this.add=function(b){if(b instanceof KJUR.asn1.cms.Attribute){this.list.push(b)}};this.length=function(){return this.list.length};this.clear=function(){this.list=new Array();this.hTLV=null;this.hV=null};this.getEncodedHex=function(){if(typeof this.hTLV=="string"){return this.hTLV}var b=new KJUR.asn1.DERSet({array:this.list,sortflag:this.sortFlag});this.hTLV=b.getEncodedHex();return this.hTLV};if(typeof a!="undefined"){if(typeof a.sortflag!="undefined"&&a.sortflag==false){this.sortFlag=false}}};YAHOO.lang.extend(KJUR.asn1.cms.AttributeList,KJUR.asn1.ASN1Object);KJUR.asn1.cms.SignerInfo=function(c){KJUR.asn1.cms.SignerInfo.superclass.constructor.call(this);var a=KJUR.asn1;var b=KJUR.asn1.cms;var d=KJUR.asn1.x509;this.dCMSVersion=new a.DERInteger({"int":1});this.dSignerIdentifier=null;this.dDigestAlgorithm=null;this.dSignedAttrs=new b.AttributeList();this.dSigAlg=null;this.dSig=null;this.dUnsignedAttrs=new b.AttributeList();this.setSignerIdentifier=function(f){if(typeof f=="string"&&f.indexOf("CERTIFICATE")!=-1&&f.indexOf("BEGIN")!=-1&&f.indexOf("END")!=-1){var e=f;this.dSignerIdentifier=new b.IssuerAndSerialNumber({cert:f})}};this.setForContentAndHash=function(e){if(typeof e!="undefined"){if(e.eciObj instanceof KJUR.asn1.cms.EncapsulatedContentInfo){this.dSignedAttrs.add(new b.ContentType({oid:"1.2.840.113549.1.7.1"}));this.dSignedAttrs.add(new b.MessageDigest({eciObj:e.eciObj,hashAlg:e.hashAlg}))}if(typeof e.sdObj!="undefined"&&e.sdObj instanceof KJUR.asn1.cms.SignedData){if(e.sdObj.digestAlgNameList.join(":").indexOf(e.hashAlg)==-1){e.sdObj.digestAlgNameList.push(e.hashAlg)}}if(typeof e.hashAlg=="string"){this.dDigestAlgorithm=new d.AlgorithmIdentifier({name:e.hashAlg})}}};this.sign=function(j,f){this.dSigAlg=new d.AlgorithmIdentifier({name:f});var g=this.dSignedAttrs.getEncodedHex();var e=KEYUTIL.getKey(j);var i=new KJUR.crypto.Signature({alg:f});i.init(e);i.updateHex(g);var h=i.sign();this.dSig=new a.DEROctetString({hex:h})};this.addUnsigned=function(e){this.hTLV=null;this.dUnsignedAttrs.hTLV=null;this.dUnsignedAttrs.add(e)};this.getEncodedHex=function(){if(this.dSignedAttrs instanceof KJUR.asn1.cms.AttributeList&&this.dSignedAttrs.length()==0){throw"SignedAttrs length = 0 (empty)"}var e=new a.DERTaggedObject({obj:this.dSignedAttrs,tag:"a0",explicit:false});var h=null;if(this.dUnsignedAttrs.length()>0){h=new a.DERTaggedObject({obj:this.dUnsignedAttrs,tag:"a1",explicit:false})}var g=[this.dCMSVersion,this.dSignerIdentifier,this.dDigestAlgorithm,e,this.dSigAlg,this.dSig,];if(h!=null){g.push(h)}var f=new a.DERSequence({array:g});this.hTLV=f.getEncodedHex();return this.hTLV}};YAHOO.lang.extend(KJUR.asn1.cms.SignerInfo,KJUR.asn1.ASN1Object);KJUR.asn1.cms.EncapsulatedContentInfo=function(c){KJUR.asn1.cms.EncapsulatedContentInfo.superclass.constructor.call(this);var a=KJUR.asn1;var b=KJUR.asn1.cms;var d=KJUR.asn1.x509;this.dEContentType=new a.DERObjectIdentifier({name:"data"});this.dEContent=null;this.isDetached=false;this.eContentValueHex=null;this.setContentType=function(e){if(e.match(/^[0-2][.][0-9.]+$/)){this.dEContentType=new a.DERObjectIdentifier({oid:e})}else{this.dEContentType=new a.DERObjectIdentifier({name:e})}};this.setContentValue=function(e){if(typeof e!="undefined"){if(typeof e.hex=="string"){this.eContentValueHex=e.hex}else{if(typeof e.str=="string"){this.eContentValueHex=utf8tohex(e.str)}}}};this.setContentValueHex=function(e){this.eContentValueHex=e};this.setContentValueStr=function(e){this.eContentValueHex=utf8tohex(e)};this.getEncodedHex=function(){if(typeof this.eContentValueHex!="string"){throw"eContentValue not yet set"}var g=new a.DEROctetString({hex:this.eContentValueHex});this.dEContent=new a.DERTaggedObject({obj:g,tag:"a0",explicit:true});var e=[this.dEContentType];if(!this.isDetached){e.push(this.dEContent)}var f=new a.DERSequence({array:e});this.hTLV=f.getEncodedHex();return this.hTLV}};YAHOO.lang.extend(KJUR.asn1.cms.EncapsulatedContentInfo,KJUR.asn1.ASN1Object);KJUR.asn1.cms.ContentInfo=function(c){KJUR.asn1.cms.ContentInfo.superclass.constructor.call(this);var a=KJUR.asn1;var b=KJUR.asn1.cms;var d=KJUR.asn1.x509;this.dContentType=null;this.dContent=null;this.setContentType=function(e){if(typeof e=="string"){this.dContentType=d.OID.name2obj(e)}};this.getEncodedHex=function(){var f=new a.DERTaggedObject({obj:this.dContent,tag:"a0",explicit:true});var e=new a.DERSequence({array:[this.dContentType,f]});this.hTLV=e.getEncodedHex();return this.hTLV};if(typeof c!="undefined"){if(c.type){this.setContentType(c.type)}if(c.obj&&c.obj instanceof a.ASN1Object){this.dContent=c.obj}}};YAHOO.lang.extend(KJUR.asn1.cms.ContentInfo,KJUR.asn1.ASN1Object);KJUR.asn1.cms.SignedData=function(c){KJUR.asn1.cms.SignedData.superclass.constructor.call(this);var a=KJUR.asn1;var b=KJUR.asn1.cms;var d=KJUR.asn1.x509;this.dCMSVersion=new a.DERInteger({"int":1});this.dDigestAlgs=null;this.digestAlgNameList=[];this.dEncapContentInfo=new b.EncapsulatedContentInfo();this.dCerts=null;this.certificateList=[];this.crlList=[];this.signerInfoList=[new b.SignerInfo()];this.addCertificatesByPEM=function(e){var f=ASN1HEX.pemToHex(e);var g=new a.ASN1Object();g.hTLV=f;this.certificateList.push(g)};this.getEncodedHex=function(){if(typeof this.hTLV=="string"){return this.hTLV}if(this.dDigestAlgs==null){var k=[];for(var j=0;j<this.digestAlgNameList.length;j++){var h=this.digestAlgNameList[j];var m=new d.AlgorithmIdentifier({name:h});k.push(m)}this.dDigestAlgs=new a.DERSet({array:k})}var e=[this.dCMSVersion,this.dDigestAlgs,this.dEncapContentInfo];if(this.dCerts==null){if(this.certificateList.length>0){var l=new a.DERSet({array:this.certificateList});this.dCerts=new a.DERTaggedObject({obj:l,tag:"a0",explicit:false})}}if(this.dCerts!=null){e.push(this.dCerts)}var g=new a.DERSet({array:this.signerInfoList});e.push(g);var f=new a.DERSequence({array:e});this.hTLV=f.getEncodedHex();return this.hTLV};this.getContentInfo=function(){this.getEncodedHex();var e=new b.ContentInfo({type:"signed-data",obj:this});return e};this.getContentInfoEncodedHex=function(){var e=this.getContentInfo();var f=e.getEncodedHex();return f};this.getPEM=function(){var e=this.getContentInfoEncodedHex();var f=a.ASN1Util.getPEMStringFromHex(e,"CMS");return f}};YAHOO.lang.extend(KJUR.asn1.cms.SignedData,KJUR.asn1.ASN1Object);KJUR.asn1.cms.CMSUtil=new function(){};KJUR.asn1.cms.CMSUtil.newSignedData=function(a){var h=KJUR.asn1.cms;var g=KJUR.asn1.cades;var f=new h.SignedData();f.dEncapContentInfo.setContentValue(a.content);if(typeof a.certs=="object"){for(var b=0;b<a.certs.length;b++){f.addCertificatesByPEM(a.certs[b])}}f.signerInfoList=[];for(var b=0;b<a.signerInfos.length;b++){var d=a.signerInfos[b];var c=new h.SignerInfo();c.setSignerIdentifier(d.signerCert);c.setForContentAndHash({sdObj:f,eciObj:f.dEncapContentInfo,hashAlg:d.hashAlg});for(attrName in d.sAttr){var j=d.sAttr[attrName];if(attrName=="SigningTime"){var e=new h.SigningTime(j);c.dSignedAttrs.add(e)}if(attrName=="SigningCertificate"){var e=new h.SigningCertificate(j);c.dSignedAttrs.add(e)}if(attrName=="SigningCertificateV2"){var e=new h.SigningCertificateV2(j);c.dSignedAttrs.add(e)}if(attrName=="SignaturePolicyIdentifier"){var e=new g.SignaturePolicyIdentifier(j);c.dSignedAttrs.add(e)}}c.sign(d.signerPrvKey,d.sigAlg);f.signerInfoList.push(c)}return f};
	/*! asn1tsp-1.0.1.js (c) 2014 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.asn1=="undefined"||!KJUR.asn1){KJUR.asn1={}}if(typeof KJUR.asn1.tsp=="undefined"||!KJUR.asn1.tsp){KJUR.asn1.tsp={}}KJUR.asn1.tsp.Accuracy=function(b){KJUR.asn1.tsp.Accuracy.superclass.constructor.call(this);var a=KJUR.asn1;this.seconds=null;this.millis=null;this.micros=null;this.getEncodedHex=function(){var e=null;var g=null;var i=null;var c=[];if(this.seconds!=null){e=new a.DERInteger({"int":this.seconds});c.push(e)}if(this.millis!=null){var h=new a.DERInteger({"int":this.millis});g=new a.DERTaggedObject({obj:h,tag:"80",explicit:false});c.push(g)}if(this.micros!=null){var f=new a.DERInteger({"int":this.micros});i=new a.DERTaggedObject({obj:f,tag:"81",explicit:false});c.push(i)}var d=new a.DERSequence({array:c});this.hTLV=d.getEncodedHex();return this.hTLV};if(typeof b!="undefined"){if(typeof b.seconds=="number"){this.seconds=b.seconds}if(typeof b.millis=="number"){this.millis=b.millis}if(typeof b.micros=="number"){this.micros=b.micros}}};YAHOO.lang.extend(KJUR.asn1.tsp.Accuracy,KJUR.asn1.ASN1Object);KJUR.asn1.tsp.MessageImprint=function(b){KJUR.asn1.tsp.MessageImprint.superclass.constructor.call(this);var a=KJUR.asn1;var c=KJUR.asn1.x509;this.dHashAlg=null;this.dHashValue=null;this.getEncodedHex=function(){if(typeof this.hTLV=="string"){return this.hTLV}var d=new a.DERSequence({array:[this.dHashAlg,this.dHashValue]});return d.getEncodedHex()};if(typeof b!="undefined"){if(typeof b.hashAlg=="string"){this.dHashAlg=new c.AlgorithmIdentifier({name:b.hashAlg})}if(typeof b.hashValue=="string"){this.dHashValue=new a.DEROctetString({hex:b.hashValue})}}};YAHOO.lang.extend(KJUR.asn1.tsp.MessageImprint,KJUR.asn1.ASN1Object);KJUR.asn1.tsp.TimeStampReq=function(c){KJUR.asn1.tsp.TimeStampReq.superclass.constructor.call(this);var a=KJUR.asn1;var b=KJUR.asn1.tsp;this.dVersion=new a.DERInteger({"int":1});this.dMessageImprint=null;this.dPolicy=null;this.dNonce=null;this.certReq=true;this.setMessageImprint=function(d){if(d instanceof KJUR.asn1.tsp.MessageImprint){this.dMessageImprint=d;return}if(typeof d=="object"){this.dMessageImprint=new b.MessageImprint(d)}};this.getEncodedHex=function(){if(this.dMessageImprint==null){throw"messageImprint shall be specified"}var d=[this.dVersion,this.dMessageImprint];if(this.dPolicy!=null){d.push(this.dPolicy)}if(this.dNonce!=null){d.push(this.dNonce)}if(this.certReq){d.push(new a.DERBoolean())}var e=new a.DERSequence({array:d});this.hTLV=e.getEncodedHex();return this.hTLV};if(typeof c!="undefined"){if(typeof c.mi=="object"){this.setMessageImprint(c.mi)}if(typeof c.policy=="object"){this.dPolicy=new a.DERObjectIdentifier(c.policy)}if(typeof c.nonce=="object"){this.dNonce=new a.DERInteger(c.nonce)}if(typeof c.certreq=="boolean"){this.certReq=c.certreq}}};YAHOO.lang.extend(KJUR.asn1.tsp.TimeStampReq,KJUR.asn1.ASN1Object);KJUR.asn1.tsp.TSTInfo=function(c){KJUR.asn1.tsp.TSTInfo.superclass.constructor.call(this);var a=KJUR.asn1;var d=KJUR.asn1.x509;var b=KJUR.asn1.tsp;this.dVersion=new a.DERInteger({"int":1});this.dPolicy=null;this.dMessageImprint=null;this.dSerialNumber=null;this.dGenTime=null;this.dAccuracy=null;this.dOrdering=null;this.dNonce=null;this.dTsa=null;this.getEncodedHex=function(){var e=[this.dVersion];if(this.dPolicy==null){throw"policy shall be specified."}e.push(this.dPolicy);if(this.dMessageImprint==null){throw"messageImprint shall be specified."}e.push(this.dMessageImprint);if(this.dSerialNumber==null){throw"serialNumber shall be specified."}e.push(this.dSerialNumber);if(this.dGenTime==null){throw"genTime shall be specified."}e.push(this.dGenTime);if(this.dAccuracy!=null){e.push(this.dAccuracy)}if(this.dOrdering!=null){e.push(this.dOrdering)}if(this.dNonce!=null){e.push(this.dNonce)}if(this.dTsa!=null){e.push(this.dTsa)}var f=new a.DERSequence({array:e});this.hTLV=f.getEncodedHex();return this.hTLV};if(typeof c!="undefined"){if(typeof c.policy=="string"){if(!c.policy.match(/^[0-9.]+$/)){throw"policy shall be oid like 0.1.4.134"}this.dPolicy=new a.DERObjectIdentifier({oid:c.policy})}if(typeof c.messageImprint!="undefined"){this.dMessageImprint=new b.MessageImprint(c.messageImprint)}if(typeof c.serialNumber!="undefined"){this.dSerialNumber=new a.DERInteger(c.serialNumber)}if(typeof c.genTime!="undefined"){this.dGenTime=new a.DERGeneralizedTime(c.genTime)}if(typeof c.accuracy!="undefind"){this.dAccuracy=new b.Accuracy(c.accuracy)}if(typeof c.ordering!="undefined"&&c.ordering==true){this.dOrdering=new a.DERBoolean()}if(typeof c.nonce!="undefined"){this.dNonce=new a.DERInteger(c.nonce)}if(typeof c.tsa!="undefined"){this.dTsa=new d.X500Name(c.tsa)}}};YAHOO.lang.extend(KJUR.asn1.tsp.TSTInfo,KJUR.asn1.ASN1Object);KJUR.asn1.tsp.TimeStampResp=function(c){KJUR.asn1.tsp.TimeStampResp.superclass.constructor.call(this);var a=KJUR.asn1;var b=KJUR.asn1.tsp;this.dStatus=null;this.dTST=null;this.getEncodedHex=function(){if(this.dStatus==null){throw"status shall be specified"}var d=[this.dStatus];if(this.dTST!=null){d.push(this.dTST)}var e=new a.DERSequence({array:d});this.hTLV=e.getEncodedHex();return this.hTLV};if(typeof c!="undefined"){if(typeof c.status=="object"){this.dStatus=new b.PKIStatusInfo(c.status)}if(typeof c.tst!="undefined"&&c.tst instanceof KJUR.asn1.ASN1Object){this.dTST=c.tst.getContentInfo()}}};YAHOO.lang.extend(KJUR.asn1.tsp.TimeStampResp,KJUR.asn1.ASN1Object);KJUR.asn1.tsp.PKIStatusInfo=function(c){KJUR.asn1.tsp.PKIStatusInfo.superclass.constructor.call(this);var a=KJUR.asn1;var b=KJUR.asn1.tsp;this.dStatus=null;this.dStatusString=null;this.dFailureInfo=null;this.getEncodedHex=function(){if(this.dStatus==null){throw"status shall be specified"}var d=[this.dStatus];if(this.dStatusString!=null){d.push(this.dStatusString)}if(this.dFailureInfo!=null){d.push(this.dFailureInfo)}var e=new a.DERSequence({array:d});this.hTLV=e.getEncodedHex();return this.hTLV};if(typeof c!="undefined"){if(typeof c.status=="object"){this.dStatus=new b.PKIStatus(c.status)}if(typeof c.statstr=="object"){this.dStatusString=new b.PKIFreeText({array:c.statstr})}if(typeof c.failinfo=="object"){this.dFailureInfo=new b.PKIFailureInfo(c.failinfo)}}};YAHOO.lang.extend(KJUR.asn1.tsp.PKIStatusInfo,KJUR.asn1.ASN1Object);KJUR.asn1.tsp.PKIStatus=function(e){KJUR.asn1.tsp.PKIStatus.superclass.constructor.call(this);var a=KJUR.asn1;var b=KJUR.asn1.tsp;var d=null;this.getEncodedHex=function(){this.hTLV=this.dStatus.getEncodedHex();return this.hTLV};if(typeof e!="undefined"){if(typeof e.name!="undefined"){var c=b.PKIStatus.valueList;if(typeof c[e.name]=="undefined"){throw"name undefined: "+e.name}this.dStatus=new a.DERInteger({"int":c[e.name]})}else{this.dStatus=new a.DERInteger(e)}}};YAHOO.lang.extend(KJUR.asn1.tsp.PKIStatus,KJUR.asn1.ASN1Object);KJUR.asn1.tsp.PKIStatus.valueList={granted:0,grantedWithMods:1,rejection:2,waiting:3,revocationWarning:4,revocationNotification:5};KJUR.asn1.tsp.PKIFreeText=function(b){KJUR.asn1.tsp.PKIFreeText.superclass.constructor.call(this);var a=KJUR.asn1;this.textList=[];this.getEncodedHex=function(){var c=[];for(var e=0;e<this.textList.length;e++){c.push(new a.DERUTF8String({str:this.textList[e]}))}var d=new a.DERSequence({array:c});this.hTLV=d.getEncodedHex();return this.hTLV};if(typeof b!="undefined"){if(typeof b.array=="object"){this.textList=b.array}}};YAHOO.lang.extend(KJUR.asn1.tsp.PKIFreeText,KJUR.asn1.ASN1Object);KJUR.asn1.tsp.PKIFailureInfo=function(d){KJUR.asn1.tsp.PKIFailureInfo.superclass.constructor.call(this);var a=KJUR.asn1;var b=KJUR.asn1.tsp;this.value=null;this.getEncodedHex=function(){if(this.value==null){throw"value shall be specified"}var e=new Number(this.value).toString(2);var f=new a.DERBitString();f.setByBinaryString(e);this.hTLV=f.getEncodedHex();return this.hTLV};if(typeof d!="undefined"){if(typeof d.name=="string"){var c=b.PKIFailureInfo.valueList;if(typeof c[d.name]=="undefined"){throw"name undefined: "+d.name}this.value=c[d.name]}else{if(typeof d["int"]=="number"){this.value=d["int"]}}}};YAHOO.lang.extend(KJUR.asn1.tsp.PKIFailureInfo,KJUR.asn1.ASN1Object);KJUR.asn1.tsp.PKIFailureInfo.valueList={badAlg:0,badRequest:2,badDataFormat:5,timeNotAvailable:14,unacceptedPolicy:15,unacceptedExtension:16,addInfoNotAvailable:17,systemFailure:25};KJUR.asn1.tsp.AbstractTSAAdapter=function(a){this.getTSTHex=function(c,b){throw"not implemented yet"}};KJUR.asn1.tsp.SimpleTSAAdapter=function(a){KJUR.asn1.tsp.SimpleTSAAdapter.superclass.constructor.call(this);this.params=null;this.serial=0;this.getTSTHex=function(c,b){var e=KJUR.crypto.Util.hashHex(c,b);this.params.tstInfo.messageImprint={hashAlg:b,hashValue:e};this.params.tstInfo.serialNumber={"int":this.serial++};var d=Math.floor(Math.random()*1000000000);this.params.tstInfo.nonce={"int":d};var f=KJUR.asn1.tsp.TSPUtil.newTimeStampToken(this.params);return f.getContentInfoEncodedHex()};if(typeof a!="undefined"){this.params=a}};YAHOO.lang.extend(KJUR.asn1.tsp.SimpleTSAAdapter,KJUR.asn1.tsp.AbstractTSAAdapter);KJUR.asn1.tsp.FixedTSAAdapter=function(a){KJUR.asn1.tsp.FixedTSAAdapter.superclass.constructor.call(this);this.params=null;this.getTSTHex=function(c,b){var d=KJUR.crypto.Util.hashHex(c,b);this.params.tstInfo.messageImprint={hashAlg:b,hashValue:d};var e=KJUR.asn1.tsp.TSPUtil.newTimeStampToken(this.params);return e.getContentInfoEncodedHex()};if(typeof a!="undefined"){this.params=a}};YAHOO.lang.extend(KJUR.asn1.tsp.FixedTSAAdapter,KJUR.asn1.tsp.AbstractTSAAdapter);KJUR.asn1.tsp.TSPUtil=new function(){};KJUR.asn1.tsp.TSPUtil.newTimeStampToken=function(b){var j=KJUR.asn1.cms;var a=KJUR.asn1.tsp;var g=new j.SignedData();var e=new a.TSTInfo(b.tstInfo);var f=e.getEncodedHex();g.dEncapContentInfo.setContentValue({hex:f});g.dEncapContentInfo.setContentType("tstinfo");if(typeof b.certs=="object"){for(var c=0;c<b.certs.length;c++){g.addCertificatesByPEM(b.certs[c])}}var d=g.signerInfoList[0];d.setSignerIdentifier(b.signerCert);d.setForContentAndHash({sdObj:g,eciObj:g.dEncapContentInfo,hashAlg:b.hashAlg});var h=new j.SigningCertificate({array:[b.signerCert]});d.dSignedAttrs.add(h);d.sign(b.signerPrvKey,b.sigAlg);return g};KJUR.asn1.tsp.TSPUtil.parseTimeStampReq=function(d){var f={};f.certreq=false;var h=ASN1HEX.getPosArrayOfChildren_AtObj(d,0);if(h.length<2){throw"TimeStampReq must have at least 2 items"}var c=ASN1HEX.getHexOfTLV_AtObj(d,h[1]);f.mi=KJUR.asn1.tsp.TSPUtil.parseMessageImprint(c);for(var e=2;e<h.length;e++){var b=h[e];var a=d.substr(b,2);if(a=="06"){var g=ASN1HEX.getHexOfV_AtObj(d,b);f.policy=ASN1HEX.hextooidstr(g)}if(a=="02"){f.nonce=ASN1HEX.getHexOfV_AtObj(d,b)}if(a=="01"){f.certreq=true}}return f};KJUR.asn1.tsp.TSPUtil.parseMessageImprint=function(c){var h={};if(c.substr(0,2)!="30"){throw"head of messageImprint hex shall be '30'"}var a=ASN1HEX.getPosArrayOfChildren_AtObj(c,0);var i=ASN1HEX.getDecendantIndexByNthList(c,0,[0,0]);var d=ASN1HEX.getHexOfV_AtObj(c,i);var e=ASN1HEX.hextooidstr(d);var g=KJUR.asn1.x509.OID.oid2name(e);if(g==""){throw"hashAlg name undefined: "+e}var b=g;var f=ASN1HEX.getDecendantIndexByNthList(c,0,[1]);h.hashAlg=b;h.hashValue=ASN1HEX.getHexOfV_AtObj(c,f);return h};
	/*! asn1cades-1.0.1.js (c) 2014-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.asn1=="undefined"||!KJUR.asn1){KJUR.asn1={}}if(typeof KJUR.asn1.cades=="undefined"||!KJUR.asn1.cades){KJUR.asn1.cades={}}KJUR.asn1.cades.SignaturePolicyIdentifier=function(e){KJUR.asn1.cades.SignaturePolicyIdentifier.superclass.constructor.call(this);this.attrTypeOid="1.2.840.113549.1.9.16.2.15";var b=KJUR.asn1;var d=KJUR.asn1.cades;if(typeof e!="undefined"){if(typeof e.oid=="string"&&typeof e.hash=="object"){var f=new b.DERObjectIdentifier({oid:e.oid});var a=new d.OtherHashAlgAndValue(e.hash);var c=new b.DERSequence({array:[f,a]});this.valueList=[c]}}};YAHOO.lang.extend(KJUR.asn1.cades.SignaturePolicyIdentifier,KJUR.asn1.cms.Attribute);KJUR.asn1.cades.OtherHashAlgAndValue=function(b){KJUR.asn1.cades.OtherHashAlgAndValue.superclass.constructor.call(this);var a=KJUR.asn1;var c=KJUR.asn1.x509;this.dAlg=null;this.dHash=null;this.getEncodedHex=function(){var d=new a.DERSequence({array:[this.dAlg,this.dHash]});this.hTLV=d.getEncodedHex();return this.hTLV};if(typeof b!="undefined"){if(typeof b.alg=="string"&&typeof b.hash=="string"){this.dAlg=new c.AlgorithmIdentifier({name:b.alg});this.dHash=new a.DEROctetString({hex:b.hash})}}};YAHOO.lang.extend(KJUR.asn1.cades.OtherHashAlgAndValue,KJUR.asn1.ASN1Object);KJUR.asn1.cades.SignatureTimeStamp=function(c){KJUR.asn1.cades.SignatureTimeStamp.superclass.constructor.call(this);this.attrTypeOid="1.2.840.113549.1.9.16.2.14";this.tstHex=null;var a=KJUR.asn1;if(typeof c!="undefined"){if(typeof c.res!="undefined"){if(typeof c.res=="string"&&c.res.match(/^[0-9A-Fa-f]+$/)){}else{if(c.res instanceof KJUR.asn1.ASN1Object){}else{throw"res param shall be ASN1Object or hex string"}}}if(typeof c.tst!="undefined"){if(typeof c.tst=="string"&&c.tst.match(/^[0-9A-Fa-f]+$/)){var b=new a.ASN1Object();this.tstHex=c.tst;b.hTLV=this.tstHex;b.getEncodedHex();this.valueList=[b]}else{if(c.tst instanceof KJUR.asn1.ASN1Object){}else{throw"tst param shall be ASN1Object or hex string"}}}}};YAHOO.lang.extend(KJUR.asn1.cades.SignatureTimeStamp,KJUR.asn1.cms.Attribute);KJUR.asn1.cades.CompleteCertificateRefs=function(c){KJUR.asn1.cades.CompleteCertificateRefs.superclass.constructor.call(this);this.attrTypeOid="1.2.840.113549.1.9.16.2.21";var a=KJUR.asn1;var b=KJUR.asn1.cades;this.setByArray=function(d){this.valueList=[];for(var e=0;e<d.length;e++){var f=new b.OtherCertID(d[e]);this.valueList.push(f)}};if(typeof c!="undefined"){if(typeof c=="object"&&typeof c.length=="number"){this.setByArray(c)}}};YAHOO.lang.extend(KJUR.asn1.cades.CompleteCertificateRefs,KJUR.asn1.cms.Attribute);KJUR.asn1.cades.OtherCertID=function(d){KJUR.asn1.cades.OtherCertID.superclass.constructor.call(this);var a=KJUR.asn1;var c=KJUR.asn1.cms;var b=KJUR.asn1.cades;this.hasIssuerSerial=true;this.dOtherCertHash=null;this.dIssuerSerial=null;this.setByCertPEM=function(e){this.dOtherCertHash=new b.OtherHash(e);if(this.hasIssuerSerial){this.dIssuerSerial=new c.IssuerAndSerialNumber(e)}};this.getEncodedHex=function(){if(this.hTLV!=null){return this.hTLV}if(this.dOtherCertHash==null){throw"otherCertHash not set"}var e=[this.dOtherCertHash];if(this.dIssuerSerial!=null){e.push(this.dIssuerSerial)}var f=new a.DERSequence({array:e});this.hTLV=f.getEncodedHex();return this.hTLV};if(typeof d!="undefined"){if(typeof d=="string"&&d.indexOf("-----BEGIN ")!=-1){this.setByCertPEM(d)}if(typeof d=="object"){if(d.hasis===false){this.hasIssuerSerial=false}if(typeof d.cert=="string"){this.setByCertPEM(d.cert)}}}};YAHOO.lang.extend(KJUR.asn1.cades.OtherCertID,KJUR.asn1.ASN1Object);KJUR.asn1.cades.OtherHash=function(c){KJUR.asn1.cades.OtherHash.superclass.constructor.call(this);var a=KJUR.asn1;var b=KJUR.asn1.cades;this.alg="sha256";this.dOtherHash=null;this.setByCertPEM=function(d){if(d.indexOf("-----BEGIN ")==-1){throw"certPEM not to seem PEM format"}var e=ASN1HEX.pemToHex(d);var f=KJUR.crypto.Util.hashHex(e,this.alg);this.dOtherHash=new b.OtherHashAlgAndValue({alg:this.alg,hash:f})};this.getEncodedHex=function(){if(this.dOtherHash==null){throw"OtherHash not set"}return this.dOtherHash.getEncodedHex()};if(typeof c!="undefined"){if(typeof c=="string"){if(c.indexOf("-----BEGIN ")!=-1){this.setByCertPEM(c)}else{if(c.match(/^[0-9A-Fa-f]+$/)){this.dOtherHash=new a.DEROctetString({hex:c})}else{throw"unsupported string value for params"}}}else{if(typeof c=="object"){if(typeof c.cert=="string"){if(typeof c.alg=="string"){this.alg=c.alg}this.setByCertPEM(c.cert)}else{this.dOtherHash=new b.OtherHashAlgAndValue(c)}}}}};YAHOO.lang.extend(KJUR.asn1.cades.OtherHash,KJUR.asn1.ASN1Object);KJUR.asn1.cades.CAdESUtil=new function(){};KJUR.asn1.cades.CAdESUtil.addSigTS=function(c,b,a){};KJUR.asn1.cades.CAdESUtil.parseSignedDataForAddingUnsigned=function(d){var q=KJUR.asn1;var p=KJUR.asn1.cms;var c=KJUR.asn1.cades.CAdESUtil;var a={};if(ASN1HEX.getDecendantHexTLVByNthList(d,0,[0])!="06092a864886f70d010702"){throw"hex is not CMS SignedData"}var s=ASN1HEX.getDecendantIndexByNthList(d,0,[1,0]);var b=ASN1HEX.getPosArrayOfChildren_AtObj(d,s);if(b.length<4){throw"num of SignedData elem shall be 4 at least"}var f=b.shift();a.version=ASN1HEX.getHexOfTLV_AtObj(d,f);var l=b.shift();a.algs=ASN1HEX.getHexOfTLV_AtObj(d,l);var m=b.shift();a.encapcontent=ASN1HEX.getHexOfTLV_AtObj(d,m);a.certs=null;a.revs=null;a.si=[];var n=b.shift();if(d.substr(n,2)=="a0"){a.certs=ASN1HEX.getHexOfTLV_AtObj(d,n);n=b.shift()}if(d.substr(n,2)=="a1"){a.revs=ASN1HEX.getHexOfTLV_AtObj(d,n);n=b.shift()}var k=n;if(d.substr(k,2)!="31"){throw"Can't find signerInfos"}var j=ASN1HEX.getPosArrayOfChildren_AtObj(d,k);for(var h=0;h<j.length;h++){var o=j[h];var e=c.parseSignerInfoForAddingUnsigned(d,o,h);a.si[h]=e}var g=null;a.obj=new p.SignedData();g=new q.ASN1Object();g.hTLV=a.version;a.obj.dCMSVersion=g;g=new q.ASN1Object();g.hTLV=a.algs;a.obj.dDigestAlgs=g;g=new q.ASN1Object();g.hTLV=a.encapcontent;a.obj.dEncapContentInfo=g;g=new q.ASN1Object();g.hTLV=a.certs;a.obj.dCerts=g;a.obj.signerInfoList=[];for(var h=0;h<a.si.length;h++){a.obj.signerInfoList.push(a.si[h].obj)}return a};KJUR.asn1.cades.CAdESUtil.parseSignerInfoForAddingUnsigned=function(d,k,a){var m=KJUR.asn1;var l=KJUR.asn1.cms;var b={};var e=ASN1HEX.getPosArrayOfChildren_AtObj(d,k);if(e.length!=6){throw"not supported items for SignerInfo (!=6)"}var f=e.shift();b.version=ASN1HEX.getHexOfTLV_AtObj(d,f);var n=e.shift();b.si=ASN1HEX.getHexOfTLV_AtObj(d,n);var h=e.shift();b.digalg=ASN1HEX.getHexOfTLV_AtObj(d,h);var c=e.shift();b.sattrs=ASN1HEX.getHexOfTLV_AtObj(d,c);var i=e.shift();b.sigalg=ASN1HEX.getHexOfTLV_AtObj(d,i);var j=e.shift();b.sig=ASN1HEX.getHexOfTLV_AtObj(d,j);b.sigval=ASN1HEX.getHexOfV_AtObj(d,j);var g=null;b.obj=new l.SignerInfo();g=new m.ASN1Object();g.hTLV=b.version;b.obj.dCMSVersion=g;g=new m.ASN1Object();g.hTLV=b.si;b.obj.dSignerIdentifier=g;g=new m.ASN1Object();g.hTLV=b.digalg;b.obj.dDigestAlgorithm=g;g=new m.ASN1Object();g.hTLV=b.sattrs;b.obj.dSignedAttrs=g;g=new m.ASN1Object();g.hTLV=b.sigalg;b.obj.dSigAlg=g;g=new m.ASN1Object();g.hTLV=b.sig;b.obj.dSig=g;b.obj.dUnsignedAttrs=new l.AttributeList();return b};
	/*! asn1csr-1.0.3.js (c) 2015-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR.asn1.csr=="undefined"||!KJUR.asn1.csr){KJUR.asn1.csr={}}KJUR.asn1.csr.CertificationRequest=function(f){KJUR.asn1.csr.CertificationRequest.superclass.constructor.call(this);var b=null;var d=null;var e=null;var c=null;var a=null;this.sign=function(i,h){if(this.prvKey==null){this.prvKey=h}this.asn1SignatureAlg=new KJUR.asn1.x509.AlgorithmIdentifier({name:i});sig=new KJUR.crypto.Signature({alg:i});sig.initSign(this.prvKey);sig.updateHex(this.asn1CSRInfo.getEncodedHex());this.hexSig=sig.sign();this.asn1Sig=new KJUR.asn1.DERBitString({hex:"00"+this.hexSig});var g=new KJUR.asn1.DERSequence({array:[this.asn1CSRInfo,this.asn1SignatureAlg,this.asn1Sig]});this.hTLV=g.getEncodedHex();this.isModified=false};this.getPEMString=function(){var g=KJUR.asn1.ASN1Util.getPEMStringFromHex(this.getEncodedHex(),"CERTIFICATE REQUEST");return g};this.getEncodedHex=function(){if(this.isModified==false&&this.hTLV!=null){return this.hTLV}throw"not signed yet"};if(typeof f!="undefined"){if(typeof f.csrinfo!="undefined"){this.asn1CSRInfo=f.csrinfo}}};YAHOO.lang.extend(KJUR.asn1.csr.CertificationRequest,KJUR.asn1.ASN1Object);KJUR.asn1.csr.CertificationRequestInfo=function(a){KJUR.asn1.csr.CertificationRequestInfo.superclass.constructor.call(this);this._initialize=function(){this.asn1Array=new Array();this.asn1Version=new KJUR.asn1.DERInteger({"int":0});this.asn1Subject=null;this.asn1SubjPKey=null;this.extensionsArray=new Array()};this.setSubjectByParam=function(b){this.asn1Subject=new KJUR.asn1.x509.X500Name(b)};this.setSubjectPublicKeyByGetKey=function(c){var b=KEYUTIL.getKey(c);this.asn1SubjPKey=new KJUR.asn1.x509.SubjectPublicKeyInfo(b)};this.appendExtensionByName=function(c,b){KJUR.asn1.x509.Extension.appendByNameToArray(c,b,this.extensionsArray)};this.getEncodedHex=function(){this.asn1Array=new Array();this.asn1Array.push(this.asn1Version);this.asn1Array.push(this.asn1Subject);this.asn1Array.push(this.asn1SubjPKey);if(this.extensionsArray.length>0){var e=new KJUR.asn1.DERSequence({array:this.extensionsArray});var d=new KJUR.asn1.DERSet({array:[e]});var c=new KJUR.asn1.DERSequence({array:[new KJUR.asn1.DERObjectIdentifier({oid:"1.2.840.113549.1.9.14"}),d]});var b=new KJUR.asn1.DERTaggedObject({explicit:true,tag:"a0",obj:c});this.asn1Array.push(b)}else{var b=new KJUR.asn1.DERTaggedObject({explicit:false,tag:"a0",obj:new KJUR.asn1.DERNull()});this.asn1Array.push(b)}var f=new KJUR.asn1.DERSequence({array:this.asn1Array});this.hTLV=f.getEncodedHex();this.isModified=false;return this.hTLV};this._initialize()};YAHOO.lang.extend(KJUR.asn1.csr.CertificationRequestInfo,KJUR.asn1.ASN1Object);KJUR.asn1.csr.CSRUtil=new function(){};KJUR.asn1.csr.CSRUtil.newCSRPEM=function(g){var d=KJUR.asn1.csr;if(g.subject===undefined){throw"parameter subject undefined"}if(g.sbjpubkey===undefined){throw"parameter sbjpubkey undefined"}if(g.sigalg===undefined){throw"parameter sigalg undefined"}if(g.sbjprvkey===undefined){throw"parameter sbjpubkey undefined"}var b=new d.CertificationRequestInfo();b.setSubjectByParam(g.subject);b.setSubjectPublicKeyByGetKey(g.sbjpubkey);if(g.ext!==undefined&&g.ext.length!==undefined){for(var c=0;c<g.ext.length;c++){for(key in g.ext[c]){b.appendExtensionByName(key,g.ext[c][key])}}}var e=new d.CertificationRequest({csrinfo:b});var a=KEYUTIL.getKey(g.sbjprvkey);e.sign(g.sigalg,a);var f=e.getPEMString();return f};KJUR.asn1.csr.CSRUtil.getInfo=function(b){var a={};a.subject={};a.pubkey={};if(b.indexOf("-----BEGIN CERTIFICATE REQUEST")==-1){throw"argument is not PEM file"}var c=ASN1HEX.pemToHex(b,"CERTIFICATE REQUEST");a.subject.hex=ASN1HEX.getDecendantHexTLVByNthList(c,0,[0,1]);a.subject.name=X509.hex2dn(a.subject.hex);a.pubkey.hex=ASN1HEX.getDecendantHexTLVByNthList(c,0,[0,2]);a.pubkey.obj=KEYUTIL.getKey(a.pubkey.hex,null,"pkcs8pub");return a};
	/*! asn1ocsp-1.0.1.js (c) 2016 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.asn1=="undefined"||!KJUR.asn1){KJUR.asn1={}}if(typeof KJUR.asn1.ocsp=="undefined"||!KJUR.asn1.ocsp){KJUR.asn1.ocsp={}}KJUR.asn1.ocsp.DEFAULT_HASH="sha1";KJUR.asn1.ocsp.CertID=function(c){KJUR.asn1.ocsp.CertID.superclass.constructor.call(this);var a=KJUR.asn1;var e=KJUR.asn1.x509;this.dHashAlg=null;this.dIssuerNameHash=null;this.dIssuerKeyHash=null;this.dSerialNumber=null;this.setByValue=function(i,h,f,g){if(g===undefined){g=KJUR.asn1.ocsp.DEFAULT_HASH}this.dHashAlg=new e.AlgorithmIdentifier({name:g});this.dIssuerNameHash=new a.DEROctetString({hex:i});this.dIssuerKeyHash=new a.DEROctetString({hex:h});this.dSerialNumber=new a.DERInteger({hex:f})};this.setByCert=function(m,i,k){if(k===undefined){k=KJUR.asn1.ocsp.DEFAULT_HASH}var f=new X509();f.readCertPEM(i);var n=new X509();n.readCertPEM(m);var o=X509.getPublicKeyInfoPropOfCertPEM(m);var l=o.keyhex;var g=f.getSerialNumberHex();var h=KJUR.crypto.Util.hashHex(n.getSubjectHex(),k);var j=KJUR.crypto.Util.hashHex(l,k);this.setByValue(h,j,g,k);this.hoge=f.getSerialNumberHex()};this.getEncodedHex=function(){if(this.dHashAlg===null&&this.dIssuerNameHash===null&&this.dIssuerKeyHash===null&&this.dSerialNumber===null){throw"not yet set values"}var f=[this.dHashAlg,this.dIssuerNameHash,this.dIssuerKeyHash,this.dSerialNumber];var g=new a.DERSequence({array:f});this.hTLV=g.getEncodedHex();return this.hTLV};if(typeof c!=="undefined"){var b=c;if(typeof b.issuerCert!=="undefined"&&typeof b.subjectCert!=="undefined"){var d=KJUR.asn1.ocsp.DEFAULT_HASH;if(typeof b.alg==="undefined"){d=undefined}this.setByCert(b.issuerCert,b.subjectCert,d)}else{if(typeof b.namehash!=="undefined"&&typeof b.keyhash!=="undefined"&&typeof b.serial!=="undefined"){var d=KJUR.asn1.ocsp.DEFAULT_HASH;if(typeof b.alg==="undefined"){d=undefined}this.setByValue(b.namehash,b.keyhash,b.serial,d)}else{throw"invalid constructor arguments"}}}};YAHOO.lang.extend(KJUR.asn1.ocsp.CertID,KJUR.asn1.ASN1Object);KJUR.asn1.ocsp.Request=function(b){KJUR.asn1.ocsp.Request.superclass.constructor.call(this);this.dReqCert=null;this.dExt=null;this.getEncodedHex=function(){var c=[];if(this.dReqCert===null){throw"reqCert not set"}c.push(this.dReqCert);var d=new KJUR.asn1.DERSequence({array:c});this.hTLV=d.getEncodedHex();return this.hTLV};if(typeof b!=="undefined"){var a=new KJUR.asn1.ocsp.CertID(b);this.dReqCert=a}};YAHOO.lang.extend(KJUR.asn1.ocsp.Request,KJUR.asn1.ASN1Object);KJUR.asn1.ocsp.TBSRequest=function(a){KJUR.asn1.ocsp.TBSRequest.superclass.constructor.call(this);this.version=0;this.dRequestorName=null;this.dRequestList=[];this.dRequestExt=null;this.setRequestListByParam=function(d){var b=[];for(var c=0;c<d.length;c++){var e=new KJUR.asn1.ocsp.Request(d[0]);b.push(e)}this.dRequestList=b};this.getEncodedHex=function(){var b=[];if(this.version!==0){throw"not supported version: "+this.version}if(this.dRequestorName!==null){throw"requestorName not supported"}var d=new KJUR.asn1.DERSequence({array:this.dRequestList});b.push(d);if(this.dRequestExt!==null){throw"requestExtensions not supported"}var c=new KJUR.asn1.DERSequence({array:b});this.hTLV=c.getEncodedHex();return this.hTLV};if(typeof a!=="undefined"){if(typeof a.reqList!=="undefined"){this.setRequestListByParam(a.reqList)}}};YAHOO.lang.extend(KJUR.asn1.ocsp.TBSRequest,KJUR.asn1.ASN1Object);KJUR.asn1.ocsp.OCSPRequest=function(b){KJUR.asn1.ocsp.OCSPRequest.superclass.constructor.call(this);this.dTbsRequest=null;this.dOptionalSignature=null;this.getEncodedHex=function(){var c=[];if(this.dTbsRequest!==null){c.push(this.dTbsRequest)}else{throw"tbsRequest not set"}if(this.dOptionalSignature!==null){throw"optionalSignature not supported"}var d=new KJUR.asn1.DERSequence({array:c});this.hTLV=d.getEncodedHex();return this.hTLV};if(typeof b!=="undefined"){if(typeof b.reqList!=="undefined"){var a=new KJUR.asn1.ocsp.TBSRequest(b);this.dTbsRequest=a}}};YAHOO.lang.extend(KJUR.asn1.ocsp.OCSPRequest,KJUR.asn1.ASN1Object);KJUR.asn1.ocsp.OCSPUtil={};KJUR.asn1.ocsp.OCSPUtil.getRequestHex=function(a,b,e){if(e===undefined){e=KJUR.asn1.ocsp.DEFAULT_HASH}var d={alg:e,issuerCert:a,subjectCert:b};var c=new KJUR.asn1.ocsp.OCSPRequest({reqList:[d]});return c.getEncodedHex()};KJUR.asn1.ocsp.OCSPUtil.getOCSPResponseInfo=function(f){var a={};try{var b=ASN1HEX.getVbyList(f,0,[0],"0a");a.responseStatus=parseInt(b,16)}catch(d){}if(a.responseStatus!==0){return a}try{var e=ASN1HEX.getDecendantIndexByNthList(f,0,[1,0,1,0,0,2,0,1]);if(f.substr(e,2)==="80"){a.certStatus="good"}else{if(f.substr(e,2)==="a1"){a.certStatus="revoked";a.revocationTime=hextoutf8(ASN1HEX.getDecendantHexVByNthList(f,e,[0]))}else{if(f.substr(e,2)==="82"){a.certStatus="unknown"}}}}catch(d){}try{var c=ASN1HEX.getDecendantIndexByNthList(f,0,[1,0,1,0,0,2,0,2]);a.thisUpdate=hextoutf8(ASN1HEX.getHexOfV_AtObj(f,c))}catch(d){}try{var g=ASN1HEX.getDecendantIndexByNthList(f,0,[1,0,1,0,0,2,0,3]);if(f.substr(g,2)==="a0"){a.nextUpdate=hextoutf8(ASN1HEX.getDecendantHexVByNthList(f,g,[0]))}}catch(d){}return a};
	/*! base64x-1.1.8 (c) 2012-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	var KJUR;if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.lang=="undefined"||!KJUR.lang){KJUR.lang={}}KJUR.lang.String=function(){};function Base64x(){}function stoBA(d){var b=new Array();for(var c=0;c<d.length;c++){b[c]=d.charCodeAt(c)}return b}function BAtos(b){var d="";for(var c=0;c<b.length;c++){d=d+String.fromCharCode(b[c])}return d}function BAtohex(b){var e="";for(var d=0;d<b.length;d++){var c=b[d].toString(16);if(c.length==1){c="0"+c}e=e+c}return e}function stohex(a){return BAtohex(stoBA(a))}function stob64(a){return hex2b64(stohex(a))}function stob64u(a){return b64tob64u(hex2b64(stohex(a)))}function b64utos(a){return BAtos(b64toBA(b64utob64(a)))}function b64tob64u(a){a=a.replace(/\=/g,"");a=a.replace(/\+/g,"-");a=a.replace(/\//g,"_");return a}function b64utob64(a){if(a.length%4==2){a=a+"=="}else{if(a.length%4==3){a=a+"="}}a=a.replace(/-/g,"+");a=a.replace(/_/g,"/");return a}function hextob64u(a){if(a.length%2==1){a="0"+a}return b64tob64u(hex2b64(a))}function b64utohex(a){return b64tohex(b64utob64(a))}var utf8tob64u,b64utoutf8;if(typeof Buffer==="function"){utf8tob64u=function(a){return b64tob64u(new Buffer(a,"utf8").toString("base64"))};b64utoutf8=function(a){return new Buffer(b64utob64(a),"base64").toString("utf8")}}else{utf8tob64u=function(a){return hextob64u(uricmptohex(encodeURIComponentAll(a)))};b64utoutf8=function(a){return decodeURIComponent(hextouricmp(b64utohex(a)))}}function utf8tob64(a){return hex2b64(uricmptohex(encodeURIComponentAll(a)))}function b64toutf8(a){return decodeURIComponent(hextouricmp(b64tohex(a)))}function utf8tohex(a){return uricmptohex(encodeURIComponentAll(a))}function hextoutf8(a){return decodeURIComponent(hextouricmp(a))}function hextorstr(c){var b="";for(var a=0;a<c.length-1;a+=2){b+=String.fromCharCode(parseInt(c.substr(a,2),16))}return b}function rstrtohex(c){var a="";for(var b=0;b<c.length;b++){a+=("0"+c.charCodeAt(b).toString(16)).slice(-2)}return a}function hextob64(a){return hex2b64(a)}function hextob64nl(b){var a=hextob64(b);var c=a.replace(/(.{64})/g,"$1\r\n");c=c.replace(/\r\n$/,"");return c}function b64nltohex(b){var a=b.replace(/[^0-9A-Za-z\/+=]*/g,"");var c=b64tohex(a);return c}function hextoArrayBuffer(d){if(d.length%2!=0){throw"input is not even length"}if(d.match(/^[0-9A-Fa-f]+$/)==null){throw"input is not hexadecimal"}var b=new ArrayBuffer(d.length/2);var a=new DataView(b);for(var c=0;c<d.length/2;c++){a.setUint8(c,parseInt(d.substr(c*2,2),16))}return b}function ArrayBuffertohex(b){var d="";var a=new DataView(b);for(var c=0;c<b.byteLength;c++){d+=("00"+a.getUint8(c).toString(16)).slice(-2)}return d}function uricmptohex(a){return a.replace(/%/g,"")}function hextouricmp(a){return a.replace(/(..)/g,"%$1")}function encodeURIComponentAll(a){var d=encodeURIComponent(a);var b="";for(var c=0;c<d.length;c++){if(d[c]=="%"){b=b+d.substr(c,3);c=c+2}else{b=b+"%"+stohex(d[c])}}return b}function newline_toUnix(a){a=a.replace(/\r\n/mg,"\n");return a}function newline_toDos(a){a=a.replace(/\r\n/mg,"\n");a=a.replace(/\n/mg,"\r\n");return a}KJUR.lang.String.isInteger=function(a){if(a.match(/^[0-9]+$/)){return true}else{if(a.match(/^-[0-9]+$/)){return true}else{return false}}};KJUR.lang.String.isHex=function(a){if(a.length%2==0&&(a.match(/^[0-9a-f]+$/)||a.match(/^[0-9A-F]+$/))){return true}else{return false}};KJUR.lang.String.isBase64=function(a){a=a.replace(/\s+/g,"");if(a.match(/^[0-9A-Za-z+\/]+={0,3}$/)&&a.length%4==0){return true}else{return false}};KJUR.lang.String.isBase64URL=function(a){if(a.match(/[+/=]/)){return false}a=b64utob64(a);return KJUR.lang.String.isBase64(a)};KJUR.lang.String.isIntegerArray=function(a){a=a.replace(/\s+/g,"");if(a.match(/^\[[0-9,]+\]$/)){return true}else{return false}};function intarystrtohex(b){b=b.replace(/^\s*\[\s*/,"");b=b.replace(/\s*\]\s*$/,"");b=b.replace(/\s*/g,"");try{var c=b.split(/,/).map(function(g,e,h){var f=parseInt(g);if(f<0||255<f){throw"integer not in range 0-255"}var d=("00"+f.toString(16)).slice(-2);return d}).join("");return c}catch(a){throw"malformed integer array string: "+a}}var strdiffidx=function(c,a){var d=c.length;if(c.length>a.length){d=a.length}for(var b=0;b<d;b++){if(c.charCodeAt(b)!=a.charCodeAt(b)){return b}}if(c.length!=a.length){return d}return -1};
	/*! crypto-1.1.12.js (c) 2013-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.crypto=="undefined"||!KJUR.crypto){KJUR.crypto={}}KJUR.crypto.Util=new function(){this.DIGESTINFOHEAD={sha1:"3021300906052b0e03021a05000414",sha224:"302d300d06096086480165030402040500041c",sha256:"3031300d060960864801650304020105000420",sha384:"3041300d060960864801650304020205000430",sha512:"3051300d060960864801650304020305000440",md2:"3020300c06082a864886f70d020205000410",md5:"3020300c06082a864886f70d020505000410",ripemd160:"3021300906052b2403020105000414",};this.DEFAULTPROVIDER={md5:"cryptojs",sha1:"cryptojs",sha224:"cryptojs",sha256:"cryptojs",sha384:"cryptojs",sha512:"cryptojs",ripemd160:"cryptojs",hmacmd5:"cryptojs",hmacsha1:"cryptojs",hmacsha224:"cryptojs",hmacsha256:"cryptojs",hmacsha384:"cryptojs",hmacsha512:"cryptojs",hmacripemd160:"cryptojs",MD5withRSA:"cryptojs/jsrsa",SHA1withRSA:"cryptojs/jsrsa",SHA224withRSA:"cryptojs/jsrsa",SHA256withRSA:"cryptojs/jsrsa",SHA384withRSA:"cryptojs/jsrsa",SHA512withRSA:"cryptojs/jsrsa",RIPEMD160withRSA:"cryptojs/jsrsa",MD5withECDSA:"cryptojs/jsrsa",SHA1withECDSA:"cryptojs/jsrsa",SHA224withECDSA:"cryptojs/jsrsa",SHA256withECDSA:"cryptojs/jsrsa",SHA384withECDSA:"cryptojs/jsrsa",SHA512withECDSA:"cryptojs/jsrsa",RIPEMD160withECDSA:"cryptojs/jsrsa",SHA1withDSA:"cryptojs/jsrsa",SHA224withDSA:"cryptojs/jsrsa",SHA256withDSA:"cryptojs/jsrsa",MD5withRSAandMGF1:"cryptojs/jsrsa",SHA1withRSAandMGF1:"cryptojs/jsrsa",SHA224withRSAandMGF1:"cryptojs/jsrsa",SHA256withRSAandMGF1:"cryptojs/jsrsa",SHA384withRSAandMGF1:"cryptojs/jsrsa",SHA512withRSAandMGF1:"cryptojs/jsrsa",RIPEMD160withRSAandMGF1:"cryptojs/jsrsa",};this.CRYPTOJSMESSAGEDIGESTNAME={md5:CryptoJS.algo.MD5,sha1:CryptoJS.algo.SHA1,sha224:CryptoJS.algo.SHA224,sha256:CryptoJS.algo.SHA256,sha384:CryptoJS.algo.SHA384,sha512:CryptoJS.algo.SHA512,ripemd160:CryptoJS.algo.RIPEMD160};this.getDigestInfoHex=function(a,b){if(typeof this.DIGESTINFOHEAD[b]=="undefined"){throw"alg not supported in Util.DIGESTINFOHEAD: "+b}return this.DIGESTINFOHEAD[b]+a};this.getPaddedDigestInfoHex=function(h,a,j){var c=this.getDigestInfoHex(h,a);var d=j/4;if(c.length+22>d){throw"key is too short for SigAlg: keylen="+j+","+a}var b="0001";var k="00"+c;var g="";var l=d-b.length-k.length;for(var f=0;f<l;f+=2){g+="ff"}var e=b+g+k;return e};this.hashString=function(a,c){var b=new KJUR.crypto.MessageDigest({alg:c});return b.digestString(a)};this.hashHex=function(b,c){var a=new KJUR.crypto.MessageDigest({alg:c});return a.digestHex(b)};this.sha1=function(a){var b=new KJUR.crypto.MessageDigest({alg:"sha1",prov:"cryptojs"});return b.digestString(a)};this.sha256=function(a){var b=new KJUR.crypto.MessageDigest({alg:"sha256",prov:"cryptojs"});return b.digestString(a)};this.sha256Hex=function(a){var b=new KJUR.crypto.MessageDigest({alg:"sha256",prov:"cryptojs"});return b.digestHex(a)};this.sha512=function(a){var b=new KJUR.crypto.MessageDigest({alg:"sha512",prov:"cryptojs"});return b.digestString(a)};this.sha512Hex=function(a){var b=new KJUR.crypto.MessageDigest({alg:"sha512",prov:"cryptojs"});return b.digestHex(a)}};KJUR.crypto.Util.md5=function(a){var b=new KJUR.crypto.MessageDigest({alg:"md5",prov:"cryptojs"});return b.digestString(a)};KJUR.crypto.Util.ripemd160=function(a){var b=new KJUR.crypto.MessageDigest({alg:"ripemd160",prov:"cryptojs"});return b.digestString(a)};KJUR.crypto.Util.SECURERANDOMGEN=new SecureRandom();KJUR.crypto.Util.getRandomHexOfNbytes=function(b){var a=new Array(b);KJUR.crypto.Util.SECURERANDOMGEN.nextBytes(a);return BAtohex(a)};KJUR.crypto.Util.getRandomBigIntegerOfNbytes=function(a){return new BigInteger(KJUR.crypto.Util.getRandomHexOfNbytes(a),16)};KJUR.crypto.Util.getRandomHexOfNbits=function(d){var c=d%8;var a=(d-c)/8;var b=new Array(a+1);KJUR.crypto.Util.SECURERANDOMGEN.nextBytes(b);b[0]=(((255<<c)&255)^255)&b[0];return BAtohex(b)};KJUR.crypto.Util.getRandomBigIntegerOfNbits=function(a){return new BigInteger(KJUR.crypto.Util.getRandomHexOfNbits(a),16)};KJUR.crypto.Util.getRandomBigIntegerZeroToMax=function(b){var a=b.bitLength();while(1){var c=KJUR.crypto.Util.getRandomBigIntegerOfNbits(a);if(b.compareTo(c)!=-1){return c}}};KJUR.crypto.Util.getRandomBigIntegerMinToMax=function(e,b){var c=e.compareTo(b);if(c==1){throw"biMin is greater than biMax"}if(c==0){return e}var a=b.subtract(e);var d=KJUR.crypto.Util.getRandomBigIntegerZeroToMax(a);return d.add(e)};KJUR.crypto.MessageDigest=function(c){var b=null;var a=null;var d=null;this.setAlgAndProvider=function(g,f){g=KJUR.crypto.MessageDigest.getCanonicalAlgName(g);if(g!==null&&f===undefined){f=KJUR.crypto.Util.DEFAULTPROVIDER[g]}if(":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(g)!=-1&&f=="cryptojs"){try{this.md=KJUR.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[g].create()}catch(e){throw"setAlgAndProvider hash alg set fail alg="+g+"/"+e}this.updateString=function(h){this.md.update(h)};this.updateHex=function(h){var i=CryptoJS.enc.Hex.parse(h);this.md.update(i)};this.digest=function(){var h=this.md.finalize();return h.toString(CryptoJS.enc.Hex)};this.digestString=function(h){this.updateString(h);return this.digest()};this.digestHex=function(h){this.updateHex(h);return this.digest()}}if(":sha256:".indexOf(g)!=-1&&f=="sjcl"){try{this.md=new sjcl.hash.sha256()}catch(e){throw"setAlgAndProvider hash alg set fail alg="+g+"/"+e}this.updateString=function(h){this.md.update(h)};this.updateHex=function(i){var h=sjcl.codec.hex.toBits(i);this.md.update(h)};this.digest=function(){var h=this.md.finalize();return sjcl.codec.hex.fromBits(h)};this.digestString=function(h){this.updateString(h);return this.digest()};this.digestHex=function(h){this.updateHex(h);return this.digest()}}};this.updateString=function(e){throw"updateString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName};this.updateHex=function(e){throw"updateHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName};this.digest=function(){throw"digest() not supported for this alg/prov: "+this.algName+"/"+this.provName};this.digestString=function(e){throw"digestString(str) not supported for this alg/prov: "+this.algName+"/"+this.provName};this.digestHex=function(e){throw"digestHex(hex) not supported for this alg/prov: "+this.algName+"/"+this.provName};if(c!==undefined){if(c.alg!==undefined){this.algName=c.alg;if(c.prov===undefined){this.provName=KJUR.crypto.Util.DEFAULTPROVIDER[this.algName]}this.setAlgAndProvider(this.algName,this.provName)}}};KJUR.crypto.MessageDigest.getCanonicalAlgName=function(a){if(typeof a==="string"){a=a.toLowerCase();a=a.replace(/-/,"")}return a};KJUR.crypto.MessageDigest.getHashLength=function(c){var b=KJUR.crypto.MessageDigest;var a=b.getCanonicalAlgName(c);if(b.HASHLENGTH[a]===undefined){throw"not supported algorithm: "+c}return b.HASHLENGTH[a]};KJUR.crypto.MessageDigest.HASHLENGTH={md5:16,sha1:20,sha224:28,sha256:32,sha384:48,sha512:64,ripemd160:20};KJUR.crypto.Mac=function(d){var f=null;var c=null;var a=null;var e=null;var b=null;this.setAlgAndProvider=function(k,i){k=k.toLowerCase();if(k==null){k="hmacsha1"}k=k.toLowerCase();if(k.substr(0,4)!="hmac"){throw"setAlgAndProvider unsupported HMAC alg: "+k}if(i===undefined){i=KJUR.crypto.Util.DEFAULTPROVIDER[k]}this.algProv=k+"/"+i;var g=k.substr(4);if(":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(g)!=-1&&i=="cryptojs"){try{var j=KJUR.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[g];this.mac=CryptoJS.algo.HMAC.create(j,this.pass)}catch(h){throw"setAlgAndProvider hash alg set fail hashAlg="+g+"/"+h}this.updateString=function(l){this.mac.update(l)};this.updateHex=function(l){var m=CryptoJS.enc.Hex.parse(l);this.mac.update(m)};this.doFinal=function(){var l=this.mac.finalize();return l.toString(CryptoJS.enc.Hex)};this.doFinalString=function(l){this.updateString(l);return this.doFinal()};this.doFinalHex=function(l){this.updateHex(l);return this.doFinal()}}};this.updateString=function(g){throw"updateString(str) not supported for this alg/prov: "+this.algProv};this.updateHex=function(g){throw"updateHex(hex) not supported for this alg/prov: "+this.algProv};this.doFinal=function(){throw"digest() not supported for this alg/prov: "+this.algProv};this.doFinalString=function(g){throw"digestString(str) not supported for this alg/prov: "+this.algProv};this.doFinalHex=function(g){throw"digestHex(hex) not supported for this alg/prov: "+this.algProv};this.setPassword=function(h){if(typeof h=="string"){var g=h;if(h.length%2==1||!h.match(/^[0-9A-Fa-f]+$/)){g=rstrtohex(h)}this.pass=CryptoJS.enc.Hex.parse(g);return}if(typeof h!="object"){throw"KJUR.crypto.Mac unsupported password type: "+h}var g=null;if(h.hex!==undefined){if(h.hex.length%2!=0||!h.hex.match(/^[0-9A-Fa-f]+$/)){throw"Mac: wrong hex password: "+h.hex}g=h.hex}if(h.utf8!==undefined){g=utf8tohex(h.utf8)}if(h.rstr!==undefined){g=rstrtohex(h.rstr)}if(h.b64!==undefined){g=b64tohex(h.b64)}if(h.b64u!==undefined){g=b64utohex(h.b64u)}if(g==null){throw"KJUR.crypto.Mac unsupported password type: "+h}this.pass=CryptoJS.enc.Hex.parse(g)};if(d!==undefined){if(d.pass!==undefined){this.setPassword(d.pass)}if(d.alg!==undefined){this.algName=d.alg;if(d.prov===undefined){this.provName=KJUR.crypto.Util.DEFAULTPROVIDER[this.algName]}this.setAlgAndProvider(this.algName,this.provName)}}};KJUR.crypto.Signature=function(o){var q=null;var n=null;var r=null;var c=null;var l=null;var d=null;var k=null;var h=null;var p=null;var e=null;var b=-1;var g=null;var j=null;var a=null;var i=null;var f=null;this._setAlgNames=function(){var s=this.algName.match(/^(.+)with(.+)$/);if(s){this.mdAlgName=s[1].toLowerCase();this.pubkeyAlgName=s[2].toLowerCase()}};this._zeroPaddingOfSignature=function(x,w){var v="";var t=w/4-x.length;for(var u=0;u<t;u++){v=v+"0"}return v+x};this.setAlgAndProvider=function(u,t){this._setAlgNames();if(t!="cryptojs/jsrsa"){throw"provider not supported: "+t}if(":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName)!=-1){try{this.md=new KJUR.crypto.MessageDigest({alg:this.mdAlgName})}catch(s){throw"setAlgAndProvider hash alg set fail alg="+this.mdAlgName+"/"+s}this.init=function(w,x){var y=null;try{if(x===undefined){y=KEYUTIL.getKey(w)}else{y=KEYUTIL.getKey(w,x)}}catch(v){throw"init failed:"+v}if(y.isPrivate===true){this.prvKey=y;this.state="SIGN"}else{if(y.isPublic===true){this.pubKey=y;this.state="VERIFY"}else{throw"init failed.:"+y}}};this.initSign=function(v){if(typeof v.ecprvhex=="string"&&typeof v.eccurvename=="string"){this.ecprvhex=v.ecprvhex;this.eccurvename=v.eccurvename}else{this.prvKey=v}this.state="SIGN"};this.initVerifyByPublicKey=function(v){if(typeof v.ecpubhex=="string"&&typeof v.eccurvename=="string"){this.ecpubhex=v.ecpubhex;this.eccurvename=v.eccurvename}else{if(v instanceof KJUR.crypto.ECDSA){this.pubKey=v}else{if(v instanceof RSAKey){this.pubKey=v}}}this.state="VERIFY"};this.initVerifyByCertificatePEM=function(v){var w=new X509();w.readCertPEM(v);this.pubKey=w.subjectPublicKeyRSA;this.state="VERIFY"};this.updateString=function(v){this.md.updateString(v)};this.updateHex=function(v){this.md.updateHex(v)};this.sign=function(){this.sHashHex=this.md.digest();if(typeof this.ecprvhex!="undefined"&&typeof this.eccurvename!="undefined"){var v=new KJUR.crypto.ECDSA({curve:this.eccurvename});this.hSign=v.signHex(this.sHashHex,this.ecprvhex)}else{if(this.prvKey instanceof RSAKey&&this.pubkeyAlgName=="rsaandmgf1"){this.hSign=this.prvKey.signWithMessageHashPSS(this.sHashHex,this.mdAlgName,this.pssSaltLen)}else{if(this.prvKey instanceof RSAKey&&this.pubkeyAlgName=="rsa"){this.hSign=this.prvKey.signWithMessageHash(this.sHashHex,this.mdAlgName)}else{if(this.prvKey instanceof KJUR.crypto.ECDSA){this.hSign=this.prvKey.signWithMessageHash(this.sHashHex)}else{if(this.prvKey instanceof KJUR.crypto.DSA){this.hSign=this.prvKey.signWithMessageHash(this.sHashHex)}else{throw"Signature: unsupported public key alg: "+this.pubkeyAlgName}}}}}return this.hSign};this.signString=function(v){this.updateString(v);return this.sign()};this.signHex=function(v){this.updateHex(v);return this.sign()};this.verify=function(v){this.sHashHex=this.md.digest();if(typeof this.ecpubhex!="undefined"&&typeof this.eccurvename!="undefined"){var w=new KJUR.crypto.ECDSA({curve:this.eccurvename});return w.verifyHex(this.sHashHex,v,this.ecpubhex)}else{if(this.pubKey instanceof RSAKey&&this.pubkeyAlgName=="rsaandmgf1"){return this.pubKey.verifyWithMessageHashPSS(this.sHashHex,v,this.mdAlgName,this.pssSaltLen)}else{if(this.pubKey instanceof RSAKey&&this.pubkeyAlgName=="rsa"){return this.pubKey.verifyWithMessageHash(this.sHashHex,v)}else{if(this.pubKey instanceof KJUR.crypto.ECDSA){return this.pubKey.verifyWithMessageHash(this.sHashHex,v)}else{if(this.pubKey instanceof KJUR.crypto.DSA){return this.pubKey.verifyWithMessageHash(this.sHashHex,v)}else{throw"Signature: unsupported public key alg: "+this.pubkeyAlgName}}}}}}}};this.init=function(s,t){throw"init(key, pass) not supported for this alg:prov="+this.algProvName};this.initVerifyByPublicKey=function(s){throw"initVerifyByPublicKey(rsaPubKeyy) not supported for this alg:prov="+this.algProvName};this.initVerifyByCertificatePEM=function(s){throw"initVerifyByCertificatePEM(certPEM) not supported for this alg:prov="+this.algProvName};this.initSign=function(s){throw"initSign(prvKey) not supported for this alg:prov="+this.algProvName};this.updateString=function(s){throw"updateString(str) not supported for this alg:prov="+this.algProvName};this.updateHex=function(s){throw"updateHex(hex) not supported for this alg:prov="+this.algProvName};this.sign=function(){throw"sign() not supported for this alg:prov="+this.algProvName};this.signString=function(s){throw"digestString(str) not supported for this alg:prov="+this.algProvName};this.signHex=function(s){throw"digestHex(hex) not supported for this alg:prov="+this.algProvName};this.verify=function(s){throw"verify(hSigVal) not supported for this alg:prov="+this.algProvName};this.initParams=o;if(o!==undefined){if(o.alg!==undefined){this.algName=o.alg;if(o.prov===undefined){this.provName=KJUR.crypto.Util.DEFAULTPROVIDER[this.algName]}else{this.provName=o.prov}this.algProvName=this.algName+":"+this.provName;this.setAlgAndProvider(this.algName,this.provName);this._setAlgNames()}if(o.psssaltlen!==undefined){this.pssSaltLen=o.psssaltlen}if(o.prvkeypem!==undefined){if(o.prvkeypas!==undefined){throw"both prvkeypem and prvkeypas parameters not supported"}else{try{var q=new RSAKey();q.readPrivateKeyFromPEMString(o.prvkeypem);this.initSign(q)}catch(m){throw"fatal error to load pem private key: "+m}}}}};KJUR.crypto.Cipher=function(a){};KJUR.crypto.Cipher.encrypt=function(e,f,d){if(f instanceof RSAKey&&f.isPublic){var c=KJUR.crypto.Cipher.getAlgByKeyAndName(f,d);if(c==="RSA"){return f.encrypt(e)}if(c==="RSAOAEP"){return f.encryptOAEP(e,"sha1")}var b=c.match(/^RSAOAEP(\d+)$/);if(b!==null){return f.encryptOAEP(e,"sha"+b[1])}throw"Cipher.encrypt: unsupported algorithm for RSAKey: "+d}else{throw"Cipher.encrypt: unsupported key or algorithm"}};KJUR.crypto.Cipher.decrypt=function(e,f,d){if(f instanceof RSAKey&&f.isPrivate){var c=KJUR.crypto.Cipher.getAlgByKeyAndName(f,d);if(c==="RSA"){return f.decrypt(e)}if(c==="RSAOAEP"){return f.decryptOAEP(e,"sha1")}var b=c.match(/^RSAOAEP(\d+)$/);if(b!==null){return f.decryptOAEP(e,"sha"+b[1])}throw"Cipher.decrypt: unsupported algorithm for RSAKey: "+d}else{throw"Cipher.decrypt: unsupported key or algorithm"}};KJUR.crypto.Cipher.getAlgByKeyAndName=function(b,a){if(b instanceof RSAKey){if(":RSA:RSAOAEP:RSAOAEP224:RSAOAEP256:RSAOAEP384:RSAOAEP512:".indexOf(a)!=-1){return a}if(a===null||a===undefined){return"RSA"}throw"getAlgByKeyAndName: not supported algorithm name for RSAKey: "+a}throw"getAlgByKeyAndName: not supported algorithm name: "+a};KJUR.crypto.OID=new function(){this.oidhex2name={"2a864886f70d010101":"rsaEncryption","2a8648ce3d0201":"ecPublicKey","2a8648ce380401":"dsa","2a8648ce3d030107":"secp256r1","2b8104001f":"secp192k1","2b81040021":"secp224r1","2b8104000a":"secp256k1","2b81040023":"secp521r1","2b81040022":"secp384r1","2a8648ce380403":"SHA1withDSA","608648016503040301":"SHA224withDSA","608648016503040302":"SHA256withDSA",}};
	/*! ecdsa-modified-1.1.0.js (c) Stephan Thomas, Kenji Urushima | github.com/bitcoinjs/bitcoinjs-lib/blob/master/LICENSE
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.crypto=="undefined"||!KJUR.crypto){KJUR.crypto={}}KJUR.crypto.ECDSA=function(h){var e="secp256r1";var g=null;var b=null;var f=null;var a=new SecureRandom();var d=null;this.type="EC";this.isPrivate=false;this.isPublic=false;function c(s,o,r,n){var j=Math.max(o.bitLength(),n.bitLength());var t=s.add2D(r);var q=s.curve.getInfinity();for(var p=j-1;p>=0;--p){q=q.twice2D();q.z=BigInteger.ONE;if(o.testBit(p)){if(n.testBit(p)){q=q.add2D(t)}else{q=q.add2D(s)}}else{if(n.testBit(p)){q=q.add2D(r)}}}return q}this.getBigRandom=function(i){return new BigInteger(i.bitLength(),a).mod(i.subtract(BigInteger.ONE)).add(BigInteger.ONE)};this.setNamedCurve=function(i){this.ecparams=KJUR.crypto.ECParameterDB.getByName(i);this.prvKeyHex=null;this.pubKeyHex=null;this.curveName=i};this.setPrivateKeyHex=function(i){this.isPrivate=true;this.prvKeyHex=i};this.setPublicKeyHex=function(i){this.isPublic=true;this.pubKeyHex=i};this.getPublicKeyXYHex=function(){var k=this.pubKeyHex;if(k.substr(0,2)!=="04"){throw"this method supports uncompressed format(04) only"}var j=this.ecparams.keylen/4;if(k.length!==2+j*2){throw"malformed public key hex length"}var i={};i.x=k.substr(2,j);i.y=k.substr(2+j);return i};this.getShortNISTPCurveName=function(){var i=this.curveName;if(i==="secp256r1"||i==="NIST P-256"||i==="P-256"||i==="prime256v1"){return"P-256"}if(i==="secp384r1"||i==="NIST P-384"||i==="P-384"){return"P-384"}return null};this.generateKeyPairHex=function(){var k=this.ecparams.n;var n=this.getBigRandom(k);var l=this.ecparams.G.multiply(n);var q=l.getX().toBigInteger();var o=l.getY().toBigInteger();var i=this.ecparams.keylen/4;var m=("0000000000"+n.toString(16)).slice(-i);var r=("0000000000"+q.toString(16)).slice(-i);var p=("0000000000"+o.toString(16)).slice(-i);var j="04"+r+p;this.setPrivateKeyHex(m);this.setPublicKeyHex(j);return{ecprvhex:m,ecpubhex:j}};this.signWithMessageHash=function(i){return this.signHex(i,this.prvKeyHex)};this.signHex=function(o,j){var t=new BigInteger(j,16);var l=this.ecparams.n;var q=new BigInteger(o,16);do{var m=this.getBigRandom(l);var u=this.ecparams.G;var p=u.multiply(m);var i=p.getX().toBigInteger().mod(l)}while(i.compareTo(BigInteger.ZERO)<=0);var v=m.modInverse(l).multiply(q.add(t.multiply(i))).mod(l);return KJUR.crypto.ECDSA.biRSSigToASN1Sig(i,v)};this.sign=function(m,u){var q=u;var j=this.ecparams.n;var p=BigInteger.fromByteArrayUnsigned(m);do{var l=this.getBigRandom(j);var t=this.ecparams.G;var o=t.multiply(l);var i=o.getX().toBigInteger().mod(j)}while(i.compareTo(BigInteger.ZERO)<=0);var v=l.modInverse(j).multiply(p.add(q.multiply(i))).mod(j);return this.serializeSig(i,v)};this.verifyWithMessageHash=function(j,i){return this.verifyHex(j,i,this.pubKeyHex)};this.verifyHex=function(m,i,p){var l,j;var o=KJUR.crypto.ECDSA.parseSigHex(i);l=o.r;j=o.s;var k;k=ECPointFp.decodeFromHex(this.ecparams.curve,p);var n=new BigInteger(m,16);return this.verifyRaw(n,l,j,k)};this.verify=function(o,p,j){var l,i;if(Bitcoin.Util.isArray(p)){var n=this.parseSig(p);l=n.r;i=n.s}else{if("object"===typeof p&&p.r&&p.s){l=p.r;i=p.s}else{throw"Invalid value for signature"}}var k;if(j instanceof ECPointFp){k=j}else{if(Bitcoin.Util.isArray(j)){k=ECPointFp.decodeFrom(this.ecparams.curve,j)}else{throw"Invalid format for pubkey value, must be byte array or ECPointFp"}}var m=BigInteger.fromByteArrayUnsigned(o);return this.verifyRaw(m,l,i,k)};this.verifyRaw=function(o,i,w,m){var l=this.ecparams.n;var u=this.ecparams.G;if(i.compareTo(BigInteger.ONE)<0||i.compareTo(l)>=0){return false}if(w.compareTo(BigInteger.ONE)<0||w.compareTo(l)>=0){return false}var p=w.modInverse(l);var k=o.multiply(p).mod(l);var j=i.multiply(p).mod(l);var q=u.multiply(k).add(m.multiply(j));var t=q.getX().toBigInteger().mod(l);return t.equals(i)};this.serializeSig=function(k,j){var l=k.toByteArraySigned();var i=j.toByteArraySigned();var m=[];m.push(2);m.push(l.length);m=m.concat(l);m.push(2);m.push(i.length);m=m.concat(i);m.unshift(m.length);m.unshift(48);return m};this.parseSig=function(n){var m;if(n[0]!=48){throw new Error("Signature not a valid DERSequence")}m=2;if(n[m]!=2){throw new Error("First element in signature must be a DERInteger")}var l=n.slice(m+2,m+2+n[m+1]);m+=2+n[m+1];if(n[m]!=2){throw new Error("Second element in signature must be a DERInteger")}var i=n.slice(m+2,m+2+n[m+1]);m+=2+n[m+1];var k=BigInteger.fromByteArrayUnsigned(l);var j=BigInteger.fromByteArrayUnsigned(i);return{r:k,s:j}};this.parseSigCompact=function(m){if(m.length!==65){throw"Signature has the wrong length"}var j=m[0]-27;if(j<0||j>7){throw"Invalid signature type"}var o=this.ecparams.n;var l=BigInteger.fromByteArrayUnsigned(m.slice(1,33)).mod(o);var k=BigInteger.fromByteArrayUnsigned(m.slice(33,65)).mod(o);return{r:l,s:k,i:j}};this.readPKCS5PrvKeyHex=function(l){var n=ASN1HEX;var m=KJUR.crypto.ECDSA.getName;var p=n.getVbyList;if(n.isASN1HEX(l)===false){throw"not ASN.1 hex string"}var i,k,o;try{i=p(l,0,[2,0],"06");k=p(l,0,[1],"04");try{o=p(l,0,[3,0],"03").substr(2)}catch(j){}}catch(j){throw"malformed PKCS#1/5 plain ECC private key"}this.curveName=m(i);if(this.curveName===undefined){throw"unsupported curve name"}this.setNamedCurve(this.curveName);this.setPublicKeyHex(o);this.setPrivateKeyHex(k);this.isPublic=false};this.readPKCS8PrvKeyHex=function(l){var q=ASN1HEX;var i=KJUR.crypto.ECDSA.getName;var n=q.getVbyList;if(q.isASN1HEX(l)===false){throw"not ASN.1 hex string"}var j,p,m,k;try{j=n(l,0,[1,0],"06");p=n(l,0,[1,1],"06");m=n(l,0,[2,0,1],"04");try{k=n(l,0,[2,0,2,0],"03").substr(2)}catch(o){}}catch(o){throw"malformed PKCS#8 plain ECC private key"}this.curveName=i(p);if(this.curveName===undefined){throw"unsupported curve name"}this.setNamedCurve(this.curveName);this.setPublicKeyHex(k);this.setPrivateKeyHex(m);this.isPublic=false};this.readPKCS8PubKeyHex=function(l){var n=ASN1HEX;var m=KJUR.crypto.ECDSA.getName;var p=n.getVbyList;if(n.isASN1HEX(l)===false){throw"not ASN.1 hex string"}var k,i,o;try{k=p(l,0,[0,0],"06");i=p(l,0,[0,1],"06");o=p(l,0,[1],"03").substr(2)}catch(j){throw"malformed PKCS#8 ECC public key"}this.curveName=m(i);if(this.curveName===null){throw"unsupported curve name"}this.setNamedCurve(this.curveName);this.setPublicKeyHex(o)};this.readCertPubKeyHex=function(k,p){if(p!==5){p=6}var m=ASN1HEX;var l=KJUR.crypto.ECDSA.getName;var o=m.getVbyList;if(m.isASN1HEX(k)===false){throw"not ASN.1 hex string"}var i,n;try{i=o(k,0,[0,p,0,1],"06");n=o(k,0,[0,p,1],"03").substr(2)}catch(j){throw"malformed X.509 certificate ECC public key"}this.curveName=l(i);if(this.curveName===null){throw"unsupported curve name"}this.setNamedCurve(this.curveName);this.setPublicKeyHex(n)};if(h!==undefined){if(h.curve!==undefined){this.curveName=h.curve}}if(this.curveName===undefined){this.curveName=e}this.setNamedCurve(this.curveName);if(h!==undefined){if(h.prv!==undefined){this.setPrivateKeyHex(h.prv)}if(h.pub!==undefined){this.setPublicKeyHex(h.pub)}}};KJUR.crypto.ECDSA.parseSigHex=function(a){var b=KJUR.crypto.ECDSA.parseSigHexInHexRS(a);var d=new BigInteger(b.r,16);var c=new BigInteger(b.s,16);return{r:d,s:c}};KJUR.crypto.ECDSA.parseSigHexInHexRS=function(c){if(c.substr(0,2)!="30"){throw"signature is not a ASN.1 sequence"}var b=ASN1HEX.getPosArrayOfChildren_AtObj(c,0);if(b.length!=2){throw"number of signature ASN.1 sequence elements seem wrong"}var g=b[0];var f=b[1];if(c.substr(g,2)!="02"){throw"1st item of sequene of signature is not ASN.1 integer"}if(c.substr(f,2)!="02"){throw"2nd item of sequene of signature is not ASN.1 integer"}var e=ASN1HEX.getHexOfV_AtObj(c,g);var d=ASN1HEX.getHexOfV_AtObj(c,f);return{r:e,s:d}};KJUR.crypto.ECDSA.asn1SigToConcatSig=function(c){var d=KJUR.crypto.ECDSA.parseSigHexInHexRS(c);var b=d.r;var a=d.s;if(b.substr(0,2)=="00"&&(((b.length/2)*8)%(16*8))==8){b=b.substr(2)}if(a.substr(0,2)=="00"&&(((a.length/2)*8)%(16*8))==8){a=a.substr(2)}if((((b.length/2)*8)%(16*8))!=0){throw"unknown ECDSA sig r length error"}if((((a.length/2)*8)%(16*8))!=0){throw"unknown ECDSA sig s length error"}return b+a};KJUR.crypto.ECDSA.concatSigToASN1Sig=function(a){if((((a.length/2)*8)%(16*8))!=0){throw"unknown ECDSA concatinated r-s sig  length error"}var c=a.substr(0,a.length/2);var b=a.substr(a.length/2);return KJUR.crypto.ECDSA.hexRSSigToASN1Sig(c,b)};KJUR.crypto.ECDSA.hexRSSigToASN1Sig=function(b,a){var d=new BigInteger(b,16);var c=new BigInteger(a,16);return KJUR.crypto.ECDSA.biRSSigToASN1Sig(d,c)};KJUR.crypto.ECDSA.biRSSigToASN1Sig=function(e,c){var b=new KJUR.asn1.DERInteger({bigint:e});var a=new KJUR.asn1.DERInteger({bigint:c});var d=new KJUR.asn1.DERSequence({array:[b,a]});return d.getEncodedHex()};KJUR.crypto.ECDSA.getName=function(a){if(a==="2a8648ce3d030107"){return"secp256r1"}if(a==="2b8104000a"){return"secp256k1"}if(a==="2b81040022"){return"secp384r1"}if("|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(a)!==-1){return"secp256r1"}if("|secp256k1|".indexOf(a)!==-1){return"secp256k1"}if("|secp384r1|NIST P-384|P-384|".indexOf(a)!==-1){return"secp384r1"}return null};
	/*! ecparam-1.0.0.js (c) 2013 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.crypto=="undefined"||!KJUR.crypto){KJUR.crypto={}}KJUR.crypto.ECParameterDB=new function(){var b={};var c={};function a(d){return new BigInteger(d,16)}this.getByName=function(e){var d=e;if(typeof c[d]!="undefined"){d=c[e]}if(typeof b[d]!="undefined"){return b[d]}throw"unregistered EC curve name: "+d};this.regist=function(A,l,o,g,m,e,j,f,k,u,d,x){b[A]={};var s=a(o);var z=a(g);var y=a(m);var t=a(e);var w=a(j);var r=new ECCurveFp(s,z,y);var q=r.decodePointHex("04"+f+k);b[A]["name"]=A;b[A]["keylen"]=l;b[A]["curve"]=r;b[A]["G"]=q;b[A]["n"]=t;b[A]["h"]=w;b[A]["oid"]=d;b[A]["info"]=x;for(var v=0;v<u.length;v++){c[u[v]]=A}}};KJUR.crypto.ECParameterDB.regist("secp128r1",128,"FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC","E87579C11079F43DD824993C2CEE5ED3","FFFFFFFE0000000075A30D1B9038A115","1","161FF7528B899B2D0C28607CA52C5B86","CF5AC8395BAFEB13C02DA292DDED7A83",[],"","secp128r1 : SECG curve over a 128 bit prime field");KJUR.crypto.ECParameterDB.regist("secp160k1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73","0","7","0100000000000000000001B8FA16DFAB9ACA16B6B3","1","3B4C382CE37AA192A4019E763036F4F5DD4D7EBB","938CF935318FDCED6BC28286531733C3F03C4FEE",[],"","secp160k1 : SECG curve over a 160 bit prime field");KJUR.crypto.ECParameterDB.regist("secp160r1",160,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC","1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45","0100000000000000000001F4C8F927AED3CA752257","1","4A96B5688EF573284664698968C38BB913CBFC82","23A628553168947D59DCC912042351377AC5FB32",[],"","secp160r1 : SECG curve over a 160 bit prime field");KJUR.crypto.ECParameterDB.regist("secp192k1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37","0","3","FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D","1","DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D","9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D",[]);KJUR.crypto.ECParameterDB.regist("secp192r1",192,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC","64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1","FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831","1","188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012","07192B95FFC8DA78631011ED6B24CDD573F977A11E794811",[]);KJUR.crypto.ECParameterDB.regist("secp224r1",224,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE","B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4","FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D","1","B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21","BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34",[]);KJUR.crypto.ECParameterDB.regist("secp256k1",256,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F","0","7","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141","1","79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798","483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8",[]);KJUR.crypto.ECParameterDB.regist("secp256r1",256,"FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF","FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC","5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B","FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551","1","6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296","4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5",["NIST P-256","P-256","prime256v1"]);KJUR.crypto.ECParameterDB.regist("secp384r1",384,"FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC","B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF","FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973","1","AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7","3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f",["NIST P-384","P-384"]);KJUR.crypto.ECParameterDB.regist("secp521r1",521,"1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC","051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00","1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409","1","C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66","011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650",["NIST P-521","P-521"]);
	/*! dsa-2.1.0.js (c) 2016-2017 Kenji Urushimma | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.crypto=="undefined"||!KJUR.crypto){KJUR.crypto={}}KJUR.crypto.DSA=function(){this.p=null;this.q=null;this.g=null;this.y=null;this.x=null;this.type="DSA";this.isPrivate=false;this.isPublic=false;this.setPrivate=function(d,c,b,e,a){this.isPrivate=true;this.p=d;this.q=c;this.g=b;this.y=e;this.x=a};this.setPrivateHex=function(d,b,f,i,j){var c,a,e,g,h;c=new BigInteger(d,16);a=new BigInteger(b,16);e=new BigInteger(f,16);if(typeof i==="string"&&i.length>1){g=new BigInteger(i,16)}else{g=null}h=new BigInteger(j,16);this.setPrivate(c,a,e,g,h)};this.setPublic=function(c,b,a,d){this.isPublic=true;this.p=c;this.q=b;this.g=a;this.y=d;this.x=null};this.setPublicHex=function(f,e,d,g){var b,a,h,c;b=new BigInteger(f,16);a=new BigInteger(e,16);h=new BigInteger(d,16);c=new BigInteger(g,16);this.setPublic(b,a,h,c)};this.signWithMessageHash=function(d){var c=this.p;var b=this.q;var f=this.g;var i=this.y;var j=this.x;var e=KJUR.crypto.Util.getRandomBigIntegerMinToMax(BigInteger.ONE.add(BigInteger.ONE),b.subtract(BigInteger.ONE));var l=d.substr(0,b.bitLength()/4);var h=new BigInteger(l,16);var a=(f.modPow(e,c)).mod(b);var n=(e.modInverse(b).multiply(h.add(j.multiply(a)))).mod(b);var m=KJUR.asn1.ASN1Util.jsonToASN1HEX({seq:[{"int":{bigint:a}},{"int":{bigint:n}}]});return m};this.verifyWithMessageHash=function(h,f){var d=this.p;var b=this.q;var j=this.g;var l=this.y;var i=this.parseASN1Signature(f);var a=i[0];var t=i[1];var o=h.substr(0,b.bitLength()/4);var k=new BigInteger(o,16);if(BigInteger.ZERO.compareTo(a)>0||a.compareTo(b)>0){throw"invalid DSA signature"}if(BigInteger.ZERO.compareTo(t)>0||t.compareTo(b)>0){throw"invalid DSA signature"}var m=t.modInverse(b);var e=k.multiply(m).mod(b);var c=a.multiply(m).mod(b);var n=j.modPow(e,d).multiply(l.modPow(c,d)).mod(d).mod(b);return n.compareTo(a)==0};this.parseASN1Signature=function(a){try{var d=new BigInteger(ASN1HEX.getVbyList(a,0,[0],"02"),16);var c=new BigInteger(ASN1HEX.getVbyList(a,0,[1],"02"),16);return[d,c]}catch(b){throw"malformed ASN.1 DSA signature"}};this.readPKCS5PrvKeyHex=function(c){var b,a,f,g,i;var j=ASN1HEX;var d=j.getVbyList;if(j.isASN1HEX(c)===false){throw"not ASN.1 hex string"}try{b=d(c,0,[1],"02");a=d(c,0,[2],"02");f=d(c,0,[3],"02");g=d(c,0,[4],"02");i=d(c,0,[5],"02")}catch(e){console.log("EXCEPTION:"+e);throw"malformed PKCS#1/5 plain DSA private key"}this.setPrivateHex(b,a,f,g,i)};this.readPKCS8PrvKeyHex=function(d){var f,c,b,g;var e=ASN1HEX;var i=e.getVbyList;if(e.isASN1HEX(d)===false){throw"not ASN.1 hex string"}try{f=i(d,0,[1,1,0],"02");c=i(d,0,[1,1,1],"02");b=i(d,0,[1,1,2],"02");g=i(d,0,[2,0],"02")}catch(a){console.log("EXCEPTION:"+a);throw"malformed PKCS#8 plain DSA private key"}this.setPrivateHex(f,c,b,null,g)};this.readPKCS8PubKeyHex=function(d){var f,c,b,g;var e=ASN1HEX;var i=e.getVbyList;if(e.isASN1HEX(d)===false){throw"not ASN.1 hex string"}try{f=i(d,0,[0,1,0],"02");c=i(d,0,[0,1,1],"02");b=i(d,0,[0,1,2],"02");g=i(d,0,[1,0],"02")}catch(a){console.log("EXCEPTION:"+a);throw"malformed PKCS#8 DSA public key"}this.setPublicHex(f,c,b,g)};this.readCertPubKeyHex=function(c,f){if(f!==5){f=6}var b,a,g,i;var j=ASN1HEX;var d=j.getVbyList;if(j.isASN1HEX(c)===false){throw"not ASN.1 hex string"}try{b=d(c,0,[0,f,0,1,0],"02");a=d(c,0,[0,f,0,1,1],"02");g=d(c,0,[0,f,0,1,2],"02");i=d(c,0,[0,f,1,0],"02")}catch(e){console.log("EXCEPTION:"+e);throw"malformed X.509 certificate DSA public key"}this.setPublicHex(b,a,g,i)}};
	/*! pkcs5pkey-1.1.0.js (c) 2013-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	var PKCS5PKEY=function(){var c=function(o,q,p){return j(CryptoJS.AES,o,q,p)};var d=function(o,q,p){return j(CryptoJS.TripleDES,o,q,p)};var j=function(r,w,t,p){var q=CryptoJS.enc.Hex.parse(w);var v=CryptoJS.enc.Hex.parse(t);var o=CryptoJS.enc.Hex.parse(p);var s={};s.key=v;s.iv=o;s.ciphertext=q;var u=r.decrypt(s,v,{iv:o});return CryptoJS.enc.Hex.stringify(u)};var k=function(o,q,p){return e(CryptoJS.AES,o,q,p)};var n=function(o,q,p){return e(CryptoJS.TripleDES,o,q,p)};var e=function(t,y,w,q){var s=CryptoJS.enc.Hex.parse(y);var x=CryptoJS.enc.Hex.parse(w);var p=CryptoJS.enc.Hex.parse(q);var o={};var v=t.encrypt(s,x,{iv:p});var r=CryptoJS.enc.Hex.parse(v.toString());var u=CryptoJS.enc.Base64.stringify(r);return u};var g={"AES-256-CBC":{proc:c,eproc:k,keylen:32,ivlen:16},"AES-192-CBC":{proc:c,eproc:k,keylen:24,ivlen:16},"AES-128-CBC":{proc:c,eproc:k,keylen:16,ivlen:16},"DES-EDE3-CBC":{proc:d,eproc:n,keylen:24,ivlen:8}};var b=function(o){return g[o]["proc"]};var l=function(o){var q=CryptoJS.lib.WordArray.random(o);var p=CryptoJS.enc.Hex.stringify(q);return p};var m=function(u){var v={};var p=u.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)","m"));if(p){v.cipher=p[1];v.ivsalt=p[2]}var o=u.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));if(o){v.type=o[1]}var t=-1;var w=0;if(u.indexOf("\r\n\r\n")!=-1){t=u.indexOf("\r\n\r\n");w=2}if(u.indexOf("\n\n")!=-1){t=u.indexOf("\n\n");w=1}var r=u.indexOf("-----END");if(t!=-1&&r!=-1){var q=u.substring(t+w*2,r-w);q=q.replace(/\s+/g,"");v.data=q}return v};var i=function(p,x,o){var u=o.substring(0,16);var s=CryptoJS.enc.Hex.parse(u);var q=CryptoJS.enc.Utf8.parse(x);var t=g[p]["keylen"]+g[p]["ivlen"];var w="";var v=null;for(;;){var r=CryptoJS.algo.MD5.create();if(v!=null){r.update(v)}r.update(q);r.update(s);v=r.finalize();w=w+CryptoJS.enc.Hex.stringify(v);if(w.length>=t*2){break}}var y={};y.keyhex=w.substr(0,g[p]["keylen"]*2);y.ivhex=w.substr(g[p]["keylen"]*2,g[p]["ivlen"]*2);return y};var a=function(o,u,q,v){var r=CryptoJS.enc.Base64.parse(o);var p=CryptoJS.enc.Hex.stringify(r);var t=g[u]["proc"];var s=t(p,q,v);return s};var f=function(o,r,p,t){var q=g[r]["eproc"];var s=q(o,p,t);return s};return{version:"1.0.5",getHexFromPEM:function(o,p){return ASN1HEX.pemToHex(o,p)},getDecryptedKeyHexByKeyIV:function(p,s,r,q){var o=b(s);return o(p,r,q)},parsePKCS5PEM:function(o){return m(o)},getKeyAndUnusedIvByPasscodeAndIvsalt:function(p,o,q){return i(p,o,q)},decryptKeyB64:function(o,q,p,r){return a(o,q,p,r)},getDecryptedKeyHex:function(x,w){var p=m(x);var s=p.type;var q=p.cipher;var o=p.ivsalt;var r=p.data;var v=i(q,w,o);var u=v.keyhex;var t=a(r,q,u,o);return t},getRSAKeyFromEncryptedPKCS5PEM:function(q,p){var r=this.getDecryptedKeyHex(q,p);var o=new RSAKey();o.readPrivateKeyFromASN1HexString(r);return o},getEncryptedPKCS5PEMFromPrvKeyHex:function(r,y,s,q){if(typeof s=="undefined"||s==null){s="AES-256-CBC"}if(typeof g[s]=="undefined"){throw"PKCS5PKEY unsupported algorithm: "+s}if(typeof q=="undefined"||q==null){var u=g[s]["ivlen"];var t=l(u);q=t.toUpperCase()}var x=i(s,y,q);var w=x.keyhex;var v=f(r,s,w,q);var p=v.replace(/(.{64})/g,"$1\r\n");var o="-----BEGIN RSA PRIVATE KEY-----\r\n";o+="Proc-Type: 4,ENCRYPTED\r\n";o+="DEK-Info: "+s+","+q+"\r\n";o+="\r\n";o+=p;o+="\r\n-----END RSA PRIVATE KEY-----\r\n";return o},getEncryptedPKCS5PEMFromRSAKey:function(C,D,o,s){var A=new KJUR.asn1.DERInteger({"int":0});var v=new KJUR.asn1.DERInteger({bigint:C.n});var z=new KJUR.asn1.DERInteger({"int":C.e});var B=new KJUR.asn1.DERInteger({bigint:C.d});var t=new KJUR.asn1.DERInteger({bigint:C.p});var r=new KJUR.asn1.DERInteger({bigint:C.q});var y=new KJUR.asn1.DERInteger({bigint:C.dmp1});var u=new KJUR.asn1.DERInteger({bigint:C.dmq1});var x=new KJUR.asn1.DERInteger({bigint:C.coeff});var E=new KJUR.asn1.DERSequence({array:[A,v,z,B,t,r,y,u,x]});var w=E.getEncodedHex();return this.getEncryptedPKCS5PEMFromPrvKeyHex(w,D,o,s)},newEncryptedPKCS5PEM:function(o,p,s,t){if(typeof p=="undefined"||p==null){p=1024}if(typeof s=="undefined"||s==null){s="10001"}var q=new RSAKey();q.generate(p,s);var r=null;if(typeof t=="undefined"||t==null){r=this.getEncryptedPKCS5PEMFromRSAKey(pkey,o)}else{r=this.getEncryptedPKCS5PEMFromRSAKey(pkey,o,t)}return r},getRSAKeyFromPlainPKCS8PEM:function(q){if(q.match(/ENCRYPTED/)){throw"pem shall be not ENCRYPTED"}var p=ASN1HEX.pemToHex(q,"PRIVATE KEY");var o=this.getRSAKeyFromPlainPKCS8Hex(p);return o},getRSAKeyFromPlainPKCS8Hex:function(p){var o=new RSAKey();o.readPKCS8PrvKeyHex(p);return o},parseHexOfEncryptedPKCS8:function(v){var r={};var q=ASN1HEX.getPosArrayOfChildren_AtObj(v,0);if(q.length!=2){throw"malformed format: SEQUENCE(0).items != 2: "+q.length}r.ciphertext=ASN1HEX.getHexOfV_AtObj(v,q[1]);var x=ASN1HEX.getPosArrayOfChildren_AtObj(v,q[0]);if(x.length!=2){throw"malformed format: SEQUENCE(0.0).items != 2: "+x.length}if(ASN1HEX.getHexOfV_AtObj(v,x[0])!="2a864886f70d01050d"){throw"this only supports pkcs5PBES2"}var o=ASN1HEX.getPosArrayOfChildren_AtObj(v,x[1]);if(x.length!=2){throw"malformed format: SEQUENCE(0.0.1).items != 2: "+o.length}var p=ASN1HEX.getPosArrayOfChildren_AtObj(v,o[1]);if(p.length!=2){throw"malformed format: SEQUENCE(0.0.1.1).items != 2: "+p.length}if(ASN1HEX.getHexOfV_AtObj(v,p[0])!="2a864886f70d0307"){throw"this only supports TripleDES"}r.encryptionSchemeAlg="TripleDES";r.encryptionSchemeIV=ASN1HEX.getHexOfV_AtObj(v,p[1]);var s=ASN1HEX.getPosArrayOfChildren_AtObj(v,o[0]);if(s.length!=2){throw"malformed format: SEQUENCE(0.0.1.0).items != 2: "+s.length}if(ASN1HEX.getHexOfV_AtObj(v,s[0])!="2a864886f70d01050c"){throw"this only supports pkcs5PBKDF2"}var w=ASN1HEX.getPosArrayOfChildren_AtObj(v,s[1]);if(w.length<2){throw"malformed format: SEQUENCE(0.0.1.0.1).items < 2: "+w.length}r.pbkdf2Salt=ASN1HEX.getHexOfV_AtObj(v,w[0]);var t=ASN1HEX.getHexOfV_AtObj(v,w[1]);try{r.pbkdf2Iter=parseInt(t,16)}catch(u){throw"malformed format pbkdf2Iter: "+t}return r},getPBKDF2KeyHexFromParam:function(t,o){var s=CryptoJS.enc.Hex.parse(t.pbkdf2Salt);var p=t.pbkdf2Iter;var r=CryptoJS.PBKDF2(o,s,{keySize:192/32,iterations:p});var q=CryptoJS.enc.Hex.stringify(r);return q},getPlainPKCS8HexFromEncryptedPKCS8PEM:function(w,x){var q=ASN1HEX.pemToHex(w,"ENCRYPTED PRIVATE KEY");var o=this.parseHexOfEncryptedPKCS8(q);var t=PKCS5PKEY.getPBKDF2KeyHexFromParam(o,x);var u={};u.ciphertext=CryptoJS.enc.Hex.parse(o.ciphertext);var s=CryptoJS.enc.Hex.parse(t);var r=CryptoJS.enc.Hex.parse(o.encryptionSchemeIV);var v=CryptoJS.TripleDES.decrypt(u,s,{iv:r});var p=CryptoJS.enc.Hex.stringify(v);return p},getRSAKeyFromEncryptedPKCS8PEM:function(r,q){var p=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(r,q);var o=this.getRSAKeyFromPlainPKCS8Hex(p);return o},getKeyFromEncryptedPKCS8PEM:function(r,p){var o=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(r,p);var q=this.getKeyFromPlainPrivatePKCS8Hex(o);return q},parsePlainPrivatePKCS8Hex:function(r){var p={};p.algparam=null;if(r.substr(0,2)!="30"){throw"malformed plain PKCS8 private key(code:001)"}var q=ASN1HEX.getPosArrayOfChildren_AtObj(r,0);if(q.length!=3){throw"malformed plain PKCS8 private key(code:002)"}if(r.substr(q[1],2)!="30"){throw"malformed PKCS8 private key(code:003)"}var o=ASN1HEX.getPosArrayOfChildren_AtObj(r,q[1]);if(o.length!=2){throw"malformed PKCS8 private key(code:004)"}if(r.substr(o[0],2)!="06"){throw"malformed PKCS8 private key(code:005)"}p.algoid=ASN1HEX.getHexOfV_AtObj(r,o[0]);if(r.substr(o[1],2)=="06"){p.algparam=ASN1HEX.getHexOfV_AtObj(r,o[1])}if(r.substr(q[2],2)!="04"){throw"malformed PKCS8 private key(code:006)"}p.keyidx=ASN1HEX.getStartPosOfV_AtObj(r,q[2]);return p},getKeyFromPlainPrivatePKCS8PEM:function(p){var o=ASN1HEX.pemToHex(p,"PRIVATE KEY");var q=this.getKeyFromPlainPrivatePKCS8Hex(o);return q},getKeyFromPlainPrivatePKCS8Hex:function(o){var p=this.parsePlainPrivatePKCS8Hex(o);var q;if(p.algoid=="2a864886f70d010101"){q=new RSAKey()}else{if(p.algoid=="2a8648ce380401"){q=new KJUR.crypto.DSA()}else{if(p.algoid=="2a8648ce3d0201"){q=new KJUR.crypto.ECDSA()}else{throw"unsupported private key algorithm"}}}q.readPKCS8PrvKeyHex(o);return q},getRSAKeyFromPublicPKCS8PEM:function(p){var q=ASN1HEX.pemToHex(p,"PUBLIC KEY");var o=this.getRSAKeyFromPublicPKCS8Hex(q);return o},getKeyFromPublicPKCS8PEM:function(p){var q=ASN1HEX.pemToHex(p,"PUBLIC KEY");var o=this.getKeyFromPublicPKCS8Hex(q);return o},getKeyFromPublicPKCS8Hex:function(o){var p;var q=ASN1HEX.getVbyList(h,0,[0,0],"06");if(q==="2a864886f70d010101"){p=new RSAKey()}else{if(q==="2a8648ce380401"){p=new KJUR.crypto.DSA()}else{if(q==="2a8648ce3d0201"){p=new KJUR.crypto.ECDSA()}else{throw"unsupported PKCS#8 public key hex"}}}p.readPKCS8PubKeyHex(h);return p},parsePublicRawRSAKeyHex:function(q){var o={};if(q.substr(0,2)!="30"){throw"malformed RSA key(code:001)"}var p=ASN1HEX.getPosArrayOfChildren_AtObj(q,0);if(p.length!=2){throw"malformed RSA key(code:002)"}if(q.substr(p[0],2)!="02"){throw"malformed RSA key(code:003)"}o.n=ASN1HEX.getHexOfV_AtObj(q,p[0]);if(q.substr(p[1],2)!="02"){throw"malformed RSA key(code:004)"}o.e=ASN1HEX.getHexOfV_AtObj(q,p[1]);return o},parsePrivateRawRSAKeyHexAtObj:function(p,r){var q=r.keyidx;if(p.substr(q,2)!="30"){throw"malformed RSA private key(code:001)"}var o=ASN1HEX.getPosArrayOfChildren_AtObj(p,q);if(o.length!=9){throw"malformed RSA private key(code:002)"}r.key={};r.key.n=ASN1HEX.getHexOfV_AtObj(p,o[1]);r.key.e=ASN1HEX.getHexOfV_AtObj(p,o[2]);r.key.d=ASN1HEX.getHexOfV_AtObj(p,o[3]);r.key.p=ASN1HEX.getHexOfV_AtObj(p,o[4]);r.key.q=ASN1HEX.getHexOfV_AtObj(p,o[5]);r.key.dp=ASN1HEX.getHexOfV_AtObj(p,o[6]);r.key.dq=ASN1HEX.getHexOfV_AtObj(p,o[7]);r.key.co=ASN1HEX.getHexOfV_AtObj(p,o[8])},parsePrivateRawECKeyHexAtObj:function(p,r){var q=r.keyidx;if(p.substr(q,2)!="30"){throw"malformed ECC private key(code:001)"}var o=ASN1HEX.getPosArrayOfChildren_AtObj(p,q);if(o.length!=3){throw"malformed ECC private key(code:002)"}if(p.substr(o[1],2)!="04"){throw"malformed ECC private key(code:003)"}r.key=ASN1HEX.getHexOfV_AtObj(p,o[1])},parsePublicPKCS8Hex:function(r){var p={};p.algparam=null;var q=ASN1HEX.getPosArrayOfChildren_AtObj(r,0);if(q.length!=2){throw"outer DERSequence shall have 2 elements: "+q.length}var s=q[0];if(r.substr(s,2)!="30"){throw"malformed PKCS8 public key(code:001)"}var o=ASN1HEX.getPosArrayOfChildren_AtObj(r,s);if(o.length!=2){throw"malformed PKCS8 public key(code:002)"}if(r.substr(o[0],2)!="06"){throw"malformed PKCS8 public key(code:003)"}p.algoid=ASN1HEX.getHexOfV_AtObj(r,o[0]);if(r.substr(o[1],2)=="06"){p.algparam=ASN1HEX.getHexOfV_AtObj(r,o[1])}if(r.substr(q[1],2)!="03"){throw"malformed PKCS8 public key(code:004)"}p.key=ASN1HEX.getHexOfV_AtObj(r,q[1]).substr(2);return p},getRSAKeyFromPublicPKCS8Hex:function(o){var p=new RSAKey();p.readPKCS8PubKeyHex(o);return p},}}();
	/*! keyutil-1.0.15.js (c) 2013-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	var KEYUTIL=function(){var d=function(p,r,q){return k(CryptoJS.AES,p,r,q)};var e=function(p,r,q){return k(CryptoJS.TripleDES,p,r,q)};var a=function(p,r,q){return k(CryptoJS.DES,p,r,q)};var k=function(s,x,u,q){var r=CryptoJS.enc.Hex.parse(x);var w=CryptoJS.enc.Hex.parse(u);var p=CryptoJS.enc.Hex.parse(q);var t={};t.key=w;t.iv=p;t.ciphertext=r;var v=s.decrypt(t,w,{iv:p});return CryptoJS.enc.Hex.stringify(v)};var l=function(p,r,q){return g(CryptoJS.AES,p,r,q)};var o=function(p,r,q){return g(CryptoJS.TripleDES,p,r,q)};var f=function(p,r,q){return g(CryptoJS.DES,p,r,q)};var g=function(t,y,v,q){var s=CryptoJS.enc.Hex.parse(y);var x=CryptoJS.enc.Hex.parse(v);var p=CryptoJS.enc.Hex.parse(q);var w=t.encrypt(s,x,{iv:p});var r=CryptoJS.enc.Hex.parse(w.toString());var u=CryptoJS.enc.Base64.stringify(r);return u};var i={"AES-256-CBC":{proc:d,eproc:l,keylen:32,ivlen:16},"AES-192-CBC":{proc:d,eproc:l,keylen:24,ivlen:16},"AES-128-CBC":{proc:d,eproc:l,keylen:16,ivlen:16},"DES-EDE3-CBC":{proc:e,eproc:o,keylen:24,ivlen:8},"DES-CBC":{proc:a,eproc:f,keylen:8,ivlen:8}};var c=function(p){return i[p]["proc"]};var m=function(p){var r=CryptoJS.lib.WordArray.random(p);var q=CryptoJS.enc.Hex.stringify(r);return q};var n=function(v){var w={};var q=v.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)","m"));if(q){w.cipher=q[1];w.ivsalt=q[2]}var p=v.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));if(p){w.type=p[1]}var u=-1;var x=0;if(v.indexOf("\r\n\r\n")!=-1){u=v.indexOf("\r\n\r\n");x=2}if(v.indexOf("\n\n")!=-1){u=v.indexOf("\n\n");x=1}var t=v.indexOf("-----END");if(u!=-1&&t!=-1){var r=v.substring(u+x*2,t-x);r=r.replace(/\s+/g,"");w.data=r}return w};var j=function(q,y,p){var v=p.substring(0,16);var t=CryptoJS.enc.Hex.parse(v);var r=CryptoJS.enc.Utf8.parse(y);var u=i[q]["keylen"]+i[q]["ivlen"];var x="";var w=null;for(;;){var s=CryptoJS.algo.MD5.create();if(w!=null){s.update(w)}s.update(r);s.update(t);w=s.finalize();x=x+CryptoJS.enc.Hex.stringify(w);if(x.length>=u*2){break}}var z={};z.keyhex=x.substr(0,i[q]["keylen"]*2);z.ivhex=x.substr(i[q]["keylen"]*2,i[q]["ivlen"]*2);return z};var b=function(p,v,r,w){var s=CryptoJS.enc.Base64.parse(p);var q=CryptoJS.enc.Hex.stringify(s);var u=i[v]["proc"];var t=u(q,r,w);return t};var h=function(p,s,q,u){var r=i[s]["eproc"];var t=r(p,q,u);return t};return{version:"1.0.0",getHexFromPEM:function(p,q){return ASN1HEX.pemToHex(p,q)},getDecryptedKeyHexByKeyIV:function(q,t,s,r){var p=c(t);return p(q,s,r)},parsePKCS5PEM:function(p){return n(p)},getKeyAndUnusedIvByPasscodeAndIvsalt:function(q,p,r){return j(q,p,r)},decryptKeyB64:function(p,r,q,s){return b(p,r,q,s)},getDecryptedKeyHex:function(y,x){var q=n(y);var t=q.type;var r=q.cipher;var p=q.ivsalt;var s=q.data;var w=j(r,x,p);var v=w.keyhex;var u=b(s,r,v,p);return u},getRSAKeyFromEncryptedPKCS5PEM:function(r,q){var s=this.getDecryptedKeyHex(r,q);var p=new RSAKey();p.readPrivateKeyFromASN1HexString(s);return p},getEncryptedPKCS5PEMFromPrvKeyHex:function(x,s,A,t,r){var p="";if(typeof t=="undefined"||t==null){t="AES-256-CBC"}if(typeof i[t]=="undefined"){throw"KEYUTIL unsupported algorithm: "+t}if(typeof r=="undefined"||r==null){var v=i[t]["ivlen"];var u=m(v);r=u.toUpperCase()}var z=j(t,A,r);var y=z.keyhex;var w=h(s,t,y,r);var q=w.replace(/(.{64})/g,"$1\r\n");var p="-----BEGIN "+x+" PRIVATE KEY-----\r\n";p+="Proc-Type: 4,ENCRYPTED\r\n";p+="DEK-Info: "+t+","+r+"\r\n";p+="\r\n";p+=q;p+="\r\n-----END "+x+" PRIVATE KEY-----\r\n";return p},getEncryptedPKCS5PEMFromRSAKey:function(D,E,r,t){var B=new KJUR.asn1.DERInteger({"int":0});var w=new KJUR.asn1.DERInteger({bigint:D.n});var A=new KJUR.asn1.DERInteger({"int":D.e});var C=new KJUR.asn1.DERInteger({bigint:D.d});var u=new KJUR.asn1.DERInteger({bigint:D.p});var s=new KJUR.asn1.DERInteger({bigint:D.q});var z=new KJUR.asn1.DERInteger({bigint:D.dmp1});var v=new KJUR.asn1.DERInteger({bigint:D.dmq1});var y=new KJUR.asn1.DERInteger({bigint:D.coeff});var F=new KJUR.asn1.DERSequence({array:[B,w,A,C,u,s,z,v,y]});var x=F.getEncodedHex();return this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA",x,E,r,t)},newEncryptedPKCS5PEM:function(p,q,t,u){if(typeof q=="undefined"||q==null){q=1024}if(typeof t=="undefined"||t==null){t="10001"}var r=new RSAKey();r.generate(q,t);var s=null;if(typeof u=="undefined"||u==null){s=this.getEncryptedPKCS5PEMFromRSAKey(r,p)}else{s=this.getEncryptedPKCS5PEMFromRSAKey(r,p,u)}return s},getRSAKeyFromPlainPKCS8PEM:function(r){if(r.match(/ENCRYPTED/)){throw"pem shall be not ENCRYPTED"}var q=ASN1HEX.pemToHex(r,"PRIVATE KEY");var p=this.getRSAKeyFromPlainPKCS8Hex(q);return p},getRSAKeyFromPlainPKCS8Hex:function(q){var p=new RSAKey();p.readPKCS8PrvKeyHex(q);return p},parseHexOfEncryptedPKCS8:function(w){var s={};var r=ASN1HEX.getPosArrayOfChildren_AtObj(w,0);if(r.length!=2){throw"malformed format: SEQUENCE(0).items != 2: "+r.length}s.ciphertext=ASN1HEX.getHexOfV_AtObj(w,r[1]);var y=ASN1HEX.getPosArrayOfChildren_AtObj(w,r[0]);if(y.length!=2){throw"malformed format: SEQUENCE(0.0).items != 2: "+y.length}if(ASN1HEX.getHexOfV_AtObj(w,y[0])!="2a864886f70d01050d"){throw"this only supports pkcs5PBES2"}var p=ASN1HEX.getPosArrayOfChildren_AtObj(w,y[1]);if(y.length!=2){throw"malformed format: SEQUENCE(0.0.1).items != 2: "+p.length}var q=ASN1HEX.getPosArrayOfChildren_AtObj(w,p[1]);if(q.length!=2){throw"malformed format: SEQUENCE(0.0.1.1).items != 2: "+q.length}if(ASN1HEX.getHexOfV_AtObj(w,q[0])!="2a864886f70d0307"){throw"this only supports TripleDES"}s.encryptionSchemeAlg="TripleDES";s.encryptionSchemeIV=ASN1HEX.getHexOfV_AtObj(w,q[1]);var t=ASN1HEX.getPosArrayOfChildren_AtObj(w,p[0]);if(t.length!=2){throw"malformed format: SEQUENCE(0.0.1.0).items != 2: "+t.length}if(ASN1HEX.getHexOfV_AtObj(w,t[0])!="2a864886f70d01050c"){throw"this only supports pkcs5PBKDF2"}var x=ASN1HEX.getPosArrayOfChildren_AtObj(w,t[1]);if(x.length<2){throw"malformed format: SEQUENCE(0.0.1.0.1).items < 2: "+x.length}s.pbkdf2Salt=ASN1HEX.getHexOfV_AtObj(w,x[0]);var u=ASN1HEX.getHexOfV_AtObj(w,x[1]);try{s.pbkdf2Iter=parseInt(u,16)}catch(v){throw"malformed format pbkdf2Iter: "+u}return s},getPBKDF2KeyHexFromParam:function(u,p){var t=CryptoJS.enc.Hex.parse(u.pbkdf2Salt);var q=u.pbkdf2Iter;var s=CryptoJS.PBKDF2(p,t,{keySize:192/32,iterations:q});var r=CryptoJS.enc.Hex.stringify(s);return r},getPlainPKCS8HexFromEncryptedPKCS8PEM:function(x,y){var r=ASN1HEX.pemToHex(x,"ENCRYPTED PRIVATE KEY");var p=this.parseHexOfEncryptedPKCS8(r);var u=KEYUTIL.getPBKDF2KeyHexFromParam(p,y);var v={};v.ciphertext=CryptoJS.enc.Hex.parse(p.ciphertext);var t=CryptoJS.enc.Hex.parse(u);var s=CryptoJS.enc.Hex.parse(p.encryptionSchemeIV);var w=CryptoJS.TripleDES.decrypt(v,t,{iv:s});var q=CryptoJS.enc.Hex.stringify(w);return q},getRSAKeyFromEncryptedPKCS8PEM:function(s,r){var q=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(s,r);var p=this.getRSAKeyFromPlainPKCS8Hex(q);return p},getKeyFromEncryptedPKCS8PEM:function(s,q){var p=this.getPlainPKCS8HexFromEncryptedPKCS8PEM(s,q);var r=this.getKeyFromPlainPrivatePKCS8Hex(p);return r},parsePlainPrivatePKCS8Hex:function(s){var q={};q.algparam=null;if(s.substr(0,2)!="30"){throw"malformed plain PKCS8 private key(code:001)"}var r=ASN1HEX.getPosArrayOfChildren_AtObj(s,0);if(r.length!=3){throw"malformed plain PKCS8 private key(code:002)"}if(s.substr(r[1],2)!="30"){throw"malformed PKCS8 private key(code:003)"}var p=ASN1HEX.getPosArrayOfChildren_AtObj(s,r[1]);if(p.length!=2){throw"malformed PKCS8 private key(code:004)"}if(s.substr(p[0],2)!="06"){throw"malformed PKCS8 private key(code:005)"}q.algoid=ASN1HEX.getHexOfV_AtObj(s,p[0]);if(s.substr(p[1],2)=="06"){q.algparam=ASN1HEX.getHexOfV_AtObj(s,p[1])}if(s.substr(r[2],2)!="04"){throw"malformed PKCS8 private key(code:006)"}q.keyidx=ASN1HEX.getStartPosOfV_AtObj(s,r[2]);return q},getKeyFromPlainPrivatePKCS8PEM:function(q){var p=ASN1HEX.pemToHex(q,"PRIVATE KEY");var r=this.getKeyFromPlainPrivatePKCS8Hex(p);return r},getKeyFromPlainPrivatePKCS8Hex:function(p){var q=this.parsePlainPrivatePKCS8Hex(p);var r;if(q.algoid=="2a864886f70d010101"){r=new RSAKey()}else{if(q.algoid=="2a8648ce380401"){r=new KJUR.crypto.DSA()}else{if(q.algoid=="2a8648ce3d0201"){r=new KJUR.crypto.ECDSA()}else{throw"unsupported private key algorithm"}}}r.readPKCS8PrvKeyHex(p);return r},getRSAKeyFromPublicPKCS8PEM:function(q){var r=ASN1HEX.pemToHex(q,"PUBLIC KEY");var p=this.getRSAKeyFromPublicPKCS8Hex(r);return p},getKeyFromPublicPKCS8PEM:function(q){var r=ASN1HEX.pemToHex(q,"PUBLIC KEY");var p=this.getKeyFromPublicPKCS8Hex(r);return p},getKeyFromPublicPKCS8Hex:function(q){var p;var r=ASN1HEX.getVbyList(q,0,[0,0],"06");if(r==="2a864886f70d010101"){p=new RSAKey()}else{if(r==="2a8648ce380401"){p=new KJUR.crypto.DSA()}else{if(r==="2a8648ce3d0201"){p=new KJUR.crypto.ECDSA()}else{throw"unsupported PKCS#8 public key hex"}}}p.readPKCS8PubKeyHex(q);return p},parsePublicRawRSAKeyHex:function(r){var p={};if(r.substr(0,2)!="30"){throw"malformed RSA key(code:001)"}var q=ASN1HEX.getPosArrayOfChildren_AtObj(r,0);if(q.length!=2){throw"malformed RSA key(code:002)"}if(r.substr(q[0],2)!="02"){throw"malformed RSA key(code:003)"}p.n=ASN1HEX.getHexOfV_AtObj(r,q[0]);if(r.substr(q[1],2)!="02"){throw"malformed RSA key(code:004)"}p.e=ASN1HEX.getHexOfV_AtObj(r,q[1]);return p},parsePrivateRawRSAKeyHexAtObj:function(q,u){var t=ASN1HEX;var r=t.getHexOfV_AtObj;var s=t.getDecendantIndexByNthList(q,0,[2,0]);var p=t.getPosArrayOfChildren_AtObj(q,s);if(p.length!==9){throw"malformed PKCS#8 plain RSA private key"}u.key={};u.key.n=r(q,p[1]);u.key.e=r(q,p[2]);u.key.d=r(q,p[3]);u.key.p=r(q,p[4]);u.key.q=r(q,p[5]);u.key.dp=r(q,p[6]);u.key.dq=r(q,p[7]);u.key.co=r(q,p[8])},parsePrivateRawECKeyHexAtObj:function(p,t){var s=ASN1HEX;var q=t.keyidx;var r=new KJUR.crypto.ECDSA();r.readPKCS8PrvKeyHex(p);t.key=r.prvKeyHex;t.pubkey=r.pubKeyHex},parsePublicPKCS8Hex:function(s){var q={};q.algparam=null;var r=ASN1HEX.getPosArrayOfChildren_AtObj(s,0);if(r.length!=2){throw"outer DERSequence shall have 2 elements: "+r.length}var t=r[0];if(s.substr(t,2)!="30"){throw"malformed PKCS8 public key(code:001)"}var p=ASN1HEX.getPosArrayOfChildren_AtObj(s,t);if(p.length!=2){throw"malformed PKCS8 public key(code:002)"}if(s.substr(p[0],2)!="06"){throw"malformed PKCS8 public key(code:003)"}q.algoid=ASN1HEX.getHexOfV_AtObj(s,p[0]);if(s.substr(p[1],2)=="06"){q.algparam=ASN1HEX.getHexOfV_AtObj(s,p[1])}else{if(s.substr(p[1],2)=="30"){q.algparam={};q.algparam.p=ASN1HEX.getVbyList(s,p[1],[0],"02");q.algparam.q=ASN1HEX.getVbyList(s,p[1],[1],"02");q.algparam.g=ASN1HEX.getVbyList(s,p[1],[2],"02")}}if(s.substr(r[1],2)!="03"){throw"malformed PKCS8 public key(code:004)"}q.key=ASN1HEX.getHexOfV_AtObj(s,r[1]).substr(2);return q},getRSAKeyFromPublicPKCS8Hex:function(p){var q=new RSAKey();q.readPKCS8PubKeyHex(p);return q},}}();KEYUTIL.getKey=function(i,f,j){if(typeof RSAKey!="undefined"&&i instanceof RSAKey){return i}if(typeof KJUR.crypto.ECDSA!="undefined"&&i instanceof KJUR.crypto.ECDSA){return i}if(typeof KJUR.crypto.DSA!="undefined"&&i instanceof KJUR.crypto.DSA){return i}if(i.curve!==undefined&&i.xy!==undefined&&i.d===undefined){return new KJUR.crypto.ECDSA({pub:i.xy,curve:i.curve})}if(i.curve!==undefined&&i.d!==undefined){return new KJUR.crypto.ECDSA({prv:i.d,curve:i.curve})}if(i.kty===undefined&&i.n!==undefined&&i.e!==undefined&&i.d===undefined){var D=new RSAKey();D.setPublic(i.n,i.e);return D}if(i.kty===undefined&&i.n!==undefined&&i.e!==undefined&&i.d!==undefined&&i.p!==undefined&&i.q!==undefined&&i.dp!==undefined&&i.dq!==undefined&&i.co!==undefined&&i.qi===undefined){var D=new RSAKey();D.setPrivateEx(i.n,i.e,i.d,i.p,i.q,i.dp,i.dq,i.co);return D}if(i.kty===undefined&&i.n!==undefined&&i.e!==undefined&&i.d!==undefined&&i.p===undefined){var D=new RSAKey();D.setPrivate(i.n,i.e,i.d);return D}if(i.p!==undefined&&i.q!==undefined&&i.g!==undefined&&i.y!==undefined&&i.x===undefined){var D=new KJUR.crypto.DSA();D.setPublic(i.p,i.q,i.g,i.y);return D}if(i.p!==undefined&&i.q!==undefined&&i.g!==undefined&&i.y!==undefined&&i.x!==undefined){var D=new KJUR.crypto.DSA();D.setPrivate(i.p,i.q,i.g,i.y,i.x);return D}if(i.kty==="RSA"&&i.n!==undefined&&i.e!==undefined&&i.d===undefined){var D=new RSAKey();D.setPublic(b64utohex(i.n),b64utohex(i.e));return D}if(i.kty==="RSA"&&i.n!==undefined&&i.e!==undefined&&i.d!==undefined&&i.p!==undefined&&i.q!==undefined&&i.dp!==undefined&&i.dq!==undefined&&i.qi!==undefined){var D=new RSAKey();D.setPrivateEx(b64utohex(i.n),b64utohex(i.e),b64utohex(i.d),b64utohex(i.p),b64utohex(i.q),b64utohex(i.dp),b64utohex(i.dq),b64utohex(i.qi));return D}if(i.kty==="RSA"&&i.n!==undefined&&i.e!==undefined&&i.d!==undefined){var D=new RSAKey();D.setPrivate(b64utohex(i.n),b64utohex(i.e),b64utohex(i.d));return D}if(i.kty==="EC"&&i.crv!==undefined&&i.x!==undefined&&i.y!==undefined&&i.d===undefined){var e=new KJUR.crypto.ECDSA({curve:i.crv});var n=e.ecparams.keylen/4;var t=("0000000000"+b64utohex(i.x)).slice(-n);var r=("0000000000"+b64utohex(i.y)).slice(-n);var o="04"+t+r;e.setPublicKeyHex(o);return e}if(i.kty==="EC"&&i.crv!==undefined&&i.x!==undefined&&i.y!==undefined&&i.d!==undefined){var e=new KJUR.crypto.ECDSA({curve:i.crv});var n=e.ecparams.keylen/4;var t=("0000000000"+b64utohex(i.x)).slice(-n);var r=("0000000000"+b64utohex(i.y)).slice(-n);var o="04"+t+r;var b=("0000000000"+b64utohex(i.d)).slice(-n);e.setPublicKeyHex(o);e.setPrivateKeyHex(b);return e}if(j==="pkcs5prv"){var A=i,w=ASN1HEX,C,D;C=w.getPosArrayOfChildren_AtObj(A,0);if(C.length===9){D=new RSAKey();D.readPrivateKeyFromASN1HexString(i)}else{if(C.length===6){D=new KJUR.crypto.DSA();D.readPKCS5PrvKeyHex(A)}else{if(C.length>2&&A.substr(C[1],2)==="04"){D=new KJUR.crypto.ECDSA();D.readPKCS5PrvKeyHex(A)}else{throw"unsupported PKCS#1/5 hexadecimal key"}}}return D}if(j==="pkcs8prv"){var D=KEYUTIL.getKeyFromPlainPrivatePKCS8Hex(i);return D}if(j==="pkcs8pub"){return KEYUTIL.getKeyFromPublicPKCS8Hex(i)}if(j==="x509pub"){return X509.getPublicKeyFromCertHex(i)}if(i.indexOf("-END CERTIFICATE-",0)!=-1||i.indexOf("-END X509 CERTIFICATE-",0)!=-1||i.indexOf("-END TRUSTED CERTIFICATE-",0)!=-1){return X509.getPublicKeyFromCertPEM(i)}if(i.indexOf("-END PUBLIC KEY-")!=-1){return KEYUTIL.getKeyFromPublicPKCS8PEM(i)}if(i.indexOf("-END RSA PRIVATE KEY-")!=-1&&i.indexOf("4,ENCRYPTED")==-1){var k=ASN1HEX.pemToHex(i,"RSA PRIVATE KEY");return KEYUTIL.getKey(k,null,"pkcs5prv")}if(i.indexOf("-END DSA PRIVATE KEY-")!=-1&&i.indexOf("4,ENCRYPTED")==-1){var z=ASN1HEX.pemToHex(i,"DSA PRIVATE KEY");var v=ASN1HEX.getVbyList(z,0,[1],"02");var u=ASN1HEX.getVbyList(z,0,[2],"02");var B=ASN1HEX.getVbyList(z,0,[3],"02");var l=ASN1HEX.getVbyList(z,0,[4],"02");var m=ASN1HEX.getVbyList(z,0,[5],"02");var D=new KJUR.crypto.DSA();D.setPrivate(new BigInteger(v,16),new BigInteger(u,16),new BigInteger(B,16),new BigInteger(l,16),new BigInteger(m,16));return D}if(i.indexOf("-END PRIVATE KEY-")!=-1){return KEYUTIL.getKeyFromPlainPrivatePKCS8PEM(i)}if(i.indexOf("-END RSA PRIVATE KEY-")!=-1&&i.indexOf("4,ENCRYPTED")!=-1){return KEYUTIL.getRSAKeyFromEncryptedPKCS5PEM(i,f)}if(i.indexOf("-END EC PRIVATE KEY-")!=-1&&i.indexOf("4,ENCRYPTED")!=-1){var z=KEYUTIL.getDecryptedKeyHex(i,f);var D=ASN1HEX.getVbyList(z,0,[1],"04");var d=ASN1HEX.getVbyList(z,0,[2,0],"06");var s=ASN1HEX.getVbyList(z,0,[3,0],"03").substr(2);var c="";if(KJUR.crypto.OID.oidhex2name[d]!==undefined){c=KJUR.crypto.OID.oidhex2name[d]}else{throw"undefined OID(hex) in KJUR.crypto.OID: "+d}var e=new KJUR.crypto.ECDSA({curve:c});e.setPublicKeyHex(s);e.setPrivateKeyHex(D);e.isPublic=false;return e}if(i.indexOf("-END DSA PRIVATE KEY-")!=-1&&i.indexOf("4,ENCRYPTED")!=-1){var z=KEYUTIL.getDecryptedKeyHex(i,f);var v=ASN1HEX.getVbyList(z,0,[1],"02");var u=ASN1HEX.getVbyList(z,0,[2],"02");var B=ASN1HEX.getVbyList(z,0,[3],"02");var l=ASN1HEX.getVbyList(z,0,[4],"02");var m=ASN1HEX.getVbyList(z,0,[5],"02");var D=new KJUR.crypto.DSA();D.setPrivate(new BigInteger(v,16),new BigInteger(u,16),new BigInteger(B,16),new BigInteger(l,16),new BigInteger(m,16));return D}if(i.indexOf("-END ENCRYPTED PRIVATE KEY-")!=-1){return KEYUTIL.getKeyFromEncryptedPKCS8PEM(i,f)}throw"not supported argument"};KEYUTIL.generateKeypair=function(a,c){if(a=="RSA"){var b=c;var h=new RSAKey();h.generate(b,"10001");h.isPrivate=true;h.isPublic=true;var f=new RSAKey();var e=h.n.toString(16);var i=h.e.toString(16);f.setPublic(e,i);f.isPrivate=false;f.isPublic=true;var k={};k.prvKeyObj=h;k.pubKeyObj=f;return k}else{if(a=="EC"){var d=c;var g=new KJUR.crypto.ECDSA({curve:d});var j=g.generateKeyPairHex();var h=new KJUR.crypto.ECDSA({curve:d});h.setPublicKeyHex(j.ecpubhex);h.setPrivateKeyHex(j.ecprvhex);h.isPrivate=true;h.isPublic=false;var f=new KJUR.crypto.ECDSA({curve:d});f.setPublicKeyHex(j.ecpubhex);f.isPrivate=false;f.isPublic=true;var k={};k.prvKeyObj=h;k.pubKeyObj=f;return k}else{throw"unknown algorithm: "+a}}};KEYUTIL.getPEM=function(a,r,o,g,j){var v=KJUR.asn1;var u=KJUR.crypto;function p(s){var w=KJUR.asn1.ASN1Util.newObject({seq:[{"int":0},{"int":{bigint:s.n}},{"int":s.e},{"int":{bigint:s.d}},{"int":{bigint:s.p}},{"int":{bigint:s.q}},{"int":{bigint:s.dmp1}},{"int":{bigint:s.dmq1}},{"int":{bigint:s.coeff}}]});return w}function q(w){var s=KJUR.asn1.ASN1Util.newObject({seq:[{"int":1},{octstr:{hex:w.prvKeyHex}},{tag:["a0",true,{oid:{name:w.curveName}}]},{tag:["a1",true,{bitstr:{hex:"00"+w.pubKeyHex}}]}]});return s}function n(s){var w=KJUR.asn1.ASN1Util.newObject({seq:[{"int":0},{"int":{bigint:s.p}},{"int":{bigint:s.q}},{"int":{bigint:s.g}},{"int":{bigint:s.y}},{"int":{bigint:s.x}}]});return w}if(((typeof RSAKey!="undefined"&&a instanceof RSAKey)||(typeof u.DSA!="undefined"&&a instanceof u.DSA)||(typeof u.ECDSA!="undefined"&&a instanceof u.ECDSA))&&a.isPublic==true&&(r===undefined||r=="PKCS8PUB")){var t=new KJUR.asn1.x509.SubjectPublicKeyInfo(a);var m=t.getEncodedHex();return v.ASN1Util.getPEMStringFromHex(m,"PUBLIC KEY")}if(r=="PKCS1PRV"&&typeof RSAKey!="undefined"&&a instanceof RSAKey&&(o===undefined||o==null)&&a.isPrivate==true){var t=p(a);var m=t.getEncodedHex();return v.ASN1Util.getPEMStringFromHex(m,"RSA PRIVATE KEY")}if(r=="PKCS1PRV"&&typeof RSAKey!="undefined"&&a instanceof KJUR.crypto.ECDSA&&(o===undefined||o==null)&&a.isPrivate==true){var f=new KJUR.asn1.DERObjectIdentifier({name:a.curveName});var l=f.getEncodedHex();var e=q(a);var k=e.getEncodedHex();var i="";i+=v.ASN1Util.getPEMStringFromHex(l,"EC PARAMETERS");i+=v.ASN1Util.getPEMStringFromHex(k,"EC PRIVATE KEY");return i}if(r=="PKCS1PRV"&&typeof KJUR.crypto.DSA!="undefined"&&a instanceof KJUR.crypto.DSA&&(o===undefined||o==null)&&a.isPrivate==true){var t=n(a);var m=t.getEncodedHex();return v.ASN1Util.getPEMStringFromHex(m,"DSA PRIVATE KEY")}if(r=="PKCS5PRV"&&typeof RSAKey!="undefined"&&a instanceof RSAKey&&(o!==undefined&&o!=null)&&a.isPrivate==true){var t=p(a);var m=t.getEncodedHex();if(g===undefined){g="DES-EDE3-CBC"}return this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA",m,o,g)}if(r=="PKCS5PRV"&&typeof KJUR.crypto.ECDSA!="undefined"&&a instanceof KJUR.crypto.ECDSA&&(o!==undefined&&o!=null)&&a.isPrivate==true){var t=q(a);var m=t.getEncodedHex();if(g===undefined){g="DES-EDE3-CBC"}return this.getEncryptedPKCS5PEMFromPrvKeyHex("EC",m,o,g)}if(r=="PKCS5PRV"&&typeof KJUR.crypto.DSA!="undefined"&&a instanceof KJUR.crypto.DSA&&(o!==undefined&&o!=null)&&a.isPrivate==true){var t=n(a);var m=t.getEncodedHex();if(g===undefined){g="DES-EDE3-CBC"}return this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA",m,o,g)}var h=function(w,s){var y=b(w,s);var x=new KJUR.asn1.ASN1Util.newObject({seq:[{seq:[{oid:{name:"pkcs5PBES2"}},{seq:[{seq:[{oid:{name:"pkcs5PBKDF2"}},{seq:[{octstr:{hex:y.pbkdf2Salt}},{"int":y.pbkdf2Iter}]}]},{seq:[{oid:{name:"des-EDE3-CBC"}},{octstr:{hex:y.encryptionSchemeIV}}]}]}]},{octstr:{hex:y.ciphertext}}]});return x.getEncodedHex()};var b=function(D,E){var x=100;var C=CryptoJS.lib.WordArray.random(8);var B="DES-EDE3-CBC";var s=CryptoJS.lib.WordArray.random(8);var y=CryptoJS.PBKDF2(E,C,{keySize:192/32,iterations:x});var z=CryptoJS.enc.Hex.parse(D);var A=CryptoJS.TripleDES.encrypt(z,y,{iv:s})+"";var w={};w.ciphertext=A;w.pbkdf2Salt=CryptoJS.enc.Hex.stringify(C);w.pbkdf2Iter=x;w.encryptionSchemeAlg=B;w.encryptionSchemeIV=CryptoJS.enc.Hex.stringify(s);return w};if(r=="PKCS8PRV"&&typeof RSAKey!="undefined"&&a instanceof RSAKey&&a.isPrivate==true){var d=p(a);var c=d.getEncodedHex();var t=KJUR.asn1.ASN1Util.newObject({seq:[{"int":0},{seq:[{oid:{name:"rsaEncryption"}},{"null":true}]},{octstr:{hex:c}}]});var m=t.getEncodedHex();if(o===undefined||o==null){return v.ASN1Util.getPEMStringFromHex(m,"PRIVATE KEY")}else{var k=h(m,o);return v.ASN1Util.getPEMStringFromHex(k,"ENCRYPTED PRIVATE KEY")}}if(r=="PKCS8PRV"&&typeof KJUR.crypto.ECDSA!="undefined"&&a instanceof KJUR.crypto.ECDSA&&a.isPrivate==true){var d=new KJUR.asn1.ASN1Util.newObject({seq:[{"int":1},{octstr:{hex:a.prvKeyHex}},{tag:["a1",true,{bitstr:{hex:"00"+a.pubKeyHex}}]}]});var c=d.getEncodedHex();var t=KJUR.asn1.ASN1Util.newObject({seq:[{"int":0},{seq:[{oid:{name:"ecPublicKey"}},{oid:{name:a.curveName}}]},{octstr:{hex:c}}]});var m=t.getEncodedHex();if(o===undefined||o==null){return v.ASN1Util.getPEMStringFromHex(m,"PRIVATE KEY")}else{var k=h(m,o);return v.ASN1Util.getPEMStringFromHex(k,"ENCRYPTED PRIVATE KEY")}}if(r=="PKCS8PRV"&&typeof KJUR.crypto.DSA!="undefined"&&a instanceof KJUR.crypto.DSA&&a.isPrivate==true){var d=new KJUR.asn1.DERInteger({bigint:a.x});var c=d.getEncodedHex();var t=KJUR.asn1.ASN1Util.newObject({seq:[{"int":0},{seq:[{oid:{name:"dsa"}},{seq:[{"int":{bigint:a.p}},{"int":{bigint:a.q}},{"int":{bigint:a.g}}]}]},{octstr:{hex:c}}]});var m=t.getEncodedHex();if(o===undefined||o==null){return v.ASN1Util.getPEMStringFromHex(m,"PRIVATE KEY")}else{var k=h(m,o);return v.ASN1Util.getPEMStringFromHex(k,"ENCRYPTED PRIVATE KEY")}}throw"unsupported object nor format"};KEYUTIL.getKeyFromCSRPEM=function(b){var a=ASN1HEX.pemToHex(b,"CERTIFICATE REQUEST");var c=KEYUTIL.getKeyFromCSRHex(a);return c};KEYUTIL.getKeyFromCSRHex=function(a){var c=KEYUTIL.parseCSRHex(a);var b=KEYUTIL.getKey(c.p8pubkeyhex,null,"pkcs8pub");return b};KEYUTIL.parseCSRHex=function(c){var b={};var e=c;if(e.substr(0,2)!="30"){throw"malformed CSR(code:001)"}var d=ASN1HEX.getPosArrayOfChildren_AtObj(e,0);if(d.length<1){throw"malformed CSR(code:002)"}if(e.substr(d[0],2)!="30"){throw"malformed CSR(code:003)"}var a=ASN1HEX.getPosArrayOfChildren_AtObj(e,d[0]);if(a.length<3){throw"malformed CSR(code:004)"}b.p8pubkeyhex=ASN1HEX.getHexOfTLV_AtObj(e,a[2]);return b};KEYUTIL.getJWKFromKey=function(d){var b={};if(d instanceof RSAKey&&d.isPrivate){b.kty="RSA";b.n=hextob64u(d.n.toString(16));b.e=hextob64u(d.e.toString(16));b.d=hextob64u(d.d.toString(16));b.p=hextob64u(d.p.toString(16));b.q=hextob64u(d.q.toString(16));b.dp=hextob64u(d.dmp1.toString(16));b.dq=hextob64u(d.dmq1.toString(16));b.qi=hextob64u(d.coeff.toString(16));return b}else{if(d instanceof RSAKey&&d.isPublic){b.kty="RSA";b.n=hextob64u(d.n.toString(16));b.e=hextob64u(d.e.toString(16));return b}else{if(d instanceof KJUR.crypto.ECDSA&&d.isPrivate){var a=d.getShortNISTPCurveName();if(a!=="P-256"&&a!=="P-384"){throw"unsupported curve name for JWT: "+a}var c=d.getPublicKeyXYHex();b.kty="EC";b.crv=a;b.x=hextob64u(c.x);b.y=hextob64u(c.y);b.d=hextob64u(d.prvKeyHex);return b}else{if(d instanceof KJUR.crypto.ECDSA&&d.isPublic){var a=d.getShortNISTPCurveName();if(a!=="P-256"&&a!=="P-384"){throw"unsupported curve name for JWT: "+a}var c=d.getPublicKeyXYHex();b.kty="EC";b.crv=a;b.x=hextob64u(c.x);b.y=hextob64u(c.y);return b}}}}throw"not supported key object"};
	/*! rsapem-1.2.0.js (c) 2012-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	RSAKey.pemToBase64=function(b){var a=b;a=a.replace("-----BEGIN RSA PRIVATE KEY-----","");a=a.replace("-----END RSA PRIVATE KEY-----","");a=a.replace(/[ \n]+/g,"");return a};RSAKey.getPosArrayOfChildrenFromHex=function(g){var j=new Array();var i=ASN1HEX.getStartPosOfV_AtObj(g,0);var b=ASN1HEX.getPosOfNextSibling_AtObj(g,i);var e=ASN1HEX.getPosOfNextSibling_AtObj(g,b);var f=ASN1HEX.getPosOfNextSibling_AtObj(g,e);var l=ASN1HEX.getPosOfNextSibling_AtObj(g,f);var k=ASN1HEX.getPosOfNextSibling_AtObj(g,l);var d=ASN1HEX.getPosOfNextSibling_AtObj(g,k);var c=ASN1HEX.getPosOfNextSibling_AtObj(g,d);var h=ASN1HEX.getPosOfNextSibling_AtObj(g,c);j.push(i,b,e,f,l,k,d,c,h);return j};RSAKey.getHexValueArrayOfChildrenFromHex=function(f){var l=RSAKey.getPosArrayOfChildrenFromHex(f);var e=ASN1HEX.getHexOfV_AtObj(f,l[0]);var j=ASN1HEX.getHexOfV_AtObj(f,l[1]);var b=ASN1HEX.getHexOfV_AtObj(f,l[2]);var c=ASN1HEX.getHexOfV_AtObj(f,l[3]);var h=ASN1HEX.getHexOfV_AtObj(f,l[4]);var g=ASN1HEX.getHexOfV_AtObj(f,l[5]);var m=ASN1HEX.getHexOfV_AtObj(f,l[6]);var k=ASN1HEX.getHexOfV_AtObj(f,l[7]);var d=ASN1HEX.getHexOfV_AtObj(f,l[8]);var i=new Array();i.push(e,j,b,c,h,g,m,k,d);return i};RSAKey.prototype.readPrivateKeyFromPEMString=function(e){var c=RSAKey.pemToBase64(e);var d=b64tohex(c);var b=RSAKey.getHexValueArrayOfChildrenFromHex(d);this.setPrivateEx(b[1],b[2],b[3],b[4],b[5],b[6],b[7],b[8])};RSAKey.prototype.readPrivateKeyFromASN1HexString=function(a){this.readPKCS5PrvKeyHex(a)};RSAKey.prototype.readPKCS5PrvKeyHex=function(c){var b=RSAKey.getHexValueArrayOfChildrenFromHex(c);this.setPrivateEx(b[1],b[2],b[3],b[4],b[5],b[6],b[7],b[8])};RSAKey.prototype.readPKCS8PrvKeyHex=function(e){var c,j,l,b,a,f,d,k;var m=ASN1HEX;var g=m.getVbyList;if(m.isASN1HEX(e)===false){throw"not ASN.1 hex string"}try{c=g(e,0,[2,0,1],"02");j=g(e,0,[2,0,2],"02");l=g(e,0,[2,0,3],"02");b=g(e,0,[2,0,4],"02");a=g(e,0,[2,0,5],"02");f=g(e,0,[2,0,6],"02");d=g(e,0,[2,0,7],"02");k=g(e,0,[2,0,8],"02")}catch(i){throw"malformed PKCS#8 plain RSA private key"}this.setPrivateEx(c,j,l,b,a,f,d,k)};RSAKey.prototype.readPKCS5PubKeyHex=function(b){if(ASN1HEX.isASN1HEX(b)===false){throw"keyHex is not ASN.1 hex string"}var a=ASN1HEX.getPosArrayOfChildren_AtObj(b,0);if(a.length!==2||b.substr(a[0],2)!=="02"||b.substr(a[1],2)!=="02"){throw"wrong hex for PKCS#5 public key"}var d=ASN1HEX.getHexOfV_AtObj(b,a[0]);var c=ASN1HEX.getHexOfV_AtObj(b,a[1]);this.setPublic(d,c)};RSAKey.prototype.readPKCS8PubKeyHex=function(b){if(ASN1HEX.isASN1HEX(b)===false){throw"not ASN.1 hex string"}if(ASN1HEX.getDecendantHexTLVByNthList(b,0,[0,0])!=="06092a864886f70d010101"){throw"not PKCS8 RSA public key"}var a=ASN1HEX.getDecendantHexTLVByNthList(b,0,[1,0]);this.readPKCS5PubKeyHex(a)};RSAKey.prototype.readCertPubKeyHex=function(b,c){if(c!==5){c=6}if(ASN1HEX.isASN1HEX(b)===false){throw"not ASN.1 hex string"}var a=ASN1HEX.getDecendantHexTLVByNthList(b,0,[0,c]);this.readPKCS8PubKeyHex(a)};
	/*! rsasign-1.2.7.js (c) 2012 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	var _RE_HEXDECONLY=new RegExp("");_RE_HEXDECONLY.compile("[^0-9a-f]","gi");function _rsasign_getHexPaddedDigestInfoForString(d,e,a){var b=function(f){return KJUR.crypto.Util.hashString(f,a)};var c=b(d);return KJUR.crypto.Util.getPaddedDigestInfoHex(c,a,e)}function _zeroPaddingOfSignature(e,d){var c="";var a=d/4-e.length;for(var b=0;b<a;b++){c=c+"0"}return c+e}function _rsasign_signString(d,a){var b=function(e){return KJUR.crypto.Util.hashString(e,a)};var c=b(d);return this.signWithMessageHash(c,a)}function _rsasign_signWithMessageHash(e,c){var f=KJUR.crypto.Util.getPaddedDigestInfoHex(e,c,this.n.bitLength());var b=parseBigInt(f,16);var d=this.doPrivate(b);var a=d.toString(16);return _zeroPaddingOfSignature(a,this.n.bitLength())}function _rsasign_signStringWithSHA1(a){return _rsasign_signString.call(this,a,"sha1")}function _rsasign_signStringWithSHA256(a){return _rsasign_signString.call(this,a,"sha256")}function pss_mgf1_str(c,a,e){var b="",d=0;while(b.length<a){b+=hextorstr(e(rstrtohex(c+String.fromCharCode.apply(String,[(d&4278190080)>>24,(d&16711680)>>16,(d&65280)>>8,d&255]))));d+=1}return b}function _rsasign_signStringPSS(e,a,d){var c=function(f){return KJUR.crypto.Util.hashHex(f,a)};var b=c(rstrtohex(e));if(d===undefined){d=-1}return this.signWithMessageHashPSS(b,a,d)}function _rsasign_signWithMessageHashPSS(l,a,k){var b=hextorstr(l);var g=b.length;var m=this.n.bitLength()-1;var c=Math.ceil(m/8);var d;var o=function(i){return KJUR.crypto.Util.hashHex(i,a)};if(k===-1||k===undefined){k=g}else{if(k===-2){k=c-g-2}else{if(k<-2){throw"invalid salt length"}}}if(c<(g+k+2)){throw"data too long"}var f="";if(k>0){f=new Array(k);new SecureRandom().nextBytes(f);f=String.fromCharCode.apply(String,f)}var n=hextorstr(o(rstrtohex("\x00\x00\x00\x00\x00\x00\x00\x00"+b+f)));var j=[];for(d=0;d<c-k-g-2;d+=1){j[d]=0}var e=String.fromCharCode.apply(String,j)+"\x01"+f;var h=pss_mgf1_str(n,e.length,o);var q=[];for(d=0;d<e.length;d+=1){q[d]=e.charCodeAt(d)^h.charCodeAt(d)}var p=(65280>>(8*c-m))&255;q[0]&=~p;for(d=0;d<g;d++){q.push(n.charCodeAt(d))}q.push(188);return _zeroPaddingOfSignature(this.doPrivate(new BigInteger(q)).toString(16),this.n.bitLength())}function _rsasign_getDecryptSignatureBI(a,d,c){var b=new RSAKey();b.setPublic(d,c);var e=b.doPublic(a);return e}function _rsasign_getHexDigestInfoFromSig(a,c,b){var e=_rsasign_getDecryptSignatureBI(a,c,b);var d=e.toString(16).replace(/^1f+00/,"");return d}function _rsasign_getAlgNameAndHashFromHexDisgestInfo(f){for(var e in KJUR.crypto.Util.DIGESTINFOHEAD){var d=KJUR.crypto.Util.DIGESTINFOHEAD[e];var b=d.length;if(f.substring(0,b)==d){var c=[e,f.substring(b)];return c}}return[]}function _rsasign_verifySignatureWithArgs(f,b,g,j){var e=_rsasign_getHexDigestInfoFromSig(b,g,j);var h=_rsasign_getAlgNameAndHashFromHexDisgestInfo(e);if(h.length==0){return false}var d=h[0];var i=h[1];var a=function(k){return KJUR.crypto.Util.hashString(k,d)};var c=a(f);return(i==c)}function _rsasign_verifyHexSignatureForMessage(c,b){var d=parseBigInt(c,16);var a=_rsasign_verifySignatureWithArgs(b,d,this.n.toString(16),this.e.toString(16));return a}function _rsasign_verifyString(f,j){j=j.replace(_RE_HEXDECONLY,"");j=j.replace(/[ \n]+/g,"");var b=parseBigInt(j,16);if(b.bitLength()>this.n.bitLength()){return 0}var i=this.doPublic(b);var e=i.toString(16).replace(/^1f+00/,"");var g=_rsasign_getAlgNameAndHashFromHexDisgestInfo(e);if(g.length==0){return false}var d=g[0];var h=g[1];var a=function(k){return KJUR.crypto.Util.hashString(k,d)};var c=a(f);return(h==c)}function _rsasign_verifyWithMessageHash(e,a){a=a.replace(_RE_HEXDECONLY,"");a=a.replace(/[ \n]+/g,"");var b=parseBigInt(a,16);if(b.bitLength()>this.n.bitLength()){return 0}var h=this.doPublic(b);var g=h.toString(16).replace(/^1f+00/,"");var c=_rsasign_getAlgNameAndHashFromHexDisgestInfo(g);if(c.length==0){return false}var d=c[0];var f=c[1];return(f==e)}function _rsasign_verifyStringPSS(c,b,a,f){var e=function(g){return KJUR.crypto.Util.hashHex(g,a)};var d=e(rstrtohex(c));if(f===undefined){f=-1}return this.verifyWithMessageHashPSS(d,b,a,f)}function _rsasign_verifyWithMessageHashPSS(f,s,l,c){var k=new BigInteger(s,16);if(k.bitLength()>this.n.bitLength()){return false}var r=function(i){return KJUR.crypto.Util.hashHex(i,l)};var j=hextorstr(f);var h=j.length;var g=this.n.bitLength()-1;var m=Math.ceil(g/8);var q;if(c===-1||c===undefined){c=h}else{if(c===-2){c=m-h-2}else{if(c<-2){throw"invalid salt length"}}}if(m<(h+c+2)){throw"data too long"}var a=this.doPublic(k).toByteArray();for(q=0;q<a.length;q+=1){a[q]&=255}while(a.length<m){a.unshift(0)}if(a[m-1]!==188){throw"encoded message does not end in 0xbc"}a=String.fromCharCode.apply(String,a);var d=a.substr(0,m-h-1);var e=a.substr(d.length,h);var p=(65280>>(8*m-g))&255;if((d.charCodeAt(0)&p)!==0){throw"bits beyond keysize not zero"}var n=pss_mgf1_str(e,d.length,r);var o=[];for(q=0;q<d.length;q+=1){o[q]=d.charCodeAt(q)^n.charCodeAt(q)}o[0]&=~p;var b=m-h-c-2;for(q=0;q<b;q+=1){if(o[q]!==0){throw"leftmost octets not zero"}}if(o[b]!==1){throw"0x01 marker not found"}return e===hextorstr(r(rstrtohex("\x00\x00\x00\x00\x00\x00\x00\x00"+j+String.fromCharCode.apply(String,o.slice(-c)))))}RSAKey.prototype.signWithMessageHash=_rsasign_signWithMessageHash;RSAKey.prototype.signString=_rsasign_signString;RSAKey.prototype.signStringWithSHA1=_rsasign_signStringWithSHA1;RSAKey.prototype.signStringWithSHA256=_rsasign_signStringWithSHA256;RSAKey.prototype.sign=_rsasign_signString;RSAKey.prototype.signWithSHA1=_rsasign_signStringWithSHA1;RSAKey.prototype.signWithSHA256=_rsasign_signStringWithSHA256;RSAKey.prototype.signWithMessageHashPSS=_rsasign_signWithMessageHashPSS;RSAKey.prototype.signStringPSS=_rsasign_signStringPSS;RSAKey.prototype.signPSS=_rsasign_signStringPSS;RSAKey.SALT_LEN_HLEN=-1;RSAKey.SALT_LEN_MAX=-2;RSAKey.prototype.verifyWithMessageHash=_rsasign_verifyWithMessageHash;RSAKey.prototype.verifyString=_rsasign_verifyString;RSAKey.prototype.verifyHexSignatureForMessage=_rsasign_verifyHexSignatureForMessage;RSAKey.prototype.verify=_rsasign_verifyString;RSAKey.prototype.verifyHexSignatureForByteArrayMessage=_rsasign_verifyHexSignatureForMessage;RSAKey.prototype.verifyWithMessageHashPSS=_rsasign_verifyWithMessageHashPSS;RSAKey.prototype.verifyStringPSS=_rsasign_verifyStringPSS;RSAKey.prototype.verifyPSS=_rsasign_verifyStringPSS;RSAKey.SALT_LEN_RECOVER=-2;
	/*! x509-1.1.12.js (c) 2012-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	function X509(){this.subjectPublicKeyRSA=null;this.subjectPublicKeyRSA_hN=null;this.subjectPublicKeyRSA_hE=null;this.hex=null;this.getSerialNumberHex=function(){return ASN1HEX.getDecendantHexVByNthList(this.hex,0,[0,1])};this.getSignatureAlgorithmField=function(){var b=ASN1HEX.getDecendantHexVByNthList(this.hex,0,[0,2,0]);var a=KJUR.asn1.ASN1Util.oidHexToInt(b);var c=KJUR.asn1.x509.OID.oid2name(a);return c};this.getIssuerHex=function(){return ASN1HEX.getDecendantHexTLVByNthList(this.hex,0,[0,3])};this.getIssuerString=function(){return X509.hex2dn(ASN1HEX.getDecendantHexTLVByNthList(this.hex,0,[0,3]))};this.getSubjectHex=function(){return ASN1HEX.getDecendantHexTLVByNthList(this.hex,0,[0,5])};this.getSubjectString=function(){return X509.hex2dn(ASN1HEX.getDecendantHexTLVByNthList(this.hex,0,[0,5]))};this.getNotBefore=function(){var a=ASN1HEX.getDecendantHexVByNthList(this.hex,0,[0,4,0]);a=a.replace(/(..)/g,"%$1");a=decodeURIComponent(a);return a};this.getNotAfter=function(){var a=ASN1HEX.getDecendantHexVByNthList(this.hex,0,[0,4,1]);a=a.replace(/(..)/g,"%$1");a=decodeURIComponent(a);return a};this.readCertPEM=function(c){var e=ASN1HEX.pemToHex(c);var b=X509.getPublicKeyHexArrayFromCertHex(e);var d=new RSAKey();d.setPublic(b[0],b[1]);this.subjectPublicKeyRSA=d;this.subjectPublicKeyRSA_hN=b[0];this.subjectPublicKeyRSA_hE=b[1];this.hex=e};this.readCertPEMWithoutRSAInit=function(c){var d=ASN1HEX.pemToHex(c);var b=X509.getPublicKeyHexArrayFromCertHex(d);if(typeof this.subjectPublicKeyRSA.setPublic==="function"){this.subjectPublicKeyRSA.setPublic(b[0],b[1])}this.subjectPublicKeyRSA_hN=b[0];this.subjectPublicKeyRSA_hE=b[1];this.hex=d};this.getInfo=function(){var p="Basic Fields\n";p+="  serial number: "+this.getSerialNumberHex()+"\n";p+="  signature algorithm: "+this.getSignatureAlgorithmField()+"\n";p+="  issuer: "+this.getIssuerString()+"\n";p+="  notBefore: "+this.getNotBefore()+"\n";p+="  notAfter: "+this.getNotAfter()+"\n";p+="  subject: "+this.getSubjectString()+"\n";p+="  subject public key info: \n";var j=X509.getSubjectPublicKeyInfoPosFromCertHex(this.hex);var d=ASN1HEX.getHexOfTLV_AtObj(this.hex,j);var n=KEYUTIL.getKey(d,null,"pkcs8pub");if(n instanceof RSAKey){p+="    key algorithm: RSA\n";p+="    n="+n.n.toString(16).substr(0,16)+"...\n";p+="    e="+n.e.toString(16)+"\n"}p+="X509v3 Extensions:\n";var m=X509.getV3ExtInfoListOfCertHex(this.hex);for(var e=0;e<m.length;e++){var b=m[e];var o=KJUR.asn1.x509.OID.oid2name(b.oid);if(o===""){o=b.oid}var k="";if(b.critical===true){k="CRITICAL"}p+="  "+o+" "+k+":\n";if(o==="basicConstraints"){var g=X509.getExtBasicConstraints(this.hex);if(g.cA===undefined){p+="    {}\n"}else{p+="    cA=true";if(g.pathLen!==undefined){p+=", pathLen="+g.pathLen}p+="\n"}}else{if(o==="keyUsage"){p+="    "+X509.getExtKeyUsageString(this.hex)+"\n"}else{if(o==="subjectKeyIdentifier"){p+="    "+X509.getExtSubjectKeyIdentifier(this.hex)+"\n"}else{if(o==="authorityKeyIdentifier"){var a=X509.getExtAuthorityKeyIdentifier(this.hex);if(a.kid!==undefined){p+="    kid="+a.kid+"\n"}}else{if(o==="extKeyUsage"){var h=X509.getExtExtKeyUsageName(this.hex);p+="    "+h.join(", ")+"\n"}else{if(o==="subjectAltName"){var f=X509.getExtSubjectAltName(this.hex);p+="    "+f.join(", ")+"\n"}else{if(o==="cRLDistributionPoints"){var l=X509.getExtCRLDistributionPointsURI(this.hex);p+="    "+l+"\n"}else{if(o==="authorityInfoAccess"){var c=X509.getExtAIAInfo(this.hex);if(c.ocsp!==undefined){p+="    ocsp: "+c.ocsp.join(",")+"\n"}if(c.caissuer!==undefined){p+="    caissuer: "+c.caissuer.join(",")+"\n"}}}}}}}}}}p+="signature algorithm: "+X509.getSignatureAlgorithmName(this.hex)+"\n";p+="signature: "+X509.getSignatureValueHex(this.hex).substr(0,16)+"...\n";return p}}X509.pemToBase64=function(a){var b=a;b=b.replace("-----BEGIN CERTIFICATE-----","");b=b.replace("-----END CERTIFICATE-----","");b=b.replace(/[ \n]+/g,"");return b};X509.pemToHex=function(a){return ASN1HEX.pemToHex(a)};X509.getSubjectPublicKeyPosFromCertHex=function(f){var e=X509.getSubjectPublicKeyInfoPosFromCertHex(f);if(e==-1){return -1}var b=ASN1HEX.getPosArrayOfChildren_AtObj(f,e);if(b.length!=2){return -1}var d=b[1];if(f.substring(d,d+2)!="03"){return -1}var c=ASN1HEX.getStartPosOfV_AtObj(f,d);if(f.substring(c,c+2)!="00"){return -1}return c+2};X509.getSubjectPublicKeyInfoPosFromCertHex=function(d){var c=ASN1HEX.getStartPosOfV_AtObj(d,0);var b=ASN1HEX.getPosArrayOfChildren_AtObj(d,c);if(b.length<1){return -1}if(d.substring(b[0],b[0]+10)=="a003020102"){if(b.length<6){return -1}return b[6]}else{if(b.length<5){return -1}return b[5]}};X509.getPublicKeyHexArrayFromCertHex=function(f){var e=X509.getSubjectPublicKeyPosFromCertHex(f);var b=ASN1HEX.getPosArrayOfChildren_AtObj(f,e);if(b.length!=2){return[]}var d=ASN1HEX.getHexOfV_AtObj(f,b[0]);var c=ASN1HEX.getHexOfV_AtObj(f,b[1]);if(d!=null&&c!=null){return[d,c]}else{return[]}};X509.getHexTbsCertificateFromCert=function(b){var a=ASN1HEX.getStartPosOfV_AtObj(b,0);return a};X509.getPublicKeyHexArrayFromCertPEM=function(c){var d=ASN1HEX.pemToHex(c);var b=X509.getPublicKeyHexArrayFromCertHex(d);return b};X509.hex2dn=function(f,b){if(b===undefined){b=0}if(f.substr(b,2)!=="30"){throw"malformed DN"}var c=new Array();var d=ASN1HEX.getPosArrayOfChildren_AtObj(f,b);for(var e=0;e<d.length;e++){c.push(X509.hex2rdn(f,d[e]))}c=c.map(function(a){return a.replace("/","\\/")});return"/"+c.join("/")};X509.hex2rdn=function(f,b){if(b===undefined){b=0}if(f.substr(b,2)!=="31"){throw"malformed RDN"}var c=new Array();var d=ASN1HEX.getPosArrayOfChildren_AtObj(f,b);for(var e=0;e<d.length;e++){c.push(X509.hex2attrTypeValue(f,d[e]))}c=c.map(function(a){return a.replace("+","\\+")});return c.join("+")};X509.hex2attrTypeValue=function(g,b){if(b===undefined){b=0}if(g.substr(b,2)!=="30"){throw"malformed attribute type and value"}var c=ASN1HEX.getPosArrayOfChildren_AtObj(g,b);if(c.length!==2||g.substr(c[0],2)!=="06"){"malformed attribute type and value"}var d=ASN1HEX.getHexOfV_AtObj(g,c[0]);var h=KJUR.asn1.ASN1Util.oidHexToInt(d);var f=KJUR.asn1.x509.OID.oid2atype(h);var a=ASN1HEX.getHexOfV_AtObj(g,c[1]);var e=hextorstr(a);return f+"="+e};X509.getPublicKeyFromCertHex=function(c){var a,e,b;var g=6;var d=ASN1HEX;var f=d.getVbyList;b=d.getDecendantHexTLVByNthList(c,0,[0,0]);if(b!=="a003020102"){g=5}e=f(c,0,[0,g,0,0],"06");if(e==="2a864886f70d010101"){a=new RSAKey()}else{if(e==="2a8648ce380401"){a=new KJUR.crypto.DSA()}else{if(e==="2a8648ce3d0201"){a=new KJUR.crypto.ECDSA()}else{throw"unsupported public key in X.509 cert"}}}a.readCertPubKeyHex(c,g);return a};X509.getPublicKeyFromCertPEM=function(a){var c=ASN1HEX;var b=c.pemToHex(a);return X509.getPublicKeyFromCertHex(b)};X509.getPublicKeyInfoPropOfCertPEM=function(e){var i={};i.algparam=null;var f=ASN1HEX.pemToHex(e);var d=ASN1HEX.getPosArrayOfChildren_AtObj(f,0);if(d.length!=3){throw"malformed X.509 certificate PEM (code:001)"}if(f.substr(d[0],2)!="30"){throw"malformed X.509 certificate PEM (code:002)"}var c=ASN1HEX.getPosArrayOfChildren_AtObj(f,d[0]);var g=6;if(f.substr(c[0],2)!=="a0"){g=5}if(c.length<g+1){throw"malformed X.509 certificate PEM (code:003)"}var a=ASN1HEX.getPosArrayOfChildren_AtObj(f,c[g]);if(a.length!=2){throw"malformed X.509 certificate PEM (code:004)"}var h=ASN1HEX.getPosArrayOfChildren_AtObj(f,a[0]);if(h.length!=2){throw"malformed X.509 certificate PEM (code:005)"}i.algoid=ASN1HEX.getHexOfV_AtObj(f,h[0]);if(f.substr(h[1],2)=="06"){i.algparam=ASN1HEX.getHexOfV_AtObj(f,h[1])}else{if(f.substr(h[1],2)=="30"){i.algparam=ASN1HEX.getHexOfTLV_AtObj(f,h[1])}}if(f.substr(a[1],2)!="03"){throw"malformed X.509 certificate PEM (code:006)"}var b=ASN1HEX.getHexOfV_AtObj(f,a[1]);i.keyhex=b.substr(2);return i};X509.getPublicKeyInfoPosOfCertHEX=function(c){var b=ASN1HEX.getPosArrayOfChildren_AtObj(c,0);if(b.length!=3){throw"malformed X.509 certificate PEM (code:001)"}if(c.substr(b[0],2)!="30"){throw"malformed X.509 certificate PEM (code:002)"}var a=ASN1HEX.getPosArrayOfChildren_AtObj(c,b[0]);if(a.length<7){throw"malformed X.509 certificate PEM (code:003)"}return a[6]};X509.getV3ExtInfoListOfCertHex=function(g){var b=ASN1HEX.getPosArrayOfChildren_AtObj(g,0);if(b.length!=3){throw"malformed X.509 certificate PEM (code:001)"}if(g.substr(b[0],2)!="30"){throw"malformed X.509 certificate PEM (code:002)"}var a=ASN1HEX.getPosArrayOfChildren_AtObj(g,b[0]);if(a.length<8){throw"malformed X.509 certificate PEM (code:003)"}if(g.substr(a[7],2)!="a3"){throw"malformed X.509 certificate PEM (code:004)"}var h=ASN1HEX.getPosArrayOfChildren_AtObj(g,a[7]);if(h.length!=1){throw"malformed X.509 certificate PEM (code:005)"}if(g.substr(h[0],2)!="30"){throw"malformed X.509 certificate PEM (code:006)"}var f=ASN1HEX.getPosArrayOfChildren_AtObj(g,h[0]);var e=f.length;var d=new Array(e);for(var c=0;c<e;c++){d[c]=X509.getV3ExtItemInfo_AtObj(g,f[c])}return d};X509.getV3ExtItemInfo_AtObj=function(f,g){var e={};e.posTLV=g;var b=ASN1HEX.getPosArrayOfChildren_AtObj(f,g);if(b.length!=2&&b.length!=3){throw"malformed X.509v3 Ext (code:001)"}if(f.substr(b[0],2)!="06"){throw"malformed X.509v3 Ext (code:002)"}var d=ASN1HEX.getHexOfV_AtObj(f,b[0]);e.oid=ASN1HEX.hextooidstr(d);e.critical=false;if(b.length==3){e.critical=true}var c=b[b.length-1];if(f.substr(c,2)!="04"){throw"malformed X.509v3 Ext (code:003)"}e.posV=ASN1HEX.getStartPosOfV_AtObj(f,c);return e};X509.getHexOfTLV_V3ExtValue=function(b,a){var c=X509.getPosOfTLV_V3ExtValue(b,a);if(c==-1){return null}return ASN1HEX.getHexOfTLV_AtObj(b,c)};X509.getHexOfV_V3ExtValue=function(b,a){var c=X509.getPosOfTLV_V3ExtValue(b,a);if(c==-1){return null}return ASN1HEX.getHexOfV_AtObj(b,c)};X509.getPosOfTLV_V3ExtValue=function(f,b){var d=b;if(!b.match(/^[0-9.]+$/)){d=KJUR.asn1.x509.OID.name2oid(b)}if(d==""){return -1}var c=X509.getV3ExtInfoListOfCertHex(f);for(var a=0;a<c.length;a++){var e=c[a];if(e.oid==d){return e.posV}}return -1};X509.getExtBasicConstraints=function(d){var a=X509.getHexOfV_V3ExtValue(d,"basicConstraints");if(a===null){return null}if(a===""){return{}}if(a==="0101ff"){return{cA:true}}if(a.substr(0,8)==="0101ff02"){var c=ASN1HEX.getHexOfV_AtObj(a,6);var b=parseInt(c,16);return{cA:true,pathLen:b}}throw"unknown error"};X509.KEYUSAGE_NAME=["digitalSignature","nonRepudiation","keyEncipherment","dataEncipherment","keyAgreement","keyCertSign","cRLSign","encipherOnly","decipherOnly"];X509.getExtKeyUsageBin=function(d){var b=X509.getHexOfV_V3ExtValue(d,"keyUsage");if(b==""){return""}if(b.length%2!=0||b.length<=2){throw"malformed key usage value"}var a=parseInt(b.substr(0,2));var c=parseInt(b.substr(2),16).toString(2);return c.substr(0,c.length-a)};X509.getExtKeyUsageString=function(e){var d=X509.getExtKeyUsageBin(e);var b=new Array();for(var c=0;c<d.length;c++){if(d.substr(c,1)=="1"){b.push(X509.KEYUSAGE_NAME[c])}}return b.join(",")};X509.getExtSubjectKeyIdentifier=function(b){var a=X509.getHexOfV_V3ExtValue(b,"subjectKeyIdentifier");return a};X509.getExtAuthorityKeyIdentifier=function(f){var b={};var e=X509.getHexOfTLV_V3ExtValue(f,"authorityKeyIdentifier");if(e===null){return null}var c=ASN1HEX.getPosArrayOfChildren_AtObj(e,0);for(var d=0;d<c.length;d++){if(e.substr(c[d],2)==="80"){b.kid=ASN1HEX.getHexOfV_AtObj(e,c[d])}}return b};X509.getExtExtKeyUsageName=function(k){var b=new Array();var f=X509.getHexOfTLV_V3ExtValue(k,"extKeyUsage");if(f===null){return null}var c=ASN1HEX.getPosArrayOfChildren_AtObj(f,0);for(var e=0;e<c.length;e++){var j=ASN1HEX.getHexOfV_AtObj(f,c[e]);var g=KJUR.asn1.ASN1Util.oidHexToInt(j);var d=KJUR.asn1.x509.OID.oid2name(g);b.push(d)}return b};X509.getExtSubjectAltName=function(g){var b=new Array();var f=X509.getHexOfTLV_V3ExtValue(g,"subjectAltName");var c=ASN1HEX.getPosArrayOfChildren_AtObj(f,0);for(var e=0;e<c.length;e++){if(f.substr(c[e],2)==="82"){var d=hextoutf8(ASN1HEX.getHexOfV_AtObj(f,c[e]));b.push(d)}}return b};X509.getExtCRLDistributionPointsURI=function(n){var p=new Array();var k=X509.getHexOfTLV_V3ExtValue(n,"cRLDistributionPoints");var o=ASN1HEX.getPosArrayOfChildren_AtObj(k,0);for(var g=0;g<o.length;g++){var l=ASN1HEX.getHexOfTLV_AtObj(k,o[g]);var b=ASN1HEX.getPosArrayOfChildren_AtObj(l,0);for(var e=0;e<b.length;e++){if(l.substr(b[e],2)==="a0"){var f=ASN1HEX.getHexOfV_AtObj(l,b[e]);if(f.substr(0,2)==="a0"){var c=ASN1HEX.getHexOfV_AtObj(f,0);if(c.substr(0,2)==="86"){var m=ASN1HEX.getHexOfV_AtObj(c,0);var d=hextoutf8(m);p.push(d)}}}}}return p};X509.getExtAIAInfo=function(g){var j={};j.ocsp=[];j.caissuer=[];var h=X509.getPosOfTLV_V3ExtValue(g,"authorityInfoAccess");if(h==-1){return null}if(g.substr(h,2)!="30"){throw"malformed AIA Extn Value"}var d=ASN1HEX.getPosArrayOfChildren_AtObj(g,h);for(var c=0;c<d.length;c++){var a=d[c];var b=ASN1HEX.getPosArrayOfChildren_AtObj(g,a);if(b.length!=2){throw"malformed AccessDescription of AIA Extn"}var e=b[0];var f=b[1];if(ASN1HEX.getHexOfV_AtObj(g,e)=="2b06010505073001"){if(g.substr(f,2)=="86"){j.ocsp.push(hextoutf8(ASN1HEX.getHexOfV_AtObj(g,f)))}}if(ASN1HEX.getHexOfV_AtObj(g,e)=="2b06010505073002"){if(g.substr(f,2)=="86"){j.caissuer.push(hextoutf8(ASN1HEX.getHexOfV_AtObj(g,f)))}}}return j};X509.getSignatureAlgorithmName=function(d){var b=ASN1HEX.getDecendantHexVByNthList(d,0,[1,0]);var a=KJUR.asn1.ASN1Util.oidHexToInt(b);var c=KJUR.asn1.x509.OID.oid2name(a);return c};X509.getSignatureValueHex=function(b){var a=ASN1HEX.getDecendantHexVByNthList(b,0,[2]);if(a.substr(0,2)!=="00"){throw"can't get signature value"}return a.substr(2)};X509.getSerialNumberHex=function(a){return ASN1HEX.getDecendantHexVByNthList(a,0,[0,1])};X509.verifySignature=function(f,c){var d=X509.getSignatureAlgorithmName(f);var a=X509.getSignatureValueHex(f);var b=ASN1HEX.getDecendantHexTLVByNthList(f,0,[0]);var e=new KJUR.crypto.Signature({alg:d});e.init(c);e.updateHex(b);return e.verify(a)};
	/*! jws-3.3.5 (c) 2013-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.jws=="undefined"||!KJUR.jws){KJUR.jws={}}KJUR.jws.JWS=function(){var a=KJUR.jws.JWS;this.parseJWS=function(e,h){if((this.parsedJWS!==undefined)&&(h||(this.parsedJWS.sigvalH!==undefined))){return}var g=e.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);if(g==null){throw"JWS signature is not a form of 'Head.Payload.SigValue'."}var i=g[1];var c=g[2];var j=g[3];var l=i+"."+c;this.parsedJWS={};this.parsedJWS.headB64U=i;this.parsedJWS.payloadB64U=c;this.parsedJWS.sigvalB64U=j;this.parsedJWS.si=l;if(!h){var f=b64utohex(j);var d=parseBigInt(f,16);this.parsedJWS.sigvalH=f;this.parsedJWS.sigvalBI=d}var b=b64utoutf8(i);var k=b64utoutf8(c);this.parsedJWS.headS=b;this.parsedJWS.payloadS=k;if(!a.isSafeJSONString(b,this.parsedJWS,"headP")){throw"malformed JSON string for JWS Head: "+b}}};KJUR.jws.JWS.sign=function(a,i,c,m,l){var k=KJUR.jws.JWS;var q,e,j;if(typeof i!="string"&&typeof i!="object"){throw"spHeader must be JSON string or object: "+i}if(typeof i=="object"){e=i;q=JSON.stringify(e)}if(typeof i=="string"){q=i;if(!k.isSafeJSONString(q)){throw"JWS Head is not safe JSON string: "+q}e=k.readSafeJSONString(q)}j=c;if(typeof c=="object"){j=JSON.stringify(c)}if((a==""||a==null)&&e.alg!==undefined){a=e.alg}if((a!=""&&a!=null)&&e.alg===undefined){e.alg=a;q=JSON.stringify(e)}if(a!==e.alg){throw"alg and sHeader.alg doesn't match: "+a+"!="+e.alg}var d=null;if(k.jwsalg2sigalg[a]===undefined){throw"unsupported alg name: "+a}else{d=k.jwsalg2sigalg[a]}var b=utf8tob64u(q);var g=utf8tob64u(j);var o=b+"."+g;var n="";if(d.substr(0,4)=="Hmac"){if(m===undefined){throw"mac key shall be specified for HS* alg"}var h=new KJUR.crypto.Mac({alg:d,prov:"cryptojs",pass:m});h.updateString(o);n=h.doFinal()}else{if(d.indexOf("withECDSA")!=-1){var p=new KJUR.crypto.Signature({alg:d});p.init(m,l);p.updateString(o);hASN1Sig=p.sign();n=KJUR.crypto.ECDSA.asn1SigToConcatSig(hASN1Sig)}else{if(d!="none"){var p=new KJUR.crypto.Signature({alg:d});p.init(m,l);p.updateString(o);n=p.sign()}}}var f=hextob64u(n);return o+"."+f};KJUR.jws.JWS.verify=function(p,t,j){var m=KJUR.jws.JWS;var q=p.split(".");var d=q[0];var l=q[1];var b=d+"."+l;var r=b64utohex(q[2]);var i=m.readSafeJSONString(b64utoutf8(q[0]));var h=null;var s=null;if(i.alg===undefined){throw"algorithm not specified in header"}else{h=i.alg;s=h.substr(0,2)}if(j!=null&&Object.prototype.toString.call(j)==="[object Array]"&&j.length>0){var c=":"+j.join(":")+":";if(c.indexOf(":"+h+":")==-1){throw"algorithm '"+h+"' not accepted in the list"}}if(h!="none"&&t===null){throw"key shall be specified to verify."}if(typeof t=="string"&&t.indexOf("-----BEGIN ")!=-1){t=KEYUTIL.getKey(t)}if(s=="RS"||s=="PS"){if(!(t instanceof RSAKey)){throw"key shall be a RSAKey obj for RS* and PS* algs"}}if(s=="ES"){if(!(t instanceof KJUR.crypto.ECDSA)){throw"key shall be a ECDSA obj for ES* algs"}}if(h=="none"){}var n=null;if(m.jwsalg2sigalg[i.alg]===undefined){throw"unsupported alg name: "+h}else{n=m.jwsalg2sigalg[h]}if(n=="none"){throw"not supported"}else{if(n.substr(0,4)=="Hmac"){var k=null;if(t===undefined){throw"hexadecimal key shall be specified for HMAC"}var g=new KJUR.crypto.Mac({alg:n,pass:t});g.updateString(b);k=g.doFinal();return r==k}else{if(n.indexOf("withECDSA")!=-1){var f=null;try{f=KJUR.crypto.ECDSA.concatSigToASN1Sig(r)}catch(o){return false}var e=new KJUR.crypto.Signature({alg:n});e.init(t);e.updateString(b);return e.verify(f)}else{var e=new KJUR.crypto.Signature({alg:n});e.init(t);e.updateString(b);return e.verify(r)}}}};KJUR.jws.JWS.parse=function(g){var c=g.split(".");var b={};var f,e,d;if(c.length!=2&&c.length!=3){throw"malformed sJWS: wrong number of '.' splitted elements"}f=c[0];e=c[1];if(c.length==3){d=c[2]}b.headerObj=KJUR.jws.JWS.readSafeJSONString(b64utoutf8(f));b.payloadObj=KJUR.jws.JWS.readSafeJSONString(b64utoutf8(e));b.headerPP=JSON.stringify(b.headerObj,null,"  ");if(b.payloadObj==null){b.payloadPP=b64utoutf8(e)}else{b.payloadPP=JSON.stringify(b.payloadObj,null,"  ")}if(d!==undefined){b.sigHex=b64utohex(d)}return b};KJUR.jws.JWS.verifyJWT=function(d,j,l){var h=KJUR.jws.JWS;var i=d.split(".");var c=i[0];var g=i[1];var m=c+"."+g;var k=b64utohex(i[2]);var f=h.readSafeJSONString(b64utoutf8(c));var e=h.readSafeJSONString(b64utoutf8(g));if(f.alg===undefined){return false}if(l.alg===undefined){throw"acceptField.alg shall be specified"}if(!h.inArray(f.alg,l.alg)){return false}if(e.iss!==undefined&&typeof l.iss==="object"){if(!h.inArray(e.iss,l.iss)){return false}}if(e.sub!==undefined&&typeof l.sub==="object"){if(!h.inArray(e.sub,l.sub)){return false}}if(e.aud!==undefined&&typeof l.aud==="object"){if(typeof e.aud=="string"){if(!h.inArray(e.aud,l.aud)){return false}}else{if(typeof e.aud=="object"){if(!h.includedArray(e.aud,l.aud)){return false}}}}var b=KJUR.jws.IntDate.getNow();if(l.verifyAt!==undefined&&typeof l.verifyAt==="number"){b=l.verifyAt}if(l.gracePeriod===undefined||typeof l.gracePeriod!=="number"){l.gracePeriod=0}if(e.exp!==undefined&&typeof e.exp=="number"){if(e.exp+l.gracePeriod<b){return false}}if(e.nbf!==undefined&&typeof e.nbf=="number"){if(b<e.nbf-l.gracePeriod){return false}}if(e.iat!==undefined&&typeof e.iat=="number"){if(b<e.iat-l.gracePeriod){return false}}if(e.jti!==undefined&&l.jti!==undefined){if(e.jti!==l.jti){return false}}if(!KJUR.jws.JWS.verify(d,j,l.alg)){return false}return true};KJUR.jws.JWS.includedArray=function(b,a){var d=KJUR.jws.JWS.inArray;if(b===null){return false}if(typeof b!=="object"){return false}if(typeof b.length!=="number"){return false}for(var c=0;c<b.length;c++){if(!d(b[c],a)){return false}}return true};KJUR.jws.JWS.inArray=function(d,b){if(b===null){return false}if(typeof b!=="object"){return false}if(typeof b.length!=="number"){return false}for(var c=0;c<b.length;c++){if(b[c]==d){return true}}return false};KJUR.jws.JWS.jwsalg2sigalg={HS256:"HmacSHA256",HS384:"HmacSHA384",HS512:"HmacSHA512",RS256:"SHA256withRSA",RS384:"SHA384withRSA",RS512:"SHA512withRSA",ES256:"SHA256withECDSA",ES384:"SHA384withECDSA",PS256:"SHA256withRSAandMGF1",PS384:"SHA384withRSAandMGF1",PS512:"SHA512withRSAandMGF1",none:"none",};KJUR.jws.JWS.isSafeJSONString=function(c,b,d){var e=null;try{e=jsonParse(c);if(typeof e!="object"){return 0}if(e.constructor===Array){return 0}if(b){b[d]=e}return 1}catch(a){return 0}};KJUR.jws.JWS.readSafeJSONString=function(b){var c=null;try{c=jsonParse(b);if(typeof c!="object"){return null}if(c.constructor===Array){return null}return c}catch(a){return null}};KJUR.jws.JWS.getEncodedSignatureValueFromJWS=function(b){var a=b.match(/^[^.]+\.[^.]+\.([^.]+)$/);if(a==null){throw"JWS signature is not a form of 'Head.Payload.SigValue'."}return a[1]};KJUR.jws.JWS.getJWKthumbprint=function(d){if(d.kty!=="RSA"&&d.kty!=="EC"&&d.kty!=="oct"){throw"unsupported algorithm for JWK Thumprint"}var a="{";if(d.kty==="RSA"){if(typeof d.n!="string"||typeof d.e!="string"){throw"wrong n and e value for RSA key"}a+='"e":"'+d.e+'",';a+='"kty":"'+d.kty+'",';a+='"n":"'+d.n+'"}'}else{if(d.kty==="EC"){if(typeof d.crv!="string"||typeof d.x!="string"||typeof d.y!="string"){throw"wrong crv, x and y value for EC key"}a+='"crv":"'+d.crv+'",';a+='"kty":"'+d.kty+'",';a+='"x":"'+d.x+'",';a+='"y":"'+d.y+'"}'}else{if(d.kty==="oct"){if(typeof d.k!="string"){throw"wrong k value for oct(symmetric) key"}a+='"kty":"'+d.kty+'",';a+='"k":"'+d.k+'"}'}}}var b=rstrtohex(a);var c=KJUR.crypto.Util.hashHex(b,"sha256");var e=hextob64u(c);return e};KJUR.jws.IntDate={};KJUR.jws.IntDate.get=function(a){if(a=="now"){return KJUR.jws.IntDate.getNow()}else{if(a=="now + 1hour"){return KJUR.jws.IntDate.getNow()+60*60}else{if(a=="now + 1day"){return KJUR.jws.IntDate.getNow()+60*60*24}else{if(a=="now + 1month"){return KJUR.jws.IntDate.getNow()+60*60*24*30}else{if(a=="now + 1year"){return KJUR.jws.IntDate.getNow()+60*60*24*365}else{if(a.match(/Z$/)){return KJUR.jws.IntDate.getZulu(a)}else{if(a.match(/^[0-9]+$/)){return parseInt(a)}}}}}}}throw"unsupported format: "+a};KJUR.jws.IntDate.getZulu=function(k){var b=k.match(/(\d+)(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)Z/);if(b){var a=b[1];var i=parseInt(a);if(a.length==4){}else{if(a.length==2){if(50<=i&&i<100){i=1900+i}else{if(0<=i&&i<50){i=2000+i}else{throw"malformed year string for UTCTime"}}}else{throw"malformed year string"}}var g=parseInt(b[2])-1;var j=parseInt(b[3]);var c=parseInt(b[4]);var e=parseInt(b[5]);var f=parseInt(b[6]);var h=new Date(Date.UTC(i,g,j,c,e,f));return ~~(h/1000)}throw"unsupported format: "+k};KJUR.jws.IntDate.getNow=function(){var a=~~(new Date()/1000);return a};KJUR.jws.IntDate.intDate2UTCString=function(a){var b=new Date(a*1000);return b.toUTCString()};KJUR.jws.IntDate.intDate2Zulu=function(e){var i=new Date(e*1000);var h=("0000"+i.getUTCFullYear()).slice(-4);var g=("00"+(i.getUTCMonth()+1)).slice(-2);var b=("00"+i.getUTCDate()).slice(-2);var a=("00"+i.getUTCHours()).slice(-2);var c=("00"+i.getUTCMinutes()).slice(-2);var f=("00"+i.getUTCSeconds()).slice(-2);return h+g+b+a+c+f+"Z"};
	/*! jwsjs-2.1.0 (c) 2010-2016 Kenji Urushima | kjur.github.com/jsrsasign/license
	 */
	if(typeof KJUR=="undefined"||!KJUR){KJUR={}}if(typeof KJUR.jws=="undefined"||!KJUR.jws){KJUR.jws={}}KJUR.jws.JWSJS=function(){var b=KJUR.jws.JWS;var a=KJUR.jws.JWS;this.aHeader=[];this.sPayload="";this.aSignature=[];this.init=function(){this.aHeader=[];this.sPayload=undefined;this.aSignature=[]};this.initWithJWS=function(d){this.init();var c=d.split(".");if(c.length!=3){throw"malformed input JWS"}this.aHeader.push(c[0]);this.sPayload=c[1];this.aSignature.push(c[2])};this.addSignature=function(c,f,k,i){if(this.sPayload===undefined||this.sPayload===null){throw"there's no JSON-JS signature to add."}var j=this.aHeader.length;if(this.aHeader.length!=this.aSignature.length){throw"aHeader.length != aSignature.length"}try{var d=KJUR.jws.JWS.sign(c,f,this.sPayload,k,i);var h=d.split(".");var l=h[0];var e=h[2];this.aHeader.push(h[0]);this.aSignature.push(h[2])}catch(g){if(this.aHeader.length>j){this.aHeader.pop()}if(this.aSignature.length>j){this.aSignature.pop()}throw"addSignature failed: "+g}};this.addSignatureByHeaderKey=function(f,c){var e=b64utoutf8(this.sPayload);var d=new KJUR.jws.JWS();var g=d.generateJWSByP1PrvKey(f,e,c);this.aHeader.push(d.parsedJWS.headB64U);this.aSignature.push(d.parsedJWS.sigvalB64U)};this.addSignatureByHeaderPayloadKey=function(f,e,c){var d=new KJUR.jws.JWS();var g=d.generateJWSByP1PrvKey(f,e,c);this.aHeader.push(d.parsedJWS.headB64U);this.sPayload=d.parsedJWS.payloadB64U;this.aSignature.push(d.parsedJWS.sigvalB64U)};this.verifyAll=function(f){if(this.aHeader.length!==f.length||this.aSignature.length!==f.length){return false}for(var e=0;e<f.length;e++){var d=f[e];if(d.length!==2){return false}var c=this.verifyNth(e,d[0],d[1]);if(c===false){return false}}return true};this.verifyNth=function(d,h,e){if(this.aHeader.length<=d||this.aSignature.length<=d){return false}var f=this.aHeader[d];var i=this.aSignature[d];var j=f+"."+this.sPayload+"."+i;var c=false;try{c=a.verify(j,h,e)}catch(g){return false}return c};this.verifyWithCerts=function(d){if(this.aHeader.length!=d.length){throw"num headers does not match with num certs"}if(this.aSignature.length!=d.length){throw"num signatures does not match with num certs"}var l=this.sPayload;var h="";for(var e=0;e<d.length;e++){var f=d[e];var g=this.aHeader[e];var n=this.aSignature[e];var c=g+"."+l+"."+n;var k=new KJUR.jws.JWS();try{var m=k.verifyJWSByPemX509Cert(c,f);if(m!=1){h+=(e+1)+"th signature unmatch. "}}catch(j){h+=(e+1)+"th signature fail("+j+"). "}}if(h==""){return 1}else{throw h}};this.readJWSJS=function(e){if(typeof e==="string"){var d=b.readSafeJSONString(e);if(d==null){throw"argument is not safe JSON object string"}this.aHeader=d.headers;this.sPayload=d.payload;this.aSignature=d.signatures}else{try{if(e.headers.length>0){this.aHeader=e.headers}else{throw"malformed header"}if(typeof e.payload==="string"){this.sPayload=e.payload}else{throw"malformed signatures"}if(e.signatures.length>0){this.signatures=e.signatures}else{throw"malformed signatures"}}catch(c){throw"malformed JWS-JS JSON object: "+c}}};this.getJSON=function(){return{headers:this.aHeader,payload:this.sPayload,signatures:this.aSignature}};this.isEmpty=function(){if(this.aHeader.length==0){return 1}return 0}};
	exports.SecureRandom = SecureRandom;
	exports.rng_seed_time = rng_seed_time;
	
	exports.BigInteger = BigInteger;
	exports.RSAKey = RSAKey;
	exports.ECDSA = KJUR.crypto.ECDSA;
	exports.DSA = KJUR.crypto.DSA;
	exports.Signature = KJUR.crypto.Signature;
	exports.MessageDigest = KJUR.crypto.MessageDigest;
	exports.Mac = KJUR.crypto.Mac;
	exports.Cipher = KJUR.crypto.Cipher;
	exports.KEYUTIL = KEYUTIL;
	exports.ASN1HEX = ASN1HEX;
	exports.X509 = X509;
	exports.CryptoJS = CryptoJS;
	
	// ext/base64.js
	exports.b64tohex = b64tohex;
	exports.b64toBA = b64toBA;
	
	// base64x.js
	exports.stoBA = stoBA;
	exports.BAtos = BAtos;
	exports.BAtohex = BAtohex;
	exports.stohex = stohex;
	exports.stob64 = stob64;
	exports.stob64u = stob64u;
	exports.b64utos = b64utos;
	exports.b64tob64u = b64tob64u;
	exports.b64utob64 = b64utob64;
	exports.hex2b64 = hex2b64;
	exports.hextob64u = hextob64u;
	exports.b64utohex = b64utohex;
	exports.b64tohex = b64tohex;
	exports.utf8tob64u = utf8tob64u;
	exports.b64utoutf8 = b64utoutf8;
	exports.utf8tob64 = utf8tob64;
	exports.b64toutf8 = b64toutf8;
	exports.utf8tohex = utf8tohex;
	exports.hextoutf8 = hextoutf8;
	exports.hextorstr = hextorstr;
	exports.rstrtohex = rstrtohex;
	exports.newline_toUnix = newline_toUnix;
	exports.newline_toDos = newline_toDos;
	exports.intarystrtohex = intarystrtohex;
	exports.strdiffidx = strdiffidx;
	exports.hextob64 = hextob64;
	exports.hextob64nl = hextob64nl;
	exports.b64nltohex = b64nltohex;
	exports.hextoArrayBuffer = hextoArrayBuffer;
	exports.ArrayBuffertohex = ArrayBuffertohex;
	
	// name spaces
	exports.KJUR = KJUR;
	exports.crypto = KJUR.crypto;
	exports.asn1 = KJUR.asn1;
	exports.jws = KJUR.jws;
	exports.lang = KJUR.lang;
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(525).Buffer))

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

	"use strict";
	
	/*global ace*/
	/* eslint "import/no-commonjs": 0 */
	ace.define("ace/theme/metabase", ["require", "exports", "module", "ace/lib/dom"], function (require, exports, module) {
	
	    exports.isDark = false;
	    exports.cssClass = "ace-metabase";
	    exports.cssText = "\
	.ace-metabase .ace_gutter {\
	background: rgb(220,236,249);\
	color: #509EE3;\
	font-weight: bold;\
	}\
	.ace-metabase  {\
	background: #fff;\
	color: #000;\
	}\
	.ace-metabase .ace_keyword {\
	font-weight: bold;\
	}\
	.ace-metabase .ace_string {\
	color: #A989C5;\
	font-weight: bold;\
	}\
	.ace-metabase .ace_variable.ace_class {\
	color: teal;\
	}\
	.ace-metabase .ace_constant.ace_numeric {\
	color: #6EA637;\
	}\
	.ace-metabase .ace_constant.ace_buildin {\
	color: #0086B3;\
	}\
	.ace-metabase .ace_support.ace_function {\
	color: #0086B3;\
	}\
	.ace-metabase .ace_comment {\
	color: #998;\
	font-style: italic;\
	}\
	.ace-metabase .ace_variable.ace_language  {\
	color: #0086B3;\
	}\
	.ace-metabase .ace_paren {\
	font-weight: bold;\
	}\
	.ace-metabase .ace_boolean {\
	font-weight: bold;\
	}\
	.ace-metabase .ace_string.ace_regexp {\
	color: #009926;\
	font-weight: normal;\
	}\
	.ace-metabase .ace_variable.ace_instance {\
	color: teal;\
	}\
	.ace-metabase .ace_constant.ace_language {\
	font-weight: bold;\
	}\
	.ace-metabase .ace_cursor {\
	color: black;\
	}\
	.ace-metabase.ace_focus .ace_marker-layer .ace_active-line {\
	background: rgb(255, 255, 204);\
	}\
	.ace-metabase .ace_marker-layer .ace_active-line {\
	background: rgb(245, 245, 245);\
	}\
	.ace-metabase .ace_marker-layer .ace_selection {\
	background: rgb(181, 213, 255);\
	}\
	.ace-metabase.ace_multiselect .ace_selection.ace_start {\
	box-shadow: 0 0 3px 0px white;\
	}\
	.ace-metabase.ace_nobold .ace_line > span {\
	font-weight: normal !important;\
	}\
	.ace-metabase .ace_marker-layer .ace_step {\
	background: rgb(252, 255, 0);\
	}\
	.ace-metabase .ace_marker-layer .ace_stack {\
	background: rgb(164, 229, 101);\
	}\
	.ace-metabase .ace_marker-layer .ace_bracket {\
	margin: -1px 0 0 -1px;\
	border: 1px solid rgb(192, 192, 192);\
	}\
	.ace-metabase .ace_gutter-active-line {\
	background-color : rgba(0, 0, 0, 0.07);\
	}\
	.ace-metabase .ace_marker-layer .ace_selected-word {\
	background: rgb(250, 250, 255);\
	border: 1px solid rgb(200, 200, 250);\
	}\
	.ace-metabase .ace_invisible {\
	color: #BFBFBF\
	}\
	.ace-metabase .ace_print-margin {\
	width: 1px;\
	background: #e8e8e8;\
	}\
	.ace-metabase .ace_indent-guide {\
	background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAE0lEQVQImWP4////f4bLly//BwAmVgd1/w11/gAAAABJRU5ErkJggg==\") right repeat-y;\
	}";
	
	    var dom = require("../lib/dom");
	    dom.importCssString(exports.cssText, exports.cssClass);
	});

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

	ace.define("ace/mode/clojure_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){var e="* *1 *2 *3 *agent* *allow-unresolved-vars* *assert* *clojure-version* *command-line-args* *compile-files* *compile-path* *e *err* *file* *flush-on-newline* *in* *macro-meta* *math-context* *ns* *out* *print-dup* *print-length* *print-level* *print-meta* *print-readably* *read-eval* *source-path* *use-context-classloader* *warn-on-reflection* + - -> ->> .. / < <= = == > &gt; >= &gt;= accessor aclone add-classpath add-watch agent agent-errors aget alength alias all-ns alter alter-meta! alter-var-root amap ancestors and apply areduce array-map aset aset-boolean aset-byte aset-char aset-double aset-float aset-int aset-long aset-short assert assoc assoc! assoc-in associative? atom await await-for await1 bases bean bigdec bigint binding bit-and bit-and-not bit-clear bit-flip bit-not bit-or bit-set bit-shift-left bit-shift-right bit-test bit-xor boolean boolean-array booleans bound-fn bound-fn* butlast byte byte-array bytes cast char char-array char-escape-string char-name-string char? chars chunk chunk-append chunk-buffer chunk-cons chunk-first chunk-next chunk-rest chunked-seq? class class? clear-agent-errors clojure-version coll? comment commute comp comparator compare compare-and-set! compile complement concat cond condp conj conj! cons constantly construct-proxy contains? count counted? create-ns create-struct cycle dec decimal? declare definline defmacro defmethod defmulti defn defn- defonce defstruct delay delay? deliver deref derive descendants destructure disj disj! dissoc dissoc! distinct distinct? doall doc dorun doseq dosync dotimes doto double double-array doubles drop drop-last drop-while empty empty? ensure enumeration-seq eval even? every? false? ffirst file-seq filter find find-doc find-ns find-var first float float-array float? floats flush fn fn? fnext for force format future future-call future-cancel future-cancelled? future-done? future? gen-class gen-interface gensym get get-in get-method get-proxy-class get-thread-bindings get-validator hash hash-map hash-set identical? identity if-let if-not ifn? import in-ns inc init-proxy instance? int int-array integer? interleave intern interpose into into-array ints io! isa? iterate iterator-seq juxt key keys keyword keyword? last lazy-cat lazy-seq let letfn line-seq list list* list? load load-file load-reader load-string loaded-libs locking long long-array longs loop macroexpand macroexpand-1 make-array make-hierarchy map map? mapcat max max-key memfn memoize merge merge-with meta method-sig methods min min-key mod name namespace neg? newline next nfirst nil? nnext not not-any? not-empty not-every? not= ns ns-aliases ns-imports ns-interns ns-map ns-name ns-publics ns-refers ns-resolve ns-unalias ns-unmap nth nthnext num number? odd? or parents partial partition pcalls peek persistent! pmap pop pop! pop-thread-bindings pos? pr pr-str prefer-method prefers primitives-classnames print print-ctor print-doc print-dup print-method print-namespace-doc print-simple print-special-doc print-str printf println println-str prn prn-str promise proxy proxy-call-with-super proxy-mappings proxy-name proxy-super push-thread-bindings pvalues quot rand rand-int range ratio? rational? rationalize re-find re-groups re-matcher re-matches re-pattern re-seq read read-line read-string reduce ref ref-history-count ref-max-history ref-min-history ref-set refer refer-clojure release-pending-sends rem remove remove-method remove-ns remove-watch repeat repeatedly replace replicate require reset! reset-meta! resolve rest resultset-seq reverse reversible? rseq rsubseq second select-keys send send-off seq seq? seque sequence sequential? set set-validator! set? short short-array shorts shutdown-agents slurp some sort sort-by sorted-map sorted-map-by sorted-set sorted-set-by sorted? special-form-anchor special-symbol? split-at split-with str stream? string? struct struct-map subs subseq subvec supers swap! symbol symbol? sync syntax-symbol-anchor take take-last take-nth take-while test the-ns time to-array to-array-2d trampoline transient tree-seq true? type unchecked-add unchecked-dec unchecked-divide unchecked-inc unchecked-multiply unchecked-negate unchecked-remainder unchecked-subtract underive unquote unquote-splicing update-in update-proxy use val vals var-get var-set var? vary-meta vec vector vector? when when-first when-let when-not while with-bindings with-bindings* with-in-str with-loading-context with-local-vars with-meta with-open with-out-str with-precision xml-seq zero? zipmap",t="throw try var def do fn if let loop monitor-enter monitor-exit new quote recur set!",n="true false nil",r=this.createKeywordMapper({keyword:t,"constant.language":n,"support.function":e},"identifier",!1," ");this.$rules={start:[{token:"comment",regex:";.*$"},{token:"keyword",regex:"[\\(|\\)]"},{token:"keyword",regex:"[\\'\\(]"},{token:"keyword",regex:"[\\[|\\]]"},{token:"keyword",regex:"[\\{|\\}|\\#\\{|\\#\\}]"},{token:"keyword",regex:"[\\&]"},{token:"keyword",regex:"[\\#\\^\\{]"},{token:"keyword",regex:"[\\%]"},{token:"keyword",regex:"[@]"},{token:"constant.numeric",regex:"0[xX][0-9a-fA-F]+\\b"},{token:"constant.numeric",regex:"[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"},{token:"constant.language",regex:"[!|\\$|%|&|\\*|\\-\\-|\\-|\\+\\+|\\+||=|!=|<=|>=|<>|<|>|!|&&]"},{token:r,regex:"[a-zA-Z_$][a-zA-Z0-9_$\\-]*\\b"},{token:"string",regex:'"',next:"string"},{token:"constant",regex:/:[^()\[\]{}'"\^%`,;\s]+/},{token:"string.regexp",regex:'/#"(?:\\.|(?:\\")|[^""\n])*"/g'}],string:[{token:"constant.language.escape",regex:"\\\\.|\\\\$"},{token:"string",regex:'[^"\\\\]+'},{token:"string",regex:'"',next:"start"}]}};r.inherits(s,i),t.ClojureHighlightRules=s}),ace.define("ace/mode/matching_parens_outdent",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("../range").Range,i=function(){};(function(){this.checkOutdent=function(e,t){return/^\s+$/.test(e)?/^\s*\)/.test(t):!1},this.autoOutdent=function(e,t){var n=e.getLine(t),i=n.match(/^(\s*\))/);if(!i)return 0;var s=i[1].length,o=e.findMatchingBracket({row:t,column:s});if(!o||o.row==t)return 0;var u=this.$getIndent(e.getLine(o.row));e.replace(new r(t,0,t,s-1),u)},this.$getIndent=function(e){var t=e.match(/^(\s+)/);return t?t[1]:""}}).call(i.prototype),t.MatchingParensOutdent=i}),ace.define("ace/mode/clojure",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/clojure_highlight_rules","ace/mode/matching_parens_outdent"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text").Mode,s=e("./clojure_highlight_rules").ClojureHighlightRules,o=e("./matching_parens_outdent").MatchingParensOutdent,u=function(){this.HighlightRules=s,this.$outdent=new o,this.$behaviour=this.$defaultBehaviour};r.inherits(u,i),function(){this.lineCommentStart=";",this.minorIndentFunctions=["defn","defn-","defmacro","def","deftest","testing"],this.$toIndent=function(e){return e.split("").map(function(e){return/\s/.exec(e)?e:" "}).join("")},this.$calculateIndent=function(e,t){var n=this.$getIndent(e),r=0,i,s;for(var o=e.length-1;o>=0;o--){s=e[o],s==="("?(r--,i=!0):s==="("||s==="["||s==="{"?(r--,i=!1):(s===")"||s==="]"||s==="}")&&r++;if(r<0)break}if(!(r<0&&i))return r<0&&!i?this.$toIndent(e.substring(0,o+1)):r>0?(n=n.substring(0,n.length-t.length),n):n;o+=1;var u=o,a="";for(;;){s=e[o];if(s===" "||s==="	")return this.minorIndentFunctions.indexOf(a)!==-1?this.$toIndent(e.substring(0,u-1)+t):this.$toIndent(e.substring(0,o+1));if(s===undefined)return this.$toIndent(e.substring(0,u-1)+t);a+=e[o],o++}},this.getNextLineIndent=function(e,t,n){return this.$calculateIndent(t,n)},this.checkOutdent=function(e,t,n){return this.$outdent.checkOutdent(t,n)},this.autoOutdent=function(e,t,n){this.$outdent.autoOutdent(t,n)},this.$id="ace/mode/clojure"}.call(u.prototype),t.Mode=u})

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

	ace.define("ace/mode/ruby_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=t.constantOtherSymbol={token:"constant.other.symbol.ruby",regex:"[:](?:[A-Za-z_]|[@$](?=[a-zA-Z0-9_]))[a-zA-Z0-9_]*[!=?]?"},o=t.qString={token:"string",regex:"['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"},u=t.qqString={token:"string",regex:'["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'},a=t.tString={token:"string",regex:"[`](?:(?:\\\\.)|(?:[^'\\\\]))*?[`]"},f=t.constantNumericHex={token:"constant.numeric",regex:"0[xX][0-9a-fA-F](?:[0-9a-fA-F]|_(?=[0-9a-fA-F]))*\\b"},l=t.constantNumericFloat={token:"constant.numeric",regex:"[+-]?\\d(?:\\d|_(?=\\d))*(?:(?:\\.\\d(?:\\d|_(?=\\d))*)?(?:[eE][+-]?\\d+)?)?\\b"},c=function(){var e="abort|Array|assert|assert_equal|assert_not_equal|assert_same|assert_not_same|assert_nil|assert_not_nil|assert_match|assert_no_match|assert_in_delta|assert_throws|assert_raise|assert_nothing_raised|assert_instance_of|assert_kind_of|assert_respond_to|assert_operator|assert_send|assert_difference|assert_no_difference|assert_recognizes|assert_generates|assert_response|assert_redirected_to|assert_template|assert_select|assert_select_email|assert_select_rjs|assert_select_encoded|css_select|at_exit|attr|attr_writer|attr_reader|attr_accessor|attr_accessible|autoload|binding|block_given?|callcc|caller|catch|chomp|chomp!|chop|chop!|defined?|delete_via_redirect|eval|exec|exit|exit!|fail|Float|flunk|follow_redirect!|fork|form_for|form_tag|format|gets|global_variables|gsub|gsub!|get_via_redirect|host!|https?|https!|include|Integer|lambda|link_to|link_to_unless_current|link_to_function|link_to_remote|load|local_variables|loop|open|open_session|p|print|printf|proc|putc|puts|post_via_redirect|put_via_redirect|raise|rand|raw|readline|readlines|redirect?|request_via_redirect|require|scan|select|set_trace_func|sleep|split|sprintf|srand|String|stylesheet_link_tag|syscall|system|sub|sub!|test|throw|trace_var|trap|untrace_var|atan2|cos|exp|frexp|ldexp|log|log10|sin|sqrt|tan|render|javascript_include_tag|csrf_meta_tag|label_tag|text_field_tag|submit_tag|check_box_tag|content_tag|radio_button_tag|text_area_tag|password_field_tag|hidden_field_tag|fields_for|select_tag|options_for_select|options_from_collection_for_select|collection_select|time_zone_select|select_date|select_time|select_datetime|date_select|time_select|datetime_select|select_year|select_month|select_day|select_hour|select_minute|select_second|file_field_tag|file_field|respond_to|skip_before_filter|around_filter|after_filter|verify|protect_from_forgery|rescue_from|helper_method|redirect_to|before_filter|send_data|send_file|validates_presence_of|validates_uniqueness_of|validates_length_of|validates_format_of|validates_acceptance_of|validates_associated|validates_exclusion_of|validates_inclusion_of|validates_numericality_of|validates_with|validates_each|authenticate_or_request_with_http_basic|authenticate_or_request_with_http_digest|filter_parameter_logging|match|get|post|resources|redirect|scope|assert_routing|translate|localize|extract_locale_from_tld|caches_page|expire_page|caches_action|expire_action|cache|expire_fragment|expire_cache_for|observe|cache_sweeper|has_many|has_one|belongs_to|has_and_belongs_to_many",t="alias|and|BEGIN|begin|break|case|class|def|defined|do|else|elsif|END|end|ensure|__FILE__|finally|for|gem|if|in|__LINE__|module|next|not|or|private|protected|public|redo|rescue|retry|return|super|then|undef|unless|until|when|while|yield",n="true|TRUE|false|FALSE|nil|NIL|ARGF|ARGV|DATA|ENV|RUBY_PLATFORM|RUBY_RELEASE_DATE|RUBY_VERSION|STDERR|STDIN|STDOUT|TOPLEVEL_BINDING",r="$DEBUG|$defout|$FILENAME|$LOAD_PATH|$SAFE|$stdin|$stdout|$stderr|$VERBOSE|$!|root_url|flash|session|cookies|params|request|response|logger|self",i=this.$keywords=this.createKeywordMapper({keyword:t,"constant.language":n,"variable.language":r,"support.function":e,"invalid.deprecated":"debugger"},"identifier");this.$rules={start:[{token:"comment",regex:"#.*$"},{token:"comment",regex:"^=begin(?:$|\\s.*$)",next:"comment"},{token:"string.regexp",regex:"[/](?:(?:\\[(?:\\\\]|[^\\]])+\\])|(?:\\\\/|[^\\]/]))*[/]\\w*\\s*(?=[).,;]|$)"},[{regex:"[{}]",onMatch:function(e,t,n){this.next=e=="{"?this.nextState:"";if(e=="{"&&n.length)return n.unshift("start",t),"paren.lparen";if(e=="}"&&n.length){n.shift(),this.next=n.shift();if(this.next.indexOf("string")!=-1)return"paren.end"}return e=="{"?"paren.lparen":"paren.rparen"},nextState:"start"},{token:"string.start",regex:/"/,push:[{token:"constant.language.escape",regex:/\\(?:[nsrtvfbae'"\\]|c.|C-.|M-.(?:\\C-.)?|[0-7]{3}|x[\da-fA-F]{2}|u[\da-fA-F]{4})/},{token:"paren.start",regex:/#{/,push:"start"},{token:"string.end",regex:/"/,next:"pop"},{defaultToken:"string"}]},{token:"string.start",regex:/`/,push:[{token:"constant.language.escape",regex:/\\(?:[nsrtvfbae'"\\]|c.|C-.|M-.(?:\\C-.)?|[0-7]{3}|x[\da-fA-F]{2}|u[\da-fA-F]{4})/},{token:"paren.start",regex:/#{/,push:"start"},{token:"string.end",regex:/`/,next:"pop"},{defaultToken:"string"}]},{token:"string.start",regex:/'/,push:[{token:"constant.language.escape",regex:/\\['\\]/},{token:"string.end",regex:/'/,next:"pop"},{defaultToken:"string"}]}],{token:"text",regex:"::"},{token:"variable.instance",regex:"@{1,2}[a-zA-Z_\\d]+"},{token:"support.class",regex:"[A-Z][a-zA-Z_\\d]+"},s,f,l,{token:"constant.language.boolean",regex:"(?:true|false)\\b"},{token:i,regex:"[a-zA-Z_$][a-zA-Z0-9_$]*\\b"},{token:"punctuation.separator.key-value",regex:"=>"},{stateName:"heredoc",onMatch:function(e,t,n){var r=e[2]=="-"?"indentedHeredoc":"heredoc",i=e.split(this.splitRegex);return n.push(r,i[3]),[{type:"constant",value:i[1]},{type:"string",value:i[2]},{type:"support.class",value:i[3]},{type:"string",value:i[4]}]},regex:"(<<-?)(['\"`]?)([\\w]+)(['\"`]?)",rules:{heredoc:[{onMatch:function(e,t,n){return e===n[1]?(n.shift(),n.shift(),this.next=n[0]||"start","support.class"):(this.next="","string")},regex:".*$",next:"start"}],indentedHeredoc:[{token:"string",regex:"^ +"},{onMatch:function(e,t,n){return e===n[1]?(n.shift(),n.shift(),this.next=n[0]||"start","support.class"):(this.next="","string")},regex:".*$",next:"start"}]}},{regex:"$",token:"empty",next:function(e,t){return t[0]==="heredoc"||t[0]==="indentedHeredoc"?t[0]:e}},{token:"string.character",regex:"\\B\\?."},{token:"keyword.operator",regex:"!|\\$|%|&|\\*|\\-\\-|\\-|\\+\\+|\\+|~|===|==|=|!=|!==|<=|>=|<<=|>>=|>>>=|<>|<|>|!|&&|\\|\\||\\?\\:|\\*=|%=|\\+=|\\-=|&=|\\^=|\\b(?:in|instanceof|new|delete|typeof|void)"},{token:"paren.lparen",regex:"[[({]"},{token:"paren.rparen",regex:"[\\])}]"},{token:"text",regex:"\\s+"}],comment:[{token:"comment",regex:"^=end(?:$|\\s.*$)",next:"start"},{token:"comment",regex:".+"}]},this.normalizeRules()};r.inherits(c,i),t.RubyHighlightRules=c}),ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("../range").Range,i=function(){};(function(){this.checkOutdent=function(e,t){return/^\s+$/.test(e)?/^\s*\}/.test(t):!1},this.autoOutdent=function(e,t){var n=e.getLine(t),i=n.match(/^(\s*\})/);if(!i)return 0;var s=i[1].length,o=e.findMatchingBracket({row:t,column:s});if(!o||o.row==t)return 0;var u=this.$getIndent(e.getLine(o.row));e.replace(new r(t,0,t,s-1),u)},this.$getIndent=function(e){return e.match(/^\s*/)[0]}}).call(i.prototype),t.MatchingBraceOutdent=i}),ace.define("ace/mode/folding/coffee",["require","exports","module","ace/lib/oop","ace/mode/folding/fold_mode","ace/range"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("./fold_mode").FoldMode,s=e("../../range").Range,o=t.FoldMode=function(){};r.inherits(o,i),function(){this.getFoldWidgetRange=function(e,t,n){var r=this.indentationBlock(e,n);if(r)return r;var i=/\S/,o=e.getLine(n),u=o.search(i);if(u==-1||o[u]!="#")return;var a=o.length,f=e.getLength(),l=n,c=n;while(++n<f){o=e.getLine(n);var h=o.search(i);if(h==-1)continue;if(o[h]!="#")break;c=n}if(c>l){var p=e.getLine(c).length;return new s(l,a,c,p)}},this.getFoldWidget=function(e,t,n){var r=e.getLine(n),i=r.search(/\S/),s=e.getLine(n+1),o=e.getLine(n-1),u=o.search(/\S/),a=s.search(/\S/);if(i==-1)return e.foldWidgets[n-1]=u!=-1&&u<a?"start":"","";if(u==-1){if(i==a&&r[i]=="#"&&s[i]=="#")return e.foldWidgets[n-1]="",e.foldWidgets[n+1]="","start"}else if(u==i&&r[i]=="#"&&o[i]=="#"&&e.getLine(n-2).search(/\S/)==-1)return e.foldWidgets[n-1]="start",e.foldWidgets[n+1]="","";return u!=-1&&u<i?e.foldWidgets[n-1]="start":e.foldWidgets[n-1]="",i<a?"start":""}}.call(o.prototype)}),ace.define("ace/mode/ruby",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/ruby_highlight_rules","ace/mode/matching_brace_outdent","ace/range","ace/mode/behaviour/cstyle","ace/mode/folding/coffee"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text").Mode,s=e("./ruby_highlight_rules").RubyHighlightRules,o=e("./matching_brace_outdent").MatchingBraceOutdent,u=e("../range").Range,a=e("./behaviour/cstyle").CstyleBehaviour,f=e("./folding/coffee").FoldMode,l=function(){this.HighlightRules=s,this.$outdent=new o,this.$behaviour=new a,this.foldingRules=new f};r.inherits(l,i),function(){this.lineCommentStart="#",this.getNextLineIndent=function(e,t,n){var r=this.$getIndent(t),i=this.getTokenizer().getLineTokens(t,e),s=i.tokens;if(s.length&&s[s.length-1].type=="comment")return r;if(e=="start"){var o=t.match(/^.*[\{\(\[]\s*$/),u=t.match(/^\s*(class|def|module)\s.*$/),a=t.match(/.*do(\s*|\s+\|.*\|\s*)$/),f=t.match(/^\s*(if|else|when)\s*/);if(o||u||a||f)r+=n}return r},this.checkOutdent=function(e,t,n){return/^\s+(end|else)$/.test(t+n)||this.$outdent.checkOutdent(t,n)},this.autoOutdent=function(e,t,n){var r=t.getLine(n);if(/}/.test(r))return this.$outdent.autoOutdent(t,n);var i=this.$getIndent(r),s=t.getLine(n-1),o=this.$getIndent(s),a=t.getTabString();o.length<=i.length&&i.slice(-a.length)==a&&t.remove(new u(n,i.length-a.length,n,i.length))},this.$id="ace/mode/ruby"}.call(l.prototype),t.Mode=l})

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

	ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){this.$rules={start:[{token:"comment.doc.tag",regex:"@[\\w\\d_]+"},s.getTagRule(),{defaultToken:"comment.doc",caseInsensitive:!0}]}};r.inherits(s,i),s.getTagRule=function(e){return{token:"comment.doc.tag.storage.type",regex:"\\b(?:TODO|FIXME|XXX|HACK)\\b"}},s.getStartRule=function(e){return{token:"comment.doc",regex:"\\/\\*(?=\\*)",next:e}},s.getEndRule=function(e){return{token:"comment.doc",regex:"\\*\\/",next:e}},t.DocCommentHighlightRules=s}),ace.define("ace/mode/javascript_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";function a(){var e=o.replace("\\d","\\d\\-"),t={onMatch:function(e,t,n){var r=e.charAt(1)=="/"?2:1;if(r==1)t!=this.nextState?n.unshift(this.next,this.nextState,0):n.unshift(this.next),n[2]++;else if(r==2&&t==this.nextState){n[1]--;if(!n[1]||n[1]<0)n.shift(),n.shift()}return[{type:"meta.tag.punctuation."+(r==1?"":"end-")+"tag-open.xml",value:e.slice(0,r)},{type:"meta.tag.tag-name.xml",value:e.substr(r)}]},regex:"</?"+e+"",next:"jsxAttributes",nextState:"jsx"};this.$rules.start.unshift(t);var n={regex:"{",token:"paren.quasi.start",push:"start"};this.$rules.jsx=[n,t,{include:"reference"},{defaultToken:"string"}],this.$rules.jsxAttributes=[{token:"meta.tag.punctuation.tag-close.xml",regex:"/?>",onMatch:function(e,t,n){return t==n[0]&&n.shift(),e.length==2&&(n[0]==this.nextState&&n[1]--,(!n[1]||n[1]<0)&&n.splice(0,2)),this.next=n[0]||"start",[{type:this.token,value:e}]},nextState:"jsx"},n,f("jsxAttributes"),{token:"entity.other.attribute-name.xml",regex:e},{token:"keyword.operator.attribute-equals.xml",regex:"="},{token:"text.tag-whitespace.xml",regex:"\\s+"},{token:"string.attribute-value.xml",regex:"'",stateName:"jsx_attr_q",push:[{token:"string.attribute-value.xml",regex:"'",next:"pop"},{include:"reference"},{defaultToken:"string.attribute-value.xml"}]},{token:"string.attribute-value.xml",regex:'"',stateName:"jsx_attr_qq",push:[{token:"string.attribute-value.xml",regex:'"',next:"pop"},{include:"reference"},{defaultToken:"string.attribute-value.xml"}]},t],this.$rules.reference=[{token:"constant.language.escape.reference.xml",regex:"(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"}]}function f(e){return[{token:"comment",regex:/\/\*/,next:[i.getTagRule(),{token:"comment",regex:"\\*\\/",next:e||"pop"},{defaultToken:"comment",caseInsensitive:!0}]},{token:"comment",regex:"\\/\\/",next:[i.getTagRule(),{token:"comment",regex:"$|^",next:e||"pop"},{defaultToken:"comment",caseInsensitive:!0}]}]}var r=e("../lib/oop"),i=e("./doc_comment_highlight_rules").DocCommentHighlightRules,s=e("./text_highlight_rules").TextHighlightRules,o="[a-zA-Z\\$_\u00a1-\uffff][a-zA-Z\\d\\$_\u00a1-\uffff]*",u=function(e){var t=this.createKeywordMapper({"variable.language":"Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|Namespace|QName|XML|XMLList|ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|SyntaxError|TypeError|URIError|decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|isNaN|parseFloat|parseInt|JSON|Math|this|arguments|prototype|window|document",keyword:"const|yield|import|get|set|async|await|break|case|catch|continue|default|delete|do|else|finally|for|function|if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|__parent__|__count__|escape|unescape|with|__proto__|class|enum|extends|super|export|implements|private|public|interface|package|protected|static","storage.type":"const|let|var|function","constant.language":"null|Infinity|NaN|undefined","support.function":"alert","constant.language.boolean":"true|false"},"identifier"),n="case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void",r="\\\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|u{[0-9a-fA-F]{1,6}}|[0-2][0-7]{0,2}|3[0-7][0-7]?|[4-7][0-7]?|.)";this.$rules={no_regex:[i.getStartRule("doc-start"),f("no_regex"),{token:"string",regex:"'(?=.)",next:"qstring"},{token:"string",regex:'"(?=.)',next:"qqstring"},{token:"constant.numeric",regex:/0(?:[xX][0-9a-fA-F]+|[bB][01]+)\b/},{token:"constant.numeric",regex:/[+-]?\d[\d_]*(?:(?:\.\d*)?(?:[eE][+-]?\d+)?)?\b/},{token:["storage.type","punctuation.operator","support.function","punctuation.operator","entity.name.function","text","keyword.operator"],regex:"("+o+")(\\.)(prototype)(\\.)("+o+")(\\s*)(=)",next:"function_arguments"},{token:["storage.type","punctuation.operator","entity.name.function","text","keyword.operator","text","storage.type","text","paren.lparen"],regex:"("+o+")(\\.)("+o+")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:["entity.name.function","text","keyword.operator","text","storage.type","text","paren.lparen"],regex:"("+o+")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:["storage.type","punctuation.operator","entity.name.function","text","keyword.operator","text","storage.type","text","entity.name.function","text","paren.lparen"],regex:"("+o+")(\\.)("+o+")(\\s*)(=)(\\s*)(function)(\\s+)(\\w+)(\\s*)(\\()",next:"function_arguments"},{token:["storage.type","text","entity.name.function","text","paren.lparen"],regex:"(function)(\\s+)("+o+")(\\s*)(\\()",next:"function_arguments"},{token:["entity.name.function","text","punctuation.operator","text","storage.type","text","paren.lparen"],regex:"("+o+")(\\s*)(:)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:["text","text","storage.type","text","paren.lparen"],regex:"(:)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:"keyword",regex:"(?:"+n+")\\b",next:"start"},{token:["support.constant"],regex:/that\b/},{token:["storage.type","punctuation.operator","support.function.firebug"],regex:/(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/},{token:t,regex:o},{token:"punctuation.operator",regex:/[.](?![.])/,next:"property"},{token:"keyword.operator",regex:/--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,next:"start"},{token:"punctuation.operator",regex:/[?:,;.]/,next:"start"},{token:"paren.lparen",regex:/[\[({]/,next:"start"},{token:"paren.rparen",regex:/[\])}]/},{token:"comment",regex:/^#!.*$/}],property:[{token:"text",regex:"\\s+"},{token:["storage.type","punctuation.operator","entity.name.function","text","keyword.operator","text","storage.type","text","entity.name.function","text","paren.lparen"],regex:"("+o+")(\\.)("+o+")(\\s*)(=)(\\s*)(function)(?:(\\s+)(\\w+))?(\\s*)(\\()",next:"function_arguments"},{token:"punctuation.operator",regex:/[.](?![.])/},{token:"support.function",regex:/(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/},{token:"support.function.dom",regex:/(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/},{token:"support.constant",regex:/(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/},{token:"identifier",regex:o},{regex:"",token:"empty",next:"no_regex"}],start:[i.getStartRule("doc-start"),f("start"),{token:"string.regexp",regex:"\\/",next:"regex"},{token:"text",regex:"\\s+|^$",next:"start"},{token:"empty",regex:"",next:"no_regex"}],regex:[{token:"regexp.keyword.operator",regex:"\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"},{token:"string.regexp",regex:"/[sxngimy]*",next:"no_regex"},{token:"invalid",regex:/\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/},{token:"constant.language.escape",regex:/\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/},{token:"constant.language.delimiter",regex:/\|/},{token:"constant.language.escape",regex:/\[\^?/,next:"regex_character_class"},{token:"empty",regex:"$",next:"no_regex"},{defaultToken:"string.regexp"}],regex_character_class:[{token:"regexp.charclass.keyword.operator",regex:"\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"},{token:"constant.language.escape",regex:"]",next:"regex"},{token:"constant.language.escape",regex:"-"},{token:"empty",regex:"$",next:"no_regex"},{defaultToken:"string.regexp.charachterclass"}],function_arguments:[{token:"variable.parameter",regex:o},{token:"punctuation.operator",regex:"[, ]+"},{token:"punctuation.operator",regex:"$"},{token:"empty",regex:"",next:"no_regex"}],qqstring:[{token:"constant.language.escape",regex:r},{token:"string",regex:"\\\\$",next:"qqstring"},{token:"string",regex:'"|$',next:"no_regex"},{defaultToken:"string"}],qstring:[{token:"constant.language.escape",regex:r},{token:"string",regex:"\\\\$",next:"qstring"},{token:"string",regex:"'|$",next:"no_regex"},{defaultToken:"string"}]};if(!e||!e.noES6)this.$rules.no_regex.unshift({regex:"[{}]",onMatch:function(e,t,n){this.next=e=="{"?this.nextState:"";if(e=="{"&&n.length)n.unshift("start",t);else if(e=="}"&&n.length){n.shift(),this.next=n.shift();if(this.next.indexOf("string")!=-1||this.next.indexOf("jsx")!=-1)return"paren.quasi.end"}return e=="{"?"paren.lparen":"paren.rparen"},nextState:"start"},{token:"string.quasi.start",regex:/`/,push:[{token:"constant.language.escape",regex:r},{token:"paren.quasi.start",regex:/\${/,push:"start"},{token:"string.quasi.end",regex:/`/,next:"pop"},{defaultToken:"string.quasi"}]}),(!e||e.jsx!=0)&&a.call(this);this.embedRules(i,"doc-",[i.getEndRule("no_regex")]),this.normalizeRules()};r.inherits(u,s),t.JavaScriptHighlightRules=u}),ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("../range").Range,i=function(){};(function(){this.checkOutdent=function(e,t){return/^\s+$/.test(e)?/^\s*\}/.test(t):!1},this.autoOutdent=function(e,t){var n=e.getLine(t),i=n.match(/^(\s*\})/);if(!i)return 0;var s=i[1].length,o=e.findMatchingBracket({row:t,column:s});if(!o||o.row==t)return 0;var u=this.$getIndent(e.getLine(o.row));e.replace(new r(t,0,t,s-1),u)},this.$getIndent=function(e){return e.match(/^\s*/)[0]}}).call(i.prototype),t.MatchingBraceOutdent=i}),ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("../../range").Range,s=e("./fold_mode").FoldMode,o=t.FoldMode=function(e){e&&(this.foldingStartMarker=new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/,"|"+e.start)),this.foldingStopMarker=new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/,"|"+e.end)))};r.inherits(o,s),function(){this.foldingStartMarker=/(\{|\[)[^\}\]]*$|^\s*(\/\*)/,this.foldingStopMarker=/^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/,this.singleLineBlockCommentRe=/^\s*(\/\*).*\*\/\s*$/,this.tripleStarBlockCommentRe=/^\s*(\/\*\*\*).*\*\/\s*$/,this.startRegionRe=/^\s*(\/\*|\/\/)#?region\b/,this._getFoldWidgetBase=this.getFoldWidget,this.getFoldWidget=function(e,t,n){var r=e.getLine(n);if(this.singleLineBlockCommentRe.test(r)&&!this.startRegionRe.test(r)&&!this.tripleStarBlockCommentRe.test(r))return"";var i=this._getFoldWidgetBase(e,t,n);return!i&&this.startRegionRe.test(r)?"start":i},this.getFoldWidgetRange=function(e,t,n,r){var i=e.getLine(n);if(this.startRegionRe.test(i))return this.getCommentRegionBlock(e,i,n);var s=i.match(this.foldingStartMarker);if(s){var o=s.index;if(s[1])return this.openingBracketBlock(e,s[1],n,o);var u=e.getCommentFoldRange(n,o+s[0].length,1);return u&&!u.isMultiLine()&&(r?u=this.getSectionRange(e,n):t!="all"&&(u=null)),u}if(t==="markbegin")return;var s=i.match(this.foldingStopMarker);if(s){var o=s.index+s[0].length;return s[1]?this.closingBracketBlock(e,s[1],n,o):e.getCommentFoldRange(n,o,-1)}},this.getSectionRange=function(e,t){var n=e.getLine(t),r=n.search(/\S/),s=t,o=n.length;t+=1;var u=t,a=e.getLength();while(++t<a){n=e.getLine(t);var f=n.search(/\S/);if(f===-1)continue;if(r>f)break;var l=this.getFoldWidgetRange(e,"all",t);if(l){if(l.start.row<=s)break;if(l.isMultiLine())t=l.end.row;else if(r==f)break}u=t}return new i(s,o,u,e.getLine(u).length)},this.getCommentRegionBlock=function(e,t,n){var r=t.search(/\s*$/),s=e.getLength(),o=n,u=/^\s*(?:\/\*|\/\/|--)#?(end)?region\b/,a=1;while(++n<s){t=e.getLine(n);var f=u.exec(t);if(!f)continue;f[1]?a--:a++;if(!a)break}var l=n;if(l>o)return new i(o,r,l,t.length)}}.call(o.prototype)}),ace.define("ace/mode/javascript",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/javascript_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text").Mode,s=e("./javascript_highlight_rules").JavaScriptHighlightRules,o=e("./matching_brace_outdent").MatchingBraceOutdent,u=e("../worker/worker_client").WorkerClient,a=e("./behaviour/cstyle").CstyleBehaviour,f=e("./folding/cstyle").FoldMode,l=function(){this.HighlightRules=s,this.$outdent=new o,this.$behaviour=new a,this.foldingRules=new f};r.inherits(l,i),function(){this.lineCommentStart="//",this.blockComment={start:"/*",end:"*/"},this.getNextLineIndent=function(e,t,n){var r=this.$getIndent(t),i=this.getTokenizer().getLineTokens(t,e),s=i.tokens,o=i.state;if(s.length&&s[s.length-1].type=="comment")return r;if(e=="start"||e=="no_regex"){var u=t.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);u&&(r+=n)}else if(e=="doc-start"){if(o=="start"||o=="no_regex")return"";var u=t.match(/^\s*(\/?)\*/);u&&(u[1]&&(r+=" "),r+="* ")}return r},this.checkOutdent=function(e,t,n){return this.$outdent.checkOutdent(t,n)},this.autoOutdent=function(e,t,n){this.$outdent.autoOutdent(t,n)},this.createWorker=function(e){var t=new u(["ace"],"ace/mode/javascript_worker","JavaScriptWorker");return t.attachToDocument(e.getDocument()),t.on("annotate",function(t){e.setAnnotations(t.data)}),t.on("terminate",function(){e.clearAnnotations()}),t},this.$id="ace/mode/javascript"}.call(l.prototype),t.Mode=l}),ace.define("ace/mode/css_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("../lib/lang"),s=e("./text_highlight_rules").TextHighlightRules,o=t.supportType="align-content|align-items|align-self|all|animation|animation-delay|animation-direction|animation-duration|animation-fill-mode|animation-iteration-count|animation-name|animation-play-state|animation-timing-function|backface-visibility|background|background-attachment|background-blend-mode|background-clip|background-color|background-image|background-origin|background-position|background-repeat|background-size|border|border-bottom|border-bottom-color|border-bottom-left-radius|border-bottom-right-radius|border-bottom-style|border-bottom-width|border-collapse|border-color|border-image|border-image-outset|border-image-repeat|border-image-slice|border-image-source|border-image-width|border-left|border-left-color|border-left-style|border-left-width|border-radius|border-right|border-right-color|border-right-style|border-right-width|border-spacing|border-style|border-top|border-top-color|border-top-left-radius|border-top-right-radius|border-top-style|border-top-width|border-width|bottom|box-shadow|box-sizing|caption-side|clear|clip|color|column-count|column-fill|column-gap|column-rule|column-rule-color|column-rule-style|column-rule-width|column-span|column-width|columns|content|counter-increment|counter-reset|cursor|direction|display|empty-cells|filter|flex|flex-basis|flex-direction|flex-flow|flex-grow|flex-shrink|flex-wrap|float|font|font-family|font-size|font-size-adjust|font-stretch|font-style|font-variant|font-weight|hanging-punctuation|height|justify-content|left|letter-spacing|line-height|list-style|list-style-image|list-style-position|list-style-type|margin|margin-bottom|margin-left|margin-right|margin-top|max-height|max-width|min-height|min-width|nav-down|nav-index|nav-left|nav-right|nav-up|opacity|order|outline|outline-color|outline-offset|outline-style|outline-width|overflow|overflow-x|overflow-y|padding|padding-bottom|padding-left|padding-right|padding-top|page-break-after|page-break-before|page-break-inside|perspective|perspective-origin|position|quotes|resize|right|tab-size|table-layout|text-align|text-align-last|text-decoration|text-decoration-color|text-decoration-line|text-decoration-style|text-indent|text-justify|text-overflow|text-shadow|text-transform|top|transform|transform-origin|transform-style|transition|transition-delay|transition-duration|transition-property|transition-timing-function|unicode-bidi|vertical-align|visibility|white-space|width|word-break|word-spacing|word-wrap|z-index",u=t.supportFunction="rgb|rgba|url|attr|counter|counters",a=t.supportConstant="absolute|after-edge|after|all-scroll|all|alphabetic|always|antialiased|armenian|auto|avoid-column|avoid-page|avoid|balance|baseline|before-edge|before|below|bidi-override|block-line-height|block|bold|bolder|border-box|both|bottom|box|break-all|break-word|capitalize|caps-height|caption|center|central|char|circle|cjk-ideographic|clone|close-quote|col-resize|collapse|column|consider-shifts|contain|content-box|cover|crosshair|cubic-bezier|dashed|decimal-leading-zero|decimal|default|disabled|disc|disregard-shifts|distribute-all-lines|distribute-letter|distribute-space|distribute|dotted|double|e-resize|ease-in|ease-in-out|ease-out|ease|ellipsis|end|exclude-ruby|fill|fixed|georgian|glyphs|grid-height|groove|hand|hanging|hebrew|help|hidden|hiragana-iroha|hiragana|horizontal|icon|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space|ideographic|inactive|include-ruby|inherit|initial|inline-block|inline-box|inline-line-height|inline-table|inline|inset|inside|inter-ideograph|inter-word|invert|italic|justify|katakana-iroha|katakana|keep-all|last|left|lighter|line-edge|line-through|line|linear|list-item|local|loose|lower-alpha|lower-greek|lower-latin|lower-roman|lowercase|lr-tb|ltr|mathematical|max-height|max-size|medium|menu|message-box|middle|move|n-resize|ne-resize|newspaper|no-change|no-close-quote|no-drop|no-open-quote|no-repeat|none|normal|not-allowed|nowrap|nw-resize|oblique|open-quote|outset|outside|overline|padding-box|page|pointer|pre-line|pre-wrap|pre|preserve-3d|progress|relative|repeat-x|repeat-y|repeat|replaced|reset-size|ridge|right|round|row-resize|rtl|s-resize|scroll|se-resize|separate|slice|small-caps|small-caption|solid|space|square|start|static|status-bar|step-end|step-start|steps|stretch|strict|sub|super|sw-resize|table-caption|table-cell|table-column-group|table-column|table-footer-group|table-header-group|table-row-group|table-row|table|tb-rl|text-after-edge|text-before-edge|text-bottom|text-size|text-top|text|thick|thin|transparent|underline|upper-alpha|upper-latin|upper-roman|uppercase|use-script|vertical-ideographic|vertical-text|visible|w-resize|wait|whitespace|z-index|zero",f=t.supportConstantColor="aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow",l=t.supportConstantFonts="arial|century|comic|courier|cursive|fantasy|garamond|georgia|helvetica|impact|lucida|symbol|system|tahoma|times|trebuchet|utopia|verdana|webdings|sans-serif|serif|monospace",c=t.numRe="\\-?(?:(?:[0-9]+)|(?:[0-9]*\\.[0-9]+))",h=t.pseudoElements="(\\:+)\\b(after|before|first-letter|first-line|moz-selection|selection)\\b",p=t.pseudoClasses="(:)\\b(active|checked|disabled|empty|enabled|first-child|first-of-type|focus|hover|indeterminate|invalid|last-child|last-of-type|link|not|nth-child|nth-last-child|nth-last-of-type|nth-of-type|only-child|only-of-type|required|root|target|valid|visited)\\b",d=function(){var e=this.createKeywordMapper({"support.function":u,"support.constant":a,"support.type":o,"support.constant.color":f,"support.constant.fonts":l},"text",!0);this.$rules={start:[{token:"comment",regex:"\\/\\*",push:"comment"},{token:"paren.lparen",regex:"\\{",push:"ruleset"},{token:"string",regex:"@.*?{",push:"media"},{token:"keyword",regex:"#[a-z0-9-_]+"},{token:"variable",regex:"\\.[a-z0-9-_]+"},{token:"string",regex:":[a-z0-9-_]+"},{token:"constant",regex:"[a-z0-9-_]+"},{caseInsensitive:!0}],media:[{token:"comment",regex:"\\/\\*",push:"comment"},{token:"paren.lparen",regex:"\\{",push:"ruleset"},{token:"string",regex:"\\}",next:"pop"},{token:"keyword",regex:"#[a-z0-9-_]+"},{token:"variable",regex:"\\.[a-z0-9-_]+"},{token:"string",regex:":[a-z0-9-_]+"},{token:"constant",regex:"[a-z0-9-_]+"},{caseInsensitive:!0}],comment:[{token:"comment",regex:"\\*\\/",next:"pop"},{defaultToken:"comment"}],ruleset:[{token:"paren.rparen",regex:"\\}",next:"pop"},{token:"comment",regex:"\\/\\*",push:"comment"},{token:"string",regex:'["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'},{token:"string",regex:"['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"},{token:["constant.numeric","keyword"],regex:"("+c+")(ch|cm|deg|em|ex|fr|gd|grad|Hz|in|kHz|mm|ms|pc|pt|px|rad|rem|s|turn|vh|vm|vw|%)"},{token:"constant.numeric",regex:c},{token:"constant.numeric",regex:"#[a-f0-9]{6}"},{token:"constant.numeric",regex:"#[a-f0-9]{3}"},{token:["punctuation","entity.other.attribute-name.pseudo-element.css"],regex:h},{token:["punctuation","entity.other.attribute-name.pseudo-class.css"],regex:p},{token:["support.function","string","support.function"],regex:"(url\\()(.*)(\\))"},{token:e,regex:"\\-?[a-zA-Z_][a-zA-Z0-9_\\-]*"},{caseInsensitive:!0}]},this.normalizeRules()};r.inherits(d,s),t.CssHighlightRules=d}),ace.define("ace/mode/css_completions",["require","exports","module"],function(e,t,n){"use strict";var r={background:{"#$0":1},"background-color":{"#$0":1,transparent:1,fixed:1},"background-image":{"url('/$0')":1},"background-repeat":{repeat:1,"repeat-x":1,"repeat-y":1,"no-repeat":1,inherit:1},"background-position":{bottom:2,center:2,left:2,right:2,top:2,inherit:2},"background-attachment":{scroll:1,fixed:1},"background-size":{cover:1,contain:1},"background-clip":{"border-box":1,"padding-box":1,"content-box":1},"background-origin":{"border-box":1,"padding-box":1,"content-box":1},border:{"solid $0":1,"dashed $0":1,"dotted $0":1,"#$0":1},"border-color":{"#$0":1},"border-style":{solid:2,dashed:2,dotted:2,"double":2,groove:2,hidden:2,inherit:2,inset:2,none:2,outset:2,ridged:2},"border-collapse":{collapse:1,separate:1},bottom:{px:1,em:1,"%":1},clear:{left:1,right:1,both:1,none:1},color:{"#$0":1,"rgb(#$00,0,0)":1},cursor:{"default":1,pointer:1,move:1,text:1,wait:1,help:1,progress:1,"n-resize":1,"ne-resize":1,"e-resize":1,"se-resize":1,"s-resize":1,"sw-resize":1,"w-resize":1,"nw-resize":1},display:{none:1,block:1,inline:1,"inline-block":1,"table-cell":1},"empty-cells":{show:1,hide:1},"float":{left:1,right:1,none:1},"font-family":{Arial:2,"Comic Sans MS":2,Consolas:2,"Courier New":2,Courier:2,Georgia:2,Monospace:2,"Sans-Serif":2,"Segoe UI":2,Tahoma:2,"Times New Roman":2,"Trebuchet MS":2,Verdana:1},"font-size":{px:1,em:1,"%":1},"font-weight":{bold:1,normal:1},"font-style":{italic:1,normal:1},"font-variant":{normal:1,"small-caps":1},height:{px:1,em:1,"%":1},left:{px:1,em:1,"%":1},"letter-spacing":{normal:1},"line-height":{normal:1},"list-style-type":{none:1,disc:1,circle:1,square:1,decimal:1,"decimal-leading-zero":1,"lower-roman":1,"upper-roman":1,"lower-greek":1,"lower-latin":1,"upper-latin":1,georgian:1,"lower-alpha":1,"upper-alpha":1},margin:{px:1,em:1,"%":1},"margin-right":{px:1,em:1,"%":1},"margin-left":{px:1,em:1,"%":1},"margin-top":{px:1,em:1,"%":1},"margin-bottom":{px:1,em:1,"%":1},"max-height":{px:1,em:1,"%":1},"max-width":{px:1,em:1,"%":1},"min-height":{px:1,em:1,"%":1},"min-width":{px:1,em:1,"%":1},overflow:{hidden:1,visible:1,auto:1,scroll:1},"overflow-x":{hidden:1,visible:1,auto:1,scroll:1},"overflow-y":{hidden:1,visible:1,auto:1,scroll:1},padding:{px:1,em:1,"%":1},"padding-top":{px:1,em:1,"%":1},"padding-right":{px:1,em:1,"%":1},"padding-bottom":{px:1,em:1,"%":1},"padding-left":{px:1,em:1,"%":1},"page-break-after":{auto:1,always:1,avoid:1,left:1,right:1},"page-break-before":{auto:1,always:1,avoid:1,left:1,right:1},position:{absolute:1,relative:1,fixed:1,"static":1},right:{px:1,em:1,"%":1},"table-layout":{fixed:1,auto:1},"text-decoration":{none:1,underline:1,"line-through":1,blink:1},"text-align":{left:1,right:1,center:1,justify:1},"text-transform":{capitalize:1,uppercase:1,lowercase:1,none:1},top:{px:1,em:1,"%":1},"vertical-align":{top:1,bottom:1},visibility:{hidden:1,visible:1},"white-space":{nowrap:1,normal:1,pre:1,"pre-line":1,"pre-wrap":1},width:{px:1,em:1,"%":1},"word-spacing":{normal:1},filter:{"alpha(opacity=$0100)":1},"text-shadow":{"$02px 2px 2px #777":1},"text-overflow":{"ellipsis-word":1,clip:1,ellipsis:1},"-moz-border-radius":1,"-moz-border-radius-topright":1,"-moz-border-radius-bottomright":1,"-moz-border-radius-topleft":1,"-moz-border-radius-bottomleft":1,"-webkit-border-radius":1,"-webkit-border-top-right-radius":1,"-webkit-border-top-left-radius":1,"-webkit-border-bottom-right-radius":1,"-webkit-border-bottom-left-radius":1,"-moz-box-shadow":1,"-webkit-box-shadow":1,transform:{"rotate($00deg)":1,"skew($00deg)":1},"-moz-transform":{"rotate($00deg)":1,"skew($00deg)":1},"-webkit-transform":{"rotate($00deg)":1,"skew($00deg)":1}},i=function(){};(function(){this.completionsDefined=!1,this.defineCompletions=function(){if(document){var e=document.createElement("c").style;for(var t in e){if(typeof e[t]!="string")continue;var n=t.replace(/[A-Z]/g,function(e){return"-"+e.toLowerCase()});r.hasOwnProperty(n)||(r[n]=1)}}this.completionsDefined=!0},this.getCompletions=function(e,t,n,r){this.completionsDefined||this.defineCompletions();var i=t.getTokenAt(n.row,n.column);if(!i)return[];if(e==="ruleset"){var s=t.getLine(n.row).substr(0,n.column);return/:[^;]+$/.test(s)?(/([\w\-]+):[^:]*$/.test(s),this.getPropertyValueCompletions(e,t,n,r)):this.getPropertyCompletions(e,t,n,r)}return[]},this.getPropertyCompletions=function(e,t,n,i){var s=Object.keys(r);return s.map(function(e){return{caption:e,snippet:e+": $0",meta:"property",score:Number.MAX_VALUE}})},this.getPropertyValueCompletions=function(e,t,n,i){var s=t.getLine(n.row).substr(0,n.column),o=(/([\w\-]+):[^:]*$/.exec(s)||{})[1];if(!o)return[];var u=[];return o in r&&typeof r[o]=="object"&&(u=Object.keys(r[o])),u.map(function(e){return{caption:e,snippet:e,meta:"property value",score:Number.MAX_VALUE}})}}).call(i.prototype),t.CssCompletions=i}),ace.define("ace/mode/behaviour/css",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/mode/behaviour/cstyle","ace/token_iterator"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("../behaviour").Behaviour,s=e("./cstyle").CstyleBehaviour,o=e("../../token_iterator").TokenIterator,u=function(){this.inherit(s),this.add("colon","insertion",function(e,t,n,r,i){if(i===":"){var s=n.getCursorPosition(),u=new o(r,s.row,s.column),a=u.getCurrentToken();a&&a.value.match(/\s+/)&&(a=u.stepBackward());if(a&&a.type==="support.type"){var f=r.doc.getLine(s.row),l=f.substring(s.column,s.column+1);if(l===":")return{text:"",selection:[1,1]};if(!f.substring(s.column).match(/^\s*;/))return{text:":;",selection:[1,1]}}}}),this.add("colon","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&s===":"){var u=n.getCursorPosition(),a=new o(r,u.row,u.column),f=a.getCurrentToken();f&&f.value.match(/\s+/)&&(f=a.stepBackward());if(f&&f.type==="support.type"){var l=r.doc.getLine(i.start.row),c=l.substring(i.end.column,i.end.column+1);if(c===";")return i.end.column++,i}}}),this.add("semicolon","insertion",function(e,t,n,r,i){if(i===";"){var s=n.getCursorPosition(),o=r.doc.getLine(s.row),u=o.substring(s.column,s.column+1);if(u===";")return{text:"",selection:[1,1]}}})};r.inherits(u,s),t.CssBehaviour=u}),ace.define("ace/mode/css",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/css_highlight_rules","ace/mode/matching_brace_outdent","ace/worker/worker_client","ace/mode/css_completions","ace/mode/behaviour/css","ace/mode/folding/cstyle"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text").Mode,s=e("./css_highlight_rules").CssHighlightRules,o=e("./matching_brace_outdent").MatchingBraceOutdent,u=e("../worker/worker_client").WorkerClient,a=e("./css_completions").CssCompletions,f=e("./behaviour/css").CssBehaviour,l=e("./folding/cstyle").FoldMode,c=function(){this.HighlightRules=s,this.$outdent=new o,this.$behaviour=new f,this.$completer=new a,this.foldingRules=new l};r.inherits(c,i),function(){this.foldingRules="cStyle",this.blockComment={start:"/*",end:"*/"},this.getNextLineIndent=function(e,t,n){var r=this.$getIndent(t),i=this.getTokenizer().getLineTokens(t,e).tokens;if(i.length&&i[i.length-1].type=="comment")return r;var s=t.match(/^.*\{\s*$/);return s&&(r+=n),r},this.checkOutdent=function(e,t,n){return this.$outdent.checkOutdent(t,n)},this.autoOutdent=function(e,t,n){this.$outdent.autoOutdent(t,n)},this.getCompletions=function(e,t,n,r){return this.$completer.getCompletions(e,t,n,r)},this.createWorker=function(e){var t=new u(["ace"],"ace/mode/css_worker","Worker");return t.attachToDocument(e.getDocument()),t.on("annotate",function(t){e.setAnnotations(t.data)}),t.on("terminate",function(){e.clearAnnotations()}),t},this.$id="ace/mode/css"}.call(c.prototype),t.Mode=c}),ace.define("ace/mode/xml_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(e){var t="[_:a-zA-Z\u00c0-\uffff][-_:.a-zA-Z0-9\u00c0-\uffff]*";this.$rules={start:[{token:"string.cdata.xml",regex:"<\\!\\[CDATA\\[",next:"cdata"},{token:["punctuation.xml-decl.xml","keyword.xml-decl.xml"],regex:"(<\\?)(xml)(?=[\\s])",next:"xml_decl",caseInsensitive:!0},{token:["punctuation.instruction.xml","keyword.instruction.xml"],regex:"(<\\?)("+t+")",next:"processing_instruction"},{token:"comment.xml",regex:"<\\!--",next:"comment"},{token:["xml-pe.doctype.xml","xml-pe.doctype.xml"],regex:"(<\\!)(DOCTYPE)(?=[\\s])",next:"doctype",caseInsensitive:!0},{include:"tag"},{token:"text.end-tag-open.xml",regex:"</"},{token:"text.tag-open.xml",regex:"<"},{include:"reference"},{defaultToken:"text.xml"}],xml_decl:[{token:"entity.other.attribute-name.decl-attribute-name.xml",regex:"(?:"+t+":)?"+t+""},{token:"keyword.operator.decl-attribute-equals.xml",regex:"="},{include:"whitespace"},{include:"string"},{token:"punctuation.xml-decl.xml",regex:"\\?>",next:"start"}],processing_instruction:[{token:"punctuation.instruction.xml",regex:"\\?>",next:"start"},{defaultToken:"instruction.xml"}],doctype:[{include:"whitespace"},{include:"string"},{token:"xml-pe.doctype.xml",regex:">",next:"start"},{token:"xml-pe.xml",regex:"[-_a-zA-Z0-9:]+"},{token:"punctuation.int-subset",regex:"\\[",push:"int_subset"}],int_subset:[{token:"text.xml",regex:"\\s+"},{token:"punctuation.int-subset.xml",regex:"]",next:"pop"},{token:["punctuation.markup-decl.xml","keyword.markup-decl.xml"],regex:"(<\\!)("+t+")",push:[{token:"text",regex:"\\s+"},{token:"punctuation.markup-decl.xml",regex:">",next:"pop"},{include:"string"}]}],cdata:[{token:"string.cdata.xml",regex:"\\]\\]>",next:"start"},{token:"text.xml",regex:"\\s+"},{token:"text.xml",regex:"(?:[^\\]]|\\](?!\\]>))+"}],comment:[{token:"comment.xml",regex:"-->",next:"start"},{defaultToken:"comment.xml"}],reference:[{token:"constant.language.escape.reference.xml",regex:"(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"}],attr_reference:[{token:"constant.language.escape.reference.attribute-value.xml",regex:"(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"}],tag:[{token:["meta.tag.punctuation.tag-open.xml","meta.tag.punctuation.end-tag-open.xml","meta.tag.tag-name.xml"],regex:"(?:(<)|(</))((?:"+t+":)?"+t+")",next:[{include:"attributes"},{token:"meta.tag.punctuation.tag-close.xml",regex:"/?>",next:"start"}]}],tag_whitespace:[{token:"text.tag-whitespace.xml",regex:"\\s+"}],whitespace:[{token:"text.whitespace.xml",regex:"\\s+"}],string:[{token:"string.xml",regex:"'",push:[{token:"string.xml",regex:"'",next:"pop"},{defaultToken:"string.xml"}]},{token:"string.xml",regex:'"',push:[{token:"string.xml",regex:'"',next:"pop"},{defaultToken:"string.xml"}]}],attributes:[{token:"entity.other.attribute-name.xml",regex:"(?:"+t+":)?"+t+""},{token:"keyword.operator.attribute-equals.xml",regex:"="},{include:"tag_whitespace"},{include:"attribute_value"}],attribute_value:[{token:"string.attribute-value.xml",regex:"'",push:[{token:"string.attribute-value.xml",regex:"'",next:"pop"},{include:"attr_reference"},{defaultToken:"string.attribute-value.xml"}]},{token:"string.attribute-value.xml",regex:'"',push:[{token:"string.attribute-value.xml",regex:'"',next:"pop"},{include:"attr_reference"},{defaultToken:"string.attribute-value.xml"}]}]},this.constructor===s&&this.normalizeRules()};(function(){this.embedTagRules=function(e,t,n){this.$rules.tag.unshift({token:["meta.tag.punctuation.tag-open.xml","meta.tag."+n+".tag-name.xml"],regex:"(<)("+n+"(?=\\s|>|$))",next:[{include:"attributes"},{token:"meta.tag.punctuation.tag-close.xml",regex:"/?>",next:t+"start"}]}),this.$rules[n+"-end"]=[{include:"attributes"},{token:"meta.tag.punctuation.tag-close.xml",regex:"/?>",next:"start",onMatch:function(e,t,n){return n.splice(0),this.token}}],this.embedRules(e,t,[{token:["meta.tag.punctuation.end-tag-open.xml","meta.tag."+n+".tag-name.xml"],regex:"(</)("+n+"(?=\\s|>|$))",next:n+"-end"},{token:"string.cdata.xml",regex:"<\\!\\[CDATA\\["},{token:"string.cdata.xml",regex:"\\]\\]>"}])}}).call(i.prototype),r.inherits(s,i),t.XmlHighlightRules=s}),ace.define("ace/mode/html_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/css_highlight_rules","ace/mode/javascript_highlight_rules","ace/mode/xml_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("../lib/lang"),s=e("./css_highlight_rules").CssHighlightRules,o=e("./javascript_highlight_rules").JavaScriptHighlightRules,u=e("./xml_highlight_rules").XmlHighlightRules,a=i.createMap({a:"anchor",button:"form",form:"form",img:"image",input:"form",label:"form",option:"form",script:"script",select:"form",textarea:"form",style:"style",table:"table",tbody:"table",td:"table",tfoot:"table",th:"table",tr:"table"}),f=function(){u.call(this),this.addRules({attributes:[{include:"tag_whitespace"},{token:"entity.other.attribute-name.xml",regex:"[-_a-zA-Z0-9:.]+"},{token:"keyword.operator.attribute-equals.xml",regex:"=",push:[{include:"tag_whitespace"},{token:"string.unquoted.attribute-value.html",regex:"[^<>='\"`\\s]+",next:"pop"},{token:"empty",regex:"",next:"pop"}]},{include:"attribute_value"}],tag:[{token:function(e,t){var n=a[t];return["meta.tag.punctuation."+(e=="<"?"":"end-")+"tag-open.xml","meta.tag"+(n?"."+n:"")+".tag-name.xml"]},regex:"(</?)([-_a-zA-Z0-9:.]+)",next:"tag_stuff"}],tag_stuff:[{include:"attributes"},{token:"meta.tag.punctuation.tag-close.xml",regex:"/?>",next:"start"}]}),this.embedTagRules(s,"css-","style"),this.embedTagRules((new o({jsx:!1})).getRules(),"js-","script"),this.constructor===f&&this.normalizeRules()};r.inherits(f,u),t.HtmlHighlightRules=f}),ace.define("ace/mode/behaviour/xml",["require","exports","module","ace/lib/oop","ace/mode/behaviour","ace/token_iterator","ace/lib/lang"],function(e,t,n){"use strict";function u(e,t){return e.type.lastIndexOf(t+".xml")>-1}var r=e("../../lib/oop"),i=e("../behaviour").Behaviour,s=e("../../token_iterator").TokenIterator,o=e("../../lib/lang"),a=function(){this.add("string_dquotes","insertion",function(e,t,n,r,i){if(i=='"'||i=="'"){var o=i,a=r.doc.getTextRange(n.getSelectionRange());if(a!==""&&a!=="'"&&a!='"'&&n.getWrapBehavioursEnabled())return{text:o+a+o,selection:!1};var f=n.getCursorPosition(),l=r.doc.getLine(f.row),c=l.substring(f.column,f.column+1),h=new s(r,f.row,f.column),p=h.getCurrentToken();if(c==o&&(u(p,"attribute-value")||u(p,"string")))return{text:"",selection:[1,1]};p||(p=h.stepBackward());if(!p)return;while(u(p,"tag-whitespace")||u(p,"whitespace"))p=h.stepBackward();var d=!c||c.match(/\s/);if(u(p,"attribute-equals")&&(d||c==">")||u(p,"decl-attribute-equals")&&(d||c=="?"))return{text:o+o,selection:[1,1]}}}),this.add("string_dquotes","deletion",function(e,t,n,r,i){var s=r.doc.getTextRange(i);if(!i.isMultiLine()&&(s=='"'||s=="'")){var o=r.doc.getLine(i.start.row),u=o.substring(i.start.column+1,i.start.column+2);if(u==s)return i.end.column++,i}}),this.add("autoclosing","insertion",function(e,t,n,r,i){if(i==">"){var o=n.getSelectionRange().start,a=new s(r,o.row,o.column),f=a.getCurrentToken()||a.stepBackward();if(!f||!(u(f,"tag-name")||u(f,"tag-whitespace")||u(f,"attribute-name")||u(f,"attribute-equals")||u(f,"attribute-value")))return;if(u(f,"reference.attribute-value"))return;if(u(f,"attribute-value")){var l=f.value.charAt(0);if(l=='"'||l=="'"){var c=f.value.charAt(f.value.length-1),h=a.getCurrentTokenColumn()+f.value.length;if(h>o.column||h==o.column&&l!=c)return}}while(!u(f,"tag-name")){f=a.stepBackward();if(f.value=="<"){f=a.stepForward();break}}var p=a.getCurrentTokenRow(),d=a.getCurrentTokenColumn();if(u(a.stepBackward(),"end-tag-open"))return;var v=f.value;p==o.row&&(v=v.substring(0,o.column-d));if(this.voidElements.hasOwnProperty(v.toLowerCase()))return;return{text:"></"+v+">",selection:[1,1]}}}),this.add("autoindent","insertion",function(e,t,n,r,i){if(i=="\n"){var o=n.getCursorPosition(),u=r.getLine(o.row),a=new s(r,o.row,o.column),f=a.getCurrentToken();if(f&&f.type.indexOf("tag-close")!==-1){if(f.value=="/>")return;while(f&&f.type.indexOf("tag-name")===-1)f=a.stepBackward();if(!f)return;var l=f.value,c=a.getCurrentTokenRow();f=a.stepBackward();if(!f||f.type.indexOf("end-tag")!==-1)return;if(this.voidElements&&!this.voidElements[l]){var h=r.getTokenAt(o.row,o.column+1),u=r.getLine(c),p=this.$getIndent(u),d=p+r.getTabString();return h&&h.value==="</"?{text:"\n"+d+"\n"+p,selection:[1,d.length,1,d.length]}:{text:"\n"+d}}}}})};r.inherits(a,i),t.XmlBehaviour=a}),ace.define("ace/mode/folding/mixed",["require","exports","module","ace/lib/oop","ace/mode/folding/fold_mode"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("./fold_mode").FoldMode,s=t.FoldMode=function(e,t){this.defaultMode=e,this.subModes=t};r.inherits(s,i),function(){this.$getMode=function(e){typeof e!="string"&&(e=e[0]);for(var t in this.subModes)if(e.indexOf(t)===0)return this.subModes[t];return null},this.$tryMode=function(e,t,n,r){var i=this.$getMode(e);return i?i.getFoldWidget(t,n,r):""},this.getFoldWidget=function(e,t,n){return this.$tryMode(e.getState(n-1),e,t,n)||this.$tryMode(e.getState(n),e,t,n)||this.defaultMode.getFoldWidget(e,t,n)},this.getFoldWidgetRange=function(e,t,n){var r=this.$getMode(e.getState(n-1));if(!r||!r.getFoldWidget(e,t,n))r=this.$getMode(e.getState(n));if(!r||!r.getFoldWidget(e,t,n))r=this.defaultMode;return r.getFoldWidgetRange(e,t,n)}}.call(s.prototype)}),ace.define("ace/mode/folding/xml",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/range","ace/mode/folding/fold_mode","ace/token_iterator"],function(e,t,n){"use strict";function l(e,t){return e.type.lastIndexOf(t+".xml")>-1}var r=e("../../lib/oop"),i=e("../../lib/lang"),s=e("../../range").Range,o=e("./fold_mode").FoldMode,u=e("../../token_iterator").TokenIterator,a=t.FoldMode=function(e,t){o.call(this),this.voidElements=e||{},this.optionalEndTags=r.mixin({},this.voidElements),t&&r.mixin(this.optionalEndTags,t)};r.inherits(a,o);var f=function(){this.tagName="",this.closing=!1,this.selfClosing=!1,this.start={row:0,column:0},this.end={row:0,column:0}};(function(){this.getFoldWidget=function(e,t,n){var r=this._getFirstTagInLine(e,n);return r?r.closing||!r.tagName&&r.selfClosing?t=="markbeginend"?"end":"":!r.tagName||r.selfClosing||this.voidElements.hasOwnProperty(r.tagName.toLowerCase())?"":this._findEndTagInLine(e,n,r.tagName,r.end.column)?"":"start":""},this._getFirstTagInLine=function(e,t){var n=e.getTokens(t),r=new f;for(var i=0;i<n.length;i++){var s=n[i];if(l(s,"tag-open")){r.end.column=r.start.column+s.value.length,r.closing=l(s,"end-tag-open"),s=n[++i];if(!s)return null;r.tagName=s.value,r.end.column+=s.value.length;for(i++;i<n.length;i++){s=n[i],r.end.column+=s.value.length;if(l(s,"tag-close")){r.selfClosing=s.value=="/>";break}}return r}if(l(s,"tag-close"))return r.selfClosing=s.value=="/>",r;r.start.column+=s.value.length}return null},this._findEndTagInLine=function(e,t,n,r){var i=e.getTokens(t),s=0;for(var o=0;o<i.length;o++){var u=i[o];s+=u.value.length;if(s<r)continue;if(l(u,"end-tag-open")){u=i[o+1];if(u&&u.value==n)return!0}}return!1},this._readTagForward=function(e){var t=e.getCurrentToken();if(!t)return null;var n=new f;do if(l(t,"tag-open"))n.closing=l(t,"end-tag-open"),n.start.row=e.getCurrentTokenRow(),n.start.column=e.getCurrentTokenColumn();else if(l(t,"tag-name"))n.tagName=t.value;else if(l(t,"tag-close"))return n.selfClosing=t.value=="/>",n.end.row=e.getCurrentTokenRow(),n.end.column=e.getCurrentTokenColumn()+t.value.length,e.stepForward(),n;while(t=e.stepForward());return null},this._readTagBackward=function(e){var t=e.getCurrentToken();if(!t)return null;var n=new f;do{if(l(t,"tag-open"))return n.closing=l(t,"end-tag-open"),n.start.row=e.getCurrentTokenRow(),n.start.column=e.getCurrentTokenColumn(),e.stepBackward(),n;l(t,"tag-name")?n.tagName=t.value:l(t,"tag-close")&&(n.selfClosing=t.value=="/>",n.end.row=e.getCurrentTokenRow(),n.end.column=e.getCurrentTokenColumn()+t.value.length)}while(t=e.stepBackward());return null},this._pop=function(e,t){while(e.length){var n=e[e.length-1];if(!t||n.tagName==t.tagName)return e.pop();if(this.optionalEndTags.hasOwnProperty(n.tagName)){e.pop();continue}return null}},this.getFoldWidgetRange=function(e,t,n){var r=this._getFirstTagInLine(e,n);if(!r)return null;var i=r.closing||r.selfClosing,o=[],a;if(!i){var f=new u(e,n,r.start.column),l={row:n,column:r.start.column+r.tagName.length+2};r.start.row==r.end.row&&(l.column=r.end.column);while(a=this._readTagForward(f)){if(a.selfClosing){if(!o.length)return a.start.column+=a.tagName.length+2,a.end.column-=2,s.fromPoints(a.start,a.end);continue}if(a.closing){this._pop(o,a);if(o.length==0)return s.fromPoints(l,a.start)}else o.push(a)}}else{var f=new u(e,n,r.end.column),c={row:n,column:r.start.column};while(a=this._readTagBackward(f)){if(a.selfClosing){if(!o.length)return a.start.column+=a.tagName.length+2,a.end.column-=2,s.fromPoints(a.start,a.end);continue}if(!a.closing){this._pop(o,a);if(o.length==0)return a.start.column+=a.tagName.length+2,a.start.row==a.end.row&&a.start.column<a.end.column&&(a.start.column=a.end.column),s.fromPoints(a.start,c)}else o.push(a)}}}}).call(a.prototype)}),ace.define("ace/mode/folding/html",["require","exports","module","ace/lib/oop","ace/mode/folding/mixed","ace/mode/folding/xml","ace/mode/folding/cstyle"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("./mixed").FoldMode,s=e("./xml").FoldMode,o=e("./cstyle").FoldMode,u=t.FoldMode=function(e,t){i.call(this,new s(e,t),{"js-":new o,"css-":new o})};r.inherits(u,i)}),ace.define("ace/mode/html_completions",["require","exports","module","ace/token_iterator"],function(e,t,n){"use strict";function f(e,t){return e.type.lastIndexOf(t+".xml")>-1}function l(e,t){var n=new r(e,t.row,t.column),i=n.getCurrentToken();while(i&&!f(i,"tag-name"))i=n.stepBackward();if(i)return i.value}function c(e,t){var n=new r(e,t.row,t.column),i=n.getCurrentToken();while(i&&!f(i,"attribute-name"))i=n.stepBackward();if(i)return i.value}var r=e("../token_iterator").TokenIterator,i=["accesskey","class","contenteditable","contextmenu","dir","draggable","dropzone","hidden","id","inert","itemid","itemprop","itemref","itemscope","itemtype","lang","spellcheck","style","tabindex","title","translate"],s=["onabort","onblur","oncancel","oncanplay","oncanplaythrough","onchange","onclick","onclose","oncontextmenu","oncuechange","ondblclick","ondrag","ondragend","ondragenter","ondragleave","ondragover","ondragstart","ondrop","ondurationchange","onemptied","onended","onerror","onfocus","oninput","oninvalid","onkeydown","onkeypress","onkeyup","onload","onloadeddata","onloadedmetadata","onloadstart","onmousedown","onmousemove","onmouseout","onmouseover","onmouseup","onmousewheel","onpause","onplay","onplaying","onprogress","onratechange","onreset","onscroll","onseeked","onseeking","onselect","onshow","onstalled","onsubmit","onsuspend","ontimeupdate","onvolumechange","onwaiting"],o=i.concat(s),u={html:{manifest:1},head:{},title:{},base:{href:1,target:1},link:{href:1,hreflang:1,rel:{stylesheet:1,icon:1},media:{all:1,screen:1,print:1},type:{"text/css":1,"image/png":1,"image/jpeg":1,"image/gif":1},sizes:1},meta:{"http-equiv":{"content-type":1},name:{description:1,keywords:1},content:{"text/html; charset=UTF-8":1},charset:1},style:{type:1,media:{all:1,screen:1,print:1},scoped:1},script:{charset:1,type:{"text/javascript":1},src:1,defer:1,async:1},noscript:{href:1},body:{onafterprint:1,onbeforeprint:1,onbeforeunload:1,onhashchange:1,onmessage:1,onoffline:1,onpopstate:1,onredo:1,onresize:1,onstorage:1,onundo:1,onunload:1},section:{},nav:{},article:{pubdate:1},aside:{},h1:{},h2:{},h3:{},h4:{},h5:{},h6:{},header:{},footer:{},address:{},main:{},p:{},hr:{},pre:{},blockquote:{cite:1},ol:{start:1,reversed:1},ul:{},li:{value:1},dl:{},dt:{},dd:{},figure:{},figcaption:{},div:{},a:{href:1,target:{_blank:1,top:1},ping:1,rel:{nofollow:1,alternate:1,author:1,bookmark:1,help:1,license:1,next:1,noreferrer:1,prefetch:1,prev:1,search:1,tag:1},media:1,hreflang:1,type:1},em:{},strong:{},small:{},s:{},cite:{},q:{cite:1},dfn:{},abbr:{},data:{},time:{datetime:1},code:{},"var":{},samp:{},kbd:{},sub:{},sup:{},i:{},b:{},u:{},mark:{},ruby:{},rt:{},rp:{},bdi:{},bdo:{},span:{},br:{},wbr:{},ins:{cite:1,datetime:1},del:{cite:1,datetime:1},img:{alt:1,src:1,height:1,width:1,usemap:1,ismap:1},iframe:{name:1,src:1,height:1,width:1,sandbox:{"allow-same-origin":1,"allow-top-navigation":1,"allow-forms":1,"allow-scripts":1},seamless:{seamless:1}},embed:{src:1,height:1,width:1,type:1},object:{param:1,data:1,type:1,height:1,width:1,usemap:1,name:1,form:1,classid:1},param:{name:1,value:1},video:{src:1,autobuffer:1,autoplay:{autoplay:1},loop:{loop:1},controls:{controls:1},width:1,height:1,poster:1,muted:{muted:1},preload:{auto:1,metadata:1,none:1}},audio:{src:1,autobuffer:1,autoplay:{autoplay:1},loop:{loop:1},controls:{controls:1},muted:{muted:1},preload:{auto:1,metadata:1,none:1}},source:{src:1,type:1,media:1},track:{kind:1,src:1,srclang:1,label:1,"default":1},canvas:{width:1,height:1},map:{name:1},area:{shape:1,coords:1,href:1,hreflang:1,alt:1,target:1,media:1,rel:1,ping:1,type:1},svg:{},math:{},table:{summary:1},caption:{},colgroup:{span:1},col:{span:1},tbody:{},thead:{},tfoot:{},tr:{},td:{headers:1,rowspan:1,colspan:1},th:{headers:1,rowspan:1,colspan:1,scope:1},form:{"accept-charset":1,action:1,autocomplete:1,enctype:{"multipart/form-data":1,"application/x-www-form-urlencoded":1},method:{get:1,post:1},name:1,novalidate:1,target:{_blank:1,top:1}},fieldset:{disabled:1,form:1,name:1},legend:{},label:{form:1,"for":1},input:{type:{text:1,password:1,hidden:1,checkbox:1,submit:1,radio:1,file:1,button:1,reset:1,image:31,color:1,date:1,datetime:1,"datetime-local":1,email:1,month:1,number:1,range:1,search:1,tel:1,time:1,url:1,week:1},accept:1,alt:1,autocomplete:{on:1,off:1},autofocus:{autofocus:1},checked:{checked:1},disabled:{disabled:1},form:1,formaction:1,formenctype:{"application/x-www-form-urlencoded":1,"multipart/form-data":1,"text/plain":1},formmethod:{get:1,post:1},formnovalidate:{formnovalidate:1},formtarget:{_blank:1,_self:1,_parent:1,_top:1},height:1,list:1,max:1,maxlength:1,min:1,multiple:{multiple:1},name:1,pattern:1,placeholder:1,readonly:{readonly:1},required:{required:1},size:1,src:1,step:1,width:1,files:1,value:1},button:{autofocus:1,disabled:{disabled:1},form:1,formaction:1,formenctype:1,formmethod:1,formnovalidate:1,formtarget:1,name:1,value:1,type:{button:1,submit:1}},select:{autofocus:1,disabled:1,form:1,multiple:{multiple:1},name:1,size:1,readonly:{readonly:1}},datalist:{},optgroup:{disabled:1,label:1},option:{disabled:1,selected:1,label:1,value:1},textarea:{autofocus:{autofocus:1},disabled:{disabled:1},form:1,maxlength:1,name:1,placeholder:1,readonly:{readonly:1},required:{required:1},rows:1,cols:1,wrap:{on:1,off:1,hard:1,soft:1}},keygen:{autofocus:1,challenge:{challenge:1},disabled:{disabled:1},form:1,keytype:{rsa:1,dsa:1,ec:1},name:1},output:{"for":1,form:1,name:1},progress:{value:1,max:1},meter:{value:1,min:1,max:1,low:1,high:1,optimum:1},details:{open:1},summary:{},command:{type:1,label:1,icon:1,disabled:1,checked:1,radiogroup:1,command:1},menu:{type:1,label:1},dialog:{open:1}},a=Object.keys(u),h=function(){};(function(){this.getCompletions=function(e,t,n,r){var i=t.getTokenAt(n.row,n.column);if(!i)return[];if(f(i,"tag-name")||f(i,"tag-open")||f(i,"end-tag-open"))return this.getTagCompletions(e,t,n,r);if(f(i,"tag-whitespace")||f(i,"attribute-name"))return this.getAttributeCompletions(e,t,n,r);if(f(i,"attribute-value"))return this.getAttributeValueCompletions(e,t,n,r);var s=t.getLine(n.row).substr(0,n.column);return/&[a-z]*$/i.test(s)?this.getHTMLEntityCompletions(e,t,n,r):[]},this.getTagCompletions=function(e,t,n,r){return a.map(function(e){return{value:e,meta:"tag",score:Number.MAX_VALUE}})},this.getAttributeCompletions=function(e,t,n,r){var i=l(t,n);if(!i)return[];var s=o;return i in u&&(s=s.concat(Object.keys(u[i]))),s.map(function(e){return{caption:e,snippet:e+'="$0"',meta:"attribute",score:Number.MAX_VALUE}})},this.getAttributeValueCompletions=function(e,t,n,r){var i=l(t,n),s=c(t,n);if(!i)return[];var o=[];return i in u&&s in u[i]&&typeof u[i][s]=="object"&&(o=Object.keys(u[i][s])),o.map(function(e){return{caption:e,snippet:e,meta:"attribute value",score:Number.MAX_VALUE}})},this.getHTMLEntityCompletions=function(e,t,n,r){var i=["Aacute;","aacute;","Acirc;","acirc;","acute;","AElig;","aelig;","Agrave;","agrave;","alefsym;","Alpha;","alpha;","amp;","and;","ang;","Aring;","aring;","asymp;","Atilde;","atilde;","Auml;","auml;","bdquo;","Beta;","beta;","brvbar;","bull;","cap;","Ccedil;","ccedil;","cedil;","cent;","Chi;","chi;","circ;","clubs;","cong;","copy;","crarr;","cup;","curren;","Dagger;","dagger;","dArr;","darr;","deg;","Delta;","delta;","diams;","divide;","Eacute;","eacute;","Ecirc;","ecirc;","Egrave;","egrave;","empty;","emsp;","ensp;","Epsilon;","epsilon;","equiv;","Eta;","eta;","ETH;","eth;","Euml;","euml;","euro;","exist;","fnof;","forall;","frac12;","frac14;","frac34;","frasl;","Gamma;","gamma;","ge;","gt;","hArr;","harr;","hearts;","hellip;","Iacute;","iacute;","Icirc;","icirc;","iexcl;","Igrave;","igrave;","image;","infin;","int;","Iota;","iota;","iquest;","isin;","Iuml;","iuml;","Kappa;","kappa;","Lambda;","lambda;","lang;","laquo;","lArr;","larr;","lceil;","ldquo;","le;","lfloor;","lowast;","loz;","lrm;","lsaquo;","lsquo;","lt;","macr;","mdash;","micro;","middot;","minus;","Mu;","mu;","nabla;","nbsp;","ndash;","ne;","ni;","not;","notin;","nsub;","Ntilde;","ntilde;","Nu;","nu;","Oacute;","oacute;","Ocirc;","ocirc;","OElig;","oelig;","Ograve;","ograve;","oline;","Omega;","omega;","Omicron;","omicron;","oplus;","or;","ordf;","ordm;","Oslash;","oslash;","Otilde;","otilde;","otimes;","Ouml;","ouml;","para;","part;","permil;","perp;","Phi;","phi;","Pi;","pi;","piv;","plusmn;","pound;","Prime;","prime;","prod;","prop;","Psi;","psi;","quot;","radic;","rang;","raquo;","rArr;","rarr;","rceil;","rdquo;","real;","reg;","rfloor;","Rho;","rho;","rlm;","rsaquo;","rsquo;","sbquo;","Scaron;","scaron;","sdot;","sect;","shy;","Sigma;","sigma;","sigmaf;","sim;","spades;","sub;","sube;","sum;","sup;","sup1;","sup2;","sup3;","supe;","szlig;","Tau;","tau;","there4;","Theta;","theta;","thetasym;","thinsp;","THORN;","thorn;","tilde;","times;","trade;","Uacute;","uacute;","uArr;","uarr;","Ucirc;","ucirc;","Ugrave;","ugrave;","uml;","upsih;","Upsilon;","upsilon;","Uuml;","uuml;","weierp;","Xi;","xi;","Yacute;","yacute;","yen;","Yuml;","yuml;","Zeta;","zeta;","zwj;","zwnj;"];return i.map(function(e){return{caption:e,snippet:e,meta:"html entity",score:Number.MAX_VALUE}})}}).call(h.prototype),t.HtmlCompletions=h}),ace.define("ace/mode/html",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/text","ace/mode/javascript","ace/mode/css","ace/mode/html_highlight_rules","ace/mode/behaviour/xml","ace/mode/folding/html","ace/mode/html_completions","ace/worker/worker_client"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("../lib/lang"),s=e("./text").Mode,o=e("./javascript").Mode,u=e("./css").Mode,a=e("./html_highlight_rules").HtmlHighlightRules,f=e("./behaviour/xml").XmlBehaviour,l=e("./folding/html").FoldMode,c=e("./html_completions").HtmlCompletions,h=e("../worker/worker_client").WorkerClient,p=["area","base","br","col","embed","hr","img","input","keygen","link","meta","menuitem","param","source","track","wbr"],d=["li","dt","dd","p","rt","rp","optgroup","option","colgroup","td","th"],v=function(e){this.fragmentContext=e&&e.fragmentContext,this.HighlightRules=a,this.$behaviour=new f,this.$completer=new c,this.createModeDelegates({"js-":o,"css-":u}),this.foldingRules=new l(this.voidElements,i.arrayToMap(d))};r.inherits(v,s),function(){this.blockComment={start:"<!--",end:"-->"},this.voidElements=i.arrayToMap(p),this.getNextLineIndent=function(e,t,n){return this.$getIndent(t)},this.checkOutdent=function(e,t,n){return!1},this.getCompletions=function(e,t,n,r){return this.$completer.getCompletions(e,t,n,r)},this.createWorker=function(e){if(this.constructor!=v)return;var t=new h(["ace"],"ace/mode/html_worker","Worker");return t.attachToDocument(e.getDocument()),this.fragmentContext&&t.call("setOptions",[{context:this.fragmentContext}]),t.on("error",function(t){e.setAnnotations(t.data)}),t.on("terminate",function(){e.clearAnnotations()}),t},this.$id="ace/mode/html"}.call(v.prototype),t.Mode=v})

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){this.$rules={start:[{token:"comment.doc.tag",regex:"@[\\w\\d_]+"},s.getTagRule(),{defaultToken:"comment.doc",caseInsensitive:!0}]}};r.inherits(s,i),s.getTagRule=function(e){return{token:"comment.doc.tag.storage.type",regex:"\\b(?:TODO|FIXME|XXX|HACK)\\b"}},s.getStartRule=function(e){return{token:"comment.doc",regex:"\\/\\*(?=\\*)",next:e}},s.getEndRule=function(e){return{token:"comment.doc",regex:"\\*\\/",next:e}},t.DocCommentHighlightRules=s}),ace.define("ace/mode/jsx_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"],function(e,t,n){var r=e("../lib/oop"),i=e("../lib/lang"),s=e("./doc_comment_highlight_rules").DocCommentHighlightRules,o=e("./text_highlight_rules").TextHighlightRules,u=function(){var e=i.arrayToMap("break|do|instanceof|typeof|case|else|new|var|catch|finally|return|void|continue|for|switch|default|while|function|this|if|throw|delete|in|try|class|extends|super|import|from|into|implements|interface|static|mixin|override|abstract|final|number|int|string|boolean|variant|log|assert".split("|")),t=i.arrayToMap("null|true|false|NaN|Infinity|__FILE__|__LINE__|undefined".split("|")),n=i.arrayToMap("debugger|with|const|export|let|private|public|yield|protected|extern|native|as|operator|__fake__|__readonly__".split("|")),r="[a-zA-Z_][a-zA-Z0-9_]*\\b";this.$rules={start:[{token:"comment",regex:"\\/\\/.*$"},s.getStartRule("doc-start"),{token:"comment",regex:"\\/\\*",next:"comment"},{token:"string.regexp",regex:"[/](?:(?:\\[(?:\\\\]|[^\\]])+\\])|(?:\\\\/|[^\\]/]))*[/]\\w*\\s*(?=[).,;]|$)"},{token:"string",regex:'["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'},{token:"string",regex:"['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"},{token:"constant.numeric",regex:"0[xX][0-9a-fA-F]+\\b"},{token:"constant.numeric",regex:"[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"},{token:"constant.language.boolean",regex:"(?:true|false)\\b"},{token:["storage.type","text","entity.name.function"],regex:"(function)(\\s+)("+r+")"},{token:function(r){return r=="this"?"variable.language":r=="function"?"storage.type":e.hasOwnProperty(r)||n.hasOwnProperty(r)?"keyword":t.hasOwnProperty(r)?"constant.language":/^_?[A-Z][a-zA-Z0-9_]*$/.test(r)?"language.support.class":"identifier"},regex:r},{token:"keyword.operator",regex:"!|%|&|\\*|\\-\\-|\\-|\\+\\+|\\+|~|==|=|!=|<=|>=|<<=|>>=|>>>=|<>|<|>|!|&&|\\|\\||\\?\\:|\\*=|%=|\\+=|\\-=|&=|\\^=|\\b(?:in|instanceof|new|delete|typeof|void)"},{token:"punctuation.operator",regex:"\\?|\\:|\\,|\\;|\\."},{token:"paren.lparen",regex:"[[({<]"},{token:"paren.rparen",regex:"[\\])}>]"},{token:"text",regex:"\\s+"}],comment:[{token:"comment",regex:".*?\\*\\/",next:"start"},{token:"comment",regex:".+"}]},this.embedRules(s,"doc-",[s.getEndRule("start")])};r.inherits(u,o),t.JsxHighlightRules=u}),ace.define("ace/mode/matching_brace_outdent",["require","exports","module","ace/range"],function(e,t,n){"use strict";var r=e("../range").Range,i=function(){};(function(){this.checkOutdent=function(e,t){return/^\s+$/.test(e)?/^\s*\}/.test(t):!1},this.autoOutdent=function(e,t){var n=e.getLine(t),i=n.match(/^(\s*\})/);if(!i)return 0;var s=i[1].length,o=e.findMatchingBracket({row:t,column:s});if(!o||o.row==t)return 0;var u=this.$getIndent(e.getLine(o.row));e.replace(new r(t,0,t,s-1),u)},this.$getIndent=function(e){return e.match(/^\s*/)[0]}}).call(i.prototype),t.MatchingBraceOutdent=i}),ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("../../range").Range,s=e("./fold_mode").FoldMode,o=t.FoldMode=function(e){e&&(this.foldingStartMarker=new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/,"|"+e.start)),this.foldingStopMarker=new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/,"|"+e.end)))};r.inherits(o,s),function(){this.foldingStartMarker=/(\{|\[)[^\}\]]*$|^\s*(\/\*)/,this.foldingStopMarker=/^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/,this.singleLineBlockCommentRe=/^\s*(\/\*).*\*\/\s*$/,this.tripleStarBlockCommentRe=/^\s*(\/\*\*\*).*\*\/\s*$/,this.startRegionRe=/^\s*(\/\*|\/\/)#?region\b/,this._getFoldWidgetBase=this.getFoldWidget,this.getFoldWidget=function(e,t,n){var r=e.getLine(n);if(this.singleLineBlockCommentRe.test(r)&&!this.startRegionRe.test(r)&&!this.tripleStarBlockCommentRe.test(r))return"";var i=this._getFoldWidgetBase(e,t,n);return!i&&this.startRegionRe.test(r)?"start":i},this.getFoldWidgetRange=function(e,t,n,r){var i=e.getLine(n);if(this.startRegionRe.test(i))return this.getCommentRegionBlock(e,i,n);var s=i.match(this.foldingStartMarker);if(s){var o=s.index;if(s[1])return this.openingBracketBlock(e,s[1],n,o);var u=e.getCommentFoldRange(n,o+s[0].length,1);return u&&!u.isMultiLine()&&(r?u=this.getSectionRange(e,n):t!="all"&&(u=null)),u}if(t==="markbegin")return;var s=i.match(this.foldingStopMarker);if(s){var o=s.index+s[0].length;return s[1]?this.closingBracketBlock(e,s[1],n,o):e.getCommentFoldRange(n,o,-1)}},this.getSectionRange=function(e,t){var n=e.getLine(t),r=n.search(/\S/),s=t,o=n.length;t+=1;var u=t,a=e.getLength();while(++t<a){n=e.getLine(t);var f=n.search(/\S/);if(f===-1)continue;if(r>f)break;var l=this.getFoldWidgetRange(e,"all",t);if(l){if(l.start.row<=s)break;if(l.isMultiLine())t=l.end.row;else if(r==f)break}u=t}return new i(s,o,u,e.getLine(u).length)},this.getCommentRegionBlock=function(e,t,n){var r=t.search(/\s*$/),s=e.getLength(),o=n,u=/^\s*(?:\/\*|\/\/|--)#?(end)?region\b/,a=1;while(++n<s){t=e.getLine(n);var f=u.exec(t);if(!f)continue;f[1]?a--:a++;if(!a)break}var l=n;if(l>o)return new i(o,r,l,t.length)}}.call(o.prototype)}),ace.define("ace/mode/jsx",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/jsx_highlight_rules","ace/mode/matching_brace_outdent","ace/mode/behaviour/cstyle","ace/mode/folding/cstyle"],function(e,t,n){"use strict";function f(){this.HighlightRules=s,this.$outdent=new o,this.$behaviour=new u,this.foldingRules=new a}var r=e("../lib/oop"),i=e("./text").Mode,s=e("./jsx_highlight_rules").JsxHighlightRules,o=e("./matching_brace_outdent").MatchingBraceOutdent,u=e("./behaviour/cstyle").CstyleBehaviour,a=e("./folding/cstyle").FoldMode;r.inherits(f,i),function(){this.lineCommentStart="//",this.blockComment={start:"/*",end:"*/"},this.getNextLineIndent=function(e,t,n){var r=this.$getIndent(t),i=this.getTokenizer().getLineTokens(t,e),s=i.tokens;if(s.length&&s[s.length-1].type=="comment")return r;if(e=="start"){var o=t.match(/^.*[\{\(\[]\s*$/);o&&(r+=n)}return r},this.checkOutdent=function(e,t,n){return this.$outdent.checkOutdent(t,n)},this.autoOutdent=function(e,t,n){this.$outdent.autoOutdent(t,n)},this.$id="ace/mode/jsx"}.call(f.prototype),t.Mode=f})

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EmbedTitle = exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _inflection = __webpack_require__(520);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SharingPane = __webpack_require__(1240);
	
	var _SharingPane2 = _interopRequireDefault(_SharingPane);
	
	var _AdvancedEmbedPane = __webpack_require__(1211);
	
	var _AdvancedEmbedPane2 = _interopRequireDefault(_AdvancedEmbedPane);
	
	var _embed = __webpack_require__(1232);
	
	var _settings = __webpack_require__(1265);
	
	var _user = __webpack_require__(1127);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        isAdmin: (0, _user.getUserIsAdmin)(state, props),
	        siteUrl: (0, _settings.getSiteUrl)(state, props),
	        secretKey: (0, _settings.getEmbeddingSecretKey)(state, props),
	        isPublicSharingEnabled: (0, _settings.getIsPublicSharingEnabled)(state, props),
	        isApplicationEmbeddingEnabled: (0, _settings.getIsApplicationEmbeddingEnabled)(state, props)
	    };
	};
	
	var EmbedModalContent = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(EmbedModalContent, _Component);
	
	    function EmbedModalContent(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, EmbedModalContent);
	
	        var _this = _possibleConstructorReturn(this, (EmbedModalContent.__proto__ || Object.getPrototypeOf(EmbedModalContent)).call(this, props));
	
	        _this.handleSave = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	            var _resource, _this$state, _embeddingParams, _embedType;
	
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _resource = _this.props.resource;
	                            _this$state = _this.state, _embeddingParams = _this$state.embeddingParams, _embedType = _this$state.embedType;
	
	                            if (!(_embedType === "application")) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            if (_resource.enable_embedding) {
	                                _context.next = 7;
	                                break;
	                            }
	
	                            _context.next = 7;
	                            return _this.props.onUpdateEnableEmbedding(true);
	
	                        case 7:
	                            _context.next = 9;
	                            return _this.props.onUpdateEmbeddingParams(_embeddingParams);
	
	                        case 9:
	                            _context.next = 14;
	                            break;
	
	                        case 11:
	                            if (_resource.public_uuid) {
	                                _context.next = 14;
	                                break;
	                            }
	
	                            _context.next = 14;
	                            return _this.props.onCreatePublicLink();
	
	                        case 14:
	                            _context.next = 20;
	                            break;
	
	                        case 16:
	                            _context.prev = 16;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error(_context.t0);
	                            throw _context.t0;
	
	                        case 20:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[0, 16]]);
	        }));
	        _this.handleUnpublish = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.next = 2;
	                            return _this.props.onUpdateEnableEmbedding(false);
	
	                        case 2:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, _this2);
	        }));
	
	        _this.handleDiscard = function () {
	            var resource = _this.props.resource;
	
	            _this.setState({ embeddingParams: resource.embedding_params || {} });
	        };
	
	        _this.state = {
	            pane: "preview",
	            embedType: null,
	            embeddingParams: props.resource.embedding_params || {},
	            displayOptions: {
	                theme: null,
	                bordered: true,
	                titled: true
	            },
	
	            parameterValues: {}
	        };
	        return _this;
	    }
	
	    _createClass(EmbedModalContent, [{
	        key: "getPreviewParams",
	        value: function getPreviewParams() {
	            var resourceParameters = this.props.resourceParameters;
	            var _state = this.state,
	                embeddingParams = _state.embeddingParams,
	                parameterValues = _state.parameterValues;
	
	            var params = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = resourceParameters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var parameter = _step.value;
	
	                    if (embeddingParams[parameter.slug] === "locked") {
	                        params[parameter.slug] = parameter.id in parameterValues ? parameterValues[parameter.id] : null;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return params;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                siteUrl = _props.siteUrl,
	                secretKey = _props.secretKey,
	                resource = _props.resource,
	                resourceType = _props.resourceType,
	                resourceParameters = _props.resourceParameters,
	                onClose = _props.onClose;
	            var _state2 = this.state,
	                pane = _state2.pane,
	                embedType = _state2.embedType,
	                embeddingParams = _state2.embeddingParams,
	                parameterValues = _state2.parameterValues,
	                displayOptions = _state2.displayOptions;
	
	
	            var params = this.getPreviewParams();
	
	            var previewParameters = resourceParameters.filter(function (p) {
	                return embeddingParams[p.slug] === "locked";
	            });
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex flex-column full-height" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "px2 py1 z1 flex align-center", style: { boxShadow: embedType === "application" ? "0px 8px 15px -9px rgba(0,0,0,0.2)" : undefined } },
	                    _react2.default.createElement(
	                        "h2",
	                        { className: "ml-auto" },
	                        _react2.default.createElement(EmbedTitle, {
	                            onClick: function onClick() {
	                                return _this3.setState({ embedType: null });
	                            },
	                            type: embedType && (0, _inflection.titleize)(embedType)
	                        })
	                    ),
	                    _react2.default.createElement(_Icon2.default, {
	                        className: "text-grey-2 text-grey-4-hover cursor-pointer p2 ml-auto",
	                        name: "close",
	                        size: 24,
	                        onClick: function onClick() {
	                            _analytics2.default.trackEvent("Sharing Modal", "Modal Closed");
	                            onClose();
	                        }
	                    })
	                ),
	                embedType == null ? _react2.default.createElement(
	                    "div",
	                    { className: "flex-full" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ml-auto mr-auto", style: { maxWidth: 1040 } },
	                        _react2.default.createElement(_SharingPane2.default
	                        // $FlowFixMe: Flow doesn't understand these are provided by @connect?
	                        , _extends({}, this.props, {
	                            publicUrl: (0, _embed.getUnsignedPreviewUrl)(siteUrl, resourceType, resource.public_uuid, displayOptions),
	                            iframeUrl: (0, _embed.getUnsignedPreviewUrl)(siteUrl, resourceType, resource.public_uuid, displayOptions),
	                            onChangeEmbedType: function onChangeEmbedType(embedType) {
	                                return _this3.setState({ embedType: embedType });
	                            }
	                        }))
	                    )
	                ) : embedType === "application" ? _react2.default.createElement(
	                    "div",
	                    { className: "flex flex-full" },
	                    _react2.default.createElement(_AdvancedEmbedPane2.default, {
	                        pane: pane,
	                        resource: resource,
	                        resourceType: resourceType,
	                        embedType: embedType,
	                        token: (0, _embed.getSignedToken)(resourceType, resource.id, params, secretKey, embeddingParams),
	                        iframeUrl: (0, _embed.getSignedPreviewUrl)(siteUrl, resourceType, resource.id, params, displayOptions, secretKey, embeddingParams),
	                        siteUrl: siteUrl,
	                        secretKey: secretKey,
	                        params: params,
	                        displayOptions: displayOptions,
	                        previewParameters: previewParameters,
	                        parameterValues: parameterValues,
	                        resourceParameters: resourceParameters,
	                        embeddingParams: embeddingParams,
	                        onChangeDisplayOptions: function onChangeDisplayOptions(displayOptions) {
	                            return _this3.setState({ displayOptions: displayOptions });
	                        },
	                        onChangeEmbeddingParameters: function onChangeEmbeddingParameters(embeddingParams) {
	                            return _this3.setState({ embeddingParams: embeddingParams });
	                        },
	                        onChangeParameterValue: function onChangeParameterValue(id, value) {
	                            return _this3.setState({
	                                parameterValues: _extends({}, parameterValues, _defineProperty({}, id, value))
	                            });
	                        },
	                        onChangePane: function onChangePane(pane) {
	                            return _this3.setState({ pane: pane });
	                        },
	                        onSave: this.handleSave,
	                        onUnpublish: this.handleUnpublish,
	                        onDiscard: this.handleDiscard
	                    })
	                ) : null
	            );
	        }
	    }]);
	
	    return EmbedModalContent;
	}(_react.Component), _class2.defaultProps = {}, _temp)) || _class);
	EmbedModalContent.displayName = "EmbedModalContent";
	exports.default = EmbedModalContent;
	var EmbedTitle = exports.EmbedTitle = function EmbedTitle(_ref3) {
	    var type = _ref3.type,
	        onClick = _ref3.onClick;
	    return _react2.default.createElement(
	        "a",
	        { className: "flex align-center", onClick: onClick },
	        _react2.default.createElement(
	            "span",
	            { className: "text-brand-hover" },
	            "Sharing"
	        ),
	        type && _react2.default.createElement(_Icon2.default, { name: "chevronright", className: "mx1 text-grey-3" }),
	        type
	    );
	};
	EmbedTitle.displayName = "EmbedTitle";

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRetinaImage = __webpack_require__(903);
	
	var _reactRetinaImage2 = _interopRequireDefault(_reactRetinaImage);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Toggle = __webpack_require__(1241);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _CopyWidget = __webpack_require__(1244);
	
	var _CopyWidget2 = _interopRequireDefault(_CopyWidget);
	
	var _Confirm = __webpack_require__(1245);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _code = __webpack_require__(1231);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SharingPane = (_temp2 = _class = function (_Component) {
	    _inherits(SharingPane, _Component);
	
	    function SharingPane() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SharingPane);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SharingPane.__proto__ || Object.getPrototypeOf(SharingPane)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            extension: null
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SharingPane, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                resource = _props.resource,
	                resourceType = _props.resourceType,
	                onCreatePublicLink = _props.onCreatePublicLink,
	                onDisablePublicLink = _props.onDisablePublicLink,
	                extensions = _props.extensions,
	                getPublicUrl = _props.getPublicUrl,
	                onChangeEmbedType = _props.onChangeEmbedType,
	                isAdmin = _props.isAdmin,
	                isPublicSharingEnabled = _props.isPublicSharingEnabled,
	                isApplicationEmbeddingEnabled = _props.isApplicationEmbeddingEnabled;
	
	
	            var publicLink = getPublicUrl(resource, this.state.extension);
	            var iframeSource = (0, _code.getPublicEmbedHTML)(getPublicUrl(resource));
	
	            return _react2.default.createElement(
	                "div",
	                { className: "pt2 ml-auto mr-auto", style: { maxWidth: 600 } },
	                isAdmin && isPublicSharingEnabled && _react2.default.createElement(
	                    "div",
	                    { className: "pb2 mb4 border-bottom flex align-center" },
	                    _react2.default.createElement(
	                        "h4",
	                        null,
	                        "Enable sharing"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ml-auto" },
	                        resource.public_uuid ? _react2.default.createElement(
	                            _Confirm2.default,
	                            {
	                                title: "Disable this public link?",
	                                content: "This will cause the existing link to stop working. You can re-enable it, but when you do it will be a different link.",
	                                action: function action() {
	                                    _analytics2.default.trackEvent("Sharing Modal", "Public Link Disabled", resourceType);
	                                    onDisablePublicLink();
	                                }
	                            },
	                            _react2.default.createElement(_Toggle2.default, { value: true })
	                        ) : _react2.default.createElement(_Toggle2.default, { value: false, onChange: function onChange() {
	                                _analytics2.default.trackEvent("Sharing Modal", "Public Link Enabled", resourceType);
	                                onCreatePublicLink();
	                            } })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)("mb4 flex align-center", { disabled: !resource.public_uuid }) },
	                    _react2.default.createElement(
	                        "div",
	                        { style: { width: 98, height: 63 }, className: "bordered rounded shadowed flex layout-centered" },
	                        _react2.default.createElement(_Icon2.default, { name: "link", size: 32 })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ml2 flex-full" },
	                        _react2.default.createElement(
	                            "h3",
	                            { className: "text-brand mb1" },
	                            "Public link"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "mb1" },
	                            "Share this ",
	                            resourceType,
	                            " with people who don't have a Metabase account using the URL below:"
	                        ),
	                        _react2.default.createElement(_CopyWidget2.default, { value: publicLink }),
	                        extensions && extensions.length > 0 && _react2.default.createElement(
	                            "div",
	                            { className: "mt1" },
	                            extensions.map(function (extension) {
	                                return _react2.default.createElement(
	                                    "span",
	                                    {
	                                        className: (0, _classnames2.default)("cursor-pointer text-brand-hover text-bold text-uppercase", extension === _this2.state.extension ? "text-brand" : "text-grey-2"),
	                                        onClick: function onClick() {
	                                            return _this2.setState({ extension: extension === _this2.state.extension ? null : extension });
	                                        }
	                                    },
	                                    extension,
	                                    " "
	                                );
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)("mb4 flex align-center", { disabled: !resource.public_uuid }) },
	                    _react2.default.createElement(_reactRetinaImage2.default, {
	                        width: 98,
	                        src: "app/assets/img/simple_embed.png",
	                        forceOriginalDimensions: false
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ml2 flex-full" },
	                        _react2.default.createElement(
	                            "h3",
	                            { className: "text-green mb1" },
	                            "Public embed"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "mb1" },
	                            "Embed this ",
	                            resourceType,
	                            " in blog posts or web pages by copying and pasting this snippet:"
	                        ),
	                        _react2.default.createElement(_CopyWidget2.default, { value: iframeSource })
	                    )
	                ),
	                isAdmin && _react2.default.createElement(
	                    "div",
	                    {
	                        className: (0, _classnames2.default)("mb4 flex align-center cursor-pointer", { disabled: !isApplicationEmbeddingEnabled }),
	                        onClick: function onClick() {
	                            return onChangeEmbedType("application");
	                        }
	                    },
	                    _react2.default.createElement(_reactRetinaImage2.default, {
	                        width: 100,
	                        src: "app/assets/img/secure_embed.png",
	                        forceOriginalDimensions: false
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ml2 flex-full" },
	                        _react2.default.createElement(
	                            "h3",
	                            { className: "text-purple mb1" },
	                            "Embed this ",
	                            resourceType,
	                            " in an application"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "" },
	                            "By integrating with your application server code, you can provide a secure stats ",
	                            resourceType,
	                            " limited to a specific user, customer, organization, etc."
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SharingPane;
	}(_react.Component), _class.defaultProps = {
	    extensions: []
	}, _temp2);
	SharingPane.displayName = "SharingPane";
	exports.default = SharingPane;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Toggle = __webpack_require__(1242);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toggle = (_temp = _class = function (_Component) {
	    _inherits(Toggle, _Component);
	
	    function Toggle(props, context) {
	        _classCallCheck(this, Toggle);
	
	        var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props, context));
	
	        _this.onClick = _this.onClick.bind(_this);
	        return _this;
	    }
	
	    _createClass(Toggle, [{
	        key: "onClick",
	        value: function onClick() {
	            if (this.props.onChange) {
	                this.props.onChange(!this.props.value);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement("a", {
	                className: (0, _classnames2.default)(_Toggle2.default.toggle, "no-decoration", _defineProperty({}, _Toggle2.default.selected, this.props.value)) + " " + (this.props.className || ""),
	                style: { color: this.props.color || null },
	                onClick: this.props.onChange ? this.onClick : null
	            });
	        }
	    }]);
	
	    return Toggle;
	}(_react.Component), _class.propTypes = {
	    value: _propTypes2.default.bool.isRequired,
	    onChange: _propTypes2.default.func
	}, _temp);
	Toggle.displayName = "Toggle";
	exports.default = Toggle;

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"toggle":"_2lChr","selected":"_3MRMF"};

/***/ }),
/* 1243 */,
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CopyButton = __webpack_require__(1220);
	
	var _CopyButton2 = _interopRequireDefault(_CopyButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CopyWidget = function (_Component) {
	    _inherits(CopyWidget, _Component);
	
	    function CopyWidget() {
	        _classCallCheck(this, CopyWidget);
	
	        return _possibleConstructorReturn(this, (CopyWidget.__proto__ || Object.getPrototypeOf(CopyWidget)).apply(this, arguments));
	    }
	
	    _createClass(CopyWidget, [{
	        key: "render",
	        value: function render() {
	            var value = this.props.value;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex" },
	                _react2.default.createElement("input", {
	                    className: "flex-full p1 flex align-center text-grey-4 text-bold no-focus border-top border-left border-bottom border-med rounded-left",
	                    style: { borderRight: "none" },
	                    type: "text",
	                    value: value,
	                    onClick: function onClick(e) {
	                        return e.target.setSelectionRange(0, e.target.value.length);
	                    }
	                }),
	                _react2.default.createElement(_CopyButton2.default, {
	                    className: "p1 flex align-center bordered border-med rounded-right text-brand bg-brand-hover text-white-hover",
	                    value: value
	                })
	            );
	        }
	    }]);
	
	    return CopyWidget;
	}(_react.Component);
	
	CopyWidget.displayName = "CopyWidget";
	exports.default = CopyWidget;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _ConfirmContent = __webpack_require__(1264);
	
	var _ConfirmContent2 = _interopRequireDefault(_ConfirmContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Confirm = (_temp = _class = function (_Component) {
	    _inherits(Confirm, _Component);
	
	    function Confirm() {
	        _classCallCheck(this, Confirm);
	
	        return _possibleConstructorReturn(this, (Confirm.__proto__ || Object.getPrototypeOf(Confirm)).apply(this, arguments));
	    }
	
	    _createClass(Confirm, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                action = _props.action,
	                children = _props.children,
	                title = _props.title,
	                content = _props.content,
	                triggerClasses = _props.triggerClasses;
	
	            return _react2.default.createElement(
	                _ModalWithTrigger2.default,
	                { ref: "modal", triggerElement: children, triggerClasses: triggerClasses },
	                _react2.default.createElement(_ConfirmContent2.default, {
	                    title: title,
	                    content: content,
	                    onClose: function onClose() {
	                        _this2.refs.modal.close();
	                    },
	                    onAction: action
	                })
	            );
	        }
	    }]);
	
	    return Confirm;
	}(_react.Component), _class.propTypes = {
	    action: _propTypes2.default.func.isRequired,
	    title: _propTypes2.default.string.isRequired,
	    children: _propTypes2.default.any,
	    content: _propTypes2.default.any,
	    triggerClasses: _propTypes2.default.string
	}, _temp);
	Confirm.displayName = "Confirm";
	exports.default = Confirm;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Triggerable = __webpack_require__(981);
	
	var _Triggerable2 = _interopRequireDefault(_Triggerable);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _Triggerable2.default)(_Modal2.default);

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TestModal = exports.InlineModal = exports.FullPageModal = exports.WindowModal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp, _class2, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dom = __webpack_require__(859);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(924);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _reactMotion = __webpack_require__(1248);
	
	var _OnClickOutsideWrapper = __webpack_require__(933);
	
	var _OnClickOutsideWrapper2 = _interopRequireDefault(_OnClickOutsideWrapper);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Routeless = __webpack_require__(1263);
	
	var _Routeless2 = _interopRequireDefault(_Routeless);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getModalContent(props) {
	    if (_react2.default.Children.count(props.children) > 1 || props.title != null || props.footer != null) {
	        return _react2.default.createElement(_ModalContent2.default, _underscore2.default.omit(props, "className", "style"));
	    } else {
	        return _react2.default.Children.only(props.children);
	    }
	}
	
	var WindowModal = exports.WindowModal = (_temp = _class = function (_Component) {
	    _inherits(WindowModal, _Component);
	
	    function WindowModal() {
	        _classCallCheck(this, WindowModal);
	
	        return _possibleConstructorReturn(this, (WindowModal.__proto__ || Object.getPrototypeOf(WindowModal)).apply(this, arguments));
	    }
	
	    _createClass(WindowModal, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this._modalElement = document.createElement('span');
	            this._modalElement.className = 'ModalContainer';
	            document.querySelector('body').appendChild(this._modalElement);
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this._renderPopover();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this._renderPopover();
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            _reactDom2.default.unmountComponentAtNode(this._modalElement);
	            if (this._modalElement.parentNode) {
	                this._modalElement.parentNode.removeChild(this._modalElement);
	            }
	        }
	    }, {
	        key: "handleDismissal",
	        value: function handleDismissal() {
	            if (this.props.onClose) {
	                this.props.onClose();
	            }
	        }
	    }, {
	        key: "_modalComponent",
	        value: function _modalComponent() {
	            var _this2 = this;
	
	            var className = _classnames2.default.apply(undefined, [this.props.className].concat(_toConsumableArray(["small", "medium", "wide", "tall"].filter(function (type) {
	                return _this2.props[type];
	            }).map(function (type) {
	                return "Modal--" + type;
	            }))));
	            return _react2.default.createElement(
	                _OnClickOutsideWrapper2.default,
	                { handleDismissal: this.handleDismissal.bind(this) },
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)(className, 'relative bordered bg-white rounded') },
	                    getModalContent(_extends({}, this.props, {
	                        fullPageModal: false,
	                        formModal: !!this.props.form
	                    }))
	                )
	            );
	        }
	    }, {
	        key: "_renderPopover",
	        value: function _renderPopover() {
	            var _props = this.props,
	                backdropClassName = _props.backdropClassName,
	                isOpen = _props.isOpen,
	                style = _props.style;
	
	            var backdropClassnames = 'flex justify-center align-center fixed top left bottom right';
	            _reactDom2.default.unstable_renderSubtreeIntoContainer(this, _react2.default.createElement(
	                _reactAddonsCssTransitionGroup2.default,
	                { transitionName: "Modal", transitionAppear: true, transitionAppearTimeout: 250, transitionEnterTimeout: 250, transitionLeaveTimeout: 250 },
	                isOpen && _react2.default.createElement(
	                    "div",
	                    { key: "modal", className: (0, _classnames2.default)(backdropClassName, backdropClassnames), style: style },
	                    this._modalComponent()
	                )
	            ), this._modalElement);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return WindowModal;
	}(_react.Component), _class.propTypes = {
	    isOpen: _propTypes2.default.bool
	}, _class.defaultProps = {
	    className: "Modal",
	    backdropClassName: "Modal-backdrop"
	}, _temp);
	WindowModal.displayName = "WindowModal";
	
	var FullPageModal = exports.FullPageModal = function (_Component2) {
	    _inherits(FullPageModal, _Component2);
	
	    function FullPageModal() {
	        _classCallCheck(this, FullPageModal);
	
	        return _possibleConstructorReturn(this, (FullPageModal.__proto__ || Object.getPrototypeOf(FullPageModal)).apply(this, arguments));
	    }
	
	    _createClass(FullPageModal, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this._modalElement = document.createElement("div");
	            this._modalElement.className = "Modal--full";
	            document.querySelector('body').appendChild(this._modalElement);
	
	            // save the scroll position, scroll to the top left, and disable scrolling
	            this._scrollX = (0, _dom.getScrollX)();
	            this._scrollY = (0, _dom.getScrollY)();
	            window.scrollTo(0, 0);
	            document.body.style.overflow = "hidden";
	
	            this.componentDidUpdate();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            // set the top of the modal to the bottom of the nav
	            var nav = document.body.querySelector(".Nav");
	            if (nav) {
	                this._modalElement.style.top = nav.getBoundingClientRect().bottom + "px";
	            }
	            this._renderModal(true);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            var _this4 = this;
	
	            this._renderModal(false);
	
	            // restore scroll position and scrolling
	            document.body.style.overflow = "";
	
	            // On IE11 a timeout is required for the scroll to happen after the change of overflow setting
	            setTimeout(function () {
	                window.scrollTo(_this4._scrollX, _this4._scrollY);
	            }, 0);
	
	            // wait for animations to complete before unmounting
	            setTimeout(function () {
	                _reactDom2.default.unmountComponentAtNode(_this4._modalElement);
	                _this4._modalElement.parentNode.removeChild(_this4._modalElement);
	            }, 300);
	        }
	    }, {
	        key: "_renderModal",
	        value: function _renderModal(open) {
	            var _this5 = this;
	
	            _reactDom2.default.unstable_renderSubtreeIntoContainer(this, _react2.default.createElement(
	                _reactMotion.Motion,
	                { defaultStyle: { opacity: 0, top: 20 }, style: open ? { opacity: (0, _reactMotion.spring)(1), top: (0, _reactMotion.spring)(0) } : { opacity: (0, _reactMotion.spring)(0), top: (0, _reactMotion.spring)(20) } },
	                function (motionStyle) {
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "full-height relative scroll-y", style: motionStyle },
	                        getModalContent(_extends({}, _this5.props, {
	                            fullPageModal: true,
	                            formModal: !!_this5.props.form
	                        }))
	                    );
	                }
	            ), this._modalElement);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return FullPageModal;
	}(_react.Component);
	
	FullPageModal.displayName = "FullPageModal";
	
	var InlineModal = exports.InlineModal = function (_Component3) {
	    _inherits(InlineModal, _Component3);
	
	    function InlineModal() {
	        _classCallCheck(this, InlineModal);
	
	        return _possibleConstructorReturn(this, (InlineModal.__proto__ || Object.getPrototypeOf(InlineModal)).apply(this, arguments));
	    }
	
	    _createClass(InlineModal, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                null,
	                this.props.isOpen ? _react2.default.createElement(FullPageModal, this.props) : null
	            );
	        }
	    }]);
	
	    return InlineModal;
	}(_react.Component);
	
	InlineModal.displayName = "InlineModal";
	
	
	/**
	 * A modified version of Modal for Jest/Enzyme tests. Renders the modal content inline instead of document root.
	 */
	var TestModal = exports.TestModal = (_temp2 = _class2 = function (_Component4) {
	    _inherits(TestModal, _Component4);
	
	    function TestModal() {
	        _classCallCheck(this, TestModal);
	
	        return _possibleConstructorReturn(this, (TestModal.__proto__ || Object.getPrototypeOf(TestModal)).apply(this, arguments));
	    }
	
	    _createClass(TestModal, [{
	        key: "render",
	        value: function render() {
	            if (this.props.isOpen) {
	                return _react2.default.createElement(
	                    "div",
	                    {
	                        className: "test-modal",
	                        onClick: function onClick(e) {
	                            return e.stopPropagation();
	                        }
	                    },
	                    getModalContent(_extends({}, this.props, {
	                        fullPageModal: true,
	                        formModal: !!this.props.form
	                    }))
	                );
	            } else {
	                return null;
	            }
	        }
	    }]);
	
	    return TestModal;
	}(_react.Component), _class2.defaultProps = {
	    isOpen: true
	}, _temp2);
	TestModal.displayName = "TestModal";
	
	
	// the "routeless" version should only be used for non-inline modals
	var RoutelessFullPageModal = (0, _Routeless2.default)(FullPageModal);
	
	var Modal = function Modal(_ref) {
	    var full = _ref.full,
	        inline = _ref.inline,
	        props = _objectWithoutProperties(_ref, ["full", "inline"]);
	
	    return full ? props.isOpen ? _react2.default.createElement(RoutelessFullPageModal, props) : null : inline ? _react2.default.createElement(InlineModal, props) : _react2.default.createElement(WindowModal, props);
	};
	
	Modal.defaultProps = {
	    isOpen: true
	};
	
	exports.default = Modal;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(1249);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(1256);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(1257);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(1259);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(1260);
	
	exports.presets = _interopRequire(_presets);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(1261);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(1250);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(1251);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(1252);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(1253);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(1254);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(1255);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = _react2['default'].createClass({
	  displayName: 'Motion',
	
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyle: _react.PropTypes.objectOf(_react.PropTypes.number),
	    style: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object])).isRequired,
	    children: _react.PropTypes.func.isRequired,
	    onRest: _react.PropTypes.func
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  },
	
	  wasAnimating: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyle: null,
	  // after checking for unreadPropStyle != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
	    var dirty = false;
	    var _state = this.state;
	    var currentStyle = _state.currentStyle;
	    var currentVelocity = _state.currentVelocity;
	    var lastIdealStyle = _state.lastIdealStyle;
	    var lastIdealVelocity = _state.lastIdealVelocity;
	
	    for (var key in destStyle) {
	      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	        continue;
	      }
	
	      var styleValue = destStyle[key];
	      if (typeof styleValue === 'number') {
	        if (!dirty) {
	          dirty = true;
	          currentStyle = _extends({}, currentStyle);
	          currentVelocity = _extends({}, currentVelocity);
	          lastIdealStyle = _extends({}, lastIdealStyle);
	          lastIdealVelocity = _extends({}, lastIdealVelocity);
	        }
	
	        currentStyle[key] = styleValue;
	        currentVelocity[key] = 0;
	        lastIdealStyle[key] = styleValue;
	        lastIdealVelocity[key] = 0;
	      }
	    }
	
	    if (dirty) {
	      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // check if we need to animate in the first place
	      var propsStyle = _this.props.style;
	      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	        if (_this.wasAnimating && _this.props.onRest) {
	          _this.props.onRest();
	        }
	
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.wasAnimating = false;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      _this.wasAnimating = true;
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyle = {};
	      var newLastIdealVelocity = {};
	      var newCurrentStyle = {};
	      var newCurrentVelocity = {};
	
	      for (var key in propsStyle) {
	        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	          continue;
	        }
	
	        var styleValue = propsStyle[key];
	        if (typeof styleValue === 'number') {
	          newCurrentStyle[key] = styleValue;
	          newCurrentVelocity[key] = 0;
	          newLastIdealStyle[key] = styleValue;
	          newLastIdealVelocity[key] = 0;
	        } else {
	          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	          for (var i = 0; i < framesToCatchUp; i++) {
	            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            newLastIdealStyleValue = _stepper[0];
	            newLastIdealVelocityValue = _stepper[1];
	          }
	
	          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	          var nextIdealX = _stepper2[0];
	          var nextIdealV = _stepper2[1];
	
	          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	          newLastIdealStyle[key] = newLastIdealStyleValue;
	          newLastIdealVelocity[key] = newLastIdealVelocityValue;
	        }
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyle: newCurrentStyle,
	        currentVelocity: newCurrentVelocity,
	        lastIdealStyle: newLastIdealStyle,
	        lastIdealVelocity: newLastIdealVelocity
	      });
	
	      _this.unreadPropStyle = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = Motion;
	module.exports = exports['default'];

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1253)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1255 */
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(1250);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(1251);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(1252);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(1253);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(1254);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(1255);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = _react2['default'].createClass({
	  displayName: 'StaggeredMotion',
	
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyles: _react.PropTypes.arrayOf(_react.PropTypes.objectOf(_react.PropTypes.number)),
	    styles: _react.PropTypes.func.isRequired,
	    children: _react.PropTypes.func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  },
	
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _state = this.state;
	    var currentStyles = _state.currentStyles;
	    var currentVelocities = _state.currentVelocities;
	    var lastIdealStyles = _state.lastIdealStyles;
	    var lastIdealVelocities = _state.lastIdealVelocities;
	
	    var someDirty = false;
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i];
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            someDirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	        }
	      }
	    }
	
	    if (someDirty) {
	      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyles = [];
	      var newLastIdealVelocities = [];
	      var newCurrentStyles = [];
	      var newCurrentVelocities = [];
	
	      for (var i = 0; i < destStyles.length; i++) {
	        var destStyle = destStyles[i];
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in destStyle) {
	          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	            continue;
	          }
	
	          var styleValue = destStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(1250);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(1251);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(1252);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(1258);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(1253);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(1254);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(1255);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = _react2['default'].createClass({
	  displayName: 'TransitionMotion',
	
	  propTypes: {
	    defaultStyles: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      key: _react.PropTypes.string.isRequired,
	      data: _react.PropTypes.any,
	      style: _react.PropTypes.objectOf(_react.PropTypes.number).isRequired
	    })),
	    styles: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      key: _react.PropTypes.string.isRequired,
	      data: _react.PropTypes.any,
	      style: _react.PropTypes.objectOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.object])).isRequired
	    }))]).isRequired,
	    children: _react.PropTypes.func.isRequired,
	    willEnter: _react.PropTypes.func,
	    willLeave: _react.PropTypes.func,
	    didLeave: _react.PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync = mergeAndSync(
	    // Because this is an old-style React.createClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync[0];
	    var currentStyles = _mergeAndSync[1];
	    var currentVelocities = _mergeAndSync[2];
	    var lastIdealStyles = _mergeAndSync[3];
	    var lastIdealVelocities = _mergeAndSync[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  },
	
	  unmounting: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);
	
	    var mergedPropsStyles = _mergeAndSync2[0];
	    var currentStyles = _mergeAndSync2[1];
	    var currentVelocities = _mergeAndSync2[2];
	    var lastIdealStyles = _mergeAndSync2[3];
	    var lastIdealVelocities = _mergeAndSync2[4];
	
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i].style;
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            mergedPropsStyles[i] = {
	              key: mergedPropsStyles[i].key,
	              data: mergedPropsStyles[i].data,
	              style: _extends({}, mergedPropsStyles[i].style)
	            };
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	          mergedPropsStyles[i].style[key] = styleValue;
	        }
	      }
	    }
	
	    // unlike the other 2 components, we can't detect staleness and optionally
	    // opt out of setState here. each style object's data might contain new
	    // stuff we're not/cannot compare
	    this.setState({
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      mergedPropsStyles: mergedPropsStyles,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities
	    });
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    if (this.unmounting) {
	      return;
	    }
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      var propStyles = _this.props.styles;
	      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var newMergedPropsStyles = _mergeAndSync3[0];
	      var newCurrentStyles = _mergeAndSync3[1];
	      var newCurrentVelocities = _mergeAndSync3[2];
	      var newLastIdealStyles = _mergeAndSync3[3];
	      var newLastIdealVelocities = _mergeAndSync3[4];
	
	      for (var i = 0; i < newMergedPropsStyles.length; i++) {
	        var newMergedPropsStyle = newMergedPropsStyles[i].style;
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in newMergedPropsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = newMergedPropsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = newLastIdealStyles[i][key];
	            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities,
	        mergedPropsStyles: newMergedPropsStyles
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

/***/ }),
/* 1258 */
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(1260);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1260 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ModalFooter = exports.ModalBody = exports.ModalHeader = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalContent = (_temp = _class = function (_Component) {
	    _inherits(ModalContent, _Component);
	
	    function ModalContent() {
	        _classCallCheck(this, ModalContent);
	
	        return _possibleConstructorReturn(this, (ModalContent.__proto__ || Object.getPrototypeOf(ModalContent)).apply(this, arguments));
	    }
	
	    _createClass(ModalContent, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                footer = _props.footer,
	                onClose = _props.onClose,
	                children = _props.children,
	                className = _props.className,
	                fullPageModal = _props.fullPageModal,
	                formModal = _props.formModal;
	
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    id: this.props.id,
	                    className: (0, _classnames2.default)("ModalContent NewForm flex-full flex flex-column relative", className, { "full-height": fullPageModal && !formModal })
	                },
	                onClose && _react2.default.createElement(_Icon2.default, {
	                    className: "text-grey-2 text-grey-4-hover cursor-pointer absolute m2 p2 top right",
	                    name: "close",
	                    size: fullPageModal ? 24 : 16,
	                    onClick: onClose
	                }),
	                title && _react2.default.createElement(
	                    ModalHeader,
	                    { fullPageModal: fullPageModal, formModal: formModal },
	                    title
	                ),
	                _react2.default.createElement(
	                    ModalBody,
	                    { fullPageModal: fullPageModal, formModal: formModal },
	                    children
	                ),
	                footer && _react2.default.createElement(
	                    ModalFooter,
	                    { fullPageModal: fullPageModal, formModal: formModal },
	                    footer
	                )
	            );
	        }
	    }]);
	
	    return ModalContent;
	}(_react.Component), _class.propTypes = {
	    id: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    onClose: _propTypes2.default.func.isRequired,
	    fullPageModal: _propTypes2.default.bool,
	    formModal: _propTypes2.default.bool
	}, _class.defaultProps = {}, _temp);
	ModalContent.displayName = "ModalContent";
	exports.default = ModalContent;
	
	
	var FORM_WIDTH = 500 + 32 * 2; // includes padding
	
	var ModalHeader = exports.ModalHeader = function ModalHeader(_ref) {
	    var children = _ref.children,
	        fullPageModal = _ref.fullPageModal,
	        formModal = _ref.formModal;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("ModalHeader flex-no-shrink px4 py4 full") },
	        _react2.default.createElement(
	            "h2",
	            { className: (0, _classnames2.default)("text-bold", { "text-centered": fullPageModal }, { "mr4": !fullPageModal }) },
	            children
	        )
	    );
	};
	
	ModalHeader.displayName = "ModalHeader";
	var ModalBody = exports.ModalBody = function ModalBody(_ref2) {
	    var children = _ref2.children,
	        fullPageModal = _ref2.fullPageModal,
	        formModal = _ref2.formModal;
	    return _react2.default.createElement(
	        "div",
	        {
	            className: (0, _classnames2.default)("ModalBody", { "px4": formModal, "flex flex-full flex-basis-auto": !formModal })
	        },
	        _react2.default.createElement(
	            "div",
	            {
	                className: "flex-full ml-auto mr-auto flex flex-column",
	                style: { maxWidth: formModal && fullPageModal ? FORM_WIDTH : undefined }
	            },
	            children
	        )
	    );
	};
	
	ModalBody.displayName = "ModalBody";
	var ModalFooter = exports.ModalFooter = function ModalFooter(_ref3) {
	    var children = _ref3.children,
	        fullPageModal = _ref3.fullPageModal,
	        formModal = _ref3.formModal;
	    return _react2.default.createElement(
	        "div",
	        {
	            className: (0, _classnames2.default)("ModalFooter flex-no-shrink px4", fullPageModal ? "py4" : "py2", {
	                "border-top": !fullPageModal || fullPageModal && !formModal
	            })
	        },
	        _react2.default.createElement(
	            "div",
	            {
	                className: "flex-full ml-auto mr-auto flex",
	                style: { maxWidth: formModal && fullPageModal ? FORM_WIDTH : undefined }
	            },
	            _react2.default.createElement("div", { className: "flex-full" }),
	            Array.isArray(children) ? children.map(function (child, index) {
	                return _react2.default.createElement(
	                    "span",
	                    { key: index, className: "ml2" },
	                    child
	                );
	            }) : children
	        )
	    );
	};
	ModalFooter.displayName = "ModalFooter";

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	// namespace under _routeless_
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        _routeless_location: state.routing.locationBeforeTransitions
	    };
	};
	
	var mapDispatchToProps = {
	    _routeless_push: _reactRouterRedux.push,
	    _routeless_goBack: _reactRouterRedux.goBack
	};
	
	// this higher order component wraps any component (typically a fullscreen modal) with an "onClose"
	// prop, injects an entry in the browser history, and closes the component if the back button is pressed
	
	exports.default = function (ComposedComponent) {
	    var _dec, _class, _class2, _temp;
	
	    return _dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	        _inherits(_class, _Component);
	
	        function _class() {
	            _classCallCheck(this, _class);
	
	            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	            key: "componentWillMount",
	            value: function componentWillMount() {
	                var push = this.props._routeless_push;
	                var location = this.props._routeless_location;
	                var pathname = location.pathname,
	                    query = location.query,
	                    search = location.search,
	                    hash = location.hash,
	                    state = location.state;
	                // clone the state object otherwise the state will be replaced rather than pushed
	                // save the state object so that we know when it's changed
	
	                this._state = (typeof state === "undefined" ? "undefined" : _typeof(state)) === "object" ? Object.create(state) : {};
	                push({ pathname: pathname, query: query, search: search, hash: hash, state: this._state });
	            }
	        }, {
	            key: "componentWillReceiveProps",
	            value: function componentWillReceiveProps(nextProps) {
	                var _this2 = this;
	
	                var location = this.props._routeless_location;
	                var nextLocation = nextProps._routeless_location;
	                // if the state previously was the saved one and is now not, then we probably
	                // hit the back button, so close the wrapped component
	                if (location.state === this._state && nextLocation.state !== this._state) {
	                    // perform this in a timeout because the component may be unmounted anyway, in which
	                    // case calling onClose again may cause problems.
	                    // alternatively may be able to tighten up the logic above
	                    this._timeout = setTimeout(function () {
	                        _this2.props.onClose();
	                    }, 100);
	                }
	            }
	        }, {
	            key: "componentWillUnmount",
	            value: function componentWillUnmount() {
	                var location = this.props._routeless_location;
	                var goBack = this.props._routeless_goBack;
	
	                if (this._timeout != null) {
	                    clearTimeout(this._timeout);
	                }
	
	                // if we unmount (e.x. hit the close button which calls onClose directly) and still have the
	                // same state then go back to the original state
	                // NOTE: ideally we would remove the current state from the history so the forward
	                // button wouldn't be enabled, maybe using `replace`
	                if (location.state === this._state) {
	                    goBack();
	                }
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                var props = _underscore2.default.omit(this.props, "_routeless_location", "_routeless_goBack", "_routeless_push");
	                return _react2.default.createElement(ComposedComponent, props);
	            }
	        }]);
	
	        return _class;
	    }(_react.Component), _class2.displayName = "Routeless[" + (ComposedComponent.displayName || ComposedComponent.name) + "]", _temp)) || _class;
	};

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nop = function nop() {};
	
	var ConfirmContent = function ConfirmContent(_ref) {
	    var title = _ref.title,
	        content = _ref.content,
	        _ref$message = _ref.message,
	        message = _ref$message === undefined ? "Are you sure you want to do this?" : _ref$message,
	        _ref$onClose = _ref.onClose,
	        _onClose = _ref$onClose === undefined ? nop : _ref$onClose,
	        _ref$onAction = _ref.onAction,
	        onAction = _ref$onAction === undefined ? nop : _ref$onAction,
	        _ref$onCancel = _ref.onCancel,
	        onCancel = _ref$onCancel === undefined ? nop : _ref$onCancel,
	        _ref$confirmButtonTex = _ref.confirmButtonText,
	        confirmButtonText = _ref$confirmButtonTex === undefined ? "Yes" : _ref$confirmButtonTex,
	        _ref$cancelButtonText = _ref.cancelButtonText,
	        cancelButtonText = _ref$cancelButtonText === undefined ? "Cancel" : _ref$cancelButtonText;
	
	    return _react2.default.createElement(
	        _ModalContent2.default,
	        {
	            title: title,
	            onClose: function onClose() {
	                onCancel();_onClose();
	            }
	        },
	        _react2.default.createElement(
	            "div",
	            { className: "mx4" },
	            content
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "Form-inputs mb4" },
	            _react2.default.createElement(
	                "p",
	                null,
	                message
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "Form-actions ml-auto" },
	            _react2.default.createElement(
	                "button",
	                { className: "Button", onClick: function onClick() {
	                        onCancel();_onClose();
	                    } },
	                cancelButtonText
	            ),
	            _react2.default.createElement(
	                "button",
	                { className: "Button Button--danger ml2", onClick: function onClick() {
	                        onAction();_onClose();
	                    } },
	                confirmButtonText
	            )
	        )
	    );
	};
	
	ConfirmContent.displayName = "ConfirmContent";
	exports.default = ConfirmContent;

/***/ }),
/* 1265 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	// NOTE: these are "public" settings
	var getIsPublicSharingEnabled = exports.getIsPublicSharingEnabled = function getIsPublicSharingEnabled(state) {
	  return state.settings.values["public_sharing"];
	};
	var getIsApplicationEmbeddingEnabled = exports.getIsApplicationEmbeddingEnabled = function getIsApplicationEmbeddingEnabled(state) {
	  return state.settings.values["embedding"];
	};
	
	// NOTE: these are admin-only settings
	var getSiteUrl = exports.getSiteUrl = function getSiteUrl(state) {
	  return state.settings.values["site-url"];
	};
	var getEmbeddingSecretKey = exports.getEmbeddingSecretKey = function getEmbeddingSecretKey(state) {
	  return state.settings.values["embedding-secret-key"];
	};

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _EmbedModalContent = __webpack_require__(1239);
	
	var _EmbedModalContent2 = _interopRequireDefault(_EmbedModalContent);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmbedWidget = function (_Component) {
	    _inherits(EmbedWidget, _Component);
	
	    function EmbedWidget() {
	        _classCallCheck(this, EmbedWidget);
	
	        return _possibleConstructorReturn(this, (EmbedWidget.__proto__ || Object.getPrototypeOf(EmbedWidget)).apply(this, arguments));
	    }
	
	    _createClass(EmbedWidget, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                resourceType = _props.resourceType;
	
	            return _react2.default.createElement(
	                _ModalWithTrigger2.default,
	                {
	                    ref: function ref(m) {
	                        return _this2._modal = m;
	                    },
	                    full: true,
	                    triggerElement: _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: "Sharing and embedding" },
	                        _react2.default.createElement(_Icon2.default, { name: "share", onClick: function onClick() {
	                                return _analytics2.default.trackEvent("Sharing / Embedding", resourceType, "Sharing Link Clicked");
	                            } })
	                    ),
	                    triggerClasses: (0, _classnames2.default)(className, "text-brand-hover"),
	                    className: "scroll-y"
	                },
	                _react2.default.createElement(_EmbedModalContent2.default, _extends({}, this.props, {
	                    onClose: function onClose() {
	                        _this2._modal && _this2._modal.close();
	                    },
	                    className: "full-height"
	                }))
	            );
	        }
	    }]);
	
	    return EmbedWidget;
	}(_react.Component);
	
	EmbedWidget.displayName = "EmbedWidget";
	exports.default = EmbedWidget;

/***/ }),
/* 1267 */,
/* 1268 */,
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Visualization = __webpack_require__(1270);
	
	var _Visualization2 = _interopRequireDefault(_Visualization);
	
	var _QueryDownloadWidget = __webpack_require__(1500);
	
	var _QueryDownloadWidget2 = _interopRequireDefault(_QueryDownloadWidget);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _ExplicitSize = __webpack_require__(1271);
	
	var _ExplicitSize2 = _interopRequireDefault(_ExplicitSize);
	
	var _EmbedFrame = __webpack_require__(1187);
	
	var _EmbedFrame2 = _interopRequireDefault(_EmbedFrame);
	
	var _Parameter = __webpack_require__(958);
	
	var _Card = __webpack_require__(957);
	
	var _services = __webpack_require__(857);
	
	var _app = __webpack_require__(864);
	
	var _metadata = __webpack_require__(1110);
	
	var _icepick = __webpack_require__(855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = {
	    setErrorPage: _app.setErrorPage,
	    addParamValues: _metadata.addParamValues
	};
	
	var PublicQuestion = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = (0, _ExplicitSize2.default)(_class = function (_Component) {
	    _inherits(PublicQuestion, _Component);
	
	    function PublicQuestion(props) {
	        var _this2 = this;
	
	        _classCallCheck(this, PublicQuestion);
	
	        var _this = _possibleConstructorReturn(this, (PublicQuestion.__proto__ || Object.getPrototypeOf(PublicQuestion)).call(this, props));
	
	        _this.setParameterValue = function (id, value) {
	            _this.setState({
	                parameterValues: _extends({}, _this.state.parameterValues, _defineProperty({}, id, value))
	            }, _this.run);
	        };
	
	        _this.run = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	            var _this$props, setErrorPage, _this$props$params, uuid, token, _this$state, card, parameterValues, parameters, newResult, datasetQuery;
	
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _this$props = _this.props, setErrorPage = _this$props.setErrorPage, _this$props$params = _this$props.params, uuid = _this$props$params.uuid, token = _this$props$params.token;
	                            _this$state = _this.state, card = _this$state.card, parameterValues = _this$state.parameterValues;
	
	                            if (card) {
	                                _context.next = 4;
	                                break;
	                            }
	
	                            return _context.abrupt("return");
	
	                        case 4:
	                            parameters = (0, _Card.getParameters)(card);
	                            _context.prev = 5;
	                            newResult = void 0;
	
	                            if (!token) {
	                                _context.next = 13;
	                                break;
	                            }
	
	                            _context.next = 10;
	                            return _services.EmbedApi.cardQuery(_extends({
	                                token: token
	                            }, (0, _Parameter.getParametersBySlug)(parameters, parameterValues)));
	
	                        case 10:
	                            newResult = _context.sent;
	                            _context.next = 21;
	                            break;
	
	                        case 13:
	                            if (!uuid) {
	                                _context.next = 20;
	                                break;
	                            }
	
	                            // public links currently apply parameters client-side
	                            datasetQuery = (0, _Card.applyParameters)(card, parameters, parameterValues);
	                            _context.next = 17;
	                            return _services.PublicApi.cardQuery({
	                                uuid: uuid,
	                                parameters: JSON.stringify(datasetQuery.parameters)
	                            });
	
	                        case 17:
	                            newResult = _context.sent;
	                            _context.next = 21;
	                            break;
	
	                        case 20:
	                            throw { status: 404 };
	
	                        case 21:
	
	                            _this.setState({ result: newResult });
	                            _context.next = 28;
	                            break;
	
	                        case 24:
	                            _context.prev = 24;
	                            _context.t0 = _context["catch"](5);
	
	                            console.error("error", _context.t0);
	                            setErrorPage(_context.t0);
	
	                        case 28:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[5, 24]]);
	        }));
	
	        _this.state = {
	            card: null,
	            result: null,
	            parameterValues: {}
	        };
	        return _this;
	    }
	
	    // $FlowFixMe
	
	
	    _createClass(PublicQuestion, [{
	        key: "componentWillMount",
	        value: function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	                var _props, setErrorPage, _props$params, uuid, token, query, _card, _parameterValues, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, parameter;
	
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _props = this.props, setErrorPage = _props.setErrorPage, _props$params = _props.params, uuid = _props$params.uuid, token = _props$params.token, query = _props.location.query;
	                                _context2.prev = 1;
	                                _card = void 0;
	
	                                if (!token) {
	                                    _context2.next = 9;
	                                    break;
	                                }
	
	                                _context2.next = 6;
	                                return _services.EmbedApi.card({ token: token });
	
	                            case 6:
	                                _card = _context2.sent;
	                                _context2.next = 16;
	                                break;
	
	                            case 9:
	                                if (!uuid) {
	                                    _context2.next = 15;
	                                    break;
	                                }
	
	                                _context2.next = 12;
	                                return _services.PublicApi.card({ uuid: uuid });
	
	                            case 12:
	                                _card = _context2.sent;
	                                _context2.next = 16;
	                                break;
	
	                            case 15:
	                                throw { status: 404 };
	
	                            case 16:
	
	                                if (_card.param_values) {
	                                    this.props.addParamValues(_card.param_values);
	                                }
	
	                                _parameterValues = {};
	                                _iteratorNormalCompletion = true;
	                                _didIteratorError = false;
	                                _iteratorError = undefined;
	                                _context2.prev = 21;
	
	                                for (_iterator = (0, _Card.getParameters)(_card)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                    parameter = _step.value;
	
	                                    _parameterValues[String(parameter.id)] = query[parameter.slug];
	                                }
	
	                                _context2.next = 29;
	                                break;
	
	                            case 25:
	                                _context2.prev = 25;
	                                _context2.t0 = _context2["catch"](21);
	                                _didIteratorError = true;
	                                _iteratorError = _context2.t0;
	
	                            case 29:
	                                _context2.prev = 29;
	                                _context2.prev = 30;
	
	                                if (!_iteratorNormalCompletion && _iterator.return) {
	                                    _iterator.return();
	                                }
	
	                            case 32:
	                                _context2.prev = 32;
	
	                                if (!_didIteratorError) {
	                                    _context2.next = 35;
	                                    break;
	                                }
	
	                                throw _iteratorError;
	
	                            case 35:
	                                return _context2.finish(32);
	
	                            case 36:
	                                return _context2.finish(29);
	
	                            case 37:
	                                this.setState({ card: _card, parameterValues: _parameterValues }, this.run);
	                                _context2.next = 44;
	                                break;
	
	                            case 40:
	                                _context2.prev = 40;
	                                _context2.t1 = _context2["catch"](1);
	
	                                console.error("error", _context2.t1);
	                                setErrorPage(_context2.t1);
	
	                            case 44:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this, [[1, 40], [21, 25, 29, 37], [30,, 32, 36]]);
	            }));
	
	            function componentWillMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	
	        // $FlowFixMe: setState expects return type void
	
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props$params2 = this.props.params,
	                uuid = _props$params2.uuid,
	                token = _props$params2.token;
	            var _state = this.state,
	                card = _state.card,
	                result = _state.result,
	                parameterValues = _state.parameterValues;
	
	
	            var actionButtons = result && _react2.default.createElement(_QueryDownloadWidget2.default, {
	                className: "m1 text-grey-4-hover",
	                uuid: uuid,
	                token: token,
	                result: result
	            });
	
	            return _react2.default.createElement(
	                _EmbedFrame2.default,
	                {
	                    name: card && card.name,
	                    description: card && card.description,
	                    parameters: card && (0, _Card.getParametersWithExtras)(card),
	                    actionButtons: actionButtons,
	                    parameterValues: parameterValues,
	                    setParameterValue: this.setParameterValue
	                },
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !result },
	                    function () {
	                        return _react2.default.createElement(_Visualization2.default, {
	                            series: [{ card: card, data: result && result.data }],
	                            className: "full flex-full",
	                            onUpdateVisualizationSettings: function onUpdateVisualizationSettings(settings) {
	                                return _this3.setState({
	                                    // $FlowFixMe
	                                    result: (0, _icepick.updateIn)(result, ["card", "visualization_settings"], function (s) {
	                                        return _extends({}, s, settings);
	                                    })
	                                });
	                            },
	                            gridUnit: 12,
	                            showTitle: false,
	                            isDashboard: true
	                        });
	                    }
	                )
	            );
	        }
	    }]);
	
	    return PublicQuestion;
	}(_react.Component)) || _class) || _class);
	PublicQuestion.displayName = "PublicQuestion";
	exports.default = PublicQuestion;

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.ERROR_MESSAGE_PERMISSION = exports.ERROR_MESSAGE_GENERIC = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /*  weak */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExplicitSize = __webpack_require__(1271);
	
	var _ExplicitSize2 = _interopRequireDefault(_ExplicitSize);
	
	var _LegendHeader = __webpack_require__(1273);
	
	var _LegendHeader2 = _interopRequireDefault(_LegendHeader);
	
	var _ChartTooltip = __webpack_require__(1278);
	
	var _ChartTooltip2 = _interopRequireDefault(_ChartTooltip);
	
	var _ChartClickActions = __webpack_require__(1280);
	
	var _ChartClickActions2 = _interopRequireDefault(_ChartClickActions);
	
	var _LoadingSpinner = __webpack_require__(1281);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _formatting = __webpack_require__(872);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _visualizations = __webpack_require__(1284);
	
	var _settings = __webpack_require__(1376);
	
	var _utils = __webpack_require__(878);
	
	var _utils2 = __webpack_require__(521);
	
	var _utils3 = _interopRequireDefault(_utils2);
	
	var _dataset = __webpack_require__(877);
	
	var _errors = __webpack_require__(1388);
	
	var _icepick = __webpack_require__(855);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ERROR_MESSAGE_GENERIC = exports.ERROR_MESSAGE_GENERIC = "There was a problem displaying this chart.";
	var ERROR_MESSAGE_PERMISSION = exports.ERROR_MESSAGE_PERMISSION = "Sorry, you don't have permission to see this card.";
	
	var Visualization = (0, _ExplicitSize2.default)(_class = (_temp = _class2 = function (_Component) {
	    _inherits(Visualization, _Component);
	
	    function Visualization(props) {
	        _classCallCheck(this, Visualization);
	
	        var _this = _possibleConstructorReturn(this, (Visualization.__proto__ || Object.getPrototypeOf(Visualization)).call(this, props));
	
	        _this.handleHoverChange = function (hovered) {
	            if (hovered) {
	                var _yAxisSplit = _this.state.yAxisSplit;
	                // if we have Y axis split info then find the Y axis index (0 = left, 1 = right)
	
	                if (_yAxisSplit) {
	                    var axisIndex = _underscore2.default.findIndex(_yAxisSplit, function (indexes) {
	                        return _underscore2.default.contains(indexes, hovered.index);
	                    });
	                    hovered = (0, _icepick.assoc)(hovered, "axisIndex", axisIndex);
	                }
	                _this.setState({ hovered: hovered });
	                // If we previously set a timeout for clearing the hover clear it now since we received
	                // a new hover.
	                if (_this._resetHoverTimer !== null) {
	                    clearTimeout(_this._resetHoverTimer);
	                    _this._resetHoverTimer = null;
	                }
	            } else {
	                // When reseting the hover wait in case we're simply transitioning from one
	                // element to another. This allows visualizations to use mouseleave events etc.
	                _this._resetHoverTimer = setTimeout(function () {
	                    _this.setState({ hovered: null });
	                    _this._resetHoverTimer = null;
	                }, 0);
	            }
	        };
	
	        _this.visualizationIsClickable = function (clicked) {
	            var onChangeCardAndRun = _this.props.onChangeCardAndRun;
	
	            if (!onChangeCardAndRun) {
	                return false;
	            }
	            try {
	                return _this.getClickActions(clicked).length > 0;
	            } catch (e) {
	                console.warn(e);
	                return false;
	            }
	        };
	
	        _this.handleVisualizationClick = function (clicked) {
	            if (clicked) {
	                _analytics2.default.trackEvent("Actions", "Clicked", (clicked.column ? "column" : "") + " " + (clicked.value ? "value" : "") + " " + (clicked.dimensions ? "dimensions=" + clicked.dimensions.length : ""));
	            }
	
	            // needs to be delayed so we don't clear it when switching from one drill through to another
	            setTimeout(function () {
	                _this.setState({ clicked: clicked });
	            }, 100);
	        };
	
	        _this.handleOnChangeCardAndRun = function (_ref) {
	            var nextCard = _ref.nextCard,
	                seriesIndex = _ref.seriesIndex;
	            var _this$state = _this.state,
	                series = _this$state.series,
	                clicked = _this$state.clicked;
	
	
	            var index = seriesIndex || clicked && clicked.seriesIndex || 0;
	            var previousCard = series && series[index] && series[index].card;
	
	            _this.props.onChangeCardAndRun({ nextCard: nextCard, previousCard: previousCard });
	        };
	
	        _this.onRender = function () {
	            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                yAxisSplit = _ref2.yAxisSplit,
	                _ref2$warnings = _ref2.warnings,
	                warnings = _ref2$warnings === undefined ? [] : _ref2$warnings;
	
	            _this.setState({ yAxisSplit: yAxisSplit, warnings: warnings });
	        };
	
	        _this.onRenderError = function (error) {
	            _this.setState({ error: error });
	        };
	
	        _this.hideActions = function () {
	            _this.setState({ clicked: null });
	        };
	
	        _this.state = {
	            hovered: null,
	            clicked: null,
	            error: null,
	            warnings: [],
	            yAxisSplit: null,
	            series: null,
	            CardVisualization: null
	        };
	        return _this;
	    }
	
	    _createClass(Visualization, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.transform(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            if (!(0, _utils.isSameSeries)(newProps.series, this.props.series) || !_utils3.default.equals(newProps.settings, this.props.settings)) {
	                this.transform(newProps);
	            }
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.updateWarnings();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (!_utils3.default.equals(this.getWarnings(prevProps, prevState), this.getWarnings())) {
	                this.updateWarnings();
	            }
	        }
	
	        // $FlowFixMe
	
	    }, {
	        key: "getWarnings",
	        value: function getWarnings() {
	            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	            var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	
	            var warnings = state.warnings || [];
	            // don't warn about truncated data for table since we show a warning in the row count
	            if (state.series[0].card.display !== "table") {
	                warnings = warnings.concat(props.series.filter(function (s) {
	                    return s.data && s.data.rows_truncated != null;
	                }).map(function (s) {
	                    return "Data truncated to " + (0, _formatting.formatNumber)(s.data.rows_truncated) + " rows.";
	                }));
	            }
	            return warnings;
	        }
	    }, {
	        key: "updateWarnings",
	        value: function updateWarnings() {
	            if (this.props.onUpdateWarnings) {
	                this.props.onUpdateWarnings(this.getWarnings() || []);
	            }
	        }
	    }, {
	        key: "transform",
	        value: function transform(newProps) {
	            this.setState(_extends({
	                hovered: null,
	                clicked: null,
	                error: null,
	                warnings: [],
	                yAxisSplit: null
	            }, (0, _visualizations.getVisualizationTransformed)((0, _visualizations.extractRemappings)(newProps.series))));
	        }
	    }, {
	        key: "getClickActions",
	        value: function getClickActions(clicked) {
	            if (!clicked) {
	                return [];
	            }
	            // TODO: push this logic into Question?
	            var _props = this.props,
	                series = _props.series,
	                metadata = _props.metadata;
	
	            var seriesIndex = clicked.seriesIndex || 0;
	            var card = series[seriesIndex].card;
	            var question = new _Question2.default(metadata, card);
	            var mode = question.mode();
	            return mode ? mode.actionsForClick(clicked, {}) : [];
	        }
	
	        // Add the underlying card of current series to onChangeCardAndRun if available
	
	    }, {
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                actionButtons = _props2.actionButtons,
	                className = _props2.className,
	                showTitle = _props2.showTitle,
	                isDashboard = _props2.isDashboard,
	                width = _props2.width,
	                height = _props2.height,
	                errorIcon = _props2.errorIcon,
	                isSlow = _props2.isSlow,
	                expectedDuration = _props2.expectedDuration,
	                replacementContent = _props2.replacementContent;
	            var _state = this.state,
	                series = _state.series,
	                CardVisualization = _state.CardVisualization;
	
	            var small = width < 330;
	
	            var _state2 = this.state,
	                hovered = _state2.hovered,
	                clicked = _state2.clicked;
	
	
	            var clickActions = this.getClickActions(clicked);
	            if (clickActions.length > 0) {
	                hovered = null;
	            }
	
	            var error = this.props.error || this.state.error;
	            var loading = !(series && series.length > 0 && _underscore2.default.every(series, function (s) {
	                return s.data;
	            }));
	            var noResults = false;
	
	            // don't try to load settings unless data is loaded
	            var settings = this.props.settings || {};
	
	            if (!loading && !error) {
	                settings = this.props.settings || (0, _settings.getSettings)(series);
	                if (!CardVisualization) {
	                    error = "Could not find visualization";
	                } else {
	                    try {
	                        if (CardVisualization.checkRenderable) {
	                            CardVisualization.checkRenderable(series, settings);
	                        }
	                    } catch (e) {
	                        error = e.message || "Could not display this chart with this data.";
	                        if (e instanceof _errors.ChartSettingsError && this.props.onOpenChartSettings) {
	                            error = _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    error
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "mt2" },
	                                    _react2.default.createElement(
	                                        "button",
	                                        { className: "Button Button--primary Button--medium", onClick: this.props.onOpenChartSettings },
	                                        e.buttonText
	                                    )
	                                )
	                            );
	                        } else if (e instanceof _errors.MinRowsError) {
	                            noResults = true;
	                        }
	                    }
	                }
	            }
	
	            if (!error) {
	                // $FlowFixMe
	                noResults = _underscore2.default.every(series, function (s) {
	                    return s && s.data && (0, _dataset.datasetContainsNoResults)(s.data);
	                });
	            }
	
	            var extra = _react2.default.createElement(
	                "span",
	                { className: "flex align-center" },
	                isSlow && !loading && _react2.default.createElement(_LoadingSpinner2.default, { size: 18, className: (0, _classnames2.default)("Visualization-slow-spinner", isSlow === "usually-slow" ? "text-gold" : "text-slate") }),
	                actionButtons
	            );
	
	            var _props3 = this.props,
	                gridSize = _props3.gridSize,
	                gridUnit = _props3.gridUnit;
	
	            if (!gridSize && gridUnit) {
	                gridSize = {
	                    width: Math.round(width / (gridUnit * 4)),
	                    height: Math.round(height / (gridUnit * 3))
	                };
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(className, "flex flex-column") },
	                showTitle && (settings["card.title"] || extra) && (loading || error || noResults || !(CardVisualization && CardVisualization.noHeader)) || replacementContent ? _react2.default.createElement(
	                    "div",
	                    { className: "p1 flex-no-shrink" },
	                    _react2.default.createElement(_LegendHeader2.default, {
	                        series: settings["card.title"] ?
	                        // if we have a card title set, use it
	                        // $FlowFixMe
	                        (0, _icepick.setIn)(series, [0, "card", "name"], settings["card.title"]) :
	                        // otherwise use the original series
	                        series,
	                        actionButtons: extra,
	                        description: settings["card.description"],
	                        settings: settings,
	                        onChangeCardAndRun: this.props.onChangeCardAndRun ? this.handleOnChangeCardAndRun : null
	                    })
	                ) : null,
	                replacementContent ? replacementContent
	                // on dashboards we should show the "No results!" warning if there are no rows or there's a MinRowsError and actualRows === 0
	                : isDashboard && noResults ? _react2.default.createElement(
	                    "div",
	                    { className: "flex-full px1 pb1 text-centered flex flex-column layout-centered " + (isDashboard ? "text-slate-light" : "text-slate") },
	                    _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: "No results!", isEnabled: small },
	                        _react2.default.createElement("img", { src: "../app/assets/img/no_results.svg" })
	                    ),
	                    !small && _react2.default.createElement(
	                        "span",
	                        { className: "h4 text-bold" },
	                        "No results!"
	                    )
	                ) : error ? _react2.default.createElement(
	                    "div",
	                    { className: "flex-full px1 pb1 text-centered flex flex-column layout-centered " + (isDashboard ? "text-slate-light" : "text-slate") },
	                    _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: error, isEnabled: small },
	                        _react2.default.createElement(_Icon2.default, { className: "mb2", name: errorIcon || "warning", size: 50 })
	                    ),
	                    !small && _react2.default.createElement(
	                        "span",
	                        { className: "h4 text-bold" },
	                        error
	                    )
	                ) : loading ? _react2.default.createElement(
	                    "div",
	                    { className: "flex-full p1 text-centered text-brand flex flex-column layout-centered" },
	                    isSlow ? _react2.default.createElement(
	                        "div",
	                        { className: "text-slate" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "h4 text-bold mb1" },
	                            "Still Waiting..."
	                        ),
	                        isSlow === "usually-slow" ? _react2.default.createElement(
	                            "div",
	                            null,
	                            "This usually takes an average of ",
	                            _react2.default.createElement(
	                                "span",
	                                { style: { whiteSpace: "nowrap" } },
	                                (0, _formatting.duration)(expectedDuration)
	                            ),
	                            ".",
	                            _react2.default.createElement("br", null),
	                            "(This is a bit long for a dashboard)"
	                        ) : _react2.default.createElement(
	                            "div",
	                            null,
	                            "This is usually pretty fast, but seems to be taking awhile right now."
	                        )
	                    ) : _react2.default.createElement(_LoadingSpinner2.default, { className: "text-slate" })
	                ) :
	                // $FlowFixMe
	                _react2.default.createElement(CardVisualization, _extends({}, this.props, {
	                    className: "flex-full",
	                    series: series,
	                    settings: settings
	                    // $FlowFixMe
	                    , card: series[0].card // convenience for single-series visualizations
	                    // $FlowFixMe
	                    , data: series[0].data // convenience for single-series visualizations
	                    , hovered: hovered,
	                    onHoverChange: this.handleHoverChange,
	                    onVisualizationClick: this.handleVisualizationClick,
	                    visualizationIsClickable: this.visualizationIsClickable,
	                    onRenderError: this.onRenderError,
	                    onRender: this.onRender,
	                    onActionDismissal: this.hideActions,
	                    gridSize: gridSize,
	                    onChangeCardAndRun: this.props.onChangeCardAndRun ? this.handleOnChangeCardAndRun : null
	                })),
	                _react2.default.createElement(_ChartTooltip2.default, {
	                    series: series,
	                    hovered: hovered
	                }),
	                this.props.onChangeCardAndRun && _react2.default.createElement(_ChartClickActions2.default, {
	                    clicked: clicked,
	                    clickActions: clickActions,
	                    onChangeCardAndRun: this.handleOnChangeCardAndRun,
	                    onClose: this.hideActions
	                })
	            );
	        }
	    }]);
	
	    return Visualization;
	}(_react.Component), _class2.defaultProps = {
	    showTitle: false,
	    isDashboard: false,
	    isEditing: false,
	    onUpdateVisualizationSettings: function onUpdateVisualizationSettings() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return console.warn("onUpdateVisualizationSettings", args);
	    }
	}, _temp)) || _class;
	
	Visualization.displayName = "Visualization";
	exports.default = Visualization;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _resizeObserverPolyfill = __webpack_require__(1272);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (ComposedComponent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_Component) {
	        _inherits(_class, _Component);
	
	        function _class(props, context) {
	            _classCallCheck(this, _class);
	
	            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));
	
	            _this._updateSize = function () {
	                var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(_this).getBoundingClientRect(),
	                    width = _ReactDOM$findDOMNode.width,
	                    height = _ReactDOM$findDOMNode.height;
	
	                if (_this.state.width !== width || _this.state.height !== height) {
	                    _this.setState({ width: width, height: height });
	                }
	            };
	
	            _this.state = {
	                width: null,
	                height: null
	            };
	            return _this;
	        }
	
	        _createClass(_class, [{
	            key: "componentDidMount",
	            value: function componentDidMount() {
	                var _this2 = this;
	
	                // media query listener, ensure re-layout when printing
	                this._mql = window.matchMedia("print");
	                this._mql.addListener(this._updateSize);
	
	                // resize observer, ensure re-layout when container element changes size
	                this._ro = new _resizeObserverPolyfill2.default(function (entries, observer) {
	                    var element = _reactDom2.default.findDOMNode(_this2);
	                    var _iteratorNormalCompletion = true;
	                    var _didIteratorError = false;
	                    var _iteratorError = undefined;
	
	                    try {
	                        for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                            var entry = _step.value;
	
	                            if (entry.target === element) {
	                                _this2._updateSize();
	                                break;
	                            }
	                        }
	                    } catch (err) {
	                        _didIteratorError = true;
	                        _iteratorError = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	                        } finally {
	                            if (_didIteratorError) {
	                                throw _iteratorError;
	                            }
	                        }
	                    }
	                });
	                this._ro.observe(_reactDom2.default.findDOMNode(this));
	
	                this._updateSize();
	            }
	        }, {
	            key: "componentDidUpdate",
	            value: function componentDidUpdate() {
	                this._updateSize();
	            }
	        }, {
	            key: "componentWillUnmount",
	            value: function componentWillUnmount() {
	                this._ro.disconnect();
	                this._mql.removeListener(this._updateSize);
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2.default.createElement(ComposedComponent, _extends({}, this.props, this.state));
	            }
	        }]);
	
	        return _class;
	    }(_react.Component), _class.displayName = "ExplicitSize[" + (ComposedComponent.displayName || ComposedComponent.name) + "]", _temp;
	};

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () {
	'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map != 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: {} };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window != 'undefined' && typeof document != 'undefined' && window.document === document;
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        return requestAnimationFrame;
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Detect whether running in IE 11 (facepalm).
	var isIE11 = typeof navigator != 'undefined' && /Trident\/.*rv:11/.test(navigator.userAgent);
	
	// MutationObserver should not be used if running in Internet Explorer 11 as it's
	// implementation is unreliable. Example: https://jsfiddle.net/x2r3jpuz/2/
	//
	// It's a real bummer that there is no other way to check for this issue but to
	// use the UA information.
	var mutationObserverSupported = typeof MutationObserver != 'undefined' && !isIE11;
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    /**
	     * Indicates whether DOM listeners have been added.
	     *
	     * @private {boolean}
	     */
	    this.connected_ = false;
	
	    /**
	     * Tells that controller has subscribed for Mutation Events.
	     *
	     * @private {boolean}
	     */
	    this.mutationEventsAdded_ = false;
	
	    /**
	     * Keeps reference to the instance of MutationObserver.
	     *
	     * @private {MutationObserver}
	     */
	    this.mutationsObserver_ = null;
	
	    /**
	     * A list of connected observers.
	     *
	     * @private {Array<ResizeObserverSPI>}
	     */
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName;
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = Array.prototype.slice.call(arguments, 1);
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement != 'undefined') {
	        return function (target) { return target instanceof SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly != 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    /**
	     * Broadcasted width of content rectangle.
	     *
	     * @type {number}
	     */
	    this.broadcastWidth = 0;
	
	    /**
	     * Broadcasted height of content rectangle.
	     *
	     * @type {number}
	     */
	    this.broadcastHeight = 0;
	
	    /**
	     * Reference to the last observed content rectangle.
	     *
	     * @private {DOMRectInit}
	     */
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    /**
	     * Reference to the observed element.
	     *
	     * @type {Element}
	     */
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    /**
	     * Collection of resize observations that have detected changes in dimensions
	     * of elements.
	     *
	     * @private {Array<ResizeObservation>}
	     */
	    this.activeObservations_ = [];
	
	    /**
	     * Registry of the ResizeObservation instances.
	     *
	     * @private {Map<Element, ResizeObservation>}
	     */
	    this.observations_ = new MapShim();
	
	    /**
	     * Reference to the callback function.
	     *
	     * @private {ResizeObserverCallback}
	     */
	    this.callback_ = callback;
	
	    /**
	     * Reference to the associated ResizeObserverController.
	     *
	     * @private {ResizeObserverController}
	     */
	    this.controller_ = controller;
	
	    /**
	     * Public ResizeObserver instance which will be passed to the callback
	     * function and used as a value of it's "this" binding.
	     *
	     * @private {ResizeObserver}
	     */
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap != 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver$1 = function(callback) {
	    if (!(this instanceof ResizeObserver$1)) {
	        throw new TypeError('Cannot call a class as a function');
	    }
	
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver$1.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof ResizeObserver != 'undefined') {
	        // eslint-disable-next-line no-undef
	        return ResizeObserver;
	    }
	
	    return ResizeObserver$1;
	})();
	
	return index;
	})));


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Legend = __webpack_require__(1274);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LegendItem = __webpack_require__(1276);
	
	var _LegendItem2 = _interopRequireDefault(_LegendItem);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _colors = __webpack_require__(881);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_COLORS = Object.values(_colors.normal);
	
	var LegendHeader = (_temp = _class = function (_Component) {
	    _inherits(LegendHeader, _Component);
	
	    function LegendHeader(props, context) {
	        _classCallCheck(this, LegendHeader);
	
	        var _this = _possibleConstructorReturn(this, (LegendHeader.__proto__ || Object.getPrototypeOf(LegendHeader)).call(this, props, context));
	
	        _this.state = {
	            width: 0
	        };
	        return _this;
	    }
	
	    _createClass(LegendHeader, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.componentDidUpdate();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var width = _reactDom2.default.findDOMNode(this).offsetWidth;
	            if (width !== this.state.width) {
	                this.setState({ width: width });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                series = _props.series,
	                hovered = _props.hovered,
	                onRemoveSeries = _props.onRemoveSeries,
	                actionButtons = _props.actionButtons,
	                onHoverChange = _props.onHoverChange,
	                onChangeCardAndRun = _props.onChangeCardAndRun,
	                settings = _props.settings,
	                description = _props.description,
	                onVisualizationClick = _props.onVisualizationClick,
	                visualizationIsClickable = _props.visualizationIsClickable;
	
	            var showDots = series.length > 1;
	            var isNarrow = this.state.width < 150;
	            var showTitles = !showDots || !isNarrow;
	
	            var colors = settings["graph.colors"] || DEFAULT_COLORS;
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(_Legend2.default.LegendHeader, "Card-title mx1 flex flex-no-shrink flex-row align-center") },
	                series.map(function (s, index) {
	                    return [_react2.default.createElement(_LegendItem2.default, {
	                        key: index,
	                        title: s.card.name,
	                        description: description,
	                        color: colors[index % colors.length],
	                        showDot: showDots,
	                        showTitle: showTitles,
	                        isMuted: hovered && hovered.index != null && index !== hovered.index,
	                        onMouseEnter: function onMouseEnter() {
	                            return onHoverChange && onHoverChange({ index: index });
	                        },
	                        onMouseLeave: function onMouseLeave() {
	                            return onHoverChange && onHoverChange(null);
	                        },
	                        onClick: s.clicked && visualizationIsClickable(s.clicked) ? function (e) {
	                            return onVisualizationClick(_extends({}, s.clicked, { element: e.currentTarget }));
	                        } : onChangeCardAndRun ? function () {
	                            return onChangeCardAndRun({ nextCard: s.card, seriesIndex: index });
	                        } : null
	                    }), onRemoveSeries && index > 0 && _react2.default.createElement(_Icon2.default, {
	                        name: "close",
	                        className: "text-grey-2 flex-no-shrink mr1 cursor-pointer",
	                        width: 12, height: 12,
	                        onClick: function onClick() {
	                            return onRemoveSeries(s.card);
	                        }
	                    })];
	                }),
	                actionButtons && _react2.default.createElement(
	                    "span",
	                    { className: "flex-no-shrink flex-align-right relative" },
	                    actionButtons
	                )
	            );
	        }
	    }]);
	
	    return LegendHeader;
	}(_react.Component), _class.propTypes = {
	    series: _propTypes2.default.array.isRequired,
	    hovered: _propTypes2.default.object,
	    onHoverChange: _propTypes2.default.func,
	    onRemoveSeries: _propTypes2.default.func,
	    onChangeCardAndRun: _propTypes2.default.func,
	    actionButtons: _propTypes2.default.node,
	    description: _propTypes2.default.string
	}, _class.defaultProps = {
	    series: [],
	    settings: {},
	    visualizationIsClickable: function visualizationIsClickable() {
	        return false;
	    }
	}, _temp);
	LegendHeader.displayName = "LegendHeader";
	exports.default = LegendHeader;

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"LegendHeader":"_14YpV","LegendItem":"_1zU60","Legend":"_2tUFa","none":"_3YdyC","vertical":"_1BBNM","horizontal":"_1TLy7"};

/***/ }),
/* 1275 */,
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Ellipsified = __webpack_require__(1277);
	
	var _Ellipsified2 = _interopRequireDefault(_Ellipsified);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Don't use a <a> tag if there's no href
	var LegendLink = function LegendLink(props) {
	    return props.href ? _react2.default.createElement("a", props) : _react2.default.createElement("span", props);
	};
	
	var LegendItem = (_temp = _class = function (_Component) {
	    _inherits(LegendItem, _Component);
	
	    function LegendItem(props, context) {
	        _classCallCheck(this, LegendItem);
	
	        var _this = _possibleConstructorReturn(this, (LegendItem.__proto__ || Object.getPrototypeOf(LegendItem)).call(this, props, context));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(LegendItem, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                color = _props.color,
	                showDot = _props.showDot,
	                showTitle = _props.showTitle,
	                isMuted = _props.isMuted,
	                showTooltip = _props.showTooltip,
	                showDotTooltip = _props.showDotTooltip,
	                onMouseEnter = _props.onMouseEnter,
	                onMouseLeave = _props.onMouseLeave,
	                className = _props.className,
	                description = _props.description,
	                onClick = _props.onClick;
	
	            return _react2.default.createElement(
	                LegendLink,
	                {
	                    className: (0, _classnames2.default)(className, "LegendItem", "no-decoration flex align-center fullscreen-normal-text fullscreen-night-text", {
	                        mr1: showTitle,
	                        muted: isMuted,
	                        "cursor-pointer": onClick
	                    }),
	                    style: { overflowX: "hidden", flex: "0 1 auto" },
	                    onMouseEnter: onMouseEnter,
	                    onMouseLeave: onMouseLeave,
	                    onClick: onClick
	                },
	                showDot && _react2.default.createElement(
	                    _Tooltip2.default,
	                    { tooltip: title, isEnabled: showTooltip && showDotTooltip },
	                    _react2.default.createElement("div", {
	                        className: (0, _classnames2.default)("flex-no-shrink", "inline-block circular"),
	                        style: { width: 13, height: 13, margin: 4, marginRight: 8, backgroundColor: color }
	                    })
	                ),
	                showTitle && _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "mr1" },
	                        _react2.default.createElement(
	                            _Ellipsified2.default,
	                            { showTooltip: showTooltip },
	                            title
	                        )
	                    ),
	                    description && _react2.default.createElement(
	                        "div",
	                        { className: "hover-child" },
	                        _react2.default.createElement(
	                            _Tooltip2.default,
	                            { tooltip: description, maxWidth: '22em' },
	                            _react2.default.createElement(_Icon2.default, { name: "info" })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LegendItem;
	}(_react.Component), _class.propTypes = {}, _class.defaultProps = {
	    showDot: true,
	    showTitle: true,
	    isMuted: false,
	    showTooltip: true,
	    showDotTooltip: true
	}, _temp);
	LegendItem.displayName = "LegendItem";
	exports.default = LegendItem;

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ellipsified = (_temp = _class = function (_Component) {
	    _inherits(Ellipsified, _Component);
	
	    function Ellipsified(props, context) {
	        _classCallCheck(this, Ellipsified);
	
	        var _this = _possibleConstructorReturn(this, (Ellipsified.__proto__ || Object.getPrototypeOf(Ellipsified)).call(this, props, context));
	
	        _this.state = {
	            isTruncated: false
	        };
	        return _this;
	    }
	
	    _createClass(Ellipsified, [{
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            // Only show tooltip if title is hidden or ellipsified
	            var element = _reactDom2.default.findDOMNode(this.refs.content);
	            var isTruncated = element && element.offsetWidth < element.scrollWidth;
	            if (this.state.isTruncated !== isTruncated) {
	                this.setState({ isTruncated: isTruncated });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                showTooltip = _props.showTooltip,
	                children = _props.children,
	                style = _props.style,
	                className = _props.className,
	                tooltip = _props.tooltip,
	                alwaysShowTooltip = _props.alwaysShowTooltip,
	                tooltipMaxWidth = _props.tooltipMaxWidth;
	            var isTruncated = this.state.isTruncated;
	
	            return _react2.default.createElement(
	                _Tooltip2.default,
	                {
	                    tooltip: tooltip || children || ' ',
	                    verticalAttachments: ["top", "bottom"],
	                    isEnabled: showTooltip && (isTruncated || alwaysShowTooltip) || false,
	                    maxWidth: tooltipMaxWidth
	                },
	                _react2.default.createElement(
	                    "div",
	                    { ref: "content", className: className, style: _extends({}, style, { overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }) },
	                    children
	                )
	            );
	        }
	    }]);
	
	    return Ellipsified;
	}(_react.Component), _class.propTypes = {}, _class.defaultProps = {
	    style: {},
	    className: "",
	    showTooltip: true
	}, _temp);
	Ellipsified.displayName = "Ellipsified";
	exports.default = Ellipsified;

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TooltipPopover = __webpack_require__(912);
	
	var _TooltipPopover2 = _interopRequireDefault(_TooltipPopover);
	
	var _Value = __webpack_require__(1279);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _utils = __webpack_require__(878);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartTooltip = (_temp = _class = function (_Component) {
	    _inherits(ChartTooltip, _Component);
	
	    function ChartTooltip() {
	        _classCallCheck(this, ChartTooltip);
	
	        return _possibleConstructorReturn(this, (ChartTooltip.__proto__ || Object.getPrototypeOf(ChartTooltip)).apply(this, arguments));
	    }
	
	    _createClass(ChartTooltip, [{
	        key: "_getRows",
	        value: function _getRows() {
	            var _props = this.props,
	                series = _props.series,
	                hovered = _props.hovered;
	
	            if (!hovered) {
	                return [];
	            }
	            // Array of key, value, col: { data: [{ key, value, col }], element, event }
	            if (Array.isArray(hovered.data)) {
	                return hovered.data;
	            }
	            // ClickObject: { value, column, dimensions: [{ value, column }], element, event }
	            else if (hovered.value !== undefined || hovered.dimensions) {
	                    var dimensions = [];
	                    if (hovered.value !== undefined) {
	                        dimensions.push({ value: hovered.value, column: hovered.column });
	                    }
	                    if (hovered.dimensions) {
	                        dimensions.push.apply(dimensions, _toConsumableArray(hovered.dimensions));
	                    }
	                    return dimensions.map(function (_ref) {
	                        var value = _ref.value,
	                            column = _ref.column;
	                        return {
	                            key: (0, _utils.getFriendlyName)(column),
	                            value: value,
	                            col: column
	                        };
	                    });
	                }
	                // DEPRECATED: { key, value }
	                else if (hovered.data) {
	                        console.warn("hovered should be a ClickObject or hovered.data should be an array of { key, value, col }", hovered.data);
	                        var s = series[hovered.index] || series[0];
	                        return [{
	                            key: (0, _utils.getFriendlyName)(s.data.cols[0]),
	                            value: hovered.data.key,
	                            col: s.data.cols[0]
	                        }, {
	                            key: (0, _utils.getFriendlyName)(s.data.cols[1]),
	                            value: hovered.data.value,
	                            col: s.data.cols[1]
	                        }];
	                    }
	            return [];
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var hovered = this.props.hovered;
	
	            var rows = this._getRows();
	            var hasEventOrElement = hovered && (hovered.element && document.contains(hovered.element) || hovered.event);
	            var isOpen = rows.length > 0 && !!hasEventOrElement;
	            return _react2.default.createElement(
	                _TooltipPopover2.default,
	                {
	                    target: hovered && hovered.element,
	                    targetEvent: hovered && hovered.event,
	                    verticalAttachments: ["bottom", "top"],
	                    isOpen: isOpen
	                },
	                _react2.default.createElement(
	                    "table",
	                    { className: "py1 px2" },
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        rows.map(function (_ref2, index) {
	                            var key = _ref2.key,
	                                value = _ref2.value,
	                                col = _ref2.col;
	                            return _react2.default.createElement(TooltipRow, {
	                                key: index,
	                                name: key,
	                                value: value,
	                                column: col
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ChartTooltip;
	}(_react.Component), _class.propTypes = {
	    series: _propTypes2.default.array.isRequired,
	    hovered: _propTypes2.default.object
	}, _temp);
	ChartTooltip.displayName = "ChartTooltip";
	exports.default = ChartTooltip;
	
	
	var TooltipRow = function TooltipRow(_ref3) {
	    var name = _ref3.name,
	        value = _ref3.value,
	        column = _ref3.column;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            { className: "text-light text-right" },
	            name,
	            ":"
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: "pl1 text-bold text-left" },
	            _react2.default.isValidElement(value) ? value : _react2.default.createElement(_Value2.default, {
	                type: "tooltip",
	                value: value,
	                column: column,
	                majorWidth: 0
	            })
	        )
	    );
	};
	TooltipRow.displayName = "TooltipRow";

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formatting = __webpack_require__(872);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Value = function Value(_ref) {
	    var value = _ref.value,
	        options = _objectWithoutProperties(_ref, ["value"]);
	
	    var formatted = (0, _formatting.formatValue)(value, _extends({}, options, { jsx: true }));
	    if (_react2.default.isValidElement(formatted)) {
	        return formatted;
	    } else {
	        return _react2.default.createElement(
	            "span",
	            null,
	            formatted
	        );
	    }
	};
	
	exports.default = Value;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SECTIONS = {
	    zoom: {
	        icon: "zoom"
	    },
	    records: {
	        icon: "table2"
	    },
	    details: {
	        icon: "document"
	    },
	    sort: {
	        icon: "sort"
	    },
	    breakout: {
	        icon: "breakout"
	    },
	    sum: {
	        icon: "sum"
	    },
	    averages: {
	        icon: "curve"
	    },
	    filter: {
	        icon: "funneloutline"
	    },
	    dashboard: {
	        icon: "dashboard"
	    },
	    distribution: {
	        icon: "bar"
	    }
	};
	// give them indexes so we can sort the sections by the above ordering (JS objects are ordered)
	Object.values(SECTIONS).map(function (section, index) {
	    // $FlowFixMe
	    section.index = index;
	});
	
	var ChartClickActions = function (_Component) {
	    _inherits(ChartClickActions, _Component);
	
	    function ChartClickActions() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ChartClickActions);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChartClickActions.__proto__ || Object.getPrototypeOf(ChartClickActions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            popoverAction: null
	        }, _this.close = function () {
	            _this.setState({ popoverAction: null });
	            if (_this.props.onClose) {
	                _this.props.onClose();
	            }
	        }, _this.handleClickAction = function (action) {
	            var onChangeCardAndRun = _this.props.onChangeCardAndRun;
	
	            if (action.popover) {
	                _this.setState({ popoverAction: action });
	            } else if (action.question) {
	                var nextQuestion = action.question();
	                if (nextQuestion) {
	                    _analytics2.default.trackEvent("Actions", "Executed Click Action", (action.section || "") + ":" + (action.name || ""));
	                    onChangeCardAndRun({ nextCard: nextQuestion.card() });
	                }
	                _this.close();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ChartClickActions, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                clicked = _props.clicked,
	                clickActions = _props.clickActions,
	                onChangeCardAndRun = _props.onChangeCardAndRun;
	
	
	            if (!clicked || !clickActions || clickActions.length === 0) {
	                return null;
	            }
	
	            var popoverAction = this.state.popoverAction;
	
	            var popover = void 0;
	            if (popoverAction && popoverAction.popover) {
	                var PopoverContent = popoverAction.popover;
	                popover = _react2.default.createElement(PopoverContent, {
	                    onChangeCardAndRun: function (_onChangeCardAndRun) {
	                        function onChangeCardAndRun(_x) {
	                            return _onChangeCardAndRun.apply(this, arguments);
	                        }
	
	                        onChangeCardAndRun.toString = function () {
	                            return _onChangeCardAndRun.toString();
	                        };
	
	                        return onChangeCardAndRun;
	                    }(function (_ref2) {
	                        var nextCard = _ref2.nextCard;
	
	                        if (popoverAction) {
	                            _analytics2.default.trackEvent("Action", "Executed Click Action", (popoverAction.section || "") + ":" + (popoverAction.name || ""));
	                        }
	                        onChangeCardAndRun({ nextCard: nextCard });
	                    }),
	                    onClose: function onClose() {
	                        _analytics2.default.trackEvent("Action", "Dismissed Click Action Menu");
	                        _this2.close();
	                    }
	                });
	            }
	
	            var sections = _underscore2.default.chain(clickActions).groupBy("section").pairs().sortBy(function (_ref3) {
	                var _ref4 = _slicedToArray(_ref3, 1),
	                    key = _ref4[0];
	
	                return SECTIONS[key] ? SECTIONS[key].index : 99;
	            }).value();
	
	            return _react2.default.createElement(
	                _Popover2.default,
	                {
	                    target: clicked.element,
	                    targetEvent: clicked.event,
	                    onClose: function onClose() {
	                        _analytics2.default.trackEvent("Action", "Dismissed Click Action Menu");
	                        _this2.close();
	                    },
	                    verticalAttachments: ["top", "bottom"],
	                    horizontalAttachments: ["left", "center", "right"],
	                    sizeToFit: true,
	                    pinInitialAttachment: true
	                },
	                popover ? popover : _react2.default.createElement(
	                    "div",
	                    { className: "text-bold text-grey-3" },
	                    sections.map(function (_ref5) {
	                        var _ref6 = _slicedToArray(_ref5, 2),
	                            key = _ref6[0],
	                            actions = _ref6[1];
	
	                        return _react2.default.createElement(
	                            "div",
	                            { key: key, className: "border-row-divider p2 flex align-center text-default-hover" },
	                            _react2.default.createElement(_Icon2.default, { name: SECTIONS[key] && SECTIONS[key].icon || "unknown", className: "mr3", size: 16 }),
	                            actions.map(function (action, index) {
	                                return _react2.default.createElement(
	                                    "div",
	                                    {
	                                        key: index,
	                                        className: (0, _classnames2.default)("text-brand-hover cursor-pointer", { "pr2": index === actions.length - 1, "pr4": index != actions.length - 1 }),
	                                        onClick: function onClick() {
	                                            return _this2.handleClickAction(action);
	                                        }
	                                    },
	                                    action.title
	                                );
	                            })
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ChartClickActions;
	}(_react.Component);
	
	ChartClickActions.displayName = "ChartClickActions";
	exports.default = ChartClickActions;

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingSpinner = (_temp = _class = function (_Component) {
	    _inherits(LoadingSpinner, _Component);
	
	    function LoadingSpinner() {
	        _classCallCheck(this, LoadingSpinner);
	
	        return _possibleConstructorReturn(this, (LoadingSpinner.__proto__ || Object.getPrototypeOf(LoadingSpinner)).apply(this, arguments));
	    }
	
	    _createClass(LoadingSpinner, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                size = _props.size,
	                borderWidth = _props.borderWidth,
	                className = _props.className,
	                spinnerClassName = _props.spinnerClassName;
	
	            return _react2.default.createElement(
	                "div",
	                { className: className },
	                _react2.default.createElement("div", { className: spinnerClassName, style: { width: size, height: size, borderWidth: borderWidth } })
	            );
	        }
	    }]);
	
	    return LoadingSpinner;
	}(_react.Component), _class.defaultProps = {
	    size: 32,
	    borderWidth: 4,
	    fill: 'currentcolor',
	    spinnerClassName: 'LoadingSpinner'
	}, _temp);
	LoadingSpinner.displayName = "LoadingSpinner";
	exports.default = LoadingSpinner;

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1283 */,
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.extractRemappings = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.registerVisualization = registerVisualization;
	exports.getVisualizationRaw = getVisualizationRaw;
	exports.getVisualizationTransformed = getVisualizationTransformed;
	
	var _Scalar = __webpack_require__(1285);
	
	var _Scalar2 = _interopRequireDefault(_Scalar);
	
	var _Progress = __webpack_require__(1288);
	
	var _Progress2 = _interopRequireDefault(_Progress);
	
	var _Table = __webpack_require__(1298);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _LineChart = __webpack_require__(1369);
	
	var _LineChart2 = _interopRequireDefault(_LineChart);
	
	var _BarChart = __webpack_require__(1395);
	
	var _BarChart2 = _interopRequireDefault(_BarChart);
	
	var _RowChart = __webpack_require__(1396);
	
	var _RowChart2 = _interopRequireDefault(_RowChart);
	
	var _PieChart = __webpack_require__(1397);
	
	var _PieChart2 = _interopRequireDefault(_PieChart);
	
	var _AreaChart = __webpack_require__(1405);
	
	var _AreaChart2 = _interopRequireDefault(_AreaChart);
	
	var _Map = __webpack_require__(1406);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _ScatterPlot = __webpack_require__(1491);
	
	var _ScatterPlot2 = _interopRequireDefault(_ScatterPlot);
	
	var _Funnel = __webpack_require__(1492);
	
	var _Funnel2 = _interopRequireDefault(_Funnel);
	
	var _ObjectDetail = __webpack_require__(1497);
	
	var _ObjectDetail2 = _interopRequireDefault(_ObjectDetail);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*  weak */
	
	var visualizations = new Map();
	var aliases = new Map();
	// $FlowFixMe
	visualizations.get = function (key) {
	    return Map.prototype.get.call(this, key) || aliases.get(key) || _Table2.default;
	};
	
	function registerVisualization(visualization) {
	    var identifier = visualization.identifier;
	    if (identifier == null) {
	        throw new Error("Visualization must define an 'identifier' static variable: " + visualization.name);
	    }
	    if (visualizations.has(identifier)) {
	        throw new Error("Visualization with that identifier is already registered: " + visualization.name);
	    }
	    visualizations.set(identifier, visualization);
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (visualization.aliases || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var alias = _step.value;
	
	            aliases.set(alias, visualization);
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	}
	
	function getVisualizationRaw(series) {
	    return {
	        series: series,
	        CardVisualization: visualizations.get(series[0].card.display)
	    };
	}
	
	function getVisualizationTransformed(series) {
	    // don't transform if we don't have the data
	    if (_underscore2.default.any(series, function (s) {
	        return s.data == null;
	    })) {
	        return getVisualizationRaw(series);
	    }
	
	    // if a visualization has a transformSeries function, do the transformation until it returns the same visualization / series
	    var CardVisualization = void 0,
	        lastSeries = void 0;
	    do {
	        CardVisualization = visualizations.get(series[0].card.display);
	        if (!CardVisualization) {
	            throw new Error("No visualization for " + series[0].card.display);
	        }
	        lastSeries = series;
	        if (typeof CardVisualization.transformSeries === "function") {
	            series = CardVisualization.transformSeries(series);
	        }
	        if (series !== lastSeries) {
	            // $FlowFixMe
	            series = [].concat(_toConsumableArray(series));
	            // $FlowFixMe
	            series._raw = lastSeries;
	        }
	    } while (series !== lastSeries);
	
	    return { series: series, CardVisualization: CardVisualization };
	}
	
	var extractRemappings = exports.extractRemappings = function extractRemappings(series) {
	    var se = series.map(function (s) {
	        return _extends({}, s, {
	            data: s.data && extractRemappedColumns(s.data)
	        });
	    });
	    return se;
	};
	
	// removes columns with `remapped_from` property and adds a `remapping` to the appropriate column
	var extractRemappedColumns = function extractRemappedColumns(data) {
	    var cols = data.cols.map(function (col) {
	        return _extends({}, col, {
	            remapped_from_index: col.remapped_from && _underscore2.default.findIndex(data.cols, function (c) {
	                return c.name === col.remapped_from;
	            }),
	            remapping: col.remapped_to && new Map()
	        });
	    });
	
	    var rows = data.rows.map(function (row, rowIndex) {
	        return row.filter(function (value, colIndex) {
	            var col = cols[colIndex];
	            if (col.remapped_from != null) {
	                cols[col.remapped_from_index].remapped_to_column = col;
	                cols[col.remapped_from_index].remapping.set(row[col.remapped_from_index], row[colIndex]);
	                return false;
	            } else {
	                return true;
	            }
	        });
	    });
	    return _extends({}, data, {
	        rows: rows,
	        cols: cols.filter(function (col) {
	            return col.remapped_from == null;
	        })
	    });
	};
	
	registerVisualization(_Scalar2.default);
	registerVisualization(_Progress2.default);
	registerVisualization(_Table2.default);
	registerVisualization(_LineChart2.default);
	registerVisualization(_AreaChart2.default);
	registerVisualization(_BarChart2.default);
	registerVisualization(_RowChart2.default);
	registerVisualization(_ScatterPlot2.default);
	registerVisualization(_PieChart2.default);
	registerVisualization(_Map2.default);
	registerVisualization(_Funnel2.default);
	registerVisualization(_ObjectDetail2.default);
	
	exports.default = visualizations;

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Scalar = __webpack_require__(1286);
	
	var _Scalar2 = _interopRequireDefault(_Scalar);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Ellipsified = __webpack_require__(1277);
	
	var _Ellipsified2 = _interopRequireDefault(_Ellipsified);
	
	var _formatting = __webpack_require__(872);
	
	var _types = __webpack_require__(868);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d2 = __webpack_require__(873);
	
	var _d3 = _interopRequireDefault(_d2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scalar = (_temp = _class = function (_Component) {
	    _inherits(Scalar, _Component);
	
	    function Scalar() {
	        _classCallCheck(this, Scalar);
	
	        return _possibleConstructorReturn(this, (Scalar.__proto__ || Object.getPrototypeOf(Scalar)).apply(this, arguments));
	    }
	
	    _createClass(Scalar, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$series = _slicedToArray(_props.series, 1),
	                _props$series$ = _props$series[0],
	                card = _props$series$.card,
	                _props$series$$data = _props$series$.data,
	                cols = _props$series$$data.cols,
	                rows = _props$series$$data.rows,
	                className = _props.className,
	                actionButtons = _props.actionButtons,
	                gridSize = _props.gridSize,
	                settings = _props.settings,
	                onChangeCardAndRun = _props.onChangeCardAndRun,
	                visualizationIsClickable = _props.visualizationIsClickable,
	                onVisualizationClick = _props.onVisualizationClick;
	
	            var description = settings["card.description"];
	
	            var isSmall = gridSize && gridSize.width < 4;
	            var column = cols[0];
	
	            var scalarValue = rows[0] && rows[0][0];
	            if (scalarValue == null) {
	                scalarValue = "";
	            }
	
	            var compactScalarValue = void 0,
	                fullScalarValue = void 0;
	
	            // TODO: some or all of these options should be part of formatValue
	            if (typeof scalarValue === "number" && (0, _schema_metadata.isNumber)(column)) {
	                var number = scalarValue;
	
	                // scale
	                var scale = parseFloat(settings["scalar.scale"]);
	                if (!isNaN(scale)) {
	                    number *= scale;
	                }
	
	                var localeStringOptions = {};
	
	                // decimals
	                var decimals = parseFloat(settings["scalar.decimals"]);
	                if (!isNaN(decimals)) {
	                    number = _d3.default.round(number, decimals);
	                    localeStringOptions.minimumFractionDigits = decimals;
	                }
	
	                // currency
	                if (settings["scalar.currency"] != null) {
	                    localeStringOptions.style = "currency";
	                    localeStringOptions.currency = settings["scalar.currency"];
	                }
	
	                try {
	                    // format with separators and correct number of decimals
	                    if (settings["scalar.locale"]) {
	                        number = number.toLocaleString(settings["scalar.locale"], localeStringOptions);
	                    } else {
	                        // HACK: no locales that don't thousands separators?
	                        number = number.toLocaleString("en", localeStringOptions).replace(/,/g, "");
	                    }
	                } catch (e) {
	                    console.warn("error formatting scalar", e);
	                }
	                fullScalarValue = (0, _formatting.formatValue)(number, { column: column });
	            } else {
	                fullScalarValue = (0, _formatting.formatValue)(scalarValue, { column: column });
	            }
	
	            compactScalarValue = isSmall ? (0, _formatting.formatValue)(scalarValue, { column: column, compact: true }) : fullScalarValue;
	
	            if (settings["scalar.prefix"]) {
	                compactScalarValue = settings["scalar.prefix"] + compactScalarValue;
	                fullScalarValue = settings["scalar.prefix"] + fullScalarValue;
	            }
	            if (settings["scalar.suffix"]) {
	                compactScalarValue = compactScalarValue + settings["scalar.suffix"];
	                fullScalarValue = fullScalarValue + settings["scalar.suffix"];
	            }
	
	            var clicked = {
	                value: rows[0] && rows[0][0],
	                column: cols[0]
	            };
	            var isClickable = visualizationIsClickable(clicked);
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(className, _Scalar2.default.Scalar, _Scalar2.default[isSmall ? "small" : "large"]) },
	                _react2.default.createElement(
	                    "div",
	                    { className: "Card-title absolute top right p1 px2" },
	                    actionButtons
	                ),
	                _react2.default.createElement(
	                    _Ellipsified2.default,
	                    {
	                        className: (0, _classnames2.default)(_Scalar2.default.Value, 'ScalarValue text-dark fullscreen-normal-text fullscreen-night-text', {
	                            "text-brand-hover cursor-pointer": isClickable
	                        }),
	                        tooltip: fullScalarValue,
	                        alwaysShowTooltip: fullScalarValue !== compactScalarValue,
	                        style: { maxWidth: '100%' }
	                    },
	                    _react2.default.createElement(
	                        "span",
	                        {
	                            onClick: isClickable && function () {
	                                return _this2._scalar && onVisualizationClick(_extends({}, clicked, { element: _this2._scalar }));
	                            },
	                            ref: function ref(scalar) {
	                                return _this2._scalar = scalar;
	                            }
	                        },
	                        compactScalarValue
	                    )
	                ),
	                this.props.isDashboard && _react2.default.createElement(
	                    "div",
	                    { className: _Scalar2.default.Title + " flex align-center relative" },
	                    _react2.default.createElement(
	                        _Ellipsified2.default,
	                        { tooltip: card.name },
	                        _react2.default.createElement(
	                            "span",
	                            {
	                                onClick: onChangeCardAndRun && function () {
	                                    return onChangeCardAndRun({ nextCard: card });
	                                },
	                                className: (0, _classnames2.default)("fullscreen-normal-text fullscreen-night-text", {
	                                    "cursor-pointer": !!onChangeCardAndRun
	                                })
	                            },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "Scalar-title" },
	                                settings["card.title"]
	                            )
	                        )
	                    ),
	                    description && _react2.default.createElement(
	                        "div",
	                        {
	                            className: "absolute top bottom hover-child flex align-center justify-center",
	                            style: { right: -20, top: 2 }
	                        },
	                        _react2.default.createElement(
	                            _Tooltip2.default,
	                            { tooltip: description, maxWidth: '22em' },
	                            _react2.default.createElement(_Icon2.default, { name: "infooutlined" })
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: "isSensible",
	        value: function isSensible(cols, rows) {
	            return rows.length === 1 && cols.length === 1;
	        }
	    }, {
	        key: "checkRenderable",
	        value: function checkRenderable(_ref) {
	            // scalar can always be rendered, nothing needed here
	
	            var _ref2 = _slicedToArray(_ref, 1),
	                _ref2$0$data = _ref2[0].data,
	                cols = _ref2$0$data.cols,
	                rows = _ref2$0$data.rows;
	        }
	    }, {
	        key: "seriesAreCompatible",
	        value: function seriesAreCompatible(initialSeries, newSeries) {
	            if (newSeries.data.cols && newSeries.data.cols.length === 1) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: "transformSeries",
	        value: function transformSeries(series) {
	            if (series.length > 1) {
	                return series.map(function (s, seriesIndex) {
	                    return {
	                        card: _extends({}, s.card, {
	                            display: "funnel",
	                            visualization_settings: _extends({}, s.card.visualization_settings, {
	                                "graph.x_axis.labels_enabled": false
	                            }),
	                            _seriesIndex: seriesIndex
	                        }),
	                        data: {
	                            cols: [{ base_type: _types.TYPE.Text, display_name: "Name", name: "name" }, _extends({}, s.data.cols[0])],
	                            rows: [[s.card.name, s.data.rows[0][0]]]
	                        }
	                    };
	                });
	            } else {
	                return series;
	            }
	        }
	    }]);
	
	    return Scalar;
	}(_react.Component), _class.uiName = "Number", _class.identifier = "scalar", _class.iconName = "number", _class.noHeader = true, _class.supportsSeries = true, _class.minSize = { width: 3, height: 3 }, _class.settings = {
	    "scalar.locale": {
	        title: "Separator style",
	        widget: "select",
	        props: {
	            options: [{ name: "100000.00", value: null }, { name: "100,000.00", value: "en" }, { name: "100 000,00", value: "fr" }, { name: "100.000,00", value: "de" }]
	        },
	        default: "en"
	    },
	    "scalar.decimals": {
	        title: "Number of decimal places",
	        widget: "number"
	    },
	    "scalar.prefix": {
	        title: "Add a prefix",
	        widget: "input"
	    },
	    "scalar.suffix": {
	        title: "Add a suffix",
	        widget: "input"
	    },
	    "scalar.scale": {
	        title: "Multiply by a number",
	        widget: "number"
	    }
	}, _temp);
	Scalar.displayName = "Scalar";
	exports.default = Scalar;

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Scalar":"_1yBQv","Value":"_4U6UK","Title":"_1QEEv","small":"_3eqn_","large":"_2Rovb"};

/***/ }),
/* 1287 */,
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _formatting = __webpack_require__(872);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _IconBorder = __webpack_require__(1289);
	
	var _IconBorder2 = _interopRequireDefault(_IconBorder);
	
	var _colors = __webpack_require__(881);
	
	var _color = __webpack_require__(1290);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BORDER_RADIUS = 5;
	var MAX_BAR_HEIGHT = 65;
	
	var Progress = (_temp = _class = function (_Component) {
	    _inherits(Progress, _Component);
	
	    function Progress() {
	        _classCallCheck(this, Progress);
	
	        return _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
	    }
	
	    _createClass(Progress, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.componentDidUpdate();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var component = _reactDom2.default.findDOMNode(this);
	            var pointer = _reactDom2.default.findDOMNode(this.refs.pointer);
	            var label = _reactDom2.default.findDOMNode(this.refs.label);
	            var container = _reactDom2.default.findDOMNode(this.refs.container);
	            var bar = _reactDom2.default.findDOMNode(this.refs.bar);
	
	            // Safari not respecting `height: 25%` so just do it here ¯\_(ツ)_/¯
	            bar.style.height = Math.min(MAX_BAR_HEIGHT, component.offsetHeight) + "px";
	
	            if (this.props.gridSize && this.props.gridSize.height < 4) {
	                pointer.parentNode.style.display = "none";
	                label.parentNode.style.display = "none";
	                // no need to do the rest of the repositioning
	                return;
	            } else {
	                pointer.parentNode.style.display = null;
	                label.parentNode.style.display = null;
	            }
	
	            // reset the pointer transform for these computations
	            pointer.style.transform = null;
	
	            // position the label
	            var containerWidth = container.offsetWidth;
	            var labelWidth = label.offsetWidth;
	            var pointerWidth = pointer.offsetWidth;
	            var pointerCenter = pointer.offsetLeft + pointerWidth / 2;
	            var minOffset = -pointerWidth / 2 + BORDER_RADIUS;
	            if (pointerCenter - labelWidth / 2 < minOffset) {
	                label.style.left = minOffset + "px";
	                label.style.right = null;
	            } else if (pointerCenter + labelWidth / 2 > containerWidth - minOffset) {
	                label.style.left = null;
	                label.style.right = minOffset + "px";
	            } else {
	                label.style.left = pointerCenter - labelWidth / 2 + "px";
	                label.style.right = null;
	            }
	
	            // shift pointer at ends inward to line up with border radius
	            if (pointerCenter < BORDER_RADIUS) {
	                pointer.style.transform = "translate(" + BORDER_RADIUS + "px,0)";
	            } else if (pointerCenter > containerWidth - 5) {
	                pointer.style.transform = "translate(-" + BORDER_RADIUS + "px,0)";
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                _props$series = _slicedToArray(_props.series, 1),
	                _props$series$0$data = _props$series[0].data,
	                rows = _props$series$0$data.rows,
	                cols = _props$series$0$data.cols,
	                settings = _props.settings,
	                onVisualizationClick = _props.onVisualizationClick,
	                visualizationIsClickable = _props.visualizationIsClickable;
	
	            var value = rows[0][0];
	            var goal = settings["progress.goal"] || 0;
	
	            var mainColor = settings["progress.color"];
	            var lightColor = (0, _color2.default)(mainColor).lighten(0.25).rgb().string();
	            var darkColor = (0, _color2.default)(mainColor).darken(0.30).rgb().string();
	
	            var progressColor = mainColor;
	            var restColor = value > goal ? darkColor : lightColor;
	            var arrowColor = value > goal ? darkColor : mainColor;
	
	            var barPercent = Math.max(0, value < goal ? value / goal : goal / value);
	            var arrowPercent = Math.max(0, value < goal ? value / goal : 1);
	
	            var barMessage = void 0;
	            if (value === goal) {
	                barMessage = "Goal met";
	            } else if (value > goal) {
	                barMessage = "Goal exceeded";
	            }
	
	            var clicked = {
	                value: value,
	                column: cols[0]
	            };
	            var isClickable = visualizationIsClickable(clicked);
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(this.props.className, "flex layout-centered") },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex-full full-height flex flex-column justify-center", style: { padding: 10, paddingTop: 0 } },
	                    _react2.default.createElement(
	                        "div",
	                        {
	                            ref: "container",
	                            className: "relative text-bold text-grey-4",
	                            style: { height: 20 }
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                ref: "label",
	                                style: { position: "absolute" }
	                            },
	                            (0, _formatting.formatValue)(value, { comma: true })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "relative", style: { height: 10, marginBottom: 5 } },
	                        _react2.default.createElement("div", {
	                            ref: "pointer",
	                            style: {
	                                width: 0,
	                                height: 0,
	                                position: "absolute",
	                                left: arrowPercent * 100 + "%",
	                                marginLeft: -10,
	                                borderLeft: "10px solid transparent",
	                                borderRight: "10px solid transparent",
	                                borderTop: "10px solid " + arrowColor
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        {
	                            ref: "bar",
	                            className: (0, _classnames2.default)("relative", { "cursor-pointer": isClickable }),
	                            style: {
	                                backgroundColor: restColor,
	                                borderRadius: BORDER_RADIUS,
	                                overflow: "hidden"
	                            },
	                            onClick: isClickable && function (e) {
	                                return onVisualizationClick(_extends({}, clicked, { event: e.nativeEvent }));
	                            }
	                        },
	                        _react2.default.createElement("div", { style: {
	                                backgroundColor: progressColor,
	                                width: barPercent * 100 + "%",
	                                height: "100%"
	                            }
	                        }),
	                        barMessage && _react2.default.createElement(
	                            "div",
	                            { className: "flex align-center absolute spread text-white text-bold px2" },
	                            _react2.default.createElement(
	                                _IconBorder2.default,
	                                { borderWidth: 2 },
	                                _react2.default.createElement(_Icon2.default, { name: "check", size: 14 })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "pl2" },
	                                barMessage
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "mt1" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "float-left" },
	                            "0"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            { className: "float-right" },
	                            "Goal ",
	                            (0, _formatting.formatValue)(goal, { comma: true })
	                        )
	                    )
	                )
	            );
	        }
	    }], [{
	        key: "isSensible",
	        value: function isSensible(cols, rows) {
	            return rows.length === 1 && cols.length === 1;
	        }
	    }, {
	        key: "checkRenderable",
	        value: function checkRenderable(_ref) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                _ref2$0$data = _ref2[0].data,
	                cols = _ref2$0$data.cols,
	                rows = _ref2$0$data.rows;
	
	            if (!(0, _schema_metadata.isNumeric)(cols[0])) {
	                throw new Error("Progress visualization requires a number.");
	            }
	        }
	    }]);
	
	    return Progress;
	}(_react.Component), _class.uiName = "Progress", _class.identifier = "progress", _class.iconName = "progress", _class.minSize = { width: 3, height: 3 }, _class.settings = {
	    "progress.goal": {
	        section: "Display",
	        title: "Goal",
	        widget: "number",
	        default: 0
	    },
	    "progress.color": {
	        section: "Display",
	        title: "Color",
	        widget: "color",
	        default: _colors.normal.green
	    }
	}, _temp);
	Progress.displayName = "Progress";
	exports.default = Progress;

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	   Creates a bordered container for an <Icon /> component
	   based on the <Icon /> component's size.
	
	   usage:
	   <IconBorder {...props} >
	   <Icon name={chevrondown} size={12} />
	   </IconBorder>
	 */
	
	var IconBorder = (_temp = _class = function (_Component) {
	    _inherits(IconBorder, _Component);
	
	    function IconBorder() {
	        _classCallCheck(this, IconBorder);
	
	        return _possibleConstructorReturn(this, (IconBorder.__proto__ || Object.getPrototypeOf(IconBorder)).apply(this, arguments));
	    }
	
	    _createClass(IconBorder, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                borderWidth = _props.borderWidth,
	                borderStyle = _props.borderStyle,
	                borderColor = _props.borderColor,
	                borderRadius = _props.borderRadius,
	                className = _props.className,
	                style = _props.style,
	                children = _props.children;
	
	            var size = parseInt(children.props.size || children.props.width, 10) * 2;
	            var styles = _extends({
	                width: size,
	                height: size,
	                borderWidth: borderWidth,
	                borderStyle: borderStyle,
	                borderColor: borderColor,
	                borderRadius: borderRadius
	            }, style);
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)('flex layout-centered', className), style: styles },
	                children
	            );
	        }
	    }]);
	
	    return IconBorder;
	}(_react.Component), _class.propTypes = {
	    borderWidth: _propTypes2.default.string,
	    borderStyle: _propTypes2.default.string,
	    borderColor: _propTypes2.default.string,
	    borderRadius: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    children: _propTypes2.default.any.isRequired
	}, _class.defaultProps = {
	    borderWidth: '1px',
	    borderStyle: 'solid',
	    borderColor: 'currentcolor',
	    borderRadius: '99px',
	    style: {}
	}, _temp);
	IconBorder.displayName = "IconBorder";
	exports.default = IconBorder;

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var colorString = __webpack_require__(1291);
	var convert = __webpack_require__(1295);
	
	var _slice = [].slice;
	
	var skippedModels = [
		// to be honest, I don't really feel like keyword belongs in color convert, but eh.
		'keyword',
	
		// gray conflicts with some method names, and has its own method defined.
		'gray',
	
		// shouldn't really be in color-convert either...
		'hex'
	];
	
	var hashedModelKeys = {};
	Object.keys(convert).forEach(function (model) {
		hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
	});
	
	var limiters = {};
	
	function Color(obj, model) {
		if (!(this instanceof Color)) {
			return new Color(obj, model);
		}
	
		if (model && model in skippedModels) {
			model = null;
		}
	
		if (model && !(model in convert)) {
			throw new Error('Unknown model: ' + model);
		}
	
		var i;
		var channels;
	
		if (!obj) {
			this.model = 'rgb';
			this.color = [0, 0, 0];
			this.valpha = 1;
		} else if (obj instanceof Color) {
			this.model = obj.model;
			this.color = obj.color.slice();
			this.valpha = obj.valpha;
		} else if (typeof obj === 'string') {
			var result = colorString.get(obj);
			if (result === null) {
				throw new Error('Unable to parse color from string: ' + obj);
			}
	
			this.model = result.model;
			channels = convert[this.model].channels;
			this.color = result.value.slice(0, channels);
			this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
		} else if (obj.length) {
			this.model = model || 'rgb';
			channels = convert[this.model].channels;
			var newArr = _slice.call(obj, 0, channels);
			this.color = zeroArray(newArr, channels);
			this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
		} else if (typeof obj === 'number') {
			// this is always RGB - can be converted later on.
			obj &= 0xFFFFFF;
			this.model = 'rgb';
			this.color = [
				(obj >> 16) & 0xFF,
				(obj >> 8) & 0xFF,
				obj & 0xFF
			];
			this.valpha = 1;
		} else {
			this.valpha = 1;
	
			var keys = Object.keys(obj);
			if ('alpha' in obj) {
				keys.splice(keys.indexOf('alpha'), 1);
				this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
			}
	
			var hashedKeys = keys.sort().join('');
			if (!(hashedKeys in hashedModelKeys)) {
				throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
			}
	
			this.model = hashedModelKeys[hashedKeys];
	
			var labels = convert[this.model].labels;
			var color = [];
			for (i = 0; i < labels.length; i++) {
				color.push(obj[labels[i]]);
			}
	
			this.color = zeroArray(color);
		}
	
		// perform limitations (clamping, etc.)
		if (limiters[this.model]) {
			channels = convert[this.model].channels;
			for (i = 0; i < channels; i++) {
				var limit = limiters[this.model][i];
				if (limit) {
					this.color[i] = limit(this.color[i]);
				}
			}
		}
	
		this.valpha = Math.max(0, Math.min(1, this.valpha));
	
		if (Object.freeze) {
			Object.freeze(this);
		}
	}
	
	Color.prototype = {
		toString: function () {
			return this.string();
		},
	
		toJSON: function () {
			return this[this.model]();
		},
	
		string: function (places) {
			var self = this.model in colorString.to ? this : this.rgb();
			self = self.round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to[self.model](args);
		},
	
		percentString: function (places) {
			var self = this.rgb().round(typeof places === 'number' ? places : 1);
			var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
			return colorString.to.rgb.percent(args);
		},
	
		array: function () {
			return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
		},
	
		object: function () {
			var result = {};
			var channels = convert[this.model].channels;
			var labels = convert[this.model].labels;
	
			for (var i = 0; i < channels; i++) {
				result[labels[i]] = this.color[i];
			}
	
			if (this.valpha !== 1) {
				result.alpha = this.valpha;
			}
	
			return result;
		},
	
		unitArray: function () {
			var rgb = this.rgb().color;
			rgb[0] /= 255;
			rgb[1] /= 255;
			rgb[2] /= 255;
	
			if (this.valpha !== 1) {
				rgb.push(this.valpha);
			}
	
			return rgb;
		},
	
		unitObject: function () {
			var rgb = this.rgb().object();
			rgb.r /= 255;
			rgb.g /= 255;
			rgb.b /= 255;
	
			if (this.valpha !== 1) {
				rgb.alpha = this.valpha;
			}
	
			return rgb;
		},
	
		round: function (places) {
			places = Math.max(places || 0, 0);
			return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
		},
	
		alpha: function (val) {
			if (arguments.length) {
				return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
			}
	
			return this.valpha;
		},
	
		// rgb
		red: getset('rgb', 0, maxfn(255)),
		green: getset('rgb', 1, maxfn(255)),
		blue: getset('rgb', 2, maxfn(255)),
	
		hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style
	
		saturationl: getset('hsl', 1, maxfn(100)),
		lightness: getset('hsl', 2, maxfn(100)),
	
		saturationv: getset('hsv', 1, maxfn(100)),
		value: getset('hsv', 2, maxfn(100)),
	
		chroma: getset('hcg', 1, maxfn(100)),
		gray: getset('hcg', 2, maxfn(100)),
	
		white: getset('hwb', 1, maxfn(100)),
		wblack: getset('hwb', 2, maxfn(100)),
	
		cyan: getset('cmyk', 0, maxfn(100)),
		magenta: getset('cmyk', 1, maxfn(100)),
		yellow: getset('cmyk', 2, maxfn(100)),
		black: getset('cmyk', 3, maxfn(100)),
	
		x: getset('xyz', 0, maxfn(100)),
		y: getset('xyz', 1, maxfn(100)),
		z: getset('xyz', 2, maxfn(100)),
	
		l: getset('lab', 0, maxfn(100)),
		a: getset('lab', 1),
		b: getset('lab', 2),
	
		keyword: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return convert[this.model].keyword(this.color);
		},
	
		hex: function (val) {
			if (arguments.length) {
				return new Color(val);
			}
	
			return colorString.to.hex(this.rgb().round().color);
		},
	
		rgbNumber: function () {
			var rgb = this.rgb().color;
			return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.rgb().color;
	
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
	
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
	
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
	
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.rgb().color;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = this.rgb();
			for (var i = 0; i < 3; i++) {
				rgb.color[i] = 255 - rgb.color[i];
			}
			return rgb;
		},
	
		lighten: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] += hsl.color[2] * ratio;
			return hsl;
		},
	
		darken: function (ratio) {
			var hsl = this.hsl();
			hsl.color[2] -= hsl.color[2] * ratio;
			return hsl;
		},
	
		saturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] += hsl.color[1] * ratio;
			return hsl;
		},
	
		desaturate: function (ratio) {
			var hsl = this.hsl();
			hsl.color[1] -= hsl.color[1] * ratio;
			return hsl;
		},
	
		whiten: function (ratio) {
			var hwb = this.hwb();
			hwb.color[1] += hwb.color[1] * ratio;
			return hwb;
		},
	
		blacken: function (ratio) {
			var hwb = this.hwb();
			hwb.color[2] += hwb.color[2] * ratio;
			return hwb;
		},
	
		grayscale: function () {
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var rgb = this.rgb().color;
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			return Color.rgb(val, val, val);
		},
	
		fade: function (ratio) {
			return this.alpha(this.valpha - (this.valpha * ratio));
		},
	
		opaquer: function (ratio) {
			return this.alpha(this.valpha + (this.valpha * ratio));
		},
	
		rotate: function (degrees) {
			var hsl = this.hsl();
			var hue = hsl.color[0];
			hue = (hue + degrees) % 360;
			hue = hue < 0 ? 360 + hue : hue;
			hsl.color[0] = hue;
			return hsl;
		},
	
		mix: function (mixinColor, weight) {
			// ported from sass implementation in C
			// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
			var color1 = this.rgb();
			var color2 = mixinColor.rgb();
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return Color.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue(),
					color1.alpha() * p + color2.alpha() * (1 - p));
		}
	};
	
	// model conversion methods and static constructors
	Object.keys(convert).forEach(function (model) {
		if (skippedModels.indexOf(model) !== -1) {
			return;
		}
	
		var channels = convert[model].channels;
	
		// conversion methods
		Color.prototype[model] = function () {
			if (this.model === model) {
				return new Color(this);
			}
	
			if (arguments.length) {
				return new Color(arguments, model);
			}
	
			var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
			return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
		};
	
		// 'static' construction methods
		Color[model] = function (color) {
			if (typeof color === 'number') {
				color = zeroArray(_slice.call(arguments), channels);
			}
			return new Color(color, model);
		};
	});
	
	function roundTo(num, places) {
		return Number(num.toFixed(places));
	}
	
	function roundToPlace(places) {
		return function (num) {
			return roundTo(num, places);
		};
	}
	
	function getset(model, channel, modifier) {
		model = Array.isArray(model) ? model : [model];
	
		model.forEach(function (m) {
			(limiters[m] || (limiters[m] = []))[channel] = modifier;
		});
	
		model = model[0];
	
		return function (val) {
			var result;
	
			if (arguments.length) {
				if (modifier) {
					val = modifier(val);
				}
	
				result = this[model]();
				result.color[channel] = val;
				return result;
			}
	
			result = this[model]().color[channel];
			if (modifier) {
				result = modifier(result);
			}
	
			return result;
		};
	}
	
	function maxfn(max) {
		return function (v) {
			return Math.max(0, Math.min(max, v));
		};
	}
	
	function assertArray(val) {
		return Array.isArray(val) ? val : [val];
	}
	
	function zeroArray(arr, length) {
		for (var i = 0; i < length; i++) {
			if (typeof arr[i] !== 'number') {
				arr[i] = 0;
			}
		}
	
		return arr;
	}
	
	module.exports = Color;


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(1292);
	var swizzle = __webpack_require__(1293);
	
	var reverseNames = {};
	
	// create a list of reverse color names
	for (var name in colorNames) {
		if (colorNames.hasOwnProperty(name)) {
			reverseNames[colorNames[name]] = name;
		}
	}
	
	var cs = module.exports = {
		to: {}
	};
	
	cs.get = function (string) {
		var prefix = string.substring(0, 3).toLowerCase();
		var val;
		var model;
		switch (prefix) {
			case 'hsl':
				val = cs.get.hsl(string);
				model = 'hsl';
				break;
			case 'hwb':
				val = cs.get.hwb(string);
				model = 'hwb';
				break;
			default:
				val = cs.get.rgb(string);
				model = 'rgb';
				break;
		}
	
		if (!val) {
			return null;
		}
	
		return {model: model, value: val};
	};
	
	cs.get.rgb = function (string) {
		if (!string) {
			return null;
		}
	
		var abbr = /^#([a-f0-9]{3,4})$/i;
		var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
		var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var keyword = /(\D+)/;
	
		var rgb = [0, 0, 0, 1];
		var match;
		var i;
		var hexAlpha;
	
		if (match = string.match(hex)) {
			hexAlpha = match[2];
			match = match[1];
	
			for (i = 0; i < 3; i++) {
				// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
				var i2 = i * 2;
				rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
			}
	
			if (hexAlpha) {
				rgb[3] = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
			}
		} else if (match = string.match(abbr)) {
			match = match[1];
			hexAlpha = match[3];
	
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i] + match[i], 16);
			}
	
			if (hexAlpha) {
				rgb[3] = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
			}
		} else if (match = string.match(rgba)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = parseInt(match[i + 1], 0);
			}
	
			if (match[4]) {
				rgb[3] = parseFloat(match[4]);
			}
		} else if (match = string.match(per)) {
			for (i = 0; i < 3; i++) {
				rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
			}
	
			if (match[4]) {
				rgb[3] = parseFloat(match[4]);
			}
		} else if (match = string.match(keyword)) {
			if (match[1] === 'transparent') {
				return [0, 0, 0, 0];
			}
	
			rgb = colorNames[match[1]];
	
			if (!rgb) {
				return null;
			}
	
			rgb[3] = 1;
	
			return rgb;
		} else {
			return null;
		}
	
		for (i = 0; i < 3; i++) {
			rgb[i] = clamp(rgb[i], 0, 255);
		}
		rgb[3] = clamp(rgb[3], 0, 1);
	
		return rgb;
	};
	
	cs.get.hsl = function (string) {
		if (!string) {
			return null;
		}
	
		var hsl = /^hsla?\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var match = string.match(hsl);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = ((parseFloat(match[1]) % 360) + 360) % 360;
			var s = clamp(parseFloat(match[2]), 0, 100);
			var l = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
	
			return [h, s, l, a];
		}
	
		return null;
	};
	
	cs.get.hwb = function (string) {
		if (!string) {
			return null;
		}
	
		var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
		var match = string.match(hwb);
	
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = ((parseFloat(match[1]) % 360) + 360) % 360;
			var w = clamp(parseFloat(match[2]), 0, 100);
			var b = clamp(parseFloat(match[3]), 0, 100);
			var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
			return [h, w, b, a];
		}
	
		return null;
	};
	
	cs.to.hex = function () {
		var rgba = swizzle(arguments);
	
		return (
			'#' +
			hexDouble(rgba[0]) +
			hexDouble(rgba[1]) +
			hexDouble(rgba[2]) +
			(rgba[3] < 1
				? (hexDouble(Math.round(rgba[3] * 255)))
				: '')
		);
	};
	
	cs.to.rgb = function () {
		var rgba = swizzle(arguments);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
			: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
	};
	
	cs.to.rgb.percent = function () {
		var rgba = swizzle(arguments);
	
		var r = Math.round(rgba[0] / 255 * 100);
		var g = Math.round(rgba[1] / 255 * 100);
		var b = Math.round(rgba[2] / 255 * 100);
	
		return rgba.length < 4 || rgba[3] === 1
			? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
			: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
	};
	
	cs.to.hsl = function () {
		var hsla = swizzle(arguments);
		return hsla.length < 4 || hsla[3] === 1
			? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
			: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
	};
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	cs.to.hwb = function () {
		var hwba = swizzle(arguments);
	
		var a = '';
		if (hwba.length >= 4 && hwba[3] !== 1) {
			a = ', ' + hwba[3];
		}
	
		return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
	};
	
	cs.to.keyword = function (rgb) {
		return reverseNames[rgb.slice(0, 3)];
	};
	
	// helpers
	function clamp(num, min, max) {
		return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
		var str = num.toString(16).toUpperCase();
		return (str.length < 2) ? '0' + str : str;
	}


/***/ }),
/* 1292 */
/***/ (function(module, exports) {

	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isArrayish = __webpack_require__(1294);
	
	var concat = Array.prototype.concat;
	var slice = Array.prototype.slice;
	
	var swizzle = module.exports = function swizzle(args) {
		var results = [];
	
		for (var i = 0, len = args.length; i < len; i++) {
			var arg = args[i];
	
			if (isArrayish(arg)) {
				// http://jsperf.com/javascript-array-concat-vs-push/98
				results = concat.call(results, slice.call(arg));
			} else {
				results.push(arg);
			}
		}
	
		return results;
	};
	
	swizzle.wrap = function (fn) {
		return function () {
			return fn(swizzle(arguments));
		};
	};


/***/ }),
/* 1294 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isArrayish(obj) {
		if (!obj || typeof obj === 'string') {
			return false;
		}
	
		return obj instanceof Array || Array.isArray(obj) ||
			(obj.length >= 0 && (obj.splice instanceof Function ||
				(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
	};


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(1296);
	var route = __webpack_require__(1297);
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	module.exports = convert;


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var cssKeywords = __webpack_require__(1292);
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
		if (cssKeywords.hasOwnProperty(key)) {
			reverseKeywords[cssKeywords[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var v;
	
		if (max === 0) {
			s = 0;
		} else {
			s = (delta / max * 1000) / 10;
		}
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		v = ((max / 255) * 1000) / 10;
	
		return [h, s, v];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in cssKeywords) {
			if (cssKeywords.hasOwnProperty(keyword)) {
				var value = cssKeywords[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return cssKeywords[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(1296);
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);
	
	function buildGraph() {
		var graph = {};
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	module.exports = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TestTable = exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableInteractive = __webpack_require__(1299);
	
	var _TableInteractive2 = _interopRequireDefault(_TableInteractive);
	
	var _TableSimple = __webpack_require__(1362);
	
	var _TableSimple2 = _interopRequireDefault(_TableSimple);
	
	var _data_grid = __webpack_require__(1365);
	
	var DataGrid = _interopRequireWildcard(_data_grid);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _utils = __webpack_require__(878);
	
	var _ChartSettingOrderedFields = __webpack_require__(1366);
	
	var _ChartSettingOrderedFields2 = _interopRequireDefault(_ChartSettingOrderedFields);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Table = (_temp = _class = function (_Component) {
	    _inherits(Table, _Component);
	
	    _createClass(Table, null, [{
	        key: "isSensible",
	        value: function isSensible(cols, rows) {
	            return true;
	        }
	    }, {
	        key: "checkRenderable",
	        value: function checkRenderable(_ref) {
	            // scalar can always be rendered, nothing needed here
	
	            var _ref2 = _slicedToArray(_ref, 1),
	                _ref2$0$data = _ref2[0].data,
	                cols = _ref2$0$data.cols,
	                rows = _ref2$0$data.rows;
	        }
	    }]);
	
	    function Table(props) {
	        _classCallCheck(this, Table);
	
	        var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	        _this.state = {
	            data: null
	        };
	        return _this;
	    }
	
	    _createClass(Table, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this._updateData(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            // TODO: remove use of deprecated "card" and "data" props
	            if (newProps.data !== this.props.data || !_underscore2.default.isEqual(newProps.settings, this.props.settings)) {
	                this._updateData(newProps);
	            }
	        }
	    }, {
	        key: "_updateData",
	        value: function _updateData(_ref3) {
	            var data = _ref3.data,
	                settings = _ref3.settings;
	
	            if (settings["table.pivot"]) {
	                this.setState({
	                    data: DataGrid.pivot(data)
	                });
	            } else {
	                var cols = data.cols,
	                    rows = data.rows,
	                    columns = data.columns;
	
	                var columnIndexes = settings["table.columns"].filter(function (f) {
	                    return f.enabled;
	                }).map(function (f) {
	                    return _underscore2.default.findIndex(cols, function (c) {
	                        return c.name === f.name;
	                    });
	                }).filter(function (i) {
	                    return i >= 0 && i < cols.length;
	                });
	
	                this.setState({
	                    data: {
	                        cols: columnIndexes.map(function (i) {
	                            return cols[i];
	                        }),
	                        columns: columnIndexes.map(function (i) {
	                            return columns[i];
	                        }),
	                        rows: rows.map(function (row) {
	                            return columnIndexes.map(function (i) {
	                                return row[i];
	                            });
	                        })
	                    }
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                card = _props.card,
	                isDashboard = _props.isDashboard,
	                settings = _props.settings;
	            var data = this.state.data;
	
	            var sort = (0, _icepick.getIn)(card, ["dataset_query", "query", "order_by"]) || null;
	            var isPivoted = settings["table.pivot"];
	            var TableComponent = isDashboard ? _TableSimple2.default : _TableInteractive2.default;
	
	            if (!data) {
	                return null;
	            }
	
	            return (
	                // $FlowFixMe
	                _react2.default.createElement(TableComponent, _extends({}, this.props, {
	                    data: data,
	                    isPivoted: isPivoted,
	                    sort: sort
	                }))
	            );
	        }
	    }]);
	
	    return Table;
	}(_react.Component), _class.uiName = "Table", _class.identifier = "table", _class.iconName = "table", _class.minSize = { width: 4, height: 4 }, _class.settings = {
	    "table.pivot": {
	        title: "Pivot the table",
	        widget: "toggle",
	        getHidden: function getHidden(_ref4) {
	            var _ref5 = _slicedToArray(_ref4, 1),
	                _ref5$ = _ref5[0],
	                card = _ref5$.card,
	                data = _ref5$.data;
	
	            return data && data.cols.length !== 3;
	        },
	        getDefault: function getDefault(_ref6) {
	            var _ref7 = _slicedToArray(_ref6, 1),
	                _ref7$ = _ref7[0],
	                card = _ref7$.card,
	                data = _ref7$.data;
	
	            return data && data.cols.length === 3 && _query2.default.isStructured(card.dataset_query) && data.cols.filter(_schema_metadata.isMetric).length === 1 && data.cols.filter(_schema_metadata.isDimension).length === 2;
	        }
	    },
	    "table.columns": {
	        title: "Fields to include",
	        widget: _ChartSettingOrderedFields2.default,
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["table.pivot"];
	        },
	        isValid: function isValid(_ref8) {
	            var _ref9 = _slicedToArray(_ref8, 1),
	                _ref9$ = _ref9[0],
	                card = _ref9$.card,
	                data = _ref9$.data;
	
	            return card.visualization_settings["table.columns"] && (0, _utils.columnsAreValid)(card.visualization_settings["table.columns"].map(function (x) {
	                return x.name;
	            }), data);
	        },
	        getDefault: function getDefault(_ref10) {
	            var _ref11 = _slicedToArray(_ref10, 1),
	                cols = _ref11[0].data.cols;
	
	            return cols.map(function (col) {
	                return {
	                    name: col.name,
	                    enabled: col.visibility_type !== "details-only"
	                };
	            });
	        },
	        getProps: function getProps(_ref12) {
	            var _ref13 = _slicedToArray(_ref12, 1),
	                cols = _ref13[0].data.cols;
	
	            return {
	                columnNames: cols.reduce(function (o, col) {
	                    return _extends({}, o, _defineProperty({}, col.name, (0, _utils.getFriendlyName)(col)));
	                }, {})
	            };
	        }
	    },
	    "table.column_widths": {}
	}, _temp);
	Table.displayName = "Table";
	exports.default = Table;
	
	
	/**
	 * A modified version of TestPopover for Jest/Enzyme tests.
	 * It always uses TableSimple which Enzyme is able to render correctly.
	 * TableInteractive uses react-virtualized library which requires a real browser viewport.
	 */
	var TestTable = exports.TestTable = function TestTable(props) {
	    return _react2.default.createElement(Table, _extends({}, props, { isDashboard: true }));
	};
	TestTable.displayName = "TestTable";
	TestTable.uiName = Table.uiName;
	TestTable.identifier = Table.identifier;
	TestTable.iconName = Table.iconName;
	TestTable.minSize = Table.minSize;
	TestTable.settings = Table.settings;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(1300);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _formatting = __webpack_require__(872);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _table = __webpack_require__(1302);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ExplicitSize = __webpack_require__(1271);
	
	var _ExplicitSize2 = _interopRequireDefault(_ExplicitSize);
	
	var _reactVirtualized = __webpack_require__(1303);
	
	var _reactDraggable = __webpack_require__(1361);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HEADER_HEIGHT = 36;
	var ROW_HEIGHT = 30;
	var MIN_COLUMN_WIDTH = ROW_HEIGHT;
	var RESIZE_HANDLE_WIDTH = 5;
	
	var TableInteractive = (0, _ExplicitSize2.default)(_class = (_temp = _class2 = function (_Component) {
	    _inherits(TableInteractive, _Component);
	
	    function TableInteractive(props) {
	        _classCallCheck(this, TableInteractive);
	
	        var _this = _possibleConstructorReturn(this, (TableInteractive.__proto__ || Object.getPrototypeOf(TableInteractive)).call(this, props));
	
	        _this.recomputeGridSize = function () {
	            if (_this.header && _this.grid) {
	                _this.header.recomputeGridSize();
	                _this.grid.recomputeGridSize();
	            }
	        };
	
	        _this.recomputeColumnSizes = _underscore2.default.debounce(function () {
	            _this.setState({ contentWidths: null });
	        }, 100);
	
	        _this.cellRenderer = function (_ref) {
	            var key = _ref.key,
	                style = _ref.style,
	                rowIndex = _ref.rowIndex,
	                columnIndex = _ref.columnIndex;
	            var _this$props = _this.props,
	                data = _this$props.data,
	                isPivoted = _this$props.isPivoted,
	                onVisualizationClick = _this$props.onVisualizationClick,
	                visualizationIsClickable = _this$props.visualizationIsClickable;
	            var rows = data.rows,
	                cols = data.cols;
	
	
	            var column = cols[columnIndex];
	            var row = rows[rowIndex];
	            var value = row[columnIndex];
	
	            var clicked = (0, _table.getTableCellClickedObject)(data, rowIndex, columnIndex, isPivoted);
	            var isClickable = onVisualizationClick && visualizationIsClickable(clicked);
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    key: key, style: style,
	                    className: (0, _classnames2.default)("TableInteractive-cellWrapper", {
	                        "TableInteractive-cellWrapper--firstColumn": columnIndex === 0,
	                        "cursor-pointer": isClickable,
	                        "justify-end": (0, _table.isColumnRightAligned)(column),
	                        "link": isClickable && (0, _schema_metadata.isID)(column)
	                    }),
	                    onClick: isClickable && function (e) {
	                        onVisualizationClick(_extends({}, clicked, { element: e.currentTarget }));
	                    }
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "cellData" },
	                    (0, _formatting.formatValue)(value, {
	                        column: column,
	                        type: "cell",
	                        jsx: true
	                    })
	                )
	            );
	        };
	
	        _this.tableHeaderRenderer = function (_ref2) {
	            var key = _ref2.key,
	                style = _ref2.style,
	                columnIndex = _ref2.columnIndex;
	            var _this$props2 = _this.props,
	                sort = _this$props2.sort,
	                isPivoted = _this$props2.isPivoted,
	                onVisualizationClick = _this$props2.onVisualizationClick,
	                visualizationIsClickable = _this$props2.visualizationIsClickable;
	            // $FlowFixMe: not sure why flow has a problem with this
	
	            var cols = _this.props.data.cols;
	
	            var column = cols[columnIndex];
	
	            var columnTitle = (0, _formatting.formatColumn)(column);
	            if (!columnTitle && _this.props.isPivoted && columnIndex !== 0) {
	                columnTitle = "Unset";
	            }
	
	            var clicked = void 0;
	            if (isPivoted) {
	                // if it's a pivot table, the first column is
	                if (columnIndex >= 0) {
	                    clicked = column._dimension;
	                }
	            } else {
	                clicked = { column: column };
	            }
	
	            var isClickable = onVisualizationClick && visualizationIsClickable(clicked);
	            var isSortable = isClickable && column.source;
	            var isRightAligned = (0, _table.isColumnRightAligned)(column);
	
	            var isSorted = sort && sort[0] && sort[0][0] === column.id;
	            var isAscending = sort && sort[0] && sort[0][1] === "ascending";
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    key: key,
	                    style: _extends({}, style, { overflow: "visible" /* ensure resize handle is visible */ }),
	                    className: (0, _classnames2.default)("TableInteractive-cellWrapper TableInteractive-headerCellData", {
	                        "TableInteractive-cellWrapper--firstColumn": columnIndex === 0,
	                        "TableInteractive-headerCellData--sorted": isSorted,
	                        "cursor-pointer": isClickable,
	                        "justify-end": isRightAligned
	                    }),
	                    onClick: isClickable && function (e) {
	                        onVisualizationClick(_extends({}, clicked, { element: e.currentTarget }));
	                    }
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "cellData" },
	                    isSortable && isRightAligned && _react2.default.createElement(_Icon2.default, { className: "Icon mr1", name: isAscending ? "chevronup" : "chevrondown", size: 8 }),
	                    columnTitle,
	                    isSortable && !isRightAligned && _react2.default.createElement(_Icon2.default, { className: "Icon ml1", name: isAscending ? "chevronup" : "chevrondown", size: 8 })
	                ),
	                _react2.default.createElement(
	                    _reactDraggable2.default,
	                    {
	                        axis: "x",
	                        bounds: { left: RESIZE_HANDLE_WIDTH },
	                        position: { x: _this.getColumnWidth({ index: columnIndex }), y: 0 },
	                        onStop: function onStop(e, _ref3) {
	                            var x = _ref3.x;
	
	                            _this.onColumnResize(columnIndex, x);
	                        }
	                    },
	                    _react2.default.createElement("div", {
	                        className: "bg-brand-hover bg-brand-active",
	                        style: { zIndex: 99, position: "absolute", width: RESIZE_HANDLE_WIDTH, top: 0, bottom: 0, left: -RESIZE_HANDLE_WIDTH - 1, cursor: "ew-resize" }
	                    })
	                )
	            );
	        };
	
	        _this.getColumnWidth = function (_ref4) {
	            var index = _ref4.index;
	            var settings = _this.props.settings;
	            var columnWidths = _this.state.columnWidths;
	
	            var columnWidthsSetting = settings["table.column_widths"] || [];
	            return columnWidthsSetting[index] || columnWidths[index] || MIN_COLUMN_WIDTH;
	        };
	
	        _this.state = {
	            columnWidths: [],
	            contentWidths: null
	        };
	        _this.columnHasResized = {};
	        return _this;
	    }
	
	    _createClass(TableInteractive, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            // for measuring cells:
	            this._div = document.createElement("div");
	            this._div.className = "TableInteractive";
	            this._div.style.display = "inline-block";
	            this._div.style.position = "absolute";
	            this._div.style.visibility = "hidden";
	            this._div.style.zIndex = "-1";
	            document.body.appendChild(this._div);
	
	            this._measure();
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            if (this._div && this._div.parentNode) {
	                this._div.parentNode.removeChild(this._div);
	            }
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            if (JSON.stringify(this.props.data && this.props.data.cols) !== JSON.stringify(newProps.data && newProps.data.cols)) {
	                this.resetColumnWidths();
	            }
	        }
	    }, {
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            var PROP_KEYS = ["width", "height", "settings", "data"];
	            // compare specific props and state to determine if we should re-render
	            return !_underscore2.default.isEqual(_underscore2.default.pick.apply(_underscore2.default, [this.props].concat(PROP_KEYS)), _underscore2.default.pick.apply(_underscore2.default, [nextProps].concat(PROP_KEYS))) || !_underscore2.default.isEqual(this.state, nextState);
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            if (!this.state.contentWidths) {
	                this._measure();
	            }
	        }
	    }, {
	        key: "resetColumnWidths",
	        value: function resetColumnWidths() {
	            this.setState({
	                columnWidths: [],
	                contentWidths: null
	            });
	            this.columnHasResized = {};
	            this.props.onUpdateVisualizationSettings({ "table.column_widths": undefined });
	        }
	    }, {
	        key: "_measure",
	        value: function _measure() {
	            var _this2 = this;
	
	            var cols = this.props.data.cols;
	
	
	            var contentWidths = cols.map(function (col, index) {
	                return _this2._measureColumn(index);
	            });
	
	            var columnWidths = cols.map(function (col, index) {
	                if (_this2.columnNeedsResize) {
	                    if (_this2.columnNeedsResize[index] && !_this2.columnHasResized[index]) {
	                        _this2.columnHasResized[index] = true;
	                        return contentWidths[index] + 1; // + 1 to make sure it doen't wrap?
	                    } else if (_this2.state.columnWidths[index]) {
	                        return _this2.state.columnWidths[index];
	                    } else {
	                        return 0;
	                    }
	                } else {
	                    return contentWidths[index] + 1;
	                }
	            });
	
	            delete this.columnNeedsResize;
	
	            this.setState({ contentWidths: contentWidths, columnWidths: columnWidths }, this.recomputeGridSize);
	        }
	    }, {
	        key: "_measureColumn",
	        value: function _measureColumn(columnIndex) {
	            var rows = this.props.data.rows;
	
	            var width = MIN_COLUMN_WIDTH;
	
	            // measure column header
	            width = Math.max(width, this._measureCell(this.tableHeaderRenderer({ columnIndex: columnIndex, rowIndex: 0, key: "", style: {} })));
	
	            // measure up to 10 non-nil cells
	            var remaining = 10;
	            for (var _rowIndex = 0; _rowIndex < rows.length && remaining > 0; _rowIndex++) {
	                if (rows[_rowIndex][columnIndex] != null) {
	                    var cellWidth = this._measureCell(this.cellRenderer({ rowIndex: _rowIndex, columnIndex: columnIndex, key: "", style: {} }));
	                    width = Math.max(width, cellWidth);
	                    remaining--;
	                }
	            }
	
	            return width;
	        }
	    }, {
	        key: "_measureCell",
	        value: function _measureCell(cell) {
	            _reactDom2.default.unstable_renderSubtreeIntoContainer(this, cell, this._div);
	
	            // 2px for border?
	            var width = this._div.clientWidth + 2;
	
	            _reactDom2.default.unmountComponentAtNode(this._div);
	
	            return width;
	        }
	    }, {
	        key: "onCellResize",
	        value: function onCellResize(columnIndex) {
	            this.columnNeedsResize = this.columnNeedsResize || {};
	            this.columnNeedsResize[columnIndex] = true;
	            this.recomputeColumnSizes();
	        }
	    }, {
	        key: "onColumnResize",
	        value: function onColumnResize(columnIndex, width) {
	            var _this3 = this;
	
	            var settings = this.props.settings;
	
	            var columnWidthsSetting = settings["table.column_widths"] ? settings["table.column_widths"].slice() : [];
	            columnWidthsSetting[columnIndex] = Math.max(MIN_COLUMN_WIDTH, width);
	            this.props.onUpdateVisualizationSettings({ "table.column_widths": columnWidthsSetting });
	            setTimeout(function () {
	                return _this3.recomputeGridSize();
	            }, 1);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var _props = this.props,
	                width = _props.width,
	                height = _props.height,
	                _props$data = _props.data,
	                cols = _props$data.cols,
	                rows = _props$data.rows,
	                className = _props.className;
	
	
	            if (!width || !height) {
	                return _react2.default.createElement("div", { className: className });
	            }
	
	            return _react2.default.createElement(
	                _reactVirtualized.ScrollSync,
	                null,
	                function (_ref5) {
	                    var clientHeight = _ref5.clientHeight,
	                        clientWidth = _ref5.clientWidth,
	                        _onScroll = _ref5.onScroll,
	                        scrollHeight = _ref5.scrollHeight,
	                        scrollLeft = _ref5.scrollLeft,
	                        scrollTop = _ref5.scrollTop,
	                        scrollWidth = _ref5.scrollWidth;
	                    return _react2.default.createElement(
	                        "div",
	                        { className: (0, _classnames2.default)(className, 'TableInteractive relative', { 'TableInteractive--pivot': _this4.props.isPivoted, 'TableInteractive--ready': _this4.state.contentWidths }) },
	                        _react2.default.createElement("canvas", { className: "spread", style: { pointerEvents: "none", zIndex: 999 }, width: width, height: height }),
	                        _react2.default.createElement(_reactVirtualized.Grid, {
	                            ref: function ref(_ref7) {
	                                return _this4.header = _ref7;
	                            },
	                            style: { top: 0, left: 0, right: 0, height: HEADER_HEIGHT, position: "absolute", overflow: "hidden" },
	                            className: "TableInteractive-header scroll-hide-all",
	                            width: width || 0,
	                            height: HEADER_HEIGHT,
	                            rowCount: 1,
	                            rowHeight: HEADER_HEIGHT
	                            // HACK: there might be a better way to do this, but add a phantom padding cell at the end to ensure scroll stays synced if main content scrollbars are visible
	                            , columnCount: cols.length + 1,
	                            columnWidth: function columnWidth(props) {
	                                return props.index < cols.length ? _this4.getColumnWidth(props) : 50;
	                            },
	                            cellRenderer: function cellRenderer(props) {
	                                return props.columnIndex < cols.length ? _this4.tableHeaderRenderer(props) : null;
	                            },
	                            onScroll: function onScroll(_ref6) {
	                                var scrollLeft = _ref6.scrollLeft;
	                                return _onScroll({ scrollLeft: scrollLeft });
	                            },
	                            scrollLeft: scrollLeft,
	                            tabIndex: null
	                        }),
	                        _react2.default.createElement(_reactVirtualized.Grid, {
	                            ref: function ref(_ref9) {
	                                return _this4.grid = _ref9;
	                            },
	                            style: { top: HEADER_HEIGHT, left: 0, right: 0, bottom: 0, position: "absolute" },
	                            className: "",
	                            width: width,
	                            height: height - HEADER_HEIGHT,
	                            columnCount: cols.length,
	                            columnWidth: _this4.getColumnWidth,
	                            rowCount: rows.length,
	                            rowHeight: ROW_HEIGHT,
	                            cellRenderer: _this4.cellRenderer,
	                            onScroll: function onScroll(_ref8) {
	                                var scrollLeft = _ref8.scrollLeft;
	
	                                _this4.props.onActionDismissal();
	                                return _onScroll({ scrollLeft: scrollLeft });
	                            },
	                            scrollLeft: scrollLeft,
	                            tabIndex: null,
	                            overscanRowCount: 20
	                        })
	                    );
	                }
	            );
	        }
	    }]);
	
	    return TableInteractive;
	}(_react.Component), _class2.propTypes = {
	    data: _propTypes2.default.object.isRequired,
	    isPivoted: _propTypes2.default.bool.isRequired,
	    sort: _propTypes2.default.array
	}, _class2.defaultProps = {
	    isPivoted: false
	}, _temp)) || _class;
	
	TableInteractive.displayName = "TableInteractive";
	exports.default = TableInteractive;

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1301 */,
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getTableCellClickedObject = getTableCellClickedObject;
	exports.isColumnRightAligned = isColumnRightAligned;
	
	var _schema_metadata = __webpack_require__(867);
	
	function getTableCellClickedObject(data, rowIndex, columnIndex, isPivoted) {
	    var rows = data.rows,
	        cols = data.cols;
	
	
	    var column = cols[columnIndex];
	    var row = rows[rowIndex];
	    var value = row[columnIndex];
	
	    if (isPivoted) {
	        // if it's a pivot table, the first column is
	        if (columnIndex === 0) {
	            // $FlowFixMe: _dimension
	            return row._dimension;
	        } else {
	            return {
	                value: value,
	                column: column,
	                // $FlowFixMe: _dimension
	                dimensions: [row._dimension, column._dimension]
	            };
	        }
	    } else if (column.source === "aggregation") {
	        return {
	            value: value,
	            column: column,
	            dimensions: cols.map(function (column, index) {
	                return { value: row[index], column: column };
	            }).filter(function (dimension) {
	                return dimension.column.source === "breakout";
	            })
	        };
	    } else {
	        return { value: value, column: column };
	    }
	}
	
	/*
	 * Returns whether the column should be right-aligned in a table.
	 * Includes numbers and lat/lon coordinates, but not zip codes, IDs, etc.
	 */
	
	
	function isColumnRightAligned(column) {
	    return (0, _schema_metadata.isNumber)(column) || (0, _schema_metadata.isCoordinate)(column);
	}

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ArrowKeyStepper = __webpack_require__(1304);
	
	Object.defineProperty(exports, 'ArrowKeyStepper', {
	  enumerable: true,
	  get: function get() {
	    return _ArrowKeyStepper.ArrowKeyStepper;
	  }
	});
	
	var _AutoSizer = __webpack_require__(1306);
	
	Object.defineProperty(exports, 'AutoSizer', {
	  enumerable: true,
	  get: function get() {
	    return _AutoSizer.AutoSizer;
	  }
	});
	
	var _CellMeasurer = __webpack_require__(1309);
	
	Object.defineProperty(exports, 'CellMeasurer', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.CellMeasurer;
	  }
	});
	Object.defineProperty(exports, 'CellMeasurerCache', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.CellMeasurerCache;
	  }
	});
	
	var _Collection = __webpack_require__(1312);
	
	Object.defineProperty(exports, 'Collection', {
	  enumerable: true,
	  get: function get() {
	    return _Collection.Collection;
	  }
	});
	
	var _ColumnSizer = __webpack_require__(1322);
	
	Object.defineProperty(exports, 'ColumnSizer', {
	  enumerable: true,
	  get: function get() {
	    return _ColumnSizer.ColumnSizer;
	  }
	});
	
	var _Grid = __webpack_require__(1324);
	
	Object.defineProperty(exports, 'accessibilityOverscanIndicesGetter', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.accessibilityOverscanIndicesGetter;
	  }
	});
	Object.defineProperty(exports, 'defaultCellRangeRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.defaultCellRangeRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultOverscanIndicesGetter', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.defaultOverscanIndicesGetter;
	  }
	});
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.Grid;
	  }
	});
	
	var _InfiniteLoader = __webpack_require__(1333);
	
	Object.defineProperty(exports, 'InfiniteLoader', {
	  enumerable: true,
	  get: function get() {
	    return _InfiniteLoader.InfiniteLoader;
	  }
	});
	
	var _List = __webpack_require__(1335);
	
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _List.List;
	  }
	});
	
	var _Masonry = __webpack_require__(1337);
	
	Object.defineProperty(exports, 'createMasonryCellPositioner', {
	  enumerable: true,
	  get: function get() {
	    return _Masonry.createCellPositioner;
	  }
	});
	Object.defineProperty(exports, 'Masonry', {
	  enumerable: true,
	  get: function get() {
	    return _Masonry.Masonry;
	  }
	});
	
	var _MultiGrid = __webpack_require__(1343);
	
	Object.defineProperty(exports, 'MultiGrid', {
	  enumerable: true,
	  get: function get() {
	    return _MultiGrid.MultiGrid;
	  }
	});
	
	var _ScrollSync = __webpack_require__(1345);
	
	Object.defineProperty(exports, 'ScrollSync', {
	  enumerable: true,
	  get: function get() {
	    return _ScrollSync.ScrollSync;
	  }
	});
	
	var _Table = __webpack_require__(1347);
	
	Object.defineProperty(exports, 'defaultTableCellDataGetter', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultCellDataGetter;
	  }
	});
	Object.defineProperty(exports, 'defaultTableCellRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultCellRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableHeaderRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultHeaderRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableHeaderRowRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultHeaderRowRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableRowRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultRowRenderer;
	  }
	});
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _Table.Table;
	  }
	});
	Object.defineProperty(exports, 'Column', {
	  enumerable: true,
	  get: function get() {
	    return _Table.Column;
	  }
	});
	Object.defineProperty(exports, 'SortDirection', {
	  enumerable: true,
	  get: function get() {
	    return _Table.SortDirection;
	  }
	});
	Object.defineProperty(exports, 'SortIndicator', {
	  enumerable: true,
	  get: function get() {
	    return _Table.SortIndicator;
	  }
	});
	
	var _WindowScroller = __webpack_require__(1357);
	
	Object.defineProperty(exports, 'WindowScroller', {
	  enumerable: true,
	  get: function get() {
	    return _WindowScroller.WindowScroller;
	  }
	});

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ArrowKeyStepper = exports.default = undefined;
	
	var _ArrowKeyStepper2 = __webpack_require__(1305);
	
	var _ArrowKeyStepper3 = _interopRequireDefault(_ArrowKeyStepper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ArrowKeyStepper3.default;
	exports.ArrowKeyStepper = _ArrowKeyStepper3.default;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
	 */
	var ArrowKeyStepper = function (_PureComponent) {
	  _inherits(ArrowKeyStepper, _PureComponent);
	
	  function ArrowKeyStepper(props, context) {
	    _classCallCheck(this, ArrowKeyStepper);
	
	    var _this = _possibleConstructorReturn(this, (ArrowKeyStepper.__proto__ || Object.getPrototypeOf(ArrowKeyStepper)).call(this, props, context));
	
	    _this.state = {
	      scrollToColumn: props.scrollToColumn,
	      scrollToRow: props.scrollToRow
	    };
	
	    _this._columnStartIndex = 0;
	    _this._columnStopIndex = 0;
	    _this._rowStartIndex = 0;
	    _this._rowStopIndex = 0;
	
	    _this._onKeyDown = _this._onKeyDown.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    return _this;
	  }
	
	  _createClass(ArrowKeyStepper, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var scrollToColumn = nextProps.scrollToColumn,
	          scrollToRow = nextProps.scrollToRow;
	      var _props = this.props,
	          prevScrollToColumn = _props.scrollToColumn,
	          prevScrollToRow = _props.scrollToRow;
	
	
	      if (prevScrollToColumn !== scrollToColumn && prevScrollToRow !== scrollToRow) {
	        this.setState({
	          scrollToColumn: scrollToColumn,
	          scrollToRow: scrollToRow
	        });
	      } else if (prevScrollToColumn !== scrollToColumn) {
	        this.setState({ scrollToColumn: scrollToColumn });
	      } else if (prevScrollToRow !== scrollToRow) {
	        this.setState({ scrollToRow: scrollToRow });
	      }
	    }
	  }, {
	    key: 'setScrollIndexes',
	    value: function setScrollIndexes(_ref) {
	      var scrollToColumn = _ref.scrollToColumn,
	          scrollToRow = _ref.scrollToRow;
	
	      this.setState({
	        scrollToRow: scrollToRow,
	        scrollToColumn: scrollToColumn
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          children = _props2.children;
	      var _state = this.state,
	          scrollToColumn = _state.scrollToColumn,
	          scrollToRow = _state.scrollToRow;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          onKeyDown: this._onKeyDown
	        },
	        children({
	          onSectionRendered: this._onSectionRendered,
	          scrollToColumn: scrollToColumn,
	          scrollToRow: scrollToRow
	        })
	      );
	    }
	  }, {
	    key: '_onKeyDown',
	    value: function _onKeyDown(event) {
	      var _props3 = this.props,
	          columnCount = _props3.columnCount,
	          disabled = _props3.disabled,
	          mode = _props3.mode,
	          rowCount = _props3.rowCount;
	
	
	      if (disabled) {
	        return;
	      }
	
	      var _state2 = this.state,
	          scrollToColumnPrevious = _state2.scrollToColumn,
	          scrollToRowPrevious = _state2.scrollToRow;
	      var _state3 = this.state,
	          scrollToColumn = _state3.scrollToColumn,
	          scrollToRow = _state3.scrollToRow;
	
	      // The above cases all prevent default event event behavior.
	      // This is to keep the grid from scrolling after the snap-to update.
	
	      switch (event.key) {
	        case 'ArrowDown':
	          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(this._rowStopIndex + 1, rowCount - 1);
	          break;
	        case 'ArrowLeft':
	          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(this._columnStartIndex - 1, 0);
	          break;
	        case 'ArrowRight':
	          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(this._columnStopIndex + 1, columnCount - 1);
	          break;
	        case 'ArrowUp':
	          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(this._rowStartIndex - 1, 0);
	          break;
	      }
	
	      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
	        event.preventDefault();
	
	        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
	      }
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref2) {
	      var columnStartIndex = _ref2.columnStartIndex,
	          columnStopIndex = _ref2.columnStopIndex,
	          rowStartIndex = _ref2.rowStartIndex,
	          rowStopIndex = _ref2.rowStopIndex;
	
	      this._columnStartIndex = columnStartIndex;
	      this._columnStopIndex = columnStopIndex;
	      this._rowStartIndex = rowStartIndex;
	      this._rowStopIndex = rowStopIndex;
	    }
	  }]);
	
	  return ArrowKeyStepper;
	}(_react.PureComponent);
	
	ArrowKeyStepper.defaultProps = {
	  disabled: false,
	  mode: 'edges',
	  scrollToColumn: 0,
	  scrollToRow: 0
	};
	exports.default = ArrowKeyStepper;
	 false ? ArrowKeyStepper.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  className: _propTypes2.default.string,
	  columnCount: _propTypes2.default.number.isRequired,
	  disabled: _propTypes2.default.bool.isRequired,
	  mode: _propTypes2.default.oneOf(['cells', 'edges']),
	  rowCount: _propTypes2.default.number.isRequired,
	  scrollToColumn: _propTypes2.default.number.isRequired,
	  scrollToRow: _propTypes2.default.number.isRequired
	} : void 0;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AutoSizer = exports.default = undefined;
	
	var _AutoSizer2 = __webpack_require__(1307);
	
	var _AutoSizer3 = _interopRequireDefault(_AutoSizer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoSizer3.default;
	exports.AutoSizer = _AutoSizer3.default;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _detectElementResize = __webpack_require__(1308);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Decorator component that automatically adjusts the width and height of a single child.
	 * Child component should not be declared as a child but should rather be specified by a `ChildComponent` property.
	 * All other properties will be passed through to the child component.
	 */
	var AutoSizer = function (_PureComponent) {
	  _inherits(AutoSizer, _PureComponent);
	
	  function AutoSizer(props) {
	    _classCallCheck(this, AutoSizer);
	
	    var _this = _possibleConstructorReturn(this, (AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call(this, props));
	
	    _this.state = {
	      height: 0,
	      width: 0
	    };
	
	    _this._onResize = _this._onResize.bind(_this);
	    _this._setRef = _this._setRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(AutoSizer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Delay access of parentNode until mount.
	      // This handles edge-cases where the component has already been unmounted before its ref has been set,
	      // As well as libraries like react-lite which have a slightly different lifecycle.
	      this._parentNode = this._autoSizer.parentNode;
	
	      // Defer requiring resize handler in order to support server-side rendering.
	      // See issue #41
	      this._detectElementResize = (0, _detectElementResize2.default)();
	      this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
	
	      this._onResize();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._detectElementResize) {
	        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          disableHeight = _props.disableHeight,
	          disableWidth = _props.disableWidth;
	      var _state = this.state,
	          height = _state.height,
	          width = _state.width;
	
	      // Outer div should not force width/height since that may prevent containers from shrinking.
	      // Inner component should overflow and use calculated width/height.
	      // See issue #68 for more information.
	
	      var outerStyle = { overflow: 'visible' };
	
	      if (!disableHeight) {
	        outerStyle.height = 0;
	      }
	
	      if (!disableWidth) {
	        outerStyle.width = 0;
	      }
	
	      /**
	       * TODO: Avoid rendering children before the initial measurements have been collected.
	       * At best this would just be wasting cycles.
	       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
	      if (
	        height !== 0 &&
	        width !== 0
	      ) {
	        child = children({ height, width })
	      }
	      */
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setRef,
	          style: outerStyle
	        },
	        children({ height: height, width: width })
	      );
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize() {
	      var _props2 = this.props,
	          disableHeight = _props2.disableHeight,
	          disableWidth = _props2.disableWidth,
	          onResize = _props2.onResize;
	
	      // Guard against AutoSizer component being removed from the DOM immediately after being added.
	      // This can result in invalid style values which can result in NaN values if we don't handle them.
	      // See issue #150 for more context.
	
	      var height = this._parentNode.offsetHeight || 0;
	      var width = this._parentNode.offsetWidth || 0;
	
	      var style = window.getComputedStyle(this._parentNode) || {};
	      var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
	      var paddingRight = parseInt(style.paddingRight, 10) || 0;
	      var paddingTop = parseInt(style.paddingTop, 10) || 0;
	      var paddingBottom = parseInt(style.paddingBottom, 10) || 0;
	
	      var newHeight = height - paddingTop - paddingBottom;
	      var newWidth = width - paddingLeft - paddingRight;
	
	      if (!disableHeight && this.state.height !== newHeight || !disableWidth && this.state.width !== newWidth) {
	        this.setState({
	          height: height - paddingTop - paddingBottom,
	          width: width - paddingLeft - paddingRight
	        });
	
	        onResize({ height: height, width: width });
	      }
	    }
	  }, {
	    key: '_setRef',
	    value: function _setRef(autoSizer) {
	      this._autoSizer = autoSizer;
	    }
	  }]);
	
	  return AutoSizer;
	}(_react.PureComponent);
	
	AutoSizer.defaultProps = {
	  onResize: function onResize() {}
	};
	exports.default = AutoSizer;
	 false ? AutoSizer.propTypes = {
	  /**
	  * Function responsible for rendering children.
	  * This function should implement the following signature:
	  * ({ height, width }) => PropTypes.element
	  */
	  children: _propTypes2.default.func.isRequired,
	
	  /** Disable dynamic :height property */
	  disableHeight: _propTypes2.default.bool,
	
	  /** Disable dynamic :width property */
	  disableWidth: _propTypes2.default.bool,
	
	  /** Callback to be invoked on-resize: ({ height, width }) */
	  onResize: _propTypes2.default.func.isRequired
	} : void 0;

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createDetectElementResize;
	/**
	 * Detect Element Resize.
	 * https://github.com/sdecima/javascript-detect-element-resize
	 * Sebastian Decima
	 *
	 * Forked from version 0.5.3; includes the following modifications:
	 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
	 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
	 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
	 **/
	
	function createDetectElementResize() {
	  // Check `document` and `window` in case of server-side rendering
	  var _window;
	  if (typeof window !== 'undefined') {
	    _window = window;
	  } else if (typeof self !== 'undefined') {
	    _window = self;
	  } else {
	    _window = this;
	  }
	
	  var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	
	  if (!attachEvent) {
	    var requestFrame = function () {
	      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	        return _window.setTimeout(fn, 20);
	      };
	      return function (fn) {
	        return raf(fn);
	      };
	    }();
	
	    var cancelFrame = function () {
	      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	      return function (id) {
	        return cancel(id);
	      };
	    }();
	
	    var resetTriggers = function resetTriggers(element) {
	      var triggers = element.__resizeTriggers__,
	          expand = triggers.firstElementChild,
	          contract = triggers.lastElementChild,
	          expandChild = expand.firstElementChild;
	      contract.scrollLeft = contract.scrollWidth;
	      contract.scrollTop = contract.scrollHeight;
	      expandChild.style.width = expand.offsetWidth + 1 + 'px';
	      expandChild.style.height = expand.offsetHeight + 1 + 'px';
	      expand.scrollLeft = expand.scrollWidth;
	      expand.scrollTop = expand.scrollHeight;
	    };
	
	    var checkTriggers = function checkTriggers(element) {
	      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	    };
	
	    var scrollListener = function scrollListener(e) {
	      // Don't measure (which forces) reflow for scrolls that happen inside of children!
	      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
	        return;
	      }
	
	      var element = this;
	      resetTriggers(this);
	      if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
	      this.__resizeRAF__ = requestFrame(function () {
	        if (checkTriggers(element)) {
	          element.__resizeLast__.width = element.offsetWidth;
	          element.__resizeLast__.height = element.offsetHeight;
	          element.__resizeListeners__.forEach(function (fn) {
	            fn.call(element, e);
	          });
	        }
	      });
	    };
	
	    /* Detect CSS Animations support to detect element display/re-attach */
	    var animation = false,
	        animationstring = 'animation',
	        keyframeprefix = '',
	        animationstartevent = 'animationstart',
	        domPrefixes = 'Webkit Moz O ms'.split(' '),
	        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	        pfx = '';
	    {
	      var elm = document.createElement('fakeelement');
	      if (elm.style.animationName !== undefined) {
	        animation = true;
	      }
	
	      if (animation === false) {
	        for (var i = 0; i < domPrefixes.length; i++) {
	          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	            pfx = domPrefixes[i];
	            animationstring = pfx + 'Animation';
	            keyframeprefix = '-' + pfx.toLowerCase() + '-';
	            animationstartevent = startEvents[i];
	            animation = true;
	            break;
	          }
	        }
	      }
	    }
	
	    var animationName = 'resizeanim';
	    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	  }
	
	  var createStyles = function createStyles() {
	    if (!document.getElementById('detectElementResize')) {
	      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	          head = document.head || document.getElementsByTagName('head')[0],
	          style = document.createElement('style');
	
	      style.id = 'detectElementResize';
	      style.type = 'text/css';
	      if (style.styleSheet) {
	        style.styleSheet.cssText = css;
	      } else {
	        style.appendChild(document.createTextNode(css));
	      }
	
	      head.appendChild(style);
	    }
	  };
	
	  var addResizeListener = function addResizeListener(element, fn) {
	    if (attachEvent) element.attachEvent('onresize', fn);else {
	      if (!element.__resizeTriggers__) {
	        var elementStyle = _window.getComputedStyle(element);
	        if (elementStyle && elementStyle.position == 'static') {
	          element.style.position = 'relative';
	        }
	        createStyles();
	        element.__resizeLast__ = {};
	        element.__resizeListeners__ = [];
	        (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
	        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	        element.appendChild(element.__resizeTriggers__);
	        resetTriggers(element);
	        element.addEventListener('scroll', scrollListener, true);
	
	        /* Listen for a css animation to detect element display/re-attach */
	        if (animationstartevent) {
	          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
	            if (e.animationName == animationName) resetTriggers(element);
	          };
	          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	        }
	      }
	      element.__resizeListeners__.push(fn);
	    }
	  };
	
	  var removeResizeListener = function removeResizeListener(element, fn) {
	    if (attachEvent) element.detachEvent('onresize', fn);else {
	      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	      if (!element.__resizeListeners__.length) {
	        element.removeEventListener('scroll', scrollListener, true);
	        if (element.__resizeTriggers__.__animationListener__) {
	          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	          element.__resizeTriggers__.__animationListener__ = null;
	        }
	        try {
	          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	        } catch (e) {
	          // Preact compat; see developit/preact-compat/issues/228
	        }
	      }
	    }
	  };
	
	  return {
	    addResizeListener: addResizeListener,
	    removeResizeListener: removeResizeListener
	  };
	}

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CellMeasurerCache = exports.CellMeasurer = exports.default = undefined;
	
	var _CellMeasurer2 = __webpack_require__(1310);
	
	var _CellMeasurer3 = _interopRequireDefault(_CellMeasurer2);
	
	var _CellMeasurerCache2 = __webpack_require__(1311);
	
	var _CellMeasurerCache3 = _interopRequireDefault(_CellMeasurerCache2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CellMeasurer3.default;
	exports.CellMeasurer = _CellMeasurer3.default;
	exports.CellMeasurerCache = _CellMeasurerCache3.default;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _reactDom = __webpack_require__(330);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Wraps a cell and measures its rendered content.
	 * Measurements are stored in a per-cell cache.
	 * Cached-content is not be re-measured.
	 */
	var CellMeasurer = function (_PureComponent) {
	  _inherits(CellMeasurer, _PureComponent);
	
	  function CellMeasurer(props, context) {
	    _classCallCheck(this, CellMeasurer);
	
	    var _this = _possibleConstructorReturn(this, (CellMeasurer.__proto__ || Object.getPrototypeOf(CellMeasurer)).call(this, props, context));
	
	    _this._measure = _this._measure.bind(_this);
	    return _this;
	  }
	
	  _createClass(CellMeasurer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._maybeMeasureCell();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      this._maybeMeasureCell();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return typeof children === 'function' ? children({ measure: this._measure }) : children;
	    }
	  }, {
	    key: '_maybeMeasureCell',
	    value: function _maybeMeasureCell() {
	      var _props = this.props,
	          cache = _props.cache,
	          _props$columnIndex = _props.columnIndex,
	          columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex,
	          parent = _props.parent,
	          _props$rowIndex = _props.rowIndex,
	          rowIndex = _props$rowIndex === undefined ? this.props.index : _props$rowIndex;
	
	
	      if (!cache.has(rowIndex, columnIndex)) {
	        var node = (0, _reactDom.findDOMNode)(this);
	
	        // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
	
	        // Even if we are measuring initially- if we're inside of a MultiGrid component,
	        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
	        // eg top/left Grid renders before bottom/right Grid
	        // Since the CellMeasurerCache is shared between them this taints derived cell size values.
	        if (!cache.hasFixedWidth()) {
	          node.style.width = 'auto';
	        }
	        if (!cache.hasFixedHeight()) {
	          node.style.height = 'auto';
	        }
	
	        var height = Math.ceil(node.offsetHeight);
	        var width = Math.ceil(node.offsetWidth);
	
	        cache.set(rowIndex, columnIndex, width, height);
	
	        // If size has changed, let Grid know to re-render.
	        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
	          parent.invalidateCellSizeAfterRender({
	            columnIndex: columnIndex,
	            rowIndex: rowIndex
	          });
	        }
	      }
	    }
	  }, {
	    key: '_measure',
	    value: function _measure() {
	      var _props2 = this.props,
	          cache = _props2.cache,
	          _props2$columnIndex = _props2.columnIndex,
	          columnIndex = _props2$columnIndex === undefined ? 0 : _props2$columnIndex,
	          parent = _props2.parent,
	          _props2$rowIndex = _props2.rowIndex,
	          rowIndex = _props2$rowIndex === undefined ? this.props.index : _props2$rowIndex;
	
	
	      var node = (0, _reactDom.findDOMNode)(this);
	
	      // If we are re-measuring a cell that has already been measured,
	      // It will have a hard-coded width/height from the previous measurement.
	      // The fact that we are measuring indicates this measurement is probably stale,
	      // So explicitly clear it out (eg set to "auto") so we can recalculate.
	      // See issue #593 for more info.
	      if (!cache.hasFixedWidth()) {
	        node.style.width = 'auto';
	      }
	      if (!cache.hasFixedHeight()) {
	        node.style.height = 'auto';
	      }
	
	      var height = Math.ceil(node.offsetHeight);
	      var width = Math.ceil(node.offsetWidth);
	
	      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
	        cache.set(rowIndex, columnIndex, width, height);
	
	        if (parent && typeof parent.recomputeGridSize === 'function') {
	          parent.recomputeGridSize({
	            columnIndex: columnIndex,
	            rowIndex: rowIndex
	          });
	        }
	      }
	    }
	  }]);
	
	  return CellMeasurer;
	}(_react.PureComponent);
	
	// Used for DEV mode warning check
	
	
	exports.default = CellMeasurer;
	if (false) {
	  CellMeasurer.__internalCellMeasurerFlag = true;
	}

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_HEIGHT = exports.DEFAULT_HEIGHT = 30;
	var DEFAULT_WIDTH = exports.DEFAULT_WIDTH = 100;
	
	// Enables more intelligent mapping of a given column and row index to an item ID.
	// This prevents a cell cache from being invalidated when its parent collection is modified.
	
	/**
	 * Caches measurements for a given cell.
	 */
	var CellMeasurerCache = function () {
	  function CellMeasurerCache() {
	    var _this = this;
	
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, CellMeasurerCache);
	
	    this.columnWidth = function (_ref) {
	      var index = _ref.index;
	
	      var key = _this._keyMapper(0, index);
	
	      return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
	    };
	
	    this.rowHeight = function (_ref2) {
	      var index = _ref2.index;
	
	      var key = _this._keyMapper(index, 0);
	
	      return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
	    };
	
	    var defaultHeight = params.defaultHeight,
	        defaultWidth = params.defaultWidth,
	        fixedHeight = params.fixedHeight,
	        fixedWidth = params.fixedWidth,
	        keyMapper = params.keyMapper,
	        minHeight = params.minHeight,
	        minWidth = params.minWidth;
	
	
	    this._hasFixedHeight = fixedHeight === true;
	    this._hasFixedWidth = fixedWidth === true;
	    this._minHeight = minHeight || 0;
	    this._minWidth = minWidth || 0;
	    this._keyMapper = keyMapper || defaultKeyMapper;
	
	    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
	    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);
	
	    if (false) {
	      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
	        console.warn('CellMeasurerCache should only measure a cell\'s width or height. ' + 'You have configured CellMeasurerCache to measure both. ' + 'This will result in poor performance.');
	      }
	
	      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
	        console.warn('Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
	      }
	
	      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
	        console.warn('Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
	      }
	    }
	
	    this._columnCount = 0;
	    this._rowCount = 0;
	
	    this._cellHeightCache = {};
	    this._cellWidthCache = {};
	    this._columnWidthCache = {};
	    this._rowHeightCache = {};
	  }
	
	  _createClass(CellMeasurerCache, [{
	    key: 'clear',
	    value: function clear(rowIndex, columnIndex) {
	      var key = this._keyMapper(rowIndex, columnIndex);
	
	      delete this._cellHeightCache[key];
	      delete this._cellWidthCache[key];
	
	      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
	    }
	  }, {
	    key: 'clearAll',
	    value: function clearAll() {
	      this._cellHeightCache = {};
	      this._cellWidthCache = {};
	      this._columnWidthCache = {};
	      this._rowHeightCache = {};
	    }
	  }, {
	    key: 'hasFixedHeight',
	    value: function hasFixedHeight() {
	      return this._hasFixedHeight;
	    }
	  }, {
	    key: 'hasFixedWidth',
	    value: function hasFixedWidth() {
	      return this._hasFixedWidth;
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var key = this._keyMapper(rowIndex, columnIndex);
	
	      return this._cellHeightCache.hasOwnProperty(key) ? Math.max(this._minHeight, this._cellHeightCache[key]) : this._defaultHeight;
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var key = this._keyMapper(rowIndex, columnIndex);
	
	      return this._cellWidthCache.hasOwnProperty(key) ? Math.max(this._minWidth, this._cellWidthCache[key]) : this._defaultWidth;
	    }
	  }, {
	    key: 'has',
	    value: function has(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var key = this._keyMapper(rowIndex, columnIndex);
	
	      return this._cellHeightCache.hasOwnProperty(key);
	    }
	  }, {
	    key: 'set',
	    value: function set(rowIndex, columnIndex, width, height) {
	      var key = this._keyMapper(rowIndex, columnIndex);
	
	      if (columnIndex >= this._columnCount) {
	        this._columnCount = columnIndex + 1;
	      }
	      if (rowIndex >= this._rowCount) {
	        this._rowCount = rowIndex + 1;
	      }
	
	      // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
	      this._cellHeightCache[key] = height;
	      this._cellWidthCache[key] = width;
	
	      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
	    }
	  }, {
	    key: '_updateCachedColumnAndRowSizes',
	    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
	      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
	      // Pre-cache these derived values for faster lookup later.
	      // Reads are expected to occur more frequently than writes in this case.
	      var columnWidth = 0;
	      for (var i = 0; i < this._rowCount; i++) {
	        columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
	      }
	      var rowHeight = 0;
	      for (var _i = 0; _i < this._columnCount; _i++) {
	        rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
	      }
	
	      var columnKey = this._keyMapper(0, columnIndex);
	      var rowKey = this._keyMapper(rowIndex, 0);
	
	      this._columnWidthCache[columnKey] = columnWidth;
	      this._rowHeightCache[rowKey] = rowHeight;
	    }
	  }, {
	    key: 'defaultHeight',
	    get: function get() {
	      return this._defaultHeight;
	    }
	  }, {
	    key: 'defaultWidth',
	    get: function get() {
	      return this._defaultWidth;
	    }
	  }]);
	
	  return CellMeasurerCache;
	}();
	
	exports.default = CellMeasurerCache;
	
	
	function defaultKeyMapper(rowIndex, columnIndex) {
	  return rowIndex + '-' + columnIndex;
	}

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collection = exports.default = undefined;
	
	var _Collection2 = __webpack_require__(1313);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Collection3.default;
	exports.Collection = _Collection3.default;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CollectionView = __webpack_require__(1314);
	
	var _CollectionView2 = _interopRequireDefault(_CollectionView);
	
	var _calculateSizeAndPositionData2 = __webpack_require__(1318);
	
	var _calculateSizeAndPositionData3 = _interopRequireDefault(_calculateSizeAndPositionData2);
	
	var _getUpdatedOffsetForIndex = __webpack_require__(1321);
	
	var _getUpdatedOffsetForIndex2 = _interopRequireDefault(_getUpdatedOffsetForIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Renders scattered or non-linear data.
	 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
	 */
	var Collection = function (_PureComponent) {
	  _inherits(Collection, _PureComponent);
	
	  function Collection(props, context) {
	    _classCallCheck(this, Collection);
	
	    var _this = _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this, props, context));
	
	    _this._cellMetadata = [];
	    _this._lastRenderedCellIndices = [];
	
	    // Cell cache during scroll (for perforamnce)
	    _this._cellCache = [];
	
	    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
	    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(Collection, [{
	    key: 'forceUpdate',
	    value: function forceUpdate() {
	      if (this._collectionView !== undefined) {
	        this._collectionView.forceUpdate();
	      }
	    }
	
	    /** See Collection#recomputeCellSizesAndPositions */
	
	  }, {
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this._cellCache = [];
	      this._collectionView.recomputeCellSizesAndPositions();
	    }
	
	    /** React lifecycle methods */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = _objectWithoutProperties(this.props, []);
	
	      return _react2.default.createElement(_CollectionView2.default, _extends({
	        cellLayoutManager: this,
	        isScrollingChange: this._isScrollingChange,
	        ref: this._setCollectionViewRef
	      }, props));
	    }
	
	    /** CellLayoutManager interface */
	
	  }, {
	    key: 'calculateSizeAndPositionData',
	    value: function calculateSizeAndPositionData() {
	      var _props = this.props,
	          cellCount = _props.cellCount,
	          cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter,
	          sectionSize = _props.sectionSize;
	
	
	      var data = (0, _calculateSizeAndPositionData3.default)({
	        cellCount: cellCount,
	        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
	        sectionSize: sectionSize
	      });
	
	      this._cellMetadata = data.cellMetadata;
	      this._sectionManager = data.sectionManager;
	      this._height = data.height;
	      this._width = data.width;
	    }
	
	    /**
	     * Returns the most recently rendered set of cell indices.
	     */
	
	  }, {
	    key: 'getLastRenderedIndices',
	    value: function getLastRenderedIndices() {
	      return this._lastRenderedCellIndices;
	    }
	
	    /**
	     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
	     */
	
	  }, {
	    key: 'getScrollPositionForCell',
	    value: function getScrollPositionForCell(_ref) {
	      var align = _ref.align,
	          cellIndex = _ref.cellIndex,
	          height = _ref.height,
	          scrollLeft = _ref.scrollLeft,
	          scrollTop = _ref.scrollTop,
	          width = _ref.width;
	      var cellCount = this.props.cellCount;
	
	
	      if (cellIndex >= 0 && cellIndex < cellCount) {
	        var cellMetadata = this._cellMetadata[cellIndex];
	
	        scrollLeft = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.x,
	          cellSize: cellMetadata.width,
	          containerSize: width,
	          currentOffset: scrollLeft,
	          targetIndex: cellIndex
	        });
	
	        scrollTop = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.y,
	          cellSize: cellMetadata.height,
	          containerSize: height,
	          currentOffset: scrollTop,
	          targetIndex: cellIndex
	        });
	      }
	
	      return {
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      };
	    }
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return {
	        height: this._height,
	        width: this._width
	      };
	    }
	  }, {
	    key: 'cellRenderers',
	    value: function cellRenderers(_ref2) {
	      var _this2 = this;
	
	      var height = _ref2.height,
	          isScrolling = _ref2.isScrolling,
	          width = _ref2.width,
	          x = _ref2.x,
	          y = _ref2.y;
	      var _props2 = this.props,
	          cellGroupRenderer = _props2.cellGroupRenderer,
	          cellRenderer = _props2.cellRenderer;
	
	      // Store for later calls to getLastRenderedIndices()
	
	      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
	        height: height,
	        width: width,
	        x: x,
	        y: y
	      });
	
	      return cellGroupRenderer({
	        cellCache: this._cellCache,
	        cellRenderer: cellRenderer,
	        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
	          var index = _ref3.index;
	          return _this2._sectionManager.getCellMetadata({ index: index });
	        },
	        indices: this._lastRenderedCellIndices,
	        isScrolling: isScrolling
	      });
	    }
	  }, {
	    key: '_isScrollingChange',
	    value: function _isScrollingChange(isScrolling) {
	      if (!isScrolling) {
	        this._cellCache = [];
	      }
	    }
	  }, {
	    key: '_setCollectionViewRef',
	    value: function _setCollectionViewRef(ref) {
	      this._collectionView = ref;
	    }
	  }]);
	
	  return Collection;
	}(_react.PureComponent);
	
	Collection.defaultProps = {
	  'aria-label': 'grid',
	  cellGroupRenderer: defaultCellGroupRenderer
	};
	exports.default = Collection;
	 false ? Collection.propTypes = {
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Number of cells in Collection.
	   */
	  cellCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Responsible for rendering a group of cells given their indices.
	   * Should implement the following interface: ({
	   *   cellSizeAndPositionGetter:Function,
	   *   indices: Array<number>,
	   *   cellRenderer: Function
	   * }): Array<PropTypes.node>
	   */
	  cellGroupRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Responsible for rendering a cell given an row and column index.
	   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
	   */
	  cellRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback responsible for returning size and offset/position information for a given cell (index).
	   * ({ index: number }): { height: number, width: number, x: number, y: number }
	   */
	  cellSizeAndPositionGetter: _propTypes2.default.func.isRequired,
	
	  /**
	   * Optionally override the size of the sections a Collection's cells are split into.
	   */
	  sectionSize: _propTypes2.default.number
	} : void 0;
	
	
	function defaultCellGroupRenderer(_ref4) {
	  var cellCache = _ref4.cellCache,
	      cellRenderer = _ref4.cellRenderer,
	      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
	      indices = _ref4.indices,
	      isScrolling = _ref4.isScrolling;
	
	  return indices.map(function (index) {
	    var cellMetadata = cellSizeAndPositionGetter({ index: index });
	
	    var cellRendererProps = {
	      index: index,
	      isScrolling: isScrolling,
	      key: index,
	      style: {
	        height: cellMetadata.height,
	        left: cellMetadata.x,
	        position: 'absolute',
	        top: cellMetadata.y,
	        width: cellMetadata.width
	      }
	    };
	
	    // Avoid re-creating cells while scrolling.
	    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	    // If a scroll is in progress- cache and reuse cells.
	    // This cache will be thrown away once scrolling complets.
	    if (isScrolling) {
	      if (!(index in cellCache)) {
	        cellCache[index] = cellRenderer(cellRendererProps);
	      }
	
	      return cellCache[index];
	    } else {
	      return cellRenderer(cellRendererProps);
	    }
	  }).filter(function (renderedCell) {
	    return !!renderedCell;
	  });
	}

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _createCallbackMemoizer = __webpack_require__(1315);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _scrollbarSize = __webpack_require__(1316);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// @TODO Merge Collection and CollectionView
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	/**
	 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
	 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
	 */
	
	var CollectionView = function (_PureComponent) {
	  _inherits(CollectionView, _PureComponent);
	
	  function CollectionView(props, context) {
	    _classCallCheck(this, CollectionView);
	
	    var _this = _possibleConstructorReturn(this, (CollectionView.__proto__ || Object.getPrototypeOf(CollectionView)).call(this, props, context));
	
	    _this.state = {
	      isScrolling: false,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    _this._calculateSizeAndPositionDataOnNextUpdate = false;
	
	    // Invokes callbacks only when their values have changed.
	    _this._onSectionRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	
	    // Bind functions to instance so they don't lose context when passed around.
	    _this._invokeOnSectionRenderedHelper = _this._invokeOnSectionRenderedHelper.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._setScrollingContainerRef = _this._setScrollingContainerRef.bind(_this);
	    _this._updateScrollPositionForScrollToCell = _this._updateScrollPositionForScrollToCell.bind(_this);
	    return _this;
	  }
	
	  /**
	   * Forced recompute of cell sizes and positions.
	   * This function should be called if cell sizes have changed but nothing else has.
	   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
	   */
	
	
	  _createClass(CollectionView, [{
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this._calculateSizeAndPositionDataOnNextUpdate = true;
	      this.forceUpdate();
	    }
	
	    /* ---------------------------- Component lifecycle methods ---------------------------- */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          cellLayoutManager = _props.cellLayoutManager,
	          scrollLeft = _props.scrollLeft,
	          scrollToCell = _props.scrollToCell,
	          scrollTop = _props.scrollTop;
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = (0, _scrollbarSize2.default)();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (scrollToCell >= 0) {
	        this._updateScrollPositionForScrollToCell();
	      } else if (scrollLeft >= 0 || scrollTop >= 0) {
	        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      // Update onSectionRendered callback.
	      this._invokeOnSectionRenderedHelper();
	
	      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
	          totalHeight = _cellLayoutManager$ge.height,
	          totalWidth = _cellLayoutManager$ge.width;
	
	      // Initialize onScroll callback.
	
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalHeight: totalHeight,
	        totalWidth: totalWidth
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props,
	          height = _props2.height,
	          scrollToAlignment = _props2.scrollToAlignment,
	          scrollToCell = _props2.scrollToCell,
	          width = _props2.width;
	      var _state = this.state,
	          scrollLeft = _state.scrollLeft,
	          scrollPositionChangeReason = _state.scrollPositionChangeReason,
	          scrollTop = _state.scrollTop;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Update scroll offsets if the current :scrollToCell values requires it
	      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
	        this._updateScrollPositionForScrollToCell();
	      }
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnSectionRenderedHelper();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var cellLayoutManager = this.props.cellLayoutManager;
	
	
	      cellLayoutManager.calculateSizeAndPositionData();
	
	      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	      // We handle this case in componentDidMount()
	      this._scrollbarSize = (0, _scrollbarSize2.default)();
	      if (this._scrollbarSize === undefined) {
	        this._scrollbarSizeMeasured = false;
	        this._scrollbarSize = 0;
	      } else {
	        this._scrollbarSizeMeasured = true;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _state2 = this.state,
	          scrollLeft = _state2.scrollLeft,
	          scrollTop = _state2.scrollTop;
	
	
	      if (nextProps.cellCount === 0 && (scrollLeft !== 0 || scrollTop !== 0)) {
	        this._setScrollPosition({
	          scrollLeft: 0,
	          scrollTop: 0
	        });
	      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        this._setScrollPosition({
	          scrollLeft: nextProps.scrollLeft,
	          scrollTop: nextProps.scrollTop
	        });
	      }
	
	      if (nextProps.cellCount !== this.props.cellCount || nextProps.cellLayoutManager !== this.props.cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
	        nextProps.cellLayoutManager.calculateSizeAndPositionData();
	      }
	
	      if (this._calculateSizeAndPositionDataOnNextUpdate) {
	        this._calculateSizeAndPositionDataOnNextUpdate = false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          autoHeight = _props3.autoHeight,
	          cellCount = _props3.cellCount,
	          cellLayoutManager = _props3.cellLayoutManager,
	          className = _props3.className,
	          height = _props3.height,
	          horizontalOverscanSize = _props3.horizontalOverscanSize,
	          id = _props3.id,
	          noContentRenderer = _props3.noContentRenderer,
	          style = _props3.style,
	          verticalOverscanSize = _props3.verticalOverscanSize,
	          width = _props3.width;
	      var _state3 = this.state,
	          isScrolling = _state3.isScrolling,
	          scrollLeft = _state3.scrollLeft,
	          scrollTop = _state3.scrollTop;
	
	      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
	          totalHeight = _cellLayoutManager$ge2.height,
	          totalWidth = _cellLayoutManager$ge2.width;
	
	      // Safely expand the rendered area by the specified overscan amount
	
	
	      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
	      var top = Math.max(0, scrollTop - verticalOverscanSize);
	      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
	      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
	
	      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
	        height: bottom - top,
	        isScrolling: isScrolling,
	        width: right - left,
	        x: left,
	        y: top
	      }) : [];
	
	      var collectionStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        WebkitOverflowScrolling: 'touch',
	        width: width,
	        willChange: 'transform'
	      };
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setScrollingContainerRef,
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Collection', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: 'grid',
	          style: _extends({}, collectionStyle, style),
	          tabIndex: 0
	        },
	        cellCount > 0 && _react2.default.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Collection__innerScrollContainer',
	            style: {
	              height: totalHeight,
	              maxHeight: totalHeight,
	              maxWidth: totalWidth,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : '',
	              width: totalWidth
	            }
	          },
	          childrenToDisplay
	        ),
	        cellCount === 0 && noContentRenderer()
	      );
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Collection.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_enablePointerEventsAfterDelay',
	    value: function _enablePointerEventsAfterDelay() {
	      var _this2 = this;
	
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = setTimeout(function () {
	        var isScrollingChange = _this2.props.isScrollingChange;
	
	
	        isScrollingChange(false);
	
	        _this2._disablePointerEventsTimeoutId = null;
	        _this2.setState({
	          isScrolling: false
	        });
	      }, IS_SCROLLING_TIMEOUT);
	    }
	  }, {
	    key: '_invokeOnSectionRenderedHelper',
	    value: function _invokeOnSectionRenderedHelper() {
	      var _props4 = this.props,
	          cellLayoutManager = _props4.cellLayoutManager,
	          onSectionRendered = _props4.onSectionRendered;
	
	
	      this._onSectionRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          indices: cellLayoutManager.getLastRenderedIndices()
	        }
	      });
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref) {
	      var _this3 = this;
	
	      var scrollLeft = _ref.scrollLeft,
	          scrollTop = _ref.scrollTop,
	          totalHeight = _ref.totalHeight,
	          totalWidth = _ref.totalWidth;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref2) {
	          var scrollLeft = _ref2.scrollLeft,
	              scrollTop = _ref2.scrollTop;
	          var _props5 = _this3.props,
	              height = _props5.height,
	              onScroll = _props5.onScroll,
	              width = _props5.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: '_setScrollingContainerRef',
	    value: function _setScrollingContainerRef(ref) {
	      this._scrollingContainer = ref;
	    }
	  }, {
	    key: '_setScrollPosition',
	    value: function _setScrollPosition(_ref3) {
	      var scrollLeft = _ref3.scrollLeft,
	          scrollTop = _ref3.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (scrollLeft >= 0) {
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (scrollTop >= 0) {
	        newState.scrollTop = scrollTop;
	      }
	
	      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: '_updateScrollPositionForScrollToCell',
	    value: function _updateScrollPositionForScrollToCell() {
	      var _props6 = this.props,
	          cellLayoutManager = _props6.cellLayoutManager,
	          height = _props6.height,
	          scrollToAlignment = _props6.scrollToAlignment,
	          scrollToCell = _props6.scrollToCell,
	          width = _props6.width;
	      var _state4 = this.state,
	          scrollLeft = _state4.scrollLeft,
	          scrollTop = _state4.scrollTop;
	
	
	      if (scrollToCell >= 0) {
	        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
	          align: scrollToAlignment,
	          cellIndex: scrollToCell,
	          height: height,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          width: width
	        });
	
	        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
	          this._setScrollPosition(scrollPosition);
	        }
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target !== this._scrollingContainer) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._enablePointerEventsAfterDelay();
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
	      var _props7 = this.props,
	          cellLayoutManager = _props7.cellLayoutManager,
	          height = _props7.height,
	          isScrollingChange = _props7.isScrollingChange,
	          width = _props7.width;
	
	      var scrollbarSize = this._scrollbarSize;
	
	      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
	          totalHeight = _cellLayoutManager$ge3.height,
	          totalWidth = _cellLayoutManager$ge3.width;
	
	      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
	      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
	        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
	        // All things considered, this seems to be the best current work around that I'm aware of.
	        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
	        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;
	
	        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
	        if (!this.state.isScrolling) {
	          isScrollingChange(true);
	        }
	
	        this.setState({
	          isScrolling: true,
	          scrollLeft: scrollLeft,
	          scrollPositionChangeReason: scrollPositionChangeReason,
	          scrollTop: scrollTop
	        });
	      }
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        totalWidth: totalWidth,
	        totalHeight: totalHeight
	      });
	    }
	  }]);
	
	  return CollectionView;
	}(_react.PureComponent);
	
	CollectionView.defaultProps = {
	  'aria-label': 'grid',
	  horizontalOverscanSize: 0,
	  noContentRenderer: function noContentRenderer() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  onSectionRendered: function onSectionRendered() {
	    return null;
	  },
	  scrollToAlignment: 'auto',
	  scrollToCell: -1,
	  style: {},
	  verticalOverscanSize: 0
	};
	exports.default = CollectionView;
	 false ? CollectionView.propTypes = {
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _propTypes2.default.bool,
	
	  /**
	   * Number of cells in collection.
	   */
	  cellCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
	   */
	  cellLayoutManager: _propTypes2.default.object.isRequired,
	
	  /**
	   * Optional custom CSS class name to attach to root Collection element.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
	   */
	  height: _propTypes2.default.number.isRequired,
	
	  /**
	   * Optional custom id to attach to root Collection element.
	   */
	  id: _propTypes2.default.string,
	
	  /**
	   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  horizontalOverscanSize: _propTypes2.default.number.isRequired,
	
	  isScrollingChange: _propTypes2.default.func,
	
	  /**
	   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
	   */
	  noContentRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
	   */
	  onScroll: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback invoked with information about the section of the Collection that was just rendered.
	   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
	   */
	  onSectionRendered: _propTypes2.default.func.isRequired,
	
	  /**
	   * Horizontal offset.
	   */
	  scrollLeft: _propTypes2.default.number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /**
	   * Cell index to ensure visible (by forcefully scrolling if necessary).
	   */
	  scrollToCell: _propTypes2.default.number.isRequired,
	
	  /**
	   * Vertical offset.
	   */
	  scrollTop: _propTypes2.default.number,
	
	  /**
	   * Optional custom inline style to attach to root Collection element.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  verticalOverscanSize: _propTypes2.default.number.isRequired,
	
	  /**
	   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
	   */
	  width: _propTypes2.default.number.isRequired
	} : void 0;

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createCallbackMemoizer;
	/**
	 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
	 */
	function createCallbackMemoizer() {
	  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  var cachedIndices = {};
	
	  return function (_ref) {
	    var callback = _ref.callback,
	        indices = _ref.indices;
	
	    var keys = Object.keys(indices);
	    var allInitialized = !requireAllKeys || keys.every(function (key) {
	      var value = indices[key];
	      return Array.isArray(value) ? value.length > 0 : value >= 0;
	    });
	    var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function (key) {
	      var cachedValue = cachedIndices[key];
	      var value = indices[key];
	
	      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
	    });
	
	    cachedIndices = indices;
	
	    if (allInitialized && indexChanged) {
	      callback(indices);
	    }
	  };
	}

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (recalc) {
	  if (!size || recalc) {
	    if (_inDOM2.default) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};
	
	var _inDOM = __webpack_require__(1317);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = void 0;
	
	module.exports = exports['default'];

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionData;
	
	var _SectionManager = __webpack_require__(1319);
	
	var _SectionManager2 = _interopRequireDefault(_SectionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calculateSizeAndPositionData(_ref) {
	  var cellCount = _ref.cellCount,
	      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
	      sectionSize = _ref.sectionSize;
	
	  var cellMetadata = [];
	  var sectionManager = new _SectionManager2.default(sectionSize);
	  var height = 0;
	  var width = 0;
	
	  for (var index = 0; index < cellCount; index++) {
	    var cellMetadatum = cellSizeAndPositionGetter({ index: index });
	
	    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
	      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
	    }
	
	    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
	    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
	
	    cellMetadata[index] = cellMetadatum;
	    sectionManager.registerCell({
	      cellMetadatum: cellMetadatum,
	      index: index
	    });
	  }
	
	  return {
	    cellMetadata: cellMetadata,
	    height: height,
	    sectionManager: sectionManager,
	    width: width
	  };
	}

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Window Sections are used to group nearby cells.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This enables us to more quickly determine which cells to display in a given region of the Window.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _Section = __webpack_require__(1320);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SECTION_SIZE = 100;
	
	/**
	 * Contains 0 to many Sections.
	 * Grows (and adds Sections) dynamically as cells are registered.
	 * Automatically adds cells to the appropriate Section(s).
	 */
	var SectionManager = function () {
	  function SectionManager() {
	    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;
	
	    _classCallCheck(this, SectionManager);
	
	    this._sectionSize = sectionSize;
	
	    this._cellMetadata = [];
	    this._sections = {};
	  }
	
	  /**
	   * Gets all cell indices contained in the specified region.
	   * A region may encompass 1 or more Sections.
	   */
	
	
	  _createClass(SectionManager, [{
	    key: 'getCellIndices',
	    value: function getCellIndices(_ref) {
	      var height = _ref.height,
	          width = _ref.width,
	          x = _ref.x,
	          y = _ref.y;
	
	      var indices = {};
	
	      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
	        return section.getCellIndices().forEach(function (index) {
	          indices[index] = index;
	        });
	      });
	
	      // Object keys are strings; this function returns numbers
	      return Object.keys(indices).map(function (index) {
	        return indices[index];
	      });
	    }
	
	    /** Get size and position information for the cell specified. */
	
	  }, {
	    key: 'getCellMetadata',
	    value: function getCellMetadata(_ref2) {
	      var index = _ref2.index;
	
	      return this._cellMetadata[index];
	    }
	
	    /** Get all Sections overlapping the specified region. */
	
	  }, {
	    key: 'getSections',
	    value: function getSections(_ref3) {
	      var height = _ref3.height,
	          width = _ref3.width,
	          x = _ref3.x,
	          y = _ref3.y;
	
	      var sectionXStart = Math.floor(x / this._sectionSize);
	      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
	      var sectionYStart = Math.floor(y / this._sectionSize);
	      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
	
	      var sections = [];
	
	      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
	        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
	          var key = sectionX + '.' + sectionY;
	
	          if (!this._sections[key]) {
	            this._sections[key] = new _Section2.default({
	              height: this._sectionSize,
	              width: this._sectionSize,
	              x: sectionX * this._sectionSize,
	              y: sectionY * this._sectionSize
	            });
	          }
	
	          sections.push(this._sections[key]);
	        }
	      }
	
	      return sections;
	    }
	
	    /** Total number of Sections based on the currently registered cells. */
	
	  }, {
	    key: 'getTotalSectionCount',
	    value: function getTotalSectionCount() {
	      return Object.keys(this._sections).length;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var _this = this;
	
	      return Object.keys(this._sections).map(function (index) {
	        return _this._sections[index].toString();
	      });
	    }
	
	    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */
	
	  }, {
	    key: 'registerCell',
	    value: function registerCell(_ref4) {
	      var cellMetadatum = _ref4.cellMetadatum,
	          index = _ref4.index;
	
	      this._cellMetadata[index] = cellMetadatum;
	
	      this.getSections(cellMetadatum).forEach(function (section) {
	        return section.addCellIndex({ index: index });
	      });
	    }
	  }]);
	
	  return SectionManager;
	}();
	
	exports.default = SectionManager;

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A section of the Window.
	 * Window Sections are used to group nearby cells.
	 * This enables us to more quickly determine which cells to display in a given region of the Window.
	 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
	 */
	var Section = function () {
	  function Section(_ref) {
	    var height = _ref.height,
	        width = _ref.width,
	        x = _ref.x,
	        y = _ref.y;
	
	    _classCallCheck(this, Section);
	
	    this.height = height;
	    this.width = width;
	    this.x = x;
	    this.y = y;
	
	    this._indexMap = {};
	    this._indices = [];
	  }
	
	  /** Add a cell to this section. */
	
	
	  _createClass(Section, [{
	    key: 'addCellIndex',
	    value: function addCellIndex(_ref2) {
	      var index = _ref2.index;
	
	      if (!this._indexMap[index]) {
	        this._indexMap[index] = true;
	        this._indices.push(index);
	      }
	    }
	
	    /** Get all cell indices that have been added to this section. */
	
	  }, {
	    key: 'getCellIndices',
	    value: function getCellIndices() {
	      return this._indices;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
	    }
	  }]);
	
	  return Section;
	}(); /** @rlow */
	
	
	exports.default = Section;

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUpdatedOffsetForIndex;
	/**
	 * Determines a new offset that ensures a certain cell is visible, given the current offset.
	 * If the cell is already visible then the current offset will be returned.
	 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	 *
	 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	 * @param cellOffset Offset (x or y) position for cell
	 * @param cellSize Size (width or height) of cell
	 * @param containerSize Total size (width or height) of the container
	 * @param currentOffset Container's current (x or y) offset
	 * @return Offset to use to ensure the specified cell is visible
	 */
	function getUpdatedOffsetForIndex(_ref) {
	  var _ref$align = _ref.align,
	      align = _ref$align === undefined ? 'auto' : _ref$align,
	      cellOffset = _ref.cellOffset,
	      cellSize = _ref.cellSize,
	      containerSize = _ref.containerSize,
	      currentOffset = _ref.currentOffset;
	
	  var maxOffset = cellOffset;
	  var minOffset = maxOffset - containerSize + cellSize;
	
	  switch (align) {
	    case 'start':
	      return maxOffset;
	    case 'end':
	      return minOffset;
	    case 'center':
	      return maxOffset - (containerSize - cellSize) / 2;
	    default:
	      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
	  }
	}

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColumnSizer = exports.default = undefined;
	
	var _ColumnSizer2 = __webpack_require__(1323);
	
	var _ColumnSizer3 = _interopRequireDefault(_ColumnSizer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ColumnSizer3.default;
	exports.ColumnSizer = _ColumnSizer3.default;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * High-order component that auto-calculates column-widths for `Grid` cells.
	 */
	var ColumnSizer = function (_PureComponent) {
	  _inherits(ColumnSizer, _PureComponent);
	
	  function ColumnSizer(props, context) {
	    _classCallCheck(this, ColumnSizer);
	
	    var _this = _possibleConstructorReturn(this, (ColumnSizer.__proto__ || Object.getPrototypeOf(ColumnSizer)).call(this, props, context));
	
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  _createClass(ColumnSizer, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props = this.props,
	          columnMaxWidth = _props.columnMaxWidth,
	          columnMinWidth = _props.columnMinWidth,
	          columnCount = _props.columnCount,
	          width = _props.width;
	
	
	      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
	        if (this._registeredChild) {
	          this._registeredChild.recomputeGridSize();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          columnMaxWidth = _props2.columnMaxWidth,
	          columnMinWidth = _props2.columnMinWidth,
	          columnCount = _props2.columnCount,
	          width = _props2.width;
	
	
	      var safeColumnMinWidth = columnMinWidth || 1;
	
	      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
	
	      var columnWidth = width / columnCount;
	      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
	      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
	      columnWidth = Math.floor(columnWidth);
	
	      var adjustedWidth = Math.min(width, columnWidth * columnCount);
	
	      return children({
	        adjustedWidth: adjustedWidth,
	        columnWidth: columnWidth,
	        getColumnWidth: function getColumnWidth() {
	          return columnWidth;
	        },
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(child) {
	      if (child && typeof child.recomputeGridSize !== 'function') {
	        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
	      }
	
	      this._registeredChild = child;
	
	      if (this._registeredChild) {
	        this._registeredChild.recomputeGridSize();
	      }
	    }
	  }]);
	
	  return ColumnSizer;
	}(_react.PureComponent);
	
	exports.default = ColumnSizer;
	 false ? ColumnSizer.propTypes = {
	  /**
	   * Function responsible for rendering a virtualized Grid.
	   * This function should implement the following signature:
	   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
	   *
	   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
	   * The :registerChild should be passed to the Grid's :ref property.
	   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
	   */
	  children: _propTypes2.default.func.isRequired,
	
	  /** Optional maximum allowed column width */
	  columnMaxWidth: _propTypes2.default.number,
	
	  /** Optional minimum allowed column width */
	  columnMinWidth: _propTypes2.default.number,
	
	  /** Number of columns in Grid or Table child */
	  columnCount: _propTypes2.default.number.isRequired,
	
	  /** Width of Grid or Table child */
	  width: _propTypes2.default.number.isRequired
	} : void 0;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultOverscanIndicesGetter = exports.defaultCellRangeRenderer = exports.accessibilityOverscanIndicesGetter = exports.Grid = exports.default = undefined;
	
	var _Grid2 = __webpack_require__(1325);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _accessibilityOverscanIndicesGetter2 = __webpack_require__(1332);
	
	var _accessibilityOverscanIndicesGetter3 = _interopRequireDefault(_accessibilityOverscanIndicesGetter2);
	
	var _defaultCellRangeRenderer2 = __webpack_require__(1331);
	
	var _defaultCellRangeRenderer3 = _interopRequireDefault(_defaultCellRangeRenderer2);
	
	var _defaultOverscanIndicesGetter2 = __webpack_require__(1329);
	
	var _defaultOverscanIndicesGetter3 = _interopRequireDefault(_defaultOverscanIndicesGetter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Grid3.default;
	exports.Grid = _Grid3.default;
	exports.accessibilityOverscanIndicesGetter = _accessibilityOverscanIndicesGetter3.default;
	exports.defaultCellRangeRenderer = _defaultCellRangeRenderer3.default;
	exports.defaultOverscanIndicesGetter = _defaultOverscanIndicesGetter3.default;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset = __webpack_require__(1326);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset2 = _interopRequireDefault(_calculateSizeAndPositionDataAndUpdateScrollOffset);
	
	var _ScalingCellSizeAndPositionManager = __webpack_require__(1327);
	
	var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);
	
	var _createCallbackMemoizer = __webpack_require__(1315);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _defaultOverscanIndicesGetter = __webpack_require__(1329);
	
	var _defaultOverscanIndicesGetter2 = _interopRequireDefault(_defaultOverscanIndicesGetter);
	
	var _updateScrollIndexHelper = __webpack_require__(1330);
	
	var _updateScrollIndexHelper2 = _interopRequireDefault(_updateScrollIndexHelper);
	
	var _defaultCellRangeRenderer = __webpack_require__(1331);
	
	var _defaultCellRangeRenderer2 = _interopRequireDefault(_defaultCellRangeRenderer);
	
	var _scrollbarSize = __webpack_require__(1316);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	/**
	 * Renders tabular data with virtualization along the vertical and horizontal axes.
	 * Row heights and column widths must be known ahead of time and specified as properties.
	 */
	
	var Grid = function (_PureComponent) {
	  _inherits(Grid, _PureComponent);
	
	  function Grid(props, context) {
	    _classCallCheck(this, Grid);
	
	    var _this = _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this, props, context));
	
	    _this.state = {
	      isScrolling: false,
	      scrollDirectionHorizontal: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
	      scrollDirectionVertical: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    // Invokes onSectionRendered callback only when start/stop row or column indices change
	    _this._onGridRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	
	    // Bind functions to instance so they don't lose context when passed around
	    _this._debounceScrollEndedCallback = _this._debounceScrollEndedCallback.bind(_this);
	    _this._invokeOnGridRenderedHelper = _this._invokeOnGridRenderedHelper.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._setScrollingContainerRef = _this._setScrollingContainerRef.bind(_this);
	
	    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
	    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);
	
	    _this._deferredInvalidateColumnIndex = null;
	    _this._deferredInvalidateRowIndex = null;
	    _this._recomputeScrollLeftFlag = false;
	    _this._recomputeScrollTopFlag = false;
	
	    var deferredMeasurementCache = props.deferredMeasurementCache;
	    var deferredMode = typeof deferredMeasurementCache !== 'undefined';
	
	    _this._columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      batchAllCells: deferredMode && !deferredMeasurementCache.hasFixedHeight(),
	      cellCount: props.columnCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return _this._columnWidthGetter(params);
	      },
	      estimatedCellSize: _this._getEstimatedColumnSize(props)
	    });
	    _this._rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      batchAllCells: deferredMode && !deferredMeasurementCache.hasFixedWidth(),
	      cellCount: props.rowCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return _this._rowHeightGetter(params);
	      },
	      estimatedCellSize: _this._getEstimatedRowSize(props)
	    });
	
	    // See defaultCellRangeRenderer() for more information on the usage of these caches
	    _this._cellCache = {};
	    _this._styleCache = {};
	    return _this;
	  }
	
	  /**
	   * Gets offsets for a given cell and alignment.
	   */
	
	
	  _createClass(Grid, [{
	    key: 'getOffsetForCell',
	    value: function getOffsetForCell() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$alignment = _ref.alignment,
	          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
	          _ref$columnIndex = _ref.columnIndex,
	          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
	          _ref$rowIndex = _ref.rowIndex,
	          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;
	
	      var offsetProps = _extends({}, this.props, {
	        scrollToAlignment: alignment,
	        scrollToColumn: columnIndex,
	        scrollToRow: rowIndex
	      });
	
	      return {
	        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
	        scrollTop: this._getCalculatedScrollTop(offsetProps)
	      };
	    }
	
	    /**
	     * Invalidate Grid size and recompute visible cells.
	     * This is a deferred wrapper for recomputeGridSize().
	     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
	     * This method is intended for advanced use-cases like CellMeasurer.
	     */
	    // @TODO (bvaughn) Add automated test coverage for this.
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender(_ref2) {
	      var columnIndex = _ref2.columnIndex,
	          rowIndex = _ref2.rowIndex;
	
	      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
	      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
	    }
	
	    /**
	     * Pre-measure all columns and rows in a Grid.
	     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
	     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
	     */
	
	  }, {
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      var _props = this.props,
	          columnCount = _props.columnCount,
	          rowCount = _props.rowCount;
	
	
	      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
	      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
	    }
	
	    /**
	     * Forced recompute of row heights and column widths.
	     * This function should be called if dynamic column or row sizes have changed but nothing else has.
	     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
	     */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref3$columnIndex = _ref3.columnIndex,
	          columnIndex = _ref3$columnIndex === undefined ? 0 : _ref3$columnIndex,
	          _ref3$rowIndex = _ref3.rowIndex,
	          rowIndex = _ref3$rowIndex === undefined ? 0 : _ref3$rowIndex;
	
	      var _props2 = this.props,
	          scrollToColumn = _props2.scrollToColumn,
	          scrollToRow = _props2.scrollToRow;
	
	
	      this._columnSizeAndPositionManager.resetCell(columnIndex);
	      this._rowSizeAndPositionManager.resetCell(rowIndex);
	
	      // Cell sizes may be determined by a function property.
	      // In this case the cDU handler can't know if they changed.
	      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
	      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && columnIndex <= scrollToColumn;
	      this._recomputeScrollTopFlag = scrollToRow >= 0 && rowIndex <= scrollToRow;
	
	      // Clear cell cache in case we are scrolling;
	      // Invalid row heights likely mean invalid cached content as well.
	      this._cellCache = {};
	      this._styleCache = {};
	
	      this.forceUpdate();
	    }
	
	    /**
	     * Ensure column and row are visible.
	     */
	
	  }, {
	    key: 'scrollToCell',
	    value: function scrollToCell(_ref4) {
	      var columnIndex = _ref4.columnIndex,
	          rowIndex = _ref4.rowIndex;
	      var columnCount = this.props.columnCount;
	
	
	      var props = this.props;
	
	      // Don't adjust scroll offset for single-column grids (eg List, Table).
	      // This can cause a funky scroll offset because of the vertical scrollbar width.
	      if (columnCount > 1) {
	        this._updateScrollLeftForScrollToColumn(_extends({}, props, {
	          scrollToColumn: columnIndex
	        }));
	      }
	
	      this._updateScrollTopForScrollToRow(_extends({}, props, {
	        scrollToRow: rowIndex
	      }));
	    }
	
	    /**
	     * Scroll to the specified offset(s).
	     * Useful for animating position changes.
	     */
	
	  }, {
	    key: 'scrollToPosition',
	    value: function scrollToPosition() {
	      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          scrollLeft = _ref5.scrollLeft,
	          scrollTop = _ref5.scrollTop;
	
	      this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props3 = this.props,
	          getScrollbarSize = _props3.getScrollbarSize,
	          scrollLeft = _props3.scrollLeft,
	          scrollToColumn = _props3.scrollToColumn,
	          scrollTop = _props3.scrollTop,
	          scrollToRow = _props3.scrollToRow;
	
	      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
	      // We must do this at the start of the method as we may calculate and update scroll position below.
	
	      this._handleInvalidatedGridSize();
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = getScrollbarSize();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (scrollLeft >= 0 || scrollTop >= 0) {
	        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      if (scrollToColumn >= 0 || scrollToRow >= 0) {
	        this._updateScrollLeftForScrollToColumn();
	        this._updateScrollTopForScrollToRow();
	      }
	
	      // Update onRowsRendered callback
	      this._invokeOnGridRenderedHelper();
	
	      // Initialize onScroll callback
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
	        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
	      });
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) New scroll-to-cell props have been set
	     */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          autoHeight = _props4.autoHeight,
	          autoWidth = _props4.autoWidth,
	          columnCount = _props4.columnCount,
	          height = _props4.height,
	          rowCount = _props4.rowCount,
	          scrollToAlignment = _props4.scrollToAlignment,
	          scrollToColumn = _props4.scrollToColumn,
	          scrollToRow = _props4.scrollToRow,
	          width = _props4.width;
	      var _state = this.state,
	          scrollLeft = _state.scrollLeft,
	          scrollPositionChangeReason = _state.scrollPositionChangeReason,
	          scrollTop = _state.scrollTop;
	
	      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
	      // We must do this at the start of the method as we may calculate and update scroll position below.
	
	      this._handleInvalidatedGridSize();
	
	      // Handle edge case where column or row count has only just increased over 0.
	      // In this case we may have to restore a previously-specified scroll offset.
	      // For more info see bvaughn/react-virtualized/issues/218
	      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
	        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
	        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
	      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
	      if (this._recomputeScrollLeftFlag) {
	        this._recomputeScrollLeftFlag = false;
	        this._updateScrollLeftForScrollToColumn(this.props);
	      } else {
	        (0, _updateScrollIndexHelper2.default)({
	          cellSizeAndPositionManager: this._columnSizeAndPositionManager,
	          previousCellsCount: prevProps.columnCount,
	          previousCellSize: prevProps.columnWidth,
	          previousScrollToAlignment: prevProps.scrollToAlignment,
	          previousScrollToIndex: prevProps.scrollToColumn,
	          previousSize: prevProps.width,
	          scrollOffset: scrollLeft,
	          scrollToAlignment: scrollToAlignment,
	          scrollToIndex: scrollToColumn,
	          size: width,
	          updateScrollIndexCallback: function updateScrollIndexCallback(scrollToColumn) {
	            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
	          }
	        });
	      }
	
	      if (this._recomputeScrollTopFlag) {
	        this._recomputeScrollTopFlag = false;
	        this._updateScrollTopForScrollToRow(this.props);
	      } else {
	        (0, _updateScrollIndexHelper2.default)({
	          cellSizeAndPositionManager: this._rowSizeAndPositionManager,
	          previousCellsCount: prevProps.rowCount,
	          previousCellSize: prevProps.rowHeight,
	          previousScrollToAlignment: prevProps.scrollToAlignment,
	          previousScrollToIndex: prevProps.scrollToRow,
	          previousSize: prevProps.height,
	          scrollOffset: scrollTop,
	          scrollToAlignment: scrollToAlignment,
	          scrollToIndex: scrollToRow,
	          size: height,
	          updateScrollIndexCallback: function updateScrollIndexCallback(scrollToRow) {
	            return _this2._updateScrollTopForScrollToRow(_this2.props);
	          }
	        });
	      }
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnGridRenderedHelper();
	
	      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
	      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
	        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	
	        this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var getScrollbarSize = this.props.getScrollbarSize;
	
	      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	      // We handle this case in componentDidMount()
	
	      this._scrollbarSize = getScrollbarSize();
	      if (this._scrollbarSize === undefined) {
	        this._scrollbarSizeMeasured = false;
	        this._scrollbarSize = 0;
	      } else {
	        this._scrollbarSizeMeasured = true;
	      }
	
	      this._calculateChildrenToRender();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          scrollLeft = _state2.scrollLeft,
	          scrollTop = _state2.scrollTop;
	
	
	      if (nextProps.columnCount === 0 && scrollLeft !== 0 || nextProps.rowCount === 0 && scrollTop !== 0) {
	        this._setScrollPosition({
	          scrollLeft: 0,
	          scrollTop: 0
	        });
	      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        var newState = {};
	
	        if (nextProps.scrollLeft != null) {
	          newState.scrollLeft = nextProps.scrollLeft;
	        }
	        if (nextProps.scrollTop != null) {
	          newState.scrollTop = nextProps.scrollTop;
	        }
	
	        this._setScrollPosition(newState);
	      }
	
	      if (nextProps.columnWidth !== this.props.columnWidth || nextProps.rowHeight !== this.props.rowHeight) {
	        this._styleCache = {};
	      }
	
	      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
	      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);
	
	      this._columnSizeAndPositionManager.configure({
	        cellCount: nextProps.columnCount,
	        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
	      });
	      this._rowSizeAndPositionManager.configure({
	        cellCount: nextProps.rowCount,
	        estimatedCellSize: this._getEstimatedRowSize(nextProps)
	      });
	
	      var _props5 = this.props,
	          columnCount = _props5.columnCount,
	          rowCount = _props5.rowCount;
	
	      // Special case when either cols or rows were 0
	      // This would prevent any cells from rendering
	      // So we need to reset row scroll if cols changed from 0 (and vice versa)
	
	      if (columnCount === 0 || rowCount === 0) {
	        columnCount = 0;
	        rowCount = 0;
	      }
	
	      // If scrolling is controlled outside this component, clear cache when scrolling stops
	      if (nextProps.autoHeight && nextProps.isScrolling === false && this.props.isScrolling === true) {
	        this._resetStyleCache();
	      }
	
	      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: columnCount,
	        cellSize: this.props.columnWidth,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._columnSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.columnCount,
	        nextCellSize: nextProps.columnWidth,
	        nextScrollToIndex: nextProps.scrollToColumn,
	        scrollToIndex: this.props.scrollToColumn,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollLeftForScrollToColumn(nextProps, _this3.state);
	        }
	      });
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: rowCount,
	        cellSize: this.props.rowHeight,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._rowSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.rowCount,
	        nextCellSize: nextProps.rowHeight,
	        nextScrollToIndex: nextProps.scrollToRow,
	        scrollToIndex: this.props.scrollToRow,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollTopForScrollToRow(nextProps, _this3.state);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this._calculateChildrenToRender(nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          autoContainerWidth = _props6.autoContainerWidth,
	          autoHeight = _props6.autoHeight,
	          autoWidth = _props6.autoWidth,
	          className = _props6.className,
	          containerStyle = _props6.containerStyle,
	          height = _props6.height,
	          id = _props6.id,
	          noContentRenderer = _props6.noContentRenderer,
	          role = _props6.role,
	          style = _props6.style,
	          tabIndex = _props6.tabIndex,
	          width = _props6.width;
	
	
	      var isScrolling = this._isScrolling();
	
	      var gridStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        width: autoWidth ? 'auto' : width,
	        WebkitOverflowScrolling: 'touch',
	        willChange: 'transform'
	      };
	
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      var childrenToDisplay = this._childrenToDisplay;
	
	      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setScrollingContainerRef,
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Grid', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: role,
	          style: _extends({}, gridStyle, style),
	          tabIndex: tabIndex
	        },
	        childrenToDisplay.length > 0 && _react2.default.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Grid__innerScrollContainer',
	            style: _extends({
	              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
	              height: totalRowsHeight,
	              maxWidth: totalColumnsWidth,
	              maxHeight: totalRowsHeight,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : '',
	              position: 'relative'
	            }, containerStyle)
	          },
	          childrenToDisplay
	        ),
	        showNoContentRenderer && noContentRenderer()
	      );
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	  }, {
	    key: '_calculateChildrenToRender',
	    value: function _calculateChildrenToRender() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var cellRenderer = props.cellRenderer,
	          cellRangeRenderer = props.cellRangeRenderer,
	          columnCount = props.columnCount,
	          deferredMeasurementCache = props.deferredMeasurementCache,
	          height = props.height,
	          overscanColumnCount = props.overscanColumnCount,
	          overscanIndicesGetter = props.overscanIndicesGetter,
	          overscanRowCount = props.overscanRowCount,
	          rowCount = props.rowCount,
	          width = props.width;
	      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
	          scrollDirectionVertical = state.scrollDirectionVertical,
	          scrollLeft = state.scrollLeft,
	          scrollTop = state.scrollTop;
	
	
	      var isScrolling = this._isScrolling(props, state);
	
	      this._childrenToDisplay = [];
	
	      // Render only enough columns and rows to cover the visible area of the grid.
	      if (height > 0 && width > 0) {
	        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._renderedColumnStartIndex = visibleColumnIndices.start;
	        this._renderedColumnStopIndex = visibleColumnIndices.stop;
	        this._renderedRowStartIndex = visibleRowIndices.start;
	        this._renderedRowStopIndex = visibleRowIndices.stop;
	
	        var overscanColumnIndices = overscanIndicesGetter({
	          direction: 'horizontal',
	          cellCount: columnCount,
	          overscanCellsCount: overscanColumnCount,
	          scrollDirection: scrollDirectionHorizontal,
	          startIndex: this._renderedColumnStartIndex,
	          stopIndex: this._renderedColumnStopIndex
	        });
	
	        var overscanRowIndices = overscanIndicesGetter({
	          direction: 'vertical',
	          cellCount: rowCount,
	          overscanCellsCount: overscanRowCount,
	          scrollDirection: scrollDirectionVertical,
	          startIndex: this._renderedRowStartIndex,
	          stopIndex: this._renderedRowStopIndex
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
	        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
	        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
	        this._rowStopIndex = overscanRowIndices.overscanStopIndex;
	
	        this._childrenToDisplay = cellRangeRenderer({
	          cellCache: this._cellCache,
	          cellRenderer: cellRenderer,
	          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
	          columnStartIndex: this._columnStartIndex,
	          columnStopIndex: this._columnStopIndex,
	          deferredMeasurementCache: deferredMeasurementCache,
	          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
	          isScrolling: isScrolling,
	          parent: this,
	          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
	          rowStartIndex: this._rowStartIndex,
	          rowStopIndex: this._rowStopIndex,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          styleCache: this._styleCache,
	          verticalOffsetAdjustment: verticalOffsetAdjustment,
	          visibleColumnIndices: visibleColumnIndices,
	          visibleRowIndices: visibleRowIndices
	        });
	      }
	    }
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Grid.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_debounceScrollEnded',
	    value: function _debounceScrollEnded() {
	      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
	
	
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = setTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
	    }
	  }, {
	    key: '_debounceScrollEndedCallback',
	    value: function _debounceScrollEndedCallback() {
	      this._disablePointerEventsTimeoutId = null;
	      this._resetStyleCache();
	    }
	  }, {
	    key: '_getEstimatedColumnSize',
	    value: function _getEstimatedColumnSize(props) {
	      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
	    }
	  }, {
	    key: '_getEstimatedRowSize',
	    value: function _getEstimatedRowSize(props) {
	      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
	    }
	
	    /**
	     * Check for batched CellMeasurer size invalidations.
	     * This will occur the first time one or more previously unmeasured cells are rendered.
	     */
	
	  }, {
	    key: '_handleInvalidatedGridSize',
	    value: function _handleInvalidatedGridSize() {
	      if (typeof this._deferredInvalidateColumnIndex === 'number') {
	        var columnIndex = this._deferredInvalidateColumnIndex;
	        var rowIndex = this._deferredInvalidateRowIndex;
	
	        this._deferredInvalidateColumnIndex = null;
	        this._deferredInvalidateRowIndex = null;
	
	        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
	      }
	    }
	  }, {
	    key: '_invokeOnGridRenderedHelper',
	    value: function _invokeOnGridRenderedHelper() {
	      var onSectionRendered = this.props.onSectionRendered;
	
	
	      this._onGridRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          columnOverscanStartIndex: this._columnStartIndex,
	          columnOverscanStopIndex: this._columnStopIndex,
	          columnStartIndex: this._renderedColumnStartIndex,
	          columnStopIndex: this._renderedColumnStopIndex,
	          rowOverscanStartIndex: this._rowStartIndex,
	          rowOverscanStopIndex: this._rowStopIndex,
	          rowStartIndex: this._renderedRowStartIndex,
	          rowStopIndex: this._renderedRowStopIndex
	        }
	      });
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref6) {
	      var _this4 = this;
	
	      var scrollLeft = _ref6.scrollLeft,
	          scrollTop = _ref6.scrollTop,
	          totalColumnsWidth = _ref6.totalColumnsWidth,
	          totalRowsHeight = _ref6.totalRowsHeight;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref7) {
	          var scrollLeft = _ref7.scrollLeft,
	              scrollTop = _ref7.scrollTop;
	          var _props7 = _this4.props,
	              height = _props7.height,
	              onScroll = _props7.onScroll,
	              width = _props7.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalRowsHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalColumnsWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: '_isScrolling',
	    value: function _isScrolling() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	
	      // If isScrolling is defined in props, use it to override the value in state
	      // This is a performance optimization for WindowScroller + Grid
	      return Object.hasOwnProperty.call(props, 'isScrolling') ? props.isScrolling : state.isScrolling;
	    }
	  }, {
	    key: '_setScrollingContainerRef',
	    value: function _setScrollingContainerRef(ref) {
	      this._scrollingContainer = ref;
	    }
	  }, {
	    key: '_setScrollPosition',
	    value: function _setScrollPosition(_ref8) {
	      var scrollLeft = _ref8.scrollLeft,
	          scrollTop = _ref8.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (scrollLeft >= 0) {
	        newState.scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (scrollTop >= 0) {
	        newState.scrollDirectionVertical = scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollTop = scrollTop;
	      }
	
	      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: '_wrapPropertyGetter',
	    value: function _wrapPropertyGetter(value) {
	      return typeof value === 'function' ? value : function () {
	        return value;
	      };
	    }
	  }, {
	    key: '_wrapSizeGetter',
	    value: function _wrapSizeGetter(size) {
	      return this._wrapPropertyGetter(size);
	    }
	  }, {
	    key: '_getCalculatedScrollLeft',
	    value: function _getCalculatedScrollLeft() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var columnCount = props.columnCount,
	          height = props.height,
	          scrollToAlignment = props.scrollToAlignment,
	          scrollToColumn = props.scrollToColumn,
	          width = props.width;
	      var scrollLeft = state.scrollLeft;
	
	
	      if (scrollToColumn >= 0 && columnCount > 0) {
	        var targetIndex = Math.max(0, Math.min(columnCount - 1, scrollToColumn));
	        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	        var scrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
	
	        return this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: width - scrollBarSize,
	          currentOffset: scrollLeft,
	          targetIndex: targetIndex
	        });
	      }
	    }
	  }, {
	    key: '_updateScrollLeftForScrollToColumn',
	    value: function _updateScrollLeftForScrollToColumn() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var scrollLeft = state.scrollLeft;
	
	      var calculatedScrollLeft = this._getCalculatedScrollLeft(props, state);
	
	      if (calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
	        this._setScrollPosition({
	          scrollLeft: calculatedScrollLeft
	        });
	      }
	    }
	  }, {
	    key: '_getCalculatedScrollTop',
	    value: function _getCalculatedScrollTop() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var height = props.height,
	          rowCount = props.rowCount,
	          scrollToAlignment = props.scrollToAlignment,
	          scrollToRow = props.scrollToRow,
	          width = props.width;
	      var scrollTop = state.scrollTop;
	
	
	      if (scrollToRow >= 0 && rowCount > 0) {
	        var targetIndex = Math.max(0, Math.min(rowCount - 1, scrollToRow));
	        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	        var scrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;
	
	        return this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: height - scrollBarSize,
	          currentOffset: scrollTop,
	          targetIndex: targetIndex
	        });
	      }
	    }
	  }, {
	    key: '_resetStyleCache',
	    value: function _resetStyleCache() {
	      var styleCache = this._styleCache;
	
	      // Reset cell and style caches once scrolling stops.
	      // This makes Grid simpler to use (since cells commonly change).
	      // And it keeps the caches from growing too large.
	      // Performance is most sensitive when a user is scrolling.
	      this._cellCache = {};
	      this._styleCache = {};
	
	      // Copy over the visible cell styles so avoid unnecessary re-render.
	      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
	        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
	          var key = rowIndex + '-' + columnIndex;
	          this._styleCache[key] = styleCache[key];
	        }
	      }
	
	      this.setState({
	        isScrolling: false
	      });
	    }
	  }, {
	    key: '_updateScrollTopForScrollToRow',
	    value: function _updateScrollTopForScrollToRow() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var scrollTop = state.scrollTop;
	
	      var calculatedScrollTop = this._getCalculatedScrollTop(props, state);
	
	      if (calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
	        this._setScrollPosition({
	          scrollTop: calculatedScrollTop
	        });
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target !== this._scrollingContainer) {
	        return;
	      }
	
	      // On iOS, we can arrive at negative offsets by swiping past the start.
	      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
	      if (event.target.scrollTop < 0) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._debounceScrollEnded();
	
	      var _props8 = this.props,
	          autoHeight = _props8.autoHeight,
	          autoWidth = _props8.autoWidth,
	          height = _props8.height,
	          width = _props8.width;
	      var _event$target = event.target,
	          eventScrollLeft = _event$target.scrollLeft,
	          eventScrollTop = _event$target.scrollTop;
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
	
	      var scrollbarSize = this._scrollbarSize;
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), eventScrollLeft);
	      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), eventScrollTop);
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
	        // Don't change direction for an axis unless scroll offset has changed.
	        var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
	        var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
	
	        var newState = {
	          isScrolling: true,
	          scrollDirectionHorizontal: scrollDirectionHorizontal,
	          scrollDirectionVertical: scrollDirectionVertical,
	          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
	        };
	
	        if (!autoHeight) {
	          newState.scrollTop = scrollTop;
	        }
	        if (!autoWidth) {
	          newState.scrollLeft = scrollLeft;
	        }
	
	        this.setState(newState);
	      }
	
	      this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
	    }
	  }]);
	
	  return Grid;
	}(_react.PureComponent);
	
	Grid.defaultProps = {
	  'aria-label': 'grid',
	  cellRangeRenderer: _defaultCellRangeRenderer2.default,
	  estimatedColumnSize: 100,
	  estimatedRowSize: 30,
	  getScrollbarSize: _scrollbarSize2.default,
	  noContentRenderer: function noContentRenderer() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  onSectionRendered: function onSectionRendered() {
	    return null;
	  },
	  overscanColumnCount: 0,
	  overscanIndicesGetter: _defaultOverscanIndicesGetter2.default,
	  overscanRowCount: 10,
	  role: 'grid',
	  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
	  scrollToAlignment: 'auto',
	  scrollToColumn: -1,
	  scrollToRow: -1,
	  style: {},
	  tabIndex: 0
	};
	exports.default = Grid;
	 false ? Grid.propTypes = {
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Set the width of the inner scrollable container to 'auto'.
	   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
	   */
	  autoContainerWidth: _propTypes2.default.bool,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
	   * Intended for use with WindowScroller
	   */
	  autoHeight: _propTypes2.default.bool,
	
	  /**
	   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
	   * Intended for use with WindowScroller
	   */
	  autoWidth: _propTypes2.default.bool,
	
	  /**
	   * Responsible for rendering a cell given an row and column index.
	   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
	   */
	  cellRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Responsible for rendering a group of cells given their index ranges.
	   * Should implement the following interface: ({
	   *   cellCache: Map,
	   *   cellRenderer: Function,
	   *   columnSizeAndPositionManager: CellSizeAndPositionManager,
	   *   columnStartIndex: number,
	   *   columnStopIndex: number,
	   *   isScrolling: boolean,
	   *   rowSizeAndPositionManager: CellSizeAndPositionManager,
	   *   rowStartIndex: number,
	   *   rowStopIndex: number,
	   *   scrollLeft: number,
	   *   scrollTop: number
	   * }): Array<PropTypes.node>
	   */
	  cellRangeRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Optional custom CSS class name to attach to root Grid element.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Number of columns in grid.
	   */
	  columnCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Either a fixed column width (number) or a function that returns the width of a column given its index.
	   * Should implement the following interface: (index: number): number
	   */
	  columnWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
	
	  /** Optional inline style applied to inner cell-container */
	  containerStyle: _propTypes2.default.object,
	
	  /**
	   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
	   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
	   */
	  deferredMeasurementCache: _propTypes2.default.object,
	
	  /**
	   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
	   * The estimated total width is adjusted as columns are rendered.
	   */
	  estimatedColumnSize: _propTypes2.default.number.isRequired,
	
	  /**
	   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _propTypes2.default.number.isRequired,
	
	  /**
	   * Exposed for testing purposes only.
	   */
	  getScrollbarSize: _propTypes2.default.func.isRequired,
	
	  /**
	   * Height of Grid; this property determines the number of visible (vs virtualized) rows.
	   */
	  height: _propTypes2.default.number.isRequired,
	
	  /**
	   * Optional custom id to attach to root Grid element.
	   */
	  id: _propTypes2.default.string,
	
	  /**
	   * Override internal is-scrolling state tracking.
	   * This property is primarily intended for use with the WindowScroller component.
	   */
	  isScrolling: _propTypes2.default.bool,
	
	  /**
	   * Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.
	   */
	  noContentRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
	   */
	  onScroll: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback invoked with information about the section of the Grid that was just rendered.
	   * ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }): void
	   */
	  onSectionRendered: _propTypes2.default.func.isRequired,
	
	  /**
	   * Number of columns to render before/after the visible section of the grid.
	   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanColumnCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Calculates the number of cells to overscan before and after a specified range.
	   * This function ensures that overscanning doesn't exceed the available cells.
	   * Should implement the following interface: ({
	   *   cellCount: number,
	   *   overscanCellsCount: number,
	   *   scrollDirection: number,
	   *   startIndex: number,
	   *   stopIndex: number
	   * }): {overscanStartIndex: number, overscanStopIndex: number}
	   */
	  overscanIndicesGetter: _propTypes2.default.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible section of the grid.
	   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanRowCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * ARIA role for the grid element.
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * Should implement the following interface: ({ index: number }): number
	   */
	  rowHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
	
	  /**
	   * Number of rows in grid.
	   */
	  rowCount: _propTypes2.default.number.isRequired,
	
	  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
	  scrollingResetTimeInterval: _propTypes2.default.number,
	
	  /** Horizontal offset. */
	  scrollLeft: _propTypes2.default.number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /**
	   * Column index to ensure visible (by forcefully scrolling if necessary)
	   */
	  scrollToColumn: _propTypes2.default.number.isRequired,
	
	  /** Vertical offset. */
	  scrollTop: _propTypes2.default.number,
	
	  /**
	   * Row index to ensure visible (by forcefully scrolling if necessary)
	   */
	  scrollToRow: _propTypes2.default.number.isRequired,
	
	  /** Optional inline style */
	  style: _propTypes2.default.object,
	
	  /** Tab index for focus */
	  tabIndex: _propTypes2.default.number,
	
	  /**
	   * Width of Grid; this property determines the number of visible (vs virtualized) columns.
	   */
	  width: _propTypes2.default.number.isRequired
	} : void 0;

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionDataAndUpdateScrollOffset;
	/**
	 * Helper method that determines when to recalculate row or column metadata.
	 *
	 * @param cellCount Number of rows or columns in the current axis
	 * @param cellsSize Width or height of cells for the current axis
	 * @param computeMetadataCallback Method to invoke if cell metadata should be recalculated
	 * @param computeMetadataCallbackProps Parameters to pass to :computeMetadataCallback
	 * @param nextCellsCount Newly updated number of rows or columns in the current axis
	 * @param nextCellsSize Newly updated width or height of cells for the current axis
	 * @param nextScrollToIndex Newly updated scroll-to-index
	 * @param scrollToIndex Scroll-to-index
	 * @param updateScrollOffsetForScrollToIndex Callback to invoke if the scroll position should be recalculated
	 */
	function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
	  var cellCount = _ref.cellCount,
	      cellSize = _ref.cellSize,
	      computeMetadataCallback = _ref.computeMetadataCallback,
	      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
	      nextCellsCount = _ref.nextCellsCount,
	      nextCellSize = _ref.nextCellSize,
	      nextScrollToIndex = _ref.nextScrollToIndex,
	      scrollToIndex = _ref.scrollToIndex,
	      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
	
	  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
	  // In that event users should use the manual recompute methods to inform of changes.
	  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
	    computeMetadataCallback(computeMetadataCallbackProps);
	
	    // Updated cell metadata may have hidden the previous scrolled-to item.
	    // In this case we should also update the scrollTop to ensure it stays visible.
	    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
	      updateScrollOffsetForScrollToIndex();
	    }
	  }
	}

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_MAX_SCROLL_SIZE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CellSizeAndPositionManager = __webpack_require__(1328);
	
	var _CellSizeAndPositionManager2 = _interopRequireDefault(_CellSizeAndPositionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
	 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
	 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
	 */
	var DEFAULT_MAX_SCROLL_SIZE = exports.DEFAULT_MAX_SCROLL_SIZE = 1500000;
	
	/**
	 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
	 */
	
	var ScalingCellSizeAndPositionManager = function () {
	  function ScalingCellSizeAndPositionManager(_ref) {
	    var _ref$maxScrollSize = _ref.maxScrollSize,
	        maxScrollSize = _ref$maxScrollSize === undefined ? DEFAULT_MAX_SCROLL_SIZE : _ref$maxScrollSize,
	        params = _objectWithoutProperties(_ref, ['maxScrollSize']);
	
	    _classCallCheck(this, ScalingCellSizeAndPositionManager);
	
	    // Favor composition over inheritance to simplify IE10 support
	    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager2.default(params);
	    this._maxScrollSize = maxScrollSize;
	  }
	
	  _createClass(ScalingCellSizeAndPositionManager, [{
	    key: 'areOffsetsAdjusted',
	    value: function areOffsetsAdjusted() {
	      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
	    }
	  }, {
	    key: 'configure',
	    value: function configure(params) {
	      this._cellSizeAndPositionManager.configure(params);
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellSizeAndPositionManager.getCellCount();
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._cellSizeAndPositionManager.getEstimatedCellSize();
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
	    }
	
	    /**
	     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
	     * The offset passed to this function is scalled (safe) as well.
	     */
	
	  }, {
	    key: 'getOffsetAdjustment',
	    value: function getOffsetAdjustment(_ref2) {
	      var containerSize = _ref2.containerSize,
	          offset = _ref2.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	      var offsetPercentage = this._getOffsetPercentage({
	        containerSize: containerSize,
	        offset: offset,
	        totalSize: safeTotalSize
	      });
	
	      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
	    }
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
	    }
	
	    /** See CellSizeAndPositionManager#getTotalSize */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
	    }
	
	    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align,
	          align = _ref3$align === undefined ? 'auto' : _ref3$align,
	          containerSize = _ref3.containerSize,
	          currentOffset = _ref3.currentOffset,
	          targetIndex = _ref3.targetIndex,
	          totalSize = _ref3.totalSize;
	
	      currentOffset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: currentOffset
	      });
	
	      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
	        align: align,
	        containerSize: containerSize,
	        currentOffset: currentOffset,
	        targetIndex: targetIndex,
	        totalSize: totalSize
	      });
	
	      return this._offsetToSafeOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	
	    /** See CellSizeAndPositionManager#getVisibleCellRange */
	
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize,
	          offset = _ref4.offset;
	
	      offset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	
	      return this._cellSizeAndPositionManager.getVisibleCellRange({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._cellSizeAndPositionManager.resetCell(index);
	    }
	  }, {
	    key: '_getOffsetPercentage',
	    value: function _getOffsetPercentage(_ref5) {
	      var containerSize = _ref5.containerSize,
	          offset = _ref5.offset,
	          totalSize = _ref5.totalSize;
	
	      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
	    }
	  }, {
	    key: '_offsetToSafeOffset',
	    value: function _offsetToSafeOffset(_ref6) {
	      var containerSize = _ref6.containerSize,
	          offset = _ref6.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: totalSize
	        });
	
	        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
	      }
	    }
	  }, {
	    key: '_safeOffsetToOffset',
	    value: function _safeOffsetToOffset(_ref7) {
	      var containerSize = _ref7.containerSize,
	          offset = _ref7.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: safeTotalSize
	        });
	
	        return Math.round(offsetPercentage * (totalSize - containerSize));
	      }
	    }
	  }]);
	
	  return ScalingCellSizeAndPositionManager;
	}();
	
	exports.default = ScalingCellSizeAndPositionManager;

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Just-in-time calculates and caches size and position information for a collection of cells.
	 */
	var CellSizeAndPositionManager = function () {
	  function CellSizeAndPositionManager(_ref) {
	    var _ref$batchAllCells = _ref.batchAllCells,
	        batchAllCells = _ref$batchAllCells === undefined ? false : _ref$batchAllCells,
	        cellCount = _ref.cellCount,
	        cellSizeGetter = _ref.cellSizeGetter,
	        estimatedCellSize = _ref.estimatedCellSize;
	
	    _classCallCheck(this, CellSizeAndPositionManager);
	
	    this._batchAllCells = batchAllCells;
	    this._cellSizeGetter = cellSizeGetter;
	    this._cellCount = cellCount;
	    this._estimatedCellSize = estimatedCellSize;
	
	    // Cache of size and position data for cells, mapped by cell index.
	    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
	    this._cellSizeAndPositionData = {};
	
	    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
	    this._lastMeasuredIndex = -1;
	
	    // Used in deferred mode to track which cells have been queued for measurement.
	    this._lastBatchedIndex = -1;
	  }
	
	  _createClass(CellSizeAndPositionManager, [{
	    key: 'areOffsetsAdjusted',
	    value: function areOffsetsAdjusted() {
	      return false;
	    }
	  }, {
	    key: 'configure',
	    value: function configure(_ref2) {
	      var cellCount = _ref2.cellCount,
	          estimatedCellSize = _ref2.estimatedCellSize;
	
	      this._cellCount = cellCount;
	      this._estimatedCellSize = estimatedCellSize;
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellCount;
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._estimatedCellSize;
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._lastMeasuredIndex;
	    }
	  }, {
	    key: 'getOffsetAdjustment',
	    value: function getOffsetAdjustment(_ref3) {
	      var containerSize = _ref3.containerSize,
	          offset = _ref3.offset;
	
	      return 0;
	    }
	
	    /**
	     * This method returns the size and position for the cell at the specified index.
	     * It just-in-time calculates (or used cached values) for cells leading up to the index.
	     */
	
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      if (index < 0 || index >= this._cellCount) {
	        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
	      }
	
	      if (index > this._lastMeasuredIndex) {
	        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
	
	        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
	          var _size = this._cellSizeGetter({ index: i });
	
	          // undefined or NaN probably means a logic error in the size getter.
	          // null means we're using CellMeasurer and haven't yet measured a given index.
	          if (_size === undefined || isNaN(_size)) {
	            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
	          } else if (_size === null) {
	            this._cellSizeAndPositionData[i] = {
	              offset: _offset,
	              size: 0
	            };
	
	            this._lastBatchedIndex = index;
	          } else {
	            this._cellSizeAndPositionData[i] = {
	              offset: _offset,
	              size: _size
	            };
	
	            _offset += _size;
	
	            this._lastMeasuredIndex = index;
	          }
	        }
	      }
	
	      return this._cellSizeAndPositionData[index];
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
	        offset: 0,
	        size: 0
	      };
	    }
	
	    /**
	     * Total size of all cells being measured.
	     * This value will be completedly estimated initially.
	     * As cells as measured the estimate will be updated.
	     */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	
	      return lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size + (this._cellCount - this._lastMeasuredIndex - 1) * this._estimatedCellSize;
	    }
	
	    /**
	     * Determines a new offset that ensures a certain cell is visible, given the current offset.
	     * If the cell is already visible then the current offset will be returned.
	     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	     *
	     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	     * @param containerSize Size (width or height) of the container viewport
	     * @param currentOffset Container's current (x or y) offset
	     * @param totalSize Total size (width or height) of all cells
	     * @return Offset to use to ensure the specified cell is visible
	     */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref4) {
	      var _ref4$align = _ref4.align,
	          align = _ref4$align === undefined ? 'auto' : _ref4$align,
	          containerSize = _ref4.containerSize,
	          currentOffset = _ref4.currentOffset,
	          targetIndex = _ref4.targetIndex;
	
	      if (containerSize <= 0) {
	        return 0;
	      }
	
	      var datum = this.getSizeAndPositionOfCell(targetIndex);
	      var maxOffset = datum.offset;
	      var minOffset = maxOffset - containerSize + datum.size;
	
	      var idealOffset = void 0;
	
	      switch (align) {
	        case 'start':
	          idealOffset = maxOffset;
	          break;
	        case 'end':
	          idealOffset = minOffset;
	          break;
	        case 'center':
	          idealOffset = maxOffset - (containerSize - datum.size) / 2;
	          break;
	        default:
	          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
	          break;
	      }
	
	      var totalSize = this.getTotalSize();
	
	      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
	    }
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(params) {
	      // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
	      // eg we can't know a row's height without measuring the height of all columns within that row.
	      if (this._batchAllCells) {
	        return {
	          start: 0,
	          stop: this._cellCount - 1
	        };
	      }
	
	      var containerSize = params.containerSize,
	          offset = params.offset;
	
	
	      var totalSize = this.getTotalSize();
	
	      if (totalSize === 0) {
	        return {};
	      }
	
	      var maxOffset = offset + containerSize;
	      var start = this._findNearestCell(offset);
	
	      var datum = this.getSizeAndPositionOfCell(start);
	      offset = datum.offset + datum.size;
	
	      var stop = start;
	
	      while (offset < maxOffset && stop < this._cellCount - 1) {
	        stop++;
	
	        offset += this.getSizeAndPositionOfCell(stop).size;
	      }
	
	      return {
	        start: start,
	        stop: stop
	      };
	    }
	
	    /**
	     * Clear all cached values for cells after the specified index.
	     * This method should be called for any cell that has changed its size.
	     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
	     */
	
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
	    }
	  }, {
	    key: '_binarySearch',
	    value: function _binarySearch(_ref5) {
	      var high = _ref5.high,
	          low = _ref5.low,
	          offset = _ref5.offset;
	
	      var middle = void 0;
	      var currentOffset = void 0;
	
	      while (low <= high) {
	        middle = low + Math.floor((high - low) / 2);
	        currentOffset = this.getSizeAndPositionOfCell(middle).offset;
	
	        if (currentOffset === offset) {
	          return middle;
	        } else if (currentOffset < offset) {
	          low = middle + 1;
	        } else if (currentOffset > offset) {
	          high = middle - 1;
	        }
	      }
	
	      if (low > 0) {
	        return low - 1;
	      }
	    }
	  }, {
	    key: '_exponentialSearch',
	    value: function _exponentialSearch(_ref6) {
	      var index = _ref6.index,
	          offset = _ref6.offset;
	
	      var interval = 1;
	
	      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
	        index += interval;
	        interval *= 2;
	      }
	
	      return this._binarySearch({
	        high: Math.min(index, this._cellCount - 1),
	        low: Math.floor(index / 2),
	        offset: offset
	      });
	    }
	
	    /**
	     * Searches for the cell (index) nearest the specified offset.
	     *
	     * If no exact match is found the next lowest cell index will be returned.
	     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
	     */
	
	  }, {
	    key: '_findNearestCell',
	    value: function _findNearestCell(offset) {
	      if (isNaN(offset)) {
	        throw Error('Invalid offset ' + offset + ' specified');
	      }
	
	      // Our search algorithms find the nearest match at or below the specified offset.
	      // So make sure the offset is at least 0 or no match will be found.
	      offset = Math.max(0, offset);
	
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
	
	      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
	        // If we've already measured cells within this range just use a binary search as it's faster.
	        return this._binarySearch({
	          high: lastMeasuredIndex,
	          low: 0,
	          offset: offset
	        });
	      } else {
	        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
	        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
	        // The overall complexity for this approach is O(log n).
	        return this._exponentialSearch({
	          index: lastMeasuredIndex,
	          offset: offset
	        });
	      }
	    }
	  }]);
	
	  return CellSizeAndPositionManager;
	}();
	
	exports.default = CellSizeAndPositionManager;

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultOverscanIndicesGetter;
	var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
	var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;
	
	var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
	var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 *
	 * @param direction One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
	 * @param cellCount Number of rows or columns in the current axis
	 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
	 * @param overscanCellsCount Maximum number of cells to over-render in either direction
	 * @param startIndex Begin of range of visible cells
	 * @param stopIndex End of range of visible cells
	 */
	function defaultOverscanIndicesGetter(_ref) {
	  var direction = _ref.direction,
	      cellCount = _ref.cellCount,
	      overscanCellsCount = _ref.overscanCellsCount,
	      scrollDirection = _ref.scrollDirection,
	      startIndex = _ref.startIndex,
	      stopIndex = _ref.stopIndex;
	
	  var overscanStartIndex = void 0;
	  var overscanStopIndex = void 0;
	
	  switch (scrollDirection) {
	    case SCROLL_DIRECTION_FORWARD:
	      overscanStartIndex = startIndex;
	      overscanStopIndex = stopIndex + overscanCellsCount;
	      break;
	    case SCROLL_DIRECTION_BACKWARD:
	      overscanStartIndex = startIndex - overscanCellsCount;
	      overscanStopIndex = stopIndex;
	      break;
	  }
	
	  return {
	    overscanStartIndex: Math.max(0, overscanStartIndex),
	    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
	  };
	}

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateScrollIndexHelper;
	/**
	 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
	 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
	 *
	 * @param cellsSize Width or height of cells for the current axis
	 * @param cellSizeAndPositionManager Manages size and position metadata of cells
	 * @param previousCellsCount Previous number of rows or columns
	 * @param previousCellsSize Previous width or height of cells
	 * @param previousScrollToIndex Previous scroll-to-index
	 * @param previousSize Previous width or height of the virtualized container
	 * @param scrollOffset Current scrollLeft or scrollTop
	 * @param scrollToIndex Scroll-to-index
	 * @param size Width or height of the virtualized container
	 * @param updateScrollIndexCallback Callback to invoke with an scroll-to-index value
	 */
	function updateScrollIndexHelper(_ref) {
	  var cellSize = _ref.cellSize,
	      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
	      previousCellsCount = _ref.previousCellsCount,
	      previousCellSize = _ref.previousCellSize,
	      previousScrollToAlignment = _ref.previousScrollToAlignment,
	      previousScrollToIndex = _ref.previousScrollToIndex,
	      previousSize = _ref.previousSize,
	      scrollOffset = _ref.scrollOffset,
	      scrollToAlignment = _ref.scrollToAlignment,
	      scrollToIndex = _ref.scrollToIndex,
	      size = _ref.size,
	      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
	
	  var cellCount = cellSizeAndPositionManager.getCellCount();
	  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
	  var sizeHasChanged = size !== previousSize || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
	
	  // If we have a new scroll target OR if height/row-height has changed,
	  // We should ensure that the scroll target is visible.
	  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
	    updateScrollIndexCallback(scrollToIndex);
	
	    // If we don't have a selected item but list size or number of children have decreased,
	    // Make sure we aren't scrolled too far past the current content.
	  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
	    // We need to ensure that the current scroll offset is still within the collection's range.
	    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
	    // Just check to make sure we're still okay.
	    // Only adjust the scroll position if we've scrolled below the last set of rows.
	    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
	      updateScrollIndexCallback(cellCount - 1);
	    }
	  }
	}

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRangeRenderer;
	
	/**
	 * Default implementation of cellRangeRenderer used by Grid.
	 * This renderer supports cell-caching while the user is scrolling.
	 */
	function defaultCellRangeRenderer(_ref) {
	  var cellCache = _ref.cellCache,
	      cellRenderer = _ref.cellRenderer,
	      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
	      columnStartIndex = _ref.columnStartIndex,
	      columnStopIndex = _ref.columnStopIndex,
	      deferredMeasurementCache = _ref.deferredMeasurementCache,
	      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
	      isScrolling = _ref.isScrolling,
	      parent = _ref.parent,
	      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
	      rowStartIndex = _ref.rowStartIndex,
	      rowStopIndex = _ref.rowStopIndex,
	      scrollLeft = _ref.scrollLeft,
	      scrollTop = _ref.scrollTop,
	      styleCache = _ref.styleCache,
	      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
	      visibleColumnIndices = _ref.visibleColumnIndices,
	      visibleRowIndices = _ref.visibleRowIndices;
	
	  var deferredMode = typeof deferredMeasurementCache !== 'undefined';
	
	  var renderedCells = [];
	
	  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
	  // User cannot scroll beyond these size limitations.
	  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
	  // We should never cache styles for compressed offsets though as this can lead to bugs.
	  // See issue #576 for more.
	  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
	
	  var canCacheStyle = !isScrolling || !areOffsetsAdjusted;
	
	  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
	    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
	
	    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
	      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
	      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
	      var key = rowIndex + '-' + columnIndex;
	      var style = void 0;
	
	      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
	      if (canCacheStyle && styleCache[key]) {
	        style = styleCache[key];
	      } else {
	        // In deferred mode, cells will be initially rendered before we know their size.
	        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
	        if (deferredMode && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
	          // Position not-yet-measured cells at top/left 0,0,
	          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
	          // Positioning them further to the right/bottom influences their measured size.
	          style = {
	            height: 'auto',
	            left: 0,
	            position: 'absolute',
	            top: 0,
	            width: 'auto'
	          };
	        } else {
	          style = {
	            height: rowDatum.size,
	            left: columnDatum.offset + horizontalOffsetAdjustment,
	            position: 'absolute',
	            top: rowDatum.offset + verticalOffsetAdjustment,
	            width: columnDatum.size
	          };
	
	          styleCache[key] = style;
	        }
	      }
	
	      var cellRendererParams = {
	        columnIndex: columnIndex,
	        isScrolling: isScrolling,
	        isVisible: isVisible,
	        key: key,
	        parent: parent,
	        rowIndex: rowIndex,
	        style: style
	      };
	
	      var renderedCell = void 0;
	
	      // Avoid re-creating cells while scrolling.
	      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	      // If a scroll is in progress- cache and reuse cells.
	      // This cache will be thrown away once scrolling completes.
	      // However if we are scaling scroll positions and sizes, we should also avoid caching.
	      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
	      // For more info refer to issue #395
	      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
	        if (!cellCache[key]) {
	          cellCache[key] = cellRenderer(cellRendererParams);
	        }
	
	        renderedCell = cellCache[key];
	
	        // If the user is no longer scrolling, don't cache cells.
	        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
	      } else {
	        renderedCell = cellRenderer(cellRendererParams);
	      }
	
	      if (renderedCell == null || renderedCell === false) {
	        continue;
	      }
	
	      if (false) {
	        warnAboutMissingStyle(parent, renderedCell);
	      }
	
	      renderedCells.push(renderedCell);
	    }
	  }
	
	  return renderedCells;
	}
	
	function warnAboutMissingStyle(parent, renderedCell) {
	  if (false) {
	    if (renderedCell) {
	      // If the direct child is a CellMeasurer, then we should check its child
	      // See issue #611
	      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
	        renderedCell = renderedCell.props.children;
	      }
	
	      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
	        parent.__warnedAboutMissingStyle = true;
	
	        console.warn('Rendered cell should include style property for positioning.');
	      }
	    }
	  }
	}

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultOverscanIndicesGetter;
	var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
	var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;
	
	var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
	var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 *
	 * @param direction One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
	 * @param cellCount Number of rows or columns in the current axis
	 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
	 * @param overscanCellsCount Maximum number of cells to over-render in either direction
	 * @param startIndex Begin of range of visible cells
	 * @param stopIndex End of range of visible cells
	 */
	function defaultOverscanIndicesGetter(_ref) {
	  var direction = _ref.direction,
	      cellCount = _ref.cellCount,
	      overscanCellsCount = _ref.overscanCellsCount,
	      scrollDirection = _ref.scrollDirection,
	      startIndex = _ref.startIndex,
	      stopIndex = _ref.stopIndex;
	
	  var overscanStartIndex = void 0;
	  var overscanStopIndex = void 0;
	
	  // Make sure we render at least 1 cell extra before and after (except near boundaries)
	  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
	  // For more info see issues #625
	  overscanCellsCount = Math.max(1, overscanCellsCount);
	
	  switch (scrollDirection) {
	    case SCROLL_DIRECTION_FORWARD:
	      overscanStartIndex = startIndex - 1;
	      overscanStopIndex = stopIndex + overscanCellsCount;
	      break;
	    case SCROLL_DIRECTION_BACKWARD:
	      overscanStartIndex = startIndex - overscanCellsCount;
	      overscanStopIndex = stopIndex + 1;
	      break;
	  }
	
	  return {
	    overscanStartIndex: Math.max(0, overscanStartIndex),
	    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
	  };
	}

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfiniteLoader = exports.default = undefined;
	
	var _InfiniteLoader2 = __webpack_require__(1334);
	
	var _InfiniteLoader3 = _interopRequireDefault(_InfiniteLoader2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InfiniteLoader3.default;
	exports.InfiniteLoader = _InfiniteLoader3.default;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.isRangeVisible = isRangeVisible;
	exports.scanForUnloadedRanges = scanForUnloadedRanges;
	exports.forceUpdateReactVirtualizedComponent = forceUpdateReactVirtualizedComponent;
	
	var _react = __webpack_require__(300);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createCallbackMemoizer = __webpack_require__(1315);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Higher-order component that manages lazy-loading for "infinite" data.
	 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
	 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
	 */
	var InfiniteLoader = function (_PureComponent) {
	  _inherits(InfiniteLoader, _PureComponent);
	
	  function InfiniteLoader(props, context) {
	    _classCallCheck(this, InfiniteLoader);
	
	    var _this = _possibleConstructorReturn(this, (InfiniteLoader.__proto__ || Object.getPrototypeOf(InfiniteLoader)).call(this, props, context));
	
	    _this._loadMoreRowsMemoizer = (0, _createCallbackMemoizer2.default)();
	
	    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  _createClass(InfiniteLoader, [{
	    key: 'resetLoadMoreRowsCache',
	    value: function resetLoadMoreRowsCache() {
	      this._loadMoreRowsMemoizer = (0, _createCallbackMemoizer2.default)();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return children({
	        onRowsRendered: this._onRowsRendered,
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: '_loadUnloadedRanges',
	    value: function _loadUnloadedRanges(unloadedRanges) {
	      var _this2 = this;
	
	      var loadMoreRows = this.props.loadMoreRows;
	
	
	      unloadedRanges.forEach(function (unloadedRange) {
	        var promise = loadMoreRows(unloadedRange);
	        if (promise) {
	          promise.then(function () {
	            // Refresh the visible rows if any of them have just been loaded.
	            // Otherwise they will remain in their unloaded visual state.
	            if (isRangeVisible({
	              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
	              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
	              startIndex: unloadedRange.startIndex,
	              stopIndex: unloadedRange.stopIndex
	            })) {
	              if (_this2._registeredChild) {
	                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
	              }
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: '_onRowsRendered',
	    value: function _onRowsRendered(_ref) {
	      var _this3 = this;
	
	      var startIndex = _ref.startIndex,
	          stopIndex = _ref.stopIndex;
	      var _props = this.props,
	          isRowLoaded = _props.isRowLoaded,
	          minimumBatchSize = _props.minimumBatchSize,
	          rowCount = _props.rowCount,
	          threshold = _props.threshold;
	
	
	      this._lastRenderedStartIndex = startIndex;
	      this._lastRenderedStopIndex = stopIndex;
	
	      var unloadedRanges = scanForUnloadedRanges({
	        isRowLoaded: isRowLoaded,
	        minimumBatchSize: minimumBatchSize,
	        rowCount: rowCount,
	        startIndex: Math.max(0, startIndex - threshold),
	        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
	      });
	
	      // For memoize comparison
	      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
	        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
	      }, []);
	
	      this._loadMoreRowsMemoizer({
	        callback: function callback() {
	          _this3._loadUnloadedRanges(unloadedRanges);
	        },
	        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
	      });
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(registeredChild) {
	      this._registeredChild = registeredChild;
	    }
	  }]);
	
	  return InfiniteLoader;
	}(_react.PureComponent);
	
	/**
	 * Determines if the specified start/stop range is visible based on the most recently rendered range.
	 */
	
	
	InfiniteLoader.defaultProps = {
	  minimumBatchSize: 10,
	  rowCount: 0,
	  threshold: 15
	};
	exports.default = InfiniteLoader;
	 false ? InfiniteLoader.propTypes = {
	  /**
	   * Function responsible for rendering a virtualized component.
	   * This function should implement the following signature:
	   * ({ onRowsRendered, registerChild }) => PropTypes.element
	   *
	   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
	   * The :registerChild callback should be set as the virtualized component's :ref.
	   */
	  children: _propTypes2.default.func.isRequired,
	
	  /**
	   * Function responsible for tracking the loaded state of each row.
	   * It should implement the following signature: ({ index: number }): boolean
	   */
	  isRowLoaded: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback to be invoked when more rows must be loaded.
	   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
	   * The returned Promise should be resolved once row data has finished loading.
	   * It will be used to determine when to refresh the list with the newly-loaded data.
	   * This callback may be called multiple times in reaction to a single scroll event.
	   */
	  loadMoreRows: _propTypes2.default.func.isRequired,
	
	  /**
	   * Minimum number of rows to be loaded at a time.
	   * This property can be used to batch requests to reduce HTTP requests.
	   */
	  minimumBatchSize: _propTypes2.default.number.isRequired,
	
	  /**
	   * Number of rows in list; can be arbitrary high number if actual number is unknown.
	   */
	  rowCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Threshold at which to pre-fetch data.
	   * A threshold X means that data will start loading when a user scrolls within X rows.
	   * This value defaults to 15.
	   */
	  threshold: _propTypes2.default.number.isRequired
	} : void 0;
	function isRangeVisible(_ref2) {
	  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex,
	      lastRenderedStopIndex = _ref2.lastRenderedStopIndex,
	      startIndex = _ref2.startIndex,
	      stopIndex = _ref2.stopIndex;
	
	  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
	}
	
	/**
	 * Returns all of the ranges within a larger range that contain unloaded rows.
	 */
	function scanForUnloadedRanges(_ref3) {
	  var isRowLoaded = _ref3.isRowLoaded,
	      minimumBatchSize = _ref3.minimumBatchSize,
	      rowCount = _ref3.rowCount,
	      startIndex = _ref3.startIndex,
	      stopIndex = _ref3.stopIndex;
	
	  var unloadedRanges = [];
	
	  var rangeStartIndex = null;
	  var rangeStopIndex = null;
	
	  for (var index = startIndex; index <= stopIndex; index++) {
	    var loaded = isRowLoaded({ index: index });
	
	    if (!loaded) {
	      rangeStopIndex = index;
	      if (rangeStartIndex === null) {
	        rangeStartIndex = index;
	      }
	    } else if (rangeStopIndex !== null) {
	      unloadedRanges.push({
	        startIndex: rangeStartIndex,
	        stopIndex: rangeStopIndex
	      });
	
	      rangeStartIndex = rangeStopIndex = null;
	    }
	  }
	
	  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
	  // Scan forward to try filling our :minimumBatchSize.
	  if (rangeStopIndex !== null) {
	    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);
	
	    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
	      if (!isRowLoaded({ index: _index })) {
	        rangeStopIndex = _index;
	      } else {
	        break;
	      }
	    }
	
	    unloadedRanges.push({
	      startIndex: rangeStartIndex,
	      stopIndex: rangeStopIndex
	    });
	  }
	
	  // Check to see if our first range ended prematurely.
	  // In this case we should scan backwards to try filling our :minimumBatchSize.
	  if (unloadedRanges.length) {
	    var firstUnloadedRange = unloadedRanges[0];
	
	    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
	      var _index2 = firstUnloadedRange.startIndex - 1;
	
	      if (!isRowLoaded({ index: _index2 })) {
	        firstUnloadedRange.startIndex = _index2;
	      } else {
	        break;
	      }
	    }
	  }
	
	  return unloadedRanges;
	}
	
	/**
	 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
	 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
	 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
	 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
	 * Else the inner Grid will not be re-rendered and visuals may be stale.
	 *
	 * Additionally, while a Grid is scrolling the cells can be cached,
	 * So it's important to invalidate that cache by recalculating sizes
	 * before forcing a rerender.
	 */
	function forceUpdateReactVirtualizedComponent(component) {
	  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;
	
	  if (recomputeSize) {
	    recomputeSize.call(component, currentIndex);
	  } else {
	    component.forceUpdate();
	  }
	}

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.List = exports.default = undefined;
	
	var _List2 = __webpack_require__(1336);
	
	var _List3 = _interopRequireDefault(_List2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _List3.default;
	exports.List = _List3.default;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Grid = __webpack_require__(1324);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
	 * if only a few of those elements are visible. The primary purpose of this component is to improve
	 * performance by only rendering the DOM nodes that a user is able to see based on their current
	 * scroll position.
	 *
	 * This component renders a virtualized list of elements with either fixed or dynamic heights.
	 */
	var List = function (_PureComponent) {
	  _inherits(List, _PureComponent);
	
	  function List(props, context) {
	    _classCallCheck(this, List);
	
	    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props, context));
	
	    _this._cellRenderer = _this._cellRenderer.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    _this._setRef = _this._setRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      this.Grid.forceUpdate();
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      this.Grid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.recomputeGridSize({
	        rowIndex: index
	      });
	    }
	
	    /** See Grid#getOffsetForCell */
	
	  }, {
	    key: 'getOffsetForRow',
	    value: function getOffsetForRow(_ref) {
	      var alignment = _ref.alignment,
	          index = _ref.index;
	
	      var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
	        alignment: alignment,
	        rowIndex: index
	      }),
	          scrollTop = _Grid$getOffsetForCel.scrollTop;
	
	      return scrollTop;
	    }
	
	    /** See Grid#scrollToPosition */
	
	  }, {
	    key: 'scrollToPosition',
	    value: function scrollToPosition() {
	      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.scrollToPosition({ scrollTop: scrollTop });
	    }
	
	    /** See Grid#scrollToCell */
	
	  }, {
	    key: 'scrollToRow',
	    value: function scrollToRow() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.scrollToCell({
	        columnIndex: 0,
	        rowIndex: index
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          noRowsRenderer = _props.noRowsRenderer,
	          scrollToIndex = _props.scrollToIndex,
	          width = _props.width;
	
	
	      var classNames = (0, _classnames2.default)('ReactVirtualized__List', className);
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, this.props, {
	        autoContainerWidth: true,
	        cellRenderer: this._cellRenderer,
	        className: classNames,
	        columnWidth: width,
	        columnCount: 1,
	        noContentRenderer: noRowsRenderer,
	        onScroll: this._onScroll,
	        onSectionRendered: this._onSectionRendered,
	        ref: this._setRef,
	        scrollToRow: scrollToIndex
	      }));
	    }
	  }, {
	    key: '_cellRenderer',
	    value: function _cellRenderer(_ref2) {
	      var rowIndex = _ref2.rowIndex,
	          style = _ref2.style,
	          rest = _objectWithoutProperties(_ref2, ['rowIndex', 'style']);
	
	      var rowRenderer = this.props.rowRenderer;
	
	      // TRICKY The style object is sometimes cached by Grid.
	      // This prevents new style objects from bypassing shallowCompare().
	      // However as of React 16, style props are auto-frozen (at least in dev mode)
	      // Check to make sure we can still modify the style before proceeding.
	      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
	
	      var _Object$getOwnPropert = Object.getOwnPropertyDescriptor(style, 'width'),
	          writable = _Object$getOwnPropert.writable;
	
	      if (writable) {
	        // By default, List cells should be 100% width.
	        // This prevents them from flowing under a scrollbar (if present).
	        style.width = '100%';
	      }
	
	      return rowRenderer(_extends({
	        index: rowIndex,
	        style: style
	      }, rest));
	    }
	  }, {
	    key: '_setRef',
	    value: function _setRef(ref) {
	      this.Grid = ref;
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref3) {
	      var clientHeight = _ref3.clientHeight,
	          scrollHeight = _ref3.scrollHeight,
	          scrollTop = _ref3.scrollTop;
	      var onScroll = this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref4) {
	      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
	          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
	          rowStartIndex = _ref4.rowStartIndex,
	          rowStopIndex = _ref4.rowStopIndex;
	      var onRowsRendered = this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }
	  }]);
	
	  return List;
	}(_react.PureComponent);
	
	List.defaultProps = {
	  estimatedRowSize: 30,
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
	  overscanRowCount: 10,
	  scrollToAlignment: 'auto',
	  scrollToIndex: -1,
	  style: {}
	};
	exports.default = List;
	 false ? List.propTypes = {
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _propTypes2.default.bool,
	
	  /** Optional CSS class name */
	  className: _propTypes2.default.string,
	
	  /**
	   * Used to estimate the total height of a List before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _propTypes2.default.number.isRequired,
	
	  /** Height constraint for list (determines how many actual rows are rendered) */
	  height: _propTypes2.default.number.isRequired,
	
	  /** Optional renderer to be used in place of rows when rowCount is 0 */
	  noRowsRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback invoked with information about the slice of rows that were just rendered.
	   * ({ startIndex, stopIndex }): void
	   */
	  onRowsRendered: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, scrollHeight, scrollTop }): void
	   */
	  onScroll: _propTypes2.default.func.isRequired,
	
	  /** See Grid#overscanIndicesGetter */
	  overscanIndicesGetter: _propTypes2.default.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * ({ index: number }): number
	   */
	  rowHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
	
	  /** Responsible for rendering a row given an index; ({ index: number }): node */
	  rowRenderer: _propTypes2.default.func.isRequired,
	
	  /** Number of rows in list. */
	  rowCount: _propTypes2.default.number.isRequired,
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _propTypes2.default.number.isRequired,
	
	  /** Vertical offset. */
	  scrollTop: _propTypes2.default.number,
	
	  /** Optional inline style */
	  style: _propTypes2.default.object,
	
	  /** Tab index for focus */
	  tabIndex: _propTypes2.default.number,
	
	  /** Width of list */
	  width: _propTypes2.default.number.isRequired
	} : void 0;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createCellPositioner = exports.Masonry = exports.default = undefined;
	
	var _Masonry2 = __webpack_require__(1338);
	
	var _Masonry3 = _interopRequireDefault(_Masonry2);
	
	var _createCellPositioner2 = __webpack_require__(1342);
	
	var _createCellPositioner3 = _interopRequireDefault(_createCellPositioner2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Masonry3.default;
	exports.Masonry = _Masonry3.default;
	exports.createCellPositioner = _createCellPositioner3.default;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PositionCache = __webpack_require__(1339);
	
	var _PositionCache2 = _interopRequireDefault(_PositionCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
	
	/**
	 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
	 * Cell position is determined by an injected `cellPositioner` property.
	 * Windowing is vertical; this component does not support horizontal scrolling.
	 *
	 * Rendering occurs in two phases:
	 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
	 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
	 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
	 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
	 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
	 * 2) Second pass uses the external `cellPositioner` to layout cells.
	 *    At this time the positioner has access to cached size measurements for all cells.
	 *    The positions it returns are cached by Masonry for fast access later.
	 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
	 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
	 *
	 * Animation constraints:
	 *   Simple animations are supported (eg translate/slide into place on initial reveal).
	 *   More complex animations are not (eg flying from one position to another on resize).
	 *
	 * Layout constraints:
	 *   This component supports multi-column layout.
	 *   The height of each item may vary.
	 *   The width of each item must not exceed the width of the column it is "in".
	 *   The left position of all items within a column must align.
	 *   (Items may not span multiple columns.)
	 */
	
	var Masonry = function (_PureComponent) {
	  _inherits(Masonry, _PureComponent);
	
	  function Masonry(props, context) {
	    _classCallCheck(this, Masonry);
	
	    var _this = _possibleConstructorReturn(this, (Masonry.__proto__ || Object.getPrototypeOf(Masonry)).call(this, props, context));
	
	    _this._invalidateOnUpdateStartIndex = null;
	    _this._invalidateOnUpdateStopIndex = null;
	    _this._positionCache = new _PositionCache2.default();
	    _this._startIndex = null;
	    _this._startIndexMemoized = null;
	    _this._stopIndex = null;
	    _this._stopIndexMemoized = null;
	
	
	    _this.state = {
	      isScrolling: false,
	      scrollTop: 0
	    };
	
	    _this._debounceResetIsScrollingCallback = _this._debounceResetIsScrollingCallback.bind(_this);
	    _this._setScrollingContainerRef = _this._setScrollingContainerRef.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(Masonry, [{
	    key: 'clearCellPositions',
	    value: function clearCellPositions() {
	      this._positionCache = new _PositionCache2.default();
	      this.forceUpdate();
	    }
	
	    // HACK This method signature was intended for Grid
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender(_ref) {
	      var index = _ref.rowIndex;
	
	      if (this._invalidateOnUpdateStartIndex === null) {
	        this._invalidateOnUpdateStartIndex = index;
	        this._invalidateOnUpdateStopIndex = index;
	      } else {
	        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
	        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
	      }
	    }
	  }, {
	    key: 'recomputeCellPositions',
	    value: function recomputeCellPositions() {
	      var stopIndex = this._positionCache.count - 1;
	
	      this._positionCache = new _PositionCache2.default();
	      this._populatePositionCache(0, stopIndex);
	
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._checkInvalidateOnUpdate();
	      this._invokeOnScrollCallback();
	      this._invokeOnCellsRenderedCallback();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      this._checkInvalidateOnUpdate();
	      this._invokeOnScrollCallback();
	      this._invokeOnCellsRenderedCallback();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._debounceResetIsScrollingId) {
	        clearTimeout(this._debounceResetIsScrollingId);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var scrollTop = this.props.scrollTop;
	
	
	      if (scrollTop !== nextProps.scrollTop) {
	        this._debounceResetIsScrolling();
	
	        this.setState({
	          isScrolling: true,
	          scrollTop: nextProps.scrollTop
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          autoHeight = _props.autoHeight,
	          cellCount = _props.cellCount,
	          cellMeasurerCache = _props.cellMeasurerCache,
	          cellRenderer = _props.cellRenderer,
	          className = _props.className,
	          height = _props.height,
	          id = _props.id,
	          keyMapper = _props.keyMapper,
	          overscanByPixels = _props.overscanByPixels,
	          role = _props.role,
	          style = _props.style,
	          tabIndex = _props.tabIndex,
	          width = _props.width;
	      var _state = this.state,
	          isScrolling = _state.isScrolling,
	          scrollTop = _state.scrollTop;
	
	
	      var children = [];
	
	      var estimateTotalHeight = this._getEstimatedTotalHeight();
	
	      var shortestColumnSize = this._positionCache.shortestColumnSize;
	      var measuredCellCount = this._positionCache.count;
	
	      // We need to measure more cells before layout
	      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
	        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));
	
	        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
	          children.push(cellRenderer({
	            index: _index,
	            isScrolling: isScrolling,
	            key: keyMapper(_index),
	            parent: this,
	            style: {
	              width: cellMeasurerCache.getWidth(_index)
	            }
	          }));
	        }
	      } else {
	        (function () {
	          var stopIndex = void 0;
	          var startIndex = void 0;
	
	          _this2._positionCache.range(scrollTop - overscanByPixels, height + overscanByPixels, function (index, left, top) {
	            if (typeof startIndex === 'undefined') {
	              startIndex = index;
	              stopIndex = index;
	            } else {
	              startIndex = Math.min(startIndex, index);
	              stopIndex = Math.max(stopIndex, index);
	            }
	
	            children.push(cellRenderer({
	              index: index,
	              isScrolling: isScrolling,
	              key: keyMapper(index),
	              parent: _this2,
	              style: {
	                height: cellMeasurerCache.getHeight(index),
	                left: left,
	                position: 'absolute',
	                top: top,
	                width: cellMeasurerCache.getWidth(index)
	              }
	            }));
	
	            _this2._startIndex = startIndex;
	            _this2._stopIndex = stopIndex;
	          });
	        })();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setScrollingContainerRef,
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Masonry', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: role,
	          style: _extends({
	            boxSizing: 'border-box',
	            direction: 'ltr',
	            height: autoHeight ? 'auto' : height,
	            overflowX: 'hidden',
	            overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
	            position: 'relative',
	            width: width,
	            WebkitOverflowScrolling: 'touch',
	            willChange: 'transform'
	          }, style),
	          tabIndex: tabIndex
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Masonry__innerScrollContainer',
	            style: {
	              width: '100%',
	              height: estimateTotalHeight,
	              maxWidth: '100%',
	              maxHeight: estimateTotalHeight,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : '',
	              position: 'relative'
	            }
	          },
	          children
	        )
	      );
	    }
	  }, {
	    key: '_checkInvalidateOnUpdate',
	    value: function _checkInvalidateOnUpdate() {
	      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
	        var _startIndex = this._invalidateOnUpdateStartIndex;
	        var _stopIndex = this._invalidateOnUpdateStopIndex;
	
	        this._invalidateOnUpdateStartIndex = null;
	        this._invalidateOnUpdateStopIndex = null;
	
	        // Query external layout logic for position of newly-measured cells
	        this._populatePositionCache(_startIndex, _stopIndex);
	
	        this.forceUpdate();
	      }
	    }
	  }, {
	    key: '_debounceResetIsScrolling',
	    value: function _debounceResetIsScrolling() {
	      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
	
	
	      if (this._debounceResetIsScrollingId) {
	        clearTimeout(this._debounceResetIsScrollingId);
	      }
	
	      this._debounceResetIsScrollingId = setTimeout(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
	    }
	  }, {
	    key: '_debounceResetIsScrollingCallback',
	    value: function _debounceResetIsScrollingCallback() {
	      this.setState({
	        isScrolling: false
	      });
	    }
	  }, {
	    key: '_getEstimatedTotalHeight',
	    value: function _getEstimatedTotalHeight() {
	      var _props2 = this.props,
	          cellCount = _props2.cellCount,
	          cellMeasurerCache = _props2.cellMeasurerCache,
	          width = _props2.width;
	
	
	      var estimatedColumnCount = Math.floor(width / cellMeasurerCache.defaultWidth);
	
	      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
	    }
	  }, {
	    key: '_invokeOnScrollCallback',
	    value: function _invokeOnScrollCallback() {
	      var _props3 = this.props,
	          height = _props3.height,
	          onScroll = _props3.onScroll;
	      var scrollTop = this.state.scrollTop;
	
	
	      if (this._onScrollMemoized !== scrollTop) {
	        onScroll({
	          clientHeight: height,
	          scrollHeight: this._getEstimatedTotalHeight(),
	          scrollTop: scrollTop
	        });
	
	        this._onScrollMemoized = scrollTop;
	      }
	    }
	  }, {
	    key: '_invokeOnCellsRenderedCallback',
	    value: function _invokeOnCellsRenderedCallback() {
	      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
	        var _onCellsRendered = this.props.onCellsRendered;
	
	
	        _onCellsRendered({
	          startIndex: this._startIndex,
	          stopIndex: this._stopIndex
	        });
	
	        this._startIndexMemoized = this._startIndex;
	        this._stopIndexMemoized = this._stopIndex;
	      }
	    }
	  }, {
	    key: '_populatePositionCache',
	    value: function _populatePositionCache(startIndex, stopIndex) {
	      var _props4 = this.props,
	          cellMeasurerCache = _props4.cellMeasurerCache,
	          cellPositioner = _props4.cellPositioner;
	
	
	      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
	        var _cellPositioner = cellPositioner(_index2),
	            _left = _cellPositioner.left,
	            _top = _cellPositioner.top;
	
	        this._positionCache.setPosition(_index2, _left, _top, cellMeasurerCache.getHeight(_index2));
	      }
	    }
	  }, {
	    key: '_setScrollingContainerRef',
	    value: function _setScrollingContainerRef(ref) {
	      this._scrollingContainer = ref;
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      var height = this.props.height;
	
	
	      var eventScrollTop = event.target.scrollTop;
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
	      var scrollTop = Math.min(Math.max(0, this._getEstimatedTotalHeight() - height), eventScrollTop);
	
	      // On iOS, we can arrive at negative offsets by swiping past the start or end.
	      // Avoid re-rendering in this case as it can cause problems; see #532 for more.
	      if (eventScrollTop !== scrollTop) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._debounceResetIsScrolling();
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollTop !== scrollTop) {
	        this.setState({
	          isScrolling: true,
	          scrollTop: scrollTop
	        });
	      }
	    }
	  }]);
	
	  return Masonry;
	}(_react.PureComponent);
	
	Masonry.defaultProps = {
	  autoHeight: false,
	  keyMapper: identity,
	  onCellsRendered: noop,
	  onScroll: noop,
	  overscanByPixels: 20,
	  role: 'grid',
	  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
	  style: emptyObject,
	  tabIndex: 0
	};
	exports.default = Masonry;
	
	
	var emptyObject = {};
	
	function identity(value) {
	  return value;
	}
	
	function noop() {}

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _intervalTree = __webpack_require__(1340);
	
	var _intervalTree2 = _interopRequireDefault(_intervalTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Position cache requirements:
	//   O(log(n)) lookup of cells to render for a given viewport size
	//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
	var PositionCache = function () {
	  function PositionCache() {
	    _classCallCheck(this, PositionCache);
	
	    this._columnSizeMap = {};
	    this._intervalTree = (0, _intervalTree2.default)();
	    this._leftMap = {};
	  }
	  // Tracks the height of each column
	
	
	  // Store tops and bottoms of each cell for fast intersection lookup.
	
	
	  // Maps cell index to x coordinates for quick lookup.
	
	
	  _createClass(PositionCache, [{
	    key: 'estimateTotalHeight',
	    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
	      var unmeasuredCellCount = cellCount - this.count;
	      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
	    }
	
	    // Render all cells visible within the viewport range defined.
	
	  }, {
	    key: 'range',
	    value: function range(scrollTop, clientHeight, renderCallback) {
	      var _this = this;
	
	      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 3),
	            top = _ref2[0],
	            _ = _ref2[1],
	            index = _ref2[2];
	
	        return renderCallback(index, _this._leftMap[index], top);
	      });
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(index, left, top, height) {
	      this._intervalTree.insert([top, top + height, index]);
	      this._leftMap[index] = left;
	
	      var columnSizeMap = this._columnSizeMap;
	      var columnHeight = columnSizeMap[left];
	      if (columnHeight === undefined) {
	        columnSizeMap[left] = top + height;
	      } else {
	        columnSizeMap[left] = Math.max(columnHeight, top + height);
	      }
	    }
	  }, {
	    key: 'count',
	    get: function get() {
	      return this._intervalTree.count;
	    }
	  }, {
	    key: 'shortestColumnSize',
	    get: function get() {
	      var columnSizeMap = this._columnSizeMap;
	
	      var size = 0;
	
	      for (var i in columnSizeMap) {
	        var height = columnSizeMap[i];
	        size = size === 0 ? height : Math.min(size, height);
	      }
	
	      return size;
	    }
	  }, {
	    key: 'tallestColumnSize',
	    get: function get() {
	      var columnSizeMap = this._columnSizeMap;
	
	      var size = 0;
	
	      for (var i in columnSizeMap) {
	        var height = columnSizeMap[i];
	        size = Math.max(size, height);
	      }
	
	      return size;
	    }
	  }]);
	
	  return PositionCache;
	}();
	
	exports.default = PositionCache;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createWrapper;
	
	var _binarySearchBounds = __webpack_require__(1341);
	
	var _binarySearchBounds2 = _interopRequireDefault(_binarySearchBounds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NOT_FOUND = 0; /**
	                    * Binary Search Bounds
	                    * https://github.com/mikolalysenko/interval-tree-1d
	                    * Mikola Lysenko
	                    *
	                    * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
	                    * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
	                    **/
	
	var SUCCESS = 1;
	var EMPTY = 2;
	
	function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
	  this.mid = mid;
	  this.left = left;
	  this.right = right;
	  this.leftPoints = leftPoints;
	  this.rightPoints = rightPoints;
	  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
	}
	
	var proto = IntervalTreeNode.prototype;
	
	function copy(a, b) {
	  a.mid = b.mid;
	  a.left = b.left;
	  a.right = b.right;
	  a.leftPoints = b.leftPoints;
	  a.rightPoints = b.rightPoints;
	  a.count = b.count;
	}
	
	function rebuild(node, intervals) {
	  var ntree = createIntervalTree(intervals);
	  node.mid = ntree.mid;
	  node.left = ntree.left;
	  node.right = ntree.right;
	  node.leftPoints = ntree.leftPoints;
	  node.rightPoints = ntree.rightPoints;
	  node.count = ntree.count;
	}
	
	function rebuildWithInterval(node, interval) {
	  var intervals = node.intervals([]);
	  intervals.push(interval);
	  rebuild(node, intervals);
	}
	
	function rebuildWithoutInterval(node, interval) {
	  var intervals = node.intervals([]);
	  var idx = intervals.indexOf(interval);
	  if (idx < 0) {
	    return NOT_FOUND;
	  }
	  intervals.splice(idx, 1);
	  rebuild(node, intervals);
	  return SUCCESS;
	}
	
	proto.intervals = function (result) {
	  result.push.apply(result, this.leftPoints);
	  if (this.left) {
	    this.left.intervals(result);
	  }
	  if (this.right) {
	    this.right.intervals(result);
	  }
	  return result;
	};
	
	proto.insert = function (interval) {
	  var weight = this.count - this.leftPoints.length;
	  this.count += 1;
	  if (interval[1] < this.mid) {
	    if (this.left) {
	      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
	        rebuildWithInterval(this, interval);
	      } else {
	        this.left.insert(interval);
	      }
	    } else {
	      this.left = createIntervalTree([interval]);
	    }
	  } else if (interval[0] > this.mid) {
	    if (this.right) {
	      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
	        rebuildWithInterval(this, interval);
	      } else {
	        this.right.insert(interval);
	      }
	    } else {
	      this.right = createIntervalTree([interval]);
	    }
	  } else {
	    var l = _binarySearchBounds2.default.ge(this.leftPoints, interval, compareBegin);
	    var r = _binarySearchBounds2.default.ge(this.rightPoints, interval, compareEnd);
	    this.leftPoints.splice(l, 0, interval);
	    this.rightPoints.splice(r, 0, interval);
	  }
	};
	
	proto.remove = function (interval) {
	  var weight = this.count - this.leftPoints;
	  if (interval[1] < this.mid) {
	    if (!this.left) {
	      return NOT_FOUND;
	    }
	    var rw = this.right ? this.right.count : 0;
	    if (4 * rw > 3 * (weight - 1)) {
	      return rebuildWithoutInterval(this, interval);
	    }
	    var r = this.left.remove(interval);
	    if (r === EMPTY) {
	      this.left = null;
	      this.count -= 1;
	      return SUCCESS;
	    } else if (r === SUCCESS) {
	      this.count -= 1;
	    }
	    return r;
	  } else if (interval[0] > this.mid) {
	    if (!this.right) {
	      return NOT_FOUND;
	    }
	    var lw = this.left ? this.left.count : 0;
	    if (4 * lw > 3 * (weight - 1)) {
	      return rebuildWithoutInterval(this, interval);
	    }
	    var r = this.right.remove(interval);
	    if (r === EMPTY) {
	      this.right = null;
	      this.count -= 1;
	      return SUCCESS;
	    } else if (r === SUCCESS) {
	      this.count -= 1;
	    }
	    return r;
	  } else {
	    if (this.count === 1) {
	      if (this.leftPoints[0] === interval) {
	        return EMPTY;
	      } else {
	        return NOT_FOUND;
	      }
	    }
	    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
	      if (this.left && this.right) {
	        var p = this;
	        var n = this.left;
	        while (n.right) {
	          p = n;
	          n = n.right;
	        }
	        if (p === this) {
	          n.right = this.right;
	        } else {
	          var l = this.left;
	          var r = this.right;
	          p.count -= n.count;
	          p.right = n.left;
	          n.left = l;
	          n.right = r;
	        }
	        copy(this, n);
	        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
	      } else if (this.left) {
	        copy(this, this.left);
	      } else {
	        copy(this, this.right);
	      }
	      return SUCCESS;
	    }
	    for (var l = _binarySearchBounds2.default.ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
	      if (this.leftPoints[l][0] !== interval[0]) {
	        break;
	      }
	      if (this.leftPoints[l] === interval) {
	        this.count -= 1;
	        this.leftPoints.splice(l, 1);
	        for (var r = _binarySearchBounds2.default.ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
	          if (this.rightPoints[r][1] !== interval[1]) {
	            break;
	          } else if (this.rightPoints[r] === interval) {
	            this.rightPoints.splice(r, 1);
	            return SUCCESS;
	          }
	        }
	      }
	    }
	    return NOT_FOUND;
	  }
	};
	
	function reportLeftRange(arr, hi, cb) {
	  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
	    var r = cb(arr[i]);
	    if (r) {
	      return r;
	    }
	  }
	}
	
	function reportRightRange(arr, lo, cb) {
	  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
	    var r = cb(arr[i]);
	    if (r) {
	      return r;
	    }
	  }
	}
	
	function reportRange(arr, cb) {
	  for (var i = 0; i < arr.length; ++i) {
	    var r = cb(arr[i]);
	    if (r) {
	      return r;
	    }
	  }
	}
	
	proto.queryPoint = function (x, cb) {
	  if (x < this.mid) {
	    if (this.left) {
	      var r = this.left.queryPoint(x, cb);
	      if (r) {
	        return r;
	      }
	    }
	    return reportLeftRange(this.leftPoints, x, cb);
	  } else if (x > this.mid) {
	    if (this.right) {
	      var r = this.right.queryPoint(x, cb);
	      if (r) {
	        return r;
	      }
	    }
	    return reportRightRange(this.rightPoints, x, cb);
	  } else {
	    return reportRange(this.leftPoints, cb);
	  }
	};
	
	proto.queryInterval = function (lo, hi, cb) {
	  if (lo < this.mid && this.left) {
	    var r = this.left.queryInterval(lo, hi, cb);
	    if (r) {
	      return r;
	    }
	  }
	  if (hi > this.mid && this.right) {
	    var r = this.right.queryInterval(lo, hi, cb);
	    if (r) {
	      return r;
	    }
	  }
	  if (hi < this.mid) {
	    return reportLeftRange(this.leftPoints, hi, cb);
	  } else if (lo > this.mid) {
	    return reportRightRange(this.rightPoints, lo, cb);
	  } else {
	    return reportRange(this.leftPoints, cb);
	  }
	};
	
	function compareNumbers(a, b) {
	  return a - b;
	}
	
	function compareBegin(a, b) {
	  var d = a[0] - b[0];
	  if (d) {
	    return d;
	  }
	  return a[1] - b[1];
	}
	
	function compareEnd(a, b) {
	  var d = a[1] - b[1];
	  if (d) {
	    return d;
	  }
	  return a[0] - b[0];
	}
	
	function createIntervalTree(intervals) {
	  if (intervals.length === 0) {
	    return null;
	  }
	  var pts = [];
	  for (var i = 0; i < intervals.length; ++i) {
	    pts.push(intervals[i][0], intervals[i][1]);
	  }
	  pts.sort(compareNumbers);
	
	  var mid = pts[pts.length >> 1];
	
	  var leftIntervals = [];
	  var rightIntervals = [];
	  var centerIntervals = [];
	  for (var i = 0; i < intervals.length; ++i) {
	    var s = intervals[i];
	    if (s[1] < mid) {
	      leftIntervals.push(s);
	    } else if (mid < s[0]) {
	      rightIntervals.push(s);
	    } else {
	      centerIntervals.push(s);
	    }
	  }
	
	  //Split center intervals
	  var leftPoints = centerIntervals;
	  var rightPoints = centerIntervals.slice();
	  leftPoints.sort(compareBegin);
	  rightPoints.sort(compareEnd);
	
	  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
	}
	
	//User friendly wrapper that makes it possible to support empty trees
	function IntervalTree(root) {
	  this.root = root;
	}
	
	var tproto = IntervalTree.prototype;
	
	tproto.insert = function (interval) {
	  if (this.root) {
	    this.root.insert(interval);
	  } else {
	    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
	  }
	};
	
	tproto.remove = function (interval) {
	  if (this.root) {
	    var r = this.root.remove(interval);
	    if (r === EMPTY) {
	      this.root = null;
	    }
	    return r !== NOT_FOUND;
	  }
	  return false;
	};
	
	tproto.queryPoint = function (p, cb) {
	  if (this.root) {
	    return this.root.queryPoint(p, cb);
	  }
	};
	
	tproto.queryInterval = function (lo, hi, cb) {
	  if (lo <= hi && this.root) {
	    return this.root.queryInterval(lo, hi, cb);
	  }
	};
	
	Object.defineProperty(tproto, "count", {
	  get: function get() {
	    if (this.root) {
	      return this.root.count;
	    }
	    return 0;
	  }
	});
	
	Object.defineProperty(tproto, "intervals", {
	  get: function get() {
	    if (this.root) {
	      return this.root.intervals([]);
	    }
	    return [];
	  }
	});
	
	function createWrapper(intervals) {
	  if (!intervals || intervals.length === 0) {
	    return new IntervalTree(null);
	  }
	  return new IntervalTree(createIntervalTree(intervals));
	}

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Binary Search Bounds
	 * https://github.com/mikolalysenko/binary-search-bounds
	 * Mikola Lysenko
	 *
	 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
	 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
	 **/
	
	function _GEA(a, l, h, y) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x >= y) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function _GEP(a, l, h, y, c) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) >= 0) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchGE(a, y, c, l, h) {
	  if (typeof c === "function") {
	    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _GTA(a, l, h, y) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x > y) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function _GTP(a, l, h, y, c) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) > 0) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchGT(a, y, c, l, h) {
	  if (typeof c === "function") {
	    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _LTA(a, l, h, y) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x < y) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function _LTP(a, l, h, y, c) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) < 0) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchLT(a, y, c, l, h) {
	  if (typeof c === "function") {
	    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _LEA(a, l, h, y) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x <= y) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function _LEP(a, l, h, y, c) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) <= 0) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchLE(a, y, c, l, h) {
	  if (typeof c === "function") {
	    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _EQA(a, l, h, y) {
	  l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x === y) {
	      return m;
	    } else if (x <= y) {
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return -1;
	}
	function _EQP(a, l, h, y, c) {
	  l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    var p = c(x, y);
	    if (p === 0) {
	      return m;
	    } else if (p <= 0) {
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return -1;
	}
	function dispatchBsearchEQ(a, y, c, l, h) {
	  if (typeof c === "function") {
	    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	exports.default = {
	  ge: dispatchBsearchGE,
	  gt: dispatchBsearchGT,
	  lt: dispatchBsearchLT,
	  le: dispatchBsearchLE,
	  eq: dispatchBsearchEQ
	};

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createCellPositioner;
	function createCellPositioner(_ref) {
	  var cellMeasurerCache = _ref.cellMeasurerCache,
	      columnCount = _ref.columnCount,
	      columnWidth = _ref.columnWidth,
	      _ref$spacer = _ref.spacer,
	      spacer = _ref$spacer === undefined ? 0 : _ref$spacer;
	
	  var columnHeights = void 0;
	
	  initOrResetDerivedValues();
	
	  function cellPositioner(index) {
	    // Find the shortest column and use it.
	    var columnIndex = 0;
	    for (var i = 1; i < columnHeights.length; i++) {
	      if (columnHeights[i] < columnHeights[columnIndex]) {
	        columnIndex = i;
	      }
	    }
	
	    var left = columnIndex * (columnWidth + spacer);
	    var top = columnHeights[columnIndex] || 0;
	
	    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;
	
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  function initOrResetDerivedValues() {
	    // Track the height of each column.
	    // Layout algorithm below always inserts into the shortest column.
	    columnHeights = [];
	    for (var i = 0; i < columnCount; i++) {
	      columnHeights[i] = 0;
	    }
	  }
	
	  function reset(params) {
	    columnCount = params.columnCount;
	    columnWidth = params.columnWidth;
	    spacer = params.spacer;
	
	    initOrResetDerivedValues();
	  }
	
	  cellPositioner.reset = reset;
	
	  return cellPositioner;
	}

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MultiGrid = exports.default = undefined;
	
	var _MultiGrid2 = __webpack_require__(1344);
	
	var _MultiGrid3 = _interopRequireDefault(_MultiGrid2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MultiGrid3.default;
	exports.MultiGrid = _MultiGrid3.default;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(1324);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SCROLLBAR_SIZE_BUFFER = 20;
	
	/**
	 * Renders 1, 2, or 4 Grids depending on configuration.
	 * A main (body) Grid will always be rendered.
	 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
	 * If no sticky columns, only 1 sticky header Grid will be rendered.
	 * If sticky columns, 2 sticky header Grids will be rendered.
	 */
	
	var MultiGrid = function (_PureComponent) {
	  _inherits(MultiGrid, _PureComponent);
	
	  function MultiGrid(props, context) {
	    _classCallCheck(this, MultiGrid);
	
	    var _this = _possibleConstructorReturn(this, (MultiGrid.__proto__ || Object.getPrototypeOf(MultiGrid)).call(this, props, context));
	
	    _this.state = {
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    _this._deferredInvalidateColumnIndex = null;
	    _this._deferredInvalidateRowIndex = null;
	
	    _this._bottomLeftGridRef = _this._bottomLeftGridRef.bind(_this);
	    _this._bottomRightGridRef = _this._bottomRightGridRef.bind(_this);
	    _this._cellRendererBottomLeftGrid = _this._cellRendererBottomLeftGrid.bind(_this);
	    _this._cellRendererBottomRightGrid = _this._cellRendererBottomRightGrid.bind(_this);
	    _this._cellRendererTopRightGrid = _this._cellRendererTopRightGrid.bind(_this);
	    _this._columnWidthRightGrid = _this._columnWidthRightGrid.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._rowHeightBottomGrid = _this._rowHeightBottomGrid.bind(_this);
	    _this._topLeftGridRef = _this._topLeftGridRef.bind(_this);
	    _this._topRightGridRef = _this._topRightGridRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(MultiGrid, [{
	    key: 'forceUpdateGrids',
	    value: function forceUpdateGrids() {
	      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
	      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
	      this._topLeftGrid && this._topLeftGrid.forceUpdate();
	      this._topRightGrid && this._topRightGrid.forceUpdate();
	    }
	
	    /** See Grid#invalidateCellSizeAfterRender */
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$columnIndex = _ref.columnIndex,
	          columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex,
	          _ref$rowIndex = _ref.rowIndex,
	          rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;
	
	      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
	      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
	      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
	      this._topLeftGrid && this._topLeftGrid.measureAllCells();
	      this._topRightGrid && this._topRightGrid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$columnIndex = _ref2.columnIndex,
	          columnIndex = _ref2$columnIndex === undefined ? 0 : _ref2$columnIndex,
	          _ref2$rowIndex = _ref2.rowIndex,
	          rowIndex = _ref2$rowIndex === undefined ? 0 : _ref2$rowIndex;
	
	      var _props = this.props,
	          fixedColumnCount = _props.fixedColumnCount,
	          fixedRowCount = _props.fixedRowCount;
	
	
	      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
	      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
	
	      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
	        columnIndex: columnIndex,
	        rowIndex: adjustedRowIndex
	      });
	      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
	        columnIndex: adjustedColumnIndex,
	        rowIndex: adjustedRowIndex
	      });
	      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
	        columnIndex: columnIndex,
	        rowIndex: rowIndex
	      });
	      this._topRightGrid && this._topRightGrid.recomputeGridSize({
	        columnIndex: adjustedColumnIndex,
	        rowIndex: rowIndex
	      });
	
	      this._leftGridWidth = null;
	      this._topGridHeight = null;
	      this._maybeCalculateCachedStyles(null, this.props, null, this.state);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props2 = this.props,
	          scrollLeft = _props2.scrollLeft,
	          scrollTop = _props2.scrollTop;
	
	
	      if (scrollLeft > 0 || scrollTop > 0) {
	        var newState = {};
	
	        if (scrollLeft > 0) {
	          newState.scrollLeft = scrollLeft;
	        }
	
	        if (scrollTop > 0) {
	          newState.scrollTop = scrollTop;
	        }
	
	        this.setState(newState);
	      }
	      this._handleInvalidatedGridSize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      this._handleInvalidatedGridSize();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this._maybeCalculateCachedStyles(null, this.props, null, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextState) {
	      var _props3 = this.props,
	          columnWidth = _props3.columnWidth,
	          fixedColumnCount = _props3.fixedColumnCount,
	          fixedRowCount = _props3.fixedRowCount,
	          rowHeight = _props3.rowHeight;
	
	
	      if (columnWidth !== nextProps.columnWidth || fixedColumnCount !== nextProps.fixedColumnCount) {
	        this._leftGridWidth = null;
	      }
	
	      if (fixedRowCount !== nextProps.fixedRowCount || rowHeight !== nextProps.rowHeight) {
	        this._topGridHeight = null;
	      }
	
	      if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        var newState = {};
	
	        if (nextProps.scrollLeft != null && nextProps.scrollLeft >= 0) {
	          newState.scrollLeft = nextProps.scrollLeft;
	        }
	
	        if (nextProps.scrollTop != null && nextProps.scrollTop >= 0) {
	          newState.scrollTop = nextProps.scrollTop;
	        }
	
	        this.setState(newState);
	      }
	
	      this._maybeCalculateCachedStyles(this.props, nextProps, this.state, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          onScroll = _props4.onScroll,
	          onSectionRendered = _props4.onSectionRendered,
	          scrollLeftProp = _props4.scrollLeft,
	          scrollToColumn = _props4.scrollToColumn,
	          scrollTopProp = _props4.scrollTop,
	          scrollToRow = _props4.scrollToRow,
	          rest = _objectWithoutProperties(_props4, ['onScroll', 'onSectionRendered', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);
	
	      // Don't render any of our Grids if there are no cells.
	      // This mirrors what Grid does,
	      // And prevents us from recording inaccurage measurements when used with CellMeasurer.
	
	
	      if (this.props.width === 0 || this.props.height === 0) {
	        return null;
	      }
	
	      // scrollTop and scrollLeft props are explicitly filtered out and ignored
	
	      var _state = this.state,
	          scrollLeft = _state.scrollLeft,
	          scrollTop = _state.scrollTop;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: this._containerOuterStyle },
	        _react2.default.createElement(
	          'div',
	          { style: this._containerTopStyle },
	          this._renderTopLeftGrid(rest),
	          this._renderTopRightGrid(_extends({}, rest, {
	            scrollLeft: scrollLeft
	          }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: this._containerBottomStyle },
	          this._renderBottomLeftGrid(_extends({}, rest, {
	            scrollTop: scrollTop
	          })),
	          this._renderBottomRightGrid(_extends({}, rest, {
	            onScroll: onScroll,
	            onSectionRendered: onSectionRendered,
	            scrollLeft: scrollLeft,
	            scrollToColumn: scrollToColumn,
	            scrollToRow: scrollToRow,
	            scrollTop: scrollTop
	          }))
	        )
	      );
	    }
	  }, {
	    key: '_bottomLeftGridRef',
	    value: function _bottomLeftGridRef(ref) {
	      this._bottomLeftGrid = ref;
	    }
	  }, {
	    key: '_bottomRightGridRef',
	    value: function _bottomRightGridRef(ref) {
	      this._bottomRightGrid = ref;
	    }
	  }, {
	    key: '_cellRendererBottomLeftGrid',
	    value: function _cellRendererBottomLeftGrid(_ref3) {
	      var rowIndex = _ref3.rowIndex,
	          rest = _objectWithoutProperties(_ref3, ['rowIndex']);
	
	      var _props5 = this.props,
	          cellRenderer = _props5.cellRenderer,
	          fixedRowCount = _props5.fixedRowCount,
	          rowCount = _props5.rowCount;
	
	
	      if (rowIndex === rowCount - fixedRowCount) {
	        return _react2.default.createElement('div', {
	          key: rest.key,
	          style: _extends({}, rest.style, {
	            height: SCROLLBAR_SIZE_BUFFER
	          })
	        });
	      } else {
	        return cellRenderer(_extends({}, rest, {
	          parent: this,
	          rowIndex: rowIndex + fixedRowCount
	        }));
	      }
	    }
	  }, {
	    key: '_cellRendererBottomRightGrid',
	    value: function _cellRendererBottomRightGrid(_ref4) {
	      var columnIndex = _ref4.columnIndex,
	          rowIndex = _ref4.rowIndex,
	          rest = _objectWithoutProperties(_ref4, ['columnIndex', 'rowIndex']);
	
	      var _props6 = this.props,
	          cellRenderer = _props6.cellRenderer,
	          fixedColumnCount = _props6.fixedColumnCount,
	          fixedRowCount = _props6.fixedRowCount;
	
	
	      return cellRenderer(_extends({}, rest, {
	        columnIndex: columnIndex + fixedColumnCount,
	        parent: this,
	        rowIndex: rowIndex + fixedRowCount
	      }));
	    }
	  }, {
	    key: '_cellRendererTopRightGrid',
	    value: function _cellRendererTopRightGrid(_ref5) {
	      var columnIndex = _ref5.columnIndex,
	          rest = _objectWithoutProperties(_ref5, ['columnIndex']);
	
	      var _props7 = this.props,
	          cellRenderer = _props7.cellRenderer,
	          columnCount = _props7.columnCount,
	          fixedColumnCount = _props7.fixedColumnCount;
	
	
	      if (columnIndex === columnCount - fixedColumnCount) {
	        return _react2.default.createElement('div', {
	          key: rest.key,
	          style: _extends({}, rest.style, {
	            width: SCROLLBAR_SIZE_BUFFER
	          })
	        });
	      } else {
	        return cellRenderer(_extends({}, rest, {
	          columnIndex: columnIndex + fixedColumnCount,
	          parent: this
	        }));
	      }
	    }
	  }, {
	    key: '_columnWidthRightGrid',
	    value: function _columnWidthRightGrid(_ref6) {
	      var index = _ref6.index;
	      var _props8 = this.props,
	          columnCount = _props8.columnCount,
	          fixedColumnCount = _props8.fixedColumnCount,
	          columnWidth = _props8.columnWidth;
	
	      // An extra cell is added to the count
	      // This gives the smaller Grid extra room for offset,
	      // In case the main (bottom right) Grid has a scrollbar
	      // If no scrollbar, the extra space is overflow:hidden anyway
	
	      if (index === columnCount - fixedColumnCount) {
	        return SCROLLBAR_SIZE_BUFFER;
	      }
	
	      return typeof columnWidth === 'function' ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
	    }
	  }, {
	    key: '_getBottomGridHeight',
	    value: function _getBottomGridHeight(props) {
	      var height = props.height;
	
	
	      var topGridHeight = this._getTopGridHeight(props);
	
	      return height - topGridHeight;
	    }
	  }, {
	    key: '_getLeftGridWidth',
	    value: function _getLeftGridWidth(props) {
	      var fixedColumnCount = props.fixedColumnCount,
	          columnWidth = props.columnWidth;
	
	
	      if (this._leftGridWidth == null) {
	        if (typeof columnWidth === 'function') {
	          var leftGridWidth = 0;
	
	          for (var index = 0; index < fixedColumnCount; index++) {
	            leftGridWidth += columnWidth({ index: index });
	          }
	
	          this._leftGridWidth = leftGridWidth;
	        } else {
	          this._leftGridWidth = columnWidth * fixedColumnCount;
	        }
	      }
	
	      return this._leftGridWidth;
	    }
	  }, {
	    key: '_getRightGridWidth',
	    value: function _getRightGridWidth(props) {
	      var width = props.width;
	
	
	      var leftGridWidth = this._getLeftGridWidth(props);
	
	      return width - leftGridWidth;
	    }
	  }, {
	    key: '_getTopGridHeight',
	    value: function _getTopGridHeight(props) {
	      var fixedRowCount = props.fixedRowCount,
	          rowHeight = props.rowHeight;
	
	
	      if (this._topGridHeight == null) {
	        if (typeof rowHeight === 'function') {
	          var topGridHeight = 0;
	
	          for (var index = 0; index < fixedRowCount; index++) {
	            topGridHeight += rowHeight({ index: index });
	          }
	
	          this._topGridHeight = topGridHeight;
	        } else {
	          this._topGridHeight = rowHeight * fixedRowCount;
	        }
	      }
	
	      return this._topGridHeight;
	    }
	  }, {
	    key: '_handleInvalidatedGridSize',
	    value: function _handleInvalidatedGridSize() {
	      if (typeof this._deferredInvalidateColumnIndex === 'number') {
	        var columnIndex = this._deferredInvalidateColumnIndex;
	        var rowIndex = this._deferredInvalidateRowIndex;
	
	        this._deferredInvalidateColumnIndex = null;
	        this._deferredInvalidateRowIndex = null;
	
	        this.recomputeGridSize({
	          columnIndex: columnIndex,
	          rowIndex: rowIndex
	        });
	        this.forceUpdate();
	      }
	    }
	
	    /**
	     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
	     * This method recalculates styles only when specific props change.
	     */
	
	  }, {
	    key: '_maybeCalculateCachedStyles',
	    value: function _maybeCalculateCachedStyles(prevProps, props, prevState, state) {
	      var columnWidth = props.columnWidth,
	          height = props.height,
	          fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount,
	          rowHeight = props.rowHeight,
	          style = props.style,
	          styleBottomLeftGrid = props.styleBottomLeftGrid,
	          styleBottomRightGrid = props.styleBottomRightGrid,
	          styleTopLeftGrid = props.styleTopLeftGrid,
	          styleTopRightGrid = props.styleTopRightGrid,
	          width = props.width;
	
	
	      var firstRender = !prevProps;
	      var sizeChange = firstRender || height !== prevProps.height || width !== prevProps.width;
	      var leftSizeChange = firstRender || columnWidth !== prevProps.columnWidth || fixedColumnCount !== prevProps.fixedColumnCount;
	      var topSizeChange = firstRender || fixedRowCount !== prevProps.fixedRowCount || rowHeight !== prevProps.rowHeight;
	
	      if (firstRender || sizeChange || style !== prevProps.style) {
	        this._containerOuterStyle = _extends({
	          height: height,
	          overflow: 'visible', // Let :focus outline show through
	          width: width
	        }, style);
	      }
	
	      if (firstRender || sizeChange || topSizeChange) {
	        this._containerTopStyle = {
	          height: this._getTopGridHeight(props),
	          position: 'relative',
	          width: width
	        };
	
	        this._containerBottomStyle = {
	          height: height - this._getTopGridHeight(props),
	          overflow: 'visible', // Let :focus outline show through
	          position: 'relative',
	          width: width
	        };
	      }
	
	      if (firstRender || styleBottomLeftGrid !== prevProps.styleBottomLeftGrid) {
	        this._bottomLeftGridStyle = _extends({
	          left: 0,
	          overflowX: 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute'
	        }, styleBottomLeftGrid);
	      }
	
	      if (firstRender || leftSizeChange || styleBottomRightGrid !== prevProps.styleBottomRightGrid) {
	        this._bottomRightGridStyle = _extends({
	          left: this._getLeftGridWidth(props),
	          position: 'absolute'
	        }, styleBottomRightGrid);
	      }
	
	      if (firstRender || styleTopLeftGrid !== prevProps.styleTopLeftGrid) {
	        this._topLeftGridStyle = _extends({
	          left: 0,
	          overflowX: 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute',
	          top: 0
	        }, styleTopLeftGrid);
	      }
	
	      if (firstRender || leftSizeChange || styleTopRightGrid !== prevProps.styleTopRightGrid) {
	        this._topRightGridStyle = _extends({
	          left: this._getLeftGridWidth(props),
	          overflowX: 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute',
	          top: 0
	        }, styleTopRightGrid);
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(scrollInfo) {
	      var scrollLeft = scrollInfo.scrollLeft,
	          scrollTop = scrollInfo.scrollTop;
	
	      this.setState({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      });
	      var onScroll = this.props.onScroll;
	      if (onScroll) {
	        onScroll(scrollInfo);
	      }
	    }
	  }, {
	    key: '_renderBottomLeftGrid',
	    value: function _renderBottomLeftGrid(props) {
	      var fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount,
	          rowCount = props.rowCount,
	          scrollTop = props.scrollTop;
	
	
	      if (!fixedColumnCount) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        cellRenderer: this._cellRendererBottomLeftGrid,
	        columnCount: fixedColumnCount,
	        height: this._getBottomGridHeight(props),
	        ref: this._bottomLeftGridRef,
	        rowCount: Math.max(0, rowCount - fixedRowCount) + 1 /* See _rowHeightBottomGrid */,
	        rowHeight: this._rowHeightBottomGrid,
	        scrollTop: scrollTop,
	        style: this._bottomLeftGridStyle,
	        tabIndex: null,
	        width: this._getLeftGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderBottomRightGrid',
	    value: function _renderBottomRightGrid(props) {
	      var columnCount = props.columnCount,
	          fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount,
	          rowCount = props.rowCount,
	          scrollToColumn = props.scrollToColumn,
	          scrollToRow = props.scrollToRow;
	
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        cellRenderer: this._cellRendererBottomRightGrid,
	        columnCount: Math.max(0, columnCount - fixedColumnCount),
	        columnWidth: this._columnWidthRightGrid,
	        height: this._getBottomGridHeight(props),
	        onScroll: this._onScroll,
	        ref: this._bottomRightGridRef,
	        rowCount: Math.max(0, rowCount - fixedRowCount),
	        rowHeight: this._rowHeightBottomGrid,
	        scrollToColumn: scrollToColumn - fixedColumnCount,
	        scrollToRow: scrollToRow - fixedRowCount,
	        style: this._bottomRightGridStyle,
	        width: this._getRightGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderTopLeftGrid',
	    value: function _renderTopLeftGrid(props) {
	      var fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount;
	
	
	      if (!fixedColumnCount || !fixedRowCount) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        columnCount: fixedColumnCount,
	        height: this._getTopGridHeight(props),
	        ref: this._topLeftGridRef,
	        rowCount: fixedRowCount,
	        style: this._topLeftGridStyle,
	        tabIndex: null,
	        width: this._getLeftGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderTopRightGrid',
	    value: function _renderTopRightGrid(props) {
	      var columnCount = props.columnCount,
	          fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount,
	          scrollLeft = props.scrollLeft;
	
	
	      if (!fixedRowCount) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Grid2.default, _extends({}, props, {
	        cellRenderer: this._cellRendererTopRightGrid,
	        columnCount: Math.max(0, columnCount - fixedColumnCount) + 1 /* See _columnWidthRightGrid */,
	        columnWidth: this._columnWidthRightGrid,
	        height: this._getTopGridHeight(props),
	        ref: this._topRightGridRef,
	        rowCount: fixedRowCount,
	        scrollLeft: scrollLeft,
	        style: this._topRightGridStyle,
	        tabIndex: null,
	        width: this._getRightGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_rowHeightBottomGrid',
	    value: function _rowHeightBottomGrid(_ref7) {
	      var index = _ref7.index;
	      var _props9 = this.props,
	          fixedRowCount = _props9.fixedRowCount,
	          rowCount = _props9.rowCount,
	          rowHeight = _props9.rowHeight;
	
	      // An extra cell is added to the count
	      // This gives the smaller Grid extra room for offset,
	      // In case the main (bottom right) Grid has a scrollbar
	      // If no scrollbar, the extra space is overflow:hidden anyway
	
	      if (index === rowCount - fixedRowCount) {
	        return SCROLLBAR_SIZE_BUFFER;
	      }
	
	      return typeof rowHeight === 'function' ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
	    }
	  }, {
	    key: '_topLeftGridRef',
	    value: function _topLeftGridRef(ref) {
	      this._topLeftGrid = ref;
	    }
	  }, {
	    key: '_topRightGridRef',
	    value: function _topRightGridRef(ref) {
	      this._topRightGrid = ref;
	    }
	  }]);
	
	  return MultiGrid;
	}(_react.PureComponent);
	
	MultiGrid.defaultProps = {
	  fixedColumnCount: 0,
	  fixedRowCount: 0,
	  style: {},
	  styleBottomLeftGrid: {},
	  styleBottomRightGrid: {},
	  styleTopLeftGrid: {},
	  styleTopRightGrid: {}
	};
	exports.default = MultiGrid;
	 false ? MultiGrid.propTypes = {
	  fixedColumnCount: _propTypes2.default.number.isRequired,
	  fixedRowCount: _propTypes2.default.number.isRequired,
	  style: _propTypes2.default.object.isRequired,
	  styleBottomLeftGrid: _propTypes2.default.object.isRequired,
	  styleBottomRightGrid: _propTypes2.default.object.isRequired,
	  styleTopLeftGrid: _propTypes2.default.object.isRequired,
	  styleTopRightGrid: _propTypes2.default.object.isRequired
	} : void 0;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScrollSync = exports.default = undefined;
	
	var _ScrollSync2 = __webpack_require__(1346);
	
	var _ScrollSync3 = _interopRequireDefault(_ScrollSync2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ScrollSync3.default;
	exports.ScrollSync = _ScrollSync3.default;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
	 */
	var ScrollSync = function (_PureComponent) {
	  _inherits(ScrollSync, _PureComponent);
	
	  function ScrollSync(props, context) {
	    _classCallCheck(this, ScrollSync);
	
	    var _this = _possibleConstructorReturn(this, (ScrollSync.__proto__ || Object.getPrototypeOf(ScrollSync)).call(this, props, context));
	
	    _this.state = {
	      clientHeight: 0,
	      clientWidth: 0,
	      scrollHeight: 0,
	      scrollLeft: 0,
	      scrollTop: 0,
	      scrollWidth: 0
	    };
	
	    _this._onScroll = _this._onScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScrollSync, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state = this.state,
	          clientHeight = _state.clientHeight,
	          clientWidth = _state.clientWidth,
	          scrollHeight = _state.scrollHeight,
	          scrollLeft = _state.scrollLeft,
	          scrollTop = _state.scrollTop,
	          scrollWidth = _state.scrollWidth;
	
	
	      return children({
	        clientHeight: clientHeight,
	        clientWidth: clientWidth,
	        onScroll: this._onScroll,
	        scrollHeight: scrollHeight,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        scrollWidth: scrollWidth
	      });
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref) {
	      var clientHeight = _ref.clientHeight,
	          clientWidth = _ref.clientWidth,
	          scrollHeight = _ref.scrollHeight,
	          scrollLeft = _ref.scrollLeft,
	          scrollTop = _ref.scrollTop,
	          scrollWidth = _ref.scrollWidth;
	
	      this.setState({ clientHeight: clientHeight, clientWidth: clientWidth, scrollHeight: scrollHeight, scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth });
	    }
	  }]);
	
	  return ScrollSync;
	}(_react.PureComponent);
	
	exports.default = ScrollSync;
	 false ? ScrollSync.propTypes = {
	  /**
	   * Function responsible for rendering 2 or more virtualized components.
	   * This function should implement the following signature:
	   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
	   */
	  children: _propTypes2.default.func.isRequired
	} : void 0;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SortIndicator = exports.SortDirection = exports.Column = exports.Table = exports.defaultRowRenderer = exports.defaultHeaderRenderer = exports.defaultHeaderRowRenderer = exports.defaultCellRenderer = exports.defaultCellDataGetter = exports.default = undefined;
	
	var _Table2 = __webpack_require__(1348);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _defaultCellDataGetter2 = __webpack_require__(1354);
	
	var _defaultCellDataGetter3 = _interopRequireDefault(_defaultCellDataGetter2);
	
	var _defaultCellRenderer2 = __webpack_require__(1353);
	
	var _defaultCellRenderer3 = _interopRequireDefault(_defaultCellRenderer2);
	
	var _defaultHeaderRowRenderer2 = __webpack_require__(1356);
	
	var _defaultHeaderRowRenderer3 = _interopRequireDefault(_defaultHeaderRowRenderer2);
	
	var _defaultHeaderRenderer2 = __webpack_require__(1350);
	
	var _defaultHeaderRenderer3 = _interopRequireDefault(_defaultHeaderRenderer2);
	
	var _defaultRowRenderer2 = __webpack_require__(1355);
	
	var _defaultRowRenderer3 = _interopRequireDefault(_defaultRowRenderer2);
	
	var _Column2 = __webpack_require__(1349);
	
	var _Column3 = _interopRequireDefault(_Column2);
	
	var _SortDirection2 = __webpack_require__(1352);
	
	var _SortDirection3 = _interopRequireDefault(_SortDirection2);
	
	var _SortIndicator2 = __webpack_require__(1351);
	
	var _SortIndicator3 = _interopRequireDefault(_SortIndicator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Table3.default;
	exports.defaultCellDataGetter = _defaultCellDataGetter3.default;
	exports.defaultCellRenderer = _defaultCellRenderer3.default;
	exports.defaultHeaderRowRenderer = _defaultHeaderRowRenderer3.default;
	exports.defaultHeaderRenderer = _defaultHeaderRenderer3.default;
	exports.defaultRowRenderer = _defaultRowRenderer3.default;
	exports.Table = _Table3.default;
	exports.Column = _Column3.default;
	exports.SortDirection = _SortDirection3.default;
	exports.SortIndicator = _SortIndicator3.default;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Column = __webpack_require__(1349);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _Grid = __webpack_require__(1324);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _defaultRowRenderer = __webpack_require__(1355);
	
	var _defaultRowRenderer2 = _interopRequireDefault(_defaultRowRenderer);
	
	var _defaultHeaderRowRenderer = __webpack_require__(1356);
	
	var _defaultHeaderRowRenderer2 = _interopRequireDefault(_defaultHeaderRowRenderer);
	
	var _SortDirection = __webpack_require__(1352);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
	 * This component expects explicit width, height, and padding parameters.
	 */
	var Table = function (_PureComponent) {
	  _inherits(Table, _PureComponent);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	    _this.state = {
	      scrollbarWidth: 0
	    };
	
	    _this._createColumn = _this._createColumn.bind(_this);
	    _this._createRow = _this._createRow.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    _this._setRef = _this._setRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      this.Grid.forceUpdate();
	    }
	
	    /** See Grid#getOffsetForCell */
	
	  }, {
	    key: 'getOffsetForRow',
	    value: function getOffsetForRow(_ref) {
	      var alignment = _ref.alignment,
	          index = _ref.index;
	
	      var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
	        alignment: alignment,
	        rowIndex: index
	      }),
	          scrollTop = _Grid$getOffsetForCel.scrollTop;
	
	      return scrollTop;
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      this.Grid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.recomputeGridSize({
	        rowIndex: index
	      });
	    }
	
	    /** See Grid#scrollToPosition */
	
	  }, {
	    key: 'scrollToPosition',
	    value: function scrollToPosition() {
	      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.scrollToPosition({ scrollTop: scrollTop });
	    }
	
	    /** See Grid#scrollToCell */
	
	  }, {
	    key: 'scrollToRow',
	    value: function scrollToRow() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      this.Grid.scrollToCell({
	        columnIndex: 0,
	        rowIndex: index
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          disableHeader = _props.disableHeader,
	          gridClassName = _props.gridClassName,
	          gridStyle = _props.gridStyle,
	          headerHeight = _props.headerHeight,
	          headerRowRenderer = _props.headerRowRenderer,
	          height = _props.height,
	          id = _props.id,
	          noRowsRenderer = _props.noRowsRenderer,
	          rowClassName = _props.rowClassName,
	          rowStyle = _props.rowStyle,
	          scrollToIndex = _props.scrollToIndex,
	          style = _props.style,
	          width = _props.width;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var availableRowsHeight = disableHeader ? height : height - headerHeight;
	
	      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: -1 }) : rowClassName;
	      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: -1 }) : rowStyle;
	
	      // Precompute and cache column styles before rendering rows and columns to speed things up
	      this._cachedColumnStyles = [];
	      _react2.default.Children.toArray(children).forEach(function (column, index) {
	        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);
	
	        _this2._cachedColumnStyles[index] = _extends({}, flexStyles, {
	          overflow: 'hidden'
	        });
	      });
	
	      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
	      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
	      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('ReactVirtualized__Table', className),
	          id: id,
	          role: 'grid',
	          style: style
	        },
	        !disableHeader && headerRowRenderer({
	          className: (0, _classnames2.default)('ReactVirtualized__Table__headerRow', rowClass),
	          columns: this._getHeaderColumns(),
	          style: _extends({}, rowStyleObject, {
	            height: headerHeight,
	            overflow: 'hidden',
	            paddingRight: scrollbarWidth,
	            width: width
	          })
	        }),
	        _react2.default.createElement(_Grid2.default, _extends({}, this.props, {
	          autoContainerWidth: true,
	          className: (0, _classnames2.default)('ReactVirtualized__Table__Grid', gridClassName),
	          cellRenderer: this._createRow,
	          columnWidth: width,
	          columnCount: 1,
	          height: availableRowsHeight,
	          id: undefined,
	          noContentRenderer: noRowsRenderer,
	          onScroll: this._onScroll,
	          onSectionRendered: this._onSectionRendered,
	          ref: this._setRef,
	          role: 'rowgroup',
	          scrollbarWidth: scrollbarWidth,
	          scrollToRow: scrollToIndex,
	          style: _extends({}, gridStyle, {
	            overflowX: 'hidden'
	          })
	        }))
	      );
	    }
	  }, {
	    key: '_createColumn',
	    value: function _createColumn(_ref2) {
	      var column = _ref2.column,
	          columnIndex = _ref2.columnIndex,
	          isScrolling = _ref2.isScrolling,
	          parent = _ref2.parent,
	          rowData = _ref2.rowData,
	          rowIndex = _ref2.rowIndex;
	      var _column$props = column.props,
	          cellDataGetter = _column$props.cellDataGetter,
	          cellRenderer = _column$props.cellRenderer,
	          className = _column$props.className,
	          columnData = _column$props.columnData,
	          dataKey = _column$props.dataKey;
	
	
	      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
	      var renderedCell = cellRenderer({ cellData: cellData, columnData: columnData, dataKey: dataKey, isScrolling: isScrolling, parent: parent, rowData: rowData, rowIndex: rowIndex });
	
	      var style = this._cachedColumnStyles[columnIndex];
	
	      var title = typeof renderedCell === 'string' ? renderedCell : null;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: 'Row' + rowIndex + '-Col' + columnIndex,
	          className: (0, _classnames2.default)('ReactVirtualized__Table__rowColumn', className),
	          style: style,
	          title: title
	        },
	        renderedCell
	      );
	    }
	  }, {
	    key: '_createHeader',
	    value: function _createHeader(_ref3) {
	      var column = _ref3.column,
	          index = _ref3.index;
	      var _props2 = this.props,
	          headerClassName = _props2.headerClassName,
	          headerStyle = _props2.headerStyle,
	          onHeaderClick = _props2.onHeaderClick,
	          sort = _props2.sort,
	          sortBy = _props2.sortBy,
	          sortDirection = _props2.sortDirection;
	      var _column$props2 = column.props,
	          dataKey = _column$props2.dataKey,
	          disableSort = _column$props2.disableSort,
	          headerRenderer = _column$props2.headerRenderer,
	          label = _column$props2.label,
	          columnData = _column$props2.columnData;
	
	      var sortEnabled = !disableSort && sort;
	
	      var classNames = (0, _classnames2.default)('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
	        'ReactVirtualized__Table__sortableHeaderColumn': sortEnabled
	      });
	      var style = this._getFlexStyleForColumn(column, headerStyle);
	
	      var renderedHeader = headerRenderer({
	        columnData: columnData,
	        dataKey: dataKey,
	        disableSort: disableSort,
	        label: label,
	        sortBy: sortBy,
	        sortDirection: sortDirection
	      });
	
	      var a11yProps = {};
	
	      if (sortEnabled || onHeaderClick) {
	        (function () {
	          // If this is a sortable header, clicking it should update the table data's sorting.
	          var newSortDirection = sortBy !== dataKey || sortDirection === _SortDirection2.default.DESC ? _SortDirection2.default.ASC : _SortDirection2.default.DESC;
	
	          var onClick = function onClick(event) {
	            sortEnabled && sort({
	              sortBy: dataKey,
	              sortDirection: newSortDirection
	            });
	            onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey, event: event });
	          };
	
	          var onKeyDown = function onKeyDown(event) {
	            if (event.key === 'Enter' || event.key === ' ') {
	              onClick(event);
	            }
	          };
	
	          a11yProps['aria-label'] = column.props['aria-label'] || label || dataKey;
	          a11yProps.role = 'rowheader';
	          a11yProps.tabIndex = 0;
	          a11yProps.onClick = onClick;
	          a11yProps.onKeyDown = onKeyDown;
	        })();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, a11yProps, {
	          key: 'Header-Col' + index,
	          className: classNames,
	          style: style
	        }),
	        renderedHeader
	      );
	    }
	  }, {
	    key: '_createRow',
	    value: function _createRow(_ref4) {
	      var _this3 = this;
	
	      var index = _ref4.rowIndex,
	          isScrolling = _ref4.isScrolling,
	          key = _ref4.key,
	          parent = _ref4.parent,
	          style = _ref4.style;
	      var _props3 = this.props,
	          children = _props3.children,
	          onRowClick = _props3.onRowClick,
	          onRowDoubleClick = _props3.onRowDoubleClick,
	          onRowMouseOver = _props3.onRowMouseOver,
	          onRowMouseOut = _props3.onRowMouseOut,
	          rowClassName = _props3.rowClassName,
	          rowGetter = _props3.rowGetter,
	          rowRenderer = _props3.rowRenderer,
	          rowStyle = _props3.rowStyle;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: index }) : rowClassName;
	      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: index }) : rowStyle;
	      var rowData = rowGetter({ index: index });
	
	      var columns = _react2.default.Children.toArray(children).map(function (column, columnIndex) {
	        return _this3._createColumn({
	          column: column,
	          columnIndex: columnIndex,
	          isScrolling: isScrolling,
	          parent: parent,
	          rowData: rowData,
	          rowIndex: index,
	          scrollbarWidth: scrollbarWidth
	        });
	      });
	
	      var className = (0, _classnames2.default)('ReactVirtualized__Table__row', rowClass);
	      var flattenedStyle = _extends({}, style, rowStyleObject, {
	        height: this._getRowHeight(index),
	        overflow: 'hidden',
	        paddingRight: scrollbarWidth
	      });
	
	      return rowRenderer({
	        className: className,
	        columns: columns,
	        index: index,
	        isScrolling: isScrolling,
	        key: key,
	        onRowClick: onRowClick,
	        onRowDoubleClick: onRowDoubleClick,
	        onRowMouseOver: onRowMouseOver,
	        onRowMouseOut: onRowMouseOut,
	        rowData: rowData,
	        style: flattenedStyle
	      });
	    }
	
	    /**
	     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
	     */
	
	  }, {
	    key: '_getFlexStyleForColumn',
	    value: function _getFlexStyleForColumn(column) {
	      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';
	
	      var style = _extends({}, customStyle, {
	        flex: flexValue,
	        msFlex: flexValue,
	        WebkitFlex: flexValue
	      });
	
	      if (column.props.maxWidth) {
	        style.maxWidth = column.props.maxWidth;
	      }
	
	      if (column.props.minWidth) {
	        style.minWidth = column.props.minWidth;
	      }
	
	      return style;
	    }
	  }, {
	    key: '_getHeaderColumns',
	    value: function _getHeaderColumns() {
	      var _this4 = this;
	
	      var _props4 = this.props,
	          children = _props4.children,
	          disableHeader = _props4.disableHeader;
	
	      var items = disableHeader ? [] : _react2.default.Children.toArray(children);
	
	      return items.map(function (column, index) {
	        return _this4._createHeader({ column: column, index: index });
	      });
	    }
	  }, {
	    key: '_getRowHeight',
	    value: function _getRowHeight(rowIndex) {
	      var rowHeight = this.props.rowHeight;
	
	
	      return typeof rowHeight === 'function' ? rowHeight({ index: rowIndex }) : rowHeight;
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref5) {
	      var clientHeight = _ref5.clientHeight,
	          scrollHeight = _ref5.scrollHeight,
	          scrollTop = _ref5.scrollTop;
	      var onScroll = this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref6) {
	      var rowOverscanStartIndex = _ref6.rowOverscanStartIndex,
	          rowOverscanStopIndex = _ref6.rowOverscanStopIndex,
	          rowStartIndex = _ref6.rowStartIndex,
	          rowStopIndex = _ref6.rowStopIndex;
	      var onRowsRendered = this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }
	  }, {
	    key: '_setRef',
	    value: function _setRef(ref) {
	      this.Grid = ref;
	    }
	  }, {
	    key: '_setScrollbarWidth',
	    value: function _setScrollbarWidth() {
	      var Grid = (0, _reactDom.findDOMNode)(this.Grid);
	      var clientWidth = Grid.clientWidth || 0;
	      var offsetWidth = Grid.offsetWidth || 0;
	      var scrollbarWidth = offsetWidth - clientWidth;
	
	      this.setState({ scrollbarWidth: scrollbarWidth });
	    }
	  }]);
	
	  return Table;
	}(_react.PureComponent);
	
	Table.defaultProps = {
	  disableHeader: false,
	  estimatedRowSize: 30,
	  headerHeight: 0,
	  headerStyle: {},
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
	  overscanRowCount: 10,
	  rowRenderer: _defaultRowRenderer2.default,
	  headerRowRenderer: _defaultHeaderRowRenderer2.default,
	  rowStyle: {},
	  scrollToAlignment: 'auto',
	  scrollToIndex: -1,
	  style: {}
	};
	exports.default = Table;
	 false ? Table.propTypes = {
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _propTypes2.default.bool,
	
	  /** One or more Columns describing the data displayed in this row */
	  children: function children(props, propName, componentName) {
	    var children = _react2.default.Children.toArray(props.children);
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].type !== _Column2.default) {
	        return new Error('Table only accepts children of type Column');
	      }
	    }
	  },
	
	  /** Optional CSS class name */
	  className: _propTypes2.default.string,
	
	  /** Disable rendering the header at all */
	  disableHeader: _propTypes2.default.bool,
	
	  /**
	   * Used to estimate the total height of a Table before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _propTypes2.default.number.isRequired,
	
	  /** Optional custom CSS class name to attach to inner Grid element. */
	  gridClassName: _propTypes2.default.string,
	
	  /** Optional inline style to attach to inner Grid element. */
	  gridStyle: _propTypes2.default.object,
	
	  /** Optional CSS class to apply to all column headers */
	  headerClassName: _propTypes2.default.string,
	
	  /** Fixed height of header row */
	  headerHeight: _propTypes2.default.number.isRequired,
	
	  /**
	   * Responsible for rendering a table row given an array of columns:
	   * Should implement the following interface: ({
	   *   className: string,
	   *   columns: any[],
	   *   style: any
	   * }): PropTypes.node
	   */
	  headerRowRenderer: _propTypes2.default.func,
	
	  /** Optional custom inline style to attach to table header columns. */
	  headerStyle: _propTypes2.default.object,
	
	  /** Fixed/available height for out DOM element */
	  height: _propTypes2.default.number.isRequired,
	
	  /** Optional id */
	  id: _propTypes2.default.string,
	
	  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
	  noRowsRenderer: _propTypes2.default.func,
	
	  /**
	  * Optional callback when a column's header is clicked.
	  * ({ columnData: any, dataKey: string }): void
	  */
	  onHeaderClick: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when a user clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowClick: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when a user double-clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowDoubleClick: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when the mouse leaves a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOut: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when a user moves the mouse over a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOver: _propTypes2.default.func,
	
	  /**
	   * Callback invoked with information about the slice of rows that were just rendered.
	   * ({ startIndex, stopIndex }): void
	   */
	  onRowsRendered: _propTypes2.default.func,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, scrollHeight, scrollTop }): void
	   */
	  onScroll: _propTypes2.default.func.isRequired,
	
	  /** See Grid#overscanIndicesGetter */
	  overscanIndicesGetter: _propTypes2.default.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Optional CSS class to apply to all table rows (including the header row).
	   * This property can be a CSS class name (string) or a function that returns a class name.
	   * If a function is provided its signature should be: ({ index: number }): string
	   */
	  rowClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * Callback responsible for returning a data row given an index.
	   * ({ index: number }): any
	   */
	  rowGetter: _propTypes2.default.func.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * ({ index: number }): number
	   */
	  rowHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
	
	  /** Number of rows in table. */
	  rowCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Responsible for rendering a table row given an array of columns:
	   * Should implement the following interface: ({
	   *   className: string,
	   *   columns: Array,
	   *   index: number,
	   *   isScrolling: boolean,
	   *   onRowClick: ?Function,
	   *   onRowDoubleClick: ?Function,
	   *   onRowMouseOver: ?Function,
	   *   onRowMouseOut: ?Function,
	   *   rowData: any,
	   *   style: any
	   * }): PropTypes.node
	   */
	  rowRenderer: _propTypes2.default.func,
	
	  /** Optional custom inline style to attach to table rows. */
	  rowStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]).isRequired,
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _propTypes2.default.number.isRequired,
	
	  /** Vertical offset. */
	  scrollTop: _propTypes2.default.number,
	
	  /**
	   * Sort function to be called if a sortable header is clicked.
	   * ({ sortBy: string, sortDirection: SortDirection }): void
	   */
	  sort: _propTypes2.default.func,
	
	  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
	  sortBy: _propTypes2.default.string,
	
	  /** Table data is currently sorted in this direction (if it is sorted at all) */
	  sortDirection: _propTypes2.default.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC]),
	
	  /** Optional inline style */
	  style: _propTypes2.default.object,
	
	  /** Tab index for focus */
	  tabIndex: _propTypes2.default.number,
	
	  /** Width of list */
	  width: _propTypes2.default.number.isRequired
	} : void 0;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _defaultHeaderRenderer = __webpack_require__(1350);
	
	var _defaultHeaderRenderer2 = _interopRequireDefault(_defaultHeaderRenderer);
	
	var _defaultCellRenderer = __webpack_require__(1353);
	
	var _defaultCellRenderer2 = _interopRequireDefault(_defaultCellRenderer);
	
	var _defaultCellDataGetter = __webpack_require__(1354);
	
	var _defaultCellDataGetter2 = _interopRequireDefault(_defaultCellDataGetter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Describes the header and cell contents of a table column.
	 */
	var Column = function (_Component) {
	  _inherits(Column, _Component);
	
	  function Column() {
	    _classCallCheck(this, Column);
	
	    return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
	  }
	
	  return Column;
	}(_react.Component);
	
	Column.defaultProps = {
	  cellDataGetter: _defaultCellDataGetter2.default,
	  cellRenderer: _defaultCellRenderer2.default,
	  flexGrow: 0,
	  flexShrink: 1,
	  headerRenderer: _defaultHeaderRenderer2.default,
	  style: {}
	};
	exports.default = Column;
	 false ? Column.propTypes = {
	  /** Optional aria-label value to set on the column header */
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Callback responsible for returning a cell's data, given its :dataKey
	   * ({ columnData: any, dataKey: string, rowData: any }): any
	   */
	  cellDataGetter: _propTypes2.default.func,
	
	  /**
	   * Callback responsible for rendering a cell's contents.
	   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
	   */
	  cellRenderer: _propTypes2.default.func,
	
	  /** Optional CSS class to apply to cell */
	  className: _propTypes2.default.string,
	
	  /** Optional additional data passed to this column's :cellDataGetter */
	  columnData: _propTypes2.default.object,
	
	  /** Uniquely identifies the row-data attribute correspnding to this cell */
	  dataKey: _propTypes2.default.any.isRequired,
	
	  /** If sort is enabled for the table at large, disable it for this column */
	  disableSort: _propTypes2.default.bool,
	
	  /** Flex grow style; defaults to 0 */
	  flexGrow: _propTypes2.default.number,
	
	  /** Flex shrink style; defaults to 1 */
	  flexShrink: _propTypes2.default.number,
	
	  /** Optional CSS class to apply to this column's header */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * Optional callback responsible for rendering a column header contents.
	   * ({ columnData: object, dataKey: string, disableSort: boolean, label: string, sortBy: string, sortDirection: string }): PropTypes.node
	   */
	  headerRenderer: _propTypes2.default.func.isRequired,
	
	  /** Header label for this column */
	  label: _propTypes2.default.string,
	
	  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
	  maxWidth: _propTypes2.default.number,
	
	  /** Minimum width of column. */
	  minWidth: _propTypes2.default.number,
	
	  /** Optional inline style to apply to cell */
	  style: _propTypes2.default.object,
	
	  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
	  width: _propTypes2.default.number.isRequired
	} : void 0;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultHeaderRenderer;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SortIndicator = __webpack_require__(1351);
	
	var _SortIndicator2 = _interopRequireDefault(_SortIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default table header renderer.
	 */
	function defaultHeaderRenderer(_ref) {
	  var columnData = _ref.columnData,
	      dataKey = _ref.dataKey,
	      disableSort = _ref.disableSort,
	      label = _ref.label,
	      sortBy = _ref.sortBy,
	      sortDirection = _ref.sortDirection;
	
	  var showSortIndicator = sortBy === dataKey;
	  var children = [_react2.default.createElement(
	    'span',
	    {
	      className: 'ReactVirtualized__Table__headerTruncatedText',
	      key: 'label',
	      title: label
	    },
	    label
	  )];
	
	  if (showSortIndicator) {
	    children.push(_react2.default.createElement(_SortIndicator2.default, {
	      key: 'SortIndicator',
	      sortDirection: sortDirection
	    }));
	  }
	
	  return children;
	}

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SortIndicator;
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SortDirection = __webpack_require__(1352);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Displayed beside a header to indicate that a Table is currently sorted by this column.
	 */
	function SortIndicator(_ref) {
	  var sortDirection = _ref.sortDirection;
	
	  var classNames = (0, _classnames2.default)('ReactVirtualized__Table__sortableHeaderIcon', {
	    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === _SortDirection2.default.ASC,
	    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === _SortDirection2.default.DESC
	  });
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      className: classNames,
	      width: 18,
	      height: 18,
	      viewBox: '0 0 24 24'
	    },
	    sortDirection === _SortDirection2.default.ASC ? _react2.default.createElement('path', { d: 'M7 14l5-5 5 5z' }) : _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' }),
	    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
	  );
	}
	
	 false ? SortIndicator.propTypes = {
	  sortDirection: _propTypes2.default.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC])
	} : void 0;

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SortDirection = {
	  /**
	   * Sort items in ascending order.
	   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
	   */
	  ASC: 'ASC',
	
	  /**
	   * Sort items in descending order.
	   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
	   */
	  DESC: 'DESC'
	};
	
	exports.default = SortDirection;

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRenderer;
	
	
	/**
	 * Default cell renderer that displays an attribute as a simple string
	 * You should override the column's cellRenderer if your data is some other type of object.
	 */
	function defaultCellRenderer(_ref) {
	  var cellData = _ref.cellData,
	      columnData = _ref.columnData,
	      dataKey = _ref.dataKey,
	      rowData = _ref.rowData,
	      rowIndex = _ref.rowIndex;
	
	  if (cellData == null) {
	    return '';
	  } else {
	    return String(cellData);
	  }
	}

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellDataGetter;
	
	
	/**
	 * Default accessor for returning a cell value for a given attribute.
	 * This function expects to operate on either a vanilla Object or an Immutable Map.
	 * You should override the column's cellDataGetter if your data is some other type of object.
	 */
	function defaultCellDataGetter(_ref) {
	  var columnData = _ref.columnData,
	      dataKey = _ref.dataKey,
	      rowData = _ref.rowData;
	
	  if (typeof rowData.get === 'function') {
	    return rowData.get(dataKey);
	  } else {
	    return rowData[dataKey];
	  }
	}

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = defaultRowRenderer;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default row renderer for Table.
	 */
	function defaultRowRenderer(_ref) {
	  var className = _ref.className,
	      columns = _ref.columns,
	      index = _ref.index,
	      isScrolling = _ref.isScrolling,
	      key = _ref.key,
	      onRowClick = _ref.onRowClick,
	      onRowDoubleClick = _ref.onRowDoubleClick,
	      onRowMouseOver = _ref.onRowMouseOver,
	      onRowMouseOut = _ref.onRowMouseOut,
	      rowData = _ref.rowData,
	      style = _ref.style;
	
	  var a11yProps = {};
	
	  if (onRowClick || onRowDoubleClick || onRowMouseOver || onRowMouseOut) {
	    a11yProps['aria-label'] = 'row';
	    a11yProps.tabIndex = 0;
	
	    if (onRowClick) {
	      a11yProps.onClick = function (event) {
	        return onRowClick({ event: event, index: index, rowData: rowData });
	      };
	    }
	    if (onRowDoubleClick) {
	      a11yProps.onDoubleClick = function (event) {
	        return onRowDoubleClick({ event: event, index: index, rowData: rowData });
	      };
	    }
	    if (onRowMouseOut) {
	      a11yProps.onMouseOut = function (event) {
	        return onRowMouseOut({ event: event, index: index, rowData: rowData });
	      };
	    }
	    if (onRowMouseOver) {
	      a11yProps.onMouseOver = function (event) {
	        return onRowMouseOver({ event: event, index: index, rowData: rowData });
	      };
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    _extends({}, a11yProps, {
	      className: className,
	      key: key,
	      role: 'row',
	      style: style
	    }),
	    columns
	  );
	}

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultHeaderRowRenderer;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultHeaderRowRenderer(_ref) {
	  var className = _ref.className,
	      columns = _ref.columns,
	      style = _ref.style;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      role: 'row',
	      style: style
	    },
	    columns
	  );
	}

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_SCROLLING_TIMEOUT = exports.WindowScroller = exports.default = undefined;
	
	var _onScroll = __webpack_require__(1358);
	
	Object.defineProperty(exports, 'IS_SCROLLING_TIMEOUT', {
	  enumerable: true,
	  get: function get() {
	    return _onScroll.IS_SCROLLING_TIMEOUT;
	  }
	});
	
	var _WindowScroller2 = __webpack_require__(1359);
	
	var _WindowScroller3 = _interopRequireDefault(_WindowScroller2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _WindowScroller3.default;
	exports.WindowScroller = _WindowScroller3.default;

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerScrollListener = registerScrollListener;
	exports.unregisterScrollListener = unregisterScrollListener;
	var mountedInstances = [];
	var originalBodyPointerEvents = null;
	var disablePointerEventsTimeoutId = null;
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = exports.IS_SCROLLING_TIMEOUT = 150;
	
	function enablePointerEventsIfDisabled() {
	  if (disablePointerEventsTimeoutId) {
	    disablePointerEventsTimeoutId = null;
	
	    document.body.style.pointerEvents = originalBodyPointerEvents;
	
	    originalBodyPointerEvents = null;
	  }
	}
	
	function enablePointerEventsAfterDelayCallback() {
	  enablePointerEventsIfDisabled();
	  mountedInstances.forEach(function (instance) {
	    return instance.__resetIsScrolling();
	  });
	}
	
	function enablePointerEventsAfterDelay() {
	  if (disablePointerEventsTimeoutId) {
	    clearTimeout(disablePointerEventsTimeoutId);
	  }
	
	  disablePointerEventsTimeoutId = setTimeout(enablePointerEventsAfterDelayCallback, IS_SCROLLING_TIMEOUT);
	}
	
	function onScrollWindow(event) {
	  if (event.currentTarget === window && originalBodyPointerEvents == null) {
	    originalBodyPointerEvents = document.body.style.pointerEvents;
	
	    document.body.style.pointerEvents = 'none';
	  }
	  enablePointerEventsAfterDelay();
	  mountedInstances.forEach(function (instance) {
	    if (instance.scrollElement === event.currentTarget) {
	      instance.__handleWindowScrollEvent(event);
	    }
	  });
	}
	
	function registerScrollListener(component, element) {
	  if (!mountedInstances.some(function (instance) {
	    return instance.scrollElement === element;
	  })) {
	    element.addEventListener('scroll', onScrollWindow);
	  }
	  mountedInstances.push(component);
	}
	
	function unregisterScrollListener(component, element) {
	  mountedInstances = mountedInstances.filter(function (instance) {
	    return instance !== component;
	  });
	  if (!mountedInstances.length) {
	    element.removeEventListener('scroll', onScrollWindow);
	    if (disablePointerEventsTimeoutId) {
	      clearTimeout(disablePointerEventsTimeoutId);
	      enablePointerEventsIfDisabled();
	    }
	  }
	}

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(300);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _onScroll = __webpack_require__(1358);
	
	var _dimensions = __webpack_require__(1360);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WindowScroller = function (_PureComponent) {
	  _inherits(WindowScroller, _PureComponent);
	
	  function WindowScroller(props) {
	    _classCallCheck(this, WindowScroller);
	
	    // Handle server-side rendering case
	    var _this = _possibleConstructorReturn(this, (WindowScroller.__proto__ || Object.getPrototypeOf(WindowScroller)).call(this, props));
	
	    var _ref = typeof window !== 'undefined' ? (0, _dimensions.getDimensions)(props.scrollElement || window) : { width: 0, height: 0 },
	        width = _ref.width,
	        height = _ref.height;
	
	    _this.state = {
	      height: height,
	      width: width,
	      isScrolling: false,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    _this._onResize = _this._onResize.bind(_this);
	    _this.__handleWindowScrollEvent = _this.__handleWindowScrollEvent.bind(_this);
	    _this.__resetIsScrolling = _this.__resetIsScrolling.bind(_this);
	    return _this;
	  }
	
	  // Can’t use defaultProps for scrollElement without breaking server-side rendering
	
	
	  _createClass(WindowScroller, [{
	    key: 'updatePosition',
	    value: function updatePosition(scrollElement) {
	      var onResize = this.props.onResize;
	      var _state = this.state,
	          height = _state.height,
	          width = _state.width;
	
	
	      scrollElement = scrollElement || this.props.scrollElement || window;
	      var offset = (0, _dimensions.getPositionOffset)(_reactDom2.default.findDOMNode(this), scrollElement);
	      this._positionFromTop = offset.top;
	      this._positionFromLeft = offset.left;
	
	      var dimensions = (0, _dimensions.getDimensions)(scrollElement);
	      if (height !== dimensions.height || width !== dimensions.width) {
	        this.setState({
	          height: dimensions.height,
	          width: dimensions.width
	        });
	        onResize({
	          height: dimensions.height,
	          width: dimensions.width
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var scrollElement = this.props.scrollElement || window;
	
	      this.updatePosition(scrollElement);
	
	      (0, _onScroll.registerScrollListener)(this, scrollElement);
	
	      window.addEventListener('resize', this._onResize, false);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var scrollElement = this.props.scrollElement || window;
	      var nextScrollElement = nextProps.scrollElement || window;
	
	      if (scrollElement !== nextScrollElement) {
	        this.updatePosition(nextScrollElement);
	
	        (0, _onScroll.unregisterScrollListener)(this, scrollElement);
	        (0, _onScroll.registerScrollListener)(this, nextScrollElement);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _onScroll.unregisterScrollListener)(this, this.props.scrollElement || window);
	
	      window.removeEventListener('resize', this._onResize, false);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state2 = this.state,
	          isScrolling = _state2.isScrolling,
	          scrollTop = _state2.scrollTop,
	          scrollLeft = _state2.scrollLeft,
	          height = _state2.height,
	          width = _state2.width;
	
	
	      return children({
	        width: width,
	        height: height,
	        isScrolling: isScrolling,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      });
	    }
	  }, {
	    key: '_onResize',
	    value: function _onResize(event) {
	      this.updatePosition();
	    }
	
	    // Referenced by utils/onScroll
	
	  }, {
	    key: '__handleWindowScrollEvent',
	    value: function __handleWindowScrollEvent(event) {
	      var onScroll = this.props.onScroll;
	
	
	      var scrollElement = this.props.scrollElement || window;
	      var scrollOffset = (0, _dimensions.getScrollOffset)(scrollElement);
	      var scrollLeft = Math.max(0, scrollOffset.left - this._positionFromLeft);
	      var scrollTop = Math.max(0, scrollOffset.top - this._positionFromTop);
	
	      this.setState({
	        isScrolling: true,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      });
	
	      onScroll({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      });
	    }
	
	    // Referenced by utils/onScroll
	
	  }, {
	    key: '__resetIsScrolling',
	    value: function __resetIsScrolling() {
	      this.setState({
	        isScrolling: false
	      });
	    }
	  }, {
	    key: 'scrollElement',
	    get: function get() {
	      return this.props.scrollElement || window;
	    }
	  }]);
	
	  return WindowScroller;
	}(_react.PureComponent);
	
	WindowScroller.defaultProps = {
	  onResize: function onResize() {},
	  onScroll: function onScroll() {}
	};
	exports.default = WindowScroller;
	 false ? WindowScroller.propTypes = {
	  /**
	   * Function responsible for rendering children.
	   * This function should implement the following signature:
	   * ({ height, isScrolling, scrollLeft, scrollTop, width }) => PropTypes.element
	   */
	  children: _propTypes2.default.func.isRequired,
	
	  /** Callback to be invoked on-resize: ({ height, width }) */
	  onResize: _propTypes2.default.func.isRequired,
	
	  /** Callback to be invoked on-scroll: ({ scrollLeft, scrollTop }) */
	  onScroll: _propTypes2.default.func.isRequired,
	
	  /** Element to attach scroll event listeners. Defaults to window. */
	  scrollElement: _propTypes2.default.any
	} : void 0;

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDimensions = getDimensions;
	exports.getPositionOffset = getPositionOffset;
	exports.getScrollOffset = getScrollOffset;
	/**
	 * Gets the dimensions of the element, accounting for API differences between
	 * `window` and other DOM elements.
	 */
	
	function getDimensions(element) {
	  if (element === window) {
	    return {
	      height: typeof window.innerHeight === 'number' ? window.innerHeight : 0,
	      width: typeof window.innerWidth === 'number' ? window.innerWidth : 0
	    };
	  }
	
	  var _element$getBoundingC = element.getBoundingClientRect(),
	      width = _element$getBoundingC.width,
	      height = _element$getBoundingC.height;
	
	  return { width: width, height: height };
	}
	
	/**
	 * Gets the vertical and horizontal position of an element within its scroll container.
	 * Elements that have been “scrolled past” return negative values.
	 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
	 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
	 */
	function getPositionOffset(element, container) {
	  var scrollOffset = container === window ? { top: 0, left: 0 } : getScrollOffset(container);
	  var containerElement = container === window ? document.documentElement : container;
	  var elementRect = element.getBoundingClientRect();
	  var containerRect = containerElement.getBoundingClientRect();
	  return {
	    top: elementRect.top + scrollOffset.top - containerRect.top,
	    left: elementRect.left + scrollOffset.left - containerRect.left
	  };
	}
	
	/**
	 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
	 * and API differences between `window` and other DOM elements.
	 */
	function getScrollOffset(element) {
	  if (element === window) {
	    return {
	      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
	      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
	    };
	  } else {
	    return {
	      top: element.scrollTop,
	      left: element.scrollLeft
	    };
	  }
	}

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(300), __webpack_require__(330));
		else if(typeof define === 'function' && define.amd)
			define(["react", "react-dom"], factory);
		else if(typeof exports === 'object')
			exports["ReactDraggable"] = factory(require("react"), require("react-dom"));
		else
			root["ReactDraggable"] = factory(root["React"], root["ReactDOM"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		module.exports = __webpack_require__(1).default;
		module.exports.DraggableCore = __webpack_require__(9).default;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _reactDom = __webpack_require__(3);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _classnames = __webpack_require__(4);
		
		var _classnames2 = _interopRequireDefault(_classnames);
		
		var _domFns = __webpack_require__(5);
		
		var _positionFns = __webpack_require__(8);
		
		var _shims = __webpack_require__(6);
		
		var _DraggableCore = __webpack_require__(9);
		
		var _DraggableCore2 = _interopRequireDefault(_DraggableCore);
		
		var _log = __webpack_require__(11);
		
		var _log2 = _interopRequireDefault(_log);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		// $FlowIgnore
		
		
		/*:: import type {DraggableEventHandler} from './utils/types';*/
		/*:: type DraggableState = {
		  dragging: boolean,
		  dragged: boolean,
		  x: number, y: number,
		  slackX: number, slackY: number,
		  isElementSVG: boolean
		};*/
		
		
		//
		// Define <Draggable>
		//
		
		/*:: type ConstructorProps = {
		  position: { x: number, y: number },
		  defaultPosition: { x: number, y: number }
		};*/
		
		var Draggable = function (_React$Component) {
		  _inherits(Draggable, _React$Component);
		
		  function Draggable(props /*: ConstructorProps*/) {
		    _classCallCheck(this, Draggable);
		
		    var _this = _possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));
		
		    _this.onDragStart = function (e, coreData) {
		      (0, _log2.default)('Draggable: onDragStart: %j', coreData);
		
		      // Short-circuit if user's callback killed it.
		      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_this, coreData));
		      // Kills start event on core as well, so move handlers are never bound.
		      if (shouldStart === false) return false;
		
		      _this.setState({ dragging: true, dragged: true });
		    };
		
		    _this.onDrag = function (e, coreData) {
		      if (!_this.state.dragging) return false;
		      (0, _log2.default)('Draggable: onDrag: %j', coreData);
		
		      var uiData = (0, _positionFns.createDraggableData)(_this, coreData);
		
		      var newState /*: $Shape<DraggableState>*/ = {
		        x: uiData.x,
		        y: uiData.y
		      };
		
		      // Keep within bounds.
		      if (_this.props.bounds) {
		        // Save original x and y.
		        var _x = newState.x,
		            _y = newState.y;
		
		        // Add slack to the values used to calculate bound position. This will ensure that if
		        // we start removing slack, the element won't react to it right away until it's been
		        // completely removed.
		
		        newState.x += _this.state.slackX;
		        newState.y += _this.state.slackY;
		
		        // Get bound position. This will ceil/floor the x and y within the boundaries.
		        // $FlowBug
		
		        // Recalculate slack by noting how much was shaved by the boundPosition handler.
		        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_this, newState.x, newState.y);
		
		        var _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2);
		
		        newState.x = _getBoundPosition2[0];
		        newState.y = _getBoundPosition2[1];
		        newState.slackX = _this.state.slackX + (_x - newState.x);
		        newState.slackY = _this.state.slackY + (_y - newState.y);
		
		        // Update the event we fire to reflect what really happened after bounds took effect.
		        uiData.x = _x;
		        uiData.y = _y;
		        uiData.deltaX = newState.x - _this.state.x;
		        uiData.deltaY = newState.y - _this.state.y;
		      }
		
		      // Short-circuit if user's callback killed it.
		      var shouldUpdate = _this.props.onDrag(e, uiData);
		      if (shouldUpdate === false) return false;
		
		      _this.setState(newState);
		    };
		
		    _this.onDragStop = function (e, coreData) {
		      if (!_this.state.dragging) return false;
		
		      // Short-circuit if user's callback killed it.
		      var shouldStop = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_this, coreData));
		      if (shouldStop === false) return false;
		
		      (0, _log2.default)('Draggable: onDragStop: %j', coreData);
		
		      var newState /*: $Shape<DraggableState>*/ = {
		        dragging: false,
		        slackX: 0,
		        slackY: 0
		      };
		
		      // If this is a controlled component, the result of this operation will be to
		      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
		      var controlled = Boolean(_this.props.position);
		      if (controlled) {
		        var _this$props$position = _this.props.position,
		            _x2 = _this$props$position.x,
		            _y2 = _this$props$position.y;
		
		        newState.x = _x2;
		        newState.y = _y2;
		      }
		
		      _this.setState(newState);
		    };
		
		    _this.state = {
		      // Whether or not we are currently dragging.
		      dragging: false,
		
		      // Whether or not we have been dragged before.
		      dragged: false,
		
		      // Current transform x and y.
		      x: props.position ? props.position.x : props.defaultPosition.x,
		      y: props.position ? props.position.y : props.defaultPosition.y,
		
		      // Used for compensating for out-of-bounds drags
		      slackX: 0, slackY: 0,
		
		      // Can only determine if SVG after mounting
		      isElementSVG: false
		    };
		    return _this;
		  }
		
		  _createClass(Draggable, [{
		    key: 'componentWillMount',
		    value: function componentWillMount() {
		      if (this.props.position && !(this.props.onDrag || this.props.onStop)) {
		        // eslint-disable-next-line
		        console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
		      }
		    }
		  }, {
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      // Check to see if the element passed is an instanceof SVGElement
		      if (typeof SVGElement !== 'undefined' && _reactDom2.default.findDOMNode(this) instanceof SVGElement) {
		        this.setState({ isElementSVG: true });
		      }
		    }
		  }, {
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps /*: Object*/) {
		      // Set x/y if position has changed
		      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
		        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
		      }
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
		    }
		  }, {
		    key: 'render',
		    value: function render() /*: React.Element<any>*/ {
		      var _classNames;
		
		      var style = {},
		          svgTransform = null;
		
		      // If this is controlled, we don't want to move it - unless it's dragging.
		      var controlled = Boolean(this.props.position);
		      var draggable = !controlled || this.state.dragging;
		
		      var position = this.props.position || this.props.defaultPosition;
		      var transformOpts = {
		        // Set left if horizontal drag is enabled
		        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : position.x,
		
		        // Set top if vertical drag is enabled
		        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : position.y
		      };
		
		      // If this element was SVG, we use the `transform` attribute.
		      if (this.state.isElementSVG) {
		        svgTransform = (0, _domFns.createSVGTransform)(transformOpts);
		      } else {
		        // Add a CSS transform to move the element around. This allows us to move the element around
		        // without worrying about whether or not it is relatively or absolutely positioned.
		        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
		        // has a clean slate.
		        style = (0, _domFns.createCSSTransform)(transformOpts);
		      }
		
		      var _props = this.props,
		          defaultClassName = _props.defaultClassName,
		          defaultClassNameDragging = _props.defaultClassNameDragging,
		          defaultClassNameDragged = _props.defaultClassNameDragged;
		
		      // Mark with class while dragging
		
		      var className = (0, _classnames2.default)(this.props.children.props.className || '', defaultClassName, (_classNames = {}, _defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), _defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));
		
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return _react2.default.createElement(
		        _DraggableCore2.default,
		        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
		        _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
		          className: className,
		          style: _extends({}, this.props.children.props.style, style),
		          transform: svgTransform
		        })
		      );
		    }
		  }]);
		
		  return Draggable;
		}(_react2.default.Component);
		
		Draggable.displayName = 'Draggable';
		Draggable.propTypes = _extends({}, _DraggableCore2.default.propTypes, {
		
		  /**
		   * `axis` determines which axis the draggable can move.
		   *
		   *  Note that all callbacks will still return data as normal. This only
		   *  controls flushing to the DOM.
		   *
		   * 'both' allows movement horizontally and vertically.
		   * 'x' limits movement to horizontal axis.
		   * 'y' limits movement to vertical axis.
		   * 'none' limits all movement.
		   *
		   * Defaults to 'both'.
		   */
		  axis: _react.PropTypes.oneOf(['both', 'x', 'y', 'none']),
		
		  /**
		   * `bounds` determines the range of movement available to the element.
		   * Available values are:
		   *
		   * 'parent' restricts movement within the Draggable's parent node.
		   *
		   * Alternatively, pass an object with the following properties, all of which are optional:
		   *
		   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
		   *
		   * All values are in px.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable bounds={{right: 300, bottom: 300}}>
		   *              <div>Content</div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  bounds: _react.PropTypes.oneOfType([_react.PropTypes.shape({
		    left: _react.PropTypes.number,
		    right: _react.PropTypes.number,
		    top: _react.PropTypes.number,
		    bottom: _react.PropTypes.number
		  }), _react.PropTypes.string, _react.PropTypes.oneOf([false])]),
		
		  defaultClassName: _react.PropTypes.string,
		  defaultClassNameDragging: _react.PropTypes.string,
		  defaultClassNameDragged: _react.PropTypes.string,
		
		  /**
		   * `defaultPosition` specifies the x and y that the dragged item should start at
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  defaultPosition: _react.PropTypes.shape({
		    x: _react.PropTypes.number,
		    y: _react.PropTypes.number
		  }),
		
		  /**
		   * `position`, if present, defines the current position of the element.
		   *
		   *  This is similar to how form elements in React work - if no `position` is supplied, the component
		   *  is uncontrolled.
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable position={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  position: _react.PropTypes.shape({
		    x: _react.PropTypes.number,
		    y: _react.PropTypes.number
		  }),
		
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: _shims.dontSetMe,
		  style: _shims.dontSetMe,
		  transform: _shims.dontSetMe
		});
		Draggable.defaultProps = _extends({}, _DraggableCore2.default.defaultProps, {
		  axis: 'both',
		  bounds: false,
		  defaultClassName: 'react-draggable',
		  defaultClassNameDragging: 'react-draggable-dragging',
		  defaultClassNameDragged: 'react-draggable-dragged',
		  defaultPosition: { x: 0, y: 0 },
		  position: null
		});
		exports.default = Draggable;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
		/* global define */
		
		(function () {
			'use strict';
		
			var hasOwn = {}.hasOwnProperty;
		
			function classNames () {
				var classes = [];
		
				for (var i = 0; i < arguments.length; i++) {
					var arg = arguments[i];
					if (!arg) continue;
		
					var argType = typeof arg;
		
					if (argType === 'string' || argType === 'number') {
						classes.push(arg);
					} else if (Array.isArray(arg)) {
						classes.push(classNames.apply(null, arg));
					} else if (argType === 'object') {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					}
				}
		
				return classes.join(' ');
			}
		
			if (typeof module !== 'undefined' && module.exports) {
				module.exports = classNames;
			} else if (true) {
				// register as 'classnames', consistent with npm package name
				!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
					return classNames;
				}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			} else {
				window.classNames = classNames;
			}
		}());
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		exports.matchesSelector = matchesSelector;
		exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
		exports.addEvent = addEvent;
		exports.removeEvent = removeEvent;
		exports.outerHeight = outerHeight;
		exports.outerWidth = outerWidth;
		exports.innerHeight = innerHeight;
		exports.innerWidth = innerWidth;
		exports.offsetXYFromParent = offsetXYFromParent;
		exports.createCSSTransform = createCSSTransform;
		exports.createSVGTransform = createSVGTransform;
		exports.getTouch = getTouch;
		exports.getTouchIdentifier = getTouchIdentifier;
		exports.addUserSelectStyles = addUserSelectStyles;
		exports.removeUserSelectStyles = removeUserSelectStyles;
		exports.styleHacks = styleHacks;
		
		var _shims = __webpack_require__(6);
		
		var _getPrefix = __webpack_require__(7);
		
		var _getPrefix2 = _interopRequireDefault(_getPrefix);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		/*:: import type {ControlPosition} from './types';*/
		
		
		var matchesSelectorFunc = '';
		function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
		  if (!matchesSelectorFunc) {
		    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
		      // $FlowIgnore: Doesn't think elements are indexable
		      return (0, _shims.isFunction)(el[method]);
		    });
		  }
		
		  // $FlowIgnore: Doesn't think elements are indexable
		  return el[matchesSelectorFunc].call(el, selector);
		}
		
		// Works up the tree to the draggable itself attempting to match selector.
		function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
		  var node = el;
		  do {
		    if (matchesSelector(node, selector)) return true;
		    if (node === baseNode) return false;
		    node = node.parentNode;
		  } while (node);
		
		  return false;
		}
		
		function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.attachEvent) {
		    el.attachEvent('on' + event, handler);
		  } else if (el.addEventListener) {
		    el.addEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = handler;
		  }
		}
		
		function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.detachEvent) {
		    el.detachEvent('on' + event, handler);
		  } else if (el.removeEventListener) {
		    el.removeEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = null;
		  }
		}
		
		function outerHeight(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetTop which is including margin. See getBoundPosition
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height += (0, _shims.int)(computedStyle.borderTopWidth);
		  height += (0, _shims.int)(computedStyle.borderBottomWidth);
		  return height;
		}
		
		function outerWidth(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetLeft which is including margin. See getBoundPosition
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width += (0, _shims.int)(computedStyle.borderLeftWidth);
		  width += (0, _shims.int)(computedStyle.borderRightWidth);
		  return width;
		}
		function innerHeight(node /*: HTMLElement*/) /*: number*/ {
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height -= (0, _shims.int)(computedStyle.paddingTop);
		  height -= (0, _shims.int)(computedStyle.paddingBottom);
		  return height;
		}
		
		function innerWidth(node /*: HTMLElement*/) /*: number*/ {
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width -= (0, _shims.int)(computedStyle.paddingLeft);
		  width -= (0, _shims.int)(computedStyle.paddingRight);
		  return width;
		}
		
		// Get from offsetParent
		function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
		  var isBody = offsetParent === offsetParent.ownerDocument.body;
		  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();
		
		  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
		  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;
		
		  return { x: x, y: y };
		}
		
		function createCSSTransform(_ref) /*: Object*/ {
		  var x = _ref.x,
		      y = _ref.y;
		
		  // Replace unitless items with px
		  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix2.default), 'translate(' + x + 'px,' + y + 'px)');
		}
		
		function createSVGTransform(_ref3) /*: string*/ {
		  var x = _ref3.x,
		      y = _ref3.y;
		
		  return 'translate(' + x + ',' + y + ')';
		}
		
		function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
		  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
		    return identifier === t.identifier;
		  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
		    return identifier === t.identifier;
		  });
		}
		
		function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
		  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
		  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
		}
		
		// User-select Hacks:
		//
		// Useful for preventing blue highlights all over everything when dragging.
		var userSelectPrefix = (0, _getPrefix.getPrefix)('user-select');
		var userSelect = (0, _getPrefix.browserPrefixToStyle)('user-select', userSelectPrefix);
		var userSelectStyle = ';' + userSelect + ': none;';
		var userSelectReplaceRegExp = new RegExp(';?' + userSelect + ': none;'); // leading ; not present on IE
		
		// Note we're passing `document` b/c we could be iframed
		function addUserSelectStyles(body /*: HTMLElement*/) {
		  var style = body.getAttribute('style') || '';
		  body.setAttribute('style', style + userSelectStyle);
		}
		
		function removeUserSelectStyles(body /*: HTMLElement*/) {
		  var style = body.getAttribute('style') || '';
		  body.setAttribute('style', style.replace(userSelectReplaceRegExp, ''));
		}
		
		function styleHacks() /*: Object*/ {
		  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		
		  // Workaround IE pointer events; see #51
		  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
		  return _extends({
		    touchAction: 'none'
		  }, childStyle);
		}
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.findInArray = findInArray;
		exports.isFunction = isFunction;
		exports.isNum = isNum;
		exports.int = int;
		exports.dontSetMe = dontSetMe;
		
		// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
		function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
		  for (var i = 0, length = array.length; i < length; i++) {
		    if (callback.apply(callback, [array[i], i, array])) return array[i];
		  }
		}
		
		function isFunction(func /*: any*/) /*: boolean*/ {
		  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
		}
		
		function isNum(num /*: any*/) /*: boolean*/ {
		  return typeof num === 'number' && !isNaN(num);
		}
		
		function int(a /*: string*/) /*: number*/ {
		  return parseInt(a, 10);
		}
		
		function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
		  if (props[propName]) {
		    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
		  }
		}
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getPrefix = getPrefix;
		exports.browserPrefixToKey = browserPrefixToKey;
		exports.browserPrefixToStyle = browserPrefixToStyle;
		var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
		function getPrefix() /*: string*/ {
		  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
		
		  // Checking specifically for 'window.document' is for pseudo-browser server-side
		  // environments that define 'window' as the global context.
		  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
		  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';
		
		  var style = window.document.documentElement.style;
		
		  if (prop in style) return '';
		
		  for (var i = 0; i < prefixes.length; i++) {
		    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
		  }
		
		  return '';
		}
		
		function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
		  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
		}
		
		function browserPrefixToStyle(prop /*: string*/, prefix /*: string*/) /*: string*/ {
		  return prefix ? '-' + prefix.toLowerCase() + '-' + prop : prop;
		}
		
		function kebabToTitleCase(str /*: string*/) /*: string*/ {
		  var out = '';
		  var shouldCapitalize = true;
		  for (var i = 0; i < str.length; i++) {
		    if (shouldCapitalize) {
		      out += str[i].toUpperCase();
		      shouldCapitalize = false;
		    } else if (str[i] === '-') {
		      shouldCapitalize = true;
		    } else {
		      out += str[i];
		    }
		  }
		  return out;
		}
		
		// Default export is the prefix itself, like 'Moz', 'Webkit', etc
		// Note that you may have to re-test for certain things; for instance, Chrome 50
		// can handle unprefixed `transform`, but not unprefixed `user-select`
		exports.default = getPrefix();
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getBoundPosition = getBoundPosition;
		exports.snapToGrid = snapToGrid;
		exports.canDragX = canDragX;
		exports.canDragY = canDragY;
		exports.getControlPosition = getControlPosition;
		exports.createCoreData = createCoreData;
		exports.createDraggableData = createDraggableData;
		
		var _shims = __webpack_require__(6);
		
		var _reactDom = __webpack_require__(3);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _domFns = __webpack_require__(5);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		/*:: import type Draggable from '../Draggable';*/
		/*:: import type {Bounds, ControlPosition, DraggableData} from './types';*/
		/*:: import type DraggableCore from '../DraggableCore';*/
		function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
		  // If no bounds, short-circuit and move on
		  if (!draggable.props.bounds) return [x, y];
		
		  // Clone new bounds
		  var bounds = draggable.props.bounds;
		
		  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
		  var node = _reactDom2.default.findDOMNode(draggable);
		
		  if (typeof bounds === 'string') {
		    var ownerDocument = node.ownerDocument;
		
		    var ownerWindow = ownerDocument.defaultView;
		    var boundNode = void 0;
		    if (bounds === 'parent') {
		      boundNode = node.parentNode;
		    } else {
		      boundNode = ownerDocument.querySelector(bounds);
		      if (!boundNode) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
		    }
		    var nodeStyle = ownerWindow.getComputedStyle(node);
		    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
		    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
		    bounds = {
		      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.borderLeftWidth) + (0, _shims.int)(nodeStyle.marginLeft),
		      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.borderTopWidth) + (0, _shims.int)(nodeStyle.marginTop),
		      right: (0, _domFns.innerWidth)(boundNode) - (0, _domFns.outerWidth)(node) - node.offsetLeft,
		      bottom: (0, _domFns.innerHeight)(boundNode) - (0, _domFns.outerHeight)(node) - node.offsetTop
		    };
		  }
		
		  // Keep x and y below right and bottom limits...
		  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
		  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
		
		  // But above left and top limits.
		  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
		  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
		
		  return [x, y];
		}
		
		function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
		  var x = Math.round(pendingX / grid[0]) * grid[0];
		  var y = Math.round(pendingY / grid[1]) * grid[1];
		  return [x, y];
		}
		
		function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
		}
		
		function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
		}
		
		// Get {x, y} positions from event.
		function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
		  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
		  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
		  var node = _reactDom2.default.findDOMNode(draggableCore);
		  // User can provide an offsetParent if desired.
		  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
		  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent);
		}
		
		// Create an data object exposed by <DraggableCore>'s events
		function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
		  var state = draggable.state;
		  var isStart = !(0, _shims.isNum)(state.lastX);
		
		  if (isStart) {
		    // If this is our first move, use the x and y as last coords.
		    return {
		      node: _reactDom2.default.findDOMNode(draggable),
		      deltaX: 0, deltaY: 0,
		      lastX: x, lastY: y,
		      x: x, y: y
		    };
		  } else {
		    // Otherwise calculate proper values.
		    return {
		      node: _reactDom2.default.findDOMNode(draggable),
		      deltaX: x - state.lastX, deltaY: y - state.lastY,
		      lastX: state.lastX, lastY: state.lastY,
		      x: x, y: y
		    };
		  }
		}
		
		// Create an data exposed by <Draggable>'s events
		function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
		  return {
		    node: coreData.node,
		    x: draggable.state.x + coreData.deltaX,
		    y: draggable.state.y + coreData.deltaY,
		    deltaX: coreData.deltaX,
		    deltaY: coreData.deltaY,
		    lastX: draggable.state.x,
		    lastY: draggable.state.y
		  };
		}
		
		// A lot faster than stringify/parse
		function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
		  return {
		    left: bounds.left,
		    top: bounds.top,
		    right: bounds.right,
		    bottom: bounds.bottom
		  };
		}
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _reactDom = __webpack_require__(3);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _domFns = __webpack_require__(5);
		
		var _positionFns = __webpack_require__(8);
		
		var _shims = __webpack_require__(6);
		
		var _log = __webpack_require__(11);
		
		var _log2 = _interopRequireDefault(_log);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		// Simple abstraction for dragging events names.
		/*:: import type {EventHandler} from './utils/types';*/
		var eventsFor = {
		  touch: {
		    start: 'touchstart',
		    move: 'touchmove',
		    stop: 'touchend'
		  },
		  mouse: {
		    start: 'mousedown',
		    move: 'mousemove',
		    stop: 'mouseup'
		  }
		};
		
		// Default to mouse events.
		var dragEventFor = eventsFor.mouse;
		
		//
		// Define <DraggableCore>.
		//
		// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
		// work well with libraries that require more control over the element.
		//
		
		/*:: type CoreState = {
		  dragging: boolean,
		  lastX: number,
		  lastY: number,
		  touchIdentifier: ?number
		};*/
		
		var DraggableCore = function (_React$Component) {
		  _inherits(DraggableCore, _React$Component);
		
		  function DraggableCore() {
		    var _ref;
		
		    var _temp, _this, _ret;
		
		    _classCallCheck(this, DraggableCore);
		
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
		
		    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
		      dragging: false,
		      // Used while dragging to determine deltas.
		      lastX: NaN, lastY: NaN,
		      touchIdentifier: null
		    }, _this.handleDragStart = function (e) {
		      // Make it possible to attach event handlers on top of this one.
		      _this.props.onMouseDown(e);
		
		      // Only accept left-clicks.
		      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
		
		      // Get nodes. Be sure to grab relative document (could be iframed)
		      var domNode = _reactDom2.default.findDOMNode(_this);
		      var ownerDocument = domNode.ownerDocument;
		
		      // Short circuit if handle or cancel prop was provided and selector doesn't match.
		
		      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, domNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, domNode)) {
		        return;
		      }
		
		      // Set touch identifier in component state if this is a touch event. This allows us to
		      // distinguish between individual touches on multitouch screens by identifying which
		      // touchpoint was set to this element.
		      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
		      _this.setState({ touchIdentifier: touchIdentifier });
		
		      // Get the current drag point from the event. This is used as the offset.
		      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _this);
		      if (position == null) return; // not possible but satisfies flow
		      var x = position.x,
		          y = position.y;
		
		      // Create an event object with all the data parents need to make a decision here.
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      (0, _log2.default)('DraggableCore: handleDragStart: %j', coreEvent);
		
		      // Call event handler. If it returns explicit false, cancel.
		      (0, _log2.default)('calling', _this.props.onStart);
		      var shouldUpdate = _this.props.onStart(e, coreEvent);
		      if (shouldUpdate === false) return;
		
		      // Add a style to the body to disable user-select. This prevents text from
		      // being selected all over the page.
		      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument.body);
		
		      // Initiate dragging. Set the current x and y as offsets
		      // so we know how much we've moved during the drag. This allows us
		      // to drag elements around even if they have been moved, without issue.
		      _this.setState({
		        dragging: true,
		
		        lastX: x,
		        lastY: y
		      });
		
		      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
		      // this element. We use different events depending on whether or not we have detected that this
		      // is a touch-capable device.
		      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
		      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
		    }, _this.handleDrag = function (e) {
		
		      // Prevent scrolling on mobile devices, like ipad/iphone.
		      if (e.type === 'touchmove') e.preventDefault();
		
		      // Get the current drag point from the event. This is used as the offset.
		      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x,
		          y = position.y;
		
		      // Snap to grid if prop has been provided
		
		      if (x !== x) debugger;
		
		      if (Array.isArray(_this.props.grid)) {
		        var deltaX = x - _this.state.lastX,
		            deltaY = y - _this.state.lastY;
		
		        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
		
		        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
		
		        deltaX = _snapToGrid2[0];
		        deltaY = _snapToGrid2[1];
		
		        if (!deltaX && !deltaY) return; // skip useless drag
		        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
		      }
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      (0, _log2.default)('DraggableCore: handleDrag: %j', coreEvent);
		
		      // Call event handler. If it returns explicit false, trigger end.
		      var shouldUpdate = _this.props.onDrag(e, coreEvent);
		      if (shouldUpdate === false) {
		        try {
		          // $FlowIgnore
		          _this.handleDragStop(new MouseEvent('mouseup'));
		        } catch (err) {
		          // Old browsers
		          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
		          // I see why this insanity was deprecated
		          // $FlowIgnore
		          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		          _this.handleDragStop(event);
		        }
		        return;
		      }
		
		      _this.setState({
		        lastX: x,
		        lastY: y
		      });
		    }, _this.handleDragStop = function (e) {
		      if (!_this.state.dragging) return;
		
		      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x,
		          y = position.y;
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(_this),
		          ownerDocument = _ReactDOM$findDOMNode.ownerDocument;
		
		      // Remove user-select hack
		
		
		      if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument.body);
		
		      (0, _log2.default)('DraggableCore: handleDragStop: %j', coreEvent);
		
		      // Reset the el.
		      _this.setState({
		        dragging: false,
		        lastX: NaN,
		        lastY: NaN
		      });
		
		      // Call event handler
		      _this.props.onStop(e, coreEvent);
		
		      // Remove event handlers
		      (0, _log2.default)('DraggableCore: Removing handlers');
		      (0, _domFns.removeEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
		    }, _this.onMouseDown = function (e) {
		      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
		
		      return _this.handleDragStart(e);
		    }, _this.onMouseUp = function (e) {
		      dragEventFor = eventsFor.mouse;
		
		      return _this.handleDragStop(e);
		    }, _this.onTouchStart = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
		
		      return _this.handleDragStart(e);
		    }, _this.onTouchEnd = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
		
		      return _this.handleDragStop(e);
		    }, _temp), _possibleConstructorReturn(_this, _ret);
		  }
		
		  _createClass(DraggableCore, [{
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
		      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
		      var _ReactDOM$findDOMNode2 = _reactDom2.default.findDOMNode(this),
		          ownerDocument = _ReactDOM$findDOMNode2.ownerDocument;
		
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
		      if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument.body);
		    }
		
		    // Same as onMouseDown (start drag), but now consider this a touch device.
		
		  }, {
		    key: 'render',
		    value: function render() /*: React.Element<any>*/ {
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
		        style: (0, _domFns.styleHacks)(this.props.children.props.style),
		
		        // Note: mouseMove handler is attached to document so it will still function
		        // when the user drags quickly and leaves the bounds of the element.
		        onMouseDown: this.onMouseDown,
		        onTouchStart: this.onTouchStart,
		        onMouseUp: this.onMouseUp,
		        onTouchEnd: this.onTouchEnd
		      });
		    }
		  }]);
		
		  return DraggableCore;
		}(_react2.default.Component);
		
		DraggableCore.displayName = 'DraggableCore';
		DraggableCore.propTypes = {
		  /**
		   * `allowAnyClick` allows dragging using any mouse button.
		   * By default, we only accept the left button.
		   *
		   * Defaults to `false`.
		   */
		  allowAnyClick: _react.PropTypes.bool,
		
		  /**
		   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
		   * with the exception of `onMouseDown`, will not fire.
		   */
		  disabled: _react.PropTypes.bool,
		
		  /**
		   * By default, we add 'user-select:none' attributes to the document body
		   * to prevent ugly text selection during drag. If this is causing problems
		   * for your app, set this to `false`.
		   */
		  enableUserSelectHack: _react.PropTypes.bool,
		
		  /**
		   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
		   * instead of using the parent node.
		   */
		  offsetParent: function offsetParent(props, propName) {
		    if (process.browser && props[propName] && props[propName].nodeType !== 1) {
		      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
		    }
		  },
		
		  /**
		   * `grid` specifies the x and y that dragging should snap to.
		   */
		  grid: _react.PropTypes.arrayOf(_react.PropTypes.number),
		
		  /**
		   * `handle` specifies a selector to be used as the handle that initiates drag.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable handle=".handle">
		   *              <div>
		   *                  <div className="handle">Click me to drag</div>
		   *                  <div>This is some other content</div>
		   *              </div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  handle: _react.PropTypes.string,
		
		  /**
		   * `cancel` specifies a selector to be used to prevent drag initialization.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *           return(
		   *               <Draggable cancel=".cancel">
		   *                   <div>
		   *                     <div className="cancel">You can't drag from here</div>
		   *                     <div>Dragging here works fine</div>
		   *                   </div>
		   *               </Draggable>
		   *           );
		   *       }
		   *   });
		   * ```
		   */
		  cancel: _react.PropTypes.string,
		
		  /**
		   * Called when dragging starts.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onStart: _react.PropTypes.func,
		
		  /**
		   * Called while dragging.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onDrag: _react.PropTypes.func,
		
		  /**
		   * Called when dragging stops.
		   * If this function returns the boolean false, the drag will remain active.
		   */
		  onStop: _react.PropTypes.func,
		
		  /**
		   * A workaround option which can be passed if onMouseDown needs to be accessed,
		   * since it'll always be blocked (as there is internal use of onMouseDown)
		   */
		  onMouseDown: _react.PropTypes.func,
		
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: _shims.dontSetMe,
		  style: _shims.dontSetMe,
		  transform: _shims.dontSetMe
		};
		DraggableCore.defaultProps = {
		  allowAnyClick: false, // by default only accept left click
		  cancel: null,
		  disabled: false,
		  enableUserSelectHack: true,
		  offsetParent: null,
		  handle: null,
		  grid: null,
		  transform: null,
		  onStart: function onStart() {},
		  onDrag: function onDrag() {},
		  onStop: function onStop() {},
		  onMouseDown: function onMouseDown() {}
		};
		exports.default = DraggableCore;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = log;
		
		/*eslint no-console:0*/
		function log() {
		  var _console;
		
		  if ((undefined)) (_console = console).log.apply(_console, arguments);
		}
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=react-draggable.js.map

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Table = __webpack_require__(1363);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _ExplicitSize = __webpack_require__(1271);
	
	var _ExplicitSize2 = _interopRequireDefault(_ExplicitSize);
	
	var _Ellipsified = __webpack_require__(1277);
	
	var _Ellipsified2 = _interopRequireDefault(_Ellipsified);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _formatting = __webpack_require__(872);
	
	var _table = __webpack_require__(1302);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableSimple = (0, _ExplicitSize2.default)(_class = (_temp = _class2 = function (_Component) {
	    _inherits(TableSimple, _Component);
	
	    function TableSimple(props) {
	        _classCallCheck(this, TableSimple);
	
	        var _this = _possibleConstructorReturn(this, (TableSimple.__proto__ || Object.getPrototypeOf(TableSimple)).call(this, props));
	
	        _this.state = {
	            page: 0,
	            pageSize: 1,
	            sortColumn: null,
	            sortDescending: false
	        };
	        return _this;
	    }
	
	    _createClass(TableSimple, [{
	        key: "setSort",
	        value: function setSort(colIndex) {
	            if (this.state.sortColumn === colIndex) {
	                this.setState({ sortDescending: !this.state.sortDescending });
	            } else {
	                this.setState({ sortColumn: colIndex });
	            }
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var headerHeight = _reactDom2.default.findDOMNode(this.refs.header).getBoundingClientRect().height;
	            var footerHeight = this.refs.footer ? _reactDom2.default.findDOMNode(this.refs.footer).getBoundingClientRect().height : 0;
	            var rowHeight = _reactDom2.default.findDOMNode(this.refs.firstRow).getBoundingClientRect().height + 1;
	            var pageSize = Math.max(1, Math.floor((this.props.height - headerHeight - footerHeight) / rowHeight));
	            if (this.state.pageSize !== pageSize) {
	                this.setState({ pageSize: pageSize });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                data = _props.data,
	                onVisualizationClick = _props.onVisualizationClick,
	                visualizationIsClickable = _props.visualizationIsClickable,
	                isPivoted = _props.isPivoted;
	            var rows = data.rows,
	                cols = data.cols;
	            var _state = this.state,
	                page = _state.page,
	                pageSize = _state.pageSize,
	                sortColumn = _state.sortColumn,
	                sortDescending = _state.sortDescending;
	
	
	            var start = pageSize * page;
	            var end = Math.min(rows.length - 1, pageSize * (page + 1) - 1);
	
	            var rowIndexes = _underscore2.default.range(0, rows.length);
	            if (sortColumn != null) {
	                rowIndexes = _underscore2.default.sortBy(rowIndexes, function (rowIndex) {
	                    return rows[rowIndex][sortColumn];
	                });
	                if (sortDescending) {
	                    rowIndexes.reverse();
	                }
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(this.props.className, "relative flex flex-column") },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex-full relative" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "absolute top bottom left right scroll-x scroll-show scroll-show--horizontal scroll-show--hover", style: { overflowY: "hidden" } },
	                        _react2.default.createElement(
	                            "table",
	                            { className: (0, _classnames2.default)(_Table2.default.Table, _Table2.default.TableSimple, 'fullscreen-normal-text', 'fullscreen-night-text') },
	                            _react2.default.createElement(
	                                "thead",
	                                { ref: "header" },
	                                _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    cols.map(function (col, colIndex) {
	                                        return _react2.default.createElement(
	                                            "th",
	                                            {
	                                                key: colIndex,
	                                                className: (0, _classnames2.default)("TableInteractive-headerCellData cellData text-brand-hover", {
	                                                    "TableInteractive-headerCellData--sorted": sortColumn === colIndex,
	                                                    "text-right": (0, _table.isColumnRightAligned)(col)
	                                                }),
	                                                onClick: function onClick() {
	                                                    return _this2.setSort(colIndex);
	                                                }
	                                            },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "relative" },
	                                                _react2.default.createElement(_Icon2.default, {
	                                                    name: sortDescending ? "chevrondown" : "chevronup",
	                                                    width: 8, height: 8,
	                                                    style: { position: "absolute", right: "100%", marginRight: 3 }
	                                                }),
	                                                _react2.default.createElement(
	                                                    _Ellipsified2.default,
	                                                    null,
	                                                    (0, _formatting.formatColumn)(col)
	                                                )
	                                            )
	                                        );
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "tbody",
	                                null,
	                                rowIndexes.slice(start, end + 1).map(function (rowIndex, index) {
	                                    return _react2.default.createElement(
	                                        "tr",
	                                        { key: rowIndex, ref: index === 0 ? "firstRow" : null },
	                                        rows[rowIndex].map(function (cell, columnIndex) {
	                                            var clicked = (0, _table.getTableCellClickedObject)(data, rowIndex, columnIndex, isPivoted);
	                                            var isClickable = onVisualizationClick && visualizationIsClickable(clicked);
	                                            return _react2.default.createElement(
	                                                "td",
	                                                {
	                                                    key: columnIndex,
	                                                    style: { whiteSpace: "nowrap" },
	                                                    className: (0, _classnames2.default)("px1 border-bottom", { "text-right": (0, _table.isColumnRightAligned)(cols[columnIndex]) })
	                                                },
	                                                _react2.default.createElement(
	                                                    "span",
	                                                    {
	                                                        className: (0, _classnames2.default)({ "cursor-pointer text-brand-hover": isClickable }),
	                                                        onClick: isClickable && function (e) {
	                                                            onVisualizationClick(_extends({}, clicked, { element: e.currentTarget }));
	                                                        }
	                                                    },
	                                                    cell == null ? "-" : (0, _formatting.formatValue)(cell, { column: cols[columnIndex], jsx: true })
	                                                )
	                                            );
	                                        })
	                                    );
	                                })
	                            )
	                        )
	                    )
	                ),
	                pageSize < rows.length ? _react2.default.createElement(
	                    "div",
	                    { ref: "footer", className: "p1 flex flex-no-shrink flex-align-right fullscreen-normal-text fullscreen-night-text" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "text-bold" },
	                        "Rows ",
	                        start + 1,
	                        "-",
	                        end + 1,
	                        " of ",
	                        rows.length
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: (0, _classnames2.default)("text-brand-hover px1 cursor-pointer", { disabled: start === 0 }), onClick: function onClick() {
	                                return _this2.setState({ page: page - 1 });
	                            } },
	                        _react2.default.createElement(_Icon2.default, { name: "left", size: 10 })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: (0, _classnames2.default)("text-brand-hover pr1 cursor-pointer", { disabled: end + 1 >= rows.length }), onClick: function onClick() {
	                                return _this2.setState({ page: page + 1 });
	                            } },
	                        _react2.default.createElement(_Icon2.default, { name: "right", size: 10 })
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return TableSimple;
	}(_react.Component), _class2.propTypes = {
	    data: _propTypes2.default.object.isRequired
	}, _class2.defaultProps = {
	    className: ""
	}, _temp)) || _class;
	
	TableSimple.displayName = "TableSimple";
	exports.default = TableSimple;

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Table":"CtorL","TableSimple":"ipoXK"};

/***/ }),
/* 1364 */,
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.pivot = pivot;
	exports.distinctValues = distinctValues;
	exports.cardinality = cardinality;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _schema_metadata = __webpack_require__(867);
	
	var SchemaMetadata = _interopRequireWildcard(_schema_metadata);
	
	var _formatting = __webpack_require__(872);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function compareNumbers(a, b) {
	    return a - b;
	}
	
	function pivot(data) {
	    // find the lowest cardinality dimension and make it our "pivoted" column
	    // TODO: we assume dimensions are in the first 2 columns, which is less than ideal
	    var pivotCol = 0,
	        normalCol = 1,
	        cellCol = 2,
	        pivotColValues = distinctValues(data, pivotCol),
	        normalColValues = distinctValues(data, normalCol);
	    if (normalColValues.length <= pivotColValues.length) {
	        pivotCol = 1;
	        normalCol = 0;
	
	        var tmp = pivotColValues;
	        pivotColValues = normalColValues;
	        normalColValues = tmp;
	    }
	
	    // sort the column values sensibly
	    if (SchemaMetadata.isNumeric(data.cols[pivotCol])) {
	        pivotColValues.sort(compareNumbers);
	    } else {
	        pivotColValues.sort();
	    }
	
	    if (SchemaMetadata.isNumeric(data.cols[normalCol])) {
	        normalColValues.sort(compareNumbers);
	    } else {
	        normalColValues.sort();
	    }
	
	    // make sure that the first element in the pivoted column list is null which makes room for the label of the other column
	    pivotColValues.unshift(data.cols[normalCol].display_name);
	
	    // start with an empty grid that we'll fill with the appropriate values
	    var pivotedRows = normalColValues.map(function (normalColValues, index) {
	        var row = pivotColValues.map(function () {
	            return null;
	        });
	        // for onVisualizationClick:
	        row._dimension = {
	            value: normalColValues,
	            column: data.cols[normalCol]
	        };
	        return row;
	    });
	
	    // fill it up with the data
	    for (var j = 0; j < data.rows.length; j++) {
	        var normalColIdx = normalColValues.lastIndexOf(data.rows[j][normalCol]);
	        var pivotColIdx = pivotColValues.lastIndexOf(data.rows[j][pivotCol]);
	
	        pivotedRows[normalColIdx][0] = data.rows[j][normalCol];
	        // NOTE: we are hard coding the expectation that the metric is in the 3rd column
	        pivotedRows[normalColIdx][pivotColIdx] = data.rows[j][2];
	    }
	
	    // provide some column metadata to maintain consistency
	    var cols = pivotColValues.map(function (value, idx) {
	        if (idx === 0) {
	            // first column is always the coldef of the normal column
	            return data.cols[normalCol];
	        }
	
	        var colDef = _underscore2.default.clone(data.cols[cellCol]);
	        colDef.name = colDef.display_name = (0, _formatting.formatValue)(value, { column: data.cols[pivotCol] }) || "";
	        // for onVisualizationClick:
	        colDef._dimension = {
	            value: value,
	            column: data.cols[pivotCol]
	        };
	        // delete colDef.id
	        return colDef;
	    });
	
	    return {
	        cols: cols,
	        columns: pivotColValues,
	        rows: pivotedRows
	    };
	}
	
	function distinctValues(data, colIdx) {
	    var vals = data.rows.map(function (r) {
	        return r[colIdx];
	    });
	
	    return vals.filter(function (v, i) {
	        return i == vals.lastIndexOf(v);
	    });
	}
	
	function cardinality(data, colIdx) {
	    return distinctValues(data, colIdx).length;
	}

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CheckBox = __webpack_require__(1004);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _reactSortable = __webpack_require__(1367);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderedFieldListItem = (0, _reactSortable.sortable)(_class = function (_Component) {
	    _inherits(OrderedFieldListItem, _Component);
	
	    function OrderedFieldListItem() {
	        _classCallCheck(this, OrderedFieldListItem);
	
	        return _possibleConstructorReturn(this, (OrderedFieldListItem.__proto__ || Object.getPrototypeOf(OrderedFieldListItem)).apply(this, arguments));
	    }
	
	    _createClass(OrderedFieldListItem, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                _extends({}, this.props, { className: "list-item" }),
	                this.props.children
	            );
	        }
	    }]);
	
	    return OrderedFieldListItem;
	}(_react.Component)) || _class;
	
	OrderedFieldListItem.displayName = "OrderedFieldListItem";
	
	var ChartSettingOrderedFields = function (_Component2) {
	    _inherits(ChartSettingOrderedFields, _Component2);
	
	    function ChartSettingOrderedFields(props) {
	        _classCallCheck(this, ChartSettingOrderedFields);
	
	        var _this2 = _possibleConstructorReturn(this, (ChartSettingOrderedFields.__proto__ || Object.getPrototypeOf(ChartSettingOrderedFields)).call(this, props));
	
	        _this2.updateState = function (obj) {
	            _this2.setState(obj);
	            if (obj.draggingIndex == null) {
	                _this2.props.onChange([].concat(_toConsumableArray(_this2.state.data.items)));
	            }
	        };
	
	        _this2.setEnabled = function (index, checked) {
	            var items = [].concat(_toConsumableArray(_this2.state.data.items));
	            items[index] = _extends({}, items[index], { enabled: checked });
	            _this2.setState({ data: { items: items } });
	            _this2.props.onChange([].concat(_toConsumableArray(items)));
	        };
	
	        _this2.state = {
	            draggingIndex: null,
	            data: { items: [].concat(_toConsumableArray(_this2.props.value)) }
	        };
	        return _this2;
	    }
	
	    _createClass(ChartSettingOrderedFields, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ data: { items: [].concat(_toConsumableArray(nextProps.value)) } });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var columnNames = this.props.columnNames;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "list" },
	                this.state.data.items.map(function (item, i) {
	                    return _react2.default.createElement(
	                        OrderedFieldListItem,
	                        {
	                            key: i,
	                            updateState: _this3.updateState,
	                            items: _this3.state.data.items,
	                            draggingIndex: _this3.state.draggingIndex,
	                            sortId: i,
	                            outline: "list"
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            { className: (0, _classnames2.default)("flex align-center p1", { "text-grey-2": !item.enabled }) },
	                            _react2.default.createElement(_CheckBox2.default, {
	                                checked: item.enabled,
	                                onChange: function onChange(e) {
	                                    return _this3.setEnabled(i, e.target.checked);
	                                }
	                            }),
	                            _react2.default.createElement(
	                                "span",
	                                { className: "ml1 h4" },
	                                columnNames[item.name]
	                            ),
	                            _react2.default.createElement(_Icon2.default, { className: "flex-align-right text-grey-2 mr1 cursor-pointer", name: "grabber", width: 14, height: 14 })
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return ChartSettingOrderedFields;
	}(_react.Component);
	
	ChartSettingOrderedFields.displayName = "ChartSettingOrderedFields";
	exports.default = ChartSettingOrderedFields;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SortableComposition = __webpack_require__(1368);
	
	Object.defineProperty(exports, 'sortable', {
	  enumerable: true,
	  get: function get() {
	    return _SortableComposition.SortableComposition;
	  }
	});

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.swapArrayElements = swapArrayElements;
	exports.isMouseBeyond = isMouseBeyond;
	exports.SortableComposition = SortableComposition;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*** Helper functions - they are decoupled from component itself for testability */
	
	/**
	 * @param {array} items
	 * @param {number} indexFrom
	 * @param {number} indexTo
	 * @returns {array}
	 */
	function swapArrayElements(items, indexFrom, indexTo) {
	  var item = items[indexTo];
	  items[indexTo] = items[indexFrom];
	  items[indexFrom] = item;
	  return items;
	}
	
	/**
	 * @param {number} mousePos
	 * @param {number} elementPos
	 * @param {number} elementSize
	 * @returns {boolean}
	 */
	function isMouseBeyond(mousePos, elementPos, elementSize) {
	  //TODO refactor for UP
	  var breakPoint = elementSize / 2; //break point is set to the middle line of element
	  var mouseOverlap = mousePos - elementPos;
	  return mouseOverlap > breakPoint;
	}
	
	/*** Higher-order component - this component works like a factory for draggable items */
	
	function SortableComposition(Component) {
	
	  var elementEdge = 0;
	  var updateEdge = true;
	
	  return _react2.default.createClass({
	
	    proptypes: {
	      items: _react2.default.PropTypes.array.isRequired,
	      updateState: _react2.default.PropTypes.func.isRequired,
	      sortId: _react2.default.PropTypes.number,
	      outline: _react2.default.PropTypes.string.isRequired, // list | grid
	      draggingIndex: _react2.default.PropTypes.number,
	      childProps: _react2.default.PropTypes.object
	    },
	
	    getInitialState: function getInitialState() {
	      return {
	        draggingIndex: null
	      };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        draggingIndex: nextProps.draggingIndex
	      });
	    },
	    sortEnd: function sortEnd(e) {
	      e.preventDefault();
	      this.props.updateState({
	        draggingIndex: null
	      });
	    },
	    sortStart: function sortStart(e) {
	      var draggingIndex = e.currentTarget.dataset.id;
	
	      this.props.updateState({
	        draggingIndex: draggingIndex
	      });
	      this.setState({
	        draggingIndex: draggingIndex
	      });
	
	      var dt = e.dataTransfer;
	      if (dt !== undefined) {
	        e.dataTransfer.setData('text', e.target);
	
	        //fix http://stackoverflow.com/questions/27656183/preserve-appearance-of-dragged-a-element-when-using-html5-draggable-attribute
	        if (dt.setDragImage && e.currentTarget.tagName.toLowerCase() === 'a') {
	          dt.setDragImage(e.target, 0, 0);
	        }
	      }
	      updateEdge = true;
	    },
	    dragOver: function dragOver(e) {
	      e.preventDefault();
	      var mouseBeyond;
	      var positionX, positionY;
	      var height, topOffset;
	      var items = this.props.items;
	      var overEl = e.currentTarget; //underlying element //TODO: not working for touch
	      var indexDragged = Number(overEl.dataset.id); //index of underlying element in the set DOM elements
	      var indexFrom = Number(this.state.draggingIndex);
	
	      height = overEl.getBoundingClientRect().height;
	
	      positionX = e.clientX;
	      positionY = e.clientY;
	      topOffset = overEl.getBoundingClientRect().top;
	
	      if (this.props.outline === "list") {
	        mouseBeyond = isMouseBeyond(positionY, topOffset, height);
	      }
	
	      if (this.props.outline === "grid") {
	        mouseBeyond = isMouseBeyond(positionX, overEl.getBoundingClientRect().left, overEl.getBoundingClientRect().width);
	      }
	
	      if (indexDragged !== indexFrom && mouseBeyond) {
	        items = swapArrayElements(items, indexFrom, indexDragged);
	        this.props.updateState({
	          items: items, draggingIndex: indexDragged
	        });
	      }
	    },
	    isDragging: function isDragging() {
	      return this.props.draggingIndex == this.props.sortId;
	    },
	    render: function render() {
	      var draggingClassName = Component.displayName + "-dragging";
	      return _react2.default.createElement(Component, _extends({
	        className: this.isDragging() ? draggingClassName : "",
	        draggable: true,
	        onDragOver: this.dragOver,
	        onDragStart: this.sortStart,
	        onDragEnd: this.sortEnd,
	        onDrop: function onDrop(e) {
	          e.preventDefault();
	        },
	        onTouchStart: this.sortStart,
	        onTouchMove: this.dragOver,
	        onTouchEnd: this.sortEnd,
	        children: this.props.children,
	        'data-id': this.props.sortId
	      }, this.props.childProps || {}));
	    }
	  });
	}

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _LineAreaBarChart2 = __webpack_require__(1370);
	
	var _LineAreaBarChart3 = _interopRequireDefault(_LineAreaBarChart2);
	
	var _LineAreaBarRenderer = __webpack_require__(1389);
	
	var _graph = __webpack_require__(1394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LineChart = (_temp = _class = function (_LineAreaBarChart) {
	    _inherits(LineChart, _LineAreaBarChart);
	
	    function LineChart() {
	        _classCallCheck(this, LineChart);
	
	        return _possibleConstructorReturn(this, (LineChart.__proto__ || Object.getPrototypeOf(LineChart)).apply(this, arguments));
	    }
	
	    return LineChart;
	}(_LineAreaBarChart3.default), _class.uiName = "Line", _class.identifier = "line", _class.iconName = "line", _class.noun = "line chart", _class.settings = _extends({}, _graph.GRAPH_DATA_SETTINGS, _graph.LINE_SETTINGS, _graph.GRAPH_GOAL_SETTINGS, _graph.LINE_SETTINGS_2, _graph.GRAPH_COLORS_SETTINGS, _graph.GRAPH_AXIS_SETTINGS), _class.renderer = _LineAreaBarRenderer.lineRenderer, _temp);
	exports.default = LineChart;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CardRenderer = __webpack_require__(1371);
	
	var _CardRenderer2 = _interopRequireDefault(_CardRenderer);
	
	var _LegendHeader = __webpack_require__(1273);
	
	var _LegendHeader2 = _interopRequireDefault(_LegendHeader);
	
	var _TitleLegendHeader = __webpack_require__(1373);
	
	__webpack_require__(1374);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _utils = __webpack_require__(878);
	
	var _dom = __webpack_require__(859);
	
	var _formatting = __webpack_require__(872);
	
	var _settings = __webpack_require__(1376);
	
	var _errors = __webpack_require__(1388);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SERIES = 20;
	
	var MUTE_STYLE = "opacity: 0.25;";
	for (var i = 0; i < MAX_SERIES; i++) {
	    (0, _dom.addCSSRule)(".LineAreaBarChart.mute-" + i + " svg.stacked .stack._" + i + " .area", MUTE_STYLE);
	    (0, _dom.addCSSRule)(".LineAreaBarChart.mute-" + i + " svg.stacked .stack._" + i + " .line", MUTE_STYLE);
	    (0, _dom.addCSSRule)(".LineAreaBarChart.mute-" + i + " svg.stacked .stack._" + i + " .bar", MUTE_STYLE);
	    (0, _dom.addCSSRule)(".LineAreaBarChart.mute-" + i + " svg.stacked .dc-tooltip._" + i + " .dot", MUTE_STYLE);
	
	    (0, _dom.addCSSRule)(".LineAreaBarChart.mute-" + i + " svg:not(.stacked) .sub._" + i + " .bar", MUTE_STYLE);
	    (0, _dom.addCSSRule)(".LineAreaBarChart.mute-" + i + " svg:not(.stacked) .sub._" + i + " .line", MUTE_STYLE);
	    (0, _dom.addCSSRule)(".LineAreaBarChart.mute-" + i + " svg:not(.stacked) .sub._" + i + " .dot", MUTE_STYLE);
	    (0, _dom.addCSSRule)(".LineAreaBarChart.mute-" + i + " svg:not(.stacked) .sub._" + i + " .bubble", MUTE_STYLE);
	
	    // row charts don't support multiseries
	    (0, _dom.addCSSRule)(".LineAreaBarChart.mute-" + i + " svg:not(.stacked) .row", MUTE_STYLE);
	}
	
	var LineAreaBarChart = (_temp = _class = function (_Component) {
	    _inherits(LineAreaBarChart, _Component);
	
	    function LineAreaBarChart() {
	        _classCallCheck(this, LineAreaBarChart);
	
	        return _possibleConstructorReturn(this, (LineAreaBarChart.__proto__ || Object.getPrototypeOf(LineAreaBarChart)).apply(this, arguments));
	    }
	
	    _createClass(LineAreaBarChart, [{
	        key: "getHoverClasses",
	        value: function getHoverClasses() {
	            var hovered = this.props.hovered;
	
	            if (hovered && hovered.index != null) {
	                var seriesClasses = _underscore2.default.range(0, MAX_SERIES).filter(function (n) {
	                    return n !== hovered.index;
	                }).map(function (n) {
	                    return "mute-" + n;
	                });
	                var axisClasses = hovered.axisIndex === 0 ? "mute-yr" : hovered.axisIndex === 1 ? "mute-yl" : null;
	                return seriesClasses.concat(axisClasses);
	            } else {
	                return null;
	            }
	        }
	    }, {
	        key: "getFidelity",
	        value: function getFidelity() {
	            var fidelity = { x: 0, y: 0 };
	            var size = this.props.gridSize || { width: Infinity, height: Infinity };
	            if (size.width >= 5) {
	                fidelity.x = 2;
	            } else if (size.width >= 4) {
	                fidelity.x = 1;
	            }
	            if (size.height >= 5) {
	                fidelity.y = 2;
	            } else if (size.height >= 4) {
	                fidelity.y = 1;
	            }
	
	            return fidelity;
	        }
	    }, {
	        key: "getSettings",
	        value: function getSettings() {
	            var fidelity = this.getFidelity();
	
	            var settings = _extends({}, this.props.settings);
	
	            // no axis in < 1 fidelity
	            if (fidelity.x < 1) {
	                settings["graph.y_axis.axis_enabled"] = false;
	            }
	            if (fidelity.y < 1) {
	                settings["graph.x_axis.axis_enabled"] = false;
	            }
	
	            // no labels in < 2 fidelity
	            if (fidelity.x < 2) {
	                settings["graph.y_axis.labels_enabled"] = false;
	            }
	            if (fidelity.y < 2) {
	                settings["graph.x_axis.labels_enabled"] = false;
	            }
	
	            // smooth interpolation at smallest x/y fidelity
	            if (fidelity.x === 0 && fidelity.y === 0) {
	                settings["line.interpolate"] = "cardinal";
	            }
	
	            return settings;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                series = _props.series,
	                hovered = _props.hovered,
	                showTitle = _props.showTitle,
	                actionButtons = _props.actionButtons,
	                onChangeCardAndRun = _props.onChangeCardAndRun,
	                onVisualizationClick = _props.onVisualizationClick,
	                visualizationIsClickable = _props.visualizationIsClickable;
	
	
	            var settings = this.getSettings();
	
	            var multiseriesHeaderSeries = void 0;
	            if (series.length > 1) {
	                multiseriesHeaderSeries = series;
	            }
	
	            var hasTitle = showTitle && settings["card.title"];
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("LineAreaBarChart flex flex-column p1", this.getHoverClasses(), this.props.className) },
	                hasTitle && _react2.default.createElement(_TitleLegendHeader.TitleLegendHeader, {
	                    series: series,
	                    settings: settings,
	                    onChangeCardAndRun: onChangeCardAndRun,
	                    actionButtons: actionButtons
	                }),
	                multiseriesHeaderSeries || !hasTitle && actionButtons ? // always show action buttons if we have them
	                _react2.default.createElement(_LegendHeader2.default, {
	                    className: "flex-no-shrink",
	                    series: multiseriesHeaderSeries,
	                    settings: settings,
	                    hovered: hovered,
	                    onHoverChange: this.props.onHoverChange,
	                    actionButtons: !hasTitle ? actionButtons : null,
	                    onChangeCardAndRun: onChangeCardAndRun,
	                    onVisualizationClick: onVisualizationClick,
	                    visualizationIsClickable: visualizationIsClickable
	                }) : null,
	                _react2.default.createElement(_CardRenderer2.default, _extends({}, this.props, {
	                    series: series,
	                    settings: settings,
	                    className: "renderer flex-full",
	                    maxSeries: MAX_SERIES,
	                    renderer: this.constructor.renderer
	                }))
	            );
	        }
	    }], [{
	        key: "isSensible",
	        value: function isSensible(cols, rows) {
	            return (0, _utils.getChartTypeFromData)(cols, rows, false) != null;
	        }
	    }, {
	        key: "checkRenderable",
	        value: function checkRenderable(series, settings) {
	            var singleSeriesHasNoRows = function singleSeriesHasNoRows(_ref) {
	                var _ref$data = _ref.data,
	                    cols = _ref$data.cols,
	                    rows = _ref$data.rows;
	                return rows.length < 1;
	            };
	            if (_underscore2.default.every(series, singleSeriesHasNoRows)) {
	                throw new _errors.MinRowsError(1, 0);
	            }
	
	            var dimensions = (settings["graph.dimensions"] || []).filter(function (name) {
	                return name;
	            });
	            var metrics = (settings["graph.metrics"] || []).filter(function (name) {
	                return name;
	            });
	            if (dimensions.length < 1 || metrics.length < 1) {
	                throw new _errors.ChartSettingsError("Which fields do you want to use for the X and Y axes?", "Data", "Choose fields");
	            }
	        }
	    }, {
	        key: "seriesAreCompatible",
	        value: function seriesAreCompatible(initialSeries, newSeries) {
	            var initialSettings = (0, _settings.getSettings)([initialSeries]);
	            var newSettings = (0, _settings.getSettings)([newSeries]);
	
	            var initialDimensions = getColumnsFromNames(initialSeries.data.cols, initialSettings["graph.dimensions"]);
	            var newDimensions = getColumnsFromNames(newSeries.data.cols, newSettings["graph.dimensions"]);
	            var newMetrics = getColumnsFromNames(newSeries.data.cols, newSettings["graph.metrics"]);
	
	            // must have at least one dimension and one metric
	            if (newDimensions.length === 0 || newMetrics.length === 0) {
	                return false;
	            }
	
	            // all metrics must be numeric
	            if (!_underscore2.default.all(newMetrics, _schema_metadata.isNumeric)) {
	                return false;
	            }
	
	            // both or neither primary dimension must be dates
	            if ((0, _schema_metadata.isDate)(initialDimensions[0]) !== (0, _schema_metadata.isDate)(newDimensions[0])) {
	                return false;
	            }
	
	            // both or neither primary dimension must be numeric
	            // a timestamp field is both date and number so don't enforce the condition if both fields are dates; see #2811
	            if ((0, _schema_metadata.isNumeric)(initialDimensions[0]) !== (0, _schema_metadata.isNumeric)(newDimensions[0]) && !((0, _schema_metadata.isDate)(initialDimensions[0]) && (0, _schema_metadata.isDate)(newDimensions[0]))) {
	                return false;
	            }
	
	            return true;
	        }
	    }, {
	        key: "transformSeries",
	        value: function transformSeries(series) {
	            var _ref2;
	
	            var newSeries = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(series.map(function (s, seriesIndex) {
	                return transformSingleSeries(s, series, seriesIndex);
	            })));
	            if (_underscore2.default.isEqual(series, newSeries) || newSeries.length === 0) {
	                return series;
	            } else {
	                return newSeries;
	            }
	        }
	    }]);
	
	    return LineAreaBarChart;
	}(_react.Component), _class.noHeader = true, _class.supportsSeries = true, _class.minSize = { width: 4, height: 3 }, _class.propTypes = {
	    series: _propTypes2.default.array.isRequired,
	    actionButtons: _propTypes2.default.node,
	    showTitle: _propTypes2.default.bool,
	    isDashboard: _propTypes2.default.bool
	}, _class.defaultProps = {}, _temp);
	LineAreaBarChart.displayName = "LineAreaBarChart";
	exports.default = LineAreaBarChart;
	
	
	function getColumnsFromNames(cols, names) {
	    if (!names) {
	        return [];
	    }
	    return names.map(function (name) {
	        return _underscore2.default.findWhere(cols, { name: name });
	    });
	}
	
	function transformSingleSeries(s, series, seriesIndex) {
	    var card = s.card,
	        data = s.data;
	
	    // HACK: prevents cards from being transformed too many times
	
	    if (card._transformed) {
	        return [s];
	    }
	
	    var cols = data.cols,
	        rows = data.rows;
	
	    var settings = (0, _settings.getSettings)([s]);
	
	    var dimensions = settings["graph.dimensions"].filter(function (d) {
	        return d != null;
	    });
	    var metrics = settings["graph.metrics"].filter(function (d) {
	        return d != null;
	    });
	    var dimensionColumnIndexes = dimensions.map(function (dimensionName) {
	        return _underscore2.default.findIndex(cols, function (col) {
	            return col.name === dimensionName;
	        });
	    });
	    var metricColumnIndexes = metrics.map(function (metricName) {
	        return _underscore2.default.findIndex(cols, function (col) {
	            return col.name === metricName;
	        });
	    });
	    var bubbleColumnIndex = settings["scatter.bubble"] && _underscore2.default.findIndex(cols, function (col) {
	        return col.name === settings["scatter.bubble"];
	    });
	    var extraColumnIndexes = bubbleColumnIndex && bubbleColumnIndex >= 0 ? [bubbleColumnIndex] : [];
	
	    if (dimensions.length > 1) {
	        var _dimensionColumnIndex = _slicedToArray(dimensionColumnIndexes, 2),
	            dimensionColumnIndex = _dimensionColumnIndex[0],
	            seriesColumnIndex = _dimensionColumnIndex[1];
	
	        var rowColumnIndexes = [dimensionColumnIndex].concat(metricColumnIndexes, extraColumnIndexes);
	
	        var breakoutValues = [];
	        var breakoutRowsByValue = new Map();
	
	        var _loop = function _loop(rowIndex) {
	            var row = rows[rowIndex];
	            var seriesValue = row[seriesColumnIndex];
	
	            var seriesRows = breakoutRowsByValue.get(seriesValue);
	            if (!seriesRows) {
	                breakoutRowsByValue.set(seriesValue, seriesRows = []);
	                breakoutValues.push(seriesValue);
	            }
	
	            var newRow = rowColumnIndexes.map(function (columnIndex) {
	                return row[columnIndex];
	            });
	            // $FlowFixMe: _origin not typed
	            newRow._origin = { seriesIndex: seriesIndex, rowIndex: rowIndex, row: row, cols: cols };
	            seriesRows.push(newRow);
	        };
	
	        for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
	            _loop(rowIndex);
	        }
	
	        return breakoutValues.map(function (breakoutValue) {
	            return {
	                card: _extends({}, card, {
	                    // if multiseries include the card title as well as the breakout value
	                    name: [
	                    // show series title if it's multiseries
	                    series.length > 1 && card.name,
	                    // always show grouping value
	                    (0, _formatting.formatValue)(breakoutValue, { column: cols[seriesColumnIndex] })].filter(function (n) {
	                        return n;
	                    }).join(": "),
	                    _transformed: true,
	                    _breakoutValue: breakoutValue,
	                    _breakoutColumn: cols[seriesColumnIndex]
	                }),
	                data: {
	                    rows: breakoutRowsByValue.get(breakoutValue),
	                    cols: rowColumnIndexes.map(function (i) {
	                        return cols[i];
	                    }),
	                    _rawCols: cols
	                },
	                // for when the legend header for the breakout is clicked
	                clicked: {
	                    dimensions: [{
	                        value: breakoutValue,
	                        column: cols[seriesColumnIndex]
	                    }]
	                }
	            };
	        });
	    } else {
	        var _dimensionColumnIndex2 = dimensionColumnIndexes[0];
	        return metricColumnIndexes.map(function (metricColumnIndex) {
	            var col = cols[metricColumnIndex];
	            var rowColumnIndexes = [_dimensionColumnIndex2].concat(metricColumnIndex, extraColumnIndexes);
	            return {
	                card: _extends({}, card, {
	                    name: [
	                    // show series title if it's multiseries
	                    series.length > 1 && card.name,
	                    // show column name if there are multiple metrics
	                    metricColumnIndexes.length > 1 && (0, _utils.getFriendlyName)(col)].filter(function (n) {
	                        return n;
	                    }).join(": "),
	                    _transformed: true,
	                    _seriesIndex: seriesIndex
	                }),
	                data: {
	                    rows: rows.map(function (row, rowIndex) {
	                        var newRow = rowColumnIndexes.map(function (i) {
	                            return row[i];
	                        });
	                        // $FlowFixMe: _origin not typed
	                        newRow._origin = { seriesIndex: seriesIndex, rowIndex: rowIndex, row: row, cols: cols };
	                        return newRow;
	                    }),
	                    cols: rowColumnIndexes.map(function (i) {
	                        return cols[i];
	                    }),
	                    _rawCols: cols
	                }
	            };
	        });
	    }
	}

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /* eslint "react/prop-types": "warn" */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ExplicitSize = __webpack_require__(1271);
	
	var _ExplicitSize2 = _interopRequireDefault(_ExplicitSize);
	
	var _utils = __webpack_require__(878);
	
	var _dc = __webpack_require__(1372);
	
	var _dc2 = _interopRequireDefault(_dc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardRenderer = (0, _ExplicitSize2.default)(_class = (_temp = _class2 = function (_Component) {
	    _inherits(CardRenderer, _Component);
	
	    function CardRenderer() {
	        _classCallCheck(this, CardRenderer);
	
	        return _possibleConstructorReturn(this, (CardRenderer.__proto__ || Object.getPrototypeOf(CardRenderer)).apply(this, arguments));
	    }
	
	    _createClass(CardRenderer, [{
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            // a chart only needs re-rendering when the result itself changes OR the chart type is different
	            var sameSize = this.props.width === nextProps.width && this.props.height === nextProps.height;
	            var sameSeries = (0, _utils.isSameSeries)(this.props.series, nextProps.series);
	            return !(sameSize && sameSeries);
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.renderChart();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this.renderChart();
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            this._deregisterChart();
	        }
	    }, {
	        key: "_deregisterChart",
	        value: function _deregisterChart() {
	            if (this._chart) {
	                // Prevents memory leak
	                _dc2.default.chartRegistry.deregister(this._chart);
	                delete this._chart;
	            }
	        }
	    }, {
	        key: "renderChart",
	        value: function renderChart() {
	            if (this.props.width == null || this.props.height == null) {
	                return;
	            }
	
	            var parent = _reactDom2.default.findDOMNode(this);
	
	            // deregister previous chart:
	            this._deregisterChart();
	
	            // reset the DOM:
	            var element = parent.firstChild;
	            if (element) {
	                parent.removeChild(element);
	            }
	
	            // create a new container element
	            element = document.createElement("div");
	            parent.appendChild(element);
	
	            try {
	                this._chart = this.props.renderer(element, this.props);
	            } catch (err) {
	                console.error(err);
	                this.props.onRenderError(err.message || err);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement("div", { className: this.props.className });
	        }
	    }]);
	
	    return CardRenderer;
	}(_react.Component), _class2.propTypes = {
	    series: _propTypes2.default.array.isRequired,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    renderer: _propTypes2.default.func.isRequired,
	    onRenderError: _propTypes2.default.func.isRequired,
	    className: _propTypes2.default.string
	}, _temp)) || _class;
	
	CardRenderer.displayName = "CardRenderer";
	exports.default = CardRenderer;

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 *  dc 2.1.4
	 *  http://dc-js.github.io/dc.js/
	 *  Copyright 2012-2016 Nick Zhu & the dc.js Developers
	 *  https://github.com/dc-js/dc.js/blob/master/AUTHORS
	 *
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	(function() { function _dc(d3, crossfilter) {
	'use strict';
	
	/**
	 * The entire dc.js library is scoped under the **dc** name space. It does not introduce
	 * anything else into the global name space.
	 *
	 * Most `dc` functions are designed to allow function chaining, meaning they return the current chart
	 * instance whenever it is appropriate.  The getter forms of functions do not participate in function
	 * chaining because they return values that are not the chart, although some,
	 * such as {@link dc.baseMixin#svg .svg} and {@link dc.coordinateGridMixin#xAxis .xAxis},
	 * return values that are themselves chainable d3 objects.
	 * @namespace dc
	 * @version 2.1.4
	 * @example
	 * // Example chaining
	 * chart.width(300)
	 *      .height(300)
	 *      .filter('sunday');
	 */
	/*jshint -W079*/
	var dc = {
	    version: '2.1.4',
	    constants: {
	        CHART_CLASS: 'dc-chart',
	        DEBUG_GROUP_CLASS: 'debug',
	        STACK_CLASS: 'stack',
	        DESELECTED_CLASS: 'deselected',
	        SELECTED_CLASS: 'selected',
	        NODE_INDEX_NAME: '__index__',
	        GROUP_INDEX_NAME: '__group_index__',
	        DEFAULT_CHART_GROUP: '__default_chart_group__',
	        EVENT_DELAY: 40,
	        NEGLIGIBLE_NUMBER: 1e-10
	    },
	    _renderlet: null
	};
	/*jshint +W079*/
	
	/**
	 * The dc.chartRegistry object maintains sets of all instantiated dc.js charts under named groups
	 * and the default group.
	 *
	 * A chart group often corresponds to a crossfilter instance. It specifies
	 * the set of charts which should be updated when a filter changes on one of the charts or when the
	 * global functions {@link dc.filterAll dc.filterAll}, {@link dc.refocusAll dc.refocusAll},
	 * {@link dc.renderAll dc.renderAll}, {@link dc.redrawAll dc.redrawAll}, or chart functions
	 * {@link dc.baseMixin#renderGroup baseMixin.renderGroup},
	 * {@link dc.baseMixin#redrawGroup baseMixin.redrawGroup} are called.
	 *
	 * @namespace chartRegistry
	 * @memberof dc
	 * @type {{has, register, deregister, clear, list}}
	 */
	dc.chartRegistry = (function () {
	    // chartGroup:string => charts:array
	    var _chartMap = {};
	
	    function initializeChartGroup (group) {
	        if (!group) {
	            group = dc.constants.DEFAULT_CHART_GROUP;
	        }
	
	        if (!_chartMap[group]) {
	            _chartMap[group] = [];
	        }
	
	        return group;
	    }
	
	    return {
	        /**
	         * Determine if a given chart instance resides in any group in the registry.
	         * @method has
	         * @memberof dc.chartRegistry
	         * @param {Object} chart dc.js chart instance
	         * @returns {Boolean}
	         */
	        has: function (chart) {
	            for (var e in _chartMap) {
	                if (_chartMap[e].indexOf(chart) >= 0) {
	                    return true;
	                }
	            }
	            return false;
	        },
	
	        /**
	         * Add given chart instance to the given group, creating the group if necessary.
	         * If no group is provided, the default group `dc.constants.DEFAULT_CHART_GROUP` will be used.
	         * @method register
	         * @memberof dc.chartRegistry
	         * @param {Object} chart dc.js chart instance
	         * @param {String} [group] Group name
	         */
	        register: function (chart, group) {
	            group = initializeChartGroup(group);
	            _chartMap[group].push(chart);
	        },
	
	        /**
	         * Remove given chart instance from the given group, creating the group if necessary.
	         * If no group is provided, the default group `dc.constants.DEFAULT_CHART_GROUP` will be used.
	         * @method deregister
	         * @memberof dc.chartRegistry
	         * @param {Object} chart dc.js chart instance
	         * @param {String} [group] Group name
	         */
	        deregister: function (chart, group) {
	            group = initializeChartGroup(group);
	            for (var i = 0; i < _chartMap[group].length; i++) {
	                if (_chartMap[group][i].anchorName() === chart.anchorName()) {
	                    _chartMap[group].splice(i, 1);
	                    break;
	                }
	            }
	        },
	
	        /**
	         * Clear given group if one is provided, otherwise clears all groups.
	         * @method clear
	         * @memberof dc.chartRegistry
	         * @param {String} group Group name
	         */
	        clear: function (group) {
	            if (group) {
	                delete _chartMap[group];
	            } else {
	                _chartMap = {};
	            }
	        },
	
	        /**
	         * Get an array of each chart instance in the given group.
	         * If no group is provided, the charts in the default group are returned.
	         * @method list
	         * @memberof dc.chartRegistry
	         * @param {String} [group] Group name
	         * @returns {Array<Object>}
	         */
	        list: function (group) {
	            group = initializeChartGroup(group);
	            return _chartMap[group];
	        }
	    };
	})();
	
	/**
	 * Add given chart instance to the given group, creating the group if necessary.
	 * If no group is provided, the default group `dc.constants.DEFAULT_CHART_GROUP` will be used.
	 * @memberof dc
	 * @method registerChart
	 * @param {Object} chart dc.js chart instance
	 * @param {String} [group] Group name
	 */
	dc.registerChart = function (chart, group) {
	    dc.chartRegistry.register(chart, group);
	};
	
	/**
	 * Remove given chart instance from the given group, creating the group if necessary.
	 * If no group is provided, the default group `dc.constants.DEFAULT_CHART_GROUP` will be used.
	 * @memberof dc
	 * @method deregisterChart
	 * @param {Object} chart dc.js chart instance
	 * @param {String} [group] Group name
	 */
	dc.deregisterChart = function (chart, group) {
	    dc.chartRegistry.deregister(chart, group);
	};
	
	/**
	 * Determine if a given chart instance resides in any group in the registry.
	 * @memberof dc
	 * @method hasChart
	 * @param {Object} chart dc.js chart instance
	 * @returns {Boolean}
	 */
	dc.hasChart = function (chart) {
	    return dc.chartRegistry.has(chart);
	};
	
	/**
	 * Clear given group if one is provided, otherwise clears all groups.
	 * @memberof dc
	 * @method deregisterAllCharts
	 * @param {String} group Group name
	 */
	dc.deregisterAllCharts = function (group) {
	    dc.chartRegistry.clear(group);
	};
	
	/**
	 * Clear all filters on all charts within the given chart group. If the chart group is not given then
	 * only charts that belong to the default chart group will be reset.
	 * @memberof dc
	 * @method filterAll
	 * @param {String} [group]
	 */
	dc.filterAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        charts[i].filterAll();
	    }
	};
	
	/**
	 * Reset zoom level / focus on all charts that belong to the given chart group. If the chart group is
	 * not given then only charts that belong to the default chart group will be reset.
	 * @memberof dc
	 * @method refocusAll
	 * @param {String} [group]
	 */
	dc.refocusAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        if (charts[i].focus) {
	            charts[i].focus();
	        }
	    }
	};
	
	/**
	 * Re-render all charts belong to the given chart group. If the chart group is not given then only
	 * charts that belong to the default chart group will be re-rendered.
	 * @memberof dc
	 * @method renderAll
	 * @param {String} [group]
	 */
	dc.renderAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        charts[i].render();
	    }
	
	    if (dc._renderlet !== null) {
	        dc._renderlet(group);
	    }
	};
	
	/**
	 * Redraw all charts belong to the given chart group. If the chart group is not given then only charts
	 * that belong to the default chart group will be re-drawn. Redraw is different from re-render since
	 * when redrawing dc tries to update the graphic incrementally, using transitions, instead of starting
	 * from scratch.
	 * @memberof dc
	 * @method redrawAll
	 * @param {String} [group]
	 */
	dc.redrawAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        charts[i].redraw();
	    }
	
	    if (dc._renderlet !== null) {
	        dc._renderlet(group);
	    }
	};
	
	/**
	 * If this boolean is set truthy, all transitions will be disabled, and changes to the charts will happen
	 * immediately.
	 * @memberof dc
	 * @member disableTransitions
	 * @type {Boolean}
	 * @default false
	 */
	dc.disableTransitions = false;
	
	/**
	 * Start a transition on a selection if transitions are globally enabled
	 * ({@link dc.disableTransitions} is false) and the duration is greater than zero; otherwise return
	 * the selection. Since most operations are the same on a d3 selection and a d3 transition, this
	 * allows a common code path for both cases.
	 * @memberof dc
	 * @method transition
	 * @param {d3.selection} selection - the selection to be transitioned
	 * @param {Number|Function} [duration=250] - the duration of the transition in milliseconds, a
	 * function returning the duration, or 0 for no transition
	 * @param {Number|Function} [delay] - the delay of the transition in milliseconds, or a function
	 * returning the delay, or 0 for no delay
	 * @param {String} [name] - the name of the transition (if concurrent transitions on the same
	 * elements are needed)
	 * @returns {d3.transition|d3.selection}
	 */
	dc.transition = function (selection, duration, delay, name) {
	    if (dc.disableTransitions || duration <= 0) {
	        return selection;
	    }
	
	    var s = selection.transition(name);
	
	    if (duration >= 0 || duration !== undefined) {
	        s = s.duration(duration);
	    }
	    if (delay >= 0 || delay !== undefined) {
	        s = s.delay(delay);
	    }
	
	    return s;
	};
	
	/* somewhat silly, but to avoid duplicating logic */
	dc.optionalTransition = function (enable, duration, delay, name) {
	    if (enable) {
	        return function (selection) {
	            return dc.transition(selection, duration, delay, name);
	        };
	    } else {
	        return function (selection) {
	            return selection;
	        };
	    }
	};
	
	// See http://stackoverflow.com/a/20773846
	dc.afterTransition = function (transition, callback) {
	    if (transition.empty() || !transition.duration) {
	        callback.call(transition);
	    } else {
	        var n = 0;
	        transition
	            .each(function () { ++n; })
	            .each('end', function () {
	                if (!--n) {
	                    callback.call(transition);
	                }
	            });
	    }
	};
	
	/**
	 * @namespace units
	 * @memberof dc
	 * @type {{}}
	 */
	dc.units = {};
	
	/**
	 * The default value for {@link dc.coordinateGridMixin#xUnits .xUnits} for the
	 * {@link dc.coordinateGridMixin Coordinate Grid Chart} and should
	 * be used when the x values are a sequence of integers.
	 * It is a function that counts the number of integers in the range supplied in its start and end parameters.
	 * @method integers
	 * @memberof dc.units
	 * @see {@link dc.coordinateGridMixin#xUnits coordinateGridMixin.xUnits}
	 * @example
	 * chart.xUnits(dc.units.integers) // already the default
	 * @param {Number} start
	 * @param {Number} end
	 * @returns {Number}
	 */
	dc.units.integers = function (start, end) {
	    return Math.abs(end - start);
	};
	
	/**
	 * This argument can be passed to the {@link dc.coordinateGridMixin#xUnits .xUnits} function of the to
	 * specify ordinal units for the x axis. Usually this parameter is used in combination with passing
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Ordinal-Scales.md d3.scale.ordinal} to
	 * {@link dc.coordinateGridMixin#x .x}.
	 * It just returns the domain passed to it, which for ordinal charts is an array of all values.
	 * @method ordinal
	 * @memberof dc.units
	 * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Ordinal-Scales.md d3.scale.ordinal}
	 * @see {@link dc.coordinateGridMixin#xUnits coordinateGridMixin.xUnits}
	 * @see {@link dc.coordinateGridMixin#x coordinateGridMixin.x}
	 * @example
	 * chart.xUnits(dc.units.ordinal)
	 *      .x(d3.scale.ordinal())
	 * @param {*} start
	 * @param {*} end
	 * @param {Array<String>} domain
	 * @returns {Array<String>}
	 */
	dc.units.ordinal = function (start, end, domain) {
	    return domain;
	};
	
	/**
	 * @namespace fp
	 * @memberof dc.units
	 * @type {{}}
	 */
	dc.units.fp = {};
	/**
	 * This function generates an argument for the {@link dc.coordinateGridMixin Coordinate Grid Chart}
	 * {@link dc.coordinateGridMixin#xUnits .xUnits} function specifying that the x values are floating-point
	 * numbers with the given precision.
	 * The returned function determines how many values at the given precision will fit into the range
	 * supplied in its start and end parameters.
	 * @method precision
	 * @memberof dc.units.fp
	 * @see {@link dc.coordinateGridMixin#xUnits coordinateGridMixin.xUnits}
	 * @example
	 * // specify values (and ticks) every 0.1 units
	 * chart.xUnits(dc.units.fp.precision(0.1)
	 * // there are 500 units between 0.5 and 1 if the precision is 0.001
	 * var thousandths = dc.units.fp.precision(0.001);
	 * thousandths(0.5, 1.0) // returns 500
	 * @param {Number} precision
	 * @returns {Function} start-end unit function
	 */
	dc.units.fp.precision = function (precision) {
	    var _f = function (s, e) {
	        var d = Math.abs((e - s) / _f.resolution);
	        if (dc.utils.isNegligible(d - Math.floor(d))) {
	            return Math.floor(d);
	        } else {
	            return Math.ceil(d);
	        }
	    };
	    _f.resolution = precision;
	    return _f;
	};
	
	dc.round = {};
	dc.round.floor = function (n) {
	    return Math.floor(n);
	};
	dc.round.ceil = function (n) {
	    return Math.ceil(n);
	};
	dc.round.round = function (n) {
	    return Math.round(n);
	};
	
	dc.override = function (obj, functionName, newFunction) {
	    var existingFunction = obj[functionName];
	    obj['_' + functionName] = existingFunction;
	    obj[functionName] = newFunction;
	};
	
	dc.renderlet = function (_) {
	    if (!arguments.length) {
	        return dc._renderlet;
	    }
	    dc._renderlet = _;
	    return dc;
	};
	
	dc.instanceOfChart = function (o) {
	    return o instanceof Object && o.__dcFlag__ && true;
	};
	
	dc.errors = {};
	
	dc.errors.Exception = function (msg) {
	    var _msg = msg || 'Unexpected internal error';
	
	    this.message = _msg;
	
	    this.toString = function () {
	        return _msg;
	    };
	    this.stack = (new Error()).stack;
	};
	dc.errors.Exception.prototype = Object.create(Error.prototype);
	dc.errors.Exception.prototype.constructor = dc.errors.Exception;
	
	dc.errors.InvalidStateException = function () {
	    dc.errors.Exception.apply(this, arguments);
	};
	
	dc.errors.InvalidStateException.prototype = Object.create(dc.errors.Exception.prototype);
	dc.errors.InvalidStateException.prototype.constructor = dc.errors.InvalidStateException;
	
	dc.errors.BadArgumentException = function () {
	    dc.errors.Exception.apply(this, arguments);
	};
	
	dc.errors.BadArgumentException.prototype = Object.create(dc.errors.Exception.prototype);
	dc.errors.BadArgumentException.prototype.constructor = dc.errors.BadArgumentException;
	
	/**
	 * The default date format for dc.js
	 * @name dateFormat
	 * @memberof dc
	 * @type {Function}
	 * @default d3.time.format('%m/%d/%Y')
	 */
	dc.dateFormat = d3.time.format('%m/%d/%Y');
	
	/**
	 * @namespace printers
	 * @memberof dc
	 * @type {{}}
	 */
	dc.printers = {};
	
	/**
	 * Converts a list of filters into a readable string.
	 * @method filters
	 * @memberof dc.printers
	 * @param {Array<dc.filters>} filters
	 * @returns {String}
	 */
	dc.printers.filters = function (filters) {
	    var s = '';
	
	    for (var i = 0; i < filters.length; ++i) {
	        if (i > 0) {
	            s += ', ';
	        }
	        s += dc.printers.filter(filters[i]);
	    }
	
	    return s;
	};
	
	/**
	 * Converts a filter into a readable string.
	 * @method filter
	 * @memberof dc.printers
	 * @param {dc.filters|any|Array<any>} filter
	 * @returns {String}
	 */
	dc.printers.filter = function (filter) {
	    var s = '';
	
	    if (typeof filter !== 'undefined' && filter !== null) {
	        if (filter instanceof Array) {
	            if (filter.length >= 2) {
	                s = '[' + dc.utils.printSingleValue(filter[0]) + ' -> ' + dc.utils.printSingleValue(filter[1]) + ']';
	            } else if (filter.length >= 1) {
	                s = dc.utils.printSingleValue(filter[0]);
	            }
	        } else {
	            s = dc.utils.printSingleValue(filter);
	        }
	    }
	
	    return s;
	};
	
	/**
	 * Returns a function that given a string property name, can be used to pluck the property off an object.  A function
	 * can be passed as the second argument to also alter the data being returned.
	 *
	 * This can be a useful shorthand method to create accessor functions.
	 * @method pluck
	 * @memberof dc
	 * @example
	 * var xPluck = dc.pluck('x');
	 * var objA = {x: 1};
	 * xPluck(objA) // 1
	 * @example
	 * var xPosition = dc.pluck('x', function (x, i) {
	 *     // `this` is the original datum,
	 *     // `x` is the x property of the datum,
	 *     // `i` is the position in the array
	 *     return this.radius + x;
	 * });
	 * dc.selectAll('.circle').data(...).x(xPosition);
	 * @param {String} n
	 * @param {Function} [f]
	 * @returns {Function}
	 */
	dc.pluck = function (n, f) {
	    if (!f) {
	        return function (d) { return d[n]; };
	    }
	    return function (d, i) { return f.call(d, d[n], i); };
	};
	
	/**
	 * @namespace utils
	 * @memberof dc
	 * @type {{}}
	 */
	dc.utils = {};
	
	/**
	 * Print a single value filter.
	 * @method printSingleValue
	 * @memberof dc.utils
	 * @param {any} filter
	 * @returns {String}
	 */
	dc.utils.printSingleValue = function (filter) {
	    var s = '' + filter;
	
	    if (filter instanceof Date) {
	        s = dc.dateFormat(filter);
	    } else if (typeof(filter) === 'string') {
	        s = filter;
	    } else if (dc.utils.isFloat(filter)) {
	        s = dc.utils.printSingleValue.fformat(filter);
	    } else if (dc.utils.isInteger(filter)) {
	        s = Math.round(filter);
	    }
	
	    return s;
	};
	dc.utils.printSingleValue.fformat = d3.format('.2f');
	
	/**
	 * Arbitrary add one value to another.
	 * @method add
	 * @memberof dc.utils
	 * @todo
	 * These assume than any string r is a percentage (whether or not it includes %).
	 * They also generate strange results if l is a string.
	 * @param {String|Date|Number} l the value to modify
	 * @param {Number} r the amount by which to modify the value
	 * @param {String} [t] if `l` is a `Date`, the
	 * [interval](https://github.com/d3/d3-3.x-api-reference/blob/master/Time-Intervals.md#interval) in
	 * the `d3.time` namespace
	 * @returns {String|Date|Number}
	 */
	dc.utils.add = function (l, r, t) {
	    if (typeof r === 'string') {
	        r = r.replace('%', '');
	    }
	
	    if (l instanceof Date) {
	        if (typeof r === 'string') {
	            r = +r;
	        }
	        if (t === 'millis') {
	            return new Date(l.getTime() + r);
	        }
	        t = t || 'day';
	        return d3.time[t].offset(l, r);
	    } else if (typeof r === 'string') {
	        var percentage = (+r / 100);
	        return l > 0 ? l * (1 + percentage) : l * (1 - percentage);
	    } else {
	        return l + r;
	    }
	};
	
	/**
	 * Arbitrary subtract one value from another.
	 * @method subtract
	 * @memberof dc.utils
	 * @todo
	 * These assume than any string r is a percentage (whether or not it includes %).
	 * They also generate strange results if l is a string.
	 * @param {String|Date|Number} l the value to modify
	 * @param {Number} r the amount by which to modify the value
	 * @param {String} [t] if `l` is a `Date`, the
	 * [interval](https://github.com/d3/d3-3.x-api-reference/blob/master/Time-Intervals.md#interval) in
	 * the `d3.time` namespace
	 * @returns {String|Date|Number}
	 */
	dc.utils.subtract = function (l, r, t) {
	    if (typeof r === 'string') {
	        r = r.replace('%', '');
	    }
	
	    if (l instanceof Date) {
	        if (typeof r === 'string') {
	            r = +r;
	        }
	        if (t === 'millis') {
	            return new Date(l.getTime() - r);
	        }
	        t = t || 'day';
	        return d3.time[t].offset(l, -r);
	    } else if (typeof r === 'string') {
	        var percentage = (+r / 100);
	        return l < 0 ? l * (1 + percentage) : l * (1 - percentage);
	    } else {
	        return l - r;
	    }
	};
	
	/**
	 * Is the value a number?
	 * @method isNumber
	 * @memberof dc.utils
	 * @param {any} n
	 * @returns {Boolean}
	 */
	dc.utils.isNumber = function (n) {
	    return n === +n;
	};
	
	/**
	 * Is the value a float?
	 * @method isFloat
	 * @memberof dc.utils
	 * @param {any} n
	 * @returns {Boolean}
	 */
	dc.utils.isFloat = function (n) {
	    return n === +n && n !== (n | 0);
	};
	
	/**
	 * Is the value an integer?
	 * @method isInteger
	 * @memberof dc.utils
	 * @param {any} n
	 * @returns {Boolean}
	 */
	dc.utils.isInteger = function (n) {
	    return n === +n && n === (n | 0);
	};
	
	/**
	 * Is the value very close to zero?
	 * @method isNegligible
	 * @memberof dc.utils
	 * @param {any} n
	 * @returns {Boolean}
	 */
	dc.utils.isNegligible = function (n) {
	    return !dc.utils.isNumber(n) || (n < dc.constants.NEGLIGIBLE_NUMBER && n > -dc.constants.NEGLIGIBLE_NUMBER);
	};
	
	/**
	 * Ensure the value is no greater or less than the min/max values.  If it is return the boundary value.
	 * @method clamp
	 * @memberof dc.utils
	 * @param {any} val
	 * @param {any} min
	 * @param {any} max
	 * @returns {any}
	 */
	dc.utils.clamp = function (val, min, max) {
	    return val < min ? min : (val > max ? max : val);
	};
	
	/**
	 * Using a simple static counter, provide a unique integer id.
	 * @method uniqueId
	 * @memberof dc.utils
	 * @returns {Number}
	 */
	var _idCounter = 0;
	dc.utils.uniqueId = function () {
	    return ++_idCounter;
	};
	
	/**
	 * Convert a name to an ID.
	 * @method nameToId
	 * @memberof dc.utils
	 * @param {String} name
	 * @returns {String}
	 */
	dc.utils.nameToId = function (name) {
	    return name.toLowerCase().replace(/[\s]/g, '_').replace(/[\.']/g, '');
	};
	
	/**
	 * Append or select an item on a parent element.
	 * @method appendOrSelect
	 * @memberof dc.utils
	 * @param {d3.selection} parent
	 * @param {String} selector
	 * @param {String} tag
	 * @returns {d3.selection}
	 */
	dc.utils.appendOrSelect = function (parent, selector, tag) {
	    tag = tag || selector;
	    var element = parent.select(selector);
	    if (element.empty()) {
	        element = parent.append(tag);
	    }
	    return element;
	};
	
	/**
	 * Return the number if the value is a number; else 0.
	 * @method safeNumber
	 * @memberof dc.utils
	 * @param {Number|any} n
	 * @returns {Number}
	 */
	dc.utils.safeNumber = function (n) { return dc.utils.isNumber(+n) ? +n : 0;};
	
	dc.logger = {};
	
	dc.logger.enableDebugLog = false;
	
	dc.logger.warn = function (msg) {
	    if (console) {
	        if (console.warn) {
	            console.warn(msg);
	        } else if (console.log) {
	            console.log(msg);
	        }
	    }
	
	    return dc.logger;
	};
	
	dc.logger.debug = function (msg) {
	    if (dc.logger.enableDebugLog && console) {
	        if (console.debug) {
	            console.debug(msg);
	        } else if (console.log) {
	            console.log(msg);
	        }
	    }
	
	    return dc.logger;
	};
	
	dc.logger.deprecate = function (fn, msg) {
	    // Allow logging of deprecation
	    var warned = false;
	    function deprecated () {
	        if (!warned) {
	            dc.logger.warn(msg);
	            warned = true;
	        }
	        return fn.apply(this, arguments);
	    }
	    return deprecated;
	};
	
	dc.events = {
	    current: null
	};
	
	/**
	 * This function triggers a throttled event function with a specified delay (in milli-seconds).  Events
	 * that are triggered repetitively due to user interaction such brush dragging might flood the library
	 * and invoke more renders than can be executed in time. Using this function to wrap your event
	 * function allows the library to smooth out the rendering by throttling events and only responding to
	 * the most recent event.
	 * @name events.trigger
	 * @memberof dc
	 * @example
	 * chart.on('renderlet', function(chart) {
	 *     // smooth the rendering through event throttling
	 *     dc.events.trigger(function(){
	 *         // focus some other chart to the range selected by user on this chart
	 *         someOtherChart.focus(chart.filter());
	 *     });
	 * })
	 * @param {Function} closure
	 * @param {Number} [delay]
	 */
	dc.events.trigger = function (closure, delay) {
	    if (!delay) {
	        closure();
	        return;
	    }
	
	    dc.events.current = closure;
	
	    setTimeout(function () {
	        if (closure === dc.events.current) {
	            closure();
	        }
	    }, delay);
	};
	
	/**
	 * The dc.js filters are functions which are passed into crossfilter to chose which records will be
	 * accumulated to produce values for the charts.  In the crossfilter model, any filters applied on one
	 * dimension will affect all the other dimensions but not that one.  dc always applies a filter
	 * function to the dimension; the function combines multiple filters and if any of them accept a
	 * record, it is filtered in.
	 *
	 * These filter constructors are used as appropriate by the various charts to implement brushing.  We
	 * mention below which chart uses which filter.  In some cases, many instances of a filter will be added.
	 *
	 * Each of the dc.js filters is an object with the following properties:
	 * * `isFiltered` - a function that returns true if a value is within the filter
	 * * `filterType` - a string identifying the filter, here the name of the constructor
	 *
	 * Currently these filter objects are also arrays, but this is not a requirement. Custom filters
	 * can be used as long as they have the properties above.
	 * @namespace filters
	 * @memberof dc
	 * @type {{}}
	 */
	dc.filters = {};
	
	/**
	 * RangedFilter is a filter which accepts keys between `low` and `high`.  It is used to implement X
	 * axis brushing for the {@link dc.coordinateGridMixin coordinate grid charts}.
	 *
	 * Its `filterType` is 'RangedFilter'
	 * @name RangedFilter
	 * @memberof dc.filters
	 * @param {Number} low
	 * @param {Number} high
	 * @returns {Array<Number>}
	 * @constructor
	 */
	dc.filters.RangedFilter = function (low, high) {
	    var range = new Array(low, high);
	    range.isFiltered = function (value) {
	        return value >= this[0] && value < this[1];
	    };
	    range.filterType = 'RangedFilter';
	
	    return range;
	};
	
	/**
	 * TwoDimensionalFilter is a filter which accepts a single two-dimensional value.  It is used by the
	 * {@link dc.heatMap heat map chart} to include particular cells as they are clicked.  (Rows and columns are
	 * filtered by filtering all the cells in the row or column.)
	 *
	 * Its `filterType` is 'TwoDimensionalFilter'
	 * @name TwoDimensionalFilter
	 * @memberof dc.filters
	 * @param {Array<Number>} filter
	 * @returns {Array<Number>}
	 * @constructor
	 */
	dc.filters.TwoDimensionalFilter = function (filter) {
	    if (filter === null) { return null; }
	
	    var f = filter;
	    f.isFiltered = function (value) {
	        return value.length && value.length === f.length &&
	               value[0] === f[0] && value[1] === f[1];
	    };
	    f.filterType = 'TwoDimensionalFilter';
	
	    return f;
	};
	
	/**
	 * The RangedTwoDimensionalFilter allows filtering all values which fit within a rectangular
	 * region. It is used by the {@link dc.scatterPlot scatter plot} to implement rectangular brushing.
	 *
	 * It takes two two-dimensional points in the form `[[x1,y1],[x2,y2]]`, and normalizes them so that
	 * `x1 <= x2` and `y1 <= y2`. It then returns a filter which accepts any points which are in the
	 * rectangular range including the lower values but excluding the higher values.
	 *
	 * If an array of two values are given to the RangedTwoDimensionalFilter, it interprets the values as
	 * two x coordinates `x1` and `x2` and returns a filter which accepts any points for which `x1 <= x <
	 * x2`.
	 *
	 * Its `filterType` is 'RangedTwoDimensionalFilter'
	 * @name RangedTwoDimensionalFilter
	 * @memberof dc.filters
	 * @param {Array<Array<Number>>} filter
	 * @returns {Array<Array<Number>>}
	 * @constructor
	 */
	dc.filters.RangedTwoDimensionalFilter = function (filter) {
	    if (filter === null) { return null; }
	
	    var f = filter;
	    var fromBottomLeft;
	
	    if (f[0] instanceof Array) {
	        fromBottomLeft = [
	            [Math.min(filter[0][0], filter[1][0]), Math.min(filter[0][1], filter[1][1])],
	            [Math.max(filter[0][0], filter[1][0]), Math.max(filter[0][1], filter[1][1])]
	        ];
	    } else {
	        fromBottomLeft = [[filter[0], -Infinity], [filter[1], Infinity]];
	    }
	
	    f.isFiltered = function (value) {
	        var x, y;
	
	        if (value instanceof Array) {
	            x = value[0];
	            y = value[1];
	        } else {
	            x = value;
	            y = fromBottomLeft[0][1];
	        }
	
	        return x >= fromBottomLeft[0][0] && x < fromBottomLeft[1][0] &&
	               y >= fromBottomLeft[0][1] && y < fromBottomLeft[1][1];
	    };
	    f.filterType = 'RangedTwoDimensionalFilter';
	
	    return f;
	};
	
	/**
	 * `dc.baseMixin` is an abstract functional object representing a basic `dc` chart object
	 * for all chart and widget implementations. Methods from the {@link #dc.baseMixin dc.baseMixin} are inherited
	 * and available on all chart implementations in the `dc` library.
	 * @name baseMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @returns {dc.baseMixin}
	 */
	dc.baseMixin = function (_chart) {
	    _chart.__dcFlag__ = dc.utils.uniqueId();
	
	    var _dimension;
	    var _group;
	
	    var _anchor;
	    var _root;
	    var _svg;
	    var _isChild;
	
	    var _minWidth = 200;
	    var _defaultWidthCalc = function (element) {
	        var width = element && element.getBoundingClientRect && element.getBoundingClientRect().width;
	        return (width && width > _minWidth) ? width : _minWidth;
	    };
	    var _widthCalc = _defaultWidthCalc;
	
	    var _minHeight = 200;
	    var _defaultHeightCalc = function (element) {
	        var height = element && element.getBoundingClientRect && element.getBoundingClientRect().height;
	        return (height && height > _minHeight) ? height : _minHeight;
	    };
	    var _heightCalc = _defaultHeightCalc;
	    var _width, _height;
	
	    var _keyAccessor = dc.pluck('key');
	    var _valueAccessor = dc.pluck('value');
	    var _label = dc.pluck('key');
	
	    var _ordering = dc.pluck('key');
	    var _orderSort;
	
	    var _renderLabel = false;
	
	    var _title = function (d) {
	        return _chart.keyAccessor()(d) + ': ' + _chart.valueAccessor()(d);
	    };
	    var _renderTitle = true;
	    var _controlsUseVisibility = false;
	
	    var _transitionDuration = 750;
	
	    var _transitionDelay = 0;
	
	    var _filterPrinter = dc.printers.filters;
	
	    var _mandatoryAttributes = ['dimension', 'group'];
	
	    var _chartGroup = dc.constants.DEFAULT_CHART_GROUP;
	
	    var _listeners = d3.dispatch(
	        'preRender',
	        'postRender',
	        'preRedraw',
	        'postRedraw',
	        'filtered',
	        'zoomed',
	        'renderlet',
	        'pretransition');
	
	    var _legend;
	    var _commitHandler;
	
	    var _filters = [];
	    var _filterHandler = function (dimension, filters) {
	        if (filters.length === 0) {
	            dimension.filter(null);
	        } else if (filters.length === 1 && !filters[0].isFiltered) {
	            // single value and not a function-based filter
	            dimension.filterExact(filters[0]);
	        } else if (filters.length === 1 && filters[0].filterType === 'RangedFilter') {
	            // single range-based filter
	            dimension.filterRange(filters[0]);
	        } else {
	            dimension.filterFunction(function (d) {
	                for (var i = 0; i < filters.length; i++) {
	                    var filter = filters[i];
	                    if (filter.isFiltered && filter.isFiltered(d)) {
	                        return true;
	                    } else if (filter <= d && filter >= d) {
	                        return true;
	                    }
	                }
	                return false;
	            });
	        }
	        return filters;
	    };
	
	    var _data = function (group) {
	        return group.all();
	    };
	
	    /**
	     * Set or get the height attribute of a chart. The height is applied to the SVGElement generated by
	     * the chart when rendered (or re-rendered). If a value is given, then it will be used to calculate
	     * the new height and the chart returned for method chaining.  The value can either be a numeric, a
	     * function, or falsy. If no value is specified then the value of the current height attribute will
	     * be returned.
	     *
	     * By default, without an explicit height being given, the chart will select the width of its
	     * anchor element. If that isn't possible it defaults to 200 (provided by the
	     * {@link dc.baseMixin#minHeight minHeight} property). Setting the value falsy will return
	     * the chart to the default behavior.
	     * @method height
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#minHeight minHeight}
	     * @example
	     * // Default height
	     * chart.height(function (element) {
	     *     var height = element && element.getBoundingClientRect && element.getBoundingClientRect().height;
	     *     return (height && height > chart.minHeight()) ? height : chart.minHeight();
	     * });
	     *
	     * chart.height(250); // Set the chart's height to 250px;
	     * chart.height(function(anchor) { return doSomethingWith(anchor); }); // set the chart's height with a function
	     * chart.height(null); // reset the height to the default auto calculation
	     * @param {Number|Function} [height]
	     * @returns {Number|dc.baseMixin}
	     */
	    _chart.height = function (height) {
	        if (!arguments.length) {
	            if (!dc.utils.isNumber(_height)) {
	                // only calculate once
	                _height = _heightCalc(_root.node());
	            }
	            return _height;
	        }
	        _heightCalc = d3.functor(height || _defaultHeightCalc);
	        _height = undefined;
	        return _chart;
	    };
	
	    /**
	     * Set or get the width attribute of a chart.
	     * @method width
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#height height}
	     * @see {@link dc.baseMixin#minWidth minWidth}
	     * @example
	     * // Default width
	     * chart.width(function (element) {
	     *     var width = element && element.getBoundingClientRect && element.getBoundingClientRect().width;
	     *     return (width && width > chart.minWidth()) ? width : chart.minWidth();
	     * });
	     * @param {Number|Function} [width]
	     * @returns {Number|dc.baseMixin}
	     */
	    _chart.width = function (width) {
	        if (!arguments.length) {
	            if (!dc.utils.isNumber(_width)) {
	                // only calculate once
	                _width = _widthCalc(_root.node());
	            }
	            return _width;
	        }
	        _widthCalc = d3.functor(width || _defaultWidthCalc);
	        _width = undefined;
	        return _chart;
	    };
	
	    /**
	     * Set or get the minimum width attribute of a chart. This only has effect when used with the default
	     * {@link dc.baseMixin#width width} function.
	     * @method minWidth
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#width width}
	     * @param {Number} [minWidth=200]
	     * @returns {Number|dc.baseMixin}
	     */
	    _chart.minWidth = function (minWidth) {
	        if (!arguments.length) {
	            return _minWidth;
	        }
	        _minWidth = minWidth;
	        return _chart;
	    };
	
	    /**
	     * Set or get the minimum height attribute of a chart. This only has effect when used with the default
	     * {@link dc.baseMixin#height height} function.
	     * @method minHeight
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#height height}
	     * @param {Number} [minHeight=200]
	     * @returns {Number|dc.baseMixin}
	     */
	    _chart.minHeight = function (minHeight) {
	        if (!arguments.length) {
	            return _minHeight;
	        }
	        _minHeight = minHeight;
	        return _chart;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Set or get the dimension attribute of a chart. In `dc`, a dimension can be any valid
	     * {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#dimension crossfilter dimension}
	     *
	     * If a value is given, then it will be used as the new dimension. If no value is specified then
	     * the current dimension will be returned.
	     * @method dimension
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#dimension crossfilter.dimension}
	     * @example
	     * var index = crossfilter([]);
	     * var dimension = index.dimension(dc.pluck('key'));
	     * chart.dimension(dimension);
	     * @param {crossfilter.dimension} [dimension]
	     * @returns {crossfilter.dimension|dc.baseMixin}
	     */
	    _chart.dimension = function (dimension) {
	        if (!arguments.length) {
	            return _dimension;
	        }
	        _dimension = dimension;
	        _chart.expireCache();
	        return _chart;
	    };
	
	    /**
	     * Set the data callback or retrieve the chart's data set. The data callback is passed the chart's
	     * group and by default will return
	     * {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#group_all group.all}.
	     * This behavior may be modified to, for instance, return only the top 5 groups.
	     * @method data
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // Default data function
	     * chart.data(function (group) { return group.all(); });
	     *
	     * chart.data(function (group) { return group.top(5); });
	     * @param {Function} [callback]
	     * @returns {*|dc.baseMixin}
	     */
	    _chart.data = function (callback) {
	        if (!arguments.length) {
	            return _data.call(_chart, _group);
	        }
	        _data = d3.functor(callback);
	        _chart.expireCache();
	        return _chart;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Set or get the group attribute of a chart. In `dc` a group is a
	     * {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#group-map-reduce crossfilter group}.
	     * Usually the group should be created from the particular dimension associated with the same chart. If a value is
	     * given, then it will be used as the new group.
	     *
	     * If no value specified then the current group will be returned.
	     * If `name` is specified then it will be used to generate legend label.
	     * @method group
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#group-map-reduce crossfilter.group}
	     * @example
	     * var index = crossfilter([]);
	     * var dimension = index.dimension(dc.pluck('key'));
	     * chart.dimension(dimension);
	     * chart.group(dimension.group(crossfilter.reduceSum()));
	     * @param {crossfilter.group} [group]
	     * @param {String} [name]
	     * @returns {crossfilter.group|dc.baseMixin}
	     */
	    _chart.group = function (group, name) {
	        if (!arguments.length) {
	            return _group;
	        }
	        _group = group;
	        _chart._groupName = name;
	        _chart.expireCache();
	        return _chart;
	    };
	
	    /**
	     * Get or set an accessor to order ordinal dimensions.  The chart uses
	     * {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#quicksort_by crossfilter.quicksort.by}
	     * to sort elements; this accessor returns the value to order on.
	     * @method ordering
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#quicksort_by crossfilter.quicksort.by}
	     * @example
	     * // Default ordering accessor
	     * _chart.ordering(dc.pluck('key'));
	     * @param {Function} [orderFunction]
	     * @returns {Function|dc.baseMixin}
	     */
	    _chart.ordering = function (orderFunction) {
	        if (!arguments.length) {
	            return _ordering;
	        }
	        _ordering = orderFunction;
	        _orderSort = crossfilter.quicksort.by(_ordering);
	        _chart.expireCache();
	        return _chart;
	    };
	
	    _chart._computeOrderedGroups = function (data) {
	        var dataCopy = data.slice(0);
	
	        if (dataCopy.length <= 1) {
	            return dataCopy;
	        }
	
	        if (!_orderSort) {
	            _orderSort = crossfilter.quicksort.by(_ordering);
	        }
	
	        return _orderSort(dataCopy, 0, dataCopy.length);
	    };
	
	    /**
	     * Clear all filters associated with this chart. The same effect can be achieved by calling
	     * {@link dc.baseMixin#filter chart.filter(null)}.
	     * @method filterAll
	     * @memberof dc.baseMixin
	     * @instance
	     * @returns {dc.baseMixin}
	     */
	    _chart.filterAll = function () {
	        return _chart.filter(null);
	    };
	
	    /**
	     * Execute d3 single selection in the chart's scope using the given selector and return the d3
	     * selection.
	     *
	     * This function is **not chainable** since it does not return a chart instance; however the d3
	     * selection result can be chained to d3 function calls.
	     * @method select
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#d3_select d3.select}
	     * @example
	     * // Has the same effect as d3.select('#chart-id').select(selector)
	     * chart.select(selector)
	     * @returns {d3.selection}
	     */
	    _chart.select = function (s) {
	        return _root.select(s);
	    };
	
	    /**
	     * Execute in scope d3 selectAll using the given selector and return d3 selection result.
	     *
	     * This function is **not chainable** since it does not return a chart instance; however the d3
	     * selection result can be chained to d3 function calls.
	     * @method selectAll
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#d3_selectAll d3.selectAll}
	     * @example
	     * // Has the same effect as d3.select('#chart-id').selectAll(selector)
	     * chart.selectAll(selector)
	     * @returns {d3.selection}
	     */
	    _chart.selectAll = function (s) {
	        return _root ? _root.selectAll(s) : null;
	    };
	
	    /**
	     * Set the root SVGElement to either be an existing chart's root; or any valid [d3 single
	     * selector](https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements) specifying a dom
	     * block element such as a div; or a dom element or d3 selection. Optionally registers the chart
	     * within the chartGroup. This class is called internally on chart initialization, but be called
	     * again to relocate the chart. However, it will orphan any previously created SVGElements.
	     * @method anchor
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {anchorChart|anchorSelector|anchorNode} [parent]
	     * @param {String} [chartGroup]
	     * @returns {String|node|d3.selection|dc.baseMixin}
	     */
	    _chart.anchor = function (parent, chartGroup) {
	        if (!arguments.length) {
	            return _anchor;
	        }
	        if (dc.instanceOfChart(parent)) {
	            _anchor = parent.anchor();
	            _root = parent.root();
	            _isChild = true;
	        } else if (parent) {
	            if (parent.select && parent.classed) { // detect d3 selection
	                _anchor = parent.node();
	            } else {
	                _anchor = parent;
	            }
	            _root = d3.select(_anchor);
	            _root.classed(dc.constants.CHART_CLASS, true);
	            dc.registerChart(_chart, chartGroup);
	            _isChild = false;
	        } else {
	            throw new dc.errors.BadArgumentException('parent must be defined');
	        }
	        _chartGroup = chartGroup;
	        return _chart;
	    };
	
	    /**
	     * Returns the DOM id for the chart's anchored location.
	     * @method anchorName
	     * @memberof dc.baseMixin
	     * @instance
	     * @returns {String}
	     */
	    _chart.anchorName = function () {
	        var a = _chart.anchor();
	        if (a && a.id) {
	            return a.id;
	        }
	        if (a && a.replace) {
	            return a.replace('#', '');
	        }
	        return 'dc-chart' + _chart.chartID();
	    };
	
	    /**
	     * Returns the root element where a chart resides. Usually it will be the parent div element where
	     * the SVGElement was created. You can also pass in a new root element however this is usually handled by
	     * dc internally. Resetting the root element on a chart outside of dc internals may have
	     * unexpected consequences.
	     * @method root
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement HTMLElement}
	     * @param {HTMLElement} [rootElement]
	     * @returns {HTMLElement|dc.baseMixin}
	     */
	    _chart.root = function (rootElement) {
	        if (!arguments.length) {
	            return _root;
	        }
	        _root = rootElement;
	        return _chart;
	    };
	
	    /**
	     * Returns the top SVGElement for this specific chart. You can also pass in a new SVGElement,
	     * however this is usually handled by dc internally. Resetting the SVGElement on a chart outside
	     * of dc internals may have unexpected consequences.
	     * @method svg
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/SVGElement SVGElement}
	     * @param {SVGElement|d3.selection} [svgElement]
	     * @returns {SVGElement|d3.selection|dc.baseMixin}
	     */
	    _chart.svg = function (svgElement) {
	        if (!arguments.length) {
	            return _svg;
	        }
	        _svg = svgElement;
	        return _chart;
	    };
	
	    /**
	     * Remove the chart's SVGElements from the dom and recreate the container SVGElement.
	     * @method resetSvg
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/SVGElement SVGElement}
	     * @returns {SVGElement}
	     */
	    _chart.resetSvg = function () {
	        _chart.select('svg').remove();
	        return generateSvg();
	    };
	
	    function sizeSvg () {
	        if (_svg) {
	            _svg
	                .attr('width', _chart.width())
	                .attr('height', _chart.height());
	        }
	    }
	
	    function generateSvg () {
	        _svg = _chart.root().append('svg');
	        sizeSvg();
	        return _svg;
	    }
	
	    /**
	     * Set or get the filter printer function. The filter printer function is used to generate human
	     * friendly text for filter value(s) associated with the chart instance. The text will get shown
	     * in the `.filter element; see {@link dc.baseMixin#turnOnControls turnOnControls}.
	     *
	     * By default dc charts use a default filter printer {@link dc.printers.filters dc.printers.filters}
	     * that provides simple printing support for both single value and ranged filters.
	     * @method filterPrinter
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // for a chart with an ordinal brush, print the filters in upper case
	     * chart.filterPrinter(function(filters) {
	     *   return filters.map(function(f) { return f.toUpperCase(); }).join(', ');
	     * });
	     * // for a chart with a range brush, print the filter as start and extent
	     * chart.filterPrinter(function(filters) {
	     *   return 'start ' + dc.utils.printSingleValue(filters[0][0]) +
	     *     ' extent ' + dc.utils.printSingleValue(filters[0][1] - filters[0][0]);
	     * });
	     * @param {Function} [filterPrinterFunction=dc.printers.filters]
	     * @returns {Function|dc.baseMixin}
	     */
	    _chart.filterPrinter = function (filterPrinterFunction) {
	        if (!arguments.length) {
	            return _filterPrinter;
	        }
	        _filterPrinter = filterPrinterFunction;
	        return _chart;
	    };
	
	    /**
	     * If set, use the `visibility` attribute instead of the `display` attribute for showing/hiding
	     * chart reset and filter controls, for less disruption to the layout.
	     * @method controlsUseVisibility
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Boolean} [controlsUseVisibility=false]
	     * @returns {Boolean|dc.baseMixin}
	     **/
	    _chart.controlsUseVisibility = function (useVisibility) {
	        if (!arguments.length) {
	            return _controlsUseVisibility;
	        }
	        _controlsUseVisibility = useVisibility;
	        return _chart;
	    };
	
	    /**
	     * Turn on optional control elements within the root element. dc currently supports the
	     * following html control elements.
	     * * root.selectAll('.reset') - elements are turned on if the chart has an active filter. This type
	     * of control element is usually used to store a reset link to allow user to reset filter on a
	     * certain chart. This element will be turned off automatically if the filter is cleared.
	     * * root.selectAll('.filter') elements are turned on if the chart has an active filter. The text
	     * content of this element is then replaced with the current filter value using the filter printer
	     * function. This type of element will be turned off automatically if the filter is cleared.
	     * @method turnOnControls
	     * @memberof dc.baseMixin
	     * @instance
	     * @returns {dc.baseMixin}
	     */
	    _chart.turnOnControls = function () {
	        if (_root) {
	            var attribute = _chart.controlsUseVisibility() ? 'visibility' : 'display';
	            _chart.selectAll('.reset').style(attribute, null);
	            _chart.selectAll('.filter').text(_filterPrinter(_chart.filters())).style(attribute, null);
	        }
	        return _chart;
	    };
	
	    /**
	     * Turn off optional control elements within the root element.
	     * @method turnOffControls
	     * @memberof dc.baseMixin
	     * @see {@link dc.baseMixin#turnOnControls turnOnControls}
	     * @instance
	     * @returns {dc.baseMixin}
	     */
	    _chart.turnOffControls = function () {
	        if (_root) {
	            var attribute = _chart.controlsUseVisibility() ? 'visibility' : 'display';
	            var value = _chart.controlsUseVisibility() ? 'hidden' : 'none';
	            _chart.selectAll('.reset').style(attribute, value);
	            _chart.selectAll('.filter').style(attribute, value).text(_chart.filter());
	        }
	        return _chart;
	    };
	
	    /**
	     * Set or get the animation transition duration (in milliseconds) for this chart instance.
	     * @method transitionDuration
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Number} [duration=750]
	     * @returns {Number|dc.baseMixin}
	     */
	    _chart.transitionDuration = function (duration) {
	        if (!arguments.length) {
	            return _transitionDuration;
	        }
	        _transitionDuration = duration;
	        return _chart;
	    };
	
	    /**
	     * Set or get the animation transition delay (in milliseconds) for this chart instance.
	     * @method transitionDelay
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Number} [delay=0]
	     * @returns {Number|dc.baseMixin}
	     */
	    _chart.transitionDelay = function (delay) {
	        if (!arguments.length) {
	            return _transitionDelay;
	        }
	        _transitionDelay = delay;
	        return _chart;
	    };
	
	    _chart._mandatoryAttributes = function (_) {
	        if (!arguments.length) {
	            return _mandatoryAttributes;
	        }
	        _mandatoryAttributes = _;
	        return _chart;
	    };
	
	    function checkForMandatoryAttributes (a) {
	        if (!_chart[a] || !_chart[a]()) {
	            throw new dc.errors.InvalidStateException('Mandatory attribute chart.' + a +
	                ' is missing on chart[#' + _chart.anchorName() + ']');
	        }
	    }
	
	    /**
	     * Invoking this method will force the chart to re-render everything from scratch. Generally it
	     * should only be used to render the chart for the first time on the page or if you want to make
	     * sure everything is redrawn from scratch instead of relying on the default incremental redrawing
	     * behaviour.
	     * @method render
	     * @memberof dc.baseMixin
	     * @instance
	     * @returns {dc.baseMixin}
	     */
	    _chart.render = function () {
	        _height = _width = undefined; // force recalculate
	        _listeners.preRender(_chart);
	
	        if (_mandatoryAttributes) {
	            _mandatoryAttributes.forEach(checkForMandatoryAttributes);
	        }
	
	        var result = _chart._doRender();
	
	        if (_legend) {
	            _legend.render();
	        }
	
	        _chart._activateRenderlets('postRender');
	
	        return result;
	    };
	
	    _chart._activateRenderlets = function (event) {
	        _listeners.pretransition(_chart);
	        if (_chart.transitionDuration() > 0 && _svg) {
	            _svg.transition().duration(_chart.transitionDuration()).delay(_chart.transitionDelay())
	                .each('end', function () {
	                    _listeners.renderlet(_chart);
	                    if (event) {
	                        _listeners[event](_chart);
	                    }
	                });
	        } else {
	            _listeners.renderlet(_chart);
	            if (event) {
	                _listeners[event](_chart);
	            }
	        }
	    };
	
	    /**
	     * Calling redraw will cause the chart to re-render data changes incrementally. If there is no
	     * change in the underlying data dimension then calling this method will have no effect on the
	     * chart. Most chart interaction in dc will automatically trigger this method through internal
	     * events (in particular {@link dc.redrawAll dc.redrawAll}); therefore, you only need to
	     * manually invoke this function if data is manipulated outside of dc's control (for example if
	     * data is loaded in the background using
	     * {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#crossfilter_add crossfilter.add}).
	     * @method redraw
	     * @memberof dc.baseMixin
	     * @instance
	     * @returns {dc.baseMixin}
	     */
	    _chart.redraw = function () {
	        sizeSvg();
	        _listeners.preRedraw(_chart);
	
	        var result = _chart._doRedraw();
	
	        if (_legend) {
	            _legend.render();
	        }
	
	        _chart._activateRenderlets('postRedraw');
	
	        return result;
	    };
	
	    /**
	     * Gets/sets the commit handler. If the chart has a commit handler, the handler will be called when
	     * the chart's filters have changed, in order to send the filter data asynchronously to a server.
	     *
	     * Unlike other functions in dc.js, the commit handler is asynchronous. It takes two arguments:
	     * a flag indicating whether this is a render (true) or a redraw (false), and a callback to be
	     * triggered once the commit is filtered. The callback has the standard node.js continuation signature
	     * with error first and result second.
	     * @method commitHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @returns {dc.baseMixin}
	     */
	    _chart.commitHandler = function (commitHandler) {
	        if (!arguments.length) {
	            return _commitHandler;
	        }
	        _commitHandler = commitHandler;
	        return _chart;
	    };
	
	    /**
	     * Redraws all charts in the same group as this chart, typically in reaction to a filter
	     * change. If the chart has a {@link dc.baseMixin.commitFilter commitHandler}, it will
	     * be executed and waited for.
	     * @method redrawGroup
	     * @memberof dc.baseMixin
	     * @instance
	     * @returns {dc.baseMixin}
	     */
	    _chart.redrawGroup = function () {
	        if (_commitHandler) {
	            _commitHandler(false, function (error, result) {
	                if (error) {
	                    console.log(error);
	                } else {
	                    dc.redrawAll(_chart.chartGroup());
	                }
	            });
	        } else {
	            dc.redrawAll(_chart.chartGroup());
	        }
	        return _chart;
	    };
	
	    /**
	     * Renders all charts in the same group as this chart. If the chart has a
	     * {@link dc.baseMixin.commitFilter commitHandler}, it will be executed and waited for
	     * @method renderGroup
	     * @memberof dc.baseMixin
	     * @instance
	     * @returns {dc.baseMixin}
	     */
	    _chart.renderGroup = function () {
	        if (_commitHandler) {
	            _commitHandler(false, function (error, result) {
	                if (error) {
	                    console.log(error);
	                } else {
	                    dc.renderAll(_chart.chartGroup());
	                }
	            });
	        } else {
	            dc.renderAll(_chart.chartGroup());
	        }
	        return _chart;
	    };
	
	    _chart._invokeFilteredListener = function (f) {
	        if (f !== undefined) {
	            _listeners.filtered(_chart, f);
	        }
	    };
	
	    _chart._invokeZoomedListener = function () {
	        _listeners.zoomed(_chart);
	    };
	
	    var _hasFilterHandler = function (filters, filter) {
	        if (filter === null || typeof(filter) === 'undefined') {
	            return filters.length > 0;
	        }
	        return filters.some(function (f) {
	            return filter <= f && filter >= f;
	        });
	    };
	
	    /**
	     * Set or get the has-filter handler. The has-filter handler is a function that checks to see if
	     * the chart's current filters (first argument) include a specific filter (second argument).  Using a custom has-filter handler allows
	     * you to change the way filters are checked for and replaced.
	     * @method hasFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default has-filter handler
	     * chart.hasFilterHandler(function (filters, filter) {
	     *     if (filter === null || typeof(filter) === 'undefined') {
	     *         return filters.length > 0;
	     *     }
	     *     return filters.some(function (f) {
	     *         return filter <= f && filter >= f;
	     *     });
	     * });
	     *
	     * // custom filter handler (no-op)
	     * chart.hasFilterHandler(function(filters, filter) {
	     *     return false;
	     * });
	     * @param {Function} [hasFilterHandler]
	     * @returns {Function|dc.baseMixin}
	     */
	    _chart.hasFilterHandler = function (hasFilterHandler) {
	        if (!arguments.length) {
	            return _hasFilterHandler;
	        }
	        _hasFilterHandler = hasFilterHandler;
	        return _chart;
	    };
	
	    /**
	     * Check whether any active filter or a specific filter is associated with particular chart instance.
	     * This function is **not chainable**.
	     * @method hasFilter
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#hasFilterHandler hasFilterHandler}
	     * @param {*} [filter]
	     * @returns {Boolean}
	     */
	    _chart.hasFilter = function (filter) {
	        return _hasFilterHandler(_filters, filter);
	    };
	
	    var _removeFilterHandler = function (filters, filter) {
	        for (var i = 0; i < filters.length; i++) {
	            if (filters[i] <= filter && filters[i] >= filter) {
	                filters.splice(i, 1);
	                break;
	            }
	        }
	        return filters;
	    };
	
	    /**
	     * Set or get the remove filter handler. The remove filter handler is a function that removes a
	     * filter from the chart's current filters. Using a custom remove filter handler allows you to
	     * change how filters are removed or perform additional work when removing a filter, e.g. when
	     * using a filter server other than crossfilter.
	     *
	     * The handler should return a new or modified array as the result.
	     * @method removeFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default remove filter handler
	     * chart.removeFilterHandler(function (filters, filter) {
	     *     for (var i = 0; i < filters.length; i++) {
	     *         if (filters[i] <= filter && filters[i] >= filter) {
	     *             filters.splice(i, 1);
	     *             break;
	     *         }
	     *     }
	     *     return filters;
	     * });
	     *
	     * // custom filter handler (no-op)
	     * chart.removeFilterHandler(function(filters, filter) {
	     *     return filters;
	     * });
	     * @param {Function} [removeFilterHandler]
	     * @returns {Function|dc.baseMixin}
	     */
	    _chart.removeFilterHandler = function (removeFilterHandler) {
	        if (!arguments.length) {
	            return _removeFilterHandler;
	        }
	        _removeFilterHandler = removeFilterHandler;
	        return _chart;
	    };
	
	    var _addFilterHandler = function (filters, filter) {
	        filters.push(filter);
	        return filters;
	    };
	
	    /**
	     * Set or get the add filter handler. The add filter handler is a function that adds a filter to
	     * the chart's filter list. Using a custom add filter handler allows you to change the way filters
	     * are added or perform additional work when adding a filter, e.g. when using a filter server other
	     * than crossfilter.
	     *
	     * The handler should return a new or modified array as the result.
	     * @method addFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default add filter handler
	     * chart.addFilterHandler(function (filters, filter) {
	     *     filters.push(filter);
	     *     return filters;
	     * });
	     *
	     * // custom filter handler (no-op)
	     * chart.addFilterHandler(function(filters, filter) {
	     *     return filters;
	     * });
	     * @param {Function} [addFilterHandler]
	     * @returns {Function|dc.baseMixin}
	     */
	    _chart.addFilterHandler = function (addFilterHandler) {
	        if (!arguments.length) {
	            return _addFilterHandler;
	        }
	        _addFilterHandler = addFilterHandler;
	        return _chart;
	    };
	
	    var _resetFilterHandler = function (filters) {
	        return [];
	    };
	
	    /**
	     * Set or get the reset filter handler. The reset filter handler is a function that resets the
	     * chart's filter list by returning a new list. Using a custom reset filter handler allows you to
	     * change the way filters are reset, or perform additional work when resetting the filters,
	     * e.g. when using a filter server other than crossfilter.
	     *
	     * The handler should return a new or modified array as the result.
	     * @method resetFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default remove filter handler
	     * function (filters) {
	     *     return [];
	     * }
	     *
	     * // custom filter handler (no-op)
	     * chart.resetFilterHandler(function(filters) {
	     *     return filters;
	     * });
	     * @param {Function} [resetFilterHandler]
	     * @returns {dc.baseMixin}
	     */
	    _chart.resetFilterHandler = function (resetFilterHandler) {
	        if (!arguments.length) {
	            return _resetFilterHandler;
	        }
	        _resetFilterHandler = resetFilterHandler;
	        return _chart;
	    };
	
	    function applyFilters (filters) {
	        if (_chart.dimension() && _chart.dimension().filter) {
	            var fs = _filterHandler(_chart.dimension(), filters);
	            if (fs) {
	                filters = fs;
	            }
	        }
	        return filters;
	    }
	
	    /**
	     * Replace the chart filter. This is equivalent to calling `chart.filter(null).filter(filter)`
	     * but more efficient because the filter is only applied once.
	     *
	     * @method replaceFilter
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {*} [filter]
	     * @returns {dc.baseMixin}
	     **/
	    _chart.replaceFilter = function (filter) {
	        _filters = _resetFilterHandler(_filters);
	        _chart.filter(filter);
	    };
	
	    /**
	     * Filter the chart by the given parameter, or return the current filter if no input parameter
	     * is given.
	     *
	     * The filter parameter can take one of these forms:
	     * * A single value: the value will be toggled (added if it is not present in the current
	     * filters, removed if it is present)
	     * * An array containing a single array of values (`[[value,value,value]]`): each value is
	     * toggled
	     * * When appropriate for the chart, a {@link dc.filters dc filter object} such as
	     *   * {@link dc.filters.RangedFilter `dc.filters.RangedFilter`} for the
	     * {@link dc.coordinateGridMixin dc.coordinateGridMixin} charts
	     *   * {@link dc.filters.TwoDimensionalFilter `dc.filters.TwoDimensionalFilter`} for the
	     * {@link dc.heatMap heat map}
	     *   * {@link dc.filters.RangedTwoDimensionalFilter `dc.filters.RangedTwoDimensionalFilter`}
	     * for the {@link dc.scatterPlot scatter plot}
	     * * `null`: the filter will be reset using the
	     * {@link dc.baseMixin#resetFilterHandler resetFilterHandler}
	     *
	     * Note that this is always a toggle (even when it doesn't make sense for the filter type). If
	     * you wish to replace the current filter, either call `chart.filter(null)` first - or it's more
	     * efficient to call {@link dc.baseMixin#replaceFilter `chart.replaceFilter(filter)`} instead.
	     *
	     * Each toggle is executed by checking if the value is already present using the
	     * {@link dc.baseMixin#hasFilterHandler hasFilterHandler}; if it is not present, it is added
	     * using the {@link dc.baseMixin#addFilterHandler addFilterHandler}; if it is already present,
	     * it is removed using the {@link dc.baseMixin#removeFilterHandler removeFilterHandler}.
	     *
	     * Once the filters array has been updated, the filters are applied to the
	     * crossfilter dimension, using the {@link dc.baseMixin#filterHandler filterHandler}.
	     *
	     * Once you have set the filters, call {@link dc.baseMixin#redrawGroup `chart.redrawGroup()`}
	     * (or {@link dc.redrawAll `dc.redrawAll()`}) to redraw the chart's group.
	     * @method filter
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#addFilterHandler addFilterHandler}
	     * @see {@link dc.baseMixin#removeFilterHandler removeFilterHandler}
	     * @see {@link dc.baseMixin#resetFilterHandler resetFilterHandler}
	     * @see {@link dc.baseMixin#filterHandler filterHandler}
	     * @example
	     * // filter by a single string
	     * chart.filter('Sunday');
	     * // filter by a single age
	     * chart.filter(18);
	     * // filter by a set of states
	     * chart.filter([['MA', 'TX', 'ND', 'WA']]);
	     * // filter by range -- note the use of dc.filters.RangedFilter, which is different
	     * // from the syntax for filtering a crossfilter dimension directly, dimension.filter([15,20])
	     * chart.filter(dc.filters.RangedFilter(15,20));
	     * @param {*} [filter]
	     * @returns {dc.baseMixin}
	     */
	    _chart.filter = function (filter) {
	        if (!arguments.length) {
	            return _filters.length > 0 ? _filters[0] : null;
	        }
	        var filters = _filters;
	        if (filter instanceof Array && filter[0] instanceof Array && !filter.isFiltered) {
	            // toggle each filter
	            filter[0].forEach(function (f) {
	                if (_hasFilterHandler(filters, f)) {
	                    filters = _removeFilterHandler(filters, f);
	                } else {
	                    filters = _addFilterHandler(filters, f);
	                }
	            });
	        } else if (filter === null) {
	            filters = _resetFilterHandler(filters);
	        } else {
	            if (_hasFilterHandler(filters, filter)) {
	                filters = _removeFilterHandler(filters, filter);
	            } else {
	                filters = _addFilterHandler(filters, filter);
	            }
	        }
	        _filters = applyFilters(filters);
	        _chart._invokeFilteredListener(filter);
	
	        if (_root !== null && _chart.hasFilter()) {
	            _chart.turnOnControls();
	        } else {
	            _chart.turnOffControls();
	        }
	
	        return _chart;
	    };
	
	    /**
	     * Returns all current filters. This method does not perform defensive cloning of the internal
	     * filter array before returning, therefore any modification of the returned array will effect the
	     * chart's internal filter storage.
	     * @method filters
	     * @memberof dc.baseMixin
	     * @instance
	     * @returns {Array<*>}
	     */
	    _chart.filters = function () {
	        return _filters;
	    };
	
	    _chart.highlightSelected = function (e) {
	        d3.select(e).classed(dc.constants.SELECTED_CLASS, true);
	        d3.select(e).classed(dc.constants.DESELECTED_CLASS, false);
	    };
	
	    _chart.fadeDeselected = function (e) {
	        d3.select(e).classed(dc.constants.SELECTED_CLASS, false);
	        d3.select(e).classed(dc.constants.DESELECTED_CLASS, true);
	    };
	
	    _chart.resetHighlight = function (e) {
	        d3.select(e).classed(dc.constants.SELECTED_CLASS, false);
	        d3.select(e).classed(dc.constants.DESELECTED_CLASS, false);
	    };
	
	    /**
	     * This function is passed to d3 as the onClick handler for each chart. The default behavior is to
	     * filter on the clicked datum (passed to the callback) and redraw the chart group.
	     * @method onClick
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {*} datum
	     */
	    _chart.onClick = function (datum) {
	        var filter = _chart.keyAccessor()(datum);
	        dc.events.trigger(function () {
	            _chart.filter(filter);
	            _chart.redrawGroup();
	        });
	    };
	
	    /**
	     * Set or get the filter handler. The filter handler is a function that performs the filter action
	     * on a specific dimension. Using a custom filter handler allows you to perform additional logic
	     * before or after filtering.
	     * @method filterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#dimension_filter crossfilter.dimension.filter}
	     * @example
	     * // the default filter handler handles all possible cases for the charts in dc.js
	     * // you can replace it with something more specialized for your own chart
	     * chart.filterHandler(function (dimension, filters) {
	     *     if (filters.length === 0) {
	     *         // the empty case (no filtering)
	     *         dimension.filter(null);
	     *     } else if (filters.length === 1 && !filters[0].isFiltered) {
	     *         // single value and not a function-based filter
	     *         dimension.filterExact(filters[0]);
	     *     } else if (filters.length === 1 && filters[0].filterType === 'RangedFilter') {
	     *         // single range-based filter
	     *         dimension.filterRange(filters[0]);
	     *     } else {
	     *         // an array of values, or an array of filter objects
	     *         dimension.filterFunction(function (d) {
	     *             for (var i = 0; i < filters.length; i++) {
	     *                 var filter = filters[i];
	     *                 if (filter.isFiltered && filter.isFiltered(d)) {
	     *                     return true;
	     *                 } else if (filter <= d && filter >= d) {
	     *                     return true;
	     *                 }
	     *             }
	     *             return false;
	     *         });
	     *     }
	     *     return filters;
	     * });
	     *
	     * // custom filter handler
	     * chart.filterHandler(function(dimension, filter){
	     *     var newFilter = filter + 10;
	     *     dimension.filter(newFilter);
	     *     return newFilter; // set the actual filter value to the new value
	     * });
	     * @param {Function} [filterHandler]
	     * @returns {Function|dc.baseMixin}
	     */
	    _chart.filterHandler = function (filterHandler) {
	        if (!arguments.length) {
	            return _filterHandler;
	        }
	        _filterHandler = filterHandler;
	        return _chart;
	    };
	
	    // abstract function stub
	    _chart._doRender = function () {
	        // do nothing in base, should be overridden by sub-function
	        return _chart;
	    };
	
	    _chart._doRedraw = function () {
	        // do nothing in base, should be overridden by sub-function
	        return _chart;
	    };
	
	    _chart.legendables = function () {
	        // do nothing in base, should be overridden by sub-function
	        return [];
	    };
	
	    _chart.legendHighlight = function () {
	        // do nothing in base, should be overridden by sub-function
	    };
	
	    _chart.legendReset = function () {
	        // do nothing in base, should be overridden by sub-function
	    };
	
	    _chart.legendToggle = function () {
	        // do nothing in base, should be overriden by sub-function
	    };
	
	    _chart.isLegendableHidden = function () {
	        // do nothing in base, should be overridden by sub-function
	        return false;
	    };
	
	    /**
	     * Set or get the key accessor function. The key accessor function is used to retrieve the key
	     * value from the crossfilter group. Key values are used differently in different charts, for
	     * example keys correspond to slices in a pie chart and x axis positions in a grid coordinate chart.
	     * @method keyAccessor
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default key accessor
	     * chart.keyAccessor(function(d) { return d.key; });
	     * // custom key accessor for a multi-value crossfilter reduction
	     * chart.keyAccessor(function(p) { return p.value.absGain; });
	     * @param {Function} [keyAccessor]
	     * @returns {Function|dc.baseMixin}
	     */
	    _chart.keyAccessor = function (keyAccessor) {
	        if (!arguments.length) {
	            return _keyAccessor;
	        }
	        _keyAccessor = keyAccessor;
	        return _chart;
	    };
	
	    /**
	     * Set or get the value accessor function. The value accessor function is used to retrieve the
	     * value from the crossfilter group. Group values are used differently in different charts, for
	     * example values correspond to slice sizes in a pie chart and y axis positions in a grid
	     * coordinate chart.
	     * @method valueAccessor
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default value accessor
	     * chart.valueAccessor(function(d) { return d.value; });
	     * // custom value accessor for a multi-value crossfilter reduction
	     * chart.valueAccessor(function(p) { return p.value.percentageGain; });
	     * @param {Function} [valueAccessor]
	     * @returns {Function|dc.baseMixin}
	     */
	    _chart.valueAccessor = function (valueAccessor) {
	        if (!arguments.length) {
	            return _valueAccessor;
	        }
	        _valueAccessor = valueAccessor;
	        return _chart;
	    };
	
	    /**
	     * Set or get the label function. The chart class will use this function to render labels for each
	     * child element in the chart, e.g. slices in a pie chart or bubbles in a bubble chart. Not every
	     * chart supports the label function, for example line chart does not use this function
	     * at all. By default, enables labels; pass false for the second parameter if this is not desired.
	     * @method label
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default label function just return the key
	     * chart.label(function(d) { return d.key; });
	     * // label function has access to the standard d3 data binding and can get quite complicated
	     * chart.label(function(d) { return d.data.key + '(' + Math.floor(d.data.value / all.value() * 100) + '%)'; });
	     * @param {Function} [labelFunction]
	     * @param {Boolean} [enableLabels=true]
	     * @returns {Function|dc.baseMixin}
	     */
	    _chart.label = function (labelFunction, enableLabels) {
	        if (!arguments.length) {
	            return _label;
	        }
	        _label = labelFunction;
	        if ((enableLabels === undefined) || enableLabels) {
	            _renderLabel = true;
	        }
	        return _chart;
	    };
	
	    /**
	     * Turn on/off label rendering
	     * @method renderLabel
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Boolean} [renderLabel=false]
	     * @returns {Boolean|dc.baseMixin}
	     */
	    _chart.renderLabel = function (renderLabel) {
	        if (!arguments.length) {
	            return _renderLabel;
	        }
	        _renderLabel = renderLabel;
	        return _chart;
	    };
	
	    /**
	     * Set or get the title function. The chart class will use this function to render the SVGElement title
	     * (usually interpreted by browser as tooltips) for each child element in the chart, e.g. a slice
	     * in a pie chart or a bubble in a bubble chart. Almost every chart supports the title function;
	     * however in grid coordinate charts you need to turn off the brush in order to see titles, because
	     * otherwise the brush layer will block tooltip triggering.
	     * @method title
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default title function shows "key: value"
	     * chart.title(function(d) { return d.key + ': ' + d.value; });
	     * // title function has access to the standard d3 data binding and can get quite complicated
	     * chart.title(function(p) {
	     *    return p.key.getFullYear()
	     *        + '\n'
	     *        + 'Index Gain: ' + numberFormat(p.value.absGain) + '\n'
	     *        + 'Index Gain in Percentage: ' + numberFormat(p.value.percentageGain) + '%\n'
	     *        + 'Fluctuation / Index Ratio: ' + numberFormat(p.value.fluctuationPercentage) + '%';
	     * });
	     * @param {Function} [titleFunction]
	     * @returns {Function|dc.baseMixin}
	     */
	    _chart.title = function (titleFunction) {
	        if (!arguments.length) {
	            return _title;
	        }
	        _title = titleFunction;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off title rendering, or return the state of the render title flag if no arguments are
	     * given.
	     * @method renderTitle
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Boolean} [renderTitle=true]
	     * @returns {Boolean|dc.baseMixin}
	     */
	    _chart.renderTitle = function (renderTitle) {
	        if (!arguments.length) {
	            return _renderTitle;
	        }
	        _renderTitle = renderTitle;
	        return _chart;
	    };
	
	    /**
	     * A renderlet is similar to an event listener on rendering event. Multiple renderlets can be added
	     * to an individual chart.  Each time a chart is rerendered or redrawn the renderlets are invoked
	     * right after the chart finishes its transitions, giving you a way to modify the SVGElements.
	     * Renderlet functions take the chart instance as the only input parameter and you can
	     * use the dc API or use raw d3 to achieve pretty much any effect.
	     *
	     * Use {@link dc.baseMixin#on on} with a 'renderlet' prefix.
	     * Generates a random key for the renderlet, which makes it hard to remove.
	     * @method renderlet
	     * @memberof dc.baseMixin
	     * @instance
	     * @deprecated
	     * @example
	     * // do this instead of .renderlet(function(chart) { ... })
	     * chart.on("renderlet", function(chart){
	     *     // mix of dc API and d3 manipulation
	     *     chart.select('g.y').style('display', 'none');
	     *     // its a closure so you can also access other chart variable available in the closure scope
	     *     moveChart.filter(chart.filter());
	     * });
	     * @param {Function} renderletFunction
	     * @returns {dc.baseMixin}
	     */
	    _chart.renderlet = dc.logger.deprecate(function (renderletFunction) {
	        _chart.on('renderlet.' + dc.utils.uniqueId(), renderletFunction);
	        return _chart;
	    }, 'chart.renderlet has been deprecated.  Please use chart.on("renderlet.<renderletKey>", renderletFunction)');
	
	    /**
	     * Get or set the chart group to which this chart belongs. Chart groups are rendered or redrawn
	     * together since it is expected they share the same underlying crossfilter data set.
	     * @method chartGroup
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {String} [chartGroup]
	     * @returns {String|dc.baseMixin}
	     */
	    _chart.chartGroup = function (chartGroup) {
	        if (!arguments.length) {
	            return _chartGroup;
	        }
	        if (!_isChild) {
	            dc.deregisterChart(_chart, _chartGroup);
	        }
	        _chartGroup = chartGroup;
	        if (!_isChild) {
	            dc.registerChart(_chart, _chartGroup);
	        }
	        return _chart;
	    };
	
	    /**
	     * Expire the internal chart cache. dc charts cache some data internally on a per chart basis to
	     * speed up rendering and avoid unnecessary calculation; however it might be useful to clear the
	     * cache if you have changed state which will affect rendering.  For example, if you invoke
	     * {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#crossfilter_add crossfilter.add}
	     * function or reset group or dimension after rendering, it is a good idea to
	     * clear the cache to make sure charts are rendered properly.
	     * @method expireCache
	     * @memberof dc.baseMixin
	     * @instance
	     * @returns {dc.baseMixin}
	     */
	    _chart.expireCache = function () {
	        // do nothing in base, should be overridden by sub-function
	        return _chart;
	    };
	
	    /**
	     * Attach a dc.legend widget to this chart. The legend widget will automatically draw legend labels
	     * based on the color setting and names associated with each group.
	     * @method legend
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * chart.legend(dc.legend().x(400).y(10).itemHeight(13).gap(5))
	     * @param {dc.legend} [legend]
	     * @returns {dc.legend|dc.baseMixin}
	     */
	    _chart.legend = function (legend) {
	        if (!arguments.length) {
	            return _legend;
	        }
	        _legend = legend;
	        _legend.parent(_chart);
	        return _chart;
	    };
	
	    /**
	     * Returns the internal numeric ID of the chart.
	     * @method chartID
	     * @memberof dc.baseMixin
	     * @instance
	     * @returns {String}
	     */
	    _chart.chartID = function () {
	        return _chart.__dcFlag__;
	    };
	
	    /**
	     * Set chart options using a configuration object. Each key in the object will cause the method of
	     * the same name to be called with the value to set that attribute for the chart.
	     * @method options
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * chart.options({dimension: myDimension, group: myGroup});
	     * @param {{}} opts
	     * @returns {dc.baseMixin}
	     */
	    _chart.options = function (opts) {
	        var applyOptions = [
	            'anchor',
	            'group',
	            'xAxisLabel',
	            'yAxisLabel',
	            'stack',
	            'title',
	            'point',
	            'getColor',
	            'overlayGeoJson'
	        ];
	
	        for (var o in opts) {
	            if (typeof(_chart[o]) === 'function') {
	                if (opts[o] instanceof Array && applyOptions.indexOf(o) !== -1) {
	                    _chart[o].apply(_chart, opts[o]);
	                } else {
	                    _chart[o].call(_chart, opts[o]);
	                }
	            } else {
	                dc.logger.debug('Not a valid option setter name: ' + o);
	            }
	        }
	        return _chart;
	    };
	
	    /**
	     * All dc chart instance supports the following listeners.
	     * Supports the following events:
	     * * `renderlet` - This listener function will be invoked after transitions after redraw and render. Replaces the
	     * deprecated {@link dc.baseMixin#renderlet renderlet} method.
	     * * `pretransition` - Like `.on('renderlet', ...)` but the event is fired before transitions start.
	     * * `preRender` - This listener function will be invoked before chart rendering.
	     * * `postRender` - This listener function will be invoked after chart finish rendering including
	     * all renderlets' logic.
	     * * `preRedraw` - This listener function will be invoked before chart redrawing.
	     * * `postRedraw` - This listener function will be invoked after chart finish redrawing
	     * including all renderlets' logic.
	     * * `filtered` - This listener function will be invoked after a filter is applied, added or removed.
	     * * `zoomed` - This listener function will be invoked after a zoom is triggered.
	     * @method on
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Internals.md#dispatch_on d3.dispatch.on}
	     * @example
	     * .on('renderlet', function(chart, filter){...})
	     * .on('pretransition', function(chart, filter){...})
	     * .on('preRender', function(chart){...})
	     * .on('postRender', function(chart){...})
	     * .on('preRedraw', function(chart){...})
	     * .on('postRedraw', function(chart){...})
	     * .on('filtered', function(chart, filter){...})
	     * .on('zoomed', function(chart, filter){...})
	     * @param {String} event
	     * @param {Function} listener
	     * @returns {dc.baseMixin}
	     */
	    _chart.on = function (event, listener) {
	        _listeners.on(event, listener);
	        return _chart;
	    };
	
	    return _chart;
	};
	
	/**
	 * Margin is a mixin that provides margin utility functions for both the Row Chart and Coordinate Grid
	 * Charts.
	 * @name marginMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @returns {dc.marginMixin}
	 */
	dc.marginMixin = function (_chart) {
	    var _margin = {top: 10, right: 50, bottom: 30, left: 30};
	
	    /**
	     * Get or set the margins for a particular coordinate grid chart instance. The margins is stored as
	     * an associative Javascript array.
	     * @method margins
	     * @memberof dc.marginMixin
	     * @instance
	     * @example
	     * var leftMargin = chart.margins().left; // 30 by default
	     * chart.margins().left = 50;
	     * leftMargin = chart.margins().left; // now 50
	     * @param {{top: Number, right: Number, left: Number, bottom: Number}} [margins={top: 10, right: 50, bottom: 30, left: 30}]
	     * @returns {{top: Number, right: Number, left: Number, bottom: Number}|dc.marginMixin}
	     */
	    _chart.margins = function (margins) {
	        if (!arguments.length) {
	            return _margin;
	        }
	        _margin = margins;
	        return _chart;
	    };
	
	    _chart.effectiveWidth = function () {
	        return _chart.width() - _chart.margins().left - _chart.margins().right;
	    };
	
	    _chart.effectiveHeight = function () {
	        return _chart.height() - _chart.margins().top - _chart.margins().bottom;
	    };
	
	    return _chart;
	};
	
	/**
	 * The Color Mixin is an abstract chart functional class providing universal coloring support
	 * as a mix-in for any concrete chart implementation.
	 * @name colorMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @returns {dc.colorMixin}
	 */
	dc.colorMixin = function (_chart) {
	    var _colors = d3.scale.category20c();
	    var _defaultAccessor = true;
	
	    var _colorAccessor = function (d) { return _chart.keyAccessor()(d); };
	
	    /**
	     * Retrieve current color scale or set a new color scale. This methods accepts any function that
	     * operates like a d3 scale.
	     * @method colors
	     * @memberof dc.colorMixin
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Scales.md d3.scale}
	     * @example
	     * // alternate categorical scale
	     * chart.colors(d3.scale.category20b());
	     * // ordinal scale
	     * chart.colors(d3.scale.ordinal().range(['red','green','blue']));
	     * // convenience method, the same as above
	     * chart.ordinalColors(['red','green','blue']);
	     * // set a linear scale
	     * chart.linearColors(["#4575b4", "#ffffbf", "#a50026"]);
	     * @param {d3.scale} [colorScale=d3.scale.category20c()]
	     * @returns {d3.scale|dc.colorMixin}
	     */
	    _chart.colors = function (colorScale) {
	        if (!arguments.length) {
	            return _colors;
	        }
	        if (colorScale instanceof Array) {
	            _colors = d3.scale.quantize().range(colorScale); // deprecated legacy support, note: this fails for ordinal domains
	        } else {
	            _colors = d3.functor(colorScale);
	        }
	        return _chart;
	    };
	
	    /**
	     * Convenience method to set the color scale to
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Ordinal-Scales.md#ordinal d3.scale.ordinal} with
	     * range `r`.
	     * @method ordinalColors
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {Array<String>} r
	     * @returns {dc.colorMixin}
	     */
	    _chart.ordinalColors = function (r) {
	        return _chart.colors(d3.scale.ordinal().range(r));
	    };
	
	    /**
	     * Convenience method to set the color scale to an Hcl interpolated linear scale with range `r`.
	     * @method linearColors
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {Array<Number>} r
	     * @returns {dc.colorMixin}
	     */
	    _chart.linearColors = function (r) {
	        return _chart.colors(d3.scale.linear()
	                             .range(r)
	                             .interpolate(d3.interpolateHcl));
	    };
	
	    /**
	     * Set or the get color accessor function. This function will be used to map a data point in a
	     * crossfilter group to a color value on the color scale. The default function uses the key
	     * accessor.
	     * @method colorAccessor
	     * @memberof dc.colorMixin
	     * @instance
	     * @example
	     * // default index based color accessor
	     * .colorAccessor(function (d, i){return i;})
	     * // color accessor for a multi-value crossfilter reduction
	     * .colorAccessor(function (d){return d.value.absGain;})
	     * @param {Function} [colorAccessor]
	     * @returns {Function|dc.colorMixin}
	     */
	    _chart.colorAccessor = function (colorAccessor) {
	        if (!arguments.length) {
	            return _colorAccessor;
	        }
	        _colorAccessor = colorAccessor;
	        _defaultAccessor = false;
	        return _chart;
	    };
	
	    // what is this?
	    _chart.defaultColorAccessor = function () {
	        return _defaultAccessor;
	    };
	
	    /**
	     * Set or get the current domain for the color mapping function. The domain must be supplied as an
	     * array.
	     *
	     * Note: previously this method accepted a callback function. Instead you may use a custom scale
	     * set by {@link dc.colorMixin#colors .colors}.
	     * @method colorDomain
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {Array<String>} [domain]
	     * @returns {Array<String>|dc.colorMixin}
	     */
	    _chart.colorDomain = function (domain) {
	        if (!arguments.length) {
	            return _colors.domain();
	        }
	        _colors.domain(domain);
	        return _chart;
	    };
	
	    /**
	     * Set the domain by determining the min and max values as retrieved by
	     * {@link dc.colorMixin#colorAccessor .colorAccessor} over the chart's dataset.
	     * @method calculateColorDomain
	     * @memberof dc.colorMixin
	     * @instance
	     * @returns {dc.colorMixin}
	     */
	    _chart.calculateColorDomain = function () {
	        var newDomain = [d3.min(_chart.data(), _chart.colorAccessor()),
	                         d3.max(_chart.data(), _chart.colorAccessor())];
	        _colors.domain(newDomain);
	        return _chart;
	    };
	
	    /**
	     * Get the color for the datum d and counter i. This is used internally by charts to retrieve a color.
	     * @method getColor
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {*} d
	     * @param {Number} [i]
	     * @returns {String}
	     */
	    _chart.getColor = function (d, i) {
	        return _colors(_colorAccessor.call(this, d, i));
	    };
	
	    /**
	     * **Deprecated.** Get/set the color calculator. This actually replaces the
	     * {@link dc.colorMixin#getColor getColor} method!
	     *
	     * This is not recommended, since using a {@link dc.colorMixin#colorAccessor colorAccessor} and
	     * color scale ({@link dc.colorMixin#colors .colors}) is more powerful and idiomatic d3.
	     * @method colorCalculator
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {*} [colorCalculator]
	     * @returns {Function|dc.colorMixin}
	     */
	    _chart.colorCalculator = dc.logger.deprecate(function (colorCalculator) {
	        if (!arguments.length) {
	            return _chart.getColor;
	        }
	        _chart.getColor = colorCalculator;
	        return _chart;
	    }, 'colorMixin.colorCalculator has been deprecated. Please colorMixin.colors and colorMixin.colorAccessor instead');
	
	    return _chart;
	};
	
	/**
	 * Coordinate Grid is an abstract base chart designed to support a number of coordinate grid based
	 * concrete chart types, e.g. bar chart, line chart, and bubble chart.
	 * @name coordinateGridMixin
	 * @memberof dc
	 * @mixin
	 * @mixes dc.colorMixin
	 * @mixes dc.marginMixin
	 * @mixes dc.baseMixin
	 * @param {Object} _chart
	 * @returns {dc.coordinateGridMixin}
	 */
	dc.coordinateGridMixin = function (_chart) {
	    var GRID_LINE_CLASS = 'grid-line';
	    var HORIZONTAL_CLASS = 'horizontal';
	    var VERTICAL_CLASS = 'vertical';
	    var Y_AXIS_LABEL_CLASS = 'y-axis-label';
	    var X_AXIS_LABEL_CLASS = 'x-axis-label';
	    var DEFAULT_AXIS_LABEL_PADDING = 12;
	
	    _chart = dc.colorMixin(dc.marginMixin(dc.baseMixin(_chart)));
	
	    _chart.colors(d3.scale.category10());
	    _chart._mandatoryAttributes().push('x');
	    var _parent;
	    var _g;
	    var _chartBodyG;
	
	    var _x;
	    var _xOriginalDomain;
	    var _xAxis = d3.svg.axis().orient('bottom');
	    var _xUnits = dc.units.integers;
	    var _xAxisPadding = 0;
	    var _xAxisPaddingUnit = 'day';
	    var _xElasticity = false;
	    var _xAxisLabel;
	    var _xAxisLabelPadding = 0;
	    var _lastXDomain;
	
	    var _y;
	    var _yAxis = d3.svg.axis().orient('left');
	    var _yAxisPadding = 0;
	    var _yElasticity = false;
	    var _yAxisLabel;
	    var _yAxisLabelPadding = 0;
	
	    var _brush = d3.svg.brush();
	    var _brushOn = true;
	    var _round;
	
	    var _renderHorizontalGridLine = false;
	    var _renderVerticalGridLine = false;
	
	    var _refocused = false, _resizing = false;
	    var _unitCount;
	
	    var _zoomScale = [1, Infinity];
	    var _zoomOutRestrict = true;
	
	    var _zoom = d3.behavior.zoom().on('zoom', zoomHandler);
	    var _nullZoom = d3.behavior.zoom().on('zoom', null);
	    var _hasBeenMouseZoomable = false;
	
	    var _rangeChart;
	    var _focusChart;
	
	    var _mouseZoomable = false;
	    var _clipPadding = 0;
	
	    var _outerRangeBandPadding = 0.5;
	    var _rangeBandPadding = 0;
	
	    var _useRightYAxis = false;
	
	    /**
	     * When changing the domain of the x or y scale, it is necessary to tell the chart to recalculate
	     * and redraw the axes. (`.rescale()` is called automatically when the x or y scale is replaced
	     * with {@link dc.coordinateGridMixin+x .x()} or {@link dc.coordinateGridMixin#y .y()}, and has
	     * no effect on elastic scales.)
	     * @method rescale
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @returns {dc.coordinateGridMixin}
	     */
	    _chart.rescale = function () {
	        _unitCount = undefined;
	        _resizing = true;
	        return _chart;
	    };
	
	    _chart.resizing = function () {
	        return _resizing;
	    };
	
	    /**
	     * Get or set the range selection chart associated with this instance. Setting the range selection
	     * chart using this function will automatically update its selection brush when the current chart
	     * zooms in. In return the given range chart will also automatically attach this chart as its focus
	     * chart hence zoom in when range brush updates.
	     *
	     * Usually the range and focus charts will share a dimension. The range chart will set the zoom
	     * boundaries for the focus chart, so its dimension values must be compatible with the domain of
	     * the focus chart.
	     *
	     * See the [Nasdaq 100 Index](http://dc-js.github.com/dc.js/) example for this effect in action.
	     * @method rangeChart
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {dc.coordinateGridMixin} [rangeChart]
	     * @returns {dc.coordinateGridMixin}
	     */
	    _chart.rangeChart = function (rangeChart) {
	        if (!arguments.length) {
	            return _rangeChart;
	        }
	        _rangeChart = rangeChart;
	        _rangeChart.focusChart(_chart);
	        return _chart;
	    };
	
	    /**
	     * Get or set the scale extent for mouse zooms.
	     * @method zoomScale
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Array<Number|Date>} [extent=[1, Infinity]]
	     * @returns {Array<Number|Date>|dc.coordinateGridMixin}
	     */
	    _chart.zoomScale = function (extent) {
	        if (!arguments.length) {
	            return _zoomScale;
	        }
	        _zoomScale = extent;
	        return _chart;
	    };
	
	    /**
	     * Get or set the zoom restriction for the chart. If true limits the zoom to origional domain of the chart.
	     * @method zoomOutRestrict
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [zoomOutRestrict=true]
	     * @returns {Boolean|dc.coordinateGridMixin}
	     */
	    _chart.zoomOutRestrict = function (zoomOutRestrict) {
	        if (!arguments.length) {
	            return _zoomOutRestrict;
	        }
	        _zoomScale[0] = zoomOutRestrict ? 1 : 0;
	        _zoomOutRestrict = zoomOutRestrict;
	        return _chart;
	    };
	
	    _chart._generateG = function (parent) {
	        if (parent === undefined) {
	            _parent = _chart.svg();
	        } else {
	            _parent = parent;
	        }
	
	        var href = window.location.href.split('#')[0];
	
	        _g = _parent.append('g');
	
	        _chartBodyG = _g.append('g').attr('class', 'chart-body')
	            .attr('transform', 'translate(' + _chart.margins().left + ', ' + _chart.margins().top + ')')
	            .attr('clip-path', 'url(' + href + '#' + getClipPathId() + ')');
	
	        return _g;
	    };
	
	    /**
	     * Get or set the root g element. This method is usually used to retrieve the g element in order to
	     * overlay custom svg drawing programatically. **Caution**: The root g element is usually generated
	     * by dc.js internals, and resetting it might produce unpredictable result.
	     * @method g
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {SVGElement} [gElement]
	     * @returns {SVGElement|dc.coordinateGridMixin}
	     */
	    _chart.g = function (gElement) {
	        if (!arguments.length) {
	            return _g;
	        }
	        _g = gElement;
	        return _chart;
	    };
	
	    /**
	     * Set or get mouse zoom capability flag (default: false). When turned on the chart will be
	     * zoomable using the mouse wheel. If the range selector chart is attached zooming will also update
	     * the range selection brush on the associated range selector chart.
	     * @method mouseZoomable
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [mouseZoomable=false]
	     * @returns {Boolean|dc.coordinateGridMixin}
	     */
	    _chart.mouseZoomable = function (mouseZoomable) {
	        if (!arguments.length) {
	            return _mouseZoomable;
	        }
	        _mouseZoomable = mouseZoomable;
	        return _chart;
	    };
	
	    /**
	     * Retrieve the svg group for the chart body.
	     * @method chartBodyG
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {SVGElement} [chartBodyG]
	     * @returns {SVGElement}
	     */
	    _chart.chartBodyG = function (chartBodyG) {
	        if (!arguments.length) {
	            return _chartBodyG;
	        }
	        _chartBodyG = chartBodyG;
	        return _chart;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Get or set the x scale. The x scale can be any d3
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Quantitative-Scales.md quantitive scale} or
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Ordinal-Scales.md ordinal scale}.
	     * @method x
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Scales.md d3.scale}
	     * @example
	     * // set x to a linear scale
	     * chart.x(d3.scale.linear().domain([-2500, 2500]))
	     * // set x to a time scale to generate histogram
	     * chart.x(d3.time.scale().domain([new Date(1985, 0, 1), new Date(2012, 11, 31)]))
	     * @param {d3.scale} [xScale]
	     * @returns {d3.scale|dc.coordinateGridMixin}
	     */
	    _chart.x = function (xScale) {
	        if (!arguments.length) {
	            return _x;
	        }
	        _x = xScale;
	        _xOriginalDomain = _x.domain();
	        _chart.rescale();
	        return _chart;
	    };
	
	    _chart.xOriginalDomain = function () {
	        return _xOriginalDomain;
	    };
	
	    /**
	     * Set or get the xUnits function. The coordinate grid chart uses the xUnits function to calculate
	     * the number of data projections on x axis such as the number of bars for a bar chart or the
	     * number of dots for a line chart. This function is expected to return a Javascript array of all
	     * data points on x axis, or the number of points on the axis. [d3 time range functions
	     * d3.time.days, d3.time.months, and
	     * d3.time.years](https://github.com/d3/d3-3.x-api-reference/blob/master/Time-Intervals.md#aliases) are all valid xUnits
	     * function. dc.js also provides a few units function, see the {@link dc.units Units Namespace} for
	     * a list of built-in units functions.
	     * @method xUnits
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @todo Add docs for utilities
	     * @example
	     * // set x units to count days
	     * chart.xUnits(d3.time.days);
	     * // set x units to count months
	     * chart.xUnits(d3.time.months);
	     *
	     * // A custom xUnits function can be used as long as it follows the following interface:
	     * // units in integer
	     * function(start, end, xDomain) {
	     *      // simply calculates how many integers in the domain
	     *      return Math.abs(end - start);
	     * };
	     *
	     * // fixed units
	     * function(start, end, xDomain) {
	     *      // be aware using fixed units will disable the focus/zoom ability on the chart
	     *      return 1000;
	     * @param {Function} [xUnits=dc.units.integers]
	     * @returns {Function|dc.coordinateGridMixin}
	     */
	    _chart.xUnits = function (xUnits) {
	        if (!arguments.length) {
	            return _xUnits;
	        }
	        _xUnits = xUnits;
	        return _chart;
	    };
	
	    /**
	     * Set or get the x axis used by a particular coordinate grid chart instance. This function is most
	     * useful when x axis customization is required. The x axis in dc.js is an instance of a
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Axes.md#axis d3 axis object};
	     * therefore it supports any valid d3 axis manipulation.
	     *
	     * **Caution**: The x axis is usually generated internally by dc; resetting it may cause
	     * unexpected results. Note also that when used as a getter, this function is not chainable:
	     * it returns the axis, not the chart,
	     * {@link https://github.com/dc-js/dc.js/wiki/FAQ#why-does-everything-break-after-a-call-to-xaxis-or-yaxis
	     * so attempting to call chart functions after calling `.xAxis()` will fail}.
	     * @method xAxis
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Axes.md#axis d3.svg.axis}
	     * @example
	     * // customize x axis tick format
	     * chart.xAxis().tickFormat(function(v) {return v + '%';});
	     * // customize x axis tick values
	     * chart.xAxis().tickValues([0, 100, 200, 300]);
	     * @param {d3.svg.axis} [xAxis=d3.svg.axis().orient('bottom')]
	     * @returns {d3.svg.axis|dc.coordinateGridMixin}
	     */
	    _chart.xAxis = function (xAxis) {
	        if (!arguments.length) {
	            return _xAxis;
	        }
	        _xAxis = xAxis;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off elastic x axis behavior. If x axis elasticity is turned on, then the grid chart will
	     * attempt to recalculate the x axis range whenever a redraw event is triggered.
	     * @method elasticX
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [elasticX=false]
	     * @returns {Boolean|dc.coordinateGridMixin}
	     */
	    _chart.elasticX = function (elasticX) {
	        if (!arguments.length) {
	            return _xElasticity;
	        }
	        _xElasticity = elasticX;
	        return _chart;
	    };
	
	    /**
	     * Set or get x axis padding for the elastic x axis. The padding will be added to both end of the x
	     * axis if elasticX is turned on; otherwise it is ignored.
	     *
	     * Padding can be an integer or percentage in string (e.g. '10%'). Padding can be applied to
	     * number or date x axes.  When padding a date axis, an integer represents number of units being padded
	     * and a percentage string will be treated the same as an integer. The unit will be determined by the
	     * xAxisPaddingUnit variable.
	     * @method xAxisPadding
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Number|String} [padding=0]
	     * @returns {Number|String|dc.coordinateGridMixin}
	     */
	    _chart.xAxisPadding = function (padding) {
	        if (!arguments.length) {
	            return _xAxisPadding;
	        }
	        _xAxisPadding = padding;
	        return _chart;
	    };
	
	    /**
	     * Set or get x axis padding unit for the elastic x axis. The padding unit will determine which unit to
	     * use when applying xAxis padding if elasticX is turned on and if x-axis uses a time dimension;
	     * otherwise it is ignored.
	     *
	     * Padding unit is a string that will be used when the padding is calculated. Available parameters are
	     * the available d3 time intervals; see
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Time-Intervals.md#interval d3.time.interval}.
	     * @method xAxisPaddingUnit
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {String} [unit='days']
	     * @returns {String|dc.coordinateGridMixin}
	     */
	    _chart.xAxisPaddingUnit = function (unit) {
	        if (!arguments.length) {
	            return _xAxisPaddingUnit;
	        }
	        _xAxisPaddingUnit = unit;
	        return _chart;
	    };
	
	    /**
	     * Returns the number of units displayed on the x axis using the unit measure configured by
	     * {@link dc.coordinateGridMixin#xUnits xUnits}.
	     * @method xUnitCount
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @returns {Number}
	     */
	    _chart.xUnitCount = function () {
	        if (_unitCount === undefined) {
	            var units = _chart.xUnits()(_chart.x().domain()[0], _chart.x().domain()[1], _chart.x().domain());
	
	            if (units instanceof Array) {
	                _unitCount = units.length;
	            } else {
	                _unitCount = units;
	            }
	        }
	
	        return _unitCount;
	    };
	
	    /**
	     * Gets or sets whether the chart should be drawn with a right axis instead of a left axis. When
	     * used with a chart in a composite chart, allows both left and right Y axes to be shown on a
	     * chart.
	     * @method useRightYAxis
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [useRightYAxis=false]
	     * @returns {Boolean|dc.coordinateGridMixin}
	     */
	    _chart.useRightYAxis = function (useRightYAxis) {
	        if (!arguments.length) {
	            return _useRightYAxis;
	        }
	        _useRightYAxis = useRightYAxis;
	        return _chart;
	    };
	
	    /**
	     * Returns true if the chart is using ordinal xUnits ({@link dc.units.ordinal dc.units.ordinal}, or false
	     * otherwise. Most charts behave differently with ordinal data and use the result of this method to
	     * trigger the appropriate logic.
	     * @method isOrdinal
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @returns {Boolean}
	     */
	    _chart.isOrdinal = function () {
	        return _chart.xUnits() === dc.units.ordinal;
	    };
	
	    _chart._useOuterPadding = function () {
	        return true;
	    };
	
	    _chart._ordinalXDomain = function () {
	        var groups = _chart._computeOrderedGroups(_chart.data());
	        return groups.map(_chart.keyAccessor());
	    };
	
	    function compareDomains (d1, d2) {
	        return !d1 || !d2 || d1.length !== d2.length ||
	            d1.some(function (elem, i) { return (elem && d2[i]) ? elem.toString() !== d2[i].toString() : elem === d2[i]; });
	    }
	
	    function prepareXAxis (g, render) {
	        if (!_chart.isOrdinal()) {
	            if (_chart.elasticX()) {
	                _x.domain([_chart.xAxisMin(), _chart.xAxisMax()]);
	            }
	        } else { // _chart.isOrdinal()
	            if (_chart.elasticX() || _x.domain().length === 0) {
	                _x.domain(_chart._ordinalXDomain());
	            }
	        }
	
	        // has the domain changed?
	        var xdom = _x.domain();
	        if (render || compareDomains(_lastXDomain, xdom)) {
	            _chart.rescale();
	        }
	        _lastXDomain = xdom;
	
	        // please can't we always use rangeBands for bar charts?
	        if (_chart.isOrdinal()) {
	            _x.rangeBands([0, _chart.xAxisLength()], _rangeBandPadding,
	                          _chart._useOuterPadding() ? _outerRangeBandPadding : 0);
	        } else {
	            _x.range([0, _chart.xAxisLength()]);
	        }
	
	        _xAxis = _xAxis.scale(_chart.x());
	
	        renderVerticalGridLines(g);
	    }
	
	    _chart.renderXAxis = function (g) {
	        var axisXG = g.select('g.x');
	
	        if (axisXG.empty()) {
	            axisXG = g.append('g')
	                .attr('class', 'axis x')
	                .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart._xAxisY() + ')');
	        }
	
	        var axisXLab = g.select('text.' + X_AXIS_LABEL_CLASS);
	        if (axisXLab.empty() && _chart.xAxisLabel()) {
	            axisXLab = g.append('text')
	                .attr('class', X_AXIS_LABEL_CLASS)
	                .attr('transform', 'translate(' + (_chart.margins().left + _chart.xAxisLength() / 2) + ',' +
	                      (_chart.height() - _xAxisLabelPadding) + ')')
	                .attr('text-anchor', 'middle');
	        }
	        if (_chart.xAxisLabel() && axisXLab.text() !== _chart.xAxisLabel()) {
	            axisXLab.text(_chart.xAxisLabel());
	        }
	
	        dc.transition(axisXG, _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart._xAxisY() + ')')
	            .call(_xAxis);
	        dc.transition(axisXLab, _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('transform', 'translate(' + (_chart.margins().left + _chart.xAxisLength() / 2) + ',' +
	                  (_chart.height() - _xAxisLabelPadding) + ')');
	    };
	
	    function renderVerticalGridLines (g) {
	        var gridLineG = g.select('g.' + VERTICAL_CLASS);
	
	        if (_renderVerticalGridLine) {
	            if (gridLineG.empty()) {
	                gridLineG = g.insert('g', ':first-child')
	                    .attr('class', GRID_LINE_CLASS + ' ' + VERTICAL_CLASS)
	                    .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	            }
	
	            var ticks = _xAxis.tickValues() ? _xAxis.tickValues() :
	                    (typeof _x.ticks === 'function' ? _x.ticks(_xAxis.ticks()[0]) : _x.domain());
	
	            var lines = gridLineG.selectAll('line')
	                .data(ticks);
	
	            // enter
	            var linesGEnter = lines.enter()
	                .append('line')
	                .attr('x1', function (d) {
	                    return _x(d);
	                })
	                .attr('y1', _chart._xAxisY() - _chart.margins().top)
	                .attr('x2', function (d) {
	                    return _x(d);
	                })
	                .attr('y2', 0)
	                .attr('opacity', 0);
	            dc.transition(linesGEnter, _chart.transitionDuration(), _chart.transitionDelay())
	                .attr('opacity', 1);
	
	            // update
	            dc.transition(lines, _chart.transitionDuration(), _chart.transitionDelay())
	                .attr('x1', function (d) {
	                    return _x(d);
	                })
	                .attr('y1', _chart._xAxisY() - _chart.margins().top)
	                .attr('x2', function (d) {
	                    return _x(d);
	                })
	                .attr('y2', 0);
	
	            // exit
	            lines.exit().remove();
	        } else {
	            gridLineG.selectAll('line').remove();
	        }
	    }
	
	    _chart._xAxisY = function () {
	        return (_chart.height() - _chart.margins().bottom);
	    };
	
	    _chart.xAxisLength = function () {
	        return _chart.effectiveWidth();
	    };
	
	    /**
	     * Set or get the x axis label. If setting the label, you may optionally include additional padding to
	     * the margin to make room for the label. By default the padded is set to 12 to accomodate the text height.
	     * @method xAxisLabel
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {String} [labelText]
	     * @param {Number} [padding=12]
	     * @returns {String}
	     */
	    _chart.xAxisLabel = function (labelText, padding) {
	        if (!arguments.length) {
	            return _xAxisLabel;
	        }
	        _xAxisLabel = labelText;
	        _chart.margins().bottom -= _xAxisLabelPadding;
	        _xAxisLabelPadding = (padding === undefined) ? DEFAULT_AXIS_LABEL_PADDING : padding;
	        _chart.margins().bottom += _xAxisLabelPadding;
	        return _chart;
	    };
	
	    _chart._prepareYAxis = function (g) {
	        if (_y === undefined || _chart.elasticY()) {
	            if (_y === undefined) {
	                _y = d3.scale.linear();
	            }
	            var min = _chart.yAxisMin() || 0,
	                max = _chart.yAxisMax() || 0;
	            _y.domain([min, max]).rangeRound([_chart.yAxisHeight(), 0]);
	        }
	
	        _y.range([_chart.yAxisHeight(), 0]);
	        _yAxis = _yAxis.scale(_y);
	
	        if (_useRightYAxis) {
	            _yAxis.orient('right');
	        }
	
	        _chart._renderHorizontalGridLinesForAxis(g, _y, _yAxis);
	    };
	
	    _chart.renderYAxisLabel = function (axisClass, text, rotation, labelXPosition) {
	        labelXPosition = labelXPosition || _yAxisLabelPadding;
	
	        var axisYLab = _chart.g().select('text.' + Y_AXIS_LABEL_CLASS + '.' + axisClass + '-label');
	        var labelYPosition = (_chart.margins().top + _chart.yAxisHeight() / 2);
	        if (axisYLab.empty() && text) {
	            axisYLab = _chart.g().append('text')
	                .attr('transform', 'translate(' + labelXPosition + ',' + labelYPosition + '),rotate(' + rotation + ')')
	                .attr('class', Y_AXIS_LABEL_CLASS + ' ' + axisClass + '-label')
	                .attr('text-anchor', 'middle')
	                .text(text);
	        }
	        if (text && axisYLab.text() !== text) {
	            axisYLab.text(text);
	        }
	        dc.transition(axisYLab, _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('transform', 'translate(' + labelXPosition + ',' + labelYPosition + '),rotate(' + rotation + ')');
	    };
	
	    _chart.renderYAxisAt = function (axisClass, axis, position) {
	        var axisYG = _chart.g().select('g.' + axisClass);
	        if (axisYG.empty()) {
	            axisYG = _chart.g().append('g')
	                .attr('class', 'axis ' + axisClass)
	                .attr('transform', 'translate(' + position + ',' + _chart.margins().top + ')');
	        }
	
	        dc.transition(axisYG, _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('transform', 'translate(' + position + ',' + _chart.margins().top + ')')
	            .call(axis);
	    };
	
	    _chart.renderYAxis = function () {
	        var axisPosition = _useRightYAxis ? (_chart.width() - _chart.margins().right) : _chart._yAxisX();
	        _chart.renderYAxisAt('y', _yAxis, axisPosition);
	        var labelPosition = _useRightYAxis ? (_chart.width() - _yAxisLabelPadding) : _yAxisLabelPadding;
	        var rotation = _useRightYAxis ? 90 : -90;
	        _chart.renderYAxisLabel('y', _chart.yAxisLabel(), rotation, labelPosition);
	    };
	
	    _chart._renderHorizontalGridLinesForAxis = function (g, scale, axis) {
	        var gridLineG = g.select('g.' + HORIZONTAL_CLASS);
	
	        if (_renderHorizontalGridLine) {
	            var ticks = axis.tickValues() ? axis.tickValues() : scale.ticks(axis.ticks()[0]);
	
	            if (gridLineG.empty()) {
	                gridLineG = g.insert('g', ':first-child')
	                    .attr('class', GRID_LINE_CLASS + ' ' + HORIZONTAL_CLASS)
	                    .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	            }
	
	            var lines = gridLineG.selectAll('line')
	                .data(ticks);
	
	            // enter
	            var linesGEnter = lines.enter()
	                .append('line')
	                .attr('x1', 1)
	                .attr('y1', function (d) {
	                    return scale(d);
	                })
	                .attr('x2', _chart.xAxisLength())
	                .attr('y2', function (d) {
	                    return scale(d);
	                })
	                .attr('opacity', 0);
	            dc.transition(linesGEnter, _chart.transitionDuration(), _chart.transitionDelay())
	                .attr('opacity', 1);
	
	            // update
	            dc.transition(lines, _chart.transitionDuration(), _chart.transitionDelay())
	                .attr('x1', 1)
	                .attr('y1', function (d) {
	                    return scale(d);
	                })
	                .attr('x2', _chart.xAxisLength())
	                .attr('y2', function (d) {
	                    return scale(d);
	                });
	
	            // exit
	            lines.exit().remove();
	        } else {
	            gridLineG.selectAll('line').remove();
	        }
	    };
	
	    _chart._yAxisX = function () {
	        return _chart.useRightYAxis() ? _chart.width() - _chart.margins().right : _chart.margins().left;
	    };
	
	    /**
	     * Set or get the y axis label. If setting the label, you may optionally include additional padding
	     * to the margin to make room for the label. By default the padding is set to 12 to accommodate the
	     * text height.
	     * @method yAxisLabel
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {String} [labelText]
	     * @param {Number} [padding=12]
	     * @returns {String|dc.coordinateGridMixin}
	     */
	    _chart.yAxisLabel = function (labelText, padding) {
	        if (!arguments.length) {
	            return _yAxisLabel;
	        }
	        _yAxisLabel = labelText;
	        _chart.margins().left -= _yAxisLabelPadding;
	        _yAxisLabelPadding = (padding === undefined) ? DEFAULT_AXIS_LABEL_PADDING : padding;
	        _chart.margins().left += _yAxisLabelPadding;
	        return _chart;
	    };
	
	    /**
	     * Get or set the y scale. The y scale is typically automatically determined by the chart implementation.
	     * @method y
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Scales.md d3.scale}
	     * @param {d3.scale} [yScale]
	     * @returns {d3.scale|dc.coordinateGridMixin}
	     */
	    _chart.y = function (yScale) {
	        if (!arguments.length) {
	            return _y;
	        }
	        _y = yScale;
	        _chart.rescale();
	        return _chart;
	    };
	
	    /**
	     * Set or get the y axis used by the coordinate grid chart instance. This function is most useful
	     * when y axis customization is required. The y axis in dc.js is simply an instance of a [d3 axis
	     * object](https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Axes.md#axis); therefore it supports any
	     * valid d3 axis manipulation.
	     *
	     * **Caution**: The y axis is usually generated internally by dc; resetting it may cause
	     * unexpected results.  Note also that when used as a getter, this function is not chainable: it
	     * returns the axis, not the chart,
	     * {@link https://github.com/dc-js/dc.js/wiki/FAQ#why-does-everything-break-after-a-call-to-xaxis-or-yaxis
	     * so attempting to call chart functions after calling `.yAxis()` will fail}.
	     * @method yAxis
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Axes.md#axis d3.svg.axis}
	     * @example
	     * // customize y axis tick format
	     * chart.yAxis().tickFormat(function(v) {return v + '%';});
	     * // customize y axis tick values
	     * chart.yAxis().tickValues([0, 100, 200, 300]);
	     * @param {d3.svg.axis} [yAxis=d3.svg.axis().orient('left')]
	     * @returns {d3.svg.axis|dc.coordinateGridMixin}
	     */
	    _chart.yAxis = function (yAxis) {
	        if (!arguments.length) {
	            return _yAxis;
	        }
	        _yAxis = yAxis;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off elastic y axis behavior. If y axis elasticity is turned on, then the grid chart will
	     * attempt to recalculate the y axis range whenever a redraw event is triggered.
	     * @method elasticY
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [elasticY=false]
	     * @returns {Boolean|dc.coordinateGridMixin}
	     */
	    _chart.elasticY = function (elasticY) {
	        if (!arguments.length) {
	            return _yElasticity;
	        }
	        _yElasticity = elasticY;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off horizontal grid lines.
	     * @method renderHorizontalGridLines
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [renderHorizontalGridLines=false]
	     * @returns {Boolean|dc.coordinateGridMixin}
	     */
	    _chart.renderHorizontalGridLines = function (renderHorizontalGridLines) {
	        if (!arguments.length) {
	            return _renderHorizontalGridLine;
	        }
	        _renderHorizontalGridLine = renderHorizontalGridLines;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off vertical grid lines.
	     * @method renderVerticalGridLines
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [renderVerticalGridLines=false]
	     * @returns {Boolean|dc.coordinateGridMixin}
	     */
	    _chart.renderVerticalGridLines = function (renderVerticalGridLines) {
	        if (!arguments.length) {
	            return _renderVerticalGridLine;
	        }
	        _renderVerticalGridLine = renderVerticalGridLines;
	        return _chart;
	    };
	
	    /**
	     * Calculates the minimum x value to display in the chart. Includes xAxisPadding if set.
	     * @method xAxisMin
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @returns {*}
	     */
	    _chart.xAxisMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return _chart.keyAccessor()(e);
	        });
	        return dc.utils.subtract(min, _xAxisPadding, _xAxisPaddingUnit);
	    };
	
	    /**
	     * Calculates the maximum x value to display in the chart. Includes xAxisPadding if set.
	     * @method xAxisMax
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @returns {*}
	     */
	    _chart.xAxisMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return _chart.keyAccessor()(e);
	        });
	        return dc.utils.add(max, _xAxisPadding, _xAxisPaddingUnit);
	    };
	
	    /**
	     * Calculates the minimum y value to display in the chart. Includes yAxisPadding if set.
	     * @method yAxisMin
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @returns {*}
	     */
	    _chart.yAxisMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return _chart.valueAccessor()(e);
	        });
	        return dc.utils.subtract(min, _yAxisPadding);
	    };
	
	    /**
	     * Calculates the maximum y value to display in the chart. Includes yAxisPadding if set.
	     * @method yAxisMax
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @returns {*}
	     */
	    _chart.yAxisMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return _chart.valueAccessor()(e);
	        });
	        return dc.utils.add(max, _yAxisPadding);
	    };
	
	    /**
	     * Set or get y axis padding for the elastic y axis. The padding will be added to the top and
	     * bottom of the y axis if elasticY is turned on; otherwise it is ignored.
	     *
	     * Padding can be an integer or percentage in string (e.g. '10%'). Padding can be applied to
	     * number or date axes. When padding a date axis, an integer represents number of days being padded
	     * and a percentage string will be treated the same as an integer.
	     * @method yAxisPadding
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Number|String} [padding=0]
	     * @returns {Number|dc.coordinateGridMixin}
	     */
	    _chart.yAxisPadding = function (padding) {
	        if (!arguments.length) {
	            return _yAxisPadding;
	        }
	        _yAxisPadding = padding;
	        return _chart;
	    };
	
	    _chart.yAxisHeight = function () {
	        return _chart.effectiveHeight();
	    };
	
	    /**
	     * Set or get the rounding function used to quantize the selection when brushing is enabled.
	     * @method round
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @example
	     * // set x unit round to by month, this will make sure range selection brush will
	     * // select whole months
	     * chart.round(d3.time.month.round);
	     * @param {Function} [round]
	     * @returns {Function|dc.coordinateGridMixin}
	     */
	    _chart.round = function (round) {
	        if (!arguments.length) {
	            return _round;
	        }
	        _round = round;
	        return _chart;
	    };
	
	    _chart._rangeBandPadding = function (_) {
	        if (!arguments.length) {
	            return _rangeBandPadding;
	        }
	        _rangeBandPadding = _;
	        return _chart;
	    };
	
	    _chart._outerRangeBandPadding = function (_) {
	        if (!arguments.length) {
	            return _outerRangeBandPadding;
	        }
	        _outerRangeBandPadding = _;
	        return _chart;
	    };
	
	    dc.override(_chart, 'filter', function (_) {
	        if (!arguments.length) {
	            return _chart._filter();
	        }
	
	        _chart._filter(_);
	
	        if (_) {
	            _chart.brush().extent(_);
	        } else {
	            _chart.brush().clear();
	        }
	
	        return _chart;
	    });
	
	    _chart.brush = function (_) {
	        if (!arguments.length) {
	            return _brush;
	        }
	        _brush = _;
	        return _chart;
	    };
	
	    function brushHeight () {
	        return _chart._xAxisY() - _chart.margins().top;
	    }
	
	    _chart.renderBrush = function (g) {
	        if (_brushOn) {
	            _brush.on('brush', _chart._brushing);
	            _brush.on('brushstart', _chart._disableMouseZoom);
	            _brush.on('brushend', configureMouseZoom);
	
	            var gBrush = g.append('g')
	                .attr('class', 'brush')
	                .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')')
	                .call(_brush.x(_chart.x()));
	            _chart.setBrushY(gBrush, false);
	            _chart.setHandlePaths(gBrush);
	
	            if (_chart.hasFilter()) {
	                _chart.redrawBrush(g, false);
	            }
	        }
	    };
	
	    _chart.setHandlePaths = function (gBrush) {
	        gBrush.selectAll('.resize').append('path').attr('d', _chart.resizeHandlePath);
	    };
	
	    _chart.setBrushY = function (gBrush) {
	        gBrush.selectAll('rect')
	            .attr('height', brushHeight());
	        gBrush.selectAll('.resize path')
	            .attr('d', _chart.resizeHandlePath);
	    };
	
	    _chart.extendBrush = function () {
	        var extent = _brush.extent();
	        if (_chart.round()) {
	            extent[0] = extent.map(_chart.round())[0];
	            extent[1] = extent.map(_chart.round())[1];
	
	            _g.select('.brush')
	                .call(_brush.extent(extent));
	        }
	        return extent;
	    };
	
	    _chart.brushIsEmpty = function (extent) {
	        return _brush.empty() || !extent || extent[1] <= extent[0];
	    };
	
	    _chart._brushing = function () {
	        var extent = _chart.extendBrush();
	
	        _chart.redrawBrush(_g, false);
	
	        if (_chart.brushIsEmpty(extent)) {
	            dc.events.trigger(function () {
	                _chart.filter(null);
	                _chart.redrawGroup();
	            }, dc.constants.EVENT_DELAY);
	        } else {
	            var rangedFilter = dc.filters.RangedFilter(extent[0], extent[1]);
	
	            dc.events.trigger(function () {
	                _chart.replaceFilter(rangedFilter);
	                _chart.redrawGroup();
	            }, dc.constants.EVENT_DELAY);
	        }
	    };
	
	    _chart.redrawBrush = function (g, doTransition) {
	        if (_brushOn) {
	            if (_chart.filter() && _chart.brush().empty()) {
	                _chart.brush().extent(_chart.filter());
	            }
	
	            var gBrush = dc.optionalTransition(doTransition, _chart.transitionDuration(), _chart.transitionDelay())(g.select('g.brush'));
	            _chart.setBrushY(gBrush);
	            gBrush.call(_chart.brush()
	                      .x(_chart.x())
	                      .extent(_chart.brush().extent()));
	        }
	
	        _chart.fadeDeselectedArea();
	    };
	
	    _chart.fadeDeselectedArea = function () {
	        // do nothing, sub-chart should override this function
	    };
	
	    // borrowed from Crossfilter example
	    _chart.resizeHandlePath = function (d) {
	        var e = +(d === 'e'), x = e ? 1 : -1, y = brushHeight() / 3;
	        return 'M' + (0.5 * x) + ',' + y +
	            'A6,6 0 0 ' + e + ' ' + (6.5 * x) + ',' + (y + 6) +
	            'V' + (2 * y - 6) +
	            'A6,6 0 0 ' + e + ' ' + (0.5 * x) + ',' + (2 * y) +
	            'Z' +
	            'M' + (2.5 * x) + ',' + (y + 8) +
	            'V' + (2 * y - 8) +
	            'M' + (4.5 * x) + ',' + (y + 8) +
	            'V' + (2 * y - 8);
	    };
	
	    function getClipPathId () {
	        return _chart.anchorName().replace(/[ .#=\[\]]/g, '-') + '-clip';
	    }
	
	    /**
	     * Get or set the padding in pixels for the clip path. Once set padding will be applied evenly to
	     * the top, left, right, and bottom when the clip path is generated. If set to zero, the clip area
	     * will be exactly the chart body area minus the margins.
	     * @method clipPadding
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Number} [padding=5]
	     * @returns {Number|dc.coordinateGridMixin}
	     */
	    _chart.clipPadding = function (padding) {
	        if (!arguments.length) {
	            return _clipPadding;
	        }
	        _clipPadding = padding;
	        return _chart;
	    };
	
	    function generateClipPath () {
	        var defs = dc.utils.appendOrSelect(_parent, 'defs');
	        // cannot select <clippath> elements; bug in WebKit, must select by id
	        // https://groups.google.com/forum/#!topic/d3-js/6EpAzQ2gU9I
	        var id = getClipPathId();
	        var chartBodyClip = dc.utils.appendOrSelect(defs, '#' + id, 'clipPath').attr('id', id);
	
	        var padding = _clipPadding * 2;
	
	        dc.utils.appendOrSelect(chartBodyClip, 'rect')
	            .attr('width', _chart.xAxisLength() + padding)
	            .attr('height', _chart.yAxisHeight() + padding)
	            .attr('transform', 'translate(-' + _clipPadding + ', -' + _clipPadding + ')');
	    }
	
	    _chart._preprocessData = function () {};
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _chart._preprocessData();
	
	        _chart._generateG();
	        generateClipPath();
	
	        drawChart(true);
	
	        configureMouseZoom();
	
	        return _chart;
	    };
	
	    _chart._doRedraw = function () {
	        _chart._preprocessData();
	
	        drawChart(false);
	        generateClipPath();
	
	        return _chart;
	    };
	
	    function drawChart (render) {
	        if (_chart.isOrdinal()) {
	            _brushOn = false;
	        }
	
	        prepareXAxis(_chart.g(), render);
	        _chart._prepareYAxis(_chart.g());
	
	        _chart.plotData();
	
	        if (_chart.elasticX() || _resizing || render) {
	            _chart.renderXAxis(_chart.g());
	        }
	
	        if (_chart.elasticY() || _resizing || render) {
	            _chart.renderYAxis(_chart.g());
	        }
	
	        if (render) {
	            _chart.renderBrush(_chart.g(), false);
	        } else {
	            _chart.redrawBrush(_chart.g(), _resizing);
	        }
	        _chart.fadeDeselectedArea();
	        _resizing = false;
	    }
	
	    function configureMouseZoom () {
	        if (_mouseZoomable) {
	            _chart._enableMouseZoom();
	        } else if (_hasBeenMouseZoomable) {
	            _chart._disableMouseZoom();
	        }
	    }
	
	    _chart._enableMouseZoom = function () {
	        _hasBeenMouseZoomable = true;
	        _zoom.x(_chart.x())
	            .scaleExtent(_zoomScale)
	            .size([_chart.width(), _chart.height()])
	            .duration(_chart.transitionDuration());
	        _chart.root().call(_zoom);
	    };
	
	    _chart._disableMouseZoom = function () {
	        _chart.root().call(_nullZoom);
	    };
	
	    function zoomHandler () {
	        _refocused = true;
	        if (_zoomOutRestrict) {
	            var constraint = _xOriginalDomain;
	            if (_rangeChart) {
	                constraint = intersectExtents(constraint, _rangeChart.x().domain());
	            }
	            var constrained = constrainExtent(_chart.x().domain(), constraint);
	            if (constrained) {
	                _chart.x().domain(constrained);
	            }
	        }
	
	        var domain = _chart.x().domain();
	        var domFilter = dc.filters.RangedFilter(domain[0], domain[1]);
	
	        _chart.replaceFilter(domFilter);
	        _chart.rescale();
	        _chart.redraw();
	
	        if (_rangeChart && !rangesEqual(_chart.filter(), _rangeChart.filter())) {
	            dc.events.trigger(function () {
	                _rangeChart.replaceFilter(domFilter);
	                _rangeChart.redraw();
	            });
	        }
	
	        _chart._invokeZoomedListener();
	
	        dc.events.trigger(function () {
	            _chart.redrawGroup();
	        }, dc.constants.EVENT_DELAY);
	
	        _refocused = !rangesEqual(domain, _xOriginalDomain);
	    }
	
	    function intersectExtents (ext1, ext2) {
	        if (ext1[0] > ext2[1] || ext1[1] < ext2[0]) {
	            console.warn('could not intersect extents');
	        }
	        return [Math.max(ext1[0], ext2[0]), Math.min(ext1[1], ext2[1])];
	    }
	
	    function constrainExtent (extent, constraint) {
	        var size = extent[1] - extent[0];
	        if (extent[0] < constraint[0]) {
	            return [constraint[0], Math.min(constraint[1], dc.utils.add(constraint[0], size, 'millis'))];
	        } else if (extent[1] > constraint[1]) {
	            return [Math.max(constraint[0], dc.utils.subtract(constraint[1], size, 'millis')), constraint[1]];
	        } else {
	            return null;
	        }
	    }
	
	    /**
	     * Zoom this chart to focus on the given range. The given range should be an array containing only
	     * 2 elements (`[start, end]`) defining a range in the x domain. If the range is not given or set
	     * to null, then the zoom will be reset. _For focus to work elasticX has to be turned off;
	     * otherwise focus will be ignored.
	     * @method focus
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @example
	     * chart.on('renderlet', function(chart) {
	     *     // smooth the rendering through event throttling
	     *     dc.events.trigger(function(){
	     *          // focus some other chart to the range selected by user on this chart
	     *          someOtherChart.focus(chart.filter());
	     *     });
	     * })
	     * @param {Array<Number>} [range]
	     */
	    _chart.focus = function (range) {
	        if (hasRangeSelected(range)) {
	            _chart.x().domain(range);
	        } else {
	            _chart.x().domain(_xOriginalDomain);
	        }
	
	        _zoom.x(_chart.x());
	        zoomHandler();
	    };
	
	    _chart.refocused = function () {
	        return _refocused;
	    };
	
	    _chart.focusChart = function (c) {
	        if (!arguments.length) {
	            return _focusChart;
	        }
	        _focusChart = c;
	        _chart.on('filtered', function (chart) {
	            if (!chart.filter()) {
	                dc.events.trigger(function () {
	                    _focusChart.x().domain(_focusChart.xOriginalDomain());
	                });
	            } else if (!rangesEqual(chart.filter(), _focusChart.filter())) {
	                dc.events.trigger(function () {
	                    _focusChart.focus(chart.filter());
	                });
	            }
	        });
	        return _chart;
	    };
	
	    function rangesEqual (range1, range2) {
	        if (!range1 && !range2) {
	            return true;
	        } else if (!range1 || !range2) {
	            return false;
	        } else if (range1.length === 0 && range2.length === 0) {
	            return true;
	        } else if (range1[0].valueOf() === range2[0].valueOf() &&
	            range1[1].valueOf() === range2[1].valueOf()) {
	            return true;
	        }
	        return false;
	    }
	
	    /**
	     * Turn on/off the brush-based range filter. When brushing is on then user can drag the mouse
	     * across a chart with a quantitative scale to perform range filtering based on the extent of the
	     * brush, or click on the bars of an ordinal bar chart or slices of a pie chart to filter and
	     * un-filter them. However turning on the brush filter will disable other interactive elements on
	     * the chart such as highlighting, tool tips, and reference lines. Zooming will still be possible
	     * if enabled, but only via scrolling (panning will be disabled.)
	     * @method brushOn
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [brushOn=true]
	     * @returns {Boolean|dc.coordinateGridMixin}
	     */
	    _chart.brushOn = function (brushOn) {
	        if (!arguments.length) {
	            return _brushOn;
	        }
	        _brushOn = brushOn;
	        return _chart;
	    };
	
	    function hasRangeSelected (range) {
	        return range instanceof Array && range.length > 1;
	    }
	
	    return _chart;
	};
	
	/**
	 * Stack Mixin is an mixin that provides cross-chart support of stackability using d3.layout.stack.
	 * @name stackMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @returns {dc.stackMixin}
	 */
	dc.stackMixin = function (_chart) {
	
	    function prepareValues (layer, layerIdx) {
	        var valAccessor = layer.accessor || _chart.valueAccessor();
	        layer.name = String(layer.name || layerIdx);
	        layer.values = layer.group.all().map(function (d, i) {
	            return {
	                x: _chart.keyAccessor()(d, i),
	                y: layer.hidden ? null : valAccessor(d, i),
	                data: d,
	                layer: layer.name,
	                hidden: layer.hidden
	            };
	        });
	
	        layer.values = layer.values.filter(domainFilter());
	        return layer.values;
	    }
	
	    var _stackLayout = d3.layout.stack()
	        .values(prepareValues);
	
	    var _stack = [];
	    var _titles = {};
	
	    var _hidableStacks = false;
	
	    function domainFilter () {
	        if (!_chart.x()) {
	            return d3.functor(true);
	        }
	        var xDomain = _chart.x().domain();
	        if (_chart.isOrdinal()) {
	            // TODO #416
	            //var domainSet = d3.set(xDomain);
	            return function () {
	                return true; //domainSet.has(p.x);
	            };
	        }
	        if (_chart.elasticX()) {
	            return function () { return true; };
	        }
	        return function (p) {
	            //return true;
	            return p.x >= xDomain[0] && p.x <= xDomain[xDomain.length - 1];
	        };
	    }
	
	    /**
	     * Stack a new crossfilter group onto this chart with an optional custom value accessor. All stacks
	     * in the same chart will share the same key accessor and therefore the same set of keys.
	     *
	     * For example, in a stacked bar chart, the bars of each stack will be positioned using the same set
	     * of keys on the x axis, while stacked vertically. If name is specified then it will be used to
	     * generate the legend label.
	     * @method stack
	     * @memberof dc.stackMixin
	     * @instance
	     * @see {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#group-map-reduce crossfilter.group}
	     * @example
	     * // stack group using default accessor
	     * chart.stack(valueSumGroup)
	     * // stack group using custom accessor
	     * .stack(avgByDayGroup, function(d){return d.value.avgByDay;});
	     * @param {crossfilter.group} group
	     * @param {String} [name]
	     * @param {Function} [accessor]
	     * @returns {Array<{group: crossfilter.group, name: String, accessor: Function}>|dc.stackMixin}
	     */
	    _chart.stack = function (group, name, accessor) {
	        if (!arguments.length) {
	            return _stack;
	        }
	
	        if (arguments.length <= 2) {
	            accessor = name;
	        }
	
	        var layer = {group: group};
	        if (typeof name === 'string') {
	            layer.name = name;
	        }
	        if (typeof accessor === 'function') {
	            layer.accessor = accessor;
	        }
	        _stack.push(layer);
	
	        return _chart;
	    };
	
	    dc.override(_chart, 'group', function (g, n, f) {
	        if (!arguments.length) {
	            return _chart._group();
	        }
	        _stack = [];
	        _titles = {};
	        _chart.stack(g, n);
	        if (f) {
	            _chart.valueAccessor(f);
	        }
	        return _chart._group(g, n);
	    });
	
	    /**
	     * Allow named stacks to be hidden or shown by clicking on legend items.
	     * This does not affect the behavior of hideStack or showStack.
	     * @method hidableStacks
	     * @memberof dc.stackMixin
	     * @instance
	     * @param {Boolean} [hidableStacks=false]
	     * @returns {Boolean|dc.stackMixin}
	     */
	    _chart.hidableStacks = function (hidableStacks) {
	        if (!arguments.length) {
	            return _hidableStacks;
	        }
	        _hidableStacks = hidableStacks;
	        return _chart;
	    };
	
	    function findLayerByName (n) {
	        var i = _stack.map(dc.pluck('name')).indexOf(n);
	        return _stack[i];
	    }
	
	    /**
	     * Hide all stacks on the chart with the given name.
	     * The chart must be re-rendered for this change to appear.
	     * @method hideStack
	     * @memberof dc.stackMixin
	     * @instance
	     * @param {String} stackName
	     * @returns {dc.stackMixin}
	     */
	    _chart.hideStack = function (stackName) {
	        var layer = findLayerByName(stackName);
	        if (layer) {
	            layer.hidden = true;
	        }
	        return _chart;
	    };
	
	    /**
	     * Show all stacks on the chart with the given name.
	     * The chart must be re-rendered for this change to appear.
	     * @method showStack
	     * @memberof dc.stackMixin
	     * @instance
	     * @param {String} stackName
	     * @returns {dc.stackMixin}
	     */
	    _chart.showStack = function (stackName) {
	        var layer = findLayerByName(stackName);
	        if (layer) {
	            layer.hidden = false;
	        }
	        return _chart;
	    };
	
	    _chart.getValueAccessorByIndex = function (index) {
	        return _stack[index].accessor || _chart.valueAccessor();
	    };
	
	    _chart.yAxisMin = function () {
	        var min = d3.min(flattenStack(), function (p) {
	            return (p.y < 0) ? (p.y + p.y0) : p.y0;
	        });
	
	        return dc.utils.subtract(min, _chart.yAxisPadding());
	
	    };
	
	    _chart.yAxisMax = function () {
	        var max = d3.max(flattenStack(), function (p) {
	            return (p.y > 0) ? (p.y + p.y0) : p.y0;
	        });
	
	        return dc.utils.add(max, _chart.yAxisPadding());
	    };
	
	    function flattenStack () {
	        var valueses = _chart.data().map(function (layer) { return layer.values; });
	        return Array.prototype.concat.apply([], valueses);
	    }
	
	    _chart.xAxisMin = function () {
	        var min = d3.min(flattenStack(), dc.pluck('x'));
	        return dc.utils.subtract(min, _chart.xAxisPadding(), _chart.xAxisPaddingUnit());
	    };
	
	    _chart.xAxisMax = function () {
	        var max = d3.max(flattenStack(), dc.pluck('x'));
	        return dc.utils.add(max, _chart.xAxisPadding(), _chart.xAxisPaddingUnit());
	    };
	
	    /**
	     * Set or get the title function. Chart class will use this function to render svg title (usually interpreted by
	     * browser as tooltips) for each child element in the chart, i.e. a slice in a pie chart or a bubble in a bubble chart.
	     * Almost every chart supports title function however in grid coordinate chart you need to turn off brush in order to
	     * use title otherwise the brush layer will block tooltip trigger.
	     *
	     * If the first argument is a stack name, the title function will get or set the title for that stack. If stackName
	     * is not provided, the first stack is implied.
	     * @method title
	     * @memberof dc.stackMixin
	     * @instance
	     * @example
	     * // set a title function on 'first stack'
	     * chart.title('first stack', function(d) { return d.key + ': ' + d.value; });
	     * // get a title function from 'second stack'
	     * var secondTitleFunction = chart.title('second stack');
	     * @param {String} [stackName]
	     * @param {Function} [titleAccessor]
	     * @returns {String|dc.stackMixin}
	     */
	    dc.override(_chart, 'title', function (stackName, titleAccessor) {
	        if (!stackName) {
	            return _chart._title();
	        }
	
	        if (typeof stackName === 'function') {
	            return _chart._title(stackName);
	        }
	        if (stackName === _chart._groupName && typeof titleAccessor === 'function') {
	            return _chart._title(titleAccessor);
	        }
	
	        if (typeof titleAccessor !== 'function') {
	            return _titles[stackName] || _chart._title();
	        }
	
	        _titles[stackName] = titleAccessor;
	
	        return _chart;
	    });
	
	    /**
	     * Gets or sets the stack layout algorithm, which computes a baseline for each stack and
	     * propagates it to the next.
	     * @method stackLayout
	     * @memberof dc.stackMixin
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Stack-Layout.md d3.layout.stack}
	     * @param {Function} [stack=d3.layout.stack]
	     * @returns {Function|dc.stackMixin}
	     */
	    _chart.stackLayout = function (stack) {
	        if (!arguments.length) {
	            return _stackLayout;
	        }
	        _stackLayout = stack;
	        if (_stackLayout.values() === d3.layout.stack().values()) {
	            _stackLayout.values(prepareValues);
	        }
	        return _chart;
	    };
	
	    function visability (l) {
	        return !l.hidden;
	    }
	
	    _chart.data(function () {
	        var layers = _stack.filter(visability);
	        return layers.length ? _chart.stackLayout()(layers) : [];
	    });
	
	    _chart._ordinalXDomain = function () {
	        var flat = flattenStack().map(dc.pluck('data'));
	        var ordered = _chart._computeOrderedGroups(flat);
	        return ordered.map(_chart.keyAccessor());
	    };
	
	    _chart.colorAccessor(function (d) {
	        var layer = this.layer || this.name || d.name || d.layer;
	        return layer;
	    });
	
	    _chart.legendables = function () {
	        return _stack.map(function (layer, i) {
	            return {
	                chart: _chart,
	                name: layer.name,
	                hidden: layer.hidden || false,
	                color: _chart.getColor.call(layer, layer.values, i)
	            };
	        });
	    };
	
	    _chart.isLegendableHidden = function (d) {
	        var layer = findLayerByName(d.name);
	        return layer ? layer.hidden : false;
	    };
	
	    _chart.legendToggle = function (d) {
	        if (_hidableStacks) {
	            if (_chart.isLegendableHidden(d)) {
	                _chart.showStack(d.name);
	            } else {
	                _chart.hideStack(d.name);
	            }
	            //_chart.redraw();
	            _chart.renderGroup();
	        }
	    };
	
	    return _chart;
	};
	
	/**
	 * Cap is a mixin that groups small data elements below a _cap_ into an *others* grouping for both the
	 * Row and Pie Charts.
	 *
	 * The top ordered elements in the group up to the cap amount will be kept in the chart, and the rest
	 * will be replaced with an *others* element, with value equal to the sum of the replaced values. The
	 * keys of the elements below the cap limit are recorded in order to filter by those keys when the
	 * others* element is clicked.
	 * @name capMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @returns {dc.capMixin}
	 */
	dc.capMixin = function (_chart) {
	    var _cap = Infinity, _takeFront = true;
	    var _othersLabel = 'Others';
	
	    var _othersGrouper = function (topItems, restItems) {
	        var restItemsSum = d3.sum(restItems, _chart.valueAccessor()),
	            restKeys = restItems.map(_chart.keyAccessor());
	        if (restItemsSum > 0) {
	            return topItems.concat([{
	                others: restKeys,
	                key: _chart.othersLabel(),
	                value: restItemsSum
	            }]);
	        }
	        return topItems;
	    };
	
	    _chart.cappedKeyAccessor = function (d, i) {
	        if (d.others) {
	            return d.key;
	        }
	        return _chart.keyAccessor()(d, i);
	    };
	
	    _chart.cappedValueAccessor = function (d, i) {
	        if (d.others) {
	            return d.value;
	        }
	        return _chart.valueAccessor()(d, i);
	    };
	
	    // return N "top" groups, where N is the cap, sorted by baseMixin.ordering
	    // whether top means front or back depends on takeFront
	    _chart.data(function (group) {
	        if (_cap === Infinity) {
	            return _chart._computeOrderedGroups(group.all());
	        } else {
	            var items = group.all(), rest;
	            items = _chart._computeOrderedGroups(items); // sort by baseMixin.ordering
	
	            if (_cap) {
	                if (_takeFront) {
	                    rest = items.slice(_cap);
	                    items = items.slice(0, _cap);
	                } else {
	                    var start = Math.max(0, items.length - _cap);
	                    rest = items.slice(0, start);
	                    items = items.slice(start);
	                }
	            }
	
	            if (_othersGrouper) {
	                return _othersGrouper(items, rest);
	            }
	            return items;
	        }
	    });
	
	    /**
	     * Get or set the count of elements to that will be included in the cap. If there is an
	     * {@link dc.capMixin#othersGrouper othersGrouper}, any further elements will be combined in an
	     * extra element with its name determined by {@link dc.capMixin#othersLabel othersLabel}.
	     *
	     * As of dc.js 2.1 and onward, the capped charts use
	     * {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#group_all group.all()}
	     * and {@link dc.baseMixin#ordering baseMixin.ordering()} to determine the order of
	     * elements. Then `cap` and {@link dc.capMixin#takeFront takeFront} determine how many elements
	     * to keep, from which end of the resulting array.
	     *
	     * **Migration note:** Up through dc.js 2.0.*, capping used
	     * {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#group_top group.top(N)},
	     * which selects the largest items according to
	     * {@link https://github.com/crossfilter/crossfilter/wiki/API-Reference#group_order group.order()}.
	     * The chart then sorted the items according to {@link dc.baseMixin#ordering baseMixin.ordering()}.
	     * So the two values essentially had to agree, but if the `group.order()` was incorrect (it's
	     * easy to forget about), the wrong rows or slices would be displayed, in the correct order.
	     *
	     * If your chart previously relied on `group.order()`, use `chart.ordering()` instead. If you
	     * actually want to cap by size but e.g. sort alphabetically by key, please
	     * [file an issue](https://github.com/dc-js/dc.js/issues/new) - it's still possible but we'll
	     * need to work up an example.
	     * @method cap
	     * @memberof dc.capMixin
	     * @instance
	     * @param {Number} [count=Infinity]
	     * @returns {Number|dc.capMixin}
	     */
	    _chart.cap = function (count) {
	        if (!arguments.length) {
	            return _cap;
	        }
	        _cap = count;
	        return _chart;
	    };
	
	    /**
	     * Get or set the direction of capping. If set, the chart takes the first
	     * {@link dc.capMixin#cap cap} elements from the sorted array of elements; otherwise
	     * it takes the last `cap` elements.
	     * @method takeFront
	     * @memberof dc.capMixin
	     * @instance
	     * @param {Boolean} [takeFront=true]
	     * @returns {Boolean|dc.capMixin}
	     */
	    _chart.takeFront = function (takeFront) {
	        if (!arguments.length) {
	            return _takeFront;
	        }
	        _takeFront = takeFront;
	        return _chart;
	    };
	
	    /**
	     * Get or set the label for *Others* slice when slices cap is specified.
	     * @method othersLabel
	     * @memberof dc.capMixin
	     * @instance
	     * @param {String} [label="Others"]
	     * @returns {String|dc.capMixin}
	     */
	    _chart.othersLabel = function (label) {
	        if (!arguments.length) {
	            return _othersLabel;
	        }
	        _othersLabel = label;
	        return _chart;
	    };
	
	    /**
	     * Get or set the grouper function that will perform the insertion of data for the *Others* slice
	     * if the slices cap is specified. If set to a falsy value, no others will be added.
	     *
	     * The grouper function takes an array of included ("top") items, and an array of the rest of
	     * the items. By default the grouper function computes the sum of the rest.
	     * @method othersGrouper
	     * @memberof dc.capMixin
	     * @instance
	     * @example
	     * // Do not show others
	     * chart.othersGrouper(null);
	     * // Default others grouper
	     * chart.othersGrouper(function (topItems, restItems) {
	     *     var restItemsSum = d3.sum(restItems, _chart.valueAccessor()),
	     *         restKeys = restItems.map(_chart.keyAccessor());
	     *     if (restItemsSum > 0) {
	     *         return topItems.concat([{
	     *             others: restKeys,
	     *             key: _chart.othersLabel(),
	     *             value: restItemsSum
	     *         }]);
	     *     }
	     *     return topItems;
	     * });
	     * @param {Function} [grouperFunction]
	     * @returns {Function|dc.capMixin}
	     */
	    _chart.othersGrouper = function (grouperFunction) {
	        if (!arguments.length) {
	            return _othersGrouper;
	        }
	        _othersGrouper = grouperFunction;
	        return _chart;
	    };
	
	    dc.override(_chart, 'onClick', function (d) {
	        if (d.others) {
	            _chart.filter([d.others]);
	        }
	        _chart._onClick(d);
	    });
	
	    return _chart;
	};
	
	/**
	 * This Mixin provides reusable functionalities for any chart that needs to visualize data using bubbles.
	 * @name bubbleMixin
	 * @memberof dc
	 * @mixin
	 * @mixes dc.colorMixin
	 * @param {Object} _chart
	 * @returns {dc.bubbleMixin}
	 */
	dc.bubbleMixin = function (_chart) {
	    var _maxBubbleRelativeSize = 0.3;
	    var _minRadiusWithLabel = 10;
	    var _sortBubbleSize = false;
	    var _elasticRadius = false;
	
	    _chart.BUBBLE_NODE_CLASS = 'node';
	    _chart.BUBBLE_CLASS = 'bubble';
	    _chart.MIN_RADIUS = 10;
	
	    _chart = dc.colorMixin(_chart);
	
	    _chart.renderLabel(true);
	
	    _chart.data(function (group) {
	        var data = group.all();
	        if (_sortBubbleSize) {
	            // sort descending so smaller bubbles are on top
	            var radiusAccessor = _chart.radiusValueAccessor();
	            data.sort(function (a, b) { return d3.descending(radiusAccessor(a), radiusAccessor(b)); });
	        }
	        return data;
	    });
	
	    var _r = d3.scale.linear().domain([0, 100]);
	
	    var _rValueAccessor = function (d) {
	        return d.r;
	    };
	
	    /**
	     * Get or set the bubble radius scale. By default the bubble chart uses
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Quantitative-Scales.md#linear d3.scale.linear().domain([0, 100])}
	     * as its radius scale.
	     * @method r
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Scales.md d3.scale}
	     * @param {d3.scale} [bubbleRadiusScale=d3.scale.linear().domain([0, 100])]
	     * @returns {d3.scale|dc.bubbleMixin}
	     */
	    _chart.r = function (bubbleRadiusScale) {
	        if (!arguments.length) {
	            return _r;
	        }
	        _r = bubbleRadiusScale;
	        return _chart;
	    };
	
	    /**
	     * Turn on or off the elastic bubble radius feature, or return the value of the flag. If this
	     * feature is turned on, then bubble radii will be automatically rescaled to fit the chart better.
	     * @method elasticRadius
	     * @memberof dc.bubbleChart
	     * @instance
	     * @param {Boolean} [elasticRadius=false]
	     * @returns {Boolean|dc.bubbleChart}
	     */
	    _chart.elasticRadius = function (elasticRadius) {
	        if (!arguments.length) {
	            return _elasticRadius;
	        }
	        _elasticRadius = elasticRadius;
	        return _chart;
	    };
	
	    _chart.calculateRadiusDomain = function () {
	        if (_elasticRadius) {
	            _chart.r().domain([_chart.rMin(), _chart.rMax()]);
	        }
	    };
	
	    /**
	     * Get or set the radius value accessor function. If set, the radius value accessor function will
	     * be used to retrieve a data value for each bubble. The data retrieved then will be mapped using
	     * the r scale to the actual bubble radius. This allows you to encode a data dimension using bubble
	     * size.
	     * @method radiusValueAccessor
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Function} [radiusValueAccessor]
	     * @returns {Function|dc.bubbleMixin}
	     */
	    _chart.radiusValueAccessor = function (radiusValueAccessor) {
	        if (!arguments.length) {
	            return _rValueAccessor;
	        }
	        _rValueAccessor = radiusValueAccessor;
	        return _chart;
	    };
	
	    _chart.rMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return _chart.radiusValueAccessor()(e);
	        });
	        return min;
	    };
	
	    _chart.rMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return _chart.radiusValueAccessor()(e);
	        });
	        return max;
	    };
	
	    _chart.bubbleR = function (d) {
	        var value = _chart.radiusValueAccessor()(d);
	        var r = _chart.r()(value);
	        if (isNaN(r) || value <= 0) {
	            r = 0;
	        }
	        return r;
	    };
	
	    var labelFunction = function (d) {
	        return _chart.label()(d);
	    };
	
	    var shouldLabel = function (d) {
	        return (_chart.bubbleR(d) > _minRadiusWithLabel);
	    };
	
	    var labelOpacity = function (d) {
	        return shouldLabel(d) ? 1 : 0;
	    };
	
	    var labelPointerEvent = function (d) {
	        return shouldLabel(d) ? 'all' : 'none';
	    };
	
	    _chart._doRenderLabel = function (bubbleGEnter) {
	        if (_chart.renderLabel()) {
	            var label = bubbleGEnter.select('text');
	
	            if (label.empty()) {
	                label = bubbleGEnter.append('text')
	                    .attr('text-anchor', 'middle')
	                    .attr('dy', '.3em')
	                    .on('click', _chart.onClick);
	            }
	
	            label
	                .attr('opacity', 0)
	                .attr('pointer-events', labelPointerEvent)
	                .text(labelFunction);
	            dc.transition(label, _chart.transitionDuration(), _chart.transitionDelay())
	                .attr('opacity', labelOpacity);
	        }
	    };
	
	    _chart.doUpdateLabels = function (bubbleGEnter) {
	        if (_chart.renderLabel()) {
	            var labels = bubbleGEnter.select('text')
	                .attr('pointer-events', labelPointerEvent)
	                .text(labelFunction);
	            dc.transition(labels, _chart.transitionDuration(), _chart.transitionDelay())
	                .attr('opacity', labelOpacity);
	        }
	    };
	
	    var titleFunction = function (d) {
	        return _chart.title()(d);
	    };
	
	    _chart._doRenderTitles = function (g) {
	        if (_chart.renderTitle()) {
	            var title = g.select('title');
	
	            if (title.empty()) {
	                g.append('title').text(titleFunction);
	            }
	        }
	    };
	
	    _chart.doUpdateTitles = function (g) {
	        if (_chart.renderTitle()) {
	            g.select('title').text(titleFunction);
	        }
	    };
	
	    /**
	     * Turn on or off the bubble sorting feature, or return the value of the flag. If enabled,
	     * bubbles will be sorted by their radius, with smaller bubbles in front.
	     * @method sortBubbleSize
	     * @memberof dc.bubbleChart
	     * @instance
	     * @param {Boolean} [sortBubbleSize=false]
	     * @returns {Boolean|dc.bubbleChart}
	     */
	    _chart.sortBubbleSize = function (sortBubbleSize) {
	        if (!arguments.length) {
	            return _sortBubbleSize;
	        }
	        _sortBubbleSize = sortBubbleSize;
	        return _chart;
	    };
	
	    /**
	     * Get or set the minimum radius. This will be used to initialize the radius scale's range.
	     * @method minRadius
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Number} [radius=10]
	     * @returns {Number|dc.bubbleMixin}
	     */
	    _chart.minRadius = function (radius) {
	        if (!arguments.length) {
	            return _chart.MIN_RADIUS;
	        }
	        _chart.MIN_RADIUS = radius;
	        return _chart;
	    };
	
	    /**
	     * Get or set the minimum radius for label rendering. If a bubble's radius is less than this value
	     * then no label will be rendered.
	     * @method minRadiusWithLabel
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Number} [radius=10]
	     * @returns {Number|dc.bubbleMixin}
	     */
	
	    _chart.minRadiusWithLabel = function (radius) {
	        if (!arguments.length) {
	            return _minRadiusWithLabel;
	        }
	        _minRadiusWithLabel = radius;
	        return _chart;
	    };
	
	    /**
	     * Get or set the maximum relative size of a bubble to the length of x axis. This value is useful
	     * when the difference in radius between bubbles is too great.
	     * @method maxBubbleRelativeSize
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Number} [relativeSize=0.3]
	     * @returns {Number|dc.bubbleMixin}
	     */
	    _chart.maxBubbleRelativeSize = function (relativeSize) {
	        if (!arguments.length) {
	            return _maxBubbleRelativeSize;
	        }
	        _maxBubbleRelativeSize = relativeSize;
	        return _chart;
	    };
	
	    _chart.fadeDeselectedArea = function () {
	        if (_chart.hasFilter()) {
	            _chart.selectAll('g.' + _chart.BUBBLE_NODE_CLASS).each(function (d) {
	                if (_chart.isSelectedNode(d)) {
	                    _chart.highlightSelected(this);
	                } else {
	                    _chart.fadeDeselected(this);
	                }
	            });
	        } else {
	            _chart.selectAll('g.' + _chart.BUBBLE_NODE_CLASS).each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	    };
	
	    _chart.isSelectedNode = function (d) {
	        return _chart.hasFilter(d.key);
	    };
	
	    _chart.onClick = function (d) {
	        var filter = d.key;
	        dc.events.trigger(function () {
	            _chart.filter(filter);
	            _chart.redrawGroup();
	        });
	    };
	
	    return _chart;
	};
	
	/**
	 * The pie chart implementation is usually used to visualize a small categorical distribution.  The pie
	 * chart uses keyAccessor to determine the slices, and valueAccessor to calculate the size of each
	 * slice relative to the sum of all values. Slices are ordered by {@link dc.baseMixin#ordering ordering}
	 * which defaults to sorting by key.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * @class pieChart
	 * @memberof dc
	 * @mixes dc.capMixin
	 * @mixes dc.colorMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a pie chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.pieChart('#chart-container1');
	 * // create a pie chart under #chart-container2 element using chart group A
	 * var chart2 = dc.pieChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.pieChart}
	 */
	dc.pieChart = function (parent, chartGroup) {
	    var DEFAULT_MIN_ANGLE_FOR_LABEL = 0.5;
	
	    var _sliceCssClass = 'pie-slice';
	    var _labelCssClass = 'pie-label';
	    var _sliceGroupCssClass = 'pie-slice-group';
	    var _labelGroupCssClass = 'pie-label-group';
	    var _emptyCssClass = 'empty-chart';
	    var _emptyTitle = 'empty';
	
	    var _radius,
	        _givenRadius, // specified radius, if any
	        _innerRadius = 0,
	        _externalRadiusPadding = 0;
	
	    var _g;
	    var _cx;
	    var _cy;
	    var _minAngleForLabel = DEFAULT_MIN_ANGLE_FOR_LABEL;
	    var _externalLabelRadius;
	    var _drawPaths = false;
	    var _chart = dc.capMixin(dc.colorMixin(dc.baseMixin({})));
	
	    _chart.colorAccessor(_chart.cappedKeyAccessor);
	
	    _chart.title(function (d) {
	        return _chart.cappedKeyAccessor(d) + ': ' + _chart.cappedValueAccessor(d);
	    });
	
	    /**
	     * Get or set the maximum number of slices the pie chart will generate. The top slices are determined by
	     * value from high to low. Other slices exeeding the cap will be rolled up into one single *Others* slice.
	     * @method slicesCap
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [cap]
	     * @returns {Number|dc.pieChart}
	     */
	    _chart.slicesCap = _chart.cap;
	
	    _chart.label(_chart.cappedKeyAccessor);
	    _chart.renderLabel(true);
	
	    _chart.transitionDuration(350);
	    _chart.transitionDelay(0);
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _g = _chart.svg()
	            .append('g')
	            .attr('transform', 'translate(' + _chart.cx() + ',' + _chart.cy() + ')');
	
	        _g.append('g').attr('class', _sliceGroupCssClass);
	        _g.append('g').attr('class', _labelGroupCssClass);
	
	        drawChart();
	
	        return _chart;
	    };
	
	    function drawChart () {
	        // set radius on basis of chart dimension if missing
	        _radius = _givenRadius ? _givenRadius : d3.min([_chart.width(), _chart.height()]) / 2;
	
	        var arc = buildArcs();
	
	        var pie = pieLayout();
	        var pieData;
	        // if we have data...
	        if (d3.sum(_chart.data(), _chart.valueAccessor())) {
	            pieData = pie(_chart.data());
	            _g.classed(_emptyCssClass, false);
	        } else {
	            // otherwise we'd be getting NaNs, so override
	            // note: abuse others for its ignoring the value accessor
	            pieData = pie([{key: _emptyTitle, value: 1, others: [_emptyTitle]}]);
	            _g.classed(_emptyCssClass, true);
	        }
	
	        if (_g) {
	            var slices = _g.select('g.' + _sliceGroupCssClass)
	                .selectAll('g.' + _sliceCssClass)
	                .data(pieData);
	
	            var labels = _g.select('g.' + _labelGroupCssClass)
	                .selectAll('text.' + _labelCssClass)
	                .data(pieData);
	
	            createElements(slices, labels, arc, pieData);
	
	            updateElements(pieData, arc);
	
	            removeElements(slices, labels);
	
	            highlightFilter();
	
	            dc.transition(_g, _chart.transitionDuration(), _chart.transitionDelay())
	                .attr('transform', 'translate(' + _chart.cx() + ',' + _chart.cy() + ')');
	        }
	    }
	
	    function createElements (slices, labels, arc, pieData) {
	        var slicesEnter = createSliceNodes(slices);
	
	        createSlicePath(slicesEnter, arc);
	
	        createTitles(slicesEnter);
	
	        createLabels(labels, pieData, arc);
	    }
	
	    function createSliceNodes (slices) {
	        var slicesEnter = slices
	            .enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return _sliceCssClass + ' _' + i;
	            });
	        return slicesEnter;
	    }
	
	    function createSlicePath (slicesEnter, arc) {
	        var slicePath = slicesEnter.append('path')
	            .attr('fill', fill)
	            .on('click', onClick)
	            .attr('d', function (d, i) {
	                return safeArc(d, i, arc);
	            });
	
	        var transition = dc.transition(slicePath, _chart.transitionDuration(), _chart.transitionDelay());
	        if (transition.attrTween) {
	            transition.attrTween('d', tweenPie);
	        }
	    }
	
	    function createTitles (slicesEnter) {
	        if (_chart.renderTitle()) {
	            slicesEnter.append('title').text(function (d) {
	                return _chart.title()(d.data);
	            });
	        }
	    }
	
	    _chart._applyLabelText = function (labels) {
	        labels
	            .text(function (d) {
	                var data = d.data;
	                if ((sliceHasNoData(data) || sliceTooSmall(d)) && !isSelectedSlice(d)) {
	                    return '';
	                }
	                return _chart.label()(d.data);
	            });
	    };
	
	    function positionLabels (labels, arc) {
	        _chart._applyLabelText(labels);
	        dc.transition(labels, _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('transform', function (d) {
	                return labelPosition(d, arc);
	            })
	            .attr('text-anchor', 'middle');
	    }
	
	    function highlightSlice (i, whether) {
	        _chart.select('g.pie-slice._' + i)
	            .classed('highlight', whether);
	    }
	
	    function createLabels (labels, pieData, arc) {
	        if (_chart.renderLabel()) {
	            var labelsEnter = labels
	                .enter()
	                .append('text')
	                .attr('class', function (d, i) {
	                    var classes = _sliceCssClass + ' ' + _labelCssClass + ' _' + i;
	                    if (_externalLabelRadius) {
	                        classes += ' external';
	                    }
	                    return classes;
	                })
	                .on('click', onClick)
	                .on('mouseover', function (d, i) {
	                    highlightSlice(i, true);
	                })
	                .on('mouseout', function (d, i) {
	                    highlightSlice(i, false);
	                });
	            positionLabels(labelsEnter, arc);
	            if (_externalLabelRadius && _drawPaths) {
	                updateLabelPaths(pieData, arc);
	            }
	        }
	    }
	
	    function updateLabelPaths (pieData, arc) {
	        var polyline = _g.selectAll('polyline.' + _sliceCssClass)
	                .data(pieData);
	
	        polyline
	                .enter()
	                .append('polyline')
	                .attr('class', function (d, i) {
	                    return 'pie-path _' + i + ' ' + _sliceCssClass;
	                })
	                .on('click', onClick)
	                .on('mouseover', function (d, i) {
	                    highlightSlice(i, true);
	                })
	                .on('mouseout', function (d, i) {
	                    highlightSlice(i, false);
	                });
	
	        polyline.exit().remove();
	        var arc2 = d3.svg.arc()
	                .outerRadius(_radius - _externalRadiusPadding + _externalLabelRadius)
	                .innerRadius(_radius - _externalRadiusPadding);
	        var transition = dc.transition(polyline, _chart.transitionDuration(), _chart.transitionDelay());
	        // this is one rare case where d3.selection differs from d3.transition
	        if (transition.attrTween) {
	            transition
	                .attrTween('points', function (d) {
	                    var current = this._current || d;
	                    current = {startAngle: current.startAngle, endAngle: current.endAngle};
	                    var interpolate = d3.interpolate(current, d);
	                    this._current = interpolate(0);
	                    return function (t) {
	                        var d2 = interpolate(t);
	                        return [arc.centroid(d2), arc2.centroid(d2)];
	                    };
	                });
	        } else {
	            transition.attr('points', function (d) {
	                return [arc.centroid(d), arc2.centroid(d)];
	            });
	        }
	        transition.style('visibility', function (d) {
	            return d.endAngle - d.startAngle < 0.0001 ? 'hidden' : 'visible';
	        });
	
	    }
	
	    function updateElements (pieData, arc) {
	        updateSlicePaths(pieData, arc);
	        updateLabels(pieData, arc);
	        updateTitles(pieData);
	    }
	
	    function updateSlicePaths (pieData, arc) {
	        var slicePaths = _g.selectAll('g.' + _sliceCssClass)
	            .data(pieData)
	            .select('path')
	            .attr('d', function (d, i) {
	                return safeArc(d, i, arc);
	            });
	        var transition = dc.transition(slicePaths, _chart.transitionDuration(), _chart.transitionDelay());
	        if (transition.attrTween) {
	            transition.attrTween('d', tweenPie);
	        }
	        transition.attr('fill', fill);
	    }
	
	    function updateLabels (pieData, arc) {
	        if (_chart.renderLabel()) {
	            var labels = _g.selectAll('text.' + _labelCssClass)
	                .data(pieData);
	            positionLabels(labels, arc);
	            if (_externalLabelRadius && _drawPaths) {
	                updateLabelPaths(pieData, arc);
	            }
	        }
	    }
	
	    function updateTitles (pieData) {
	        if (_chart.renderTitle()) {
	            _g.selectAll('g.' + _sliceCssClass)
	                .data(pieData)
	                .select('title')
	                .text(function (d) {
	                    return _chart.title()(d.data);
	                });
	        }
	    }
	
	    function removeElements (slices, labels) {
	        slices.exit().remove();
	        labels.exit().remove();
	    }
	
	    function highlightFilter () {
	        if (_chart.hasFilter()) {
	            _chart.selectAll('g.' + _sliceCssClass).each(function (d) {
	                if (isSelectedSlice(d)) {
	                    _chart.highlightSelected(this);
	                } else {
	                    _chart.fadeDeselected(this);
	                }
	            });
	        } else {
	            _chart.selectAll('g.' + _sliceCssClass).each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	    }
	
	    /**
	     * Get or set the external radius padding of the pie chart. This will force the radius of the
	     * pie chart to become smaller or larger depending on the value.
	     * @method externalRadiusPadding
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [externalRadiusPadding=0]
	     * @returns {Number|dc.pieChart}
	     */
	    _chart.externalRadiusPadding = function (externalRadiusPadding) {
	        if (!arguments.length) {
	            return _externalRadiusPadding;
	        }
	        _externalRadiusPadding = externalRadiusPadding;
	        return _chart;
	    };
	
	    /**
	     * Get or set the inner radius of the pie chart. If the inner radius is greater than 0px then the
	     * pie chart will be rendered as a doughnut chart.
	     * @method innerRadius
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [innerRadius=0]
	     * @returns {Number|dc.pieChart}
	     */
	    _chart.innerRadius = function (innerRadius) {
	        if (!arguments.length) {
	            return _innerRadius;
	        }
	        _innerRadius = innerRadius;
	        return _chart;
	    };
	
	    /**
	     * Get or set the outer radius. If the radius is not set, it will be half of the minimum of the
	     * chart width and height.
	     * @method radius
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [radius]
	     * @returns {Number|dc.pieChart}
	     */
	    _chart.radius = function (radius) {
	        if (!arguments.length) {
	            return _givenRadius;
	        }
	        _givenRadius = radius;
	        return _chart;
	    };
	
	    /**
	     * Get or set center x coordinate position. Default is center of svg.
	     * @method cx
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [cx]
	     * @returns {Number|dc.pieChart}
	     */
	    _chart.cx = function (cx) {
	        if (!arguments.length) {
	            return (_cx ||  _chart.width() / 2);
	        }
	        _cx = cx;
	        return _chart;
	    };
	
	    /**
	     * Get or set center y coordinate position. Default is center of svg.
	     * @method cy
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [cy]
	     * @returns {Number|dc.pieChart}
	     */
	    _chart.cy = function (cy) {
	        if (!arguments.length) {
	            return (_cy ||  _chart.height() / 2);
	        }
	        _cy = cy;
	        return _chart;
	    };
	
	    function buildArcs () {
	        return d3.svg.arc()
	            .outerRadius(_radius - _externalRadiusPadding)
	            .innerRadius(_innerRadius);
	    }
	
	    function isSelectedSlice (d) {
	        return _chart.hasFilter(_chart.cappedKeyAccessor(d.data));
	    }
	
	    _chart._doRedraw = function () {
	        drawChart();
	        return _chart;
	    };
	
	    /**
	     * Get or set the minimal slice angle for label rendering. Any slice with a smaller angle will not
	     * display a slice label.
	     * @method minAngleForLabel
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [minAngleForLabel=0.5]
	     * @returns {Number|dc.pieChart}
	     */
	    _chart.minAngleForLabel = function (minAngleForLabel) {
	        if (!arguments.length) {
	            return _minAngleForLabel;
	        }
	        _minAngleForLabel = minAngleForLabel;
	        return _chart;
	    };
	
	    function pieLayout () {
	        return d3.layout.pie().sort(null).value(_chart.cappedValueAccessor);
	    }
	
	    function sliceTooSmall (d) {
	        var angle = (d.endAngle - d.startAngle);
	        return isNaN(angle) || angle < _minAngleForLabel;
	    }
	
	    function sliceHasNoData (d) {
	        return _chart.cappedValueAccessor(d) === 0;
	    }
	
	    function tweenPie (b) {
	        b.innerRadius = _innerRadius;
	        var current = this._current;
	        if (isOffCanvas(current)) {
	            current = {startAngle: 0, endAngle: 0};
	        } else {
	            // only interpolate startAngle & endAngle, not the whole data object
	            current = {startAngle: current.startAngle, endAngle: current.endAngle};
	        }
	        var i = d3.interpolate(current, b);
	        this._current = i(0);
	        return function (t) {
	            return safeArc(i(t), 0, buildArcs());
	        };
	    }
	
	    function isOffCanvas (current) {
	        return !current || isNaN(current.startAngle) || isNaN(current.endAngle);
	    }
	
	    function fill (d, i) {
	        return _chart.getColor(d.data, i);
	    }
	
	    function onClick (d, i) {
	        if (_g.attr('class') !== _emptyCssClass) {
	            _chart.onClick(d.data, i);
	        }
	    }
	
	    function safeArc (d, i, arc) {
	        var path = arc(d, i);
	        if (path.indexOf('NaN') >= 0) {
	            path = 'M0,0';
	        }
	        return path;
	    }
	
	    /**
	     * Title to use for the only slice when there is no data.
	     * @method emptyTitle
	     * @memberof dc.pieChart
	     * @instance
	     * @param {String} [title]
	     * @returns {String|dc.pieChart}
	     */
	    _chart.emptyTitle = function (title) {
	        if (arguments.length === 0) {
	            return _emptyTitle;
	        }
	        _emptyTitle = title;
	        return _chart;
	    };
	
	    /**
	     * Position slice labels offset from the outer edge of the chart.
	     *
	     * The argument specifies the extra radius to be added for slice labels.
	     * @method externalLabels
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [externalLabelRadius]
	     * @returns {Number|dc.pieChart}
	     */
	    _chart.externalLabels = function (externalLabelRadius) {
	        if (arguments.length === 0) {
	            return _externalLabelRadius;
	        } else if (externalLabelRadius) {
	            _externalLabelRadius = externalLabelRadius;
	        } else {
	            _externalLabelRadius = undefined;
	        }
	
	        return _chart;
	    };
	
	    /**
	     * Get or set whether to draw lines from pie slices to their labels.
	     *
	     * @method drawPaths
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Boolean} [drawPaths]
	     * @returns {Boolean|dc.pieChart}
	     */
	    _chart.drawPaths = function (drawPaths) {
	        if (arguments.length === 0) {
	            return _drawPaths;
	        }
	        _drawPaths = drawPaths;
	        return _chart;
	    };
	
	    function labelPosition (d, arc) {
	        var centroid;
	        if (_externalLabelRadius) {
	            centroid = d3.svg.arc()
	                .outerRadius(_radius - _externalRadiusPadding + _externalLabelRadius)
	                .innerRadius(_radius - _externalRadiusPadding + _externalLabelRadius)
	                .centroid(d);
	        } else {
	            centroid = arc.centroid(d);
	        }
	        if (isNaN(centroid[0]) || isNaN(centroid[1])) {
	            return 'translate(0,0)';
	        } else {
	            return 'translate(' + centroid + ')';
	        }
	    }
	
	    _chart.legendables = function () {
	        return _chart.data().map(function (d, i) {
	            var legendable = {name: d.key, data: d.value, others: d.others, chart: _chart};
	            legendable.color = _chart.getColor(d, i);
	            return legendable;
	        });
	    };
	
	    _chart.legendHighlight = function (d) {
	        highlightSliceFromLegendable(d, true);
	    };
	
	    _chart.legendReset = function (d) {
	        highlightSliceFromLegendable(d, false);
	    };
	
	    _chart.legendToggle = function (d) {
	        _chart.onClick({key: d.name, others: d.others});
	    };
	
	    function highlightSliceFromLegendable (legendable, highlighted) {
	        _chart.selectAll('g.pie-slice').each(function (d) {
	            if (legendable.name === d.data.key) {
	                d3.select(this).classed('highlight', highlighted);
	            }
	        });
	    }
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Concrete bar chart/histogram implementation.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * - {@link http://dc-js.github.com/dc.js/crime/index.html Canadian City Crime Stats}
	 * @class barChart
	 * @memberof dc
	 * @mixes dc.stackMixin
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a bar chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.barChart('#chart-container1');
	 * // create a bar chart under #chart-container2 element using chart group A
	 * var chart2 = dc.barChart('#chart-container2', 'chartGroupA');
	 * // create a sub-chart under a composite parent chart
	 * var chart3 = dc.barChart(compositeChart);
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector}
	 * specifying a dom block element such as a div; or a dom element or d3 selection.  If the bar
	 * chart is a sub-chart in a {@link dc.compositeChart Composite Chart} then pass in the parent
	 * composite chart instance instead.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.barChart}
	 */
	dc.barChart = function (parent, chartGroup) {
	    var MIN_BAR_WIDTH = 1;
	    var DEFAULT_GAP_BETWEEN_BARS = 2;
	    var LABEL_PADDING = 3;
	
	    var _chart = dc.stackMixin(dc.coordinateGridMixin({}));
	
	    var _gap = DEFAULT_GAP_BETWEEN_BARS;
	    var _centerBar = false;
	    var _alwaysUseRounding = false;
	
	    var _barWidth;
	
	    dc.override(_chart, 'rescale', function () {
	        _chart._rescale();
	        _barWidth = undefined;
	        return _chart;
	    });
	
	    dc.override(_chart, 'render', function () {
	        if (_chart.round() && _centerBar && !_alwaysUseRounding) {
	            dc.logger.warn('By default, brush rounding is disabled if bars are centered. ' +
	                         'See dc.js bar chart API documentation for details.');
	        }
	
	        return _chart._render();
	    });
	
	    _chart.label(function (d) {
	        return dc.utils.printSingleValue(d.y0 + d.y);
	    }, false);
	
	    _chart.plotData = function () {
	        var layers = _chart.chartBodyG().selectAll('g.stack')
	            .data(_chart.data());
	
	        calculateBarWidth();
	
	        layers
	            .enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return 'stack ' + '_' + i;
	            });
	
	        var last = layers.size() - 1;
	        layers.each(function (d, i) {
	            var layer = d3.select(this);
	
	            renderBars(layer, i, d);
	
	            if (_chart.renderLabel() && last === i) {
	                renderLabels(layer, i, d);
	            }
	        });
	    };
	
	    function barHeight (d) {
	        return dc.utils.safeNumber(Math.abs(_chart.y()(d.y + d.y0) - _chart.y()(d.y0)));
	    }
	
	    function renderLabels (layer, layerIndex, d) {
	        var labels = layer.selectAll('text.barLabel')
	            .data(d.values, dc.pluck('x'));
	
	        labels.enter()
	            .append('text')
	            .attr('class', 'barLabel')
	            .attr('text-anchor', 'middle');
	
	        if (_chart.isOrdinal()) {
	            labels.on('click', _chart.onClick);
	            labels.attr('cursor', 'pointer');
	        }
	
	        dc.transition(labels, _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('x', function (d) {
	                var x = _chart.x()(d.x);
	                if (!_centerBar) {
	                    x += _barWidth / 2;
	                }
	                return dc.utils.safeNumber(x);
	            })
	            .attr('y', function (d) {
	                var y = _chart.y()(d.y + d.y0);
	
	                if (d.y < 0) {
	                    y -= barHeight(d);
	                }
	
	                return dc.utils.safeNumber(y - LABEL_PADDING);
	            })
	            .text(function (d) {
	                return _chart.label()(d);
	            });
	
	        dc.transition(labels.exit(), _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('height', 0)
	            .remove();
	    }
	
	    function renderBars (layer, layerIndex, d) {
	        var bars = layer.selectAll('rect.bar')
	            .data(d.values, dc.pluck('x'));
	
	        var enter = bars.enter()
	            .append('rect')
	            .attr('class', 'bar')
	            .attr('fill', dc.pluck('data', _chart.getColor))
	            .attr('y', _chart.yAxisHeight())
	            .attr('height', 0);
	
	        if (_chart.renderTitle()) {
	            enter.append('title').text(dc.pluck('data', _chart.title(d.name)));
	        }
	
	        if (_chart.isOrdinal()) {
	            bars.on('click', _chart.onClick);
	        }
	
	        dc.transition(bars, _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('x', function (d) {
	                var x = _chart.x()(d.x);
	                if (_centerBar) {
	                    x -= _barWidth / 2;
	                }
	                if (_chart.isOrdinal() && _gap !== undefined) {
	                    x += _gap / 2;
	                }
	                return dc.utils.safeNumber(x);
	            })
	            .attr('y', function (d) {
	                var y = _chart.y()(d.y + d.y0);
	
	                if (d.y < 0) {
	                    y -= barHeight(d);
	                }
	
	                return dc.utils.safeNumber(y);
	            })
	            .attr('width', _barWidth)
	            .attr('height', function (d) {
	                return barHeight(d);
	            })
	            .attr('fill', dc.pluck('data', _chart.getColor))
	            .select('title').text(dc.pluck('data', _chart.title(d.name)));
	
	        dc.transition(bars.exit(), _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('x', function (d) { return _chart.x()(d.x); })
	            .attr('width', _barWidth * 0.9)
	            .remove();
	    }
	
	    function calculateBarWidth () {
	        if (_barWidth === undefined) {
	            var numberOfBars = _chart.xUnitCount();
	
	            // please can't we always use rangeBands for bar charts?
	            if (_chart.isOrdinal() && _gap === undefined) {
	                _barWidth = Math.floor(_chart.x().rangeBand());
	            } else if (_gap) {
	                _barWidth = Math.floor((_chart.xAxisLength() - (numberOfBars - 1) * _gap) / numberOfBars);
	            } else {
	                _barWidth = Math.floor(_chart.xAxisLength() / (1 + _chart.barPadding()) / numberOfBars);
	            }
	
	            if (_barWidth === Infinity || isNaN(_barWidth) || _barWidth < MIN_BAR_WIDTH) {
	                _barWidth = MIN_BAR_WIDTH;
	            }
	        }
	    }
	
	    _chart.fadeDeselectedArea = function () {
	        var bars = _chart.chartBodyG().selectAll('rect.bar');
	        var extent = _chart.brush().extent();
	
	        if (_chart.isOrdinal()) {
	            if (_chart.hasFilter()) {
	                bars.classed(dc.constants.SELECTED_CLASS, function (d) {
	                    return _chart.hasFilter(d.x);
	                });
	                bars.classed(dc.constants.DESELECTED_CLASS, function (d) {
	                    return !_chart.hasFilter(d.x);
	                });
	            } else {
	                bars.classed(dc.constants.SELECTED_CLASS, false);
	                bars.classed(dc.constants.DESELECTED_CLASS, false);
	            }
	        } else {
	            if (!_chart.brushIsEmpty(extent)) {
	                var start = extent[0];
	                var end = extent[1];
	
	                bars.classed(dc.constants.DESELECTED_CLASS, function (d) {
	                    return d.x < start || d.x >= end;
	                });
	            } else {
	                bars.classed(dc.constants.DESELECTED_CLASS, false);
	            }
	        }
	    };
	
	    /**
	     * Whether the bar chart will render each bar centered around the data position on the x-axis.
	     * @method centerBar
	     * @memberof dc.barChart
	     * @instance
	     * @param {Boolean} [centerBar=false]
	     * @returns {Boolean|dc.barChart}
	     */
	    _chart.centerBar = function (centerBar) {
	        if (!arguments.length) {
	            return _centerBar;
	        }
	        _centerBar = centerBar;
	        return _chart;
	    };
	
	    dc.override(_chart, 'onClick', function (d) {
	        _chart._onClick(d.data);
	    });
	
	    /**
	     * Get or set the spacing between bars as a fraction of bar size. Valid values are between 0-1.
	     * Setting this value will also remove any previously set {@link dc.barChart#gap gap}. See the
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Ordinal-Scales.md#ordinal_rangeBands d3 docs}
	     * for a visual description of how the padding is applied.
	     * @method barPadding
	     * @memberof dc.barChart
	     * @instance
	     * @param {Number} [barPadding=0]
	     * @returns {Number|dc.barChart}
	     */
	    _chart.barPadding = function (barPadding) {
	        if (!arguments.length) {
	            return _chart._rangeBandPadding();
	        }
	        _chart._rangeBandPadding(barPadding);
	        _gap = undefined;
	        return _chart;
	    };
	
	    _chart._useOuterPadding = function () {
	        return _gap === undefined;
	    };
	
	    /**
	     * Get or set the outer padding on an ordinal bar chart. This setting has no effect on non-ordinal charts.
	     * Will pad the width by `padding * barWidth` on each side of the chart.
	     * @method outerPadding
	     * @memberof dc.barChart
	     * @instance
	     * @param {Number} [padding=0.5]
	     * @returns {Number|dc.barChart}
	     */
	    _chart.outerPadding = _chart._outerRangeBandPadding;
	
	    /**
	     * Manually set fixed gap (in px) between bars instead of relying on the default auto-generated
	     * gap.  By default the bar chart implementation will calculate and set the gap automatically
	     * based on the number of data points and the length of the x axis.
	     * @method gap
	     * @memberof dc.barChart
	     * @instance
	     * @param {Number} [gap=2]
	     * @returns {Number|dc.barChart}
	     */
	    _chart.gap = function (gap) {
	        if (!arguments.length) {
	            return _gap;
	        }
	        _gap = gap;
	        return _chart;
	    };
	
	    _chart.extendBrush = function () {
	        var extent = _chart.brush().extent();
	        if (_chart.round() && (!_centerBar || _alwaysUseRounding)) {
	            extent[0] = extent.map(_chart.round())[0];
	            extent[1] = extent.map(_chart.round())[1];
	
	            _chart.chartBodyG().select('.brush')
	                .call(_chart.brush().extent(extent));
	        }
	
	        return extent;
	    };
	
	    /**
	     * Set or get whether rounding is enabled when bars are centered. If false, using
	     * rounding with centered bars will result in a warning and rounding will be ignored.  This flag
	     * has no effect if bars are not {@link dc.barChart#centerBar centered}.
	     * When using standard d3.js rounding methods, the brush often doesn't align correctly with
	     * centered bars since the bars are offset.  The rounding function must add an offset to
	     * compensate, such as in the following example.
	     * @method alwaysUseRounding
	     * @memberof dc.barChart
	     * @instance
	     * @example
	     * chart.round(function(n) { return Math.floor(n) + 0.5; });
	     * @param {Boolean} [alwaysUseRounding=false]
	     * @returns {Boolean|dc.barChart}
	     */
	    _chart.alwaysUseRounding = function (alwaysUseRounding) {
	        if (!arguments.length) {
	            return _alwaysUseRounding;
	        }
	        _alwaysUseRounding = alwaysUseRounding;
	        return _chart;
	    };
	
	    function colorFilter (color, inv) {
	        return function () {
	            var item = d3.select(this);
	            var match = item.attr('fill') === color;
	            return inv ? !match : match;
	        };
	    }
	
	    _chart.legendHighlight = function (d) {
	        if (!_chart.isLegendableHidden(d)) {
	            _chart.g().selectAll('rect.bar')
	                .classed('highlight', colorFilter(d.color))
	                .classed('fadeout', colorFilter(d.color, true));
	        }
	    };
	
	    _chart.legendReset = function () {
	        _chart.g().selectAll('rect.bar')
	            .classed('highlight', false)
	            .classed('fadeout', false);
	    };
	
	    dc.override(_chart, 'xAxisMax', function () {
	        var max = this._xAxisMax();
	        if ('resolution' in _chart.xUnits()) {
	            var res = _chart.xUnits().resolution;
	            max += res;
	        }
	        return max;
	    });
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Concrete line/area chart implementation.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * - {@link http://dc-js.github.com/dc.js/crime/index.html Canadian City Crime Stats}
	 * @class lineChart
	 * @memberof dc
	 * @mixes dc.stackMixin
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a line chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.lineChart('#chart-container1');
	 * // create a line chart under #chart-container2 element using chart group A
	 * var chart2 = dc.lineChart('#chart-container2', 'chartGroupA');
	 * // create a sub-chart under a composite parent chart
	 * var chart3 = dc.lineChart(compositeChart);
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector}
	 * specifying a dom block element such as a div; or a dom element or d3 selection.  If the line
	 * chart is a sub-chart in a {@link dc.compositeChart Composite Chart} then pass in the parent
	 * composite chart instance instead.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.lineChart}
	 */
	dc.lineChart = function (parent, chartGroup) {
	    var DEFAULT_DOT_RADIUS = 5;
	    var TOOLTIP_G_CLASS = 'dc-tooltip';
	    var DOT_CIRCLE_CLASS = 'dot';
	    var Y_AXIS_REF_LINE_CLASS = 'yRef';
	    var X_AXIS_REF_LINE_CLASS = 'xRef';
	    var DEFAULT_DOT_OPACITY = 1e-6;
	    var LABEL_PADDING = 3;
	
	    var _chart = dc.stackMixin(dc.coordinateGridMixin({}));
	    var _renderArea = false;
	    var _dotRadius = DEFAULT_DOT_RADIUS;
	    var _dataPointRadius = null;
	    var _dataPointFillOpacity = DEFAULT_DOT_OPACITY;
	    var _dataPointStrokeOpacity = DEFAULT_DOT_OPACITY;
	    var _interpolate = 'linear';
	    var _tension = 0.7;
	    var _defined;
	    var _dashStyle;
	    var _xyTipsOn = true;
	
	    _chart.transitionDuration(500);
	    _chart.transitionDelay(0);
	    _chart._rangeBandPadding(1);
	
	    _chart.plotData = function () {
	        var chartBody = _chart.chartBodyG();
	        var layersList = chartBody.select('g.stack-list');
	
	        if (layersList.empty()) {
	            layersList = chartBody.append('g').attr('class', 'stack-list');
	        }
	
	        var layers = layersList.selectAll('g.stack').data(_chart.data());
	
	        var layersEnter = layers
	            .enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return 'stack ' + '_' + i;
	            });
	
	        drawLine(layersEnter, layers);
	
	        drawArea(layersEnter, layers);
	
	        drawDots(chartBody, layers);
	
	        if (_chart.renderLabel()) {
	            drawLabels(layers);
	        }
	    };
	
	    /**
	     * Gets or sets the interpolator to use for lines drawn, by string name, allowing e.g. step
	     * functions, splines, and cubic interpolation.  This is passed to
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#line_interpolate d3.svg.line.interpolate} and
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#area_interpolate d3.svg.area.interpolate},
	     * where you can find a complete list of valid arguments.
	     * @method interpolate
	     * @memberof dc.lineChart
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#line_interpolate d3.svg.line.interpolate}
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#area_interpolate d3.svg.area.interpolate}
	     * @param  {String} [interpolate='linear']
	     * @returns {String|dc.lineChart}
	     */
	    _chart.interpolate = function (interpolate) {
	        if (!arguments.length) {
	            return _interpolate;
	        }
	        _interpolate = interpolate;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the tension to use for lines drawn, in the range 0 to 1.
	     * This parameter further customizes the interpolation behavior.  It is passed to
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#line_tension d3.svg.line.tension} and
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#area_tension d3.svg.area.tension}.
	     * @method tension
	     * @memberof dc.lineChart
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#line_interpolate d3.svg.line.interpolate}
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#area_interpolate d3.svg.area.interpolate}
	     * @param  {Number} [tension=0.7]
	     * @returns {Number|dc.lineChart}
	     */
	    _chart.tension = function (tension) {
	        if (!arguments.length) {
	            return _tension;
	        }
	        _tension = tension;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets a function that will determine discontinuities in the line which should be
	     * skipped: the path will be broken into separate subpaths if some points are undefined.
	     * This function is passed to
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#line_defined d3.svg.line.defined}
	     *
	     * Note: crossfilter will sometimes coerce nulls to 0, so you may need to carefully write
	     * custom reduce functions to get this to work, depending on your data. See
	     * {@link https://github.com/dc-js/dc.js/issues/615#issuecomment-49089248 this GitHub comment}
	     * for more details and an example.
	     * @method defined
	     * @memberof dc.lineChart
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#line_defined d3.svg.line.defined}
	     * @param  {Function} [defined]
	     * @returns {Function|dc.lineChart}
	     */
	    _chart.defined = function (defined) {
	        if (!arguments.length) {
	            return _defined;
	        }
	        _defined = defined;
	        return _chart;
	    };
	
	    /**
	     * Set the line's d3 dashstyle. This value becomes the 'stroke-dasharray' of line. Defaults to empty
	     * array (solid line).
	     * @method dashStyle
	     * @memberof dc.lineChart
	     * @instance
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-dasharray stroke-dasharray}
	     * @example
	     * // create a Dash Dot Dot Dot
	     * chart.dashStyle([3,1,1,1]);
	     * @param  {Array<Number>} [dashStyle=[]]
	     * @returns {Array<Number>|dc.lineChart}
	     */
	    _chart.dashStyle = function (dashStyle) {
	        if (!arguments.length) {
	            return _dashStyle;
	        }
	        _dashStyle = dashStyle;
	        return _chart;
	    };
	
	    /**
	     * Get or set render area flag. If the flag is set to true then the chart will render the area
	     * beneath each line and the line chart effectively becomes an area chart.
	     * @method renderArea
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {Boolean} [renderArea=false]
	     * @returns {Boolean|dc.lineChart}
	     */
	    _chart.renderArea = function (renderArea) {
	        if (!arguments.length) {
	            return _renderArea;
	        }
	        _renderArea = renderArea;
	        return _chart;
	    };
	
	    function colors (d, i) {
	        return _chart.getColor.call(d, d.values, i);
	    }
	
	    function drawLine (layersEnter, layers) {
	        var line = d3.svg.line()
	            .x(function (d) {
	                return _chart.x()(d.x);
	            })
	            .y(function (d) {
	                return _chart.y()(d.y + d.y0);
	            })
	            .interpolate(_interpolate)
	            .tension(_tension);
	        if (_defined) {
	            line.defined(_defined);
	        }
	
	        var path = layersEnter.append('path')
	            .attr('class', 'line')
	            .attr('stroke', colors);
	        if (_dashStyle) {
	            path.attr('stroke-dasharray', _dashStyle);
	        }
	
	        dc.transition(layers.select('path.line'), _chart.transitionDuration(), _chart.transitionDelay())
	            //.ease('linear')
	            .attr('stroke', colors)
	            .attr('d', function (d) {
	                return safeD(line(d.values));
	            });
	    }
	
	    function drawArea (layersEnter, layers) {
	        if (_renderArea) {
	            var area = d3.svg.area()
	                .x(function (d) {
	                    return _chart.x()(d.x);
	                })
	                .y(function (d) {
	                    return _chart.y()(d.y + d.y0);
	                })
	                .y0(function (d) {
	                    return _chart.y()(d.y0);
	                })
	                .interpolate(_interpolate)
	                .tension(_tension);
	            if (_defined) {
	                area.defined(_defined);
	            }
	
	            layersEnter.append('path')
	                .attr('class', 'area')
	                .attr('fill', colors)
	                .attr('d', function (d) {
	                    return safeD(area(d.values));
	                });
	
	            dc.transition(layers.select('path.area'), _chart.transitionDuration(), _chart.transitionDelay())
	                //.ease('linear')
	                .attr('fill', colors)
	                .attr('d', function (d) {
	                    return safeD(area(d.values));
	                });
	        }
	    }
	
	    function safeD (d) {
	        return (!d || d.indexOf('NaN') >= 0) ? 'M0,0' : d;
	    }
	
	    function drawDots (chartBody, layers) {
	        if (_chart.xyTipsOn() === 'always' || (!_chart.brushOn() && _chart.xyTipsOn())) {
	            var tooltipListClass = TOOLTIP_G_CLASS + '-list';
	            var tooltips = chartBody.select('g.' + tooltipListClass);
	
	            if (tooltips.empty()) {
	                tooltips = chartBody.append('g').attr('class', tooltipListClass);
	            }
	
	            layers.each(function (d, layerIndex) {
	                var points = d.values;
	                if (_defined) {
	                    points = points.filter(_defined);
	                }
	
	                var g = tooltips.select('g.' + TOOLTIP_G_CLASS + '._' + layerIndex);
	                if (g.empty()) {
	                    g = tooltips.append('g').attr('class', TOOLTIP_G_CLASS + ' _' + layerIndex);
	                }
	
	                createRefLines(g);
	
	                var dots = g.selectAll('circle.' + DOT_CIRCLE_CLASS)
	                    .data(points, dc.pluck('x'));
	
	                dots.enter()
	                    .append('circle')
	                    .attr('class', DOT_CIRCLE_CLASS)
	                    .attr('r', getDotRadius())
	                    .style('fill-opacity', _dataPointFillOpacity)
	                    .style('stroke-opacity', _dataPointStrokeOpacity)
	                    .attr('fill', _chart.getColor)
	                    .on('mousemove', function () {
	                        var dot = d3.select(this);
	                        showDot(dot);
	                        showRefLines(dot, g);
	                    })
	                    .on('mouseout', function () {
	                        var dot = d3.select(this);
	                        hideDot(dot);
	                        hideRefLines(g);
	                    });
	
	                dots.call(renderTitle, d);
	
	                dc.transition(dots, _chart.transitionDuration())
	                    .attr('cx', function (d) {
	                        return dc.utils.safeNumber(_chart.x()(d.x));
	                    })
	                    .attr('cy', function (d) {
	                        return dc.utils.safeNumber(_chart.y()(d.y + d.y0));
	                    })
	                    .attr('fill', _chart.getColor);
	
	                dots.exit().remove();
	            });
	        }
	    }
	
	    _chart.label(function (d) {
	        return dc.utils.printSingleValue(d.y0 + d.y);
	    }, false);
	
	    function drawLabels (layers) {
	        layers.each(function (d, layerIndex) {
	            var layer = d3.select(this);
	            var labels = layer.selectAll('text.lineLabel')
	                .data(d.values, dc.pluck('x'));
	
	            labels.enter()
	                .append('text')
	                .attr('class', 'lineLabel')
	                .attr('text-anchor', 'middle');
	
	            dc.transition(labels, _chart.transitionDuration())
	                .attr('x', function (d) {
	                    return dc.utils.safeNumber(_chart.x()(d.x));
	                })
	                .attr('y', function (d) {
	                    var y = _chart.y()(d.y + d.y0) - LABEL_PADDING;
	                    return dc.utils.safeNumber(y);
	                })
	                .text(function (d) {
	                    return _chart.label()(d);
	                });
	
	            dc.transition(labels.exit(), _chart.transitionDuration())
	                .attr('height', 0)
	                .remove();
	        });
	    }
	
	    function createRefLines (g) {
	        var yRefLine = g.select('path.' + Y_AXIS_REF_LINE_CLASS).empty() ?
	            g.append('path').attr('class', Y_AXIS_REF_LINE_CLASS) : g.select('path.' + Y_AXIS_REF_LINE_CLASS);
	        yRefLine.style('display', 'none').attr('stroke-dasharray', '5,5');
	
	        var xRefLine = g.select('path.' + X_AXIS_REF_LINE_CLASS).empty() ?
	            g.append('path').attr('class', X_AXIS_REF_LINE_CLASS) : g.select('path.' + X_AXIS_REF_LINE_CLASS);
	        xRefLine.style('display', 'none').attr('stroke-dasharray', '5,5');
	    }
	
	    function showDot (dot) {
	        dot.style('fill-opacity', 0.8);
	        dot.style('stroke-opacity', 0.8);
	        dot.attr('r', _dotRadius);
	        return dot;
	    }
	
	    function showRefLines (dot, g) {
	        var x = dot.attr('cx');
	        var y = dot.attr('cy');
	        var yAxisX = (_chart._yAxisX() - _chart.margins().left);
	        var yAxisRefPathD = 'M' + yAxisX + ' ' + y + 'L' + (x) + ' ' + (y);
	        var xAxisRefPathD = 'M' + x + ' ' + _chart.yAxisHeight() + 'L' + x + ' ' + y;
	        g.select('path.' + Y_AXIS_REF_LINE_CLASS).style('display', '').attr('d', yAxisRefPathD);
	        g.select('path.' + X_AXIS_REF_LINE_CLASS).style('display', '').attr('d', xAxisRefPathD);
	    }
	
	    function getDotRadius () {
	        return _dataPointRadius || _dotRadius;
	    }
	
	    function hideDot (dot) {
	        dot.style('fill-opacity', _dataPointFillOpacity)
	            .style('stroke-opacity', _dataPointStrokeOpacity)
	            .attr('r', getDotRadius());
	    }
	
	    function hideRefLines (g) {
	        g.select('path.' + Y_AXIS_REF_LINE_CLASS).style('display', 'none');
	        g.select('path.' + X_AXIS_REF_LINE_CLASS).style('display', 'none');
	    }
	
	    function renderTitle (dot, d) {
	        if (_chart.renderTitle()) {
	            dot.select('title').remove();
	            dot.append('title').text(dc.pluck('data', _chart.title(d.name)));
	        }
	    }
	
	    /**
	     * Turn on/off the mouseover behavior of an individual data point which renders a circle and x/y axis
	     * dashed lines back to each respective axis.  This is ignored if the chart
	     * {@link dc.coordinateGridMixin#brushOn brush} is on
	     * @method xyTipsOn
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {Boolean} [xyTipsOn=false]
	     * @returns {Boolean|dc.lineChart}
	     */
	    _chart.xyTipsOn = function (xyTipsOn) {
	        if (!arguments.length) {
	            return _xyTipsOn;
	        }
	        _xyTipsOn = xyTipsOn;
	        return _chart;
	    };
	
	    /**
	     * Get or set the radius (in px) for dots displayed on the data points.
	     * @method dotRadius
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {Number} [dotRadius=5]
	     * @returns {Number|dc.lineChart}
	     */
	    _chart.dotRadius = function (dotRadius) {
	        if (!arguments.length) {
	            return _dotRadius;
	        }
	        _dotRadius = dotRadius;
	        return _chart;
	    };
	
	    /**
	     * Always show individual dots for each datapoint.
	     *
	     * If `options` is falsy, it disables data point rendering. If no `options` are provided, the
	     * current `options` values are instead returned.
	     * @method renderDataPoints
	     * @memberof dc.lineChart
	     * @instance
	     * @example
	     * chart.renderDataPoints({radius: 2, fillOpacity: 0.8, strokeOpacity: 0.8})
	     * @param  {{fillOpacity: Number, strokeOpacity: Number, radius: Number}} [options={fillOpacity: 0.8, strokeOpacity: 0.8, radius: 2}]
	     * @returns {{fillOpacity: Number, strokeOpacity: Number, radius: Number}|dc.lineChart}
	     */
	    _chart.renderDataPoints = function (options) {
	        if (!arguments.length) {
	            return {
	                fillOpacity: _dataPointFillOpacity,
	                strokeOpacity: _dataPointStrokeOpacity,
	                radius: _dataPointRadius
	            };
	        } else if (!options) {
	            _dataPointFillOpacity = DEFAULT_DOT_OPACITY;
	            _dataPointStrokeOpacity = DEFAULT_DOT_OPACITY;
	            _dataPointRadius = null;
	        } else {
	            _dataPointFillOpacity = options.fillOpacity || 0.8;
	            _dataPointStrokeOpacity = options.strokeOpacity || 0.8;
	            _dataPointRadius = options.radius || 2;
	        }
	        return _chart;
	    };
	
	    function colorFilter (color, dashstyle, inv) {
	        return function () {
	            var item = d3.select(this);
	            var match = (item.attr('stroke') === color &&
	                item.attr('stroke-dasharray') === ((dashstyle instanceof Array) ?
	                    dashstyle.join(',') : null)) || item.attr('fill') === color;
	            return inv ? !match : match;
	        };
	    }
	
	    _chart.legendHighlight = function (d) {
	        if (!_chart.isLegendableHidden(d)) {
	            _chart.g().selectAll('path.line, path.area')
	                .classed('highlight', colorFilter(d.color, d.dashstyle))
	                .classed('fadeout', colorFilter(d.color, d.dashstyle, true));
	        }
	    };
	
	    _chart.legendReset = function () {
	        _chart.g().selectAll('path.line, path.area')
	            .classed('highlight', false)
	            .classed('fadeout', false);
	    };
	
	    dc.override(_chart, 'legendables', function () {
	        var legendables = _chart._legendables();
	        if (!_dashStyle) {
	            return legendables;
	        }
	        return legendables.map(function (l) {
	            l.dashstyle = _dashStyle;
	            return l;
	        });
	    });
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * The data count widget is a simple widget designed to display the number of records selected by the
	 * current filters out of the total number of records in the data set. Once created the data count widget
	 * will automatically update the text content of child elements with the following classes:
	 *
	 * * `.total-count` - total number of records
	 * * `.filter-count` - number of records matched by the current filters
	 *
	 * Note: this widget works best for the specific case of showing the number of records out of a
	 * total. If you want a more general-purpose numeric display, please use the
	 * {@link dc.numberDisplay} widget instead.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * @class dataCount
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @example
	 * var ndx = crossfilter(data);
	 * var all = ndx.groupAll();
	 *
	 * dc.dataCount('.dc-data-count')
	 *     .dimension(ndx)
	 *     .group(all);
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.dataCount}
	 */
	dc.dataCount = function (parent, chartGroup) {
	    var _formatNumber = d3.format(',d');
	    var _chart = dc.baseMixin({});
	    var _html = {some: '', all: ''};
	
	    /**
	     * Gets or sets an optional object specifying HTML templates to use depending how many items are
	     * selected. The text `%total-count` will replaced with the total number of records, and the text
	     * `%filter-count` will be replaced with the number of selected records.
	     * - all: HTML template to use if all items are selected
	     * - some: HTML template to use if not all items are selected
	     * @method html
	     * @memberof dc.dataCount
	     * @instance
	     * @example
	     * counter.html({
	     *      some: '%filter-count out of %total-count records selected',
	     *      all: 'All records selected. Click on charts to apply filters'
	     * })
	     * @param {{some:String, all: String}} [options]
	     * @returns {{some:String, all: String}|dc.dataCount}
	     */
	    _chart.html = function (options) {
	        if (!arguments.length) {
	            return _html;
	        }
	        if (options.all) {
	            _html.all = options.all;
	        }
	        if (options.some) {
	            _html.some = options.some;
	        }
	        return _chart;
	    };
	
	    /**
	     * Gets or sets an optional function to format the filter count and total count.
	     * @method formatNumber
	     * @memberof dc.dataCount
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Formatting.md d3.format}
	     * @example
	     * counter.formatNumber(d3.format('.2g'))
	     * @param {Function} [formatter=d3.format('.2g')]
	     * @returns {Function|dc.dataCount}
	     */
	    _chart.formatNumber = function (formatter) {
	        if (!arguments.length) {
	            return _formatNumber;
	        }
	        _formatNumber = formatter;
	        return _chart;
	    };
	
	    _chart._doRender = function () {
	        var tot = _chart.dimension().size(),
	            val = _chart.group().value();
	        var all = _formatNumber(tot);
	        var selected = _formatNumber(val);
	
	        if ((tot === val) && (_html.all !== '')) {
	            _chart.root().html(_html.all.replace('%total-count', all).replace('%filter-count', selected));
	        } else if (_html.some !== '') {
	            _chart.root().html(_html.some.replace('%total-count', all).replace('%filter-count', selected));
	        } else {
	            _chart.selectAll('.total-count').text(all);
	            _chart.selectAll('.filter-count').text(selected);
	        }
	        return _chart;
	    };
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * The data table is a simple widget designed to list crossfilter focused data set (rows being
	 * filtered) in a good old tabular fashion.
	 *
	 * Note: Unlike other charts, the data table (and data grid chart) use the {@link dc.dataTable#group group} attribute as a
	 * keying function for {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#nest nesting} the data
	 * together in groups.  Do not pass in a crossfilter group as this will not work.
	 *
	 * Another interesting feature of the data table is that you can pass a crossfilter group to the `dimension`, as
	 * long as you specify the {@link dc.dataTable#order order} as `d3.descending`, since the data
	 * table will use `dimension.top()` to fetch the data in that case, and the method is equally
	 * supported on the crossfilter group as the crossfilter dimension.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * - {@link http://dc-js.github.io/dc.js/examples/table-on-aggregated-data.html dataTable on a crossfilter group}
	 * ({@link https://github.com/dc-js/dc.js/blob/develop/web/examples/table-on-aggregated-data.html source})
	 * @class dataTable
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.dataTable}
	 */
	dc.dataTable = function (parent, chartGroup) {
	    var LABEL_CSS_CLASS = 'dc-table-label';
	    var ROW_CSS_CLASS = 'dc-table-row';
	    var COLUMN_CSS_CLASS = 'dc-table-column';
	    var GROUP_CSS_CLASS = 'dc-table-group';
	    var HEAD_CSS_CLASS = 'dc-table-head';
	
	    var _chart = dc.baseMixin({});
	
	    var _size = 25;
	    var _columns = [];
	    var _sortBy = function (d) {
	        return d;
	    };
	    var _order = d3.ascending;
	    var _beginSlice = 0;
	    var _endSlice;
	    var _showGroups = true;
	
	    _chart._doRender = function () {
	        _chart.selectAll('tbody').remove();
	
	        renderRows(renderGroups());
	
	        return _chart;
	    };
	
	    _chart._doColumnValueFormat = function (v, d) {
	        return ((typeof v === 'function') ?
	                v(d) :                          // v as function
	                ((typeof v === 'string') ?
	                 d[v] :                         // v is field name string
	                 v.format(d)                        // v is Object, use fn (element 2)
	                )
	               );
	    };
	
	    _chart._doColumnHeaderFormat = function (d) {
	        // if 'function', convert to string representation
	        // show a string capitalized
	        // if an object then display its label string as-is.
	        return (typeof d === 'function') ?
	                _chart._doColumnHeaderFnToString(d) :
	                ((typeof d === 'string') ?
	                 _chart._doColumnHeaderCapitalize(d) : String(d.label));
	    };
	
	    _chart._doColumnHeaderCapitalize = function (s) {
	        // capitalize
	        return s.charAt(0).toUpperCase() + s.slice(1);
	    };
	
	    _chart._doColumnHeaderFnToString = function (f) {
	        // columnString(f) {
	        var s = String(f);
	        var i1 = s.indexOf('return ');
	        if (i1 >= 0) {
	            var i2 = s.lastIndexOf(';');
	            if (i2 >= 0) {
	                s = s.substring(i1 + 7, i2);
	                var i3 = s.indexOf('numberFormat');
	                if (i3 >= 0) {
	                    s = s.replace('numberFormat', '');
	                }
	            }
	        }
	        return s;
	    };
	
	    function renderGroups () {
	        // The 'original' example uses all 'functions'.
	        // If all 'functions' are used, then don't remove/add a header, and leave
	        // the html alone. This preserves the functionality of earlier releases.
	        // A 2nd option is a string representing a field in the data.
	        // A third option is to supply an Object such as an array of 'information', and
	        // supply your own _doColumnHeaderFormat and _doColumnValueFormat functions to
	        // create what you need.
	        var bAllFunctions = true;
	        _columns.forEach(function (f) {
	            bAllFunctions = bAllFunctions & (typeof f === 'function');
	        });
	
	        if (!bAllFunctions) {
	            // ensure one thead
	            var thead = _chart.selectAll('thead').data([0]);
	            thead.enter().append('thead');
	            thead.exit().remove();
	
	            // with one tr
	            var headrow = thead.selectAll('tr').data([0]);
	            headrow.enter().append('tr');
	            headrow.exit().remove();
	
	            // with a th for each column
	            var headcols = headrow.selectAll('th')
	                .data(_columns);
	            headcols.enter().append('th');
	            headcols.exit().remove();
	
	            headcols
	                .attr('class', HEAD_CSS_CLASS)
	                    .html(function (d) {
	                        return (_chart._doColumnHeaderFormat(d));
	
	                    });
	        }
	
	        var groups = _chart.root().selectAll('tbody')
	            .data(nestEntries(), function (d) {
	                return _chart.keyAccessor()(d);
	            });
	
	        var rowGroup = groups
	            .enter()
	            .append('tbody');
	
	        if (_showGroups === true) {
	            rowGroup
	                .append('tr')
	                .attr('class', GROUP_CSS_CLASS)
	                    .append('td')
	                    .attr('class', LABEL_CSS_CLASS)
	                    .attr('colspan', _columns.length)
	                    .html(function (d) {
	                        return _chart.keyAccessor()(d);
	                    });
	        }
	
	        groups.exit().remove();
	
	        return rowGroup;
	    }
	
	    function nestEntries () {
	        var entries;
	        if (_order === d3.ascending) {
	            entries = _chart.dimension().bottom(_size);
	        } else {
	            entries = _chart.dimension().top(_size);
	        }
	
	        return d3.nest()
	            .key(_chart.group())
	            .sortKeys(_order)
	            .entries(entries.sort(function (a, b) {
	                return _order(_sortBy(a), _sortBy(b));
	            }).slice(_beginSlice, _endSlice));
	    }
	
	    function renderRows (groups) {
	        var rows = groups.order()
	            .selectAll('tr.' + ROW_CSS_CLASS)
	            .data(function (d) {
	                return d.values;
	            });
	
	        var rowEnter = rows.enter()
	            .append('tr')
	            .attr('class', ROW_CSS_CLASS);
	
	        _columns.forEach(function (v, i) {
	            rowEnter.append('td')
	                .attr('class', COLUMN_CSS_CLASS + ' _' + i)
	                .html(function (d) {
	                    return _chart._doColumnValueFormat(v, d);
	                });
	        });
	
	        rows.exit().remove();
	
	        return rows;
	    }
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    /**
	     * Get or set the group function for the data table. The group function takes a data row and
	     * returns the key to specify to {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#d3_nest d3.nest}
	     * to split rows into groups.
	     *
	     * Do not pass in a crossfilter group as this will not work.
	     * @method group
	     * @memberof dc.dataTable
	     * @instance
	     * @example
	     * // group rows by the value of their field
	     * chart
	     *     .group(function(d) { return d.field; })
	     * @param {Function} groupFunction Function taking a row of data and returning the nest key.
	     * @returns {Function|dc.dataTable}
	     */
	
	    /**
	     * Get or set the table size which determines the number of rows displayed by the widget.
	     * @method size
	     * @memberof dc.dataTable
	     * @instance
	     * @param {Number} [size=25]
	     * @returns {Number|dc.dataTable}
	     */
	    _chart.size = function (size) {
	        if (!arguments.length) {
	            return _size;
	        }
	        _size = size;
	        return _chart;
	    };
	
	    /**
	     * Get or set the index of the beginning slice which determines which entries get displayed
	     * by the widget. Useful when implementing pagination.
	     *
	     * Note: the sortBy function will determine how the rows are ordered for pagination purposes.
	
	     * See the {@link http://dc-js.github.io/dc.js/examples/table-pagination.html table pagination example}
	     * to see how to implement the pagination user interface using `beginSlice` and `endSlice`.
	     * @method beginSlice
	     * @memberof dc.dataTable
	     * @instance
	     * @param {Number} [beginSlice=0]
	     * @returns {Number|dc.dataTable}
	     */
	    _chart.beginSlice = function (beginSlice) {
	        if (!arguments.length) {
	            return _beginSlice;
	        }
	        _beginSlice = beginSlice;
	        return _chart;
	    };
	
	    /**
	     * Get or set the index of the end slice which determines which entries get displayed by the
	     * widget. Useful when implementing pagination. See {@link dc.dataTable#beginSlice `beginSlice`} for more information.
	     * @method endSlice
	     * @memberof dc.dataTable
	     * @instance
	     * @param {Number|undefined} [endSlice=undefined]
	     * @returns {Number|dc.dataTable}
	     */
	    _chart.endSlice = function (endSlice) {
	        if (!arguments.length) {
	            return _endSlice;
	        }
	        _endSlice = endSlice;
	        return _chart;
	    };
	
	    /**
	     * Get or set column functions. The data table widget supports several methods of specifying the
	     * columns to display.
	     *
	     * The original method uses an array of functions to generate dynamic columns. Column functions
	     * are simple javascript functions with only one input argument `d` which represents a row in
	     * the data set. The return value of these functions will be used to generate the content for
	     * each cell. However, this method requires the HTML for the table to have a fixed set of column
	     * headers.
	     *
	     * <pre><code>chart.columns([
	     *     function(d) { return d.date; },
	     *     function(d) { return d.open; },
	     *     function(d) { return d.close; },
	     *     function(d) { return numberFormat(d.close - d.open); },
	     *     function(d) { return d.volume; }
	     * ]);
	     * </code></pre>
	     *
	     * In the second method, you can list the columns to read from the data without specifying it as
	     * a function, except where necessary (ie, computed columns).  Note the data element name is
	     * capitalized when displayed in the table header. You can also mix in functions as necessary,
	     * using the third `{label, format}` form, as shown below.
	     *
	     * <pre><code>chart.columns([
	     *     "date",    // d["date"], ie, a field accessor; capitalized automatically
	     *     "open",    // ...
	     *     "close",   // ...
	     *     {
	     *         label: "Change",
	     *         format: function (d) {
	     *             return numberFormat(d.close - d.open);
	     *         }
	     *     },
	     *     "volume"   // d["volume"], ie, a field accessor; capitalized automatically
	     * ]);
	     * </code></pre>
	     *
	     * In the third example, we specify all fields using the `{label, format}` method:
	     * <pre><code>chart.columns([
	     *     {
	     *         label: "Date",
	     *         format: function (d) { return d.date; }
	     *     },
	     *     {
	     *         label: "Open",
	     *         format: function (d) { return numberFormat(d.open); }
	     *     },
	     *     {
	     *         label: "Close",
	     *         format: function (d) { return numberFormat(d.close); }
	     *     },
	     *     {
	     *         label: "Change",
	     *         format: function (d) { return numberFormat(d.close - d.open); }
	     *     },
	     *     {
	     *         label: "Volume",
	     *         format: function (d) { return d.volume; }
	     *     }
	     * ]);
	     * </code></pre>
	     *
	     * You may wish to override the dataTable functions `_doColumnHeaderCapitalize` and
	     * `_doColumnHeaderFnToString`, which are used internally to translate the column information or
	     * function into a displayed header. The first one is used on the "string" column specifier; the
	     * second is used to transform a stringified function into something displayable. For the Stock
	     * example, the function for Change becomes the table header **d.close - d.open**.
	     *
	     * Finally, you can even specify a completely different form of column definition. To do this,
	     * override `_chart._doColumnHeaderFormat` and `_chart._doColumnValueFormat` Be aware that
	     * fields without numberFormat specification will be displayed just as they are stored in the
	     * data, unformatted.
	     * @method columns
	     * @memberof dc.dataTable
	     * @instance
	     * @param {Array<Function>} [columns=[]]
	     * @returns {Array<Function>}|dc.dataTable}
	     */
	    _chart.columns = function (columns) {
	        if (!arguments.length) {
	            return _columns;
	        }
	        _columns = columns;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort-by function. This function works as a value accessor at row level and returns a
	     * particular field to be sorted by.
	     * @method sortBy
	     * @memberof dc.dataTable
	     * @instance
	     * @example
	     * chart.sortBy(function(d) {
	     *     return d.date;
	     * });
	     * @param {Function} [sortBy=identity function]
	     * @returns {Function|dc.dataTable}
	     */
	    _chart.sortBy = function (sortBy) {
	        if (!arguments.length) {
	            return _sortBy;
	        }
	        _sortBy = sortBy;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort order. If the order is `d3.ascending`, the data table will use
	     * `dimension().bottom()` to fetch the data; otherwise it will use `dimension().top()`
	     * @method order
	     * @memberof dc.dataTable
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#d3_ascending d3.ascending}
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#d3_descending d3.descending}
	     * @example
	     * chart.order(d3.descending);
	     * @param {Function} [order=d3.ascending]
	     * @returns {Function|dc.dataTable}
	     */
	    _chart.order = function (order) {
	        if (!arguments.length) {
	            return _order;
	        }
	        _order = order;
	        return _chart;
	    };
	
	    /**
	     * Get or set if group rows will be shown. The dataTable {@link dc.dataTable#group group}
	     * function must be specified even if groups are not shown.
	     * @method showGroups
	     * @memberof dc.dataTable
	     * @instance
	     * @example
	     * chart
	     *     .group([value], [name])
	     *     .showGroups(true|false);
	     * @param {Boolean} [showGroups=true]
	     * @returns {Boolean|dc.dataTable}
	     */
	    _chart.showGroups = function (showGroups) {
	        if (!arguments.length) {
	            return _showGroups;
	        }
	        _showGroups = showGroups;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Data grid is a simple widget designed to list the filtered records, providing
	 * a simple way to define how the items are displayed.
	 *
	 * Note: Unlike other charts, the data grid chart (and data table) use the {@link dc.dataGrid#group group} attribute as a keying function
	 * for {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#nest nesting} the data together in groups.
	 * Do not pass in a crossfilter group as this will not work.
	 *
	 * Examples:
	 * - {@link http://europarl.me/dc.js/web/ep/index.html List of members of the european parliament}
	 * @class dataGrid
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.dataGrid}
	 */
	dc.dataGrid = function (parent, chartGroup) {
	    var LABEL_CSS_CLASS = 'dc-grid-label';
	    var ITEM_CSS_CLASS = 'dc-grid-item';
	    var GROUP_CSS_CLASS = 'dc-grid-group';
	    var GRID_CSS_CLASS = 'dc-grid-top';
	
	    var _chart = dc.baseMixin({});
	
	    var _size = 999; // shouldn't be needed, but you might
	    var _html = function (d) { return 'you need to provide an html() handling param:  ' + JSON.stringify(d); };
	    var _sortBy = function (d) {
	        return d;
	    };
	    var _order = d3.ascending;
	    var _beginSlice = 0, _endSlice;
	
	    var _htmlGroup = function (d) {
	        return '<div class=\'' + GROUP_CSS_CLASS + '\'><h1 class=\'' + LABEL_CSS_CLASS + '\'>' +
	            _chart.keyAccessor()(d) + '</h1></div>';
	    };
	
	    _chart._doRender = function () {
	        _chart.selectAll('div.' + GRID_CSS_CLASS).remove();
	
	        renderItems(renderGroups());
	
	        return _chart;
	    };
	
	    function renderGroups () {
	        var groups = _chart.root().selectAll('div.' + GRID_CSS_CLASS)
	                .data(nestEntries(), function (d) {
	                    return _chart.keyAccessor()(d);
	                });
	
	        var itemGroup = groups
	                .enter()
	                .append('div')
	                .attr('class', GRID_CSS_CLASS);
	
	        if (_htmlGroup) {
	            itemGroup
	                .html(function (d) {
	                    return _htmlGroup(d);
	                });
	        }
	
	        groups.exit().remove();
	        return itemGroup;
	    }
	
	    function nestEntries () {
	        var entries = _chart.dimension().top(_size);
	
	        return d3.nest()
	            .key(_chart.group())
	            .sortKeys(_order)
	            .entries(entries.sort(function (a, b) {
	                return _order(_sortBy(a), _sortBy(b));
	            }).slice(_beginSlice, _endSlice));
	    }
	
	    function renderItems (groups) {
	        var items = groups.order()
	                .selectAll('div.' + ITEM_CSS_CLASS)
	                .data(function (d) {
	                    return d.values;
	                });
	
	        items.enter()
	            .append('div')
	            .attr('class', ITEM_CSS_CLASS)
	            .html(function (d) {
	                return _html(d);
	            });
	
	        items.exit().remove();
	
	        return items;
	    }
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    /**
	     * Get or set the group function for the data grid. The group function takes a data row and
	     * returns the key to specify to {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#d3_nest d3.nest}
	     * to split rows into groups.
	     *
	     * Do not pass in a crossfilter group as this will not work.
	     * @method group
	     * @memberof dc.dataGrid
	     * @instance
	     * @example
	     * // group rows by the value of their field
	     * chart
	     *     .group(function(d) { return d.field; })
	     * @param {Function} groupFunction Function taking a row of data and returning the nest key.
	     * @returns {Function|dc.dataTable}
	     */
	
	    /**
	     * Get or set the index of the beginning slice which determines which entries get displayed by the widget.
	     * Useful when implementing pagination.
	     * @method beginSlice
	     * @memberof dc.dataGrid
	     * @instance
	     * @param {Number} [beginSlice=0]
	     * @returns {Number|dc.dataGrid}
	     */
	    _chart.beginSlice = function (beginSlice) {
	        if (!arguments.length) {
	            return _beginSlice;
	        }
	        _beginSlice = beginSlice;
	        return _chart;
	    };
	
	    /**
	     * Get or set the index of the end slice which determines which entries get displayed by the widget.
	     * Useful when implementing pagination.
	     * @method endSlice
	     * @memberof dc.dataGrid
	     * @instance
	     * @param {Number} [endSlice]
	     * @returns {Number|dc.dataGrid}
	     */
	    _chart.endSlice = function (endSlice) {
	        if (!arguments.length) {
	            return _endSlice;
	        }
	        _endSlice = endSlice;
	        return _chart;
	    };
	
	    /**
	     * Get or set the grid size which determines the number of items displayed by the widget.
	     * @method size
	     * @memberof dc.dataGrid
	     * @instance
	     * @param {Number} [size=999]
	     * @returns {Number|dc.dataGrid}
	     */
	    _chart.size = function (size) {
	        if (!arguments.length) {
	            return _size;
	        }
	        _size = size;
	        return _chart;
	    };
	
	    /**
	     * Get or set the function that formats an item. The data grid widget uses a
	     * function to generate dynamic html. Use your favourite templating engine or
	     * generate the string directly.
	     * @method html
	     * @memberof dc.dataGrid
	     * @instance
	     * @example
	     * chart.html(function (d) { return '<div class='item '+data.exampleCategory+''>'+data.exampleString+'</div>';});
	     * @param {Function} [html]
	     * @returns {Function|dc.dataGrid}
	     */
	    _chart.html = function (html) {
	        if (!arguments.length) {
	            return _html;
	        }
	        _html = html;
	        return _chart;
	    };
	
	    /**
	     * Get or set the function that formats a group label.
	     * @method htmlGroup
	     * @memberof dc.dataGrid
	     * @instance
	     * @example
	     * chart.htmlGroup (function (d) { return '<h2>'.d.key . 'with ' . d.values.length .' items</h2>'});
	     * @param {Function} [htmlGroup]
	     * @returns {Function|dc.dataGrid}
	     */
	    _chart.htmlGroup = function (htmlGroup) {
	        if (!arguments.length) {
	            return _htmlGroup;
	        }
	        _htmlGroup = htmlGroup;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort-by function. This function works as a value accessor at the item
	     * level and returns a particular field to be sorted.
	     * @method sortBy
	     * @memberof dc.dataGrid
	     * @instance
	     * @example
	     * chart.sortBy(function(d) {
	     *     return d.date;
	     * });
	     * @param {Function} [sortByFunction]
	     * @returns {Function|dc.dataGrid}
	     */
	    _chart.sortBy = function (sortByFunction) {
	        if (!arguments.length) {
	            return _sortBy;
	        }
	        _sortBy = sortByFunction;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort the order function.
	     * @method order
	     * @memberof dc.dataGrid
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#d3_ascending d3.ascending}
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#d3_descending d3.descending}
	     * @example
	     * chart.order(d3.descending);
	     * @param {Function} [order=d3.ascending]
	     * @returns {Function|dc.dataGrid}
	     */
	    _chart.order = function (order) {
	        if (!arguments.length) {
	            return _order;
	        }
	        _order = order;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A concrete implementation of a general purpose bubble chart that allows data visualization using the
	 * following dimensions:
	 * - x axis position
	 * - y axis position
	 * - bubble radius
	 * - color
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * - {@link http://dc-js.github.com/dc.js/vc/index.html US Venture Capital Landscape 2011}
	 * @class bubbleChart
	 * @memberof dc
	 * @mixes dc.bubbleMixin
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a bubble chart under #chart-container1 element using the default global chart group
	 * var bubbleChart1 = dc.bubbleChart('#chart-container1');
	 * // create a bubble chart under #chart-container2 element using chart group A
	 * var bubbleChart2 = dc.bubbleChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.bubbleChart}
	 */
	dc.bubbleChart = function (parent, chartGroup) {
	    var _chart = dc.bubbleMixin(dc.coordinateGridMixin({}));
	
	    _chart.transitionDuration(750);
	
	    _chart.transitionDelay(0);
	
	    var bubbleLocator = function (d) {
	        return 'translate(' + (bubbleX(d)) + ',' + (bubbleY(d)) + ')';
	    };
	
	    _chart.plotData = function () {
	        _chart.calculateRadiusDomain();
	        _chart.r().range([_chart.MIN_RADIUS, _chart.xAxisLength() * _chart.maxBubbleRelativeSize()]);
	
	        var data = _chart.data();
	        var bubbleG = _chart.chartBodyG().selectAll('g.' + _chart.BUBBLE_NODE_CLASS)
	                .data(data, function (d) { return d.key; });
	        if (_chart.sortBubbleSize()) {
	            // update dom order based on sort
	            bubbleG.order();
	        }
	
	        renderNodes(bubbleG);
	
	        updateNodes(bubbleG);
	
	        removeNodes(bubbleG);
	
	        _chart.fadeDeselectedArea();
	    };
	
	    function renderNodes (bubbleG) {
	        var bubbleGEnter = bubbleG.enter().append('g');
	
	        bubbleGEnter
	            .attr('class', _chart.BUBBLE_NODE_CLASS)
	            .attr('transform', bubbleLocator)
	            .append('circle').attr('class', function (d, i) {
	                return _chart.BUBBLE_CLASS + ' _' + i;
	            })
	            .on('click', _chart.onClick)
	            .attr('fill', _chart.getColor)
	            .attr('r', 0);
	        dc.transition(bubbleG, _chart.transitionDuration(), _chart.transitionDelay())
	            .select('circle.' + _chart.BUBBLE_CLASS)
	            .attr('r', function (d) {
	                return _chart.bubbleR(d);
	            })
	            .attr('opacity', function (d) {
	                return (_chart.bubbleR(d) > 0) ? 1 : 0;
	            });
	
	        _chart._doRenderLabel(bubbleGEnter);
	
	        _chart._doRenderTitles(bubbleGEnter);
	    }
	
	    function updateNodes (bubbleG) {
	        dc.transition(bubbleG, _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('transform', bubbleLocator)
	            .select('circle.' + _chart.BUBBLE_CLASS)
	            .attr('fill', _chart.getColor)
	            .attr('r', function (d) {
	                return _chart.bubbleR(d);
	            })
	            .attr('opacity', function (d) {
	                return (_chart.bubbleR(d) > 0) ? 1 : 0;
	            });
	
	        _chart.doUpdateLabels(bubbleG);
	        _chart.doUpdateTitles(bubbleG);
	    }
	
	    function removeNodes (bubbleG) {
	        bubbleG.exit().remove();
	    }
	
	    function bubbleX (d) {
	        var x = _chart.x()(_chart.keyAccessor()(d));
	        if (isNaN(x)) {
	            x = 0;
	        }
	        return x;
	    }
	
	    function bubbleY (d) {
	        var y = _chart.y()(_chart.valueAccessor()(d));
	        if (isNaN(y)) {
	            y = 0;
	        }
	        return y;
	    }
	
	    _chart.renderBrush = function () {
	        // override default x axis brush from parent chart
	    };
	
	    _chart.redrawBrush = function () {
	        // override default x axis brush from parent chart
	        _chart.fadeDeselectedArea();
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Composite charts are a special kind of chart that render multiple charts on the same Coordinate
	 * Grid. You can overlay (compose) different bar/line/area charts in a single composite chart to
	 * achieve some quite flexible charting effects.
	 * @class compositeChart
	 * @memberof dc
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a composite chart under #chart-container1 element using the default global chart group
	 * var compositeChart1 = dc.compositeChart('#chart-container1');
	 * // create a composite chart under #chart-container2 element using chart group A
	 * var compositeChart2 = dc.compositeChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.compositeChart}
	 */
	dc.compositeChart = function (parent, chartGroup) {
	
	    var SUB_CHART_CLASS = 'sub';
	    var DEFAULT_RIGHT_Y_AXIS_LABEL_PADDING = 12;
	
	    var _chart = dc.coordinateGridMixin({});
	    var _children = [];
	
	    var _childOptions = {};
	
	    var _shareColors = false,
	        _shareTitle = true,
	        _alignYAxes = false;
	
	    var _rightYAxis = d3.svg.axis(),
	        _rightYAxisLabel = 0,
	        _rightYAxisLabelPadding = DEFAULT_RIGHT_Y_AXIS_LABEL_PADDING,
	        _rightY,
	        _rightAxisGridLines = false;
	
	    _chart._mandatoryAttributes([]);
	    _chart.transitionDuration(500);
	    _chart.transitionDelay(0);
	
	    dc.override(_chart, '_generateG', function () {
	        var g = this.__generateG();
	
	        for (var i = 0; i < _children.length; ++i) {
	            var child = _children[i];
	
	            generateChildG(child, i);
	
	            if (!child.dimension()) {
	                child.dimension(_chart.dimension());
	            }
	            if (!child.group()) {
	                child.group(_chart.group());
	            }
	
	            child.chartGroup(_chart.chartGroup());
	            child.svg(_chart.svg());
	            child.xUnits(_chart.xUnits());
	            child.transitionDuration(_chart.transitionDuration(), _chart.transitionDelay());
	            child.brushOn(_chart.brushOn());
	            child.renderTitle(_chart.renderTitle());
	            child.elasticX(_chart.elasticX());
	        }
	
	        return g;
	    });
	
	    _chart._brushing = function () {
	        var extent = _chart.extendBrush();
	        var brushIsEmpty = _chart.brushIsEmpty(extent);
	
	        for (var i = 0; i < _children.length; ++i) {
	            _children[i].replaceFilter(brushIsEmpty ? null : extent);
	        }
	    };
	
	    _chart._prepareYAxis = function () {
	        var left = (leftYAxisChildren().length !== 0);
	        var right = (rightYAxisChildren().length !== 0);
	        var ranges = calculateYAxisRanges(left, right);
	
	        if (left) { prepareLeftYAxis(ranges); }
	        if (right) { prepareRightYAxis(ranges); }
	
	        if (leftYAxisChildren().length > 0 && !_rightAxisGridLines) {
	            _chart._renderHorizontalGridLinesForAxis(_chart.g(), _chart.y(), _chart.yAxis());
	        } else if (rightYAxisChildren().length > 0) {
	            _chart._renderHorizontalGridLinesForAxis(_chart.g(), _rightY, _rightYAxis);
	        }
	    };
	
	    _chart.renderYAxis = function () {
	        if (leftYAxisChildren().length !== 0) {
	            _chart.renderYAxisAt('y', _chart.yAxis(), _chart.margins().left);
	            _chart.renderYAxisLabel('y', _chart.yAxisLabel(), -90);
	        }
	
	        if (rightYAxisChildren().length !== 0) {
	            _chart.renderYAxisAt('yr', _chart.rightYAxis(), _chart.width() - _chart.margins().right);
	            _chart.renderYAxisLabel('yr', _chart.rightYAxisLabel(), 90, _chart.width() - _rightYAxisLabelPadding);
	        }
	    };
	
	    function calculateYAxisRanges (left, right) {
	        var lyAxisMin, lyAxisMax, ryAxisMin, ryAxisMax;
	        var ranges;
	
	        if (left) {
	            lyAxisMin = yAxisMin();
	            lyAxisMax = yAxisMax();
	        }
	
	        if (right) {
	            ryAxisMin = rightYAxisMin();
	            ryAxisMax = rightYAxisMax();
	        }
	
	        if (_chart.alignYAxes() && left && right) {
	            ranges = alignYAxisRanges(lyAxisMin, lyAxisMax, ryAxisMin, ryAxisMax);
	        }
	
	        return ranges || {
	            lyAxisMin: lyAxisMin,
	            lyAxisMax: lyAxisMax,
	            ryAxisMin: ryAxisMin,
	            ryAxisMax: ryAxisMax
	        };
	    }
	
	    function alignYAxisRanges (lyAxisMin, lyAxisMax, ryAxisMin, ryAxisMax) {
	        // since the two series will share a zero, each Y is just a multiple
	        // of the other. and the ratio should be the ratio of the ranges of the
	        // input data, so that they come out the same height. so we just min/max
	
	        // note: both ranges already include zero due to the stack mixin (#667)
	        // if #667 changes, we can reconsider whether we want data height or
	        // height from zero to be equal. and it will be possible for the axes
	        // to be aligned but not visible.
	        var extentRatio = (ryAxisMax - ryAxisMin) / (lyAxisMax - lyAxisMin);
	
	        return {
	            lyAxisMin: Math.min(lyAxisMin, ryAxisMin / extentRatio),
	            lyAxisMax: Math.max(lyAxisMax, ryAxisMax / extentRatio),
	            ryAxisMin: Math.min(ryAxisMin, lyAxisMin * extentRatio),
	            ryAxisMax: Math.max(ryAxisMax, lyAxisMax * extentRatio)
	        };
	    }
	
	    function prepareRightYAxis (ranges) {
	        var needDomain = _chart.rightY() === undefined || _chart.elasticY(),
	            needRange = needDomain || _chart.resizing();
	        if (_chart.rightY() === undefined) {
	            _chart.rightY(d3.scale.linear());
	        }
	        if (needDomain) {
	            _chart.rightY().domain([ranges.ryAxisMin, ranges.ryAxisMax]);
	        }
	        if (needRange) {
	            _chart.rightY().rangeRound([_chart.yAxisHeight(), 0]);
	        }
	
	        _chart.rightY().range([_chart.yAxisHeight(), 0]);
	        _chart.rightYAxis(_chart.rightYAxis().scale(_chart.rightY()));
	
	        _chart.rightYAxis().orient('right');
	    }
	
	    function prepareLeftYAxis (ranges) {
	        var needDomain = _chart.y() === undefined || _chart.elasticY(),
	            needRange = needDomain || _chart.resizing();
	        if (_chart.y() === undefined) {
	            _chart.y(d3.scale.linear());
	        }
	        if (needDomain) {
	            _chart.y().domain([ranges.lyAxisMin, ranges.lyAxisMax]);
	        }
	        if (needRange) {
	            _chart.y().rangeRound([_chart.yAxisHeight(), 0]);
	        }
	
	        _chart.y().range([_chart.yAxisHeight(), 0]);
	        _chart.yAxis(_chart.yAxis().scale(_chart.y()));
	
	        _chart.yAxis().orient('left');
	    }
	
	    function generateChildG (child, i) {
	        child._generateG(_chart.g());
	        child.g().attr('class', SUB_CHART_CLASS + ' _' + i);
	    }
	
	    _chart.plotData = function () {
	        for (var i = 0; i < _children.length; ++i) {
	            var child = _children[i];
	
	            if (!child.g()) {
	                generateChildG(child, i);
	            }
	
	            if (_shareColors) {
	                child.colors(_chart.colors());
	            }
	
	            child.x(_chart.x());
	
	            child.xAxis(_chart.xAxis());
	
	            if (child.useRightYAxis()) {
	                child.y(_chart.rightY());
	                child.yAxis(_chart.rightYAxis());
	            } else {
	                child.y(_chart.y());
	                child.yAxis(_chart.yAxis());
	            }
	
	            child.plotData();
	
	            child._activateRenderlets();
	        }
	    };
	
	    /**
	     * Get or set whether to draw gridlines from the right y axis.  Drawing from the left y axis is the
	     * default behavior. This option is only respected when subcharts with both left and right y-axes
	     * are present.
	     * @method useRightAxisGridLines
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Boolean} [useRightAxisGridLines=false]
	     * @returns {Boolean|dc.compositeChart}
	     */
	    _chart.useRightAxisGridLines = function (useRightAxisGridLines) {
	        if (!arguments) {
	            return _rightAxisGridLines;
	        }
	
	        _rightAxisGridLines = useRightAxisGridLines;
	        return _chart;
	    };
	
	    /**
	     * Get or set chart-specific options for all child charts. This is equivalent to calling
	     * {@link dc.baseMixin#options .options} on each child chart.
	     * @method childOptions
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Object} [childOptions]
	     * @returns {Object|dc.compositeChart}
	     */
	    _chart.childOptions = function (childOptions) {
	        if (!arguments.length) {
	            return _childOptions;
	        }
	        _childOptions = childOptions;
	        _children.forEach(function (child) {
	            child.options(_childOptions);
	        });
	        return _chart;
	    };
	
	    _chart.fadeDeselectedArea = function () {
	        for (var i = 0; i < _children.length; ++i) {
	            var child = _children[i];
	            child.brush(_chart.brush());
	            child.fadeDeselectedArea();
	        }
	    };
	
	    /**
	     * Set or get the right y axis label.
	     * @method rightYAxisLabel
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {String} [rightYAxisLabel]
	     * @param {Number} [padding]
	     * @returns {String|dc.compositeChart}
	     */
	    _chart.rightYAxisLabel = function (rightYAxisLabel, padding) {
	        if (!arguments.length) {
	            return _rightYAxisLabel;
	        }
	        _rightYAxisLabel = rightYAxisLabel;
	        _chart.margins().right -= _rightYAxisLabelPadding;
	        _rightYAxisLabelPadding = (padding === undefined) ? DEFAULT_RIGHT_Y_AXIS_LABEL_PADDING : padding;
	        _chart.margins().right += _rightYAxisLabelPadding;
	        return _chart;
	    };
	
	    /**
	     * Combine the given charts into one single composite coordinate grid chart.
	     * @method compose
	     * @memberof dc.compositeChart
	     * @instance
	     * @example
	     * moveChart.compose([
	     *     // when creating sub-chart you need to pass in the parent chart
	     *     dc.lineChart(moveChart)
	     *         .group(indexAvgByMonthGroup) // if group is missing then parent's group will be used
	     *         .valueAccessor(function (d){return d.value.avg;})
	     *         // most of the normal functions will continue to work in a composed chart
	     *         .renderArea(true)
	     *         .stack(monthlyMoveGroup, function (d){return d.value;})
	     *         .title(function (d){
	     *             var value = d.value.avg?d.value.avg:d.value;
	     *             if(isNaN(value)) value = 0;
	     *             return dateFormat(d.key) + '\n' + numberFormat(value);
	     *         }),
	     *     dc.barChart(moveChart)
	     *         .group(volumeByMonthGroup)
	     *         .centerBar(true)
	     * ]);
	     * @param {Array<Chart>} [subChartArray]
	     * @returns {dc.compositeChart}
	     */
	    _chart.compose = function (subChartArray) {
	        _children = subChartArray;
	        _children.forEach(function (child) {
	            child.height(_chart.height());
	            child.width(_chart.width());
	            child.margins(_chart.margins());
	
	            if (_shareTitle) {
	                child.title(_chart.title());
	            }
	
	            child.options(_childOptions);
	        });
	        return _chart;
	    };
	
	    /**
	     * Returns the child charts which are composed into the composite chart.
	     * @method children
	     * @memberof dc.compositeChart
	     * @instance
	     * @returns {Array<dc.baseMixin>}
	     */
	    _chart.children = function () {
	        return _children;
	    };
	
	    /**
	     * Get or set color sharing for the chart. If set, the {@link dc.colorMixin#colors .colors()} value from this chart
	     * will be shared with composed children. Additionally if the child chart implements
	     * Stackable and has not set a custom .colorAccessor, then it will generate a color
	     * specific to its order in the composition.
	     * @method shareColors
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Boolean} [shareColors=false]
	     * @returns {Boolean|dc.compositeChart}
	     */
	    _chart.shareColors = function (shareColors) {
	        if (!arguments.length) {
	            return _shareColors;
	        }
	        _shareColors = shareColors;
	        return _chart;
	    };
	
	    /**
	     * Get or set title sharing for the chart. If set, the {@link dc.baseMixin#title .title()} value from
	     * this chart will be shared with composed children.
	     * @method shareTitle
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Boolean} [shareTitle=true]
	     * @returns {Boolean|dc.compositeChart}
	     */
	    _chart.shareTitle = function (shareTitle) {
	        if (!arguments.length) {
	            return _shareTitle;
	        }
	        _shareTitle = shareTitle;
	        return _chart;
	    };
	
	    /**
	     * Get or set the y scale for the right axis. The right y scale is typically automatically
	     * generated by the chart implementation.
	     * @method rightY
	     * @memberof dc.compositeChart
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Scales.md d3.scale}
	     * @param {d3.scale} [yScale]
	     * @returns {d3.scale|dc.compositeChart}
	     */
	    _chart.rightY = function (yScale) {
	        if (!arguments.length) {
	            return _rightY;
	        }
	        _rightY = yScale;
	        _chart.rescale();
	        return _chart;
	    };
	
	    /**
	     * Get or set alignment between left and right y axes. A line connecting '0' on both y axis
	     * will be parallel to x axis. This only has effect when {@link #dc.coordinateGridMixin+elasticY elasticY} is true.
	     * @method alignYAxes
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Boolean} [alignYAxes=false]
	     * @returns {Chart}
	     */
	    _chart.alignYAxes = function (alignYAxes) {
	        if (!arguments.length) {
	            return _alignYAxes;
	        }
	        _alignYAxes = alignYAxes;
	        _chart.rescale();
	        return _chart;
	    };
	
	    function leftYAxisChildren () {
	        return _children.filter(function (child) {
	            return !child.useRightYAxis();
	        });
	    }
	
	    function rightYAxisChildren () {
	        return _children.filter(function (child) {
	            return child.useRightYAxis();
	        });
	    }
	
	    function getYAxisMin (charts) {
	        return charts.map(function (c) {
	            return c.yAxisMin();
	        });
	    }
	
	    delete _chart.yAxisMin;
	    function yAxisMin () {
	        return d3.min(getYAxisMin(leftYAxisChildren()));
	    }
	
	    function rightYAxisMin () {
	        return d3.min(getYAxisMin(rightYAxisChildren()));
	    }
	
	    function getYAxisMax (charts) {
	        return charts.map(function (c) {
	            return c.yAxisMax();
	        });
	    }
	
	    delete _chart.yAxisMax;
	    function yAxisMax () {
	        return dc.utils.add(d3.max(getYAxisMax(leftYAxisChildren())), _chart.yAxisPadding());
	    }
	
	    function rightYAxisMax () {
	        return dc.utils.add(d3.max(getYAxisMax(rightYAxisChildren())), _chart.yAxisPadding());
	    }
	
	    function getAllXAxisMinFromChildCharts () {
	        return _children.map(function (c) {
	            return c.xAxisMin();
	        });
	    }
	
	    dc.override(_chart, 'xAxisMin', function () {
	        return dc.utils.subtract(d3.min(getAllXAxisMinFromChildCharts()), _chart.xAxisPadding());
	    });
	
	    function getAllXAxisMaxFromChildCharts () {
	        return _children.map(function (c) {
	            return c.xAxisMax();
	        });
	    }
	
	    dc.override(_chart, 'xAxisMax', function () {
	        return dc.utils.add(d3.max(getAllXAxisMaxFromChildCharts()), _chart.xAxisPadding());
	    });
	
	    _chart.legendables = function () {
	        return _children.reduce(function (items, child) {
	            if (_shareColors) {
	                child.colors(_chart.colors());
	            }
	            items.push.apply(items, child.legendables());
	            return items;
	        }, []);
	    };
	
	    _chart.legendHighlight = function (d) {
	        for (var j = 0; j < _children.length; ++j) {
	            var child = _children[j];
	            child.legendHighlight(d);
	        }
	    };
	
	    _chart.legendReset = function (d) {
	        for (var j = 0; j < _children.length; ++j) {
	            var child = _children[j];
	            child.legendReset(d);
	        }
	    };
	
	    _chart.legendToggle = function () {
	        console.log('composite should not be getting legendToggle itself');
	    };
	
	    /**
	     * Set or get the right y axis used by the composite chart. This function is most useful when y
	     * axis customization is required. The y axis in dc.js is an instance of a [d3 axis
	     * object](https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Axes.md#axis) therefore it supports any valid
	     * d3 axis manipulation.
	     *
	     * **Caution**: The y axis is usually generated internally by dc; resetting it may cause
	     * unexpected results.
	     * @method rightYAxis
	     * @memberof dc.compositeChart
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Axes.md#axis d3.svg.axis}
	     * @example
	     * // customize y axis tick format
	     * chart.rightYAxis().tickFormat(function (v) {return v + '%';});
	     * // customize y axis tick values
	     * chart.rightYAxis().tickValues([0, 100, 200, 300]);
	     * @param {d3.svg.axis} [rightYAxis]
	     * @returns {d3.svg.axis|dc.compositeChart}
	     */
	    _chart.rightYAxis = function (rightYAxis) {
	        if (!arguments.length) {
	            return _rightYAxis;
	        }
	        _rightYAxis = rightYAxis;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A series chart is a chart that shows multiple series of data overlaid on one chart, where the
	 * series is specified in the data. It is a specialization of Composite Chart and inherits all
	 * composite features other than recomposing the chart.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.io/dc.js/examples/series.html Series Chart}
	 * @class seriesChart
	 * @memberof dc
	 * @mixes dc.compositeChart
	 * @example
	 * // create a series chart under #chart-container1 element using the default global chart group
	 * var seriesChart1 = dc.seriesChart("#chart-container1");
	 * // create a series chart under #chart-container2 element using chart group A
	 * var seriesChart2 = dc.seriesChart("#chart-container2", "chartGroupA");
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.seriesChart}
	 */
	dc.seriesChart = function (parent, chartGroup) {
	    var _chart = dc.compositeChart(parent, chartGroup);
	
	    function keySort (a, b) {
	        return d3.ascending(_chart.keyAccessor()(a), _chart.keyAccessor()(b));
	    }
	
	    var _charts = {};
	    var _chartFunction = dc.lineChart;
	    var _seriesAccessor;
	    var _seriesSort = d3.ascending;
	    var _valueSort = keySort;
	
	    _chart._mandatoryAttributes().push('seriesAccessor', 'chart');
	    _chart.shareColors(true);
	
	    _chart._preprocessData = function () {
	        var keep = [];
	        var childrenChanged;
	        var nester = d3.nest().key(_seriesAccessor);
	        if (_seriesSort) {
	            nester.sortKeys(_seriesSort);
	        }
	        if (_valueSort) {
	            nester.sortValues(_valueSort);
	        }
	        var nesting = nester.entries(_chart.data());
	        var children =
	            nesting.map(function (sub, i) {
	                var subChart = _charts[sub.key] || _chartFunction.call(_chart, _chart, chartGroup, sub.key, i);
	                if (!_charts[sub.key]) {
	                    childrenChanged = true;
	                }
	                _charts[sub.key] = subChart;
	                keep.push(sub.key);
	                return subChart
	                    .dimension(_chart.dimension())
	                    .group({all: d3.functor(sub.values)}, sub.key)
	                    .keyAccessor(_chart.keyAccessor())
	                    .valueAccessor(_chart.valueAccessor())
	                    .brushOn(_chart.brushOn());
	            });
	        // this works around the fact compositeChart doesn't really
	        // have a removal interface
	        Object.keys(_charts)
	            .filter(function (c) {return keep.indexOf(c) === -1;})
	            .forEach(function (c) {
	                clearChart(c);
	                childrenChanged = true;
	            });
	        _chart._compose(children);
	        if (childrenChanged && _chart.legend()) {
	            _chart.legend().render();
	        }
	    };
	
	    function clearChart (c) {
	        if (_charts[c].g()) {
	            _charts[c].g().remove();
	        }
	        delete _charts[c];
	    }
	
	    function resetChildren () {
	        Object.keys(_charts).map(clearChart);
	        _charts = {};
	    }
	
	    /**
	     * Get or set the chart function, which generates the child charts.
	     * @method chart
	     * @memberof dc.seriesChart
	     * @instance
	     * @example
	     * // put interpolation on the line charts used for the series
	     * chart.chart(function(c) { return dc.lineChart(c).interpolate('basis'); })
	     * // do a scatter series chart
	     * chart.chart(dc.scatterPlot)
	     * @param {Function} [chartFunction=dc.lineChart]
	     * @returns {Function|dc.seriesChart}
	     */
	    _chart.chart = function (chartFunction) {
	        if (!arguments.length) {
	            return _chartFunction;
	        }
	        _chartFunction = chartFunction;
	        resetChildren();
	        return _chart;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Get or set accessor function for the displayed series. Given a datum, this function
	     * should return the series that datum belongs to.
	     * @method seriesAccessor
	     * @memberof dc.seriesChart
	     * @instance
	     * @example
	     * // simple series accessor
	     * chart.seriesAccessor(function(d) { return "Expt: " + d.key[0]; })
	     * @param {Function} [accessor]
	     * @returns {Function|dc.seriesChart}
	     */
	    _chart.seriesAccessor = function (accessor) {
	        if (!arguments.length) {
	            return _seriesAccessor;
	        }
	        _seriesAccessor = accessor;
	        resetChildren();
	        return _chart;
	    };
	
	    /**
	     * Get or set a function to sort the list of series by, given series values.
	     * @method seriesSort
	     * @memberof dc.seriesChart
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#d3_ascending d3.ascending}
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#d3_descending d3.descending}
	     * @example
	     * chart.seriesSort(d3.descending);
	     * @param {Function} [sortFunction=d3.ascending]
	     * @returns {Function|dc.seriesChart}
	     */
	    _chart.seriesSort = function (sortFunction) {
	        if (!arguments.length) {
	            return _seriesSort;
	        }
	        _seriesSort = sortFunction;
	        resetChildren();
	        return _chart;
	    };
	
	    /**
	     * Get or set a function to sort each series values by. By default this is the key accessor which,
	     * for example, will ensure a lineChart series connects its points in increasing key/x order,
	     * rather than haphazardly.
	     * @method valueSort
	     * @memberof dc.seriesChart
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#d3_ascending d3.ascending}
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Arrays.md#d3_descending d3.descending}
	     * @example
	     * // Default value sort
	     * _chart.valueSort(function keySort (a, b) {
	     *     return d3.ascending(_chart.keyAccessor()(a), _chart.keyAccessor()(b));
	     * });
	     * @param {Function} [sortFunction]
	     * @returns {Function|dc.seriesChart}
	     */
	    _chart.valueSort = function (sortFunction) {
	        if (!arguments.length) {
	            return _valueSort;
	        }
	        _valueSort = sortFunction;
	        resetChildren();
	        return _chart;
	    };
	
	    // make compose private
	    _chart._compose = _chart.compose;
	    delete _chart.compose;
	
	    return _chart;
	};
	
	/**
	 * The geo choropleth chart is designed as an easy way to create a crossfilter driven choropleth map
	 * from GeoJson data. This chart implementation was inspired by
	 * {@link http://bl.ocks.org/4060606 the great d3 choropleth example}.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/vc/index.html US Venture Capital Landscape 2011}
	 * @class geoChoroplethChart
	 * @memberof dc
	 * @mixes dc.colorMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a choropleth chart under '#us-chart' element using the default global chart group
	 * var chart1 = dc.geoChoroplethChart('#us-chart');
	 * // create a choropleth chart under '#us-chart2' element using chart group A
	 * var chart2 = dc.compositeChart('#us-chart2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.geoChoroplethChart}
	 */
	dc.geoChoroplethChart = function (parent, chartGroup) {
	    var _chart = dc.colorMixin(dc.baseMixin({}));
	
	    _chart.colorAccessor(function (d) {
	        return d || 0;
	    });
	
	    var _geoPath = d3.geo.path();
	    var _projectionFlag;
	
	    var _geoJsons = [];
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	        for (var layerIndex = 0; layerIndex < _geoJsons.length; ++layerIndex) {
	            var states = _chart.svg().append('g')
	                .attr('class', 'layer' + layerIndex);
	
	            var regionG = states.selectAll('g.' + geoJson(layerIndex).name)
	                .data(geoJson(layerIndex).data)
	                .enter()
	                .append('g')
	                .attr('class', geoJson(layerIndex).name);
	
	            regionG
	                .append('path')
	                .attr('fill', 'white')
	                .attr('d', _geoPath);
	
	            regionG.append('title');
	
	            plotData(layerIndex);
	        }
	        _projectionFlag = false;
	    };
	
	    function plotData (layerIndex) {
	        var data = generateLayeredData();
	
	        if (isDataLayer(layerIndex)) {
	            var regionG = renderRegionG(layerIndex);
	
	            renderPaths(regionG, layerIndex, data);
	
	            renderTitle(regionG, layerIndex, data);
	        }
	    }
	
	    function generateLayeredData () {
	        var data = {};
	        var groupAll = _chart.data();
	        for (var i = 0; i < groupAll.length; ++i) {
	            data[_chart.keyAccessor()(groupAll[i])] = _chart.valueAccessor()(groupAll[i]);
	        }
	        return data;
	    }
	
	    function isDataLayer (layerIndex) {
	        return geoJson(layerIndex).keyAccessor;
	    }
	
	    function renderRegionG (layerIndex) {
	        var regionG = _chart.svg()
	            .selectAll(layerSelector(layerIndex))
	            .classed('selected', function (d) {
	                return isSelected(layerIndex, d);
	            })
	            .classed('deselected', function (d) {
	                return isDeselected(layerIndex, d);
	            })
	            .attr('class', function (d) {
	                var layerNameClass = geoJson(layerIndex).name;
	                var regionClass = dc.utils.nameToId(geoJson(layerIndex).keyAccessor(d));
	                var baseClasses = layerNameClass + ' ' + regionClass;
	                if (isSelected(layerIndex, d)) {
	                    baseClasses += ' selected';
	                }
	                if (isDeselected(layerIndex, d)) {
	                    baseClasses += ' deselected';
	                }
	                return baseClasses;
	            });
	        return regionG;
	    }
	
	    function layerSelector (layerIndex) {
	        return 'g.layer' + layerIndex + ' g.' + geoJson(layerIndex).name;
	    }
	
	    function isSelected (layerIndex, d) {
	        return _chart.hasFilter() && _chart.hasFilter(getKey(layerIndex, d));
	    }
	
	    function isDeselected (layerIndex, d) {
	        return _chart.hasFilter() && !_chart.hasFilter(getKey(layerIndex, d));
	    }
	
	    function getKey (layerIndex, d) {
	        return geoJson(layerIndex).keyAccessor(d);
	    }
	
	    function geoJson (index) {
	        return _geoJsons[index];
	    }
	
	    function renderPaths (regionG, layerIndex, data) {
	        var paths = regionG
	            .select('path')
	            .attr('fill', function () {
	                var currentFill = d3.select(this).attr('fill');
	                if (currentFill) {
	                    return currentFill;
	                }
	                return 'none';
	            })
	            .on('click', function (d) {
	                return _chart.onClick(d, layerIndex);
	            });
	
	        dc.transition(paths, _chart.transitionDuration(), _chart.transitionDelay()).attr('fill', function (d, i) {
	            return _chart.getColor(data[geoJson(layerIndex).keyAccessor(d)], i);
	        });
	    }
	
	    _chart.onClick = function (d, layerIndex) {
	        var selectedRegion = geoJson(layerIndex).keyAccessor(d);
	        dc.events.trigger(function () {
	            _chart.filter(selectedRegion);
	            _chart.redrawGroup();
	        });
	    };
	
	    function renderTitle (regionG, layerIndex, data) {
	        if (_chart.renderTitle()) {
	            regionG.selectAll('title').text(function (d) {
	                var key = getKey(layerIndex, d);
	                var value = data[key];
	                return _chart.title()({key: key, value: value});
	            });
	        }
	    }
	
	    _chart._doRedraw = function () {
	        for (var layerIndex = 0; layerIndex < _geoJsons.length; ++layerIndex) {
	            plotData(layerIndex);
	            if (_projectionFlag) {
	                _chart.svg().selectAll('g.' + geoJson(layerIndex).name + ' path').attr('d', _geoPath);
	            }
	        }
	        _projectionFlag = false;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Use this function to insert a new GeoJson map layer. This function can be invoked multiple times
	     * if you have multiple GeoJson data layers to render on top of each other. If you overlay multiple
	     * layers with the same name the new overlay will override the existing one.
	     * @method overlayGeoJson
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @see {@link http://geojson.org/ GeoJSON}
	     * @see {@link https://github.com/topojson/topojson/wiki TopoJSON}
	     * @see {@link https://github.com/topojson/topojson-1.x-api-reference/blob/master/API-Reference.md#wiki-feature topojson.feature}
	     * @example
	     * // insert a layer for rendering US states
	     * chart.overlayGeoJson(statesJson.features, 'state', function(d) {
	     *      return d.properties.name;
	     * });
	     * @param {geoJson} json - a geojson feed
	     * @param {String} name - name of the layer
	     * @param {Function} keyAccessor - accessor function used to extract 'key' from the GeoJson data. The key extracted by
	     * this function should match the keys returned by the crossfilter groups.
	     * @returns {dc.geoChoroplethChart}
	     */
	    _chart.overlayGeoJson = function (json, name, keyAccessor) {
	        for (var i = 0; i < _geoJsons.length; ++i) {
	            if (_geoJsons[i].name === name) {
	                _geoJsons[i].data = json;
	                _geoJsons[i].keyAccessor = keyAccessor;
	                return _chart;
	            }
	        }
	        _geoJsons.push({name: name, data: json, keyAccessor: keyAccessor});
	        return _chart;
	    };
	
	    /**
	     * Set custom geo projection function. See the available
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Geo-Projections.md d3 geo projection functions}.
	     * @method projection
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Geo-Projections.md d3.geo.projection}
	     * @see {@link https://github.com/d3/d3-geo-projection Extended d3.geo.projection}
	     * @param {d3.projection} [projection=d3.geo.albersUsa()]
	     * @returns {dc.geoChoroplethChart}
	     */
	    _chart.projection = function (projection) {
	        _geoPath.projection(projection);
	        _projectionFlag = true;
	        return _chart;
	    };
	
	    /**
	     * Returns all GeoJson layers currently registered with this chart. The returned array is a
	     * reference to this chart's internal data structure, so any modification to this array will also
	     * modify this chart's internal registration.
	     * @method geoJsons
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @returns {Array<{name:String, data: Object, accessor: Function}>}
	     */
	    _chart.geoJsons = function () {
	        return _geoJsons;
	    };
	
	    /**
	     * Returns the {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Geo-Paths.md#path d3.geo.path} object used to
	     * render the projection and features.  Can be useful for figuring out the bounding box of the
	     * feature set and thus a way to calculate scale and translation for the projection.
	     * @method geoPath
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Geo-Paths.md#path d3.geo.path}
	     * @returns {d3.geo.path}
	     */
	    _chart.geoPath = function () {
	        return _geoPath;
	    };
	
	    /**
	     * Remove a GeoJson layer from this chart by name
	     * @method removeGeoJson
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @param {String} name
	     * @returns {dc.geoChoroplethChart}
	     */
	    _chart.removeGeoJson = function (name) {
	        var geoJsons = [];
	
	        for (var i = 0; i < _geoJsons.length; ++i) {
	            var layer = _geoJsons[i];
	            if (layer.name !== name) {
	                geoJsons.push(layer);
	            }
	        }
	
	        _geoJsons = geoJsons;
	
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * The bubble overlay chart is quite different from the typical bubble chart. With the bubble overlay
	 * chart you can arbitrarily place bubbles on an existing svg or bitmap image, thus changing the
	 * typical x and y positioning while retaining the capability to visualize data using bubble radius
	 * and coloring.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/crime/index.html Canadian City Crime Stats}
	 * @class bubbleOverlay
	 * @memberof dc
	 * @mixes dc.bubbleMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a bubble overlay chart on top of the '#chart-container1 svg' element using the default global chart group
	 * var bubbleChart1 = dc.bubbleOverlayChart('#chart-container1').svg(d3.select('#chart-container1 svg'));
	 * // create a bubble overlay chart on top of the '#chart-container2 svg' element using chart group A
	 * var bubbleChart2 = dc.compositeChart('#chart-container2', 'chartGroupA').svg(d3.select('#chart-container2 svg'));
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.bubbleOverlay}
	 */
	dc.bubbleOverlay = function (parent, chartGroup) {
	    var BUBBLE_OVERLAY_CLASS = 'bubble-overlay';
	    var BUBBLE_NODE_CLASS = 'node';
	    var BUBBLE_CLASS = 'bubble';
	
	    /**
	     * **mandatory**
	     *
	     * Set the underlying svg image element. Unlike other dc charts this chart will not generate a svg
	     * element; therefore the bubble overlay chart will not work if this function is not invoked. If the
	     * underlying image is a bitmap, then an empty svg will need to be created on top of the image.
	     * @method svg
	     * @memberof dc.bubbleOverlay
	     * @instance
	     * @example
	     * // set up underlying svg element
	     * chart.svg(d3.select('#chart svg'));
	     * @param {SVGElement|d3.selection} [imageElement]
	     * @returns {dc.bubbleOverlay}
	     */
	    var _chart = dc.bubbleMixin(dc.baseMixin({}));
	    var _g;
	    var _points = [];
	
	    _chart.transitionDuration(750);
	
	    _chart.transitionDelay(0);
	
	    _chart.radiusValueAccessor(function (d) {
	        return d.value;
	    });
	
	    /**
	     * **mandatory**
	     *
	     * Set up a data point on the overlay. The name of a data point should match a specific 'key' among
	     * data groups generated using keyAccessor.  If a match is found (point name <-> data group key)
	     * then a bubble will be generated at the position specified by the function. x and y
	     * value specified here are relative to the underlying svg.
	     * @method point
	     * @memberof dc.bubbleOverlay
	     * @instance
	     * @param {String} name
	     * @param {Number} x
	     * @param {Number} y
	     * @returns {dc.bubbleOverlay}
	     */
	    _chart.point = function (name, x, y) {
	        _points.push({name: name, x: x, y: y});
	        return _chart;
	    };
	
	    _chart._doRender = function () {
	        _g = initOverlayG();
	
	        _chart.r().range([_chart.MIN_RADIUS, _chart.width() * _chart.maxBubbleRelativeSize()]);
	
	        initializeBubbles();
	
	        _chart.fadeDeselectedArea();
	
	        return _chart;
	    };
	
	    function initOverlayG () {
	        _g = _chart.select('g.' + BUBBLE_OVERLAY_CLASS);
	        if (_g.empty()) {
	            _g = _chart.svg().append('g').attr('class', BUBBLE_OVERLAY_CLASS);
	        }
	        return _g;
	    }
	
	    function initializeBubbles () {
	        var data = mapData();
	        _chart.calculateRadiusDomain();
	
	        _points.forEach(function (point) {
	            var nodeG = getNodeG(point, data);
	
	            var circle = nodeG.select('circle.' + BUBBLE_CLASS);
	
	            if (circle.empty()) {
	                circle = nodeG.append('circle')
	                    .attr('class', BUBBLE_CLASS)
	                    .attr('r', 0)
	                    .attr('fill', _chart.getColor)
	                    .on('click', _chart.onClick);
	            }
	
	            dc.transition(circle, _chart.transitionDuration(), _chart.transitionDelay())
	                .attr('r', function (d) {
	                    return _chart.bubbleR(d);
	                });
	
	            _chart._doRenderLabel(nodeG);
	
	            _chart._doRenderTitles(nodeG);
	        });
	    }
	
	    function mapData () {
	        var data = {};
	        _chart.data().forEach(function (datum) {
	            data[_chart.keyAccessor()(datum)] = datum;
	        });
	        return data;
	    }
	
	    function getNodeG (point, data) {
	        var bubbleNodeClass = BUBBLE_NODE_CLASS + ' ' + dc.utils.nameToId(point.name);
	
	        var nodeG = _g.select('g.' + dc.utils.nameToId(point.name));
	
	        if (nodeG.empty()) {
	            nodeG = _g.append('g')
	                .attr('class', bubbleNodeClass)
	                .attr('transform', 'translate(' + point.x + ',' + point.y + ')');
	        }
	
	        nodeG.datum(data[point.name]);
	
	        return nodeG;
	    }
	
	    _chart._doRedraw = function () {
	        updateBubbles();
	
	        _chart.fadeDeselectedArea();
	
	        return _chart;
	    };
	
	    function updateBubbles () {
	        var data = mapData();
	        _chart.calculateRadiusDomain();
	
	        _points.forEach(function (point) {
	            var nodeG = getNodeG(point, data);
	
	            var circle = nodeG.select('circle.' + BUBBLE_CLASS);
	
	            dc.transition(circle, _chart.transitionDuration(), _chart.transitionDelay())
	                .attr('r', function (d) {
	                    return _chart.bubbleR(d);
	                })
	                .attr('fill', _chart.getColor);
	
	            _chart.doUpdateLabels(nodeG);
	
	            _chart.doUpdateTitles(nodeG);
	        });
	    }
	
	    _chart.debug = function (flag) {
	        if (flag) {
	            var debugG = _chart.select('g.' + dc.constants.DEBUG_GROUP_CLASS);
	
	            if (debugG.empty()) {
	                debugG = _chart.svg()
	                    .append('g')
	                    .attr('class', dc.constants.DEBUG_GROUP_CLASS);
	            }
	
	            var debugText = debugG.append('text')
	                .attr('x', 10)
	                .attr('y', 20);
	
	            debugG
	                .append('rect')
	                .attr('width', _chart.width())
	                .attr('height', _chart.height())
	                .on('mousemove', function () {
	                    var position = d3.mouse(debugG.node());
	                    var msg = position[0] + ', ' + position[1];
	                    debugText.text(msg);
	                });
	        } else {
	            _chart.selectAll('.debug').remove();
	        }
	
	        return _chart;
	    };
	
	    _chart.anchor(parent, chartGroup);
	
	    return _chart;
	};
	
	/**
	 * Concrete row chart implementation.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * @class rowChart
	 * @memberof dc
	 * @mixes dc.capMixin
	 * @mixes dc.marginMixin
	 * @mixes dc.colorMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a row chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.rowChart('#chart-container1');
	 * // create a row chart under #chart-container2 element using chart group A
	 * var chart2 = dc.rowChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.rowChart}
	 */
	dc.rowChart = function (parent, chartGroup) {
	
	    var _g;
	
	    var _labelOffsetX = 10;
	    var _labelOffsetY = 15;
	    var _hasLabelOffsetY = false;
	    var _dyOffset = '0.35em';  // this helps center labels https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#svg_text
	    var _titleLabelOffsetX = 2;
	
	    var _gap = 5;
	
	    var _fixedBarHeight = false;
	    var _rowCssClass = 'row';
	    var _titleRowCssClass = 'titlerow';
	    var _renderTitleLabel = false;
	
	    var _chart = dc.capMixin(dc.marginMixin(dc.colorMixin(dc.baseMixin({}))));
	
	    var _x;
	
	    var _elasticX;
	
	    var _xAxis = d3.svg.axis().orient('bottom');
	
	    var _rowData;
	
	    _chart.rowsCap = _chart.cap;
	
	    function calculateAxisScale () {
	        if (!_x || _elasticX) {
	            var extent = d3.extent(_rowData, _chart.cappedValueAccessor);
	            if (extent[0] > 0) {
	                extent[0] = 0;
	            }
	            if (extent[1] < 0) {
	                extent[1] = 0;
	            }
	            _x = d3.scale.linear().domain(extent)
	                .range([0, _chart.effectiveWidth()]);
	        }
	        _xAxis.scale(_x);
	    }
	
	    function drawAxis () {
	        var axisG = _g.select('g.axis');
	
	        calculateAxisScale();
	
	        if (axisG.empty()) {
	            axisG = _g.append('g').attr('class', 'axis');
	        }
	        axisG.attr('transform', 'translate(0, ' + _chart.effectiveHeight() + ')');
	
	        dc.transition(axisG, _chart.transitionDuration(), _chart.transitionDelay())
	            .call(_xAxis);
	    }
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _g = _chart.svg()
	            .append('g')
	            .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	
	        drawChart();
	
	        return _chart;
	    };
	
	    _chart.title(function (d) {
	        return _chart.cappedKeyAccessor(d) + ': ' + _chart.cappedValueAccessor(d);
	    });
	
	    _chart.label(_chart.cappedKeyAccessor);
	
	    /**
	     * Gets or sets the x scale. The x scale can be any d3
	     * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Quantitative-Scales.md quantitive scale}.
	     * @method x
	     * @memberof dc.rowChart
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Quantitative-Scales.md quantitive scale}
	     * @param {d3.scale} [scale]
	     * @returns {d3.scale|dc.rowChart}
	     */
	    _chart.x = function (scale) {
	        if (!arguments.length) {
	            return _x;
	        }
	        _x = scale;
	        return _chart;
	    };
	
	    function drawGridLines () {
	        _g.selectAll('g.tick')
	            .select('line.grid-line')
	            .remove();
	
	        _g.selectAll('g.tick')
	            .append('line')
	            .attr('class', 'grid-line')
	            .attr('x1', 0)
	            .attr('y1', 0)
	            .attr('x2', 0)
	            .attr('y2', function () {
	                return -_chart.effectiveHeight();
	            });
	    }
	
	    function drawChart () {
	        _rowData = _chart.data();
	
	        drawAxis();
	        drawGridLines();
	
	        var rows = _g.selectAll('g.' + _rowCssClass)
	            .data(_rowData);
	
	        createElements(rows);
	        removeElements(rows);
	        updateElements(rows);
	    }
	
	    function createElements (rows) {
	        var rowEnter = rows.enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return _rowCssClass + ' _' + i;
	            });
	
	        rowEnter.append('rect').attr('width', 0);
	
	        createLabels(rowEnter);
	    }
	
	    function removeElements (rows) {
	        rows.exit().remove();
	    }
	
	    function rootValue () {
	        var root = _x(0);
	        return (root === -Infinity || root !== root) ? _x(1) : root;
	    }
	
	    function updateElements (rows) {
	        var n = _rowData.length;
	
	        var height;
	        if (!_fixedBarHeight) {
	            height = (_chart.effectiveHeight() - (n + 1) * _gap) / n;
	        } else {
	            height = _fixedBarHeight;
	        }
	
	        // vertically align label in center unless they override the value via property setter
	        if (!_hasLabelOffsetY) {
	            _labelOffsetY = height / 2;
	        }
	
	        var rect = rows.attr('transform', function (d, i) {
	                return 'translate(0,' + ((i + 1) * _gap + i * height) + ')';
	            }).select('rect')
	            .attr('height', height)
	            .attr('fill', _chart.getColor)
	            .on('click', onClick)
	            .classed('deselected', function (d) {
	                return (_chart.hasFilter()) ? !isSelectedRow(d) : false;
	            })
	            .classed('selected', function (d) {
	                return (_chart.hasFilter()) ? isSelectedRow(d) : false;
	            });
	
	        dc.transition(rect, _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('width', function (d) {
	                return Math.abs(rootValue() - _x(_chart.valueAccessor()(d)));
	            })
	            .attr('transform', translateX);
	
	        createTitles(rows);
	        updateLabels(rows);
	    }
	
	    function createTitles (rows) {
	        if (_chart.renderTitle()) {
	            rows.select('title').remove();
	            rows.append('title').text(_chart.title());
	        }
	    }
	
	    function createLabels (rowEnter) {
	        if (_chart.renderLabel()) {
	            rowEnter.append('text')
	                .on('click', onClick);
	        }
	        if (_chart.renderTitleLabel()) {
	            rowEnter.append('text')
	                .attr('class', _titleRowCssClass)
	                .on('click', onClick);
	        }
	    }
	
	    function updateLabels (rows) {
	        if (_chart.renderLabel()) {
	            var lab = rows.select('text')
	                .attr('x', _labelOffsetX)
	                .attr('y', _labelOffsetY)
	                .attr('dy', _dyOffset)
	                .on('click', onClick)
	                .attr('class', function (d, i) {
	                    return _rowCssClass + ' _' + i;
	                })
	                .text(function (d) {
	                    return _chart.label()(d);
	                });
	            dc.transition(lab, _chart.transitionDuration(), _chart.transitionDelay())
	                .attr('transform', translateX);
	        }
	        if (_chart.renderTitleLabel()) {
	            var titlelab = rows.select('.' + _titleRowCssClass)
	                    .attr('x', _chart.effectiveWidth() - _titleLabelOffsetX)
	                    .attr('y', _labelOffsetY)
	                    .attr('dy', _dyOffset)
	                    .attr('text-anchor', 'end')
	                    .on('click', onClick)
	                    .attr('class', function (d, i) {
	                        return _titleRowCssClass + ' _' + i ;
	                    })
	                    .text(function (d) {
	                        return _chart.title()(d);
	                    });
	            dc.transition(titlelab, _chart.transitionDuration(), _chart.transitionDelay())
	                .attr('transform', translateX);
	        }
	    }
	
	    /**
	     * Turn on/off Title label rendering (values) using SVG style of text-anchor 'end'.
	     * @method renderTitleLabel
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Boolean} [renderTitleLabel=false]
	     * @returns {Boolean|dc.rowChart}
	     */
	    _chart.renderTitleLabel = function (renderTitleLabel) {
	        if (!arguments.length) {
	            return _renderTitleLabel;
	        }
	        _renderTitleLabel = renderTitleLabel;
	        return _chart;
	    };
	
	    function onClick (d) {
	        _chart.onClick(d);
	    }
	
	    function translateX (d) {
	        var x = _x(_chart.cappedValueAccessor(d)),
	            x0 = rootValue(),
	            s = x > x0 ? x0 : x;
	        return 'translate(' + s + ',0)';
	    }
	
	    _chart._doRedraw = function () {
	        drawChart();
	        return _chart;
	    };
	
	    /**
	     * Get the x axis for the row chart instance.  Note: not settable for row charts.
	     * See the {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Axes.md#axis d3 axis object}
	     * documention for more information.
	     * @method xAxis
	     * @memberof dc.rowChart
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Axes.md#axis d3.svg.axis}
	     * @example
	     * // customize x axis tick format
	     * chart.xAxis().tickFormat(function (v) {return v + '%';});
	     * // customize x axis tick values
	     * chart.xAxis().tickValues([0, 100, 200, 300]);
	     * @returns {d3.svg.axis}
	     */
	    _chart.xAxis = function () {
	        return _xAxis;
	    };
	
	    /**
	     * Get or set the fixed bar height. Default is [false] which will auto-scale bars.
	     * For example, if you want to fix the height for a specific number of bars (useful in TopN charts)
	     * you could fix height as follows (where count = total number of bars in your TopN and gap is
	     * your vertical gap space).
	     * @method fixedBarHeight
	     * @memberof dc.rowChart
	     * @instance
	     * @example
	     * chart.fixedBarHeight( chartheight - (count + 1) * gap / count);
	     * @param {Boolean|Number} [fixedBarHeight=false]
	     * @returns {Boolean|Number|dc.rowChart}
	     */
	    _chart.fixedBarHeight = function (fixedBarHeight) {
	        if (!arguments.length) {
	            return _fixedBarHeight;
	        }
	        _fixedBarHeight = fixedBarHeight;
	        return _chart;
	    };
	
	    /**
	     * Get or set the vertical gap space between rows on a particular row chart instance.
	     * @method gap
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [gap=5]
	     * @returns {Number|dc.rowChart}
	     */
	    _chart.gap = function (gap) {
	        if (!arguments.length) {
	            return _gap;
	        }
	        _gap = gap;
	        return _chart;
	    };
	
	    /**
	     * Get or set the elasticity on x axis. If this attribute is set to true, then the x axis will rescle to auto-fit the
	     * data range when filtered.
	     * @method elasticX
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Boolean} [elasticX]
	     * @returns {Boolean|dc.rowChart}
	     */
	    _chart.elasticX = function (elasticX) {
	        if (!arguments.length) {
	            return _elasticX;
	        }
	        _elasticX = elasticX;
	        return _chart;
	    };
	
	    /**
	     * Get or set the x offset (horizontal space to the top left corner of a row) for labels on a particular row chart.
	     * @method labelOffsetX
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [labelOffsetX=10]
	     * @returns {Number|dc.rowChart}
	     */
	    _chart.labelOffsetX = function (labelOffsetX) {
	        if (!arguments.length) {
	            return _labelOffsetX;
	        }
	        _labelOffsetX = labelOffsetX;
	        return _chart;
	    };
	
	    /**
	     * Get or set the y offset (vertical space to the top left corner of a row) for labels on a particular row chart.
	     * @method labelOffsetY
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [labelOffsety=15]
	     * @returns {Number|dc.rowChart}
	     */
	    _chart.labelOffsetY = function (labelOffsety) {
	        if (!arguments.length) {
	            return _labelOffsetY;
	        }
	        _labelOffsetY = labelOffsety;
	        _hasLabelOffsetY = true;
	        return _chart;
	    };
	
	    /**
	     * Get of set the x offset (horizontal space between right edge of row and right edge or text.
	     * @method titleLabelOffsetX
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [titleLabelOffsetX=2]
	     * @returns {Number|dc.rowChart}
	     */
	    _chart.titleLabelOffsetX = function (titleLabelOffsetX) {
	        if (!arguments.length) {
	            return _titleLabelOffsetX;
	        }
	        _titleLabelOffsetX = titleLabelOffsetX;
	        return _chart;
	    };
	
	    function isSelectedRow (d) {
	        return _chart.hasFilter(_chart.cappedKeyAccessor(d));
	    }
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Legend is a attachable widget that can be added to other dc charts to render horizontal legend
	 * labels.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * - {@link http://dc-js.github.com/dc.js/crime/index.html Canadian City Crime Stats}
	 * @class legend
	 * @memberof dc
	 * @example
	 * chart.legend(dc.legend().x(400).y(10).itemHeight(13).gap(5))
	 * @returns {dc.legend}
	 */
	dc.legend = function () {
	    var LABEL_GAP = 2;
	
	    var _legend = {},
	        _parent,
	        _x = 0,
	        _y = 0,
	        _itemHeight = 12,
	        _gap = 5,
	        _horizontal = false,
	        _legendWidth = 560,
	        _itemWidth = 70,
	        _autoItemWidth = false,
	        _legendText = dc.pluck('name'),
	        _maxItems;
	
	    var _g;
	
	    _legend.parent = function (p) {
	        if (!arguments.length) {
	            return _parent;
	        }
	        _parent = p;
	        return _legend;
	    };
	
	    _legend.render = function () {
	        _parent.svg().select('g.dc-legend').remove();
	        _g = _parent.svg().append('g')
	            .attr('class', 'dc-legend')
	            .attr('transform', 'translate(' + _x + ',' + _y + ')');
	        var legendables = _parent.legendables();
	
	        if (_maxItems !== undefined) {
	            legendables = legendables.slice(0, _maxItems);
	        }
	
	        var itemEnter = _g.selectAll('g.dc-legend-item')
	            .data(legendables)
	            .enter()
	            .append('g')
	            .attr('class', 'dc-legend-item')
	            .on('mouseover', function (d) {
	                _parent.legendHighlight(d);
	            })
	            .on('mouseout', function (d) {
	                _parent.legendReset(d);
	            })
	            .on('click', function (d) {
	                d.chart.legendToggle(d);
	            });
	
	        _g.selectAll('g.dc-legend-item')
	            .classed('fadeout', function (d) {
	                return d.chart.isLegendableHidden(d);
	            });
	
	        if (legendables.some(dc.pluck('dashstyle'))) {
	            itemEnter
	                .append('line')
	                .attr('x1', 0)
	                .attr('y1', _itemHeight / 2)
	                .attr('x2', _itemHeight)
	                .attr('y2', _itemHeight / 2)
	                .attr('stroke-width', 2)
	                .attr('stroke-dasharray', dc.pluck('dashstyle'))
	                .attr('stroke', dc.pluck('color'));
	        } else {
	            itemEnter
	                .append('rect')
	                .attr('width', _itemHeight)
	                .attr('height', _itemHeight)
	                .attr('fill', function (d) {return d ? d.color : 'blue';});
	        }
	
	        itemEnter.append('text')
	                .text(_legendText)
	                .attr('x', _itemHeight + LABEL_GAP)
	                .attr('y', function () {
	                    return _itemHeight / 2 + (this.clientHeight ? this.clientHeight : 13) / 2 - 2;
	                });
	
	        var _cumulativeLegendTextWidth = 0;
	        var row = 0;
	        itemEnter.attr('transform', function (d, i) {
	            if (_horizontal) {
	                var itemWidth   = _autoItemWidth === true ? this.getBBox().width + _gap : _itemWidth;
	                if ((_cumulativeLegendTextWidth + itemWidth) > _legendWidth && _cumulativeLegendTextWidth > 0) {
	                    ++row;
	                    _cumulativeLegendTextWidth = 0;
	                }
	                var translateBy = 'translate(' + _cumulativeLegendTextWidth + ',' + row * legendItemHeight() + ')';
	                _cumulativeLegendTextWidth += itemWidth;
	                return translateBy;
	            } else {
	                return 'translate(0,' + i * legendItemHeight() + ')';
	            }
	        });
	    };
	
	    function legendItemHeight () {
	        return _gap + _itemHeight;
	    }
	
	    /**
	     * Set or get x coordinate for legend widget.
	     * @method x
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [x=0]
	     * @returns {Number|dc.legend}
	     */
	    _legend.x = function (x) {
	        if (!arguments.length) {
	            return _x;
	        }
	        _x = x;
	        return _legend;
	    };
	
	    /**
	     * Set or get y coordinate for legend widget.
	     * @method y
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [y=0]
	     * @returns {Number|dc.legend}
	     */
	    _legend.y = function (y) {
	        if (!arguments.length) {
	            return _y;
	        }
	        _y = y;
	        return _legend;
	    };
	
	    /**
	     * Set or get gap between legend items.
	     * @method gap
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [gap=5]
	     * @returns {Number|dc.legend}
	     */
	    _legend.gap = function (gap) {
	        if (!arguments.length) {
	            return _gap;
	        }
	        _gap = gap;
	        return _legend;
	    };
	
	    /**
	     * Set or get legend item height.
	     * @method itemHeight
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [itemHeight=12]
	     * @returns {Number|dc.legend}
	     */
	    _legend.itemHeight = function (itemHeight) {
	        if (!arguments.length) {
	            return _itemHeight;
	        }
	        _itemHeight = itemHeight;
	        return _legend;
	    };
	
	    /**
	     * Position legend horizontally instead of vertically.
	     * @method horizontal
	     * @memberof dc.legend
	     * @instance
	     * @param  {Boolean} [horizontal=false]
	     * @returns {Boolean|dc.legend}
	     */
	    _legend.horizontal = function (horizontal) {
	        if (!arguments.length) {
	            return _horizontal;
	        }
	        _horizontal = horizontal;
	        return _legend;
	    };
	
	    /**
	     * Maximum width for horizontal legend.
	     * @method legendWidth
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [legendWidth=500]
	     * @returns {Number|dc.legend}
	     */
	    _legend.legendWidth = function (legendWidth) {
	        if (!arguments.length) {
	            return _legendWidth;
	        }
	        _legendWidth = legendWidth;
	        return _legend;
	    };
	
	    /**
	     * Legend item width for horizontal legend.
	     * @method itemWidth
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [itemWidth=70]
	     * @returns {Number|dc.legend}
	     */
	    _legend.itemWidth = function (itemWidth) {
	        if (!arguments.length) {
	            return _itemWidth;
	        }
	        _itemWidth = itemWidth;
	        return _legend;
	    };
	
	    /**
	     * Turn automatic width for legend items on or off. If true, {@link dc.legend#itemWidth itemWidth} is ignored.
	     * This setting takes into account the {@link dc.legend#gap gap}.
	     * @method autoItemWidth
	     * @memberof dc.legend
	     * @instance
	     * @param  {Boolean} [autoItemWidth=false]
	     * @returns {Boolean|dc.legend}
	     */
	    _legend.autoItemWidth = function (autoItemWidth) {
	        if (!arguments.length) {
	            return _autoItemWidth;
	        }
	        _autoItemWidth = autoItemWidth;
	        return _legend;
	    };
	
	    /**
	     * Set or get the legend text function. The legend widget uses this function to render the legend
	     * text for each item. If no function is specified the legend widget will display the names
	     * associated with each group.
	     * @method legendText
	     * @memberof dc.legend
	     * @instance
	     * @param  {Function} [legendText]
	     * @returns {Function|dc.legend}
	     * @example
	     * // default legendText
	     * legend.legendText(dc.pluck('name'))
	     *
	     * // create numbered legend items
	     * chart.legend(dc.legend().legendText(function(d, i) { return i + '. ' + d.name; }))
	     *
	     * // create legend displaying group counts
	     * chart.legend(dc.legend().legendText(function(d) { return d.name + ': ' d.data; }))
	     **/
	    _legend.legendText = function (legendText) {
	        if (!arguments.length) {
	            return _legendText;
	        }
	        _legendText = legendText;
	        return _legend;
	    };
	
	    /**
	     * Maximum number of legend items to display
	     * @method maxItems
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [maxItems]
	     * @return {dc.legend}
	     */
	    _legend.maxItems = function (maxItems) {
	        if (!arguments.length) {
	            return _maxItems;
	        }
	        _maxItems = dc.utils.isNumber(maxItems) ? maxItems : undefined;
	        return _legend;
	    };
	
	    return _legend;
	};
	
	/**
	 * A scatter plot chart
	 *
	 * Examples:
	 * - {@link http://dc-js.github.io/dc.js/examples/scatter.html Scatter Chart}
	 * - {@link http://dc-js.github.io/dc.js/examples/multi-scatter.html Multi-Scatter Chart}
	 * @class scatterPlot
	 * @memberof dc
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a scatter plot under #chart-container1 element using the default global chart group
	 * var chart1 = dc.scatterPlot('#chart-container1');
	 * // create a scatter plot under #chart-container2 element using chart group A
	 * var chart2 = dc.scatterPlot('#chart-container2', 'chartGroupA');
	 * // create a sub-chart under a composite parent chart
	 * var chart3 = dc.scatterPlot(compositeChart);
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.scatterPlot}
	 */
	dc.scatterPlot = function (parent, chartGroup) {
	    var _chart = dc.coordinateGridMixin({});
	    var _symbol = d3.svg.symbol();
	
	    var _existenceAccessor = function (d) { return d.value; };
	
	    var originalKeyAccessor = _chart.keyAccessor();
	    _chart.keyAccessor(function (d) { return originalKeyAccessor(d)[0]; });
	    _chart.valueAccessor(function (d) { return originalKeyAccessor(d)[1]; });
	    _chart.colorAccessor(function () { return _chart._groupName; });
	
	    _chart.title(function (d) {
	        // this basically just counteracts the setting of its own key/value accessors
	        // see https://github.com/dc-js/dc.js/issues/702
	        return _chart.keyAccessor()(d) + ',' + _chart.valueAccessor()(d) + ': ' +
	            _chart.existenceAccessor()(d);
	    });
	
	    var _locator = function (d) {
	        return 'translate(' + _chart.x()(_chart.keyAccessor()(d)) + ',' +
	                              _chart.y()(_chart.valueAccessor()(d)) + ')';
	    };
	
	    var _highlightedSize = 7;
	    var _symbolSize = 5;
	    var _excludedSize = 3;
	    var _excludedColor = null;
	    var _excludedOpacity = 1.0;
	    var _emptySize = 0;
	    var _emptyOpacity = 0;
	    var _nonemptyOpacity = 1;
	    var _emptyColor = null;
	    var _filtered = [];
	
	    _symbol.size(function (d, i) {
	        if (!_existenceAccessor(d)) {
	            return Math.pow(_emptySize, 2);
	        } else if (_filtered[i]) {
	            return Math.pow(_symbolSize, 2);
	        } else {
	            return Math.pow(_excludedSize, 2);
	        }
	    });
	
	    dc.override(_chart, '_filter', function (filter) {
	        if (!arguments.length) {
	            return _chart.__filter();
	        }
	
	        return _chart.__filter(dc.filters.RangedTwoDimensionalFilter(filter));
	    });
	
	    _chart.plotData = function () {
	        var symbols = _chart.chartBodyG().selectAll('path.symbol')
	            .data(_chart.data());
	
	        symbols
	            .enter()
	        .append('path')
	            .attr('class', 'symbol')
	            .attr('opacity', 0)
	            .attr('fill', _chart.getColor)
	            .attr('transform', _locator);
	
	        symbols.call(renderTitles, _chart.data());
	
	        symbols.each(function (d, i) {
	            _filtered[i] = !_chart.filter() || _chart.filter().isFiltered([d.key[0], d.key[1]]);
	        });
	
	        dc.transition(symbols, _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('opacity', function (d, i) {
	                if (!_existenceAccessor(d)) {
	                    return _emptyOpacity;
	                } else if (_filtered[i]) {
	                    return _nonemptyOpacity;
	                } else {
	                    return _chart.excludedOpacity();
	                }
	            })
	            .attr('fill', function (d, i) {
	                if (_emptyColor && !_existenceAccessor(d)) {
	                    return _emptyColor;
	                } else if (_chart.excludedColor() && !_filtered[i]) {
	                    return _chart.excludedColor();
	                } else {
	                    return _chart.getColor(d);
	                }
	            })
	            .attr('transform', _locator)
	            .attr('d', _symbol);
	
	        dc.transition(symbols.exit(), _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('opacity', 0).remove();
	    };
	
	    function renderTitles (symbol, d) {
	        if (_chart.renderTitle()) {
	            symbol.selectAll('title').remove();
	            symbol.append('title').text(function (d) {
	                return _chart.title()(d);
	            });
	        }
	    }
	
	    /**
	     * Get or set the existence accessor.  If a point exists, it is drawn with
	     * {@link dc.scatterPlot#symbolSize symbolSize} radius and
	     * opacity 1; if it does not exist, it is drawn with
	     * {@link dc.scatterPlot#emptySize emptySize} radius and opacity 0. By default,
	     * the existence accessor checks if the reduced value is truthy.
	     * @method existenceAccessor
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link dc.scatterPlot#symbolSize symbolSize}
	     * @see {@link dc.scatterPlot#emptySize emptySize}
	     * @example
	     * // default accessor
	     * chart.existenceAccessor(function (d) { return d.value; });
	     * @param {Function} [accessor]
	     * @returns {Function|dc.scatterPlot}
	     */
	    _chart.existenceAccessor = function (accessor) {
	        if (!arguments.length) {
	            return _existenceAccessor;
	        }
	        _existenceAccessor = accessor;
	        return this;
	    };
	
	    /**
	     * Get or set the symbol type used for each point. By default the symbol is a circle.
	     * Type can be a constant or an accessor.
	     * @method symbol
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#symbol_type d3.svg.symbol.type}
	     * @example
	     * // Circle type
	     * chart.symbol('circle');
	     * // Square type
	     * chart.symbol('square');
	     * @param {String|Function} [type='circle']
	     * @returns {String|Function|dc.scatterPlot}
	     */
	    _chart.symbol = function (type) {
	        if (!arguments.length) {
	            return _symbol.type();
	        }
	        _symbol.type(type);
	        return _chart;
	    };
	
	    /**
	     * Set or get radius for symbols.
	     * @method symbolSize
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#symbol_size d3.svg.symbol.size}
	     * @param {Number} [symbolSize=3]
	     * @returns {Number|dc.scatterPlot}
	     */
	    _chart.symbolSize = function (symbolSize) {
	        if (!arguments.length) {
	            return _symbolSize;
	        }
	        _symbolSize = symbolSize;
	        return _chart;
	    };
	
	    /**
	     * Set or get radius for highlighted symbols.
	     * @method highlightedSize
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#symbol_size d3.svg.symbol.size}
	     * @param {Number} [highlightedSize=5]
	     * @returns {Number|dc.scatterPlot}
	     */
	    _chart.highlightedSize = function (highlightedSize) {
	        if (!arguments.length) {
	            return _highlightedSize;
	        }
	        _highlightedSize = highlightedSize;
	        return _chart;
	    };
	
	    /**
	     * Set or get size for symbols excluded from this chart's filter. If null, no
	     * special size is applied for symbols based on their filter status.
	     * @method excludedSize
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#symbol_size d3.svg.symbol.size}
	     * @param {Number} [excludedSize=null]
	     * @returns {Number|dc.scatterPlot}
	     */
	    _chart.excludedSize = function (excludedSize) {
	        if (!arguments.length) {
	            return _excludedSize;
	        }
	        _excludedSize = excludedSize;
	        return _chart;
	    };
	
	    /**
	     * Set or get color for symbols excluded from this chart's filter. If null, no
	     * special color is applied for symbols based on their filter status.
	     * @method excludedColor
	     * @memberof dc.scatterPlot
	     * @instance
	     * @param {Number} [excludedColor=null]
	     * @returns {Number|dc.scatterPlot}
	     */
	    _chart.excludedColor = function (excludedColor) {
	        if (!arguments.length) {
	            return _excludedColor;
	        }
	        _excludedColor = excludedColor;
	        return _chart;
	    };
	
	    /**
	     * Set or get opacity for symbols excluded from this chart's filter.
	     * @method excludedOpacity
	     * @memberof dc.scatterPlot
	     * @instance
	     * @param {Number} [excludedOpacity=1.0]
	     * @returns {Number|dc.scatterPlot}
	     */
	    _chart.excludedOpacity = function (excludedOpacity) {
	        if (!arguments.length) {
	            return _excludedOpacity;
	        }
	        _excludedOpacity = excludedOpacity;
	        return _chart;
	    };
	
	    /**
	     * Set or get radius for symbols when the group is empty.
	     * @method emptySize
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/SVG-Shapes.md#symbol_size d3.svg.symbol.size}
	     * @param {Number} [emptySize=0]
	     * @returns {Number|dc.scatterPlot}
	     */
	    _chart.hiddenSize = _chart.emptySize = function (emptySize) {
	        if (!arguments.length) {
	            return _emptySize;
	        }
	        _emptySize = emptySize;
	        return _chart;
	    };
	
	    /**
	     * Set or get color for symbols when the group is empty. If null, just use the
	     * {@link dc.colorMixin#colors colorMixin.colors} color scale zero value.
	     * @name emptyColor
	     * @memberof dc.scatterPlot
	     * @instance
	     * @param {String} [emptyColor=null]
	     * @return {String}
	     * @return {dc.scatterPlot}/
	     */
	    _chart.emptyColor = function (emptyColor) {
	        if (!arguments.length) {
	            return _emptyColor;
	        }
	        _emptyColor = emptyColor;
	        return _chart;
	    };
	
	    /**
	     * Set or get opacity for symbols when the group is empty.
	     * @name emptyOpacity
	     * @memberof dc.scatterPlot
	     * @instance
	     * @param {Number} [emptyOpacity=0]
	     * @return {Number}
	     * @return {dc.scatterPlot}
	     */
	    _chart.emptyOpacity = function (emptyOpacity) {
	        if (!arguments.length) {
	            return _emptyOpacity;
	        }
	        _emptyOpacity = emptyOpacity;
	        return _chart;
	    };
	
	    /**
	     * Set or get opacity for symbols when the group is not empty.
	     * @name nonemptyOpacity
	     * @memberof dc.scatterPlot
	     * @instance
	     * @param {Number} [nonemptyOpacity=1]
	     * @return {Number}
	     * @return {dc.scatterPlot}
	     */
	    _chart.nonemptyOpacity = function (nonemptyOpacity) {
	        if (!arguments.length) {
	            return _emptyOpacity;
	        }
	        _nonemptyOpacity = nonemptyOpacity;
	        return _chart;
	    };
	
	    _chart.legendables = function () {
	        return [{chart: _chart, name: _chart._groupName, color: _chart.getColor()}];
	    };
	
	    _chart.legendHighlight = function (d) {
	        resizeSymbolsWhere(function (symbol) {
	            return symbol.attr('fill') === d.color;
	        }, _highlightedSize);
	        _chart.selectAll('.chart-body path.symbol').filter(function () {
	            return d3.select(this).attr('fill') !== d.color;
	        }).classed('fadeout', true);
	    };
	
	    _chart.legendReset = function (d) {
	        resizeSymbolsWhere(function (symbol) {
	            return symbol.attr('fill') === d.color;
	        }, _symbolSize);
	        _chart.selectAll('.chart-body path.symbol').filter(function () {
	            return d3.select(this).attr('fill') !== d.color;
	        }).classed('fadeout', false);
	    };
	
	    function resizeSymbolsWhere (condition, size) {
	        var symbols = _chart.selectAll('.chart-body path.symbol').filter(function () {
	            return condition(d3.select(this));
	        });
	        var oldSize = _symbol.size();
	        _symbol.size(Math.pow(size, 2));
	        dc.transition(symbols, _chart.transitionDuration(), _chart.transitionDelay()).attr('d', _symbol);
	        _symbol.size(oldSize);
	    }
	
	    _chart.setHandlePaths = function () {
	        // no handle paths for poly-brushes
	    };
	
	    _chart.extendBrush = function () {
	        var extent = _chart.brush().extent();
	        if (_chart.round()) {
	            extent[0] = extent[0].map(_chart.round());
	            extent[1] = extent[1].map(_chart.round());
	
	            _chart.g().select('.brush')
	                .call(_chart.brush().extent(extent));
	        }
	        return extent;
	    };
	
	    _chart.brushIsEmpty = function (extent) {
	        return _chart.brush().empty() || !extent || extent[0][0] >= extent[1][0] || extent[0][1] >= extent[1][1];
	    };
	
	    _chart._brushing = function () {
	        var extent = _chart.extendBrush();
	
	        _chart.redrawBrush(_chart.g());
	
	        if (_chart.brushIsEmpty(extent)) {
	            dc.events.trigger(function () {
	                _chart.filter(null);
	                _chart.redrawGroup();
	            });
	
	        } else {
	            var ranged2DFilter = dc.filters.RangedTwoDimensionalFilter(extent);
	            dc.events.trigger(function () {
	                _chart.filter(null);
	                _chart.filter(ranged2DFilter);
	                _chart.redrawGroup();
	            }, dc.constants.EVENT_DELAY);
	
	        }
	    };
	
	    _chart.setBrushY = function (gBrush) {
	        gBrush.call(_chart.brush().y(_chart.y()));
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A display of a single numeric value.
	 * Unlike other charts, you do not need to set a dimension. Instead a group object must be provided and
	 * a valueAccessor that returns a single value.
	 * @class numberDisplay
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @example
	 * // create a number display under #chart-container1 element using the default global chart group
	 * var display1 = dc.numberDisplay('#chart-container1');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.numberDisplay}
	 */
	dc.numberDisplay = function (parent, chartGroup) {
	    var SPAN_CLASS = 'number-display';
	    var _formatNumber = d3.format('.2s');
	    var _chart = dc.baseMixin({});
	    var _html = {one: '', some: '', none: ''};
	    var _lastValue;
	
	    // dimension not required
	    _chart._mandatoryAttributes(['group']);
	
	    // default to ordering by value, to emulate old group.top(1) behavior when multiple groups
	    _chart.ordering(function (kv) { return kv.value; });
	
	    /**
	     * Gets or sets an optional object specifying HTML templates to use depending on the number
	     * displayed.  The text `%number` will be replaced with the current value.
	     * - one: HTML template to use if the number is 1
	     * - zero: HTML template to use if the number is 0
	     * - some: HTML template to use otherwise
	     * @method html
	     * @memberof dc.numberDisplay
	     * @instance
	     * @example
	     * numberWidget.html({
	     *      one:'%number record',
	     *      some:'%number records',
	     *      none:'no records'})
	     * @param {{one:String, some:String, none:String}} [html={one: '', some: '', none: ''}]
	     * @returns {{one:String, some:String, none:String}|dc.numberDisplay}
	     */
	    _chart.html = function (html) {
	        if (!arguments.length) {
	            return _html;
	        }
	        if (html.none) {
	            _html.none = html.none;//if none available
	        } else if (html.one) {
	            _html.none = html.one;//if none not available use one
	        } else if (html.some) {
	            _html.none = html.some;//if none and one not available use some
	        }
	        if (html.one) {
	            _html.one = html.one;//if one available
	        } else if (html.some) {
	            _html.one = html.some;//if one not available use some
	        }
	        if (html.some) {
	            _html.some = html.some;//if some available
	        } else if (html.one) {
	            _html.some = html.one;//if some not available use one
	        }
	        return _chart;
	    };
	
	    /**
	     * Calculate and return the underlying value of the display.
	     * @method value
	     * @memberof dc.numberDisplay
	     * @instance
	     * @returns {Number}
	     */
	    _chart.value = function () {
	        return _chart.data();
	    };
	
	    // probably unnecessary efficiency over computeOrderedGroups sort
	    function maxBin (all) {
	        if (all.length < 1) {
	            return null;
	        }
	        var maxi = 0, max = _chart.ordering()(all[0]);
	        for (var i = 1; i < all.length; ++i) {
	            var v = _chart.ordering()(all[i]);
	            if (v > max) {
	                max = v;
	                maxi = i;
	            }
	        }
	        return all[maxi];
	    }
	    _chart.data(function (group) {
	        var valObj = group.value ? group.value() : maxBin(group.all());
	        return _chart.valueAccessor()(valObj);
	    });
	
	    _chart.transitionDuration(250); // good default
	    _chart.transitionDelay(0);
	
	    _chart._doRender = function () {
	        var newValue = _chart.value(),
	            span = _chart.selectAll('.' + SPAN_CLASS);
	
	        if (span.empty()) {
	            span = span.data([0])
	                .enter()
	                .append('span')
	                .attr('class', SPAN_CLASS);
	        }
	
	        span.transition()
	            .duration(_chart.transitionDuration())
	            .delay(_chart.transitionDelay())
	            .ease('quad-out-in')
	            .tween('text', function () {
	                // [XA] don't try and interpolate from Infinity, else this breaks.
	                var interpStart = isFinite(_lastValue) ? _lastValue : 0;
	                var interp = d3.interpolateNumber(interpStart || 0, newValue);
	                _lastValue = newValue;
	                return function (t) {
	                    var html = null, num = _chart.formatNumber()(interp(t));
	                    if (newValue === 0 && (_html.none !== '')) {
	                        html = _html.none;
	                    } else if (newValue === 1 && (_html.one !== '')) {
	                        html = _html.one;
	                    } else if (_html.some !== '') {
	                        html = _html.some;
	                    }
	                    this.innerHTML = html ? html.replace('%number', num) : num;
	                };
	            });
	    };
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    /**
	     * Get or set a function to format the value for the display.
	     * @method formatNumber
	     * @memberof dc.numberDisplay
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Formatting.md d3.format}
	     * @param {Function} [formatter=d3.format('.2s')]
	     * @returns {Function|dc.numberDisplay}
	     */
	    _chart.formatNumber = function (formatter) {
	        if (!arguments.length) {
	            return _formatNumber;
	        }
	        _formatNumber = formatter;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A heat map is matrix that represents the values of two dimensions of data using colors.
	 * @class heatMap
	 * @memberof dc
	 * @mixes dc.colorMixin
	 * @mixes dc.marginMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a heat map under #chart-container1 element using the default global chart group
	 * var heatMap1 = dc.heatMap('#chart-container1');
	 * // create a heat map under #chart-container2 element using chart group A
	 * var heatMap2 = dc.heatMap('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.heatMap}
	 */
	dc.heatMap = function (parent, chartGroup) {
	
	    var DEFAULT_BORDER_RADIUS = 6.75;
	
	    var _chartBody;
	
	    var _cols;
	    var _rows;
	    var _colOrdering = d3.ascending;
	    var _rowOrdering = d3.ascending;
	    var _colScale = d3.scale.ordinal();
	    var _rowScale = d3.scale.ordinal();
	
	    var _xBorderRadius = DEFAULT_BORDER_RADIUS;
	    var _yBorderRadius = DEFAULT_BORDER_RADIUS;
	
	    var _chart = dc.colorMixin(dc.marginMixin(dc.baseMixin({})));
	    _chart._mandatoryAttributes(['group']);
	    _chart.title(_chart.colorAccessor());
	
	    var _colsLabel = function (d) {
	        return d;
	    };
	    var _rowsLabel = function (d) {
	        return d;
	    };
	
	    /**
	     * Set or get the column label function. The chart class uses this function to render
	     * column labels on the X axis. It is passed the column name.
	     * @method colsLabel
	     * @memberof dc.heatMap
	     * @instance
	     * @example
	     * // the default label function just returns the name
	     * chart.colsLabel(function(d) { return d; });
	     * @param  {Function} [labelFunction=function(d) { return d; }]
	     * @returns {Function|dc.heatMap}
	     */
	    _chart.colsLabel = function (labelFunction) {
	        if (!arguments.length) {
	            return _colsLabel;
	        }
	        _colsLabel = labelFunction;
	        return _chart;
	    };
	
	    /**
	     * Set or get the row label function. The chart class uses this function to render
	     * row labels on the Y axis. It is passed the row name.
	     * @method rowsLabel
	     * @memberof dc.heatMap
	     * @instance
	     * @example
	     * // the default label function just returns the name
	     * chart.rowsLabel(function(d) { return d; });
	     * @param  {Function} [labelFunction=function(d) { return d; }]
	     * @returns {Function|dc.heatMap}
	     */
	    _chart.rowsLabel = function (labelFunction) {
	        if (!arguments.length) {
	            return _rowsLabel;
	        }
	        _rowsLabel = labelFunction;
	        return _chart;
	    };
	
	    var _xAxisOnClick = function (d) { filterAxis(0, d); };
	    var _yAxisOnClick = function (d) { filterAxis(1, d); };
	    var _boxOnClick = function (d) {
	        var filter = d.key;
	        dc.events.trigger(function () {
	            _chart.filter(filter);
	            _chart.redrawGroup();
	        });
	    };
	
	    function filterAxis (axis, value) {
	        var cellsOnAxis = _chart.selectAll('.box-group').filter(function (d) {
	            return d.key[axis] === value;
	        });
	        var unfilteredCellsOnAxis = cellsOnAxis.filter(function (d) {
	            return !_chart.hasFilter(d.key);
	        });
	        dc.events.trigger(function () {
	            var selection = unfilteredCellsOnAxis.empty() ? cellsOnAxis : unfilteredCellsOnAxis;
	            var filters = selection.data().map(function (kv) {
	                return dc.filters.TwoDimensionalFilter(kv.key);
	            });
	            _chart._filter([filters]);
	            _chart.redrawGroup();
	        });
	    }
	
	    dc.override(_chart, 'filter', function (filter) {
	        if (!arguments.length) {
	            return _chart._filter();
	        }
	
	        return _chart._filter(dc.filters.TwoDimensionalFilter(filter));
	    });
	
	    /**
	     * Gets or sets the values used to create the rows of the heatmap, as an array. By default, all
	     * the values will be fetched from the data using the value accessor.
	     * @method rows
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Array<String|Number>} [rows]
	     * @returns {Array<String|Number>|dc.heatMap}
	     */
	
	    _chart.rows = function (rows) {
	        if (!arguments.length) {
	            return _rows;
	        }
	        _rows = rows;
	        return _chart;
	    };
	
	    /**
	     #### .rowOrdering([orderFunction])
	     Get or set an accessor to order the rows.  Default is d3.ascending.
	     */
	    _chart.rowOrdering = function (_) {
	        if (!arguments.length) {
	            return _rowOrdering;
	        }
	        _rowOrdering = _;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the keys used to create the columns of the heatmap, as an array. By default, all
	     * the values will be fetched from the data using the key accessor.
	     * @method cols
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Array<String|Number>} [cols]
	     * @returns {Array<String|Number>|dc.heatMap}
	     */
	    _chart.cols = function (cols) {
	        if (!arguments.length) {
	            return _cols;
	        }
	        _cols = cols;
	        return _chart;
	    };
	
	    /**
	     #### .colOrdering([orderFunction])
	     Get or set an accessor to order the cols.  Default is ascending.
	     */
	    _chart.colOrdering = function (_) {
	        if (!arguments.length) {
	            return _colOrdering;
	        }
	        _colOrdering = _;
	        return _chart;
	    };
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _chartBody = _chart.svg()
	            .append('g')
	            .attr('class', 'heatmap')
	            .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	
	        return _chart._doRedraw();
	    };
	
	    _chart._doRedraw = function () {
	        var data = _chart.data(),
	            rows = _chart.rows() || data.map(_chart.valueAccessor()),
	            cols = _chart.cols() || data.map(_chart.keyAccessor());
	        if (_rowOrdering) {
	            rows = rows.sort(_rowOrdering);
	        }
	        if (_colOrdering) {
	            cols = cols.sort(_colOrdering);
	        }
	        rows = _rowScale.domain(rows);
	        cols = _colScale.domain(cols);
	
	        var rowCount = rows.domain().length,
	            colCount = cols.domain().length,
	            boxWidth = Math.floor(_chart.effectiveWidth() / colCount),
	            boxHeight = Math.floor(_chart.effectiveHeight() / rowCount);
	
	        cols.rangeRoundBands([0, _chart.effectiveWidth()]);
	        rows.rangeRoundBands([_chart.effectiveHeight(), 0]);
	
	        var boxes = _chartBody.selectAll('g.box-group').data(_chart.data(), function (d, i) {
	            return _chart.keyAccessor()(d, i) + '\0' + _chart.valueAccessor()(d, i);
	        });
	        var gEnter = boxes.enter().append('g')
	            .attr('class', 'box-group');
	
	        gEnter.append('rect')
	            .attr('class', 'heat-box')
	            .attr('fill', 'white')
	            .on('click', _chart.boxOnClick());
	
	        if (_chart.renderTitle()) {
	            gEnter.append('title');
	            boxes.select('title').text(_chart.title());
	        }
	
	        dc.transition(boxes.select('rect'), _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('x', function (d, i) { return cols(_chart.keyAccessor()(d, i)); })
	            .attr('y', function (d, i) { return rows(_chart.valueAccessor()(d, i)); })
	            .attr('rx', _xBorderRadius)
	            .attr('ry', _yBorderRadius)
	            .attr('fill', _chart.getColor)
	            .attr('width', boxWidth)
	            .attr('height', boxHeight);
	
	        boxes.exit().remove();
	
	        var gCols = _chartBody.select('g.cols');
	        if (gCols.empty()) {
	            gCols = _chartBody.append('g').attr('class', 'cols axis');
	        }
	        var gColsText = gCols.selectAll('text').data(cols.domain());
	        gColsText.enter().append('text')
	              .attr('x', function (d) { return cols(d) + boxWidth / 2; })
	              .style('text-anchor', 'middle')
	              .attr('y', _chart.effectiveHeight())
	              .attr('dy', 12)
	              .on('click', _chart.xAxisOnClick())
	              .text(_chart.colsLabel());
	        dc.transition(gColsText, _chart.transitionDuration(), _chart.transitionDelay())
	               .text(_chart.colsLabel())
	               .attr('x', function (d) { return cols(d) + boxWidth / 2; })
	               .attr('y', _chart.effectiveHeight());
	        gColsText.exit().remove();
	        var gRows = _chartBody.select('g.rows');
	        if (gRows.empty()) {
	            gRows = _chartBody.append('g').attr('class', 'rows axis');
	        }
	        var gRowsText = gRows.selectAll('text').data(rows.domain());
	        gRowsText.enter().append('text')
	              .attr('dy', 6)
	              .style('text-anchor', 'end')
	              .attr('x', 0)
	              .attr('dx', -2)
	              .on('click', _chart.yAxisOnClick())
	              .text(_chart.rowsLabel());
	        dc.transition(gRowsText, _chart.transitionDuration(), _chart.transitionDelay())
	              .text(_chart.rowsLabel())
	              .attr('y', function (d) { return rows(d) + boxHeight / 2; });
	        gRowsText.exit().remove();
	
	        if (_chart.hasFilter()) {
	            _chart.selectAll('g.box-group').each(function (d) {
	                if (_chart.isSelectedNode(d)) {
	                    _chart.highlightSelected(this);
	                } else {
	                    _chart.fadeDeselected(this);
	                }
	            });
	        } else {
	            _chart.selectAll('g.box-group').each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the handler that fires when an individual cell is clicked in the heatmap.
	     * By default, filtering of the cell will be toggled.
	     * @method boxOnClick
	     * @memberof dc.heatMap
	     * @instance
	     * @example
	     * // default box on click handler
	     * chart.boxOnClick(function (d) {
	     *     var filter = d.key;
	     *     dc.events.trigger(function () {
	     *         _chart.filter(filter);
	     *         _chart.redrawGroup();
	     *     });
	     * });
	     * @param  {Function} [handler]
	     * @returns {Function|dc.heatMap}
	     */
	    _chart.boxOnClick = function (handler) {
	        if (!arguments.length) {
	            return _boxOnClick;
	        }
	        _boxOnClick = handler;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the handler that fires when a column tick is clicked in the x axis.
	     * By default, if any cells in the column are unselected, the whole column will be selected,
	     * otherwise the whole column will be unselected.
	     * @method xAxisOnClick
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Function} [handler]
	     * @returns {Function|dc.heatMap}
	     */
	    _chart.xAxisOnClick = function (handler) {
	        if (!arguments.length) {
	            return _xAxisOnClick;
	        }
	        _xAxisOnClick = handler;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the handler that fires when a row tick is clicked in the y axis.
	     * By default, if any cells in the row are unselected, the whole row will be selected,
	     * otherwise the whole row will be unselected.
	     * @method yAxisOnClick
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Function} [handler]
	     * @returns {Function|dc.heatMap}
	     */
	    _chart.yAxisOnClick = function (handler) {
	        if (!arguments.length) {
	            return _yAxisOnClick;
	        }
	        _yAxisOnClick = handler;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the X border radius.  Set to 0 to get full rectangles.
	     * @method xBorderRadius
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Number} [xBorderRadius=6.75]
	     * @returns {Number|dc.heatMap}
	     */
	    _chart.xBorderRadius = function (xBorderRadius) {
	        if (!arguments.length) {
	            return _xBorderRadius;
	        }
	        _xBorderRadius = xBorderRadius;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the Y border radius.  Set to 0 to get full rectangles.
	     * @method yBorderRadius
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Number} [yBorderRadius=6.75]
	     * @returns {Number|dc.heatMap}
	     */
	    _chart.yBorderRadius = function (yBorderRadius) {
	        if (!arguments.length) {
	            return _yBorderRadius;
	        }
	        _yBorderRadius = yBorderRadius;
	        return _chart;
	    };
	
	    _chart.isSelectedNode = function (d) {
	        return _chart.hasFilter(d.key);
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	// https://github.com/d3/d3-plugins/blob/master/box/box.js
	(function () {
	
	    // Inspired by http://informationandvisualization.de/blog/box-plot
	    d3.box = function () {
	        var width = 1,
	            height = 1,
	            duration = 0,
	            delay = 0,
	            domain = null,
	            value = Number,
	            whiskers = boxWhiskers,
	            quartiles = boxQuartiles,
	            tickFormat = null;
	
	        // For each small multiple…
	        function box (g) {
	            g.each(function (d, i) {
	                d = d.map(value).sort(d3.ascending);
	                var g = d3.select(this),
	                    n = d.length,
	                    min = d[0],
	                    max = d[n - 1];
	
	                // Compute quartiles. Must return exactly 3 elements.
	                var quartileData = d.quartiles = quartiles(d);
	
	                // Compute whiskers. Must return exactly 2 elements, or null.
	                var whiskerIndices = whiskers && whiskers.call(this, d, i),
	                    whiskerData = whiskerIndices && whiskerIndices.map(function (i) { return d[i]; });
	
	                // Compute outliers. If no whiskers are specified, all data are 'outliers'.
	                // We compute the outliers as indices, so that we can join across transitions!
	                var outlierIndices = whiskerIndices ?
	                    d3.range(0, whiskerIndices[0]).concat(d3.range(whiskerIndices[1] + 1, n)) : d3.range(n);
	
	                // Compute the new x-scale.
	                var x1 = d3.scale.linear()
	                    .domain(domain && domain.call(this, d, i) || [min, max])
	                    .range([height, 0]);
	
	                // Retrieve the old x-scale, if this is an update.
	                var x0 = this.__chart__ || d3.scale.linear()
	                    .domain([0, Infinity])
	                    .range(x1.range());
	
	                // Stash the new scale.
	                this.__chart__ = x1;
	
	                // Note: the box, median, and box tick elements are fixed in number,
	                // so we only have to handle enter and update. In contrast, the outliers
	                // and other elements are variable, so we need to exit them! Variable
	                // elements also fade in and out.
	
	                // Update center line: the vertical line spanning the whiskers.
	                var center = g.selectAll('line.center')
	                    .data(whiskerData ? [whiskerData] : []);
	
	                center.enter().insert('line', 'rect')
	                    .attr('class', 'center')
	                    .attr('x1', width / 2)
	                    .attr('y1', function (d) { return x0(d[0]); })
	                    .attr('x2', width / 2)
	                    .attr('y2', function (d) { return x0(d[1]); })
	                    .style('opacity', 1e-6)
	                    .transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .style('opacity', 1)
	                    .attr('y1', function (d) { return x1(d[0]); })
	                    .attr('y2', function (d) { return x1(d[1]); });
	
	                center.transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .style('opacity', 1)
	                    .attr('x1', width / 2)
	                    .attr('x2', width / 2)
	                    .attr('y1', function (d) { return x1(d[0]); })
	                    .attr('y2', function (d) { return x1(d[1]); });
	
	                center.exit().transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .style('opacity', 1e-6)
	                    .attr('y1', function (d) { return x1(d[0]); })
	                    .attr('y2', function (d) { return x1(d[1]); })
	                    .remove();
	
	                // Update innerquartile box.
	                var box = g.selectAll('rect.box')
	                    .data([quartileData]);
	
	                box.enter().append('rect')
	                    .attr('class', 'box')
	                    .attr('x', 0)
	                    .attr('y', function (d) { return x0(d[2]); })
	                    .attr('width', width)
	                    .attr('height', function (d) { return x0(d[0]) - x0(d[2]); })
	                  .transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('y', function (d) { return x1(d[2]); })
	                    .attr('height', function (d) { return x1(d[0]) - x1(d[2]); });
	
	                box.transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('width', width)
	                    .attr('y', function (d) { return x1(d[2]); })
	                    .attr('height', function (d) { return x1(d[0]) - x1(d[2]); });
	
	                // Update median line.
	                var medianLine = g.selectAll('line.median')
	                    .data([quartileData[1]]);
	
	                medianLine.enter().append('line')
	                    .attr('class', 'median')
	                    .attr('x1', 0)
	                    .attr('y1', x0)
	                    .attr('x2', width)
	                    .attr('y2', x0)
	                    .transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('y1', x1)
	                    .attr('y2', x1);
	
	                medianLine.transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('x1', 0)
	                    .attr('x2', width)
	                    .attr('y1', x1)
	                    .attr('y2', x1);
	
	                // Update whiskers.
	                var whisker = g.selectAll('line.whisker')
	                    .data(whiskerData || []);
	
	                whisker.enter().insert('line', 'circle, text')
	                    .attr('class', 'whisker')
	                    .attr('x1', 0)
	                    .attr('y1', x0)
	                    .attr('x2', width)
	                    .attr('y2', x0)
	                    .style('opacity', 1e-6)
	                  .transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('y1', x1)
	                    .attr('y2', x1)
	                    .style('opacity', 1);
	
	                whisker.transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('x1', 0)
	                    .attr('x2', width)
	                    .attr('y1', x1)
	                    .attr('y2', x1)
	                    .style('opacity', 1);
	
	                whisker.exit().transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('y1', x1)
	                    .attr('y2', x1)
	                    .style('opacity', 1e-6)
	                    .remove();
	
	                // Update outliers.
	                var outlier = g.selectAll('circle.outlier')
	                    .data(outlierIndices, Number);
	
	                outlier.enter().insert('circle', 'text')
	                    .attr('class', 'outlier')
	                    .attr('r', 5)
	                    .attr('cx', width / 2)
	                    .attr('cy', function (i) { return x0(d[i]); })
	                    .style('opacity', 1e-6)
	                    .transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('cy', function (i) { return x1(d[i]); })
	                    .style('opacity', 1);
	
	                outlier.transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('cx', width / 2)
	                    .attr('cy', function (i) { return x1(d[i]); })
	                    .style('opacity', 1);
	
	                outlier.exit().transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('cy', function (i) { return x1(d[i]); })
	                    .style('opacity', 1e-6)
	                    .remove();
	
	                // Compute the tick format.
	                var format = tickFormat || x1.tickFormat(8);
	
	                // Update box ticks.
	                var boxTick = g.selectAll('text.box')
	                    .data(quartileData);
	
	                boxTick.enter().append('text')
	                    .attr('class', 'box')
	                    .attr('dy', '.3em')
	                    .attr('dx', function (d, i) { return i & 1 ? 6 : -6; })
	                    .attr('x', function (d, i) { return i & 1 ? width : 0; })
	                    .attr('y', x0)
	                    .attr('text-anchor', function (d, i) { return i & 1 ? 'start' : 'end'; })
	                    .text(format)
	                    .transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('y', x1);
	
	                boxTick.transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .text(format)
	                    .attr('x', function (d, i) { return i & 1 ? width : 0; })
	                    .attr('y', x1);
	
	                // Update whisker ticks. These are handled separately from the box
	                // ticks because they may or may not exist, and we want don't want
	                // to join box ticks pre-transition with whisker ticks post-.
	                var whiskerTick = g.selectAll('text.whisker')
	                    .data(whiskerData || []);
	
	                whiskerTick.enter().append('text')
	                    .attr('class', 'whisker')
	                    .attr('dy', '.3em')
	                    .attr('dx', 6)
	                    .attr('x', width)
	                    .attr('y', x0)
	                    .text(format)
	                    .style('opacity', 1e-6)
	                    .transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('y', x1)
	                    .style('opacity', 1);
	
	                whiskerTick.transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .text(format)
	                    .attr('x', width)
	                    .attr('y', x1)
	                    .style('opacity', 1);
	
	                whiskerTick.exit().transition()
	                    .duration(duration)
	                    .delay(delay)
	                    .attr('y', x1)
	                    .style('opacity', 1e-6)
	                    .remove();
	            });
	            d3.timer.flush();
	        }
	
	        box.width = function (x) {
	            if (!arguments.length) {
	                return width;
	            }
	            width = x;
	            return box;
	        };
	
	        box.height = function (x) {
	            if (!arguments.length) {
	                return height;
	            }
	            height = x;
	            return box;
	        };
	
	        box.tickFormat = function (x) {
	            if (!arguments.length) {
	                return tickFormat;
	            }
	            tickFormat = x;
	            return box;
	        };
	
	        box.duration = function (x) {
	            if (!arguments.length) {
	                return duration;
	            }
	            duration = x;
	            return box;
	        };
	
	        box.domain = function (x) {
	            if (!arguments.length) {
	                return domain;
	            }
	            domain = x === null ? x : d3.functor(x);
	            return box;
	        };
	
	        box.value = function (x) {
	            if (!arguments.length) {
	                return value;
	            }
	            value = x;
	            return box;
	        };
	
	        box.whiskers = function (x) {
	            if (!arguments.length) {
	                return whiskers;
	            }
	            whiskers = x;
	            return box;
	        };
	
	        box.quartiles = function (x) {
	            if (!arguments.length) {
	                return quartiles;
	            }
	            quartiles = x;
	            return box;
	        };
	
	        return box;
	    };
	
	    function boxWhiskers (d) {
	        return [0, d.length - 1];
	    }
	
	    function boxQuartiles (d) {
	        return [
	            d3.quantile(d, 0.25),
	            d3.quantile(d, 0.5),
	            d3.quantile(d, 0.75)
	        ];
	    }
	
	})();
	
	
	/**
	 * A box plot is a chart that depicts numerical data via their quartile ranges.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.io/dc.js/examples/box-plot-time.html Box plot time example}
	 * - {@link http://dc-js.github.io/dc.js/examples/box-plot.html Box plot example}
	 * @class boxPlot
	 * @memberof dc
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a box plot under #chart-container1 element using the default global chart group
	 * var boxPlot1 = dc.boxPlot('#chart-container1');
	 * // create a box plot under #chart-container2 element using chart group A
	 * var boxPlot2 = dc.boxPlot('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Selections.md#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @returns {dc.boxPlot}
	 */
	dc.boxPlot = function (parent, chartGroup) {
	    var _chart = dc.coordinateGridMixin({});
	
	    // Returns a function to compute the interquartile range.
	    function DEFAULT_WHISKERS_IQR (k) {
	        return function (d) {
	            var q1 = d.quartiles[0],
	                q3 = d.quartiles[2],
	                iqr = (q3 - q1) * k,
	                i = -1,
	                j = d.length;
	            do { ++i; } while (d[i] < q1 - iqr);
	            do { --j; } while (d[j] > q3 + iqr);
	            return [i, j];
	        };
	    }
	
	    var _whiskerIqrFactor = 1.5;
	    var _whiskersIqr = DEFAULT_WHISKERS_IQR;
	    var _whiskers = _whiskersIqr(_whiskerIqrFactor);
	
	    var _box = d3.box();
	    var _tickFormat = null;
	
	    var _boxWidth = function (innerChartWidth, xUnits) {
	        if (_chart.isOrdinal()) {
	            return _chart.x().rangeBand();
	        } else {
	            return innerChartWidth / (1 + _chart.boxPadding()) / xUnits;
	        }
	    };
	
	    // default padding to handle min/max whisker text
	    _chart.yAxisPadding(12);
	
	    // default to ordinal
	    _chart.x(d3.scale.ordinal());
	    _chart.xUnits(dc.units.ordinal);
	
	    // valueAccessor should return an array of values that can be coerced into numbers
	    // or if data is overloaded for a static array of arrays, it should be `Number`.
	    // Empty arrays are not included.
	    _chart.data(function (group) {
	        return group.all().map(function (d) {
	            d.map = function (accessor) { return accessor.call(d, d); };
	            return d;
	        }).filter(function (d) {
	            var values = _chart.valueAccessor()(d);
	            return values.length !== 0;
	        });
	    });
	
	    /**
	     * Get or set the spacing between boxes as a fraction of box size. Valid values are within 0-1.
	     * See the {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Ordinal-Scales.md#ordinal_rangeBands d3 docs}
	     * for a visual description of how the padding is applied.
	     * @method boxPadding
	     * @memberof dc.boxPlot
	     * @instance
	     * @see {@link https://github.com/d3/d3-3.x-api-reference/blob/master/Ordinal-Scales.md#ordinal_rangeBands d3.scale.ordinal.rangeBands}
	     * @param {Number} [padding=0.8]
	     * @returns {Number|dc.boxPlot}
	     */
	    _chart.boxPadding = _chart._rangeBandPadding;
	    _chart.boxPadding(0.8);
	
	    /**
	     * Get or set the outer padding on an ordinal box chart. This setting has no effect on non-ordinal charts
	     * or on charts with a custom {@link dc.boxPlot#boxWidth .boxWidth}. Will pad the width by
	     * `padding * barWidth` on each side of the chart.
	     * @method outerPadding
	     * @memberof dc.boxPlot
	     * @instance
	     * @param {Number} [padding=0.5]
	     * @returns {Number|dc.boxPlot}
	     */
	    _chart.outerPadding = _chart._outerRangeBandPadding;
	    _chart.outerPadding(0.5);
	
	    /**
	     * Get or set the numerical width of the boxplot box. The width may also be a function taking as
	     * parameters the chart width excluding the right and left margins, as well as the number of x
	     * units.
	     * @example
	     * // Using numerical parameter
	     * chart.boxWidth(10);
	     * // Using function
	     * chart.boxWidth((innerChartWidth, xUnits) { ... });
	     * @method boxWidth
	     * @memberof dc.boxPlot
	     * @instance
	     * @param {Number|Function} [boxWidth=0.5]
	     * @returns {Number|Function|dc.boxPlot}
	     */
	    _chart.boxWidth = function (boxWidth) {
	        if (!arguments.length) {
	            return _boxWidth;
	        }
	        _boxWidth = d3.functor(boxWidth);
	        return _chart;
	    };
	
	    var boxTransform = function (d, i) {
	        var xOffset = _chart.x()(_chart.keyAccessor()(d, i));
	        return 'translate(' + xOffset + ', 0)';
	    };
	
	    _chart._preprocessData = function () {
	        if (_chart.elasticX()) {
	            _chart.x().domain([]);
	        }
	    };
	
	    _chart.plotData = function () {
	        var _calculatedBoxWidth = _boxWidth(_chart.effectiveWidth(), _chart.xUnitCount());
	
	        _box.whiskers(_whiskers)
	            .width(_calculatedBoxWidth)
	            .height(_chart.effectiveHeight())
	            .value(_chart.valueAccessor())
	            .domain(_chart.y().domain())
	            .duration(_chart.transitionDuration())
	            .tickFormat(_tickFormat);
	
	        var boxesG = _chart.chartBodyG().selectAll('g.box').data(_chart.data(), _chart.keyAccessor());
	
	        renderBoxes(boxesG);
	        updateBoxes(boxesG);
	        removeBoxes(boxesG);
	
	        _chart.fadeDeselectedArea();
	    };
	
	    function renderBoxes (boxesG) {
	        var boxesGEnter = boxesG.enter().append('g');
	
	        boxesGEnter
	            .attr('class', 'box')
	            .attr('transform', boxTransform)
	            .call(_box)
	            .on('click', function (d) {
	                _chart.filter(_chart.keyAccessor()(d));
	                _chart.redrawGroup();
	            });
	    }
	
	    function updateBoxes (boxesG) {
	        dc.transition(boxesG, _chart.transitionDuration(), _chart.transitionDelay())
	            .attr('transform', boxTransform)
	            .call(_box)
	            .each(function () {
	                d3.select(this).select('rect.box').attr('fill', _chart.getColor);
	            });
	    }
	
	    function removeBoxes (boxesG) {
	        boxesG.exit().remove().call(_box);
	    }
	
	    _chart.fadeDeselectedArea = function () {
	        if (_chart.hasFilter()) {
	            if (_chart.isOrdinal()) {
	                _chart.g().selectAll('g.box').each(function (d) {
	                    if (_chart.isSelectedNode(d)) {
	                        _chart.highlightSelected(this);
	                    } else {
	                        _chart.fadeDeselected(this);
	                    }
	                });
	            } else {
	                var extent = _chart.brush().extent();
	                var start = extent[0];
	                var end = extent[1];
	                var keyAccessor = _chart.keyAccessor();
	                _chart.g().selectAll('g.box').each(function (d) {
	                    var key = keyAccessor(d);
	                    if (key < start || key >= end) {
	                        _chart.fadeDeselected(this);
	                    } else {
	                        _chart.highlightSelected(this);
	                    }
	                });
	            }
	        } else {
	            _chart.g().selectAll('g.box').each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	    };
	
	    _chart.isSelectedNode = function (d) {
	        return _chart.hasFilter(_chart.keyAccessor()(d));
	    };
	
	    _chart.yAxisMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return d3.min(_chart.valueAccessor()(e));
	        });
	        return dc.utils.subtract(min, _chart.yAxisPadding());
	    };
	
	    _chart.yAxisMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return d3.max(_chart.valueAccessor()(e));
	        });
	        return dc.utils.add(max, _chart.yAxisPadding());
	    };
	
	    /**
	     * Set the numerical format of the boxplot median, whiskers and quartile labels. Defaults to
	     * integer formatting.
	     * @example
	     * // format ticks to 2 decimal places
	     * chart.tickFormat(d3.format('.2f'));
	     * @method tickFormat
	     * @memberof dc.boxPlot
	     * @instance
	     * @param {Function} [tickFormat]
	     * @returns {Number|Function|dc.boxPlot}
	     */
	    _chart.tickFormat = function (tickFormat) {
	        if (!arguments.length) {
	            return _tickFormat;
	        }
	        _tickFormat = tickFormat;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * The select menu is a simple widget designed to filter a dimension by selecting an option from
	 * an HTML `<select/>` menu. The menu can be optionally turned into a multiselect.
	 * @class selectMenu
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @example
	 * // create a select menu under #select-container using the default global chart group
	 * var select = dc.selectMenu('#select-container')
	 *                .dimension(states)
	 *                .group(stateGroup);
	 * // the option text can be set via the title() function
	 * // by default the option text is '`key`: `value`'
	 * select.title(function (d){
	 *     return 'STATE: ' + d.key;
	 * })
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * [d3 single selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this widget should be placed in.
	 * Interaction with the widget will only trigger events and redraws within its group.
	 * @returns {selectMenu}
	 **/
	dc.selectMenu = function (parent, chartGroup) {
	    var SELECT_CSS_CLASS = 'dc-select-menu';
	    var OPTION_CSS_CLASS = 'dc-select-option';
	
	    var _chart = dc.baseMixin({});
	
	    var _select;
	    var _promptText = 'Select all';
	    var _multiple = false;
	    var _promptValue = null;
	    var _numberVisible = null;
	    var _order = function (a, b) {
	        return _chart.keyAccessor()(a) > _chart.keyAccessor()(b) ?
	             1 : _chart.keyAccessor()(b) > _chart.keyAccessor()(a) ?
	            -1 : 0;
	    };
	
	    var _filterDisplayed = function (d) {
	        return _chart.valueAccessor()(d) > 0;
	    };
	
	    _chart.data(function (group) {
	        return group.all().filter(_filterDisplayed);
	    });
	
	    _chart._doRender = function () {
	        _chart.select('select').remove();
	        _select = _chart.root().append('select')
	                        .classed(SELECT_CSS_CLASS, true);
	        _select.append('option').text(_promptText).attr('value', '');
	
	        _chart._doRedraw();
	        return _chart;
	    };
	
	    _chart._doRedraw = function () {
	        setAttributes();
	        renderOptions();
	        // select the option(s) corresponding to current filter(s)
	        if (_chart.hasFilter() && _multiple) {
	            _select.selectAll('option')
	                .property('selected', function (d) {
	                    return d && _chart.filters().indexOf(String(_chart.keyAccessor()(d))) >= 0;
	                });
	        } else if (_chart.hasFilter()) {
	            _select.property('value', _chart.filter());
	        } else {
	            _select.property('value', '');
	        }
	        return _chart;
	    };
	
	    function renderOptions () {
	        var options = _select.selectAll('option.' + OPTION_CSS_CLASS)
	          .data(_chart.data(), function (d) { return _chart.keyAccessor()(d); });
	
	        options.enter()
	              .append('option')
	              .classed(OPTION_CSS_CLASS, true)
	              .attr('value', function (d) { return _chart.keyAccessor()(d); });
	
	        options.text(_chart.title());
	        options.exit().remove();
	        _select.selectAll('option.' + OPTION_CSS_CLASS).sort(_order);
	
	        _select.on('change', onChange);
	        return options;
	    }
	
	    function onChange (d, i) {
	        var values;
	        var target = d3.event.target;
	        if (target.selectedOptions) {
	            var selectedOptions = Array.prototype.slice.call(target.selectedOptions);
	            values = selectedOptions.map(function (d) {
	                return d.value;
	            });
	        } else { // IE and other browsers do not support selectedOptions
	            // adapted from this polyfill: https://gist.github.com/brettz9/4212217
	            var options = [].slice.call(d3.event.target.options);
	            values = options.filter(function (option) {
	                return option.selected;
	            }).map(function (option) {
	                return option.value;
	            });
	        }
	        // console.log(values);
	        // check if only prompt option is selected
	        if (values.length === 1 && values[0] === '') {
	            values = _promptValue || null;
	        } else if (!_multiple && values.length === 1) {
	            values = values[0];
	        }
	        _chart.onChange(values);
	    }
	
	    _chart.onChange = function (val) {
	        if (val && _multiple) {
	            _chart.replaceFilter([val]);
	        } else if (val) {
	            _chart.replaceFilter(val);
	        } else {
	            _chart.filterAll();
	        }
	        dc.events.trigger(function () {
	            _chart.redrawGroup();
	        });
	    };
	
	    function setAttributes () {
	        if (_multiple) {
	            _select.attr('multiple', true);
	        } else {
	            _select.attr('multiple', null);
	        }
	        if (_numberVisible !== null) {
	            _select.attr('size', _numberVisible);
	        } else {
	            _select.attr('size', null);
	        }
	    }
	
	    /**
	     * Get or set the function that controls the ordering of option tags in the
	     * select menu. By default options are ordered by the group key in ascending
	     * order.
	     * @name order
	     * @memberof dc.selectMenu
	     * @instance
	     * @param {Function} [order]
	     * @example
	     * // order by the group's value
	     * chart.order(function (a,b) {
	     *     return a.value > b.value ? 1 : b.value > a.value ? -1 : 0;
	     * });
	     **/
	    _chart.order = function (order) {
	        if (!arguments.length) {
	            return _order;
	        }
	        _order = order;
	        return _chart;
	    };
	
	    /**
	     * Get or set the text displayed in the options used to prompt selection.
	     * @name promptText
	     * @memberof dc.selectMenu
	     * @instance
	     * @param {String} [promptText='Select all']
	     * @example
	     * chart.promptText('All states');
	     **/
	    _chart.promptText = function (_) {
	        if (!arguments.length) {
	            return _promptText;
	        }
	        _promptText = _;
	        return _chart;
	    };
	
	    /**
	     * Get or set the function that filters option tags prior to display. By default options
	     * with a value of < 1 are not displayed.
	     * @name filterDisplayed
	     * @memberof dc.selectMenu
	     * @instance
	     * @param {function} [filterDisplayed]
	     * @example
	     * // display all options override the `filterDisplayed` function:
	     * chart.filterDisplayed(function () {
	     *     return true;
	     * });
	     **/
	    _chart.filterDisplayed = function (filterDisplayed) {
	        if (!arguments.length) {
	            return _filterDisplayed;
	        }
	        _filterDisplayed = filterDisplayed;
	        return _chart;
	    };
	
	    /**
	     * Controls the type of select menu. Setting it to true converts the underlying
	     * HTML tag into a multiple select.
	     * @name multiple
	     * @memberof dc.selectMenu
	     * @instance
	     * @param {boolean} [multiple=false]
	     * @example
	     * chart.multiple(true);
	     **/
	    _chart.multiple = function (multiple) {
	        if (!arguments.length) {
	            return _multiple;
	        }
	        _multiple = multiple;
	
	        return _chart;
	    };
	
	    /**
	     * Controls the default value to be used for
	     * [dimension.filter](https://github.com/crossfilter/crossfilter/wiki/API-Reference#dimension_filter)
	     * when only the prompt value is selected. If `null` (the default), no filtering will occur when
	     * just the prompt is selected.
	     * @name promptValue
	     * @memberof dc.selectMenu
	     * @instance
	     * @param {?*} [promptValue=null]
	     **/
	    _chart.promptValue = function (promptValue) {
	        if (!arguments.length) {
	            return _promptValue;
	        }
	        _promptValue = promptValue;
	
	        return _chart;
	    };
	
	    /**
	     * Controls the number of items to show in the select menu, when `.multiple()` is true. This
	     * controls the [`size` attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select#Attributes) of
	     * the `select` element. If `null` (the default), uses the browser's default height.
	     * @name numberItems
	     * @memberof dc.selectMenu
	     * @instance
	     * @param {?number} [numberVisible=null]
	     * @example
	     * chart.numberVisible(10);
	     **/
	    _chart.numberVisible = function (numberVisible) {
	        if (!arguments.length) {
	            return _numberVisible;
	        }
	        _numberVisible = numberVisible;
	
	        return _chart;
	    };
	
	    _chart.size = dc.logger.deprecate(_chart.numberVisible, 'selectMenu.size is ambiguous - use numberVisible instead');
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	// Renamed functions
	
	dc.abstractBubbleChart = dc.bubbleMixin;
	dc.baseChart = dc.baseMixin;
	dc.capped = dc.capMixin;
	dc.colorChart = dc.colorMixin;
	dc.coordinateGridChart = dc.coordinateGridMixin;
	dc.marginable = dc.marginMixin;
	dc.stackableChart = dc.stackMixin;
	
	// Expose d3 and crossfilter, so that clients in browserify
	// case can obtain them if they need them.
	dc.d3 = d3;
	dc.crossfilter = crossfilter;
	
	return dc;}
	    if(true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(873), __webpack_require__(879)], __WEBPACK_AMD_DEFINE_FACTORY__ = (_dc), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if(typeof module === "object" && module.exports) {
	        var _d3 = require('d3');
	        var _crossfilter = require('crossfilter2');
	        // When using npm + browserify, 'crossfilter' is a function,
	        // since package.json specifies index.js as main function, and it
	        // does special handling. When using bower + browserify,
	        // there's no main in bower.json (in fact, there's no bower.json),
	        // so we need to fix it.
	        if (typeof _crossfilter !== "function") {
	            _crossfilter = _crossfilter.crossfilter;
	        }
	        module.exports = _dc(_d3, _crossfilter);
	    } else {
	        this.dc = _dc(d3, crossfilter);
	    }
	}
	)();
	
	//# sourceMappingURL=dc.js.map

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TitleLegendHeader = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LegendHeader = __webpack_require__(1273);
	
	var _LegendHeader2 = _interopRequireDefault(_LegendHeader);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TitleLegendHeader = exports.TitleLegendHeader = function TitleLegendHeader(_ref) {
	    var series = _ref.series,
	        settings = _ref.settings,
	        onChangeCardAndRun = _ref.onChangeCardAndRun,
	        actionButtons = _ref.actionButtons;
	
	    // $FlowFixMe
	    var originalSeries = series._raw || series;
	    var cardIds = _underscore2.default.uniq(originalSeries.map(function (s) {
	        return s.card.id;
	    }));
	    var isComposedOfMultipleQuestions = cardIds.length > 1;
	
	    if (settings["card.title"]) {
	        var titleHeaderSeries = [{ card: _extends({
	                name: settings["card.title"]
	            }, isComposedOfMultipleQuestions ? {} : {
	                id: cardIds[0],
	                dataset_query: originalSeries[0].card.dataset_query
	            }) }];
	
	        return _react2.default.createElement(_LegendHeader2.default, {
	            className: "flex-no-shrink",
	            series: titleHeaderSeries,
	            description: settings["card.description"],
	            actionButtons: actionButtons
	            // If a dashboard card is composed of multiple questions, its custom card title
	            // shouldn't act as a link as it's ambiguous that which question it should open
	            , onChangeCardAndRun: isComposedOfMultipleQuestions ? null : onChangeCardAndRun
	        });
	    } else {
	        // If the title isn't provided in settings, render nothing
	        return null;
	    }
	};

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1375 */,
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getDefaultColumns = getDefaultColumns;
	exports.getDefaultDimensionAndMetric = getDefaultDimensionAndMetric;
	exports.getOptionFromColumn = getOptionFromColumn;
	exports.metricSetting = metricSetting;
	exports.dimensionSetting = dimensionSetting;
	exports.fieldSetting = fieldSetting;
	exports.getSettings = getSettings;
	exports.getSettingsWidgets = getSettingsWidgets;
	
	var _visualizations = __webpack_require__(1284);
	
	var _utils = __webpack_require__(878);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _ChartSettingInput = __webpack_require__(1377);
	
	var _ChartSettingInput2 = _interopRequireDefault(_ChartSettingInput);
	
	var _ChartSettingInputNumeric = __webpack_require__(1378);
	
	var _ChartSettingInputNumeric2 = _interopRequireDefault(_ChartSettingInputNumeric);
	
	var _ChartSettingRadio = __webpack_require__(1379);
	
	var _ChartSettingRadio2 = _interopRequireDefault(_ChartSettingRadio);
	
	var _ChartSettingSelect = __webpack_require__(1381);
	
	var _ChartSettingSelect2 = _interopRequireDefault(_ChartSettingSelect);
	
	var _ChartSettingToggle = __webpack_require__(1382);
	
	var _ChartSettingToggle2 = _interopRequireDefault(_ChartSettingToggle);
	
	var _ChartSettingFieldPicker = __webpack_require__(1383);
	
	var _ChartSettingFieldPicker2 = _interopRequireDefault(_ChartSettingFieldPicker);
	
	var _ChartSettingFieldsPicker = __webpack_require__(1384);
	
	var _ChartSettingFieldsPicker2 = _interopRequireDefault(_ChartSettingFieldsPicker);
	
	var _ChartSettingColorPicker = __webpack_require__(1385);
	
	var _ChartSettingColorPicker2 = _interopRequireDefault(_ChartSettingColorPicker);
	
	var _ChartSettingColorsPicker = __webpack_require__(1387);
	
	var _ChartSettingColorsPicker2 = _interopRequireDefault(_ChartSettingColorsPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var WIDGETS = {
	    input: _ChartSettingInput2.default,
	    number: _ChartSettingInputNumeric2.default,
	    radio: _ChartSettingRadio2.default,
	    select: _ChartSettingSelect2.default,
	    toggle: _ChartSettingToggle2.default,
	    field: _ChartSettingFieldPicker2.default,
	    fields: _ChartSettingFieldsPicker2.default,
	    color: _ChartSettingColorPicker2.default,
	    colors: _ChartSettingColorsPicker2.default
	};
	
	function getDefaultColumns(series) {
	    if (series[0].card.display === "scatter") {
	        return getDefaultScatterColumns(series);
	    } else {
	        return getDefaultLineAreaBarColumns(series);
	    }
	}
	
	function getDefaultScatterColumns(_ref) {
	    var _ref2 = _slicedToArray(_ref, 1),
	        _ref2$0$data = _ref2[0].data,
	        cols = _ref2$0$data.cols,
	        rows = _ref2$0$data.rows;
	
	    var dimensions = cols.filter(_schema_metadata.isDimension);
	    var metrics = cols.filter(_schema_metadata.isMetric);
	    if (dimensions.length === 2 && metrics.length < 2) {
	        return {
	            dimensions: [dimensions[0].name],
	            metrics: [dimensions[1].name],
	            bubble: metrics.length === 1 ? metrics[0].name : null
	        };
	    } else {
	        return {
	            dimensions: [null],
	            metrics: [null],
	            bubble: null
	        };
	    }
	}
	
	function getDefaultLineAreaBarColumns(_ref3) {
	    var _ref4 = _slicedToArray(_ref3, 1),
	        _ref4$0$data = _ref4[0].data,
	        cols = _ref4$0$data.cols,
	        rows = _ref4$0$data.rows;
	
	    var type = (0, _utils.getChartTypeFromData)(cols, rows, false);
	    switch (type) {
	        case _utils.DIMENSION_DIMENSION_METRIC:
	            var dimensions = [cols[0], cols[1]];
	            if ((0, _schema_metadata.isDate)(dimensions[1]) && !(0, _schema_metadata.isDate)(dimensions[0])) {
	                // if the series dimension is a date but the axis dimension is not then swap them
	                dimensions.reverse();
	            } else if ((0, _utils.getColumnCardinality)(cols, rows, 1) > (0, _utils.getColumnCardinality)(cols, rows, 0)) {
	                // if the series dimension is higher cardinality than the axis dimension then swap them
	                dimensions.reverse();
	            }
	            return {
	                dimensions: dimensions.map(function (col) {
	                    return col.name;
	                }),
	                metrics: [cols[2].name]
	            };
	        case _utils.DIMENSION_METRIC:
	            return {
	                dimensions: [cols[0].name],
	                metrics: [cols[1].name]
	            };
	        case _utils.DIMENSION_METRIC_METRIC:
	            return {
	                dimensions: [cols[0].name],
	                metrics: cols.slice(1).map(function (col) {
	                    return col.name;
	                })
	            };
	        default:
	            return {
	                dimensions: [null],
	                metrics: [null]
	            };
	    }
	}
	
	function getDefaultDimensionAndMetric(_ref5) {
	    var _ref6 = _slicedToArray(_ref5, 1),
	        _ref6$0$data = _ref6[0].data,
	        cols = _ref6$0$data.cols,
	        rows = _ref6$0$data.rows;
	
	    var type = (0, _utils.getChartTypeFromData)(cols, rows, false);
	    if (type === _utils.DIMENSION_METRIC) {
	        return {
	            dimension: cols[0].name,
	            metric: cols[1].name
	        };
	    } else if (type === _utils.DIMENSION_DIMENSION_METRIC) {
	        return {
	            dimension: null,
	            metric: cols[2].name
	        };
	    } else {
	        return {
	            dimension: null,
	            metric: null
	        };
	    }
	}
	
	function getOptionFromColumn(col) {
	    return {
	        name: (0, _utils.getFriendlyName)(col),
	        value: col.name
	    };
	}
	
	function metricSetting(id) {
	    return fieldSetting(id, _schema_metadata.isMetric, function (series) {
	        return getDefaultDimensionAndMetric(series).metric;
	    });
	}
	
	function dimensionSetting(id) {
	    return fieldSetting(id, _schema_metadata.isDimension, function (series) {
	        return getDefaultDimensionAndMetric(series).dimension;
	    });
	}
	
	function fieldSetting(id, filter, getDefault) {
	    return {
	        widget: "select",
	        isValid: function isValid(_ref7, vizSettings) {
	            var _ref8 = _slicedToArray(_ref7, 1),
	                _ref8$ = _ref8[0],
	                card = _ref8$.card,
	                data = _ref8$.data;
	
	            return (0, _utils.columnsAreValid)(card.visualization_settings[id], data, filter);
	        },
	        getDefault: getDefault,
	        getProps: function getProps(_ref9) {
	            var _ref10 = _slicedToArray(_ref9, 1),
	                _ref10$ = _ref10[0],
	                card = _ref10$.card,
	                cols = _ref10$.data.cols;
	
	            return {
	                options: cols.filter(filter).map(getOptionFromColumn)
	            };
	        }
	    };
	}
	
	var COMMON_SETTINGS = {
	    "card.title": {
	        title: "Title",
	        widget: "input",
	        getDefault: function getDefault(series) {
	            return series.length === 1 ? series[0].card.name : null;
	        },
	        dashboard: true,
	        useRawSeries: true
	    },
	    "card.description": {
	        title: "Description",
	        widget: "input",
	        getDefault: function getDefault(series) {
	            return series.length === 1 ? series[0].card.description : null;
	        },
	        dashboard: true,
	        useRawSeries: true
	    }
	};
	
	function getSetting(settingDefs, id, vizSettings, series) {
	    if (id in vizSettings) {
	        return;
	    }
	
	    var settingDef = settingDefs[id];
	
	    var _series = series,
	        _series2 = _slicedToArray(_series, 1),
	        card = _series2[0].card;
	
	    var visualization_settings = card.visualization_settings || {};
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = (settingDef.readDependencies || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var dependentId = _step.value;
	
	            getSetting(settingDefs, dependentId, vizSettings, series);
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    if (settingDef.useRawSeries && series._raw) {
	        series = series._raw;
	    }
	
	    try {
	        if (settingDef.getValue) {
	            return vizSettings[id] = settingDef.getValue(series, vizSettings);
	        }
	
	        if (visualization_settings[id] !== undefined) {
	            if (!settingDef.isValid || settingDef.isValid(series, vizSettings)) {
	                return vizSettings[id] = visualization_settings[id];
	            }
	        }
	
	        if (settingDef.getDefault) {
	            return vizSettings[id] = settingDef.getDefault(series, vizSettings);
	        }
	
	        if ("default" in settingDef) {
	            return vizSettings[id] = settingDef.default;
	        }
	    } catch (e) {
	        console.error("Error getting setting", id, e);
	    }
	    return vizSettings[id] = undefined;
	}
	
	function getSettingDefintionsForSeries(series) {
	    var _getVisualizationRaw = (0, _visualizations.getVisualizationRaw)(series),
	        CardVisualization = _getVisualizationRaw.CardVisualization;
	
	    var definitions = _extends({}, COMMON_SETTINGS, CardVisualization.settings || {});
	    for (var id in definitions) {
	        definitions[id].id = id;
	    }
	    return definitions;
	}
	
	function getSettings(series) {
	    var vizSettings = {};
	    var settingsDefs = getSettingDefintionsForSeries(series);
	    for (var id in settingsDefs) {
	        getSetting(settingsDefs, id, vizSettings, series);
	    }
	    return vizSettings;
	}
	
	function getSettingWidget(settingDef, vizSettings, series, onChangeSettings) {
	    var id = settingDef.id;
	    var value = vizSettings[id];
	    var onChange = function onChange(value) {
	        var newSettings = _defineProperty({}, id, value);
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = (settingDef.writeDependencies || [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var _id = _step2.value;
	
	                newSettings[_id] = vizSettings[_id];
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        onChangeSettings(newSettings);
	    };
	    if (settingDef.useRawSeries && series._raw) {
	        series = series._raw;
	    }
	    return _extends({}, settingDef, {
	        id: id,
	        value: value,
	        title: settingDef.getTitle ? settingDef.getTitle(series, vizSettings) : settingDef.title,
	        hidden: settingDef.getHidden ? settingDef.getHidden(series, vizSettings) : false,
	        disabled: settingDef.getDisabled ? settingDef.getDisabled(series, vizSettings) : false,
	        props: _extends({}, settingDef.props ? settingDef.props : {}, settingDef.getProps ? settingDef.getProps(series, vizSettings, onChange) : {}),
	        widget: typeof settingDef.widget === "string" ? WIDGETS[settingDef.widget] : settingDef.widget,
	        onChange: onChange
	    });
	}
	
	function getSettingsWidgets(series, onChangeSettings) {
	    var isDashboard = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var vizSettings = getSettings(series);
	    return Object.values(getSettingDefintionsForSeries(series)).map(function (settingDef) {
	        return getSettingWidget(settingDef, vizSettings, series, onChangeSettings);
	    }).filter(function (widget) {
	        return widget.widget && !widget.hidden && (widget.dashboard === undefined || widget.dashboard === isDashboard);
	    });
	}

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartSettingInput = function ChartSettingInput(_ref) {
	    var value = _ref.value,
	        _onChange = _ref.onChange;
	    return _react2.default.createElement("input", {
	        className: "input block full",
	        value: value,
	        onChange: function onChange(e) {
	            return _onChange(e.target.value);
	        }
	    });
	};
	
	ChartSettingInput.displayName = "ChartSettingInput";
	exports.default = ChartSettingInput;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartSettingInputNumeric = function (_Component) {
	    _inherits(ChartSettingInputNumeric, _Component);
	
	    function ChartSettingInputNumeric(props, context) {
	        _classCallCheck(this, ChartSettingInputNumeric);
	
	        var _this = _possibleConstructorReturn(this, (ChartSettingInputNumeric.__proto__ || Object.getPrototypeOf(ChartSettingInputNumeric)).call(this, props, context));
	
	        _this.state = {
	            value: String(props.value == null ? "" : props.value)
	        };
	        return _this;
	    }
	
	    _createClass(ChartSettingInputNumeric, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ value: String(nextProps.value == null ? "" : nextProps.value) });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _onChange = this.props.onChange;
	
	            return _react2.default.createElement("input", {
	                className: (0, _classnames2.default)("input block full", { "border-error": this.state.value !== "" && isNaN(parseFloat(this.state.value)) }),
	                value: this.state.value,
	                onChange: function onChange(e) {
	                    var num = parseFloat(e.target.value);
	                    if (!isNaN(num) && num !== _this2.props.value) {
	                        _onChange(num);
	                    }
	                    _this2.setState({ value: e.target.value });
	                },
	                onBlur: function onBlur(e) {
	                    var num = parseFloat(e.target.value);
	                    if (isNaN(num)) {
	                        _onChange(undefined);
	                    } else {
	                        _onChange(num);
	                    }
	                }
	            });
	        }
	    }]);
	
	    return ChartSettingInputNumeric;
	}(_react.Component);
	
	ChartSettingInputNumeric.displayName = "ChartSettingInputNumeric";
	exports.default = ChartSettingInputNumeric;

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Radio = __webpack_require__(1380);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartSettingRadio = function ChartSettingRadio(_ref) {
	    var value = _ref.value,
	        onChange = _ref.onChange,
	        _ref$options = _ref.options,
	        options = _ref$options === undefined ? [] : _ref$options,
	        className = _ref.className;
	    return _react2.default.createElement(_Radio2.default, {
	        className: className,
	        value: value,
	        onChange: onChange,
	        options: options,
	        isVertical: true
	    });
	};
	
	ChartSettingRadio.displayName = "ChartSettingRadio";
	exports.default = ChartSettingRadio;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radio = (_temp = _class = function (_Component) {
	    _inherits(Radio, _Component);
	
	    function Radio(props, context) {
	        _classCallCheck(this, Radio);
	
	        var _this = _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).call(this, props, context));
	
	        _this._id = _underscore2.default.uniqueId("radio-");
	        return _this;
	    }
	
	    _createClass(Radio, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                value = _props.value,
	                options = _props.options,
	                onChange = _props.onChange,
	                optionNameFn = _props.optionNameFn,
	                optionValueFn = _props.optionValueFn,
	                optionKeyFn = _props.optionKeyFn,
	                isVertical = _props.isVertical,
	                className = _props.className;
	            // show buttons for vertical only by default
	
	            var showButtons = this.props.showButtons != undefined ? this.props.showButtons : isVertical;
	            return _react2.default.createElement(
	                "ul",
	                { className: (0, _classnames2.default)(className, "flex", { "flex-column": isVertical, "text-bold h3": !showButtons }) },
	                options.map(function (option) {
	                    return _react2.default.createElement(
	                        "li",
	                        {
	                            key: optionKeyFn(option),
	                            className: (0, _classnames2.default)("flex align-center cursor-pointer mt1 mr2", { "text-brand-hover": !showButtons }),
	                            onClick: function onClick(e) {
	                                return onChange(optionValueFn(option));
	                            }
	                        },
	                        _react2.default.createElement("input", {
	                            className: "Form-radio",
	                            type: "radio",
	                            name: _this2._id,
	                            value: optionValueFn(option),
	                            checked: value === optionValueFn(option),
	                            id: _this2._id + "-" + optionKeyFn(option)
	                        }),
	                        showButtons && _react2.default.createElement("label", { htmlFor: _this2._id + "-" + optionKeyFn(option) }),
	                        _react2.default.createElement(
	                            "span",
	                            { className: (0, _classnames2.default)({ "text-brand": value === optionValueFn(option) }) },
	                            optionNameFn(option)
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return Radio;
	}(_react.Component), _class.propTypes = {
	    value: _propTypes2.default.any,
	    options: _propTypes2.default.array.isRequired,
	    onChange: _propTypes2.default.func,
	    optionNameFn: _propTypes2.default.func,
	    optionValueFn: _propTypes2.default.func,
	    optionKeyFn: _propTypes2.default.func,
	    isVertical: _propTypes2.default.bool,
	    showButtons: _propTypes2.default.bool
	}, _class.defaultProps = {
	    optionNameFn: function optionNameFn(option) {
	        return option.name;
	    },
	    optionValueFn: function optionValueFn(option) {
	        return option.value;
	    },
	    optionKeyFn: function optionKeyFn(option) {
	        return option.value;
	    },
	    isVertical: false
	}, _temp);
	Radio.displayName = "Radio";
	exports.default = Radio;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartSettingSelect = function ChartSettingSelect(_ref) {
	    var value = _ref.value,
	        onChange = _ref.onChange,
	        _ref$options = _ref.options,
	        options = _ref$options === undefined ? [] : _ref$options,
	        isInitiallyOpen = _ref.isInitiallyOpen,
	        className = _ref.className,
	        placeholder = _ref.placeholder,
	        placeholderNoOptions = _ref.placeholderNoOptions;
	    return _react2.default.createElement(_Select2.default, {
	        className: (0, _classnames2.default)(className, "block flex-full", { disabled: options.length === 0 || options.length === 1 && options[0].value === value }),
	        value: _underscore2.default.findWhere(options, { value: value }),
	        options: options,
	        optionNameFn: function optionNameFn(o) {
	            return o.name;
	        },
	        optionValueFn: function optionValueFn(o) {
	            return o.value;
	        },
	        onChange: onChange,
	        placeholder: options.length === 0 ? placeholderNoOptions : placeholder,
	        isInitiallyOpen: isInitiallyOpen
	    });
	};
	
	ChartSettingSelect.displayName = "ChartSettingSelect";
	exports.default = ChartSettingSelect;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Toggle = __webpack_require__(1241);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartSettingToggle = function ChartSettingToggle(_ref) {
	    var value = _ref.value,
	        onChange = _ref.onChange;
	    return _react2.default.createElement(_Toggle2.default, {
	        value: value,
	        onChange: onChange
	    });
	};
	
	ChartSettingToggle.displayName = "ChartSettingToggle";
	exports.default = ChartSettingToggle;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ChartSettingSelect = __webpack_require__(1381);
	
	var _ChartSettingSelect2 = _interopRequireDefault(_ChartSettingSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartSettingFieldPicker = function ChartSettingFieldPicker(_ref) {
	    var value = _ref.value,
	        options = _ref.options,
	        onChange = _ref.onChange,
	        onRemove = _ref.onRemove;
	    return _react2.default.createElement(
	        "div",
	        { className: "flex align-center" },
	        _react2.default.createElement(_ChartSettingSelect2.default, {
	            value: value,
	            options: options,
	            onChange: onChange,
	            placeholder: "Select a field",
	            placeholderNoOptions: "No valid fields",
	            isInitiallyOpen: value === undefined
	        }),
	        _react2.default.createElement(_Icon2.default, {
	            name: "close",
	            className: (0, _classnames2.default)("ml1 text-grey-4 text-brand-hover cursor-pointer", {
	                "disabled hidden": !onRemove
	            }),
	            width: 12, height: 12,
	            onClick: onRemove
	        })
	    );
	};
	
	ChartSettingFieldPicker.displayName = "ChartSettingFieldPicker";
	exports.default = ChartSettingFieldPicker;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChartSettingFieldPicker = __webpack_require__(1383);
	
	var _ChartSettingFieldPicker2 = _interopRequireDefault(_ChartSettingFieldPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ChartSettingFieldsPicker = function ChartSettingFieldsPicker(_ref) {
	    var _ref$value = _ref.value,
	        value = _ref$value === undefined ? [] : _ref$value,
	        options = _ref.options,
	        _onChange = _ref.onChange,
	        addAnother = _ref.addAnother;
	    return _react2.default.createElement(
	        "div",
	        null,
	        Array.isArray(value) ? value.map(function (v, index) {
	            return _react2.default.createElement(_ChartSettingFieldPicker2.default, {
	                key: index,
	                value: v,
	                options: options,
	                onChange: function onChange(v) {
	                    var newValue = [].concat(_toConsumableArray(value));
	                    // this swaps the position of the existing value
	                    var existingIndex = value.indexOf(v);
	                    if (existingIndex >= 0) {
	                        newValue.splice(existingIndex, 1, value[index]);
	                    }
	                    // replace with the new value
	                    newValue.splice(index, 1, v);
	                    _onChange(newValue);
	                },
	                onRemove: value.filter(function (v) {
	                    return v != null;
	                }).length > 1 || value.length > 1 && v == null ? function () {
	                    return _onChange([].concat(_toConsumableArray(value.slice(0, index)), _toConsumableArray(value.slice(index + 1))));
	                } : null
	            });
	        }) : _react2.default.createElement(
	            "span",
	            { className: "text-error" },
	            "error"
	        ),
	        addAnother && _react2.default.createElement(
	            "div",
	            { className: "mt1" },
	            _react2.default.createElement(
	                "a",
	                { onClick: function onClick() {
	                        var remaining = options.filter(function (o) {
	                            return value.indexOf(o.value) < 0;
	                        });
	                        if (remaining.length === 1) {
	                            // if there's only one unused option, use it
	                            _onChange(value.concat([remaining[0].value]));
	                        } else {
	                            // otherwise leave it blank
	                            _onChange(value.concat([undefined]));
	                        }
	                    } },
	                addAnother
	            )
	        )
	    );
	};
	
	ChartSettingFieldsPicker.displayName = "ChartSettingFieldsPicker";
	exports.default = ChartSettingFieldsPicker;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ColorPicker = __webpack_require__(1386);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartSettingColorPicker = function (_Component) {
	    _inherits(ChartSettingColorPicker, _Component);
	
	    function ChartSettingColorPicker() {
	        _classCallCheck(this, ChartSettingColorPicker);
	
	        return _possibleConstructorReturn(this, (ChartSettingColorPicker.__proto__ || Object.getPrototypeOf(ChartSettingColorPicker)).apply(this, arguments));
	    }
	
	    _createClass(ChartSettingColorPicker, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "flex align-center mb1" },
	                _react2.default.createElement(_ColorPicker2.default, _extends({}, this.props, { triggerSize: 12 })),
	                this.props.title && _react2.default.createElement(
	                    "h4",
	                    { className: "ml1" },
	                    this.props.title
	                )
	            );
	        }
	    }]);
	
	    return ChartSettingColorPicker;
	}(_react.Component);
	
	ChartSettingColorPicker.displayName = "ChartSettingColorPicker";
	exports.default = ChartSettingColorPicker;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _colors = __webpack_require__(881);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_COLOR_SQUARE_SIZE = 32;
	
	var ColorSquare = function ColorSquare(_ref) {
	    var color = _ref.color,
	        size = _ref.size;
	    return _react2.default.createElement("div", { style: {
	            width: size,
	            height: size,
	            backgroundColor: color,
	            borderRadius: size / 8
	        } });
	};
	
	ColorSquare.displayName = "ColorSquare";
	var ColorPicker = (_temp = _class = function (_Component) {
	    _inherits(ColorPicker, _Component);
	
	    function ColorPicker() {
	        _classCallCheck(this, ColorPicker);
	
	        return _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).apply(this, arguments));
	    }
	
	    _createClass(ColorPicker, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                colors = _props.colors,
	                onChange = _props.onChange,
	                padding = _props.padding,
	                size = _props.size,
	                triggerSize = _props.triggerSize,
	                value = _props.value;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "inline-block" },
	                _react2.default.createElement(
	                    _PopoverWithTrigger2.default,
	                    {
	                        ref: "colorPopover",
	                        triggerElement: _react2.default.createElement(
	                            "div",
	                            {
	                                className: "bordered rounded flex align-center",
	                                style: { padding: triggerSize / 4 }
	                            },
	                            _react2.default.createElement(ColorSquare, { color: value, size: triggerSize })
	                        )
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "p1" },
	                        _react2.default.createElement(
	                            "ol",
	                            {
	                                className: "flex flex-wrap",
	                                style: {
	                                    maxWidth: 120
	                                }
	                            },
	                            colors.map(function (color, index) {
	                                return _react2.default.createElement(
	                                    "li",
	                                    {
	                                        className: "cursor-pointer",
	                                        style: { padding: padding },
	                                        key: index,
	                                        onClick: function onClick() {
	                                            onChange(color);
	                                            _this2.refs.colorPopover.close();
	                                        }
	                                    },
	                                    _react2.default.createElement(ColorSquare, { color: color, size: size })
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ColorPicker;
	}(_react.Component), _class.defaultProps = {
	    colors: [].concat(_toConsumableArray(Object.values(_colors.normal))),
	    size: DEFAULT_COLOR_SQUARE_SIZE,
	    triggerSize: DEFAULT_COLOR_SQUARE_SIZE,
	    padding: 4
	}, _class.propTypes = {
	    colors: _propTypes2.default.array,
	    onChange: _propTypes2.default.func.isRequired,
	    size: _propTypes2.default.number,
	    triggerSize: _propTypes2.default.number,
	    value: _propTypes2.default.string
	}, _temp);
	ColorPicker.displayName = "ColorPicker";
	exports.default = ColorPicker;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChartSettingColorPicker = __webpack_require__(1385);
	
	var _ChartSettingColorPicker2 = _interopRequireDefault(_ChartSettingColorPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartSettingColorsPicker = function (_Component) {
	    _inherits(ChartSettingColorsPicker, _Component);
	
	    function ChartSettingColorsPicker() {
	        _classCallCheck(this, ChartSettingColorsPicker);
	
	        return _possibleConstructorReturn(this, (ChartSettingColorsPicker.__proto__ || Object.getPrototypeOf(ChartSettingColorsPicker)).apply(this, arguments));
	    }
	
	    _createClass(ChartSettingColorsPicker, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                value = _props.value,
	                _onChange = _props.onChange,
	                seriesTitles = _props.seriesTitles;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                seriesTitles.map(function (title, index) {
	                    return _react2.default.createElement(_ChartSettingColorPicker2.default, {
	                        key: index,
	                        onChange: function onChange(color) {
	                            return _onChange([].concat(_toConsumableArray(value.slice(0, index)), [color], _toConsumableArray(value.slice(index + 1))));
	                        },
	                        title: title,
	                        value: value[index]
	                    });
	                })
	            );
	        }
	    }]);
	
	    return ChartSettingColorsPicker;
	}(_react.Component);
	
	ChartSettingColorsPicker.displayName = "ChartSettingColorsPicker";
	exports.default = ChartSettingColorsPicker;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChartSettingsError = exports.LatitudeLongitudeError = exports.MinRowsError = exports.MinColumnsError = undefined;
	
	var _formatting = __webpack_require__(872);
	
	function _extendableBuiltin7(cls) {
	    function ExtendableBuiltin() {
	        var instance = Reflect.construct(cls, Array.from(arguments));
	        Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
	        return instance;
	    }
	
	    ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	        constructor: {
	            value: cls,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        }
	    });
	
	    if (Object.setPrototypeOf) {
	        Object.setPrototypeOf(ExtendableBuiltin, cls);
	    } else {
	        ExtendableBuiltin.__proto__ = cls;
	    }
	
	    return ExtendableBuiltin;
	}
	
	function _extendableBuiltin5(cls) {
	    function ExtendableBuiltin() {
	        var instance = Reflect.construct(cls, Array.from(arguments));
	        Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
	        return instance;
	    }
	
	    ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	        constructor: {
	            value: cls,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        }
	    });
	
	    if (Object.setPrototypeOf) {
	        Object.setPrototypeOf(ExtendableBuiltin, cls);
	    } else {
	        ExtendableBuiltin.__proto__ = cls;
	    }
	
	    return ExtendableBuiltin;
	}
	
	function _extendableBuiltin3(cls) {
	    function ExtendableBuiltin() {
	        var instance = Reflect.construct(cls, Array.from(arguments));
	        Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
	        return instance;
	    }
	
	    ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	        constructor: {
	            value: cls,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        }
	    });
	
	    if (Object.setPrototypeOf) {
	        Object.setPrototypeOf(ExtendableBuiltin, cls);
	    } else {
	        ExtendableBuiltin.__proto__ = cls;
	    }
	
	    return ExtendableBuiltin;
	}
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	    function ExtendableBuiltin() {
	        var instance = Reflect.construct(cls, Array.from(arguments));
	        Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
	        return instance;
	    }
	
	    ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	        constructor: {
	            value: cls,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        }
	    });
	
	    if (Object.setPrototypeOf) {
	        Object.setPrototypeOf(ExtendableBuiltin, cls);
	    } else {
	        ExtendableBuiltin.__proto__ = cls;
	    }
	
	    return ExtendableBuiltin;
	}
	
	// NOTE: extending Error with Babel requires babel-plugin-transform-builtin-extend
	
	var MinColumnsError = exports.MinColumnsError = function (_extendableBuiltin2) {
	    _inherits(MinColumnsError, _extendableBuiltin2);
	
	    function MinColumnsError(minColumns, actualColumns) {
	        _classCallCheck(this, MinColumnsError);
	
	        return _possibleConstructorReturn(this, (MinColumnsError.__proto__ || Object.getPrototypeOf(MinColumnsError)).call(this, "Doh! The data from your query doesn't fit the chosen display choice. This visualization requires at least " + actualColumns + " " + (0, _formatting.inflect)("column", actualColumns) + " of data."));
	    }
	
	    return MinColumnsError;
	}(_extendableBuiltin(Error));
	
	var MinRowsError = exports.MinRowsError = function (_extendableBuiltin4) {
	    _inherits(MinRowsError, _extendableBuiltin4);
	
	    function MinRowsError(minRows, actualRows) {
	        _classCallCheck(this, MinRowsError);
	
	        return _possibleConstructorReturn(this, (MinRowsError.__proto__ || Object.getPrototypeOf(MinRowsError)).call(this, "No dice. We have " + actualRows + " data " + (0, _formatting.inflect)("point", actualRows) + " to show and that's not enough for this visualization."));
	    }
	
	    return MinRowsError;
	}(_extendableBuiltin3(Error));
	
	var LatitudeLongitudeError = exports.LatitudeLongitudeError = function (_extendableBuiltin6) {
	    _inherits(LatitudeLongitudeError, _extendableBuiltin6);
	
	    function LatitudeLongitudeError() {
	        _classCallCheck(this, LatitudeLongitudeError);
	
	        return _possibleConstructorReturn(this, (LatitudeLongitudeError.__proto__ || Object.getPrototypeOf(LatitudeLongitudeError)).call(this, "Bummer. We can't actually do a pin map for this data because we require both a latitude and longitude column."));
	    }
	
	    return LatitudeLongitudeError;
	}(_extendableBuiltin5(Error));
	
	var ChartSettingsError = exports.ChartSettingsError = function (_extendableBuiltin8) {
	    _inherits(ChartSettingsError, _extendableBuiltin8);
	
	    function ChartSettingsError(message, section, buttonText) {
	        _classCallCheck(this, ChartSettingsError);
	
	        var _this4 = _possibleConstructorReturn(this, (ChartSettingsError.__proto__ || Object.getPrototypeOf(ChartSettingsError)).call(this, message || "Please configure this chart in the chart settings"));
	
	        _this4.section = section;
	        _this4.buttonText = buttonText || "Edit Settings";
	        return _this4;
	    }
	
	    return ChartSettingsError;
	}(_extendableBuiltin7(Error));

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.scatterRenderer = exports.barRenderer = exports.areaRenderer = exports.lineRenderer = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	exports.hasRemappingAndValuesAreStrings = hasRemappingAndValuesAreStrings;
	exports.default = lineAreaBar;
	exports.rowRenderer = rowRenderer;
	
	var _crossfilter = __webpack_require__(879);
	
	var _crossfilter2 = _interopRequireDefault(_crossfilter);
	
	var _d2 = __webpack_require__(873);
	
	var _d3 = _interopRequireDefault(_d2);
	
	var _dc = __webpack_require__(1372);
	
	var _dc2 = _interopRequireDefault(_dc);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	var _utils = __webpack_require__(878);
	
	var _timeseries = __webpack_require__(1390);
	
	var _numeric = __webpack_require__(882);
	
	var _tooltip = __webpack_require__(1391);
	
	var _dom = __webpack_require__(859);
	
	var _formatting = __webpack_require__(872);
	
	var _time = __webpack_require__(876);
	
	var _Card = __webpack_require__(957);
	
	var _dataset3 = __webpack_require__(877);
	
	var _actions = __webpack_require__(959);
	
	var _brush = __webpack_require__(1392);
	
	var _addons = __webpack_require__(1393);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var MIN_PIXELS_PER_TICK = { x: 100, y: 32 };
	var BAR_PADDING_RATIO = 0.2;
	var DEFAULT_INTERPOLATION = "linear";
	
	// max number of points to "fill"
	// TODO: base on pixel width of chart?
	var MAX_FILL_COUNT = 10000;
	
	var DOT_OVERLAP_COUNT_LIMIT = 8;
	var DOT_OVERLAP_RATIO = 0.10;
	var DOT_OVERLAP_DISTANCE = 8;
	
	var VORONOI_TARGET_RADIUS = 25;
	var VORONOI_MAX_POINTS = 300;
	
	// min margin
	var MARGIN_TOP_MIN = 20; // needs to be large enough for goal line text
	var MARGIN_BOTTOM_MIN = 10;
	var MARGIN_HORIZONTAL_MIN = 20;
	
	// extra padding for axis
	var X_AXIS_PADDING = 0;
	var Y_AXIS_PADDING = 8;
	
	// label offset (doesn't increase padding)
	var X_LABEL_PADDING = 10;
	var Y_LABEL_PADDING = 22;
	
	var UNAGGREGATED_DATA_WARNING = function UNAGGREGATED_DATA_WARNING(col) {
	    return "\"" + (0, _utils.getFriendlyName)(col) + "\" is an unaggregated field: if it has more than one value at a point on the x-axis, the values will be summed.";
	};
	var NULL_DIMENSION_WARNING = "Data includes missing dimension values.";
	
	function adjustTicksIfNeeded(axis, axisSize, minPixelsPerTick) {
	    var ticks = axis.ticks();
	    // d3.js is dumb and sometimes numTicks is a number like 10 and other times it is an Array like [10]
	    // if it's an array then convert to a num
	    var numTicks = Array.isArray(ticks) ? ticks[0] : ticks;
	
	    if (axisSize / numTicks < minPixelsPerTick) {
	        axis.ticks(Math.round(axisSize / minPixelsPerTick));
	    }
	}
	
	function getDcjsChart(cardType, parent) {
	    switch (cardType) {
	        case "line":
	            return (0, _addons.lineAddons)(_dc2.default.lineChart(parent));
	        case "area":
	            return (0, _addons.lineAddons)(_dc2.default.lineChart(parent));
	        case "bar":
	            return _dc2.default.barChart(parent);
	        case "scatter":
	            return _dc2.default.bubbleChart(parent);
	        default:
	            return _dc2.default.barChart(parent);
	    }
	}
	
	function initChart(chart, element) {
	    // set the bounds
	    chart.width((0, _utils.getAvailableCanvasWidth)(element));
	    chart.height((0, _utils.getAvailableCanvasHeight)(element));
	    // disable animations
	    chart.transitionDuration(0);
	    // disable brush
	    if (chart.brushOn) {
	        chart.brushOn(false);
	    }
	}
	
	function applyChartTimeseriesXAxis(chart, settings, series, xValues, xDomain, xInterval) {
	    // find the first nonempty single series
	    var firstSeries = _underscore2.default.find(series, function (s) {
	        return !(0, _dataset3.datasetContainsNoResults)(s.data);
	    });
	
	    // setup an x-axis where the dimension is a timeseries
	    var dimensionColumn = firstSeries.data.cols[0];
	
	    // get the data's timezone offset from the first row
	    var dataOffset = (0, _time.parseTimestamp)(firstSeries.data.rows[0][0]).utcOffset() / 60;
	
	    // compute the data interval
	    var dataInterval = xInterval;
	    var tickInterval = dataInterval;
	
	    if (settings["graph.x_axis.labels_enabled"]) {
	        chart.xAxisLabel(settings["graph.x_axis.title_text"] || (0, _utils.getFriendlyName)(dimensionColumn), X_LABEL_PADDING);
	    }
	    if (settings["graph.x_axis.axis_enabled"]) {
	        chart.renderVerticalGridLines(settings["graph.x_axis.gridLine_enabled"]);
	
	        if (dimensionColumn.unit == null) {
	            dimensionColumn = _extends({}, dimensionColumn, { unit: dataInterval.interval });
	        }
	
	        // special handling for weeks
	        // TODO: are there any other cases where we should do this?
	        if (dataInterval.interval === "week") {
	            // if tick interval is compressed then show months instead of weeks because they're nicer formatted
	            var newTickInterval = (0, _timeseries.computeTimeseriesTicksInterval)(xDomain, tickInterval, chart.width(), MIN_PIXELS_PER_TICK.x);
	            if (newTickInterval.interval !== tickInterval.interval || newTickInterval.count !== tickInterval.count) {
	                dimensionColumn = _extends({}, dimensionColumn, { unit: "month" }), tickInterval = { interval: "month", count: 1 };
	            }
	        }
	
	        chart.xAxis().tickFormat(function (timestamp) {
	            // timestamp is a plain Date object which discards the timezone,
	            // so add it back in so it's formatted correctly
	            var timestampFixed = (0, _moment2.default)(timestamp).utcOffset(dataOffset).format();
	            return (0, _formatting.formatValue)(timestampFixed, { column: dimensionColumn, type: "axis" });
	        });
	
	        // Compute a sane interval to display based on the data granularity, domain, and chart width
	        tickInterval = (0, _timeseries.computeTimeseriesTicksInterval)(xDomain, tickInterval, chart.width(), MIN_PIXELS_PER_TICK.x);
	        chart.xAxis().ticks(_d3.default.time[tickInterval.interval], tickInterval.count);
	    } else {
	        chart.xAxis().ticks(0);
	    }
	
	    // pad the domain slightly to prevent clipping
	    xDomain[0] = (0, _moment2.default)(xDomain[0]).subtract(dataInterval.count * 0.75, dataInterval.interval);
	    xDomain[1] = (0, _moment2.default)(xDomain[1]).add(dataInterval.count * 0.75, dataInterval.interval);
	
	    // set the x scale
	    chart.x(_d3.default.time.scale.utc().domain(xDomain)); //.nice(d3.time[dataInterval.interval]));
	
	    // set the x units (used to compute bar size)
	    chart.xUnits(function (start, stop) {
	        return Math.ceil(1 + (0, _moment2.default)(stop).diff(start, dataInterval.interval) / dataInterval.count);
	    });
	}
	
	function applyChartQuantitativeXAxis(chart, settings, series, xValues, xDomain, xInterval) {
	    // find the first nonempty single series
	    var firstSeries = _underscore2.default.find(series, function (s) {
	        return !(0, _dataset3.datasetContainsNoResults)(s.data);
	    });
	    var dimensionColumn = firstSeries.data.cols[0];
	
	    if (settings["graph.x_axis.labels_enabled"]) {
	        chart.xAxisLabel(settings["graph.x_axis.title_text"] || (0, _utils.getFriendlyName)(dimensionColumn), X_LABEL_PADDING);
	    }
	    if (settings["graph.x_axis.axis_enabled"]) {
	        chart.renderVerticalGridLines(settings["graph.x_axis.gridLine_enabled"]);
	        adjustTicksIfNeeded(chart.xAxis(), chart.width(), MIN_PIXELS_PER_TICK.x);
	
	        chart.xAxis().tickFormat(function (d) {
	            return (0, _formatting.formatValue)(d, { column: dimensionColumn });
	        });
	    } else {
	        chart.xAxis().ticks(0);
	        chart.xAxis().tickFormat('');
	    }
	
	    var scale = void 0;
	    if (settings["graph.x_axis.scale"] === "pow") {
	        scale = _d3.default.scale.pow().exponent(0.5);
	    } else if (settings["graph.x_axis.scale"] === "log") {
	        scale = _d3.default.scale.log().base(Math.E);
	        if (!(xDomain[0] < 0 && xDomain[1] < 0 || xDomain[0] > 0 && xDomain[1] > 0)) {
	            throw "X-axis must not cross 0 when using log scale.";
	        }
	    } else {
	        scale = _d3.default.scale.linear();
	    }
	
	    // pad the domain slightly to prevent clipping
	    xDomain = [xDomain[0] - xInterval * 0.75, xDomain[1] + xInterval * 0.75];
	
	    chart.x(scale.domain(xDomain)).xUnits(_dc2.default.units.fp.precision(xInterval));
	}
	
	function applyChartOrdinalXAxis(chart, settings, series, xValues) {
	    // find the first nonempty single series
	    var firstSeries = _underscore2.default.find(series, function (s) {
	        return !(0, _dataset3.datasetContainsNoResults)(s.data);
	    });
	
	    var dimensionColumn = firstSeries.data.cols[0];
	
	    if (settings["graph.x_axis.labels_enabled"]) {
	        chart.xAxisLabel(settings["graph.x_axis.title_text"] || (0, _utils.getFriendlyName)(dimensionColumn), X_LABEL_PADDING);
	    }
	    if (settings["graph.x_axis.axis_enabled"]) {
	        chart.renderVerticalGridLines(settings["graph.x_axis.gridLine_enabled"]);
	        chart.xAxis().ticks(xValues.length);
	        adjustTicksIfNeeded(chart.xAxis(), chart.width(), MIN_PIXELS_PER_TICK.x);
	
	        // unfortunately with ordinal axis you can't rely on xAxis.ticks(num) to control the display of labels
	        // so instead if we want to display fewer ticks than our full set we need to calculate visibleTicks()
	        var numTicks = chart.xAxis().ticks();
	        if (Array.isArray(numTicks)) {
	            numTicks = numTicks[0];
	        }
	        if (numTicks < xValues.length) {
	            var keyInterval = Math.round(xValues.length / numTicks);
	            var visibleKeys = xValues.filter(function (v, i) {
	                return i % keyInterval === 0;
	            });
	            chart.xAxis().tickValues(visibleKeys);
	        }
	        chart.xAxis().tickFormat(function (d) {
	            return (0, _formatting.formatValue)(d, { column: dimensionColumn });
	        });
	    } else {
	        chart.xAxis().ticks(0);
	        chart.xAxis().tickFormat('');
	    }
	
	    chart.x(_d3.default.scale.ordinal().domain(xValues)).xUnits(_dc2.default.units.ordinal);
	}
	
	function applyChartYAxis(chart, settings, series, yExtent, axisName) {
	    var axis = void 0;
	    if (axisName !== "right") {
	        axis = {
	            scale: function scale() {
	                return chart.y.apply(chart, arguments);
	            },
	            axis: function axis() {
	                return chart.yAxis.apply(chart, arguments);
	            },
	            label: function label() {
	                return chart.yAxisLabel.apply(chart, arguments);
	            },
	            setting: function setting(name) {
	                return settings["graph.y_axis." + name];
	            }
	        };
	    } else {
	        axis = {
	            scale: function scale() {
	                return chart.rightY.apply(chart, arguments);
	            },
	            axis: function axis() {
	                return chart.rightYAxis.apply(chart, arguments);
	            },
	            label: function label() {
	                return chart.rightYAxisLabel.apply(chart, arguments);
	            },
	            setting: function setting(name) {
	                return settings["graph.y_axis." + name];
	            } // TODO: right axis settings
	        };
	    }
	
	    if (axis.setting("labels_enabled")) {
	        // left
	        if (axis.setting("title_text")) {
	            axis.label(axis.setting("title_text"), Y_LABEL_PADDING);
	        } else {
	            // only use the column name if all in the series are the same
	            var labels = _underscore2.default.uniq(series.map(function (s) {
	                return (0, _utils.getFriendlyName)(s.data.cols[1]);
	            }));
	            if (labels.length === 1) {
	                axis.label(labels[0], Y_LABEL_PADDING);
	            }
	        }
	    }
	
	    if (axis.setting("axis_enabled")) {
	        // special case for normalized stacked charts
	        if (settings["stackable.stack_type"] === "normalized") {
	            axis.axis().tickFormat(function (value) {
	                return value * 100 + "%";
	            });
	        }
	        chart.renderHorizontalGridLines(true);
	        adjustTicksIfNeeded(axis.axis(), chart.height(), MIN_PIXELS_PER_TICK.y);
	    } else {
	        axis.axis().ticks(0);
	    }
	
	    var scale = void 0;
	    if (axis.setting("scale") === "pow") {
	        scale = _d3.default.scale.pow().exponent(0.5);
	    } else if (axis.setting("scale") === "log") {
	        scale = _d3.default.scale.log().base(Math.E);
	        // axis.axis().tickFormat((d) => scale.tickFormat(4,d3.format(",d"))(d));
	    } else {
	        scale = _d3.default.scale.linear();
	    }
	
	    if (axis.setting("auto_range")) {
	        // elasticY not compatible with log scale
	        if (axis.setting("scale") !== "log") {
	            // TODO: right axis?
	            chart.elasticY(true);
	        } else {
	            if (!(yExtent[0] < 0 && yExtent[1] < 0 || yExtent[0] > 0 && yExtent[1] > 0)) {
	                throw "Y-axis must not cross 0 when using log scale.";
	            }
	            scale.domain(yExtent);
	        }
	        axis.scale(scale);
	    } else {
	        if (axis.setting("scale") === "log" && !(axis.setting("min") < 0 && axis.setting("max") < 0 || axis.setting("min") > 0 && axis.setting("max") > 0)) {
	            throw "Y-axis must not cross 0 when using log scale.";
	        }
	        axis.scale(scale.domain([axis.setting("min"), axis.setting("max")]));
	    }
	}
	
	function applyChartTooltips(chart, series, isStacked, isNormalized, isScalarSeries, onHoverChange, onVisualizationClick) {
	    var _series = _slicedToArray(series, 1),
	        cols = _series[0].data.cols;
	
	    chart.on("renderlet.tooltips", function (chart) {
	        chart.selectAll("title").remove();
	
	        if (onHoverChange) {
	            chart.selectAll(".bar, .dot, .area, .line, .bubble").on("mousemove", function (d, i) {
	                var seriesIndex = (0, _tooltip.determineSeriesIndexFromElement)(this, isStacked);
	                var card = series[seriesIndex].card;
	                var isSingleSeriesBar = this.classList.contains("bar") && series.length === 1;
	                var isArea = this.classList.contains("area");
	
	                var data = [];
	                if (Array.isArray(d.key)) {
	                    // scatter
	                    if (d.key._origin) {
	                        data = d.key._origin.row.map(function (value, index) {
	                            var col = d.key._origin.cols[index];
	                            return { key: (0, _utils.getFriendlyName)(col), value: value, col: col };
	                        });
	                    } else {
	                        data = d.key.map(function (value, index) {
	                            return { key: (0, _utils.getFriendlyName)(cols[index]), value: value, col: cols[index] };
	                        });
	                    }
	                } else if (d.data) {
	                    // line, area, bar
	                    if (!isSingleSeriesBar) {
	                        cols = series[seriesIndex].data.cols;
	                    }
	
	                    data = [{
	                        key: (0, _utils.getFriendlyName)(cols[0]),
	                        value: d.data.key,
	                        col: cols[0]
	                    }, {
	                        key: (0, _utils.getFriendlyName)(cols[1]),
	                        value: isNormalized ? (0, _formatting.formatValue)(d.data.value) * 100 + "%" : d.data.value,
	                        col: cols[1]
	                    }];
	                }
	
	                if (data && series.length > 1) {
	                    if (card._breakoutColumn) {
	                        data.unshift({
	                            key: (0, _utils.getFriendlyName)(card._breakoutColumn),
	                            value: card._breakoutValue,
	                            col: card._breakoutColumn
	                        });
	                    }
	                }
	
	                data = _underscore2.default.uniq(data, function (d) {
	                    return d.col;
	                });
	
	                onHoverChange({
	                    // for single series bar charts, fade the series and highlght the hovered element with CSS
	                    index: isSingleSeriesBar ? -1 : seriesIndex,
	                    // for area charts, use the mouse location rather than the DOM element
	                    element: isArea ? null : this,
	                    event: isArea ? _d3.default.event : null,
	                    data: data.length > 0 ? data : null
	                });
	            }).on("mouseleave", function () {
	                if (!onHoverChange) {
	                    return;
	                }
	                onHoverChange(null);
	            });
	        }
	
	        if (onVisualizationClick) {
	            var onClick = function onClick(d) {
	                var seriesIndex = (0, _tooltip.determineSeriesIndexFromElement)(this, isStacked);
	                var card = series[seriesIndex].card;
	                var isSingleSeriesBar = this.classList.contains("bar") && series.length === 1;
	
	                var clicked = void 0;
	                if (Array.isArray(d.key)) {
	                    // scatter
	                    clicked = {
	                        value: d.key[2],
	                        column: cols[2],
	                        dimensions: [{ value: d.key[0], column: cols[0] }, { value: d.key[1], column: cols[1] }].filter(function (_ref) {
	                            var column = _ref.column;
	                            return (
	                                // don't include aggregations since we can't filter on them
	                                column.source !== "aggregation"
	                            );
	                        }),
	                        origin: d.key._origin
	                    };
	                } else if (isScalarSeries) {
	                    // special case for multi-series scalar series, which should be treated as scalars
	                    clicked = {
	                        value: d.data.value,
	                        column: series[seriesIndex].data.cols[1]
	                    };
	                } else if (d.data) {
	                    // line, area, bar
	                    if (!isSingleSeriesBar) {
	                        cols = series[seriesIndex].data.cols;
	                    }
	                    clicked = {
	                        value: d.data.value,
	                        column: cols[1],
	                        dimensions: [{ value: d.data.key, column: cols[0] }]
	                    };
	                } else {
	                    clicked = {
	                        dimensions: []
	                    };
	                }
	
	                // handle multiseries
	                if (clicked && series.length > 1) {
	                    if (card._breakoutColumn) {
	                        // $FlowFixMe
	                        clicked.dimensions.push({
	                            value: card._breakoutValue,
	                            column: card._breakoutColumn
	                        });
	                    }
	                }
	
	                if (card._seriesIndex != null) {
	                    // $FlowFixMe
	                    clicked.seriesIndex = card._seriesIndex;
	                }
	
	                if (clicked) {
	                    var isLine = this.classList.contains("dot");
	                    onVisualizationClick(_extends({}, clicked, {
	                        element: isLine ? this : null,
	                        event: isLine ? null : _d3.default.event
	                    }));
	                }
	            };
	
	            // for some reason interaction with brush requires we use click for .dot and .bubble but mousedown for bar
	            chart.selectAll(".dot, .bubble").style({ "cursor": "pointer" }).on("click", onClick);
	            chart.selectAll(".bar").style({ "cursor": "pointer" }).on("mousedown", onClick);
	        }
	    });
	}
	
	function applyChartLineBarSettings(chart, settings, chartType) {
	    // LINE/AREA:
	    // for chart types that have an 'interpolate' option (line/area charts), enable based on settings
	    if (chart.interpolate) {
	        if (settings["line.interpolate"]) {
	            chart.interpolate(settings["line.interpolate"]);
	        } else {
	            chart.interpolate(DEFAULT_INTERPOLATION);
	        }
	    }
	
	    // AREA:
	    if (chart.renderArea) {
	        chart.renderArea(chartType === "area");
	    }
	
	    // BAR:
	    if (chart.barPadding) {
	        chart.barPadding(BAR_PADDING_RATIO).centerBar(settings["graph.x_axis.scale"] !== "ordinal");
	    }
	}
	
	function lineAndBarOnRender(chart, settings, onGoalHover, isSplitAxis, isStacked) {
	    // once chart has rendered and we can access the SVG, do customizations to axis labels / etc that you can't do through dc.js
	
	    function removeClipPath() {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = chart.selectAll(".sub, .chart-body")[0][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var elem = _step.value;
	
	                // prevents dots from being clipped:
	                elem.removeAttribute("clip-path");
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    }
	
	    function moveContentToTop() {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = chart.selectAll(".sub, .chart-body")[0][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var elem = _step2.value;
	
	                // move chart content on top of axis (z-index doesn't work on SVG):
	                elem.parentNode.appendChild(elem);
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	    }
	
	    function setDotStyle() {
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = chart.svg().selectAll('.dc-tooltip circle.dot')[0][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var elem = _step3.value;
	
	                // set the color of the dots to the fill color so we can use currentColor in CSS rules:
	                elem.style.color = elem.getAttribute("fill");
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	    }
	
	    function enableDots() {
	        var enableDots = void 0;
	        var dots = chart.svg().selectAll(".dc-tooltip .dot")[0];
	        if (settings["line.marker_enabled"] != null) {
	            enableDots = !!settings["line.marker_enabled"];
	        } else if (dots.length > 500) {
	            // more than 500 dots is almost certainly too dense, don't waste time computing the voronoi map
	            enableDots = false;
	        } else {
	            var vertices = dots.map(function (e, index) {
	                var rect = e.getBoundingClientRect();
	                return [rect.left, rect.top, index];
	            });
	            var overlappedIndex = {};
	            // essentially pairs of vertices closest to each other
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	                for (var _iterator4 = _d3.default.geom.voronoi().links(vertices)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var _ref3 = _step4.value;
	                    var source = _ref3.source,
	                        target = _ref3.target;
	
	                    if (Math.sqrt(Math.pow(source[0] - target[0], 2) + Math.pow(source[1] - target[1], 2)) < DOT_OVERLAP_DISTANCE) {
	                        // if they overlap, mark both as overlapped
	                        overlappedIndex[source[2]] = overlappedIndex[target[2]] = true;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                        _iterator4.return();
	                    }
	                } finally {
	                    if (_didIteratorError4) {
	                        throw _iteratorError4;
	                    }
	                }
	            }
	
	            var total = vertices.length;
	            var overlapping = Object.keys(overlappedIndex).length;
	            enableDots = overlapping < DOT_OVERLAP_COUNT_LIMIT || overlapping / total < DOT_OVERLAP_RATIO;
	        }
	        chart.svg().classed("enable-dots", enableDots).classed("enable-dots-onhover", !enableDots);
	    }
	
	    function voronoiHover() {
	        var parent = chart.svg().select("svg > g");
	        var dots = chart.svg().selectAll(".sub .dc-tooltip .dot")[0];
	
	        if (dots.length === 0 || dots.length > VORONOI_MAX_POINTS) {
	            return;
	        }
	
	        var originRect = chart.svg().node().getBoundingClientRect();
	        var vertices = dots.map(function (e) {
	            var _e$getBoundingClientR = e.getBoundingClientRect(),
	                top = _e$getBoundingClientR.top,
	                left = _e$getBoundingClientR.left,
	                width = _e$getBoundingClientR.width,
	                height = _e$getBoundingClientR.height;
	
	            var px = left + width / 2 - originRect.left;
	            var py = top + height / 2 - originRect.top;
	            return [px, py, e];
	        });
	
	        // HACK Atte Keinänen 8/8/17: For some reason the parent node is not present in Jest/Enzyme tests
	        // so simply return empty width and height for preventing the need to do bigger hacks in test code
	
	        var _ref4 = parent.node() ? parent.node().getBBox() : { width: 0, height: 0 },
	            width = _ref4.width,
	            height = _ref4.height;
	
	        var voronoi = _d3.default.geom.voronoi().clipExtent([[0, 0], [width, height]]);
	
	        // circular clip paths to limit distance from actual point
	        parent.append("svg:g").selectAll("clipPath").data(vertices).enter().append("svg:clipPath").attr("id", function (d, i) {
	            return "clip-" + i;
	        }).append("svg:circle").attr('cx', function (d) {
	            return d[0];
	        }).attr('cy', function (d) {
	            return d[1];
	        }).attr('r', VORONOI_TARGET_RADIUS);
	
	        // voronoi layout with clip paths applied
	        parent.append("svg:g").classed("voronoi", true).selectAll("path").data(voronoi(vertices), function (d) {
	            return d && d.join(",");
	        }).enter().append("svg:path").filter(function (d) {
	            return d != undefined;
	        }).attr("d", function (d) {
	            return "M" + d.join("L") + "Z";
	        }).attr("clip-path", function (d, i) {
	            return (0, _dom.clipPathReference)("clip-" + i);
	        }).on("mousemove", function (_ref5) {
	            var point = _ref5.point;
	
	            var e = point[2];
	            dispatchUIEvent(e, "mousemove");
	            _d3.default.select(e).classed("hover", true);
	        }).on("mouseleave", function (_ref6) {
	            var point = _ref6.point;
	
	            var e = point[2];
	            dispatchUIEvent(e, "mouseleave");
	            _d3.default.select(e).classed("hover", false);
	        }).on("click", function (_ref7) {
	            var point = _ref7.point;
	
	            var e = point[2];
	            dispatchUIEvent(e, "click");
	        }).order();
	
	        function dispatchUIEvent(element, eventName) {
	            var e = document.createEvent("UIEvents");
	            // $FlowFixMe
	            e.initUIEvent(eventName, true, true, window, 1);
	            element.dispatchEvent(e);
	        }
	    }
	
	    function hideDisabledLabels() {
	        if (!settings["graph.x_axis.labels_enabled"]) {
	            chart.selectAll(".x-axis-label").remove();
	        }
	        if (!settings["graph.y_axis.labels_enabled"]) {
	            chart.selectAll(".y-axis-label").remove();
	        }
	    }
	
	    function hideDisabledAxis() {
	        if (!settings["graph.x_axis.axis_enabled"]) {
	            chart.selectAll(".axis.x").remove();
	        }
	        if (!settings["graph.y_axis.axis_enabled"]) {
	            chart.selectAll(".axis.y, .axis.yr").remove();
	        }
	    }
	
	    function hideBadAxis() {
	        if (chart.selectAll(".axis.x .tick")[0].length === 1) {
	            chart.selectAll(".axis.x").remove();
	        }
	    }
	
	    function adjustMargin(margin, direction, padding, axisSelector, labelSelector, enabled) {
	        var axis = chart.select(axisSelector).node();
	        var label = chart.select(labelSelector).node();
	        var axisSize = axis ? axis.getBoundingClientRect()[direction] + 10 : 0;
	        var labelSize = label ? label.getBoundingClientRect()[direction] + 5 : 0;
	        chart.margins()[margin] = axisSize + labelSize + padding;
	    }
	
	    function computeMinHorizontalMargins() {
	        var min = { left: 0, right: 0 };
	        var ticks = chart.selectAll(".axis.x .tick text")[0];
	        if (ticks.length > 0) {
	            var chartRect = chart.select("svg").node().getBoundingClientRect();
	            min.left = chart.margins().left - (ticks[0].getBoundingClientRect().left - chartRect.left);
	            min.right = chart.margins().right - (chartRect.right - ticks[ticks.length - 1].getBoundingClientRect().right);
	        }
	        return min;
	    }
	
	    function disableClickFiltering() {
	        chart.selectAll("rect.bar").on("click", function (d) {
	            chart.filter(null);
	            chart.filter(d.key);
	        });
	    }
	
	    function fixStackZIndex() {
	        // reverse the order of .stack-list and .dc-tooltip-list children so 0 points in stacked
	        // charts don't appear on top of non-zero points
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	            for (var _iterator5 = chart.selectAll(".stack-list, .dc-tooltip-list")[0][Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                var list = _step5.value;
	                var _iteratorNormalCompletion6 = true;
	                var _didIteratorError6 = false;
	                var _iteratorError6 = undefined;
	
	                try {
	                    for (var _iterator6 = list.childNodes[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                        var child = _step6.value;
	
	                        list.insertBefore(list.firstChild, child);
	                    }
	                } catch (err) {
	                    _didIteratorError6 = true;
	                    _iteratorError6 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                            _iterator6.return();
	                        }
	                    } finally {
	                        if (_didIteratorError6) {
	                            throw _iteratorError6;
	                        }
	                    }
	                }
	            }
	        } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                    _iterator5.return();
	                }
	            } finally {
	                if (_didIteratorError5) {
	                    throw _iteratorError5;
	                }
	            }
	        }
	    }
	
	    function cleanupGoal() {
	        // remove dots
	        chart.selectAll(".goal .dot").remove();
	
	        // move to end of the parent node so it's on top
	        chart.selectAll(".goal").each(function () {
	            this.parentNode.appendChild(this);
	        });
	        chart.selectAll(".goal .line").attr({
	            "stroke": "rgba(157,160,164, 0.7)",
	            "stroke-dasharray": "5,5"
	        });
	
	        // add the label
	        var goalLine = chart.selectAll(".goal .line")[0][0];
	        if (goalLine) {
	
	            // stretch the goal line all the way across, use x axis as reference
	            var xAxisLine = chart.selectAll(".axis.x .domain")[0][0];
	
	            // HACK Atte Keinänen 8/8/17: For some reason getBBox method is not present in Jest/Enzyme tests
	            if (xAxisLine && goalLine.getBBox) {
	                goalLine.setAttribute("d", "M0," + goalLine.getBBox().y + "L" + xAxisLine.getBBox().width + "," + goalLine.getBBox().y);
	            }
	
	            var _ref8 = goalLine.getBBox ? goalLine.getBBox() : { x: 0, y: 0, width: 0 },
	                x = _ref8.x,
	                y = _ref8.y,
	                width = _ref8.width;
	
	            var labelOnRight = !isSplitAxis;
	            chart.selectAll(".goal .stack._0").append("text").text("Goal").attr({
	                x: labelOnRight ? x + width : x,
	                y: y - 5,
	                "text-anchor": labelOnRight ? "end" : "start",
	                "font-weight": "bold",
	                fill: "rgb(157,160,164)"
	            }).on("mouseenter", function () {
	                onGoalHover(this);
	            }).on("mouseleave", function () {
	                onGoalHover(null);
	            });
	        }
	    }
	
	    function setClassName() {
	        chart.svg().classed("stacked", isStacked);
	    }
	
	    // run these first so the rest of the margin computations take it into account
	    hideDisabledLabels();
	    hideDisabledAxis();
	    hideBadAxis();
	
	    // should be run before adjusting margins
	    var mins = computeMinHorizontalMargins();
	
	    // adjust the margins to fit the X and Y axis tick and label sizes, if enabled
	    adjustMargin("bottom", "height", X_AXIS_PADDING, ".axis.x", ".x-axis-label", settings["graph.x_axis.labels_enabled"]);
	    adjustMargin("left", "width", Y_AXIS_PADDING, ".axis.y", ".y-axis-label.y-label", settings["graph.y_axis.labels_enabled"]);
	    adjustMargin("right", "width", Y_AXIS_PADDING, ".axis.yr", ".y-axis-label.yr-label", settings["graph.y_axis.labels_enabled"]);
	
	    // set margins to the max of the various mins
	    chart.margins().top = Math.max(MARGIN_TOP_MIN, chart.margins().top);
	    chart.margins().left = Math.max(MARGIN_HORIZONTAL_MIN, mins.left, chart.margins().left);
	    chart.margins().right = Math.max(MARGIN_HORIZONTAL_MIN, mins.right, chart.margins().right);
	    chart.margins().bottom = Math.max(MARGIN_BOTTOM_MIN, chart.margins().bottom);
	
	    chart.on("renderlet.on-render", function () {
	        removeClipPath();
	        moveContentToTop();
	        setDotStyle();
	        enableDots();
	        voronoiHover();
	        cleanupGoal(); // do this before hiding x-axis
	        hideDisabledLabels();
	        hideDisabledAxis();
	        hideBadAxis();
	        disableClickFiltering();
	        fixStackZIndex();
	        setClassName();
	    });
	
	    chart.render();
	}
	
	function reduceGroup(group, key, warnUnaggregated) {
	    return group.reduce(function (acc, d) {
	        if (acc == null && d[key] == null) {
	            return null;
	        } else {
	            if (acc != null) {
	                warnUnaggregated();
	                return acc + (d[key] || 0);
	            } else {
	                return d[key] || 0;
	            }
	        }
	    }, function (acc, d) {
	        if (acc == null && d[key] == null) {
	            return null;
	        } else {
	            if (acc != null) {
	                warnUnaggregated();
	                return acc - (d[key] || 0);
	            } else {
	                return -(d[key] || 0);
	            }
	        }
	    }, function () {
	        return null;
	    });
	}
	
	function fillMissingValues(datas, xValues, fillValue) {
	    var getKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (v) {
	        return v;
	    };
	
	    try {
	        return datas.map(function (rows) {
	            var fillValues = rows[0].slice(1).map(function (d) {
	                return fillValue;
	            });
	
	            var map = new Map();
	            var _iteratorNormalCompletion7 = true;
	            var _didIteratorError7 = false;
	            var _iteratorError7 = undefined;
	
	            try {
	                for (var _iterator7 = rows[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	                    var row = _step7.value;
	
	                    map.set(getKey(row[0]), row);
	                }
	            } catch (err) {
	                _didIteratorError7 = true;
	                _iteratorError7 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                        _iterator7.return();
	                    }
	                } finally {
	                    if (_didIteratorError7) {
	                        throw _iteratorError7;
	                    }
	                }
	            }
	
	            var newRows = xValues.map(function (value) {
	                var key = getKey(value);
	                var row = map.get(key);
	                if (row) {
	                    map.delete(key);
	                    return [value].concat(_toConsumableArray(row.slice(1)));
	                } else {
	                    return [value].concat(_toConsumableArray(fillValues));
	                }
	            });
	            if (map.size > 0) {
	                console.warn("xValues missing!", map, newRows);
	            }
	            return newRows;
	        });
	    } catch (e) {
	        console.warn(e);
	        return datas;
	    }
	}
	
	// Crossfilter calls toString on each moment object, which calls format(), which is very slow.
	// Replace toString with a function that just returns the unparsed ISO input date, since that works
	// just as well and is much faster
	var HACK_parseTimestamp = function HACK_parseTimestamp(value, unit, warn) {
	    if (value == null) {
	        warn(NULL_DIMENSION_WARNING);
	        return null;
	    } else {
	        var m = (0, _time.parseTimestamp)(value, unit);
	        m.toString = moment_fast_toString;
	        return m;
	    }
	};
	
	function moment_fast_toString() {
	    return this._i;
	}
	
	function makeIndexMap(values) {
	    var indexMap = new Map();
	    var _iteratorNormalCompletion8 = true;
	    var _didIteratorError8 = false;
	    var _iteratorError8 = undefined;
	
	    try {
	        for (var _iterator8 = values.entries()[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	            var _step8$value = _slicedToArray(_step8.value, 2),
	                index = _step8$value[0],
	                _key = _step8$value[1];
	
	            indexMap.set(_key, index);
	        }
	    } catch (err) {
	        _didIteratorError8 = true;
	        _iteratorError8 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                _iterator8.return();
	            }
	        } finally {
	            if (_didIteratorError8) {
	                throw _iteratorError8;
	            }
	        }
	    }
	
	    return indexMap;
	}
	
	// HACK: This ensures each group is sorted by the same order as xValues,
	// otherwise we can end up with line charts with x-axis labels in the correct order
	// but the points in the wrong order. There may be a more efficient way to do this.
	function forceSortedGroup(group, indexMap) {
	    // $FlowFixMe
	    var sorted = group.top(Infinity).sort(function (a, b) {
	        return indexMap.get(a.key) - indexMap.get(b.key);
	    });
	    for (var i = 0; i < sorted.length; i++) {
	        sorted[i].index = i;
	    }
	    group.all = function () {
	        return sorted;
	    };
	}
	
	function forceSortedGroupsOfGroups(groupsOfGroups, indexMap) {
	    var _iteratorNormalCompletion9 = true;
	    var _didIteratorError9 = false;
	    var _iteratorError9 = undefined;
	
	    try {
	        for (var _iterator9 = groupsOfGroups[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	            var groups = _step9.value;
	            var _iteratorNormalCompletion10 = true;
	            var _didIteratorError10 = false;
	            var _iteratorError10 = undefined;
	
	            try {
	                for (var _iterator10 = groups[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	                    var group = _step10.value;
	
	                    forceSortedGroup(group, indexMap);
	                }
	            } catch (err) {
	                _didIteratorError10 = true;
	                _iteratorError10 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
	                        _iterator10.return();
	                    }
	                } finally {
	                    if (_didIteratorError10) {
	                        throw _iteratorError10;
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError9 = true;
	        _iteratorError9 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                _iterator9.return();
	            }
	        } finally {
	            if (_didIteratorError9) {
	                throw _iteratorError9;
	            }
	        }
	    }
	}
	
	function hasRemappingAndValuesAreStrings(_ref9) {
	    var cols = _ref9.cols;
	    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    var column = cols[i];
	
	    if (column.remapping && column.remapping.size > 0) {
	        // We have remapped values, so check their type for determining whether the dimension is numeric
	        // ES6 Map makes the lookup of first value a little verbose
	        return typeof column.remapping.values().next().value === "string";
	    } else {
	        return false;
	    }
	}
	
	function lineAreaBar(element, _ref10) {
	    var _ref12;
	
	    var series = _ref10.series,
	        onHoverChange = _ref10.onHoverChange,
	        onVisualizationClick = _ref10.onVisualizationClick,
	        onRender = _ref10.onRender,
	        chartType = _ref10.chartType,
	        isScalarSeries = _ref10.isScalarSeries,
	        settings = _ref10.settings,
	        maxSeries = _ref10.maxSeries,
	        onChangeCardAndRun = _ref10.onChangeCardAndRun;
	
	    var colors = settings["graph.colors"];
	
	    // force histogram to be ordinal axis with zero-filled missing points
	    var isHistogram = settings["graph.x_axis.scale"] === "histogram";
	    if (isHistogram) {
	        settings["line.missing"] = "zero";
	        settings["graph.x_axis.scale"] = "ordinal";
	    }
	
	    // bar histograms have special tick formatting:
	    // * aligned with beginning of bar to show bin boundaries
	    // * label only shows beginning value of bin
	    // * includes an extra tick at the end for the end of the last bin
	    var isHistogramBar = isHistogram && chartType === "bar";
	
	    var isTimeseries = settings["graph.x_axis.scale"] === "timeseries";
	    var isQuantitative = ["linear", "log", "pow"].indexOf(settings["graph.x_axis.scale"]) >= 0;
	    var isOrdinal = !isTimeseries && !isQuantitative;
	
	    // is this a dashboard multiseries?
	    // TODO: better way to detect this?
	    var isMultiCardSeries = series.length > 1 && (0, _icepick.getIn)(series, [0, "card", "id"]) !== (0, _icepick.getIn)(series, [1, "card", "id"]);
	
	    // find the first nonempty single series
	    // $FlowFixMe
	    var firstSeries = _underscore2.default.find(series, function (s) {
	        return !(0, _dataset3.datasetContainsNoResults)(s.data);
	    });
	
	    var isDimensionTimeseries = (0, _timeseries.dimensionIsTimeseries)(firstSeries.data);
	    var isDimensionNumeric = (0, _numeric.dimensionIsNumeric)(firstSeries.data);
	    var isRemappedToString = hasRemappingAndValuesAreStrings(firstSeries.data);
	
	    var enableBrush = !!(onChangeCardAndRun && !isMultiCardSeries && (0, _Card.isStructured)(series[0].card) && !isRemappedToString);
	
	    if (firstSeries.data.cols.length < 2) {
	        throw new Error("This chart type requires at least 2 columns.");
	    }
	
	    if (series.length > maxSeries) {
	        throw new Error("This chart type doesn't support more than " + maxSeries + " series of data.");
	    }
	
	    var warnings = {};
	    var warn = function warn(id) {
	        warnings[id] = (warnings[id] || 0) + 1;
	    };
	
	    var datas = series.map(function (s, index) {
	        return s.data.rows.map(function (row) {
	            var newRow = [
	            // don't parse as timestamp if we're going to display as a quantitative scale, e.x. years and Unix timestamps
	            isDimensionTimeseries && !isQuantitative ? HACK_parseTimestamp(row[0], s.data.cols[0].unit, warn) : isDimensionNumeric ? row[0] : String(row[0])].concat(_toConsumableArray(row.slice(1)));
	            // $FlowFixMe: _origin not typed
	            newRow._origin = row._origin;
	            return newRow;
	        });
	    });
	
	    // compute the x-values
	    var xValues = (0, _utils.getXValues)(datas, chartType);
	
	    // compute the domain
	    var xDomain = _d3.default.extent(xValues);
	
	    var xInterval = void 0;
	    if (isTimeseries) {
	        // compute the interval
	        var unit = (0, _timeseries.minTimeseriesUnit)(series.map(function (s) {
	            return s.data.cols[0].unit;
	        }));
	        xInterval = (0, _timeseries.computeTimeseriesDataInverval)(xValues, unit);
	    } else if (isQuantitative || isHistogram) {
	        if (firstSeries.data.cols[0].binning_info) {
	            // Get the bin width from binning_info, if available
	            // TODO: multiseries?
	            xInterval = firstSeries.data.cols[0].binning_info.bin_width;
	        } else {
	            // Otherwise try to infer from the X values
	            xInterval = (0, _numeric.computeNumericDataInverval)(xValues);
	        }
	    }
	
	    if (settings["line.missing"] === "zero" || settings["line.missing"] === "none") {
	        var fillValue = settings["line.missing"] === "zero" ? 0 : null;
	        if (isTimeseries) {
	            // $FlowFixMe
	            var _xInterval = xInterval,
	                interval = _xInterval.interval,
	                count = _xInterval.count;
	
	            if (count <= MAX_FILL_COUNT) {
	                // replace xValues with
	                xValues = _d3.default.time[interval].range(xDomain[0], (0, _moment2.default)(xDomain[1]).add(1, "ms"), count).map(function (d) {
	                    return (0, _moment2.default)(d);
	                });
	                datas = fillMissingValues(datas, xValues, fillValue, function (m) {
	                    return _d3.default.round(m.toDate().getTime(), -1);
	                } // sometimes rounds up 1ms?
	                );
	            }
	        }if (isQuantitative || isHistogram) {
	            // $FlowFixMe
	            var _count = Math.abs((xDomain[1] - xDomain[0]) / xInterval);
	            if (_count <= MAX_FILL_COUNT) {
	                var _xDomain = _slicedToArray(xDomain, 2),
	                    start = _xDomain[0],
	                    end = _xDomain[1];
	
	                if (isHistogramBar) {
	                    // NOTE: intentionally add an end point for bar histograms
	                    // $FlowFixMe
	                    end += xInterval * 1.5;
	                } else {
	                    // NOTE: avoid including endpoint due to floating point error
	                    // $FlowFixMe
	                    end += xInterval * 0.5;
	                }
	                xValues = _d3.default.range(start, end, xInterval);
	                datas = fillMissingValues(datas, xValues, fillValue,
	                // NOTE: normalize to xInterval to avoid floating point issues
	                function (v) {
	                    return Math.round(v / xInterval);
	                });
	            }
	        } else {
	            datas = fillMissingValues(datas, xValues, fillValue);
	        }
	    }
	
	    if (isScalarSeries) {
	        xValues = datas.map(function (data) {
	            return data[0][0];
	        });
	    }
	
	    var dimension = void 0,
	        groups = void 0,
	        yAxisSplit = void 0;
	
	    var isScatter = chartType === "scatter";
	    var isStacked = settings["stackable.stack_type"] && datas.length > 1;
	    var isNormalized = isStacked && settings["stackable.stack_type"] === "normalized";
	
	    if (isScatter) {
	        var dataset = (0, _crossfilter2.default)();
	        datas.map(function (data) {
	            return dataset.add(data);
	        });
	
	        dimension = dataset.dimension(function (row) {
	            return row;
	        });
	        groups = datas.map(function (data) {
	            var dim = (0, _crossfilter2.default)(data).dimension(function (row) {
	                return row;
	            });
	            return [dim.group().reduceSum(function (d) {
	                return d[2] || 1;
	            })];
	        });
	    } else if (isStacked) {
	        var _dataset = (0, _crossfilter2.default)();
	
	        // get the sum of the metric for each dimension value in order to scale
	        var scaleFactors = {};
	        if (isNormalized) {
	            var _iteratorNormalCompletion11 = true;
	            var _didIteratorError11 = false;
	            var _iteratorError11 = undefined;
	
	            try {
	                for (var _iterator11 = datas[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	                    var data = _step11.value;
	                    var _iteratorNormalCompletion12 = true;
	                    var _didIteratorError12 = false;
	                    var _iteratorError12 = undefined;
	
	                    try {
	                        for (var _iterator12 = data[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	                            var _step12$value = _slicedToArray(_step12.value, 2),
	                                d = _step12$value[0],
	                                m = _step12$value[1];
	
	                            scaleFactors[d] = (scaleFactors[d] || 0) + m;
	                        }
	                    } catch (err) {
	                        _didIteratorError12 = true;
	                        _iteratorError12 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion12 && _iterator12.return) {
	                                _iterator12.return();
	                            }
	                        } finally {
	                            if (_didIteratorError12) {
	                                throw _iteratorError12;
	                            }
	                        }
	                    }
	                }
	
	                // $FlowFixMe
	            } catch (err) {
	                _didIteratorError11 = true;
	                _iteratorError11 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
	                        _iterator11.return();
	                    }
	                } finally {
	                    if (_didIteratorError11) {
	                        throw _iteratorError11;
	                    }
	                }
	            }
	
	            series = series.map(function (s) {
	                return (0, _icepick.updateIn)(s, ["data", "cols", 1], function (col) {
	                    return _extends({}, col, {
	                        display_name: "% " + (0, _utils.getFriendlyName)(col)
	                    });
	                });
	            });
	        }
	
	        datas.map(function (data, i) {
	            return _dataset.add(data.map(function (d) {
	                var _ref11;
	
	                return _ref11 = {}, _defineProperty(_ref11, 0, d[0]), _defineProperty(_ref11, i + 1, isNormalized ? d[1] / scaleFactors[d[0]] : d[1]), _ref11;
	            }));
	        });
	
	        dimension = _dataset.dimension(function (d) {
	            return d[0];
	        });
	        groups = [datas.map(function (data, seriesIndex) {
	            return reduceGroup(dimension.group(), seriesIndex + 1, function () {
	                return warn(UNAGGREGATED_DATA_WARNING(series[seriesIndex].data.cols[0]));
	            });
	        })];
	    } else {
	        var _dataset2 = (0, _crossfilter2.default)();
	        datas.map(function (data) {
	            return _dataset2.add(data);
	        });
	
	        dimension = _dataset2.dimension(function (d) {
	            return d[0];
	        });
	        groups = datas.map(function (data, seriesIndex) {
	            // If the value is empty, pass a dummy array to crossfilter
	            data = data.length > 0 ? data : [[null, null]];
	
	            var dim = (0, _crossfilter2.default)(data).dimension(function (d) {
	                return d[0];
	            });
	
	            return data[0].slice(1).map(function (_, metricIndex) {
	                return reduceGroup(dim.group(), metricIndex + 1, function () {
	                    return warn(UNAGGREGATED_DATA_WARNING(series[seriesIndex].data.cols[0]));
	                });
	            });
	        });
	    }
	
	    var yExtents = groups.map(function (group) {
	        return _d3.default.extent(group[0].all(), function (d) {
	            return d.value;
	        });
	    });
	    var yExtent = _d3.default.extent((_ref12 = []).concat.apply(_ref12, _toConsumableArray(yExtents)));
	
	    // don't auto-split if the metric columns are all identical, i.e. it's a breakout multiseries
	    var hasDifferentYAxisColumns = _underscore2.default.uniq(series.map(function (s) {
	        return s.data.cols[1];
	    })).length > 1;
	    if (!isScalarSeries && !isScatter && !isStacked && hasDifferentYAxisColumns && settings["graph.y_axis.auto_split"] !== false) {
	        yAxisSplit = (0, _utils.computeSplit)(yExtents);
	    } else {
	        yAxisSplit = [series.map(function (s, i) {
	            return i;
	        })];
	    }
	
	    // Don't apply to linear or timeseries X-axis since the points are always plotted in order
	    if (!isTimeseries && !isQuantitative) {
	        forceSortedGroupsOfGroups(groups, makeIndexMap(xValues));
	    }
	
	    var parent = _dc2.default.compositeChart(element);
	    initChart(parent, element);
	
	    var isBrushing = false;
	    var onBrushChange = function onBrushChange() {
	        isBrushing = true;
	    };
	    var onBrushEnd = function onBrushEnd(range) {
	        isBrushing = false;
	        if (range) {
	            var column = series[0].data.cols[0];
	            var card = series[0].card;
	
	            var _range = _slicedToArray(range, 2),
	                _start = _range[0],
	                _end = _range[1];
	
	            if (isDimensionTimeseries) {
	                onChangeCardAndRun({ nextCard: (0, _actions.updateDateTimeFilter)(card, column, _start, _end), previousCard: card });
	            } else {
	                onChangeCardAndRun({ nextCard: (0, _actions.updateNumericFilter)(card, column, _start, _end), previousCard: card });
	            }
	        }
	    };
	
	    var charts = groups.map(function (group, index) {
	        var chart = getDcjsChart(chartType, parent);
	
	        if (enableBrush) {
	            (0, _brush.initBrush)(parent, chart, onBrushChange, onBrushEnd);
	        }
	
	        // disable clicks
	        chart.onClick = function () {};
	
	        chart.dimension(dimension).group(group[0]).transitionDuration(0).useRightYAxis(yAxisSplit.length > 1 && yAxisSplit[1].includes(index));
	
	        if (isScatter) {
	            chart.keyAccessor(function (d) {
	                return d.key[0];
	            }).valueAccessor(function (d) {
	                return d.key[1];
	            });
	
	            if (chart.radiusValueAccessor) {
	                var isBubble = datas[index][0].length > 2;
	                if (isBubble) {
	                    var BUBBLE_SCALE_FACTOR_MAX = 64;
	                    chart.radiusValueAccessor(function (d) {
	                        return d.value;
	                    }).r(_d3.default.scale.sqrt().domain([0, yExtent[1] * BUBBLE_SCALE_FACTOR_MAX]).range([0, 1]));
	                } else {
	                    chart.radiusValueAccessor(function (d) {
	                        return 1;
	                    });
	                    chart.MIN_RADIUS = 3;
	                }
	                chart.minRadiusWithLabel(Infinity);
	            }
	        }
	
	        if (chart.defined) {
	            chart.defined(settings["line.missing"] === "none" ? function (d) {
	                return d.y != null;
	            } : function (d) {
	                return true;
	            });
	        }
	
	        // multiple series
	        if (groups.length > 1 || isScatter) {
	            // multiple stacks
	            if (group.length > 1) {
	                // compute shades of the assigned color
	                chart.ordinalColors((0, _utils.colorShades)(colors[index % colors.length], group.length));
	            } else {
	                chart.colors(colors[index % colors.length]);
	            }
	        } else {
	            chart.ordinalColors(colors);
	        }
	
	        for (var i = 1; i < group.length; i++) {
	            chart.stack(group[i]);
	        }
	
	        applyChartLineBarSettings(chart, settings, chartType);
	
	        return chart;
	    });
	
	    var onGoalHover = function onGoalHover() {};
	    if (settings["graph.show_goal"]) {
	        var goalValue = settings["graph.goal_value"];
	        var goalData = [[xDomain[0], goalValue], [xDomain[1], goalValue]];
	        var goalDimension = (0, _crossfilter2.default)(goalData).dimension(function (d) {
	            return d[0];
	        });
	        // Take the last point rather than summing in case xDomain[0] === xDomain[1], e.x. when the chart
	        // has just a single row / datapoint
	        var goalGroup = goalDimension.group().reduce(function (p, d) {
	            return d[1];
	        }, function (p, d) {
	            return p;
	        }, function () {
	            return 0;
	        });
	        var goalIndex = charts.length;
	        var goalChart = _dc2.default.lineChart(parent).dimension(goalDimension).group(goalGroup).on('renderlet', function (chart) {
	            // remove "sub" class so the goal is not used in voronoi computation
	            chart.select(".sub._" + goalIndex).classed("sub", false).classed("goal", true);
	        });
	        charts.push(goalChart);
	
	        onGoalHover = function onGoalHover(element) {
	            onHoverChange(element && {
	                element: element,
	                data: [{ key: "Goal", value: goalValue }]
	            });
	        };
	    }
	
	    parent.compose(charts);
	
	    if (groups.length > 1 && !isScalarSeries) {
	        parent.on("renderlet.grouped-bar", function (chart) {
	            // HACK: dc.js doesn't support grouped bar charts so we need to manually resize/reposition them
	            // https://github.com/dc-js/dc.js/issues/558
	            var barCharts = chart.selectAll(".sub rect:first-child")[0].map(function (node) {
	                return node.parentNode.parentNode.parentNode;
	            });
	            if (barCharts.length > 0) {
	                var oldBarWidth = parseFloat(barCharts[0].querySelector("rect").getAttribute("width"));
	                var newBarWidthTotal = oldBarWidth / barCharts.length;
	                var seriesPadding = newBarWidthTotal < 4 ? 0 : newBarWidthTotal < 8 ? 1 : 2;
	                var newBarWidth = Math.max(1, newBarWidthTotal - seriesPadding);
	
	                chart.selectAll("g.sub rect").attr("width", newBarWidth);
	                barCharts.forEach(function (barChart, index) {
	                    barChart.setAttribute("transform", "translate(" + (newBarWidth + seriesPadding) * index + ", 0)");
	                });
	            }
	        });
	    } else if (isHistogramBar) {
	        parent.on("renderlet.histogram-bar", function (chart) {
	            var barCharts = chart.selectAll(".sub rect:first-child")[0].map(function (node) {
	                return node.parentNode.parentNode.parentNode;
	            });
	            if (barCharts.length > 0) {
	                // manually size bars to fill space, minus 1 pixel padding
	                var bars = barCharts[0].querySelectorAll("rect");
	                var barWidth = parseFloat(bars[0].getAttribute("width"));
	                var newBarWidth = parseFloat(bars[1].getAttribute("x")) - parseFloat(bars[0].getAttribute("x")) - 1;
	                if (newBarWidth > barWidth) {
	                    chart.selectAll("g.sub .bar").attr("width", newBarWidth);
	                }
	
	                // shift half of bar width so ticks line up with start of each bar
	                var _iteratorNormalCompletion13 = true;
	                var _didIteratorError13 = false;
	                var _iteratorError13 = undefined;
	
	                try {
	                    for (var _iterator13 = barCharts[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	                        var barChart = _step13.value;
	
	                        barChart.setAttribute("transform", "translate(" + barWidth / 2 + ", 0)");
	                    }
	                } catch (err) {
	                    _didIteratorError13 = true;
	                    _iteratorError13 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion13 && _iterator13.return) {
	                            _iterator13.return();
	                        }
	                    } finally {
	                        if (_didIteratorError13) {
	                            throw _iteratorError13;
	                        }
	                    }
	                }
	            }
	        });
	    }
	
	    // HACK: compositeChart + ordinal X axis shenanigans
	    if (chartType === "bar") {
	        parent._rangeBandPadding(BAR_PADDING_RATIO); // https://github.com/dc-js/dc.js/issues/678
	    } else {
	        parent._rangeBandPadding(1); // https://github.com/dc-js/dc.js/issues/662
	    }
	
	    // x-axis settings
	    if (isTimeseries) {
	        applyChartTimeseriesXAxis(parent, settings, series, xValues, xDomain, xInterval);
	    } else if (isQuantitative) {
	        applyChartQuantitativeXAxis(parent, settings, series, xValues, xDomain, xInterval);
	    } else {
	        applyChartOrdinalXAxis(parent, settings, series, xValues);
	    }
	
	    // override tick format for bars. ticks are aligned with beginning of bar, so just show the start value
	    if (isHistogramBar) {
	        parent.xAxis().tickFormat(function (d) {
	            return (0, _formatting.formatNumber)(d);
	        });
	    }
	
	    // y-axis settings
	
	    var _yAxisSplit$map = yAxisSplit.map(function (indexes) {
	        var _ref13;
	
	        return {
	            series: indexes.map(function (index) {
	                return series[index];
	            }),
	            extent: _d3.default.extent((_ref13 = []).concat.apply(_ref13, _toConsumableArray(indexes.map(function (index) {
	                return yExtents[index];
	            }))))
	        };
	    }),
	        _yAxisSplit$map2 = _slicedToArray(_yAxisSplit$map, 2),
	        left = _yAxisSplit$map2[0],
	        right = _yAxisSplit$map2[1];
	
	    if (left && left.series.length > 0) {
	        applyChartYAxis(parent, settings, left.series, left.extent, "left");
	    }
	    if (right && right.series.length > 0) {
	        applyChartYAxis(parent, settings, right.series, right.extent, "right");
	    }
	    var isSplitAxis = right && right.series.length && left && left.series.length > 0;
	
	    applyChartTooltips(parent, series, isStacked, isNormalized, isScalarSeries, function (hovered) {
	        // disable tooltips while brushing
	        if (onHoverChange && !isBrushing) {
	            // disable tooltips on lines
	            if (hovered && hovered.element && hovered.element.classList.contains("line")) {
	                delete hovered.element;
	            }
	            onHoverChange(hovered);
	        }
	    }, onVisualizationClick);
	
	    // render
	    parent.render();
	
	    // apply any on-rendering functions
	    lineAndBarOnRender(parent, settings, onGoalHover, isSplitAxis, isStacked);
	
	    // only ordinal axis can display "null" values
	    if (isOrdinal) {
	        delete warnings[NULL_DIMENSION_WARNING];
	    }
	
	    onRender && onRender({
	        yAxisSplit: yAxisSplit,
	        warnings: Object.keys(warnings)
	    });
	
	    return parent;
	}
	
	var lineRenderer = exports.lineRenderer = function lineRenderer(element, props) {
	    return lineAreaBar(element, _extends({}, props, { chartType: "line" }));
	};
	var areaRenderer = exports.areaRenderer = function areaRenderer(element, props) {
	    return lineAreaBar(element, _extends({}, props, { chartType: "area" }));
	};
	var barRenderer = exports.barRenderer = function barRenderer(element, props) {
	    return lineAreaBar(element, _extends({}, props, { chartType: "bar" }));
	};
	var scatterRenderer = exports.scatterRenderer = function scatterRenderer(element, props) {
	    return lineAreaBar(element, _extends({}, props, { chartType: "scatter" }));
	};
	
	function rowRenderer(element, _ref14) {
	    var settings = _ref14.settings,
	        series = _ref14.series,
	        onHoverChange = _ref14.onHoverChange,
	        onVisualizationClick = _ref14.onVisualizationClick,
	        height = _ref14.height;
	    var cols = series[0].data.cols;
	
	
	    if (series.length > 1) {
	        throw new Error("Row chart does not support multiple series");
	    }
	
	    var chart = _dc2.default.rowChart(element);
	
	    // disable clicks
	    chart.onClick = function () {};
	
	    var colors = settings["graph.colors"];
	
	    var formatDimension = function formatDimension(row) {
	        return (0, _formatting.formatValue)(row[0], { column: cols[0], type: "axis" });
	    };
	
	    // dc.js doesn't give us a way to format the row labels from unformatted data, so we have to
	    // do it here then construct a mapping to get the original dimension for tooltipsd/clicks
	    var rows = series[0].data.rows.map(function (row) {
	        return [formatDimension(row), row[1]];
	    });
	    var formattedDimensionMap = new Map(rows.map(function (_ref15, index) {
	        var _ref16 = _slicedToArray(_ref15, 1),
	            formattedDimension = _ref16[0];
	
	        return [formattedDimension, series[0].data.rows[index][0]];
	    }));
	
	    var dataset = (0, _crossfilter2.default)(rows);
	    var dimension = dataset.dimension(function (d) {
	        return d[0];
	    });
	    var group = dimension.group().reduceSum(function (d) {
	        return d[1];
	    });
	    var xDomain = _d3.default.extent(rows, function (d) {
	        return d[1];
	    });
	    var yValues = rows.map(function (d) {
	        return d[0];
	    });
	
	    forceSortedGroup(group, makeIndexMap(yValues));
	
	    initChart(chart, element);
	
	    chart.on("renderlet.tooltips", function (chart) {
	        if (onHoverChange) {
	            chart.selectAll(".row rect").on("mousemove", function (d, i) {
	                onHoverChange && onHoverChange({
	                    // for single series bar charts, fade the series and highlght the hovered element with CSS
	                    index: -1,
	                    event: _d3.default.event,
	                    data: [{ key: (0, _utils.getFriendlyName)(cols[0]), value: formattedDimensionMap.get(d.key), col: cols[0] }, { key: (0, _utils.getFriendlyName)(cols[1]), value: d.value, col: cols[1] }]
	                });
	            }).on("mouseleave", function () {
	                onHoverChange && onHoverChange(null);
	            });
	        }
	
	        if (onVisualizationClick) {
	            chart.selectAll(".row rect").on("click", function (d) {
	                onVisualizationClick({
	                    value: d.value,
	                    column: cols[1],
	                    dimensions: [{
	                        value: formattedDimensionMap.get(d.key),
	                        column: cols[0]
	                    }],
	                    element: this
	                });
	            });
	        }
	    });
	
	    chart.ordinalColors([colors[0]]).x(_d3.default.scale.linear().domain(xDomain)).elasticX(true).dimension(dimension).group(group).ordering(function (d) {
	        return d.index;
	    });
	
	    var labelPadHorizontal = 5;
	    var labelPadVertical = 1;
	    var labelsOutside = false;
	
	    chart.on("renderlet.bar-labels", function (chart) {
	        chart.selectAll("g.row text").attr("text-anchor", labelsOutside ? "end" : "start").attr("x", labelsOutside ? -labelPadHorizontal : labelPadHorizontal).classed(labelsOutside ? "outside" : "inside", true);
	    });
	
	    if (settings["graph.y_axis.labels_enabled"]) {
	        chart.on("renderlet.axis-labels", function (chart) {
	            chart.svg().append("text").attr("class", "x-axis-label").attr("text-anchor", "middle").attr("x", chart.width() / 2).attr("y", chart.height() - 10).text(settings["graph.y_axis.title_text"]);
	        });
	    }
	
	    // inital render
	    chart.render();
	
	    // bottom label height
	    var axisLabelHeight = 0;
	    if (settings["graph.y_axis.labels_enabled"]) {
	        axisLabelHeight = chart.select(".x-axis-label").node().getBoundingClientRect().height;
	        chart.margins().bottom += axisLabelHeight;
	    }
	
	    // cap number of rows to fit
	    var rects = chart.selectAll(".row rect")[0];
	    var containerHeight = rects[rects.length - 1].getBoundingClientRect().bottom - rects[0].getBoundingClientRect().top;
	    var maxTextHeight = Math.max.apply(Math, _toConsumableArray(chart.selectAll("g.row text")[0].map(function (e) {
	        return e.getBoundingClientRect().height;
	    })));
	    var rowHeight = maxTextHeight + chart.gap() + labelPadVertical * 2;
	    var cap = Math.max(1, Math.floor(containerHeight / rowHeight));
	    chart.cap(cap);
	
	    chart.render();
	
	    // check if labels overflow after rendering correct number of rows
	    var maxTextWidth = 0;
	    var _iteratorNormalCompletion14 = true;
	    var _didIteratorError14 = false;
	    var _iteratorError14 = undefined;
	
	    try {
	        for (var _iterator14 = chart.selectAll("g.row")[0][Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	            var elem = _step14.value;
	
	            var rect = elem.querySelector("rect").getBoundingClientRect();
	            var text = elem.querySelector("text").getBoundingClientRect();
	            maxTextWidth = Math.max(maxTextWidth, text.width);
	            if (rect.width < text.width + labelPadHorizontal * 2) {
	                labelsOutside = true;
	            }
	        }
	    } catch (err) {
	        _didIteratorError14 = true;
	        _iteratorError14 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion14 && _iterator14.return) {
	                _iterator14.return();
	            }
	        } finally {
	            if (_didIteratorError14) {
	                throw _iteratorError14;
	            }
	        }
	    }
	
	    if (labelsOutside) {
	        chart.margins().left += maxTextWidth;
	        chart.render();
	    }
	}

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.dimensionIsTimeseries = dimensionIsTimeseries;
	exports.minTimeseriesUnit = minTimeseriesUnit;
	exports.computeTimeseriesDataInverval = computeTimeseriesDataInverval;
	exports.computeTimeseriesTicksInterval = computeTimeseriesTicksInterval;
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _time = __webpack_require__(876);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	
	var TIMESERIES_UNITS = new Set(["minute", "hour", "day", "week", "month", "quarter", "year" // https://github.com/metabase/metabase/issues/1992
	]);
	
	// investigate the response from a dataset query and determine if the dimension is a timeseries
	function dimensionIsTimeseries(_ref) {
	    var cols = _ref.cols,
	        rows = _ref.rows;
	    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    return (0, _schema_metadata.isDate)(cols[i]) && (cols[i].unit == null || TIMESERIES_UNITS.has(cols[i].unit)) || (0, _moment2.default)(rows[0] && rows[0][i], _moment2.default.ISO_8601).isValid();
	}
	
	// mostly matches
	// https://github.com/mbostock/d3/wiki/Time-Scales
	// https://github.com/mbostock/d3/wiki/Time-Intervals
	// Use UTC methods to avoid issues with daylight savings
	// NOTE: smaller modulos within an interval type must be multiples of larger ones (e.x. can't do both 2 days and 7 days i.e. week)
	var TIMESERIES_INTERVALS = [{ interval: "ms", count: 1, testFn: function testFn(d) {
	        return 0;
	    } }, //  (0) millisecond
	{ interval: "second", count: 1, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).milliseconds();
	    } }, //  (1) 1 second
	{ interval: "second", count: 5, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).seconds() % 5;
	    } }, //  (2) 5 seconds
	{ interval: "second", count: 15, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).seconds() % 15;
	    } }, //  (3) 15 seconds
	{ interval: "second", count: 30, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).seconds() % 30;
	    } }, //  (4) 30 seconds
	{ interval: "minute", count: 1, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).seconds();
	    } }, //  (5) 1 minute
	{ interval: "minute", count: 5, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).minutes() % 5;
	    } }, //  (6) 5 minutes
	{ interval: "minute", count: 15, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).minutes() % 15;
	    } }, //  (7) 15 minutes
	{ interval: "minute", count: 30, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).minutes() % 30;
	    } }, //  (8) 30 minutes
	{ interval: "hour", count: 1, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).minutes();
	    } }, //  (9) 1 hour
	{ interval: "hour", count: 3, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).hours() % 3;
	    } }, // (10) 3 hours
	{ interval: "hour", count: 6, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).hours() % 6;
	    } }, // (11) 6 hours
	{ interval: "hour", count: 12, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).hours() % 12;
	    } }, // (12) 12 hours
	{ interval: "day", count: 1, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).hours();
	    } }, // (13) 1 day
	{ interval: "week", count: 1, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).date() % 7;
	    } }, // (14) 7 days / 1 week
	{ interval: "month", count: 1, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).date();
	    } }, // (15) 1 months
	{ interval: "month", count: 3, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).month() % 3;
	    } }, // (16) 3 months / 1 quarter
	{ interval: "year", count: 1, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).month();
	    } }, // (17) 1 year
	{ interval: "year", count: 5, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).year() % 5;
	    } }, // (18) 5 year
	{ interval: "year", count: 10, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).year() % 10;
	    } }, // (19) 10 year
	{ interval: "year", count: 50, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).year() % 50;
	    } }, // (20) 50 year
	{ interval: "year", count: 100, testFn: function testFn(d) {
	        return (0, _time.parseTimestamp)(d).year() % 100;
	    } } // (21) 100 year
	];
	
	// mapping from Metabase "unit" to d3 intervals above
	var INTERVAL_INDEX_BY_UNIT = {
	    "minute": 1,
	    "hour": 9,
	    "day": 13,
	    "week": 14,
	    "month": 15,
	    "quarter": 16,
	    "year": 17
	};
	
	function minTimeseriesUnit(units) {
	    return units.reduce(function (minUnit, unit) {
	        return unit != null && (minUnit == null || INTERVAL_INDEX_BY_UNIT[unit] < INTERVAL_INDEX_BY_UNIT[minUnit]) ? unit : minUnit;
	    }, null);
	}
	
	function computeTimeseriesDataInvervalIndex(xValues, unit) {
	    if (unit && INTERVAL_INDEX_BY_UNIT[unit] != undefined) {
	        return INTERVAL_INDEX_BY_UNIT[unit];
	    }
	    // Keep track of the value seen for each level of granularity,
	    // if any don't match then we know the data is *at least* that granular.
	    var values = [];
	    var index = TIMESERIES_INTERVALS.length;
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = xValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var xValue = _step.value;
	
	            // Only need to check more granular than the current interval
	            for (var i = 0; i < TIMESERIES_INTERVALS.length && i < index; i++) {
	                var interval = TIMESERIES_INTERVALS[i];
	                var value = interval.testFn(xValue);
	                if (values[i] === undefined) {
	                    values[i] = value;
	                } else if (values[i] !== value) {
	                    index = i;
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return index - 1;
	}
	
	function computeTimeseriesDataInverval(xValues, unit) {
	    return TIMESERIES_INTERVALS[computeTimeseriesDataInvervalIndex(xValues, unit)];
	}
	
	function computeTimeseriesTicksInterval(xDomain, xInterval, chartWidth, minPixels) {
	    // If the interval that matches the data granularity results in too many ticks reduce the granularity until it doesn't.
	    // TODO: compute this directly instead of iteratively
	    var maxTickCount = Math.round(chartWidth / minPixels);
	    var index = _underscore2.default.findIndex(TIMESERIES_INTERVALS, function (_ref2) {
	        var interval = _ref2.interval,
	            count = _ref2.count;
	        return interval === xInterval.interval && count === xInterval.count;
	    });
	    while (index < TIMESERIES_INTERVALS.length - 1) {
	        var interval = TIMESERIES_INTERVALS[index];
	        var intervalMs = (0, _moment2.default)(0).add(interval.count, interval.interval).valueOf();
	        var tickCount = (xDomain[1] - xDomain[0]) / intervalMs;
	        if (tickCount <= maxTickCount) {
	            break;
	        }
	        index++;
	    }
	    return TIMESERIES_INTERVALS[index];
	}

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.determineSeriesIndexFromElement = determineSeriesIndexFromElement;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/*  weak */
	
	function getElementIndex(e) {
	    return e && [].concat(_toConsumableArray(e.classList)).map(function (c) {
	        return c.match(/^_(\d+)$/);
	    }).filter(function (c) {
	        return c;
	    }).map(function (c) {
	        return parseInt(c[1], 10);
	    })[0];
	}
	
	function getParentWithClass(element, className) {
	    while (element) {
	        if (element.classList && element.classList.contains(className)) {
	            return element;
	        }
	        element = element.parentNode;
	    }
	    return null;
	}
	
	// HACK: This determines the index of the series the provided element belongs to since DC doesn't seem to provide another way
	function determineSeriesIndexFromElement(element, isStacked) {
	    if (isStacked) {
	        if (element.classList.contains("dot")) {
	            // .dots are children of dc-tooltip
	            return getElementIndex(getParentWithClass(element, "dc-tooltip"));
	        } else {
	            return getElementIndex(getParentWithClass(element, "stack"));
	        }
	    } else {
	        return getElementIndex(getParentWithClass(element, "sub"));
	    }
	}

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initBrush = initBrush;
	
	var _keyboard = __webpack_require__(934);
	
	var _dom = __webpack_require__(859);
	
	function initBrush(parent, child, onBrushChange, onBrushEnd) {
	    if (!parent.brushOn || !child.brushOn) {
	        return;
	    }
	
	    // enable brush
	    parent.brushOn(true);
	    child.brushOn(true);
	
	    // normally dots are disabled if brush is on but we want them anyway
	    if (child.xyTipsOn) {
	        child.xyTipsOn("always");
	    }
	
	    // the brush has been cancelled by pressing escape
	    var cancelled = false;
	    // the last updated range when brushing
	    var range = null;
	
	    // start
	    parent.brush().on("brushstart.custom", function () {
	        // reset "range"
	        range = null;
	        // reset "cancelled" flag
	        cancelled = false;
	        // add "dragging" class to chart
	        parent.svg().classed("dragging", true);
	        // move the brush element to the front
	        (0, _dom.moveToFront)(parent.select(".brush").node());
	        // add an escape keydown listener
	        window.addEventListener("keydown", onKeyDown, true);
	    });
	
	    // change
	    child.addFilterHandler(function (filters, r) {
	        // update "range" with new filter range
	        range = r;
	
	        // emit "onBrushChange" event
	        onBrushChange(range);
	
	        // fade deselected bars
	        parent.fadeDeselectedArea();
	
	        // return filters unmodified
	        return filters;
	    });
	
	    // end
	    parent.brush().on("brushend.custom", function () {
	        // remove the "dragging" classed
	        parent.svg().classed("dragging", false);
	        // reset brush opacity (if the brush was cancelled)
	        parent.select(".brush").style("opacity", 1);
	        // move the brush to the back
	        (0, _dom.moveToBack)(parent.select(".brush").node());
	        // remove the escape keydown listener
	        window.removeEventListener("keydown", onKeyDown, true);
	        // reset the fitler and redraw
	        child.filterAll();
	        parent.redraw();
	
	        // if not cancelled, emit the onBrushEnd event with the last filter range
	        onBrushEnd(cancelled ? null : range);
	        range = null;
	    });
	
	    // cancel
	    var onKeyDown = function onKeyDown(e) {
	        if (e.keyCode === _keyboard.KEYCODE_ESCAPE) {
	            // set the "cancelled" flag
	            cancelled = true;
	            // dispatch a mouseup to end brushing early
	            window.dispatchEvent(new MouseEvent("mouseup"));
	        }
	    };
	
	    parent.on("pretransition.custom", function (chart) {
	        // move brush to the back so tootips/clicks still work
	        (0, _dom.moveToBack)(chart.select(".brush").node());
	        // remove the handles since we can't adjust them anyway
	        chart.selectAll(".brush .resize").remove();
	    });
	}

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.lineAddons = undefined;
	
	var _dc = __webpack_require__(1372);
	
	var _dc2 = _interopRequireDefault(_dc);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	
	var lineAddons = exports.lineAddons = function lineAddons(_chart) {
	    _chart.fadeDeselectedArea = function () {
	        var dots = _chart.chartBodyG().selectAll(".dot");
	        var extent = _chart.brush().extent();
	
	        if (_chart.isOrdinal()) {
	            if (_chart.hasFilter()) {
	                dots.classed(_dc2.default.constants.SELECTED_CLASS, function (d) {
	                    return _chart.hasFilter(d.x);
	                });
	                dots.classed(_dc2.default.constants.DESELECTED_CLASS, function (d) {
	                    return !_chart.hasFilter(d.x);
	                });
	            } else {
	                dots.classed(_dc2.default.constants.SELECTED_CLASS, false);
	                dots.classed(_dc2.default.constants.DESELECTED_CLASS, false);
	            }
	        } else {
	            if (!_chart.brushIsEmpty(extent)) {
	                var start = extent[0];
	                var end = extent[1];
	                var isSelected = function isSelected(d) {
	                    if (_moment2.default.isDate(start)) {
	                        return !((0, _moment2.default)(d.x).isBefore(start) || (0, _moment2.default)(d.x).isAfter(end));
	                    } else {
	                        return !(d.x < start || d.x >= end);
	                    }
	                };
	                dots.classed(_dc2.default.constants.DESELECTED_CLASS, function (d) {
	                    return !isSelected(d);
	                });
	                dots.classed(_dc2.default.constants.SELECTED_CLASS, function (d) {
	                    return isSelected(d);
	                });
	            } else {
	                dots.classed(_dc2.default.constants.DESELECTED_CLASS, false);
	                dots.classed(_dc2.default.constants.SELECTED_CLASS, false);
	            }
	        }
	    };
	
	    return _chart;
	};

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GRAPH_AXIS_SETTINGS = exports.GRAPH_COLORS_SETTINGS = exports.LINE_SETTINGS_2 = exports.GRAPH_GOAL_SETTINGS = exports.STACKABLE_SETTINGS = exports.LINE_SETTINGS = exports.GRAPH_BUBBLE_SETTINGS = exports.GRAPH_DATA_SETTINGS = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _formatting = __webpack_require__(872);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _settings = __webpack_require__(1376);
	
	var _utils = __webpack_require__(878);
	
	var _numeric = __webpack_require__(882);
	
	var _timeseries = __webpack_require__(1390);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSeriesTitles(series, vizSettings) {
	    return series.map(function (s) {
	        return s.card.name;
	    });
	}
	
	var GRAPH_DATA_SETTINGS = exports.GRAPH_DATA_SETTINGS = {
	    "graph._dimension_filter": {
	        getDefault: function getDefault(_ref) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                card = _ref2[0].card;
	
	            return card.display === "scatter" ? _schema_metadata.isAny : _schema_metadata.isDimension;
	        },
	        useRawSeries: true
	    },
	    "graph._metric_filter": {
	        getDefault: function getDefault(_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 1),
	                card = _ref4[0].card;
	
	            return card.display === "scatter" ? _schema_metadata.isNumeric : _schema_metadata.isMetric;
	        },
	        useRawSeries: true
	    },
	    "graph.dimensions": {
	        section: "Data",
	        title: "X-axis",
	        widget: "fields",
	        isValid: function isValid(_ref5, vizSettings) {
	            var _ref6 = _slicedToArray(_ref5, 1),
	                _ref6$ = _ref6[0],
	                card = _ref6$.card,
	                data = _ref6$.data;
	
	            return (0, _utils.columnsAreValid)(card.visualization_settings["graph.dimensions"], data, vizSettings["graph._dimension_filter"]) && (0, _utils.columnsAreValid)(card.visualization_settings["graph.metrics"], data, vizSettings["graph._metric_filter"]);
	        },
	        getDefault: function getDefault(series, vizSettings) {
	            return (0, _settings.getDefaultColumns)(series).dimensions;
	        },
	        getProps: function getProps(_ref7, vizSettings) {
	            var _ref8 = _slicedToArray(_ref7, 1),
	                _ref8$ = _ref8[0],
	                card = _ref8$.card,
	                data = _ref8$.data;
	
	            var value = vizSettings["graph.dimensions"];
	            var options = data.cols.filter(vizSettings["graph._dimension_filter"]).map(_settings.getOptionFromColumn);
	            return {
	                options: options,
	                addAnother: options.length > value.length && value.length < 2 && vizSettings["graph.metrics"].length < 2 ? "Add a series breakout..." : null
	            };
	        },
	        readDependencies: ["graph._dimension_filter", "graph._metric_filter"],
	        writeDependencies: ["graph.metrics"],
	        dashboard: false,
	        useRawSeries: true
	    },
	    "graph.metrics": {
	        section: "Data",
	        title: "Y-axis",
	        widget: "fields",
	        isValid: function isValid(_ref9, vizSettings) {
	            var _ref10 = _slicedToArray(_ref9, 1),
	                _ref10$ = _ref10[0],
	                card = _ref10$.card,
	                data = _ref10$.data;
	
	            return (0, _utils.columnsAreValid)(card.visualization_settings["graph.dimensions"], data, vizSettings["graph._dimension_filter"]) && (0, _utils.columnsAreValid)(card.visualization_settings["graph.metrics"], data, vizSettings["graph._metric_filter"]);
	        },
	        getDefault: function getDefault(series, vizSettings) {
	            return (0, _settings.getDefaultColumns)(series).metrics;
	        },
	        getProps: function getProps(_ref11, vizSettings) {
	            var _ref12 = _slicedToArray(_ref11, 1),
	                _ref12$ = _ref12[0],
	                card = _ref12$.card,
	                data = _ref12$.data;
	
	            var value = vizSettings["graph.dimensions"];
	            var options = data.cols.filter(vizSettings["graph._metric_filter"]).map(_settings.getOptionFromColumn);
	            return {
	                options: options,
	                addAnother: options.length > value.length && vizSettings["graph.dimensions"].length < 2 ? "Add another series..." : null
	            };
	        },
	        readDependencies: ["graph._dimension_filter", "graph._metric_filter"],
	        writeDependencies: ["graph.dimensions"],
	        dashboard: false,
	        useRawSeries: true
	    }
	};
	
	var GRAPH_BUBBLE_SETTINGS = exports.GRAPH_BUBBLE_SETTINGS = {
	    "scatter.bubble": {
	        section: "Data",
	        title: "Bubble size",
	        widget: "field",
	        isValid: function isValid(_ref13, vizSettings) {
	            var _ref14 = _slicedToArray(_ref13, 1),
	                _ref14$ = _ref14[0],
	                card = _ref14$.card,
	                data = _ref14$.data;
	
	            return (0, _utils.columnsAreValid)([card.visualization_settings["scatter.bubble"]], data, _schema_metadata.isNumeric);
	        },
	        getDefault: function getDefault(series) {
	            return (0, _settings.getDefaultColumns)(series).bubble;
	        },
	        getProps: function getProps(_ref15, vizSettings, onChange) {
	            var _ref16 = _slicedToArray(_ref15, 1),
	                _ref16$ = _ref16[0],
	                card = _ref16$.card,
	                data = _ref16$.data;
	
	            var options = data.cols.filter(_schema_metadata.isNumeric).map(_settings.getOptionFromColumn);
	            return {
	                options: options,
	                onRemove: vizSettings["scatter.bubble"] ? function () {
	                    return onChange(null);
	                } : null
	            };
	        },
	        writeDependencies: ["graph.dimensions"],
	        dashboard: false,
	        useRawSeries: true
	    }
	};
	
	var LINE_SETTINGS = exports.LINE_SETTINGS = {
	    "line.interpolate": {
	        section: "Display",
	        title: "Style",
	        widget: "select",
	        props: {
	            options: [{ name: "Line", value: "linear" }, { name: "Curve", value: "cardinal" }, { name: "Step", value: "step-after" }]
	        },
	        getDefault: function getDefault() {
	            return "linear";
	        }
	    },
	    "line.marker_enabled": {
	        section: "Display",
	        title: "Show point markers on lines",
	        widget: "toggle"
	    }
	};
	
	var STACKABLE_SETTINGS = exports.STACKABLE_SETTINGS = {
	    "stackable.stack_type": {
	        section: "Display",
	        title: "Stacking",
	        widget: "radio",
	        getProps: function getProps(series, vizSettings) {
	            return {
	                options: [{ name: "Don't stack", value: null }, { name: "Stack", value: "stacked" }, { name: "Stack - 100%", value: "normalized" }]
	            };
	        },
	        getDefault: function getDefault(_ref17, vizSettings) {
	            var _ref18 = _slicedToArray(_ref17, 1),
	                _ref18$ = _ref18[0],
	                card = _ref18$.card,
	                data = _ref18$.data;
	
	            return (
	                // legacy setting and default for D-M-M+ charts
	                vizSettings["stackable.stacked"] || card.display === "area" && vizSettings["graph.metrics"].length > 1 ? "stacked" : null
	            );
	        },
	        getHidden: function getHidden(series) {
	            return series.length < 2;
	        },
	        readDependencies: ["graph.metrics"]
	    }
	};
	
	var GRAPH_GOAL_SETTINGS = exports.GRAPH_GOAL_SETTINGS = {
	    "graph.show_goal": {
	        section: "Display",
	        title: "Show goal",
	        widget: "toggle",
	        default: false
	    },
	    "graph.goal_value": {
	        section: "Display",
	        title: "Goal value",
	        widget: "number",
	        default: 0,
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["graph.show_goal"] !== true;
	        },
	        readDependencies: ["graph.show_goal"]
	    }
	};
	
	var LINE_SETTINGS_2 = exports.LINE_SETTINGS_2 = {
	    "line.missing": {
	        section: "Display",
	        title: "Replace missing values with",
	        widget: "select",
	        default: "interpolate",
	        getProps: function getProps(series, vizSettings) {
	            return {
	                options: [{ name: "Zero", value: "zero" }, { name: "Nothing", value: "none" }, { name: "Linear Interpolated", value: "interpolate" }]
	            };
	        }
	    }
	};
	
	var GRAPH_COLORS_SETTINGS = exports.GRAPH_COLORS_SETTINGS = {
	    "graph.colors": {
	        section: "Display",
	        getTitle: function getTitle(_ref19) {
	            var _ref20 = _slicedToArray(_ref19, 1),
	                display = _ref20[0].card.display;
	
	            return (0, _formatting.capitalize)(display === "scatter" ? "bubble" : display) + " colors";
	        },
	        widget: "colors",
	        readDependencies: ["graph.dimensions", "graph.metrics"],
	        getDefault: function getDefault(_ref21, vizSettings) {
	            var _ref22 = _slicedToArray(_ref21, 1),
	                _ref22$ = _ref22[0],
	                card = _ref22$.card,
	                data = _ref22$.data;
	
	            return (0, _utils.getCardColors)(card);
	        },
	        getProps: function getProps(series, vizSettings) {
	            return { seriesTitles: getSeriesTitles(series, vizSettings) };
	        }
	    }
	};
	
	var GRAPH_AXIS_SETTINGS = exports.GRAPH_AXIS_SETTINGS = {
	    "graph.x_axis._is_timeseries": {
	        readDependencies: ["graph.dimensions"],
	        getDefault: function getDefault(_ref23, vizSettings) {
	            var _ref24 = _slicedToArray(_ref23, 1),
	                data = _ref24[0].data;
	
	            return (0, _timeseries.dimensionIsTimeseries)(data, _underscore2.default.findIndex(data.cols, function (c) {
	                return c.name === vizSettings["graph.dimensions"].filter(function (d) {
	                    return d;
	                })[0];
	            }));
	        }
	    },
	    "graph.x_axis._is_numeric": {
	        readDependencies: ["graph.dimensions"],
	        getDefault: function getDefault(_ref25, vizSettings) {
	            var _ref26 = _slicedToArray(_ref25, 1),
	                data = _ref26[0].data;
	
	            return (0, _numeric.dimensionIsNumeric)(data, _underscore2.default.findIndex(data.cols, function (c) {
	                return c.name === vizSettings["graph.dimensions"].filter(function (d) {
	                    return d;
	                })[0];
	            }));
	        }
	    },
	    "graph.x_axis._is_histogram": {
	        getDefault: function getDefault(_ref27, vizSettings) {
	            var _ref28 = _slicedToArray(_ref27, 1),
	                cols = _ref28[0].data.cols;
	
	            return cols[0].binning_info != null;
	        }
	    },
	    "graph.x_axis.scale": {
	        section: "Axes",
	        title: "X-axis scale",
	        widget: "select",
	        default: "ordinal",
	        readDependencies: ["graph.x_axis._is_timeseries", "graph.x_axis._is_numeric", "graph.x_axis._is_histogram"],
	        getDefault: function getDefault(series, vizSettings) {
	            return vizSettings["graph.x_axis._is_histogram"] ? "histogram" : vizSettings["graph.x_axis._is_timeseries"] ? "timeseries" : vizSettings["graph.x_axis._is_numeric"] ? "linear" : "ordinal";
	        },
	        getProps: function getProps(series, vizSettings) {
	            var options = [];
	            if (vizSettings["graph.x_axis._is_timeseries"]) {
	                options.push({ name: "Timeseries", value: "timeseries" });
	            }
	            if (vizSettings["graph.x_axis._is_numeric"]) {
	                options.push({ name: "Linear", value: "linear" });
	                if (!vizSettings["graph.x_axis._is_histogram"]) {
	                    options.push({ name: "Power", value: "pow" });
	                    options.push({ name: "Log", value: "log" });
	                }
	                options.push({ name: "Histogram", value: "histogram" });
	            }
	            options.push({ name: "Ordinal", value: "ordinal" });
	            return { options: options };
	        }
	    },
	    "graph.y_axis.scale": {
	        section: "Axes",
	        title: "Y-axis scale",
	        widget: "select",
	        default: "linear",
	        getProps: function getProps(series, vizSettings) {
	            return {
	                options: [{ name: "Linear", value: "linear" }, { name: "Power", value: "pow" }, { name: "Log", value: "log" }]
	            };
	        }
	    },
	    "graph.x_axis.axis_enabled": {
	        section: "Axes",
	        title: "Show x-axis line and marks",
	        widget: "toggle",
	        default: true
	    },
	    "graph.y_axis.axis_enabled": {
	        section: "Axes",
	        title: "Show y-axis line and marks",
	        widget: "toggle",
	        default: true
	    },
	    "graph.y_axis.auto_range": {
	        section: "Axes",
	        title: "Auto y-axis range",
	        widget: "toggle",
	        default: true
	    },
	    "graph.y_axis.min": {
	        section: "Axes",
	        title: "Min",
	        widget: "number",
	        default: 0,
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["graph.y_axis.auto_range"] !== false;
	        }
	    },
	    "graph.y_axis.max": {
	        section: "Axes",
	        title: "Max",
	        widget: "number",
	        default: 100,
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["graph.y_axis.auto_range"] !== false;
	        }
	    },
	    /*
	      "graph.y_axis_right.auto_range": {
	          section: "Axes",
	          title: "Auto right-hand y-axis range",
	          widget: "toggle",
	          default: true
	      },
	      "graph.y_axis_right.min": {
	          section: "Axes",
	          title: "Min",
	          widget: "number",
	          default: 0,
	          getHidden: (series, vizSettings) => vizSettings["graph.y_axis_right.auto_range"] !== false
	      },
	      "graph.y_axis_right.max": {
	          section: "Axes",
	          title: "Max",
	          widget: "number",
	          default: 100,
	          getHidden: (series, vizSettings) => vizSettings["graph.y_axis_right.auto_range"] !== false
	      },
	    */
	    "graph.y_axis.auto_split": {
	        section: "Axes",
	        title: "Use a split y-axis when necessary",
	        widget: "toggle",
	        default: true,
	        getHidden: function getHidden(series) {
	            return series.length < 2;
	        }
	    },
	    "graph.x_axis.labels_enabled": {
	        section: "Labels",
	        title: "Show label on x-axis",
	        widget: "toggle",
	        default: true
	    },
	    "graph.x_axis.title_text": {
	        section: "Labels",
	        title: "X-axis label",
	        widget: "input",
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["graph.x_axis.labels_enabled"] === false;
	        },
	        getDefault: function getDefault(series, vizSettings) {
	            return series.length === 1 ? (0, _utils.getFriendlyName)(series[0].data.cols[0]) : null;
	        }
	    },
	    "graph.y_axis.labels_enabled": {
	        section: "Labels",
	        title: "Show label on y-axis",
	        widget: "toggle",
	        default: true
	    },
	    "graph.y_axis.title_text": {
	        section: "Labels",
	        title: "Y-axis label",
	        widget: "input",
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["graph.y_axis.labels_enabled"] === false;
	        },
	        getDefault: function getDefault(series, vizSettings) {
	            return series.length === 1 ? (0, _utils.getFriendlyName)(series[0].data.cols[1]) : null;
	        }
	    }
	};

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _LineAreaBarChart2 = __webpack_require__(1370);
	
	var _LineAreaBarChart3 = _interopRequireDefault(_LineAreaBarChart2);
	
	var _LineAreaBarRenderer = __webpack_require__(1389);
	
	var _graph = __webpack_require__(1394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BarChart = (_temp = _class = function (_LineAreaBarChart) {
	    _inherits(BarChart, _LineAreaBarChart);
	
	    function BarChart() {
	        _classCallCheck(this, BarChart);
	
	        return _possibleConstructorReturn(this, (BarChart.__proto__ || Object.getPrototypeOf(BarChart)).apply(this, arguments));
	    }
	
	    return BarChart;
	}(_LineAreaBarChart3.default), _class.uiName = "Bar", _class.identifier = "bar", _class.iconName = "bar", _class.noun = "bar chart", _class.settings = _extends({}, _graph.GRAPH_DATA_SETTINGS, _graph.STACKABLE_SETTINGS, _graph.GRAPH_GOAL_SETTINGS, _graph.GRAPH_COLORS_SETTINGS, _graph.GRAPH_AXIS_SETTINGS), _class.renderer = _LineAreaBarRenderer.barRenderer, _temp);
	exports.default = BarChart;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _LineAreaBarChart2 = __webpack_require__(1370);
	
	var _LineAreaBarChart3 = _interopRequireDefault(_LineAreaBarChart2);
	
	var _LineAreaBarRenderer = __webpack_require__(1389);
	
	var _graph = __webpack_require__(1394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RowChart = (_temp = _class = function (_LineAreaBarChart) {
	    _inherits(RowChart, _LineAreaBarChart);
	
	    function RowChart() {
	        _classCallCheck(this, RowChart);
	
	        return _possibleConstructorReturn(this, (RowChart.__proto__ || Object.getPrototypeOf(RowChart)).apply(this, arguments));
	    }
	
	    return RowChart;
	}(_LineAreaBarChart3.default), _class.uiName = "Row Chart", _class.identifier = "row", _class.iconName = "horizontal_bar", _class.noun = "row chart", _class.supportsSeries = false, _class.renderer = _LineAreaBarRenderer.rowRenderer, _class.settings = _extends({}, _graph.GRAPH_DATA_SETTINGS, _graph.GRAPH_COLORS_SETTINGS), _temp);
	
	// rename these settings
	
	exports.default = RowChart;
	RowChart.settings["graph.metrics"] = _extends({}, RowChart.settings["graph.metrics"], {
	    title: "X-axis"
	});
	RowChart.settings["graph.dimensions"] = _extends({}, RowChart.settings["graph.dimensions"], {
	    title: "Y-axis"
	});

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PieChart = __webpack_require__(1398);
	
	var _PieChart2 = _interopRequireDefault(_PieChart);
	
	var _ChartTooltip = __webpack_require__(1278);
	
	var _ChartTooltip2 = _interopRequireDefault(_ChartTooltip);
	
	var _ChartWithLegend = __webpack_require__(1400);
	
	var _ChartWithLegend2 = _interopRequireDefault(_ChartWithLegend);
	
	var _errors = __webpack_require__(1388);
	
	var _utils = __webpack_require__(878);
	
	var _settings = __webpack_require__(1376);
	
	var _formatting = __webpack_require__(872);
	
	var _colors = __webpack_require__(881);
	
	var colors = _interopRequireWildcard(_colors);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d2 = __webpack_require__(873);
	
	var _d3 = _interopRequireDefault(_d2);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OUTER_RADIUS = 50; // within 100px canvas
	var INNER_RADIUS_RATIO = 3 / 5;
	
	var PAD_ANGLE = Math.PI / 180 * 1; // 1 degree in radians
	var SLICE_THRESHOLD = 1 / 360; // 1 degree in percentage
	var OTHER_SLICE_MIN_PERCENTAGE = 0.003;
	
	var PERCENT_REGEX = /percent/i;
	
	var PieChart = (_temp = _class = function (_Component) {
	    _inherits(PieChart, _Component);
	
	    function PieChart() {
	        _classCallCheck(this, PieChart);
	
	        return _possibleConstructorReturn(this, (PieChart.__proto__ || Object.getPrototypeOf(PieChart)).apply(this, arguments));
	    }
	
	    _createClass(PieChart, [{
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var groupElement = _reactDom2.default.findDOMNode(this.refs.group);
	            var detailElement = _reactDom2.default.findDOMNode(this.refs.detail);
	            if (groupElement.getBoundingClientRect().width < 100) {
	                detailElement.classList.add("hide");
	            } else {
	                detailElement.classList.remove("hide");
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                series = _props.series,
	                hovered = _props.hovered,
	                _onHoverChange = _props.onHoverChange,
	                visualizationIsClickable = _props.visualizationIsClickable,
	                onVisualizationClick = _props.onVisualizationClick,
	                className = _props.className,
	                gridSize = _props.gridSize,
	                settings = _props.settings;
	
	            var _series = _slicedToArray(series, 1),
	                _series$0$data = _series[0].data,
	                cols = _series$0$data.cols,
	                rows = _series$0$data.rows;
	
	            var dimensionIndex = _underscore2.default.findIndex(cols, function (col) {
	                return col.name === settings["pie.dimension"];
	            });
	            var metricIndex = _underscore2.default.findIndex(cols, function (col) {
	                return col.name === settings["pie.metric"];
	            });
	
	            var formatDimension = function formatDimension(dimension) {
	                var jsx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	                return (0, _formatting.formatValue)(dimension, { column: cols[dimensionIndex], jsx: jsx, majorWidth: 0 });
	            };
	            var formatMetric = function formatMetric(metric) {
	                var jsx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	                return (0, _formatting.formatValue)(metric, { column: cols[metricIndex], jsx: jsx, majorWidth: 0 });
	            };
	            var formatPercent = function formatPercent(percent) {
	                return (100 * percent).toFixed(2) + "%";
	            };
	
	            var showPercentInTooltip = !PERCENT_REGEX.test(cols[metricIndex].name) && !PERCENT_REGEX.test(cols[metricIndex].display_name);
	
	            // $FlowFixMe
	            var total = rows.reduce(function (sum, row) {
	                return sum + row[metricIndex];
	            }, 0);
	
	            // use standard colors for up to 5 values otherwise use color harmony to help differentiate slices
	            var sliceColors = Object.values(rows.length > 5 ? colors.harmony : colors.normal);
	            var sliceThreshold = typeof settings["pie.slice_threshold"] === "number" ? settings["pie.slice_threshold"] / 100 : SLICE_THRESHOLD;
	
	            var _$chain$map$partition = _underscore2.default.chain(rows).map(function (row, index) {
	                return {
	                    key: row[dimensionIndex],
	                    value: row[metricIndex],
	                    percentage: row[metricIndex] / total,
	                    color: sliceColors[index % sliceColors.length]
	                };
	            }).partition(function (d) {
	                return d.percentage > sliceThreshold;
	            }).value(),
	                _$chain$map$partition2 = _slicedToArray(_$chain$map$partition, 2),
	                slices = _$chain$map$partition2[0],
	                others = _$chain$map$partition2[1];
	
	            var otherSlice = void 0;
	            if (others.length > 1) {
	                var otherTotal = others.reduce(function (acc, o) {
	                    return acc + o.value;
	                }, 0);
	                if (otherTotal > 0) {
	                    otherSlice = {
	                        key: "Other",
	                        value: otherTotal,
	                        percentage: otherTotal / total,
	                        color: "gray"
	                    };
	                    slices.push(otherSlice);
	                }
	            } else {
	                slices.push.apply(slices, _toConsumableArray(others));
	            }
	
	            // increase "other" slice so it's barely visible
	            if (otherSlice && otherSlice.percentage < OTHER_SLICE_MIN_PERCENTAGE) {
	                otherSlice.value = total * OTHER_SLICE_MIN_PERCENTAGE;
	            }
	
	            var legendTitles = slices.map(function (slice) {
	                return [slice.key === "Other" ? slice.key : formatDimension(slice.key, true), settings["pie.show_legend_perecent"] ? formatPercent(slice.percentage) : undefined];
	            });
	            var legendColors = slices.map(function (slice) {
	                return slice.color;
	            });
	
	            var pie = _d3.default.layout.pie().sort(null).padAngle(PAD_ANGLE).value(function (d) {
	                return d.value;
	            });
	            var arc = _d3.default.svg.arc().outerRadius(OUTER_RADIUS).innerRadius(OUTER_RADIUS * INNER_RADIUS_RATIO);
	
	            var hoverForIndex = function hoverForIndex(index, event) {
	                return {
	                    index: index,
	                    event: event && event.nativeEvent,
	                    data: slices[index] === otherSlice ? others.map(function (o) {
	                        return {
	                            key: formatDimension(o.key, false),
	                            value: formatMetric(o.value, false)
	                        };
	                    }) : [{ key: (0, _utils.getFriendlyName)(cols[dimensionIndex]), value: formatDimension(slices[index].key) }, { key: (0, _utils.getFriendlyName)(cols[metricIndex]), value: formatMetric(slices[index].value) }].concat(showPercentInTooltip ? [{ key: "Percentage", value: formatPercent(slices[index].percentage) }] : [])
	                };
	            };
	
	            var value = void 0,
	                title = void 0;
	            if (hovered && hovered.index != null && slices[hovered.index] !== otherSlice) {
	                title = formatDimension(slices[hovered.index].key);
	                value = formatMetric(slices[hovered.index].value);
	            } else {
	                title = "Total";
	                value = formatMetric(total);
	            }
	
	            var getSliceClickObject = function getSliceClickObject(index) {
	                return {
	                    value: slices[index].value,
	                    column: cols[metricIndex],
	                    dimensions: [{
	                        value: slices[index].key,
	                        column: cols[dimensionIndex]
	                    }]
	                };
	            };
	
	            var isClickable = onVisualizationClick && visualizationIsClickable(getSliceClickObject(0));
	            var getSliceIsClickable = function getSliceIsClickable(index) {
	                return isClickable && slices[index] !== otherSlice;
	            };
	
	            return _react2.default.createElement(
	                _ChartWithLegend2.default,
	                {
	                    className: className,
	                    legendTitles: legendTitles, legendColors: legendColors,
	                    gridSize: gridSize,
	                    hovered: hovered, onHoverChange: function onHoverChange(d) {
	                        return _onHoverChange && _onHoverChange(d && _extends({}, d, hoverForIndex(d.index)));
	                    },
	                    showLegend: settings["pie.show_legend"]
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: _PieChart2.default.ChartAndDetail },
	                    _react2.default.createElement(
	                        "div",
	                        { ref: "detail", className: _PieChart2.default.Detail },
	                        _react2.default.createElement(
	                            "div",
	                            { className: (0, _classnames2.default)(_PieChart2.default.Value, "fullscreen-normal-text fullscreen-night-text") },
	                            value
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _PieChart2.default.Title },
	                            title
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _PieChart2.default.Chart },
	                        _react2.default.createElement(
	                            "svg",
	                            { className: _PieChart2.default.Donut + " m1", viewBox: "0 0 100 100" },
	                            _react2.default.createElement(
	                                "g",
	                                { ref: "group", transform: "translate(50,50)" },
	                                pie(slices).map(function (slice, index) {
	                                    return _react2.default.createElement("path", {
	                                        key: index,
	                                        d: arc(slice),
	                                        fill: slices[index].color,
	                                        opacity: hovered && hovered.index != null && hovered.index !== index ? 0.3 : 1,
	                                        onMouseMove: function onMouseMove(e) {
	                                            return _onHoverChange && _onHoverChange(hoverForIndex(index, e));
	                                        },
	                                        onMouseLeave: function onMouseLeave() {
	                                            return _onHoverChange && _onHoverChange(null);
	                                        },
	                                        className: (0, _classnames2.default)({ "cursor-pointer": getSliceIsClickable(index) }),
	                                        onClick: getSliceIsClickable(index) && function (e) {
	                                            return onVisualizationClick(_extends({}, getSliceClickObject(index), {
	                                                event: e.nativeEvent
	                                            }));
	                                        }
	                                    });
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_ChartTooltip2.default, { series: series, hovered: hovered })
	            );
	        }
	    }], [{
	        key: "isSensible",
	        value: function isSensible(cols, rows) {
	            return cols.length === 2;
	        }
	    }, {
	        key: "checkRenderable",
	        value: function checkRenderable(_ref, settings) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                _ref2$0$data = _ref2[0].data,
	                cols = _ref2$0$data.cols,
	                rows = _ref2$0$data.rows;
	
	            if (!settings["pie.dimension"] || !settings["pie.metric"]) {
	                throw new _errors.ChartSettingsError("Which columns do you want to use?", "Data");
	            }
	        }
	    }]);
	
	    return PieChart;
	}(_react.Component), _class.uiName = "Pie", _class.identifier = "pie", _class.iconName = "pie", _class.minSize = { width: 4, height: 4 }, _class.settings = {
	    "pie.dimension": _extends({
	        section: "Data",
	        title: "Dimension"
	    }, (0, _settings.dimensionSetting)("pie.dimension")),
	    "pie.metric": _extends({
	        section: "Data",
	        title: "Measure"
	    }, (0, _settings.metricSetting)("pie.metric")),
	    "pie.show_legend": {
	        section: "Display",
	        title: "Show legend",
	        widget: "toggle"
	    },
	    "pie.show_legend_perecent": {
	        section: "Display",
	        title: "Show percentages in legend",
	        widget: "toggle",
	        default: true
	    },
	    "pie.slice_threshold": {
	        section: "Display",
	        title: "Minimum slice percentage",
	        widget: "number"
	    }
	}, _temp);
	PieChart.displayName = "PieChart";
	exports.default = PieChart;

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ChartAndDetail":"_2I4qY","Chart":"_1rcAr","Detail":"n71oW","Donut":"_2Gb1p","Value":"_2tU5X","Title":"-GCLu"};

/***/ }),
/* 1399 */,
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChartWithLegend = __webpack_require__(1401);
	
	var _ChartWithLegend2 = _interopRequireDefault(_ChartWithLegend);
	
	var _LegendVertical = __webpack_require__(1403);
	
	var _LegendVertical2 = _interopRequireDefault(_LegendVertical);
	
	var _LegendHorizontal = __webpack_require__(1404);
	
	var _LegendHorizontal2 = _interopRequireDefault(_LegendHorizontal);
	
	var _ExplicitSize = __webpack_require__(1271);
	
	var _ExplicitSize2 = _interopRequireDefault(_ExplicitSize);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GRID_ASPECT_RATIO = 4 / 3;
	var PADDING = 14;
	
	var ChartWithLegend = (0, _ExplicitSize2.default)(_class = (_temp = _class2 = function (_Component) {
	    _inherits(ChartWithLegend, _Component);
	
	    function ChartWithLegend() {
	        _classCallCheck(this, ChartWithLegend);
	
	        return _possibleConstructorReturn(this, (ChartWithLegend.__proto__ || Object.getPrototypeOf(ChartWithLegend)).apply(this, arguments));
	    }
	
	    _createClass(ChartWithLegend, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                legendTitles = _props.legendTitles,
	                legendColors = _props.legendColors,
	                hovered = _props.hovered,
	                onHoverChange = _props.onHoverChange,
	                className = _props.className,
	                gridSize = _props.gridSize,
	                aspectRatio = _props.aspectRatio,
	                height = _props.height,
	                width = _props.width,
	                showLegend = _props.showLegend;
	
	            // padding
	
	            width -= PADDING * 2;
	            height -= PADDING;
	
	            var chartWidth = void 0,
	                chartHeight = void 0,
	                flexChart = false;
	            var type = void 0,
	                LegendComponent = void 0;
	            var isHorizontal = gridSize && gridSize.width > gridSize.height / GRID_ASPECT_RATIO;
	            if (showLegend === false) {
	                type = "small";
	            } else if (!gridSize || isHorizontal && (showLegend || gridSize.width > 4 || gridSize.height > 4)) {
	                type = "horizontal";
	                LegendComponent = _LegendVertical2.default;
	                if (gridSize && gridSize.width < 6) {
	                    legendTitles = legendTitles.map(function (title) {
	                        return Array.isArray(title) ? title.slice(0, 1) : title;
	                    });
	                }
	                var desiredWidth = height * aspectRatio;
	                if (desiredWidth > width * (2 / 3)) {
	                    flexChart = true;
	                } else {
	                    chartWidth = desiredWidth;
	                }
	                chartHeight = height;
	            } else if (!isHorizontal && (showLegend || gridSize.height > 3 && gridSize.width > 2)) {
	                type = "vertical";
	                LegendComponent = _LegendHorizontal2.default;
	                legendTitles = legendTitles.map(function (title) {
	                    return Array.isArray(title) ? title[0] : title;
	                });
	                var desiredHeight = width * (1 / aspectRatio);
	                if (desiredHeight > height * (3 / 4)) {
	                    // chartHeight = height * (3 / 4);
	                    flexChart = true;
	                } else {
	                    chartHeight = desiredHeight;
	                }
	                chartWidth = width;
	            } else {
	                type = "small";
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(className, 'fullscreen-text-small fullscreen-normal-text fullscreen-night-text', _ChartWithLegend2.default.ChartWithLegend, _ChartWithLegend2.default[type], flexChart && _ChartWithLegend2.default.flexChart), style: { paddingBottom: PADDING, paddingLeft: PADDING, paddingRight: PADDING } },
	                LegendComponent ? _react2.default.createElement(LegendComponent, {
	                    className: _ChartWithLegend2.default.Legend,
	                    titles: legendTitles,
	                    colors: legendColors,
	                    hovered: hovered,
	                    onHoverChange: onHoverChange
	                }) : null,
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)(_ChartWithLegend2.default.Chart), style: { width: chartWidth, height: chartHeight } },
	                    children
	                )
	            );
	        }
	    }]);
	
	    return ChartWithLegend;
	}(_react.Component), _class2.defaultProps = {
	    aspectRatio: 1
	}, _temp)) || _class;
	
	ChartWithLegend.displayName = "ChartWithLegend";
	exports.default = ChartWithLegend;

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ChartWithLegend":"_3qyVV","Legend":"_1ABjV","Chart":"_2luIt","small":"_1CAv1","vertical":"_1rOS_","flexChart":"_168j7","horizontal":"_32nW-"};

/***/ }),
/* 1402 */,
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Legend = __webpack_require__(1274);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _LegendItem = __webpack_require__(1276);
	
	var _LegendItem2 = _interopRequireDefault(_LegendItem);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LegendVertical = (_temp = _class = function (_Component) {
	    _inherits(LegendVertical, _Component);
	
	    function LegendVertical(props, context) {
	        _classCallCheck(this, LegendVertical);
	
	        var _this = _possibleConstructorReturn(this, (LegendVertical.__proto__ || Object.getPrototypeOf(LegendVertical)).call(this, props, context));
	
	        _this.state = {
	            overflowCount: 0,
	            size: null
	        };
	        return _this;
	    }
	
	    _createClass(LegendVertical, [{
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            // Get the bounding rectangle of the chart widget to determine if
	            // legend items will overflow the widget area
	            var size = _reactDom2.default.findDOMNode(this).getBoundingClientRect();
	
	            // only check the height. width may flucatuate depending on the browser causing an infinite loop
	            if (this.state.size && size.height !== this.state.size.height) {
	                this.setState({ overflowCount: 0, size: size });
	            } else if (this.state.overflowCount === 0) {
	                var overflowCount = 0;
	                for (var i = 0; i < this.props.titles.length; i++) {
	                    var itemSize = _reactDom2.default.findDOMNode(this.refs["item" + i]).getBoundingClientRect();
	                    if (size.top > itemSize.top || size.bottom < itemSize.bottom) {
	                        overflowCount++;
	                    }
	                }
	                if (this.state.overflowCount !== overflowCount) {
	                    this.setState({ overflowCount: overflowCount, size: size });
	                }
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                titles = _props.titles,
	                colors = _props.colors,
	                hovered = _props.hovered,
	                onHoverChange = _props.onHoverChange;
	            var overflowCount = this.state.overflowCount;
	
	            var items = void 0,
	                extraItems = void 0,
	                extraColors = void 0;
	            if (overflowCount > 0) {
	                items = titles.slice(0, -overflowCount - 1);
	                extraItems = titles.slice(-overflowCount - 1);
	                extraColors = colors.slice(-overflowCount - 1).concat(colors.slice(0, -overflowCount - 1));
	            } else {
	                items = titles;
	            }
	            return _react2.default.createElement(
	                "ol",
	                { ref: "container", className: (0, _classnames2.default)(className, _Legend2.default.Legend, _Legend2.default.vertical) },
	                items.map(function (title, index) {
	                    return _react2.default.createElement(
	                        "li",
	                        {
	                            key: index,
	                            ref: "item" + index,
	                            className: "flex flex-no-shrink",
	                            onMouseEnter: function onMouseEnter(e) {
	                                return onHoverChange && onHoverChange({
	                                    index: index,
	                                    element: _reactDom2.default.findDOMNode(_this2.refs["legendItem" + index])
	                                });
	                            },
	                            onMouseLeave: function onMouseLeave(e) {
	                                return onHoverChange && onHoverChange();
	                            }
	                        },
	                        _react2.default.createElement(_LegendItem2.default, {
	                            ref: "legendItem" + index,
	                            title: Array.isArray(title) ? title[0] : title,
	                            color: colors[index % colors.length],
	                            isMuted: hovered && hovered.index != null && index !== hovered.index,
	                            showTooltip: false
	                        }),
	                        Array.isArray(title) && _react2.default.createElement(
	                            "span",
	                            { className: (0, _classnames2.default)("LegendItem", "flex-align-right pl1", { muted: hovered && hovered.index != null && index !== hovered.index }) },
	                            title[1]
	                        )
	                    );
	                }),
	                overflowCount > 0 ? _react2.default.createElement(
	                    "li",
	                    { key: "extra", className: "flex flex-no-shrink" },
	                    _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: _react2.default.createElement(LegendVertical, { className: "p2", titles: extraItems, colors: extraColors }) },
	                        _react2.default.createElement(_LegendItem2.default, {
	                            title: overflowCount + 1 + " more",
	                            color: "gray",
	                            showTooltip: false
	                        })
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return LegendVertical;
	}(_react.Component), _class.propTypes = {}, _class.defaultProps = {}, _temp);
	LegendVertical.displayName = "LegendVertical";
	exports.default = LegendVertical;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Legend = __webpack_require__(1274);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _LegendItem = __webpack_require__(1276);
	
	var _LegendItem2 = _interopRequireDefault(_LegendItem);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LegendHorizontal = function (_Component) {
	    _inherits(LegendHorizontal, _Component);
	
	    function LegendHorizontal() {
	        _classCallCheck(this, LegendHorizontal);
	
	        return _possibleConstructorReturn(this, (LegendHorizontal.__proto__ || Object.getPrototypeOf(LegendHorizontal)).apply(this, arguments));
	    }
	
	    _createClass(LegendHorizontal, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                titles = _props.titles,
	                colors = _props.colors,
	                hovered = _props.hovered,
	                onHoverChange = _props.onHoverChange;
	
	            return _react2.default.createElement(
	                "ol",
	                { ref: "container", className: (0, _classnames2.default)(className, _Legend2.default.Legend, _Legend2.default.horizontal) },
	                titles.map(function (title, index) {
	                    return _react2.default.createElement(
	                        "li",
	                        { key: index },
	                        _react2.default.createElement(_LegendItem2.default, {
	                            ref: "legendItem" + index,
	                            title: title,
	                            color: colors[index % colors.length],
	                            isMuted: hovered && hovered.index != null && index !== hovered.index,
	                            showTooltip: false,
	                            onMouseEnter: function onMouseEnter() {
	                                return onHoverChange && onHoverChange({
	                                    index: index,
	                                    element: _reactDom2.default.findDOMNode(_this2.refs["legendItem" + index])
	                                });
	                            },
	                            onMouseLeave: function onMouseLeave() {
	                                return onHoverChange && onHoverChange(null);
	                            }
	                        })
	                    );
	                })
	            );
	        }
	    }]);
	
	    return LegendHorizontal;
	}(_react.Component);
	
	LegendHorizontal.displayName = "LegendHorizontal";
	exports.default = LegendHorizontal;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _LineAreaBarChart2 = __webpack_require__(1370);
	
	var _LineAreaBarChart3 = _interopRequireDefault(_LineAreaBarChart2);
	
	var _LineAreaBarRenderer = __webpack_require__(1389);
	
	var _graph = __webpack_require__(1394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AreaChart = (_temp = _class = function (_LineAreaBarChart) {
	    _inherits(AreaChart, _LineAreaBarChart);
	
	    function AreaChart() {
	        _classCallCheck(this, AreaChart);
	
	        return _possibleConstructorReturn(this, (AreaChart.__proto__ || Object.getPrototypeOf(AreaChart)).apply(this, arguments));
	    }
	
	    return AreaChart;
	}(_LineAreaBarChart3.default), _class.uiName = "Area", _class.identifier = "area", _class.iconName = "area", _class.noun = "area chart", _class.settings = _extends({}, _graph.GRAPH_DATA_SETTINGS, _graph.LINE_SETTINGS, _graph.STACKABLE_SETTINGS, _graph.GRAPH_GOAL_SETTINGS, _graph.LINE_SETTINGS_2, _graph.GRAPH_COLORS_SETTINGS, _graph.GRAPH_AXIS_SETTINGS), _class.renderer = _LineAreaBarRenderer.areaRenderer, _temp);
	exports.default = AreaChart;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChoroplethMap = __webpack_require__(1407);
	
	var _ChoroplethMap2 = _interopRequireDefault(_ChoroplethMap);
	
	var _PinMap = __webpack_require__(1483);
	
	var _PinMap2 = _interopRequireDefault(_PinMap);
	
	var _errors = __webpack_require__(1388);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _settings = __webpack_require__(1376);
	
	var _settings2 = __webpack_require__(518);
	
	var _settings3 = _interopRequireDefault(_settings2);
	
	var _utils = __webpack_require__(878);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// NOTE Atte Keinänen 8/2/17: Heat/grid maps disabled in the first merged version of binning
	// const PIN_MAP_TYPES = new Set(["pin", "heat", "grid"]);
	var PIN_MAP_TYPES = new Set(["pin"]);
	
	var Map = (_temp = _class = function (_Component) {
	    _inherits(Map, _Component);
	
	    function Map() {
	        _classCallCheck(this, Map);
	
	        return _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).apply(this, arguments));
	    }
	
	    _createClass(Map, [{
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            var sameSize = this.props.width === nextProps.width && this.props.height === nextProps.height;
	            var sameSeries = (0, _utils.isSameSeries)(this.props.series, nextProps.series);
	            return !(sameSize && sameSeries);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var settings = this.props.settings;
	
	            var type = settings["map.type"];
	            if (PIN_MAP_TYPES.has(type)) {
	                return _react2.default.createElement(_PinMap2.default, this.props);
	            } else if (type === "region") {
	                return _react2.default.createElement(_ChoroplethMap2.default, this.props);
	            }
	        }
	    }], [{
	        key: "isSensible",
	        value: function isSensible(cols, rows) {
	            return true;
	        }
	    }, {
	        key: "checkRenderable",
	        value: function checkRenderable(_ref, settings) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                _ref2$0$data = _ref2[0].data,
	                cols = _ref2$0$data.cols,
	                rows = _ref2$0$data.rows;
	
	            if (PIN_MAP_TYPES.has(settings["map.type"])) {
	                if (!settings["map.longitude_column"] || !settings["map.latitude_column"]) {
	                    throw new _errors.ChartSettingsError("Please select longitude and latitude columns in the chart settings.", "Data");
	                }
	            } else if (settings["map.type"] === "region") {
	                if (!settings["map.region"]) {
	                    throw new _errors.ChartSettingsError("Please select a region map.", "Data");
	                }
	                if (!settings["map.dimension"] || !settings["map.metric"]) {
	                    throw new _errors.ChartSettingsError("Please select region and metric columns in the chart settings.", "Data");
	                }
	            }
	        }
	    }]);
	
	    return Map;
	}(_react.Component), _class.uiName = "Map", _class.identifier = "map", _class.iconName = "pinmap", _class.aliases = ["state", "country", "pin_map"], _class.minSize = { width: 4, height: 4 }, _class.settings = {
	    "map.type": {
	        title: "Map type",
	        widget: "select",
	        props: {
	            options: [{ name: "Region map", value: "region" }, { name: "Pin map", value: "pin" }
	            // NOTE Atte Keinänen 8/2/17: Heat/grid maps disabled in the first merged version of binning
	            // { name: "Heat map", value: "heat" },
	            // { name: "Grid map", value: "grid" }
	            ]
	        },
	        getDefault: function getDefault(_ref3, settings) {
	            var _ref4 = _slicedToArray(_ref3, 1),
	                _ref4$ = _ref4[0],
	                card = _ref4$.card,
	                cols = _ref4$.data.cols;
	
	            switch (card.display) {
	                case "state":
	                case "country":
	                    return "region";
	                case "pin_map":
	                    return "pin";
	                default:
	                    // NOTE Atte Keinänen 8/2/17: Heat/grid maps disabled in the first merged version of binning
	                    if ((0, _schema_metadata.hasLatitudeAndLongitudeColumns)(cols)) {
	                        //     const latitudeColumn = _.findWhere(cols, { name: settings["map.latitude_column"] });
	                        //     const longitudeColumn = _.findWhere(cols, { name: settings["map.longitude_column"] });
	                        //     if (latitudeColumn && longitudeColumn && latitudeColumn.binning_info && longitudeColumn.binning_info) {
	                        //         // lat/lon columns are binned, use grid by default
	                        //         return "grid";
	                        //     } else if (settings["map.metric_column"]) {
	                        //         //
	                        //         return "heat";
	                        //     } else {
	                        return "pin";
	                        //     }
	                    } else {
	                        return "region";
	                    }
	            }
	        },
	        readDependencies: ["map.latitude_column", "map.longitude_column", "map.metric_column"]
	    },
	    "map.pin_type": {
	        title: "Pin type",
	        // Don't expose this in the UI for now
	        // widget: "select",
	        props: {
	            options: [{ name: "Tiles", value: "tiles" }, { name: "Markers", value: "markers" }]
	        },
	        getDefault: function getDefault(series, vizSettings) {
	            return vizSettings["map.type"] === "heat" ? "heat" : vizSettings["map.type"] === "grid" ? "grid" : series[0].data.rows.length >= 1000 ? "tiles" : "markers";
	        },
	        getHidden: function getHidden(series, vizSettings) {
	            return !PIN_MAP_TYPES.has(vizSettings["map.type"]);
	        }
	    },
	    "map.latitude_column": _extends({
	        title: "Latitude field"
	    }, (0, _settings.fieldSetting)("map.latitude_column", _schema_metadata.isNumeric, function (_ref5) {
	        var _ref6 = _slicedToArray(_ref5, 1),
	            cols = _ref6[0].data.cols;
	
	        return (_underscore2.default.find(cols, _schema_metadata.isLatitude) || {}).name;
	    }), {
	        getHidden: function getHidden(series, vizSettings) {
	            return !PIN_MAP_TYPES.has(vizSettings["map.type"]);
	        }
	    }),
	    "map.longitude_column": _extends({
	        title: "Longitude field"
	    }, (0, _settings.fieldSetting)("map.longitude_column", _schema_metadata.isNumeric, function (_ref7) {
	        var _ref8 = _slicedToArray(_ref7, 1),
	            cols = _ref8[0].data.cols;
	
	        return (_underscore2.default.find(cols, _schema_metadata.isLongitude) || {}).name;
	    }), {
	        getHidden: function getHidden(series, vizSettings) {
	            return !PIN_MAP_TYPES.has(vizSettings["map.type"]);
	        }
	    }),
	    "map.metric_column": _extends({
	        title: "Metric field"
	    }, (0, _settings.metricSetting)("map.metric_column"), {
	        getHidden: function getHidden(series, vizSettings) {
	            return !PIN_MAP_TYPES.has(vizSettings["map.type"]) || vizSettings["map.pin_type"] !== "heat" && vizSettings["map.pin_type"] !== "grid";
	        }
	    }),
	    "map.region": {
	        title: "Region map",
	        widget: "select",
	        getDefault: function getDefault(_ref9) {
	            var _ref10 = _slicedToArray(_ref9, 1),
	                _ref10$ = _ref10[0],
	                card = _ref10$.card,
	                cols = _ref10$.data.cols;
	
	            if (card.display === "state" || _underscore2.default.any(cols, _schema_metadata.isState)) {
	                return "us_states";
	            } else if (card.display === "country" || _underscore2.default.any(cols, _schema_metadata.isCountry)) {
	                return "world_countries";
	            }
	            return null;
	        },
	        getProps: function getProps() {
	            return {
	                // $FlowFixMe:
	                options: Object.entries(_settings3.default.get("custom_geojson", {})).map(function (_ref11) {
	                    var _ref12 = _slicedToArray(_ref11, 2),
	                        key = _ref12[0],
	                        value = _ref12[1];
	
	                    return { name: value.name, value: key };
	                })
	            };
	        },
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["map.type"] !== "region";
	        }
	    },
	    "map.metric": _extends({
	        title: "Metric field"
	    }, (0, _settings.metricSetting)("map.metric"), {
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["map.type"] !== "region";
	        }
	    }),
	    "map.dimension": _extends({
	        title: "Region field",
	        widget: "select"
	    }, (0, _settings.dimensionSetting)("map.dimension"), {
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["map.type"] !== "region";
	        }
	    }),
	    "map.zoom": {},
	    "map.center_latitude": {},
	    "map.center_longitude": {},
	    "map.heat.radius": {
	        title: "Radius",
	        widget: "number",
	        default: 30,
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["map.type"] !== "heat";
	        }
	    },
	    "map.heat.blur": {
	        title: "Blur",
	        widget: "number",
	        default: 60,
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["map.type"] !== "heat";
	        }
	    },
	    "map.heat.min-opacity": {
	        title: "Min Opacity",
	        widget: "number",
	        default: 0,
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["map.type"] !== "heat";
	        }
	    },
	    "map.heat.max-zoom": {
	        title: "Max Zoom",
	        widget: "number",
	        default: 1,
	        getHidden: function getHidden(series, vizSettings) {
	            return vizSettings["map.type"] !== "heat";
	        }
	    }
	}, _temp);
	Map.displayName = "Map";
	exports.default = Map;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoadingSpinner = __webpack_require__(1281);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _errors = __webpack_require__(1388);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _formatting = __webpack_require__(872);
	
	var _ChartWithLegend = __webpack_require__(1400);
	
	var _ChartWithLegend2 = _interopRequireDefault(_ChartWithLegend);
	
	var _LegacyChoropleth = __webpack_require__(1408);
	
	var _LegacyChoropleth2 = _interopRequireDefault(_LegacyChoropleth);
	
	var _LeafletChoropleth = __webpack_require__(1409);
	
	var _LeafletChoropleth2 = _interopRequireDefault(_LeafletChoropleth);
	
	var _mapping = __webpack_require__(1413);
	
	var _d2 = __webpack_require__(873);
	
	var _d3 = _interopRequireDefault(_d2);
	
	var _simpleStatistics = __webpack_require__(1414);
	
	var _simpleStatistics2 = _interopRequireDefault(_simpleStatistics);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const HEAT_MAP_COLORS = [
	//     "#E1F2FF",
	//     "#67B9FF",
	//     "#2DA0FF",
	//     "#0A93FF",
	//     "#005FB8"
	// ];
	// const HEAT_MAP_ZERO_COLOR = '#CCC';
	
	var HEAT_MAP_COLORS = [
	// "#E2F2FF",
	"#C4E4FF",
	// "#9ED2FF",
	"#81C5FF",
	// "#6BBAFF",
	"#51AEFF",
	// "#36A2FF",
	"#1E96FF",
	// "#0089FF",
	"#0061B5"];
	var HEAT_MAP_ZERO_COLOR = '#CCC';
	
	var geoJsonCache = new Map();
	function loadGeoJson(geoJsonPath, callback) {
	    if (geoJsonCache.has(geoJsonPath)) {
	        setTimeout(function () {
	            return callback(geoJsonCache.get(geoJsonPath));
	        }, 0);
	    } else {
	        _d3.default.json(geoJsonPath, function (json) {
	            geoJsonCache.set(geoJsonPath, json);
	            callback(json);
	        });
	    }
	}
	
	var ChoroplethMap = (_temp = _class = function (_Component) {
	    _inherits(ChoroplethMap, _Component);
	
	    _createClass(ChoroplethMap, null, [{
	        key: "isSensible",
	        value: function isSensible(cols, rows) {
	            return cols.length > 1 && (0, _schema_metadata.isString)(cols[0]);
	        }
	    }, {
	        key: "checkRenderable",
	        value: function checkRenderable(_ref) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                _ref2$0$data = _ref2[0].data,
	                cols = _ref2$0$data.cols,
	                rows = _ref2$0$data.rows;
	
	            if (cols.length < 2) {
	                throw new _errors.MinColumnsError(2, cols.length);
	            }
	        }
	    }]);
	
	    function ChoroplethMap(props, context) {
	        _classCallCheck(this, ChoroplethMap);
	
	        var _this = _possibleConstructorReturn(this, (ChoroplethMap.__proto__ || Object.getPrototypeOf(ChoroplethMap)).call(this, props, context));
	
	        _this.state = {
	            geoJson: null,
	            geoJsonPath: null
	        };
	        return _this;
	    }
	
	    _createClass(ChoroplethMap, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.componentWillReceiveProps(this.props);
	        }
	    }, {
	        key: "_getDetails",
	        value: function _getDetails(props) {
	            return _settings2.default.get("custom_geojson", {})[props.settings["map.region"]];
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            var details = this._getDetails(nextProps);
	            if (details) {
	                var geoJsonPath = void 0;
	                if (details.builtin) {
	                    geoJsonPath = details.url;
	                } else {
	                    geoJsonPath = "api/geojson/" + nextProps.settings["map.region"];
	                }
	                if (this.state.geoJsonPath !== geoJsonPath) {
	                    this.setState({
	                        geoJson: null,
	                        geoJsonPath: geoJsonPath
	                    });
	                    loadGeoJson(geoJsonPath, function (geoJson) {
	                        _this2.setState({
	                            geoJson: geoJson,
	                            geoJsonPath: geoJsonPath,
	                            minimalBounds: (0, _mapping.computeMinimalBounds)(geoJson.features)
	                        });
	                    });
	                }
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var details = this._getDetails(this.props);
	            if (!details) {
	                return _react2.default.createElement(
	                    "div",
	                    null,
	                    "unknown map"
	                );
	            }
	
	            var _props = this.props,
	                series = _props.series,
	                className = _props.className,
	                gridSize = _props.gridSize,
	                hovered = _props.hovered,
	                onHoverChange = _props.onHoverChange,
	                visualizationIsClickable = _props.visualizationIsClickable,
	                onVisualizationClick = _props.onVisualizationClick,
	                settings = _props.settings;
	            var _state = this.state,
	                geoJson = _state.geoJson,
	                minimalBounds = _state.minimalBounds;
	
	            // special case builtin maps to use legacy choropleth map
	
	            var projection = void 0;
	            if (settings["map.region"] === "us_states") {
	                projection = _d3.default.geo.albersUsa();
	            } else if (settings["map.region"] === "world_countries") {
	                projection = _d3.default.geo.mercator();
	            } else {
	                projection = null;
	            }
	
	            var nameProperty = details.region_name;
	            var keyProperty = details.region_key;
	
	            if (!geoJson) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: className + " flex layout-centered" },
	                    _react2.default.createElement(_LoadingSpinner2.default, null)
	                );
	            }
	
	            var _series = _slicedToArray(series, 1),
	                _series$0$data = _series[0].data,
	                cols = _series$0$data.cols,
	                rows = _series$0$data.rows;
	
	            var dimensionIndex = _underscore2.default.findIndex(cols, function (col) {
	                return col.name === settings["map.dimension"];
	            });
	            var metricIndex = _underscore2.default.findIndex(cols, function (col) {
	                return col.name === settings["map.metric"];
	            });
	
	            var getRowKey = function getRowKey(row) {
	                return (0, _mapping.getCanonicalRowKey)(row[dimensionIndex], settings["map.region"]);
	            };
	            var getRowValue = function getRowValue(row) {
	                return row[metricIndex] || 0;
	            };
	            var getFeatureName = function getFeatureName(feature) {
	                return String(feature.properties[nameProperty]);
	            };
	            var getFeatureKey = function getFeatureKey(feature) {
	                return String(feature.properties[keyProperty]).toLowerCase();
	            };
	            var getFeatureValue = function getFeatureValue(feature) {
	                return valuesMap[getFeatureKey(feature)];
	            };
	
	            var heatMapColors = HEAT_MAP_COLORS.slice(0, Math.min(HEAT_MAP_COLORS.length, rows.length));
	
	            var onHoverFeature = function onHoverFeature(hover) {
	                onHoverChange && onHoverChange(hover && {
	                    index: heatMapColors.indexOf(getColor(hover.feature)),
	                    event: hover.event,
	                    data: { key: getFeatureName(hover.feature), value: getFeatureValue(hover.feature)
	                    } });
	            };
	
	            var getFeatureClickObject = function getFeatureClickObject(row) {
	                return {
	                    value: row[metricIndex],
	                    column: cols[metricIndex],
	                    dimensions: [{
	                        value: row[dimensionIndex],
	                        column: cols[dimensionIndex]
	                    }]
	                };
	            };
	
	            var isClickable = onVisualizationClick && visualizationIsClickable(getFeatureClickObject(rows[0]));
	
	            var onClickFeature = isClickable && function (click) {
	                var featureKey = getFeatureKey(click.feature);
	                var row = _underscore2.default.find(rows, function (row) {
	                    return getRowKey(row) === featureKey;
	                });
	                if (onVisualizationClick && row !== undefined) {
	                    onVisualizationClick(_extends({}, getFeatureClickObject(row), {
	                        event: click.event
	                    }));
	                }
	            };
	
	            var valuesMap = {};
	            var domain = [];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var row = _step.value;
	
	                    valuesMap[getRowKey(row)] = (valuesMap[getRowKey(row)] || 0) + getRowValue(row);
	                    domain.push(getRowValue(row));
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var groups = _simpleStatistics2.default.ckmeans(domain, heatMapColors.length);
	
	            var colorScale = _d3.default.scale.quantile().domain(groups.map(function (cluster) {
	                return cluster[0];
	            })).range(heatMapColors);
	
	            var legendColors = heatMapColors.slice();
	            var legendTitles = heatMapColors.map(function (color, index) {
	                var min = groups[index][0];
	                var max = groups[index].slice(-1)[0];
	                return index === heatMapColors.length - 1 ? (0, _formatting.formatNumber)(min) + " +" : (0, _formatting.formatNumber)(min) + " - " + (0, _formatting.formatNumber)(max);
	            });
	
	            var getColor = function getColor(feature) {
	                var value = getFeatureValue(feature);
	                return value == null ? HEAT_MAP_ZERO_COLOR : colorScale(value);
	            };
	
	            var aspectRatio = void 0;
	            if (projection) {
	                var translate = projection.translate();
	                var width = translate[0] * 2;
	                var height = translate[1] * 2;
	                aspectRatio = width / height;
	            } else {
	                aspectRatio = (minimalBounds.getEast() - minimalBounds.getWest()) / (minimalBounds.getNorth() - minimalBounds.getSouth());
	            }
	
	            return _react2.default.createElement(
	                _ChartWithLegend2.default,
	                {
	                    className: className,
	                    aspectRatio: aspectRatio,
	                    legendTitles: legendTitles, legendColors: legendColors,
	                    gridSize: gridSize,
	                    hovered: hovered, onHoverChange: onHoverChange
	                },
	                projection ? _react2.default.createElement(_LegacyChoropleth2.default, {
	                    series: series,
	                    geoJson: geoJson,
	                    getColor: getColor,
	                    onHoverFeature: onHoverFeature,
	                    onClickFeature: onClickFeature,
	                    projection: projection
	                }) : _react2.default.createElement(_LeafletChoropleth2.default, {
	                    series: series,
	                    geoJson: geoJson,
	                    getColor: getColor,
	                    onHoverFeature: onHoverFeature,
	                    onClickFeature: onClickFeature,
	                    minimalBounds: minimalBounds
	                })
	            );
	        }
	    }]);
	
	    return ChoroplethMap;
	}(_react.Component), _class.propTypes = {}, _class.minSize = { width: 4, height: 4 }, _temp);
	ChoroplethMap.displayName = "ChoroplethMap";
	exports.default = ChoroplethMap;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(878);
	
	var _d = __webpack_require__(873);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LegacyChoropleth = function LegacyChoropleth(_ref) {
	    var series = _ref.series,
	        geoJson = _ref.geoJson,
	        projection = _ref.projection,
	        getColor = _ref.getColor,
	        onHoverFeature = _ref.onHoverFeature,
	        onClickFeature = _ref.onClickFeature;
	
	    var geo = _d2.default.geo.path().projection(projection);
	
	    var translate = projection.translate();
	    var width = translate[0] * 2;
	    var height = translate[1] * 2;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "absolute top bottom left right flex layout-centered" },
	        _react2.default.createElement(
	            ShouldUpdate,
	            { series: series, shouldUpdate: function shouldUpdate(props, nextProps) {
	                    return !(0, _utils.isSameSeries)(props.series, nextProps.series);
	                } },
	            function () {
	                return (// eslint-disable-line react/display-name
	                    _react2.default.createElement(
	                        "svg",
	                        { className: "flex-full m1", viewBox: "0 0 " + width + " " + height },
	                        geoJson.features.map(function (feature, index) {
	                            return _react2.default.createElement("path", {
	                                d: geo(feature, index),
	                                stroke: "white",
	                                strokeWidth: 1,
	                                fill: getColor(feature),
	                                onMouseMove: function onMouseMove(e) {
	                                    return onHoverFeature({
	                                        feature: feature,
	                                        event: e.nativeEvent
	                                    });
	                                },
	                                onMouseLeave: function onMouseLeave() {
	                                    return onHoverFeature(null);
	                                },
	                                className: (0, _classnames2.default)({ "cursor-pointer": !!onClickFeature }),
	                                onClick: onClickFeature && function (e) {
	                                    return onClickFeature({
	                                        feature: feature,
	                                        event: e.nativeEvent
	                                    });
	                                }
	                            });
	                        })
	                    )
	                );
	            }
	        )
	    );
	};
	
	LegacyChoropleth.displayName = "LegacyChoropleth";
	
	var ShouldUpdate = function (_Component) {
	    _inherits(ShouldUpdate, _Component);
	
	    function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, (ShouldUpdate.__proto__ || Object.getPrototypeOf(ShouldUpdate)).apply(this, arguments));
	    }
	
	    _createClass(ShouldUpdate, [{
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps) {
	            if (nextProps.shouldUpdate) {
	                return nextProps.shouldUpdate(this.props, nextProps);
	            }
	            return true;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var children = this.props.children;
	
	            if (typeof children === "function") {
	                return children();
	            } else {
	                return children;
	            }
	        }
	    }]);
	
	    return ShouldUpdate;
	}(_react.Component);
	
	ShouldUpdate.displayName = "ShouldUpdate";
	exports.default = LegacyChoropleth;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	// import L from "leaflet";
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(881);
	
	var _CardRenderer = __webpack_require__(1371);
	
	var _CardRenderer2 = _interopRequireDefault(_CardRenderer);
	
	__webpack_require__(1410);
	
	var _leaflet = __webpack_require__(1412);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _mapping = __webpack_require__(1413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeafletChoropleth = function LeafletChoropleth(_ref) {
	    var series = _ref.series,
	        geoJson = _ref.geoJson,
	        _ref$minimalBounds = _ref.minimalBounds,
	        minimalBounds = _ref$minimalBounds === undefined ? (0, _mapping.computeMinimalBounds)(geoJson.features) : _ref$minimalBounds,
	        _ref$getColor = _ref.getColor,
	        getColor = _ref$getColor === undefined ? function () {
	        return _colors.normal.blue;
	    } : _ref$getColor,
	        _ref$onHoverFeature = _ref.onHoverFeature,
	        onHoverFeature = _ref$onHoverFeature === undefined ? function () {} : _ref$onHoverFeature,
	        _ref$onClickFeature = _ref.onClickFeature,
	        onClickFeature = _ref$onClickFeature === undefined ? function () {} : _ref$onClickFeature;
	    return _react2.default.createElement(_CardRenderer2.default, {
	        series: series,
	        className: "spread",
	        renderer: function renderer(element, props) {
	            element.className = "spread";
	            element.style.backgroundColor = "transparent";
	
	            var map = _leaflet2.default.map(element, {
	                zoomSnap: 0,
	                worldCopyJump: true,
	                attributionControl: false,
	
	                // disable zoom controls
	                dragging: false,
	                tap: false,
	                zoomControl: false,
	                touchZoom: false,
	                doubleClickZoom: false,
	                scrollWheelZoom: false,
	                boxZoom: false,
	                keyboard: false
	            });
	
	            // L.tileLayer("http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
	            //     attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
	            // }).addTo(map);
	
	            var style = function style(feature) {
	                return {
	                    fillColor: getColor(feature),
	                    weight: 1,
	                    opacity: 1,
	                    color: "white",
	                    fillOpacity: 1
	                };
	            };
	
	            var onEachFeature = function onEachFeature(feature, layer) {
	                layer.on({
	                    mousemove: function mousemove(e) {
	                        onHoverFeature({
	                            feature: feature,
	                            event: e.originalEvent
	                        });
	                    },
	                    mouseout: function mouseout(e) {
	                        onHoverFeature(null);
	                    },
	                    click: function click(e) {
	                        onClickFeature({
	                            feature: feature,
	                            event: e.originalEvent
	                        });
	                    }
	                });
	            };
	
	            // main layer
	            _leaflet2.default.featureGroup([_leaflet2.default.geoJson(geoJson, {
	                style: style,
	                onEachFeature: onEachFeature
	            })]).addTo(map);
	
	            // left and right duplicates so we can pan a bit
	            _leaflet2.default.featureGroup([_leaflet2.default.geoJson(geoJson, {
	                style: style,
	                onEachFeature: onEachFeature,
	                coordsToLatLng: function coordsToLatLng(_ref2) {
	                    var _ref3 = _slicedToArray(_ref2, 2),
	                        longitude = _ref3[0],
	                        latitude = _ref3[1];
	
	                    return _leaflet2.default.latLng(latitude, longitude - 360);
	                }
	            }), _leaflet2.default.geoJson(geoJson, {
	                style: style,
	                onEachFeature: onEachFeature,
	                coordsToLatLng: function coordsToLatLng(_ref4) {
	                    var _ref5 = _slicedToArray(_ref4, 2),
	                        longitude = _ref5[0],
	                        latitude = _ref5[1];
	
	                    return _leaflet2.default.latLng(latitude, longitude + 360);
	                }
	            })]).addTo(map);
	
	            map.fitBounds(minimalBounds);
	            // map.fitBounds(geoFeatureGroup.getBounds());
	        }
	    });
	};
	
	LeafletChoropleth.displayName = "LeafletChoropleth";
	exports.default = LeafletChoropleth;

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1411 */,
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Leaflet 1.0.3, a JS library for interactive maps. http://leafletjs.com
	 (c) 2010-2016 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	*/
	(function (window, document, undefined) {
	var L = {
		version: "1.0.3"
	};
	
	function expose() {
		var oldL = window.L;
	
		L.noConflict = function () {
			window.L = oldL;
			return this;
		};
	
		window.L = L;
	}
	
	// define Leaflet for Node module pattern loaders, including Browserify
	if (typeof module === 'object' && typeof module.exports === 'object') {
		module.exports = L;
	
	// define Leaflet as an AMD module
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (L), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	// define Leaflet as a global L variable, saving the original L to restore later if needed
	if (typeof window !== 'undefined') {
		expose();
	}
	
	
	
	/*
	 * @namespace Util
	 *
	 * Various utility functions, used by Leaflet internally.
	 */
	
	L.Util = {
	
		// @function extend(dest: Object, src?: Object): Object
		// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
		extend: function (dest) {
			var i, j, len, src;
	
			for (j = 1, len = arguments.length; j < len; j++) {
				src = arguments[j];
				for (i in src) {
					dest[i] = src[i];
				}
			}
			return dest;
		},
	
		// @function create(proto: Object, properties?: Object): Object
		// Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
		create: Object.create || (function () {
			function F() {}
			return function (proto) {
				F.prototype = proto;
				return new F();
			};
		})(),
	
		// @function bind(fn: Function, …): Function
		// Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
		// Has a `L.bind()` shortcut.
		bind: function (fn, obj) {
			var slice = Array.prototype.slice;
	
			if (fn.bind) {
				return fn.bind.apply(fn, slice.call(arguments, 1));
			}
	
			var args = slice.call(arguments, 2);
	
			return function () {
				return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
			};
		},
	
		// @function stamp(obj: Object): Number
		// Returns the unique ID of an object, assiging it one if it doesn't have it.
		stamp: function (obj) {
			/*eslint-disable */
			obj._leaflet_id = obj._leaflet_id || ++L.Util.lastId;
			return obj._leaflet_id;
			/*eslint-enable */
		},
	
		// @property lastId: Number
		// Last unique ID used by [`stamp()`](#util-stamp)
		lastId: 0,
	
		// @function throttle(fn: Function, time: Number, context: Object): Function
		// Returns a function which executes function `fn` with the given scope `context`
		// (so that the `this` keyword refers to `context` inside `fn`'s code). The function
		// `fn` will be called no more than one time per given amount of `time`. The arguments
		// received by the bound function will be any arguments passed when binding the
		// function, followed by any arguments passed when invoking the bound function.
		// Has an `L.bind` shortcut.
		throttle: function (fn, time, context) {
			var lock, args, wrapperFn, later;
	
			later = function () {
				// reset lock and call if queued
				lock = false;
				if (args) {
					wrapperFn.apply(context, args);
					args = false;
				}
			};
	
			wrapperFn = function () {
				if (lock) {
					// called too soon, queue to call later
					args = arguments;
	
				} else {
					// call and lock until later
					fn.apply(context, arguments);
					setTimeout(later, time);
					lock = true;
				}
			};
	
			return wrapperFn;
		},
	
		// @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
		// Returns the number `num` modulo `range` in such a way so it lies within
		// `range[0]` and `range[1]`. The returned value will be always smaller than
		// `range[1]` unless `includeMax` is set to `true`.
		wrapNum: function (x, range, includeMax) {
			var max = range[1],
			    min = range[0],
			    d = max - min;
			return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
		},
	
		// @function falseFn(): Function
		// Returns a function which always returns `false`.
		falseFn: function () { return false; },
	
		// @function formatNum(num: Number, digits?: Number): Number
		// Returns the number `num` rounded to `digits` decimals, or to 5 decimals by default.
		formatNum: function (num, digits) {
			var pow = Math.pow(10, digits || 5);
			return Math.round(num * pow) / pow;
		},
	
		// @function trim(str: String): String
		// Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
		trim: function (str) {
			return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
		},
	
		// @function splitWords(str: String): String[]
		// Trims and splits the string on whitespace and returns the array of parts.
		splitWords: function (str) {
			return L.Util.trim(str).split(/\s+/);
		},
	
		// @function setOptions(obj: Object, options: Object): Object
		// Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
		setOptions: function (obj, options) {
			if (!obj.hasOwnProperty('options')) {
				obj.options = obj.options ? L.Util.create(obj.options) : {};
			}
			for (var i in options) {
				obj.options[i] = options[i];
			}
			return obj.options;
		},
	
		// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
		// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
		// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
		// be appended at the end. If `uppercase` is `true`, the parameter names will
		// be uppercased (e.g. `'?A=foo&B=bar'`)
		getParamString: function (obj, existingUrl, uppercase) {
			var params = [];
			for (var i in obj) {
				params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
			}
			return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
		},
	
		// @function template(str: String, data: Object): String
		// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
		// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
		// `('Hello foo, bar')`. You can also specify functions instead of strings for
		// data values — they will be evaluated passing `data` as an argument.
		template: function (str, data) {
			return str.replace(L.Util.templateRe, function (str, key) {
				var value = data[key];
	
				if (value === undefined) {
					throw new Error('No value provided for variable ' + str);
	
				} else if (typeof value === 'function') {
					value = value(data);
				}
				return value;
			});
		},
	
		templateRe: /\{ *([\w_\-]+) *\}/g,
	
		// @function isArray(obj): Boolean
		// Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
		isArray: Array.isArray || function (obj) {
			return (Object.prototype.toString.call(obj) === '[object Array]');
		},
	
		// @function indexOf(array: Array, el: Object): Number
		// Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
		indexOf: function (array, el) {
			for (var i = 0; i < array.length; i++) {
				if (array[i] === el) { return i; }
			}
			return -1;
		},
	
		// @property emptyImageUrl: String
		// Data URI string containing a base64-encoded empty GIF image.
		// Used as a hack to free memory from unused images on WebKit-powered
		// mobile devices (by setting image `src` to this string).
		emptyImageUrl: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
	};
	
	(function () {
		// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
		function getPrefixed(name) {
			return window['webkit' + name] || window['moz' + name] || window['ms' + name];
		}
	
		var lastTime = 0;
	
		// fallback for IE 7-8
		function timeoutDefer(fn) {
			var time = +new Date(),
			    timeToCall = Math.max(0, 16 - (time - lastTime));
	
			lastTime = time + timeToCall;
			return window.setTimeout(fn, timeToCall);
		}
	
		var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer,
		    cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
		               getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };
	
	
		// @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
		// Schedules `fn` to be executed when the browser repaints. `fn` is bound to
		// `context` if given. When `immediate` is set, `fn` is called immediately if
		// the browser doesn't have native support for
		// [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
		// otherwise it's delayed. Returns a request ID that can be used to cancel the request.
		L.Util.requestAnimFrame = function (fn, context, immediate) {
			if (immediate && requestFn === timeoutDefer) {
				fn.call(context);
			} else {
				return requestFn.call(window, L.bind(fn, context));
			}
		};
	
		// @function cancelAnimFrame(id: Number): undefined
		// Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
		L.Util.cancelAnimFrame = function (id) {
			if (id) {
				cancelFn.call(window, id);
			}
		};
	})();
	
	// shortcuts for most used utility functions
	L.extend = L.Util.extend;
	L.bind = L.Util.bind;
	L.stamp = L.Util.stamp;
	L.setOptions = L.Util.setOptions;
	
	
	
	
	// @class Class
	// @aka L.Class
	
	// @section
	// @uninheritable
	
	// Thanks to John Resig and Dean Edwards for inspiration!
	
	L.Class = function () {};
	
	L.Class.extend = function (props) {
	
		// @function extend(props: Object): Function
		// [Extends the current class](#class-inheritance) given the properties to be included.
		// Returns a Javascript function that is a class constructor (to be called with `new`).
		var NewClass = function () {
	
			// call the constructor
			if (this.initialize) {
				this.initialize.apply(this, arguments);
			}
	
			// call all constructor hooks
			this.callInitHooks();
		};
	
		var parentProto = NewClass.__super__ = this.prototype;
	
		var proto = L.Util.create(parentProto);
		proto.constructor = NewClass;
	
		NewClass.prototype = proto;
	
		// inherit parent's statics
		for (var i in this) {
			if (this.hasOwnProperty(i) && i !== 'prototype') {
				NewClass[i] = this[i];
			}
		}
	
		// mix static properties into the class
		if (props.statics) {
			L.extend(NewClass, props.statics);
			delete props.statics;
		}
	
		// mix includes into the prototype
		if (props.includes) {
			L.Util.extend.apply(null, [proto].concat(props.includes));
			delete props.includes;
		}
	
		// merge options
		if (proto.options) {
			props.options = L.Util.extend(L.Util.create(proto.options), props.options);
		}
	
		// mix given properties into the prototype
		L.extend(proto, props);
	
		proto._initHooks = [];
	
		// add method for calling all hooks
		proto.callInitHooks = function () {
	
			if (this._initHooksCalled) { return; }
	
			if (parentProto.callInitHooks) {
				parentProto.callInitHooks.call(this);
			}
	
			this._initHooksCalled = true;
	
			for (var i = 0, len = proto._initHooks.length; i < len; i++) {
				proto._initHooks[i].call(this);
			}
		};
	
		return NewClass;
	};
	
	
	// @function include(properties: Object): this
	// [Includes a mixin](#class-includes) into the current class.
	L.Class.include = function (props) {
		L.extend(this.prototype, props);
		return this;
	};
	
	// @function mergeOptions(options: Object): this
	// [Merges `options`](#class-options) into the defaults of the class.
	L.Class.mergeOptions = function (options) {
		L.extend(this.prototype.options, options);
		return this;
	};
	
	// @function addInitHook(fn: Function): this
	// Adds a [constructor hook](#class-constructor-hooks) to the class.
	L.Class.addInitHook = function (fn) { // (Function) || (String, args...)
		var args = Array.prototype.slice.call(arguments, 1);
	
		var init = typeof fn === 'function' ? fn : function () {
			this[fn].apply(this, args);
		};
	
		this.prototype._initHooks = this.prototype._initHooks || [];
		this.prototype._initHooks.push(init);
		return this;
	};
	
	
	
	/*
	 * @class Evented
	 * @aka L.Evented
	 * @inherits Class
	 *
	 * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
	 *
	 * @example
	 *
	 * ```js
	 * map.on('click', function(e) {
	 * 	alert(e.latlng);
	 * } );
	 * ```
	 *
	 * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
	 *
	 * ```js
	 * function onClick(e) { ... }
	 *
	 * map.on('click', onClick);
	 * map.off('click', onClick);
	 * ```
	 */
	
	
	L.Evented = L.Class.extend({
	
		/* @method on(type: String, fn: Function, context?: Object): this
		 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
		 *
		 * @alternative
		 * @method on(eventMap: Object): this
		 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		 */
		on: function (types, fn, context) {
	
			// types can be a map of types/handlers
			if (typeof types === 'object') {
				for (var type in types) {
					// we don't process space-separated events here for performance;
					// it's a hot path since Layer uses the on(obj) syntax
					this._on(type, types[type], fn);
				}
	
			} else {
				// types can be a string of space-separated words
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._on(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		/* @method off(type: String, fn?: Function, context?: Object): this
		 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
		 *
		 * @alternative
		 * @method off(eventMap: Object): this
		 * Removes a set of type/listener pairs.
		 *
		 * @alternative
		 * @method off: this
		 * Removes all listeners to all events on the object.
		 */
		off: function (types, fn, context) {
	
			if (!types) {
				// clear all listeners if called without arguments
				delete this._events;
	
			} else if (typeof types === 'object') {
				for (var type in types) {
					this._off(type, types[type], fn);
				}
	
			} else {
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._off(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		// attach listener (without syntactic sugar now)
		_on: function (type, fn, context) {
			this._events = this._events || {};
	
			/* get/init listeners for type */
			var typeListeners = this._events[type];
			if (!typeListeners) {
				typeListeners = [];
				this._events[type] = typeListeners;
			}
	
			if (context === this) {
				// Less memory footprint.
				context = undefined;
			}
			var newListener = {fn: fn, ctx: context},
			    listeners = typeListeners;
	
			// check if fn already there
			for (var i = 0, len = listeners.length; i < len; i++) {
				if (listeners[i].fn === fn && listeners[i].ctx === context) {
					return;
				}
			}
	
			listeners.push(newListener);
		},
	
		_off: function (type, fn, context) {
			var listeners,
			    i,
			    len;
	
			if (!this._events) { return; }
	
			listeners = this._events[type];
	
			if (!listeners) {
				return;
			}
	
			if (!fn) {
				// Set all removed listeners to noop so they are not called if remove happens in fire
				for (i = 0, len = listeners.length; i < len; i++) {
					listeners[i].fn = L.Util.falseFn;
				}
				// clear all listeners for a type if function isn't specified
				delete this._events[type];
				return;
			}
	
			if (context === this) {
				context = undefined;
			}
	
			if (listeners) {
	
				// find fn and remove it
				for (i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					if (l.ctx !== context) { continue; }
					if (l.fn === fn) {
	
						// set the removed listener to noop so that's not called if remove happens in fire
						l.fn = L.Util.falseFn;
	
						if (this._firingCount) {
							/* copy array in case events are being fired */
							this._events[type] = listeners = listeners.slice();
						}
						listeners.splice(i, 1);
	
						return;
					}
				}
			}
		},
	
		// @method fire(type: String, data?: Object, propagate?: Boolean): this
		// Fires an event of the specified type. You can optionally provide an data
		// object — the first argument of the listener function will contain its
		// properties. The event can optionally be propagated to event parents.
		fire: function (type, data, propagate) {
			if (!this.listens(type, propagate)) { return this; }
	
			var event = L.Util.extend({}, data, {type: type, target: this});
	
			if (this._events) {
				var listeners = this._events[type];
	
				if (listeners) {
					this._firingCount = (this._firingCount + 1) || 1;
					for (var i = 0, len = listeners.length; i < len; i++) {
						var l = listeners[i];
						l.fn.call(l.ctx || this, event);
					}
	
					this._firingCount--;
				}
			}
	
			if (propagate) {
				// propagate the event to parents (set with addEventParent)
				this._propagateEvent(event);
			}
	
			return this;
		},
	
		// @method listens(type: String): Boolean
		// Returns `true` if a particular event type has any listeners attached to it.
		listens: function (type, propagate) {
			var listeners = this._events && this._events[type];
			if (listeners && listeners.length) { return true; }
	
			if (propagate) {
				// also check parents for listeners if event propagates
				for (var id in this._eventParents) {
					if (this._eventParents[id].listens(type, propagate)) { return true; }
				}
			}
			return false;
		},
	
		// @method once(…): this
		// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
		once: function (types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this.once(type, types[type], fn);
				}
				return this;
			}
	
			var handler = L.bind(function () {
				this
				    .off(types, fn, context)
				    .off(types, handler, context);
			}, this);
	
			// add a listener that's executed once and removed after that
			return this
			    .on(types, fn, context)
			    .on(types, handler, context);
		},
	
		// @method addEventParent(obj: Evented): this
		// Adds an event parent - an `Evented` that will receive propagated events
		addEventParent: function (obj) {
			this._eventParents = this._eventParents || {};
			this._eventParents[L.stamp(obj)] = obj;
			return this;
		},
	
		// @method removeEventParent(obj: Evented): this
		// Removes an event parent, so it will stop receiving propagated events
		removeEventParent: function (obj) {
			if (this._eventParents) {
				delete this._eventParents[L.stamp(obj)];
			}
			return this;
		},
	
		_propagateEvent: function (e) {
			for (var id in this._eventParents) {
				this._eventParents[id].fire(e.type, L.extend({layer: e.target}, e), true);
			}
		}
	});
	
	var proto = L.Evented.prototype;
	
	// aliases; we should ditch those eventually
	
	// @method addEventListener(…): this
	// Alias to [`on(…)`](#evented-on)
	proto.addEventListener = proto.on;
	
	// @method removeEventListener(…): this
	// Alias to [`off(…)`](#evented-off)
	
	// @method clearAllEventListeners(…): this
	// Alias to [`off()`](#evented-off)
	proto.removeEventListener = proto.clearAllEventListeners = proto.off;
	
	// @method addOneTimeEventListener(…): this
	// Alias to [`once(…)`](#evented-once)
	proto.addOneTimeEventListener = proto.once;
	
	// @method fireEvent(…): this
	// Alias to [`fire(…)`](#evented-fire)
	proto.fireEvent = proto.fire;
	
	// @method hasEventListeners(…): Boolean
	// Alias to [`listens(…)`](#evented-listens)
	proto.hasEventListeners = proto.listens;
	
	L.Mixin = {Events: proto};
	
	
	
	/*
	 * @namespace Browser
	 * @aka L.Browser
	 *
	 * A namespace with static properties for browser/feature detection used by Leaflet internally.
	 *
	 * @example
	 *
	 * ```js
	 * if (L.Browser.ielt9) {
	 *   alert('Upgrade your browser, dude!');
	 * }
	 * ```
	 */
	
	(function () {
	
		var ua = navigator.userAgent.toLowerCase(),
		    doc = document.documentElement,
	
		    ie = 'ActiveXObject' in window,
	
		    webkit    = ua.indexOf('webkit') !== -1,
		    phantomjs = ua.indexOf('phantom') !== -1,
		    android23 = ua.search('android [23]') !== -1,
		    chrome    = ua.indexOf('chrome') !== -1,
		    gecko     = ua.indexOf('gecko') !== -1  && !webkit && !window.opera && !ie,
	
		    win = navigator.platform.indexOf('Win') === 0,
	
		    mobile = typeof orientation !== 'undefined' || ua.indexOf('mobile') !== -1,
		    msPointer = !window.PointerEvent && window.MSPointerEvent,
		    pointer = window.PointerEvent || msPointer,
	
		    ie3d = ie && ('transition' in doc.style),
		    webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23,
		    gecko3d = 'MozPerspective' in doc.style,
		    opera12 = 'OTransition' in doc.style;
	
	
		var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
				(window.DocumentTouch && document instanceof window.DocumentTouch));
	
		L.Browser = {
	
			// @property ie: Boolean
			// `true` for all Internet Explorer versions (not Edge).
			ie: ie,
	
			// @property ielt9: Boolean
			// `true` for Internet Explorer versions less than 9.
			ielt9: ie && !document.addEventListener,
	
			// @property edge: Boolean
			// `true` for the Edge web browser.
			edge: 'msLaunchUri' in navigator && !('documentMode' in document),
	
			// @property webkit: Boolean
			// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
			webkit: webkit,
	
			// @property gecko: Boolean
			// `true` for gecko-based browsers like Firefox.
			gecko: gecko,
	
			// @property android: Boolean
			// `true` for any browser running on an Android platform.
			android: ua.indexOf('android') !== -1,
	
			// @property android23: Boolean
			// `true` for browsers running on Android 2 or Android 3.
			android23: android23,
	
			// @property chrome: Boolean
			// `true` for the Chrome browser.
			chrome: chrome,
	
			// @property safari: Boolean
			// `true` for the Safari browser.
			safari: !chrome && ua.indexOf('safari') !== -1,
	
	
			// @property win: Boolean
			// `true` when the browser is running in a Windows platform
			win: win,
	
	
			// @property ie3d: Boolean
			// `true` for all Internet Explorer versions supporting CSS transforms.
			ie3d: ie3d,
	
			// @property webkit3d: Boolean
			// `true` for webkit-based browsers supporting CSS transforms.
			webkit3d: webkit3d,
	
			// @property gecko3d: Boolean
			// `true` for gecko-based browsers supporting CSS transforms.
			gecko3d: gecko3d,
	
			// @property opera12: Boolean
			// `true` for the Opera browser supporting CSS transforms (version 12 or later).
			opera12: opera12,
	
			// @property any3d: Boolean
			// `true` for all browsers supporting CSS transforms.
			any3d: !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantomjs,
	
	
			// @property mobile: Boolean
			// `true` for all browsers running in a mobile device.
			mobile: mobile,
	
			// @property mobileWebkit: Boolean
			// `true` for all webkit-based browsers in a mobile device.
			mobileWebkit: mobile && webkit,
	
			// @property mobileWebkit3d: Boolean
			// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
			mobileWebkit3d: mobile && webkit3d,
	
			// @property mobileOpera: Boolean
			// `true` for the Opera browser in a mobile device.
			mobileOpera: mobile && window.opera,
	
			// @property mobileGecko: Boolean
			// `true` for gecko-based browsers running in a mobile device.
			mobileGecko: mobile && gecko,
	
	
			// @property touch: Boolean
			// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
			// This does not necessarily mean that the browser is running in a computer with
			// a touchscreen, it only means that the browser is capable of understanding
			// touch events.
			touch: !!touch,
	
			// @property msPointer: Boolean
			// `true` for browsers implementing the Microsoft touch events model (notably IE10).
			msPointer: !!msPointer,
	
			// @property pointer: Boolean
			// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
			pointer: !!pointer,
	
	
			// @property retina: Boolean
			// `true` for browsers on a high-resolution "retina" screen.
			retina: (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1
		};
	
	}());
	
	
	
	/*
	 * @class Point
	 * @aka L.Point
	 *
	 * Represents a point with `x` and `y` coordinates in pixels.
	 *
	 * @example
	 *
	 * ```js
	 * var point = L.point(200, 300);
	 * ```
	 *
	 * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```js
	 * map.panBy([200, 300]);
	 * map.panBy(L.point(200, 300));
	 * ```
	 */
	
	L.Point = function (x, y, round) {
		// @property x: Number; The `x` coordinate of the point
		this.x = (round ? Math.round(x) : x);
		// @property y: Number; The `y` coordinate of the point
		this.y = (round ? Math.round(y) : y);
	};
	
	L.Point.prototype = {
	
		// @method clone(): Point
		// Returns a copy of the current point.
		clone: function () {
			return new L.Point(this.x, this.y);
		},
	
		// @method add(otherPoint: Point): Point
		// Returns the result of addition of the current and the given points.
		add: function (point) {
			// non-destructive, returns a new point
			return this.clone()._add(L.point(point));
		},
	
		_add: function (point) {
			// destructive, used directly for performance in situations where it's safe to modify existing point
			this.x += point.x;
			this.y += point.y;
			return this;
		},
	
		// @method subtract(otherPoint: Point): Point
		// Returns the result of subtraction of the given point from the current.
		subtract: function (point) {
			return this.clone()._subtract(L.point(point));
		},
	
		_subtract: function (point) {
			this.x -= point.x;
			this.y -= point.y;
			return this;
		},
	
		// @method divideBy(num: Number): Point
		// Returns the result of division of the current point by the given number.
		divideBy: function (num) {
			return this.clone()._divideBy(num);
		},
	
		_divideBy: function (num) {
			this.x /= num;
			this.y /= num;
			return this;
		},
	
		// @method multiplyBy(num: Number): Point
		// Returns the result of multiplication of the current point by the given number.
		multiplyBy: function (num) {
			return this.clone()._multiplyBy(num);
		},
	
		_multiplyBy: function (num) {
			this.x *= num;
			this.y *= num;
			return this;
		},
	
		// @method scaleBy(scale: Point): Point
		// Multiply each coordinate of the current point by each coordinate of
		// `scale`. In linear algebra terms, multiply the point by the
		// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
		// defined by `scale`.
		scaleBy: function (point) {
			return new L.Point(this.x * point.x, this.y * point.y);
		},
	
		// @method unscaleBy(scale: Point): Point
		// Inverse of `scaleBy`. Divide each coordinate of the current point by
		// each coordinate of `scale`.
		unscaleBy: function (point) {
			return new L.Point(this.x / point.x, this.y / point.y);
		},
	
		// @method round(): Point
		// Returns a copy of the current point with rounded coordinates.
		round: function () {
			return this.clone()._round();
		},
	
		_round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			return this;
		},
	
		// @method floor(): Point
		// Returns a copy of the current point with floored coordinates (rounded down).
		floor: function () {
			return this.clone()._floor();
		},
	
		_floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			return this;
		},
	
		// @method ceil(): Point
		// Returns a copy of the current point with ceiled coordinates (rounded up).
		ceil: function () {
			return this.clone()._ceil();
		},
	
		_ceil: function () {
			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			return this;
		},
	
		// @method distanceTo(otherPoint: Point): Number
		// Returns the cartesian distance between the current and the given points.
		distanceTo: function (point) {
			point = L.point(point);
	
			var x = point.x - this.x,
			    y = point.y - this.y;
	
			return Math.sqrt(x * x + y * y);
		},
	
		// @method equals(otherPoint: Point): Boolean
		// Returns `true` if the given point has the same coordinates.
		equals: function (point) {
			point = L.point(point);
	
			return point.x === this.x &&
			       point.y === this.y;
		},
	
		// @method contains(otherPoint: Point): Boolean
		// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
		contains: function (point) {
			point = L.point(point);
	
			return Math.abs(point.x) <= Math.abs(this.x) &&
			       Math.abs(point.y) <= Math.abs(this.y);
		},
	
		// @method toString(): String
		// Returns a string representation of the point for debugging purposes.
		toString: function () {
			return 'Point(' +
			        L.Util.formatNum(this.x) + ', ' +
			        L.Util.formatNum(this.y) + ')';
		}
	};
	
	// @factory L.point(x: Number, y: Number, round?: Boolean)
	// Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
	
	// @alternative
	// @factory L.point(coords: Number[])
	// Expects an array of the form `[x, y]` instead.
	
	// @alternative
	// @factory L.point(coords: Object)
	// Expects a plain object of the form `{x: Number, y: Number}` instead.
	L.point = function (x, y, round) {
		if (x instanceof L.Point) {
			return x;
		}
		if (L.Util.isArray(x)) {
			return new L.Point(x[0], x[1]);
		}
		if (x === undefined || x === null) {
			return x;
		}
		if (typeof x === 'object' && 'x' in x && 'y' in x) {
			return new L.Point(x.x, x.y);
		}
		return new L.Point(x, y, round);
	};
	
	
	
	/*
	 * @class Bounds
	 * @aka L.Bounds
	 *
	 * Represents a rectangular area in pixel coordinates.
	 *
	 * @example
	 *
	 * ```js
	 * var p1 = L.point(10, 10),
	 * p2 = L.point(40, 60),
	 * bounds = L.bounds(p1, p2);
	 * ```
	 *
	 * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * otherBounds.intersects([[10, 10], [40, 60]]);
	 * ```
	 */
	
	L.Bounds = function (a, b) {
		if (!a) { return; }
	
		var points = b ? [a, b] : a;
	
		for (var i = 0, len = points.length; i < len; i++) {
			this.extend(points[i]);
		}
	};
	
	L.Bounds.prototype = {
		// @method extend(point: Point): this
		// Extends the bounds to contain the given point.
		extend: function (point) { // (Point)
			point = L.point(point);
	
			// @property min: Point
			// The top left corner of the rectangle.
			// @property max: Point
			// The bottom right corner of the rectangle.
			if (!this.min && !this.max) {
				this.min = point.clone();
				this.max = point.clone();
			} else {
				this.min.x = Math.min(point.x, this.min.x);
				this.max.x = Math.max(point.x, this.max.x);
				this.min.y = Math.min(point.y, this.min.y);
				this.max.y = Math.max(point.y, this.max.y);
			}
			return this;
		},
	
		// @method getCenter(round?: Boolean): Point
		// Returns the center point of the bounds.
		getCenter: function (round) {
			return new L.Point(
			        (this.min.x + this.max.x) / 2,
			        (this.min.y + this.max.y) / 2, round);
		},
	
		// @method getBottomLeft(): Point
		// Returns the bottom-left point of the bounds.
		getBottomLeft: function () {
			return new L.Point(this.min.x, this.max.y);
		},
	
		// @method getTopRight(): Point
		// Returns the top-right point of the bounds.
		getTopRight: function () { // -> Point
			return new L.Point(this.max.x, this.min.y);
		},
	
		// @method getSize(): Point
		// Returns the size of the given bounds
		getSize: function () {
			return this.max.subtract(this.min);
		},
	
		// @method contains(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle contains the given one.
		// @alternative
		// @method contains(point: Point): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) {
			var min, max;
	
			if (typeof obj[0] === 'number' || obj instanceof L.Point) {
				obj = L.point(obj);
			} else {
				obj = L.bounds(obj);
			}
	
			if (obj instanceof L.Bounds) {
				min = obj.min;
				max = obj.max;
			} else {
				min = max = obj;
			}
	
			return (min.x >= this.min.x) &&
			       (max.x <= this.max.x) &&
			       (min.y >= this.min.y) &&
			       (max.y <= this.max.y);
		},
	
		// @method intersects(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds
		// intersect if they have at least one point in common.
		intersects: function (bounds) { // (Bounds) -> Boolean
			bounds = L.bounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
			    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
			return xIntersects && yIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds
		// overlap if their intersection is an area.
		overlaps: function (bounds) { // (Bounds) -> Boolean
			bounds = L.bounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
			    yOverlaps = (max2.y > min.y) && (min2.y < max.y);
	
			return xOverlaps && yOverlaps;
		},
	
		isValid: function () {
			return !!(this.min && this.max);
		}
	};
	
	
	// @factory L.bounds(topLeft: Point, bottomRight: Point)
	// Creates a Bounds object from two coordinates (usually top-left and bottom-right corners).
	// @alternative
	// @factory L.bounds(points: Point[])
	// Creates a Bounds object from the points it contains
	L.bounds = function (a, b) {
		if (!a || a instanceof L.Bounds) {
			return a;
		}
		return new L.Bounds(a, b);
	};
	
	
	
	/*
	 * @class Transformation
	 * @aka L.Transformation
	 *
	 * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
	 * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
	 * the reverse. Used by Leaflet in its projections code.
	 *
	 * @example
	 *
	 * ```js
	 * var transformation = new L.Transformation(2, 5, -1, 10),
	 * 	p = L.point(1, 2),
	 * 	p2 = transformation.transform(p), //  L.point(7, 8)
	 * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
	 * ```
	 */
	
	
	// factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
	// Creates a `Transformation` object with the given coefficients.
	L.Transformation = function (a, b, c, d) {
		this._a = a;
		this._b = b;
		this._c = c;
		this._d = d;
	};
	
	L.Transformation.prototype = {
		// @method transform(point: Point, scale?: Number): Point
		// Returns a transformed point, optionally multiplied by the given scale.
		// Only accepts actual `L.Point` instances, not arrays.
		transform: function (point, scale) { // (Point, Number) -> Point
			return this._transform(point.clone(), scale);
		},
	
		// destructive transform (faster)
		_transform: function (point, scale) {
			scale = scale || 1;
			point.x = scale * (this._a * point.x + this._b);
			point.y = scale * (this._c * point.y + this._d);
			return point;
		},
	
		// @method untransform(point: Point, scale?: Number): Point
		// Returns the reverse transformation of the given point, optionally divided
		// by the given scale. Only accepts actual `L.Point` instances, not arrays.
		untransform: function (point, scale) {
			scale = scale || 1;
			return new L.Point(
			        (point.x / scale - this._b) / this._a,
			        (point.y / scale - this._d) / this._c);
		}
	};
	
	
	
	/*
	 * @namespace DomUtil
	 *
	 * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
	 * tree, used by Leaflet internally.
	 *
	 * Most functions expecting or returning a `HTMLElement` also work for
	 * SVG elements. The only difference is that classes refer to CSS classes
	 * in HTML and SVG classes in SVG.
	 */
	
	L.DomUtil = {
	
		// @function get(id: String|HTMLElement): HTMLElement
		// Returns an element given its DOM id, or returns the element itself
		// if it was passed directly.
		get: function (id) {
			return typeof id === 'string' ? document.getElementById(id) : id;
		},
	
		// @function getStyle(el: HTMLElement, styleAttrib: String): String
		// Returns the value for a certain style attribute on an element,
		// including computed values or values set through CSS.
		getStyle: function (el, style) {
	
			var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);
	
			if ((!value || value === 'auto') && document.defaultView) {
				var css = document.defaultView.getComputedStyle(el, null);
				value = css ? css[style] : null;
			}
	
			return value === 'auto' ? null : value;
		},
	
		// @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
		// Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
		create: function (tagName, className, container) {
	
			var el = document.createElement(tagName);
			el.className = className || '';
	
			if (container) {
				container.appendChild(el);
			}
	
			return el;
		},
	
		// @function remove(el: HTMLElement)
		// Removes `el` from its parent element
		remove: function (el) {
			var parent = el.parentNode;
			if (parent) {
				parent.removeChild(el);
			}
		},
	
		// @function empty(el: HTMLElement)
		// Removes all of `el`'s children elements from `el`
		empty: function (el) {
			while (el.firstChild) {
				el.removeChild(el.firstChild);
			}
		},
	
		// @function toFront(el: HTMLElement)
		// Makes `el` the last children of its parent, so it renders in front of the other children.
		toFront: function (el) {
			el.parentNode.appendChild(el);
		},
	
		// @function toBack(el: HTMLElement)
		// Makes `el` the first children of its parent, so it renders back from the other children.
		toBack: function (el) {
			var parent = el.parentNode;
			parent.insertBefore(el, parent.firstChild);
		},
	
		// @function hasClass(el: HTMLElement, name: String): Boolean
		// Returns `true` if the element's class attribute contains `name`.
		hasClass: function (el, name) {
			if (el.classList !== undefined) {
				return el.classList.contains(name);
			}
			var className = L.DomUtil.getClass(el);
			return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
		},
	
		// @function addClass(el: HTMLElement, name: String)
		// Adds `name` to the element's class attribute.
		addClass: function (el, name) {
			if (el.classList !== undefined) {
				var classes = L.Util.splitWords(name);
				for (var i = 0, len = classes.length; i < len; i++) {
					el.classList.add(classes[i]);
				}
			} else if (!L.DomUtil.hasClass(el, name)) {
				var className = L.DomUtil.getClass(el);
				L.DomUtil.setClass(el, (className ? className + ' ' : '') + name);
			}
		},
	
		// @function removeClass(el: HTMLElement, name: String)
		// Removes `name` from the element's class attribute.
		removeClass: function (el, name) {
			if (el.classList !== undefined) {
				el.classList.remove(name);
			} else {
				L.DomUtil.setClass(el, L.Util.trim((' ' + L.DomUtil.getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
			}
		},
	
		// @function setClass(el: HTMLElement, name: String)
		// Sets the element's class.
		setClass: function (el, name) {
			if (el.className.baseVal === undefined) {
				el.className = name;
			} else {
				// in case of SVG element
				el.className.baseVal = name;
			}
		},
	
		// @function getClass(el: HTMLElement): String
		// Returns the element's class.
		getClass: function (el) {
			return el.className.baseVal === undefined ? el.className : el.className.baseVal;
		},
	
		// @function setOpacity(el: HTMLElement, opacity: Number)
		// Set the opacity of an element (including old IE support).
		// `opacity` must be a number from `0` to `1`.
		setOpacity: function (el, value) {
	
			if ('opacity' in el.style) {
				el.style.opacity = value;
	
			} else if ('filter' in el.style) {
				L.DomUtil._setOpacityIE(el, value);
			}
		},
	
		_setOpacityIE: function (el, value) {
			var filter = false,
			    filterName = 'DXImageTransform.Microsoft.Alpha';
	
			// filters collection throws an error if we try to retrieve a filter that doesn't exist
			try {
				filter = el.filters.item(filterName);
			} catch (e) {
				// don't set opacity to 1 if we haven't already set an opacity,
				// it isn't needed and breaks transparent pngs.
				if (value === 1) { return; }
			}
	
			value = Math.round(value * 100);
	
			if (filter) {
				filter.Enabled = (value !== 100);
				filter.Opacity = value;
			} else {
				el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
			}
		},
	
		// @function testProp(props: String[]): String|false
		// Goes through the array of style names and returns the first name
		// that is a valid style name for an element. If no such name is found,
		// it returns false. Useful for vendor-prefixed styles like `transform`.
		testProp: function (props) {
	
			var style = document.documentElement.style;
	
			for (var i = 0; i < props.length; i++) {
				if (props[i] in style) {
					return props[i];
				}
			}
			return false;
		},
	
		// @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
		// Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
		// and optionally scaled by `scale`. Does not have an effect if the
		// browser doesn't support 3D CSS transforms.
		setTransform: function (el, offset, scale) {
			var pos = offset || new L.Point(0, 0);
	
			el.style[L.DomUtil.TRANSFORM] =
				(L.Browser.ie3d ?
					'translate(' + pos.x + 'px,' + pos.y + 'px)' :
					'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
				(scale ? ' scale(' + scale + ')' : '');
		},
	
		// @function setPosition(el: HTMLElement, position: Point)
		// Sets the position of `el` to coordinates specified by `position`,
		// using CSS translate or top/left positioning depending on the browser
		// (used by Leaflet internally to position its layers).
		setPosition: function (el, point) { // (HTMLElement, Point[, Boolean])
	
			/*eslint-disable */
			el._leaflet_pos = point;
			/*eslint-enable */
	
			if (L.Browser.any3d) {
				L.DomUtil.setTransform(el, point);
			} else {
				el.style.left = point.x + 'px';
				el.style.top = point.y + 'px';
			}
		},
	
		// @function getPosition(el: HTMLElement): Point
		// Returns the coordinates of an element previously positioned with setPosition.
		getPosition: function (el) {
			// this method is only used for elements previously positioned using setPosition,
			// so it's safe to cache the position for performance
	
			return el._leaflet_pos || new L.Point(0, 0);
		}
	};
	
	
	(function () {
		// prefix style property names
	
		// @property TRANSFORM: String
		// Vendor-prefixed fransform style name (e.g. `'webkitTransform'` for WebKit).
		L.DomUtil.TRANSFORM = L.DomUtil.testProp(
				['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	
		// webkitTransition comes first because some browser versions that drop vendor prefix don't do
		// the same for the transitionend event, in particular the Android 4.1 stock browser
	
		// @property TRANSITION: String
		// Vendor-prefixed transform style name.
		var transition = L.DomUtil.TRANSITION = L.DomUtil.testProp(
				['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
		L.DomUtil.TRANSITION_END =
				transition === 'webkitTransition' || transition === 'OTransition' ? transition + 'End' : 'transitionend';
	
		// @function disableTextSelection()
		// Prevents the user from generating `selectstart` DOM events, usually generated
		// when the user drags the mouse through a page with text. Used internally
		// by Leaflet to override the behaviour of any click-and-drag interaction on
		// the map. Affects drag interactions on the whole document.
	
		// @function enableTextSelection()
		// Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
		if ('onselectstart' in document) {
			L.DomUtil.disableTextSelection = function () {
				L.DomEvent.on(window, 'selectstart', L.DomEvent.preventDefault);
			};
			L.DomUtil.enableTextSelection = function () {
				L.DomEvent.off(window, 'selectstart', L.DomEvent.preventDefault);
			};
	
		} else {
			var userSelectProperty = L.DomUtil.testProp(
				['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
			L.DomUtil.disableTextSelection = function () {
				if (userSelectProperty) {
					var style = document.documentElement.style;
					this._userSelect = style[userSelectProperty];
					style[userSelectProperty] = 'none';
				}
			};
			L.DomUtil.enableTextSelection = function () {
				if (userSelectProperty) {
					document.documentElement.style[userSelectProperty] = this._userSelect;
					delete this._userSelect;
				}
			};
		}
	
		// @function disableImageDrag()
		// As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
		// for `dragstart` DOM events, usually generated when the user drags an image.
		L.DomUtil.disableImageDrag = function () {
			L.DomEvent.on(window, 'dragstart', L.DomEvent.preventDefault);
		};
	
		// @function enableImageDrag()
		// Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
		L.DomUtil.enableImageDrag = function () {
			L.DomEvent.off(window, 'dragstart', L.DomEvent.preventDefault);
		};
	
		// @function preventOutline(el: HTMLElement)
		// Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
		// of the element `el` invisible. Used internally by Leaflet to prevent
		// focusable elements from displaying an outline when the user performs a
		// drag interaction on them.
		L.DomUtil.preventOutline = function (element) {
			while (element.tabIndex === -1) {
				element = element.parentNode;
			}
			if (!element || !element.style) { return; }
			L.DomUtil.restoreOutline();
			this._outlineElement = element;
			this._outlineStyle = element.style.outline;
			element.style.outline = 'none';
			L.DomEvent.on(window, 'keydown', L.DomUtil.restoreOutline, this);
		};
	
		// @function restoreOutline()
		// Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
		L.DomUtil.restoreOutline = function () {
			if (!this._outlineElement) { return; }
			this._outlineElement.style.outline = this._outlineStyle;
			delete this._outlineElement;
			delete this._outlineStyle;
			L.DomEvent.off(window, 'keydown', L.DomUtil.restoreOutline, this);
		};
	})();
	
	
	
	/* @class LatLng
	 * @aka L.LatLng
	 *
	 * Represents a geographical point with a certain latitude and longitude.
	 *
	 * @example
	 *
	 * ```
	 * var latlng = L.latLng(50.5, 30.5);
	 * ```
	 *
	 * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```
	 * map.panTo([50, 30]);
	 * map.panTo({lon: 30, lat: 50});
	 * map.panTo({lat: 50, lng: 30});
	 * map.panTo(L.latLng(50, 30));
	 * ```
	 */
	
	L.LatLng = function (lat, lng, alt) {
		if (isNaN(lat) || isNaN(lng)) {
			throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
		}
	
		// @property lat: Number
		// Latitude in degrees
		this.lat = +lat;
	
		// @property lng: Number
		// Longitude in degrees
		this.lng = +lng;
	
		// @property alt: Number
		// Altitude in meters (optional)
		if (alt !== undefined) {
			this.alt = +alt;
		}
	};
	
	L.LatLng.prototype = {
		// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
		// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overriden by setting `maxMargin` to a small number.
		equals: function (obj, maxMargin) {
			if (!obj) { return false; }
	
			obj = L.latLng(obj);
	
			var margin = Math.max(
			        Math.abs(this.lat - obj.lat),
			        Math.abs(this.lng - obj.lng));
	
			return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
		},
	
		// @method toString(): String
		// Returns a string representation of the point (for debugging purposes).
		toString: function (precision) {
			return 'LatLng(' +
			        L.Util.formatNum(this.lat, precision) + ', ' +
			        L.Util.formatNum(this.lng, precision) + ')';
		},
	
		// @method distanceTo(otherLatLng: LatLng): Number
		// Returns the distance (in meters) to the given `LatLng` calculated using the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula).
		distanceTo: function (other) {
			return L.CRS.Earth.distance(this, L.latLng(other));
		},
	
		// @method wrap(): LatLng
		// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
		wrap: function () {
			return L.CRS.Earth.wrapLatLng(this);
		},
	
		// @method toBounds(sizeInMeters: Number): LatLngBounds
		// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
		toBounds: function (sizeInMeters) {
			var latAccuracy = 180 * sizeInMeters / 40075017,
			    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);
	
			return L.latLngBounds(
			        [this.lat - latAccuracy, this.lng - lngAccuracy],
			        [this.lat + latAccuracy, this.lng + lngAccuracy]);
		},
	
		clone: function () {
			return new L.LatLng(this.lat, this.lng, this.alt);
		}
	};
	
	
	
	// @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
	// Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
	
	// @alternative
	// @factory L.latLng(coords: Array): LatLng
	// Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
	
	// @alternative
	// @factory L.latLng(coords: Object): LatLng
	// Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
	
	L.latLng = function (a, b, c) {
		if (a instanceof L.LatLng) {
			return a;
		}
		if (L.Util.isArray(a) && typeof a[0] !== 'object') {
			if (a.length === 3) {
				return new L.LatLng(a[0], a[1], a[2]);
			}
			if (a.length === 2) {
				return new L.LatLng(a[0], a[1]);
			}
			return null;
		}
		if (a === undefined || a === null) {
			return a;
		}
		if (typeof a === 'object' && 'lat' in a) {
			return new L.LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
		}
		if (b === undefined) {
			return null;
		}
		return new L.LatLng(a, b, c);
	};
	
	
	
	/*
	 * @class LatLngBounds
	 * @aka L.LatLngBounds
	 *
	 * Represents a rectangular geographical area on a map.
	 *
	 * @example
	 *
	 * ```js
	 * var corner1 = L.latLng(40.712, -74.227),
	 * corner2 = L.latLng(40.774, -74.125),
	 * bounds = L.latLngBounds(corner1, corner2);
	 * ```
	 *
	 * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * map.fitBounds([
	 * 	[40.712, -74.227],
	 * 	[40.774, -74.125]
	 * ]);
	 * ```
	 *
	 * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
	 */
	
	L.LatLngBounds = function (corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
		if (!corner1) { return; }
	
		var latlngs = corner2 ? [corner1, corner2] : corner1;
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			this.extend(latlngs[i]);
		}
	};
	
	L.LatLngBounds.prototype = {
	
		// @method extend(latlng: LatLng): this
		// Extend the bounds to contain the given point
	
		// @alternative
		// @method extend(otherBounds: LatLngBounds): this
		// Extend the bounds to contain the given bounds
		extend: function (obj) {
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof L.LatLng) {
				sw2 = obj;
				ne2 = obj;
	
			} else if (obj instanceof L.LatLngBounds) {
				sw2 = obj._southWest;
				ne2 = obj._northEast;
	
				if (!sw2 || !ne2) { return this; }
	
			} else {
				return obj ? this.extend(L.latLng(obj) || L.latLngBounds(obj)) : this;
			}
	
			if (!sw && !ne) {
				this._southWest = new L.LatLng(sw2.lat, sw2.lng);
				this._northEast = new L.LatLng(ne2.lat, ne2.lng);
			} else {
				sw.lat = Math.min(sw2.lat, sw.lat);
				sw.lng = Math.min(sw2.lng, sw.lng);
				ne.lat = Math.max(ne2.lat, ne.lat);
				ne.lng = Math.max(ne2.lng, ne.lng);
			}
	
			return this;
		},
	
		// @method pad(bufferRatio: Number): LatLngBounds
		// Returns bigger bounds created by extending the current bounds by a given percentage in each direction.
		pad: function (bufferRatio) {
			var sw = this._southWest,
			    ne = this._northEast,
			    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
			    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
			return new L.LatLngBounds(
			        new L.LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
			        new L.LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
		},
	
		// @method getCenter(): LatLng
		// Returns the center point of the bounds.
		getCenter: function () {
			return new L.LatLng(
			        (this._southWest.lat + this._northEast.lat) / 2,
			        (this._southWest.lng + this._northEast.lng) / 2);
		},
	
		// @method getSouthWest(): LatLng
		// Returns the south-west point of the bounds.
		getSouthWest: function () {
			return this._southWest;
		},
	
		// @method getNorthEast(): LatLng
		// Returns the north-east point of the bounds.
		getNorthEast: function () {
			return this._northEast;
		},
	
		// @method getNorthWest(): LatLng
		// Returns the north-west point of the bounds.
		getNorthWest: function () {
			return new L.LatLng(this.getNorth(), this.getWest());
		},
	
		// @method getSouthEast(): LatLng
		// Returns the south-east point of the bounds.
		getSouthEast: function () {
			return new L.LatLng(this.getSouth(), this.getEast());
		},
	
		// @method getWest(): Number
		// Returns the west longitude of the bounds
		getWest: function () {
			return this._southWest.lng;
		},
	
		// @method getSouth(): Number
		// Returns the south latitude of the bounds
		getSouth: function () {
			return this._southWest.lat;
		},
	
		// @method getEast(): Number
		// Returns the east longitude of the bounds
		getEast: function () {
			return this._northEast.lng;
		},
	
		// @method getNorth(): Number
		// Returns the north latitude of the bounds
		getNorth: function () {
			return this._northEast.lat;
		},
	
		// @method contains(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle contains the given one.
	
		// @alternative
		// @method contains (latlng: LatLng): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
			if (typeof obj[0] === 'number' || obj instanceof L.LatLng || 'lat' in obj) {
				obj = L.latLng(obj);
			} else {
				obj = L.latLngBounds(obj);
			}
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof L.LatLngBounds) {
				sw2 = obj.getSouthWest();
				ne2 = obj.getNorthEast();
			} else {
				sw2 = ne2 = obj;
			}
	
			return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
			       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
		},
	
		// @method intersects(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
		intersects: function (bounds) {
			bounds = L.latLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
			    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
			return latIntersects && lngIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
		overlaps: function (bounds) {
			bounds = L.latLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
			    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);
	
			return latOverlaps && lngOverlaps;
		},
	
		// @method toBBoxString(): String
		// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
		toBBoxString: function () {
			return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
		},
	
		// @method equals(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds.
		equals: function (bounds) {
			if (!bounds) { return false; }
	
			bounds = L.latLngBounds(bounds);
	
			return this._southWest.equals(bounds.getSouthWest()) &&
			       this._northEast.equals(bounds.getNorthEast());
		},
	
		// @method isValid(): Boolean
		// Returns `true` if the bounds are properly initialized.
		isValid: function () {
			return !!(this._southWest && this._northEast);
		}
	};
	
	// TODO International date line?
	
	// @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
	// Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
	
	// @alternative
	// @factory L.latLngBounds(latlngs: LatLng[])
	// Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
	L.latLngBounds = function (a, b) {
		if (a instanceof L.LatLngBounds) {
			return a;
		}
		return new L.LatLngBounds(a, b);
	};
	
	
	
	/*
	 * @namespace Projection
	 * @section
	 * Leaflet comes with a set of already defined Projections out of the box:
	 *
	 * @projection L.Projection.LonLat
	 *
	 * Equirectangular, or Plate Carree projection — the most simple projection,
	 * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
	 * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
	 * `EPSG:3395` and `Simple` CRS.
	 */
	
	L.Projection = {};
	
	L.Projection.LonLat = {
		project: function (latlng) {
			return new L.Point(latlng.lng, latlng.lat);
		},
	
		unproject: function (point) {
			return new L.LatLng(point.y, point.x);
		},
	
		bounds: L.bounds([-180, -90], [180, 90])
	};
	
	
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.SphericalMercator
	 *
	 * Spherical Mercator projection — the most common projection for online maps,
	 * used by almost all free and commercial tile providers. Assumes that Earth is
	 * a sphere. Used by the `EPSG:3857` CRS.
	 */
	
	L.Projection.SphericalMercator = {
	
		R: 6378137,
		MAX_LATITUDE: 85.0511287798,
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    max = this.MAX_LATITUDE,
			    lat = Math.max(Math.min(max, latlng.lat), -max),
			    sin = Math.sin(lat * d);
	
			return new L.Point(
					this.R * latlng.lng * d,
					this.R * Math.log((1 + sin) / (1 - sin)) / 2);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI;
	
			return new L.LatLng(
				(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
				point.x * d / this.R);
		},
	
		bounds: (function () {
			var d = 6378137 * Math.PI;
			return L.bounds([-d, -d], [d, d]);
		})()
	};
	
	
	
	/*
	 * @class CRS
	 * @aka L.CRS
	 * Abstract class that defines coordinate reference systems for projecting
	 * geographical points into pixel (screen) coordinates and back (and to
	 * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
	 * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
	 *
	 * Leaflet defines the most usual CRSs by default. If you want to use a
	 * CRS not defined by default, take a look at the
	 * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
	 */
	
	L.CRS = {
		// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
		// Projects geographical coordinates into pixel coordinates for a given zoom.
		latLngToPoint: function (latlng, zoom) {
			var projectedPoint = this.projection.project(latlng),
			    scale = this.scale(zoom);
	
			return this.transformation._transform(projectedPoint, scale);
		},
	
		// @method pointToLatLng(point: Point, zoom: Number): LatLng
		// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
		// zoom into geographical coordinates.
		pointToLatLng: function (point, zoom) {
			var scale = this.scale(zoom),
			    untransformedPoint = this.transformation.untransform(point, scale);
	
			return this.projection.unproject(untransformedPoint);
		},
	
		// @method project(latlng: LatLng): Point
		// Projects geographical coordinates into coordinates in units accepted for
		// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
		project: function (latlng) {
			return this.projection.project(latlng);
		},
	
		// @method unproject(point: Point): LatLng
		// Given a projected coordinate returns the corresponding LatLng.
		// The inverse of `project`.
		unproject: function (point) {
			return this.projection.unproject(point);
		},
	
		// @method scale(zoom: Number): Number
		// Returns the scale used when transforming projected coordinates into
		// pixel coordinates for a particular zoom. For example, it returns
		// `256 * 2^zoom` for Mercator-based CRS.
		scale: function (zoom) {
			return 256 * Math.pow(2, zoom);
		},
	
		// @method zoom(scale: Number): Number
		// Inverse of `scale()`, returns the zoom level corresponding to a scale
		// factor of `scale`.
		zoom: function (scale) {
			return Math.log(scale / 256) / Math.LN2;
		},
	
		// @method getProjectedBounds(zoom: Number): Bounds
		// Returns the projection's bounds scaled and transformed for the provided `zoom`.
		getProjectedBounds: function (zoom) {
			if (this.infinite) { return null; }
	
			var b = this.projection.bounds,
			    s = this.scale(zoom),
			    min = this.transformation.transform(b.min, s),
			    max = this.transformation.transform(b.max, s);
	
			return L.bounds(min, max);
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates.
	
		// @property code: String
		// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
		//
		// @property wrapLng: Number[]
		// An array of two numbers defining whether the longitude (horizontal) coordinate
		// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
		// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
		//
		// @property wrapLat: Number[]
		// Like `wrapLng`, but for the latitude (vertical) axis.
	
		// wrapLng: [min, max],
		// wrapLat: [min, max],
	
		// @property infinite: Boolean
		// If true, the coordinate space will be unbounded (infinite in both axes)
		infinite: false,
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where lat and lng has been wrapped according to the
		// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
		// Only accepts actual `L.LatLng` instances, not arrays.
		wrapLatLng: function (latlng) {
			var lng = this.wrapLng ? L.Util.wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
			    lat = this.wrapLat ? L.Util.wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
			    alt = latlng.alt;
	
			return L.latLng(lat, lng, alt);
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring
		// that its center is within the CRS's bounds.
		// Only accepts actual `L.LatLngBounds` instances, not arrays.
		wrapLatLngBounds: function (bounds) {
			var center = bounds.getCenter(),
			    newCenter = this.wrapLatLng(center),
			    latShift = center.lat - newCenter.lat,
			    lngShift = center.lng - newCenter.lng;
	
			if (latShift === 0 && lngShift === 0) {
				return bounds;
			}
	
			var sw = bounds.getSouthWest(),
			    ne = bounds.getNorthEast(),
			    newSw = L.latLng({lat: sw.lat - latShift, lng: sw.lng - lngShift}),
			    newNe = L.latLng({lat: ne.lat - latShift, lng: ne.lng - lngShift});
	
			return new L.LatLngBounds(newSw, newNe);
		}
	};
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Simple
	 *
	 * A simple CRS that maps longitude and latitude into `x` and `y` directly.
	 * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
	 * axis should still be inverted (going from bottom to top). `distance()` returns
	 * simple euclidean distance.
	 */
	
	L.CRS.Simple = L.extend({}, L.CRS, {
		projection: L.Projection.LonLat,
		transformation: new L.Transformation(1, 0, -1, 0),
	
		scale: function (zoom) {
			return Math.pow(2, zoom);
		},
	
		zoom: function (scale) {
			return Math.log(scale) / Math.LN2;
		},
	
		distance: function (latlng1, latlng2) {
			var dx = latlng2.lng - latlng1.lng,
			    dy = latlng2.lat - latlng1.lat;
	
			return Math.sqrt(dx * dx + dy * dy);
		},
	
		infinite: true
	});
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Earth
	 *
	 * Serves as the base for CRS that are global such that they cover the earth.
	 * Can only be used as the base for other CRS and cannot be used directly,
	 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
	 * meters.
	 */
	
	L.CRS.Earth = L.extend({}, L.CRS, {
		wrapLng: [-180, 180],
	
		// Mean Earth Radius, as recommended for use by
		// the International Union of Geodesy and Geophysics,
		// see http://rosettacode.org/wiki/Haversine_formula
		R: 6371000,
	
		// distance between two geographical points using spherical law of cosines approximation
		distance: function (latlng1, latlng2) {
			var rad = Math.PI / 180,
			    lat1 = latlng1.lat * rad,
			    lat2 = latlng2.lat * rad,
			    a = Math.sin(lat1) * Math.sin(lat2) +
			        Math.cos(lat1) * Math.cos(lat2) * Math.cos((latlng2.lng - latlng1.lng) * rad);
	
			return this.R * Math.acos(Math.min(a, 1));
		}
	});
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3857
	 *
	 * The most common CRS for online maps, used by almost all free and commercial
	 * tile providers. Uses Spherical Mercator projection. Set in by default in
	 * Map's `crs` option.
	 */
	
	L.CRS.EPSG3857 = L.extend({}, L.CRS.Earth, {
		code: 'EPSG:3857',
		projection: L.Projection.SphericalMercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * L.Projection.SphericalMercator.R);
			return new L.Transformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	L.CRS.EPSG900913 = L.extend({}, L.CRS.EPSG3857, {
		code: 'EPSG:900913'
	});
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG4326
	 *
	 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
	 *
	 * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
	 * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
	 * with this CRS, ensure that there are two 256x256 pixel tiles covering the
	 * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
	 * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
	 */
	
	L.CRS.EPSG4326 = L.extend({}, L.CRS.Earth, {
		code: 'EPSG:4326',
		projection: L.Projection.LonLat,
		transformation: new L.Transformation(1 / 180, 1, -1 / 180, 0.5)
	});
	
	
	
	/*
	 * @class Map
	 * @aka L.Map
	 * @inherits Evented
	 *
	 * The central class of the API — it is used to create a map on a page and manipulate it.
	 *
	 * @example
	 *
	 * ```js
	 * // initialize the map on the "map" div with a given center and zoom
	 * var map = L.map('map', {
	 * 	center: [51.505, -0.09],
	 * 	zoom: 13
	 * });
	 * ```
	 *
	 */
	
	L.Map = L.Evented.extend({
	
		options: {
			// @section Map State Options
			// @option crs: CRS = L.CRS.EPSG3857
			// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
			// sure what it means.
			crs: L.CRS.EPSG3857,
	
			// @option center: LatLng = undefined
			// Initial geographic center of the map
			center: undefined,
	
			// @option zoom: Number = undefined
			// Initial map zoom level
			zoom: undefined,
	
			// @option minZoom: Number = undefined
			// Minimum zoom level of the map. Overrides any `minZoom` option set on map layers.
			minZoom: undefined,
	
			// @option maxZoom: Number = undefined
			// Maximum zoom level of the map. Overrides any `maxZoom` option set on map layers.
			maxZoom: undefined,
	
			// @option layers: Layer[] = []
			// Array of layers that will be added to the map initially
			layers: [],
	
			// @option maxBounds: LatLngBounds = null
			// When this option is set, the map restricts the view to the given
			// geographical bounds, bouncing the user back if the user tries to pan
			// outside the view. To set the restriction dynamically, use
			// [`setMaxBounds`](#map-setmaxbounds) method.
			maxBounds: undefined,
	
			// @option renderer: Renderer = *
			// The default method for drawing vector layers on the map. `L.SVG`
			// or `L.Canvas` by default depending on browser support.
			renderer: undefined,
	
	
			// @section Animation Options
			// @option zoomAnimation: Boolean = true
			// Whether the map zoom animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			zoomAnimation: true,
	
			// @option zoomAnimationThreshold: Number = 4
			// Won't animate zoom if the zoom difference exceeds this value.
			zoomAnimationThreshold: 4,
	
			// @option fadeAnimation: Boolean = true
			// Whether the tile fade animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			fadeAnimation: true,
	
			// @option markerZoomAnimation: Boolean = true
			// Whether markers animate their zoom with the zoom animation, if disabled
			// they will disappear for the length of the animation. By default it's
			// enabled in all browsers that support CSS3 Transitions except Android.
			markerZoomAnimation: true,
	
			// @option transform3DLimit: Number = 2^23
			// Defines the maximum size of a CSS translation transform. The default
			// value should not be changed unless a web browser positions layers in
			// the wrong place after doing a large `panBy`.
			transform3DLimit: 8388608, // Precision limit of a 32-bit float
	
			// @section Interaction Options
			// @option zoomSnap: Number = 1
			// Forces the map's zoom level to always be a multiple of this, particularly
			// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
			// By default, the zoom level snaps to the nearest integer; lower values
			// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
			// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
			zoomSnap: 1,
	
			// @option zoomDelta: Number = 1
			// Controls how much the map's zoom level will change after a
			// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
			// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
			// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
			zoomDelta: 1,
	
			// @option trackResize: Boolean = true
			// Whether the map automatically handles browser window resize to update itself.
			trackResize: true
		},
	
		initialize: function (id, options) { // (HTMLElement or String, Object)
			options = L.setOptions(this, options);
	
			this._initContainer(id);
			this._initLayout();
	
			// hack for https://github.com/Leaflet/Leaflet/issues/1980
			this._onResize = L.bind(this._onResize, this);
	
			this._initEvents();
	
			if (options.maxBounds) {
				this.setMaxBounds(options.maxBounds);
			}
	
			if (options.zoom !== undefined) {
				this._zoom = this._limitZoom(options.zoom);
			}
	
			if (options.center && options.zoom !== undefined) {
				this.setView(L.latLng(options.center), options.zoom, {reset: true});
			}
	
			this._handlers = [];
			this._layers = {};
			this._zoomBoundLayers = {};
			this._sizeChanged = true;
	
			this.callInitHooks();
	
			// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
			this._zoomAnimated = L.DomUtil.TRANSITION && L.Browser.any3d && !L.Browser.mobileOpera &&
					this.options.zoomAnimation;
	
			// zoom transitions run with the same duration for all layers, so if one of transitionend events
			// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
			if (this._zoomAnimated) {
				this._createAnimProxy();
				L.DomEvent.on(this._proxy, L.DomUtil.TRANSITION_END, this._catchTransitionEnd, this);
			}
	
			this._addLayers(this.options.layers);
		},
	
	
		// @section Methods for modifying map state
	
		// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) with the given
		// animation options.
		setView: function (center, zoom, options) {
	
			zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
			center = this._limitCenter(L.latLng(center), zoom, this.options.maxBounds);
			options = options || {};
	
			this._stop();
	
			if (this._loaded && !options.reset && options !== true) {
	
				if (options.animate !== undefined) {
					options.zoom = L.extend({animate: options.animate}, options.zoom);
					options.pan = L.extend({animate: options.animate, duration: options.duration}, options.pan);
				}
	
				// try animating pan or zoom
				var moved = (this._zoom !== zoom) ?
					this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
					this._tryAnimatedPan(center, options.pan);
	
				if (moved) {
					// prevent resize handler call, the view will refresh after animation anyway
					clearTimeout(this._sizeTimer);
					return this;
				}
			}
	
			// animation didn't start, just reset the map view
			this._resetView(center, zoom);
	
			return this;
		},
	
		// @method setZoom(zoom: Number, options: Zoom/pan options): this
		// Sets the zoom of the map.
		setZoom: function (zoom, options) {
			if (!this._loaded) {
				this._zoom = zoom;
				return this;
			}
			return this.setView(this.getCenter(), zoom, {zoom: options});
		},
	
		// @method zoomIn(delta?: Number, options?: Zoom options): this
		// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomIn: function (delta, options) {
			delta = delta || (L.Browser.any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom + delta, options);
		},
	
		// @method zoomOut(delta?: Number, options?: Zoom options): this
		// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomOut: function (delta, options) {
			delta = delta || (L.Browser.any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom - delta, options);
		},
	
		// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified geographical point on the map
		// stationary (e.g. used internally for scroll zoom and double-click zoom).
		// @alternative
		// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
		setZoomAround: function (latlng, zoom, options) {
			var scale = this.getZoomScale(zoom),
			    viewHalf = this.getSize().divideBy(2),
			    containerPoint = latlng instanceof L.Point ? latlng : this.latLngToContainerPoint(latlng),
	
			    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
			    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
			return this.setView(newCenter, zoom, {zoom: options});
		},
	
		_getBoundsCenterZoom: function (bounds, options) {
	
			options = options || {};
			bounds = bounds.getBounds ? bounds.getBounds() : L.latLngBounds(bounds);
	
			var paddingTL = L.point(options.paddingTopLeft || options.padding || [0, 0]),
			    paddingBR = L.point(options.paddingBottomRight || options.padding || [0, 0]),
	
			    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
			zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;
	
			var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
			    swPoint = this.project(bounds.getSouthWest(), zoom),
			    nePoint = this.project(bounds.getNorthEast(), zoom),
			    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
			return {
				center: center,
				zoom: zoom
			};
		},
	
		// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets a map view that contains the given geographical bounds with the
		// maximum zoom level possible.
		fitBounds: function (bounds, options) {
	
			bounds = L.latLngBounds(bounds);
	
			if (!bounds.isValid()) {
				throw new Error('Bounds are not valid.');
			}
	
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.setView(target.center, target.zoom, options);
		},
	
		// @method fitWorld(options?: fitBounds options): this
		// Sets a map view that mostly contains the whole world with the maximum
		// zoom level possible.
		fitWorld: function (options) {
			return this.fitBounds([[-90, -180], [90, 180]], options);
		},
	
		// @method panTo(latlng: LatLng, options?: Pan options): this
		// Pans the map to a given center.
		panTo: function (center, options) { // (LatLng)
			return this.setView(center, this._zoom, {pan: options});
		},
	
		// @method panBy(offset: Point): this
		// Pans the map by a given number of pixels (animated).
		panBy: function (offset, options) {
			offset = L.point(offset).round();
			options = options || {};
	
			if (!offset.x && !offset.y) {
				return this.fire('moveend');
			}
			// If we pan too far, Chrome gets issues with tiles
			// and makes them disappear or appear in the wrong place (slightly offset) #2602
			if (options.animate !== true && !this.getSize().contains(offset)) {
				this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
				return this;
			}
	
			if (!this._panAnim) {
				this._panAnim = new L.PosAnimation();
	
				this._panAnim.on({
					'step': this._onPanTransitionStep,
					'end': this._onPanTransitionEnd
				}, this);
			}
	
			// don't fire movestart if animating inertia
			if (!options.noMoveStart) {
				this.fire('movestart');
			}
	
			// animate pan unless animate: false specified
			if (options.animate !== false) {
				L.DomUtil.addClass(this._mapPane, 'leaflet-pan-anim');
	
				var newPos = this._getMapPanePos().subtract(offset).round();
				this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
			} else {
				this._rawPanBy(offset);
				this.fire('move').fire('moveend');
			}
	
			return this;
		},
	
		// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) performing a smooth
		// pan-zoom animation.
		flyTo: function (targetCenter, targetZoom, options) {
	
			options = options || {};
			if (options.animate === false || !L.Browser.any3d) {
				return this.setView(targetCenter, targetZoom, options);
			}
	
			this._stop();
	
			var from = this.project(this.getCenter()),
			    to = this.project(targetCenter),
			    size = this.getSize(),
			    startZoom = this._zoom;
	
			targetCenter = L.latLng(targetCenter);
			targetZoom = targetZoom === undefined ? startZoom : targetZoom;
	
			var w0 = Math.max(size.x, size.y),
			    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
			    u1 = (to.distanceTo(from)) || 1,
			    rho = 1.42,
			    rho2 = rho * rho;
	
			function r(i) {
				var s1 = i ? -1 : 1,
				    s2 = i ? w1 : w0,
				    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
				    b1 = 2 * s2 * rho2 * u1,
				    b = t1 / b1,
				    sq = Math.sqrt(b * b + 1) - b;
	
				    // workaround for floating point precision bug when sq = 0, log = -Infinite,
				    // thus triggering an infinite loop in flyTo
				    var log = sq < 0.000000001 ? -18 : Math.log(sq);
	
				return log;
			}
	
			function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
			function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
			function tanh(n) { return sinh(n) / cosh(n); }
	
			var r0 = r(0);
	
			function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
			function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }
	
			function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }
	
			var start = Date.now(),
			    S = (r(1) - r0) / rho,
			    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
	
			function frame() {
				var t = (Date.now() - start) / duration,
				    s = easeOut(t) * S;
	
				if (t <= 1) {
					this._flyToFrame = L.Util.requestAnimFrame(frame, this);
	
					this._move(
						this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
						this.getScaleZoom(w0 / w(s), startZoom),
						{flyTo: true});
	
				} else {
					this
						._move(targetCenter, targetZoom)
						._moveEnd(true);
				}
			}
	
			this._moveStart(true);
	
			frame.call(this);
			return this;
		},
	
		// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
		// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
		flyToBounds: function (bounds, options) {
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.flyTo(target.center, target.zoom, options);
		},
	
		// @method setMaxBounds(bounds: Bounds): this
		// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
		setMaxBounds: function (bounds) {
			bounds = L.latLngBounds(bounds);
	
			if (!bounds.isValid()) {
				this.options.maxBounds = null;
				return this.off('moveend', this._panInsideMaxBounds);
			} else if (this.options.maxBounds) {
				this.off('moveend', this._panInsideMaxBounds);
			}
	
			this.options.maxBounds = bounds;
	
			if (this._loaded) {
				this._panInsideMaxBounds();
			}
	
			return this.on('moveend', this._panInsideMaxBounds);
		},
	
		// @method setMinZoom(zoom: Number): this
		// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
		setMinZoom: function (zoom) {
			this.options.minZoom = zoom;
	
			if (this._loaded && this.getZoom() < this.options.minZoom) {
				return this.setZoom(zoom);
			}
	
			return this;
		},
	
		// @method setMaxZoom(zoom: Number): this
		// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
		setMaxZoom: function (zoom) {
			this.options.maxZoom = zoom;
	
			if (this._loaded && (this.getZoom() > this.options.maxZoom)) {
				return this.setZoom(zoom);
			}
	
			return this;
		},
	
		// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
		// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
		panInsideBounds: function (bounds, options) {
			this._enforcingBounds = true;
			var center = this.getCenter(),
			    newCenter = this._limitCenter(center, this._zoom, L.latLngBounds(bounds));
	
			if (!center.equals(newCenter)) {
				this.panTo(newCenter, options);
			}
	
			this._enforcingBounds = false;
			return this;
		},
	
		// @method invalidateSize(options: Zoom/Pan options): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default. If `options.pan` is `false`, panning will not occur.
		// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
		// that it doesn't happen often even if the method is called many
		// times in a row.
	
		// @alternative
		// @method invalidateSize(animate: Boolean): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default.
		invalidateSize: function (options) {
			if (!this._loaded) { return this; }
	
			options = L.extend({
				animate: false,
				pan: true
			}, options === true ? {animate: true} : options);
	
			var oldSize = this.getSize();
			this._sizeChanged = true;
			this._lastCenter = null;
	
			var newSize = this.getSize(),
			    oldCenter = oldSize.divideBy(2).round(),
			    newCenter = newSize.divideBy(2).round(),
			    offset = oldCenter.subtract(newCenter);
	
			if (!offset.x && !offset.y) { return this; }
	
			if (options.animate && options.pan) {
				this.panBy(offset);
	
			} else {
				if (options.pan) {
					this._rawPanBy(offset);
				}
	
				this.fire('move');
	
				if (options.debounceMoveend) {
					clearTimeout(this._sizeTimer);
					this._sizeTimer = setTimeout(L.bind(this.fire, this, 'moveend'), 200);
				} else {
					this.fire('moveend');
				}
			}
	
			// @section Map state change events
			// @event resize: ResizeEvent
			// Fired when the map is resized.
			return this.fire('resize', {
				oldSize: oldSize,
				newSize: newSize
			});
		},
	
		// @section Methods for modifying map state
		// @method stop(): this
		// Stops the currently running `panTo` or `flyTo` animation, if any.
		stop: function () {
			this.setZoom(this._limitZoom(this._zoom));
			if (!this.options.zoomSnap) {
				this.fire('viewreset');
			}
			return this._stop();
		},
	
		// @section Geolocation methods
		// @method locate(options?: Locate options): this
		// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
		// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
		// and optionally sets the map view to the user's location with respect to
		// detection accuracy (or to the world view if geolocation failed).
		// Note that, if your page doesn't use HTTPS, this method will fail in
		// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
		// See `Locate options` for more details.
		locate: function (options) {
	
			options = this._locateOptions = L.extend({
				timeout: 10000,
				watch: false
				// setView: false
				// maxZoom: <Number>
				// maximumAge: 0
				// enableHighAccuracy: false
			}, options);
	
			if (!('geolocation' in navigator)) {
				this._handleGeolocationError({
					code: 0,
					message: 'Geolocation not supported.'
				});
				return this;
			}
	
			var onResponse = L.bind(this._handleGeolocationResponse, this),
			    onError = L.bind(this._handleGeolocationError, this);
	
			if (options.watch) {
				this._locationWatchId =
				        navigator.geolocation.watchPosition(onResponse, onError, options);
			} else {
				navigator.geolocation.getCurrentPosition(onResponse, onError, options);
			}
			return this;
		},
	
		// @method stopLocate(): this
		// Stops watching location previously initiated by `map.locate({watch: true})`
		// and aborts resetting the map view if map.locate was called with
		// `{setView: true}`.
		stopLocate: function () {
			if (navigator.geolocation && navigator.geolocation.clearWatch) {
				navigator.geolocation.clearWatch(this._locationWatchId);
			}
			if (this._locateOptions) {
				this._locateOptions.setView = false;
			}
			return this;
		},
	
		_handleGeolocationError: function (error) {
			var c = error.code,
			    message = error.message ||
			            (c === 1 ? 'permission denied' :
			            (c === 2 ? 'position unavailable' : 'timeout'));
	
			if (this._locateOptions.setView && !this._loaded) {
				this.fitWorld();
			}
	
			// @section Location events
			// @event locationerror: ErrorEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
			this.fire('locationerror', {
				code: c,
				message: 'Geolocation error: ' + message + '.'
			});
		},
	
		_handleGeolocationResponse: function (pos) {
			var lat = pos.coords.latitude,
			    lng = pos.coords.longitude,
			    latlng = new L.LatLng(lat, lng),
			    bounds = latlng.toBounds(pos.coords.accuracy),
			    options = this._locateOptions;
	
			if (options.setView) {
				var zoom = this.getBoundsZoom(bounds);
				this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
			}
	
			var data = {
				latlng: latlng,
				bounds: bounds,
				timestamp: pos.timestamp
			};
	
			for (var i in pos.coords) {
				if (typeof pos.coords[i] === 'number') {
					data[i] = pos.coords[i];
				}
			}
	
			// @event locationfound: LocationEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method)
			// went successfully.
			this.fire('locationfound', data);
		},
	
		// TODO handler.addTo
		// TODO Appropiate docs section?
		// @section Other Methods
		// @method addHandler(name: String, HandlerClass: Function): this
		// Adds a new `Handler` to the map, given its name and constructor function.
		addHandler: function (name, HandlerClass) {
			if (!HandlerClass) { return this; }
	
			var handler = this[name] = new HandlerClass(this);
	
			this._handlers.push(handler);
	
			if (this.options[name]) {
				handler.enable();
			}
	
			return this;
		},
	
		// @method remove(): this
		// Destroys the map and clears all related event listeners.
		remove: function () {
	
			this._initEvents(true);
	
			if (this._containerId !== this._container._leaflet_id) {
				throw new Error('Map container is being reused by another instance');
			}
	
			try {
				// throws error in IE6-8
				delete this._container._leaflet_id;
				delete this._containerId;
			} catch (e) {
				/*eslint-disable */
				this._container._leaflet_id = undefined;
				/*eslint-enable */
				this._containerId = undefined;
			}
	
			L.DomUtil.remove(this._mapPane);
	
			if (this._clearControlPos) {
				this._clearControlPos();
			}
	
			this._clearHandlers();
	
			if (this._loaded) {
				// @section Map state change events
				// @event unload: Event
				// Fired when the map is destroyed with [remove](#map-remove) method.
				this.fire('unload');
			}
	
			for (var i in this._layers) {
				this._layers[i].remove();
			}
	
			return this;
		},
	
		// @section Other Methods
		// @method createPane(name: String, container?: HTMLElement): HTMLElement
		// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
		// then returns it. The pane is created as a children of `container`, or
		// as a children of the main map pane if not set.
		createPane: function (name, container) {
			var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
			    pane = L.DomUtil.create('div', className, container || this._mapPane);
	
			if (name) {
				this._panes[name] = pane;
			}
			return pane;
		},
	
		// @section Methods for Getting Map State
	
		// @method getCenter(): LatLng
		// Returns the geographical center of the map view
		getCenter: function () {
			this._checkIfLoaded();
	
			if (this._lastCenter && !this._moved()) {
				return this._lastCenter;
			}
			return this.layerPointToLatLng(this._getCenterLayerPoint());
		},
	
		// @method getZoom(): Number
		// Returns the current zoom level of the map view
		getZoom: function () {
			return this._zoom;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the geographical bounds visible in the current map view
		getBounds: function () {
			var bounds = this.getPixelBounds(),
			    sw = this.unproject(bounds.getBottomLeft()),
			    ne = this.unproject(bounds.getTopRight());
	
			return new L.LatLngBounds(sw, ne);
		},
	
		// @method getMinZoom(): Number
		// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
		getMinZoom: function () {
			return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
		},
	
		// @method getMaxZoom(): Number
		// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
		getMaxZoom: function () {
			return this.options.maxZoom === undefined ?
				(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
				this.options.maxZoom;
		},
	
		// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean): Number
		// Returns the maximum zoom level on which the given bounds fit to the map
		// view in its entirety. If `inside` (optional) is set to `true`, the method
		// instead returns the minimum zoom level on which the map view fits into
		// the given bounds in its entirety.
		getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
			bounds = L.latLngBounds(bounds);
			padding = L.point(padding || [0, 0]);
	
			var zoom = this.getZoom() || 0,
			    min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    nw = bounds.getNorthWest(),
			    se = bounds.getSouthEast(),
			    size = this.getSize().subtract(padding),
			    boundsSize = L.bounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
			    snap = L.Browser.any3d ? this.options.zoomSnap : 1;
	
			var scale = Math.min(size.x / boundsSize.x, size.y / boundsSize.y);
			zoom = this.getScaleZoom(scale, zoom);
	
			if (snap) {
				zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
				zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
			}
	
			return Math.max(min, Math.min(max, zoom));
		},
	
		// @method getSize(): Point
		// Returns the current size of the map container (in pixels).
		getSize: function () {
			if (!this._size || this._sizeChanged) {
				this._size = new L.Point(
					this._container.clientWidth || 0,
					this._container.clientHeight || 0);
	
				this._sizeChanged = false;
			}
			return this._size.clone();
		},
	
		// @method getPixelBounds(): Bounds
		// Returns the bounds of the current map view in projected pixel
		// coordinates (sometimes useful in layer and overlay implementations).
		getPixelBounds: function (center, zoom) {
			var topLeftPoint = this._getTopLeftPoint(center, zoom);
			return new L.Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
		},
	
		// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
		// the map pane? "left point of the map layer" can be confusing, specially
		// since there can be negative offsets.
		// @method getPixelOrigin(): Point
		// Returns the projected pixel coordinates of the top left point of
		// the map layer (useful in custom layer and overlay implementations).
		getPixelOrigin: function () {
			this._checkIfLoaded();
			return this._pixelOrigin;
		},
	
		// @method getPixelWorldBounds(zoom?: Number): Bounds
		// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
		// If `zoom` is omitted, the map's current zoom level is used.
		getPixelWorldBounds: function (zoom) {
			return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
		},
	
		// @section Other Methods
	
		// @method getPane(pane: String|HTMLElement): HTMLElement
		// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
		getPane: function (pane) {
			return typeof pane === 'string' ? this._panes[pane] : pane;
		},
	
		// @method getPanes(): Object
		// Returns a plain object containing the names of all [panes](#map-pane) as keys and
		// the panes as values.
		getPanes: function () {
			return this._panes;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the map.
		getContainer: function () {
			return this._container;
		},
	
	
		// @section Conversion Methods
	
		// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
		// Returns the scale factor to be applied to a map transition from zoom level
		// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
		getZoomScale: function (toZoom, fromZoom) {
			// TODO replace with universal implementation after refactoring projections
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			return crs.scale(toZoom) / crs.scale(fromZoom);
		},
	
		// @method getScaleZoom(scale: Number, fromZoom: Number): Number
		// Returns the zoom level that the map would end up at, if it is at `fromZoom`
		// level and everything is scaled by a factor of `scale`. Inverse of
		// [`getZoomScale`](#map-getZoomScale).
		getScaleZoom: function (scale, fromZoom) {
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			var zoom = crs.zoom(scale * crs.scale(fromZoom));
			return isNaN(zoom) ? Infinity : zoom;
		},
	
		// @method project(latlng: LatLng, zoom: Number): Point
		// Projects a geographical coordinate `LatLng` according to the projection
		// of the map's CRS, then scales it according to `zoom` and the CRS's
		// `Transformation`. The result is pixel coordinate relative to
		// the CRS origin.
		project: function (latlng, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.latLngToPoint(L.latLng(latlng), zoom);
		},
	
		// @method unproject(point: Point, zoom: Number): LatLng
		// Inverse of [`project`](#map-project).
		unproject: function (point, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.pointToLatLng(L.point(point), zoom);
		},
	
		// @method layerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding geographical coordinate (for the current zoom level).
		layerPointToLatLng: function (point) {
			var projectedPoint = L.point(point).add(this.getPixelOrigin());
			return this.unproject(projectedPoint);
		},
	
		// @method latLngToLayerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the [origin pixel](#map-getpixelorigin).
		latLngToLayerPoint: function (latlng) {
			var projectedPoint = this.project(L.latLng(latlng))._round();
			return projectedPoint._subtract(this.getPixelOrigin());
		},
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
		// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
		// CRS's bounds.
		// By default this means longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees.
		wrapLatLng: function (latlng) {
			return this.options.crs.wrapLatLng(L.latLng(latlng));
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring that
		// its center is within the CRS's bounds.
		// By default this means the center longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees, and the majority of the bounds
		// overlaps the CRS's bounds.
		wrapLatLngBounds: function (latlng) {
			return this.options.crs.wrapLatLngBounds(L.latLngBounds(latlng));
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates according to
		// the map's CRS. By default this measures distance in meters.
		distance: function (latlng1, latlng2) {
			return this.options.crs.distance(L.latLng(latlng1), L.latLng(latlng2));
		},
	
		// @method containerPointToLayerPoint(point: Point): Point
		// Given a pixel coordinate relative to the map container, returns the corresponding
		// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
		containerPointToLayerPoint: function (point) { // (Point)
			return L.point(point).subtract(this._getMapPanePos());
		},
	
		// @method layerPointToContainerPoint(point: Point): Point
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding pixel coordinate relative to the map container.
		layerPointToContainerPoint: function (point) { // (Point)
			return L.point(point).add(this._getMapPanePos());
		},
	
		// @method containerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the map container, returns
		// the corresponding geographical coordinate (for the current zoom level).
		containerPointToLatLng: function (point) {
			var layerPoint = this.containerPointToLayerPoint(L.point(point));
			return this.layerPointToLatLng(layerPoint);
		},
	
		// @method latLngToContainerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the map container.
		latLngToContainerPoint: function (latlng) {
			return this.layerPointToContainerPoint(this.latLngToLayerPoint(L.latLng(latlng)));
		},
	
		// @method mouseEventToContainerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to the
		// map container where the event took place.
		mouseEventToContainerPoint: function (e) {
			return L.DomEvent.getMousePosition(e, this._container);
		},
	
		// @method mouseEventToLayerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to
		// the [origin pixel](#map-getpixelorigin) where the event took place.
		mouseEventToLayerPoint: function (e) {
			return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
		},
	
		// @method mouseEventToLatLng(ev: MouseEvent): LatLng
		// Given a MouseEvent object, returns geographical coordinate where the
		// event took place.
		mouseEventToLatLng: function (e) { // (MouseEvent)
			return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
		},
	
	
		// map initialization methods
	
		_initContainer: function (id) {
			var container = this._container = L.DomUtil.get(id);
	
			if (!container) {
				throw new Error('Map container not found.');
			} else if (container._leaflet_id) {
				throw new Error('Map container is already initialized.');
			}
	
			L.DomEvent.addListener(container, 'scroll', this._onScroll, this);
			this._containerId = L.Util.stamp(container);
		},
	
		_initLayout: function () {
			var container = this._container;
	
			this._fadeAnimated = this.options.fadeAnimation && L.Browser.any3d;
	
			L.DomUtil.addClass(container, 'leaflet-container' +
				(L.Browser.touch ? ' leaflet-touch' : '') +
				(L.Browser.retina ? ' leaflet-retina' : '') +
				(L.Browser.ielt9 ? ' leaflet-oldie' : '') +
				(L.Browser.safari ? ' leaflet-safari' : '') +
				(this._fadeAnimated ? ' leaflet-fade-anim' : ''));
	
			var position = L.DomUtil.getStyle(container, 'position');
	
			if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
				container.style.position = 'relative';
			}
	
			this._initPanes();
	
			if (this._initControlPos) {
				this._initControlPos();
			}
		},
	
		_initPanes: function () {
			var panes = this._panes = {};
			this._paneRenderers = {};
	
			// @section
			//
			// Panes are DOM elements used to control the ordering of layers on the map. You
			// can access panes with [`map.getPane`](#map-getpane) or
			// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
			// [`map.createPane`](#map-createpane) method.
			//
			// Every map has the following default panes that differ only in zIndex.
			//
			// @pane mapPane: HTMLElement = 'auto'
			// Pane that contains all other map panes
	
			this._mapPane = this.createPane('mapPane', this._container);
			L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));
	
			// @pane tilePane: HTMLElement = 200
			// Pane for `GridLayer`s and `TileLayer`s
			this.createPane('tilePane');
			// @pane overlayPane: HTMLElement = 400
			// Pane for vector overlays (`Path`s), like `Polyline`s and `Polygon`s
			this.createPane('shadowPane');
			// @pane shadowPane: HTMLElement = 500
			// Pane for overlay shadows (e.g. `Marker` shadows)
			this.createPane('overlayPane');
			// @pane markerPane: HTMLElement = 600
			// Pane for `Icon`s of `Marker`s
			this.createPane('markerPane');
			// @pane tooltipPane: HTMLElement = 650
			// Pane for tooltip.
			this.createPane('tooltipPane');
			// @pane popupPane: HTMLElement = 700
			// Pane for `Popup`s.
			this.createPane('popupPane');
	
			if (!this.options.markerZoomAnimation) {
				L.DomUtil.addClass(panes.markerPane, 'leaflet-zoom-hide');
				L.DomUtil.addClass(panes.shadowPane, 'leaflet-zoom-hide');
			}
		},
	
	
		// private methods that modify map state
	
		// @section Map state change events
		_resetView: function (center, zoom) {
			L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));
	
			var loading = !this._loaded;
			this._loaded = true;
			zoom = this._limitZoom(zoom);
	
			this.fire('viewprereset');
	
			var zoomChanged = this._zoom !== zoom;
			this
				._moveStart(zoomChanged)
				._move(center, zoom)
				._moveEnd(zoomChanged);
	
			// @event viewreset: Event
			// Fired when the map needs to redraw its content (this usually happens
			// on map zoom or load). Very useful for creating custom overlays.
			this.fire('viewreset');
	
			// @event load: Event
			// Fired when the map is initialized (when its center and zoom are set
			// for the first time).
			if (loading) {
				this.fire('load');
			}
		},
	
		_moveStart: function (zoomChanged) {
			// @event zoomstart: Event
			// Fired when the map zoom is about to change (e.g. before zoom animation).
			// @event movestart: Event
			// Fired when the view of the map starts changing (e.g. user starts dragging the map).
			if (zoomChanged) {
				this.fire('zoomstart');
			}
			return this.fire('movestart');
		},
	
		_move: function (center, zoom, data) {
			if (zoom === undefined) {
				zoom = this._zoom;
			}
			var zoomChanged = this._zoom !== zoom;
	
			this._zoom = zoom;
			this._lastCenter = center;
			this._pixelOrigin = this._getNewPixelOrigin(center);
	
			// @event zoom: Event
			// Fired repeatedly during any change in zoom level, including zoom
			// and fly animations.
			if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
				this.fire('zoom', data);
			}
	
			// @event move: Event
			// Fired repeatedly during any movement of the map, including pan and
			// fly animations.
			return this.fire('move', data);
		},
	
		_moveEnd: function (zoomChanged) {
			// @event zoomend: Event
			// Fired when the map has changed, after any animations.
			if (zoomChanged) {
				this.fire('zoomend');
			}
	
			// @event moveend: Event
			// Fired when the center of the map stops changing (e.g. user stopped
			// dragging the map).
			return this.fire('moveend');
		},
	
		_stop: function () {
			L.Util.cancelAnimFrame(this._flyToFrame);
			if (this._panAnim) {
				this._panAnim.stop();
			}
			return this;
		},
	
		_rawPanBy: function (offset) {
			L.DomUtil.setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
		},
	
		_getZoomSpan: function () {
			return this.getMaxZoom() - this.getMinZoom();
		},
	
		_panInsideMaxBounds: function () {
			if (!this._enforcingBounds) {
				this.panInsideBounds(this.options.maxBounds);
			}
		},
	
		_checkIfLoaded: function () {
			if (!this._loaded) {
				throw new Error('Set map center and zoom first.');
			}
		},
	
		// DOM event handling
	
		// @section Interaction events
		_initEvents: function (remove) {
			if (!L.DomEvent) { return; }
	
			this._targets = {};
			this._targets[L.stamp(this._container)] = this;
	
			var onOff = remove ? 'off' : 'on';
	
			// @event click: MouseEvent
			// Fired when the user clicks (or taps) the map.
			// @event dblclick: MouseEvent
			// Fired when the user double-clicks (or double-taps) the map.
			// @event mousedown: MouseEvent
			// Fired when the user pushes the mouse button on the map.
			// @event mouseup: MouseEvent
			// Fired when the user releases the mouse button on the map.
			// @event mouseover: MouseEvent
			// Fired when the mouse enters the map.
			// @event mouseout: MouseEvent
			// Fired when the mouse leaves the map.
			// @event mousemove: MouseEvent
			// Fired while the mouse moves over the map.
			// @event contextmenu: MouseEvent
			// Fired when the user pushes the right mouse button on the map, prevents
			// default browser context menu from showing if there are listeners on
			// this event. Also fired on mobile when the user holds a single touch
			// for a second (also called long press).
			// @event keypress: KeyboardEvent
			// Fired when the user presses a key from the keyboard while the map is focused.
			L.DomEvent[onOff](this._container, 'click dblclick mousedown mouseup ' +
				'mouseover mouseout mousemove contextmenu keypress', this._handleDOMEvent, this);
	
			if (this.options.trackResize) {
				L.DomEvent[onOff](window, 'resize', this._onResize, this);
			}
	
			if (L.Browser.any3d && this.options.transform3DLimit) {
				this[onOff]('moveend', this._onMoveEnd);
			}
		},
	
		_onResize: function () {
			L.Util.cancelAnimFrame(this._resizeRequest);
			this._resizeRequest = L.Util.requestAnimFrame(
			        function () { this.invalidateSize({debounceMoveend: true}); }, this);
		},
	
		_onScroll: function () {
			this._container.scrollTop  = 0;
			this._container.scrollLeft = 0;
		},
	
		_onMoveEnd: function () {
			var pos = this._getMapPanePos();
			if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
				// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
				// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
				this._resetView(this.getCenter(), this.getZoom());
			}
		},
	
		_findEventTargets: function (e, type) {
			var targets = [],
			    target,
			    isHover = type === 'mouseout' || type === 'mouseover',
			    src = e.target || e.srcElement,
			    dragging = false;
	
			while (src) {
				target = this._targets[L.stamp(src)];
				if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
					// Prevent firing click after you just dragged an object.
					dragging = true;
					break;
				}
				if (target && target.listens(type, true)) {
					if (isHover && !L.DomEvent._isExternalTarget(src, e)) { break; }
					targets.push(target);
					if (isHover) { break; }
				}
				if (src === this._container) { break; }
				src = src.parentNode;
			}
			if (!targets.length && !dragging && !isHover && L.DomEvent._isExternalTarget(src, e)) {
				targets = [this];
			}
			return targets;
		},
	
		_handleDOMEvent: function (e) {
			if (!this._loaded || L.DomEvent._skipped(e)) { return; }
	
			var type = e.type === 'keypress' && e.keyCode === 13 ? 'click' : e.type;
	
			if (type === 'mousedown') {
				// prevents outline when clicking on keyboard-focusable element
				L.DomUtil.preventOutline(e.target || e.srcElement);
			}
	
			this._fireDOMEvent(e, type);
		},
	
		_fireDOMEvent: function (e, type, targets) {
	
			if (e.type === 'click') {
				// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
				// @event preclick: MouseEvent
				// Fired before mouse click on the map (sometimes useful when you
				// want something to happen on click before any existing click
				// handlers start running).
				var synth = L.Util.extend({}, e);
				synth.type = 'preclick';
				this._fireDOMEvent(synth, synth.type, targets);
			}
	
			if (e._stopped) { return; }
	
			// Find the layer the event is propagating from and its parents.
			targets = (targets || []).concat(this._findEventTargets(e, type));
	
			if (!targets.length) { return; }
	
			var target = targets[0];
			if (type === 'contextmenu' && target.listens(type, true)) {
				L.DomEvent.preventDefault(e);
			}
	
			var data = {
				originalEvent: e
			};
	
			if (e.type !== 'keypress') {
				var isMarker = target instanceof L.Marker;
				data.containerPoint = isMarker ?
						this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
				data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
				data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
			}
	
			for (var i = 0; i < targets.length; i++) {
				targets[i].fire(type, data, true);
				if (data.originalEvent._stopped ||
					(targets[i].options.nonBubblingEvents && L.Util.indexOf(targets[i].options.nonBubblingEvents, type) !== -1)) { return; }
			}
		},
	
		_draggableMoved: function (obj) {
			obj = obj.dragging && obj.dragging.enabled() ? obj : this;
			return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
		},
	
		_clearHandlers: function () {
			for (var i = 0, len = this._handlers.length; i < len; i++) {
				this._handlers[i].disable();
			}
		},
	
		// @section Other Methods
	
		// @method whenReady(fn: Function, context?: Object): this
		// Runs the given function `fn` when the map gets initialized with
		// a view (center and zoom) and at least one layer, or immediately
		// if it's already initialized, optionally passing a function context.
		whenReady: function (callback, context) {
			if (this._loaded) {
				callback.call(context || this, {target: this});
			} else {
				this.on('load', callback, context);
			}
			return this;
		},
	
	
		// private methods for getting map state
	
		_getMapPanePos: function () {
			return L.DomUtil.getPosition(this._mapPane) || new L.Point(0, 0);
		},
	
		_moved: function () {
			var pos = this._getMapPanePos();
			return pos && !pos.equals([0, 0]);
		},
	
		_getTopLeftPoint: function (center, zoom) {
			var pixelOrigin = center && zoom !== undefined ?
				this._getNewPixelOrigin(center, zoom) :
				this.getPixelOrigin();
			return pixelOrigin.subtract(this._getMapPanePos());
		},
	
		_getNewPixelOrigin: function (center, zoom) {
			var viewHalf = this.getSize()._divideBy(2);
			return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
		},
	
		_latLngToNewLayerPoint: function (latlng, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return this.project(latlng, zoom)._subtract(topLeft);
		},
	
		_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return L.bounds([
				this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
			]);
		},
	
		// layer point of the current center
		_getCenterLayerPoint: function () {
			return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
		},
	
		// offset of the specified place to the current center in pixels
		_getCenterOffset: function (latlng) {
			return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
		},
	
		// adjust center for view to get inside bounds
		_limitCenter: function (center, zoom, bounds) {
	
			if (!bounds) { return center; }
	
			var centerPoint = this.project(center, zoom),
			    viewHalf = this.getSize().divideBy(2),
			    viewBounds = new L.Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
			    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
			// If offset is less than a pixel, ignore.
			// This prevents unstable projections from getting into
			// an infinite loop of tiny offsets.
			if (offset.round().equals([0, 0])) {
				return center;
			}
	
			return this.unproject(centerPoint.add(offset), zoom);
		},
	
		// adjust offset for view to get inside bounds
		_limitOffset: function (offset, bounds) {
			if (!bounds) { return offset; }
	
			var viewBounds = this.getPixelBounds(),
			    newBounds = new L.Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
			return offset.add(this._getBoundsOffset(newBounds, bounds));
		},
	
		// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
		_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
			var projectedMaxBounds = L.bounds(
			        this.project(maxBounds.getNorthEast(), zoom),
			        this.project(maxBounds.getSouthWest(), zoom)
			    ),
			    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
			    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),
	
			    dx = this._rebound(minOffset.x, -maxOffset.x),
			    dy = this._rebound(minOffset.y, -maxOffset.y);
	
			return new L.Point(dx, dy);
		},
	
		_rebound: function (left, right) {
			return left + right > 0 ?
				Math.round(left - right) / 2 :
				Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
		},
	
		_limitZoom: function (zoom) {
			var min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    snap = L.Browser.any3d ? this.options.zoomSnap : 1;
			if (snap) {
				zoom = Math.round(zoom / snap) * snap;
			}
			return Math.max(min, Math.min(max, zoom));
		},
	
		_onPanTransitionStep: function () {
			this.fire('move');
		},
	
		_onPanTransitionEnd: function () {
			L.DomUtil.removeClass(this._mapPane, 'leaflet-pan-anim');
			this.fire('moveend');
		},
	
		_tryAnimatedPan: function (center, options) {
			// difference between the new and current centers in pixels
			var offset = this._getCenterOffset(center)._floor();
	
			// don't animate too far unless animate: true specified in options
			if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
			this.panBy(offset, options);
	
			return true;
		},
	
		_createAnimProxy: function () {
	
			var proxy = this._proxy = L.DomUtil.create('div', 'leaflet-proxy leaflet-zoom-animated');
			this._panes.mapPane.appendChild(proxy);
	
			this.on('zoomanim', function (e) {
				var prop = L.DomUtil.TRANSFORM,
				    transform = proxy.style[prop];
	
				L.DomUtil.setTransform(proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
	
				// workaround for case when transform is the same and so transitionend event is not fired
				if (transform === proxy.style[prop] && this._animatingZoom) {
					this._onZoomTransitionEnd();
				}
			}, this);
	
			this.on('load moveend', function () {
				var c = this.getCenter(),
				    z = this.getZoom();
				L.DomUtil.setTransform(proxy, this.project(c, z), this.getZoomScale(z, 1));
			}, this);
		},
	
		_catchTransitionEnd: function (e) {
			if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
				this._onZoomTransitionEnd();
			}
		},
	
		_nothingToAnimate: function () {
			return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
		},
	
		_tryAnimatedZoom: function (center, zoom, options) {
	
			if (this._animatingZoom) { return true; }
	
			options = options || {};
	
			// don't animate if disabled, not supported or zoom difference is too large
			if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
			        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
			// offset is the pixel coords of the zoom origin relative to the current center
			var scale = this.getZoomScale(zoom),
			    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
	
			// don't animate if the zoom origin isn't within one screen from the current center, unless forced
			if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
			L.Util.requestAnimFrame(function () {
				this
				    ._moveStart(true)
				    ._animateZoom(center, zoom, true);
			}, this);
	
			return true;
		},
	
		_animateZoom: function (center, zoom, startAnim, noUpdate) {
			if (startAnim) {
				this._animatingZoom = true;
	
				// remember what center/zoom to set after animation
				this._animateToCenter = center;
				this._animateToZoom = zoom;
	
				L.DomUtil.addClass(this._mapPane, 'leaflet-zoom-anim');
			}
	
			// @event zoomanim: ZoomAnimEvent
			// Fired on every frame of a zoom animation
			this.fire('zoomanim', {
				center: center,
				zoom: zoom,
				noUpdate: noUpdate
			});
	
			// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
			setTimeout(L.bind(this._onZoomTransitionEnd, this), 250);
		},
	
		_onZoomTransitionEnd: function () {
			if (!this._animatingZoom) { return; }
	
			L.DomUtil.removeClass(this._mapPane, 'leaflet-zoom-anim');
	
			this._animatingZoom = false;
	
			this._move(this._animateToCenter, this._animateToZoom);
	
			// This anim frame should prevent an obscure iOS webkit tile loading race condition.
			L.Util.requestAnimFrame(function () {
				this._moveEnd(true);
			}, this);
		}
	});
	
	// @section
	
	// @factory L.map(id: String, options?: Map options)
	// Instantiates a map object given the DOM ID of a `<div>` element
	// and optionally an object literal with `Map options`.
	//
	// @alternative
	// @factory L.map(el: HTMLElement, options?: Map options)
	// Instantiates a map object given an instance of a `<div>` HTML element
	// and optionally an object literal with `Map options`.
	L.map = function (id, options) {
		return new L.Map(id, options);
	};
	
	
	
	
	/*
	 * @class Layer
	 * @inherits Evented
	 * @aka L.Layer
	 * @aka ILayer
	 *
	 * A set of methods from the Layer base class that all Leaflet layers use.
	 * Inherits all methods, options and events from `L.Evented`.
	 *
	 * @example
	 *
	 * ```js
	 * var layer = L.Marker(latlng).addTo(map);
	 * layer.addTo(map);
	 * layer.remove();
	 * ```
	 *
	 * @event add: Event
	 * Fired after the layer is added to a map
	 *
	 * @event remove: Event
	 * Fired after the layer is removed from a map
	 */
	
	
	L.Layer = L.Evented.extend({
	
		// Classes extending `L.Layer` will inherit the following options:
		options: {
			// @option pane: String = 'overlayPane'
			// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
			pane: 'overlayPane',
			nonBubblingEvents: [],  // Array of events that should not be bubbled to DOM parents (like the map),
	
			// @option attribution: String = null
			// String to be shown in the attribution control, describes the layer data, e.g. "© Mapbox".
			attribution: null
		},
	
		/* @section
		 * Classes extending `L.Layer` will inherit the following methods:
		 *
		 * @method addTo(map: Map): this
		 * Adds the layer to the given map
		 */
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		// @method remove: this
		// Removes the layer from the map it is currently active on.
		remove: function () {
			return this.removeFrom(this._map || this._mapToAdd);
		},
	
		// @method removeFrom(map: Map): this
		// Removes the layer from the given map
		removeFrom: function (obj) {
			if (obj) {
				obj.removeLayer(this);
			}
			return this;
		},
	
		// @method getPane(name? : String): HTMLElement
		// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
		getPane: function (name) {
			return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
		},
	
		addInteractiveTarget: function (targetEl) {
			this._map._targets[L.stamp(targetEl)] = this;
			return this;
		},
	
		removeInteractiveTarget: function (targetEl) {
			delete this._map._targets[L.stamp(targetEl)];
			return this;
		},
	
		// @method getAttribution: String
		// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
		getAttribution: function () {
			return this.options.attribution;
		},
	
		_layerAdd: function (e) {
			var map = e.target;
	
			// check in case layer gets added and then removed before the map is ready
			if (!map.hasLayer(this)) { return; }
	
			this._map = map;
			this._zoomAnimated = map._zoomAnimated;
	
			if (this.getEvents) {
				var events = this.getEvents();
				map.on(events, this);
				this.once('remove', function () {
					map.off(events, this);
				}, this);
			}
	
			this.onAdd(map);
	
			if (this.getAttribution && map.attributionControl) {
				map.attributionControl.addAttribution(this.getAttribution());
			}
	
			this.fire('add');
			map.fire('layeradd', {layer: this});
		}
	});
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): this
	 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
	 *
	 * @method onRemove(map: Map): this
	 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
	 *
	 * @method getEvents(): Object
	 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
	 *
	 * @method getAttribution(): String
	 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
	 *
	 * @method beforeAdd(map: Map): this
	 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
	 */
	
	
	/* @namespace Map
	 * @section Layer events
	 *
	 * @event layeradd: LayerEvent
	 * Fired when a new layer is added to the map.
	 *
	 * @event layerremove: LayerEvent
	 * Fired when some layer is removed from the map
	 *
	 * @section Methods for Layers and Controls
	 */
	L.Map.include({
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the map
		addLayer: function (layer) {
			var id = L.stamp(layer);
			if (this._layers[id]) { return this; }
			this._layers[id] = layer;
	
			layer._mapToAdd = this;
	
			if (layer.beforeAdd) {
				layer.beforeAdd(this);
			}
	
			this.whenReady(layer._layerAdd, layer);
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the map.
		removeLayer: function (layer) {
			var id = L.stamp(layer);
	
			if (!this._layers[id]) { return this; }
	
			if (this._loaded) {
				layer.onRemove(this);
			}
	
			if (layer.getAttribution && this.attributionControl) {
				this.attributionControl.removeAttribution(layer.getAttribution());
			}
	
			delete this._layers[id];
	
			if (this._loaded) {
				this.fire('layerremove', {layer: layer});
				layer.fire('remove');
			}
	
			layer._map = layer._mapToAdd = null;
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the map
		hasLayer: function (layer) {
			return !!layer && (L.stamp(layer) in this._layers);
		},
	
		/* @method eachLayer(fn: Function, context?: Object): this
		 * Iterates over the layers of the map, optionally specifying context of the iterator function.
		 * ```
		 * map.eachLayer(function(layer){
		 *     layer.bindPopup('Hello');
		 * });
		 * ```
		 */
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		_addLayers: function (layers) {
			layers = layers ? (L.Util.isArray(layers) ? layers : [layers]) : [];
	
			for (var i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		},
	
		_addZoomLimit: function (layer) {
			if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
				this._zoomBoundLayers[L.stamp(layer)] = layer;
				this._updateZoomLevels();
			}
		},
	
		_removeZoomLimit: function (layer) {
			var id = L.stamp(layer);
	
			if (this._zoomBoundLayers[id]) {
				delete this._zoomBoundLayers[id];
				this._updateZoomLevels();
			}
		},
	
		_updateZoomLevels: function () {
			var minZoom = Infinity,
			    maxZoom = -Infinity,
			    oldZoomSpan = this._getZoomSpan();
	
			for (var i in this._zoomBoundLayers) {
				var options = this._zoomBoundLayers[i].options;
	
				minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
				maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
			}
	
			this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
			this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
	
			// @section Map state change events
			// @event zoomlevelschange: Event
			// Fired when the number of zoomlevels on the map is changed due
			// to adding or removing a layer.
			if (oldZoomSpan !== this._getZoomSpan()) {
				this.fire('zoomlevelschange');
			}
	
			if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
				this.setZoom(this._layersMaxZoom);
			}
			if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
				this.setZoom(this._layersMinZoom);
			}
		}
	});
	
	
	
	/*
	 * @namespace DomEvent
	 * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
	 */
	
	// Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
	
	
	
	var eventsKey = '_leaflet_events';
	
	L.DomEvent = {
	
		// @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
		// Adds a listener function (`fn`) to a particular DOM event type of the
		// element `el`. You can optionally specify the context of the listener
		// (object the `this` keyword will point to). You can also pass several
		// space-separated types (e.g. `'click dblclick'`).
	
		// @alternative
		// @function on(el: HTMLElement, eventMap: Object, context?: Object): this
		// Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		on: function (obj, types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this._on(obj, type, types[type], fn);
				}
			} else {
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._on(obj, types[i], fn, context);
				}
			}
	
			return this;
		},
	
		// @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
		// Removes a previously added listener function. If no function is specified,
		// it will remove all the listeners of that particular DOM event from the element.
		// Note that if you passed a custom context to on, you must pass the same
		// context to `off` in order to remove the listener.
	
		// @alternative
		// @function off(el: HTMLElement, eventMap: Object, context?: Object): this
		// Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		off: function (obj, types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this._off(obj, type, types[type], fn);
				}
			} else {
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._off(obj, types[i], fn, context);
				}
			}
	
			return this;
		},
	
		_on: function (obj, type, fn, context) {
			var id = type + L.stamp(fn) + (context ? '_' + L.stamp(context) : '');
	
			if (obj[eventsKey] && obj[eventsKey][id]) { return this; }
	
			var handler = function (e) {
				return fn.call(context || obj, e || window.event);
			};
	
			var originalHandler = handler;
	
			if (L.Browser.pointer && type.indexOf('touch') === 0) {
				this.addPointerListener(obj, type, handler, id);
	
			} else if (L.Browser.touch && (type === 'dblclick') && this.addDoubleTapListener &&
			           !(L.Browser.pointer && L.Browser.chrome)) {
				// Chrome >55 does not need the synthetic dblclicks from addDoubleTapListener
				// See #5180
				this.addDoubleTapListener(obj, handler, id);
	
			} else if ('addEventListener' in obj) {
	
				if (type === 'mousewheel') {
					obj.addEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
				} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
					handler = function (e) {
						e = e || window.event;
						if (L.DomEvent._isExternalTarget(obj, e)) {
							originalHandler(e);
						}
					};
					obj.addEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);
	
				} else {
					if (type === 'click' && L.Browser.android) {
						handler = function (e) {
							return L.DomEvent._filterClick(e, originalHandler);
						};
					}
					obj.addEventListener(type, handler, false);
				}
	
			} else if ('attachEvent' in obj) {
				obj.attachEvent('on' + type, handler);
			}
	
			obj[eventsKey] = obj[eventsKey] || {};
			obj[eventsKey][id] = handler;
	
			return this;
		},
	
		_off: function (obj, type, fn, context) {
	
			var id = type + L.stamp(fn) + (context ? '_' + L.stamp(context) : ''),
			    handler = obj[eventsKey] && obj[eventsKey][id];
	
			if (!handler) { return this; }
	
			if (L.Browser.pointer && type.indexOf('touch') === 0) {
				this.removePointerListener(obj, type, id);
	
			} else if (L.Browser.touch && (type === 'dblclick') && this.removeDoubleTapListener) {
				this.removeDoubleTapListener(obj, id);
	
			} else if ('removeEventListener' in obj) {
	
				if (type === 'mousewheel') {
					obj.removeEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
				} else {
					obj.removeEventListener(
						type === 'mouseenter' ? 'mouseover' :
						type === 'mouseleave' ? 'mouseout' : type, handler, false);
				}
	
			} else if ('detachEvent' in obj) {
				obj.detachEvent('on' + type, handler);
			}
	
			obj[eventsKey][id] = null;
	
			return this;
		},
	
		// @function stopPropagation(ev: DOMEvent): this
		// Stop the given event from propagation to parent elements. Used inside the listener functions:
		// ```js
		// L.DomEvent.on(div, 'click', function (ev) {
		// 	L.DomEvent.stopPropagation(ev);
		// });
		// ```
		stopPropagation: function (e) {
	
			if (e.stopPropagation) {
				e.stopPropagation();
			} else if (e.originalEvent) {  // In case of Leaflet event.
				e.originalEvent._stopped = true;
			} else {
				e.cancelBubble = true;
			}
			L.DomEvent._skipped(e);
	
			return this;
		},
	
		// @function disableScrollPropagation(el: HTMLElement): this
		// Adds `stopPropagation` to the element's `'mousewheel'` events (plus browser variants).
		disableScrollPropagation: function (el) {
			return L.DomEvent.on(el, 'mousewheel', L.DomEvent.stopPropagation);
		},
	
		// @function disableClickPropagation(el: HTMLElement): this
		// Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
		// `'mousedown'` and `'touchstart'` events (plus browser variants).
		disableClickPropagation: function (el) {
			var stop = L.DomEvent.stopPropagation;
	
			L.DomEvent.on(el, L.Draggable.START.join(' '), stop);
	
			return L.DomEvent.on(el, {
				click: L.DomEvent._fakeStop,
				dblclick: stop
			});
		},
	
		// @function preventDefault(ev: DOMEvent): this
		// Prevents the default action of the DOM Event `ev` from happening (such as
		// following a link in the href of the a element, or doing a POST request
		// with page reload when a `<form>` is submitted).
		// Use it inside listener functions.
		preventDefault: function (e) {
	
			if (e.preventDefault) {
				e.preventDefault();
			} else {
				e.returnValue = false;
			}
			return this;
		},
	
		// @function stop(ev): this
		// Does `stopPropagation` and `preventDefault` at the same time.
		stop: function (e) {
			return L.DomEvent
				.preventDefault(e)
				.stopPropagation(e);
		},
	
		// @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
		// Gets normalized mouse position from a DOM event relative to the
		// `container` or to the whole page if not specified.
		getMousePosition: function (e, container) {
			if (!container) {
				return new L.Point(e.clientX, e.clientY);
			}
	
			var rect = container.getBoundingClientRect();
	
			return new L.Point(
				e.clientX - rect.left - container.clientLeft,
				e.clientY - rect.top - container.clientTop);
		},
	
		// Chrome on Win scrolls double the pixels as in other platforms (see #4538),
		// and Firefox scrolls device pixels, not CSS pixels
		_wheelPxFactor: (L.Browser.win && L.Browser.chrome) ? 2 :
		                L.Browser.gecko ? window.devicePixelRatio :
		                1,
	
		// @function getWheelDelta(ev: DOMEvent): Number
		// Gets normalized wheel delta from a mousewheel DOM event, in vertical
		// pixels scrolled (negative if scrolling down).
		// Events from pointing devices without precise scrolling are mapped to
		// a best guess of 60 pixels.
		getWheelDelta: function (e) {
			return (L.Browser.edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
			       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / L.DomEvent._wheelPxFactor : // Pixels
			       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
			       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
			       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
			       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
			       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
			       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
			       0;
		},
	
		_skipEvents: {},
	
		_fakeStop: function (e) {
			// fakes stopPropagation by setting a special event flag, checked/reset with L.DomEvent._skipped(e)
			L.DomEvent._skipEvents[e.type] = true;
		},
	
		_skipped: function (e) {
			var skipped = this._skipEvents[e.type];
			// reset when checking, as it's only used in map container and propagates outside of the map
			this._skipEvents[e.type] = false;
			return skipped;
		},
	
		// check if element really left/entered the event target (for mouseenter/mouseleave)
		_isExternalTarget: function (el, e) {
	
			var related = e.relatedTarget;
	
			if (!related) { return true; }
	
			try {
				while (related && (related !== el)) {
					related = related.parentNode;
				}
			} catch (err) {
				return false;
			}
			return (related !== el);
		},
	
		// this is a horrible workaround for a bug in Android where a single touch triggers two click events
		_filterClick: function (e, handler) {
			var timeStamp = (e.timeStamp || (e.originalEvent && e.originalEvent.timeStamp)),
			    elapsed = L.DomEvent._lastClick && (timeStamp - L.DomEvent._lastClick);
	
			// are they closer together than 500ms yet more than 100ms?
			// Android typically triggers them ~300ms apart while multiple listeners
			// on the same event should be triggered far faster;
			// or check if click is simulated on the element, and if it is, reject any non-simulated events
	
			if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
				L.DomEvent.stop(e);
				return;
			}
			L.DomEvent._lastClick = timeStamp;
	
			handler(e);
		}
	};
	
	// @function addListener(…): this
	// Alias to [`L.DomEvent.on`](#domevent-on)
	L.DomEvent.addListener = L.DomEvent.on;
	
	// @function removeListener(…): this
	// Alias to [`L.DomEvent.off`](#domevent-off)
	L.DomEvent.removeListener = L.DomEvent.off;
	
	
	
	/*
	 * @class PosAnimation
	 * @aka L.PosAnimation
	 * @inherits Evented
	 * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
	 *
	 * @example
	 * ```js
	 * var fx = new L.PosAnimation();
	 * fx.run(el, [300, 500], 0.5);
	 * ```
	 *
	 * @constructor L.PosAnimation()
	 * Creates a `PosAnimation` object.
	 *
	 */
	
	L.PosAnimation = L.Evented.extend({
	
		// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
		// Run an animation of a given element to a new position, optionally setting
		// duration in seconds (`0.25` by default) and easing linearity factor (3rd
		// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
		// `0.5` by default).
		run: function (el, newPos, duration, easeLinearity) {
			this.stop();
	
			this._el = el;
			this._inProgress = true;
			this._duration = duration || 0.25;
			this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
			this._startPos = L.DomUtil.getPosition(el);
			this._offset = newPos.subtract(this._startPos);
			this._startTime = +new Date();
	
			// @event start: Event
			// Fired when the animation starts
			this.fire('start');
	
			this._animate();
		},
	
		// @method stop()
		// Stops the animation (if currently running).
		stop: function () {
			if (!this._inProgress) { return; }
	
			this._step(true);
			this._complete();
		},
	
		_animate: function () {
			// animation loop
			this._animId = L.Util.requestAnimFrame(this._animate, this);
			this._step();
		},
	
		_step: function (round) {
			var elapsed = (+new Date()) - this._startTime,
			    duration = this._duration * 1000;
	
			if (elapsed < duration) {
				this._runFrame(this._easeOut(elapsed / duration), round);
			} else {
				this._runFrame(1);
				this._complete();
			}
		},
	
		_runFrame: function (progress, round) {
			var pos = this._startPos.add(this._offset.multiplyBy(progress));
			if (round) {
				pos._round();
			}
			L.DomUtil.setPosition(this._el, pos);
	
			// @event step: Event
			// Fired continuously during the animation.
			this.fire('step');
		},
	
		_complete: function () {
			L.Util.cancelAnimFrame(this._animId);
	
			this._inProgress = false;
			// @event end: Event
			// Fired when the animation ends.
			this.fire('end');
		},
	
		_easeOut: function (t) {
			return 1 - Math.pow(1 - t, this._easeOutPower);
		}
	});
	
	
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.Mercator
	 *
	 * Elliptical Mercator projection — more complex than Spherical Mercator. Takes into account that Earth is a geoid, not a perfect sphere. Used by the EPSG:3395 CRS.
	 */
	
	L.Projection.Mercator = {
		R: 6378137,
		R_MINOR: 6356752.314245179,
	
		bounds: L.bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    r = this.R,
			    y = latlng.lat * d,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    con = e * Math.sin(y);
	
			var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
			y = -r * Math.log(Math.max(ts, 1E-10));
	
			return new L.Point(latlng.lng * d * r, y);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI,
			    r = this.R,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    ts = Math.exp(-point.y / r),
			    phi = Math.PI / 2 - 2 * Math.atan(ts);
	
			for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
				con = e * Math.sin(phi);
				con = Math.pow((1 - con) / (1 + con), e / 2);
				dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
				phi += dphi;
			}
	
			return new L.LatLng(phi * d, point.x * d / r);
		}
	};
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3395
	 *
	 * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
	 */
	
	L.CRS.EPSG3395 = L.extend({}, L.CRS.Earth, {
		code: 'EPSG:3395',
		projection: L.Projection.Mercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * L.Projection.Mercator.R);
			return new L.Transformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	
	
	/*
	 * @class GridLayer
	 * @inherits Layer
	 * @aka L.GridLayer
	 *
	 * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
	 * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
	 *
	 *
	 * @section Synchronous usage
	 * @example
	 *
	 * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords){
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
	 *         var ctx = tile.getContext('2d');
	 *
	 *         // return the tile so it can be rendered on screen
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section Asynchronous usage
	 * @example
	 *
	 * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords, done){
	 *         var error;
	 *
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // draw something asynchronously and pass the tile to the done() callback
	 *         setTimeout(function() {
	 *             done(error, tile);
	 *         }, 1000);
	 *
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section
	 */
	
	
	L.GridLayer = L.Layer.extend({
	
		// @section
		// @aka GridLayer options
		options: {
			// @option tileSize: Number|Point = 256
			// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
			tileSize: 256,
	
			// @option opacity: Number = 1.0
			// Opacity of the tiles. Can be used in the `createTile()` function.
			opacity: 1,
	
			// @option updateWhenIdle: Boolean = depends
			// If `false`, new tiles are loaded during panning, otherwise only after it (for better performance). `true` by default on mobile browsers, otherwise `false`.
			updateWhenIdle: L.Browser.mobile,
	
			// @option updateWhenZooming: Boolean = true
			// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
			updateWhenZooming: true,
	
			// @option updateInterval: Number = 200
			// Tiles will not update more than once every `updateInterval` milliseconds when panning.
			updateInterval: 200,
	
			// @option zIndex: Number = 1
			// The explicit zIndex of the tile layer.
			zIndex: 1,
	
			// @option bounds: LatLngBounds = undefined
			// If set, tiles will only be loaded inside the set `LatLngBounds`.
			bounds: null,
	
			// @option minZoom: Number = 0
			// The minimum zoom level that tiles will be loaded at. By default the entire map.
			minZoom: 0,
	
			// @option maxZoom: Number = undefined
			// The maximum zoom level that tiles will be loaded at.
			maxZoom: undefined,
	
			// @option noWrap: Boolean = false
			// Whether the layer is wrapped around the antimeridian. If `true`, the
			// GridLayer will only be displayed once at low zoom levels. Has no
			// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
			// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
			// tiles outside the CRS limits.
			noWrap: false,
	
			// @option pane: String = 'tilePane'
			// `Map pane` where the grid layer will be added.
			pane: 'tilePane',
	
			// @option className: String = ''
			// A custom class name to assign to the tile layer. Empty by default.
			className: '',
	
			// @option keepBuffer: Number = 2
			// When panning the map, keep this many rows and columns of tiles before unloading them.
			keepBuffer: 2
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		onAdd: function () {
			this._initContainer();
	
			this._levels = {};
			this._tiles = {};
	
			this._resetView();
			this._update();
		},
	
		beforeAdd: function (map) {
			map._addZoomLimit(this);
		},
	
		onRemove: function (map) {
			this._removeAllTiles();
			L.DomUtil.remove(this._container);
			map._removeZoomLimit(this);
			this._container = null;
			this._tileZoom = null;
		},
	
		// @method bringToFront: this
		// Brings the tile layer to the top of all tile layers.
		bringToFront: function () {
			if (this._map) {
				L.DomUtil.toFront(this._container);
				this._setAutoZIndex(Math.max);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings the tile layer to the bottom of all tile layers.
		bringToBack: function () {
			if (this._map) {
				L.DomUtil.toBack(this._container);
				this._setAutoZIndex(Math.min);
			}
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the tiles for this layer.
		getContainer: function () {
			return this._container;
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the [opacity](#gridlayer-opacity) of the grid layer.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			this._updateOpacity();
			return this;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
		setZIndex: function (zIndex) {
			this.options.zIndex = zIndex;
			this._updateZIndex();
	
			return this;
		},
	
		// @method isLoading: Boolean
		// Returns `true` if any tile in the grid layer has not finished loading.
		isLoading: function () {
			return this._loading;
		},
	
		// @method redraw: this
		// Causes the layer to clear all the tiles and request them again.
		redraw: function () {
			if (this._map) {
				this._removeAllTiles();
				this._update();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				viewprereset: this._invalidateAll,
				viewreset: this._resetView,
				zoom: this._resetView,
				moveend: this._onMoveEnd
			};
	
			if (!this.options.updateWhenIdle) {
				// update tiles on move, but not more often than once per given interval
				if (!this._onMove) {
					this._onMove = L.Util.throttle(this._onMoveEnd, this.options.updateInterval, this);
				}
	
				events.move = this._onMove;
			}
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @section Extension methods
		// Layers extending `GridLayer` shall reimplement the following method.
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, must be overriden by classes extending `GridLayer`.
		// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
		// is specified, it must be called when the tile has finished loading and drawing.
		createTile: function () {
			return document.createElement('div');
		},
	
		// @section
		// @method getTileSize: Point
		// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
		getTileSize: function () {
			var s = this.options.tileSize;
			return s instanceof L.Point ? s : new L.Point(s, s);
		},
	
		_updateZIndex: function () {
			if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
				this._container.style.zIndex = this.options.zIndex;
			}
		},
	
		_setAutoZIndex: function (compare) {
			// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
	
			var layers = this.getPane().children,
			    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
	
			for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	
				zIndex = layers[i].style.zIndex;
	
				if (layers[i] !== this._container && zIndex) {
					edgeZIndex = compare(edgeZIndex, +zIndex);
				}
			}
	
			if (isFinite(edgeZIndex)) {
				this.options.zIndex = edgeZIndex + compare(-1, 1);
				this._updateZIndex();
			}
		},
	
		_updateOpacity: function () {
			if (!this._map) { return; }
	
			// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
			if (L.Browser.ielt9) { return; }
	
			L.DomUtil.setOpacity(this._container, this.options.opacity);
	
			var now = +new Date(),
			    nextFrame = false,
			    willPrune = false;
	
			for (var key in this._tiles) {
				var tile = this._tiles[key];
				if (!tile.current || !tile.loaded) { continue; }
	
				var fade = Math.min(1, (now - tile.loaded) / 200);
	
				L.DomUtil.setOpacity(tile.el, fade);
				if (fade < 1) {
					nextFrame = true;
				} else {
					if (tile.active) { willPrune = true; }
					tile.active = true;
				}
			}
	
			if (willPrune && !this._noPrune) { this._pruneTiles(); }
	
			if (nextFrame) {
				L.Util.cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = L.Util.requestAnimFrame(this._updateOpacity, this);
			}
		},
	
		_initContainer: function () {
			if (this._container) { return; }
	
			this._container = L.DomUtil.create('div', 'leaflet-layer ' + (this.options.className || ''));
			this._updateZIndex();
	
			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
	
			this.getPane().appendChild(this._container);
		},
	
		_updateLevels: function () {
	
			var zoom = this._tileZoom,
			    maxZoom = this.options.maxZoom;
	
			if (zoom === undefined) { return undefined; }
	
			for (var z in this._levels) {
				if (this._levels[z].el.children.length || z === zoom) {
					this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
				} else {
					L.DomUtil.remove(this._levels[z].el);
					this._removeTilesAtZoom(z);
					delete this._levels[z];
				}
			}
	
			var level = this._levels[zoom],
			    map = this._map;
	
			if (!level) {
				level = this._levels[zoom] = {};
	
				level.el = L.DomUtil.create('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
				level.el.style.zIndex = maxZoom;
	
				level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
				level.zoom = zoom;
	
				this._setZoomTransform(level, map.getCenter(), map.getZoom());
	
				// force the browser to consider the newly added element for transition
				L.Util.falseFn(level.el.offsetWidth);
			}
	
			this._level = level;
	
			return level;
		},
	
		_pruneTiles: function () {
			if (!this._map) {
				return;
			}
	
			var key, tile;
	
			var zoom = this._map.getZoom();
			if (zoom > this.options.maxZoom ||
				zoom < this.options.minZoom) {
				this._removeAllTiles();
				return;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				tile.retain = tile.current;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				if (tile.current && !tile.active) {
					var coords = tile.coords;
					if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
						this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
					}
				}
			}
	
			for (key in this._tiles) {
				if (!this._tiles[key].retain) {
					this._removeTile(key);
				}
			}
		},
	
		_removeTilesAtZoom: function (zoom) {
			for (var key in this._tiles) {
				if (this._tiles[key].coords.z !== zoom) {
					continue;
				}
				this._removeTile(key);
			}
		},
	
		_removeAllTiles: function () {
			for (var key in this._tiles) {
				this._removeTile(key);
			}
		},
	
		_invalidateAll: function () {
			for (var z in this._levels) {
				L.DomUtil.remove(this._levels[z].el);
				delete this._levels[z];
			}
			this._removeAllTiles();
	
			this._tileZoom = null;
		},
	
		_retainParent: function (x, y, z, minZoom) {
			var x2 = Math.floor(x / 2),
			    y2 = Math.floor(y / 2),
			    z2 = z - 1,
			    coords2 = new L.Point(+x2, +y2);
			coords2.z = +z2;
	
			var key = this._tileCoordsToKey(coords2),
			    tile = this._tiles[key];
	
			if (tile && tile.active) {
				tile.retain = true;
				return true;
	
			} else if (tile && tile.loaded) {
				tile.retain = true;
			}
	
			if (z2 > minZoom) {
				return this._retainParent(x2, y2, z2, minZoom);
			}
	
			return false;
		},
	
		_retainChildren: function (x, y, z, maxZoom) {
	
			for (var i = 2 * x; i < 2 * x + 2; i++) {
				for (var j = 2 * y; j < 2 * y + 2; j++) {
	
					var coords = new L.Point(i, j);
					coords.z = z + 1;
	
					var key = this._tileCoordsToKey(coords),
					    tile = this._tiles[key];
	
					if (tile && tile.active) {
						tile.retain = true;
						continue;
	
					} else if (tile && tile.loaded) {
						tile.retain = true;
					}
	
					if (z + 1 < maxZoom) {
						this._retainChildren(i, j, z + 1, maxZoom);
					}
				}
			}
		},
	
		_resetView: function (e) {
			var animating = e && (e.pinch || e.flyTo);
			this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
		},
	
		_animateZoom: function (e) {
			this._setView(e.center, e.zoom, true, e.noUpdate);
		},
	
		_setView: function (center, zoom, noPrune, noUpdate) {
			var tileZoom = Math.round(zoom);
			if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
			    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
				tileZoom = undefined;
			}
	
			var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);
	
			if (!noUpdate || tileZoomChanged) {
	
				this._tileZoom = tileZoom;
	
				if (this._abortLoading) {
					this._abortLoading();
				}
	
				this._updateLevels();
				this._resetGrid();
	
				if (tileZoom !== undefined) {
					this._update(center);
				}
	
				if (!noPrune) {
					this._pruneTiles();
				}
	
				// Flag to prevent _updateOpacity from pruning tiles during
				// a zoom anim or a pinch gesture
				this._noPrune = !!noPrune;
			}
	
			this._setZoomTransforms(center, zoom);
		},
	
		_setZoomTransforms: function (center, zoom) {
			for (var i in this._levels) {
				this._setZoomTransform(this._levels[i], center, zoom);
			}
		},
	
		_setZoomTransform: function (level, center, zoom) {
			var scale = this._map.getZoomScale(zoom, level.zoom),
			    translate = level.origin.multiplyBy(scale)
			        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();
	
			if (L.Browser.any3d) {
				L.DomUtil.setTransform(level.el, translate, scale);
			} else {
				L.DomUtil.setPosition(level.el, translate);
			}
		},
	
		_resetGrid: function () {
			var map = this._map,
			    crs = map.options.crs,
			    tileSize = this._tileSize = this.getTileSize(),
			    tileZoom = this._tileZoom;
	
			var bounds = this._map.getPixelWorldBounds(this._tileZoom);
			if (bounds) {
				this._globalTileRange = this._pxBoundsToTileRange(bounds);
			}
	
			this._wrapX = crs.wrapLng && !this.options.noWrap && [
				Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
				Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
			];
			this._wrapY = crs.wrapLat && !this.options.noWrap && [
				Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
				Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
			];
		},
	
		_onMoveEnd: function () {
			if (!this._map || this._map._animatingZoom) { return; }
	
			this._update();
		},
	
		_getTiledPixelBounds: function (center) {
			var map = this._map,
			    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
			    scale = map.getZoomScale(mapZoom, this._tileZoom),
			    pixelCenter = map.project(center, this._tileZoom).floor(),
			    halfSize = map.getSize().divideBy(scale * 2);
	
			return new L.Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
		},
	
		// Private method to load tiles in the grid's active zoom level according to map bounds
		_update: function (center) {
			var map = this._map;
			if (!map) { return; }
			var zoom = map.getZoom();
	
			if (center === undefined) { center = map.getCenter(); }
			if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom
	
			var pixelBounds = this._getTiledPixelBounds(center),
			    tileRange = this._pxBoundsToTileRange(pixelBounds),
			    tileCenter = tileRange.getCenter(),
			    queue = [],
			    margin = this.options.keepBuffer,
			    noPruneRange = new L.Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
			                              tileRange.getTopRight().add([margin, -margin]));
	
			for (var key in this._tiles) {
				var c = this._tiles[key].coords;
				if (c.z !== this._tileZoom || !noPruneRange.contains(L.point(c.x, c.y))) {
					this._tiles[key].current = false;
				}
			}
	
			// _update just loads more tiles. If the tile zoom level differs too much
			// from the map's, let _setView reset levels and prune old tiles.
			if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }
	
			// create a queue of coordinates to load tiles from
			for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
				for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
					var coords = new L.Point(i, j);
					coords.z = this._tileZoom;
	
					if (!this._isValidTile(coords)) { continue; }
	
					var tile = this._tiles[this._tileCoordsToKey(coords)];
					if (tile) {
						tile.current = true;
					} else {
						queue.push(coords);
					}
				}
			}
	
			// sort tile queue to load tiles in order of their distance to center
			queue.sort(function (a, b) {
				return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
			});
	
			if (queue.length !== 0) {
				// if it's the first batch of tiles to load
				if (!this._loading) {
					this._loading = true;
					// @event loading: Event
					// Fired when the grid layer starts loading tiles.
					this.fire('loading');
				}
	
				// create DOM fragment to append tiles in one batch
				var fragment = document.createDocumentFragment();
	
				for (i = 0; i < queue.length; i++) {
					this._addTile(queue[i], fragment);
				}
	
				this._level.el.appendChild(fragment);
			}
		},
	
		_isValidTile: function (coords) {
			var crs = this._map.options.crs;
	
			if (!crs.infinite) {
				// don't load tile if it's out of bounds and not wrapped
				var bounds = this._globalTileRange;
				if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
				    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
			}
	
			if (!this.options.bounds) { return true; }
	
			// don't load tile if it doesn't intersect the bounds in options
			var tileBounds = this._tileCoordsToBounds(coords);
			return L.latLngBounds(this.options.bounds).overlaps(tileBounds);
		},
	
		_keyToBounds: function (key) {
			return this._tileCoordsToBounds(this._keyToTileCoords(key));
		},
	
		// converts tile coordinates to its geographical bounds
		_tileCoordsToBounds: function (coords) {
	
			var map = this._map,
			    tileSize = this.getTileSize(),
	
			    nwPoint = coords.scaleBy(tileSize),
			    sePoint = nwPoint.add(tileSize),
	
			    nw = map.unproject(nwPoint, coords.z),
			    se = map.unproject(sePoint, coords.z),
			    bounds = new L.LatLngBounds(nw, se);
	
			if (!this.options.noWrap) {
				map.wrapLatLngBounds(bounds);
			}
	
			return bounds;
		},
	
		// converts tile coordinates to key for the tile cache
		_tileCoordsToKey: function (coords) {
			return coords.x + ':' + coords.y + ':' + coords.z;
		},
	
		// converts tile cache key to coordinates
		_keyToTileCoords: function (key) {
			var k = key.split(':'),
			    coords = new L.Point(+k[0], +k[1]);
			coords.z = +k[2];
			return coords;
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
			if (!tile) { return; }
	
			L.DomUtil.remove(tile.el);
	
			delete this._tiles[key];
	
			// @event tileunload: TileEvent
			// Fired when a tile is removed (e.g. when a tile goes off the screen).
			this.fire('tileunload', {
				tile: tile.el,
				coords: this._keyToTileCoords(key)
			});
		},
	
		_initTile: function (tile) {
			L.DomUtil.addClass(tile, 'leaflet-tile');
	
			var tileSize = this.getTileSize();
			tile.style.width = tileSize.x + 'px';
			tile.style.height = tileSize.y + 'px';
	
			tile.onselectstart = L.Util.falseFn;
			tile.onmousemove = L.Util.falseFn;
	
			// update opacity on tiles in IE7-8 because of filter inheritance problems
			if (L.Browser.ielt9 && this.options.opacity < 1) {
				L.DomUtil.setOpacity(tile, this.options.opacity);
			}
	
			// without this hack, tiles disappear after zoom on Chrome for Android
			// https://github.com/Leaflet/Leaflet/issues/2078
			if (L.Browser.android && !L.Browser.android23) {
				tile.style.WebkitBackfaceVisibility = 'hidden';
			}
		},
	
		_addTile: function (coords, container) {
			var tilePos = this._getTilePos(coords),
			    key = this._tileCoordsToKey(coords);
	
			var tile = this.createTile(this._wrapCoords(coords), L.bind(this._tileReady, this, coords));
	
			this._initTile(tile);
	
			// if createTile is defined with a second argument ("done" callback),
			// we know that tile is async and will be ready later; otherwise
			if (this.createTile.length < 2) {
				// mark tile as ready, but delay one frame for opacity animation to happen
				L.Util.requestAnimFrame(L.bind(this._tileReady, this, coords, null, tile));
			}
	
			L.DomUtil.setPosition(tile, tilePos);
	
			// save tile in cache
			this._tiles[key] = {
				el: tile,
				coords: coords,
				current: true
			};
	
			container.appendChild(tile);
			// @event tileloadstart: TileEvent
			// Fired when a tile is requested and starts loading.
			this.fire('tileloadstart', {
				tile: tile,
				coords: coords
			});
		},
	
		_tileReady: function (coords, err, tile) {
			if (!this._map) { return; }
	
			if (err) {
				// @event tileerror: TileErrorEvent
				// Fired when there is an error loading a tile.
				this.fire('tileerror', {
					error: err,
					tile: tile,
					coords: coords
				});
			}
	
			var key = this._tileCoordsToKey(coords);
	
			tile = this._tiles[key];
			if (!tile) { return; }
	
			tile.loaded = +new Date();
			if (this._map._fadeAnimated) {
				L.DomUtil.setOpacity(tile.el, 0);
				L.Util.cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = L.Util.requestAnimFrame(this._updateOpacity, this);
			} else {
				tile.active = true;
				this._pruneTiles();
			}
	
			if (!err) {
				L.DomUtil.addClass(tile.el, 'leaflet-tile-loaded');
	
				// @event tileload: TileEvent
				// Fired when a tile loads.
				this.fire('tileload', {
					tile: tile.el,
					coords: coords
				});
			}
	
			if (this._noTilesToLoad()) {
				this._loading = false;
				// @event load: Event
				// Fired when the grid layer loaded all visible tiles.
				this.fire('load');
	
				if (L.Browser.ielt9 || !this._map._fadeAnimated) {
					L.Util.requestAnimFrame(this._pruneTiles, this);
				} else {
					// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
					// to trigger a pruning.
					setTimeout(L.bind(this._pruneTiles, this), 250);
				}
			}
		},
	
		_getTilePos: function (coords) {
			return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
		},
	
		_wrapCoords: function (coords) {
			var newCoords = new L.Point(
				this._wrapX ? L.Util.wrapNum(coords.x, this._wrapX) : coords.x,
				this._wrapY ? L.Util.wrapNum(coords.y, this._wrapY) : coords.y);
			newCoords.z = coords.z;
			return newCoords;
		},
	
		_pxBoundsToTileRange: function (bounds) {
			var tileSize = this.getTileSize();
			return new L.Bounds(
				bounds.min.unscaleBy(tileSize).floor(),
				bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
		},
	
		_noTilesToLoad: function () {
			for (var key in this._tiles) {
				if (!this._tiles[key].loaded) { return false; }
			}
			return true;
		}
	});
	
	// @factory L.gridLayer(options?: GridLayer options)
	// Creates a new instance of GridLayer with the supplied options.
	L.gridLayer = function (options) {
		return new L.GridLayer(options);
	};
	
	
	
	/*
	 * @class TileLayer
	 * @inherits GridLayer
	 * @aka L.TileLayer
	 * Used to load and display tile layers on the map. Extends `GridLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar'}).addTo(map);
	 * ```
	 *
	 * @section URL template
	 * @example
	 *
	 * A string of the following form:
	 *
	 * ```
	 * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
	 * ```
	 *
	 * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add @2x to the URL to load retina tiles.
	 *
	 * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
	 *
	 * ```
	 * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
	 * ```
	 */
	
	
	L.TileLayer = L.GridLayer.extend({
	
		// @section
		// @aka TileLayer options
		options: {
			// @option minZoom: Number = 0
			// Minimum zoom number.
			minZoom: 0,
	
			// @option maxZoom: Number = 18
			// Maximum zoom number.
			maxZoom: 18,
	
			// @option maxNativeZoom: Number = null
			// Maximum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
			// from `maxNativeZoom` level and auto-scaled.
			maxNativeZoom: null,
	
			// @option minNativeZoom: Number = null
			// Minimum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
			// from `minNativeZoom` level and auto-scaled.
			minNativeZoom: null,
	
			// @option subdomains: String|String[] = 'abc'
			// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
			subdomains: 'abc',
	
			// @option errorTileUrl: String = ''
			// URL to the tile image to show in place of the tile that failed to load.
			errorTileUrl: '',
	
			// @option zoomOffset: Number = 0
			// The zoom number used in tile URLs will be offset with this value.
			zoomOffset: 0,
	
			// @option tms: Boolean = false
			// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
			tms: false,
	
			// @option zoomReverse: Boolean = false
			// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
			zoomReverse: false,
	
			// @option detectRetina: Boolean = false
			// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
			detectRetina: false,
	
			// @option crossOrigin: Boolean = false
			// If true, all tiles will have their crossOrigin attribute set to ''. This is needed if you want to access tile pixel data.
			crossOrigin: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			options = L.setOptions(this, options);
	
			// detecting retina displays, adjusting tileSize and zoom levels
			if (options.detectRetina && L.Browser.retina && options.maxZoom > 0) {
	
				options.tileSize = Math.floor(options.tileSize / 2);
	
				if (!options.zoomReverse) {
					options.zoomOffset++;
					options.maxZoom--;
				} else {
					options.zoomOffset--;
					options.minZoom++;
				}
	
				options.minZoom = Math.max(0, options.minZoom);
			}
	
			if (typeof options.subdomains === 'string') {
				options.subdomains = options.subdomains.split('');
			}
	
			// for https://github.com/Leaflet/Leaflet/issues/137
			if (!L.Browser.android) {
				this.on('tileunload', this._onTileRemove);
			}
		},
	
		// @method setUrl(url: String, noRedraw?: Boolean): this
		// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
		setUrl: function (url, noRedraw) {
			this._url = url;
	
			if (!noRedraw) {
				this.redraw();
			}
			return this;
		},
	
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
		// to return an `<img>` HTML element with the appropiate image URL given `coords`. The `done`
		// callback is called when the tile has been loaded.
		createTile: function (coords, done) {
			var tile = document.createElement('img');
	
			L.DomEvent.on(tile, 'load', L.bind(this._tileOnLoad, this, done, tile));
			L.DomEvent.on(tile, 'error', L.bind(this._tileOnError, this, done, tile));
	
			if (this.options.crossOrigin) {
				tile.crossOrigin = '';
			}
	
			/*
			 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
			 http://www.w3.org/TR/WCAG20-TECHS/H67
			*/
			tile.alt = '';
	
			/*
			 Set role="presentation" to force screen readers to ignore this
			 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
			*/
			tile.setAttribute('role', 'presentation');
	
			tile.src = this.getTileUrl(coords);
	
			return tile;
		},
	
		// @section Extension methods
		// @uninheritable
		// Layers extending `TileLayer` might reimplement the following method.
		// @method getTileUrl(coords: Object): String
		// Called only internally, returns the URL for a tile given its coordinates.
		// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
		getTileUrl: function (coords) {
			var data = {
				r: L.Browser.retina ? '@2x' : '',
				s: this._getSubdomain(coords),
				x: coords.x,
				y: coords.y,
				z: this._getZoomForUrl()
			};
			if (this._map && !this._map.options.crs.infinite) {
				var invertedY = this._globalTileRange.max.y - coords.y;
				if (this.options.tms) {
					data['y'] = invertedY;
				}
				data['-y'] = invertedY;
			}
	
			return L.Util.template(this._url, L.extend(data, this.options));
		},
	
		_tileOnLoad: function (done, tile) {
			// For https://github.com/Leaflet/Leaflet/issues/3332
			if (L.Browser.ielt9) {
				setTimeout(L.bind(done, this, null, tile), 0);
			} else {
				done(null, tile);
			}
		},
	
		_tileOnError: function (done, tile, e) {
			var errorUrl = this.options.errorTileUrl;
			if (errorUrl && tile.src !== errorUrl) {
				tile.src = errorUrl;
			}
			done(e, tile);
		},
	
		getTileSize: function () {
			var map = this._map,
			tileSize = L.GridLayer.prototype.getTileSize.call(this),
			zoom = this._tileZoom + this.options.zoomOffset,
			minNativeZoom = this.options.minNativeZoom,
			maxNativeZoom = this.options.maxNativeZoom;
	
			// decrease tile size when scaling below minNativeZoom
			if (minNativeZoom !== null && zoom < minNativeZoom) {
				return tileSize.divideBy(map.getZoomScale(minNativeZoom, zoom)).round();
			}
	
			// increase tile size when scaling above maxNativeZoom
			if (maxNativeZoom !== null && zoom > maxNativeZoom) {
				return tileSize.divideBy(map.getZoomScale(maxNativeZoom, zoom)).round();
			}
	
			return tileSize;
		},
	
		_onTileRemove: function (e) {
			e.tile.onload = null;
		},
	
		_getZoomForUrl: function () {
			var zoom = this._tileZoom,
			maxZoom = this.options.maxZoom,
			zoomReverse = this.options.zoomReverse,
			zoomOffset = this.options.zoomOffset,
			minNativeZoom = this.options.minNativeZoom,
			maxNativeZoom = this.options.maxNativeZoom;
	
			if (zoomReverse) {
				zoom = maxZoom - zoom;
			}
	
			zoom += zoomOffset;
	
			if (minNativeZoom !== null && zoom < minNativeZoom) {
				return minNativeZoom;
			}
	
			if (maxNativeZoom !== null && zoom > maxNativeZoom) {
				return maxNativeZoom;
			}
	
			return zoom;
		},
	
		_getSubdomain: function (tilePoint) {
			var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
			return this.options.subdomains[index];
		},
	
		// stops loading all tiles in the background layer
		_abortLoading: function () {
			var i, tile;
			for (i in this._tiles) {
				if (this._tiles[i].coords.z !== this._tileZoom) {
					tile = this._tiles[i].el;
	
					tile.onload = L.Util.falseFn;
					tile.onerror = L.Util.falseFn;
	
					if (!tile.complete) {
						tile.src = L.Util.emptyImageUrl;
						L.DomUtil.remove(tile);
					}
				}
			}
		}
	});
	
	
	// @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
	// Instantiates a tile layer object given a `URL template` and optionally an options object.
	
	L.tileLayer = function (url, options) {
		return new L.TileLayer(url, options);
	};
	
	
	
	/*
	 * @class TileLayer.WMS
	 * @inherits TileLayer
	 * @aka L.TileLayer.WMS
	 * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
	 * 	layers: 'nexrad-n0r-900913',
	 * 	format: 'image/png',
	 * 	transparent: true,
	 * 	attribution: "Weather data © 2012 IEM Nexrad"
	 * });
	 * ```
	 */
	
	L.TileLayer.WMS = L.TileLayer.extend({
	
		// @section
		// @aka TileLayer.WMS options
		// If any custom options not documented here are used, they will be sent to the
		// WMS server as extra parameters in each request URL. This can be useful for
		// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
		defaultWmsParams: {
			service: 'WMS',
			request: 'GetMap',
	
			// @option layers: String = ''
			// **(required)** Comma-separated list of WMS layers to show.
			layers: '',
	
			// @option styles: String = ''
			// Comma-separated list of WMS styles.
			styles: '',
	
			// @option format: String = 'image/jpeg'
			// WMS image format (use `'image/png'` for layers with transparency).
			format: 'image/jpeg',
	
			// @option transparent: Boolean = false
			// If `true`, the WMS service will return images with transparency.
			transparent: false,
	
			// @option version: String = '1.1.1'
			// Version of the WMS service to use
			version: '1.1.1'
		},
	
		options: {
			// @option crs: CRS = null
			// Coordinate Reference System to use for the WMS requests, defaults to
			// map CRS. Don't change this if you're not sure what it means.
			crs: null,
	
			// @option uppercase: Boolean = false
			// If `true`, WMS request parameter keys will be uppercase.
			uppercase: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			var wmsParams = L.extend({}, this.defaultWmsParams);
	
			// all keys that are not TileLayer options go to WMS params
			for (var i in options) {
				if (!(i in this.options)) {
					wmsParams[i] = options[i];
				}
			}
	
			options = L.setOptions(this, options);
	
			wmsParams.width = wmsParams.height = options.tileSize * (options.detectRetina && L.Browser.retina ? 2 : 1);
	
			this.wmsParams = wmsParams;
		},
	
		onAdd: function (map) {
	
			this._crs = this.options.crs || map.options.crs;
			this._wmsVersion = parseFloat(this.wmsParams.version);
	
			var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
			this.wmsParams[projectionKey] = this._crs.code;
	
			L.TileLayer.prototype.onAdd.call(this, map);
		},
	
		getTileUrl: function (coords) {
	
			var tileBounds = this._tileCoordsToBounds(coords),
			    nw = this._crs.project(tileBounds.getNorthWest()),
			    se = this._crs.project(tileBounds.getSouthEast()),
	
			    bbox = (this._wmsVersion >= 1.3 && this._crs === L.CRS.EPSG4326 ?
				    [se.y, nw.x, nw.y, se.x] :
				    [nw.x, se.y, se.x, nw.y]).join(','),
	
			    url = L.TileLayer.prototype.getTileUrl.call(this, coords);
	
			return url +
				L.Util.getParamString(this.wmsParams, url, this.options.uppercase) +
				(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
		},
	
		// @method setParams(params: Object, noRedraw?: Boolean): this
		// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
		setParams: function (params, noRedraw) {
	
			L.extend(this.wmsParams, params);
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		}
	});
	
	
	// @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
	// Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
	L.tileLayer.wms = function (url, options) {
		return new L.TileLayer.WMS(url, options);
	};
	
	
	
	/*
	 * @class ImageOverlay
	 * @aka L.ImageOverlay
	 * @inherits Interactive layer
	 *
	 * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
	 * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
	 * L.imageOverlay(imageUrl, imageBounds).addTo(map);
	 * ```
	 */
	
	L.ImageOverlay = L.Layer.extend({
	
		// @section
		// @aka ImageOverlay options
		options: {
			// @option opacity: Number = 1.0
			// The opacity of the image overlay.
			opacity: 1,
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the image (useful for accessibility).
			alt: '',
	
			// @option interactive: Boolean = false
			// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
			interactive: false,
	
			// @option crossOrigin: Boolean = false
			// If true, the image will have its crossOrigin attribute set to ''. This is needed if you want to access image pixel data.
			crossOrigin: false
		},
	
		initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
			this._url = url;
			this._bounds = L.latLngBounds(bounds);
	
			L.setOptions(this, options);
		},
	
		onAdd: function () {
			if (!this._image) {
				this._initImage();
	
				if (this.options.opacity < 1) {
					this._updateOpacity();
				}
			}
	
			if (this.options.interactive) {
				L.DomUtil.addClass(this._image, 'leaflet-interactive');
				this.addInteractiveTarget(this._image);
			}
	
			this.getPane().appendChild(this._image);
			this._reset();
		},
	
		onRemove: function () {
			L.DomUtil.remove(this._image);
			if (this.options.interactive) {
				this.removeInteractiveTarget(this._image);
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Sets the opacity of the overlay.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._image) {
				this._updateOpacity();
			}
			return this;
		},
	
		setStyle: function (styleOpts) {
			if (styleOpts.opacity) {
				this.setOpacity(styleOpts.opacity);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all overlays.
		bringToFront: function () {
			if (this._map) {
				L.DomUtil.toFront(this._image);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all overlays.
		bringToBack: function () {
			if (this._map) {
				L.DomUtil.toBack(this._image);
			}
			return this;
		},
	
		// @method setUrl(url: String): this
		// Changes the URL of the image.
		setUrl: function (url) {
			this._url = url;
	
			if (this._image) {
				this._image.src = url;
			}
			return this;
		},
	
		// @method setBounds(bounds: LatLngBounds): this
		// Update the bounds that this ImageOverlay covers
		setBounds: function (bounds) {
			this._bounds = bounds;
	
			if (this._map) {
				this._reset();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				zoom: this._reset,
				viewreset: this._reset
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @method getBounds(): LatLngBounds
		// Get the bounds that this ImageOverlay covers
		getBounds: function () {
			return this._bounds;
		},
	
		// @method getElement(): HTMLElement
		// Get the img element that represents the ImageOverlay on the map
		getElement: function () {
			return this._image;
		},
	
		_initImage: function () {
			var img = this._image = L.DomUtil.create('img',
					'leaflet-image-layer ' + (this._zoomAnimated ? 'leaflet-zoom-animated' : ''));
	
			img.onselectstart = L.Util.falseFn;
			img.onmousemove = L.Util.falseFn;
	
			img.onload = L.bind(this.fire, this, 'load');
	
			if (this.options.crossOrigin) {
				img.crossOrigin = '';
			}
	
			img.src = this._url;
			img.alt = this.options.alt;
		},
	
		_animateZoom: function (e) {
			var scale = this._map.getZoomScale(e.zoom),
			    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
	
			L.DomUtil.setTransform(this._image, offset, scale);
		},
	
		_reset: function () {
			var image = this._image,
			    bounds = new L.Bounds(
			        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
			        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
			    size = bounds.getSize();
	
			L.DomUtil.setPosition(image, bounds.min);
	
			image.style.width  = size.x + 'px';
			image.style.height = size.y + 'px';
		},
	
		_updateOpacity: function () {
			L.DomUtil.setOpacity(this._image, this.options.opacity);
		}
	});
	
	// @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
	// Instantiates an image overlay object given the URL of the image and the
	// geographical bounds it is tied to.
	L.imageOverlay = function (url, bounds, options) {
		return new L.ImageOverlay(url, bounds, options);
	};
	
	
	
	/*
	 * @class Icon
	 * @aka L.Icon
	 * @inherits Layer
	 *
	 * Represents an icon to provide when creating a marker.
	 *
	 * @example
	 *
	 * ```js
	 * var myIcon = L.icon({
	 *     iconUrl: 'my-icon.png',
	 *     iconRetinaUrl: 'my-icon@2x.png',
	 *     iconSize: [38, 95],
	 *     iconAnchor: [22, 94],
	 *     popupAnchor: [-3, -76],
	 *     shadowUrl: 'my-icon-shadow.png',
	 *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
	 *     shadowSize: [68, 95],
	 *     shadowAnchor: [22, 94]
	 * });
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
	 *
	 */
	
	L.Icon = L.Class.extend({
	
		/* @section
		 * @aka Icon options
		 *
		 * @option iconUrl: String = null
		 * **(required)** The URL to the icon image (absolute or relative to your script path).
		 *
		 * @option iconRetinaUrl: String = null
		 * The URL to a retina sized version of the icon image (absolute or relative to your
		 * script path). Used for Retina screen devices.
		 *
		 * @option iconSize: Point = null
		 * Size of the icon image in pixels.
		 *
		 * @option iconAnchor: Point = null
		 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
		 * will be aligned so that this point is at the marker's geographical location. Centered
		 * by default if size is specified, also can be set in CSS with negative margins.
		 *
		 * @option popupAnchor: Point = null
		 * The coordinates of the point from which popups will "open", relative to the icon anchor.
		 *
		 * @option shadowUrl: String = null
		 * The URL to the icon shadow image. If not specified, no shadow image will be created.
		 *
		 * @option shadowRetinaUrl: String = null
		 *
		 * @option shadowSize: Point = null
		 * Size of the shadow image in pixels.
		 *
		 * @option shadowAnchor: Point = null
		 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
		 * as iconAnchor if not specified).
		 *
		 * @option className: String = ''
		 * A custom class name to assign to both icon and shadow images. Empty by default.
		 */
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		// @method createIcon(oldIcon?: HTMLElement): HTMLElement
		// Called internally when the icon has to be shown, returns a `<img>` HTML element
		// styled according to the options.
		createIcon: function (oldIcon) {
			return this._createIcon('icon', oldIcon);
		},
	
		// @method createShadow(oldIcon?: HTMLElement): HTMLElement
		// As `createIcon`, but for the shadow beneath it.
		createShadow: function (oldIcon) {
			return this._createIcon('shadow', oldIcon);
		},
	
		_createIcon: function (name, oldIcon) {
			var src = this._getIconUrl(name);
	
			if (!src) {
				if (name === 'icon') {
					throw new Error('iconUrl not set in Icon options (see the docs).');
				}
				return null;
			}
	
			var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
			this._setIconStyles(img, name);
	
			return img;
		},
	
		_setIconStyles: function (img, name) {
			var options = this.options;
			var sizeOption = options[name + 'Size'];
	
			if (typeof sizeOption === 'number') {
				sizeOption = [sizeOption, sizeOption];
			}
	
			var size = L.point(sizeOption),
			    anchor = L.point(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
			            size && size.divideBy(2, true));
	
			img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
	
			if (anchor) {
				img.style.marginLeft = (-anchor.x) + 'px';
				img.style.marginTop  = (-anchor.y) + 'px';
			}
	
			if (size) {
				img.style.width  = size.x + 'px';
				img.style.height = size.y + 'px';
			}
		},
	
		_createImg: function (src, el) {
			el = el || document.createElement('img');
			el.src = src;
			return el;
		},
	
		_getIconUrl: function (name) {
			return L.Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
		}
	});
	
	
	// @factory L.icon(options: Icon options)
	// Creates an icon instance with the given options.
	L.icon = function (options) {
		return new L.Icon(options);
	};
	
	
	
	/*
	 * @miniclass Icon.Default (Icon)
	 * @aka L.Icon.Default
	 * @section
	 *
	 * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
	 * no icon is specified. Points to the blue marker image distributed with Leaflet
	 * releases.
	 *
	 * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
	 * (which is a set of `Icon options`).
	 *
	 * If you want to _completely_ replace the default icon, override the
	 * `L.Marker.prototype.options.icon` with your own icon instead.
	 */
	
	L.Icon.Default = L.Icon.extend({
	
		options: {
			iconUrl:       'marker-icon.png',
			iconRetinaUrl: 'marker-icon-2x.png',
			shadowUrl:     'marker-shadow.png',
			iconSize:    [25, 41],
			iconAnchor:  [12, 41],
			popupAnchor: [1, -34],
			tooltipAnchor: [16, -28],
			shadowSize:  [41, 41]
		},
	
		_getIconUrl: function (name) {
			if (!L.Icon.Default.imagePath) {	// Deprecated, backwards-compatibility only
				L.Icon.Default.imagePath = this._detectIconPath();
			}
	
			// @option imagePath: String
			// `L.Icon.Default` will try to auto-detect the absolute location of the
			// blue icon images. If you are placing these images in a non-standard
			// way, set this option to point to the right absolute path.
			return (this.options.imagePath || L.Icon.Default.imagePath) + L.Icon.prototype._getIconUrl.call(this, name);
		},
	
		_detectIconPath: function () {
			var el = L.DomUtil.create('div',  'leaflet-default-icon-path', document.body);
			var path = L.DomUtil.getStyle(el, 'background-image') ||
			           L.DomUtil.getStyle(el, 'backgroundImage');	// IE8
	
			document.body.removeChild(el);
	
			return path.indexOf('url') === 0 ?
				path.replace(/^url\([\"\']?/, '').replace(/marker-icon\.png[\"\']?\)$/, '') : '';
		}
	});
	
	
	
	/*
	 * @class Marker
	 * @inherits Interactive layer
	 * @aka L.Marker
	 * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.marker([50.5, 30.5]).addTo(map);
	 * ```
	 */
	
	L.Marker = L.Layer.extend({
	
		// @section
		// @aka Marker options
		options: {
			// @option icon: Icon = *
			// Icon class to use for rendering the marker. See [Icon documentation](#L.Icon) for details on how to customize the marker icon. If not specified, a new `L.Icon.Default` is used.
			icon: new L.Icon.Default(),
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true,
	
			// @option draggable: Boolean = false
			// Whether the marker is draggable with mouse/touch or not.
			draggable: false,
	
			// @option keyboard: Boolean = true
			// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
			keyboard: true,
	
			// @option title: String = ''
			// Text for the browser tooltip that appear on marker hover (no tooltip by default).
			title: '',
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the icon image (useful for accessibility).
			alt: '',
	
			// @option zIndexOffset: Number = 0
			// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
			zIndexOffset: 0,
	
			// @option opacity: Number = 1.0
			// The opacity of the marker.
			opacity: 1,
	
			// @option riseOnHover: Boolean = false
			// If `true`, the marker will get on top of others when you hover the mouse over it.
			riseOnHover: false,
	
			// @option riseOffset: Number = 250
			// The z-index offset used for the `riseOnHover` feature.
			riseOffset: 250,
	
			// @option pane: String = 'markerPane'
			// `Map pane` where the markers icon will be added.
			pane: 'markerPane',
	
			// FIXME: shadowPane is no longer a valid option
			nonBubblingEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu']
		},
	
		/* @section
		 *
		 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
		 */
	
		initialize: function (latlng, options) {
			L.setOptions(this, options);
			this._latlng = L.latLng(latlng);
		},
	
		onAdd: function (map) {
			this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	
			if (this._zoomAnimated) {
				map.on('zoomanim', this._animateZoom, this);
			}
	
			this._initIcon();
			this.update();
		},
	
		onRemove: function (map) {
			if (this.dragging && this.dragging.enabled()) {
				this.options.draggable = true;
				this.dragging.removeHooks();
			}
	
			if (this._zoomAnimated) {
				map.off('zoomanim', this._animateZoom, this);
			}
	
			this._removeIcon();
			this._removeShadow();
		},
	
		getEvents: function () {
			return {
				zoom: this.update,
				viewreset: this.update
			};
		},
	
		// @method getLatLng: LatLng
		// Returns the current geographical position of the marker.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Changes the marker position to the given point.
		setLatLng: function (latlng) {
			var oldLatLng = this._latlng;
			this._latlng = L.latLng(latlng);
			this.update();
	
			// @event move: Event
			// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
			return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
		},
	
		// @method setZIndexOffset(offset: Number): this
		// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
		setZIndexOffset: function (offset) {
			this.options.zIndexOffset = offset;
			return this.update();
		},
	
		// @method setIcon(icon: Icon): this
		// Changes the marker icon.
		setIcon: function (icon) {
	
			this.options.icon = icon;
	
			if (this._map) {
				this._initIcon();
				this.update();
			}
	
			if (this._popup) {
				this.bindPopup(this._popup, this._popup.options);
			}
	
			return this;
		},
	
		getElement: function () {
			return this._icon;
		},
	
		update: function () {
	
			if (this._icon) {
				var pos = this._map.latLngToLayerPoint(this._latlng).round();
				this._setPos(pos);
			}
	
			return this;
		},
	
		_initIcon: function () {
			var options = this.options,
			    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			var icon = options.icon.createIcon(this._icon),
			    addIcon = false;
	
			// if we're not reusing the icon, remove the old one and init new one
			if (icon !== this._icon) {
				if (this._icon) {
					this._removeIcon();
				}
				addIcon = true;
	
				if (options.title) {
					icon.title = options.title;
				}
				if (options.alt) {
					icon.alt = options.alt;
				}
			}
	
			L.DomUtil.addClass(icon, classToAdd);
	
			if (options.keyboard) {
				icon.tabIndex = '0';
			}
	
			this._icon = icon;
	
			if (options.riseOnHover) {
				this.on({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			var newShadow = options.icon.createShadow(this._shadow),
			    addShadow = false;
	
			if (newShadow !== this._shadow) {
				this._removeShadow();
				addShadow = true;
			}
	
			if (newShadow) {
				L.DomUtil.addClass(newShadow, classToAdd);
				newShadow.alt = '';
			}
			this._shadow = newShadow;
	
	
			if (options.opacity < 1) {
				this._updateOpacity();
			}
	
	
			if (addIcon) {
				this.getPane().appendChild(this._icon);
			}
			this._initInteraction();
			if (newShadow && addShadow) {
				this.getPane('shadowPane').appendChild(this._shadow);
			}
		},
	
		_removeIcon: function () {
			if (this.options.riseOnHover) {
				this.off({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			L.DomUtil.remove(this._icon);
			this.removeInteractiveTarget(this._icon);
	
			this._icon = null;
		},
	
		_removeShadow: function () {
			if (this._shadow) {
				L.DomUtil.remove(this._shadow);
			}
			this._shadow = null;
		},
	
		_setPos: function (pos) {
			L.DomUtil.setPosition(this._icon, pos);
	
			if (this._shadow) {
				L.DomUtil.setPosition(this._shadow, pos);
			}
	
			this._zIndex = pos.y + this.options.zIndexOffset;
	
			this._resetZIndex();
		},
	
		_updateZIndex: function (offset) {
			this._icon.style.zIndex = this._zIndex + offset;
		},
	
		_animateZoom: function (opt) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
			this._setPos(pos);
		},
	
		_initInteraction: function () {
	
			if (!this.options.interactive) { return; }
	
			L.DomUtil.addClass(this._icon, 'leaflet-interactive');
	
			this.addInteractiveTarget(this._icon);
	
			if (L.Handler.MarkerDrag) {
				var draggable = this.options.draggable;
				if (this.dragging) {
					draggable = this.dragging.enabled();
					this.dragging.disable();
				}
	
				this.dragging = new L.Handler.MarkerDrag(this);
	
				if (draggable) {
					this.dragging.enable();
				}
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the opacity of the marker.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			if (this._map) {
				this._updateOpacity();
			}
	
			return this;
		},
	
		_updateOpacity: function () {
			var opacity = this.options.opacity;
	
			L.DomUtil.setOpacity(this._icon, opacity);
	
			if (this._shadow) {
				L.DomUtil.setOpacity(this._shadow, opacity);
			}
		},
	
		_bringToFront: function () {
			this._updateZIndex(this.options.riseOffset);
		},
	
		_resetZIndex: function () {
			this._updateZIndex(0);
		},
	
		_getPopupAnchor: function () {
			return this.options.icon.options.popupAnchor || [0, 0];
		},
	
		_getTooltipAnchor: function () {
			return this.options.icon.options.tooltipAnchor || [0, 0];
		}
	});
	
	
	// factory L.marker(latlng: LatLng, options? : Marker options)
	
	// @factory L.marker(latlng: LatLng, options? : Marker options)
	// Instantiates a Marker object given a geographical point and optionally an options object.
	L.marker = function (latlng, options) {
		return new L.Marker(latlng, options);
	};
	
	
	
	/*
	 * @class DivIcon
	 * @aka L.DivIcon
	 * @inherits Icon
	 *
	 * Represents a lightweight icon for markers that uses a simple `<div>`
	 * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
	 *
	 * @example
	 * ```js
	 * var myIcon = L.divIcon({className: 'my-div-icon'});
	 * // you can set .my-div-icon styles in CSS
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
	 */
	
	L.DivIcon = L.Icon.extend({
		options: {
			// @section
			// @aka DivIcon options
			iconSize: [12, 12], // also can be set through CSS
	
			// iconAnchor: (Point),
			// popupAnchor: (Point),
	
			// @option html: String = ''
			// Custom HTML code to put inside the div element, empty by default.
			html: false,
	
			// @option bgPos: Point = [0, 0]
			// Optional relative position of the background, in pixels
			bgPos: null,
	
			className: 'leaflet-div-icon'
		},
	
		createIcon: function (oldIcon) {
			var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
			    options = this.options;
	
			div.innerHTML = options.html !== false ? options.html : '';
	
			if (options.bgPos) {
				var bgPos = L.point(options.bgPos);
				div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
			}
			this._setIconStyles(div, 'icon');
	
			return div;
		},
	
		createShadow: function () {
			return null;
		}
	});
	
	// @factory L.divIcon(options: DivIcon options)
	// Creates a `DivIcon` instance with the given options.
	L.divIcon = function (options) {
		return new L.DivIcon(options);
	};
	
	
	
	/*
	 * @class DivOverlay
	 * @inherits Layer
	 * @aka L.DivOverlay
	 * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
	 */
	
	// @namespace DivOverlay
	L.DivOverlay = L.Layer.extend({
	
		// @section
		// @aka DivOverlay options
		options: {
			// @option offset: Point = Point(0, 7)
			// The offset of the popup position. Useful to control the anchor
			// of the popup when opening it on some overlays.
			offset: [0, 7],
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: '',
	
			// @option pane: String = 'popupPane'
			// `Map pane` where the popup will be added.
			pane: 'popupPane'
		},
	
		initialize: function (options, source) {
			L.setOptions(this, options);
	
			this._source = source;
		},
	
		onAdd: function (map) {
			this._zoomAnimated = map._zoomAnimated;
	
			if (!this._container) {
				this._initLayout();
			}
	
			if (map._fadeAnimated) {
				L.DomUtil.setOpacity(this._container, 0);
			}
	
			clearTimeout(this._removeTimeout);
			this.getPane().appendChild(this._container);
			this.update();
	
			if (map._fadeAnimated) {
				L.DomUtil.setOpacity(this._container, 1);
			}
	
			this.bringToFront();
		},
	
		onRemove: function (map) {
			if (map._fadeAnimated) {
				L.DomUtil.setOpacity(this._container, 0);
				this._removeTimeout = setTimeout(L.bind(L.DomUtil.remove, L.DomUtil, this._container), 200);
			} else {
				L.DomUtil.remove(this._container);
			}
		},
	
		// @namespace Popup
		// @method getLatLng: LatLng
		// Returns the geographical point of popup.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Sets the geographical point where the popup will open.
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
			if (this._map) {
				this._updatePosition();
				this._adjustPan();
			}
			return this;
		},
	
		// @method getContent: String|HTMLElement
		// Returns the content of the popup.
		getContent: function () {
			return this._content;
		},
	
		// @method setContent(htmlContent: String|HTMLElement|Function): this
		// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
		setContent: function (content) {
			this._content = content;
			this.update();
			return this;
		},
	
		// @method getElement: String|HTMLElement
		// Alias for [getContent()](#popup-getcontent)
		getElement: function () {
			return this._container;
		},
	
		// @method update: null
		// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
		update: function () {
			if (!this._map) { return; }
	
			this._container.style.visibility = 'hidden';
	
			this._updateContent();
			this._updateLayout();
			this._updatePosition();
	
			this._container.style.visibility = '';
	
			this._adjustPan();
		},
	
		getEvents: function () {
			var events = {
				zoom: this._updatePosition,
				viewreset: this._updatePosition
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
			return events;
		},
	
		// @method isOpen: Boolean
		// Returns `true` when the popup is visible on the map.
		isOpen: function () {
			return !!this._map && this._map.hasLayer(this);
		},
	
		// @method bringToFront: this
		// Brings this popup in front of other popups (in the same map pane).
		bringToFront: function () {
			if (this._map) {
				L.DomUtil.toFront(this._container);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings this popup to the back of other popups (in the same map pane).
		bringToBack: function () {
			if (this._map) {
				L.DomUtil.toBack(this._container);
			}
			return this;
		},
	
		_updateContent: function () {
			if (!this._content) { return; }
	
			var node = this._contentNode;
			var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;
	
			if (typeof content === 'string') {
				node.innerHTML = content;
			} else {
				while (node.hasChildNodes()) {
					node.removeChild(node.firstChild);
				}
				node.appendChild(content);
			}
			this.fire('contentupdate');
		},
	
		_updatePosition: function () {
			if (!this._map) { return; }
	
			var pos = this._map.latLngToLayerPoint(this._latlng),
			    offset = L.point(this.options.offset),
			    anchor = this._getAnchor();
	
			if (this._zoomAnimated) {
				L.DomUtil.setPosition(this._container, pos.add(anchor));
			} else {
				offset = offset.add(pos).add(anchor);
			}
	
			var bottom = this._containerBottom = -offset.y,
			    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
	
			// bottom position the popup in case the height of the popup changes (images loading etc)
			this._container.style.bottom = bottom + 'px';
			this._container.style.left = left + 'px';
		},
	
		_getAnchor: function () {
			return [0, 0];
		}
	
	});
	
	
	
	/*
	 * @class Popup
	 * @inherits DivOverlay
	 * @aka L.Popup
	 * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
	 * open popups while making sure that only one popup is open at one time
	 * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
	 *
	 * @example
	 *
	 * If you want to just bind a popup to marker click and then open it, it's really easy:
	 *
	 * ```js
	 * marker.bindPopup(popupContent).openPopup();
	 * ```
	 * Path overlays like polylines also have a `bindPopup` method.
	 * Here's a more complicated way to open a popup on a map:
	 *
	 * ```js
	 * var popup = L.popup()
	 * 	.setLatLng(latlng)
	 * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
	 * 	.openOn(map);
	 * ```
	 */
	
	
	// @namespace Popup
	L.Popup = L.DivOverlay.extend({
	
		// @section
		// @aka Popup options
		options: {
			// @option maxWidth: Number = 300
			// Max width of the popup, in pixels.
			maxWidth: 300,
	
			// @option minWidth: Number = 50
			// Min width of the popup, in pixels.
			minWidth: 50,
	
			// @option maxHeight: Number = null
			// If set, creates a scrollable container of the given height
			// inside a popup if its content exceeds it.
			maxHeight: null,
	
			// @option autoPan: Boolean = true
			// Set it to `false` if you don't want the map to do panning animation
			// to fit the opened popup.
			autoPan: true,
	
			// @option autoPanPaddingTopLeft: Point = null
			// The margin between the popup and the top left corner of the map
			// view after autopanning was performed.
			autoPanPaddingTopLeft: null,
	
			// @option autoPanPaddingBottomRight: Point = null
			// The margin between the popup and the bottom right corner of the map
			// view after autopanning was performed.
			autoPanPaddingBottomRight: null,
	
			// @option autoPanPadding: Point = Point(5, 5)
			// Equivalent of setting both top left and bottom right autopan padding to the same value.
			autoPanPadding: [5, 5],
	
			// @option keepInView: Boolean = false
			// Set it to `true` if you want to prevent users from panning the popup
			// off of the screen while it is open.
			keepInView: false,
	
			// @option closeButton: Boolean = true
			// Controls the presence of a close button in the popup.
			closeButton: true,
	
			// @option autoClose: Boolean = true
			// Set it to `false` if you want to override the default behavior of
			// the popup closing when user clicks the map (set globally by
			// the Map's [closePopupOnClick](#map-closepopuponclick) option).
			autoClose: true,
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: ''
		},
	
		// @namespace Popup
		// @method openOn(map: Map): this
		// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
		openOn: function (map) {
			map.openPopup(this);
			return this;
		},
	
		onAdd: function (map) {
			L.DivOverlay.prototype.onAdd.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupopen: PopupEvent
			// Fired when a popup is opened in the map
			map.fire('popupopen', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupopen: PopupEvent
				// Fired when a popup bound to this layer is opened
				this._source.fire('popupopen', {popup: this}, true);
				// For non-path layers, we toggle the popup when clicking
				// again the layer, so prevent the map to reopen it.
				if (!(this._source instanceof L.Path)) {
					this._source.on('preclick', L.DomEvent.stopPropagation);
				}
			}
		},
	
		onRemove: function (map) {
			L.DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupclose: PopupEvent
			// Fired when a popup in the map is closed
			map.fire('popupclose', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupclose: PopupEvent
				// Fired when a popup bound to this layer is closed
				this._source.fire('popupclose', {popup: this}, true);
				if (!(this._source instanceof L.Path)) {
					this._source.off('preclick', L.DomEvent.stopPropagation);
				}
			}
		},
	
		getEvents: function () {
			var events = L.DivOverlay.prototype.getEvents.call(this);
	
			if ('closeOnClick' in this.options ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
				events.preclick = this._close;
			}
	
			if (this.options.keepInView) {
				events.moveend = this._adjustPan;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closePopup(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-popup',
			    container = this._container = L.DomUtil.create('div',
				prefix + ' ' + (this.options.className || '') +
				' leaflet-zoom-animated');
	
			if (this.options.closeButton) {
				var closeButton = this._closeButton = L.DomUtil.create('a', prefix + '-close-button', container);
				closeButton.href = '#close';
				closeButton.innerHTML = '&#215;';
	
				L.DomEvent.on(closeButton, 'click', this._onCloseButtonClick, this);
			}
	
			var wrapper = this._wrapper = L.DomUtil.create('div', prefix + '-content-wrapper', container);
			this._contentNode = L.DomUtil.create('div', prefix + '-content', wrapper);
	
			L.DomEvent
				.disableClickPropagation(wrapper)
				.disableScrollPropagation(this._contentNode)
				.on(wrapper, 'contextmenu', L.DomEvent.stopPropagation);
	
			this._tipContainer = L.DomUtil.create('div', prefix + '-tip-container', container);
			this._tip = L.DomUtil.create('div', prefix + '-tip', this._tipContainer);
		},
	
		_updateLayout: function () {
			var container = this._contentNode,
			    style = container.style;
	
			style.width = '';
			style.whiteSpace = 'nowrap';
	
			var width = container.offsetWidth;
			width = Math.min(width, this.options.maxWidth);
			width = Math.max(width, this.options.minWidth);
	
			style.width = (width + 1) + 'px';
			style.whiteSpace = '';
	
			style.height = '';
	
			var height = container.offsetHeight,
			    maxHeight = this.options.maxHeight,
			    scrolledClass = 'leaflet-popup-scrolled';
	
			if (maxHeight && height > maxHeight) {
				style.height = maxHeight + 'px';
				L.DomUtil.addClass(container, scrolledClass);
			} else {
				L.DomUtil.removeClass(container, scrolledClass);
			}
	
			this._containerWidth = this._container.offsetWidth;
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
			    anchor = this._getAnchor();
			L.DomUtil.setPosition(this._container, pos.add(anchor));
		},
	
		_adjustPan: function () {
			if (!this.options.autoPan || (this._map._panAnim && this._map._panAnim._inProgress)) { return; }
	
			var map = this._map,
			    marginBottom = parseInt(L.DomUtil.getStyle(this._container, 'marginBottom'), 10) || 0,
			    containerHeight = this._container.offsetHeight + marginBottom,
			    containerWidth = this._containerWidth,
			    layerPos = new L.Point(this._containerLeft, -containerHeight - this._containerBottom);
	
			layerPos._add(L.DomUtil.getPosition(this._container));
	
			var containerPos = map.layerPointToContainerPoint(layerPos),
			    padding = L.point(this.options.autoPanPadding),
			    paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding),
			    paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding),
			    size = map.getSize(),
			    dx = 0,
			    dy = 0;
	
			if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
				dx = containerPos.x + containerWidth - size.x + paddingBR.x;
			}
			if (containerPos.x - dx - paddingTL.x < 0) { // left
				dx = containerPos.x - paddingTL.x;
			}
			if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
				dy = containerPos.y + containerHeight - size.y + paddingBR.y;
			}
			if (containerPos.y - dy - paddingTL.y < 0) { // top
				dy = containerPos.y - paddingTL.y;
			}
	
			// @namespace Map
			// @section Popup events
			// @event autopanstart: Event
			// Fired when the map starts autopanning when opening a popup.
			if (dx || dy) {
				map
				    .fire('autopanstart')
				    .panBy([dx, dy]);
			}
		},
	
		_onCloseButtonClick: function (e) {
			this._close();
			L.DomEvent.stop(e);
		},
	
		_getAnchor: function () {
			// Where should we anchor the popup on the source layer?
			return L.point(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Popup
	// @factory L.popup(options?: Popup options, source?: Layer)
	// Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
	L.popup = function (options, source) {
		return new L.Popup(options, source);
	};
	
	
	/* @namespace Map
	 * @section Interaction Options
	 * @option closePopupOnClick: Boolean = true
	 * Set it to `false` if you don't want popups to close when user clicks the map.
	 */
	L.Map.mergeOptions({
		closePopupOnClick: true
	});
	
	
	// @namespace Map
	// @section Methods for Layers and Controls
	L.Map.include({
		// @method openPopup(popup: Popup): this
		// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
		// @alternative
		// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
		// Creates a popup with the specified content and options and opens it in the given point on a map.
		openPopup: function (popup, latlng, options) {
			if (!(popup instanceof L.Popup)) {
				popup = new L.Popup(options).setContent(popup);
			}
	
			if (latlng) {
				popup.setLatLng(latlng);
			}
	
			if (this.hasLayer(popup)) {
				return this;
			}
	
			if (this._popup && this._popup.options.autoClose) {
				this.closePopup();
			}
	
			this._popup = popup;
			return this.addLayer(popup);
		},
	
		// @method closePopup(popup?: Popup): this
		// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
		closePopup: function (popup) {
			if (!popup || popup === this._popup) {
				popup = this._popup;
				this._popup = null;
			}
			if (popup) {
				this.removeLayer(popup);
			}
			return this;
		}
	});
	
	/*
	 * @namespace Layer
	 * @section Popup methods example
	 *
	 * All layers share a set of methods convenient for binding popups to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
	 * layer.openPopup();
	 * layer.closePopup();
	 * ```
	 *
	 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
	 */
	
	// @section Popup methods
	L.Layer.include({
	
		// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
		// Binds a popup to the layer with the passed `content` and sets up the
		// neccessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindPopup: function (content, options) {
	
			if (content instanceof L.Popup) {
				L.setOptions(content, options);
				this._popup = content;
				content._source = this;
			} else {
				if (!this._popup || options) {
					this._popup = new L.Popup(options, this);
				}
				this._popup.setContent(content);
			}
	
			if (!this._popupHandlersAdded) {
				this.on({
					click: this._openPopup,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = true;
			}
	
			return this;
		},
	
		// @method unbindPopup(): this
		// Removes the popup previously bound with `bindPopup`.
		unbindPopup: function () {
			if (this._popup) {
				this.off({
					click: this._openPopup,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = false;
				this._popup = null;
			}
			return this;
		},
	
		// @method openPopup(latlng?: LatLng): this
		// Opens the bound popup at the specificed `latlng` or at the default popup anchor if no `latlng` is passed.
		openPopup: function (layer, latlng) {
			if (!(layer instanceof L.Layer)) {
				latlng = layer;
				layer = this;
			}
	
			if (layer instanceof L.FeatureGroup) {
				for (var id in this._layers) {
					layer = this._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
			}
	
			if (this._popup && this._map) {
				// set popup source to this layer
				this._popup._source = layer;
	
				// update the popup (content, layout, ect...)
				this._popup.update();
	
				// open the popup on the map
				this._map.openPopup(this._popup, latlng);
			}
	
			return this;
		},
	
		// @method closePopup(): this
		// Closes the popup bound to this layer if it is open.
		closePopup: function () {
			if (this._popup) {
				this._popup._close();
			}
			return this;
		},
	
		// @method togglePopup(): this
		// Opens or closes the popup bound to this layer depending on its current state.
		togglePopup: function (target) {
			if (this._popup) {
				if (this._popup._map) {
					this.closePopup();
				} else {
					this.openPopup(target);
				}
			}
			return this;
		},
	
		// @method isPopupOpen(): boolean
		// Returns `true` if the popup bound to this layer is currently open.
		isPopupOpen: function () {
			return (this._popup ? this._popup.isOpen() : false);
		},
	
		// @method setPopupContent(content: String|HTMLElement|Popup): this
		// Sets the content of the popup bound to this layer.
		setPopupContent: function (content) {
			if (this._popup) {
				this._popup.setContent(content);
			}
			return this;
		},
	
		// @method getPopup(): Popup
		// Returns the popup bound to this layer.
		getPopup: function () {
			return this._popup;
		},
	
		_openPopup: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._popup) {
				return;
			}
	
			if (!this._map) {
				return;
			}
	
			// prevent map click
			L.DomEvent.stop(e);
	
			// if this inherits from Path its a vector and we can just
			// open the popup at the new location
			if (layer instanceof L.Path) {
				this.openPopup(e.layer || e.target, e.latlng);
				return;
			}
	
			// otherwise treat it like a marker and figure out
			// if we should toggle it open/closed
			if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
				this.closePopup();
			} else {
				this.openPopup(layer, e.latlng);
			}
		},
	
		_movePopup: function (e) {
			this._popup.setLatLng(e.latlng);
		}
	});
	
	
	
	/*
	 * @class Tooltip
	 * @inherits DivOverlay
	 * @aka L.Tooltip
	 * Used to display small texts on top of map layers.
	 *
	 * @example
	 *
	 * ```js
	 * marker.bindTooltip("my tooltip text").openTooltip();
	 * ```
	 * Note about tooltip offset. Leaflet takes two options in consideration
	 * for computing tooltip offseting:
	 * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
	 *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
	 *   move it to the bottom. Negatives will move to the left and top.
	 * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
	 *   should adapt this value if you use a custom icon.
	 */
	
	
	// @namespace Tooltip
	L.Tooltip = L.DivOverlay.extend({
	
		// @section
		// @aka Tooltip options
		options: {
			// @option pane: String = 'tooltipPane'
			// `Map pane` where the tooltip will be added.
			pane: 'tooltipPane',
	
			// @option offset: Point = Point(0, 0)
			// Optional offset of the tooltip position.
			offset: [0, 0],
	
			// @option direction: String = 'auto'
			// Direction where to open the tooltip. Possible values are: `right`, `left`,
			// `top`, `bottom`, `center`, `auto`.
			// `auto` will dynamicaly switch between `right` and `left` according to the tooltip
			// position on the map.
			direction: 'auto',
	
			// @option permanent: Boolean = false
			// Whether to open the tooltip permanently or only on mouseover.
			permanent: false,
	
			// @option sticky: Boolean = false
			// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
			sticky: false,
	
			// @option interactive: Boolean = false
			// If true, the tooltip will listen to the feature events.
			interactive: false,
	
			// @option opacity: Number = 0.9
			// Tooltip container opacity.
			opacity: 0.9
		},
	
		onAdd: function (map) {
			L.DivOverlay.prototype.onAdd.call(this, map);
			this.setOpacity(this.options.opacity);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipopen: TooltipEvent
			// Fired when a tooltip is opened in the map.
			map.fire('tooltipopen', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipopen: TooltipEvent
				// Fired when a tooltip bound to this layer is opened.
				this._source.fire('tooltipopen', {tooltip: this}, true);
			}
		},
	
		onRemove: function (map) {
			L.DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipclose: TooltipEvent
			// Fired when a tooltip in the map is closed.
			map.fire('tooltipclose', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipclose: TooltipEvent
				// Fired when a tooltip bound to this layer is closed.
				this._source.fire('tooltipclose', {tooltip: this}, true);
			}
		},
	
		getEvents: function () {
			var events = L.DivOverlay.prototype.getEvents.call(this);
	
			if (L.Browser.touch && !this.options.permanent) {
				events.preclick = this._close;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closeTooltip(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-tooltip',
			    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			this._contentNode = this._container = L.DomUtil.create('div', className);
		},
	
		_updateLayout: function () {},
	
		_adjustPan: function () {},
	
		_setPosition: function (pos) {
			var map = this._map,
			    container = this._container,
			    centerPoint = map.latLngToContainerPoint(map.getCenter()),
			    tooltipPoint = map.layerPointToContainerPoint(pos),
			    direction = this.options.direction,
			    tooltipWidth = container.offsetWidth,
			    tooltipHeight = container.offsetHeight,
			    offset = L.point(this.options.offset),
			    anchor = this._getAnchor();
	
			if (direction === 'top') {
				pos = pos.add(L.point(-tooltipWidth / 2 + offset.x, -tooltipHeight + offset.y + anchor.y, true));
			} else if (direction === 'bottom') {
				pos = pos.subtract(L.point(tooltipWidth / 2 - offset.x, -offset.y, true));
			} else if (direction === 'center') {
				pos = pos.subtract(L.point(tooltipWidth / 2 + offset.x, tooltipHeight / 2 - anchor.y + offset.y, true));
			} else if (direction === 'right' || direction === 'auto' && tooltipPoint.x < centerPoint.x) {
				direction = 'right';
				pos = pos.add(L.point(offset.x + anchor.x, anchor.y - tooltipHeight / 2 + offset.y, true));
			} else {
				direction = 'left';
				pos = pos.subtract(L.point(tooltipWidth + anchor.x - offset.x, tooltipHeight / 2 - anchor.y - offset.y, true));
			}
	
			L.DomUtil.removeClass(container, 'leaflet-tooltip-right');
			L.DomUtil.removeClass(container, 'leaflet-tooltip-left');
			L.DomUtil.removeClass(container, 'leaflet-tooltip-top');
			L.DomUtil.removeClass(container, 'leaflet-tooltip-bottom');
			L.DomUtil.addClass(container, 'leaflet-tooltip-' + direction);
			L.DomUtil.setPosition(container, pos);
		},
	
		_updatePosition: function () {
			var pos = this._map.latLngToLayerPoint(this._latlng);
			this._setPosition(pos);
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._container) {
				L.DomUtil.setOpacity(this._container, opacity);
			}
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
			this._setPosition(pos);
		},
	
		_getAnchor: function () {
			// Where should we anchor the tooltip on the source layer?
			return L.point(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Tooltip
	// @factory L.tooltip(options?: Tooltip options, source?: Layer)
	// Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
	L.tooltip = function (options, source) {
		return new L.Tooltip(options, source);
	};
	
	// @namespace Map
	// @section Methods for Layers and Controls
	L.Map.include({
	
		// @method openTooltip(tooltip: Tooltip): this
		// Opens the specified tooltip.
		// @alternative
		// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
		// Creates a tooltip with the specified content and options and open it.
		openTooltip: function (tooltip, latlng, options) {
			if (!(tooltip instanceof L.Tooltip)) {
				tooltip = new L.Tooltip(options).setContent(tooltip);
			}
	
			if (latlng) {
				tooltip.setLatLng(latlng);
			}
	
			if (this.hasLayer(tooltip)) {
				return this;
			}
	
			return this.addLayer(tooltip);
		},
	
		// @method closeTooltip(tooltip?: Tooltip): this
		// Closes the tooltip given as parameter.
		closeTooltip: function (tooltip) {
			if (tooltip) {
				this.removeLayer(tooltip);
			}
			return this;
		}
	
	});
	
	/*
	 * @namespace Layer
	 * @section Tooltip methods example
	 *
	 * All layers share a set of methods convenient for binding tooltips to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
	 * layer.openTooltip();
	 * layer.closeTooltip();
	 * ```
	 */
	
	// @section Tooltip methods
	L.Layer.include({
	
		// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
		// Binds a tooltip to the layer with the passed `content` and sets up the
		// neccessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindTooltip: function (content, options) {
	
			if (content instanceof L.Tooltip) {
				L.setOptions(content, options);
				this._tooltip = content;
				content._source = this;
			} else {
				if (!this._tooltip || options) {
					this._tooltip = L.tooltip(options, this);
				}
				this._tooltip.setContent(content);
	
			}
	
			this._initTooltipInteractions();
	
			if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
				this.openTooltip();
			}
	
			return this;
		},
	
		// @method unbindTooltip(): this
		// Removes the tooltip previously bound with `bindTooltip`.
		unbindTooltip: function () {
			if (this._tooltip) {
				this._initTooltipInteractions(true);
				this.closeTooltip();
				this._tooltip = null;
			}
			return this;
		},
	
		_initTooltipInteractions: function (remove) {
			if (!remove && this._tooltipHandlersAdded) { return; }
			var onOff = remove ? 'off' : 'on',
			    events = {
				remove: this.closeTooltip,
				move: this._moveTooltip
			    };
			if (!this._tooltip.options.permanent) {
				events.mouseover = this._openTooltip;
				events.mouseout = this.closeTooltip;
				if (this._tooltip.options.sticky) {
					events.mousemove = this._moveTooltip;
				}
				if (L.Browser.touch) {
					events.click = this._openTooltip;
				}
			} else {
				events.add = this._openTooltip;
			}
			this[onOff](events);
			this._tooltipHandlersAdded = !remove;
		},
	
		// @method openTooltip(latlng?: LatLng): this
		// Opens the bound tooltip at the specificed `latlng` or at the default tooltip anchor if no `latlng` is passed.
		openTooltip: function (layer, latlng) {
			if (!(layer instanceof L.Layer)) {
				latlng = layer;
				layer = this;
			}
	
			if (layer instanceof L.FeatureGroup) {
				for (var id in this._layers) {
					layer = this._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
			}
	
			if (this._tooltip && this._map) {
	
				// set tooltip source to this layer
				this._tooltip._source = layer;
	
				// update the tooltip (content, layout, ect...)
				this._tooltip.update();
	
				// open the tooltip on the map
				this._map.openTooltip(this._tooltip, latlng);
	
				// Tooltip container may not be defined if not permanent and never
				// opened.
				if (this._tooltip.options.interactive && this._tooltip._container) {
					L.DomUtil.addClass(this._tooltip._container, 'leaflet-clickable');
					this.addInteractiveTarget(this._tooltip._container);
				}
			}
	
			return this;
		},
	
		// @method closeTooltip(): this
		// Closes the tooltip bound to this layer if it is open.
		closeTooltip: function () {
			if (this._tooltip) {
				this._tooltip._close();
				if (this._tooltip.options.interactive && this._tooltip._container) {
					L.DomUtil.removeClass(this._tooltip._container, 'leaflet-clickable');
					this.removeInteractiveTarget(this._tooltip._container);
				}
			}
			return this;
		},
	
		// @method toggleTooltip(): this
		// Opens or closes the tooltip bound to this layer depending on its current state.
		toggleTooltip: function (target) {
			if (this._tooltip) {
				if (this._tooltip._map) {
					this.closeTooltip();
				} else {
					this.openTooltip(target);
				}
			}
			return this;
		},
	
		// @method isTooltipOpen(): boolean
		// Returns `true` if the tooltip bound to this layer is currently open.
		isTooltipOpen: function () {
			return this._tooltip.isOpen();
		},
	
		// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
		// Sets the content of the tooltip bound to this layer.
		setTooltipContent: function (content) {
			if (this._tooltip) {
				this._tooltip.setContent(content);
			}
			return this;
		},
	
		// @method getTooltip(): Tooltip
		// Returns the tooltip bound to this layer.
		getTooltip: function () {
			return this._tooltip;
		},
	
		_openTooltip: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._tooltip || !this._map) {
				return;
			}
			this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
		},
	
		_moveTooltip: function (e) {
			var latlng = e.latlng, containerPoint, layerPoint;
			if (this._tooltip.options.sticky && e.originalEvent) {
				containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
				layerPoint = this._map.containerPointToLayerPoint(containerPoint);
				latlng = this._map.layerPointToLatLng(layerPoint);
			}
			this._tooltip.setLatLng(latlng);
		}
	});
	
	
	
	/*
	 * @class LayerGroup
	 * @aka L.LayerGroup
	 * @inherits Layer
	 *
	 * Used to group several layers and handle them as one. If you add it to the map,
	 * any layers added or removed from the group will be added/removed on the map as
	 * well. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.layerGroup([marker1, marker2])
	 * 	.addLayer(polyline)
	 * 	.addTo(map);
	 * ```
	 */
	
	L.LayerGroup = L.Layer.extend({
	
		initialize: function (layers) {
			this._layers = {};
	
			var i, len;
	
			if (layers) {
				for (i = 0, len = layers.length; i < len; i++) {
					this.addLayer(layers[i]);
				}
			}
		},
	
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the group.
		addLayer: function (layer) {
			var id = this.getLayerId(layer);
	
			this._layers[id] = layer;
	
			if (this._map) {
				this._map.addLayer(layer);
			}
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the group.
		// @alternative
		// @method removeLayer(id: Number): this
		// Removes the layer with the given internal ID from the group.
		removeLayer: function (layer) {
			var id = layer in this._layers ? layer : this.getLayerId(layer);
	
			if (this._map && this._layers[id]) {
				this._map.removeLayer(this._layers[id]);
			}
	
			delete this._layers[id];
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the group.
		hasLayer: function (layer) {
			return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
		},
	
		// @method clearLayers(): this
		// Removes all the layers from the group.
		clearLayers: function () {
			for (var i in this._layers) {
				this.removeLayer(this._layers[i]);
			}
			return this;
		},
	
		// @method invoke(methodName: String, …): this
		// Calls `methodName` on every layer contained in this group, passing any
		// additional parameters. Has no effect if the layers contained do not
		// implement `methodName`.
		invoke: function (methodName) {
			var args = Array.prototype.slice.call(arguments, 1),
			    i, layer;
	
			for (i in this._layers) {
				layer = this._layers[i];
	
				if (layer[methodName]) {
					layer[methodName].apply(layer, args);
				}
			}
	
			return this;
		},
	
		onAdd: function (map) {
			for (var i in this._layers) {
				map.addLayer(this._layers[i]);
			}
		},
	
		onRemove: function (map) {
			for (var i in this._layers) {
				map.removeLayer(this._layers[i]);
			}
		},
	
		// @method eachLayer(fn: Function, context?: Object): this
		// Iterates over the layers of the group, optionally specifying context of the iterator function.
		// ```js
		// group.eachLayer(function (layer) {
		// 	layer.bindPopup('Hello');
		// });
		// ```
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		// @method getLayer(id: Number): Layer
		// Returns the layer with the given internal ID.
		getLayer: function (id) {
			return this._layers[id];
		},
	
		// @method getLayers(): Layer[]
		// Returns an array of all the layers added to the group.
		getLayers: function () {
			var layers = [];
	
			for (var i in this._layers) {
				layers.push(this._layers[i]);
			}
			return layers;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Calls `setZIndex` on every layer contained in this group, passing the z-index.
		setZIndex: function (zIndex) {
			return this.invoke('setZIndex', zIndex);
		},
	
		// @method getLayerId(layer: Layer): Number
		// Returns the internal ID for a layer
		getLayerId: function (layer) {
			return L.stamp(layer);
		}
	});
	
	
	// @factory L.layerGroup(layers: Layer[])
	// Create a layer group, optionally given an initial set of layers.
	L.layerGroup = function (layers) {
		return new L.LayerGroup(layers);
	};
	
	
	
	/*
	 * @class FeatureGroup
	 * @aka L.FeatureGroup
	 * @inherits LayerGroup
	 *
	 * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
	 *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
	 *  * Events are propagated to the `FeatureGroup`, so if the group has an event
	 * handler, it will handle events from any of the layers. This includes mouse events
	 * and custom events.
	 *  * Has `layeradd` and `layerremove` events
	 *
	 * @example
	 *
	 * ```js
	 * L.featureGroup([marker1, marker2, polyline])
	 * 	.bindPopup('Hello world!')
	 * 	.on('click', function() { alert('Clicked on a member of the group!'); })
	 * 	.addTo(map);
	 * ```
	 */
	
	L.FeatureGroup = L.LayerGroup.extend({
	
		addLayer: function (layer) {
			if (this.hasLayer(layer)) {
				return this;
			}
	
			layer.addEventParent(this);
	
			L.LayerGroup.prototype.addLayer.call(this, layer);
	
			// @event layeradd: LayerEvent
			// Fired when a layer is added to this `FeatureGroup`
			return this.fire('layeradd', {layer: layer});
		},
	
		removeLayer: function (layer) {
			if (!this.hasLayer(layer)) {
				return this;
			}
			if (layer in this._layers) {
				layer = this._layers[layer];
			}
	
			layer.removeEventParent(this);
	
			L.LayerGroup.prototype.removeLayer.call(this, layer);
	
			// @event layerremove: LayerEvent
			// Fired when a layer is removed from this `FeatureGroup`
			return this.fire('layerremove', {layer: layer});
		},
	
		// @method setStyle(style: Path options): this
		// Sets the given path options to each layer of the group that has a `setStyle` method.
		setStyle: function (style) {
			return this.invoke('setStyle', style);
		},
	
		// @method bringToFront(): this
		// Brings the layer group to the top of all other layers
		bringToFront: function () {
			return this.invoke('bringToFront');
		},
	
		// @method bringToBack(): this
		// Brings the layer group to the top of all other layers
		bringToBack: function () {
			return this.invoke('bringToBack');
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
		getBounds: function () {
			var bounds = new L.LatLngBounds();
	
			for (var id in this._layers) {
				var layer = this._layers[id];
				bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
			}
			return bounds;
		}
	});
	
	// @factory L.featureGroup(layers: Layer[])
	// Create a feature group, optionally given an initial set of layers.
	L.featureGroup = function (layers) {
		return new L.FeatureGroup(layers);
	};
	
	
	
	/*
	 * @class Renderer
	 * @inherits Layer
	 * @aka L.Renderer
	 *
	 * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
	 * DOM container of the renderer, its bounds, and its zoom animation.
	 *
	 * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
	 * itself can be added or removed to the map. All paths use a renderer, which can
	 * be implicit (the map will decide the type of renderer and use it automatically)
	 * or explicit (using the [`renderer`](#path-renderer) option of the path).
	 *
	 * Do not use this class directly, use `SVG` and `Canvas` instead.
	 *
	 * @event update: Event
	 * Fired when the renderer updates its bounds, center and zoom, for example when
	 * its map has moved
	 */
	
	L.Renderer = L.Layer.extend({
	
		// @section
		// @aka Renderer options
		options: {
			// @option padding: Number = 0.1
			// How much to extend the clip area around the map view (relative to its size)
			// e.g. 0.1 would be 10% of map view in each direction
			padding: 0.1
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
			L.stamp(this);
			this._layers = this._layers || {};
		},
	
		onAdd: function () {
			if (!this._container) {
				this._initContainer(); // defined by renderer implementations
	
				if (this._zoomAnimated) {
					L.DomUtil.addClass(this._container, 'leaflet-zoom-animated');
				}
			}
	
			this.getPane().appendChild(this._container);
			this._update();
			this.on('update', this._updatePaths, this);
		},
	
		onRemove: function () {
			L.DomUtil.remove(this._container);
			this.off('update', this._updatePaths, this);
		},
	
		getEvents: function () {
			var events = {
				viewreset: this._reset,
				zoom: this._onZoom,
				moveend: this._update,
				zoomend: this._onZoomEnd
			};
			if (this._zoomAnimated) {
				events.zoomanim = this._onAnimZoom;
			}
			return events;
		},
	
		_onAnimZoom: function (ev) {
			this._updateTransform(ev.center, ev.zoom);
		},
	
		_onZoom: function () {
			this._updateTransform(this._map.getCenter(), this._map.getZoom());
		},
	
		_updateTransform: function (center, zoom) {
			var scale = this._map.getZoomScale(zoom, this._zoom),
			    position = L.DomUtil.getPosition(this._container),
			    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
			    currentCenterPoint = this._map.project(this._center, zoom),
			    destCenterPoint = this._map.project(center, zoom),
			    centerOffset = destCenterPoint.subtract(currentCenterPoint),
	
			    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);
	
			if (L.Browser.any3d) {
				L.DomUtil.setTransform(this._container, topLeftOffset, scale);
			} else {
				L.DomUtil.setPosition(this._container, topLeftOffset);
			}
		},
	
		_reset: function () {
			this._update();
			this._updateTransform(this._center, this._zoom);
	
			for (var id in this._layers) {
				this._layers[id]._reset();
			}
		},
	
		_onZoomEnd: function () {
			for (var id in this._layers) {
				this._layers[id]._project();
			}
		},
	
		_updatePaths: function () {
			for (var id in this._layers) {
				this._layers[id]._update();
			}
		},
	
		_update: function () {
			// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
			// Subclasses are responsible of firing the 'update' event.
			var p = this.options.padding,
			    size = this._map.getSize(),
			    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
	
			this._bounds = new L.Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
	
			this._center = this._map.getCenter();
			this._zoom = this._map.getZoom();
		}
	});
	
	
	L.Map.include({
		// @namespace Map; @method getRenderer(layer: Path): Renderer
		// Returns the instance of `Renderer` that should be used to render the given
		// `Path`. It will ensure that the `renderer` options of the map and paths
		// are respected, and that the renderers do exist on the map.
		getRenderer: function (layer) {
			// @namespace Path; @option renderer: Renderer
			// Use this specific instance of `Renderer` for this path. Takes
			// precedence over the map's [default renderer](#map-renderer).
			var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
	
			if (!renderer) {
				// @namespace Map; @option preferCanvas: Boolean = false
				// Whether `Path`s should be rendered on a `Canvas` renderer.
				// By default, all `Path`s are rendered in a `SVG` renderer.
				renderer = this._renderer = (this.options.preferCanvas && L.canvas()) || L.svg();
			}
	
			if (!this.hasLayer(renderer)) {
				this.addLayer(renderer);
			}
			return renderer;
		},
	
		_getPaneRenderer: function (name) {
			if (name === 'overlayPane' || name === undefined) {
				return false;
			}
	
			var renderer = this._paneRenderers[name];
			if (renderer === undefined) {
				renderer = (L.SVG && L.svg({pane: name})) || (L.Canvas && L.canvas({pane: name}));
				this._paneRenderers[name] = renderer;
			}
			return renderer;
		}
	});
	
	
	
	/*
	 * @class Path
	 * @aka L.Path
	 * @inherits Interactive layer
	 *
	 * An abstract class that contains options and constants shared between vector
	 * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
	 */
	
	L.Path = L.Layer.extend({
	
		// @section
		// @aka Path options
		options: {
			// @option stroke: Boolean = true
			// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
			stroke: true,
	
			// @option color: String = '#3388ff'
			// Stroke color
			color: '#3388ff',
	
			// @option weight: Number = 3
			// Stroke width in pixels
			weight: 3,
	
			// @option opacity: Number = 1.0
			// Stroke opacity
			opacity: 1,
	
			// @option lineCap: String= 'round'
			// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
			lineCap: 'round',
	
			// @option lineJoin: String = 'round'
			// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
			lineJoin: 'round',
	
			// @option dashArray: String = null
			// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashArray: null,
	
			// @option dashOffset: String = null
			// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashOffset: null,
	
			// @option fill: Boolean = depends
			// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
			fill: false,
	
			// @option fillColor: String = *
			// Fill color. Defaults to the value of the [`color`](#path-color) option
			fillColor: null,
	
			// @option fillOpacity: Number = 0.2
			// Fill opacity.
			fillOpacity: 0.2,
	
			// @option fillRule: String = 'evenodd'
			// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
			fillRule: 'evenodd',
	
			// className: '',
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true
		},
	
		beforeAdd: function (map) {
			// Renderer is set here because we need to call renderer.getEvents
			// before this.getEvents.
			this._renderer = map.getRenderer(this);
		},
	
		onAdd: function () {
			this._renderer._initPath(this);
			this._reset();
			this._renderer._addPath(this);
		},
	
		onRemove: function () {
			this._renderer._removePath(this);
		},
	
		// @method redraw(): this
		// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
		redraw: function () {
			if (this._map) {
				this._renderer._updatePath(this);
			}
			return this;
		},
	
		// @method setStyle(style: Path options): this
		// Changes the appearance of a Path based on the options in the `Path options` object.
		setStyle: function (style) {
			L.setOptions(this, style);
			if (this._renderer) {
				this._renderer._updateStyle(this);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all path layers.
		bringToFront: function () {
			if (this._renderer) {
				this._renderer._bringToFront(this);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all path layers.
		bringToBack: function () {
			if (this._renderer) {
				this._renderer._bringToBack(this);
			}
			return this;
		},
	
		getElement: function () {
			return this._path;
		},
	
		_reset: function () {
			// defined in children classes
			this._project();
			this._update();
		},
	
		_clickTolerance: function () {
			// used when doing hit detection for Canvas layers
			return (this.options.stroke ? this.options.weight / 2 : 0) + (L.Browser.touch ? 10 : 0);
		}
	});
	
	
	
	/*
	 * @namespace LineUtil
	 *
	 * Various utility functions for polyine points processing, used by Leaflet internally to make polylines lightning-fast.
	 */
	
	L.LineUtil = {
	
		// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
		// Improves rendering performance dramatically by lessening the number of points to draw.
	
		// @function simplify(points: Point[], tolerance: Number): Point[]
		// Dramatically reduces the number of points in a polyline while retaining
		// its shape and returns a new array of simplified points, using the
		// [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
		// Used for a huge performance boost when processing/displaying Leaflet polylines for
		// each zoom level and also reducing visual noise. tolerance affects the amount of
		// simplification (lesser value means higher quality but slower and with more points).
		// Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
		simplify: function (points, tolerance) {
			if (!tolerance || !points.length) {
				return points.slice();
			}
	
			var sqTolerance = tolerance * tolerance;
	
			// stage 1: vertex reduction
			points = this._reducePoints(points, sqTolerance);
	
			// stage 2: Douglas-Peucker simplification
			points = this._simplifyDP(points, sqTolerance);
	
			return points;
		},
	
		// @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
		// Returns the distance between point `p` and segment `p1` to `p2`.
		pointToSegmentDistance:  function (p, p1, p2) {
			return Math.sqrt(this._sqClosestPointOnSegment(p, p1, p2, true));
		},
	
		// @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
		// Returns the closest point from a point `p` on a segment `p1` to `p2`.
		closestPointOnSegment: function (p, p1, p2) {
			return this._sqClosestPointOnSegment(p, p1, p2);
		},
	
		// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
		_simplifyDP: function (points, sqTolerance) {
	
			var len = points.length,
			    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
			    markers = new ArrayConstructor(len);
	
			markers[0] = markers[len - 1] = 1;
	
			this._simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
			var i,
			    newPoints = [];
	
			for (i = 0; i < len; i++) {
				if (markers[i]) {
					newPoints.push(points[i]);
				}
			}
	
			return newPoints;
		},
	
		_simplifyDPStep: function (points, markers, sqTolerance, first, last) {
	
			var maxSqDist = 0,
			    index, i, sqDist;
	
			for (i = first + 1; i <= last - 1; i++) {
				sqDist = this._sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
				if (sqDist > maxSqDist) {
					index = i;
					maxSqDist = sqDist;
				}
			}
	
			if (maxSqDist > sqTolerance) {
				markers[index] = 1;
	
				this._simplifyDPStep(points, markers, sqTolerance, first, index);
				this._simplifyDPStep(points, markers, sqTolerance, index, last);
			}
		},
	
		// reduce points that are too close to each other to a single point
		_reducePoints: function (points, sqTolerance) {
			var reducedPoints = [points[0]];
	
			for (var i = 1, prev = 0, len = points.length; i < len; i++) {
				if (this._sqDist(points[i], points[prev]) > sqTolerance) {
					reducedPoints.push(points[i]);
					prev = i;
				}
			}
			if (prev < len - 1) {
				reducedPoints.push(points[len - 1]);
			}
			return reducedPoints;
		},
	
	
		// @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
		// Clips the segment a to b by rectangular bounds with the
		// [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
		// (modifying the segment points directly!). Used by Leaflet to only show polyline
		// points that are on the screen or near, increasing performance.
		clipSegment: function (a, b, bounds, useLastCode, round) {
			var codeA = useLastCode ? this._lastCode : this._getBitCode(a, bounds),
			    codeB = this._getBitCode(b, bounds),
	
			    codeOut, p, newCode;
	
			// save 2nd code to avoid calculating it on the next segment
			this._lastCode = codeB;
	
			while (true) {
				// if a,b is inside the clip window (trivial accept)
				if (!(codeA | codeB)) {
					return [a, b];
				}
	
				// if a,b is outside the clip window (trivial reject)
				if (codeA & codeB) {
					return false;
				}
	
				// other cases
				codeOut = codeA || codeB;
				p = this._getEdgeIntersection(a, b, codeOut, bounds, round);
				newCode = this._getBitCode(p, bounds);
	
				if (codeOut === codeA) {
					a = p;
					codeA = newCode;
				} else {
					b = p;
					codeB = newCode;
				}
			}
		},
	
		_getEdgeIntersection: function (a, b, code, bounds, round) {
			var dx = b.x - a.x,
			    dy = b.y - a.y,
			    min = bounds.min,
			    max = bounds.max,
			    x, y;
	
			if (code & 8) { // top
				x = a.x + dx * (max.y - a.y) / dy;
				y = max.y;
	
			} else if (code & 4) { // bottom
				x = a.x + dx * (min.y - a.y) / dy;
				y = min.y;
	
			} else if (code & 2) { // right
				x = max.x;
				y = a.y + dy * (max.x - a.x) / dx;
	
			} else if (code & 1) { // left
				x = min.x;
				y = a.y + dy * (min.x - a.x) / dx;
			}
	
			return new L.Point(x, y, round);
		},
	
		_getBitCode: function (p, bounds) {
			var code = 0;
	
			if (p.x < bounds.min.x) { // left
				code |= 1;
			} else if (p.x > bounds.max.x) { // right
				code |= 2;
			}
	
			if (p.y < bounds.min.y) { // bottom
				code |= 4;
			} else if (p.y > bounds.max.y) { // top
				code |= 8;
			}
	
			return code;
		},
	
		// square distance (to avoid unnecessary Math.sqrt calls)
		_sqDist: function (p1, p2) {
			var dx = p2.x - p1.x,
			    dy = p2.y - p1.y;
			return dx * dx + dy * dy;
		},
	
		// return closest point on segment or distance to that point
		_sqClosestPointOnSegment: function (p, p1, p2, sqDist) {
			var x = p1.x,
			    y = p1.y,
			    dx = p2.x - x,
			    dy = p2.y - y,
			    dot = dx * dx + dy * dy,
			    t;
	
			if (dot > 0) {
				t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
				if (t > 1) {
					x = p2.x;
					y = p2.y;
				} else if (t > 0) {
					x += dx * t;
					y += dy * t;
				}
			}
	
			dx = p.x - x;
			dy = p.y - y;
	
			return sqDist ? dx * dx + dy * dy : new L.Point(x, y);
		}
	};
	
	
	
	/*
	 * @class Polyline
	 * @aka L.Polyline
	 * @inherits Path
	 *
	 * A class for drawing polyline overlays on a map. Extends `Path`.
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polyline from an array of LatLng points
	 * var latlngs = [
	 * 	[45.51, -122.68],
	 * 	[37.77, -122.43],
	 * 	[34.04, -118.2]
	 * ];
	 *
	 * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polyline
	 * map.fitBounds(polyline.getBounds());
	 * ```
	 *
	 * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
	 *
	 * ```js
	 * // create a red polyline from an array of arrays of LatLng points
	 * var latlngs = [
	 * 	[[45.51, -122.68],
	 * 	 [37.77, -122.43],
	 * 	 [34.04, -118.2]],
	 * 	[[40.78, -73.91],
	 * 	 [41.83, -87.62],
	 * 	 [32.76, -96.72]]
	 * ];
	 * ```
	 */
	
	L.Polyline = L.Path.extend({
	
		// @section
		// @aka Polyline options
		options: {
			// @option smoothFactor: Number = 1.0
			// How much to simplify the polyline on each zoom level. More means
			// better performance and smoother look, and less means more accurate representation.
			smoothFactor: 1.0,
	
			// @option noClip: Boolean = false
			// Disable polyline clipping.
			noClip: false
		},
	
		initialize: function (latlngs, options) {
			L.setOptions(this, options);
			this._setLatLngs(latlngs);
		},
	
		// @method getLatLngs(): LatLng[]
		// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
		getLatLngs: function () {
			return this._latlngs;
		},
	
		// @method setLatLngs(latlngs: LatLng[]): this
		// Replaces all the points in the polyline with the given array of geographical points.
		setLatLngs: function (latlngs) {
			this._setLatLngs(latlngs);
			return this.redraw();
		},
	
		// @method isEmpty(): Boolean
		// Returns `true` if the Polyline has no LatLngs.
		isEmpty: function () {
			return !this._latlngs.length;
		},
	
		closestLayerPoint: function (p) {
			var minDistance = Infinity,
			    minPoint = null,
			    closest = L.LineUtil._sqClosestPointOnSegment,
			    p1, p2;
	
			for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
				var points = this._parts[j];
	
				for (var i = 1, len = points.length; i < len; i++) {
					p1 = points[i - 1];
					p2 = points[i];
	
					var sqDist = closest(p, p1, p2, true);
	
					if (sqDist < minDistance) {
						minDistance = sqDist;
						minPoint = closest(p, p1, p2);
					}
				}
			}
			if (minPoint) {
				minPoint.distance = Math.sqrt(minDistance);
			}
			return minPoint;
		},
	
		// @method getCenter(): LatLng
		// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, halfDist, segDist, dist, p1, p2, ratio,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polyline centroid algorithm; only uses the first ring if there are multiple
	
			for (i = 0, halfDist = 0; i < len - 1; i++) {
				halfDist += points[i].distanceTo(points[i + 1]) / 2;
			}
	
			// The line is so small in the current view that all points are on the same pixel.
			if (halfDist === 0) {
				return this._map.layerPointToLatLng(points[0]);
			}
	
			for (i = 0, dist = 0; i < len - 1; i++) {
				p1 = points[i];
				p2 = points[i + 1];
				segDist = p1.distanceTo(p2);
				dist += segDist;
	
				if (dist > halfDist) {
					ratio = (dist - halfDist) / segDist;
					return this._map.layerPointToLatLng([
						p2.x - ratio * (p2.x - p1.x),
						p2.y - ratio * (p2.y - p1.y)
					]);
				}
			}
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			return this._bounds;
		},
	
		// @method addLatLng(latlng: LatLng, latlngs? LatLng[]): this
		// Adds a given point to the polyline. By default, adds to the first ring of
		// the polyline in case of a multi-polyline, but can be overridden by passing
		// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
		addLatLng: function (latlng, latlngs) {
			latlngs = latlngs || this._defaultShape();
			latlng = L.latLng(latlng);
			latlngs.push(latlng);
			this._bounds.extend(latlng);
			return this.redraw();
		},
	
		_setLatLngs: function (latlngs) {
			this._bounds = new L.LatLngBounds();
			this._latlngs = this._convertLatLngs(latlngs);
		},
	
		_defaultShape: function () {
			return L.Polyline._flat(this._latlngs) ? this._latlngs : this._latlngs[0];
		},
	
		// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
		_convertLatLngs: function (latlngs) {
			var result = [],
			    flat = L.Polyline._flat(latlngs);
	
			for (var i = 0, len = latlngs.length; i < len; i++) {
				if (flat) {
					result[i] = L.latLng(latlngs[i]);
					this._bounds.extend(result[i]);
				} else {
					result[i] = this._convertLatLngs(latlngs[i]);
				}
			}
	
			return result;
		},
	
		_project: function () {
			var pxBounds = new L.Bounds();
			this._rings = [];
			this._projectLatlngs(this._latlngs, this._rings, pxBounds);
	
			var w = this._clickTolerance(),
			    p = new L.Point(w, w);
	
			if (this._bounds.isValid() && pxBounds.isValid()) {
				pxBounds.min._subtract(p);
				pxBounds.max._add(p);
				this._pxBounds = pxBounds;
			}
		},
	
		// recursively turns latlngs into a set of rings with projected coordinates
		_projectLatlngs: function (latlngs, result, projectedBounds) {
			var flat = latlngs[0] instanceof L.LatLng,
			    len = latlngs.length,
			    i, ring;
	
			if (flat) {
				ring = [];
				for (i = 0; i < len; i++) {
					ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
					projectedBounds.extend(ring[i]);
				}
				result.push(ring);
			} else {
				for (i = 0; i < len; i++) {
					this._projectLatlngs(latlngs[i], result, projectedBounds);
				}
			}
		},
	
		// clip polyline by renderer bounds so that we have less to render for performance
		_clipPoints: function () {
			var bounds = this._renderer._bounds;
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			var parts = this._parts,
			    i, j, k, len, len2, segment, points;
	
			for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
				points = this._rings[i];
	
				for (j = 0, len2 = points.length; j < len2 - 1; j++) {
					segment = L.LineUtil.clipSegment(points[j], points[j + 1], bounds, j, true);
	
					if (!segment) { continue; }
	
					parts[k] = parts[k] || [];
					parts[k].push(segment[0]);
	
					// if segment goes out of screen, or it's the last one, it's the end of the line part
					if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
						parts[k].push(segment[1]);
						k++;
					}
				}
			}
		},
	
		// simplify each clipped part of the polyline for performance
		_simplifyPoints: function () {
			var parts = this._parts,
			    tolerance = this.options.smoothFactor;
	
			for (var i = 0, len = parts.length; i < len; i++) {
				parts[i] = L.LineUtil.simplify(parts[i], tolerance);
			}
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			this._clipPoints();
			this._simplifyPoints();
			this._updatePath();
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this);
		}
	});
	
	// @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
	// Instantiates a polyline object given an array of geographical points and
	// optionally an options object. You can create a `Polyline` object with
	// multiple separate lines (`MultiPolyline`) by passing an array of arrays
	// of geographic points.
	L.polyline = function (latlngs, options) {
		return new L.Polyline(latlngs, options);
	};
	
	L.Polyline._flat = function (latlngs) {
		// true if it's a flat array of latlngs; false if nested
		return !L.Util.isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
	};
	
	
	
	/*
	 * @namespace PolyUtil
	 * Various utility functions for polygon geometries.
	 */
	
	L.PolyUtil = {};
	
	/* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
	 * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgeman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
	 * Used by Leaflet to only show polygon points that are on the screen or near, increasing
	 * performance. Note that polygon points needs different algorithm for clipping
	 * than polyline, so there's a seperate method for it.
	 */
	L.PolyUtil.clipPolygon = function (points, bounds, round) {
		var clippedPoints,
		    edges = [1, 4, 2, 8],
		    i, j, k,
		    a, b,
		    len, edge, p,
		    lu = L.LineUtil;
	
		for (i = 0, len = points.length; i < len; i++) {
			points[i]._code = lu._getBitCode(points[i], bounds);
		}
	
		// for each edge (left, bottom, right, top)
		for (k = 0; k < 4; k++) {
			edge = edges[k];
			clippedPoints = [];
	
			for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
				a = points[i];
				b = points[j];
	
				// if a is inside the clip window
				if (!(a._code & edge)) {
					// if b is outside the clip window (a->b goes out of screen)
					if (b._code & edge) {
						p = lu._getEdgeIntersection(b, a, edge, bounds, round);
						p._code = lu._getBitCode(p, bounds);
						clippedPoints.push(p);
					}
					clippedPoints.push(a);
	
				// else if b is inside the clip window (a->b enters the screen)
				} else if (!(b._code & edge)) {
					p = lu._getEdgeIntersection(b, a, edge, bounds, round);
					p._code = lu._getBitCode(p, bounds);
					clippedPoints.push(p);
				}
			}
			points = clippedPoints;
		}
	
		return points;
	};
	
	
	
	/*
	 * @class Polygon
	 * @aka L.Polygon
	 * @inherits Polyline
	 *
	 * A class for drawing polygon overlays on a map. Extends `Polyline`.
	 *
	 * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
	 *
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polygon from an array of LatLng points
	 * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
	 *
	 * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polygon
	 * map.fitBounds(polygon.getBounds());
	 * ```
	 *
	 * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
	 *
	 * ```js
	 * var latlngs = [
	 *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 * ];
	 * ```
	 *
	 * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
	 *
	 * ```js
	 * var latlngs = [
	 *   [ // first polygon
	 *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 *   ],
	 *   [ // second polygon
	 *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
	 *   ]
	 * ];
	 * ```
	 */
	
	L.Polygon = L.Polyline.extend({
	
		options: {
			fill: true
		},
	
		isEmpty: function () {
			return !this._latlngs.length || !this._latlngs[0].length;
		},
	
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, j, p1, p2, f, area, x, y, center,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polygon centroid algorithm; only uses the first ring if there are multiple
	
			area = x = y = 0;
	
			for (i = 0, j = len - 1; i < len; j = i++) {
				p1 = points[i];
				p2 = points[j];
	
				f = p1.y * p2.x - p2.y * p1.x;
				x += (p1.x + p2.x) * f;
				y += (p1.y + p2.y) * f;
				area += f * 3;
			}
	
			if (area === 0) {
				// Polygon is so small that all points are on same pixel.
				center = points[0];
			} else {
				center = [x / area, y / area];
			}
			return this._map.layerPointToLatLng(center);
		},
	
		_convertLatLngs: function (latlngs) {
			var result = L.Polyline.prototype._convertLatLngs.call(this, latlngs),
			    len = result.length;
	
			// remove last point if it equals first one
			if (len >= 2 && result[0] instanceof L.LatLng && result[0].equals(result[len - 1])) {
				result.pop();
			}
			return result;
		},
	
		_setLatLngs: function (latlngs) {
			L.Polyline.prototype._setLatLngs.call(this, latlngs);
			if (L.Polyline._flat(this._latlngs)) {
				this._latlngs = [this._latlngs];
			}
		},
	
		_defaultShape: function () {
			return L.Polyline._flat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
		},
	
		_clipPoints: function () {
			// polygons need a different clipping algorithm so we redefine that
	
			var bounds = this._renderer._bounds,
			    w = this.options.weight,
			    p = new L.Point(w, w);
	
			// increase clip padding by stroke width to avoid stroke on clip edges
			bounds = new L.Bounds(bounds.min.subtract(p), bounds.max.add(p));
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
				clipped = L.PolyUtil.clipPolygon(this._rings[i], bounds, true);
				if (clipped.length) {
					this._parts.push(clipped);
				}
			}
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this, true);
		}
	});
	
	
	// @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
	L.polygon = function (latlngs, options) {
		return new L.Polygon(latlngs, options);
	};
	
	
	
	/*
	 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	 */
	
	/*
	 * @class Rectangle
	 * @aka L.Retangle
	 * @inherits Polygon
	 *
	 * A class for drawing rectangle overlays on a map. Extends `Polygon`.
	 *
	 * @example
	 *
	 * ```js
	 * // define rectangle geographical bounds
	 * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	 *
	 * // create an orange rectangle
	 * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
	 *
	 * // zoom the map to the rectangle bounds
	 * map.fitBounds(bounds);
	 * ```
	 *
	 */
	
	
	L.Rectangle = L.Polygon.extend({
		initialize: function (latLngBounds, options) {
			L.Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
		},
	
		// @method setBounds(latLngBounds: LatLngBounds): this
		// Redraws the rectangle with the passed bounds.
		setBounds: function (latLngBounds) {
			return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
		},
	
		_boundsToLatLngs: function (latLngBounds) {
			latLngBounds = L.latLngBounds(latLngBounds);
			return [
				latLngBounds.getSouthWest(),
				latLngBounds.getNorthWest(),
				latLngBounds.getNorthEast(),
				latLngBounds.getSouthEast()
			];
		}
	});
	
	
	// @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
	L.rectangle = function (latLngBounds, options) {
		return new L.Rectangle(latLngBounds, options);
	};
	
	
	
	/*
	 * @class CircleMarker
	 * @aka L.CircleMarker
	 * @inherits Path
	 *
	 * A circle of a fixed size with radius specified in pixels. Extends `Path`.
	 */
	
	L.CircleMarker = L.Path.extend({
	
		// @section
		// @aka CircleMarker options
		options: {
			fill: true,
	
			// @option radius: Number = 10
			// Radius of the circle marker, in pixels
			radius: 10
		},
	
		initialize: function (latlng, options) {
			L.setOptions(this, options);
			this._latlng = L.latLng(latlng);
			this._radius = this.options.radius;
		},
	
		// @method setLatLng(latLng: LatLng): this
		// Sets the position of a circle marker to a new location.
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
			this.redraw();
			return this.fire('move', {latlng: this._latlng});
		},
	
		// @method getLatLng(): LatLng
		// Returns the current geographical position of the circle marker
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle marker. Units are in pixels.
		setRadius: function (radius) {
			this.options.radius = this._radius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of the circle
		getRadius: function () {
			return this._radius;
		},
	
		setStyle : function (options) {
			var radius = options && options.radius || this._radius;
			L.Path.prototype.setStyle.call(this, options);
			this.setRadius(radius);
			return this;
		},
	
		_project: function () {
			this._point = this._map.latLngToLayerPoint(this._latlng);
			this._updateBounds();
		},
	
		_updateBounds: function () {
			var r = this._radius,
			    r2 = this._radiusY || r,
			    w = this._clickTolerance(),
			    p = [r + w, r2 + w];
			this._pxBounds = new L.Bounds(this._point.subtract(p), this._point.add(p));
		},
	
		_update: function () {
			if (this._map) {
				this._updatePath();
			}
		},
	
		_updatePath: function () {
			this._renderer._updateCircle(this);
		},
	
		_empty: function () {
			return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
		}
	});
	
	
	// @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
	// Instantiates a circle marker object given a geographical point, and an optional options object.
	L.circleMarker = function (latlng, options) {
		return new L.CircleMarker(latlng, options);
	};
	
	
	
	/*
	 * @class Circle
	 * @aka L.Circle
	 * @inherits CircleMarker
	 *
	 * A class for drawing circle overlays on a map. Extends `CircleMarker`.
	 *
	 * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
	 *
	 * @example
	 *
	 * ```js
	 * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
	 * ```
	 */
	
	L.Circle = L.CircleMarker.extend({
	
		initialize: function (latlng, options, legacyOptions) {
			if (typeof options === 'number') {
				// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
				options = L.extend({}, legacyOptions, {radius: options});
			}
			L.setOptions(this, options);
			this._latlng = L.latLng(latlng);
	
			if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }
	
			// @section
			// @aka Circle options
			// @option radius: Number; Radius of the circle, in meters.
			this._mRadius = this.options.radius;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle. Units are in meters.
		setRadius: function (radius) {
			this._mRadius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of a circle. Units are in meters.
		getRadius: function () {
			return this._mRadius;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			var half = [this._radius, this._radiusY || this._radius];
	
			return new L.LatLngBounds(
				this._map.layerPointToLatLng(this._point.subtract(half)),
				this._map.layerPointToLatLng(this._point.add(half)));
		},
	
		setStyle: L.Path.prototype.setStyle,
	
		_project: function () {
	
			var lng = this._latlng.lng,
			    lat = this._latlng.lat,
			    map = this._map,
			    crs = map.options.crs;
	
			if (crs.distance === L.CRS.Earth.distance) {
				var d = Math.PI / 180,
				    latR = (this._mRadius / L.CRS.Earth.R) / d,
				    top = map.project([lat + latR, lng]),
				    bottom = map.project([lat - latR, lng]),
				    p = top.add(bottom).divideBy(2),
				    lat2 = map.unproject(p).lat,
				    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
				            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
	
				if (isNaN(lngR) || lngR === 0) {
					lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
				}
	
				this._point = p.subtract(map.getPixelOrigin());
				this._radius = isNaN(lngR) ? 0 : Math.max(Math.round(p.x - map.project([lat2, lng - lngR]).x), 1);
				this._radiusY = Math.max(Math.round(p.y - top.y), 1);
	
			} else {
				var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
	
				this._point = map.latLngToLayerPoint(this._latlng);
				this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
			}
	
			this._updateBounds();
		}
	});
	
	// @factory L.circle(latlng: LatLng, options?: Circle options)
	// Instantiates a circle object given a geographical point, and an options object
	// which contains the circle radius.
	// @alternative
	// @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
	// Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
	// Do not use in new applications or plugins.
	L.circle = function (latlng, options, legacyOptions) {
		return new L.Circle(latlng, options, legacyOptions);
	};
	
	
	
	/*
	 * @class SVG
	 * @inherits Renderer
	 * @aka L.SVG
	 *
	 * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
	 * available in all web browsers, notably Android 2.x and 3.x.
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support
	 * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
	 * (a now deprecated technology), and the SVG renderer will fall back to VML in
	 * this case.
	 *
	 * @example
	 *
	 * Use SVG by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.svg()
	 * });
	 * ```
	 *
	 * Use a SVG renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.svg({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	L.SVG = L.Renderer.extend({
	
		getEvents: function () {
			var events = L.Renderer.prototype.getEvents.call(this);
			events.zoomstart = this._onZoomStart;
			return events;
		},
	
		_initContainer: function () {
			this._container = L.SVG.create('svg');
	
			// makes it possible to click through svg root; we'll reset it back in individual paths
			this._container.setAttribute('pointer-events', 'none');
	
			this._rootGroup = L.SVG.create('g');
			this._container.appendChild(this._rootGroup);
		},
	
		_onZoomStart: function () {
			// Drag-then-pinch interactions might mess up the center and zoom.
			// In this case, the easiest way to prevent this is re-do the renderer
			//   bounds and padding when the zooming starts.
			this._update();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			L.Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    size = b.getSize(),
			    container = this._container;
	
			// set size of svg-container if changed
			if (!this._svgSize || !this._svgSize.equals(size)) {
				this._svgSize = size;
				container.setAttribute('width', size.x);
				container.setAttribute('height', size.y);
			}
	
			// movement: update container viewBox so that we don't have to change coordinates of individual layers
			L.DomUtil.setPosition(container, b.min);
			container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));
	
			this.fire('update');
		},
	
		// methods below are called by vector layers implementations
	
		_initPath: function (layer) {
			var path = layer._path = L.SVG.create('path');
	
			// @namespace Path
			// @option className: String = null
			// Custom class name set on an element. Only for SVG renderer.
			if (layer.options.className) {
				L.DomUtil.addClass(path, layer.options.className);
			}
	
			if (layer.options.interactive) {
				L.DomUtil.addClass(path, 'leaflet-interactive');
			}
	
			this._updateStyle(layer);
			this._layers[L.stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			this._rootGroup.appendChild(layer._path);
			layer.addInteractiveTarget(layer._path);
		},
	
		_removePath: function (layer) {
			L.DomUtil.remove(layer._path);
			layer.removeInteractiveTarget(layer._path);
			delete this._layers[L.stamp(layer)];
		},
	
		_updatePath: function (layer) {
			layer._project();
			layer._update();
		},
	
		_updateStyle: function (layer) {
			var path = layer._path,
			    options = layer.options;
	
			if (!path) { return; }
	
			if (options.stroke) {
				path.setAttribute('stroke', options.color);
				path.setAttribute('stroke-opacity', options.opacity);
				path.setAttribute('stroke-width', options.weight);
				path.setAttribute('stroke-linecap', options.lineCap);
				path.setAttribute('stroke-linejoin', options.lineJoin);
	
				if (options.dashArray) {
					path.setAttribute('stroke-dasharray', options.dashArray);
				} else {
					path.removeAttribute('stroke-dasharray');
				}
	
				if (options.dashOffset) {
					path.setAttribute('stroke-dashoffset', options.dashOffset);
				} else {
					path.removeAttribute('stroke-dashoffset');
				}
			} else {
				path.setAttribute('stroke', 'none');
			}
	
			if (options.fill) {
				path.setAttribute('fill', options.fillColor || options.color);
				path.setAttribute('fill-opacity', options.fillOpacity);
				path.setAttribute('fill-rule', options.fillRule || 'evenodd');
			} else {
				path.setAttribute('fill', 'none');
			}
		},
	
		_updatePoly: function (layer, closed) {
			this._setPath(layer, L.SVG.pointsToPath(layer._parts, closed));
		},
	
		_updateCircle: function (layer) {
			var p = layer._point,
			    r = layer._radius,
			    r2 = layer._radiusY || r,
			    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
	
			// drawing a circle with two half-arcs
			var d = layer._empty() ? 'M0 0' :
					'M' + (p.x - r) + ',' + p.y +
					arc + (r * 2) + ',0 ' +
					arc + (-r * 2) + ',0 ';
	
			this._setPath(layer, d);
		},
	
		_setPath: function (layer, path) {
			layer._path.setAttribute('d', path);
		},
	
		// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
		_bringToFront: function (layer) {
			L.DomUtil.toFront(layer._path);
		},
	
		_bringToBack: function (layer) {
			L.DomUtil.toBack(layer._path);
		}
	});
	
	
	// @namespace SVG; @section
	// There are several static functions which can be called without instantiating L.SVG:
	L.extend(L.SVG, {
		// @function create(name: String): SVGElement
		// Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
		// corresponding to the class name passed. For example, using 'line' will return
		// an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
		create: function (name) {
			return document.createElementNS('http://www.w3.org/2000/svg', name);
		},
	
		// @function pointsToPath(rings: Point[], closed: Boolean): String
		// Generates a SVG path string for multiple rings, with each ring turning
		// into "M..L..L.." instructions
		pointsToPath: function (rings, closed) {
			var str = '',
			    i, j, len, len2, points, p;
	
			for (i = 0, len = rings.length; i < len; i++) {
				points = rings[i];
	
				for (j = 0, len2 = points.length; j < len2; j++) {
					p = points[j];
					str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
				}
	
				// closes the ring for polygons; "x" is VML syntax
				str += closed ? (L.Browser.svg ? 'z' : 'x') : '';
			}
	
			// SVG complains about empty path strings
			return str || 'M0 0';
		}
	});
	
	// @namespace Browser; @property svg: Boolean
	// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
	L.Browser.svg = !!(document.createElementNS && L.SVG.create('svg').createSVGRect);
	
	
	// @namespace SVG
	// @factory L.svg(options?: Renderer options)
	// Creates a SVG renderer with the given options.
	L.svg = function (options) {
		return L.Browser.svg || L.Browser.vml ? new L.SVG(options) : null;
	};
	
	
	
	/*
	 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	 */
	
	/*
	 * @class SVG
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language), and the SVG renderer will fall back to VML in this case.
	 *
	 * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
	 * with old versions of Internet Explorer.
	 */
	
	// @namespace Browser; @property vml: Boolean
	// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
	L.Browser.vml = !L.Browser.svg && (function () {
		try {
			var div = document.createElement('div');
			div.innerHTML = '<v:shape adj="1"/>';
	
			var shape = div.firstChild;
			shape.style.behavior = 'url(#default#VML)';
	
			return shape && (typeof shape.adj === 'object');
	
		} catch (e) {
			return false;
		}
	}());
	
	// redefine some SVG methods to handle VML syntax which is similar but with some differences
	L.SVG.include(!L.Browser.vml ? {} : {
	
		_initContainer: function () {
			this._container = L.DomUtil.create('div', 'leaflet-vml-container');
		},
	
		_update: function () {
			if (this._map._animatingZoom) { return; }
			L.Renderer.prototype._update.call(this);
			this.fire('update');
		},
	
		_initPath: function (layer) {
			var container = layer._container = L.SVG.create('shape');
	
			L.DomUtil.addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
	
			container.coordsize = '1 1';
	
			layer._path = L.SVG.create('path');
			container.appendChild(layer._path);
	
			this._updateStyle(layer);
			this._layers[L.stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			var container = layer._container;
			this._container.appendChild(container);
	
			if (layer.options.interactive) {
				layer.addInteractiveTarget(container);
			}
		},
	
		_removePath: function (layer) {
			var container = layer._container;
			L.DomUtil.remove(container);
			layer.removeInteractiveTarget(container);
			delete this._layers[L.stamp(layer)];
		},
	
		_updateStyle: function (layer) {
			var stroke = layer._stroke,
			    fill = layer._fill,
			    options = layer.options,
			    container = layer._container;
	
			container.stroked = !!options.stroke;
			container.filled = !!options.fill;
	
			if (options.stroke) {
				if (!stroke) {
					stroke = layer._stroke = L.SVG.create('stroke');
				}
				container.appendChild(stroke);
				stroke.weight = options.weight + 'px';
				stroke.color = options.color;
				stroke.opacity = options.opacity;
	
				if (options.dashArray) {
					stroke.dashStyle = L.Util.isArray(options.dashArray) ?
					    options.dashArray.join(' ') :
					    options.dashArray.replace(/( *, *)/g, ' ');
				} else {
					stroke.dashStyle = '';
				}
				stroke.endcap = options.lineCap.replace('butt', 'flat');
				stroke.joinstyle = options.lineJoin;
	
			} else if (stroke) {
				container.removeChild(stroke);
				layer._stroke = null;
			}
	
			if (options.fill) {
				if (!fill) {
					fill = layer._fill = L.SVG.create('fill');
				}
				container.appendChild(fill);
				fill.color = options.fillColor || options.color;
				fill.opacity = options.fillOpacity;
	
			} else if (fill) {
				container.removeChild(fill);
				layer._fill = null;
			}
		},
	
		_updateCircle: function (layer) {
			var p = layer._point.round(),
			    r = Math.round(layer._radius),
			    r2 = Math.round(layer._radiusY || r);
	
			this._setPath(layer, layer._empty() ? 'M0 0' :
					'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
		},
	
		_setPath: function (layer, path) {
			layer._path.v = path;
		},
	
		_bringToFront: function (layer) {
			L.DomUtil.toFront(layer._container);
		},
	
		_bringToBack: function (layer) {
			L.DomUtil.toBack(layer._container);
		}
	});
	
	if (L.Browser.vml) {
		L.SVG.create = (function () {
			try {
				document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
				return function (name) {
					return document.createElement('<lvml:' + name + ' class="lvml">');
				};
			} catch (e) {
				return function (name) {
					return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
				};
			}
		})();
	}
	
	
	
	/*
	 * @class Canvas
	 * @inherits Renderer
	 * @aka L.Canvas
	 *
	 * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
	 * available in all web browsers, notably IE8, and overlapping geometries might
	 * not display properly in some edge cases.
	 *
	 * @example
	 *
	 * Use Canvas by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.canvas()
	 * });
	 * ```
	 *
	 * Use a Canvas renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.canvas({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	L.Canvas = L.Renderer.extend({
		getEvents: function () {
			var events = L.Renderer.prototype.getEvents.call(this);
			events.viewprereset = this._onViewPreReset;
			return events;
		},
	
		_onViewPreReset: function () {
			// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
			this._postponeUpdatePaths = true;
		},
	
		onAdd: function () {
			L.Renderer.prototype.onAdd.call(this);
	
			// Redraw vectors since canvas is cleared upon removal,
			// in case of removing the renderer itself from the map.
			this._draw();
		},
	
		_initContainer: function () {
			var container = this._container = document.createElement('canvas');
	
			L.DomEvent
				.on(container, 'mousemove', L.Util.throttle(this._onMouseMove, 32, this), this)
				.on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this)
				.on(container, 'mouseout', this._handleMouseOut, this);
	
			this._ctx = container.getContext('2d');
		},
	
		_updatePaths: function () {
			if (this._postponeUpdatePaths) { return; }
	
			var layer;
			this._redrawBounds = null;
			for (var id in this._layers) {
				layer = this._layers[id];
				layer._update();
			}
			this._redraw();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			this._drawnLayers = {};
	
			L.Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    container = this._container,
			    size = b.getSize(),
			    m = L.Browser.retina ? 2 : 1;
	
			L.DomUtil.setPosition(container, b.min);
	
			// set canvas size (also clearing it); use double size on retina
			container.width = m * size.x;
			container.height = m * size.y;
			container.style.width = size.x + 'px';
			container.style.height = size.y + 'px';
	
			if (L.Browser.retina) {
				this._ctx.scale(2, 2);
			}
	
			// translate so we use the same path coordinates after canvas element moves
			this._ctx.translate(-b.min.x, -b.min.y);
	
			// Tell paths to redraw themselves
			this.fire('update');
		},
	
		_reset: function () {
			L.Renderer.prototype._reset.call(this);
	
			if (this._postponeUpdatePaths) {
				this._postponeUpdatePaths = false;
				this._updatePaths();
			}
		},
	
		_initPath: function (layer) {
			this._updateDashArray(layer);
			this._layers[L.stamp(layer)] = layer;
	
			var order = layer._order = {
				layer: layer,
				prev: this._drawLast,
				next: null
			};
			if (this._drawLast) { this._drawLast.next = order; }
			this._drawLast = order;
			this._drawFirst = this._drawFirst || this._drawLast;
		},
	
		_addPath: function (layer) {
			this._requestRedraw(layer);
		},
	
		_removePath: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				this._drawLast = prev;
			}
			if (prev) {
				prev.next = next;
			} else {
				this._drawFirst = next;
			}
	
			delete layer._order;
	
			delete this._layers[L.stamp(layer)];
	
			this._requestRedraw(layer);
		},
	
		_updatePath: function (layer) {
			// Redraw the union of the layer's old pixel
			// bounds and the new pixel bounds.
			this._extendRedrawBounds(layer);
			layer._project();
			layer._update();
			// The redraw will extend the redraw bounds
			// with the new pixel bounds.
			this._requestRedraw(layer);
		},
	
		_updateStyle: function (layer) {
			this._updateDashArray(layer);
			this._requestRedraw(layer);
		},
	
		_updateDashArray: function (layer) {
			if (layer.options.dashArray) {
				var parts = layer.options.dashArray.split(','),
				    dashArray = [],
				    i;
				for (i = 0; i < parts.length; i++) {
					dashArray.push(Number(parts[i]));
				}
				layer.options._dashArray = dashArray;
			}
		},
	
		_requestRedraw: function (layer) {
			if (!this._map) { return; }
	
			this._extendRedrawBounds(layer);
			this._redrawRequest = this._redrawRequest || L.Util.requestAnimFrame(this._redraw, this);
		},
	
		_extendRedrawBounds: function (layer) {
			var padding = (layer.options.weight || 0) + 1;
			this._redrawBounds = this._redrawBounds || new L.Bounds();
			this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
			this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
		},
	
		_redraw: function () {
			this._redrawRequest = null;
	
			if (this._redrawBounds) {
				this._redrawBounds.min._floor();
				this._redrawBounds.max._ceil();
			}
	
			this._clear(); // clear layers in redraw bounds
			this._draw(); // draw layers
	
			this._redrawBounds = null;
		},
	
		_clear: function () {
			var bounds = this._redrawBounds;
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
			} else {
				this._ctx.clearRect(0, 0, this._container.width, this._container.height);
			}
		},
	
		_draw: function () {
			var layer, bounds = this._redrawBounds;
			this._ctx.save();
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.beginPath();
				this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
				this._ctx.clip();
			}
	
			this._drawing = true;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
					layer._updatePath();
				}
			}
	
			this._drawing = false;
	
			this._ctx.restore();  // Restore state before clipping.
		},
	
		_updatePoly: function (layer, closed) {
			if (!this._drawing) { return; }
	
			var i, j, len2, p,
			    parts = layer._parts,
			    len = parts.length,
			    ctx = this._ctx;
	
			if (!len) { return; }
	
			this._drawnLayers[layer._leaflet_id] = layer;
	
			ctx.beginPath();
	
			if (ctx.setLineDash) {
				ctx.setLineDash(layer.options && layer.options._dashArray || []);
			}
	
			for (i = 0; i < len; i++) {
				for (j = 0, len2 = parts[i].length; j < len2; j++) {
					p = parts[i][j];
					ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
				}
				if (closed) {
					ctx.closePath();
				}
			}
	
			this._fillStroke(ctx, layer);
	
			// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
		},
	
		_updateCircle: function (layer) {
	
			if (!this._drawing || layer._empty()) { return; }
	
			var p = layer._point,
			    ctx = this._ctx,
			    r = layer._radius,
			    s = (layer._radiusY || r) / r;
	
			this._drawnLayers[layer._leaflet_id] = layer;
	
			if (s !== 1) {
				ctx.save();
				ctx.scale(1, s);
			}
	
			ctx.beginPath();
			ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
	
			if (s !== 1) {
				ctx.restore();
			}
	
			this._fillStroke(ctx, layer);
		},
	
		_fillStroke: function (ctx, layer) {
			var options = layer.options;
	
			if (options.fill) {
				ctx.globalAlpha = options.fillOpacity;
				ctx.fillStyle = options.fillColor || options.color;
				ctx.fill(options.fillRule || 'evenodd');
			}
	
			if (options.stroke && options.weight !== 0) {
				ctx.globalAlpha = options.opacity;
				ctx.lineWidth = options.weight;
				ctx.strokeStyle = options.color;
				ctx.lineCap = options.lineCap;
				ctx.lineJoin = options.lineJoin;
				ctx.stroke();
			}
		},
	
		// Canvas obviously doesn't have mouse events for individual drawn objects,
		// so we emulate that by calculating what's under the mouse on mousemove/click manually
	
		_onClick: function (e) {
			var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
					clickedLayer = layer;
				}
			}
			if (clickedLayer)  {
				L.DomEvent._fakeStop(e);
				this._fireEvent([clickedLayer], e);
			}
		},
	
		_onMouseMove: function (e) {
			if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }
	
			var point = this._map.mouseEventToLayerPoint(e);
			this._handleMouseHover(e, point);
		},
	
	
		_handleMouseOut: function (e) {
			var layer = this._hoveredLayer;
			if (layer) {
				// if we're leaving the layer, fire mouseout
				L.DomUtil.removeClass(this._container, 'leaflet-interactive');
				this._fireEvent([layer], e, 'mouseout');
				this._hoveredLayer = null;
			}
		},
	
		_handleMouseHover: function (e, point) {
			var layer, candidateHoveredLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point)) {
					candidateHoveredLayer = layer;
				}
			}
	
			if (candidateHoveredLayer !== this._hoveredLayer) {
				this._handleMouseOut(e);
	
				if (candidateHoveredLayer) {
					L.DomUtil.addClass(this._container, 'leaflet-interactive'); // change cursor
					this._fireEvent([candidateHoveredLayer], e, 'mouseover');
					this._hoveredLayer = candidateHoveredLayer;
				}
			}
	
			if (this._hoveredLayer) {
				this._fireEvent([this._hoveredLayer], e);
			}
		},
	
		_fireEvent: function (layers, e, type) {
			this._map._fireDOMEvent(e, type || e.type, layers);
		},
	
		_bringToFront: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				// Already last
				return;
			}
			if (prev) {
				prev.next = next;
			} else if (next) {
				// Update first entry unless this is the
				// signle entry
				this._drawFirst = next;
			}
	
			order.prev = this._drawLast;
			this._drawLast.next = order;
	
			order.next = null;
			this._drawLast = order;
	
			this._requestRedraw(layer);
		},
	
		_bringToBack: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (prev) {
				prev.next = next;
			} else {
				// Already first
				return;
			}
			if (next) {
				next.prev = prev;
			} else if (prev) {
				// Update last entry unless this is the
				// signle entry
				this._drawLast = prev;
			}
	
			order.prev = null;
	
			order.next = this._drawFirst;
			this._drawFirst.prev = order;
			this._drawFirst = order;
	
			this._requestRedraw(layer);
		}
	});
	
	// @namespace Browser; @property canvas: Boolean
	// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	L.Browser.canvas = (function () {
		return !!document.createElement('canvas').getContext;
	}());
	
	// @namespace Canvas
	// @factory L.canvas(options?: Renderer options)
	// Creates a Canvas renderer with the given options.
	L.canvas = function (options) {
		return L.Browser.canvas ? new L.Canvas(options) : null;
	};
	
	L.Polyline.prototype._containsPoint = function (p, closed) {
		var i, j, k, len, len2, part,
		    w = this._clickTolerance();
	
		if (!this._pxBounds.contains(p)) { return false; }
	
		// hit detection for polylines
		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];
	
			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				if (!closed && (j === 0)) { continue; }
	
				if (L.LineUtil.pointToSegmentDistance(p, part[k], part[j]) <= w) {
					return true;
				}
			}
		}
		return false;
	};
	
	L.Polygon.prototype._containsPoint = function (p) {
		var inside = false,
		    part, p1, p2, i, j, k, len, len2;
	
		if (!this._pxBounds.contains(p)) { return false; }
	
		// ray casting algorithm for detecting if point is in polygon
		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];
	
			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				p1 = part[j];
				p2 = part[k];
	
				if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
					inside = !inside;
				}
			}
		}
	
		// also check if it's on polygon stroke
		return inside || L.Polyline.prototype._containsPoint.call(this, p, true);
	};
	
	L.CircleMarker.prototype._containsPoint = function (p) {
		return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
	};
	
	
	
	/*
	 * @class GeoJSON
	 * @aka L.GeoJSON
	 * @inherits FeatureGroup
	 *
	 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
	 * GeoJSON data and display it on the map. Extends `FeatureGroup`.
	 *
	 * @example
	 *
	 * ```js
	 * L.geoJSON(data, {
	 * 	style: function (feature) {
	 * 		return {color: feature.properties.color};
	 * 	}
	 * }).bindPopup(function (layer) {
	 * 	return layer.feature.properties.description;
	 * }).addTo(map);
	 * ```
	 */
	
	L.GeoJSON = L.FeatureGroup.extend({
	
		/* @section
		 * @aka GeoJSON options
		 *
		 * @option pointToLayer: Function = *
		 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
		 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
		 * The default is to spawn a default `Marker`:
		 * ```js
		 * function(geoJsonPoint, latlng) {
		 * 	return L.marker(latlng);
		 * }
		 * ```
		 *
		 * @option style: Function = *
		 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
		 * called internally when data is added.
		 * The default value is to not override any defaults:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return {}
		 * }
		 * ```
		 *
		 * @option onEachFeature: Function = *
		 * A `Function` that will be called once for each created `Feature`, after it has
		 * been created and styled. Useful for attaching events and popups to features.
		 * The default is to do nothing with the newly created layers:
		 * ```js
		 * function (feature, layer) {}
		 * ```
		 *
		 * @option filter: Function = *
		 * A `Function` that will be used to decide whether to include a feature or not.
		 * The default is to include all features:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return true;
		 * }
		 * ```
		 * Note: dynamically changing the `filter` option will have effect only on newly
		 * added data. It will _not_ re-evaluate already included features.
		 *
		 * @option coordsToLatLng: Function = *
		 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
		 * The default is the `coordsToLatLng` static method.
		 */
	
		initialize: function (geojson, options) {
			L.setOptions(this, options);
	
			this._layers = {};
	
			if (geojson) {
				this.addData(geojson);
			}
		},
	
		// @method addData( <GeoJSON> data ): this
		// Adds a GeoJSON object to the layer.
		addData: function (geojson) {
			var features = L.Util.isArray(geojson) ? geojson : geojson.features,
			    i, len, feature;
	
			if (features) {
				for (i = 0, len = features.length; i < len; i++) {
					// only add this if geometry or geometries are set and not null
					feature = features[i];
					if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
						this.addData(feature);
					}
				}
				return this;
			}
	
			var options = this.options;
	
			if (options.filter && !options.filter(geojson)) { return this; }
	
			var layer = L.GeoJSON.geometryToLayer(geojson, options);
			if (!layer) {
				return this;
			}
			layer.feature = L.GeoJSON.asFeature(geojson);
	
			layer.defaultOptions = layer.options;
			this.resetStyle(layer);
	
			if (options.onEachFeature) {
				options.onEachFeature(geojson, layer);
			}
	
			return this.addLayer(layer);
		},
	
		// @method resetStyle( <Path> layer ): this
		// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
		resetStyle: function (layer) {
			// reset any custom styles
			layer.options = L.Util.extend({}, layer.defaultOptions);
			this._setLayerStyle(layer, this.options.style);
			return this;
		},
	
		// @method setStyle( <Function> style ): this
		// Changes styles of GeoJSON vector layers with the given style function.
		setStyle: function (style) {
			return this.eachLayer(function (layer) {
				this._setLayerStyle(layer, style);
			}, this);
		},
	
		_setLayerStyle: function (layer, style) {
			if (typeof style === 'function') {
				style = style(layer.feature);
			}
			if (layer.setStyle) {
				layer.setStyle(style);
			}
		}
	});
	
	// @section
	// There are several static functions which can be called without instantiating L.GeoJSON:
	L.extend(L.GeoJSON, {
		// @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
		// Creates a `Layer` from a given GeoJSON feature. Can use a custom
		// [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
		// functions if provided as options.
		geometryToLayer: function (geojson, options) {
	
			var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
			    coords = geometry ? geometry.coordinates : null,
			    layers = [],
			    pointToLayer = options && options.pointToLayer,
			    coordsToLatLng = options && options.coordsToLatLng || this.coordsToLatLng,
			    latlng, latlngs, i, len;
	
			if (!coords && !geometry) {
				return null;
			}
	
			switch (geometry.type) {
			case 'Point':
				latlng = coordsToLatLng(coords);
				return pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng);
	
			case 'MultiPoint':
				for (i = 0, len = coords.length; i < len; i++) {
					latlng = coordsToLatLng(coords[i]);
					layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng));
				}
				return new L.FeatureGroup(layers);
	
			case 'LineString':
			case 'MultiLineString':
				latlngs = this.coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, coordsToLatLng);
				return new L.Polyline(latlngs, options);
	
			case 'Polygon':
			case 'MultiPolygon':
				latlngs = this.coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, coordsToLatLng);
				return new L.Polygon(latlngs, options);
	
			case 'GeometryCollection':
				for (i = 0, len = geometry.geometries.length; i < len; i++) {
					var layer = this.geometryToLayer({
						geometry: geometry.geometries[i],
						type: 'Feature',
						properties: geojson.properties
					}, options);
	
					if (layer) {
						layers.push(layer);
					}
				}
				return new L.FeatureGroup(layers);
	
			default:
				throw new Error('Invalid GeoJSON object.');
			}
		},
	
		// @function coordsToLatLng(coords: Array): LatLng
		// Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
		// or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
		coordsToLatLng: function (coords) {
			return new L.LatLng(coords[1], coords[0], coords[2]);
		},
	
		// @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
		// Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
		// `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
		// Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
		coordsToLatLngs: function (coords, levelsDeep, coordsToLatLng) {
			var latlngs = [];
	
			for (var i = 0, len = coords.length, latlng; i < len; i++) {
				latlng = levelsDeep ?
				        this.coordsToLatLngs(coords[i], levelsDeep - 1, coordsToLatLng) :
				        (coordsToLatLng || this.coordsToLatLng)(coords[i]);
	
				latlngs.push(latlng);
			}
	
			return latlngs;
		},
	
		// @function latLngToCoords(latlng: LatLng): Array
		// Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
		latLngToCoords: function (latlng) {
			return latlng.alt !== undefined ?
					[latlng.lng, latlng.lat, latlng.alt] :
					[latlng.lng, latlng.lat];
		},
	
		// @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
		// Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
		// `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
		latLngsToCoords: function (latlngs, levelsDeep, closed) {
			var coords = [];
	
			for (var i = 0, len = latlngs.length; i < len; i++) {
				coords.push(levelsDeep ?
					L.GeoJSON.latLngsToCoords(latlngs[i], levelsDeep - 1, closed) :
					L.GeoJSON.latLngToCoords(latlngs[i]));
			}
	
			if (!levelsDeep && closed) {
				coords.push(coords[0]);
			}
	
			return coords;
		},
	
		getFeature: function (layer, newGeometry) {
			return layer.feature ?
					L.extend({}, layer.feature, {geometry: newGeometry}) :
					L.GeoJSON.asFeature(newGeometry);
		},
	
		// @function asFeature(geojson: Object): Object
		// Normalize GeoJSON geometries/features into GeoJSON features.
		asFeature: function (geojson) {
			if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
				return geojson;
			}
	
			return {
				type: 'Feature',
				properties: {},
				geometry: geojson
			};
		}
	});
	
	var PointToGeoJSON = {
		toGeoJSON: function () {
			return L.GeoJSON.getFeature(this, {
				type: 'Point',
				coordinates: L.GeoJSON.latLngToCoords(this.getLatLng())
			});
		}
	};
	
	// @namespace Marker
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
	L.Marker.include(PointToGeoJSON);
	
	// @namespace CircleMarker
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
	L.Circle.include(PointToGeoJSON);
	L.CircleMarker.include(PointToGeoJSON);
	
	
	// @namespace Polyline
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
	L.Polyline.prototype.toGeoJSON = function () {
		var multi = !L.Polyline._flat(this._latlngs);
	
		var coords = L.GeoJSON.latLngsToCoords(this._latlngs, multi ? 1 : 0);
	
		return L.GeoJSON.getFeature(this, {
			type: (multi ? 'Multi' : '') + 'LineString',
			coordinates: coords
		});
	};
	
	// @namespace Polygon
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
	L.Polygon.prototype.toGeoJSON = function () {
		var holes = !L.Polyline._flat(this._latlngs),
		    multi = holes && !L.Polyline._flat(this._latlngs[0]);
	
		var coords = L.GeoJSON.latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true);
	
		if (!holes) {
			coords = [coords];
		}
	
		return L.GeoJSON.getFeature(this, {
			type: (multi ? 'Multi' : '') + 'Polygon',
			coordinates: coords
		});
	};
	
	
	// @namespace LayerGroup
	L.LayerGroup.include({
		toMultiPoint: function () {
			var coords = [];
	
			this.eachLayer(function (layer) {
				coords.push(layer.toGeoJSON().geometry.coordinates);
			});
	
			return L.GeoJSON.getFeature(this, {
				type: 'MultiPoint',
				coordinates: coords
			});
		},
	
		// @method toGeoJSON(): Object
		// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `GeometryCollection`).
		toGeoJSON: function () {
	
			var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	
			if (type === 'MultiPoint') {
				return this.toMultiPoint();
			}
	
			var isGeometryCollection = type === 'GeometryCollection',
			    jsons = [];
	
			this.eachLayer(function (layer) {
				if (layer.toGeoJSON) {
					var json = layer.toGeoJSON();
					jsons.push(isGeometryCollection ? json.geometry : L.GeoJSON.asFeature(json));
				}
			});
	
			if (isGeometryCollection) {
				return L.GeoJSON.getFeature(this, {
					geometries: jsons,
					type: 'GeometryCollection'
				});
			}
	
			return {
				type: 'FeatureCollection',
				features: jsons
			};
		}
	});
	
	// @namespace GeoJSON
	// @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
	// Creates a GeoJSON layer. Optionally accepts an object in
	// [GeoJSON format](http://geojson.org/geojson-spec.html) to display on the map
	// (you can alternatively add it later with `addData` method) and an `options` object.
	L.geoJSON = function (geojson, options) {
		return new L.GeoJSON(geojson, options);
	};
	// Backward compatibility.
	L.geoJson = L.geoJSON;
	
	
	
	/*
	 * @class Draggable
	 * @aka L.Draggable
	 * @inherits Evented
	 *
	 * A class for making DOM elements draggable (including touch support).
	 * Used internally for map and marker dragging. Only works for elements
	 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
	 *
	 * @example
	 * ```js
	 * var draggable = new L.Draggable(elementToDrag);
	 * draggable.enable();
	 * ```
	 */
	
	L.Draggable = L.Evented.extend({
	
		options: {
			// @option clickTolerance: Number = 3
			// The max number of pixels a user can shift the mouse pointer during a click
			// for it to be considered a valid click (as opposed to a mouse drag).
			clickTolerance: 3
		},
	
		statics: {
			START: L.Browser.touch ? ['touchstart', 'mousedown'] : ['mousedown'],
			END: {
				mousedown: 'mouseup',
				touchstart: 'touchend',
				pointerdown: 'touchend',
				MSPointerDown: 'touchend'
			},
			MOVE: {
				mousedown: 'mousemove',
				touchstart: 'touchmove',
				pointerdown: 'touchmove',
				MSPointerDown: 'touchmove'
			}
		},
	
		// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline: Boolean)
		// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
		initialize: function (element, dragStartTarget, preventOutline) {
			this._element = element;
			this._dragStartTarget = dragStartTarget || element;
			this._preventOutline = preventOutline;
		},
	
		// @method enable()
		// Enables the dragging ability
		enable: function () {
			if (this._enabled) { return; }
	
			L.DomEvent.on(this._dragStartTarget, L.Draggable.START.join(' '), this._onDown, this);
	
			this._enabled = true;
		},
	
		// @method disable()
		// Disables the dragging ability
		disable: function () {
			if (!this._enabled) { return; }
	
			// If we're currently dragging this draggable,
			// disabling it counts as first ending the drag.
			if (L.Draggable._dragging === this) {
				this.finishDrag();
			}
	
			L.DomEvent.off(this._dragStartTarget, L.Draggable.START.join(' '), this._onDown, this);
	
			this._enabled = false;
			this._moved = false;
		},
	
		_onDown: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			this._moved = false;
	
			if (L.DomUtil.hasClass(this._element, 'leaflet-zoom-anim')) { return; }
	
			if (L.Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
			L.Draggable._dragging = this;  // Prevent dragging multiple objects at once.
	
			if (this._preventOutline) {
				L.DomUtil.preventOutline(this._element);
			}
	
			L.DomUtil.disableImageDrag();
			L.DomUtil.disableTextSelection();
	
			if (this._moving) { return; }
	
			// @event down: Event
			// Fired when a drag is about to start.
			this.fire('down');
	
			var first = e.touches ? e.touches[0] : e;
	
			this._startPoint = new L.Point(first.clientX, first.clientY);
	
			L.DomEvent
				.on(document, L.Draggable.MOVE[e.type], this._onMove, this)
				.on(document, L.Draggable.END[e.type], this._onUp, this);
		},
	
		_onMove: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			if (e.touches && e.touches.length > 1) {
				this._moved = true;
				return;
			}
	
			var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
			    newPoint = new L.Point(first.clientX, first.clientY),
			    offset = newPoint.subtract(this._startPoint);
	
			if (!offset.x && !offset.y) { return; }
			if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }
	
			L.DomEvent.preventDefault(e);
	
			if (!this._moved) {
				// @event dragstart: Event
				// Fired when a drag starts
				this.fire('dragstart');
	
				this._moved = true;
				this._startPos = L.DomUtil.getPosition(this._element).subtract(offset);
	
				L.DomUtil.addClass(document.body, 'leaflet-dragging');
	
				this._lastTarget = e.target || e.srcElement;
				// IE and Edge do not give the <use> element, so fetch it
				// if necessary
				if ((window.SVGElementInstance) && (this._lastTarget instanceof SVGElementInstance)) {
					this._lastTarget = this._lastTarget.correspondingUseElement;
				}
				L.DomUtil.addClass(this._lastTarget, 'leaflet-drag-target');
			}
	
			this._newPos = this._startPos.add(offset);
			this._moving = true;
	
			L.Util.cancelAnimFrame(this._animRequest);
			this._lastEvent = e;
			this._animRequest = L.Util.requestAnimFrame(this._updatePosition, this, true);
		},
	
		_updatePosition: function () {
			var e = {originalEvent: this._lastEvent};
	
			// @event predrag: Event
			// Fired continuously during dragging *before* each corresponding
			// update of the element's position.
			this.fire('predrag', e);
			L.DomUtil.setPosition(this._element, this._newPos);
	
			// @event drag: Event
			// Fired continuously during dragging.
			this.fire('drag', e);
		},
	
		_onUp: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
			this.finishDrag();
		},
	
		finishDrag: function () {
			L.DomUtil.removeClass(document.body, 'leaflet-dragging');
	
			if (this._lastTarget) {
				L.DomUtil.removeClass(this._lastTarget, 'leaflet-drag-target');
				this._lastTarget = null;
			}
	
			for (var i in L.Draggable.MOVE) {
				L.DomEvent
					.off(document, L.Draggable.MOVE[i], this._onMove, this)
					.off(document, L.Draggable.END[i], this._onUp, this);
			}
	
			L.DomUtil.enableImageDrag();
			L.DomUtil.enableTextSelection();
	
			if (this._moved && this._moving) {
				// ensure drag is not fired after dragend
				L.Util.cancelAnimFrame(this._animRequest);
	
				// @event dragend: DragEndEvent
				// Fired when the drag ends.
				this.fire('dragend', {
					distance: this._newPos.distanceTo(this._startPos)
				});
			}
	
			this._moving = false;
			L.Draggable._dragging = false;
		}
	
	});
	
	
	
	/*
		L.Handler is a base class for handler classes that are used internally to inject
		interaction features like dragging to classes like Map and Marker.
	*/
	
	// @class Handler
	// @aka L.Handler
	// Abstract class for map interaction handlers
	
	L.Handler = L.Class.extend({
		initialize: function (map) {
			this._map = map;
		},
	
		// @method enable(): this
		// Enables the handler
		enable: function () {
			if (this._enabled) { return this; }
	
			this._enabled = true;
			this.addHooks();
			return this;
		},
	
		// @method disable(): this
		// Disables the handler
		disable: function () {
			if (!this._enabled) { return this; }
	
			this._enabled = false;
			this.removeHooks();
			return this;
		},
	
		// @method enabled(): Boolean
		// Returns `true` if the handler is enabled
		enabled: function () {
			return !!this._enabled;
		}
	
		// @section Extension methods
		// Classes inheriting from `Handler` must implement the two following methods:
		// @method addHooks()
		// Called when the handler is enabled, should add event hooks.
		// @method removeHooks()
		// Called when the handler is disabled, should remove the event hooks added previously.
	});
	
	
	
	/*
	 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @option dragging: Boolean = true
		// Whether the map be draggable with mouse/touch or not.
		dragging: true,
	
		// @section Panning Inertia Options
		// @option inertia: Boolean = *
		// If enabled, panning of the map will have an inertia effect where
		// the map builds momentum while dragging and continues moving in
		// the same direction for some time. Feels especially nice on touch
		// devices. Enabled by default unless running on old Android devices.
		inertia: !L.Browser.android23,
	
		// @option inertiaDeceleration: Number = 3000
		// The rate with which the inertial movement slows down, in pixels/second².
		inertiaDeceleration: 3400, // px/s^2
	
		// @option inertiaMaxSpeed: Number = Infinity
		// Max speed of the inertial movement, in pixels/second.
		inertiaMaxSpeed: Infinity, // px/s
	
		// @option easeLinearity: Number = 0.2
		easeLinearity: 0.2,
	
		// TODO refactor, move to CRS
		// @option worldCopyJump: Boolean = false
		// With this option enabled, the map tracks when you pan to another "copy"
		// of the world and seamlessly jumps to the original one so that all overlays
		// like markers and vector layers are still visible.
		worldCopyJump: false,
	
		// @option maxBoundsViscosity: Number = 0.0
		// If `maxBounds` is set, this option will control how solid the bounds
		// are when dragging the map around. The default value of `0.0` allows the
		// user to drag outside the bounds at normal speed, higher values will
		// slow down map dragging outside bounds, and `1.0` makes the bounds fully
		// solid, preventing the user from dragging outside the bounds.
		maxBoundsViscosity: 0.0
	});
	
	L.Map.Drag = L.Handler.extend({
		addHooks: function () {
			if (!this._draggable) {
				var map = this._map;
	
				this._draggable = new L.Draggable(map._mapPane, map._container);
	
				this._draggable.on({
					down: this._onDown,
					dragstart: this._onDragStart,
					drag: this._onDrag,
					dragend: this._onDragEnd
				}, this);
	
				this._draggable.on('predrag', this._onPreDragLimit, this);
				if (map.options.worldCopyJump) {
					this._draggable.on('predrag', this._onPreDragWrap, this);
					map.on('zoomend', this._onZoomEnd, this);
	
					map.whenReady(this._onZoomEnd, this);
				}
			}
			L.DomUtil.addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
			this._draggable.enable();
			this._positions = [];
			this._times = [];
		},
	
		removeHooks: function () {
			L.DomUtil.removeClass(this._map._container, 'leaflet-grab');
			L.DomUtil.removeClass(this._map._container, 'leaflet-touch-drag');
			this._draggable.disable();
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		moving: function () {
			return this._draggable && this._draggable._moving;
		},
	
		_onDown: function () {
			this._map._stop();
		},
	
		_onDragStart: function () {
			var map = this._map;
	
			if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
				var bounds = L.latLngBounds(this._map.options.maxBounds);
	
				this._offsetLimit = L.bounds(
					this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
					this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
						.add(this._map.getSize()));
	
				this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
			} else {
				this._offsetLimit = null;
			}
	
			map
			    .fire('movestart')
			    .fire('dragstart');
	
			if (map.options.inertia) {
				this._positions = [];
				this._times = [];
			}
		},
	
		_onDrag: function (e) {
			if (this._map.options.inertia) {
				var time = this._lastTime = +new Date(),
				    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
	
				this._positions.push(pos);
				this._times.push(time);
	
				if (time - this._times[0] > 50) {
					this._positions.shift();
					this._times.shift();
				}
			}
	
			this._map
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_onZoomEnd: function () {
			var pxCenter = this._map.getSize().divideBy(2),
			    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
			this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
			this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
		},
	
		_viscousLimit: function (value, threshold) {
			return value - (value - threshold) * this._viscosity;
		},
	
		_onPreDragLimit: function () {
			if (!this._viscosity || !this._offsetLimit) { return; }
	
			var offset = this._draggable._newPos.subtract(this._draggable._startPos);
	
			var limit = this._offsetLimit;
			if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
			if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
			if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
			if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }
	
			this._draggable._newPos = this._draggable._startPos.add(offset);
		},
	
		_onPreDragWrap: function () {
			// TODO refactor to be able to adjust map pane position after zoom
			var worldWidth = this._worldWidth,
			    halfWidth = Math.round(worldWidth / 2),
			    dx = this._initialWorldOffset,
			    x = this._draggable._newPos.x,
			    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
			    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
			    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
			this._draggable._absPos = this._draggable._newPos.clone();
			this._draggable._newPos.x = newX;
		},
	
		_onDragEnd: function (e) {
			var map = this._map,
			    options = map.options,
	
			    noInertia = !options.inertia || this._times.length < 2;
	
			map.fire('dragend', e);
	
			if (noInertia) {
				map.fire('moveend');
	
			} else {
	
				var direction = this._lastPos.subtract(this._positions[0]),
				    duration = (this._lastTime - this._times[0]) / 1000,
				    ease = options.easeLinearity,
	
				    speedVector = direction.multiplyBy(ease / duration),
				    speed = speedVector.distanceTo([0, 0]),
	
				    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
				    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
				    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
				    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
				if (!offset.x && !offset.y) {
					map.fire('moveend');
	
				} else {
					offset = map._limitOffset(offset, map.options.maxBounds);
	
					L.Util.requestAnimFrame(function () {
						map.panBy(offset, {
							duration: decelerationDuration,
							easeLinearity: ease,
							noMoveStart: true,
							animate: true
						});
					});
				}
			}
		}
	});
	
	// @section Handlers
	// @property dragging: Handler
	// Map dragging handler (by both mouse and touch).
	L.Map.addInitHook('addHandler', 'dragging', L.Map.Drag);
	
	
	
	/*
	 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	
	L.Map.mergeOptions({
		// @option doubleClickZoom: Boolean|String = true
		// Whether the map can be zoomed in by double clicking on it and
		// zoomed out by double clicking while holding shift. If passed
		// `'center'`, double-click zoom will zoom to the center of the
		//  view regardless of where the mouse was.
		doubleClickZoom: true
	});
	
	L.Map.DoubleClickZoom = L.Handler.extend({
		addHooks: function () {
			this._map.on('dblclick', this._onDoubleClick, this);
		},
	
		removeHooks: function () {
			this._map.off('dblclick', this._onDoubleClick, this);
		},
	
		_onDoubleClick: function (e) {
			var map = this._map,
			    oldZoom = map.getZoom(),
			    delta = map.options.zoomDelta,
			    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
	
			if (map.options.doubleClickZoom === 'center') {
				map.setZoom(zoom);
			} else {
				map.setZoomAround(e.containerPoint, zoom);
			}
		}
	});
	
	// @section Handlers
	//
	// Map properties include interaction handlers that allow you to control
	// interaction behavior in runtime, enabling or disabling certain features such
	// as dragging or touch zoom (see `Handler` methods). For example:
	//
	// ```js
	// map.doubleClickZoom.disable();
	// ```
	//
	// @property doubleClickZoom: Handler
	// Double click zoom handler.
	L.Map.addInitHook('addHandler', 'doubleClickZoom', L.Map.DoubleClickZoom);
	
	
	
	/*
	 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @section Mousewheel options
		// @option scrollWheelZoom: Boolean|String = true
		// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
		// it will zoom to the center of the view regardless of where the mouse was.
		scrollWheelZoom: true,
	
		// @option wheelDebounceTime: Number = 40
		// Limits the rate at which a wheel can fire (in milliseconds). By default
		// user can't zoom via wheel more often than once per 40 ms.
		wheelDebounceTime: 40,
	
		// @option wheelPxPerZoomLevel: Number = 60
		// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
		// mean a change of one full zoom level. Smaller values will make wheel-zooming
		// faster (and vice versa).
		wheelPxPerZoomLevel: 60
	});
	
	L.Map.ScrollWheelZoom = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'mousewheel', this._onWheelScroll, this);
	
			this._delta = 0;
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'mousewheel', this._onWheelScroll, this);
		},
	
		_onWheelScroll: function (e) {
			var delta = L.DomEvent.getWheelDelta(e);
	
			var debounce = this._map.options.wheelDebounceTime;
	
			this._delta += delta;
			this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
			if (!this._startTime) {
				this._startTime = +new Date();
			}
	
			var left = Math.max(debounce - (+new Date() - this._startTime), 0);
	
			clearTimeout(this._timer);
			this._timer = setTimeout(L.bind(this._performZoom, this), left);
	
			L.DomEvent.stop(e);
		},
	
		_performZoom: function () {
			var map = this._map,
			    zoom = map.getZoom(),
			    snap = this._map.options.zoomSnap || 0;
	
			map._stop(); // stop panning and fly animations if any
	
			// map the delta with a sigmoid function to -4..4 range leaning on -1..1
			var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
			    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
			    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
			    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
	
			this._delta = 0;
			this._startTime = null;
	
			if (!delta) { return; }
	
			if (map.options.scrollWheelZoom === 'center') {
				map.setZoom(zoom + delta);
			} else {
				map.setZoomAround(this._lastMousePos, zoom + delta);
			}
		}
	});
	
	// @section Handlers
	// @property scrollWheelZoom: Handler
	// Scroll wheel zoom handler.
	L.Map.addInitHook('addHandler', 'scrollWheelZoom', L.Map.ScrollWheelZoom);
	
	
	
	/*
	 * Extends the event handling code with double tap support for mobile browsers.
	 */
	
	L.extend(L.DomEvent, {
	
		_touchstart: L.Browser.msPointer ? 'MSPointerDown' : L.Browser.pointer ? 'pointerdown' : 'touchstart',
		_touchend: L.Browser.msPointer ? 'MSPointerUp' : L.Browser.pointer ? 'pointerup' : 'touchend',
	
		// inspired by Zepto touch code by Thomas Fuchs
		addDoubleTapListener: function (obj, handler, id) {
			var last, touch,
			    doubleTap = false,
			    delay = 250;
	
			function onTouchStart(e) {
				var count;
	
				if (L.Browser.pointer) {
					if ((!L.Browser.edge) || e.pointerType === 'mouse') { return; }
					count = L.DomEvent._pointersCount;
				} else {
					count = e.touches.length;
				}
	
				if (count > 1) { return; }
	
				var now = Date.now(),
				    delta = now - (last || now);
	
				touch = e.touches ? e.touches[0] : e;
				doubleTap = (delta > 0 && delta <= delay);
				last = now;
			}
	
			function onTouchEnd(e) {
				if (doubleTap && !touch.cancelBubble) {
					if (L.Browser.pointer) {
						if ((!L.Browser.edge) || e.pointerType === 'mouse') { return; }
	
						// work around .type being readonly with MSPointer* events
						var newTouch = {},
						    prop, i;
	
						for (i in touch) {
							prop = touch[i];
							newTouch[i] = prop && prop.bind ? prop.bind(touch) : prop;
						}
						touch = newTouch;
					}
					touch.type = 'dblclick';
					handler(touch);
					last = null;
				}
			}
	
			var pre = '_leaflet_',
			    touchstart = this._touchstart,
			    touchend = this._touchend;
	
			obj[pre + touchstart + id] = onTouchStart;
			obj[pre + touchend + id] = onTouchEnd;
			obj[pre + 'dblclick' + id] = handler;
	
			obj.addEventListener(touchstart, onTouchStart, false);
			obj.addEventListener(touchend, onTouchEnd, false);
	
			// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
			// the browser doesn't fire touchend/pointerup events but does fire
			// native dblclicks. See #4127.
			// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
			obj.addEventListener('dblclick', handler, false);
	
			return this;
		},
	
		removeDoubleTapListener: function (obj, id) {
			var pre = '_leaflet_',
			    touchstart = obj[pre + this._touchstart + id],
			    touchend = obj[pre + this._touchend + id],
			    dblclick = obj[pre + 'dblclick' + id];
	
			obj.removeEventListener(this._touchstart, touchstart, false);
			obj.removeEventListener(this._touchend, touchend, false);
			if (!L.Browser.edge) {
				obj.removeEventListener('dblclick', dblclick, false);
			}
	
			return this;
		}
	});
	
	
	
	/*
	 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	 */
	
	L.extend(L.DomEvent, {
	
		POINTER_DOWN:   L.Browser.msPointer ? 'MSPointerDown'   : 'pointerdown',
		POINTER_MOVE:   L.Browser.msPointer ? 'MSPointerMove'   : 'pointermove',
		POINTER_UP:     L.Browser.msPointer ? 'MSPointerUp'     : 'pointerup',
		POINTER_CANCEL: L.Browser.msPointer ? 'MSPointerCancel' : 'pointercancel',
		TAG_WHITE_LIST: ['INPUT', 'SELECT', 'OPTION'],
	
		_pointers: {},
		_pointersCount: 0,
	
		// Provides a touch events wrapper for (ms)pointer events.
		// ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
		addPointerListener: function (obj, type, handler, id) {
	
			if (type === 'touchstart') {
				this._addPointerStart(obj, handler, id);
	
			} else if (type === 'touchmove') {
				this._addPointerMove(obj, handler, id);
	
			} else if (type === 'touchend') {
				this._addPointerEnd(obj, handler, id);
			}
	
			return this;
		},
	
		removePointerListener: function (obj, type, id) {
			var handler = obj['_leaflet_' + type + id];
	
			if (type === 'touchstart') {
				obj.removeEventListener(this.POINTER_DOWN, handler, false);
	
			} else if (type === 'touchmove') {
				obj.removeEventListener(this.POINTER_MOVE, handler, false);
	
			} else if (type === 'touchend') {
				obj.removeEventListener(this.POINTER_UP, handler, false);
				obj.removeEventListener(this.POINTER_CANCEL, handler, false);
			}
	
			return this;
		},
	
		_addPointerStart: function (obj, handler, id) {
			var onDown = L.bind(function (e) {
				if (e.pointerType !== 'mouse' && e.MSPOINTER_TYPE_MOUSE && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
					// In IE11, some touch events needs to fire for form controls, or
					// the controls will stop working. We keep a whitelist of tag names that
					// need these events. For other target tags, we prevent default on the event.
					if (this.TAG_WHITE_LIST.indexOf(e.target.tagName) < 0) {
						L.DomEvent.preventDefault(e);
					} else {
						return;
					}
				}
	
				this._handlePointer(e, handler);
			}, this);
	
			obj['_leaflet_touchstart' + id] = onDown;
			obj.addEventListener(this.POINTER_DOWN, onDown, false);
	
			// need to keep track of what pointers and how many are active to provide e.touches emulation
			if (!this._pointerDocListener) {
				var pointerUp = L.bind(this._globalPointerUp, this);
	
				// we listen documentElement as any drags that end by moving the touch off the screen get fired there
				document.documentElement.addEventListener(this.POINTER_DOWN, L.bind(this._globalPointerDown, this), true);
				document.documentElement.addEventListener(this.POINTER_MOVE, L.bind(this._globalPointerMove, this), true);
				document.documentElement.addEventListener(this.POINTER_UP, pointerUp, true);
				document.documentElement.addEventListener(this.POINTER_CANCEL, pointerUp, true);
	
				this._pointerDocListener = true;
			}
		},
	
		_globalPointerDown: function (e) {
			this._pointers[e.pointerId] = e;
			this._pointersCount++;
		},
	
		_globalPointerMove: function (e) {
			if (this._pointers[e.pointerId]) {
				this._pointers[e.pointerId] = e;
			}
		},
	
		_globalPointerUp: function (e) {
			delete this._pointers[e.pointerId];
			this._pointersCount--;
		},
	
		_handlePointer: function (e, handler) {
			e.touches = [];
			for (var i in this._pointers) {
				e.touches.push(this._pointers[i]);
			}
			e.changedTouches = [e];
	
			handler(e);
		},
	
		_addPointerMove: function (obj, handler, id) {
			var onMove = L.bind(function (e) {
				// don't fire touch moves when mouse isn't down
				if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }
	
				this._handlePointer(e, handler);
			}, this);
	
			obj['_leaflet_touchmove' + id] = onMove;
			obj.addEventListener(this.POINTER_MOVE, onMove, false);
		},
	
		_addPointerEnd: function (obj, handler, id) {
			var onUp = L.bind(function (e) {
				this._handlePointer(e, handler);
			}, this);
	
			obj['_leaflet_touchend' + id] = onUp;
			obj.addEventListener(this.POINTER_UP, onUp, false);
			obj.addEventListener(this.POINTER_CANCEL, onUp, false);
		}
	});
	
	
	
	/*
	 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @section Touch interaction options
		// @option touchZoom: Boolean|String = *
		// Whether the map can be zoomed by touch-dragging with two fingers. If
		// passed `'center'`, it will zoom to the center of the view regardless of
		// where the touch events (fingers) were. Enabled for touch-capable web
		// browsers except for old Androids.
		touchZoom: L.Browser.touch && !L.Browser.android23,
	
		// @option bounceAtZoomLimits: Boolean = true
		// Set it to false if you don't want the map to zoom beyond min/max zoom
		// and then bounce back when pinch-zooming.
		bounceAtZoomLimits: true
	});
	
	L.Map.TouchZoom = L.Handler.extend({
		addHooks: function () {
			L.DomUtil.addClass(this._map._container, 'leaflet-touch-zoom');
			L.DomEvent.on(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		removeHooks: function () {
			L.DomUtil.removeClass(this._map._container, 'leaflet-touch-zoom');
			L.DomEvent.off(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		_onTouchStart: function (e) {
			var map = this._map;
			if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
			var p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]);
	
			this._centerPoint = map.getSize()._divideBy(2);
			this._startLatLng = map.containerPointToLatLng(this._centerPoint);
			if (map.options.touchZoom !== 'center') {
				this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
			}
	
			this._startDist = p1.distanceTo(p2);
			this._startZoom = map.getZoom();
	
			this._moved = false;
			this._zooming = true;
	
			map._stop();
	
			L.DomEvent
			    .on(document, 'touchmove', this._onTouchMove, this)
			    .on(document, 'touchend', this._onTouchEnd, this);
	
			L.DomEvent.preventDefault(e);
		},
	
		_onTouchMove: function (e) {
			if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
			var map = this._map,
			    p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]),
			    scale = p1.distanceTo(p2) / this._startDist;
	
	
			this._zoom = map.getScaleZoom(scale, this._startZoom);
	
			if (!map.options.bounceAtZoomLimits && (
				(this._zoom < map.getMinZoom() && scale < 1) ||
				(this._zoom > map.getMaxZoom() && scale > 1))) {
				this._zoom = map._limitZoom(this._zoom);
			}
	
			if (map.options.touchZoom === 'center') {
				this._center = this._startLatLng;
				if (scale === 1) { return; }
			} else {
				// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
				var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
				if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
				this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
			}
	
			if (!this._moved) {
				map._moveStart(true);
				this._moved = true;
			}
	
			L.Util.cancelAnimFrame(this._animRequest);
	
			var moveFn = L.bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
			this._animRequest = L.Util.requestAnimFrame(moveFn, this, true);
	
			L.DomEvent.preventDefault(e);
		},
	
		_onTouchEnd: function () {
			if (!this._moved || !this._zooming) {
				this._zooming = false;
				return;
			}
	
			this._zooming = false;
			L.Util.cancelAnimFrame(this._animRequest);
	
			L.DomEvent
			    .off(document, 'touchmove', this._onTouchMove)
			    .off(document, 'touchend', this._onTouchEnd);
	
			// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
			if (this._map.options.zoomAnimation) {
				this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
			} else {
				this._map._resetView(this._center, this._map._limitZoom(this._zoom));
			}
		}
	});
	
	// @section Handlers
	// @property touchZoom: Handler
	// Touch zoom handler.
	L.Map.addInitHook('addHandler', 'touchZoom', L.Map.TouchZoom);
	
	
	
	/*
	 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @section Touch interaction options
		// @option tap: Boolean = true
		// Enables mobile hacks for supporting instant taps (fixing 200ms click
		// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
		tap: true,
	
		// @option tapTolerance: Number = 15
		// The max number of pixels a user can shift his finger during touch
		// for it to be considered a valid tap.
		tapTolerance: 15
	});
	
	L.Map.Tap = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'touchstart', this._onDown, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'touchstart', this._onDown, this);
		},
	
		_onDown: function (e) {
			if (!e.touches) { return; }
	
			L.DomEvent.preventDefault(e);
	
			this._fireClick = true;
	
			// don't simulate click or track longpress if more than 1 touch
			if (e.touches.length > 1) {
				this._fireClick = false;
				clearTimeout(this._holdTimeout);
				return;
			}
	
			var first = e.touches[0],
			    el = first.target;
	
			this._startPos = this._newPos = new L.Point(first.clientX, first.clientY);
	
			// if touching a link, highlight it
			if (el.tagName && el.tagName.toLowerCase() === 'a') {
				L.DomUtil.addClass(el, 'leaflet-active');
			}
	
			// simulate long hold but setting a timeout
			this._holdTimeout = setTimeout(L.bind(function () {
				if (this._isTapValid()) {
					this._fireClick = false;
					this._onUp();
					this._simulateEvent('contextmenu', first);
				}
			}, this), 1000);
	
			this._simulateEvent('mousedown', first);
	
			L.DomEvent.on(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
		},
	
		_onUp: function (e) {
			clearTimeout(this._holdTimeout);
	
			L.DomEvent.off(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
	
			if (this._fireClick && e && e.changedTouches) {
	
				var first = e.changedTouches[0],
				    el = first.target;
	
				if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
					L.DomUtil.removeClass(el, 'leaflet-active');
				}
	
				this._simulateEvent('mouseup', first);
	
				// simulate click if the touch didn't move too much
				if (this._isTapValid()) {
					this._simulateEvent('click', first);
				}
			}
		},
	
		_isTapValid: function () {
			return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
		},
	
		_onMove: function (e) {
			var first = e.touches[0];
			this._newPos = new L.Point(first.clientX, first.clientY);
			this._simulateEvent('mousemove', first);
		},
	
		_simulateEvent: function (type, e) {
			var simulatedEvent = document.createEvent('MouseEvents');
	
			simulatedEvent._simulated = true;
			e.target._simulatedClick = true;
	
			simulatedEvent.initMouseEvent(
			        type, true, true, window, 1,
			        e.screenX, e.screenY,
			        e.clientX, e.clientY,
			        false, false, false, false, 0, null);
	
			e.target.dispatchEvent(simulatedEvent);
		}
	});
	
	// @section Handlers
	// @property tap: Handler
	// Mobile touch hacks (quick tap and touch hold) handler.
	if (L.Browser.touch && !L.Browser.pointer) {
		L.Map.addInitHook('addHandler', 'tap', L.Map.Tap);
	}
	
	
	
	/*
	 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
	 * (zoom to a selected bounding box), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @option boxZoom: Boolean = true
		// Whether the map can be zoomed to a rectangular area specified by
		// dragging the mouse while pressing the shift key.
		boxZoom: true
	});
	
	L.Map.BoxZoom = L.Handler.extend({
		initialize: function (map) {
			this._map = map;
			this._container = map._container;
			this._pane = map._panes.overlayPane;
		},
	
		addHooks: function () {
			L.DomEvent.on(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		moved: function () {
			return this._moved;
		},
	
		_resetState: function () {
			this._moved = false;
		},
	
		_onMouseDown: function (e) {
			if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
			this._resetState();
	
			L.DomUtil.disableTextSelection();
			L.DomUtil.disableImageDrag();
	
			this._startPoint = this._map.mouseEventToContainerPoint(e);
	
			L.DomEvent.on(document, {
				contextmenu: L.DomEvent.stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseMove: function (e) {
			if (!this._moved) {
				this._moved = true;
	
				this._box = L.DomUtil.create('div', 'leaflet-zoom-box', this._container);
				L.DomUtil.addClass(this._container, 'leaflet-crosshair');
	
				this._map.fire('boxzoomstart');
			}
	
			this._point = this._map.mouseEventToContainerPoint(e);
	
			var bounds = new L.Bounds(this._point, this._startPoint),
			    size = bounds.getSize();
	
			L.DomUtil.setPosition(this._box, bounds.min);
	
			this._box.style.width  = size.x + 'px';
			this._box.style.height = size.y + 'px';
		},
	
		_finish: function () {
			if (this._moved) {
				L.DomUtil.remove(this._box);
				L.DomUtil.removeClass(this._container, 'leaflet-crosshair');
			}
	
			L.DomUtil.enableTextSelection();
			L.DomUtil.enableImageDrag();
	
			L.DomEvent.off(document, {
				contextmenu: L.DomEvent.stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseUp: function (e) {
			if ((e.which !== 1) && (e.button !== 1)) { return; }
	
			this._finish();
	
			if (!this._moved) { return; }
			// Postpone to next JS tick so internal click event handling
			// still see it as "moved".
			setTimeout(L.bind(this._resetState, this), 0);
	
			var bounds = new L.LatLngBounds(
			        this._map.containerPointToLatLng(this._startPoint),
			        this._map.containerPointToLatLng(this._point));
	
			this._map
				.fitBounds(bounds)
				.fire('boxzoomend', {boxZoomBounds: bounds});
		},
	
		_onKeyDown: function (e) {
			if (e.keyCode === 27) {
				this._finish();
			}
		}
	});
	
	// @section Handlers
	// @property boxZoom: Handler
	// Box (shift-drag with mouse) zoom handler.
	L.Map.addInitHook('addHandler', 'boxZoom', L.Map.BoxZoom);
	
	
	
	/*
	 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Keyboard Navigation Options
	L.Map.mergeOptions({
		// @option keyboard: Boolean = true
		// Makes the map focusable and allows users to navigate the map with keyboard
		// arrows and `+`/`-` keys.
		keyboard: true,
	
		// @option keyboardPanDelta: Number = 80
		// Amount of pixels to pan when pressing an arrow key.
		keyboardPanDelta: 80
	});
	
	L.Map.Keyboard = L.Handler.extend({
	
		keyCodes: {
			left:    [37],
			right:   [39],
			down:    [40],
			up:      [38],
			zoomIn:  [187, 107, 61, 171],
			zoomOut: [189, 109, 54, 173]
		},
	
		initialize: function (map) {
			this._map = map;
	
			this._setPanDelta(map.options.keyboardPanDelta);
			this._setZoomDelta(map.options.zoomDelta);
		},
	
		addHooks: function () {
			var container = this._map._container;
	
			// make the container focusable by tabbing
			if (container.tabIndex <= 0) {
				container.tabIndex = '0';
			}
	
			L.DomEvent.on(container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.on({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		removeHooks: function () {
			this._removeHooks();
	
			L.DomEvent.off(this._map._container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.off({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		_onMouseDown: function () {
			if (this._focused) { return; }
	
			var body = document.body,
			    docEl = document.documentElement,
			    top = body.scrollTop || docEl.scrollTop,
			    left = body.scrollLeft || docEl.scrollLeft;
	
			this._map._container.focus();
	
			window.scrollTo(left, top);
		},
	
		_onFocus: function () {
			this._focused = true;
			this._map.fire('focus');
		},
	
		_onBlur: function () {
			this._focused = false;
			this._map.fire('blur');
		},
	
		_setPanDelta: function (panDelta) {
			var keys = this._panKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.left.length; i < len; i++) {
				keys[codes.left[i]] = [-1 * panDelta, 0];
			}
			for (i = 0, len = codes.right.length; i < len; i++) {
				keys[codes.right[i]] = [panDelta, 0];
			}
			for (i = 0, len = codes.down.length; i < len; i++) {
				keys[codes.down[i]] = [0, panDelta];
			}
			for (i = 0, len = codes.up.length; i < len; i++) {
				keys[codes.up[i]] = [0, -1 * panDelta];
			}
		},
	
		_setZoomDelta: function (zoomDelta) {
			var keys = this._zoomKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.zoomIn.length; i < len; i++) {
				keys[codes.zoomIn[i]] = zoomDelta;
			}
			for (i = 0, len = codes.zoomOut.length; i < len; i++) {
				keys[codes.zoomOut[i]] = -zoomDelta;
			}
		},
	
		_addHooks: function () {
			L.DomEvent.on(document, 'keydown', this._onKeyDown, this);
		},
	
		_removeHooks: function () {
			L.DomEvent.off(document, 'keydown', this._onKeyDown, this);
		},
	
		_onKeyDown: function (e) {
			if (e.altKey || e.ctrlKey || e.metaKey) { return; }
	
			var key = e.keyCode,
			    map = this._map,
			    offset;
	
			if (key in this._panKeys) {
	
				if (map._panAnim && map._panAnim._inProgress) { return; }
	
				offset = this._panKeys[key];
				if (e.shiftKey) {
					offset = L.point(offset).multiplyBy(3);
				}
	
				map.panBy(offset);
	
				if (map.options.maxBounds) {
					map.panInsideBounds(map.options.maxBounds);
				}
	
			} else if (key in this._zoomKeys) {
				map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
	
			} else if (key === 27) {
				map.closePopup();
	
			} else {
				return;
			}
	
			L.DomEvent.stop(e);
		}
	});
	
	// @section Handlers
	// @section Handlers
	// @property keyboard: Handler
	// Keyboard navigation handler.
	L.Map.addInitHook('addHandler', 'keyboard', L.Map.Keyboard);
	
	
	
	/*
	 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	 */
	
	
	/* @namespace Marker
	 * @section Interaction handlers
	 *
	 * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
	 *
	 * ```js
	 * marker.dragging.disable();
	 * ```
	 *
	 * @property dragging: Handler
	 * Marker dragging handler (by both mouse and touch).
	 */
	
	L.Handler.MarkerDrag = L.Handler.extend({
		initialize: function (marker) {
			this._marker = marker;
		},
	
		addHooks: function () {
			var icon = this._marker._icon;
	
			if (!this._draggable) {
				this._draggable = new L.Draggable(icon, icon, true);
			}
	
			this._draggable.on({
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).enable();
	
			L.DomUtil.addClass(icon, 'leaflet-marker-draggable');
		},
	
		removeHooks: function () {
			this._draggable.off({
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).disable();
	
			if (this._marker._icon) {
				L.DomUtil.removeClass(this._marker._icon, 'leaflet-marker-draggable');
			}
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		_onDragStart: function () {
			// @section Dragging events
			// @event dragstart: Event
			// Fired when the user starts dragging the marker.
	
			// @event movestart: Event
			// Fired when the marker starts moving (because of dragging).
	
			this._oldLatLng = this._marker.getLatLng();
			this._marker
			    .closePopup()
			    .fire('movestart')
			    .fire('dragstart');
		},
	
		_onDrag: function (e) {
			var marker = this._marker,
			    shadow = marker._shadow,
			    iconPos = L.DomUtil.getPosition(marker._icon),
			    latlng = marker._map.layerPointToLatLng(iconPos);
	
			// update shadow position
			if (shadow) {
				L.DomUtil.setPosition(shadow, iconPos);
			}
	
			marker._latlng = latlng;
			e.latlng = latlng;
			e.oldLatLng = this._oldLatLng;
	
			// @event drag: Event
			// Fired repeatedly while the user drags the marker.
			marker
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_onDragEnd: function (e) {
			// @event dragend: DragEndEvent
			// Fired when the user stops dragging the marker.
	
			// @event moveend: Event
			// Fired when the marker stops moving (because of dragging).
			delete this._oldLatLng;
			this._marker
			    .fire('moveend')
			    .fire('dragend', e);
		}
	});
	
	
	
	/*
	 * @class Control
	 * @aka L.Control
	 * @inherits Class
	 *
	 * L.Control is a base class for implementing map controls. Handles positioning.
	 * All other controls extend from this class.
	 */
	
	L.Control = L.Class.extend({
		// @section
		// @aka Control options
		options: {
			// @option position: String = 'topright'
			// The position of the control (one of the map corners). Possible values are `'topleft'`,
			// `'topright'`, `'bottomleft'` or `'bottomright'`
			position: 'topright'
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		/* @section
		 * Classes extending L.Control will inherit the following methods:
		 *
		 * @method getPosition: string
		 * Returns the position of the control.
		 */
		getPosition: function () {
			return this.options.position;
		},
	
		// @method setPosition(position: string): this
		// Sets the position of the control.
		setPosition: function (position) {
			var map = this._map;
	
			if (map) {
				map.removeControl(this);
			}
	
			this.options.position = position;
	
			if (map) {
				map.addControl(this);
			}
	
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTMLElement that contains the control.
		getContainer: function () {
			return this._container;
		},
	
		// @method addTo(map: Map): this
		// Adds the control to the given map.
		addTo: function (map) {
			this.remove();
			this._map = map;
	
			var container = this._container = this.onAdd(map),
			    pos = this.getPosition(),
			    corner = map._controlCorners[pos];
	
			L.DomUtil.addClass(container, 'leaflet-control');
	
			if (pos.indexOf('bottom') !== -1) {
				corner.insertBefore(container, corner.firstChild);
			} else {
				corner.appendChild(container);
			}
	
			return this;
		},
	
		// @method remove: this
		// Removes the control from the map it is currently active on.
		remove: function () {
			if (!this._map) {
				return this;
			}
	
			L.DomUtil.remove(this._container);
	
			if (this.onRemove) {
				this.onRemove(this._map);
			}
	
			this._map = null;
	
			return this;
		},
	
		_refocusOnMap: function (e) {
			// if map exists and event is not a keyboard event
			if (this._map && e && e.screenX > 0 && e.screenY > 0) {
				this._map.getContainer().focus();
			}
		}
	});
	
	L.control = function (options) {
		return new L.Control(options);
	};
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every control should extend from `L.Control` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): HTMLElement
	 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
	 *
	 * @method onRemove(map: Map)
	 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
	 */
	
	/* @namespace Map
	 * @section Methods for Layers and Controls
	 */
	L.Map.include({
		// @method addControl(control: Control): this
		// Adds the given control to the map
		addControl: function (control) {
			control.addTo(this);
			return this;
		},
	
		// @method removeControl(control: Control): this
		// Removes the given control from the map
		removeControl: function (control) {
			control.remove();
			return this;
		},
	
		_initControlPos: function () {
			var corners = this._controlCorners = {},
			    l = 'leaflet-',
			    container = this._controlContainer =
			            L.DomUtil.create('div', l + 'control-container', this._container);
	
			function createCorner(vSide, hSide) {
				var className = l + vSide + ' ' + l + hSide;
	
				corners[vSide + hSide] = L.DomUtil.create('div', className, container);
			}
	
			createCorner('top', 'left');
			createCorner('top', 'right');
			createCorner('bottom', 'left');
			createCorner('bottom', 'right');
		},
	
		_clearControlPos: function () {
			L.DomUtil.remove(this._controlContainer);
		}
	});
	
	
	
	/*
	 * @class Control.Zoom
	 * @aka L.Control.Zoom
	 * @inherits Control
	 *
	 * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
	 */
	
	L.Control.Zoom = L.Control.extend({
		// @section
		// @aka Control.Zoom options
		options: {
			position: 'topleft',
	
			// @option zoomInText: String = '+'
			// The text set on the 'zoom in' button.
			zoomInText: '+',
	
			// @option zoomInTitle: String = 'Zoom in'
			// The title set on the 'zoom in' button.
			zoomInTitle: 'Zoom in',
	
			// @option zoomOutText: String = '-'
			// The text set on the 'zoom out' button.
			zoomOutText: '-',
	
			// @option zoomOutTitle: String = 'Zoom out'
			// The title set on the 'zoom out' button.
			zoomOutTitle: 'Zoom out'
		},
	
		onAdd: function (map) {
			var zoomName = 'leaflet-control-zoom',
			    container = L.DomUtil.create('div', zoomName + ' leaflet-bar'),
			    options = this.options;
	
			this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
			        zoomName + '-in',  container, this._zoomIn);
			this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
			        zoomName + '-out', container, this._zoomOut);
	
			this._updateDisabled();
			map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off('zoomend zoomlevelschange', this._updateDisabled, this);
		},
	
		disable: function () {
			this._disabled = true;
			this._updateDisabled();
			return this;
		},
	
		enable: function () {
			this._disabled = false;
			this._updateDisabled();
			return this;
		},
	
		_zoomIn: function (e) {
			if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
				this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_zoomOut: function (e) {
			if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
				this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_createButton: function (html, title, className, container, fn) {
			var link = L.DomUtil.create('a', className, container);
			link.innerHTML = html;
			link.href = '#';
			link.title = title;
	
			/*
			 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
			 */
			link.setAttribute('role', 'button');
			link.setAttribute('aria-label', title);
	
			L.DomEvent
			    .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
			    .on(link, 'click', L.DomEvent.stop)
			    .on(link, 'click', fn, this)
			    .on(link, 'click', this._refocusOnMap, this);
	
			return link;
		},
	
		_updateDisabled: function () {
			var map = this._map,
			    className = 'leaflet-disabled';
	
			L.DomUtil.removeClass(this._zoomInButton, className);
			L.DomUtil.removeClass(this._zoomOutButton, className);
	
			if (this._disabled || map._zoom === map.getMinZoom()) {
				L.DomUtil.addClass(this._zoomOutButton, className);
			}
			if (this._disabled || map._zoom === map.getMaxZoom()) {
				L.DomUtil.addClass(this._zoomInButton, className);
			}
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option zoomControl: Boolean = true
	// Whether a [zoom control](#control-zoom) is added to the map by default.
	L.Map.mergeOptions({
		zoomControl: true
	});
	
	L.Map.addInitHook(function () {
		if (this.options.zoomControl) {
			this.zoomControl = new L.Control.Zoom();
			this.addControl(this.zoomControl);
		}
	});
	
	// @namespace Control.Zoom
	// @factory L.control.zoom(options: Control.Zoom options)
	// Creates a zoom control
	L.control.zoom = function (options) {
		return new L.Control.Zoom(options);
	};
	
	
	
	/*
	 * @class Control.Attribution
	 * @aka L.Control.Attribution
	 * @inherits Control
	 *
	 * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
	 */
	
	L.Control.Attribution = L.Control.extend({
		// @section
		// @aka Control.Attribution options
		options: {
			position: 'bottomright',
	
			// @option prefix: String = 'Leaflet'
			// The HTML text shown before the attributions. Pass `false` to disable.
			prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
	
			this._attributions = {};
		},
	
		onAdd: function (map) {
			map.attributionControl = this;
			this._container = L.DomUtil.create('div', 'leaflet-control-attribution');
			if (L.DomEvent) {
				L.DomEvent.disableClickPropagation(this._container);
			}
	
			// TODO ugly, refactor
			for (var i in map._layers) {
				if (map._layers[i].getAttribution) {
					this.addAttribution(map._layers[i].getAttribution());
				}
			}
	
			this._update();
	
			return this._container;
		},
	
		// @method setPrefix(prefix: String): this
		// Sets the text before the attributions.
		setPrefix: function (prefix) {
			this.options.prefix = prefix;
			this._update();
			return this;
		},
	
		// @method addAttribution(text: String): this
		// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
		addAttribution: function (text) {
			if (!text) { return this; }
	
			if (!this._attributions[text]) {
				this._attributions[text] = 0;
			}
			this._attributions[text]++;
	
			this._update();
	
			return this;
		},
	
		// @method removeAttribution(text: String): this
		// Removes an attribution text.
		removeAttribution: function (text) {
			if (!text) { return this; }
	
			if (this._attributions[text]) {
				this._attributions[text]--;
				this._update();
			}
	
			return this;
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			var attribs = [];
	
			for (var i in this._attributions) {
				if (this._attributions[i]) {
					attribs.push(i);
				}
			}
	
			var prefixAndAttribs = [];
	
			if (this.options.prefix) {
				prefixAndAttribs.push(this.options.prefix);
			}
			if (attribs.length) {
				prefixAndAttribs.push(attribs.join(', '));
			}
	
			this._container.innerHTML = prefixAndAttribs.join(' | ');
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option attributionControl: Boolean = true
	// Whether a [attribution control](#control-attribution) is added to the map by default.
	L.Map.mergeOptions({
		attributionControl: true
	});
	
	L.Map.addInitHook(function () {
		if (this.options.attributionControl) {
			new L.Control.Attribution().addTo(this);
		}
	});
	
	// @namespace Control.Attribution
	// @factory L.control.attribution(options: Control.Attribution options)
	// Creates an attribution control.
	L.control.attribution = function (options) {
		return new L.Control.Attribution(options);
	};
	
	
	
	/*
	 * @class Control.Scale
	 * @aka L.Control.Scale
	 * @inherits Control
	 *
	 * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * L.control.scale().addTo(map);
	 * ```
	 */
	
	L.Control.Scale = L.Control.extend({
		// @section
		// @aka Control.Scale options
		options: {
			position: 'bottomleft',
	
			// @option maxWidth: Number = 100
			// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
			maxWidth: 100,
	
			// @option metric: Boolean = True
			// Whether to show the metric scale line (m/km).
			metric: true,
	
			// @option imperial: Boolean = True
			// Whether to show the imperial scale line (mi/ft).
			imperial: true
	
			// @option updateWhenIdle: Boolean = false
			// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
		},
	
		onAdd: function (map) {
			var className = 'leaflet-control-scale',
			    container = L.DomUtil.create('div', className),
			    options = this.options;
	
			this._addScales(options, className + '-line', container);
	
			map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
			map.whenReady(this._update, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		},
	
		_addScales: function (options, className, container) {
			if (options.metric) {
				this._mScale = L.DomUtil.create('div', className, container);
			}
			if (options.imperial) {
				this._iScale = L.DomUtil.create('div', className, container);
			}
		},
	
		_update: function () {
			var map = this._map,
			    y = map.getSize().y / 2;
	
			var maxMeters = map.distance(
					map.containerPointToLatLng([0, y]),
					map.containerPointToLatLng([this.options.maxWidth, y]));
	
			this._updateScales(maxMeters);
		},
	
		_updateScales: function (maxMeters) {
			if (this.options.metric && maxMeters) {
				this._updateMetric(maxMeters);
			}
			if (this.options.imperial && maxMeters) {
				this._updateImperial(maxMeters);
			}
		},
	
		_updateMetric: function (maxMeters) {
			var meters = this._getRoundNum(maxMeters),
			    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
	
			this._updateScale(this._mScale, label, meters / maxMeters);
		},
	
		_updateImperial: function (maxMeters) {
			var maxFeet = maxMeters * 3.2808399,
			    maxMiles, miles, feet;
	
			if (maxFeet > 5280) {
				maxMiles = maxFeet / 5280;
				miles = this._getRoundNum(maxMiles);
				this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
	
			} else {
				feet = this._getRoundNum(maxFeet);
				this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
			}
		},
	
		_updateScale: function (scale, text, ratio) {
			scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
			scale.innerHTML = text;
		},
	
		_getRoundNum: function (num) {
			var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
			    d = num / pow10;
	
			d = d >= 10 ? 10 :
			    d >= 5 ? 5 :
			    d >= 3 ? 3 :
			    d >= 2 ? 2 : 1;
	
			return pow10 * d;
		}
	});
	
	
	// @factory L.control.scale(options?: Control.Scale options)
	// Creates an scale control with the given options.
	L.control.scale = function (options) {
		return new L.Control.Scale(options);
	};
	
	
	
	/*
	 * @class Control.Layers
	 * @aka L.Control.Layers
	 * @inherits Control
	 *
	 * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control.html)). Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * var baseLayers = {
	 * 	"Mapbox": mapbox,
	 * 	"OpenStreetMap": osm
	 * };
	 *
	 * var overlays = {
	 * 	"Marker": marker,
	 * 	"Roads": roadsLayer
	 * };
	 *
	 * L.control.layers(baseLayers, overlays).addTo(map);
	 * ```
	 *
	 * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
	 *
	 * ```js
	 * {
	 *     "<someName1>": layer1,
	 *     "<someName2>": layer2
	 * }
	 * ```
	 *
	 * The layer names can contain HTML, which allows you to add additional styling to the items:
	 *
	 * ```js
	 * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
	 * ```
	 */
	
	
	L.Control.Layers = L.Control.extend({
		// @section
		// @aka Control.Layers options
		options: {
			// @option collapsed: Boolean = true
			// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
			collapsed: true,
			position: 'topright',
	
			// @option autoZIndex: Boolean = true
			// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
			autoZIndex: true,
	
			// @option hideSingleBase: Boolean = false
			// If `true`, the base layers in the control will be hidden when there is only one.
			hideSingleBase: false,
	
			// @option sortLayers: Boolean = false
			// Whether to sort the layers. When `false`, layers will keep the order
			// in which they were added to the control.
			sortLayers: false,
	
			// @option sortFunction: Function = *
			// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
			// that will be used for sorting the layers, when `sortLayers` is `true`.
			// The function receives both the `L.Layer` instances and their names, as in
			// `sortFunction(layerA, layerB, nameA, nameB)`.
			// By default, it sorts layers alphabetically by their name.
			sortFunction: function (layerA, layerB, nameA, nameB) {
				return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
			}
		},
	
		initialize: function (baseLayers, overlays, options) {
			L.setOptions(this, options);
	
			this._layers = [];
			this._lastZIndex = 0;
			this._handlingClick = false;
	
			for (var i in baseLayers) {
				this._addLayer(baseLayers[i], i);
			}
	
			for (i in overlays) {
				this._addLayer(overlays[i], i, true);
			}
		},
	
		onAdd: function (map) {
			this._initLayout();
			this._update();
	
			this._map = map;
			map.on('zoomend', this._checkDisabledLayers, this);
	
			return this._container;
		},
	
		onRemove: function () {
			this._map.off('zoomend', this._checkDisabledLayers, this);
	
			for (var i = 0; i < this._layers.length; i++) {
				this._layers[i].layer.off('add remove', this._onLayerChange, this);
			}
		},
	
		// @method addBaseLayer(layer: Layer, name: String): this
		// Adds a base layer (radio button entry) with the given name to the control.
		addBaseLayer: function (layer, name) {
			this._addLayer(layer, name);
			return (this._map) ? this._update() : this;
		},
	
		// @method addOverlay(layer: Layer, name: String): this
		// Adds an overlay (checkbox entry) with the given name to the control.
		addOverlay: function (layer, name) {
			this._addLayer(layer, name, true);
			return (this._map) ? this._update() : this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Remove the given layer from the control.
		removeLayer: function (layer) {
			layer.off('add remove', this._onLayerChange, this);
	
			var obj = this._getLayer(L.stamp(layer));
			if (obj) {
				this._layers.splice(this._layers.indexOf(obj), 1);
			}
			return (this._map) ? this._update() : this;
		},
	
		// @method expand(): this
		// Expand the control container if collapsed.
		expand: function () {
			L.DomUtil.addClass(this._container, 'leaflet-control-layers-expanded');
			this._form.style.height = null;
			var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
			if (acceptableHeight < this._form.clientHeight) {
				L.DomUtil.addClass(this._form, 'leaflet-control-layers-scrollbar');
				this._form.style.height = acceptableHeight + 'px';
			} else {
				L.DomUtil.removeClass(this._form, 'leaflet-control-layers-scrollbar');
			}
			this._checkDisabledLayers();
			return this;
		},
	
		// @method collapse(): this
		// Collapse the control container if expanded.
		collapse: function () {
			L.DomUtil.removeClass(this._container, 'leaflet-control-layers-expanded');
			return this;
		},
	
		_initLayout: function () {
			var className = 'leaflet-control-layers',
			    container = this._container = L.DomUtil.create('div', className),
			    collapsed = this.options.collapsed;
	
			// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
			container.setAttribute('aria-haspopup', true);
	
			L.DomEvent.disableClickPropagation(container);
			if (!L.Browser.touch) {
				L.DomEvent.disableScrollPropagation(container);
			}
	
			var form = this._form = L.DomUtil.create('form', className + '-list');
	
			if (collapsed) {
				this._map.on('click', this.collapse, this);
	
				if (!L.Browser.android) {
					L.DomEvent.on(container, {
						mouseenter: this.expand,
						mouseleave: this.collapse
					}, this);
				}
			}
	
			var link = this._layersLink = L.DomUtil.create('a', className + '-toggle', container);
			link.href = '#';
			link.title = 'Layers';
	
			if (L.Browser.touch) {
				L.DomEvent
				    .on(link, 'click', L.DomEvent.stop)
				    .on(link, 'click', this.expand, this);
			} else {
				L.DomEvent.on(link, 'focus', this.expand, this);
			}
	
			// work around for Firefox Android issue https://github.com/Leaflet/Leaflet/issues/2033
			L.DomEvent.on(form, 'click', function () {
				setTimeout(L.bind(this._onInputClick, this), 0);
			}, this);
	
			// TODO keyboard accessibility
	
			if (!collapsed) {
				this.expand();
			}
	
			this._baseLayersList = L.DomUtil.create('div', className + '-base', form);
			this._separator = L.DomUtil.create('div', className + '-separator', form);
			this._overlaysList = L.DomUtil.create('div', className + '-overlays', form);
	
			container.appendChild(form);
		},
	
		_getLayer: function (id) {
			for (var i = 0; i < this._layers.length; i++) {
	
				if (this._layers[i] && L.stamp(this._layers[i].layer) === id) {
					return this._layers[i];
				}
			}
		},
	
		_addLayer: function (layer, name, overlay) {
			layer.on('add remove', this._onLayerChange, this);
	
			this._layers.push({
				layer: layer,
				name: name,
				overlay: overlay
			});
	
			if (this.options.sortLayers) {
				this._layers.sort(L.bind(function (a, b) {
					return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
				}, this));
			}
	
			if (this.options.autoZIndex && layer.setZIndex) {
				this._lastZIndex++;
				layer.setZIndex(this._lastZIndex);
			}
		},
	
		_update: function () {
			if (!this._container) { return this; }
	
			L.DomUtil.empty(this._baseLayersList);
			L.DomUtil.empty(this._overlaysList);
	
			var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
	
			for (i = 0; i < this._layers.length; i++) {
				obj = this._layers[i];
				this._addItem(obj);
				overlaysPresent = overlaysPresent || obj.overlay;
				baseLayersPresent = baseLayersPresent || !obj.overlay;
				baseLayersCount += !obj.overlay ? 1 : 0;
			}
	
			// Hide base layers section if there's only one layer.
			if (this.options.hideSingleBase) {
				baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
				this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
			}
	
			this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	
			return this;
		},
	
		_onLayerChange: function (e) {
			if (!this._handlingClick) {
				this._update();
			}
	
			var obj = this._getLayer(L.stamp(e.target));
	
			// @namespace Map
			// @section Layer events
			// @event baselayerchange: LayersControlEvent
			// Fired when the base layer is changed through the [layer control](#control-layers).
			// @event overlayadd: LayersControlEvent
			// Fired when an overlay is selected through the [layer control](#control-layers).
			// @event overlayremove: LayersControlEvent
			// Fired when an overlay is deselected through the [layer control](#control-layers).
			// @namespace Control.Layers
			var type = obj.overlay ?
				(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
				(e.type === 'add' ? 'baselayerchange' : null);
	
			if (type) {
				this._map.fire(type, obj);
			}
		},
	
		// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
		_createRadioElement: function (name, checked) {
	
			var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
					name + '"' + (checked ? ' checked="checked"' : '') + '/>';
	
			var radioFragment = document.createElement('div');
			radioFragment.innerHTML = radioHtml;
	
			return radioFragment.firstChild;
		},
	
		_addItem: function (obj) {
			var label = document.createElement('label'),
			    checked = this._map.hasLayer(obj.layer),
			    input;
	
			if (obj.overlay) {
				input = document.createElement('input');
				input.type = 'checkbox';
				input.className = 'leaflet-control-layers-selector';
				input.defaultChecked = checked;
			} else {
				input = this._createRadioElement('leaflet-base-layers', checked);
			}
	
			input.layerId = L.stamp(obj.layer);
	
			L.DomEvent.on(input, 'click', this._onInputClick, this);
	
			var name = document.createElement('span');
			name.innerHTML = ' ' + obj.name;
	
			// Helps from preventing layer control flicker when checkboxes are disabled
			// https://github.com/Leaflet/Leaflet/issues/2771
			var holder = document.createElement('div');
	
			label.appendChild(holder);
			holder.appendChild(input);
			holder.appendChild(name);
	
			var container = obj.overlay ? this._overlaysList : this._baseLayersList;
			container.appendChild(label);
	
			this._checkDisabledLayers();
			return label;
		},
	
		_onInputClick: function () {
			var inputs = this._form.getElementsByTagName('input'),
			    input, layer, hasLayer;
			var addedLayers = [],
			    removedLayers = [];
	
			this._handlingClick = true;
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
				hasLayer = this._map.hasLayer(layer);
	
				if (input.checked && !hasLayer) {
					addedLayers.push(layer);
	
				} else if (!input.checked && hasLayer) {
					removedLayers.push(layer);
				}
			}
	
			// Bugfix issue 2318: Should remove all old layers before readding new ones
			for (i = 0; i < removedLayers.length; i++) {
				this._map.removeLayer(removedLayers[i]);
			}
			for (i = 0; i < addedLayers.length; i++) {
				this._map.addLayer(addedLayers[i]);
			}
	
			this._handlingClick = false;
	
			this._refocusOnMap();
		},
	
		_checkDisabledLayers: function () {
			var inputs = this._form.getElementsByTagName('input'),
			    input,
			    layer,
			    zoom = this._map.getZoom();
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
				input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
				                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);
	
			}
		},
	
		_expand: function () {
			// Backward compatibility, remove me in 1.1.
			return this.expand();
		},
	
		_collapse: function () {
			// Backward compatibility, remove me in 1.1.
			return this.collapse();
		}
	
	});
	
	
	// @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
	// Creates an attribution control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
	L.control.layers = function (baseLayers, overlays, options) {
		return new L.Control.Layers(baseLayers, overlays, options);
	};
	
	
	
	}(window, document));
	//# sourceMappingURL=leaflet-src.map

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*  weak */
	
	exports.computeMinimalBounds = computeMinimalBounds;
	exports.computeLargestGap = computeLargestGap;
	exports.getAllFeaturesPoints = getAllFeaturesPoints;
	exports.getCanonicalRowKey = getCanonicalRowKey;
	
	var _leafletSrc = __webpack_require__(1412);
	
	var _leafletSrc2 = _interopRequireDefault(_leafletSrc);
	
	var _d2 = __webpack_require__(873);
	
	var _d3 = _interopRequireDefault(_d2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function computeMinimalBounds(features) {
	    var points = getAllFeaturesPoints(features);
	    var gap = computeLargestGap(points, function (d) {
	        return d[0];
	    });
	
	    var _d3$extent = _d3.default.extent(points, function (d) {
	        return d[0];
	    }),
	        _d3$extent2 = _slicedToArray(_d3$extent, 2),
	        west = _d3$extent2[0],
	        east = _d3$extent2[1];
	
	    var _d3$extent3 = _d3.default.extent(points, function (d) {
	        return d[1];
	    }),
	        _d3$extent4 = _slicedToArray(_d3$extent3, 2),
	        north = _d3$extent4[0],
	        south = _d3$extent4[1];
	
	    var normalGapSize = gap[1] - gap[0];
	    var antemeridianGapSize = 180 + west + (180 - east);
	
	    if (antemeridianGapSize > normalGapSize) {
	        return _leafletSrc2.default.latLngBounds(_leafletSrc2.default.latLng(south, west), // SW
	        _leafletSrc2.default.latLng(north, east) // NE
	        );
	    } else {
	        return _leafletSrc2.default.latLngBounds(_leafletSrc2.default.latLng(south, -360 + gap[1]), // SW
	        _leafletSrc2.default.latLng(north, gap[0]) // NE
	        );
	    }
	}
	
	function computeLargestGap(items) {
	    var valueAccessor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (d) {
	        return d;
	    };
	
	    var _d3$extent5 = _d3.default.extent(items, valueAccessor),
	        _d3$extent6 = _slicedToArray(_d3$extent5, 2),
	        xMin = _d3$extent6[0],
	        xMax = _d3$extent6[1];
	
	    if (xMin === xMax) {
	        return [xMin, xMax];
	    }
	
	    var buckets = [];
	    var bucketSize = (xMax - xMin) / items.length;
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var item = _step.value;
	
	            var x = valueAccessor(item);
	            var k = Math.floor((x - xMin) / bucketSize);
	            if (buckets[k] === undefined) {
	                buckets[k] = [x, x];
	            } else {
	                buckets[k] = [Math.min(x, buckets[k][0]), Math.max(x, buckets[k][1])];
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    var largestGap = [0, 0];
	    for (var i = 0; i < items.length; i++) {
	        if (buckets[i + 1] === undefined) {
	            buckets[i + 1] = buckets[i];
	        } else if (buckets[i + 1][0] - buckets[i][1] > largestGap[1] - largestGap[0]) {
	            largestGap = [buckets[i][1], buckets[i + 1][0]];
	        }
	    }
	    return largestGap;
	}
	
	function getAllFeaturesPoints(features) {
	    var points = [];
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = features[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var feature = _step2.value;
	
	            if (feature.geometry.type === "Polygon") {
	                var _iteratorNormalCompletion3 = true;
	                var _didIteratorError3 = false;
	                var _iteratorError3 = undefined;
	
	                try {
	                    for (var _iterator3 = feature.geometry.coordinates[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                        var coordinates = _step3.value;
	
	                        points = points.concat(coordinates);
	                    }
	                } catch (err) {
	                    _didIteratorError3 = true;
	                    _iteratorError3 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                            _iterator3.return();
	                        }
	                    } finally {
	                        if (_didIteratorError3) {
	                            throw _iteratorError3;
	                        }
	                    }
	                }
	            } else if (feature.geometry.type === "MultiPolygon") {
	                var _iteratorNormalCompletion4 = true;
	                var _didIteratorError4 = false;
	                var _iteratorError4 = undefined;
	
	                try {
	                    for (var _iterator4 = feature.geometry.coordinates[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                        var coordinatesList = _step4.value;
	                        var _iteratorNormalCompletion5 = true;
	                        var _didIteratorError5 = false;
	                        var _iteratorError5 = undefined;
	
	                        try {
	                            for (var _iterator5 = coordinatesList[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                                var _coordinates = _step5.value;
	
	                                points = points.concat(_coordinates);
	                            }
	                        } catch (err) {
	                            _didIteratorError5 = true;
	                            _iteratorError5 = err;
	                        } finally {
	                            try {
	                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                                    _iterator5.return();
	                                }
	                            } finally {
	                                if (_didIteratorError5) {
	                                    throw _iteratorError5;
	                                }
	                            }
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError4 = true;
	                    _iteratorError4 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                            _iterator4.return();
	                        }
	                    } finally {
	                        if (_didIteratorError4) {
	                            throw _iteratorError4;
	                        }
	                    }
	                }
	            } else {
	                console.warn("Unimplemented feature.geometry.type", feature.geometry.type);
	            }
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return points;
	}
	
	var STATE_CODES = [["AL", "Alabama"], ["AK", "Alaska"], ["AS", "American Samoa"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"], ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["DC", "District Of Columbia"], ["FM", "Federated States Of Micronesia"], ["FL", "Florida"], ["GA", "Georgia"], ["GU", "Guam"], ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"], ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"], ["MH", "Marshall Islands"], ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"], ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"], ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"], ["NY", "New York"], ["NC", "North Carolina"], ["ND", "North Dakota"], ["MP", "Northern Mariana Islands"], ["OH", "Ohio"], ["OK", "Oklahoma"], ["OR", "Oregon"], ["PW", "Palau"], ["PA", "Pennsylvania"], ["PR", "Puerto Rico"], ["RI", "Rhode Island"], ["SC", "South Carolina"], ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"], ["VI", "Virgin Islands"], ["VA", "Virginia"], ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"]];
	
	var stateNamesMap = new Map(STATE_CODES.map(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        key = _ref2[0],
	        name = _ref2[1];
	
	    return [name.toLowerCase(), key.toLowerCase()];
	}));
	
	/**
	 * Canonicalizes row values to match those in the GeoJSONs.
	 *
	 * Currently transforms US state names to state codes for the "us_states" region map, and just lowercases all others.
	 */
	function getCanonicalRowKey(key, region) {
	    key = String(key).toLowerCase();
	    // Special case for supporting both US state names and state codes
	    // This should be ok because we know there's no overlap between state names and codes, and we know the "us_states" region map expects codes
	    if (region === "us_states" && stateNamesMap.has(key)) {
	        return stateNamesMap.get(key);
	    } else {
	        return key;
	    }
	}

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	/* @flow */
	'use strict';
	
	// # simple-statistics
	//
	// A simple, literate statistics system.
	
	var ss = module.exports = {};
	
	// Linear Regression
	ss.linearRegression = __webpack_require__(1415);
	ss.linearRegressionLine = __webpack_require__(1416);
	ss.standardDeviation = __webpack_require__(1417);
	ss.rSquared = __webpack_require__(1422);
	ss.mode = __webpack_require__(1423);
	ss.modeFast = __webpack_require__(1426);
	ss.modeSorted = __webpack_require__(1425);
	ss.min = __webpack_require__(1427);
	ss.max = __webpack_require__(1428);
	ss.minSorted = __webpack_require__(1429);
	ss.maxSorted = __webpack_require__(1430);
	ss.sum = __webpack_require__(1421);
	ss.sumSimple = __webpack_require__(1431);
	ss.product = __webpack_require__(1432);
	ss.quantile = __webpack_require__(1433);
	ss.quantileSorted = __webpack_require__(1434);
	ss.iqr = ss.interquartileRange = __webpack_require__(1436);
	ss.medianAbsoluteDeviation = ss.mad = __webpack_require__(1437);
	ss.chunk = __webpack_require__(1439);
	ss.sampleWithReplacement = __webpack_require__(1440);
	ss.shuffle = __webpack_require__(1441);
	ss.shuffleInPlace = __webpack_require__(1442);
	ss.sample = __webpack_require__(1443);
	ss.ckmeans = __webpack_require__(1444);
	ss.uniqueCountSorted = __webpack_require__(1445);
	ss.sumNthPowerDeviations = __webpack_require__(1419);
	ss.equalIntervalBreaks = __webpack_require__(1446);
	
	// sample statistics
	ss.sampleCovariance = __webpack_require__(1447);
	ss.sampleCorrelation = __webpack_require__(1448);
	ss.sampleVariance = __webpack_require__(1450);
	ss.sampleStandardDeviation = __webpack_require__(1449);
	ss.sampleSkewness = __webpack_require__(1451);
	
	// combinatorics
	ss.permutationsHeap = __webpack_require__(1452);
	ss.combinations = __webpack_require__(1453);
	ss.combinationsReplacement = __webpack_require__(1454);
	
	// measures of centrality
	ss.addToMean = __webpack_require__(1455);
	ss.combineMeans = __webpack_require__(1456);
	ss.combineVariances = __webpack_require__(1457);
	ss.geometricMean = __webpack_require__(1458);
	ss.harmonicMean = __webpack_require__(1459);
	ss.mean = ss.average = __webpack_require__(1420);
	ss.median = __webpack_require__(1438);
	ss.medianSorted = __webpack_require__(1460);
	ss.subtractFromMean = __webpack_require__(1461);
	
	ss.rootMeanSquare = ss.rms = __webpack_require__(1462);
	ss.variance = __webpack_require__(1418);
	ss.tTest = __webpack_require__(1463);
	ss.tTestTwoSample = __webpack_require__(1464);
	// ss.jenks = require('./src/jenks');
	
	// Classifiers
	ss.bayesian = __webpack_require__(1465);
	ss.perceptron = __webpack_require__(1466);
	
	// Distribution-related methods
	ss.epsilon = __webpack_require__(1467); // We make ε available to the test suite.
	ss.factorial = __webpack_require__(1468);
	ss.bernoulliDistribution = __webpack_require__(1469);
	ss.binomialDistribution = __webpack_require__(1470);
	ss.poissonDistribution = __webpack_require__(1471);
	ss.chiSquaredGoodnessOfFit = __webpack_require__(1472);
	
	// Normal distribution
	ss.zScore = __webpack_require__(1474);
	ss.cumulativeStdNormalProbability = __webpack_require__(1475);
	ss.standardNormalTable = __webpack_require__(1476);
	ss.errorFunction = ss.erf = __webpack_require__(1477);
	ss.inverseErrorFunction = __webpack_require__(1478);
	ss.probit = __webpack_require__(1479);
	ss.mixin = __webpack_require__(1480);
	
	// Root-finding methods
	ss.bisect = __webpack_require__(1481);


/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * [Simple linear regression](http://en.wikipedia.org/wiki/Simple_linear_regression)
	 * is a simple way to find a fitted line
	 * between a set of coordinates. This algorithm finds the slope and y-intercept of a regression line
	 * using the least sum of squares.
	 *
	 * @param {Array<Array<number>>} data an array of two-element of arrays,
	 * like `[[0, 1], [2, 3]]`
	 * @returns {Object} object containing slope and intersect of regression line
	 * @example
	 * linearRegression([[0, 0], [1, 1]]); // => { m: 1, b: 0 }
	 */
	function linearRegression(data/*: Array<Array<number>> */)/*: { m: number, b: number } */ {
	
	    var m, b;
	
	    // Store data length in a local variable to reduce
	    // repeated object property lookups
	    var dataLength = data.length;
	
	    //if there's only one point, arbitrarily choose a slope of 0
	    //and a y-intercept of whatever the y of the initial point is
	    if (dataLength === 1) {
	        m = 0;
	        b = data[0][1];
	    } else {
	        // Initialize our sums and scope the `m` and `b`
	        // variables that define the line.
	        var sumX = 0, sumY = 0,
	            sumXX = 0, sumXY = 0;
	
	        // Use local variables to grab point values
	        // with minimal object property lookups
	        var point, x, y;
	
	        // Gather the sum of all x values, the sum of all
	        // y values, and the sum of x^2 and (x*y) for each
	        // value.
	        //
	        // In math notation, these would be SS_x, SS_y, SS_xx, and SS_xy
	        for (var i = 0; i < dataLength; i++) {
	            point = data[i];
	            x = point[0];
	            y = point[1];
	
	            sumX += x;
	            sumY += y;
	
	            sumXX += x * x;
	            sumXY += x * y;
	        }
	
	        // `m` is the slope of the regression line
	        m = ((dataLength * sumXY) - (sumX * sumY)) /
	            ((dataLength * sumXX) - (sumX * sumX));
	
	        // `b` is the y-intercept of the line.
	        b = (sumY / dataLength) - ((m * sumX) / dataLength);
	    }
	
	    // Return both values as an object.
	    return {
	        m: m,
	        b: b
	    };
	}
	
	
	module.exports = linearRegression;


/***/ }),
/* 1416 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * Given the output of `linearRegression`: an object
	 * with `m` and `b` values indicating slope and intercept,
	 * respectively, generate a line function that translates
	 * x values into y values.
	 *
	 * @param {Object} mb object with `m` and `b` members, representing
	 * slope and intersect of desired line
	 * @returns {Function} method that computes y-value at any given
	 * x-value on the line.
	 * @example
	 * var l = linearRegressionLine(linearRegression([[0, 0], [1, 1]]));
	 * l(0) // = 0
	 * l(2) // = 2
	 * linearRegressionLine({ b: 0, m: 1 })(1); // => 1
	 * linearRegressionLine({ b: 1, m: 1 })(1); // => 2
	 */
	function linearRegressionLine(mb/*: { b: number, m: number }*/)/*: Function */ {
	    // Return a function that computes a `y` value for each
	    // x value it is given, based on the values of `b` and `a`
	    // that we just computed.
	    return function(x) {
	        return mb.b + (mb.m * x);
	    };
	}
	
	module.exports = linearRegressionLine;


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var variance = __webpack_require__(1418);
	
	/**
	 * The [standard deviation](http://en.wikipedia.org/wiki/Standard_deviation)
	 * is the square root of the variance. This is also known as the population
	 * standard deviation. It's useful for measuring the amount
	 * of variation or dispersion in a set of values.
	 *
	 * Standard deviation is only appropriate for full-population knowledge: for
	 * samples of a population, {@link sampleStandardDeviation} is
	 * more appropriate.
	 *
	 * @param {Array<number>} x input
	 * @returns {number} standard deviation
	 * @example
	 * variance([2, 4, 4, 4, 5, 5, 7, 9]); // => 4
	 * standardDeviation([2, 4, 4, 4, 5, 5, 7, 9]); // => 2
	 */
	function standardDeviation(x /*: Array<number> */)/*:number*/ {
	    if (x.length === 1) {
	        return 0;
	    }
	    var v = variance(x);
	    return Math.sqrt(v);
	}
	
	module.exports = standardDeviation;


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var sumNthPowerDeviations = __webpack_require__(1419);
	
	/**
	 * The [variance](http://en.wikipedia.org/wiki/Variance)
	 * is the sum of squared deviations from the mean.
	 *
	 * This is an implementation of variance, not sample variance:
	 * see the `sampleVariance` method if you want a sample measure.
	 *
	 * @param {Array<number>} x a population of one or more data points
	 * @returns {number} variance: a value greater than or equal to zero.
	 * zero indicates that all values are identical.
	 * @throws {Error} if x's length is 0
	 * @example
	 * variance([1, 2, 3, 4, 5, 6]); // => 2.9166666666666665
	 */
	function variance(x/*: Array<number> */)/*:number*/ {
	    // The variance of no numbers is null
	    if (x.length === 0) {
	        throw new Error('variance requires at least one data point');
	    }
	
	    // Find the mean of squared deviations between the
	    // mean value and each value.
	    return sumNthPowerDeviations(x, 2) / x.length;
	}
	
	module.exports = variance;


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var mean = __webpack_require__(1420);
	
	/**
	 * The sum of deviations to the Nth power.
	 * When n=2 it's the sum of squared deviations.
	 * When n=3 it's the sum of cubed deviations.
	 *
	 * @param {Array<number>} x
	 * @param {number} n power
	 * @returns {number} sum of nth power deviations
	 * @example
	 * var input = [1, 2, 3];
	 * // since the variance of a set is the mean squared
	 * // deviations, we can calculate that with sumNthPowerDeviations:
	 * var variance = sumNthPowerDeviations(input) / input.length;
	 */
	function sumNthPowerDeviations(x/*: Array<number> */, n/*: number */)/*:number*/ {
	    var meanValue = mean(x),
	        sum = 0;
	
	    for (var i = 0; i < x.length; i++) {
	        sum += Math.pow(x[i] - meanValue, n);
	    }
	
	    return sum;
	}
	
	module.exports = sumNthPowerDeviations;


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var sum = __webpack_require__(1421);
	
	/**
	 * The mean, _also known as average_,
	 * is the sum of all values over the number of values.
	 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
	 * a method of finding a typical or central value of a set of numbers.
	 *
	 * This runs on `O(n)`, linear time in respect to the array
	 *
	 * @param {Array<number>} x sample of one or more data points
	 * @throws {Error} if the the length of x is less than one
	 * @returns {number} mean
	 * @example
	 * mean([0, 10]); // => 5
	 */
	function mean(x /*: Array<number> */)/*:number*/ {
	    // The mean of no numbers is null
	    if (x.length === 0) {
	        throw new Error('mean requires at least one data point');
	    }
	
	    return sum(x) / x.length;
	}
	
	module.exports = mean;


/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * Our default sum is the [Kahan summation algorithm](https://en.wikipedia.org/wiki/Kahan_summation_algorithm) is
	 * a method for computing the sum of a list of numbers while correcting
	 * for floating-point errors. Traditionally, sums are calculated as many
	 * successive additions, each one with its own floating-point roundoff. These
	 * losses in precision add up as the number of numbers increases. This alternative
	 * algorithm is more accurate than the simple way of calculating sums by simple
	 * addition.
	 *
	 * This runs on `O(n)`, linear time in respect to the array
	 *
	 * @param {Array<number>} x input
	 * @return {number} sum of all input numbers
	 * @example
	 * sum([1, 2, 3]); // => 6
	 */
	function sum(x/*: Array<number> */)/*: number */ {
	
	    // like the traditional sum algorithm, we keep a running
	    // count of the current sum.
	    var sum = 0;
	
	    // but we also keep three extra variables as bookkeeping:
	    // most importantly, an error correction value. This will be a very
	    // small number that is the opposite of the floating point precision loss.
	    var errorCompensation = 0;
	
	    // this will be each number in the list corrected with the compensation value.
	    var correctedCurrentValue;
	
	    // and this will be the next sum
	    var nextSum;
	
	    for (var i = 0; i < x.length; i++) {
	        // first correct the value that we're going to add to the sum
	        correctedCurrentValue = x[i] - errorCompensation;
	
	        // compute the next sum. sum is likely a much larger number
	        // than correctedCurrentValue, so we'll lose precision here,
	        // and measure how much precision is lost in the next step
	        nextSum = sum + correctedCurrentValue;
	
	        // we intentionally didn't assign sum immediately, but stored
	        // it for now so we can figure out this: is (sum + nextValue) - nextValue
	        // not equal to 0? ideally it would be, but in practice it won't:
	        // it will be some very small number. that's what we record
	        // as errorCompensation.
	        errorCompensation = nextSum - sum - correctedCurrentValue;
	
	        // now that we've computed how much we'll correct for in the next
	        // loop, start treating the nextSum as the current sum.
	        sum = nextSum;
	    }
	
	    return sum;
	}
	
	module.exports = sum;


/***/ }),
/* 1422 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The [R Squared](http://en.wikipedia.org/wiki/Coefficient_of_determination)
	 * value of data compared with a function `f`
	 * is the sum of the squared differences between the prediction
	 * and the actual value.
	 *
	 * @param {Array<Array<number>>} x input data: this should be doubly-nested
	 * @param {Function} func function called on `[i][0]` values within the dataset
	 * @returns {number} r-squared value
	 * @example
	 * var samples = [[0, 0], [1, 1]];
	 * var regressionLine = linearRegressionLine(linearRegression(samples));
	 * rSquared(samples, regressionLine); // = 1 this line is a perfect fit
	 */
	function rSquared(x /*: Array<Array<number>> */, func /*: Function */) /*: number */ {
	    if (x.length < 2) { return 1; }
	
	    // Compute the average y value for the actual
	    // data set in order to compute the
	    // _total sum of squares_
	    var sum = 0, average;
	    for (var i = 0; i < x.length; i++) {
	        sum += x[i][1];
	    }
	    average = sum / x.length;
	
	    // Compute the total sum of squares - the
	    // squared difference between each point
	    // and the average of all points.
	    var sumOfSquares = 0;
	    for (var j = 0; j < x.length; j++) {
	        sumOfSquares += Math.pow(average - x[j][1], 2);
	    }
	
	    // Finally estimate the error: the squared
	    // difference between the estimate and the actual data
	    // value at each point.
	    var err = 0;
	    for (var k = 0; k < x.length; k++) {
	        err += Math.pow(x[k][1] - func(x[k][0]), 2);
	    }
	
	    // As the error grows larger, its ratio to the
	    // sum of squares increases and the r squared
	    // value grows lower.
	    return 1 - err / sumOfSquares;
	}
	
	module.exports = rSquared;


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var numericSort = __webpack_require__(1424),
	    modeSorted = __webpack_require__(1425);
	
	/**
	 * The [mode](http://bit.ly/W5K4Yt) is the number that appears in a list the highest number of times.
	 * There can be multiple modes in a list: in the event of a tie, this
	 * algorithm will return the most recently seen mode.
	 *
	 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
	 * a method of finding a typical or central value of a set of numbers.
	 *
	 * This runs on `O(nlog(n))` because it needs to sort the array internally
	 * before running an `O(n)` search to find the mode.
	 *
	 * @param {Array<number>} x input
	 * @returns {number} mode
	 * @example
	 * mode([0, 0, 1]); // => 0
	 */
	function mode(x /*: Array<number> */)/*:number*/ {
	    // Sorting the array lets us iterate through it below and be sure
	    // that every time we see a new number it's new and we'll never
	    // see the same number twice
	    return modeSorted(numericSort(x));
	}
	
	module.exports = mode;


/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * Sort an array of numbers by their numeric value, ensuring that the
	 * array is not changed in place.
	 *
	 * This is necessary because the default behavior of .sort
	 * in JavaScript is to sort arrays as string values
	 *
	 *     [1, 10, 12, 102, 20].sort()
	 *     // output
	 *     [1, 10, 102, 12, 20]
	 *
	 * @param {Array<number>} x input array
	 * @return {Array<number>} sorted array
	 * @private
	 * @example
	 * numericSort([3, 2, 1]) // => [1, 2, 3]
	 */
	function numericSort(x /*: Array<number> */) /*: Array<number> */ {
	    return x
	        // ensure the array is not changed in-place
	        .slice()
	        // comparator function that treats input as numeric
	        .sort(function(a, b) {
	            return a - b;
	        });
	}
	
	module.exports = numericSort;


/***/ }),
/* 1425 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The [mode](http://bit.ly/W5K4Yt) is the number that appears in a list the highest number of times.
	 * There can be multiple modes in a list: in the event of a tie, this
	 * algorithm will return the most recently seen mode.
	 *
	 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
	 * a method of finding a typical or central value of a set of numbers.
	 *
	 * This runs in `O(n)` because the input is sorted.
	 *
	 * @param {Array<number>} sorted a sample of one or more data points
	 * @returns {number} mode
	 * @throws {Error} if sorted is empty
	 * @example
	 * modeSorted([0, 0, 1]); // => 0
	 */
	function modeSorted(sorted /*: Array<number> */)/*:number*/ {
	
	    // Handle edge cases:
	    // The mode of an empty list is undefined
	    if (sorted.length === 0) {
	        throw new Error('mode requires at least one data point');
	    } else if (sorted.length === 1) {
	        return sorted[0];
	    }
	
	    // This assumes it is dealing with an array of size > 1, since size
	    // 0 and 1 are handled immediately. Hence it starts at index 1 in the
	    // array.
	    var last = sorted[0],
	        // store the mode as we find new modes
	        value = NaN,
	        // store how many times we've seen the mode
	        maxSeen = 0,
	        // how many times the current candidate for the mode
	        // has been seen
	        seenThis = 1;
	
	    // end at sorted.length + 1 to fix the case in which the mode is
	    // the highest number that occurs in the sequence. the last iteration
	    // compares sorted[i], which is undefined, to the highest number
	    // in the series
	    for (var i = 1; i < sorted.length + 1; i++) {
	        // we're seeing a new number pass by
	        if (sorted[i] !== last) {
	            // the last number is the new mode since we saw it more
	            // often than the old one
	            if (seenThis > maxSeen) {
	                maxSeen = seenThis;
	                value = last;
	            }
	            seenThis = 1;
	            last = sorted[i];
	        // if this isn't a new number, it's one more occurrence of
	        // the potential mode
	        } else { seenThis++; }
	    }
	    return value;
	}
	
	module.exports = modeSorted;


/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	/* globals Map: false */
	
	/**
	 * The [mode](http://bit.ly/W5K4Yt) is the number that appears in a list the highest number of times.
	 * There can be multiple modes in a list: in the event of a tie, this
	 * algorithm will return the most recently seen mode.
	 *
	 * modeFast uses a Map object to keep track of the mode, instead of the approach
	 * used with `mode`, a sorted array. As a result, it is faster
	 * than `mode` and supports any data type that can be compared with `==`.
	 * It also requires a
	 * [JavaScript environment with support for Map](https://kangax.github.io/compat-table/es6/#test-Map),
	 * and will throw an error if Map is not available.
	 *
	 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
	 * a method of finding a typical or central value of a set of numbers.
	 *
	 * @param {Array<*>} x a sample of one or more data points
	 * @returns {?*} mode
	 * @throws {ReferenceError} if the JavaScript environment doesn't support Map
	 * @throws {Error} if x is empty
	 * @example
	 * modeFast(['rabbits', 'rabbits', 'squirrels']); // => 'rabbits'
	 */
	function modeFast/*::<T>*/(x /*: Array<T> */)/*: ?T */ {
	
	    // This index will reflect the incidence of different values, indexing
	    // them like
	    // { value: count }
	    var index = new Map();
	
	    // A running `mode` and the number of times it has been encountered.
	    var mode;
	    var modeCount = 0;
	
	    for (var i = 0; i < x.length; i++) {
	        var newCount = index.get(x[i]);
	        if (newCount === undefined) {
	            newCount = 1;
	        } else {
	            newCount++;
	        }
	        if (newCount > modeCount) {
	            mode = x[i];
	            modeCount = newCount;
	        }
	        index.set(x[i], newCount);
	    }
	
	    if (modeCount === 0) {
	        throw new Error('mode requires at last one data point');
	    }
	
	    return mode;
	}
	
	module.exports = modeFast;


/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The min is the lowest number in the array. This runs on `O(n)`, linear time in respect to the array
	 *
	 * @param {Array<number>} x sample of one or more data points
	 * @throws {Error} if the the length of x is less than one
	 * @returns {number} minimum value
	 * @example
	 * min([1, 5, -10, 100, 2]); // => -10
	 */
	function min(x /*: Array<number> */)/*:number*/ {
	    var value;
	    for (var i = 0; i < x.length; i++) {
	        // On the first iteration of this loop, min is
	        // undefined and is thus made the minimum element in the array
	        if (value === undefined || x[i] < value) {
	            value = x[i];
	        }
	    }
	    if (value === undefined) {
	        throw new Error('min requires at least one data point');
	    }
	    return value;
	}
	
	module.exports = min;


/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * This computes the maximum number in an array.
	 *
	 * This runs on `O(n)`, linear time in respect to the array
	 *
	 * @param {Array<number>} x sample of one or more data points
	 * @returns {number} maximum value
	 * @throws {Error} if the the length of x is less than one
	 * @example
	 * max([1, 2, 3, 4]);
	 * // => 4
	 */
	function max(x /*: Array<number> */) /*:number*/ {
	    var value;
	    for (var i = 0; i < x.length; i++) {
	        // On the first iteration of this loop, max is
	        // undefined and is thus made the maximum element in the array
	        if (value === undefined || x[i] > value) {
	            value = x[i];
	        }
	    }
	    if (value === undefined) {
	        throw new Error('max requires at least one data point');
	    }
	    return value;
	}
	
	module.exports = max;


/***/ }),
/* 1429 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The minimum is the lowest number in the array. With a sorted array,
	 * the first element in the array is always the smallest, so this calculation
	 * can be done in one step, or constant time.
	 *
	 * @param {Array<number>} x input
	 * @returns {number} minimum value
	 * @example
	 * minSorted([-100, -10, 1, 2, 5]); // => -100
	 */
	function minSorted(x /*: Array<number> */)/*:number*/ {
	    return x[0];
	}
	
	module.exports = minSorted;


/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The maximum is the highest number in the array. With a sorted array,
	 * the last element in the array is always the largest, so this calculation
	 * can be done in one step, or constant time.
	 *
	 * @param {Array<number>} x input
	 * @returns {number} maximum value
	 * @example
	 * maxSorted([-100, -10, 1, 2, 5]); // => 5
	 */
	function maxSorted(x /*: Array<number> */)/*:number*/ {
	    return x[x.length - 1];
	}
	
	module.exports = maxSorted;


/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The simple [sum](https://en.wikipedia.org/wiki/Summation) of an array
	 * is the result of adding all numbers together, starting from zero.
	 *
	 * This runs on `O(n)`, linear time in respect to the array
	 *
	 * @param {Array<number>} x input
	 * @return {number} sum of all input numbers
	 * @example
	 * sumSimple([1, 2, 3]); // => 6
	 */
	function sumSimple(x/*: Array<number> */)/*: number */ {
	    var value = 0;
	    for (var i = 0; i < x.length; i++) {
	        value += x[i];
	    }
	    return value;
	}
	
	module.exports = sumSimple;


/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The [product](https://en.wikipedia.org/wiki/Product_(mathematics)) of an array
	 * is the result of multiplying all numbers together, starting using one as the multiplicative identity.
	 *
	 * This runs on `O(n)`, linear time in respect to the array
	 *
	 * @param {Array<number>} x input
	 * @return {number} product of all input numbers
	 * @example
	 * product([1, 2, 3, 4]); // => 24
	 */
	function product(x/*: Array<number> */)/*: number */ {
	    var value = 1;
	    for (var i = 0; i < x.length; i++) {
	        value *= x[i];
	    }
	    return value;
	}
	
	module.exports = product;


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var quantileSorted = __webpack_require__(1434);
	var quickselect = __webpack_require__(1435);
	
	/**
	 * The [quantile](https://en.wikipedia.org/wiki/Quantile):
	 * this is a population quantile, since we assume to know the entire
	 * dataset in this library. This is an implementation of the
	 * [Quantiles of a Population](http://en.wikipedia.org/wiki/Quantile#Quantiles_of_a_population)
	 * algorithm from wikipedia.
	 *
	 * Sample is a one-dimensional array of numbers,
	 * and p is either a decimal number from 0 to 1 or an array of decimal
	 * numbers from 0 to 1.
	 * In terms of a k/q quantile, p = k/q - it's just dealing with fractions or dealing
	 * with decimal values.
	 * When p is an array, the result of the function is also an array containing the appropriate
	 * quantiles in input order
	 *
	 * @param {Array<number>} x sample of one or more numbers
	 * @param {number} p the desired quantile, as a number between 0 and 1
	 * @returns {number} quantile
	 * @example
	 * quantile([3, 6, 7, 8, 8, 9, 10, 13, 15, 16, 20], 0.5); // => 9
	 */
	function quantile(x /*: Array<number> */, p /*: Array<number> | number */) {
	    var copy = x.slice();
	
	    if (Array.isArray(p)) {
	        // rearrange elements so that each element corresponding to a requested
	        // quantile is on a place it would be if the array was fully sorted
	        multiQuantileSelect(copy, p);
	        // Initialize the result array
	        var results = [];
	        // For each requested quantile
	        for (var i = 0; i < p.length; i++) {
	            results[i] = quantileSorted(copy, p[i]);
	        }
	        return results;
	    } else {
	        var idx = quantileIndex(copy.length, p);
	        quantileSelect(copy, idx, 0, copy.length - 1);
	        return quantileSorted(copy, p);
	    }
	}
	
	function quantileSelect(arr, k, left, right) {
	    if (k % 1 === 0) {
	        quickselect(arr, k, left, right);
	    } else {
	        k = Math.floor(k);
	        quickselect(arr, k, left, right);
	        quickselect(arr, k + 1, k + 1, right);
	    }
	}
	
	function multiQuantileSelect(arr, p) {
	    var indices = [0];
	    for (var i = 0; i < p.length; i++) {
	        indices.push(quantileIndex(arr.length, p[i]));
	    }
	    indices.push(arr.length - 1);
	    indices.sort(compare);
	
	    var stack = [0, indices.length - 1];
	
	    while (stack.length) {
	        var r = Math.ceil(stack.pop());
	        var l = Math.floor(stack.pop());
	        if (r - l <= 1) continue;
	
	        var m = Math.floor((l + r) / 2);
	        quantileSelect(arr, indices[m], indices[l], indices[r]);
	
	        stack.push(l, m, m, r);
	    }
	}
	
	function compare(a, b) {
	    return a - b;
	}
	
	function quantileIndex(len /*: number */, p /*: number */)/*:number*/ {
	    var idx = len * p;
	    if (p === 1) {
	        // If p is 1, directly return the last index
	        return len - 1;
	    } else if (p === 0) {
	        // If p is 0, directly return the first index
	        return 0;
	    } else if (idx % 1 !== 0) {
	        // If index is not integer, return the next index in array
	        return Math.ceil(idx) - 1;
	    } else if (len % 2 === 0) {
	        // If the list has even-length, we'll return the middle of two indices
	        // around quantile to indicate that we need an average value of the two
	        return idx - 0.5;
	    } else {
	        // Finally, in the simple case of an integer index
	        // with an odd-length list, return the index
	        return idx;
	    }
	}
	
	module.exports = quantile;


/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * This is the internal implementation of quantiles: when you know
	 * that the order is sorted, you don't need to re-sort it, and the computations
	 * are faster.
	 *
	 * @param {Array<number>} x sample of one or more data points
	 * @param {number} p desired quantile: a number between 0 to 1, inclusive
	 * @returns {number} quantile value
	 * @throws {Error} if p ix outside of the range from 0 to 1
	 * @throws {Error} if x is empty
	 * @example
	 * quantileSorted([3, 6, 7, 8, 8, 9, 10, 13, 15, 16, 20], 0.5); // => 9
	 */
	function quantileSorted(x /*: Array<number> */, p /*: number */)/*:number*/ {
	    var idx = x.length * p;
	    if (x.length === 0) {
	        throw new Error('quantile requires at least one data point.');
	    } else if (p < 0 || p > 1) {
	        throw new Error('quantiles must be between 0 and 1');
	    } else if (p === 1) {
	        // If p is 1, directly return the last element
	        return x[x.length - 1];
	    } else if (p === 0) {
	        // If p is 0, directly return the first element
	        return x[0];
	    } else if (idx % 1 !== 0) {
	        // If p is not integer, return the next element in array
	        return x[Math.ceil(idx) - 1];
	    } else if (x.length % 2 === 0) {
	        // If the list has even-length, we'll take the average of this number
	        // and the next value, if there is one
	        return (x[idx - 1] + x[idx]) / 2;
	    } else {
	        // Finally, in the simple case of an integer value
	        // with an odd-length list, return the x value at the index.
	        return x[idx];
	    }
	}
	
	module.exports = quantileSorted;


/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	module.exports = quickselect;
	
	/**
	 * Rearrange items in `arr` so that all items in `[left, k]` range are the smallest.
	 * The `k`-th element will have the `(k - left + 1)`-th smallest value in `[left, right]`.
	 *
	 * Implements Floyd-Rivest selection algorithm https://en.wikipedia.org/wiki/Floyd-Rivest_algorithm
	 *
	 * @private
	 * @param {Array<number>} arr input array
	 * @param {number} k pivot index
	 * @param {number} left left index
	 * @param {number} right right index
	 * @returns {undefined}
	 * @example
	 * var arr = [65, 28, 59, 33, 21, 56, 22, 95, 50, 12, 90, 53, 28, 77, 39];
	 * quickselect(arr, 8);
	 * // = [39, 28, 28, 33, 21, 12, 22, 50, 53, 56, 59, 65, 90, 77, 95]
	 */
	function quickselect(arr /*: Array<number> */, k /*: number */, left /*: number */, right /*: number */) {
	    left = left || 0;
	    right = right || (arr.length - 1);
	
	    while (right > left) {
	        // 600 and 0.5 are arbitrary constants chosen in the original paper to minimize execution time
	        if (right - left > 600) {
	            var n = right - left + 1;
	            var m = k - left + 1;
	            var z = Math.log(n);
	            var s = 0.5 * Math.exp(2 * z / 3);
	            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n);
	            if (m - n / 2 < 0) sd *= -1;
	            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
	            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
	            quickselect(arr, k, newLeft, newRight);
	        }
	
	        var t = arr[k];
	        var i = left;
	        var j = right;
	
	        swap(arr, left, k);
	        if (arr[right] > t) swap(arr, left, right);
	
	        while (i < j) {
	            swap(arr, i, j);
	            i++;
	            j--;
	            while (arr[i] < t) i++;
	            while (arr[j] > t) j--;
	        }
	
	        if (arr[left] === t) swap(arr, left, j);
	        else {
	            j++;
	            swap(arr, j, right);
	        }
	
	        if (j <= k) left = j + 1;
	        if (k <= j) right = j - 1;
	    }
	}
	
	function swap(arr, i, j) {
	    var tmp = arr[i];
	    arr[i] = arr[j];
	    arr[j] = tmp;
	}


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var quantile = __webpack_require__(1433);
	
	/**
	 * The [Interquartile range](http://en.wikipedia.org/wiki/Interquartile_range) is
	 * a measure of statistical dispersion, or how scattered, spread, or
	 * concentrated a distribution is. It's computed as the difference between
	 * the third quartile and first quartile.
	 *
	 * @param {Array<number>} x sample of one or more numbers
	 * @returns {number} interquartile range: the span between lower and upper quartile,
	 * 0.25 and 0.75
	 * @example
	 * interquartileRange([0, 1, 2, 3]); // => 2
	 */
	function interquartileRange(x/*: Array<number> */) {
	    // Interquartile range is the span between the upper quartile,
	    // at `0.75`, and lower quartile, `0.25`
	    var q1 = quantile(x, 0.75),
	        q2 = quantile(x, 0.25);
	
	    if (typeof q1 === 'number' && typeof q2 === 'number') {
	        return q1 - q2;
	    }
	}
	
	module.exports = interquartileRange;


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var median = __webpack_require__(1438);
	
	/**
	 * The [Median Absolute Deviation](http://en.wikipedia.org/wiki/Median_absolute_deviation) is
	 * a robust measure of statistical
	 * dispersion. It is more resilient to outliers than the standard deviation.
	 *
	 * @param {Array<number>} x input array
	 * @returns {number} median absolute deviation
	 * @example
	 * medianAbsoluteDeviation([1, 1, 2, 2, 4, 6, 9]); // => 1
	 */
	function medianAbsoluteDeviation(x /*: Array<number> */) {
	    // The mad of nothing is null
	    var medianValue = median(x),
	        medianAbsoluteDeviations = [];
	
	    // Make a list of absolute deviations from the median
	    for (var i = 0; i < x.length; i++) {
	        medianAbsoluteDeviations.push(Math.abs(x[i] - medianValue));
	    }
	
	    // Find the median value of that list
	    return median(medianAbsoluteDeviations);
	}
	
	module.exports = medianAbsoluteDeviation;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var quantile = __webpack_require__(1433);
	
	/**
	 * The [median](http://en.wikipedia.org/wiki/Median) is
	 * the middle number of a list. This is often a good indicator of 'the middle'
	 * when there are outliers that skew the `mean()` value.
	 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
	 * a method of finding a typical or central value of a set of numbers.
	 *
	 * The median isn't necessarily one of the elements in the list: the value
	 * can be the average of two elements if the list has an even length
	 * and the two central values are different.
	 *
	 * @param {Array<number>} x input
	 * @returns {number} median value
	 * @example
	 * median([10, 2, 5, 100, 2, 1]); // => 3.5
	 */
	function median(x /*: Array<number> */)/*:number*/ {
	    return +quantile(x, 0.5);
	}
	
	module.exports = median;


/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * Split an array into chunks of a specified size. This function
	 * has the same behavior as [PHP's array_chunk](http://php.net/manual/en/function.array-chunk.php)
	 * function, and thus will insert smaller-sized chunks at the end if
	 * the input size is not divisible by the chunk size.
	 *
	 * `x` is expected to be an array, and `chunkSize` a number.
	 * The `x` array can contain any kind of data.
	 *
	 * @param {Array} x a sample
	 * @param {number} chunkSize size of each output array. must be a positive integer
	 * @returns {Array<Array>} a chunked array
	 * @throws {Error} if chunk size is less than 1 or not an integer
	 * @example
	 * chunk([1, 2, 3, 4, 5, 6], 2);
	 * // => [[1, 2], [3, 4], [5, 6]]
	 */
	function chunk(x/*:Array<any>*/, chunkSize/*:number*/)/*:?Array<Array<any>>*/ {
	
	    // a list of result chunks, as arrays in an array
	    var output = [];
	
	    // `chunkSize` must be zero or higher - otherwise the loop below,
	    // in which we call `start += chunkSize`, will loop infinitely.
	    // So, we'll detect and throw in that case to indicate
	    // invalid input.
	    if (chunkSize < 1) {
	        throw new Error('chunk size must be a positive number');
	    }
	
	    if (Math.floor(chunkSize) !== chunkSize) {
	        throw new Error('chunk size must be an integer');
	    }
	
	    // `start` is the index at which `.slice` will start selecting
	    // new array elements
	    for (var start = 0; start < x.length; start += chunkSize) {
	
	        // for each chunk, slice that part of the array and add it
	        // to the output. The `.slice` function does not change
	        // the original array.
	        output.push(x.slice(start, start + chunkSize));
	    }
	    return output;
	}
	
	module.exports = chunk;


/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * Sampling with replacement is a type of sampling that allows the same
	 * item to be picked out of a population more than once.
	 *
	 * @param {Array<*>} x an array of any kind of value
	 * @param {number} n count of how many elements to take
	 * @param {Function} [randomSource=Math.random] an optional entropy source that
	 * returns numbers between 0 inclusive and 1 exclusive: the range [0, 1)
	 * @return {Array} n sampled items from the population
	 * @example
	 * var sample = sampleWithReplacement([1, 2, 3, 4], 2);
	 * sampleWithReplacement; // = [2, 4] or any other random sample of 2 items
	 */
	function sampleWithReplacement/*::<T>*/(x/*:Array<T>*/,
	    n /*: number */,
	    randomSource/*:Function*/) {
	
	    if (x.length === 0) {
	        return [];
	    }
	
	    // a custom random number source can be provided if you want to use
	    // a fixed seed or another random number generator, like
	    // [random-js](https://www.npmjs.org/package/random-js)
	    randomSource = randomSource || Math.random;
	
	    var length = x.length;
	    var sample = [];
	
	    for (var i = 0; i < n; i++) {
	        var index = Math.floor(randomSource() * length);
	
	        sample.push(x[index]);
	    }
	
	    return sample;
	}
	
	module.exports = sampleWithReplacement;


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var shuffleInPlace = __webpack_require__(1442);
	
	/**
	 * A [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle)
	 * is a fast way to create a random permutation of a finite set. This is
	 * a function around `shuffle_in_place` that adds the guarantee that
	 * it will not modify its input.
	 *
	 * @param {Array} x sample of 0 or more numbers
	 * @param {Function} [randomSource=Math.random] an optional entropy source that
	 * returns numbers between 0 inclusive and 1 exclusive: the range [0, 1)
	 * @return {Array} shuffled version of input
	 * @example
	 * var shuffled = shuffle([1, 2, 3, 4]);
	 * shuffled; // = [2, 3, 1, 4] or any other random permutation
	 */
	function shuffle/*::<T>*/(x/*:Array<T>*/, randomSource/*:Function*/) {
	    // slice the original array so that it is not modified
	    var sample = x.slice();
	
	    // and then shuffle that shallow-copied array, in place
	    return shuffleInPlace(sample.slice(), randomSource);
	}
	
	module.exports = shuffle;


/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * A [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle)
	 * in-place - which means that it **will change the order of the original
	 * array by reference**.
	 *
	 * This is an algorithm that generates a random [permutation](https://en.wikipedia.org/wiki/Permutation)
	 * of a set.
	 *
	 * @param {Array} x sample of one or more numbers
	 * @param {Function} [randomSource=Math.random] an optional entropy source that
	 * returns numbers between 0 inclusive and 1 exclusive: the range [0, 1)
	 * @returns {Array} x
	 * @example
	 * var x = [1, 2, 3, 4];
	 * shuffleInPlace(x);
	 * // x is shuffled to a value like [2, 1, 4, 3]
	 */
	function shuffleInPlace(x/*:Array<any>*/, randomSource/*:Function*/)/*:Array<any>*/ {
	
	    // a custom random number source can be provided if you want to use
	    // a fixed seed or another random number generator, like
	    // [random-js](https://www.npmjs.org/package/random-js)
	    randomSource = randomSource || Math.random;
	
	    // store the current length of the x to determine
	    // when no elements remain to shuffle.
	    var length = x.length;
	
	    // temporary is used to hold an item when it is being
	    // swapped between indices.
	    var temporary;
	
	    // The index to swap at each stage.
	    var index;
	
	    // While there are still items to shuffle
	    while (length > 0) {
	        // chose a random index within the subset of the array
	        // that is not yet shuffled
	        index = Math.floor(randomSource() * length--);
	
	        // store the value that we'll move temporarily
	        temporary = x[length];
	
	        // swap the value at `x[length]` with `x[index]`
	        x[length] = x[index];
	        x[index] = temporary;
	    }
	
	    return x;
	}
	
	module.exports = shuffleInPlace;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var shuffle = __webpack_require__(1441);
	
	/**
	 * Create a [simple random sample](http://en.wikipedia.org/wiki/Simple_random_sample)
	 * from a given array of `n` elements.
	 *
	 * The sampled values will be in any order, not necessarily the order
	 * they appear in the input.
	 *
	 * @param {Array<any>} x input array. can contain any type
	 * @param {number} n count of how many elements to take
	 * @param {Function} [randomSource=Math.random] an optional entropy source that
	 * returns numbers between 0 inclusive and 1 exclusive: the range [0, 1)
	 * @return {Array} subset of n elements in original array
	 * @example
	 * var values = [1, 2, 4, 5, 6, 7, 8, 9];
	 * sample(values, 3); // returns 3 random values, like [2, 5, 8];
	 */
	function sample/*:: <T> */(
	    x /*: Array<T> */,
	    n /*: number */,
	    randomSource /*: Function */) /*: Array<T> */ {
	    // shuffle the original array using a fisher-yates shuffle
	    var shuffled = shuffle(x, randomSource);
	
	    // and then return a subset of it - the first `n` elements.
	    return shuffled.slice(0, n);
	}
	
	module.exports = sample;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var uniqueCountSorted = __webpack_require__(1445),
	    numericSort = __webpack_require__(1424);
	
	/**
	 * Create a new column x row matrix.
	 *
	 * @private
	 * @param {number} columns
	 * @param {number} rows
	 * @return {Array<Array<number>>} matrix
	 * @example
	 * makeMatrix(10, 10);
	 */
	function makeMatrix(columns, rows) {
	    var matrix = [];
	    for (var i = 0; i < columns; i++) {
	        var column = [];
	        for (var j = 0; j < rows; j++) {
	            column.push(0);
	        }
	        matrix.push(column);
	    }
	    return matrix;
	}
	
	/**
	 * Generates incrementally computed values based on the sums and sums of
	 * squares for the data array
	 *
	 * @private
	 * @param {number} j
	 * @param {number} i
	 * @param {Array<number>} sums
	 * @param {Array<number>} sumsOfSquares
	 * @return {number}
	 * @example
	 * ssq(0, 1, [-1, 0, 2], [1, 1, 5]);
	 */
	function ssq(j, i, sums, sumsOfSquares) {
	    var sji; // s(j, i)
	    if (j > 0) {
	        var muji = (sums[i] - sums[j - 1]) / (i - j + 1); // mu(j, i)
	        sji = sumsOfSquares[i] - sumsOfSquares[j - 1] - (i - j + 1) * muji * muji;
	    } else {
	        sji = sumsOfSquares[i] - sums[i] * sums[i] / (i + 1);
	    }
	    if (sji < 0) {
	        return 0;
	    }
	    return sji;
	}
	
	/**
	 * Function that recursively divides and conquers computations
	 * for cluster j
	 *
	 * @private
	 * @param {number} iMin Minimum index in cluster to be computed
	 * @param {number} iMax Maximum index in cluster to be computed
	 * @param {number} cluster Index of the cluster currently being computed
	 * @param {Array<Array<number>>} matrix
	 * @param {Array<Array<number>>} backtrackMatrix
	 * @param {Array<number>} sums
	 * @param {Array<number>} sumsOfSquares
	 */
	function fillMatrixColumn(iMin, iMax, cluster, matrix, backtrackMatrix, sums, sumsOfSquares) {
	    if (iMin > iMax) {
	        return;
	    }
	
	    // Start at midpoint between iMin and iMax
	    var i = Math.floor((iMin + iMax) / 2);
	
	    matrix[cluster][i] = matrix[cluster - 1][i - 1];
	    backtrackMatrix[cluster][i] = i;
	
	    var jlow = cluster; // the lower end for j
	
	    if (iMin > cluster) {
	        jlow = Math.max(jlow, backtrackMatrix[cluster][iMin - 1] || 0);
	    }
	    jlow = Math.max(jlow, backtrackMatrix[cluster - 1][i] || 0);
	
	    var jhigh = i - 1; // the upper end for j
	    if (iMax < matrix.length - 1) {
	        jhigh = Math.min(jhigh, backtrackMatrix[cluster][iMax + 1] || 0);
	    }
	
	    var sji;
	    var sjlowi;
	    var ssqjlow;
	    var ssqj;
	    for (var j = jhigh; j >= jlow; --j) {
	        sji = ssq(j, i, sums, sumsOfSquares);
	
	        if (sji + matrix[cluster - 1][jlow - 1] >= matrix[cluster][i]) {
	            break;
	        }
	
	        // Examine the lower bound of the cluster border
	        sjlowi = ssq(jlow, i, sums, sumsOfSquares);
	
	        ssqjlow = sjlowi + matrix[cluster - 1][jlow - 1];
	
	        if (ssqjlow < matrix[cluster][i]) {
	            // Shrink the lower bound
	            matrix[cluster][i] = ssqjlow;
	            backtrackMatrix[cluster][i] = jlow;
	        }
	        jlow++;
	
	        ssqj = sji + matrix[cluster - 1][j - 1];
	        if (ssqj < matrix[cluster][i]) {
	            matrix[cluster][i] = ssqj;
	            backtrackMatrix[cluster][i] = j;
	        }
	    }
	
	    fillMatrixColumn(iMin, i - 1, cluster, matrix, backtrackMatrix, sums, sumsOfSquares);
	    fillMatrixColumn(i + 1, iMax, cluster, matrix, backtrackMatrix, sums, sumsOfSquares);
	}
	
	/**
	 * Initializes the main matrices used in Ckmeans and kicks
	 * off the divide and conquer cluster computation strategy
	 *
	 * @private
	 * @param {Array<number>} data sorted array of values
	 * @param {Array<Array<number>>} matrix
	 * @param {Array<Array<number>>} backtrackMatrix
	 */
	function fillMatrices(data, matrix, backtrackMatrix) {
	    var nValues = matrix[0].length;
	
	    // Shift values by the median to improve numeric stability
	    var shift = data[Math.floor(nValues / 2)];
	
	    // Cumulative sum and cumulative sum of squares for all values in data array
	    var sums = [];
	    var sumsOfSquares = [];
	
	    // Initialize first column in matrix & backtrackMatrix
	    for (var i = 0, shiftedValue; i < nValues; ++i) {
	        shiftedValue = data[i] - shift;
	        if (i === 0) {
	            sums.push(shiftedValue);
	            sumsOfSquares.push(shiftedValue * shiftedValue);
	        } else {
	            sums.push(sums[i - 1] + shiftedValue);
	            sumsOfSquares.push(sumsOfSquares[i - 1] + shiftedValue * shiftedValue);
	        }
	
	        // Initialize for cluster = 0
	        matrix[0][i] = ssq(0, i, sums, sumsOfSquares);
	        backtrackMatrix[0][i] = 0;
	    }
	
	    // Initialize the rest of the columns
	    var iMin;
	    for (var cluster = 1; cluster < matrix.length; ++cluster) {
	        if (cluster < matrix.length - 1) {
	            iMin = cluster;
	        } else {
	            // No need to compute matrix[K-1][0] ... matrix[K-1][N-2]
	            iMin = nValues - 1;
	        }
	
	        fillMatrixColumn(iMin, nValues - 1, cluster, matrix, backtrackMatrix, sums, sumsOfSquares);
	    }
	}
	
	/**
	 * Ckmeans clustering is an improvement on heuristic-based clustering
	 * approaches like Jenks. The algorithm was developed in
	 * [Haizhou Wang and Mingzhou Song](http://journal.r-project.org/archive/2011-2/RJournal_2011-2_Wang+Song.pdf)
	 * as a [dynamic programming](https://en.wikipedia.org/wiki/Dynamic_programming) approach
	 * to the problem of clustering numeric data into groups with the least
	 * within-group sum-of-squared-deviations.
	 *
	 * Minimizing the difference within groups - what Wang & Song refer to as
	 * `withinss`, or within sum-of-squares, means that groups are optimally
	 * homogenous within and the data is split into representative groups.
	 * This is very useful for visualization, where you may want to represent
	 * a continuous variable in discrete color or style groups. This function
	 * can provide groups that emphasize differences between data.
	 *
	 * Being a dynamic approach, this algorithm is based on two matrices that
	 * store incrementally-computed values for squared deviations and backtracking
	 * indexes.
	 *
	 * This implementation is based on Ckmeans 3.4.6, which introduced a new divide
	 * and conquer approach that improved runtime from O(kn^2) to O(kn log(n)).
	 *
	 * Unlike the [original implementation](https://cran.r-project.org/web/packages/Ckmeans.1d.dp/index.html),
	 * this implementation does not include any code to automatically determine
	 * the optimal number of clusters: this information needs to be explicitly
	 * provided.
	 *
	 * ### References
	 * _Ckmeans.1d.dp: Optimal k-means Clustering in One Dimension by Dynamic
	 * Programming_ Haizhou Wang and Mingzhou Song ISSN 2073-4859
	 *
	 * from The R Journal Vol. 3/2, December 2011
	 * @param {Array<number>} x input data, as an array of number values
	 * @param {number} nClusters number of desired classes. This cannot be
	 * greater than the number of values in the data array.
	 * @returns {Array<Array<number>>} clustered input
	 * @throws {Error} if the number of requested clusters is higher than the size of the data
	 * @example
	 * ckmeans([-1, 2, -1, 2, 4, 5, 6, -1, 2, -1], 3);
	 * // The input, clustered into groups of similar numbers.
	 * //= [[-1, -1, -1, -1], [2, 2, 2], [4, 5, 6]]);
	 */
	function ckmeans(x/*: Array<number> */, nClusters/*: number */)/*: Array<Array<number>> */ {
	
	    if (nClusters > x.length) {
	        throw new Error('cannot generate more classes than there are data values');
	    }
	
	    var sorted = numericSort(x),
	        // we'll use this as the maximum number of clusters
	        uniqueCount = uniqueCountSorted(sorted);
	
	    // if all of the input values are identical, there's one cluster
	    // with all of the input in it.
	    if (uniqueCount === 1) {
	        return [sorted];
	    }
	
	    // named 'S' originally
	    var matrix = makeMatrix(nClusters, sorted.length),
	        // named 'J' originally
	        backtrackMatrix = makeMatrix(nClusters, sorted.length);
	
	    // This is a dynamic programming way to solve the problem of minimizing
	    // within-cluster sum of squares. It's similar to linear regression
	    // in this way, and this calculation incrementally computes the
	    // sum of squares that are later read.
	    fillMatrices(sorted, matrix, backtrackMatrix);
	
	    // The real work of Ckmeans clustering happens in the matrix generation:
	    // the generated matrices encode all possible clustering combinations, and
	    // once they're generated we can solve for the best clustering groups
	    // very quickly.
	    var clusters = [],
	        clusterRight = backtrackMatrix[0].length - 1;
	
	    // Backtrack the clusters from the dynamic programming matrix. This
	    // starts at the bottom-right corner of the matrix (if the top-left is 0, 0),
	    // and moves the cluster target with the loop.
	    for (var cluster = backtrackMatrix.length - 1; cluster >= 0; cluster--) {
	
	        var clusterLeft = backtrackMatrix[cluster][clusterRight];
	
	        // fill the cluster from the sorted input by taking a slice of the
	        // array. the backtrack matrix makes this easy - it stores the
	        // indexes where the cluster should start and end.
	        clusters[cluster] = sorted.slice(clusterLeft, clusterRight + 1);
	
	        if (cluster > 0) {
	            clusterRight = clusterLeft - 1;
	        }
	    }
	
	    return clusters;
	}
	
	module.exports = ckmeans;


/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * For a sorted input, counting the number of unique values
	 * is possible in constant time and constant memory. This is
	 * a simple implementation of the algorithm.
	 *
	 * Values are compared with `===`, so objects and non-primitive objects
	 * are not handled in any special way.
	 *
	 * @param {Array<*>} x an array of any kind of value
	 * @returns {number} count of unique values
	 * @example
	 * uniqueCountSorted([1, 2, 3]); // => 3
	 * uniqueCountSorted([1, 1, 1]); // => 1
	 */
	function uniqueCountSorted(x/*: Array<any>*/)/*: number */ {
	    var uniqueValueCount = 0,
	        lastSeenValue;
	    for (var i = 0; i < x.length; i++) {
	        if (i === 0 || x[i] !== lastSeenValue) {
	            lastSeenValue = x[i];
	            uniqueValueCount++;
	        }
	    }
	    return uniqueValueCount;
	}
	
	module.exports = uniqueCountSorted;


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var max = __webpack_require__(1428),
	    min = __webpack_require__(1427);
	
	/**
	 * Given an array of x, this will find the extent of the
	 * x and return an array of breaks that can be used
	 * to categorize the x into a number of classes. The
	 * returned array will always be 1 longer than the number of
	 * classes because it includes the minimum value.
	 *
	 * @param {Array<number>} x an array of number values
	 * @param {number} nClasses number of desired classes
	 * @returns {Array<number>} array of class break positions
	 * @example
	 * equalIntervalBreaks([1, 2, 3, 4, 5, 6], 4); //= [1, 2.25, 3.5, 4.75, 6]
	 */
	function equalIntervalBreaks(x/*: Array<number> */, nClasses/*:number*/)/*: Array<number> */ {
	
	    if (x.length < 2) {
	        return x;
	    }
	
	    var theMin = min(x),
	        theMax = max(x); 
	
	    // the first break will always be the minimum value
	    // in the xset
	    var breaks = [theMin];
	
	    // The size of each break is the full range of the x
	    // divided by the number of classes requested
	    var breakSize = (theMax - theMin) / nClasses;
	
	    // In the case of nClasses = 1, this loop won't run
	    // and the returned breaks will be [min, max]
	    for (var i = 1; i < nClasses; i++) {
	        breaks.push(breaks[0] + breakSize * i);
	    }
	
	    // the last break will always be the
	    // maximum.
	    breaks.push(theMax);
	
	    return breaks;
	}
	
	module.exports = equalIntervalBreaks;


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var mean = __webpack_require__(1420);
	
	/**
	 * [Sample covariance](https://en.wikipedia.org/wiki/Sample_mean_and_sampleCovariance) of two datasets:
	 * how much do the two datasets move together?
	 * x and y are two datasets, represented as arrays of numbers.
	 *
	 * @param {Array<number>} x a sample of two or more data points
	 * @param {Array<number>} y a sample of two or more data points
	 * @throws {Error} if x and y do not have equal lengths
	 * @throws {Error} if x or y have length of one or less
	 * @returns {number} sample covariance
	 * @example
	 * sampleCovariance([1, 2, 3, 4, 5, 6], [6, 5, 4, 3, 2, 1]); // => -3.5
	 */
	function sampleCovariance(x /*:Array<number>*/, y /*:Array<number>*/)/*:number*/ {
	
	    // The two datasets must have the same length which must be more than 1
	    if (x.length !== y.length) {
	        throw new Error('sampleCovariance requires samples with equal lengths');
	    }
	
	    if (x.length < 2) {
	        throw new Error('sampleCovariance requires at least two data points in each sample');
	    }
	
	    // determine the mean of each dataset so that we can judge each
	    // value of the dataset fairly as the difference from the mean. this
	    // way, if one dataset is [1, 2, 3] and [2, 3, 4], their covariance
	    // does not suffer because of the difference in absolute values
	    var xmean = mean(x),
	        ymean = mean(y),
	        sum = 0;
	
	    // for each pair of values, the covariance increases when their
	    // difference from the mean is associated - if both are well above
	    // or if both are well below
	    // the mean, the covariance increases significantly.
	    for (var i = 0; i < x.length; i++) {
	        sum += (x[i] - xmean) * (y[i] - ymean);
	    }
	
	    // this is Bessels' Correction: an adjustment made to sample statistics
	    // that allows for the reduced degree of freedom entailed in calculating
	    // values from samples rather than complete populations.
	    var besselsCorrection = x.length - 1;
	
	    // the covariance is weighted by the length of the datasets.
	    return sum / besselsCorrection;
	}
	
	module.exports = sampleCovariance;


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var sampleCovariance = __webpack_require__(1447);
	var sampleStandardDeviation = __webpack_require__(1449);
	
	/**
	 * The [correlation](http://en.wikipedia.org/wiki/Correlation_and_dependence) is
	 * a measure of how correlated two datasets are, between -1 and 1
	 *
	 * @param {Array<number>} x first input
	 * @param {Array<number>} y second input
	 * @returns {number} sample correlation
	 * @example
	 * sampleCorrelation([1, 2, 3, 4, 5, 6], [2, 2, 3, 4, 5, 60]).toFixed(2);
	 * // => '0.69'
	 */
	function sampleCorrelation(x/*: Array<number> */, y/*: Array<number> */)/*:number*/ {
	    var cov = sampleCovariance(x, y),
	        xstd = sampleStandardDeviation(x),
	        ystd = sampleStandardDeviation(y);
	
	    return cov / xstd / ystd;
	}
	
	module.exports = sampleCorrelation;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var sampleVariance = __webpack_require__(1450);
	
	/**
	 * The [standard deviation](http://en.wikipedia.org/wiki/Standard_deviation)
	 * is the square root of the variance.
	 *
	 * @param {Array<number>} x input array
	 * @returns {number} sample standard deviation
	 * @example
	 * sampleStandardDeviation([2, 4, 4, 4, 5, 5, 7, 9]).toFixed(2);
	 * // => '2.14'
	 */
	function sampleStandardDeviation(x/*:Array<number>*/)/*:number*/ {
	    // The standard deviation of no numbers is null
	    var sampleVarianceX = sampleVariance(x);
	    return Math.sqrt(sampleVarianceX);
	}
	
	module.exports = sampleStandardDeviation;


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var sumNthPowerDeviations = __webpack_require__(1419);
	
	/**
	 * The [sample variance](https://en.wikipedia.org/wiki/Variance#Sample_variance)
	 * is the sum of squared deviations from the mean. The sample variance
	 * is distinguished from the variance by the usage of [Bessel's Correction](https://en.wikipedia.org/wiki/Bessel's_correction):
	 * instead of dividing the sum of squared deviations by the length of the input,
	 * it is divided by the length minus one. This corrects the bias in estimating
	 * a value from a set that you don't know if full.
	 *
	 * References:
	 * * [Wolfram MathWorld on Sample Variance](http://mathworld.wolfram.com/SampleVariance.html)
	 *
	 * @param {Array<number>} x a sample of two or more data points
	 * @throws {Error} if the length of x is less than 2
	 * @return {number} sample variance
	 * @example
	 * sampleVariance([1, 2, 3, 4, 5]); // => 2.5
	 */
	function sampleVariance(x /*: Array<number> */)/*:number*/ {
	    // The variance of no numbers is null
	    if (x.length < 2) {
	        throw new Error('sampleVariance requires at least two data points');
	    }
	
	    var sumSquaredDeviationsValue = sumNthPowerDeviations(x, 2);
	
	    // this is Bessels' Correction: an adjustment made to sample statistics
	    // that allows for the reduced degree of freedom entailed in calculating
	    // values from samples rather than complete populations.
	    var besselsCorrection = x.length - 1;
	
	    // Find the mean value of that list
	    return sumSquaredDeviationsValue / besselsCorrection;
	}
	
	module.exports = sampleVariance;


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var sumNthPowerDeviations = __webpack_require__(1419);
	var sampleStandardDeviation = __webpack_require__(1449);
	
	/**
	 * [Skewness](http://en.wikipedia.org/wiki/Skewness) is
	 * a measure of the extent to which a probability distribution of a
	 * real-valued random variable "leans" to one side of the mean.
	 * The skewness value can be positive or negative, or even undefined.
	 *
	 * Implementation is based on the adjusted Fisher-Pearson standardized
	 * moment coefficient, which is the version found in Excel and several
	 * statistical packages including Minitab, SAS and SPSS.
	 *
	 * @param {Array<number>} x a sample of 3 or more data points
	 * @returns {number} sample skewness
	 * @throws {Error} if x has length of 3 or less
	 * @example
	 * sampleSkewness([2, 4, 6, 3, 1]); // => 0.590128656384365
	 */
	function sampleSkewness(x /*: Array<number> */)/*:number*/ {
	    // The skewness of less than three arguments is null
	    var theSampleStandardDeviation = sampleStandardDeviation(x);
	
	    if (x.length < 3) {
	        throw new Error('sampleSkewness requires at least three data points');
	    }
	
	    var n = x.length,
	        cubedS = Math.pow(theSampleStandardDeviation, 3),
	        sumCubedDeviations = sumNthPowerDeviations(x, 3);
	
	    return n * sumCubedDeviations / ((n - 1) * (n - 2) * cubedS);
	}
	
	module.exports = sampleSkewness;


/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	/* @flow */
	
	'use strict';
	
	/**
	 * Implementation of [Heap's Algorithm](https://en.wikipedia.org/wiki/Heap%27s_algorithm)
	 * for generating permutations.
	 *
	 * @param {Array} elements any type of data
	 * @returns {Array<Array>} array of permutations
	 */
	function permutationsHeap/*:: <T> */(elements /*: Array<T> */)/*: Array<Array<T>> */ {
	    var indexes = new Array(elements.length);
	    var permutations = [elements.slice()];
	
	    for (var i = 0; i < elements.length; i++) {
	        indexes[i] = 0;
	    }
	
	    for (i = 0; i < elements.length;) {
	        if (indexes[i] < i) {
	
	            // At odd indexes, swap from indexes[i] instead
	            // of from the beginning of the array
	            var swapFrom = 0;
	            if (i % 2 !== 0) {
	                swapFrom = indexes[i];
	            }
	
	            // swap between swapFrom and i, using
	            // a temporary variable as storage.
	            var temp = elements[swapFrom];
	            elements[swapFrom] = elements[i];
	            elements[i] = temp;
	
	            permutations.push(elements.slice());
	            indexes[i]++;
	            i = 0;
	
	        } else {
	            indexes[i] = 0;
	            i++;
	        }
	    }
	
	    return permutations;
	}
	
	module.exports = permutationsHeap;


/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	/* @flow */
	'use strict';
	/**
	 * Implementation of Combinations
	 * Combinations are unique subsets of a collection - in this case, k x from a collection at a time.
	 * https://en.wikipedia.org/wiki/Combination
	 * @param {Array} x any type of data
	 * @param {int} k the number of objects in each group (without replacement)
	 * @returns {Array<Array>} array of permutations
	 * @example
	 * combinations([1, 2, 3], 2); // => [[1,2], [1,3], [2,3]]
	 */
	
	function combinations(x /*: Array<any> */, k/*: number */) {
	    var i;
	    var subI;
	    var combinationList = [];
	    var subsetCombinations;
	    var next;
	
	    for (i = 0; i < x.length; i++) {
	        if (k === 1) {
	            combinationList.push([x[i]])
	        } else {
	            subsetCombinations = combinations(x.slice( i + 1, x.length ), k - 1);
	            for (subI = 0; subI < subsetCombinations.length; subI++) {
	                next = subsetCombinations[subI];
	                next.unshift(x[i]);
	                combinationList.push(next);
	            }
	        }
	    }
	    return combinationList;
	}
	
	module.exports = combinations;


/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	/* @flow */
	'use strict';
	
	/**
	 * Implementation of [Combinations](https://en.wikipedia.org/wiki/Combination) with replacement
	 * Combinations are unique subsets of a collection - in this case, k x from a collection at a time.
	 * 'With replacement' means that a given element can be chosen multiple times.
	 * Unlike permutation, order doesn't matter for combinations.
	 * 
	 * @param {Array} x any type of data
	 * @param {int} k the number of objects in each group (without replacement)
	 * @returns {Array<Array>} array of permutations
	 * @example
	 * combinationsReplacement([1, 2], 2); // => [[1, 1], [1, 2], [2, 2]]
	 */
	function combinationsReplacement(
	    x /*: Array<any> */,
	    k /*: number */) {
	
	    var combinationList = [];
	
	    for (var i = 0; i < x.length; i++) {
	        if (k === 1) {
	            // If we're requested to find only one element, we don't need
	            // to recurse: just push `x[i]` onto the list of combinations.
	            combinationList.push([x[i]])
	        } else {
	            // Otherwise, recursively find combinations, given `k - 1`. Note that
	            // we request `k - 1`, so if you were looking for k=3 combinations, we're
	            // requesting k=2. This -1 gets reversed in the for loop right after this
	            // code, since we concatenate `x[i]` onto the selected combinations,
	            // bringing `k` back up to your requested level.
	            // This recursion may go many levels deep, since it only stops once
	            // k=1.
	            var subsetCombinations = combinationsReplacement(
	                x.slice(i, x.length),
	                k - 1);
	
	            for (var j = 0; j < subsetCombinations.length; j++) {
	                combinationList.push([x[i]]
	                    .concat(subsetCombinations[j]));
	            }
	        }
	    }
	
	    return combinationList;
	}
	
	module.exports = combinationsReplacement;


/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * When adding a new value to a list, one does not have to necessary
	 * recompute the mean of the list in linear time. They can instead use
	 * this function to compute the new mean by providing the current mean,
	 * the number of elements in the list that produced it and the new
	 * value to add.
	 *
	 * @param {number} mean current mean
	 * @param {number} n number of items in the list
	 * @param {number} newValue the added value
	 * @returns {number} the new mean
	 *
	 * @example
	 * addToMean(14, 5, 53); // => 20.5
	 */
	function addToMean(mean /*: number*/, n/*: number */, newValue/*: number */)/*: number */ {
	    return mean + ((newValue - mean) / (n + 1));
	}
	
	module.exports = addToMean;


/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * When combining two lists of values for which one already knows the means,
	 * one does not have to necessary recompute the mean of the combined lists in
	 * linear time. They can instead use this function to compute the combined
	 * mean by providing the mean & number of values of the first list and the mean
	 * & number of values of the second list.
	 *
	 * @param {number} mean1 mean of the first list
	 * @param {number} n1 number of items in the first list
	 * @param {number} mean2 mean of the second list
	 * @param {number} n2 number of items in the second list
	 * @returns {number} the combined mean
	 *
	 * @example
	 * combineMeans(5, 3, 4, 3); // => 4.5
	 */
	function combineMeans(mean1 /*: number*/, n1/*: number */, mean2 /*: number*/, n2/*: number */)/*: number */ {
	    return (mean1 * n1 + mean2 * n2) / (n1 + n2);
	}
	
	module.exports = combineMeans;


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var combineMeans = __webpack_require__(1456)
	
	/**
	 * When combining two lists of values for which one already knows the variances,
	 * one does not have to necessary recompute the variance of the combined lists
	 * in linear time. They can instead use this function to compute the combined
	 * variance by providing the variance, mean & number of values of the first list
	 * and the variance, mean & number of values of the second list.
	 *
	 * @param {number} variance1 variance of the first list
	 * @param {number} mean1 mean of the first list
	 * @param {number} n1 number of items in the first list
	 * @param {number} variance2 variance of the second list
	 * @param {number} mean2 mean of the second list
	 * @param {number} n2 number of items in the second list
	 * @returns {number} the combined mean
	 *
	 * @example
	 * combineVariances(14 / 3, 5, 3, 8 / 3, 4, 3); // => 47 / 12
	 */
	function combineVariances(
	    variance1 /*: number*/,
	    mean1 /*: number*/,
	    n1/*: number */,
	    variance2 /*: number*/,
	    mean2 /*: number*/,
	    n2/*: number */)/*: number */ {
	
	    var newMean = combineMeans(mean1, n1, mean2, n2);
	
	    return (
	      n1 * (variance1 + Math.pow(mean1 - newMean, 2)) +
	      n2 * (variance2 + Math.pow(mean2 - newMean, 2))
	    ) / (n1 + n2);
	}
	
	module.exports = combineVariances;


/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The [Geometric Mean](https://en.wikipedia.org/wiki/Geometric_mean) is
	 * a mean function that is more useful for numbers in different
	 * ranges.
	 *
	 * This is the nth root of the input numbers multiplied by each other.
	 *
	 * The geometric mean is often useful for
	 * **[proportional growth](https://en.wikipedia.org/wiki/Geometric_mean#Proportional_growth)**: given
	 * growth rates for multiple years, like _80%, 16.66% and 42.85%_, a simple
	 * mean will incorrectly estimate an average growth rate, whereas a geometric
	 * mean will correctly estimate a growth rate that, over those years,
	 * will yield the same end value.
	 *
	 * This runs on `O(n)`, linear time in respect to the array
	 *
	 * @param {Array<number>} x sample of one or more data points
	 * @returns {number} geometric mean
	 * @throws {Error} if x is empty
	 * @throws {Error} if x contains a negative number
	 * @example
	 * var growthRates = [1.80, 1.166666, 1.428571];
	 * var averageGrowth = geometricMean(growthRates);
	 * var averageGrowthRates = [averageGrowth, averageGrowth, averageGrowth];
	 * var startingValue = 10;
	 * var startingValueMean = 10;
	 * growthRates.forEach(function(rate) {
	 *   startingValue *= rate;
	 * });
	 * averageGrowthRates.forEach(function(rate) {
	 *   startingValueMean *= rate;
	 * });
	 * startingValueMean === startingValue;
	 */
	function geometricMean(x /*: Array<number> */) {
	    // The mean of no numbers is null
	    if (x.length === 0) {
	        throw new Error('geometricMean requires at least one data point');
	    }
	
	    // the starting value.
	    var value = 1;
	
	    for (var i = 0; i < x.length; i++) {
	        // the geometric mean is only valid for positive numbers
	        if (x[i] <= 0) {
	            throw new Error('geometricMean requires only positive numbers as input');
	        }
	
	        // repeatedly multiply the value by each number
	        value *= x[i];
	    }
	
	    return Math.pow(value, 1 / x.length);
	}
	
	module.exports = geometricMean;


/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The [Harmonic Mean](https://en.wikipedia.org/wiki/Harmonic_mean) is
	 * a mean function typically used to find the average of rates.
	 * This mean is calculated by taking the reciprocal of the arithmetic mean
	 * of the reciprocals of the input numbers.
	 *
	 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
	 * a method of finding a typical or central value of a set of numbers.
	 *
	 * This runs on `O(n)`, linear time in respect to the array.
	 *
	 * @param {Array<number>} x sample of one or more data points
	 * @returns {number} harmonic mean
	 * @throws {Error} if x is empty
	 * @throws {Error} if x contains a negative number
	 * @example
	 * harmonicMean([2, 3]).toFixed(2) // => '2.40'
	 */
	function harmonicMean(x /*: Array<number> */) {
	    // The mean of no numbers is null
	    if (x.length === 0) {
	        throw new Error('harmonicMean requires at least one data point');
	    }
	
	    var reciprocalSum = 0;
	
	    for (var i = 0; i < x.length; i++) {
	        // the harmonic mean is only valid for positive numbers
	        if (x[i] <= 0) {
	            throw new Error('harmonicMean requires only positive numbers as input');
	        }
	
	        reciprocalSum += 1 / x[i];
	    }
	
	    // divide n by the the reciprocal sum
	    return x.length / reciprocalSum;
	}
	
	module.exports = harmonicMean;


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var quantileSorted = __webpack_require__(1434);
	
	/**
	 * The [median](http://en.wikipedia.org/wiki/Median) is
	 * the middle number of a list. This is often a good indicator of 'the middle'
	 * when there are outliers that skew the `mean()` value.
	 * This is a [measure of central tendency](https://en.wikipedia.org/wiki/Central_tendency):
	 * a method of finding a typical or central value of a set of numbers.
	 *
	 * The median isn't necessarily one of the elements in the list: the value
	 * can be the average of two elements if the list has an even length
	 * and the two central values are different.
	 *
	 * @param {Array<number>} sorted input
	 * @returns {number} median value
	 * @example
	 * medianSorted([10, 2, 5, 100, 2, 1]); // => 52.5
	 */
	function medianSorted(sorted /*: Array<number> */)/*:number*/ {
	    return quantileSorted(sorted, 0.5);
	}
	
	module.exports = medianSorted;


/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * When removing a value from a list, one does not have to necessary
	 * recompute the mean of the list in linear time. They can instead use
	 * this function to compute the new mean by providing the current mean,
	 * the number of elements in the list that produced it and the value to remove.
	 *
	 * @param {number} mean current mean
	 * @param {number} n number of items in the list
	 * @param {number} value the value to remove
	 * @returns {number} the new mean
	 *
	 * @example
	 * subtractFromMean(20.5, 6, 53); // => 14
	 */
	function subtractFromMean(mean /*: number*/, n/*: number */, value/*: number */)/*: number */ {
	    return ((mean * n) - value) / (n - 1);
	}
	
	module.exports = subtractFromMean;


/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The Root Mean Square (RMS) is
	 * a mean function used as a measure of the magnitude of a set
	 * of numbers, regardless of their sign.
	 * This is the square root of the mean of the squares of the
	 * input numbers.
	 * This runs on `O(n)`, linear time in respect to the array
	 *
	 * @param {Array<number>} x a sample of one or more data points
	 * @returns {number} root mean square
	 * @throws {Error} if x is empty
	 * @example
	 * rootMeanSquare([-1, 1, -1, 1]); // => 1
	 */
	function rootMeanSquare(x /*: Array<number> */)/*:number*/ {
	    if (x.length === 0) {
	        throw new Error('rootMeanSquare requires at least one data point');
	    }
	
	    var sumOfSquares = 0;
	    for (var i = 0; i < x.length; i++) {
	        sumOfSquares += Math.pow(x[i], 2);
	    }
	
	    return Math.sqrt(sumOfSquares / x.length);
	}
	
	module.exports = rootMeanSquare;


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var standardDeviation = __webpack_require__(1417);
	var mean = __webpack_require__(1420);
	
	/**
	 * This is to compute [a one-sample t-test](https://en.wikipedia.org/wiki/Student%27s_t-test#One-sample_t-test), comparing the mean
	 * of a sample to a known value, x.
	 *
	 * in this case, we're trying to determine whether the
	 * population mean is equal to the value that we know, which is `x`
	 * here. usually the results here are used to look up a
	 * [p-value](http://en.wikipedia.org/wiki/P-value), which, for
	 * a certain level of significance, will let you determine that the
	 * null hypothesis can or cannot be rejected.
	 *
	 * @param {Array<number>} x sample of one or more numbers
	 * @param {number} expectedValue expected value of the population mean
	 * @returns {number} value
	 * @example
	 * tTest([1, 2, 3, 4, 5, 6], 3.385).toFixed(2); // => '0.16'
	 */
	function tTest(x/*: Array<number> */, expectedValue/*: number */)/*:number*/ {
	    // The mean of the sample
	    var sampleMean = mean(x);
	
	    // The standard deviation of the sample
	    var sd = standardDeviation(x);
	
	    // Square root the length of the sample
	    var rootN = Math.sqrt(x.length);
	
	    // returning the t value
	    return (sampleMean - expectedValue) / (sd / rootN);
	}
	
	module.exports = tTest;


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var mean = __webpack_require__(1420);
	var sampleVariance = __webpack_require__(1450);
	
	/**
	 * This is to compute [two sample t-test](http://en.wikipedia.org/wiki/Student's_t-test).
	 * Tests whether "mean(X)-mean(Y) = difference", (
	 * in the most common case, we often have `difference == 0` to test if two samples
	 * are likely to be taken from populations with the same mean value) with
	 * no prior knowledge on standard deviations of both samples
	 * other than the fact that they have the same standard deviation.
	 *
	 * Usually the results here are used to look up a
	 * [p-value](http://en.wikipedia.org/wiki/P-value), which, for
	 * a certain level of significance, will let you determine that the
	 * null hypothesis can or cannot be rejected.
	 *
	 * `diff` can be omitted if it equals 0.
	 *
	 * [This is used to confirm or deny](http://www.monarchlab.org/Lab/Research/Stats/2SampleT.aspx)
	 * a null hypothesis that the two populations that have been sampled into
	 * `sampleX` and `sampleY` are equal to each other.
	 *
	 * @param {Array<number>} sampleX a sample as an array of numbers
	 * @param {Array<number>} sampleY a sample as an array of numbers
	 * @param {number} [difference=0]
	 * @returns {number} test result
	 * @example
	 * ss.tTestTwoSample([1, 2, 3, 4], [3, 4, 5, 6], 0); //= -2.1908902300206643
	 */
	function tTestTwoSample(
	    sampleX/*: Array<number> */,
	    sampleY/*: Array<number> */,
	    difference/*: number */) {
	    var n = sampleX.length,
	        m = sampleY.length;
	
	    // If either sample doesn't actually have any values, we can't
	    // compute this at all, so we return `null`.
	    if (!n || !m) { return null; }
	
	    // default difference (mu) is zero
	    if (!difference) {
	        difference = 0;
	    }
	
	    var meanX = mean(sampleX),
	        meanY = mean(sampleY),
	        sampleVarianceX = sampleVariance(sampleX),
	        sampleVarianceY = sampleVariance(sampleY);
	
	    if (typeof meanX === 'number' &&
	        typeof meanY === 'number' &&
	        typeof sampleVarianceX === 'number' &&
	        typeof sampleVarianceY === 'number') {
	        var weightedVariance = ((n - 1) * sampleVarianceX +
	            (m - 1) * sampleVarianceY) / (n + m - 2);
	
	        return (meanX - meanY - difference) /
	            Math.sqrt(weightedVariance * (1 / n + 1 / m));
	    }
	}
	
	module.exports = tTestTwoSample;


/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * [Bayesian Classifier](http://en.wikipedia.org/wiki/Naive_Bayes_classifier)
	 *
	 * This is a naïve bayesian classifier that takes
	 * singly-nested objects.
	 *
	 * @class
	 * @example
	 * var bayes = new BayesianClassifier();
	 * bayes.train({
	 *   species: 'Cat'
	 * }, 'animal');
	 * var result = bayes.score({
	 *   species: 'Cat'
	 * })
	 * // result
	 * // {
	 * //   animal: 1
	 * // }
	 */
	function BayesianClassifier() {
	    // The number of items that are currently
	    // classified in the model
	    this.totalCount = 0;
	    // Every item classified in the model
	    this.data = {};
	}
	
	/**
	 * Train the classifier with a new item, which has a single
	 * dimension of Javascript literal keys and values.
	 *
	 * @param {Object} item an object with singly-deep properties
	 * @param {string} category the category this item belongs to
	 * @return {undefined} adds the item to the classifier
	 */
	BayesianClassifier.prototype.train = function(item, category) {
	    // If the data object doesn't have any values
	    // for this category, create a new object for it.
	    if (!this.data[category]) {
	        this.data[category] = {};
	    }
	
	    // Iterate through each key in the item.
	    for (var k in item) {
	        var v = item[k];
	        // Initialize the nested object `data[category][k][item[k]]`
	        // with an object of keys that equal 0.
	        if (this.data[category][k] === undefined) {
	            this.data[category][k] = {};
	        }
	        if (this.data[category][k][v] === undefined) {
	            this.data[category][k][v] = 0;
	        }
	
	        // And increment the key for this key/value combination.
	        this.data[category][k][v]++;
	    }
	
	    // Increment the number of items classified
	    this.totalCount++;
	};
	
	/**
	 * Generate a score of how well this item matches all
	 * possible categories based on its attributes
	 *
	 * @param {Object} item an item in the same format as with train
	 * @returns {Object} of probabilities that this item belongs to a
	 * given category.
	 */
	BayesianClassifier.prototype.score = function(item) {
	    // Initialize an empty array of odds per category.
	    var odds = {}, category;
	    // Iterate through each key in the item,
	    // then iterate through each category that has been used
	    // in previous calls to `.train()`
	    for (var k in item) {
	        var v = item[k];
	        for (category in this.data) {
	            // Create an empty object for storing key - value combinations
	            // for this category.
	            odds[category] = {};
	
	            // If this item doesn't even have a property, it counts for nothing,
	            // but if it does have the property that we're looking for from
	            // the item to categorize, it counts based on how popular it is
	            // versus the whole population.
	            if (this.data[category][k]) {
	                odds[category][k + '_' + v] = (this.data[category][k][v] || 0) / this.totalCount;
	            } else {
	                odds[category][k + '_' + v] = 0;
	            }
	        }
	    }
	
	    // Set up a new object that will contain sums of these odds by category
	    var oddsSums = {};
	
	    for (category in odds) {
	        // Tally all of the odds for each category-combination pair -
	        // the non-existence of a category does not add anything to the
	        // score.
	        oddsSums[category] = 0;
	        for (var combination in odds[category]) {
	            oddsSums[category] += odds[category][combination];
	        }
	    }
	
	    return oddsSums;
	};
	
	module.exports = BayesianClassifier;


/***/ }),
/* 1466 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * This is a single-layer [Perceptron Classifier](http://en.wikipedia.org/wiki/Perceptron) that takes
	 * arrays of numbers and predicts whether they should be classified
	 * as either 0 or 1 (negative or positive examples).
	 * @class
	 * @example
	 * // Create the model
	 * var p = new PerceptronModel();
	 * // Train the model with input with a diagonal boundary.
	 * for (var i = 0; i < 5; i++) {
	 *     p.train([1, 1], 1);
	 *     p.train([0, 1], 0);
	 *     p.train([1, 0], 0);
	 *     p.train([0, 0], 0);
	 * }
	 * p.predict([0, 0]); // 0
	 * p.predict([0, 1]); // 0
	 * p.predict([1, 0]); // 0
	 * p.predict([1, 1]); // 1
	 */
	function PerceptronModel() {
	    // The weights, or coefficients of the model;
	    // weights are only populated when training with data.
	    this.weights = [];
	    // The bias term, or intercept; it is also a weight but
	    // it's stored separately for convenience as it is always
	    // multiplied by one.
	    this.bias = 0;
	}
	
	/**
	 * **Predict**: Use an array of features with the weight array and bias
	 * to predict whether an example is labeled 0 or 1.
	 *
	 * @param {Array<number>} features an array of features as numbers
	 * @returns {number} 1 if the score is over 0, otherwise 0
	 */
	PerceptronModel.prototype.predict = function(features) {
	
	    // Only predict if previously trained
	    // on the same size feature array(s).
	    if (features.length !== this.weights.length) { return null; }
	
	    // Calculate the sum of features times weights,
	    // with the bias added (implicitly times one).
	    var score = 0;
	    for (var i = 0; i < this.weights.length; i++) {
	        score += this.weights[i] * features[i];
	    }
	    score += this.bias;
	
	    // Classify as 1 if the score is over 0, otherwise 0.
	    if (score > 0) {
	        return 1;
	    } else {
	        return 0;
	    }
	};
	
	/**
	 * **Train** the classifier with a new example, which is
	 * a numeric array of features and a 0 or 1 label.
	 *
	 * @param {Array<number>} features an array of features as numbers
	 * @param {number} label either 0 or 1
	 * @returns {PerceptronModel} this
	 */
	PerceptronModel.prototype.train = function(features, label) {
	    // Require that only labels of 0 or 1 are considered.
	    if (label !== 0 && label !== 1) { return null; }
	    // The length of the feature array determines
	    // the length of the weight array.
	    // The perceptron will continue learning as long as
	    // it keeps seeing feature arrays of the same length.
	    // When it sees a new data shape, it initializes.
	    if (features.length !== this.weights.length) {
	        this.weights = features;
	        this.bias = 1;
	    }
	    // Make a prediction based on current weights.
	    var prediction = this.predict(features);
	    // Update the weights if the prediction is wrong.
	    if (prediction !== label) {
	        var gradient = label - prediction;
	        for (var i = 0; i < this.weights.length; i++) {
	            this.weights[i] += gradient * features[i];
	        }
	        this.bias += gradient;
	    }
	    return this;
	};
	
	module.exports = PerceptronModel;


/***/ }),
/* 1467 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * We use `ε`, epsilon, as a stopping criterion when we want to iterate
	 * until we're "close enough". Epsilon is a very small number: for
	 * simple statistics, that number is **0.0001**
	 *
	 * This is used in calculations like the binomialDistribution, in which
	 * the process of finding a value is [iterative](https://en.wikipedia.org/wiki/Iterative_method):
	 * it progresses until it is close enough.
	 *
	 * Below is an example of using epsilon in [gradient descent](https://en.wikipedia.org/wiki/Gradient_descent),
	 * where we're trying to find a local minimum of a function's derivative,
	 * given by the `fDerivative` method.
	 *
	 * @example
	 * // From calculation, we expect that the local minimum occurs at x=9/4
	 * var x_old = 0;
	 * // The algorithm starts at x=6
	 * var x_new = 6;
	 * var stepSize = 0.01;
	 *
	 * function fDerivative(x) {
	 *   return 4 * Math.pow(x, 3) - 9 * Math.pow(x, 2);
	 * }
	 *
	 * // The loop runs until the difference between the previous
	 * // value and the current value is smaller than epsilon - a rough
	 * // meaure of 'close enough'
	 * while (Math.abs(x_new - x_old) > ss.epsilon) {
	 *   x_old = x_new;
	 *   x_new = x_old - stepSize * fDerivative(x_old);
	 * }
	 *
	 * console.log('Local minimum occurs at', x_new);
	 */
	var epsilon = 0.0001;
	
	module.exports = epsilon;


/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * A [Factorial](https://en.wikipedia.org/wiki/Factorial), usually written n!, is the product of all positive
	 * integers less than or equal to n. Often factorial is implemented
	 * recursively, but this iterative approach is significantly faster
	 * and simpler.
	 *
	 * @param {number} n input, must be an integer number 1 or greater
	 * @returns {number} factorial: n!
	 * @throws {Error} if n is less than 0 or not an integer
	 * @example
	 * factorial(5); // => 120
	 */
	function factorial(n /*: number */)/*: number */ {
	
	    // factorial is mathematically undefined for negative numbers
	    if (n < 0) {
	        throw new Error('factorial requires an integer input');
	    }
	
	    if (Math.floor(n) !== n) {
	        throw new Error('factorial requires a non-negative value');
	    }
	
	    // typically you'll expand the factorial function going down, like
	    // 5! = 5 * 4 * 3 * 2 * 1. This is going in the opposite direction,
	    // counting from 2 up to the number in question, and since anything
	    // multiplied by 1 is itself, the loop only needs to start at 2.
	    var accumulator = 1;
	    for (var i = 2; i <= n; i++) {
	        // for each number up to and including the number `n`, multiply
	        // the accumulator my that number.
	        accumulator *= i;
	    }
	    return accumulator;
	}
	
	module.exports = factorial;


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var binomialDistribution = __webpack_require__(1470);
	
	/**
	 * The [Bernoulli distribution](http://en.wikipedia.org/wiki/Bernoulli_distribution)
	 * is the probability discrete
	 * distribution of a random variable which takes value 1 with success
	 * probability `p` and value 0 with failure
	 * probability `q` = 1 - `p`. It can be used, for example, to represent the
	 * toss of a coin, where "1" is defined to mean "heads" and "0" is defined
	 * to mean "tails" (or vice versa). It is
	 * a special case of a Binomial Distribution
	 * where `n` = 1.
	 *
	 * @param {number} p input value, between 0 and 1 inclusive
	 * @returns {number} value of bernoulli distribution at this point
	 * @throws {Error} if p is outside 0 and 1
	 * @example
	 * bernoulliDistribution(0.5); // => { '0': 0.5, '1': 0.5 }
	 */
	function bernoulliDistribution(p/*: number */) {
	    // Check that `p` is a valid probability (0 ≤ p ≤ 1)
	    if (p < 0 || p > 1 ) {
	        throw new Error('bernoulliDistribution requires probability to be between 0 and 1 inclusive');
	    }
	
	    return binomialDistribution(1, p);
	}
	
	module.exports = bernoulliDistribution;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var epsilon = __webpack_require__(1467);
	var factorial = __webpack_require__(1468);
	
	/**
	 * The [Binomial Distribution](http://en.wikipedia.org/wiki/Binomial_distribution) is the discrete probability
	 * distribution of the number of successes in a sequence of n independent yes/no experiments, each of which yields
	 * success with probability `probability`. Such a success/failure experiment is also called a Bernoulli experiment or
	 * Bernoulli trial; when trials = 1, the Binomial Distribution is a Bernoulli Distribution.
	 *
	 * @param {number} trials number of trials to simulate
	 * @param {number} probability
	 * @returns {Object} output
	 */
	function binomialDistribution(
	    trials/*: number */,
	    probability/*: number */)/*: ?Object */ {
	    // Check that `p` is a valid probability (0 ≤ p ≤ 1),
	    // that `n` is an integer, strictly positive.
	    if (probability < 0 || probability > 1 ||
	        trials <= 0 || trials % 1 !== 0) {
	        return undefined;
	    }
	
	    // We initialize `x`, the random variable, and `accumulator`, an accumulator
	    // for the cumulative distribution function to 0. `distribution_functions`
	    // is the object we'll return with the `probability_of_x` and the
	    // `cumulativeProbability_of_x`, as well as the calculated mean &
	    // variance. We iterate until the `cumulativeProbability_of_x` is
	    // within `epsilon` of 1.0.
	    var x = 0,
	        cumulativeProbability = 0,
	        cells = {};
	
	    // This algorithm iterates through each potential outcome,
	    // until the `cumulativeProbability` is very close to 1, at
	    // which point we've defined the vast majority of outcomes
	    do {
	        // a [probability mass function](https://en.wikipedia.org/wiki/Probability_mass_function)
	        cells[x] = factorial(trials) /
	            (factorial(x) * factorial(trials - x)) *
	            (Math.pow(probability, x) * Math.pow(1 - probability, trials - x));
	        cumulativeProbability += cells[x];
	        x++;
	    // when the cumulativeProbability is nearly 1, we've calculated
	    // the useful range of this distribution
	    } while (cumulativeProbability < 1 - epsilon);
	
	    return cells;
	}
	
	module.exports = binomialDistribution;


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var epsilon = __webpack_require__(1467);
	var factorial = __webpack_require__(1468);
	
	/**
	 * The [Poisson Distribution](http://en.wikipedia.org/wiki/Poisson_distribution)
	 * is a discrete probability distribution that expresses the probability
	 * of a given number of events occurring in a fixed interval of time
	 * and/or space if these events occur with a known average rate and
	 * independently of the time since the last event.
	 *
	 * The Poisson Distribution is characterized by the strictly positive
	 * mean arrival or occurrence rate, `λ`.
	 *
	 * @param {number} lambda location poisson distribution
	 * @returns {number} value of poisson distribution at that point
	 */
	function poissonDistribution(lambda/*: number */) {
	    // Check that lambda is strictly positive
	    if (lambda <= 0) { return undefined; }
	
	    // our current place in the distribution
	    var x = 0,
	        // and we keep track of the current cumulative probability, in
	        // order to know when to stop calculating chances.
	        cumulativeProbability = 0,
	        // the calculated cells to be returned
	        cells = {};
	
	    // This algorithm iterates through each potential outcome,
	    // until the `cumulativeProbability` is very close to 1, at
	    // which point we've defined the vast majority of outcomes
	    do {
	        // a [probability mass function](https://en.wikipedia.org/wiki/Probability_mass_function)
	        cells[x] = (Math.pow(Math.E, -lambda) * Math.pow(lambda, x)) / factorial(x);
	        cumulativeProbability += cells[x];
	        x++;
	    // when the cumulativeProbability is nearly 1, we've calculated
	    // the useful range of this distribution
	    } while (cumulativeProbability < 1 - epsilon);
	
	    return cells;
	}
	
	module.exports = poissonDistribution;


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var mean = __webpack_require__(1420);
	var chiSquaredDistributionTable = __webpack_require__(1473);
	
	/**
	 * The [χ2 (Chi-Squared) Goodness-of-Fit Test](http://en.wikipedia.org/wiki/Goodness_of_fit#Pearson.27s_chi-squared_test)
	 * uses a measure of goodness of fit which is the sum of differences between observed and expected outcome frequencies
	 * (that is, counts of observations), each squared and divided by the number of observations expected given the
	 * hypothesized distribution. The resulting χ2 statistic, `chiSquared`, can be compared to the chi-squared distribution
	 * to determine the goodness of fit. In order to determine the degrees of freedom of the chi-squared distribution, one
	 * takes the total number of observed frequencies and subtracts the number of estimated parameters. The test statistic
	 * follows, approximately, a chi-square distribution with (k − c) degrees of freedom where `k` is the number of non-empty
	 * cells and `c` is the number of estimated parameters for the distribution.
	 *
	 * @param {Array<number>} data
	 * @param {Function} distributionType a function that returns a point in a distribution:
	 * for instance, binomial, bernoulli, or poisson
	 * @param {number} significance
	 * @returns {number} chi squared goodness of fit
	 * @example
	 * // Data from Poisson goodness-of-fit example 10-19 in William W. Hines & Douglas C. Montgomery,
	 * // "Probability and Statistics in Engineering and Management Science", Wiley (1980).
	 * var data1019 = [
	 *     0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	 *     0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	 *     1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
	 *     2, 2, 2, 2, 2, 2, 2, 2, 2,
	 *     3, 3, 3, 3
	 * ];
	 * ss.chiSquaredGoodnessOfFit(data1019, ss.poissonDistribution, 0.05)); //= false
	 */
	function chiSquaredGoodnessOfFit(
	    data/*: Array<number> */,
	    distributionType/*: Function */,
	    significance/*: number */)/*: boolean */ {
	    // Estimate from the sample data, a weighted mean.
	    var inputMean = mean(data),
	        // Calculated value of the χ2 statistic.
	        chiSquared = 0,
	        // Degrees of freedom, calculated as (number of class intervals -
	        // number of hypothesized distribution parameters estimated - 1)
	        degreesOfFreedom,
	        // Number of hypothesized distribution parameters estimated, expected to be supplied in the distribution test.
	        // Lose one degree of freedom for estimating `lambda` from the sample data.
	        c = 1,
	        // The hypothesized distribution.
	        // Generate the hypothesized distribution.
	        hypothesizedDistribution = distributionType(inputMean),
	        observedFrequencies = [],
	        expectedFrequencies = [],
	        k;
	
	    // Create an array holding a histogram from the sample data, of
	    // the form `{ value: numberOfOcurrences }`
	    for (var i = 0; i < data.length; i++) {
	        if (observedFrequencies[data[i]] === undefined) {
	            observedFrequencies[data[i]] = 0;
	        }
	        observedFrequencies[data[i]]++;
	    }
	
	    // The histogram we created might be sparse - there might be gaps
	    // between values. So we iterate through the histogram, making
	    // sure that instead of undefined, gaps have 0 values.
	    for (i = 0; i < observedFrequencies.length; i++) {
	        if (observedFrequencies[i] === undefined) {
	            observedFrequencies[i] = 0;
	        }
	    }
	
	    // Create an array holding a histogram of expected data given the
	    // sample size and hypothesized distribution.
	    for (k in hypothesizedDistribution) {
	        if (k in observedFrequencies) {
	            expectedFrequencies[+k] = hypothesizedDistribution[k] * data.length;
	        }
	    }
	
	    // Working backward through the expected frequencies, collapse classes
	    // if less than three observations are expected for a class.
	    // This transformation is applied to the observed frequencies as well.
	    for (k = expectedFrequencies.length - 1; k >= 0; k--) {
	        if (expectedFrequencies[k] < 3) {
	            expectedFrequencies[k - 1] += expectedFrequencies[k];
	            expectedFrequencies.pop();
	
	            observedFrequencies[k - 1] += observedFrequencies[k];
	            observedFrequencies.pop();
	        }
	    }
	
	    // Iterate through the squared differences between observed & expected
	    // frequencies, accumulating the `chiSquared` statistic.
	    for (k = 0; k < observedFrequencies.length; k++) {
	        chiSquared += Math.pow(
	            observedFrequencies[k] - expectedFrequencies[k], 2) /
	            expectedFrequencies[k];
	    }
	
	    // Calculate degrees of freedom for this test and look it up in the
	    // `chiSquaredDistributionTable` in order to
	    // accept or reject the goodness-of-fit of the hypothesized distribution.
	    degreesOfFreedom = observedFrequencies.length - c - 1;
	    return chiSquaredDistributionTable[degreesOfFreedom][significance] < chiSquared;
	}
	
	module.exports = chiSquaredGoodnessOfFit;


/***/ }),
/* 1473 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * **Percentage Points of the χ2 (Chi-Squared) Distribution**
	 *
	 * The [χ2 (Chi-Squared) Distribution](http://en.wikipedia.org/wiki/Chi-squared_distribution) is used in the common
	 * chi-squared tests for goodness of fit of an observed distribution to a theoretical one, the independence of two
	 * criteria of classification of qualitative data, and in confidence interval estimation for a population standard
	 * deviation of a normal distribution from a sample standard deviation.
	 *
	 * Values from Appendix 1, Table III of William W. Hines & Douglas C. Montgomery, "Probability and Statistics in
	 * Engineering and Management Science", Wiley (1980).
	 */
	var chiSquaredDistributionTable = {
	    '1': {
	        '0.995': 0,
	        '0.99': 0,
	        '0.975': 0,
	        '0.95': 0,
	        '0.9': 0.02,
	        '0.5': 0.45,
	        '0.1': 2.71,
	        '0.05': 3.84,
	        '0.025': 5.02,
	        '0.01': 6.63,
	        '0.005': 7.88
	    },
	    '2': {
	        '0.995': 0.01,
	        '0.99': 0.02,
	        '0.975': 0.05,
	        '0.95': 0.1,
	        '0.9': 0.21,
	        '0.5': 1.39,
	        '0.1': 4.61,
	        '0.05': 5.99,
	        '0.025': 7.38,
	        '0.01': 9.21,
	        '0.005': 10.6
	    },
	    '3': {
	        '0.995': 0.07,
	        '0.99': 0.11,
	        '0.975': 0.22,
	        '0.95': 0.35,
	        '0.9': 0.58,
	        '0.5': 2.37,
	        '0.1': 6.25,
	        '0.05': 7.81,
	        '0.025': 9.35,
	        '0.01': 11.34,
	        '0.005': 12.84
	    },
	    '4': {
	        '0.995': 0.21,
	        '0.99': 0.3,
	        '0.975': 0.48,
	        '0.95': 0.71,
	        '0.9': 1.06,
	        '0.5': 3.36,
	        '0.1': 7.78,
	        '0.05': 9.49,
	        '0.025': 11.14,
	        '0.01': 13.28,
	        '0.005': 14.86
	    },
	    '5': {
	        '0.995': 0.41,
	        '0.99': 0.55,
	        '0.975': 0.83,
	        '0.95': 1.15,
	        '0.9': 1.61,
	        '0.5': 4.35,
	        '0.1': 9.24,
	        '0.05': 11.07,
	        '0.025': 12.83,
	        '0.01': 15.09,
	        '0.005': 16.75
	    },
	    '6': {
	        '0.995': 0.68,
	        '0.99': 0.87,
	        '0.975': 1.24,
	        '0.95': 1.64,
	        '0.9': 2.2,
	        '0.5': 5.35,
	        '0.1': 10.65,
	        '0.05': 12.59,
	        '0.025': 14.45,
	        '0.01': 16.81,
	        '0.005': 18.55
	    },
	    '7': {
	        '0.995': 0.99,
	        '0.99': 1.25,
	        '0.975': 1.69,
	        '0.95': 2.17,
	        '0.9': 2.83,
	        '0.5': 6.35,
	        '0.1': 12.02,
	        '0.05': 14.07,
	        '0.025': 16.01,
	        '0.01': 18.48,
	        '0.005': 20.28
	    },
	    '8': {
	        '0.995': 1.34,
	        '0.99': 1.65,
	        '0.975': 2.18,
	        '0.95': 2.73,
	        '0.9': 3.49,
	        '0.5': 7.34,
	        '0.1': 13.36,
	        '0.05': 15.51,
	        '0.025': 17.53,
	        '0.01': 20.09,
	        '0.005': 21.96
	    },
	    '9': {
	        '0.995': 1.73,
	        '0.99': 2.09,
	        '0.975': 2.7,
	        '0.95': 3.33,
	        '0.9': 4.17,
	        '0.5': 8.34,
	        '0.1': 14.68,
	        '0.05': 16.92,
	        '0.025': 19.02,
	        '0.01': 21.67,
	        '0.005': 23.59
	    },
	    '10': {
	        '0.995': 2.16,
	        '0.99': 2.56,
	        '0.975': 3.25,
	        '0.95': 3.94,
	        '0.9': 4.87,
	        '0.5': 9.34,
	        '0.1': 15.99,
	        '0.05': 18.31,
	        '0.025': 20.48,
	        '0.01': 23.21,
	        '0.005': 25.19
	    },
	    '11': {
	        '0.995': 2.6,
	        '0.99': 3.05,
	        '0.975': 3.82,
	        '0.95': 4.57,
	        '0.9': 5.58,
	        '0.5': 10.34,
	        '0.1': 17.28,
	        '0.05': 19.68,
	        '0.025': 21.92,
	        '0.01': 24.72,
	        '0.005': 26.76
	    },
	    '12': {
	        '0.995': 3.07,
	        '0.99': 3.57,
	        '0.975': 4.4,
	        '0.95': 5.23,
	        '0.9': 6.3,
	        '0.5': 11.34,
	        '0.1': 18.55,
	        '0.05': 21.03,
	        '0.025': 23.34,
	        '0.01': 26.22,
	        '0.005': 28.3
	    },
	    '13': {
	        '0.995': 3.57,
	        '0.99': 4.11,
	        '0.975': 5.01,
	        '0.95': 5.89,
	        '0.9': 7.04,
	        '0.5': 12.34,
	        '0.1': 19.81,
	        '0.05': 22.36,
	        '0.025': 24.74,
	        '0.01': 27.69,
	        '0.005': 29.82
	    },
	    '14': {
	        '0.995': 4.07,
	        '0.99': 4.66,
	        '0.975': 5.63,
	        '0.95': 6.57,
	        '0.9': 7.79,
	        '0.5': 13.34,
	        '0.1': 21.06,
	        '0.05': 23.68,
	        '0.025': 26.12,
	        '0.01': 29.14,
	        '0.005': 31.32
	    },
	    '15': {
	        '0.995': 4.6,
	        '0.99': 5.23,
	        '0.975': 6.27,
	        '0.95': 7.26,
	        '0.9': 8.55,
	        '0.5': 14.34,
	        '0.1': 22.31,
	        '0.05': 25,
	        '0.025': 27.49,
	        '0.01': 30.58,
	        '0.005': 32.8
	    },
	    '16': {
	        '0.995': 5.14,
	        '0.99': 5.81,
	        '0.975': 6.91,
	        '0.95': 7.96,
	        '0.9': 9.31,
	        '0.5': 15.34,
	        '0.1': 23.54,
	        '0.05': 26.3,
	        '0.025': 28.85,
	        '0.01': 32,
	        '0.005': 34.27
	    },
	    '17': {
	        '0.995': 5.7,
	        '0.99': 6.41,
	        '0.975': 7.56,
	        '0.95': 8.67,
	        '0.9': 10.09,
	        '0.5': 16.34,
	        '0.1': 24.77,
	        '0.05': 27.59,
	        '0.025': 30.19,
	        '0.01': 33.41,
	        '0.005': 35.72
	    },
	    '18': {
	        '0.995': 6.26,
	        '0.99': 7.01,
	        '0.975': 8.23,
	        '0.95': 9.39,
	        '0.9': 10.87,
	        '0.5': 17.34,
	        '0.1': 25.99,
	        '0.05': 28.87,
	        '0.025': 31.53,
	        '0.01': 34.81,
	        '0.005': 37.16
	    },
	    '19': {
	        '0.995': 6.84,
	        '0.99': 7.63,
	        '0.975': 8.91,
	        '0.95': 10.12,
	        '0.9': 11.65,
	        '0.5': 18.34,
	        '0.1': 27.2,
	        '0.05': 30.14,
	        '0.025': 32.85,
	        '0.01': 36.19,
	        '0.005': 38.58
	    },
	    '20': {
	        '0.995': 7.43,
	        '0.99': 8.26,
	        '0.975': 9.59,
	        '0.95': 10.85,
	        '0.9': 12.44,
	        '0.5': 19.34,
	        '0.1': 28.41,
	        '0.05': 31.41,
	        '0.025': 34.17,
	        '0.01': 37.57,
	        '0.005': 40
	    },
	    '21': {
	        '0.995': 8.03,
	        '0.99': 8.9,
	        '0.975': 10.28,
	        '0.95': 11.59,
	        '0.9': 13.24,
	        '0.5': 20.34,
	        '0.1': 29.62,
	        '0.05': 32.67,
	        '0.025': 35.48,
	        '0.01': 38.93,
	        '0.005': 41.4
	    },
	    '22': {
	        '0.995': 8.64,
	        '0.99': 9.54,
	        '0.975': 10.98,
	        '0.95': 12.34,
	        '0.9': 14.04,
	        '0.5': 21.34,
	        '0.1': 30.81,
	        '0.05': 33.92,
	        '0.025': 36.78,
	        '0.01': 40.29,
	        '0.005': 42.8
	    },
	    '23': {
	        '0.995': 9.26,
	        '0.99': 10.2,
	        '0.975': 11.69,
	        '0.95': 13.09,
	        '0.9': 14.85,
	        '0.5': 22.34,
	        '0.1': 32.01,
	        '0.05': 35.17,
	        '0.025': 38.08,
	        '0.01': 41.64,
	        '0.005': 44.18
	    },
	    '24': {
	        '0.995': 9.89,
	        '0.99': 10.86,
	        '0.975': 12.4,
	        '0.95': 13.85,
	        '0.9': 15.66,
	        '0.5': 23.34,
	        '0.1': 33.2,
	        '0.05': 36.42,
	        '0.025': 39.36,
	        '0.01': 42.98,
	        '0.005': 45.56
	    },
	    '25': {
	        '0.995': 10.52,
	        '0.99': 11.52,
	        '0.975': 13.12,
	        '0.95': 14.61,
	        '0.9': 16.47,
	        '0.5': 24.34,
	        '0.1': 34.28,
	        '0.05': 37.65,
	        '0.025': 40.65,
	        '0.01': 44.31,
	        '0.005': 46.93
	    },
	    '26': {
	        '0.995': 11.16,
	        '0.99': 12.2,
	        '0.975': 13.84,
	        '0.95': 15.38,
	        '0.9': 17.29,
	        '0.5': 25.34,
	        '0.1': 35.56,
	        '0.05': 38.89,
	        '0.025': 41.92,
	        '0.01': 45.64,
	        '0.005': 48.29
	    },
	    '27': {
	        '0.995': 11.81,
	        '0.99': 12.88,
	        '0.975': 14.57,
	        '0.95': 16.15,
	        '0.9': 18.11,
	        '0.5': 26.34,
	        '0.1': 36.74,
	        '0.05': 40.11,
	        '0.025': 43.19,
	        '0.01': 46.96,
	        '0.005': 49.65
	    },
	    '28': {
	        '0.995': 12.46,
	        '0.99': 13.57,
	        '0.975': 15.31,
	        '0.95': 16.93,
	        '0.9': 18.94,
	        '0.5': 27.34,
	        '0.1': 37.92,
	        '0.05': 41.34,
	        '0.025': 44.46,
	        '0.01': 48.28,
	        '0.005': 50.99
	    },
	    '29': {
	        '0.995': 13.12,
	        '0.99': 14.26,
	        '0.975': 16.05,
	        '0.95': 17.71,
	        '0.9': 19.77,
	        '0.5': 28.34,
	        '0.1': 39.09,
	        '0.05': 42.56,
	        '0.025': 45.72,
	        '0.01': 49.59,
	        '0.005': 52.34
	    },
	    '30': {
	        '0.995': 13.79,
	        '0.99': 14.95,
	        '0.975': 16.79,
	        '0.95': 18.49,
	        '0.9': 20.6,
	        '0.5': 29.34,
	        '0.1': 40.26,
	        '0.05': 43.77,
	        '0.025': 46.98,
	        '0.01': 50.89,
	        '0.005': 53.67
	    },
	    '40': {
	        '0.995': 20.71,
	        '0.99': 22.16,
	        '0.975': 24.43,
	        '0.95': 26.51,
	        '0.9': 29.05,
	        '0.5': 39.34,
	        '0.1': 51.81,
	        '0.05': 55.76,
	        '0.025': 59.34,
	        '0.01': 63.69,
	        '0.005': 66.77
	    },
	    '50': {
	        '0.995': 27.99,
	        '0.99': 29.71,
	        '0.975': 32.36,
	        '0.95': 34.76,
	        '0.9': 37.69,
	        '0.5': 49.33,
	        '0.1': 63.17,
	        '0.05': 67.5,
	        '0.025': 71.42,
	        '0.01': 76.15,
	        '0.005': 79.49
	    },
	    '60': {
	        '0.995': 35.53,
	        '0.99': 37.48,
	        '0.975': 40.48,
	        '0.95': 43.19,
	        '0.9': 46.46,
	        '0.5': 59.33,
	        '0.1': 74.4,
	        '0.05': 79.08,
	        '0.025': 83.3,
	        '0.01': 88.38,
	        '0.005': 91.95
	    },
	    '70': {
	        '0.995': 43.28,
	        '0.99': 45.44,
	        '0.975': 48.76,
	        '0.95': 51.74,
	        '0.9': 55.33,
	        '0.5': 69.33,
	        '0.1': 85.53,
	        '0.05': 90.53,
	        '0.025': 95.02,
	        '0.01': 100.42,
	        '0.005': 104.22
	    },
	    '80': {
	        '0.995': 51.17,
	        '0.99': 53.54,
	        '0.975': 57.15,
	        '0.95': 60.39,
	        '0.9': 64.28,
	        '0.5': 79.33,
	        '0.1': 96.58,
	        '0.05': 101.88,
	        '0.025': 106.63,
	        '0.01': 112.33,
	        '0.005': 116.32
	    },
	    '90': {
	        '0.995': 59.2,
	        '0.99': 61.75,
	        '0.975': 65.65,
	        '0.95': 69.13,
	        '0.9': 73.29,
	        '0.5': 89.33,
	        '0.1': 107.57,
	        '0.05': 113.14,
	        '0.025': 118.14,
	        '0.01': 124.12,
	        '0.005': 128.3
	    },
	    '100': {
	        '0.995': 67.33,
	        '0.99': 70.06,
	        '0.975': 74.22,
	        '0.95': 77.93,
	        '0.9': 82.36,
	        '0.5': 99.33,
	        '0.1': 118.5,
	        '0.05': 124.34,
	        '0.025': 129.56,
	        '0.01': 135.81,
	        '0.005': 140.17
	    }
	};
	
	module.exports = chiSquaredDistributionTable;


/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The [Z-Score, or Standard Score](http://en.wikipedia.org/wiki/Standard_score).
	 *
	 * The standard score is the number of standard deviations an observation
	 * or datum is above or below the mean. Thus, a positive standard score
	 * represents a datum above the mean, while a negative standard score
	 * represents a datum below the mean. It is a dimensionless quantity
	 * obtained by subtracting the population mean from an individual raw
	 * score and then dividing the difference by the population standard
	 * deviation.
	 *
	 * The z-score is only defined if one knows the population parameters;
	 * if one only has a sample set, then the analogous computation with
	 * sample mean and sample standard deviation yields the
	 * Student's t-statistic.
	 *
	 * @param {number} x
	 * @param {number} mean
	 * @param {number} standardDeviation
	 * @return {number} z score
	 * @example
	 * zScore(78, 80, 5); // => -0.4
	 */
	function zScore(x/*:number*/, mean/*:number*/, standardDeviation/*:number*/)/*:number*/ {
	    return (x - mean) / standardDeviation;
	}
	
	module.exports = zScore;


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var standardNormalTable = __webpack_require__(1476);
	
	/**
	 * **[Cumulative Standard Normal Probability](http://en.wikipedia.org/wiki/Standard_normal_table)**
	 *
	 * Since probability tables cannot be
	 * printed for every normal distribution, as there are an infinite variety
	 * of normal distributions, it is common practice to convert a normal to a
	 * standard normal and then use the standard normal table to find probabilities.
	 *
	 * You can use `.5 + .5 * errorFunction(x / Math.sqrt(2))` to calculate the probability
	 * instead of looking it up in a table.
	 *
	 * @param {number} z
	 * @returns {number} cumulative standard normal probability
	 */
	function cumulativeStdNormalProbability(z /*:number */)/*:number */ {
	
	    // Calculate the position of this value.
	    var absZ = Math.abs(z),
	        // Each row begins with a different
	        // significant digit: 0.5, 0.6, 0.7, and so on. Each value in the table
	        // corresponds to a range of 0.01 in the input values, so the value is
	        // multiplied by 100.
	        index = Math.min(Math.round(absZ * 100), standardNormalTable.length - 1);
	
	    // The index we calculate must be in the table as a positive value,
	    // but we still pay attention to whether the input is positive
	    // or negative, and flip the output value as a last step.
	    if (z >= 0) {
	        return standardNormalTable[index];
	    } else {
	        // due to floating-point arithmetic, values in the table with
	        // 4 significant figures can nevertheless end up as repeating
	        // fractions when they're computed here.
	        return +(1 - standardNormalTable[index]).toFixed(4);
	    }
	}
	
	module.exports = cumulativeStdNormalProbability;


/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	var SQRT_2PI = Math.sqrt(2 * Math.PI);
	
	function cumulativeDistribution(z) {
	    var sum = z,
	        tmp = z;
	
	    // 15 iterations are enough for 4-digit precision
	    for (var i = 1; i < 15; i++) {
	        tmp *= z * z / (2 * i + 1);
	        sum += tmp;
	    }
	    return Math.round((0.5 + (sum / SQRT_2PI) * Math.exp(-z * z / 2)) * 1e4) / 1e4;
	}
	
	/**
	 * A standard normal table, also called the unit normal table or Z table,
	 * is a mathematical table for the values of Φ (phi), which are the values of
	 * the cumulative distribution function of the normal distribution.
	 * It is used to find the probability that a statistic is observed below,
	 * above, or between values on the standard normal distribution, and by
	 * extension, any normal distribution.
	 *
	 * The probabilities are calculated using the
	 * [Cumulative distribution function](https://en.wikipedia.org/wiki/Normal_distribution#Cumulative_distribution_function).
	 * The table used is the cumulative, and not cumulative from 0 to mean
	 * (even though the latter has 5 digits precision, instead of 4).
	 */
	var standardNormalTable/*: Array<number> */ = [];
	
	for (var z = 0; z <= 3.09; z += 0.01) {
	    standardNormalTable.push(cumulativeDistribution(z));
	}
	
	module.exports = standardNormalTable;


/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * **[Gaussian error function](http://en.wikipedia.org/wiki/Error_function)**
	 *
	 * The `errorFunction(x/(sd * Math.sqrt(2)))` is the probability that a value in a
	 * normal distribution with standard deviation sd is within x of the mean.
	 *
	 * This function returns a numerical approximation to the exact value.
	 *
	 * @param {number} x input
	 * @return {number} error estimation
	 * @example
	 * errorFunction(1).toFixed(2); // => '0.84'
	 */
	function errorFunction(x/*: number */)/*: number */ {
	    var t = 1 / (1 + 0.5 * Math.abs(x));
	    var tau = t * Math.exp(-Math.pow(x, 2) -
	        1.26551223 +
	        1.00002368 * t +
	        0.37409196 * Math.pow(t, 2) +
	        0.09678418 * Math.pow(t, 3) -
	        0.18628806 * Math.pow(t, 4) +
	        0.27886807 * Math.pow(t, 5) -
	        1.13520398 * Math.pow(t, 6) +
	        1.48851587 * Math.pow(t, 7) -
	        0.82215223 * Math.pow(t, 8) +
	        0.17087277 * Math.pow(t, 9));
	    if (x >= 0) {
	        return 1 - tau;
	    } else {
	        return tau - 1;
	    }
	}
	
	module.exports = errorFunction;


/***/ }),
/* 1478 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * The Inverse [Gaussian error function](http://en.wikipedia.org/wiki/Error_function)
	 * returns a numerical approximation to the value that would have caused
	 * `errorFunction()` to return x.
	 *
	 * @param {number} x value of error function
	 * @returns {number} estimated inverted value
	 */
	function inverseErrorFunction(x/*: number */)/*: number */ {
	    var a = (8 * (Math.PI - 3)) / (3 * Math.PI * (4 - Math.PI));
	
	    var inv = Math.sqrt(Math.sqrt(
	        Math.pow(2 / (Math.PI * a) + Math.log(1 - x * x) / 2, 2) -
	        Math.log(1 - x * x) / a) -
	        (2 / (Math.PI * a) + Math.log(1 - x * x) / 2));
	
	    if (x >= 0) {
	        return inv;
	    } else {
	        return -inv;
	    }
	}
	
	module.exports = inverseErrorFunction;


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var epsilon = __webpack_require__(1467);
	var inverseErrorFunction = __webpack_require__(1478);
	
	/**
	 * The [Probit](http://en.wikipedia.org/wiki/Probit)
	 * is the inverse of cumulativeStdNormalProbability(),
	 * and is also known as the normal quantile function.
	 *
	 * It returns the number of standard deviations from the mean
	 * where the p'th quantile of values can be found in a normal distribution.
	 * So, for example, probit(0.5 + 0.6827/2) ≈ 1 because 68.27% of values are
	 * normally found within 1 standard deviation above or below the mean.
	 *
	 * @param {number} p
	 * @returns {number} probit
	 */
	function probit(p /*: number */)/*: number */ {
	    if (p === 0) {
	        p = epsilon;
	    } else if (p >= 1) {
	        p = 1 - epsilon;
	    }
	    return Math.sqrt(2) * inverseErrorFunction(2 * p - 1);
	}
	
	module.exports = probit;


/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * **Mixin** simple_statistics to a single Array instance if provided
	 * or the Array native object if not. This is an optional
	 * feature that lets you treat simple_statistics as a native feature
	 * of Javascript.
	 *
	 * @param {Object} ss simple statistics
	 * @param {Array} [array=] a single array instance which will be augmented
	 * with the extra methods. If omitted, mixin will apply to all arrays
	 * by changing the global `Array.prototype`.
	 * @throws {Error} if the JavaScript environment doesn't support Object.defineProperty
	 * @returns {*} the extended Array, or Array.prototype if no object
	 * is given.
	 *
	 * @example
	 * var myNumbers = [1, 2, 3];
	 * mixin(ss, myNumbers);
	 * console.log(myNumbers.sum()); // 6
	 */
	function mixin(ss /*: Object */, array /*: ?Array<any> */)/*: any */ {
	    var support = !!(Object.defineProperty && Object.defineProperties);
	    // Coverage testing will never test this error.
	    /* istanbul ignore next */
	    if (!support) {
	        throw new Error('without defineProperty, simple-statistics cannot be mixed in');
	    }
	
	    // only methods which work on basic arrays in a single step
	    // are supported
	    var arrayMethods = ['median', 'standardDeviation', 'sum', 'product',
	        'sampleSkewness',
	        'mean', 'min', 'max', 'quantile', 'geometricMean',
	        'harmonicMean', 'root_mean_square'];
	
	    // create a closure with a method name so that a reference
	    // like `arrayMethods[i]` doesn't follow the loop increment
	    function wrap(method) {
	        return function() {
	            // cast any arguments into an array, since they're
	            // natively objects
	            var args = Array.prototype.slice.apply(arguments);
	            // make the first argument the array itself
	            args.unshift(this);
	            // return the result of the ss method
	            return ss[method].apply(ss, args);
	        };
	    }
	
	    // select object to extend
	    var extending;
	    if (array) {
	        // create a shallow copy of the array so that our internal
	        // operations do not change it by reference
	        extending = array.slice();
	    } else {
	        extending = Array.prototype;
	    }
	
	    // for each array function, define a function that gets
	    // the array as the first argument.
	    // We use [defineProperty](https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Object/defineProperty)
	    // because it allows these properties to be non-enumerable:
	    // `for (var in x)` loops will not run into problems with this
	    // implementation.
	    for (var i = 0; i < arrayMethods.length; i++) {
	        Object.defineProperty(extending, arrayMethods[i], {
	            value: wrap(arrayMethods[i]),
	            configurable: true,
	            enumerable: false,
	            writable: true
	        });
	    }
	
	    return extending;
	}
	
	module.exports = mixin;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/* @flow */
	
	var sign = __webpack_require__(1482);
	/**
	 * [Bisection method](https://en.wikipedia.org/wiki/Bisection_method) is a root-finding 
	 * method that repeatedly bisects an interval to find the root.
	 * 
	 * This function returns a numerical approximation to the exact value.
	 * 
	 * @param {Function} func input function
	 * @param {Number} start - start of interval
	 * @param {Number} end - end of interval
	 * @param {Number} maxIterations - the maximum number of iterations
	 * @param {Number} errorTolerance - the error tolerance
	 * @returns {Number} estimated root value
	 * @throws {TypeError} Argument func must be a function
	 * 
	 * @example
	 * bisect(Math.cos,0,4,100,0.003); // => 1.572265625
	 */
	function bisect(
	    func/*: (x: any) => number */,
	    start/*: number */,
	    end/*: number */,
	    maxIterations/*: number */,
	    errorTolerance/*: number */)/*:number*/ {
	
	    if (typeof func !== 'function') throw new TypeError('func must be a function');
	    
	    for (var i = 0; i < maxIterations; i++) {
	        var output = (start + end) / 2;
	
	        if (func(output) === 0 || Math.abs((end - start) / 2) < errorTolerance) {
	            return output;
	        }
	
	        if (sign(func(output)) === sign(func(start))) {
	            start = output;
	        } else {
	            end = output;
	        }
	    }
	    
	    throw new Error('maximum number of iterations exceeded');
	}
	
	module.exports = bisect;


/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	'use strict';
	/* @flow */
	
	/**
	 * [Sign](https://en.wikipedia.org/wiki/Sign_function) is a function 
	 * that extracts the sign of a real number
	 * 
	 * @param {Number} x input value
	 * @returns {Number} sign value either 1, 0 or -1
	 * @throws {TypeError} if the input argument x is not a number
	 * @private
	 * 
	 * @example
	 * sign(2); // => 1
	 */
	function sign(x/*: number */)/*: number */ {
	    if (typeof x === 'number') {
	        if (x < 0) {
	            return -1;
	        } else if (x === 0) {
	            return 0
	        } else {
	            return 1;
	        }
	    } else {
	        throw new TypeError('not a number');
	    }
	}
	
	module.exports = sign;


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _errors = __webpack_require__(1388);
	
	var _LeafletMarkerPinMap = __webpack_require__(1484);
	
	var _LeafletMarkerPinMap2 = _interopRequireDefault(_LeafletMarkerPinMap);
	
	var _LeafletTilePinMap = __webpack_require__(1487);
	
	var _LeafletTilePinMap2 = _interopRequireDefault(_LeafletTilePinMap);
	
	var _LeafletHeatMap = __webpack_require__(1488);
	
	var _LeafletHeatMap2 = _interopRequireDefault(_LeafletHeatMap);
	
	var _LeafletGridHeatMap = __webpack_require__(1490);
	
	var _LeafletGridHeatMap2 = _interopRequireDefault(_LeafletGridHeatMap);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d2 = __webpack_require__(873);
	
	var _d3 = _interopRequireDefault(_d2);
	
	var _leaflet = __webpack_require__(1412);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAP_COMPONENTS_BY_TYPE = {
	    "markers": _LeafletMarkerPinMap2.default,
	    "tiles": _LeafletTilePinMap2.default,
	    "heat": _LeafletHeatMap2.default,
	    "grid": _LeafletGridHeatMap2.default
	};
	
	var PinMap = (_temp = _class = function (_Component) {
	    _inherits(PinMap, _Component);
	
	    _createClass(PinMap, null, [{
	        key: "isSensible",
	        value: function isSensible(cols, rows) {
	            return (0, _schema_metadata.hasLatitudeAndLongitudeColumns)(cols);
	        }
	    }, {
	        key: "checkRenderable",
	        value: function checkRenderable(_ref) {
	            var _ref2 = _slicedToArray(_ref, 1),
	                _ref2$0$data = _ref2[0].data,
	                cols = _ref2$0$data.cols,
	                rows = _ref2$0$data.rows;
	
	            if (!(0, _schema_metadata.hasLatitudeAndLongitudeColumns)(cols)) {
	                throw new _errors.LatitudeLongitudeError();
	            }
	        }
	    }]);
	
	    function PinMap(props) {
	        _classCallCheck(this, PinMap);
	
	        var _this = _possibleConstructorReturn(this, (PinMap.__proto__ || Object.getPrototypeOf(PinMap)).call(this, props));
	
	        _this._map = null;
	
	        _this.updateSettings = function () {
	            var newSettings = {};
	            if (_this.state.lat != null) {
	                newSettings["map.center_latitude"] = _this.state.lat;
	            }
	            if (_this.state.lng != null) {
	                newSettings["map.center_longitude"] = _this.state.lng;
	            }
	            if (_this.state.zoom != null) {
	                newSettings["map.zoom"] = _this.state.zoom;
	            }
	            _this.props.onUpdateVisualizationSettings(newSettings);
	            _this.setState({ lat: null, lng: null, zoom: null });
	        };
	
	        _this.onMapCenterChange = function (lat, lng) {
	            _this.setState({ lat: lat, lng: lng });
	        };
	
	        _this.onMapZoomChange = function (zoom) {
	            _this.setState({ zoom: zoom });
	        };
	
	        _this.state = _extends({
	            lat: null,
	            lng: null,
	            zoom: null,
	            filtering: false
	        }, _this._getPoints(props));
	        return _this;
	    }
	
	    _createClass(PinMap, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            var SETTINGS_KEYS = ["map.latitude_column", "map.longitude_column", "map.metric_column"];
	            if (newProps.series[0].data !== this.props.series[0].data || !_underscore2.default.isEqual(
	            // $FlowFixMe
	            _underscore2.default.pick.apply(_underscore2.default, [newProps.settings].concat(SETTINGS_KEYS)),
	            // $FlowFixMe
	            _underscore2.default.pick.apply(_underscore2.default, [this.props.settings].concat(SETTINGS_KEYS)))) {
	                this.setState(this._getPoints(newProps));
	            }
	        }
	    }, {
	        key: "_getPoints",
	        value: function _getPoints(props) {
	            var settings = props.settings,
	                _props$series = _slicedToArray(props.series, 1),
	                _props$series$0$data = _props$series[0].data,
	                cols = _props$series$0$data.cols,
	                rows = _props$series$0$data.rows;
	
	            var latitudeIndex = _underscore2.default.findIndex(cols, function (col) {
	                return col.name === settings["map.latitude_column"];
	            });
	            var longitudeIndex = _underscore2.default.findIndex(cols, function (col) {
	                return col.name === settings["map.longitude_column"];
	            });
	            var metricIndex = _underscore2.default.findIndex(cols, function (col) {
	                return col.name === settings["map.metric_column"];
	            });
	
	            var points = rows.map(function (row) {
	                return [row[latitudeIndex], row[longitudeIndex], metricIndex >= 0 ? row[metricIndex] : 1];
	            });
	
	            var bounds = _leaflet2.default.latLngBounds(points);
	
	            var min = _d3.default.min(points, function (point) {
	                return point[2];
	            });
	            var max = _d3.default.max(points, function (point) {
	                return point[2];
	            });
	
	            var binWidth = cols[longitudeIndex] && cols[longitudeIndex].binning_info && cols[longitudeIndex].binning_info.bin_width;
	            var binHeight = cols[latitudeIndex] && cols[latitudeIndex].binning_info && cols[latitudeIndex].binning_info.bin_width;
	
	            if (binWidth != null) {
	                bounds._northEast.lng += binWidth;
	            }
	            if (binHeight != null) {
	                bounds._northEast.lat += binHeight;
	            }
	
	            return { points: points, bounds: bounds, min: min, max: max, binWidth: binWidth, binHeight: binHeight };
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                settings = _props.settings,
	                isEditing = _props.isEditing,
	                isDashboard = _props.isDashboard;
	            var _state = this.state,
	                lat = _state.lat,
	                lng = _state.lng,
	                zoom = _state.zoom;
	
	            var disableUpdateButton = lat == null && lng == null && zoom == null;
	
	            var Map = MAP_COMPONENTS_BY_TYPE[settings["map.pin_type"]];
	
	            var _state2 = this.state,
	                points = _state2.points,
	                bounds = _state2.bounds,
	                min = _state2.min,
	                max = _state2.max,
	                binHeight = _state2.binHeight,
	                binWidth = _state2.binWidth;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(className, "PinMap relative hover-parent hover--visibility"), onMouseDownCapture: function onMouseDownCapture(e) {
	                        return e.stopPropagation();
	                    } /* prevent dragging */ },
	                Map ? _react2.default.createElement(Map, _extends({}, this.props, {
	                    ref: function ref(map) {
	                        return _this2._map = map;
	                    },
	                    className: "absolute top left bottom right z1",
	                    onMapCenterChange: this.onMapCenterChange,
	                    onMapZoomChange: this.onMapZoomChange,
	                    lat: lat,
	                    lng: lng,
	                    zoom: zoom,
	                    points: points,
	                    bounds: bounds,
	                    min: min,
	                    max: max,
	                    binWidth: binWidth,
	                    binHeight: binHeight,
	                    onFiltering: function onFiltering(filtering) {
	                        return _this2.setState({ filtering: filtering });
	                    }
	                })) : null,
	                _react2.default.createElement(
	                    "div",
	                    { className: "absolute top right m1 z2 flex flex-column hover-child" },
	                    isEditing || !isDashboard ? _react2.default.createElement(
	                        "div",
	                        { className: (0, _classnames2.default)("PinMapUpdateButton Button Button--small mb1", { "PinMapUpdateButton--disabled": disableUpdateButton }), onClick: this.updateSettings },
	                        "Save as default view"
	                    ) : null,
	                    !isDashboard && _react2.default.createElement(
	                        "div",
	                        {
	                            className: (0, _classnames2.default)("PinMapUpdateButton Button Button--small mb1"),
	                            onClick: function onClick() {
	                                if (!_this2.state.filtering && _this2._map && _this2._map.startFilter) {
	                                    _this2._map.startFilter();
	                                } else if (_this2.state.filtering && _this2._map && _this2._map.stopFilter) {
	                                    _this2._map.stopFilter();
	                                }
	                            }
	                        },
	                        !this.state.filtering ? "Draw box to filter" : "Cancel filter"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PinMap;
	}(_react.Component), _class.uiName = "Pin Map", _class.identifier = "pin_map", _class.iconName = "pinmap", _temp);
	PinMap.displayName = "PinMap";
	exports.default = PinMap;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _LeafletMap2 = __webpack_require__(1485);
	
	var _LeafletMap3 = _interopRequireDefault(_LeafletMap2);
	
	var _leaflet = __webpack_require__(1412);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _formatting = __webpack_require__(872);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MARKER_ICON = _leaflet2.default.icon({
	    iconUrl: "app/assets/img/pin.png",
	    iconSize: [28, 32],
	    iconAnchor: [15, 24],
	    popupAnchor: [0, -13]
	});
	
	var LeafletMarkerPinMap = function (_LeafletMap) {
	    _inherits(LeafletMarkerPinMap, _LeafletMap);
	
	    function LeafletMarkerPinMap() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LeafletMarkerPinMap);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeafletMarkerPinMap.__proto__ || Object.getPrototypeOf(LeafletMarkerPinMap)).call.apply(_ref, [this].concat(args))), _this), _this._createMarker = function (index) {
	            var marker = _leaflet2.default.marker([0, 0], { icon: MARKER_ICON });
	            marker.on("click", function () {
	                var _this$props$series = _slicedToArray(_this.props.series, 1),
	                    data = _this$props$series[0].data;
	
	                var _this2 = _this,
	                    popup = _this2.popup;
	
	                var el = document.createElement("div");
	                _reactDom2.default.render(_react2.default.createElement(ObjectDetailTooltip, { row: data.rows[index], cols: data.cols }), el);
	                marker.unbindPopup();
	                marker.bindPopup(el, popup);
	                marker.openPopup();
	            });
	            return marker;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LeafletMarkerPinMap, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            _get(LeafletMarkerPinMap.prototype.__proto__ || Object.getPrototypeOf(LeafletMarkerPinMap.prototype), "componentDidMount", this).call(this);
	
	            this.pinMarkerLayer = _leaflet2.default.layerGroup([]).addTo(this.map);
	            this.componentDidUpdate({}, {});
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState) {
	            _get(LeafletMarkerPinMap.prototype.__proto__ || Object.getPrototypeOf(LeafletMarkerPinMap.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);
	
	            try {
	                var pinMarkerLayer = this.pinMarkerLayer;
	                var points = this.props.points;
	
	
	                var markers = pinMarkerLayer.getLayers();
	                var max = Math.max(points.length, markers.length);
	                for (var i = 0; i < max; i++) {
	                    if (i >= points.length) {
	                        pinMarkerLayer.removeLayer(markers[i]);
	                    }
	                    if (i >= markers.length) {
	                        var marker = this._createMarker(i);
	                        pinMarkerLayer.addLayer(marker);
	                        markers.push(marker);
	                    }
	
	                    if (i < points.length) {
	                        var _markers$i$getLatLng = markers[i].getLatLng(),
	                            lat = _markers$i$getLatLng.lat,
	                            lng = _markers$i$getLatLng.lng;
	
	                        if (lng !== points[i][0] || lat !== points[i][1]) {
	                            markers[i].setLatLng(points[i]);
	                        }
	                    }
	                }
	            } catch (err) {
	                console.error(err);
	                this.props.onRenderError(err.message || err);
	            }
	        }
	    }]);
	
	    return LeafletMarkerPinMap;
	}(_LeafletMap3.default);
	
	exports.default = LeafletMarkerPinMap;
	
	
	var ObjectDetailTooltip = function ObjectDetailTooltip(_ref2) {
	    var row = _ref2.row,
	        cols = _ref2.cols;
	    return _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	            "tbody",
	            null,
	            cols.map(function (col, index) {
	                return _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                        "td",
	                        { className: "pr1" },
	                        col.display_name,
	                        ":"
	                    ),
	                    _react2.default.createElement(
	                        "td",
	                        null,
	                        (0, _formatting.formatValue)(row[index], { column: col, jsx: true })
	                    )
	                );
	            })
	        )
	    );
	};
	ObjectDetailTooltip.displayName = "ObjectDetailTooltip";

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	__webpack_require__(1410);
	
	var _leaflet = __webpack_require__(1412);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(1486);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _actions = __webpack_require__(959);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeafletMap = function (_Component) {
	    _inherits(LeafletMap, _Component);
	
	    function LeafletMap() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LeafletMap);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeafletMap.__proto__ || Object.getPrototypeOf(LeafletMap)).call.apply(_ref, [this].concat(args))), _this), _this.onFilter = function (e) {
	            var bounds = e.layer.getBounds();
	
	            var _this$props = _this.props,
	                _this$props$series = _slicedToArray(_this$props.series, 1),
	                _this$props$series$ = _this$props$series[0],
	                card = _this$props$series$.card,
	                cols = _this$props$series$.data.cols,
	                settings = _this$props.settings,
	                setCardAndRun = _this$props.setCardAndRun;
	
	            var latitudeColumn = _underscore2.default.findWhere(cols, { name: settings["map.latitude_column"] });
	            var longitudeColumn = _underscore2.default.findWhere(cols, { name: settings["map.longitude_column"] });
	
	            setCardAndRun((0, _actions.updateLatLonFilter)(card, latitudeColumn, longitudeColumn, bounds));
	
	            _this.props.onFiltering(false);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LeafletMap, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            try {
	                var element = _reactDom2.default.findDOMNode(this.refs.map);
	
	                var map = this.map = _leaflet2.default.map(element, {
	                    scrollWheelZoom: false,
	                    minZoom: 2,
	                    drawControlTooltips: false,
	                    zoomSnap: false
	                });
	
	                var drawnItems = new _leaflet2.default.FeatureGroup();
	                map.addLayer(drawnItems);
	                var drawControl = this.drawControl = new _leaflet2.default.Control.Draw({
	                    draw: {
	                        rectangle: false,
	                        polyline: false,
	                        polygon: false,
	                        circle: false,
	                        marker: false
	                    },
	                    edit: {
	                        featureGroup: drawnItems,
	                        edit: false,
	                        remove: false
	                    }
	                });
	                map.addControl(drawControl);
	                map.on("draw:created", this.onFilter);
	
	                map.setView([0, 0], 8);
	
	                var mapTileUrl = _settings2.default.get("map_tile_server_url");
	                var mapTileAttribution = mapTileUrl.indexOf("openstreetmap.org") >= 0 ? 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors' : null;
	
	                _leaflet2.default.tileLayer(mapTileUrl, { attribution: mapTileAttribution }).addTo(map);
	
	                map.on("moveend", function () {
	                    var _map$getCenter = map.getCenter(),
	                        lat = _map$getCenter.lat,
	                        lng = _map$getCenter.lng;
	
	                    _this2.props.onMapCenterChange(lat, lng);
	                });
	                map.on("zoomend", function () {
	                    var zoom = map.getZoom();
	                    _this2.props.onMapZoomChange(zoom);
	                });
	            } catch (err) {
	                console.error(err);
	                this.props.onRenderError(err.message || err);
	            }
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps) {
	            var _props = this.props,
	                bounds = _props.bounds,
	                settings = _props.settings;
	
	            if (!prevProps || prevProps.points !== this.props.points || prevProps.width !== this.props.width || prevProps.height !== this.props.height) {
	                this.map.invalidateSize();
	
	                if (settings["map.center_latitude"] != null || settings["map.center_longitude"] != null || settings["map.zoom"] != null) {
	                    this.map.setView([settings["map.center_latitude"], settings["map.center_longitude"]], settings["map.zoom"]);
	                } else {
	                    // compute ideal lat and lon zoom separately and use the lesser zoom to ensure the bounds are visible
	                    var latZoom = this.map.getBoundsZoom(_leaflet2.default.latLngBounds([[bounds.getSouth(), 0], [bounds.getNorth(), 0]]));
	                    var lonZoom = this.map.getBoundsZoom(_leaflet2.default.latLngBounds([[0, bounds.getWest()], [0, bounds.getEast()]]));
	                    var zoom = Math.min(latZoom, lonZoom);
	                    // NOTE: unclear why calling `fitBounds` twice is sometimes required to get it to work 
	                    this.map.fitBounds(bounds);
	                    this.map.setZoom(zoom);
	                    this.map.fitBounds(bounds);
	                }
	            }
	        }
	    }, {
	        key: "startFilter",
	        value: function startFilter() {
	            this._filter = new _leaflet2.default.Draw.Rectangle(this.map, this.drawControl.options.rectangle);
	            this._filter.enable();
	            this.props.onFiltering(true);
	        }
	    }, {
	        key: "stopFilter",
	        value: function stopFilter() {
	            this._filter && this._filter.disable();
	            this.props.onFiltering(false);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var className = this.props.className;
	
	            return _react2.default.createElement("div", { className: className, ref: "map" });
	        }
	    }, {
	        key: "_getLatLonIndexes",
	        value: function _getLatLonIndexes() {
	            var _props2 = this.props,
	                settings = _props2.settings,
	                _props2$series = _slicedToArray(_props2.series, 1),
	                cols = _props2$series[0].data.cols;
	
	            return {
	                latitudeIndex: _underscore2.default.findIndex(cols, function (col) {
	                    return col.name === settings["map.latitude_column"];
	                }),
	                longitudeIndex: _underscore2.default.findIndex(cols, function (col) {
	                    return col.name === settings["map.longitude_column"];
	                })
	            };
	        }
	    }, {
	        key: "_getLatLonColumns",
	        value: function _getLatLonColumns() {
	            var _props$series = _slicedToArray(this.props.series, 1),
	                cols = _props$series[0].data.cols;
	
	            var _getLatLonIndexes2 = this._getLatLonIndexes(),
	                latitudeIndex = _getLatLonIndexes2.latitudeIndex,
	                longitudeIndex = _getLatLonIndexes2.longitudeIndex;
	
	            return {
	                latitudeColumn: cols[latitudeIndex],
	                longitudeColumn: cols[longitudeIndex]
	            };
	        }
	    }, {
	        key: "_getMetricColumn",
	        value: function _getMetricColumn() {
	            var _props3 = this.props,
	                settings = _props3.settings,
	                _props3$series = _slicedToArray(_props3.series, 1),
	                cols = _props3$series[0].data.cols;
	
	            return _underscore2.default.findWhere(cols, { name: settings["map.metric_column"] });
	        }
	    }]);
	
	    return LeafletMap;
	}(_react.Component);
	
	LeafletMap.displayName = "LeafletMap";
	exports.default = LeafletMap;

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	/*
	 Leaflet.draw 0.4.9, a plugin that adds drawing and editing tools to Leaflet powered maps.
	 (c) 2012-2017, Jacob Toye, Jon West, Smartrak, Leaflet
	
	 https://github.com/Leaflet/Leaflet.draw
	 http://leafletjs.com
	 */
	!function(t,e,i){L.drawVersion="0.4.9",L.Draw={},L.drawLocal={draw:{toolbar:{actions:{title:"Cancel drawing",text:"Cancel"},finish:{title:"Finish drawing",text:"Finish"},undo:{title:"Delete last point drawn",text:"Delete last point"},buttons:{polyline:"Draw a polyline",polygon:"Draw a polygon",rectangle:"Draw a rectangle",circle:"Draw a circle",marker:"Draw a marker"}},handlers:{circle:{tooltip:{start:"Click and drag to draw circle."},radius:"Radius"},marker:{tooltip:{start:"Click map to place marker."}},polygon:{tooltip:{start:"Click to start drawing shape.",cont:"Click to continue drawing shape.",end:"Click first point to close this shape."}},polyline:{error:"<strong>Error:</strong> shape edges cannot cross!",tooltip:{start:"Click to start drawing line.",cont:"Click to continue drawing line.",end:"Click last point to finish line."}},rectangle:{tooltip:{start:"Click and drag to draw rectangle."}},simpleshape:{tooltip:{end:"Release mouse to finish drawing."}}}},edit:{toolbar:{actions:{save:{title:"Save changes.",text:"Save"},cancel:{title:"Cancel editing, discards all changes.",text:"Cancel"}},buttons:{edit:"Edit layers.",editDisabled:"No layers to edit.",remove:"Delete layers.",removeDisabled:"No layers to delete."}},handlers:{edit:{tooltip:{text:"Drag handles, or marker to edit feature.",subtext:"Click cancel to undo changes."}},remove:{tooltip:{text:"Click on a feature to remove"}}}}},L.Draw.Event={},L.Draw.Event.CREATED="draw:created",L.Draw.Event.EDITED="draw:edited",L.Draw.Event.DELETED="draw:deleted",L.Draw.Event.DRAWSTART="draw:drawstart",L.Draw.Event.DRAWSTOP="draw:drawstop",L.Draw.Event.DRAWVERTEX="draw:drawvertex",L.Draw.Event.EDITSTART="draw:editstart",L.Draw.Event.EDITMOVE="draw:editmove",L.Draw.Event.EDITRESIZE="draw:editresize",L.Draw.Event.EDITVERTEX="draw:editvertex",L.Draw.Event.EDITSTOP="draw:editstop",L.Draw.Event.DELETESTART="draw:deletestart",L.Draw.Event.DELETESTOP="draw:deletestop",L.Draw=L.Draw||{},L.Draw.Feature=L.Handler.extend({includes:L.Mixin.Events,initialize:function(t,e){this._map=t,this._container=t._container,this._overlayPane=t._panes.overlayPane,this._popupPane=t._panes.popupPane,e&&e.shapeOptions&&(e.shapeOptions=L.Util.extend({},this.options.shapeOptions,e.shapeOptions)),L.setOptions(this,e)},enable:function(){this._enabled||(L.Handler.prototype.enable.call(this),this.fire("enabled",{handler:this.type}),this._map.fire(L.Draw.Event.DRAWSTART,{layerType:this.type}))},disable:function(){this._enabled&&(L.Handler.prototype.disable.call(this),this._map.fire(L.Draw.Event.DRAWSTOP,{layerType:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(L.DomUtil.disableTextSelection(),t.getContainer().focus(),this._tooltip=new L.Draw.Tooltip(this._map),L.DomEvent.on(this._container,"keyup",this._cancelDrawing,this))},removeHooks:function(){this._map&&(L.DomUtil.enableTextSelection(),this._tooltip.dispose(),this._tooltip=null,L.DomEvent.off(this._container,"keyup",this._cancelDrawing,this))},setOptions:function(t){L.setOptions(this,t)},_fireCreatedEvent:function(t){this._map.fire(L.Draw.Event.CREATED,{layer:t,layerType:this.type})},_cancelDrawing:function(t){this._map.fire("draw:canceled",{layerType:this.type}),27===t.keyCode&&this.disable()}}),L.Draw.Polyline=L.Draw.Feature.extend({statics:{TYPE:"polyline"},Poly:L.Polyline,options:{allowIntersection:!0,repeatMode:!1,drawError:{color:"#b00b00",timeout:2500},icon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon"}),touchIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"}),guidelineDistance:20,maxGuideLineLength:4e3,shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!1,clickable:!0},metric:!0,feet:!0,nautic:!1,showLength:!0,zIndexOffset:2e3},initialize:function(t,e){L.Browser.touch&&(this.options.icon=this.options.touchIcon),this.options.drawError.message=L.drawLocal.draw.handlers.polyline.error,e&&e.drawError&&(e.drawError=L.Util.extend({},this.options.drawError,e.drawError)),this.type=L.Draw.Polyline.TYPE,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._markers=[],this._markerGroup=new L.LayerGroup,this._map.addLayer(this._markerGroup),this._poly=new L.Polyline([],this.options.shapeOptions),this._tooltip.updateContent(this._getTooltipText()),this._mouseMarker||(this._mouseMarker=L.marker(this._map.getCenter(),{icon:L.divIcon({className:"leaflet-mouse-marker",iconAnchor:[20,20],iconSize:[40,40]}),opacity:0,zIndexOffset:this.options.zIndexOffset})),this._mouseMarker.on("mouseout",this._onMouseOut,this).on("mousemove",this._onMouseMove,this).on("mousedown",this._onMouseDown,this).on("mouseup",this._onMouseUp,this).addTo(this._map),this._map.on("mouseup",this._onMouseUp,this).on("mousemove",this._onMouseMove,this).on("zoomlevelschange",this._onZoomEnd,this).on("touchstart",this._onTouch,this).on("zoomend",this._onZoomEnd,this))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._clearHideErrorTimeout(),this._cleanUpShape(),this._map.removeLayer(this._markerGroup),delete this._markerGroup,delete this._markers,this._map.removeLayer(this._poly),delete this._poly,this._mouseMarker.off("mousedown",this._onMouseDown,this).off("mouseout",this._onMouseOut,this).off("mouseup",this._onMouseUp,this).off("mousemove",this._onMouseMove,this),this._map.removeLayer(this._mouseMarker),delete this._mouseMarker,this._clearGuides(),this._map.off("mouseup",this._onMouseUp,this).off("mousemove",this._onMouseMove,this).off("zoomlevelschange",this._onZoomEnd,this).off("zoomend",this._onZoomEnd,this).off("touchstart",this._onTouch,this).off("click",this._onTouch,this)},deleteLastVertex:function(){if(!(this._markers.length<=1)){var t=this._markers.pop(),e=this._poly,i=e.getLatLngs(),o=i.splice(-1,1)[0];this._poly.setLatLngs(i),this._markerGroup.removeLayer(t),e.getLatLngs().length<2&&this._map.removeLayer(e),this._vertexChanged(o,!1)}},addVertex:function(t){var e=this._markers.length;return e>=2&&!this.options.allowIntersection&&this._poly.newLatLngIntersects(t)?void this._showErrorTooltip():(this._errorShown&&this._hideErrorTooltip(),this._markers.push(this._createMarker(t)),this._poly.addLatLng(t),2===this._poly.getLatLngs().length&&this._map.addLayer(this._poly),void this._vertexChanged(t,!0))},completeShape:function(){this._markers.length<=1||(this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable())},_finishShape:function(){var t=this._poly._defaultShape?this._poly._defaultShape():this._poly.getLatLngs(),e=this._poly.newLatLngIntersects(t[t.length-1]);return!this.options.allowIntersection&&e||!this._shapeIsValid()?void this._showErrorTooltip():(this._fireCreatedEvent(),this.disable(),void(this.options.repeatMode&&this.enable()))},_shapeIsValid:function(){return!0},_onZoomEnd:function(){null!==this._markers&&this._updateGuide()},_onMouseMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent),i=this._map.layerPointToLatLng(e);this._currentLatLng=i,this._updateTooltip(i),this._updateGuide(e),this._mouseMarker.setLatLng(i),L.DomEvent.preventDefault(t.originalEvent)},_vertexChanged:function(t,e){this._map.fire(L.Draw.Event.DRAWVERTEX,{layers:this._markerGroup}),this._updateFinishHandler(),this._updateRunningMeasure(t,e),this._clearGuides(),this._updateTooltip()},_onMouseDown:function(t){if(!this._clickHandled&&!this._touchHandled&&!this._disableMarkers){this._onMouseMove(t),this._clickHandled=!0,this._disableNewMarkers();var e=t.originalEvent,i=e.clientX,o=e.clientY;this._startPoint.call(this,i,o)}},_startPoint:function(t,e){this._mouseDownOrigin=L.point(t,e)},_onMouseUp:function(t){var e=t.originalEvent,i=e.clientX,o=e.clientY;this._endPoint.call(this,i,o,t),this._clickHandled=null},_endPoint:function(e,i,o){if(this._mouseDownOrigin){var n=L.point(e,i).distanceTo(this._mouseDownOrigin),s=this._calculateFinishDistance(o.latlng);s<10&&L.Browser.touch?this._finishShape():Math.abs(n)<9*(t.devicePixelRatio||1)&&this.addVertex(o.latlng),this._enableNewMarkers()}this._mouseDownOrigin=null},_onTouch:function(t){var e,i,o=t.originalEvent;!o.touches||!o.touches[0]||this._clickHandled||this._touchHandled||this._disableMarkers||(e=o.touches[0].clientX,i=o.touches[0].clientY,this._disableNewMarkers(),this._touchHandled=!0,this._startPoint.call(this,e,i),this._endPoint.call(this,e,i,t),this._touchHandled=null),this._clickHandled=null},_onMouseOut:function(){this._tooltip&&this._tooltip._onMouseOut.call(this._tooltip)},_calculateFinishDistance:function(t){var e;if(this._markers.length>0){var i;if(this.type===L.Draw.Polyline.TYPE)i=this._markers[this._markers.length-1];else{if(this.type!==L.Draw.Polygon.TYPE)return 1/0;i=this._markers[0]}var o=this._map.latLngToContainerPoint(i.getLatLng()),n=new L.Marker(t,{icon:this.options.icon,zIndexOffset:2*this.options.zIndexOffset}),s=this._map.latLngToContainerPoint(n.getLatLng());e=o.distanceTo(s)}else e=1/0;return e},_updateFinishHandler:function(){var t=this._markers.length;t>1&&this._markers[t-1].on("click",this._finishShape,this),t>2&&this._markers[t-2].off("click",this._finishShape,this)},_createMarker:function(t){var e=new L.Marker(t,{icon:this.options.icon,zIndexOffset:2*this.options.zIndexOffset});return this._markerGroup.addLayer(e),e},_updateGuide:function(t){var e=this._markers?this._markers.length:0;e>0&&(t=t||this._map.latLngToLayerPoint(this._currentLatLng),this._clearGuides(),this._drawGuide(this._map.latLngToLayerPoint(this._markers[e-1].getLatLng()),t))},_updateTooltip:function(t){var e=this._getTooltipText();t&&this._tooltip.updatePosition(t),this._errorShown||this._tooltip.updateContent(e)},_drawGuide:function(t,e){var i,o,n,s=Math.floor(Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))),a=this.options.guidelineDistance,r=this.options.maxGuideLineLength,h=s>r?s-r:a;for(this._guidesContainer||(this._guidesContainer=L.DomUtil.create("div","leaflet-draw-guides",this._overlayPane));h<s;h+=this.options.guidelineDistance)i=h/s,o={x:Math.floor(t.x*(1-i)+i*e.x),y:Math.floor(t.y*(1-i)+i*e.y)},n=L.DomUtil.create("div","leaflet-draw-guide-dash",this._guidesContainer),n.style.backgroundColor=this._errorShown?this.options.drawError.color:this.options.shapeOptions.color,L.DomUtil.setPosition(n,o)},_updateGuideColor:function(t){if(this._guidesContainer)for(var e=0,i=this._guidesContainer.childNodes.length;e<i;e++)this._guidesContainer.childNodes[e].style.backgroundColor=t},_clearGuides:function(){if(this._guidesContainer)for(;this._guidesContainer.firstChild;)this._guidesContainer.removeChild(this._guidesContainer.firstChild)},_getTooltipText:function(){var t,e,i=this.options.showLength;return L.Browser.touch&&(i=!1),0===this._markers.length?t={text:L.drawLocal.draw.handlers.polyline.tooltip.start}:(e=i?this._getMeasurementString():"",t=1===this._markers.length?{text:L.drawLocal.draw.handlers.polyline.tooltip.cont,subtext:e}:{text:L.drawLocal.draw.handlers.polyline.tooltip.end,subtext:e}),t},_updateRunningMeasure:function(t,e){var i,o,n=this._markers.length;1===this._markers.length?this._measurementRunningTotal=0:(i=n-(e?2:1),o=t.distanceTo(this._markers[i].getLatLng()),this._measurementRunningTotal+=o*(e?1:-1))},_getMeasurementString:function(){var t,e=this._currentLatLng,i=this._markers[this._markers.length-1].getLatLng();return t=this._measurementRunningTotal+e.distanceTo(i),L.GeometryUtil.readableDistance(t,this.options.metric,this.options.feet,this.options.nautic)},_showErrorTooltip:function(){this._errorShown=!0,this._tooltip.showAsError().updateContent({text:this.options.drawError.message}),this._updateGuideColor(this.options.drawError.color),this._poly.setStyle({color:this.options.drawError.color}),this._clearHideErrorTimeout(),this._hideErrorTimeout=setTimeout(L.Util.bind(this._hideErrorTooltip,this),this.options.drawError.timeout)},_hideErrorTooltip:function(){this._errorShown=!1,this._clearHideErrorTimeout(),this._tooltip.removeError().updateContent(this._getTooltipText()),this._updateGuideColor(this.options.shapeOptions.color),this._poly.setStyle({color:this.options.shapeOptions.color})},_clearHideErrorTimeout:function(){this._hideErrorTimeout&&(clearTimeout(this._hideErrorTimeout),this._hideErrorTimeout=null)},_disableNewMarkers:function(){this._disableMarkers=!0},_enableNewMarkers:function(){setTimeout(function(){this._disableMarkers=!1}.bind(this),50)},_cleanUpShape:function(){this._markers.length>1&&this._markers[this._markers.length-1].off("click",this._finishShape,this)},_fireCreatedEvent:function(){var t=new this.Poly(this._poly.getLatLngs(),this.options.shapeOptions);L.Draw.Feature.prototype._fireCreatedEvent.call(this,t)}}),L.Draw.Polygon=L.Draw.Polyline.extend({statics:{TYPE:"polygon"},Poly:L.Polygon,options:{showArea:!1,shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0},metric:!0},initialize:function(t,e){L.Draw.Polyline.prototype.initialize.call(this,t,e),this.type=L.Draw.Polygon.TYPE},_updateFinishHandler:function(){var t=this._markers.length;1===t&&this._markers[0].on("click",this._finishShape,this),t>2&&(this._markers[t-1].on("dblclick",this._finishShape,this),t>3&&this._markers[t-2].off("dblclick",this._finishShape,this))},_getTooltipText:function(){var t,e;return 0===this._markers.length?t=L.drawLocal.draw.handlers.polygon.tooltip.start:this._markers.length<3?t=L.drawLocal.draw.handlers.polygon.tooltip.cont:(t=L.drawLocal.draw.handlers.polygon.tooltip.end,e=this._getMeasurementString()),{text:t,subtext:e}},_getMeasurementString:function(){var t=this._area;return t?L.GeometryUtil.readableArea(t,this.options.metric):null},_shapeIsValid:function(){return this._markers.length>=3},_vertexChanged:function(t,e){var i;!this.options.allowIntersection&&this.options.showArea&&(i=this._poly.getLatLngs(),this._area=L.GeometryUtil.geodesicArea(i)),L.Draw.Polyline.prototype._vertexChanged.call(this,t,e)},_cleanUpShape:function(){var t=this._markers.length;t>0&&(this._markers[0].off("click",this._finishShape,this),t>2&&this._markers[t-1].off("dblclick",this._finishShape,this))}}),L.SimpleShape={},L.Draw.SimpleShape=L.Draw.Feature.extend({options:{repeatMode:!1},initialize:function(t,e){this._endLabelText=L.drawLocal.draw.handlers.simpleshape.tooltip.end,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._mapDraggable=this._map.dragging.enabled(),this._mapDraggable&&this._map.dragging.disable(),this._container.style.cursor="crosshair",this._tooltip.updateContent({text:this._initialLabelText}),this._map.on("mousedown",this._onMouseDown,this).on("mousemove",this._onMouseMove,this).on("touchstart",this._onMouseDown,this).on("touchmove",this._onMouseMove,this))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._map&&(this._mapDraggable&&this._map.dragging.enable(),this._container.style.cursor="",this._map.off("mousedown",this._onMouseDown,this).off("mousemove",this._onMouseMove,this).off("touchstart",this._onMouseDown,this).off("touchmove",this._onMouseMove,this),L.DomEvent.off(e,"mouseup",this._onMouseUp,this),L.DomEvent.off(e,"touchend",this._onMouseUp,this),this._shape&&(this._map.removeLayer(this._shape),delete this._shape)),this._isDrawing=!1},_getTooltipText:function(){return{text:this._endLabelText}},_onMouseDown:function(t){this._isDrawing=!0,this._startLatLng=t.latlng,L.DomEvent.on(e,"mouseup",this._onMouseUp,this).on(e,"touchend",this._onMouseUp,this).preventDefault(t.originalEvent)},_onMouseMove:function(t){var e=t.latlng;this._tooltip.updatePosition(e),this._isDrawing&&(this._tooltip.updateContent(this._getTooltipText()),this._drawShape(e))},_onMouseUp:function(){this._shape&&this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable()}}),L.Draw.Rectangle=L.Draw.SimpleShape.extend({statics:{TYPE:"rectangle"},options:{shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,showArea:!0,clickable:!0},metric:!0},initialize:function(t,e){this.type=L.Draw.Rectangle.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.rectangle.tooltip.start,L.Draw.SimpleShape.prototype.initialize.call(this,t,e)},_drawShape:function(t){this._shape?this._shape.setBounds(new L.LatLngBounds(this._startLatLng,t)):(this._shape=new L.Rectangle(new L.LatLngBounds(this._startLatLng,t),this.options.shapeOptions),this._map.addLayer(this._shape))},_fireCreatedEvent:function(){var t=new L.Rectangle(this._shape.getBounds(),this.options.shapeOptions);L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this,t)},_getTooltipText:function(){var t,e,i,o=L.Draw.SimpleShape.prototype._getTooltipText.call(this),n=this._shape,s=this.options.showArea;return n&&(t=this._shape._defaultShape?this._shape._defaultShape():this._shape.getLatLngs(),e=L.GeometryUtil.geodesicArea(t),i=s?L.GeometryUtil.readableArea(e,this.options.metric):""),{text:o.text,subtext:i}}}),L.Draw.Circle=L.Draw.SimpleShape.extend({statics:{TYPE:"circle"},options:{shapeOptions:{stroke:!0,color:"#3388ff",weight:4,opacity:.5,fill:!0,fillColor:null,fillOpacity:.2,clickable:!0},showRadius:!0,metric:!0,feet:!0,nautic:!1},initialize:function(t,e){this.type=L.Draw.Circle.TYPE,this._initialLabelText=L.drawLocal.draw.handlers.circle.tooltip.start,L.Draw.SimpleShape.prototype.initialize.call(this,t,e)},_drawShape:function(t){this._shape?this._shape.setRadius(this._startLatLng.distanceTo(t)):(this._shape=new L.Circle(this._startLatLng,this._startLatLng.distanceTo(t),this.options.shapeOptions),this._map.addLayer(this._shape))},_fireCreatedEvent:function(){var t=new L.Circle(this._startLatLng,this._shape.getRadius(),this.options.shapeOptions);L.Draw.SimpleShape.prototype._fireCreatedEvent.call(this,t)},_onMouseMove:function(t){var e,i=t.latlng,o=this.options.showRadius,n=this.options.metric;if(this._tooltip.updatePosition(i),this._isDrawing){this._drawShape(i),e=this._shape.getRadius().toFixed(1);var s="";o&&(s=L.drawLocal.draw.handlers.circle.radius+": "+L.GeometryUtil.readableDistance(e,n,this.options.feet,this.options.nautic)),this._tooltip.updateContent({text:this._endLabelText,subtext:s})}}}),L.Draw.Marker=L.Draw.Feature.extend({statics:{TYPE:"marker"},options:{icon:new L.Icon.Default,repeatMode:!1,zIndexOffset:2e3},initialize:function(t,e){this.type=L.Draw.Marker.TYPE,L.Draw.Feature.prototype.initialize.call(this,t,e)},addHooks:function(){L.Draw.Feature.prototype.addHooks.call(this),this._map&&(this._tooltip.updateContent({text:L.drawLocal.draw.handlers.marker.tooltip.start}),this._mouseMarker||(this._mouseMarker=L.marker(this._map.getCenter(),{icon:L.divIcon({className:"leaflet-mouse-marker",iconAnchor:[20,20],iconSize:[40,40]}),opacity:0,zIndexOffset:this.options.zIndexOffset})),this._mouseMarker.on("click",this._onClick,this).addTo(this._map),this._map.on("mousemove",this._onMouseMove,this),this._map.on("click",this._onTouch,this))},removeHooks:function(){L.Draw.Feature.prototype.removeHooks.call(this),this._map&&(this._marker&&(this._marker.off("click",this._onClick,this),this._map.off("click",this._onClick,this).off("click",this._onTouch,this).removeLayer(this._marker),delete this._marker),this._mouseMarker.off("click",this._onClick,this),this._map.removeLayer(this._mouseMarker),delete this._mouseMarker,this._map.off("mousemove",this._onMouseMove,this))},_onMouseMove:function(t){var e=t.latlng;this._tooltip.updatePosition(e),this._mouseMarker.setLatLng(e),this._marker?(e=this._mouseMarker.getLatLng(),this._marker.setLatLng(e)):(this._marker=new L.Marker(e,{icon:this.options.icon,zIndexOffset:this.options.zIndexOffset}),this._marker.on("click",this._onClick,this),this._map.on("click",this._onClick,this).addLayer(this._marker))},_onClick:function(){this._fireCreatedEvent(),this.disable(),this.options.repeatMode&&this.enable()},_onTouch:function(t){this._onMouseMove(t),this._onClick()},_fireCreatedEvent:function(){var t=new L.Marker.Touch(this._marker.getLatLng(),{icon:this.options.icon});L.Draw.Feature.prototype._fireCreatedEvent.call(this,t)}}),L.Edit=L.Edit||{},L.Edit.Marker=L.Handler.extend({initialize:function(t,e){this._marker=t,L.setOptions(this,e)},addHooks:function(){var t=this._marker;t.dragging.enable(),t.on("dragend",this._onDragEnd,t),this._toggleMarkerHighlight()},removeHooks:function(){var t=this._marker;t.dragging.disable(),t.off("dragend",this._onDragEnd,t),this._toggleMarkerHighlight()},_onDragEnd:function(t){var e=t.target;e.edited=!0,this._map.fire(L.Draw.Event.EDITMOVE,{layer:e})},_toggleMarkerHighlight:function(){var t=this._marker._icon;t&&(t.style.display="none",L.DomUtil.hasClass(t,"leaflet-edit-marker-selected")?(L.DomUtil.removeClass(t,"leaflet-edit-marker-selected"),this._offsetMarker(t,-4)):(L.DomUtil.addClass(t,"leaflet-edit-marker-selected"),this._offsetMarker(t,4)),t.style.display="")},_offsetMarker:function(t,e){var i=parseInt(t.style.marginTop,10)-e,o=parseInt(t.style.marginLeft,10)-e;t.style.marginTop=i+"px",t.style.marginLeft=o+"px"}}),L.Marker.addInitHook(function(){L.Edit.Marker&&(this.editing=new L.Edit.Marker(this),this.options.editable&&this.editing.enable())}),L.Edit=L.Edit||{},L.Edit.Poly=L.Handler.extend({options:{},initialize:function(t,e){this.latlngs=[t._latlngs],t._holes&&(this.latlngs=this.latlngs.concat(t._holes)),this._poly=t,L.setOptions(this,e),this._poly.on("revert-edited",this._updateLatLngs,this)},_defaultShape:function(){return L.Polyline._flat?L.Polyline._flat(this._poly._latlngs)?this._poly._latlngs:this._poly._latlngs[0]:this._poly._latlngs},_eachVertexHandler:function(t){for(var e=0;e<this._verticesHandlers.length;e++)t(this._verticesHandlers[e])},addHooks:function(){this._initHandlers(),this._eachVertexHandler(function(t){t.addHooks()})},removeHooks:function(){this._eachVertexHandler(function(t){t.removeHooks()})},updateMarkers:function(){this._eachVertexHandler(function(t){t.updateMarkers()})},_initHandlers:function(){this._verticesHandlers=[];for(var t=0;t<this.latlngs.length;t++)this._verticesHandlers.push(new L.Edit.PolyVerticesEdit(this._poly,this.latlngs[t],this.options))},_updateLatLngs:function(t){this.latlngs=[t.layer._latlngs],t.layer._holes&&(this.latlngs=this.latlngs.concat(t.layer._holes))}}),L.Edit.PolyVerticesEdit=L.Handler.extend({options:{icon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon"}),touchIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-touch-icon"}),drawError:{color:"#b00b00",timeout:1e3}},initialize:function(t,e,i){L.Browser.touch&&(this.options.icon=this.options.touchIcon),this._poly=t,i&&i.drawError&&(i.drawError=L.Util.extend({},this.options.drawError,i.drawError)),this._latlngs=e,L.setOptions(this,i)},_defaultShape:function(){return L.Polyline._flat?L.Polyline._flat(this._latlngs)?this._latlngs:this._latlngs[0]:this._latlngs},addHooks:function(){var t=this._poly;t instanceof L.Polygon||(t.options.fill=!1,t.options.editing&&(t.options.editing.fill=!1)),t.setStyle(t.options.editing),this._poly._map&&(this._map=this._poly._map,this._markerGroup||this._initMarkers(),this._poly._map.addLayer(this._markerGroup))},removeHooks:function(){var t=this._poly;t.setStyle(t.options.original),t._map&&(t._map.removeLayer(this._markerGroup),delete this._markerGroup,delete this._markers)},updateMarkers:function(){this._markerGroup.clearLayers(),this._initMarkers()},_initMarkers:function(){this._markerGroup||(this._markerGroup=new L.LayerGroup),this._markers=[];var t,e,i,o,n=this._defaultShape();for(t=0,i=n.length;t<i;t++)o=this._createMarker(n[t],t),o.on("click",this._onMarkerClick,this),this._markers.push(o);var s,a;for(t=0,e=i-1;t<i;e=t++)(0!==t||L.Polygon&&this._poly instanceof L.Polygon)&&(s=this._markers[e],a=this._markers[t],this._createMiddleMarker(s,a),this._updatePrevNext(s,a))},_createMarker:function(t,e){var i=new L.Marker.Touch(t,{draggable:!0,icon:this.options.icon});return i._origLatLng=t,i._index=e,i.on("dragstart",this._onMarkerDragStart,this).on("drag",this._onMarkerDrag,this).on("dragend",this._fireEdit,this).on("touchmove",this._onTouchMove,this).on("touchend",this._fireEdit,this).on("MSPointerMove",this._onTouchMove,this).on("MSPointerUp",this._fireEdit,this),this._markerGroup.addLayer(i),i},_onMarkerDragStart:function(){this._poly.fire("editstart")},_spliceLatLngs:function(){var t=this._defaultShape(),e=[].splice.apply(t,arguments);return this._poly._convertLatLngs(t,!0),this._poly.redraw(),e},_removeMarker:function(t){var e=t._index;this._markerGroup.removeLayer(t),this._markers.splice(e,1),this._spliceLatLngs(e,1),this._updateIndexes(e,-1),t.off("dragstart",this._onMarkerDragStart,this).off("drag",this._onMarkerDrag,this).off("dragend",this._fireEdit,this).off("touchmove",this._onMarkerDrag,this).off("touchend",this._fireEdit,this).off("click",this._onMarkerClick,this).off("MSPointerMove",this._onTouchMove,this).off("MSPointerUp",this._fireEdit,this)},_fireEdit:function(){this._poly.edited=!0,this._poly.fire("edit"),this._poly._map.fire(L.Draw.Event.EDITVERTEX,{layers:this._markerGroup,poly:this._poly})},_onMarkerDrag:function(t){var e=t.target,i=this._poly;if(L.extend(e._origLatLng,e._latlng),e._middleLeft&&e._middleLeft.setLatLng(this._getMiddleLatLng(e._prev,e)),e._middleRight&&e._middleRight.setLatLng(this._getMiddleLatLng(e,e._next)),i.options.poly){var o=i._map._editTooltip;if(!i.options.poly.allowIntersection&&i.intersects()){var n=i.options.color;i.setStyle({color:this.options.drawError.color}),0!==L.version.indexOf("0.7")&&e.dragging._draggable._onUp(t),this._onMarkerClick(t),o&&o.updateContent({text:L.drawLocal.draw.handlers.polyline.error}),setTimeout(function(){i.setStyle({color:n}),o&&o.updateContent({text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext})},1e3)}}this._poly.redraw(),this._poly.fire("editdrag")},_onMarkerClick:function(t){var e=L.Polygon&&this._poly instanceof L.Polygon?4:3,i=t.target;this._defaultShape().length<e||(this._removeMarker(i),this._updatePrevNext(i._prev,i._next),i._middleLeft&&this._markerGroup.removeLayer(i._middleLeft),i._middleRight&&this._markerGroup.removeLayer(i._middleRight),i._prev&&i._next?this._createMiddleMarker(i._prev,i._next):i._prev?i._next||(i._prev._middleRight=null):i._next._middleLeft=null,this._fireEdit())},_onTouchMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]),i=this._map.layerPointToLatLng(e),o=t.target;L.extend(o._origLatLng,i),o._middleLeft&&o._middleLeft.setLatLng(this._getMiddleLatLng(o._prev,o)),o._middleRight&&o._middleRight.setLatLng(this._getMiddleLatLng(o,o._next)),this._poly.redraw(),this.updateMarkers()},_updateIndexes:function(t,e){this._markerGroup.eachLayer(function(i){i._index>t&&(i._index+=e)})},_createMiddleMarker:function(t,e){var i,o,n,s=this._getMiddleLatLng(t,e),a=this._createMarker(s);a.setOpacity(.6),t._middleRight=e._middleLeft=a,o=function(){a.off("touchmove",o,this);var n=e._index;a._index=n,a.off("click",i,this).on("click",this._onMarkerClick,this),s.lat=a.getLatLng().lat,s.lng=a.getLatLng().lng,this._spliceLatLngs(n,0,s),this._markers.splice(n,0,a),a.setOpacity(1),this._updateIndexes(n,1),e._index++,this._updatePrevNext(t,a),this._updatePrevNext(a,e),this._poly.fire("editstart")},n=function(){a.off("dragstart",o,this),a.off("dragend",n,this),a.off("touchmove",o,this),this._createMiddleMarker(t,a),this._createMiddleMarker(a,e)},i=function(){o.call(this),n.call(this),this._fireEdit()},a.on("click",i,this).on("dragstart",o,this).on("dragend",n,this).on("touchmove",o,this),this._markerGroup.addLayer(a)},_updatePrevNext:function(t,e){t&&(t._next=e),e&&(e._prev=t)},_getMiddleLatLng:function(t,e){var i=this._poly._map,o=i.project(t.getLatLng()),n=i.project(e.getLatLng());return i.unproject(o._add(n)._divideBy(2))}}),L.Polyline.addInitHook(function(){this.editing||(L.Edit.Poly&&(this.editing=new L.Edit.Poly(this,this.options.poly),this.options.editable&&this.editing.enable()),this.on("add",function(){this.editing&&this.editing.enabled()&&this.editing.addHooks()}),this.on("remove",function(){this.editing&&this.editing.enabled()&&this.editing.removeHooks()}))}),L.Edit=L.Edit||{},L.Edit.SimpleShape=L.Handler.extend({options:{moveIcon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-move"}),resizeIcon:new L.DivIcon({iconSize:new L.Point(8,8),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-resize"}),touchMoveIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-move leaflet-touch-icon"}),touchResizeIcon:new L.DivIcon({iconSize:new L.Point(20,20),className:"leaflet-div-icon leaflet-editing-icon leaflet-edit-resize leaflet-touch-icon"})},initialize:function(t,e){L.Browser.touch&&(this.options.moveIcon=this.options.touchMoveIcon,this.options.resizeIcon=this.options.touchResizeIcon),this._shape=t,L.Util.setOptions(this,e)},addHooks:function(){var t=this._shape;this._shape._map&&(this._map=this._shape._map,t.setStyle(t.options.editing),t._map&&(this._map=t._map,this._markerGroup||this._initMarkers(),this._map.addLayer(this._markerGroup)))},removeHooks:function(){var t=this._shape;if(t.setStyle(t.options.original),t._map){this._unbindMarker(this._moveMarker);for(var e=0,i=this._resizeMarkers.length;e<i;e++)this._unbindMarker(this._resizeMarkers[e]);this._resizeMarkers=null,this._map.removeLayer(this._markerGroup),delete this._markerGroup}this._map=null},updateMarkers:function(){this._markerGroup.clearLayers(),this._initMarkers()},_initMarkers:function(){this._markerGroup||(this._markerGroup=new L.LayerGroup),this._createMoveMarker(),this._createResizeMarker()},_createMoveMarker:function(){},_createResizeMarker:function(){},_createMarker:function(t,e){var i=new L.Marker.Touch(t,{draggable:!0,icon:e,zIndexOffset:10});return this._bindMarker(i),this._markerGroup.addLayer(i),i},_bindMarker:function(t){t.on("dragstart",this._onMarkerDragStart,this).on("drag",this._onMarkerDrag,this).on("dragend",this._onMarkerDragEnd,this).on("touchstart",this._onTouchStart,this).on("touchmove",this._onTouchMove,this).on("MSPointerMove",this._onTouchMove,this).on("touchend",this._onTouchEnd,this).on("MSPointerUp",this._onTouchEnd,this)},_unbindMarker:function(t){t.off("dragstart",this._onMarkerDragStart,this).off("drag",this._onMarkerDrag,this).off("dragend",this._onMarkerDragEnd,this).off("touchstart",this._onTouchStart,this).off("touchmove",this._onTouchMove,this).off("MSPointerMove",this._onTouchMove,this).off("touchend",this._onTouchEnd,this).off("MSPointerUp",this._onTouchEnd,this)},_onMarkerDragStart:function(t){var e=t.target;e.setOpacity(0),this._shape.fire("editstart")},_fireEdit:function(){this._shape.edited=!0,this._shape.fire("edit")},_onMarkerDrag:function(t){var e=t.target,i=e.getLatLng();e===this._moveMarker?this._move(i):this._resize(i),this._shape.redraw(),this._shape.fire("editdrag")},_onMarkerDragEnd:function(t){var e=t.target;e.setOpacity(1),this._fireEdit()},_onTouchStart:function(t){if(L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this,t),"function"==typeof this._getCorners){var e=this._getCorners(),i=t.target,o=i._cornerIndex;i.setOpacity(0),this._oppositeCorner=e[(o+2)%4],this._toggleCornerMarkers(0,o)}this._shape.fire("editstart")},_onTouchMove:function(t){var e=this._map.mouseEventToLayerPoint(t.originalEvent.touches[0]),i=this._map.layerPointToLatLng(e),o=t.target;return o===this._moveMarker?this._move(i):this._resize(i),this._shape.redraw(),!1},_onTouchEnd:function(t){var e=t.target;e.setOpacity(1),this.updateMarkers(),this._fireEdit()},_move:function(){},_resize:function(){}}),L.Edit=L.Edit||{},L.Edit.Rectangle=L.Edit.SimpleShape.extend({_createMoveMarker:function(){var t=this._shape.getBounds(),e=t.getCenter();this._moveMarker=this._createMarker(e,this.options.moveIcon);
	},_createResizeMarker:function(){var t=this._getCorners();this._resizeMarkers=[];for(var e=0,i=t.length;e<i;e++)this._resizeMarkers.push(this._createMarker(t[e],this.options.resizeIcon)),this._resizeMarkers[e]._cornerIndex=e},_onMarkerDragStart:function(t){L.Edit.SimpleShape.prototype._onMarkerDragStart.call(this,t);var e=this._getCorners(),i=t.target,o=i._cornerIndex;this._oppositeCorner=e[(o+2)%4],this._toggleCornerMarkers(0,o)},_onMarkerDragEnd:function(t){var e,i,o=t.target;o===this._moveMarker&&(e=this._shape.getBounds(),i=e.getCenter(),o.setLatLng(i)),this._toggleCornerMarkers(1),this._repositionCornerMarkers(),L.Edit.SimpleShape.prototype._onMarkerDragEnd.call(this,t)},_move:function(t){for(var e,i=this._shape._defaultShape?this._shape._defaultShape():this._shape.getLatLngs(),o=this._shape.getBounds(),n=o.getCenter(),s=[],a=0,r=i.length;a<r;a++)e=[i[a].lat-n.lat,i[a].lng-n.lng],s.push([t.lat+e[0],t.lng+e[1]]);this._shape.setLatLngs(s),this._repositionCornerMarkers(),this._map.fire(L.Draw.Event.EDITMOVE,{layer:this._shape})},_resize:function(t){var e;this._shape.setBounds(L.latLngBounds(t,this._oppositeCorner)),e=this._shape.getBounds(),this._moveMarker.setLatLng(e.getCenter()),this._map.fire(L.Draw.Event.EDITRESIZE,{layer:this._shape})},_getCorners:function(){var t=this._shape.getBounds(),e=t.getNorthWest(),i=t.getNorthEast(),o=t.getSouthEast(),n=t.getSouthWest();return[e,i,o,n]},_toggleCornerMarkers:function(t){for(var e=0,i=this._resizeMarkers.length;e<i;e++)this._resizeMarkers[e].setOpacity(t)},_repositionCornerMarkers:function(){for(var t=this._getCorners(),e=0,i=this._resizeMarkers.length;e<i;e++)this._resizeMarkers[e].setLatLng(t[e])}}),L.Rectangle.addInitHook(function(){L.Edit.Rectangle&&(this.editing=new L.Edit.Rectangle(this),this.options.editable&&this.editing.enable())}),L.Edit=L.Edit||{},L.Edit.Circle=L.Edit.SimpleShape.extend({_createMoveMarker:function(){var t=this._shape.getLatLng();this._moveMarker=this._createMarker(t,this.options.moveIcon)},_createResizeMarker:function(){var t=this._shape.getLatLng(),e=this._getResizeMarkerPoint(t);this._resizeMarkers=[],this._resizeMarkers.push(this._createMarker(e,this.options.resizeIcon))},_getResizeMarkerPoint:function(t){var e=this._shape._radius*Math.cos(Math.PI/4),i=this._map.project(t);return this._map.unproject([i.x+e,i.y-e])},_move:function(t){var e=this._getResizeMarkerPoint(t);this._resizeMarkers[0].setLatLng(e),this._shape.setLatLng(t),this._map.fire(L.Draw.Event.EDITMOVE,{layer:this._shape})},_resize:function(t){var e=this._moveMarker.getLatLng(),i=e.distanceTo(t);this._shape.setRadius(i),this._map.fire(L.Draw.Event.EDITRESIZE,{layer:this._shape})}}),L.Circle.addInitHook(function(){L.Edit.Circle&&(this.editing=new L.Edit.Circle(this),this.options.editable&&this.editing.enable()),this.on("add",function(){this.editing&&this.editing.enabled()&&this.editing.addHooks()}),this.on("remove",function(){this.editing&&this.editing.enabled()&&this.editing.removeHooks()})}),L.Map.mergeOptions({touchExtend:!0}),L.Map.TouchExtend=L.Handler.extend({initialize:function(t){this._map=t,this._container=t._container,this._pane=t._panes.overlayPane},addHooks:function(){L.DomEvent.on(this._container,"touchstart",this._onTouchStart,this),L.DomEvent.on(this._container,"touchend",this._onTouchEnd,this),L.DomEvent.on(this._container,"touchmove",this._onTouchMove,this),this._detectIE()?(L.DomEvent.on(this._container,"MSPointerDown",this._onTouchStart,this),L.DomEvent.on(this._container,"MSPointerUp",this._onTouchEnd,this),L.DomEvent.on(this._container,"MSPointerMove",this._onTouchMove,this),L.DomEvent.on(this._container,"MSPointerCancel",this._onTouchCancel,this)):(L.DomEvent.on(this._container,"touchcancel",this._onTouchCancel,this),L.DomEvent.on(this._container,"touchleave",this._onTouchLeave,this))},removeHooks:function(){L.DomEvent.off(this._container,"touchstart",this._onTouchStart),L.DomEvent.off(this._container,"touchend",this._onTouchEnd),L.DomEvent.off(this._container,"touchmove",this._onTouchMove),this._detectIE()?(L.DomEvent.off(this._container,"MSPointerDowm",this._onTouchStart),L.DomEvent.off(this._container,"MSPointerUp",this._onTouchEnd),L.DomEvent.off(this._container,"MSPointerMove",this._onTouchMove),L.DomEvent.off(this._container,"MSPointerCancel",this._onTouchCancel)):(L.DomEvent.off(this._container,"touchcancel",this._onTouchCancel),L.DomEvent.off(this._container,"touchleave",this._onTouchLeave))},_touchEvent:function(t,e){var i={};if("undefined"!=typeof t.touches){if(!t.touches.length)return;i=t.touches[0]}else{if("touch"!==t.pointerType)return;if(i=t,!this._filterClick(t))return}var o=this._map.mouseEventToContainerPoint(i),n=this._map.mouseEventToLayerPoint(i),s=this._map.layerPointToLatLng(n);this._map.fire(e,{latlng:s,layerPoint:n,containerPoint:o,pageX:i.pageX,pageY:i.pageY,originalEvent:t})},_filterClick:function(t){var e=t.timeStamp||t.originalEvent.timeStamp,i=L.DomEvent._lastClick&&e-L.DomEvent._lastClick;return i&&i>100&&i<500||t.target._simulatedClick&&!t._simulated?(L.DomEvent.stop(t),!1):(L.DomEvent._lastClick=e,!0)},_onTouchStart:function(t){if(this._map._loaded){var e="touchstart";this._touchEvent(t,e)}},_onTouchEnd:function(t){if(this._map._loaded){var e="touchend";this._touchEvent(t,e)}},_onTouchCancel:function(t){if(this._map._loaded){var e="touchcancel";this._detectIE()&&(e="pointercancel"),this._touchEvent(t,e)}},_onTouchLeave:function(t){if(this._map._loaded){var e="touchleave";this._touchEvent(t,e)}},_onTouchMove:function(t){if(this._map._loaded){var e="touchmove";this._touchEvent(t,e)}},_detectIE:function(){var e=t.navigator.userAgent,i=e.indexOf("MSIE ");if(i>0)return parseInt(e.substring(i+5,e.indexOf(".",i)),10);var o=e.indexOf("Trident/");if(o>0){var n=e.indexOf("rv:");return parseInt(e.substring(n+3,e.indexOf(".",n)),10)}var s=e.indexOf("Edge/");return s>0&&parseInt(e.substring(s+5,e.indexOf(".",s)),10)}}),L.Map.addInitHook("addHandler","touchExtend",L.Map.TouchExtend),L.Marker.Touch=L.Marker.extend({_initInteraction:function(){return this.addInteractiveTarget?L.Marker.prototype._initInteraction.apply(this):this._initInteractionLegacy()},_initInteractionLegacy:function(){if(this.options.clickable){var t=this._icon,e=["dblclick","mousedown","mouseover","mouseout","contextmenu","touchstart","touchend","touchmove"];this._detectIE?e.concat(["MSPointerDown","MSPointerUp","MSPointerMove","MSPointerCancel"]):e.concat(["touchcancel"]),L.DomUtil.addClass(t,"leaflet-clickable"),L.DomEvent.on(t,"click",this._onMouseClick,this),L.DomEvent.on(t,"keypress",this._onKeyPress,this);for(var i=0;i<e.length;i++)L.DomEvent.on(t,e[i],this._fireMouseEvent,this);L.Handler.MarkerDrag&&(this.dragging=new L.Handler.MarkerDrag(this),this.options.draggable&&this.dragging.enable())}},_detectIE:function(){var e=t.navigator.userAgent,i=e.indexOf("MSIE ");if(i>0)return parseInt(e.substring(i+5,e.indexOf(".",i)),10);var o=e.indexOf("Trident/");if(o>0){var n=e.indexOf("rv:");return parseInt(e.substring(n+3,e.indexOf(".",n)),10)}var s=e.indexOf("Edge/");return s>0&&parseInt(e.substring(s+5,e.indexOf(".",s)),10)}}),L.LatLngUtil={cloneLatLngs:function(t){for(var e=[],i=0,o=t.length;i<o;i++)Array.isArray(t[i])?e.push(L.LatLngUtil.cloneLatLngs(t[i])):e.push(this.cloneLatLng(t[i]));return e},cloneLatLng:function(t){return L.latLng(t.lat,t.lng)}},L.GeometryUtil=L.extend(L.GeometryUtil||{},{geodesicArea:function(t){var e,i,o=t.length,n=0,s=Math.PI/180;if(o>2){for(var a=0;a<o;a++)e=t[a],i=t[(a+1)%o],n+=(i.lng-e.lng)*s*(2+Math.sin(e.lat*s)+Math.sin(i.lat*s));n=6378137*n*6378137/2}return Math.abs(n)},readableArea:function(t,e){var i;return e?i=t>=1e4?(1e-4*t).toFixed(2)+" ha":t.toFixed(2)+" m&sup2;":(t/=.836127,i=t>=3097600?(t/3097600).toFixed(2)+" mi&sup2;":t>=4840?(t/4840).toFixed(2)+" acres":Math.ceil(t)+" yd&sup2;"),i},readableDistance:function(t,e,i,o){var n,s;switch(s="string"==typeof e?e:i?"feet":o?"nauticalMile":e?"metric":"yards"){case"metric":n=t>1e3?(t/1e3).toFixed(2)+" km":Math.ceil(t)+" m";break;case"feet":t*=3.28083,n=Math.ceil(t)+" ft";break;case"nauticalMile":t*=.53996,n=(t/1e3).toFixed(2)+" nm";break;case"yards":default:t*=1.09361,n=t>1760?(t/1760).toFixed(2)+" miles":Math.ceil(t)+" yd"}return n}}),L.Util.extend(L.LineUtil,{segmentsIntersect:function(t,e,i,o){return this._checkCounterclockwise(t,i,o)!==this._checkCounterclockwise(e,i,o)&&this._checkCounterclockwise(t,e,i)!==this._checkCounterclockwise(t,e,o)},_checkCounterclockwise:function(t,e,i){return(i.y-t.y)*(e.x-t.x)>(e.y-t.y)*(i.x-t.x)}}),L.Polyline.include({intersects:function(){var t,e,i,o=this._getProjectedPoints(),n=o?o.length:0;if(this._tooFewPointsForIntersection())return!1;for(t=n-1;t>=3;t--)if(e=o[t-1],i=o[t],this._lineSegmentsIntersectsRange(e,i,t-2))return!0;return!1},newLatLngIntersects:function(t,e){return!!this._map&&this.newPointIntersects(this._map.latLngToLayerPoint(t),e)},newPointIntersects:function(t,e){var i=this._getProjectedPoints(),o=i?i.length:0,n=i?i[o-1]:null,s=o-2;return!this._tooFewPointsForIntersection(1)&&this._lineSegmentsIntersectsRange(n,t,s,e?1:0)},_tooFewPointsForIntersection:function(t){var e=this._getProjectedPoints(),i=e?e.length:0;return i+=t||0,!e||i<=3},_lineSegmentsIntersectsRange:function(t,e,i,o){var n,s,a=this._getProjectedPoints();o=o||0;for(var r=i;r>o;r--)if(n=a[r-1],s=a[r],L.LineUtil.segmentsIntersect(t,e,n,s))return!0;return!1},_getProjectedPoints:function(){if(!this._defaultShape)return this._originalPoints;for(var t=[],e=this._defaultShape(),i=0;i<e.length;i++)t.push(this._map.latLngToLayerPoint(e[i]));return t}}),L.Polygon.include({intersects:function(){var t,e,i,o,n,s=this._getProjectedPoints();return!this._tooFewPointsForIntersection()&&(!!(t=L.Polyline.prototype.intersects.call(this))||(e=s.length,i=s[0],o=s[e-1],n=e-2,this._lineSegmentsIntersectsRange(o,i,n,1)))}}),L.Control.Draw=L.Control.extend({options:{position:"topleft",draw:{},edit:!1},initialize:function(t){if(L.version<"0.7")throw new Error("Leaflet.draw 0.2.3+ requires Leaflet 0.7.0+. Download latest from https://github.com/Leaflet/Leaflet/");L.Control.prototype.initialize.call(this,t);var e;this._toolbars={},L.DrawToolbar&&this.options.draw&&(e=new L.DrawToolbar(this.options.draw),this._toolbars[L.DrawToolbar.TYPE]=e,this._toolbars[L.DrawToolbar.TYPE].on("enable",this._toolbarEnabled,this)),L.EditToolbar&&this.options.edit&&(e=new L.EditToolbar(this.options.edit),this._toolbars[L.EditToolbar.TYPE]=e,this._toolbars[L.EditToolbar.TYPE].on("enable",this._toolbarEnabled,this)),L.toolbar=this},onAdd:function(t){var e,i=L.DomUtil.create("div","leaflet-draw"),o=!1,n="leaflet-draw-toolbar-top";for(var s in this._toolbars)this._toolbars.hasOwnProperty(s)&&(e=this._toolbars[s].addToolbar(t),e&&(o||(L.DomUtil.hasClass(e,n)||L.DomUtil.addClass(e.childNodes[0],n),o=!0),i.appendChild(e)));return i},onRemove:function(){for(var t in this._toolbars)this._toolbars.hasOwnProperty(t)&&this._toolbars[t].removeToolbar()},setDrawingOptions:function(t){for(var e in this._toolbars)this._toolbars[e]instanceof L.DrawToolbar&&this._toolbars[e].setOptions(t)},_toolbarEnabled:function(t){var e=t.target;for(var i in this._toolbars)this._toolbars[i]!==e&&this._toolbars[i].disable()}}),L.Map.mergeOptions({drawControlTooltips:!0,drawControl:!1}),L.Map.addInitHook(function(){this.options.drawControl&&(this.drawControl=new L.Control.Draw,this.addControl(this.drawControl))}),L.Toolbar=L.Class.extend({includes:[L.Mixin.Events],initialize:function(t){L.setOptions(this,t),this._modes={},this._actionButtons=[],this._activeMode=null},enabled:function(){return null!==this._activeMode},disable:function(){this.enabled()&&this._activeMode.handler.disable()},addToolbar:function(t){var e,i=L.DomUtil.create("div","leaflet-draw-section"),o=0,n=this._toolbarClass||"",s=this.getModeHandlers(t);for(this._toolbarContainer=L.DomUtil.create("div","leaflet-draw-toolbar leaflet-bar"),this._map=t,e=0;e<s.length;e++)s[e].enabled&&this._initModeHandler(s[e].handler,this._toolbarContainer,o++,n,s[e].title);if(o)return this._lastButtonIndex=--o,this._actionsContainer=L.DomUtil.create("ul","leaflet-draw-actions"),i.appendChild(this._toolbarContainer),i.appendChild(this._actionsContainer),i},removeToolbar:function(){for(var t in this._modes)this._modes.hasOwnProperty(t)&&(this._disposeButton(this._modes[t].button,this._modes[t].handler.enable,this._modes[t].handler),this._modes[t].handler.disable(),this._modes[t].handler.off("enabled",this._handlerActivated,this).off("disabled",this._handlerDeactivated,this));this._modes={};for(var e=0,i=this._actionButtons.length;e<i;e++)this._disposeButton(this._actionButtons[e].button,this._actionButtons[e].callback,this);this._actionButtons=[],this._actionsContainer=null},_initModeHandler:function(t,e,i,o,n){var s=t.type;this._modes[s]={},this._modes[s].handler=t,this._modes[s].button=this._createButton({type:s,title:n,className:o+"-"+s,container:e,callback:this._modes[s].handler.enable,context:this._modes[s].handler}),this._modes[s].buttonIndex=i,this._modes[s].handler.on("enabled",this._handlerActivated,this).on("disabled",this._handlerDeactivated,this)},_createButton:function(t){var e=L.DomUtil.create("a",t.className||"",t.container),i=L.DomUtil.create("span","sr-only",t.container);return e.href="#",e.appendChild(i),t.title&&(e.title=t.title,i.innerHTML=t.title),t.text&&(e.innerHTML=t.text,i.innerHTML=t.text),L.DomEvent.on(e,"click",L.DomEvent.stopPropagation).on(e,"mousedown",L.DomEvent.stopPropagation).on(e,"dblclick",L.DomEvent.stopPropagation).on(e,"touchstart",L.DomEvent.stopPropagation).on(e,"click",L.DomEvent.preventDefault).on(e,"click",t.callback,t.context),e},_disposeButton:function(t,e){L.DomEvent.off(t,"click",L.DomEvent.stopPropagation).off(t,"mousedown",L.DomEvent.stopPropagation).off(t,"dblclick",L.DomEvent.stopPropagation).off(t,"touchstart",L.DomEvent.stopPropagation).off(t,"click",L.DomEvent.preventDefault).off(t,"click",e)},_handlerActivated:function(t){this.disable(),this._activeMode=this._modes[t.handler],L.DomUtil.addClass(this._activeMode.button,"leaflet-draw-toolbar-button-enabled"),this._showActionsToolbar(),this.fire("enable")},_handlerDeactivated:function(){this._hideActionsToolbar(),L.DomUtil.removeClass(this._activeMode.button,"leaflet-draw-toolbar-button-enabled"),this._activeMode=null,this.fire("disable")},_createActions:function(t){var e,i,o,n,s=this._actionsContainer,a=this.getActions(t),r=a.length;for(i=0,o=this._actionButtons.length;i<o;i++)this._disposeButton(this._actionButtons[i].button,this._actionButtons[i].callback);for(this._actionButtons=[];s.firstChild;)s.removeChild(s.firstChild);for(var h=0;h<r;h++)"enabled"in a[h]&&!a[h].enabled||(e=L.DomUtil.create("li","",s),n=this._createButton({title:a[h].title,text:a[h].text,container:e,callback:a[h].callback,context:a[h].context}),this._actionButtons.push({button:n,callback:a[h].callback}))},_showActionsToolbar:function(){var t=this._activeMode.buttonIndex,e=this._lastButtonIndex,i=this._activeMode.button.offsetTop-1;this._createActions(this._activeMode.handler),this._actionsContainer.style.top=i+"px",0===t&&(L.DomUtil.addClass(this._toolbarContainer,"leaflet-draw-toolbar-notop"),L.DomUtil.addClass(this._actionsContainer,"leaflet-draw-actions-top")),t===e&&(L.DomUtil.addClass(this._toolbarContainer,"leaflet-draw-toolbar-nobottom"),L.DomUtil.addClass(this._actionsContainer,"leaflet-draw-actions-bottom")),this._actionsContainer.style.display="block"},_hideActionsToolbar:function(){this._actionsContainer.style.display="none",L.DomUtil.removeClass(this._toolbarContainer,"leaflet-draw-toolbar-notop"),L.DomUtil.removeClass(this._toolbarContainer,"leaflet-draw-toolbar-nobottom"),L.DomUtil.removeClass(this._actionsContainer,"leaflet-draw-actions-top"),L.DomUtil.removeClass(this._actionsContainer,"leaflet-draw-actions-bottom")}}),L.Draw=L.Draw||{},L.Draw.Tooltip=L.Class.extend({initialize:function(t){this._map=t,this._popupPane=t._panes.popupPane,this._container=t.options.drawControlTooltips?L.DomUtil.create("div","leaflet-draw-tooltip",this._popupPane):null,this._singleLineLabel=!1,this._map.on("mouseout",this._onMouseOut,this)},dispose:function(){this._map.off("mouseout",this._onMouseOut,this),this._container&&(this._popupPane.removeChild(this._container),this._container=null)},updateContent:function(t){return this._container?(t.subtext=t.subtext||"",0!==t.subtext.length||this._singleLineLabel?t.subtext.length>0&&this._singleLineLabel&&(L.DomUtil.removeClass(this._container,"leaflet-draw-tooltip-single"),this._singleLineLabel=!1):(L.DomUtil.addClass(this._container,"leaflet-draw-tooltip-single"),this._singleLineLabel=!0),this._container.innerHTML=(t.subtext.length>0?'<span class="leaflet-draw-tooltip-subtext">'+t.subtext+"</span><br />":"")+"<span>"+t.text+"</span>",this):this},updatePosition:function(t){var e=this._map.latLngToLayerPoint(t),i=this._container;return this._container&&(i.style.visibility="inherit",L.DomUtil.setPosition(i,e)),this},showAsError:function(){return this._container&&L.DomUtil.addClass(this._container,"leaflet-error-draw-tooltip"),this},removeError:function(){return this._container&&L.DomUtil.removeClass(this._container,"leaflet-error-draw-tooltip"),this},_onMouseOut:function(){this._container&&(this._container.style.visibility="hidden")}}),L.DrawToolbar=L.Toolbar.extend({statics:{TYPE:"draw"},options:{polyline:{},polygon:{},rectangle:{},circle:{},marker:{}},initialize:function(t){for(var e in this.options)this.options.hasOwnProperty(e)&&t[e]&&(t[e]=L.extend({},this.options[e],t[e]));this._toolbarClass="leaflet-draw-draw",L.Toolbar.prototype.initialize.call(this,t)},getModeHandlers:function(t){return[{enabled:this.options.polyline,handler:new L.Draw.Polyline(t,this.options.polyline),title:L.drawLocal.draw.toolbar.buttons.polyline},{enabled:this.options.polygon,handler:new L.Draw.Polygon(t,this.options.polygon),title:L.drawLocal.draw.toolbar.buttons.polygon},{enabled:this.options.rectangle,handler:new L.Draw.Rectangle(t,this.options.rectangle),title:L.drawLocal.draw.toolbar.buttons.rectangle},{enabled:this.options.circle,handler:new L.Draw.Circle(t,this.options.circle),title:L.drawLocal.draw.toolbar.buttons.circle},{enabled:this.options.marker,handler:new L.Draw.Marker(t,this.options.marker),title:L.drawLocal.draw.toolbar.buttons.marker}]},getActions:function(t){return[{enabled:t.completeShape,title:L.drawLocal.draw.toolbar.finish.title,text:L.drawLocal.draw.toolbar.finish.text,callback:t.completeShape,context:t},{enabled:t.deleteLastVertex,title:L.drawLocal.draw.toolbar.undo.title,text:L.drawLocal.draw.toolbar.undo.text,callback:t.deleteLastVertex,context:t},{title:L.drawLocal.draw.toolbar.actions.title,text:L.drawLocal.draw.toolbar.actions.text,callback:this.disable,context:this}]},setOptions:function(t){L.setOptions(this,t);for(var e in this._modes)this._modes.hasOwnProperty(e)&&t.hasOwnProperty(e)&&this._modes[e].handler.setOptions(t[e])}}),L.EditToolbar=L.Toolbar.extend({statics:{TYPE:"edit"},options:{edit:{selectedPathOptions:{dashArray:"10, 10",fill:!0,fillColor:"#fe57a1",fillOpacity:.1,maintainColor:!1}},remove:{},poly:null,featureGroup:null},initialize:function(t){t.edit&&("undefined"==typeof t.edit.selectedPathOptions&&(t.edit.selectedPathOptions=this.options.edit.selectedPathOptions),t.edit.selectedPathOptions=L.extend({},this.options.edit.selectedPathOptions,t.edit.selectedPathOptions)),t.remove&&(t.remove=L.extend({},this.options.remove,t.remove)),t.poly&&(t.poly=L.extend({},this.options.poly,t.poly)),this._toolbarClass="leaflet-draw-edit",L.Toolbar.prototype.initialize.call(this,t),this._selectedFeatureCount=0},getModeHandlers:function(t){var e=this.options.featureGroup;return[{enabled:this.options.edit,handler:new L.EditToolbar.Edit(t,{featureGroup:e,selectedPathOptions:this.options.edit.selectedPathOptions,poly:this.options.poly}),title:L.drawLocal.edit.toolbar.buttons.edit},{enabled:this.options.remove,handler:new L.EditToolbar.Delete(t,{featureGroup:e}),title:L.drawLocal.edit.toolbar.buttons.remove}]},getActions:function(){return[{title:L.drawLocal.edit.toolbar.actions.save.title,text:L.drawLocal.edit.toolbar.actions.save.text,callback:this._save,context:this},{title:L.drawLocal.edit.toolbar.actions.cancel.title,text:L.drawLocal.edit.toolbar.actions.cancel.text,callback:this.disable,context:this}]},addToolbar:function(t){var e=L.Toolbar.prototype.addToolbar.call(this,t);return this._checkDisabled(),this.options.featureGroup.on("layeradd layerremove",this._checkDisabled,this),e},removeToolbar:function(){this.options.featureGroup.off("layeradd layerremove",this._checkDisabled,this),L.Toolbar.prototype.removeToolbar.call(this)},disable:function(){this.enabled()&&(this._activeMode.handler.revertLayers(),L.Toolbar.prototype.disable.call(this))},_save:function(){this._activeMode.handler.save(),this._activeMode&&this._activeMode.handler.disable()},_checkDisabled:function(){var t,e=this.options.featureGroup,i=0!==e.getLayers().length;this.options.edit&&(t=this._modes[L.EditToolbar.Edit.TYPE].button,i?L.DomUtil.removeClass(t,"leaflet-disabled"):L.DomUtil.addClass(t,"leaflet-disabled"),t.setAttribute("title",i?L.drawLocal.edit.toolbar.buttons.edit:L.drawLocal.edit.toolbar.buttons.editDisabled)),this.options.remove&&(t=this._modes[L.EditToolbar.Delete.TYPE].button,i?L.DomUtil.removeClass(t,"leaflet-disabled"):L.DomUtil.addClass(t,"leaflet-disabled"),t.setAttribute("title",i?L.drawLocal.edit.toolbar.buttons.remove:L.drawLocal.edit.toolbar.buttons.removeDisabled))}}),L.EditToolbar.Edit=L.Handler.extend({statics:{TYPE:"edit"},includes:L.Mixin.Events,initialize:function(t,e){if(L.Handler.prototype.initialize.call(this,t),L.setOptions(this,e),this._featureGroup=e.featureGroup,!(this._featureGroup instanceof L.FeatureGroup))throw new Error("options.featureGroup must be a L.FeatureGroup");this._uneditedLayerProps={},this.type=L.EditToolbar.Edit.TYPE},enable:function(){!this._enabled&&this._hasAvailableLayers()&&(this.fire("enabled",{handler:this.type}),this._map.fire(L.Draw.Event.EDITSTART,{handler:this.type}),L.Handler.prototype.enable.call(this),this._featureGroup.on("layeradd",this._enableLayerEdit,this).on("layerremove",this._disableLayerEdit,this))},disable:function(){this._enabled&&(this._featureGroup.off("layeradd",this._enableLayerEdit,this).off("layerremove",this._disableLayerEdit,this),L.Handler.prototype.disable.call(this),this._map.fire(L.Draw.Event.EDITSTOP,{handler:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(t.getContainer().focus(),this._featureGroup.eachLayer(this._enableLayerEdit,this),this._tooltip=new L.Draw.Tooltip(this._map),this._tooltip.updateContent({text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext}),t._editTooltip=this._tooltip,this._updateTooltip(),this._map.on("mousemove",this._onMouseMove,this).on("touchmove",this._onMouseMove,this).on("MSPointerMove",this._onMouseMove,this).on(L.Draw.Event.EDITVERTEX,this._updateTooltip,this))},removeHooks:function(){this._map&&(this._featureGroup.eachLayer(this._disableLayerEdit,this),this._uneditedLayerProps={},this._tooltip.dispose(),this._tooltip=null,this._map.off("mousemove",this._onMouseMove,this).off("touchmove",this._onMouseMove,this).off("MSPointerMove",this._onMouseMove,this).off(L.Draw.Event.EDITVERTEX,this._updateTooltip,this))},revertLayers:function(){this._featureGroup.eachLayer(function(t){this._revertLayer(t)},this)},save:function(){var t=new L.LayerGroup;this._featureGroup.eachLayer(function(e){e.edited&&(t.addLayer(e),e.edited=!1)}),this._map.fire(L.Draw.Event.EDITED,{layers:t})},_backupLayer:function(t){var e=L.Util.stamp(t);this._uneditedLayerProps[e]||(t instanceof L.Polyline||t instanceof L.Polygon||t instanceof L.Rectangle?this._uneditedLayerProps[e]={latlngs:L.LatLngUtil.cloneLatLngs(t.getLatLngs())}:t instanceof L.Circle?this._uneditedLayerProps[e]={latlng:L.LatLngUtil.cloneLatLng(t.getLatLng()),radius:t.getRadius()}:t instanceof L.Marker&&(this._uneditedLayerProps[e]={latlng:L.LatLngUtil.cloneLatLng(t.getLatLng())}))},_getTooltipText:function(){return{text:L.drawLocal.edit.handlers.edit.tooltip.text,subtext:L.drawLocal.edit.handlers.edit.tooltip.subtext}},_updateTooltip:function(){this._tooltip.updateContent(this._getTooltipText())},_revertLayer:function(t){var e=L.Util.stamp(t);t.edited=!1,this._uneditedLayerProps.hasOwnProperty(e)&&(t instanceof L.Polyline||t instanceof L.Polygon||t instanceof L.Rectangle?t.setLatLngs(this._uneditedLayerProps[e].latlngs):t instanceof L.Circle?(t.setLatLng(this._uneditedLayerProps[e].latlng),t.setRadius(this._uneditedLayerProps[e].radius)):t instanceof L.Marker&&t.setLatLng(this._uneditedLayerProps[e].latlng),t.fire("revert-edited",{layer:t}))},_enableLayerEdit:function(t){var e,i,o=t.layer||t.target||t;this._backupLayer(o),this.options.poly&&(i=L.Util.extend({},this.options.poly),o.options.poly=i),this.options.selectedPathOptions&&(e=L.Util.extend({},this.options.selectedPathOptions),e.maintainColor&&(e.color=o.options.color,e.fillColor=o.options.fillColor),o.options.original=L.extend({},o.options),o.options.editing=e),o instanceof L.Marker?(o.editing&&o.editing.enable(),o.dragging.enable(),o.on("dragend",this._onMarkerDragEnd).on("touchmove",this._onTouchMove,this).on("MSPointerMove",this._onTouchMove,this).on("touchend",this._onMarkerDragEnd,this).on("MSPointerUp",this._onMarkerDragEnd,this)):o.editing.enable()},_disableLayerEdit:function(t){var e=t.layer||t.target||t;e.edited=!1,e.editing&&e.editing.disable(),delete e.options.editing,delete e.options.original,this._selectedPathOptions&&(e instanceof L.Marker?this._toggleMarkerHighlight(e):(e.setStyle(e.options.previousOptions),delete e.options.previousOptions)),e instanceof L.Marker?(e.dragging.disable(),e.off("dragend",this._onMarkerDragEnd,this).off("touchmove",this._onTouchMove,this).off("MSPointerMove",this._onTouchMove,this).off("touchend",this._onMarkerDragEnd,this).off("MSPointerUp",this._onMarkerDragEnd,this)):e.editing.disable()},_onMouseMove:function(t){this._tooltip.updatePosition(t.latlng)},_onMarkerDragEnd:function(t){var e=t.target;e.edited=!0,this._map.fire(L.Draw.Event.EDITMOVE,{layer:e})},_onTouchMove:function(t){var e=t.originalEvent.changedTouches[0],i=this._map.mouseEventToLayerPoint(e),o=this._map.layerPointToLatLng(i);t.target.setLatLng(o)},_hasAvailableLayers:function(){return 0!==this._featureGroup.getLayers().length}}),L.EditToolbar.Delete=L.Handler.extend({statics:{TYPE:"remove"},includes:L.Mixin.Events,initialize:function(t,e){if(L.Handler.prototype.initialize.call(this,t),L.Util.setOptions(this,e),this._deletableLayers=this.options.featureGroup,!(this._deletableLayers instanceof L.FeatureGroup))throw new Error("options.featureGroup must be a L.FeatureGroup");this.type=L.EditToolbar.Delete.TYPE},enable:function(){!this._enabled&&this._hasAvailableLayers()&&(this.fire("enabled",{handler:this.type}),this._map.fire(L.Draw.Event.DELETESTART,{handler:this.type}),L.Handler.prototype.enable.call(this),this._deletableLayers.on("layeradd",this._enableLayerDelete,this).on("layerremove",this._disableLayerDelete,this))},disable:function(){this._enabled&&(this._deletableLayers.off("layeradd",this._enableLayerDelete,this).off("layerremove",this._disableLayerDelete,this),L.Handler.prototype.disable.call(this),this._map.fire(L.Draw.Event.DELETESTOP,{handler:this.type}),this.fire("disabled",{handler:this.type}))},addHooks:function(){var t=this._map;t&&(t.getContainer().focus(),this._deletableLayers.eachLayer(this._enableLayerDelete,this),this._deletedLayers=new L.LayerGroup,this._tooltip=new L.Draw.Tooltip(this._map),this._tooltip.updateContent({text:L.drawLocal.edit.handlers.remove.tooltip.text}),this._map.on("mousemove",this._onMouseMove,this))},removeHooks:function(){this._map&&(this._deletableLayers.eachLayer(this._disableLayerDelete,this),this._deletedLayers=null,this._tooltip.dispose(),this._tooltip=null,this._map.off("mousemove",this._onMouseMove,this))},revertLayers:function(){this._deletedLayers.eachLayer(function(t){this._deletableLayers.addLayer(t),t.fire("revert-deleted",{layer:t})},this)},save:function(){this._map.fire(L.Draw.Event.DELETED,{layers:this._deletedLayers})},_enableLayerDelete:function(t){var e=t.layer||t.target||t;e.on("click",this._removeLayer,this)},_disableLayerDelete:function(t){var e=t.layer||t.target||t;e.off("click",this._removeLayer,this),this._deletedLayers.removeLayer(e)},_removeLayer:function(t){var e=t.layer||t.target||t;this._deletableLayers.removeLayer(e),this._deletedLayers.addLayer(e),e.fire("deleted")},_onMouseMove:function(t){this._tooltip.updatePosition(t.latlng)},_hasAvailableLayers:function(){return 0!==this._deletableLayers.getLayers().length}})}(window,document);

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _LeafletMap2 = __webpack_require__(1485);
	
	var _LeafletMap3 = _interopRequireDefault(_LeafletMap2);
	
	var _leaflet = __webpack_require__(1412);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeafletTilePinMap = function (_LeafletMap) {
	    _inherits(LeafletTilePinMap, _LeafletMap);
	
	    function LeafletTilePinMap() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LeafletTilePinMap);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeafletTilePinMap.__proto__ || Object.getPrototypeOf(LeafletTilePinMap)).call.apply(_ref, [this].concat(args))), _this), _this._getTileUrl = function (coord, zoom) {
	            var _this$props$series = _slicedToArray(_this.props.series, 1),
	                _this$props$series$ = _this$props$series[0],
	                dataset_query = _this$props$series$.card.dataset_query,
	                cols = _this$props$series$.data.cols;
	
	            var _this$_getLatLonIndex = _this._getLatLonIndexes(),
	                latitudeIndex = _this$_getLatLonIndex.latitudeIndex,
	                longitudeIndex = _this$_getLatLonIndex.longitudeIndex;
	
	            var latitudeField = cols[latitudeIndex];
	            var longitudeField = cols[longitudeIndex];
	
	            if (!latitudeField || !longitudeField) {
	                return;
	            }
	
	            return 'api/tiles/' + zoom + '/' + coord.x + '/' + coord.y + '/' + latitudeField.id + '/' + longitudeField.id + '/' + latitudeIndex + '/' + longitudeIndex + '/' + '?query=' + encodeURIComponent(JSON.stringify(dataset_query));
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LeafletTilePinMap, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            _get(LeafletTilePinMap.prototype.__proto__ || Object.getPrototypeOf(LeafletTilePinMap.prototype), "componentDidMount", this).call(this);
	
	            this.pinTileLayer = _leaflet2.default.tileLayer("", {}).addTo(this.map);
	            this.componentDidUpdate({}, {});
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState) {
	            _get(LeafletTilePinMap.prototype.__proto__ || Object.getPrototypeOf(LeafletTilePinMap.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);
	
	            try {
	                var pinTileLayer = this.pinTileLayer;
	
	                var newUrl = this._getTileUrl({ x: "{x}", y: "{y}" }, "{z}");
	                if (newUrl !== pinTileLayer._url) {
	                    pinTileLayer.setUrl(newUrl);
	                }
	            } catch (err) {
	                console.error(err);
	                this.props.onRenderError(err.message || err);
	            }
	        }
	    }]);
	
	    return LeafletTilePinMap;
	}(_LeafletMap3.default);
	
	exports.default = LeafletTilePinMap;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _LeafletMap2 = __webpack_require__(1485);
	
	var _LeafletMap3 = _interopRequireDefault(_LeafletMap2);
	
	var _leaflet = __webpack_require__(1412);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	__webpack_require__(1489);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeafletHeatMap = function (_LeafletMap) {
	    _inherits(LeafletHeatMap, _LeafletMap);
	
	    function LeafletHeatMap() {
	        _classCallCheck(this, LeafletHeatMap);
	
	        return _possibleConstructorReturn(this, (LeafletHeatMap.__proto__ || Object.getPrototypeOf(LeafletHeatMap)).apply(this, arguments));
	    }
	
	    _createClass(LeafletHeatMap, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            _get(LeafletHeatMap.prototype.__proto__ || Object.getPrototypeOf(LeafletHeatMap.prototype), "componentDidMount", this).call(this);
	
	            // Leaflet map may not be fully initialized
	            // https://stackoverflow.com/a/28903337/113
	            setTimeout(function () {
	                _this2.pinMarkerLayer = _leaflet2.default.layerGroup([]).addTo(_this2.map);
	                _this2.heatLayer = _leaflet2.default.heatLayer([], { radius: 25 }).addTo(_this2.map);
	                _this2.componentDidUpdate({}, {});
	            });
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState) {
	            _get(LeafletHeatMap.prototype.__proto__ || Object.getPrototypeOf(LeafletHeatMap.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);
	
	            try {
	                var heatLayer = this.heatLayer;
	                var _props = this.props,
	                    points = _props.points,
	                    max = _props.max,
	                    settings = _props.settings;
	
	
	                heatLayer.setOptions({
	                    max: max,
	                    maxZoom: settings["map.heat.max-zoom"],
	                    minOpacity: settings["map.heat.min-opacity"],
	                    radius: settings["map.heat.radius"],
	                    blur: settings["map.heat.blur"]
	                });
	                heatLayer.setLatLngs(points);
	            } catch (err) {
	                console.error(err);
	                this.props.onRenderError(err.message || err);
	            }
	        }
	    }]);
	
	    return LeafletHeatMap;
	}(_LeafletMap3.default);
	
	exports.default = LeafletHeatMap;

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

	/*
	 (c) 2014, Vladimir Agafonkin
	 simpleheat, a tiny JavaScript library for drawing heatmaps with Canvas
	 https://github.com/mourner/simpleheat
	*/
	!function(){"use strict";function t(i){return this instanceof t?(this._canvas=i="string"==typeof i?document.getElementById(i):i,this._ctx=i.getContext("2d"),this._width=i.width,this._height=i.height,this._max=1,void this.clear()):new t(i)}t.prototype={defaultRadius:25,defaultGradient:{.4:"blue",.6:"cyan",.7:"lime",.8:"yellow",1:"red"},data:function(t,i){return this._data=t,this},max:function(t){return this._max=t,this},add:function(t){return this._data.push(t),this},clear:function(){return this._data=[],this},radius:function(t,i){i=i||15;var a=this._circle=document.createElement("canvas"),s=a.getContext("2d"),e=this._r=t+i;return a.width=a.height=2*e,s.shadowOffsetX=s.shadowOffsetY=200,s.shadowBlur=i,s.shadowColor="black",s.beginPath(),s.arc(e-200,e-200,t,0,2*Math.PI,!0),s.closePath(),s.fill(),this},gradient:function(t){var i=document.createElement("canvas"),a=i.getContext("2d"),s=a.createLinearGradient(0,0,0,256);i.width=1,i.height=256;for(var e in t)s.addColorStop(e,t[e]);return a.fillStyle=s,a.fillRect(0,0,1,256),this._grad=a.getImageData(0,0,1,256).data,this},draw:function(t){this._circle||this.radius(this.defaultRadius),this._grad||this.gradient(this.defaultGradient);var i=this._ctx;i.clearRect(0,0,this._width,this._height);for(var a,s=0,e=this._data.length;e>s;s++)a=this._data[s],i.globalAlpha=Math.max(a[2]/this._max,t||.05),i.drawImage(this._circle,a[0]-this._r,a[1]-this._r);var n=i.getImageData(0,0,this._width,this._height);return this._colorize(n.data,this._grad),i.putImageData(n,0,0),this},_colorize:function(t,i){for(var a,s=3,e=t.length;e>s;s+=4)a=4*t[s],a&&(t[s-3]=i[a],t[s-2]=i[a+1],t[s-1]=i[a+2])}},window.simpleheat=t}(),/*
	 (c) 2014, Vladimir Agafonkin
	 Leaflet.heat, a tiny and fast heatmap plugin for Leaflet.
	 https://github.com/Leaflet/Leaflet.heat
	*/
	L.HeatLayer=(L.Layer?L.Layer:L.Class).extend({initialize:function(t,i){this._latlngs=t,L.setOptions(this,i)},setLatLngs:function(t){return this._latlngs=t,this.redraw()},addLatLng:function(t){return this._latlngs.push(t),this.redraw()},setOptions:function(t){return L.setOptions(this,t),this._heat&&this._updateOptions(),this.redraw()},redraw:function(){return!this._heat||this._frame||this._map._animating||(this._frame=L.Util.requestAnimFrame(this._redraw,this)),this},onAdd:function(t){this._map=t,this._canvas||this._initCanvas(),t._panes.overlayPane.appendChild(this._canvas),t.on("moveend",this._reset,this),t.options.zoomAnimation&&L.Browser.any3d&&t.on("zoomanim",this._animateZoom,this),this._reset()},onRemove:function(t){t.getPanes().overlayPane.removeChild(this._canvas),t.off("moveend",this._reset,this),t.options.zoomAnimation&&t.off("zoomanim",this._animateZoom,this)},addTo:function(t){return t.addLayer(this),this},_initCanvas:function(){var t=this._canvas=L.DomUtil.create("canvas","leaflet-heatmap-layer leaflet-layer"),i=L.DomUtil.testProp(["transformOrigin","WebkitTransformOrigin","msTransformOrigin"]);t.style[i]="50% 50%";var a=this._map.getSize();t.width=a.x,t.height=a.y;var s=this._map.options.zoomAnimation&&L.Browser.any3d;L.DomUtil.addClass(t,"leaflet-zoom-"+(s?"animated":"hide")),this._heat=simpleheat(t),this._updateOptions()},_updateOptions:function(){this._heat.radius(this.options.radius||this._heat.defaultRadius,this.options.blur),this.options.gradient&&this._heat.gradient(this.options.gradient),this.options.max&&this._heat.max(this.options.max)},_reset:function(){var t=this._map.containerPointToLayerPoint([0,0]);L.DomUtil.setPosition(this._canvas,t);var i=this._map.getSize();this._heat._width!==i.x&&(this._canvas.width=this._heat._width=i.x),this._heat._height!==i.y&&(this._canvas.height=this._heat._height=i.y),this._redraw()},_redraw:function(){var t,i,a,s,e,n,h,o,r,d=[],_=this._heat._r,l=this._map.getSize(),m=new L.Bounds(L.point([-_,-_]),l.add([_,_])),c=void 0===this.options.max?1:this.options.max,u=void 0===this.options.maxZoom?this._map.getMaxZoom():this.options.maxZoom,f=1/Math.pow(2,Math.max(0,Math.min(u-this._map.getZoom(),12))),g=_/2,p=[],v=this._map._getMapPanePos(),w=v.x%g,y=v.y%g;for(t=0,i=this._latlngs.length;i>t;t++)if(a=this._map.latLngToContainerPoint(this._latlngs[t]),m.contains(a)){e=Math.floor((a.x-w)/g)+2,n=Math.floor((a.y-y)/g)+2;var x=void 0!==this._latlngs[t].alt?this._latlngs[t].alt:void 0!==this._latlngs[t][2]?+this._latlngs[t][2]:1;r=x*f,p[n]=p[n]||[],s=p[n][e],s?(s[0]=(s[0]*s[2]+a.x*r)/(s[2]+r),s[1]=(s[1]*s[2]+a.y*r)/(s[2]+r),s[2]+=r):p[n][e]=[a.x,a.y,r]}for(t=0,i=p.length;i>t;t++)if(p[t])for(h=0,o=p[t].length;o>h;h++)s=p[t][h],s&&d.push([Math.round(s[0]),Math.round(s[1]),Math.min(s[2],c)]);this._heat.data(d).draw(this.options.minOpacity),this._frame=null},_animateZoom:function(t){var i=this._map.getZoomScale(t.zoom),a=this._map._getCenterOffset(t.center)._multiplyBy(-i).subtract(this._map._getMapPanePos());L.DomUtil.setTransform?L.DomUtil.setTransform(this._canvas,a,i):this._canvas.style[L.DomUtil.TRANSFORM]=L.DomUtil.getTranslateString(a)+" scale("+i+")"}}),L.heatLayer=function(t,i){return new L.HeatLayer(t,i)};

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _LeafletMap2 = __webpack_require__(1485);
	
	var _LeafletMap3 = _interopRequireDefault(_LeafletMap2);
	
	var _leaflet = __webpack_require__(1412);
	
	var _leaflet2 = _interopRequireDefault(_leaflet);
	
	var _d2 = __webpack_require__(873);
	
	var _d3 = _interopRequireDefault(_d2);
	
	var _dataset = __webpack_require__(877);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeafletGridHeatMap = function (_LeafletMap) {
	    _inherits(LeafletGridHeatMap, _LeafletMap);
	
	    function LeafletGridHeatMap() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LeafletGridHeatMap);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LeafletGridHeatMap.__proto__ || Object.getPrototypeOf(LeafletGridHeatMap)).call.apply(_ref, [this].concat(args))), _this), _this._createGridSquare = function (index) {
	            var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	            var gridSquare = _leaflet2.default.rectangle(bounds, {
	                color: "red",
	                weight: 1,
	                stroke: true,
	                fillOpacity: 0.5,
	                strokeOpacity: 1.0
	            });
	            gridSquare.on("click", _this._onVisualizationClick.bind(_this, index));
	            gridSquare.on("mousemove", _this._onHoverChange.bind(_this, index));
	            gridSquare.on("mouseout", _this._onHoverChange.bind(_this, null));
	            return gridSquare;
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LeafletGridHeatMap, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            _get(LeafletGridHeatMap.prototype.__proto__ || Object.getPrototypeOf(LeafletGridHeatMap.prototype), "componentDidMount", this).call(this);
	
	            this.gridLayer = _leaflet2.default.layerGroup([]).addTo(this.map);
	            this.componentDidUpdate({}, {});
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps, prevState) {
	            _get(LeafletGridHeatMap.prototype.__proto__ || Object.getPrototypeOf(LeafletGridHeatMap.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);
	
	            try {
	                var gridLayer = this.gridLayer;
	                var _props = this.props,
	                    points = _props.points,
	                    min = _props.min,
	                    max = _props.max;
	
	                var _getLatLonColumns = this._getLatLonColumns(),
	                    latitudeColumn = _getLatLonColumns.latitudeColumn,
	                    longitudeColumn = _getLatLonColumns.longitudeColumn;
	
	                if (!latitudeColumn.binning_info || !longitudeColumn.binning_info) {
	                    throw new Error("Grid map requires binned longitude/latitude.");
	                }
	
	                var color = _d3.default.scale.linear().domain([min, max]).interpolate(_d3.default.interpolateHcl).range([_d3.default.rgb("#00FF00"), _d3.default.rgb('#FF0000')]);
	
	                var gridSquares = gridLayer.getLayers();
	                var totalSquares = Math.max(points.length, gridSquares.length);
	                for (var i = 0; i < totalSquares; i++) {
	                    if (i >= points.length) {
	                        gridLayer.removeLayer(gridSquares[i]);
	                    }
	                    if (i >= gridSquares.length) {
	                        var gridSquare = this._createGridSquare(i);
	                        gridLayer.addLayer(gridSquare);
	                        gridSquares.push(gridSquare);
	                    }
	
	                    if (i < points.length) {
	                        gridSquares[i].setStyle({ color: color(points[i][2]) });
	
	                        var _rangeForValue = (0, _dataset.rangeForValue)(points[i][0], latitudeColumn),
	                            _rangeForValue2 = _slicedToArray(_rangeForValue, 2),
	                            latMin = _rangeForValue2[0],
	                            latMax = _rangeForValue2[1];
	
	                        var _rangeForValue3 = (0, _dataset.rangeForValue)(points[i][1], longitudeColumn),
	                            _rangeForValue4 = _slicedToArray(_rangeForValue3, 2),
	                            lonMin = _rangeForValue4[0],
	                            lonMax = _rangeForValue4[1];
	
	                        gridSquares[i].setBounds([[latMin, lonMin], [latMax, lonMax]]);
	                    }
	                }
	            } catch (err) {
	                console.error(err);
	                this.props.onRenderError(err.message || err);
	            }
	        }
	    }, {
	        key: "_clickForPoint",
	        value: function _clickForPoint(index, e) {
	            var points = this.props.points;
	
	            var point = points[index];
	            var metricColumn = this._getMetricColumn();
	
	            var _getLatLonColumns2 = this._getLatLonColumns(),
	                latitudeColumn = _getLatLonColumns2.latitudeColumn,
	                longitudeColumn = _getLatLonColumns2.longitudeColumn;
	
	            return {
	                value: point[2],
	                column: metricColumn,
	                dimensions: [{
	                    value: point[0],
	                    column: latitudeColumn
	                }, {
	                    value: point[1],
	                    column: longitudeColumn
	                }],
	                event: e.originalEvent
	            };
	        }
	    }, {
	        key: "_onVisualizationClick",
	        value: function _onVisualizationClick(index, e) {
	            var onVisualizationClick = this.props.onVisualizationClick;
	
	            if (onVisualizationClick) {
	                onVisualizationClick(this._clickForPoint(index, e));
	            }
	        }
	    }, {
	        key: "_onHoverChange",
	        value: function _onHoverChange(index, e) {
	            var onHoverChange = this.props.onHoverChange;
	
	            if (onHoverChange) {
	                if (index == null) {
	                    onHoverChange(null);
	                } else {
	                    onHoverChange(this._clickForPoint(index, e));
	                }
	            }
	        }
	    }]);
	
	    return LeafletGridHeatMap;
	}(_LeafletMap3.default);
	
	exports.default = LeafletGridHeatMap;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _class, _temp;
	
	var _LineAreaBarChart2 = __webpack_require__(1370);
	
	var _LineAreaBarChart3 = _interopRequireDefault(_LineAreaBarChart2);
	
	var _LineAreaBarRenderer = __webpack_require__(1389);
	
	var _graph = __webpack_require__(1394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScatterPlot = (_temp = _class = function (_LineAreaBarChart) {
	    _inherits(ScatterPlot, _LineAreaBarChart);
	
	    function ScatterPlot() {
	        _classCallCheck(this, ScatterPlot);
	
	        return _possibleConstructorReturn(this, (ScatterPlot.__proto__ || Object.getPrototypeOf(ScatterPlot)).apply(this, arguments));
	    }
	
	    return ScatterPlot;
	}(_LineAreaBarChart3.default), _class.uiName = "Scatter", _class.identifier = "scatter", _class.iconName = "bubble", _class.noun = "scatter plot", _class.renderer = _LineAreaBarRenderer.scatterRenderer, _class.settings = _extends({}, _graph.GRAPH_DATA_SETTINGS, _graph.GRAPH_BUBBLE_SETTINGS, _graph.GRAPH_GOAL_SETTINGS, _graph.GRAPH_COLORS_SETTINGS, _graph.GRAPH_AXIS_SETTINGS), _temp);
	exports.default = ScatterPlot;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _errors = __webpack_require__(1388);
	
	var _formatting = __webpack_require__(872);
	
	var _settings = __webpack_require__(1376);
	
	var _FunnelNormal = __webpack_require__(1493);
	
	var _FunnelNormal2 = _interopRequireDefault(_FunnelNormal);
	
	var _FunnelBar = __webpack_require__(1496);
	
	var _FunnelBar2 = _interopRequireDefault(_FunnelBar);
	
	var _LegendHeader = __webpack_require__(1273);
	
	var _LegendHeader2 = _interopRequireDefault(_LegendHeader);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TitleLegendHeader = __webpack_require__(1373);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Funnel = (_temp = _class = function (_Component) {
	    _inherits(Funnel, _Component);
	
	    function Funnel() {
	        _classCallCheck(this, Funnel);
	
	        return _possibleConstructorReturn(this, (Funnel.__proto__ || Object.getPrototypeOf(Funnel)).apply(this, arguments));
	    }
	
	    _createClass(Funnel, [{
	        key: "render",
	        value: function render() {
	            var settings = this.props.settings;
	
	
	            var hasTitle = settings["card.title"];
	
	            if (settings["funnel.type"] === "bar") {
	                return _react2.default.createElement(_FunnelBar2.default, this.props);
	            } else {
	                var _props = this.props,
	                    actionButtons = _props.actionButtons,
	                    className = _props.className,
	                    onChangeCardAndRun = _props.onChangeCardAndRun,
	                    series = _props.series;
	
	                return _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)(className, "flex flex-column p1") },
	                    hasTitle && _react2.default.createElement(_TitleLegendHeader.TitleLegendHeader, {
	                        series: series,
	                        settings: settings,
	                        onChangeCardAndRun: onChangeCardAndRun,
	                        actionButtons: actionButtons
	                    }),
	                    _react2.default.createElement(_LegendHeader2.default, {
	                        className: "flex-no-shrink"
	                        // $FlowFixMe
	                        , series: series._raw || series,
	                        actionButtons: !hasTitle && actionButtons,
	                        onChangeCardAndRun: onChangeCardAndRun
	                    }),
	                    _react2.default.createElement(_FunnelNormal2.default, _extends({}, this.props, { className: "flex-full" }))
	                );
	            }
	        }
	    }], [{
	        key: "isSensible",
	        value: function isSensible(cols, rows) {
	            return cols.length === 2;
	        }
	    }, {
	        key: "checkRenderable",
	        value: function checkRenderable(series, settings) {
	            var _series = _slicedToArray(series, 1),
	                rows = _series[0].data.rows;
	
	            if (series.length > 1) {
	                return;
	            }
	
	            if (rows.length < 1) {
	                throw new _errors.MinRowsError(1, rows.length);
	            }
	            if (!settings["funnel.dimension"] || !settings["funnel.metric"]) {
	                throw new _errors.ChartSettingsError("Which fields do you want to use?", "Data", "Choose fields");
	            }
	        }
	    }, {
	        key: "transformSeries",
	        value: function transformSeries(series) {
	            var _series2 = _slicedToArray(series, 1),
	                _series2$ = _series2[0],
	                card = _series2$.card,
	                _series2$$data = _series2$.data,
	                rows = _series2$$data.rows,
	                cols = _series2$$data.cols;
	
	            var settings = (0, _settings.getSettings)(series);
	
	            var dimensionIndex = _underscore2.default.findIndex(cols, function (col) {
	                return col.name === settings["funnel.dimension"];
	            });
	            var metricIndex = _underscore2.default.findIndex(cols, function (col) {
	                return col.name === settings["funnel.metric"];
	            });
	
	            if (!card._transformed && series.length === 1 && rows.length > 1 && dimensionIndex >= 0 && metricIndex >= 0) {
	                return rows.map(function (row) {
	                    return {
	                        card: _extends({}, card, {
	                            name: (0, _formatting.formatValue)(row[dimensionIndex], { column: cols[dimensionIndex] }),
	                            _transformed: true
	                        }),
	                        data: {
	                            rows: [[row[dimensionIndex], row[metricIndex]]],
	                            cols: [cols[dimensionIndex], cols[metricIndex]]
	                        }
	                    };
	                });
	            } else {
	                return series;
	            }
	        }
	    }]);
	
	    return Funnel;
	}(_react.Component), _class.uiName = "Funnel", _class.identifier = "funnel", _class.iconName = "funnel", _class.noHeader = true, _class.minSize = {
	    width: 5,
	    height: 4
	}, _class.settings = {
	    "funnel.dimension": _extends({
	        section: "Data",
	        title: "Step"
	    }, (0, _settings.dimensionSetting)("funnel.dimension"), {
	        dashboard: false,
	        useRawSeries: true
	    }),
	    "funnel.metric": _extends({
	        section: "Data",
	        title: "Measure"
	    }, (0, _settings.metricSetting)("funnel.metric"), {
	        dashboard: false,
	        useRawSeries: true
	    }),
	    "funnel.type": {
	        title: "Funnel type",
	        section: "Display",
	        widget: "select",
	        props: {
	            options: [{ name: "Funnel", value: "funnel" }, { name: "Bar chart", value: "bar" }]
	        },
	        // legacy "bar" funnel was only previously available via multiseries
	        getDefault: function getDefault(series) {
	            return series.length > 1 ? "bar" : "funnel";
	        },
	        useRawSeries: true
	    }
	}, _temp);
	Funnel.displayName = "Funnel";
	exports.default = Funnel;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FunnelNormal = __webpack_require__(1494);
	
	var _FunnelNormal2 = _interopRequireDefault(_FunnelNormal);
	
	var _Ellipsified = __webpack_require__(1277);
	
	var _Ellipsified2 = _interopRequireDefault(_Ellipsified);
	
	var _formatting = __webpack_require__(872);
	
	var _utils = __webpack_require__(878);
	
	var _colors = __webpack_require__(881);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_COLORS = Object.values(_colors.normal);
	
	var Funnel = function (_Component) {
	    _inherits(Funnel, _Component);
	
	    function Funnel() {
	        _classCallCheck(this, Funnel);
	
	        return _possibleConstructorReturn(this, (Funnel.__proto__ || Object.getPrototypeOf(Funnel)).apply(this, arguments));
	    }
	
	    _createClass(Funnel, [{
	        key: "render",
	        value: function render() {
	            var _cx;
	
	            var _props = this.props,
	                className = _props.className,
	                series = _props.series,
	                gridSize = _props.gridSize,
	                hovered = _props.hovered,
	                onHoverChange = _props.onHoverChange,
	                onVisualizationClick = _props.onVisualizationClick,
	                visualizationIsClickable = _props.visualizationIsClickable;
	
	
	            var dimensionIndex = 0;
	            var metricIndex = 1;
	            var cols = series[0].data.cols;
	            // $FlowFixMe
	            var rows = series.map(function (s) {
	                return s.data.rows[0];
	            });
	
	            var funnelSmallSize = gridSize && (gridSize.width < 7 || gridSize.height <= 5);
	
	            var formatDimension = function formatDimension(dimension) {
	                var jsx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	                return (0, _formatting.formatValue)(dimension, { column: cols[dimensionIndex], jsx: jsx, majorWidth: 0 });
	            };
	            var formatMetric = function formatMetric(metric) {
	                var jsx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	                return (0, _formatting.formatValue)(metric, { column: cols[metricIndex], jsx: jsx, majorWidth: 0, comma: true });
	            };
	            var formatPercent = function formatPercent(percent) {
	                return (100 * percent).toFixed(2) + " %";
	            };
	
	            // Initial infos (required for step calculation)
	            var infos = [{
	                value: rows[0][metricIndex],
	                graph: {
	                    startBottom: 0.0,
	                    startTop: 1.0,
	                    endBottom: 0.0,
	                    endTop: 1.0
	                }
	            }];
	
	            var remaining = rows[0][metricIndex];
	
	            rows.map(function (row, rowIndex) {
	                remaining -= infos[rowIndex].value - row[metricIndex];
	
	                infos[rowIndex + 1] = {
	                    value: row[metricIndex],
	
	                    graph: {
	                        startBottom: infos[rowIndex].graph.endBottom,
	                        startTop: infos[rowIndex].graph.endTop,
	                        endTop: 0.5 + remaining / infos[0].value / 2,
	                        endBottom: 0.5 - remaining / infos[0].value / 2
	                    },
	
	                    hovered: {
	                        index: rowIndex,
	                        data: [{
	                            key: 'Step',
	                            value: formatDimension(row[dimensionIndex])
	                        }, {
	                            key: (0, _utils.getFriendlyName)(cols[metricIndex]),
	                            value: formatMetric(row[metricIndex])
	                        }, {
	                            key: 'Retained',
	                            value: formatPercent(row[metricIndex] / infos[0].value)
	                        }]
	                    },
	
	                    clicked: {
	                        value: row[metricIndex],
	                        column: cols[metricIndex],
	                        dimensions: [{
	                            value: row[dimensionIndex],
	                            column: cols[dimensionIndex]
	                        }]
	                    }
	                };
	            });
	
	            // Remove initial setup
	            infos = infos.slice(1);
	
	            var initial = infos[0];
	
	            var isClickable = visualizationIsClickable(infos[0].clicked);
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(className, _FunnelNormal2.default.Funnel, 'flex', (_cx = {}, _defineProperty(_cx, _FunnelNormal2.default.Small, funnelSmallSize), _defineProperty(_cx, "p1", funnelSmallSize), _defineProperty(_cx, "p2", !funnelSmallSize), _cx)) },
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)(_FunnelNormal2.default.FunnelStep, _FunnelNormal2.default.Initial, 'flex flex-column') },
	                    _react2.default.createElement(
	                        _Ellipsified2.default,
	                        { className: _FunnelNormal2.default.Head },
	                        formatDimension(rows[0][dimensionIndex])
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _FunnelNormal2.default.Start },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _FunnelNormal2.default.Title },
	                            formatMetric(rows[0][metricIndex])
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _FunnelNormal2.default.Subtitle },
	                            (0, _utils.getFriendlyName)(cols[dimensionIndex])
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _FunnelNormal2.default.Infos },
	                        _react2.default.createElement(
	                            "div",
	                            { className: _FunnelNormal2.default.Title },
	                            "\xA0"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _FunnelNormal2.default.Subtitle },
	                            "\xA0"
	                        )
	                    )
	                ),
	                infos.slice(1).map(function (info, index) {
	                    return _react2.default.createElement(
	                        "div",
	                        { key: index, className: (0, _classnames2.default)(_FunnelNormal2.default.FunnelStep, 'flex flex-column') },
	                        _react2.default.createElement(
	                            _Ellipsified2.default,
	                            { className: _FunnelNormal2.default.Head },
	                            formatDimension(rows[index + 1][dimensionIndex])
	                        ),
	                        _react2.default.createElement(GraphSection, {
	                            className: (0, _classnames2.default)({ "cursor-pointer": isClickable }),
	                            index: index,
	                            info: info,
	                            infos: infos,
	                            hovered: hovered,
	                            onHoverChange: onHoverChange,
	                            onVisualizationClick: isClickable ? onVisualizationClick : null
	                        }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: _FunnelNormal2.default.Infos },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _FunnelNormal2.default.Title },
	                                formatPercent(info.value / initial.value)
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _FunnelNormal2.default.Subtitle },
	                                formatMetric(rows[index + 1][metricIndex])
	                            )
	                        )
	                    );
	                })
	            );
	        }
	    }]);
	
	    return Funnel;
	}(_react.Component);
	
	Funnel.displayName = "Funnel";
	exports.default = Funnel;
	
	var GraphSection = function GraphSection(_ref) {
	    var index = _ref.index,
	        info = _ref.info,
	        infos = _ref.infos,
	        hovered = _ref.hovered,
	        onHoverChange = _ref.onHoverChange,
	        onVisualizationClick = _ref.onVisualizationClick,
	        className = _ref.className;
	
	    return _react2.default.createElement(
	        "svg",
	        {
	            className: (0, _classnames2.default)(className, _FunnelNormal2.default.Graph),
	            onMouseMove: function onMouseMove(e) {
	                if (onHoverChange && info.hovered) {
	                    onHoverChange(_extends({}, info.hovered, {
	                        event: e.nativeEvent
	                    }));
	                }
	            },
	            onMouseLeave: function onMouseLeave() {
	                return onHoverChange && onHoverChange(null);
	            },
	            onClick: function onClick(e) {
	                if (onVisualizationClick && info.clicked) {
	                    onVisualizationClick(_extends({}, info.clicked, {
	                        event: e.nativeEvent
	                    }));
	                }
	            },
	            viewBox: "0 0 1 1",
	            preserveAspectRatio: "none"
	        },
	        _react2.default.createElement("polygon", {
	            opacity: 1 - index * (0.9 / (infos.length + 1)),
	            fill: DEFAULT_COLORS[0],
	            points: "0 " + info.graph.startBottom + ", 0 " + info.graph.startTop + ", 1 " + info.graph.endTop + ", 1 " + info.graph.endBottom
	        })
	    );
	};
	GraphSection.displayName = "GraphSection";

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Funnel":"PS5df","FunnelStep":"_2vUMz","Initial":"_2N5af","Start":"_2Wc6M","Title":"_1o3km","Subtitle":"_2N341","Head":"_cker","Graph":"GvdI5","Infos":"_129--","Small":"_2Xb73"};

/***/ }),
/* 1495 */,
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BarChart = __webpack_require__(1395);
	
	var _BarChart2 = _interopRequireDefault(_BarChart);
	
	var _settings = __webpack_require__(1376);
	
	var _icepick = __webpack_require__(855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BarFunnel = function (_Component) {
	    _inherits(BarFunnel, _Component);
	
	    function BarFunnel() {
	        _classCallCheck(this, BarFunnel);
	
	        return _possibleConstructorReturn(this, (BarFunnel.__proto__ || Object.getPrototypeOf(BarFunnel)).apply(this, arguments));
	    }
	
	    _createClass(BarFunnel, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_BarChart2.default, _extends({}, this.props, {
	                isScalarSeries: true,
	                settings: _extends({}, this.props.settings, (0, _settings.getSettings)((0, _icepick.assocIn)(this.props.series, [0, "card", "display"], "bar")), {
	                    "bar.scalar_series": true
	                })
	            }));
	        }
	    }]);
	
	    return BarFunnel;
	}(_react.Component);
	
	BarFunnel.displayName = "BarFunnel";
	exports.default = BarFunnel;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ObjectDetail = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; /*  weak */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _DirectionalButton = __webpack_require__(1498);
	
	var _DirectionalButton2 = _interopRequireDefault(_DirectionalButton);
	
	var _ExpandableString = __webpack_require__(1499);
	
	var _ExpandableString2 = _interopRequireDefault(_ExpandableString);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _IconBorder = __webpack_require__(1289);
	
	var _IconBorder2 = _interopRequireDefault(_IconBorder);
	
	var _LoadingSpinner = __webpack_require__(1281);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _types = __webpack_require__(868);
	
	var _inflection = __webpack_require__(520);
	
	var _formatting = __webpack_require__(872);
	
	var _table = __webpack_require__(871);
	
	var _actions = __webpack_require__(863);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps() {
	    return {};
	};
	
	var mapDispatchToProps = {
	    viewPreviousObjectDetail: _actions.viewPreviousObjectDetail,
	    viewNextObjectDetail: _actions.viewNextObjectDetail
	};
	
	var ObjectDetail = exports.ObjectDetail = (_temp2 = _class = function (_Component) {
	    _inherits(ObjectDetail, _Component);
	
	    function ObjectDetail() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ObjectDetail);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ObjectDetail.__proto__ || Object.getPrototypeOf(ObjectDetail)).call.apply(_ref, [this].concat(args))), _this), _this.foreignKeyClicked = function (fk) {
	            _this.props.followForeignKey(fk);
	        }, _this.onKeyDown = function (event) {
	            if (event.key === 'ArrowLeft') {
	                _this.props.viewPreviousObjectDetail();
	            }
	            if (event.key === 'ArrowRight') {
	                _this.props.viewNextObjectDetail();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ObjectDetail, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // load up FK references
	            this.props.loadObjectDetailFKReferences();
	            window.addEventListener('keydown', this.onKeyDown, true);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener('keydown', this.onKeyDown, true);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // if the card has changed then reload fk references
	            if (this.props.data != nextProps.data) {
	                this.props.loadObjectDetailFKReferences();
	            }
	        }
	    }, {
	        key: 'getIdValue',
	        value: function getIdValue() {
	            if (!this.props.data) return null;
	
	            var _props$data = this.props.data,
	                cols = _props$data.cols,
	                rows = _props$data.rows;
	
	            var columnIndex = _underscore2.default.findIndex(cols, function (col) {
	                return (0, _schema_metadata.isPK)(col);
	            });
	            return rows[0][columnIndex];
	        }
	    }, {
	        key: 'cellRenderer',
	        value: function cellRenderer(column, value, isColumn) {
	            var _props = this.props,
	                onVisualizationClick = _props.onVisualizationClick,
	                visualizationIsClickable = _props.visualizationIsClickable;
	
	
	            var cellValue = void 0;
	            var clicked = void 0;
	            var isLink = void 0;
	
	            if (isColumn) {
	                cellValue = column !== null ? (0, _formatting.formatColumn)(column) : null;
	                clicked = {
	                    column: column
	                };
	                isLink = false;
	            } else {
	                if (value === null || value === undefined || value === "") {
	                    cellValue = _react2.default.createElement(
	                        'span',
	                        { className: 'text-grey-2' },
	                        'Empty'
	                    );
	                } else if ((0, _types.isa)(column.special_type, _types.TYPE.SerializedJSON)) {
	                    var formattedJson = JSON.stringify(JSON.parse(value), null, 2);
	                    cellValue = _react2.default.createElement(
	                        'pre',
	                        { className: 'ObjectJSON' },
	                        formattedJson
	                    );
	                } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === "object") {
	                    var _formattedJson = JSON.stringify(value, null, 2);
	                    cellValue = _react2.default.createElement(
	                        'pre',
	                        { className: 'ObjectJSON' },
	                        _formattedJson
	                    );
	                } else {
	                    cellValue = (0, _formatting.formatValue)(value, { column: column, jsx: true });
	                    if (typeof cellValue === "string") {
	                        cellValue = _react2.default.createElement(_ExpandableString2.default, { str: cellValue, length: 140 });
	                    }
	                }
	                clicked = {
	                    column: column,
	                    value: value
	                };
	                isLink = (0, _schema_metadata.isID)(column);
	            }
	
	            var isClickable = onVisualizationClick && visualizationIsClickable(clicked);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: (0, _classnames2.default)({ "cursor-pointer": isClickable, "link": isClickable && isLink }),
	                        onClick: isClickable && function (e) {
	                            onVisualizationClick(_extends({}, clicked, { element: e.currentTarget }));
	                        }
	                    },
	                    cellValue
	                )
	            );
	        }
	    }, {
	        key: 'renderDetailsTable',
	        value: function renderDetailsTable() {
	            var _this2 = this;
	
	            var _props$data2 = this.props.data,
	                cols = _props$data2.cols,
	                rows = _props$data2.rows;
	
	            return cols.map(function (column, columnIndex) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'Grid Grid--1of2 mb2', key: columnIndex },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Grid-cell' },
	                        _this2.cellRenderer(column, rows[0][columnIndex], true)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { wordWrap: 'break-word' }, className: 'Grid-cell text-bold text-dark' },
	                        _this2.cellRenderer(column, rows[0][columnIndex], false)
	                    )
	                );
	            });
	        }
	    }, {
	        key: 'renderRelationships',
	        value: function renderRelationships() {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                tableForeignKeys = _props2.tableForeignKeys,
	                tableForeignKeyReferences = _props2.tableForeignKeyReferences;
	
	            if (!tableForeignKeys) {
	                return null;
	            }
	
	            tableForeignKeys = tableForeignKeys.filter(function (fk) {
	                return (0, _table.isQueryable)(fk.origin.table);
	            });
	
	            if (tableForeignKeys.length < 1) {
	                return _react2.default.createElement(
	                    'p',
	                    { className: 'my4 text-centered' },
	                    'No relationships found.'
	                );
	            }
	
	            var fkCountsByTable = (0, _schema_metadata.foreignKeyCountsByOriginTable)(tableForeignKeys);
	
	            var relationships = tableForeignKeys.sort(function (a, b) {
	                return a.origin.table.display_name.localeCompare(b.origin.table.display_name);
	            }).map(function (fk) {
	                var fkCount = _react2.default.createElement(_LoadingSpinner2.default, { size: 25 });
	                var fkCountValue = 0;
	                var fkClickable = false;
	                if (tableForeignKeyReferences) {
	                    var fkCountInfo = tableForeignKeyReferences[fk.origin.id];
	                    if (fkCountInfo && fkCountInfo.status === 1) {
	                        fkCount = _react2.default.createElement(
	                            'span',
	                            null,
	                            fkCountInfo.value
	                        );
	
	                        if (fkCountInfo.value) {
	                            fkCountValue = fkCountInfo.value;
	                            fkClickable = true;
	                        }
	                    }
	                }
	                var chevron = _react2.default.createElement(
	                    _IconBorder2.default,
	                    { className: 'flex-align-right' },
	                    _react2.default.createElement(_Icon2.default, { name: 'chevronright', size: 10 })
	                );
	
	                var relationName = (0, _inflection.inflect)(fk.origin.table.display_name, fkCountValue);
	                var via = fkCountsByTable[fk.origin.table.id] > 1 ? _react2.default.createElement(
	                    'span',
	                    { className: 'text-grey-3 text-normal' },
	                    ' via ',
	                    fk.origin.display_name
	                ) : null;
	
	                var info = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        fkCount
	                    ),
	                    _react2.default.createElement(
	                        'h5',
	                        { className: 'block' },
	                        relationName,
	                        via
	                    )
	                );
	                var fkReference = void 0;
	                var referenceClasses = (0, _classnames2.default)('flex align-center my2 pb2 border-bottom', {
	                    'text-brand-hover cursor-pointer text-dark': fkClickable,
	                    'text-grey-3': !fkClickable
	                });
	
	                if (fkClickable) {
	                    fkReference = _react2.default.createElement(
	                        'div',
	                        { className: referenceClasses, key: fk.id, onClick: _this3.foreignKeyClicked.bind(null, fk) },
	                        info,
	                        chevron
	                    );
	                } else {
	                    fkReference = _react2.default.createElement(
	                        'div',
	                        { className: referenceClasses, key: fk.id },
	                        info
	                    );
	                }
	
	                return _react2.default.createElement(
	                    'li',
	                    null,
	                    fkReference
	                );
	            });
	
	            return _react2.default.createElement(
	                'ul',
	                { className: 'px4' },
	                relationships
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.props.data) {
	                return false;
	            }
	
	            var tableName = this.props.tableMetadata ? (0, _inflection.singularize)(this.props.tableMetadata.display_name) : "Unknown";
	            // TODO: once we nail down the "title" column of each table this should be something other than the id
	            var idValue = this.getIdValue();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'ObjectDetail rounded mt2' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'Grid ObjectDetail-headingGroup' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Grid-cell ObjectDetail-infoMain px4 py3 ml2 arrow-right' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-brand text-bold' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                tableName
	                            ),
	                            _react2.default.createElement(
	                                'h1',
	                                null,
	                                idValue
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Grid-cell flex align-center Cell--1of3 bg-alt' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'p4 flex align-center text-bold text-grey-3' },
	                            _react2.default.createElement(_Icon2.default, { name: 'connections', size: 17 }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'ml2' },
	                                'This ',
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'text-dark' },
	                                    tableName
	                                ),
	                                ' is connected to:'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'Grid' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Grid-cell ObjectDetail-infoMain p4' },
	                        this.renderDetailsTable()
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'Grid-cell Cell--1of3 bg-alt' },
	                        this.renderRelationships()
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: (0, _classnames2.default)("fixed left cursor-pointer text-brand-hover lg-ml2", { "disabled": idValue <= 1 }),
	                        style: { top: '50%', left: '1em', transform: 'translate(0, -50%)' }
	                    },
	                    _react2.default.createElement(_DirectionalButton2.default, {
	                        direction: 'back',
	                        onClick: this.props.viewPreviousObjectDetail
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: 'fixed right cursor-pointer text-brand-hover lg-ml2',
	                        style: { top: '50%', right: '1em', transform: 'translate(0, -50%)' }
	                    },
	                    _react2.default.createElement(_DirectionalButton2.default, {
	                        direction: 'forward',
	                        onClick: this.props.viewNextObjectDetail
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ObjectDetail;
	}(_react.Component), _class.uiName = "Object Detail", _class.identifier = "object", _class.iconName = "document", _class.noun = "object", _class.hidden = true, _temp2);
	ObjectDetail.displayName = 'ObjectDetail';
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ObjectDetail);

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DirectionalButton = function DirectionalButton(_ref) {
	    var _ref$direction = _ref.direction,
	        direction = _ref$direction === undefined ? "back" : _ref$direction,
	        onClick = _ref.onClick;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: 'shadowed cursor-pointer text-brand-hover text-grey-4 flex align-center circle p2 bg-white transition-background transition-color',
	            onClick: onClick,
	            style: {
	                border: "1px solid #DCE1E4",
	                boxShadow: "0 2px 4px 0 #DCE1E4"
	            }
	        },
	        _react2.default.createElement(_Icon2.default, { name: direction + 'Arrow' })
	    );
	};
	
	DirectionalButton.displayName = 'DirectionalButton';
	exports.default = DirectionalButton;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _humanizePlus = __webpack_require__(874);
	
	var _humanizePlus2 = _interopRequireDefault(_humanizePlus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandableString = (_temp = _class = function (_Component) {
	    _inherits(ExpandableString, _Component);
	
	    function ExpandableString(props, context) {
	        _classCallCheck(this, ExpandableString);
	
	        var _this = _possibleConstructorReturn(this, (ExpandableString.__proto__ || Object.getPrototypeOf(ExpandableString)).call(this, props, context));
	
	        _this.toggleExpansion = _this.toggleExpansion.bind(_this);
	
	        _this.state = {
	            expanded: false
	        };
	        return _this;
	    }
	
	    _createClass(ExpandableString, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            this.setState({
	                expanded: newProps.expanded
	            });
	        }
	    }, {
	        key: "toggleExpansion",
	        value: function toggleExpansion() {
	            this.setState({
	                expanded: !this.state.expanded
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (!this.props.str) return false;
	
	            var truncated = _humanizePlus2.default.truncate(this.props.str || "", 140);
	
	            if (this.state.expanded) {
	                return _react2.default.createElement(
	                    "span",
	                    null,
	                    this.props.str,
	                    " ",
	                    _react2.default.createElement(
	                        "span",
	                        { className: "block mt1 link", onClick: this.toggleExpansion },
	                        "View less"
	                    )
	                );
	            } else if (truncated !== this.props.str) {
	                return _react2.default.createElement(
	                    "span",
	                    null,
	                    truncated,
	                    " ",
	                    _react2.default.createElement(
	                        "span",
	                        { className: "block mt1 link", onClick: this.toggleExpansion },
	                        "View more"
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    "span",
	                    null,
	                    this.props.str
	                );
	            }
	        }
	    }]);
	
	    return ExpandableString;
	}(_react.Component), _class.defaultProps = {
	    length: 140,
	    expanded: false
	}, _temp);
	ExpandableString.displayName = "ExpandableString";
	exports.default = ExpandableString;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DownloadButton = __webpack_require__(1501);
	
	var _DownloadButton2 = _interopRequireDefault(_DownloadButton);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _FieldSet = __webpack_require__(1006);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXPORT_FORMATS = ["csv", "xlsx", "json"];
	
	var QueryDownloadWidget = function QueryDownloadWidget(_ref) {
	    var className = _ref.className,
	        card = _ref.card,
	        result = _ref.result,
	        uuid = _ref.uuid,
	        token = _ref.token;
	    return _react2.default.createElement(
	        _PopoverWithTrigger2.default,
	        {
	            triggerElement: _react2.default.createElement(
	                _Tooltip2.default,
	                { tooltip: "Download full results" },
	                _react2.default.createElement(_Icon2.default, { title: "Download this data", name: "downarrow", size: 16 })
	            ),
	            triggerClasses: (0, _classnames2.default)(className, "text-brand-hover")
	        },
	        _react2.default.createElement(
	            "div",
	            { className: "p2", style: { maxWidth: 320 } },
	            _react2.default.createElement(
	                "h4",
	                null,
	                "Download full results"
	            ),
	            result.data.rows_truncated != null && _react2.default.createElement(
	                _FieldSet2.default,
	                { className: "my2 text-gold border-gold", legend: "Warning" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "my1" },
	                    "Your answer has a large number of rows so it could take awhile to download."
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    "The maximum download size is 1 million rows."
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "flex flex-row mt2" },
	                EXPORT_FORMATS.map(function (type) {
	                    return uuid ? _react2.default.createElement(PublicQueryButton, { key: type, type: type, uuid: uuid, className: "mr1 text-uppercase text-default" }) : token ? _react2.default.createElement(EmbedQueryButton, { key: type, type: type, token: token, className: "mr1 text-uppercase text-default" }) : card && card.id ? _react2.default.createElement(SavedQueryButton, { key: type, type: type, card: card, result: result, className: "mr1 text-uppercase text-default" }) : card && !card.id ? _react2.default.createElement(UnsavedQueryButton, { key: type, type: type, card: card, result: result, className: "mr1 text-uppercase text-default" }) : null;
	                })
	            )
	        )
	    );
	};
	
	QueryDownloadWidget.displayName = "QueryDownloadWidget";
	var UnsavedQueryButton = function UnsavedQueryButton(_ref2) {
	    var className = _ref2.className,
	        type = _ref2.type,
	        json_query = _ref2.result.json_query,
	        card = _ref2.card;
	    return _react2.default.createElement(
	        _DownloadButton2.default,
	        {
	            className: className,
	            url: "api/dataset/" + type,
	            params: { query: JSON.stringify(_underscore2.default.omit(json_query, "constraints")) },
	            extensions: [type]
	        },
	        type
	    );
	};
	
	UnsavedQueryButton.displayName = "UnsavedQueryButton";
	var SavedQueryButton = function SavedQueryButton(_ref3) {
	    var className = _ref3.className,
	        type = _ref3.type,
	        json_query = _ref3.result.json_query,
	        card = _ref3.card;
	    return _react2.default.createElement(
	        _DownloadButton2.default,
	        {
	            className: className,
	            url: "api/card/" + card.id + "/query/" + type,
	            params: { parameters: JSON.stringify(json_query.parameters) },
	            extensions: [type]
	        },
	        type
	    );
	};
	
	SavedQueryButton.displayName = "SavedQueryButton";
	var PublicQueryButton = function PublicQueryButton(_ref4) {
	    var className = _ref4.className,
	        type = _ref4.type,
	        uuid = _ref4.uuid;
	    return _react2.default.createElement(
	        _DownloadButton2.default,
	        {
	            className: className,
	            method: "GET",
	            url: Urls.publicCard(uuid, type),
	            extensions: [type]
	        },
	        type
	    );
	};
	
	PublicQueryButton.displayName = "PublicQueryButton";
	var EmbedQueryButton = function EmbedQueryButton(_ref5) {
	    var className = _ref5.className,
	        type = _ref5.type,
	        token = _ref5.token;
	    return _react2.default.createElement(
	        _DownloadButton2.default,
	        {
	            className: className,
	            method: "GET",
	            url: Urls.embedCard(token, type),
	            extensions: [type]
	        },
	        type
	    );
	};
	
	EmbedQueryButton.displayName = "EmbedQueryButton";
	QueryDownloadWidget.propTypes = {
	    className: _propTypes2.default.string,
	    card: _propTypes2.default.object,
	    result: _propTypes2.default.object,
	    uuid: _propTypes2.default.string
	};
	
	exports.default = QueryDownloadWidget;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DownloadButton = function DownloadButton(_ref) {
	    var className = _ref.className,
	        style = _ref.style,
	        children = _ref.children,
	        method = _ref.method,
	        url = _ref.url,
	        params = _ref.params,
	        extensions = _ref.extensions,
	        props = _objectWithoutProperties(_ref, ["className", "style", "children", "method", "url", "params", "extensions"]);
	
	    return _react2.default.createElement(
	        "form",
	        { className: className, style: style, method: method, action: url },
	        Object.entries(params).map(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                name = _ref3[0],
	                value = _ref3[1];
	
	            return _react2.default.createElement("input", { key: name, type: "hidden", name: name, value: value });
	        }),
	        _react2.default.createElement(
	            _Button2.default,
	            _extends({
	                onClick: function onClick(e) {
	                    if (window.OSX) {
	                        // prevent form from being submitted normally
	                        e.preventDefault();
	                        // download using the API provided by the OS X app
	                        window.OSX.download(method, url, params, extensions);
	                    }
	                }
	            }, props),
	            children
	        )
	    );
	};
	
	DownloadButton.displayName = "DownloadButton";
	DownloadButton.propTypes = {
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    url: _propTypes2.default.string.isRequired,
	    method: _propTypes2.default.string,
	    params: _propTypes2.default.object,
	    icon: _propTypes2.default.string,
	    extensions: _propTypes2.default.array
	};
	
	DownloadButton.defaultProps = {
	    icon: "downarrow",
	    method: "POST",
	    params: {},
	    extensions: []
	};
	
	exports.default = DownloadButton;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LoadingSpinner = __webpack_require__(1281);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingAndErrorWrapper = (_temp2 = _class = function (_Component) {
	    _inherits(LoadingAndErrorWrapper, _Component);
	
	    function LoadingAndErrorWrapper() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, LoadingAndErrorWrapper);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoadingAndErrorWrapper.__proto__ || Object.getPrototypeOf(LoadingAndErrorWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            messageIndex: 0,
	            sceneIndex: 0
	        }, _this.loadingInterval = function () {
	            if (_this.props.loading) {
	                _this.cycleLoadingMessage();
	            }
	        }, _this.cycleLoadingMessage = function () {
	            _this.setState({
	                messageIndex: _this.state.messageIndex + 1 < _this.props.loadingMessages.length ? _this.state.messageIndex + 1 : 0
	
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(LoadingAndErrorWrapper, [{
	        key: "getErrorMessage",
	        value: function getErrorMessage() {
	            var error = this.props.error;
	
	            return (
	                // NOTE Atte Keinänen 5/10/17 Dashboard API endpoint returns the error as JSON with `message` field
	                error.data && (error.data.message ? error.data.message : error.data) || error.statusText || error.message || "An error occured"
	            );
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _props = this.props,
	                loadingMessages = _props.loadingMessages,
	                messageInterval = _props.messageInterval;
	            // only start cycling if multiple messages are provided
	
	            if (loadingMessages.length > 1) {
	                this.cycle = setInterval(this.loadingInterval, messageInterval);
	            }
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            clearInterval(this.cycle);
	        }
	    }, {
	        key: "getChildren",
	        value: function getChildren() {
	            function resolveChild(child) {
	                if (Array.isArray(child)) {
	                    return child.map(resolveChild);
	                } else if (typeof child === "function") {
	                    return child();
	                } else {
	                    return child;
	                }
	            }
	            return resolveChild(this.props.children);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                loading = _props2.loading,
	                error = _props2.error,
	                noBackground = _props2.noBackground,
	                noWrapper = _props2.noWrapper,
	                showSpinner = _props2.showSpinner,
	                loadingMessages = _props2.loadingMessages,
	                loadingScenes = _props2.loadingScenes;
	            var _state = this.state,
	                messageIndex = _state.messageIndex,
	                sceneIndex = _state.sceneIndex;
	
	
	            var contentClassName = (0, _classnames2.default)("wrapper py4 text-brand text-centered flex-full flex flex-column layout-centered", { "bg-white": !noBackground });
	
	            if (noWrapper && !error && !loading) {
	                return _react2.default.Children.only(this.getChildren());
	            }
	            return _react2.default.createElement(
	                "div",
	                { className: this.props.className, style: this.props.style },
	                error ? _react2.default.createElement(
	                    "div",
	                    { className: contentClassName },
	                    _react2.default.createElement(
	                        "h2",
	                        { className: "text-normal text-grey-2 ie-wrap-content-fix" },
	                        this.getErrorMessage()
	                    )
	                ) : loading ? _react2.default.createElement(
	                    "div",
	                    { className: contentClassName },
	                    loadingScenes && loadingScenes[sceneIndex],
	                    !loadingScenes && showSpinner && _react2.default.createElement(_LoadingSpinner2.default, null),
	                    _react2.default.createElement(
	                        "h2",
	                        { className: "text-normal text-grey-2 mt1" },
	                        loadingMessages[messageIndex]
	                    )
	                ) : this.getChildren()
	            );
	        }
	    }]);
	
	    return LoadingAndErrorWrapper;
	}(_react.Component), _class.propTypes = {
	    className: _propTypes2.default.string,
	    error: _propTypes2.default.any,
	    loading: _propTypes2.default.any,
	    noBackground: _propTypes2.default.bool,
	    noWrapper: _propTypes2.default.bool,
	    children: _propTypes2.default.any,
	    style: _propTypes2.default.object,
	    showSpinner: _propTypes2.default.bool,
	    loadingMessages: _propTypes2.default.array,
	    messageInterval: _propTypes2.default.number,
	    loadingScenes: _propTypes2.default.array
	}, _class.defaultProps = {
	    className: "flex flex-full",
	    error: false,
	    loading: false,
	    noBackground: false,
	    noWrapper: false,
	    showSpinner: true,
	    loadingMessages: ['Loading...'],
	    messageInterval: 6000
	}, _temp2);
	LoadingAndErrorWrapper.displayName = "LoadingAndErrorWrapper";
	exports.default = LoadingAndErrorWrapper;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dom = __webpack_require__(859);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _DashboardGrid = __webpack_require__(1504);
	
	var _DashboardGrid2 = _interopRequireDefault(_DashboardGrid);
	
	var _DashboardControls = __webpack_require__(1525);
	
	var _DashboardControls2 = _interopRequireDefault(_DashboardControls);
	
	var _DashboardActions = __webpack_require__(1527);
	
	var _EmbedFrame = __webpack_require__(1187);
	
	var _EmbedFrame2 = _interopRequireDefault(_EmbedFrame);
	
	var _metadata = __webpack_require__(1110);
	
	var _app = __webpack_require__(864);
	
	var _selectors = __webpack_require__(1518);
	
	var _dashboard = __webpack_require__(1520);
	
	var dashboardActions = _interopRequireWildcard(_dashboard);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        dashboardId: props.params.dashboardId || props.params.uuid || props.params.token,
	        dashboard: (0, _selectors.getDashboardComplete)(state, props),
	        dashcardData: (0, _selectors.getCardData)(state, props),
	        slowCards: (0, _selectors.getSlowCards)(state, props),
	        parameters: (0, _selectors.getParameters)(state, props),
	        parameterValues: (0, _selectors.getParameterValues)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, dashboardActions, {
	    fetchDatabaseMetadata: _metadata.fetchDatabaseMetadata,
	    setErrorPage: _app.setErrorPage,
	    onChangeLocation: _reactRouterRedux.push
	});
	
	var PublicDashboard = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (0, _DashboardControls2.default)(_class = function (_Component) {
	    _inherits(PublicDashboard, _Component);
	
	    function PublicDashboard() {
	        _classCallCheck(this, PublicDashboard);
	
	        return _possibleConstructorReturn(this, (PublicDashboard.__proto__ || Object.getPrototypeOf(PublicDashboard)).apply(this, arguments));
	    }
	
	    _createClass(PublicDashboard, [{
	        key: "componentWillMount",
	
	
	        // $FlowFixMe
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var _props, initialize, fetchDashboard, fetchDashboardCardData, setErrorPage, location, _props$params, uuid, token;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _props = this.props, initialize = _props.initialize, fetchDashboard = _props.fetchDashboard, fetchDashboardCardData = _props.fetchDashboardCardData, setErrorPage = _props.setErrorPage, location = _props.location, _props$params = _props.params, uuid = _props$params.uuid, token = _props$params.token;
	
	                                initialize();
	                                _context.prev = 2;
	                                _context.next = 5;
	                                return fetchDashboard(uuid || token, location.query);
	
	                            case 5:
	                                _context.next = 7;
	                                return fetchDashboardCardData({ reload: false, clear: true });
	
	                            case 7:
	                                _context.next = 12;
	                                break;
	
	                            case 9:
	                                _context.prev = 9;
	                                _context.t0 = _context["catch"](2);
	
	                                setErrorPage(_context.t0);
	
	                            case 12:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[2, 9]]);
	            }));
	
	            function componentWillMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (!_underscore2.default.isEqual(this.props.parameterValues, nextProps.parameterValues)) {
	                this.props.fetchDashboardCardData({ reload: false, clear: true });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dashboard = _props2.dashboard,
	                parameters = _props2.parameters,
	                parameterValues = _props2.parameterValues,
	                isFullscreen = _props2.isFullscreen,
	                isNightMode = _props2.isNightMode;
	
	            var buttons = !_dom.IFRAMED ? (0, _DashboardActions.getDashboardActions)(this.props) : [];
	
	            return _react2.default.createElement(
	                _EmbedFrame2.default,
	                {
	                    name: dashboard && dashboard.name,
	                    description: dashboard && dashboard.description,
	                    parameters: parameters,
	                    parameterValues: parameterValues,
	                    setParameterValue: this.props.setParameterValue,
	                    actionButtons: buttons.length > 0 && _react2.default.createElement(
	                        "div",
	                        null,
	                        buttons.map(function (button, index) {
	                            return _react2.default.createElement(
	                                "span",
	                                { key: index, className: "m1" },
	                                button
	                            );
	                        })
	                    )
	                },
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { className: (0, _classnames2.default)("Dashboard p1 flex-full", { "Dashboard--fullscreen": isFullscreen, "Dashboard--night": isNightMode }), loading: !dashboard },
	                    function () {
	                        return _react2.default.createElement(_DashboardGrid2.default, _extends({}, _this2.props, {
	                            className: "spread"
	                            // Don't allow clicking titles on public dashboards
	                            , navigateToNewCardFromDashboard: null
	                        }));
	                    }
	                )
	            );
	        }
	    }]);
	
	    return PublicDashboard;
	}(_react.Component)) || _class) || _class);
	PublicDashboard.displayName = "PublicDashboard";
	exports.default = PublicDashboard;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GridLayout = __webpack_require__(1505);
	
	var _GridLayout2 = _interopRequireDefault(_GridLayout);
	
	var _DashCard = __webpack_require__(1511);
	
	var _DashCard2 = _interopRequireDefault(_DashCard);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ExplicitSize = __webpack_require__(1271);
	
	var _ExplicitSize2 = _interopRequireDefault(_ExplicitSize);
	
	var _RemoveFromDashboardModal = __webpack_require__(1523);
	
	var _RemoveFromDashboardModal2 = _interopRequireDefault(_RemoveFromDashboardModal);
	
	var _AddSeriesModal = __webpack_require__(1524);
	
	var _AddSeriesModal2 = _interopRequireDefault(_AddSeriesModal);
	
	var _visualizations = __webpack_require__(1284);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _dashboard_grid = __webpack_require__(1522);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MOBILE_ASPECT_RATIO = 3 / 2;
	
	var DashboardGrid = (0, _ExplicitSize2.default)(_class = (_temp = _class2 = function (_Component) {
	    _inherits(DashboardGrid, _Component);
	
	    function DashboardGrid(props, context) {
	        _classCallCheck(this, DashboardGrid);
	
	        var _this = _possibleConstructorReturn(this, (DashboardGrid.__proto__ || Object.getPrototypeOf(DashboardGrid)).call(this, props, context));
	
	        _this.state = {
	            layout: _this.getLayout(props),
	            dashcards: _this.getSortedDashcards(props),
	            removeModalDashCard: null,
	            addSeriesModalDashCard: null,
	            isDragging: false
	        };
	
	        _underscore2.default.bindAll(_this, "onDashCardMouseDown");
	        return _this;
	    }
	
	    _createClass(DashboardGrid, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({
	                dashcards: this.getSortedDashcards(nextProps),
	                layout: this.getLayout(nextProps)
	            });
	        }
	    }, {
	        key: "onLayoutChange",
	        value: function onLayoutChange(layout) {
	            var _this2 = this;
	
	            var changes = layout.filter(function (newLayout) {
	                return !_underscore2.default.isEqual(newLayout, _this2.getLayoutForDashCard(newLayout.dashcard));
	            });
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = changes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var change = _step.value;
	
	                    this.props.setDashCardAttributes({
	                        id: change.dashcard.id,
	                        attributes: { col: change.x, row: change.y, sizeX: change.w, sizeY: change.h }
	                    });
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            if (changes && changes.length > 0) {
	                _analytics2.default.trackEvent("Dashboard", "Layout Changed");
	            }
	        }
	    }, {
	        key: "getSortedDashcards",
	        value: function getSortedDashcards(props) {
	            return props.dashboard && props.dashboard.ordered_cards.sort(function (a, b) {
	                if (a.row < b.row) {
	                    return -1;
	                }
	                if (a.row > b.row) {
	                    return 1;
	                }
	                if (a.col < b.col) {
	                    return -1;
	                }
	                if (a.col > b.col) {
	                    return 1;
	                }
	                return 0;
	            });
	        }
	    }, {
	        key: "getLayoutForDashCard",
	        value: function getLayoutForDashCard(dashcard) {
	            var _getVisualizationRaw = (0, _visualizations.getVisualizationRaw)([{ card: dashcard.card }]),
	                CardVisualization = _getVisualizationRaw.CardVisualization;
	
	            var initialSize = _dashboard_grid.DEFAULT_CARD_SIZE;
	            var minSize = CardVisualization.minSize || _dashboard_grid.DEFAULT_CARD_SIZE;
	            return {
	                i: String(dashcard.id),
	                x: dashcard.col || 0,
	                y: dashcard.row || 0,
	                w: dashcard.sizeX || initialSize.width,
	                h: dashcard.sizeY || initialSize.height,
	                dashcard: dashcard,
	                minSize: minSize
	            };
	        }
	    }, {
	        key: "getLayout",
	        value: function getLayout(props) {
	            return props.dashboard.ordered_cards.map(this.getLayoutForDashCard);
	        }
	    }, {
	        key: "renderRemoveModal",
	        value: function renderRemoveModal() {
	            var _this3 = this;
	
	            // can't use PopoverWithTrigger due to strange interaction with ReactGridLayout
	            var isOpen = this.state.removeModalDashCard != null;
	            return _react2.default.createElement(
	                _Modal2.default,
	                { isOpen: isOpen },
	                isOpen && _react2.default.createElement(_RemoveFromDashboardModal2.default, {
	                    dashcard: this.state.removeModalDashCard,
	                    dashboard: this.props.dashboard,
	                    removeCardFromDashboard: this.props.removeCardFromDashboard,
	                    onClose: function onClose() {
	                        return _this3.setState({ removeModalDashCard: null });
	                    }
	                })
	            );
	        }
	    }, {
	        key: "renderAddSeriesModal",
	        value: function renderAddSeriesModal() {
	            var _this4 = this;
	
	            // can't use PopoverWithTrigger due to strange interaction with ReactGridLayout
	            var isOpen = this.state.addSeriesModalDashCard != null;
	            return _react2.default.createElement(
	                _Modal2.default,
	                { className: "Modal AddSeriesModal", isOpen: isOpen },
	                isOpen && _react2.default.createElement(_AddSeriesModal2.default, {
	                    dashcard: this.state.addSeriesModalDashCard,
	                    dashboard: this.props.dashboard,
	                    cards: this.props.cards,
	                    dashcardData: this.props.dashcardData,
	                    databases: this.props.databases,
	                    fetchCards: this.props.fetchCards,
	                    fetchCardData: this.props.fetchCardData,
	                    fetchDatabaseMetadata: this.props.fetchDatabaseMetadata,
	                    removeCardFromDashboard: this.props.removeCardFromDashboard,
	                    setDashCardAttributes: this.props.setDashCardAttributes,
	                    onClose: function onClose() {
	                        return _this4.setState({ addSeriesModalDashCard: null });
	                    }
	                })
	            );
	        }
	
	        // we need to track whether or not we're dragging so we can disable pointer events on action buttons :-/
	
	    }, {
	        key: "onDrag",
	        value: function onDrag() {
	            if (!this.state.isDragging) {
	                this.setState({ isDragging: true });
	            }
	        }
	    }, {
	        key: "onDragStop",
	        value: function onDragStop() {
	            this.setState({ isDragging: false });
	        }
	
	        // we use onMouseDownCapture to prevent dragging due to react-grid-layout bug referenced below
	
	    }, {
	        key: "onDashCardMouseDown",
	        value: function onDashCardMouseDown(e) {
	            if (!this.props.isEditing) {
	                e.stopPropagation();
	            }
	        }
	    }, {
	        key: "onDashCardRemove",
	        value: function onDashCardRemove(dc) {
	            this.setState({ removeModalDashCard: dc });
	        }
	    }, {
	        key: "onDashCardAddSeries",
	        value: function onDashCardAddSeries(dc) {
	            this.setState({ addSeriesModalDashCard: dc });
	        }
	    }, {
	        key: "renderDashCard",
	        value: function renderDashCard(dc, isMobile) {
	            return _react2.default.createElement(_DashCard2.default, {
	                dashcard: dc,
	                dashcardData: this.props.dashcardData,
	                parameterValues: this.props.parameterValues,
	                slowCards: this.props.slowCards,
	                fetchCardData: this.props.fetchCardData,
	                markNewCardSeen: this.props.markNewCardSeen,
	                isEditing: this.props.isEditing,
	                isEditingParameter: this.props.isEditingParameter,
	                isFullscreen: this.props.isFullscreen,
	                isMobile: isMobile,
	                onRemove: this.onDashCardRemove.bind(this, dc),
	                onAddSeries: this.onDashCardAddSeries.bind(this, dc),
	                onUpdateVisualizationSettings: this.props.onUpdateDashCardVisualizationSettings.bind(this, dc.id),
	                onReplaceAllVisualizationSettings: this.props.onReplaceAllDashCardVisualizationSettings.bind(this, dc.id),
	                navigateToNewCardFromDashboard: this.props.navigateToNewCardFromDashboard,
	                metadata: this.props.metadata
	            });
	        }
	    }, {
	        key: "renderMobile",
	        value: function renderMobile() {
	            var _this5 = this;
	
	            var _props = this.props,
	                isEditing = _props.isEditing,
	                isEditingParameter = _props.isEditingParameter,
	                width = _props.width;
	            var dashcards = this.state.dashcards;
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)("DashboardGrid", { "Dash--editing": isEditing, "Dash--editingParameter": isEditingParameter, "Dash--dragging": this.state.isDragging }),
	                    style: { margin: 0 }
	                },
	                dashcards && dashcards.map(function (dc) {
	                    return _react2.default.createElement(
	                        "div",
	                        { key: dc.id, className: "DashCard", style: { width: width, marginTop: 10, marginBottom: 10, height: width / MOBILE_ASPECT_RATIO } },
	                        _this5.renderDashCard(dc, true)
	                    );
	                })
	            );
	        }
	    }, {
	        key: "renderGrid",
	        value: function renderGrid() {
	            var _this6 = this;
	
	            var _props2 = this.props,
	                dashboard = _props2.dashboard,
	                isEditing = _props2.isEditing,
	                isEditingParameter = _props2.isEditingParameter,
	                width = _props2.width;
	
	            var rowHeight = Math.floor(width / _dashboard_grid.GRID_WIDTH / _dashboard_grid.GRID_ASPECT_RATIO);
	            return _react2.default.createElement(
	                _GridLayout2.default,
	                {
	                    className: (0, _classnames2.default)("DashboardGrid", { "Dash--editing": isEditing, "Dash--editingParameter": isEditingParameter, "Dash--dragging": this.state.isDragging }),
	                    layout: this.state.layout,
	                    cols: _dashboard_grid.GRID_WIDTH,
	                    margin: _dashboard_grid.GRID_MARGIN,
	                    rowHeight: rowHeight,
	                    onLayoutChange: function onLayoutChange() {
	                        return _this6.onLayoutChange.apply(_this6, arguments);
	                    },
	                    onDrag: function onDrag() {
	                        return _this6.onDrag.apply(_this6, arguments);
	                    },
	                    onDragStop: function onDragStop() {
	                        return _this6.onDragStop.apply(_this6, arguments);
	                    },
	                    isEditing: isEditing
	                },
	                dashboard && dashboard.ordered_cards.map(function (dc) {
	                    return _react2.default.createElement(
	                        "div",
	                        { key: dc.id, className: "DashCard", onMouseDownCapture: _this6.onDashCardMouseDown, onTouchStartCapture: _this6.onDashCardMouseDown },
	                        _this6.renderDashCard(dc, false)
	                    );
	                })
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var width = this.props.width;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex layout-centered" },
	                width === 0 ? _react2.default.createElement("div", null) : width <= 752 ? this.renderMobile() : this.renderGrid(),
	                this.renderRemoveModal(),
	                this.renderAddSeriesModal()
	            );
	        }
	    }]);
	
	    return DashboardGrid;
	}(_react.Component), _class2.propTypes = {
	    isEditing: _propTypes2.default.bool.isRequired,
	    isEditingParameter: _propTypes2.default.bool.isRequired,
	    dashboard: _propTypes2.default.object.isRequired,
	    parameterValues: _propTypes2.default.object.isRequired,
	    cards: _propTypes2.default.array,
	
	    setDashCardAttributes: _propTypes2.default.func.isRequired,
	    removeCardFromDashboard: _propTypes2.default.func.isRequired,
	    markNewCardSeen: _propTypes2.default.func.isRequired,
	    fetchCardData: _propTypes2.default.func.isRequired,
	
	    onUpdateDashCardVisualizationSettings: _propTypes2.default.func.isRequired,
	    onReplaceAllDashCardVisualizationSettings: _propTypes2.default.func.isRequired,
	
	    onChangeLocation: _propTypes2.default.func.isRequired
	}, _class2.defaultProps = {
	    width: 0,
	    isEditing: false,
	    isEditingParameter: false
	}, _temp)) || _class;
	
	DashboardGrid.displayName = "DashboardGrid";
	exports.default = DashboardGrid;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _GridItem = __webpack_require__(1506);
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GridLayout = function (_Component) {
	    _inherits(GridLayout, _Component);
	
	    function GridLayout(props, context) {
	        _classCallCheck(this, GridLayout);
	
	        var _this = _possibleConstructorReturn(this, (GridLayout.__proto__ || Object.getPrototypeOf(GridLayout)).call(this, props, context));
	
	        _this.state = {
	            width: 0,
	            layout: props.layout,
	            dragging: false,
	            resizing: false,
	            placeholderLayout: null
	        };
	
	        _underscore2.default.bindAll(_this, "onDrag", "onDragStart", "onDragStop", "onResize", "onResizeStart", "onResizeStop");
	        return _this;
	    }
	
	    _createClass(GridLayout, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            var _state = this.state,
	                dragging = _state.dragging,
	                resizing = _state.resizing;
	
	            if (!dragging && !resizing && this.state.layout !== newProps.layout) {
	                this.setState({ layout: newProps.layout });
	            }
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.componentDidUpdate();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var width = _reactDom2.default.findDOMNode(this).parentNode.offsetWidth;
	            if (this.state.width !== width) {
	                this.setState({ width: width });
	            }
	        }
	    }, {
	        key: "onDragStart",
	        value: function onDragStart(i, _ref) {
	            // this.setState({ dragging: true })
	
	            var position = _ref.position;
	        }
	    }, {
	        key: "layoutsOverlap",
	        value: function layoutsOverlap(a, b) {
	            return a.x < b.x + b.w && b.x < a.x + a.w && a.y < b.y + b.h && b.y < a.y + a.h;
	        }
	    }, {
	        key: "onDrag",
	        value: function onDrag(i, _ref2) {
	            var position = _ref2.position;
	
	            var placeholderLayout = _extends({}, this.computeDraggedLayout(i, position), {
	                i: "placeholder"
	            });
	            this.setState({ dragging: true, placeholderLayout: placeholderLayout });
	            this.props.onDrag();
	        }
	    }, {
	        key: "onDragStop",
	        value: function onDragStop(i, _ref3) {
	            var position = _ref3.position;
	            var placeholderLayout = this.state.placeholderLayout;
	
	            var newLayout = void 0;
	            if (placeholderLayout) {
	                var x = placeholderLayout.x,
	                    y = placeholderLayout.y,
	                    w = placeholderLayout.w,
	                    h = placeholderLayout.h;
	
	                newLayout = this.state.layout.map(function (l) {
	                    return l.i === i ? _extends({}, l, { x: x, y: y, w: w, h: h }) : l;
	                });
	            }
	            this.setState({ dragging: false, placeholderLayout: null });
	            if (newLayout) {
	                this.props.onLayoutChange(newLayout);
	            }
	            this.props.onDragStop();
	        }
	    }, {
	        key: "computeDraggedLayout",
	        value: function computeDraggedLayout(i, position) {
	            var cellSize = this.getCellSize();
	            var originalLayout = this.getLayoutForItem(i);
	            var pos = this.getStyleForLayout(originalLayout);
	            pos.top += position.y;
	            pos.left += position.x;
	
	            var maxX = this.props.cols - originalLayout.w;
	            var maxY = Infinity;
	
	            var targetLayout = {
	                w: originalLayout.w,
	                h: originalLayout.h,
	                x: Math.min(maxX, Math.max(0, Math.round(pos.left / cellSize.width))),
	                y: Math.min(maxY, Math.max(0, Math.round(pos.top / cellSize.height)))
	            };
	            var proposedLayout = targetLayout;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = this.state.layout[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var otherLayout = _step.value;
	
	                    if (originalLayout !== otherLayout && this.layoutsOverlap(proposedLayout, otherLayout)) {
	                        return this.state.placeholderLayout || originalLayout;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return proposedLayout;
	        }
	    }, {
	        key: "onResizeStart",
	        value: function onResizeStart(i, _ref4) {
	            var size = _ref4.size;
	
	            this.setState({ resizing: true });
	        }
	    }, {
	        key: "onResize",
	        value: function onResize(i, _ref5) {
	            var size = _ref5.size;
	
	            var placeholderLayout = _extends({}, this.computeResizedLayout(i, size), {
	                i: "placeholder"
	            });
	            this.setState({ placeholderLayout: placeholderLayout });
	        }
	    }, {
	        key: "onResizeStop",
	        value: function onResizeStop(i, _ref6) {
	            var _this2 = this;
	
	            var size = _ref6.size;
	            var _state$placeholderLay = this.state.placeholderLayout,
	                x = _state$placeholderLay.x,
	                y = _state$placeholderLay.y,
	                w = _state$placeholderLay.w,
	                h = _state$placeholderLay.h;
	
	            var newLayout = this.state.layout.map(function (l) {
	                return l.i === i ? _extends({}, l, { x: x, y: y, w: w, h: h }) : l;
	            });
	            this.setState({ resizing: false, placeholderLayout: null }, function () {
	                return _this2.props.onLayoutChange(newLayout);
	            });
	        }
	    }, {
	        key: "computeResizedLayout",
	        value: function computeResizedLayout(i, size) {
	            var cellSize = this.getCellSize();
	            var originalLayout = this.getLayoutForItem(i);
	
	            var minW = originalLayout.minSize.width;
	            var minH = originalLayout.minSize.height;
	            var maxW = this.props.cols - originalLayout.x;
	            var maxH = Infinity;
	            var targetLayout = {
	                w: Math.min(maxW, Math.max(minW, Math.round(size.width / cellSize.width))),
	                h: Math.min(maxH, Math.max(minH, Math.round(size.height / cellSize.height))),
	                x: originalLayout.x,
	                y: originalLayout.y
	            };
	
	            var proposedLayout = targetLayout;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = this.state.layout[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var otherLayout = _step2.value;
	
	                    if (originalLayout !== otherLayout && this.layoutsOverlap(proposedLayout, otherLayout)) {
	                        return this.state.placeholderLayout || originalLayout;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            return proposedLayout;
	        }
	    }, {
	        key: "getLayoutForItem",
	        value: function getLayoutForItem(i) {
	            return _underscore2.default.findWhere(this.state.layout, { i: i });
	        }
	    }, {
	        key: "getCellSize",
	        value: function getCellSize() {
	            var margin = this.props.margin;
	            // add 1 margin to make it fill the full width
	
	            return {
	                width: (this.state.width + margin) / this.props.cols,
	                height: this.props.rowHeight
	            };
	        }
	    }, {
	        key: "getMinSizeForLayout",
	        value: function getMinSizeForLayout(l) {
	            var margin = this.props.margin;
	
	            var cellSize = this.getCellSize();
	            return {
	                width: cellSize.width * l.minSize.width - margin,
	                height: cellSize.height * l.minSize.height - margin
	            };
	        }
	    }, {
	        key: "getStyleForLayout",
	        value: function getStyleForLayout(l) {
	            var margin = this.props.margin;
	
	            var cellSize = this.getCellSize();
	            return {
	                width: cellSize.width * l.w - margin,
	                height: cellSize.height * l.h - margin,
	                left: cellSize.width * l.x + margin / 2,
	                top: cellSize.height * l.y + margin / 2
	            };
	        }
	    }, {
	        key: "renderChild",
	        value: function renderChild(child) {
	            var l = this.getLayoutForItem(child.key);
	            var style = this.getStyleForLayout(l);
	            return _react2.default.createElement(
	                _GridItem2.default,
	                _extends({}, l, style, {
	                    key: l.i,
	                    onDragStart: this.onDragStart,
	                    onDrag: this.onDrag,
	                    onDragStop: this.onDragStop,
	                    onResizeStart: this.onResizeStart,
	                    onResize: this.onResize,
	                    onResizeStop: this.onResizeStop,
	                    minSize: this.getMinSizeForLayout(l)
	                }),
	                child
	            );
	        }
	    }, {
	        key: "renderPlaceholder",
	        value: function renderPlaceholder() {
	            if (this.state.placeholderLayout) {
	                var style = _extends({}, this.getStyleForLayout(this.state.placeholderLayout));
	                return _react2.default.createElement("div", { className: "react-grid-placeholder absolute", style: style });
	            }
	        }
	    }, {
	        key: "getGridBackground",
	        value: function getGridBackground() {
	            var _props = this.props,
	                margin = _props.margin,
	                cols = _props.cols;
	
	            var cellSize = this.getCellSize();
	            return "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='" + cellSize.width * cols + "' height='" + cellSize.height + "'>" + (0, _underscore2.default)(cols).times(function (i) {
	                return "<rect stroke='rgba(0, 0, 0, 0.117647)' stroke-width='1' fill='none' x='" + (Math.round(margin / 2 + i * cellSize.width) + 1.5) + "' y='" + (margin / 2 + 1.5) + "' width='" + Math.round(cellSize.width - margin - 3) + "' height='" + (cellSize.height - margin - 3) + "'/>";
	            }).join("") + "</svg>\")";
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                className = _props2.className,
	                layout = _props2.layout,
	                cols = _props2.cols,
	                margin = _props2.margin,
	                isEditing = _props2.isEditing;
	
	
	            var cellSize = this.getCellSize();
	            var bottom = Math.max.apply(Math, _toConsumableArray(layout.map(function (l) {
	                return l.y + l.h;
	            })));
	
	            var backgroundImage = void 0;
	            if (isEditing) {
	                // render grid as a background image:
	                backgroundImage = this.getGridBackground();
	                // add one vertical screen worth of rows to ensure the grid fills the screen
	                bottom += Math.ceil(window.innerHeight / cellSize.height);
	            }
	
	            var width = cellSize.width * cols;
	            var height = cellSize.height * bottom;
	
	            // subtract half of a margin to ensure it lines up with the edges
	            return _react2.default.createElement(
	                "div",
	                { className: className, style: { position: "relative", width: width, height: height, backgroundImage: backgroundImage, marginLeft: -margin / 2, marginRight: -margin / 2 } },
	                this.props.children.map(function (child) {
	                    return _this3.renderChild(child);
	                }),
	                this.renderPlaceholder()
	            );
	        }
	    }]);
	
	    return GridLayout;
	}(_react.Component);
	
	GridLayout.displayName = "GridLayout";
	exports.default = GridLayout;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(1361);
	
	var _reactResizable = __webpack_require__(1507);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GridItem = function (_Component) {
	    _inherits(GridItem, _Component);
	
	    function GridItem(props, context) {
	        _classCallCheck(this, GridItem);
	
	        var _this = _possibleConstructorReturn(this, (GridItem.__proto__ || Object.getPrototypeOf(GridItem)).call(this, props, context));
	
	        _this.state = {
	            dragging: null,
	            resizing: null
	        };
	        return _this;
	    }
	
	    _createClass(GridItem, [{
	        key: "onDragHandler",
	        value: function onDragHandler(handlerName) {
	            var _this2 = this;
	
	            return function (e, _ref) {
	                var node = _ref.node,
	                    x = _ref.x,
	                    y = _ref.y;
	
	                // react-draggle seems to return undefined/NaN occasionally, which breaks things
	                if (isNaN(x) || isNaN(y)) {
	                    return;
	                }
	
	                var _state = _this2.state,
	                    dragStartPosition = _state.dragStartPosition,
	                    dragStartScrollTop = _state.dragStartScrollTop;
	
	                if (handlerName === "onDragStart") {
	                    dragStartPosition = { x: x, y: y };
	                    dragStartScrollTop = document.body.scrollTop;
	                    _this2.setState({ dragStartPosition: dragStartPosition, dragStartScrollTop: dragStartScrollTop });
	                }
	
	                // track vertical scroll. we don't need horizontal  allow horizontal scrolling
	                var scrollTopDelta = document.body.scrollTop - dragStartScrollTop;
	                // compute new position
	                var pos = {
	                    x: x - dragStartPosition.x,
	                    y: y - dragStartPosition.y + scrollTopDelta
	                };
	
	                if (handlerName === "onDragStop") {
	                    _this2.setState({ dragging: null });
	                } else {
	                    _this2.setState({ dragging: pos });
	                }
	
	                _this2.props[handlerName](_this2.props.i, { e: e, node: node, position: pos });
	            };
	        }
	    }, {
	        key: "onResizeHandler",
	        value: function onResizeHandler(handlerName) {
	            var _this3 = this;
	
	            return function (e, _ref2) {
	                var element = _ref2.element,
	                    size = _ref2.size;
	
	
	                if (handlerName === "onResize") {
	                    _this3.setState({ resizing: size });
	                }if (handlerName === "onResizeStop") {
	                    _this3.setState({ resizing: null });
	                }
	
	                _this3.props[handlerName](_this3.props.i, { e: e, element: element, size: size });
	            };
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                width = _props.width,
	                height = _props.height,
	                top = _props.top,
	                left = _props.left,
	                minSize = _props.minSize;
	
	
	            if (this.state.dragging) {
	                left += this.state.dragging.x;
	                top += this.state.dragging.y;
	            }
	
	            if (this.state.resizing) {
	                width = Math.max(minSize.width, this.state.resizing.width);
	                height = Math.max(minSize.height, this.state.resizing.height);
	            }
	
	            var style = {
	                width: width, height: height, top: top, left: left,
	                position: "absolute"
	            };
	
	            var child = _react2.default.Children.only(this.props.children);
	            return _react2.default.createElement(
	                _reactDraggable.DraggableCore,
	                {
	                    cancel: ".react-resizable-handle",
	                    onStart: this.onDragHandler("onDragStart"),
	                    onDrag: this.onDragHandler("onDrag"),
	                    onStop: this.onDragHandler("onDragStop")
	                },
	                _react2.default.createElement(
	                    _reactResizable.Resizable,
	                    {
	                        width: width,
	                        height: height,
	                        onResizeStart: this.onResizeHandler("onResizeStart"),
	                        onResize: this.onResizeHandler("onResize"),
	                        onResizeStop: this.onResizeHandler("onResizeStop")
	                    },
	                    _react2.default.cloneElement(child, {
	                        style: style,
	                        className: (0, _classnames2.default)(child.props.className, { dragging: !!this.state.dragging, resizing: !!this.state.resizing })
	                    })
	                )
	            );
	        }
	    }]);
	
	    return GridItem;
	}(_react.Component);
	
	GridItem.displayName = "GridItem";
	exports.default = GridItem;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = function() {
	  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
	};
	
	module.exports.Resizable = __webpack_require__(1508).default;
	module.exports.ResizableBox = __webpack_require__(1510).default;


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(1361);
	
	var _cloneElement = __webpack_require__(1509);
	
	var _cloneElement2 = _interopRequireDefault(_cloneElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*:: export type Props = {
	  children: React.Element<any>,
	  width: number,
	  height: number,
	  handleSize: [number, number],
	  lockAspectRatio: boolean,
	  axis: Axis,
	  minConstraints: [number, number],
	  maxConstraints: [number, number],
	  onResizeStop?: ?(e: SyntheticEvent, data: ResizeCallbackData) => any,
	  onResizeStart?: ?(e: SyntheticEvent, data: ResizeCallbackData) => any,
	  onResize?: ?(e: SyntheticEvent, data: ResizeCallbackData) => any,
	  draggableOpts?: ?Object
	};*/
	/*:: type Axis = 'both' | 'x' | 'y' | 'none';*/
	/*:: type Position = {
	
	};*/
	/*:: type State = {
	  resizing: boolean,
	  width: number, height: number,
	  slackW: number, slackH: number
	};*/
	/*:: type DragCallbackData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number
	};*/
	/*:: type ResizeCallbackData = {
	  node: HTMLElement,
	  size: {width: number, height: number}
	};*/
	
	var Resizable = function (_React$Component) {
	  _inherits(Resizable, _React$Component);
	
	  function Resizable() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Resizable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      resizing: false,
	      width: _this.props.width, height: _this.props.height,
	      slackW: 0, slackH: 0
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Resizable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps /*: Object*/) {
	    // If parent changes height/width, set that in our state.
	    if (!this.state.resizing && (nextProps.width !== this.props.width || nextProps.height !== this.props.height)) {
	      this.setState({
	        width: nextProps.width,
	        height: nextProps.height
	      });
	    }
	  };
	
	  Resizable.prototype.lockAspectRatio = function lockAspectRatio(width /*: number*/, height /*: number*/, aspectRatio /*: number*/) /*: [number, number]*/ {
	    height = width / aspectRatio;
	    width = height * aspectRatio;
	    return [width, height];
	  };
	
	  // If you do this, be careful of constraints
	
	
	  Resizable.prototype.runConstraints = function runConstraints(width /*: number*/, height /*: number*/) /*: [number, number]*/ {
	    var _ref = [this.props.minConstraints, this.props.maxConstraints],
	        min = _ref[0],
	        max = _ref[1];
	
	
	    if (this.props.lockAspectRatio) {
	      var ratio = this.state.width / this.state.height;
	      height = width / ratio;
	      width = height * ratio;
	    }
	
	    if (!min && !max) return [width, height];
	
	    var oldW = width,
	        oldH = height;
	
	    // Add slack to the values used to calculate bound position. This will ensure that if
	    // we start removing slack, the element won't react to it right away until it's been
	    // completely removed.
	
	    var _state = this.state,
	        slackW = _state.slackW,
	        slackH = _state.slackH;
	
	    width += slackW;
	    height += slackH;
	
	    if (min) {
	      width = Math.max(min[0], width);
	      height = Math.max(min[1], height);
	    }
	    if (max) {
	      width = Math.min(max[0], width);
	      height = Math.min(max[1], height);
	    }
	
	    // If the numbers changed, we must have introduced some slack. Record it for the next iteration.
	    slackW += oldW - width;
	    slackH += oldH - height;
	    if (slackW !== this.state.slackW || slackH !== this.state.slackH) {
	      this.setState({ slackW: slackW, slackH: slackH });
	    }
	
	    return [width, height];
	  };
	
	  /**
	   * Wrapper around drag events to provide more useful data.
	   *
	   * @param  {String} handlerName Handler name to wrap.
	   * @return {Function}           Handler function.
	   */
	
	
	  Resizable.prototype.resizeHandler = function resizeHandler(handlerName /*: string*/) /*: Function*/ {
	    var _this2 = this;
	
	    return function (e /*: SyntheticEvent | MouseEvent*/, _ref2) {
	      var node = _ref2.node,
	          deltaX = _ref2.deltaX,
	          deltaY = _ref2.deltaY;
	
	
	      // Axis restrictions
	      var canDragX = _this2.props.axis === 'both' || _this2.props.axis === 'x';
	      var canDragY = _this2.props.axis === 'both' || _this2.props.axis === 'y';
	
	      // Update w/h
	      var width = _this2.state.width + (canDragX ? deltaX : 0);
	      var height = _this2.state.height + (canDragY ? deltaY : 0);
	
	      // Early return if no change
	      var widthChanged = width !== _this2.state.width,
	          heightChanged = height !== _this2.state.height;
	      if (handlerName === 'onResize' && !widthChanged && !heightChanged) return;
	
	      // Set the appropriate state for this handler.
	      var _runConstraints = _this2.runConstraints(width, height);
	
	      width = _runConstraints[0];
	      height = _runConstraints[1];
	      var newState = {};
	      if (handlerName === 'onResizeStart') {
	        newState.resizing = true;
	      } else if (handlerName === 'onResizeStop') {
	        newState.resizing = false;
	        newState.slackW = newState.slackH = 0;
	      } else {
	        // Early return if no change after constraints
	        if (width === _this2.state.width && height === _this2.state.height) return;
	        newState.width = width;
	        newState.height = height;
	      }
	
	      var hasCb = typeof _this2.props[handlerName] === 'function';
	      if (hasCb) {
	        if (typeof e.persist === 'function') e.persist();
	        _this2.setState(newState, function () {
	          return _this2.props[handlerName](e, { node: node, size: { width: width, height: height } });
	        });
	      } else {
	        _this2.setState(newState);
	      }
	    };
	  };
	
	  Resizable.prototype.render = function render() /*: React.Element<any>*/ {
	    // eslint-disable-next-line no-unused-vars
	    var _props = this.props,
	        children = _props.children,
	        draggableOpts = _props.draggableOpts,
	        width = _props.width,
	        height = _props.height,
	        handleSize = _props.handleSize,
	        lockAspectRatio = _props.lockAspectRatio,
	        axis = _props.axis,
	        minConstraints = _props.minConstraints,
	        maxConstraints = _props.maxConstraints,
	        onResize = _props.onResize,
	        onResizeStop = _props.onResizeStop,
	        onResizeStart = _props.onResizeStart,
	        p = _objectWithoutProperties(_props, ['children', 'draggableOpts', 'width', 'height', 'handleSize', 'lockAspectRatio', 'axis', 'minConstraints', 'maxConstraints', 'onResize', 'onResizeStop', 'onResizeStart']);
	
	    var className = p.className ? p.className + ' react-resizable' : 'react-resizable';
	
	    // What we're doing here is getting the child of this element, and cloning it with this element's props.
	    // We are then defining its children as:
	    // Its original children (resizable's child's children), and
	    // A draggable handle.
	    return (0, _cloneElement2.default)(children, _extends({}, p, {
	      className: className,
	      children: [children.props.children, _react2.default.createElement(
	        _reactDraggable.DraggableCore,
	        _extends({}, draggableOpts, {
	          key: 'resizableHandle',
	          onStop: this.resizeHandler('onResizeStop'),
	          onStart: this.resizeHandler('onResizeStart'),
	          onDrag: this.resizeHandler('onResize')
	        }),
	        _react2.default.createElement('span', { className: 'react-resizable-handle' })
	      )]
	    }));
	  };
	
	  return Resizable;
	}(_react2.default.Component);
	
	Resizable.propTypes = {
	  //
	  // Required Props
	  //
	
	  // Require that one and only one child be present.
	  children: _react.PropTypes.element.isRequired,
	
	  // Initial w/h
	  width: _react.PropTypes.number.isRequired,
	  height: _react.PropTypes.number.isRequired,
	
	  //
	  // Optional props
	  //
	
	  // If you change this, be sure to update your css
	  handleSize: _react.PropTypes.array,
	
	  // If true, will only allow width/height to move in lockstep
	  lockAspectRatio: _react.PropTypes.bool,
	
	  // Restricts resizing to a particular axis (default: 'both')
	  // 'both' - allows resizing by width or height
	  // 'x' - only allows the width to be changed
	  // 'y' - only allows the height to be changed
	  // 'none' - disables resizing altogether
	  axis: _react.PropTypes.oneOf(['both', 'x', 'y', 'none']),
	
	  // Min/max size
	  minConstraints: _react.PropTypes.arrayOf(_react.PropTypes.number),
	  maxConstraints: _react.PropTypes.arrayOf(_react.PropTypes.number),
	
	  // Callbacks
	  onResizeStop: _react.PropTypes.func,
	  onResizeStart: _react.PropTypes.func,
	  onResize: _react.PropTypes.func,
	
	  // These will be passed wholesale to react-draggable's DraggableCore
	  draggableOpts: _react.PropTypes.object
	};
	Resizable.defaultProps = {
	  handleSize: [20, 20],
	  lockAspectRatio: false,
	  axis: 'both',
	  minConstraints: [20, 20],
	  maxConstraints: [Infinity, Infinity]
	};
	exports.default = Resizable;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// React.addons.cloneWithProps look-alike that merges style & className.
	module.exports = function cloneElement(element /*: React.Element<any>*/, props /*: Object*/) /*: React.Element<any>*/ {
	  if (props.style && element.props.style) {
	    props.style = _extends({}, element.props.style, props.style);
	  }
	  if (props.className && element.props.className) {
	    props.className = element.props.className + ' ' + props.className;
	  }
	  return _react2.default.cloneElement(element, props);
	};

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Resizable = __webpack_require__(1508);
	
	var _Resizable2 = _interopRequireDefault(_Resizable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*:: import type {Props as ResizableProps} from './Resizable';*/
	/*:: type State = {width: number, height: number};*/
	/*:: type Size = {width: number, height: number};*/
	
	
	// An example use of Resizable.
	/*:: type ResizeData = {element: Element, size: Size};*/
	
	var ResizableBox = function (_React$Component) {
	  _inherits(ResizableBox, _React$Component);
	
	  function ResizableBox() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResizableBox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      width: _this.props.width,
	      height: _this.props.height
	    }, _this.onResize = function (e /*: Event*/, _ref) {
	      var element = _ref.element,
	          size = _ref.size;
	      var width = size.width,
	          height = size.height;
	
	
	      if (_this.props.onResize) {
	        e.persist && e.persist();
	        _this.setState(size, function () {
	          return _this.props.onResize(e, { element: element, size: size });
	        });
	      } else {
	        _this.setState(size);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ResizableBox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps /*: ResizableProps*/) {
	    if (nextProps.width !== this.props.width || nextProps.height !== this.props.height) {
	      this.setState({
	        width: nextProps.width,
	        height: nextProps.height
	      });
	    }
	  };
	
	  ResizableBox.prototype.render = function render() /*: React.Element<any>*/ {
	    // Basic wrapper around a Resizable instance.
	    // If you use Resizable directly, you are responsible for updating the child component
	    // with a new width and height.
	    var _props = this.props,
	        handleSize = _props.handleSize,
	        onResize = _props.onResize,
	        onResizeStart = _props.onResizeStart,
	        onResizeStop = _props.onResizeStop,
	        draggableOpts = _props.draggableOpts,
	        minConstraints = _props.minConstraints,
	        maxConstraints = _props.maxConstraints,
	        lockAspectRatio = _props.lockAspectRatio,
	        axis = _props.axis,
	        width = _props.width,
	        height = _props.height,
	        props = _objectWithoutProperties(_props, ['handleSize', 'onResize', 'onResizeStart', 'onResizeStop', 'draggableOpts', 'minConstraints', 'maxConstraints', 'lockAspectRatio', 'axis', 'width', 'height']);
	
	    return _react2.default.createElement(
	      _Resizable2.default,
	      {
	        handleSize: handleSize,
	        width: this.state.width,
	        height: this.state.height,
	        onResizeStart: onResizeStart,
	        onResize: this.onResize,
	        onResizeStop: onResizeStop,
	        draggableOpts: draggableOpts,
	        minConstraints: minConstraints,
	        maxConstraints: maxConstraints,
	        lockAspectRatio: lockAspectRatio,
	        axis: axis
	      },
	      _react2.default.createElement('div', _extends({ style: { width: this.state.width + 'px', height: this.state.height + 'px' } }, props))
	    );
	  };
	
	  return ResizableBox;
	}(_react2.default.Component);
	
	ResizableBox.propTypes = {
	  height: _react.PropTypes.number,
	  width: _react.PropTypes.number
	};
	ResizableBox.defaultProps = {
	  handleSize: [20, 20]
	};
	exports.default = ResizableBox;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _visualizations = __webpack_require__(1284);
	
	var _visualizations2 = _interopRequireDefault(_visualizations);
	
	var _Visualization = __webpack_require__(1270);
	
	var _Visualization2 = _interopRequireDefault(_Visualization);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _ChartSettings = __webpack_require__(1512);
	
	var _ChartSettings2 = _interopRequireDefault(_ChartSettings);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DashCardParameterMapper = __webpack_require__(1514);
	
	var _DashCardParameterMapper2 = _interopRequireDefault(_DashCardParameterMapper);
	
	var _embed = __webpack_require__(858);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DATASET_USUALLY_FAST_THRESHOLD = 15 * 1000;
	
	var HEADER_ICON_SIZE = 16;
	
	var HEADER_ACTION_STYLE = {
	    padding: 4
	};
	
	var DashCard = (_temp = _class = function (_Component) {
	    _inherits(DashCard, _Component);
	
	    function DashCard() {
	        _classCallCheck(this, DashCard);
	
	        return _possibleConstructorReturn(this, (DashCard.__proto__ || Object.getPrototypeOf(DashCard)).apply(this, arguments));
	    }
	
	    _createClass(DashCard, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var _props, dashcard, markNewCardSeen;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _props = this.props, dashcard = _props.dashcard, markNewCardSeen = _props.markNewCardSeen;
	
	                                // HACK: way to scroll to a newly added card
	
	                                if (dashcard.justAdded) {
	                                    _reactDom2.default.findDOMNode(this).scrollIntoView();
	                                    markNewCardSeen(dashcard.id);
	                                }
	
	                            case 2:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            window.clearInterval(this.visibilityTimer);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                dashcard = _props2.dashcard,
	                dashcardData = _props2.dashcardData,
	                slowCards = _props2.slowCards,
	                parameterValues = _props2.parameterValues,
	                isEditing = _props2.isEditing,
	                isEditingParameter = _props2.isEditingParameter,
	                onAddSeries = _props2.onAddSeries,
	                onRemove = _props2.onRemove,
	                navigateToNewCardFromDashboard = _props2.navigateToNewCardFromDashboard,
	                metadata = _props2.metadata;
	
	
	            var mainCard = _extends({}, dashcard.card, {
	                visualization_settings: _extends({}, dashcard.card.visualization_settings, dashcard.visualization_settings)
	            });
	            var cards = [mainCard].concat(dashcard.series || []);
	            var series = cards.map(function (card) {
	                return _extends({}, (0, _icepick.getIn)(dashcardData, [dashcard.id, card.id]), {
	                    card: card,
	                    isSlow: slowCards[card.id],
	                    isUsuallyFast: card.query_average_duration && card.query_average_duration < DATASET_USUALLY_FAST_THRESHOLD
	                });
	            });
	
	            var loading = !(series.length > 0 && _underscore2.default.every(series, function (s) {
	                return s.data;
	            }));
	            var expectedDuration = Math.max.apply(Math, _toConsumableArray(series.map(function (s) {
	                return s.card.query_average_duration || 0;
	            })));
	            var usuallyFast = _underscore2.default.every(series, function (s) {
	                return s.isUsuallyFast;
	            });
	            var isSlow = loading && _underscore2.default.some(series, function (s) {
	                return s.isSlow;
	            }) && (usuallyFast ? "usually-fast" : "usually-slow");
	
	            var parameterMap = dashcard && dashcard.parameter_mappings && dashcard.parameter_mappings.reduce(function (map, mapping) {
	                return _extends({}, map, _defineProperty({}, mapping.parameter_id, mapping));
	            }, {});
	
	            var isMappedToAllParameters = !parameterValues || Object.keys(parameterValues).filter(function (parameterId) {
	                return parameterValues[parameterId] !== null;
	            }).every(function (parameterId) {
	                return parameterMap[parameterId];
	            });
	
	            var errors = series.map(function (s) {
	                return s.error;
	            }).filter(function (e) {
	                return e;
	            });
	
	            var errorMessage = void 0,
	                errorIcon = void 0;
	            if (_underscore2.default.any(errors, function (e) {
	                return e && e.status === 403;
	            })) {
	                errorMessage = _Visualization.ERROR_MESSAGE_PERMISSION;
	                errorIcon = "key";
	            } else if (errors.length > 0) {
	                if (_embed.IS_EMBED_PREVIEW) {
	                    errorMessage = errors[0] && errors[0].data || _Visualization.ERROR_MESSAGE_GENERIC;
	                } else {
	                    errorMessage = _Visualization.ERROR_MESSAGE_GENERIC;
	                }
	                errorIcon = "warning";
	            }
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)("Card bordered rounded flex flex-column hover-parent hover--visibility", {
	                        "Card--recent": dashcard.isAdded,
	                        "Card--unmapped": !isMappedToAllParameters && !isEditing,
	                        "Card--slow": isSlow === "usually-slow"
	                    })
	                },
	                _react2.default.createElement(_Visualization2.default, {
	                    className: "flex-full",
	                    error: errorMessage,
	                    errorIcon: errorIcon,
	                    isSlow: isSlow,
	                    expectedDuration: expectedDuration,
	                    series: series,
	                    showTitle: true,
	                    isDashboard: true,
	                    isEditing: isEditing,
	                    gridSize: this.props.isMobile ? undefined : { width: dashcard.sizeX, height: dashcard.sizeY },
	                    actionButtons: isEditing && !isEditingParameter ? _react2.default.createElement(DashCardActionButtons, {
	                        series: series,
	                        onRemove: onRemove,
	                        onAddSeries: onAddSeries,
	                        onReplaceAllVisualizationSettings: this.props.onReplaceAllVisualizationSettings
	                    }) : undefined,
	                    onUpdateVisualizationSettings: this.props.onUpdateVisualizationSettings,
	                    replacementContent: isEditingParameter && _react2.default.createElement(_DashCardParameterMapper2.default, { dashcard: dashcard }),
	                    metadata: metadata,
	                    onChangeCardAndRun: navigateToNewCardFromDashboard ? function (_ref2) {
	                        var nextCard = _ref2.nextCard,
	                            previousCard = _ref2.previousCard;
	
	                        // navigateToNewCardFromDashboard needs `dashcard` for applying active filters to the query
	                        navigateToNewCardFromDashboard({ nextCard: nextCard, previousCard: previousCard, dashcard: dashcard });
	                    } : null
	                })
	            );
	        }
	    }]);
	
	    return DashCard;
	}(_react.Component), _class.propTypes = {
	    dashcard: _propTypes2.default.object.isRequired,
	    dashcardData: _propTypes2.default.object.isRequired,
	    slowCards: _propTypes2.default.object.isRequired,
	    parameterValues: _propTypes2.default.object.isRequired,
	    markNewCardSeen: _propTypes2.default.func.isRequired,
	    fetchCardData: _propTypes2.default.func.isRequired,
	    navigateToNewCardFromDashboard: _propTypes2.default.func.isRequired
	}, _temp);
	DashCard.displayName = "DashCard";
	exports.default = DashCard;
	
	
	var DashCardActionButtons = function DashCardActionButtons(_ref3) {
	    var series = _ref3.series,
	        onRemove = _ref3.onRemove,
	        onAddSeries = _ref3.onAddSeries,
	        onReplaceAllVisualizationSettings = _ref3.onReplaceAllVisualizationSettings;
	    return _react2.default.createElement(
	        "span",
	        { className: "DashCard-actions flex align-center", style: { lineHeight: 1 } },
	        (0, _visualizations.getVisualizationRaw)(series).CardVisualization.supportsSeries && _react2.default.createElement(AddSeriesButton, { series: series, onAddSeries: onAddSeries }),
	        onReplaceAllVisualizationSettings && _react2.default.createElement(ChartSettingsButton, { series: series, onReplaceAllVisualizationSettings: onReplaceAllVisualizationSettings }),
	        _react2.default.createElement(RemoveButton, { onRemove: onRemove })
	    );
	};
	
	DashCardActionButtons.displayName = "DashCardActionButtons";
	var ChartSettingsButton = function ChartSettingsButton(_ref4) {
	    var series = _ref4.series,
	        onReplaceAllVisualizationSettings = _ref4.onReplaceAllVisualizationSettings;
	    return _react2.default.createElement(
	        _ModalWithTrigger2.default,
	        {
	            wide: true, tall: true,
	            triggerElement: _react2.default.createElement(_Icon2.default, { name: "gear", size: HEADER_ICON_SIZE, style: HEADER_ACTION_STYLE }),
	            triggerClasses: "text-grey-2 text-grey-4-hover cursor-pointer flex align-center flex-no-shrink mr1"
	        },
	        _react2.default.createElement(_ChartSettings2.default, {
	            series: series,
	            onChange: onReplaceAllVisualizationSettings,
	            isDashboard: true
	        })
	    );
	};
	
	ChartSettingsButton.displayName = "ChartSettingsButton";
	var RemoveButton = function RemoveButton(_ref5) {
	    var onRemove = _ref5.onRemove;
	    return _react2.default.createElement(
	        "a",
	        { className: "text-grey-2 text-grey-4-hover ", "data-metabase-event": "Dashboard;Remove Card Modal", onClick: onRemove, style: HEADER_ACTION_STYLE },
	        _react2.default.createElement(_Icon2.default, { name: "close", size: HEADER_ICON_SIZE })
	    );
	};
	
	RemoveButton.displayName = "RemoveButton";
	var AddSeriesButton = function AddSeriesButton(_ref6) {
	    var series = _ref6.series,
	        onAddSeries = _ref6.onAddSeries;
	    return _react2.default.createElement(
	        "a",
	        {
	            "data-metabase-event": "Dashboard;Edit Series Modal;open",
	            className: "text-grey-2 text-grey-4-hover cursor-pointer h3 flex-no-shrink relative mr1",
	            onClick: onAddSeries,
	            style: HEADER_ACTION_STYLE
	        },
	        _react2.default.createElement(
	            "span",
	            { className: "flex align-center" },
	            _react2.default.createElement(
	                "span",
	                { className: "flex" },
	                _react2.default.createElement(_Icon2.default, { className: "absolute", name: "add", style: { top: 0, left: 0 }, size: HEADER_ICON_SIZE / 2 }),
	                _react2.default.createElement(_Icon2.default, { name: getSeriesIconName(series), size: HEADER_ICON_SIZE })
	            ),
	            _react2.default.createElement(
	                "span",
	                { className: "flex-no-shrink text-bold" },
	                "\xA0",
	                series.length > 1 ? "Edit" : "Add"
	            )
	        )
	    );
	};
	
	AddSeriesButton.displayName = "AddSeriesButton";
	function getSeriesIconName(series) {
	    try {
	        var display = series[0].card.display;
	        return _visualizations2.default.get(display === "scalar" ? "bar" : display).iconName;
	    } catch (e) {
	        return "bar";
	    }
	}

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icepick = __webpack_require__(855);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Warnings = __webpack_require__(1513);
	
	var _Warnings2 = _interopRequireDefault(_Warnings);
	
	var _Visualization = __webpack_require__(1270);
	
	var _Visualization2 = _interopRequireDefault(_Visualization);
	
	var _settings = __webpack_require__(1376);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _visualizations = __webpack_require__(1284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartSettingsTab = function ChartSettingsTab(_ref) {
	    var name = _ref.name,
	        active = _ref.active,
	        _onClick = _ref.onClick;
	    return _react2.default.createElement(
	        "a",
	        {
	            className: (0, _classnames2.default)('block text-brand py1 text-centered', { 'bg-brand text-white': active }),
	            onClick: function onClick() {
	                return _onClick(name);
	            }
	        },
	        name.toUpperCase()
	    );
	};
	
	ChartSettingsTab.displayName = "ChartSettingsTab";
	var ChartSettingsTabs = function ChartSettingsTabs(_ref2) {
	    var tabs = _ref2.tabs,
	        selectTab = _ref2.selectTab,
	        activeTab = _ref2.activeTab;
	    return _react2.default.createElement(
	        "ul",
	        { className: "bordered rounded flex justify-around overflow-hidden" },
	        tabs.map(function (tab, index) {
	            return _react2.default.createElement(
	                "li",
	                { className: "flex-full border-left", key: index },
	                _react2.default.createElement(ChartSettingsTab, { name: tab, active: tab === activeTab, onClick: selectTab })
	            );
	        })
	    );
	};
	
	ChartSettingsTabs.displayName = "ChartSettingsTabs";
	var Widget = function Widget(_ref3) {
	    var title = _ref3.title,
	        hidden = _ref3.hidden,
	        disabled = _ref3.disabled,
	        widget = _ref3.widget,
	        value = _ref3.value,
	        onChange = _ref3.onChange,
	        props = _ref3.props;
	
	    var W = widget;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("mb2", { hide: hidden, disable: disabled }) },
	        title && _react2.default.createElement(
	            "h4",
	            { className: "mb1" },
	            title
	        ),
	        W && _react2.default.createElement(W, _extends({ value: value, onChange: onChange }, props))
	    );
	};
	
	Widget.displayName = "Widget";
	
	var ChartSettings = function (_Component) {
	    _inherits(ChartSettings, _Component);
	
	    function ChartSettings(props) {
	        _classCallCheck(this, ChartSettings);
	
	        var _this = _possibleConstructorReturn(this, (ChartSettings.__proto__ || Object.getPrototypeOf(ChartSettings)).call(this, props));
	
	        _this.selectTab = function (tab) {
	            _this.setState({ currentTab: tab });
	        };
	
	        _this.onResetSettings = function () {
	            _analytics2.default.trackEvent("Chart Settings", "Reset Settings");
	            _this.setState({
	                settings: {},
	                series: _this._getSeries(_this.props.series, {})
	            });
	        };
	
	        _this.onChangeSettings = function (newSettings) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = Object.keys(newSettings)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var key = _step.value;
	
	                    _analytics2.default.trackEvent("Chart Settings", "Change Setting", key);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var settings = _extends({}, _this.state.settings, newSettings);
	            _this.setState({
	                settings: settings,
	                series: _this._getSeries(_this.props.series, settings)
	            });
	        };
	
	        var initialSettings = props.series[0].card.visualization_settings;
	        _this.state = {
	            currentTab: null,
	            settings: initialSettings,
	            series: _this._getSeries(props.series, initialSettings)
	        };
	        return _this;
	    }
	
	    _createClass(ChartSettings, [{
	        key: "_getSeries",
	        value: function _getSeries(series, settings) {
	            if (settings) {
	                series = (0, _icepick.assocIn)(series, [0, "card", "visualization_settings"], settings);
	            }
	            var transformed = (0, _visualizations.getVisualizationTransformed)((0, _visualizations.extractRemappings)(series));
	            return transformed.series;
	        }
	    }, {
	        key: "onDone",
	        value: function onDone() {
	            this.props.onChange(this.state.settings);
	            this.props.onClose();
	        }
	    }, {
	        key: "getChartTypeName",
	        value: function getChartTypeName() {
	            var _getVisualizationTran = (0, _visualizations.getVisualizationTransformed)(this.props.series),
	                CardVisualization = _getVisualizationTran.CardVisualization;
	
	            switch (CardVisualization.identifier) {
	                case "table":
	                    return "table";
	                case "scalar":
	                    return "number";
	                case "funnel":
	                    return "funnel";
	                default:
	                    return "chart";
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                onClose = _props.onClose,
	                isDashboard = _props.isDashboard;
	            var series = this.state.series;
	
	
	            var tabs = {};
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = (0, _settings.getSettingsWidgets)(series, this.onChangeSettings, isDashboard)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var widget = _step2.value;
	
	                    tabs[widget.section] = tabs[widget.section] || [];
	                    tabs[widget.section].push(widget);
	                }
	
	                // Move settings from the "undefined" section in the first tab
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            if (tabs["undefined"] && Object.values(tabs).length > 1) {
	                var _Object$values$;
	
	                var extra = tabs["undefined"];
	                delete tabs["undefined"];
	                (_Object$values$ = Object.values(tabs)[0]).unshift.apply(_Object$values$, _toConsumableArray(extra));
	            }
	
	            var tabNames = Object.keys(tabs);
	            var currentTab = this.state.currentTab || tabNames[0];
	            var widgets = tabs[currentTab];
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex flex-column spread p4" },
	                _react2.default.createElement(
	                    "h2",
	                    { className: "my2" },
	                    "Customize this ",
	                    this.getChartTypeName()
	                ),
	                tabNames.length > 1 && _react2.default.createElement(ChartSettingsTabs, { tabs: tabNames, selectTab: this.selectTab, activeTab: currentTab }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "Grid flex-full mt3" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Grid-cell Cell--1of3 scroll-y p1" },
	                        widgets && widgets.map(function (widget) {
	                            return _react2.default.createElement(Widget, _extends({ key: widget.id }, widget));
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Grid-cell flex flex-column" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex flex-column" },
	                            _react2.default.createElement(_Warnings2.default, { className: "mx2 align-self-end text-gold", warnings: this.state.warnings, size: 20 })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex-full relative" },
	                            _react2.default.createElement(_Visualization2.default, {
	                                className: "spread",
	                                series: series,
	                                isEditing: true,
	                                showTitle: true,
	                                isDashboard: true,
	                                showWarnings: true,
	                                onUpdateVisualizationSettings: this.onChangeSettings,
	                                onUpdateWarnings: function onUpdateWarnings(warnings) {
	                                    return _this2.setState({ warnings: warnings });
	                                }
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "pt1" },
	                    !_underscore2.default.isEqual(this.state.settings, {}) && _react2.default.createElement(
	                        "a",
	                        { className: "Button Button--danger float-right", onClick: this.onResetSettings, "data-metabase-event": "Chart Settings;Reset" },
	                        "Reset to defaults"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "float-left" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "Button Button--primary ml2", onClick: function onClick() {
	                                    return _this2.onDone();
	                                }, "data-metabase-event": "Chart Settings;Done" },
	                            "Done"
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { className: "Button ml2", onClick: onClose, "data-metabase-event": "Chart Settings;Cancel" },
	                            "Cancel"
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ChartSettings;
	}(_react.Component);
	
	ChartSettings.displayName = "ChartSettings";
	exports.default = ChartSettings;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Warnings = function Warnings(_ref) {
	    var warnings = _ref.warnings,
	        className = _ref.className,
	        _ref$size = _ref.size,
	        size = _ref$size === undefined ? 16 : _ref$size;
	
	    if (!warnings || warnings.length === 0) {
	        return null;
	    }
	    var tooltip = _react2.default.createElement(
	        "ul",
	        { className: "px2 pt2 pb1", style: { maxWidth: 350 } },
	        warnings.map(function (warning) {
	            return _react2.default.createElement(
	                "li",
	                { className: "pb1", key: warning },
	                warning
	            );
	        })
	    );
	
	    return _react2.default.createElement(
	        _Tooltip2.default,
	        { tooltip: tooltip },
	        _react2.default.createElement(_Icon2.default, { className: className, name: "warning2", size: size })
	    );
	};
	
	Warnings.displayName = "Warnings";
	exports.default = Warnings;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DashCardCardParameterMapper = __webpack_require__(1515);
	
	var _DashCardCardParameterMapper2 = _interopRequireDefault(_DashCardCardParameterMapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashCardParameterMapper = function DashCardParameterMapper(_ref) {
	    var dashcard = _ref.dashcard;
	    return _react2.default.createElement(
	        "div",
	        { className: "relative flex-full flex flex-column layout-centered" },
	        dashcard.series && dashcard.series.length > 0 && _react2.default.createElement(
	            "div",
	            { className: "mx4 my1 p1 rounded", style: { backgroundColor: "#F5F5F5", color: "#8691AC", marginTop: -10 } },
	            "Make sure to make a selection for each series, or the filter won't work on this card."
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "flex mx4 z1", style: { justifyContent: "space-around" } },
	            [dashcard.card].concat(dashcard.series || []).map(function (card) {
	                return _react2.default.createElement(_DashCardCardParameterMapper2.default, { key: dashcard.id + "," + card.id, dashcard: dashcard, card: card });
	            })
	        )
	    );
	};
	
	DashCardParameterMapper.displayName = "DashCardParameterMapper";
	exports.default = DashCardParameterMapper;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _DashCardCardParameterMapper = __webpack_require__(1516);
	
	var _DashCardCardParameterMapper2 = _interopRequireDefault(_DashCardCardParameterMapper);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AccordianList = __webpack_require__(977);
	
	var _AccordianList2 = _interopRequireDefault(_AccordianList);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _metadata = __webpack_require__(1110);
	
	var _selectors = __webpack_require__(1518);
	
	var _dashboard = __webpack_require__(1520);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icepick = __webpack_require__(855);
	
	var _AtomicQuery = __webpack_require__(948);
	
	var _AtomicQuery2 = _interopRequireDefault(_AtomicQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var makeMapStateToProps = function makeMapStateToProps() {
	    var getParameterMappingOptions = (0, _selectors.makeGetParameterMappingOptions)();
	    var mapStateToProps = function mapStateToProps(state, props) {
	        return {
	            parameter: (0, _selectors.getEditingParameter)(state, props),
	            mappingOptions: getParameterMappingOptions(state, props),
	            mappingOptionSections: _underscore2.default.groupBy(getParameterMappingOptions(state, props), "sectionName"),
	            target: (0, _selectors.getParameterTarget)(state, props),
	            mappingsByParameter: (0, _selectors.getMappingsByParameter)(state, props)
	        };
	    };
	    return mapStateToProps;
	};
	
	var mapDispatchToProps = {
	    setParameterMapping: _dashboard.setParameterMapping,
	    fetchDatabaseMetadata: _metadata.fetchDatabaseMetadata
	};
	
	var DashCardCardParameterMapper = (_dec = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_Component) {
	    _inherits(DashCardCardParameterMapper, _Component);
	
	    function DashCardCardParameterMapper() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DashCardCardParameterMapper);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DashCardCardParameterMapper.__proto__ || Object.getPrototypeOf(DashCardCardParameterMapper)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (option) {
	            var _this$props = _this.props,
	                setParameterMapping = _this$props.setParameterMapping,
	                parameter = _this$props.parameter,
	                dashcard = _this$props.dashcard,
	                card = _this$props.card;
	
	            setParameterMapping(parameter.id, dashcard.id, card.id, option ? option.target : null);
	            _this.refs.popover.close();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DashCardCardParameterMapper, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var card = this.props.card;
	            // Type check for Flow
	
	            card.dataset_query instanceof _AtomicQuery2.default && this.props.fetchDatabaseMetadata(card.dataset_query.database);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _cx,
	                _this2 = this;
	
	            var _props = this.props,
	                mappingOptions = _props.mappingOptions,
	                mappingOptionSections = _props.mappingOptionSections,
	                target = _props.target,
	                mappingsByParameter = _props.mappingsByParameter,
	                parameter = _props.parameter,
	                dashcard = _props.dashcard,
	                card = _props.card;
	
	            // TODO: move some of these to selectors?
	
	            var disabled = mappingOptions.length === 0;
	            var selected = _underscore2.default.find(mappingOptions, function (o) {
	                return _underscore2.default.isEqual(o.target, target);
	            });
	
	            var mapping = (0, _icepick.getIn)(mappingsByParameter, [parameter.id, dashcard.id, card.id]);
	            var noOverlap = !!(mapping && mapping.mappingsWithValues > 1 && mapping.overlapMax === 1);
	
	            var hasFkOption = _underscore2.default.any(mappingOptions, function (o) {
	                return !!o.isFk;
	            });
	
	            var sections = _underscore2.default.map(mappingOptionSections, function (options) {
	                return {
	                    name: options[0].sectionName,
	                    items: options
	                };
	            });
	
	            var tooltipText = null;
	            if (disabled) {
	                tooltipText = "This card doesn't have any fields or parameters that can be mapped to this parameter type.";
	            } else if (noOverlap) {
	                tooltipText = "The values in this field don't overlap with the values of any other fields you've chosen.";
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "mx1 flex flex-column align-center", onMouseDown: function onMouseDown(e) {
	                        return e.stopPropagation();
	                    } },
	                dashcard.series && dashcard.series.length > 0 && _react2.default.createElement(
	                    "div",
	                    { className: "h5 mb1 text-bold", style: { textOverflow: "ellipsis", whiteSpace: "nowrap", overflowX: "hidden", maxWidth: 100 } },
	                    card.name
	                ),
	                _react2.default.createElement(
	                    _PopoverWithTrigger2.default,
	                    {
	                        ref: "popover",
	                        triggerClasses: (0, _classnames2.default)({ "disabled": disabled }),
	                        sizeToFit: true,
	                        triggerElement: _react2.default.createElement(
	                            _Tooltip2.default,
	                            { tooltip: tooltipText, verticalAttachments: ["bottom", "top"] },
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: (0, _classnames2.default)(_DashCardCardParameterMapper2.default.button, (_cx = {}, _defineProperty(_cx, _DashCardCardParameterMapper2.default.mapped, !!selected), _defineProperty(_cx, _DashCardCardParameterMapper2.default.warn, noOverlap), _defineProperty(_cx, _DashCardCardParameterMapper2.default.disabled, disabled), _cx))
	                                },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "text-centered mr1" },
	                                    disabled ? "No valid fields" : selected ? selected.name : "Select…"
	                                ),
	                                selected ? _react2.default.createElement(_Icon2.default, { className: "flex-align-right", name: "close", size: 16, onClick: function onClick(e) {
	                                        _this2.onChange(null);e.stopPropagation();
	                                    } }) : !disabled ? _react2.default.createElement(_Icon2.default, { className: "flex-align-right", name: "chevrondown", size: 16 }) : null
	                            )
	                        )
	                    },
	                    _react2.default.createElement(_AccordianList2.default, {
	                        className: "text-brand scroll-show scroll-y",
	                        style: { maxHeight: 600 },
	                        sections: sections,
	                        onChange: this.onChange,
	                        itemIsSelected: function itemIsSelected(item) {
	                            return _underscore2.default.isEqual(item.target, target);
	                        },
	                        renderItemIcon: function renderItemIcon(item) {
	                            return _react2.default.createElement(_Icon2.default, { name: item.icon || "unknown", size: 18 });
	                        },
	                        alwaysExpanded: true,
	                        hideSingleSectionTitle: !hasFkOption
	                    })
	                )
	            );
	        }
	    }]);
	
	    return DashCardCardParameterMapper;
	}(_react.Component), _class2.propTypes = {
	    dashcard: _propTypes2.default.object.isRequired,
	    card: _propTypes2.default.object.isRequired
	}, _class2.defaultProps = {}, _temp2)) || _class);
	DashCardCardParameterMapper.displayName = "DashCardCardParameterMapper";
	exports.default = DashCardCardParameterMapper;

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_31Acd _38618 _3Dqep eTBAP _3TD8R _1a-AI","mapped":"_1cuH0","warn":"_2bBGA","disabled":"_3fcMT _1f32L"};

/***/ }),
/* 1517 */,
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.makeGetParameterMappingOptions = exports.getParameters = exports.getMappingsByParameter = exports.getParameterTarget = exports.getIsEditingParameter = exports.getEditingParameter = exports.getEditingParameterId = exports.getCardList = exports.getIsDirty = exports.getDashboardComplete = exports.getDashboard = exports.getParameterValues = exports.getRevisions = exports.getCardIdList = exports.getSlowCards = exports.getCardData = exports.getDashcards = exports.getDashboards = exports.getCards = exports.getIsEditing = exports.getDashboardId = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	var _reselect = __webpack_require__(1072);
	
	var _metadata = __webpack_require__(1073);
	
	var _Dashboard = __webpack_require__(1519);
	
	var Dashboard = _interopRequireWildcard(_Dashboard);
	
	var _Parameter = __webpack_require__(958);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getDashboardId = exports.getDashboardId = function getDashboardId(state) {
	    return state.dashboard.dashboardId;
	};
	var getIsEditing = exports.getIsEditing = function getIsEditing(state) {
	    return state.dashboard.isEditing;
	};
	var getCards = exports.getCards = function getCards(state) {
	    return state.dashboard.cards;
	};
	var getDashboards = exports.getDashboards = function getDashboards(state) {
	    return state.dashboard.dashboards;
	};
	var getDashcards = exports.getDashcards = function getDashcards(state) {
	    return state.dashboard.dashcards;
	};
	var getCardData = exports.getCardData = function getCardData(state) {
	    return state.dashboard.dashcardData;
	};
	var getSlowCards = exports.getSlowCards = function getSlowCards(state) {
	    return state.dashboard.slowCards;
	};
	var getCardIdList = exports.getCardIdList = function getCardIdList(state) {
	    return state.dashboard.cardList;
	};
	var getRevisions = exports.getRevisions = function getRevisions(state) {
	    return state.dashboard.revisions;
	};
	var getParameterValues = exports.getParameterValues = function getParameterValues(state) {
	    return state.dashboard.parameterValues;
	};
	
	var getDashboard = exports.getDashboard = (0, _reselect.createSelector)([getDashboardId, getDashboards], function (dashboardId, dashboards) {
	    return dashboards[dashboardId];
	});
	
	var getDashboardComplete = exports.getDashboardComplete = (0, _reselect.createSelector)([getDashboard, getDashcards], function (dashboard, dashcards) {
	    return dashboard && _extends({}, dashboard, {
	        ordered_cards: dashboard.ordered_cards.map(function (id) {
	            return dashcards[id];
	        }).filter(function (dc) {
	            return !dc.isRemoved;
	        })
	    });
	});
	
	var getIsDirty = exports.getIsDirty = (0, _reselect.createSelector)([getDashboard, getDashcards], function (dashboard, dashcards) {
	    return !!(dashboard && (dashboard.isDirty || _underscore2.default.some(dashboard.ordered_cards, function (id) {
	        return !(dashcards[id].isAdded && dashcards[id].isRemoved) && (dashcards[id].isDirty || dashcards[id].isAdded || dashcards[id].isRemoved);
	    })));
	});
	
	var getCardList = exports.getCardList = (0, _reselect.createSelector)([getCardIdList, getCards], function (cardIdList, cards) {
	    return cardIdList && cardIdList.map(function (id) {
	        return cards[id];
	    });
	});
	
	var getEditingParameterId = exports.getEditingParameterId = function getEditingParameterId(state) {
	    return state.dashboard.editingParameterId;
	};
	
	var getEditingParameter = exports.getEditingParameter = (0, _reselect.createSelector)([getDashboard, getEditingParameterId], function (dashboard, editingParameterId) {
	    return editingParameterId != null ? _underscore2.default.findWhere(dashboard.parameters, { id: editingParameterId }) : null;
	});
	
	var getIsEditingParameter = exports.getIsEditingParameter = function getIsEditingParameter(state) {
	    return state.dashboard.editingParameterId != null;
	};
	
	var getCard = function getCard(state, props) {
	    return props.card;
	};
	var getDashCard = function getDashCard(state, props) {
	    return props.dashcard;
	};
	
	var getParameterTarget = exports.getParameterTarget = (0, _reselect.createSelector)([getEditingParameter, getCard, getDashCard], function (parameter, card, dashcard) {
	    var mapping = _underscore2.default.findWhere(dashcard.parameter_mappings, { card_id: card.id, parameter_id: parameter.id });
	    return mapping && mapping.target;
	});
	
	var getMappingsByParameter = exports.getMappingsByParameter = (0, _reselect.createSelector)([_metadata.getMetadata, getDashboardComplete], function (metadata, dashboard) {
	    if (!dashboard) {
	        return {};
	    }
	
	    var mappingsByParameter = {};
	    var mappings = [];
	    var countsByParameter = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = dashboard.ordered_cards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var dashcard = _step.value;
	
	            var cards = [dashcard.card].concat(dashcard.series);
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	                for (var _iterator4 = (dashcard.parameter_mappings || [])[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var mapping = _step4.value;
	
	                    var card = _underscore2.default.findWhere(cards, { id: mapping.card_id });
	                    var fieldId = card && (0, _Parameter.getParameterTargetFieldId)(mapping.target, card.dataset_query);
	                    var field = metadata.fields[fieldId];
	                    var _values = field && field.fieldValues() || [];
	                    if (_values.length) {
	                        countsByParameter[mapping.parameter_id] = countsByParameter[mapping.parameter_id] || {};
	                    }
	                    var _iteratorNormalCompletion5 = true;
	                    var _didIteratorError5 = false;
	                    var _iteratorError5 = undefined;
	
	                    try {
	                        for (var _iterator5 = _values[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                            var value = _step5.value;
	
	                            countsByParameter[mapping.parameter_id][value] = (countsByParameter[mapping.parameter_id][value] || 0) + 1;
	                        }
	                    } catch (err) {
	                        _didIteratorError5 = true;
	                        _iteratorError5 = err;
	                    } finally {
	                        try {
	                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                                _iterator5.return();
	                            }
	                        } finally {
	                            if (_didIteratorError5) {
	                                throw _iteratorError5;
	                            }
	                        }
	                    }
	
	                    var augmentedMapping = _extends({}, mapping, {
	                        parameter_id: mapping.parameter_id,
	                        dashcard_id: dashcard.id,
	                        card_id: mapping.card_id,
	                        field_id: fieldId,
	                        values: _values
	                    });
	                    mappingsByParameter = (0, _icepick.setIn)(mappingsByParameter, [mapping.parameter_id, dashcard.id, mapping.card_id], augmentedMapping);
	                    mappings.push(augmentedMapping);
	                }
	            } catch (err) {
	                _didIteratorError4 = true;
	                _iteratorError4 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                        _iterator4.return();
	                    }
	                } finally {
	                    if (_didIteratorError4) {
	                        throw _iteratorError4;
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    var mappingsWithValuesByParameter = {};
	    // update max values overlap for each mapping
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        var _loop = function _loop() {
	            var mapping = _step2.value;
	
	            if (mapping.values && mapping.values.length > 0) {
	                var _overlapMax = Math.max.apply(Math, _toConsumableArray(mapping.values.map(function (value) {
	                    return countsByParameter[mapping.parameter_id][value];
	                })));
	                mappingsByParameter = (0, _icepick.setIn)(mappingsByParameter, [mapping.parameter_id, mapping.dashcard_id, mapping.card_id, "overlapMax"], _overlapMax);
	                mappingsWithValuesByParameter[mapping.parameter_id] = (mappingsWithValuesByParameter[mapping.parameter_id] || 0) + 1;
	            }
	        };
	
	        for (var _iterator2 = mappings[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            _loop();
	        }
	        // update count of mappings with values
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        for (var _iterator3 = mappings[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var _mapping = _step3.value;
	
	            mappingsByParameter = (0, _icepick.setIn)(mappingsByParameter, [_mapping.parameter_id, _mapping.dashcard_id, _mapping.card_id, "mappingsWithValues"], mappingsWithValuesByParameter[_mapping.parameter_id] || 0);
	        }
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	
	    return mappingsByParameter;
	});
	
	/** Returns the dashboard's parameters objects, with field_id added, if appropriate */
	var getParameters = exports.getParameters = (0, _reselect.createSelector)([getDashboard, getMappingsByParameter], function (dashboard, mappingsByParameter) {
	    return (dashboard && dashboard.parameters || []).map(function (parameter) {
	        // get the unique list of field IDs these mappings reference
	        var fieldIds = _underscore2.default.chain(mappingsByParameter[parameter.id]).map(_underscore2.default.values).flatten().map(function (m) {
	            return m.field_id;
	        }).uniq().filter(function (fieldId) {
	            return fieldId != null;
	        }).value();
	        return _extends({}, parameter, {
	            field_ids: fieldIds
	        });
	    });
	});
	
	var makeGetParameterMappingOptions = exports.makeGetParameterMappingOptions = function makeGetParameterMappingOptions() {
	    var getParameterMappingOptions = (0, _reselect.createSelector)([_metadata.getMetadata, getEditingParameter, getCard], function (metadata, parameter, card) {
	        return Dashboard.getParameterMappingOptions(metadata, parameter, card);
	    });
	    return getParameterMappingOptions;
	};

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PARAMETER_SECTIONS = exports.PARAMETER_OPTIONS = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getFieldDimension = getFieldDimension;
	exports.getTagDimension = getTagDimension;
	exports.getCardDimensions = getCardDimensions;
	exports.getTableDimensions = getTableDimensions;
	exports.getCardVariables = getCardVariables;
	exports.fieldFilterForParameterType = fieldFilterForParameterType;
	exports.parameterOptionsForField = parameterOptionsForField;
	exports.getParameterMappingOptions = getParameterMappingOptions;
	exports.createParameter = createParameter;
	exports.setParameterName = setParameterName;
	exports.setParameterDefaultValue = setParameterDefaultValue;
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Field = __webpack_require__(900);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Card = __webpack_require__(957);
	
	var _formatting = __webpack_require__(872);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _types = __webpack_require__(868);
	
	var _util = __webpack_require__(870);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var PARAMETER_OPTIONS = exports.PARAMETER_OPTIONS = [{
	    type: "date/month-year",
	    name: "Month and Year",
	    description: "Like January, 2016"
	}, {
	    type: "date/quarter-year",
	    name: "Quarter and Year",
	    description: "Like Q1, 2016"
	}, {
	    type: "date/single",
	    name: "Single Date",
	    description: "Like January 31, 2016"
	}, {
	    type: "date/range",
	    name: "Date Range",
	    description: "Like December 25, 2015 - February 14, 2016"
	}, {
	    type: "date/relative",
	    name: "Relative Date",
	    description: "Like \"the last 7 days\" or \"this month\""
	}, {
	    type: "date/all-options",
	    name: "Date Filter",
	    menuName: "All Options",
	    description: "Contains all of the above"
	}, {
	    type: "location/city",
	    name: "City"
	}, {
	    type: "location/state",
	    name: "State"
	}, {
	    type: "location/zip_code",
	    name: "ZIP or Postal Code"
	}, {
	    type: "location/country",
	    name: "Country"
	}, {
	    type: "id",
	    name: "ID"
	}, {
	    type: "category",
	    name: "Category"
	}];
	
	var PARAMETER_SECTIONS = exports.PARAMETER_SECTIONS = [{ id: "date", name: "Time", description: "Date range, relative date, time of day, etc.", options: [] }, { id: "location", name: "Location", description: "City, State, Country, ZIP code.", options: [] }, { id: "id", name: "ID", description: "User ID, product ID, event ID, etc.", options: [] }, { id: "category", name: "Other Categories", description: "Category, Type, Model, Rating, etc.", options: [] }];
	
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;
	
	try {
	    for (var _iterator = PARAMETER_OPTIONS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var option = _step.value;
	
	        var sectionId = option.type.split("/")[0];
	        var section = _underscore2.default.findWhere(PARAMETER_SECTIONS, { id: sectionId });
	        if (!section) {
	            section = _underscore2.default.findWhere(PARAMETER_SECTIONS, { id: "category" });
	        }
	        if (section) {
	            section.options = section.options || [];
	            section.options.push(option);
	        }
	    }
	} catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	} finally {
	    try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	        }
	    } finally {
	        if (_didIteratorError) {
	            throw _iteratorError;
	        }
	    }
	}
	
	function getFieldDimension(field) {
	    return {
	        name: field.display_name,
	        field_id: field.id,
	        parentName: field.table.display_name,
	        target: ["field-id", field.id],
	        depth: 0
	    };
	}
	
	function getTagDimension(tag, dimension) {
	    return {
	        name: dimension.name,
	        parentName: dimension.parentName,
	        target: ["template-tag", tag.name],
	        field_id: dimension.field_id,
	        depth: 0
	    };
	}
	
	function getCardDimensions(metadata, card) {
	    var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
	        return true;
	    };
	
	    if (card.dataset_query.type === "query") {
	        var table = card.dataset_query.query.source_table != null ? metadata.tables[card.dataset_query.query.source_table] : null;
	        if (table) {
	            return getTableDimensions(table, 1, filter);
	        }
	    } else if (card.dataset_query.type === "native") {
	        var dimensions = [];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = (0, _Card.getTemplateTags)(card)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var _tag = _step2.value;
	
	                if (_tag.type === "dimension" && Array.isArray(_tag.dimension) && (0, _util.mbqlEq)(_tag.dimension[0], "field-id")) {
	                    var _field = metadata.fields[_tag.dimension[1]];
	                    if (_field && filter(_field)) {
	                        var fieldDimension = getFieldDimension(_field);
	                        dimensions.push(getTagDimension(_tag, fieldDimension));
	                    }
	                }
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        return dimensions;
	    }
	    return [];
	}
	
	function getDimensionTargetFieldId(target) {
	    if (Array.isArray(target) && (0, _util.mbqlEq)(target[0], "template-tag")) {
	        return null;
	    } else {
	        return _query2.default.getFieldTargetId(target);
	    }
	}
	
	function getTableDimensions(table, depth) {
	    var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
	        return true;
	    };
	
	    return _underscore2.default.chain(table.fields).map(function (field) {
	        var targetField = field.target;
	        if (targetField && depth > 0) {
	            var targetTable = targetField.table;
	            return getTableDimensions(targetTable, depth - 1, filter).map(function (dimension) {
	                return _extends({}, dimension, {
	                    parentName: (0, _formatting.stripId)(field.display_name),
	                    target: ["fk->", field.id, getDimensionTargetFieldId(dimension.target)],
	                    depth: dimension.depth + 1
	                });
	            });
	        } else if (filter(field)) {
	            return [getFieldDimension(field)];
	        }
	    }).flatten().filter(function (dimension) {
	        return dimension != null;
	    }).value();
	}
	
	function getCardVariables(metadata, card) {
	    var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
	        return true;
	    };
	
	    if (card.dataset_query.type === "native") {
	        var variables = [];
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = (0, _Card.getTemplateTags)(card)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var _tag2 = _step3.value;
	
	                if (!filter || filter(_tag2)) {
	                    variables.push({
	                        name: _tag2.display_name || _tag2.name,
	                        type: _tag2.type,
	                        target: ["template-tag", _tag2.name]
	                    });
	                }
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	
	        return variables;
	    }
	    return [];
	}
	
	function fieldFilterForParameter(parameter) {
	    return fieldFilterForParameterType(parameter.type);
	}
	
	function fieldFilterForParameterType(parameterType) {
	    var _parameterType$split = parameterType.split("/"),
	        _parameterType$split2 = _slicedToArray(_parameterType$split, 1),
	        type = _parameterType$split2[0];
	
	    switch (type) {
	        case "date":
	            return function (field) {
	                return field.isDate();
	            };
	        case "id":
	            return function (field) {
	                return field.isID();
	            };
	        case "category":
	            return function (field) {
	                return field.isCategory();
	            };
	    }
	
	    switch (parameterType) {
	        case "location/city":
	            return function (field) {
	                return (0, _types.isa)(field.special_type, _types.TYPE.City);
	            };
	        case "location/state":
	            return function (field) {
	                return (0, _types.isa)(field.special_type, _types.TYPE.State);
	            };
	        case "location/zip_code":
	            return function (field) {
	                return (0, _types.isa)(field.special_type, _types.TYPE.ZipCode);
	            };
	        case "location/country":
	            return function (field) {
	                return (0, _types.isa)(field.special_type, _types.TYPE.Country);
	            };
	    }
	    return function (field) {
	        return false;
	    };
	}
	
	function parameterOptionsForField(field) {
	    return PARAMETER_OPTIONS.filter(function (option) {
	        return fieldFilterForParameterType(option.type)(field);
	    });
	}
	
	function tagFilterForParameter(parameter) {
	    var _parameter$type$split = parameter.type.split("/"),
	        _parameter$type$split2 = _slicedToArray(_parameter$type$split, 2),
	        type = _parameter$type$split2[0],
	        subtype = _parameter$type$split2[1];
	
	    switch (type) {
	        case "date":
	            return function (tag) {
	                return subtype === "single" && tag.type === "date";
	            };
	        case "location":
	            return function (tag) {
	                return tag.type === "number" || tag.type === "text";
	            };
	        case "id":
	            return function (tag) {
	                return tag.type === "number" || tag.type === "text";
	            };
	        case "category":
	            return function (tag) {
	                return tag.type === "number" || tag.type === "text";
	            };
	    }
	    return function (tag) {
	        return false;
	    };
	}
	
	var VARIABLE_ICONS = {
	    "text": "string",
	    "number": "int",
	    "date": "calendar"
	};
	
	function getParameterMappingOptions(metadata, parameter, card) {
	    var options = [];
	
	    // dimensions
	    options.push.apply(options, _toConsumableArray(getCardDimensions(metadata, card, fieldFilterForParameter(parameter)).map(function (dimension) {
	        var field = metadata.fields[dimension.field_id];
	        return {
	            name: dimension.name,
	            target: ["dimension", dimension.target],
	            icon: field && field.icon(),
	            sectionName: dimension.parentName,
	            isFk: dimension.depth > 0
	        };
	    })));
	
	    // variables
	    options.push.apply(options, _toConsumableArray(getCardVariables(metadata, card, tagFilterForParameter(parameter)).map(function (variable) {
	        return {
	            name: variable.name,
	            target: ["variable", variable.target],
	            icon: VARIABLE_ICONS[variable.type],
	            sectionName: "Variables",
	            isVariable: true
	        };
	    })));
	
	    return options;
	}
	
	function createParameter(option) {
	    var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var name = option.name;
	    var nameIndex = 0;
	    // get a unique name
	    while (_underscore2.default.any(parameters, function (p) {
	        return p.name === name;
	    })) {
	        name = option.name + " " + ++nameIndex;
	    }
	    var parameter = {
	        name: "",
	        slug: "",
	        id: Math.floor(Math.random() * Math.pow(2, 32)).toString(16),
	        type: option.type
	    };
	    return setParameterName(parameter, name);
	}
	
	function setParameterName(parameter, name) {
	    var slug = (0, _formatting.slugify)(name);
	    return _extends({}, parameter, {
	        name: name,
	        slug: slug
	    });
	}
	
	function setParameterDefaultValue(parameter, value) {
	    return _extends({}, parameter, {
	        default: value
	    });
	}

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.navigateToNewCardFromDashboard = exports.deletePublicLink = exports.DELETE_PUBLIC_LINK = exports.createPublicLink = exports.CREATE_PUBLIC_LINK = exports.setParameterValue = exports.setParameterDefaultValue = exports.setParameterName = exports.removeParameter = exports.addParameter = exports.setParameterMapping = exports.setEditingParameter = exports.onReplaceAllDashCardVisualizationSettings = exports.onUpdateDashCardVisualizationSettings = exports.revertToRevision = exports.fetchRevisions = exports.updateEmbeddingParams = exports.updateEnableEmbedding = exports.fetchDashboard = exports.markCardAsSlow = exports.fetchCardData = exports.fetchDashboardCardData = exports.fetchDataOrError = exports.clearCardData = exports.removeCardFromDashboard = exports.saveDashboardAndCards = exports.addCardToDashboard = exports.deleteCard = exports.fetchCards = exports.setDashCardAttributes = exports.setDashboardAttributes = exports.markNewCardSeen = exports.setEditingDashboard = exports.initialize = exports.SET_PARAMETER_DEFAULT_VALUE = exports.SET_PARAMETER_VALUE = exports.SET_PARAMETER_NAME = exports.SET_PARAMETER_MAPPING = exports.REMOVE_PARAMETER = exports.ADD_PARAMETER = exports.SET_EDITING_PARAMETER_ID = exports.MARK_NEW_CARD_SEEN = exports.REVERT_TO_REVISION = exports.FETCH_REVISIONS = exports.CLEAR_CARD_DATA = exports.MARK_CARD_AS_SLOW = exports.FETCH_CARD_DATA = exports.FETCH_DASHBOARD_CARD_DATA = exports.UPDATE_DASHCARD_ID = exports.REPLACE_ALL_DASHCARD_VISUALIZATION_SETTINGS = exports.UPDATE_DASHCARD_VISUALIZATION_SETTINGS = exports.SET_DASHCARD_ATTRIBUTES = exports.REMOVE_CARD_FROM_DASH = exports.ADD_CARD_TO_DASH = exports.SET_DASHBOARD_ATTRIBUTES = exports.SAVE_DASHBOARD_AND_CARDS = exports.FETCH_DASHBOARD = exports.DELETE_CARD = exports.FETCH_CARDS = exports.SET_EDITING_DASHBOARD = exports.INITIALIZE = undefined;
	
	var _handleActions, _handleActions2, _handleActions4, _handleActions5, _handleActions6, _handleActions7, _handleActions9, _handleActions11;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var fetchDataOrError = exports.fetchDataOrError = function () {
	    var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dataPromise) {
	        return regeneratorRuntime.wrap(function _callee6$(_context6) {
	            while (1) {
	                switch (_context6.prev = _context6.next) {
	                    case 0:
	                        _context6.prev = 0;
	                        _context6.next = 3;
	                        return dataPromise;
	
	                    case 3:
	                        return _context6.abrupt("return", _context6.sent);
	
	                    case 6:
	                        _context6.prev = 6;
	                        _context6.t0 = _context6["catch"](0);
	                        return _context6.abrupt("return", { error: _context6.t0 });
	
	                    case 9:
	                    case "end":
	                        return _context6.stop();
	                }
	            }
	        }, _callee6, this, [[0, 6]]);
	    }));
	
	    return function fetchDataOrError(_x10) {
	        return _ref8.apply(this, arguments);
	    };
	}();
	
	var _icepick = __webpack_require__(855);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _redux = __webpack_require__(657);
	
	var _normalizr = __webpack_require__(1111);
	
	var _dashboards = __webpack_require__(1521);
	
	var _Dashboard = __webpack_require__(1519);
	
	var _Card = __webpack_require__(957);
	
	var _Parameter = __webpack_require__(958);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _dashboard_grid = __webpack_require__(1522);
	
	var _metadata = __webpack_require__(1110);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _services = __webpack_require__(857);
	
	var _selectors = __webpack_require__(1518);
	
	var _utils3 = __webpack_require__(878);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /*  weak */
	
	var DATASET_SLOW_TIMEOUT = 15 * 1000;
	
	// normalizr schemas
	var dashcard = new _normalizr.schema.Entity('dashcard');
	var card = new _normalizr.schema.Entity('card');
	var dashboard = new _normalizr.schema.Entity('dashboard', {
	    ordered_cards: [dashcard]
	});
	
	// action constants
	
	var INITIALIZE = exports.INITIALIZE = "metabase/dashboard/INITIALIZE";
	
	var SET_EDITING_DASHBOARD = exports.SET_EDITING_DASHBOARD = "metabase/dashboard/SET_EDITING_DASHBOARD";
	
	var FETCH_CARDS = exports.FETCH_CARDS = "metabase/dashboard/FETCH_CARDS";
	var DELETE_CARD = exports.DELETE_CARD = "metabase/dashboard/DELETE_CARD";
	
	// NOTE: this is used in metabase/redux/metadata but can't be imported directly due to circular reference
	var FETCH_DASHBOARD = exports.FETCH_DASHBOARD = "metabase/dashboard/FETCH_DASHBOARD";
	var SAVE_DASHBOARD_AND_CARDS = exports.SAVE_DASHBOARD_AND_CARDS = "metabase/dashboard/SAVE_DASHBOARD_AND_CARDS";
	var SET_DASHBOARD_ATTRIBUTES = exports.SET_DASHBOARD_ATTRIBUTES = "metabase/dashboard/SET_DASHBOARD_ATTRIBUTES";
	
	var ADD_CARD_TO_DASH = exports.ADD_CARD_TO_DASH = "metabase/dashboard/ADD_CARD_TO_DASH";
	var REMOVE_CARD_FROM_DASH = exports.REMOVE_CARD_FROM_DASH = "metabase/dashboard/REMOVE_CARD_FROM_DASH";
	var SET_DASHCARD_ATTRIBUTES = exports.SET_DASHCARD_ATTRIBUTES = "metabase/dashboard/SET_DASHCARD_ATTRIBUTES";
	var UPDATE_DASHCARD_VISUALIZATION_SETTINGS = exports.UPDATE_DASHCARD_VISUALIZATION_SETTINGS = "metabase/dashboard/UPDATE_DASHCARD_VISUALIZATION_SETTINGS";
	var REPLACE_ALL_DASHCARD_VISUALIZATION_SETTINGS = exports.REPLACE_ALL_DASHCARD_VISUALIZATION_SETTINGS = "metabase/dashboard/REPLACE_ALL_DASHCARD_VISUALIZATION_SETTINGS";
	var UPDATE_DASHCARD_ID = exports.UPDATE_DASHCARD_ID = "metabase/dashboard/UPDATE_DASHCARD_ID";
	
	var FETCH_DASHBOARD_CARD_DATA = exports.FETCH_DASHBOARD_CARD_DATA = "metabase/dashboard/FETCH_DASHBOARD_CARD_DATA";
	var FETCH_CARD_DATA = exports.FETCH_CARD_DATA = "metabase/dashboard/FETCH_CARD_DATA";
	var MARK_CARD_AS_SLOW = exports.MARK_CARD_AS_SLOW = "metabase/dashboard/MARK_CARD_AS_SLOW";
	var CLEAR_CARD_DATA = exports.CLEAR_CARD_DATA = "metabase/dashboard/CLEAR_CARD_DATA";
	
	var FETCH_REVISIONS = exports.FETCH_REVISIONS = "metabase/dashboard/FETCH_REVISIONS";
	var REVERT_TO_REVISION = exports.REVERT_TO_REVISION = "metabase/dashboard/REVERT_TO_REVISION";
	
	var MARK_NEW_CARD_SEEN = exports.MARK_NEW_CARD_SEEN = "metabase/dashboard/MARK_NEW_CARD_SEEN";
	
	var SET_EDITING_PARAMETER_ID = exports.SET_EDITING_PARAMETER_ID = "metabase/dashboard/SET_EDITING_PARAMETER_ID";
	var ADD_PARAMETER = exports.ADD_PARAMETER = "metabase/dashboard/ADD_PARAMETER";
	var REMOVE_PARAMETER = exports.REMOVE_PARAMETER = "metabase/dashboard/REMOVE_PARAMETER";
	var SET_PARAMETER_MAPPING = exports.SET_PARAMETER_MAPPING = "metabase/dashboard/SET_PARAMETER_MAPPING";
	var SET_PARAMETER_NAME = exports.SET_PARAMETER_NAME = "metabase/dashboard/SET_PARAMETER_NAME";
	var SET_PARAMETER_VALUE = exports.SET_PARAMETER_VALUE = "metabase/dashboard/SET_PARAMETER_VALUE";
	var SET_PARAMETER_DEFAULT_VALUE = exports.SET_PARAMETER_DEFAULT_VALUE = "metabase/dashboard/SET_PARAMETER_DEFAULT_VALUE";
	
	function getDashboardType(id) {
	    if (_utils2.default.isUUID(id)) {
	        return "public";
	    } else if (_utils2.default.isJWT(id)) {
	        return "embed";
	    } else {
	        return "normal";
	    }
	}
	
	// action creators
	
	var initialize = exports.initialize = (0, _redux.createAction)(INITIALIZE);
	var setEditingDashboard = exports.setEditingDashboard = (0, _redux.createAction)(SET_EDITING_DASHBOARD);
	
	var markNewCardSeen = exports.markNewCardSeen = (0, _redux.createAction)(MARK_NEW_CARD_SEEN);
	
	// these operations don't get saved to server immediately
	var setDashboardAttributes = exports.setDashboardAttributes = (0, _redux.createAction)(SET_DASHBOARD_ATTRIBUTES);
	var setDashCardAttributes = exports.setDashCardAttributes = (0, _redux.createAction)(SET_DASHCARD_ATTRIBUTES);
	
	// TODO: consolidate with questions reducer
	var fetchCards = exports.fetchCards = (0, _redux.createThunkAction)(FETCH_CARDS, function () {
	    var filterMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "all";
	
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var cards, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, c;
	
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return _services.CardApi.list({ f: filterMode });
	
	                        case 2:
	                            cards = _context.sent;
	                            _iteratorNormalCompletion = true;
	                            _didIteratorError = false;
	                            _iteratorError = undefined;
	                            _context.prev = 6;
	
	                            for (_iterator = cards[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                c = _step.value;
	
	                                c.updated_at = (0, _moment2.default)(c.updated_at);
	                            }
	                            _context.next = 14;
	                            break;
	
	                        case 10:
	                            _context.prev = 10;
	                            _context.t0 = _context["catch"](6);
	                            _didIteratorError = true;
	                            _iteratorError = _context.t0;
	
	                        case 14:
	                            _context.prev = 14;
	                            _context.prev = 15;
	
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	
	                        case 17:
	                            _context.prev = 17;
	
	                            if (!_didIteratorError) {
	                                _context.next = 20;
	                                break;
	                            }
	
	                            throw _iteratorError;
	
	                        case 20:
	                            return _context.finish(17);
	
	                        case 21:
	                            return _context.finish(14);
	
	                        case 22:
	                            return _context.abrupt("return", (0, _normalizr.normalize)(cards, [card]));
	
	                        case 23:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[6, 10, 14, 22], [15,, 17, 21]]);
	        }));
	
	        return function (_x2, _x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var deleteCard = exports.deleteCard = (0, _redux.createThunkAction)(DELETE_CARD, function (cardId) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.next = 2;
	                            return _services.CardApi.delete({ cardId: cardId });
	
	                        case 2:
	                            return _context2.abrupt("return", cardId);
	
	                        case 3:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        return function (_x4, _x5) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	var addCardToDashboard = exports.addCardToDashboard = function addCardToDashboard(_ref3) {
	    var dashId = _ref3.dashId,
	        cardId = _ref3.cardId;
	
	    return function (dispatch, getState) {
	        var _getState$dashboard = getState().dashboard,
	            dashboards = _getState$dashboard.dashboards,
	            dashcards = _getState$dashboard.dashcards,
	            cards = _getState$dashboard.cards;
	
	        var dashboard = dashboards[dashId];
	        var existingCards = dashboard.ordered_cards.map(function (id) {
	            return dashcards[id];
	        }).filter(function (dc) {
	            return !dc.isRemoved;
	        });
	        var card = cards[cardId];
	        var dashcard = _extends({
	            id: Math.random(), // temporary id
	            dashboard_id: dashId,
	            card_id: card.id,
	            card: card,
	            series: []
	        }, (0, _dashboard_grid.getPositionForNewDashCard)(existingCards), {
	            parameter_mappings: [],
	            visualization_settings: {}
	        });
	        dispatch((0, _redux.createAction)(ADD_CARD_TO_DASH)(dashcard));
	        dispatch(fetchCardData(card, dashcard, { reload: true, clear: true }));
	    };
	};
	
	var saveDashboardAndCards = exports.saveDashboardAndCards = (0, _redux.createThunkAction)(SAVE_DASHBOARD_AND_CARDS, function () {
	    return function () {
	        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
	            var _this = this;
	
	            var _getState$dashboard2, dashboards, dashcards, dashboardId, dashboard, updatedDashcards, id, name, description, parameters, _cards, result;
	
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            _getState$dashboard2 = getState().dashboard, dashboards = _getState$dashboard2.dashboards, dashcards = _getState$dashboard2.dashcards, dashboardId = _getState$dashboard2.dashboardId;
	                            dashboard = _extends({}, dashboards[dashboardId], {
	                                ordered_cards: dashboards[dashboardId].ordered_cards.map(function (dashcardId) {
	                                    return dashcards[dashcardId];
	                                })
	                            });
	
	                            // remove isRemoved dashboards
	
	                            _context5.next = 4;
	                            return Promise.all(dashboard.ordered_cards.filter(function (dc) {
	                                return dc.isRemoved && !dc.isAdded;
	                            }).map(function (dc) {
	                                return _services.DashboardApi.removecard({ dashId: dashboard.id, dashcardId: dc.id });
	                            }));
	
	                        case 4:
	                            _context5.next = 6;
	                            return Promise.all(dashboard.ordered_cards.filter(function (dc) {
	                                return !dc.isRemoved;
	                            }).map(function () {
	                                var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dc) {
	                                    var result;
	                                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                                        while (1) {
	                                            switch (_context3.prev = _context3.next) {
	                                                case 0:
	                                                    if (!dc.isAdded) {
	                                                        _context3.next = 8;
	                                                        break;
	                                                    }
	
	                                                    _context3.next = 3;
	                                                    return _services.DashboardApi.addcard({ dashId: dashboard.id, cardId: dc.card_id });
	
	                                                case 3:
	                                                    result = _context3.sent;
	
	                                                    dispatch(updateDashcardId(dc.id, result.id));
	
	                                                    // mark isAdded because addcard doesn't record the position
	                                                    return _context3.abrupt("return", _extends({}, result, {
	                                                        col: dc.col, row: dc.row,
	                                                        sizeX: dc.sizeX, sizeY: dc.sizeY,
	                                                        series: dc.series,
	                                                        parameter_mappings: dc.parameter_mappings,
	                                                        visualization_settings: dc.visualization_settings,
	                                                        isAdded: true
	                                                    }));
	
	                                                case 8:
	                                                    return _context3.abrupt("return", dc);
	
	                                                case 9:
	                                                case "end":
	                                                    return _context3.stop();
	                                            }
	                                        }
	                                    }, _callee3, _this);
	                                }));
	
	                                return function (_x8) {
	                                    return _ref5.apply(this, arguments);
	                                };
	                            }()));
	
	                        case 6:
	                            updatedDashcards = _context5.sent;
	                            _context5.next = 9;
	                            return Promise.all(dashboard.ordered_cards.filter(function (dc) {
	                                return dc.card.isDirty;
	                            }).map(function () {
	                                var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dc) {
	                                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                                        while (1) {
	                                            switch (_context4.prev = _context4.next) {
	                                                case 0:
	                                                    return _context4.abrupt("return", _services.CardApi.update(dc.card));
	
	                                                case 1:
	                                                case "end":
	                                                    return _context4.stop();
	                                            }
	                                        }
	                                    }, _callee4, _this);
	                                }));
	
	                                return function (_x9) {
	                                    return _ref6.apply(this, arguments);
	                                };
	                            }()));
	
	                        case 9:
	                            if (!dashboard.isDirty) {
	                                _context5.next = 13;
	                                break;
	                            }
	
	                            id = dashboard.id, name = dashboard.name, description = dashboard.description, parameters = dashboard.parameters;
	                            _context5.next = 13;
	                            return dispatch((0, _dashboards.saveDashboard)({ id: id, name: name, description: description, parameters: parameters }));
	
	                        case 13:
	                            if (!_underscore2.default.some(updatedDashcards, function (dc) {
	                                return dc.isDirty || dc.isAdded;
	                            })) {
	                                _context5.next = 20;
	                                break;
	                            }
	
	                            _cards = updatedDashcards.map(function (_ref7) {
	                                var id = _ref7.id,
	                                    card_id = _ref7.card_id,
	                                    row = _ref7.row,
	                                    col = _ref7.col,
	                                    sizeX = _ref7.sizeX,
	                                    sizeY = _ref7.sizeY,
	                                    series = _ref7.series,
	                                    parameter_mappings = _ref7.parameter_mappings,
	                                    visualization_settings = _ref7.visualization_settings;
	                                return {
	                                    id: id, card_id: card_id, row: row, col: col, sizeX: sizeX, sizeY: sizeY, series: series, visualization_settings: visualization_settings,
	                                    parameter_mappings: parameter_mappings && parameter_mappings.filter(function (mapping) {
	                                        return (
	                                            // filter out mappings for deleted paramters
	                                            _underscore2.default.findWhere(dashboard.parameters, { id: mapping.parameter_id }) && (
	                                            // filter out mappings for deleted series
	                                            card_id === mapping.card_id || _underscore2.default.findWhere(series, { id: mapping.card_id }))
	                                        );
	                                    })
	                                };
	                            });
	                            _context5.next = 17;
	                            return _services.DashboardApi.reposition_cards({ dashId: dashboard.id, cards: _cards });
	
	                        case 17:
	                            result = _context5.sent;
	
	                            if (!(result.status !== "ok")) {
	                                _context5.next = 20;
	                                break;
	                            }
	
	                            throw new Error(result.status);
	
	                        case 20:
	                            _context5.next = 22;
	                            return dispatch((0, _dashboards.saveDashboard)(dashboard));
	
	                        case 22:
	
	                            // make sure that we've fully cleared out any dirty state from editing (this is overkill, but simple)
	                            dispatch(fetchDashboard(dashboard.id, null, true)); // disable using query parameters when saving
	
	                        case 23:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, this);
	        }));
	
	        return function (_x6, _x7) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	});
	
	var removeCardFromDashboard = exports.removeCardFromDashboard = (0, _redux.createAction)(REMOVE_CARD_FROM_DASH);
	
	var updateDashcardId = (0, _redux.createAction)(UPDATE_DASHCARD_ID, function (oldDashcardId, newDashcardId) {
	    return { oldDashcardId: oldDashcardId, newDashcardId: newDashcardId };
	});
	
	var clearCardData = exports.clearCardData = (0, _redux.createAction)(CLEAR_CARD_DATA, function (cardId, dashcardId) {
	    return { cardId: cardId, dashcardId: dashcardId };
	});
	
	var fetchDashboardCardData = exports.fetchDashboardCardData = (0, _redux.createThunkAction)(FETCH_DASHBOARD_CARD_DATA, function (options) {
	    return function () {
	        var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
	            var dashboard, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _dashcard, _cards2, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _card;
	
	            return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            dashboard = (0, _selectors.getDashboardComplete)(getState());
	
	                            if (!dashboard) {
	                                _context7.next = 46;
	                                break;
	                            }
	
	                            _iteratorNormalCompletion2 = true;
	                            _didIteratorError2 = false;
	                            _iteratorError2 = undefined;
	                            _context7.prev = 5;
	                            _iterator2 = dashboard.ordered_cards[Symbol.iterator]();
	
	                        case 7:
	                            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                                _context7.next = 32;
	                                break;
	                            }
	
	                            _dashcard = _step2.value;
	                            _cards2 = [_dashcard.card].concat(_dashcard.series || []);
	                            _iteratorNormalCompletion3 = true;
	                            _didIteratorError3 = false;
	                            _iteratorError3 = undefined;
	                            _context7.prev = 13;
	
	                            for (_iterator3 = _cards2[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                                _card = _step3.value;
	
	                                dispatch(fetchCardData(_card, _dashcard, options));
	                            }
	                            _context7.next = 21;
	                            break;
	
	                        case 17:
	                            _context7.prev = 17;
	                            _context7.t0 = _context7["catch"](13);
	                            _didIteratorError3 = true;
	                            _iteratorError3 = _context7.t0;
	
	                        case 21:
	                            _context7.prev = 21;
	                            _context7.prev = 22;
	
	                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                                _iterator3.return();
	                            }
	
	                        case 24:
	                            _context7.prev = 24;
	
	                            if (!_didIteratorError3) {
	                                _context7.next = 27;
	                                break;
	                            }
	
	                            throw _iteratorError3;
	
	                        case 27:
	                            return _context7.finish(24);
	
	                        case 28:
	                            return _context7.finish(21);
	
	                        case 29:
	                            _iteratorNormalCompletion2 = true;
	                            _context7.next = 7;
	                            break;
	
	                        case 32:
	                            _context7.next = 38;
	                            break;
	
	                        case 34:
	                            _context7.prev = 34;
	                            _context7.t1 = _context7["catch"](5);
	                            _didIteratorError2 = true;
	                            _iteratorError2 = _context7.t1;
	
	                        case 38:
	                            _context7.prev = 38;
	                            _context7.prev = 39;
	
	                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                _iterator2.return();
	                            }
	
	                        case 41:
	                            _context7.prev = 41;
	
	                            if (!_didIteratorError2) {
	                                _context7.next = 44;
	                                break;
	                            }
	
	                            throw _iteratorError2;
	
	                        case 44:
	                            return _context7.finish(41);
	
	                        case 45:
	                            return _context7.finish(38);
	
	                        case 46:
	                        case "end":
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, undefined, [[5, 34, 38, 46], [13, 17, 21, 29], [22,, 24, 28], [39,, 41, 45]]);
	        }));
	
	        return function (_x11, _x12) {
	            return _ref9.apply(this, arguments);
	        };
	    }();
	});
	
	var fetchCardData = exports.fetchCardData = (0, _redux.createThunkAction)(FETCH_CARD_DATA, function (card, dashcard) {
	    var _ref10 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	        reload = _ref10.reload,
	        clear = _ref10.clear;
	
	    return function () {
	        var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(dispatch, getState) {
	            var dashboardType, _getState$dashboard3, dashboardId, dashboards, parameterValues, dashcardData, dashboard, datasetQuery, lastResult, result, slowCardTimer;
	
	            return regeneratorRuntime.wrap(function _callee8$(_context8) {
	                while (1) {
	                    switch (_context8.prev = _context8.next) {
	                        case 0:
	                            if (card.dataset_query) {
	                                _context8.next = 2;
	                                break;
	                            }
	
	                            return _context8.abrupt("return", {
	                                dashcard_id: dashcard.id,
	                                card_id: card.id,
	                                result: { error: { status: 403 } }
	                            });
	
	                        case 2:
	                            dashboardType = getDashboardType(dashcard.dashboard_id);
	                            _getState$dashboard3 = getState().dashboard, dashboardId = _getState$dashboard3.dashboardId, dashboards = _getState$dashboard3.dashboards, parameterValues = _getState$dashboard3.parameterValues, dashcardData = _getState$dashboard3.dashcardData;
	                            dashboard = dashboards[dashboardId];
	
	                            // if we have a parameter, apply it to the card query before we execute
	
	                            datasetQuery = (0, _Card.applyParameters)(card, dashboard.parameters, parameterValues, dashcard && dashcard.parameter_mappings);
	
	                            if (reload) {
	                                _context8.next = 10;
	                                break;
	                            }
	
	                            // if reload not set, check to see if the last result has the same query dict and return that
	                            lastResult = (0, _icepick.getIn)(dashcardData, [dashcard.id, card.id]);
	                            // "constraints" is added by the backend, remove it when comparing
	
	                            if (!(lastResult && _utils2.default.equals(_underscore2.default.omit(lastResult.json_query, "constraints"), datasetQuery))) {
	                                _context8.next = 10;
	                                break;
	                            }
	
	                            return _context8.abrupt("return", {
	                                dashcard_id: dashcard.id,
	                                card_id: card.id,
	                                result: lastResult
	                            });
	
	                        case 10:
	
	                            if (clear) {
	                                // clears the card data to indicate the card is reloading
	                                dispatch(clearCardData(card.id, dashcard.id));
	                            }
	
	                            result = null;
	
	                            // start a timer that will show the expected card duration if the query takes too long
	
	                            slowCardTimer = setTimeout(function () {
	                                if (result === null) {
	                                    dispatch(markCardAsSlow(card, datasetQuery));
	                                }
	                            }, DATASET_SLOW_TIMEOUT);
	
	                            // make the actual request
	
	                            if (!(dashboardType === "public")) {
	                                _context8.next = 19;
	                                break;
	                            }
	
	                            _context8.next = 16;
	                            return fetchDataOrError(_services.PublicApi.dashboardCardQuery({
	                                uuid: dashcard.dashboard_id,
	                                cardId: card.id,
	                                parameters: datasetQuery.parameters ? JSON.stringify(datasetQuery.parameters) : undefined
	                            }));
	
	                        case 16:
	                            result = _context8.sent;
	                            _context8.next = 28;
	                            break;
	
	                        case 19:
	                            if (!(dashboardType === "embed")) {
	                                _context8.next = 25;
	                                break;
	                            }
	
	                            _context8.next = 22;
	                            return fetchDataOrError(_services.EmbedApi.dashboardCardQuery(_extends({
	                                token: dashcard.dashboard_id,
	                                dashcardId: dashcard.id,
	                                cardId: card.id
	                            }, (0, _Parameter.getParametersBySlug)(dashboard.parameters, parameterValues))));
	
	                        case 22:
	                            result = _context8.sent;
	                            _context8.next = 28;
	                            break;
	
	                        case 25:
	                            _context8.next = 27;
	                            return fetchDataOrError(_services.CardApi.query({ cardId: card.id, parameters: datasetQuery.parameters }));
	
	                        case 27:
	                            result = _context8.sent;
	
	                        case 28:
	
	                            clearTimeout(slowCardTimer);
	
	                            return _context8.abrupt("return", {
	                                dashcard_id: dashcard.id,
	                                card_id: card.id,
	                                result: result
	                            });
	
	                        case 30:
	                        case "end":
	                            return _context8.stop();
	                    }
	                }
	            }, _callee8, this);
	        }));
	
	        return function (_x14, _x15) {
	            return _ref11.apply(this, arguments);
	        };
	    }();
	});
	
	var markCardAsSlow = exports.markCardAsSlow = (0, _redux.createAction)(MARK_CARD_AS_SLOW, function (card) {
	    return {
	        id: card.id,
	        result: true
	    };
	});
	
	var fetchDashboard = exports.fetchDashboard = (0, _redux.createThunkAction)(FETCH_DASHBOARD, function (dashId, queryParams) {
	    var enableDefaultParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    var result = void 0;
	    return function () {
	        var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState) {
	            var dashboardType, parameterValues, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, parameter;
	
	            return regeneratorRuntime.wrap(function _callee9$(_context9) {
	                while (1) {
	                    switch (_context9.prev = _context9.next) {
	                        case 0:
	                            dashboardType = getDashboardType(dashId);
	
	                            if (!(dashboardType === "public")) {
	                                _context9.next = 8;
	                                break;
	                            }
	
	                            _context9.next = 4;
	                            return _services.PublicApi.dashboard({ uuid: dashId });
	
	                        case 4:
	                            result = _context9.sent;
	
	                            result = _extends({}, result, {
	                                id: dashId,
	                                ordered_cards: result.ordered_cards.map(function (dc) {
	                                    return _extends({}, dc, {
	                                        dashboard_id: dashId
	                                    });
	                                })
	                            });
	                            _context9.next = 18;
	                            break;
	
	                        case 8:
	                            if (!(dashboardType === "embed")) {
	                                _context9.next = 15;
	                                break;
	                            }
	
	                            _context9.next = 11;
	                            return _services.EmbedApi.dashboard({ token: dashId });
	
	                        case 11:
	                            result = _context9.sent;
	
	                            result = _extends({}, result, {
	                                id: dashId,
	                                ordered_cards: result.ordered_cards.map(function (dc) {
	                                    return _extends({}, dc, {
	                                        dashboard_id: dashId
	                                    });
	                                })
	                            });
	                            _context9.next = 18;
	                            break;
	
	                        case 15:
	                            _context9.next = 17;
	                            return _services.DashboardApi.get({ dashId: dashId });
	
	                        case 17:
	                            result = _context9.sent;
	
	                        case 18:
	                            parameterValues = {};
	
	                            if (!result.parameters) {
	                                _context9.next = 39;
	                                break;
	                            }
	
	                            _iteratorNormalCompletion4 = true;
	                            _didIteratorError4 = false;
	                            _iteratorError4 = undefined;
	                            _context9.prev = 23;
	
	                            for (_iterator4 = result.parameters[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                                parameter = _step4.value;
	
	                                if (queryParams && queryParams[parameter.slug] != null) {
	                                    parameterValues[parameter.id] = queryParams[parameter.slug];
	                                } else if (enableDefaultParameters && parameter.default != null) {
	                                    parameterValues[parameter.id] = parameter.default;
	                                }
	                            }
	                            _context9.next = 31;
	                            break;
	
	                        case 27:
	                            _context9.prev = 27;
	                            _context9.t0 = _context9["catch"](23);
	                            _didIteratorError4 = true;
	                            _iteratorError4 = _context9.t0;
	
	                        case 31:
	                            _context9.prev = 31;
	                            _context9.prev = 32;
	
	                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                                _iterator4.return();
	                            }
	
	                        case 34:
	                            _context9.prev = 34;
	
	                            if (!_didIteratorError4) {
	                                _context9.next = 37;
	                                break;
	                            }
	
	                            throw _iteratorError4;
	
	                        case 37:
	                            return _context9.finish(34);
	
	                        case 38:
	                            return _context9.finish(31);
	
	                        case 39:
	
	                            if (dashboardType === "normal") {
	                                // fetch database metadata for every card
	                                _underscore2.default.chain(result.ordered_cards).map(function (dc) {
	                                    return [dc.card].concat(dc.series);
	                                }).flatten().filter(function (card) {
	                                    return card && card.dataset_query && card.dataset_query.database;
	                                }).map(function (card) {
	                                    return card.dataset_query.database;
	                                }).uniq().each(function (dbId) {
	                                    return dispatch((0, _metadata.fetchDatabaseMetadata)(dbId));
	                                });
	                            }
	
	                            if (result.param_values) {
	                                dispatch((0, _metadata.addParamValues)(result.param_values));
	                            }
	
	                            return _context9.abrupt("return", _extends({}, (0, _normalizr.normalize)(result, dashboard), { // includes `result` and `entities`
	                                dashboardId: dashId,
	                                parameterValues: parameterValues
	                            }));
	
	                        case 42:
	                        case "end":
	                            return _context9.stop();
	                    }
	                }
	            }, _callee9, this, [[23, 27, 31, 39], [32,, 34, 38]]);
	        }));
	
	        return function (_x17, _x18) {
	            return _ref12.apply(this, arguments);
	        };
	    }();
	});
	
	var UPDATE_ENABLE_EMBEDDING = "metabase/dashboard/UPDATE_ENABLE_EMBEDDING";
	var updateEnableEmbedding = exports.updateEnableEmbedding = (0, _redux.createAction)(UPDATE_ENABLE_EMBEDDING, function (_ref13, enable_embedding) {
	    var id = _ref13.id;
	    return _services.DashboardApi.update({ id: id, enable_embedding: enable_embedding });
	});
	
	var UPDATE_EMBEDDING_PARAMS = "metabase/dashboard/UPDATE_EMBEDDING_PARAMS";
	var updateEmbeddingParams = exports.updateEmbeddingParams = (0, _redux.createAction)(UPDATE_EMBEDDING_PARAMS, function (_ref14, embedding_params) {
	    var id = _ref14.id;
	    return _services.DashboardApi.update({ id: id, embedding_params: embedding_params });
	});
	
	var fetchRevisions = exports.fetchRevisions = (0, _redux.createThunkAction)(FETCH_REVISIONS, function (_ref15) {
	    var entity = _ref15.entity,
	        id = _ref15.id;
	
	    return function () {
	        var _ref16 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(dispatch, getState) {
	            var revisions;
	            return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                while (1) {
	                    switch (_context10.prev = _context10.next) {
	                        case 0:
	                            _context10.next = 2;
	                            return _services.RevisionApi.list({ entity: entity, id: id });
	
	                        case 2:
	                            revisions = _context10.sent;
	                            return _context10.abrupt("return", { entity: entity, id: id, revisions: revisions });
	
	                        case 4:
	                        case "end":
	                            return _context10.stop();
	                    }
	                }
	            }, _callee10, this);
	        }));
	
	        return function (_x19, _x20) {
	            return _ref16.apply(this, arguments);
	        };
	    }();
	});
	
	var revertToRevision = exports.revertToRevision = (0, _redux.createThunkAction)(REVERT_TO_REVISION, function (_ref17) {
	    var entity = _ref17.entity,
	        id = _ref17.id,
	        revision_id = _ref17.revision_id;
	
	    return function () {
	        var _ref18 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee11$(_context11) {
	                while (1) {
	                    switch (_context11.prev = _context11.next) {
	                        case 0:
	                            _context11.next = 2;
	                            return _services.RevisionApi.revert({ entity: entity, id: id, revision_id: revision_id });
	
	                        case 2:
	                        case "end":
	                            return _context11.stop();
	                    }
	                }
	            }, _callee11, this);
	        }));
	
	        return function (_x21, _x22) {
	            return _ref18.apply(this, arguments);
	        };
	    }();
	});
	
	var onUpdateDashCardVisualizationSettings = exports.onUpdateDashCardVisualizationSettings = (0, _redux.createAction)(UPDATE_DASHCARD_VISUALIZATION_SETTINGS, function (id, settings) {
	    return { id: id, settings: settings };
	});
	var onReplaceAllDashCardVisualizationSettings = exports.onReplaceAllDashCardVisualizationSettings = (0, _redux.createAction)(REPLACE_ALL_DASHCARD_VISUALIZATION_SETTINGS, function (id, settings) {
	    return { id: id, settings: settings };
	});
	
	var setEditingParameter = exports.setEditingParameter = (0, _redux.createAction)(SET_EDITING_PARAMETER_ID);
	var setParameterMapping = exports.setParameterMapping = (0, _redux.createThunkAction)(SET_PARAMETER_MAPPING, function (parameter_id, dashcard_id, card_id, target) {
	    return function (dispatch, getState) {
	        var parameter_mappings = getState().dashboard.dashcards[dashcard_id].parameter_mappings || [];
	        parameter_mappings = parameter_mappings.filter(function (m) {
	            return m.card_id !== card_id || m.parameter_id !== parameter_id;
	        });
	        if (target) {
	            parameter_mappings = parameter_mappings.concat({ parameter_id: parameter_id, card_id: card_id, target: target });
	        }
	        dispatch(setDashCardAttributes({ id: dashcard_id, attributes: { parameter_mappings: parameter_mappings } }));
	    };
	});
	
	function updateParameter(dispatch, getState, id, parameterUpdater) {
	    var dashboard = (0, _selectors.getDashboard)(getState());
	    var index = _underscore2.default.findIndex(dashboard && dashboard.parameters, function (p) {
	        return p.id === id;
	    });
	    if (index >= 0) {
	        var parameters = (0, _icepick.assoc)(dashboard.parameters, index, parameterUpdater(dashboard.parameters[index]));
	        dispatch(setDashboardAttributes({ id: dashboard.id, attributes: { parameters: parameters } }));
	    }
	}
	
	function updateParameters(dispatch, getState, parametersUpdater) {
	    var dashboard = (0, _selectors.getDashboard)(getState());
	    if (dashboard) {
	        var parameters = parametersUpdater(dashboard.parameters || []);
	        dispatch(setDashboardAttributes({ id: dashboard.id, attributes: { parameters: parameters } }));
	    }
	}
	
	var addParameter = exports.addParameter = (0, _redux.createThunkAction)(ADD_PARAMETER, function (parameterOption) {
	    return function (dispatch, getState) {
	        var parameter = void 0;
	        updateParameters(dispatch, getState, function (parameters) {
	            parameter = (0, _Dashboard.createParameter)(parameterOption, parameters);
	            return parameters.concat(parameter);
	        });
	        return parameter;
	    };
	});
	
	var removeParameter = exports.removeParameter = (0, _redux.createThunkAction)(REMOVE_PARAMETER, function (parameterId) {
	    return function (dispatch, getState) {
	        updateParameters(dispatch, getState, function (parameters) {
	            return parameters.filter(function (p) {
	                return p.id !== parameterId;
	            });
	        });
	        return { id: parameterId };
	    };
	});
	
	var setParameterName = exports.setParameterName = (0, _redux.createThunkAction)(SET_PARAMETER_NAME, function (parameterId, name) {
	    return function (dispatch, getState) {
	        updateParameter(dispatch, getState, parameterId, function (parameter) {
	            return (0, _Dashboard.setParameterName)(parameter, name);
	        });
	        return { id: parameterId, name: name };
	    };
	});
	
	var setParameterDefaultValue = exports.setParameterDefaultValue = (0, _redux.createThunkAction)(SET_PARAMETER_DEFAULT_VALUE, function (parameterId, defaultValue) {
	    return function (dispatch, getState) {
	        updateParameter(dispatch, getState, parameterId, function (parameter) {
	            return (0, _Dashboard.setParameterDefaultValue)(parameter, defaultValue);
	        });
	        return { id: parameterId, defaultValue: defaultValue };
	    };
	});
	
	var setParameterValue = exports.setParameterValue = (0, _redux.createThunkAction)(SET_PARAMETER_VALUE, function (parameterId, value) {
	    return function (dispatch, getState) {
	        return { id: parameterId, value: value };
	    };
	});
	
	var CREATE_PUBLIC_LINK = exports.CREATE_PUBLIC_LINK = "metabase/dashboard/CREATE_PUBLIC_LINK";
	var createPublicLink = exports.createPublicLink = (0, _redux.createAction)(CREATE_PUBLIC_LINK, function () {
	    var _ref19 = _asyncToGenerator(regeneratorRuntime.mark(function _callee12(_ref20) {
	        var id = _ref20.id;
	
	        var _ref21, uuid;
	
	        return regeneratorRuntime.wrap(function _callee12$(_context12) {
	            while (1) {
	                switch (_context12.prev = _context12.next) {
	                    case 0:
	                        _context12.next = 2;
	                        return _services.DashboardApi.createPublicLink({ id: id });
	
	                    case 2:
	                        _ref21 = _context12.sent;
	                        uuid = _ref21.uuid;
	                        return _context12.abrupt("return", { id: id, uuid: uuid });
	
	                    case 5:
	                    case "end":
	                        return _context12.stop();
	                }
	            }
	        }, _callee12, undefined);
	    }));
	
	    return function (_x23) {
	        return _ref19.apply(this, arguments);
	    };
	}());
	
	var DELETE_PUBLIC_LINK = exports.DELETE_PUBLIC_LINK = "metabase/dashboard/DELETE_PUBLIC_LINK";
	var deletePublicLink = exports.deletePublicLink = (0, _redux.createAction)(DELETE_PUBLIC_LINK, function () {
	    var _ref22 = _asyncToGenerator(regeneratorRuntime.mark(function _callee13(_ref23) {
	        var id = _ref23.id;
	        return regeneratorRuntime.wrap(function _callee13$(_context13) {
	            while (1) {
	                switch (_context13.prev = _context13.next) {
	                    case 0:
	                        _context13.next = 2;
	                        return _services.DashboardApi.deletePublicLink({ id: id });
	
	                    case 2:
	                        return _context13.abrupt("return", { id: id });
	
	                    case 3:
	                    case "end":
	                        return _context13.stop();
	                }
	            }
	        }, _callee13, undefined);
	    }));
	
	    return function (_x24) {
	        return _ref22.apply(this, arguments);
	    };
	}());
	
	/**
	 * All navigation actions from dashboards to cards (e.x. clicking a title, drill through)
	 * should go through this action, which merges any currently applied dashboard filters
	 * into the new card / URL parameters.
	 *
	 * User-triggered events that are handled here:
	 *     - clicking a dashcard legend:
	 *         * question title legend (only for single-question cards)
	 *         * series legend (multi-aggregation, multi-breakout, multiple questions)
	 *     - clicking the visualization inside dashcard
	 *         * drill-through (single series, multi-aggregation, multi-breakout, multiple questions)
	 *         * (not in 0.24.2 yet: drag on line/area/bar visualization)
	 *     - those all can be applied without or with a dashboard filter
	 */
	
	var NAVIGATE_TO_NEW_CARD = "metabase/dashboard/NAVIGATE_TO_NEW_CARD";
	var navigateToNewCardFromDashboard = exports.navigateToNewCardFromDashboard = (0, _redux.createThunkAction)(NAVIGATE_TO_NEW_CARD, function (_ref24) {
	    var nextCard = _ref24.nextCard,
	        previousCard = _ref24.previousCard,
	        dashcard = _ref24.dashcard;
	    return function (dispatch, getState) {
	        var _getState = getState(),
	            metadata = _getState.metadata;
	
	        var _getState$dashboard4 = getState().dashboard,
	            dashboardId = _getState$dashboard4.dashboardId,
	            dashboards = _getState$dashboard4.dashboards,
	            parameterValues = _getState$dashboard4.parameterValues;
	
	        var dashboard = dashboards[dashboardId];
	        var cardIsDirty = !_underscore2.default.isEqual(previousCard.dataset_query, nextCard.dataset_query);
	        var cardAfterClick = (0, _utils3.getCardAfterVisualizationClick)(nextCard, previousCard);
	
	        // clicking graph title with a filter applied loses display type and visualization settings; see #5278
	        var cardWithVizSettings = _extends({}, cardAfterClick, {
	            display: cardAfterClick.display || previousCard.display,
	            visualization_settings: cardAfterClick.visualization_settings || previousCard.visualization_settings
	        });
	
	        var url = (0, _Card.questionUrlWithParameters)(cardWithVizSettings, metadata, dashboard.parameters, parameterValues, dashcard && dashcard.parameter_mappings, cardIsDirty);
	
	        dispatch((0, _reactRouterRedux.push)(url));
	    };
	});
	
	// reducers
	
	var dashboardId = (0, _redux.handleActions)((_handleActions = {}, _defineProperty(_handleActions, INITIALIZE, { next: function next(state) {
	        return null;
	    } }), _defineProperty(_handleActions, FETCH_DASHBOARD, { next: function next(state, _ref25) {
	        var dashboardId = _ref25.payload.dashboardId;
	        return dashboardId;
	    } }), _handleActions), null);
	
	var isEditing = (0, _redux.handleActions)((_handleActions2 = {}, _defineProperty(_handleActions2, INITIALIZE, { next: function next(state) {
	        return false;
	    } }), _defineProperty(_handleActions2, SET_EDITING_DASHBOARD, { next: function next(state, _ref26) {
	        var payload = _ref26.payload;
	        return payload;
	    } }), _handleActions2), false);
	
	// TODO: consolidate with questions reducer
	var cards = (0, _redux.handleActions)(_defineProperty({}, FETCH_CARDS, { next: function next(state, _ref27) {
	        var payload = _ref27.payload;
	        return _extends({}, payload.entities.card);
	    } }), {});
	
	var cardList = (0, _redux.handleActions)((_handleActions4 = {}, _defineProperty(_handleActions4, FETCH_CARDS, { next: function next(state, _ref28) {
	        var payload = _ref28.payload;
	        return payload.result;
	    } }), _defineProperty(_handleActions4, DELETE_CARD, { next: function next(state, _ref29) {
	        var payload = _ref29.payload;
	        return state;
	    } }), _handleActions4), null);
	
	var dashboards = (0, _redux.handleActions)((_handleActions5 = {}, _defineProperty(_handleActions5, FETCH_DASHBOARD, { next: function next(state, _ref30) {
	        var payload = _ref30.payload;
	        return _extends({}, state, payload.entities.dashboard);
	    } }), _defineProperty(_handleActions5, SET_DASHBOARD_ATTRIBUTES, {
	    next: function next(state, _ref31) {
	        var _ref31$payload = _ref31.payload,
	            id = _ref31$payload.id,
	            attributes = _ref31$payload.attributes;
	        return _extends({}, state, _defineProperty({}, id, _extends({}, state[id], attributes, { isDirty: true })));
	    }
	}), _defineProperty(_handleActions5, ADD_CARD_TO_DASH, function (state, _ref32) {
	    var dashcard = _ref32.payload;
	    return _extends({}, state, _defineProperty({}, dashcard.dashboard_id, _extends({}, state[dashcard.dashboard_id], { ordered_cards: [].concat(_toConsumableArray(state[dashcard.dashboard_id].ordered_cards), [dashcard.id]) })));
	}), _defineProperty(_handleActions5, CREATE_PUBLIC_LINK, { next: function next(state, _ref33) {
	        var payload = _ref33.payload;
	        return (0, _icepick.assocIn)(state, [payload.id, "public_uuid"], payload.uuid);
	    }
	}), _defineProperty(_handleActions5, DELETE_PUBLIC_LINK, { next: function next(state, _ref34) {
	        var payload = _ref34.payload;
	        return (0, _icepick.assocIn)(state, [payload.id, "public_uuid"], null);
	    }
	}), _defineProperty(_handleActions5, UPDATE_EMBEDDING_PARAMS, { next: function next(state, _ref35) {
	        var payload = _ref35.payload;
	        return (0, _icepick.assocIn)(state, [payload.id, "embedding_params"], payload.embedding_params);
	    }
	}), _defineProperty(_handleActions5, UPDATE_ENABLE_EMBEDDING, { next: function next(state, _ref36) {
	        var payload = _ref36.payload;
	        return (0, _icepick.assocIn)(state, [payload.id, "enable_embedding"], payload.enable_embedding);
	    }
	}), _handleActions5), {});
	
	var dashcards = (0, _redux.handleActions)((_handleActions6 = {}, _defineProperty(_handleActions6, FETCH_DASHBOARD, { next: function next(state, _ref37) {
	        var payload = _ref37.payload;
	        return _extends({}, state, payload.entities.dashcard);
	    } }), _defineProperty(_handleActions6, SET_DASHCARD_ATTRIBUTES, {
	    next: function next(state, _ref38) {
	        var _ref38$payload = _ref38.payload,
	            id = _ref38$payload.id,
	            attributes = _ref38$payload.attributes;
	        return _extends({}, state, _defineProperty({}, id, _extends({}, state[id], attributes, { isDirty: true })));
	    }
	}), _defineProperty(_handleActions6, UPDATE_DASHCARD_VISUALIZATION_SETTINGS, {
	    next: function next(state, _ref39) {
	        var _ref39$payload = _ref39.payload,
	            id = _ref39$payload.id,
	            settings = _ref39$payload.settings;
	        return (0, _icepick.chain)(state).updateIn([id, "visualization_settings"], function () {
	            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            return _extends({}, value, settings);
	        }).assocIn([id, "isDirty"], true).value();
	    }
	}), _defineProperty(_handleActions6, REPLACE_ALL_DASHCARD_VISUALIZATION_SETTINGS, {
	    next: function next(state, _ref40) {
	        var _ref40$payload = _ref40.payload,
	            id = _ref40$payload.id,
	            settings = _ref40$payload.settings;
	        return (0, _icepick.chain)(state).assocIn([id, "visualization_settings"], settings).assocIn([id, "isDirty"], true).value();
	    }
	}), _defineProperty(_handleActions6, ADD_CARD_TO_DASH, function (state, _ref41) {
	    var dashcard = _ref41.payload;
	    return _extends({}, state, _defineProperty({}, dashcard.id, _extends({}, dashcard, { isAdded: true, justAdded: true })));
	}), _defineProperty(_handleActions6, REMOVE_CARD_FROM_DASH, function (state, _ref42) {
	    var dashcardId = _ref42.payload.dashcardId;
	    return _extends({}, state, _defineProperty({}, dashcardId, _extends({}, state[dashcardId], { isRemoved: true })));
	}), _defineProperty(_handleActions6, MARK_NEW_CARD_SEEN, function (state, _ref43) {
	    var dashcardId = _ref43.payload;
	    return _extends({}, state, _defineProperty({}, dashcardId, _extends({}, state[dashcardId], { justAdded: false })));
	}), _handleActions6), {});
	
	var editingParameterId = (0, _redux.handleActions)((_handleActions7 = {}, _defineProperty(_handleActions7, SET_EDITING_PARAMETER_ID, { next: function next(state, _ref44) {
	        var payload = _ref44.payload;
	        return payload;
	    } }), _defineProperty(_handleActions7, ADD_PARAMETER, { next: function next(state, _ref45) {
	        var id = _ref45.payload.id;
	        return id;
	    } }), _handleActions7), null);
	
	var revisions = (0, _redux.handleActions)(_defineProperty({}, FETCH_REVISIONS, { next: function next(state, _ref46) {
	        var _ref46$payload = _ref46.payload,
	            entity = _ref46$payload.entity,
	            id = _ref46$payload.id,
	            revisions = _ref46$payload.revisions;
	        return _extends({}, state, _defineProperty({}, entity + '-' + id, revisions));
	    } }), {});
	
	var dashcardData = (0, _redux.handleActions)((_handleActions9 = {}, _defineProperty(_handleActions9, INITIALIZE, { next: function next(state) {
	        return {};
	    } }), _defineProperty(_handleActions9, FETCH_CARD_DATA, { next: function next(state, _ref47) {
	        var _ref47$payload = _ref47.payload,
	            dashcard_id = _ref47$payload.dashcard_id,
	            card_id = _ref47$payload.card_id,
	            result = _ref47$payload.result;
	        return (0, _icepick.assocIn)(state, [dashcard_id, card_id], result);
	    }
	}), _defineProperty(_handleActions9, CLEAR_CARD_DATA, { next: function next(state, _ref48) {
	        var _ref48$payload = _ref48.payload,
	            cardId = _ref48$payload.cardId,
	            dashcardId = _ref48$payload.dashcardId;
	        return (0, _icepick.assocIn)(state, [dashcardId, cardId]);
	    }
	}), _defineProperty(_handleActions9, UPDATE_DASHCARD_ID, { next: function next(state, _ref49) {
	        var _ref49$payload = _ref49.payload,
	            oldDashcardId = _ref49$payload.oldDashcardId,
	            newDashcardId = _ref49$payload.newDashcardId;
	        return (0, _icepick.chain)(state).assoc(newDashcardId, state[oldDashcardId]).dissoc(oldDashcardId).value();
	    }
	}), _handleActions9), {});
	
	var slowCards = (0, _redux.handleActions)(_defineProperty({}, MARK_CARD_AS_SLOW, { next: function next(state, _ref50) {
	        var _ref50$payload = _ref50.payload,
	            id = _ref50$payload.id,
	            result = _ref50$payload.result;
	        return _extends({}, state, _defineProperty({}, id, result));
	    } }), {});
	
	var parameterValues = (0, _redux.handleActions)((_handleActions11 = {}, _defineProperty(_handleActions11, INITIALIZE, { next: function next() {
	        return {};
	    } }), _defineProperty(_handleActions11, SET_PARAMETER_VALUE, { next: function next(state, _ref51) {
	        var _ref51$payload = _ref51.payload,
	            id = _ref51$payload.id,
	            value = _ref51$payload.value;
	        return (0, _icepick.assoc)(state, id, value);
	    } }), _defineProperty(_handleActions11, REMOVE_PARAMETER, { next: function next(state, _ref52) {
	        var id = _ref52.payload.id;
	        return (0, _icepick.dissoc)(state, id);
	    } }), _defineProperty(_handleActions11, FETCH_DASHBOARD, { next: function next(state, _ref53) {
	        var parameterValues = _ref53.payload.parameterValues;
	        return parameterValues;
	    } }), _handleActions11), {});
	
	exports.default = (0, _redux.combineReducers)({
	    dashboardId: dashboardId,
	    isEditing: isEditing,
	    cards: cards,
	    cardList: cardList,
	    dashboards: dashboards,
	    dashcards: dashcards,
	    editingParameterId: editingParameterId,
	    revisions: revisions,
	    dashcardData: dashcardData,
	    slowCards: slowCards,
	    parameterValues: parameterValues
	});

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.archiveDashboard = exports.setArchived = exports.setFavorited = exports.saveDashboard = exports.updateDashboard = exports.createDashboard = exports.fetchArchivedDashboards = exports.fetchDashboards = exports.SET_ARCHIVED = exports.SET_FAVORITED = exports.UPDATE_DASHBOARD = exports.SAVE_DASHBOARD = exports.DELETE_DASHBOARD = exports.CREATE_DASHBOARD = exports.FETCH_ARCHIVE = exports.FETCH_DASHBOARDS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _handleActions, _handleActions2;
	
	var _redux = __webpack_require__(657);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _services = __webpack_require__(857);
	
	var _undo = __webpack_require__(1070);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /*  weak */
	
	var FETCH_DASHBOARDS = exports.FETCH_DASHBOARDS = "metabase/dashboards/FETCH_DASHBOARDS";
	var FETCH_ARCHIVE = exports.FETCH_ARCHIVE = "metabase/dashboards/FETCH_ARCHIVE";
	var CREATE_DASHBOARD = exports.CREATE_DASHBOARD = "metabase/dashboards/CREATE_DASHBOARD";
	var DELETE_DASHBOARD = exports.DELETE_DASHBOARD = "metabase/dashboards/DELETE_DASHBOARD";
	var SAVE_DASHBOARD = exports.SAVE_DASHBOARD = "metabase/dashboards/SAVE_DASHBOARD";
	var UPDATE_DASHBOARD = exports.UPDATE_DASHBOARD = "metabase/dashboards/UPDATE_DASHBOARD";
	var SET_FAVORITED = exports.SET_FAVORITED = "metabase/dashboards/SET_FAVORITED";
	var SET_ARCHIVED = exports.SET_ARCHIVED = "metabase/dashboards/SET_ARCHIVED";
	
	/**
	 * Actions that retrieve/update the basic information of dashboards
	 * `dashboards.dashboardListing` holds an array of all dashboards without cards
	 */
	
	var fetchDashboards = exports.fetchDashboards = (0, _redux.createThunkAction)(FETCH_DASHBOARDS, function () {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var dashboards, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, dashboard;
	
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return _services.DashboardApi.list({ f: "all" });
	
	                        case 2:
	                            dashboards = _context.sent;
	                            _iteratorNormalCompletion = true;
	                            _didIteratorError = false;
	                            _iteratorError = undefined;
	                            _context.prev = 6;
	
	
	                            for (_iterator = dashboards[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                dashboard = _step.value;
	
	                                dashboard.updated_at = (0, _moment2.default)(dashboard.updated_at);
	                            }
	
	                            _context.next = 14;
	                            break;
	
	                        case 10:
	                            _context.prev = 10;
	                            _context.t0 = _context["catch"](6);
	                            _didIteratorError = true;
	                            _iteratorError = _context.t0;
	
	                        case 14:
	                            _context.prev = 14;
	                            _context.prev = 15;
	
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	
	                        case 17:
	                            _context.prev = 17;
	
	                            if (!_didIteratorError) {
	                                _context.next = 20;
	                                break;
	                            }
	
	                            throw _iteratorError;
	
	                        case 20:
	                            return _context.finish(17);
	
	                        case 21:
	                            return _context.finish(14);
	
	                        case 22:
	                            return _context.abrupt("return", dashboards);
	
	                        case 23:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[6, 10, 14, 22], [15,, 17, 21]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var fetchArchivedDashboards = exports.fetchArchivedDashboards = (0, _redux.createThunkAction)(FETCH_ARCHIVE, function () {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var dashboards, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, dashboard;
	
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.next = 2;
	                            return _services.DashboardApi.list({ f: "archived" });
	
	                        case 2:
	                            dashboards = _context2.sent;
	                            _iteratorNormalCompletion2 = true;
	                            _didIteratorError2 = false;
	                            _iteratorError2 = undefined;
	                            _context2.prev = 6;
	
	
	                            for (_iterator2 = dashboards[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                                dashboard = _step2.value;
	
	                                dashboard.updated_at = (0, _moment2.default)(dashboard.updated_at);
	                            }
	
	                            _context2.next = 14;
	                            break;
	
	                        case 10:
	                            _context2.prev = 10;
	                            _context2.t0 = _context2["catch"](6);
	                            _didIteratorError2 = true;
	                            _iteratorError2 = _context2.t0;
	
	                        case 14:
	                            _context2.prev = 14;
	                            _context2.prev = 15;
	
	                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                _iterator2.return();
	                            }
	
	                        case 17:
	                            _context2.prev = 17;
	
	                            if (!_didIteratorError2) {
	                                _context2.next = 20;
	                                break;
	                            }
	
	                            throw _iteratorError2;
	
	                        case 20:
	                            return _context2.finish(17);
	
	                        case 21:
	                            return _context2.finish(14);
	
	                        case 22:
	                            return _context2.abrupt("return", dashboards);
	
	                        case 23:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[6, 10, 14, 22], [15,, 17, 21]]);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	var createDashboard = exports.createDashboard = (0, _redux.createThunkAction)(CREATE_DASHBOARD, function (dashboard, _ref3) {
	    var redirect = _ref3.redirect;
	    return function () {
	        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            var createdDashboard;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _analytics2.default.trackEvent("Dashboard", "Create");
	                            _context3.next = 3;
	                            return _services.DashboardApi.create(dashboard);
	
	                        case 3:
	                            createdDashboard = _context3.sent;
	
	
	                            if (redirect) {
	                                dispatch((0, _reactRouterRedux.push)(Urls.dashboard(createdDashboard.id)));
	                            }
	
	                            return _context3.abrupt("return", createdDashboard);
	
	                        case 6:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	});
	
	var updateDashboard = exports.updateDashboard = (0, _redux.createThunkAction)(UPDATE_DASHBOARD, function (dashboard) {
	    return function () {
	        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
	            var id, name, description, parameters, caveats, points_of_interest, show_in_getting_started, cleanDashboard, updatedDashboard;
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            id = dashboard.id, name = dashboard.name, description = dashboard.description, parameters = dashboard.parameters, caveats = dashboard.caveats, points_of_interest = dashboard.points_of_interest, show_in_getting_started = dashboard.show_in_getting_started;
	                            cleanDashboard = {
	                                id: id,
	                                name: name,
	                                description: description,
	                                parameters: parameters,
	                                caveats: caveats,
	                                points_of_interest: points_of_interest,
	                                show_in_getting_started: show_in_getting_started
	                            };
	                            _context4.next = 4;
	                            return _services.DashboardApi.update(cleanDashboard);
	
	                        case 4:
	                            updatedDashboard = _context4.sent;
	
	
	                            _analytics2.default.trackEvent("Dashboard", "Update");
	
	                            return _context4.abrupt("return", updatedDashboard);
	
	                        case 7:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, undefined);
	        }));
	
	        return function (_x7, _x8) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	});
	
	var saveDashboard = exports.saveDashboard = (0, _redux.createThunkAction)(SAVE_DASHBOARD, function (dashboard) {
	    return function () {
	        var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
	            var id, name, description, parameters;
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            id = dashboard.id, name = dashboard.name, description = dashboard.description, parameters = dashboard.parameters;
	
	                            _analytics2.default.trackEvent("Dashboard", "Update");
	                            _context5.next = 4;
	                            return _services.DashboardApi.update({ id: id, name: name, description: description, parameters: parameters });
	
	                        case 4:
	                            return _context5.abrupt("return", _context5.sent);
	
	                        case 5:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, this);
	        }));
	
	        return function (_x9, _x10) {
	            return _ref6.apply(this, arguments);
	        };
	    }();
	});
	
	var setFavorited = exports.setFavorited = (0, _redux.createThunkAction)(SET_FAVORITED, function (dashId, favorited) {
	    return function () {
	        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            if (!favorited) {
	                                _context6.next = 5;
	                                break;
	                            }
	
	                            _context6.next = 3;
	                            return _services.DashboardApi.favorite({ dashId: dashId });
	
	                        case 3:
	                            _context6.next = 7;
	                            break;
	
	                        case 5:
	                            _context6.next = 7;
	                            return _services.DashboardApi.unfavorite({ dashId: dashId });
	
	                        case 7:
	                            _analytics2.default.trackEvent("Dashboard", favorited ? "Favorite" : "Unfavorite");
	                            return _context6.abrupt("return", { id: dashId, favorite: favorited });
	
	                        case 9:
	                        case "end":
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, undefined);
	        }));
	
	        return function (_x11, _x12) {
	            return _ref7.apply(this, arguments);
	        };
	    }();
	});
	
	// A simplified version of a similar method in questions/questions.js
	function createUndo(type, action) {
	    return {
	        type: type,
	        count: 1,
	        message: function message(undo) {
	            return (// eslint-disable-line react/display-name
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    " ",
	                    "Dashboard was " + type + ".",
	                    " "
	                )
	            );
	        },
	        actions: [action]
	    };
	}
	
	var setArchived = exports.setArchived = (0, _redux.createThunkAction)(SET_ARCHIVED, function (dashId, archived) {
	    var undoable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    return function () {
	        var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            _context7.next = 2;
	                            return _services.DashboardApi.update({
	                                id: dashId,
	                                archived: archived
	                            });
	
	                        case 2:
	                            response = _context7.sent;
	
	
	                            if (undoable) {
	                                dispatch((0, _undo.addUndo)(createUndo(archived ? "archived" : "unarchived", setArchived(dashId, !archived))));
	                            }
	
	                            _analytics2.default.trackEvent("Dashboard", archived ? "Archive" : "Unarchive");
	                            return _context7.abrupt("return", response);
	
	                        case 6:
	                        case "end":
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, undefined);
	        }));
	
	        return function (_x14, _x15) {
	            return _ref8.apply(this, arguments);
	        };
	    }();
	});
	// Convenience shorthand
	var archiveDashboard = exports.archiveDashboard = function () {
	    var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(dashId) {
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	            while (1) {
	                switch (_context8.prev = _context8.next) {
	                    case 0:
	                        _context8.next = 2;
	                        return setArchived(dashId, true);
	
	                    case 2:
	                        return _context8.abrupt("return", _context8.sent);
	
	                    case 3:
	                    case "end":
	                        return _context8.stop();
	                }
	            }
	        }, _callee8, undefined);
	    }));
	
	    return function archiveDashboard(_x16) {
	        return _ref9.apply(this, arguments);
	    };
	}();
	
	var archive = (0, _redux.handleActions)((_handleActions = {}, _defineProperty(_handleActions, FETCH_ARCHIVE, function (state, _ref10) {
	    var payload = _ref10.payload;
	    return payload;
	}), _defineProperty(_handleActions, SET_ARCHIVED, function (state, _ref11) {
	    var payload = _ref11.payload;
	    return payload.archived ? (state || []).concat(payload) : (state || []).filter(function (d) {
	        return d.id !== payload.id;
	    });
	}), _handleActions), null);
	
	var dashboardListing = (0, _redux.handleActions)((_handleActions2 = {}, _defineProperty(_handleActions2, FETCH_DASHBOARDS, function (state, _ref12) {
	    var payload = _ref12.payload;
	    return payload;
	}), _defineProperty(_handleActions2, CREATE_DASHBOARD, function (state, _ref13) {
	    var payload = _ref13.payload;
	    return (state || []).concat(payload);
	}), _defineProperty(_handleActions2, DELETE_DASHBOARD, function (state, _ref14) {
	    var payload = _ref14.payload;
	    return (state || []).filter(function (d) {
	        return d.id !== payload;
	    });
	}), _defineProperty(_handleActions2, SAVE_DASHBOARD, function (state, _ref15) {
	    var payload = _ref15.payload;
	    return (state || []).map(function (d) {
	        return d.id === payload.id ? payload : d;
	    });
	}), _defineProperty(_handleActions2, UPDATE_DASHBOARD, function (state, _ref16) {
	    var payload = _ref16.payload;
	    return (state || []).map(function (d) {
	        return d.id === payload.id ? payload : d;
	    });
	}), _defineProperty(_handleActions2, SET_FAVORITED, function (state, _ref17) {
	    var payload = _ref17.payload;
	    return (state || []).map(function (d) {
	        return d.id === payload.id ? _extends({}, d, { favorite: payload.favorite }) : d;
	    });
	}), _defineProperty(_handleActions2, SET_ARCHIVED, function (state, _ref18) {
	    var payload = _ref18.payload;
	    return payload.archived ? (state || []).filter(function (d) {
	        return d.id !== payload.id;
	    }) : (state || []).concat(payload);
	}), _handleActions2), null);
	
	exports.default = (0, _redux.combineReducers)({
	    dashboardListing: dashboardListing,
	    archive: archive
	});

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPositionForNewDashCard = getPositionForNewDashCard;
	var GRID_WIDTH = exports.GRID_WIDTH = 18;
	
	var GRID_ASPECT_RATIO = exports.GRID_ASPECT_RATIO = 4 / 3;
	var GRID_MARGIN = exports.GRID_MARGIN = 6;
	
	var DEFAULT_CARD_SIZE = exports.DEFAULT_CARD_SIZE = { width: 4, height: 4 };
	
	// returns the first available position from left to right, top to bottom,
	// based on the existing cards,  item size, and grid width
	function getPositionForNewDashCard(cards) {
	    var sizeX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_CARD_SIZE.width;
	    var sizeY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CARD_SIZE.height;
	    var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : GRID_WIDTH;
	
	    var row = 0;
	    var col = 0;
	    while (row < 1000) {
	        while (col <= width - sizeX) {
	            var good = true;
	            var position = { col: col, row: row, sizeX: sizeX, sizeY: sizeY };
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = cards[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var card = _step.value;
	
	                    if (intersects(card, position)) {
	                        good = false;
	                        break;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            if (good) {
	                return position;
	            }
	            col++;
	        }
	        col = 0;
	        row++;
	    }
	    // this should never happen but flow complains if we return undefined
	    return { col: col, row: row, sizeX: sizeX, sizeY: sizeY };
	}
	
	function intersects(a, b) {
	    return !(b.col >= a.col + a.sizeX || b.col + b.sizeX <= a.col || b.row >= a.row + a.sizeY || b.row + b.sizeY <= a.row);
	}
	
	// for debugging
	/*eslint-disable */
	function printGrid(cards, width) {
	    var grid = [];
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = cards[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var card = _step2.value;
	
	            for (var _col = card.col; _col < card.col + card.sizeX; _col++) {
	                for (var _row = card.row; _row < card.row + card.sizeY; _row++) {
	                    grid[_row] = grid[_row] || Array(width).join(".").split(".").map(function () {
	                        return 0;
	                    });
	                    grid[_row][_col]++;
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    console.log("\n" + grid.map(function (row) {
	        return row.join(".");
	    }).join("\n") + "\n");
	}
	/*eslint-enable */

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RemoveFromDashboardModal = (_temp = _class = function (_Component) {
	    _inherits(RemoveFromDashboardModal, _Component);
	
	    function RemoveFromDashboardModal(props, context) {
	        _classCallCheck(this, RemoveFromDashboardModal);
	
	        var _this = _possibleConstructorReturn(this, (RemoveFromDashboardModal.__proto__ || Object.getPrototypeOf(RemoveFromDashboardModal)).call(this, props, context));
	
	        _this.state = { deleteCard: false };
	        return _this;
	    }
	
	    _createClass(RemoveFromDashboardModal, [{
	        key: "onRemove",
	        value: function onRemove() {
	            this.props.removeCardFromDashboard({
	                dashId: this.props.dashboard.id,
	                dashcardId: this.props.dashcard.id
	            });
	            if (this.state.deleteCard) {
	                // this.props.dispatch(deleteCard(this.props.dashcard.card_id))
	                // this.props.dispatch(markCardForDeletion(this.props.dashcard.card_id))
	            }
	            this.props.onClose();
	
	            _analytics2.default.trackEvent("Dashboard", "Remove Card");
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    title: "Remove this question?",
	                    onClose: function onClose() {
	                        return _this2.props.onClose();
	                    }
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "Form-actions flex-align-right" },
	                    _react2.default.createElement(
	                        "button",
	                        { className: "Button Button", onClick: this.props.onClose },
	                        "Cancel"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        { className: "Button Button--danger ml2", onClick: function onClick() {
	                                return _this2.onRemove();
	                            } },
	                        "Remove"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RemoveFromDashboardModal;
	}(_react.Component), _class.propTypes = {
	    dashcard: _propTypes2.default.object.isRequired,
	    dashboard: _propTypes2.default.object.isRequired,
	    removeCardFromDashboard: _propTypes2.default.func.isRequired,
	    onClose: _propTypes2.default.func.isRequired
	}, _temp);
	RemoveFromDashboardModal.displayName = "RemoveFromDashboardModal";
	exports.default = RemoveFromDashboardModal;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Visualization = __webpack_require__(1270);
	
	var _Visualization2 = _interopRequireDefault(_Visualization);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _CheckBox = __webpack_require__(1004);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _visualizations = __webpack_require__(1284);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icepick = __webpack_require__(855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getQueryColumns(card, databases) {
	    var dbId = card.dataset_query.database;
	    if (card.dataset_query.type !== "query") {
	        return null;
	    }
	    var query = card.dataset_query.query;
	    var table = databases && databases[dbId] && databases[dbId].tables_lookup[query.source_table];
	    if (!table) {
	        return null;
	    }
	    return _query2.default.getQueryColumns(table, query);
	}
	
	var AddSeriesModal = (_temp = _class = function (_Component) {
	    _inherits(AddSeriesModal, _Component);
	
	    function AddSeriesModal(props, context) {
	        _classCallCheck(this, AddSeriesModal);
	
	        var _this = _possibleConstructorReturn(this, (AddSeriesModal.__proto__ || Object.getPrototypeOf(AddSeriesModal)).call(this, props, context));
	
	        _this.state = {
	            searchValue: "",
	            error: null,
	            series: props.dashcard.series || [],
	            badCards: {}
	        };
	
	        _underscore2.default.bindAll(_this, "onSearchChange", "onSearchFocus", "onDone", "filteredCards", "onRemoveSeries");
	        return _this;
	    }
	
	    _createClass(AddSeriesModal, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var _this2 = this;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return this.props.fetchCards();
	
	                            case 3:
	                                _context.next = 5;
	                                return Promise.all(_underscore2.default.uniq(this.props.cards.map(function (c) {
	                                    return c.database_id;
	                                })).map(function (db_id) {
	                                    return _this2.props.fetchDatabaseMetadata(db_id);
	                                }));
	
	                            case 5:
	                                _context.next = 11;
	                                break;
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context["catch"](0);
	
	                                console.error(_context.t0);
	                                this.setState({ error: _context.t0 });
	
	                            case 11:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 7]]);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "onSearchFocus",
	        value: function onSearchFocus() {
	            _analytics2.default.trackEvent("Dashboard", "Edit Series Modal", "search");
	        }
	    }, {
	        key: "onSearchChange",
	        value: function onSearchChange(e) {
	            this.setState({ searchValue: e.target.value.toLowerCase() });
	        }
	    }, {
	        key: "onCardChange",
	        value: function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(card, e) {
	                var _this3 = this;
	
	                var _props, dashcard, dashcardData, _getVisualizationRaw, CardVisualization, sourceDataset, seriesDataset;
	
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _props = this.props, dashcard = _props.dashcard, dashcardData = _props.dashcardData;
	                                _getVisualizationRaw = (0, _visualizations.getVisualizationRaw)([{ card: dashcard.card }]), CardVisualization = _getVisualizationRaw.CardVisualization;
	                                _context2.prev = 2;
	
	                                if (!e.target.checked) {
	                                    _context2.next = 13;
	                                    break;
	                                }
	
	                                if (!((0, _icepick.getIn)(dashcardData, [dashcard.id, card.id]) === undefined)) {
	                                    _context2.next = 8;
	                                    break;
	                                }
	
	                                this.setState({ state: "loading" });
	                                _context2.next = 8;
	                                return this.props.fetchCardData(card, dashcard, { reload: false, clear: true });
	
	                            case 8:
	                                sourceDataset = (0, _icepick.getIn)(this.props.dashcardData, [dashcard.id, dashcard.card.id]);
	                                seriesDataset = (0, _icepick.getIn)(this.props.dashcardData, [dashcard.id, card.id]);
	
	                                if (CardVisualization.seriesAreCompatible({ card: dashcard.card, data: sourceDataset.data }, { card: card, data: seriesDataset.data })) {
	                                    this.setState({
	                                        state: null,
	                                        series: this.state.series.concat(card)
	                                    });
	
	                                    _analytics2.default.trackEvent("Dashboard", "Add Series", card.display + ", success");
	                                } else {
	                                    this.setState({
	                                        state: "incompatible",
	                                        badCards: _extends({}, this.state.badCards, _defineProperty({}, card.id, true))
	                                    });
	                                    setTimeout(function () {
	                                        return _this3.setState({ state: null });
	                                    }, 2000);
	
	                                    _analytics2.default.trackEvent("Dashboard", "Add Series", card.dataset_query.type + ", " + card.display + ", fail");
	                                }
	                                _context2.next = 15;
	                                break;
	
	                            case 13:
	                                this.setState({ series: this.state.series.filter(function (c) {
	                                        return c.id !== card.id;
	                                    }) });
	
	                                _analytics2.default.trackEvent("Dashboard", "Remove Series");
	
	                            case 15:
	                                _context2.next = 22;
	                                break;
	
	                            case 17:
	                                _context2.prev = 17;
	                                _context2.t0 = _context2["catch"](2);
	
	                                console.error("onCardChange", _context2.t0);
	                                this.setState({
	                                    state: "incompatible",
	                                    badCards: _extends({}, this.state.badCards, _defineProperty({}, card.id, true))
	                                });
	                                setTimeout(function () {
	                                    return _this3.setState({ state: null });
	                                }, 2000);
	
	                            case 22:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this, [[2, 17]]);
	            }));
	
	            function onCardChange(_x, _x2) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return onCardChange;
	        }()
	    }, {
	        key: "onRemoveSeries",
	        value: function onRemoveSeries(card) {
	            this.setState({ series: this.state.series.filter(function (c) {
	                    return c.id !== card.id;
	                }) });
	            _analytics2.default.trackEvent("Dashboard", "Remove Series");
	        }
	    }, {
	        key: "onDone",
	        value: function onDone() {
	            this.props.setDashCardAttributes({
	                id: this.props.dashcard.id,
	                attributes: { series: this.state.series }
	            });
	            this.props.onClose();
	            _analytics2.default.trackEvent("Dashboard", "Edit Series Modal", "done");
	        }
	    }, {
	        key: "filteredCards",
	        value: function filteredCards() {
	            var _props2 = this.props,
	                cards = _props2.cards,
	                dashcard = _props2.dashcard,
	                databases = _props2.databases,
	                dashcardData = _props2.dashcardData;
	            var searchValue = this.state.searchValue;
	
	
	            var initialSeries = {
	                card: dashcard.card,
	                data: (0, _icepick.getIn)(dashcardData, [dashcard.id, dashcard.card.id, "data"])
	            };
	
	            var _getVisualizationRaw2 = (0, _visualizations.getVisualizationRaw)([{ card: dashcard.card }]),
	                CardVisualization = _getVisualizationRaw2.CardVisualization;
	
	            return cards.filter(function (card) {
	                try {
	                    // filter out the card itself
	                    if (card.id === dashcard.card.id) {
	                        return false;
	                    }
	                    if (card.dataset_query.type === "query") {
	                        if (!CardVisualization.seriesAreCompatible(initialSeries, { card: card, data: { cols: getQueryColumns(card, databases), rows: [] } })) {
	                            return false;
	                        }
	                    }
	                    // search
	                    if (searchValue && card.name.toLowerCase().indexOf(searchValue) < 0) {
	                        return false;
	                    }
	                    return true;
	                } catch (e) {
	                    console.warn(e);
	                    return false;
	                }
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var _props3 = this.props,
	                dashcard = _props3.dashcard,
	                dashcardData = _props3.dashcardData,
	                cards = _props3.cards;
	
	
	            var error = this.state.error;
	
	            var filteredCards = void 0;
	            if (!error && cards) {
	                filteredCards = this.filteredCards();
	                if (filteredCards.length === 0) {
	                    error = new Error("Whoops, no compatible questions match your search.");
	                }
	                // SQL cards at the bottom
	                filteredCards.sort(function (a, b) {
	                    if (a.dataset_query.type !== "query") {
	                        return 1;
	                    } else if (b.dataset_query.type !== "query") {
	                        return -1;
	                    } else {
	                        return 0;
	                    }
	                });
	            }
	
	            var badCards = this.state.badCards;
	
	            var enabledCards = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = this.state.series[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var c = _step.value;
	
	                    enabledCards[c.id] = true;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var series = [dashcard.card].concat(this.state.series).map(function (card) {
	                return {
	                    card: card,
	                    data: (0, _icepick.getIn)(dashcardData, [dashcard.id, card.id, "data"])
	                };
	            }).filter(function (s) {
	                return !!s.data;
	            });
	
	            return _react2.default.createElement(
	                "div",
	                { className: "spread flex" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex flex-column flex-full" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-no-shrink h3 pl4 pt4 pb2 text-bold" },
	                        "Edit data"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-full ml2 mr1 relative" },
	                        _react2.default.createElement(_Visualization2.default, {
	                            className: "spread",
	                            series: series,
	                            showTitle: true,
	                            isDashboard: true,
	                            isMultiseries: true,
	                            onRemoveSeries: this.onRemoveSeries
	                        }),
	                        this.state.state && _react2.default.createElement(
	                            "div",
	                            { className: "spred flex layout-centered", style: { backgroundColor: "rgba(255,255,255,0.80)" } },
	                            this.state.state === "loading" ? _react2.default.createElement(
	                                "div",
	                                { className: "h3 rounded bordered p3 bg-white shadowed" },
	                                "Applying Question"
	                            ) : this.state.state === "incompatible" ? _react2.default.createElement(
	                                "div",
	                                { className: "h3 rounded bordered p3 bg-error border-error text-white" },
	                                "That question isn't compatible"
	                            ) : null
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-no-shrink pl4 pb4 pt1" },
	                        _react2.default.createElement(
	                            "button",
	                            { className: "Button Button--primary", onClick: this.onDone },
	                            "Done"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { "data-metabase-event": "Dashboard;Edit Series Modal;cancel", className: "Button ml2", onClick: this.props.onClose },
	                            "Cancel"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "border-left flex flex-column", style: { width: 370, backgroundColor: "#F8FAFA", borderColor: "#DBE1DF" } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-no-shrink border-bottom flex flex-row align-center", style: { borderColor: "#DBE1DF" } },
	                        _react2.default.createElement(_Icon2.default, { className: "ml2", name: "search", size: 16 }),
	                        _react2.default.createElement("input", { className: "h4 input full pl1", style: { border: "none", backgroundColor: "transparent" }, type: "search", placeholder: "Search for a question", onFocus: this.onSearchFocus, onChange: this.onSearchChange })
	                    ),
	                    _react2.default.createElement(
	                        _LoadingAndErrorWrapper2.default,
	                        { className: "flex flex-full", loading: !filteredCards, error: error, noBackground: true },
	                        function () {
	                            return _react2.default.createElement(
	                                "ul",
	                                { className: "flex-full scroll-y scroll-show pr1" },
	                                filteredCards.map(function (card) {
	                                    return _react2.default.createElement(
	                                        "li",
	                                        { key: card.id, className: (0, _classnames2.default)("my1 pl2 py1 flex align-center", { disabled: badCards[card.id] }) },
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: "px1 flex-no-shrink" },
	                                            _react2.default.createElement(_CheckBox2.default, { checked: enabledCards[card.id], onChange: _this4.onCardChange.bind(_this4, card) })
	                                        ),
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: "px1" },
	                                            card.name
	                                        ),
	                                        card.dataset_query.type !== "query" && _react2.default.createElement(
	                                            _Tooltip2.default,
	                                            { tooltip: "We're not sure if this question is compatible" },
	                                            _react2.default.createElement(_Icon2.default, { className: "px1 flex-align-right text-grey-2 text-grey-4-hover cursor-pointer flex-no-shrink", name: "warning", size: 20 })
	                                        )
	                                    );
	                                })
	                            );
	                        }
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddSeriesModal;
	}(_react.Component), _class.propTypes = {
	    dashcard: _propTypes2.default.object.isRequired,
	    cards: _propTypes2.default.array,
	    dashcardData: _propTypes2.default.object.isRequired,
	    fetchCards: _propTypes2.default.func.isRequired,
	    fetchCardData: _propTypes2.default.func.isRequired,
	    fetchDatabaseMetadata: _propTypes2.default.func.isRequired,
	    setDashCardAttributes: _propTypes2.default.func.isRequired,
	    onClose: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {}, _temp);
	AddSeriesModal.displayName = "AddSeriesModal";
	exports.default = AddSeriesModal;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _browser = __webpack_require__(1188);
	
	var _screenfull = __webpack_require__(1526);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TICK_PERIOD = 0.25; // seconds
	
	/* This contains some state for dashboard controls on both private and embedded dashboards.
	 * It should probably be in Redux?
	 */
	
	exports.default = function (ComposedComponent) {
	    var _class, _temp2;
	
	    return (0, _reactRedux.connect)(null, { replace: _reactRouterRedux.replace })((_temp2 = _class = function (_Component) {
	        _inherits(_class, _Component);
	
	        function _class() {
	            var _ref,
	                _this2 = this;
	
	            var _temp, _this, _ret;
	
	            _classCallCheck(this, _class);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	                isFullscreen: false,
	                isNightMode: false,
	
	                refreshPeriod: null,
	                refreshElapsed: null
	            }, _this.loadDashboardParams = function () {
	                var location = _this.props.location;
	
	
	                var options = (0, _browser.parseHashOptions)(location.hash);
	                _this.setRefreshPeriod(Number.isNaN(options.refresh) || options.refresh === 0 ? null : options.refresh);
	                _this.setNightMode(options.theme === "night" || options.night); // DEPRECATED: options.night
	                _this.setFullscreen(options.fullscreen);
	            }, _this.updateDashboardParams = function () {
	                var _this$props = _this.props,
	                    location = _this$props.location,
	                    replace = _this$props.replace;
	
	
	                var options = (0, _browser.parseHashOptions)(location.hash);
	                var setValue = function setValue(name, value) {
	                    if (value) {
	                        options[name] = value;
	                    } else {
	                        delete options[name];
	                    }
	                };
	                setValue("refresh", _this.state.refreshPeriod);
	                setValue("fullscreen", _this.state.isFullscreen);
	                setValue("theme", _this.state.isNightMode ? "night" : null);
	
	                delete options.night; // DEPRECATED: options.night
	
	                // Delete the "add card to dashboard" parameter if it's present because we don't
	                // want to add the card again on page refresh. The `add` parameter is already handled in
	                // DashboardApp before this method is called.
	                delete options.add;
	
	                var hash = (0, _browser.stringifyHashOptions)(options);
	                hash = hash ? "#" + hash : "";
	
	                if (hash !== location.hash) {
	                    replace({
	                        pathname: location.pathname,
	                        search: location.search,
	                        hash: hash
	                    });
	                }
	            }, _this.setRefreshPeriod = function (refreshPeriod) {
	                _this._clearRefreshInterval();
	                if (refreshPeriod != null) {
	                    _this._interval = setInterval(_this._tickRefreshClock, TICK_PERIOD * 1000);
	                    _this.setState({ refreshPeriod: refreshPeriod, refreshElapsed: 0 });
	                    _analytics2.default.trackEvent("Dashboard", "Set Refresh", refreshPeriod);
	                } else {
	                    _this.setState({
	                        refreshPeriod: null,
	                        refreshElapsed: null
	                    });
	                }
	            }, _this.setNightMode = function (isNightMode) {
	                isNightMode = !!isNightMode;
	                _this.setState({ isNightMode: isNightMode });
	            }, _this.setFullscreen = function (isFullscreen) {
	                var browserFullscreen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	                isFullscreen = !!isFullscreen;
	                if (isFullscreen !== _this.state.isFullscreen) {
	                    if (_screenfull2.default.enabled && browserFullscreen) {
	                        if (isFullscreen) {
	                            _screenfull2.default.request();
	                        } else {
	                            _screenfull2.default.exit();
	                        }
	                    }
	                    _this.setState({ isFullscreen: isFullscreen });
	                }
	            }, _this._tickRefreshClock = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var refreshElapsed;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                refreshElapsed = (_this.state.refreshElapsed || 0) + TICK_PERIOD;
	
	                                if (!(_this.state.refreshPeriod && refreshElapsed >= _this.state.refreshPeriod)) {
	                                    _context.next = 8;
	                                    break;
	                                }
	
	                                _this.setState({ refreshElapsed: 0 });
	                                _context.next = 5;
	                                return _this.props.fetchDashboard(_this.props.dashboardId, _this.props.location.query);
	
	                            case 5:
	                                _this.props.fetchDashboardCardData({
	                                    reload: true,
	                                    clear: false
	                                });
	                                _context.next = 9;
	                                break;
	
	                            case 8:
	                                _this.setState({ refreshElapsed: refreshElapsed });
	
	                            case 9:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2);
	            })), _this._fullScreenChanged = function () {
	                _this.setState({ isFullscreen: !!_screenfull2.default.isFullscreen });
	            }, _temp), _possibleConstructorReturn(_this, _ret);
	        }
	
	        _createClass(_class, [{
	            key: "componentWillMount",
	            value: function componentWillMount() {
	                if (_screenfull2.default.enabled) {
	                    document.addEventListener(_screenfull2.default.raw.fullscreenchange, this._fullScreenChanged);
	                }
	                this.loadDashboardParams();
	            }
	        }, {
	            key: "componentDidUpdate",
	            value: function componentDidUpdate() {
	                this.updateDashboardParams();
	                this._showNav(!this.state.isFullscreen);
	            }
	        }, {
	            key: "componentWillUnmount",
	            value: function componentWillUnmount() {
	                this._showNav(true);
	                this._clearRefreshInterval();
	                if (_screenfull2.default.enabled) {
	                    document.removeEventListener(_screenfull2.default.raw.fullscreenchange, this._fullScreenChanged);
	                }
	            }
	        }, {
	            key: "_clearRefreshInterval",
	            value: function _clearRefreshInterval() {
	                if (this._interval != null) {
	                    clearInterval(this._interval);
	                }
	            }
	        }, {
	            key: "_showNav",
	            value: function _showNav(show) {
	                // NOTE Atte Keinänen 8/10/17: For some reason `document` object isn't present in Jest tests
	                // when _showNav is called for the first time
	                if (window.document) {
	                    var nav = window.document.querySelector(".Nav");
	                    if (show && nav) {
	                        nav.classList.remove("hide");
	                    } else if (!show && nav) {
	                        nav.classList.add("hide");
	                    }
	                }
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                return _react2.default.createElement(ComposedComponent, _extends({}, this.props, this.state, {
	                    loadDashboardParams: this.loadDashboardParams,
	                    updateDashboardParams: this.updateDashboardParams,
	                    onNightModeChange: this.setNightMode,
	                    onFullscreenChange: this.setFullscreen,
	                    onRefreshPeriodChange: this.setRefreshPeriod
	                }));
	            }
	        }]);
	
	        return _class;
	    }(_react.Component), _class.displayName = "DashboardControls[" + (ComposedComponent.displayName || ComposedComponent.name) + "]", _temp2));
	};

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	/*!
	* screenfull
	* v3.0.2 - 2017-03-13
	* (c) Sindre Sorhus; MIT License
	*/
	(function () {
		'use strict';
	
		var isCommonjs = typeof module !== 'undefined' && module.exports;
		var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
	
		var fn = (function () {
			var val;
	
			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// new WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				// old WebKit (Safari 5.1)
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];
	
			var i = 0;
			var l = fnMap.length;
			var ret = {};
	
			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}
	
			return false;
		})();
	
		var screenfull = {
			request: function (elem) {
				var request = fn.requestFullscreen;
	
				elem = elem || document.documentElement;
	
				// Work around Safari 5.1 bug: reports support for
				// keyboard in fullscreen even though it doesn't.
				// Browser sniffing, since the alternative with
				// setTimeout is even worse.
				if (/5\.1[.\d]* Safari/.test(navigator.userAgent)) {
					elem[request]();
				} else {
					elem[request](keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT);
				}
			},
			exit: function () {
				document[fn.exitFullscreen]();
			},
			toggle: function (elem) {
				if (this.isFullscreen) {
					this.exit();
				} else {
					this.request(elem);
				}
			},
			onchange: function (callback) {
				document.addEventListener(fn.fullscreenchange, callback, false);
			},
			onerror: function (callback) {
				document.addEventListener(fn.fullscreenerror, callback, false);
			},
			raw: fn
		};
	
		if (!fn) {
			if (isCommonjs) {
				module.exports = false;
			} else {
				window.screenfull = false;
			}
	
			return;
		}
	
		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			enabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});
	
		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})();


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getDashboardActions = undefined;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _NightModeIcon = __webpack_require__(1528);
	
	var _NightModeIcon2 = _interopRequireDefault(_NightModeIcon);
	
	var _FullscreenIcon = __webpack_require__(1529);
	
	var _FullscreenIcon2 = _interopRequireDefault(_FullscreenIcon);
	
	var _RefreshWidget = __webpack_require__(1530);
	
	var _RefreshWidget2 = _interopRequireDefault(_RefreshWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDashboardActions = exports.getDashboardActions = function getDashboardActions(_ref) {
	    var _ref$isEditing = _ref.isEditing,
	        isEditing = _ref$isEditing === undefined ? false : _ref$isEditing,
	        _ref$isEmpty = _ref.isEmpty,
	        isEmpty = _ref$isEmpty === undefined ? false : _ref$isEmpty,
	        isFullscreen = _ref.isFullscreen,
	        isNightMode = _ref.isNightMode,
	        onNightModeChange = _ref.onNightModeChange,
	        onFullscreenChange = _ref.onFullscreenChange,
	        refreshPeriod = _ref.refreshPeriod,
	        refreshElapsed = _ref.refreshElapsed,
	        onRefreshPeriodChange = _ref.onRefreshPeriodChange;
	
	    var buttons = [];
	
	    if (!isEditing && !isEmpty) {
	        buttons.push(_react2.default.createElement(_RefreshWidget2.default, {
	            "data-metabase-event": "Dashboard;Refresh Menu Open",
	            className: "text-brand-hover",
	            key: "refresh",
	            period: refreshPeriod,
	            elapsed: refreshElapsed,
	            onChangePeriod: onRefreshPeriodChange
	        }));
	    }
	
	    if (!isEditing && isFullscreen) {
	        buttons.push(_react2.default.createElement(
	            _Tooltip2.default,
	            { tooltip: isNightMode ? "Daytime mode" : "Nighttime mode" },
	            _react2.default.createElement(
	                "span",
	                {
	                    "data-metabase-event": "Dashboard;Night Mode;" + !isNightMode
	                },
	                _react2.default.createElement(_NightModeIcon2.default, {
	                    className: "text-brand-hover cursor-pointer",
	                    key: "night",
	                    isNightMode: isNightMode,
	                    onClick: function onClick() {
	                        return onNightModeChange(!isNightMode);
	                    }
	                })
	            )
	        ));
	    }
	
	    if (!isEditing && !isEmpty) {
	        // option click to enter fullscreen without making the browser go fullscreen
	        buttons.push(_react2.default.createElement(
	            _Tooltip2.default,
	            {
	                tooltip: isFullscreen ? "Exit fullscreen" : "Enter fullscreen"
	            },
	            _react2.default.createElement(
	                "span",
	                {
	                    "data-metabase-event": "Dashboard;Fullscreen Mode;" + !isFullscreen
	                },
	                _react2.default.createElement(_FullscreenIcon2.default, {
	                    className: "text-brand-hover cursor-pointer",
	                    key: "fullscreen",
	                    isFullscreen: isFullscreen,
	                    onClick: function onClick(e) {
	                        return onFullscreenChange(!isFullscreen, !e.altKey);
	                    }
	                })
	            )
	        ));
	    }
	
	    return buttons;
	};

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NightModeIcon = function NightModeIcon(_ref) {
	    var isNightMode = _ref.isNightMode,
	        props = _objectWithoutProperties(_ref, ["isNightMode"]);
	
	    return _react2.default.createElement(_Icon2.default, _extends({ name: isNightMode ? "sun" : "moon" }, props));
	};
	
	NightModeIcon.displayName = "NightModeIcon";
	exports.default = NightModeIcon;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FullscreenIcon = function FullscreenIcon(_ref) {
	    var isFullscreen = _ref.isFullscreen,
	        props = _objectWithoutProperties(_ref, ["isFullscreen"]);
	
	    return _react2.default.createElement(_Icon2.default, _extends({ name: isFullscreen ? "contract" : "expand" }, props));
	};
	
	FullscreenIcon.displayName = "FullscreenIcon";
	exports.default = FullscreenIcon;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RefreshWidget = __webpack_require__(1531);
	
	var _RefreshWidget2 = _interopRequireDefault(_RefreshWidget);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ClockIcon = __webpack_require__(1533);
	
	var _ClockIcon2 = _interopRequireDefault(_ClockIcon);
	
	var _CountdownIcon = __webpack_require__(1534);
	
	var _CountdownIcon2 = _interopRequireDefault(_CountdownIcon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OPTIONS = [{ name: "Off", period: null }, { name: "1 minute", period: 1 * 60 }, { name: "5 minutes", period: 5 * 60 }, { name: "10 minutes", period: 10 * 60 }, { name: "15 minutes", period: 15 * 60 }, { name: "30 minutes", period: 30 * 60 }, { name: "60 minutes", period: 60 * 60 }];
	
	var RefreshWidget = function (_Component) {
	    _inherits(RefreshWidget, _Component);
	
	    function RefreshWidget() {
	        _classCallCheck(this, RefreshWidget);
	
	        return _possibleConstructorReturn(this, (RefreshWidget.__proto__ || Object.getPrototypeOf(RefreshWidget)).apply(this, arguments));
	    }
	
	    _createClass(RefreshWidget, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                period = _props.period,
	                elapsed = _props.elapsed,
	                onChangePeriod = _props.onChangePeriod,
	                className = _props.className;
	
	            var remaining = period - elapsed;
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                {
	                    ref: "popover",
	                    triggerElement: elapsed == null ? _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: "Auto-refresh" },
	                        _react2.default.createElement(_ClockIcon2.default, { width: 18, height: 18, className: className })
	                    ) : _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: "Refreshing in " + Math.floor(remaining / 60) + ":" + (remaining % 60 < 10 ? "0" : "") + Math.round(remaining % 60) },
	                        _react2.default.createElement(_CountdownIcon2.default, { width: 18, height: 18, className: "text-green", percent: Math.min(0.95, (period - elapsed) / period) })
	                    ),
	                    targetOffsetY: 10
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: _RefreshWidget2.default.popover },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _RefreshWidget2.default.title },
	                        "Auto Refresh"
	                    ),
	                    _react2.default.createElement(
	                        RefreshOptionList,
	                        null,
	                        OPTIONS.map(function (option) {
	                            return _react2.default.createElement(RefreshOption, { key: option.period, name: option.name, period: option.period, selected: option.period === period, onClick: function onClick() {
	                                    _this2.refs.popover.close();onChangePeriod(option.period);
	                                } });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RefreshWidget;
	}(_react.Component);
	
	RefreshWidget.displayName = "RefreshWidget";
	exports.default = RefreshWidget;
	
	
	var RefreshOptionList = function RefreshOptionList(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        "ul",
	        null,
	        children
	    );
	};
	
	RefreshOptionList.displayName = "RefreshOptionList";
	var RefreshOption = function RefreshOption(_ref2) {
	    var name = _ref2.name,
	        period = _ref2.period,
	        selected = _ref2.selected,
	        onClick = _ref2.onClick;
	    return _react2.default.createElement(
	        "li",
	        { className: (0, _classnames2.default)(_RefreshWidget2.default.option, _RefreshWidget2.default[period == null ? "off" : "on"], _defineProperty({}, _RefreshWidget2.default.selected, selected)), onClick: onClick },
	        _react2.default.createElement(_Icon2.default, { name: "check", size: 14 }),
	        _react2.default.createElement(
	            "span",
	            { className: _RefreshWidget2.default.name },
	            name.split(" ")[0]
	        ),
	        _react2.default.createElement(
	            "span",
	            { className: _RefreshWidget2.default.nameSuffix },
	            " ",
	            name.split(" ")[1]
	        )
	    );
	};
	RefreshOption.displayName = "RefreshOption";

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"popover":"_1PJaB","title":"_3oZM_","option":"_3sT2c _1a-AI","valueLabel":"UY_RI","on":"_1YWy_","selected":"BoMv1"};

/***/ }),
/* 1532 */,
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockIcon = function ClockIcon(_ref) {
	    var _ref$hour = _ref.hour,
	        hour = _ref$hour === undefined ? 12 : _ref$hour,
	        _ref$minute = _ref.minute,
	        minute = _ref$minute === undefined ? 40 : _ref$minute,
	        _ref$width = _ref.width,
	        width = _ref$width === undefined ? 20 : _ref$width,
	        _ref$height = _ref.height,
	        height = _ref$height === undefined ? 20 : _ref$height,
	        className = _ref.className;
	    return _react2.default.createElement(
	        "svg",
	        { width: width, height: height, className: className, viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("circle", { cx: "10", cy: "10", r: "10", fill: "currentColor" }),
	        _react2.default.createElement("line", { x1: "10", y1: "10", x2: "10", y2: "5", stroke: "white", strokeWidth: 2, strokeLinecap: "round", transform: "rotate(" + hour % 12 / 12 * 360 + " 10 10)" }),
	        _react2.default.createElement("line", { x1: "10", y1: "10", x2: "10", y2: "6", stroke: "white", strokeWidth: 2, strokeLinecap: "round", transform: "rotate(" + minute % 60 / 60 * 360 + " 10 10)" })
	    );
	};
	
	ClockIcon.displayName = "ClockIcon";
	exports.default = ClockIcon;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CountdownIcon = function CountdownIcon(_ref) {
	    var _ref$percent = _ref.percent,
	        percent = _ref$percent === undefined ? 0.75 : _ref$percent,
	        _ref$width = _ref.width,
	        width = _ref$width === undefined ? 20 : _ref$width,
	        _ref$height = _ref.height,
	        height = _ref$height === undefined ? 20 : _ref$height,
	        className = _ref.className;
	    return _react2.default.createElement(
	        "svg",
	        { width: width, height: height, className: className, viewBox: "0 0 32 32", style: { transform: "rotate(-" + (percent * 360 + 90) + "deg)", borderRadius: "50%" } },
	        _react2.default.createElement("circle", { r: "16", cx: "16", cy: "16", fill: "currentColor", stroke: "currentColor", fillOpacity: "0.5", strokeWidth: "32", strokeDasharray: percent * 100 + " 100" })
	    );
	};
	
	CountdownIcon.displayName = "CountdownIcon";
	exports.default = CountdownIcon;

/***/ }),
/* 1535 */,
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _auth = __webpack_require__(1123);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _app = __webpack_require__(864);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _metadata = __webpack_require__(1110);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _requests = __webpack_require__(856);
	
	var _requests2 = _interopRequireDefault(_requests);
	
	var _settings = __webpack_require__(656);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _undo = __webpack_require__(1070);
	
	var _undo2 = _interopRequireDefault(_undo);
	
	var _user = __webpack_require__(862);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* ducks */
	exports.default = {
	    // global reducers
	    app: _app2.default,
	    auth: _auth2.default,
	    currentUser: _user.currentUser,
	    metadata: _metadata2.default,
	    requests: _requests2.default,
	    settings: _settings2.default,
	    undo: _undo2.default
	};
	
	/* user */
	
	
	// Reducers shared between "main" and "public" apps

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getRoutes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	// auth containers
	
	
	// main app containers
	
	
	// new question
	
	
	// admin containers
	
	
	// Reference Guide
	
	// Reference Metrics
	
	// Reference Segments
	
	// Reference Databases
	
	
	/* XRay */
	
	
	/* Comparisons */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Title = __webpack_require__(1538);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _reduxAuthWrapper = __webpack_require__(1539);
	
	var _user = __webpack_require__(862);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _App = __webpack_require__(1541);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _ForgotPasswordApp = __webpack_require__(1568);
	
	var _ForgotPasswordApp2 = _interopRequireDefault(_ForgotPasswordApp);
	
	var _LoginApp = __webpack_require__(1574);
	
	var _LoginApp2 = _interopRequireDefault(_LoginApp);
	
	var _LogoutApp = __webpack_require__(1576);
	
	var _LogoutApp2 = _interopRequireDefault(_LogoutApp);
	
	var _PasswordResetApp = __webpack_require__(1577);
	
	var _PasswordResetApp2 = _interopRequireDefault(_PasswordResetApp);
	
	var _GoogleNoAccount = __webpack_require__(1578);
	
	var _GoogleNoAccount2 = _interopRequireDefault(_GoogleNoAccount);
	
	var _HomepageApp = __webpack_require__(1579);
	
	var _HomepageApp2 = _interopRequireDefault(_HomepageApp);
	
	var _Dashboards = __webpack_require__(1592);
	
	var _Dashboards2 = _interopRequireDefault(_Dashboards);
	
	var _DashboardsArchive = __webpack_require__(1603);
	
	var _DashboardsArchive2 = _interopRequireDefault(_DashboardsArchive);
	
	var _DashboardApp = __webpack_require__(1606);
	
	var _DashboardApp2 = _interopRequireDefault(_DashboardApp);
	
	var _QuestionIndex = __webpack_require__(1650);
	
	var _QuestionIndex2 = _interopRequireDefault(_QuestionIndex);
	
	var _Archive = __webpack_require__(1654);
	
	var _Archive2 = _interopRequireDefault(_Archive);
	
	var _CollectionPage = __webpack_require__(1655);
	
	var _CollectionPage2 = _interopRequireDefault(_CollectionPage);
	
	var _CollectionEdit = __webpack_require__(1656);
	
	var _CollectionEdit2 = _interopRequireDefault(_CollectionEdit);
	
	var _CollectionCreate = __webpack_require__(1658);
	
	var _CollectionCreate2 = _interopRequireDefault(_CollectionCreate);
	
	var _SearchResults = __webpack_require__(1659);
	
	var _SearchResults2 = _interopRequireDefault(_SearchResults);
	
	var _EditLabels = __webpack_require__(1660);
	
	var _EditLabels2 = _interopRequireDefault(_EditLabels);
	
	var _CollectionsPermissionsApp = __webpack_require__(1671);
	
	var _CollectionsPermissionsApp2 = _interopRequireDefault(_CollectionsPermissionsApp);
	
	var _EntityList = __webpack_require__(1614);
	
	var _EntityList2 = _interopRequireDefault(_EntityList);
	
	var _PulseEditApp = __webpack_require__(1686);
	
	var _PulseEditApp2 = _interopRequireDefault(_PulseEditApp);
	
	var _PulseListApp = __webpack_require__(1702);
	
	var _PulseListApp2 = _interopRequireDefault(_PulseListApp);
	
	var _QueryBuilder = __webpack_require__(1707);
	
	var _QueryBuilder2 = _interopRequireDefault(_QueryBuilder);
	
	var _SetupApp = __webpack_require__(1782);
	
	var _SetupApp2 = _interopRequireDefault(_SetupApp);
	
	var _UserSettingsApp = __webpack_require__(1796);
	
	var _UserSettingsApp2 = _interopRequireDefault(_UserSettingsApp);
	
	var _router_wrappers = __webpack_require__(1802);
	
	var _DatabaseListApp = __webpack_require__(1810);
	
	var _DatabaseListApp2 = _interopRequireDefault(_DatabaseListApp);
	
	var _DatabaseEditApp = __webpack_require__(1814);
	
	var _DatabaseEditApp2 = _interopRequireDefault(_DatabaseEditApp);
	
	var _MetadataEditorApp = __webpack_require__(1816);
	
	var _MetadataEditorApp2 = _interopRequireDefault(_MetadataEditorApp);
	
	var _MetricApp = __webpack_require__(1837);
	
	var _MetricApp2 = _interopRequireDefault(_MetricApp);
	
	var _SegmentApp = __webpack_require__(1843);
	
	var _SegmentApp2 = _interopRequireDefault(_SegmentApp);
	
	var _RevisionHistoryApp = __webpack_require__(1845);
	
	var _RevisionHistoryApp2 = _interopRequireDefault(_RevisionHistoryApp);
	
	var _AdminPeopleApp = __webpack_require__(1867);
	
	var _AdminPeopleApp2 = _interopRequireDefault(_AdminPeopleApp);
	
	var _SettingsEditorApp = __webpack_require__(1871);
	
	var _SettingsEditorApp2 = _interopRequireDefault(_SettingsEditorApp);
	
	var _FieldApp = __webpack_require__(1907);
	
	var _FieldApp2 = _interopRequireDefault(_FieldApp);
	
	var _TableSettingsApp = __webpack_require__(1911);
	
	var _TableSettingsApp2 = _interopRequireDefault(_TableSettingsApp);
	
	var _NotFound = __webpack_require__(1563);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _Unauthorized = __webpack_require__(1564);
	
	var _Unauthorized2 = _interopRequireDefault(_Unauthorized);
	
	var _GettingStartedGuideContainer = __webpack_require__(1913);
	
	var _GettingStartedGuideContainer2 = _interopRequireDefault(_GettingStartedGuideContainer);
	
	var _MetricListContainer = __webpack_require__(1936);
	
	var _MetricListContainer2 = _interopRequireDefault(_MetricListContainer);
	
	var _MetricDetailContainer = __webpack_require__(1951);
	
	var _MetricDetailContainer2 = _interopRequireDefault(_MetricDetailContainer);
	
	var _MetricQuestionsContainer = __webpack_require__(1968);
	
	var _MetricQuestionsContainer2 = _interopRequireDefault(_MetricQuestionsContainer);
	
	var _MetricRevisionsContainer = __webpack_require__(1970);
	
	var _MetricRevisionsContainer2 = _interopRequireDefault(_MetricRevisionsContainer);
	
	var _SegmentListContainer = __webpack_require__(1974);
	
	var _SegmentListContainer2 = _interopRequireDefault(_SegmentListContainer);
	
	var _SegmentDetailContainer = __webpack_require__(1976);
	
	var _SegmentDetailContainer2 = _interopRequireDefault(_SegmentDetailContainer);
	
	var _SegmentQuestionsContainer = __webpack_require__(1980);
	
	var _SegmentQuestionsContainer2 = _interopRequireDefault(_SegmentQuestionsContainer);
	
	var _SegmentRevisionsContainer = __webpack_require__(1982);
	
	var _SegmentRevisionsContainer2 = _interopRequireDefault(_SegmentRevisionsContainer);
	
	var _SegmentFieldListContainer = __webpack_require__(1984);
	
	var _SegmentFieldListContainer2 = _interopRequireDefault(_SegmentFieldListContainer);
	
	var _SegmentFieldDetailContainer = __webpack_require__(1989);
	
	var _SegmentFieldDetailContainer2 = _interopRequireDefault(_SegmentFieldDetailContainer);
	
	var _DatabaseListContainer = __webpack_require__(1993);
	
	var _DatabaseListContainer2 = _interopRequireDefault(_DatabaseListContainer);
	
	var _DatabaseDetailContainer = __webpack_require__(1995);
	
	var _DatabaseDetailContainer2 = _interopRequireDefault(_DatabaseDetailContainer);
	
	var _TableListContainer = __webpack_require__(1998);
	
	var _TableListContainer2 = _interopRequireDefault(_TableListContainer);
	
	var _TableDetailContainer = __webpack_require__(2000);
	
	var _TableDetailContainer2 = _interopRequireDefault(_TableDetailContainer);
	
	var _TableQuestionsContainer = __webpack_require__(2004);
	
	var _TableQuestionsContainer2 = _interopRequireDefault(_TableQuestionsContainer);
	
	var _FieldListContainer = __webpack_require__(2006);
	
	var _FieldListContainer2 = _interopRequireDefault(_FieldListContainer);
	
	var _FieldDetailContainer = __webpack_require__(2008);
	
	var _FieldDetailContainer2 = _interopRequireDefault(_FieldDetailContainer);
	
	var _FieldXray = __webpack_require__(2011);
	
	var _FieldXray2 = _interopRequireDefault(_FieldXray);
	
	var _TableXRay = __webpack_require__(2023);
	
	var _TableXRay2 = _interopRequireDefault(_TableXRay);
	
	var _SegmentXRay = __webpack_require__(2025);
	
	var _SegmentXRay2 = _interopRequireDefault(_SegmentXRay);
	
	var _CardXRay = __webpack_require__(2026);
	
	var _CardXRay2 = _interopRequireDefault(_CardXRay);
	
	var _SegmentComparison = __webpack_require__(2028);
	
	var _SegmentComparison2 = _interopRequireDefault(_SegmentComparison);
	
	var _SegmentTableComparison = __webpack_require__(2032);
	
	var _SegmentTableComparison2 = _interopRequireDefault(_SegmentTableComparison);
	
	var _routes = __webpack_require__(2033);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _PeopleListingApp = __webpack_require__(2038);
	
	var _PeopleListingApp2 = _interopRequireDefault(_PeopleListingApp);
	
	var _GroupsListingApp = __webpack_require__(2046);
	
	var _GroupsListingApp2 = _interopRequireDefault(_GroupsListingApp);
	
	var _GroupDetailApp = __webpack_require__(2050);
	
	var _GroupDetailApp2 = _interopRequireDefault(_GroupDetailApp);
	
	var _PublicQuestion = __webpack_require__(1269);
	
	var _PublicQuestion2 = _interopRequireDefault(_PublicQuestion);
	
	var _PublicDashboard = __webpack_require__(1503);
	
	var _PublicDashboard2 = _interopRequireDefault(_PublicDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var MetabaseIsSetup = (0, _reduxAuthWrapper.UserAuthWrapper)({
	    predicate: function predicate(authData) {
	        return !authData.hasSetupToken;
	    },
	    failureRedirectPath: "/setup",
	    authSelector: function authSelector(state) {
	        return { hasSetupToken: _settings2.default.hasSetupToken() };
	    }, // HACK
	    wrapperDisplayName: 'MetabaseIsSetup',
	    allowRedirectBack: false,
	    redirectAction: _reactRouterRedux.routerActions.replace
	});
	
	var UserIsAuthenticated = (0, _reduxAuthWrapper.UserAuthWrapper)({
	    failureRedirectPath: '/auth/login',
	    authSelector: function authSelector(state) {
	        return state.currentUser;
	    },
	    wrapperDisplayName: 'UserIsAuthenticated',
	    redirectAction: function redirectAction(location) {
	        return (
	            // HACK: workaround for redux-auth-wrapper not including hash
	            // https://github.com/mjrussell/redux-auth-wrapper/issues/121
	            _reactRouterRedux.routerActions.replace(_extends({}, location, {
	                query: _extends({}, location.query, {
	                    redirect: location.query.redirect + (window.location.hash || "")
	                })
	            }))
	        );
	    }
	});
	
	var UserIsAdmin = (0, _reduxAuthWrapper.UserAuthWrapper)({
	    predicate: function predicate(currentUser) {
	        return currentUser && currentUser.is_superuser;
	    },
	    failureRedirectPath: '/unauthorized',
	    authSelector: function authSelector(state) {
	        return state.currentUser;
	    },
	    allowRedirectBack: false,
	    wrapperDisplayName: 'UserIsAdmin',
	    redirectAction: _reactRouterRedux.routerActions.replace
	});
	
	var UserIsNotAuthenticated = (0, _reduxAuthWrapper.UserAuthWrapper)({
	    predicate: function predicate(currentUser) {
	        return !currentUser;
	    },
	    failureRedirectPath: '/',
	    authSelector: function authSelector(state) {
	        return state.currentUser;
	    },
	    allowRedirectBack: false,
	    wrapperDisplayName: 'UserIsNotAuthenticated',
	    redirectAction: _reactRouterRedux.routerActions.replace
	});
	
	var IsAuthenticated = MetabaseIsSetup(UserIsAuthenticated(function (_ref) {
	    var children = _ref.children;
	    return children;
	}));
	var IsAdmin = MetabaseIsSetup(UserIsAuthenticated(UserIsAdmin(function (_ref2) {
	    var children = _ref2.children;
	    return children;
	})));
	var IsNotAuthenticated = MetabaseIsSetup(UserIsNotAuthenticated(function (_ref3) {
	    var children = _ref3.children;
	    return children;
	}));
	
	var getRoutes = exports.getRoutes = function getRoutes(store) {
	    return _react2.default.createElement(
	        _Title.Route,
	        { title: "Metabase", component: _App2.default },
	        _react2.default.createElement(_Title.Route, { path: "/setup", component: _SetupApp2.default, onEnter: function onEnter(nextState, replace) {
	                if (!_settings2.default.hasSetupToken()) {
	                    replace("/");
	                }
	            } }),
	        _react2.default.createElement(
	            _Title.Route,
	            { path: "public" },
	            _react2.default.createElement(_Title.Route, { path: "question/:uuid", component: _PublicQuestion2.default }),
	            _react2.default.createElement(_Title.Route, { path: "dashboard/:uuid", component: _PublicDashboard2.default })
	        ),
	        _react2.default.createElement(
	            _Title.Route,
	            { onEnter: function () {
	                    var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(nextState, replace, done) {
	                        return regeneratorRuntime.wrap(function _callee$(_context) {
	                            while (1) {
	                                switch (_context.prev = _context.next) {
	                                    case 0:
	                                        _context.next = 2;
	                                        return store.dispatch((0, _user.loadCurrentUser)());
	
	                                    case 2:
	                                        done();
	
	                                    case 3:
	                                    case "end":
	                                        return _context.stop();
	                                }
	                            }
	                        }, _callee, undefined);
	                    }));
	
	                    return function (_x, _x2, _x3) {
	                        return _ref4.apply(this, arguments);
	                    };
	                }() },
	            _react2.default.createElement(
	                _Title.Route,
	                { path: "/auth" },
	                _react2.default.createElement(_reactRouter.IndexRedirect, { to: "/auth/login" }),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { component: IsNotAuthenticated },
	                    _react2.default.createElement(_Title.Route, { path: "login", title: "Login", component: _LoginApp2.default })
	                ),
	                _react2.default.createElement(_Title.Route, { path: "logout", component: _LogoutApp2.default }),
	                _react2.default.createElement(_Title.Route, { path: "forgot_password", component: _ForgotPasswordApp2.default }),
	                _react2.default.createElement(_Title.Route, { path: "reset_password/:token", component: _PasswordResetApp2.default }),
	                _react2.default.createElement(_Title.Route, { path: "google_no_mb_account", component: _GoogleNoAccount2.default })
	            ),
	            _react2.default.createElement(
	                _Title.Route,
	                { component: IsAuthenticated },
	                _react2.default.createElement(_Title.Route, { path: "/", component: _HomepageApp2.default }),
	                _react2.default.createElement(_Title.Route, { path: "/dashboards", title: "Dashboards", component: _Dashboards2.default }),
	                _react2.default.createElement(_Title.Route, { path: "/dashboards/archive", title: "Dashboards", component: _DashboardsArchive2.default }),
	                _react2.default.createElement(_Title.Route, { path: "/dashboard/:dashboardId", title: "Dashboard", component: _DashboardApp2.default }),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { path: "/question" },
	                    _react2.default.createElement(_reactRouter.IndexRoute, { component: _QueryBuilder2.default }),
	                    _react2.default.createElement(
	                        _Title.Route,
	                        { path: "new", title: "New Question" },
	                        _react2.default.createElement(_reactRouter.IndexRoute, { component: _router_wrappers.NewQuestionStart }),
	                        _react2.default.createElement(_Title.Route, { path: "metric", title: "Metrics", component: _router_wrappers.NewQuestionMetricSearch })
	                    )
	                ),
	                _react2.default.createElement(_Title.Route, { path: "/question/:cardId", component: _QueryBuilder2.default }),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { path: "/questions", title: "Questions" },
	                    _react2.default.createElement(_reactRouter.IndexRoute, { component: _QuestionIndex2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "search", title: function title(_ref5) {
	                            var q = _ref5.location.query.q;
	                            return "Search: " + q;
	                        }, component: _SearchResults2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "archive", title: "Archive", component: _Archive2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "collections/:collectionSlug", component: _CollectionPage2.default })
	                ),
	                _react2.default.createElement(_Title.Route, { path: "/entities/:entityType", component: function component(_ref6) {
	                        var location = _ref6.location,
	                            params = _ref6.params;
	                        return _react2.default.createElement(
	                            "div",
	                            { className: "p4" },
	                            _react2.default.createElement(_EntityList2.default, { entityType: params.entityType, entityQuery: location.query })
	                        );
	                    } }),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { path: "/collections" },
	                    _react2.default.createElement(_Title.Route, { path: "create", component: _CollectionCreate2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "permissions", component: _CollectionsPermissionsApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: ":collectionId", component: _CollectionEdit2.default })
	                ),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { path: "/labels" },
	                    _react2.default.createElement(_reactRouter.IndexRoute, { component: _EditLabels2.default })
	                ),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { path: "/reference", title: "Data Reference" },
	                    _react2.default.createElement(_reactRouter.IndexRedirect, { to: "/reference/guide" }),
	                    _react2.default.createElement(_Title.Route, { path: "guide", title: "Getting Started", component: _GettingStartedGuideContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "metrics", component: _MetricListContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "metrics/:metricId", component: _MetricDetailContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "metrics/:metricId/questions", component: _MetricQuestionsContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "metrics/:metricId/revisions", component: _MetricRevisionsContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "segments", component: _SegmentListContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "segments/:segmentId", component: _SegmentDetailContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "segments/:segmentId/fields", component: _SegmentFieldListContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "segments/:segmentId/fields/:fieldId", component: _SegmentFieldDetailContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "segments/:segmentId/questions", component: _SegmentQuestionsContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "segments/:segmentId/revisions", component: _SegmentRevisionsContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "databases", component: _DatabaseListContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "databases/:databaseId", component: _DatabaseDetailContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "databases/:databaseId/tables", component: _TableListContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "databases/:databaseId/tables/:tableId", component: _TableDetailContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "databases/:databaseId/tables/:tableId/fields", component: _FieldListContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "databases/:databaseId/tables/:tableId/fields/:fieldId", component: _FieldDetailContainer2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "databases/:databaseId/tables/:tableId/questions", component: _TableQuestionsContainer2.default })
	                ),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { path: "/xray", title: "XRay" },
	                    _react2.default.createElement(_Title.Route, { path: "segment/:segmentId/:cost", component: _SegmentXRay2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "table/:tableId/:cost", component: _TableXRay2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "field/:fieldId/:cost", component: _FieldXray2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "card/:cardId/:cost", component: _CardXRay2.default }),
	                    _react2.default.createElement(
	                        _Title.Route,
	                        { path: "compare", title: "Compare" },
	                        _react2.default.createElement(
	                            _Title.Route,
	                            { path: "segments/:segmentId1/:segmentId2" },
	                            _react2.default.createElement(_Title.Route, { path: ":cost", component: _SegmentComparison2.default })
	                        ),
	                        _react2.default.createElement(
	                            _Title.Route,
	                            { path: "segment/:segmentId/table/:tableId" },
	                            _react2.default.createElement(_Title.Route, { path: ":cost", component: _SegmentTableComparison2.default })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { path: "/pulse", title: "Pulses" },
	                    _react2.default.createElement(_reactRouter.IndexRoute, { component: _PulseListApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "create", component: _PulseEditApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: ":pulseId", component: _PulseEditApp2.default })
	                ),
	                _react2.default.createElement(_Title.Route, { path: "/user/edit_current", component: _UserSettingsApp2.default })
	            ),
	            _react2.default.createElement(
	                _Title.Route,
	                { path: "/admin", title: "Admin", component: IsAdmin },
	                _react2.default.createElement(_reactRouter.IndexRedirect, { to: "/admin/settings" }),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { path: "databases", title: "Databases" },
	                    _react2.default.createElement(_reactRouter.IndexRoute, { component: _DatabaseListApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "create", component: _DatabaseEditApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: ":databaseId", component: _DatabaseEditApp2.default })
	                ),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { path: "datamodel", title: "Data Model" },
	                    _react2.default.createElement(_reactRouter.IndexRedirect, { to: "database" }),
	                    _react2.default.createElement(_Title.Route, { path: "database", component: _MetadataEditorApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "database/:databaseId", component: _MetadataEditorApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "database/:databaseId/:mode", component: _MetadataEditorApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "database/:databaseId/:mode/:tableId", component: _MetadataEditorApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "database/:databaseId/:mode/:tableId/settings", component: _TableSettingsApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "database/:databaseId/:mode/:tableId/:fieldId", component: _FieldApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "metric/create", component: _MetricApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "metric/:id", component: _MetricApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "segment/create", component: _SegmentApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: "segment/:id", component: _SegmentApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: ":entity/:id/revisions", component: _RevisionHistoryApp2.default })
	                ),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { path: "people", title: "People", component: _AdminPeopleApp2.default },
	                    _react2.default.createElement(_reactRouter.IndexRoute, { component: _PeopleListingApp2.default }),
	                    _react2.default.createElement(
	                        _Title.Route,
	                        { path: "groups", title: "Groups" },
	                        _react2.default.createElement(_reactRouter.IndexRoute, { component: _GroupsListingApp2.default }),
	                        _react2.default.createElement(_Title.Route, { path: ":groupId", component: _GroupDetailApp2.default })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Title.Route,
	                    { path: "settings", title: "Settings" },
	                    _react2.default.createElement(_reactRouter.IndexRedirect, { to: "/admin/settings/setup" }),
	                    _react2.default.createElement(_Title.Route, { path: ":section/:authType", component: _SettingsEditorApp2.default }),
	                    _react2.default.createElement(_Title.Route, { path: ":section", component: _SettingsEditorApp2.default })
	                ),
	                (0, _routes2.default)(store)
	            ),
	            _react2.default.createElement(_Title.Route, {
	                path: "/_internal",
	                getChildRoutes: function getChildRoutes(partialNextState, callback) {
	                    return (
	                        // $FlowFixMe: flow doesn't know about require.ensure
	                        __webpack_require__.e/* nsure */(4, function (require) {
	                            callback(null, [__webpack_require__(2053).default]);
	                        })
	                    );
	                }
	            }),
	            _react2.default.createElement(_Title.Route, { path: "/q", onEnter: function onEnter(_ref7, replace) {
	                    var location = _ref7.location;
	                    return replace({ pathname: "/question", hash: location.hash });
	                } }),
	            _react2.default.createElement(_Title.Route, { path: "/card/:cardId", onEnter: function onEnter(_ref8, replace) {
	                    var location = _ref8.location,
	                        params = _ref8.params;
	                    return replace({ pathname: "/question/" + params.cardId, hash: location.hash });
	                } }),
	            _react2.default.createElement(_reactRouter.Redirect, { from: "/dash/:dashboardId", to: "/dashboard/:dashboardId" }),
	            _react2.default.createElement(_Title.Route, { path: "/unauthorized", component: _Unauthorized2.default }),
	            _react2.default.createElement(_Title.Route, { path: "/*", component: _NotFound2.default })
	        )
	    );
	};
	getRoutes.displayName = "getRoutes";

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Route = exports.setBaseName = exports.setHierarchical = exports.setSeparator = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reactRouter = __webpack_require__(1128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var componentStack = [];
	
	var SEPARATOR = " · ";
	var HIERARCHICAL = true;
	var BASE_NAME = null;
	
	var setSeparator = exports.setSeparator = function setSeparator(separator) {
	    return SEPARATOR = separator;
	};
	var setHierarchical = exports.setHierarchical = function setHierarchical(hierarchical) {
	    return HIERARCHICAL = hierarchical;
	};
	var setBaseName = exports.setBaseName = function setBaseName(baseName) {
	    return BASE_NAME = baseName;
	};
	
	var updateDocumentTitle = _underscore2.default.debounce(function () {
	    if (HIERARCHICAL) {
	        document.title = componentStack.map(function (component) {
	            return component._documentTitle;
	        }).filter(function (title) {
	            return title;
	        }).reverse().join(SEPARATOR);
	    } else {
	        // update with the top-most title
	        for (var i = componentStack.length - 1; i >= 0; i--) {
	            var _title = componentStack[i]._documentTitle;
	            if (_title) {
	                if (BASE_NAME) {
	                    _title += SEPARATOR + BASE_NAME;
	                }
	                if (document.title !== _title) {
	                    document.title = _title;
	                }
	                break;
	            }
	        }
	    }
	});
	
	var title = function title(documentTitleOrGetter) {
	    return function (ComposedComponent) {
	        var _class, _temp;
	
	        return _temp = _class = function (_React$Component) {
	            _inherits(_class, _React$Component);
	
	            function _class() {
	                _classCallCheck(this, _class);
	
	                return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	            }
	
	            _createClass(_class, [{
	                key: "componentWillMount",
	                value: function componentWillMount() {
	                    componentStack.push(this);
	                    this._updateDocumentTitle();
	                }
	            }, {
	                key: "componentDidUpdate",
	                value: function componentDidUpdate() {
	                    this._updateDocumentTitle();
	                }
	            }, {
	                key: "componentWillUnmount",
	                value: function componentWillUnmount() {
	                    for (var i = 0; i < componentStack.length; i++) {
	                        if (componentStack[i] === this) {
	                            componentStack.splice(i, 1);
	                            break;
	                        }
	                    }
	                    this._updateDocumentTitle();
	                }
	            }, {
	                key: "_updateDocumentTitle",
	                value: function _updateDocumentTitle() {
	                    if (typeof documentTitleOrGetter === "string") {
	                        this._documentTitle = documentTitleOrGetter;
	                    } else if (typeof documentTitleOrGetter === "function") {
	                        this._documentTitle = documentTitleOrGetter(this.props);
	                    }
	                    updateDocumentTitle();
	                }
	            }, {
	                key: "render",
	                value: function render() {
	                    return _react2.default.createElement(ComposedComponent, this.props);
	                }
	            }]);
	
	            return _class;
	        }(_react2.default.Component), _class.displayName = "Title[" + (ComposedComponent.displayName || ComposedComponent.name) + "]", _temp;
	    };
	};
	
	exports.default = title;
	
	// react-router Route wrapper that adds a `title` property
	var Route = exports.Route = function (_Route2) {
	    _inherits(Route, _Route2);
	
	    function Route() {
	        _classCallCheck(this, Route);
	
	        return _possibleConstructorReturn(this, (Route.__proto__ || Object.getPrototypeOf(Route)).apply(this, arguments));
	    }
	
	    _createClass(Route, null, [{
	        key: "createRouteFromReactElement",
	        value: function createRouteFromReactElement(element) {
	            if (element.props.title) {
	                element = _react2.default.cloneElement(element, {
	                    component: title(element.props.title)(element.props.component || function (_ref) {
	                        var children = _ref.children;
	                        return children;
	                    })
	                });
	            }
	            return _reactRouter.Route.createRouteFromReactElement(element);
	        }
	    }]);

	    return Route;
	}(_reactRouter.Route);

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserAuthWrapper = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _hoistNonReactStatics = __webpack_require__(474);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _lodash = __webpack_require__(1540);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _url = __webpack_require__(1120);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var defaults = {
	  LoadingComponent: function LoadingComponent() {
	    return null;
	  }, // dont render anything while authenticating
	  failureRedirectPath: '/login',
	  FailureComponent: undefined,
	  redirectQueryParamName: 'redirect',
	  wrapperDisplayName: 'AuthWrapper',
	  predicate: function predicate(x) {
	    return !(0, _lodash2.default)(x);
	  },
	  authenticatingSelector: function authenticatingSelector() {
	    return false;
	  },
	  allowRedirectBack: true,
	  propMapper: function propMapper(_ref) {
	    var redirect = _ref.redirect,
	        authData = _ref.authData,
	        isAuthenticating = _ref.isAuthenticating,
	        failureRedirectPath = _ref.failureRedirectPath,
	        otherProps = _objectWithoutProperties(_ref, ['redirect', 'authData', 'isAuthenticating', 'failureRedirectPath']);
	
	    return _extends({ authData: authData }, otherProps);
	  } // eslint-disable-line no-unused-vars
	};
	
	var UserAuthWrapper = exports.UserAuthWrapper = function UserAuthWrapper(args) {
	  var _defaults$args = _extends({}, defaults, args),
	      authSelector = _defaults$args.authSelector,
	      authenticatingSelector = _defaults$args.authenticatingSelector,
	      LoadingComponent = _defaults$args.LoadingComponent,
	      failureRedirectPath = _defaults$args.failureRedirectPath,
	      FailureComponent = _defaults$args.FailureComponent,
	      wrapperDisplayName = _defaults$args.wrapperDisplayName,
	      predicate = _defaults$args.predicate,
	      allowRedirectBack = _defaults$args.allowRedirectBack,
	      redirectAction = _defaults$args.redirectAction,
	      redirectQueryParamName = _defaults$args.redirectQueryParamName,
	      propMapper = _defaults$args.propMapper;
	
	  var isAuthorized = function isAuthorized(authData) {
	    return predicate(authData);
	  };
	
	  var createRedirect = function createRedirect(location, redirect, redirectPath) {
	    var redirectLoc = _url2.default.parse(redirectPath, true);
	
	    var query = void 0;
	    var canRedirect = typeof allowRedirectBack === 'function' ? allowRedirectBack(location, redirectPath) : allowRedirectBack;
	
	    if (canRedirect) {
	      query = _defineProperty({}, redirectQueryParamName, '' + location.pathname + location.search);
	    } else {
	      query = {};
	    }
	
	    query = _extends({}, query, redirectLoc.query);
	
	    redirect({
	      pathname: redirectLoc.pathname,
	      query: query
	    });
	  };
	
	  var shouldRedirect = FailureComponent === undefined;
	  var locationShape = _react.PropTypes.shape({
	    pathname: _react.PropTypes.string.isRequired,
	    search: _react.PropTypes.string.isRequired
	  });
	
	  // Wraps the component that needs the auth enforcement
	  function wrapComponent(DecoratedComponent) {
	    var _dec, _class, _class2, _temp2;
	
	    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	      if (redirectAction !== undefined) {
	        return { redirect: function redirect(args) {
	            return dispatch(redirectAction(args));
	          } };
	      } else {
	        return {};
	      }
	    };
	
	    var UserAuthWrapper = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
	      return {
	        authData: authSelector(state, ownProps),
	        failureRedirectPath: typeof failureRedirectPath === 'function' ? failureRedirectPath(state, ownProps) : failureRedirectPath,
	        isAuthenticating: authenticatingSelector(state, ownProps)
	      };
	    }, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_Component) {
	      _inherits(UserAuthWrapper, _Component);
	
	      function UserAuthWrapper() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, UserAuthWrapper);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = UserAuthWrapper.__proto__ || Object.getPrototypeOf(UserAuthWrapper)).call.apply(_ref2, [this].concat(args))), _this), _this.getRedirectFunc = function (_ref3) {
	          var redirect = _ref3.redirect;
	
	          if (redirect) {
	            return redirect;
	          } else {
	            if (!_this.context.router.replace) {
	              /* istanbul ignore next sanity */
	              throw new Error('You must provide a router context (or use React-Router 2.x) if not passing a redirectAction to ' + wrapperDisplayName);
	            } else {
	              return _this.context.router.replace;
	            }
	          }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(UserAuthWrapper, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          if (!this.props.isAuthenticating && !isAuthorized(this.props.authData) && shouldRedirect) {
	            createRedirect(this.props.location, this.getRedirectFunc(this.props), this.props.failureRedirectPath);
	          }
	        }
	      }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          var willBeAuthorized = isAuthorized(nextProps.authData);
	          var willbeAuthenticating = nextProps.isAuthenticating;
	          var wasAuthorized = isAuthorized(this.props.authData);
	          var wasAuthenticating = this.props.isAuthenticating;
	
	          // Don't bother to redirect if:
	          // 1. currently authenticating or FailureComponent is set
	          if (willbeAuthenticating || !shouldRedirect) return;
	
	          // Redirect if:
	          if ( // 1. Was authorized, but no longer
	          wasAuthorized && !willBeAuthorized ||
	          // 2. Was not authorized and authenticating
	          wasAuthenticating && !willBeAuthorized) {
	            createRedirect(nextProps.location, this.getRedirectFunc(nextProps), nextProps.failureRedirectPath);
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          // Allow everything but the replace aciton creator to be passed down
	          // Includes route props from React-Router and authData
	          var _props = this.props,
	              authData = _props.authData,
	              isAuthenticating = _props.isAuthenticating;
	
	          if (isAuthorized(authData)) {
	            return _react2.default.createElement(DecoratedComponent, propMapper(this.props));
	          } else if (isAuthenticating) {
	            return _react2.default.createElement(LoadingComponent, propMapper(this.props));
	          } else {
	            // Display FailureComponent or nothing if FailureComponent is null
	            // If FailureComponent is undefined user will never see this because
	            // they will be redirected to failureRedirectPath
	            return FailureComponent ? _react2.default.createElement(FailureComponent, propMapper(this.props)) : null;
	          }
	        }
	      }]);
	
	      return UserAuthWrapper;
	    }(_react.Component), _class2.displayName = wrapperDisplayName + '(' + displayName + ')', _class2.propTypes = {
	      failureRedirectPath: _react.PropTypes.string.isRequired,
	      location: shouldRedirect ? locationShape.isRequired : locationShape,
	      redirect: _react.PropTypes.func,
	      authData: _react.PropTypes.object
	    }, _class2.contextTypes = {
	      // Only used if no redirectAction specified
	      router: _react.PropTypes.object
	    }, _temp2)) || _class);
	
	
	    return (0, _hoistNonReactStatics2.default)(UserAuthWrapper, DecoratedComponent);
	  }
	
	  if (shouldRedirect) {
	    wrapComponent.onEnter = function (store, nextState, replace) {
	      var authData = authSelector(store.getState(), nextState);
	      var isAuthenticating = authenticatingSelector(store.getState(), nextState);
	
	      if (!isAuthorized(authData) && !isAuthenticating) {
	        var redirectPath = typeof failureRedirectPath === 'function' ? failureRedirectPath(store.getState(), nextState) : failureRedirectPath;
	        createRedirect(nextState.location, replace, redirectPath);
	      }
	    };
	  }
	
	  return wrapComponent;
	};

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap');
	
	/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
	var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' ||
	        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (nonEnumShadows || isPrototype(value)) {
	    return !nativeKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEmpty;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(494)(module)))

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; /*  weak */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Navbar = __webpack_require__(1542);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _UndoListing = __webpack_require__(1558);
	
	var _UndoListing2 = _interopRequireDefault(_UndoListing);
	
	var _NotFound = __webpack_require__(1563);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _Unauthorized = __webpack_require__(1564);
	
	var _Unauthorized2 = _interopRequireDefault(_Unauthorized);
	
	var _Archived = __webpack_require__(1565);
	
	var _Archived2 = _interopRequireDefault(_Archived);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        errorPage: state.app.errorPage
	    };
	};
	
	var getErrorComponent = function getErrorComponent(_ref) {
	    var status = _ref.status,
	        data = _ref.data,
	        context = _ref.context;
	
	    if (status === 403) {
	        return _react2.default.createElement(_Unauthorized2.default, null);
	    } else if (data && data.error_code === "archived" && context === "dashboard") {
	        return _react2.default.createElement(_Archived2.default, { entityName: "dashboard", linkTo: "/dashboards/archive" });
	    } else if (data && data.error_code === "archived" && context === "query-builder") {
	        return _react2.default.createElement(_Archived2.default, { entityName: "question", linkTo: "/questions/archive" });
	    } else {
	        return _react2.default.createElement(_NotFound2.default, null);
	    }
	};
	
	var App = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = function (_Component) {
	    _inherits(App, _Component);
	
	    function App() {
	        _classCallCheck(this, App);
	
	        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	    }
	
	    _createClass(App, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                location = _props.location,
	                errorPage = _props.errorPage;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "spread flex flex-column" },
	                _react2.default.createElement(_Navbar2.default, { location: location, className: "flex-no-shrink" }),
	                errorPage ? getErrorComponent(errorPage) : children,
	                _react2.default.createElement(_UndoListing2.default, null)
	            );
	        }
	    }]);
	
	    return App;
	}(_react.Component)) || _class);
	App.displayName = "App";
	exports.default = App;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LogoIcon = __webpack_require__(1205);
	
	var _LogoIcon2 = _interopRequireDefault(_LogoIcon);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _ProfileLink = __webpack_require__(1543);
	
	var _ProfileLink2 = _interopRequireDefault(_ProfileLink);
	
	var _selectors = __webpack_require__(1557);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        path: (0, _selectors.getPath)(state, props),
	        context: (0, _selectors.getContext)(state, props),
	        user: (0, _selectors.getUser)(state)
	    };
	};
	
	var mapDispatchToProps = {
	    onChangeLocation: _reactRouterRedux.push
	};
	
	var BUTTON_PADDING_STYLES = {
	    navButton: {
	        paddingLeft: "1.0rem",
	        paddingRight: "1.0rem",
	        paddingTop: "0.75rem",
	        paddingBottom: "0.75rem"
	    },
	
	    newQuestion: {
	        paddingLeft: "1.0rem",
	        paddingRight: "1.0rem",
	        paddingTop: "0.75rem",
	        paddingBottom: "0.75rem"
	    }
	};
	
	var AdminNavItem = function AdminNavItem(_ref) {
	    var name = _ref.name,
	        path = _ref.path,
	        currentPath = _ref.currentPath;
	    return _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	            _reactRouter.Link,
	            {
	                to: path,
	                "data-metabase-event": "NavBar;" + name,
	                className: (0, _classnames2.default)("NavItem py1 px2 no-decoration", { "is--selected": currentPath.startsWith(path) })
	            },
	            name
	        )
	    );
	};
	
	AdminNavItem.displayName = "AdminNavItem";
	var MainNavLink = function MainNavLink(_ref2) {
	    var to = _ref2.to,
	        name = _ref2.name,
	        eventName = _ref2.eventName;
	    return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	            to: to,
	            "data-metabase-event": "NavBar;" + eventName,
	            style: BUTTON_PADDING_STYLES.navButton,
	            className: "NavItem cursor-pointer text-white text-bold no-decoration flex align-center px2 transition-background",
	            activeClassName: "NavItem--selected"
	        },
	        name
	    );
	};
	
	MainNavLink.displayName = "MainNavLink";
	var Navbar = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(Navbar, _Component);
	
	    function Navbar(props, context) {
	        _classCallCheck(this, Navbar);
	
	        return _possibleConstructorReturn(this, (Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call(this, props, context));
	    }
	
	    _createClass(Navbar, [{
	        key: "isActive",
	        value: function isActive(path) {
	            return this.props.path.startsWith(path);
	        }
	    }, {
	        key: "renderAdminNav",
	        value: function renderAdminNav() {
	            return _react2.default.createElement(
	                "nav",
	                { className: (0, _classnames2.default)("Nav AdminNav", this.props.className) },
	                _react2.default.createElement(
	                    "div",
	                    { className: "wrapper flex align-center" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "NavTitle flex align-center" },
	                        _react2.default.createElement(_Icon2.default, { name: 'gear', className: "AdminGear", size: 22 }),
	                        _react2.default.createElement(
	                            "span",
	                            { className: "NavItem-text ml1 hide sm-show text-bold" },
	                            "Metabase Admin Panel"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        { className: "sm-ml4 flex flex-full text-strong" },
	                        _react2.default.createElement(AdminNavItem, { name: "Settings", path: "/admin/settings", currentPath: this.props.path }),
	                        _react2.default.createElement(AdminNavItem, { name: "People", path: "/admin/people", currentPath: this.props.path }),
	                        _react2.default.createElement(AdminNavItem, { name: "Data Model", path: "/admin/datamodel", currentPath: this.props.path }),
	                        _react2.default.createElement(AdminNavItem, { name: "Databases", path: "/admin/databases", currentPath: this.props.path }),
	                        _react2.default.createElement(AdminNavItem, { name: "Permissions", path: "/admin/permissions", currentPath: this.props.path })
	                    ),
	                    _react2.default.createElement(_ProfileLink2.default, this.props)
	                )
	            );
	        }
	    }, {
	        key: "renderEmptyNav",
	        value: function renderEmptyNav() {
	            return _react2.default.createElement(
	                "nav",
	                { className: (0, _classnames2.default)("Nav py2 sm-py1 xl-py3 relative", this.props.className) },
	                _react2.default.createElement(
	                    "ul",
	                    { className: "wrapper flex align-center" },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/", "data-metabase-event": "Navbar;Logo", className: "NavItem cursor-pointer flex align-center" },
	                            _react2.default.createElement(_LogoIcon2.default, { className: "text-brand my2" })
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: "renderMainNav",
	        value: function renderMainNav() {
	            return _react2.default.createElement(
	                "nav",
	                { className: (0, _classnames2.default)("Nav relative bg-brand sm-py2 sm-py1 xl-py3", this.props.className) },
	                _react2.default.createElement(
	                    "ul",
	                    { className: "ml2 sm-pl4 pr1 flex align-center" },
	                    _react2.default.createElement(
	                        "li",
	                        null,
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/", "data-metabase-event": "Navbar;Logo", className: "NavItem cursor-pointer text-white flex align-center my1 transition-background p1" },
	                            _react2.default.createElement(_LogoIcon2.default, { dark: true })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "pl3 hide xs-show" },
	                        _react2.default.createElement(MainNavLink, { to: "/dashboards", name: "Dashboards", eventName: "Dashboards" })
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "pl1 hide xs-show" },
	                        _react2.default.createElement(MainNavLink, { to: "/questions", name: "Questions", eventName: "Questions" })
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "pl1 hide sm-show" },
	                        _react2.default.createElement(MainNavLink, { to: "/pulse", name: "Pulses", eventName: "Pulses" })
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "pl1 hide sm-show" },
	                        _react2.default.createElement(MainNavLink, { to: "/reference/guide", name: "Data Reference", eventName: "DataReference" })
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "pl3 hide sm-show" },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: Urls.newQuestion(), "data-metabase-event": "Navbar;New Question", style: BUTTON_PADDING_STYLES.newQuestion, className: "NavNewQuestion rounded inline-block bg-white text-brand text-bold cursor-pointer px2 no-decoration transition-all" },
	                            "New ",
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                "Question"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "li",
	                        { className: "flex-align-right transition-background" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "inline-block text-white" },
	                            _react2.default.createElement(_ProfileLink2.default, this.props)
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                context = _props.context,
	                user = _props.user;
	
	
	            if (!user) return null;
	
	            switch (context) {
	                case "admin":
	                    return this.renderAdminNav();
	                case "auth":
	                    return null;
	                case "none":
	                    return this.renderEmptyNav();
	                case "setup":
	                    return null;
	                default:
	                    return this.renderMainNav();
	            }
	        }
	    }]);
	
	    return Navbar;
	}(_react.Component), _class2.propTypes = {
	    className: _propTypes2.default.string,
	    context: _propTypes2.default.string.isRequired,
	    path: _propTypes2.default.string.isRequired,
	    user: _propTypes2.default.object
	}, _temp)) || _class);
	Navbar.displayName = "Navbar";
	exports.default = Navbar;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _OnClickOutsideWrapper = __webpack_require__(933);
	
	var _OnClickOutsideWrapper2 = _interopRequireDefault(_OnClickOutsideWrapper);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _formatting = __webpack_require__(872);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Logs = __webpack_require__(1544);
	
	var _Logs2 = _interopRequireDefault(_Logs);
	
	var _UserAvatar = __webpack_require__(1556);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LogoIcon = __webpack_require__(1205);
	
	var _LogoIcon2 = _interopRequireDefault(_LogoIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileLink = (_temp = _class = function (_Component) {
	    _inherits(ProfileLink, _Component);
	
	    function ProfileLink(props, context) {
	        _classCallCheck(this, ProfileLink);
	
	        var _this = _possibleConstructorReturn(this, (ProfileLink.__proto__ || Object.getPrototypeOf(ProfileLink)).call(this, props, context));
	
	        _this.state = {
	            dropdownOpen: false,
	            modalOpen: null
	        };
	
	        _underscore2.default.bindAll(_this, "toggleDropdown", "closeDropdown", "openModal", "closeModal");
	        return _this;
	    }
	
	    _createClass(ProfileLink, [{
	        key: "toggleDropdown",
	        value: function toggleDropdown() {
	            this.setState({ dropdownOpen: !this.state.dropdownOpen });
	        }
	    }, {
	        key: "closeDropdown",
	        value: function closeDropdown() {
	            this.setState({ dropdownOpen: false });
	        }
	    }, {
	        key: "openModal",
	        value: function openModal(modalName) {
	            this.setState({ dropdownOpen: false, modalOpen: modalName });
	        }
	    }, {
	        key: "closeModal",
	        value: function closeModal() {
	            this.setState({ modalOpen: null });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                context = _props.context;
	            var _state = this.state,
	                modalOpen = _state.modalOpen,
	                dropdownOpen = _state.dropdownOpen;
	
	            var _MetabaseSettings$get = _settings2.default.get('version'),
	                tag = _MetabaseSettings$get.tag,
	                date = _MetabaseSettings$get.date,
	                versionExtra = _objectWithoutProperties(_MetabaseSettings$get, ["tag", "date"]);
	
	            var dropDownClasses = (0, _classnames2.default)({
	                'NavDropdown': true,
	                'inline-block': true,
	                'cursor-pointer': true,
	                'open': dropdownOpen
	            });
	
	            return _react2.default.createElement(
	                "div",
	                { className: dropDownClasses },
	                _react2.default.createElement(
	                    "a",
	                    { "data-metabase-event": "Navbar;Profile Dropdown;Toggle", className: "NavDropdown-button NavItem flex align-center p2 transition-background", onClick: this.toggleDropdown },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "NavDropdown-button-layer" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex align-center" },
	                            _react2.default.createElement(_UserAvatar2.default, { user: user, style: { backgroundColor: 'transparent' } }),
	                            _react2.default.createElement(_Icon2.default, { name: "chevrondown", className: "Dropdown-chevron ml1", size: 8 })
	                        )
	                    )
	                ),
	                dropdownOpen ? _react2.default.createElement(
	                    _OnClickOutsideWrapper2.default,
	                    { handleDismissal: this.closeDropdown },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "NavDropdown-content right" },
	                        _react2.default.createElement(
	                            "ul",
	                            { className: "NavDropdown-content-layer" },
	                            !user.google_auth && !user.ldap_auth ? _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: "/user/edit_current", "data-metabase-event": "Navbar;Profile Dropdown;Edit Profile", onClick: this.closeDropdown, className: "Dropdown-item block text-white no-decoration" },
	                                    "Account Settings"
	                                )
	                            ) : null,
	                            user.is_superuser && context !== 'admin' ? _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: "/admin", "data-metabase-event": "Navbar;Profile Dropdown;Enter Admin", onClick: this.closeDropdown, className: "Dropdown-item block text-white no-decoration" },
	                                    "Admin Panel"
	                                )
	                            ) : null,
	                            user.is_superuser && context === 'admin' ? _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: "/", "data-metabase-event": "Navbar;Profile Dropdown;Exit Admin", onClick: this.closeDropdown, className: "Dropdown-item block text-white no-decoration" },
	                                    "Exit Admin"
	                                )
	                            ) : null,
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "a",
	                                    { "data-metabase-event": "Navbar;Profile Dropdown;Help " + tag, className: "Dropdown-item block text-white no-decoration", href: "http://www.metabase.com/docs/" + tag, target: "_blank" },
	                                    "Help"
	                                )
	                            ),
	                            user.is_superuser && _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "a",
	                                    { "data-metabase-event": "Navbar;Profile Dropdown;Debugging " + tag, onClick: this.openModal.bind(this, "logs"), className: "Dropdown-item block text-white no-decoration" },
	                                    "Logs"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "a",
	                                    { "data-metabase-event": "Navbar;Profile Dropdown;About " + tag, onClick: this.openModal.bind(this, "about"), className: "Dropdown-item block text-white no-decoration" },
	                                    "About Metabase"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                { className: "border-top border-light" },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    {
	                                        to: "/auth/logout",
	                                        "data-metabase-event": "Navbar;Profile Dropdown;Logout",
	                                        className: "Dropdown-item block text-white no-decoration"
	                                    },
	                                    "Sign out"
	                                )
	                            )
	                        )
	                    )
	                ) : null,
	                modalOpen === "about" ? _react2.default.createElement(
	                    _Modal2.default,
	                    { small: true, onClose: this.closeModal },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "px4 pt4 pb2 text-centered relative" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "absolute top right p4 text-normal text-grey-3 cursor-pointer", onClick: this.closeModal },
	                            _react2.default.createElement(_Icon2.default, { name: 'close', size: 16 })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "text-brand pb2" },
	                            _react2.default.createElement(_LogoIcon2.default, { width: 48, height: 48 })
	                        ),
	                        _react2.default.createElement(
	                            "h2",
	                            { style: { fontSize: "1.75em" }, className: "text-dark" },
	                            "Thanks for using Metabase!"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "pt2" },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "text-dark mb1" },
	                                "You're on version ",
	                                tag
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-grey-3 text-bold" },
	                                "Built on ",
	                                date
	                            ),
	                            !/^v\d+\.\d+\.\d+$/.test(tag) && _react2.default.createElement(
	                                "div",
	                                null,
	                                _underscore2.default.map(versionExtra, function (value, key) {
	                                    return _react2.default.createElement(
	                                        "p",
	                                        { key: key, className: "text-grey-3 text-bold" },
	                                        (0, _formatting.capitalize)(key),
	                                        ": ",
	                                        value
	                                    );
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { style: { borderWidth: "2px" }, className: "p2 h5 text-centered text-grey-3 border-top" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "block" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "text-bold" },
	                                "Metabase"
	                            ),
	                            " is a Trademark of Metabase, Inc"
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "and is built with care in San Francisco, CA"
	                        )
	                    )
	                ) : modalOpen === "logs" ? _react2.default.createElement(
	                    _Modal2.default,
	                    { wide: true, onClose: this.closeModal },
	                    _react2.default.createElement(_Logs2.default, { onClose: this.closeModal })
	                ) : null
	            );
	        }
	    }]);
	
	    return ProfileLink;
	}(_react.Component), _class.propTypes = {
	    user: _propTypes2.default.object.isRequired,
	    context: _propTypes2.default.string.isRequired
	}, _temp);
	ProfileLink.displayName = "ProfileLink";
	exports.default = ProfileLink;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _services = __webpack_require__(857);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _reactAnsiStyle = __webpack_require__(1545);
	
	var _reactAnsiStyle2 = _interopRequireDefault(_reactAnsiStyle);
	
	__webpack_require__(1549);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logs = function (_Component) {
	    _inherits(Logs, _Component);
	
	    function Logs() {
	        _classCallCheck(this, Logs);
	
	        var _this = _possibleConstructorReturn(this, (Logs.__proto__ || Object.getPrototypeOf(Logs)).call(this));
	
	        _this.state = {
	            logs: [],
	            scrollToBottom: true
	        };
	
	        _this._onScroll = function () {
	            _this.scrolling = true;
	            _this._onScrollDebounced();
	        };
	        _this._onScrollDebounced = _underscore2.default.debounce(function () {
	            var elem = _reactDom2.default.findDOMNode(_this).parentNode;
	            var scrollToBottom = Math.abs(elem.scrollTop - (elem.scrollHeight - elem.offsetHeight)) < 10;
	            _this.setState({ scrollToBottom: scrollToBottom }, function () {
	                _this.scrolling = false;
	            });
	        }, 500);
	        return _this;
	    }
	
	    _createClass(Logs, [{
	        key: "fetchLogs",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var logs;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _services.UtilApi.logs();
	
	                            case 2:
	                                logs = _context.sent;
	
	                                this.setState({ logs: logs.reverse() });
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchLogs() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchLogs;
	        }()
	    }, {
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.timer = setInterval(this.fetchLogs.bind(this), 1000);
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var elem = _reactDom2.default.findDOMNode(this).parentNode;
	            elem.addEventListener("scroll", this._onScroll, false);
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var elem = _reactDom2.default.findDOMNode(this).parentNode;
	            if (!this.scrolling && this.state.scrollToBottom) {
	                if (elem.scrollTop !== elem.scrollHeight - elem.offsetHeight) {
	                    elem.scrollTop = elem.scrollHeight - elem.offsetHeight;
	                }
	            }
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            var elem = _reactDom2.default.findDOMNode(this).parentNode;
	            elem.removeEventListener("scroll", this._onScroll, false);
	            clearTimeout(this.timer);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var logs = this.state.logs;
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: !logs || logs.length === 0 },
	                function () {
	                    return _react2.default.createElement(
	                        "div",
	                        { style: { backgroundColor: "black", fontFamily: "monospace", fontSize: "14px", whiteSpace: "pre-line", padding: "0.5em" } },
	                        (0, _reactAnsiStyle2.default)(_react2.default, logs.join("\n"))
	                    );
	                }
	            );
	        }
	    }]);
	
	    return Logs;
	}(_react.Component);
	
	Logs.displayName = "Logs";
	exports.default = Logs;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	var parser = __webpack_require__(1546);
	var default_prefix = __webpack_require__(1548);
	
	module.exports = function(React, str, opts){
	  opts = opts || {};
	  var prefix = opts.prefix || default_prefix;
	  return parser(str).map(function(chunk, i){
	    return React.createElement('span', {
	      key: i,
	      className: chunk.styles.map(function(style){
	        return prefix + style;
	      }).join(' ')
	    }, chunk.text);
	  });
	};


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	var ansiRegEx = __webpack_require__(1547);
	
	var each = function(obj, fn){
	  var key;
	  for(key in obj){
	    if(obj.hasOwnProperty(key)){
	      fn(obj[key], key, obj);
	    }
	  }
	};
	
	var removeElm = function(arr, val){
	  var i = arr.indexOf(val);
	  if(i >= 0){
	    arr.splice(i, 1)
	  }
	};
	
	//values - first is the code, the reset are escapes
	var styles = {
	  bold: [1, 21, 22],
	  dim: [2, 21, 22],
	  italic: [3, 23],
	  underline: [4, 24],
	  inverse: [7, 27],
	  hidden: [8, 28],
	  strikethrough: [9, 29],
	  black: [30, 39],
	  red: [31, 39],
	  green: [32, 39],
	  yellow: [33, 39],
	  blue: [34, 39],
	  magenta: [35, 39],
	  cyan: [36, 39],
	  white: [37, 39],
	  gray: [90, 39],
	  lightRed: [91, 39],
	  lightGreen: [92, 39],
	  lightYellow: [93, 39],
	  lightBlue: [94, 39],
	  lightMagenta: [95, 39],
	  lightCyan: [96, 39],
	  lightWhite: [97, 39],
	  bgBlack: [40, 49],
	  bgRed: [41, 49],
	  bgGreen: [42, 49],
	  bgYellow: [43, 49],
	  bgBlue: [44, 49],
	  bgMagenta: [45, 49],
	  bgCyan: [46, 49],
	  bgWhite: [47, 49],
	  bgGray: [100, 49],
	  bgLightRed: [101, 49],
	  bgLightGreen: [102, 49],
	  bgLightYellow: [103, 49],
	  bgLightBlue: [104, 49],
	  bgLightMagenta: [105, 49],
	  bgLightCyan: [106, 49],
	  bgLightWhite: [107, 49],
	};
	
	var code_to_style = {};
	var escape_codes = {};
	var common_escapes = {};
	
	var addEscapeCode = function(escape_code, code, name){
	  if(!escape_codes[escape_code]){
	    escape_codes[escape_code] = {};
	  }
	  escape_codes[escape_code][code] = true;
	  escape_codes[escape_code][name] = true;
	};
	
	each(styles, function(style, name){
	  var code = '\u001b['+style[0]+'m';
	  code_to_style[code] = name;
	
	  each(style.slice(1), function(num){
	    var esc_code = '\u001b['+num+'m';
	    addEscapeCode(esc_code, code, name);
	    if(!common_escapes[esc_code]){
	      common_escapes[esc_code] = {};
	    }
	    common_escapes[esc_code][code] = true;
	  });
	  addEscapeCode('\u001b[m', code, name);
	  addEscapeCode('\u001b[0m', code, name);
	});
	
	each(common_escapes, function(styles, code){
	  each(styles, function(o, style_a){
	    each(styles, function(o, style_b){
	      if(style_a !== style_b){
	        addEscapeCode(style_a, style_b, code_to_style[style_b]);
	      }
	    });
	  });
	});
	
	module.exports = function(str){
	  var r = [];
	  var curr = str;
	  var curr_style = [];
	  var code;
	  var e;
	  while(e = ansiRegEx().exec(curr)){
	    if(e.index > 0){
	      r.push({
	        styles: curr_style.slice(0),
	        text: curr.substr(0, e.index)
	      });
	    }
	    code = e[0];
	    if(escape_codes[code]){
	      each(escape_codes[code], function(o, code){
	        removeElm(curr_style, code);
	      });
	    }
	    if(code_to_style[code]){
	      curr_style.push(code_to_style[code]);
	    }
	    curr = curr.substr(e.index + e[0].length);
	  }
	  if(curr.length > 0){
	    r.push({
	      styles: curr_style,
	      text: curr
	    });
	  }
	  return r;
	};


/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function () {
		return /[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-PRZcf-nqry=><]/g;
	};


/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	module.exports = 'react-ansi-style-';


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	var jsCss = __webpack_require__(1550);
	var prefix = __webpack_require__(1548);
	
	var styles = {
	  bold: {'font-weight': 'bold'},
	  dim: {'font-weight': 'lighter'},
	  italic: {'font-style': 'italic'},
	  underline: {'text-decoration': 'underline'},
	  inverse: {'color': 'black', 'background-color': 'white'},
	  hidden: {'color': 'transparent'},
	  strikethrough: {'text-decoration': 'line-through'}
	};
	
	[
	  'black',
	  'red',
	  'green',
	  'yellow',
	  'blue',
	  'magenta',
	  'cyan',
	  'white',
	  'gray'
	].forEach(function(color){
	  styles[color] = {'color': color};
	  styles['bg' + color[0].toUpperCase() + color.substr(1)] = {
	    'background-color': color
	  };
	});
	
	var prefixed_styles = {};
	var key;
	for(key in styles){
	  if(styles.hasOwnProperty(key)){
	    prefixed_styles['.' + prefix + key] = styles[key];
	  }
	}
	jsCss(prefixed_styles);


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	var jsToCss = __webpack_require__(1551);
	var insertCss = __webpack_require__(1555);
	
	if(typeof document === "undefined"){
	  insertCss = function(){};
	}
	
	var css = "";
	var has_inserted_batch = false;
	setTimeout(function(){
	  if(css.length > 0){
	    insertCss(css);
	    has_inserted_batch = true;
	  }
	}, 1);
	
	module.exports = function(json){
	  var d = jsToCss(json);
	  if(has_inserted_batch){
	    insertCss(d.css);
	  }else{
	    css += "\n" + d.css;
	  }
	  return d.vars;
	};


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	var gen = __webpack_require__(1552);
	var replaceVars = __webpack_require__(1554);
	
	var map = function(obj, fn){
	  var r = [];
	  for(k in obj){
	    if(obj.hasOwnProperty(k)){
	      r.push(fn(obj[k], k));
	    }
	  }
	  return r;
	};
	
	var normalizeWhitespace = function(str){
	  return str.replace(/\s+/g, " ").replace(/^\s+/, "").replace(/\s+$/, "");
	};
	
	var renderProperties = function(properties){
	  return map(properties, function(val, key){
	    return normalizeWhitespace(key) + ":" + normalizeWhitespace(val + "");
	  }).join(";");
	};
	
	var renderRules = function(rules){
	  return map(rules, function(group_rules, group){
	
	    var group_css = map(group_rules, function(properties, key){
	      return normalizeWhitespace(key) + "{" + renderProperties(properties) + "}";
	    }).join("\n");
	
	    return group.length > 0
	      ? group + "{" + group_css + "}"
	      : group_css;
	  }).join("\n");
	};
	
	var keyToRule = function(context, key){
	  return map(context.split(","), function(c){
	    return map(key.split(","), function(p){
	      p = normalizeWhitespace(p);
	
	      if(p[0] === ":"){
	        return c + p;
	      }else if(p[0] === "&"){
	        return c + p.substring(1);
	      }
	      return (c + " " + p).replace(/^\s+/, "");
	    }).join(",");
	  }).join(",");
	};
	
	module.exports = function(json){
	  var rules = {};
	  var var_cache = {};
	
	  var normalizeAndApplyVars = function(key){
	    return replaceVars(normalizeWhitespace(key), function(v){
	      if(!var_cache.hasOwnProperty(v)){
	        var_cache[v] = gen();
	      }
	      return var_cache[v];
	    });
	  };
	
	  var recurseRules = function(group, context, o){
	    map(o, function(val, key){
	      if(/^@/.test(key)){
	        recurseRules(keyToRule(context, normalizeAndApplyVars(key)), context, val);
	      }else if(Object.prototype.toString.call(val) === "[object Object]"){
	        recurseRules(group, keyToRule(context, normalizeAndApplyVars(key)), val);
	      }else{
	        if(!rules.hasOwnProperty(group)){
	          rules[group] = {};
	        }
	        if(!rules[group].hasOwnProperty(context)){
	          rules[group][context] = {};
	        }
	        rules[group][context][key] = normalizeAndApplyVars(val + "");
	      }
	    });
	  };
	  recurseRules("", "", json);
	
	  return {
	    css: renderRules(rules),
	    vars: var_cache
	  };
	};


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1553)("g");


/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	var i = 0;
	module.exports = function(prefix){
	  return function(){
	    i++;
	    return prefix + i.toString(36);
	  };
	};


/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	module.exports = function(key, varToCSS){
	  var path = "";
	  var buff = "";
	  var is_in_var = false;
	  var i, c;
	  for(i=0; i < key.length; i++){
	    c = key[i];
	    if(is_in_var){
	      if(/^[a-zA-Z0-9\-_]$/.test(c)){
	        buff += c;
	      }else{
	        path += varToCSS(buff);
	        is_in_var = false;
	        buff = "";
	      }
	    }
	    if(c === "$"){
	      is_in_var = true;
	      buff = "";
	    }else if(!is_in_var){
	      path += c;
	    }
	  }
	  if(is_in_var && buff.length > 0){
	    path += varToCSS(buff);
	  }
	  return path;
	};


/***/ }),
/* 1555 */
/***/ (function(module, exports) {

	var inserted = {};
	
	module.exports = function (css, options) {
	    if (inserted[css]) return;
	    inserted[css] = true;
	    
	    var elem = document.createElement('style');
	    elem.setAttribute('type', 'text/css');
	
	    if ('textContent' in elem) {
	      elem.textContent = css;
	    } else {
	      elem.styleSheet.cssText = css;
	    }
	    
	    var head = document.getElementsByTagName('head')[0];
	    if (options && options.prepend) {
	        head.insertBefore(elem, head.childNodes[0]);
	    } else {
	        head.appendChild(elem);
	    }
	};


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserAvatar = (_temp = _class = function (_Component) {
	    _inherits(UserAvatar, _Component);
	
	    function UserAvatar(props, context) {
	        _classCallCheck(this, UserAvatar);
	
	        var _this = _possibleConstructorReturn(this, (UserAvatar.__proto__ || Object.getPrototypeOf(UserAvatar)).call(this, props, context));
	
	        _this.styles = {
	            fontSize: '0.85rem',
	            borderWidth: '1px',
	            borderStyle: 'solid',
	            borderRadius: '99px',
	            width: '2rem',
	            height: '2rem'
	        };
	        return _this;
	    }
	
	    _createClass(UserAvatar, [{
	        key: 'userInitials',
	        value: function userInitials() {
	            var _props$user = this.props.user,
	                first_name = _props$user.first_name,
	                last_name = _props$user.last_name;
	
	
	            function initial(name) {
	                return typeof name !== 'undefined' && name.length ? name.substring(0, 1).toUpperCase() : '';
	            }
	
	            var initials = initial(first_name) + initial(last_name);
	
	            return initials.length ? initials : '?';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var background = this.props.background;
	
	            var classes = {
	                'flex': true,
	                'align-center': true,
	                'justify-center': true
	            };
	            classes[background] = true;
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)(classes), style: Object.assign(this.styles, this.props.style) },
	                this.userInitials()
	            );
	        }
	    }]);
	
	    return UserAvatar;
	}(_react.Component), _class.propTypes = {
	    background: _propTypes2.default.string,
	    user: _propTypes2.default.object.isRequired
	}, _class.defaultProps = {
	    background: 'bg-brand'
	}, _temp);
	UserAvatar.displayName = 'UserAvatar';
	exports.default = UserAvatar;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getContext = exports.getPath = exports.getUser = undefined;
	
	var _user = __webpack_require__(1127);
	
	Object.defineProperty(exports, 'getUser', {
	    enumerable: true,
	    get: function get() {
	        return _user.getUser;
	    }
	});
	
	var _reselect = __webpack_require__(1072);
	
	var getPath = exports.getPath = function getPath(state, props) {
	    return props.location.pathname;
	};
	
	var getContext = exports.getContext = (0, _reselect.createSelector)([getPath], function (path) {
	    return path.startsWith('/auth/') ? 'auth' : path.startsWith('/setup/') ? 'setup' : path.startsWith('/admin/') ? 'admin' : path === '/' ? 'home' : 'main';
	});

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _UndoListing = __webpack_require__(1559);
	
	var _UndoListing2 = _interopRequireDefault(_UndoListing);
	
	var _undo = __webpack_require__(1070);
	
	var _undo2 = __webpack_require__(1561);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _BodyComponent = __webpack_require__(1562);
	
	var _BodyComponent2 = _interopRequireDefault(_BodyComponent);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(924);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        undos: (0, _undo2.getUndos)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    dismissUndo: _undo.dismissUndo,
	    performUndo: _undo.performUndo
	};
	
	var UndoListing = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (0, _BodyComponent2.default)(_class = (_temp = _class2 = function (_Component) {
	    _inherits(UndoListing, _Component);
	
	    function UndoListing() {
	        _classCallCheck(this, UndoListing);
	
	        return _possibleConstructorReturn(this, (UndoListing.__proto__ || Object.getPrototypeOf(UndoListing)).apply(this, arguments));
	    }
	
	    _createClass(UndoListing, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                undos = _props.undos,
	                performUndo = _props.performUndo,
	                dismissUndo = _props.dismissUndo;
	
	            return _react2.default.createElement(
	                "ul",
	                { className: _UndoListing2.default.listing },
	                _react2.default.createElement(
	                    _reactAddonsCssTransitionGroup2.default,
	                    {
	                        transitionName: "UndoListing",
	                        transitionEnterTimeout: 300,
	                        transitionLeaveTimeout: 300
	                    },
	                    undos.map(function (undo) {
	                        return _react2.default.createElement(
	                            "li",
	                            { key: undo._domId, className: _UndoListing2.default.undo },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _UndoListing2.default.message },
	                                typeof undo.message === "function" ? undo.message(undo) : undo.message
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: _UndoListing2.default.actions },
	                                _react2.default.createElement(
	                                    "a",
	                                    { className: _UndoListing2.default.undoButton, onClick: function onClick() {
	                                            return performUndo(undo.id);
	                                        } },
	                                    "Undo"
	                                ),
	                                _react2.default.createElement(_Icon2.default, { className: _UndoListing2.default.dismissButton, name: "close", onClick: function onClick() {
	                                        return dismissUndo(undo.id);
	                                    } })
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return UndoListing;
	}(_react.Component), _class2.propTypes = {
	    undos: _propTypes2.default.array.isRequired,
	    performUndo: _propTypes2.default.func.isRequired,
	    dismissUndo: _propTypes2.default.func.isRequired
	}, _temp)) || _class) || _class);
	UndoListing.displayName = "UndoListing";
	exports.default = UndoListing;

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"listing":"_1k4_d _2Em4n _1wiTN _1gKwo _2h9Fs","undo":"_14p1j _17V2F _2z9kb _2zlem Wr_al _26OGD eTBAP _18-EI _38618 _3Dqep","actions":"yvUyo _38618 _3Dqep VW9bs","undoButton":"_318oQ _1ABq6 _3l3zl _3TD8R","dismissButton":"lsc_S _1a-AI"};

/***/ }),
/* 1560 */,
/* 1561 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getUndos = exports.getUndos = function getUndos(state, props) {
	  return state.undo;
	};

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TestBodyComponent = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (ComposedComponent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_Component) {
	        _inherits(_class, _Component);
	
	        function _class() {
	            _classCallCheck(this, _class);
	
	            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	            key: "componentWillMount",
	            value: function componentWillMount() {
	                this._element = document.createElement('div');
	                document.body.appendChild(this._element);
	            }
	        }, {
	            key: "componentDidMount",
	            value: function componentDidMount() {
	                this._render();
	            }
	        }, {
	            key: "componentDidUpdate",
	            value: function componentDidUpdate() {
	                this._render();
	            }
	        }, {
	            key: "componentWillUnmount",
	            value: function componentWillUnmount() {
	                _reactDom2.default.unmountComponentAtNode(this._element);
	                if (this._element.parentNode) {
	                    this._element.parentNode.removeChild(this._element);
	                }
	            }
	        }, {
	            key: "_render",
	            value: function _render() {
	                this._element.className = this.props.className || "";
	                _reactDom2.default.unstable_renderSubtreeIntoContainer(this, _react2.default.createElement(ComposedComponent, _extends({}, this.props, { className: undefined })), this._element);
	            }
	        }, {
	            key: "render",
	            value: function render() {
	                return null;
	            }
	        }]);
	
	        return _class;
	    }(_react.Component), _class.displayName = "BodyComponent[" + (ComposedComponent.displayName || ComposedComponent.name) + "]", _temp;
	};
	
	/**
	 * A modified version of BodyComponent HOC for Jest/Enzyme tests.
	 * Simply renders the component inline instead of mutating DOM root.
	 */
	
	
	var TestBodyComponent = exports.TestBodyComponent = function TestBodyComponent(ComposedComponent) {
	    var _class2, _temp2;
	
	    return _temp2 = _class2 = function (_Component2) {
	        _inherits(_class2, _Component2);
	
	        function _class2() {
	            _classCallCheck(this, _class2);
	
	            return _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).apply(this, arguments));
	        }
	
	        _createClass(_class2, [{
	            key: "render",
	            value: function render() {
	                return _react2.default.createElement(
	                    "div",
	                    {
	                        // because popover is normally directly attached to body element, other elements should not need
	                        // to care about clicks that happen inside the popover
	                        onClick: function onClick(e) {
	                            e.stopPropagation();
	                        }
	                    },
	                    _react2.default.createElement(ComposedComponent, _extends({}, this.props, { className: undefined }))
	                );
	            }
	        }]);
	
	        return _class2;
	    }(_react.Component), _class2.displayName = "TestBodyComponent[" + (ComposedComponent.displayName || ComposedComponent.name) + "]", _temp2;
	};

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFound = function (_Component) {
	    _inherits(NotFound, _Component);
	
	    function NotFound() {
	        _classCallCheck(this, NotFound);
	
	        return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
	    }
	
	    _createClass(NotFound, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "layout-centered flex full" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "p4 text-bold" },
	                    _react2.default.createElement(
	                        "h1",
	                        { className: "text-brand text-light mb3" },
	                        "We're a little lost..."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "h4 mb1" },
	                        "The page you asked for couldn't be found."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "h4" },
	                        "You might've been tricked by a ninja, but in all likelihood, you were just given a bad link."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "h4 my4" },
	                        "You can always:"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center" },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: Urls.question(), className: "Button Button--primary" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "p1" },
	                                "Ask a new question."
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            { className: "mx2" },
	                            "or"
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { className: "Button Button--withIcon", target: "_blank", href: "http://tv.giphy.com/kitten" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "p1 flex align-center relative" },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "h2" },
	                                    "\uD83D\uDE38"
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "ml1" },
	                                    "Take a kitten break."
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NotFound;
	}(_react.Component);
	
	NotFound.displayName = "NotFound";
	exports.default = NotFound;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Unauthorized = function (_Component) {
	    _inherits(Unauthorized, _Component);
	
	    function Unauthorized() {
	        _classCallCheck(this, Unauthorized);
	
	        return _possibleConstructorReturn(this, (Unauthorized.__proto__ || Object.getPrototypeOf(Unauthorized)).apply(this, arguments));
	    }
	
	    _createClass(Unauthorized, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "flex layout-centered flex-full flex-column text-grey-2" },
	                _react2.default.createElement(_Icon2.default, { name: "key", size: 100 }),
	                _react2.default.createElement(
	                    "h1",
	                    { className: "mt4" },
	                    "Sorry, you don\u2019t have permission to see that."
	                )
	            );
	        }
	    }]);
	
	    return Unauthorized;
	}(_react.Component);
	
	Unauthorized.displayName = "Unauthorized";
	exports.default = Unauthorized;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _Link = __webpack_require__(1567);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Archived = function Archived(_ref) {
	    var entityName = _ref.entityName,
	        linkTo = _ref.linkTo;
	    return _react2.default.createElement(
	        "div",
	        { className: "full-height flex justify-center align-center" },
	        _react2.default.createElement(_EmptyState2.default, {
	            message: _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    "This ",
	                    entityName,
	                    " has been archived"
	                ),
	                _react2.default.createElement(
	                    _Link2.default,
	                    { to: linkTo, className: "my2 link", style: { fontSize: "14px" } },
	                    "View the archive"
	                )
	            ),
	            icon: "viewArchive"
	        })
	    );
	};
	
	Archived.displayName = "Archived";
	exports.default = Archived;

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyState = function EmptyState(_ref) {
	    var title = _ref.title,
	        message = _ref.message,
	        icon = _ref.icon,
	        image = _ref.image,
	        imageHeight = _ref.imageHeight,
	        imageClassName = _ref.imageClassName,
	        action = _ref.action,
	        link = _ref.link,
	        onActionClick = _ref.onActionClick,
	        _ref$smallDescription = _ref.smallDescription,
	        smallDescription = _ref$smallDescription === undefined ? false : _ref$smallDescription;
	    return _react2.default.createElement(
	        "div",
	        { className: "text-centered text-brand-light my2", style: smallDescription ? {} : { width: "350px" } },
	        title && _react2.default.createElement(
	            "h2",
	            { className: "text-brand mb4" },
	            title
	        ),
	        icon && _react2.default.createElement(_Icon2.default, { name: icon, size: 40 }),
	        image && _react2.default.createElement("img", { src: image + ".png", width: "300px", height: imageHeight, alt: message, srcSet: image + "@2x.png 2x",
	            className: imageClassName }),
	        _react2.default.createElement(
	            "div",
	            { className: "flex justify-center" },
	            _react2.default.createElement(
	                "h2",
	                { className: (0, _classnames2.default)("text-grey-2 text-normal mt2 mb4", { "text-paragraph": smallDescription }),
	                    style: { lineHeight: "1.5em" } },
	                message
	            )
	        ),
	        action && link && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: link, className: "Button Button--primary mt4",
	                target: link.startsWith('http') ? "_blank" : "" },
	            action
	        ),
	        action && onActionClick && _react2.default.createElement(
	            "a",
	            { onClick: onActionClick, className: "Button Button--primary mt4" },
	            action
	        )
	    );
	};
	/*
	 * EmptyState is a component that can
	 *  1) introduce a new section of Metabase to a user and encourage the user to take an action
	 *  2) indicate an empty result after a user-triggered search/query
	 */
	
	EmptyState.displayName = "EmptyState";
	exports.default = EmptyState;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Link = function Link(_ref) {
	    var to = _ref.to,
	        className = _ref.className,
	        children = _ref.children,
	        props = _objectWithoutProperties(_ref, ["to", "className", "children"]);
	
	    return _react2.default.createElement(
	        _reactRouter.Link,
	        _extends({
	            to: to,
	            className: className || "link"
	        }, props),
	        children
	    );
	};
	
	Link.displayName = "Link";
	exports.default = Link;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AuthScene = __webpack_require__(1569);
	
	var _AuthScene2 = _interopRequireDefault(_AuthScene);
	
	var _BackToLogin = __webpack_require__(1570);
	
	var _BackToLogin2 = _interopRequireDefault(_BackToLogin);
	
	var _FormField = __webpack_require__(1571);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormLabel = __webpack_require__(1572);
	
	var _FormLabel2 = _interopRequireDefault(_FormLabel);
	
	var _FormMessage = __webpack_require__(1573);
	
	var _FormMessage2 = _interopRequireDefault(_FormMessage);
	
	var _LogoIcon = __webpack_require__(1205);
	
	var _LogoIcon2 = _interopRequireDefault(_LogoIcon);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgotPasswordApp = function (_Component) {
	    _inherits(ForgotPasswordApp, _Component);
	
	    function ForgotPasswordApp(props, context) {
	        _classCallCheck(this, ForgotPasswordApp);
	
	        var _this = _possibleConstructorReturn(this, (ForgotPasswordApp.__proto__ || Object.getPrototypeOf(ForgotPasswordApp)).call(this, props, context));
	
	        _this.state = {
	            email: props.location.query.email || null,
	            sentNotification: false,
	            error: null
	        };
	        return _this;
	    }
	
	    _createClass(ForgotPasswordApp, [{
	        key: "sendResetNotification",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(e) {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                e.preventDefault();
	
	                                if (_underscore2.default.isEmpty(this.state.email)) {
	                                    _context.next = 11;
	                                    break;
	                                }
	
	                                _context.prev = 2;
	                                _context.next = 5;
	                                return _services.SessionApi.forgot_password({ "email": this.state.email });
	
	                            case 5:
	                                this.setState({ sentNotification: true, error: null });
	                                _context.next = 11;
	                                break;
	
	                            case 8:
	                                _context.prev = 8;
	                                _context.t0 = _context["catch"](2);
	
	                                this.setState({ error: _context.t0 });
	
	                            case 11:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[2, 8]]);
	            }));
	
	            function sendResetNotification(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return sendResetNotification;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                sentNotification = _state.sentNotification,
	                error = _state.error;
	
	            var valid = !_underscore2.default.isEmpty(this.state.email);
	            var emailConfigured = _settings2.default.isEmailConfigured();
	
	            return _react2.default.createElement(
	                "div",
	                { className: "full-height bg-white flex flex-column flex-full md-layout-centered" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "Login-wrapper wrapper Grid Grid--full md-Grid--1of2" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Grid-cell flex layout-centered text-brand" },
	                        _react2.default.createElement(_LogoIcon2.default, { className: "Logo my4 sm-my0", width: 66, height: 85 })
	                    ),
	                    !emailConfigured ? _react2.default.createElement(
	                        "div",
	                        { className: "Grid-cell" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "text-centered bordered rounded shadowed p4" },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "my4" },
	                                "Please contact an administrator to have them reset your password"
	                            ),
	                            _react2.default.createElement(_BackToLogin2.default, null)
	                        )
	                    ) : _react2.default.createElement(
	                        "div",
	                        { className: "Grid-cell" },
	                        !sentNotification ? _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "form",
	                                { className: "ForgotForm bg-white Form-new bordered rounded shadowed", name: "form", noValidate: true },
	                                _react2.default.createElement(
	                                    "h3",
	                                    { className: "Login-header Form-offset mb3" },
	                                    "Forgot password"
	                                ),
	                                _react2.default.createElement(_FormMessage2.default, { message: error && error.data && error.data.message }),
	                                _react2.default.createElement(
	                                    _FormField2.default,
	                                    { key: "email", fieldName: "email", formError: error },
	                                    _react2.default.createElement(_FormLabel2.default, { title: "Email address", fieldName: "email", formError: error }),
	                                    _react2.default.createElement("input", { className: "Form-input Form-offset full", name: "email", placeholder: "The email you use for your Metabase account", type: "text", onChange: function onChange(e) {
	                                            return _this2.setState({ "email": e.target.value });
	                                        }, defaultValue: this.state.email, autoFocus: true }),
	                                    _react2.default.createElement("span", { className: "Form-charm" })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "Form-actions" },
	                                    _react2.default.createElement(
	                                        "button",
	                                        { className: (0, _classnames2.default)("Button", { "Button--primary": valid }), onClick: function onClick(e) {
	                                                return _this2.sendResetNotification(e);
	                                            }, disabled: !valid },
	                                        "Send password reset email"
	                                    )
	                                )
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "div",
	                                { className: "SuccessGroup bg-white bordered rounded shadowed" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "SuccessMark" },
	                                    _react2.default.createElement(_Icon2.default, { name: "check" })
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    { className: "SuccessText" },
	                                    "Check your email for instructions on how to reset your password."
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_AuthScene2.default, null)
	            );
	        }
	    }]);
	
	    return ForgotPasswordApp;
	}(_react.Component);
	
	ForgotPasswordApp.displayName = "ForgotPasswordApp";
	exports.default = ForgotPasswordApp;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AuthScene = function (_Component) {
	    _inherits(AuthScene, _Component);
	
	    function AuthScene() {
	        _classCallCheck(this, AuthScene);
	
	        return _possibleConstructorReturn(this, (AuthScene.__proto__ || Object.getPrototypeOf(AuthScene)).apply(this, arguments));
	    }
	
	    _createClass(AuthScene, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            // HACK: React 0.14 doesn't support "fill-rule" attribute. We can remove this when upgrading to React 0.15.
	            _reactDom2.default.findDOMNode(this.refs.HACK_fill_rule_1).setAttribute("fill-rule", "evenodd");
	            _reactDom2.default.findDOMNode(this.refs.HACK_fill_rule_2).setAttribute("fill-rule", "evenodd");
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "section",
	                { className: "z1 brand-scene absolute bottom left right hide sm-show" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "brand-boat-container" },
	                    _react2.default.createElement(
	                        "svg",
	                        { className: "brand-boat", width: "27px", height: "28px", viewBox: "0 0 27 28" },
	                        _react2.default.createElement(
	                            "g",
	                            { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", ref: "HACK_fill_rule_1" },
	                            _react2.default.createElement(
	                                "g",
	                                { transform: "translate(-52.000000, -49.000000)", fill: "#fff" },
	                                _react2.default.createElement("path", { d: "M56.9966734,62.0821591 C56.9548869,62.5960122 56.5246217,63 56,63 C55.4477153,63 55,62.5522847 55,62 C55,61.4477153 55.4477153,61 56,61 C56.1542427,61 56.3003292,61.0349209 56.4307846,61.0972878 C56.4365546,60.9708421 56.4672874,60.8469847 56.5249064,60.738086 L60.591292,53.0527085 C60.6128147,53.0120312 60.6340855,52.9741034 60.6550548,52.9389125 C60.2727349,52.7984089 60,52.4310548 60,52 C60,51.4477153 60.4477153,51 61,51 C61.5522847,51 62,51.4477153 62,52 C62,52.4778316 61.6648606,52.8773872 61.2168176,52.9764309 C61.2239494,53.0443316 61.2276783,53.1212219 61.2276783,53.2070193 L61.2276783,64.6460667 C61.2276783,64.7905295 61.2109404,64.9142428 61.1799392,65.0161455 C61.6463447,65.1008929 62,65.5091461 62,66 C62,66.5522847 61.5522847,67 61,67 C60.4477153,67 60,66.5522847 60,66 C60,65.6775356 60.1526298,65.3907197 60.3895873,65.2078547 C60.3353792,65.1698515 60.2797019,65.1246206 60.2229246,65.0720038 L56.9966734,62.0821591 Z M66.1768361,51.0536808 L76.3863147,62.9621534 C76.6248381,62.7575589 76.9348843,62.6339439 77.2738087,62.6339439 C78.0269541,62.6339439 78.6374991,63.2443563 78.6374991,63.9973383 C78.6374991,64.7503202 78.0269541,65.3607327 77.2738087,65.3607327 C76.7179077,65.3607327 76.2396954,65.0281798 76.0273418,64.5512033 L76.0273418,64.5512033 L66.2470617,68.8970508 L66.2470617,68.8970508 C66.3224088,69.0662913 66.3642852,69.2537142 66.3642852,69.4509158 C66.3642852,70.2038977 65.7537402,70.8143102 65.0005948,70.8143102 C64.2474494,70.8143102 63.6369043,70.2038977 63.6369043,69.4509158 C63.6369043,68.6979339 64.2474494,68.0875214 65.0005948,68.0875214 L65.0005948,51.7267888 C64.2474494,51.7267888 63.6369043,51.1163763 63.6369043,50.3633944 C63.6369043,49.6104125 64.2474494,49 65.0005948,49 C65.7537402,49 66.3642852,49.6104125 66.3642852,50.3633944 C66.3642852,50.6152816 66.2959632,50.8512148 66.1768361,51.0536808 L66.1768361,51.0536808 Z M74.9589487,72 C76.0592735,72 76.2934239,72.6072543 75.4783436,73.3596586 L73.4702868,75.2133052 C72.656816,75.9642239 71.1011127,76.5729638 69.999426,76.5729638 L57.9641665,76.5729638 C56.8607339,76.5729638 55.3083859,75.9657095 54.4933056,75.2133052 L52.4852488,73.3596586 C51.6717779,72.6087399 51.9052063,72 53.0046438,72 L74.9589487,72 Z", id: "boat" })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "brand-illustration" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "brand-mountain-1" },
	                        _react2.default.createElement(
	                            "svg",
	                            { width: "514px", height: "175px", viewBox: "0 0 514 175", version: "1.1" },
	                            _react2.default.createElement("path", { fill: "#fff", d: "M41.5,45 L78,33 L78,74.5 L2.5,92 L41.5,45 Z", id: "Path", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M77.5,32.5 L143,45.5 L76.5,75.5 L77.5,32.5 Z", id: "Path-Copy-8", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M1.5,91 L78,73.5 L87,119.5 L41.5,149 L1.5,91 Z", id: "Path-Copy", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M77.5000001,74.5 L143,44 L174,46 L86.0000001,119.5 L77.5000001,74.5 Z", id: "Path-Copy-7", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M142.5,45 L205,25.5 L229,39.5 L173.5,47.5 L142.5,45 Z", id: "Path-Copy-9", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M158.499999,99 L225.499999,80.5 L270.999999,87.5 L226.999999,125 L158.499999,99 Z", id: "Path-Copy-3", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M156.499999,101.5 L172.999999,47 L226.499999,39 L226.499999,81 L156.499999,101.5 Z", id: "Path-Copy-11", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M243.000001,88.5 L225.5,43.5 L288,39 L288,81.5 L243.000001,88.5 Z", id: "Path-Copy-12", stroke: "#B6CCE5", transform: "translate(256.750000, 63.750000) scale(-1, 1) translate(-256.750000, -63.750000) " }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M286.5,44.5 L342.5,64 L319.5,110.5 L270,86.5 L286.5,44.5 Z", id: "Path-Copy-4", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M341.5,64 L390.5,111 L396.5,155 L317,109 L341.5,64 Z", id: "Path-Copy-10", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M389,111 L505,149 L396,154 L389,111 Z", id: "Path-Copy-13", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M321,110 L397,154 L282,149 L321,110 Z", id: "Path-Copy-14", stroke: "#4A90E2" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M247.5,20.5 L287,44.5 L226.5,40 L247.5,20.5 Z", id: "Path-Copy-5", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M221.999999,13 L248.499999,20.5 L227.499999,40 L203.999999,26 L221.999999,13 Z", id: "Path-Copy-6", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M228.499999,126.000001 L284.000003,148.499999 L224.500001,171.000001 L158.500001,148.499999 L228.499999,126.000001 Z", id: "fg-geometry", stroke: "#4A90E2" }),
	                            _react2.default.createElement("polygon", { fill: "#fff", id: "Path", stroke: "#4A90E2", points: "158.5 99 159.5 149 42 149 " }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M271.000001,86.0000002 L321.5,110.5 L283,149.5 L225,125.5 L271.000001,86.0000002 Z", id: "Path-Copy-3", stroke: "#4A90E2" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M42.2061,154.838108 C45.4069681,154.838108 48.0017844,152.243855 48.0017844,149.043682 C48.0017844,145.843509 45.4069681,143.249256 42.2061,143.249256 C39.0052319,143.249256 36.4104157,145.843509 36.4104157,149.043682 C36.4104157,152.243855 39.0052319,154.838108 42.2061,154.838108 Z M159.483477,154.838108 C162.684345,154.838108 165.279162,152.243855 165.279162,149.043682 C165.279162,145.843509 162.684345,143.249256 159.483477,143.249256 C156.282609,143.249256 153.687793,145.843509 153.687793,149.043682 C153.687793,152.243855 156.282609,154.838108 159.483477,154.838108 Z M282.215617,154.838108 C285.416485,154.838108 288.011301,152.243855 288.011301,149.043682 C288.011301,145.843509 285.416485,143.249256 282.215617,143.249256 C279.014748,143.249256 276.419932,145.843509 276.419932,149.043682 C276.419932,152.243855 279.014748,154.838108 282.215617,154.838108 Z M505.860848,154.156411 C509.061716,154.156411 511.656532,151.562158 511.656532,148.361985 C511.656532,145.161811 509.061716,142.567558 505.860848,142.567558 C502.65998,142.567558 500.065164,145.161811 500.065164,148.361985 C500.065164,151.562158 502.65998,154.156411 505.860848,154.156411 Z M396.083768,159.950837 C399.284636,159.950837 401.879452,157.356584 401.879452,154.156411 C401.879452,150.956238 399.284636,148.361985 396.083768,148.361985 C392.8829,148.361985 390.288084,150.956238 390.288084,154.156411 C390.288084,157.356584 392.8829,159.950837 396.083768,159.950837 Z M319.717104,115.981368 C322.917972,115.981368 325.512788,113.387115 325.512788,110.186942 C325.512788,106.986769 322.917972,104.392516 319.717104,104.392516 C316.516235,104.392516 313.921419,106.986769 313.921419,110.186942 C313.921419,113.387115 316.516235,115.981368 319.717104,115.981368 Z M270.624248,92.8036633 C273.825116,92.8036633 276.419932,90.2094103 276.419932,87.0092371 C276.419932,83.8090639 273.825116,81.214811 270.624248,81.214811 C267.42338,81.214811 264.828563,83.8090639 264.828563,87.0092371 C264.828563,90.2094103 267.42338,92.8036633 270.624248,92.8036633 Z M229.03169,131.660403 C232.232558,131.660403 234.827374,129.06615 234.827374,125.865977 C234.827374,122.665804 232.232558,120.071551 229.03169,120.071551 C225.830822,120.071551 223.236005,122.665804 223.236005,125.865977 C223.236005,129.06615 225.830822,131.660403 229.03169,131.660403 Z M158.119787,104.392516 C161.320655,104.392516 163.915471,101.798263 163.915471,98.5980894 C163.915471,95.3979162 161.320655,92.8036633 158.119787,92.8036633 C154.918919,92.8036633 152.324103,95.3979162 152.324103,98.5980894 C152.324103,101.798263 154.918919,104.392516 158.119787,104.392516 Z M224.940618,173.925629 C228.141486,173.925629 230.736303,171.331376 230.736303,168.131203 C230.736303,164.93103 228.141486,162.336777 224.940618,162.336777 C221.73975,162.336777 219.144934,164.93103 219.144934,168.131203 C219.144934,171.331376 221.73975,173.925629 224.940618,173.925629 Z", id: "fg-points", stroke: "#4A90E2" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M78.0029739,76.4429306 C79.5092648,76.4429306 80.7303548,75.2221057 80.7303548,73.7161419 C80.7303548,72.210178 79.5092648,70.9893531 78.0029739,70.9893531 C76.4966831,70.9893531 75.275593,72.210178 75.275593,73.7161419 C75.275593,75.2221057 76.4966831,76.4429306 78.0029739,76.4429306 Z M3,94.4779116 C4.50629086,94.4779116 5.72738087,93.2570867 5.72738087,91.7511228 C5.72738087,90.245159 4.50629086,89.024334 3,89.024334 C1.49370914,89.024334 0.27261913,90.245159 0.27261913,91.7511228 C0.27261913,93.2570867 1.49370914,94.4779116 3,94.4779116 Z M42.5470226,48.167594 C44.0533135,48.167594 45.2744035,46.9467691 45.2744035,45.4408052 C45.2744035,43.9348413 44.0533135,42.7140164 42.5470226,42.7140164 C41.0407318,42.7140164 39.8196417,43.9348413 39.8196417,45.4408052 C39.8196417,46.9467691 41.0407318,48.167594 42.5470226,48.167594 Z M78.0029739,35.541099 C79.5092648,35.541099 80.7303548,34.3202741 80.7303548,32.8143102 C80.7303548,31.3083464 79.5092648,30.0875214 78.0029739,30.0875214 C76.4966831,30.0875214 75.275593,31.3083464 75.275593,32.8143102 C75.275593,34.3202741 76.4966831,35.541099 78.0029739,35.541099 Z M142.77827,47.1299513 C144.28456,47.1299513 145.50565,45.9091264 145.50565,44.4031625 C145.50565,42.8971987 144.28456,41.6763737 142.77827,41.6763737 C141.271979,41.6763737 140.050889,42.8971987 140.050889,44.4031625 C140.050889,45.9091264 141.271979,47.1299513 142.77827,47.1299513 Z M86.8669617,122.116643 C88.3732526,122.116643 89.5943426,120.895818 89.5943426,119.389854 C89.5943426,117.88389 88.3732526,116.663065 86.8669617,116.663065 C85.3606709,116.663065 84.1395809,117.88389 84.1395809,119.389854 C84.1395809,120.895818 85.3606709,122.116643 86.8669617,122.116643 Z M246.418743,23.2705495 C247.925033,23.2705495 249.146123,22.0497246 249.146123,20.5437607 C249.146123,19.0377969 247.925033,17.8169719 246.418743,17.8169719 C244.912452,17.8169719 243.691362,19.0377969 243.691362,20.5437607 C243.691362,22.0497246 244.912452,23.2705495 246.418743,23.2705495 Z M173.461304,49.8567401 C174.967595,49.8567401 176.188685,48.6359151 176.188685,47.1299513 C176.188685,45.6239874 174.967595,44.4031625 173.461304,44.4031625 C171.955013,44.4031625 170.733923,45.6239874 170.733923,47.1299513 C170.733923,48.6359151 171.955013,49.8567401 173.461304,49.8567401 Z M204.144339,28.0424299 C205.65063,28.0424299 206.87172,26.8216049 206.87172,25.3156411 C206.87172,23.8096772 205.65063,22.5888523 204.144339,22.5888523 C202.638048,22.5888523 201.416958,23.8096772 201.416958,25.3156411 C201.416958,26.8216049 202.638048,28.0424299 204.144339,28.0424299 Z M225.963386,83.2599026 C227.469677,83.2599026 228.690767,82.0390776 228.690767,80.5331138 C228.690767,79.0271499 227.469677,77.806325 225.963386,77.806325 C224.457095,77.806325 223.236005,79.0271499 223.236005,80.5331138 C223.236005,82.0390776 224.457095,83.2599026 225.963386,83.2599026 Z M225.963386,41.6763737 C227.469677,41.6763737 228.690767,40.4555488 228.690767,38.949585 C228.690767,37.4436211 227.469677,36.2227962 225.963386,36.2227962 C224.457095,36.2227962 223.236005,37.4436211 223.236005,38.949585 C223.236005,40.4555488 224.457095,41.6763737 225.963386,41.6763737 Z M390.288084,113.254579 C391.794374,113.254579 393.015464,112.033754 393.015464,110.52779 C393.015464,109.021826 391.794374,107.801002 390.288084,107.801002 C388.781793,107.801002 387.560703,109.021826 387.560703,110.52779 C387.560703,112.033754 388.781793,113.254579 390.288084,113.254579 Z M342.558918,66.8991699 C344.065209,66.8991699 345.286299,65.678345 345.286299,64.1723811 C345.286299,62.6664173 344.065209,61.4455924 342.558918,61.4455924 C341.052627,61.4455924 339.831537,62.6664173 339.831537,64.1723811 C339.831537,65.678345 341.052627,66.8991699 342.558918,66.8991699 Z M286.64761,47.1299513 C288.153901,47.1299513 289.374991,45.9091264 289.374991,44.4031625 C289.374991,42.8971987 288.153901,41.6763737 286.64761,41.6763737 C285.14132,41.6763737 283.92023,42.8971987 283.92023,44.4031625 C283.92023,45.9091264 285.14132,47.1299513 286.64761,47.1299513 Z M221.872315,16.4535776 C223.378606,16.4535776 224.599696,15.2327526 224.599696,13.7267888 C224.599696,12.2208249 223.378606,11 221.872315,11 C220.366024,11 219.144934,12.2208249 219.144934,13.7267888 C219.144934,15.2327526 220.366024,16.4535776 221.872315,16.4535776 Z", id: "bg-points", stroke: "#B6CCE6" })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "brand-bridge" },
	                        _react2.default.createElement(
	                            "svg",
	                            { width: "683px", height: "154px", viewBox: "0 0 683 154", version: "1.1" },
	                            _react2.default.createElement(
	                                "g",
	                                { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", ref: "HACK_fill_rule_2" },
	                                _react2.default.createElement(
	                                    "g",
	                                    { id: "Artboard-1" },
	                                    _react2.default.createElement("path", { d: "M193,69.49194 L193,48.696628 L193,48.696628 C193.437006,48.5974065 193.825695,48.3709078 194.125079,48.0581427 L197.242752,49.9287465 C197.479542,50.0708205 197.786672,49.994038 197.928746,49.7572479 C198.070821,49.5204577 197.994038,49.2133276 197.757248,49.0712535 L194.639252,47.2004558 C194.711048,46.9803849 194.749866,46.7453991 194.749866,46.5013419 C194.749866,45.4300479 194.00192,44.5335399 193,44.3060559 L193,23.4611785 L193,23.4611785 C193.70858,23.3422265 194.332923,22.9747274 194.780416,22.4513446 L197.242752,23.9287465 C197.479542,24.0708205 197.786672,23.994038 197.928746,23.7572479 C198.070821,23.5204577 197.994038,23.2133276 197.757248,23.0712535 L195.294823,21.5937988 C195.427115,21.2552485 195.499732,20.88678 195.499732,20.5013419 C195.499732,18.8437465 194.156706,17.5 192.5,17.5 C190.843294,17.5 189.500268,18.8437465 189.500268,20.5013419 C189.500268,21.1091075 189.680819,21.6746805 189.991183,22.1472957 L165.767183,44.64101 L165.767183,44.64101 C165.406294,44.3944476 164.969976,44.2502684 164.5,44.2502684 C163.257433,44.2502684 162.250134,45.2581083 162.250134,46.5013419 C162.250134,46.9292933 162.369489,47.3293527 162.576711,47.6700143 L138.72545,69.6131742 C138.372873,69.383631 137.952003,69.2502684 137.5,69.2502684 C136.257433,69.2502684 135.250134,70.2581083 135.250134,71.5013419 C135.250134,71.5912406 135.255401,71.6799086 135.265643,71.7670536 L111.39825,80.2911227 C110.99879,79.6645016 110.2979,79.2489265 109.5,79.2489265 C108.429185,79.2489265 107.533094,79.9974077 107.305831,81 L89.6941692,81 C89.4669062,79.9974077 88.5708148,79.2489265 87.5,79.2489265 C86.4291852,79.2489265 85.5330938,79.9974077 85.3058308,81 L60.6941692,81 L60.6941692,81 C60.4669062,79.9974077 59.5708148,79.2489265 58.5,79.2489265 C57.4291852,79.2489265 56.5330938,79.9974077 56.3058308,81 L30.6941692,81 C30.4669062,79.9974077 29.5708148,79.2489265 28.5,79.2489265 C27.4291852,79.2489265 26.5330938,79.9974077 26.3058308,81 L-9,81 L-9,82 L26.3058308,82 C26.5330938,83.0025923 27.4291852,83.7510735 28.5,83.7510735 C29.5708148,83.7510735 30.4669062,83.0025923 30.6941692,82 L30.6941692,82 L56.3058308,82 C56.5330938,83.0025923 57.4291852,83.7510735 58.5,83.7510735 C59.5708148,83.7510735 60.4669062,83.0025923 60.6941692,82 L85.3058308,82 C85.5330938,83.0025923 86.4291852,83.7510735 87.5,83.7510735 C88.5708148,83.7510735 89.4669062,83.0025923 89.6941692,82 L89.6941692,82 L107.305831,82 C107.496622,82.8416934 108.158796,83.5042922 109,83.6952861 L109,83.6952861 L109,91.3060559 C108.159243,91.4969482 107.497326,92.1589443 107.306135,93 L89.6941692,93 L89.6941692,93 C89.4669062,91.9974077 88.5708148,91.2489265 87.5,91.2489265 C86.4291852,91.2489265 85.5330938,91.9974077 85.3058308,93 L60.6941692,93 C60.4669062,91.9974077 59.5708148,91.2489265 58.5,91.2489265 C57.4291852,91.2489265 56.5330938,91.9974077 56.3058308,93 L30.6941692,93 C30.4669062,91.9974077 29.5708148,91.2489265 28.5,91.2489265 C27.4291852,91.2489265 26.5330938,91.9974077 26.3058308,93 L-9,93 L-9,94 L26.3058308,94 C26.5330938,95.0025923 27.4291852,95.7510735 28.5,95.7510735 C29.5708148,95.7510735 30.4669062,95.0025923 30.6941692,94 L56.3058308,94 C56.5330938,95.0025923 57.4291852,95.7510735 58.5,95.7510735 C59.5708148,95.7510735 60.4669062,95.0025923 60.6941692,94 L60.6941692,94 L85.3058308,94 C85.5330938,95.0025923 86.4291852,95.7510735 87.5,95.7510735 C88.5708148,95.7510735 89.4669062,95.0025923 89.6941692,94 L107.305527,94 C107.495918,94.842331 108.158349,95.5055326 109,95.696628 L109,144 L110,144 L110,95.696628 C110.841651,95.5055326 111.504082,94.842331 111.694473,94 L135.305527,94 C135.532294,95.0032662 136.428708,95.7524154 137.5,95.7524154 C138.571292,95.7524154 139.467706,95.0032662 139.694473,94 L162.305527,94 C162.532294,95.0032662 163.428708,95.7524154 164.5,95.7524154 C165.571292,95.7524154 166.467706,95.0032662 166.694473,94 L190.305527,94 C190.495918,94.842331 191.158349,95.5055326 192,95.696628 L192,143 L193,143 L193,95.696628 C193.841651,95.5055326 194.504082,94.842331 194.694473,94 L200,94 L200,93 L194.693865,93 C194.502674,92.1589443 193.840757,91.4969482 193,91.3060559 L193,91.3060559 L193,71.50806 C192.84938,71.5829117 192.679605,71.625 192.5,71.625 C192.320395,71.625 192.15062,71.5829117 192,71.50806 L192,91.3060559 C191.159243,91.4969482 190.497326,92.1589443 190.306135,93 L190.306135,93 L166.693865,93 L166.693865,93 C166.502674,92.1589443 165.840757,91.4969482 165,91.3060559 L165,48.696628 C166.00192,48.4691439 166.749866,47.5726359 166.749866,46.5013419 C166.749866,46.0904765 166.639851,45.7053203 166.447687,45.3737543 L166.447687,45.3737543 L190.671139,22.8805483 L190.671139,22.8805483 C191.052092,23.1741316 191.505536,23.378171 192,23.4611785 L192,44.3060559 L192,44.3060559 C190.99808,44.5335399 190.250134,45.4300479 190.250134,46.5013419 C190.250134,47.5726359 190.99808,48.4691439 192,48.696628 L192,69.49194 C192.15062,69.4170883 192.320395,69.375 192.5,69.375 C192.679605,69.375 192.84938,69.4170883 193,69.49194 L193,69.49194 Z M193.621469,70.5897864 L197.757248,73.0712535 C197.994038,73.2133276 198.070821,73.5204577 197.928746,73.7572479 C197.786672,73.994038 197.479542,74.0708205 197.242752,73.9287465 L193.10705,71.4473254 C193.394921,71.2624741 193.593026,70.9499958 193.621469,70.5897864 L193.621469,70.5897864 Z M110,83.6952861 L110,91.3060559 C110.840757,91.4969482 111.502674,92.1589443 111.693865,93 L111.693865,93 L135.306135,93 C135.497326,92.1589443 136.159243,91.4969482 137,91.3060559 L137,73.696628 L137,73.696628 C136.41374,73.5635187 135.914437,73.2013459 135.601054,72.709126 L111.734205,81.2330006 C111.744547,81.3205598 111.749866,81.4096584 111.749866,81.5 C111.749866,82.571294 111.00192,83.467802 110,83.6952861 L110,83.6952861 Z M164,48.696628 L164,91.3060559 L164,91.3060559 C163.159243,91.4969482 162.497326,92.1589443 162.306135,93 L139.693865,93 C139.502674,92.1589443 138.840757,91.4969482 138,91.3060559 L138,73.696628 L138,73.696628 C139.00192,73.4691439 139.749866,72.5726359 139.749866,71.5013419 C139.749866,71.07267 139.630108,70.671984 139.422242,70.3309493 L163.272842,48.3883968 C162.990559,48.2042543 162.752146,47.9584208 162.576711,47.6700143 L164,48.696628 Z M137.5,94.625 C138.12132,94.625 138.625,94.1213203 138.625,93.5 C138.625,92.8786797 138.12132,92.375 137.5,92.375 C136.87868,92.375 136.375,92.8786797 136.375,93.5 C136.375,94.1213203 136.87868,94.625 137.5,94.625 Z M164.5,94.625 C165.12132,94.625 165.625,94.1213203 165.625,93.5 C165.625,92.8786797 165.12132,92.375 164.5,92.375 C163.87868,92.375 163.375,92.8786797 163.375,93.5 C163.375,94.1213203 163.87868,94.625 164.5,94.625 Z M109.5,94.625 C110.12132,94.625 110.625,94.1213203 110.625,93.5 C110.625,92.8786797 110.12132,92.375 109.5,92.375 C108.87868,92.375 108.375,92.8786797 108.375,93.5 C108.375,94.1213203 108.87868,94.625 109.5,94.625 Z M137.5,72.625 C138.12132,72.625 138.625,72.1213203 138.625,71.5 C138.625,70.8786797 138.12132,70.375 137.5,70.375 C136.87868,70.375 136.375,70.8786797 136.375,71.5 C136.375,72.1213203 136.87868,72.625 137.5,72.625 Z M164.5,47.625 C165.12132,47.625 165.625,47.1213203 165.625,46.5 C165.625,45.8786797 165.12132,45.375 164.5,45.375 C163.87868,45.375 163.375,45.8786797 163.375,46.5 C163.375,47.1213203 163.87868,47.625 164.5,47.625 Z M109.5,82.6236581 C110.12132,82.6236581 110.625,82.1199784 110.625,81.4986581 C110.625,80.8773377 110.12132,80.3736581 109.5,80.3736581 C108.87868,80.3736581 108.375,80.8773377 108.375,81.4986581 C108.375,82.1199784 108.87868,82.6236581 109.5,82.6236581 Z M87.5,82.6236581 C88.1213203,82.6236581 88.625,82.1199784 88.625,81.4986581 C88.625,80.8773377 88.1213203,80.3736581 87.5,80.3736581 C86.8786797,80.3736581 86.375,80.8773377 86.375,81.4986581 C86.375,82.1199784 86.8786797,82.6236581 87.5,82.6236581 Z M87.5,94.6236581 C88.1213203,94.6236581 88.625,94.1199784 88.625,93.4986581 C88.625,92.8773377 88.1213203,92.3736581 87.5,92.3736581 C86.8786797,92.3736581 86.375,92.8773377 86.375,93.4986581 C86.375,94.1199784 86.8786797,94.6236581 87.5,94.6236581 Z M58.5,94.6236581 C59.1213203,94.6236581 59.625,94.1199784 59.625,93.4986581 C59.625,92.8773377 59.1213203,92.3736581 58.5,92.3736581 C57.8786797,92.3736581 57.375,92.8773377 57.375,93.4986581 C57.375,94.1199784 57.8786797,94.6236581 58.5,94.6236581 Z M58.5,82.6236581 C59.1213203,82.6236581 59.625,82.1199784 59.625,81.4986581 C59.625,80.8773377 59.1213203,80.3736581 58.5,80.3736581 C57.8786797,80.3736581 57.375,80.8773377 57.375,81.4986581 C57.375,82.1199784 57.8786797,82.6236581 58.5,82.6236581 Z M28.5,82.6236581 C29.1213203,82.6236581 29.625,82.1199784 29.625,81.4986581 C29.625,80.8773377 29.1213203,80.3736581 28.5,80.3736581 C27.8786797,80.3736581 27.375,80.8773377 27.375,81.4986581 C27.375,82.1199784 27.8786797,82.6236581 28.5,82.6236581 Z M28.5,94.6236581 C29.1213203,94.6236581 29.625,94.1199784 29.625,93.4986581 C29.625,92.8773377 29.1213203,92.3736581 28.5,92.3736581 C27.8786797,92.3736581 27.375,92.8773377 27.375,93.4986581 C27.375,94.1199784 27.8786797,94.6236581 28.5,94.6236581 Z M192.5,47.625 C193.12132,47.625 193.625,47.1213203 193.625,46.5 C193.625,45.8786797 193.12132,45.375 192.5,45.375 C191.87868,45.375 191.375,45.8786797 191.375,46.5 C191.375,47.1213203 191.87868,47.625 192.5,47.625 Z M192.5,22 C193.328427,22 194,21.3284271 194,20.5 C194,19.6715729 193.328427,19 192.5,19 C191.671573,19 191,19.6715729 191,20.5 C191,21.3284271 191.671573,22 192.5,22 Z M192.5,94.625 C193.12132,94.625 193.625,94.1213203 193.625,93.5 C193.625,92.8786797 193.12132,92.375 192.5,92.375 C191.87868,92.375 191.375,92.8786797 191.375,93.5 C191.375,94.1213203 191.87868,94.625 192.5,94.625 Z", id: "Rectangle-5", fill: "#F55C23" }),
	                                    _react2.default.createElement("path", { d: "M362.999924,69.49194 L362.999924,48.696628 L362.999924,48.696628 C363.436931,48.5974065 363.82562,48.3709078 364.125004,48.0581427 L367.242677,49.9287465 C367.479467,50.0708205 367.786597,49.994038 367.928671,49.7572479 C368.070745,49.5204577 367.993962,49.2133276 367.757172,49.0712535 L364.639176,47.2004558 C364.710972,46.9803849 364.74979,46.7453991 364.74979,46.5013419 C364.74979,45.4300479 364.001844,44.5335399 362.999924,44.3060559 L362.999924,23.4611785 L362.999924,23.4611785 C363.708504,23.3422265 364.332848,22.9747274 364.78034,22.4513446 L367.242677,23.9287465 C367.479467,24.0708205 367.786597,23.994038 367.928671,23.7572479 C368.070745,23.5204577 367.993962,23.2133276 367.757172,23.0712535 L365.294748,21.5937988 C365.427039,21.2552485 365.499656,20.88678 365.499656,20.5013419 C365.499656,18.8437465 364.156631,17.5 362.499924,17.5 C360.843218,17.5 359.500193,18.8437465 359.500193,20.5013419 C359.500193,21.1091075 359.680743,21.6746805 359.991107,22.1472957 L335.767107,44.64101 L335.767107,44.64101 C335.406219,44.3944476 334.9699,44.2502684 334.499924,44.2502684 C333.257358,44.2502684 332.250059,45.2581083 332.250059,46.5013419 C332.250059,46.9292933 332.369414,47.3293527 332.576636,47.6700143 L308.725375,69.6131742 C308.372798,69.383631 307.951927,69.2502684 307.499924,69.2502684 C306.257358,69.2502684 305.250059,70.2581083 305.250059,71.5013419 C305.250059,71.5912406 305.255326,71.6799086 305.265568,71.7670536 L281.398174,80.2911227 C280.998715,79.6645016 280.297825,79.2489265 279.499924,79.2489265 C278.42911,79.2489265 277.533018,79.9974077 277.305755,81 L251.694094,81 C251.466831,79.9974077 250.570739,79.2489265 249.499924,79.2489265 C248.42911,79.2489265 247.533018,79.9974077 247.305755,81 L228.694094,81 L228.694094,81 C228.466831,79.9974077 227.570739,79.2489265 226.499924,79.2489265 C225.42911,79.2489265 224.533018,79.9974077 224.305755,81 L196.999924,81 L196.999924,82 L224.305755,82 C224.496546,82.8416934 225.158721,83.5042922 225.999924,83.6952861 L225.999924,91.3047139 C225.158721,91.4957078 224.496546,92.1583066 224.305755,93 L197.999924,93 L197.999924,94 L224.305755,94 C224.533018,95.0025923 225.42911,95.7510735 226.499924,95.7510735 C227.570739,95.7510735 228.466831,95.0025923 228.694094,94 L228.694094,94 L247.305755,94 L247.305755,94 C247.533018,95.0025923 248.42911,95.7510735 249.499924,95.7510735 C250.570739,95.7510735 251.466831,95.0025923 251.694094,94 L277.305452,94 C277.532219,95.0032662 278.428632,95.7524154 279.499924,95.7524154 C280.571217,95.7524154 281.46763,95.0032662 281.694397,94 L305.305452,94 C305.532219,95.0032662 306.428632,95.7524154 307.499924,95.7524154 C308.571217,95.7524154 309.46763,95.0032662 309.694397,94 L309.694397,94 L332.305452,94 C332.532219,95.0032662 333.428632,95.7524154 334.499924,95.7524154 C335.571217,95.7524154 336.46763,95.0032662 336.694397,94 L360.305452,94 C360.495843,94.842331 361.158274,95.5055326 361.999924,95.696628 L361.999924,143 L362.999924,143 L362.999924,95.696628 C363.841575,95.5055326 364.504006,94.842331 364.694397,94 L366.999924,94 L366.999924,93 L364.693789,93 C364.502599,92.1589443 363.840681,91.4969482 362.999924,91.3060559 L362.999924,91.3060559 L362.999924,71.50806 C362.849305,71.5829117 362.67953,71.625 362.499924,71.625 C362.320319,71.625 362.150544,71.5829117 361.999924,71.50806 L361.999924,91.3060559 C361.159168,91.4969482 360.49725,92.1589443 360.30606,93 L360.30606,93 L336.693789,93 L336.693789,93 C336.502599,92.1589443 335.840681,91.4969482 334.999924,91.3060559 L334.999924,48.696628 C336.001844,48.4691439 336.74979,47.5726359 336.74979,46.5013419 C336.74979,46.0904765 336.639775,45.7053203 336.447611,45.3737543 L336.447611,45.3737543 L360.671064,22.8805483 L360.671064,22.8805483 C361.052017,23.1741316 361.505461,23.378171 361.999924,23.4611785 L361.999924,44.3060559 L361.999924,44.3060559 C360.998005,44.5335399 360.250059,45.4300479 360.250059,46.5013419 C360.250059,47.5726359 360.998005,48.4691439 361.999924,48.696628 L361.999924,69.49194 C362.150544,69.4170883 362.320319,69.375 362.499924,69.375 C362.67953,69.375 362.849305,69.4170883 362.999924,69.49194 L362.999924,69.49194 Z M363.621394,70.5897864 L367.757172,73.0712535 C367.993962,73.2133276 368.070745,73.5204577 367.928671,73.7572479 C367.786597,73.994038 367.479467,74.0708205 367.242677,73.9287465 L363.106975,71.4473254 C363.394845,71.2624741 363.59295,70.9499958 363.621394,70.5897864 L363.621394,70.5897864 Z M247.305755,93 L228.694094,93 L228.694094,93 C228.503302,92.1583066 227.841128,91.4957078 226.999924,91.3047139 L226.999924,83.6952861 C227.841128,83.5042922 228.503302,82.8416934 228.694094,82 L247.305755,82 C247.496546,82.8416934 248.158721,83.5042922 248.999924,83.6952861 L248.999924,91.3047139 C248.158721,91.4957078 247.496546,92.1583066 247.305755,93 L247.305755,93 Z M251.694094,93 L277.30606,93 C277.49725,92.1589443 278.159168,91.4969482 278.999924,91.3060559 L278.999924,83.6952861 L278.999924,83.6952861 C278.158721,83.5042922 277.496546,82.8416934 277.305755,82 L251.694094,82 L251.694094,82 C251.503302,82.8416934 250.841128,83.5042922 249.999924,83.6952861 L249.999924,91.3047139 C250.841128,91.4957078 251.503302,92.1583066 251.694094,93 L251.694094,93 Z M279.999924,83.6952861 L279.999924,91.3060559 C280.840681,91.4969482 281.502599,92.1589443 281.693789,93 L281.693789,93 L305.30606,93 C305.49725,92.1589443 306.159168,91.4969482 306.999924,91.3060559 L306.999924,73.696628 L306.999924,73.696628 C306.413665,73.5635187 305.914362,73.2013459 305.600978,72.709126 L281.73413,81.2330006 C281.744471,81.3205598 281.74979,81.4096584 281.74979,81.5 C281.74979,82.571294 281.001844,83.467802 279.999924,83.6952861 L279.999924,83.6952861 Z M333.999924,48.696628 L333.999924,91.3060559 L333.999924,91.3060559 C333.159168,91.4969482 332.49725,92.1589443 332.30606,93 L309.693789,93 C309.502599,92.1589443 308.840681,91.4969482 307.999924,91.3060559 L307.999924,73.696628 L307.999924,73.696628 C309.001844,73.4691439 309.74979,72.5726359 309.74979,71.5013419 C309.74979,71.07267 309.630033,70.671984 309.422166,70.3309493 L333.272767,48.3883968 C332.990484,48.2042543 332.752071,47.9584208 332.576636,47.6700143 L333.999924,48.696628 Z M307.499924,94.625 C308.121245,94.625 308.624924,94.1213203 308.624924,93.5 C308.624924,92.8786797 308.121245,92.375 307.499924,92.375 C306.878604,92.375 306.374924,92.8786797 306.374924,93.5 C306.374924,94.1213203 306.878604,94.625 307.499924,94.625 Z M334.499924,94.625 C335.121245,94.625 335.624924,94.1213203 335.624924,93.5 C335.624924,92.8786797 335.121245,92.375 334.499924,92.375 C333.878604,92.375 333.374924,92.8786797 333.374924,93.5 C333.374924,94.1213203 333.878604,94.625 334.499924,94.625 Z M279.499924,94.625 C280.121245,94.625 280.624924,94.1213203 280.624924,93.5 C280.624924,92.8786797 280.121245,92.375 279.499924,92.375 C278.878604,92.375 278.374924,92.8786797 278.374924,93.5 C278.374924,94.1213203 278.878604,94.625 279.499924,94.625 Z M307.499924,72.625 C308.121245,72.625 308.624924,72.1213203 308.624924,71.5 C308.624924,70.8786797 308.121245,70.375 307.499924,70.375 C306.878604,70.375 306.374924,70.8786797 306.374924,71.5 C306.374924,72.1213203 306.878604,72.625 307.499924,72.625 Z M334.499924,47.625 C335.121245,47.625 335.624924,47.1213203 335.624924,46.5 C335.624924,45.8786797 335.121245,45.375 334.499924,45.375 C333.878604,45.375 333.374924,45.8786797 333.374924,46.5 C333.374924,47.1213203 333.878604,47.625 334.499924,47.625 Z M279.499924,82.6236581 C280.121245,82.6236581 280.624924,82.1199784 280.624924,81.4986581 C280.624924,80.8773377 280.121245,80.3736581 279.499924,80.3736581 C278.878604,80.3736581 278.374924,80.8773377 278.374924,81.4986581 C278.374924,82.1199784 278.878604,82.6236581 279.499924,82.6236581 Z M249.499924,82.6236581 C250.121245,82.6236581 250.624924,82.1199784 250.624924,81.4986581 C250.624924,80.8773377 250.121245,80.3736581 249.499924,80.3736581 C248.878604,80.3736581 248.374924,80.8773377 248.374924,81.4986581 C248.374924,82.1199784 248.878604,82.6236581 249.499924,82.6236581 Z M226.499924,82.6236581 C227.121245,82.6236581 227.624924,82.1199784 227.624924,81.4986581 C227.624924,80.8773377 227.121245,80.3736581 226.499924,80.3736581 C225.878604,80.3736581 225.374924,80.8773377 225.374924,81.4986581 C225.374924,82.1199784 225.878604,82.6236581 226.499924,82.6236581 Z M226.499924,94.6236581 C227.121245,94.6236581 227.624924,94.1199784 227.624924,93.4986581 C227.624924,92.8773377 227.121245,92.3736581 226.499924,92.3736581 C225.878604,92.3736581 225.374924,92.8773377 225.374924,93.4986581 C225.374924,94.1199784 225.878604,94.6236581 226.499924,94.6236581 Z M249.499924,94.6236581 C250.121245,94.6236581 250.624924,94.1199784 250.624924,93.4986581 C250.624924,92.8773377 250.121245,92.3736581 249.499924,92.3736581 C248.878604,92.3736581 248.374924,92.8773377 248.374924,93.4986581 C248.374924,94.1199784 248.878604,94.6236581 249.499924,94.6236581 Z M362.499924,47.625 C363.121245,47.625 363.624924,47.1213203 363.624924,46.5 C363.624924,45.8786797 363.121245,45.375 362.499924,45.375 C361.878604,45.375 361.374924,45.8786797 361.374924,46.5 C361.374924,47.1213203 361.878604,47.625 362.499924,47.625 Z M362.499924,22 C363.328352,22 363.999924,21.3284271 363.999924,20.5 C363.999924,19.6715729 363.328352,19 362.499924,19 C361.671497,19 360.999924,19.6715729 360.999924,20.5 C360.999924,21.3284271 361.671497,22 362.499924,22 Z M362.499924,94.625 C363.121245,94.625 363.624924,94.1213203 363.624924,93.5 C363.624924,92.8786797 363.121245,92.375 362.499924,92.375 C361.878604,92.375 361.374924,92.8786797 361.374924,93.5 C361.374924,94.1213203 361.878604,94.625 362.499924,94.625 Z", id: "Rectangle-5-Copy", fill: "#F55C23", transform: "translate(282.499962, 80.250000) scale(-1, 1) translate(-282.499962, -80.250000) " }),
	                                    _react2.default.createElement("path", { d: "M92.2682896,101.529121 L98.4048966,101.529121 L98.9048966,101.529121 L98.9048966,100.529121 L98.4048966,100.529121 L92.2682896,100.529121 L91.7682896,100.529121 L91.7682896,101.529121 L92.2682896,101.529121 Z M30.90222,109.02779 L37.038827,109.02779 L37.538827,109.02779 L37.538827,108.02779 L37.038827,108.02779 L30.90222,108.02779 L30.40222,108.02779 L30.40222,109.02779 L30.90222,109.02779 Z M30.90222,115.02779 L37.038827,115.02779 L37.538827,115.02779 L37.538827,114.02779 L37.038827,114.02779 L30.90222,114.02779 L30.40222,114.02779 L30.40222,115.02779 L30.90222,115.02779 Z M30.90222,123.02779 L37.038827,123.02779 L37.538827,123.02779 L37.538827,122.02779 L37.038827,122.02779 L30.90222,122.02779 L30.40222,122.02779 L30.40222,123.02779 L30.90222,123.02779 Z M30.90222,101.529121 L37.038827,101.529121 L37.538827,101.529121 L37.538827,100.529121 L37.038827,100.529121 L30.90222,100.529121 L30.40222,100.529121 L30.40222,101.529121 L30.90222,101.529121 Z M51.3575766,101.529121 L57.4941835,101.529121 L57.9941835,101.529121 L57.9941835,100.529121 L57.4941835,100.529121 L51.3575766,100.529121 L50.8575766,100.529121 L50.8575766,101.529121 L51.3575766,101.529121 Z M92.2682896,131.523798 L98.4048966,131.523798 L98.9048966,131.523798 L98.9048966,130.523798 L98.4048966,130.523798 L92.2682896,130.523798 L91.7682896,130.523798 L91.7682896,131.523798 L92.2682896,131.523798 Z M92.2682896,124.025129 L98.4048966,124.025129 L98.9048966,124.025129 L98.9048966,123.025129 L98.4048966,123.025129 L92.2682896,123.025129 L91.7682896,123.025129 L91.7682896,124.025129 L92.2682896,124.025129 Z M92.2682896,116.526459 L98.4048966,116.526459 L98.9048966,116.526459 L98.9048966,115.526459 L98.4048966,115.526459 L92.2682896,115.526459 L91.7682896,115.526459 L91.7682896,116.526459 L92.2682896,116.526459 Z M71.8129331,101.529121 L77.94954,101.529121 L78.44954,101.529121 L78.44954,100.529121 L77.94954,100.529121 L71.8129331,100.529121 L71.3129331,100.529121 L71.3129331,101.529121 L71.8129331,101.529121 Z M71.8129331,108.529121 L77.94954,108.529121 L78.44954,108.529121 L78.44954,107.529121 L77.94954,107.529121 L71.8129331,107.529121 L71.3129331,107.529121 L71.3129331,108.529121 L71.8129331,108.529121 Z M91.8129331,108.529121 L97.94954,108.529121 L98.44954,108.529121 L98.44954,107.529121 L97.94954,107.529121 L91.8129331,107.529121 L91.3129331,107.529121 L91.3129331,108.529121 L91.8129331,108.529121 Z", id: "bricks", fill: "#F55C23" }),
	                                    _react2.default.createElement("path", { d: "M87.5316955,137 L87.5316955,126.72949 L76.6335576,111.72949 L59,106 L41.3664424,111.72949 L30.4683045,126.72949 L30.4683045,137 L87.5316955,137 Z", id: "Polygon-3", stroke: "#F55C23", fill: "#FFFFFF" }),
	                                    _react2.default.createElement("circle", { id: "Oval-42", stroke: "#F65C23", fill: "#FFFFFF", cx: "40.75", cy: "111.75", r: "1.75" }),
	                                    _react2.default.createElement("circle", { id: "Oval-42-Copy-2", stroke: "#F65C23", fill: "#FFFFFF", cx: "76.75", cy: "111.75", r: "1.75" }),
	                                    _react2.default.createElement("circle", { id: "Oval-42-Copy-7", stroke: "#F65C23", fill: "#FFFFFF", cx: "86.75", cy: "126.75", r: "1.75" }),
	                                    _react2.default.createElement("circle", { id: "Oval-42-Copy", stroke: "#F65C23", fill: "#FFFFFF", cx: "59", cy: "106", r: "1.75" }),
	                                    _react2.default.createElement(
	                                        "g",
	                                        { id: "pylon-copy", transform: "translate(181.596857, 142.941563)", fill: "#FFFFFF" },
	                                        _react2.default.createElement("polygon", { id: "Polygon-3", stroke: "#F55C23", transform: "translate(16.364285, 4.090183) scale(1, -1) translate(-16.364285, -4.090183) ", points: "16.3642852 0 31.9276453 2.82624706 25.9829707 7.39921085 6.7455997 7.39921085 0.800925127 2.82624706 " }),
	                                        _react2.default.createElement("ellipse", { id: "Oval-153", stroke: "#F65C23", cx: "2.38645826", cy: "5.11272896", rx: "1.70461304", ry: "1.70424299" }),
	                                        _react2.default.createElement("ellipse", { id: "Oval-153", stroke: "#F65C23", cx: "30.3421122", cy: "5.11272896", rx: "1.70461304", ry: "1.70424299" })
	                                    ),
	                                    _react2.default.createElement("ellipse", { id: "Oval-42-Copy-4", stroke: "#F65C23", fill: "#FFFFFF", transform: "translate(202.726374, 143.734238) scale(-1, 1) translate(-202.726374, -143.734238) ", cx: "202.726374", cy: "143.734238", rx: "1.72637406", ry: "1.73423766" }),
	                                    _react2.default.createElement("ellipse", { id: "Oval-42-Copy-3", stroke: "#F65C23", fill: "#FFFFFF", transform: "translate(192.726374, 143.734238) scale(-1, 1) translate(-192.726374, -143.734238) ", cx: "192.726374", cy: "143.734238", rx: "1.72637406", ry: "1.73423766" }),
	                                    _react2.default.createElement(
	                                        "g",
	                                        { id: "Group", transform: "translate(367.000000, 17.000000)" },
	                                        _react2.default.createElement("path", { d: "M86,54.50806 L86,74.3060559 C86.8407567,74.4969482 87.5026741,75.1589443 87.6938646,76 L93,76 L93,77 L87.6944729,77 C87.5040817,77.842331 86.8416508,78.5055326 86,78.696628 L86,126 L85,126 L85,78.696628 C84.1583492,78.5055326 83.4959183,77.842331 83.3055271,77 L83.3055271,77 L59.6944729,77 L59.6944729,77 C59.4677057,78.0032662 58.5712925,78.7524154 57.5,78.7524154 C56.4287075,78.7524154 55.5322943,78.0032662 55.3055271,77 L32.6944729,77 C32.4677057,78.0032662 31.5712925,78.7524154 30.5,78.7524154 C29.4287075,78.7524154 28.5322943,78.0032662 28.3055271,77 L4.69447293,77 L4.69447293,77 C4.46770567,78.0032662 3.57129249,78.7524154 2.5,78.7524154 C1.25743338,78.7524154 0.250134119,77.7445755 0.250134119,76.5013419 C0.250134119,75.4300479 0.99808035,74.5335399 2,74.3060559 L2,66.6952861 C0.99808035,66.467802 0.250134119,65.571294 0.250134119,64.5 C0.250134119,63.2567664 1.25743338,62.2489265 2.5,62.2489265 C3.29790038,62.2489265 3.99879007,62.6645016 4.39824959,63.2911227 L4.39824959,63.2911227 L28.2656431,54.7670536 C28.2554011,54.6799086 28.2501341,54.5912406 28.2501341,54.5013419 C28.2501341,53.2581083 29.2574334,52.2502684 30.5,52.2502684 C30.9520026,52.2502684 31.3728733,52.383631 31.7254503,52.6131742 L31.7254503,52.6131742 L55.5767111,30.6700143 L55.5767111,30.6700143 C55.3694895,30.3293527 55.2501341,29.9292933 55.2501341,29.5013419 C55.2501341,28.2581083 56.2574334,27.2502684 57.5,27.2502684 C57.9699755,27.2502684 58.4062942,27.3944476 58.7671826,27.64101 L82.9911826,5.14729569 C82.680819,4.67468048 82.5002682,4.10910746 82.5002682,3.50134191 C82.5002682,1.84374654 83.8432939,0.5 85.5,0.5 C87.1567061,0.5 88.4997318,1.84374654 88.4997318,3.50134191 C88.4997318,3.88678004 88.427115,4.25524852 88.2948233,4.59379876 L90.7572479,6.07125354 C90.994038,6.21332762 91.0708205,6.52045774 90.9287465,6.75724788 C90.7866724,6.99403801 90.4795423,7.07082054 90.2427521,6.92874646 L87.7804156,5.45134457 C87.3329231,5.97472736 86.70858,6.34222649 86,6.46117854 L86,6.46117854 L86,27.3060559 L86,27.3060559 C87.0019197,27.5335399 87.7498659,28.4300479 87.7498659,29.5013419 C87.7498659,29.7453991 87.7110476,29.9803849 87.6392516,30.2004558 L90.7572479,32.0712535 C90.994038,32.2133276 91.0708205,32.5204577 90.9287465,32.7572479 C90.7866724,32.994038 90.4795423,33.0708205 90.2427521,32.9287465 L87.1250792,31.0581427 C86.8256955,31.3709078 86.4370061,31.5974065 86,31.696628 L86,52.49194 C86.3704296,52.6760278 86.625,53.0582848 86.625,53.5 C86.625,53.5302219 86.6238083,53.5601656 86.6214693,53.5897864 L90.7572479,56.0712535 C90.994038,56.2133276 91.0708205,56.5204577 90.9287465,56.7572479 C90.7866724,56.994038 90.4795423,57.0708205 90.2427521,56.9287465 L86.1070504,54.4473254 C86.0726064,54.4694431 86.0368773,54.4897336 86,54.50806 L86,54.50806 Z M85,54.50806 L85,74.3060559 C84.1592433,74.4969482 83.4973259,75.1589443 83.3061354,76 L83.3061354,76 L59.6938646,76 L59.6938646,76 C59.5026741,75.1589443 58.8407567,74.4969482 58,74.3060559 L58,31.696628 C59.0019197,31.4691439 59.7498659,30.5726359 59.7498659,29.5013419 C59.7498659,29.0904765 59.6398508,28.7053203 59.4476867,28.3737543 L59.4476867,28.3737543 L83.6711393,5.8805483 L83.6711393,5.8805483 C84.0520923,6.1741316 84.5055363,6.37817101 85,6.46117854 L85,27.3060559 L85,27.3060559 C83.9980803,27.5335399 83.2501341,28.4300479 83.2501341,29.5013419 C83.2501341,30.5726359 83.9980803,31.4691439 85,31.696628 L85,52.49194 C85.1506199,52.4170883 85.3203948,52.375 85.5,52.375 C85.6796052,52.375 85.8493801,52.4170883 86,52.49194 L85,54.50806 Z M4.73420518,64.2330006 L28.601054,55.709126 C28.9144371,56.2013459 29.4137402,56.5635187 30,56.696628 L30,74.3060559 C29.1592433,74.4969482 28.4973259,75.1589443 28.3061354,76 L4.69386458,76 C4.50267409,75.1589443 3.84075674,74.4969482 3,74.3060559 L3,66.6952861 C4.00191965,66.467802 4.74986588,65.571294 4.74986588,64.5 C4.74986588,64.4096584 4.7445469,64.3205598 4.73420518,64.2330006 L4.73420518,64.2330006 Z M56.2728421,31.3883968 L32.4222415,53.3309493 L32.4222415,53.3309493 C32.6301083,53.671984 32.7498659,54.07267 32.7498659,54.5013419 C32.7498659,55.5726359 32.0019197,56.4691439 31,56.696628 L31,74.3060559 C31.8407567,74.4969482 32.5026741,75.1589443 32.6938646,76 L55.3061354,76 C55.4973259,75.1589443 56.1592433,74.4969482 57,74.3060559 L57,31.696628 C56.7371633,31.6369514 56.4918047,31.5312334 56.2728421,31.3883968 L56.2728421,31.3883968 Z M30.5,77.625 C31.1213203,77.625 31.625,77.1213203 31.625,76.5 C31.625,75.8786797 31.1213203,75.375 30.5,75.375 C29.8786797,75.375 29.375,75.8786797 29.375,76.5 C29.375,77.1213203 29.8786797,77.625 30.5,77.625 Z M57.5,77.625 C58.1213203,77.625 58.625,77.1213203 58.625,76.5 C58.625,75.8786797 58.1213203,75.375 57.5,75.375 C56.8786797,75.375 56.375,75.8786797 56.375,76.5 C56.375,77.1213203 56.8786797,77.625 57.5,77.625 Z M2.5,77.625 C3.12132034,77.625 3.625,77.1213203 3.625,76.5 C3.625,75.8786797 3.12132034,75.375 2.5,75.375 C1.87867966,75.375 1.375,75.8786797 1.375,76.5 C1.375,77.1213203 1.87867966,77.625 2.5,77.625 Z M30.5,55.625 C31.1213203,55.625 31.625,55.1213203 31.625,54.5 C31.625,53.8786797 31.1213203,53.375 30.5,53.375 C29.8786797,53.375 29.375,53.8786797 29.375,54.5 C29.375,55.1213203 29.8786797,55.625 30.5,55.625 Z M57.5,30.625 C58.1213203,30.625 58.625,30.1213203 58.625,29.5 C58.625,28.8786797 58.1213203,28.375 57.5,28.375 C56.8786797,28.375 56.375,28.8786797 56.375,29.5 C56.375,30.1213203 56.8786797,30.625 57.5,30.625 Z M2.5,65.6236581 C3.12132034,65.6236581 3.625,65.1199784 3.625,64.4986581 C3.625,63.8773377 3.12132034,63.3736581 2.5,63.3736581 C1.87867966,63.3736581 1.375,63.8773377 1.375,64.4986581 C1.375,65.1199784 1.87867966,65.6236581 2.5,65.6236581 Z M85.5,30.625 C86.1213203,30.625 86.625,30.1213203 86.625,29.5 C86.625,28.8786797 86.1213203,28.375 85.5,28.375 C84.8786797,28.375 84.375,28.8786797 84.375,29.5 C84.375,30.1213203 84.8786797,30.625 85.5,30.625 Z M85.5,5 C86.3284271,5 87,4.32842712 87,3.5 C87,2.67157288 86.3284271,2 85.5,2 C84.6715729,2 84,2.67157288 84,3.5 C84,4.32842712 84.6715729,5 85.5,5 Z M85.5,77.625 C86.1213203,77.625 86.625,77.1213203 86.625,76.5 C86.625,75.8786797 86.1213203,75.375 85.5,75.375 C84.8786797,75.375 84.375,75.8786797 84.375,76.5 C84.375,77.1213203 84.8786797,77.625 85.5,77.625 Z", id: "Rectangle-5-Copy-3", fill: "#F55C23" }),
	                                        _react2.default.createElement(
	                                            "g",
	                                            { id: "pylon-copy-2", transform: "translate(74.596857, 125.941563)", fill: "#FFFFFF" },
	                                            _react2.default.createElement("polygon", { id: "Polygon-3", stroke: "#F55C23", transform: "translate(16.364285, 4.090183) scale(1, -1) translate(-16.364285, -4.090183) ", points: "16.3642852 0 31.9276453 2.82624706 25.9829707 7.39921085 6.7455997 7.39921085 0.800925127 2.82624706 " }),
	                                            _react2.default.createElement("ellipse", { id: "Oval-153", stroke: "#F65C23", cx: "2.38645826", cy: "5.11272896", rx: "1.70461304", ry: "1.70424299" }),
	                                            _react2.default.createElement("ellipse", { id: "Oval-153", stroke: "#F65C23", cx: "30.3421122", cy: "5.11272896", rx: "1.70461304", ry: "1.70424299" })
	                                        ),
	                                        _react2.default.createElement("ellipse", { id: "Oval-42-Copy-5", stroke: "#F65C23", fill: "#FFFFFF", transform: "translate(95.726374, 126.734238) scale(-1, 1) translate(-95.726374, -126.734238) ", cx: "95.7263741", cy: "126.734238", rx: "1.72637406", ry: "1.73423766" }),
	                                        _react2.default.createElement("ellipse", { id: "Oval-42-Copy-6", stroke: "#F65C23", fill: "#FFFFFF", transform: "translate(85.726374, 126.734238) scale(-1, 1) translate(-85.726374, -126.734238) ", cx: "85.7263741", cy: "126.734238", rx: "1.72637406", ry: "1.73423766" })
	                                    ),
	                                    _react2.default.createElement("path", { d: "M658,69.49194 L658,48.696628 L658,48.696628 C658.437006,48.5974065 658.825695,48.3709078 659.125079,48.0581427 L662.242752,49.9287465 C662.479542,50.0708205 662.786672,49.994038 662.928746,49.7572479 C663.070821,49.5204577 662.994038,49.2133276 662.757248,49.0712535 L659.639252,47.2004558 C659.711048,46.9803849 659.749866,46.7453991 659.749866,46.5013419 C659.749866,45.4300479 659.00192,44.5335399 658,44.3060559 L658,23.4611785 L658,23.4611785 C658.70858,23.3422265 659.332923,22.9747274 659.780416,22.4513446 L662.242752,23.9287465 C662.479542,24.0708205 662.786672,23.994038 662.928746,23.7572479 C663.070821,23.5204577 662.994038,23.2133276 662.757248,23.0712535 L660.294823,21.5937988 C660.427115,21.2552485 660.499732,20.88678 660.499732,20.5013419 C660.499732,18.8437465 659.156706,17.5 657.5,17.5 C655.843294,17.5 654.500268,18.8437465 654.500268,20.5013419 C654.500268,21.1091075 654.680819,21.6746805 654.991183,22.1472957 L630.767183,44.64101 L630.767183,44.64101 C630.406294,44.3944476 629.969976,44.2502684 629.5,44.2502684 C628.257433,44.2502684 627.250134,45.2581083 627.250134,46.5013419 C627.250134,46.9292933 627.369489,47.3293527 627.576711,47.6700143 L603.72545,69.6131742 C603.372873,69.383631 602.952003,69.2502684 602.5,69.2502684 C601.257433,69.2502684 600.250134,70.2581083 600.250134,71.5013419 C600.250134,71.5912406 600.255401,71.6799086 600.265643,71.7670536 L576.39825,80.2911227 C575.99879,79.6645016 575.2979,79.2489265 574.5,79.2489265 C573.429185,79.2489265 572.533094,79.9974077 572.305831,81 L554.694169,81 C554.466906,79.9974077 553.570815,79.2489265 552.5,79.2489265 C551.429185,79.2489265 550.533094,79.9974077 550.305831,81 L525.694169,81 L525.694169,81 C525.466906,79.9974077 524.570815,79.2489265 523.5,79.2489265 C522.429185,79.2489265 521.533094,79.9974077 521.305831,81 L495.694169,81 C495.466906,79.9974077 494.570815,79.2489265 493.5,79.2489265 C492.429185,79.2489265 491.533094,79.9974077 491.305831,81 L456,81 L456,82 L491.305831,82 C491.533094,83.0025923 492.429185,83.7510735 493.5,83.7510735 C494.570815,83.7510735 495.466906,83.0025923 495.694169,82 L495.694169,82 L521.305831,82 C521.533094,83.0025923 522.429185,83.7510735 523.5,83.7510735 C524.570815,83.7510735 525.466906,83.0025923 525.694169,82 L550.305831,82 C550.533094,83.0025923 551.429185,83.7510735 552.5,83.7510735 C553.570815,83.7510735 554.466906,83.0025923 554.694169,82 L554.694169,82 L572.305831,82 C572.496622,82.8416934 573.158796,83.5042922 574,83.6952861 L574,83.6952861 L574,91.3060559 C573.159243,91.4969482 572.497326,92.1589443 572.306135,93 L554.694169,93 L554.694169,93 C554.466906,91.9974077 553.570815,91.2489265 552.5,91.2489265 C551.429185,91.2489265 550.533094,91.9974077 550.305831,93 L525.694169,93 C525.466906,91.9974077 524.570815,91.2489265 523.5,91.2489265 C522.429185,91.2489265 521.533094,91.9974077 521.305831,93 L495.694169,93 C495.466906,91.9974077 494.570815,91.2489265 493.5,91.2489265 C492.429185,91.2489265 491.533094,91.9974077 491.305831,93 L456,93 L456,94 L491.305831,94 C491.533094,95.0025923 492.429185,95.7510735 493.5,95.7510735 C494.570815,95.7510735 495.466906,95.0025923 495.694169,94 L521.305831,94 C521.533094,95.0025923 522.429185,95.7510735 523.5,95.7510735 C524.570815,95.7510735 525.466906,95.0025923 525.694169,94 L525.694169,94 L550.305831,94 C550.533094,95.0025923 551.429185,95.7510735 552.5,95.7510735 C553.570815,95.7510735 554.466906,95.0025923 554.694169,94 L572.305527,94 C572.495918,94.842331 573.158349,95.5055326 574,95.696628 L574,144 L575,144 L575,95.696628 C575.841651,95.5055326 576.504082,94.842331 576.694473,94 L600.305527,94 C600.532294,95.0032662 601.428708,95.7524154 602.5,95.7524154 C603.571292,95.7524154 604.467706,95.0032662 604.694473,94 L627.305527,94 C627.532294,95.0032662 628.428708,95.7524154 629.5,95.7524154 C630.571292,95.7524154 631.467706,95.0032662 631.694473,94 L655.305527,94 C655.495918,94.842331 656.158349,95.5055326 657,95.696628 L657,143 L658,143 L658,95.696628 C658.841651,95.5055326 659.504082,94.842331 659.694473,94 L665,94 L665,93 L659.693865,93 C659.502674,92.1589443 658.840757,91.4969482 658,91.3060559 L658,91.3060559 L658,71.50806 C657.84938,71.5829117 657.679605,71.625 657.5,71.625 C657.320395,71.625 657.15062,71.5829117 657,71.50806 L657,91.3060559 C656.159243,91.4969482 655.497326,92.1589443 655.306135,93 L655.306135,93 L631.693865,93 L631.693865,93 C631.502674,92.1589443 630.840757,91.4969482 630,91.3060559 L630,48.696628 C631.00192,48.4691439 631.749866,47.5726359 631.749866,46.5013419 C631.749866,46.0904765 631.639851,45.7053203 631.447687,45.3737543 L631.447687,45.3737543 L655.671139,22.8805483 L655.671139,22.8805483 C656.052092,23.1741316 656.505536,23.378171 657,23.4611785 L657,44.3060559 L657,44.3060559 C655.99808,44.5335399 655.250134,45.4300479 655.250134,46.5013419 C655.250134,47.5726359 655.99808,48.4691439 657,48.696628 L657,69.49194 C657.15062,69.4170883 657.320395,69.375 657.5,69.375 C657.679605,69.375 657.84938,69.4170883 658,69.49194 L658,69.49194 Z M658.621469,70.5897864 L662.757248,73.0712535 C662.994038,73.2133276 663.070821,73.5204577 662.928746,73.7572479 C662.786672,73.994038 662.479542,74.0708205 662.242752,73.9287465 L658.10705,71.4473254 C658.394921,71.2624741 658.593026,70.9499958 658.621469,70.5897864 L658.621469,70.5897864 Z M575,83.6952861 L575,91.3060559 C575.840757,91.4969482 576.502674,92.1589443 576.693865,93 L576.693865,93 L600.306135,93 C600.497326,92.1589443 601.159243,91.4969482 602,91.3060559 L602,73.696628 L602,73.696628 C601.41374,73.5635187 600.914437,73.2013459 600.601054,72.709126 L576.734205,81.2330006 C576.744547,81.3205598 576.749866,81.4096584 576.749866,81.5 C576.749866,82.571294 576.00192,83.467802 575,83.6952861 L575,83.6952861 Z M629,48.696628 L629,91.3060559 L629,91.3060559 C628.159243,91.4969482 627.497326,92.1589443 627.306135,93 L604.693865,93 C604.502674,92.1589443 603.840757,91.4969482 603,91.3060559 L603,73.696628 L603,73.696628 C604.00192,73.4691439 604.749866,72.5726359 604.749866,71.5013419 C604.749866,71.07267 604.630108,70.671984 604.422242,70.3309493 L628.272842,48.3883968 C627.990559,48.2042543 627.752146,47.9584208 627.576711,47.6700143 L629,48.696628 Z M602.5,94.625 C603.12132,94.625 603.625,94.1213203 603.625,93.5 C603.625,92.8786797 603.12132,92.375 602.5,92.375 C601.87868,92.375 601.375,92.8786797 601.375,93.5 C601.375,94.1213203 601.87868,94.625 602.5,94.625 Z M629.5,94.625 C630.12132,94.625 630.625,94.1213203 630.625,93.5 C630.625,92.8786797 630.12132,92.375 629.5,92.375 C628.87868,92.375 628.375,92.8786797 628.375,93.5 C628.375,94.1213203 628.87868,94.625 629.5,94.625 Z M574.5,94.625 C575.12132,94.625 575.625,94.1213203 575.625,93.5 C575.625,92.8786797 575.12132,92.375 574.5,92.375 C573.87868,92.375 573.375,92.8786797 573.375,93.5 C573.375,94.1213203 573.87868,94.625 574.5,94.625 Z M602.5,72.625 C603.12132,72.625 603.625,72.1213203 603.625,71.5 C603.625,70.8786797 603.12132,70.375 602.5,70.375 C601.87868,70.375 601.375,70.8786797 601.375,71.5 C601.375,72.1213203 601.87868,72.625 602.5,72.625 Z M629.5,47.625 C630.12132,47.625 630.625,47.1213203 630.625,46.5 C630.625,45.8786797 630.12132,45.375 629.5,45.375 C628.87868,45.375 628.375,45.8786797 628.375,46.5 C628.375,47.1213203 628.87868,47.625 629.5,47.625 Z M574.5,82.6236581 C575.12132,82.6236581 575.625,82.1199784 575.625,81.4986581 C575.625,80.8773377 575.12132,80.3736581 574.5,80.3736581 C573.87868,80.3736581 573.375,80.8773377 573.375,81.4986581 C573.375,82.1199784 573.87868,82.6236581 574.5,82.6236581 Z M552.5,82.6236581 C553.12132,82.6236581 553.625,82.1199784 553.625,81.4986581 C553.625,80.8773377 553.12132,80.3736581 552.5,80.3736581 C551.87868,80.3736581 551.375,80.8773377 551.375,81.4986581 C551.375,82.1199784 551.87868,82.6236581 552.5,82.6236581 Z M552.5,94.6236581 C553.12132,94.6236581 553.625,94.1199784 553.625,93.4986581 C553.625,92.8773377 553.12132,92.3736581 552.5,92.3736581 C551.87868,92.3736581 551.375,92.8773377 551.375,93.4986581 C551.375,94.1199784 551.87868,94.6236581 552.5,94.6236581 Z M523.5,94.6236581 C524.12132,94.6236581 524.625,94.1199784 524.625,93.4986581 C524.625,92.8773377 524.12132,92.3736581 523.5,92.3736581 C522.87868,92.3736581 522.375,92.8773377 522.375,93.4986581 C522.375,94.1199784 522.87868,94.6236581 523.5,94.6236581 Z M523.5,82.6236581 C524.12132,82.6236581 524.625,82.1199784 524.625,81.4986581 C524.625,80.8773377 524.12132,80.3736581 523.5,80.3736581 C522.87868,80.3736581 522.375,80.8773377 522.375,81.4986581 C522.375,82.1199784 522.87868,82.6236581 523.5,82.6236581 Z M493.5,82.6236581 C494.12132,82.6236581 494.625,82.1199784 494.625,81.4986581 C494.625,80.8773377 494.12132,80.3736581 493.5,80.3736581 C492.87868,80.3736581 492.375,80.8773377 492.375,81.4986581 C492.375,82.1199784 492.87868,82.6236581 493.5,82.6236581 Z M493.5,94.6236581 C494.12132,94.6236581 494.625,94.1199784 494.625,93.4986581 C494.625,92.8773377 494.12132,92.3736581 493.5,92.3736581 C492.87868,92.3736581 492.375,92.8773377 492.375,93.4986581 C492.375,94.1199784 492.87868,94.6236581 493.5,94.6236581 Z M657.5,47.625 C658.12132,47.625 658.625,47.1213203 658.625,46.5 C658.625,45.8786797 658.12132,45.375 657.5,45.375 C656.87868,45.375 656.375,45.8786797 656.375,46.5 C656.375,47.1213203 656.87868,47.625 657.5,47.625 Z M657.5,22 C658.328427,22 659,21.3284271 659,20.5 C659,19.6715729 658.328427,19 657.5,19 C656.671573,19 656,19.6715729 656,20.5 C656,21.3284271 656.671573,22 657.5,22 Z M657.5,94.625 C658.12132,94.625 658.625,94.1213203 658.625,93.5 C658.625,92.8786797 658.12132,92.375 657.5,92.375 C656.87868,92.375 656.375,92.8786797 656.375,93.5 C656.375,94.1213203 656.87868,94.625 657.5,94.625 Z", id: "Rectangle-5-Copy-2", fill: "#F55C23", transform: "translate(560.500000, 80.750000) scale(-1, 1) translate(-560.500000, -80.750000) " }),
	                                    _react2.default.createElement("path", { d: "M563.038827,101.529121 L556.90222,101.529121 L556.40222,101.529121 L556.40222,100.529121 L556.90222,100.529121 L563.038827,100.529121 L563.538827,100.529121 L563.538827,101.529121 L563.038827,101.529121 Z M624.404897,109.02779 L618.26829,109.02779 L617.76829,109.02779 L617.76829,108.02779 L618.26829,108.02779 L624.404897,108.02779 L624.904897,108.02779 L624.904897,109.02779 L624.404897,109.02779 Z M624.404897,115.02779 L618.26829,115.02779 L617.76829,115.02779 L617.76829,114.02779 L618.26829,114.02779 L624.404897,114.02779 L624.904897,114.02779 L624.904897,115.02779 L624.404897,115.02779 Z M624.404897,123.02779 L618.26829,123.02779 L617.76829,123.02779 L617.76829,122.02779 L618.26829,122.02779 L624.404897,122.02779 L624.904897,122.02779 L624.904897,123.02779 L624.404897,123.02779 Z M624.404897,101.529121 L618.26829,101.529121 L617.76829,101.529121 L617.76829,100.529121 L618.26829,100.529121 L624.404897,100.529121 L624.904897,100.529121 L624.904897,101.529121 L624.404897,101.529121 Z M603.94954,101.529121 L597.812933,101.529121 L597.312933,101.529121 L597.312933,100.529121 L597.812933,100.529121 L603.94954,100.529121 L604.44954,100.529121 L604.44954,101.529121 L603.94954,101.529121 Z M563.038827,131.523798 L556.90222,131.523798 L556.40222,131.523798 L556.40222,130.523798 L556.90222,130.523798 L563.038827,130.523798 L563.538827,130.523798 L563.538827,131.523798 L563.038827,131.523798 Z M563.038827,124.025129 L556.90222,124.025129 L556.40222,124.025129 L556.40222,123.025129 L556.90222,123.025129 L563.038827,123.025129 L563.538827,123.025129 L563.538827,124.025129 L563.038827,124.025129 Z M563.038827,116.526459 L556.90222,116.526459 L556.40222,116.526459 L556.40222,115.526459 L556.90222,115.526459 L563.038827,115.526459 L563.538827,115.526459 L563.538827,116.526459 L563.038827,116.526459 Z M583.494184,101.529121 L577.357577,101.529121 L576.857577,101.529121 L576.857577,100.529121 L577.357577,100.529121 L583.494184,100.529121 L583.994184,100.529121 L583.994184,101.529121 L583.494184,101.529121 Z M583.494184,108.529121 L577.357577,108.529121 L576.857577,108.529121 L576.857577,107.529121 L577.357577,107.529121 L583.494184,107.529121 L583.994184,107.529121 L583.994184,108.529121 L583.494184,108.529121 Z M563.494184,108.529121 L557.357577,108.529121 L556.857577,108.529121 L556.857577,107.529121 L557.357577,107.529121 L563.494184,107.529121 L563.994184,107.529121 L563.994184,108.529121 L563.494184,108.529121 Z", id: "bricks-copy", fill: "#F55C23" }),
	                                    _react2.default.createElement("path", { d: "M556.468305,137 L556.468305,126.72949 L567.366442,111.72949 L585,106 L602.633558,111.72949 L613.531695,126.72949 L613.531695,137 L556.468305,137 Z", id: "Polygon-3-Copy", stroke: "#F55C23", fill: "#FFFFFF" }),
	                                    _react2.default.createElement("circle", { id: "Oval-42-Copy-8", stroke: "#F65C23", fill: "#FFFFFF", cx: "566.75", cy: "111.75", r: "1.75" }),
	                                    _react2.default.createElement("circle", { id: "Oval-42-Copy-9", stroke: "#F65C23", fill: "#FFFFFF", cx: "602.75", cy: "111.75", r: "1.75" }),
	                                    _react2.default.createElement("circle", { id: "Oval-42-Copy-10", stroke: "#F65C23", fill: "#FFFFFF", cx: "612.75", cy: "126.75", r: "1.75" }),
	                                    _react2.default.createElement("circle", { id: "Oval-42-Copy-11", stroke: "#F65C23", fill: "#FFFFFF", cx: "585", cy: "106", r: "1.75" })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "brand-mountain-2" },
	                        _react2.default.createElement(
	                            "svg",
	                            { width: "514px", height: "175px", viewBox: "0 0 514 175", version: "1.1" },
	                            _react2.default.createElement("path", { fill: "#fff", d: "M41.5,45 L78,33 L78,74.5 L2.5,92 L41.5,45 Z", id: "Path", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M77.5,32.5 L143,45.5 L76.5,75.5 L77.5,32.5 Z", id: "Path-Copy-8", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M1.5,91 L78,73.5 L87,119.5 L41.5,149 L1.5,91 Z", id: "Path-Copy", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M77.5000001,74.5 L143,44 L174,46 L86.0000001,119.5 L77.5000001,74.5 Z", id: "Path-Copy-7", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M142.5,45 L205,25.5 L229,39.5 L173.5,47.5 L142.5,45 Z", id: "Path-Copy-9", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M158.499999,99 L225.499999,80.5 L270.999999,87.5 L226.999999,125 L158.499999,99 Z", id: "Path-Copy-2", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M156.499999,101.5 L172.999999,47 L226.499999,39 L226.499999,81 L156.499999,101.5 Z", id: "Path-Copy-11", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M243.000001,88.5 L225.5,43.5 L288,39 L288,81.5 L243.000001,88.5 Z", id: "Path-Copy-12", stroke: "#B6CCE5", transform: "translate(256.750000, 63.750000) scale(-1, 1) translate(-256.750000, -63.750000) " }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M286.5,44.5 L342.5,64 L319.5,110.5 L270,86.5 L286.5,44.5 Z", id: "Path-Copy-4", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M341.5,64 L390.5,111 L396.5,155 L317,109 L341.5,64 Z", id: "Path-Copy-10", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M389,111 L505,149 L396,154 L389,111 Z", id: "Path-Copy-13", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M321,110 L397,154 L282,149 L321,110 Z", id: "Path-Copy-14", stroke: "#4A90E2" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M247.5,20.5 L287,44.5 L226.5,40 L247.5,20.5 Z", id: "Path-Copy-5", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M221.999999,13 L248.499999,20.5 L227.499999,40 L203.999999,26 L221.999999,13 Z", id: "Path-Copy-6", stroke: "#B6CCE5" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M228.499999,126.000001 L284.000003,148.499999 L224.500001,171.000001 L158.500001,148.499999 L228.499999,126.000001 Z", id: "fg-geometry", stroke: "#4A90E2" }),
	                            _react2.default.createElement("polygon", { fill: "#fff", id: "Path", stroke: "#4A90E2", points: "158.5 99 159.5 149 42 149 " }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M271.000001,86.0000002 L321.5,110.5 L283,149.5 L225,125.5 L271.000001,86.0000002 Z", id: "Path-Copy-3", stroke: "#4A90E2" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M42.2061,154.838108 C45.4069681,154.838108 48.0017844,152.243855 48.0017844,149.043682 C48.0017844,145.843509 45.4069681,143.249256 42.2061,143.249256 C39.0052319,143.249256 36.4104157,145.843509 36.4104157,149.043682 C36.4104157,152.243855 39.0052319,154.838108 42.2061,154.838108 Z M159.483477,154.838108 C162.684345,154.838108 165.279162,152.243855 165.279162,149.043682 C165.279162,145.843509 162.684345,143.249256 159.483477,143.249256 C156.282609,143.249256 153.687793,145.843509 153.687793,149.043682 C153.687793,152.243855 156.282609,154.838108 159.483477,154.838108 Z M282.215617,154.838108 C285.416485,154.838108 288.011301,152.243855 288.011301,149.043682 C288.011301,145.843509 285.416485,143.249256 282.215617,143.249256 C279.014748,143.249256 276.419932,145.843509 276.419932,149.043682 C276.419932,152.243855 279.014748,154.838108 282.215617,154.838108 Z M505.860848,154.156411 C509.061716,154.156411 511.656532,151.562158 511.656532,148.361985 C511.656532,145.161811 509.061716,142.567558 505.860848,142.567558 C502.65998,142.567558 500.065164,145.161811 500.065164,148.361985 C500.065164,151.562158 502.65998,154.156411 505.860848,154.156411 Z M396.083768,159.950837 C399.284636,159.950837 401.879452,157.356584 401.879452,154.156411 C401.879452,150.956238 399.284636,148.361985 396.083768,148.361985 C392.8829,148.361985 390.288084,150.956238 390.288084,154.156411 C390.288084,157.356584 392.8829,159.950837 396.083768,159.950837 Z M319.717104,115.981368 C322.917972,115.981368 325.512788,113.387115 325.512788,110.186942 C325.512788,106.986769 322.917972,104.392516 319.717104,104.392516 C316.516235,104.392516 313.921419,106.986769 313.921419,110.186942 C313.921419,113.387115 316.516235,115.981368 319.717104,115.981368 Z M270.624248,92.8036633 C273.825116,92.8036633 276.419932,90.2094103 276.419932,87.0092371 C276.419932,83.8090639 273.825116,81.214811 270.624248,81.214811 C267.42338,81.214811 264.828563,83.8090639 264.828563,87.0092371 C264.828563,90.2094103 267.42338,92.8036633 270.624248,92.8036633 Z M229.03169,131.660403 C232.232558,131.660403 234.827374,129.06615 234.827374,125.865977 C234.827374,122.665804 232.232558,120.071551 229.03169,120.071551 C225.830822,120.071551 223.236005,122.665804 223.236005,125.865977 C223.236005,129.06615 225.830822,131.660403 229.03169,131.660403 Z M158.119787,104.392516 C161.320655,104.392516 163.915471,101.798263 163.915471,98.5980894 C163.915471,95.3979162 161.320655,92.8036633 158.119787,92.8036633 C154.918919,92.8036633 152.324103,95.3979162 152.324103,98.5980894 C152.324103,101.798263 154.918919,104.392516 158.119787,104.392516 Z M224.940618,173.925629 C228.141486,173.925629 230.736303,171.331376 230.736303,168.131203 C230.736303,164.93103 228.141486,162.336777 224.940618,162.336777 C221.73975,162.336777 219.144934,164.93103 219.144934,168.131203 C219.144934,171.331376 221.73975,173.925629 224.940618,173.925629 Z", id: "fg-points", stroke: "#4A90E2" }),
	                            _react2.default.createElement("path", { fill: "#fff", d: "M78.0029739,76.4429306 C79.5092648,76.4429306 80.7303548,75.2221057 80.7303548,73.7161419 C80.7303548,72.210178 79.5092648,70.9893531 78.0029739,70.9893531 C76.4966831,70.9893531 75.275593,72.210178 75.275593,73.7161419 C75.275593,75.2221057 76.4966831,76.4429306 78.0029739,76.4429306 Z M3,94.4779116 C4.50629086,94.4779116 5.72738087,93.2570867 5.72738087,91.7511228 C5.72738087,90.245159 4.50629086,89.024334 3,89.024334 C1.49370914,89.024334 0.27261913,90.245159 0.27261913,91.7511228 C0.27261913,93.2570867 1.49370914,94.4779116 3,94.4779116 Z M42.5470226,48.167594 C44.0533135,48.167594 45.2744035,46.9467691 45.2744035,45.4408052 C45.2744035,43.9348413 44.0533135,42.7140164 42.5470226,42.7140164 C41.0407318,42.7140164 39.8196417,43.9348413 39.8196417,45.4408052 C39.8196417,46.9467691 41.0407318,48.167594 42.5470226,48.167594 Z M78.0029739,35.541099 C79.5092648,35.541099 80.7303548,34.3202741 80.7303548,32.8143102 C80.7303548,31.3083464 79.5092648,30.0875214 78.0029739,30.0875214 C76.4966831,30.0875214 75.275593,31.3083464 75.275593,32.8143102 C75.275593,34.3202741 76.4966831,35.541099 78.0029739,35.541099 Z M142.77827,47.1299513 C144.28456,47.1299513 145.50565,45.9091264 145.50565,44.4031625 C145.50565,42.8971987 144.28456,41.6763737 142.77827,41.6763737 C141.271979,41.6763737 140.050889,42.8971987 140.050889,44.4031625 C140.050889,45.9091264 141.271979,47.1299513 142.77827,47.1299513 Z M86.8669617,122.116643 C88.3732526,122.116643 89.5943426,120.895818 89.5943426,119.389854 C89.5943426,117.88389 88.3732526,116.663065 86.8669617,116.663065 C85.3606709,116.663065 84.1395809,117.88389 84.1395809,119.389854 C84.1395809,120.895818 85.3606709,122.116643 86.8669617,122.116643 Z M246.418743,23.2705495 C247.925033,23.2705495 249.146123,22.0497246 249.146123,20.5437607 C249.146123,19.0377969 247.925033,17.8169719 246.418743,17.8169719 C244.912452,17.8169719 243.691362,19.0377969 243.691362,20.5437607 C243.691362,22.0497246 244.912452,23.2705495 246.418743,23.2705495 Z M173.461304,49.8567401 C174.967595,49.8567401 176.188685,48.6359151 176.188685,47.1299513 C176.188685,45.6239874 174.967595,44.4031625 173.461304,44.4031625 C171.955013,44.4031625 170.733923,45.6239874 170.733923,47.1299513 C170.733923,48.6359151 171.955013,49.8567401 173.461304,49.8567401 Z M204.144339,28.0424299 C205.65063,28.0424299 206.87172,26.8216049 206.87172,25.3156411 C206.87172,23.8096772 205.65063,22.5888523 204.144339,22.5888523 C202.638048,22.5888523 201.416958,23.8096772 201.416958,25.3156411 C201.416958,26.8216049 202.638048,28.0424299 204.144339,28.0424299 Z M225.963386,83.2599026 C227.469677,83.2599026 228.690767,82.0390776 228.690767,80.5331138 C228.690767,79.0271499 227.469677,77.806325 225.963386,77.806325 C224.457095,77.806325 223.236005,79.0271499 223.236005,80.5331138 C223.236005,82.0390776 224.457095,83.2599026 225.963386,83.2599026 Z M225.963386,41.6763737 C227.469677,41.6763737 228.690767,40.4555488 228.690767,38.949585 C228.690767,37.4436211 227.469677,36.2227962 225.963386,36.2227962 C224.457095,36.2227962 223.236005,37.4436211 223.236005,38.949585 C223.236005,40.4555488 224.457095,41.6763737 225.963386,41.6763737 Z M390.288084,113.254579 C391.794374,113.254579 393.015464,112.033754 393.015464,110.52779 C393.015464,109.021826 391.794374,107.801002 390.288084,107.801002 C388.781793,107.801002 387.560703,109.021826 387.560703,110.52779 C387.560703,112.033754 388.781793,113.254579 390.288084,113.254579 Z M342.558918,66.8991699 C344.065209,66.8991699 345.286299,65.678345 345.286299,64.1723811 C345.286299,62.6664173 344.065209,61.4455924 342.558918,61.4455924 C341.052627,61.4455924 339.831537,62.6664173 339.831537,64.1723811 C339.831537,65.678345 341.052627,66.8991699 342.558918,66.8991699 Z M286.64761,47.1299513 C288.153901,47.1299513 289.374991,45.9091264 289.374991,44.4031625 C289.374991,42.8971987 288.153901,41.6763737 286.64761,41.6763737 C285.14132,41.6763737 283.92023,42.8971987 283.92023,44.4031625 C283.92023,45.9091264 285.14132,47.1299513 286.64761,47.1299513 Z M221.872315,16.4535776 C223.378606,16.4535776 224.599696,15.2327526 224.599696,13.7267888 C224.599696,12.2208249 223.378606,11 221.872315,11 C220.366024,11 219.144934,12.2208249 219.144934,13.7267888 C219.144934,15.2327526 220.366024,16.4535776 221.872315,16.4535776 Z", id: "bg-points", stroke: "#B6CCE6" })
	                        )
	                    )
	                ),
	                _react2.default.createElement("div", { id: "caspian", className: "bg-brand block py3 absolute bottom left right" })
	            );
	        }
	    }]);
	
	    return AuthScene;
	}(_react.Component);
	
	AuthScene.displayName = "AuthScene";
	exports.default = AuthScene;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackToLogin = function BackToLogin() {
	    return _react2.default.createElement(
	        _reactRouter.Link,
	        { to: "/auth/login", className: "link block" },
	        "Back to login"
	    );
	};
	
	BackToLogin.displayName = "BackToLogin";
	exports.default = BackToLogin;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormField = (_temp = _class = function (_Component) {
	    _inherits(FormField, _Component);
	
	    function FormField() {
	        _classCallCheck(this, FormField);
	
	        return _possibleConstructorReturn(this, (FormField.__proto__ || Object.getPrototypeOf(FormField)).apply(this, arguments));
	    }
	
	    _createClass(FormField, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                className = _props.className,
	                fieldName = _props.fieldName,
	                formError = _props.formError,
	                error = _props.error;
	
	
	            var classes = (0, _classnames2.default)('Form-field', className, {
	                'Form--fieldError': error === true || formError && formError.data.errors && fieldName in formError.data.errors
	            });
	
	            return _react2.default.createElement(
	                "div",
	                { className: classes },
	                children
	            );
	        }
	    }]);
	
	    return FormField;
	}(_react.Component), _class.propTypes = {
	    fieldName: _propTypes2.default.string.isRequired
	}, _temp);
	FormField.displayName = "FormField";
	exports.default = FormField;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormLabel = (_temp = _class = function (_Component) {
	    _inherits(FormLabel, _Component);
	
	    function FormLabel() {
	        _classCallCheck(this, FormLabel);
	
	        return _possibleConstructorReturn(this, (FormLabel.__proto__ || Object.getPrototypeOf(FormLabel)).apply(this, arguments));
	    }
	
	    _createClass(FormLabel, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                fieldName = _props.fieldName,
	                formError = _props.formError,
	                message = _props.message,
	                offset = _props.offset,
	                title = _props.title;
	
	
	            if (!message) {
	                message = formError && formError.data.errors && fieldName in formError.data.errors ? formError.data.errors[fieldName] : undefined;
	            }
	
	            return _react2.default.createElement(
	                "label",
	                { className: (0, _classnames2.default)("Form-label", { "Form-offset": offset }) },
	                title,
	                ": ",
	                message !== undefined ? _react2.default.createElement(
	                    "span",
	                    null,
	                    message
	                ) : null
	            );
	        }
	    }]);
	
	    return FormLabel;
	}(_react.Component), _class.propTypes = {
	    fieldName: _propTypes2.default.string.isRequired,
	    formError: _propTypes2.default.object,
	    message: _propTypes2.default.string
	}, _class.defaultProps = {
	    offset: true
	}, _temp);
	FormLabel.displayName = "FormLabel";
	exports.default = FormLabel;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.UNKNOWN_ERROR_MESSAGE = exports.SERVER_ERROR_MESSAGE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SERVER_ERROR_MESSAGE = exports.SERVER_ERROR_MESSAGE = "Server error encountered";
	var UNKNOWN_ERROR_MESSAGE = exports.UNKNOWN_ERROR_MESSAGE = "Unknown error encountered";
	
	var FormMessage = function (_Component) {
	    _inherits(FormMessage, _Component);
	
	    function FormMessage() {
	        _classCallCheck(this, FormMessage);
	
	        return _possibleConstructorReturn(this, (FormMessage.__proto__ || Object.getPrototypeOf(FormMessage)).apply(this, arguments));
	    }
	
	    _createClass(FormMessage, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                formError = _props.formError,
	                formSuccess = _props.formSuccess,
	                message = _props.message;
	
	
	            if (!message) {
	                if (formError) {
	                    if (formError.data && formError.data.message) {
	                        message = formError.data.message;
	                    } else if (formError.status >= 400) {
	                        message = SERVER_ERROR_MESSAGE;
	                    } else {
	                        message = UNKNOWN_ERROR_MESSAGE;
	                    }
	                } else if (formSuccess && formSuccess.data.message) {
	                    message = formSuccess.data.message;
	                }
	            }
	
	            var classes = (0, _classnames2.default)('Form-message', 'px2', className, {
	                'Form-message--visible': !!message,
	                'text-success': formSuccess != undefined,
	                'text-error': formError != undefined
	            });
	
	            return _react2.default.createElement(
	                "span",
	                { className: classes },
	                message
	            );
	        }
	    }]);
	
	    return FormMessage;
	}(_react.Component);
	
	FormMessage.displayName = "FormMessage";
	exports.default = FormMessage;

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _reactRedux = __webpack_require__(467);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AuthScene = __webpack_require__(1569);
	
	var _AuthScene2 = _interopRequireDefault(_AuthScene);
	
	var _SSOLoginButton = __webpack_require__(1575);
	
	var _SSOLoginButton2 = _interopRequireDefault(_SSOLoginButton);
	
	var _FormField = __webpack_require__(1571);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormLabel = __webpack_require__(1572);
	
	var _FormLabel2 = _interopRequireDefault(_FormLabel);
	
	var _FormMessage = __webpack_require__(1573);
	
	var _FormMessage2 = _interopRequireDefault(_FormMessage);
	
	var _LogoIcon = __webpack_require__(1205);
	
	var _LogoIcon2 = _interopRequireDefault(_LogoIcon);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _auth = __webpack_require__(1123);
	
	var authActions = _interopRequireWildcard(_auth);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        loginError: state.auth && state.auth.loginError,
	        user: state.currentUser
	    };
	};
	
	var mapDispatchToProps = _extends({}, authActions);
	
	var LoginApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(LoginApp, _Component);
	
	    function LoginApp(props, context) {
	        _classCallCheck(this, LoginApp);
	
	        var _this = _possibleConstructorReturn(this, (LoginApp.__proto__ || Object.getPrototypeOf(LoginApp)).call(this, props, context));
	
	        _this.state = {
	            credentials: {},
	            valid: false
	        };
	        return _this;
	    }
	
	    _createClass(LoginApp, [{
	        key: "validateForm",
	        value: function validateForm() {
	            var credentials = this.state.credentials;
	
	
	            var valid = true;
	
	            if (!credentials.username || !credentials.password) {
	                valid = false;
	            }
	
	            if (this.state.valid !== valid) {
	                this.setState({ valid: valid });
	            }
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	
	            this.validateForm();
	
	            var _props = this.props,
	                loginGoogle = _props.loginGoogle,
	                location = _props.location;
	
	
	            var ssoLoginButton = (0, _reactDom.findDOMNode)(this.refs.ssoLoginButton);
	
	            function attachGoogleAuth() {
	                // if gapi isn't loaded yet then wait 100ms and check again. Keep doing this until we're ready
	                if (!window.gapi) {
	                    window.setTimeout(attachGoogleAuth, 100);
	                    return;
	                }
	                try {
	                    window.gapi.load('auth2', function () {
	                        var auth2 = window.gapi.auth2.init({
	                            client_id: _settings2.default.get('google_auth_client_id'),
	                            cookiepolicy: 'single_host_origin'
	                        });
	                        auth2.attachClickHandler(ssoLoginButton, {}, function (googleUser) {
	                            return loginGoogle(googleUser, location.query.redirect);
	                        }, function (error) {
	                            return console.error('There was an error logging in', error);
	                        });
	                    });
	                } catch (error) {
	                    console.error('Error attaching Google Auth handler: ', error);
	                }
	            }
	            attachGoogleAuth();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this.validateForm();
	        }
	    }, {
	        key: "onChange",
	        value: function onChange(fieldName, fieldValue) {
	            this.setState({ credentials: _extends({}, this.state.credentials, _defineProperty({}, fieldName, fieldValue)) });
	        }
	    }, {
	        key: "formSubmitted",
	        value: function formSubmitted(e) {
	            e.preventDefault();
	
	            var _props2 = this.props,
	                login = _props2.login,
	                location = _props2.location;
	            var credentials = this.state.credentials;
	
	
	            login(credentials, location.query.redirect);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var loginError = this.props.loginError;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "full-height full bg-white flex flex-column flex-full md-layout-centered" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "Login-wrapper wrapper Grid Grid--full md-Grid--1of2 relative z2" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Grid-cell flex layout-centered text-brand" },
	                        _react2.default.createElement(_LogoIcon2.default, { className: "Logo my4 sm-my0", width: 66, height: 85 })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Login-content Grid-cell" },
	                        _react2.default.createElement(
	                            "form",
	                            { className: "Form-new bg-white bordered rounded shadowed", name: "form", onSubmit: function onSubmit(e) {
	                                    return _this2.formSubmitted(e);
	                                }, noValidate: true },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "Login-header Form-offset" },
	                                "Sign in to Metabase"
	                            ),
	                            _settings2.default.ssoEnabled() && _react2.default.createElement(
	                                "div",
	                                { className: "mx4 mb4 py3 border-bottom relative" },
	                                _react2.default.createElement(_SSOLoginButton2.default, { provider: "google", ref: "ssoLoginButton" }),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "mx1 absolute text-centered left right", style: { bottom: -8 } },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: "text-bold px3 py2 text-grey-3 bg-white" },
	                                        "OR"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(_FormMessage2.default, { formError: loginError && loginError.data.message ? loginError : null }),
	                            _react2.default.createElement(
	                                _FormField2.default,
	                                { key: "username", fieldName: "username", formError: loginError },
	                                _react2.default.createElement(_FormLabel2.default, { title: _settings2.default.ldapEnabled() ? "Username or email address" : "Email address", fieldName: "username", formError: loginError }),
	                                _react2.default.createElement("input", { className: "Form-input Form-offset full py1", name: "username", placeholder: "youlooknicetoday@email.com", type: "text", onChange: function onChange(e) {
	                                        return _this2.onChange("username", e.target.value);
	                                    }, autoFocus: true }),
	                                _react2.default.createElement("span", { className: "Form-charm" })
	                            ),
	                            _react2.default.createElement(
	                                _FormField2.default,
	                                { key: "password", fieldName: "password", formError: loginError },
	                                _react2.default.createElement(_FormLabel2.default, { title: "Password", fieldName: "password", formError: loginError }),
	                                _react2.default.createElement("input", { className: "Form-input Form-offset full py1", name: "password", placeholder: "Shh...", type: "password", onChange: function onChange(e) {
	                                        return _this2.onChange("password", e.target.value);
	                                    } }),
	                                _react2.default.createElement("span", { className: "Form-charm" })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "Form-field" },
	                                _react2.default.createElement(
	                                    "ul",
	                                    { className: "Form-offset" },
	                                    _react2.default.createElement("input", { name: "remember", type: "checkbox", defaultChecked: true }),
	                                    " ",
	                                    _react2.default.createElement(
	                                        "label",
	                                        { className: "inline-block" },
	                                        "Remember Me:"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "Form-actions p2 Grid Grid--full md-Grid--1of2" },
	                                _react2.default.createElement(
	                                    "button",
	                                    { className: (0, _classnames2.default)("Button Grid-cell", { 'Button--primary': this.state.valid }), disabled: !this.state.valid },
	                                    "Sign in"
	                                ),
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: "/auth/forgot_password" + (_utils2.default.validEmail(this.state.credentials.username) ? "?email=" + this.state.credentials.username : ""), className: "Grid-cell py2 sm-py0 text-grey-3 md-text-right text-centered flex-full link", onClick: function onClick(e) {
	                                            window.OSX ? window.OSX.resetPassword() : null;
	                                        } },
	                                    "I seem to have forgotten my password"
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_AuthScene2.default, null)
	            );
	        }
	    }]);
	
	    return LoginApp;
	}(_react.Component)) || _class);
	LoginApp.displayName = "LoginApp";
	exports.default = LoginApp;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _humanizePlus = __webpack_require__(874);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  provider: _propTypes2.default.string.isRequired
	};
	
	var SSOLoginButton = function (_Component) {
	  _inherits(SSOLoginButton, _Component);
	
	  function SSOLoginButton() {
	    _classCallCheck(this, SSOLoginButton);
	
	    return _possibleConstructorReturn(this, (SSOLoginButton.__proto__ || Object.getPrototypeOf(SSOLoginButton)).apply(this, arguments));
	  }
	
	  _createClass(SSOLoginButton, [{
	    key: "render",
	    value: function render() {
	      var provider = this.props.provider;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "relative z2 bg-white p2 cursor-pointer shadow-hover text-centered sm-text-left rounded block sm-inline-block bordered shadowed" },
	        _react2.default.createElement(
	          "div",
	          { className: "flex align-center" },
	          _react2.default.createElement(_Icon2.default, { className: "mr1", name: provider }),
	          _react2.default.createElement(
	            "h4",
	            null,
	            "Sign in with " + (0, _humanizePlus.capitalize)(provider)
	          )
	        )
	      );
	    }
	  }]);
	
	  return SSOLoginButton;
	}(_react.Component);
	
	SSOLoginButton.displayName = "SSOLoginButton";
	
	
	SSOLoginButton.proptypes = propTypes;
	
	exports.default = SSOLoginButton;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _reactRedux = __webpack_require__(467);
	
	var _auth = __webpack_require__(1123);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = null;
	
	var mapDispatchToProps = {
	    logout: _auth.logout
	};
	
	var LogoutApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(LogoutApp, _Component);
	
	    function LogoutApp() {
	        _classCallCheck(this, LogoutApp);
	
	        return _possibleConstructorReturn(this, (LogoutApp.__proto__ || Object.getPrototypeOf(LogoutApp)).apply(this, arguments));
	    }
	
	    _createClass(LogoutApp, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.logout();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return LogoutApp;
	}(_react.Component)) || _class);
	LogoutApp.displayName = "LogoutApp";
	exports.default = LogoutApp;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AuthScene = __webpack_require__(1569);
	
	var _AuthScene2 = _interopRequireDefault(_AuthScene);
	
	var _FormField = __webpack_require__(1571);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormLabel = __webpack_require__(1572);
	
	var _FormLabel2 = _interopRequireDefault(_FormLabel);
	
	var _FormMessage = __webpack_require__(1573);
	
	var _FormMessage2 = _interopRequireDefault(_FormMessage);
	
	var _LogoIcon = __webpack_require__(1205);
	
	var _LogoIcon2 = _interopRequireDefault(_LogoIcon);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _auth = __webpack_require__(1123);
	
	var authActions = _interopRequireWildcard(_auth);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        token: props.params.token,
	        resetError: state.auth && state.auth.resetError,
	        resetSuccess: state.auth && state.auth.resetSuccess,
	        newUserJoining: props.location.hash === "#new"
	    };
	};
	
	var mapDispatchToProps = _extends({}, authActions);
	
	var PasswordResetApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(PasswordResetApp, _Component);
	
	    function PasswordResetApp(props, context) {
	        _classCallCheck(this, PasswordResetApp);
	
	        var _this = _possibleConstructorReturn(this, (PasswordResetApp.__proto__ || Object.getPrototypeOf(PasswordResetApp)).call(this, props, context));
	
	        _this.state = {
	            credentials: {},
	            valid: false,
	            tokenValid: false
	        };
	        return _this;
	    }
	
	    _createClass(PasswordResetApp, [{
	        key: "validateForm",
	        value: function validateForm() {
	            var credentials = this.state.credentials;
	
	
	            var valid = true;
	
	            if (!credentials.password || !credentials.password2) {
	                valid = false;
	            }
	
	            if (this.state.valid !== valid) {
	                this.setState({ valid: valid });
	            }
	        }
	    }, {
	        key: "componentWillMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var result;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return _services.SessionApi.password_reset_token_valid({ token: this.props.token });
	
	                            case 3:
	                                result = _context.sent;
	
	                                if (result && result.valid) {
	                                    this.setState({ tokenValid: true });
	                                }
	                                _context.next = 10;
	                                break;
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context["catch"](0);
	
	                                console.log("error validating token", _context.t0);
	
	                            case 10:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 7]]);
	            }));
	
	            function componentWillMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.validateForm();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this.validateForm();
	        }
	    }, {
	        key: "onChange",
	        value: function onChange(fieldName, fieldValue) {
	            this.setState({ credentials: _extends({}, this.state.credentials, _defineProperty({}, fieldName, fieldValue)) });
	        }
	    }, {
	        key: "formSubmitted",
	        value: function formSubmitted(e) {
	            e.preventDefault();
	
	            var _props = this.props,
	                token = _props.token,
	                passwordReset = _props.passwordReset;
	            var credentials = this.state.credentials;
	
	
	            passwordReset(token, credentials);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                resetError = _props2.resetError,
	                resetSuccess = _props2.resetSuccess,
	                newUserJoining = _props2.newUserJoining;
	
	            var passwordComplexity = _settings2.default.passwordComplexity(false);
	
	            if (!this.state.tokenValid) {
	                return _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "full-height bg-white flex flex-column flex-full md-layout-centered" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "wrapper" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "Login-wrapper Grid  Grid--full md-Grid--1of2" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "Grid-cell flex layout-centered text-brand" },
	                                    _react2.default.createElement(_LogoIcon2.default, { className: "Logo my4 sm-my0", width: 66, height: 85 })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "Grid-cell bordered rounded shadowed" },
	                                    _react2.default.createElement(
	                                        "h3",
	                                        { className: "Login-header Form-offset mt4" },
	                                        "Whoops, that's an expired link"
	                                    ),
	                                    _react2.default.createElement(
	                                        "p",
	                                        { className: "Form-offset mb4 mr4" },
	                                        "For security reasons, password reset links expire after a little while. If you still need to reset your password, you can ",
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: "/auth/forgot_password", className: "link" },
	                                            "request a new reset email"
	                                        ),
	                                        "."
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_AuthScene2.default, null)
	                );
	            } else {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "full-height bg-white flex flex-column flex-full md-layout-centered" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Login-wrapper wrapper Grid  Grid--full md-Grid--1of2" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Grid-cell flex layout-centered text-brand" },
	                            _react2.default.createElement(_LogoIcon2.default, { className: "Logo my4 sm-my0", width: 66, height: 85 })
	                        ),
	                        !resetSuccess ? _react2.default.createElement(
	                            "div",
	                            { className: "Grid-cell" },
	                            _react2.default.createElement(
	                                "form",
	                                { className: "ForgotForm Login-wrapper bg-white Form-new bordered rounded shadowed", name: "form", onSubmit: function onSubmit(e) {
	                                        return _this2.formSubmitted(e);
	                                    }, noValidate: true },
	                                _react2.default.createElement(
	                                    "h3",
	                                    { className: "Login-header Form-offset" },
	                                    "New password"
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    { className: "Form-offset text-grey-3 mb4" },
	                                    "To keep your data secure, passwords ",
	                                    passwordComplexity
	                                ),
	                                _react2.default.createElement(_FormMessage2.default, { formError: resetError && resetError.data.message ? resetError : null }),
	                                _react2.default.createElement(
	                                    _FormField2.default,
	                                    { key: "password", fieldName: "password", formError: resetError },
	                                    _react2.default.createElement(_FormLabel2.default, { title: "Create a new password", fieldName: "password", formError: resetError }),
	                                    _react2.default.createElement("input", { className: "Form-input Form-offset full", name: "password", placeholder: "Make sure its secure like the instructions above", type: "password", onChange: function onChange(e) {
	                                            return _this2.onChange("password", e.target.value);
	                                        }, autoFocus: true }),
	                                    _react2.default.createElement("span", { className: "Form-charm" })
	                                ),
	                                _react2.default.createElement(
	                                    _FormField2.default,
	                                    { key: "password2", fieldName: "password2", formError: resetError },
	                                    _react2.default.createElement(_FormLabel2.default, { title: "Confirm new password", fieldName: "password2", formError: resetError }),
	                                    _react2.default.createElement("input", { className: "Form-input Form-offset full", name: "password2", placeholder: "Make sure it matches the one you just entered", type: "password", onChange: function onChange(e) {
	                                            return _this2.onChange("password2", e.target.value);
	                                        } }),
	                                    _react2.default.createElement("span", { className: "Form-charm" })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "Form-actions" },
	                                    _react2.default.createElement(
	                                        "button",
	                                        { className: (0, _classnames2.default)("Button", { "Button--primary": this.state.valid }), disabled: !this.state.valid },
	                                        "Save new password"
	                                    )
	                                )
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: "Grid-cell" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "SuccessGroup bg-white bordered rounded shadowed" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "SuccessMark" },
	                                    _react2.default.createElement(_Icon2.default, { name: "check" })
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    "Your password has been reset."
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    null,
	                                    newUserJoining ? _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: "/?new", className: "Button Button--primary" },
	                                        "Sign in with your new password"
	                                    ) : _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: "/", className: "Button Button--primary" },
	                                        "Sign in with your new password"
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_AuthScene2.default, null)
	                );
	            }
	        }
	    }]);
	
	    return PasswordResetApp;
	}(_react.Component)) || _class);
	PasswordResetApp.displayName = "PasswordResetApp";
	exports.default = PasswordResetApp;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthScene = __webpack_require__(1569);
	
	var _AuthScene2 = _interopRequireDefault(_AuthScene);
	
	var _LogoIcon = __webpack_require__(1205);
	
	var _LogoIcon2 = _interopRequireDefault(_LogoIcon);
	
	var _BackToLogin = __webpack_require__(1570);
	
	var _BackToLogin2 = _interopRequireDefault(_BackToLogin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoogleNoAccount = function GoogleNoAccount() {
	    return _react2.default.createElement(
	        "div",
	        { className: "full-height bg-white flex flex-column flex-full md-layout-centered" },
	        _react2.default.createElement(
	            "div",
	            { className: "wrapper" },
	            _react2.default.createElement(
	                "div",
	                { className: "Login-wrapper Grid  Grid--full md-Grid--1of2" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "Grid-cell flex layout-centered text-brand" },
	                    _react2.default.createElement(_LogoIcon2.default, { className: "Logo my4 sm-my0", width: 66, height: 85 })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "Grid-cell text-centered bordered rounded shadowed p4" },
	                    _react2.default.createElement(
	                        "h3",
	                        { className: "mt4 mb2" },
	                        "No Metabase account exists for this Google account."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "mb4 ml-auto mr-auto", style: { maxWidth: 360 } },
	                        "You'll need an administrator to create a Metabase account before you can use Google to log in."
	                    ),
	                    _react2.default.createElement(_BackToLogin2.default, null)
	                )
	            )
	        ),
	        _react2.default.createElement(_AuthScene2.default, null)
	    );
	};
	
	GoogleNoAccount.displayName = "GoogleNoAccount";
	exports.default = GoogleNoAccount;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _greeting = __webpack_require__(1580);
	
	var _greeting2 = _interopRequireDefault(_greeting);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Activity = __webpack_require__(1581);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _RecentViews = __webpack_require__(1584);
	
	var _RecentViews2 = _interopRequireDefault(_RecentViews);
	
	var _Smile = __webpack_require__(1586);
	
	var _Smile2 = _interopRequireDefault(_Smile);
	
	var _NewUserOnboardingModal = __webpack_require__(1587);
	
	var _NewUserOnboardingModal2 = _interopRequireDefault(_NewUserOnboardingModal);
	
	var _NextStep = __webpack_require__(1589);
	
	var _NextStep2 = _interopRequireDefault(_NextStep);
	
	var _actions = __webpack_require__(1590);
	
	var homepageActions = _interopRequireWildcard(_actions);
	
	var _selectors = __webpack_require__(1591);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        activity: (0, _selectors.getActivity)(state),
	        recentViews: (0, _selectors.getRecentViews)(state),
	        user: (0, _selectors.getUser)(state),
	        showOnboarding: "new" in props.location.query
	    };
	};
	
	var mapDispatchToProps = _extends({}, homepageActions, {
	    onChangeLocation: _reactRouterRedux.push
	});
	
	var HomepageApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(HomepageApp, _Component);
	
	    function HomepageApp(props, context) {
	        _classCallCheck(this, HomepageApp);
	
	        var _this = _possibleConstructorReturn(this, (HomepageApp.__proto__ || Object.getPrototypeOf(HomepageApp)).call(this, props, context));
	
	        _this.state = {
	            greeting: _greeting2.default.sayHello(props.user && props.user.first_name),
	            onboarding: props.showOnboarding
	        };
	
	        _this.styles = {
	            headerGreeting: {
	                fontSize: "x-large"
	            }
	        };
	        return _this;
	    }
	
	    _createClass(HomepageApp, [{
	        key: "completeOnboarding",
	        value: function completeOnboarding() {
	            this.setState({ onboarding: false });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var user = this.props.user;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "full" },
	                this.state.onboarding ? _react2.default.createElement(
	                    _Modal2.default,
	                    null,
	                    _react2.default.createElement(_NewUserOnboardingModal2.default, {
	                        user: user,
	                        onClose: function onClose() {
	                            return _this2.completeOnboarding();
	                        }
	                    })
	                ) : null,
	                _react2.default.createElement(
	                    "div",
	                    { className: "bg-brand text-white md-pl4" },
	                    _react2.default.createElement(
	                        "div",
	                        { style: { marginRight: 346 } },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Layout-mainColumn" },
	                            _react2.default.createElement(
	                                "header",
	                                { style: this.styles.headerGreeting, className: "flex align-center pb4 pt1" },
	                                _react2.default.createElement(_Smile2.default, null),
	                                _react2.default.createElement(
	                                    "div",
	                                    { id: "Greeting", className: "ml2" },
	                                    this.state.greeting
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wrapper" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Layout-mainColumn pl2" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "pt4 h2 text-normal ml2" },
	                                "Activity"
	                            ),
	                            _react2.default.createElement(_Activity2.default, this.props)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Layout-sidebar flex-no-shrink hide sm-show" },
	                        _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(_NextStep2.default, null),
	                            _react2.default.createElement(_RecentViews2.default, this.props)
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HomepageApp;
	}(_react.Component), _class2.propTypes = {
	    onChangeLocation: _propTypes2.default.func.isRequired,
	    showOnboarding: _propTypes2.default.bool.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    activity: _propTypes2.default.array,
	    recentViews: _propTypes2.default.array,
	    fetchActivity: _propTypes2.default.func.isRequired,
	    fetchRecentViews: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	HomepageApp.displayName = "HomepageApp";
	exports.default = HomepageApp;

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var greetingPrefixes = ['Hey there,', 'How\'s it going,', 'Howdy,', 'Greetings,', 'Good to see you,'];
	
	var subheadPrefixes = ['What do you want to know?', 'What\'s on your mind?', 'What do you want to find out?'];
	
	var Greeting = {
	    simpleGreeting: function simpleGreeting() {
	        // TODO - this can result in an undefined thing
	        var randomIndex = Math.floor(Math.random() * (greetingPrefixes.length - 1));
	        return greetingPrefixes[randomIndex];
	    },
	
	    sayHello: function sayHello(personalization) {
	        if (personalization) {
	            var g = Greeting.simpleGreeting();
	            if (g === 'How\'s it going,') {
	                return g + ' ' + personalization + '?';
	            } else {
	                return g + ' ' + personalization;
	            }
	        } else {
	            return Greeting.simpleGreeting();
	        }
	    },
	
	    encourageCuriosity: function encourageCuriosity() {
	        // TODO - this can result in an undefined thing
	        var randomIndex = Math.floor(Math.random() * (subheadPrefixes.length - 1));
	
	        return subheadPrefixes[randomIndex];
	    }
	};
	
	exports.default = Greeting;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _ActivityItem = __webpack_require__(1582);
	
	var _ActivityItem2 = _interopRequireDefault(_ActivityItem);
	
	var _ActivityStory = __webpack_require__(1583);
	
	var _ActivityStory2 = _interopRequireDefault(_ActivityStory);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Activity = (_temp = _class = function (_Component) {
	    _inherits(Activity, _Component);
	
	    function Activity(props, context) {
	        _classCallCheck(this, Activity);
	
	        var _this = _possibleConstructorReturn(this, (Activity.__proto__ || Object.getPrototypeOf(Activity)).call(this, props, context));
	
	        _this.state = { error: null, userColors: {} };
	
	        _this.colorClasses = ['bg-brand', 'bg-purple', 'bg-error', 'bg-green', 'bg-gold', 'bg-grey-2'];
	        return _this;
	    }
	
	    _createClass(Activity, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return this.props.fetchActivity();
	
	                            case 3:
	                                _context.next = 8;
	                                break;
	
	                            case 5:
	                                _context.prev = 5;
	                                _context.t0 = _context["catch"](0);
	
	                                this.setState({ error: _context.t0 });
	
	                            case 8:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 5]]);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            // do a quick pass over the activity and make sure we've assigned colors to all users which have activity
	            var activity = nextProps.activity,
	                user = nextProps.user;
	            var userColors = this.state.userColors;
	
	
	            var colors = [1, 2, 3, 4, 5];
	            var maxColorUsed = _underscore2.default.isEmpty(userColors) ? 0 : _underscore2.default.max(_underscore2.default.values(userColors));
	            var currColor = maxColorUsed && maxColorUsed < colors.length ? maxColorUsed : 0;
	
	            if (user && activity) {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = activity[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var item = _step.value;
	
	                        if (!(item.user_id in userColors)) {
	                            // assign the user a color
	                            if (item.user_id === user.id) {
	                                userColors[item.user_id] = 0;
	                            } else if (item.user_id === null) {
	                                // just skip this scenario, we handle this differently
	                            } else {
	                                userColors[item.user_id] = colors[currColor];
	                                currColor++;
	
	                                // if we hit the end of the colors list then just go back to the beginning again
	                                if (currColor >= colors.length) {
	                                    currColor = 0;
	                                }
	                            }
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	
	            this.setState({ userColors: userColors });
	        }
	    }, {
	        key: "userName",
	        value: function userName(user, currentUser) {
	            if (user && currentUser && user.id === currentUser.id) {
	                return "You";
	            } else if (user) {
	                return user.first_name;
	            } else {
	                return "Metabase";
	            }
	        }
	    }, {
	        key: "activityHeader",
	        value: function activityHeader(item, user) {
	
	            // this is a base to start with
	            var description = {
	                userName: this.userName(item.user, user),
	                subject: "did some super awesome stuff thats hard to describe",
	                subjectRefLink: null,
	                subjectRefName: null,
	                timeSince: item.timestamp.fromNow()
	            };
	
	            switch (item.topic) {
	                case "card-create":
	                case "card-update":
	                    if (item.table) {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "saved a question about ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.tableRowsQuery(item.database_id, item.table_id), "data-metabase-event": "Activity Feed;Header Clicked;Database -> " + item.topic, className: "link text-dark" },
	                                item.table.display_name
	                            )
	                        );
	                    } else {
	                        description.summary = "saved a question";
	                    }
	                    break;
	                case "card-delete":
	                    description.summary = "deleted a question";
	                    break;
	                case "dashboard-create":
	                    description.summary = "created a dashboard";
	                    break;
	                case "dashboard-delete":
	                    description.summary = "deleted a dashboard";
	                    break;
	                case "dashboard-add-cards":
	                    if (item.model_exists) {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "added a question to the dashboard - ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.dashboard(item.model_id), "data-metabase-event": "Activity Feed;Header Clicked;Dashboard -> " + item.topic, className: "link text-dark" },
	                                item.details.name
	                            )
	                        );
	                    } else {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "added a question to the dashboard - ",
	                            _react2.default.createElement(
	                                "span",
	                                { className: "text-dark" },
	                                item.details.name
	                            )
	                        );
	                    }
	                    break;
	                case "dashboard-remove-cards":
	                    if (item.model_exists) {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "removed a question from the dashboard - ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.dashboard(item.model_id), "data-metabase-event": "Activity Feed;Header Clicked;Dashboard -> " + item.topic, className: "link text-dark" },
	                                item.details.name
	                            )
	                        );
	                    } else {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "removed a question from the dashboard - ",
	                            _react2.default.createElement(
	                                "span",
	                                { className: "text-dark" },
	                                item.details.name
	                            )
	                        );
	                    }
	                    break;
	                case "database-sync":
	                    // NOTE: this is a relic from the very early days of the activity feed when we accidentally didn't
	                    //       capture the name/description/engine of a Database properly in the details and so it was
	                    //       possible for a database to be deleted and we'd lose any way of knowing what it's name was :(
	                    var oldName = item.database && 'name' in item.database ? item.database.name : "Unknown";
	                    if (item.details.name) {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "received the latest data from ",
	                            _react2.default.createElement(
	                                "span",
	                                { className: "text-dark" },
	                                item.details.name
	                            )
	                        );
	                    } else {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "received the latest data from ",
	                            _react2.default.createElement(
	                                "span",
	                                { className: "text-dark" },
	                                oldName
	                            )
	                        );
	                    }
	                    break;
	                case "install":
	                    description.userName = "Hello World!";
	                    description.summary = "Metabase is up and running.";
	                    break;
	                case "metric-create":
	                    if (item.model_exists) {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "added the metric ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.tableRowsQuery(item.database_id, item.table_id, item.model_id), "data-metabase-event": "Activity Feed;Header Clicked;Metric -> " + item.topic, className: "link text-dark" },
	                                item.details.name
	                            ),
	                            " to the ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.tableRowsQuery(item.database_id, item.table_id), "data-metabase-event": "Activity Feed;Header Clicked;Table -> " + item.topic, className: "link text-dark" },
	                                item.table.display_name
	                            ),
	                            " table"
	                        );
	                    } else {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "added the metric ",
	                            _react2.default.createElement(
	                                "span",
	                                { className: "text-dark" },
	                                item.details.name
	                            )
	                        );
	                    }
	                    break;
	                case "metric-update":
	                    if (item.model_exists) {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "made changes to the metric ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.tableRowsQuery(item.database_id, item.table_id, item.model_id), "data-metabase-event": "Activity Feed;Header Clicked;Metric -> " + item.topic, className: "link text-dark" },
	                                item.details.name
	                            ),
	                            " in the ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.tableRowsQuery(item.database_id, item.table_id), "data-metabase-event": "Activity Feed;Header Clicked;Table -> " + item.topic, className: "link text-dark" },
	                                item.table.display_name
	                            ),
	                            " table"
	                        );
	                    } else {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "made changes to the metric ",
	                            _react2.default.createElement(
	                                "span",
	                                { className: "text-dark" },
	                                item.details.name
	                            )
	                        );
	                    }
	                    break;
	                case "metric-delete":
	                    description.summary = "removed the metric " + item.details.name;
	                    break;
	                case "pulse-create":
	                    description.summary = "created a pulse";
	                    break;
	                case "pulse-delete":
	                    description.summary = "deleted a pulse";
	                    break;
	                case "segment-create":
	                    if (item.model_exists) {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "added the filter ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.tableRowsQuery(item.database_id, item.table_id, null, item.model_id), "data-metabase-event": "Activity Feed;Header Clicked;Segment -> " + item.topic, className: "link text-dark" },
	                                item.details.name
	                            ),
	                            " to the ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.tableRowsQuery(item.database_id, item.table_id), "data-metabase-event": "Activity Feed;Header Clicked;Table -> " + item.topic, className: "link text-dark" },
	                                item.table.display_name
	                            ),
	                            " table"
	                        );
	                    } else {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "added the filter ",
	                            _react2.default.createElement(
	                                "span",
	                                { className: "text-dark" },
	                                item.details.name
	                            )
	                        );
	                    }
	                    break;
	                case "segment-update":
	                    if (item.model_exists) {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "made changes to the filter ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.tableRowsQuery(item.database_id, item.table_id, null, item.model_id), "data-metabase-event": "Activity Feed;Header Clicked;Segment -> " + item.topic, className: "link text-dark" },
	                                item.details.name
	                            ),
	                            " in the ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.tableRowsQuery(item.database_id, item.table_id), "data-metabase-event": "Activity Feed;Header Clicked;Table -> " + item.topic, className: "link text-dark" },
	                                item.table.display_name
	                            ),
	                            " table"
	                        );
	                    } else {
	                        description.summary = _react2.default.createElement(
	                            "span",
	                            null,
	                            "made changes to the filter ",
	                            _react2.default.createElement(
	                                "span",
	                                { className: "text-dark" },
	                                item.details.name
	                            )
	                        );
	                    }
	                    break;
	                case "segment-delete":
	                    description.summary = "removed the filter " + item.details.name;
	                    break;
	                case "user-joined":
	                    description.summary = "joined!";
	                    break;
	            }
	
	            return description;
	        }
	    }, {
	        key: "activityStory",
	        value: function activityStory(item) {
	
	            // this is a base to start with
	            var description = {
	                topic: item.topic,
	                body: null,
	                bodyLink: null
	            };
	
	            switch (item.topic) {
	                case "card-create":
	                case "card-update":
	                    description.body = item.details.name;
	                    description.bodyLink = item.model_exists ? Urls.modelToUrl(item.model, item.model_id) : null;
	                    break;
	                case "card-delete":
	                    description.body = item.details.name;
	                    break;
	                case "dashboard-create":
	                    description.body = item.details.name;
	                    description.bodyLink = item.model_exists ? Urls.modelToUrl(item.model, item.model_id) : null;
	                    break;
	                case "dashboard-delete":
	                    description.body = item.details.name;
	                    break;
	                case "dashboard-add-cards":
	                case "dashboard-remove-cards":
	                    description.body = item.details.dashcards[0].name;
	                    if (item.details.dashcards[0].exists) {
	                        description.bodyLink = Urls.question(item.details.dashcards[0].card_id);
	                    }
	                    break;
	                case "metric-create":
	                    description.body = item.details.description;
	                    break;
	                case "metric-update":
	                    description.body = item.details.revision_message;
	                    break;
	                case "metric-delete":
	                    description.body = item.details.revision_message;
	                    break;
	                case "pulse-create":
	                    description.body = item.details.name;
	                    description.bodyLink = item.model_exists ? Urls.modelToUrl(item.model, item.model_id) : null;
	                    break;
	                case "pulse-delete":
	                    description.body = item.details.name;
	                    break;
	                case "segment-create":
	                    description.body = item.details.description;
	                    break;
	                case "segment-update":
	                    description.body = item.details.revision_message;
	                    break;
	                case "segment-delete":
	                    description.body = item.details.revision_message;
	                    break;
	            }
	
	            return description;
	        }
	    }, {
	        key: "initialsCssClasses",
	        value: function initialsCssClasses(user) {
	            var userColors = this.state.userColors;
	
	
	            if (user) {
	                var userColorIndex = userColors[user.id];
	                var colorCssClass = this.colorClasses[userColorIndex];
	
	                return colorCssClass;
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                activity = _props.activity,
	                user = _props.user;
	            var error = this.state.error;
	
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: !activity, error: error },
	                function () {
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "full flex flex-column" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "" },
	                            activity.length === 0 ? _react2.default.createElement(
	                                "div",
	                                { className: "flex flex-column layout-centered mt4" },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "QuestionCircle" },
	                                    "!"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "text-normal mt3 mb1" },
	                                    "Hmmm, looks like nothing has happened yet."
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "text-normal text-grey-2" },
	                                    "Save a question and get this baby going!"
	                                )
	                            ) : _react2.default.createElement(
	                                "ul",
	                                { className: "pb4 relative" },
	                                activity.map(function (item) {
	                                    return _react2.default.createElement(
	                                        "li",
	                                        { key: item.id, className: "mt3" },
	                                        _react2.default.createElement(_ActivityItem2.default, {
	                                            item: item,
	                                            description: _this2.activityHeader(item, user),
	                                            userColors: _this2.initialsCssClasses(item.user)
	                                        }),
	                                        _react2.default.createElement(_ActivityStory2.default, { story: _this2.activityStory(item) })
	                                    );
	                                })
	                            )
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return Activity;
	}(_react.Component), _class.propTypes = {
	    user: _propTypes2.default.object.isRequired,
	    activity: _propTypes2.default.array,
	    fetchActivity: _propTypes2.default.func.isRequired
	}, _temp);
	Activity.displayName = "Activity";
	exports.default = Activity;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _IconBorder = __webpack_require__(1289);
	
	var _IconBorder2 = _interopRequireDefault(_IconBorder);
	
	var _UserAvatar = __webpack_require__(1556);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityItem = (_temp = _class = function (_Component) {
	    _inherits(ActivityItem, _Component);
	
	    function ActivityItem() {
	        _classCallCheck(this, ActivityItem);
	
	        return _possibleConstructorReturn(this, (ActivityItem.__proto__ || Object.getPrototypeOf(ActivityItem)).apply(this, arguments));
	    }
	
	    _createClass(ActivityItem, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                item = _props.item,
	                description = _props.description,
	                userColors = _props.userColors;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'ml1 flex align-center mr2' },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    item.user ? _react2.default.createElement(_UserAvatar2.default, { user: item.user, background: userColors, style: { color: '#fff', borderWidth: '0' } }) : _react2.default.createElement(
	                        _IconBorder2.default,
	                        { style: { color: '#B8C0C8' } },
	                        _react2.default.createElement(_Icon2.default, { name: 'sync', size: 16 })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'ml2 full flex align-center' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-grey-4' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-dark' },
	                            description.userName
	                        ),
	                        '\xA0',
	                        description.summary
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex-align-right text-right text-grey-2' },
	                        description.timeSince
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ActivityItem;
	}(_react.Component), _class.propTypes = {
	    item: _propTypes2.default.object.isRequired,
	    description: _propTypes2.default.object.isRequired,
	    userColors: _propTypes2.default.string
	}, _temp);
	ActivityItem.displayName = 'ActivityItem';
	exports.default = ActivityItem;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityStory = (_temp = _class = function (_Component) {
	    _inherits(ActivityStory, _Component);
	
	    function ActivityStory(props, context) {
	        _classCallCheck(this, ActivityStory);
	
	        var _this = _possibleConstructorReturn(this, (ActivityStory.__proto__ || Object.getPrototypeOf(ActivityStory)).call(this, props, context));
	
	        _this.styles = {
	            borderWidth: '2px',
	            borderColor: '#DFE8EA'
	        };
	        return _this;
	    }
	
	    _createClass(ActivityStory, [{
	        key: "render",
	        value: function render() {
	            var story = this.props.story;
	
	
	            if (!story.body) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "mt1 border-left flex mr2", style: { borderWidth: '3px', marginLeft: '22px', borderColor: '#F2F5F6' } },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex full ml4 bordered rounded p2", style: this.styles },
	                    story.bodyLink ? _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: story.bodyLink, "data-metabase-event": "Activity Feed;Story Clicked;" + story.topic, className: "link" },
	                        story.body
	                    ) : _react2.default.createElement(
	                        "span",
	                        null,
	                        story.body
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ActivityStory;
	}(_react.Component), _class.propTypes = {
	    story: _propTypes2.default.object.isRequired
	}, _temp);
	ActivityStory.displayName = "ActivityStory";
	exports.default = ActivityStory;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SidebarSection = __webpack_require__(1585);
	
	var _SidebarSection2 = _interopRequireDefault(_SidebarSection);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _colors = __webpack_require__(881);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecentViews = (_temp = _class = function (_Component) {
	    _inherits(RecentViews, _Component);
	
	    function RecentViews() {
	        _classCallCheck(this, RecentViews);
	
	        return _possibleConstructorReturn(this, (RecentViews.__proto__ || Object.getPrototypeOf(RecentViews)).apply(this, arguments));
	    }
	
	    _createClass(RecentViews, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.props.fetchRecentViews();
	
	                            case 1:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "getIconName",
	        value: function getIconName(_ref2) {
	            var model = _ref2.model,
	                model_object = _ref2.model_object;
	
	            if (model === 'card' && 'display' in model_object) {
	                return model_object.display;
	            } else if (model === 'dashboard') {
	                return 'dashboard';
	            } else {
	                return null;
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var recentViews = this.props.recentViews;
	
	            return _react2.default.createElement(
	                _SidebarSection2.default,
	                { title: "Recently Viewed", icon: "clock" },
	                recentViews.length > 0 ? _react2.default.createElement(
	                    "ul",
	                    { className: "p2" },
	                    recentViews.map(function (item, index) {
	                        var iconName = _this2.getIconName(item);
	                        return _react2.default.createElement(
	                            "li",
	                            { key: index, className: "py1 ml1 flex align-center clearfix" },
	                            _react2.default.createElement(_Icon2.default, {
	                                name: iconName,
	                                size: 18,
	                                style: { color: iconName === 'dashboard' ? _colors.normal.purple : _colors.normal.blue }
	                            }),
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.modelToUrl(item.model, item.model_id), "data-metabase-event": "Recent Views;" + item.model + ";" + item.cnt, className: "ml1 flex-full link" },
	                                item.model_object.name
	                            )
	                        );
	                    })
	                ) : _react2.default.createElement(
	                    "div",
	                    { className: "flex flex-column layout-centered text-normal text-grey-2" },
	                    _react2.default.createElement(
	                        "p",
	                        { className: "p3 text-centered text-grey-2", style: { "maxWidth": "100%" } },
	                        "You haven't looked at any dashboards or questions recently"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RecentViews;
	}(_react.Component), _class.propTypes = {
	    fetchRecentViews: _propTypes2.default.func.isRequired,
	    recentViews: _propTypes2.default.array.isRequired
	}, _class.defaultProps = {
	    recentViews: []
	}, _temp);
	RecentViews.displayName = "RecentViews";
	exports.default = RecentViews;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidebarSection = function SidebarSection(_ref) {
	    var title = _ref.title,
	        icon = _ref.icon,
	        extra = _ref.extra,
	        children = _ref.children;
	    return _react2.default.createElement(
	        "div",
	        { className: "px2 pt1" },
	        _react2.default.createElement(
	            "div",
	            { className: "text-dark-grey clearfix pt2 pb2" },
	            _react2.default.createElement(_Icon2.default, { className: "float-left", name: icon, size: 18 }),
	            _react2.default.createElement(
	                "span",
	                { className: "pl1 Sidebar-header" },
	                title
	            ),
	            extra && _react2.default.createElement(
	                "span",
	                { className: "float-right" },
	                extra
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "rounded bg-white", style: { border: '1px solid #E5E5E5' } },
	            children
	        )
	    );
	};
	
	SidebarSection.displayName = "SidebarSection";
	exports.default = SidebarSection;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Smile = function (_Component) {
	    _inherits(Smile, _Component);
	
	    function Smile() {
	        _classCallCheck(this, Smile);
	
	        return _possibleConstructorReturn(this, (Smile.__proto__ || Object.getPrototypeOf(Smile)).apply(this, arguments));
	    }
	
	    _createClass(Smile, [{
	        key: 'render',
	        value: function render() {
	            var styles = {
	                width: '48px',
	                height: '48px',
	                backgroundImage: 'url("app/assets/img/smile.svg")'
	            };
	            return _react2.default.createElement('div', { style: styles });
	        }
	    }]);
	
	    return Smile;
	}(_react.Component);
	
	Smile.displayName = 'Smile';
	exports.default = Smile;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StepIndicators = __webpack_require__(1588);
	
	var _StepIndicators2 = _interopRequireDefault(_StepIndicators);
	
	var _reactRetinaImage = __webpack_require__(903);
	
	var _reactRetinaImage2 = _interopRequireDefault(_reactRetinaImage);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STEPS = [{
	    title: 'Ask questions and explore',
	    text: 'Click on charts or tables to explore, or ask a new question using the easy interface or the powerful SQL editor.',
	    image: _react2.default.createElement(_reactRetinaImage2.default, {
	        className: 'absolute full',
	        style: { top: 30 },
	        src: 'app/assets/img/welcome-modal-1.png'
	    })
	}, {
	    title: 'Make your own charts',
	    text: 'Create line charts, scatter plots, maps, and more.',
	    image: _react2.default.createElement(_reactRetinaImage2.default, {
	        className: 'absolute ml-auto mr-auto inline-block left right',
	        style: { bottom: -20 },
	        src: 'app/assets/img/welcome-modal-2.png'
	    })
	}, {
	    title: 'Share what you find',
	    text: 'Create powerful and flexible dashboards, and send regular updates via email or Slack.',
	    image: _react2.default.createElement(_reactRetinaImage2.default, {
	        className: 'absolute ml-auto mr-auto inline-block left right',
	        style: { bottom: -30 },
	        src: 'app/assets/img/welcome-modal-3.png'
	    })
	}];
	
	var NewUserOnboardingModal = function (_Component) {
	    _inherits(NewUserOnboardingModal, _Component);
	
	    function NewUserOnboardingModal() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NewUserOnboardingModal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewUserOnboardingModal.__proto__ || Object.getPrototypeOf(NewUserOnboardingModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            step: 1
	        }, _this.nextStep = function () {
	            var stepCount = _settings2.default.get("has_sample_dataset") ? 3 : 2;
	            var nextStep = _this.state.step + 1;
	
	            if (nextStep <= stepCount) {
	                _this.setState({ step: nextStep });
	            } else {
	                _this.props.onClose();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NewUserOnboardingModal, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var step = this.state.step;
	
	            var currentStep = STEPS[step - 1];
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(OnboardingImages, {
	                    currentStep: currentStep
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'p4 pb3 text-centered' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        currentStep.title
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'ml-auto mr-auto text-paragraph', style: { maxWidth: 420 } },
	                        currentStep.text
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex align-center py2 relative' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'ml-auto mr-auto' },
	                            _react2.default.createElement(_StepIndicators2.default, {
	                                currentStep: step,
	                                steps: STEPS,
	                                goToStep: function goToStep(step) {
	                                    return _this2.setState({ step: step });
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                className: 'link flex-align-right text-bold absolute right',
	                                onClick: function onClick() {
	                                    return _this2.nextStep();
	                                }
	                            },
	                            step === 3 ? 'Let\'s go' : 'Next'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NewUserOnboardingModal;
	}(_react.Component);
	
	NewUserOnboardingModal.displayName = 'NewUserOnboardingModal';
	exports.default = NewUserOnboardingModal;
	
	
	var OnboardingImages = function OnboardingImages(_ref2, _ref3) {
	    var currentStep = _ref2.currentStep;
	    var object = _ref3.currentStep;
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                position: 'relative',
	                backgroundColor: '#F5F9FE',
	                borderBottom: '1px solid #DCE1E4',
	                height: 254,
	                paddingTop: '3em',
	                paddingBottom: '3em'
	            } },
	        currentStep.image
	    );
	};
	OnboardingImages.displayName = 'OnboardingImages';

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(881);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StepIndicators = function StepIndicators(_ref) {
	    var _ref$activeDotColor = _ref.activeDotColor,
	        activeDotColor = _ref$activeDotColor === undefined ? _colors.normal.blue : _ref$activeDotColor,
	        _ref$currentStep = _ref.currentStep,
	        currentStep = _ref$currentStep === undefined ? 0 : _ref$currentStep,
	        _ref$dotSize = _ref.dotSize,
	        dotSize = _ref$dotSize === undefined ? 8 : _ref$dotSize,
	        goToStep = _ref.goToStep,
	        steps = _ref.steps;
	    return _react2.default.createElement(
	        'ol',
	        { className: 'flex' },
	        steps.map(function (step, index) {
	            return _react2.default.createElement('li', {
	                onClick: function onClick() {
	                    return goToStep && goToStep(index + 1);
	                },
	                style: {
	                    width: dotSize,
	                    height: dotSize,
	                    borderRadius: 99,
	                    cursor: 'pointer',
	                    marginLeft: 2,
	                    marginRight: 2,
	                    backgroundColor: index + 1 === currentStep ? activeDotColor : '#D8D8D8',
	                    transition: 'background 600ms ease-in'
	                },
	                key: index
	            });
	        })
	    );
	};
	
	StepIndicators.displayName = 'StepIndicators';
	exports.default = StepIndicators;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _services = __webpack_require__(857);
	
	var _SidebarSection = __webpack_require__(1585);
	
	var _SidebarSection2 = _interopRequireDefault(_SidebarSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NextStep = function (_Component) {
	    _inherits(NextStep, _Component);
	
	    function NextStep(props, context) {
	        _classCallCheck(this, NextStep);
	
	        var _this = _possibleConstructorReturn(this, (NextStep.__proto__ || Object.getPrototypeOf(NextStep)).call(this, props, context));
	
	        _this.state = {
	            next: null
	        };
	        return _this;
	    }
	
	    _createClass(NextStep, [{
	        key: "componentWillMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var sections, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, section, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, task;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _services.SetupApi.admin_checklist(null, { noEvent: true });
	
	                            case 2:
	                                sections = _context.sent;
	                                _iteratorNormalCompletion = true;
	                                _didIteratorError = false;
	                                _iteratorError = undefined;
	                                _context.prev = 6;
	                                _iterator = sections[Symbol.iterator]();
	
	                            case 8:
	                                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                                    _context.next = 40;
	                                    break;
	                                }
	
	                                section = _step.value;
	                                _iteratorNormalCompletion2 = true;
	                                _didIteratorError2 = false;
	                                _iteratorError2 = undefined;
	                                _context.prev = 13;
	                                _iterator2 = section.tasks[Symbol.iterator]();
	
	                            case 15:
	                                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
	                                    _context.next = 23;
	                                    break;
	                                }
	
	                                task = _step2.value;
	
	                                if (!task.is_next_step) {
	                                    _context.next = 20;
	                                    break;
	                                }
	
	                                this.setState({ next: task });
	                                return _context.abrupt("break", 23);
	
	                            case 20:
	                                _iteratorNormalCompletion2 = true;
	                                _context.next = 15;
	                                break;
	
	                            case 23:
	                                _context.next = 29;
	                                break;
	
	                            case 25:
	                                _context.prev = 25;
	                                _context.t0 = _context["catch"](13);
	                                _didIteratorError2 = true;
	                                _iteratorError2 = _context.t0;
	
	                            case 29:
	                                _context.prev = 29;
	                                _context.prev = 30;
	
	                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                    _iterator2.return();
	                                }
	
	                            case 32:
	                                _context.prev = 32;
	
	                                if (!_didIteratorError2) {
	                                    _context.next = 35;
	                                    break;
	                                }
	
	                                throw _iteratorError2;
	
	                            case 35:
	                                return _context.finish(32);
	
	                            case 36:
	                                return _context.finish(29);
	
	                            case 37:
	                                _iteratorNormalCompletion = true;
	                                _context.next = 8;
	                                break;
	
	                            case 40:
	                                _context.next = 46;
	                                break;
	
	                            case 42:
	                                _context.prev = 42;
	                                _context.t1 = _context["catch"](6);
	                                _didIteratorError = true;
	                                _iteratorError = _context.t1;
	
	                            case 46:
	                                _context.prev = 46;
	                                _context.prev = 47;
	
	                                if (!_iteratorNormalCompletion && _iterator.return) {
	                                    _iterator.return();
	                                }
	
	                            case 49:
	                                _context.prev = 49;
	
	                                if (!_didIteratorError) {
	                                    _context.next = 52;
	                                    break;
	                                }
	
	                                throw _iteratorError;
	
	                            case 52:
	                                return _context.finish(49);
	
	                            case 53:
	                                return _context.finish(46);
	
	                            case 54:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[6, 42, 46, 54], [13, 25, 29, 37], [30,, 32, 36], [47,, 49, 53]]);
	            }));
	
	            function componentWillMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var next = this.state.next;
	
	            if (next) {
	                return _react2.default.createElement(
	                    _SidebarSection2.default,
	                    { title: "Setup Tip", icon: "info", extra: _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/admin/settings", className: "text-brand no-decoration" },
	                            "View all"
	                        ) },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: next.link, className: "block p3 no-decoration" },
	                        _react2.default.createElement(
	                            "h4",
	                            { className: "text-brand text-bold" },
	                            next.title
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            { className: "m0 mt1" },
	                            next.description
	                        )
	                    )
	                );
	            } else {
	                return _react2.default.createElement("span", { className: "hide" });
	            }
	        }
	    }]);
	
	    return NextStep;
	}(_react.Component);
	
	NextStep.displayName = "NextStep";
	exports.default = NextStep;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchRecentViews = exports.fetchActivity = exports.FETCH_RECENT_VIEWS = exports.FETCH_ACTIVITY = undefined;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _redux = __webpack_require__(657);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// action constants
	var FETCH_ACTIVITY = exports.FETCH_ACTIVITY = 'FETCH_ACTIVITY';
	var FETCH_RECENT_VIEWS = exports.FETCH_RECENT_VIEWS = 'FETCH_RECENT_VIEWS';
	
	// action creators
	
	var fetchActivity = exports.fetchActivity = (0, _redux.createThunkAction)(FETCH_ACTIVITY, function () {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var activity, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ai;
	
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return _services.ActivityApi.list();
	
	                        case 2:
	                            activity = _context.sent;
	                            _iteratorNormalCompletion = true;
	                            _didIteratorError = false;
	                            _iteratorError = undefined;
	                            _context.prev = 6;
	
	                            for (_iterator = activity[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                ai = _step.value;
	
	                                ai.timestamp = (0, _moment2.default)(ai.timestamp);
	                                ai.hasLinkableModel = function () {
	                                    return _underscore2.default.contains(["card", "dashboard"], this.model);
	                                };
	                            }
	                            _context.next = 14;
	                            break;
	
	                        case 10:
	                            _context.prev = 10;
	                            _context.t0 = _context["catch"](6);
	                            _didIteratorError = true;
	                            _iteratorError = _context.t0;
	
	                        case 14:
	                            _context.prev = 14;
	                            _context.prev = 15;
	
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	
	                        case 17:
	                            _context.prev = 17;
	
	                            if (!_didIteratorError) {
	                                _context.next = 20;
	                                break;
	                            }
	
	                            throw _iteratorError;
	
	                        case 20:
	                            return _context.finish(17);
	
	                        case 21:
	                            return _context.finish(14);
	
	                        case 22:
	                            return _context.abrupt("return", activity);
	
	                        case 23:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[6, 10, 14, 22], [15,, 17, 21]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var fetchRecentViews = exports.fetchRecentViews = (0, _redux.createThunkAction)(FETCH_RECENT_VIEWS, function () {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var recentViews, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, v;
	
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.next = 2;
	                            return _services.ActivityApi.recent_views();
	
	                        case 2:
	                            recentViews = _context2.sent;
	                            _iteratorNormalCompletion2 = true;
	                            _didIteratorError2 = false;
	                            _iteratorError2 = undefined;
	                            _context2.prev = 6;
	
	                            for (_iterator2 = recentViews[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                                v = _step2.value;
	
	                                v.timestamp = (0, _moment2.default)(v.timestamp);
	                            }
	                            _context2.next = 14;
	                            break;
	
	                        case 10:
	                            _context2.prev = 10;
	                            _context2.t0 = _context2["catch"](6);
	                            _didIteratorError2 = true;
	                            _iteratorError2 = _context2.t0;
	
	                        case 14:
	                            _context2.prev = 14;
	                            _context2.prev = 15;
	
	                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                                _iterator2.return();
	                            }
	
	                        case 17:
	                            _context2.prev = 17;
	
	                            if (!_didIteratorError2) {
	                                _context2.next = 20;
	                                break;
	                            }
	
	                            throw _iteratorError2;
	
	                        case 20:
	                            return _context2.finish(17);
	
	                        case 21:
	                            return _context2.finish(14);
	
	                        case 22:
	                            return _context2.abrupt("return", recentViews);
	
	                        case 23:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[6, 10, 14, 22], [15,, 17, 21]]);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getActivity = exports.getActivity = function getActivity(state) {
	  return state.home && state.home.activity;
	};
	var getRecentViews = exports.getRecentViews = function getRecentViews(state) {
	  return state.home && state.home.recentViews;
	};
	var getUser = exports.getUser = function getUser(state) {
	  return state.currentUser;
	};

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Dashboards = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _DashboardList = __webpack_require__(1593);
	
	var _DashboardList2 = _interopRequireDefault(_DashboardList);
	
	var _TitleAndDescription = __webpack_require__(1595);
	
	var _TitleAndDescription2 = _interopRequireDefault(_TitleAndDescription);
	
	var _CreateDashboardModal = __webpack_require__(1596);
	
	var _CreateDashboardModal2 = _interopRequireDefault(_CreateDashboardModal);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SearchHeader = __webpack_require__(1598);
	
	var _SearchHeader2 = _interopRequireDefault(_SearchHeader);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _ListFilterWidget = __webpack_require__(1601);
	
	var _ListFilterWidget2 = _interopRequireDefault(_ListFilterWidget);
	
	var _string = __webpack_require__(955);
	
	var _dashboards = __webpack_require__(1521);
	
	var dashboardsActions = _interopRequireWildcard(_dashboards);
	
	var _selectors = __webpack_require__(1602);
	
	var _user = __webpack_require__(1127);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        dashboards: (0, _selectors.getDashboardListing)(state),
	        user: (0, _user.getUser)(state)
	    };
	};
	
	var mapDispatchToProps = dashboardsActions;
	
	var SECTION_ID_ALL = 'all';
	var SECTION_ID_MINE = 'mine';
	var SECTION_ID_FAVORITES = 'fav';
	
	var SECTIONS = [{
	    id: SECTION_ID_ALL,
	    name: 'All dashboards',
	    icon: 'dashboard'
	}, {
	    id: SECTION_ID_FAVORITES,
	    name: 'Favorites',
	    icon: 'star'
	}, {
	    id: SECTION_ID_MINE,
	    name: 'Saved by me',
	    icon: 'mine'
	}];
	
	var Dashboards = exports.Dashboards = function (_Component) {
	    _inherits(Dashboards, _Component);
	
	    function Dashboards() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Dashboards);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dashboards.__proto__ || Object.getPrototypeOf(Dashboards)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            modalOpen: false,
	            searchText: "",
	            section: SECTIONS[0]
	        }, _this.showCreateDashboard = function () {
	            _this.setState({ modalOpen: !_this.state.modalOpen });
	        }, _this.hideCreateDashboard = function () {
	            _this.setState({ modalOpen: false });
	        }, _this.searchTextFilter = function (searchText) {
	            return function (_ref2) {
	                var name = _ref2.name,
	                    description = _ref2.description;
	                return (0, _string.caseInsensitiveSearch)(name, searchText) || description && (0, _string.caseInsensitiveSearch)(description, searchText);
	            };
	        }, _this.sectionFilter = function (section) {
	            return function (_ref3) {
	                var creator_id = _ref3.creator_id,
	                    favorite = _ref3.favorite;
	                return section.id === SECTION_ID_ALL || section.id === SECTION_ID_MINE && creator_id === _this.props.user.id || section.id === SECTION_ID_FAVORITES && favorite === true;
	            };
	        }, _this.getFilteredDashboards = function () {
	            var _this$state = _this.state,
	                searchText = _this$state.searchText,
	                section = _this$state.section;
	            var dashboards = _this.props.dashboards;
	
	            var noOpFilter = _underscore2.default.constant(true);
	
	            return _underscore2.default.chain(dashboards).filter(searchText != "" ? _this.searchTextFilter(searchText) : noOpFilter).filter(_this.sectionFilter(section)).value().sort(function (a, b) {
	                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
	            });
	        }, _this.updateSection = function (section) {
	            _this.setState({ section: section });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Dashboards, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.fetchDashboards();
	        }
	    }, {
	        key: "onCreateDashboard",
	        value: function () {
	            var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(newDashboard) {
	                var createDashboard;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                createDashboard = this.props.createDashboard;
	                                _context.prev = 1;
	                                _context.next = 4;
	                                return createDashboard(newDashboard, { redirect: true });
	
	                            case 4:
	                                _context.next = 9;
	                                break;
	
	                            case 6:
	                                _context.prev = 6;
	                                _context.t0 = _context["catch"](1);
	
	                                console.log("createDashboard failed", _context.t0);
	
	                            case 9:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[1, 6]]);
	            }));
	
	            function onCreateDashboard(_x) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return onCreateDashboard;
	        }()
	    }, {
	        key: "renderCreateDashboardModal",
	        value: function renderCreateDashboardModal() {
	            return _react2.default.createElement(
	                _Modal2.default,
	                null,
	                _react2.default.createElement(_CreateDashboardModal2.default, {
	                    createDashboardFn: this.onCreateDashboard.bind(this),
	                    onClose: this.hideCreateDashboard })
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                modalOpen = _state.modalOpen,
	                searchText = _state.searchText,
	                section = _state.section;
	
	
	            var isLoading = this.props.dashboards === null;
	            var noDashboardsCreated = this.props.dashboards && this.props.dashboards.length === 0;
	            var filteredDashboards = isLoading ? [] : this.getFilteredDashboards();
	            var noResultsFound = filteredDashboards.length === 0;
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                {
	                    loading: isLoading,
	                    className: (0, _classnames2.default)("relative px4 full-height", { "flex flex-full flex-column": noDashboardsCreated }),
	                    noBackground: true
	                },
	                modalOpen ? this.renderCreateDashboardModal() : null,
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center pt4 pb1" },
	                    _react2.default.createElement(_TitleAndDescription2.default, { title: "Dashboards" }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-align-right cursor-pointer text-grey-5" },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/dashboards/archive" },
	                            _react2.default.createElement(_Icon2.default, { name: "viewArchive",
	                                className: "mr2 text-brand-hover",
	                                tooltip: "View the archive",
	                                size: 20 })
	                        ),
	                        !noDashboardsCreated && _react2.default.createElement(_Icon2.default, { name: "add",
	                            className: "text-brand-hover",
	                            tooltip: "Add new dashboard",
	                            size: 20,
	                            onClick: this.showCreateDashboard })
	                    )
	                ),
	                noDashboardsCreated ? _react2.default.createElement(
	                    "div",
	                    { className: "mt2 flex-full flex align-center justify-center" },
	                    _react2.default.createElement(_EmptyState2.default, {
	                        message: _react2.default.createElement(
	                            "span",
	                            null,
	                            "Put the charts and graphs you look at ",
	                            _react2.default.createElement("br", null),
	                            "frequently in a single, handy place."
	                        ),
	                        image: "/app/img/dashboard_illustration",
	                        action: "Create a dashboard",
	                        onActionClick: this.showCreateDashboard,
	                        className: "mt2",
	                        imageClassName: "mln2"
	                    })
	                ) : _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-full flex align-center pb1" },
	                        _react2.default.createElement(_SearchHeader2.default, {
	                            searchText: searchText,
	                            setSearchText: function setSearchText(text) {
	                                return _this2.setState({ searchText: text });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex-align-right" },
	                            _react2.default.createElement(_ListFilterWidget2.default, {
	                                items: SECTIONS.filter(function (item) {
	                                    return item.id !== "archived";
	                                }),
	                                activeItem: section,
	                                onChange: this.updateSection
	                            })
	                        )
	                    ),
	                    noResultsFound ? _react2.default.createElement(
	                        "div",
	                        { className: "flex justify-center" },
	                        _react2.default.createElement(_EmptyState2.default, {
	                            message: _react2.default.createElement(
	                                "div",
	                                { className: "mt4" },
	                                _react2.default.createElement(
	                                    "h3",
	                                    { className: "text-grey-5" },
	                                    "No results found"
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    { className: "text-grey-4" },
	                                    "Try adjusting your filter to find what you\u2019re looking for."
	                                )
	                            ),
	                            image: "/app/img/empty_dashboard",
	                            imageHeight: "210px",
	                            action: "Create a dashboard",
	                            imageClassName: "mln2",
	                            smallDescription: true
	                        })
	                    ) : _react2.default.createElement(_DashboardList2.default, { dashboards: filteredDashboards,
	                        setFavorited: this.props.setFavorited,
	                        setArchived: this.props.setArchived })
	                )
	            );
	        }
	    }]);
	
	    return Dashboards;
	}(_react.Component);
	
	Dashboards.displayName = "Dashboards";
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Dashboards);

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DashboardListItem = undefined;
	
	var _class2, _temp2;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Background = __webpack_require__(1594);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Ellipsified = __webpack_require__(1277);
	
	var _Ellipsified2 = _interopRequireDefault(_Ellipsified);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DashboardListItem = exports.DashboardListItem = function (_Component) {
	    _inherits(DashboardListItem, _Component);
	
	    function DashboardListItem() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DashboardListItem);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DashboardListItem.__proto__ || Object.getPrototypeOf(DashboardListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            hover: false,
	            fadingOut: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DashboardListItem, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                dashboard = _props.dashboard,
	                setFavorited = _props.setFavorited,
	                setArchived = _props.setArchived;
	            var _state = this.state,
	                hover = _state.hover,
	                fadingOut = _state.fadingOut;
	            var id = dashboard.id,
	                name = dashboard.name,
	                created_at = dashboard.created_at,
	                archived = dashboard.archived,
	                favorite = dashboard.favorite;
	
	
	            var archivalButton = _react2.default.createElement(
	                _Tooltip2.default,
	                { tooltip: archived ? "Unarchive" : "Archive" },
	                _react2.default.createElement(_Icon2.default, {
	                    className: "flex cursor-pointer text-light-blue text-brand-hover ml2 archival-button",
	                    name: archived ? "unarchive" : "archive",
	                    size: 21,
	                    onClick: function onClick(e) {
	                        e.preventDefault();
	
	                        // Let the 0.2s transition finish before the archival API call (`setArchived` action)
	                        _this2.setState({ fadingOut: true });
	                        setTimeout(function () {
	                            return setArchived(id, !archived, true);
	                        }, 300);
	                    }
	                })
	            );
	
	            var favoritingButton = _react2.default.createElement(
	                _Tooltip2.default,
	                { tooltip: favorite ? "Unfavorite" : "Favorite" },
	                _react2.default.createElement(_Icon2.default, {
	                    className: (0, _classnames2.default)("flex cursor-pointer ml2 favoriting-button", { "text-light-blue text-brand-hover": !favorite }, { "text-gold": favorite }),
	                    name: favorite ? "star" : "staroutline",
	                    size: 22,
	                    onClick: function onClick(e) {
	                        e.preventDefault();
	                        setFavorited(id, !favorite);
	                    }
	                })
	            );
	
	            var dashboardIcon = _react2.default.createElement(_Icon2.default, { name: "dashboard",
	                className: "ml2 text-grey-1",
	                size: 25 });
	
	            return _react2.default.createElement(
	                "li",
	                { className: "Grid-cell shrink-below-content-size", style: { maxWidth: "550px" } },
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: Urls.dashboard(id),
	                        "data-metabase-event": "Navbar;Dashboards;Open Dashboard;" + id,
	                        className: "flex align-center border-box p2 rounded no-decoration transition-background bg-white transition-all relative",
	                        style: {
	                            border: "1px solid rgba(220,225,228,0.50)",
	                            boxShadow: hover ? "0 3px 8px 0 rgba(220,220,220,0.50)" : "0 1px 3px 0 rgba(220,220,220,0.50)",
	                            height: "70px",
	                            opacity: fadingOut ? 0 : 1,
	                            top: fadingOut ? "10px" : 0
	                        },
	                        onMouseOver: function onMouseOver() {
	                            return _this2.setState({ hover: true });
	                        },
	                        onMouseLeave: function onMouseLeave() {
	                            return _this2.setState({ hover: false });
	                        } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-full shrink-below-content-size" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex align-center" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "flex-full shrink-below-content-size" },
	                                _react2.default.createElement(
	                                    "h3",
	                                    {
	                                        className: (0, _classnames2.default)("text-ellipsis text-nowrap overflow-hidden text-bold transition-all", { "text-slate": !hover }, { "text-brand": hover }),
	                                        style: { marginBottom: "0.3em" }
	                                    },
	                                    _react2.default.createElement(
	                                        _Ellipsified2.default,
	                                        null,
	                                        name
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    {
	                                        className: "text-smaller text-uppercase text-bold text-grey-3" },
	                                    (0, _moment2.default)(created_at).format('MMM D, YYYY')
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "flex align-center hidden" },
	                                hover && archivalButton,
	                                (favorite || hover) && favoritingButton,
	                                !hover && !favorite && dashboardIcon
	                            ),
	                            !favorite && _react2.default.createElement(
	                                "div",
	                                { className: "flex align-center absolute right transition-all",
	                                    style: { right: "16px", opacity: hover ? 0 : 1 } },
	                                dashboardIcon
	                            ),
	                            favorite && _react2.default.createElement(
	                                "div",
	                                { className: "flex align-center absolute right transition-all",
	                                    style: { right: "16px", opacity: 1 } },
	                                favoritingButton
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "flex align-center absolute right transition-all",
	                                    style: { right: "16px", opacity: hover ? 1 : 0 } },
	                                archivalButton,
	                                favoritingButton
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DashboardListItem;
	}(_react.Component);
	
	DashboardListItem.displayName = "DashboardListItem";
	var DashboardList = (_temp2 = _class2 = function (_Component2) {
	    _inherits(DashboardList, _Component2);
	
	    function DashboardList() {
	        _classCallCheck(this, DashboardList);
	
	        return _possibleConstructorReturn(this, (DashboardList.__proto__ || Object.getPrototypeOf(DashboardList)).apply(this, arguments));
	    }
	
	    _createClass(DashboardList, [{
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                dashboards = _props2.dashboards,
	                isArchivePage = _props2.isArchivePage,
	                setFavorited = _props2.setFavorited,
	                setArchived = _props2.setArchived;
	
	
	            return _react2.default.createElement(
	                "ol",
	                { className: "Grid Grid--guttersXl Grid--full small-Grid--1of2 md-Grid--1of3" },
	                dashboards.map(function (dash) {
	                    return _react2.default.createElement(DashboardListItem, { key: dash.id, dashboard: dash,
	                        setFavorited: setFavorited,
	                        setArchived: setArchived,
	                        disableLink: isArchivePage });
	                })
	            );
	        }
	    }]);
	
	    return DashboardList;
	}(_react.Component), _class2.propTypes = {
	    dashboards: _propTypes2.default.array.isRequired
	}, _temp2);
	DashboardList.displayName = "DashboardList";
	exports.default = (0, _Background.withBackground)('bg-slate-extra-light')(DashboardList);

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.withBackground = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withBackground = exports.withBackground = function withBackground(className) {
	    return function (ComposedComponent) {
	        var _class, _temp;
	
	        return _temp = _class = function (_Component) {
	            _inherits(_class, _Component);
	
	            function _class() {
	                _classCallCheck(this, _class);
	
	                return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	            }
	
	            _createClass(_class, [{
	                key: 'componentWillMount',
	                value: function componentWillMount() {
	                    document.body.classList.add(className);
	                }
	            }, {
	                key: 'componentWillUnmount',
	                value: function componentWillUnmount() {
	                    document.body.classList.remove(className);
	                }
	            }, {
	                key: 'render',
	                value: function render() {
	                    return _react2.default.createElement(ComposedComponent, this.props);
	                }
	            }]);
	
	            return _class;
	        }(_react.Component), _class.displayName = 'BackgroundApplicator', _temp;
	    };
	};

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TitleAndDescription = function TitleAndDescription(_ref) {
	    var title = _ref.title,
	        description = _ref.description,
	        className = _ref.className;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("flex align-center", className) },
	        _react2.default.createElement(
	            "h2",
	            { className: "mr1" },
	            title
	        ),
	        description && _react2.default.createElement(
	            _Tooltip2.default,
	            { tooltip: description, maxWidth: '22em' },
	            _react2.default.createElement(_Icon2.default, { name: "info", style: { marginTop: 3 } })
	        )
	    );
	};
	TitleAndDescription.displayName = "TitleAndDescription";
	exports.default = (0, _pure2.default)(TitleAndDescription);

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FormField = __webpack_require__(1597);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreateDashboardModal = (_temp = _class = function (_Component) {
	    _inherits(CreateDashboardModal, _Component);
	
	    function CreateDashboardModal(props, context) {
	        _classCallCheck(this, CreateDashboardModal);
	
	        var _this = _possibleConstructorReturn(this, (CreateDashboardModal.__proto__ || Object.getPrototypeOf(CreateDashboardModal)).call(this, props, context));
	
	        _this.createNewDash = _this.createNewDash.bind(_this);
	        _this.setDescription = _this.setDescription.bind(_this);
	        _this.setName = _this.setName.bind(_this);
	
	        _this.state = {
	            name: null,
	            description: null,
	            errors: null
	        };
	        return _this;
	    }
	
	    _createClass(CreateDashboardModal, [{
	        key: "setName",
	        value: function setName(event) {
	            this.setState({ name: event.target.value });
	        }
	    }, {
	        key: "setDescription",
	        value: function setDescription(event) {
	            this.setState({ description: event.target.value });
	        }
	    }, {
	        key: "createNewDash",
	        value: function createNewDash(event) {
	            event.preventDefault();
	
	            var name = this.state.name && this.state.name.trim();
	            var description = this.state.description && this.state.description.trim();
	
	            // populate a new Dash object
	            var newDash = {
	                name: name && name.length > 0 ? name : null,
	                description: description && description.length > 0 ? description : null
	            };
	
	            // create a new dashboard
	            var component = this;
	            this.props.createDashboardFn(newDash).then(null, function (error) {
	                component.setState({
	                    errors: error
	                });
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var formError;
	            if (this.state.errors) {
	                var errorMessage = "Server error encountered";
	                if (this.state.errors.data && this.state.errors.data.message) {
	                    errorMessage = this.state.errors.data.message;
	                }
	
	                // TODO: timeout display?
	                formError = _react2.default.createElement(
	                    "span",
	                    { className: "text-error px2" },
	                    errorMessage
	                );
	            }
	
	            var name = this.state.name && this.state.name.trim();
	
	            var formReady = name !== null && name !== "";
	
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    id: "CreateDashboardModal",
	                    title: "Create dashboard",
	                    footer: [formError, _react2.default.createElement(
	                        _Button2.default,
	                        { onClick: this.props.onClose },
	                        "Cancel"
	                    ), _react2.default.createElement(
	                        _Button2.default,
	                        { primary: formReady, disabled: !formReady, onClick: this.createNewDash },
	                        "Create"
	                    )],
	                    onClose: this.props.onClose
	                },
	                _react2.default.createElement(
	                    "form",
	                    { className: "Modal-form", onSubmit: this.createNewDash },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Form-inputs" },
	                        _react2.default.createElement(
	                            _FormField2.default,
	                            {
	                                displayName: "Name",
	                                fieldName: "name",
	                                errors: this.state.errors
	                            },
	                            _react2.default.createElement("input", { className: "Form-input full", name: "name", placeholder: "What is the name of your dashboard?", value: this.state.name, onChange: this.setName, autoFocus: true })
	                        ),
	                        _react2.default.createElement(
	                            _FormField2.default,
	                            {
	                                displayName: "Description",
	                                fieldName: "description",
	                                errors: this.state.errors
	                            },
	                            _react2.default.createElement("input", { className: "Form-input full", name: "description", placeholder: "It's optional but oh, so helpful", value: this.state.description, onChange: this.setDescription })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CreateDashboardModal;
	}(_react.Component), _class.propTypes = {
	    createDashboardFn: _propTypes2.default.func.isRequired,
	    onClose: _propTypes2.default.func
	}, _temp);
	CreateDashboardModal.displayName = "CreateDashboardModal";
	exports.default = CreateDashboardModal;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormField = (_temp = _class = function (_Component) {
	    _inherits(FormField, _Component);
	
	    function FormField() {
	        _classCallCheck(this, FormField);
	
	        return _possibleConstructorReturn(this, (FormField.__proto__ || Object.getPrototypeOf(FormField)).apply(this, arguments));
	    }
	
	    _createClass(FormField, [{
	        key: "getError",
	        value: function getError() {
	            if (this.props.error && this.props.visited !== false && this.props.active !== true) {
	                return this.props.error;
	            }
	
	            // legacy
	            if (this.props.errors && this.props.errors.data.errors && this.props.fieldName in this.props.errors.data.errors) {
	                return this.props.errors.data.errors[this.props.fieldName];
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var fieldErrorMessage = void 0;
	            var fieldError = this.getError();
	            if (fieldError) {
	                fieldErrorMessage = _react2.default.createElement(
	                    "span",
	                    { className: "text-error mx1" },
	                    fieldError
	                );
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("Form-field", { "Form--fieldError": fieldError }) },
	                _react2.default.createElement(
	                    "label",
	                    { className: "Form-label", htmlFor: this.props.name },
	                    this.props.displayName,
	                    " ",
	                    fieldErrorMessage
	                ),
	                this.props.children
	            );
	        }
	    }]);
	
	    return FormField;
	}(_react.Component), _class.propTypes = {
	    // redux-form compatible:
	    name: _propTypes2.default.string,
	    error: _propTypes2.default.any,
	    visited: _propTypes2.default.bool,
	    active: _propTypes2.default.bool,
	
	    displayName: _propTypes2.default.string.isRequired,
	
	    // legacy
	    fieldName: _propTypes2.default.string,
	    errors: _propTypes2.default.object
	}, _temp);
	FormField.displayName = "FormField";
	exports.default = FormField;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SearchHeader = __webpack_require__(1599);
	
	var _SearchHeader2 = _interopRequireDefault(_SearchHeader);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchHeader = function SearchHeader(_ref) {
	    var searchText = _ref.searchText,
	        setSearchText = _ref.setSearchText,
	        autoFocus = _ref.autoFocus,
	        inputRef = _ref.inputRef,
	        resetSearchText = _ref.resetSearchText;
	    return _react2.default.createElement(
	        "div",
	        { className: "flex align-center" },
	        _react2.default.createElement(_Icon2.default, { className: _SearchHeader2.default.searchIcon, name: "search", size: 18 }),
	        _react2.default.createElement("input", {
	            className: (0, _classnames2.default)("input bg-transparent", _SearchHeader2.default.searchBox),
	            type: "text",
	            placeholder: "Filter this list...",
	            value: searchText,
	            onChange: function onChange(e) {
	                return setSearchText(e.target.value);
	            },
	            autoFocus: !!autoFocus,
	            ref: inputRef || function () {}
	        }),
	        resetSearchText && searchText !== "" && _react2.default.createElement(_Icon2.default, {
	            name: "close",
	            className: "cursor-pointer text-grey-2",
	            size: 18,
	            onClick: resetSearchText
	        })
	    );
	}; /* eslint "react/prop-types": "warn" */
	SearchHeader.displayName = "SearchHeader";
	
	
	SearchHeader.propTypes = {
	    searchText: _propTypes2.default.string.isRequired,
	    setSearchText: _propTypes2.default.func.isRequired,
	    autoFocus: _propTypes2.default.bool,
	    inputRef: _propTypes2.default.func,
	    resetSearchText: _propTypes2.default.func
	};
	
	exports.default = SearchHeader;

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_1-Z9y _37W4X _2AJrG","searchIcon":"_3WCb_","searchBox":"_3VMyy _1RQS5"};

/***/ }),
/* 1600 */,
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// An UI element that is normally right-aligned and showing a currently selected filter together with chevron.
	// Clicking the element will trigger a popover showing all available filter options.
	
	var ListFilterWidget = function (_Component) {
	    _inherits(ListFilterWidget, _Component);
	
	    function ListFilterWidget() {
	        _classCallCheck(this, ListFilterWidget);
	
	        return _possibleConstructorReturn(this, (ListFilterWidget.__proto__ || Object.getPrototypeOf(ListFilterWidget)).apply(this, arguments));
	    }
	
	    _createClass(ListFilterWidget, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                items = _props.items,
	                activeItem = _props.activeItem,
	                onChange = _props.onChange;
	
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                {
	                    ref: function ref(p) {
	                        return _this2.popoverRef = p;
	                    },
	                    triggerClasses: "block ml-auto flex-no-shrink",
	                    targetOffsetY: 10,
	                    triggerElement: _react2.default.createElement(
	                        "div",
	                        { className: "ml2 flex align-center text-brand" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "text-bold" },
	                            activeItem && activeItem.name
	                        ),
	                        _react2.default.createElement(_Icon2.default, {
	                            ref: function ref(i) {
	                                return _this2.iconRef = i;
	                            },
	                            className: "ml1",
	                            name: "chevrondown",
	                            width: "12",
	                            height: "12"
	                        })
	                    ),
	                    target: function target() {
	                        return _this2.iconRef;
	                    }
	                },
	                _react2.default.createElement(
	                    "ol",
	                    { className: "text-brand mt2 mb1" },
	                    items.map(function (item, index) {
	                        return _react2.default.createElement(
	                            "li",
	                            {
	                                key: index,
	                                className: "cursor-pointer flex align-center brand-hover px2 py1 mb1",
	                                onClick: function onClick() {
	                                    onChange(item);
	                                    _this2.popoverRef.close();
	                                }
	                            },
	                            _react2.default.createElement(_Icon2.default, {
	                                className: "mr1 text-light-blue",
	                                name: item.icon
	                            }),
	                            _react2.default.createElement(
	                                "h4",
	                                { className: "List-item-title" },
	                                item.name
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ListFilterWidget;
	}(_react.Component);
	
	ListFilterWidget.displayName = "ListFilterWidget";
	exports.default = ListFilterWidget;

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDashboardListing = exports.getDashboardListing = function getDashboardListing(state) {
	  return state.dashboards.dashboardListing;
	};
	var getArchivedDashboards = exports.getArchivedDashboards = function getArchivedDashboards(state) {
	  return state.dashboards.archive;
	};

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Dashboards = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _HeaderWithBack = __webpack_require__(1604);
	
	var _HeaderWithBack2 = _interopRequireDefault(_HeaderWithBack);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _SearchHeader = __webpack_require__(1598);
	
	var _SearchHeader2 = _interopRequireDefault(_SearchHeader);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _ArchivedItem = __webpack_require__(1605);
	
	var _ArchivedItem2 = _interopRequireDefault(_ArchivedItem);
	
	var _string = __webpack_require__(955);
	
	var _dashboards = __webpack_require__(1521);
	
	var _selectors = __webpack_require__(1602);
	
	var _user = __webpack_require__(1127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        dashboards: (0, _selectors.getArchivedDashboards)(state),
	        isAdmin: (0, _user.getUserIsAdmin)(state, props)
	    };
	};
	
	var mapDispatchToProps = { fetchArchivedDashboards: _dashboards.fetchArchivedDashboards, setArchived: _dashboards.setArchived };
	
	var Dashboards = exports.Dashboards = function (_Component) {
	    _inherits(Dashboards, _Component);
	
	    function Dashboards() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Dashboards);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dashboards.__proto__ || Object.getPrototypeOf(Dashboards)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            searchText: ""
	        }, _this.searchTextFilter = function (searchText) {
	            return function (_ref2) {
	                var name = _ref2.name,
	                    description = _ref2.description;
	                return (0, _string.caseInsensitiveSearch)(name, searchText) || description && (0, _string.caseInsensitiveSearch)(description, searchText);
	            };
	        }, _this.getFilteredDashboards = function () {
	            var searchText = _this.state.searchText;
	            var dashboards = _this.props.dashboards;
	
	            var noOpFilter = _underscore2.default.constant(true);
	
	            return _underscore2.default.chain(dashboards).filter(searchText != "" ? _this.searchTextFilter(searchText) : noOpFilter).sortBy(function (dash) {
	                return dash.name.toLowerCase();
	            }).value().sort(function (a, b) {
	                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Dashboards, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.fetchArchivedDashboards();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var searchText = this.state.searchText;
	
	
	            var isLoading = this.props.dashboards === null;
	            var noDashboardsArchived = this.props.dashboards && this.props.dashboards.length === 0;
	            var filteredDashboards = isLoading ? [] : this.getFilteredDashboards();
	            var noSearchResults = searchText !== "" && filteredDashboards.length === 0;
	
	            var headerWithBackContainer = _react2.default.createElement(
	                "div",
	                { className: "flex align-center pt4 pb1" },
	                _react2.default.createElement(_HeaderWithBack2.default, { name: "Archive" })
	            );
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                {
	                    loading: isLoading,
	                    className: (0, _classnames2.default)("relative mx4", { "flex-full ": noDashboardsArchived })
	                },
	                noDashboardsArchived ? _react2.default.createElement(
	                    "div",
	                    null,
	                    headerWithBackContainer,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "full flex justify-center", style: { marginTop: "75px" } },
	                        _react2.default.createElement(_EmptyState2.default, {
	                            message: _react2.default.createElement(
	                                "span",
	                                null,
	                                "No dashboards have been",
	                                _react2.default.createElement("br", null),
	                                "archived yet"
	                            ),
	                            icon: "viewArchive"
	                        })
	                    )
	                ) : _react2.default.createElement(
	                    "div",
	                    null,
	                    headerWithBackContainer,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center pb1" },
	                        _react2.default.createElement(_SearchHeader2.default, {
	                            searchText: searchText,
	                            setSearchText: function setSearchText(text) {
	                                return _this2.setState({ searchText: text });
	                            }
	                        })
	                    ),
	                    noSearchResults ? _react2.default.createElement(
	                        "div",
	                        { className: "flex justify-center" },
	                        _react2.default.createElement(_EmptyState2.default, {
	                            message: _react2.default.createElement(
	                                "div",
	                                { className: "mt4" },
	                                _react2.default.createElement(
	                                    "h3",
	                                    { className: "text-grey-5" },
	                                    "No results found"
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    { className: "text-grey-4" },
	                                    "Try adjusting your filter to find what you\u2019re looking for."
	                                )
	                            ),
	                            image: "/app/img/empty_dashboard",
	                            imageClassName: "mln2",
	                            smallDescription: true
	                        })
	                    ) : _react2.default.createElement(
	                        "div",
	                        null,
	                        filteredDashboards.map(function (dashboard) {
	                            return _react2.default.createElement(_ArchivedItem2.default, { key: dashboard.id, name: dashboard.name, type: "dashboard",
	                                icon: "dashboard",
	                                isAdmin: true, onUnarchive: _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                                        while (1) {
	                                            switch (_context.prev = _context.next) {
	                                                case 0:
	                                                    _context.next = 2;
	                                                    return _this2.props.setArchived(dashboard.id, false);
	
	                                                case 2:
	                                                case "end":
	                                                    return _context.stop();
	                                            }
	                                        }
	                                    }, _callee, _this2);
	                                })) });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Dashboards;
	}(_react.Component);
	
	Dashboards.displayName = "Dashboards";
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Dashboards);

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TitleAndDescription = __webpack_require__(1595);
	
	var _TitleAndDescription2 = _interopRequireDefault(_TitleAndDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_BACK = function DEFAULT_BACK() {
	    return window.history.back();
	};
	
	var HeaderWithBack = function HeaderWithBack(_ref) {
	    var name = _ref.name,
	        description = _ref.description,
	        onBack = _ref.onBack;
	    return _react2.default.createElement(
	        "div",
	        { className: "flex align-center" },
	        (onBack || window.history.length > 1) && _react2.default.createElement(_Icon2.default, {
	            className: "cursor-pointer text-brand mr2 flex align-center circle p2 bg-light-blue bg-brand-hover text-white-hover transition-background transition-color",
	            name: "backArrow",
	            onClick: onBack || DEFAULT_BACK
	        }),
	        _react2.default.createElement(_TitleAndDescription2.default, {
	            title: name,
	            description: description
	        })
	    );
	};
	
	HeaderWithBack.displayName = "HeaderWithBack";
	HeaderWithBack.propTypes = {
	    name: _propTypes2.default.string.isRequired
	};
	
	exports.default = HeaderWithBack;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint "react/prop-types": "warn" */
	
	var ArchivedItem = function ArchivedItem(_ref) {
	    var name = _ref.name,
	        type = _ref.type,
	        icon = _ref.icon,
	        _ref$color = _ref.color,
	        color = _ref$color === undefined ? '#DEEAF1' : _ref$color,
	        _ref$isAdmin = _ref.isAdmin,
	        isAdmin = _ref$isAdmin === undefined ? false : _ref$isAdmin,
	        onUnarchive = _ref.onUnarchive;
	    return _react2.default.createElement(
	        "div",
	        { className: "flex align-center p2 hover-parent hover--visibility border-bottom bg-grey-0-hover" },
	        _react2.default.createElement(_Icon2.default, {
	            name: icon,
	            className: "mr2",
	            style: { color: color },
	            size: 20
	        }),
	        name,
	        isAdmin && _react2.default.createElement(
	            _Tooltip2.default,
	            { tooltip: "Unarchive this " + (type === "card" ? "question" : type) },
	            _react2.default.createElement(_Icon2.default, {
	                onClick: onUnarchive,
	                className: "ml-auto cursor-pointer text-brand-hover hover-child",
	                name: "unarchive"
	            })
	        )
	    );
	};
	
	ArchivedItem.displayName = "ArchivedItem";
	ArchivedItem.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    type: _propTypes2.default.string.isRequired,
	    icon: _propTypes2.default.string.isRequired,
	    color: _propTypes2.default.string,
	    isAdmin: _propTypes2.default.bool,
	    onUnarchive: _propTypes2.default.func.isRequired
	};
	
	exports.default = ArchivedItem;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _Title = __webpack_require__(1538);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Dashboard = __webpack_require__(1607);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _metadata = __webpack_require__(1110);
	
	var _app = __webpack_require__(864);
	
	var _selectors = __webpack_require__(1518);
	
	var _metadata2 = __webpack_require__(1073);
	
	var _user = __webpack_require__(1127);
	
	var _dashboard = __webpack_require__(1520);
	
	var dashboardActions = _interopRequireWildcard(_dashboard);
	
	var _dashboards = __webpack_require__(1521);
	
	var _browser = __webpack_require__(1188);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        dashboardId: props.params.dashboardId,
	
	        isAdmin: (0, _user.getUserIsAdmin)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        isEditingParameter: (0, _selectors.getIsEditingParameter)(state, props),
	        isDirty: (0, _selectors.getIsDirty)(state, props),
	        dashboard: (0, _selectors.getDashboardComplete)(state, props),
	        cards: (0, _selectors.getCardList)(state, props),
	        revisions: (0, _selectors.getRevisions)(state, props),
	        dashcardData: (0, _selectors.getCardData)(state, props),
	        slowCards: (0, _selectors.getSlowCards)(state, props),
	        databases: (0, _metadata2.getDatabases)(state, props),
	        editingParameter: (0, _selectors.getEditingParameter)(state, props),
	        parameters: (0, _selectors.getParameters)(state, props),
	        parameterValues: (0, _selectors.getParameterValues)(state, props),
	        metadata: (0, _metadata2.getMetadata)(state)
	    };
	};
	
	var mapDispatchToProps = _extends({}, dashboardActions, {
	    archiveDashboard: _dashboards.archiveDashboard,
	    fetchDatabaseMetadata: _metadata.fetchDatabaseMetadata,
	    setErrorPage: _app.setErrorPage,
	    onChangeLocation: _reactRouterRedux.push
	});
	
	var DashboardApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _Title2.default)(function (_ref) {
	    var dashboard = _ref.dashboard;
	    return dashboard && dashboard.name;
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(DashboardApp, _Component);
	
	    function DashboardApp() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DashboardApp);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = DashboardApp.__proto__ || Object.getPrototypeOf(DashboardApp)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	            addCardOnLoad: null
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DashboardApp, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            var options = (0, _browser.parseHashOptions)(window.location.hash);
	            if (options.add) {
	                this.setState({ addCardOnLoad: parseInt(options.add) });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_Dashboard2.default, _extends({ addCardOnLoad: this.state.addCardOnLoad }, this.props));
	        }
	    }]);
	
	    return DashboardApp;
	}(_react.Component)) || _class) || _class);
	DashboardApp.displayName = "DashboardApp";
	exports.default = DashboardApp;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DashboardHeader = __webpack_require__(1608);
	
	var _DashboardHeader2 = _interopRequireDefault(_DashboardHeader);
	
	var _DashboardGrid = __webpack_require__(1504);
	
	var _DashboardGrid2 = _interopRequireDefault(_DashboardGrid);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _Parameters = __webpack_require__(1189);
	
	var _Parameters2 = _interopRequireDefault(_Parameters);
	
	var _DashboardControls = __webpack_require__(1525);
	
	var _DashboardControls2 = _interopRequireDefault(_DashboardControls);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dashboard = (0, _DashboardControls2.default)(_class = (_temp2 = _class2 = function (_Component) {
	    _inherits(Dashboard, _Component);
	
	    function Dashboard() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Dashboard);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            error: null
	        }, _this.setEditing = function (isEditing) {
	            _this.props.onRefreshPeriodChange(null);
	            _this.props.setEditingDashboard(isEditing);
	        }, _this.setDashboardAttribute = function (attribute, value) {
	            _this.props.setDashboardAttributes({
	                id: _this.props.dashboard.id,
	                attributes: _defineProperty({}, attribute, value)
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Dashboard, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.loadDashboard(this.props.dashboardId);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.dashboardId !== nextProps.dashboardId) {
	                this.loadDashboard(nextProps.dashboardId);
	            } else if (!_underscore2.default.isEqual(this.props.parameterValues, nextProps.parameterValues) || !this.props.dashboard) {
	                this.props.fetchDashboardCardData({ reload: false, clear: true });
	            }
	        }
	    }, {
	        key: "loadDashboard",
	        value: function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dashboardId) {
	                var _props, addCardOnLoad, fetchDashboard, fetchCards, addCardToDashboard, setErrorPage, location;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.props.initialize();
	
	                                this.props.loadDashboardParams();
	                                _props = this.props, addCardOnLoad = _props.addCardOnLoad, fetchDashboard = _props.fetchDashboard, fetchCards = _props.fetchCards, addCardToDashboard = _props.addCardToDashboard, setErrorPage = _props.setErrorPage, location = _props.location;
	                                _context.prev = 3;
	                                _context.next = 6;
	                                return fetchDashboard(dashboardId, location.query);
	
	                            case 6:
	                                if (!(addCardOnLoad != null)) {
	                                    _context.next = 11;
	                                    break;
	                                }
	
	                                _context.next = 9;
	                                return fetchCards();
	
	                            case 9:
	                                this.setEditing(true);
	                                addCardToDashboard({ dashId: dashboardId, cardId: addCardOnLoad });
	
	                            case 11:
	                                _context.next = 16;
	                                break;
	
	                            case 13:
	                                _context.prev = 13;
	                                _context.t0 = _context["catch"](3);
	
	                                if (_context.t0.status === 404) {
	                                    setErrorPage(_extends({}, _context.t0, { context: "dashboard" }));
	                                } else {
	                                    console.error(_context.t0);
	                                    this.setState({ error: _context.t0 });
	                                }
	
	                            case 16:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[3, 13]]);
	            }));
	
	            function loadDashboard(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return loadDashboard;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                dashboard = _props2.dashboard,
	                isEditing = _props2.isEditing,
	                editingParameter = _props2.editingParameter,
	                parameters = _props2.parameters,
	                parameterValues = _props2.parameterValues,
	                location = _props2.location,
	                isFullscreen = _props2.isFullscreen,
	                isNightMode = _props2.isNightMode;
	            var error = this.state.error;
	
	            isNightMode = isNightMode && isFullscreen;
	
	            var parametersWidget = void 0;
	            if (parameters && parameters.length > 0) {
	                parametersWidget = _react2.default.createElement(_Parameters2.default, {
	                    syncQueryString: true,
	
	                    isEditing: isEditing,
	                    isFullscreen: isFullscreen,
	                    isNightMode: isNightMode,
	
	                    parameters: parameters.map(function (p) {
	                        return _extends({}, p, { value: parameterValues[p.id] });
	                    }),
	                    query: location.query,
	
	                    editingParameter: editingParameter,
	                    setEditingParameter: this.props.setEditingParameter,
	
	                    setParameterName: this.props.setParameterName,
	                    setParameterDefaultValue: this.props.setParameterDefaultValue,
	                    removeParameter: this.props.removeParameter,
	                    setParameterValue: this.props.setParameterValue
	                });
	            }
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { className: (0, _classnames2.default)("Dashboard flex-full pb4", { "Dashboard--fullscreen": isFullscreen, "Dashboard--night": isNightMode }), loading: !dashboard, error: error },
	                function () {
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "full", style: { overflowX: "hidden" } },
	                        _react2.default.createElement(
	                            "header",
	                            { className: "DashboardHeader relative z2" },
	                            _react2.default.createElement(_DashboardHeader2.default, _extends({}, _this2.props, {
	                                onEditingChange: _this2.setEditing,
	                                setDashboardAttribute: _this2.setDashboardAttribute,
	                                addParameter: _this2.props.addParameter,
	                                parametersWidget: parametersWidget
	                            }))
	                        ),
	                        !isFullscreen && parametersWidget && _react2.default.createElement(
	                            "div",
	                            { className: "wrapper flex flex-column align-start mt2 relative z2" },
	                            parametersWidget
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "wrapper" },
	                            dashboard.ordered_cards.length === 0 ? _react2.default.createElement(
	                                "div",
	                                { className: "absolute z1 top bottom left right flex flex-column layout-centered" },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "QuestionCircle" },
	                                    "?"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "text-normal mt3 mb1" },
	                                    "This dashboard is looking empty."
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "text-normal text-grey-2" },
	                                    "Add a question to start making it useful!"
	                                )
	                            ) : _react2.default.createElement(_DashboardGrid2.default, _extends({}, _this2.props, {
	                                onEditingChange: _this2.setEditing
	                            }))
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return Dashboard;
	}(_react.Component), _class2.propTypes = {
	    isEditable: _propTypes2.default.bool,
	    isEditing: _propTypes2.default.bool.isRequired,
	    isEditingParameter: _propTypes2.default.bool.isRequired,
	
	    dashboard: _propTypes2.default.object,
	    cards: _propTypes2.default.array,
	    parameters: _propTypes2.default.array,
	
	    addCardToDashboard: _propTypes2.default.func.isRequired,
	    archiveDashboard: _propTypes2.default.func.isRequired,
	    fetchCards: _propTypes2.default.func.isRequired,
	    fetchDashboard: _propTypes2.default.func.isRequired,
	    fetchRevisions: _propTypes2.default.func.isRequired,
	    revertToRevision: _propTypes2.default.func.isRequired,
	    saveDashboardAndCards: _propTypes2.default.func.isRequired,
	    setDashboardAttributes: _propTypes2.default.func.isRequired,
	    setEditingDashboard: _propTypes2.default.func.isRequired,
	
	    onUpdateDashCardVisualizationSettings: _propTypes2.default.func.isRequired,
	    onReplaceAllDashCardVisualizationSettings: _propTypes2.default.func.isRequired,
	
	    onChangeLocation: _propTypes2.default.func.isRequired
	}, _class2.defaultProps = {
	    isEditable: true
	}, _temp2)) || _class;
	
	Dashboard.displayName = "Dashboard";
	exports.default = Dashboard;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ActionButton = __webpack_require__(1213);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _AddToDashSelectQuestionModal = __webpack_require__(1609);
	
	var _AddToDashSelectQuestionModal2 = _interopRequireDefault(_AddToDashSelectQuestionModal);
	
	var _ArchiveDashboardModal = __webpack_require__(1643);
	
	var _ArchiveDashboardModal2 = _interopRequireDefault(_ArchiveDashboardModal);
	
	var _Header = __webpack_require__(1644);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _HistoryModal = __webpack_require__(1647);
	
	var _HistoryModal2 = _interopRequireDefault(_HistoryModal);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _DashboardEmbedWidget = __webpack_require__(1648);
	
	var _DashboardEmbedWidget2 = _interopRequireDefault(_DashboardEmbedWidget);
	
	var _DashboardActions = __webpack_require__(1527);
	
	var _ParametersPopover = __webpack_require__(1649);
	
	var _ParametersPopover2 = _interopRequireDefault(_ParametersPopover);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DashboardHeader = (_temp2 = _class = function (_Component) {
	    _inherits(DashboardHeader, _Component);
	
	    function DashboardHeader() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, DashboardHeader);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DashboardHeader.__proto__ || Object.getPrototypeOf(DashboardHeader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            modal: null
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DashboardHeader, [{
	        key: "onEdit",
	        value: function onEdit() {
	            this.props.onEditingChange(true);
	        }
	    }, {
	        key: "onDoneEditing",
	        value: function onDoneEditing() {
	            this.props.onEditingChange(false);
	        }
	    }, {
	        key: "onRevert",
	        value: function onRevert() {
	            this.props.fetchDashboard(this.props.dashboard.id, this.props.location.query);
	        }
	    }, {
	        key: "onSave",
	        value: function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.saveDashboardAndCards(this.props.dashboard.id);
	
	                            case 2:
	                                this.onDoneEditing();
	
	                            case 3:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function onSave() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return onSave;
	        }()
	    }, {
	        key: "onCancel",
	        value: function () {
	            var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                this.onRevert();
	                                this.onDoneEditing();
	
	                            case 2:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function onCancel() {
	                return _ref3.apply(this, arguments);
	            }
	
	            return onCancel;
	        }()
	    }, {
	        key: "onArchive",
	        value: function () {
	            var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return this.props.archiveDashboard(this.props.dashboard.id);
	
	                            case 2:
	                                this.props.onChangeLocation("/dashboards");
	
	                            case 3:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function onArchive() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return onArchive;
	        }()
	
	        // 1. fetch revisions
	
	    }, {
	        key: "onFetchRevisions",
	        value: function onFetchRevisions(_ref5) {
	            var entity = _ref5.entity,
	                id = _ref5.id;
	
	            return this.props.fetchRevisions({ entity: entity, id: id });
	        }
	
	        // 2. revert to a revision
	
	    }, {
	        key: "onRevertToRevision",
	        value: function onRevertToRevision(_ref6) {
	            var entity = _ref6.entity,
	                id = _ref6.id,
	                revision_id = _ref6.revision_id;
	
	            return this.props.revertToRevision({ entity: entity, id: id, revision_id: revision_id });
	        }
	
	        // 3. finished reverting to a revision
	
	    }, {
	        key: "onRevertedRevision",
	        value: function onRevertedRevision() {
	            this.refs.dashboardHistory.toggle();
	            this.props.fetchDashboard(this.props.dashboard.id, this.props.location.query);
	        }
	    }, {
	        key: "getEditingButtons",
	        value: function getEditingButtons() {
	            var _this2 = this;
	
	            return [_react2.default.createElement(
	                "a",
	                { "data-metabase-event": "Dashboard;Cancel Edits", key: "cancel", className: "Button Button--small", onClick: function onClick() {
	                        return _this2.onCancel();
	                    } },
	                "Cancel"
	            ), _react2.default.createElement(
	                _ModalWithTrigger2.default,
	                {
	                    key: "archive",
	                    ref: "archiveDashboardModal",
	                    triggerClasses: "Button Button--small",
	                    triggerElement: "Archive"
	                },
	                _react2.default.createElement(_ArchiveDashboardModal2.default, {
	                    dashboard: this.props.dashboard,
	                    onClose: function onClose() {
	                        return _this2.refs.archiveDashboardModal.toggle();
	                    },
	                    onArchive: function onArchive() {
	                        return _this2.onArchive();
	                    }
	                })
	            ), _react2.default.createElement(_ActionButton2.default, {
	                key: "save",
	                actionFn: function actionFn() {
	                    return _this2.onSave();
	                },
	                className: "Button Button--small Button--primary",
	                normalText: "Save",
	                activeText: "Saving\u2026",
	                failedText: "Save failed",
	                successText: "Saved"
	            })];
	        }
	    }, {
	        key: "getHeaderButtons",
	        value: function getHeaderButtons() {
	            var _this3 = this;
	
	            var _props = this.props,
	                dashboard = _props.dashboard,
	                parametersWidget = _props.parametersWidget,
	                isEditing = _props.isEditing,
	                isFullscreen = _props.isFullscreen,
	                isEditable = _props.isEditable,
	                isAdmin = _props.isAdmin;
	
	            var isEmpty = !dashboard || dashboard.ordered_cards.length === 0;
	            var canEdit = isEditable && !!dashboard;
	
	            var isPublicLinksEnabled = _settings2.default.get("public_sharing");
	            var isEmbeddingEnabled = _settings2.default.get("embedding");
	
	            var buttons = [];
	
	            if (isFullscreen && parametersWidget) {
	                buttons.push(parametersWidget);
	            }
	
	            if (isEditing) {
	                // Parameters
	                buttons.push(_react2.default.createElement(
	                    "span",
	                    null,
	                    _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: "Add a filter" },
	                        _react2.default.createElement(
	                            "a",
	                            {
	                                key: "parameters",
	                                className: (0, _classnames2.default)("text-brand-hover", { "text-brand": this.state.modal == "parameters" }),
	                                title: "Parameters",
	                                onClick: function onClick() {
	                                    return _this3.setState({ modal: "parameters" });
	                                }
	                            },
	                            _react2.default.createElement(_Icon2.default, { name: "funneladd", size: 16 })
	                        )
	                    ),
	                    this.state.modal && this.state.modal === "parameters" && _react2.default.createElement(
	                        _Popover2.default,
	                        { onClose: function onClose() {
	                                return _this3.setState({ modal: null });
	                            } },
	                        _react2.default.createElement(_ParametersPopover2.default, {
	                            onAddParameter: this.props.addParameter,
	                            onClose: function onClose() {
	                                return _this3.setState({ modal: null });
	                            }
	                        })
	                    )
	                ));
	
	                buttons.push(_react2.default.createElement(
	                    _ModalWithTrigger2.default,
	                    {
	                        key: "history",
	                        ref: "dashboardHistory",
	                        triggerElement: _react2.default.createElement(
	                            _Tooltip2.default,
	                            { tooltip: "Revision history" },
	                            _react2.default.createElement(
	                                "span",
	                                { "data-metabase-event": "Dashboard;Revisions" },
	                                _react2.default.createElement(_Icon2.default, { className: "text-brand-hover", name: "history", size: 16 })
	                            )
	                        )
	                    },
	                    _react2.default.createElement(_HistoryModal2.default, {
	                        entityType: "dashboard",
	                        entityId: dashboard.id,
	                        revisions: this.props.revisions["dashboard-" + dashboard.id],
	                        onFetchRevisions: this.onFetchRevisions.bind(this),
	                        onRevertToRevision: this.onRevertToRevision.bind(this),
	                        onClose: function onClose() {
	                            return _this3.refs.dashboardHistory.toggle();
	                        },
	                        onReverted: function onReverted() {
	                            return _this3.onRevertedRevision();
	                        }
	                    })
	                ));
	            }
	
	            if (!isFullscreen && !isEditing && canEdit) {
	                buttons.push(_react2.default.createElement(
	                    _Tooltip2.default,
	                    { tooltip: "Edit dashboard" },
	                    _react2.default.createElement(
	                        "a",
	                        { "data-metabase-event": "Dashboard;Edit", key: "edit", title: "Edit Dashboard Layout", className: "text-brand-hover cursor-pointer", onClick: function onClick() {
	                                return _this3.onEdit();
	                            } },
	                        _react2.default.createElement(_Icon2.default, { name: "pencil", size: 16 })
	                    )
	                ));
	            }
	
	            if (!isFullscreen && canEdit) {
	                buttons.push(_react2.default.createElement(
	                    _ModalWithTrigger2.default,
	                    {
	                        full: true,
	                        key: "add",
	                        ref: "addQuestionModal",
	                        triggerElement: _react2.default.createElement(
	                            _Tooltip2.default,
	                            { tooltip: "Add a question" },
	                            _react2.default.createElement(
	                                "span",
	                                { "data-metabase-event": "Dashboard;Add Card Modal", title: "Add a question to this dashboard" },
	                                _react2.default.createElement(_Icon2.default, { className: (0, _classnames2.default)("text-brand-hover cursor-pointer", { "Icon--pulse": isEmpty }), name: "add", size: 16 })
	                            )
	                        )
	                    },
	                    _react2.default.createElement(_AddToDashSelectQuestionModal2.default, {
	                        dashboard: dashboard,
	                        cards: this.props.cards,
	                        fetchCards: this.props.fetchCards,
	                        addCardToDashboard: this.props.addCardToDashboard,
	                        onEditingChange: this.props.onEditingChange,
	                        onClose: function onClose() {
	                            return _this3.refs.addQuestionModal.toggle();
	                        }
	                    })
	                ));
	            }
	
	            if (!isFullscreen && (isPublicLinksEnabled && (isAdmin || dashboard.public_uuid) || isEmbeddingEnabled && isAdmin)) {
	                buttons.push(_react2.default.createElement(_DashboardEmbedWidget2.default, { dashboard: dashboard }));
	            }
	
	            buttons.push.apply(buttons, _toConsumableArray((0, _DashboardActions.getDashboardActions)(this.props)));
	
	            return [buttons];
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var dashboard = this.props.dashboard;
	
	
	            return _react2.default.createElement(_Header2.default, {
	                headerClassName: "wrapper",
	                objectType: "dashboard",
	                item: dashboard,
	                isEditing: this.props.isEditing,
	                isEditingInfo: this.props.isEditing,
	                headerButtons: this.getHeaderButtons(),
	                editingTitle: "You are editing a dashboard",
	                editingButtons: this.getEditingButtons(),
	                setItemAttributeFn: this.props.setDashboardAttribute,
	                headerModalMessage: this.props.isEditingParameter ? "Select the field that should be filtered for each card" : null,
	                onHeaderModalDone: function onHeaderModalDone() {
	                    return _this4.props.setEditingParameter(null);
	                }
	            });
	        }
	    }]);
	
	    return DashboardHeader;
	}(_react.Component), _class.propTypes = {
	    dashboard: _propTypes2.default.object.isRequired,
	    revisions: _propTypes2.default.object.isRequired,
	    isEditable: _propTypes2.default.bool.isRequired,
	    isEditing: _propTypes2.default.bool.isRequired,
	    isFullscreen: _propTypes2.default.bool.isRequired,
	    isNightMode: _propTypes2.default.bool.isRequired,
	
	    refreshPeriod: _propTypes2.default.number,
	    refreshElapsed: _propTypes2.default.number,
	
	    addCardToDashboard: _propTypes2.default.func.isRequired,
	    archiveDashboard: _propTypes2.default.func.isRequired,
	    fetchCards: _propTypes2.default.func.isRequired,
	    fetchDashboard: _propTypes2.default.func.isRequired,
	    fetchRevisions: _propTypes2.default.func.isRequired,
	    revertToRevision: _propTypes2.default.func.isRequired,
	    saveDashboardAndCards: _propTypes2.default.func.isRequired,
	    setDashboardAttribute: _propTypes2.default.func.isRequired,
	
	    onEditingChange: _propTypes2.default.func.isRequired,
	    onRefreshPeriodChange: _propTypes2.default.func.isRequired,
	    onNightModeChange: _propTypes2.default.func.isRequired,
	    onFullscreenChange: _propTypes2.default.func.isRequired
	}, _temp2);
	DashboardHeader.displayName = "DashboardHeader";
	exports.default = DashboardHeader;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _AddToDashboard = __webpack_require__(1610);
	
	var _AddToDashboard2 = _interopRequireDefault(_AddToDashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddToDashSelectQuestionModal = (_temp = _class = function (_Component) {
	    _inherits(AddToDashSelectQuestionModal, _Component);
	
	    function AddToDashSelectQuestionModal(props, context) {
	        _classCallCheck(this, AddToDashSelectQuestionModal);
	
	        var _this = _possibleConstructorReturn(this, (AddToDashSelectQuestionModal.__proto__ || Object.getPrototypeOf(AddToDashSelectQuestionModal)).call(this, props, context));
	
	        _this.state = {
	            error: null
	        };
	        return _this;
	    }
	
	    _createClass(AddToDashSelectQuestionModal, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return this.props.fetchCards();
	
	                            case 3:
	                                _context.next = 9;
	                                break;
	
	                            case 5:
	                                _context.prev = 5;
	                                _context.t0 = _context["catch"](0);
	
	                                console.error(_context.t0);
	                                this.setState({ error: _context.t0 });
	
	                            case 9:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 5]]);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "onAdd",
	        value: function onAdd(card) {
	            this.props.addCardToDashboard({ dashId: this.props.dashboard.id, cardId: card.id });
	            this.props.onEditingChange(true);
	            this.props.onClose();
	            _analytics2.default.trackEvent("Dashboard", "Add Card");
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(_AddToDashboard2.default, {
	                onAdd: function onAdd(card) {
	                    return _this2.onAdd(card);
	                },
	                onClose: this.props.onClose
	            });
	        }
	    }]);
	
	    return AddToDashSelectQuestionModal;
	}(_react.Component), _class.propTypes = {
	    dashboard: _propTypes2.default.object.isRequired,
	    cards: _propTypes2.default.array,
	
	    fetchCards: _propTypes2.default.func.isRequired,
	    addCardToDashboard: _propTypes2.default.func.isRequired,
	    onEditingChange: _propTypes2.default.func.isRequired,
	
	    onClose: _propTypes2.default.func.isRequired
	}, _temp);
	AddToDashSelectQuestionModal.displayName = "AddToDashSelectQuestionModal";
	exports.default = AddToDashSelectQuestionModal;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _HeaderWithBack = __webpack_require__(1604);
	
	var _HeaderWithBack2 = _interopRequireDefault(_HeaderWithBack);
	
	var _CollectionList = __webpack_require__(1611);
	
	var _CollectionList2 = _interopRequireDefault(_CollectionList);
	
	var _EntityList = __webpack_require__(1614);
	
	var _EntityList2 = _interopRequireDefault(_EntityList);
	
	var _ExpandingSearchField = __webpack_require__(1642);
	
	var _ExpandingSearchField2 = _interopRequireDefault(_ExpandingSearchField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddToDashboard = function (_Component) {
	    _inherits(AddToDashboard, _Component);
	
	    function AddToDashboard(props, context) {
	        _classCallCheck(this, AddToDashboard);
	
	        var _this = _possibleConstructorReturn(this, (AddToDashboard.__proto__ || Object.getPrototypeOf(AddToDashboard)).call(this, props, context));
	
	        _this.state = {
	            collection: null,
	            query: null
	        };
	        return _this;
	    }
	
	    _createClass(AddToDashboard, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                query = _state.query,
	                collection = _state.collection;
	
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    title: "Pick a question to add",
	                    className: "px4 mb4 scroll-y",
	                    onClose: function onClose() {
	                        return _this2.props.onClose();
	                    }
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "py1" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center" },
	                        !query ? _react2.default.createElement(_ExpandingSearchField2.default, {
	                            defaultValue: query && query.q,
	                            onSearch: function onSearch(value) {
	                                return _this2.setState({
	                                    collection: null,
	                                    query: { q: value }
	                                });
	                            }
	                        }) : _react2.default.createElement(_HeaderWithBack2.default, {
	                            name: collection && collection.name,
	                            onBack: function onBack() {
	                                return _this2.setState({ collection: null, query: null });
	                            }
	                        }),
	                        query && _react2.default.createElement(
	                            "div",
	                            { className: "ml-auto flex align-center" },
	                            _react2.default.createElement(
	                                "h5",
	                                null,
	                                "Sort by"
	                            ),
	                            _react2.default.createElement(
	                                _Button2.default,
	                                { borderless: true },
	                                "Last modified"
	                            ),
	                            _react2.default.createElement(
	                                _Button2.default,
	                                { borderless: true },
	                                "Alphabetical order"
	                            )
	                        )
	                    )
	                ),
	                this.state.query ? _react2.default.createElement(_EntityList2.default, {
	                    entityType: "cards",
	                    entityQuery: this.state.query,
	                    editable: false,
	                    showSearchWidget: false,
	                    onEntityClick: this.props.onAdd
	                }) : _react2.default.createElement(
	                    _CollectionList2.default,
	                    null,
	                    function (collections) {
	                        return _react2.default.createElement(
	                            "ol",
	                            null,
	                            collections.map(function (collection, index) {
	                                return _react2.default.createElement(
	                                    "li",
	                                    {
	                                        className: "text-brand-hover flex align-center border-bottom cursor-pointer py1 md-py2",
	                                        key: index,
	                                        onClick: function onClick() {
	                                            return _this2.setState({
	                                                collection: collection,
	                                                query: { collection: collection.slug }
	                                            });
	                                        }
	                                    },
	                                    _react2.default.createElement(_Icon2.default, {
	                                        className: "mr2",
	                                        name: "all",
	                                        style: { color: collection.color }
	                                    }),
	                                    _react2.default.createElement(
	                                        "h3",
	                                        null,
	                                        collection.name
	                                    ),
	                                    _react2.default.createElement(_Icon2.default, {
	                                        className: "ml-auto",
	                                        name: "chevronright"
	                                    })
	                                );
	                            }),
	                            _react2.default.createElement(
	                                "li",
	                                {
	                                    className: "text-brand-hover flex align-center border-bottom cursor-pointer py1 md-py2",
	                                    onClick: function onClick() {
	                                        return _this2.setState({
	                                            collection: { name: "Everything else" },
	                                            query: { collection: "" }
	                                        });
	                                    }
	                                },
	                                _react2.default.createElement(_Icon2.default, {
	                                    className: "mr2",
	                                    name: "everything"
	                                }),
	                                _react2.default.createElement(
	                                    "h3",
	                                    null,
	                                    "Everything else"
	                                ),
	                                _react2.default.createElement(_Icon2.default, {
	                                    className: "ml-auto",
	                                    name: "chevronright"
	                                })
	                            )
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return AddToDashboard;
	}(_react.Component);
	
	AddToDashboard.displayName = "AddToDashboard";
	exports.default = AddToDashboard;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _selectors = __webpack_require__(1612);
	
	var _collections = __webpack_require__(1613);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        collections: props.writable ? (0, _selectors.getWritableCollections)(state, props) : (0, _selectors.getAllCollections)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    loadCollections: _collections.loadCollections
	};
	
	var Collections = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(Collections, _Component);
	
	    function Collections() {
	        _classCallCheck(this, Collections);
	
	        return _possibleConstructorReturn(this, (Collections.__proto__ || Object.getPrototypeOf(Collections)).apply(this, arguments));
	    }
	
	    _createClass(Collections, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.loadCollections();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var collectionList = this.props.children(this.props.collections);
	            return collectionList && _react2.default.Children.only(collectionList);
	        }
	    }]);
	
	    return Collections;
	}(_react.Component)) || _class);
	Collections.displayName = "Collections";
	exports.default = Collections;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSectionName = exports.getLabelsWithSelectedState = exports.getLabelsError = exports.getLabelsLoading = exports.getLabels = exports.getEditingLabelId = exports.getSections = exports.getSectionIsArchive = exports.getAllAreSelected = exports.getSelectedCount = exports.getVisibleCount = exports.getTotalCount = exports.getSelectedEntities = exports.getVisibleEntities = exports.getAllEntities = exports.makeGetItem = exports.getEntityIds = exports.getSectionError = exports.getSectionLoading = exports.getQuery = exports.getWritableCollections = exports.getAllCollections = exports.getSelectedIds = exports.getSearchText = exports.getItemsBySection = exports.getEntities = exports.getLoadingInitialEntities = exports.getSection = exports.getEntityQuery = exports.getEntityType = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__(1072);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _icepick = __webpack_require__(855);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _visualizations = __webpack_require__(1284);
	
	var _visualizations2 = _interopRequireDefault(_visualizations);
	
	var _string = __webpack_require__(955);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getEntityType = exports.getEntityType = function getEntityType(state, props) {
	    return props && props.entityType ? props.entityType : state.questions.lastEntityType;
	};
	var getEntityQuery = exports.getEntityQuery = function getEntityQuery(state, props) {
	    return props && props.entityQuery ? JSON.stringify(props.entityQuery) : state.questions.lastEntityQuery;
	};
	
	var getSection = exports.getSection = function getSection(state, props) {
	    return props.entityQuery && JSON.stringify(props.entityQuery);
	};
	var getLoadingInitialEntities = exports.getLoadingInitialEntities = function getLoadingInitialEntities(state, props) {
	    return state.questions.loadingInitialEntities;
	};
	var getEntities = exports.getEntities = function getEntities(state, props) {
	    return state.questions.entities;
	};
	var getItemsBySection = exports.getItemsBySection = function getItemsBySection(state, props) {
	    return state.questions.itemsBySection;
	};
	
	var getSearchText = exports.getSearchText = function getSearchText(state, props) {
	    return state.questions.searchText;
	};
	var getSelectedIds = exports.getSelectedIds = function getSelectedIds(state, props) {
	    return state.questions.selectedIds;
	};
	
	var getAllCollections = exports.getAllCollections = function getAllCollections(state, props) {
	    return state.collections.collections;
	};
	
	var getWritableCollections = exports.getWritableCollections = (0, _reselect.createSelector)([getAllCollections], function (collections) {
	    return _underscore2.default.filter(collections, function (collection) {
	        return collection.can_write;
	    });
	});
	
	var getQuery = exports.getQuery = (0, _reselect.createSelector)([getEntityQuery], function (entityQuery) {
	    return entityQuery && JSON.parse(entityQuery);
	});
	
	var getSectionData = (0, _reselect.createSelector)([getItemsBySection, getEntityType, getEntityQuery], function (itemsBySection, entityType, entityQuery) {
	    return (0, _icepick.getIn)(itemsBySection, [entityType, entityQuery]);
	});
	
	var getSectionLoading = exports.getSectionLoading = (0, _reselect.createSelector)([getSectionData], function (sectionData) {
	    return !(sectionData && sectionData.items);
	});
	
	var getSectionError = exports.getSectionError = (0, _reselect.createSelector)([getSectionData], function (sectionData) {
	    return sectionData && sectionData.error;
	});
	
	var getEntityIds = exports.getEntityIds = (0, _reselect.createSelector)([getSectionData], function (sectionData) {
	    return sectionData ? _underscore2.default.sortBy(sectionData.items, function (id) {
	        return sectionData.sortIndex[id] != null ? sectionData.sortIndex[id] : Infinity;
	    }) : [];
	});
	
	var getEntity = function getEntity(state, props) {
	    return getEntities(state, props)[props.entityType][props.entityId];
	};
	
	var getEntitySelected = function getEntitySelected(state, props) {
	    return getSelectedIds(state, props)[props.entityId] || false;
	};
	
	var getEntityVisible = function getEntityVisible(state, props) {
	    return (0, _string.caseInsensitiveSearch)(getEntity(state, props).name, getSearchText(state, props));
	};
	
	var getLabelEntities = function getLabelEntities(state, props) {
	    return state.labels.entities.labels;
	};
	
	var makeGetItem = exports.makeGetItem = function makeGetItem() {
	    var getItem = (0, _reselect.createSelector)([getEntity, getEntitySelected, getEntityVisible, getLabelEntities], function (entity, selected, visible, labelEntities) {
	        return {
	            name: entity.name,
	            id: entity.id,
	            created: entity.created_at ? (0, _moment2.default)(entity.created_at).fromNow() : null,
	            by: entity.creator && entity.creator.common_name,
	            icon: _visualizations2.default.get(entity.display).iconName,
	            favorite: entity.favorite,
	            archived: entity.archived,
	            collection: entity.collection,
	            labels: entity.labels ? entity.labels.map(function (labelId) {
	                return labelEntities[labelId];
	            }).filter(function (l) {
	                return l;
	            }) : [],
	            selected: selected,
	            visible: visible,
	            description: entity.description
	        };
	    });
	    return getItem;
	};
	
	var getAllEntities = exports.getAllEntities = (0, _reselect.createSelector)([getEntityIds, getEntityType, getEntities], function (entityIds, entityType, entities) {
	    return entityIds.map(function (entityId) {
	        return (0, _icepick.getIn)(entities, [entityType, entityId]);
	    });
	});
	
	var getVisibleEntities = exports.getVisibleEntities = (0, _reselect.createSelector)([getAllEntities, getSearchText], function (allEntities, searchText) {
	    return allEntities.filter(function (entity) {
	        return (0, _string.caseInsensitiveSearch)(entity.name, searchText);
	    });
	});
	
	var getSelectedEntities = exports.getSelectedEntities = (0, _reselect.createSelector)([getVisibleEntities, getSelectedIds], function (visibleEntities, selectedIds) {
	    return visibleEntities.filter(function (entity) {
	        return selectedIds[entity.id];
	    });
	});
	
	var getTotalCount = exports.getTotalCount = (0, _reselect.createSelector)([getAllEntities], function (entities) {
	    return entities.length;
	});
	
	var getVisibleCount = exports.getVisibleCount = (0, _reselect.createSelector)([getVisibleEntities], function (visibleEntities) {
	    return visibleEntities.length;
	});
	
	var getSelectedCount = exports.getSelectedCount = (0, _reselect.createSelector)([getSelectedEntities], function (selectedEntities) {
	    return selectedEntities.length;
	});
	
	var getAllAreSelected = exports.getAllAreSelected = (0, _reselect.createSelector)([getSelectedCount, getVisibleCount], function (selectedCount, visibleCount) {
	    return selectedCount === visibleCount && visibleCount > 0;
	});
	
	var getSectionIsArchive = exports.getSectionIsArchive = (0, _reselect.createSelector)([getQuery], function (query) {
	    return query && query.f === "archived";
	});
	
	var sections = [{ id: "all", name: "All questions", icon: "all" }, { id: "fav", name: "Favorites", icon: "star" }, { id: "recent", name: "Recently viewed", icon: "recents" }, { id: "mine", name: "Saved by me", icon: "mine" }, { id: "popular", name: "Most popular", icon: "popular" }];
	
	var getSections = exports.getSections = function getSections(state, props) {
	    return sections;
	};
	
	var getEditingLabelId = exports.getEditingLabelId = function getEditingLabelId(state, props) {
	    return state.labels.editing;
	};
	
	var getLabels = exports.getLabels = (0, _reselect.createSelector)([function (state, props) {
	    return state.labels.entities.labels;
	}, function (state, props) {
	    return state.labels.labelIds;
	}], function (labelEntities, labelIds) {
	    return labelIds ? labelIds.map(function (id) {
	        return labelEntities[id];
	    }).sort(function (a, b) {
	        return a.name.localeCompare(b.name);
	    }) : [];
	});
	
	var getLabelsLoading = exports.getLabelsLoading = function getLabelsLoading(state, props) {
	    return !state.labels.labelIds;
	};
	var getLabelsError = exports.getLabelsError = function getLabelsError(state, props) {
	    return state.labels.error;
	};
	
	var getLabelCountsForSelectedEntities = (0, _reselect.createSelector)([getSelectedEntities], function (entities) {
	    var counts = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = entities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var entity = _step.value;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = entity.labels[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var labelId = _step2.value;
	
	                    counts[labelId] = (counts[labelId] || 0) + 1;
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return counts;
	});
	
	var getLabelsWithSelectedState = exports.getLabelsWithSelectedState = (0, _reselect.createSelector)([getLabels, getSelectedCount, getLabelCountsForSelectedEntities], function (labels, selectedCount, counts) {
	    return labels.map(function (label) {
	        return _extends({}, label, {
	            count: counts[label.id],
	            selected: counts[label.id] === 0 || counts[label.id] == null ? false : counts[label.id] === selectedCount ? true : null
	        });
	    });
	});
	
	var getSectionName = exports.getSectionName = (0, _reselect.createSelector)([getSection, getSections, getLabels], function (sectionId, sections, labels) {
	    var match = sectionId && sectionId.match(/^(.*)-(.*)/);
	    if (match) {
	        if (match[1] === "label") {
	            var label = _underscore2.default.findWhere(labels, { slug: match[2] });
	            if (label && label.name) {
	                return label.name;
	            }
	        }
	    } else {
	        var section = _underscore2.default.findWhere(sections, { id: sectionId });
	        if (section) {
	            return section.name || "";
	        } else if (sectionId === "archived") {
	            return "Archive";
	        }
	    }
	    return "";
	});

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.deleteCollection = exports.setCollectionArchived = exports.saveCollection = exports.loadCollections = exports.loadCollection = exports.SET_COLLECTION_ARCHIVED = exports.DELETE_COLLECTION = exports.SAVE_COLLECTION = exports.LOAD_COLLECTIONS = exports.LOAD_COLLECTION = undefined;
	
	var _handleActions, _handleActions3;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(657);
	
	var _reduxForm = __webpack_require__(589);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var LOAD_COLLECTION = exports.LOAD_COLLECTION = 'metabase/collections/LOAD_COLLECTION';
	var LOAD_COLLECTIONS = exports.LOAD_COLLECTIONS = 'metabase/collections/LOAD_COLLECTIONS';
	var SAVE_COLLECTION = exports.SAVE_COLLECTION = 'metabase/collections/SAVE_COLLECTION';
	var DELETE_COLLECTION = exports.DELETE_COLLECTION = 'metabase/collections/DELETE_COLLECTION';
	var SET_COLLECTION_ARCHIVED = exports.SET_COLLECTION_ARCHIVED = 'metabase/collections/SET_COLLECTION_ARCHIVED';
	
	var loadCollection = exports.loadCollection = (0, _redux.createAction)(LOAD_COLLECTION, function (id) {
	    return _services.CollectionsApi.get({ id: id });
	});
	var loadCollections = exports.loadCollections = (0, _redux.createAction)(LOAD_COLLECTIONS, _services.CollectionsApi.list);
	
	var saveCollection = exports.saveCollection = (0, _redux.createThunkAction)(SAVE_COLLECTION, function (collection) {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            if (!collection.description) {
	                                // description must be nil or non empty string
	                                collection = _extends({}, collection, { description: null });
	                            }
	                            response = void 0;
	
	                            if (!(collection.id == null)) {
	                                _context.next = 10;
	                                break;
	                            }
	
	                            _analytics2.default.trackEvent("Collections", "Create");
	                            _context.next = 7;
	                            return _services.CollectionsApi.create(collection);
	
	                        case 7:
	                            response = _context.sent;
	                            _context.next = 14;
	                            break;
	
	                        case 10:
	                            _analytics2.default.trackEvent("Collections", "Update");
	                            _context.next = 13;
	                            return _services.CollectionsApi.update(collection);
	
	                        case 13:
	                            response = _context.sent;
	
	                        case 14:
	                            if (response.id != null) {
	                                dispatch((0, _reduxForm.reset)("collection"));
	                                // use `replace` so form url doesn't appear in history
	                                dispatch((0, _reactRouterRedux.replace)('/questions/'));
	                            }
	                            return _context.abrupt("return", response);
	
	                        case 18:
	                            _context.prev = 18;
	                            _context.t0 = _context["catch"](0);
	
	                            if (!(_context.t0.data && _context.t0.data.errors)) {
	                                _context.next = 24;
	                                break;
	                            }
	
	                            throw _context.t0.data.errors;
	
	                        case 24:
	                            if (!(_context.t0.data && _context.t0.data.message)) {
	                                _context.next = 28;
	                                break;
	                            }
	
	                            throw { _error: _context.t0.data.message };
	
	                        case 28:
	                            throw { _error: "An unknown error occured" };
	
	                        case 29:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 18]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var setCollectionArchived = exports.setCollectionArchived = (0, _redux.createThunkAction)(SET_COLLECTION_ARCHIVED, function (id, archived) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var collection;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _analytics2.default.trackEvent("Collections", "Set Archived", archived);
	                            // HACK: currently the only way to archive/unarchive a collection is to PUT it along with name/description/color, so grab it from the list
	                            _context2.t0 = _underscore2.default;
	                            _context2.next = 4;
	                            return _services.CollectionsApi.list({ archived: !archived });
	
	                        case 4:
	                            _context2.t1 = _context2.sent;
	                            _context2.t2 = { id: id };
	                            collection = _context2.t0.findWhere.call(_context2.t0, _context2.t1, _context2.t2);
	                            _context2.next = 9;
	                            return _services.CollectionsApi.update(_extends({}, collection, { archived: archived }));
	
	                        case 9:
	                            return _context2.abrupt("return", _context2.sent);
	
	                        case 10:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	var deleteCollection = exports.deleteCollection = (0, _redux.createThunkAction)(DELETE_COLLECTION, function (id) {
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	
	                            _analytics2.default.trackEvent("Collections", "Delete");
	                            _context3.next = 4;
	                            return _services.CollectionsApi.delete({ id: id });
	
	                        case 4:
	                            return _context3.abrupt("return", id);
	
	                        case 7:
	                            _context3.prev = 7;
	                            _context3.t0 = _context3["catch"](0);
	                            return _context3.abrupt("return", null);
	
	                        case 10:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[0, 7]]);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	});
	
	var collections = (0, _redux.handleActions)((_handleActions = {}, _defineProperty(_handleActions, LOAD_COLLECTIONS, { next: function next(state, _ref4) {
	        var payload = _ref4.payload;
	        return payload;
	    } }), _defineProperty(_handleActions, SAVE_COLLECTION, { next: function next(state, _ref5) {
	        var payload = _ref5.payload;
	        return state.filter(function (c) {
	            return c.id !== payload.id;
	        }).concat(payload);
	    } }), _defineProperty(_handleActions, DELETE_COLLECTION, { next: function next(state, _ref6) {
	        var payload = _ref6.payload;
	        return state.filter(function (c) {
	            return c.id !== payload;
	        });
	    } }), _defineProperty(_handleActions, SET_COLLECTION_ARCHIVED, { next: function next(state, _ref7) {
	        var payload = _ref7.payload;
	        return state.filter(function (c) {
	            return c.id !== payload.id;
	        });
	    } }), _handleActions), []);
	
	var error = (0, _redux.handleActions)(_defineProperty({}, SAVE_COLLECTION, {
	    next: function next(state) {
	        return null;
	    },
	    throw: function _throw(state, _ref8) {
	        var error = _ref8.error;
	        return error;
	    }
	}), null);
	
	var collection = (0, _redux.handleActions)((_handleActions3 = {}, _defineProperty(_handleActions3, LOAD_COLLECTION, {
	    next: function next(state, _ref9) {
	        var payload = _ref9.payload;
	        return payload;
	    }
	}), _defineProperty(_handleActions3, SAVE_COLLECTION, {
	    next: function next(state, _ref10) {
	        var payload = _ref10.payload;
	        return payload;
	    }
	}), _handleActions3), null);
	
	exports.default = (0, _redux.combineReducers)({
	    collection: collection,
	    collections: collections,
	    error: error
	});

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(467);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _ListFilterWidget = __webpack_require__(1601);
	
	var _ListFilterWidget2 = _interopRequireDefault(_ListFilterWidget);
	
	var _List = __webpack_require__(1615);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _List3 = __webpack_require__(1618);
	
	var _List4 = _interopRequireDefault(_List3);
	
	var _SearchHeader = __webpack_require__(1598);
	
	var _SearchHeader2 = _interopRequireDefault(_SearchHeader);
	
	var _ActionHeader = __webpack_require__(1630);
	
	var _ActionHeader2 = _interopRequireDefault(_ActionHeader);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _questions = __webpack_require__(1622);
	
	var _labels = __webpack_require__(1641);
	
	var _selectors = __webpack_require__(1612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        section: (0, _selectors.getSection)(state, props),
	        entityIds: (0, _selectors.getEntityIds)(state, props),
	        loading: (0, _selectors.getSectionLoading)(state, props),
	        error: (0, _selectors.getSectionError)(state, props),
	
	        searchText: (0, _selectors.getSearchText)(state, props),
	
	        visibleCount: (0, _selectors.getVisibleCount)(state, props),
	        selectedCount: (0, _selectors.getSelectedCount)(state, props),
	        allAreSelected: (0, _selectors.getAllAreSelected)(state, props),
	        sectionIsArchive: (0, _selectors.getSectionIsArchive)(state, props),
	
	        labels: (0, _selectors.getLabelsWithSelectedState)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    setItemSelected: _questions.setItemSelected,
	    setAllSelected: _questions.setAllSelected,
	    setSearchText: _questions.setSearchText,
	    setArchived: _questions.setArchived,
	    loadEntities: _questions.loadEntities,
	    loadLabels: _labels.loadLabels
	};
	
	var SECTIONS = [{
	    id: 'all',
	    name: 'All questions',
	    icon: 'all',
	    empty: 'No questions have been saved yet.'
	}, {
	    id: 'fav',
	    name: 'Favorites',
	    icon: 'star',
	    empty: 'You haven\'t favorited any questions yet.'
	}, {
	    id: 'recent',
	    name: 'Recently viewed',
	    icon: 'recents',
	    empty: 'You haven\'t viewed any questions recently.'
	}, {
	    id: 'mine',
	    name: 'Saved by me',
	    icon: 'mine',
	    empty: 'You haven\'t saved any questions yet.'
	}, {
	    id: 'popular',
	    name: 'Most popular',
	    icon: 'popular',
	    empty: 'The most viewed questions across your company will show up here.'
	}, {
	    id: 'archived',
	    name: "Archive",
	    icon: 'archive',
	    empty: 'If you no longer need a question, you can archive it.'
	}];
	
	var DEFAULT_SECTION = {
	    icon: 'all',
	    empty: 'There aren\'t any questions matching that criteria.'
	};
	
	var EntityList = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(EntityList, _Component);
	
	    function EntityList() {
	        _classCallCheck(this, EntityList);
	
	        return _possibleConstructorReturn(this, (EntityList.__proto__ || Object.getPrototypeOf(EntityList)).apply(this, arguments));
	    }
	
	    _createClass(EntityList, [{
	        key: "componentDidUpdate",
	        value: function componentDidUpdate(prevProps) {
	            // Scroll to the top of the list if the section changed
	            // A little hacky, something like https://github.com/taion/scroll-behavior might be better
	            if (this.props.section !== prevProps.section) {
	                _reactDom2.default.findDOMNode(this).scrollTop = 0;
	            }
	        }
	    }, {
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.loadLabels();
	            this.props.loadEntities(this.props.entityType, this.props.entityQuery);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (!_underscore2.default.isEqual(this.props.entityQuery, nextProps.entityQuery) || nextProps.entityType !== this.props.entityType) {
	                this.props.loadEntities(nextProps.entityType, nextProps.entityQuery);
	            }
	        }
	    }, {
	        key: "getSection",
	        value: function getSection() {
	            return _underscore2.default.findWhere(SECTIONS, { id: this.props.entityQuery && this.props.entityQuery.f || "all" }) || DEFAULT_SECTION;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                style = _props.style,
	                loading = _props.loading,
	                error = _props.error,
	                entityType = _props.entityType,
	                entityIds = _props.entityIds,
	                searchText = _props.searchText,
	                setSearchText = _props.setSearchText,
	                showSearchWidget = _props.showSearchWidget,
	                visibleCount = _props.visibleCount,
	                selectedCount = _props.selectedCount,
	                allAreSelected = _props.allAreSelected,
	                sectionIsArchive = _props.sectionIsArchive,
	                labels = _props.labels,
	                setItemSelected = _props.setItemSelected,
	                setAllSelected = _props.setAllSelected,
	                setArchived = _props.setArchived,
	                onChangeSection = _props.onChangeSection,
	                showCollectionName = _props.showCollectionName,
	                editable = _props.editable,
	                onEntityClick = _props.onEntityClick;
	
	
	            var section = this.getSection();
	
	            var hasEntitiesInPlainState = entityIds.length > 0 || section.section !== "all";
	
	            var showActionHeader = editable && selectedCount > 0;
	            var showSearchHeader = hasEntitiesInPlainState && showSearchWidget;
	            var showEntityFilterWidget = onChangeSection;
	
	            return _react2.default.createElement(
	                "div",
	                { style: style },
	                (showActionHeader || showSearchHeader || showEntityFilterWidget) && _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center my1", style: { height: 40 } },
	                    showActionHeader ? _react2.default.createElement(_ActionHeader2.default, {
	                        visibleCount: visibleCount,
	                        selectedCount: selectedCount,
	                        allAreSelected: allAreSelected,
	                        sectionIsArchive: sectionIsArchive,
	                        setAllSelected: setAllSelected,
	                        setArchived: setArchived,
	                        labels: labels
	                    }) : showSearchHeader ? _react2.default.createElement(
	                        "div",
	                        { style: { marginLeft: "10px" } },
	                        _react2.default.createElement(_SearchHeader2.default, {
	                            searchText: searchText,
	                            setSearchText: setSearchText
	                        })
	                    ) : null,
	                    showEntityFilterWidget && hasEntitiesInPlainState && _react2.default.createElement(_ListFilterWidget2.default, {
	                        items: SECTIONS.filter(function (item) {
	                            return item.id !== "archived";
	                        }),
	                        activeItem: section,
	                        onChange: function onChange(item) {
	                            return onChangeSection(item.id);
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { className: "full", loading: !error && loading, error: error },
	                    function () {
	                        return entityIds.length > 0 ? _react2.default.createElement(_List4.default, {
	                            entityType: entityType,
	                            entityIds: entityIds,
	                            editable: editable,
	                            setItemSelected: setItemSelected,
	                            onEntityClick: onEntityClick,
	                            showCollectionName: showCollectionName
	                        }) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_EmptyState2.default, { message: section.id === "all" && _this2.props.defaultEmptyState ? _this2.props.defaultEmptyState : section.empty, icon: section.icon })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return EntityList;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object,
	
	    entityQuery: _propTypes2.default.object.isRequired,
	    entityType: _propTypes2.default.string.isRequired,
	
	    section: _propTypes2.default.string,
	    loading: _propTypes2.default.bool.isRequired,
	    error: _propTypes2.default.any,
	    entityIds: _propTypes2.default.array.isRequired,
	    searchText: _propTypes2.default.string.isRequired,
	    setSearchText: _propTypes2.default.func.isRequired,
	    visibleCount: _propTypes2.default.number.isRequired,
	    selectedCount: _propTypes2.default.number.isRequired,
	    allAreSelected: _propTypes2.default.bool.isRequired,
	    sectionIsArchive: _propTypes2.default.bool.isRequired,
	    labels: _propTypes2.default.array.isRequired,
	    setItemSelected: _propTypes2.default.func.isRequired,
	    setAllSelected: _propTypes2.default.func.isRequired,
	    setArchived: _propTypes2.default.func.isRequired,
	
	    loadEntities: _propTypes2.default.func.isRequired,
	    loadLabels: _propTypes2.default.func.isRequired,
	
	    onEntityClick: _propTypes2.default.func,
	    onChangeSection: _propTypes2.default.func,
	    showSearchWidget: _propTypes2.default.bool.isRequired,
	    showCollectionName: _propTypes2.default.bool.isRequired,
	    editable: _propTypes2.default.bool.isRequired,
	
	    defaultEmptyState: _propTypes2.default.string
	}, _class2.defaultProps = {
	    showSearchWidget: true,
	    showCollectionName: true,
	    editable: true
	}, _temp)) || _class);
	EntityList.displayName = "EntityList";
	exports.default = EntityList;

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_3LQ64 _37W4X _2AJrG _1PyuO _37W4X _2AJrG","list":"bQKSq OPZ6L xdpBZ","list-wrapper":"_2Ydkd OPZ6L xdpBZ","empty":"_1JV60 _38618 _3Dqep _1X7sA _1b0Gt","item":"_11yCM _2Hk-A _38618 _3Dqep _18-EI","itemBody":"_3wIie _2kZNz","itemTitle":"_2nDq4 _3TD8R","itemName":"_1Q1yt _3K4no CO6xt","itemSubtitle":"_2GXvv","itemSubtitleBold":"_3q1Jt","open":"iQVSf","tagIcon":"LUqOT"};

/***/ }),
/* 1616 */,
/* 1617 */,
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(1615);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _EntityItem = __webpack_require__(1619);
	
	var _EntityItem2 = _interopRequireDefault(_EntityItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint "react/prop-types": "warn" */
	
	
	var List = function List(_ref) {
	    var entityIds = _ref.entityIds,
	        props = _objectWithoutProperties(_ref, ["entityIds"]);
	
	    return _react2.default.createElement(
	        "ul",
	        { className: _List2.default.list },
	        entityIds.map(function (entityId) {
	            return _react2.default.createElement(_EntityItem2.default, _extends({ key: entityId, entityId: entityId }, props));
	        })
	    );
	};
	
	List.displayName = "List";
	List.propTypes = {
	    entityIds: _propTypes2.default.array.isRequired
	};
	
	exports.default = (0, _pure2.default)(List);

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Item = __webpack_require__(1620);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _questions = __webpack_require__(1622);
	
	var _selectors = __webpack_require__(1612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var makeMapStateToProps = function makeMapStateToProps() {
	    var getItem = (0, _selectors.makeGetItem)();
	    var mapStateToProps = function mapStateToProps(state, props) {
	        return {
	            item: getItem(state, props)
	        };
	    };
	    return mapStateToProps;
	};
	
	var mapDispatchToProps = {
	    setItemSelected: _questions.setItemSelected,
	    setFavorited: _questions.setFavorited,
	    setArchived: _questions.setArchived
	};
	
	var EntityItem = (_dec = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(EntityItem, _Component);
	
	    function EntityItem() {
	        _classCallCheck(this, EntityItem);
	
	        return _possibleConstructorReturn(this, (EntityItem.__proto__ || Object.getPrototypeOf(EntityItem)).apply(this, arguments));
	    }
	
	    _createClass(EntityItem, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                item = _props.item,
	                editable = _props.editable,
	                setItemSelected = _props.setItemSelected,
	                setFavorited = _props.setFavorited,
	                setArchived = _props.setArchived,
	                onMove = _props.onMove,
	                onEntityClick = _props.onEntityClick,
	                showCollectionName = _props.showCollectionName;
	
	            return _react2.default.createElement(
	                "li",
	                { className: "relative", style: { display: item.visible ? undefined : "none" } },
	                _react2.default.createElement(_Item2.default, _extends({
	                    setItemSelected: editable ? setItemSelected : null,
	                    setFavorited: editable ? setFavorited : null,
	                    setArchived: editable ? setArchived : null,
	                    onMove: editable ? onMove : null,
	                    onEntityClick: onEntityClick,
	                    showCollectionName: showCollectionName,
	                    entity: item
	                }, item))
	            );
	        }
	    }]);
	
	    return EntityItem;
	}(_react.Component), _class2.propTypes = {
	    item: _propTypes2.default.object.isRequired,
	    setItemSelected: _propTypes2.default.func.isRequired,
	    setFavorited: _propTypes2.default.func.isRequired,
	    setArchived: _propTypes2.default.func.isRequired,
	    editable: _propTypes2.default.bool,
	    showCollectionName: _propTypes2.default.bool,
	    onEntityClick: _propTypes2.default.func,
	    onMove: _propTypes2.default.func
	}, _temp)) || _class);
	EntityItem.displayName = "EntityItem";
	exports.default = EntityItem;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _List = __webpack_require__(1615);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _CheckBox = __webpack_require__(1004);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _MoveToCollection = __webpack_require__(1621);
	
	var _MoveToCollection2 = _interopRequireDefault(_MoveToCollection);
	
	var _Labels = __webpack_require__(1623);
	
	var _Labels2 = _interopRequireDefault(_Labels);
	
	var _CollectionBadge = __webpack_require__(1629);
	
	var _CollectionBadge2 = _interopRequireDefault(_CollectionBadge);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint "react/prop-types": "warn" */
	
	
	var ITEM_ICON_SIZE = 20;
	
	var Item = function Item(_ref) {
	    var entity = _ref.entity,
	        id = _ref.id,
	        name = _ref.name,
	        description = _ref.description,
	        labels = _ref.labels,
	        created = _ref.created,
	        by = _ref.by,
	        favorite = _ref.favorite,
	        collection = _ref.collection,
	        archived = _ref.archived,
	        icon = _ref.icon,
	        selected = _ref.selected,
	        setItemSelected = _ref.setItemSelected,
	        setFavorited = _ref.setFavorited,
	        setArchived = _ref.setArchived,
	        showCollectionName = _ref.showCollectionName,
	        onEntityClick = _ref.onEntityClick;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)('hover-parent hover--visibility', _List2.default.item) },
	        _react2.default.createElement(
	            "div",
	            { className: "flex flex-full align-center" },
	            _react2.default.createElement(
	                "div",
	                { className: "relative flex ml1 mr2", style: { width: ITEM_ICON_SIZE, height: ITEM_ICON_SIZE } },
	                icon && _react2.default.createElement(_Icon2.default, {
	                    className: (0, _classnames2.default)("text-light-blue absolute top left visible", { "hover-child--hidden": !!setItemSelected }),
	                    name: icon,
	                    size: ITEM_ICON_SIZE
	                }),
	                setItemSelected && _react2.default.createElement(
	                    "span",
	                    { className: (0, _classnames2.default)("absolute top left", { "visible": selected }, { "hover-child": !selected }) },
	                    _react2.default.createElement(_CheckBox2.default, {
	                        checked: selected,
	                        onChange: function onChange(e) {
	                            return setItemSelected(_defineProperty({}, id, e.target.checked));
	                        },
	                        size: ITEM_ICON_SIZE,
	                        padding: 3
	                    })
	                )
	            ),
	            _react2.default.createElement(ItemBody, {
	                entity: entity,
	                id: id,
	                name: name,
	                description: description,
	                labels: labels,
	                favorite: favorite,
	                collection: showCollectionName && collection,
	                setFavorited: setFavorited,
	                onEntityClick: onEntityClick
	            })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "flex flex-column ml-auto" },
	            _react2.default.createElement(ItemCreated, {
	                by: by,
	                created: created
	            }),
	            setArchived && _react2.default.createElement(
	                "div",
	                { className: "hover-child mt1 ml-auto" },
	                _react2.default.createElement(
	                    _ModalWithTrigger2.default,
	                    {
	                        full: true,
	                        triggerElement: _react2.default.createElement(
	                            _Tooltip2.default,
	                            { tooltip: "Move to a collection" },
	                            _react2.default.createElement(_Icon2.default, {
	                                className: "text-light-blue cursor-pointer text-brand-hover transition-color mx2",
	                                name: "move",
	                                size: 18
	                            })
	                        )
	                    },
	                    _react2.default.createElement(_MoveToCollection2.default, {
	                        questionId: id,
	                        initialCollectionId: collection && collection.id
	                    })
	                ),
	                _react2.default.createElement(
	                    _Tooltip2.default,
	                    { tooltip: archived ? "Unarchive" : "Archive" },
	                    _react2.default.createElement(_Icon2.default, {
	                        className: "text-light-blue cursor-pointer text-brand-hover transition-color",
	                        name: archived ? "unarchive" : "archive",
	                        onClick: function onClick() {
	                            return setArchived(id, !archived, true);
	                        },
	                        size: 18
	                    })
	                )
	            )
	        )
	    );
	};
	
	Item.displayName = "Item";
	Item.propTypes = {
	    entity: _propTypes2.default.object.isRequired,
	    id: _propTypes2.default.number.isRequired,
	    name: _propTypes2.default.string.isRequired,
	    created: _propTypes2.default.string.isRequired,
	    description: _propTypes2.default.string,
	    by: _propTypes2.default.string.isRequired,
	    labels: _propTypes2.default.array.isRequired,
	    collection: _propTypes2.default.object,
	    selected: _propTypes2.default.bool.isRequired,
	    favorite: _propTypes2.default.bool.isRequired,
	    archived: _propTypes2.default.bool.isRequired,
	    icon: _propTypes2.default.string.isRequired,
	    setItemSelected: _propTypes2.default.func,
	    setFavorited: _propTypes2.default.func,
	    setArchived: _propTypes2.default.func,
	    onEntityClick: _propTypes2.default.func,
	    showCollectionName: _propTypes2.default.bool
	};
	
	var ItemBody = (0, _pure2.default)(function (_ref2) {
	    var entity = _ref2.entity,
	        id = _ref2.id,
	        name = _ref2.name,
	        description = _ref2.description,
	        labels = _ref2.labels,
	        favorite = _ref2.favorite,
	        collection = _ref2.collection,
	        setFavorited = _ref2.setFavorited,
	        onEntityClick = _ref2.onEntityClick;
	    return _react2.default.createElement(
	        "div",
	        { className: _List2.default.itemBody },
	        _react2.default.createElement(
	            "div",
	            { className: (0, _classnames2.default)('flex', _List2.default.itemTitle) },
	            _react2.default.createElement(
	                _reactRouter.Link,
	                { to: Urls.question(id), className: (0, _classnames2.default)(_List2.default.itemName), onClick: onEntityClick && function (e) {
	                        e.preventDefault();onEntityClick(entity);
	                    } },
	                name
	            ),
	            collection && _react2.default.createElement(_CollectionBadge2.default, { collection: collection }),
	            favorite != null && setFavorited && _react2.default.createElement(
	                _Tooltip2.default,
	                { tooltip: favorite ? "Unfavorite" : "Favorite" },
	                _react2.default.createElement(_Icon2.default, {
	                    className: (0, _classnames2.default)("flex cursor-pointer", { "hover-child text-light-blue text-brand-hover": !favorite }, { "visible text-gold": favorite }),
	                    name: favorite ? "star" : "staroutline",
	                    size: ITEM_ICON_SIZE,
	                    onClick: function onClick() {
	                        return setFavorited(id, !favorite);
	                    }
	                })
	            ),
	            _react2.default.createElement(_Labels2.default, { labels: labels })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: (0, _classnames2.default)({ 'text-slate': description }, { 'text-light-blue': !description }) },
	            description ? description : "No description yet"
	        )
	    );
	});
	
	ItemBody.propTypes = {
	    description: _propTypes2.default.string,
	    favorite: _propTypes2.default.bool.isRequired,
	    id: _propTypes2.default.number.isRequired,
	    name: _propTypes2.default.string.isRequired,
	    setFavorited: _propTypes2.default.func
	};
	
	var ItemCreated = (0, _pure2.default)(function (_ref3) {
	    var created = _ref3.created,
	        by = _ref3.by;
	    return created || by ? _react2.default.createElement(
	        "div",
	        { className: _List2.default.itemSubtitle },
	        "Created" + (created ? " " + created : "") + (by ? " by " + by : "")
	    ) : null;
	});
	
	ItemCreated.propTypes = {
	    created: _propTypes2.default.string.isRequired,
	    by: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _pure2.default)(Item);

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _CollectionList = __webpack_require__(1611);
	
	var _CollectionList2 = _interopRequireDefault(_CollectionList);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _questions = __webpack_require__(1622);
	
	var _collections = __webpack_require__(1613);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {};
	};
	
	var mapDispatchToProps = {
	    loadCollections: _collections.loadCollections,
	    defaultSetCollection: _questions.setCollection
	};
	
	var MoveToCollection = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(MoveToCollection, _Component);
	
	    function MoveToCollection(props) {
	        _classCallCheck(this, MoveToCollection);
	
	        var _this = _possibleConstructorReturn(this, (MoveToCollection.__proto__ || Object.getPrototypeOf(MoveToCollection)).call(this, props));
	
	        _this.state = {
	            currentCollection: { id: props.initialCollectionId }
	        };
	
	        return _this;
	    }
	
	    _createClass(MoveToCollection, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.loadCollections();
	        }
	    }, {
	        key: "onMove",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(collection) {
	                var _setCollection;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	
	                                this.setState({ error: null });
	                                _setCollection = this.props.setCollection || this.props.defaultSetCollection;
	                                _context.next = 5;
	                                return _setCollection(this.props.questionId, collection, true);
	
	                            case 5:
	                                this.props.onClose();
	                                _context.next = 11;
	                                break;
	
	                            case 8:
	                                _context.prev = 8;
	                                _context.t0 = _context["catch"](0);
	
	                                this.setState({ error: _context.t0 });
	
	                            case 11:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 8]]);
	            }));
	
	            function onMove(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return onMove;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var onClose = this.props.onClose;
	            var _state = this.state,
	                currentCollection = _state.currentCollection,
	                error = _state.error;
	
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    title: "Which collection should this be in?",
	                    footer: _react2.default.createElement(
	                        "div",
	                        null,
	                        error && _react2.default.createElement(
	                            "span",
	                            { className: "text-error mr1" },
	                            error.data && error.data.message
	                        ),
	                        _react2.default.createElement(
	                            _Button2.default,
	                            { className: "mr1", onClick: onClose },
	                            "Cancel"
	                        ),
	                        _react2.default.createElement(
	                            _Button2.default,
	                            { primary: true, disabled: currentCollection.id === undefined, onClick: function onClick() {
	                                    return _this2.onMove(currentCollection);
	                                } },
	                            "Move"
	                        )
	                    ),
	                    fullPageModal: true,
	                    onClose: onClose
	                },
	                _react2.default.createElement(
	                    _CollectionList2.default,
	                    { writable: true },
	                    function (collections) {
	                        return _react2.default.createElement(
	                            "ol",
	                            { className: "List text-brand ml-auto mr-auto", style: { width: 520 } },
	                            [{ name: "None", id: null }].concat(collections).map(function (collection, index) {
	                                return _react2.default.createElement(
	                                    "li",
	                                    {
	                                        className: (0, _classnames2.default)("List-item flex align-center cursor-pointer mb1 p1", { "List-item--selected": collection.id === currentCollection.id }),
	                                        key: index,
	                                        onClick: function onClick() {
	                                            return _this2.setState({ currentCollection: collection });
	                                        }
	                                    },
	                                    _react2.default.createElement(_Icon2.default, {
	                                        className: "Icon mr2",
	                                        name: "all",
	                                        style: {
	                                            color: collection.color,
	                                            visibility: collection.color == null ? "hidden" : null
	                                        }
	                                    }),
	                                    _react2.default.createElement(
	                                        "h3",
	                                        { className: "List-item-title" },
	                                        collection.name
	                                    )
	                                );
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return MoveToCollection;
	}(_react.Component)) || _class);
	MoveToCollection.displayName = "MoveToCollection";
	exports.default = MoveToCollection;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setAllSelected = exports.setItemSelected = exports.setSearchText = exports.setCollection = exports.setLabeled = exports.setArchived = exports.setFavorited = exports.search = exports.loadEntities = exports.LOAD_ENTITIES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var _ref7 = arguments[1];
	    var type = _ref7.type,
	        payload = _ref7.payload,
	        error = _ref7.error;
	
	    switch (type) {
	        case SET_SEARCH_TEXT:
	            return _extends({}, state, { searchText: payload });
	        case SET_ITEM_SELECTED:
	            return _extends({}, state, { selectedIds: _extends({}, state.selectedIds, payload) });
	        case SET_ALL_SELECTED:
	            return _extends({}, state, { selectedIds: payload });
	        case LOAD_ENTITIES:
	            if (error) {
	                return (0, _icepick.assocIn)(state, ["itemsBySection", payload.entityType, payload.entityQuery, "error"], payload.error);
	            } else {
	                return (0, _icepick.chain)(state).assoc("loadingInitialEntities", false).assoc("entities", (0, _redux.mergeEntities)(state.entities, payload.entities)).assoc("lastEntityType", payload.entityType).assoc("lastEntityQuery", payload.entityQuery).assoc("selectedIds", {}).assoc("searchText", "").assocIn(["itemsBySection", payload.entityType, payload.entityQuery, "error"], null).assocIn(["itemsBySection", payload.entityType, payload.entityQuery, "items"], payload.result)
	                // store the initial sort order so if we remove and undo an item it can be put back in it's original location
	                .assocIn(["itemsBySection", payload.entityType, payload.entityQuery, "sortIndex"], payload.result.reduce(function (o, id, i) {
	                    o[id] = i;return o;
	                }, {})).value();
	            }
	        case SET_FAVORITED:
	            if (error) {
	                return state;
	            } else if (payload && payload.id != null) {
	                state = (0, _icepick.assocIn)(state, ["entities", "cards", payload.id], _extends({}, (0, _icepick.getIn)(state, ["entities", "cards", payload.id]), payload));
	                // FIXME: incorrectly adds to sections it may not have previously been in, but not a big deal since we reload whens switching sections
	                state = updateSections(state, "cards", payload.id, function (s) {
	                    return s.f === "fav";
	                }, payload.favorite);
	            }
	            return state;
	        case SET_ARCHIVED:
	            if (error) {
	                return state;
	            } else if (payload && payload.id != null) {
	                state = (0, _icepick.assocIn)(state, ["entities", "cards", payload.id], _extends({}, (0, _icepick.getIn)(state, ["entities", "cards", payload.id]), payload));
	                // FIXME: incorrectly adds to sections it may not have previously been in, but not a big deal since we reload whens switching sections
	                state = updateSections(state, "cards", payload.id, function (s) {
	                    return s.f === "archived";
	                }, payload.archived);
	                state = updateSections(state, "cards", payload.id, function (s) {
	                    return s.f !== "archived";
	                }, !payload.archived);
	            }
	            return state;
	        case SET_LABELED:
	            if (error) {
	                return state;
	            } else if (payload && payload.id != null) {
	                state = (0, _icepick.assocIn)(state, ["entities", "cards", payload.id], _extends({}, (0, _icepick.getIn)(state, ["entities", "cards", payload.id]), payload));
	                // FIXME: incorrectly adds to sections it may not have previously been in, but not a big deal since we reload whens switching sections
	                state = updateSections(state, "cards", payload.id, function (s) {
	                    return s.label === payload._changedLabelSlug;
	                }, payload._changedLabeled);
	            }
	            return state;
	        case SET_COLLECTION:
	            if (error) {
	                return state;
	            } else if (payload && payload.id != null) {
	                state = (0, _icepick.assocIn)(state, ["entities", "cards", payload.id], _extends({}, (0, _icepick.getIn)(state, ["entities", "cards", payload.id]), payload));
	                state = updateSections(state, "cards", payload.id, function (s) {
	                    return s.collection !== payload._changedSectionSlug;
	                }, false);
	                state = updateSections(state, "cards", payload.id, function (s) {
	                    return s.collection === payload._changedSectionSlug;
	                }, true);
	            }
	            return state;
	        case _collections.SET_COLLECTION_ARCHIVED:
	            if (error) {
	                return state;
	            } else if (payload && payload.id != null) {
	                state = (0, _icepick.assocIn)(state, ["entities", "collections", payload.id], _extends({}, (0, _icepick.getIn)(state, ["entities", "collections", payload.id]), payload));
	                state = updateSections(state, "collections", payload.id, function (s) {
	                    return s.archived;
	                }, payload.archived);
	                state = updateSections(state, "collections", payload.id, function (s) {
	                    return !s.archived;
	                }, !payload.archived);
	            }
	            return state;
	        default:
	            return state;
	    }
	};
	
	var _redux = __webpack_require__(657);
	
	var _normalizr = __webpack_require__(1111);
	
	var _icepick = __webpack_require__(855);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _formatting = __webpack_require__(872);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _requests = __webpack_require__(856);
	
	var _undo = __webpack_require__(1070);
	
	var _selectors = __webpack_require__(1612);
	
	var _collections = __webpack_require__(1613);
	
	var _services = __webpack_require__(857);
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var label = new _normalizr.schema.Entity('labels');
	var collection = new _normalizr.schema.Entity('collections');
	var card = new _normalizr.schema.Entity('cards', {
	    labels: [label]
	});
	
	var LOAD_ENTITIES = exports.LOAD_ENTITIES = 'metabase/questions/LOAD_ENTITIES';
	var SET_SEARCH_TEXT = 'metabase/questions/SET_SEARCH_TEXT';
	var SET_ITEM_SELECTED = 'metabase/questions/SET_ITEM_SELECTED';
	var SET_ALL_SELECTED = 'metabase/questions/SET_ALL_SELECTED';
	var SET_FAVORITED = 'metabase/questions/SET_FAVORITED';
	var SET_ARCHIVED = 'metabase/questions/SET_ARCHIVED';
	var SET_LABELED = 'metabase/questions/SET_LABELED';
	var SET_COLLECTION = 'metabase/collections/SET_COLLECTION';
	
	var loadEntities = exports.loadEntities = (0, _redux.createThunkAction)(LOAD_ENTITIES, function (entityType, entityQueryObject) {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var entityQuery, result;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            entityQuery = JSON.stringify(entityQueryObject);
	                            _context.prev = 1;
	                            result = void 0;
	
	                            dispatch((0, _requests.setRequestState)({ statePath: ['questions', 'fetch'], state: "LOADING" }));
	
	                            if (!(entityType === "cards")) {
	                                _context.next = 18;
	                                break;
	                            }
	
	                            _context.t0 = _extends;
	                            _context.t1 = { entityType: entityType, entityQuery: entityQuery };
	                            _context.t2 = _normalizr.normalize;
	                            _context.t3 = _redux.momentifyArraysTimestamps;
	                            _context.next = 11;
	                            return _services.CardApi.list(entityQueryObject);
	
	                        case 11:
	                            _context.t4 = _context.sent;
	                            _context.t5 = (0, _context.t3)(_context.t4);
	                            _context.t6 = [card];
	                            _context.t7 = (0, _context.t2)(_context.t5, _context.t6);
	                            result = (0, _context.t0)(_context.t1, _context.t7);
	                            _context.next = 33;
	                            break;
	
	                        case 18:
	                            if (!(entityType === "collections")) {
	                                _context.next = 32;
	                                break;
	                            }
	
	                            _context.t8 = _extends;
	                            _context.t9 = { entityType: entityType, entityQuery: entityQuery };
	                            _context.t10 = _normalizr.normalize;
	                            _context.t11 = _redux.momentifyArraysTimestamps;
	                            _context.next = 25;
	                            return _services.CollectionsApi.list(entityQueryObject);
	
	                        case 25:
	                            _context.t12 = _context.sent;
	                            _context.t13 = (0, _context.t11)(_context.t12);
	                            _context.t14 = [collection];
	                            _context.t15 = (0, _context.t10)(_context.t13, _context.t14);
	                            result = (0, _context.t8)(_context.t9, _context.t15);
	                            _context.next = 33;
	                            break;
	
	                        case 32:
	                            throw "Unknown entity type " + entityType;
	
	                        case 33:
	                            dispatch((0, _requests.setRequestState)({ statePath: ['questions', 'fetch'], state: "LOADED" }));
	                            return _context.abrupt("return", result);
	
	                        case 37:
	                            _context.prev = 37;
	                            _context.t16 = _context["catch"](1);
	                            throw { entityType: entityType, entityQuery: entityQuery, error: _context.t16 };
	
	                        case 40:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[1, 37]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var search = exports.search = function search(q, repl) {
	    return (repl ? _reactRouterRedux.replace : _reactRouterRedux.push)("/questions/search?q=" + encodeURIComponent(q));
	};
	
	var setFavorited = exports.setFavorited = (0, _redux.createThunkAction)(SET_FAVORITED, function (cardId, favorited) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (!favorited) {
	                                _context2.next = 5;
	                                break;
	                            }
	
	                            _context2.next = 3;
	                            return _services.CardApi.favorite({ cardId: cardId });
	
	                        case 3:
	                            _context2.next = 7;
	                            break;
	
	                        case 5:
	                            _context2.next = 7;
	                            return _services.CardApi.unfavorite({ cardId: cardId });
	
	                        case 7:
	                            _analytics2.default.trackEvent("Questions", favorited ? "Favorite" : "Unfavorite");
	                            return _context2.abrupt("return", { id: cardId, favorite: favorited });
	
	                        case 9:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	function createUndo(type, actions, collection) {
	    return {
	        type: type,
	        count: actions.length,
	        message: function message(undo) {
	            return (// eslint-disable-line react/display-name
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex flex-column" },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        undo.count + " " + (0, _formatting.inflect)(null, undo.count, "question was", "questions were") + " " + type,
	                        undo.count === 1 && collection && _react2.default.createElement(
	                            "span",
	                            null,
	                            " to the ",
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { className: "link", to: Urls.collection(collection) },
	                                collection.name
	                            ),
	                            " collection."
	                        )
	                    )
	                )
	            );
	        },
	        actions: actions
	    };
	}
	
	var setArchived = exports.setArchived = (0, _redux.createThunkAction)(SET_ARCHIVED, function (cardId, archived) {
	    var undoable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            var selected, _card, response;
	
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            if (!(cardId == null)) {
	                                _context3.next = 6;
	                                break;
	                            }
	
	                            // bulk archive
	                            selected = (0, _selectors.getSelectedEntities)(getState()).filter(function (item) {
	                                return item.archived !== archived;
	                            });
	
	                            selected.map(function (item) {
	                                return dispatch(setArchived(item.id, archived));
	                            });
	                            // TODO: errors
	                            if (undoable) {
	                                dispatch((0, _undo.addUndo)(createUndo(archived ? "archived" : "unarchived", selected.map(function (item) {
	                                    return setArchived(item.id, !archived);
	                                }))));
	                                _analytics2.default.trackEvent("Questions", archived ? "Bulk Archive" : "Bulk Unarchive", selected.length);
	                            }
	                            _context3.next = 12;
	                            break;
	
	                        case 6:
	                            _card = _extends({}, getState().questions.entities.cards[cardId], {
	                                archived: archived
	                            });
	                            _context3.next = 9;
	                            return _services.CardApi.update(_card);
	
	                        case 9:
	                            response = _context3.sent;
	
	                            if (undoable) {
	                                dispatch((0, _undo.addUndo)(createUndo(archived ? "archived" : "unarchived", [setArchived(cardId, !archived)], !archived && _card.collection)));
	                                _analytics2.default.trackEvent("Questions", archived ? "Archive" : "Unarchive");
	                            }
	                            return _context3.abrupt("return", response);
	
	                        case 12:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined);
	        }));
	
	        return function (_x6, _x7) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	});
	
	var setLabeled = exports.setLabeled = (0, _redux.createThunkAction)(SET_LABELED, function (cardId, labelId, labeled) {
	    var undoable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    return function () {
	        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
	            var selected, state, labelSlug, labels, newLabels;
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            if (!(cardId == null)) {
	                                _context4.next = 6;
	                                break;
	                            }
	
	                            // bulk label
	                            selected = (0, _selectors.getSelectedEntities)(getState());
	
	                            selected.map(function (item) {
	                                return dispatch(setLabeled(item.id, labelId, labeled));
	                            });
	                            // TODO: errors
	                            if (undoable) {
	                                dispatch((0, _undo.addUndo)(createUndo(labeled ? "labeled" : "unlabeled", selected.map(function (item) {
	                                    return setLabeled(item.id, labelId, !labeled);
	                                }))));
	                                _analytics2.default.trackEvent("Questions", labeled ? "Bulk Apply Label" : "Bulk Remove Label", selected.length);
	                            }
	                            _context4.next = 16;
	                            break;
	
	                        case 6:
	                            state = getState();
	                            labelSlug = (0, _icepick.getIn)(state.questions, ["entities", "labels", labelId, "slug"]);
	                            labels = (0, _icepick.getIn)(state.questions, ["entities", "cards", cardId, "labels"]);
	                            newLabels = labels.filter(function (id) {
	                                return id !== labelId;
	                            });
	
	                            if (labeled) {
	                                newLabels.push(labelId);
	                            }
	
	                            if (!(labels.length !== newLabels.length)) {
	                                _context4.next = 16;
	                                break;
	                            }
	
	                            _context4.next = 14;
	                            return _services.CardApi.updateLabels({ cardId: cardId, label_ids: newLabels });
	
	                        case 14:
	                            if (undoable) {
	                                dispatch((0, _undo.addUndo)(createUndo(labeled ? "labeled" : "unlabeled", [setLabeled(cardId, labelId, !labeled)])));
	                                _analytics2.default.trackEvent("Questions", labeled ? "Apply Label" : "Remove Label");
	                            }
	                            return _context4.abrupt("return", { id: cardId, labels: newLabels, _changedLabelSlug: labelSlug, _changedLabeled: labeled });
	
	                        case 16:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, undefined);
	        }));
	
	        return function (_x9, _x10) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	});
	
	var getCardCollectionId = function getCardCollectionId(state, cardId) {
	    return (0, _icepick.getIn)(state, ["questions", "entities", "cards", cardId, "collection_id"]);
	};
	
	var setCollection = exports.setCollection = (0, _redux.createThunkAction)(SET_COLLECTION, function (cardId, collection) {
	    var undoable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    return function () {
	        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
	            var state, collectionId, selected, _collection, _card2;
	
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            state = getState();
	                            collectionId = collection.id;
	
	                            if (!(cardId == null)) {
	                                _context5.next = 8;
	                                break;
	                            }
	
	                            // bulk move
	                            selected = (0, _selectors.getSelectedEntities)(getState());
	
	                            if (undoable) {
	                                dispatch((0, _undo.addUndo)(createUndo("moved", selected.map(function (item) {
	                                    return setCollection(item.id, getCardCollectionId(state, item.id));
	                                }))));
	                                _analytics2.default.trackEvent("Questions", "Bulk Move to Collection");
	                            }
	                            selected.map(function (item) {
	                                return dispatch(setCollection(item.id, { id: collectionId }));
	                            });
	                            _context5.next = 14;
	                            break;
	
	                        case 8:
	                            _collection = _underscore2.default.findWhere(state.collections.collections, { id: collectionId });
	
	
	                            if (undoable) {
	                                dispatch((0, _undo.addUndo)(createUndo("moved", [setCollection(cardId, getCardCollectionId(state, cardId))])));
	                                _analytics2.default.trackEvent("Questions", "Move to Collection");
	                            }
	                            _context5.next = 12;
	                            return _services.CardApi.update({ id: cardId, collection_id: collectionId });
	
	                        case 12:
	                            _card2 = _context5.sent;
	                            return _context5.abrupt("return", _extends({}, _card2, {
	                                _changedSectionSlug: _collection && _collection.slug
	                            }));
	
	                        case 14:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, undefined);
	        }));
	
	        return function (_x12, _x13) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	});
	
	var setSearchText = exports.setSearchText = (0, _redux.createAction)(SET_SEARCH_TEXT);
	var setItemSelected = exports.setItemSelected = (0, _redux.createAction)(SET_ITEM_SELECTED);
	
	var setAllSelected = exports.setAllSelected = (0, _redux.createThunkAction)(SET_ALL_SELECTED, function (selected) {
	    return function () {
	        var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
	            var visibleEntities, selectedIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entity;
	
	            return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            visibleEntities = (0, _selectors.getVisibleEntities)(getState());
	                            selectedIds = {};
	
	                            if (!selected) {
	                                _context6.next = 22;
	                                break;
	                            }
	
	                            _iteratorNormalCompletion = true;
	                            _didIteratorError = false;
	                            _iteratorError = undefined;
	                            _context6.prev = 6;
	
	                            for (_iterator = visibleEntities[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                entity = _step.value;
	
	                                selectedIds[entity.id] = true;
	                            }
	                            _context6.next = 14;
	                            break;
	
	                        case 10:
	                            _context6.prev = 10;
	                            _context6.t0 = _context6["catch"](6);
	                            _didIteratorError = true;
	                            _iteratorError = _context6.t0;
	
	                        case 14:
	                            _context6.prev = 14;
	                            _context6.prev = 15;
	
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	
	                        case 17:
	                            _context6.prev = 17;
	
	                            if (!_didIteratorError) {
	                                _context6.next = 20;
	                                break;
	                            }
	
	                            throw _iteratorError;
	
	                        case 20:
	                            return _context6.finish(17);
	
	                        case 21:
	                            return _context6.finish(14);
	
	                        case 22:
	                            _analytics2.default.trackEvent("Questions", selected ? "Select All" : "Unselect All", visibleEntities.length);
	                            return _context6.abrupt("return", selectedIds);
	
	                        case 24:
	                        case "end":
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, undefined, [[6, 10, 14, 22], [15,, 17, 21]]);
	        }));
	
	        return function (_x14, _x15) {
	            return _ref6.apply(this, arguments);
	        };
	    }();
	});
	
	var initialState = {
	    lastEntityType: null,
	    lastEntityQuery: null,
	    entities: {},
	    loadingInitialEntities: true,
	    itemsBySection: {},
	    searchText: "",
	    selectedIds: {},
	    undos: []
	};
	
	function updateSections(state, entityType, entityId, sectionPredicate, shouldContain) {
	    return (0, _icepick.updateIn)(state, ["itemsBySection", entityType], function (entityQueries) {
	        return _underscore2.default.mapObject(entityQueries, function (entityQueryResult, entityQuery) {
	            if (sectionPredicate(JSON.parse(entityQuery))) {
	                var doesContain = _underscore2.default.contains(entityQueryResult.items, entityId);
	                if (!doesContain && shouldContain) {
	                    return _extends({}, entityQueryResult, { items: entityQueryResult.items.concat(entityId) });
	                } else if (doesContain && !shouldContain) {
	                    return _extends({}, entityQueryResult, { items: entityQueryResult.items.filter(function (id) {
	                            return id !== entityId;
	                        }) });
	                }
	            }
	            return entityQueryResult;
	        });
	    });
	}

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _Labels = __webpack_require__(1624);
	
	var _Labels2 = _interopRequireDefault(_Labels);
	
	var _color = __webpack_require__(1290);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _EmojiIcon = __webpack_require__(1626);
	
	var _EmojiIcon2 = _interopRequireDefault(_EmojiIcon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint "react/prop-types": "warn" */
	
	
	var Labels = function Labels(_ref) {
	    var labels = _ref.labels;
	    return _react2.default.createElement(
	        "ul",
	        { className: _Labels2.default.list },
	        labels.map(function (label) {
	            return _react2.default.createElement(
	                "li",
	                { className: _Labels2.default.listItem, key: label.id },
	                _react2.default.createElement(Label, label)
	            );
	        })
	    );
	};
	
	Labels.displayName = "Labels";
	Labels.propTypes = {
	    labels: _propTypes2.default.array.isRequired
	};
	
	var Label = function (_Component) {
	    _inherits(Label, _Component);
	
	    function Label(props) {
	        _classCallCheck(this, Label);
	
	        var _this = _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).call(this, props));
	
	        _this.state = {
	            hovered: false
	        };
	        return _this;
	    }
	
	    _createClass(Label, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                name = _props.name,
	                icon = _props.icon,
	                slug = _props.slug;
	            var hovered = this.state.hovered;
	
	            return _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                    to: Urls.label({ slug: slug }),
	                    onMouseEnter: function onMouseEnter() {
	                        return _this2.setState({ hovered: true });
	                    },
	                    onMouseLeave: function onMouseLeave() {
	                        return _this2.setState({ hovered: false });
	                    }
	                },
	                icon.charAt(0) === ":" ? _react2.default.createElement(
	                    "span",
	                    { className: (0, _classnames2.default)(_Labels2.default.label, _Labels2.default.emojiLabel) },
	                    _react2.default.createElement(_EmojiIcon2.default, { name: icon, className: _Labels2.default.emojiIcon }),
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        name
	                    )
	                ) : icon.charAt(0) === "#" ? _react2.default.createElement(
	                    "span",
	                    {
	                        className: _Labels2.default.label,
	                        style: {
	                            backgroundColor: hovered ? (0, _color2.default)(icon).darken(0.1).hex() : icon,
	                            boxShadow: "1px 1px 0 " + (0, _color2.default)(icon).darken(hovered ? 0.1 : 0.2).hex(),
	                            transition: 'background .3s ease-in-out'
	                        }
	                    },
	                    name
	                ) : _react2.default.createElement(
	                    "span",
	                    { className: _Labels2.default.label },
	                    name
	                )
	            );
	        }
	    }]);
	
	    return Label;
	}(_react.Component);
	
	Label.displayName = "Label";
	
	
	Label.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    icon: _propTypes2.default.string.isRequired,
	    slug: _propTypes2.default.string.isRequired
	};
	
	exports.default = Labels;

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"_1vLFj _3kYJR","listItem":"_1ZXxG CO6xt","label":"_1-Vqi _3kYJR JmZU_ _3TD8R","emojiLabel":"CtDFn eTBAP","emojiIcon":"_2g6EI"};

/***/ }),
/* 1625 */,
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emoji = __webpack_require__(1627);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmojiIcon = function EmojiIcon(_ref) {
	    var _ref$size = _ref.size,
	        size = _ref$size === undefined ? 18 : _ref$size,
	        style = _ref.style,
	        className = _ref.className,
	        name = _ref.name;
	    return _react2.default.createElement(
	        "span",
	        { className: className, style: _extends({ width: size, height: size }, style) },
	        _emoji.emoji[name].react
	    );
	};
	
	EmojiIcon.displayName = "EmojiIcon";
	EmojiIcon.propTypes = {
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    size: _propTypes2.default.number,
	    name: _propTypes2.default.string.isRequired
	};
	
	exports.default = EmojiIcon;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.categories = exports.emoji = undefined;
	
	var _emoji = __webpack_require__(1628);
	
	var _emoji2 = _interopRequireDefault(_emoji);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emoji = exports.emoji = {};
	var categories = exports.categories = _emoji2.default.categories;
	
	for (var shortcode in _emoji2.default.emoji) {
	    var e = _emoji2.default.emoji[shortcode];
	    emoji[shortcode] = {
	        codepoint: e,
	        str: String.fromCodePoint(e),
	        react: String.fromCodePoint(e)
	    };
	}

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	module.exports = {
		"emoji": {
			":grinning:": 128512,
			":grimacing:": 128556,
			":grin:": 128513,
			":joy:": 128514,
			":smiley:": 128515,
			":smile:": 128516,
			":sweat_smile:": 128517,
			":laughing:": 128518,
			":innocent:": 128519,
			":wink:": 128521,
			":blush:": 128522,
			":slight_smile:": 128578,
			":upside_down:": 128579,
			":relaxed:": 9786,
			":yum:": 128523,
			":relieved:": 128524,
			":heart_eyes:": 128525,
			":kissing_heart:": 128536,
			":kissing:": 128535,
			":kissing_smiling_eyes:": 128537,
			":kissing_closed_eyes:": 128538,
			":stuck_out_tongue_winking_eye:": 128540,
			":stuck_out_tongue_closed_eyes:": 128541,
			":stuck_out_tongue:": 128539,
			":money_mouth:": 129297,
			":nerd:": 129299,
			":sunglasses:": 128526,
			":hugging:": 129303,
			":smirk:": 128527,
			":no_mouth:": 128566,
			":neutral_face:": 128528,
			":expressionless:": 128529,
			":unamused:": 128530,
			":rolling_eyes:": 128580,
			":thinking:": 129300,
			":flushed:": 128563,
			":disappointed:": 128542,
			":worried:": 128543,
			":angry:": 128544,
			":rage:": 128545,
			":pensive:": 128532,
			":confused:": 128533,
			":slight_frown:": 128577,
			":frowning2:": 9785,
			":persevere:": 128547,
			":confounded:": 128534,
			":tired_face:": 128555,
			":weary:": 128553,
			":triumph:": 128548,
			":open_mouth:": 128558,
			":scream:": 128561,
			":fearful:": 128552,
			":cold_sweat:": 128560,
			":hushed:": 128559,
			":frowning:": 128550,
			":anguished:": 128551,
			":cry:": 128546,
			":disappointed_relieved:": 128549,
			":sleepy:": 128554,
			":sweat:": 128531,
			":sob:": 128557,
			":dizzy_face:": 128565,
			":astonished:": 128562,
			":zipper_mouth:": 129296,
			":mask:": 128567,
			":thermometer_face:": 129298,
			":head_bandage:": 129301,
			":sleeping:": 128564,
			":zzz:": 128164,
			":poop:": 128169,
			":smiling_imp:": 128520,
			":imp:": 128127,
			":japanese_ogre:": 128121,
			":japanese_goblin:": 128122,
			":skull:": 128128,
			":ghost:": 128123,
			":alien:": 128125,
			":robot:": 129302,
			":smiley_cat:": 128570,
			":smile_cat:": 128568,
			":joy_cat:": 128569,
			":heart_eyes_cat:": 128571,
			":smirk_cat:": 128572,
			":kissing_cat:": 128573,
			":scream_cat:": 128576,
			":crying_cat_face:": 128575,
			":pouting_cat:": 128574,
			":raised_hands:": 128588,
			":clap:": 128079,
			":wave:": 128075,
			":thumbsup:": 128077,
			":thumbsdown:": 128078,
			":punch:": 128074,
			":fist:": 9994,
			":v:": 9996,
			":ok_hand:": 128076,
			":raised_hand:": 9995,
			":open_hands:": 128080,
			":muscle:": 128170,
			":pray:": 128591,
			":point_up:": 9757,
			":point_up_2:": 128070,
			":point_down:": 128071,
			":point_left:": 128072,
			":point_right:": 128073,
			":middle_finger:": 128405,
			":hand_splayed:": 128400,
			":metal:": 129304,
			":vulcan:": 128406,
			":writing_hand:": 9997,
			":nail_care:": 128133,
			":lips:": 128068,
			":tongue:": 128069,
			":ear:": 128066,
			":nose:": 128067,
			":eye:": 128065,
			":eyes:": 128064,
			":bust_in_silhouette:": 128100,
			":busts_in_silhouette:": 128101,
			":speaking_head:": 128483,
			":baby:": 128118,
			":boy:": 128102,
			":girl:": 128103,
			":man:": 128104,
			":woman:": 128105,
			":person_with_blond_hair:": 128113,
			":older_man:": 128116,
			":older_woman:": 128117,
			":man_with_gua_pi_mao:": 128114,
			":man_with_turban:": 128115,
			":cop:": 128110,
			":construction_worker:": 128119,
			":guardsman:": 128130,
			":spy:": 128373,
			":santa:": 127877,
			":angel:": 128124,
			":princess:": 128120,
			":bride_with_veil:": 128112,
			":walking:": 128694,
			":runner:": 127939,
			":dancer:": 128131,
			":dancers:": 128111,
			":couple:": 128107,
			":two_men_holding_hands:": 128108,
			":two_women_holding_hands:": 128109,
			":bow:": 128583,
			":information_desk_person:": 128129,
			":no_good:": 128581,
			":ok_woman:": 128582,
			":raising_hand:": 128587,
			":person_with_pouting_face:": 128590,
			":person_frowning:": 128589,
			":haircut:": 128135,
			":massage:": 128134,
			":couple_with_heart:": 128145,
			":couple_ww:": 128105,
			":couple_mm:": 128104,
			":couplekiss:": 128143,
			":kiss_ww:": 128105,
			":kiss_mm:": 128104,
			":family:": 128106,
			":family_mwg:": 128104,
			":family_mwgb:": 128104,
			":family_mwbb:": 128104,
			":family_mwgg:": 128104,
			":family_wwb:": 128105,
			":family_wwg:": 128105,
			":family_wwgb:": 128105,
			":family_wwbb:": 128105,
			":family_wwgg:": 128105,
			":family_mmb:": 128104,
			":family_mmg:": 128104,
			":family_mmgb:": 128104,
			":family_mmbb:": 128104,
			":family_mmgg:": 128104,
			":womans_clothes:": 128090,
			":shirt:": 128085,
			":jeans:": 128086,
			":necktie:": 128084,
			":dress:": 128087,
			":bikini:": 128089,
			":kimono:": 128088,
			":lipstick:": 128132,
			":kiss:": 128139,
			":footprints:": 128099,
			":high_heel:": 128096,
			":sandal:": 128097,
			":boot:": 128098,
			":mans_shoe:": 128094,
			":athletic_shoe:": 128095,
			":womans_hat:": 128082,
			":tophat:": 127913,
			":helmet_with_cross:": 9937,
			":mortar_board:": 127891,
			":crown:": 128081,
			":school_satchel:": 127890,
			":pouch:": 128093,
			":purse:": 128091,
			":handbag:": 128092,
			":briefcase:": 128188,
			":eyeglasses:": 128083,
			":dark_sunglasses:": 128374,
			":ring:": 128141,
			":closed_umbrella:": 127746,
			":dog:": 128054,
			":cat:": 128049,
			":mouse:": 128045,
			":hamster:": 128057,
			":rabbit:": 128048,
			":bear:": 128059,
			":panda_face:": 128060,
			":koala:": 128040,
			":tiger:": 128047,
			":lion_face:": 129409,
			":cow:": 128046,
			":pig:": 128055,
			":pig_nose:": 128061,
			":frog:": 128056,
			":octopus:": 128025,
			":monkey_face:": 128053,
			":see_no_evil:": 128584,
			":hear_no_evil:": 128585,
			":speak_no_evil:": 128586,
			":monkey:": 128018,
			":chicken:": 128020,
			":penguin:": 128039,
			":bird:": 128038,
			":baby_chick:": 128036,
			":hatching_chick:": 128035,
			":hatched_chick:": 128037,
			":wolf:": 128058,
			":boar:": 128023,
			":horse:": 128052,
			":unicorn:": 129412,
			":bee:": 128029,
			":bug:": 128027,
			":snail:": 128012,
			":beetle:": 128030,
			":ant:": 128028,
			":spider:": 128375,
			":scorpion:": 129410,
			":crab:": 129408,
			":snake:": 128013,
			":turtle:": 128034,
			":tropical_fish:": 128032,
			":fish:": 128031,
			":blowfish:": 128033,
			":dolphin:": 128044,
			":whale:": 128051,
			":whale2:": 128011,
			":crocodile:": 128010,
			":leopard:": 128006,
			":tiger2:": 128005,
			":water_buffalo:": 128003,
			":ox:": 128002,
			":cow2:": 128004,
			":dromedary_camel:": 128042,
			":camel:": 128043,
			":elephant:": 128024,
			":goat:": 128016,
			":ram:": 128015,
			":sheep:": 128017,
			":racehorse:": 128014,
			":pig2:": 128022,
			":rat:": 128000,
			":mouse2:": 128001,
			":rooster:": 128019,
			":turkey:": 129411,
			":dove:": 128330,
			":dog2:": 128021,
			":poodle:": 128041,
			":cat2:": 128008,
			":rabbit2:": 128007,
			":chipmunk:": 128063,
			":feet:": 128062,
			":dragon:": 128009,
			":dragon_face:": 128050,
			":cactus:": 127797,
			":christmas_tree:": 127876,
			":evergreen_tree:": 127794,
			":deciduous_tree:": 127795,
			":palm_tree:": 127796,
			":seedling:": 127793,
			":herb:": 127807,
			":shamrock:": 9752,
			":four_leaf_clover:": 127808,
			":bamboo:": 127885,
			":tanabata_tree:": 127883,
			":leaves:": 127811,
			":fallen_leaf:": 127810,
			":maple_leaf:": 127809,
			":ear_of_rice:": 127806,
			":hibiscus:": 127802,
			":sunflower:": 127803,
			":rose:": 127801,
			":tulip:": 127799,
			":blossom:": 127804,
			":cherry_blossom:": 127800,
			":bouquet:": 128144,
			":mushroom:": 127812,
			":chestnut:": 127792,
			":jack_o_lantern:": 127875,
			":shell:": 128026,
			":spider_web:": 128376,
			":earth_americas:": 127758,
			":earth_africa:": 127757,
			":earth_asia:": 127759,
			":full_moon:": 127765,
			":waning_gibbous_moon:": 127766,
			":last_quarter_moon:": 127767,
			":waning_crescent_moon:": 127768,
			":new_moon:": 127761,
			":waxing_crescent_moon:": 127762,
			":first_quarter_moon:": 127763,
			":waxing_gibbous_moon:": 127764,
			":new_moon_with_face:": 127770,
			":full_moon_with_face:": 127773,
			":first_quarter_moon_with_face:": 127771,
			":last_quarter_moon_with_face:": 127772,
			":sun_with_face:": 127774,
			":crescent_moon:": 127769,
			":star:": 11088,
			":star2:": 127775,
			":dizzy:": 128171,
			":sparkles:": 10024,
			":comet:": 9732,
			":sunny:": 9728,
			":white_sun_small_cloud:": 127780,
			":partly_sunny:": 9925,
			":white_sun_cloud:": 127781,
			":white_sun_rain_cloud:": 127782,
			":cloud:": 9729,
			":cloud_rain:": 127783,
			":thunder_cloud_rain:": 9928,
			":cloud_lightning:": 127785,
			":zap:": 9889,
			":fire:": 128293,
			":boom:": 128165,
			":snowflake:": 10052,
			":cloud_snow:": 127784,
			":snowman2:": 9731,
			":snowman:": 9924,
			":wind_blowing_face:": 127788,
			":dash:": 128168,
			":cloud_tornado:": 127786,
			":fog:": 127787,
			":umbrella2:": 9730,
			":umbrella:": 9748,
			":droplet:": 128167,
			":sweat_drops:": 128166,
			":ocean:": 127754,
			":green_apple:": 127823,
			":apple:": 127822,
			":pear:": 127824,
			":tangerine:": 127818,
			":lemon:": 127819,
			":banana:": 127820,
			":watermelon:": 127817,
			":grapes:": 127815,
			":strawberry:": 127827,
			":melon:": 127816,
			":cherries:": 127826,
			":peach:": 127825,
			":pineapple:": 127821,
			":tomato:": 127813,
			":eggplant:": 127814,
			":hot_pepper:": 127798,
			":corn:": 127805,
			":sweet_potato:": 127840,
			":honey_pot:": 127855,
			":bread:": 127838,
			":cheese:": 129472,
			":poultry_leg:": 127831,
			":meat_on_bone:": 127830,
			":fried_shrimp:": 127844,
			":egg:": 127859,
			":hamburger:": 127828,
			":fries:": 127839,
			":hotdog:": 127789,
			":pizza:": 127829,
			":spaghetti:": 127837,
			":taco:": 127790,
			":burrito:": 127791,
			":ramen:": 127836,
			":stew:": 127858,
			":fish_cake:": 127845,
			":sushi:": 127843,
			":bento:": 127857,
			":curry:": 127835,
			":rice_ball:": 127833,
			":rice:": 127834,
			":rice_cracker:": 127832,
			":oden:": 127842,
			":dango:": 127841,
			":shaved_ice:": 127847,
			":ice_cream:": 127848,
			":icecream:": 127846,
			":cake:": 127856,
			":birthday:": 127874,
			":custard:": 127854,
			":candy:": 127852,
			":lollipop:": 127853,
			":chocolate_bar:": 127851,
			":popcorn:": 127871,
			":doughnut:": 127849,
			":cookie:": 127850,
			":beer:": 127866,
			":beers:": 127867,
			":wine_glass:": 127863,
			":cocktail:": 127864,
			":tropical_drink:": 127865,
			":champagne:": 127870,
			":sake:": 127862,
			":tea:": 127861,
			":coffee:": 9749,
			":baby_bottle:": 127868,
			":fork_and_knife:": 127860,
			":fork_knife_plate:": 127869,
			":soccer:": 9917,
			":basketball:": 127936,
			":football:": 127944,
			":baseball:": 9918,
			":tennis:": 127934,
			":volleyball:": 127952,
			":rugby_football:": 127945,
			":8ball:": 127921,
			":golf:": 9971,
			":golfer:": 127948,
			":ping_pong:": 127955,
			":badminton:": 127992,
			":hockey:": 127954,
			":field_hockey:": 127953,
			":cricket:": 127951,
			":ski:": 127935,
			":skier:": 9975,
			":snowboarder:": 127938,
			":ice_skate:": 9976,
			":bow_and_arrow:": 127993,
			":fishing_pole_and_fish:": 127907,
			":rowboat:": 128675,
			":swimmer:": 127946,
			":surfer:": 127940,
			":bath:": 128704,
			":basketball_player:": 9977,
			":lifter:": 127947,
			":bicyclist:": 128692,
			":mountain_bicyclist:": 128693,
			":horse_racing:": 127943,
			":levitate:": 128372,
			":trophy:": 127942,
			":running_shirt_with_sash:": 127933,
			":medal:": 127941,
			":military_medal:": 127894,
			":reminder_ribbon:": 127895,
			":rosette:": 127989,
			":ticket:": 127915,
			":tickets:": 127903,
			":performing_arts:": 127917,
			":art:": 127912,
			":circus_tent:": 127914,
			":microphone:": 127908,
			":headphones:": 127911,
			":musical_score:": 127932,
			":musical_keyboard:": 127929,
			":saxophone:": 127927,
			":trumpet:": 127930,
			":guitar:": 127928,
			":violin:": 127931,
			":clapper:": 127916,
			":video_game:": 127918,
			":space_invader:": 128126,
			":dart:": 127919,
			":game_die:": 127922,
			":slot_machine:": 127920,
			":bowling:": 127923,
			":red_car:": 128663,
			":taxi:": 128661,
			":blue_car:": 128665,
			":bus:": 128652,
			":trolleybus:": 128654,
			":race_car:": 127950,
			":police_car:": 128659,
			":ambulance:": 128657,
			":fire_engine:": 128658,
			":minibus:": 128656,
			":truck:": 128666,
			":articulated_lorry:": 128667,
			":tractor:": 128668,
			":motorcycle:": 127949,
			":bike:": 128690,
			":rotating_light:": 128680,
			":oncoming_police_car:": 128660,
			":oncoming_bus:": 128653,
			":oncoming_automobile:": 128664,
			":oncoming_taxi:": 128662,
			":aerial_tramway:": 128673,
			":mountain_cableway:": 128672,
			":suspension_railway:": 128671,
			":railway_car:": 128643,
			":train:": 128651,
			":monorail:": 128669,
			":bullettrain_side:": 128644,
			":bullettrain_front:": 128645,
			":light_rail:": 128648,
			":mountain_railway:": 128670,
			":steam_locomotive:": 128642,
			":train2:": 128646,
			":metro:": 128647,
			":tram:": 128650,
			":station:": 128649,
			":helicopter:": 128641,
			":airplane_small:": 128745,
			":airplane:": 9992,
			":airplane_departure:": 128747,
			":airplane_arriving:": 128748,
			":sailboat:": 9973,
			":motorboat:": 128741,
			":speedboat:": 128676,
			":ferry:": 9972,
			":cruise_ship:": 128755,
			":rocket:": 128640,
			":satellite_orbital:": 128752,
			":seat:": 128186,
			":anchor:": 9875,
			":construction:": 128679,
			":fuelpump:": 9981,
			":busstop:": 128655,
			":vertical_traffic_light:": 128678,
			":traffic_light:": 128677,
			":checkered_flag:": 127937,
			":ship:": 128674,
			":ferris_wheel:": 127905,
			":roller_coaster:": 127906,
			":carousel_horse:": 127904,
			":construction_site:": 127959,
			":foggy:": 127745,
			":tokyo_tower:": 128508,
			":factory:": 127981,
			":fountain:": 9970,
			":rice_scene:": 127889,
			":mountain:": 9968,
			":mountain_snow:": 127956,
			":mount_fuji:": 128507,
			":volcano:": 127755,
			":japan:": 128510,
			":camping:": 127957,
			":tent:": 9978,
			":park:": 127966,
			":motorway:": 128739,
			":railway_track:": 128740,
			":sunrise:": 127749,
			":sunrise_over_mountains:": 127748,
			":desert:": 127964,
			":beach:": 127958,
			":island:": 127965,
			":city_sunset:": 127751,
			":city_dusk:": 127750,
			":cityscape:": 127961,
			":night_with_stars:": 127747,
			":bridge_at_night:": 127753,
			":milky_way:": 127756,
			":stars:": 127776,
			":sparkler:": 127879,
			":fireworks:": 127878,
			":rainbow:": 127752,
			":homes:": 127960,
			":european_castle:": 127984,
			":japanese_castle:": 127983,
			":stadium:": 127967,
			":statue_of_liberty:": 128509,
			":house:": 127968,
			":house_with_garden:": 127969,
			":house_abandoned:": 127962,
			":office:": 127970,
			":department_store:": 127980,
			":post_office:": 127971,
			":european_post_office:": 127972,
			":hospital:": 127973,
			":bank:": 127974,
			":hotel:": 127976,
			":convenience_store:": 127978,
			":school:": 127979,
			":love_hotel:": 127977,
			":wedding:": 128146,
			":classical_building:": 127963,
			":church:": 9962,
			":mosque:": 128332,
			":synagogue:": 128333,
			":kaaba:": 128331,
			":shinto_shrine:": 9961,
			":watch:": 8986,
			":iphone:": 128241,
			":calling:": 128242,
			":computer:": 128187,
			":keyboard:": 9000,
			":desktop:": 128421,
			":printer:": 128424,
			":mouse_three_button:": 128433,
			":trackball:": 128434,
			":joystick:": 128377,
			":compression:": 128476,
			":minidisc:": 128189,
			":floppy_disk:": 128190,
			":cd:": 128191,
			":dvd:": 128192,
			":vhs:": 128252,
			":camera:": 128247,
			":camera_with_flash:": 128248,
			":video_camera:": 128249,
			":movie_camera:": 127909,
			":projector:": 128253,
			":film_frames:": 127902,
			":telephone_receiver:": 128222,
			":telephone:": 9742,
			":pager:": 128223,
			":fax:": 128224,
			":tv:": 128250,
			":radio:": 128251,
			":microphone2:": 127897,
			":level_slider:": 127898,
			":control_knobs:": 127899,
			":stopwatch:": 9201,
			":timer:": 9202,
			":alarm_clock:": 9200,
			":clock:": 128368,
			":hourglass_flowing_sand:": 9203,
			":hourglass:": 8987,
			":satellite:": 128225,
			":battery:": 128267,
			":electric_plug:": 128268,
			":bulb:": 128161,
			":flashlight:": 128294,
			":candle:": 128367,
			":wastebasket:": 128465,
			":oil:": 128738,
			":money_with_wings:": 128184,
			":dollar:": 128181,
			":yen:": 128180,
			":euro:": 128182,
			":pound:": 128183,
			":moneybag:": 128176,
			":credit_card:": 128179,
			":gem:": 128142,
			":scales:": 9878,
			":wrench:": 128295,
			":hammer:": 128296,
			":hammer_pick:": 9874,
			":tools:": 128736,
			":pick:": 9935,
			":nut_and_bolt:": 128297,
			":gear:": 9881,
			":chains:": 9939,
			":gun:": 128299,
			":bomb:": 128163,
			":knife:": 128298,
			":dagger:": 128481,
			":crossed_swords:": 9876,
			":shield:": 128737,
			":smoking:": 128684,
			":skull_crossbones:": 9760,
			":coffin:": 9904,
			":urn:": 9905,
			":amphora:": 127994,
			":crystal_ball:": 128302,
			":prayer_beads:": 128255,
			":barber:": 128136,
			":alembic:": 9879,
			":telescope:": 128301,
			":microscope:": 128300,
			":hole:": 128371,
			":pill:": 128138,
			":syringe:": 128137,
			":thermometer:": 127777,
			":label:": 127991,
			":bookmark:": 128278,
			":toilet:": 128701,
			":shower:": 128703,
			":bathtub:": 128705,
			":key:": 128273,
			":key2:": 128477,
			":couch:": 128715,
			":sleeping_accommodation:": 128716,
			":bed:": 128719,
			":door:": 128682,
			":bellhop:": 128718,
			":frame_photo:": 128444,
			":map:": 128506,
			":beach_umbrella:": 9969,
			":moyai:": 128511,
			":shopping_bags:": 128717,
			":balloon:": 127880,
			":flags:": 127887,
			":ribbon:": 127872,
			":gift:": 127873,
			":confetti_ball:": 127882,
			":tada:": 127881,
			":dolls:": 127886,
			":wind_chime:": 127888,
			":crossed_flags:": 127884,
			":izakaya_lantern:": 127982,
			":envelope:": 9993,
			":envelope_with_arrow:": 128233,
			":incoming_envelope:": 128232,
			":e-mail:": 128231,
			":love_letter:": 128140,
			":postbox:": 128238,
			":mailbox_closed:": 128234,
			":mailbox:": 128235,
			":mailbox_with_mail:": 128236,
			":mailbox_with_no_mail:": 128237,
			":package:": 128230,
			":postal_horn:": 128239,
			":inbox_tray:": 128229,
			":outbox_tray:": 128228,
			":scroll:": 128220,
			":page_with_curl:": 128195,
			":bookmark_tabs:": 128209,
			":bar_chart:": 128202,
			":chart_with_upwards_trend:": 128200,
			":chart_with_downwards_trend:": 128201,
			":page_facing_up:": 128196,
			":date:": 128197,
			":calendar:": 128198,
			":calendar_spiral:": 128467,
			":card_index:": 128199,
			":card_box:": 128451,
			":ballot_box:": 128499,
			":file_cabinet:": 128452,
			":clipboard:": 128203,
			":notepad_spiral:": 128466,
			":file_folder:": 128193,
			":open_file_folder:": 128194,
			":dividers:": 128450,
			":newspaper2:": 128478,
			":newspaper:": 128240,
			":notebook:": 128211,
			":closed_book:": 128213,
			":green_book:": 128215,
			":blue_book:": 128216,
			":orange_book:": 128217,
			":notebook_with_decorative_cover:": 128212,
			":ledger:": 128210,
			":books:": 128218,
			":book:": 128214,
			":link:": 128279,
			":paperclip:": 128206,
			":paperclips:": 128391,
			":scissors:": 9986,
			":triangular_ruler:": 128208,
			":straight_ruler:": 128207,
			":pushpin:": 128204,
			":round_pushpin:": 128205,
			":triangular_flag_on_post:": 128681,
			":flag_white:": 127987,
			":flag_black:": 127988,
			":closed_lock_with_key:": 128272,
			":lock:": 128274,
			":unlock:": 128275,
			":lock_with_ink_pen:": 128271,
			":pen_ballpoint:": 128394,
			":pen_fountain:": 128395,
			":black_nib:": 10002,
			":pencil:": 128221,
			":pencil2:": 9999,
			":crayon:": 128397,
			":paintbrush:": 128396,
			":mag:": 128269,
			":mag_right:": 128270,
			":heart:": 10084,
			":yellow_heart:": 128155,
			":green_heart:": 128154,
			":blue_heart:": 128153,
			":purple_heart:": 128156,
			":broken_heart:": 128148,
			":heart_exclamation:": 10083,
			":two_hearts:": 128149,
			":revolving_hearts:": 128158,
			":heartbeat:": 128147,
			":heartpulse:": 128151,
			":sparkling_heart:": 128150,
			":cupid:": 128152,
			":gift_heart:": 128157,
			":heart_decoration:": 128159,
			":peace:": 9774,
			":cross:": 10013,
			":star_and_crescent:": 9770,
			":om_symbol:": 128329,
			":wheel_of_dharma:": 9784,
			":star_of_david:": 10017,
			":six_pointed_star:": 128303,
			":menorah:": 128334,
			":yin_yang:": 9775,
			":orthodox_cross:": 9766,
			":place_of_worship:": 128720,
			":ophiuchus:": 9934,
			":aries:": 9800,
			":taurus:": 9801,
			":gemini:": 9802,
			":cancer:": 9803,
			":leo:": 9804,
			":virgo:": 9805,
			":libra:": 9806,
			":scorpius:": 9807,
			":sagittarius:": 9808,
			":capricorn:": 9809,
			":aquarius:": 9810,
			":pisces:": 9811,
			":id:": 127380,
			":atom:": 9883,
			":u7a7a:": 127539,
			":u5272:": 127545,
			":radioactive:": 9762,
			":biohazard:": 9763,
			":mobile_phone_off:": 128244,
			":vibration_mode:": 128243,
			":u6709:": 127542,
			":u7121:": 127514,
			":u7533:": 127544,
			":u55b6:": 127546,
			":u6708:": 127543,
			":eight_pointed_black_star:": 10036,
			":vs:": 127386,
			":accept:": 127569,
			":white_flower:": 128174,
			":ideograph_advantage:": 127568,
			":secret:": 12953,
			":congratulations:": 12951,
			":u5408:": 127540,
			":u6e80:": 127541,
			":u7981:": 127538,
			":a:": 127344,
			":b:": 127345,
			":ab:": 127374,
			":cl:": 127377,
			":o2:": 127358,
			":sos:": 127384,
			":no_entry:": 9940,
			":name_badge:": 128219,
			":no_entry_sign:": 128683,
			":x:": 10060,
			":o:": 11093,
			":anger:": 128162,
			":hotsprings:": 9832,
			":no_pedestrians:": 128695,
			":do_not_litter:": 128687,
			":no_bicycles:": 128691,
			":non-potable_water:": 128689,
			":underage:": 128286,
			":no_mobile_phones:": 128245,
			":exclamation:": 10071,
			":grey_exclamation:": 10069,
			":question:": 10067,
			":grey_question:": 10068,
			":bangbang:": 8252,
			":interrobang:": 8265,
			":100:": 128175,
			":low_brightness:": 128261,
			":high_brightness:": 128262,
			":trident:": 128305,
			":fleur-de-lis:": 9884,
			":part_alternation_mark:": 12349,
			":warning:": 9888,
			":children_crossing:": 128696,
			":beginner:": 128304,
			":recycle:": 9851,
			":u6307:": 127535,
			":chart:": 128185,
			":sparkle:": 10055,
			":eight_spoked_asterisk:": 10035,
			":negative_squared_cross_mark:": 10062,
			":white_check_mark:": 9989,
			":diamond_shape_with_a_dot_inside:": 128160,
			":cyclone:": 127744,
			":loop:": 10175,
			":globe_with_meridians:": 127760,
			":m:": 9410,
			":atm:": 127975,
			":sa:": 127490,
			":passport_control:": 128706,
			":customs:": 128707,
			":baggage_claim:": 128708,
			":left_luggage:": 128709,
			":wheelchair:": 9855,
			":no_smoking:": 128685,
			":wc:": 128702,
			":parking:": 127359,
			":potable_water:": 128688,
			":mens:": 128697,
			":womens:": 128698,
			":baby_symbol:": 128700,
			":restroom:": 128699,
			":put_litter_in_its_place:": 128686,
			":cinema:": 127910,
			":signal_strength:": 128246,
			":koko:": 127489,
			":ng:": 127382,
			":ok:": 127383,
			":up:": 127385,
			":cool:": 127378,
			":new:": 127381,
			":free:": 127379,
			":zero:": 48,
			":one:": 49,
			":two:": 50,
			":three:": 51,
			":four:": 52,
			":five:": 53,
			":six:": 54,
			":seven:": 55,
			":eight:": 56,
			":nine:": 57,
			":ten:": 128287,
			":1234:": 128290,
			":arrow_forward:": 9654,
			":pause_button:": 9208,
			":play_pause:": 9199,
			":stop_button:": 9209,
			":record_button:": 9210,
			":track_next:": 9197,
			":track_previous:": 9198,
			":fast_forward:": 9193,
			":rewind:": 9194,
			":twisted_rightwards_arrows:": 128256,
			":repeat:": 128257,
			":repeat_one:": 128258,
			":arrow_backward:": 9664,
			":arrow_up_small:": 128316,
			":arrow_down_small:": 128317,
			":arrow_double_up:": 9195,
			":arrow_double_down:": 9196,
			":arrow_right:": 10145,
			":arrow_left:": 11013,
			":arrow_up:": 11014,
			":arrow_down:": 11015,
			":arrow_upper_right:": 8599,
			":arrow_lower_right:": 8600,
			":arrow_lower_left:": 8601,
			":arrow_upper_left:": 8598,
			":arrow_up_down:": 8597,
			":left_right_arrow:": 8596,
			":arrows_counterclockwise:": 128260,
			":arrow_right_hook:": 8618,
			":leftwards_arrow_with_hook:": 8617,
			":arrow_heading_up:": 10548,
			":arrow_heading_down:": 10549,
			":hash:": 35,
			":asterisk:": 42,
			":information_source:": 8505,
			":abc:": 128292,
			":abcd:": 128289,
			":capital_abcd:": 128288,
			":symbols:": 128291,
			":musical_note:": 127925,
			":notes:": 127926,
			":wavy_dash:": 12336,
			":curly_loop:": 10160,
			":heavy_check_mark:": 10004,
			":arrows_clockwise:": 128259,
			":heavy_plus_sign:": 10133,
			":heavy_minus_sign:": 10134,
			":heavy_division_sign:": 10135,
			":heavy_multiplication_x:": 10006,
			":heavy_dollar_sign:": 128178,
			":currency_exchange:": 128177,
			":copyright:": 169,
			":registered:": 174,
			":tm:": 8482,
			":end:": 128282,
			":back:": 128281,
			":on:": 128283,
			":top:": 128285,
			":soon:": 128284,
			":ballot_box_with_check:": 9745,
			":radio_button:": 128280,
			":white_circle:": 9898,
			":black_circle:": 9899,
			":red_circle:": 128308,
			":large_blue_circle:": 128309,
			":small_orange_diamond:": 128312,
			":small_blue_diamond:": 128313,
			":large_orange_diamond:": 128310,
			":large_blue_diamond:": 128311,
			":small_red_triangle:": 128314,
			":black_small_square:": 9642,
			":white_small_square:": 9643,
			":black_large_square:": 11035,
			":white_large_square:": 11036,
			":small_red_triangle_down:": 128315,
			":black_medium_square:": 9724,
			":white_medium_square:": 9723,
			":black_medium_small_square:": 9726,
			":white_medium_small_square:": 9725,
			":black_square_button:": 128306,
			":white_square_button:": 128307,
			":speaker:": 128264,
			":sound:": 128265,
			":loud_sound:": 128266,
			":mute:": 128263,
			":mega:": 128227,
			":loudspeaker:": 128226,
			":bell:": 128276,
			":no_bell:": 128277,
			":black_joker:": 127183,
			":mahjong:": 126980,
			":spades:": 9824,
			":clubs:": 9827,
			":hearts:": 9829,
			":diamonds:": 9830,
			":flower_playing_cards:": 127924,
			":thought_balloon:": 128173,
			":anger_right:": 128495,
			":speech_balloon:": 128172,
			":clock1:": 128336,
			":clock2:": 128337,
			":clock3:": 128338,
			":clock4:": 128339,
			":clock5:": 128340,
			":clock6:": 128341,
			":clock7:": 128342,
			":clock8:": 128343,
			":clock9:": 128344,
			":clock10:": 128345,
			":clock11:": 128346,
			":clock12:": 128347,
			":clock130:": 128348,
			":clock230:": 128349,
			":clock330:": 128350,
			":clock430:": 128351,
			":clock530:": 128352,
			":clock630:": 128353,
			":clock730:": 128354,
			":clock830:": 128355,
			":clock930:": 128356,
			":clock1030:": 128357,
			":clock1130:": 128358,
			":clock1230:": 128359,
			":eye_in_speech_bubble:": 128065,
			":flag_ac:": 127462,
			":flag_af:": 127462,
			":flag_al:": 127462,
			":flag_dz:": 127465,
			":flag_ad:": 127462,
			":flag_ao:": 127462,
			":flag_ai:": 127462,
			":flag_ag:": 127462,
			":flag_ar:": 127462,
			":flag_am:": 127462,
			":flag_aw:": 127462,
			":flag_au:": 127462,
			":flag_at:": 127462,
			":flag_az:": 127462,
			":flag_bs:": 127463,
			":flag_bh:": 127463,
			":flag_bd:": 127463,
			":flag_bb:": 127463,
			":flag_by:": 127463,
			":flag_be:": 127463,
			":flag_bz:": 127463,
			":flag_bj:": 127463,
			":flag_bm:": 127463,
			":flag_bt:": 127463,
			":flag_bo:": 127463,
			":flag_ba:": 127463,
			":flag_bw:": 127463,
			":flag_br:": 127463,
			":flag_bn:": 127463,
			":flag_bg:": 127463,
			":flag_bf:": 127463,
			":flag_bi:": 127463,
			":flag_cv:": 127464,
			":flag_kh:": 127472,
			":flag_cm:": 127464,
			":flag_ca:": 127464,
			":flag_ky:": 127472,
			":flag_cf:": 127464,
			":flag_td:": 127481,
			":flag_cl:": 127464,
			":flag_cn:": 127464,
			":flag_co:": 127464,
			":flag_km:": 127472,
			":flag_cg:": 127464,
			":flag_cd:": 127464,
			":flag_cr:": 127464,
			":flag_hr:": 127469,
			":flag_cu:": 127464,
			":flag_cy:": 127464,
			":flag_cz:": 127464,
			":flag_dk:": 127465,
			":flag_dj:": 127465,
			":flag_dm:": 127465,
			":flag_do:": 127465,
			":flag_ec:": 127466,
			":flag_eg:": 127466,
			":flag_sv:": 127480,
			":flag_gq:": 127468,
			":flag_er:": 127466,
			":flag_ee:": 127466,
			":flag_et:": 127466,
			":flag_fk:": 127467,
			":flag_fo:": 127467,
			":flag_fj:": 127467,
			":flag_fi:": 127467,
			":flag_fr:": 127467,
			":flag_pf:": 127477,
			":flag_ga:": 127468,
			":flag_gm:": 127468,
			":flag_ge:": 127468,
			":flag_de:": 127465,
			":flag_gh:": 127468,
			":flag_gi:": 127468,
			":flag_gr:": 127468,
			":flag_gl:": 127468,
			":flag_gd:": 127468,
			":flag_gu:": 127468,
			":flag_gt:": 127468,
			":flag_gn:": 127468,
			":flag_gw:": 127468,
			":flag_gy:": 127468,
			":flag_ht:": 127469,
			":flag_hn:": 127469,
			":flag_hk:": 127469,
			":flag_hu:": 127469,
			":flag_is:": 127470,
			":flag_in:": 127470,
			":flag_id:": 127470,
			":flag_ir:": 127470,
			":flag_iq:": 127470,
			":flag_ie:": 127470,
			":flag_il:": 127470,
			":flag_it:": 127470,
			":flag_ci:": 127464,
			":flag_jm:": 127471,
			":flag_jp:": 127471,
			":flag_je:": 127471,
			":flag_jo:": 127471,
			":flag_kz:": 127472,
			":flag_ke:": 127472,
			":flag_ki:": 127472,
			":flag_xk:": 127485,
			":flag_kw:": 127472,
			":flag_kg:": 127472,
			":flag_la:": 127473,
			":flag_lv:": 127473,
			":flag_lb:": 127473,
			":flag_ls:": 127473,
			":flag_lr:": 127473,
			":flag_ly:": 127473,
			":flag_li:": 127473,
			":flag_lt:": 127473,
			":flag_lu:": 127473,
			":flag_mo:": 127474,
			":flag_mk:": 127474,
			":flag_mg:": 127474,
			":flag_mw:": 127474,
			":flag_my:": 127474,
			":flag_mv:": 127474,
			":flag_ml:": 127474,
			":flag_mt:": 127474,
			":flag_mh:": 127474,
			":flag_mr:": 127474,
			":flag_mu:": 127474,
			":flag_mx:": 127474,
			":flag_fm:": 127467,
			":flag_md:": 127474,
			":flag_mc:": 127474,
			":flag_mn:": 127474,
			":flag_me:": 127474,
			":flag_ms:": 127474,
			":flag_ma:": 127474,
			":flag_mz:": 127474,
			":flag_mm:": 127474,
			":flag_na:": 127475,
			":flag_nr:": 127475,
			":flag_np:": 127475,
			":flag_nl:": 127475,
			":flag_nc:": 127475,
			":flag_nz:": 127475,
			":flag_ni:": 127475,
			":flag_ne:": 127475,
			":flag_ng:": 127475,
			":flag_nu:": 127475,
			":flag_kp:": 127472,
			":flag_no:": 127475,
			":flag_om:": 127476,
			":flag_pk:": 127477,
			":flag_pw:": 127477,
			":flag_ps:": 127477,
			":flag_pa:": 127477,
			":flag_pg:": 127477,
			":flag_py:": 127477,
			":flag_pe:": 127477,
			":flag_ph:": 127477,
			":flag_pl:": 127477,
			":flag_pt:": 127477,
			":flag_pr:": 127477,
			":flag_qa:": 127478,
			":flag_ro:": 127479,
			":flag_ru:": 127479,
			":flag_rw:": 127479,
			":flag_sh:": 127480,
			":flag_kn:": 127472,
			":flag_lc:": 127473,
			":flag_vc:": 127483,
			":flag_ws:": 127484,
			":flag_sm:": 127480,
			":flag_st:": 127480,
			":flag_sa:": 127480,
			":flag_sn:": 127480,
			":flag_rs:": 127479,
			":flag_sc:": 127480,
			":flag_sl:": 127480,
			":flag_sg:": 127480,
			":flag_sk:": 127480,
			":flag_si:": 127480,
			":flag_sb:": 127480,
			":flag_so:": 127480,
			":flag_za:": 127487,
			":flag_kr:": 127472,
			":flag_es:": 127466,
			":flag_lk:": 127473,
			":flag_sd:": 127480,
			":flag_sr:": 127480,
			":flag_sz:": 127480,
			":flag_se:": 127480,
			":flag_ch:": 127464,
			":flag_sy:": 127480,
			":flag_tw:": 127481,
			":flag_tj:": 127481,
			":flag_tz:": 127481,
			":flag_th:": 127481,
			":flag_tl:": 127481,
			":flag_tg:": 127481,
			":flag_to:": 127481,
			":flag_tt:": 127481,
			":flag_tn:": 127481,
			":flag_tr:": 127481,
			":flag_tm:": 127481,
			":flag_tv:": 127481,
			":flag_ug:": 127482,
			":flag_ua:": 127482,
			":flag_ae:": 127462,
			":flag_gb:": 127468,
			":flag_us:": 127482,
			":flag_vi:": 127483,
			":flag_uy:": 127482,
			":flag_uz:": 127482,
			":flag_vu:": 127483,
			":flag_va:": 127483,
			":flag_ve:": 127483,
			":flag_vn:": 127483,
			":flag_wf:": 127484,
			":flag_eh:": 127466,
			":flag_ye:": 127486,
			":flag_zm:": 127487,
			":flag_zw:": 127487,
			":flag_re:": 127479,
			":flag_ax:": 127462,
			":flag_ta:": 127481,
			":flag_io:": 127470,
			":flag_bq:": 127463,
			":flag_cx:": 127464,
			":flag_cc:": 127464,
			":flag_gg:": 127468,
			":flag_im:": 127470,
			":flag_yt:": 127486,
			":flag_nf:": 127475,
			":flag_pn:": 127477,
			":flag_bl:": 127463,
			":flag_pm:": 127477,
			":flag_gs:": 127468,
			":flag_tk:": 127481,
			":flag_bv:": 127463,
			":flag_hm:": 127469,
			":flag_sj:": 127480,
			":flag_um:": 127482,
			":flag_ic:": 127470,
			":flag_ea:": 127466,
			":flag_cp:": 127464,
			":flag_dg:": 127465,
			":flag_as:": 127462,
			":flag_aq:": 127462,
			":flag_vg:": 127483,
			":flag_ck:": 127464,
			":flag_cw:": 127464,
			":flag_eu:": 127466,
			":flag_gf:": 127468,
			":flag_tf:": 127481,
			":flag_gp:": 127468,
			":flag_mq:": 127474,
			":flag_mp:": 127474,
			":flag_sx:": 127480,
			":flag_ss:": 127480,
			":flag_tc:": 127481,
			":flag_mf:": 127474,
			":raised_hands_tone1:": 128588,
			":raised_hands_tone2:": 128588,
			":raised_hands_tone3:": 128588,
			":raised_hands_tone4:": 128588,
			":raised_hands_tone5:": 128588,
			":clap_tone1:": 128079,
			":clap_tone2:": 128079,
			":clap_tone3:": 128079,
			":clap_tone4:": 128079,
			":clap_tone5:": 128079,
			":wave_tone1:": 128075,
			":wave_tone2:": 128075,
			":wave_tone3:": 128075,
			":wave_tone4:": 128075,
			":wave_tone5:": 128075,
			":thumbsup_tone1:": 128077,
			":thumbsup_tone2:": 128077,
			":thumbsup_tone3:": 128077,
			":thumbsup_tone4:": 128077,
			":thumbsup_tone5:": 128077,
			":thumbsdown_tone1:": 128078,
			":thumbsdown_tone2:": 128078,
			":thumbsdown_tone3:": 128078,
			":thumbsdown_tone4:": 128078,
			":thumbsdown_tone5:": 128078,
			":punch_tone1:": 128074,
			":punch_tone2:": 128074,
			":punch_tone3:": 128074,
			":punch_tone4:": 128074,
			":punch_tone5:": 128074,
			":fist_tone1:": 9994,
			":fist_tone2:": 9994,
			":fist_tone3:": 9994,
			":fist_tone4:": 9994,
			":fist_tone5:": 9994,
			":v_tone1:": 9996,
			":v_tone2:": 9996,
			":v_tone3:": 9996,
			":v_tone4:": 9996,
			":v_tone5:": 9996,
			":ok_hand_tone1:": 128076,
			":ok_hand_tone2:": 128076,
			":ok_hand_tone3:": 128076,
			":ok_hand_tone4:": 128076,
			":ok_hand_tone5:": 128076,
			":raised_hand_tone1:": 9995,
			":raised_hand_tone2:": 9995,
			":raised_hand_tone3:": 9995,
			":raised_hand_tone4:": 9995,
			":raised_hand_tone5:": 9995,
			":open_hands_tone1:": 128080,
			":open_hands_tone2:": 128080,
			":open_hands_tone3:": 128080,
			":open_hands_tone4:": 128080,
			":open_hands_tone5:": 128080,
			":muscle_tone1:": 128170,
			":muscle_tone2:": 128170,
			":muscle_tone3:": 128170,
			":muscle_tone4:": 128170,
			":muscle_tone5:": 128170,
			":pray_tone1:": 128591,
			":pray_tone2:": 128591,
			":pray_tone3:": 128591,
			":pray_tone4:": 128591,
			":pray_tone5:": 128591,
			":point_up_tone1:": 9757,
			":point_up_tone2:": 9757,
			":point_up_tone3:": 9757,
			":point_up_tone4:": 9757,
			":point_up_tone5:": 9757,
			":point_up_2_tone1:": 128070,
			":point_up_2_tone2:": 128070,
			":point_up_2_tone3:": 128070,
			":point_up_2_tone4:": 128070,
			":point_up_2_tone5:": 128070,
			":point_down_tone1:": 128071,
			":point_down_tone2:": 128071,
			":point_down_tone3:": 128071,
			":point_down_tone4:": 128071,
			":point_down_tone5:": 128071,
			":point_left_tone1:": 128072,
			":point_left_tone2:": 128072,
			":point_left_tone3:": 128072,
			":point_left_tone4:": 128072,
			":point_left_tone5:": 128072,
			":point_right_tone1:": 128073,
			":point_right_tone2:": 128073,
			":point_right_tone3:": 128073,
			":point_right_tone4:": 128073,
			":point_right_tone5:": 128073,
			":middle_finger_tone1:": 128405,
			":middle_finger_tone2:": 128405,
			":middle_finger_tone3:": 128405,
			":middle_finger_tone4:": 128405,
			":middle_finger_tone5:": 128405,
			":hand_splayed_tone1:": 128400,
			":hand_splayed_tone2:": 128400,
			":hand_splayed_tone3:": 128400,
			":hand_splayed_tone4:": 128400,
			":hand_splayed_tone5:": 128400,
			":metal_tone1:": 129304,
			":metal_tone2:": 129304,
			":metal_tone3:": 129304,
			":metal_tone4:": 129304,
			":metal_tone5:": 129304,
			":vulcan_tone1:": 128406,
			":vulcan_tone2:": 128406,
			":vulcan_tone3:": 128406,
			":vulcan_tone4:": 128406,
			":vulcan_tone5:": 128406,
			":writing_hand_tone1:": 9997,
			":writing_hand_tone2:": 9997,
			":writing_hand_tone3:": 9997,
			":writing_hand_tone4:": 9997,
			":writing_hand_tone5:": 9997,
			":nail_care_tone1:": 128133,
			":nail_care_tone2:": 128133,
			":nail_care_tone3:": 128133,
			":nail_care_tone4:": 128133,
			":nail_care_tone5:": 128133,
			":ear_tone1:": 128066,
			":ear_tone2:": 128066,
			":ear_tone3:": 128066,
			":ear_tone4:": 128066,
			":ear_tone5:": 128066,
			":nose_tone1:": 128067,
			":nose_tone2:": 128067,
			":nose_tone3:": 128067,
			":nose_tone4:": 128067,
			":nose_tone5:": 128067,
			":baby_tone1:": 128118,
			":baby_tone2:": 128118,
			":baby_tone3:": 128118,
			":baby_tone4:": 128118,
			":baby_tone5:": 128118,
			":boy_tone1:": 128102,
			":boy_tone2:": 128102,
			":boy_tone3:": 128102,
			":boy_tone4:": 128102,
			":boy_tone5:": 128102,
			":girl_tone1:": 128103,
			":girl_tone2:": 128103,
			":girl_tone3:": 128103,
			":girl_tone4:": 128103,
			":girl_tone5:": 128103,
			":man_tone1:": 128104,
			":man_tone2:": 128104,
			":man_tone3:": 128104,
			":man_tone4:": 128104,
			":man_tone5:": 128104,
			":woman_tone1:": 128105,
			":woman_tone2:": 128105,
			":woman_tone3:": 128105,
			":woman_tone4:": 128105,
			":woman_tone5:": 128105,
			":person_with_blond_hair_tone1:": 128113,
			":person_with_blond_hair_tone2:": 128113,
			":person_with_blond_hair_tone3:": 128113,
			":person_with_blond_hair_tone4:": 128113,
			":person_with_blond_hair_tone5:": 128113,
			":older_man_tone1:": 128116,
			":older_man_tone2:": 128116,
			":older_man_tone3:": 128116,
			":older_man_tone4:": 128116,
			":older_man_tone5:": 128116,
			":older_woman_tone1:": 128117,
			":older_woman_tone2:": 128117,
			":older_woman_tone3:": 128117,
			":older_woman_tone4:": 128117,
			":older_woman_tone5:": 128117,
			":man_with_gua_pi_mao_tone1:": 128114,
			":man_with_gua_pi_mao_tone2:": 128114,
			":man_with_gua_pi_mao_tone3:": 128114,
			":man_with_gua_pi_mao_tone4:": 128114,
			":man_with_gua_pi_mao_tone5:": 128114,
			":man_with_turban_tone1:": 128115,
			":man_with_turban_tone2:": 128115,
			":man_with_turban_tone3:": 128115,
			":man_with_turban_tone4:": 128115,
			":man_with_turban_tone5:": 128115,
			":cop_tone1:": 128110,
			":cop_tone2:": 128110,
			":cop_tone3:": 128110,
			":cop_tone4:": 128110,
			":cop_tone5:": 128110,
			":construction_worker_tone1:": 128119,
			":construction_worker_tone2:": 128119,
			":construction_worker_tone3:": 128119,
			":construction_worker_tone4:": 128119,
			":construction_worker_tone5:": 128119,
			":guardsman_tone1:": 128130,
			":guardsman_tone2:": 128130,
			":guardsman_tone3:": 128130,
			":guardsman_tone4:": 128130,
			":guardsman_tone5:": 128130,
			":santa_tone1:": 127877,
			":santa_tone2:": 127877,
			":santa_tone3:": 127877,
			":santa_tone4:": 127877,
			":santa_tone5:": 127877,
			":angel_tone1:": 128124,
			":angel_tone2:": 128124,
			":angel_tone3:": 128124,
			":angel_tone4:": 128124,
			":angel_tone5:": 128124,
			":princess_tone1:": 128120,
			":princess_tone2:": 128120,
			":princess_tone3:": 128120,
			":princess_tone4:": 128120,
			":princess_tone5:": 128120,
			":bride_with_veil_tone1:": 128112,
			":bride_with_veil_tone2:": 128112,
			":bride_with_veil_tone3:": 128112,
			":bride_with_veil_tone4:": 128112,
			":bride_with_veil_tone5:": 128112,
			":walking_tone1:": 128694,
			":walking_tone2:": 128694,
			":walking_tone3:": 128694,
			":walking_tone4:": 128694,
			":walking_tone5:": 128694,
			":runner_tone1:": 127939,
			":runner_tone2:": 127939,
			":runner_tone3:": 127939,
			":runner_tone4:": 127939,
			":runner_tone5:": 127939,
			":dancer_tone1:": 128131,
			":dancer_tone2:": 128131,
			":dancer_tone3:": 128131,
			":dancer_tone4:": 128131,
			":dancer_tone5:": 128131,
			":bow_tone1:": 128583,
			":bow_tone2:": 128583,
			":bow_tone3:": 128583,
			":bow_tone4:": 128583,
			":bow_tone5:": 128583,
			":information_desk_person_tone1:": 128129,
			":information_desk_person_tone2:": 128129,
			":information_desk_person_tone3:": 128129,
			":information_desk_person_tone4:": 128129,
			":information_desk_person_tone5:": 128129,
			":no_good_tone1:": 128581,
			":no_good_tone2:": 128581,
			":no_good_tone3:": 128581,
			":no_good_tone4:": 128581,
			":no_good_tone5:": 128581,
			":ok_woman_tone1:": 128582,
			":ok_woman_tone2:": 128582,
			":ok_woman_tone3:": 128582,
			":ok_woman_tone4:": 128582,
			":ok_woman_tone5:": 128582,
			":raising_hand_tone1:": 128587,
			":raising_hand_tone2:": 128587,
			":raising_hand_tone3:": 128587,
			":raising_hand_tone4:": 128587,
			":raising_hand_tone5:": 128587,
			":person_with_pouting_face_tone1:": 128590,
			":person_with_pouting_face_tone2:": 128590,
			":person_with_pouting_face_tone3:": 128590,
			":person_with_pouting_face_tone4:": 128590,
			":person_with_pouting_face_tone5:": 128590,
			":person_frowning_tone1:": 128589,
			":person_frowning_tone2:": 128589,
			":person_frowning_tone3:": 128589,
			":person_frowning_tone4:": 128589,
			":person_frowning_tone5:": 128589,
			":haircut_tone1:": 128135,
			":haircut_tone2:": 128135,
			":haircut_tone3:": 128135,
			":haircut_tone4:": 128135,
			":haircut_tone5:": 128135,
			":massage_tone1:": 128134,
			":massage_tone2:": 128134,
			":massage_tone3:": 128134,
			":massage_tone4:": 128134,
			":massage_tone5:": 128134,
			":rowboat_tone1:": 128675,
			":rowboat_tone2:": 128675,
			":rowboat_tone3:": 128675,
			":rowboat_tone4:": 128675,
			":rowboat_tone5:": 128675,
			":swimmer_tone1:": 127946,
			":swimmer_tone2:": 127946,
			":swimmer_tone3:": 127946,
			":swimmer_tone4:": 127946,
			":swimmer_tone5:": 127946,
			":surfer_tone1:": 127940,
			":surfer_tone2:": 127940,
			":surfer_tone3:": 127940,
			":surfer_tone4:": 127940,
			":surfer_tone5:": 127940,
			":bath_tone1:": 128704,
			":bath_tone2:": 128704,
			":bath_tone3:": 128704,
			":bath_tone4:": 128704,
			":bath_tone5:": 128704,
			":basketball_player_tone1:": 9977,
			":basketball_player_tone2:": 9977,
			":basketball_player_tone3:": 9977,
			":basketball_player_tone4:": 9977,
			":basketball_player_tone5:": 9977,
			":lifter_tone1:": 127947,
			":lifter_tone2:": 127947,
			":lifter_tone3:": 127947,
			":lifter_tone4:": 127947,
			":lifter_tone5:": 127947,
			":bicyclist_tone1:": 128692,
			":bicyclist_tone2:": 128692,
			":bicyclist_tone3:": 128692,
			":bicyclist_tone4:": 128692,
			":bicyclist_tone5:": 128692,
			":mountain_bicyclist_tone1:": 128693,
			":mountain_bicyclist_tone2:": 128693,
			":mountain_bicyclist_tone3:": 128693,
			":mountain_bicyclist_tone4:": 128693,
			":mountain_bicyclist_tone5:": 128693,
			":horse_racing_tone1:": 127943,
			":horse_racing_tone2:": 127943,
			":horse_racing_tone3:": 127943,
			":horse_racing_tone4:": 127943,
			":horse_racing_tone5:": 127943,
			":spy_tone1:": 128373,
			":spy_tone2:": 128373,
			":spy_tone3:": 128373,
			":spy_tone4:": 128373,
			":spy_tone5:": 128373
		},
		"categories": [
			{
				"id": "people",
				"name": "Smilies & People",
				"emoji": [
					":grinning:",
					":grimacing:",
					":grin:",
					":joy:",
					":smiley:",
					":smile:",
					":sweat_smile:",
					":laughing:",
					":innocent:",
					":wink:",
					":blush:",
					":slight_smile:",
					":upside_down:",
					":relaxed:",
					":yum:",
					":relieved:",
					":heart_eyes:",
					":kissing_heart:",
					":kissing:",
					":kissing_smiling_eyes:",
					":kissing_closed_eyes:",
					":stuck_out_tongue_winking_eye:",
					":stuck_out_tongue_closed_eyes:",
					":stuck_out_tongue:",
					":money_mouth:",
					":nerd:",
					":sunglasses:",
					":hugging:",
					":smirk:",
					":no_mouth:",
					":neutral_face:",
					":expressionless:",
					":unamused:",
					":rolling_eyes:",
					":thinking:",
					":flushed:",
					":disappointed:",
					":worried:",
					":angry:",
					":rage:",
					":pensive:",
					":confused:",
					":slight_frown:",
					":frowning2:",
					":persevere:",
					":confounded:",
					":tired_face:",
					":weary:",
					":triumph:",
					":open_mouth:",
					":scream:",
					":fearful:",
					":cold_sweat:",
					":hushed:",
					":frowning:",
					":anguished:",
					":cry:",
					":disappointed_relieved:",
					":sleepy:",
					":sweat:",
					":sob:",
					":dizzy_face:",
					":astonished:",
					":zipper_mouth:",
					":mask:",
					":thermometer_face:",
					":head_bandage:",
					":sleeping:",
					":zzz:",
					":poop:",
					":smiling_imp:",
					":imp:",
					":japanese_ogre:",
					":japanese_goblin:",
					":skull:",
					":ghost:",
					":alien:",
					":robot:",
					":smiley_cat:",
					":smile_cat:",
					":joy_cat:",
					":heart_eyes_cat:",
					":smirk_cat:",
					":kissing_cat:",
					":scream_cat:",
					":crying_cat_face:",
					":pouting_cat:",
					":raised_hands:",
					":clap:",
					":wave:",
					":thumbsup:",
					":thumbsdown:",
					":punch:",
					":fist:",
					":v:",
					":ok_hand:",
					":raised_hand:",
					":open_hands:",
					":muscle:",
					":pray:",
					":point_up:",
					":point_up_2:",
					":point_down:",
					":point_left:",
					":point_right:",
					":middle_finger:",
					":hand_splayed:",
					":metal:",
					":vulcan:",
					":writing_hand:",
					":nail_care:",
					":lips:",
					":tongue:",
					":ear:",
					":nose:",
					":eye:",
					":eyes:",
					":bust_in_silhouette:",
					":busts_in_silhouette:",
					":speaking_head:",
					":baby:",
					":boy:",
					":girl:",
					":man:",
					":woman:",
					":person_with_blond_hair:",
					":older_man:",
					":older_woman:",
					":man_with_gua_pi_mao:",
					":man_with_turban:",
					":cop:",
					":construction_worker:",
					":guardsman:",
					":spy:",
					":santa:",
					":angel:",
					":princess:",
					":bride_with_veil:",
					":walking:",
					":runner:",
					":dancer:",
					":dancers:",
					":couple:",
					":two_men_holding_hands:",
					":two_women_holding_hands:",
					":bow:",
					":information_desk_person:",
					":no_good:",
					":ok_woman:",
					":raising_hand:",
					":person_with_pouting_face:",
					":person_frowning:",
					":haircut:",
					":massage:",
					":couple_with_heart:",
					":couple_ww:",
					":couple_mm:",
					":couplekiss:",
					":kiss_ww:",
					":kiss_mm:",
					":family:",
					":family_mwg:",
					":family_mwgb:",
					":family_mwbb:",
					":family_mwgg:",
					":family_wwb:",
					":family_wwg:",
					":family_wwgb:",
					":family_wwbb:",
					":family_wwgg:",
					":family_mmb:",
					":family_mmg:",
					":family_mmgb:",
					":family_mmbb:",
					":family_mmgg:",
					":womans_clothes:",
					":shirt:",
					":jeans:",
					":necktie:",
					":dress:",
					":bikini:",
					":kimono:",
					":lipstick:",
					":kiss:",
					":footprints:",
					":high_heel:",
					":sandal:",
					":boot:",
					":mans_shoe:",
					":athletic_shoe:",
					":womans_hat:",
					":tophat:",
					":helmet_with_cross:",
					":mortar_board:",
					":crown:",
					":school_satchel:",
					":pouch:",
					":purse:",
					":handbag:",
					":briefcase:",
					":eyeglasses:",
					":dark_sunglasses:",
					":ring:",
					":closed_umbrella:",
					":raised_hands_tone1:",
					":raised_hands_tone2:",
					":raised_hands_tone3:",
					":raised_hands_tone4:",
					":raised_hands_tone5:",
					":clap_tone1:",
					":clap_tone2:",
					":clap_tone3:",
					":clap_tone4:",
					":clap_tone5:",
					":wave_tone1:",
					":wave_tone2:",
					":wave_tone3:",
					":wave_tone4:",
					":wave_tone5:",
					":thumbsup_tone1:",
					":thumbsup_tone2:",
					":thumbsup_tone3:",
					":thumbsup_tone4:",
					":thumbsup_tone5:",
					":thumbsdown_tone1:",
					":thumbsdown_tone2:",
					":thumbsdown_tone3:",
					":thumbsdown_tone4:",
					":thumbsdown_tone5:",
					":punch_tone1:",
					":punch_tone2:",
					":punch_tone3:",
					":punch_tone4:",
					":punch_tone5:",
					":fist_tone1:",
					":fist_tone2:",
					":fist_tone3:",
					":fist_tone4:",
					":fist_tone5:",
					":v_tone1:",
					":v_tone2:",
					":v_tone3:",
					":v_tone4:",
					":v_tone5:",
					":ok_hand_tone1:",
					":ok_hand_tone2:",
					":ok_hand_tone3:",
					":ok_hand_tone4:",
					":ok_hand_tone5:",
					":raised_hand_tone1:",
					":raised_hand_tone2:",
					":raised_hand_tone3:",
					":raised_hand_tone4:",
					":raised_hand_tone5:",
					":open_hands_tone1:",
					":open_hands_tone2:",
					":open_hands_tone3:",
					":open_hands_tone4:",
					":open_hands_tone5:",
					":muscle_tone1:",
					":muscle_tone2:",
					":muscle_tone3:",
					":muscle_tone4:",
					":muscle_tone5:",
					":pray_tone1:",
					":pray_tone2:",
					":pray_tone3:",
					":pray_tone4:",
					":pray_tone5:",
					":point_up_tone1:",
					":point_up_tone2:",
					":point_up_tone3:",
					":point_up_tone4:",
					":point_up_tone5:",
					":point_up_2_tone1:",
					":point_up_2_tone2:",
					":point_up_2_tone3:",
					":point_up_2_tone4:",
					":point_up_2_tone5:",
					":point_down_tone1:",
					":point_down_tone2:",
					":point_down_tone3:",
					":point_down_tone4:",
					":point_down_tone5:",
					":point_left_tone1:",
					":point_left_tone2:",
					":point_left_tone3:",
					":point_left_tone4:",
					":point_left_tone5:",
					":point_right_tone1:",
					":point_right_tone2:",
					":point_right_tone3:",
					":point_right_tone4:",
					":point_right_tone5:",
					":middle_finger_tone1:",
					":middle_finger_tone2:",
					":middle_finger_tone3:",
					":middle_finger_tone4:",
					":middle_finger_tone5:",
					":hand_splayed_tone1:",
					":hand_splayed_tone2:",
					":hand_splayed_tone3:",
					":hand_splayed_tone4:",
					":hand_splayed_tone5:",
					":metal_tone1:",
					":metal_tone2:",
					":metal_tone3:",
					":metal_tone4:",
					":metal_tone5:",
					":vulcan_tone1:",
					":vulcan_tone2:",
					":vulcan_tone3:",
					":vulcan_tone4:",
					":vulcan_tone5:",
					":writing_hand_tone1:",
					":writing_hand_tone2:",
					":writing_hand_tone3:",
					":writing_hand_tone4:",
					":writing_hand_tone5:",
					":nail_care_tone1:",
					":nail_care_tone2:",
					":nail_care_tone3:",
					":nail_care_tone4:",
					":nail_care_tone5:",
					":ear_tone1:",
					":ear_tone2:",
					":ear_tone3:",
					":ear_tone4:",
					":ear_tone5:",
					":nose_tone1:",
					":nose_tone2:",
					":nose_tone3:",
					":nose_tone4:",
					":nose_tone5:",
					":baby_tone1:",
					":baby_tone2:",
					":baby_tone3:",
					":baby_tone4:",
					":baby_tone5:",
					":boy_tone1:",
					":boy_tone2:",
					":boy_tone3:",
					":boy_tone4:",
					":boy_tone5:",
					":girl_tone1:",
					":girl_tone2:",
					":girl_tone3:",
					":girl_tone4:",
					":girl_tone5:",
					":man_tone1:",
					":man_tone2:",
					":man_tone3:",
					":man_tone4:",
					":man_tone5:",
					":woman_tone1:",
					":woman_tone2:",
					":woman_tone3:",
					":woman_tone4:",
					":woman_tone5:",
					":person_with_blond_hair_tone1:",
					":person_with_blond_hair_tone2:",
					":person_with_blond_hair_tone3:",
					":person_with_blond_hair_tone4:",
					":person_with_blond_hair_tone5:",
					":older_man_tone1:",
					":older_man_tone2:",
					":older_man_tone3:",
					":older_man_tone4:",
					":older_man_tone5:",
					":older_woman_tone1:",
					":older_woman_tone2:",
					":older_woman_tone3:",
					":older_woman_tone4:",
					":older_woman_tone5:",
					":man_with_gua_pi_mao_tone1:",
					":man_with_gua_pi_mao_tone2:",
					":man_with_gua_pi_mao_tone3:",
					":man_with_gua_pi_mao_tone4:",
					":man_with_gua_pi_mao_tone5:",
					":man_with_turban_tone1:",
					":man_with_turban_tone2:",
					":man_with_turban_tone3:",
					":man_with_turban_tone4:",
					":man_with_turban_tone5:",
					":cop_tone1:",
					":cop_tone2:",
					":cop_tone3:",
					":cop_tone4:",
					":cop_tone5:",
					":construction_worker_tone1:",
					":construction_worker_tone2:",
					":construction_worker_tone3:",
					":construction_worker_tone4:",
					":construction_worker_tone5:",
					":guardsman_tone1:",
					":guardsman_tone2:",
					":guardsman_tone3:",
					":guardsman_tone4:",
					":guardsman_tone5:",
					":santa_tone1:",
					":santa_tone2:",
					":santa_tone3:",
					":santa_tone4:",
					":santa_tone5:",
					":angel_tone1:",
					":angel_tone2:",
					":angel_tone3:",
					":angel_tone4:",
					":angel_tone5:",
					":princess_tone1:",
					":princess_tone2:",
					":princess_tone3:",
					":princess_tone4:",
					":princess_tone5:",
					":bride_with_veil_tone1:",
					":bride_with_veil_tone2:",
					":bride_with_veil_tone3:",
					":bride_with_veil_tone4:",
					":bride_with_veil_tone5:",
					":walking_tone1:",
					":walking_tone2:",
					":walking_tone3:",
					":walking_tone4:",
					":walking_tone5:",
					":runner_tone1:",
					":runner_tone2:",
					":runner_tone3:",
					":runner_tone4:",
					":runner_tone5:",
					":dancer_tone1:",
					":dancer_tone2:",
					":dancer_tone3:",
					":dancer_tone4:",
					":dancer_tone5:",
					":bow_tone1:",
					":bow_tone2:",
					":bow_tone3:",
					":bow_tone4:",
					":bow_tone5:",
					":information_desk_person_tone1:",
					":information_desk_person_tone2:",
					":information_desk_person_tone3:",
					":information_desk_person_tone4:",
					":information_desk_person_tone5:",
					":no_good_tone1:",
					":no_good_tone2:",
					":no_good_tone3:",
					":no_good_tone4:",
					":no_good_tone5:",
					":ok_woman_tone1:",
					":ok_woman_tone2:",
					":ok_woman_tone3:",
					":ok_woman_tone4:",
					":ok_woman_tone5:",
					":raising_hand_tone1:",
					":raising_hand_tone2:",
					":raising_hand_tone3:",
					":raising_hand_tone4:",
					":raising_hand_tone5:",
					":person_with_pouting_face_tone1:",
					":person_with_pouting_face_tone2:",
					":person_with_pouting_face_tone3:",
					":person_with_pouting_face_tone4:",
					":person_with_pouting_face_tone5:",
					":person_frowning_tone1:",
					":person_frowning_tone2:",
					":person_frowning_tone3:",
					":person_frowning_tone4:",
					":person_frowning_tone5:",
					":haircut_tone1:",
					":haircut_tone2:",
					":haircut_tone3:",
					":haircut_tone4:",
					":haircut_tone5:",
					":massage_tone1:",
					":massage_tone2:",
					":massage_tone3:",
					":massage_tone4:",
					":massage_tone5:",
					":spy_tone1:",
					":spy_tone2:",
					":spy_tone3:",
					":spy_tone4:",
					":spy_tone5:"
				]
			},
			{
				"id": "nature",
				"name": "Animals & Nature",
				"emoji": [
					":dog:",
					":cat:",
					":mouse:",
					":hamster:",
					":rabbit:",
					":bear:",
					":panda_face:",
					":koala:",
					":tiger:",
					":lion_face:",
					":cow:",
					":pig:",
					":pig_nose:",
					":frog:",
					":octopus:",
					":monkey_face:",
					":see_no_evil:",
					":hear_no_evil:",
					":speak_no_evil:",
					":monkey:",
					":chicken:",
					":penguin:",
					":bird:",
					":baby_chick:",
					":hatching_chick:",
					":hatched_chick:",
					":wolf:",
					":boar:",
					":horse:",
					":unicorn:",
					":bee:",
					":bug:",
					":snail:",
					":beetle:",
					":ant:",
					":spider:",
					":scorpion:",
					":crab:",
					":snake:",
					":turtle:",
					":tropical_fish:",
					":fish:",
					":blowfish:",
					":dolphin:",
					":whale:",
					":whale2:",
					":crocodile:",
					":leopard:",
					":tiger2:",
					":water_buffalo:",
					":ox:",
					":cow2:",
					":dromedary_camel:",
					":camel:",
					":elephant:",
					":goat:",
					":ram:",
					":sheep:",
					":racehorse:",
					":pig2:",
					":rat:",
					":mouse2:",
					":rooster:",
					":turkey:",
					":dove:",
					":dog2:",
					":poodle:",
					":cat2:",
					":rabbit2:",
					":chipmunk:",
					":feet:",
					":dragon:",
					":dragon_face:",
					":cactus:",
					":christmas_tree:",
					":evergreen_tree:",
					":deciduous_tree:",
					":palm_tree:",
					":seedling:",
					":herb:",
					":shamrock:",
					":four_leaf_clover:",
					":bamboo:",
					":tanabata_tree:",
					":leaves:",
					":fallen_leaf:",
					":maple_leaf:",
					":ear_of_rice:",
					":hibiscus:",
					":sunflower:",
					":rose:",
					":tulip:",
					":blossom:",
					":cherry_blossom:",
					":bouquet:",
					":mushroom:",
					":chestnut:",
					":jack_o_lantern:",
					":shell:",
					":spider_web:",
					":earth_americas:",
					":earth_africa:",
					":earth_asia:",
					":full_moon:",
					":waning_gibbous_moon:",
					":last_quarter_moon:",
					":waning_crescent_moon:",
					":new_moon:",
					":waxing_crescent_moon:",
					":first_quarter_moon:",
					":waxing_gibbous_moon:",
					":new_moon_with_face:",
					":full_moon_with_face:",
					":first_quarter_moon_with_face:",
					":last_quarter_moon_with_face:",
					":sun_with_face:",
					":crescent_moon:",
					":star:",
					":star2:",
					":dizzy:",
					":sparkles:",
					":comet:",
					":sunny:",
					":white_sun_small_cloud:",
					":partly_sunny:",
					":white_sun_cloud:",
					":white_sun_rain_cloud:",
					":cloud:",
					":cloud_rain:",
					":thunder_cloud_rain:",
					":cloud_lightning:",
					":zap:",
					":fire:",
					":boom:",
					":snowflake:",
					":cloud_snow:",
					":snowman2:",
					":snowman:",
					":wind_blowing_face:",
					":dash:",
					":cloud_tornado:",
					":fog:",
					":umbrella2:",
					":umbrella:",
					":droplet:",
					":sweat_drops:",
					":ocean:"
				]
			},
			{
				"id": "food",
				"name": "Food & Drink",
				"emoji": [
					":green_apple:",
					":apple:",
					":pear:",
					":tangerine:",
					":lemon:",
					":banana:",
					":watermelon:",
					":grapes:",
					":strawberry:",
					":melon:",
					":cherries:",
					":peach:",
					":pineapple:",
					":tomato:",
					":eggplant:",
					":hot_pepper:",
					":corn:",
					":sweet_potato:",
					":honey_pot:",
					":bread:",
					":cheese:",
					":poultry_leg:",
					":meat_on_bone:",
					":fried_shrimp:",
					":egg:",
					":hamburger:",
					":fries:",
					":hotdog:",
					":pizza:",
					":spaghetti:",
					":taco:",
					":burrito:",
					":ramen:",
					":stew:",
					":fish_cake:",
					":sushi:",
					":bento:",
					":curry:",
					":rice_ball:",
					":rice:",
					":rice_cracker:",
					":oden:",
					":dango:",
					":shaved_ice:",
					":ice_cream:",
					":icecream:",
					":cake:",
					":birthday:",
					":custard:",
					":candy:",
					":lollipop:",
					":chocolate_bar:",
					":popcorn:",
					":doughnut:",
					":cookie:",
					":beer:",
					":beers:",
					":wine_glass:",
					":cocktail:",
					":tropical_drink:",
					":champagne:",
					":sake:",
					":tea:",
					":coffee:",
					":baby_bottle:",
					":fork_and_knife:",
					":fork_knife_plate:"
				]
			},
			{
				"id": "activity",
				"name": "Activity",
				"emoji": [
					":soccer:",
					":basketball:",
					":football:",
					":baseball:",
					":tennis:",
					":volleyball:",
					":rugby_football:",
					":8ball:",
					":golf:",
					":golfer:",
					":ping_pong:",
					":badminton:",
					":hockey:",
					":field_hockey:",
					":cricket:",
					":ski:",
					":skier:",
					":snowboarder:",
					":ice_skate:",
					":bow_and_arrow:",
					":fishing_pole_and_fish:",
					":rowboat:",
					":swimmer:",
					":surfer:",
					":bath:",
					":basketball_player:",
					":lifter:",
					":bicyclist:",
					":mountain_bicyclist:",
					":horse_racing:",
					":levitate:",
					":trophy:",
					":running_shirt_with_sash:",
					":medal:",
					":military_medal:",
					":reminder_ribbon:",
					":rosette:",
					":ticket:",
					":tickets:",
					":performing_arts:",
					":art:",
					":circus_tent:",
					":microphone:",
					":headphones:",
					":musical_score:",
					":musical_keyboard:",
					":saxophone:",
					":trumpet:",
					":guitar:",
					":violin:",
					":clapper:",
					":video_game:",
					":space_invader:",
					":dart:",
					":game_die:",
					":slot_machine:",
					":bowling:",
					":rowboat_tone1:",
					":rowboat_tone2:",
					":rowboat_tone3:",
					":rowboat_tone4:",
					":rowboat_tone5:",
					":swimmer_tone1:",
					":swimmer_tone2:",
					":swimmer_tone3:",
					":swimmer_tone4:",
					":swimmer_tone5:",
					":surfer_tone1:",
					":surfer_tone2:",
					":surfer_tone3:",
					":surfer_tone4:",
					":surfer_tone5:",
					":bath_tone1:",
					":bath_tone2:",
					":bath_tone3:",
					":bath_tone4:",
					":bath_tone5:",
					":basketball_player_tone1:",
					":basketball_player_tone2:",
					":basketball_player_tone3:",
					":basketball_player_tone4:",
					":basketball_player_tone5:",
					":lifter_tone1:",
					":lifter_tone2:",
					":lifter_tone3:",
					":lifter_tone4:",
					":lifter_tone5:",
					":bicyclist_tone1:",
					":bicyclist_tone2:",
					":bicyclist_tone3:",
					":bicyclist_tone4:",
					":bicyclist_tone5:",
					":mountain_bicyclist_tone1:",
					":mountain_bicyclist_tone2:",
					":mountain_bicyclist_tone3:",
					":mountain_bicyclist_tone4:",
					":mountain_bicyclist_tone5:",
					":horse_racing_tone1:",
					":horse_racing_tone2:",
					":horse_racing_tone3:",
					":horse_racing_tone4:",
					":horse_racing_tone5:"
				]
			},
			{
				"id": "travel",
				"name": "Travel & Places",
				"emoji": [
					":red_car:",
					":taxi:",
					":blue_car:",
					":bus:",
					":trolleybus:",
					":race_car:",
					":police_car:",
					":ambulance:",
					":fire_engine:",
					":minibus:",
					":truck:",
					":articulated_lorry:",
					":tractor:",
					":motorcycle:",
					":bike:",
					":rotating_light:",
					":oncoming_police_car:",
					":oncoming_bus:",
					":oncoming_automobile:",
					":oncoming_taxi:",
					":aerial_tramway:",
					":mountain_cableway:",
					":suspension_railway:",
					":railway_car:",
					":train:",
					":monorail:",
					":bullettrain_side:",
					":bullettrain_front:",
					":light_rail:",
					":mountain_railway:",
					":steam_locomotive:",
					":train2:",
					":metro:",
					":tram:",
					":station:",
					":helicopter:",
					":airplane_small:",
					":airplane:",
					":airplane_departure:",
					":airplane_arriving:",
					":sailboat:",
					":motorboat:",
					":speedboat:",
					":ferry:",
					":cruise_ship:",
					":rocket:",
					":satellite_orbital:",
					":seat:",
					":anchor:",
					":construction:",
					":fuelpump:",
					":busstop:",
					":vertical_traffic_light:",
					":traffic_light:",
					":checkered_flag:",
					":ship:",
					":ferris_wheel:",
					":roller_coaster:",
					":carousel_horse:",
					":construction_site:",
					":foggy:",
					":tokyo_tower:",
					":factory:",
					":fountain:",
					":rice_scene:",
					":mountain:",
					":mountain_snow:",
					":mount_fuji:",
					":volcano:",
					":japan:",
					":camping:",
					":tent:",
					":park:",
					":motorway:",
					":railway_track:",
					":sunrise:",
					":sunrise_over_mountains:",
					":desert:",
					":beach:",
					":island:",
					":city_sunset:",
					":city_dusk:",
					":cityscape:",
					":night_with_stars:",
					":bridge_at_night:",
					":milky_way:",
					":stars:",
					":sparkler:",
					":fireworks:",
					":rainbow:",
					":homes:",
					":european_castle:",
					":japanese_castle:",
					":stadium:",
					":statue_of_liberty:",
					":house:",
					":house_with_garden:",
					":house_abandoned:",
					":office:",
					":department_store:",
					":post_office:",
					":european_post_office:",
					":hospital:",
					":bank:",
					":hotel:",
					":convenience_store:",
					":school:",
					":love_hotel:",
					":wedding:",
					":classical_building:",
					":church:",
					":mosque:",
					":synagogue:",
					":kaaba:",
					":shinto_shrine:"
				]
			},
			{
				"id": "objects",
				"name": "Objects",
				"emoji": [
					":watch:",
					":iphone:",
					":calling:",
					":computer:",
					":keyboard:",
					":desktop:",
					":printer:",
					":mouse_three_button:",
					":trackball:",
					":joystick:",
					":compression:",
					":minidisc:",
					":floppy_disk:",
					":cd:",
					":dvd:",
					":vhs:",
					":camera:",
					":camera_with_flash:",
					":video_camera:",
					":movie_camera:",
					":projector:",
					":film_frames:",
					":telephone_receiver:",
					":telephone:",
					":pager:",
					":fax:",
					":tv:",
					":radio:",
					":microphone2:",
					":level_slider:",
					":control_knobs:",
					":stopwatch:",
					":timer:",
					":alarm_clock:",
					":clock:",
					":hourglass_flowing_sand:",
					":hourglass:",
					":satellite:",
					":battery:",
					":electric_plug:",
					":bulb:",
					":flashlight:",
					":candle:",
					":wastebasket:",
					":oil:",
					":money_with_wings:",
					":dollar:",
					":yen:",
					":euro:",
					":pound:",
					":moneybag:",
					":credit_card:",
					":gem:",
					":scales:",
					":wrench:",
					":hammer:",
					":hammer_pick:",
					":tools:",
					":pick:",
					":nut_and_bolt:",
					":gear:",
					":chains:",
					":gun:",
					":bomb:",
					":knife:",
					":dagger:",
					":crossed_swords:",
					":shield:",
					":smoking:",
					":skull_crossbones:",
					":coffin:",
					":urn:",
					":amphora:",
					":crystal_ball:",
					":prayer_beads:",
					":barber:",
					":alembic:",
					":telescope:",
					":microscope:",
					":hole:",
					":pill:",
					":syringe:",
					":thermometer:",
					":label:",
					":bookmark:",
					":toilet:",
					":shower:",
					":bathtub:",
					":key:",
					":key2:",
					":couch:",
					":sleeping_accommodation:",
					":bed:",
					":door:",
					":bellhop:",
					":frame_photo:",
					":map:",
					":beach_umbrella:",
					":moyai:",
					":shopping_bags:",
					":balloon:",
					":flags:",
					":ribbon:",
					":gift:",
					":confetti_ball:",
					":tada:",
					":dolls:",
					":wind_chime:",
					":crossed_flags:",
					":izakaya_lantern:",
					":envelope:",
					":envelope_with_arrow:",
					":incoming_envelope:",
					":e-mail:",
					":love_letter:",
					":postbox:",
					":mailbox_closed:",
					":mailbox:",
					":mailbox_with_mail:",
					":mailbox_with_no_mail:",
					":package:",
					":postal_horn:",
					":inbox_tray:",
					":outbox_tray:",
					":scroll:",
					":page_with_curl:",
					":bookmark_tabs:",
					":bar_chart:",
					":chart_with_upwards_trend:",
					":chart_with_downwards_trend:",
					":page_facing_up:",
					":date:",
					":calendar:",
					":calendar_spiral:",
					":card_index:",
					":card_box:",
					":ballot_box:",
					":file_cabinet:",
					":clipboard:",
					":notepad_spiral:",
					":file_folder:",
					":open_file_folder:",
					":dividers:",
					":newspaper2:",
					":newspaper:",
					":notebook:",
					":closed_book:",
					":green_book:",
					":blue_book:",
					":orange_book:",
					":notebook_with_decorative_cover:",
					":ledger:",
					":books:",
					":book:",
					":link:",
					":paperclip:",
					":paperclips:",
					":scissors:",
					":triangular_ruler:",
					":straight_ruler:",
					":pushpin:",
					":round_pushpin:",
					":triangular_flag_on_post:",
					":flag_white:",
					":flag_black:",
					":closed_lock_with_key:",
					":lock:",
					":unlock:",
					":lock_with_ink_pen:",
					":pen_ballpoint:",
					":pen_fountain:",
					":black_nib:",
					":pencil:",
					":pencil2:",
					":crayon:",
					":paintbrush:",
					":mag:",
					":mag_right:"
				]
			},
			{
				"id": "symbols",
				"name": "Symbols",
				"emoji": [
					":heart:",
					":yellow_heart:",
					":green_heart:",
					":blue_heart:",
					":purple_heart:",
					":broken_heart:",
					":heart_exclamation:",
					":two_hearts:",
					":revolving_hearts:",
					":heartbeat:",
					":heartpulse:",
					":sparkling_heart:",
					":cupid:",
					":gift_heart:",
					":heart_decoration:",
					":peace:",
					":cross:",
					":star_and_crescent:",
					":om_symbol:",
					":wheel_of_dharma:",
					":star_of_david:",
					":six_pointed_star:",
					":menorah:",
					":yin_yang:",
					":orthodox_cross:",
					":place_of_worship:",
					":ophiuchus:",
					":aries:",
					":taurus:",
					":gemini:",
					":cancer:",
					":leo:",
					":virgo:",
					":libra:",
					":scorpius:",
					":sagittarius:",
					":capricorn:",
					":aquarius:",
					":pisces:",
					":id:",
					":atom:",
					":u7a7a:",
					":u5272:",
					":radioactive:",
					":biohazard:",
					":mobile_phone_off:",
					":vibration_mode:",
					":u6709:",
					":u7121:",
					":u7533:",
					":u55b6:",
					":u6708:",
					":eight_pointed_black_star:",
					":vs:",
					":accept:",
					":white_flower:",
					":ideograph_advantage:",
					":secret:",
					":congratulations:",
					":u5408:",
					":u6e80:",
					":u7981:",
					":a:",
					":b:",
					":ab:",
					":cl:",
					":o2:",
					":sos:",
					":no_entry:",
					":name_badge:",
					":no_entry_sign:",
					":x:",
					":o:",
					":anger:",
					":hotsprings:",
					":no_pedestrians:",
					":do_not_litter:",
					":no_bicycles:",
					":non-potable_water:",
					":underage:",
					":no_mobile_phones:",
					":exclamation:",
					":grey_exclamation:",
					":question:",
					":grey_question:",
					":bangbang:",
					":interrobang:",
					":100:",
					":low_brightness:",
					":high_brightness:",
					":trident:",
					":fleur-de-lis:",
					":part_alternation_mark:",
					":warning:",
					":children_crossing:",
					":beginner:",
					":recycle:",
					":u6307:",
					":chart:",
					":sparkle:",
					":eight_spoked_asterisk:",
					":negative_squared_cross_mark:",
					":white_check_mark:",
					":diamond_shape_with_a_dot_inside:",
					":cyclone:",
					":loop:",
					":globe_with_meridians:",
					":m:",
					":atm:",
					":sa:",
					":passport_control:",
					":customs:",
					":baggage_claim:",
					":left_luggage:",
					":wheelchair:",
					":no_smoking:",
					":wc:",
					":parking:",
					":potable_water:",
					":mens:",
					":womens:",
					":baby_symbol:",
					":restroom:",
					":put_litter_in_its_place:",
					":cinema:",
					":signal_strength:",
					":koko:",
					":ng:",
					":ok:",
					":up:",
					":cool:",
					":new:",
					":free:",
					":zero:",
					":one:",
					":two:",
					":three:",
					":four:",
					":five:",
					":six:",
					":seven:",
					":eight:",
					":nine:",
					":ten:",
					":1234:",
					":arrow_forward:",
					":pause_button:",
					":play_pause:",
					":stop_button:",
					":record_button:",
					":track_next:",
					":track_previous:",
					":fast_forward:",
					":rewind:",
					":twisted_rightwards_arrows:",
					":repeat:",
					":repeat_one:",
					":arrow_backward:",
					":arrow_up_small:",
					":arrow_down_small:",
					":arrow_double_up:",
					":arrow_double_down:",
					":arrow_right:",
					":arrow_left:",
					":arrow_up:",
					":arrow_down:",
					":arrow_upper_right:",
					":arrow_lower_right:",
					":arrow_lower_left:",
					":arrow_upper_left:",
					":arrow_up_down:",
					":left_right_arrow:",
					":arrows_counterclockwise:",
					":arrow_right_hook:",
					":leftwards_arrow_with_hook:",
					":arrow_heading_up:",
					":arrow_heading_down:",
					":hash:",
					":asterisk:",
					":information_source:",
					":abc:",
					":abcd:",
					":capital_abcd:",
					":symbols:",
					":musical_note:",
					":notes:",
					":wavy_dash:",
					":curly_loop:",
					":heavy_check_mark:",
					":arrows_clockwise:",
					":heavy_plus_sign:",
					":heavy_minus_sign:",
					":heavy_division_sign:",
					":heavy_multiplication_x:",
					":heavy_dollar_sign:",
					":currency_exchange:",
					":copyright:",
					":registered:",
					":tm:",
					":end:",
					":back:",
					":on:",
					":top:",
					":soon:",
					":ballot_box_with_check:",
					":radio_button:",
					":white_circle:",
					":black_circle:",
					":red_circle:",
					":large_blue_circle:",
					":small_orange_diamond:",
					":small_blue_diamond:",
					":large_orange_diamond:",
					":large_blue_diamond:",
					":small_red_triangle:",
					":black_small_square:",
					":white_small_square:",
					":black_large_square:",
					":white_large_square:",
					":small_red_triangle_down:",
					":black_medium_square:",
					":white_medium_square:",
					":black_medium_small_square:",
					":white_medium_small_square:",
					":black_square_button:",
					":white_square_button:",
					":speaker:",
					":sound:",
					":loud_sound:",
					":mute:",
					":mega:",
					":loudspeaker:",
					":bell:",
					":no_bell:",
					":black_joker:",
					":mahjong:",
					":spades:",
					":clubs:",
					":hearts:",
					":diamonds:",
					":flower_playing_cards:",
					":thought_balloon:",
					":anger_right:",
					":speech_balloon:",
					":clock1:",
					":clock2:",
					":clock3:",
					":clock4:",
					":clock5:",
					":clock6:",
					":clock7:",
					":clock8:",
					":clock9:",
					":clock10:",
					":clock11:",
					":clock12:",
					":clock130:",
					":clock230:",
					":clock330:",
					":clock430:",
					":clock530:",
					":clock630:",
					":clock730:",
					":clock830:",
					":clock930:",
					":clock1030:",
					":clock1130:",
					":clock1230:",
					":eye_in_speech_bubble:"
				]
			},
			{
				"id": "flags",
				"name": "Flags",
				"emoji": [
					":flag_ac:",
					":flag_af:",
					":flag_al:",
					":flag_dz:",
					":flag_ad:",
					":flag_ao:",
					":flag_ai:",
					":flag_ag:",
					":flag_ar:",
					":flag_am:",
					":flag_aw:",
					":flag_au:",
					":flag_at:",
					":flag_az:",
					":flag_bs:",
					":flag_bh:",
					":flag_bd:",
					":flag_bb:",
					":flag_by:",
					":flag_be:",
					":flag_bz:",
					":flag_bj:",
					":flag_bm:",
					":flag_bt:",
					":flag_bo:",
					":flag_ba:",
					":flag_bw:",
					":flag_br:",
					":flag_bn:",
					":flag_bg:",
					":flag_bf:",
					":flag_bi:",
					":flag_cv:",
					":flag_kh:",
					":flag_cm:",
					":flag_ca:",
					":flag_ky:",
					":flag_cf:",
					":flag_td:",
					":flag_cl:",
					":flag_cn:",
					":flag_co:",
					":flag_km:",
					":flag_cg:",
					":flag_cd:",
					":flag_cr:",
					":flag_hr:",
					":flag_cu:",
					":flag_cy:",
					":flag_cz:",
					":flag_dk:",
					":flag_dj:",
					":flag_dm:",
					":flag_do:",
					":flag_ec:",
					":flag_eg:",
					":flag_sv:",
					":flag_gq:",
					":flag_er:",
					":flag_ee:",
					":flag_et:",
					":flag_fk:",
					":flag_fo:",
					":flag_fj:",
					":flag_fi:",
					":flag_fr:",
					":flag_pf:",
					":flag_ga:",
					":flag_gm:",
					":flag_ge:",
					":flag_de:",
					":flag_gh:",
					":flag_gi:",
					":flag_gr:",
					":flag_gl:",
					":flag_gd:",
					":flag_gu:",
					":flag_gt:",
					":flag_gn:",
					":flag_gw:",
					":flag_gy:",
					":flag_ht:",
					":flag_hn:",
					":flag_hk:",
					":flag_hu:",
					":flag_is:",
					":flag_in:",
					":flag_id:",
					":flag_ir:",
					":flag_iq:",
					":flag_ie:",
					":flag_il:",
					":flag_it:",
					":flag_ci:",
					":flag_jm:",
					":flag_jp:",
					":flag_je:",
					":flag_jo:",
					":flag_kz:",
					":flag_ke:",
					":flag_ki:",
					":flag_xk:",
					":flag_kw:",
					":flag_kg:",
					":flag_la:",
					":flag_lv:",
					":flag_lb:",
					":flag_ls:",
					":flag_lr:",
					":flag_ly:",
					":flag_li:",
					":flag_lt:",
					":flag_lu:",
					":flag_mo:",
					":flag_mk:",
					":flag_mg:",
					":flag_mw:",
					":flag_my:",
					":flag_mv:",
					":flag_ml:",
					":flag_mt:",
					":flag_mh:",
					":flag_mr:",
					":flag_mu:",
					":flag_mx:",
					":flag_fm:",
					":flag_md:",
					":flag_mc:",
					":flag_mn:",
					":flag_me:",
					":flag_ms:",
					":flag_ma:",
					":flag_mz:",
					":flag_mm:",
					":flag_na:",
					":flag_nr:",
					":flag_np:",
					":flag_nl:",
					":flag_nc:",
					":flag_nz:",
					":flag_ni:",
					":flag_ne:",
					":flag_ng:",
					":flag_nu:",
					":flag_kp:",
					":flag_no:",
					":flag_om:",
					":flag_pk:",
					":flag_pw:",
					":flag_ps:",
					":flag_pa:",
					":flag_pg:",
					":flag_py:",
					":flag_pe:",
					":flag_ph:",
					":flag_pl:",
					":flag_pt:",
					":flag_pr:",
					":flag_qa:",
					":flag_ro:",
					":flag_ru:",
					":flag_rw:",
					":flag_sh:",
					":flag_kn:",
					":flag_lc:",
					":flag_vc:",
					":flag_ws:",
					":flag_sm:",
					":flag_st:",
					":flag_sa:",
					":flag_sn:",
					":flag_rs:",
					":flag_sc:",
					":flag_sl:",
					":flag_sg:",
					":flag_sk:",
					":flag_si:",
					":flag_sb:",
					":flag_so:",
					":flag_za:",
					":flag_kr:",
					":flag_es:",
					":flag_lk:",
					":flag_sd:",
					":flag_sr:",
					":flag_sz:",
					":flag_se:",
					":flag_ch:",
					":flag_sy:",
					":flag_tw:",
					":flag_tj:",
					":flag_tz:",
					":flag_th:",
					":flag_tl:",
					":flag_tg:",
					":flag_to:",
					":flag_tt:",
					":flag_tn:",
					":flag_tr:",
					":flag_tm:",
					":flag_tv:",
					":flag_ug:",
					":flag_ua:",
					":flag_ae:",
					":flag_gb:",
					":flag_us:",
					":flag_vi:",
					":flag_uy:",
					":flag_uz:",
					":flag_vu:",
					":flag_va:",
					":flag_ve:",
					":flag_vn:",
					":flag_wf:",
					":flag_eh:",
					":flag_ye:",
					":flag_zm:",
					":flag_zw:",
					":flag_re:",
					":flag_ax:",
					":flag_ta:",
					":flag_io:",
					":flag_bq:",
					":flag_cx:",
					":flag_cc:",
					":flag_gg:",
					":flag_im:",
					":flag_yt:",
					":flag_nf:",
					":flag_pn:",
					":flag_bl:",
					":flag_pm:",
					":flag_gs:",
					":flag_tk:",
					":flag_bv:",
					":flag_hm:",
					":flag_sj:",
					":flag_um:",
					":flag_ic:",
					":flag_ea:",
					":flag_cp:",
					":flag_dg:",
					":flag_as:",
					":flag_aq:",
					":flag_vg:",
					":flag_ck:",
					":flag_cw:",
					":flag_eu:",
					":flag_gf:",
					":flag_tf:",
					":flag_gp:",
					":flag_mq:",
					":flag_mp:",
					":flag_sx:",
					":flag_ss:",
					":flag_tc:",
					":flag_mf:"
				]
			}
		]
	};

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _color = __webpack_require__(1290);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollectionBadge = function CollectionBadge(_ref) {
	    var className = _ref.className,
	        collection = _ref.collection;
	    return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	            to: Urls.collection(collection),
	            className: (0, _classnames2.default)(className, "flex align-center px1 rounded mx1"),
	            style: {
	                fontSize: 14,
	                color: (0, _color2.default)(collection.color).darken(0.1).hex(),
	                backgroundColor: (0, _color2.default)(collection.color).lighten(0.4).hex()
	            }
	        },
	        collection.name
	    );
	};
	
	CollectionBadge.displayName = "CollectionBadge";
	exports.default = CollectionBadge;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ActionHeader = __webpack_require__(1631);
	
	var _ActionHeader2 = _interopRequireDefault(_ActionHeader);
	
	var _StackedCheckBox = __webpack_require__(1633);
	
	var _StackedCheckBox2 = _interopRequireDefault(_StackedCheckBox);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _MoveToCollection = __webpack_require__(1621);
	
	var _MoveToCollection2 = _interopRequireDefault(_MoveToCollection);
	
	var _LabelPopover = __webpack_require__(1634);
	
	var _LabelPopover2 = _interopRequireDefault(_LabelPopover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHeader = function ActionHeader(_ref) {
	    var visibleCount = _ref.visibleCount,
	        selectedCount = _ref.selectedCount,
	        allAreSelected = _ref.allAreSelected,
	        sectionIsArchive = _ref.sectionIsArchive,
	        setAllSelected = _ref.setAllSelected,
	        setArchived = _ref.setArchived,
	        labels = _ref.labels;
	    return _react2.default.createElement(
	        "div",
	        { className: _ActionHeader2.default.actionHeader },
	        _react2.default.createElement(
	            _Tooltip2.default,
	            { tooltip: "Select all " + visibleCount, isEnabled: !allAreSelected },
	            _react2.default.createElement(
	                "span",
	                { className: "ml1" },
	                _react2.default.createElement(_StackedCheckBox2.default, {
	                    checked: allAreSelected,
	                    onChange: function onChange(e) {
	                        return setAllSelected(e.target.checked);
	                    },
	                    size: 20,
	                    padding: 3
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "span",
	            { className: _ActionHeader2.default.selectedCount },
	            selectedCount,
	            " selected"
	        ),
	        _react2.default.createElement(
	            "span",
	            { className: "flex align-center flex-align-right" },
	            !sectionIsArchive && labels.length > 0 ? _react2.default.createElement(_LabelPopover2.default, {
	                triggerElement: _react2.default.createElement(
	                    "span",
	                    { className: _ActionHeader2.default.actionButton },
	                    _react2.default.createElement(_Icon2.default, { name: "label" }),
	                    "Labels",
	                    _react2.default.createElement(_Icon2.default, { name: "chevrondown", size: 12 })
	                ),
	                labels: labels,
	                count: selectedCount
	            }) : null,
	            _react2.default.createElement(
	                _ModalWithTrigger2.default,
	                {
	                    full: true,
	                    triggerElement: _react2.default.createElement(
	                        "span",
	                        { className: _ActionHeader2.default.actionButton },
	                        _react2.default.createElement(_Icon2.default, { name: "move", className: "mr1" }),
	                        "Move"
	                    )
	                },
	                _react2.default.createElement(_MoveToCollection2.default, null)
	            ),
	            _react2.default.createElement(
	                "span",
	                { className: _ActionHeader2.default.actionButton, onClick: function onClick() {
	                        return setArchived(undefined, !sectionIsArchive, true);
	                    } },
	                _react2.default.createElement(_Icon2.default, { name: sectionIsArchive ? "unarchive" : "archive", className: "mr1" }),
	                sectionIsArchive ? "Unarchive" : "Archive"
	            )
	        )
	    );
	}; /* eslint "react/prop-types": "warn" */
	ActionHeader.displayName = "ActionHeader";
	
	
	ActionHeader.propTypes = {
	    labels: _propTypes2.default.array.isRequired,
	    visibleCount: _propTypes2.default.number.isRequired,
	    selectedCount: _propTypes2.default.number.isRequired,
	    allAreSelected: _propTypes2.default.bool.isRequired,
	    sectionIsArchive: _propTypes2.default.bool.isRequired,
	    setAllSelected: _propTypes2.default.func.isRequired,
	    setArchived: _propTypes2.default.func.isRequired
	};
	
	exports.default = ActionHeader;

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_2kJ06 _37W4X _2AJrG","actionHeader":"_1kFfJ _1b0Gt _38618 _3Dqep","selectedCount":"_20mbT -zXOl","allCheckbox":"qLQQf undefined","selected":"_3K4Pi","actionButton":"_17u7u _31ino _1a-AI _3TD8R _38618 _3Dqep"};

/***/ }),
/* 1632 */,
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CheckBox = __webpack_require__(1004);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OFFSET = 4;
	
	var StackedCheckBox = function StackedCheckBox(props) {
	    return _react2.default.createElement(
	        "div",
	        { className: "relative" },
	        _react2.default.createElement(
	            "span",
	            {
	                className: "absolute",
	                style: {
	                    top: -OFFSET,
	                    left: OFFSET,
	                    zIndex: -1
	                }
	            },
	            _react2.default.createElement(_CheckBox2.default, props)
	        ),
	        _react2.default.createElement(_CheckBox2.default, props)
	    );
	};
	
	StackedCheckBox.displayName = "StackedCheckBox";
	exports.default = StackedCheckBox;

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _LabelPicker = __webpack_require__(1635);
	
	var _LabelPicker2 = _interopRequireDefault(_LabelPicker);
	
	var _questions = __webpack_require__(1622);
	
	var _selectors = __webpack_require__(1612);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        labels: props.labels || (0, _selectors.getLabels)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    setLabeled: _questions.setLabeled
	};
	
	var LabelPopover = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(LabelPopover, _Component);
	
	    function LabelPopover() {
	        _classCallCheck(this, LabelPopover);
	
	        return _possibleConstructorReturn(this, (LabelPopover.__proto__ || Object.getPrototypeOf(LabelPopover)).apply(this, arguments));
	    }
	
	    _createClass(LabelPopover, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                labels = _props.labels,
	                setLabeled = _props.setLabeled,
	                item = _props.item,
	                count = _props.count;
	
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                this.props,
	                function () {
	                    return _react2.default.createElement(_LabelPicker2.default, { labels: labels, setLabeled: setLabeled, item: item, count: count });
	                }
	            );
	        }
	    }]);
	
	    return LabelPopover;
	}(_react.Component), _class2.propTypes = {
	    labels: _propTypes2.default.array.isRequired,
	    item: _propTypes2.default.object,
	    count: _propTypes2.default.number,
	    setLabeled: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	LabelPopover.displayName = "LabelPopover";
	exports.default = LabelPopover;

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _LabelPicker = __webpack_require__(1636);
	
	var _LabelPicker2 = _interopRequireDefault(_LabelPicker);
	
	var _LabelIcon = __webpack_require__(1638);
	
	var _LabelIcon2 = _interopRequireDefault(_LabelIcon);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint "react/prop-types": "warn" */
	
	
	var LabelPicker = function LabelPicker(_ref) {
	    var labels = _ref.labels,
	        count = _ref.count,
	        item = _ref.item,
	        setLabeled = _ref.setLabeled;
	    return _react2.default.createElement(
	        "div",
	        { className: _LabelPicker2.default.picker },
	        _react2.default.createElement(
	            "div",
	            { className: _LabelPicker2.default.heading },
	            count > 1 ? "Apply labels to " + count + " questions" : "Label as"
	        ),
	        _react2.default.createElement(
	            "ul",
	            { className: _LabelPicker2.default.options },
	            labels.map(function (label) {
	                var color = label.icon.charAt(0) === "#" ? label.icon : undefined;
	                var selected = item && item.labels.indexOf(label) >= 0 || label.selected === true;
	                var partiallySelected = !item && label.selected === null;
	                return _react2.default.createElement(
	                    "li",
	                    {
	                        key: label.id,
	                        onClick: function onClick() {
	                            return setLabeled(item && item.id, label.id, !selected, !item);
	                        },
	                        className: (0, _classnames2.default)(_LabelPicker2.default.option, _defineProperty({}, _LabelPicker2.default.selected, selected)),
	                        style: { color: color }
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _LabelPicker2.default.optionContent },
	                        selected ? _react2.default.createElement(_Icon2.default, { className: _LabelPicker2.default.mainIcon, name: "check" }) : partiallySelected ? _react2.default.createElement(_Icon2.default, { className: _LabelPicker2.default.mainIcon, name: "close" }) : _react2.default.createElement(_LabelIcon2.default, { className: _LabelPicker2.default.mainIcon, icon: label.icon }),
	                        _react2.default.createElement(
	                            "span",
	                            { className: _LabelPicker2.default.name },
	                            label.name
	                        ),
	                        selected && _react2.default.createElement(_Icon2.default, { className: _LabelPicker2.default.removeIcon, name: "close" })
	                    ),
	                    _react2.default.createElement("div", { className: _LabelPicker2.default.optionBackground })
	                );
	            })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _LabelPicker2.default.footer },
	            _react2.default.createElement(
	                _reactRouter.Link,
	                { className: "link", to: "/labels" },
	                "Add and edit labels"
	            ),
	            _react2.default.createElement(
	                _Tooltip2.default,
	                { tooltip: "In an upcoming release, Labels will be removed in favor of Collections." },
	                _react2.default.createElement(_Icon2.default, { name: "warning2", className: "text-error float-right" })
	            )
	        )
	    );
	};
	
	LabelPicker.displayName = "LabelPicker";
	LabelPicker.propTypes = {
	    labels: _propTypes2.default.array.isRequired,
	    count: _propTypes2.default.number,
	    item: _propTypes2.default.object,
	    setLabeled: _propTypes2.default.func.isRequired
	};
	
	exports.default = LabelPicker;

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_3KyyC _37W4X _2AJrG","picker":"_1_ONh","heading":"qDG3R _3TD8R _2z9kb GjCgU","footer":"_30c9y _3TD8R _2z9kb _2Hk-A","options":"_1Gj3C _2Cz_3 _2XN97 _2neoE","option":"_1N0JU _1a-AI _18-EI","optionContent":"_17I8h PYP7R _2XN97 _38618 _3Dqep _3TD8R","optionBackground":"_1csl0 Y2_Z-","selected":"_2jwpl","name":"_1El4N","mainIcon":"_2db6G _3K4no _9DUFn","removeIcon":"_1sB4G VW9bs _9DUFn"};

/***/ }),
/* 1637 */,
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LabelIcon = __webpack_require__(1639);
	
	var _LabelIcon2 = _interopRequireDefault(_LabelIcon);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _EmojiIcon = __webpack_require__(1626);
	
	var _EmojiIcon2 = _interopRequireDefault(_EmojiIcon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint "react/prop-types": "warn" */
	var LabelIcon = function LabelIcon(_ref) {
	    var icon = _ref.icon,
	        _ref$size = _ref.size,
	        size = _ref$size === undefined ? 18 : _ref$size,
	        className = _ref.className,
	        style = _ref.style;
	    return !icon ? null : icon.charAt(0) === ":" ? _react2.default.createElement(_EmojiIcon2.default, { className: (0, _classnames2.default)(_LabelIcon2.default.icon, _LabelIcon2.default.emojiIcon, className), name: icon, size: size, style: style }) : icon.charAt(0) === "#" ? _react2.default.createElement("span", { className: (0, _classnames2.default)(_LabelIcon2.default.icon, _LabelIcon2.default.colorIcon, className), style: { backgroundColor: icon, width: size, height: size } }) : _react2.default.createElement(_Icon2.default, { className: (0, _classnames2.default)(_LabelIcon2.default.icon, className), name: icon });
	};
	
	LabelIcon.propTypes = {
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    icon: _propTypes2.default.string,
	    size: _propTypes2.default.number
	};
	
	exports.default = LabelIcon;

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"colorIcon":"_2Xzg6 CO6xt","emojiIcon":"BdMvi rTQr-","icon":"_2ztzj _2rmlO"};

/***/ }),
/* 1640 */,
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.editLabel = exports.deleteLabel = exports.saveLabel = exports.loadLabels = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var _ref4 = arguments[1];
	    var type = _ref4.type,
	        payload = _ref4.payload,
	        error = _ref4.error;
	
	    switch (type) {
	        case LOAD_LABELS:
	            if (error) {
	                return _extends({}, state, { error: payload });
	            } else {
	                return _extends({}, state, {
	                    entities: (0, _redux.mergeEntities)(state.entities, payload.entities),
	                    labelIds: payload.result,
	                    error: null
	                });
	            }
	        case SAVE_LABEL:
	            if (error || payload == null) {
	                return state;
	            }
	            return _extends({}, state, {
	                entities: _extends({}, state.entities, {
	                    labels: _extends({}, state.entities.labels, _defineProperty({}, payload.id, payload))
	                }),
	                labelIds: _underscore2.default.uniq([].concat(_toConsumableArray(state.labelIds), [payload.id])),
	                editing: state.editing === payload.id ? null : state.editing
	            });
	        case EDIT_LABEL:
	            return _extends({}, state, { editing: payload });
	        case DELETE_LABEL:
	            if (payload == null) {
	                return state;
	            }
	            return _extends({}, state, {
	                entities: _extends({}, state.entities, {
	                    labels: _extends({}, state.entities.labels, _defineProperty({}, payload, undefined))
	                }),
	                labelIds: state.labelIds.filter(function (id) {
	                    return id !== payload;
	                })
	            });
	        default:
	            return state;
	    }
	};
	
	var _redux = __webpack_require__(657);
	
	var _reduxForm = __webpack_require__(589);
	
	var _normalizr = __webpack_require__(1111);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _services = __webpack_require__(857);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var label = new _normalizr.schema.Entity('labels');
	
	
	var LOAD_LABELS = 'metabase/labels/LOAD_LABELS';
	var EDIT_LABEL = 'metabase/labels/EDIT_LABEL';
	var SAVE_LABEL = 'metabase/labels/SAVE_LABEL';
	var DELETE_LABEL = 'metabase/labels/DELETE_LABEL';
	
	var loadLabels = exports.loadLabels = (0, _redux.createThunkAction)(LOAD_LABELS, function () {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return _services.LabelApi.list();
	
	                        case 2:
	                            response = _context.sent;
	                            return _context.abrupt("return", (0, _normalizr.normalize)(response, [label]));
	
	                        case 4:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var saveLabel = exports.saveLabel = (0, _redux.createThunkAction)(SAVE_LABEL, function (values) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var response;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            response = void 0;
	
	                            if (!(values.id == null)) {
	                                _context2.next = 9;
	                                break;
	                            }
	
	                            _analytics2.default.trackEvent("Labels", "Create");
	                            _context2.next = 6;
	                            return _services.LabelApi.create(values);
	
	                        case 6:
	                            response = _context2.sent;
	                            _context2.next = 13;
	                            break;
	
	                        case 9:
	                            _analytics2.default.trackEvent("Labels", "Update");
	                            _context2.next = 12;
	                            return _services.LabelApi.update(values);
	
	                        case 12:
	                            response = _context2.sent;
	
	                        case 13:
	                            if (response.id != null) {
	                                dispatch((0, _reduxForm.reset)("label"));
	                            }
	                            return _context2.abrupt("return", response);
	
	                        case 17:
	                            _context2.prev = 17;
	                            _context2.t0 = _context2["catch"](0);
	
	                            if (!(_context2.t0.data && _context2.t0.data.errors)) {
	                                _context2.next = 23;
	                                break;
	                            }
	
	                            throw _context2.t0.data.errors;
	
	                        case 23:
	                            if (!(_context2.t0.data && _context2.t0.data.message)) {
	                                _context2.next = 27;
	                                break;
	                            }
	
	                            throw { _error: _context2.t0.data.message };
	
	                        case 27:
	                            throw { _error: "An unknown error occured" };
	
	                        case 28:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 17]]);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	var deleteLabel = exports.deleteLabel = (0, _redux.createThunkAction)(DELETE_LABEL, function (id) {
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	
	                            _analytics2.default.trackEvent("Labels", "Delete");
	                            _context3.next = 4;
	                            return _services.LabelApi.delete({ id: id });
	
	                        case 4:
	                            return _context3.abrupt("return", id);
	
	                        case 7:
	                            _context3.prev = 7;
	                            _context3.t0 = _context3["catch"](0);
	                            return _context3.abrupt("return", null);
	
	                        case 10:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[0, 7]]);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	});
	
	var editLabel = exports.editLabel = (0, _redux.createAction)(EDIT_LABEL);
	
	var initialState = {
	    entities: {
	        labels: {}
	    },
	    labelIds: null,
	    error: null,
	    editing: null
	};

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactMotion = __webpack_require__(1248);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _keyboard = __webpack_require__(934);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandingSearchField = (_temp = _class = function (_Component) {
	    _inherits(ExpandingSearchField, _Component);
	
	    function ExpandingSearchField(props, context) {
	        _classCallCheck(this, ExpandingSearchField);
	
	        var _this = _possibleConstructorReturn(this, (ExpandingSearchField.__proto__ || Object.getPrototypeOf(ExpandingSearchField)).call(this, props, context));
	
	        _this.handleSearchKeydown = function (e) {
	            if (!_this.state.active && e.keyCode === _keyboard.KEYCODE_FORWARD_SLASH) {
	                _this.setActive();
	                e.preventDefault();
	            }
	        };
	
	        _this.onKeyPress = function (e) {
	            if (e.keyCode === _keyboard.KEYCODE_ENTER) {
	                _this.props.onSearch(e.target.value);
	            } else if (e.keyCode === _keyboard.KEYCODE_ESCAPE) {
	                _this.setInactive();
	            }
	        };
	
	        _this.setActive = function () {
	            _reactDom2.default.findDOMNode(_this.searchInput).focus();
	        };
	
	        _this.setInactive = function () {
	            _reactDom2.default.findDOMNode(_this.searchInput).blur();
	        };
	
	        _this.state = {
	            active: false
	        };
	        return _this;
	    }
	
	    _createClass(ExpandingSearchField, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.listenToSearchKeyDown();
	        }
	    }, {
	        key: "componentWillUnMount",
	        value: function componentWillUnMount() {
	            this.stopListenToSearchKeyDown();
	        }
	    }, {
	        key: "listenToSearchKeyDown",
	        value: function listenToSearchKeyDown() {
	            window.addEventListener('keydown', this.handleSearchKeydown);
	        }
	    }, {
	        key: "stopListenToSearchKeyDown",
	        value: function stopListenToSearchKeyDown() {
	            window.removeEventListener('keydown', this.handleSearchKeydown);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var className = this.props.className;
	            var active = this.state.active;
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)(className, 'bordered border-dark flex align-center pr2 transition-border', { 'border-brand': active }),
	                    onClick: this.setActive,
	                    style: { borderRadius: 99 }
	                },
	                _react2.default.createElement(_Icon2.default, {
	                    className: (0, _classnames2.default)('ml2', { 'text-brand': active }),
	                    name: "search"
	                }),
	                _react2.default.createElement(
	                    _reactMotion.Motion,
	                    {
	                        style: { width: active ? (0, _reactMotion.spring)(400) : (0, _reactMotion.spring)(200) }
	                    },
	                    function (interpolatingStyle) {
	                        return _react2.default.createElement("input", {
	                            ref: function ref(search) {
	                                return _this2.searchInput = search;
	                            },
	                            className: "input text-bold borderless",
	                            placeholder: "Search for a question...",
	                            style: Object.assign({}, interpolatingStyle, { fontSize: '1em' }),
	                            onFocus: function onFocus() {
	                                return _this2.setState({ active: true });
	                            },
	                            onBlur: function onBlur() {
	                                return _this2.setState({ active: false });
	                            },
	                            onKeyUp: _this2.onKeyPress,
	                            defaultValue: _this2.props.defaultValue
	                        });
	                    }
	                )
	            );
	        }
	    }]);
	
	    return ExpandingSearchField;
	}(_react.Component), _class.propTypes = {
	    onSearch: _propTypes2.default.func.isRequired,
	    className: _propTypes2.default.string,
	    defaultValue: _propTypes2.default.string
	}, _temp);
	ExpandingSearchField.displayName = "ExpandingSearchField";
	exports.default = ExpandingSearchField;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArchiveDashboardModal = (_temp = _class = function (_Component) {
	    _inherits(ArchiveDashboardModal, _Component);
	
	    function ArchiveDashboardModal(props, context) {
	        _classCallCheck(this, ArchiveDashboardModal);
	
	        var _this = _possibleConstructorReturn(this, (ArchiveDashboardModal.__proto__ || Object.getPrototypeOf(ArchiveDashboardModal)).call(this, props, context));
	
	        _this.state = {
	            error: null
	        };
	        return _this;
	    }
	
	    _createClass(ArchiveDashboardModal, [{
	        key: "archiveDashboard",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                try {
	                                    this.props.onArchive(this.props.dashboard);
	                                } catch (error) {
	                                    this.setState({ error: error });
	                                }
	
	                            case 1:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function archiveDashboard() {
	                return _ref.apply(this, arguments);
	            }
	
	            return archiveDashboard;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var formError;
	            if (this.state.error) {
	                var errorMessage = "Server error encountered";
	                if (this.state.error.data && this.state.error.data.message) {
	                    errorMessage = this.state.error.data.message;
	                } else {
	                    errorMessage = this.state.error.message;
	                }
	
	                // TODO: timeout display?
	                formError = _react2.default.createElement(
	                    "span",
	                    { className: "text-error px2" },
	                    errorMessage
	                );
	            }
	
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    title: "Archive Dashboard",
	                    onClose: this.props.onClose
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "Form-inputs mb4" },
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Are you sure you want to do this?"
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "Form-actions" },
	                    _react2.default.createElement(
	                        "button",
	                        { className: "Button Button--danger", onClick: function onClick() {
	                                return _this2.archiveDashboard();
	                            } },
	                        "Yes"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        { className: "Button Button--primary ml1", onClick: this.props.onClose },
	                        "No"
	                    ),
	                    formError
	                )
	            );
	        }
	    }]);
	
	    return ArchiveDashboardModal;
	}(_react.Component), _class.propTypes = {
	    dashboard: _propTypes2.default.object.isRequired,
	
	    onClose: _propTypes2.default.func,
	    onArchive: _propTypes2.default.func
	}, _temp);
	ArchiveDashboardModal.displayName = "ArchiveDashboardModal";
	exports.default = ArchiveDashboardModal;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _HeaderModal = __webpack_require__(1645);
	
	var _HeaderModal2 = _interopRequireDefault(_HeaderModal);
	
	var _TitleAndDescription = __webpack_require__(1595);
	
	var _TitleAndDescription2 = _interopRequireDefault(_TitleAndDescription);
	
	var _EditBar = __webpack_require__(1646);
	
	var _EditBar2 = _interopRequireDefault(_EditBar);
	
	var _dom = __webpack_require__(859);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = (_temp = _class = function (_Component) {
	    _inherits(Header, _Component);
	
	    function Header(props, context) {
	        _classCallCheck(this, Header);
	
	        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props, context));
	
	        _this.state = {
	            headerHeight: 0
	        };
	        return _this;
	    }
	
	    _createClass(Header, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.updateHeaderHeight();
	        }
	    }, {
	        key: "componentWillUpdate",
	        value: function componentWillUpdate() {
	            var modalIsOpen = !!this.props.headerModalMessage;
	            if (modalIsOpen) {
	                this.updateHeaderHeight();
	            }
	        }
	    }, {
	        key: "updateHeaderHeight",
	        value: function updateHeaderHeight() {
	            if (!this.refs.header) return;
	
	            var rect = _reactDom2.default.findDOMNode(this.refs.header).getBoundingClientRect();
	            var headerHeight = rect.top + (0, _dom.getScrollY)();
	            if (this.state.headerHeight !== headerHeight) {
	                this.setState({ headerHeight: headerHeight });
	            }
	        }
	    }, {
	        key: "setItemAttribute",
	        value: function setItemAttribute(attribute, event) {
	            this.props.setItemAttributeFn(attribute, event.target.value);
	        }
	    }, {
	        key: "renderEditHeader",
	        value: function renderEditHeader() {
	            if (this.props.isEditing) {
	                return _react2.default.createElement(_EditBar2.default, {
	                    title: this.props.editingTitle,
	                    subtitle: this.props.editingSubtitle,
	                    buttons: this.props.editingButtons
	                });
	            }
	        }
	    }, {
	        key: "renderHeaderModal",
	        value: function renderHeaderModal() {
	            return _react2.default.createElement(_HeaderModal2.default, {
	                isOpen: !!this.props.headerModalMessage,
	                height: this.state.headerHeight,
	                title: this.props.headerModalMessage,
	                onDone: this.props.onHeaderModalDone,
	                onCancel: this.props.onHeaderModalCancel
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var titleAndDescription;
	            if (this.props.isEditingInfo) {
	                titleAndDescription = _react2.default.createElement(
	                    "div",
	                    { className: "Header-title flex flex-column flex-full bordered rounded my1" },
	                    _react2.default.createElement(_Input2.default, { className: "AdminInput text-bold border-bottom rounded-top h3", type: "text", value: this.props.item.name || "", onChange: this.setItemAttribute.bind(this, "name") }),
	                    _react2.default.createElement(_Input2.default, { className: "AdminInput rounded-bottom h4", type: "text", value: this.props.item.description || "", onChange: this.setItemAttribute.bind(this, "description"), placeholder: "No description yet" })
	                );
	            } else {
	                if (this.props.item && this.props.item.id != null) {
	                    titleAndDescription = _react2.default.createElement(_TitleAndDescription2.default, {
	                        title: this.props.item.name,
	                        description: this.props.item.description
	                    });
	                } else {
	                    titleAndDescription = _react2.default.createElement(_TitleAndDescription2.default, {
	                        title: "New " + this.props.objectType,
	                        description: this.props.item.description
	                    });
	                }
	            }
	
	            var attribution;
	            if (this.props.item && this.props.item.creator) {
	                attribution = _react2.default.createElement(
	                    "div",
	                    { className: "Header-attribution" },
	                    "Asked by ",
	                    this.props.item.creator.common_name
	                );
	            }
	
	            var headerButtons = this.props.headerButtons.map(function (section, sectionIndex) {
	                return section && section.length > 0 && _react2.default.createElement(
	                    "span",
	                    { key: sectionIndex, className: "Header-buttonSection flex align-center" },
	                    section.map(function (button, buttonIndex) {
	                        return _react2.default.createElement(
	                            "span",
	                            { key: buttonIndex, className: "Header-button" },
	                            button
	                        );
	                    })
	                );
	            });
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                this.renderEditHeader(),
	                this.renderHeaderModal(),
	                _react2.default.createElement(
	                    "div",
	                    { className: "QueryBuilder-section flex align-center " + this.props.headerClassName, ref: "header" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Entity py3" },
	                        titleAndDescription,
	                        attribution
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center flex-align-right" },
	                        headerButtons
	                    )
	                ),
	                this.props.children
	            );
	        }
	    }]);
	
	    return Header;
	}(_react.Component), _class.defaultProps = {
	    headerButtons: [],
	    editingTitle: "",
	    editingSubtitle: "",
	    editingButtons: [],
	    headerClassName: "py1 lg-py2 xl-py3 wrapper"
	}, _temp);
	Header.displayName = "Header";
	exports.default = Header;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BodyComponent = __webpack_require__(1562);
	
	var _BodyComponent2 = _interopRequireDefault(_BodyComponent);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderModal = (0, _BodyComponent2.default)(_class = function (_Component) {
	    _inherits(HeaderModal, _Component);
	
	    function HeaderModal(props, context) {
	        _classCallCheck(this, HeaderModal);
	
	        var _this = _possibleConstructorReturn(this, (HeaderModal.__proto__ || Object.getPrototypeOf(HeaderModal)).call(this, props, context));
	
	        _this.state = {
	            initialTop: "-100%"
	        };
	        return _this;
	    }
	
	    _createClass(HeaderModal, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.setState({ initialTop: 0 });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                height = _props.height,
	                title = _props.title,
	                onDone = _props.onDone,
	                onCancel = _props.onCancel,
	                isOpen = _props.isOpen;
	            var initialTop = this.state.initialTop;
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)(className, "absolute top left right bg-brand flex flex-column layout-centered"),
	                    style: { zIndex: 4, height: height, minHeight: 50, transform: "translateY(" + (isOpen ? initialTop : "-100%") + ")", transition: "transform 400ms ease-in-out", overflow: 'hidden' }
	                },
	                _react2.default.createElement(
	                    "h2",
	                    { className: "text-white pb2" },
	                    title
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex layout-centered" },
	                    _react2.default.createElement(
	                        "button",
	                        { className: "Button Button--borderless text-brand bg-white text-bold", onClick: onDone },
	                        "Done"
	                    ),
	                    onCancel && _react2.default.createElement(
	                        "span",
	                        { className: "text-white mx1" },
	                        "or"
	                    ),
	                    onCancel && _react2.default.createElement(
	                        "a",
	                        { className: "cursor-pointer text-white text-bold", onClick: onCancel },
	                        "Cancel"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HeaderModal;
	}(_react.Component)) || _class;
	
	HeaderModal.displayName = "HeaderModal";
	exports.default = HeaderModal;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditBar = (_temp = _class = function (_Component) {
	    _inherits(EditBar, _Component);
	
	    function EditBar() {
	        _classCallCheck(this, EditBar);
	
	        return _possibleConstructorReturn(this, (EditBar.__proto__ || Object.getPrototypeOf(EditBar)).apply(this, arguments));
	    }
	
	    _createClass(EditBar, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                admin = _props.admin,
	                buttons = _props.buttons,
	                subtitle = _props.subtitle,
	                title = _props.title;
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)('EditHeader wrapper py1 flex align-center', { 'EditHeader--admin': admin }),
	                    ref: "editHeader"
	                },
	                _react2.default.createElement(
	                    "span",
	                    { className: "EditHeader-title" },
	                    title
	                ),
	                subtitle && _react2.default.createElement(
	                    "span",
	                    { className: "EditHeader-subtitle mx1" },
	                    subtitle
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: "flex-align-right flex" },
	                    buttons
	                )
	            );
	        }
	    }]);
	
	    return EditBar;
	}(_react.Component), _class.propTypes = {
	    title: _propTypes2.default.string.isRequired,
	    subtitle: _propTypes2.default.string,
	    buttons: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
	    admin: _propTypes2.default.bool
	}, _class.defaultProps = {
	    admin: false
	}, _temp);
	EditBar.displayName = "EditBar";
	exports.default = EditBar;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ActionButton = __webpack_require__(1213);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function formatDate(date) {
	    var m = (0, _moment2.default)(date);
	    if (m.isSame((0, _moment2.default)(), 'day')) {
	        return "Today, " + m.format("h:mm a");
	    } else if (m.isSame((0, _moment2.default)().subtract(1, "day"), "day")) {
	        return "Yesterday, " + m.format("h:mm a");
	    } else {
	        return m.format("MMM D YYYY, h:mm a");
	    }
	}
	
	var HistoryModal = (_temp = _class = function (_Component) {
	    _inherits(HistoryModal, _Component);
	
	    function HistoryModal(props, context) {
	        _classCallCheck(this, HistoryModal);
	
	        var _this = _possibleConstructorReturn(this, (HistoryModal.__proto__ || Object.getPrototypeOf(HistoryModal)).call(this, props, context));
	
	        _this.state = {
	            error: null
	        };
	        return _this;
	    }
	
	    _createClass(HistoryModal, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var _props, entityType, entityId;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _props = this.props, entityType = _props.entityType, entityId = _props.entityId;
	                                _context.prev = 1;
	                                _context.next = 4;
	                                return this.props.onFetchRevisions({ entity: entityType, id: entityId });
	
	                            case 4:
	                                _context.next = 9;
	                                break;
	
	                            case 6:
	                                _context.prev = 6;
	                                _context.t0 = _context["catch"](1);
	
	                                this.setState({ error: _context.t0 });
	
	                            case 9:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[1, 6]]);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "revert",
	        value: function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(revision) {
	                var _props2, entityType, entityId;
	
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _props2 = this.props, entityType = _props2.entityType, entityId = _props2.entityId;
	                                _context2.prev = 1;
	                                _context2.next = 4;
	                                return this.props.onRevertToRevision({ entity: entityType, id: entityId, revision_id: revision.id });
	
	                            case 4:
	                                this.props.onReverted();
	                                _context2.next = 11;
	                                break;
	
	                            case 7:
	                                _context2.prev = 7;
	                                _context2.t0 = _context2["catch"](1);
	
	                                console.warn("revert failed", _context2.t0);
	                                throw _context2.t0;
	
	                            case 11:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this, [[1, 7]]);
	            }));
	
	            function revert(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return revert;
	        }()
	    }, {
	        key: "revisionDescription",
	        value: function revisionDescription(revision) {
	            if (revision.is_creation) {
	                return "First revision.";
	            } else if (revision.is_reversion) {
	                return "Reverted to an earlier revision and " + revision.description;
	            } else {
	                return revision.description;
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var revisions = this.props.revisions;
	
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    title: "Revision history",
	                    onClose: function onClose() {
	                        return _this2.props.onClose();
	                    }
	                },
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { className: "flex flex-full flex-basis-auto", loading: !revisions, error: this.state.error },
	                    function () {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: "pb4 flex-full" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "border-bottom flex px4 py1 text-uppercase text-grey-3 text-bold h5" },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "flex-half" },
	                                    "When"
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "flex-half" },
	                                    "Who"
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "flex-full" },
	                                    "What"
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "px2 scroll-y" },
	                                revisions.map(function (revision, index) {
	                                    return _react2.default.createElement(
	                                        "div",
	                                        { key: revision.id, className: "border-row-divider flex py1 px2" },
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: "flex-half" },
	                                            formatDate(revision.timestamp)
	                                        ),
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: "flex-half" },
	                                            revision.user.common_name
	                                        ),
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: "flex-full flex" },
	                                            _react2.default.createElement(
	                                                "span",
	                                                null,
	                                                _this2.revisionDescription(revision)
	                                            ),
	                                            index !== 0 ? _react2.default.createElement(
	                                                "div",
	                                                { className: "flex-align-right pl1" },
	                                                _react2.default.createElement(_ActionButton2.default, {
	                                                    actionFn: function actionFn() {
	                                                        return _this2.revert(revision);
	                                                    },
	                                                    className: "Button Button--small Button--danger text-uppercase",
	                                                    normalText: "Revert",
	                                                    activeText: "Reverting\u2026",
	                                                    failedText: "Revert failed",
	                                                    successText: "Reverted"
	                                                })
	                                            ) : null
	                                        )
	                                    );
	                                })
	                            )
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return HistoryModal;
	}(_react.Component), _class.propTypes = {
	    revisions: _propTypes2.default.array,
	    entityType: _propTypes2.default.string.isRequired,
	    entityId: _propTypes2.default.number.isRequired,
	
	    onFetchRevisions: _propTypes2.default.func.isRequired,
	    onRevertToRevision: _propTypes2.default.func.isRequired,
	    onClose: _propTypes2.default.func.isRequired,
	    onReverted: _propTypes2.default.func.isRequired
	}, _temp);
	HistoryModal.displayName = "HistoryModal";
	exports.default = HistoryModal;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _EmbedWidget = __webpack_require__(1266);
	
	var _EmbedWidget2 = _interopRequireDefault(_EmbedWidget);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _dashboard = __webpack_require__(1520);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = {
	    createPublicLink: _dashboard.createPublicLink,
	    deletePublicLink: _dashboard.deletePublicLink,
	    updateEnableEmbedding: _dashboard.updateEnableEmbedding,
	    updateEmbeddingParams: _dashboard.updateEmbeddingParams
	};
	
	var DashboardEmbedWidget = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(DashboardEmbedWidget, _Component);
	
	    function DashboardEmbedWidget() {
	        _classCallCheck(this, DashboardEmbedWidget);
	
	        return _possibleConstructorReturn(this, (DashboardEmbedWidget.__proto__ || Object.getPrototypeOf(DashboardEmbedWidget)).apply(this, arguments));
	    }
	
	    _createClass(DashboardEmbedWidget, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                dashboard = _props.dashboard,
	                createPublicLink = _props.createPublicLink,
	                deletePublicLink = _props.deletePublicLink,
	                updateEnableEmbedding = _props.updateEnableEmbedding,
	                updateEmbeddingParams = _props.updateEmbeddingParams,
	                props = _objectWithoutProperties(_props, ["className", "dashboard", "createPublicLink", "deletePublicLink", "updateEnableEmbedding", "updateEmbeddingParams"]);
	
	            return _react2.default.createElement(_EmbedWidget2.default, _extends({}, props, {
	                className: className,
	                resource: dashboard,
	                resourceType: "dashboard",
	                resourceParameters: dashboard && dashboard.parameters,
	                onCreatePublicLink: function onCreatePublicLink() {
	                    return createPublicLink(dashboard);
	                },
	                onDisablePublicLink: function onDisablePublicLink() {
	                    return deletePublicLink(dashboard);
	                },
	                onUpdateEnableEmbedding: function onUpdateEnableEmbedding(enableEmbedding) {
	                    return updateEnableEmbedding(dashboard, enableEmbedding);
	                },
	                onUpdateEmbeddingParams: function onUpdateEmbeddingParams(embeddingParams) {
	                    return updateEmbeddingParams(dashboard, embeddingParams);
	                },
	                getPublicUrl: function getPublicUrl(_ref) {
	                    var public_uuid = _ref.public_uuid;
	                    return Urls.publicDashboard(public_uuid);
	                }
	            }));
	        }
	    }]);
	
	    return DashboardEmbedWidget;
	}(_react.Component)) || _class);
	DashboardEmbedWidget.displayName = "DashboardEmbedWidget";
	exports.default = DashboardEmbedWidget;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ParameterOptionsPane = exports.ParameterOptionItem = exports.ParameterOptionsSectionsPane = exports.ParameterOptionsSection = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dashboard = __webpack_require__(1519);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParametersPopover = function (_Component) {
	    _inherits(ParametersPopover, _Component);
	
	    function ParametersPopover(props, context) {
	        _classCallCheck(this, ParametersPopover);
	
	        var _this = _possibleConstructorReturn(this, (ParametersPopover.__proto__ || Object.getPrototypeOf(ParametersPopover)).call(this, props, context));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ParametersPopover, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var section = this.state.section;
	            var _props = this.props,
	                onClose = _props.onClose,
	                onAddParameter = _props.onAddParameter;
	
	            if (section == null) {
	                return _react2.default.createElement(ParameterOptionsSectionsPane, { sections: _Dashboard.PARAMETER_SECTIONS, onSelectSection: function onSelectSection(selectedSection) {
	                        var parameterSection = _underscore2.default.findWhere(_Dashboard.PARAMETER_SECTIONS, { id: selectedSection.id });
	                        if (parameterSection && parameterSection.options.length === 1) {
	                            onAddParameter(parameterSection.options[0]);
	                            onClose();
	                        } else {
	                            _this2.setState({ section: selectedSection.id });
	                        }
	                    } });
	            } else {
	                var parameterSection = _underscore2.default.findWhere(_Dashboard.PARAMETER_SECTIONS, { id: section });
	                return _react2.default.createElement(ParameterOptionsPane, { options: parameterSection && parameterSection.options, onSelectOption: function onSelectOption(option) {
	                        onAddParameter(option);onClose();
	                    } });
	            }
	        }
	    }]);
	
	    return ParametersPopover;
	}(_react.Component);
	
	ParametersPopover.displayName = "ParametersPopover";
	exports.default = ParametersPopover;
	var ParameterOptionsSection = exports.ParameterOptionsSection = function ParameterOptionsSection(_ref) {
	    var section = _ref.section,
	        onClick = _ref.onClick;
	    return _react2.default.createElement(
	        "li",
	        { onClick: onClick, className: "p1 px2 cursor-pointer brand-hover" },
	        _react2.default.createElement(
	            "div",
	            { className: "text-brand text-bold" },
	            section.name
	        ),
	        _react2.default.createElement(
	            "div",
	            null,
	            section.description
	        )
	    );
	};
	
	ParameterOptionsSection.displayName = "ParameterOptionsSection";
	var ParameterOptionsSectionsPane = exports.ParameterOptionsSectionsPane = function ParameterOptionsSectionsPane(_ref2) {
	    var sections = _ref2.sections,
	        onSelectSection = _ref2.onSelectSection;
	    return _react2.default.createElement(
	        "div",
	        { className: "pb2" },
	        _react2.default.createElement(
	            "h3",
	            { className: "p2" },
	            "What do you want to filter?"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            sections.map(function (section) {
	                return _react2.default.createElement(ParameterOptionsSection, { section: section, onClick: function onClick() {
	                        return onSelectSection(section);
	                    } });
	            })
	        )
	    );
	};
	
	ParameterOptionsSectionsPane.displayName = "ParameterOptionsSectionsPane";
	var ParameterOptionItem = exports.ParameterOptionItem = function ParameterOptionItem(_ref3) {
	    var option = _ref3.option,
	        onClick = _ref3.onClick;
	    return _react2.default.createElement(
	        "li",
	        { onClick: onClick, className: "p1 px2 cursor-pointer brand-hover" },
	        _react2.default.createElement(
	            "div",
	            { className: "text-brand text-bold" },
	            option.menuName || option.name
	        ),
	        _react2.default.createElement(
	            "div",
	            null,
	            option.description
	        )
	    );
	};
	
	ParameterOptionItem.displayName = "ParameterOptionItem";
	var ParameterOptionsPane = exports.ParameterOptionsPane = function ParameterOptionsPane(_ref4) {
	    var options = _ref4.options,
	        onSelectOption = _ref4.onSelectOption;
	    return _react2.default.createElement(
	        "div",
	        { className: "pb2" },
	        _react2.default.createElement(
	            "h3",
	            { className: "p2" },
	            "What kind of filter?"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            options && options.map(function (option) {
	                return _react2.default.createElement(ParameterOptionItem, { option: option, onClick: function onClick() {
	                        return onSelectOption(option);
	                    } });
	            })
	        )
	    );
	};
	ParameterOptionsPane.displayName = "ParameterOptionsPane";

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.QuestionIndex = exports.QuestionIndexHeader = exports.NoSavedQuestionsState = exports.CollectionEmptyState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TitleAndDescription = __webpack_require__(1595);
	
	var _TitleAndDescription2 = _interopRequireDefault(_TitleAndDescription);
	
	var _ExpandingSearchField = __webpack_require__(1642);
	
	var _ExpandingSearchField2 = _interopRequireDefault(_ExpandingSearchField);
	
	var _CollectionActions = __webpack_require__(1651);
	
	var _CollectionActions2 = _interopRequireDefault(_CollectionActions);
	
	var _CollectionButtons = __webpack_require__(1652);
	
	var _CollectionButtons2 = _interopRequireDefault(_CollectionButtons);
	
	var _EntityList = __webpack_require__(1614);
	
	var _EntityList2 = _interopRequireDefault(_EntityList);
	
	var _questions = __webpack_require__(1622);
	
	var _collections = __webpack_require__(1613);
	
	var _selectors = __webpack_require__(1612);
	
	var _user = __webpack_require__(1127);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollectionEmptyState = exports.CollectionEmptyState = function CollectionEmptyState() {
	    return _react2.default.createElement(
	        "div",
	        { className: "flex align-center p2 mt4 bordered border-med border-brand rounded bg-grey-0 text-brand" },
	        _react2.default.createElement(_Icon2.default, { name: "collection", size: 32, className: "mr2" }),
	        _react2.default.createElement(
	            "div",
	            { className: "flex-full" },
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Create collections for your saved questions"
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "mt1" },
	                "Collections help you organize your questions and allow you to decide who gets to see what.",
	                " ",
	                _react2.default.createElement(
	                    "a",
	                    { href: "http://www.metabase.com/docs/latest/administration-guide/06-collections.html", target: "_blank" },
	                    "Learn more"
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _reactRouter.Link,
	            { to: "/collections/create" },
	            _react2.default.createElement(
	                _Button2.default,
	                { primary: true },
	                "Create a collection"
	            )
	        )
	    );
	};
	
	CollectionEmptyState.displayName = "CollectionEmptyState";
	var NoSavedQuestionsState = exports.NoSavedQuestionsState = function NoSavedQuestionsState() {
	    return _react2.default.createElement(
	        "div",
	        { className: "flex-full flex align-center justify-center mb4" },
	        _react2.default.createElement(_EmptyState2.default, {
	            message: _react2.default.createElement(
	                "span",
	                null,
	                "Explore your data, create charts or maps, and save what you find."
	            ),
	            image: "/app/img/questions_illustration",
	            action: "Ask a question",
	            link: "/question"
	        })
	    );
	};
	
	NoSavedQuestionsState.displayName = "NoSavedQuestionsState";
	var QuestionIndexHeader = exports.QuestionIndexHeader = function QuestionIndexHeader(_ref) {
	    var questions = _ref.questions,
	        collections = _ref.collections,
	        isAdmin = _ref.isAdmin,
	        onSearch = _ref.onSearch;
	
	    // Some replication of logic for making writing tests easier
	    var hasCollections = collections && collections.length > 0;
	    var hasQuestionsWithoutCollection = questions && questions.length > 0;
	
	    var showSearch = hasCollections || hasQuestionsWithoutCollection;
	    var showSetPermissionsLink = isAdmin && hasCollections;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "flex align-center pt4 pb2" },
	        _react2.default.createElement(_TitleAndDescription2.default, { title: hasCollections ? "Collections of Questions" : "Saved Questions" }),
	        _react2.default.createElement(
	            "div",
	            { className: "flex align-center ml-auto" },
	            showSearch && _react2.default.createElement(_ExpandingSearchField2.default, { className: "mr2", onSearch: onSearch }),
	            _react2.default.createElement(
	                _CollectionActions2.default,
	                null,
	                showSetPermissionsLink && _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: "/collections/permissions" },
	                    _react2.default.createElement(_Icon2.default, { size: 18, name: "lock", tooltip: "Set permissions for collections" })
	                ),
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: "/questions/archive" },
	                    _react2.default.createElement(_Icon2.default, { size: 20, name: "viewArchive", tooltip: "View the archive" })
	                )
	            )
	        )
	    );
	};
	
	QuestionIndexHeader.displayName = "QuestionIndexHeader";
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        loading: (0, _selectors.getLoadingInitialEntities)(state, props),
	        questions: (0, _selectors.getAllEntities)(state, props),
	        collections: (0, _selectors.getAllCollections)(state, props),
	        isAdmin: (0, _user.getUserIsAdmin)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    search: _questions.search,
	    loadCollections: _collections.loadCollections,
	    replace: _reactRouterRedux.replace,
	    push: _reactRouterRedux.push
	};
	
	/* connect() is in the end of this file because of the plain QuestionIndex component is used in Jest tests */
	
	var QuestionIndex = exports.QuestionIndex = function (_Component) {
	    _inherits(QuestionIndex, _Component);
	
	    function QuestionIndex() {
	        _classCallCheck(this, QuestionIndex);
	
	        return _possibleConstructorReturn(this, (QuestionIndex.__proto__ || Object.getPrototypeOf(QuestionIndex)).apply(this, arguments));
	    }
	
	    _createClass(QuestionIndex, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.loadCollections();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                loading = _props.loading,
	                questions = _props.questions,
	                collections = _props.collections,
	                replace = _props.replace,
	                push = _props.push,
	                location = _props.location,
	                isAdmin = _props.isAdmin;
	
	
	            var hasCollections = collections && collections.length > 0;
	            var hasQuestionsWithoutCollection = questions && questions.length > 0;
	
	            var showNoCollectionsState = !loading && isAdmin && !hasCollections;
	            var showNoSavedQuestionsState = !loading && !hasCollections && !hasQuestionsWithoutCollection;
	
	            var hasEntityListSectionQuery = !!(location.query && location.query.f);
	            var showEntityList = hasQuestionsWithoutCollection || hasEntityListSectionQuery;
	            var showEverythingElseTitle = showEntityList && hasCollections;
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("relative px4", { "full-height flex flex-column bg-slate-extra-light": showNoSavedQuestionsState }) },
	                loading && _react2.default.createElement(_LoadingAndErrorWrapper2.default, { loading: true, noBackground: true }),
	                showNoCollectionsState && _react2.default.createElement(CollectionEmptyState, null),
	                !loading && _react2.default.createElement(QuestionIndexHeader, {
	                    questions: questions,
	                    collections: collections,
	                    isAdmin: isAdmin,
	                    onSearch: this.props.search
	                }),
	                hasCollections && _react2.default.createElement(_CollectionButtons2.default, { collections: collections, isAdmin: isAdmin, push: push }),
	                showNoSavedQuestionsState && _react2.default.createElement(NoSavedQuestionsState, null),
	                showEverythingElseTitle && _react2.default.createElement(
	                    "h2",
	                    { className: "mt2 mb2" },
	                    "Everything Else"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)({ "hide": !showEntityList }) },
	                    _react2.default.createElement(_EntityList2.default, {
	                        entityType: "cards",
	                        entityQuery: _extends({ f: "all", collection: "" }, location.query)
	                        // use replace when changing sections so back button still takes you back to collections page
	                        , onChangeSection: function onChangeSection(section) {
	                            return replace(_extends({}, location, {
	                                query: _extends({}, location.query, { f: section })
	                            }));
	                        }
	                    })
	                )
	            );
	        }
	    }]);
	
	    return QuestionIndex;
	}(_react.Component);
	
	QuestionIndex.displayName = "QuestionIndex";
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QuestionIndex);

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollectionActions = function CollectionActions(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        "div",
	        { className: "flex align-center", onClick: function onClick(e) {
	                e.stopPropagation();e.preventDefault();
	            } },
	        _react2.default.Children.map(children, function (child, index) {
	            return _react2.default.createElement(
	                "div",
	                { key: index, className: "cursor-pointer text-brand-hover mx1" },
	                child
	            );
	        })
	    );
	};
	
	CollectionActions.displayName = "CollectionActions";
	exports.default = CollectionActions;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ArchiveCollectionWidget = __webpack_require__(1653);
	
	var _ArchiveCollectionWidget2 = _interopRequireDefault(_ArchiveCollectionWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COLLECTION_ICON_SIZE = 64;
	
	var COLLECTION_BOX_CLASSES = "relative block p4 hover-parent hover--visibility cursor-pointer text-centered transition-background";
	
	var CollectionButtons = function CollectionButtons(_ref) {
	    var collections = _ref.collections,
	        isAdmin = _ref.isAdmin,
	        push = _ref.push;
	    return _react2.default.createElement(
	        "ol",
	        { className: "Grid Grid--gutters Grid--fit small-Grid--1of3 md-Grid--1of4 large-Grid--guttersLg" },
	        collections.map(function (collection) {
	            return _react2.default.createElement(CollectionButton, _extends({}, collection, { push: push, isAdmin: isAdmin }));
	        }).concat(isAdmin ? [_react2.default.createElement(NewCollectionButton, { push: push })] : []).map(function (element, index) {
	            return _react2.default.createElement(
	                "li",
	                { key: index, className: "Grid-cell" },
	                element
	            );
	        })
	    );
	};
	
	CollectionButtons.displayName = "CollectionButtons";
	
	var CollectionButton = function (_Component) {
	    _inherits(CollectionButton, _Component);
	
	    function CollectionButton() {
	        _classCallCheck(this, CollectionButton);
	
	        var _this = _possibleConstructorReturn(this, (CollectionButton.__proto__ || Object.getPrototypeOf(CollectionButton)).call(this));
	
	        _this.state = { hovered: false };
	        return _this;
	    }
	
	    _createClass(CollectionButton, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                id = _props.id,
	                name = _props.name,
	                color = _props.color,
	                slug = _props.slug,
	                isAdmin = _props.isAdmin;
	
	            return _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                    to: "/questions/collections/" + slug,
	                    className: "no-decoration",
	                    onMouseEnter: function onMouseEnter() {
	                        return _this2.setState({ hovered: true });
	                    },
	                    onMouseLeave: function onMouseLeave() {
	                        return _this2.setState({ hovered: false });
	                    }
	                },
	                _react2.default.createElement(
	                    "div",
	                    {
	                        className: (0, _classnames2.default)(COLLECTION_BOX_CLASSES, 'text-white-hover'),
	                        style: {
	                            borderRadius: 10,
	                            backgroundColor: this.state.hovered ? color : '#fafafa'
	                        }
	                    },
	                    isAdmin && _react2.default.createElement(
	                        "div",
	                        { className: "absolute top right mt2 mr2 hover-child" },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/collections/permissions?collectionId=" + id, className: "mr1" },
	                            _react2.default.createElement(_Icon2.default, { name: "lockoutline", tooltip: "Set collection permissions" })
	                        ),
	                        _react2.default.createElement(_ArchiveCollectionWidget2.default, { collectionId: id })
	                    ),
	                    _react2.default.createElement(_Icon2.default, {
	                        className: "mb2 mt2",
	                        name: "collection",
	                        size: COLLECTION_ICON_SIZE,
	                        style: { color: this.state.hovered ? '#fff' : color }
	                    }),
	                    _react2.default.createElement(
	                        "h3",
	                        null,
	                        name
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CollectionButton;
	}(_react.Component);
	
	CollectionButton.displayName = "CollectionButton";
	
	
	var NewCollectionButton = function NewCollectionButton(_ref2) {
	    var push = _ref2.push;
	    return _react2.default.createElement(
	        "div",
	        {
	            className: (0, _classnames2.default)(COLLECTION_BOX_CLASSES, 'bg-brand-hover', 'text-brand', 'text-white-hover', 'bg-grey-0'),
	            style: {
	                borderRadius: 10
	            },
	            onClick: function onClick() {
	                return push("/collections/create");
	            }
	        },
	        _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	                "div",
	                {
	                    className: "flex align-center justify-center ml-auto mr-auto mb2 mt2",
	                    style: {
	                        border: '2px solid #D8E8F5',
	                        borderRadius: COLLECTION_ICON_SIZE,
	                        height: COLLECTION_ICON_SIZE,
	                        width: COLLECTION_ICON_SIZE
	                    }
	                },
	                _react2.default.createElement(_Icon2.default, {
	                    name: "add",
	                    width: "32",
	                    height: "32"
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "h3",
	            null,
	            "New collection"
	        )
	    );
	};
	
	NewCollectionButton.displayName = "NewCollectionButton";
	exports.default = CollectionButtons;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _collections = __webpack_require__(1613);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {};
	};
	
	var mapDispatchToProps = {
	    setCollectionArchived: _collections.setCollectionArchived
	};
	
	var ArchiveCollectionWidget = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(ArchiveCollectionWidget, _Component);
	
	    function ArchiveCollectionWidget() {
	        var _ref,
	            _this2 = this;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ArchiveCollectionWidget);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ArchiveCollectionWidget.__proto__ || Object.getPrototypeOf(ArchiveCollectionWidget)).call.apply(_ref, [this].concat(args))), _this), _this._onArchive = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _this.props.setCollectionArchived(_this.props.collectionId, true);
	
	                        case 3:
	                            _this._onClose();
	                            if (_this.props.onArchived) {
	                                _this.props.onArchived();
	                            }
	                            _context.next = 11;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error(_context.t0);
	                            _this.setState({ error: _context.t0 });
	
	                        case 11:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[0, 7]]);
	        })), _this._onClose = function () {
	            if (_this.refs.modal) {
	                _this.refs.modal.close();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ArchiveCollectionWidget, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _ModalWithTrigger2.default,
	                _extends({}, this.props, {
	                    ref: "modal",
	                    triggerElement: _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: "Archive collection" },
	                        _react2.default.createElement(_Icon2.default, { size: 18, name: "archive" })
	                    ),
	                    title: "Archive this collection?",
	                    footer: [_react2.default.createElement(
	                        _Button2.default,
	                        { onClick: this._onClose },
	                        "Cancel"
	                    ), _react2.default.createElement(
	                        _Button2.default,
	                        { warning: true, onClick: this._onArchive },
	                        "Archive"
	                    )]
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "px4 pb4" },
	                    "The saved questions in this collection will also be archived."
	                )
	            );
	        }
	    }]);
	
	    return ArchiveCollectionWidget;
	}(_react.Component)) || _class);
	ArchiveCollectionWidget.displayName = "ArchiveCollectionWidget";
	exports.default = ArchiveCollectionWidget;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _HeaderWithBack = __webpack_require__(1604);
	
	var _HeaderWithBack2 = _interopRequireDefault(_HeaderWithBack);
	
	var _SearchHeader = __webpack_require__(1598);
	
	var _SearchHeader2 = _interopRequireDefault(_SearchHeader);
	
	var _ArchivedItem = __webpack_require__(1605);
	
	var _ArchivedItem2 = _interopRequireDefault(_ArchivedItem);
	
	var _questions = __webpack_require__(1622);
	
	var _collections = __webpack_require__(1613);
	
	var _selectors = __webpack_require__(1612);
	
	var _user = __webpack_require__(1127);
	
	var _visualizations = __webpack_require__(1284);
	
	var _visualizations2 = _interopRequireDefault(_visualizations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        searchText: (0, _selectors.getSearchText)(state, props),
	        archivedCards: (0, _selectors.getVisibleEntities)(state, { entityType: "cards", entityQuery: { f: "archived" } }) || [],
	        archivedCollections: (0, _selectors.getVisibleEntities)(state, { entityType: "collections", entityQuery: { archived: true } }) || [],
	
	        isAdmin: (0, _user.getUserIsAdmin)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    loadEntities: _questions.loadEntities,
	    setSearchText: _questions.setSearchText,
	    setArchived: _questions.setArchived,
	    setCollectionArchived: _collections.setCollectionArchived
	};
	
	var Archive = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(Archive, _Component);
	
	    function Archive() {
	        _classCallCheck(this, Archive);
	
	        return _possibleConstructorReturn(this, (Archive.__proto__ || Object.getPrototypeOf(Archive)).apply(this, arguments));
	    }
	
	    _createClass(Archive, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.loadEntities();
	        }
	    }, {
	        key: "loadEntities",
	        value: function loadEntities() {
	            this.props.loadEntities("cards", { f: "archived" });
	            this.props.loadEntities("collections", { archived: true });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                archivedCards = _props.archivedCards,
	                archivedCollections = _props.archivedCollections,
	                isAdmin = _props.isAdmin;
	
	            var items = [].concat(_toConsumableArray(archivedCollections.map(function (collection) {
	                return _extends({ type: "collection" }, collection);
	            })), _toConsumableArray(archivedCards.map(function (card) {
	                return _extends({ type: "card" }, card);
	            }))); //.sort((a,b) => a.updated_at.valueOf() - b.updated_at.valueOf()))
	
	            return _react2.default.createElement(
	                "div",
	                { className: "px4 pt3" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center mb2" },
	                    _react2.default.createElement(_HeaderWithBack2.default, { name: "Archive" })
	                ),
	                _react2.default.createElement(_SearchHeader2.default, { searchText: this.props.searchText, setSearchText: this.props.setSearchText }),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    items.map(function (item) {
	                        return item.type === "collection" ? _react2.default.createElement(_ArchivedItem2.default, { key: item.type + item.id, name: item.name, type: "collection", icon: "collection", color: item.color, isAdmin: isAdmin, onUnarchive: _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                                return regeneratorRuntime.wrap(function _callee$(_context) {
	                                    while (1) {
	                                        switch (_context.prev = _context.next) {
	                                            case 0:
	                                                _context.next = 2;
	                                                return _this2.props.setCollectionArchived(item.id, false);
	
	                                            case 2:
	                                                _this2.loadEntities();
	
	                                            case 3:
	                                            case "end":
	                                                return _context.stop();
	                                        }
	                                    }
	                                }, _callee, _this2);
	                            })) }) : item.type === "card" ? _react2.default.createElement(_ArchivedItem2.default, { key: item.type + item.id, name: item.name, type: "card", icon: _visualizations2.default.get(item.display).iconName, isAdmin: isAdmin, onUnarchive: _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	                                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                                    while (1) {
	                                        switch (_context2.prev = _context2.next) {
	                                            case 0:
	                                                _context2.next = 2;
	                                                return _this2.props.setArchived(item.id, false, true);
	
	                                            case 2:
	                                                _this2.loadEntities();
	
	                                            case 3:
	                                            case "end":
	                                                return _context2.stop();
	                                        }
	                                    }
	                                }, _callee2, _this2);
	                            })) }) : null;
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Archive;
	}(_react.Component)) || _class);
	Archive.displayName = "Archive";
	exports.default = Archive;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _Title = __webpack_require__(1538);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _HeaderWithBack = __webpack_require__(1604);
	
	var _HeaderWithBack2 = _interopRequireDefault(_HeaderWithBack);
	
	var _CollectionActions = __webpack_require__(1651);
	
	var _CollectionActions2 = _interopRequireDefault(_CollectionActions);
	
	var _ArchiveCollectionWidget = __webpack_require__(1653);
	
	var _ArchiveCollectionWidget2 = _interopRequireDefault(_ArchiveCollectionWidget);
	
	var _EntityList = __webpack_require__(1614);
	
	var _EntityList2 = _interopRequireDefault(_EntityList);
	
	var _collections = __webpack_require__(1613);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        collection: _underscore2.default.findWhere(state.collections.collections, { slug: props.params.collectionSlug })
	    };
	};
	
	var mapDispatchToProps = {
	    push: _reactRouterRedux.push,
	    replace: _reactRouterRedux.replace,
	    goBack: _reactRouterRedux.goBack,
	    goToQuestions: function goToQuestions() {
	        return (0, _reactRouterRedux.push)("/questions");
	    },
	    editCollection: function editCollection(id) {
	        return (0, _reactRouterRedux.push)("/collections/" + id);
	    },
	    editPermissions: function editPermissions(id) {
	        return (0, _reactRouterRedux.push)("/collections/permissions?collectionId=" + id);
	    },
	    loadCollections: _collections.loadCollections
	};
	
	var CollectionPage = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _Title2.default)(function (_ref) {
	    var collection = _ref.collection;
	    return collection && collection.name;
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(CollectionPage, _Component);
	
	    function CollectionPage() {
	        _classCallCheck(this, CollectionPage);
	
	        return _possibleConstructorReturn(this, (CollectionPage.__proto__ || Object.getPrototypeOf(CollectionPage)).apply(this, arguments));
	    }
	
	    _createClass(CollectionPage, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.loadCollections();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                collection = _props.collection,
	                params = _props.params,
	                location = _props.location,
	                push = _props.push,
	                replace = _props.replace,
	                goBack = _props.goBack;
	
	            var canEdit = collection && collection.can_write;
	            return _react2.default.createElement(
	                "div",
	                { className: "mx4 mt4" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center" },
	                    _react2.default.createElement(_HeaderWithBack2.default, {
	                        name: collection && collection.name,
	                        description: collection && collection.description,
	                        onBack: window.history.length === 1 ? function () {
	                            return push("/questions");
	                        } : function () {
	                            return goBack();
	                        }
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ml-auto" },
	                        _react2.default.createElement(
	                            _CollectionActions2.default,
	                            null,
	                            canEdit && _react2.default.createElement(_ArchiveCollectionWidget2.default, { collectionId: this.props.collection.id, onArchived: this.props.goToQuestions }),
	                            canEdit && _react2.default.createElement(_Icon2.default, { size: 18, name: "pencil", tooltip: "Edit collection", onClick: function onClick() {
	                                    return _this2.props.editCollection(_this2.props.collection.id);
	                                } }),
	                            canEdit && _react2.default.createElement(_Icon2.default, { size: 18, name: "lock", tooltip: "Set permissions", onClick: function onClick() {
	                                    return _this2.props.editPermissions(_this2.props.collection.id);
	                                } })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "mt4" },
	                    _react2.default.createElement(_EntityList2.default, {
	                        defaultEmptyState: "No questions have been added to this collection yet.",
	                        entityType: "cards",
	                        entityQuery: _extends({ f: "all", collection: params.collectionSlug }, location.query)
	                        // use replace when changing sections so back button still takes you back to collections page
	                        , onChangeSection: function onChangeSection(section) {
	                            return replace(_extends({}, location, {
	                                query: _extends({}, location.query, { f: section })
	                            }));
	                        },
	                        showCollectionName: false,
	                        editable: canEdit
	                    })
	                )
	            );
	        }
	    }]);
	
	    return CollectionPage;
	}(_react.Component)) || _class) || _class);
	CollectionPage.displayName = "CollectionPage";
	exports.default = CollectionPage;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _CollectionEditorForm = __webpack_require__(1657);
	
	var _CollectionEditorForm2 = _interopRequireDefault(_CollectionEditorForm);
	
	var _collections = __webpack_require__(1613);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        error: state.collections.error,
	        collection: state.collections.collection
	    };
	};
	
	var mapDispatchToProps = {
	    loadCollection: _collections.loadCollection,
	    saveCollection: _collections.saveCollection,
	    onClose: _reactRouterRedux.goBack
	};
	
	var CollectionEdit = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(CollectionEdit, _Component);
	
	    function CollectionEdit() {
	        _classCallCheck(this, CollectionEdit);
	
	        return _possibleConstructorReturn(this, (CollectionEdit.__proto__ || Object.getPrototypeOf(CollectionEdit)).apply(this, arguments));
	    }
	
	    _createClass(CollectionEdit, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.loadCollection(this.props.params.collectionId);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_CollectionEditorForm2.default, _extends({}, this.props, {
	                onSubmit: this.props.saveCollection,
	                initialValues: this.props.collection
	            }));
	        }
	    }]);
	
	    return CollectionEdit;
	}(_react.Component)) || _class);
	CollectionEdit.displayName = "CollectionEdit";
	exports.default = CollectionEdit;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CollectionEditorForm = exports.CollectionEditorFormActions = exports.getActionText = exports.getFormTitle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ColorPicker = __webpack_require__(1386);
	
	var _ColorPicker2 = _interopRequireDefault(_ColorPicker);
	
	var _FormField = __webpack_require__(1597);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reduxForm = __webpack_require__(589);
	
	var _colors = __webpack_require__(881);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formConfig = {
	    form: 'collection',
	    fields: ['id', 'name', 'description', 'color'],
	    validate: function validate(values) {
	        var errors = {};
	        if (!values.name) {
	            errors.name = "Name is required";
	        } else if (values.name.length > 100) {
	            errors.name = "Name must be 100 characters or less";
	        }
	        if (!values.color) {
	            errors.color = "Color is required";
	        }
	        return errors;
	    },
	    initialValues: {
	        name: "",
	        description: "",
	        // pick a random color to start so everything isn't blue all the time
	        color: (0, _colors.getRandomColor)(_colors.normal)
	    }
	};
	
	var getFormTitle = exports.getFormTitle = function getFormTitle(_ref) {
	    var id = _ref.id,
	        name = _ref.name;
	    return id.value ? name.value : "New collection";
	};
	
	var getActionText = exports.getActionText = function getActionText(_ref2) {
	    var id = _ref2.id;
	    return id.value ? "Update" : "Create";
	};
	
	var CollectionEditorFormActions = exports.CollectionEditorFormActions = function CollectionEditorFormActions(_ref3) {
	    var handleSubmit = _ref3.handleSubmit,
	        invalid = _ref3.invalid,
	        onClose = _ref3.onClose,
	        fields = _ref3.fields;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            _Button2.default,
	            { className: "mr1", onClick: onClose },
	            "Cancel"
	        ),
	        _react2.default.createElement(
	            _Button2.default,
	            { primary: true, disabled: invalid, onClick: handleSubmit },
	            getActionText(fields)
	        )
	    );
	};
	
	CollectionEditorFormActions.displayName = "CollectionEditorFormActions";
	
	var CollectionEditorForm = exports.CollectionEditorForm = function (_Component) {
	    _inherits(CollectionEditorForm, _Component);
	
	    function CollectionEditorForm() {
	        _classCallCheck(this, CollectionEditorForm);
	
	        return _possibleConstructorReturn(this, (CollectionEditorForm.__proto__ || Object.getPrototypeOf(CollectionEditorForm)).apply(this, arguments));
	    }
	
	    _createClass(CollectionEditorForm, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                fields = _props.fields,
	                onClose = _props.onClose;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                {
	                    inline: true,
	                    form: true,
	                    title: getFormTitle(fields),
	                    footer: _react2.default.createElement(CollectionEditorFormActions, this.props),
	                    onClose: onClose
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "NewForm ml-auto mr-auto mt4 pt2", style: { width: 540 } },
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        _extends({
	                            displayName: "Name"
	                        }, fields.name),
	                        _react2.default.createElement(_Input2.default, _extends({
	                            className: "Form-input full",
	                            placeholder: "My new fantastic collection",
	                            autoFocus: true
	                        }, fields.name))
	                    ),
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        _extends({
	                            displayName: "Description"
	                        }, fields.description),
	                        _react2.default.createElement("textarea", _extends({
	                            className: "Form-input full",
	                            placeholder: "It's optional but oh, so helpful"
	                        }, fields.description))
	                    ),
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        _extends({
	                            displayName: "Color"
	                        }, fields.color),
	                        _react2.default.createElement(_ColorPicker2.default, fields.color)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CollectionEditorForm;
	}(_react.Component);
	
	CollectionEditorForm.displayName = "CollectionEditorForm";
	exports.default = (0, _reduxForm.reduxForm)(formConfig)(CollectionEditorForm);

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _CollectionEditorForm = __webpack_require__(1657);
	
	var _CollectionEditorForm2 = _interopRequireDefault(_CollectionEditorForm);
	
	var _collections = __webpack_require__(1613);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        error: state.collections.error,
	        collection: state.collections.collection
	    };
	};
	
	var mapDispatchToProps = {
	    saveCollection: _collections.saveCollection,
	    onClose: function onClose() {
	        return (0, _reactRouterRedux.push)("/questions");
	    }
	};
	
	var CollectionEdit = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(CollectionEdit, _Component);
	
	    function CollectionEdit() {
	        _classCallCheck(this, CollectionEdit);
	
	        return _possibleConstructorReturn(this, (CollectionEdit.__proto__ || Object.getPrototypeOf(CollectionEdit)).apply(this, arguments));
	    }
	
	    _createClass(CollectionEdit, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_CollectionEditorForm2.default, _extends({}, this.props, {
	                onSubmit: this.props.saveCollection
	            }));
	        }
	    }]);
	
	    return CollectionEdit;
	}(_react.Component)) || _class);
	CollectionEdit.displayName = "CollectionEdit";
	exports.default = CollectionEdit;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _HeaderWithBack = __webpack_require__(1604);
	
	var _HeaderWithBack2 = _interopRequireDefault(_HeaderWithBack);
	
	var _ExpandingSearchField = __webpack_require__(1642);
	
	var _ExpandingSearchField2 = _interopRequireDefault(_ExpandingSearchField);
	
	var _EntityList = __webpack_require__(1614);
	
	var _EntityList2 = _interopRequireDefault(_EntityList);
	
	var _formatting = __webpack_require__(872);
	
	var _selectors = __webpack_require__(1612);
	
	var _questions = __webpack_require__(1622);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        totalCount: (0, _selectors.getTotalCount)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    // pass "true" as 2nd arg to replace history state so back button still takes you back to index
	    search: function search(term) {
	        return (0, _questions.search)(term, true);
	    }
	};
	
	var SearchResults = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(SearchResults, _Component);
	
	    function SearchResults() {
	        _classCallCheck(this, SearchResults);
	
	        return _possibleConstructorReturn(this, (SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).apply(this, arguments));
	    }
	
	    _createClass(SearchResults, [{
	        key: "render",
	        value: function render() {
	            var totalCount = this.props.totalCount;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "px4 pt3" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center mb3" },
	                    _react2.default.createElement(_HeaderWithBack2.default, { name: totalCount != null ? totalCount + " " + (0, _formatting.inflect)("result", totalCount) : "Search results"
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ml-auto flex align-center" },
	                        _react2.default.createElement(_ExpandingSearchField2.default, {
	                            active: true,
	                            defaultValue: this.props.location.query.q,
	                            onSearch: this.props.search
	                        })
	                    )
	                ),
	                _react2.default.createElement(_EntityList2.default, {
	                    entityType: "cards",
	                    entityQuery: this.props.location.query,
	                    showSearchWidget: false,
	                    defaultEmptyState: "No matching questions found"
	                })
	            );
	        }
	    }]);
	
	    return SearchResults;
	}(_react.Component)) || _class);
	SearchResults.displayName = "SearchResults";
	exports.default = SearchResults;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _EditLabels = __webpack_require__(1661);
	
	var _EditLabels2 = _interopRequireDefault(_EditLabels);
	
	var _Confirm = __webpack_require__(1245);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _labels = __webpack_require__(1641);
	
	var labelsActions = _interopRequireWildcard(_labels);
	
	var _selectors = __webpack_require__(1612);
	
	var _colors = __webpack_require__(881);
	
	var colors = _interopRequireWildcard(_colors);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LabelEditorForm = __webpack_require__(1663);
	
	var _LabelEditorForm2 = _interopRequireDefault(_LabelEditorForm);
	
	var _LabelIcon = __webpack_require__(1638);
	
	var _LabelIcon2 = _interopRequireDefault(_LabelIcon);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        labels: (0, _selectors.getLabels)(state, props),
	        labelsLoading: (0, _selectors.getLabelsLoading)(state, props),
	        labelsError: (0, _selectors.getLabelsError)(state, props),
	        editingLabelId: (0, _selectors.getEditingLabelId)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, labelsActions);
	
	// import LabelEditor from "../components/LabelEditor.jsx";
	var EditLabels = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(EditLabels, _Component);
	
	    function EditLabels() {
	        _classCallCheck(this, EditLabels);
	
	        return _possibleConstructorReturn(this, (EditLabels.__proto__ || Object.getPrototypeOf(EditLabels)).apply(this, arguments));
	    }
	
	    _createClass(EditLabels, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.loadLabels();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                style = _props.style,
	                labels = _props.labels,
	                labelsLoading = _props.labelsLoading,
	                labelsError = _props.labelsError,
	                editingLabelId = _props.editingLabelId,
	                saveLabel = _props.saveLabel,
	                editLabel = _props.editLabel,
	                deleteLabel = _props.deleteLabel;
	
	            return _react2.default.createElement(
	                "div",
	                { className: _EditLabels2.default.editor, style: style },
	                _react2.default.createElement(
	                    "div",
	                    { className: "wrapper wrapper--trim" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _EditLabels2.default.header },
	                        "Add and edit labels"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "bordered border-error rounded p2 mb2" },
	                        _react2.default.createElement(
	                            "h3",
	                            { className: "text-error mb1" },
	                            "Heads up!"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            null,
	                            "In an upcoming release, Labels will be removed in favor of Collections."
	                        )
	                    )
	                ),
	                _react2.default.createElement(_LabelEditorForm2.default, { onSubmit: saveLabel, initialValues: { icon: colors.normal.blue, name: "" }, submitButtonText: "Create Label", className: "wrapper wrapper--trim" }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: labelsLoading, error: labelsError, noBackground: true, noWrapper: true },
	                    function () {
	                        return labels.length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                "ul",
	                                { className: _EditLabels2.default.list },
	                                labels.map(function (label) {
	                                    return editingLabelId === label.id ? _react2.default.createElement(
	                                        "li",
	                                        { key: label.id, className: _EditLabels2.default.labelEditing },
	                                        _react2.default.createElement(_LabelEditorForm2.default, { formKey: String(label.id), className: "flex-full", onSubmit: saveLabel, initialValues: label, submitButtonText: "Update Label" }),
	                                        _react2.default.createElement(
	                                            "a",
	                                            { className: " text-grey-1 text-grey-4-hover ml2", onClick: function onClick() {
	                                                    return editLabel(null);
	                                                } },
	                                            "Cancel"
	                                        )
	                                    ) : _react2.default.createElement(
	                                        "li",
	                                        { key: label.id, className: _EditLabels2.default.label },
	                                        _react2.default.createElement(_LabelIcon2.default, { icon: label.icon, size: 28 }),
	                                        _react2.default.createElement(
	                                            "span",
	                                            { className: _EditLabels2.default.name },
	                                            label.name
	                                        ),
	                                        _react2.default.createElement(
	                                            "a",
	                                            { className: _EditLabels2.default.edit, onClick: function onClick() {
	                                                    return editLabel(label.id);
	                                                } },
	                                            "Edit"
	                                        ),
	                                        _react2.default.createElement(
	                                            _Confirm2.default,
	                                            { title: "Delete label \"" + label.name + "\"", action: function action() {
	                                                    return deleteLabel(label.id);
	                                                } },
	                                            _react2.default.createElement(_Icon2.default, { className: _EditLabels2.default.delete + " text-grey-1 text-grey-4-hover", name: "close", size: 14 })
	                                        )
	                                    );
	                                })
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: "full-height full flex-full flex align-center justify-center" },
	                            _react2.default.createElement(_EmptyState2.default, { message: "Create labels to group and manage questions.", icon: "label" })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return EditLabels;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object,
	    labels: _propTypes2.default.array.isRequired,
	    labelsLoading: _propTypes2.default.bool.isRequired,
	    labelsError: _propTypes2.default.any,
	    editingLabelId: _propTypes2.default.number,
	    saveLabel: _propTypes2.default.func.isRequired,
	    editLabel: _propTypes2.default.func.isRequired,
	    deleteLabel: _propTypes2.default.func.isRequired,
	    loadLabels: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	EditLabels.displayName = "EditLabels";
	exports.default = EditLabels;

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"i3TqC _37W4X _2AJrG _1PyuO _37W4X _2AJrG","editor":"_2XxIP _2kZNz","list":"_3JeVK hPXk7","label":"_2Jnvg _38618 _3Dqep _2Hk-A _1s_jv _3FzDO","labelEditing":"CMeaj _38618 _3Dqep _2Hk-A _1s_jv","name":"_1Jfun _2kZNz _3or2i","edit":"y4x81 _342no","delete":"SKUG5 _1a-AI"};

/***/ }),
/* 1662 */,
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LabelEditorForm = __webpack_require__(1664);
	
	var _LabelEditorForm2 = _interopRequireDefault(_LabelEditorForm);
	
	var _LabelIconPicker = __webpack_require__(1666);
	
	var _LabelIconPicker2 = _interopRequireDefault(_LabelIconPicker);
	
	var _reduxForm = __webpack_require__(589);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LabelEditorForm = (_dec = (0, _reduxForm.reduxForm)({
	    form: 'label',
	    fields: ['icon', 'name', 'id'],
	    validate: function validate(values) {
	        var errors = {};
	        if (!values.name) {
	            errors.name = true;
	        }
	        if (!values.icon) {
	            errors.icon = "Icon is required";
	        }
	        return errors;
	    }
	}), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(LabelEditorForm, _Component);
	
	    function LabelEditorForm() {
	        _classCallCheck(this, LabelEditorForm);
	
	        return _possibleConstructorReturn(this, (LabelEditorForm.__proto__ || Object.getPrototypeOf(LabelEditorForm)).apply(this, arguments));
	    }
	
	    _createClass(LabelEditorForm, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                _props$fields = _props.fields,
	                icon = _props$fields.icon,
	                name = _props$fields.name,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                invalid = _props.invalid,
	                className = _props.className,
	                submitButtonText = _props.submitButtonText;
	
	            var nameInvalid = name.invalid && (name.active && name.value || !name.active && name.visited);
	            var errorMessage = name.error || error;
	            return _react2.default.createElement(
	                "form",
	                { className: className, onSubmit: handleSubmit },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex" },
	                    _react2.default.createElement(_LabelIconPicker2.default, icon),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "full" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex" },
	                            _react2.default.createElement("input", _extends({ className: (0, _classnames2.default)(_LabelEditorForm2.default.nameInput, "input", _defineProperty({}, _LabelEditorForm2.default.invalid, nameInvalid)), type: "text", placeholder: "Name" }, name)),
	                            _react2.default.createElement(
	                                "button",
	                                { className: (0, _classnames2.default)("Button", "ml1", { "disabled": invalid, "Button--primary": !invalid }), type: "submit" },
	                                submitButtonText
	                            )
	                        ),
	                        nameInvalid && errorMessage && _react2.default.createElement(
	                            "div",
	                            { className: _LabelEditorForm2.default.errorMessage },
	                            errorMessage
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LabelEditorForm;
	}(_react.Component), _class2.propTypes = {
	    className: _propTypes2.default.string,
	    fields: _propTypes2.default.object.isRequired,
	    invalid: _propTypes2.default.bool.isRequired,
	    error: _propTypes2.default.any,
	    submitButtonText: _propTypes2.default.string.isRequired,
	    handleSubmit: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	LabelEditorForm.displayName = "LabelEditorForm";
	exports.default = LabelEditorForm;

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"nameInput":"_2ADeB _2kZNz BcFLh","invalid":"_3rOd9 _3P-AT","errorMessage":"K3QaF _31ino _2itq0 _3TD8R _1Cy_o"};

/***/ }),
/* 1665 */,
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ref, _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LabelIconPicker = __webpack_require__(1667);
	
	var _LabelIconPicker2 = _interopRequireDefault(_LabelIconPicker);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LabelIcon = __webpack_require__(1638);
	
	var _LabelIcon2 = _interopRequireDefault(_LabelIcon);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _reactVirtualized = __webpack_require__(1303);
	
	__webpack_require__(1669);
	
	var _colors = __webpack_require__(881);
	
	var colors = _interopRequireWildcard(_colors);
	
	var _emoji = __webpack_require__(1627);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint "react/prop-types": "warn" */
	
	
	var ROW_HEIGHT = 45;
	var VISIBLE_ROWS = 6;
	var HEIGHT = VISIBLE_ROWS * ROW_HEIGHT;
	var WIDTH = 330;
	
	var ICONS_PER_ROW = 6;
	
	var ROWS = [];
	var CATEGORY_ROW_MAP = {};
	
	function pushHeader(title) {
	    ROWS.push({ type: "header", title: title });
	}
	function pushIcons(icons) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = icons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var icon = _step.value;
	
	            var current = ROWS[ROWS.length - 1];
	            if (current.type !== "icons" || current.icons.length === ICONS_PER_ROW) {
	                current = { type: "icons", icons: [] };
	                ROWS.push(current);
	            }
	            current.icons.push(icon);
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	}
	
	// Colors
	var ALL_COLORS = (_ref = []).concat.apply(_ref, _toConsumableArray([colors.saturated, colors.normal, colors.desaturated].map(function (o) {
	    return Object.values(o);
	})));
	pushHeader("Colors");
	pushIcons(ALL_COLORS);
	
	// Emoji
	_emoji.categories.map(function (category) {
	    CATEGORY_ROW_MAP[category.id] = ROWS.length;
	    pushHeader(category.name);
	    pushIcons(category.emoji);
	});
	
	var LabelIconPicker = (_temp = _class = function (_Component) {
	    _inherits(LabelIconPicker, _Component);
	
	    function LabelIconPicker(props, context) {
	        _classCallCheck(this, LabelIconPicker);
	
	        var _this = _possibleConstructorReturn(this, (LabelIconPicker.__proto__ || Object.getPrototypeOf(LabelIconPicker)).call(this, props, context));
	
	        _this.state = {
	            topIndex: 0,
	            scrollToIndex: 0
	        };
	        return _this;
	    }
	
	    _createClass(LabelIconPicker, [{
	        key: "scrollToCategory",
	        value: function scrollToCategory(id) {
	            var categoryIndex = CATEGORY_ROW_MAP[id];
	            if (categoryIndex > this.state.topIndex) {
	                this.setState({ scrollToIndex: categoryIndex + VISIBLE_ROWS - 1 });
	            } else {
	                this.setState({ scrollToIndex: categoryIndex });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                value = _props.value,
	                onChange = _props.onChange;
	
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                {
	                    triggerElement: _react2.default.createElement(LabelIconButton, { value: value }),
	                    ref: "popover"
	                },
	                _react2.default.createElement(_reactVirtualized.List, {
	                    width: WIDTH,
	                    height: HEIGHT,
	                    rowCount: ROWS.length,
	                    rowHeight: ROW_HEIGHT,
	                    rowRenderer: function rowRenderer(_ref2) {
	                        var index = _ref2.index,
	                            key = _ref2.key,
	                            style = _ref2.style;
	                        return ROWS[index].type === "header" ? _react2.default.createElement(
	                            "div",
	                            { key: key, style: style, className: _LabelIconPicker2.default.sectionHeader },
	                            ROWS[index].title
	                        ) : _react2.default.createElement(
	                            "ul",
	                            { key: key, style: style, className: _LabelIconPicker2.default.list },
	                            ROWS[index].icons.map(function (icon) {
	                                return _react2.default.createElement(
	                                    "li",
	                                    { key: icon, className: _LabelIconPicker2.default.option, onClick: function onClick() {
	                                            onChange(icon);_this2.refs.popover.close();
	                                        } },
	                                    _react2.default.createElement(_LabelIcon2.default, { icon: icon, size: 28 })
	                                );
	                            })
	                        );
	                    },
	                    scrollToIndex: this.state.scrollToIndex,
	                    onRowsRendered: function onRowsRendered(_ref3) {
	                        var overscanStartIndex = _ref3.overscanStartIndex,
	                            overscanStopIndex = _ref3.overscanStopIndex,
	                            startIndex = _ref3.startIndex,
	                            stopIndex = _ref3.stopIndex;
	                        return _this2.setState({ topIndex: startIndex });
	                    }
	                }),
	                _react2.default.createElement(
	                    "ul",
	                    { className: _LabelIconPicker2.default.sectionList, style: { width: WIDTH } },
	                    _emoji.categories.map(function (category) {
	                        return _react2.default.createElement(
	                            "li",
	                            { key: category.id, className: _LabelIconPicker2.default.category, onClick: function onClick() {
	                                    return _this2.scrollToCategory(category.id);
	                                } },
	                            _react2.default.createElement(_Icon2.default, { name: "emoji" + category.id })
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return LabelIconPicker;
	}(_react.Component), _class.propTypes = {
	    value: _propTypes2.default.string,
	    onChange: _propTypes2.default.func.isRequired
	}, _temp);
	LabelIconPicker.displayName = "LabelIconPicker";
	exports.default = LabelIconPicker;
	
	
	var LabelIconButton = function LabelIconButton(_ref4) {
	    var _ref4$value = _ref4.value,
	        value = _ref4$value === undefined ? "#eee" : _ref4$value;
	    return _react2.default.createElement(
	        "span",
	        { className: _LabelIconPicker2.default.dropdownButton },
	        _react2.default.createElement(_LabelIcon2.default, { icon: value, size: 28 }),
	        _react2.default.createElement(_Icon2.default, { className: _LabelIconPicker2.default.chevron, name: "chevrondown", size: 14 })
	    );
	};
	
	LabelIconButton.displayName = "LabelIconButton";
	LabelIconButton.propTypes = {
	    value: _propTypes2.default.string
	};

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_3JYQX _37W4X _2AJrG","sectionHeader":"_2t5sZ _1FLRv PYP7R _38618 _3Dqep","list":"_1c_Rr _38618 _3Dqep _1aL0S","sectionList":"_3JRr7 _1c_Rr _38618 _3Dqep _1aL0S _2Hk-A _2XN97","option":"_14UYr _1FLRv _38618 _3-Ogs _1a-AI","dropdownButton":"_3OfvB _38618 Wr_al _31ino _3-Ogs","chevron":"_6GHBB BcFLh","category":"_3q1QM _1FLRv _1a-AI _2rmlO"};

/***/ }),
/* 1668 */,
/* 1669 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1670 */,
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _PermissionsEditor = __webpack_require__(1672);
	
	var _PermissionsEditor2 = _interopRequireDefault(_PermissionsEditor);
	
	var _PermissionsApp = __webpack_require__(1681);
	
	var _PermissionsApp2 = _interopRequireDefault(_PermissionsApp);
	
	var _services = __webpack_require__(857);
	
	var _selectors = __webpack_require__(1684);
	
	var _permissions = __webpack_require__(1682);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        grid: (0, _selectors.getCollectionsPermissionsGrid)(state, props),
	        isDirty: (0, _selectors.getIsDirty)(state, props),
	        saveError: (0, _selectors.getSaveError)(state, props),
	        diff: (0, _selectors.getDiff)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    onUpdatePermission: _permissions.updatePermission,
	    onSave: _permissions.savePermissions,
	    onCancel: function onCancel() {
	        return window.history.length > 1 ? (0, _reactRouterRedux.goBack)() : (0, _reactRouterRedux.push)("/questions");
	    }
	};
	
	var Editor = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PermissionsEditor2.default);
	
	var CollectionsPermissionsApp = (_dec = (0, _reactRedux.connect)(null, { loadCollections: _permissions.loadCollections }), _dec(_class = function (_Component) {
	    _inherits(CollectionsPermissionsApp, _Component);
	
	    function CollectionsPermissionsApp() {
	        _classCallCheck(this, CollectionsPermissionsApp);
	
	        return _possibleConstructorReturn(this, (CollectionsPermissionsApp.__proto__ || Object.getPrototypeOf(CollectionsPermissionsApp)).apply(this, arguments));
	    }
	
	    _createClass(CollectionsPermissionsApp, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.loadCollections();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _PermissionsApp2.default,
	                _extends({}, this.props, {
	                    load: _services.CollectionsApi.graph,
	                    save: _services.CollectionsApi.updateGraph
	                }),
	                _react2.default.createElement(Editor, _extends({}, this.props, { modal: true, confirmCancel: false }))
	            );
	        }
	    }]);
	
	    return CollectionsPermissionsApp;
	}(_react.Component)) || _class);
	CollectionsPermissionsApp.displayName = "CollectionsPermissionsApp";
	exports.default = CollectionsPermissionsApp;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _Confirm = __webpack_require__(1245);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PermissionsGrid = __webpack_require__(1673);
	
	var _PermissionsGrid2 = _interopRequireDefault(_PermissionsGrid);
	
	var _PermissionsConfirm = __webpack_require__(1677);
	
	var _PermissionsConfirm2 = _interopRequireDefault(_PermissionsConfirm);
	
	var _EditBar = __webpack_require__(1646);
	
	var _EditBar2 = _interopRequireDefault(_EditBar);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PermissionsEditor = function PermissionsEditor(_ref) {
	    var _ref$title = _ref.title,
	        title = _ref$title === undefined ? "Permissions" : _ref$title,
	        modal = _ref.modal,
	        admin = _ref.admin,
	        grid = _ref.grid,
	        onUpdatePermission = _ref.onUpdatePermission,
	        onSave = _ref.onSave,
	        onCancel = _ref.onCancel,
	        confirmCancel = _ref.confirmCancel,
	        isDirty = _ref.isDirty,
	        saveError = _ref.saveError,
	        diff = _ref.diff,
	        location = _ref.location;
	
	    var saveButton = _react2.default.createElement(
	        _Confirm2.default,
	        {
	            title: "Save permissions?",
	            action: onSave,
	            content: _react2.default.createElement(_PermissionsConfirm2.default, { diff: diff }),
	            triggerClasses: (0, _classnames2.default)({ disabled: !isDirty }),
	            key: "save"
	        },
	        _react2.default.createElement(
	            _Button2.default,
	            { primary: true, small: !modal },
	            "Save Changes"
	        )
	    );
	
	    var cancelButton = confirmCancel ? _react2.default.createElement(
	        _Confirm2.default,
	        {
	            title: "Discard changes?",
	            action: onCancel,
	            content: "No changes to permissions will be made.",
	            key: "discard"
	        },
	        _react2.default.createElement(
	            _Button2.default,
	            { small: !modal },
	            "Cancel"
	        )
	    ) : _react2.default.createElement(
	        _Button2.default,
	        { small: !modal, onClick: onCancel, key: "cancel" },
	        "Cancel"
	    );
	
	    return _react2.default.createElement(
	        _LoadingAndErrorWrapper2.default,
	        { loading: !grid, className: "flex-full flex flex-column" },
	        function () {
	            return (// eslint-disable-line react/display-name
	                modal ? _react2.default.createElement(
	                    _Modal2.default,
	                    { inline: true, title: title, footer: [cancelButton, saveButton], onClose: onCancel },
	                    _react2.default.createElement(_PermissionsGrid2.default, _extends({
	                        className: "flex-full",
	                        grid: grid,
	                        onUpdatePermission: onUpdatePermission
	                    }, getEntityAndGroupIdFromLocation(location)))
	                ) : _react2.default.createElement(
	                    "div",
	                    { className: "flex-full flex flex-column" },
	                    isDirty && _react2.default.createElement(_EditBar2.default, {
	                        admin: admin,
	                        title: "You've made changes to permissions.",
	                        buttons: [cancelButton, saveButton]
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wrapper pt2" },
	                        grid && grid.crumbs ? _react2.default.createElement(_Breadcrumbs2.default, { className: "py1", crumbs: grid.crumbs }) : _react2.default.createElement(
	                            "h2",
	                            null,
	                            title
	                        )
	                    ),
	                    _react2.default.createElement(_PermissionsGrid2.default, _extends({
	                        className: "flex-full",
	                        grid: grid,
	                        onUpdatePermission: onUpdatePermission
	                    }, getEntityAndGroupIdFromLocation(location)))
	                )
	            );
	        }
	    );
	};
	
	PermissionsEditor.displayName = "PermissionsEditor";
	PermissionsEditor.defaultProps = {
	    admin: true
	};
	
	function getEntityAndGroupIdFromLocation() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$query = _ref2.query,
	        query = _ref2$query === undefined ? {} : _ref2$query;
	
	    query = _underscore2.default.mapObject(query, function (value) {
	        return isNaN(value) ? value : parseFloat(value);
	    });
	    var entityId = _underscore2.default.omit(query, "groupId");
	    var groupId = query.groupId;
	    return {
	        groupId: groupId || null,
	        entityId: Object.keys(entityId).length > 0 ? entityId : null
	    };
	}
	
	exports.default = PermissionsEditor;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ConfirmContent = __webpack_require__(1264);
	
	var _ConfirmContent2 = _interopRequireDefault(_ConfirmContent);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _FixedHeaderGrid = __webpack_require__(1674);
	
	var _FixedHeaderGrid2 = _interopRequireDefault(_FixedHeaderGrid);
	
	var _reactVirtualized = __webpack_require__(1303);
	
	var _formatting = __webpack_require__(872);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/display-name */
	
	var LIGHT_BORDER = "rgb(225, 226, 227)";
	var DARK_BORDER = "rgb(161, 163, 169)";
	var BORDER_RADIUS = 4;
	
	var getBorderStyles = function getBorderStyles(_ref) {
	    var isFirstColumn = _ref.isFirstColumn,
	        isLastColumn = _ref.isLastColumn,
	        isFirstRow = _ref.isFirstRow,
	        isLastRow = _ref.isLastRow;
	    return {
	        overflow: "hidden",
	        border: "1px solid " + LIGHT_BORDER,
	        borderTopWidth: isFirstRow ? 1 : 0,
	        borderRightWidth: isLastColumn ? 1 : 0,
	        borderLeftColor: isFirstColumn ? LIGHT_BORDER : DARK_BORDER,
	        borderTopRightRadius: isLastColumn && isFirstRow ? BORDER_RADIUS : 0,
	        borderTopLeftRadius: isFirstColumn && isFirstRow ? BORDER_RADIUS : 0,
	        borderBottomRightRadius: isLastColumn && isLastRow ? BORDER_RADIUS : 0,
	        borderBottomLeftRadius: isFirstColumn && isLastRow ? BORDER_RADIUS : 0
	    };
	};
	
	var CELL_HEIGHT = 100;
	var CELL_WIDTH = 246;
	var HEADER_HEIGHT = 65;
	var HEADER_WIDTH = 240;
	
	var DEFAULT_OPTION = {
	    icon: "unknown",
	    iconColor: "#9BA5B1",
	    bgColor: "#DFE8EA"
	};
	
	var GroupColumnHeader = function GroupColumnHeader(_ref2) {
	    var group = _ref2.group,
	        permissions = _ref2.permissions,
	        isLastColumn = _ref2.isLastColumn,
	        isFirstColumn = _ref2.isFirstColumn;
	    return _react2.default.createElement(
	        "div",
	        { className: "absolute bottom left right" },
	        _react2.default.createElement(
	            "h4",
	            { className: "text-centered full my1 flex layout-centered" },
	            group.name,
	            group.tooltip && _react2.default.createElement(
	                _Tooltip2.default,
	                { tooltip: group.tooltip, maxWidth: "24em" },
	                _react2.default.createElement(_Icon2.default, { className: "ml1", name: "question" })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "flex", style: getBorderStyles({ isLastColumn: isLastColumn, isFirstColumn: isFirstColumn, isFirstRow: true, isLastRow: false }) },
	            permissions.map(function (permission, index) {
	                return _react2.default.createElement(
	                    "div",
	                    { key: permission.id, className: "flex-full border-column-divider", style: {
	                            borderColor: LIGHT_BORDER
	                        } },
	                    permission.header && _react2.default.createElement(
	                        "h5",
	                        { className: "my1 text-centered text-grey-3 text-uppercase text-light" },
	                        permission.header
	                    )
	                );
	            })
	        )
	    );
	};
	
	GroupColumnHeader.displayName = "GroupColumnHeader";
	var PermissionsCell = function PermissionsCell(_ref3) {
	    var group = _ref3.group,
	        permissions = _ref3.permissions,
	        entity = _ref3.entity,
	        onUpdatePermission = _ref3.onUpdatePermission,
	        isLastRow = _ref3.isLastRow,
	        isLastColumn = _ref3.isLastColumn,
	        isFirstColumn = _ref3.isFirstColumn,
	        isFaded = _ref3.isFaded;
	    return _react2.default.createElement(
	        "div",
	        { className: "flex", style: getBorderStyles({ isLastRow: isLastRow, isLastColumn: isLastColumn, isFirstColumn: isFirstColumn, isFirstRow: false }) },
	        permissions.map(function (permission) {
	            return _react2.default.createElement(GroupPermissionCell, {
	                key: permission.id,
	                permission: permission,
	                group: group,
	                entity: entity,
	                onUpdatePermission: onUpdatePermission,
	                isEditable: group.editable,
	                isFaded: isFaded
	            });
	        })
	    );
	};
	
	PermissionsCell.displayName = "PermissionsCell";
	
	var GroupPermissionCell = function (_Component) {
	    _inherits(GroupPermissionCell, _Component);
	
	    function GroupPermissionCell(props, context) {
	        _classCallCheck(this, GroupPermissionCell);
	
	        var _this = _possibleConstructorReturn(this, (GroupPermissionCell.__proto__ || Object.getPrototypeOf(GroupPermissionCell)).call(this, props, context));
	
	        _this.state = {
	            confirmations: null,
	            confirmAction: null,
	            hovered: false
	        };
	        return _this;
	    }
	
	    _createClass(GroupPermissionCell, [{
	        key: "hoverEnter",
	        value: function hoverEnter() {
	            // only change the hover state if the group is not the admin
	            // this helps indicate to users that the admin group is different
	            if (this.props.isEditable) {
	                return this.setState({ hovered: true });
	            }
	            return false;
	        }
	    }, {
	        key: "hoverExit",
	        value: function hoverExit() {
	            if (this.props.isEditable) {
	                return this.setState({ hovered: false });
	            }
	            return false;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                permission = _props.permission,
	                group = _props.group,
	                entity = _props.entity,
	                onUpdatePermission = _props.onUpdatePermission,
	                isFaded = _props.isFaded;
	            var confirmations = this.state.confirmations;
	
	
	            var value = permission.getter(group.id, entity.id);
	            var options = permission.options(group.id, entity.id);
	            var warning = permission.warning && permission.warning(group.id, entity.id);
	
	            var isEditable = this.props.isEditable && options.filter(function (option) {
	                return option.value !== value;
	            }).length > 0;
	            var option = _underscore2.default.findWhere(options, { value: value }) || DEFAULT_OPTION;
	
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                {
	                    ref: "popover",
	                    disabled: !isEditable,
	                    triggerClasses: "cursor-pointer flex flex-full layout-centered border-column-divider",
	                    triggerElement: _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: option.tooltip },
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                className: (0, _classnames2.default)('flex-full flex layout-centered relative', {
	                                    'cursor-pointer': isEditable,
	                                    faded: isFaded
	                                }),
	                                style: {
	                                    borderColor: LIGHT_BORDER,
	                                    height: CELL_HEIGHT - 1,
	                                    backgroundColor: this.state.hovered ? option.iconColor : option.bgColor
	                                },
	                                onMouseEnter: function onMouseEnter() {
	                                    return _this2.hoverEnter();
	                                },
	                                onMouseLeave: function onMouseLeave() {
	                                    return _this2.hoverExit();
	                                }
	                            },
	                            _react2.default.createElement(_Icon2.default, {
	                                name: option.icon,
	                                size: 28,
	                                style: { color: this.state.hovered ? '#fff' : option.iconColor }
	                            }),
	                            confirmations && confirmations.length > 0 && _react2.default.createElement(
	                                _Modal2.default,
	                                null,
	                                _react2.default.createElement(_ConfirmContent2.default, _extends({}, confirmations[0], {
	                                    onAction: function onAction() {
	                                        return (
	                                            // if it's the last one call confirmAction, otherwise remove the confirmation that was just confirmed
	                                            confirmations.length === 1 ? _this2.setState({ confirmations: null, confirmAction: null }, _this2.state.confirmAction) : _this2.setState({ confirmations: confirmations.slice(1) })
	                                        );
	                                    },
	                                    onCancel: function onCancel() {
	                                        return _this2.setState({ confirmations: null, confirmAction: null });
	                                    }
	                                }))
	                            ),
	                            warning && _react2.default.createElement(
	                                "div",
	                                { className: "absolute top right p1" },
	                                _react2.default.createElement(
	                                    _Tooltip2.default,
	                                    { tooltip: warning, maxWidth: "24em" },
	                                    _react2.default.createElement(_Icon2.default, { name: "warning2", className: "text-slate" })
	                                )
	                            )
	                        )
	                    )
	                },
	                _react2.default.createElement(AccessOptionList, {
	                    value: value,
	                    options: options,
	                    permission: permission,
	                    onChange: function onChange(value) {
	                        var confirmAction = function confirmAction() {
	                            onUpdatePermission({
	                                groupId: group.id,
	                                entityId: entity.id,
	                                value: value,
	                                updater: permission.updater,
	                                postAction: permission.postAction
	                            });
	                        };
	                        var confirmations = (permission.confirm && permission.confirm(group.id, entity.id, value) || []).filter(function (c) {
	                            return c;
	                        });
	                        if (confirmations.length > 0) {
	                            _this2.setState({ confirmations: confirmations, confirmAction: confirmAction });
	                        } else {
	                            confirmAction();
	                        }
	                        _this2.refs.popover.close();
	                    }
	                })
	            );
	        }
	    }]);
	
	    return GroupPermissionCell;
	}(_react.Component);
	
	GroupPermissionCell.displayName = "GroupPermissionCell";
	
	
	var AccessOption = function AccessOption(_ref4) {
	    var value = _ref4.value,
	        option = _ref4.option,
	        onChange = _ref4.onChange;
	    return _react2.default.createElement(
	        "div",
	        {
	            className: (0, _classnames2.default)("flex py2 px2 align-center bg-brand-hover text-white-hover cursor-pointer", {
	                "bg-brand text-white": value === option
	            }),
	            onClick: function onClick() {
	                return onChange(option.value);
	            }
	        },
	        _react2.default.createElement(_Icon2.default, { name: option.icon, className: "mr1", style: { color: option.iconColor }, size: 18 }),
	        option.title
	    );
	};
	
	AccessOption.displayName = "AccessOption";
	var AccessOptionList = function AccessOptionList(_ref5) {
	    var value = _ref5.value,
	        options = _ref5.options,
	        onChange = _ref5.onChange;
	    return _react2.default.createElement(
	        "ul",
	        { className: "py1" },
	        options.map(function (option) {
	            if (value !== option.value) {
	                return _react2.default.createElement(
	                    "li",
	                    { key: option.value },
	                    _react2.default.createElement(AccessOption, { value: value, option: option, onChange: onChange })
	                );
	            }
	        })
	    );
	};
	
	AccessOptionList.displayName = "AccessOptionList";
	var EntityRowHeader = function EntityRowHeader(_ref6) {
	    var entity = _ref6.entity,
	        icon = _ref6.icon;
	    return _react2.default.createElement(
	        "div",
	        {
	            className: "flex flex-column justify-center px1 pl4 ml2",
	            style: {
	                height: CELL_HEIGHT
	            }
	        },
	        _react2.default.createElement(
	            "div",
	            { className: "relative flex align-center" },
	            _react2.default.createElement(_Icon2.default, { name: icon, className: "absolute", style: { left: -28 } }),
	            _react2.default.createElement(
	                "h4",
	                null,
	                entity.name
	            )
	        ),
	        entity.subtitle && _react2.default.createElement(
	            "span",
	            { className: "mt1 h5 text-monospace text-normal text-grey-2 text-uppercase" },
	            entity.subtitle
	        ),
	        entity.link && _react2.default.createElement(
	            _reactRouter.Link,
	            { className: "mt1 link", to: entity.link.url },
	            entity.link.name
	        )
	    );
	};
	
	EntityRowHeader.displayName = "EntityRowHeader";
	var CornerHeader = function CornerHeader(_ref7) {
	    var grid = _ref7.grid;
	    return _react2.default.createElement(
	        "div",
	        { className: "absolute bottom left right flex flex-column align-center pb1" },
	        _react2.default.createElement(
	            "div",
	            { className: "flex align-center" },
	            _react2.default.createElement(
	                "h3",
	                { className: "ml1" },
	                (0, _formatting.capitalize)((0, _formatting.pluralize)(grid.type))
	            )
	        )
	    );
	};
	
	CornerHeader.displayName = "CornerHeader";
	
	
	var PermissionsGrid = function PermissionsGrid(_ref8) {
	    var className = _ref8.className,
	        grid = _ref8.grid,
	        onUpdatePermission = _ref8.onUpdatePermission,
	        entityId = _ref8.entityId,
	        groupId = _ref8.groupId;
	
	    var permissions = Object.entries(grid.permissions).map(function (_ref9) {
	        var _ref10 = _slicedToArray(_ref9, 2),
	            id = _ref10[0],
	            permission = _ref10[1];
	
	        return _extends({ id: id }, permission);
	    });
	    return _react2.default.createElement(
	        "div",
	        { className: className },
	        _react2.default.createElement(
	            _reactVirtualized.AutoSizer,
	            null,
	            function (_ref11) {
	                var height = _ref11.height,
	                    width = _ref11.width;
	                return _react2.default.createElement(_FixedHeaderGrid2.default, {
	                    height: height,
	                    width: width,
	                    rowCount: grid.entities.length,
	                    columnCount: grid.groups.length,
	                    columnWidth: Math.max(CELL_WIDTH, (width - 20 - HEADER_WIDTH) / grid.groups.length),
	                    rowHeight: CELL_HEIGHT,
	                    paddingBottom: 20,
	                    paddingRight: 20,
	                    columnHeaderHeight: HEADER_HEIGHT,
	                    rowHeaderWidth: HEADER_WIDTH,
	                    renderCell: function renderCell(_ref12) {
	                        var columnIndex = _ref12.columnIndex,
	                            rowIndex = _ref12.rowIndex;
	                        return _react2.default.createElement(PermissionsCell, {
	                            group: grid.groups[columnIndex],
	                            permissions: permissions,
	                            entity: grid.entities[rowIndex],
	                            onUpdatePermission: onUpdatePermission,
	                            isFirstRow: rowIndex === 0,
	                            isLastRow: rowIndex === grid.entities.length - 1,
	                            isFirstColumn: columnIndex === 0,
	                            isLastColumn: columnIndex === grid.groups.length - 1,
	                            isFaded: groupId != null && grid.groups[columnIndex].id !== groupId || entityId != null && !_underscore2.default.isEqual(entityId, grid.entities[rowIndex].id)
	                        });
	                    },
	                    renderColumnHeader: function renderColumnHeader(_ref13) {
	                        var columnIndex = _ref13.columnIndex;
	                        return _react2.default.createElement(GroupColumnHeader, {
	                            group: grid.groups[columnIndex],
	                            permissions: permissions,
	                            isFirstColumn: columnIndex === 0,
	                            isLastColumn: columnIndex === grid.groups.length - 1
	                        });
	                    },
	                    renderRowHeader: function renderRowHeader(_ref14) {
	                        var rowIndex = _ref14.rowIndex;
	                        return _react2.default.createElement(EntityRowHeader, {
	                            icon: grid.icon,
	                            entity: grid.entities[rowIndex],
	                            isFirstRow: rowIndex === 0,
	                            isLastRow: rowIndex === grid.entities.length - 1
	                        });
	                    },
	                    renderCorner: function renderCorner() {
	                        return _react2.default.createElement(CornerHeader, {
	                            grid: grid
	                        });
	                    }
	                });
	            }
	        )
	    );
	};
	
	PermissionsGrid.displayName = "PermissionsGrid";
	exports.default = PermissionsGrid;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVirtualized = __webpack_require__(1303);
	
	__webpack_require__(1669);
	
	var _FixedHeaderGrid = __webpack_require__(1675);
	
	var _FixedHeaderGrid2 = _interopRequireDefault(_FixedHeaderGrid);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FixedHeaderGrid = function FixedHeaderGrid(_ref) {
	    var className = _ref.className,
	        rowCount = _ref.rowCount,
	        columnCount = _ref.columnCount,
	        renderCell = _ref.renderCell,
	        _columnWidth = _ref.columnWidth,
	        _rowHeight = _ref.rowHeight,
	        renderColumnHeader = _ref.renderColumnHeader,
	        columnHeaderHeight = _ref.columnHeaderHeight,
	        rowHeaderWidth = _ref.rowHeaderWidth,
	        renderRowHeader = _ref.renderRowHeader,
	        renderCorner = _ref.renderCorner,
	        width = _ref.width,
	        height = _ref.height,
	        _ref$paddingBottom = _ref.paddingBottom,
	        paddingBottom = _ref$paddingBottom === undefined ? 0 : _ref$paddingBottom,
	        _ref$paddingRight = _ref.paddingRight,
	        paddingRight = _ref$paddingRight === undefined ? 0 : _ref$paddingRight;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(className, _FixedHeaderGrid2.default.fixedHeaderGrid, "relative") },
	        _react2.default.createElement(
	            _reactVirtualized.ScrollSync,
	            null,
	            function (_ref2) {
	                var clientHeight = _ref2.clientHeight,
	                    clientWidth = _ref2.clientWidth,
	                    _onScroll = _ref2.onScroll,
	                    scrollHeight = _ref2.scrollHeight,
	                    scrollLeft = _ref2.scrollLeft,
	                    scrollTop = _ref2.scrollTop,
	                    scrollWidth = _ref2.scrollWidth;
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'scroll-hide-all', style: { position: "absolute", top: 0, left: 0, width: rowHeaderWidth, height: columnHeaderHeight, overflow: "hidden" } },
	                        renderCorner()
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'scroll-hide-all', style: { position: "absolute", top: 0, left: rowHeaderWidth, height: columnHeaderHeight, overflow: "hidden" } },
	                        _react2.default.createElement(_reactVirtualized.Grid, {
	                            width: width - rowHeaderWidth,
	                            height: columnHeaderHeight,
	                            cellRenderer: function cellRenderer(_ref3) {
	                                var key = _ref3.key,
	                                    style = _ref3.style,
	                                    columnIndex = _ref3.columnIndex,
	                                    rowIndex = _ref3.rowIndex;
	                                return _react2.default.createElement(
	                                    'div',
	                                    { key: key, style: style },
	                                    columnIndex >= columnCount ? null : renderColumnHeader({ columnIndex: columnIndex })
	                                );
	                            },
	                            columnCount: columnCount + 1,
	                            columnWidth: function columnWidth(_ref4) {
	                                var index = _ref4.index;
	                                return index >= columnCount ? paddingRight : _columnWidth;
	                            },
	                            rowCount: 1,
	                            rowHeight: columnHeaderHeight,
	                            onScroll: function onScroll(_ref5) {
	                                var scrollLeft = _ref5.scrollLeft;
	                                return _onScroll({ scrollLeft: scrollLeft });
	                            },
	                            scrollLeft: scrollLeft
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'scroll-hide-all', style: { position: "absolute", top: columnHeaderHeight, left: 0, width: rowHeaderWidth, overflow: "hidden" } },
	                        _react2.default.createElement(_reactVirtualized.Grid, {
	                            width: rowHeaderWidth,
	                            height: height - columnHeaderHeight,
	                            cellRenderer: function cellRenderer(_ref6) {
	                                var key = _ref6.key,
	                                    style = _ref6.style,
	                                    columnIndex = _ref6.columnIndex,
	                                    rowIndex = _ref6.rowIndex;
	                                return _react2.default.createElement(
	                                    'div',
	                                    { key: key, style: style },
	                                    rowIndex >= rowCount ? null : renderRowHeader({ rowIndex: rowIndex })
	                                );
	                            },
	                            columnCount: 1,
	                            columnWidth: rowHeaderWidth,
	                            rowCount: rowCount + 1,
	                            rowHeight: function rowHeight(_ref7) {
	                                var index = _ref7.index;
	                                return index >= rowCount ? paddingBottom : _rowHeight;
	                            },
	                            onScroll: function onScroll(_ref8) {
	                                var scrollTop = _ref8.scrollTop;
	                                return _onScroll({ scrollTop: scrollTop });
	                            },
	                            scrollTop: scrollTop
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: "absolute", top: columnHeaderHeight, left: rowHeaderWidth, overflow: "hidden" } },
	                        _react2.default.createElement(_reactVirtualized.Grid, {
	                            width: width - rowHeaderWidth,
	                            height: height - columnHeaderHeight,
	                            cellRenderer: function cellRenderer(_ref9) {
	                                var key = _ref9.key,
	                                    style = _ref9.style,
	                                    columnIndex = _ref9.columnIndex,
	                                    rowIndex = _ref9.rowIndex;
	                                return _react2.default.createElement(
	                                    'div',
	                                    { key: key, style: style },
	                                    rowIndex >= rowCount || columnIndex >= columnCount ? null : renderCell({ columnIndex: columnIndex, rowIndex: rowIndex })
	                                );
	                            },
	                            columnCount: columnCount + 1,
	                            columnWidth: function columnWidth(_ref10) {
	                                var index = _ref10.index;
	                                return index >= columnCount ? paddingRight : _columnWidth;
	                            },
	                            rowCount: rowCount + 1,
	                            rowHeight: function rowHeight(_ref11) {
	                                var index = _ref11.index;
	                                return index >= rowCount ? paddingBottom : _rowHeight;
	                            },
	                            onScroll: function onScroll(_ref12) {
	                                var scrollTop = _ref12.scrollTop,
	                                    scrollLeft = _ref12.scrollLeft;
	                                return _onScroll({ scrollTop: scrollTop, scrollLeft: scrollLeft });
	                            },
	                            scrollTop: scrollTop,
	                            scrollLeft: scrollLeft
	                        })
	                    )
	                );
	            }
	        )
	    );
	}; /* eslint-disable react/display-name */
	
	FixedHeaderGrid.displayName = 'FixedHeaderGrid';
	exports.default = FixedHeaderGrid;

/***/ }),
/* 1675 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fixedHeaderGrid":"_3DzAH"};

/***/ }),
/* 1676 */,
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formatting = __webpack_require__(872);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupName = function GroupName(_ref) {
	    var group = _ref.group;
	    return _react2.default.createElement(
	        "span",
	        { className: "text-brand" },
	        group.name
	    );
	};
	
	GroupName.displayName = "GroupName";
	var DatabaseName = function DatabaseName(_ref2) {
	    var database = _ref2.database;
	    return _react2.default.createElement(
	        "span",
	        { className: "text-brand" },
	        database.name
	    );
	};
	
	DatabaseName.displayName = "DatabaseName";
	var TableAccessChange = function TableAccessChange(_ref3) {
	    var tables = _ref3.tables,
	        verb = _ref3.verb,
	        color = _ref3.color;
	
	    var tableNames = Object.values(tables).map(function (t) {
	        return t.name;
	    });
	    return _react2.default.createElement(
	        "span",
	        null,
	        verb,
	        _react2.default.createElement(
	            _Tooltip2.default,
	            { tooltip: _react2.default.createElement(
	                    "div",
	                    { className: "p1" },
	                    tableNames.map(function (name) {
	                        return _react2.default.createElement(
	                            "div",
	                            null,
	                            name
	                        );
	                    })
	                ) },
	            _react2.default.createElement(
	                "span",
	                null,
	                _react2.default.createElement(
	                    "span",
	                    { className: color },
	                    " " + tableNames.length + " " + (0, _formatting.inflect)("table", tableNames.length)
	                )
	            )
	        )
	    );
	};
	
	TableAccessChange.displayName = "TableAccessChange";
	var PermissionsConfirm = function PermissionsConfirm(_ref4) {
	    var diff = _ref4.diff;
	    return _react2.default.createElement(
	        "div",
	        null,
	        Object.values(diff.groups).map(function (group) {
	            return Object.values(group.databases).map(function (database) {
	                return _react2.default.createElement(
	                    "div",
	                    null,
	                    (database.grantedTables || database.revokedTables) && _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(GroupName, { group: group }),
	                        " will be ",
	                        database.grantedTables && _react2.default.createElement(TableAccessChange, { verb: "given access to", color: "text-success", tables: database.grantedTables }),
	                        database.grantedTables && database.revokedTables && " and ",
	                        database.revokedTables && _react2.default.createElement(TableAccessChange, { verb: "denied access to", color: "text-warning", tables: database.revokedTables }),
	                        " in ",
	                        _react2.default.createElement(DatabaseName, { database: database }),
	                        "."
	                    ),
	                    database.native && _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(GroupName, { group: group }),
	                        database.native === "none" ? " will no longer able to " : " will now be able to ",
	                        database.native === "read" ? _react2.default.createElement(
	                            "span",
	                            { className: "text-gold" },
	                            "read"
	                        ) : database.native === "write" ? _react2.default.createElement(
	                            "span",
	                            { className: "text-success" },
	                            "write"
	                        ) : _react2.default.createElement(
	                            "span",
	                            null,
	                            "read or write"
	                        ),
	                        " native queries for ",
	                        _react2.default.createElement(DatabaseName, { database: database }),
	                        "."
	                    )
	                );
	            });
	        })
	    );
	};
	
	PermissionsConfirm.displayName = "PermissionsConfirm";
	exports.default = PermissionsConfirm;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _Breadcrumbs = __webpack_require__(1679);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Ellipsified = __webpack_require__(1277);
	
	var _Ellipsified2 = _interopRequireDefault(_Ellipsified);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Breadcrumbs = (_temp = _class = function (_Component) {
	    _inherits(Breadcrumbs, _Component);
	
	    function Breadcrumbs() {
	        _classCallCheck(this, Breadcrumbs);
	
	        return _possibleConstructorReturn(this, (Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).apply(this, arguments));
	    }
	
	    _createClass(Breadcrumbs, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                crumbs = _props.crumbs,
	                inSidebar = _props.inSidebar,
	                placeholder = _props.placeholder;
	
	
	            var breadcrumbClass = inSidebar ? _Breadcrumbs2.default.sidebarBreadcrumb : _Breadcrumbs2.default.breadcrumb;
	            var breadcrumbsClass = inSidebar ? _Breadcrumbs2.default.sidebarBreadcrumbs : _Breadcrumbs2.default.breadcrumbs;
	
	            return _react2.default.createElement(
	                "section",
	                { className: (0, _classnames2.default)(className, breadcrumbsClass) },
	                crumbs.length <= 1 && placeholder ? _react2.default.createElement(
	                    "span",
	                    { className: (0, _classnames2.default)(breadcrumbClass, _Breadcrumbs2.default.breadcrumbPage) },
	                    placeholder
	                ) : crumbs.map(function (breadcrumb) {
	                    return Array.isArray(breadcrumb) ? breadcrumb : [breadcrumb];
	                }).map(function (breadcrumb, index) {
	                    return _react2.default.createElement(
	                        _Ellipsified2.default,
	                        {
	                            key: index,
	                            tooltip: breadcrumb[0],
	                            tooltipMaxWidth: "100%",
	                            className: (0, _classnames2.default)(breadcrumbClass, breadcrumb.length > 1 ? _Breadcrumbs2.default.breadcrumbPath : _Breadcrumbs2.default.breadcrumbPage)
	                        },
	                        breadcrumb.length > 1 ? _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: breadcrumb[1] },
	                            breadcrumb[0]
	                        ) : _react2.default.createElement(
	                            "span",
	                            null,
	                            breadcrumb[0]
	                        )
	                    );
	                }).map(function (breadcrumb, index, breadcrumbs) {
	                    return index < breadcrumbs.length - 1 ? [breadcrumb, _react2.default.createElement(_Icon2.default, {
	                        key: index + "-separator",
	                        name: "chevronright",
	                        className: _Breadcrumbs2.default.breadcrumbDivider,
	                        width: 12,
	                        height: 12
	                    })] : breadcrumb;
	                })
	            );
	        }
	    }]);
	
	    return Breadcrumbs;
	}(_react.Component), _class.propTypes = {
	    className: _propTypes2.default.string,
	    crumbs: _propTypes2.default.array,
	    inSidebar: _propTypes2.default.bool,
	    placeholder: _propTypes2.default.string
	}, _class.defaultProps = {
	    crumbs: [],
	    inSidebar: false,
	    placeholder: null
	}, _temp);
	Breadcrumbs.displayName = "Breadcrumbs";
	exports.default = Breadcrumbs;

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"breadcrumbs":"_3_Ba_","breadcrumb":"_2TF9W","breadcrumbDivider":"_2gIyS","breadcrumbPath":"_22hhf","breadcrumbPage":"_3fU6E","sidebarBreadcrumbs":"_3d7eA _38618 _3_Ba_","sidebarBreadcrumb":"eVgJF _2TF9W"};

/***/ }),
/* 1680 */,
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _permissions = __webpack_require__(1682);
	
	var _selectors = __webpack_require__(1684);
	
	var _ConfirmContent = __webpack_require__(1264);
	
	var _ConfirmContent2 = _interopRequireDefault(_ConfirmContent);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        isDirty: (0, _selectors.getIsDirty)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    initialize: _permissions.initialize,
	    push: _reactRouterRedux.push
	};
	
	var PermissionsApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactRouter.withRouter)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(PermissionsApp, _Component);
	
	    function PermissionsApp(props, context) {
	        _classCallCheck(this, PermissionsApp);
	
	        var _this = _possibleConstructorReturn(this, (PermissionsApp.__proto__ || Object.getPrototypeOf(PermissionsApp)).call(this, props, context));
	
	        _this.routerWillLeave = function (nextLocation) {
	            if (_this.props.isDirty && !_this.state.confirmed) {
	                _this.setState({ nextLocation: nextLocation, confirmed: false });
	                return false;
	            }
	        };
	
	        _this.state = {
	            nextLocation: false,
	            confirmed: false
	        };
	        return _this;
	    }
	
	    _createClass(PermissionsApp, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.initialize(this.props.load, this.props.save);
	            this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex-full flex" },
	                this.props.children,
	                _react2.default.createElement(
	                    _Modal2.default,
	                    { isOpen: this.state.nextLocation },
	                    _react2.default.createElement(_ConfirmContent2.default, {
	                        title: "You have unsaved changes",
	                        message: "Do you want to leave this page and discard your changes?",
	                        onClose: function onClose() {
	                            _this2.setState({ nextLocation: null });
	                        },
	                        onAction: function onAction() {
	                            var nextLocation = _this2.state.nextLocation;
	
	                            _this2.setState({ nextLocation: null, confirmed: true }, function () {
	                                _this2.props.push(nextLocation.pathname, nextLocation.state);
	                            });
	                        }
	                    })
	                )
	            );
	        }
	    }]);
	
	    return PermissionsApp;
	}(_react.Component), _class2.propTypes = {
	    load: _propTypes2.default.func.isRequired,
	    save: _propTypes2.default.func.isRequired
	}, _temp)) || _class) || _class);
	PermissionsApp.displayName = "PermissionsApp";
	exports.default = PermissionsApp;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.savePermissions = exports.updatePermission = exports.loadPermissions = exports.loadGroups = exports.loadCollections = exports.initialize = exports.reset = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _handleActions3, _handleActions4, _handleActions5, _handleActions8;
	
	var _redux = __webpack_require__(657);
	
	var _groups = __webpack_require__(1683);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var RESET = "metabase/admin/permissions/RESET";
	var reset = exports.reset = (0, _redux.createAction)(RESET);
	
	var INITIALIZE = "metabase/admin/permissions/INITIALIZE";
	var initialize = exports.initialize = (0, _redux.createThunkAction)(INITIALIZE, function (load, save) {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            dispatch(reset({ load: load, save: save }));
	                            _context.next = 3;
	                            return Promise.all([dispatch(loadPermissions()), dispatch(loadGroups())]);
	
	                        case 3:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	// TODO: move these to their respective ducks
	var LOAD_COLLECTIONS = "metabase/admin/permissions/LOAD_COLLECTIONS";
	var loadCollections = exports.loadCollections = (0, _redux.createAction)(LOAD_COLLECTIONS, function () {
	    return _services.CollectionsApi.list();
	});
	
	var LOAD_GROUPS = "metabase/admin/permissions/LOAD_GROUPS";
	var loadGroups = exports.loadGroups = (0, _redux.createAction)(LOAD_GROUPS, function () {
	    return _services.PermissionsApi.groups();
	});
	
	var LOAD_PERMISSIONS = "metabase/admin/permissions/LOAD_PERMISSIONS";
	var loadPermissions = exports.loadPermissions = (0, _redux.createThunkAction)(LOAD_PERMISSIONS, function () {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var load;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            load = getState().admin.permissions.load;
	                            return _context2.abrupt("return", load());
	
	                        case 2:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	var UPDATE_PERMISSION = "metabase/admin/permissions/UPDATE_PERMISSION";
	var updatePermission = exports.updatePermission = (0, _redux.createThunkAction)(UPDATE_PERMISSION, function (_ref3) {
	    var groupId = _ref3.groupId,
	        entityId = _ref3.entityId,
	        value = _ref3.value,
	        updater = _ref3.updater,
	        postAction = _ref3.postAction;
	    return function () {
	        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            var action;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            if (postAction) {
	                                action = postAction(groupId, entityId, value);
	
	                                if (action) {
	                                    dispatch(action);
	                                }
	                            }
	                            return _context3.abrupt("return", updater(groupId, entityId, value));
	
	                        case 2:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	});
	
	var SAVE_PERMISSIONS = "metabase/admin/permissions/SAVE_PERMISSIONS";
	var savePermissions = exports.savePermissions = (0, _redux.createThunkAction)(SAVE_PERMISSIONS, function () {
	    return function () {
	        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
	            var _getState$admin$permi, permissions, revision, save, result;
	
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            _analytics2.default.trackEvent("Permissions", "save");
	                            _getState$admin$permi = getState().admin.permissions, permissions = _getState$admin$permi.permissions, revision = _getState$admin$permi.revision, save = _getState$admin$permi.save;
	                            _context4.next = 4;
	                            return save({
	                                revision: revision,
	                                groups: permissions
	                            });
	
	                        case 4:
	                            result = _context4.sent;
	                            return _context4.abrupt("return", result);
	
	                        case 6:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, undefined);
	        }));
	
	        return function (_x7, _x8) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	});
	
	var save = (0, _redux.handleActions)(_defineProperty({}, RESET, { next: function next(state, _ref6) {
	        var payload = _ref6.payload;
	        return payload.save;
	    } }), null);
	var load = (0, _redux.handleActions)(_defineProperty({}, RESET, { next: function next(state, _ref7) {
	        var payload = _ref7.payload;
	        return payload.load;
	    } }), null);
	
	var permissions = (0, _redux.handleActions)((_handleActions3 = {}, _defineProperty(_handleActions3, RESET, { next: function next() {
	        return null;
	    } }), _defineProperty(_handleActions3, LOAD_PERMISSIONS, { next: function next(state, _ref8) {
	        var payload = _ref8.payload;
	        return payload.groups;
	    } }), _defineProperty(_handleActions3, SAVE_PERMISSIONS, { next: function next(state, _ref9) {
	        var payload = _ref9.payload;
	        return payload.groups;
	    } }), _defineProperty(_handleActions3, UPDATE_PERMISSION, { next: function next(state, _ref10) {
	        var payload = _ref10.payload;
	        return payload;
	    } }), _handleActions3), null);
	
	var originalPermissions = (0, _redux.handleActions)((_handleActions4 = {}, _defineProperty(_handleActions4, RESET, { next: function next() {
	        return null;
	    } }), _defineProperty(_handleActions4, LOAD_PERMISSIONS, { next: function next(state, _ref11) {
	        var payload = _ref11.payload;
	        return payload.groups;
	    } }), _defineProperty(_handleActions4, SAVE_PERMISSIONS, { next: function next(state, _ref12) {
	        var payload = _ref12.payload;
	        return payload.groups;
	    } }), _handleActions4), null);
	
	var revision = (0, _redux.handleActions)((_handleActions5 = {}, _defineProperty(_handleActions5, RESET, { next: function next() {
	        return null;
	    } }), _defineProperty(_handleActions5, LOAD_PERMISSIONS, { next: function next(state, _ref13) {
	        var payload = _ref13.payload;
	        return payload.revision;
	    } }), _defineProperty(_handleActions5, SAVE_PERMISSIONS, { next: function next(state, _ref14) {
	        var payload = _ref14.payload;
	        return payload.revision;
	    } }), _handleActions5), null);
	
	var groups = (0, _redux.handleActions)(_defineProperty({}, LOAD_GROUPS, { next: function next(state, _ref15) {
	        var payload = _ref15.payload;
	        return payload && payload.map(function (group) {
	            return _extends({}, group, {
	                editable: (0, _groups.canEditPermissions)(group)
	            });
	        });
	    }
	}), null);
	
	var collections = (0, _redux.handleActions)(_defineProperty({}, LOAD_COLLECTIONS, { next: function next(state, _ref16) {
	        var payload = _ref16.payload;
	        return payload;
	    } }), null);
	
	var saveError = (0, _redux.handleActions)((_handleActions8 = {}, _defineProperty(_handleActions8, RESET, { next: function next() {
	        return null;
	    } }), _defineProperty(_handleActions8, SAVE_PERMISSIONS, {
	    next: function next(state) {
	        return null;
	    },
	    throw: function _throw(state, _ref17) {
	        var payload = _ref17.payload;
	        return (payload && typeof payload.data === "string" ? payload.data : payload.data.message) || "Sorry, an error occurred.";
	    }
	}), _defineProperty(_handleActions8, LOAD_PERMISSIONS, {
	    next: function next(state) {
	        return null;
	    }
	}), _handleActions8), null);
	
	exports.default = (0, _redux.combineReducers)({
	    save: save,
	    load: load,
	
	    permissions: permissions,
	    originalPermissions: originalPermissions,
	    saveError: saveError,
	    revision: revision,
	    groups: groups,
	
	    collections: collections
	});

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isDefaultGroup = isDefaultGroup;
	exports.isAdminGroup = isAdminGroup;
	exports.isMetaBotGroup = isMetaBotGroup;
	exports.canEditPermissions = canEditPermissions;
	exports.canEditMembership = canEditMembership;
	exports.getGroupColor = getGroupColor;
	function isDefaultGroup(group) {
	    return group.name === "All Users";
	}
	
	function isAdminGroup(group) {
	    return group.name === "Administrators";
	}
	
	function isMetaBotGroup(group) {
	    return group.name === "MetaBot";
	}
	
	function canEditPermissions(group) {
	    return !isAdminGroup(group);
	}
	
	function canEditMembership(group) {
	    return !isDefaultGroup(group);
	}
	
	function getGroupColor(group) {
	    return isAdminGroup(group) ? "text-purple" : isDefaultGroup(group) ? "text-grey-4" : "text-brand";
	}

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getDiff = exports.getCollectionsPermissionsGrid = exports.getDatabasesPermissionsGrid = exports.getSchemasPermissionsGrid = exports.getTablesPermissionsGrid = exports.getSaveError = exports.getIsDirty = exports.getGroups = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__(1072);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _groups = __webpack_require__(1683);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	var _permissions = __webpack_require__(1685);
	
	var _metadata = __webpack_require__(1073);
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*  weak */
	
	var getPermissions = function getPermissions(state) {
	    return state.admin.permissions.permissions;
	};
	var getOriginalPermissions = function getOriginalPermissions(state) {
	    return state.admin.permissions.originalPermissions;
	};
	
	var getDatabaseId = function getDatabaseId(state, props) {
	    return props.params.databaseId ? parseInt(props.params.databaseId) : null;
	};
	var getSchemaName = function getSchemaName(state, props) {
	    return props.params.schemaName;
	};
	
	// reorder groups to be in this order
	var SPECIAL_GROUP_FILTERS = [_groups.isAdminGroup, _groups.isDefaultGroup, _groups.isMetaBotGroup].reverse();
	
	function getTooltipForGroup(group) {
	    if ((0, _groups.isAdminGroup)(group)) {
	        return "Administrators always have the highest level of access to everything in Metabase.";
	    } else if ((0, _groups.isDefaultGroup)(group)) {
	        return "Every Metabase user belongs to the All Users group. If you want to limit or restrict a group's access to something, make sure the All Users group has an equal or lower level of access.";
	    } else if ((0, _groups.isMetaBotGroup)(group)) {
	        return "MetaBot is Metabase's Slack bot. You can choose what it has access to here.";
	    }
	    return null;
	}
	
	var getGroups = exports.getGroups = (0, _reselect.createSelector)(function (state) {
	    return state.admin.permissions.groups;
	}, function (groups) {
	    var orderedGroups = groups ? [].concat(_toConsumableArray(groups)) : [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = SPECIAL_GROUP_FILTERS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var groupFilter = _step.value;
	
	            var index = _underscore2.default.findIndex(orderedGroups, groupFilter);
	            if (index >= 0) {
	                orderedGroups.unshift.apply(orderedGroups, _toConsumableArray(orderedGroups.splice(index, 1)));
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return orderedGroups.map(function (group) {
	        return _extends({}, group, {
	            tooltip: getTooltipForGroup(group)
	        });
	    });
	});
	
	var getIsDirty = exports.getIsDirty = (0, _reselect.createSelector)(getPermissions, getOriginalPermissions, function (permissions, originalPermissions) {
	    return JSON.stringify(permissions) !== JSON.stringify(originalPermissions);
	});
	
	var getSaveError = exports.getSaveError = function getSaveError(state) {
	    return state.admin.permissions.saveError;
	};
	
	// these are all the permission levels ordered by level of access
	var PERM_LEVELS = ["write", "read", "all", "controlled", "none"];
	function hasGreaterPermissions(a, b) {
	    return PERM_LEVELS.indexOf(a) - PERM_LEVELS.indexOf(b) < 0;
	}
	
	function getPermissionWarning(getter, entityType, defaultGroup, permissions, groupId, entityId, value) {
	    if (!defaultGroup || groupId === defaultGroup.id) {
	        return null;
	    }
	    var perm = value || getter(permissions, groupId, entityId);
	    var defaultPerm = getter(permissions, defaultGroup.id, entityId);
	    if (perm === "controlled" && defaultPerm === "controlled") {
	        return "The \"" + defaultGroup.name + "\" group may have access to a different set of " + entityType + " than this group, which may give this group additional access to some " + entityType + ".";
	    }
	    if (hasGreaterPermissions(defaultPerm, perm)) {
	        return "The \"" + defaultGroup.name + "\" group has a higher level of access than this, which will override this setting. You should limit or revoke the \"" + defaultGroup.name + "\" group's access to this item.";
	    }
	    return null;
	}
	
	function getPermissionWarningModal(entityType, getter, defaultGroup, permissions, groupId, entityId, value) {
	    var permissionWarning = getPermissionWarning(entityType, getter, defaultGroup, permissions, groupId, entityId, value);
	    if (permissionWarning) {
	        return {
	            title: (value === "controlled" ? "Limit" : "Revoke") + " access even though \"" + defaultGroup.name + "\" has greater access?",
	            message: permissionWarning,
	            confirmButtonText: (value === "controlled" ? "Limit" : "Revoke") + " access",
	            cancelButtonText: "Cancel"
	        };
	    }
	}
	
	function getControlledDatabaseWarningModal(permissions, groupId, entityId) {
	    if ((0, _permissions.getSchemasPermission)(permissions, groupId, entityId) !== "controlled") {
	        return {
	            title: "Change access to this database to limited?",
	            confirmButtonText: "Change",
	            cancelButtonText: "Cancel"
	        };
	    }
	}
	
	function getRawQueryWarningModal(permissions, groupId, entityId, value) {
	    if (value === "write" && (0, _permissions.getNativePermission)(permissions, groupId, entityId) !== "write" && (0, _permissions.getSchemasPermission)(permissions, groupId, entityId) !== "all") {
	        return {
	            title: "Allow Raw Query Writing?",
	            message: "This will also change this group's data access to Unrestricted for this database.",
	            confirmButtonText: "Allow",
	            cancelButtonText: "Cancel"
	        };
	    }
	}
	
	// If the user is revoking an access to every single table of a database for a specific user group,
	// warn the user that the access to raw queries will be revoked as well.
	// This warning will only be shown if the user is editing the permissions of individual tables.
	function getRevokingAccessToAllTablesWarningModal(database, permissions, groupId, entityId, value) {
	    if (value === "none" && (0, _permissions.getSchemasPermission)(permissions, groupId, entityId) === "controlled" && (0, _permissions.getNativePermission)(permissions, groupId, entityId) !== "none") {
	        // allTableEntityIds contains tables from all schemas
	        var allTableEntityIds = database.tables.map(function (table) {
	            return {
	                databaseId: table.db_id,
	                schemaName: table.schema || "",
	                tableId: table.id
	            };
	        });
	
	        // Show the warning only if user tries to revoke access to the very last table of all schemas
	        var afterChangesNoAccessToAnyTable = _underscore2.default.every(allTableEntityIds, function (id) {
	            return (0, _permissions.getFieldsPermission)(permissions, groupId, id) === "none" || _underscore2.default.isEqual(id, entityId);
	        });
	        if (afterChangesNoAccessToAnyTable) {
	            return {
	                title: "Revoke access to all tables?",
	                message: "This will also revoke this group's access to raw queries for this database.",
	                confirmButtonText: "Revoke access",
	                cancelButtonText: "Cancel"
	            };
	        }
	    }
	}
	
	var OPTION_GREEN = {
	    icon: "check",
	    iconColor: "#9CC177",
	    bgColor: "#F6F9F2"
	};
	var OPTION_YELLOW = {
	    icon: "eye",
	    iconColor: "#F9D45C",
	    bgColor: "#FEFAEE"
	};
	var OPTION_RED = {
	    icon: "close",
	    iconColor: "#EEA5A5",
	    bgColor: "#FDF3F3"
	};
	
	var OPTION_ALL = _extends({}, OPTION_GREEN, {
	    value: "all",
	    title: "Grant unrestricted access",
	    tooltip: "Unrestricted access"
	});
	
	var OPTION_CONTROLLED = _extends({}, OPTION_YELLOW, {
	    value: "controlled",
	    title: "Limit access",
	    tooltip: "Limited access",
	    icon: "permissionsLimited"
	});
	
	var OPTION_NONE = _extends({}, OPTION_RED, {
	    value: "none",
	    title: "Revoke access",
	    tooltip: "No access"
	});
	
	var OPTION_NATIVE_WRITE = _extends({}, OPTION_GREEN, {
	    value: "write",
	    title: "Write raw queries",
	    tooltip: "Can write raw queries",
	    icon: "sql"
	});
	
	var OPTION_NATIVE_READ = _extends({}, OPTION_YELLOW, {
	    value: "read",
	    title: "View raw queries",
	    tooltip: "Can view raw queries"
	});
	
	var OPTION_COLLECTION_WRITE = _extends({}, OPTION_GREEN, {
	    value: "write",
	    title: "Curate collection",
	    tooltip: "Can add and remove questions from this collection"
	});
	
	var OPTION_COLLECTION_READ = _extends({}, OPTION_YELLOW, {
	    value: "read",
	    title: "View collection",
	    tooltip: "Can view questions in this collection"
	});
	
	var getTablesPermissionsGrid = exports.getTablesPermissionsGrid = (0, _reselect.createSelector)(_metadata.getMetadata, getGroups, getPermissions, getDatabaseId, getSchemaName, function (metadata, groups, permissions, databaseId, schemaName) {
	    var database = metadata.databases[databaseId];
	
	    if (!groups || !permissions || !database) {
	        return null;
	    }
	
	    var tables = database.tablesInSchema(schemaName || null);
	    var defaultGroup = _underscore2.default.find(groups, _groups.isDefaultGroup);
	
	    return {
	        type: "table",
	        icon: "table",
	        crumbs: database.schemaNames().length > 1 ? [["Databases", "/admin/permissions/databases"], [database.name, "/admin/permissions/databases/" + database.id + "/schemas"], [schemaName]] : [["Databases", "/admin/permissions/databases"], [database.name]],
	        groups: groups,
	        permissions: {
	            "fields": {
	                header: "Data Access",
	                options: function options(groupId, entityId) {
	                    return [OPTION_ALL, OPTION_NONE];
	                },
	                getter: function getter(groupId, entityId) {
	                    return (0, _permissions.getFieldsPermission)(permissions, groupId, entityId);
	                },
	                updater: function updater(groupId, entityId, value) {
	                    _analytics2.default.trackEvent("Permissions", "fields", value);
	                    var updatedPermissions = (0, _permissions.updateFieldsPermission)(permissions, groupId, entityId, value, metadata);
	                    return (0, _permissions.inferAndUpdateEntityPermissions)(updatedPermissions, groupId, entityId, metadata);
	                },
	                confirm: function confirm(groupId, entityId, value) {
	                    return [getPermissionWarningModal(_permissions.getFieldsPermission, "fields", defaultGroup, permissions, groupId, entityId, value), getControlledDatabaseWarningModal(permissions, groupId, entityId), getRevokingAccessToAllTablesWarningModal(database, permissions, groupId, entityId, value)];
	                },
	                warning: function warning(groupId, entityId) {
	                    return getPermissionWarning(_permissions.getFieldsPermission, "fields", defaultGroup, permissions, groupId, entityId);
	                }
	            }
	        },
	        entities: tables.map(function (table) {
	            return {
	                id: {
	                    databaseId: databaseId,
	                    schemaName: schemaName,
	                    tableId: table.id
	                },
	                name: table.display_name,
	                subtitle: table.name
	            };
	        })
	    };
	});
	
	var getSchemasPermissionsGrid = exports.getSchemasPermissionsGrid = (0, _reselect.createSelector)(_metadata.getMetadata, getGroups, getPermissions, getDatabaseId, function (metadata, groups, permissions, databaseId) {
	    var database = metadata.databases[databaseId];
	
	    if (!groups || !permissions || !database) {
	        return null;
	    }
	
	    var schemaNames = database.schemaNames();
	    var defaultGroup = _underscore2.default.find(groups, _groups.isDefaultGroup);
	
	    return {
	        type: "schema",
	        icon: "folder",
	        crumbs: [["Databases", "/admin/permissions/databases"], [database.name]],
	        groups: groups,
	        permissions: {
	            "tables": {
	                header: "Data Access",
	                options: function options(groupId, entityId) {
	                    return [OPTION_ALL, OPTION_CONTROLLED, OPTION_NONE];
	                },
	                getter: function getter(groupId, entityId) {
	                    return (0, _permissions.getTablesPermission)(permissions, groupId, entityId);
	                },
	                updater: function updater(groupId, entityId, value) {
	                    _analytics2.default.trackEvent("Permissions", "tables", value);
	                    var updatedPermissions = (0, _permissions.updateTablesPermission)(permissions, groupId, entityId, value, metadata);
	                    return (0, _permissions.inferAndUpdateEntityPermissions)(updatedPermissions, groupId, entityId, metadata);
	                },
	                postAction: function postAction(groupId, _ref, value) {
	                    var databaseId = _ref.databaseId,
	                        schemaName = _ref.schemaName;
	
	                    if (value === "controlled") {
	                        return (0, _reactRouterRedux.push)("/admin/permissions/databases/" + databaseId + "/schemas/" + encodeURIComponent(schemaName) + "/tables");
	                    }
	                },
	                confirm: function confirm(groupId, entityId, value) {
	                    return [getPermissionWarningModal(_permissions.getTablesPermission, "tables", defaultGroup, permissions, groupId, entityId, value), getControlledDatabaseWarningModal(permissions, groupId, entityId)];
	                },
	                warning: function warning(groupId, entityId) {
	                    return getPermissionWarning(_permissions.getTablesPermission, "tables", defaultGroup, permissions, groupId, entityId);
	                }
	            }
	        },
	        entities: schemaNames.map(function (schemaName) {
	            return {
	                id: {
	                    databaseId: databaseId,
	                    schemaName: schemaName
	                },
	                name: schemaName,
	                link: { name: "View tables", url: "/admin/permissions/databases/" + databaseId + "/schemas/" + encodeURIComponent(schemaName) + "/tables" }
	            };
	        })
	    };
	});
	
	var getDatabasesPermissionsGrid = exports.getDatabasesPermissionsGrid = (0, _reselect.createSelector)(_metadata.getMetadata, getGroups, getPermissions, function (metadata, groups, permissions) {
	    if (!groups || !permissions || !metadata) {
	        return null;
	    }
	
	    var databases = Object.values(metadata.databases);
	    var defaultGroup = _underscore2.default.find(groups, _groups.isDefaultGroup);
	
	    return {
	        type: "database",
	        icon: "database",
	        groups: groups,
	        permissions: {
	            "schemas": {
	                header: "Data Access",
	                options: function options(groupId, entityId) {
	                    return [OPTION_ALL, OPTION_CONTROLLED, OPTION_NONE];
	                },
	                getter: function getter(groupId, entityId) {
	                    return (0, _permissions.getSchemasPermission)(permissions, groupId, entityId);
	                },
	                updater: function updater(groupId, entityId, value) {
	                    _analytics2.default.trackEvent("Permissions", "schemas", value);
	                    return (0, _permissions.updateSchemasPermission)(permissions, groupId, entityId, value, metadata);
	                },
	                postAction: function postAction(groupId, _ref2, value) {
	                    var databaseId = _ref2.databaseId;
	
	                    if (value === "controlled") {
	                        var database = metadata.databases[databaseId];
	                        var schemas = database ? database.schemaNames() : [];
	                        if (schemas.length === 0 || schemas.length === 1 && schemas[0] === "") {
	                            return (0, _reactRouterRedux.push)("/admin/permissions/databases/" + databaseId + "/tables");
	                        } else if (schemas.length === 1) {
	                            return (0, _reactRouterRedux.push)("/admin/permissions/databases/" + databaseId + "/schemas/" + schemas[0] + "/tables");
	                        } else {
	                            return (0, _reactRouterRedux.push)("/admin/permissions/databases/" + databaseId + "/schemas");
	                        }
	                    }
	                },
	                confirm: function confirm(groupId, entityId, value) {
	                    return [getPermissionWarningModal(_permissions.getSchemasPermission, "schemas", defaultGroup, permissions, groupId, entityId, value)];
	                },
	                warning: function warning(groupId, entityId) {
	                    return getPermissionWarning(_permissions.getSchemasPermission, "schemas", defaultGroup, permissions, groupId, entityId);
	                }
	            },
	            "native": {
	                header: "SQL Queries",
	                options: function options(groupId, entityId) {
	                    if ((0, _permissions.getSchemasPermission)(permissions, groupId, entityId) === "none") {
	                        return [OPTION_NONE];
	                    } else {
	                        return [OPTION_NATIVE_WRITE, OPTION_NATIVE_READ, OPTION_NONE];
	                    }
	                },
	                getter: function getter(groupId, entityId) {
	                    return (0, _permissions.getNativePermission)(permissions, groupId, entityId);
	                },
	                updater: function updater(groupId, entityId, value) {
	                    _analytics2.default.trackEvent("Permissions", "native", value);
	                    return (0, _permissions.updateNativePermission)(permissions, groupId, entityId, value, metadata);
	                },
	                confirm: function confirm(groupId, entityId, value) {
	                    return [getPermissionWarningModal(_permissions.getNativePermission, null, defaultGroup, permissions, groupId, entityId, value), getRawQueryWarningModal(permissions, groupId, entityId, value)];
	                },
	                warning: function warning(groupId, entityId) {
	                    return getPermissionWarning(_permissions.getNativePermission, null, defaultGroup, permissions, groupId, entityId);
	                }
	            }
	        },
	        entities: databases.map(function (database) {
	            var schemas = database.schemaNames();
	            return {
	                id: {
	                    databaseId: database.id
	                },
	                name: database.name,
	                link: schemas.length === 0 || schemas.length === 1 && schemas[0] === "" ? { name: "View tables", url: "/admin/permissions/databases/" + database.id + "/tables" } : schemas.length === 1 ? { name: "View tables", url: "/admin/permissions/databases/" + database.id + "/schemas/" + schemas[0] + "/tables" } : { name: "View schemas", url: "/admin/permissions/databases/" + database.id + "/schemas" }
	            };
	        })
	    };
	});
	
	var getCollections = function getCollections(state) {
	    return state.admin.permissions.collections;
	};
	var getCollectionPermission = function getCollectionPermission(permissions, groupId, _ref3) {
	    var collectionId = _ref3.collectionId;
	    return (0, _icepick.getIn)(permissions, [groupId, collectionId]);
	};
	
	var getCollectionsPermissionsGrid = exports.getCollectionsPermissionsGrid = (0, _reselect.createSelector)(getCollections, getGroups, getPermissions, function (collections, groups, permissions) {
	    if (!groups || !permissions || !collections) {
	        return null;
	    }
	
	    var defaultGroup = _underscore2.default.find(groups, _groups.isDefaultGroup);
	
	    return {
	        type: "collection",
	        icon: "collection",
	        groups: groups,
	        permissions: {
	            "access": {
	                options: function options(groupId, entityId) {
	                    return [OPTION_COLLECTION_WRITE, OPTION_COLLECTION_READ, OPTION_NONE];
	                },
	                getter: function getter(groupId, entityId) {
	                    return getCollectionPermission(permissions, groupId, entityId);
	                },
	                updater: function updater(groupId, _ref4, value) {
	                    var collectionId = _ref4.collectionId;
	
	                    return (0, _icepick.assocIn)(permissions, [groupId, collectionId], value);
	                },
	                confirm: function confirm(groupId, entityId, value) {
	                    return [getPermissionWarningModal(getCollectionPermission, null, defaultGroup, permissions, groupId, entityId, value)];
	                },
	                warning: function warning(groupId, entityId) {
	                    return getPermissionWarning(getCollectionPermission, null, defaultGroup, permissions, groupId, entityId);
	                }
	            }
	        },
	        entities: collections.map(function (collection) {
	            return {
	                id: {
	                    collectionId: collection.id
	                },
	                name: collection.name
	            };
	        })
	    };
	});
	
	var getDiff = exports.getDiff = (0, _reselect.createSelector)(_metadata.getMetadata, getGroups, getPermissions, getOriginalPermissions, function (metadata, groups, permissions, originalPermissions) {
	    return (0, _permissions.diffPermissions)(permissions, originalPermissions, groups, metadata);
	});

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getFieldsPermission = exports.getTablesPermission = exports.getNativePermission = exports.getSchemasPermission = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.getPermission = getPermission;
	exports.updatePermission = updatePermission;
	exports.downgradeNativePermissionsIfNeeded = downgradeNativePermissionsIfNeeded;
	exports.inferAndUpdateEntityPermissions = inferAndUpdateEntityPermissions;
	exports.updateFieldsPermission = updateFieldsPermission;
	exports.updateTablesPermission = updateTablesPermission;
	exports.updateSchemasPermission = updateSchemasPermission;
	exports.updateNativePermission = updateNativePermission;
	exports.diffPermissions = diffPermissions;
	
	var _icepick = __webpack_require__(855);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _Database = __webpack_require__(897);
	
	var _Database2 = _interopRequireDefault(_Database);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPermission(permissions, groupId, path) {
	    var isControlledType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    var value = (0, _icepick.getIn)(permissions, [groupId].concat(path));
	    if (isControlledType) {
	        if (!value) {
	            return "none";
	        } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
	            return "controlled";
	        } else {
	            return value;
	        }
	    } else if (value) {
	        return value;
	    } else {
	        return "none";
	    }
	}
	
	function updatePermission(permissions, groupId, path, value, entityIds) {
	    var fullPath = [groupId].concat(path);
	    var current = (0, _icepick.getIn)(permissions, fullPath);
	    if (current === value || current && (typeof current === "undefined" ? "undefined" : _typeof(current)) === "object" && value === "controlled") {
	        return permissions;
	    }
	    var newValue = void 0;
	    if (value === "controlled") {
	        newValue = {};
	        if (entityIds) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = entityIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var entityId = _step.value;
	
	                    newValue[entityId] = current;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    } else {
	        newValue = value;
	    }
	    for (var i = 0; i < fullPath.length; i++) {
	        if (typeof (0, _icepick.getIn)(permissions, fullPath.slice(0, i)) === "string") {
	            permissions = (0, _icepick.setIn)(permissions, fullPath.slice(0, i), {});
	        }
	    }
	    return (0, _icepick.setIn)(permissions, fullPath, newValue);
	}
	
	var getSchemasPermission = exports.getSchemasPermission = function getSchemasPermission(permissions, groupId, _ref) {
	    var databaseId = _ref.databaseId;
	
	    return getPermission(permissions, groupId, [databaseId, "schemas"], true);
	};
	
	var getNativePermission = exports.getNativePermission = function getNativePermission(permissions, groupId, _ref2) {
	    var databaseId = _ref2.databaseId;
	
	    return getPermission(permissions, groupId, [databaseId, "native"]);
	};
	
	var getTablesPermission = exports.getTablesPermission = function getTablesPermission(permissions, groupId, _ref3) {
	    var databaseId = _ref3.databaseId,
	        schemaName = _ref3.schemaName;
	
	    var schemas = getSchemasPermission(permissions, groupId, { databaseId: databaseId });
	    if (schemas === "controlled") {
	        return getPermission(permissions, groupId, [databaseId, "schemas", schemaName], true);
	    } else {
	        return schemas;
	    }
	};
	
	var getFieldsPermission = exports.getFieldsPermission = function getFieldsPermission(permissions, groupId, _ref4) {
	    var databaseId = _ref4.databaseId,
	        schemaName = _ref4.schemaName,
	        tableId = _ref4.tableId;
	
	    var tables = getTablesPermission(permissions, groupId, { databaseId: databaseId, schemaName: schemaName });
	    if (tables === "controlled") {
	        return getPermission(permissions, groupId, [databaseId, "schemas", schemaName, tableId], true);
	    } else {
	        return tables;
	    }
	};
	
	function downgradeNativePermissionsIfNeeded(permissions, groupId, _ref5, value, metadata) {
	    var databaseId = _ref5.databaseId;
	
	    var currentSchemas = getSchemasPermission(permissions, groupId, { databaseId: databaseId });
	    var currentNative = getNativePermission(permissions, groupId, { databaseId: databaseId });
	
	    if (value === "none") {
	        // if changing schemas to none, downgrade native to none
	        return updateNativePermission(permissions, groupId, { databaseId: databaseId }, "none", metadata);
	    } else if (value === "controlled" && currentSchemas === "all" && currentNative === "write") {
	        // if changing schemas to controlled, downgrade native to read
	        return updateNativePermission(permissions, groupId, { databaseId: databaseId }, "read", metadata);
	    } else {
	        return permissions;
	    }
	}
	
	var metadataTableToTableEntityId = function metadataTableToTableEntityId(table) {
	    return { databaseId: table.db_id, schemaName: table.schema || "", tableId: table.id };
	};
	
	// TODO Atte Keinänen 6/24/17 See if this method could be simplified
	var entityIdToMetadataTableFields = function entityIdToMetadataTableFields(entityId) {
	    return _extends({}, entityId.databaseId ? { db_id: entityId.databaseId } : {}, entityId.schemaName !== undefined ? { schema: entityId.schemaName !== "" ? entityId.schemaName : null } : {}, entityId.tableId ? { id: entityId.tableId } : {});
	};
	
	function inferEntityPermissionValueFromChildTables(permissions, groupId, entityId, metadata) {
	    var databaseId = entityId.databaseId;
	
	    var database = metadata && metadata.databases[databaseId];
	
	    var entityIdsForDescendantTables = _underscore2.default.chain(database.tables).filter(function (t) {
	        return _underscore2.default.isMatch(t, entityIdToMetadataTableFields(entityId));
	    }).map(metadataTableToTableEntityId).value();
	
	    var entityIdsByPermValue = _underscore2.default.chain(entityIdsForDescendantTables).map(function (id) {
	        return getFieldsPermission(permissions, groupId, id);
	    }).groupBy(_underscore2.default.identity).value();
	
	    var keys = Object.keys(entityIdsByPermValue);
	    var allTablesHaveSamePermissions = keys.length === 1;
	
	    if (allTablesHaveSamePermissions) {
	        // either "all" or "none"
	        return keys[0];
	    } else {
	        return "controlled";
	    }
	}
	
	// Checks the child tables of a given entityId and updates the shared table and/or schema permission values according to table permissions
	// This method was added for keeping the UI in sync when modifying child permissions
	function inferAndUpdateEntityPermissions(permissions, groupId, entityId, metadata) {
	    // $FlowFixMe
	    var databaseId = entityId.databaseId,
	        schemaName = entityId.schemaName;
	
	
	    if (schemaName) {
	        // Check all tables for current schema if their shared schema-level permission value should be updated
	        // $FlowFixMe
	        var tablesPermissionValue = inferEntityPermissionValueFromChildTables(permissions, groupId, { databaseId: databaseId, schemaName: schemaName }, metadata);
	        permissions = updateTablesPermission(permissions, groupId, { databaseId: databaseId, schemaName: schemaName }, tablesPermissionValue, metadata);
	    }
	
	    if (databaseId) {
	        // Check all tables for current database if schemas' shared database-level permission value should be updated
	        var schemasPermissionValue = inferEntityPermissionValueFromChildTables(permissions, groupId, { databaseId: databaseId }, metadata);
	        permissions = updateSchemasPermission(permissions, groupId, { databaseId: databaseId }, schemasPermissionValue, metadata);
	        permissions = downgradeNativePermissionsIfNeeded(permissions, groupId, { databaseId: databaseId }, schemasPermissionValue, metadata);
	    }
	
	    return permissions;
	}
	
	function updateFieldsPermission(permissions, groupId, entityId, value, metadata) {
	    var databaseId = entityId.databaseId,
	        schemaName = entityId.schemaName,
	        tableId = entityId.tableId;
	
	
	    permissions = updateTablesPermission(permissions, groupId, { databaseId: databaseId, schemaName: schemaName }, "controlled", metadata);
	    permissions = updatePermission(permissions, groupId, [databaseId, "schemas", schemaName, tableId], value /* TODO: field ids, when enabled "controlled" fields */);
	
	    return permissions;
	}
	
	function updateTablesPermission(permissions, groupId, _ref6, value, metadata) {
	    var databaseId = _ref6.databaseId,
	        schemaName = _ref6.schemaName;
	
	    var database = metadata && metadata.databases[databaseId];
	    var tableIds = database && database.tables.filter(function (t) {
	        return (t.schema || "") === schemaName;
	    }).map(function (t) {
	        return t.id;
	    });
	
	    permissions = updateSchemasPermission(permissions, groupId, { databaseId: databaseId }, "controlled", metadata);
	    permissions = updatePermission(permissions, groupId, [databaseId, "schemas", schemaName], value, tableIds);
	
	    return permissions;
	}
	
	function updateSchemasPermission(permissions, groupId, _ref7, value, metadata) {
	    var databaseId = _ref7.databaseId;
	
	    var database = metadata.databases[databaseId];
	    var schemaNames = database && database.schemaNames();
	    var schemaNamesOrNoSchema = schemaNames && schemaNames.length > 0 ? schemaNames : [""];
	
	    permissions = downgradeNativePermissionsIfNeeded(permissions, groupId, { databaseId: databaseId }, value, metadata);
	    return updatePermission(permissions, groupId, [databaseId, "schemas"], value, schemaNamesOrNoSchema);
	}
	
	function updateNativePermission(permissions, groupId, _ref8, value, metadata) {
	    var databaseId = _ref8.databaseId;
	
	    // if enabling native query write access, give access to all schemas since they are equivalent
	    if (value === "write") {
	        permissions = updateSchemasPermission(permissions, groupId, { databaseId: databaseId }, "all", metadata);
	    }
	    return updatePermission(permissions, groupId, [databaseId, "native"], value);
	}
	
	function deleteIfEmpty(object, key) {
	    if (Object.keys(object[key]).length === 0) {
	        delete object[key];
	    }
	}
	
	function diffDatabasePermissions(newPerms, oldPerms, groupId, database) {
	    var databaseDiff = { grantedTables: {}, revokedTables: {} };
	    // get the native permisisons for this db
	    var oldNativePerm = getNativePermission(oldPerms, groupId, { databaseId: database.id });
	    var newNativePerm = getNativePermission(newPerms, groupId, { databaseId: database.id });
	    if (oldNativePerm !== newNativePerm) {
	        databaseDiff.native = newNativePerm;
	    }
	    // check each table in this db
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = database.tables[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var table = _step2.value;
	
	            var oldFieldsPerm = getFieldsPermission(oldPerms, groupId, { databaseId: database.id, schemaName: table.schema || "", tableId: table.id });
	            var newFieldsPerm = getFieldsPermission(newPerms, groupId, { databaseId: database.id, schemaName: table.schema || "", tableId: table.id });
	            if (oldFieldsPerm !== newFieldsPerm) {
	                if (newFieldsPerm === "none") {
	                    databaseDiff.revokedTables[table.id] = { name: table.display_name };
	                } else {
	                    databaseDiff.grantedTables[table.id] = { name: table.display_name };
	                }
	            }
	        }
	        // remove types that have no tables
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    var _arr = ["grantedTables", "revokedTables"];
	    for (var _i = 0; _i < _arr.length; _i++) {
	        var type = _arr[_i];
	        deleteIfEmpty(databaseDiff, type);
	    }
	    return databaseDiff;
	}
	
	function diffGroupPermissions(newPerms, oldPerms, groupId, metadata) {
	    var groupDiff = { databases: {} };
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	        for (var _iterator3 = metadata.databasesList()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var database = _step3.value;
	
	            groupDiff.databases[database.id] = diffDatabasePermissions(newPerms, oldPerms, groupId, database);
	            deleteIfEmpty(groupDiff.databases, database.id);
	            if (groupDiff.databases[database.id]) {
	                groupDiff.databases[database.id].name = database.name;
	            }
	        }
	    } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	            }
	        } finally {
	            if (_didIteratorError3) {
	                throw _iteratorError3;
	            }
	        }
	    }
	
	    deleteIfEmpty(groupDiff, "databases");
	    return groupDiff;
	}
	
	function diffPermissions(newPerms, oldPerms, groups, metadata) {
	    var permissionsDiff = { groups: {} };
	    if (newPerms && oldPerms && metadata) {
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = groups[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var group = _step4.value;
	
	                permissionsDiff.groups[group.id] = diffGroupPermissions(newPerms, oldPerms, group.id, metadata);
	                deleteIfEmpty(permissionsDiff.groups, group.id);
	                if (permissionsDiff.groups[group.id]) {
	                    permissionsDiff.groups[group.id].name = group.name;
	                }
	            }
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                    _iterator4.return();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	    }
	    return permissionsDiff;
	}

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _Title = __webpack_require__(1538);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _PulseEdit = __webpack_require__(1687);
	
	var _PulseEdit2 = _interopRequireDefault(_PulseEdit);
	
	var _selectors = __webpack_require__(1700);
	
	var _actions = __webpack_require__(1701);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return _extends({}, (0, _selectors.editPulseSelectors)(state, props), {
	        user: state.currentUser
	    });
	};
	
	var mapDispatchToProps = {
	    setEditingPulse: _actions.setEditingPulse,
	    updateEditingPulse: _actions.updateEditingPulse,
	    saveEditingPulse: _actions.saveEditingPulse,
	    deletePulse: _actions.deletePulse,
	    fetchCards: _actions.fetchCards,
	    fetchUsers: _actions.fetchUsers,
	    fetchPulseFormInput: _actions.fetchPulseFormInput,
	    fetchPulseCardPreview: _actions.fetchPulseCardPreview,
	    testPulse: _actions.testPulse,
	    onChangeLocation: _reactRouterRedux.push
	};
	
	var PulseEditApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _Title2.default)(function (_ref) {
	    var pulse = _ref.pulse;
	    return pulse && pulse.name;
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(PulseEditApp, _Component);
	
	    function PulseEditApp() {
	        _classCallCheck(this, PulseEditApp);
	
	        return _possibleConstructorReturn(this, (PulseEditApp.__proto__ || Object.getPrototypeOf(PulseEditApp)).apply(this, arguments));
	    }
	
	    _createClass(PulseEditApp, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_PulseEdit2.default, this.props);
	        }
	    }]);
	
	    return PulseEditApp;
	}(_react.Component)) || _class) || _class);
	PulseEditApp.displayName = "PulseEditApp";
	exports.default = PulseEditApp;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _PulseEditName = __webpack_require__(1688);
	
	var _PulseEditName2 = _interopRequireDefault(_PulseEditName);
	
	var _PulseEditCards = __webpack_require__(1689);
	
	var _PulseEditCards2 = _interopRequireDefault(_PulseEditCards);
	
	var _PulseEditChannels = __webpack_require__(1692);
	
	var _PulseEditChannels2 = _interopRequireDefault(_PulseEditChannels);
	
	var _PulseEditSkip = __webpack_require__(1697);
	
	var _PulseEditSkip2 = _interopRequireDefault(_PulseEditSkip);
	
	var _WhatsAPulse = __webpack_require__(1698);
	
	var _WhatsAPulse2 = _interopRequireDefault(_WhatsAPulse);
	
	var _ActionButton = __webpack_require__(1213);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _DeleteModalWithConfirm = __webpack_require__(1699);
	
	var _DeleteModalWithConfirm2 = _interopRequireDefault(_DeleteModalWithConfirm);
	
	var _pulse = __webpack_require__(1696);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _inflection = __webpack_require__(520);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PulseEdit = (_temp = _class = function (_Component) {
	    _inherits(PulseEdit, _Component);
	
	    function PulseEdit(props) {
	        _classCallCheck(this, PulseEdit);
	
	        var _this = _possibleConstructorReturn(this, (PulseEdit.__proto__ || Object.getPrototypeOf(PulseEdit)).call(this, props));
	
	        _underscore2.default.bindAll(_this, "save", "delete", "setPulse");
	        return _this;
	    }
	
	    _createClass(PulseEdit, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.props.setEditingPulse(this.props.pulseId);
	            this.props.fetchCards();
	            this.props.fetchUsers();
	            this.props.fetchPulseFormInput();
	
	            _analytics2.default.trackEvent(this.props.pulseId ? "PulseEdit" : "PulseCreate", "Start");
	        }
	    }, {
	        key: "save",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var pulse;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                pulse = (0, _pulse.cleanPulse)(this.props.pulse, this.props.formInput.channels);
	                                _context.next = 3;
	                                return this.props.updateEditingPulse(pulse);
	
	                            case 3:
	                                _context.next = 5;
	                                return this.props.saveEditingPulse();
	
	                            case 5:
	
	                                _analytics2.default.trackEvent(this.props.pulseId ? "PulseEdit" : "PulseCreate", "Complete", this.props.pulse.cards.length);
	
	                                this.props.onChangeLocation("/pulse");
	
	                            case 7:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function save() {
	                return _ref.apply(this, arguments);
	            }
	
	            return save;
	        }()
	    }, {
	        key: "delete",
	        value: function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return this.props.deletePulse(this.props.pulse.id);
	
	                            case 2:
	
	                                _analytics2.default.trackEvent("PulseDelete", "Complete");
	
	                                this.props.onChangeLocation("/pulse");
	
	                            case 4:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function _delete() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return _delete;
	        }()
	    }, {
	        key: "setPulse",
	        value: function setPulse(pulse) {
	            this.props.updateEditingPulse(pulse);
	        }
	    }, {
	        key: "isValid",
	        value: function isValid() {
	            var _this2 = this;
	
	            var pulse = this.props.pulse;
	
	            return pulse.name && pulse.cards.length && pulse.channels.length > 0 && pulse.channels.filter(function (c) {
	                return _this2.channelIsValid(c);
	            }).length > 0;
	        }
	    }, {
	        key: "getConfirmItems",
	        value: function getConfirmItems() {
	            return this.props.pulse.channels.map(function (c) {
	                return c.channel_type === "email" ? _react2.default.createElement(
	                    "span",
	                    null,
	                    "This pulse will no longer be emailed to ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        c.recipients.length,
	                        " ",
	                        (0, _inflection.inflect)("address", c.recipients.length)
	                    ),
	                    " ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        c.schedule_type
	                    ),
	                    "."
	                ) : c.channel_type === "slack" ? _react2.default.createElement(
	                    "span",
	                    null,
	                    "Slack channel ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        c.details && c.details.channel
	                    ),
	                    " will no longer get this pulse ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        c.schedule_type
	                    ),
	                    "."
	                ) : _react2.default.createElement(
	                    "span",
	                    null,
	                    "Channel ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        c.channel_type
	                    ),
	                    " will no longer receive this pulse ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        c.schedule_type
	                    ),
	                    "."
	                );
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                pulse = _props.pulse,
	                formInput = _props.formInput;
	
	            var isValid = (0, _pulse.pulseIsValid)(pulse, formInput.channels);
	            return _react2.default.createElement(
	                "div",
	                { className: "PulseEdit" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "PulseEdit-header flex align-center border-bottom py3" },
	                    _react2.default.createElement(
	                        "h1",
	                        null,
	                        pulse && pulse.id != null ? "Edit" : "New",
	                        " pulse"
	                    ),
	                    _react2.default.createElement(
	                        _ModalWithTrigger2.default,
	                        {
	                            ref: "pulseInfo",
	                            className: "Modal WhatsAPulseModal",
	                            triggerElement: "What's a Pulse?",
	                            triggerClasses: "text-brand text-bold flex-align-right"
	                        },
	                        _react2.default.createElement(
	                            _ModalContent2.default,
	                            {
	                                onClose: function onClose() {
	                                    return _this3.refs.pulseInfo.close();
	                                }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "mx4 mb4" },
	                                _react2.default.createElement(_WhatsAPulse2.default, {
	                                    button: _react2.default.createElement(
	                                        "button",
	                                        { className: "Button Button--primary", onClick: function onClick() {
	                                                return _this3.refs.pulseInfo.close();
	                                            } },
	                                        "Got it"
	                                    )
	                                })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "PulseEdit-content pt2 pb4" },
	                    _react2.default.createElement(_PulseEditName2.default, _extends({}, this.props, { setPulse: this.setPulse })),
	                    _react2.default.createElement(_PulseEditCards2.default, _extends({}, this.props, { setPulse: this.setPulse })),
	                    _react2.default.createElement(_PulseEditChannels2.default, _extends({}, this.props, { setPulse: this.setPulse, pulseIsValid: isValid })),
	                    _react2.default.createElement(_PulseEditSkip2.default, _extends({}, this.props, { setPulse: this.setPulse })),
	                    pulse && pulse.id != null && _react2.default.createElement(
	                        "div",
	                        { className: "DangerZone mb2 p3 rounded bordered relative" },
	                        _react2.default.createElement(
	                            "h3",
	                            { className: "text-error absolute top bg-white px1", style: { marginTop: "-12px" } },
	                            "Danger Zone"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "ml1" },
	                            _react2.default.createElement(
	                                "h4",
	                                { className: "text-bold mb1" },
	                                "Delete this pulse"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "flex" },
	                                _react2.default.createElement(
	                                    "p",
	                                    { className: "h4 pr2" },
	                                    "Stop delivery and delete this pulse. There's no undo, so be careful."
	                                ),
	                                _react2.default.createElement(
	                                    _ModalWithTrigger2.default,
	                                    {
	                                        ref: "deleteModal" + pulse.id,
	                                        triggerClasses: "Button Button--danger flex-align-right flex-no-shrink",
	                                        triggerElement: "Delete this Pulse"
	                                    },
	                                    _react2.default.createElement(_DeleteModalWithConfirm2.default, {
	                                        objectType: "pulse",
	                                        objectName: pulse.name,
	                                        confirmItems: this.getConfirmItems(),
	                                        onClose: function onClose() {
	                                            return _this3.refs["deleteModal" + pulse.id].close();
	                                        },
	                                        onDelete: this.delete
	                                    })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "PulseEdit-footer flex align-center border-top py3" },
	                    _react2.default.createElement(_ActionButton2.default, {
	                        actionFn: this.save,
	                        className: (0, _classnames2.default)("Button Button--primary", { "disabled": !isValid }),
	                        normalText: pulse.id != null ? "Save changes" : "Create pulse",
	                        activeText: "Saving\u2026",
	                        failedText: "Save failed",
	                        successText: "Saved"
	                    }),
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: "/pulse", className: "Button ml2" },
	                        "Cancel"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PulseEdit;
	}(_react.Component), _class.propTypes = {
	    pulse: _propTypes2.default.object.isRequired,
	    pulseId: _propTypes2.default.number,
	    formInput: _propTypes2.default.object.isRequired,
	    setEditingPulse: _propTypes2.default.func.isRequired,
	    fetchCards: _propTypes2.default.func.isRequired,
	    fetchUsers: _propTypes2.default.func.isRequired,
	    fetchPulseFormInput: _propTypes2.default.func.isRequired,
	    updateEditingPulse: _propTypes2.default.func.isRequired,
	    saveEditingPulse: _propTypes2.default.func.isRequired,
	    deletePulse: _propTypes2.default.func.isRequired,
	    onChangeLocation: _propTypes2.default.func.isRequired
	}, _temp);
	PulseEdit.displayName = "PulseEdit";
	exports.default = PulseEdit;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PulseEditName = (_temp = _class = function (_Component) {
	    _inherits(PulseEditName, _Component);
	
	    function PulseEditName(props) {
	        _classCallCheck(this, PulseEditName);
	
	        var _this = _possibleConstructorReturn(this, (PulseEditName.__proto__ || Object.getPrototypeOf(PulseEditName)).call(this, props));
	
	        _this.state = {
	            valid: true
	        };
	
	        _underscore2.default.bindAll(_this, "setName", "validate");
	        return _this;
	    }
	
	    _createClass(PulseEditName, [{
	        key: "setName",
	        value: function setName(e) {
	            var pulse = this.props.pulse;
	
	            this.props.setPulse(_extends({}, pulse, { name: e.target.value }));
	        }
	    }, {
	        key: "validate",
	        value: function validate() {
	            this.setState({ valid: !!_reactDom2.default.findDOMNode(this.refs.name).value });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var pulse = this.props.pulse;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "py1" },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Name your pulse"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: "mt1 h4 text-bold text-grey-3" },
	                    "Give your pulse a name to help others understand what it's about."
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "my3" },
	                    _react2.default.createElement("input", {
	                        ref: "name",
	                        className: (0, _classnames2.default)("input text-bold", { "border-error": !this.state.valid }),
	                        style: { "width": "400px" },
	                        value: pulse.name || "",
	                        onChange: this.setName,
	                        onBlur: this.refs.name && this.validate,
	                        placeholder: "Important metrics",
	                        autoFocus: true
	                    })
	                )
	            );
	        }
	    }]);
	
	    return PulseEditName;
	}(_react.Component), _class.propTypes = {}, _class.defaultProps = {}, _temp);
	PulseEditName.displayName = "PulseEditName";
	exports.default = PulseEditName;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CardPicker = __webpack_require__(1690);
	
	var _CardPicker2 = _interopRequireDefault(_CardPicker);
	
	var _PulseCardPreview = __webpack_require__(1691);
	
	var _PulseCardPreview2 = _interopRequireDefault(_PulseCardPreview);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SOFT_LIMIT = 10;
	var HARD_LIMIT = 25;
	
	var PulseEditCards = (_temp = _class = function (_Component) {
	    _inherits(PulseEditCards, _Component);
	
	    function PulseEditCards(props) {
	        _classCallCheck(this, PulseEditCards);
	
	        var _this = _possibleConstructorReturn(this, (PulseEditCards.__proto__ || Object.getPrototypeOf(PulseEditCards)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(PulseEditCards, [{
	        key: "setCard",
	        value: function setCard(index, cardId) {
	            var pulse = this.props.pulse;
	
	            this.props.setPulse(_extends({}, pulse, {
	                cards: [].concat(_toConsumableArray(pulse.cards.slice(0, index)), [{ id: cardId }], _toConsumableArray(pulse.cards.slice(index + 1)))
	            }));
	
	            _analytics2.default.trackEvent(this.props.pulseId ? "PulseEdit" : "PulseCreate", "AddCard", index);
	        }
	    }, {
	        key: "removeCard",
	        value: function removeCard(index) {
	            var pulse = this.props.pulse;
	
	            this.props.setPulse(_extends({}, pulse, {
	                cards: [].concat(_toConsumableArray(pulse.cards.slice(0, index)), _toConsumableArray(pulse.cards.slice(index + 1)))
	            }));
	
	            _analytics2.default.trackEvent(this.props.pulseId ? "PulseEdit" : "PulseCreate", "RemoveCard", index);
	        }
	    }, {
	        key: "getWarnings",
	        value: function getWarnings(cardPreview, showSoftLimitWarning) {
	            var warnings = [];
	            if (cardPreview) {
	                if (cardPreview.pulse_card_type === "bar" && cardPreview.row_count > 10) {
	                    warnings.push({
	                        head: "Heads up",
	                        body: "This is a large table and we'll have to crop it to use it in a pulse. The max size that can be displayed is 2 columns and 10 rows."
	                    });
	                }
	                if (cardPreview.pulse_card_type == null) {
	                    warnings.push({
	                        head: "Heads up",
	                        body: "We are unable to display this card in a pulse"
	                    });
	                }
	            }
	            if (showSoftLimitWarning) {
	                warnings.push({
	                    head: "Looks like this pulse is getting big",
	                    body: "We recommend keeping pulses small and focused to help keep them digestable and useful to the whole team."
	                });
	            }
	            return warnings;
	        }
	    }, {
	        key: "renderCardWarnings",
	        value: function renderCardWarnings(card, index) {
	            var cardPreview = card && this.props.cardPreviews[card.id];
	            var warnings = this.getWarnings(cardPreview, index === SOFT_LIMIT);
	            if (warnings.length > 0) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "absolute", style: { width: 400, marginLeft: 420 } },
	                    warnings.map(function (warning) {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: "text-gold border-gold border-left mt1 mb2 ml3 pl3", style: { borderWidth: 3 } },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "mb1" },
	                                warning.head
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "h4" },
	                                warning.body
	                            )
	                        );
	                    })
	                );
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                pulse = _props.pulse,
	                cards = _props.cards,
	                cardList = _props.cardList,
	                cardPreviews = _props.cardPreviews;
	
	
	            var pulseCards = pulse ? pulse.cards.slice() : [];
	            if (pulseCards.length < HARD_LIMIT) {
	                pulseCards.push(null);
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "py1" },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Pick your data"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: "mt1 h4 text-bold text-grey-3" },
	                    "Pick up to five questions you'd like to send in this pulse"
	                ),
	                _react2.default.createElement(
	                    "ol",
	                    { className: "my3" },
	                    cards && pulseCards.map(function (card, index) {
	                        return _react2.default.createElement(
	                            "li",
	                            { key: index, className: "my1" },
	                            index === SOFT_LIMIT && _react2.default.createElement("div", { className: "my4 ml3", style: { width: 375, borderTop: "1px dashed rgb(214,214,214)" } }),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "flex align-top" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "flex align-top", style: { width: 400 } },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: "h3 text-bold mr1 mt2" },
	                                        index + 1,
	                                        "."
	                                    ),
	                                    card ? _react2.default.createElement(_PulseCardPreview2.default, {
	                                        card: card,
	                                        cardPreview: cardPreviews[card.id],
	                                        onRemove: _this2.removeCard.bind(_this2, index),
	                                        fetchPulseCardPreview: _this2.props.fetchPulseCardPreview
	                                    }) : _react2.default.createElement(_CardPicker2.default, {
	                                        cardList: cardList,
	                                        onChange: _this2.setCard.bind(_this2, index)
	                                    })
	                                ),
	                                _this2.renderCardWarnings(card, index)
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return PulseEditCards;
	}(_react.Component), _class.propTypes = {
	    pulse: _propTypes2.default.object.isRequired,
	    pulseId: _propTypes2.default.number,
	    cardPreviews: _propTypes2.default.object.isRequired,
	    cards: _propTypes2.default.object.isRequired,
	    cardList: _propTypes2.default.array.isRequired,
	    fetchPulseCardPreview: _propTypes2.default.func.isRequired,
	    setPulse: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {}, _temp);
	PulseEditCards.displayName = "PulseEditCards";
	exports.default = PulseEditCards;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardPicker = (_temp2 = _class = function (_Component) {
	    _inherits(CardPicker, _Component);
	
	    function CardPicker() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, CardPicker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CardPicker.__proto__ || Object.getPrototypeOf(CardPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isOpen: false,
	            inputValue: "",
	            inputWidth: 300,
	            collectionId: undefined
	        }, _this.onInputChange = function (_ref2) {
	            var target = _ref2.target;
	
	            _this.setState({ inputValue: target.value });
	        }, _this.onInputFocus = function () {
	            _this.setState({ isOpen: true });
	        }, _this.onInputBlur = function () {
	            // Without a timeout here isOpen gets set to false when an item is clicked
	            // which causes the click handler to not fire. For some reason this even
	            // happens with a 100ms delay, but not 200ms?
	            clearTimeout(_this._timer);
	            _this._timer = setTimeout(function () {
	                if (!_this.state.isClicking) {
	                    _this.setState({ isOpen: false });
	                } else {
	                    _this.setState({ isClicking: false });
	                }
	            }, 250);
	        }, _this.onChange = function (id) {
	            _this.props.onChange(id);
	            _reactDom2.default.findDOMNode(_this.refs.input).blur();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CardPicker, [{
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            clearTimeout(this._timer);
	        }
	    }, {
	        key: "renderItem",
	        value: function renderItem(card) {
	            var error = void 0;
	            try {
	                if (_query2.default.isBareRows(card.dataset_query.query)) {
	                    error = "Raw data cannot be included in pulses";
	                }
	            } catch (e) {}
	            if (card.display === "pin_map" || card.display === "state" || card.display === "country") {
	                error = "Maps cannot be included in pulses";
	            }
	
	            if (error) {
	                return _react2.default.createElement(
	                    "li",
	                    { key: card.id, className: "px2 py1" },
	                    _react2.default.createElement(
	                        "h4",
	                        { className: "text-grey-2" },
	                        card.name
	                    ),
	                    _react2.default.createElement(
	                        "h4",
	                        { className: "text-gold mt1" },
	                        error
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    "li",
	                    { key: card.id, className: "List-item cursor-pointer", onClickCapture: this.onChange.bind(this, card.id) },
	                    _react2.default.createElement(
	                        "h4",
	                        { className: "List-item-title px2 py1" },
	                        card.name
	                    )
	                );
	            }
	        }
	
	        // keep the modal width in sync with the input width :-/
	
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this.refs.input),
	                scrollWidth = _ReactDOM$findDOMNode.scrollWidth;
	
	            if (this.state.inputWidth !== scrollWidth) {
	                this.setState({ inputWidth: scrollWidth });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var cardList = this.props.cardList;
	            var _state = this.state,
	                isOpen = _state.isOpen,
	                inputValue = _state.inputValue,
	                inputWidth = _state.inputWidth,
	                collectionId = _state.collectionId;
	
	
	            var cardByCollectionId = _underscore2.default.groupBy(cardList, "collection_id");
	            var collectionIds = Object.keys(cardByCollectionId);
	
	            var collections = _underscore2.default.chain(cardList).map(function (card) {
	                return card.collection;
	            }).uniq(function (c) {
	                return c && c.id;
	            }).filter(function (c) {
	                return c;
	            }).sortBy("name")
	            // add "Everything else" as the last option for cards without a
	            // collection
	            .concat([{ id: null, name: "Everything else" }]).value();
	
	            var visibleCardList = void 0;
	            if (inputValue) {
	                var searchString = inputValue.toLowerCase();
	                visibleCardList = cardList.filter(function (card) {
	                    return ~(card.name || "").toLowerCase().indexOf(searchString) || ~(card.description || "").toLowerCase().indexOf(searchString);
	                });
	            } else {
	                if (collectionId !== undefined) {
	                    visibleCardList = cardByCollectionId[collectionId];
	                } else if (collectionIds.length === 1) {
	                    visibleCardList = cardByCollectionId[collectionIds[0]];
	                }
	            }
	
	            var collection = _underscore2.default.findWhere(collections, { id: collectionId });
	            return _react2.default.createElement(
	                "div",
	                { className: "CardPicker flex-full" },
	                _react2.default.createElement("input", {
	                    ref: "input",
	                    className: "input no-focus full text-bold",
	                    placeholder: "Type a question name to filter",
	                    value: this.inputValue,
	                    onFocus: this.onInputFocus,
	                    onBlur: this.onInputBlur,
	                    onChange: this.onInputChange
	                }),
	                _react2.default.createElement(
	                    _Popover2.default,
	                    {
	                        isOpen: isOpen && cardList.length > 0,
	                        hasArrow: false,
	                        tetherOptions: {
	                            attachment: "top left",
	                            targetAttachment: "bottom left",
	                            targetOffset: "0 0"
	                        }
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "rounded bordered scroll-y scroll-show", style: { width: inputWidth + "px", maxHeight: "400px" } },
	                        visibleCardList && collectionIds.length > 1 && _react2.default.createElement(
	                            "div",
	                            { className: "flex align-center text-slate cursor-pointer border-bottom p2", onClick: function onClick(e) {
	                                    _this2.setState({ collectionId: undefined, isClicking: true });
	                                } },
	                            _react2.default.createElement(_Icon2.default, { name: "chevronleft", size: 18 }),
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "ml1" },
	                                collection && collection.name
	                            )
	                        ),
	                        visibleCardList ? _react2.default.createElement(
	                            "ul",
	                            { className: "List text-brand" },
	                            visibleCardList.map(function (card) {
	                                return _this2.renderItem(card);
	                            })
	                        ) : collections ? _react2.default.createElement(
	                            CollectionList,
	                            null,
	                            collections.map(function (collection) {
	                                return _react2.default.createElement(CollectionListItem, { collection: collection, onClick: function onClick(e) {
	                                        _this2.setState({ collectionId: collection.id, isClicking: true });
	                                    } });
	                            })
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CardPicker;
	}(_react.Component), _class.propTypes = {
	    cardList: _propTypes2.default.array.isRequired,
	    onChange: _propTypes2.default.func.isRequired
	}, _temp2);
	CardPicker.displayName = "CardPicker";
	exports.default = CardPicker;
	
	
	var CollectionListItem = function CollectionListItem(_ref3) {
	    var collection = _ref3.collection,
	        onClick = _ref3.onClick;
	    return _react2.default.createElement(
	        "li",
	        { className: "List-item cursor-pointer flex align-center py1 px2", onClick: onClick },
	        _react2.default.createElement(_Icon2.default, { name: "collection", style: { color: collection.color }, className: "Icon mr2 text-default", size: 18 }),
	        _react2.default.createElement(
	            "h4",
	            { className: "List-item-title" },
	            collection.name
	        ),
	        _react2.default.createElement(_Icon2.default, { name: "chevronright", className: "flex-align-right text-grey-2" })
	    );
	};
	
	CollectionListItem.displayName = "CollectionListItem";
	CollectionListItem.propTypes = {
	    collection: _propTypes2.default.object.isRequired,
	    onClick: _propTypes2.default.func.isRequired
	};
	
	var CollectionList = function CollectionList(_ref4) {
	    var children = _ref4.children;
	    return _react2.default.createElement(
	        "ul",
	        { className: "List text-brand" },
	        children
	    );
	};
	
	CollectionList.displayName = "CollectionList";
	CollectionList.propTypes = {
	    children: _propTypes2.default.array.isRequired
	};

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	/*eslint-disable react/no-danger */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoadingSpinner = __webpack_require__(1281);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PulseCardPreview = (_temp = _class = function (_Component) {
	    _inherits(PulseCardPreview, _Component);
	
	    function PulseCardPreview(props, context) {
	        _classCallCheck(this, PulseCardPreview);
	
	        return _possibleConstructorReturn(this, (PulseCardPreview.__proto__ || Object.getPrototypeOf(PulseCardPreview)).call(this, props, context));
	    }
	
	    _createClass(PulseCardPreview, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.fetchPulseCardPreview(this.props.card.id);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var cardPreview = this.props.cardPreview;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex relative flex-full" },
	                _react2.default.createElement(
	                    "a",
	                    { className: "text-grey-2 absolute", style: { top: "15px", right: "15px" }, onClick: this.props.onRemove },
	                    _react2.default.createElement(_Icon2.default, { name: "close", size: 16 })
	                ),
	                _react2.default.createElement("div", { className: "bordered rounded flex-full scroll-x", style: { display: !cardPreview && "none" }, dangerouslySetInnerHTML: { __html: cardPreview && cardPreview.pulse_card_html } }),
	                !cardPreview && _react2.default.createElement(
	                    "div",
	                    { className: "flex-full flex align-center layout-centered pt1" },
	                    _react2.default.createElement(_LoadingSpinner2.default, { className: "inline-block" })
	                )
	            );
	        }
	    }]);
	
	    return PulseCardPreview;
	}(_react.Component), _class.propTypes = {
	    card: _propTypes2.default.object.isRequired,
	    cardPreview: _propTypes2.default.object,
	    onRemove: _propTypes2.default.func.isRequired,
	    fetchPulseCardPreview: _propTypes2.default.func.isRequired
	}, _temp);
	PulseCardPreview.displayName = "PulseCardPreview";
	exports.default = PulseCardPreview;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	var _RecipientPicker = __webpack_require__(1693);
	
	var _RecipientPicker2 = _interopRequireDefault(_RecipientPicker);
	
	var _SetupMessage = __webpack_require__(1694);
	
	var _SetupMessage2 = _interopRequireDefault(_SetupMessage);
	
	var _SchedulePicker = __webpack_require__(1695);
	
	var _SchedulePicker2 = _interopRequireDefault(_SchedulePicker);
	
	var _ActionButton = __webpack_require__(1213);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Toggle = __webpack_require__(1241);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _pulse = __webpack_require__(1696);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CHANNEL_ICONS = {
	    email: "mail",
	    slack: "slack"
	};
	
	var CHANNEL_NOUN_PLURAL = {
	    "email": "Emails",
	    "slack": "Slack messages"
	};
	
	var PulseEditChannels = (_temp = _class = function (_Component) {
	    _inherits(PulseEditChannels, _Component);
	
	    function PulseEditChannels(props) {
	        _classCallCheck(this, PulseEditChannels);
	
	        var _this = _possibleConstructorReturn(this, (PulseEditChannels.__proto__ || Object.getPrototypeOf(PulseEditChannels)).call(this, props));
	
	        _this.willPulseSkip = function () {
	            var cards = _underscore2.default.pluck(_this.props.pulse.cards, 'id');
	            var cardPreviews = _this.props.cardPreviews;
	            var previews = _underscore2.default.map(cards, function (id) {
	                return _underscore2.default.find(cardPreviews, function (card) {
	                    return id == card.id;
	                });
	            });
	            var types = _underscore2.default.pluck(previews, 'pulse_card_type');
	            var empty = _underscore2.default.isEqual(_underscore2.default.uniq(types), ["empty"]);
	            return empty && _this.props.pulse.skip_if_empty;
	        };
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(PulseEditChannels, [{
	        key: "addChannel",
	        value: function addChannel(type) {
	            var _props = this.props,
	                pulse = _props.pulse,
	                formInput = _props.formInput;
	
	
	            var channelSpec = formInput.channels[type];
	            if (!channelSpec) {
	                return;
	            }
	
	            var details = {};
	            // if (channelSpec.fields) {
	            //     for (let field of channelSpec.fields) {
	            //         if (field.required) {
	            //             if (field.type === "select") {
	            //                 details[field.name] = field.options[0];
	            //             }
	            //         }
	            //     }
	            // }
	
	            var channel = {
	                channel_type: type,
	                enabled: true,
	                recipients: [],
	                details: details,
	                schedule_type: channelSpec.schedules[0],
	                schedule_day: "mon",
	                schedule_hour: 8,
	                schedule_frame: "first"
	            };
	
	            this.props.setPulse(_extends({}, pulse, { channels: pulse.channels.concat(channel) }));
	
	            _analytics2.default.trackEvent(this.props.pulseId ? "PulseEdit" : "PulseCreate", "AddChannel", type);
	        }
	    }, {
	        key: "removeChannel",
	        value: function removeChannel(index) {
	            var pulse = this.props.pulse;
	
	            this.props.setPulse((0, _icepick.assocIn)(pulse, ["channels", index, "enabled"], false));
	        }
	    }, {
	        key: "onChannelPropertyChange",
	        value: function onChannelPropertyChange(index, name, value) {
	            var pulse = this.props.pulse;
	
	            var channels = [].concat(_toConsumableArray(pulse.channels));
	
	            channels[index] = _extends({}, channels[index], _defineProperty({}, name, value));
	
	            this.props.setPulse(_extends({}, pulse, { channels: channels }));
	        }
	
	        // changedProp contains the schedule property that user just changed
	        // newSchedule may contain also other changed properties as some property changes reset other properties
	
	    }, {
	        key: "onChannelScheduleChange",
	        value: function onChannelScheduleChange(index, newSchedule, changedProp) {
	            var pulse = this.props.pulse;
	
	            var channels = [].concat(_toConsumableArray(pulse.channels));
	
	            _analytics2.default.trackEvent(this.props.pulseId ? "PulseEdit" : "PulseCreate", channels[index].channel_type + ":" + changedProp.name, changedProp.value);
	
	            channels[index] = _extends({}, channels[index], newSchedule);
	            this.props.setPulse(_extends({}, pulse, { channels: channels }));
	        }
	    }, {
	        key: "toggleChannel",
	        value: function toggleChannel(type, enable) {
	            var pulse = this.props.pulse;
	
	            if (enable) {
	                if (pulse.channels.some(function (c) {
	                    return c.channel_type === type;
	                })) {
	                    this.props.setPulse((0, _icepick.assoc)(pulse, "channels", pulse.channels.map(function (c) {
	                        return c.channel_type === type ? (0, _icepick.assoc)(c, "enabled", true) : c;
	                    })));
	                } else {
	                    this.addChannel(type);
	                }
	            } else {
	                this.props.setPulse((0, _icepick.assoc)(pulse, "channels", pulse.channels.map(function (c) {
	                    return c.channel_type === type ? (0, _icepick.assoc)(c, "enabled", false) : c;
	                })));
	
	                _analytics2.default.trackEvent(this.props.pulseId ? "PulseEdit" : "PulseCreate", "RemoveChannel", type);
	            }
	        }
	    }, {
	        key: "onTestPulseChannel",
	        value: function onTestPulseChannel(channel) {
	            // test a single channel
	            return this.props.testPulse(_extends({}, this.props.pulse, { channels: [channel] }));
	        }
	    }, {
	        key: "renderFields",
	        value: function renderFields(channel, index, channelSpec) {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                channelSpec.fields.map(function (field) {
	                    return _react2.default.createElement(
	                        "div",
	                        { key: field.name, className: field.name },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "h4 text-bold mr1" },
	                            field.displayName
	                        ),
	                        field.type === "select" ? _react2.default.createElement(_Select2.default, {
	                            className: "h4 text-bold bg-white",
	                            value: channel.details && channel.details[field.name],
	                            options: field.options,
	                            optionNameFn: function optionNameFn(o) {
	                                return o;
	                            },
	                            optionValueFn: function optionValueFn(o) {
	                                return o;
	                            }
	                            // Address #5799 where `details` object is missing for some reason
	                            , onChange: function onChange(o) {
	                                return _this2.onChannelPropertyChange(index, "details", _extends({}, channel.details, _defineProperty({}, field.name, o)));
	                            }
	                        }) : null
	                    );
	                })
	            );
	        }
	    }, {
	        key: "renderChannel",
	        value: function renderChannel(channel, index, channelSpec) {
	            var _this3 = this;
	
	            var isValid = this.props.pulseIsValid && (0, _pulse.channelIsValid)(channel, channelSpec);
	            return _react2.default.createElement(
	                "li",
	                { key: index, className: "py2" },
	                channelSpec.error && _react2.default.createElement(
	                    "div",
	                    { className: "pb2 text-bold text-error" },
	                    channelSpec.error
	                ),
	                channelSpec.recipients && _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "h4 text-bold mb1" },
	                        "To:"
	                    ),
	                    _react2.default.createElement(_RecipientPicker2.default, {
	                        isNewPulse: this.props.pulseId === undefined,
	                        recipients: channel.recipients,
	                        recipientTypes: channelSpec.recipients,
	                        users: this.props.userList,
	                        onRecipientsChange: function onRecipientsChange(recipients) {
	                            return _this3.onChannelPropertyChange(index, "recipients", recipients);
	                        }
	                    })
	                ),
	                channelSpec.fields && this.renderFields(channel, index, channelSpec),
	                channelSpec.schedules && _react2.default.createElement(_SchedulePicker2.default, {
	                    schedule: _underscore2.default.pick(channel, "schedule_day", "schedule_frame", "schedule_hour", "schedule_type"),
	                    scheduleOptions: channelSpec.schedules,
	                    textBeforeInterval: "Sent",
	                    textBeforeSendTime: (CHANNEL_NOUN_PLURAL[channelSpec && channelSpec.type] || "Messages") + " will be sent at ",
	                    onScheduleChange: this.onChannelScheduleChange.bind(this, index)
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "pt2" },
	                    _react2.default.createElement(_ActionButton2.default, {
	                        actionFn: this.onTestPulseChannel.bind(this, channel),
	                        className: (0, _classnames2.default)("Button", { disabled: !isValid }),
	                        normalText: channelSpec.type === "email" ? "Send email now" : "Send to  " + channelSpec.name + " now",
	                        activeText: "Sending\u2026",
	                        failedText: "Sending failed",
	                        successText: this.willPulseSkip() ? "Didn’t send because the pulse has no results." : "Pulse sent",
	                        forceActiveStyle: this.willPulseSkip()
	                    })
	                )
	            );
	        }
	    }, {
	        key: "renderChannelSection",
	        value: function renderChannelSection(channelSpec) {
	            var _this4 = this;
	
	            var _props2 = this.props,
	                pulse = _props2.pulse,
	                user = _props2.user;
	
	            var channels = pulse.channels.map(function (c, i) {
	                return [c, i];
	            }).filter(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    c = _ref2[0],
	                    i = _ref2[1];
	
	                return c.enabled && c.channel_type === channelSpec.type;
	            }).map(function (_ref3) {
	                var _ref4 = _slicedToArray(_ref3, 2),
	                    channel = _ref4[0],
	                    index = _ref4[1];
	
	                return _this4.renderChannel(channel, index, channelSpec);
	            });
	            return _react2.default.createElement(
	                "li",
	                { key: channelSpec.type, className: "border-row-divider" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center p3 border-row-divider" },
	                    CHANNEL_ICONS[channelSpec.type] && _react2.default.createElement(_Icon2.default, { className: "mr1 text-grey-2", name: CHANNEL_ICONS[channelSpec.type], size: 28 }),
	                    _react2.default.createElement(
	                        "h2",
	                        null,
	                        channelSpec.name
	                    ),
	                    _react2.default.createElement(_Toggle2.default, { className: "flex-align-right", value: channels.length > 0, onChange: this.toggleChannel.bind(this, channelSpec.type) })
	                ),
	                channels.length > 0 && channelSpec.configured ? _react2.default.createElement(
	                    "ul",
	                    { className: "bg-grey-0 px3" },
	                    channels
	                ) : channels.length > 0 && !channelSpec.configured ? _react2.default.createElement(
	                    "div",
	                    { className: "p4 text-centered" },
	                    _react2.default.createElement(
	                        "h3",
	                        { className: "mb2" },
	                        channelSpec.name,
	                        " needs to be set up by an administrator."
	                    ),
	                    _react2.default.createElement(_SetupMessage2.default, { user: user, channels: [channelSpec.name] })
	                ) : null
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this5 = this;
	
	            var formInput = this.props.formInput;
	            // Default to show the default channels until full formInput is loaded
	
	            var channels = formInput.channels || {
	                email: { name: "Email", type: "email" },
	                slack: { name: "Slack", type: "slack" }
	            };
	            return _react2.default.createElement(
	                "div",
	                { className: "py1 mb4" },
	                _react2.default.createElement(
	                    "h2",
	                    { className: "mb3" },
	                    "Where should this data go?"
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "bordered rounded" },
	                    Object.values(channels).map(function (channelSpec) {
	                        return _this5.renderChannelSection(channelSpec);
	                    })
	                )
	            );
	        }
	    }]);
	
	    return PulseEditChannels;
	}(_react.Component), _class.propTypes = {
	    pulse: _propTypes2.default.object.isRequired,
	    pulseId: _propTypes2.default.number,
	    pulseIsValid: _propTypes2.default.bool.isRequired,
	    formInput: _propTypes2.default.object.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    userList: _propTypes2.default.array.isRequired,
	    setPulse: _propTypes2.default.func.isRequired,
	    testPulse: _propTypes2.default.func.isRequired,
	    cardPreviews: _propTypes2.default.array
	}, _class.defaultProps = {}, _temp);
	PulseEditChannels.displayName = "PulseEditChannels";
	exports.default = PulseEditChannels;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _UserAvatar = __webpack_require__(1556);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _keyboard = __webpack_require__(934);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VALID_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	
	var RecipientPicker = (_temp = _class = function (_Component) {
	    _inherits(RecipientPicker, _Component);
	
	    function RecipientPicker(props, context) {
	        _classCallCheck(this, RecipientPicker);
	
	        var _this = _possibleConstructorReturn(this, (RecipientPicker.__proto__ || Object.getPrototypeOf(RecipientPicker)).call(this, props, context));
	
	        _this.state = {
	            inputValue: "",
	            filteredUsers: [],
	            selectedUser: null,
	            focused: props.recipients.length === 0
	        };
	
	        _underscore2.default.bindAll(_this, "onMouseDownCapture", "onInputChange", "onInputKeyDown", "onInputFocus", "onInputBlur");
	        return _this;
	    }
	
	    // TODO: use recipientTypes to limit the type of recipient that can be added
	
	    _createClass(RecipientPicker, [{
	        key: "setInputValue",
	        value: function setInputValue(inputValue) {
	            var _props = this.props,
	                users = _props.users,
	                recipients = _props.recipients;
	            var selectedUser = this.state.selectedUser;
	
	
	            var recipientsById = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = recipients[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var recipient = _step.value;
	
	                    if (recipient.id != null) {
	                        recipientsById[recipient.id] = recipient;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var filteredUsers = [];
	            if (inputValue) {
	                // case insensitive search of name or email
	                var inputValueLower = inputValue.toLowerCase();
	                filteredUsers = users.filter(function (user) {
	                    return !(user.id in recipientsById) && (user.common_name.toLowerCase().indexOf(inputValueLower) >= 0 || user.email.toLowerCase().indexOf(inputValueLower) >= 0);
	                });
	            }
	
	            if (selectedUser == null || !_underscore2.default.find(filteredUsers, function (u) {
	                return u.id === selectedUser;
	            })) {
	                if (filteredUsers.length > 0) {
	                    selectedUser = filteredUsers[0].id;
	                } else {
	                    selectedUser = null;
	                }
	            }
	
	            this.setState({ inputValue: inputValue, filteredUsers: filteredUsers, selectedUser: selectedUser });
	        }
	    }, {
	        key: "onInputChange",
	        value: function onInputChange(e) {
	            this.setInputValue(e.target.value);
	        }
	    }, {
	        key: "onInputKeyDown",
	        value: function onInputKeyDown(e) {
	            var _this2 = this;
	
	            // enter, tab, comma
	            if (e.keyCode === _keyboard.KEYCODE_ESCAPE || e.keyCode === _keyboard.KEYCODE_TAB || e.keyCode === _keyboard.KEYCODE_COMMA) {
	                this.addCurrentRecipient();
	            }
	            // up arrow
	            else if (e.keyCode === _keyboard.KEYCODE_UP) {
	                    e.preventDefault();
	                    var index = _underscore2.default.findIndex(this.state.filteredUsers, function (u) {
	                        return u.id === _this2.state.selectedUser;
	                    });
	                    if (index > 0) {
	                        this.setState({ selectedUser: this.state.filteredUsers[index - 1].id });
	                    }
	                }
	                // down arrow
	                else if (e.keyCode === _keyboard.KEYCODE_DOWN) {
	                        e.preventDefault();
	                        var _index = _underscore2.default.findIndex(this.state.filteredUsers, function (u) {
	                            return u.id === _this2.state.selectedUser;
	                        });
	                        if (_index >= 0 && _index < this.state.filteredUsers.length - 1) {
	                            this.setState({ selectedUser: this.state.filteredUsers[_index + 1].id });
	                        }
	                    }
	                    // backspace
	                    else if (e.keyCode === _keyboard.KEYCODE_BACKSPACE) {
	                            var recipients = this.props.recipients;
	
	                            if (!this.state.inputValue && recipients.length > 0) {
	                                this.removeRecipient(recipients[recipients.length - 1]);
	                            }
	                        }
	        }
	    }, {
	        key: "onInputFocus",
	        value: function onInputFocus(e) {
	            this.setState({ focused: true });
	        }
	    }, {
	        key: "onInputBlur",
	        value: function onInputBlur(e) {
	            this.addCurrentRecipient();
	            this.setState({ focused: false });
	        }
	    }, {
	        key: "onMouseDownCapture",
	        value: function onMouseDownCapture(e) {
	            var input = _reactDom2.default.findDOMNode(this.refs.input);
	            input.focus();
	            // prevents clicks from blurring input while still allowing text selection:
	            if (input !== e.target) {
	                e.preventDefault();
	            }
	        }
	    }, {
	        key: "addCurrentRecipient",
	        value: function addCurrentRecipient() {
	            var _this3 = this;
	
	            var input = _reactDom2.default.findDOMNode(this.refs.input);
	            var user = _underscore2.default.find(this.state.filteredUsers, function (u) {
	                return u.id === _this3.state.selectedUser;
	            });
	            if (user) {
	                this.addRecipient(user);
	            } else if (VALID_EMAIL_REGEX.test(input.value)) {
	                this.addRecipient({ email: input.value });
	            }
	        }
	    }, {
	        key: "addRecipient",
	        value: function addRecipient(recipient) {
	            // recipient is a user object, or plain object containing "email" key
	            this.props.onRecipientsChange(this.props.recipients.concat(recipient));
	            this.setInputValue("");
	
	            _analytics2.default.trackEvent(this.props.isNewPulse ? "PulseCreate" : "PulseEdit", "AddRecipient", recipient.id ? "user" : "email");
	        }
	    }, {
	        key: "removeRecipient",
	        value: function removeRecipient(recipient) {
	            this.props.onRecipientsChange(this.props.recipients.filter(function (r) {
	                return recipient.id != null ? recipient.id !== r.id : recipient.email !== r.email;
	            }));
	
	            _analytics2.default.trackEvent(this.props.isNewPulse ? "PulseCreate" : "PulseEdit", "RemoveRecipient", recipient.id ? "user" : "email");
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var _state = this.state,
	                filteredUsers = _state.filteredUsers,
	                selectedUser = _state.selectedUser;
	            var recipients = this.props.recipients;
	
	
	            return _react2.default.createElement(
	                "ul",
	                { className: (0, _classnames2.default)("px1 pb1 bordered rounded flex flex-wrap bg-white", { "input--focus": this.state.focused }), onMouseDownCapture: this.onMouseDownCapture },
	                recipients.map(function (recipient, index) {
	                    return _react2.default.createElement(
	                        "li",
	                        { key: index, className: "mr1 py1 pl1 mt1 rounded bg-grey-1" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "h4 text-bold" },
	                            recipient.common_name || recipient.email
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { className: "text-grey-2 text-grey-4-hover px1", onClick: _this4.removeRecipient.bind(_this4, recipient) },
	                            _react2.default.createElement(_Icon2.default, { name: "close", className: "", size: 12 })
	                        )
	                    );
	                }),
	                _react2.default.createElement(
	                    "li",
	                    { className: "flex-full mr1 py1 pl1 mt1 bg-white", style: { "minWidth": " 100px" } },
	                    _react2.default.createElement("input", {
	                        ref: "input",
	                        type: "text",
	                        className: "full h4 text-bold text-default no-focus borderless",
	                        placeholder: recipients.length === 0 ? "Enter email addresses you'd like this data to go to" : null,
	                        value: this.state.inputValue,
	                        autoFocus: this.state.focused,
	                        onKeyDown: this.onInputKeyDown,
	                        onChange: this.onInputChange,
	                        onFocus: this.onInputFocus,
	                        onBlur: this.onInputBlur
	                    }),
	                    _react2.default.createElement(
	                        _Popover2.default,
	                        {
	                            isOpen: filteredUsers.length > 0,
	                            hasArrow: false,
	                            tetherOptions: {
	                                attachment: "top left",
	                                targetAttachment: "bottom left",
	                                targetOffset: "10 0"
	                            }
	                        },
	                        _react2.default.createElement(
	                            "ul",
	                            { className: "py1" },
	                            filteredUsers.map(function (user) {
	                                return _react2.default.createElement(
	                                    "li",
	                                    {
	                                        className: (0, _classnames2.default)("py1 px2 flex align-center text-bold bg-brand-hover text-white-hover", {
	                                            "bg-grey-1": user.id === selectedUser
	                                        }),
	                                        onClick: _this4.addRecipient.bind(_this4, user)
	                                    },
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: "text-white" },
	                                        _react2.default.createElement(_UserAvatar2.default, { user: user })
	                                    ),
	                                    _react2.default.createElement(
	                                        "span",
	                                        { className: "ml1 h4" },
	                                        user.common_name
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RecipientPicker;
	}(_react.Component), _class.propTypes = {
	    recipients: _propTypes2.default.array,
	    recipientTypes: _propTypes2.default.array.isRequired,
	    users: _propTypes2.default.array,
	    isNewPulse: _propTypes2.default.bool.isRequired,
	    onRecipientsChange: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	    recipientTypes: ["user", "email"]
	}, _temp);
	RecipientPicker.displayName = "RecipientPicker";
	exports.default = RecipientPicker;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SetupMessage = (_temp = _class = function (_Component) {
	    _inherits(SetupMessage, _Component);
	
	    function SetupMessage() {
	        _classCallCheck(this, SetupMessage);
	
	        return _possibleConstructorReturn(this, (SetupMessage.__proto__ || Object.getPrototypeOf(SetupMessage)).apply(this, arguments));
	    }
	
	    _createClass(SetupMessage, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                channels = _props.channels;
	
	            var content = void 0;
	            if (user.is_superuser) {
	                content = _react2.default.createElement(
	                    "div",
	                    null,
	                    channels.map(function (c) {
	                        return _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/admin/settings/" + c.toLowerCase(), key: c.toLowerCase(), className: "Button Button--primary mr1", target: window.OSX ? null : "_blank" },
	                            "Configure ",
	                            c
	                        );
	                    })
	                );
	            } else {
	                var adminEmail = _settings2.default.get("admin_email");
	                content = _react2.default.createElement(
	                    "div",
	                    { className: "mb1" },
	                    _react2.default.createElement(
	                        "h4",
	                        { className: "text-grey-4" },
	                        "Your admin's email address:"
	                    ),
	                    _react2.default.createElement(
	                        "a",
	                        { className: "h2 link no-decoration", href: "mailto:" + adminEmail },
	                        adminEmail
	                    )
	                );
	            }
	            return content;
	        }
	    }]);
	
	    return SetupMessage;
	}(_react.Component), _class.propTypes = {
	    user: _propTypes2.default.object.isRequired,
	    channels: _propTypes2.default.array.isRequired
	}, _class.defaultProps = {
	    channels: ["Email", "Slack"]
	}, _temp);
	SetupMessage.displayName = "SetupMessage";
	exports.default = SetupMessage;

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _formatting = __webpack_require__(872);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HOUR_OPTIONS = _underscore2.default.times(12, function (n) {
	    return { name: (n === 0 ? 12 : n) + ":00", value: n };
	});
	
	var AM_PM_OPTIONS = [{ name: "AM", value: 0 }, { name: "PM", value: 1 }];
	
	var DAY_OF_WEEK_OPTIONS = [{ name: "Sunday", value: "sun" }, { name: "Monday", value: "mon" }, { name: "Tuesday", value: "tue" }, { name: "Wednesday", value: "wed" }, { name: "Thursday", value: "thu" }, { name: "Friday", value: "fri" }, { name: "Saturday", value: "sat" }];
	
	var MONTH_DAY_OPTIONS = [{ name: "First", value: "first" }, { name: "Last", value: "last" }, { name: "15th (Midpoint)", value: "mid" }];
	
	/**
	 * Picker for selecting a hourly/daily/weekly/monthly schedule.
	 *
	 * TODO Atte Keinänen 6/30/17: This could use text input fields instead of dropdown for time (hour + AM/PM) pickers
	 */
	var SchedulePicker = (_temp = _class = function (_Component) {
	    _inherits(SchedulePicker, _Component);
	
	    function SchedulePicker() {
	        _classCallCheck(this, SchedulePicker);
	
	        return _possibleConstructorReturn(this, (SchedulePicker.__proto__ || Object.getPrototypeOf(SchedulePicker)).apply(this, arguments));
	    }
	
	    _createClass(SchedulePicker, [{
	        key: "onPropertyChange",
	        value: function onPropertyChange(name, value) {
	            var newSchedule = _extends({}, this.props.schedule, _defineProperty({}, name, value));
	
	            if (name === "schedule_type") {
	                // clear out other values than schedule_type for hourly schedule
	                if (value === "hourly") {
	                    newSchedule = _extends({}, newSchedule, { "schedule_day": null, "schedule_frame": null, "schedule_hour": null });
	                }
	
	                // default to midnight for all schedules other than hourly
	                if (value !== "hourly") {
	                    newSchedule = _extends({}, newSchedule, { "schedule_hour": newSchedule.schedule_hour || 0 });
	                }
	
	                // clear out other values than schedule_type and schedule_day for daily schedule
	                if (value === "daily") {
	                    newSchedule = _extends({}, newSchedule, { "schedule_day": null, "schedule_frame": null });
	                }
	
	                // default to Monday when user wants a weekly schedule + clear out schedule_frame
	                if (value === "weekly") {
	                    newSchedule = _extends({}, newSchedule, { "schedule_day": "mon", "schedule_frame": null });
	                }
	
	                // default to First, Monday when user wants a monthly schedule
	                if (value === "monthly") {
	                    newSchedule = _extends({}, newSchedule, { "schedule_frame": "first", "schedule_day": "mon" });
	                }
	            } else if (name === "schedule_frame") {
	                // when the monthly schedule frame is the 15th, clear out the schedule_day
	                if (value === "mid") {
	                    newSchedule = _extends({}, newSchedule, { "schedule_day": null });
	                }
	            }
	
	            var changedProp = { name: name, value: value };
	            this.props.onScheduleChange(newSchedule, changedProp);
	        }
	        // TODO: How does this tread an empty schedule?
	
	    }, {
	        key: "renderMonthlyPicker",
	        value: function renderMonthlyPicker() {
	            var _this2 = this;
	
	            var schedule = this.props.schedule;
	
	
	            var DAY_OPTIONS = DAY_OF_WEEK_OPTIONS.slice(0);
	            DAY_OPTIONS.unshift({ name: "Calendar Day", value: null });
	
	            return _react2.default.createElement(
	                "span",
	                { className: "mt1" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "h4 text-bold mx1" },
	                    "on the"
	                ),
	                _react2.default.createElement(_Select2.default, {
	                    value: _underscore2.default.find(MONTH_DAY_OPTIONS, function (o) {
	                        return o.value === schedule.schedule_frame;
	                    }),
	                    options: MONTH_DAY_OPTIONS,
	                    optionNameFn: function optionNameFn(o) {
	                        return o.name;
	                    },
	                    className: "h4 text-bold bg-white",
	                    optionValueFn: function optionValueFn(o) {
	                        return o.value;
	                    },
	                    onChange: function onChange(o) {
	                        return _this2.onPropertyChange("schedule_frame", o);
	                    }
	                }),
	                schedule.schedule_frame !== "mid" && _react2.default.createElement(
	                    "span",
	                    { className: "mt1 mx1" },
	                    _react2.default.createElement(_Select2.default, {
	                        value: _underscore2.default.find(DAY_OPTIONS, function (o) {
	                            return o.value === schedule.schedule_day;
	                        }),
	                        options: DAY_OPTIONS,
	                        optionNameFn: function optionNameFn(o) {
	                            return o.name;
	                        },
	                        optionValueFn: function optionValueFn(o) {
	                            return o.value;
	                        },
	                        className: "h4 text-bold bg-white",
	                        onChange: function onChange(o) {
	                            return _this2.onPropertyChange("schedule_day", o);
	                        }
	                    })
	                )
	            );
	        }
	    }, {
	        key: "renderDayPicker",
	        value: function renderDayPicker() {
	            var _this3 = this;
	
	            var schedule = this.props.schedule;
	
	
	            return _react2.default.createElement(
	                "span",
	                { className: "mt1" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "h4 text-bold mx1" },
	                    "on"
	                ),
	                _react2.default.createElement(_Select2.default, {
	                    value: _underscore2.default.find(DAY_OF_WEEK_OPTIONS, function (o) {
	                        return o.value === schedule.schedule_day;
	                    }),
	                    options: DAY_OF_WEEK_OPTIONS,
	                    optionNameFn: function optionNameFn(o) {
	                        return o.name;
	                    },
	                    optionValueFn: function optionValueFn(o) {
	                        return o.value;
	                    },
	                    className: "h4 text-bold bg-white",
	                    onChange: function onChange(o) {
	                        return _this3.onPropertyChange("schedule_day", o);
	                    }
	                })
	            );
	        }
	    }, {
	        key: "renderHourPicker",
	        value: function renderHourPicker() {
	            var _this4 = this;
	
	            var _props = this.props,
	                schedule = _props.schedule,
	                textBeforeSendTime = _props.textBeforeSendTime;
	
	
	            var hourOfDay = isNaN(schedule.schedule_hour) ? 8 : schedule.schedule_hour;
	            var hour = hourOfDay % 12;
	            var amPm = hourOfDay >= 12 ? 1 : 0;
	            var timezone = _settings2.default.get("timezone_short");
	            return _react2.default.createElement(
	                "div",
	                { className: "mt1" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "h4 text-bold mr1" },
	                    "at"
	                ),
	                _react2.default.createElement(_Select2.default, {
	                    className: "mr1 h4 text-bold bg-white",
	                    value: _underscore2.default.find(HOUR_OPTIONS, function (o) {
	                        return o.value === hour;
	                    }),
	                    options: HOUR_OPTIONS,
	                    optionNameFn: function optionNameFn(o) {
	                        return o.name;
	                    },
	                    optionValueFn: function optionValueFn(o) {
	                        return o.value;
	                    },
	                    onChange: function onChange(o) {
	                        return _this4.onPropertyChange("schedule_hour", o + amPm * 12);
	                    }
	                }),
	                _react2.default.createElement(_Select2.default, {
	                    value: _underscore2.default.find(AM_PM_OPTIONS, function (o) {
	                        return o.value === amPm;
	                    }),
	                    options: AM_PM_OPTIONS,
	                    optionNameFn: function optionNameFn(o) {
	                        return o.name;
	                    },
	                    optionValueFn: function optionValueFn(o) {
	                        return o.value;
	                    },
	                    onChange: function onChange(o) {
	                        return _this4.onPropertyChange("schedule_hour", hour + o * 12);
	                    },
	                    className: "h4 text-bold bg-white"
	                }),
	                textBeforeSendTime && _react2.default.createElement(
	                    "div",
	                    { className: "mt2 h4 text-bold text-grey-3 border-top pt2" },
	                    textBeforeSendTime,
	                    " ",
	                    hour === 0 ? 12 : hour,
	                    ":00 ",
	                    amPm ? "PM" : "AM",
	                    " ",
	                    timezone,
	                    ", your Metabase timezone."
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this5 = this;
	
	            var _props2 = this.props,
	                schedule = _props2.schedule,
	                scheduleOptions = _props2.scheduleOptions,
	                textBeforeInterval = _props2.textBeforeInterval;
	
	
	            var scheduleType = schedule.schedule_type;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "mt1" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "h4 text-bold mr1" },
	                    textBeforeInterval
	                ),
	                _react2.default.createElement(_Select2.default, {
	                    className: "h4 text-bold bg-white",
	                    value: scheduleType,
	                    options: scheduleOptions,
	                    optionNameFn: function optionNameFn(o) {
	                        return (0, _formatting.capitalize)(o);
	                    },
	                    optionValueFn: function optionValueFn(o) {
	                        return o;
	                    },
	                    onChange: function onChange(o) {
	                        return _this5.onPropertyChange("schedule_type", o);
	                    }
	                }),
	                scheduleType === "monthly" && this.renderMonthlyPicker(),
	                scheduleType === "weekly" && this.renderDayPicker(),
	                (scheduleType === "daily" || scheduleType === "weekly" || scheduleType === "monthly") && this.renderHourPicker()
	            );
	        }
	    }]);
	
	    return SchedulePicker;
	}(_react.Component), _class.propTypes = {
	    // the currently chosen schedule, e.g. { schedule_day: "mon", schedule_frame: "null", schedule_hour: 4, schedule_type: "daily" }
	    schedule: _propTypes2.default.object.isRequired,
	    // TODO: hourly option?
	    // available schedules, e.g. [ "daily", "weekly", "monthly"]
	    scheduleOptions: _propTypes2.default.object.isRequired,
	    // text before Daily/Weekly/Monthly... option
	    textBeforeInterval: _propTypes2.default.string,
	    // text prepended to "12:00 PM PST, your Metabase timezone"
	    textBeforeSendTime: _propTypes2.default.string,
	    onScheduleChange: _propTypes2.default.func.isRequired
	}, _temp);
	SchedulePicker.displayName = "SchedulePicker";
	exports.default = SchedulePicker;

/***/ }),
/* 1696 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.channelIsValid = channelIsValid;
	exports.pulseIsValid = pulseIsValid;
	exports.cleanPulse = cleanPulse;
	function channelIsValid(channel, channelSpec) {
	    if (!channelSpec) {
	        return false;
	    }
	    switch (channel.schedule_type) {
	        case "monthly":
	            if (channel.schedule_frame != null && channel.schedule_hour != null) {
	                return true;
	            }
	        // these cases intentionally fall though
	        case "weekly":
	            if (channel.schedule_day == null) {
	                return false;
	            }
	        case "daily":
	            if (channel.schedule_hour == null) {
	                return false;
	            }
	        case "hourly":
	            break;
	        default:
	            return false;
	    }
	    if (channelSpec.recipients) {
	        if (!channel.recipients /* || channel.recipients.length === 0*/) {
	                return false;
	            }
	    }
	    if (channelSpec.fields) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = channelSpec.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var field = _step.value;
	
	                if (field.required && channel.details && (channel.details[field.name] == null || channel.details[field.name] == "")) {
	                    return false;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    }
	    return true;
	}
	
	function pulseIsValid(pulse, channelSpecs) {
	    return pulse.name && pulse.cards.length > 0 && pulse.channels.filter(function (c) {
	        return channelIsValid(c, channelSpecs && channelSpecs[c.channel_type]);
	    }).length > 0 || false;
	}
	
	function cleanPulse(pulse, channelSpecs) {
	    return _extends({}, pulse, {
	        channels: pulse.channels.filter(function (c) {
	            return channelIsValid(c, channelSpecs && channelSpecs[c.channel_type]);
	        })
	    });
	}

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Toggle = __webpack_require__(1241);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PulseEditSkip = (_temp2 = _class = function (_Component) {
	    _inherits(PulseEditSkip, _Component);
	
	    function PulseEditSkip() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PulseEditSkip);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PulseEditSkip.__proto__ || Object.getPrototypeOf(PulseEditSkip)).call.apply(_ref, [this].concat(args))), _this), _this.toggle = function () {
	            var _this$props = _this.props,
	                pulse = _this$props.pulse,
	                setPulse = _this$props.setPulse;
	
	            setPulse(_extends({}, pulse, { skip_if_empty: !pulse.skip_if_empty }));
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PulseEditSkip, [{
	        key: "render",
	        value: function render() {
	            var pulse = this.props.pulse;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "py1" },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Skip if no results"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: "mt1 h4 text-bold text-grey-3" },
	                    "Skip a scheduled Pulse if none of its questions have any results."
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "my3" },
	                    _react2.default.createElement(_Toggle2.default, { value: pulse.skip_if_empty || false, onChange: this.toggle })
	                )
	            );
	        }
	    }]);
	
	    return PulseEditSkip;
	}(_react.Component), _class.propTypes = {
	    pulse: _propTypes2.default.object.isRequired,
	    setPulse: _propTypes2.default.func.isRequired
	}, _temp2);
	PulseEditSkip.displayName = "PulseEditSkip";
	exports.default = PulseEditSkip;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRetinaImage = __webpack_require__(903);
	
	var _reactRetinaImage2 = _interopRequireDefault(_reactRetinaImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WhatsAPulse = (_temp = _class = function (_Component) {
	    _inherits(WhatsAPulse, _Component);
	
	    function WhatsAPulse() {
	        _classCallCheck(this, WhatsAPulse);
	
	        return _possibleConstructorReturn(this, (WhatsAPulse.__proto__ || Object.getPrototypeOf(WhatsAPulse)).apply(this, arguments));
	    }
	
	    _createClass(WhatsAPulse, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "flex flex-column align-center px4" },
	                _react2.default.createElement(
	                    "h2",
	                    { className: "my4 text-brand" },
	                    "Help everyone on your team stay in sync with your data."
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "mx4" },
	                    _react2.default.createElement(_reactRetinaImage2.default, {
	                        width: 574,
	                        src: "app/assets/img/pulse_empty_illustration.png",
	                        forceOriginalDimensions: false
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "h3 my3 text-centered text-grey-2 text-bold", style: { maxWidth: "500px" } },
	                    "Pulses let you send data from Metabase to email or Slack on the schedule of your choice."
	                ),
	                this.props.button
	            );
	        }
	    }]);
	
	    return WhatsAPulse;
	}(_react.Component), _class.propTypes = {
	    button: _propTypes2.default.object
	}, _temp);
	WhatsAPulse.displayName = "WhatsAPulse";
	exports.default = WhatsAPulse;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _CheckBox = __webpack_require__(1004);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeleteModalWithConfirm = (_temp = _class = function (_Component) {
	    _inherits(DeleteModalWithConfirm, _Component);
	
	    function DeleteModalWithConfirm(props, context) {
	        _classCallCheck(this, DeleteModalWithConfirm);
	
	        var _this = _possibleConstructorReturn(this, (DeleteModalWithConfirm.__proto__ || Object.getPrototypeOf(DeleteModalWithConfirm)).call(this, props, context));
	
	        _this.state = {
	            checked: {}
	        };
	
	        _underscore2.default.bindAll(_this, "onDelete");
	        return _this;
	    }
	
	    _createClass(DeleteModalWithConfirm, [{
	        key: "onDelete",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.onDelete();
	
	                            case 2:
	                                this.props.onClose();
	
	                            case 3:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function onDelete() {
	                return _ref.apply(this, arguments);
	            }
	
	            return onDelete;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                objectName = _props.objectName,
	                objectType = _props.objectType,
	                confirmItems = _props.confirmItems;
	            var checked = this.state.checked;
	
	            var confirmed = confirmItems.reduce(function (acc, item, index) {
	                return acc && checked[index];
	            }, true);
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    title: "Delete \"" + objectName + "\"?",
	                    onClose: this.props.onClose
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "px4" },
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        confirmItems.map(function (item, index) {
	                            return _react2.default.createElement(
	                                "li",
	                                { key: index, className: "pb2 mb2 border-row-divider flex align-center" },
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "text-error" },
	                                    _react2.default.createElement(_CheckBox2.default, {
	                                        checkColor: "currentColor", borderColor: checked[index] ? "currentColor" : undefined, size: 20,
	                                        checked: checked[index],
	                                        onChange: function onChange(e) {
	                                            return _this2.setState({ checked: _extends({}, checked, _defineProperty({}, index, e.target.checked)) });
	                                        }
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "ml2 h4" },
	                                    item
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "Form-actions ml-auto" },
	                    _react2.default.createElement(
	                        "button",
	                        { className: "Button", onClick: this.props.onClose },
	                        "Cancel"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        {
	                            className: (0, _classnames2.default)("Button ml2", { disabled: !confirmed, "Button--danger": confirmed }),
	                            onClick: this.onDelete
	                        },
	                        "Delete this ",
	                        objectType
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DeleteModalWithConfirm;
	}(_react.Component), _class.propTypes = {
	    objectName: _propTypes2.default.string.isRequired,
	    objectType: _propTypes2.default.string.isRequired,
	    confirmItems: _propTypes2.default.array.isRequired,
	    onClose: _propTypes2.default.func.isRequired,
	    onDelete: _propTypes2.default.func.isRequired
	}, _temp);
	DeleteModalWithConfirm.displayName = "DeleteModalWithConfirm";
	exports.default = DeleteModalWithConfirm;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.editPulseSelectors = exports.listPulseSelectors = undefined;
	
	var _reselect = __webpack_require__(1072);
	
	var pulsesSelector = function pulsesSelector(state) {
	    return state.pulse.pulses;
	};
	var pulseIdListSelector = function pulseIdListSelector(state) {
	    return state.pulse.pulseList;
	};
	
	var pulseListSelector = (0, _reselect.createSelector)([pulseIdListSelector, pulsesSelector], function (pulseIdList, pulses) {
	    return pulseIdList && pulseIdList.map(function (id) {
	        return pulses[id];
	    });
	});
	
	var editingPulseSelector = function editingPulseSelector(state) {
	    return state.pulse.editingPulse;
	};
	
	var cardsSelector = function cardsSelector(state) {
	    return state.pulse.cards;
	};
	var cardIdListSelector = function cardIdListSelector(state) {
	    return state.pulse.cardList;
	};
	
	var usersSelector = function usersSelector(state) {
	    return state.pulse.users;
	};
	
	var formInputSelector = function formInputSelector(state) {
	    return state.pulse.formInput;
	};
	
	var cardPreviewsSelector = function cardPreviewsSelector(state) {
	    return state.pulse.cardPreviews;
	};
	
	var cardListSelector = (0, _reselect.createSelector)([cardIdListSelector, cardsSelector], function (cardIdList, cards) {
	    return cardIdList && cardIdList.map(function (id) {
	        return cards[id];
	    });
	});
	
	var userListSelector = (0, _reselect.createSelector)([usersSelector], function (users) {
	    return Object.values(users);
	});
	
	var getPulseId = function getPulseId(state, props) {
	    return props.params.pulseId ? parseInt(props.params.pulseId) : null;
	};
	
	// LIST
	var listPulseSelectors = exports.listPulseSelectors = (0, _reselect.createSelector)([getPulseId, pulseListSelector, formInputSelector], function (pulseId, pulses, formInput) {
	    return { pulseId: pulseId, pulses: pulses, formInput: formInput };
	});
	
	// EDIT
	var editPulseSelectors = exports.editPulseSelectors = (0, _reselect.createSelector)([getPulseId, editingPulseSelector, cardsSelector, cardListSelector, cardPreviewsSelector, userListSelector, formInputSelector], function (pulseId, pulse, cards, cardList, cardPreviews, userList, formInput) {
	    return { pulseId: pulseId, pulse: pulse, cards: cards, cardList: cardList, cardPreviews: cardPreviews, userList: userList, formInput: formInput };
	});

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchPulseCardPreview = exports.fetchPulseFormInput = exports.fetchUsers = exports.fetchCards = exports.testPulse = exports.deletePulse = exports.saveEditingPulse = exports.savePulse = exports.updateEditingPulse = exports.setEditingPulse = exports.fetchPulses = exports.FETCH_PULSE_CARD_PREVIEW = exports.FETCH_PULSE_FORM_INPUT = exports.FETCH_USERS = exports.FETCH_CARDS = exports.TEST_PULSE = exports.DELETE_PULSE = exports.SAVE_EDITING_PULSE = exports.SAVE_PULSE = exports.UPDATE_EDITING_PULSE = exports.SET_EDITING_PULSE = exports.FETCH_PULSES = undefined;
	
	var _reduxActions = __webpack_require__(658);
	
	var _redux = __webpack_require__(657);
	
	var _normalizr = __webpack_require__(1111);
	
	var _services = __webpack_require__(857);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var card = new _normalizr.schema.Entity('card');
	var pulse = new _normalizr.schema.Entity('pulse');
	var user = new _normalizr.schema.Entity('user');
	
	var FETCH_PULSES = exports.FETCH_PULSES = 'FETCH_PULSES';
	var SET_EDITING_PULSE = exports.SET_EDITING_PULSE = 'SET_EDITING_PULSE';
	var UPDATE_EDITING_PULSE = exports.UPDATE_EDITING_PULSE = 'UPDATE_EDITING_PULSE';
	var SAVE_PULSE = exports.SAVE_PULSE = 'SAVE_PULSE';
	var SAVE_EDITING_PULSE = exports.SAVE_EDITING_PULSE = 'SAVE_EDITING_PULSE';
	var DELETE_PULSE = exports.DELETE_PULSE = 'DELETE_PULSE';
	var TEST_PULSE = exports.TEST_PULSE = 'TEST_PULSE';
	
	var FETCH_CARDS = exports.FETCH_CARDS = 'FETCH_CARDS';
	var FETCH_USERS = exports.FETCH_USERS = 'FETCH_USERS';
	var FETCH_PULSE_FORM_INPUT = exports.FETCH_PULSE_FORM_INPUT = 'FETCH_PULSE_FORM_INPUT';
	var FETCH_PULSE_CARD_PREVIEW = exports.FETCH_PULSE_CARD_PREVIEW = 'FETCH_PULSE_CARD_PREVIEW';
	
	var fetchPulses = exports.fetchPulses = (0, _redux.createThunkAction)(FETCH_PULSES, function () {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var pulses;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return _services.PulseApi.list();
	
	                        case 2:
	                            pulses = _context.sent;
	                            return _context.abrupt("return", (0, _normalizr.normalize)(pulses, [pulse]));
	
	                        case 4:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var setEditingPulse = exports.setEditingPulse = (0, _redux.createThunkAction)(SET_EDITING_PULSE, function (id) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (!(id != null)) {
	                                _context2.next = 9;
	                                break;
	                            }
	
	                            _context2.prev = 1;
	                            _context2.next = 4;
	                            return _services.PulseApi.get({ pulseId: id });
	
	                        case 4:
	                            return _context2.abrupt("return", _context2.sent);
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2["catch"](1);
	
	                        case 9:
	                            return _context2.abrupt("return", {
	                                name: null,
	                                cards: [],
	                                channels: [],
	                                skip_if_empty: false
	                            });
	
	                        case 10:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[1, 7]]);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	var updateEditingPulse = exports.updateEditingPulse = (0, _reduxActions.createAction)(UPDATE_EDITING_PULSE);
	
	var savePulse = exports.savePulse = (0, _redux.createThunkAction)(SAVE_PULSE, function (pulse) {
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.next = 2;
	                            return _services.PulseApi.update(pulse);
	
	                        case 2:
	                            return _context3.abrupt("return", _context3.sent);
	
	                        case 3:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	});
	
	var saveEditingPulse = exports.saveEditingPulse = (0, _redux.createThunkAction)(SAVE_EDITING_PULSE, function () {
	    return function () {
	        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
	            var _getState, editingPulse;
	
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            _getState = getState(), editingPulse = _getState.pulse.editingPulse;
	
	                            if (!(editingPulse.id != null)) {
	                                _context4.next = 7;
	                                break;
	                            }
	
	                            _context4.next = 4;
	                            return _services.PulseApi.update(editingPulse);
	
	                        case 4:
	                            return _context4.abrupt("return", _context4.sent);
	
	                        case 7:
	                            _context4.next = 9;
	                            return _services.PulseApi.create(editingPulse);
	
	                        case 9:
	                            return _context4.abrupt("return", _context4.sent);
	
	                        case 10:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, this);
	        }));
	
	        return function (_x7, _x8) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	});
	
	var deletePulse = exports.deletePulse = (0, _redux.createThunkAction)(DELETE_PULSE, function (id) {
	    return function () {
	        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            _context5.next = 2;
	                            return _services.PulseApi.delete({ pulseId: id });
	
	                        case 2:
	                            return _context5.abrupt("return", _context5.sent);
	
	                        case 3:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, this);
	        }));
	
	        return function (_x9, _x10) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	});
	
	var testPulse = exports.testPulse = (0, _redux.createThunkAction)(TEST_PULSE, function (pulse) {
	    return function () {
	        var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            _context6.next = 2;
	                            return _services.PulseApi.test(pulse);
	
	                        case 2:
	                            return _context6.abrupt("return", _context6.sent);
	
	                        case 3:
	                        case "end":
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, this);
	        }));
	
	        return function (_x11, _x12) {
	            return _ref6.apply(this, arguments);
	        };
	    }();
	});
	
	// NOTE: duplicated from dashboards/actions.js
	var fetchCards = exports.fetchCards = (0, _redux.createThunkAction)(FETCH_CARDS, function () {
	    var filterMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "all";
	
	    return function () {
	        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
	            var cards;
	            return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            _context7.next = 2;
	                            return _services.CardApi.list({ f: filterMode });
	
	                        case 2:
	                            cards = _context7.sent;
	                            return _context7.abrupt("return", (0, _normalizr.normalize)(cards, [card]));
	
	                        case 4:
	                        case "end":
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, this);
	        }));
	
	        return function (_x14, _x15) {
	            return _ref7.apply(this, arguments);
	        };
	    }();
	});
	
	// NOTE: duplicated from admin/people/actions.js
	var fetchUsers = exports.fetchUsers = (0, _redux.createThunkAction)(FETCH_USERS, function () {
	    return function () {
	        var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(dispatch, getState) {
	            var users;
	            return regeneratorRuntime.wrap(function _callee8$(_context8) {
	                while (1) {
	                    switch (_context8.prev = _context8.next) {
	                        case 0:
	                            _context8.next = 2;
	                            return _services.UserApi.list();
	
	                        case 2:
	                            users = _context8.sent;
	                            return _context8.abrupt("return", (0, _normalizr.normalize)(users, [user]));
	
	                        case 4:
	                        case "end":
	                            return _context8.stop();
	                    }
	                }
	            }, _callee8, this);
	        }));
	
	        return function (_x16, _x17) {
	            return _ref8.apply(this, arguments);
	        };
	    }();
	});
	
	var fetchPulseFormInput = exports.fetchPulseFormInput = (0, _redux.createThunkAction)(FETCH_PULSE_FORM_INPUT, function (id) {
	    return function () {
	        var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee9$(_context9) {
	                while (1) {
	                    switch (_context9.prev = _context9.next) {
	                        case 0:
	                            _context9.next = 2;
	                            return _services.PulseApi.form_input();
	
	                        case 2:
	                            return _context9.abrupt("return", _context9.sent);
	
	                        case 3:
	                        case "end":
	                            return _context9.stop();
	                    }
	                }
	            }, _callee9, this);
	        }));
	
	        return function (_x18, _x19) {
	            return _ref9.apply(this, arguments);
	        };
	    }();
	});
	
	var fetchPulseCardPreview = exports.fetchPulseCardPreview = (0, _redux.createThunkAction)(FETCH_PULSE_CARD_PREVIEW, function (id) {
	    return function () {
	        var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                while (1) {
	                    switch (_context10.prev = _context10.next) {
	                        case 0:
	                            _context10.next = 2;
	                            return _services.PulseApi.preview_card({ id: id });
	
	                        case 2:
	                            return _context10.abrupt("return", _context10.sent);
	
	                        case 3:
	                        case "end":
	                            return _context10.stop();
	                    }
	                }
	            }, _callee10, this);
	        }));
	
	        return function (_x20, _x21) {
	            return _ref10.apply(this, arguments);
	        };
	    }();
	});

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _PulseList = __webpack_require__(1703);
	
	var _PulseList2 = _interopRequireDefault(_PulseList);
	
	var _selectors = __webpack_require__(1700);
	
	var _actions = __webpack_require__(1701);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return _extends({}, (0, _selectors.listPulseSelectors)(state, props), {
	        user: state.currentUser
	    });
	};
	
	var mapDispatchToProps = {
	    fetchPulses: _actions.fetchPulses,
	    fetchPulseFormInput: _actions.fetchPulseFormInput,
	    savePulse: _actions.savePulse,
	    onChangeLocation: _reactRouterRedux.push
	};
	
	var PulseListApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(PulseListApp, _Component);
	
	    function PulseListApp() {
	        _classCallCheck(this, PulseListApp);
	
	        return _possibleConstructorReturn(this, (PulseListApp.__proto__ || Object.getPrototypeOf(PulseListApp)).apply(this, arguments));
	    }
	
	    _createClass(PulseListApp, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_PulseList2.default, this.props);
	        }
	    }]);
	
	    return PulseListApp;
	}(_react.Component)) || _class);
	PulseListApp.displayName = "PulseListApp";
	exports.default = PulseListApp;

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PulseListItem = __webpack_require__(1704);
	
	var _PulseListItem2 = _interopRequireDefault(_PulseListItem);
	
	var _WhatsAPulse = __webpack_require__(1698);
	
	var _WhatsAPulse2 = _interopRequireDefault(_WhatsAPulse);
	
	var _SetupModal = __webpack_require__(1706);
	
	var _SetupModal2 = _interopRequireDefault(_SetupModal);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PulseList = (_temp = _class = function (_Component) {
	    _inherits(PulseList, _Component);
	
	    function PulseList(props, context) {
	        _classCallCheck(this, PulseList);
	
	        var _this = _possibleConstructorReturn(this, (PulseList.__proto__ || Object.getPrototypeOf(PulseList)).call(this, props, context));
	
	        _this.state = {
	            showSetupModal: false
	        };
	
	        _underscore2.default.bindAll(_this, "create");
	        return _this;
	    }
	
	    _createClass(PulseList, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.props.fetchPulses();
	            this.props.fetchPulseFormInput();
	        }
	    }, {
	        key: "create",
	        value: function create() {
	            var hasConfiguredChannel = !this.props.formInput.channels || _underscore2.default.some(Object.values(this.props.formInput.channels), function (c) {
	                return c.configured;
	            });
	            if (hasConfiguredChannel) {
	                this.props.onChangeLocation("/pulse/create");
	            } else {
	                this.setState({ showSetupModal: true });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                pulses = _props.pulses,
	                user = _props.user;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "PulseList pt3" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "border-bottom mb2" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wrapper wrapper--trim flex align-center mb2" },
	                        _react2.default.createElement(
	                            "h1",
	                            null,
	                            "Pulses"
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { onClick: this.create, className: "PulseButton Button flex-align-right" },
	                            "Create a pulse"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !pulses },
	                    function () {
	                        return pulses.length > 0 ? _react2.default.createElement(
	                            "ul",
	                            { className: "wrapper wrapper--trim" },
	                            pulses.slice().sort(function (a, b) {
	                                return b.created_at - a.created_at;
	                            }).map(function (pulse) {
	                                return _react2.default.createElement(
	                                    "li",
	                                    { key: pulse.id },
	                                    _react2.default.createElement(_PulseListItem2.default, {
	                                        scrollTo: pulse.id === _this2.props.pulseId,
	                                        pulse: pulse,
	                                        user: user,
	                                        formInput: _this2.props.formInput,
	                                        savePulse: _this2.props.savePulse
	                                    })
	                                );
	                            })
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: "mt4 ml-auto mr-auto" },
	                            _react2.default.createElement(_WhatsAPulse2.default, {
	                                button: _react2.default.createElement(
	                                    "a",
	                                    { onClick: _this2.create, className: "Button Button--primary" },
	                                    "Create a pulse"
	                                )
	                            })
	                        );
	                    }
	                ),
	                _react2.default.createElement(
	                    _Modal2.default,
	                    { isOpen: this.state.showSetupModal },
	                    _react2.default.createElement(_SetupModal2.default, {
	                        user: user,
	                        onClose: function onClose() {
	                            return _this2.setState({ showSetupModal: false });
	                        },
	                        onChangeLocation: this.props.onChangeLocation
	                    })
	                )
	            );
	        }
	    }]);
	
	    return PulseList;
	}(_react.Component), _class.propTypes = {}, _class.defaultProps = {}, _temp);
	PulseList.displayName = "PulseList";
	exports.default = PulseList;

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _PulseListChannel = __webpack_require__(1705);
	
	var _PulseListChannel2 = _interopRequireDefault(_PulseListChannel);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PulseListItem = (_temp = _class = function (_Component) {
	    _inherits(PulseListItem, _Component);
	
	    function PulseListItem() {
	        _classCallCheck(this, PulseListItem);
	
	        return _possibleConstructorReturn(this, (PulseListItem.__proto__ || Object.getPrototypeOf(PulseListItem)).apply(this, arguments));
	    }
	
	    _createClass(PulseListItem, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            if (this.props.scrollTo) {
	                var element = _reactDom2.default.findDOMNode(this.refs.pulseListItem);
	                element.scrollIntoView(true);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                pulse = _props.pulse,
	                formInput = _props.formInput,
	                user = _props.user;
	
	
	            return _react2.default.createElement(
	                "div",
	                { ref: "pulseListItem", className: (0, _classnames2.default)("PulseListItem bordered rounded mb2 pt3", { "PulseListItem--focused": this.props.scrollTo }) },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex px4 mb2" },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "h2",
	                            { className: "mb1" },
	                            pulse.name
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "Pulse by ",
	                            _react2.default.createElement(
	                                "span",
	                                { className: "text-bold" },
	                                pulse.creator && pulse.creator.common_name
	                            )
	                        )
	                    ),
	                    !pulse.read_only && _react2.default.createElement(
	                        "div",
	                        { className: "flex-align-right" },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/pulse/" + pulse.id, className: "PulseEditButton PulseButton Button no-decoration text-bold" },
	                            "Edit"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "ol",
	                    { className: "mb2 px4 flex flex-wrap" },
	                    pulse.cards.map(function (card, index) {
	                        return _react2.default.createElement(
	                            "li",
	                            { key: index, className: "mr1 mb1" },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: Urls.question(card.id), className: "Button" },
	                                card.name
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "border-top px4 bg-grey-0" },
	                    pulse.channels.filter(function (channel) {
	                        return channel.enabled;
	                    }).map(function (channel) {
	                        return _react2.default.createElement(
	                            "li",
	                            { key: channel.id, className: "border-row-divider" },
	                            _react2.default.createElement(_PulseListChannel2.default, {
	                                pulse: pulse,
	                                channel: channel,
	                                channelSpec: formInput.channels && formInput.channels[channel.channel_type],
	                                user: user,
	                                savePulse: _this2.props.savePulse
	                            })
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return PulseListItem;
	}(_react.Component), _class.propTypes = {
	    pulse: _propTypes2.default.object.isRequired,
	    formInput: _propTypes2.default.object.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    scrollTo: _propTypes2.default.bool.isRequired,
	    savePulse: _propTypes2.default.func.isRequired
	}, _temp);
	PulseListItem.displayName = "PulseListItem";
	exports.default = PulseListItem;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _inflection = __webpack_require__(520);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PulseListChannel = (_temp = _class = function (_Component) {
	    _inherits(PulseListChannel, _Component);
	
	    function PulseListChannel(props, context) {
	        _classCallCheck(this, PulseListChannel);
	
	        var _this = _possibleConstructorReturn(this, (PulseListChannel.__proto__ || Object.getPrototypeOf(PulseListChannel)).call(this, props, context));
	
	        _underscore2.default.bindAll(_this, "subscribe", "unsubscribe");
	        return _this;
	    }
	
	    _createClass(PulseListChannel, [{
	        key: "subscribe",
	        value: function subscribe() {
	            var _props = this.props,
	                pulse = _props.pulse,
	                channel = _props.channel,
	                user = _props.user;
	
	            this.props.savePulse(_extends({}, pulse, {
	                channels: pulse.channels.map(function (c) {
	                    return c !== channel ? c : _extends({}, c, { recipients: [].concat(_toConsumableArray(c.recipients), [user]) });
	                })
	            }));
	        }
	    }, {
	        key: "unsubscribe",
	        value: function unsubscribe() {
	            var _props2 = this.props,
	                pulse = _props2.pulse,
	                channel = _props2.channel,
	                user = _props2.user;
	
	            this.props.savePulse(_extends({}, pulse, {
	                channels: pulse.channels.map(function (c) {
	                    return c !== channel ? c : _extends({}, c, { recipients: c.recipients.filter(function (r) {
	                            return r.id !== user.id;
	                        }) });
	                })
	            }));
	        }
	    }, {
	        key: "renderChannelSchedule",
	        value: function renderChannelSchedule() {
	            var _props3 = this.props,
	                channel = _props3.channel,
	                channelSpec = _props3.channelSpec;
	
	
	            var channelIcon = null;
	            var channelVerb = channelSpec && channelSpec.displayName || channel.channel_type;
	            var channelSchedule = channel.schedule_type;
	            var channelTarget = channel.recipients && channel.recipients.length + " " + (0, _inflection.inflect)("people", channel.recipients.length);
	
	            if (channel.channel_type === "email") {
	                channelIcon = "mail";
	                channelVerb = "Emailed";
	            } else if (channel.channel_type === "slack") {
	                channelIcon = "slack";
	                channelVerb = "Slack'd";
	                // Address #5799 where `details` object is missing for some reason
	                channelTarget = channel.details ? channel.details.channel : "No channel";
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "h4 text-grey-4 py2 flex align-center" },
	                channelIcon && _react2.default.createElement(_Icon2.default, { className: "mr1", name: channelIcon, size: 24 }),
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    channelVerb + " ",
	                    _react2.default.createElement(
	                        "strong",
	                        null,
	                        channelSchedule
	                    ),
	                    channelTarget && _react2.default.createElement(
	                        "span",
	                        null,
	                        " to ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            channelTarget
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props4 = this.props,
	                pulse = _props4.pulse,
	                channel = _props4.channel,
	                channelSpec = _props4.channelSpec,
	                user = _props4.user;
	
	
	            var subscribable = channelSpec && channelSpec.allows_recipients;
	            var subscribed = false;
	            if (subscribable) {
	                subscribed = _underscore2.default.any(channel.recipients, function (r) {
	                    return r.id === user.id;
	                });
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "py2 flex align-center" },
	                this.renderChannelSchedule(),
	                subscribable && _react2.default.createElement(
	                    "div",
	                    { className: "flex-align-right" },
	                    subscribed ? _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center rounded bg-green text-white text-bold" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "pl2" },
	                            "You get this ",
	                            channel.channel_type
	                        ),
	                        _react2.default.createElement(_Icon2.default, { className: "p2 text-grey-1 text-white-hover cursor-pointer", name: "close", size: 12, onClick: this.unsubscribe })
	                    ) : !pulse.read_only ? _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center rounded bordered bg-white text-default text-bold cursor-pointer", onClick: this.subscribe },
	                        _react2.default.createElement(_Icon2.default, { className: "p2", name: "add", size: 12 }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "pr2" },
	                            "Get this ",
	                            channel.channel_type
	                        )
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return PulseListChannel;
	}(_react.Component), _class.propTypes = {
	    pulse: _propTypes2.default.object.isRequired,
	    channel: _propTypes2.default.object.isRequired,
	    channelSpec: _propTypes2.default.object,
	    user: _propTypes2.default.object.isRequired,
	    savePulse: _propTypes2.default.func.isRequired
	}, _temp);
	PulseListChannel.displayName = "PulseListChannel";
	exports.default = PulseListChannel;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SetupMessage = __webpack_require__(1694);
	
	var _SetupMessage2 = _interopRequireDefault(_SetupMessage);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SetupModal = (_temp = _class = function (_Component) {
	    _inherits(SetupModal, _Component);
	
	    function SetupModal() {
	        _classCallCheck(this, SetupModal);
	
	        return _possibleConstructorReturn(this, (SetupModal.__proto__ || Object.getPrototypeOf(SetupModal)).apply(this, arguments));
	    }
	
	    _createClass(SetupModal, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    onClose: this.props.onClose,
	                    title: "To send pulses, " + (this.props.user.is_superuser ? "you'll need" : "an admin needs") + " to set up email or Slack integration."
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "ml-auto mb4 mr4" },
	                    _react2.default.createElement(_SetupMessage2.default, { user: this.props.user })
	                )
	            );
	        }
	    }]);
	
	    return SetupModal;
	}(_react.Component), _class.propTypes = {
	    onClose: _propTypes2.default.func.isRequired,
	    user: _propTypes2.default.object.isRequired
	}, _temp);
	SetupModal.displayName = "SetupModal";
	exports.default = SetupModal;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(467);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _table = __webpack_require__(871);
	
	var _QueryBuilderTutorial = __webpack_require__(1708);
	
	var _QueryBuilderTutorial2 = _interopRequireDefault(_QueryBuilderTutorial);
	
	var _QueryHeader = __webpack_require__(1715);
	
	var _QueryHeader2 = _interopRequireDefault(_QueryHeader);
	
	var _GuiQueryEditor = __webpack_require__(1728);
	
	var _GuiQueryEditor2 = _interopRequireDefault(_GuiQueryEditor);
	
	var _NativeQueryEditor = __webpack_require__(1740);
	
	var _NativeQueryEditor2 = _interopRequireDefault(_NativeQueryEditor);
	
	var _QueryVisualization = __webpack_require__(1754);
	
	var _QueryVisualization2 = _interopRequireDefault(_QueryVisualization);
	
	var _DataReference = __webpack_require__(1763);
	
	var _DataReference2 = _interopRequireDefault(_DataReference);
	
	var _TagEditorSidebar = __webpack_require__(1776);
	
	var _TagEditorSidebar2 = _interopRequireDefault(_TagEditorSidebar);
	
	var _SavedQuestionIntroModal = __webpack_require__(1780);
	
	var _SavedQuestionIntroModal2 = _interopRequireDefault(_SavedQuestionIntroModal);
	
	var _ActionsWidget = __webpack_require__(1781);
	
	var _ActionsWidget2 = _interopRequireDefault(_ActionsWidget);
	
	var _Title = __webpack_require__(1538);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _selectors = __webpack_require__(1071);
	
	var _metadata = __webpack_require__(1073);
	
	var _user = __webpack_require__(1127);
	
	var _actions = __webpack_require__(863);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _services = __webpack_require__(857);
	
	var _NativeQuery = __webpack_require__(954);
	
	var _NativeQuery2 = _interopRequireDefault(_NativeQuery);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function autocompleteResults(card, prefix) {
	    var databaseId = card && card.dataset_query && card.dataset_query.database;
	    var apiCall = _services.MetabaseApi.db_autocomplete_suggestions({
	        dbId: databaseId,
	        prefix: prefix
	    });
	    return apiCall;
	}
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        isAdmin: (0, _user.getUserIsAdmin)(state, props),
	        fromUrl: props.location.query.from,
	
	        question: (0, _selectors.getQuestion)(state),
	        query: (0, _selectors.getQuery)(state),
	
	        mode: (0, _selectors.getMode)(state),
	
	        card: (0, _selectors.getCard)(state),
	        originalCard: (0, _selectors.getOriginalCard)(state),
	        originalQuestion: (0, _selectors.getOriginalQuestion)(state),
	        lastRunCard: (0, _selectors.getLastRunCard)(state),
	
	        parameterValues: (0, _selectors.getParameterValues)(state),
	
	        databases: (0, _metadata.getDatabasesList)(state),
	        nativeDatabases: (0, _selectors.getNativeDatabases)(state),
	        tables: (0, _selectors.getTables)(state),
	        tableMetadata: (0, _selectors.getTableMetadata)(state),
	        metadata: (0, _metadata.getMetadata)(state),
	
	        tableForeignKeys: (0, _selectors.getTableForeignKeys)(state),
	        tableForeignKeyReferences: (0, _selectors.getTableForeignKeyReferences)(state),
	
	        result: (0, _selectors.getQueryResult)(state),
	        results: (0, _selectors.getQueryResults)(state),
	
	        isDirty: (0, _selectors.getIsDirty)(state),
	        isNew: (0, _selectors.getIsNew)(state),
	        isObjectDetail: (0, _selectors.getIsObjectDetail)(state),
	
	        uiControls: (0, _selectors.getUiControls)(state),
	        parameters: (0, _selectors.getParameters)(state),
	        databaseFields: (0, _selectors.getDatabaseFields)(state),
	        sampleDatasetId: (0, _selectors.getSampleDatasetId)(state),
	
	        isShowingDataReference: state.qb.uiControls.isShowingDataReference,
	        isShowingTutorial: state.qb.uiControls.isShowingTutorial,
	        isEditing: state.qb.uiControls.isEditing,
	        isRunning: state.qb.uiControls.isRunning,
	        isRunnable: (0, _selectors.getIsRunnable)(state),
	        isResultDirty: (0, _selectors.getIsResultDirty)(state),
	
	        loadTableAndForeignKeysFn: _table.loadTableAndForeignKeys,
	        autocompleteResultsFn: function autocompleteResultsFn(prefix) {
	            return autocompleteResults(state.qb.card, prefix);
	        },
	        instanceSettings: (0, _selectors.getSettings)(state)
	    };
	};
	
	var getURL = function getURL(location) {
	    return location.pathname + location.search + location.hash;
	};
	
	var mapDispatchToProps = _extends({}, actions, {
	    onChangeLocation: _reactRouterRedux.push
	});
	
	var QueryBuilder = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _Title2.default)(function (_ref) {
	    var card = _ref.card;
	    return card && card.name || "Question";
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(QueryBuilder, _Component);
	
	    function QueryBuilder(props, context) {
	        _classCallCheck(this, QueryBuilder);
	
	        // TODO: React tells us that forceUpdate() is not the best thing to use, so ideally we can find a different way to trigger this
	        var _this = _possibleConstructorReturn(this, (QueryBuilder.__proto__ || Object.getPrototypeOf(QueryBuilder)).call(this, props, context));
	
	        _this.handleResize = function (e) {
	            _this.forceUpdateDebounced();
	            var viz = _reactDom2.default.findDOMNode(_this.refs.viz);
	            if (viz) {
	                viz.style.opacity = 0.2;
	            }
	        };
	
	        _this.forceUpdateDebounced = _underscore2.default.debounce(_this.forceUpdate.bind(_this), 400);
	        return _this;
	    }
	
	    _createClass(QueryBuilder, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.initializeQB(this.props.location, this.props.params);
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            window.addEventListener("resize", this.handleResize);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.uiControls.isShowingDataReference !== this.props.uiControls.isShowingDataReference || nextProps.uiControls.isShowingTemplateTagsEditor !== this.props.uiControls.isShowingTemplateTagsEditor) {
	                // when the data reference is toggled we need to trigger a rerender after a short delay in order to
	                // ensure that some components are updated after the animation completes (e.g. card visualization)
	                window.setTimeout(this.forceUpdateDebounced, 300);
	            }
	
	            if (nextProps.location.action === "POP" && getURL(nextProps.location) !== getURL(this.props.location)) {
	                this.props.popState(nextProps.location);
	            } else if (this.props.location.hash !== "#?tutorial" && nextProps.location.hash === "#?tutorial") {
	                this.props.initializeQB(nextProps.location, nextProps.params);
	            } else if (getURL(nextProps.location) === "/question" && getURL(this.props.location) !== "/question") {
	                this.props.initializeQB(nextProps.location, nextProps.params);
	            }
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var viz = _reactDom2.default.findDOMNode(this.refs.viz);
	            if (viz) {
	                viz.style.opacity = 1.0;
	            }
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            // cancel the query if one is running
	            this.props.cancelQuery();
	
	            window.removeEventListener("resize", this.handleResize);
	        }
	
	        // When the window is resized we need to re-render, mainly so that our visualization pane updates
	        // Debounce the function to improve resizing performance.
	
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "flex-full flex relative" },
	                _react2.default.createElement(LegacyQueryBuilder, this.props)
	            );
	        }
	    }]);
	
	    return QueryBuilder;
	}(_react.Component)) || _class) || _class);
	QueryBuilder.displayName = "QueryBuilder";
	exports.default = QueryBuilder;
	
	var LegacyQueryBuilder = function (_Component2) {
	    _inherits(LegacyQueryBuilder, _Component2);
	
	    function LegacyQueryBuilder() {
	        _classCallCheck(this, LegacyQueryBuilder);
	
	        return _possibleConstructorReturn(this, (LegacyQueryBuilder.__proto__ || Object.getPrototypeOf(LegacyQueryBuilder)).apply(this, arguments));
	    }
	
	    _createClass(LegacyQueryBuilder, [{
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                query = _props.query,
	                card = _props.card,
	                isDirty = _props.isDirty,
	                databases = _props.databases,
	                uiControls = _props.uiControls,
	                mode = _props.mode;
	
	            // if we don't have a card at all or no databases then we are initializing, so keep it simple
	
	            if (!card || !databases) {
	                return _react2.default.createElement("div", null);
	            }
	
	            var showDrawer = uiControls.isShowingDataReference || uiControls.isShowingTemplateTagsEditor;
	            var ModeFooter = mode && mode.ModeFooter;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex-full relative" },
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)("QueryBuilder flex flex-column bg-white spread", { "QueryBuilder--showSideDrawer": showDrawer }) },
	                    _react2.default.createElement(
	                        "div",
	                        { id: "react_qb_header" },
	                        _react2.default.createElement(_QueryHeader2.default, this.props)
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { id: "react_qb_editor", className: "z2 hide sm-show" },
	                        query instanceof _NativeQuery2.default ? _react2.default.createElement(_NativeQueryEditor2.default, _extends({}, this.props, {
	                            isOpen: !card.dataset_query.native.query || isDirty,
	                            datasetQuery: card && card.dataset_query
	                        })) : query instanceof _StructuredQuery2.default ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper" },
	                            _react2.default.createElement(_GuiQueryEditor2.default, _extends({}, this.props, {
	                                datasetQuery: card && card.dataset_query
	                            }))
	                        ) : null
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { ref: "viz", id: "react_qb_viz", className: "flex z1",
	                            style: { "transition": "opacity 0.25s ease-in-out" } },
	                        _react2.default.createElement(_QueryVisualization2.default, _extends({}, this.props, { className: "full wrapper mb2 z1" }))
	                    ),
	                    ModeFooter && _react2.default.createElement(ModeFooter, _extends({}, this.props, { className: "flex-no-shrink" }))
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)("SideDrawer hide sm-show", { "SideDrawer--show": showDrawer }) },
	                    uiControls.isShowingDataReference && _react2.default.createElement(_DataReference2.default, _extends({}, this.props, { onClose: function onClose() {
	                            return _this3.props.toggleDataReference();
	                        } })),
	                    uiControls.isShowingTemplateTagsEditor && query instanceof _NativeQuery2.default && _react2.default.createElement(_TagEditorSidebar2.default, _extends({}, this.props, { onClose: function onClose() {
	                            return _this3.props.toggleTemplateTagsEditor();
	                        } }))
	                ),
	                uiControls.isShowingTutorial && _react2.default.createElement(_QueryBuilderTutorial2.default, { onClose: function onClose() {
	                        return _this3.props.closeQbTutorial();
	                    } }),
	                uiControls.isShowingNewbModal && _react2.default.createElement(_SavedQuestionIntroModal2.default, { onClose: function onClose() {
	                        return _this3.props.closeQbNewbModal();
	                    } }),
	                _react2.default.createElement(_ActionsWidget2.default, _extends({}, this.props, { className: "z2 absolute bottom right" }))
	            );
	        }
	    }]);
	
	    return LegacyQueryBuilder;
	}(_react.Component);
	
	LegacyQueryBuilder.displayName = "LegacyQueryBuilder";

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tutorial = __webpack_require__(1709);
	
	var _Tutorial2 = _interopRequireDefault(_Tutorial);
	
	var _reactRetinaImage = __webpack_require__(903);
	
	var _reactRetinaImage2 = _interopRequireDefault(_reactRetinaImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/display-name */
	
	var QUERY_BUILDER_STEPS = [{
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".GuiBuilder");
	    },
	    getModal: function getModal(props) {
	        return _react2.default.createElement(
	            "div",
	            { className: "text-centered" },
	            _react2.default.createElement(_reactRetinaImage2.default, { className: "mb2", forceOriginalDimensions: false, src: "app/assets/img/qb_tutorial/question_builder.png", width: 186 }),
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Welcome to the Query Builder!"
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "The Query Builder lets you assemble questions (or \"queries\") to ask about your data."
	            ),
	            _react2.default.createElement(
	                "a",
	                { className: "Button Button--primary", onClick: props.onNext },
	                "Tell me more"
	            )
	        );
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".GuiBuilder-data");
	    },
	    getModalTarget: function getModalTarget() {
	        return (0, _Tutorial.qs)(".GuiBuilder-data");
	    },
	    getModal: function getModal(props) {
	        return _react2.default.createElement(
	            "div",
	            { className: "text-centered" },
	            _react2.default.createElement(_reactRetinaImage2.default, { id: "QB-TutorialTableImg", className: "mb2", forceOriginalDimensions: false, src: "app/assets/img/qb_tutorial/table.png", width: 157 }),
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Start by picking the table with the data that you have a question about."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Go ahead and select the \"Orders\" table from the dropdown menu."
	            )
	        );
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qs)(".GuiBuilder-data a").contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".GuiBuilder-data");
	    },
	    getPageFlagTarget: function getPageFlagTarget() {
	        return (0, _Tutorial.qsWithContent)(".List-section-header", "Sample Dataset");
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qsWithContent)(".List-section-header", "Sample Dataset").contains(e.target);
	    },
	    optional: true
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".GuiBuilder-data");
	    },
	    getPageFlagTarget: function getPageFlagTarget() {
	        return (0, _Tutorial.qsWithContent)(".List-item", "Orders");
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qsWithContent)(".List-item > a", "Orders").contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".GuiBuilder-filtered-by");
	    },
	    getModalTarget: function getModalTarget() {
	        return (0, _Tutorial.qs)(".GuiBuilder-filtered-by");
	    },
	    getModal: function getModal(props) {
	        return _react2.default.createElement(
	            "div",
	            { className: "text-centered" },
	            _react2.default.createElement(_reactRetinaImage2.default, {
	                className: "mb2",
	                forceOriginalDimensions: false,
	                id: "QB-TutorialFunnelImg",
	                src: "app/assets/img/qb_tutorial/funnel.png",
	                width: 135
	            }),
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Filter your data to get just what you want."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Click the plus button and select the \"Created At\" field."
	            )
	        );
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qs)(".GuiBuilder-filtered-by a").contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".GuiBuilder-filtered-by");
	    },
	    getPageFlagTarget: function getPageFlagTarget() {
	        return (0, _Tutorial.qsWithContent)(".List-item", "Created At");
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qsWithContent)(".List-item > a", "Created At").contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".GuiBuilder-filtered-by");
	    },
	    getPageFlagText: function getPageFlagText() {
	        return "Here we can pick how many days we want to see data for, try 10";
	    },
	    getPageFlagTarget: function getPageFlagTarget() {
	        return (0, _Tutorial.qs)('[data-ui-tag="relative-date-input"]');
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qs)('[data-ui-tag="relative-date-input"]').contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".GuiBuilder-filtered-by");
	    },
	    getPageFlagTarget: function getPageFlagTarget() {
	        return (0, _Tutorial.qs)('[data-ui-tag="add-filter"]');
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qs)('[data-ui-tag="add-filter"]').contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".Query-section-aggregation");
	    },
	    getModalTarget: function getModalTarget() {
	        return (0, _Tutorial.qs)(".Query-section-aggregation");
	    },
	    getModal: function getModal(props) {
	        return _react2.default.createElement(
	            "div",
	            { className: "text-centered" },
	            _react2.default.createElement(_reactRetinaImage2.default, {
	                className: "mb2",
	                forceOriginalDimensions: false,
	                id: "QB-TutorialCalculatorImg",
	                src: "app/assets/img/qb_tutorial/calculator.png",
	                width: 115
	            }),
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Here's where you can choose to add or average your data, count the number of rows in the table, or just view the raw data."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Try it: click on ",
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Raw Data"
	                ),
	                " to change it to ",
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Count of rows"
	                ),
	                " so we can count how many orders there are in this table."
	            )
	        );
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qs)('.View-section-aggregation').contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".Query-section-aggregation");
	    },
	    getPageFlagTarget: function getPageFlagTarget() {
	        return (0, _Tutorial.qsWithContent)(".List-item", "Count of rows");
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qsWithContent)(".List-item > a", "Count of rows").contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".Query-section-breakout");
	    },
	    getModalTarget: function getModalTarget() {
	        return (0, _Tutorial.qs)(".Query-section-breakout");
	    },
	    getModal: function getModal(props) {
	        return _react2.default.createElement(
	            "div",
	            { className: "text-centered" },
	            _react2.default.createElement(_reactRetinaImage2.default, {
	                className: "mb2",
	                forceOriginalDimensions: false,
	                id: "QB-TutorialBananaImg",
	                src: "app/assets/img/qb_tutorial/banana.png",
	                width: 232
	            }),
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Add a grouping to break out your results by category, day, month, and more."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Let's do it: click on ",
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Add a grouping"
	                ),
	                ", and choose ",
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Created At: by Week"
	                ),
	                "."
	            )
	        );
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qs)('.Query-section-breakout').contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".Query-section-breakout");
	    },
	    getPageFlagTarget: function getPageFlagTarget() {
	        return (0, _Tutorial.qs)(".FieldList-grouping-trigger");
	    },
	    getPageFlagText: function getPageFlagText() {
	        return "Click on \"by day\" to change it to \"Week.\"";
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qs)(".FieldList-grouping-trigger").contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".Query-section-breakout");
	    },
	    getPageFlagTarget: function getPageFlagTarget() {
	        return (0, _Tutorial.qsWithContent)(".List-item", "Week");
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qsWithContent)(".List-item > a", "Week").contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".RunButton");
	    },
	    getModalTarget: function getModalTarget() {
	        return (0, _Tutorial.qs)(".RunButton");
	    },
	    getModal: function getModal(props) {
	        return _react2.default.createElement(
	            "div",
	            { className: "text-centered" },
	            _react2.default.createElement(_reactRetinaImage2.default, {
	                className: "mb2",
	                forceOriginalDimensions: false,
	                id: "QB-TutorialRocketImg",
	                src: "app/assets/img/qb_tutorial/rocket.png",
	                width: 217
	            }),
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Run Your Query."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "You're doing so well! Click ",
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Run query"
	                ),
	                " to get your results!"
	            )
	        );
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qs)(".RunButton").contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".VisualizationSettings");
	    },
	    getModalTarget: function getModalTarget() {
	        return (0, _Tutorial.qs)(".VisualizationSettings");
	    },
	    getModal: function getModal(props) {
	        return _react2.default.createElement(
	            "div",
	            { className: "text-centered" },
	            _react2.default.createElement(_reactRetinaImage2.default, {
	                className: "mb2",
	                forceOriginalDimensions: false,
	                id: "QB-TutorialChartImg",
	                src: "app/assets/img/qb_tutorial/chart.png",
	                width: 160
	            }),
	            _react2.default.createElement(
	                "h3",
	                null,
	                "You can view your results as a chart instead of a table."
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "Everbody likes charts! Click the ",
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Visualization"
	                ),
	                " dropdown and select ",
	                _react2.default.createElement(
	                    "strong",
	                    null,
	                    "Line"
	                ),
	                "."
	            )
	        );
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qs)(".VisualizationSettings a").contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return (0, _Tutorial.qs)(".VisualizationSettings");
	    },
	    getPageFlagTarget: function getPageFlagTarget() {
	        return (0, _Tutorial.qsWithContent)(".ChartType-popover li", "Line");
	    },
	    shouldAllowEvent: function shouldAllowEvent(e) {
	        return (0, _Tutorial.qsWithContent)(".ChartType-popover li", "Line").contains(e.target);
	    }
	}, {
	    getPortalTarget: function getPortalTarget() {
	        return true;
	    },
	    getModal: function getModal(props) {
	        return _react2.default.createElement(
	            "div",
	            { className: "text-centered" },
	            _react2.default.createElement(_reactRetinaImage2.default, {
	                className: "mb2",
	                forceOriginalDimensions: false,
	                id: "QB-TutorialBoatImg",
	                src: "app/assets/img/qb_tutorial/boat.png", width: 190
	            }),
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Well done!"
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "That's all! If you still have questions, check out our ",
	                _react2.default.createElement(
	                    "a",
	                    { className: "link", target: "_blank", href: "http://www.metabase.com/docs/latest/users-guide/start" },
	                    "User's Guide"
	                ),
	                ". Have fun exploring your data!"
	            ),
	            _react2.default.createElement(
	                "a",
	                { className: "Button Button--primary", onClick: props.onNext },
	                "Thanks!"
	            )
	        );
	    }
	}, {
	    getModalTarget: function getModalTarget() {
	        return (0, _Tutorial.qsWithContent)(".Header-buttonSection a", "Save");
	    },
	    getModal: function getModal(props) {
	        return _react2.default.createElement(
	            "div",
	            { className: "text-centered" },
	            _react2.default.createElement(
	                "h3",
	                null,
	                "Save Your Questions!"
	            ),
	            _react2.default.createElement(
	                "p",
	                null,
	                "By the way, you can save your questions so you can refer to them later. Saved Questions can also be put into dashboards or Pulses."
	            ),
	            _react2.default.createElement(
	                "a",
	                { className: "Button Button--primary", onClick: props.onClose },
	                "Sounds good"
	            )
	        );
	    }
	}];
	
	var QueryBuilderTutorial = function (_Component) {
	    _inherits(QueryBuilderTutorial, _Component);
	
	    function QueryBuilderTutorial() {
	        _classCallCheck(this, QueryBuilderTutorial);
	
	        return _possibleConstructorReturn(this, (QueryBuilderTutorial.__proto__ || Object.getPrototypeOf(QueryBuilderTutorial)).apply(this, arguments));
	    }
	
	    _createClass(QueryBuilderTutorial, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_Tutorial2.default, _extends({ steps: QUERY_BUILDER_STEPS }, this.props));
	        }
	    }]);
	
	    return QueryBuilderTutorial;
	}(_react.Component);
	
	QueryBuilderTutorial.displayName = "QueryBuilderTutorial";
	exports.default = QueryBuilderTutorial;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.qs = qs;
	exports.qsWithContent = qsWithContent;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Portal = __webpack_require__(1710);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _PageFlag = __webpack_require__(1711);
	
	var _PageFlag2 = _interopRequireDefault(_PageFlag);
	
	var _TutorialModal = __webpack_require__(1714);
	
	var _TutorialModal2 = _interopRequireDefault(_TutorialModal);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function qs(selector) {
	    return document.querySelector(selector);
	}
	
	function qsWithContent(selector, content) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var element = _step.value;
	
	            if (element.textContent === content) {
	                return element;
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	}
	
	var STEP_WARNING_TIMEOUT = 60 * 1000; // 60 seconds
	var STEP_SKIP_TIMEOUT = 500; // 500 ms
	
	var Tutorial = function (_Component) {
	    _inherits(Tutorial, _Component);
	
	    function Tutorial(props, context) {
	        _classCallCheck(this, Tutorial);
	
	        var _this = _possibleConstructorReturn(this, (Tutorial.__proto__ || Object.getPrototypeOf(Tutorial)).call(this, props, context));
	
	        _this.state = {
	            step: 0,
	            bouncePageFlag: false
	        };
	
	        _underscore2.default.bindAll(_this, "close", "next", "back", "nextModal", "backModal", "mouseEventInterceptHandler");
	        return _this;
	    }
	
	    _createClass(Tutorial, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            ["mousedown", "mouseup", "mousemove", "click"].forEach(function (event) {
	                document.addEventListener(event, _this2.mouseEventInterceptHandler, true);
	            });
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            var _this3 = this;
	
	            ["mousedown", "mouseup", "mousemove", "click"].forEach(function (event) {
	                document.removeEventListener(event, _this3.mouseEventInterceptHandler, true);
	            });
	        }
	    }, {
	        key: "mouseEventInterceptHandler",
	        value: function mouseEventInterceptHandler(e) {
	            var _this4 = this;
	
	            var step = this.props.steps[this.state.step];
	
	            // don't intercept if we've somehow gotten into a weird state
	            if (!step) {
	                return;
	            }
	
	            // don't intercept on the last step
	            if (this.state.step === this.props.steps.length - 1) {
	                return;
	            }
	
	            // don't intercept events within the modal screens
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = document.querySelectorAll(".TutorialModalContent")[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var modal = _step2.value;
	
	                    if (modal.contains(e.target)) {
	                        return;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            if (step.shouldAllowEvent) {
	                try {
	                    if (step.shouldAllowEvent(e)) {
	                        if (e.type === "click") {
	                            setTimeout(this.next, 100);
	                        }
	                        return;
	                    }
	                } catch (e) {}
	            }
	
	            if (e.type === "click" && this.refs.pageflag) {
	                this.setState({ bouncePageFlag: true });
	                setTimeout(function () {
	                    return _this4.setState({ bouncePageFlag: false });
	                }, 1500);
	            }
	
	            e.stopPropagation();
	            e.preventDefault();
	        }
	    }, {
	        key: "next",
	        value: function next() {
	            if (this.state.step + 1 === this.props.steps.length) {
	                this.close();
	                _analytics2.default.trackEvent('QueryBuilder', 'Tutorial Finish');
	            } else {
	                this.setStep(this.state.step + 1);
	            }
	        }
	    }, {
	        key: "back",
	        value: function back() {
	            this.setStep(Math.max(0, this.state.step - 1));
	        }
	    }, {
	        key: "nextModal",
	        value: function nextModal() {
	            var step = this.state.step;
	            while (++step < this.props.steps.length) {
	                if (this.props.steps[step].getModal) {
	                    this.setStep(step);
	                    return;
	                }
	            }
	            this.close();
	        }
	    }, {
	        key: "backModal",
	        value: function backModal() {
	            var step = this.state.step;
	            while (--step >= 0) {
	                if (this.props.steps[step].getModal) {
	                    this.setStep(step);
	                    return;
	                }
	            }
	            this.setStep(0);
	        }
	    }, {
	        key: "setStep",
	        value: function setStep(step) {
	            var _this5 = this;
	
	            if (this.state.stepTimeout != null) {
	                clearTimeout(this.state.stepTimeout);
	            }
	            if (this.state.skipTimeout != null) {
	                clearTimeout(this.state.skipTimeout);
	            }
	            this.setState({
	                step: step,
	                stepTimeout: setTimeout(function () {
	                    _this5.setState({ stepTimeout: null });
	                }, STEP_WARNING_TIMEOUT),
	                skipTimeout: setTimeout(function () {
	                    if (_this5.props.steps[step].optional && _this5.getTargets(_this5.props.steps[step]).missingTarget) {
	                        _this5.next();
	                    }
	                }, STEP_SKIP_TIMEOUT)
	            });
	            _analytics2.default.trackEvent('QueryBuilder', 'Tutorial Step', step);
	        }
	    }, {
	        key: "close",
	        value: function close() {
	            this.props.onClose();
	        }
	    }, {
	        key: "getTargets",
	        value: function getTargets(step) {
	            var missingTarget = false;
	
	            var pageFlagTarget = void 0;
	            if (step.getPageFlagTarget) {
	                try {
	                    pageFlagTarget = step.getPageFlagTarget();
	                } catch (e) {}
	                if (pageFlagTarget == undefined) {
	                    missingTarget = missingTarget || true;
	                }
	            }
	
	            var portalTarget = void 0;
	            if (step.getPortalTarget) {
	                try {
	                    portalTarget = step.getPortalTarget();
	                } catch (e) {}
	                if (portalTarget == undefined) {
	                    missingTarget = missingTarget || true;
	                }
	            }
	
	            var modalTarget = void 0;
	            if (step.getModalTarget) {
	                try {
	                    modalTarget = step.getModalTarget();
	                } catch (e) {}
	                if (modalTarget == undefined) {
	                    missingTarget = missingTarget || true;
	                }
	            }
	
	            return {
	                missingTarget: missingTarget,
	                pageFlagTarget: pageFlagTarget,
	                portalTarget: portalTarget,
	                modalTarget: modalTarget
	            };
	        }
	
	        // HACK: Ensure we render twice so that getTargets can get the rendered DOM elements
	
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps() {
	            this.setState({ rendered: false });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.componentDidUpdate();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            if (!this.state.rendered) {
	                this.setState({ rendered: true });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var step = this.props.steps[this.state.step];
	
	            if (!step) {
	                return null;
	            }
	
	            var _getTargets = this.getTargets(step),
	                missingTarget = _getTargets.missingTarget,
	                pageFlagTarget = _getTargets.pageFlagTarget,
	                portalTarget = _getTargets.portalTarget,
	                modalTarget = _getTargets.modalTarget;
	
	            if (missingTarget && this.state.stepTimeout === null) {
	                return _react2.default.createElement(
	                    _Modal2.default,
	                    { className: "Modal TutorialModal" },
	                    _react2.default.createElement(
	                        _TutorialModal2.default,
	                        {
	                            onBack: this.backModal,
	                            onClose: this.close
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "text-centered" },
	                            _react2.default.createElement(
	                                "h2",
	                                null,
	                                "\u200BWhoops!"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: "my2" },
	                                "Sorry, it looks like something went wrong. Please try restarting the tutorial in a minute."
	                            ),
	                            _react2.default.createElement(
	                                "button",
	                                { className: "Button Button--primary", onClick: this.close },
	                                "Okay"
	                            )
	                        )
	                    )
	                );
	            }
	
	            var modal = void 0;
	            if (step.getModal) {
	                var modalSteps = this.props.steps.filter(function (s) {
	                    return !!s.getModal;
	                });
	                var modalStepIndex = modalSteps.indexOf(step);
	                modal = _react2.default.createElement(
	                    _TutorialModal2.default,
	                    {
	                        modalStepIndex: modalStepIndex,
	                        modalStepCount: modalSteps.length,
	                        onBack: this.backModal,
	                        onClose: this.close
	                    },
	                    step.getModal({
	                        onNext: this.next,
	                        onClose: this.close
	                    })
	                );
	            }
	
	            var pageFlagText = void 0;
	            if (step.getPageFlagText) {
	                pageFlagText = step.getPageFlagText();
	            }
	
	            // only pass onClose to modal/popover if we're on the last step
	            var onClose = void 0;
	            if (this.state.step === this.props.steps.length - 1) {
	                onClose = this.close;
	            }
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_PageFlag2.default, { ref: "pageflag", className: "z5", target: pageFlagTarget, text: pageFlagText, bounce: this.state.bouncePageFlag }),
	                portalTarget && _react2.default.createElement(_Portal2.default, { className: "z2", target: portalTarget }),
	                _react2.default.createElement(
	                    _Modal2.default,
	                    { isOpen: !!(modal && !step.getModalTarget), style: { backgroundColor: "transparent" }, className: "Modal TutorialModal", onClose: onClose },
	                    modal
	                ),
	                _react2.default.createElement(
	                    _Popover2.default,
	                    { isOpen: !!(modal && step.getModalTarget && modalTarget), target: step.getModalTarget, targetOffsetY: 25, onClose: onClose, className: "TutorialModal" },
	                    modal
	                )
	            );
	        }
	    }]);
	
	    return Tutorial;
	}(_react.Component);
	
	Tutorial.displayName = "Tutorial";
	exports.default = Tutorial;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BodyComponent = __webpack_require__(1562);
	
	var _BodyComponent2 = _interopRequireDefault(_BodyComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = (0, _BodyComponent2.default)(_class = (_temp = _class2 = function (_Component) {
	    _inherits(Portal, _Component);
	
	    function Portal(props, context) {
	        _classCallCheck(this, Portal);
	
	        var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props, context));
	
	        _this.state = {
	            target: null,
	            position: { top: 0, left: 0, height: 0, width: 0 }
	        };
	        return _this;
	    }
	
	    _createClass(Portal, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.componentWillReceiveProps(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            if (newProps.target !== this.state.target) {
	                var target = newProps.target,
	                    padding = newProps.padding;
	
	                var position = void 0;
	                if (target === true) {
	                    position = {
	                        top: this.state.position.top + this.state.position.height / 2,
	                        left: this.state.position.left + this.state.position.width / 2,
	                        width: -padding * 2,
	                        height: -padding * 2
	                    };
	                } else if (target) {
	                    position = target.getBoundingClientRect();
	                }
	                this.setState({ target: target, position: position || { top: 0, left: 0, height: 0, width: 0 } });
	            }
	        }
	    }, {
	        key: "getStyles",
	        value: function getStyles(position) {
	            var padding = this.props.padding;
	
	            return {
	                position: "absolute",
	                boxSizing: "content-box",
	                border: "10000px solid rgba(0,0,0,0.70)",
	                boxShadow: "inset 0px 0px 8px rgba(0,0,0,0.25)",
	                transform: "translate(-10000px, -10000px)",
	                borderRadius: "10010px",
	                pointerEvents: "none",
	                transition: position.width < 0 ? "all 0.25s ease-in-out" : "all 0.5s ease-in-out",
	                top: position.top - padding,
	                left: position.left - padding,
	                width: position.width + 2 * padding,
	                height: position.height + 2 * padding
	            };
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (!this.props.target) {
	                return _react2.default.createElement("div", { className: "hide" });
	            }
	            return _react2.default.createElement(
	                "div",
	                { style: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, overflow: "hidden", pointerEvents: "none" } },
	                _react2.default.createElement("div", { style: this.getStyles(this.state.position) })
	            );
	        }
	    }]);
	
	    return Portal;
	}(_react.Component), _class2.defaultProps = {
	    padding: 10
	}, _temp)) || _class;
	
	Portal.displayName = "Portal";
	exports.default = Portal;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1712);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(924);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _BodyComponent = __webpack_require__(1562);
	
	var _BodyComponent2 = _interopRequireDefault(_BodyComponent);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageFlag = (0, _BodyComponent2.default)(_class = function (_Component) {
	    _inherits(PageFlag, _Component);
	
	    function PageFlag() {
	        _classCallCheck(this, PageFlag);
	
	        return _possibleConstructorReturn(this, (PageFlag.__proto__ || Object.getPrototypeOf(PageFlag)).apply(this, arguments));
	    }
	
	    _createClass(PageFlag, [{
	        key: "renderPageFlag",
	        value: function renderPageFlag() {
	            var position = this.props.target.getBoundingClientRect();
	            var isLarge = !!this.props.text;
	            var style = {
	                position: "absolute",
	                left: position.left + position.width,
	                top: position.top + position.height / 2 - (isLarge ? 21 : 12)
	            };
	            return _react2.default.createElement(
	                "div",
	                { key: "flag", className: (0, _classnames2.default)("PageFlag", { "PageFlag--large": isLarge, "bounce-left": this.props.bounce }), style: style },
	                this.props.text
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _reactAddonsCssTransitionGroup2.default,
	                { transitionName: "PageFlag", transitionEnterTimeout: 250, transitionLeaveTimeout: 250 },
	                this.props.target ? [this.renderPageFlag()] : []
	            );
	        }
	    }]);
	
	    return PageFlag;
	}(_react.Component)) || _class;
	
	PageFlag.displayName = "PageFlag";
	exports.default = PageFlag;

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1713 */,
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ENABLE_BACK_BUTTON = false; // disabled due to possibility of getting in inconsistent states
	
	var TutorialModal = function (_Component) {
	    _inherits(TutorialModal, _Component);
	
	    function TutorialModal() {
	        _classCallCheck(this, TutorialModal);
	
	        return _possibleConstructorReturn(this, (TutorialModal.__proto__ || Object.getPrototypeOf(TutorialModal)).apply(this, arguments));
	    }
	
	    _createClass(TutorialModal, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                modalStepIndex = _props.modalStepIndex,
	                modalStepCount = _props.modalStepCount;
	
	            var showStepCount = modalStepIndex != null;
	            var showBackButton = ENABLE_BACK_BUTTON && modalStepIndex > 0;
	            return _react2.default.createElement(
	                "div",
	                { className: "TutorialModalContent p2" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex" },
	                    _react2.default.createElement(
	                        "a",
	                        { className: "text-grey-4 p1 cursor-pointer flex-align-right", onClick: this.props.onClose },
	                        _react2.default.createElement(_Icon2.default, { name: "close", size: 16 })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "px4" },
	                    this.props.children
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex" },
	                    showBackButton && _react2.default.createElement(
	                        "a",
	                        { className: "text-grey-4 cursor-pointer", onClick: this.props.onBack },
	                        "back"
	                    ),
	                    showStepCount && _react2.default.createElement(
	                        "span",
	                        { className: "text-grey-4 flex-align-right" },
	                        modalStepIndex + 1,
	                        " of ",
	                        modalStepCount
	                    )
	                )
	            );
	        }
	    }]);
	
	    return TutorialModal;
	}(_react.Component);
	
	TutorialModal.displayName = "TutorialModal";
	exports.default = TutorialModal;

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _reactRedux = __webpack_require__(467);
	
	var _QueryModeButton = __webpack_require__(1716);
	
	var _QueryModeButton2 = _interopRequireDefault(_QueryModeButton);
	
	var _ActionButton = __webpack_require__(1213);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _AddToDashSelectDashModal = __webpack_require__(1717);
	
	var _AddToDashSelectDashModal2 = _interopRequireDefault(_AddToDashSelectDashModal);
	
	var _ButtonBar = __webpack_require__(1721);
	
	var _ButtonBar2 = _interopRequireDefault(_ButtonBar);
	
	var _HeaderBar = __webpack_require__(1722);
	
	var _HeaderBar2 = _interopRequireDefault(_HeaderBar);
	
	var _HistoryModal = __webpack_require__(1647);
	
	var _HistoryModal2 = _interopRequireDefault(_HistoryModal);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _QuestionSavedModal = __webpack_require__(1723);
	
	var _QuestionSavedModal2 = _interopRequireDefault(_QuestionSavedModal);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _MoveToCollection = __webpack_require__(1621);
	
	var _MoveToCollection2 = _interopRequireDefault(_MoveToCollection);
	
	var _ArchiveQuestionModal = __webpack_require__(1724);
	
	var _ArchiveQuestionModal2 = _interopRequireDefault(_ArchiveQuestionModal);
	
	var _SaveQuestionModal = __webpack_require__(1725);
	
	var _SaveQuestionModal2 = _interopRequireDefault(_SaveQuestionModal);
	
	var _requests = __webpack_require__(856);
	
	var _services = __webpack_require__(857);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _promise = __webpack_require__(1069);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _NativeQuery = __webpack_require__(954);
	
	var _NativeQuery2 = _interopRequireDefault(_NativeQuery);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = {
	    clearRequestState: _requests.clearRequestState
	};
	
	var ICON_SIZE = 16;
	
	var QueryHeader = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(QueryHeader, _Component);
	
	    function QueryHeader(props, context) {
	        _classCallCheck(this, QueryHeader);
	
	        var _this = _possibleConstructorReturn(this, (QueryHeader.__proto__ || Object.getPrototypeOf(QueryHeader)).call(this, props, context));
	
	        _this.onCloseModal = function () {
	            _this.setState({ modal: null });
	        };
	
	        _this.state = {
	            recentlySaved: null,
	            modal: null,
	            revisions: null
	        };
	
	        _underscore2.default.bindAll(_this, "resetStateOnTimeout", "onCreate", "onSave", "onBeginEditing", "onCancel", "onDelete", "onFollowBreadcrumb", "onToggleDataReference", "onFetchRevisions", "onRevertToRevision", "onRevertedRevision");
	        return _this;
	    }
	
	    _createClass(QueryHeader, [{
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            clearTimeout(this.timeout);
	            if (this.requestPromise) {
	                this.requestPromise.cancel();
	            }
	        }
	    }, {
	        key: "resetStateOnTimeout",
	        value: function resetStateOnTimeout() {
	            var _this2 = this;
	
	            // clear any previously set timeouts then start a new one
	            clearTimeout(this.timeout);
	            this.timeout = setTimeout(function () {
	                return _this2.setState({ recentlySaved: null });
	            }, 5000);
	        }
	    }, {
	        key: "_getCleanedCard",
	        value: function _getCleanedCard(card) {
	            if (card.dataset_query.query) {
	                var query = _utils2.default.copy(card.dataset_query.query);
	                return _extends({}, card, {
	                    dataset_query: _extends({}, card.dataset_query, {
	                        query: _query2.default.cleanQuery(query)
	                    })
	                });
	            } else {
	                return card;
	            }
	        }
	
	        /// Add result_metadata and metadata_checksum columns to card as expected by the endpoints used for saving
	        /// and updating Cards. These values are returned as part of Query Processor results and fetched from there
	
	    }, {
	        key: "addResultMetadata",
	        value: function addResultMetadata(card) {
	            var metadata = this.props.result && this.props.result.data && this.props.result.data.results_metadata;
	            var metadataChecksum = metadata && metadata.checksum;
	            var metadataColumns = metadata && metadata.columns;
	
	            card.result_metadata = metadataColumns;
	            card.metadata_checksum = metadataChecksum;
	        }
	
	        /// remove the databases in the store that are used to populate the QB databases list.
	        /// This is done when saving a Card because the newly saved card will be elligable for use as a source query
	        /// so we want the databases list to be re-fetched next time we hit "New Question" so it shows up
	
	    }, {
	        key: "clearQBDatabases",
	        value: function clearQBDatabases() {
	            this.props.clearRequestState({ statePath: ["metadata", "databases"] });
	        }
	    }, {
	        key: "onCreate",
	        value: function onCreate(card, addToDash) {
	            var _this3 = this;
	
	            // MBQL->NATIVE
	            // if we are a native query with an MBQL query definition, remove the old MBQL stuff (happens when going from mbql -> native)
	            // if (card.dataset_query.type === "native" && card.dataset_query.query) {
	            //     delete card.dataset_query.query;
	            // } else if (card.dataset_query.type === "query" && card.dataset_query.native) {
	            //     delete card.dataset_query.native;
	            // }
	
	            var cleanedCard = this._getCleanedCard(card);
	            this.addResultMetadata(cleanedCard);
	
	            // TODO: reduxify
	            this.requestPromise = (0, _promise.cancelable)(_services.CardApi.create(cleanedCard));
	            return this.requestPromise.then(function (newCard) {
	                _this3.clearQBDatabases();
	
	                _this3.props.notifyCardCreatedFn(newCard);
	
	                _this3.setState({
	                    recentlySaved: "created",
	                    modal: addToDash ? "add-to-dashboard" : "saved"
	                }, _this3.resetStateOnTimeout);
	            });
	        }
	    }, {
	        key: "onSave",
	        value: function onSave(card, addToDash) {
	            var _this4 = this;
	
	            // MBQL->NATIVE
	            // if we are a native query with an MBQL query definition, remove the old MBQL stuff (happens when going from mbql -> native)
	            // if (card.dataset_query.type === "native" && card.dataset_query.query) {
	            //     delete card.dataset_query.query;
	            // } else if (card.dataset_query.type === "query" && card.dataset_query.native) {
	            //     delete card.dataset_query.native;
	            // }
	
	            var cleanedCard = this._getCleanedCard(card);
	            this.addResultMetadata(cleanedCard);
	
	            // TODO: reduxify
	            this.requestPromise = (0, _promise.cancelable)(_services.CardApi.update(cleanedCard));
	            return this.requestPromise.then(function (updatedCard) {
	                _this4.clearQBDatabases();
	
	                if (_this4.props.fromUrl) {
	                    _this4.onGoBack();
	                    return;
	                }
	
	                _this4.props.notifyCardUpdatedFn(updatedCard);
	
	                _this4.setState({
	                    recentlySaved: "updated",
	                    modal: addToDash ? "add-to-dashboard" : null
	                }, _this4.resetStateOnTimeout);
	            });
	        }
	    }, {
	        key: "onBeginEditing",
	        value: function onBeginEditing() {
	            this.props.onBeginEditing();
	        }
	    }, {
	        key: "onCancel",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (this.props.fromUrl) {
	                                    this.onGoBack();
	                                } else {
	                                    this.props.onCancelEditing();
	                                }
	
	                            case 1:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function onCancel() {
	                return _ref.apply(this, arguments);
	            }
	
	            return onCancel;
	        }()
	    }, {
	        key: "onDelete",
	        value: function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _context2.next = 2;
	                                return _services.CardApi.delete({ 'cardId': this.props.card.id });
	
	                            case 2:
	                                this.onGoBack();
	                                _analytics2.default.trackEvent("QueryBuilder", "Delete");
	
	                            case 4:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function onDelete() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return onDelete;
	        }()
	    }, {
	        key: "onFollowBreadcrumb",
	        value: function onFollowBreadcrumb() {
	            this.props.onRestoreOriginalQuery();
	        }
	    }, {
	        key: "onToggleDataReference",
	        value: function onToggleDataReference() {
	            this.props.toggleDataReferenceFn();
	        }
	    }, {
	        key: "onGoBack",
	        value: function onGoBack() {
	            this.props.onChangeLocation(this.props.fromUrl || "/");
	        }
	    }, {
	        key: "onFetchRevisions",
	        value: function () {
	            var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(_ref4) {
	                var entity = _ref4.entity,
	                    id = _ref4.id;
	                var revisions;
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.next = 2;
	                                return _services.RevisionApi.list({ entity: entity, id: id });
	
	                            case 2:
	                                revisions = _context3.sent;
	
	                                this.setState({ revisions: revisions });
	
	                            case 4:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function onFetchRevisions(_x) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return onFetchRevisions;
	        }()
	    }, {
	        key: "onRevertToRevision",
	        value: function onRevertToRevision(_ref5) {
	            var entity = _ref5.entity,
	                id = _ref5.id,
	                revision_id = _ref5.revision_id;
	
	            // TODO: reduxify
	            return _services.RevisionApi.revert({ entity: entity, id: id, revision_id: revision_id });
	        }
	    }, {
	        key: "onRevertedRevision",
	        value: function onRevertedRevision() {
	            this.props.reloadCardFn();
	            this.refs.cardHistory.toggle();
	        }
	    }, {
	        key: "getHeaderButtons",
	        value: function getHeaderButtons() {
	            var _this5 = this;
	
	            var _props = this.props,
	                question = _props.question,
	                card = _props.card,
	                isNew = _props.isNew,
	                isDirty = _props.isDirty,
	                isEditing = _props.isEditing,
	                tableMetadata = _props.tableMetadata,
	                databases = _props.databases;
	
	            var database = _underscore2.default.findWhere(databases, { id: card && card.dataset_query && card.dataset_query.database });
	
	            var buttonSections = [];
	
	            // NEW card
	            if (isNew && isDirty) {
	                buttonSections.push([_react2.default.createElement(
	                    _ModalWithTrigger2.default,
	                    {
	                        form: true,
	                        key: "save",
	                        ref: "saveModal",
	                        triggerClasses: "h4 text-grey-4 text-brand-hover text-uppercase",
	                        triggerElement: "Save"
	                    },
	                    _react2.default.createElement(_SaveQuestionModal2.default, {
	                        card: this.props.card,
	                        originalCard: this.props.originalCard,
	                        tableMetadata: this.props.tableMetadata,
	                        addToDashboard: false,
	                        saveFn: this.onSave,
	                        createFn: this.onCreate,
	                        onClose: function onClose() {
	                            return _this5.refs.saveModal.toggle();
	                        }
	                    })
	                )]);
	            }
	
	            // persistence buttons on saved cards
	            if (!isNew && card.can_write) {
	                if (!isEditing) {
	                    if (this.state.recentlySaved) {
	                        // existing card + not editing + recently saved = save confirmation
	                        buttonSections.push([_react2.default.createElement(
	                            "button",
	                            {
	                                key: "recentlySaved",
	                                className: "cursor-pointer bg-white text-success text-strong text-uppercase"
	                            },
	                            _react2.default.createElement(
	                                "span",
	                                null,
	                                _react2.default.createElement(_Icon2.default, { name: "check", size: 12 }),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "ml1" },
	                                    "Saved"
	                                )
	                            )
	                        )]);
	                    } else {
	                        // edit button
	                        buttonSections.push([_react2.default.createElement(
	                            _Tooltip2.default,
	                            { key: "edit", tooltip: "Edit question" },
	                            _react2.default.createElement(
	                                "a",
	                                { className: "cursor-pointer text-brand-hover", onClick: this.onBeginEditing },
	                                _react2.default.createElement(_Icon2.default, { name: "pencil", size: 16 })
	                            )
	                        )]);
	                    }
	                } else {
	                    // save button
	                    buttonSections.push([_react2.default.createElement(_ActionButton2.default, {
	                        key: "save",
	                        actionFn: function actionFn() {
	                            return _this5.onSave(_this5.props.card, false);
	                        },
	                        className: "cursor-pointer text-brand-hover bg-white text-grey-4 text-uppercase",
	                        normalText: "SAVE CHANGES",
	                        activeText: "Saving\u2026",
	                        failedText: "Save failed",
	                        successText: "Saved"
	                    })]);
	
	                    // cancel button
	                    buttonSections.push([_react2.default.createElement(
	                        "a",
	                        { key: "cancel", className: "cursor-pointer text-brand-hover text-grey-4 text-uppercase", onClick: this.onCancel },
	                        "CANCEL"
	                    )]);
	
	                    // delete button
	                    buttonSections.push([_react2.default.createElement(_ArchiveQuestionModal2.default, { questionId: this.props.card.id })]);
	
	                    buttonSections.push([_react2.default.createElement(
	                        _ModalWithTrigger2.default,
	                        {
	                            ref: "move",
	                            key: "move",
	                            full: true,
	                            triggerElement: _react2.default.createElement(
	                                _Tooltip2.default,
	                                { tooltip: "Move question" },
	                                _react2.default.createElement(_Icon2.default, { name: "move" })
	                            )
	                        },
	                        _react2.default.createElement(_MoveToCollection2.default, {
	                            questionId: this.props.card.id,
	                            initialCollectionId: this.props.card && this.props.card.collection_id,
	                            setCollection: function setCollection(questionId, collection) {
	                                _this5.props.onSetCardAttribute('collection', collection);
	                                _this5.props.onSetCardAttribute('collection_id', collection.id);
	                            }
	                        })
	                    )]);
	                }
	            }
	
	            // parameters
	            if (question.query() instanceof _NativeQuery2.default && database && _underscore2.default.contains(database.features, "native-parameters")) {
	                var parametersButtonClasses = (0, _classnames2.default)('transition-color', {
	                    'text-brand': this.props.uiControls.isShowingTemplateTagsEditor,
	                    'text-brand-hover': !this.props.uiControls.isShowingTemplateTagsEditor
	                });
	                buttonSections.push([_react2.default.createElement(
	                    _Tooltip2.default,
	                    { key: "parameterEdititor", tooltip: "Variables" },
	                    _react2.default.createElement(
	                        "a",
	                        { className: parametersButtonClasses },
	                        _react2.default.createElement(_Icon2.default, { name: "variable", size: 16, onClick: this.props.toggleTemplateTagsEditor })
	                    )
	                )]);
	            }
	
	            // add to dashboard
	            if (!isNew && !isEditing) {
	                // simply adding an existing saved card to a dashboard, so show the modal to do so
	                buttonSections.push([_react2.default.createElement(
	                    _Tooltip2.default,
	                    { key: "addtodash", tooltip: "Add to dashboard" },
	                    _react2.default.createElement(
	                        "span",
	                        { "data-metabase-event": "QueryBuilder;AddToDash Modal;normal", className: "cursor-pointer text-brand-hover", onClick: function onClick() {
	                                return _this5.setState({ modal: "add-to-dashboard" });
	                            } },
	                        _react2.default.createElement(_Icon2.default, { name: "addtodash", size: ICON_SIZE })
	                    )
	                )]);
	            } else if (isNew && isDirty) {
	                // this is a new card, so we need the user to save first then they can add to dash
	                buttonSections.push([_react2.default.createElement(
	                    _Tooltip2.default,
	                    { key: "addtodashsave", tooltip: "Add to dashboard" },
	                    _react2.default.createElement(
	                        _ModalWithTrigger2.default,
	                        {
	                            ref: "addToDashSaveModal",
	                            triggerClasses: "h4 text-brand-hover text-uppercase",
	                            triggerElement: _react2.default.createElement(
	                                "span",
	                                { "data-metabase-event": "QueryBuilder;AddToDash Modal;pre-save", className: "text-brand-hover" },
	                                _react2.default.createElement(_Icon2.default, { name: "addtodash", size: ICON_SIZE })
	                            )
	                        },
	                        _react2.default.createElement(_SaveQuestionModal2.default, {
	                            card: this.props.card,
	                            originalCard: this.props.originalCard,
	                            tableMetadata: this.props.tableMetadata,
	                            addToDashboard: true,
	                            saveFn: this.onSave,
	                            createFn: this.onCreate,
	                            onClose: function onClose() {
	                                return _this5.refs.addToDashSaveModal.toggle();
	                            }
	                        })
	                    )
	                )]);
	            }
	
	            // history icon on saved cards
	            if (!isNew) {
	                buttonSections.push([_react2.default.createElement(
	                    _Tooltip2.default,
	                    { key: "history", tooltip: "Revision history" },
	                    _react2.default.createElement(
	                        _ModalWithTrigger2.default,
	                        {
	                            ref: "cardHistory",
	                            triggerElement: _react2.default.createElement(
	                                "span",
	                                { className: "text-brand-hover" },
	                                _react2.default.createElement(_Icon2.default, { name: "history", size: 18 })
	                            )
	                        },
	                        _react2.default.createElement(_HistoryModal2.default, {
	                            revisions: this.state.revisions,
	                            entityType: "card",
	                            entityId: this.props.card.id,
	                            onFetchRevisions: this.onFetchRevisions,
	                            onRevertToRevision: this.onRevertToRevision,
	                            onClose: function onClose() {
	                                return _this5.refs.cardHistory.toggle();
	                            },
	                            onReverted: this.onRevertedRevision
	                        })
	                    )
	                )]);
	            }
	
	            // query mode toggle
	            buttonSections.push([_react2.default.createElement(_QueryModeButton2.default, {
	                key: "queryModeToggle",
	                mode: this.props.card.dataset_query.type,
	                allowNativeToQuery: isNew && !isDirty,
	                allowQueryToNative: tableMetadata ?
	                // if a table is selected, only enable if user has native write permissions for THAT database
	                tableMetadata.db && tableMetadata.db.native_permissions === "write" :
	                // if no table is selected, only enable if user has native write permissions for ANY database
	                _underscore2.default.any(databases, function (db) {
	                    return db.native_permissions === "write";
	                }),
	                nativeForm: this.props.result && this.props.result.data && this.props.result.data.native_form,
	                onSetMode: this.props.setQueryModeFn,
	                tableMetadata: tableMetadata
	            })]);
	
	            // data reference button
	            var dataReferenceButtonClasses = (0, _classnames2.default)('mr1 transition-color', {
	                'text-brand': this.props.isShowingDataReference,
	                'text-brand-hover': !this.state.isShowingDataReference
	            });
	            buttonSections.push([_react2.default.createElement(
	                _Tooltip2.default,
	                { key: "dataReference", tooltip: "Learn about your data" },
	                _react2.default.createElement(
	                    "a",
	                    { className: dataReferenceButtonClasses },
	                    _react2.default.createElement(_Icon2.default, { name: "reference", size: ICON_SIZE, onClick: this.onToggleDataReference })
	                )
	            )]);
	
	            return _react2.default.createElement(_ButtonBar2.default, { buttons: buttonSections, className: "Header-buttonSection borderless" });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this6 = this;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "relative" },
	                _react2.default.createElement(_HeaderBar2.default, {
	                    isEditing: this.props.isEditing,
	                    name: this.props.isNew ? "New question" : this.props.card.name,
	                    description: this.props.card ? this.props.card.description : null,
	                    breadcrumb: !this.props.card.id && this.props.originalCard ? _react2.default.createElement(
	                        "span",
	                        { className: "pl2" },
	                        "started from ",
	                        _react2.default.createElement(
	                            "a",
	                            { className: "link", onClick: this.onFollowBreadcrumb },
	                            this.props.originalCard.name
	                        )
	                    ) : null,
	                    buttons: this.getHeaderButtons(),
	                    setItemAttributeFn: this.props.onSetCardAttribute,
	                    badge: this.props.card.collection && _react2.default.createElement(
	                        _reactRouter.Link,
	                        {
	                            to: Urls.collection(this.props.card.collection),
	                            className: "text-uppercase flex align-center no-decoration",
	                            style: { color: this.props.card.collection.color, fontSize: 12 }
	                        },
	                        _react2.default.createElement(_Icon2.default, { name: "collection", size: 12, style: { marginRight: "0.5em" } }),
	                        this.props.card.collection.name
	                    )
	                }),
	                _react2.default.createElement(
	                    _Modal2.default,
	                    { small: true, isOpen: this.state.modal === "saved", onClose: this.onCloseModal },
	                    _react2.default.createElement(_QuestionSavedModal2.default, {
	                        addToDashboardFn: function addToDashboardFn() {
	                            return _this6.setState({ modal: "add-to-dashboard" });
	                        },
	                        onClose: this.onCloseModal
	                    })
	                ),
	                _react2.default.createElement(
	                    _Modal2.default,
	                    { isOpen: this.state.modal === "add-to-dashboard", onClose: this.onCloseModal },
	                    _react2.default.createElement(_AddToDashSelectDashModal2.default, {
	                        card: this.props.card,
	                        onClose: this.onCloseModal,
	                        onChangeLocation: this.props.onChangeLocation
	                    })
	                )
	            );
	        }
	    }]);
	
	    return QueryHeader;
	}(_react.Component), _class2.propTypes = {
	    card: _propTypes2.default.object.isRequired,
	    originalCard: _propTypes2.default.object,
	    isEditing: _propTypes2.default.bool.isRequired,
	    tableMetadata: _propTypes2.default.object, // can't be required, sometimes null
	    onSetCardAttribute: _propTypes2.default.func.isRequired,
	    reloadCardFn: _propTypes2.default.func.isRequired,
	    setQueryModeFn: _propTypes2.default.func.isRequired,
	    isShowingDataReference: _propTypes2.default.bool.isRequired,
	    toggleDataReferenceFn: _propTypes2.default.func.isRequired,
	    isNew: _propTypes2.default.bool.isRequired,
	    isDirty: _propTypes2.default.bool.isRequired
	}, _temp)) || _class);
	QueryHeader.displayName = "QueryHeader";
	exports.default = QueryHeader;

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formatting = __webpack_require__(872);
	
	var _engine = __webpack_require__(956);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QueryModeButton = (_temp = _class = function (_Component) {
	    _inherits(QueryModeButton, _Component);
	
	    function QueryModeButton(props, context) {
	        _classCallCheck(this, QueryModeButton);
	
	        var _this = _possibleConstructorReturn(this, (QueryModeButton.__proto__ || Object.getPrototypeOf(QueryModeButton)).call(this, props, context));
	
	        _this.state = {
	            isOpen: false
	        };
	        return _this;
	    }
	
	    _createClass(QueryModeButton, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                allowQueryToNative = _props.allowQueryToNative,
	                allowNativeToQuery = _props.allowNativeToQuery,
	                mode = _props.mode,
	                nativeForm = _props.nativeForm,
	                onSetMode = _props.onSetMode,
	                tableMetadata = _props.tableMetadata;
	
	            // determine the type to switch to based on the type
	
	            var targetType = mode === "query" ? "native" : "query";
	
	            var engine = tableMetadata && tableMetadata.db.engine;
	            var nativeQueryName = (0, _engine.getEngineNativeType)(engine) === "sql" ? "SQL" : "native query";
	
	            // maybe switch up the icon based on mode?
	            var onClick = null;
	            var tooltip = "Not Supported";
	            if (mode === "query" && allowQueryToNative) {
	                onClick = nativeForm ? function () {
	                    return _this2.setState({ isOpen: true });
	                } : function () {
	                    return onSetMode("native");
	                };
	                tooltip = nativeForm ? "View the " + nativeQueryName : "Switch to " + nativeQueryName;
	            } else if (mode === "native" && allowNativeToQuery) {
	                onClick = function onClick() {
	                    return onSetMode("query");
	                };
	                tooltip = "Switch to Builder";
	            }
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    _Tooltip2.default,
	                    { tooltip: tooltip },
	                    _react2.default.createElement(
	                        "span",
	                        { "data-metabase-event": "QueryBuilder;Toggle Mode", className: (0, _classnames2.default)("cursor-pointer", { "text-brand-hover": onClick, "text-grey-1": !onClick }), onClick: onClick },
	                        _react2.default.createElement(_Icon2.default, { name: "sql", size: 16 })
	                    )
	                ),
	                _react2.default.createElement(
	                    _Modal2.default,
	                    { medium: true, backdropClassName: "Modal-backdrop--dark", isOpen: this.state.isOpen, onClose: function onClose() {
	                            return _this2.setState({ isOpen: false });
	                        } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "p4" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "mb3 flex flex-row flex-full align-center justify-between" },
	                            _react2.default.createElement(
	                                "h2",
	                                null,
	                                (0, _formatting.capitalize)(nativeQueryName),
	                                " for this question"
	                            ),
	                            _react2.default.createElement(
	                                "span",
	                                { className: "cursor-pointer", onClick: function onClick() {
	                                        return _this2.setState({ isOpen: false });
	                                    } },
	                                _react2.default.createElement(_Icon2.default, { name: "close", size: 16 })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "pre",
	                            { className: "mb3 p2 sql-code" },
	                            nativeForm && nativeForm.query && ((0, _engine.getEngineNativeType)(engine) === "json" ? (0, _engine.formatJsonQuery)(nativeForm.query, engine) : (0, _formatting.formatSQL)(nativeForm.query))
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "text-centered" },
	                            _react2.default.createElement(
	                                "a",
	                                { className: "Button Button--primary", onClick: function onClick() {
	                                        onSetMode(targetType);
	                                        _this2.setState({ isOpen: false });
	                                    } },
	                                "Convert this question to ",
	                                nativeQueryName
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return QueryModeButton;
	}(_react.Component), _class.propTypes = {
	    mode: _propTypes2.default.string.isRequired,
	    allowNativeToQuery: _propTypes2.default.bool,
	    allowQueryToNative: _propTypes2.default.bool,
	    nativeForm: _propTypes2.default.object,
	    onSetMode: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	    allowNativeToQuery: false
	}, _temp);
	QueryModeButton.displayName = "QueryModeButton";
	exports.default = QueryModeButton;

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _CreateDashboardModal = __webpack_require__(1596);
	
	var _CreateDashboardModal2 = _interopRequireDefault(_CreateDashboardModal);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _SortableItemList = __webpack_require__(1718);
	
	var _SortableItemList2 = _interopRequireDefault(_SortableItemList);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _dashboards = __webpack_require__(1521);
	
	var dashboardsActions = _interopRequireWildcard(_dashboards);
	
	var _selectors = __webpack_require__(1602);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        dashboards: (0, _selectors.getDashboardListing)(state)
	    };
	};
	
	var mapDispatchToProps = {
	    fetchDashboards: dashboardsActions.fetchDashboards,
	    createDashboard: dashboardsActions.createDashboard
	};
	
	var AddToDashSelectDashModal = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(AddToDashSelectDashModal, _Component);
	
	    function AddToDashSelectDashModal() {
	        var _ref,
	            _this2 = this;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AddToDashSelectDashModal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddToDashSelectDashModal.__proto__ || Object.getPrototypeOf(AddToDashSelectDashModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            shouldCreateDashboard: false
	        }, _this.addToDashboard = function (dashboard) {
	            // we send the user over to the chosen dashboard in edit mode with the current card added
	            _this.props.onChangeLocation(Urls.dashboard(dashboard.id, { addCardWithId: _this.props.card.id }));
	        }, _this.createDashboard = function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(newDashboard) {
	                var action;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return _this.props.createDashboard(newDashboard, {});
	
	                            case 3:
	                                action = _context.sent;
	
	                                _this.addToDashboard(action.payload);
	                                _context.next = 10;
	                                break;
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context["catch"](0);
	
	                                console.log("createDashboard failed", _context.t0);
	
	                            case 10:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2, [[0, 7]]);
	            }));
	
	            return function (_x) {
	                return _ref2.apply(this, arguments);
	            };
	        }(), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AddToDashSelectDashModal, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.fetchDashboards();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            if (this.props.dashboards === null) {
	                return _react2.default.createElement("div", null);
	            } else if (this.props.dashboards.length === 0 || this.state.shouldCreateDashboard === true) {
	                return _react2.default.createElement(_CreateDashboardModal2.default, { createDashboardFn: this.createDashboard, onClose: this.props.onClose });
	            } else {
	                return _react2.default.createElement(
	                    _ModalContent2.default,
	                    {
	                        id: "AddToDashSelectDashModal",
	                        title: "Add Question to Dashboard",
	                        onClose: this.props.onClose
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex flex-column" },
	                        _react2.default.createElement(
	                            "div",
	                            {
	                                className: "link flex-align-right px4 cursor-pointer",
	                                onClick: function onClick() {
	                                    return _this3.setState({ shouldCreateDashboard: true });
	                                }
	                            },
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: "mt1 flex align-center absolute",
	                                    style: { right: 40 }
	                                },
	                                _react2.default.createElement(_Icon2.default, { name: "add", size: 16 }),
	                                _react2.default.createElement(
	                                    "h3",
	                                    { className: "ml1" },
	                                    "Add to new dashboard"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_SortableItemList2.default, {
	                            items: this.props.dashboards,
	                            onClickItemFn: this.addToDashboard
	                        })
	                    )
	                );
	            }
	        }
	    }]);
	
	    return AddToDashSelectDashModal;
	}(_react.Component)) || _class);
	AddToDashSelectDashModal.displayName = "AddToDashSelectDashModal";
	exports.default = AddToDashSelectDashModal;

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1719);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Radio = __webpack_require__(1380);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SortableItemList = (_temp = _class = function (_Component) {
	    _inherits(SortableItemList, _Component);
	
	    function SortableItemList(props, context) {
	        _classCallCheck(this, SortableItemList);
	
	        var _this = _possibleConstructorReturn(this, (SortableItemList.__proto__ || Object.getPrototypeOf(SortableItemList)).call(this, props, context));
	
	        _this.state = {
	            sort: props.initialSort || "Last Modified"
	        };
	        return _this;
	    }
	
	    _createClass(SortableItemList, [{
	        key: "onClickItem",
	        value: function onClickItem(item) {
	            if (this.props.onClickItemFn) {
	                this.props.onClickItemFn(item);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var items;
	            if (this.state.sort === "Last Modified") {
	                items = this.props.items.slice().sort(function (a, b) {
	                    return b.updated_at - a.updated_at;
	                });
	            } else if (this.state.sort === "Alphabetical Order") {
	                items = this.props.items.slice().sort(function (a, b) {
	                    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
	                });
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "SortableItemList" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center px2 pb3 border-bottom" },
	                    _react2.default.createElement(
	                        "h5",
	                        { className: "text-bold text-uppercase text-grey-3 ml2 mt1 mr2" },
	                        "Sort by"
	                    ),
	                    _react2.default.createElement(_Radio2.default, {
	                        value: this.state.sort,
	                        options: ["Last Modified", /*"Most Popular",*/"Alphabetical Order"],
	                        onChange: function onChange(sort) {
	                            return _this2.setState({ sort: sort });
	                        },
	                        optionNameFn: function optionNameFn(o) {
	                            return o;
	                        },
	                        optionValueFn: function optionValueFn(o) {
	                            return o;
	                        },
	                        optionKeyFn: function optionKeyFn(o) {
	                            return o;
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "SortableItemList-list px2 pb2" },
	                    items.map(function (item) {
	                        return _react2.default.createElement(
	                            "li",
	                            { key: item.id, className: "border-row-divider" },
	                            _react2.default.createElement(
	                                "a",
	                                { className: "no-decoration flex p2", onClick: function onClick() {
	                                        return _this2.onClickItem(item);
	                                    } },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "flex align-center flex-full mr2" },
	                                    _this2.props.showIcons ? _react2.default.createElement(
	                                        "div",
	                                        { className: "mr2" },
	                                        _react2.default.createElement(_Icon2.default, { name: 'illustration-' + item.display, size: 48 })
	                                    ) : null,
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "text-brand-hover" },
	                                        _react2.default.createElement(
	                                            "h3",
	                                            { className: "mb1" },
	                                            item.name
	                                        ),
	                                        _react2.default.createElement(
	                                            "h4",
	                                            { className: "text-grey-3" },
	                                            item.description || "No description yet"
	                                        )
	                                    )
	                                ),
	                                item.creator && item.updated_at && _react2.default.createElement(
	                                    "div",
	                                    { className: "flex-align-right text-right text-grey-3" },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "mb1" },
	                                        "Saved by ",
	                                        item.creator.common_name
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        null,
	                                        "Modified ",
	                                        item.updated_at.fromNow()
	                                    )
	                                )
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SortableItemList;
	}(_react.Component), _class.propTypes = {
	    items: _propTypes2.default.array.isRequired,
	    clickItemFn: _propTypes2.default.func,
	    showIcons: _propTypes2.default.bool
	}, _temp);
	SortableItemList.displayName = "SortableItemList";
	exports.default = SortableItemList;

/***/ }),
/* 1719 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1720 */,
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ButtonBar = (_temp = _class = function (_Component) {
	    _inherits(ButtonBar, _Component);
	
	    function ButtonBar() {
	        _classCallCheck(this, ButtonBar);
	
	        return _possibleConstructorReturn(this, (ButtonBar.__proto__ || Object.getPrototypeOf(ButtonBar)).apply(this, arguments));
	    }
	
	    _createClass(ButtonBar, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                buttons = _props.buttons,
	                className = _props.className;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex align-center" },
	                buttons.filter(function (v) {
	                    return v && v.length > 0;
	                }).map(function (section, sectionIndex) {
	                    return _react2.default.createElement(
	                        "span",
	                        { key: sectionIndex, className: className },
	                        section
	                    );
	                })
	            );
	        }
	    }]);
	
	    return ButtonBar;
	}(_react.Component), _class.defaultProps = {
	    buttons: [],
	    className: ""
	}, _temp);
	ButtonBar.displayName = "ButtonBar";
	exports.default = ButtonBar;

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _TitleAndDescription = __webpack_require__(1595);
	
	var _TitleAndDescription2 = _interopRequireDefault(_TitleAndDescription);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = (_temp = _class = function (_Component) {
	    _inherits(Header, _Component);
	
	    function Header() {
	        _classCallCheck(this, Header);
	
	        return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	    }
	
	    _createClass(Header, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                isEditing = _props.isEditing,
	                name = _props.name,
	                description = _props.description,
	                breadcrumb = _props.breadcrumb,
	                buttons = _props.buttons,
	                className = _props.className,
	                badge = _props.badge;
	
	
	            var titleAndDescription = void 0;
	            if (isEditing) {
	                titleAndDescription = _react2.default.createElement(
	                    "div",
	                    { className: "Header-title flex flex-column flex-full bordered rounded my1" },
	                    _react2.default.createElement(_Input2.default, { className: "AdminInput text-bold border-bottom rounded-top h3", type: "text", value: name, onChange: function onChange(e) {
	                            return _this2.props.setItemAttributeFn("name", e.target.value);
	                        } }),
	                    _react2.default.createElement(_Input2.default, { className: "AdminInput rounded-bottom h4", type: "text", value: description, onChange: function onChange(e) {
	                            return _this2.props.setItemAttributeFn("description", e.target.value);
	                        }, placeholder: "No description yet" })
	                );
	            } else {
	                if (name && description) {
	                    titleAndDescription = _react2.default.createElement(_TitleAndDescription2.default, {
	                        title: name,
	                        description: description
	                    });
	                } else {
	                    titleAndDescription = _react2.default.createElement(
	                        "div",
	                        { className: "flex align-baseline" },
	                        _react2.default.createElement(
	                            "h1",
	                            { className: "Header-title-name my1" },
	                            name
	                        ),
	                        " ",
	                        breadcrumb
	                    );
	                }
	            }
	
	            return (
	                // TODO Atte Keinänen 5/16/17 Take care of the mobile layout with the multimetrics UI
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)("QueryBuilder-section pt2 sm-pt2 flex align-center", className) },
	                    _react2.default.createElement(
	                        "div",
	                        { className: (0, _classnames2.default)("relative flex-full") },
	                        titleAndDescription,
	                        badge && _react2.default.createElement(
	                            "div",
	                            null,
	                            badge
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-align-right hide sm-show" },
	                        buttons
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Header;
	}(_react.Component), _class.defaultProps = {
	    buttons: null,
	    className: "py1 lg-py2 xl-py3 wrapper",
	    breadcrumb: null
	}, _temp);
	Header.displayName = "Header";
	exports.default = Header;

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuestionSavedModal = (_temp = _class = function (_Component) {
	    _inherits(QuestionSavedModal, _Component);
	
	    function QuestionSavedModal() {
	        _classCallCheck(this, QuestionSavedModal);
	
	        return _possibleConstructorReturn(this, (QuestionSavedModal.__proto__ || Object.getPrototypeOf(QuestionSavedModal)).apply(this, arguments));
	    }
	
	    _createClass(QuestionSavedModal, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    id: "QuestionSavedModal",
	                    title: "Saved! Add this to a dashboard?",
	                    onClose: this.props.onClose,
	                    className: "Modal-content Modal-content--small NewForm"
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "Form-inputs mb4" },
	                    _react2.default.createElement(
	                        "button",
	                        { className: "Button Button--primary", onClick: this.props.addToDashboardFn },
	                        "Yes please!"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        { className: "Button ml3", onClick: this.props.onClose },
	                        "Not now"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return QuestionSavedModal;
	}(_react.Component), _class.propTypes = {
	    addToDashboardFn: _propTypes2.default.func.isRequired,
	    onClose: _propTypes2.default.func.isRequired
	}, _temp);
	QuestionSavedModal.displayName = "QuestionSavedModal";
	exports.default = QuestionSavedModal;

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _actions = __webpack_require__(863);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps() {
	    return {};
	};
	
	var mapDispatchToProps = {
	    archiveQuestion: _actions.archiveQuestion
	};
	
	var ArchiveQuestionModal = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(ArchiveQuestionModal, _Component);
	
	    function ArchiveQuestionModal() {
	        var _ref,
	            _this2 = this;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ArchiveQuestionModal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ArchiveQuestionModal.__proto__ || Object.getPrototypeOf(ArchiveQuestionModal)).call.apply(_ref, [this].concat(args))), _this), _this.onArchive = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _this.props.archiveQuestion();
	
	                        case 3:
	                            _this.onClose();
	                            _context.next = 10;
	                            break;
	
	                        case 6:
	                            _context.prev = 6;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error(_context.t0);
	                            _this.setState({ error: _context.t0 });
	
	                        case 10:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[0, 6]]);
	        })), _this.onClose = function () {
	            if (_this.refs.archiveModal) {
	                _this.refs.archiveModal.close();
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ArchiveQuestionModal, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _ModalWithTrigger2.default,
	                {
	                    ref: "archiveModal",
	                    triggerElement: _react2.default.createElement(
	                        _Tooltip2.default,
	                        { key: "archive", tooltip: "Archive" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "text-brand-hover" },
	                            _react2.default.createElement(_Icon2.default, { name: "archive", size: 16 })
	                        )
	                    ),
	                    title: "Archive this question?",
	                    footer: [_react2.default.createElement(
	                        _Button2.default,
	                        { key: "cancel", onClick: this.onClose },
	                        "Cancel"
	                    ), _react2.default.createElement(
	                        _Button2.default,
	                        { key: "archive", warning: true, onClick: this.onArchive },
	                        "Archive"
	                    )]
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "px4 pb4" },
	                    "This question will be removed from any dashboards or pulses using it."
	                )
	            );
	        }
	    }]);
	
	    return ArchiveQuestionModal;
	}(_react.Component)) || _class);
	ArchiveQuestionModal.displayName = "ArchiveQuestionModal";
	exports.default = ArchiveQuestionModal;

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(924);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _FormField = __webpack_require__(1597);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _Radio = __webpack_require__(1380);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CollectionList = __webpack_require__(1611);
	
	var _CollectionList2 = _interopRequireDefault(_CollectionList);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _promise = __webpack_require__(1069);
	
	__webpack_require__(1726);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SaveQuestionModal = (_temp = _class = function (_Component) {
	    _inherits(SaveQuestionModal, _Component);
	
	    function SaveQuestionModal(props, context) {
	        var _this2 = this;
	
	        _classCallCheck(this, SaveQuestionModal);
	
	        var _this = _possibleConstructorReturn(this, (SaveQuestionModal.__proto__ || Object.getPrototypeOf(SaveQuestionModal)).call(this, props, context));
	
	        _this.formSubmitted = function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(e) {
	                var details, _this$props, card, originalCard, addToDashboard, createFn, saveFn;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	
	                                if (e) {
	                                    e.preventDefault();
	                                }
	
	                                details = _this.state.details;
	                                _this$props = _this.props, card = _this$props.card, originalCard = _this$props.originalCard, addToDashboard = _this$props.addToDashboard, createFn = _this$props.createFn, saveFn = _this$props.saveFn;
	
	
	                                card = _extends({}, card, {
	                                    name: details.saveType === "overwrite" ? originalCard.name : details.name.trim(),
	                                    // since description is optional, it can be null, so check for a description before trimming it
	                                    description: details.saveType === "overwrite" ? originalCard.description : details.description ? details.description.trim() : null,
	                                    collection_id: details.saveType === "overwrite" ? originalCard.collection_id : details.collection_id
	                                });
	
	                                if (details.saveType === "create") {
	                                    _this.requestPromise = (0, _promise.cancelable)(createFn(card, addToDashboard));
	                                } else if (details.saveType === "overwrite") {
	                                    card.id = _this.props.originalCard.id;
	                                    _this.requestPromise = (0, _promise.cancelable)(saveFn(card, addToDashboard));
	                                }
	
	                                _context.next = 8;
	                                return _this.requestPromise;
	
	                            case 8:
	                                _this.requestPromise = null;
	                                _this.props.onClose();
	                                _context.next = 15;
	                                break;
	
	                            case 12:
	                                _context.prev = 12;
	                                _context.t0 = _context["catch"](0);
	
	                                if (_context.t0 && !_context.t0.isCanceled) {
	                                    _this.setState({ error: _context.t0 });
	                                }
	
	                            case 15:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2, [[0, 12]]);
	            }));
	
	            return function (_x) {
	                return _ref.apply(this, arguments);
	            };
	        }();
	
	        var isStructured = _query2.default.isStructured(props.card.dataset_query);
	
	        _this.state = {
	            error: null,
	            valid: false,
	            details: {
	                name: props.card.name || isStructured ? _query2.default.generateQueryDescription(props.tableMetadata, props.card.dataset_query.query) : "",
	                description: props.card.description || '',
	                collection_id: props.card.collection_id || null,
	                saveType: props.originalCard ? "overwrite" : "create"
	            }
	        };
	        return _this;
	    }
	
	    _createClass(SaveQuestionModal, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.validateForm();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this.validateForm();
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            if (this.requestPromise) {
	                this.requestPromise.cancel();
	            }
	        }
	    }, {
	        key: "validateForm",
	        value: function validateForm() {
	            var details = this.state.details;
	
	
	            var valid = true;
	
	            // name is required for create
	            if (details.saveType === "create" && !details.name) {
	                valid = false;
	            }
	
	            if (this.state.valid !== valid) {
	                this.setState({ valid: valid });
	            }
	        }
	    }, {
	        key: "onChange",
	        value: function onChange(fieldName, fieldValue) {
	            this.setState({ details: _extends({}, this.state.details, _defineProperty({}, fieldName, fieldValue ? fieldValue : null)) });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _state = this.state,
	                error = _state.error,
	                details = _state.details;
	
	            var formError;
	            if (error) {
	                var errorMessage;
	                if (error.status === 500) {
	                    errorMessage = "Server error encountered";
	                }
	
	                if (error.data && error.data.message) {
	                    errorMessage = error.data.message;
	                }
	                if (error.data && error.data.errors) {
	                    errorMessage = Object.values(error.data.errors);
	                }
	
	                // TODO: timeout display?
	                if (errorMessage) {
	                    formError = _react2.default.createElement(
	                        "span",
	                        { className: "text-error px2" },
	                        errorMessage
	                    );
	                }
	            }
	
	            var saveOrUpdate = null;
	            if (!this.props.card.id && this.props.originalCard) {
	                saveOrUpdate = _react2.default.createElement(
	                    _FormField2.default,
	                    {
	                        displayName: "Replace or save as new?",
	                        fieldName: "saveType",
	                        errors: this.state.errors
	                    },
	                    _react2.default.createElement(_Radio2.default, {
	                        value: this.state.details.saveType,
	                        onChange: function onChange(value) {
	                            return _this3.onChange("saveType", value);
	                        },
	                        options: [{ name: "Replace original question, \"" + this.props.originalCard.name + "\"", value: "overwrite" }, { name: "Save as new question", value: "create" }],
	                        isVertical: true
	                    })
	                );
	            }
	
	            var title = this.props.addToDashboard ? "First, save your question" : "Save question";
	
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    id: "SaveQuestionModal",
	                    title: title,
	                    footer: [formError, _react2.default.createElement(
	                        _Button2.default,
	                        { onClick: this.props.onClose },
	                        "Cancel"
	                    ), _react2.default.createElement(
	                        _Button2.default,
	                        { primary: this.state.valid, disabled: !this.state.valid, onClick: this.formSubmitted },
	                        "Save"
	                    )],
	                    onClose: this.props.onClose
	                },
	                _react2.default.createElement(
	                    "form",
	                    { className: "Form-inputs", onSubmit: this.formSubmitted },
	                    saveOrUpdate,
	                    _react2.default.createElement(
	                        _reactAddonsCssTransitionGroup2.default,
	                        {
	                            transitionName: "saveQuestionModalFields",
	                            transitionEnterTimeout: 500,
	                            transitionLeaveTimeout: 500
	                        },
	                        details.saveType === "create" && _react2.default.createElement(
	                            "div",
	                            { key: "saveQuestionModalFields", className: "saveQuestionModalFields" },
	                            _react2.default.createElement(
	                                _FormField2.default,
	                                {
	                                    displayName: "Name",
	                                    fieldName: "name",
	                                    errors: this.state.errors
	                                },
	                                _react2.default.createElement("input", {
	                                    className: "Form-input full",
	                                    name: "name", placeholder: "What is the name of your card?",
	                                    value: this.state.details.name,
	                                    onChange: function onChange(e) {
	                                        return _this3.onChange("name", e.target.value);
	                                    },
	                                    autoFocus: true
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _FormField2.default,
	                                {
	                                    displayName: "Description",
	                                    fieldName: "description",
	                                    errors: this.state.errors
	                                },
	                                _react2.default.createElement("textarea", {
	                                    className: "Form-input full",
	                                    name: "description",
	                                    placeholder: "It's optional but oh, so helpful",
	                                    value: this.state.details.description,
	                                    onChange: function onChange(e) {
	                                        return _this3.onChange("description", e.target.value);
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                _CollectionList2.default,
	                                { writable: true },
	                                function (collections) {
	                                    return collections.length > 0 && _react2.default.createElement(
	                                        _FormField2.default,
	                                        {
	                                            displayName: "Which collection should this go in?",
	                                            fieldName: "collection_id",
	                                            errors: _this3.state.errors
	                                        },
	                                        _react2.default.createElement(
	                                            _Select2.default,
	                                            {
	                                                className: "block",
	                                                value: _this3.state.details.collection_id,
	                                                onChange: function onChange(e) {
	                                                    return _this3.onChange("collection_id", e.target.value);
	                                                }
	                                            },
	                                            [{ name: "None", id: null }].concat(collections).map(function (collection, index) {
	                                                return _react2.default.createElement(
	                                                    _Select.Option,
	                                                    {
	                                                        key: index,
	                                                        value: collection.id,
	                                                        icon: collection.id != null ? "collection" : null,
	                                                        iconColor: collection.color,
	                                                        iconSize: 18
	                                                    },
	                                                    collection.name
	                                                );
	                                            })
	                                        )
	                                    );
	                                }
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SaveQuestionModal;
	}(_react.Component), _class.propTypes = {
	    card: _propTypes2.default.object.isRequired,
	    originalCard: _propTypes2.default.object,
	    tableMetadata: _propTypes2.default.object, // can't be required, sometimes null
	    createFn: _propTypes2.default.func.isRequired,
	    saveFn: _propTypes2.default.func.isRequired,
	    onClose: _propTypes2.default.func.isRequired
	}, _temp);
	SaveQuestionModal.displayName = "SaveQuestionModal";
	exports.default = SaveQuestionModal;

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1727 */,
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BreakoutWidget = exports.AggregationWidget = exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _AggregationWidget = __webpack_require__(1005);
	
	var _AggregationWidget2 = _interopRequireDefault(_AggregationWidget);
	
	var _BreakoutWidget = __webpack_require__(1729);
	
	var _BreakoutWidget2 = _interopRequireDefault(_BreakoutWidget);
	
	var _DataSelector = __webpack_require__(1730);
	
	var _DataSelector2 = _interopRequireDefault(_DataSelector);
	
	var _ExtendedOptions = __webpack_require__(1731);
	
	var _ExtendedOptions2 = _interopRequireDefault(_ExtendedOptions);
	
	var _FilterList = __webpack_require__(983);
	
	var _FilterList2 = _interopRequireDefault(_FilterList);
	
	var _FilterPopover = __webpack_require__(987);
	
	var _FilterPopover2 = _interopRequireDefault(_FilterPopover);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _IconBorder = __webpack_require__(1289);
	
	var _IconBorder2 = _interopRequireDefault(_IconBorder);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GuiQueryEditor = (_temp2 = _class = function (_Component) {
	    _inherits(GuiQueryEditor, _Component);
	
	    function GuiQueryEditor() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, GuiQueryEditor);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GuiQueryEditor.__proto__ || Object.getPrototypeOf(GuiQueryEditor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            expanded: true
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(GuiQueryEditor, [{
	        key: "renderAdd",
	        value: function renderAdd(text, onClick, targetRefName) {
	            var className = "AddButton text-grey-2 text-bold flex align-center text-grey-4-hover cursor-pointer no-decoration transition-color";
	            if (onClick) {
	                return _react2.default.createElement(
	                    "a",
	                    { className: className, onClick: onClick },
	                    text && _react2.default.createElement(
	                        "span",
	                        { className: "mr1" },
	                        text
	                    ),
	                    this.renderAddIcon(targetRefName)
	                );
	            } else {
	                return _react2.default.createElement(
	                    "span",
	                    { className: className },
	                    text && _react2.default.createElement(
	                        "span",
	                        { className: "mr1" },
	                        text
	                    ),
	                    this.renderAddIcon(targetRefName)
	                );
	            }
	        }
	    }, {
	        key: "renderAddIcon",
	        value: function renderAddIcon(targetRefName) {
	            return _react2.default.createElement(
	                _IconBorder2.default,
	                { borderRadius: "3px", ref: targetRefName },
	                _react2.default.createElement(_Icon2.default, { name: "add", size: 14 })
	            );
	        }
	    }, {
	        key: "renderFilters",
	        value: function renderFilters() {
	            var _this2 = this;
	
	            var _props = this.props,
	                query = _props.query,
	                features = _props.features,
	                setDatasetQuery = _props.setDatasetQuery;
	
	
	            if (!features.filter) return;
	
	            var enabled = void 0;
	            var filterList = void 0;
	            var addFilterButton = void 0;
	
	            if (query.isEditable()) {
	                enabled = true;
	
	                var filters = query.filters();
	                if (filters && filters.length > 0) {
	                    filterList = _react2.default.createElement(_FilterList2.default, {
	                        query: query,
	                        filters: filters,
	                        removeFilter: function removeFilter(index) {
	                            return query.removeFilter(index).update(setDatasetQuery);
	                        },
	                        updateFilter: function updateFilter(index, filter) {
	                            return query.updateFilter(index, filter).update(setDatasetQuery);
	                        }
	                    });
	                }
	
	                if (query.canAddFilter()) {
	                    addFilterButton = this.renderAdd(filterList ? null : "Add filters to narrow your answer", null, "addFilterTarget");
	                }
	            } else {
	                enabled = false;
	                addFilterButton = this.renderAdd("Add filters to narrow your answer", null, "addFilterTarget");
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("Query-section", { disabled: !enabled }) },
	                _react2.default.createElement(
	                    "div",
	                    { className: "Query-filters" },
	                    filterList
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "mx2" },
	                    _react2.default.createElement(
	                        _PopoverWithTrigger2.default,
	                        {
	                            id: "FilterPopover",
	                            ref: "filterPopover",
	                            triggerElement: addFilterButton,
	                            triggerClasses: "flex align-center",
	                            getTarget: function getTarget() {
	                                return _this2.refs.addFilterTarget;
	                            },
	                            horizontalAttachments: ["left"]
	                        },
	                        _react2.default.createElement(_FilterPopover2.default, {
	                            isNew: true,
	                            query: query,
	                            onCommitFilter: function onCommitFilter(filter) {
	                                return query.addFilter(filter).update(setDatasetQuery);
	                            },
	                            onClose: function onClose() {
	                                return _this2.refs.filterPopover.close();
	                            }
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: "renderAggregation",
	        value: function renderAggregation() {
	            var _props2 = this.props,
	                query = _props2.query,
	                features = _props2.features,
	                setDatasetQuery = _props2.setDatasetQuery,
	                supportMultipleAggregations = _props2.supportMultipleAggregations;
	
	
	            if (!features.aggregation) {
	                return;
	            }
	
	            // aggregation clause.  must have table details available
	            if (query.isEditable()) {
	                // $FlowFixMe
	                var aggregations = query.aggregations();
	
	                if (aggregations.length === 0) {
	                    // add implicit rows aggregation
	                    aggregations.push(["rows"]);
	                }
	
	                // Placeholder aggregation for showing the add button
	                if (supportMultipleAggregations && !query.isBareRows()) {
	                    aggregations.push([]);
	                }
	
	                var aggregationList = [];
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = aggregations.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var _step$value = _slicedToArray(_step.value, 2),
	                            index = _step$value[0],
	                            _aggregation = _step$value[1];
	
	                        aggregationList.push(_react2.default.createElement(AggregationWidget, {
	                            key: "agg" + index,
	                            index: index,
	                            aggregation: _aggregation,
	                            query: query,
	                            updateQuery: setDatasetQuery,
	                            addButton: this.renderAdd(null)
	                        }));
	                        if (aggregations[index + 1] != null && aggregations[index + 1].length > 0) {
	                            aggregationList.push(_react2.default.createElement(
	                                "span",
	                                { key: "and" + index, className: "text-bold" },
	                                "and"
	                            ));
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                return aggregationList;
	            } else {
	                // TODO: move this into AggregationWidget?
	                return _react2.default.createElement(
	                    "div",
	                    { className: "Query-section Query-section-aggregation disabled" },
	                    _react2.default.createElement(
	                        "a",
	                        { className: "QueryOption p1 flex align-center" },
	                        "Raw data"
	                    )
	                );
	            }
	        }
	    }, {
	        key: "renderBreakouts",
	        value: function renderBreakouts() {
	            var _props3 = this.props,
	                query = _props3.query,
	                setDatasetQuery = _props3.setDatasetQuery,
	                features = _props3.features;
	
	
	            if (!features.breakout) {
	                return;
	            }
	
	            var breakoutList = [];
	
	            // $FlowFixMe
	            var breakouts = query.breakouts();
	
	            // Placeholder breakout for showing the add button
	            if (query.canAddBreakout()) {
	                breakouts.push(null);
	            }
	
	            for (var i = 0; i < breakouts.length; i++) {
	                var _breakout = breakouts[i];
	
	                if (_breakout == null) {
	                    breakoutList.push(_react2.default.createElement("span", { key: "nullBreakout", className: "ml1" }));
	                }
	
	                breakoutList.push(_react2.default.createElement(BreakoutWidget, {
	                    key: "breakout" + i,
	                    className: "View-section-breakout SelectionModule p1",
	                    index: i,
	                    breakout: _breakout,
	                    query: query,
	                    updateQuery: setDatasetQuery,
	                    addButton: this.renderAdd(i === 0 ? "Add a grouping" : null)
	                }));
	
	                if (breakouts[i + 1] != null) {
	                    breakoutList.push(_react2.default.createElement(
	                        "span",
	                        { key: "and" + i, className: "text-bold" },
	                        "and"
	                    ));
	                }
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("Query-section Query-section-breakout", { disabled: breakoutList.length === 0 }) },
	                breakoutList
	            );
	        }
	    }, {
	        key: "renderDataSection",
	        value: function renderDataSection() {
	            var query = this.props.query;
	
	            var tableMetadata = query.tableMetadata();
	            return _react2.default.createElement(
	                "div",
	                { className: "GuiBuilder-section GuiBuilder-data flex align-center arrow-right" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "GuiBuilder-section-label Query-label" },
	                    "Data"
	                ),
	                this.props.features.data ? _react2.default.createElement(_DataSelector2.default, {
	                    ref: "dataSection",
	                    includeTables: true,
	                    datasetQuery: query.datasetQuery(),
	                    databases: this.props.databases,
	                    tables: this.props.tables,
	                    setDatabaseFn: this.props.setDatabaseFn,
	                    setSourceTableFn: this.props.setSourceTableFn,
	                    isInitiallyOpen: (!query.datasetQuery().database || !query.query().source_table) && !this.props.isShowingTutorial
	                }) : _react2.default.createElement(
	                    "span",
	                    { className: "flex align-center px2 py2 text-bold text-grey" },
	                    tableMetadata && tableMetadata.display_name
	                )
	            );
	        }
	    }, {
	        key: "renderFilterSection",
	        value: function renderFilterSection() {
	            if (!this.props.features.filter) {
	                return;
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "GuiBuilder-section GuiBuilder-filtered-by flex align-center", ref: "filterSection" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "GuiBuilder-section-label Query-label" },
	                    "Filtered by"
	                ),
	                this.renderFilters()
	            );
	        }
	    }, {
	        key: "renderViewSection",
	        value: function renderViewSection() {
	            var features = this.props.features;
	
	            if (!features.aggregation && !features.breakout) {
	                return;
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "GuiBuilder-section GuiBuilder-view flex align-center px1 pr2", ref: "viewSection" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "GuiBuilder-section-label Query-label" },
	                    "View"
	                ),
	                this.renderAggregation()
	            );
	        }
	    }, {
	        key: "renderGroupedBySection",
	        value: function renderGroupedBySection() {
	            var features = this.props.features;
	
	            if (!features.aggregation && !features.breakout) {
	                return;
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "GuiBuilder-section GuiBuilder-groupedBy flex align-center px1", ref: "viewSection" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "GuiBuilder-section-label Query-label" },
	                    "Grouped By"
	                ),
	                this.renderBreakouts()
	            );
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var _this3 = this;
	
	            var guiBuilder = _reactDom2.default.findDOMNode(this.refs.guiBuilder);
	            if (!guiBuilder) {
	                return;
	            }
	
	            // HACK: magic number "5" accounts for the borders between the sections?
	            var contentWidth = ["data", "filter", "view", "groupedBy", "sortLimit"].reduce(function (acc, ref) {
	                var node = _reactDom2.default.findDOMNode(_this3.refs[ref + "Section"]);
	                return acc + (node ? node.offsetWidth : 0);
	            }, 0) + 5;
	            var guiBuilderWidth = guiBuilder.offsetWidth;
	
	            var expanded = contentWidth < guiBuilderWidth;
	            if (this.state.expanded !== expanded) {
	                this.setState({ expanded: expanded });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props4 = this.props,
	                databases = _props4.databases,
	                query = _props4.query;
	
	            var datasetQuery = query.datasetQuery();
	            var readOnly = datasetQuery.database != null && !_underscore2.default.findWhere(databases, { id: datasetQuery.database });
	            if (readOnly) {
	                return _react2.default.createElement("div", { className: "border-bottom border-med" });
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)("GuiBuilder rounded shadowed", { "GuiBuilder--expand": this.state.expanded, disabled: readOnly }), ref: "guiBuilder" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "GuiBuilder-row flex" },
	                    this.renderDataSection(),
	                    this.renderFilterSection()
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "GuiBuilder-row flex flex-full" },
	                    this.renderViewSection(),
	                    this.renderGroupedBySection(),
	                    _react2.default.createElement("div", { className: "flex-full" }),
	                    this.props.children,
	                    _react2.default.createElement(_ExtendedOptions2.default, this.props)
	                )
	            );
	        }
	    }]);
	
	    return GuiQueryEditor;
	}(_react.Component), _class.propTypes = {
	    databases: _propTypes2.default.array,
	    isShowingDataReference: _propTypes2.default.bool.isRequired,
	    setDatasetQuery: _propTypes2.default.func.isRequired,
	    setDatabaseFn: _propTypes2.default.func,
	    setSourceTableFn: _propTypes2.default.func,
	    features: _propTypes2.default.object,
	    supportMultipleAggregations: _propTypes2.default.bool
	}, _class.defaultProps = {
	    features: {
	        data: true,
	        filter: true,
	        aggregation: true,
	        breakout: true,
	        sort: true,
	        limit: true
	    },
	    supportMultipleAggregations: true
	}, _temp2);
	GuiQueryEditor.displayName = "GuiQueryEditor";
	exports.default = GuiQueryEditor;
	var AggregationWidget = exports.AggregationWidget = function AggregationWidget(_ref2) {
	    var index = _ref2.index,
	        aggregation = _ref2.aggregation,
	        query = _ref2.query,
	        updateQuery = _ref2.updateQuery,
	        addButton = _ref2.addButton;
	    return _react2.default.createElement(_AggregationWidget2.default, {
	        query: query,
	        aggregation: aggregation,
	        tableMetadata: query.tableMetadata(),
	        customFields: query.expressions(),
	        updateAggregation: function updateAggregation(aggregation) {
	            return query.updateAggregation(index, aggregation).update(updateQuery);
	        },
	        removeAggregation: query.canRemoveAggregation() ? function () {
	            return query.removeAggregation(index).update(updateQuery);
	        } : null,
	        addButton: addButton
	    });
	};
	
	AggregationWidget.displayName = "AggregationWidget";
	var BreakoutWidget = exports.BreakoutWidget = function BreakoutWidget(_ref3) {
	    var className = _ref3.className,
	        index = _ref3.index,
	        breakout = _ref3.breakout,
	        query = _ref3.query,
	        updateQuery = _ref3.updateQuery,
	        addButton = _ref3.addButton;
	    return _react2.default.createElement(_BreakoutWidget2.default, {
	        className: className,
	        field: breakout,
	        fieldOptions: query.breakoutOptions(breakout),
	        customFieldOptions: query.expressions(),
	        tableMetadata: query.tableMetadata(),
	        setField: function setField(field) {
	            return query.updateBreakout(index, field).update(updateQuery);
	        },
	        addButton: addButton
	    });
	};
	BreakoutWidget.displayName = "BreakoutWidget";

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FieldList = __webpack_require__(979);
	
	var _FieldList2 = _interopRequireDefault(_FieldList);
	
	var _FieldName = __webpack_require__(985);
	
	var _FieldName2 = _interopRequireDefault(_FieldName);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BreakoutWidget = (_temp = _class = function (_Component) {
	    _inherits(BreakoutWidget, _Component);
	
	    function BreakoutWidget(props, context) {
	        _classCallCheck(this, BreakoutWidget);
	
	        var _this = _possibleConstructorReturn(this, (BreakoutWidget.__proto__ || Object.getPrototypeOf(BreakoutWidget)).call(this, props, context));
	
	        _this.state = {
	            isOpen: props.isInitiallyOpen || false
	        };
	
	        _underscore2.default.bindAll(_this, "open", "close", "setBreakout");
	        return _this;
	    }
	
	    _createClass(BreakoutWidget, [{
	        key: "setBreakout",
	        value: function setBreakout(value) {
	            this.props.setField(value);
	            this.close();
	        }
	    }, {
	        key: "open",
	        value: function open() {
	            this.setState({ isOpen: true });
	        }
	    }, {
	        key: "close",
	        value: function close() {
	            this.setState({ isOpen: false });
	        }
	    }, {
	        key: "renderPopover",
	        value: function renderPopover() {
	            if (this.state.isOpen) {
	                return _react2.default.createElement(
	                    _Popover2.default,
	                    {
	                        id: "BreakoutPopover",
	                        ref: "popover",
	                        className: "FieldPopover",
	                        onClose: this.close
	                    },
	                    _react2.default.createElement(_FieldList2.default, {
	                        className: "text-green",
	                        tableMetadata: this.props.tableMetadata,
	                        field: this.props.field,
	                        fieldOptions: this.props.fieldOptions,
	                        customFieldOptions: this.props.customFieldOptions,
	                        onFieldChange: this.setBreakout,
	                        enableSubDimensions: this.props.enableSubDimensions
	                    })
	                );
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            // if we have a field then render FieldName, otherwise display our + option if enabled
	            var _props = this.props,
	                addButton = _props.addButton,
	                field = _props.field,
	                fieldOptions = _props.fieldOptions;
	
	
	            if (field) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center" },
	                    _react2.default.createElement(_FieldName2.default, {
	                        className: this.props.className,
	                        tableMetadata: this.props.tableMetadata,
	                        field: field,
	                        fieldOptions: this.props.fieldOptions,
	                        customFieldOptions: this.props.customFieldOptions,
	                        removeField: function removeField() {
	                            return _this2.setBreakout(null);
	                        },
	                        onClick: this.open
	                    }),
	                    this.renderPopover()
	                );
	            } else if (addButton && fieldOptions && fieldOptions.count > 0) {
	                return _react2.default.createElement(
	                    "div",
	                    { id: "BreakoutWidget", onClick: this.open },
	                    addButton,
	                    this.renderPopover()
	                );
	            } else {
	                // this needs to be here to prevent React error (#2304)
	                return null;
	            }
	        }
	    }]);
	
	    return BreakoutWidget;
	}(_react.Component), _class.propTypes = {
	    addButton: _propTypes2.default.object,
	    field: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	    fieldOptions: _propTypes2.default.object.isRequired,
	    customFieldOptions: _propTypes2.default.object,
	    setField: _propTypes2.default.func.isRequired,
	    isInitiallyOpen: _propTypes2.default.bool,
	    tableMetadata: _propTypes2.default.object.isRequired,
	    enableSubDimensions: _propTypes2.default.bool
	}, _class.defaultProps = {
	    enableSubDimensions: true
	}, _temp);
	BreakoutWidget.displayName = "BreakoutWidget";
	exports.default = BreakoutWidget;

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _AccordianList = __webpack_require__(977);
	
	var _AccordianList2 = _interopRequireDefault(_AccordianList);
	
	var _table = __webpack_require__(871);
	
	var _formatting = __webpack_require__(872);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataSelector = (_temp = _class = function (_Component) {
	    _inherits(DataSelector, _Component);
	
	    function DataSelector(props) {
	        _classCallCheck(this, DataSelector);
	
	        var _this = _possibleConstructorReturn(this, (DataSelector.__proto__ || Object.getPrototypeOf(DataSelector)).call(this));
	
	        _this.onChangeTable = function (item) {
	            if (item.table != null) {
	                _this.props.setSourceTableFn(item.table.id);
	            } else if (item.database != null) {
	                _this.props.setDatabaseFn(item.database.id);
	            }
	            _this.refs.popover.toggle();
	        };
	
	        _this.onChangeSegment = function (item) {
	            if (item.segment != null) {
	                _this.props.setSourceSegmentFn(item.segment.id);
	            }
	
	            _this.refs.popover.toggle();
	        };
	
	        _this.onChangeSchema = function (schema) {
	            _this.setState({
	                selectedSchema: schema,
	                showTablePicker: true
	            });
	        };
	
	        _this.onChangeSegmentSection = function () {
	            _this.setState({
	                showSegmentPicker: true
	            });
	        };
	
	        _this.onBack = function () {
	            _this.setState({
	                showTablePicker: false,
	                showSegmentPicker: false
	            });
	        };
	
	        _this.onChangeDatabase = function (index) {
	            var database = _this.state.databases[index];
	            var schema = database && (database.schemas.length > 1 ? null : database.schemas[0]);
	            if (database && database.tables.length === 0) {
	                schema = {
	                    database: database,
	                    name: "",
	                    tables: []
	                };
	            }
	            _this.setState({
	                selectedSchema: schema,
	                showTablePicker: !!schema
	            });
	        };
	
	        _this.state = {
	            databases: null,
	            selectedSchema: null,
	            showTablePicker: true,
	            showSegmentPicker: props.segments && props.segments.length > 0
	        };
	        return _this;
	    }
	
	    _createClass(DataSelector, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            this.componentWillReceiveProps(this.props);
	            if (this.props.databases.length === 1 && !this.props.segments) {
	                setTimeout(function () {
	                    return _this2.onChangeDatabase(0);
	                });
	            }
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            var tableId = newProps.datasetQuery.query && newProps.datasetQuery.query.source_table;
	            var selectedSchema = void 0;
	            // augment databases with schemas
	            var databases = newProps.databases && newProps.databases.map(function (database) {
	                var schemas = {};
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = database.tables.filter(_table.isQueryable)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var table = _step.value;
	
	                        var name = table.schema || "";
	                        schemas[name] = schemas[name] || {
	                            name: (0, _formatting.titleize)((0, _formatting.humanize)(name)),
	                            database: database,
	                            tables: []
	                        };
	                        schemas[name].tables.push(table);
	                        if (table.id === tableId) {
	                            selectedSchema = schemas[name];
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                schemas = Object.values(schemas);
	                // Hide the schema name if there is only one schema
	                if (schemas.length === 1) {
	                    schemas[0].name = "";
	                }
	                return _extends({}, database, {
	                    schemas: schemas.sort(function (a, b) {
	                        return a.name.localeCompare(b.name);
	                    })
	                });
	            });
	            this.setState({ databases: databases });
	            if (selectedSchema != undefined) {
	                this.setState({ selectedSchema: selectedSchema });
	            }
	        }
	    }, {
	        key: "getSegmentId",
	        value: function getSegmentId() {
	            return this.props.datasetQuery.segment;
	        }
	    }, {
	        key: "getDatabaseId",
	        value: function getDatabaseId() {
	            return this.props.datasetQuery.database;
	        }
	    }, {
	        key: "getTableId",
	        value: function getTableId() {
	            return this.props.datasetQuery.query && this.props.datasetQuery.query.source_table;
	        }
	    }, {
	        key: "renderDatabasePicker",
	        value: function renderDatabasePicker() {
	            var _this3 = this;
	
	            var sections = [{
	                items: this.state.databases.map(function (database) {
	                    return {
	                        name: database.name,
	                        database: database
	                    };
	                })
	            }];
	
	            return _react2.default.createElement(_AccordianList2.default, {
	                id: "DatabasePicker",
	                key: "schemaPicker",
	                className: "text-brand",
	                sections: sections,
	                onChange: this.onChangeTable,
	                itemIsSelected: function itemIsSelected(item) {
	                    return _this3.getDatabaseId() === item.database.id;
	                },
	                renderItemIcon: function renderItemIcon() {
	                    return _react2.default.createElement(_Icon2.default, { className: "Icon text-default", name: "database", size: 18 });
	                },
	                showItemArrows: false
	            });
	        }
	    }, {
	        key: "renderDatabaseSchemaPicker",
	        value: function renderDatabaseSchemaPicker() {
	            var _this4 = this;
	
	            var _state = this.state,
	                databases = _state.databases,
	                selectedSchema = _state.selectedSchema;
	
	
	            var sections = databases.map(function (database) {
	                return {
	                    name: database.name,
	                    items: database.schemas.length > 1 ? database.schemas : [],
	                    className: database.is_saved_questions ? "bg-slate-extra-light" : null,
	                    icon: database.is_saved_questions ? 'all' : 'database'
	                };
	            });
	
	            var openSection = selectedSchema && _underscore2.default.findIndex(databases, function (db) {
	                return _underscore2.default.find(db.schemas, selectedSchema);
	            });
	            if (openSection >= 0 && databases[openSection] && databases[openSection].schemas.length === 1) {
	                openSection = -1;
	            }
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_AccordianList2.default, {
	                    id: "DatabaseSchemaPicker",
	                    key: "schemaPicker",
	                    className: "text-brand",
	                    sections: sections,
	                    onChange: this.onChangeSchema,
	                    onChangeSection: this.onChangeDatabase,
	                    itemIsSelected: function itemIsSelected(schema) {
	                        return _this4.state.selectedSchema === schema;
	                    },
	                    renderSectionIcon: function renderSectionIcon(item) {
	                        return _react2.default.createElement(_Icon2.default, {
	                            className: "Icon text-default",
	                            name: item.icon,
	                            size: 18
	                        });
	                    },
	                    renderItemIcon: function renderItemIcon() {
	                        return _react2.default.createElement(_Icon2.default, { name: "folder", size: 16 });
	                    },
	                    initiallyOpenSection: openSection,
	                    showItemArrows: true,
	                    alwaysTogglable: true
	                })
	            );
	        }
	    }, {
	        key: "renderSegmentAndDatabasePicker",
	        value: function renderSegmentAndDatabasePicker() {
	            var _this5 = this;
	
	            var selectedSchema = this.state.selectedSchema;
	
	
	            var segmentItem = [{ name: 'Segments', items: [], icon: 'segment' }];
	
	            var sections = segmentItem.concat(this.state.databases.map(function (database) {
	                return {
	                    name: database.name,
	                    items: database.schemas.length > 1 ? database.schemas : []
	                };
	            }));
	
	            // FIXME: this seems a bit brittle and hard to follow
	            var openSection = selectedSchema && _underscore2.default.findIndex(this.state.databases, function (db) {
	                return _underscore2.default.find(db.schemas, selectedSchema);
	            }) + segmentItem.length;
	            if (openSection >= 0 && this.state.databases[openSection - segmentItem.length] && this.state.databases[openSection - segmentItem.length].schemas.length === 1) {
	                openSection = -1;
	            }
	
	            return _react2.default.createElement(_AccordianList2.default, {
	                key: "schemaPicker",
	                className: "text-brand",
	                sections: sections,
	                onChange: this.onChangeSchema,
	                onChangeSection: function onChangeSection(index) {
	                    return index === 0 ? _this5.onChangeSegmentSection() : _this5.onChangeDatabase(index - segmentItem.length);
	                },
	                itemIsSelected: function itemIsSelected(schema) {
	                    return _this5.state.selectedSchema === schema;
	                },
	                renderSectionIcon: function renderSectionIcon(section, sectionIndex) {
	                    return _react2.default.createElement(_Icon2.default, { className: "Icon text-default", name: section.icon || "database", size: 18 });
	                },
	                renderItemIcon: function renderItemIcon() {
	                    return _react2.default.createElement(_Icon2.default, { name: "folder", size: 16 });
	                },
	                initiallyOpenSection: openSection,
	                showItemArrows: true,
	                alwaysTogglable: true
	            });
	        }
	    }, {
	        key: "renderTablePicker",
	        value: function renderTablePicker() {
	            var _this6 = this;
	
	            var schema = this.state.selectedSchema;
	
	            var isSavedQuestionList = schema.database.is_saved_questions;
	
	            var hasMultipleDatabases = this.props.databases.length > 1;
	            var hasMultipleSchemas = schema && schema.database && _underscore2.default.uniq(schema.database.tables, function (t) {
	                return t.schema;
	            }).length > 1;
	            var hasSegments = !!this.props.segments;
	            var hasMultipleSources = hasMultipleDatabases || hasMultipleSchemas || hasSegments;
	
	            var header = _react2.default.createElement(
	                "div",
	                { className: "flex flex-wrap align-center" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "flex align-center text-brand-hover cursor-pointer", onClick: hasMultipleSources && this.onBack },
	                    hasMultipleSources && _react2.default.createElement(_Icon2.default, { name: "chevronleft", size: 18 }),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "ml1" },
	                        schema.database.name
	                    )
	                ),
	                schema.name && _react2.default.createElement(
	                    "span",
	                    { className: "ml1 text-slate" },
	                    "- ",
	                    schema.name
	                )
	            );
	
	            if (schema.tables.length === 0) {
	                // this is a database with no tables!
	                return _react2.default.createElement(
	                    "section",
	                    { className: "List-section List-section--open", style: { width: 300 } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "p1 border-bottom" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "px1 py1 flex align-center" },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "text-default" },
	                                header
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "p4 text-centered" },
	                        "No tables found in this database."
	                    )
	                );
	            } else {
	                var sections = [{
	                    name: header,
	                    items: schema.tables.map(function (table) {
	                        return {
	                            name: table.display_name,
	                            disabled: _this6.props.disabledTableIds && _this6.props.disabledTableIds.includes(table.id),
	                            table: table,
	                            database: schema.database
	                        };
	                    })
	                }];
	                return _react2.default.createElement(
	                    "div",
	                    { style: { width: 300 } },
	                    _react2.default.createElement(_AccordianList2.default, {
	                        id: "TablePicker",
	                        key: "tablePicker",
	                        className: "text-brand",
	                        sections: sections,
	                        searchable: true,
	                        onChange: this.onChangeTable,
	                        itemIsSelected: function itemIsSelected(item) {
	                            return item.table ? item.table.id === _this6.getTableId() : false;
	                        },
	                        itemIsClickable: function itemIsClickable(item) {
	                            return item.table && !item.disabled;
	                        },
	                        renderItemIcon: function renderItemIcon(item) {
	                            return item.table ? _react2.default.createElement(_Icon2.default, { name: "table2", size: 18 }) : null;
	                        },
	                        hideSingleSectionTitle: true
	                    }),
	                    isSavedQuestionList && _react2.default.createElement(
	                        "div",
	                        { className: "bg-slate-extra-light p2 text-centered" },
	                        "Is a question missing?",
	                        _react2.default.createElement(
	                            "a",
	                            { href: "http://metabase.com/docs/latest/users-guide/04-asking-questions.html#source-data", className: "block link" },
	                            "Learn more about nested queries"
	                        )
	                    )
	                );
	            }
	        }
	
	        //TODO: refactor this. lots of shared code with renderTablePicker()
	
	    }, {
	        key: "renderSegmentPicker",
	        value: function renderSegmentPicker() {
	            var _this7 = this;
	
	            var segments = this.props.segments;
	
	            var header = _react2.default.createElement(
	                "span",
	                { className: "flex align-center" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "flex align-center text-slate cursor-pointer", onClick: this.onBack },
	                    _react2.default.createElement(_Icon2.default, { name: "chevronleft", size: 18 }),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "ml1" },
	                        "Segments"
	                    )
	                )
	            );
	
	            if (!segments || segments.length === 0) {
	                return _react2.default.createElement(
	                    "section",
	                    { className: "List-section List-section--open", style: { width: '300px' } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "p1 border-bottom" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "px1 py1 flex align-center" },
	                            _react2.default.createElement(
	                                "h3",
	                                { className: "text-default" },
	                                header
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "p4 text-centered" },
	                        "No segments were found."
	                    )
	                );
	            }
	
	            var sections = [{
	                name: header,
	                items: segments.map(function (segment) {
	                    return {
	                        name: segment.name,
	                        segment: segment,
	                        disabled: _this7.props.disabledSegmentIds && _this7.props.disabledSegmentIds.includes(segment.id)
	                    };
	                })
	            }];
	
	            return _react2.default.createElement(_AccordianList2.default, {
	                key: "segmentPicker",
	                className: "text-brand",
	                sections: sections,
	                searchable: true,
	                searchPlaceholder: "Find a segment",
	                onChange: this.onChangeSegment,
	                itemIsSelected: function itemIsSelected(item) {
	                    return item.segment ? item.segment.id === _this7.getSegmentId() : false;
	                },
	                itemIsClickable: function itemIsClickable(item) {
	                    return item.segment && !item.disabled;
	                },
	                renderItemIcon: function renderItemIcon(item) {
	                    return item.segment ? _react2.default.createElement(_Icon2.default, { name: "segment", size: 18 }) : null;
	                },
	                hideSingleSectionTitle: true
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var databases = this.props.databases;
	
	
	            var dbId = this.getDatabaseId();
	            var tableId = this.getTableId();
	            var database = _underscore2.default.find(databases, function (db) {
	                return db.id === dbId;
	            });
	            var table = _underscore2.default.find(database && database.tables, function (table) {
	                return table.id === tableId;
	            });
	
	            var content;
	            if (this.props.includeTables && this.props.segments) {
	                var segmentId = this.getSegmentId();
	                var segment = _underscore2.default.find(this.props.segments, function (segment) {
	                    return segment.id === segmentId;
	                });
	                if (table) {
	                    content = _react2.default.createElement(
	                        "span",
	                        { className: "text-grey no-decoration" },
	                        table.display_name || table.name
	                    );
	                } else if (segment) {
	                    content = _react2.default.createElement(
	                        "span",
	                        { className: "text-grey no-decoration" },
	                        segment.name
	                    );
	                } else {
	                    content = _react2.default.createElement(
	                        "span",
	                        { className: "text-grey-4 no-decoration" },
	                        "Pick a segment or table"
	                    );
	                }
	            } else if (this.props.includeTables) {
	                if (table) {
	                    content = _react2.default.createElement(
	                        "span",
	                        { className: "text-grey no-decoration" },
	                        table.display_name || table.name
	                    );
	                } else {
	                    content = _react2.default.createElement(
	                        "span",
	                        { className: "text-grey-4 no-decoration" },
	                        "Select a table"
	                    );
	                }
	            } else {
	                if (database) {
	                    content = _react2.default.createElement(
	                        "span",
	                        { className: "text-grey no-decoration" },
	                        database.name
	                    );
	                } else {
	                    content = _react2.default.createElement(
	                        "span",
	                        { className: "text-grey-4 no-decoration" },
	                        "Select a database"
	                    );
	                }
	            }
	
	            var triggerElement = _react2.default.createElement(
	                "span",
	                { className: this.props.className || "px2 py2 text-bold cursor-pointer text-default", style: this.props.style },
	                content,
	                _react2.default.createElement(_Icon2.default, { className: "ml1", name: "chevrondown", size: this.props.triggerIconSize || 8 })
	            );
	
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                {
	                    id: "DataPopover",
	                    ref: "popover",
	                    sizeToFit: true,
	                    isInitiallyOpen: this.props.isInitiallyOpen,
	                    triggerElement: triggerElement,
	                    triggerClasses: "flex align-center",
	                    horizontalAttachments: this.props.segments ? ["center", "left", "right"] : ["left"]
	                },
	                !this.props.includeTables ? this.renderDatabasePicker() : this.state.selectedSchema && this.state.showTablePicker ? this.renderTablePicker() : this.props.segments ? this.state.showSegmentPicker ? this.renderSegmentPicker() : this.renderSegmentAndDatabasePicker() : this.renderDatabaseSchemaPicker()
	            );
	        }
	    }]);
	
	    return DataSelector;
	}(_react.Component), _class.propTypes = {
	    datasetQuery: _propTypes2.default.object.isRequired,
	    databases: _propTypes2.default.array.isRequired,
	    tables: _propTypes2.default.array,
	    segments: _propTypes2.default.array,
	    disabledTableIds: _propTypes2.default.array,
	    disabledSegmentIds: _propTypes2.default.array,
	    setDatabaseFn: _propTypes2.default.func.isRequired,
	    setSourceTableFn: _propTypes2.default.func,
	    setSourceSegmentFn: _propTypes2.default.func,
	    isInitiallyOpen: _propTypes2.default.bool
	}, _class.defaultProps = {
	    isInitiallyOpen: false,
	    includeTables: false
	}, _temp);
	DataSelector.displayName = "DataSelector";
	exports.default = DataSelector;

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; /*  weak */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AddClauseButton = __webpack_require__(1732);
	
	var _AddClauseButton2 = _interopRequireDefault(_AddClauseButton);
	
	var _Expressions = __webpack_require__(1733);
	
	var _Expressions2 = _interopRequireDefault(_Expressions);
	
	var _ExpressionWidget = __webpack_require__(1734);
	
	var _ExpressionWidget2 = _interopRequireDefault(_ExpressionWidget);
	
	var _LimitWidget = __webpack_require__(1735);
	
	var _LimitWidget2 = _interopRequireDefault(_LimitWidget);
	
	var _SortWidget = __webpack_require__(1736);
	
	var _SortWidget2 = _interopRequireDefault(_SortWidget);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExtendedOptions = (_temp2 = _class = function (_Component) {
	    _inherits(ExtendedOptions, _Component);
	
	    function ExtendedOptions() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ExtendedOptions);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ExtendedOptions.__proto__ || Object.getPrototypeOf(ExtendedOptions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isOpen: false,
	            editExpression: null
	        }, _this.setLimit = function (limit) {
	            var _this$props = _this.props,
	                query = _this$props.query,
	                setDatasetQuery = _this$props.setDatasetQuery;
	
	            query.updateLimit(limit).update(setDatasetQuery);
	            _analytics2.default.trackEvent('QueryBuilder', 'Set Limit', limit);
	            _this.setState({ isOpen: false });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ExtendedOptions, [{
	        key: "setExpression",
	        value: function setExpression(name, expression, previousName) {
	            var _props = this.props,
	                query = _props.query,
	                setDatasetQuery = _props.setDatasetQuery;
	
	            query.updateExpression(name, expression, previousName).update(setDatasetQuery);
	            this.setState({ editExpression: null });
	            _analytics2.default.trackEvent('QueryBuilder', 'Set Expression', !_underscore2.default.isEmpty(previousName));
	        }
	    }, {
	        key: "removeExpression",
	        value: function removeExpression(name) {
	            var _props2 = this.props,
	                query = _props2.query,
	                setDatasetQuery = _props2.setDatasetQuery;
	
	            query.removeExpression(name).update(setDatasetQuery);
	            this.setState({ editExpression: null });
	
	            _analytics2.default.trackEvent('QueryBuilder', 'Remove Expression');
	        }
	    }, {
	        key: "renderSort",
	        value: function renderSort() {
	            var _props3 = this.props,
	                query = _props3.query,
	                setDatasetQuery = _props3.setDatasetQuery;
	
	
	            if (!this.props.features.limit) {
	                return;
	            }
	
	            var sortList = void 0,
	                addSortButton = void 0;
	
	            var tableMetadata = query.table();
	            if (tableMetadata) {
	                var sorts = query.sorts();
	
	                sortList = sorts.map(function (sort, index) {
	                    return _react2.default.createElement(_SortWidget2.default, {
	                        key: index,
	                        query: query,
	                        tableMetadata: query.table(),
	                        sort: sort,
	                        fieldOptions: query.sortOptions(sort),
	                        removeOrderBy: function removeOrderBy() {
	                            return query.removeSort(index).update(setDatasetQuery);
	                        },
	                        updateOrderBy: function updateOrderBy(orderBy) {
	                            return query.updateSort(index, orderBy).update(setDatasetQuery);
	                        }
	                    });
	                });
	
	                if (query.canAddSort()) {
	                    addSortButton = _react2.default.createElement(_AddClauseButton2.default, { text: "Pick a field to sort by", onClick: function onClick() {
	                            // $FlowFixMe: shouldn't be adding a sort with null field
	                            query.addSort([null, "ascending"]).update(setDatasetQuery);
	                        } });
	                }
	            }
	
	            if (sortList && sortList.length > 0 || addSortButton) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "pb3" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "pb1 h6 text-uppercase text-grey-3 text-bold" },
	                        "Sort"
	                    ),
	                    sortList,
	                    addSortButton
	                );
	            }
	        }
	    }, {
	        key: "renderExpressionWidget",
	        value: function renderExpressionWidget() {
	            var _this2 = this;
	
	            // if we aren't editing any expression then there is nothing to do
	            if (!this.state.editExpression || !this.props.tableMetadata) return null;
	
	            var query = this.props.query;
	
	
	            var expressions = query.expressions();
	            var expression = expressions && expressions[this.state.editExpression];
	            var name = _underscore2.default.isString(this.state.editExpression) ? this.state.editExpression : "";
	
	            return _react2.default.createElement(
	                _Popover2.default,
	                { onClose: function onClose() {
	                        return _this2.setState({ editExpression: null });
	                    } },
	                _react2.default.createElement(_ExpressionWidget2.default, {
	                    name: name,
	                    expression: expression,
	                    tableMetadata: query.table(),
	                    onSetExpression: function onSetExpression(newName, newExpression) {
	                        return _this2.setExpression(newName, newExpression, name);
	                    },
	                    onRemoveExpression: function onRemoveExpression(name) {
	                        return _this2.removeExpression(name);
	                    },
	                    onCancel: function onCancel() {
	                        return _this2.setState({ editExpression: null });
	                    }
	                })
	            );
	        }
	    }, {
	        key: "renderPopover",
	        value: function renderPopover() {
	            var _this3 = this;
	
	            if (!this.state.isOpen) return null;
	
	            var _props4 = this.props,
	                features = _props4.features,
	                query = _props4.query;
	
	
	            return _react2.default.createElement(
	                _Popover2.default,
	                { onClose: function onClose() {
	                        return _this3.setState({ isOpen: false });
	                    } },
	                _react2.default.createElement(
	                    "div",
	                    { className: "p3" },
	                    this.renderSort(),
	                    _underscore2.default.contains(query.table().db.features, "expressions") ? _react2.default.createElement(_Expressions2.default, {
	                        expressions: query.expressions(),
	                        tableMetadata: query.table(),
	                        onAddExpression: function onAddExpression() {
	                            return _this3.setState({ isOpen: false, editExpression: true });
	                        },
	                        onEditExpression: function onEditExpression(name) {
	                            _this3.setState({ isOpen: false, editExpression: name });
	                            _analytics2.default.trackEvent("QueryBuilder", "Show Edit Custom Field");
	                        }
	                    }) : null,
	                    features.limit && _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: "mb1 h6 text-uppercase text-grey-3 text-bold" },
	                            "Row limit"
	                        ),
	                        _react2.default.createElement(_LimitWidget2.default, { limit: query.limit(), onChange: this.setLimit })
	                    )
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var features = this.props.features;
	
	            if (!features.sort && !features.limit) return null;
	
	            var onClick = this.props.tableMetadata ? function () {
	                return _this4.setState({ isOpen: true });
	            } : null;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "GuiBuilder-section GuiBuilder-sort-limit flex align-center" },
	                _react2.default.createElement(
	                    "span",
	                    { className: (0, _classnames2.default)("EllipsisButton no-decoration text-grey-1 px1", { "cursor-pointer": onClick }), onClick: onClick },
	                    "\u2026"
	                ),
	                this.renderPopover(),
	                this.renderExpressionWidget()
	            );
	        }
	    }]);
	
	    return ExtendedOptions;
	}(_react.Component), _class.propTypes = {
	    features: _propTypes2.default.object.isRequired,
	    datasetQuery: _propTypes2.default.object.isRequired,
	    tableMetadata: _propTypes2.default.object,
	    setDatasetQuery: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	    expressions: {}
	}, _temp2);
	ExtendedOptions.displayName = "ExtendedOptions";
	exports.default = ExtendedOptions;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _IconBorder = __webpack_require__(1289);
	
	var _IconBorder2 = _interopRequireDefault(_IconBorder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddClauseButton = (_temp = _class = function (_Component) {
	    _inherits(AddClauseButton, _Component);
	
	    function AddClauseButton() {
	        _classCallCheck(this, AddClauseButton);
	
	        return _possibleConstructorReturn(this, (AddClauseButton.__proto__ || Object.getPrototypeOf(AddClauseButton)).apply(this, arguments));
	    }
	
	    _createClass(AddClauseButton, [{
	        key: "renderAddIcon",
	        value: function renderAddIcon() {
	            return _react2.default.createElement(
	                _IconBorder2.default,
	                { borderRadius: "3px" },
	                _react2.default.createElement(_Icon2.default, { name: "add", size: 14 })
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                text = _props.text,
	                onClick = _props.onClick;
	
	
	            var className = "text-grey-2 text-bold flex align-center text-grey-4-hover cursor-pointer no-decoration transition-color";
	            if (onClick) {
	                return _react2.default.createElement(
	                    "a",
	                    { className: className, onClick: onClick },
	                    this.renderAddIcon(),
	                    text && _react2.default.createElement(
	                        "span",
	                        { className: "ml1" },
	                        text
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    "span",
	                    { className: className },
	                    this.renderAddIcon(),
	                    text && _react2.default.createElement(
	                        "span",
	                        { className: "ml1" },
	                        text
	                    )
	                );
	            }
	        }
	    }]);
	
	    return AddClauseButton;
	}(_react.Component), _class.propTypes = {
	    text: _propTypes2.default.string,
	    onClick: _propTypes2.default.func
	}, _temp);
	AddClauseButton.displayName = "AddClauseButton";
	exports.default = AddClauseButton;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _IconBorder = __webpack_require__(1289);
	
	var _IconBorder2 = _interopRequireDefault(_IconBorder);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _formatter = __webpack_require__(883);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Expressions = (_temp = _class = function (_Component) {
	    _inherits(Expressions, _Component);
	
	    function Expressions() {
	        _classCallCheck(this, Expressions);
	
	        return _possibleConstructorReturn(this, (Expressions.__proto__ || Object.getPrototypeOf(Expressions)).apply(this, arguments));
	    }
	
	    _createClass(Expressions, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                expressions = _props.expressions,
	                onAddExpression = _props.onAddExpression,
	                onEditExpression = _props.onEditExpression;
	
	
	            var sortedNames = _underscore2.default.sortBy(_underscore2.default.keys(expressions), _underscore2.default.identity);
	            return _react2.default.createElement(
	                "div",
	                { className: "pb3" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "pb1 h6 text-uppercase text-grey-3 text-bold" },
	                    "Custom fields"
	                ),
	                sortedNames && sortedNames.map(function (name) {
	                    return _react2.default.createElement(
	                        "div",
	                        { key: name, className: "pb1 text-brand text-bold cursor-pointer flex flex-row align-center justify-between", onClick: function onClick() {
	                                return onEditExpression(name);
	                            } },
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            name
	                        ),
	                        _react2.default.createElement(
	                            _Tooltip2.default,
	                            { tooltip: (0, _formatter.format)(expressions[name], {
	                                    tableMetadata: _this2.props.tableMetadata,
	                                    customFields: expressions
	                                }) },
	                            _react2.default.createElement("span", { className: "QuestionTooltipTarget" })
	                        )
	                    );
	                }),
	                _react2.default.createElement(
	                    "a",
	                    { "data-metabase-event": "QueryBuilder;Show Add Custom Field", className: "text-grey-2 text-bold flex align-center text-grey-4-hover cursor-pointer no-decoration transition-color", onClick: function onClick() {
	                            return onAddExpression();
	                        } },
	                    _react2.default.createElement(
	                        _IconBorder2.default,
	                        { borderRadius: "3px" },
	                        _react2.default.createElement(_Icon2.default, { name: "add", size: 14 })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "ml1" },
	                        "Add a custom field"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Expressions;
	}(_react.Component), _class.propTypes = {
	    expressions: _propTypes2.default.object,
	    tableMetadata: _propTypes2.default.object,
	    onAddExpression: _propTypes2.default.func.isRequired,
	    onEditExpression: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	    expressions: {}
	}, _temp);
	Expressions.displayName = "Expressions";
	exports.default = Expressions;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _ExpressionEditorTextfield = __webpack_require__(1008);
	
	var _ExpressionEditorTextfield2 = _interopRequireDefault(_ExpressionEditorTextfield);
	
	var _expressions = __webpack_require__(884);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpressionWidget = (_temp = _class = function (_Component) {
	    _inherits(ExpressionWidget, _Component);
	
	    function ExpressionWidget() {
	        _classCallCheck(this, ExpressionWidget);
	
	        return _possibleConstructorReturn(this, (ExpressionWidget.__proto__ || Object.getPrototypeOf(ExpressionWidget)).apply(this, arguments));
	    }
	
	    _createClass(ExpressionWidget, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.componentWillReceiveProps(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            this.setState({
	                name: newProps.name,
	                expression: newProps.expression
	            });
	        }
	    }, {
	        key: "isValid",
	        value: function isValid() {
	            var _state = this.state,
	                name = _state.name,
	                expression = _state.expression,
	                error = _state.error;
	
	            return !_underscore2.default.isEmpty(name) && !error && (0, _expressions.isExpression)(expression);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var expression = this.state.expression;
	
	
	            return _react2.default.createElement(
	                "div",
	                { style: { maxWidth: "600px" } },
	                _react2.default.createElement(
	                    "div",
	                    { className: "p2" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "h5 text-uppercase text-grey-3 text-bold" },
	                        "Field formula"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_ExpressionEditorTextfield2.default, {
	                            expression: expression,
	                            tableMetadata: this.props.tableMetadata,
	                            onChange: function onChange(parsedExpression) {
	                                return _this2.setState({ expression: parsedExpression, error: null });
	                            },
	                            onError: function onError(errorMessage) {
	                                return _this2.setState({ error: errorMessage });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "p",
	                            { className: "h5 text-grey-5" },
	                            "Think of this as being kind of like writing a formula in a spreadsheet program: you can use numbers, fields in this table, mathematical symbols like +, and some functions.  So you could type something like Subtotal \u2212 Cost. \xA0",
	                            _react2.default.createElement(
	                                "a",
	                                { className: "link", target: "_blank", href: "http://www.metabase.com/docs/latest/users-guide/04-asking-questions.html#creating-a-custom-field" },
	                                "Learn more"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "mt3 h5 text-uppercase text-grey-3 text-bold" },
	                        "Give it a name"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement("input", {
	                            className: "my1 input block full",
	                            type: "text",
	                            value: this.state.name,
	                            placeholder: "Something nice and descriptive",
	                            onChange: function onChange(event) {
	                                return _this2.setState({ name: event.target.value });
	                            }
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "mt2 p2 border-top flex flex-row align-center justify-between" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ml-auto" },
	                        _react2.default.createElement(
	                            "button",
	                            { className: "Button", onClick: function onClick() {
	                                    return _this2.props.onCancel();
	                                } },
	                            "Cancel"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            {
	                                className: (0, _classnames2.default)("Button ml2", { "Button--primary": this.isValid() }),
	                                onClick: function onClick() {
	                                    return _this2.props.onSetExpression(_this2.state.name, _this2.state.expression);
	                                },
	                                disabled: !this.isValid() },
	                            this.props.expression ? "Update" : "Done"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        this.props.expression ? _react2.default.createElement(
	                            "a",
	                            { className: "pr2 text-warning link", onClick: function onClick() {
	                                    return _this2.props.onRemoveExpression(_this2.props.name);
	                                } },
	                            "Remove"
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ExpressionWidget;
	}(_react.Component), _class.propTypes = {
	    expression: _propTypes2.default.array,
	    name: _propTypes2.default.string,
	    tableMetadata: _propTypes2.default.object.isRequired,
	    onSetExpression: _propTypes2.default.func.isRequired,
	    onRemoveExpression: _propTypes2.default.func.isRequired,
	    onCancel: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	    expression: null,
	    name: ""
	}, _temp);
	ExpressionWidget.displayName = "ExpressionWidget";
	exports.default = ExpressionWidget;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LimitWidget = (_temp = _class = function (_Component) {
	    _inherits(LimitWidget, _Component);
	
	    function LimitWidget() {
	        _classCallCheck(this, LimitWidget);
	
	        return _possibleConstructorReturn(this, (LimitWidget.__proto__ || Object.getPrototypeOf(LimitWidget)).apply(this, arguments));
	    }
	
	    _createClass(LimitWidget, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                "ul",
	                { className: "Button-group Button-group--blue" },
	                this.props.options.map(function (count) {
	                    return _react2.default.createElement(
	                        "li",
	                        { key: count || "None", className: (0, _classnames2.default)("Button", { "Button--active": count === _this2.props.limit }), onClick: function onClick() {
	                                return _this2.props.onChange(count);
	                            } },
	                        count || "None"
	                    );
	                })
	            );
	        }
	    }]);
	
	    return LimitWidget;
	}(_react.Component), _class.propTypes = {
	    limit: _propTypes2.default.number,
	    onChange: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	    options: [undefined, 1, 10, 25, 100, 1000]
	}, _temp);
	LimitWidget.displayName = "LimitWidget";
	exports.default = LimitWidget;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _FieldWidget = __webpack_require__(1737);
	
	var _FieldWidget2 = _interopRequireDefault(_FieldWidget);
	
	var _SelectionModule = __webpack_require__(1738);
	
	var _SelectionModule2 = _interopRequireDefault(_SelectionModule);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SortWidget = (_temp = _class = function (_Component) {
	    _inherits(SortWidget, _Component);
	
	    function SortWidget(props, context) {
	        _classCallCheck(this, SortWidget);
	
	        var _this = _possibleConstructorReturn(this, (SortWidget.__proto__ || Object.getPrototypeOf(SortWidget)).call(this, props, context));
	
	        _underscore2.default.bindAll(_this, "setDirection", "setField");
	        return _this;
	    }
	
	    _createClass(SortWidget, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.componentWillReceiveProps(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            this.setState({
	                field: newProps.sort[0], // id of the field
	                direction: newProps.sort[1] // sort direction
	            });
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            // Remove partially completed sort if the widget is removed
	            if (this.state.field == null || this.state.direction == null) {
	                this.props.removeOrderBy();
	            }
	        }
	    }, {
	        key: "setField",
	        value: function setField(value) {
	            if (this.state.field !== value) {
	                this.props.updateOrderBy([value, this.state.direction]);
	                // Optimistically set field state so componentWillUnmount logic works correctly
	                this.setState({ field: value });
	            }
	        }
	    }, {
	        key: "setDirection",
	        value: function setDirection(value) {
	            if (this.state.direction !== value) {
	                this.props.updateOrderBy([this.state.field, value]);
	                // Optimistically set direction state so componentWillUnmount logic works correctly
	                this.setState({ direction: value });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var directionOptions = [{ key: "ascending", val: "ascending" }, { key: "descending", val: "descending" }];
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex align-center" },
	                _react2.default.createElement(_FieldWidget2.default, {
	                    query: this.props.query,
	                    className: "Filter-section Filter-section-sort-field SelectionModule",
	                    tableMetadata: this.props.tableMetadata,
	                    field: this.state.field,
	                    fieldOptions: this.props.fieldOptions,
	                    customFieldOptions: this.props.customFieldOptions,
	                    setField: this.setField,
	                    isInitiallyOpen: this.state.field === null,
	                    enableSubDimensions: false
	                }),
	                _react2.default.createElement(_SelectionModule2.default, {
	                    className: "Filter-section Filter-section-sort-direction",
	                    placeholder: "...",
	                    items: directionOptions,
	                    display: "key",
	                    selectedValue: this.state.direction,
	                    selectedKey: "val",
	                    isInitiallyOpen: false,
	                    action: this.setDirection
	                }),
	                _react2.default.createElement(
	                    "a",
	                    { onClick: this.props.removeOrderBy },
	                    _react2.default.createElement(_Icon2.default, { name: "close", size: 12 })
	                )
	            );
	        }
	    }]);
	
	    return SortWidget;
	}(_react.Component), _class.propTypes = {
	    sort: _propTypes2.default.array.isRequired,
	    fieldOptions: _propTypes2.default.object.isRequired,
	    customFieldOptions: _propTypes2.default.object,
	    tableName: _propTypes2.default.string,
	    updateOrderBy: _propTypes2.default.func.isRequired,
	    removeOrderBy: _propTypes2.default.func.isRequired,
	    tableMetadata: _propTypes2.default.object.isRequired
	}, _temp);
	SortWidget.displayName = "SortWidget";
	exports.default = SortWidget;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FieldList = __webpack_require__(979);
	
	var _FieldList2 = _interopRequireDefault(_FieldList);
	
	var _FieldName = __webpack_require__(985);
	
	var _FieldName2 = _interopRequireDefault(_FieldName);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FieldWidget = (_temp = _class = function (_Component) {
	    _inherits(FieldWidget, _Component);
	
	    function FieldWidget(props, context) {
	        _classCallCheck(this, FieldWidget);
	
	        var _this = _possibleConstructorReturn(this, (FieldWidget.__proto__ || Object.getPrototypeOf(FieldWidget)).call(this, props, context));
	
	        _this.state = {
	            isOpen: props.isInitiallyOpen || false
	        };
	
	        _underscore2.default.bindAll(_this, "toggle", "setField");
	        return _this;
	    }
	
	    _createClass(FieldWidget, [{
	        key: "setField",
	        value: function setField(value) {
	            this.props.setField(value);
	            if (_query2.default.isValidField(value)) {
	                this.toggle();
	            }
	        }
	    }, {
	        key: "toggle",
	        value: function toggle() {
	            this.setState({ isOpen: !this.state.isOpen });
	        }
	    }, {
	        key: "renderPopover",
	        value: function renderPopover() {
	            if (this.state.isOpen) {
	                return _react2.default.createElement(
	                    _Popover2.default,
	                    {
	                        ref: "popover",
	                        className: "FieldPopover",
	                        onClose: this.toggle
	                    },
	                    _react2.default.createElement(_FieldList2.default, {
	                        className: "text-" + this.props.color,
	                        tableMetadata: this.props.tableMetadata,
	                        field: this.props.field,
	                        fieldOptions: this.props.fieldOptions,
	                        customFieldOptions: this.props.customFieldOptions,
	                        onFieldChange: this.setField,
	                        enableSubDimensions: this.props.enableSubDimensions
	                    })
	                );
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                field = _props.field,
	                query = _props.query;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex align-center" },
	                _react2.default.createElement(_FieldName2.default, {
	                    className: className,
	                    field: field,
	                    query: query,
	                    tableMetadata: this.props.tableMetadata,
	                    fieldOptions: this.props.fieldOptions,
	                    customFieldOptions: this.props.customFieldOptions,
	                    removeField: this.props.removeField,
	                    onClick: this.toggle
	                }),
	                this.renderPopover()
	            );
	        }
	    }]);
	
	    return FieldWidget;
	}(_react.Component), _class.propTypes = {
	    field: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	    fieldOptions: _propTypes2.default.object.isRequired,
	    customFieldOptions: _propTypes2.default.object,
	    setField: _propTypes2.default.func.isRequired,
	    removeField: _propTypes2.default.func,
	    isInitiallyOpen: _propTypes2.default.bool,
	    tableMetadata: _propTypes2.default.object.isRequired,
	    enableSubDimensions: _propTypes2.default.bool
	}, _class.defaultProps = {
	    color: "brand",
	    enableSubDimensions: true
	}, _temp);
	FieldWidget.displayName = "FieldWidget";
	exports.default = FieldWidget;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SearchBar = __webpack_require__(1739);
	
	var _SearchBar2 = _interopRequireDefault(_SearchBar);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectionModule = (_temp = _class = function (_Component) {
	    _inherits(SelectionModule, _Component);
	
	    function SelectionModule(props, context) {
	        _classCallCheck(this, SelectionModule);
	
	        var _this = _possibleConstructorReturn(this, (SelectionModule.__proto__ || Object.getPrototypeOf(SelectionModule)).call(this, props, context));
	
	        _this._expand = _this._expand.bind(_this);
	        _this._select = _this._select.bind(_this);
	        _this._toggleOpen = _this._toggleOpen.bind(_this);
	        _this.onClose = _this.onClose.bind(_this);
	        // a selection module can be told to be open on initialization but otherwise is closed
	        var isInitiallyOpen = props.isInitiallyOpen || false;
	
	        _this.state = {
	            open: isInitiallyOpen,
	            expanded: false,
	            searchThreshold: 20,
	            searchEnabled: false,
	            filterTerm: null
	        };
	        return _this;
	    }
	
	    _createClass(SelectionModule, [{
	        key: "onClose",
	        value: function onClose() {
	            this.setState({
	                open: false,
	                expanded: false
	            });
	        }
	    }, {
	        key: "_enableSearch",
	        value: function _enableSearch() {
	            /*
	            not showing search for now
	            if(this.props.items.length > this.state.searchThreshold) {
	                return true
	            } else {
	                return false
	            }
	            */
	            return false;
	        }
	    }, {
	        key: "_toggleOpen",
	        value: function _toggleOpen() {
	            this.setState({
	                open: !this.state.open,
	                expanded: !this.state.open ? this.state.expanded : false
	            });
	        }
	    }, {
	        key: "_expand",
	        value: function _expand() {
	            this.setState({
	                expanded: true
	            });
	        }
	    }, {
	        key: "_isExpanded",
	        value: function _isExpanded() {
	            if (this.state.expanded || !this.props.expandFilter) {
	                return true;
	            }
	            // if an item that is normally in the expansion is selected then show the expansion
	            for (var i = 0; i < this.props.items.length; i++) {
	                var item = this.props.items[i];
	                if (this._itemIsSelected(item) && !this.props.expandFilter(item, i)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    }, {
	        key: "_displayCustom",
	        value: function _displayCustom(values) {
	            var custom = [];
	            this.props.children.forEach(function (element) {
	                var newElement = element;
	                newElement.props.children = values[newElement.props.content];
	                custom.push(element);
	            });
	            return custom;
	        }
	    }, {
	        key: "_listItems",
	        value: function _listItems(selection) {
	            if (this.props.items) {
	                var sourceItems = this.props.items;
	
	                var isExpanded = this._isExpanded();
	                if (!isExpanded) {
	                    sourceItems = sourceItems.filter(this.props.expandFilter);
	                }
	
	                var items = sourceItems.map(function (item, index) {
	                    var display = item ? item[this.props.display] || item : item;
	                    var itemClassName = (0, _classnames2.default)({
	                        'SelectionItem': true,
	                        'SelectionItem--selected': selection === display
	                    });
	                    var description = null;
	                    if (this.props.descriptionKey && item && item[this.props.descriptionKey]) {
	                        description = _react2.default.createElement(
	                            "div",
	                            { className: "SelectionModule-description" },
	                            item[this.props.descriptionKey]
	                        );
	                    }
	                    // if children are provided, use the custom layout display
	                    return _react2.default.createElement(
	                        "li",
	                        { className: itemClassName, onClick: this._select.bind(null, item), key: index },
	                        _react2.default.createElement(_Icon2.default, { name: "check", size: 12 }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex-full" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "SelectionModule-display" },
	                                display
	                            ),
	                            description
	                        )
	                    );
	                }, this);
	
	                if (!isExpanded && items.length !== this.props.items.length) {
	                    items.push(_react2.default.createElement(
	                        "li",
	                        { className: "SelectionItem border-top", onClick: this._expand, key: "expand" },
	                        _react2.default.createElement(_Icon2.default, { name: "chevrondown", size: 12 }),
	                        _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "div",
	                                { className: "SelectionModule-display" },
	                                this.props.expandedTitle || "Advanced..."
	                            )
	                        )
	                    ));
	                }
	
	                return items;
	            } else {
	                return "Sorry. Something went wrong.";
	            }
	        }
	    }, {
	        key: "_select",
	        value: function _select(item) {
	            var index = this.props.index;
	            // send back the item with the specified action
	            if (this.props.action) {
	                if (index !== undefined) {
	                    if (this.props.parentIndex) {
	                        this.props.action(item[this.props.selectedKey], index, this.props.parentIndex);
	                    } else {
	                        this.props.action(item[this.props.selectedKey], index);
	                    }
	                } else {
	                    this.props.action(item[this.props.selectedKey]);
	                }
	            }
	            this._toggleOpen();
	        }
	    }, {
	        key: "_itemIsSelected",
	        value: function _itemIsSelected(item) {
	            return item && _underscore2.default.isEqual(item[this.props.selectedKey], this.props.selectedValue);
	        }
	    }, {
	        key: "renderPopover",
	        value: function renderPopover(selection) {
	            if (this.state.open) {
	                var itemListClasses = (0, _classnames2.default)("SelectionItems", {
	                    'SelectionItems--open': this.state.open,
	                    'SelectionItems--expanded': this.state.expanded
	                });
	
	                var searchBar;
	                if (this._enableSearch()) {
	                    searchBar = _react2.default.createElement(_SearchBar2.default, { onFilter: this._filterSelections });
	                }
	
	                return _react2.default.createElement(
	                    _Popover2.default,
	                    {
	                        className: "SelectionModule " + this.props.className,
	                        onClose: this.onClose
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        { className: itemListClasses },
	                        searchBar,
	                        _react2.default.createElement(
	                            "ul",
	                            { className: "SelectionList scroll-show scroll-y" },
	                            this._listItems(selection)
	                        )
	                    )
	                );
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var selection;
	            this.props.items.forEach(function (item) {
	                if (this._itemIsSelected(item)) {
	                    selection = item[this.props.display];
	                }
	            }, this);
	
	            var placeholder = selection || this.props.placeholder,
	                remove,
	                removeable = !!this.props.remove;
	
	            var moduleClasses = (0, _classnames2.default)({
	                'SelectionModule': true,
	                'selected': selection,
	                'removeable': removeable
	            });
	
	            if (this.props.remove) {
	                remove = _react2.default.createElement(
	                    "a",
	                    { className: "text-grey-2 no-decoration pr1 flex align-center", onClick: this.props.remove.bind(null, this.props.index) },
	                    _react2.default.createElement(_Icon2.default, { name: "close", size: 14 })
	                );
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: moduleClasses + " " + this.props.className },
	                _react2.default.createElement(
	                    "div",
	                    { className: "SelectionModule-trigger flex align-center" },
	                    _react2.default.createElement(
	                        "a",
	                        { className: "QueryOption p1 flex align-center", onClick: this._toggleOpen },
	                        placeholder
	                    ),
	                    remove
	                ),
	                this.renderPopover(selection)
	            );
	        }
	    }]);
	
	    return SelectionModule;
	}(_react.Component), _class.propTypes = {
	    action: _propTypes2.default.func.isRequired,
	    display: _propTypes2.default.string.isRequired,
	    descriptionKey: _propTypes2.default.string,
	    expandFilter: _propTypes2.default.func,
	    expandTitle: _propTypes2.default.string,
	    isInitiallyOpen: _propTypes2.default.bool,
	    items: _propTypes2.default.array,
	    remove: _propTypes2.default.func,
	    selectedKey: _propTypes2.default.string,
	    selectedValue: _propTypes2.default.node,
	    parentIndex: _propTypes2.default.number,
	    placeholder: _propTypes2.default.string
	}, _class.defaultProps = {
	    className: ""
	}, _temp);
	SelectionModule.displayName = "SelectionModule";
	exports.default = SelectionModule;

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SearchBar = (_temp = _class = function (_React$Component) {
	    _inherits(SearchBar, _React$Component);
	
	    function SearchBar(props, context) {
	        _classCallCheck(this, SearchBar);
	
	        var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props, context));
	
	        _this.handleInputChange = _this.handleInputChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(SearchBar, [{
	        key: "handleInputChange",
	        value: function handleInputChange() {
	            this.props.onFilter(_reactDom2.default.findDOMNode(this.refs.filterTextInput).value);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement("input", { className: "SearchBar", type: "text", ref: "filterTextInput", value: this.props.filter, placeholder: "Search for", onChange: this.handleInputChange });
	        }
	    }]);
	
	    return SearchBar;
	}(_react2.default.Component), _class.propTypes = {
	    filter: _propTypes2.default.string.isRequired,
	    onFilter: _propTypes2.default.func.isRequired
	}, _temp);
	SearchBar.displayName = "SearchBar";
	exports.default = SearchBar;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	/*global ace*/
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(1741);
	
	var _reactResizable = __webpack_require__(1507);
	
	__webpack_require__(1226);
	
	__webpack_require__(1743);
	
	__webpack_require__(1744);
	
	__webpack_require__(1745);
	
	__webpack_require__(1746);
	
	__webpack_require__(1747);
	
	__webpack_require__(1230);
	
	__webpack_require__(1748);
	
	__webpack_require__(1749);
	
	__webpack_require__(1750);
	
	__webpack_require__(1751);
	
	__webpack_require__(1752);
	
	var _sql_behaviour = __webpack_require__(1753);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _DataSelector = __webpack_require__(1730);
	
	var _DataSelector2 = _interopRequireDefault(_DataSelector);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Parameters = __webpack_require__(1189);
	
	var _Parameters2 = _interopRequireDefault(_Parameters);
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _NativeQuery = __webpack_require__(954);
	
	var _NativeQuery2 = _interopRequireDefault(_NativeQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SCROLL_MARGIN = 8;
	var LINE_HEIGHT = 16;
	
	var MIN_HEIGHT_LINES = 1;
	var MAX_AUTO_SIZE_LINES = 12;
	
	var getEditorLineHeight = function getEditorLineHeight(lines) {
	    return lines * LINE_HEIGHT + 2 * SCROLL_MARGIN;
	};
	
	// TODO;
	
	var NativeQueryEditor = (_temp = _class = function (_Component) {
	    _inherits(NativeQueryEditor, _Component);
	
	    function NativeQueryEditor(props) {
	        _classCallCheck(this, NativeQueryEditor);
	
	        var _this = _possibleConstructorReturn(this, (NativeQueryEditor.__proto__ || Object.getPrototypeOf(NativeQueryEditor)).call(this, props));
	
	        _this._localUpdate = false;
	
	        _this.handleKeyDown = function (e) {
	            var _this$props = _this.props,
	                query = _this$props.query,
	                runQuestionQuery = _this$props.runQuestionQuery;
	
	
	            var ENTER_KEY = 13;
	            if (e.keyCode === ENTER_KEY && (e.metaKey || e.ctrlKey) && query.canRun()) {
	                var _query = _this.props.query;
	
	                if (e.altKey) {
	                    // run just the selected text, if any
	                    var selectedText = _this._editor.getSelectedText();
	                    if (selectedText) {
	                        var temporaryCard = _query.updateQueryText(selectedText).question().card();
	                        runQuestionQuery({ overrideWithCard: temporaryCard, shouldUpdateUrl: false });
	                    }
	                } else {
	                    runQuestionQuery();
	                }
	            }
	        };
	
	        _this.toggleEditor = function () {
	            _this.setState({ showEditor: !_this.state.showEditor });
	        };
	
	        _this.setDatabaseId = function (databaseId) {
	            // TODO: use metabase-lib
	            _this.props.setDatabaseFn(databaseId);
	        };
	
	        _this.setTableId = function (tableId) {
	            // TODO: push more of this into metabase-lib?
	            var query = _this.props.query;
	
	            var table = query._metadata.tables[tableId];
	            if (table && table.name !== query.collection()) {
	                query.updateCollection(table.name).update(_this.props.setDatasetQuery);
	            }
	        };
	
	        var lines = Math.min(MAX_AUTO_SIZE_LINES, props.query && props.query.lineCount() || MAX_AUTO_SIZE_LINES);
	
	        _this.state = {
	            showEditor: !props.question || !props.question.isSaved(),
	            initialHeight: getEditorLineHeight(lines)
	        };
	
	        // Ace sometimes fires mutliple "change" events in rapid succession
	        // e.x. https://github.com/metabase/metabase/issues/2801
	        // $FlowFixMe
	        _this.onChange = _underscore2.default.debounce(_this.onChange.bind(_this), 1);
	        return _this;
	    }
	
	    _createClass(NativeQueryEditor, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.loadAceEditor();
	            document.addEventListener("keydown", this.handleKeyDown);
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var query = this.props.query;
	
	            if (!query || !this._editor) {
	                return;
	            }
	
	            if (this._editor.getValue() !== query.queryText()) {
	                // This is a weird hack, but the purpose is to avoid an infinite loop caused by the fact that calling editor.setValue()
	                // will trigger the editor 'change' event, update the query, and cause another rendering loop which we don't want, so
	                // we need a way to update the editor without causing the onChange event to go through as well
	                this._localUpdate = true;
	                this._editor.setValue(query.queryText());
	                this._editor.clearSelection();
	                this._localUpdate = false;
	            }
	
	            var editorElement = _reactDom2.default.findDOMNode(this.refs.editor);
	            if (query.hasWritePermission()) {
	                this._editor.setReadOnly(false);
	                editorElement.classList.remove("read-only");
	            } else {
	                this._editor.setReadOnly(true);
	                editorElement.classList.add("read-only");
	            }
	            var aceMode = query.aceMode();
	            if (this._editor.getSession().$modeId !== aceMode) {
	                this._editor.getSession().setMode(aceMode);
	                // monkey patch the mode to add our bracket/paren/braces-matching behavior
	                if (aceMode.indexOf("sql") >= 0) {
	                    this._editor.getSession().$mode.$behaviour = new _sql_behaviour.SQLBehaviour();
	                }
	            }
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            document.removeEventListener("keydown", this.handleKeyDown);
	        }
	    }, {
	        key: "loadAceEditor",
	        value: function loadAceEditor() {
	            var _this2 = this;
	
	            var query = this.props.query;
	
	
	            var editorElement = _reactDom2.default.findDOMNode(this.refs.editor);
	            // $FlowFixMe
	            this._editor = ace.edit(editorElement);
	
	            // listen to onChange events
	            this._editor.getSession().on('change', this.onChange);
	
	            // initialize the content
	            this._editor.setValue(query ? query.queryText() : "");
	
	            this._editor.renderer.setScrollMargin(SCROLL_MARGIN, SCROLL_MARGIN);
	
	            // clear the editor selection, otherwise we start with the whole editor selected
	            this._editor.clearSelection();
	
	            // hmmm, this could be dangerous
	            this._editor.focus();
	
	            var aceLanguageTools = ace.require('ace/ext/language_tools');
	            this._editor.setOptions({
	                enableBasicAutocompletion: true,
	                enableSnippets: true,
	                enableLiveAutocompletion: true,
	                showPrintMargin: false,
	                highlightActiveLine: false,
	                highlightGutterLine: false,
	                showLineNumbers: true
	            });
	
	            aceLanguageTools.addCompleter({
	                getCompletions: function () {
	                    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(editor, session, pos, prefix, callback) {
	                        var results, js_results;
	                        return regeneratorRuntime.wrap(function _callee$(_context) {
	                            while (1) {
	                                switch (_context.prev = _context.next) {
	                                    case 0:
	                                        _context.prev = 0;
	                                        _context.next = 3;
	                                        return _this2.props.autocompleteResultsFn(prefix);
	
	                                    case 3:
	                                        results = _context.sent;
	
	                                        // transform results of the API call into what ACE expects
	                                        js_results = results.map(function (result) {
	                                            return {
	                                                name: result[0],
	                                                value: result[0],
	                                                meta: result[1]
	                                            };
	                                        });
	
	                                        callback(null, js_results);
	                                        _context.next = 12;
	                                        break;
	
	                                    case 8:
	                                        _context.prev = 8;
	                                        _context.t0 = _context["catch"](0);
	
	                                        console.log('error getting autocompletion data', _context.t0);
	                                        callback(null, []);
	
	                                    case 12:
	                                    case "end":
	                                        return _context.stop();
	                                }
	                            }
	                        }, _callee, _this2, [[0, 8]]);
	                    }));
	
	                    return function getCompletions(_x, _x2, _x3, _x4, _x5) {
	                        return _ref.apply(this, arguments);
	                    };
	                }()
	            });
	        }
	    }, {
	        key: "_updateSize",
	        value: function _updateSize() {
	            var doc = this._editor.getSession().getDocument();
	            var element = _reactDom2.default.findDOMNode(this.refs.resizeBox);
	            var newHeight = getEditorLineHeight(doc.getLength());
	            if (newHeight > element.offsetHeight && newHeight <= getEditorLineHeight(MAX_AUTO_SIZE_LINES)) {
	                element.style.height = newHeight + "px";
	                this._editor.resize();
	            }
	        }
	    }, {
	        key: "onChange",
	        value: function onChange() {
	            var query = this.props.query;
	
	            if (this._editor && !this._localUpdate) {
	                this._updateSize();
	                if (query.queryText() !== this._editor.getValue()) {
	                    query.updateQueryText(this._editor.getValue()).update(this.props.setDatasetQuery);
	                }
	            }
	        }
	
	        /// Change the Database we're currently editing a query for.
	
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                query = _props.query,
	                setParameterValue = _props.setParameterValue,
	                location = _props.location;
	
	            var database = query.database();
	            var databases = query.databases();
	            var parameters = query.question().parameters();
	
	            var dataSelectors = [];
	            if (this.state.showEditor && databases.length > 0) {
	                // we only render a db selector if there are actually multiple to choose from
	                if (databases.length > 1 && (database == null || _underscore2.default.any(databases, function (db) {
	                    return db.id === database.id;
	                }))) {
	                    dataSelectors.push(_react2.default.createElement(
	                        "div",
	                        { key: "db_selector", className: "GuiBuilder-section GuiBuilder-data flex align-center" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "GuiBuilder-section-label Query-label" },
	                            "Database"
	                        ),
	                        _react2.default.createElement(_DataSelector2.default, {
	                            databases: databases,
	                            datasetQuery: query.datasetQuery(),
	                            setDatabaseFn: this.setDatabaseId,
	                            isInitiallyOpen: database == null
	                        })
	                    ));
	                } else if (database) {
	                    dataSelectors.push(_react2.default.createElement(
	                        "span",
	                        { key: "db", className: "p2 text-bold text-grey" },
	                        database.name
	                    ));
	                }
	                if (query.requiresTable()) {
	                    var selectedTable = query.table();
	                    var tables = query.tables() || [];
	
	                    dataSelectors.push(_react2.default.createElement(
	                        "div",
	                        { key: "table_selector", className: "GuiBuilder-section GuiBuilder-data flex align-center" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "GuiBuilder-section-label Query-label" },
	                            "Table"
	                        ),
	                        _react2.default.createElement(_DataSelector2.default, {
	                            ref: "dataSection",
	                            includeTables: true,
	                            datasetQuery: {
	                                type: "query",
	                                query: { source_table: selectedTable ? selectedTable.id : null },
	                                database: database && database.id
	                            },
	                            databases: [database],
	                            tables: tables,
	                            setDatabaseFn: this.setDatabaseId,
	                            setSourceTableFn: this.setTableId,
	                            isInitiallyOpen: false
	                        })
	                    ));
	                }
	            } else {
	                dataSelectors = _react2.default.createElement(
	                    "span",
	                    { className: "p2 text-grey-4" },
	                    "This question is written in " + query.nativeQueryLanguage() + "."
	                );
	            }
	
	            var editorClasses = void 0,
	                toggleEditorText = void 0,
	                toggleEditorIcon = void 0;
	            if (this.state.showEditor) {
	                editorClasses = "";
	                toggleEditorText = query.hasWritePermission() ? "Hide Editor" : "Hide Query";
	                toggleEditorIcon = "contract";
	            } else {
	                editorClasses = "hide";
	                toggleEditorText = query.hasWritePermission() ? "Open Editor" : "Show Query";
	                toggleEditorIcon = "expand";
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "wrapper" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "NativeQueryEditor bordered rounded shadowed" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center", style: { minHeight: 50 } },
	                        dataSelectors,
	                        _react2.default.createElement(_Parameters2.default, {
	                            parameters: parameters,
	                            query: location.query,
	                            setParameterValue: setParameterValue,
	                            syncQueryString: true,
	                            isQB: true,
	                            commitImmediately: true
	                        }),
	                        _react2.default.createElement(
	                            "a",
	                            { className: "Query-label no-decoration flex-align-right flex align-center px2", onClick: this.toggleEditor },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "mx2" },
	                                toggleEditorText
	                            ),
	                            _react2.default.createElement(_Icon2.default, { name: toggleEditorIcon, size: 20 })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactResizable.ResizableBox,
	                        {
	                            ref: "resizeBox",
	                            className: "border-top " + editorClasses,
	                            height: this.state.initialHeight,
	                            minConstraints: [Infinity, getEditorLineHeight(MIN_HEIGHT_LINES)],
	                            axis: "y",
	                            onResizeStop: function onResizeStop(e, data) {
	                                _this3._editor.resize();
	                            }
	                        },
	                        _react2.default.createElement("div", { id: "id_sql", ref: "editor" })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NativeQueryEditor;
	}(_react.Component), _class.defaultProps = {
	    isOpen: false
	}, _temp);
	NativeQueryEditor.displayName = "NativeQueryEditor";
	exports.default = NativeQueryEditor;

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1742 */,
/* 1743 */
/***/ (function(module, exports) {

	ace.define("ace/snippets",["require","exports","module","ace/lib/oop","ace/lib/event_emitter","ace/lib/lang","ace/range","ace/anchor","ace/keyboard/hash_handler","ace/tokenizer","ace/lib/dom","ace/editor"],function(e,t,n){"use strict";var r=e("./lib/oop"),i=e("./lib/event_emitter").EventEmitter,s=e("./lib/lang"),o=e("./range").Range,u=e("./anchor").Anchor,a=e("./keyboard/hash_handler").HashHandler,f=e("./tokenizer").Tokenizer,l=o.comparePoints,c=function(){this.snippetMap={},this.snippetNameMap={}};(function(){r.implement(this,i),this.getTokenizer=function(){function e(e,t,n){return e=e.substr(1),/^\d+$/.test(e)&&!n.inFormatString?[{tabstopId:parseInt(e,10)}]:[{text:e}]}function t(e){return"(?:[^\\\\"+e+"]|\\\\.)"}return c.$tokenizer=new f({start:[{regex:/:/,onMatch:function(e,t,n){return n.length&&n[0].expectIf?(n[0].expectIf=!1,n[0].elseBranch=n[0],[n[0]]):":"}},{regex:/\\./,onMatch:function(e,t,n){var r=e[1];return r=="}"&&n.length?e=r:"`$\\".indexOf(r)!=-1?e=r:n.inFormatString&&(r=="n"?e="\n":r=="t"?e="\n":"ulULE".indexOf(r)!=-1&&(e={changeCase:r,local:r>"a"})),[e]}},{regex:/}/,onMatch:function(e,t,n){return[n.length?n.shift():e]}},{regex:/\$(?:\d+|\w+)/,onMatch:e},{regex:/\$\{[\dA-Z_a-z]+/,onMatch:function(t,n,r){var i=e(t.substr(1),n,r);return r.unshift(i[0]),i},next:"snippetVar"},{regex:/\n/,token:"newline",merge:!1}],snippetVar:[{regex:"\\|"+t("\\|")+"*\\|",onMatch:function(e,t,n){n[0].choices=e.slice(1,-1).split(",")},next:"start"},{regex:"/("+t("/")+"+)/(?:("+t("/")+"*)/)(\\w*):?",onMatch:function(e,t,n){var r=n[0];return r.fmtString=e,e=this.splitRegex.exec(e),r.guard=e[1],r.fmt=e[2],r.flag=e[3],""},next:"start"},{regex:"`"+t("`")+"*`",onMatch:function(e,t,n){return n[0].code=e.splice(1,-1),""},next:"start"},{regex:"\\?",onMatch:function(e,t,n){n[0]&&(n[0].expectIf=!0)},next:"start"},{regex:"([^:}\\\\]|\\\\.)*:?",token:"",next:"start"}],formatString:[{regex:"/("+t("/")+"+)/",token:"regex"},{regex:"",onMatch:function(e,t,n){n.inFormatString=!0},next:"start"}]}),c.prototype.getTokenizer=function(){return c.$tokenizer},c.$tokenizer},this.tokenizeTmSnippet=function(e,t){return this.getTokenizer().getLineTokens(e,t).tokens.map(function(e){return e.value||e})},this.$getDefaultValue=function(e,t){if(/^[A-Z]\d+$/.test(t)){var n=t.substr(1);return(this.variables[t[0]+"__"]||{})[n]}if(/^\d+$/.test(t))return(this.variables.__||{})[t];t=t.replace(/^TM_/,"");if(!e)return;var r=e.session;switch(t){case"CURRENT_WORD":var i=r.getWordRange();case"SELECTION":case"SELECTED_TEXT":return r.getTextRange(i);case"CURRENT_LINE":return r.getLine(e.getCursorPosition().row);case"PREV_LINE":return r.getLine(e.getCursorPosition().row-1);case"LINE_INDEX":return e.getCursorPosition().column;case"LINE_NUMBER":return e.getCursorPosition().row+1;case"SOFT_TABS":return r.getUseSoftTabs()?"YES":"NO";case"TAB_SIZE":return r.getTabSize();case"FILENAME":case"FILEPATH":return"";case"FULLNAME":return"Ace"}},this.variables={},this.getVariableValue=function(e,t){return this.variables.hasOwnProperty(t)?this.variables[t](e,t)||"":this.$getDefaultValue(e,t)||""},this.tmStrFormat=function(e,t,n){var r=t.flag||"",i=t.guard;i=new RegExp(i,r.replace(/[^gi]/,""));var s=this.tokenizeTmSnippet(t.fmt,"formatString"),o=this,u=e.replace(i,function(){o.variables.__=arguments;var e=o.resolveVariables(s,n),t="E";for(var r=0;r<e.length;r++){var i=e[r];if(typeof i=="object"){e[r]="";if(i.changeCase&&i.local){var u=e[r+1];u&&typeof u=="string"&&(i.changeCase=="u"?e[r]=u[0].toUpperCase():e[r]=u[0].toLowerCase(),e[r+1]=u.substr(1))}else i.changeCase&&(t=i.changeCase)}else t=="U"?e[r]=i.toUpperCase():t=="L"&&(e[r]=i.toLowerCase())}return e.join("")});return this.variables.__=null,u},this.resolveVariables=function(e,t){function o(t){var n=e.indexOf(t,r+1);n!=-1&&(r=n)}var n=[];for(var r=0;r<e.length;r++){var i=e[r];if(typeof i=="string")n.push(i);else{if(typeof i!="object")continue;if(i.skip)o(i);else{if(i.processed<r)continue;if(i.text){var s=this.getVariableValue(t,i.text);s&&i.fmtString&&(s=this.tmStrFormat(s,i)),i.processed=r,i.expectIf==null?s&&(n.push(s),o(i)):s?i.skip=i.elseBranch:o(i)}else i.tabstopId!=null?n.push(i):i.changeCase!=null&&n.push(i)}}}return n},this.insertSnippetForSelection=function(e,t){function f(e){var t=[];for(var n=0;n<e.length;n++){var r=e[n];if(typeof r=="object"){if(a[r.tabstopId])continue;var i=e.lastIndexOf(r,n-1);r=t[i]||{tabstopId:r.tabstopId}}t[n]=r}return t}var n=e.getCursorPosition(),r=e.session.getLine(n.row),i=e.session.getTabString(),s=r.match(/^\s*/)[0];n.column<s.length&&(s=s.slice(0,n.column)),t=t.replace(/\r/g,"");var o=this.tokenizeTmSnippet(t);o=this.resolveVariables(o,e),o=o.map(function(e){return e=="\n"?e+s:typeof e=="string"?e.replace(/\t/g,i):e});var u=[];o.forEach(function(e,t){if(typeof e!="object")return;var n=e.tabstopId,r=u[n];r||(r=u[n]=[],r.index=n,r.value="");if(r.indexOf(e)!==-1)return;r.push(e);var i=o.indexOf(e,t+1);if(i===-1)return;var s=o.slice(t+1,i),a=s.some(function(e){return typeof e=="object"});a&&!r.value?r.value=s:s.length&&(!r.value||typeof r.value!="string")&&(r.value=s.join(""))}),u.forEach(function(e){e.length=0});var a={};for(var l=0;l<o.length;l++){var c=o[l];if(typeof c!="object")continue;var p=c.tabstopId,d=o.indexOf(c,l+1);if(a[p]){a[p]===c&&(a[p]=null);continue}var v=u[p],m=typeof v.value=="string"?[v.value]:f(v.value);m.unshift(l+1,Math.max(0,d-l)),m.push(c),a[p]=c,o.splice.apply(o,m),v.indexOf(c)===-1&&v.push(c)}var g=0,y=0,b="";o.forEach(function(e){if(typeof e=="string"){var t=e.split("\n");t.length>1?(y=t[t.length-1].length,g+=t.length-1):y+=e.length,b+=e}else e.start?e.end={row:g,column:y}:e.start={row:g,column:y}});var w=e.getSelectionRange(),E=e.session.replace(w,b),S=new h(e),x=e.inVirtualSelectionMode&&e.selection.index;S.addTabstops(u,w.start,E,x)},this.insertSnippet=function(e,t){var n=this;if(e.inVirtualSelectionMode)return n.insertSnippetForSelection(e,t);e.forEachSelection(function(){n.insertSnippetForSelection(e,t)},null,{keepOrder:!0}),e.tabstopManager&&e.tabstopManager.tabNext()},this.$getScope=function(e){var t=e.session.$mode.$id||"";t=t.split("/").pop();if(t==="html"||t==="php"){t==="php"&&!e.session.$mode.inlinePhp&&(t="html");var n=e.getCursorPosition(),r=e.session.getState(n.row);typeof r=="object"&&(r=r[0]),r.substring&&(r.substring(0,3)=="js-"?t="javascript":r.substring(0,4)=="css-"?t="css":r.substring(0,4)=="php-"&&(t="php"))}return t},this.getActiveScopes=function(e){var t=this.$getScope(e),n=[t],r=this.snippetMap;return r[t]&&r[t].includeScopes&&n.push.apply(n,r[t].includeScopes),n.push("_"),n},this.expandWithTab=function(e,t){var n=this,r=e.forEachSelection(function(){return n.expandSnippetForSelection(e,t)},null,{keepOrder:!0});return r&&e.tabstopManager&&e.tabstopManager.tabNext(),r},this.expandSnippetForSelection=function(e,t){var n=e.getCursorPosition(),r=e.session.getLine(n.row),i=r.substring(0,n.column),s=r.substr(n.column),o=this.snippetMap,u;return this.getActiveScopes(e).some(function(e){var t=o[e];return t&&(u=this.findMatchingSnippet(t,i,s)),!!u},this),u?t&&t.dryRun?!0:(e.session.doc.removeInLine(n.row,n.column-u.replaceBefore.length,n.column+u.replaceAfter.length),this.variables.M__=u.matchBefore,this.variables.T__=u.matchAfter,this.insertSnippetForSelection(e,u.content),this.variables.M__=this.variables.T__=null,!0):!1},this.findMatchingSnippet=function(e,t,n){for(var r=e.length;r--;){var i=e[r];if(i.startRe&&!i.startRe.test(t))continue;if(i.endRe&&!i.endRe.test(n))continue;if(!i.startRe&&!i.endRe)continue;return i.matchBefore=i.startRe?i.startRe.exec(t):[""],i.matchAfter=i.endRe?i.endRe.exec(n):[""],i.replaceBefore=i.triggerRe?i.triggerRe.exec(t)[0]:"",i.replaceAfter=i.endTriggerRe?i.endTriggerRe.exec(n)[0]:"",i}},this.snippetMap={},this.snippetNameMap={},this.register=function(e,t){function o(e){return e&&!/^\^?\(.*\)\$?$|^\\b$/.test(e)&&(e="(?:"+e+")"),e||""}function u(e,t,n){return e=o(e),t=o(t),n?(e=t+e,e&&e[e.length-1]!="$"&&(e+="$")):(e+=t,e&&e[0]!="^"&&(e="^"+e)),new RegExp(e)}function a(e){e.scope||(e.scope=t||"_"),t=e.scope,n[t]||(n[t]=[],r[t]={});var o=r[t];if(e.name){var a=o[e.name];a&&i.unregister(a),o[e.name]=e}n[t].push(e),e.tabTrigger&&!e.trigger&&(!e.guard&&/^\w/.test(e.tabTrigger)&&(e.guard="\\b"),e.trigger=s.escapeRegExp(e.tabTrigger));if(!e.trigger&&!e.guard&&!e.endTrigger&&!e.endGuard)return;e.startRe=u(e.trigger,e.guard,!0),e.triggerRe=new RegExp(e.trigger,"",!0),e.endRe=u(e.endTrigger,e.endGuard,!0),e.endTriggerRe=new RegExp(e.endTrigger,"",!0)}var n=this.snippetMap,r=this.snippetNameMap,i=this;e||(e=[]),e&&e.content?a(e):Array.isArray(e)&&e.forEach(a),this._signal("registerSnippets",{scope:t})},this.unregister=function(e,t){function i(e){var i=r[e.scope||t];if(i&&i[e.name]){delete i[e.name];var s=n[e.scope||t],o=s&&s.indexOf(e);o>=0&&s.splice(o,1)}}var n=this.snippetMap,r=this.snippetNameMap;e.content?i(e):Array.isArray(e)&&e.forEach(i)},this.parseSnippetFile=function(e){e=e.replace(/\r/g,"");var t=[],n={},r=/^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm,i;while(i=r.exec(e)){if(i[1])try{n=JSON.parse(i[1]),t.push(n)}catch(s){}if(i[4])n.content=i[4].replace(/^\t/gm,""),t.push(n),n={};else{var o=i[2],u=i[3];if(o=="regex"){var a=/\/((?:[^\/\\]|\\.)*)|$/g;n.guard=a.exec(u)[1],n.trigger=a.exec(u)[1],n.endTrigger=a.exec(u)[1],n.endGuard=a.exec(u)[1]}else o=="snippet"?(n.tabTrigger=u.match(/^\S*/)[0],n.name||(n.name=u)):n[o]=u}}return t},this.getSnippetByName=function(e,t){var n=this.snippetNameMap,r;return this.getActiveScopes(t).some(function(t){var i=n[t];return i&&(r=i[e]),!!r},this),r}}).call(c.prototype);var h=function(e){if(e.tabstopManager)return e.tabstopManager;e.tabstopManager=this,this.$onChange=this.onChange.bind(this),this.$onChangeSelection=s.delayedCall(this.onChangeSelection.bind(this)).schedule,this.$onChangeSession=this.onChangeSession.bind(this),this.$onAfterExec=this.onAfterExec.bind(this),this.attach(e)};(function(){this.attach=function(e){this.index=0,this.ranges=[],this.tabstops=[],this.$openTabstops=null,this.selectedTabstop=null,this.editor=e,this.editor.on("change",this.$onChange),this.editor.on("changeSelection",this.$onChangeSelection),this.editor.on("changeSession",this.$onChangeSession),this.editor.commands.on("afterExec",this.$onAfterExec),this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler)},this.detach=function(){this.tabstops.forEach(this.removeTabstopMarkers,this),this.ranges=null,this.tabstops=null,this.selectedTabstop=null,this.editor.removeListener("change",this.$onChange),this.editor.removeListener("changeSelection",this.$onChangeSelection),this.editor.removeListener("changeSession",this.$onChangeSession),this.editor.commands.removeListener("afterExec",this.$onAfterExec),this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler),this.editor.tabstopManager=null,this.editor=null},this.onChange=function(e){var t=e,n=e.action[0]=="r",r=e.start,i=e.end,s=r.row,o=i.row,u=o-s,a=i.column-r.column;n&&(u=-u,a=-a);if(!this.$inChange&&n){var f=this.selectedTabstop,c=f&&!f.some(function(e){return l(e.start,r)<=0&&l(e.end,i)>=0});if(c)return this.detach()}var h=this.ranges;for(var p=0;p<h.length;p++){var d=h[p];if(d.end.row<r.row)continue;if(n&&l(r,d.start)<0&&l(i,d.end)>0){this.removeRange(d),p--;continue}d.start.row==s&&d.start.column>r.column&&(d.start.column+=a),d.end.row==s&&d.end.column>=r.column&&(d.end.column+=a),d.start.row>=s&&(d.start.row+=u),d.end.row>=s&&(d.end.row+=u),l(d.start,d.end)>0&&this.removeRange(d)}h.length||this.detach()},this.updateLinkedFields=function(){var e=this.selectedTabstop;if(!e||!e.hasLinkedRanges)return;this.$inChange=!0;var n=this.editor.session,r=n.getTextRange(e.firstNonLinked);for(var i=e.length;i--;){var s=e[i];if(!s.linked)continue;var o=t.snippetManager.tmStrFormat(r,s.original);n.replace(s,o)}this.$inChange=!1},this.onAfterExec=function(e){e.command&&!e.command.readOnly&&this.updateLinkedFields()},this.onChangeSelection=function(){if(!this.editor)return;var e=this.editor.selection.lead,t=this.editor.selection.anchor,n=this.editor.selection.isEmpty();for(var r=this.ranges.length;r--;){if(this.ranges[r].linked)continue;var i=this.ranges[r].contains(e.row,e.column),s=n||this.ranges[r].contains(t.row,t.column);if(i&&s)return}this.detach()},this.onChangeSession=function(){this.detach()},this.tabNext=function(e){var t=this.tabstops.length,n=this.index+(e||1);n=Math.min(Math.max(n,1),t),n==t&&(n=0),this.selectTabstop(n),n===0&&this.detach()},this.selectTabstop=function(e){this.$openTabstops=null;var t=this.tabstops[this.index];t&&this.addTabstopMarkers(t),this.index=e,t=this.tabstops[this.index];if(!t||!t.length)return;this.selectedTabstop=t;if(!this.editor.inVirtualSelectionMode){var n=this.editor.multiSelect;n.toSingleRange(t.firstNonLinked.clone());for(var r=t.length;r--;){if(t.hasLinkedRanges&&t[r].linked)continue;n.addRange(t[r].clone(),!0)}n.ranges[0]&&n.addRange(n.ranges[0].clone())}else this.editor.selection.setRange(t.firstNonLinked);this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler)},this.addTabstops=function(e,t,n){this.$openTabstops||(this.$openTabstops=[]);if(!e[0]){var r=o.fromPoints(n,n);v(r.start,t),v(r.end,t),e[0]=[r],e[0].index=0}var i=this.index,s=[i+1,0],u=this.ranges;e.forEach(function(e,n){var r=this.$openTabstops[n]||e;for(var i=e.length;i--;){var a=e[i],f=o.fromPoints(a.start,a.end||a.start);d(f.start,t),d(f.end,t),f.original=a,f.tabstop=r,u.push(f),r!=e?r.unshift(f):r[i]=f,a.fmtString?(f.linked=!0,r.hasLinkedRanges=!0):r.firstNonLinked||(r.firstNonLinked=f)}r.firstNonLinked||(r.hasLinkedRanges=!1),r===e&&(s.push(r),this.$openTabstops[n]=r),this.addTabstopMarkers(r)},this),s.length>2&&(this.tabstops.length&&s.push(s.splice(2,1)[0]),this.tabstops.splice.apply(this.tabstops,s))},this.addTabstopMarkers=function(e){var t=this.editor.session;e.forEach(function(e){e.markerId||(e.markerId=t.addMarker(e,"ace_snippet-marker","text"))})},this.removeTabstopMarkers=function(e){var t=this.editor.session;e.forEach(function(e){t.removeMarker(e.markerId),e.markerId=null})},this.removeRange=function(e){var t=e.tabstop.indexOf(e);e.tabstop.splice(t,1),t=this.ranges.indexOf(e),this.ranges.splice(t,1),this.editor.session.removeMarker(e.markerId),e.tabstop.length||(t=this.tabstops.indexOf(e.tabstop),t!=-1&&this.tabstops.splice(t,1),this.tabstops.length||this.detach())},this.keyboardHandler=new a,this.keyboardHandler.bindKeys({Tab:function(e){if(t.snippetManager&&t.snippetManager.expandWithTab(e))return;e.tabstopManager.tabNext(1)},"Shift-Tab":function(e){e.tabstopManager.tabNext(-1)},Esc:function(e){e.tabstopManager.detach()},Return:function(e){return!1}})}).call(h.prototype);var p={};p.onChange=u.prototype.onChange,p.setPosition=function(e,t){this.pos.row=e,this.pos.column=t},p.update=function(e,t,n){this.$insertRight=n,this.pos=e,this.onChange(t)};var d=function(e,t){e.row==0&&(e.column+=t.column),e.row+=t.row},v=function(e,t){e.row==t.row&&(e.column-=t.column),e.row-=t.row};e("./lib/dom").importCssString(".ace_snippet-marker {    -moz-box-sizing: border-box;    box-sizing: border-box;    background: rgba(194, 193, 208, 0.09);    border: 1px dotted rgba(211, 208, 235, 0.62);    position: absolute;}"),t.snippetManager=new c;var m=e("./editor").Editor;(function(){this.insertSnippet=function(e,n){return t.snippetManager.insertSnippet(this,e,n)},this.expandSnippet=function(e){return t.snippetManager.expandWithTab(this,e)}}).call(m.prototype)}),ace.define("ace/autocomplete/popup",["require","exports","module","ace/virtual_renderer","ace/editor","ace/range","ace/lib/event","ace/lib/lang","ace/lib/dom"],function(e,t,n){"use strict";var r=e("../virtual_renderer").VirtualRenderer,i=e("../editor").Editor,s=e("../range").Range,o=e("../lib/event"),u=e("../lib/lang"),a=e("../lib/dom"),f=function(e){var t=new r(e);t.$maxLines=4;var n=new i(t);return n.setHighlightActiveLine(!1),n.setShowPrintMargin(!1),n.renderer.setShowGutter(!1),n.renderer.setHighlightGutterLine(!1),n.$mouseHandler.$focusWaitTimout=0,n.$highlightTagPending=!0,n},l=function(e){var t=a.createElement("div"),n=new f(t);e&&e.appendChild(t),t.style.display="none",n.renderer.content.style.cursor="default",n.renderer.setStyle("ace_autocomplete"),n.setOption("displayIndentGuides",!1),n.setOption("dragDelay",150);var r=function(){};n.focus=r,n.$isFocused=!0,n.renderer.$cursorLayer.restartTimer=r,n.renderer.$cursorLayer.element.style.opacity=0,n.renderer.$maxLines=8,n.renderer.$keepTextAreaAtCursor=!1,n.setHighlightActiveLine(!1),n.session.highlight(""),n.session.$searchHighlight.clazz="ace_highlight-marker",n.on("mousedown",function(e){var t=e.getDocumentPosition();n.selection.moveToPosition(t),c.start.row=c.end.row=t.row,e.stop()});var i,l=new s(-1,0,-1,Infinity),c=new s(-1,0,-1,Infinity);c.id=n.session.addMarker(c,"ace_active-line","fullLine"),n.setSelectOnHover=function(e){e?l.id&&(n.session.removeMarker(l.id),l.id=null):l.id=n.session.addMarker(l,"ace_line-hover","fullLine")},n.setSelectOnHover(!1),n.on("mousemove",function(e){if(!i){i=e;return}if(i.x==e.x&&i.y==e.y)return;i=e,i.scrollTop=n.renderer.scrollTop;var t=i.getDocumentPosition().row;l.start.row!=t&&(l.id||n.setRow(t),p(t))}),n.renderer.on("beforeRender",function(){if(i&&l.start.row!=-1){i.$pos=null;var e=i.getDocumentPosition().row;l.id||n.setRow(e),p(e,!0)}}),n.renderer.on("afterRender",function(){var e=n.getRow(),t=n.renderer.$textLayer,r=t.element.childNodes[e-t.config.firstRow];if(r==t.selectedNode)return;t.selectedNode&&a.removeCssClass(t.selectedNode,"ace_selected"),t.selectedNode=r,r&&a.addCssClass(r,"ace_selected")});var h=function(){p(-1)},p=function(e,t){e!==l.start.row&&(l.start.row=l.end.row=e,t||n.session._emit("changeBackMarker"),n._emit("changeHoverMarker"))};n.getHoveredRow=function(){return l.start.row},o.addListener(n.container,"mouseout",h),n.on("hide",h),n.on("changeSelection",h),n.session.doc.getLength=function(){return n.data.length},n.session.doc.getLine=function(e){var t=n.data[e];return typeof t=="string"?t:t&&t.value||""};var d=n.session.bgTokenizer;return d.$tokenizeRow=function(e){var t=n.data[e],r=[];if(!t)return r;typeof t=="string"&&(t={value:t}),t.caption||(t.caption=t.value||t.name);var i=-1,s,o;for(var u=0;u<t.caption.length;u++)o=t.caption[u],s=t.matchMask&1<<u?1:0,i!==s?(r.push({type:t.className||""+(s?"completion-highlight":""),value:o}),i=s):r[r.length-1].value+=o;if(t.meta){var a=n.renderer.$size.scrollerWidth/n.renderer.layerConfig.characterWidth,f=t.meta;f.length+t.caption.length>a-2&&(f=f.substr(0,a-t.caption.length-3)+"\u2026"),r.push({type:"rightAlignedText",value:f})}return r},d.$updateOnChange=r,d.start=r,n.session.$computeWidth=function(){return this.screenWidth=0},n.$blockScrolling=Infinity,n.isOpen=!1,n.isTopdown=!1,n.data=[],n.setData=function(e){n.setValue(u.stringRepeat("\n",e.length),-1),n.data=e||[],n.setRow(0)},n.getData=function(e){return n.data[e]},n.getRow=function(){return c.start.row},n.setRow=function(e){e=Math.max(0,Math.min(this.data.length,e)),c.start.row!=e&&(n.selection.clearSelection(),c.start.row=c.end.row=e||0,n.session._emit("changeBackMarker"),n.moveCursorTo(e||0,0),n.isOpen&&n._signal("select"))},n.on("changeSelection",function(){n.isOpen&&n.setRow(n.selection.lead.row),n.renderer.scrollCursorIntoView()}),n.hide=function(){this.container.style.display="none",this._signal("hide"),n.isOpen=!1},n.show=function(e,t,r){var s=this.container,o=window.innerHeight,u=window.innerWidth,a=this.renderer,f=a.$maxLines*t*1.4,l=e.top+this.$borderSize,c=l>o/2&&!r;c&&l+t+f>o?(a.$maxPixelHeight=l-2*this.$borderSize,s.style.top="",s.style.bottom=o-l+"px",n.isTopdown=!1):(l+=t,a.$maxPixelHeight=o-l-.2*t,s.style.top=l+"px",s.style.bottom="",n.isTopdown=!0),s.style.display="",this.renderer.$textLayer.checkForSizeChanges();var h=e.left;h+s.offsetWidth>u&&(h=u-s.offsetWidth),s.style.left=h+"px",this._signal("show"),i=null,n.isOpen=!0},n.getTextLeftOffset=function(){return this.$borderSize+this.renderer.$padding+this.$imageSize},n.$imageSize=0,n.$borderSize=1,n};a.importCssString(".ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {    background-color: #CAD6FA;    z-index: 1;}.ace_editor.ace_autocomplete .ace_line-hover {    border: 1px solid #abbffe;    margin-top: -1px;    background: rgba(233,233,253,0.4);}.ace_editor.ace_autocomplete .ace_line-hover {    position: absolute;    z-index: 2;}.ace_editor.ace_autocomplete .ace_scroller {   background: none;   border: none;   box-shadow: none;}.ace_rightAlignedText {    color: gray;    display: inline-block;    position: absolute;    right: 4px;    text-align: right;    z-index: -1;}.ace_editor.ace_autocomplete .ace_completion-highlight{    color: #000;    text-shadow: 0 0 0.01em;}.ace_editor.ace_autocomplete {    width: 280px;    z-index: 200000;    background: #fbfbfb;    color: #444;    border: 1px lightgray solid;    position: fixed;    box-shadow: 2px 3px 5px rgba(0,0,0,.2);    line-height: 1.4;}"),t.AcePopup=l}),ace.define("ace/autocomplete/util",["require","exports","module"],function(e,t,n){"use strict";t.parForEach=function(e,t,n){var r=0,i=e.length;i===0&&n();for(var s=0;s<i;s++)t(e[s],function(e,t){r++,r===i&&n(e,t)})};var r=/[a-zA-Z_0-9\$\-\u00A2-\uFFFF]/;t.retrievePrecedingIdentifier=function(e,t,n){n=n||r;var i=[];for(var s=t-1;s>=0;s--){if(!n.test(e[s]))break;i.push(e[s])}return i.reverse().join("")},t.retrieveFollowingIdentifier=function(e,t,n){n=n||r;var i=[];for(var s=t;s<e.length;s++){if(!n.test(e[s]))break;i.push(e[s])}return i},t.getCompletionPrefix=function(e){var t=e.getCursorPosition(),n=e.session.getLine(t.row),r;return e.completers.forEach(function(e){e.identifierRegexps&&e.identifierRegexps.forEach(function(e){!r&&e&&(r=this.retrievePrecedingIdentifier(n,t.column,e))}.bind(this))}.bind(this)),r||this.retrievePrecedingIdentifier(n,t.column)}}),ace.define("ace/autocomplete",["require","exports","module","ace/keyboard/hash_handler","ace/autocomplete/popup","ace/autocomplete/util","ace/lib/event","ace/lib/lang","ace/lib/dom","ace/snippets"],function(e,t,n){"use strict";var r=e("./keyboard/hash_handler").HashHandler,i=e("./autocomplete/popup").AcePopup,s=e("./autocomplete/util"),o=e("./lib/event"),u=e("./lib/lang"),a=e("./lib/dom"),f=e("./snippets").snippetManager,l=function(){this.autoInsert=!1,this.autoSelect=!0,this.exactMatch=!1,this.gatherCompletionsId=0,this.keyboardHandler=new r,this.keyboardHandler.bindKeys(this.commands),this.blurListener=this.blurListener.bind(this),this.changeListener=this.changeListener.bind(this),this.mousedownListener=this.mousedownListener.bind(this),this.mousewheelListener=this.mousewheelListener.bind(this),this.changeTimer=u.delayedCall(function(){this.updateCompletions(!0)}.bind(this)),this.tooltipTimer=u.delayedCall(this.updateDocTooltip.bind(this),50)};(function(){this.$init=function(){return this.popup=new i(document.body||document.documentElement),this.popup.on("click",function(e){this.insertMatch(),e.stop()}.bind(this)),this.popup.focus=this.editor.focus.bind(this.editor),this.popup.on("show",this.tooltipTimer.bind(null,null)),this.popup.on("select",this.tooltipTimer.bind(null,null)),this.popup.on("changeHoverMarker",this.tooltipTimer.bind(null,null)),this.popup},this.getPopup=function(){return this.popup||this.$init()},this.openPopup=function(e,t,n){this.popup||this.$init(),this.popup.setData(this.completions.filtered),e.keyBinding.addKeyboardHandler(this.keyboardHandler);var r=e.renderer;this.popup.setRow(this.autoSelect?0:-1);if(!n){this.popup.setTheme(e.getTheme()),this.popup.setFontSize(e.getFontSize());var i=r.layerConfig.lineHeight,s=r.$cursorLayer.getPixelPosition(this.base,!0);s.left-=this.popup.getTextLeftOffset();var o=e.container.getBoundingClientRect();s.top+=o.top-r.layerConfig.offset,s.left+=o.left-e.renderer.scrollLeft,s.left+=r.gutterWidth,this.popup.show(s,i)}else n&&!t&&this.detach()},this.detach=function(){this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler),this.editor.off("changeSelection",this.changeListener),this.editor.off("blur",this.blurListener),this.editor.off("mousedown",this.mousedownListener),this.editor.off("mousewheel",this.mousewheelListener),this.changeTimer.cancel(),this.hideDocTooltip(),this.gatherCompletionsId+=1,this.popup&&this.popup.isOpen&&this.popup.hide(),this.base&&this.base.detach(),this.activated=!1,this.completions=this.base=null},this.changeListener=function(e){var t=this.editor.selection.lead;(t.row!=this.base.row||t.column<this.base.column)&&this.detach(),this.activated?this.changeTimer.schedule():this.detach()},this.blurListener=function(e){e.relatedTarget&&e.relatedTarget.nodeName=="A"&&e.relatedTarget.href&&window.open(e.relatedTarget.href,"_blank");var t=document.activeElement,n=this.editor.textInput.getElement(),r=e.relatedTarget&&e.relatedTarget==this.tooltipNode,i=this.popup&&this.popup.container;t!=n&&t.parentNode!=i&&!r&&t!=this.tooltipNode&&e.relatedTarget!=n&&this.detach()},this.mousedownListener=function(e){this.detach()},this.mousewheelListener=function(e){this.detach()},this.goTo=function(e){var t=this.popup.getRow(),n=this.popup.session.getLength()-1;switch(e){case"up":t=t<=0?n:t-1;break;case"down":t=t>=n?-1:t+1;break;case"start":t=0;break;case"end":t=n}this.popup.setRow(t)},this.insertMatch=function(e,t){e||(e=this.popup.getData(this.popup.getRow()));if(!e)return!1;if(e.completer&&e.completer.insertMatch)e.completer.insertMatch(this.editor,e);else{if(this.completions.filterText){var n=this.editor.selection.getAllRanges();for(var r=0,i;i=n[r];r++)i.start.column-=this.completions.filterText.length,this.editor.session.remove(i)}e.snippet?f.insertSnippet(this.editor,e.snippet):this.editor.execCommand("insertstring",e.value||e)}this.detach()},this.commands={Up:function(e){e.completer.goTo("up")},Down:function(e){e.completer.goTo("down")},"Ctrl-Up|Ctrl-Home":function(e){e.completer.goTo("start")},"Ctrl-Down|Ctrl-End":function(e){e.completer.goTo("end")},Esc:function(e){e.completer.detach()},Return:function(e){return e.completer.insertMatch()},"Shift-Return":function(e){e.completer.insertMatch(null,{deleteSuffix:!0})},Tab:function(e){var t=e.completer.insertMatch();if(!!t||!!e.tabstopManager)return t;e.completer.goTo("down")},PageUp:function(e){e.completer.popup.gotoPageUp()},PageDown:function(e){e.completer.popup.gotoPageDown()}},this.gatherCompletions=function(e,t){var n=e.getSession(),r=e.getCursorPosition(),i=n.getLine(r.row),o=s.getCompletionPrefix(e);this.base=n.doc.createAnchor(r.row,r.column-o.length),this.base.$insertRight=!0;var u=[],a=e.completers.length;return e.completers.forEach(function(i,s){i.getCompletions(e,n,r,o,function(r,i){!r&&i&&(u=u.concat(i));var s=e.getCursorPosition(),f=n.getLine(s.row);t(null,{prefix:o,matches:u,finished:--a===0})})}),!0},this.showPopup=function(e){this.editor&&this.detach(),this.activated=!0,this.editor=e,e.completer!=this&&(e.completer&&e.completer.detach(),e.completer=this),e.on("changeSelection",this.changeListener),e.on("blur",this.blurListener),e.on("mousedown",this.mousedownListener),e.on("mousewheel",this.mousewheelListener),this.updateCompletions()},this.updateCompletions=function(e){if(e&&this.base&&this.completions){var t=this.editor.getCursorPosition(),n=this.editor.session.getTextRange({start:this.base,end:t});if(n==this.completions.filterText)return;this.completions.setFilter(n);if(!this.completions.filtered.length)return this.detach();if(this.completions.filtered.length==1&&this.completions.filtered[0].value==n&&!this.completions.filtered[0].snippet)return this.detach();this.openPopup(this.editor,n,e);return}var r=this.gatherCompletionsId;this.gatherCompletions(this.editor,function(t,n){var i=function(){if(!n.finished)return;return this.detach()}.bind(this),s=n.prefix,o=n&&n.matches;if(!o||!o.length)return i();if(s.indexOf(n.prefix)!==0||r!=this.gatherCompletionsId)return;this.completions=new c(o),this.exactMatch&&(this.completions.exactMatch=!0),this.completions.setFilter(s);var u=this.completions.filtered;if(!u.length)return i();if(u.length==1&&u[0].value==s&&!u[0].snippet)return i();if(this.autoInsert&&u.length==1&&n.finished)return this.insertMatch(u[0]);this.openPopup(this.editor,s,e)}.bind(this))},this.cancelContextMenu=function(){this.editor.$mouseHandler.cancelContextMenu()},this.updateDocTooltip=function(){var e=this.popup,t=e.data,n=t&&(t[e.getHoveredRow()]||t[e.getRow()]),r=null;if(!n||!this.editor||!this.popup.isOpen)return this.hideDocTooltip();this.editor.completers.some(function(e){return e.getDocTooltip&&(r=e.getDocTooltip(n)),r}),r||(r=n),typeof r=="string"&&(r={docText:r});if(!r||!r.docHTML&&!r.docText)return this.hideDocTooltip();this.showDocTooltip(r)},this.showDocTooltip=function(e){this.tooltipNode||(this.tooltipNode=a.createElement("div"),this.tooltipNode.className="ace_tooltip ace_doc-tooltip",this.tooltipNode.style.margin=0,this.tooltipNode.style.pointerEvents="auto",this.tooltipNode.tabIndex=-1,this.tooltipNode.onblur=this.blurListener.bind(this));var t=this.tooltipNode;e.docHTML?t.innerHTML=e.docHTML:e.docText&&(t.textContent=e.docText),t.parentNode||document.body.appendChild(t);var n=this.popup,r=n.container.getBoundingClientRect();t.style.top=n.container.style.top,t.style.bottom=n.container.style.bottom,window.innerWidth-r.right<320?(t.style.right=window.innerWidth-r.left+"px",t.style.left=""):(t.style.left=r.right+1+"px",t.style.right=""),t.style.display="block"},this.hideDocTooltip=function(){this.tooltipTimer.cancel();if(!this.tooltipNode)return;var e=this.tooltipNode;!this.editor.isFocused()&&document.activeElement==e&&this.editor.focus(),this.tooltipNode=null,e.parentNode&&e.parentNode.removeChild(e)}}).call(l.prototype),l.startCommand={name:"startAutocomplete",exec:function(e){e.completer||(e.completer=new l),e.completer.autoInsert=!1,e.completer.autoSelect=!0,e.completer.showPopup(e),e.completer.cancelContextMenu()},bindKey:"Ctrl-Space|Ctrl-Shift-Space|Alt-Space"};var c=function(e,t){this.all=e,this.filtered=e,this.filterText=t||"",this.exactMatch=!1};(function(){this.setFilter=function(e){if(e.length>this.filterText&&e.lastIndexOf(this.filterText,0)===0)var t=this.filtered;else var t=this.all;this.filterText=e,t=this.filterCompletions(t,this.filterText),t=t.sort(function(e,t){return t.exactMatch-e.exactMatch||t.score-e.score});var n=null;t=t.filter(function(e){var t=e.snippet||e.caption||e.value;return t===n?!1:(n=t,!0)}),this.filtered=t},this.filterCompletions=function(e,t){var n=[],r=t.toUpperCase(),i=t.toLowerCase();e:for(var s=0,o;o=e[s];s++){var u=o.value||o.caption||o.snippet;if(!u)continue;var a=-1,f=0,l=0,c,h;if(this.exactMatch){if(t!==u.substr(0,t.length))continue e}else for(var p=0;p<t.length;p++){var d=u.indexOf(i[p],a+1),v=u.indexOf(r[p],a+1);c=d>=0?v<0||d<v?d:v:v;if(c<0)continue e;h=c-a-1,h>0&&(a===-1&&(l+=10),l+=h),f|=1<<c,a=c}o.matchMask=f,o.exactMatch=l?0:1,o.score=(o.score||0)-l,n.push(o)}return n}}).call(c.prototype),t.Autocomplete=l,t.FilteredList=c}),ace.define("ace/autocomplete/text_completer",["require","exports","module","ace/range"],function(e,t,n){function s(e,t){var n=e.getTextRange(r.fromPoints({row:0,column:0},t));return n.split(i).length-1}function o(e,t){var n=s(e,t),r=e.getValue().split(i),o=Object.create(null),u=r[n];return r.forEach(function(e,t){if(!e||e===u)return;var i=Math.abs(n-t),s=r.length-i;o[e]?o[e]=Math.max(s,o[e]):o[e]=s}),o}var r=e("../range").Range,i=/[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;t.getCompletions=function(e,t,n,r,i){var s=o(t,n,r),u=Object.keys(s);i(null,u.map(function(e){return{caption:e,value:e,score:s[e],meta:"local"}}))}}),ace.define("ace/ext/language_tools",["require","exports","module","ace/snippets","ace/autocomplete","ace/config","ace/lib/lang","ace/autocomplete/util","ace/autocomplete/text_completer","ace/editor","ace/config"],function(e,t,n){"use strict";var r=e("../snippets").snippetManager,i=e("../autocomplete").Autocomplete,s=e("../config"),o=e("../lib/lang"),u=e("../autocomplete/util"),a=e("../autocomplete/text_completer"),f={getCompletions:function(e,t,n,r,i){if(t.$mode.completer)return t.$mode.completer.getCompletions(e,t,n,r,i);var s=e.session.getState(n.row),o=t.$mode.getCompletions(s,t,n,r);i(null,o)}},l={getCompletions:function(e,t,n,i,s){var o=r.snippetMap,u=[];r.getActiveScopes(e).forEach(function(e){var t=o[e]||[];for(var n=t.length;n--;){var r=t[n],i=r.name||r.tabTrigger;if(!i)continue;u.push({caption:i,snippet:r.content,meta:r.tabTrigger&&!r.name?r.tabTrigger+"\u21e5 ":"snippet",type:"snippet"})}},this),s(null,u)},getDocTooltip:function(e){e.type=="snippet"&&!e.docHTML&&(e.docHTML=["<b>",o.escapeHTML(e.caption),"</b>","<hr></hr>",o.escapeHTML(e.snippet)].join(""))}},c=[l,a,f];t.setCompleters=function(e){c.length=0,e&&c.push.apply(c,e)},t.addCompleter=function(e){c.push(e)},t.textCompleter=a,t.keyWordCompleter=f,t.snippetCompleter=l;var h={name:"expandSnippet",exec:function(e){return r.expandWithTab(e)},bindKey:"Tab"},p=function(e,t){d(t.session.$mode)},d=function(e){var t=e.$id;r.files||(r.files={}),v(t),e.modes&&e.modes.forEach(d)},v=function(e){if(!e||r.files[e])return;var t=e.replace("mode","snippets");r.files[e]={},s.loadModule(t,function(t){t&&(r.files[e]=t,!t.snippets&&t.snippetText&&(t.snippets=r.parseSnippetFile(t.snippetText)),r.register(t.snippets||[],t.scope),t.includeScopes&&(r.snippetMap[t.scope].includeScopes=t.includeScopes,t.includeScopes.forEach(function(e){v("ace/mode/"+e)})))})},m=function(e){var t=e.editor,n=t.completer&&t.completer.activated;if(e.command.name==="backspace")n&&!u.getCompletionPrefix(t)&&t.completer.detach();else if(e.command.name==="insertstring"){var r=u.getCompletionPrefix(t);r&&!n&&(t.completer||(t.completer=new i),t.completer.autoInsert=!1,t.completer.showPopup(t))}},g=e("../editor").Editor;e("../config").defineOptions(g.prototype,"editor",{enableBasicAutocompletion:{set:function(e){e?(this.completers||(this.completers=Array.isArray(e)?e:c),this.commands.addCommand(i.startCommand)):this.commands.removeCommand(i.startCommand)},value:!1},enableLiveAutocompletion:{set:function(e){e?(this.completers||(this.completers=Array.isArray(e)?e:c),this.commands.on("afterExec",m)):this.commands.removeListener("afterExec",m)},value:!1},enableSnippets:{set:function(e){e?(this.commands.addCommand(h),this.on("changeMode",p),p(null,this)):(this.commands.removeCommand(h),this.off("changeMode",p))},value:!1}})});
	                (function() {
	                    ace.require(["ace/ext/language_tools"], function() {});
	                })();
	            

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

	ace.define("ace/mode/sql_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){var e="select|insert|update|delete|from|where|and|or|group|by|order|limit|offset|having|as|case|when|else|end|type|left|right|join|on|outer|desc|asc|union|create|table|primary|key|if|foreign|not|references|default|null|inner|cross|natural|database|drop|grant",t="true|false",n="avg|count|first|last|max|min|sum|ucase|lcase|mid|len|round|rank|now|format|coalesce|ifnull|isnull|nvl",r="int|numeric|decimal|date|varchar|char|bigint|float|double|bit|binary|text|set|timestamp|money|real|number|integer",i=this.createKeywordMapper({"support.function":n,keyword:e,"constant.language":t,"storage.type":r},"identifier",!0);this.$rules={start:[{token:"comment",regex:"--.*$"},{token:"comment",start:"/\\*",end:"\\*/"},{token:"string",regex:'".*?"'},{token:"string",regex:"'.*?'"},{token:"constant.numeric",regex:"[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"},{token:i,regex:"[a-zA-Z_$][a-zA-Z0-9_$]*\\b"},{token:"keyword.operator",regex:"\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|="},{token:"paren.lparen",regex:"[\\(]"},{token:"paren.rparen",regex:"[\\)]"},{token:"text",regex:"\\s+"}]},this.normalizeRules()};r.inherits(s,i),t.SqlHighlightRules=s}),ace.define("ace/mode/sql",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/sql_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text").Mode,s=e("./sql_highlight_rules").SqlHighlightRules,o=function(){this.HighlightRules=s,this.$behaviour=this.$defaultBehaviour};r.inherits(o,i),function(){this.lineCommentStart="--",this.$id="ace/mode/sql"}.call(o.prototype),t.Mode=o})

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

	ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){this.$rules={start:[{token:"comment.doc.tag",regex:"@[\\w\\d_]+"},s.getTagRule(),{defaultToken:"comment.doc",caseInsensitive:!0}]}};r.inherits(s,i),s.getTagRule=function(e){return{token:"comment.doc.tag.storage.type",regex:"\\b(?:TODO|FIXME|XXX|HACK)\\b"}},s.getStartRule=function(e){return{token:"comment.doc",regex:"\\/\\*(?=\\*)",next:e}},s.getEndRule=function(e){return{token:"comment.doc",regex:"\\*\\/",next:e}},t.DocCommentHighlightRules=s}),ace.define("ace/mode/mysql_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"],function(e,t,n){var r=e("../lib/oop"),i=e("../lib/lang"),s=e("./doc_comment_highlight_rules").DocCommentHighlightRules,o=e("./text_highlight_rules").TextHighlightRules,u=function(){function i(e){var t=e.start,n=e.escape;return{token:"string.start",regex:t,next:[{token:"constant.language.escape",regex:n},{token:"string.end",next:"start",regex:t},{defaultToken:"string"}]}}var e="alter|and|as|asc|between|count|create|delete|desc|distinct|drop|from|having|in|insert|into|is|join|like|not|on|or|order|select|set|table|union|update|values|where|accessible|action|add|after|algorithm|all|analyze|asensitive|at|authors|auto_increment|autocommit|avg|avg_row_length|before|binary|binlog|both|btree|cache|call|cascade|cascaded|case|catalog_name|chain|change|changed|character|check|checkpoint|checksum|class_origin|client_statistics|close|coalesce|code|collate|collation|collations|column|columns|comment|commit|committed|completion|concurrent|condition|connection|consistent|constraint|contains|continue|contributors|convert|cross|current_date|current_time|current_timestamp|current_user|cursor|data|database|databases|day_hour|day_microsecond|day_minute|day_second|deallocate|dec|declare|default|delay_key_write|delayed|delimiter|des_key_file|describe|deterministic|dev_pop|dev_samp|deviance|directory|disable|discard|distinctrow|div|dual|dumpfile|each|elseif|enable|enclosed|end|ends|engine|engines|enum|errors|escape|escaped|even|event|events|every|execute|exists|exit|explain|extended|fast|fetch|field|fields|first|flush|for|force|foreign|found_rows|full|fulltext|function|general|global|grant|grants|group|groupby_concat|handler|hash|help|high_priority|hosts|hour_microsecond|hour_minute|hour_second|if|ignore|ignore_server_ids|import|index|index_statistics|infile|inner|innodb|inout|insensitive|insert_method|install|interval|invoker|isolation|iterate|key|keys|kill|language|last|leading|leave|left|level|limit|linear|lines|list|load|local|localtime|localtimestamp|lock|logs|low_priority|master|master_heartbeat_period|master_ssl_verify_server_cert|masters|match|max|max_rows|maxvalue|message_text|middleint|migrate|min|min_rows|minute_microsecond|minute_second|mod|mode|modifies|modify|mutex|mysql_errno|natural|next|no|no_write_to_binlog|offline|offset|one|online|open|optimize|option|optionally|out|outer|outfile|pack_keys|parser|partition|partitions|password|phase|plugin|plugins|prepare|preserve|prev|primary|privileges|procedure|processlist|profile|profiles|purge|query|quick|range|read|read_write|reads|real|rebuild|recover|references|regexp|relaylog|release|remove|rename|reorganize|repair|repeatable|replace|require|resignal|restrict|resume|return|returns|revoke|right|rlike|rollback|rollup|row|row_format|rtree|savepoint|schedule|schema|schema_name|schemas|second_microsecond|security|sensitive|separator|serializable|server|session|share|show|signal|slave|slow|smallint|snapshot|soname|spatial|specific|sql|sql_big_result|sql_buffer_result|sql_cache|sql_calc_found_rows|sql_no_cache|sql_small_result|sqlexception|sqlstate|sqlwarning|ssl|start|starting|starts|status|std|stddev|stddev_pop|stddev_samp|storage|straight_join|subclass_origin|sum|suspend|table_name|table_statistics|tables|tablespace|temporary|terminated|to|trailing|transaction|trigger|triggers|truncate|uncommitted|undo|uninstall|unique|unlock|upgrade|usage|use|use_frm|user|user_resources|user_statistics|using|utc_date|utc_time|utc_timestamp|value|variables|varying|view|views|warnings|when|while|with|work|write|xa|xor|year_month|zerofill|begin|do|then|else|loop|repeat",t="by|bool|boolean|bit|blob|decimal|double|enum|float|long|longblob|longtext|medium|mediumblob|mediumint|mediumtext|time|timestamp|tinyblob|tinyint|tinytext|text|bigint|int|int1|int2|int3|int4|int8|integer|float|float4|float8|double|char|varbinary|varchar|varcharacter|precision|date|datetime|year|unsigned|signed|numeric|ucase|lcase|mid|len|round|rank|now|format|coalesce|ifnull|isnull|nvl",n="charset|clear|connect|edit|ego|exit|go|help|nopager|notee|nowarning|pager|print|prompt|quit|rehash|source|status|system|tee",r=this.createKeywordMapper({"support.function":t,keyword:e,constant:"false|true|null|unknown|date|time|timestamp|ODBCdotTable|zerolessFloat","variable.language":n},"identifier",!0);this.$rules={start:[{token:"comment",regex:"(?:-- |#).*$"},i({start:'"',escape:/\\[0'"bnrtZ\\%_]?/}),i({start:"'",escape:/\\[0'"bnrtZ\\%_]?/}),s.getStartRule("doc-start"),{token:"comment",regex:/\/\*/,next:"comment"},{token:"constant.numeric",regex:/0[xX][0-9a-fA-F]+|[xX]'[0-9a-fA-F]+'|0[bB][01]+|[bB]'[01]+'/},{token:"constant.numeric",regex:"[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"},{token:r,regex:"[a-zA-Z_$][a-zA-Z0-9_$]*\\b"},{token:"constant.class",regex:"@@?[a-zA-Z_$][a-zA-Z0-9_$]*\\b"},{token:"constant.buildin",regex:"`[^`]*`"},{token:"keyword.operator",regex:"\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|="},{token:"paren.lparen",regex:"[\\(]"},{token:"paren.rparen",regex:"[\\)]"},{token:"text",regex:"\\s+"}],comment:[{token:"comment",regex:"\\*\\/",next:"start"},{defaultToken:"comment"}]},this.embedRules(s,"doc-",[s.getEndRule("start")]),this.normalizeRules()};r.inherits(u,o),t.MysqlHighlightRules=u}),ace.define("ace/mode/mysql",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/mysql_highlight_rules"],function(e,t,n){var r=e("../lib/oop"),i=e("../mode/text").Mode,s=e("./mysql_highlight_rules").MysqlHighlightRules,o=function(){this.HighlightRules=s,this.$behaviour=this.$defaultBehaviour};r.inherits(o,i),function(){this.lineCommentStart=["--","#"],this.blockComment={start:"/*",end:"*/"},this.$id="ace/mode/mysql"}.call(o.prototype),t.Mode=o})

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

	ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){this.$rules={start:[{token:"comment.doc.tag",regex:"@[\\w\\d_]+"},s.getTagRule(),{defaultToken:"comment.doc",caseInsensitive:!0}]}};r.inherits(s,i),s.getTagRule=function(e){return{token:"comment.doc.tag.storage.type",regex:"\\b(?:TODO|FIXME|XXX|HACK)\\b"}},s.getStartRule=function(e){return{token:"comment.doc",regex:"\\/\\*(?=\\*)",next:e}},s.getEndRule=function(e){return{token:"comment.doc",regex:"\\*\\/",next:e}},t.DocCommentHighlightRules=s}),ace.define("ace/mode/perl_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){var e="base|constant|continue|else|elsif|for|foreach|format|goto|if|last|local|my|next|no|package|parent|redo|require|scalar|sub|unless|until|while|use|vars",t="ARGV|ENV|INC|SIG",n="getprotobynumber|getprotobyname|getservbyname|gethostbyaddr|gethostbyname|getservbyport|getnetbyaddr|getnetbyname|getsockname|getpeername|setpriority|getprotoent|setprotoent|getpriority|endprotoent|getservent|setservent|endservent|sethostent|socketpair|getsockopt|gethostent|endhostent|setsockopt|setnetent|quotemeta|localtime|prototype|getnetent|endnetent|rewinddir|wantarray|getpwuid|closedir|getlogin|readlink|endgrent|getgrgid|getgrnam|shmwrite|shutdown|readline|endpwent|setgrent|readpipe|formline|truncate|dbmclose|syswrite|setpwent|getpwnam|getgrent|getpwent|ucfirst|sysread|setpgrp|shmread|sysseek|sysopen|telldir|defined|opendir|connect|lcfirst|getppid|binmode|syscall|sprintf|getpgrp|readdir|seekdir|waitpid|reverse|unshift|symlink|dbmopen|semget|msgrcv|rename|listen|chroot|msgsnd|shmctl|accept|unpack|exists|fileno|shmget|system|unlink|printf|gmtime|msgctl|semctl|values|rindex|substr|splice|length|msgget|select|socket|return|caller|delete|alarm|ioctl|index|undef|lstat|times|srand|chown|fcntl|close|write|umask|rmdir|study|sleep|chomp|untie|print|utime|mkdir|atan2|split|crypt|flock|chmod|BEGIN|bless|chdir|semop|shift|reset|link|stat|chop|grep|fork|dump|join|open|tell|pipe|exit|glob|warn|each|bind|sort|pack|eval|push|keys|getc|kill|seek|sqrt|send|wait|rand|tied|read|time|exec|recv|eof|chr|int|ord|exp|pos|pop|sin|log|abs|oct|hex|tie|cos|vec|END|ref|map|die|uc|lc|do",r=this.createKeywordMapper({keyword:e,"constant.language":t,"support.function":n},"identifier");this.$rules={start:[{token:"comment.doc",regex:"^=(?:begin|item)\\b",next:"block_comment"},{token:"string.regexp",regex:"[/](?:(?:\\[(?:\\\\]|[^\\]])+\\])|(?:\\\\/|[^\\]/]))*[/]\\w*\\s*(?=[).,;]|$)"},{token:"string",regex:'["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]'},{token:"string",regex:'["].*\\\\$',next:"qqstring"},{token:"string",regex:"['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"},{token:"string",regex:"['].*\\\\$",next:"qstring"},{token:"constant.numeric",regex:"0x[0-9a-fA-F]+\\b"},{token:"constant.numeric",regex:"[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"},{token:r,regex:"[a-zA-Z_$][a-zA-Z0-9_$]*\\b"},{token:"keyword.operator",regex:"%#|\\$#|\\.\\.\\.|\\|\\|=|>>=|<<=|<=>|&&=|=>|!~|\\^=|&=|\\|=|\\.=|x=|%=|\\/=|\\*=|\\-=|\\+=|=~|\\*\\*|\\-\\-|\\.\\.|\\|\\||&&|\\+\\+|\\->|!=|==|>=|<=|>>|<<|,|=|\\?\\:|\\^|\\||x|%|\\/|\\*|<|&|\\\\|~|!|>|\\.|\\-|\\+|\\-C|\\-b|\\-S|\\-u|\\-t|\\-p|\\-l|\\-d|\\-f|\\-g|\\-s|\\-z|\\-k|\\-e|\\-O|\\-T|\\-B|\\-M|\\-A|\\-X|\\-W|\\-c|\\-R|\\-o|\\-x|\\-w|\\-r|\\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)"},{token:"comment",regex:"#.*$"},{token:"lparen",regex:"[[({]"},{token:"rparen",regex:"[\\])}]"},{token:"text",regex:"\\s+"}],qqstring:[{token:"string",regex:'(?:(?:\\\\.)|(?:[^"\\\\]))*?"',next:"start"},{token:"string",regex:".+"}],qstring:[{token:"string",regex:"(?:(?:\\\\.)|(?:[^'\\\\]))*?'",next:"start"},{token:"string",regex:".+"}],block_comment:[{token:"comment.doc",regex:"^=cut\\b",next:"start"},{defaultToken:"comment.doc"}]}};r.inherits(s,i),t.PerlHighlightRules=s}),ace.define("ace/mode/python_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){var e="and|as|assert|break|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|not|or|pass|print|raise|return|try|while|with|yield",t="True|False|None|NotImplemented|Ellipsis|__debug__",n="abs|divmod|input|open|staticmethod|all|enumerate|int|ord|str|any|eval|isinstance|pow|sum|basestring|execfile|issubclass|print|super|binfile|iter|property|tuple|bool|filter|len|range|type|bytearray|float|list|raw_input|unichr|callable|format|locals|reduce|unicode|chr|frozenset|long|reload|vars|classmethod|getattr|map|repr|xrange|cmp|globals|max|reversed|zip|compile|hasattr|memoryview|round|__import__|complex|hash|min|set|apply|delattr|help|next|setattr|buffer|dict|hex|object|slice|coerce|dir|id|oct|sorted|intern",r=this.createKeywordMapper({"invalid.deprecated":"debugger","support.function":n,"constant.language":t,keyword:e},"identifier"),i="(?:r|u|ur|R|U|UR|Ur|uR)?",s="(?:(?:[1-9]\\d*)|(?:0))",o="(?:0[oO]?[0-7]+)",u="(?:0[xX][\\dA-Fa-f]+)",a="(?:0[bB][01]+)",f="(?:"+s+"|"+o+"|"+u+"|"+a+")",l="(?:[eE][+-]?\\d+)",c="(?:\\.\\d+)",h="(?:\\d+)",p="(?:(?:"+h+"?"+c+")|(?:"+h+"\\.))",d="(?:(?:"+p+"|"+h+")"+l+")",v="(?:"+d+"|"+p+")",m="\\\\(x[0-9A-Fa-f]{2}|[0-7]{3}|[\\\\abfnrtv'\"]|U[0-9A-Fa-f]{8}|u[0-9A-Fa-f]{4})";this.$rules={start:[{token:"comment",regex:"#.*$"},{token:"string",regex:i+'"{3}',next:"qqstring3"},{token:"string",regex:i+'"(?=.)',next:"qqstring"},{token:"string",regex:i+"'{3}",next:"qstring3"},{token:"string",regex:i+"'(?=.)",next:"qstring"},{token:"constant.numeric",regex:"(?:"+v+"|\\d+)[jJ]\\b"},{token:"constant.numeric",regex:v},{token:"constant.numeric",regex:f+"[lL]\\b"},{token:"constant.numeric",regex:f+"\\b"},{token:r,regex:"[a-zA-Z_$][a-zA-Z0-9_$]*\\b"},{token:"keyword.operator",regex:"\\+|\\-|\\*|\\*\\*|\\/|\\/\\/|%|<<|>>|&|\\||\\^|~|<|>|<=|=>|==|!=|<>|="},{token:"paren.lparen",regex:"[\\[\\(\\{]"},{token:"paren.rparen",regex:"[\\]\\)\\}]"},{token:"text",regex:"\\s+"}],qqstring3:[{token:"constant.language.escape",regex:m},{token:"string",regex:'"{3}',next:"start"},{defaultToken:"string"}],qstring3:[{token:"constant.language.escape",regex:m},{token:"string",regex:"'{3}",next:"start"},{defaultToken:"string"}],qqstring:[{token:"constant.language.escape",regex:m},{token:"string",regex:"\\\\$",next:"qqstring"},{token:"string",regex:'"|$',next:"start"},{defaultToken:"string"}],qstring:[{token:"constant.language.escape",regex:m},{token:"string",regex:"\\\\$",next:"qstring"},{token:"string",regex:"'|$",next:"start"},{defaultToken:"string"}]}};r.inherits(s,i),t.PythonHighlightRules=s}),ace.define("ace/mode/json_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){this.$rules={start:[{token:"variable",regex:'["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'},{token:"string",regex:'"',next:"string"},{token:"constant.numeric",regex:"0[xX][0-9a-fA-F]+\\b"},{token:"constant.numeric",regex:"[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"},{token:"constant.language.boolean",regex:"(?:true|false)\\b"},{token:"invalid.illegal",regex:"['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"},{token:"invalid.illegal",regex:"\\/\\/.*$"},{token:"paren.lparen",regex:"[[({]"},{token:"paren.rparen",regex:"[\\])}]"},{token:"text",regex:"\\s+"}],string:[{token:"constant.language.escape",regex:/\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/},{token:"string",regex:'[^"\\\\]+'},{token:"string",regex:'"',next:"start"},{token:"string",regex:"",next:"start"}]}};r.inherits(s,i),t.JsonHighlightRules=s}),ace.define("ace/mode/javascript_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";function a(){var e=o.replace("\\d","\\d\\-"),t={onMatch:function(e,t,n){var r=e.charAt(1)=="/"?2:1;if(r==1)t!=this.nextState?n.unshift(this.next,this.nextState,0):n.unshift(this.next),n[2]++;else if(r==2&&t==this.nextState){n[1]--;if(!n[1]||n[1]<0)n.shift(),n.shift()}return[{type:"meta.tag.punctuation."+(r==1?"":"end-")+"tag-open.xml",value:e.slice(0,r)},{type:"meta.tag.tag-name.xml",value:e.substr(r)}]},regex:"</?"+e+"",next:"jsxAttributes",nextState:"jsx"};this.$rules.start.unshift(t);var n={regex:"{",token:"paren.quasi.start",push:"start"};this.$rules.jsx=[n,t,{include:"reference"},{defaultToken:"string"}],this.$rules.jsxAttributes=[{token:"meta.tag.punctuation.tag-close.xml",regex:"/?>",onMatch:function(e,t,n){return t==n[0]&&n.shift(),e.length==2&&(n[0]==this.nextState&&n[1]--,(!n[1]||n[1]<0)&&n.splice(0,2)),this.next=n[0]||"start",[{type:this.token,value:e}]},nextState:"jsx"},n,f("jsxAttributes"),{token:"entity.other.attribute-name.xml",regex:e},{token:"keyword.operator.attribute-equals.xml",regex:"="},{token:"text.tag-whitespace.xml",regex:"\\s+"},{token:"string.attribute-value.xml",regex:"'",stateName:"jsx_attr_q",push:[{token:"string.attribute-value.xml",regex:"'",next:"pop"},{include:"reference"},{defaultToken:"string.attribute-value.xml"}]},{token:"string.attribute-value.xml",regex:'"',stateName:"jsx_attr_qq",push:[{token:"string.attribute-value.xml",regex:'"',next:"pop"},{include:"reference"},{defaultToken:"string.attribute-value.xml"}]},t],this.$rules.reference=[{token:"constant.language.escape.reference.xml",regex:"(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"}]}function f(e){return[{token:"comment",regex:/\/\*/,next:[i.getTagRule(),{token:"comment",regex:"\\*\\/",next:e||"pop"},{defaultToken:"comment",caseInsensitive:!0}]},{token:"comment",regex:"\\/\\/",next:[i.getTagRule(),{token:"comment",regex:"$|^",next:e||"pop"},{defaultToken:"comment",caseInsensitive:!0}]}]}var r=e("../lib/oop"),i=e("./doc_comment_highlight_rules").DocCommentHighlightRules,s=e("./text_highlight_rules").TextHighlightRules,o="[a-zA-Z\\$_\u00a1-\uffff][a-zA-Z\\d\\$_\u00a1-\uffff]*",u=function(e){var t=this.createKeywordMapper({"variable.language":"Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|Namespace|QName|XML|XMLList|ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|SyntaxError|TypeError|URIError|decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|isNaN|parseFloat|parseInt|JSON|Math|this|arguments|prototype|window|document",keyword:"const|yield|import|get|set|async|await|break|case|catch|continue|default|delete|do|else|finally|for|function|if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|__parent__|__count__|escape|unescape|with|__proto__|class|enum|extends|super|export|implements|private|public|interface|package|protected|static","storage.type":"const|let|var|function","constant.language":"null|Infinity|NaN|undefined","support.function":"alert","constant.language.boolean":"true|false"},"identifier"),n="case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void",r="\\\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|u{[0-9a-fA-F]{1,6}}|[0-2][0-7]{0,2}|3[0-7][0-7]?|[4-7][0-7]?|.)";this.$rules={no_regex:[i.getStartRule("doc-start"),f("no_regex"),{token:"string",regex:"'(?=.)",next:"qstring"},{token:"string",regex:'"(?=.)',next:"qqstring"},{token:"constant.numeric",regex:/0(?:[xX][0-9a-fA-F]+|[bB][01]+)\b/},{token:"constant.numeric",regex:/[+-]?\d[\d_]*(?:(?:\.\d*)?(?:[eE][+-]?\d+)?)?\b/},{token:["storage.type","punctuation.operator","support.function","punctuation.operator","entity.name.function","text","keyword.operator"],regex:"("+o+")(\\.)(prototype)(\\.)("+o+")(\\s*)(=)",next:"function_arguments"},{token:["storage.type","punctuation.operator","entity.name.function","text","keyword.operator","text","storage.type","text","paren.lparen"],regex:"("+o+")(\\.)("+o+")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:["entity.name.function","text","keyword.operator","text","storage.type","text","paren.lparen"],regex:"("+o+")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:["storage.type","punctuation.operator","entity.name.function","text","keyword.operator","text","storage.type","text","entity.name.function","text","paren.lparen"],regex:"("+o+")(\\.)("+o+")(\\s*)(=)(\\s*)(function)(\\s+)(\\w+)(\\s*)(\\()",next:"function_arguments"},{token:["storage.type","text","entity.name.function","text","paren.lparen"],regex:"(function)(\\s+)("+o+")(\\s*)(\\()",next:"function_arguments"},{token:["entity.name.function","text","punctuation.operator","text","storage.type","text","paren.lparen"],regex:"("+o+")(\\s*)(:)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:["text","text","storage.type","text","paren.lparen"],regex:"(:)(\\s*)(function)(\\s*)(\\()",next:"function_arguments"},{token:"keyword",regex:"(?:"+n+")\\b",next:"start"},{token:["support.constant"],regex:/that\b/},{token:["storage.type","punctuation.operator","support.function.firebug"],regex:/(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/},{token:t,regex:o},{token:"punctuation.operator",regex:/[.](?![.])/,next:"property"},{token:"keyword.operator",regex:/--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,next:"start"},{token:"punctuation.operator",regex:/[?:,;.]/,next:"start"},{token:"paren.lparen",regex:/[\[({]/,next:"start"},{token:"paren.rparen",regex:/[\])}]/},{token:"comment",regex:/^#!.*$/}],property:[{token:"text",regex:"\\s+"},{token:["storage.type","punctuation.operator","entity.name.function","text","keyword.operator","text","storage.type","text","entity.name.function","text","paren.lparen"],regex:"("+o+")(\\.)("+o+")(\\s*)(=)(\\s*)(function)(?:(\\s+)(\\w+))?(\\s*)(\\()",next:"function_arguments"},{token:"punctuation.operator",regex:/[.](?![.])/},{token:"support.function",regex:/(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/},{token:"support.function.dom",regex:/(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/},{token:"support.constant",regex:/(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/},{token:"identifier",regex:o},{regex:"",token:"empty",next:"no_regex"}],start:[i.getStartRule("doc-start"),f("start"),{token:"string.regexp",regex:"\\/",next:"regex"},{token:"text",regex:"\\s+|^$",next:"start"},{token:"empty",regex:"",next:"no_regex"}],regex:[{token:"regexp.keyword.operator",regex:"\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"},{token:"string.regexp",regex:"/[sxngimy]*",next:"no_regex"},{token:"invalid",regex:/\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/},{token:"constant.language.escape",regex:/\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/},{token:"constant.language.delimiter",regex:/\|/},{token:"constant.language.escape",regex:/\[\^?/,next:"regex_character_class"},{token:"empty",regex:"$",next:"no_regex"},{defaultToken:"string.regexp"}],regex_character_class:[{token:"regexp.charclass.keyword.operator",regex:"\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"},{token:"constant.language.escape",regex:"]",next:"regex"},{token:"constant.language.escape",regex:"-"},{token:"empty",regex:"$",next:"no_regex"},{defaultToken:"string.regexp.charachterclass"}],function_arguments:[{token:"variable.parameter",regex:o},{token:"punctuation.operator",regex:"[, ]+"},{token:"punctuation.operator",regex:"$"},{token:"empty",regex:"",next:"no_regex"}],qqstring:[{token:"constant.language.escape",regex:r},{token:"string",regex:"\\\\$",next:"qqstring"},{token:"string",regex:'"|$',next:"no_regex"},{defaultToken:"string"}],qstring:[{token:"constant.language.escape",regex:r},{token:"string",regex:"\\\\$",next:"qstring"},{token:"string",regex:"'|$",next:"no_regex"},{defaultToken:"string"}]};if(!e||!e.noES6)this.$rules.no_regex.unshift({regex:"[{}]",onMatch:function(e,t,n){this.next=e=="{"?this.nextState:"";if(e=="{"&&n.length)n.unshift("start",t);else if(e=="}"&&n.length){n.shift(),this.next=n.shift();if(this.next.indexOf("string")!=-1||this.next.indexOf("jsx")!=-1)return"paren.quasi.end"}return e=="{"?"paren.lparen":"paren.rparen"},nextState:"start"},{token:"string.quasi.start",regex:/`/,push:[{token:"constant.language.escape",regex:r},{token:"paren.quasi.start",regex:/\${/,push:"start"},{token:"string.quasi.end",regex:/`/,next:"pop"},{defaultToken:"string.quasi"}]}),(!e||e.jsx!=0)&&a.call(this);this.embedRules(i,"doc-",[i.getEndRule("no_regex")]),this.normalizeRules()};r.inherits(u,s),t.JavaScriptHighlightRules=u}),ace.define("ace/mode/pgsql_highlight_rules",["require","exports","module","ace/lib/oop","ace/lib/lang","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules","ace/mode/perl_highlight_rules","ace/mode/python_highlight_rules","ace/mode/json_highlight_rules","ace/mode/javascript_highlight_rules"],function(e,t,n){var r=e("../lib/oop"),i=e("../lib/lang"),s=e("./doc_comment_highlight_rules").DocCommentHighlightRules,o=e("./text_highlight_rules").TextHighlightRules,u=e("./perl_highlight_rules").PerlHighlightRules,a=e("./python_highlight_rules").PythonHighlightRules,f=e("./json_highlight_rules").JsonHighlightRules,l=e("./javascript_highlight_rules").JavaScriptHighlightRules,c=function(){var e="abort|absolute|abstime|access|aclitem|action|add|admin|after|aggregate|all|also|alter|always|analyse|analyze|and|any|anyarray|anyelement|anyenum|anynonarray|anyrange|array|as|asc|assertion|assignment|asymmetric|at|attribute|authorization|backward|before|begin|between|bigint|binary|bit|bool|boolean|both|box|bpchar|by|bytea|cache|called|cascade|cascaded|case|cast|catalog|chain|char|character|characteristics|check|checkpoint|cid|cidr|circle|class|close|cluster|coalesce|collate|collation|column|comment|comments|commit|committed|concurrently|configuration|connection|constraint|constraints|content|continue|conversion|copy|cost|create|cross|cstring|csv|current|current_catalog|current_date|current_role|current_schema|current_time|current_timestamp|current_user|cursor|cycle|data|database|date|daterange|day|deallocate|dec|decimal|declare|default|defaults|deferrable|deferred|definer|delete|delimiter|delimiters|desc|dictionary|disable|discard|distinct|do|document|domain|double|drop|each|else|enable|encoding|encrypted|end|enum|escape|event|event_trigger|except|exclude|excluding|exclusive|execute|exists|explain|extension|external|extract|false|family|fdw_handler|fetch|first|float|float4|float8|following|for|force|foreign|forward|freeze|from|full|function|functions|global|grant|granted|greatest|group|gtsvector|handler|having|header|hold|hour|identity|if|ilike|immediate|immutable|implicit|in|including|increment|index|indexes|inet|inherit|inherits|initially|inline|inner|inout|input|insensitive|insert|instead|int|int2|int2vector|int4|int4range|int8|int8range|integer|internal|intersect|interval|into|invoker|is|isnull|isolation|join|json|key|label|language|language_handler|large|last|lateral|lc_collate|lc_ctype|leading|leakproof|least|left|level|like|limit|line|listen|load|local|localtime|localtimestamp|location|lock|lseg|macaddr|mapping|match|materialized|maxvalue|minute|minvalue|mode|money|month|move|name|names|national|natural|nchar|next|no|none|not|nothing|notify|notnull|nowait|null|nullif|nulls|numeric|numrange|object|of|off|offset|oid|oids|oidvector|on|only|opaque|operator|option|options|or|order|out|outer|over|overlaps|overlay|owned|owner|parser|partial|partition|passing|password|path|pg_attribute|pg_auth_members|pg_authid|pg_class|pg_database|pg_node_tree|pg_proc|pg_type|placing|plans|point|polygon|position|preceding|precision|prepare|prepared|preserve|primary|prior|privileges|procedural|procedure|program|quote|range|read|real|reassign|recheck|record|recursive|ref|refcursor|references|refresh|regclass|regconfig|regdictionary|regoper|regoperator|regproc|regprocedure|regtype|reindex|relative|release|reltime|rename|repeatable|replace|replica|reset|restart|restrict|returning|returns|revoke|right|role|rollback|row|rows|rule|savepoint|schema|scroll|search|second|security|select|sequence|sequences|serializable|server|session|session_user|set|setof|share|show|similar|simple|smallint|smgr|snapshot|some|stable|standalone|start|statement|statistics|stdin|stdout|storage|strict|strip|substring|symmetric|sysid|system|table|tables|tablespace|temp|template|temporary|text|then|tid|time|timestamp|timestamptz|timetz|tinterval|to|trailing|transaction|treat|trigger|trim|true|truncate|trusted|tsquery|tsrange|tstzrange|tsvector|txid_snapshot|type|types|unbounded|uncommitted|unencrypted|union|unique|unknown|unlisten|unlogged|until|update|user|using|uuid|vacuum|valid|validate|validator|value|values|varbit|varchar|variadic|varying|verbose|version|view|void|volatile|when|where|whitespace|window|with|without|work|wrapper|write|xid|xml|xmlattributes|xmlconcat|xmlelement|xmlexists|xmlforest|xmlparse|xmlpi|xmlroot|xmlserialize|year|yes|zone",t="RI_FKey_cascade_del|RI_FKey_cascade_upd|RI_FKey_check_ins|RI_FKey_check_upd|RI_FKey_noaction_del|RI_FKey_noaction_upd|RI_FKey_restrict_del|RI_FKey_restrict_upd|RI_FKey_setdefault_del|RI_FKey_setdefault_upd|RI_FKey_setnull_del|RI_FKey_setnull_upd|abbrev|abs|abstime|abstimeeq|abstimege|abstimegt|abstimein|abstimele|abstimelt|abstimene|abstimeout|abstimerecv|abstimesend|aclcontains|acldefault|aclexplode|aclinsert|aclitemeq|aclitemin|aclitemout|aclremove|acos|age|any_in|any_out|anyarray_in|anyarray_out|anyarray_recv|anyarray_send|anyelement_in|anyelement_out|anyenum_in|anyenum_out|anynonarray_in|anynonarray_out|anyrange_in|anyrange_out|anytextcat|area|areajoinsel|areasel|array_agg|array_agg_finalfn|array_agg_transfn|array_append|array_cat|array_dims|array_eq|array_fill|array_ge|array_gt|array_in|array_larger|array_le|array_length|array_lower|array_lt|array_ndims|array_ne|array_out|array_prepend|array_recv|array_remove|array_replace|array_send|array_smaller|array_to_json|array_to_string|array_typanalyze|array_upper|arraycontained|arraycontains|arraycontjoinsel|arraycontsel|arrayoverlap|ascii|ascii_to_mic|ascii_to_utf8|asin|atan|atan2|avg|big5_to_euc_tw|big5_to_mic|big5_to_utf8|bit_and|bit_in|bit_length|bit_or|bit_out|bit_recv|bit_send|bitand|bitcat|bitcmp|biteq|bitge|bitgt|bitle|bitlt|bitne|bitnot|bitor|bitshiftleft|bitshiftright|bittypmodin|bittypmodout|bitxor|bool|bool_and|bool_or|booland_statefunc|booleq|boolge|boolgt|boolin|boolle|boollt|boolne|boolor_statefunc|boolout|boolrecv|boolsend|box|box_above|box_above_eq|box_add|box_below|box_below_eq|box_center|box_contain|box_contain_pt|box_contained|box_distance|box_div|box_eq|box_ge|box_gt|box_in|box_intersect|box_le|box_left|box_lt|box_mul|box_out|box_overabove|box_overbelow|box_overlap|box_overleft|box_overright|box_recv|box_right|box_same|box_send|box_sub|bpchar_larger|bpchar_pattern_ge|bpchar_pattern_gt|bpchar_pattern_le|bpchar_pattern_lt|bpchar_smaller|bpcharcmp|bpchareq|bpcharge|bpchargt|bpchariclike|bpcharicnlike|bpcharicregexeq|bpcharicregexne|bpcharin|bpcharle|bpcharlike|bpcharlt|bpcharne|bpcharnlike|bpcharout|bpcharrecv|bpcharregexeq|bpcharregexne|bpcharsend|bpchartypmodin|bpchartypmodout|broadcast|btabstimecmp|btarraycmp|btbeginscan|btboolcmp|btbpchar_pattern_cmp|btbuild|btbuildempty|btbulkdelete|btcanreturn|btcharcmp|btcostestimate|btendscan|btfloat48cmp|btfloat4cmp|btfloat4sortsupport|btfloat84cmp|btfloat8cmp|btfloat8sortsupport|btgetbitmap|btgettuple|btinsert|btint24cmp|btint28cmp|btint2cmp|btint2sortsupport|btint42cmp|btint48cmp|btint4cmp|btint4sortsupport|btint82cmp|btint84cmp|btint8cmp|btint8sortsupport|btmarkpos|btnamecmp|btnamesortsupport|btoidcmp|btoidsortsupport|btoidvectorcmp|btoptions|btrecordcmp|btreltimecmp|btrescan|btrestrpos|btrim|bttext_pattern_cmp|bttextcmp|bttidcmp|bttintervalcmp|btvacuumcleanup|bytea_string_agg_finalfn|bytea_string_agg_transfn|byteacat|byteacmp|byteaeq|byteage|byteagt|byteain|byteale|bytealike|bytealt|byteane|byteanlike|byteaout|bytearecv|byteasend|cash_cmp|cash_div_cash|cash_div_flt4|cash_div_flt8|cash_div_int2|cash_div_int4|cash_eq|cash_ge|cash_gt|cash_in|cash_le|cash_lt|cash_mi|cash_mul_flt4|cash_mul_flt8|cash_mul_int2|cash_mul_int4|cash_ne|cash_out|cash_pl|cash_recv|cash_send|cash_words|cashlarger|cashsmaller|cbrt|ceil|ceiling|center|char|char_length|character_length|chareq|charge|chargt|charin|charle|charlt|charne|charout|charrecv|charsend|chr|cideq|cidin|cidout|cidr|cidr_in|cidr_out|cidr_recv|cidr_send|cidrecv|cidsend|circle|circle_above|circle_add_pt|circle_below|circle_center|circle_contain|circle_contain_pt|circle_contained|circle_distance|circle_div_pt|circle_eq|circle_ge|circle_gt|circle_in|circle_le|circle_left|circle_lt|circle_mul_pt|circle_ne|circle_out|circle_overabove|circle_overbelow|circle_overlap|circle_overleft|circle_overright|circle_recv|circle_right|circle_same|circle_send|circle_sub_pt|clock_timestamp|close_lb|close_ls|close_lseg|close_pb|close_pl|close_ps|close_sb|close_sl|col_description|concat|concat_ws|contjoinsel|contsel|convert|convert_from|convert_to|corr|cos|cot|count|covar_pop|covar_samp|cstring_in|cstring_out|cstring_recv|cstring_send|cume_dist|current_database|current_query|current_schema|current_schemas|current_setting|current_user|currtid|currtid2|currval|cursor_to_xml|cursor_to_xmlschema|database_to_xml|database_to_xml_and_xmlschema|database_to_xmlschema|date|date_cmp|date_cmp_timestamp|date_cmp_timestamptz|date_eq|date_eq_timestamp|date_eq_timestamptz|date_ge|date_ge_timestamp|date_ge_timestamptz|date_gt|date_gt_timestamp|date_gt_timestamptz|date_in|date_larger|date_le|date_le_timestamp|date_le_timestamptz|date_lt|date_lt_timestamp|date_lt_timestamptz|date_mi|date_mi_interval|date_mii|date_ne|date_ne_timestamp|date_ne_timestamptz|date_out|date_part|date_pl_interval|date_pli|date_recv|date_send|date_smaller|date_sortsupport|date_trunc|daterange|daterange_canonical|daterange_subdiff|datetime_pl|datetimetz_pl|dcbrt|decode|degrees|dense_rank|dexp|diagonal|diameter|dispell_init|dispell_lexize|dist_cpoly|dist_lb|dist_pb|dist_pc|dist_pl|dist_ppath|dist_ps|dist_sb|dist_sl|div|dlog1|dlog10|domain_in|domain_recv|dpow|dround|dsimple_init|dsimple_lexize|dsnowball_init|dsnowball_lexize|dsqrt|dsynonym_init|dsynonym_lexize|dtrunc|elem_contained_by_range|encode|enum_cmp|enum_eq|enum_first|enum_ge|enum_gt|enum_in|enum_larger|enum_last|enum_le|enum_lt|enum_ne|enum_out|enum_range|enum_recv|enum_send|enum_smaller|eqjoinsel|eqsel|euc_cn_to_mic|euc_cn_to_utf8|euc_jis_2004_to_shift_jis_2004|euc_jis_2004_to_utf8|euc_jp_to_mic|euc_jp_to_sjis|euc_jp_to_utf8|euc_kr_to_mic|euc_kr_to_utf8|euc_tw_to_big5|euc_tw_to_mic|euc_tw_to_utf8|event_trigger_in|event_trigger_out|every|exp|factorial|family|fdw_handler_in|fdw_handler_out|first_value|float4|float48div|float48eq|float48ge|float48gt|float48le|float48lt|float48mi|float48mul|float48ne|float48pl|float4_accum|float4abs|float4div|float4eq|float4ge|float4gt|float4in|float4larger|float4le|float4lt|float4mi|float4mul|float4ne|float4out|float4pl|float4recv|float4send|float4smaller|float4um|float4up|float8|float84div|float84eq|float84ge|float84gt|float84le|float84lt|float84mi|float84mul|float84ne|float84pl|float8_accum|float8_avg|float8_corr|float8_covar_pop|float8_covar_samp|float8_regr_accum|float8_regr_avgx|float8_regr_avgy|float8_regr_intercept|float8_regr_r2|float8_regr_slope|float8_regr_sxx|float8_regr_sxy|float8_regr_syy|float8_stddev_pop|float8_stddev_samp|float8_var_pop|float8_var_samp|float8abs|float8div|float8eq|float8ge|float8gt|float8in|float8larger|float8le|float8lt|float8mi|float8mul|float8ne|float8out|float8pl|float8recv|float8send|float8smaller|float8um|float8up|floor|flt4_mul_cash|flt8_mul_cash|fmgr_c_validator|fmgr_internal_validator|fmgr_sql_validator|format|format_type|gb18030_to_utf8|gbk_to_utf8|generate_series|generate_subscripts|get_bit|get_byte|get_current_ts_config|getdatabaseencoding|getpgusername|gin_cmp_prefix|gin_cmp_tslexeme|gin_extract_tsquery|gin_extract_tsvector|gin_tsquery_consistent|ginarrayconsistent|ginarrayextract|ginbeginscan|ginbuild|ginbuildempty|ginbulkdelete|gincostestimate|ginendscan|gingetbitmap|gininsert|ginmarkpos|ginoptions|ginqueryarrayextract|ginrescan|ginrestrpos|ginvacuumcleanup|gist_box_compress|gist_box_consistent|gist_box_decompress|gist_box_penalty|gist_box_picksplit|gist_box_same|gist_box_union|gist_circle_compress|gist_circle_consistent|gist_point_compress|gist_point_consistent|gist_point_distance|gist_poly_compress|gist_poly_consistent|gistbeginscan|gistbuild|gistbuildempty|gistbulkdelete|gistcostestimate|gistendscan|gistgetbitmap|gistgettuple|gistinsert|gistmarkpos|gistoptions|gistrescan|gistrestrpos|gistvacuumcleanup|gtsquery_compress|gtsquery_consistent|gtsquery_decompress|gtsquery_penalty|gtsquery_picksplit|gtsquery_same|gtsquery_union|gtsvector_compress|gtsvector_consistent|gtsvector_decompress|gtsvector_penalty|gtsvector_picksplit|gtsvector_same|gtsvector_union|gtsvectorin|gtsvectorout|has_any_column_privilege|has_column_privilege|has_database_privilege|has_foreign_data_wrapper_privilege|has_function_privilege|has_language_privilege|has_schema_privilege|has_sequence_privilege|has_server_privilege|has_table_privilege|has_tablespace_privilege|has_type_privilege|hash_aclitem|hash_array|hash_numeric|hash_range|hashbeginscan|hashbpchar|hashbuild|hashbuildempty|hashbulkdelete|hashchar|hashcostestimate|hashendscan|hashenum|hashfloat4|hashfloat8|hashgetbitmap|hashgettuple|hashinet|hashinsert|hashint2|hashint2vector|hashint4|hashint8|hashmacaddr|hashmarkpos|hashname|hashoid|hashoidvector|hashoptions|hashrescan|hashrestrpos|hashtext|hashvacuumcleanup|hashvarlena|height|host|hostmask|iclikejoinsel|iclikesel|icnlikejoinsel|icnlikesel|icregexeqjoinsel|icregexeqsel|icregexnejoinsel|icregexnesel|inet_client_addr|inet_client_port|inet_in|inet_out|inet_recv|inet_send|inet_server_addr|inet_server_port|inetand|inetmi|inetmi_int8|inetnot|inetor|inetpl|initcap|int2|int24div|int24eq|int24ge|int24gt|int24le|int24lt|int24mi|int24mul|int24ne|int24pl|int28div|int28eq|int28ge|int28gt|int28le|int28lt|int28mi|int28mul|int28ne|int28pl|int2_accum|int2_avg_accum|int2_mul_cash|int2_sum|int2abs|int2and|int2div|int2eq|int2ge|int2gt|int2in|int2larger|int2le|int2lt|int2mi|int2mod|int2mul|int2ne|int2not|int2or|int2out|int2pl|int2recv|int2send|int2shl|int2shr|int2smaller|int2um|int2up|int2vectoreq|int2vectorin|int2vectorout|int2vectorrecv|int2vectorsend|int2xor|int4|int42div|int42eq|int42ge|int42gt|int42le|int42lt|int42mi|int42mul|int42ne|int42pl|int48div|int48eq|int48ge|int48gt|int48le|int48lt|int48mi|int48mul|int48ne|int48pl|int4_accum|int4_avg_accum|int4_mul_cash|int4_sum|int4abs|int4and|int4div|int4eq|int4ge|int4gt|int4in|int4inc|int4larger|int4le|int4lt|int4mi|int4mod|int4mul|int4ne|int4not|int4or|int4out|int4pl|int4range|int4range_canonical|int4range_subdiff|int4recv|int4send|int4shl|int4shr|int4smaller|int4um|int4up|int4xor|int8|int82div|int82eq|int82ge|int82gt|int82le|int82lt|int82mi|int82mul|int82ne|int82pl|int84div|int84eq|int84ge|int84gt|int84le|int84lt|int84mi|int84mul|int84ne|int84pl|int8_accum|int8_avg|int8_avg_accum|int8_sum|int8abs|int8and|int8div|int8eq|int8ge|int8gt|int8in|int8inc|int8inc_any|int8inc_float8_float8|int8larger|int8le|int8lt|int8mi|int8mod|int8mul|int8ne|int8not|int8or|int8out|int8pl|int8pl_inet|int8range|int8range_canonical|int8range_subdiff|int8recv|int8send|int8shl|int8shr|int8smaller|int8um|int8up|int8xor|integer_pl_date|inter_lb|inter_sb|inter_sl|internal_in|internal_out|interval_accum|interval_avg|interval_cmp|interval_div|interval_eq|interval_ge|interval_gt|interval_hash|interval_in|interval_larger|interval_le|interval_lt|interval_mi|interval_mul|interval_ne|interval_out|interval_pl|interval_pl_date|interval_pl_time|interval_pl_timestamp|interval_pl_timestamptz|interval_pl_timetz|interval_recv|interval_send|interval_smaller|interval_transform|interval_um|intervaltypmodin|intervaltypmodout|intinterval|isclosed|isempty|isfinite|ishorizontal|iso8859_1_to_utf8|iso8859_to_utf8|iso_to_koi8r|iso_to_mic|iso_to_win1251|iso_to_win866|isopen|isparallel|isperp|isvertical|johab_to_utf8|json_agg|json_agg_finalfn|json_agg_transfn|json_array_element|json_array_element_text|json_array_elements|json_array_length|json_each|json_each_text|json_extract_path|json_extract_path_op|json_extract_path_text|json_extract_path_text_op|json_in|json_object_field|json_object_field_text|json_object_keys|json_out|json_populate_record|json_populate_recordset|json_recv|json_send|justify_days|justify_hours|justify_interval|koi8r_to_iso|koi8r_to_mic|koi8r_to_utf8|koi8r_to_win1251|koi8r_to_win866|koi8u_to_utf8|lag|language_handler_in|language_handler_out|last_value|lastval|latin1_to_mic|latin2_to_mic|latin2_to_win1250|latin3_to_mic|latin4_to_mic|lead|left|length|like|like_escape|likejoinsel|likesel|line|line_distance|line_eq|line_horizontal|line_in|line_interpt|line_intersect|line_out|line_parallel|line_perp|line_recv|line_send|line_vertical|ln|lo_close|lo_creat|lo_create|lo_export|lo_import|lo_lseek|lo_lseek64|lo_open|lo_tell|lo_tell64|lo_truncate|lo_truncate64|lo_unlink|log|loread|lower|lower_inc|lower_inf|lowrite|lpad|lseg|lseg_center|lseg_distance|lseg_eq|lseg_ge|lseg_gt|lseg_horizontal|lseg_in|lseg_interpt|lseg_intersect|lseg_le|lseg_length|lseg_lt|lseg_ne|lseg_out|lseg_parallel|lseg_perp|lseg_recv|lseg_send|lseg_vertical|ltrim|macaddr_and|macaddr_cmp|macaddr_eq|macaddr_ge|macaddr_gt|macaddr_in|macaddr_le|macaddr_lt|macaddr_ne|macaddr_not|macaddr_or|macaddr_out|macaddr_recv|macaddr_send|makeaclitem|masklen|max|md5|mic_to_ascii|mic_to_big5|mic_to_euc_cn|mic_to_euc_jp|mic_to_euc_kr|mic_to_euc_tw|mic_to_iso|mic_to_koi8r|mic_to_latin1|mic_to_latin2|mic_to_latin3|mic_to_latin4|mic_to_sjis|mic_to_win1250|mic_to_win1251|mic_to_win866|min|mktinterval|mod|money|mul_d_interval|name|nameeq|namege|namegt|nameiclike|nameicnlike|nameicregexeq|nameicregexne|namein|namele|namelike|namelt|namene|namenlike|nameout|namerecv|nameregexeq|nameregexne|namesend|neqjoinsel|neqsel|netmask|network|network_cmp|network_eq|network_ge|network_gt|network_le|network_lt|network_ne|network_sub|network_subeq|network_sup|network_supeq|nextval|nlikejoinsel|nlikesel|notlike|now|npoints|nth_value|ntile|numeric_abs|numeric_accum|numeric_add|numeric_avg|numeric_avg_accum|numeric_cmp|numeric_div|numeric_div_trunc|numeric_eq|numeric_exp|numeric_fac|numeric_ge|numeric_gt|numeric_in|numeric_inc|numeric_larger|numeric_le|numeric_ln|numeric_log|numeric_lt|numeric_mod|numeric_mul|numeric_ne|numeric_out|numeric_power|numeric_recv|numeric_send|numeric_smaller|numeric_sqrt|numeric_stddev_pop|numeric_stddev_samp|numeric_sub|numeric_transform|numeric_uminus|numeric_uplus|numeric_var_pop|numeric_var_samp|numerictypmodin|numerictypmodout|numnode|numrange|numrange_subdiff|obj_description|octet_length|oid|oideq|oidge|oidgt|oidin|oidlarger|oidle|oidlt|oidne|oidout|oidrecv|oidsend|oidsmaller|oidvectoreq|oidvectorge|oidvectorgt|oidvectorin|oidvectorle|oidvectorlt|oidvectorne|oidvectorout|oidvectorrecv|oidvectorsend|oidvectortypes|on_pb|on_pl|on_ppath|on_ps|on_sb|on_sl|opaque_in|opaque_out|overlaps|overlay|path|path_add|path_add_pt|path_center|path_contain_pt|path_distance|path_div_pt|path_in|path_inter|path_length|path_mul_pt|path_n_eq|path_n_ge|path_n_gt|path_n_le|path_n_lt|path_npoints|path_out|path_recv|path_send|path_sub_pt|pclose|percent_rank|pg_advisory_lock|pg_advisory_lock_shared|pg_advisory_unlock|pg_advisory_unlock_all|pg_advisory_unlock_shared|pg_advisory_xact_lock|pg_advisory_xact_lock_shared|pg_available_extension_versions|pg_available_extensions|pg_backend_pid|pg_backup_start_time|pg_cancel_backend|pg_char_to_encoding|pg_client_encoding|pg_collation_for|pg_collation_is_visible|pg_column_is_updatable|pg_column_size|pg_conf_load_time|pg_conversion_is_visible|pg_create_restore_point|pg_current_xlog_insert_location|pg_current_xlog_location|pg_cursor|pg_database_size|pg_describe_object|pg_encoding_max_length|pg_encoding_to_char|pg_event_trigger_dropped_objects|pg_export_snapshot|pg_extension_config_dump|pg_extension_update_paths|pg_function_is_visible|pg_get_constraintdef|pg_get_expr|pg_get_function_arguments|pg_get_function_identity_arguments|pg_get_function_result|pg_get_functiondef|pg_get_indexdef|pg_get_keywords|pg_get_multixact_members|pg_get_ruledef|pg_get_serial_sequence|pg_get_triggerdef|pg_get_userbyid|pg_get_viewdef|pg_has_role|pg_identify_object|pg_indexes_size|pg_is_in_backup|pg_is_in_recovery|pg_is_other_temp_schema|pg_is_xlog_replay_paused|pg_last_xact_replay_timestamp|pg_last_xlog_receive_location|pg_last_xlog_replay_location|pg_listening_channels|pg_lock_status|pg_ls_dir|pg_my_temp_schema|pg_node_tree_in|pg_node_tree_out|pg_node_tree_recv|pg_node_tree_send|pg_notify|pg_opclass_is_visible|pg_operator_is_visible|pg_opfamily_is_visible|pg_options_to_table|pg_postmaster_start_time|pg_prepared_statement|pg_prepared_xact|pg_read_binary_file|pg_read_file|pg_relation_filenode|pg_relation_filepath|pg_relation_is_updatable|pg_relation_size|pg_reload_conf|pg_rotate_logfile|pg_sequence_parameters|pg_show_all_settings|pg_size_pretty|pg_sleep|pg_start_backup|pg_stat_clear_snapshot|pg_stat_file|pg_stat_get_activity|pg_stat_get_analyze_count|pg_stat_get_autoanalyze_count|pg_stat_get_autovacuum_count|pg_stat_get_backend_activity|pg_stat_get_backend_activity_start|pg_stat_get_backend_client_addr|pg_stat_get_backend_client_port|pg_stat_get_backend_dbid|pg_stat_get_backend_idset|pg_stat_get_backend_pid|pg_stat_get_backend_start|pg_stat_get_backend_userid|pg_stat_get_backend_waiting|pg_stat_get_backend_xact_start|pg_stat_get_bgwriter_buf_written_checkpoints|pg_stat_get_bgwriter_buf_written_clean|pg_stat_get_bgwriter_maxwritten_clean|pg_stat_get_bgwriter_requested_checkpoints|pg_stat_get_bgwriter_stat_reset_time|pg_stat_get_bgwriter_timed_checkpoints|pg_stat_get_blocks_fetched|pg_stat_get_blocks_hit|pg_stat_get_buf_alloc|pg_stat_get_buf_fsync_backend|pg_stat_get_buf_written_backend|pg_stat_get_checkpoint_sync_time|pg_stat_get_checkpoint_write_time|pg_stat_get_db_blk_read_time|pg_stat_get_db_blk_write_time|pg_stat_get_db_blocks_fetched|pg_stat_get_db_blocks_hit|pg_stat_get_db_conflict_all|pg_stat_get_db_conflict_bufferpin|pg_stat_get_db_conflict_lock|pg_stat_get_db_conflict_snapshot|pg_stat_get_db_conflict_startup_deadlock|pg_stat_get_db_conflict_tablespace|pg_stat_get_db_deadlocks|pg_stat_get_db_numbackends|pg_stat_get_db_stat_reset_time|pg_stat_get_db_temp_bytes|pg_stat_get_db_temp_files|pg_stat_get_db_tuples_deleted|pg_stat_get_db_tuples_fetched|pg_stat_get_db_tuples_inserted|pg_stat_get_db_tuples_returned|pg_stat_get_db_tuples_updated|pg_stat_get_db_xact_commit|pg_stat_get_db_xact_rollback|pg_stat_get_dead_tuples|pg_stat_get_function_calls|pg_stat_get_function_self_time|pg_stat_get_function_total_time|pg_stat_get_last_analyze_time|pg_stat_get_last_autoanalyze_time|pg_stat_get_last_autovacuum_time|pg_stat_get_last_vacuum_time|pg_stat_get_live_tuples|pg_stat_get_numscans|pg_stat_get_tuples_deleted|pg_stat_get_tuples_fetched|pg_stat_get_tuples_hot_updated|pg_stat_get_tuples_inserted|pg_stat_get_tuples_returned|pg_stat_get_tuples_updated|pg_stat_get_vacuum_count|pg_stat_get_wal_senders|pg_stat_get_xact_blocks_fetched|pg_stat_get_xact_blocks_hit|pg_stat_get_xact_function_calls|pg_stat_get_xact_function_self_time|pg_stat_get_xact_function_total_time|pg_stat_get_xact_numscans|pg_stat_get_xact_tuples_deleted|pg_stat_get_xact_tuples_fetched|pg_stat_get_xact_tuples_hot_updated|pg_stat_get_xact_tuples_inserted|pg_stat_get_xact_tuples_returned|pg_stat_get_xact_tuples_updated|pg_stat_reset|pg_stat_reset_shared|pg_stat_reset_single_function_counters|pg_stat_reset_single_table_counters|pg_stop_backup|pg_switch_xlog|pg_table_is_visible|pg_table_size|pg_tablespace_databases|pg_tablespace_location|pg_tablespace_size|pg_terminate_backend|pg_timezone_abbrevs|pg_timezone_names|pg_total_relation_size|pg_trigger_depth|pg_try_advisory_lock|pg_try_advisory_lock_shared|pg_try_advisory_xact_lock|pg_try_advisory_xact_lock_shared|pg_ts_config_is_visible|pg_ts_dict_is_visible|pg_ts_parser_is_visible|pg_ts_template_is_visible|pg_type_is_visible|pg_typeof|pg_xlog_location_diff|pg_xlog_replay_pause|pg_xlog_replay_resume|pg_xlogfile_name|pg_xlogfile_name_offset|pi|plainto_tsquery|plpgsql_call_handler|plpgsql_inline_handler|plpgsql_validator|point|point_above|point_add|point_below|point_distance|point_div|point_eq|point_horiz|point_in|point_left|point_mul|point_ne|point_out|point_recv|point_right|point_send|point_sub|point_vert|poly_above|poly_below|poly_center|poly_contain|poly_contain_pt|poly_contained|poly_distance|poly_in|poly_left|poly_npoints|poly_out|poly_overabove|poly_overbelow|poly_overlap|poly_overleft|poly_overright|poly_recv|poly_right|poly_same|poly_send|polygon|popen|position|positionjoinsel|positionsel|postgresql_fdw_validator|pow|power|prsd_end|prsd_headline|prsd_lextype|prsd_nexttoken|prsd_start|pt_contained_circle|pt_contained_poly|query_to_xml|query_to_xml_and_xmlschema|query_to_xmlschema|querytree|quote_ident|quote_literal|quote_nullable|radians|radius|random|range_adjacent|range_after|range_before|range_cmp|range_contained_by|range_contains|range_contains_elem|range_eq|range_ge|range_gist_compress|range_gist_consistent|range_gist_decompress|range_gist_penalty|range_gist_picksplit|range_gist_same|range_gist_union|range_gt|range_in|range_intersect|range_le|range_lt|range_minus|range_ne|range_out|range_overlaps|range_overleft|range_overright|range_recv|range_send|range_typanalyze|range_union|rangesel|rank|record_eq|record_ge|record_gt|record_in|record_le|record_lt|record_ne|record_out|record_recv|record_send|regclass|regclassin|regclassout|regclassrecv|regclasssend|regconfigin|regconfigout|regconfigrecv|regconfigsend|regdictionaryin|regdictionaryout|regdictionaryrecv|regdictionarysend|regexeqjoinsel|regexeqsel|regexnejoinsel|regexnesel|regexp_matches|regexp_replace|regexp_split_to_array|regexp_split_to_table|regoperatorin|regoperatorout|regoperatorrecv|regoperatorsend|regoperin|regoperout|regoperrecv|regopersend|regprocedurein|regprocedureout|regprocedurerecv|regproceduresend|regprocin|regprocout|regprocrecv|regprocsend|regr_avgx|regr_avgy|regr_count|regr_intercept|regr_r2|regr_slope|regr_sxx|regr_sxy|regr_syy|regtypein|regtypeout|regtyperecv|regtypesend|reltime|reltimeeq|reltimege|reltimegt|reltimein|reltimele|reltimelt|reltimene|reltimeout|reltimerecv|reltimesend|repeat|replace|reverse|right|round|row_number|row_to_json|rpad|rtrim|scalargtjoinsel|scalargtsel|scalarltjoinsel|scalarltsel|schema_to_xml|schema_to_xml_and_xmlschema|schema_to_xmlschema|session_user|set_bit|set_byte|set_config|set_masklen|setseed|setval|setweight|shell_in|shell_out|shift_jis_2004_to_euc_jis_2004|shift_jis_2004_to_utf8|shobj_description|sign|similar_escape|sin|sjis_to_euc_jp|sjis_to_mic|sjis_to_utf8|slope|smgreq|smgrin|smgrne|smgrout|spg_kd_choose|spg_kd_config|spg_kd_inner_consistent|spg_kd_picksplit|spg_quad_choose|spg_quad_config|spg_quad_inner_consistent|spg_quad_leaf_consistent|spg_quad_picksplit|spg_range_quad_choose|spg_range_quad_config|spg_range_quad_inner_consistent|spg_range_quad_leaf_consistent|spg_range_quad_picksplit|spg_text_choose|spg_text_config|spg_text_inner_consistent|spg_text_leaf_consistent|spg_text_picksplit|spgbeginscan|spgbuild|spgbuildempty|spgbulkdelete|spgcanreturn|spgcostestimate|spgendscan|spggetbitmap|spggettuple|spginsert|spgmarkpos|spgoptions|spgrescan|spgrestrpos|spgvacuumcleanup|split_part|sqrt|statement_timestamp|stddev|stddev_pop|stddev_samp|string_agg|string_agg_finalfn|string_agg_transfn|string_to_array|strip|strpos|substr|substring|sum|suppress_redundant_updates_trigger|table_to_xml|table_to_xml_and_xmlschema|table_to_xmlschema|tan|text|text_ge|text_gt|text_larger|text_le|text_lt|text_pattern_ge|text_pattern_gt|text_pattern_le|text_pattern_lt|text_smaller|textanycat|textcat|texteq|texticlike|texticnlike|texticregexeq|texticregexne|textin|textlen|textlike|textne|textnlike|textout|textrecv|textregexeq|textregexne|textsend|thesaurus_init|thesaurus_lexize|tideq|tidge|tidgt|tidin|tidlarger|tidle|tidlt|tidne|tidout|tidrecv|tidsend|tidsmaller|time_cmp|time_eq|time_ge|time_gt|time_hash|time_in|time_larger|time_le|time_lt|time_mi_interval|time_mi_time|time_ne|time_out|time_pl_interval|time_recv|time_send|time_smaller|time_transform|timedate_pl|timemi|timenow|timeofday|timepl|timestamp_cmp|timestamp_cmp_date|timestamp_cmp_timestamptz|timestamp_eq|timestamp_eq_date|timestamp_eq_timestamptz|timestamp_ge|timestamp_ge_date|timestamp_ge_timestamptz|timestamp_gt|timestamp_gt_date|timestamp_gt_timestamptz|timestamp_hash|timestamp_in|timestamp_larger|timestamp_le|timestamp_le_date|timestamp_le_timestamptz|timestamp_lt|timestamp_lt_date|timestamp_lt_timestamptz|timestamp_mi|timestamp_mi_interval|timestamp_ne|timestamp_ne_date|timestamp_ne_timestamptz|timestamp_out|timestamp_pl_interval|timestamp_recv|timestamp_send|timestamp_smaller|timestamp_sortsupport|timestamp_transform|timestamptypmodin|timestamptypmodout|timestamptz_cmp|timestamptz_cmp_date|timestamptz_cmp_timestamp|timestamptz_eq|timestamptz_eq_date|timestamptz_eq_timestamp|timestamptz_ge|timestamptz_ge_date|timestamptz_ge_timestamp|timestamptz_gt|timestamptz_gt_date|timestamptz_gt_timestamp|timestamptz_in|timestamptz_larger|timestamptz_le|timestamptz_le_date|timestamptz_le_timestamp|timestamptz_lt|timestamptz_lt_date|timestamptz_lt_timestamp|timestamptz_mi|timestamptz_mi_interval|timestamptz_ne|timestamptz_ne_date|timestamptz_ne_timestamp|timestamptz_out|timestamptz_pl_interval|timestamptz_recv|timestamptz_send|timestamptz_smaller|timestamptztypmodin|timestamptztypmodout|timetypmodin|timetypmodout|timetz_cmp|timetz_eq|timetz_ge|timetz_gt|timetz_hash|timetz_in|timetz_larger|timetz_le|timetz_lt|timetz_mi_interval|timetz_ne|timetz_out|timetz_pl_interval|timetz_recv|timetz_send|timetz_smaller|timetzdate_pl|timetztypmodin|timetztypmodout|timezone|tinterval|tintervalct|tintervalend|tintervaleq|tintervalge|tintervalgt|tintervalin|tintervalle|tintervalleneq|tintervallenge|tintervallengt|tintervallenle|tintervallenlt|tintervallenne|tintervallt|tintervalne|tintervalout|tintervalov|tintervalrecv|tintervalrel|tintervalsame|tintervalsend|tintervalstart|to_ascii|to_char|to_date|to_hex|to_json|to_number|to_timestamp|to_tsquery|to_tsvector|transaction_timestamp|translate|trigger_in|trigger_out|trunc|ts_debug|ts_headline|ts_lexize|ts_match_qv|ts_match_tq|ts_match_tt|ts_match_vq|ts_parse|ts_rank|ts_rank_cd|ts_rewrite|ts_stat|ts_token_type|ts_typanalyze|tsmatchjoinsel|tsmatchsel|tsq_mcontained|tsq_mcontains|tsquery_and|tsquery_cmp|tsquery_eq|tsquery_ge|tsquery_gt|tsquery_le|tsquery_lt|tsquery_ne|tsquery_not|tsquery_or|tsqueryin|tsqueryout|tsqueryrecv|tsquerysend|tsrange|tsrange_subdiff|tstzrange|tstzrange_subdiff|tsvector_cmp|tsvector_concat|tsvector_eq|tsvector_ge|tsvector_gt|tsvector_le|tsvector_lt|tsvector_ne|tsvector_update_trigger|tsvector_update_trigger_column|tsvectorin|tsvectorout|tsvectorrecv|tsvectorsend|txid_current|txid_current_snapshot|txid_snapshot_in|txid_snapshot_out|txid_snapshot_recv|txid_snapshot_send|txid_snapshot_xip|txid_snapshot_xmax|txid_snapshot_xmin|txid_visible_in_snapshot|uhc_to_utf8|unique_key_recheck|unknownin|unknownout|unknownrecv|unknownsend|unnest|upper|upper_inc|upper_inf|utf8_to_ascii|utf8_to_big5|utf8_to_euc_cn|utf8_to_euc_jis_2004|utf8_to_euc_jp|utf8_to_euc_kr|utf8_to_euc_tw|utf8_to_gb18030|utf8_to_gbk|utf8_to_iso8859|utf8_to_iso8859_1|utf8_to_johab|utf8_to_koi8r|utf8_to_koi8u|utf8_to_shift_jis_2004|utf8_to_sjis|utf8_to_uhc|utf8_to_win|uuid_cmp|uuid_eq|uuid_ge|uuid_gt|uuid_hash|uuid_in|uuid_le|uuid_lt|uuid_ne|uuid_out|uuid_recv|uuid_send|var_pop|var_samp|varbit_in|varbit_out|varbit_recv|varbit_send|varbit_transform|varbitcmp|varbiteq|varbitge|varbitgt|varbitle|varbitlt|varbitne|varbittypmodin|varbittypmodout|varchar_transform|varcharin|varcharout|varcharrecv|varcharsend|varchartypmodin|varchartypmodout|variance|version|void_in|void_out|void_recv|void_send|width|width_bucket|win1250_to_latin2|win1250_to_mic|win1251_to_iso|win1251_to_koi8r|win1251_to_mic|win1251_to_win866|win866_to_iso|win866_to_koi8r|win866_to_mic|win866_to_win1251|win_to_utf8|xideq|xideqint4|xidin|xidout|xidrecv|xidsend|xml|xml_in|xml_is_well_formed|xml_is_well_formed_content|xml_is_well_formed_document|xml_out|xml_recv|xml_send|xmlagg|xmlcomment|xmlconcat2|xmlexists|xmlvalidate|xpath|xpath_exists",n=this.createKeywordMapper({"support.function":t,keyword:e},"identifier",!0),r=[{token:"string",regex:"['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"},{token:"variable.language",regex:'".*?"'},{token:"constant.numeric",regex:"[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"},{token:n,regex:"[a-zA-Z_][a-zA-Z0-9_$]*\\b"},{token:"keyword.operator",regex:"!|!!|!~|!~\\*|!~~|!~~\\*|#|##|#<|#<=|#<>|#=|#>|#>=|%|\\&|\\&\\&|\\&<|\\&<\\||\\&>|\\*|\\+|\\-|/|<|<#>|<\\->|<<|<<=|<<\\||<=|<>|<\\?>|<@|<\\^|=|>|>=|>>|>>=|>\\^|\\?#|\\?\\-|\\?\\-\\||\\?\\||\\?\\|\\||@|@\\-@|@>|@@|@@@|\\^|\\||\\|\\&>|\\|/|\\|>>|\\|\\||\\|\\|/|~|~\\*|~<=~|~<~|~=|~>=~|~>~|~~|~~\\*"},{token:"paren.lparen",regex:"[\\(]"},{token:"paren.rparen",regex:"[\\)]"},{token:"text",regex:"\\s+"}];this.$rules={start:[{token:"comment",regex:"--.*$"},s.getStartRule("doc-start"),{token:"comment",regex:"\\/\\*",next:"comment"},{token:"keyword.statementBegin",regex:"^[a-zA-Z]+",next:"statement"},{token:"support.buildin",regex:"^\\\\[\\S]+.*$"}],statement:[{token:"comment",regex:"--.*$"},{token:"comment",regex:"\\/\\*",next:"commentStatement"},{token:"statementEnd",regex:";",next:"start"},{token:"string",regex:"\\$perl\\$",next:"perl-start"},{token:"string",regex:"\\$python\\$",next:"python-start"},{token:"string",regex:"\\$json\\$",next:"json-start"},{token:"string",regex:"\\$(js|javascript)\\$",next:"javascript-start"},{token:"string",regex:"\\$[\\w_0-9]*\\$$",next:"dollarSql"},{token:"string",regex:"\\$[\\w_0-9]*\\$",next:"dollarStatementString"}].concat(r),dollarSql:[{token:"comment",regex:"--.*$"},{token:"comment",regex:"\\/\\*",next:"commentDollarSql"},{token:"string",regex:"^\\$[\\w_0-9]*\\$",next:"statement"},{token:"string",regex:"\\$[\\w_0-9]*\\$",next:"dollarSqlString"}].concat(r),comment:[{token:"comment",regex:".*?\\*\\/",next:"start"},{token:"comment",regex:".+"}],commentStatement:[{token:"comment",regex:".*?\\*\\/",next:"statement"},{token:"comment",regex:".+"}],commentDollarSql:[{token:"comment",regex:".*?\\*\\/",next:"dollarSql"},{token:"comment",regex:".+"}],dollarStatementString:[{token:"string",regex:".*?\\$[\\w_0-9]*\\$",next:"statement"},{token:"string",regex:".+"}],dollarSqlString:[{token:"string",regex:".*?\\$[\\w_0-9]*\\$",next:"dollarSql"},{token:"string",regex:".+"}]},this.embedRules(s,"doc-",[s.getEndRule("start")]),this.embedRules(u,"perl-",[{token:"string",regex:"\\$perl\\$",next:"statement"}]),this.embedRules(a,"python-",[{token:"string",regex:"\\$python\\$",next:"statement"}]),this.embedRules(f,"json-",[{token:"string",regex:"\\$json\\$",next:"statement"}]),this.embedRules(l,"javascript-",[{token:"string",regex:"\\$(js|javascript)\\$",next:"statement"}])};r.inherits(c,o),t.PgsqlHighlightRules=c}),ace.define("ace/mode/pgsql",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/pgsql_highlight_rules"],function(e,t,n){var r=e("../lib/oop"),i=e("../mode/text").Mode,s=e("./pgsql_highlight_rules").PgsqlHighlightRules,o=function(){this.HighlightRules=s,this.$behaviour=this.$defaultBehaviour};r.inherits(o,i),function(){this.lineCommentStart="--",this.blockComment={start:"/*",end:"*/"},this.getNextLineIndent=function(e,t,n){return e=="start"||e=="keyword.statementEnd"?"":this.$getIndent(t)},this.$id="ace/mode/pgsql"}.call(o.prototype),t.Mode=o})

/***/ }),
/* 1747 */
/***/ (function(module, exports) {

	ace.define("ace/mode/doc_comment_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text_highlight_rules").TextHighlightRules,s=function(){this.$rules={start:[{token:"comment.doc.tag",regex:"@[\\w\\d_]+"},s.getTagRule(),{defaultToken:"comment.doc",caseInsensitive:!0}]}};r.inherits(s,i),s.getTagRule=function(e){return{token:"comment.doc.tag.storage.type",regex:"\\b(?:TODO|FIXME|XXX|HACK)\\b"}},s.getStartRule=function(e){return{token:"comment.doc",regex:"\\/\\*(?=\\*)",next:e}},s.getEndRule=function(e){return{token:"comment.doc",regex:"\\*\\/",next:e}},t.DocCommentHighlightRules=s}),ace.define("ace/mode/sqlserver_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/doc_comment_highlight_rules","ace/mode/text_highlight_rules"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./doc_comment_highlight_rules").DocCommentHighlightRules,s=e("./text_highlight_rules").TextHighlightRules,o=function(){var e="ALL|AND|ANY|BETWEEN|EXISTS|IN|LIKE|NOT|OR|SOME";e+="|NULL|IS|APPLY|INNER|OUTER|LEFT|RIGHT|JOIN|CROSS";var t="OPENDATASOURCE|OPENQUERY|OPENROWSET|OPENXML|AVG|CHECKSUM_AGG|COUNT|COUNT_BIG|GROUPING|GROUPING_ID|MAX|MIN|STDEV|STDEVP|SUM|VAR|VARP|DENSE_RANK|NTILE|RANK|ROW_NUMBER@@DATEFIRST|@@DBTS|@@LANGID|@@LANGUAGE|@@LOCK_TIMEOUT|@@MAX_CONNECTIONS|@@MAX_PRECISION|@@NESTLEVEL|@@OPTIONS|@@REMSERVER|@@SERVERNAME|@@SERVICENAME|@@SPID|@@TEXTSIZE|@@VERSION|CAST|CONVERT|PARSE|TRY_CAST|TRY_CONVERT|TRY_PARSE@@CURSOR_ROWS|@@FETCH_STATUS|CURSOR_STATUS|@@DATEFIRST|@@LANGUAGE|CURRENT_TIMESTAMP|DATEADD|DATEDIFF|DATEFROMPARTS|DATENAME|DATEPART|DATETIME2FROMPARTS|DATETIMEFROMPARTS|DATETIMEOFFSETFROMPARTS|DAY|EOMONTH|GETDATE|GETUTCDATE|ISDATE|MONTH|SET DATEFIRST|SET DATEFORMAT|SET LANGUAGE|SMALLDATETIMEFROMPARTS|SP_HELPLANGUAGE|SWITCHOFFSET|SYSDATETIME|SYSDATETIMEOFFSET|SYSUTCDATETIME|TIMEFROMPARTS|TODATETIMEOFFSET|YEAR|CHOOSE|IIF|ABS|ACOS|ASIN|ATAN|ATN2|CEILING|COS|COT|DEGREES|EXP|FLOOR|LOG|LOG10|PI|POWER|RADIANS|RAND|ROUND|SIGN|SIN|SQRT|SQUARE|TAN|@@PROCID|APPLOCK_MODE|APPLOCK_TEST|APP_NAME|ASSEMBLYPROPERTY|COLUMNPROPERTY|COL_LENGTH|COL_NAME|DATABASEPROPERTYEX|DATABASE_PRINCIPAL_ID|DB_ID|DB_NAME|FILEGROUPPROPERTY|FILEGROUP_ID|FILEGROUP_NAME|FILEPROPERTY|FILE_ID|FILE_IDEX|FILE_NAME|FULLTEXTCATALOGPROPERTY|FULLTEXTSERVICEPROPERTY|INDEXKEY_PROPERTY|INDEXPROPERTY|INDEX_COL|OBJECTPROPERTY|OBJECTPROPERTYEX|OBJECT_DEFINITION|OBJECT_ID|OBJECT_NAME|OBJECT_SCHEMA_NAME|ORIGINAL_DB_NAME|PARSENAME|SCHEMA_ID|SCHEMA_NAME|SCOPE_IDENTITY|SERVERPROPERTY|STATS_DATE|TYPEPROPERTY|TYPE_ID|TYPE_NAME|CERTENCODED|CERTPRIVATEKEY|CURRENT_USER|DATABASE_PRINCIPAL_ID|HAS_PERMS_BY_NAME|IS_MEMBER|IS_ROLEMEMBER|IS_SRVROLEMEMBER|ORIGINAL_LOGIN|PERMISSIONS|PWDCOMPARE|PWDENCRYPT|SCHEMA_ID|SCHEMA_NAME|SESSION_USER|SUSER_ID|SUSER_NAME|SUSER_SID|SUSER_SNAME|SYS.FN_BUILTIN_PERMISSIONS|SYS.FN_GET_AUDIT_FILE|SYS.FN_MY_PERMISSIONS|SYSTEM_USER|USER_ID|USER_NAME|ASCII|CHAR|CHARINDEX|CONCAT|DIFFERENCE|FORMAT|LEN|LOWER|LTRIM|NCHAR|PATINDEX|QUOTENAME|REPLACE|REPLICATE|REVERSE|RTRIM|SOUNDEX|SPACE|STR|STUFF|SUBSTRING|UNICODE|UPPER|$PARTITION|@@ERROR|@@IDENTITY|@@PACK_RECEIVED|@@ROWCOUNT|@@TRANCOUNT|BINARY_CHECKSUM|CHECKSUM|CONNECTIONPROPERTY|CONTEXT_INFO|CURRENT_REQUEST_ID|ERROR_LINE|ERROR_MESSAGE|ERROR_NUMBER|ERROR_PROCEDURE|ERROR_SEVERITY|ERROR_STATE|FORMATMESSAGE|GETANSINULL|GET_FILESTREAM_TRANSACTION_CONTEXT|HOST_ID|HOST_NAME|ISNULL|ISNUMERIC|MIN_ACTIVE_ROWVERSION|NEWID|NEWSEQUENTIALID|ROWCOUNT_BIG|XACT_STATE|@@CONNECTIONS|@@CPU_BUSY|@@IDLE|@@IO_BUSY|@@PACKET_ERRORS|@@PACK_RECEIVED|@@PACK_SENT|@@TIMETICKS|@@TOTAL_ERRORS|@@TOTAL_READ|@@TOTAL_WRITE|FN_VIRTUALFILESTATS|PATINDEX|TEXTPTR|TEXTVALID|COALESCE|NULLIF",n="BIGINT|BINARY|BIT|CHAR|CURSOR|DATE|DATETIME|DATETIME2|DATETIMEOFFSET|DECIMAL|FLOAT|HIERARCHYID|IMAGE|INTEGER|INT|MONEY|NCHAR|NTEXT|NUMERIC|NVARCHAR|REAL|SMALLDATETIME|SMALLINT|SMALLMONEY|SQL_VARIANT|TABLE|TEXT|TIME|TIMESTAMP|TINYINT|UNIQUEIDENTIFIER|VARBINARY|VARCHAR|XML",r="sp_addextendedproc|sp_addextendedproperty|sp_addmessage|sp_addtype|sp_addumpdevice|sp_add_data_file_recover_suspect_db|sp_add_log_file_recover_suspect_db|sp_altermessage|sp_attach_db|sp_attach_single_file_db|sp_autostats|sp_bindefault|sp_bindrule|sp_bindsession|sp_certify_removable|sp_clean_db_file_free_space|sp_clean_db_free_space|sp_configure|sp_control_plan_guide|sp_createstats|sp_create_plan_guide|sp_create_plan_guide_from_handle|sp_create_removable|sp_cycle_errorlog|sp_datatype_info|sp_dbcmptlevel|sp_dbmmonitoraddmonitoring|sp_dbmmonitorchangealert|sp_dbmmonitorchangemonitoring|sp_dbmmonitordropalert|sp_dbmmonitordropmonitoring|sp_dbmmonitorhelpalert|sp_dbmmonitorhelpmonitoring|sp_dbmmonitorresults|sp_db_increased_partitions|sp_delete_backuphistory|sp_depends|sp_describe_first_result_set|sp_describe_undeclared_parameters|sp_detach_db|sp_dropdevice|sp_dropextendedproc|sp_dropextendedproperty|sp_dropmessage|sp_droptype|sp_execute|sp_executesql|sp_getapplock|sp_getbindtoken|sp_help|sp_helpconstraint|sp_helpdb|sp_helpdevice|sp_helpextendedproc|sp_helpfile|sp_helpfilegroup|sp_helpindex|sp_helplanguage|sp_helpserver|sp_helpsort|sp_helpstats|sp_helptext|sp_helptrigger|sp_indexoption|sp_invalidate_textptr|sp_lock|sp_monitor|sp_prepare|sp_prepexec|sp_prepexecrpc|sp_procoption|sp_recompile|sp_refreshview|sp_releaseapplock|sp_rename|sp_renamedb|sp_resetstatus|sp_sequence_get_range|sp_serveroption|sp_setnetname|sp_settriggerorder|sp_spaceused|sp_tableoption|sp_unbindefault|sp_unbindrule|sp_unprepare|sp_updateextendedproperty|sp_updatestats|sp_validname|sp_who|sys.sp_merge_xtp_checkpoint_files|sys.sp_xtp_bind_db_resource_pool|sys.sp_xtp_checkpoint_force_garbage_collection|sys.sp_xtp_control_proc_exec_stats|sys.sp_xtp_control_query_exec_stats|sys.sp_xtp_unbind_db_resource_pool",s="ABSOLUTE|ACTION|ADA|ADD|ADMIN|AFTER|AGGREGATE|ALIAS|ALL|ALLOCATE|ALTER|AND|ANY|ARE|ARRAY|AS|ASC|ASENSITIVE|ASSERTION|ASYMMETRIC|AT|ATOMIC|AUTHORIZATION|BACKUP|BEFORE|BEGIN|BETWEEN|BIT_LENGTH|BLOB|BOOLEAN|BOTH|BREADTH|BREAK|BROWSE|BULK|BY|CALL|CALLED|CARDINALITY|CASCADE|CASCADED|CASE|CATALOG|CHARACTER|CHARACTER_LENGTH|CHAR_LENGTH|CHECK|CHECKPOINT|CLASS|CLOB|CLOSE|CLUSTERED|COALESCE|COLLATE|COLLATION|COLLECT|COLUMN|COMMIT|COMPLETION|COMPUTE|CONDITION|CONNECT|CONNECTION|CONSTRAINT|CONSTRAINTS|CONSTRUCTOR|CONTAINS|CONTAINSTABLE|CONTINUE|CORR|CORRESPONDING|COVAR_POP|COVAR_SAMP|CREATE|CROSS|CUBE|CUME_DIST|CURRENT|CURRENT_CATALOG|CURRENT_DATE|CURRENT_DEFAULT_TRANSFORM_GROUP|CURRENT_PATH|CURRENT_ROLE|CURRENT_SCHEMA|CURRENT_TIME|CURRENT_TRANSFORM_GROUP_FOR_TYPE|CYCLE|DATA|DATABASE|DBCC|DEALLOCATE|DEC|DECLARE|DEFAULT|DEFERRABLE|DEFERRED|DELETE|DENY|DEPTH|DEREF|DESC|DESCRIBE|DESCRIPTOR|DESTROY|DESTRUCTOR|DETERMINISTIC|DIAGNOSTICS|DICTIONARY|DISCONNECT|DISK|DISTINCT|DISTRIBUTED|DOMAIN|DOUBLE|DROP|DUMP|DYNAMIC|EACH|ELEMENT|ELSE|END|END-EXEC|EQUALS|ERRLVL|ESCAPE|EVERY|EXCEPT|EXCEPTION|EXEC|EXECUTE|EXISTS|EXIT|EXTERNAL|EXTRACT|FETCH|FILE|FILLFACTOR|FILTER|FIRST|FOR|FOREIGN|FORTRAN|FOUND|FREE|FREETEXT|FREETEXTTABLE|FROM|FULL|FULLTEXTTABLE|FUNCTION|FUSION|GENERAL|GET|GLOBAL|GO|GOTO|GRANT|GROUP|HAVING|HOLD|HOLDLOCK|HOST|HOUR|IDENTITY|IDENTITYCOL|IDENTITY_INSERT|IF|IGNORE|IMMEDIATE|IN|INCLUDE|INDEX|INDICATOR|INITIALIZE|INITIALLY|INNER|INOUT|INPUT|INSENSITIVE|INSERT|INTEGER|INTERSECT|INTERSECTION|INTERVAL|INTO|IS|ISOLATION|ITERATE|JOIN|KEY|KILL|LANGUAGE|LARGE|LAST|LATERAL|LEADING|LESS|LEVEL|LIKE|LIKE_REGEX|LIMIT|LINENO|LN|LOAD|LOCAL|LOCALTIME|LOCALTIMESTAMP|LOCATOR|MAP|MATCH|MEMBER|MERGE|METHOD|MINUTE|MOD|MODIFIES|MODIFY|MODULE|MULTISET|NAMES|NATIONAL|NATURAL|NCLOB|NEW|NEXT|NO|NOCHECK|NONCLUSTERED|NONE|NORMALIZE|NOT|NULL|NULLIF|OBJECT|OCCURRENCES_REGEX|OCTET_LENGTH|OF|OFF|OFFSETS|OLD|ON|ONLY|OPEN|OPERATION|OPTION|OR|ORDER|ORDINALITY|OUT|OUTER|OUTPUT|OVER|OVERLAPS|OVERLAY|PAD|PARAMETER|PARAMETERS|PARTIAL|PARTITION|PASCAL|PATH|PERCENT|PERCENTILE_CONT|PERCENTILE_DISC|PERCENT_RANK|PIVOT|PLAN|POSITION|POSITION_REGEX|POSTFIX|PRECISION|PREFIX|PREORDER|PREPARE|PRESERVE|PRIMARY|PRINT|PRIOR|PRIVILEGES|PROC|PROCEDURE|PUBLIC|RAISERROR|RANGE|READ|READS|READTEXT|RECONFIGURE|RECURSIVE|REF|REFERENCES|REFERENCING|REGR_AVGX|REGR_AVGY|REGR_COUNT|REGR_INTERCEPT|REGR_R2|REGR_SLOPE|REGR_SXX|REGR_SXY|REGR_SYY|RELATIVE|RELEASE|REPLICATION|RESTORE|RESTRICT|RESULT|RETURN|RETURNS|REVERT|REVOKE|ROLE|ROLLBACK|ROLLUP|ROUTINE|ROW|ROWCOUNT|ROWGUIDCOL|ROWS|RULE|SAVE|SAVEPOINT|SCHEMA|SCOPE|SCROLL|SEARCH|SECOND|SECTION|SECURITYAUDIT|SELECT|SEMANTICKEYPHRASETABLE|SEMANTICSIMILARITYDETAILSTABLE|SEMANTICSIMILARITYTABLE|SENSITIVE|SEQUENCE|SESSION|SET|SETS|SETUSER|SHUTDOWN|SIMILAR|SIZE|SOME|SPECIFIC|SPECIFICTYPE|SQL|SQLCA|SQLCODE|SQLERROR|SQLEXCEPTION|SQLSTATE|SQLWARNING|START|STATE|STATEMENT|STATIC|STATISTICS|STDDEV_POP|STDDEV_SAMP|STRUCTURE|SUBMULTISET|SUBSTRING_REGEX|SYMMETRIC|SYSTEM|TABLESAMPLE|TEMPORARY|TERMINATE|TEXTSIZE|THAN|THEN|TIMEZONE_HOUR|TIMEZONE_MINUTE|TO|TOP|TRAILING|TRAN|TRANSACTION|TRANSLATE|TRANSLATE_REGEX|TRANSLATION|TREAT|TRIGGER|TRIM|TRUNCATE|TSEQUAL|UESCAPE|UNDER|UNION|UNIQUE|UNKNOWN|UNNEST|UNPIVOT|UPDATE|UPDATETEXT|USAGE|USE|USER|USING|VALUE|VALUES|VARIABLE|VARYING|VAR_POP|VAR_SAMP|VIEW|WAITFOR|WHEN|WHENEVER|WHERE|WHILE|WIDTH_BUCKET|WINDOW|WITH|WITHIN|WITHIN GROUP|WITHOUT|WORK|WRITE|WRITETEXT|XMLAGG|XMLATTRIBUTES|XMLBINARY|XMLCAST|XMLCOMMENT|XMLCONCAT|XMLDOCUMENT|XMLELEMENT|XMLEXISTS|XMLFOREST|XMLITERATE|XMLNAMESPACES|XMLPARSE|XMLPI|XMLQUERY|XMLSERIALIZE|XMLTABLE|XMLTEXT|XMLVALIDATE|ZONE";s+="|KEEPIDENTITY|KEEPDEFAULTS|IGNORE_CONSTRAINTS|IGNORE_TRIGGERS|XLOCK|FORCESCAN|FORCESEEK|HOLDLOCK|NOLOCK|NOWAIT|PAGLOCK|READCOMMITTED|READCOMMITTEDLOCK|READPAST|READUNCOMMITTED|REPEATABLEREAD|ROWLOCK|SERIALIZABLE|SNAPSHOT|SPATIAL_WINDOW_MAX_CELLS|TABLOCK|TABLOCKX|UPDLOCK|XLOCK|IGNORE_NONCLUSTERED_COLUMNSTORE_INDEX|EXPAND|VIEWS|FAST|FORCE|KEEP|KEEPFIXED|MAXDOP|MAXRECURSION|OPTIMIZE|PARAMETERIZATION|SIMPLE|FORCED|RECOMPILE|ROBUST|PLAN|SPATIAL_WINDOW_MAX_CELLS|NOEXPAND|HINT",s+="|LOOP|HASH|MERGE|REMOTE",s+="|TRY|CATCH|THROW",s+="|TYPE",s=s.split("|"),s=s.filter(function(r,i,s){return e.split("|").indexOf(r)===-1&&t.split("|").indexOf(r)===-1&&n.split("|").indexOf(r)===-1}),s=s.sort().join("|");var o=this.createKeywordMapper({"constant.language":e,"storage.type":n,"support.function":t,"support.storedprocedure":r,keyword:s},"identifier",!0),u="SET ANSI_DEFAULTS|SET ANSI_NULLS|SET ANSI_NULL_DFLT_OFF|SET ANSI_NULL_DFLT_ON|SET ANSI_PADDING|SET ANSI_WARNINGS|SET ARITHABORT|SET ARITHIGNORE|SET CONCAT_NULL_YIELDS_NULL|SET CURSOR_CLOSE_ON_COMMIT|SET DATEFIRST|SET DATEFORMAT|SET DEADLOCK_PRIORITY|SET FIPS_FLAGGER|SET FMTONLY|SET FORCEPLAN|SET IDENTITY_INSERT|SET IMPLICIT_TRANSACTIONS|SET LANGUAGE|SET LOCK_TIMEOUT|SET NOCOUNT|SET NOEXEC|SET NUMERIC_ROUNDABORT|SET OFFSETS|SET PARSEONLY|SET QUERY_GOVERNOR_COST_LIMIT|SET QUOTED_IDENTIFIER|SET REMOTE_PROC_TRANSACTIONS|SET ROWCOUNT|SET SHOWPLAN_ALL|SET SHOWPLAN_TEXT|SET SHOWPLAN_XML|SET STATISTICS IO|SET STATISTICS PROFILE|SET STATISTICS TIME|SET STATISTICS XML|SET TEXTSIZE|SET XACT_ABORT".split("|"),a="READ UNCOMMITTED|READ COMMITTED|REPEATABLE READ|SNAPSHOP|SERIALIZABLE".split("|");for(var f=0;f<a.length;f++)u.push("SET TRANSACTION ISOLATION LEVEL "+a[f]);this.$rules={start:[{token:"string.start",regex:"'",next:[{token:"constant.language.escape",regex:/''/},{token:"string.end",next:"start",regex:"'"},{defaultToken:"string"}]},i.getStartRule("doc-start"),{token:"comment",regex:"--.*$"},{token:"comment",start:"/\\*",end:"\\*/"},{token:"constant.numeric",regex:"[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"},{token:o,regex:"@{0,2}[a-zA-Z_$][a-zA-Z0-9_$]*\\b(?!])"},{token:"constant.class",regex:"@@?[a-zA-Z_$][a-zA-Z0-9_$]*\\b"},{token:"keyword.operator",regex:"\\+|\\-|\\/|\\/\\/|%|<@>|@>|<@|&|\\^|~|<|>|<=|=>|==|!=|<>|=|\\*"},{token:"paren.lparen",regex:"[\\(]"},{token:"paren.rparen",regex:"[\\)]"},{token:"punctuation",regex:",|;"},{token:"text",regex:"\\s+"}],comment:[i.getTagRule(),{token:"comment",regex:"\\*\\/",next:"no_regex"},{defaultToken:"comment",caseInsensitive:!0}]};for(var f=0;f<u.length;f++)this.$rules.start.unshift({token:"set.statement",regex:u[f]});this.embedRules(i,"doc-",[i.getEndRule("start")]),this.normalizeRules();var l=[],c=function(e,t){e.forEach(function(e){l.push({name:e,value:e,score:0,meta:t})})};c(r.split("|"),"procedure"),c(e.split("|"),"operator"),c(t.split("|"),"function"),c(n.split("|"),"type"),c(u,"statement"),c(s.split("|"),"keyword"),this.completions=l};r.inherits(o,s),t.SqlHighlightRules=o}),ace.define("ace/mode/folding/cstyle",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/fold_mode"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("../../range").Range,s=e("./fold_mode").FoldMode,o=t.FoldMode=function(e){e&&(this.foldingStartMarker=new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/,"|"+e.start)),this.foldingStopMarker=new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/,"|"+e.end)))};r.inherits(o,s),function(){this.foldingStartMarker=/(\{|\[)[^\}\]]*$|^\s*(\/\*)/,this.foldingStopMarker=/^[^\[\{]*(\}|\])|^[\s\*]*(\*\/)/,this.singleLineBlockCommentRe=/^\s*(\/\*).*\*\/\s*$/,this.tripleStarBlockCommentRe=/^\s*(\/\*\*\*).*\*\/\s*$/,this.startRegionRe=/^\s*(\/\*|\/\/)#?region\b/,this._getFoldWidgetBase=this.getFoldWidget,this.getFoldWidget=function(e,t,n){var r=e.getLine(n);if(this.singleLineBlockCommentRe.test(r)&&!this.startRegionRe.test(r)&&!this.tripleStarBlockCommentRe.test(r))return"";var i=this._getFoldWidgetBase(e,t,n);return!i&&this.startRegionRe.test(r)?"start":i},this.getFoldWidgetRange=function(e,t,n,r){var i=e.getLine(n);if(this.startRegionRe.test(i))return this.getCommentRegionBlock(e,i,n);var s=i.match(this.foldingStartMarker);if(s){var o=s.index;if(s[1])return this.openingBracketBlock(e,s[1],n,o);var u=e.getCommentFoldRange(n,o+s[0].length,1);return u&&!u.isMultiLine()&&(r?u=this.getSectionRange(e,n):t!="all"&&(u=null)),u}if(t==="markbegin")return;var s=i.match(this.foldingStopMarker);if(s){var o=s.index+s[0].length;return s[1]?this.closingBracketBlock(e,s[1],n,o):e.getCommentFoldRange(n,o,-1)}},this.getSectionRange=function(e,t){var n=e.getLine(t),r=n.search(/\S/),s=t,o=n.length;t+=1;var u=t,a=e.getLength();while(++t<a){n=e.getLine(t);var f=n.search(/\S/);if(f===-1)continue;if(r>f)break;var l=this.getFoldWidgetRange(e,"all",t);if(l){if(l.start.row<=s)break;if(l.isMultiLine())t=l.end.row;else if(r==f)break}u=t}return new i(s,o,u,e.getLine(u).length)},this.getCommentRegionBlock=function(e,t,n){var r=t.search(/\s*$/),s=e.getLength(),o=n,u=/^\s*(?:\/\*|\/\/|--)#?(end)?region\b/,a=1;while(++n<s){t=e.getLine(n);var f=u.exec(t);if(!f)continue;f[1]?a--:a++;if(!a)break}var l=n;if(l>o)return new i(o,r,l,t.length)}}.call(o.prototype)}),ace.define("ace/mode/folding/sqlserver",["require","exports","module","ace/lib/oop","ace/range","ace/mode/folding/cstyle"],function(e,t,n){"use strict";var r=e("../../lib/oop"),i=e("../../range").Range,s=e("./cstyle").FoldMode,o=t.FoldMode=function(){};r.inherits(o,s),function(){this.foldingStartMarker=/(\bCASE\b|\bBEGIN\b)|^\s*(\/\*)/i,this.startRegionRe=/^\s*(\/\*|--)#?region\b/,this.getFoldWidgetRange=function(e,t,n,r){var i=e.getLine(n);if(this.startRegionRe.test(i))return this.getCommentRegionBlock(e,i,n);var s=i.match(this.foldingStartMarker);if(s){var o=s.index;if(s[1])return this.getBeginEndBlock(e,n,o,s[1]);var u=e.getCommentFoldRange(n,o+s[0].length,1);return u&&!u.isMultiLine()&&(r?u=this.getSectionRange(e,n):t!="all"&&(u=null)),u}if(t==="markbegin")return;return},this.getBeginEndBlock=function(e,t,n,r){var s={row:t,column:n+r.length},o=e.getLength(),u,a=1,f=/(\bCASE\b|\bBEGIN\b)|(\bEND\b)/i;while(++t<o){u=e.getLine(t);var l=f.exec(u);if(!l)continue;l[1]?a++:a--;if(!a)break}var c=t;if(c>s.row)return new i(s.row,s.column,c,u.length)}}.call(o.prototype)}),ace.define("ace/mode/sqlserver",["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/sqlserver_highlight_rules","ace/mode/folding/sqlserver"],function(e,t,n){"use strict";var r=e("../lib/oop"),i=e("./text").Mode,s=e("./sqlserver_highlight_rules").SqlHighlightRules,o=e("./folding/sqlserver").FoldMode,u=function(){this.HighlightRules=s,this.foldingRules=new o,this.$behaviour=this.$defaultBehaviour};r.inherits(u,i),function(){this.lineCommentStart="--",this.blockComment={start:"/*",end:"*/"},this.getCompletions=function(e,t,n,r){return t.$mode.$highlightRules.completions},this.$id="ace/mode/sql"}.call(u.prototype),t.Mode=u})

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

	ace.define("ace/snippets/sql",["require","exports","module"],function(e,t,n){"use strict";t.snippetText="snippet tbl\n	create table ${1:table} (\n		${2:columns}\n	);\nsnippet col\n	${1:name}	${2:type}	${3:default ''}	${4:not null}\nsnippet ccol\n	${1:name}	varchar2(${2:size})	${3:default ''}	${4:not null}\nsnippet ncol\n	${1:name}	number	${3:default 0}	${4:not null}\nsnippet dcol\n	${1:name}	date	${3:default sysdate}	${4:not null}\nsnippet ind\n	create index ${3:$1_$2} on ${1:table}(${2:column});\nsnippet uind\n	create unique index ${1:name} on ${2:table}(${3:column});\nsnippet tblcom\n	comment on table ${1:table} is '${2:comment}';\nsnippet colcom\n	comment on column ${1:table}.${2:column} is '${3:comment}';\nsnippet addcol\n	alter table ${1:table} add (${2:column} ${3:type});\nsnippet seq\n	create sequence ${1:name} start with ${2:1} increment by ${3:1} minvalue ${4:1};\nsnippet s*\n	select * from ${1:table}\n",t.scope="sql"})

/***/ }),
/* 1749 */
/***/ (function(module, exports) {

	ace.define("ace/snippets/mysql",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="mysql"})

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

	ace.define("ace/snippets/pgsql",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="pgsql"})

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

	ace.define("ace/snippets/sqlserver",["require","exports","module"],function(e,t,n){"use strict";t.snippetText="# ISNULL\nsnippet isnull\n	ISNULL(${1:check_expression}, ${2:replacement_value})\n# FORMAT\nsnippet format\n	FORMAT(${1:value}, ${2:format})\n# CAST\nsnippet cast\n	CAST(${1:expression} AS ${2:data_type})\n# CONVERT\nsnippet convert\n	CONVERT(${1:data_type}, ${2:expression})\n# DATEPART\nsnippet datepart\n	DATEPART(${1:datepart}, ${2:date})\n# DATEDIFF\nsnippet datediff\n	DATEDIFF(${1:datepart}, ${2:startdate}, ${3:enddate})\n# DATEADD\nsnippet dateadd\n	DATEADD(${1:datepart}, ${2:number}, ${3:date})\n# DATEFROMPARTS \nsnippet datefromparts\n	DATEFROMPARTS(${1:year}, ${2:month}, ${3:day})\n# OBJECT_DEFINITION\nsnippet objectdef\n	SELECT OBJECT_DEFINITION(OBJECT_ID('${1:sys.server_permissions /*object name*/}'))\n# STUFF XML\nsnippet stuffxml\n	STUFF((SELECT ', ' + ${1:ColumnName}\n		FROM ${2:TableName}\n		WHERE ${3:WhereClause}\n		FOR XML PATH('')), 1, 1, '') AS ${4:Alias}\n	${5:/*https://msdn.microsoft.com/en-us/library/ms188043.aspx*/}\n# Create Procedure\nsnippet createproc\n	-- =============================================\n	-- Author:		${1:Author}\n	-- Create date: ${2:Date}\n	-- Description:	${3:Description}\n	-- =============================================\n	CREATE PROCEDURE ${4:Procedure_Name}\n		${5:/*Add the parameters for the stored procedure here*/}\n	AS\n	BEGIN\n		-- SET NOCOUNT ON added to prevent extra result sets from interfering with SELECT statements.\n		SET NOCOUNT ON;\n		\n		${6:/*Add the T-SQL statements to compute the return value here*/}\n		\n	END\n	GO\n# Create Scalar Function\nsnippet createfn\n	-- =============================================\n	-- Author:		${1:Author}\n	-- Create date: ${2:Date}\n	-- Description:	${3:Description}\n	-- =============================================\n	CREATE FUNCTION ${4:Scalar_Function_Name}\n		-- Add the parameters for the function here\n	RETURNS ${5:Function_Data_Type}\n	AS\n	BEGIN\n		DECLARE @Result ${5:Function_Data_Type}\n		\n		${6:/*Add the T-SQL statements to compute the return value here*/}\n		\n	END\n	GO",t.scope="sqlserver"})

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

	ace.define("ace/snippets/json",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="json"})

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

	"use strict";
	
	/*global ace*/
	/* eslint "no-redeclare": 0 */
	/* eslint "import/no-commonjs": 0 */
	
	// Modified from https://github.com/ajaxorg/ace/blob/b8804b1e9db1f7f02337ca884f4780f3579cc41b/lib/ace/mode/behaviour/cstyle.js
	
	/* ***** BEGIN LICENSE BLOCK *****
	 * Distributed under the BSD license:
	 *
	 * Copyright (c) 2010, Ajax.org B.V.
	 * All rights reserved.
	 *
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are met:
	 *     * Redistributions of source code must retain the above copyright
	 *       notice, this list of conditions and the following disclaimer.
	 *     * Redistributions in binary form must reproduce the above copyright
	 *       notice, this list of conditions and the following disclaimer in the
	 *       documentation and/or other materials provided with the distribution.
	 *     * Neither the name of Ajax.org B.V. nor the
	 *       names of its contributors may be used to endorse or promote products
	 *       derived from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
	 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
	 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
	 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
	 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
	 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
	 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
	 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 *
	 * ***** END LICENSE BLOCK ***** */
	
	ace.require(["ace/lib/oop", "ace/mode/behaviour", "ace/token_iterator", "ace/lib/lang"], function (oop, _ref, _ref2, lang) {
	    var Behaviour = _ref.Behaviour;
	    var TokenIterator = _ref2.TokenIterator;
	
	
	    var SAFE_INSERT_IN_TOKENS = ["text", "paren.rparen", "punctuation.operator"];
	    var SAFE_INSERT_BEFORE_TOKENS = ["text", "paren.rparen", "punctuation.operator", "comment"];
	
	    var context;
	    var contextCache = {};
	    var initContext = function initContext(editor) {
	        var id = -1;
	        if (editor.multiSelect) {
	            id = editor.selection.index;
	            if (contextCache.rangeCount != editor.multiSelect.rangeCount) contextCache = { rangeCount: editor.multiSelect.rangeCount };
	        }
	        if (contextCache[id]) return context = contextCache[id];
	        context = contextCache[id] = {
	            autoInsertedBrackets: 0,
	            autoInsertedRow: -1,
	            autoInsertedLineEnd: "",
	            maybeInsertedBrackets: 0,
	            maybeInsertedRow: -1,
	            maybeInsertedLineStart: "",
	            maybeInsertedLineEnd: ""
	        };
	    };
	
	    var getWrapped = function getWrapped(selection, selected, opening, closing) {
	        var rowDiff = selection.end.row - selection.start.row;
	        return {
	            text: opening + selected + closing,
	            selection: [0, selection.start.column + 1, rowDiff, selection.end.column + (rowDiff ? 0 : 1)]
	        };
	    };
	
	    var SQLBehaviour = function SQLBehaviour() {
	        function createInsertDeletePair(name, opening, closing) {
	            this.add(name, "insertion", function (state, action, editor, session, text) {
	                if (text == opening) {
	                    initContext(editor);
	                    var selection = editor.getSelectionRange();
	                    var selected = session.doc.getTextRange(selection);
	                    if (selected !== "" && editor.getWrapBehavioursEnabled()) {
	                        return getWrapped(selection, selected, opening, closing);
	                    } else if (SQLBehaviour.isSaneInsertion(editor, session)) {
	                        SQLBehaviour.recordAutoInsert(editor, session, closing);
	                        return {
	                            text: opening + closing,
	                            selection: [1, 1]
	                        };
	                    }
	                } else if (text == closing) {
	                    initContext(editor);
	                    var cursor = editor.getCursorPosition();
	                    var line = session.doc.getLine(cursor.row);
	                    var rightChar = line.substring(cursor.column, cursor.column + 1);
	                    if (rightChar == closing) {
	                        var matching = session.$findOpeningBracket(closing, { column: cursor.column + 1, row: cursor.row });
	                        if (matching !== null && SQLBehaviour.isAutoInsertedClosing(cursor, line, text)) {
	                            SQLBehaviour.popAutoInsertedClosing();
	                            return {
	                                text: '',
	                                selection: [1, 1]
	                            };
	                        }
	                    }
	                }
	            });
	
	            this.add(name, "deletion", function (state, action, editor, session, range) {
	                var selected = session.doc.getTextRange(range);
	                if (!range.isMultiLine() && selected == opening) {
	                    initContext(editor);
	                    var line = session.doc.getLine(range.start.row);
	                    var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
	                    if (rightChar == closing) {
	                        range.end.column++;
	                        return range;
	                    }
	                }
	            });
	        }
	
	        createInsertDeletePair.call(this, "braces", "{", "}");
	        createInsertDeletePair.call(this, "parens", "(", ")");
	        createInsertDeletePair.call(this, "brackets", "[", "]");
	
	        this.add("string_dquotes", "insertion", function (state, action, editor, session, text) {
	            if (text == '"' || text == "'") {
	                if (this.lineCommentStart && this.lineCommentStart.indexOf(text) != -1) return;
	                initContext(editor);
	                var quote = text;
	                var selection = editor.getSelectionRange();
	                var selected = session.doc.getTextRange(selection);
	                if (selected !== "" && selected !== "'" && selected != '"' && editor.getWrapBehavioursEnabled()) {
	                    return getWrapped(selection, selected, quote, quote);
	                } else if (!selected) {
	                    var cursor = editor.getCursorPosition();
	                    var line = session.doc.getLine(cursor.row);
	                    var leftChar = line.substring(cursor.column - 1, cursor.column);
	                    var rightChar = line.substring(cursor.column, cursor.column + 1);
	
	                    var token = session.getTokenAt(cursor.row, cursor.column);
	                    var rightToken = session.getTokenAt(cursor.row, cursor.column + 1);
	                    // We're escaped.
	                    if (leftChar == "\\" && token && /escape/.test(token.type)) return null;
	
	                    var stringBefore = token && /string|escape/.test(token.type);
	                    var stringAfter = !rightToken || /string|escape/.test(rightToken.type);
	
	                    var pair;
	                    if (rightChar == quote) {
	                        pair = stringBefore !== stringAfter;
	                        if (pair && /string\.end/.test(rightToken.type)) pair = false;
	                    } else {
	                        if (stringBefore && !stringAfter) return null; // wrap string with different quote
	                        if (stringBefore && stringAfter) return null; // do not pair quotes inside strings
	                        var wordRe = session.$mode.tokenRe;
	                        wordRe.lastIndex = 0;
	                        var isWordBefore = wordRe.test(leftChar);
	                        wordRe.lastIndex = 0;
	                        var isWordAfter = wordRe.test(leftChar);
	                        if (isWordBefore || isWordAfter) return null; // before or after alphanumeric
	                        if (rightChar && !/[\s;,.})\]\\]/.test(rightChar)) return null; // there is rightChar and it isn't closing
	                        pair = true;
	                    }
	                    return {
	                        text: pair ? quote + quote : "",
	                        selection: [1, 1]
	                    };
	                }
	            }
	        });
	
	        this.add("string_dquotes", "deletion", function (state, action, editor, session, range) {
	            var selected = session.doc.getTextRange(range);
	            if (!range.isMultiLine() && (selected == '"' || selected == "'")) {
	                initContext(editor);
	                var line = session.doc.getLine(range.start.row);
	                var rightChar = line.substring(range.start.column + 1, range.start.column + 2);
	                if (rightChar == selected) {
	                    range.end.column++;
	                    return range;
	                }
	            }
	        });
	    };
	
	    SQLBehaviour.isSaneInsertion = function (editor, session) {
	        var cursor = editor.getCursorPosition();
	        var iterator = new TokenIterator(session, cursor.row, cursor.column);
	
	        // Don't insert in the middle of a keyword/identifier/lexical
	        if (!this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) {
	            // Look ahead in case we're at the end of a token
	            var iterator2 = new TokenIterator(session, cursor.row, cursor.column + 1);
	            if (!this.$matchTokenType(iterator2.getCurrentToken() || "text", SAFE_INSERT_IN_TOKENS)) return false;
	        }
	
	        // Only insert in front of whitespace/comments
	        iterator.stepForward();
	        return iterator.getCurrentTokenRow() !== cursor.row || this.$matchTokenType(iterator.getCurrentToken() || "text", SAFE_INSERT_BEFORE_TOKENS);
	    };
	
	    SQLBehaviour.$matchTokenType = function (token, types) {
	        return types.indexOf(token.type || token) > -1;
	    };
	
	    SQLBehaviour.recordAutoInsert = function (editor, session, bracket) {
	        var cursor = editor.getCursorPosition();
	        var line = session.doc.getLine(cursor.row);
	        // Reset previous state if text or context changed too much
	        if (!this.isAutoInsertedClosing(cursor, line, context.autoInsertedLineEnd[0])) context.autoInsertedBrackets = 0;
	        context.autoInsertedRow = cursor.row;
	        context.autoInsertedLineEnd = bracket + line.substr(cursor.column);
	        context.autoInsertedBrackets++;
	    };
	
	    SQLBehaviour.recordMaybeInsert = function (editor, session, bracket) {
	        var cursor = editor.getCursorPosition();
	        var line = session.doc.getLine(cursor.row);
	        if (!this.isMaybeInsertedClosing(cursor, line)) context.maybeInsertedBrackets = 0;
	        context.maybeInsertedRow = cursor.row;
	        context.maybeInsertedLineStart = line.substr(0, cursor.column) + bracket;
	        context.maybeInsertedLineEnd = line.substr(cursor.column);
	        context.maybeInsertedBrackets++;
	    };
	
	    SQLBehaviour.isAutoInsertedClosing = function (cursor, line, bracket) {
	        return context.autoInsertedBrackets > 0 && cursor.row === context.autoInsertedRow && bracket === context.autoInsertedLineEnd[0] && line.substr(cursor.column) === context.autoInsertedLineEnd;
	    };
	
	    SQLBehaviour.isMaybeInsertedClosing = function (cursor, line) {
	        return context.maybeInsertedBrackets > 0 && cursor.row === context.maybeInsertedRow && line.substr(cursor.column) === context.maybeInsertedLineEnd && line.substr(0, cursor.column) == context.maybeInsertedLineStart;
	    };
	
	    SQLBehaviour.popAutoInsertedClosing = function () {
	        context.autoInsertedLineEnd = context.autoInsertedLineEnd.substr(1);
	        context.autoInsertedBrackets--;
	    };
	
	    SQLBehaviour.clearMaybeInsertedClosing = function () {
	        if (context) {
	            context.maybeInsertedBrackets = 0;
	            context.maybeInsertedRow = -1;
	        }
	    };
	
	    oop.inherits(SQLBehaviour, Behaviour);
	
	    exports.SQLBehaviour = SQLBehaviour;
	});

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.VisualizationEmptyState = exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /*  weak */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _LoadingSpinner = __webpack_require__(1281);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ShrinkableList = __webpack_require__(1755);
	
	var _ShrinkableList2 = _interopRequireDefault(_ShrinkableList);
	
	var _RunButton = __webpack_require__(1756);
	
	var _RunButton2 = _interopRequireDefault(_RunButton);
	
	var _VisualizationSettings = __webpack_require__(1757);
	
	var _VisualizationSettings2 = _interopRequireDefault(_VisualizationSettings);
	
	var _VisualizationError = __webpack_require__(1758);
	
	var _VisualizationError2 = _interopRequireDefault(_VisualizationError);
	
	var _VisualizationResult = __webpack_require__(1760);
	
	var _VisualizationResult2 = _interopRequireDefault(_VisualizationResult);
	
	var _Warnings = __webpack_require__(1513);
	
	var _Warnings2 = _interopRequireDefault(_Warnings);
	
	var _QueryDownloadWidget = __webpack_require__(1500);
	
	var _QueryDownloadWidget2 = _interopRequireDefault(_QueryDownloadWidget);
	
	var _QuestionEmbedWidget = __webpack_require__(1762);
	
	var _QuestionEmbedWidget2 = _interopRequireDefault(_QuestionEmbedWidget);
	
	var _formatting = __webpack_require__(872);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var REFRESH_TOOLTIP_THRESHOLD = 30 * 1000; // 30 seconds
	
	var QueryVisualization = (_temp = _class = function (_Component) {
	    _inherits(QueryVisualization, _Component);
	
	    function QueryVisualization(props, context) {
	        _classCallCheck(this, QueryVisualization);
	
	        var _this = _possibleConstructorReturn(this, (QueryVisualization.__proto__ || Object.getPrototypeOf(QueryVisualization)).call(this, props, context));
	
	        _this.runQuery = function () {
	            _this.props.runQuestionQuery({ ignoreCache: true });
	        };
	
	        _this.state = _this._getStateFromProps(props);
	        return _this;
	    }
	
	    _createClass(QueryVisualization, [{
	        key: "_getStateFromProps",
	        value: function _getStateFromProps(props) {
	            return {
	                lastRunDatasetQuery: _utils2.default.copy(props.question.query().datasetQuery()),
	                lastRunParameterValues: _utils2.default.copy(props.parameterValues)
	            };
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            // whenever we are told that we are running a query lets update our understanding of the "current" query
	            if (nextProps.isRunning) {
	                this.setState(this._getStateFromProps(nextProps));
	            }
	        }
	    }, {
	        key: "isChartDisplay",
	        value: function isChartDisplay(display) {
	            return display !== "table" && display !== "scalar";
	        }
	    }, {
	        key: "renderHeader",
	        value: function renderHeader() {
	            var _props = this.props,
	                question = _props.question,
	                isObjectDetail = _props.isObjectDetail,
	                isRunnable = _props.isRunnable,
	                isRunning = _props.isRunning,
	                isResultDirty = _props.isResultDirty,
	                isAdmin = _props.isAdmin,
	                result = _props.result,
	                cancelQuery = _props.cancelQuery;
	
	
	            var runButtonTooltip = void 0;
	            if (!isResultDirty && result && result.cached && result.average_execution_time > REFRESH_TOOLTIP_THRESHOLD) {
	                runButtonTooltip = "This question will take approximately " + (0, _formatting.duration)(result.average_execution_time) + " to refresh";
	            }
	
	            var messages = [];
	            if (result && result.cached) {
	                messages.push({
	                    icon: "clock",
	                    message: _react2.default.createElement(
	                        "div",
	                        null,
	                        "Updated ",
	                        (0, _moment2.default)(result.updated_at).fromNow()
	                    )
	                });
	            }
	            if (result && result.data && !isObjectDetail && question.display() === "table") {
	                messages.push({
	                    icon: "table2",
	                    message:
	                    // class name is included for the sake of making targeting the element in tests easier
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ShownRowCount" },
	                        result.data.rows_truncated != null ? "Showing first " : "Showing ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            (0, _formatting.formatNumber)(result.row_count)
	                        ),
	                        " " + (0, _formatting.inflect)("row", result.data.rows.length)
	                    )
	                });
	            }
	
	            var isPublicLinksEnabled = _settings2.default.get("public_sharing");
	            var isEmbeddingEnabled = _settings2.default.get("embedding");
	            return _react2.default.createElement(
	                "div",
	                { className: "relative flex align-center flex-no-shrink mt2 mb1 sm-py3" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "z4 absolute left hide sm-show" },
	                    !isObjectDetail && _react2.default.createElement(_VisualizationSettings2.default, _extends({ ref: "settings" }, this.props))
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "z3 absolute left right" },
	                    _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: runButtonTooltip },
	                        _react2.default.createElement(_RunButton2.default, {
	                            isRunnable: isRunnable,
	                            isDirty: isResultDirty,
	                            isRunning: isRunning,
	                            onRun: this.runQuery,
	                            onCancel: cancelQuery
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "z4 absolute right flex align-center justify-end", style: { lineHeight: 0 /* needed to align icons :-/ */ } },
	                    _react2.default.createElement(_ShrinkableList2.default, {
	                        className: "flex",
	                        items: messages,
	                        renderItem: function renderItem(item) {
	                            return _react2.default.createElement(
	                                "div",
	                                { className: "flex-no-shrink flex align-center mx2 h5 text-grey-4" },
	                                _react2.default.createElement(_Icon2.default, { className: "mr1", name: item.icon, size: 12 }),
	                                item.message
	                            );
	                        },
	                        renderItemSmall: function renderItemSmall(item) {
	                            return _react2.default.createElement(
	                                _Tooltip2.default,
	                                { tooltip: _react2.default.createElement(
	                                        "div",
	                                        { className: "p1" },
	                                        item.message
	                                    ) },
	                                _react2.default.createElement(_Icon2.default, { className: "mx1", name: item.icon, size: 16 })
	                            );
	                        }
	                    }),
	                    !isObjectDetail && _react2.default.createElement(_Warnings2.default, { warnings: this.state.warnings, className: "mx1", size: 18 }),
	                    !isResultDirty && result && !result.error ? _react2.default.createElement(_QueryDownloadWidget2.default, {
	                        className: "mx1 hide sm-show",
	                        card: question.card(),
	                        result: result
	                    }) : null,
	                    question.isSaved() && (isPublicLinksEnabled && (isAdmin || question.publicUUID()) || isEmbeddingEnabled && isAdmin) ? _react2.default.createElement(_QuestionEmbedWidget2.default, {
	                        className: "mx1 hide sm-show",
	                        card: question.card()
	                    }) : null
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                className = _props2.className,
	                question = _props2.question,
	                databases = _props2.databases,
	                isObjectDetail = _props2.isObjectDetail,
	                isRunning = _props2.isRunning,
	                result = _props2.result;
	
	            var viz = void 0;
	
	            if (!result) {
	                var hasSampleDataset = !!_underscore2.default.findWhere(databases, { is_sample: true });
	                viz = _react2.default.createElement(VisualizationEmptyState, { showTutorialLink: hasSampleDataset });
	            } else {
	                var error = result.error;
	
	                if (error) {
	                    viz = _react2.default.createElement(_VisualizationError2.default, { error: error, card: question.card(), duration: result.duration });
	                } else if (result.data) {
	                    viz = _react2.default.createElement(_VisualizationResult2.default, _extends({
	                        lastRunDatasetQuery: this.state.lastRunDatasetQuery,
	                        onUpdateWarnings: function onUpdateWarnings(warnings) {
	                            return _this2.setState({ warnings: warnings });
	                        },
	                        onOpenChartSettings: function onOpenChartSettings() {
	                            return _this2.refs.settings.open();
	                        }
	                    }, this.props, {
	                        className: "spread"
	                    }));
	                }
	            }
	
	            var wrapperClasses = (0, _classnames2.default)(className, 'relative', {
	                'flex': !isObjectDetail,
	                'flex-column': !isObjectDetail
	            });
	
	            var visualizationClasses = (0, _classnames2.default)('flex flex-full Visualization z1 relative', {
	                'Visualization--errors': result && result.error,
	                'Visualization--loading': isRunning
	            });
	
	            return _react2.default.createElement(
	                "div",
	                { className: wrapperClasses },
	                !this.props.noHeader && this.renderHeader(),
	                isRunning && _react2.default.createElement(
	                    "div",
	                    { className: "Loading spread flex flex-column layout-centered text-brand z2" },
	                    _react2.default.createElement(_LoadingSpinner2.default, null),
	                    _react2.default.createElement(
	                        "h2",
	                        { className: "Loading-message text-brand text-uppercase my3" },
	                        "Doing science..."
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: visualizationClasses },
	                    viz
	                )
	            );
	        }
	    }]);
	
	    return QueryVisualization;
	}(_react.Component), _class.defaultProps = {
	    // NOTE: this should be more dynamic from the backend, it's set based on the query lang
	    maxTableRows: 2000
	}, _temp);
	QueryVisualization.displayName = "QueryVisualization";
	exports.default = QueryVisualization;
	var VisualizationEmptyState = exports.VisualizationEmptyState = function VisualizationEmptyState(_ref) {
	    var showTutorialLink = _ref.showTutorialLink;
	    return _react2.default.createElement(
	        "div",
	        { className: "flex full layout-centered text-grey-1 flex-column" },
	        _react2.default.createElement(
	            "h1",
	            null,
	            "If you give me some data I can show you something cool. Run a Query!"
	        ),
	        showTutorialLink && _react2.default.createElement(
	            _reactRouter.Link,
	            { to: Urls.question(null, "?tutorial"), className: "link cursor-pointer my2" },
	            "How do I use this thing?"
	        )
	    );
	};
	VisualizationEmptyState.displayName = "VisualizationEmptyState";

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ExplicitSize = __webpack_require__(1271);
	
	var _ExplicitSize2 = _interopRequireDefault(_ExplicitSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShrinkableList = (0, _ExplicitSize2.default)(_class = function (_Component) {
	    _inherits(ShrinkableList, _Component);
	
	    function ShrinkableList() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ShrinkableList);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShrinkableList.__proto__ || Object.getPrototypeOf(ShrinkableList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            isShrunk: null
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ShrinkableList, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps() {
	            this.setState({
	                isShrunk: null
	            });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.componentDidUpdate();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            var container = _reactDom2.default.findDOMNode(this);
	            var isShrunk = this.state.isShrunk;
	
	            if (container && isShrunk === null) {
	                this.setState({
	                    isShrunk: container.scrollWidth !== container.offsetWidth
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                items = _props.items,
	                className = _props.className,
	                renderItemSmall = _props.renderItemSmall,
	                renderItem = _props.renderItem;
	            var isShrunk = this.state.isShrunk;
	
	            return _react2.default.createElement(
	                "div",
	                { className: className },
	                items.map(function (item) {
	                    return isShrunk ? renderItemSmall(item) : renderItem(item);
	                })
	            );
	        }
	    }]);
	
	    return ShrinkableList;
	}(_react.Component)) || _class;
	
	ShrinkableList.displayName = "ShrinkableList";
	exports.default = ShrinkableList;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RunButton = (_temp = _class = function (_Component) {
	    _inherits(RunButton, _Component);
	
	    function RunButton() {
	        _classCallCheck(this, RunButton);
	
	        return _possibleConstructorReturn(this, (RunButton.__proto__ || Object.getPrototypeOf(RunButton)).apply(this, arguments));
	    }
	
	    _createClass(RunButton, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                isRunnable = _props.isRunnable,
	                isRunning = _props.isRunning,
	                isDirty = _props.isDirty,
	                onRun = _props.onRun,
	                onCancel = _props.onCancel;
	
	            var buttonText = null;
	            if (isRunning) {
	                buttonText = _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center" },
	                    _react2.default.createElement(_Icon2.default, { className: "mr1", name: "close" }),
	                    "Cancel"
	                );
	            } else if (isRunnable && isDirty) {
	                buttonText = "Get Answer";
	            } else if (isRunnable && !isDirty) {
	                buttonText = _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center" },
	                    _react2.default.createElement(_Icon2.default, { className: "mr1", name: "refresh" }),
	                    "Refresh"
	                );
	            }
	            var actionFn = isRunning ? onCancel : onRun;
	            var classes = (0, _classnames2.default)("Button Button--medium circular RunButton ml-auto mr-auto block", {
	                "RunButton--hidden": !buttonText,
	                "Button--primary": isDirty,
	                "text-grey-2": !isDirty,
	                "text-grey-4-hover": !isDirty
	            });
	            return _react2.default.createElement(
	                "button",
	                { className: classes, onClick: function onClick() {
	                        return actionFn();
	                    } },
	                buttonText
	            );
	        }
	    }]);
	
	    return RunButton;
	}(_react.Component), _class.propTypes = {
	    isRunnable: _propTypes2.default.bool.isRequired,
	    isRunning: _propTypes2.default.bool.isRequired,
	    isDirty: _propTypes2.default.bool.isRequired,
	    onRun: _propTypes2.default.func.isRequired,
	    onCancel: _propTypes2.default.func
	}, _temp);
	RunButton.displayName = "RunButton";
	exports.default = RunButton;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _ChartSettings = __webpack_require__(1512);
	
	var _ChartSettings2 = _interopRequireDefault(_ChartSettings);
	
	var _visualizations = __webpack_require__(1284);
	
	var _visualizations2 = _interopRequireDefault(_visualizations);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VisualizationSettings = (_temp = _class = function (_React$Component) {
	    _inherits(VisualizationSettings, _React$Component);
	
	    function VisualizationSettings(props, context) {
	        _classCallCheck(this, VisualizationSettings);
	
	        var _this = _possibleConstructorReturn(this, (VisualizationSettings.__proto__ || Object.getPrototypeOf(VisualizationSettings)).call(this, props, context));
	
	        _this.setDisplay = function (type) {
	            // notify our parent about our change
	            _this.props.setDisplayFn(type);
	            _this.refs.displayPopover.toggle();
	        };
	
	        _this.open = function () {
	            _this.refs.popover.open();
	        };
	
	        return _this;
	    }
	
	    _createClass(VisualizationSettings, [{
	        key: "renderChartTypePicker",
	        value: function renderChartTypePicker() {
	            var _this2 = this;
	
	            var _props = this.props,
	                result = _props.result,
	                card = _props.card;
	
	            var _getVisualizationRaw = (0, _visualizations.getVisualizationRaw)([{ card: card, data: result.data }]),
	                CardVisualization = _getVisualizationRaw.CardVisualization;
	
	            var triggerElement = _react2.default.createElement(
	                "span",
	                { className: "px2 py1 text-bold cursor-pointer text-default flex align-center" },
	                _react2.default.createElement(_Icon2.default, {
	                    className: "mr1",
	                    name: CardVisualization.iconName,
	                    size: 12
	                }),
	                CardVisualization.uiName,
	                _react2.default.createElement(_Icon2.default, { className: "ml1", name: "chevrondown", size: 8 })
	            );
	
	            return _react2.default.createElement(
	                "div",
	                { className: "relative" },
	                _react2.default.createElement(
	                    "span",
	                    {
	                        className: "GuiBuilder-section-label pl0 Query-label",
	                        style: { marginLeft: 4 }
	                    },
	                    "Visualization"
	                ),
	                _react2.default.createElement(
	                    _PopoverWithTrigger2.default,
	                    {
	                        id: "VisualizationPopover",
	                        ref: "displayPopover",
	                        className: "ChartType-popover",
	                        triggerId: "VisualizationTrigger",
	                        triggerElement: triggerElement,
	                        triggerClasses: "flex align-center",
	                        sizeToFit: true
	                    },
	                    _react2.default.createElement(
	                        "ul",
	                        { className: "pt1 pb1" },
	                        Array.from(_visualizations2.default).map(function (_ref, index) {
	                            var _ref2 = _slicedToArray(_ref, 2),
	                                vizType = _ref2[0],
	                                viz = _ref2[1];
	
	                            return _react2.default.createElement(
	                                "li",
	                                {
	                                    key: index,
	                                    className: (0, _classnames2.default)('p2 flex align-center cursor-pointer bg-brand-hover text-white-hover', {
	                                        'ChartType--selected': vizType === card.display,
	                                        'ChartType--notSensible': !(result && result.data && viz.isSensible && viz.isSensible(result.data.cols, result.data.rows)),
	                                        'hide': viz.hidden
	                                    }),
	                                    onClick: _this2.setDisplay.bind(null, vizType)
	                                },
	                                _react2.default.createElement(_Icon2.default, { name: viz.iconName, size: 12 }),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "ml1" },
	                                    viz.uiName
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (this.props.result && this.props.result.error === undefined) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "VisualizationSettings flex align-center" },
	                    this.renderChartTypePicker(),
	                    _react2.default.createElement(
	                        _ModalWithTrigger2.default,
	                        {
	                            wide: true, tall: true,
	                            triggerElement: _react2.default.createElement(
	                                "span",
	                                { "data-metabase-event": "Query Builder;Chart Settings" },
	                                _react2.default.createElement(_Icon2.default, { name: "gear" })
	                            ),
	                            triggerClasses: "text-brand-hover",
	                            ref: "popover"
	                        },
	                        _react2.default.createElement(_ChartSettings2.default, {
	                            series: [{ card: this.props.card, data: this.props.result.data }],
	                            onChange: this.props.onReplaceAllVisualizationSettings
	                        })
	                    )
	                );
	            } else {
	                return false;
	            }
	        }
	    }]);
	
	    return VisualizationSettings;
	}(_react2.default.Component), _class.propTypes = {
	    card: _propTypes2.default.object.isRequired,
	    result: _propTypes2.default.object,
	    setDisplayFn: _propTypes2.default.func.isRequired,
	    onUpdateVisualizationSettings: _propTypes2.default.func.isRequired,
	    onReplaceAllVisualizationSettings: _propTypes2.default.func.isRequired
	}, _temp);
	VisualizationSettings.displayName = "VisualizationSettings";
	exports.default = VisualizationSettings;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _VisualizationErrorMessage = __webpack_require__(1759);
	
	var _VisualizationErrorMessage2 = _interopRequireDefault(_VisualizationErrorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailAdmin = function EmailAdmin() {
	    var adminEmail = _settings2.default.adminEmail();
	    return adminEmail && _react2.default.createElement(
	        "span",
	        { className: "QueryError-adminEmail" },
	        _react2.default.createElement(
	            "a",
	            { className: "no-decoration", href: "mailto:" + adminEmail },
	            adminEmail
	        )
	    );
	};
	
	var VisualizationError = (_temp = _class = function (_Component) {
	    _inherits(VisualizationError, _Component);
	
	    function VisualizationError(props) {
	        _classCallCheck(this, VisualizationError);
	
	        var _this = _possibleConstructorReturn(this, (VisualizationError.__proto__ || Object.getPrototypeOf(VisualizationError)).call(this, props));
	
	        _this.state = {
	            showError: false
	        };
	        return _this;
	    }
	
	    _createClass(VisualizationError, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                card = _props.card,
	                duration = _props.duration,
	                error = _props.error;
	
	
	            if (error && typeof error.status === "number") {
	                // Assume if the request took more than 15 seconds it was due to a timeout
	                // Some platforms like Heroku return a 503 for numerous types of errors so we can't use the status code to distinguish between timeouts and other failures.
	                if (duration > 15 * 1000) {
	                    return _react2.default.createElement(_VisualizationErrorMessage2.default, {
	                        type: "timeout",
	                        title: "Your question took too long",
	                        message: "We didn't get an answer back from your database in time, so we had to stop. You can try again in a minute, or if the problem persists, you can email an admin to let them know.",
	                        action: _react2.default.createElement(EmailAdmin, null)
	                    });
	                } else {
	                    return _react2.default.createElement(_VisualizationErrorMessage2.default, {
	                        type: "serverError",
	                        title: "We're experiencing server issues",
	                        message: "Try refreshing the page after waiting a minute or two. If the problem persists we'd recommend you contact an admin.",
	                        action: _react2.default.createElement(EmailAdmin, null)
	                    });
	                }
	            } else if (card && card.dataset_query && card.dataset_query.type === 'native') {
	                // always show errors for native queries
	                return _react2.default.createElement(
	                    "div",
	                    { className: "QueryError flex full align-center text-error" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "QueryError-iconWrapper" },
	                        _react2.default.createElement(
	                            "svg",
	                            { className: "QueryError-icon", viewBox: "0 0 32 32", width: "64", height: "64", fill: "currentcolor" },
	                            _react2.default.createElement("path", { d: "M4 8 L8 4 L16 12 L24 4 L28 8 L20 16 L28 24 L24 28 L16 20 L8 28 L4 24 L12 16 z " })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "QueryError-message" },
	                        error
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "QueryError2 flex full justify-center" },
	                    _react2.default.createElement("div", { className: "QueryError-image QueryError-image--queryError mr4" }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "QueryError2-details" },
	                        _react2.default.createElement(
	                            "h1",
	                            { className: "text-bold" },
	                            "There was a problem with your question"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            { className: "QueryError-messageText" },
	                            "Most of the time this is caused by an invalid selection or bad input value.  Double check your inputs and retry your query."
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "pt2" },
	                            _react2.default.createElement(
	                                "a",
	                                { onClick: function onClick() {
	                                        return _this2.setState({ showError: true });
	                                    }, className: "link cursor-pointer" },
	                                "Show error details"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { style: { display: this.state.showError ? 'inherit' : 'none' }, className: "pt3 text-left" },
	                            _react2.default.createElement(
	                                "h2",
	                                null,
	                                "Here's the full error message"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { style: { fontFamily: "monospace" }, className: "QueryError2-detailBody bordered rounded bg-grey-0 text-bold p2 mt1" },
	                                error
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return VisualizationError;
	}(_react.Component), _class.propTypes = {
	    card: _propTypes2.default.object.isRequired,
	    duration: _propTypes2.default.number.isRequired,
	    error: _propTypes2.default.object.isRequired
	}, _temp);
	VisualizationError.displayName = "VisualizationError";
	exports.default = VisualizationError;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint "react/prop-types": "warn" */
	
	var VisualizationErrorMessage = function VisualizationErrorMessage(_ref) {
	    var title = _ref.title,
	        type = _ref.type,
	        message = _ref.message,
	        action = _ref.action;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "QueryError flex full align-center" },
	        _react2.default.createElement("div", { className: "QueryError-image QueryError-image--" + type }),
	        _react2.default.createElement(
	            "div",
	            { className: "QueryError-message text-centered" },
	            title && _react2.default.createElement(
	                "h1",
	                { className: "text-bold" },
	                title
	            ),
	            _react2.default.createElement(
	                "p",
	                { className: "QueryError-messageText" },
	                message
	            ),
	            action
	        )
	    );
	};
	
	VisualizationErrorMessage.displayName = "VisualizationErrorMessage";
	VisualizationErrorMessage.propTypes = {
	    title: _propTypes2.default.string.isRequired,
	    type: _propTypes2.default.string.isRequired,
	    message: _propTypes2.default.string.isRequired,
	    action: _propTypes2.default.node
	};
	
	exports.default = VisualizationErrorMessage;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VisualizationErrorMessage = __webpack_require__(1759);
	
	var _VisualizationErrorMessage2 = _interopRequireDefault(_VisualizationErrorMessage);
	
	var _Visualization = __webpack_require__(1270);
	
	var _Visualization2 = _interopRequireDefault(_Visualization);
	
	var _dataset = __webpack_require__(877);
	
	var _Card = __webpack_require__(1761);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint "react/prop-types": "warn" */
	
	var VisualizationResult = function VisualizationResult(_ref) {
	    var question = _ref.question,
	        isObjectDetail = _ref.isObjectDetail,
	        lastRunDatasetQuery = _ref.lastRunDatasetQuery,
	        navigateToNewCardInsideQB = _ref.navigateToNewCardInsideQB,
	        result = _ref.result,
	        results = _ref.results,
	        props = _objectWithoutProperties(_ref, ["question", "isObjectDetail", "lastRunDatasetQuery", "navigateToNewCardInsideQB", "result", "results"]);
	
	    var noResults = (0, _dataset.datasetContainsNoResults)(result.data);
	    if (noResults) {
	        // successful query but there were 0 rows returned with the result
	        return _react2.default.createElement(_VisualizationErrorMessage2.default, {
	            type: "noRows",
	            title: "No results!",
	            message: "This may be the answer you\u2019re looking for. If not, chances are your filters are too specific. Try removing or changing your filters to see more data.",
	            action: _react2.default.createElement(
	                "button",
	                { className: "Button", onClick: function onClick() {
	                        return window.history.back();
	                    } },
	                "Back to last run"
	            )
	        });
	    } else {
	        // we want to provide the visualization with a card containing the latest
	        // "display", "visualization_settings", etc, (to ensure the correct visualization is shown)
	        // BUT the last executed "dataset_query" (to ensure data matches the query)
	        var series = question.atomicQueries().map(function (metricQuery, index) {
	            return {
	                card: _extends({}, question.card(), {
	                    display: isObjectDetail ? "object" : question.card().display,
	                    dataset_query: lastRunDatasetQuery
	                }),
	                data: results[index] && results[index].data
	            };
	        });
	
	        return _react2.default.createElement(_Visualization2.default, _extends({
	            series: series,
	            onChangeCardAndRun: navigateToNewCardInsideQB,
	            isEditing: true,
	            card: question.card()
	            // Table:
	        }, props));
	    }
	};
	
	exports.default = VisualizationResult;

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _EmbedWidget = __webpack_require__(1266);
	
	var _EmbedWidget2 = _interopRequireDefault(_EmbedWidget);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _Card = __webpack_require__(957);
	
	var _actions = __webpack_require__(863);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = {
	    createPublicLink: _actions.createPublicLink,
	    deletePublicLink: _actions.deletePublicLink,
	    updateEnableEmbedding: _actions.updateEnableEmbedding,
	    updateEmbeddingParams: _actions.updateEmbeddingParams
	};
	
	var QuestionEmbedWidget = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(QuestionEmbedWidget, _Component);
	
	    function QuestionEmbedWidget() {
	        _classCallCheck(this, QuestionEmbedWidget);
	
	        return _possibleConstructorReturn(this, (QuestionEmbedWidget.__proto__ || Object.getPrototypeOf(QuestionEmbedWidget)).apply(this, arguments));
	    }
	
	    _createClass(QuestionEmbedWidget, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                card = _props.card,
	                createPublicLink = _props.createPublicLink,
	                deletePublicLink = _props.deletePublicLink,
	                updateEnableEmbedding = _props.updateEnableEmbedding,
	                updateEmbeddingParams = _props.updateEmbeddingParams,
	                props = _objectWithoutProperties(_props, ["className", "card", "createPublicLink", "deletePublicLink", "updateEnableEmbedding", "updateEmbeddingParams"]);
	
	            return _react2.default.createElement(_EmbedWidget2.default, _extends({}, props, {
	                className: className,
	                resource: card,
	                resourceType: "question",
	                resourceParameters: (0, _Card.getParameters)(card),
	                onCreatePublicLink: function onCreatePublicLink() {
	                    return createPublicLink(card);
	                },
	                onDisablePublicLink: function onDisablePublicLink() {
	                    return deletePublicLink(card);
	                },
	                onUpdateEnableEmbedding: function onUpdateEnableEmbedding(enableEmbedding) {
	                    return updateEnableEmbedding(card, enableEmbedding);
	                },
	                onUpdateEmbeddingParams: function onUpdateEmbeddingParams(embeddingParams) {
	                    return updateEmbeddingParams(card, embeddingParams);
	                },
	                getPublicUrl: function getPublicUrl(_ref, extension) {
	                    var public_uuid = _ref.public_uuid;
	                    return Urls.publicCard(public_uuid, extension);
	                },
	                extensions: ["csv", "xlsx", "json"]
	            }));
	        }
	    }]);
	
	    return QuestionEmbedWidget;
	}(_react.Component)) || _class);
	QuestionEmbedWidget.displayName = "QuestionEmbedWidget";
	exports.default = QuestionEmbedWidget;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MainPane = __webpack_require__(1764);
	
	var _MainPane2 = _interopRequireDefault(_MainPane);
	
	var _TablePane = __webpack_require__(1765);
	
	var _TablePane2 = _interopRequireDefault(_TablePane);
	
	var _FieldPane = __webpack_require__(1770);
	
	var _FieldPane2 = _interopRequireDefault(_FieldPane);
	
	var _SegmentPane = __webpack_require__(1773);
	
	var _SegmentPane2 = _interopRequireDefault(_SegmentPane);
	
	var _MetricPane = __webpack_require__(1775);
	
	var _MetricPane2 = _interopRequireDefault(_MetricPane);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataReference = (_temp = _class = function (_Component) {
	    _inherits(DataReference, _Component);
	
	    function DataReference(props, context) {
	        _classCallCheck(this, DataReference);
	
	        var _this = _possibleConstructorReturn(this, (DataReference.__proto__ || Object.getPrototypeOf(DataReference)).call(this, props, context));
	
	        _this.state = {
	            stack: [],
	            tables: {},
	            fields: {}
	        };
	
	        _underscore2.default.bindAll(_this, "back", "close", "show");
	        return _this;
	    }
	
	    _createClass(DataReference, [{
	        key: "close",
	        value: function close() {
	            this.props.onClose();
	        }
	    }, {
	        key: "back",
	        value: function back() {
	            this.setState({
	                stack: this.state.stack.slice(0, -1)
	            });
	        }
	    }, {
	        key: "show",
	        value: function show(type, item) {
	            this.setState({
	                stack: this.state.stack.concat({ type: type, item: item })
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var content;
	            if (this.state.stack.length === 0) {
	                content = _react2.default.createElement(_MainPane2.default, _extends({}, this.props, { show: this.show }));
	            } else {
	                var page = this.state.stack[this.state.stack.length - 1];
	                if (page.type === "table") {
	                    content = _react2.default.createElement(_TablePane2.default, _extends({}, this.props, { show: this.show, table: page.item }));
	                } else if (page.type === "field") {
	                    content = _react2.default.createElement(_FieldPane2.default, _extends({}, this.props, { show: this.show, field: page.item }));
	                } else if (page.type === "segment") {
	                    content = _react2.default.createElement(_SegmentPane2.default, _extends({}, this.props, { show: this.show, segment: page.item }));
	                } else if (page.type === "metric") {
	                    content = _react2.default.createElement(_MetricPane2.default, _extends({}, this.props, { show: this.show, metric: page.item }));
	                }
	            }
	
	            var backButton;
	            if (this.state.stack.length > 0) {
	                backButton = _react2.default.createElement(
	                    "a",
	                    { className: "flex align-center mb2 text-default text-brand-hover no-decoration", onClick: this.back },
	                    _react2.default.createElement(_Icon2.default, { name: "chevronleft", size: 18 }),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "text-uppercase" },
	                        "Back"
	                    )
	                );
	            }
	
	            var closeButton = _react2.default.createElement(
	                "a",
	                { className: "flex-align-right text-default text-brand-hover no-decoration", onClick: this.close },
	                _react2.default.createElement(_Icon2.default, { name: "close", size: 18 })
	            );
	
	            return _react2.default.createElement(
	                "div",
	                { className: "DataReference-container p3 full-height scroll-y" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "DataReference-header flex mb1" },
	                    backButton,
	                    closeButton
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "DataReference-content" },
	                    content
	                )
	            );
	        }
	    }]);
	
	    return DataReference;
	}(_react.Component), _class.propTypes = {
	    query: _propTypes2.default.object.isRequired,
	    onClose: _propTypes2.default.func.isRequired,
	    runQuestionQuery: _propTypes2.default.func.isRequired,
	    setDatasetQuery: _propTypes2.default.func.isRequired,
	    setDatabaseFn: _propTypes2.default.func.isRequired,
	    setSourceTableFn: _propTypes2.default.func.isRequired,
	    setDisplayFn: _propTypes2.default.func.isRequired
	}, _temp);
	DataReference.displayName = "DataReference";
	exports.default = DataReference;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _table = __webpack_require__(871);
	
	var _inflection = __webpack_require__(520);
	
	var _inflection2 = _interopRequireDefault(_inflection);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainPane = function MainPane(_ref) {
	    var databases = _ref.databases,
	        show = _ref.show;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "h1",
	            null,
	            "Data Reference"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Learn more about your data structure to ask more useful questions."
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            databases && databases.filter(function (db) {
	                return db.tables && db.tables.length > 0;
	            }).map(function (database) {
	                return _react2.default.createElement(
	                    "li",
	                    { key: database.id },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "my2" },
	                        _react2.default.createElement(
	                            "h2",
	                            { className: "inline-block" },
	                            database.name
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            { className: "ml1" },
	                            database.tables.length + " " + _inflection2.default.inflect("table", database.tables.length)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        database.tables.filter(_table.isQueryable).map(function (table, index) {
	                            return _react2.default.createElement(
	                                "li",
	                                { key: table.id, className: (0, _classnames2.default)("p1", { "border-bottom": index !== database.tables.length - 1 }) },
	                                _react2.default.createElement(
	                                    "a",
	                                    { className: "text-brand text-brand-darken-hover no-decoration", onClick: function onClick() {
	                                            return show("table", table);
	                                        } },
	                                    table.display_name
	                                )
	                            );
	                        })
	                    )
	                );
	            })
	        )
	    );
	}; /* eslint "react/prop-types": "warn" */
	MainPane.displayName = "MainPane";
	
	
	MainPane.propTypes = {
	    show: _propTypes2.default.func.isRequired,
	    databases: _propTypes2.default.array
	};
	
	exports.default = MainPane;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _QueryButton = __webpack_require__(1766);
	
	var _QueryButton2 = _interopRequireDefault(_QueryButton);
	
	var _card = __webpack_require__(865);
	
	var _query = __webpack_require__(866);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _inflection = __webpack_require__(520);
	
	var _inflection2 = _interopRequireDefault(_inflection);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Expandable = __webpack_require__(1769);
	
	var _Expandable2 = _interopRequireDefault(_Expandable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TablePane = (_temp = _class = function (_Component) {
	    _inherits(TablePane, _Component);
	
	    function TablePane(props, context) {
	        _classCallCheck(this, TablePane);
	
	        var _this = _possibleConstructorReturn(this, (TablePane.__proto__ || Object.getPrototypeOf(TablePane)).call(this, props, context));
	
	        _this.setQueryAllRows = _this.setQueryAllRows.bind(_this);
	        _this.showPane = _this.showPane.bind(_this);
	
	        _this.state = {
	            table: undefined,
	            tableForeignKeys: undefined,
	            pane: "fields"
	        };
	        return _this;
	    }
	
	    _createClass(TablePane, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            var _this2 = this;
	
	            this.props.loadTableAndForeignKeysFn(this.props.table.id).then(function (result) {
	                _this2.setState({
	                    table: result.table,
	                    tableForeignKeys: result.foreignKeys
	                });
	            }).catch(function (error) {
	                _this2.setState({
	                    error: "An error occurred loading the table"
	                });
	            });
	        }
	    }, {
	        key: "showPane",
	        value: function showPane(name) {
	            this.setState({ pane: name });
	        }
	    }, {
	        key: "setQueryAllRows",
	        value: function setQueryAllRows() {
	            var card = (0, _card.createCard)();
	            card.dataset_query = (0, _query.createQuery)("query", this.state.table.db_id, this.state.table.id);
	            this.props.setCardAndRun(card);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _state = this.state,
	                table = _state.table,
	                error = _state.error;
	
	            if (table) {
	                var queryButton;
	                if (table.rows != null) {
	                    var text = "See the raw data for " + table.display_name;
	                    queryButton = _react2.default.createElement(_QueryButton2.default, { className: "border-bottom border-top mb3", icon: "table", text: text, onClick: this.setQueryAllRows });
	                }
	                var panes = {
	                    "fields": table.fields.length,
	                    // "metrics": table.metrics.length,
	                    // "segments": table.segments.length,
	                    "connections": this.state.tableForeignKeys.length
	                };
	                var tabs = Object.entries(panes).map(function (_ref) {
	                    var _ref2 = _slicedToArray(_ref, 2),
	                        name = _ref2[0],
	                        count = _ref2[1];
	
	                    return _react2.default.createElement(
	                        "a",
	                        { key: name, className: (0, _classnames2.default)("Button Button--small", { "Button--active": name === _this3.state.pane }), onClick: _this3.showPane.bind(null, name) },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "DataReference-paneCount" },
	                            count
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            _inflection2.default.inflect(name, count)
	                        )
	                    );
	                });
	
	                var pane;
	                if (this.state.pane === "connections") {
	                    var fkCountsByTable = (0, _schema_metadata.foreignKeyCountsByOriginTable)(this.state.tableForeignKeys);
	                    pane = _react2.default.createElement(
	                        "ul",
	                        null,
	                        this.state.tableForeignKeys.sort(function (a, b) {
	                            return a.origin.table.display_name.localeCompare(b.origin.table.display_name);
	                        }).map(function (fk, index) {
	                            return _react2.default.createElement(
	                                ListItem,
	                                { key: fk.id, onClick: function onClick() {
	                                        return _this3.props.show("field", fk.origin);
	                                    } },
	                                fk.origin.table.display_name,
	                                fkCountsByTable[fk.origin.table.id] > 1 ? _react2.default.createElement(
	                                    "span",
	                                    { className: "text-grey-3 text-light h5" },
	                                    " via ",
	                                    fk.origin.display_name
	                                ) : null
	                            );
	                        })
	                    );
	                } else if (this.state.pane) {
	                    var itemType = this.state.pane.replace(/s$/, "");
	                    pane = _react2.default.createElement(
	                        "ul",
	                        null,
	                        table[this.state.pane].map(function (item, index) {
	                            return _react2.default.createElement(
	                                ListItem,
	                                { key: item.id, onClick: function onClick() {
	                                        return _this3.props.show(itemType, item);
	                                    } },
	                                item.display_name || item.name
	                            );
	                        })
	                    );
	                } else var descriptionClasses = (0, _classnames2.default)({ "text-grey-3": !table.description });
	                var description = _react2.default.createElement(
	                    "p",
	                    { className: descriptionClasses },
	                    table.description || "No description set."
	                );
	
	                return _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "h1",
	                        null,
	                        table.display_name
	                    ),
	                    description,
	                    queryButton,
	                    table.metrics && table.metrics.length > 0 && _react2.default.createElement(ExpandableItemList, {
	                        name: "Metrics",
	                        type: "metrics",
	                        show: this.props.show.bind(null, "metric"),
	                        items: table.metrics.filter(function (metric) {
	                            return metric.is_active === true;
	                        })
	                    }),
	                    table.segments && table.segments.length > 0 && _react2.default.createElement(ExpandableItemList, {
	                        name: "Segments",
	                        type: "segments",
	                        show: this.props.show.bind(null, "segment"),
	                        items: table.segments.filter(function (segment) {
	                            return segment.is_active === true;
	                        })
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Button-group Button-group--brand text-uppercase" },
	                        tabs
	                    ),
	                    pane
	                );
	            } else {
	                return _react2.default.createElement(
	                    "div",
	                    null,
	                    error
	                );
	            }
	        }
	    }]);
	
	    return TablePane;
	}(_react.Component), _class.propTypes = {
	    query: _propTypes2.default.object.isRequired,
	    loadTableAndForeignKeysFn: _propTypes2.default.func.isRequired,
	    show: _propTypes2.default.func.isRequired,
	    onClose: _propTypes2.default.func.isRequired,
	    setCardAndRun: _propTypes2.default.func.isRequired,
	    table: _propTypes2.default.object
	}, _temp);
	TablePane.displayName = "TablePane";
	exports.default = TablePane;
	
	
	var ExpandableItemList = (0, _Expandable2.default)(function (_ref3) {
	    var name = _ref3.name,
	        type = _ref3.type,
	        show = _ref3.show,
	        items = _ref3.items,
	        isExpanded = _ref3.isExpanded,
	        onExpand = _ref3.onExpand;
	    return _react2.default.createElement(
	        "div",
	        { className: "mb2" },
	        _react2.default.createElement(
	            "div",
	            { className: "text-bold mb1" },
	            name
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            items.map(function (item, index) {
	                return _react2.default.createElement(
	                    ListItem,
	                    { key: item.id, onClick: function onClick() {
	                            return show(item);
	                        } },
	                    item.name
	                );
	            }),
	            !isExpanded && _react2.default.createElement(
	                ListItem,
	                { onClick: onExpand },
	                "More..."
	            )
	        )
	    );
	});
	
	ExpandableItemList.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    type: _propTypes2.default.string.isRequired,
	    show: _propTypes2.default.func.isRequired,
	    items: _propTypes2.default.array.isRequired,
	    onExpand: _propTypes2.default.func.isRequired,
	    isExpanded: _propTypes2.default.bool.isRequired
	};
	
	var ListItem = function ListItem(_ref4) {
	    var onClick = _ref4.onClick,
	        children = _ref4.children;
	    return _react2.default.createElement(
	        "li",
	        { className: "py1 border-row-divider" },
	        _react2.default.createElement(
	            "a",
	            { className: "text-brand text-brand-darken-hover no-decoration", onClick: onClick },
	            children
	        )
	    );
	};
	
	ListItem.displayName = "ListItem";
	ListItem.propTypes = {
	    children: _propTypes2.default.any,
	    onClick: _propTypes2.default.func
	};

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _QueryButton = __webpack_require__(1767);
	
	var _QueryButton2 = _interopRequireDefault(_QueryButton);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QueryButton = function QueryButton(_ref) {
	    var className = _ref.className,
	        text = _ref.text,
	        icon = _ref.icon,
	        iconClass = _ref.iconClass,
	        onClick = _ref.onClick,
	        link = _ref.link;
	    return _react2.default.createElement(
	        "div",
	        { className: className },
	        _react2.default.createElement(
	            _reactRouter.Link,
	            { className: _QueryButton2.default.queryButton, onClick: onClick, to: link },
	            _react2.default.createElement(_Icon2.default, _extends({
	                className: iconClass,
	                size: 20
	            }, typeof icon === 'string' ? { name: icon } : icon)),
	            _react2.default.createElement(
	                "span",
	                { className: (0, _classnames2.default)(_QueryButton2.default.queryButtonText, 'text-brand-hover') },
	                text
	            ),
	            _react2.default.createElement(
	                "span",
	                { className: _QueryButton2.default.queryButtonCircle },
	                _react2.default.createElement(_Icon2.default, { size: 8, name: "chevronright" })
	            )
	        )
	    );
	};
	QueryButton.displayName = "QueryButton";
	QueryButton.propTypes = {
	    className: _propTypes2.default.string,
	    icon: _propTypes2.default.any.isRequired,
	    text: _propTypes2.default.string.isRequired,
	    iconClass: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    link: _propTypes2.default.string
	};
	
	exports.default = (0, _pure2.default)(QueryButton);

/***/ }),
/* 1767 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"queryButton":"cCKvM _38618 _3Dqep qXm3b _2XN97","queryButtonText":"_1LYwk _2kZNz _1ABq6 _1NNXY","queryButtonCircle":"_1EvPY _38618 _3Dqep _1X7sA _20SLo"};

/***/ }),
/* 1768 */,
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Expandable = function Expandable(ComposedComponent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_Component) {
	        _inherits(_class, _Component);
	
	        function _class(props, context) {
	            _classCallCheck(this, _class);
	
	            var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));
	
	            _this.state = {
	                expanded: false
	            };
	            _this.expand = function () {
	                return _this.setState({ expanded: true });
	            };
	            return _this;
	        }
	
	        _createClass(_class, [{
	            key: "render",
	            value: function render() {
	                var expanded = this.state.expanded;
	                var _props = this.props,
	                    items = _props.items,
	                    initialItemLimit = _props.initialItemLimit;
	
	                if (items.length > initialItemLimit && !expanded) {
	                    items = items.slice(0, initialItemLimit - 1);
	                }
	                expanded = items.length >= this.props.items.length;
	                return _react2.default.createElement(ComposedComponent, _extends({}, this.props, { isExpanded: expanded, onExpand: this.expand, items: items }));
	            }
	        }]);
	
	        return _class;
	    }(_react.Component), _class.displayName = "Expandable[" + (ComposedComponent.displayName || ComposedComponent.name) + "]", _class.propTypes = {
	        items: _propTypes2.default.array.isRequired,
	        initialItemLimit: _propTypes2.default.number.isRequired
	    }, _class.defaultProps = {
	        initialItemLimit: 4
	    }, _temp;
	};
	
	exports.default = Expandable;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DetailPane = __webpack_require__(1771);
	
	var _DetailPane2 = _interopRequireDefault(_DetailPane);
	
	var _QueryButton = __webpack_require__(1766);
	
	var _QueryButton2 = _interopRequireDefault(_QueryButton);
	
	var _UseForButton = __webpack_require__(1772);
	
	var _UseForButton2 = _interopRequireDefault(_UseForButton);
	
	var _metadata = __webpack_require__(1110);
	
	var _metadata2 = __webpack_require__(1073);
	
	var _card = __webpack_require__(865);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _inflection = __webpack_require__(520);
	
	var _inflection2 = _interopRequireDefault(_inflection);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Dimension = __webpack_require__(901);
	
	var _Dimension2 = _interopRequireDefault(_Dimension);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = {
	    fetchTableMetadata: _metadata.fetchTableMetadata
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        metadata: (0, _metadata2.getMetadata)(state, props)
	    };
	};
	
	var FieldPane = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(FieldPane, _Component);
	
	    function FieldPane(props, context) {
	        _classCallCheck(this, FieldPane);
	
	        var _this = _possibleConstructorReturn(this, (FieldPane.__proto__ || Object.getPrototypeOf(FieldPane)).call(this, props, context));
	
	        _this.groupBy = function () {
	            var _this$props = _this.props,
	                question = _this$props.question,
	                metadata = _this$props.metadata,
	                field = _this$props.field;
	
	            var query = question.query();
	
	            if (query instanceof _StructuredQuery2.default) {
	                // Add an aggregation so both aggregation and filter popovers aren't visible
	                if (!_query2.default.hasValidAggregation(query.datasetQuery().query)) {
	                    query = query.clearAggregations();
	                }
	
	                var defaultBreakout = metadata.fields[field.id].getDefaultBreakout();
	                query = query.addBreakout(defaultBreakout);
	
	                _this.props.updateQuestion(query.question());
	                _this.props.runQuestionQuery();
	            }
	        };
	
	        _this.newCard = function () {
	            var _this$props2 = _this.props,
	                metadata = _this$props2.metadata,
	                field = _this$props2.field;
	
	            var tableId = field.table_id;
	            var dbId = metadata.tables[tableId].database.id;
	
	            var card = (0, _card.createCard)();
	            card.dataset_query = (0, _query.createQuery)("query", dbId, tableId);
	            return card;
	        };
	
	        _this.setQuerySum = function () {
	            var card = _this.newCard();
	            card.dataset_query.query.aggregation = ["sum", _this.props.field.id];
	            _this.props.setCardAndRun(card);
	        };
	
	        _this.setQueryDistinct = function () {
	            var _this$props3 = _this.props,
	                metadata = _this$props3.metadata,
	                field = _this$props3.field;
	
	            var defaultBreakout = metadata.fields[field.id].getDefaultBreakout();
	
	            var card = _this.newCard();
	            card.dataset_query.query.aggregation = ["rows"];
	            card.dataset_query.query.breakout = [defaultBreakout];
	            _this.props.setCardAndRun(card);
	        };
	
	        _this.setQueryCountGroupedBy = function (chartType) {
	            var _this$props4 = _this.props,
	                metadata = _this$props4.metadata,
	                field = _this$props4.field;
	
	            var defaultBreakout = metadata.fields[field.id].getDefaultBreakout();
	
	            var card = _this.newCard();
	            card.dataset_query.query.aggregation = ["count"];
	            card.dataset_query.query.breakout = [defaultBreakout];
	            card.display = chartType;
	            _this.props.setCardAndRun(card);
	        };
	
	        _this.isBreakoutWithCurrentField = function (breakout) {
	            var _this$props5 = _this.props,
	                field = _this$props5.field,
	                metadata = _this$props5.metadata;
	
	            var dimension = _Dimension2.default.parseMBQL(breakout, metadata);
	            return dimension && dimension.field().id === field.id;
	        };
	
	        return _this;
	    }
	
	    _createClass(FieldPane, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.fetchTableMetadata(this.props.field.table_id);
	        }
	
	        // See the note in render() method about filterBy
	        // filterBy() {
	        //     var datasetQuery = this.setDatabaseAndTable();
	        //     // Add an aggregation so both aggregation and filter popovers aren't visible
	        //     if (!Query.hasValidAggregation(datasetQuery.query)) {
	        //         Query.clearAggregations(datasetQuery.query);
	        //     }
	        //     Query.addFilter(datasetQuery.query, [null, this.props.field.id, null]);
	        //     this.props.setDatasetQuery(datasetQuery);
	        // }
	
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                field = _props.field,
	                question = _props.question;
	
	
	            var query = question.query();
	
	            var fieldName = field.display_name;
	            var tableName = query.table() ? query.table().display_name : "";
	
	            var useForCurrentQuestion = [],
	                usefulQuestions = [];
	
	            // determine if the selected field is a valid dimension on this table
	            var validBreakout = false;
	            if (query.table()) {
	                var validDimensions = _underscore2.default.filter(query.table().fields, _schema_metadata.isDimension);
	                validBreakout = _underscore2.default.some(validDimensions, function (f) {
	                    return f.id === field.id;
	                });
	            }
	
	            // TODO: allow for filters/grouping via foreign keys
	            if (query instanceof _StructuredQuery2.default && query.tableId() === field.table_id) {
	                // NOTE: disabled this for now because we need a way to capture the completed filter before adding it to the query, or to pop open the filter widget here?
	                // useForCurrentQuestion.push(<UseForButton title={"Filter by " + name} onClick={this.filterBy} />);
	
	                // current field must be a valid breakout option for this table AND cannot already be in the breakout clause of our query
	                if (validBreakout && !_underscore2.default.some(query.breakouts(), this.isBreakoutWithCurrentField)) {
	                    useForCurrentQuestion.push(_react2.default.createElement(_UseForButton2.default, { title: "Group by " + name, onClick: this.groupBy }));
	                }
	            }
	
	            if ((0, _schema_metadata.isSummable)(field)) {
	                usefulQuestions.push(_react2.default.createElement(_QueryButton2.default, { icon: "number", text: "Sum of all values of " + fieldName, onClick: this.setQuerySum }));
	            }
	            usefulQuestions.push(_react2.default.createElement(_QueryButton2.default, { icon: "table", text: "All distinct values of " + fieldName, onClick: this.setQueryDistinct }));
	            var queryCountGroupedByText = "Number of " + _inflection2.default.pluralize(tableName) + " grouped by " + fieldName;
	            if (validBreakout) {
	                usefulQuestions.push(_react2.default.createElement(_QueryButton2.default, { icon: "bar", text: queryCountGroupedByText, onClick: this.setQueryCountGroupedBy.bind(null, "bar") }));
	                usefulQuestions.push(_react2.default.createElement(_QueryButton2.default, { icon: "pie", text: queryCountGroupedByText, onClick: this.setQueryCountGroupedBy.bind(null, "pie") }));
	            }
	
	            return _react2.default.createElement(_DetailPane2.default, {
	                name: fieldName,
	                description: field.description,
	                useForCurrentQuestion: useForCurrentQuestion,
	                usefulQuestions: usefulQuestions
	            });
	        }
	    }]);
	
	    return FieldPane;
	}(_react.Component), _class2.propTypes = {
	    field: _propTypes2.default.object.isRequired,
	    datasetQuery: _propTypes2.default.object,
	    question: _propTypes2.default.object,
	    originalQuestion: _propTypes2.default.object,
	    metadata: _propTypes2.default.object,
	    fetchTableMetadata: _propTypes2.default.func.isRequired,
	    runQuestionQuery: _propTypes2.default.func.isRequired,
	    setDatasetQuery: _propTypes2.default.func.isRequired,
	    setCardAndRun: _propTypes2.default.func.isRequired,
	    updateQuestion: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	FieldPane.displayName = "FieldPane";
	exports.default = FieldPane;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailPane = function DetailPane(_ref) {
	    var name = _ref.name,
	        description = _ref.description,
	        usefulQuestions = _ref.usefulQuestions,
	        useForCurrentQuestion = _ref.useForCurrentQuestion,
	        extra = _ref.extra;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "h1",
	            null,
	            name
	        ),
	        _react2.default.createElement(
	            "p",
	            { className: (0, _classnames2.default)({ "text-grey-3": !description }) },
	            description || "No description set."
	        ),
	        useForCurrentQuestion && useForCurrentQuestion.length > 0 ? _react2.default.createElement(
	            "div",
	            { className: "py1" },
	            _react2.default.createElement(
	                "p",
	                { className: "text-bold" },
	                "Use for current question"
	            ),
	            _react2.default.createElement(
	                "ul",
	                { className: "my2" },
	                useForCurrentQuestion.map(function (item, index) {
	                    return _react2.default.createElement(
	                        "li",
	                        { className: "mt1", key: index },
	                        item
	                    );
	                })
	            )
	        ) : null,
	        usefulQuestions && usefulQuestions.length > 0 ? _react2.default.createElement(
	            "div",
	            { className: "py1" },
	            _react2.default.createElement(
	                "p",
	                { className: "text-bold" },
	                "Potentially useful questions"
	            ),
	            _react2.default.createElement(
	                "ul",
	                null,
	                usefulQuestions.map(function (item, index) {
	                    return _react2.default.createElement(
	                        "li",
	                        { className: "border-row-divider", key: index },
	                        item
	                    );
	                })
	            )
	        ) : null,
	        extra
	    );
	}; /* eslint "react/prop-types": "warn" */
	DetailPane.displayName = "DetailPane";
	
	
	DetailPane.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    description: _propTypes2.default.string,
	    error: _propTypes2.default.string,
	    useForCurrentQuestion: _propTypes2.default.array,
	    usefulQuestions: _propTypes2.default.array,
	    extra: _propTypes2.default.element
	};
	
	exports.default = DetailPane;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UseForButton = function UseForButton(_ref) {
	    var title = _ref.title,
	        onClick = _ref.onClick;
	    return _react2.default.createElement(
	        "a",
	        { className: "Button Button--white text-default text-brand-hover border-brand-hover no-decoration", onClick: onClick },
	        _react2.default.createElement(_Icon2.default, { className: "mr1", name: "add", size: 12 }),
	        " ",
	        title
	    );
	};
	
	UseForButton.displayName = "UseForButton";
	exports.default = UseForButton;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _metadata = __webpack_require__(1110);
	
	var _metadata2 = __webpack_require__(1073);
	
	var _DetailPane = __webpack_require__(1771);
	
	var _DetailPane2 = _interopRequireDefault(_DetailPane);
	
	var _QueryButton = __webpack_require__(1766);
	
	var _QueryButton2 = _interopRequireDefault(_QueryButton);
	
	var _UseForButton = __webpack_require__(1772);
	
	var _UseForButton2 = _interopRequireDefault(_UseForButton);
	
	var _QueryDefinition = __webpack_require__(1774);
	
	var _QueryDefinition2 = _interopRequireDefault(_QueryDefinition);
	
	var _card = __webpack_require__(865);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = {
	    fetchTableMetadata: _metadata.fetchTableMetadata
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        metadata: (0, _metadata2.getMetadata)(state, props)
	    };
	};
	
	var SegmentPane = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentPane, _Component);
	
	    function SegmentPane(props, context) {
	        _classCallCheck(this, SegmentPane);
	
	        var _this = _possibleConstructorReturn(this, (SegmentPane.__proto__ || Object.getPrototypeOf(SegmentPane)).call(this, props, context));
	
	        _underscore2.default.bindAll(_this, "filterBy", "setQueryFilteredBy", "setQueryCountFilteredBy");
	        return _this;
	    }
	
	    _createClass(SegmentPane, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.fetchTableMetadata(this.props.segment.table_id);
	        }
	    }, {
	        key: "filterBy",
	        value: function filterBy() {
	            var question = this.props.question;
	
	            var query = question.query();
	
	            if (query instanceof _StructuredQuery2.default) {
	                // Add an aggregation so both aggregation and filter popovers aren't visible
	                if (!_query2.default.hasValidAggregation(query.datasetQuery().query)) {
	                    query = query.clearAggregations();
	                }
	
	                query = query.addFilter(["SEGMENT", this.props.segment.id]);
	
	                this.props.updateQuestion(query.question());
	                this.props.runQuestionQuery();
	            }
	        }
	    }, {
	        key: "newCard",
	        value: function newCard() {
	            var _props = this.props,
	                segment = _props.segment,
	                metadata = _props.metadata;
	
	            var table = metadata && metadata.tables[segment.table_id];
	
	            if (table) {
	                var card = (0, _card.createCard)();
	                card.dataset_query = (0, _query.createQuery)("query", table.db_id, table.id);
	                return card;
	            } else {
	                throw new Error("Could not find the table metadata prior to creating a new question");
	            }
	        }
	    }, {
	        key: "setQueryFilteredBy",
	        value: function setQueryFilteredBy() {
	            var card = this.newCard();
	            card.dataset_query.query.aggregation = ["rows"];
	            card.dataset_query.query.filter = ["SEGMENT", this.props.segment.id];
	            this.props.setCardAndRun(card);
	        }
	    }, {
	        key: "setQueryCountFilteredBy",
	        value: function setQueryCountFilteredBy() {
	            var card = this.newCard();
	            card.dataset_query.query.aggregation = ["count"];
	            card.dataset_query.query.filter = ["SEGMENT", this.props.segment.id];
	            this.props.setCardAndRun(card);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _$findWhere;
	
	            var _props2 = this.props,
	                segment = _props2.segment,
	                metadata = _props2.metadata,
	                question = _props2.question;
	
	            var query = question.query();
	
	            var segmentName = segment.name;
	
	            var useForCurrentQuestion = [];
	            var usefulQuestions = [];
	
	            if (query instanceof _StructuredQuery2.default && query.tableId() === segment.table_id && !_underscore2.default.findWhere(query.filters(), (_$findWhere = {}, _defineProperty(_$findWhere, 0, "SEGMENT"), _defineProperty(_$findWhere, 1, segment.id), _$findWhere))) {
	
	                useForCurrentQuestion.push(_react2.default.createElement(_UseForButton2.default, { title: "Filter by " + segmentName, onClick: this.filterBy }));
	            }
	
	            usefulQuestions.push(_react2.default.createElement(_QueryButton2.default, { icon: "number", text: "Number of " + segmentName, onClick: this.setQueryCountFilteredBy }));
	            usefulQuestions.push(_react2.default.createElement(_QueryButton2.default, { icon: "table", text: "See all " + segmentName, onClick: this.setQueryFilteredBy }));
	
	            return _react2.default.createElement(_DetailPane2.default, {
	                name: segmentName,
	                description: segment.description,
	                useForCurrentQuestion: useForCurrentQuestion,
	                usefulQuestions: usefulQuestions,
	                extra: metadata && _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: "text-bold" },
	                        "Segment Definition"
	                    ),
	                    _react2.default.createElement(_QueryDefinition2.default, { object: segment, tableMetadata: metadata.tables[segment.table_id] })
	                )
	            });
	        }
	    }]);
	
	    return SegmentPane;
	}(_react.Component), _class2.propTypes = {
	    segment: _propTypes2.default.object.isRequired,
	    datasetQuery: _propTypes2.default.object,
	    fetchTableMetadata: _propTypes2.default.func.isRequired,
	    runQuestionQuery: _propTypes2.default.func.isRequired,
	    updateQuestion: _propTypes2.default.func.isRequired,
	    setCardAndRun: _propTypes2.default.func.isRequired,
	    question: _propTypes2.default.object.isRequired,
	    originalQuestion: _propTypes2.default.object.isRequired,
	    metadata: _propTypes2.default.object.isRequired
	}, _temp)) || _class);
	SegmentPane.displayName = "SegmentPane";
	exports.default = SegmentPane;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FilterList = __webpack_require__(983);
	
	var _FilterList2 = _interopRequireDefault(_FilterList);
	
	var _AggregationWidget = __webpack_require__(1005);
	
	var _AggregationWidget2 = _interopRequireDefault(_AggregationWidget);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QueryDefinition = function QueryDefinition(_ref) {
	    var className = _ref.className,
	        object = _ref.object,
	        tableMetadata = _ref.tableMetadata;
	
	    var filters = _query2.default.getFilters(object.definition);
	    return _react2.default.createElement(
	        "div",
	        { className: className, style: { pointerEvents: "none" } },
	        object.definition.aggregation && _react2.default.createElement(_AggregationWidget2.default, {
	            aggregation: object.definition.aggregation[0],
	            tableMetadata: tableMetadata
	        }),
	        filters.length > 0 && _react2.default.createElement(_FilterList2.default, {
	            filters: filters,
	            tableMetadata: tableMetadata,
	            maxDisplayValues: Infinity
	        })
	    );
	};
	
	QueryDefinition.displayName = "QueryDefinition";
	exports.default = QueryDefinition;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DetailPane = __webpack_require__(1771);
	
	var _DetailPane2 = _interopRequireDefault(_DetailPane);
	
	var _QueryButton = __webpack_require__(1766);
	
	var _QueryButton2 = _interopRequireDefault(_QueryButton);
	
	var _QueryDefinition = __webpack_require__(1774);
	
	var _QueryDefinition2 = _interopRequireDefault(_QueryDefinition);
	
	var _card = __webpack_require__(865);
	
	var _query = __webpack_require__(866);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _metadata = __webpack_require__(1110);
	
	var _metadata2 = __webpack_require__(1073);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = {
	    fetchTableMetadata: _metadata.fetchTableMetadata
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        metadata: (0, _metadata2.getMetadata)(state, props)
	    };
	};
	
	var MetricPane = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(MetricPane, _Component);
	
	    function MetricPane(props, context) {
	        _classCallCheck(this, MetricPane);
	
	        var _this = _possibleConstructorReturn(this, (MetricPane.__proto__ || Object.getPrototypeOf(MetricPane)).call(this, props, context));
	
	        _underscore2.default.bindAll(_this, "setQueryMetric");
	        return _this;
	    }
	
	    _createClass(MetricPane, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.fetchTableMetadata(this.props.metric.table_id);
	        }
	    }, {
	        key: "newCard",
	        value: function newCard() {
	            var _props = this.props,
	                metric = _props.metric,
	                metadata = _props.metadata;
	
	            var table = metadata && metadata.tables[metric.table_id];
	
	            if (table) {
	                var card = (0, _card.createCard)();
	                card.dataset_query = (0, _query.createQuery)("query", table.db_id, table.id);
	                return card;
	            } else {
	                throw new Error("Could not find the table metadata prior to creating a new question");
	            }
	        }
	    }, {
	        key: "setQueryMetric",
	        value: function setQueryMetric() {
	            var card = this.newCard();
	            card.dataset_query.query.aggregation = ["METRIC", this.props.metric.id];
	            this.props.setCardAndRun(card);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                metric = _props2.metric,
	                metadata = _props2.metadata;
	
	
	            var metricName = metric.name;
	
	            var useForCurrentQuestion = [];
	            var usefulQuestions = [];
	
	            usefulQuestions.push(_react2.default.createElement(_QueryButton2.default, { icon: "number", text: "See " + metricName, onClick: this.setQueryMetric }));
	
	            return _react2.default.createElement(_DetailPane2.default, {
	                name: metricName,
	                description: metric.description,
	                useForCurrentQuestion: useForCurrentQuestion,
	                usefulQuestions: usefulQuestions,
	                extra: metadata && _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "p",
	                        { className: "text-bold" },
	                        "Metric Definition"
	                    ),
	                    _react2.default.createElement(_QueryDefinition2.default, { object: metric, tableMetadata: metadata.tables[metric.table_id] })
	                )
	            });
	        }
	    }]);
	
	    return MetricPane;
	}(_react.Component), _class2.propTypes = {
	    metric: _propTypes2.default.object.isRequired,
	    query: _propTypes2.default.object,
	    fetchTableMetadata: _propTypes2.default.func.isRequired,
	    runQuestionQuery: _propTypes2.default.func.isRequired,
	    setDatasetQuery: _propTypes2.default.func.isRequired,
	    setCardAndRun: _propTypes2.default.func.isRequired,
	    metadata: _propTypes2.default.object
	}, _temp)) || _class);
	MetricPane.displayName = "MetricPane";
	exports.default = MetricPane;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2; /*  weak */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TagEditorParam = __webpack_require__(1777);
	
	var _TagEditorParam2 = _interopRequireDefault(_TagEditorParam);
	
	var _TagEditorHelp = __webpack_require__(1778);
	
	var _TagEditorHelp2 = _interopRequireDefault(_TagEditorHelp);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _NativeQuery = __webpack_require__(954);
	
	var _NativeQuery2 = _interopRequireDefault(_NativeQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagEditorSidebar = (_temp2 = _class = function (_Component) {
	    _inherits(TagEditorSidebar, _Component);
	
	    function TagEditorSidebar() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, TagEditorSidebar);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TagEditorSidebar.__proto__ || Object.getPrototypeOf(TagEditorSidebar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            section: "settings"
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TagEditorSidebar, [{
	        key: "setSection",
	        value: function setSection(section) {
	            this.setState({ section: section });
	            _analytics2.default.trackEvent("QueryBuilder", "Template Tag Editor Section Change", section);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var query = this.props.query;
	
	            var tags = query.templateTags();
	
	            var section = void 0;
	            if (tags.length === 0) {
	                section = "help";
	            } else {
	                section = this.state.section;
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "DataReference-container p3 full-height scroll-y" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "DataReference-header flex align-center mb2" },
	                    _react2.default.createElement(
	                        "h2",
	                        { className: "text-default" },
	                        "Variables"
	                    ),
	                    _react2.default.createElement(
	                        "a",
	                        { className: "flex-align-right text-default text-brand-hover no-decoration", onClick: function onClick() {
	                                return _this2.props.onClose();
	                            } },
	                        _react2.default.createElement(_Icon2.default, { name: "close", size: 18 })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "DataReference-content" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Button-group Button-group--brand text-uppercase mb2" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: (0, _classnames2.default)("Button Button--small", { "Button--active": section === "settings", "disabled": tags.length === 0 }), onClick: function onClick() {
	                                    return _this2.setSection("settings");
	                                } },
	                            "Settings"
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { className: (0, _classnames2.default)("Button Button--small", { "Button--active": section === "help" }), onClick: function onClick() {
	                                    return _this2.setSection("help");
	                                } },
	                            "Help"
	                        )
	                    ),
	                    section === "settings" ? _react2.default.createElement(SettingsPane, { tags: tags, onUpdate: this.props.updateTemplateTag, databaseFields: this.props.databaseFields }) : _react2.default.createElement(_TagEditorHelp2.default, { sampleDatasetId: this.props.sampleDatasetId, setDatasetQuery: this.props.setDatasetQuery })
	                )
	            );
	        }
	    }]);
	
	    return TagEditorSidebar;
	}(_react.Component), _class.propTypes = {
	    card: _propTypes2.default.object.isRequired,
	    onClose: _propTypes2.default.func.isRequired,
	    updateTemplateTag: _propTypes2.default.func.isRequired,
	    databaseFields: _propTypes2.default.array,
	    setDatasetQuery: _propTypes2.default.func.isRequired,
	    sampleDatasetId: _propTypes2.default.number
	}, _temp2);
	TagEditorSidebar.displayName = "TagEditorSidebar";
	exports.default = TagEditorSidebar;
	
	
	var SettingsPane = function SettingsPane(_ref2) {
	    var tags = _ref2.tags,
	        onUpdate = _ref2.onUpdate,
	        databaseFields = _ref2.databaseFields;
	    return _react2.default.createElement(
	        "div",
	        null,
	        tags.map(function (tag) {
	            return _react2.default.createElement(
	                "div",
	                { key: tags.name },
	                _react2.default.createElement(_TagEditorParam2.default, { tag: tag, onUpdate: onUpdate, databaseFields: databaseFields })
	            );
	        })
	    );
	};
	
	SettingsPane.displayName = "SettingsPane";
	SettingsPane.propTypes = {
	    tags: _propTypes2.default.object.isRequired,
	    onUpdate: _propTypes2.default.func.isRequired,
	    databaseFields: _propTypes2.default.array
	};

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Toggle = __webpack_require__(1241);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _ParameterValueWidget = __webpack_require__(1191);
	
	var _ParameterValueWidget2 = _interopRequireDefault(_ParameterValueWidget);
	
	var _Dashboard = __webpack_require__(1519);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Field = __webpack_require__(900);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	var TagEditorParam = function (_Component) {
	    _inherits(TagEditorParam, _Component);
	
	    function TagEditorParam() {
	        _classCallCheck(this, TagEditorParam);
	
	        return _possibleConstructorReturn(this, (TagEditorParam.__proto__ || Object.getPrototypeOf(TagEditorParam)).apply(this, arguments));
	    }
	
	    _createClass(TagEditorParam, [{
	        key: "setParameterAttribute",
	        value: function setParameterAttribute(attr, val) {
	            // only register an update if the value actually changes
	            if (this.props.tag[attr] !== val) {
	                this.props.onUpdate(_extends({}, this.props.tag, _defineProperty({}, attr, val)));
	            }
	        }
	    }, {
	        key: "setRequired",
	        value: function setRequired(required) {
	            if (this.props.tag.required !== required) {
	                this.props.onUpdate(_extends({}, this.props.tag, {
	                    required: required,
	                    default: undefined
	                }));
	            }
	        }
	    }, {
	        key: "setType",
	        value: function setType(type) {
	            if (this.props.tag.type !== type) {
	                this.props.onUpdate(_extends({}, this.props.tag, {
	                    type: type,
	                    dimension: undefined,
	                    widget_type: undefined
	                }));
	            }
	        }
	    }, {
	        key: "setDimension",
	        value: function setDimension(fieldId) {
	            var _props = this.props,
	                tag = _props.tag,
	                onUpdate = _props.onUpdate,
	                databaseFields = _props.databaseFields;
	
	            var dimension = ["field-id", fieldId];
	            if (!_underscore2.default.isEqual(tag.dimension !== dimension)) {
	                var field = _underscore2.default.findWhere(databaseFields, { id: fieldId });
	                if (!field) {
	                    return;
	                }
	                var options = (0, _Dashboard.parameterOptionsForField)(new _Field2.default(field));
	                var widget_type = void 0;
	                if (tag.widget_type && _underscore2.default.findWhere(options, { type: tag.widget_type })) {
	                    widget_type = tag.widget_type;
	                } else if (options.length > 0) {
	                    widget_type = options[0].type;
	                }
	                onUpdate(_extends({}, tag, {
	                    dimension: dimension,
	                    widget_type: widget_type
	                }));
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                tag = _props2.tag,
	                databaseFields = _props2.databaseFields;
	
	
	            var dabaseHasSchemas = false;
	            if (databaseFields) {
	                var schemas = _underscore2.default.chain(databaseFields).pluck("schema").uniq().value();
	                dabaseHasSchemas = schemas.length > 1;
	            }
	
	            var widgetOptions = void 0;
	            if (tag.type === "dimension" && Array.isArray(tag.dimension)) {
	                var field = _underscore2.default.findWhere(databaseFields, { id: tag.dimension[1] });
	                if (field) {
	                    widgetOptions = (0, _Dashboard.parameterOptionsForField)(new _Field2.default(field));
	                }
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "pb2 mb2 border-bottom border-dark" },
	                _react2.default.createElement(
	                    "h3",
	                    { className: "pb2" },
	                    tag.name
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "pb1" },
	                    _react2.default.createElement(
	                        "h5",
	                        { className: "pb1 text-normal" },
	                        "Filter label"
	                    ),
	                    _react2.default.createElement("input", {
	                        type: "text",
	                        value: tag.display_name,
	                        className: "AdminSelect p1 text-bold text-grey-4 bordered border-med rounded full",
	                        onChange: function onChange(e) {
	                            return _this2.setParameterAttribute("display_name", e.target.value);
	                        }
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "pb1" },
	                    _react2.default.createElement(
	                        "h5",
	                        { className: "pb1 text-normal" },
	                        "Variable type"
	                    ),
	                    _react2.default.createElement(
	                        _Select2.default,
	                        {
	                            className: "border-med bg-white block",
	                            value: tag.type,
	                            onChange: function onChange(e) {
	                                return _this2.setType(e.target.value);
	                            },
	                            isInitiallyOpen: !tag.type,
	                            placeholder: "Select\u2026"
	                        },
	                        _react2.default.createElement(
	                            _Select.Option,
	                            { value: "text" },
	                            "Text"
	                        ),
	                        _react2.default.createElement(
	                            _Select.Option,
	                            { value: "number" },
	                            "Number"
	                        ),
	                        _react2.default.createElement(
	                            _Select.Option,
	                            { value: "date" },
	                            "Date"
	                        ),
	                        _react2.default.createElement(
	                            _Select.Option,
	                            { value: "dimension" },
	                            "Field Filter"
	                        )
	                    )
	                ),
	                tag.type === "dimension" && _react2.default.createElement(
	                    "div",
	                    { className: "pb1" },
	                    _react2.default.createElement(
	                        "h5",
	                        { className: "pb1 text-normal" },
	                        "Field to map to"
	                    ),
	                    _react2.default.createElement(
	                        _Select2.default,
	                        {
	                            className: "border-med bg-white block",
	                            value: Array.isArray(tag.dimension) ? tag.dimension[1] : null,
	                            onChange: function onChange(e) {
	                                return _this2.setDimension(e.target.value);
	                            },
	                            searchProp: "name",
	                            searchCaseInsensitive: true,
	                            isInitiallyOpen: !tag.dimension,
	                            placeholder: "Select\u2026"
	                        },
	                        databaseFields && databaseFields.map(function (field) {
	                            return _react2.default.createElement(
	                                _Select.Option,
	                                { key: field.id, value: field.id, name: field.name },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "cursor-pointer" },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "h6 text-bold text-uppercase text-grey-2" },
	                                        dabaseHasSchemas && field.schema + " > ",
	                                        field.table_name
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "h4 text-bold text-default" },
	                                        field.name
	                                    )
	                                )
	                            );
	                        })
	                    )
	                ),
	                widgetOptions && widgetOptions.length > 0 && _react2.default.createElement(
	                    "div",
	                    { className: "pb1" },
	                    _react2.default.createElement(
	                        "h5",
	                        { className: "pb1 text-normal" },
	                        "Filter widget type"
	                    ),
	                    _react2.default.createElement(
	                        _Select2.default,
	                        {
	                            className: "border-med bg-white block",
	                            value: tag.widget_type,
	                            onChange: function onChange(e) {
	                                return _this2.setParameterAttribute("widget_type", e.target.value);
	                            },
	                            isInitiallyOpen: !tag.widget_type,
	                            placeholder: "Select\u2026"
	                        },
	                        [{ name: "None", type: undefined }].concat(widgetOptions).map(function (widgetOption) {
	                            return _react2.default.createElement(
	                                _Select.Option,
	                                { key: widgetOption.type, value: widgetOption.type },
	                                widgetOption.name
	                            );
	                        })
	                    )
	                ),
	                tag.type !== "dimension" && _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center pb1" },
	                    _react2.default.createElement(
	                        "h5",
	                        { className: "text-normal mr1" },
	                        "Required?"
	                    ),
	                    _react2.default.createElement(_Toggle2.default, { value: tag.required, onChange: function onChange(value) {
	                            return _this2.setRequired(value);
	                        } })
	                ),
	                (tag.type !== "dimension" && tag.required || tag.type === "dimension" || tag.widget_type) && _react2.default.createElement(
	                    "div",
	                    { className: "pb1" },
	                    _react2.default.createElement(
	                        "h5",
	                        { className: "pb1 text-normal" },
	                        "Default filter widget value"
	                    ),
	                    _react2.default.createElement(_ParameterValueWidget2.default, {
	                        parameter: {
	                            type: tag.widget_type || (tag.type === "date" ? "date/single" : null)
	                        },
	                        value: tag.default,
	                        setValue: function setValue(value) {
	                            return _this2.setParameterAttribute("default", value);
	                        },
	                        className: "AdminSelect p1 text-bold text-grey-4 bordered border-med rounded bg-white",
	                        isEditing: true,
	                        commitImmediately: true
	                    })
	                )
	            );
	        }
	    }]);
	
	    return TagEditorParam;
	}(_react.Component);
	
	TagEditorParam.displayName = "TagEditorParam";
	exports.default = TagEditorParam;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Code = __webpack_require__(1779);
	
	var _Code2 = _interopRequireDefault(_Code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXAMPLES = {
	    variable: {
	        database: null,
	        type: "native",
	        native: {
	            query: "SELECT count(*)\nFROM products\nWHERE category = {{category}}",
	            template_tags: {
	                "category": { name: "category", display_name: "Category", type: "text", required: true, default: "Widget" }
	            }
	        }
	
	    },
	    dimension: {
	        database: null,
	        type: "native",
	        native: {
	            query: "SELECT count(*)\nFROM products\nWHERE {{created_at}}",
	            template_tags: {
	                "created_at": { name: "created_at", display_name: "Created At", type: "dimension", dimension: null }
	            }
	        }
	    },
	    optional: {
	        database: null,
	        type: "native",
	        native: {
	            query: "SELECT count(*)\nFROM products\n[[WHERE category = {{category}}]]",
	            template_tags: {
	                "category": { name: "category", display_name: "Category", type: "text", required: false }
	            }
	        }
	    },
	    multipleOptional: {
	        database: null,
	        type: "native",
	        native: {
	            query: "SELECT count(*)\nFROM products\nWHERE 1=1\n  [[AND id = {{id}}]]\n  [[AND category = {{category}}]]",
	            template_tags: {
	                "id": { name: "id", display_name: "ID", type: "number", required: false },
	                "category": { name: "category", display_name: "Category", type: "text", required: false }
	            }
	        }
	    }
	};
	
	var TagExample = function TagExample(_ref) {
	    var datasetQuery = _ref.datasetQuery,
	        setDatasetQuery = _ref.setDatasetQuery;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "h5",
	            null,
	            "Example:"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	                _Code2.default,
	                null,
	                datasetQuery.native.query
	            ),
	            setDatasetQuery && _react2.default.createElement(
	                "div",
	                {
	                    className: "Button Button--small mt1",
	                    "data-metabase-event": "QueryBuilder;Template Tag Example Query Used",
	                    onClick: function onClick() {
	                        return setDatasetQuery(datasetQuery, true);
	                    }
	                },
	                "Try it"
	            )
	        )
	    );
	};
	
	TagExample.displayName = "TagExample";
	var TagEditorHelp = function TagEditorHelp(_ref2) {
	    var setDatasetQuery = _ref2.setDatasetQuery,
	        sampleDatasetId = _ref2.sampleDatasetId;
	
	    var setQueryWithSampleDatasetId = null;
	    if (sampleDatasetId != null) {
	        setQueryWithSampleDatasetId = function setQueryWithSampleDatasetId(dataset_query, run) {
	            setDatasetQuery(_extends({}, dataset_query, {
	                database: sampleDatasetId
	            }), run);
	        };
	    }
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "h4",
	            null,
	            "What's this for?"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Variables in native queries let you dynamically replace values in your queries using filter widgets or through the URL."
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "pt2" },
	            "Variables"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	                _Code2.default,
	                null,
	                "{{variable_name}}"
	            ),
	            " creates a variable in this SQL template called \"variable_name\". Variables can be given types in the side panel, which changes their behavior. All variable types other than \"Field Filter\" will automatically cause a filter widget to be placed on this question; with Field Filters, this is optional. When this filter widget is filled in, that value replaces the variable in the SQL template."
	        ),
	        _react2.default.createElement(TagExample, { datasetQuery: EXAMPLES.variable, setDatasetQuery: setQueryWithSampleDatasetId }),
	        _react2.default.createElement(
	            "h4",
	            { className: "pt2" },
	            "Field Filters"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "Giving a variable the \"Field Filter\" type allows you to link SQL cards to dashboard filter widgets or use more types of filter widgets on your SQL question. A Field Filter variable inserts SQL similar to that generated by the GUI query builder when adding filters on existing columns."
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "When adding a Field Filter variable, you'll need to map it to a specific field. You can then choose to display a filter widget on your question, but even if you don't, you can now map your Field Filter variable to a dashboard filter when adding this question to a dashboard. Field Filters should be used inside of a \"WHERE\" clause."
	        ),
	        _react2.default.createElement(TagExample, { datasetQuery: EXAMPLES.dimension }),
	        _react2.default.createElement(
	            "h4",
	            { className: "pt2" },
	            "Optional Clauses"
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	                _Code2.default,
	                null,
	                "[[brackets around a {{variable}}]]"
	            ),
	            " create an optional clause in the template. If \"variable\" is set, then the entire clause is placed into the template. If not, then the entire clause is ignored."
	        ),
	        _react2.default.createElement(TagExample, { datasetQuery: EXAMPLES.optional, setDatasetQuery: setQueryWithSampleDatasetId }),
	        _react2.default.createElement(
	            "p",
	            null,
	            "To use multiple optional clauses you can include at least one non-optional WHERE clause followed by optional clauses starting with \"AND\"."
	        ),
	        _react2.default.createElement(TagExample, { datasetQuery: EXAMPLES.multipleOptional, setDatasetQuery: setQueryWithSampleDatasetId }),
	        _react2.default.createElement(
	            "p",
	            { className: "pt2 link" },
	            _react2.default.createElement(
	                "a",
	                { href: "http://www.metabase.com/docs/latest/users-guide/start", target: "_blank", "data-metabase-event": "QueryBuilder;Template Tag Documentation Click" },
	                "Read the full documentation"
	            )
	        )
	    );
	};
	
	TagEditorHelp.displayName = "TagEditorHelp";
	exports.default = TagEditorHelp;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint "react/prop-types": "warn" */
	var Code = function Code(_ref) {
	    var children = _ref.children,
	        block = _ref.block;
	
	    if (block) {
	        return _react2.default.createElement(
	            "div",
	            { className: "text-code" },
	            children
	        );
	    } else if (typeof children === "string" && children.split(/\n/g).length > 1) {
	        return _react2.default.createElement(
	            "span",
	            null,
	            children.split(/\n/g).map(function (line, index) {
	                return [_react2.default.createElement(
	                    "span",
	                    { className: "text-code", style: { lineHeight: "1.8em" } },
	                    line
	                ), _react2.default.createElement("br", null)];
	            })
	        );
	    } else {
	        return _react2.default.createElement(
	            "span",
	            { className: "text-code" },
	            children
	        );
	    }
	};
	
	Code.propTypes = {
	    children: _propTypes2.default.any.isRequired,
	    block: _propTypes2.default.bool
	};
	
	exports.default = Code;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SavedQuestionIntroModal = function (_Component) {
	    _inherits(SavedQuestionIntroModal, _Component);
	
	    function SavedQuestionIntroModal() {
	        _classCallCheck(this, SavedQuestionIntroModal);
	
	        return _possibleConstructorReturn(this, (SavedQuestionIntroModal.__proto__ || Object.getPrototypeOf(SavedQuestionIntroModal)).apply(this, arguments));
	    }
	
	    _createClass(SavedQuestionIntroModal, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { small: true, isOpen: this.props.isShowingNewbModal },
	                _react2.default.createElement(
	                    "div",
	                    { className: "Modal-content Modal-content--small NewForm" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Modal-header Form-header" },
	                        _react2.default.createElement(
	                            "h2",
	                            { className: "pb2 text-dark" },
	                            "It's okay to play around with saved questions"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "pb1 text-grey-4" },
	                            "You won't make any permanent changes to a saved question unless you click the edit icon in the top-right."
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Form-actions flex justify-center py1" },
	                        _react2.default.createElement(
	                            "button",
	                            { "data-metabase-event": "QueryBuilder;IntroModal", className: "Button Button--primary", onClick: function onClick() {
	                                    return _this2.props.onClose();
	                                } },
	                            "Okay"
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SavedQuestionIntroModal;
	}(_react.Component);
	
	SavedQuestionIntroModal.displayName = "SavedQuestionIntroModal";
	exports.default = SavedQuestionIntroModal;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _OnClickOutsideWrapper = __webpack_require__(933);
	
	var _OnClickOutsideWrapper2 = _interopRequireDefault(_OnClickOutsideWrapper);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CIRCLE_SIZE = 48;
	var NEEDLE_SIZE = 20;
	var POPOVER_WIDTH = 350;
	
	var ActionsWidget = function (_Component) {
	    _inherits(ActionsWidget, _Component);
	
	    function ActionsWidget() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ActionsWidget);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActionsWidget.__proto__ || Object.getPrototypeOf(ActionsWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            iconIsVisible: false,
	            popoverIsOpen: false,
	            isClosing: false,
	            selectedActionIndex: null
	        }, _this.handleMouseMoved = function () {
	            // Don't auto-show or auto-hide the icon if popover is open
	            if (_this.state.popoverIsOpen) return;
	
	            if (!_this.state.iconIsVisible) {
	                _this.setState({ iconIsVisible: true });
	            }
	            _this.handleMouseStoppedMoving();
	        }, _this.handleMouseStoppedMoving = _underscore2.default.debounce(function () {
	            if (_this.state.iconIsVisible) {
	                _this.setState({ iconIsVisible: false });
	            }
	        }, 1000), _this.close = function () {
	            _this.setState({ isClosing: true, popoverIsOpen: false, selectedActionIndex: null });
	            // Needed because when closing the action widget by clicking compass, this is triggered first
	            // on mousedown (by OnClickOutsideWrapper) and toggle is triggered on mouseup
	            setTimeout(function () {
	                return _this.setState({ isClosing: false });
	            }, 500);
	        }, _this.toggle = function () {
	            if (_this.state.isClosing) return;
	
	            if (!_this.state.popoverIsOpen) {
	                _analytics2.default.trackEvent("Actions", "Opened Action Menu");
	            }
	            _this.setState({
	                popoverIsOpen: !_this.state.popoverIsOpen,
	                selectedActionIndex: null
	            });
	        }, _this.handleOnChangeCardAndRun = function (_ref2) {
	            var nextCard = _ref2.nextCard;
	
	            // TODO: move lineage logic to Question?
	            var previousCard = _this.props.card;
	
	            _this.props.navigateToNewCardInsideQB({ nextCard: nextCard, previousCard: previousCard });
	        }, _this.handleActionClick = function (index) {
	            var _this$props = _this.props,
	                question = _this$props.question,
	                router = _this$props.router,
	                instanceSettings = _this$props.instanceSettings;
	
	            var mode = question.mode();
	            if (mode) {
	                var action = mode.actions(instanceSettings)[index];
	                if (action && action.popover) {
	                    _this.setState({ selectedActionIndex: index });
	                } else if (action && action.question) {
	                    var nextQuestion = action.question();
	                    if (nextQuestion) {
	                        _analytics2.default.trackEvent("Actions", "Executed Action", (action.section || "") + ":" + (action.name || ""));
	                        _this.handleOnChangeCardAndRun({ nextCard: nextQuestion.card() });
	                    }
	                    _this.close();
	                } else if (action && action.url) {
	                    router.push(action.url());
	                }
	            } else {
	                console.warn("handleActionClick: Question mode is missing");
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ActionsWidget, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            window.addEventListener("mousemove", this.handleMouseMoved, false);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            window.removeEventListener("mousemove", this.handleMouseMoved, false);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                question = _props.question,
	                instanceSettings = _props.instanceSettings;
	            var _state = this.state,
	                popoverIsOpen = _state.popoverIsOpen,
	                iconIsVisible = _state.iconIsVisible,
	                selectedActionIndex = _state.selectedActionIndex;
	
	
	            var mode = question.mode();
	            var actions = mode ? mode.actions(instanceSettings) : [];
	            if (actions.length === 0) {
	                return null;
	            }
	
	            var selectedAction = selectedActionIndex == null ? null : actions[selectedActionIndex];
	            var PopoverComponent = selectedAction && selectedAction.popover;
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(className, "relative") },
	                _react2.default.createElement(
	                    "div",
	                    {
	                        className: "circular bg-brand flex layout-centered m3 cursor-pointer",
	                        style: {
	                            width: CIRCLE_SIZE,
	                            height: CIRCLE_SIZE,
	                            transition: "opacity 300ms ease-in-out",
	                            opacity: popoverIsOpen || iconIsVisible ? 1 : 0,
	                            boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)"
	                        },
	                        onClick: this.toggle
	                    },
	                    _react2.default.createElement(_Icon2.default, {
	                        name: "compass_needle",
	                        className: "text-white",
	                        style: {
	                            transition: "transform 500ms ease-in-out",
	                            transform: popoverIsOpen ? "rotate(0deg)" : "rotate(720deg)"
	                        },
	                        size: NEEDLE_SIZE
	                    })
	                ),
	                popoverIsOpen && _react2.default.createElement(
	                    _OnClickOutsideWrapper2.default,
	                    { handleDismissal: function handleDismissal() {
	                            _analytics2.default.trackEvent("Actions", "Dismissed Action Menu");
	                            _this2.close();
	                        } },
	                    _react2.default.createElement(
	                        "div",
	                        {
	                            className: "absolute bg-white rounded bordered shadowed py1",
	                            style: {
	                                width: POPOVER_WIDTH,
	                                bottom: "50%",
	                                right: "50%",
	                                zIndex: -1,
	                                maxHeight: "600px",
	                                overflow: "scroll"
	                            }
	                        },
	                        PopoverComponent ? _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(
	                                "div",
	                                {
	                                    className: "flex align-center text-grey-4 p1 px2"
	                                },
	                                _react2.default.createElement(_Icon2.default, {
	                                    name: "chevronleft",
	                                    className: "cursor-pointer",
	                                    onClick: function onClick() {
	                                        return _this2.setState({
	                                            selectedActionIndex: null
	                                        });
	                                    }
	                                }),
	                                _react2.default.createElement(
	                                    "div",
	                                    {
	                                        className: "text-centered flex-full"
	                                    },
	                                    selectedAction && selectedAction.title
	                                )
	                            ),
	                            _react2.default.createElement(PopoverComponent, {
	                                onChangeCardAndRun: function onChangeCardAndRun(_ref3) {
	                                    var nextCard = _ref3.nextCard;
	
	                                    if (nextCard) {
	                                        if (selectedAction) {
	                                            _analytics2.default.trackEvent("Actions", "Executed Action", (selectedAction.section || "") + ":" + (selectedAction.name || ""));
	                                        }
	                                        _this2.handleOnChangeCardAndRun({ nextCard: nextCard });
	                                    }
	                                },
	                                onClose: this.close
	                            })
	                        ) : actions.map(function (action, index) {
	                            return _react2.default.createElement(
	                                "div",
	                                {
	                                    key: index,
	                                    className: "p2 flex align-center text-grey-4 brand-hover cursor-pointer",
	                                    onClick: function onClick() {
	                                        return _this2.handleActionClick(index);
	                                    }
	                                },
	                                action.icon && _react2.default.createElement(_Icon2.default, {
	                                    name: action.icon,
	                                    className: "mr1 flex-no-shrink",
	                                    size: 16
	                                }),
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    action.title
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ActionsWidget;
	}(_react.Component);
	
	ActionsWidget.displayName = "ActionsWidget";
	exports.default = ActionsWidget;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Setup = __webpack_require__(1783);
	
	var _Setup2 = _interopRequireDefault(_Setup);
	
	var _selectors = __webpack_require__(1794);
	
	var _actions = __webpack_require__(1795);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = _selectors.setupSelectors;
	
	var mapDispatchToProps = {
	    setUserDetails: _actions.setUserDetails,
	    validatePassword: _actions.validatePassword,
	    setActiveStep: _actions.setActiveStep,
	    validateDatabase: _actions.validateDatabase,
	    setDatabaseDetails: _actions.setDatabaseDetails,
	    setAllowTracking: _actions.setAllowTracking,
	    submitSetup: _actions.submitSetup
	};
	
	var SetupApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(SetupApp, _Component);
	
	    function SetupApp() {
	        _classCallCheck(this, SetupApp);
	
	        return _possibleConstructorReturn(this, (SetupApp.__proto__ || Object.getPrototypeOf(SetupApp)).apply(this, arguments));
	    }
	
	    _createClass(SetupApp, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_Setup2.default, this.props);
	        }
	    }]);
	
	    return SetupApp;
	}(_react.Component)) || _class);
	SetupApp.displayName = "SetupApp";
	exports.default = SetupApp;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _LogoIcon = __webpack_require__(1205);
	
	var _LogoIcon2 = _interopRequireDefault(_LogoIcon);
	
	var _NewsletterForm = __webpack_require__(1784);
	
	var _NewsletterForm2 = _interopRequireDefault(_NewsletterForm);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _UserStep = __webpack_require__(1785);
	
	var _UserStep2 = _interopRequireDefault(_UserStep);
	
	var _DatabaseConnectionStep = __webpack_require__(1788);
	
	var _DatabaseConnectionStep2 = _interopRequireDefault(_DatabaseConnectionStep);
	
	var _PreferencesStep = __webpack_require__(1791);
	
	var _PreferencesStep2 = _interopRequireDefault(_PreferencesStep);
	
	var _DatabaseSchedulingStep = __webpack_require__(1792);
	
	var _DatabaseSchedulingStep2 = _interopRequireDefault(_DatabaseSchedulingStep);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WELCOME_STEP_NUMBER = 0;
	var USER_STEP_NUMBER = 1;
	var DATABASE_CONNECTION_STEP_NUMBER = 2;
	var DATABASE_SCHEDULING_STEP_NUMBER = 3;
	var PREFERENCES_STEP_NUMBER = 4;
	
	var Setup = (_temp = _class = function (_Component) {
	    _inherits(Setup, _Component);
	
	    function Setup() {
	        _classCallCheck(this, Setup);
	
	        return _possibleConstructorReturn(this, (Setup.__proto__ || Object.getPrototypeOf(Setup)).apply(this, arguments));
	    }
	
	    _createClass(Setup, [{
	        key: "completeWelcome",
	        value: function completeWelcome() {
	            this.props.setActiveStep(USER_STEP_NUMBER);
	            _analytics2.default.trackEvent('Setup', 'Welcome');
	        }
	    }, {
	        key: "completeSetup",
	        value: function completeSetup() {
	            _analytics2.default.trackEvent('Setup', 'Complete');
	        }
	    }, {
	        key: "renderFooter",
	        value: function renderFooter() {
	            var _MetabaseSettings$get = _settings2.default.get('version'),
	                tag = _MetabaseSettings$get.tag;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "SetupHelp bordered border-dashed p2 rounded mb4" },
	                "If you feel stuck, ",
	                _react2.default.createElement(
	                    "a",
	                    { className: "link", href: "http://www.metabase.com/docs/" + tag + "/setting-up-metabase", target: "_blank" },
	                    "our getting started guide"
	                ),
	                " is just a click away."
	            );
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            // If we are entering the scheduling step, we need to scroll to the top of scheduling step container
	            if (this.props.activeStep !== nextProps.activeStep && nextProps.activeStep === 3) {
	                setTimeout(function () {
	                    if (_this2.refs.databaseSchedulingStepContainer) {
	                        var node = _reactDom2.default.findDOMNode(_this2.refs.databaseSchedulingStepContainer);
	                        node && node.scrollIntoView && node.scrollIntoView();
	                    }
	                }, 10);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                activeStep = _props.activeStep,
	                setupComplete = _props.setupComplete,
	                databaseDetails = _props.databaseDetails,
	                userDetails = _props.userDetails;
	
	
	            if (activeStep === WELCOME_STEP_NUMBER) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "relative full-height flex flex-full layout-centered" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wrapper wrapper--trim text-centered" },
	                        _react2.default.createElement(_LogoIcon2.default, { className: "text-brand mb4", width: 89, height: 118 }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "relative z2 text-centered ml-auto mr-auto", style: { maxWidth: 550 } },
	                            _react2.default.createElement(
	                                "h1",
	                                { style: { fontSize: '2.2rem' }, className: "text-brand" },
	                                "Welcome to Metabase"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-body" },
	                                "Looks like everything is working. Now let\u2019s get to know you, connect to your data, and start finding you some answers!"
	                            ),
	                            _react2.default.createElement(
	                                "button",
	                                { className: "Button Button--primary mt4", onClick: function onClick() {
	                                        return _this3.completeWelcome();
	                                    } },
	                                "Let's get started"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "absolute z1 bottom left right" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "inline-block" },
	                                this.renderFooter()
	                            )
	                        )
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "nav",
	                        { className: "SetupNav text-brand py2 flex layout-centered" },
	                        _react2.default.createElement(_LogoIcon2.default, { width: 41, height: 51 })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wrapper wrapper--small" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "SetupSteps full" },
	                            _react2.default.createElement(_UserStep2.default, _extends({}, this.props, { stepNumber: USER_STEP_NUMBER })),
	                            _react2.default.createElement(_DatabaseConnectionStep2.default, _extends({}, this.props, { stepNumber: DATABASE_CONNECTION_STEP_NUMBER })),
	                            _react2.default.createElement(
	                                "div",
	                                { ref: "databaseSchedulingStepContainer" },
	                                databaseDetails && databaseDetails.details && databaseDetails.details["let-user-control-scheduling"] && _react2.default.createElement(_DatabaseSchedulingStep2.default, _extends({}, this.props, { stepNumber: DATABASE_SCHEDULING_STEP_NUMBER }))
	                            ),
	                            _react2.default.createElement(_PreferencesStep2.default, _extends({}, this.props, { stepNumber: PREFERENCES_STEP_NUMBER })),
	                            setupComplete ? _react2.default.createElement(
	                                "section",
	                                { className: "SetupStep rounded SetupStep--active flex flex-column layout-centered p4" },
	                                _react2.default.createElement(
	                                    "h1",
	                                    { style: { fontSize: "xx-large" }, className: "text-light pt2 pb2" },
	                                    "You're all set up!"
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "pt4" },
	                                    _react2.default.createElement(_NewsletterForm2.default, { initialEmail: userDetails && userDetails.email })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "pt4 pb2" },
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: "/?new", className: "Button Button--primary", onClick: this.completeSetup.bind(this) },
	                                        "Take me to Metabase"
	                                    )
	                                )
	                            ) : null,
	                            _react2.default.createElement(
	                                "div",
	                                { className: "text-centered" },
	                                this.renderFooter()
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return Setup;
	}(_react.Component), _class.propTypes = {
	    activeStep: _propTypes2.default.number.isRequired,
	    setupComplete: _propTypes2.default.bool.isRequired,
	    userDetails: _propTypes2.default.object,
	    setActiveStep: _propTypes2.default.func.isRequired,
	    databaseDetails: _propTypes2.default.object.isRequired
	}, _temp);
	Setup.displayName = "Setup";
	exports.default = Setup;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsletterForm = (_temp = _class = function (_Component) {
	    _inherits(NewsletterForm, _Component);
	
	    function NewsletterForm(props, context) {
	        _classCallCheck(this, NewsletterForm);
	
	        var _this = _possibleConstructorReturn(this, (NewsletterForm.__proto__ || Object.getPrototypeOf(NewsletterForm)).call(this, props, context));
	
	        _this.state = { submitted: false };
	
	        _this.styles = {
	            container: {
	                borderWidth: "2px"
	            },
	
	            input: {
	                fontSize: '1.1rem',
	                color: '#676C72',
	                width: "350px"
	            },
	
	            label: {
	                top: "-12px"
	            }
	        };
	        return _this;
	    }
	
	    _createClass(NewsletterForm, [{
	        key: "subscribeUser",
	        value: function subscribeUser(e) {
	            e.preventDefault();
	
	            var formData = new FormData();
	            formData.append("EMAIL", _reactDom2.default.findDOMNode(this.refs.email).value);
	            formData.append("b_869fec0e4689e8fd1db91e795_b9664113a8", "");
	
	            var req = new XMLHttpRequest();
	            req.open("POST", "https://metabase.us10.list-manage.com/subscribe/post?u=869fec0e4689e8fd1db91e795&id=b9664113a8");
	            req.send(formData);
	
	            this.setState({ submitted: true });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var initialEmail = this.props.initialEmail;
	            var submitted = this.state.submitted;
	
	
	            return _react2.default.createElement(
	                "div",
	                { style: this.styles.container, className: "bordered rounded p4 relative" },
	                _react2.default.createElement(
	                    "div",
	                    { style: this.styles.label, className: "absolute text-centered left right" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "px3 bg-white h5 text-bold text-grey-4 text-uppercase inline-block" },
	                        _react2.default.createElement(_Icon2.default, { className: "mr1 float-left", name: "mail", size: 16 }),
	                        _react2.default.createElement(
	                            "span",
	                            { className: "inline-block", style: { marginTop: 1 } },
	                            "Metabase Newsletter"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "MB-Newsletter sm-float-right" },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { style: { color: "#878E95" }, className: "text-grey-4 text-strong h3 pb3" },
	                            "Get infrequent emails about new releases and feature updates."
	                        ),
	                        _react2.default.createElement(
	                            "form",
	                            { onSubmit: this.subscribeUser.bind(this), noValidate: true },
	                            _react2.default.createElement(
	                                "div",
	                                null,
	                                !submitted ? _react2.default.createElement(
	                                    "div",
	                                    { className: "" },
	                                    _react2.default.createElement("input", { ref: "email", style: this.styles.input, className: "AdminInput bordered rounded h3 inline-block", type: "email", defaultValue: initialEmail, placeholder: "Email address" }),
	                                    _react2.default.createElement("input", { className: "Button float-right inline-block ml1", type: "submit", value: "Subscribe", name: "subscribe" })
	                                ) : _react2.default.createElement(
	                                    "div",
	                                    { className: "text-success text-centered text-bold h3 p1" },
	                                    _react2.default.createElement(_Icon2.default, { className: "mr2", name: "check", size: 16 }),
	                                    "You're subscribed.  Thanks for using Metabase!"
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NewsletterForm;
	}(_react.Component), _class.propTypes = {
	    initialEmail: _propTypes2.default.string.isRequired
	}, _temp);
	NewsletterForm.displayName = "NewsletterForm";
	exports.default = NewsletterForm;

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FormField = __webpack_require__(1571);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormLabel = __webpack_require__(1572);
	
	var _FormLabel2 = _interopRequireDefault(_FormLabel);
	
	var _FormMessage = __webpack_require__(1573);
	
	var _FormMessage2 = _interopRequireDefault(_FormMessage);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _StepTitle = __webpack_require__(1786);
	
	var _StepTitle2 = _interopRequireDefault(_StepTitle);
	
	var _CollapsedStep = __webpack_require__(1787);
	
	var _CollapsedStep2 = _interopRequireDefault(_CollapsedStep);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserStep = (_temp = _class = function (_Component) {
	    _inherits(UserStep, _Component);
	
	    function UserStep(props, context) {
	        var _this2 = this;
	
	        _classCallCheck(this, UserStep);
	
	        var _this = _possibleConstructorReturn(this, (UserStep.__proto__ || Object.getPrototypeOf(UserStep)).call(this, props, context));
	
	        _this.validateForm = function () {
	            var _this$state = _this.state,
	                fieldValues = _this$state.fieldValues,
	                valid = _this$state.valid,
	                validPassword = _this$state.validPassword;
	
	            var isValid = true;
	
	            // required: first_name, last_name, email, password
	            Object.keys(fieldValues).forEach(function (fieldName) {
	                if (_utils2.default.isEmpty(fieldValues[fieldName])) isValid = false;
	            });
	
	            if (!validPassword) {
	                isValid = false;
	            }
	
	            if (isValid !== valid) {
	                _this.setState({
	                    'valid': isValid
	                });
	            }
	        };
	
	        _this.onPasswordBlur = function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(e) {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return _this.props.validatePassword(_this.state.fieldValues.password);
	
	                            case 3:
	
	                                _this.setState({
	                                    passwordError: null,
	                                    validPassword: true
	                                }, _this.validateForm);
	
	                                _context.next = 10;
	                                break;
	
	                            case 6:
	                                _context.prev = 6;
	                                _context.t0 = _context["catch"](0);
	
	                                _this.setState({
	                                    passwordError: _context.t0.data.errors.password,
	                                    validPassword: false
	                                });
	
	                                _analytics2.default.trackEvent('Setup', 'Error', 'password validation');
	
	                            case 10:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2, [[0, 6]]);
	            }));
	
	            return function (_x) {
	                return _ref.apply(this, arguments);
	            };
	        }();
	
	        _this.formSubmitted = function (e) {
	            var fieldValues = _this.state.fieldValues;
	
	
	            e.preventDefault();
	
	            _this.setState({
	                formError: null
	            });
	
	            var formErrors = { data: { errors: {} } };
	
	            // validate email address
	            if (!_utils2.default.validEmail(fieldValues.email)) {
	                formErrors.data.errors.email = "Not a valid formatted email address";
	            }
	
	            // TODO - validate password complexity
	
	            // validate password match
	            if (fieldValues.password !== fieldValues.password_confirm) {
	                formErrors.data.errors.password_confirm = "Passwords do not match";
	            }
	
	            if (_underscore2.default.keys(formErrors.data.errors).length > 0) {
	                _this.setState({
	                    formError: formErrors
	                });
	                return;
	            }
	
	            _this.props.setUserDetails({
	                'nextStep': _this.props.stepNumber + 1,
	                'details': _underscore2.default.omit(fieldValues, "password_confirm")
	            });
	
	            _analytics2.default.trackEvent('Setup', 'User Details Step');
	        };
	
	        _this.updateFieldValue = function (fieldName, value) {
	            _this.setState({
	                fieldValues: _extends({}, _this.state.fieldValues, _defineProperty({}, fieldName, value))
	            }, _this.validateForm);
	        };
	
	        _this.onFirstNameChange = function (e) {
	            return _this.updateFieldValue("first_name", e.target.value);
	        };
	
	        _this.onLastNameChange = function (e) {
	            return _this.updateFieldValue("last_name", e.target.value);
	        };
	
	        _this.onEmailChange = function (e) {
	            return _this.updateFieldValue("email", e.target.value);
	        };
	
	        _this.onPasswordChange = function (e) {
	            return _this.updateFieldValue("password", e.target.value);
	        };
	
	        _this.onPasswordConfirmChange = function (e) {
	            return _this.updateFieldValue("password_confirm", e.target.value);
	        };
	
	        _this.onSiteNameChange = function (e) {
	            return _this.updateFieldValue("site_name", e.target.value);
	        };
	
	        _this.state = {
	            fieldValues: _this.props.userDetails || {
	                first_name: "",
	                last_name: "",
	                email: "",
	                password: "",
	                site_name: ""
	            },
	            formError: null,
	            passwordError: null,
	            valid: false,
	            validPassword: false
	        };
	        return _this;
	    }
	
	    _createClass(UserStep, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                activeStep = _props.activeStep,
	                setActiveStep = _props.setActiveStep,
	                stepNumber = _props.stepNumber,
	                userDetails = _props.userDetails;
	            var _state = this.state,
	                formError = _state.formError,
	                passwordError = _state.passwordError,
	                valid = _state.valid;
	
	
	            var passwordComplexityDesc = _settings2.default.passwordComplexity();
	            var stepText = activeStep <= stepNumber ? 'What should we call you?' : 'Hi, ' + userDetails.first_name + '. nice to meet you!';
	
	            if (activeStep !== stepNumber) {
	                return _react2.default.createElement(_CollapsedStep2.default, { stepNumber: stepNumber, stepCircleText: "1", stepText: stepText, isCompleted: activeStep > stepNumber, setActiveStep: setActiveStep });
	            } else {
	                return _react2.default.createElement(
	                    "section",
	                    { className: "SetupStep SetupStep--active rounded full relative" },
	                    _react2.default.createElement(_StepTitle2.default, { title: stepText, circleText: "1" }),
	                    _react2.default.createElement(
	                        "form",
	                        { name: "userForm", onSubmit: this.formSubmitted, noValidate: true, className: "mt2" },
	                        _react2.default.createElement(
	                            _FormField2.default,
	                            { className: "Grid mb3", fieldName: "first_name", formError: formError },
	                            _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(_FormLabel2.default, { title: "First name", fieldName: "first_name", formError: formError }),
	                                _react2.default.createElement("input", { className: "Form-input Form-offset full", name: "first_name", defaultValue: userDetails ? userDetails.first_name : "", placeholder: "Johnny", required: true, autoFocus: true, onChange: this.onFirstNameChange }),
	                                _react2.default.createElement("span", { className: "Form-charm" })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                null,
	                                _react2.default.createElement(_FormLabel2.default, { title: "Last name", fieldName: "last_name", formError: formError }),
	                                _react2.default.createElement("input", { className: "Form-input Form-offset", name: "last_name", defaultValue: userDetails ? userDetails.last_name : "", placeholder: "Appleseed", required: true, onChange: this.onLastNameChange }),
	                                _react2.default.createElement("span", { className: "Form-charm" })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _FormField2.default,
	                            { fieldName: "email", formError: formError },
	                            _react2.default.createElement(_FormLabel2.default, { title: "Email address", fieldName: "email", formError: formError }),
	                            _react2.default.createElement("input", { className: "Form-input Form-offset full", name: "email", defaultValue: userDetails ? userDetails.email : "", placeholder: "youlooknicetoday@email.com", required: true, onChange: this.onEmailChange }),
	                            _react2.default.createElement("span", { className: "Form-charm" })
	                        ),
	                        _react2.default.createElement(
	                            _FormField2.default,
	                            { fieldName: "password", formError: formError, error: passwordError !== null },
	                            _react2.default.createElement(_FormLabel2.default, { title: "Create a password", fieldName: "password", formError: formError, message: passwordError }),
	                            _react2.default.createElement(
	                                "span",
	                                { style: { fontWeight: "normal" }, className: "Form-label Form-offset" },
	                                passwordComplexityDesc
	                            ),
	                            _react2.default.createElement("input", { className: "Form-input Form-offset full", name: "password", type: "password", defaultValue: userDetails ? userDetails.password : "", placeholder: "Shhh...", required: true, onChange: this.onPasswordChange, onBlur: this.onPasswordBlur }),
	                            _react2.default.createElement("span", { className: "Form-charm" })
	                        ),
	                        _react2.default.createElement(
	                            _FormField2.default,
	                            { fieldName: "password_confirm", formError: formError },
	                            _react2.default.createElement(_FormLabel2.default, { title: "Confirm password", fieldName: "password_confirm", formError: formError }),
	                            _react2.default.createElement("input", { className: "Form-input Form-offset full", name: "password_confirm", type: "password", defaultValue: userDetails ? userDetails.password : "", placeholder: "Shhh... but one more time so we get it right", required: true, onChange: this.onPasswordConfirmChange }),
	                            _react2.default.createElement("span", { className: "Form-charm" })
	                        ),
	                        _react2.default.createElement(
	                            _FormField2.default,
	                            { fieldName: "site_name", formError: formError },
	                            _react2.default.createElement(_FormLabel2.default, { title: "Your company or team name", fieldName: "site_name", formError: formError }),
	                            _react2.default.createElement("input", { className: "Form-input Form-offset full", name: "site_name", type: "text", defaultValue: userDetails ? userDetails.site_name : "", placeholder: "Department of awesome", required: true, onChange: this.onSiteNameChange }),
	                            _react2.default.createElement("span", { className: "Form-charm" })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Form-actions" },
	                            _react2.default.createElement(
	                                "button",
	                                { className: (0, _classnames2.default)("Button", { "Button--primary": valid }), disabled: !valid },
	                                "Next"
	                            ),
	                            _react2.default.createElement(_FormMessage2.default, null)
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return UserStep;
	}(_react.Component), _class.propTypes = {
	    stepNumber: _propTypes2.default.number.isRequired,
	    activeStep: _propTypes2.default.number.isRequired,
	    setActiveStep: _propTypes2.default.func.isRequired,
	
	    userDetails: _propTypes2.default.object,
	    setUserDetails: _propTypes2.default.func.isRequired,
	    validatePassword: _propTypes2.default.func.isRequired
	}, _temp);
	UserStep.displayName = "UserStep";
	exports.default = UserStep;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StepTitle = (_temp = _class = function (_Component) {
	    _inherits(StepTitle, _Component);
	
	    function StepTitle() {
	        _classCallCheck(this, StepTitle);
	
	        return _possibleConstructorReturn(this, (StepTitle.__proto__ || Object.getPrototypeOf(StepTitle)).apply(this, arguments));
	    }
	
	    _createClass(StepTitle, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                circleText = _props.circleText,
	                title = _props.title;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex align-center pt3 pb1" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "SetupStep-indicator flex layout-centered absolute bordered" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "SetupStep-number" },
	                        circleText
	                    ),
	                    _react2.default.createElement(_Icon2.default, { name: 'check', className: "SetupStep-check", size: 16 })
	                ),
	                _react2.default.createElement(
	                    "h3",
	                    { style: { marginTop: 10 }, className: "SetupStep-title Form-offset" },
	                    title
	                )
	            );
	        }
	    }]);
	
	    return StepTitle;
	}(_react.Component), _class.propTypes = {
	    circleText: _propTypes2.default.string,
	    title: _propTypes2.default.string.isRequired
	}, _temp);
	StepTitle.displayName = "StepTitle";
	exports.default = StepTitle;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollapsedStep = (_temp = _class = function (_Component) {
	    _inherits(CollapsedStep, _Component);
	
	    function CollapsedStep() {
	        _classCallCheck(this, CollapsedStep);
	
	        return _possibleConstructorReturn(this, (CollapsedStep.__proto__ || Object.getPrototypeOf(CollapsedStep)).apply(this, arguments));
	    }
	
	    _createClass(CollapsedStep, [{
	        key: "gotoStep",
	        value: function gotoStep() {
	            if (this.props.isCompleted) {
	                this.props.setActiveStep(this.props.stepNumber);
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                isCompleted = _props.isCompleted,
	                stepCircleText = _props.stepCircleText,
	                stepText = _props.stepText;
	
	
	            var classes = (0, _classnames2.default)({
	                'SetupStep': true,
	                'rounded': true,
	                'full': true,
	                'relative': true,
	                'SetupStep--completed shadowed': isCompleted,
	                'SetupStep--todo': !isCompleted
	            });
	
	            return _react2.default.createElement(
	                "section",
	                { className: classes },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center py2" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "SetupStep-indicator flex layout-centered absolute bordered" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "SetupStep-number" },
	                            stepCircleText
	                        ),
	                        _react2.default.createElement(_Icon2.default, { name: 'check', className: "SetupStep-check", size: 16 })
	                    ),
	                    _react2.default.createElement(
	                        "h3",
	                        { className: "SetupStep-title ml4 my1", onClick: this.gotoStep.bind(this) },
	                        stepText
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CollapsedStep;
	}(_react.Component), _class.propTypes = {
	    stepNumber: _propTypes2.default.number.isRequired,
	    stepCircleText: _propTypes2.default.string.isRequired,
	    stepText: _propTypes2.default.string.isRequired,
	    setActiveStep: _propTypes2.default.func.isRequired,
	    isCompleted: _propTypes2.default.bool.isRequired
	}, _temp);
	CollapsedStep.displayName = "CollapsedStep";
	exports.default = CollapsedStep;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StepTitle = __webpack_require__(1786);
	
	var _StepTitle2 = _interopRequireDefault(_StepTitle);
	
	var _CollapsedStep = __webpack_require__(1787);
	
	var _CollapsedStep2 = _interopRequireDefault(_CollapsedStep);
	
	var _DatabaseDetailsForm = __webpack_require__(1789);
	
	var _DatabaseDetailsForm2 = _interopRequireDefault(_DatabaseDetailsForm);
	
	var _FormField = __webpack_require__(1571);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _database = __webpack_require__(1790);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatabaseConnectionStep = (_temp = _class = function (_Component) {
	    _inherits(DatabaseConnectionStep, _Component);
	
	    function DatabaseConnectionStep(props, context) {
	        var _this2 = this;
	
	        _classCallCheck(this, DatabaseConnectionStep);
	
	        var _this = _possibleConstructorReturn(this, (DatabaseConnectionStep.__proto__ || Object.getPrototypeOf(DatabaseConnectionStep)).call(this, props, context));
	
	        _this.chooseDatabaseEngine = function (e) {
	            var engine = e.target.value;
	
	            _this.setState({
	                'engine': engine
	            });
	
	            _analytics2.default.trackEvent('Setup', 'Choose Database', engine);
	        };
	
	        _this.connectionDetailsCaptured = function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(database) {
	                var formError;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _this.setState({
	                                    'formError': null
	                                });
	
	                                // make sure that we are trying ssl db connections to start with
	                                database.details.ssl = true;
	
	                                _context.prev = 2;
	                                _context.next = 5;
	                                return _this.props.validateDatabase(database);
	
	                            case 5:
	                                _context.next = 24;
	                                break;
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context["catch"](2);
	                                formError = _context.t0;
	
	                                database.details.ssl = false;
	
	                                _context.prev = 11;
	                                _context.next = 14;
	                                return _this.props.validateDatabase(database);
	
	                            case 14:
	
	                                formError = null;
	
	                                _context.next = 20;
	                                break;
	
	                            case 17:
	                                _context.prev = 17;
	                                _context.t1 = _context["catch"](11);
	
	                                formError = _context.t1;
	
	                            case 20:
	                                if (!formError) {
	                                    _context.next = 24;
	                                    break;
	                                }
	
	                                _analytics2.default.trackEvent('Setup', 'Error', 'database validation: ' + _this.state.engine);
	
	                                _this.setState({
	                                    'formError': formError
	                                });
	
	                                return _context.abrupt("return");
	
	                            case 24:
	
	                                if (database.details["let-user-control-scheduling"]) {
	                                    // Show the scheduling step if user has chosen to control scheduling manually
	                                    // Add the default schedules because DatabaseSchedulingForm requires them and update the db state
	                                    _this.props.setDatabaseDetails({
	                                        'nextStep': _this.props.stepNumber + 1,
	                                        'details': _extends({}, database, {
	                                            is_full_sync: true,
	                                            schedules: _database.DEFAULT_SCHEDULES
	                                        })
	                                    });
	                                } else {
	                                    // now that they are good, store them
	                                    _this.props.setDatabaseDetails({
	                                        // skip the scheduling step
	                                        'nextStep': _this.props.stepNumber + 2,
	                                        'details': database
	                                    });
	
	                                    _analytics2.default.trackEvent('Setup', 'Database Step', _this.state.engine);
	                                }
	
	                            case 25:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2, [[2, 7], [11, 17]]);
	            }));
	
	            return function (_x) {
	                return _ref.apply(this, arguments);
	            };
	        }();
	
	        _this.state = { 'engine': "", 'formError': null };
	        return _this;
	    }
	
	    _createClass(DatabaseConnectionStep, [{
	        key: "skipDatabase",
	        value: function skipDatabase() {
	            this.setState({
	                'engine': ""
	            });
	
	            this.props.setDatabaseDetails({
	                'nextStep': this.props.stepNumber + 2,
	                'details': null
	            });
	
	            _analytics2.default.trackEvent('Setup', 'Database Step');
	        }
	    }, {
	        key: "renderEngineSelect",
	        value: function renderEngineSelect() {
	            var engines = _settings2.default.get('engines');
	            var engine = this.state.engine,
	                engineNames = _underscore2.default.keys(engines).sort();
	
	
	            return _react2.default.createElement(
	                "label",
	                { className: "Select Form-offset mt1" },
	                _react2.default.createElement(
	                    "select",
	                    { defaultValue: engine, onChange: this.chooseDatabaseEngine },
	                    _react2.default.createElement(
	                        "option",
	                        { value: "" },
	                        "Select the type of Database you use"
	                    ),
	                    engineNames.map(function (opt) {
	                        return _react2.default.createElement(
	                            "option",
	                            { key: opt, value: opt },
	                            engines[opt]['driver-name']
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                activeStep = _props.activeStep,
	                databaseDetails = _props.databaseDetails,
	                setActiveStep = _props.setActiveStep,
	                stepNumber = _props.stepNumber;
	            var _state = this.state,
	                engine = _state.engine,
	                formError = _state.formError;
	
	            var engines = _settings2.default.get('engines');
	
	            var stepText = 'Add your data';
	            if (activeStep > stepNumber) {
	                stepText = databaseDetails === null ? "I'll add my own data later" : 'Connecting to ' + databaseDetails.name;
	            }
	
	            if (activeStep !== stepNumber) {
	                return _react2.default.createElement(_CollapsedStep2.default, { stepNumber: stepNumber, stepCircleText: "2", stepText: stepText, isCompleted: activeStep > stepNumber, setActiveStep: setActiveStep });
	            } else {
	                return _react2.default.createElement(
	                    "section",
	                    { className: "SetupStep rounded full relative SetupStep--active" },
	                    _react2.default.createElement(_StepTitle2.default, { title: stepText, circleText: "2" }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "mb4" },
	                        _react2.default.createElement(
	                            "div",
	                            { style: { maxWidth: 600 }, className: "Form-field Form-offset" },
	                            "You\u2019ll need some info about your database, like the username and password.  If you don\u2019t have that right now, Metabase also comes with a sample dataset you can get started with."
	                        ),
	                        _react2.default.createElement(
	                            _FormField2.default,
	                            { fieldName: "engine" },
	                            this.renderEngineSelect()
	                        ),
	                        engine !== "" ? _react2.default.createElement(_DatabaseDetailsForm2.default, {
	                            details: databaseDetails && 'details' in databaseDetails ? _extends({}, databaseDetails.details, { name: databaseDetails.name, is_full_sync: databaseDetails.is_full_sync }) : null,
	                            engine: engine,
	                            engines: engines,
	                            formError: formError,
	                            hiddenFields: { ssl: true },
	                            submitFn: this.connectionDetailsCaptured,
	                            submitButtonText: 'Next' }) : null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Form-field Form-offset" },
	                            _react2.default.createElement(
	                                "a",
	                                { className: "link", onClick: this.skipDatabase.bind(this) },
	                                "I'll add my data later"
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return DatabaseConnectionStep;
	}(_react.Component), _class.propTypes = {
	    stepNumber: _propTypes2.default.number.isRequired,
	    activeStep: _propTypes2.default.number.isRequired,
	    setActiveStep: _propTypes2.default.func.isRequired,
	
	    databaseDetails: _propTypes2.default.object,
	    validateDatabase: _propTypes2.default.func.isRequired,
	    setDatabaseDetails: _propTypes2.default.func.isRequired
	}, _temp);
	DatabaseConnectionStep.displayName = "DatabaseConnectionStep";
	exports.default = DatabaseConnectionStep;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FormField = __webpack_require__(1571);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormLabel = __webpack_require__(1572);
	
	var _FormLabel2 = _interopRequireDefault(_FormLabel);
	
	var _FormMessage = __webpack_require__(1573);
	
	var _FormMessage2 = _interopRequireDefault(_FormMessage);
	
	var _Toggle = __webpack_require__(1241);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _recompose = __webpack_require__(1074);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO - this should be somewhere more centralized
	function isEmpty(str) {
	    return !str || 0 === str.length;
	}
	
	var AUTH_URL_PREFIXES = {
	    bigquery: 'https://accounts.google.com/o/oauth2/auth?redirect_uri=urn:ietf:wg:oauth:2.0:oob&response_type=code&scope=https://www.googleapis.com/auth/bigquery&client_id=',
	    bigquery_with_drive: 'https://accounts.google.com/o/oauth2/auth?redirect_uri=urn:ietf:wg:oauth:2.0:oob&response_type=code&scope=https://www.googleapis.com/auth/bigquery%20https://www.googleapis.com/auth/drive&client_id=',
	    googleanalytics: 'https://accounts.google.com/o/oauth2/auth?access_type=offline&redirect_uri=urn:ietf:wg:oauth:2.0:oob&response_type=code&scope=https://www.googleapis.com/auth/analytics.readonly&client_id='
	};
	
	var CREDENTIALS_URL_PREFIXES = {
	    bigquery: 'https://console.developers.google.com/apis/credentials/oauthclient?project=',
	    googleanalytics: 'https://console.developers.google.com/apis/credentials/oauthclient?project='
	};
	
	var isTunnelField = function isTunnelField(field) {
	    return (/^tunnel-/.test(field.name)
	    );
	};
	
	/**
	 * This is a form for capturing database details for a given `engine` supplied via props.
	 * The intention is to encapsulate the entire <form> with standard MB form styling and allow a callback
	 * function to receive the captured form input when the form is submitted.
	 */
	var DatabaseDetailsForm = (_temp = _class = function (_Component) {
	    _inherits(DatabaseDetailsForm, _Component);
	
	    function DatabaseDetailsForm(props, context) {
	        _classCallCheck(this, DatabaseDetailsForm);
	
	        var _this = _possibleConstructorReturn(this, (DatabaseDetailsForm.__proto__ || Object.getPrototypeOf(DatabaseDetailsForm)).call(this, props, context));
	
	        _this.state = {
	            details: props.details || {},
	            valid: false
	        };
	        return _this;
	    }
	
	    _createClass(DatabaseDetailsForm, [{
	        key: "validateForm",
	        value: function validateForm() {
	            var _props = this.props,
	                engine = _props.engine,
	                engines = _props.engines;
	            var details = this.state.details;
	
	
	            var valid = true;
	
	            // name is required
	            if (!details.name) {
	                valid = false;
	            }
	
	            // go over individual fields
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = engines[engine]['details-fields'][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var field = _step.value;
	
	                    // tunnel fields aren't required if tunnel isn't enabled
	                    if (!details["tunnel-enabled"] && isTunnelField(field)) {
	                        continue;
	                    } else if (field.required && isEmpty(details[field.name])) {
	                        valid = false;
	                        break;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            if (this.state.valid !== valid) {
	                this.setState({ valid: valid });
	            }
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (!(0, _recompose.shallowEqual)(this.props.details, nextProps.details)) {
	                this.setState({ details: nextProps.details });
	            }
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.validateForm();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this.validateForm();
	        }
	    }, {
	        key: "onChange",
	        value: function onChange(fieldName, fieldValue) {
	            this.setState({ details: _extends({}, this.state.details, _defineProperty({}, fieldName, fieldValue)) });
	        }
	    }, {
	        key: "formSubmitted",
	        value: function formSubmitted(e) {
	            e.preventDefault();
	
	            var _props2 = this.props,
	                engine = _props2.engine,
	                engines = _props2.engines,
	                submitFn = _props2.submitFn;
	            var details = this.state.details;
	
	
	            var request = {
	                engine: engine,
	                name: details.name,
	                details: {},
	                // use the existing is_full_sync setting in case that "let user control scheduling" setting is enabled
	                is_full_sync: details.is_full_sync
	            };
	
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = engines[engine]['details-fields'][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var field = _step2.value;
	
	                    var val = details[field.name] === "" ? null : details[field.name];
	
	                    if (val && field.type === 'integer') val = parseInt(val);
	                    if (val == null && field.default) val = field.default;
	
	                    request.details[field.name] = val;
	                }
	
	                // NOTE Atte Keinänen 8/15/17: Is it a little hacky approach or not to add to the `details` field property
	                // that are not part of the details schema of current db engine?
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            request.details["let-user-control-scheduling"] = details["let-user-control-scheduling"];
	
	            submitFn(request);
	        }
	    }, {
	        key: "renderFieldInput",
	        value: function renderFieldInput(field, fieldIndex) {
	            var _this2 = this;
	
	            var details = this.state.details;
	
	            var value = details && details[field.name] || "";
	
	            switch (field.type) {
	                case 'boolean':
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "Form-input Form-offset full Button-group" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: (0, _classnames2.default)('Button', details[field.name] === true ? 'Button--active' : null), onClick: function onClick(e) {
	                                    _this2.onChange(field.name, true);
	                                } },
	                            "Yes"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: (0, _classnames2.default)('Button', details[field.name] === false ? 'Button--danger' : null), onClick: function onClick(e) {
	                                    _this2.onChange(field.name, false);
	                                } },
	                            "No"
	                        )
	                    );
	                default:
	                    return _react2.default.createElement("input", {
	                        type: field.type === 'password' ? 'password' : 'text',
	                        className: "Form-input Form-offset full",
	                        ref: field.name,
	                        name: field.name,
	                        value: value,
	                        placeholder: field.default || field.placeholder,
	                        onChange: function onChange(e) {
	                            return _this2.onChange(field.name, e.target.value);
	                        },
	                        required: field.required,
	                        autoFocus: fieldIndex === 0
	                    });
	            }
	        }
	    }, {
	        key: "renderField",
	        value: function renderField(field, fieldIndex) {
	            var _this3 = this;
	
	            var engine = this.props.engine;
	
	            window.ENGINE = engine;
	
	            if (field.name === "tunnel-enabled") {
	                var on = this.state.details["tunnel-enabled"] == undefined ? false : this.state.details["tunnel-enabled"];
	                return _react2.default.createElement(
	                    _FormField2.default,
	                    { key: field.name, fieldName: field.name },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center Form-offset" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Grid-cell--top" },
	                            _react2.default.createElement(_Toggle2.default, { value: on, onChange: function onChange(val) {
	                                    return _this3.onChange("tunnel-enabled", val);
	                                } })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "px2" },
	                            _react2.default.createElement(
	                                "h3",
	                                null,
	                                "Use an SSH-tunnel for database connections"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { style: { maxWidth: "40rem" }, className: "pt1" },
	                                "Some database installations can only be accessed by connecting through an SSH bastion host. This option also provides an extra layer of security when a VPN is not available. Enabling this is usually slower than a direct connection."
	                            )
	                        )
	                    )
	                );
	            } else if (isTunnelField(field) && !this.state.details["tunnel-enabled"]) {
	                // don't show tunnel fields if tunnel isn't enabled
	                return null;
	            } else if (field.name === "let-user-control-scheduling") {
	                var _on = this.state.details["let-user-control-scheduling"] == undefined ? false : this.state.details["let-user-control-scheduling"];
	                return _react2.default.createElement(
	                    _FormField2.default,
	                    { key: field.name, fieldName: field.name },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center Form-offset" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Grid-cell--top" },
	                            _react2.default.createElement(_Toggle2.default, { value: _on, onChange: function onChange(val) {
	                                    return _this3.onChange("let-user-control-scheduling", val);
	                                } })
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "px2" },
	                            _react2.default.createElement(
	                                "h3",
	                                null,
	                                "This is a large database, so let me choose when Metabase syncs and scans"
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { style: { maxWidth: "40rem" }, className: "pt1" },
	                                "By default, Metabase does a lightweight hourly sync, and an intensive daily scan of field values. If you have a large database, we recommend turning this on and reviewing when and how often the field value scans happen."
	                            )
	                        )
	                    )
	                );
	            } else if (field.name === 'client-id' && CREDENTIALS_URL_PREFIXES[engine]) {
	                var details = this.state.details;
	
	                var projectID = details && details['project-id'];
	                var credentialsURLLink;
	                // if (projectID) {
	                var credentialsURL = CREDENTIALS_URL_PREFIXES[engine] + (projectID || "");
	                credentialsURLLink = _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center Form-offset" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Grid-cell--top" },
	                        _react2.default.createElement(
	                            "a",
	                            { href: credentialsURL, target: "_blank" },
	                            "Click here"
	                        ),
	                        " to generate a Client ID and Client Secret for your project. Choose \"Other\" as the application type. Name it whatever you'd like."
	                    )
	                );
	                // }
	
	                return _react2.default.createElement(
	                    _FormField2.default,
	                    { key: "client-id", "field-name": "client-id" },
	                    _react2.default.createElement(_FormLabel2.default, { title: field['display-name'], "field-name": "client-id" }),
	                    credentialsURLLink,
	                    this.renderFieldInput(field, fieldIndex)
	                );
	            } else if (field.name === 'auth-code' && AUTH_URL_PREFIXES[engine]) {
	                var _details = this.state.details;
	
	                var clientID = _details && _details['client-id'];
	                var authURLLink;
	                if (clientID) {
	                    var authURL = AUTH_URL_PREFIXES[engine] + clientID;
	                    authURLLink = _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center Form-offset" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Grid-cell--top" },
	                            _react2.default.createElement(
	                                "a",
	                                { href: authURL, target: "_blank" },
	                                "Click here"
	                            ),
	                            " to get an auth code",
	                            engine === "bigquery" && _react2.default.createElement(
	                                "span",
	                                null,
	                                " (or ",
	                                _react2.default.createElement(
	                                    "a",
	                                    { href: AUTH_URL_PREFIXES["bigquery_with_drive"] + clientID, target: "_blank" },
	                                    "with Google Drive permissions"
	                                ),
	                                ")"
	                            )
	                        )
	                    );
	                }
	
	                return _react2.default.createElement(
	                    _FormField2.default,
	                    { key: "auth-code", "field-name": "auth-code" },
	                    _react2.default.createElement(_FormLabel2.default, { title: field['display-name'], "field-name": "auth-code" }),
	                    authURLLink,
	                    this.renderFieldInput(field, fieldIndex)
	                );
	            } else {
	                return _react2.default.createElement(
	                    _FormField2.default,
	                    { key: field.name, fieldName: field.name },
	                    _react2.default.createElement(_FormLabel2.default, { title: field['display-name'], fieldName: field.name }),
	                    this.renderFieldInput(field, fieldIndex),
	                    _react2.default.createElement("span", { className: "Form-charm" })
	                );
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var _props3 = this.props,
	                engine = _props3.engine,
	                engines = _props3.engines,
	                formError = _props3.formError,
	                formSuccess = _props3.formSuccess,
	                hiddenFields = _props3.hiddenFields,
	                submitButtonText = _props3.submitButtonText,
	                isNewDatabase = _props3.isNewDatabase,
	                submitting = _props3.submitting;
	            var _state = this.state,
	                valid = _state.valid,
	                details = _state.details;
	
	
	            var willProceedToNextDbCreationStep = isNewDatabase && details["let-user-control-scheduling"];
	
	            var fields = [{
	                name: 'name',
	                'display-name': 'Name',
	                placeholder: "How would you like to refer to this database?",
	                required: true
	            }].concat(_toConsumableArray(engines[engine]['details-fields']), [{
	                name: "let-user-control-scheduling",
	                required: true
	            }]);
	
	            hiddenFields = hiddenFields || {};
	
	            return _react2.default.createElement(
	                "form",
	                { onSubmit: this.formSubmitted.bind(this), noValidate: true },
	                _react2.default.createElement(
	                    "div",
	                    { className: "FormInputGroup pb2" },
	                    fields.filter(function (field) {
	                        return !hiddenFields[field.name];
	                    }).map(function (field, fieldIndex) {
	                        return _this4.renderField(field, fieldIndex);
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "Form-actions" },
	                    _react2.default.createElement(
	                        "button",
	                        { className: (0, _classnames2.default)("Button", { "Button--primary": valid }), disabled: !valid || submitting },
	                        submitting ? "Saving..." : willProceedToNextDbCreationStep ? "Next" : submitButtonText
	                    ),
	                    _react2.default.createElement(_FormMessage2.default, { formError: formError, formSuccess: formSuccess })
	                )
	            );
	        }
	    }]);
	
	    return DatabaseDetailsForm;
	}(_react.Component), _class.propTypes = {
	    details: _propTypes2.default.object,
	    engine: _propTypes2.default.string.isRequired,
	    engines: _propTypes2.default.object.isRequired,
	    formError: _propTypes2.default.object,
	    hiddenFields: _propTypes2.default.object,
	    isNewDatabase: _propTypes2.default.boolean,
	    submitButtonText: _propTypes2.default.string.isRequired,
	    submitFn: _propTypes2.default.func.isRequired,
	    submitting: _propTypes2.default.boolean
	}, _temp);
	DatabaseDetailsForm.displayName = "DatabaseDetailsForm";
	exports.default = DatabaseDetailsForm;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.discardSavedFieldValues = exports.rescanDatabaseFields = exports.syncDatabaseSchema = exports.deleteDatabase = exports.saveDatabase = exports.updateDatabase = exports.createDatabase = exports.proceedWithDbCreation = exports.addSampleDataset = exports.initializeDatabase = exports.fetchDatabases = exports.selectEngine = exports.reset = exports.MIGRATE_TO_NEW_SCHEDULING_SETTINGS = exports.CLEAR_FORM_STATE = exports.DELETE_DATABASE_FAILED = exports.DELETE_DATABASE_STARTED = exports.CREATE_DATABASE_FAILED = exports.VALIDATE_DATABASE_FAILED = exports.VALIDATE_DATABASE_STARTED = exports.CREATE_DATABASE_STARTED = exports.CREATE_DATABASE = exports.SET_DATABASE_CREATION_STEP = exports.UPDATE_DATABASE_FAILED = exports.UPDATE_DATABASE_STARTED = exports.UPDATE_DATABASE = exports.DISCARD_SAVED_FIELD_VALUES = exports.RESCAN_DATABASE_FIELDS = exports.SYNC_DATABASE_SCHEMA = exports.DELETE_DATABASE = exports.ADD_SAMPLE_DATASET = exports.INITIALIZE_DATABASE = exports.FETCH_DATABASES = exports.SELECT_ENGINE = exports.RESET = exports.DB_EDIT_FORM_SCHEDULING_TAB = exports.DB_EDIT_FORM_CONNECTION_TAB = exports.DEFAULT_SCHEDULES = undefined;
	
	var _handleActions, _handleActions2, _handleActions3, _handleActions5, _handleActions6;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reduxActions = __webpack_require__(658);
	
	var _redux = __webpack_require__(657);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// Default schedules for db sync and deep analysis
	var DEFAULT_SCHEDULES = exports.DEFAULT_SCHEDULES = {
	    "cache_field_values": {
	        "schedule_day": null,
	        "schedule_frame": null,
	        "schedule_hour": 0,
	        "schedule_type": "daily"
	    },
	    "metadata_sync": {
	        "schedule_day": null,
	        "schedule_frame": null,
	        "schedule_hour": null,
	        "schedule_type": "hourly"
	    }
	};
	
	var DB_EDIT_FORM_CONNECTION_TAB = exports.DB_EDIT_FORM_CONNECTION_TAB = "connection";
	var DB_EDIT_FORM_SCHEDULING_TAB = exports.DB_EDIT_FORM_SCHEDULING_TAB = "scheduling";
	
	var RESET = exports.RESET = "metabase/admin/databases/RESET";
	var SELECT_ENGINE = exports.SELECT_ENGINE = "metabase/admin/databases/SELECT_ENGINE";
	var FETCH_DATABASES = exports.FETCH_DATABASES = "metabase/admin/databases/FETCH_DATABASES";
	var INITIALIZE_DATABASE = exports.INITIALIZE_DATABASE = "metabase/admin/databases/INITIALIZE_DATABASE";
	var ADD_SAMPLE_DATASET = exports.ADD_SAMPLE_DATASET = "metabase/admin/databases/ADD_SAMPLE_DATASET";
	var DELETE_DATABASE = exports.DELETE_DATABASE = "metabase/admin/databases/DELETE_DATABASE";
	var SYNC_DATABASE_SCHEMA = exports.SYNC_DATABASE_SCHEMA = "metabase/admin/databases/SYNC_DATABASE_SCHEMA";
	var RESCAN_DATABASE_FIELDS = exports.RESCAN_DATABASE_FIELDS = "metabase/admin/databases/RESCAN_DATABASE_FIELDS";
	var DISCARD_SAVED_FIELD_VALUES = exports.DISCARD_SAVED_FIELD_VALUES = "metabase/admin/databases/DISCARD_SAVED_FIELD_VALUES";
	var UPDATE_DATABASE = exports.UPDATE_DATABASE = 'metabase/admin/databases/UPDATE_DATABASE';
	var UPDATE_DATABASE_STARTED = exports.UPDATE_DATABASE_STARTED = 'metabase/admin/databases/UPDATE_DATABASE_STARTED';
	var UPDATE_DATABASE_FAILED = exports.UPDATE_DATABASE_FAILED = 'metabase/admin/databases/UPDATE_DATABASE_FAILED';
	var SET_DATABASE_CREATION_STEP = exports.SET_DATABASE_CREATION_STEP = 'metabase/admin/databases/SET_DATABASE_CREATION_STEP';
	var CREATE_DATABASE = exports.CREATE_DATABASE = 'metabase/admin/databases/CREATE_DATABASE';
	var CREATE_DATABASE_STARTED = exports.CREATE_DATABASE_STARTED = 'metabase/admin/databases/CREATE_DATABASE_STARTED';
	var VALIDATE_DATABASE_STARTED = exports.VALIDATE_DATABASE_STARTED = 'metabase/admin/databases/VALIDATE_DATABASE_STARTED';
	var VALIDATE_DATABASE_FAILED = exports.VALIDATE_DATABASE_FAILED = 'metabase/admin/databases/VALIDATE_DATABASE_FAILED';
	var CREATE_DATABASE_FAILED = exports.CREATE_DATABASE_FAILED = 'metabase/admin/databases/CREATE_DATABASE_FAILED';
	var DELETE_DATABASE_STARTED = exports.DELETE_DATABASE_STARTED = 'metabase/admin/databases/DELETE_DATABASE_STARTED';
	var DELETE_DATABASE_FAILED = exports.DELETE_DATABASE_FAILED = "metabase/admin/databases/DELETE_DATABASE_FAILED";
	var CLEAR_FORM_STATE = exports.CLEAR_FORM_STATE = 'metabase/admin/databases/CLEAR_FORM_STATE';
	var MIGRATE_TO_NEW_SCHEDULING_SETTINGS = exports.MIGRATE_TO_NEW_SCHEDULING_SETTINGS = 'metabase/admin/databases/MIGRATE_TO_NEW_SCHEDULING_SETTINGS';
	
	var reset = exports.reset = (0, _reduxActions.createAction)(RESET);
	
	// selectEngine (uiControl)
	var selectEngine = exports.selectEngine = (0, _reduxActions.createAction)(SELECT_ENGINE);
	
	// fetchDatabases
	var fetchDatabases = exports.fetchDatabases = (0, _redux.createThunkAction)(FETCH_DATABASES, function () {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _services.MetabaseApi.db_list();
	
	                        case 3:
	                            return _context.abrupt("return", _context.sent);
	
	                        case 6:
	                            _context.prev = 6;
	                            _context.t0 = _context["catch"](0);
	
	                            console.error("error fetching databases", _context.t0);
	
	                        case 9:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[0, 6]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	// Migrates old "Enable in-depth database analysis" option to new "Let me choose when Metabase syncs and scans" option
	// Migration is run as a separate action because that makes it easy to track in tests
	var migrateDatabaseToNewSchedulingSettings = function migrateDatabaseToNewSchedulingSettings(database) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (database.details["let-user-control-scheduling"] == undefined) {
	                                dispatch.action(MIGRATE_TO_NEW_SCHEDULING_SETTINGS, _extends({}, database, {
	                                    details: _extends({}, database.details, {
	                                        // if user has enabled in-depth analysis already, we will run sync&scan in default schedule anyway
	                                        // otherwise let the user control scheduling
	                                        "let-user-control-scheduling": !database.is_full_sync
	                                    })
	                                }));
	                            } else {
	                                console.log(MIGRATE_TO_NEW_SCHEDULING_SETTINGS + " is no-op as scheduling settings are already set");
	                            }
	
	                        case 1:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	};
	
	// initializeDatabase
	var initializeDatabase = exports.initializeDatabase = function initializeDatabase(databaseId) {
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            var database, newDatabase;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            if (!databaseId) {
	                                _context3.next = 14;
	                                break;
	                            }
	
	                            _context3.prev = 1;
	                            _context3.next = 4;
	                            return _services.MetabaseApi.db_get({ "dbId": databaseId });
	
	                        case 4:
	                            database = _context3.sent;
	
	                            dispatch.action(INITIALIZE_DATABASE, database);
	
	                            // If the new scheduling toggle isn't set, run the migration
	                            if (database.details["let-user-control-scheduling"] == undefined) {
	                                dispatch(migrateDatabaseToNewSchedulingSettings(database));
	                            }
	                            _context3.next = 12;
	                            break;
	
	                        case 9:
	                            _context3.prev = 9;
	                            _context3.t0 = _context3["catch"](1);
	
	                            if (_context3.t0.status == 404) {
	                                //$location.path('/admin/databases/');
	                            } else {
	                                console.error("error fetching database", databaseId, _context3.t0);
	                            }
	
	                        case 12:
	                            _context3.next = 16;
	                            break;
	
	                        case 14:
	                            newDatabase = {
	                                name: '',
	                                engine: Object.keys(_settings2.default.get('engines'))[0],
	                                details: {},
	                                created: false
	                            };
	
	                            dispatch.action(INITIALIZE_DATABASE, newDatabase);
	
	                        case 16:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[1, 9]]);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	};
	
	// addSampleDataset
	var addSampleDataset = exports.addSampleDataset = (0, _redux.createThunkAction)(ADD_SAMPLE_DATASET, function () {
	    return function () {
	        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
	            var sampleDataset;
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            _context4.prev = 0;
	                            _context4.next = 3;
	                            return _services.MetabaseApi.db_add_sample_dataset();
	
	                        case 3:
	                            sampleDataset = _context4.sent;
	
	                            _analytics2.default.trackEvent("Databases", "Add Sample Data");
	                            return _context4.abrupt("return", sampleDataset);
	
	                        case 8:
	                            _context4.prev = 8;
	                            _context4.t0 = _context4["catch"](0);
	
	                            console.error("error adding sample dataset", _context4.t0);
	                            return _context4.abrupt("return", _context4.t0);
	
	                        case 12:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, this, [[0, 8]]);
	        }));
	
	        return function (_x7, _x8) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	});
	
	var proceedWithDbCreation = exports.proceedWithDbCreation = function proceedWithDbCreation(database) {
	    return function () {
	        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
	            var _ref6, valid;
	
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            if (!database.details["let-user-control-scheduling"]) {
	                                _context5.next = 15;
	                                break;
	                            }
	
	                            _context5.prev = 1;
	
	                            dispatch.action(VALIDATE_DATABASE_STARTED);
	                            _context5.next = 5;
	                            return _services.MetabaseApi.db_validate({ details: database });
	
	                        case 5:
	                            _ref6 = _context5.sent;
	                            valid = _ref6.valid;
	
	
	                            if (valid) {
	                                dispatch.action(SET_DATABASE_CREATION_STEP, {
	                                    // NOTE Atte Keinänen: DatabaseSchedulingForm needs `editingDatabase` with `schedules` so I decided that
	                                    // it makes sense to set the value of editingDatabase as part of SET_DATABASE_CREATION_STEP
	                                    database: _extends({}, database, {
	                                        is_full_sync: true,
	                                        schedules: DEFAULT_SCHEDULES
	                                    }),
	                                    step: DB_EDIT_FORM_SCHEDULING_TAB
	                                });
	                            } else {
	                                dispatch.action(VALIDATE_DATABASE_FAILED, { error: { data: { message: "Couldn't connect to the database. Please check the connection details." } } });
	                            }
	                            _context5.next = 13;
	                            break;
	
	                        case 10:
	                            _context5.prev = 10;
	                            _context5.t0 = _context5["catch"](1);
	
	                            dispatch.action(VALIDATE_DATABASE_FAILED, { error: _context5.t0 });
	
	                        case 13:
	                            _context5.next = 16;
	                            break;
	
	                        case 15:
	                            // Skip the scheduling step if user doesn't need precise control over sync and scan
	                            dispatch(createDatabase(database));
	
	                        case 16:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, this, [[1, 10]]);
	        }));
	
	        return function (_x9, _x10) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	};
	
	var createDatabase = exports.createDatabase = function createDatabase(database) {
	    return function () {
	        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
	            var createdDatabase;
	            return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            _context6.prev = 0;
	
	                            dispatch.action(CREATE_DATABASE_STARTED, {});
	                            _context6.next = 4;
	                            return _services.MetabaseApi.db_create(database);
	
	                        case 4:
	                            createdDatabase = _context6.sent;
	
	                            _analytics2.default.trackEvent("Databases", "Create", database.engine);
	
	                            // update the db metadata already here because otherwise there will be a gap between "Adding..." status
	                            // and seeing the db that was just added
	                            _context6.next = 8;
	                            return dispatch(fetchDatabases());
	
	                        case 8:
	
	                            dispatch.action(CREATE_DATABASE);
	                            dispatch((0, _reactRouterRedux.push)('/admin/databases?created=' + createdDatabase.id));
	                            _context6.next = 17;
	                            break;
	
	                        case 12:
	                            _context6.prev = 12;
	                            _context6.t0 = _context6["catch"](0);
	
	                            console.error("error creating a database", _context6.t0);
	                            _analytics2.default.trackEvent("Databases", "Create Failed", database.engine);
	                            dispatch.action(CREATE_DATABASE_FAILED, { error: _context6.t0 });
	
	                        case 17:
	                        case "end":
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, this, [[0, 12]]);
	        }));
	
	        return function (_x11, _x12) {
	            return _ref7.apply(this, arguments);
	        };
	    }();
	};
	
	var updateDatabase = exports.updateDatabase = function updateDatabase(database) {
	    return function () {
	        var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
	            var savedDatabase;
	            return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            _context7.prev = 0;
	
	                            dispatch.action(UPDATE_DATABASE_STARTED, { database: database });
	                            _context7.next = 4;
	                            return _services.MetabaseApi.db_update(database);
	
	                        case 4:
	                            savedDatabase = _context7.sent;
	
	                            _analytics2.default.trackEvent("Databases", "Update", database.engine);
	
	                            dispatch.action(UPDATE_DATABASE, { database: savedDatabase });
	                            setTimeout(function () {
	                                return dispatch.action(CLEAR_FORM_STATE);
	                            }, 3000);
	                            _context7.next = 14;
	                            break;
	
	                        case 10:
	                            _context7.prev = 10;
	                            _context7.t0 = _context7["catch"](0);
	
	                            _analytics2.default.trackEvent("Databases", "Update Failed", database.engine);
	                            dispatch.action(UPDATE_DATABASE_FAILED, { error: _context7.t0 });
	
	                        case 14:
	                        case "end":
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, this, [[0, 10]]);
	        }));
	
	        return function (_x13, _x14) {
	            return _ref8.apply(this, arguments);
	        };
	    }();
	};
	
	// NOTE Atte Keinänen 7/26/17: Original monolithic saveDatabase was broken out to smaller actions
	// but `saveDatabase` action creator is still left here for keeping the interface for React components unchanged
	var saveDatabase = exports.saveDatabase = function saveDatabase(database, details) {
	    // If we don't let user control the scheduling settings, let's override them with Metabase defaults
	    // TODO Atte Keinänen 8/15/17: Implement engine-specific scheduling defaults
	    var letUserControlScheduling = details["let-user-control-scheduling"];
	    var overridesIfNoUserControl = letUserControlScheduling ? {} : {
	        is_full_sync: true,
	        schedules: DEFAULT_SCHEDULES
	    };
	
	    return function () {
	        var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(dispatch, getState) {
	            var databaseWithDetails, isUnsavedDatabase;
	            return regeneratorRuntime.wrap(function _callee8$(_context8) {
	                while (1) {
	                    switch (_context8.prev = _context8.next) {
	                        case 0:
	                            databaseWithDetails = _extends({}, database, {
	                                details: details
	                            }, overridesIfNoUserControl);
	                            isUnsavedDatabase = !databaseWithDetails.id;
	
	                            if (isUnsavedDatabase) {
	                                dispatch(createDatabase(databaseWithDetails));
	                            } else {
	                                dispatch(updateDatabase(databaseWithDetails));
	                            }
	
	                        case 3:
	                        case "end":
	                            return _context8.stop();
	                    }
	                }
	            }, _callee8, this);
	        }));
	
	        return function (_x15, _x16) {
	            return _ref9.apply(this, arguments);
	        };
	    }();
	};
	
	var deleteDatabase = exports.deleteDatabase = function deleteDatabase(databaseId) {
	    var isDetailView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    return function () {
	        var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee9$(_context9) {
	                while (1) {
	                    switch (_context9.prev = _context9.next) {
	                        case 0:
	                            _context9.prev = 0;
	
	                            dispatch.action(DELETE_DATABASE_STARTED, { databaseId: databaseId });
	                            dispatch((0, _reactRouterRedux.push)('/admin/databases/'));
	                            _context9.next = 5;
	                            return _services.MetabaseApi.db_delete({ "dbId": databaseId });
	
	                        case 5:
	                            _analytics2.default.trackEvent("Databases", "Delete", isDetailView ? "Using Detail" : "Using List");
	                            dispatch.action(DELETE_DATABASE, { databaseId: databaseId });
	                            _context9.next = 13;
	                            break;
	
	                        case 9:
	                            _context9.prev = 9;
	                            _context9.t0 = _context9["catch"](0);
	
	                            console.log('error deleting database', _context9.t0);
	                            dispatch.action(DELETE_DATABASE_FAILED, { databaseId: databaseId, error: _context9.t0 });
	
	                        case 13:
	                        case "end":
	                            return _context9.stop();
	                    }
	                }
	            }, _callee9, this, [[0, 9]]);
	        }));
	
	        return function (_x18, _x19) {
	            return _ref10.apply(this, arguments);
	        };
	    }();
	};
	
	// syncDatabaseSchema
	var syncDatabaseSchema = exports.syncDatabaseSchema = (0, _redux.createThunkAction)(SYNC_DATABASE_SCHEMA, function (databaseId) {
	    return function () {
	        var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(dispatch, getState) {
	            var call;
	            return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                while (1) {
	                    switch (_context10.prev = _context10.next) {
	                        case 0:
	                            _context10.prev = 0;
	                            _context10.next = 3;
	                            return _services.MetabaseApi.db_sync_schema({ "dbId": databaseId });
	
	                        case 3:
	                            call = _context10.sent;
	
	                            _analytics2.default.trackEvent("Databases", "Manual Sync");
	                            return _context10.abrupt("return", call);
	
	                        case 8:
	                            _context10.prev = 8;
	                            _context10.t0 = _context10["catch"](0);
	
	                            console.log('error syncing database', _context10.t0);
	
	                        case 11:
	                        case "end":
	                            return _context10.stop();
	                    }
	                }
	            }, _callee10, this, [[0, 8]]);
	        }));
	
	        return function (_x20, _x21) {
	            return _ref11.apply(this, arguments);
	        };
	    }();
	});
	
	// rescanDatabaseFields
	var rescanDatabaseFields = exports.rescanDatabaseFields = (0, _redux.createThunkAction)(RESCAN_DATABASE_FIELDS, function (databaseId) {
	    return function () {
	        var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(dispatch, getState) {
	            var call;
	            return regeneratorRuntime.wrap(function _callee11$(_context11) {
	                while (1) {
	                    switch (_context11.prev = _context11.next) {
	                        case 0:
	                            _context11.prev = 0;
	                            _context11.next = 3;
	                            return _services.MetabaseApi.db_rescan_values({ "dbId": databaseId });
	
	                        case 3:
	                            call = _context11.sent;
	
	                            _analytics2.default.trackEvent("Databases", "Manual Sync");
	                            return _context11.abrupt("return", call);
	
	                        case 8:
	                            _context11.prev = 8;
	                            _context11.t0 = _context11["catch"](0);
	
	                            console.log('error syncing database', _context11.t0);
	
	                        case 11:
	                        case "end":
	                            return _context11.stop();
	                    }
	                }
	            }, _callee11, this, [[0, 8]]);
	        }));
	
	        return function (_x22, _x23) {
	            return _ref12.apply(this, arguments);
	        };
	    }();
	});
	
	// discardSavedFieldValues
	var discardSavedFieldValues = exports.discardSavedFieldValues = (0, _redux.createThunkAction)(DISCARD_SAVED_FIELD_VALUES, function (databaseId) {
	    return function () {
	        var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee12(dispatch, getState) {
	            var call;
	            return regeneratorRuntime.wrap(function _callee12$(_context12) {
	                while (1) {
	                    switch (_context12.prev = _context12.next) {
	                        case 0:
	                            _context12.prev = 0;
	                            _context12.next = 3;
	                            return _services.MetabaseApi.db_discard_values({ "dbId": databaseId });
	
	                        case 3:
	                            call = _context12.sent;
	
	                            _analytics2.default.trackEvent("Databases", "Manual Sync");
	                            return _context12.abrupt("return", call);
	
	                        case 8:
	                            _context12.prev = 8;
	                            _context12.t0 = _context12["catch"](0);
	
	                            console.log('error syncing database', _context12.t0);
	
	                        case 11:
	                        case "end":
	                            return _context12.stop();
	                    }
	                }
	            }, _callee12, this, [[0, 8]]);
	        }));
	
	        return function (_x24, _x25) {
	            return _ref13.apply(this, arguments);
	        };
	    }();
	});
	
	// reducers
	
	var databases = (0, _redux.handleActions)((_handleActions = {}, _defineProperty(_handleActions, FETCH_DATABASES, { next: function next(state, _ref14) {
	        var payload = _ref14.payload;
	        return payload;
	    } }), _defineProperty(_handleActions, ADD_SAMPLE_DATASET, { next: function next(state, _ref15) {
	        var payload = _ref15.payload;
	        return payload ? [].concat(_toConsumableArray(state), [payload]) : state;
	    } }), _defineProperty(_handleActions, DELETE_DATABASE, function (state, _ref16) {
	    var databaseId = _ref16.payload.databaseId;
	    return databaseId ? _underscore2.default.reject(state, function (d) {
	        return d.id === databaseId;
	    }) : state;
	}), _handleActions), null);
	
	var editingDatabase = (0, _redux.handleActions)((_handleActions2 = {}, _defineProperty(_handleActions2, RESET, function () {
	    return null;
	}), _defineProperty(_handleActions2, INITIALIZE_DATABASE, function (state, _ref17) {
	    var payload = _ref17.payload;
	    return payload;
	}), _defineProperty(_handleActions2, MIGRATE_TO_NEW_SCHEDULING_SETTINGS, function (state, _ref18) {
	    var payload = _ref18.payload;
	    return payload;
	}), _defineProperty(_handleActions2, UPDATE_DATABASE, function (state, _ref19) {
	    var payload = _ref19.payload;
	    return payload.database || state;
	}), _defineProperty(_handleActions2, DELETE_DATABASE, function (state, _ref20) {
	    var payload = _ref20.payload;
	    return null;
	}), _defineProperty(_handleActions2, SELECT_ENGINE, function (state, _ref21) {
	    var payload = _ref21.payload;
	    return _extends({}, state, { engine: payload });
	}), _defineProperty(_handleActions2, SET_DATABASE_CREATION_STEP, function (state, _ref22) {
	    var database = _ref22.payload.database;
	    return database;
	}), _handleActions2), null);
	
	var deletes = (0, _redux.handleActions)((_handleActions3 = {}, _defineProperty(_handleActions3, DELETE_DATABASE_STARTED, function (state, _ref23) {
	    var databaseId = _ref23.payload.databaseId;
	    return state.concat([databaseId]);
	}), _defineProperty(_handleActions3, DELETE_DATABASE_FAILED, function (state, _ref24) {
	    var _ref24$payload = _ref24.payload,
	        databaseId = _ref24$payload.databaseId,
	        error = _ref24$payload.error;
	    return state.filter(function (dbId) {
	        return dbId !== databaseId;
	    });
	}), _defineProperty(_handleActions3, DELETE_DATABASE, function (state, _ref25) {
	    var databaseId = _ref25.payload.databaseId;
	    return state.filter(function (dbId) {
	        return dbId !== databaseId;
	    });
	}), _handleActions3), []);
	
	var deletionError = (0, _redux.handleActions)(_defineProperty({}, DELETE_DATABASE_FAILED, function (state, _ref26) {
	    var error = _ref26.payload.error;
	    return error;
	}), null);
	
	var databaseCreationStep = (0, _redux.handleActions)((_handleActions5 = {}, _defineProperty(_handleActions5, RESET, function () {
	    return DB_EDIT_FORM_CONNECTION_TAB;
	}), _defineProperty(_handleActions5, SET_DATABASE_CREATION_STEP, function (state, _ref27) {
	    var step = _ref27.payload.step;
	    return step;
	}), _handleActions5), DB_EDIT_FORM_CONNECTION_TAB);
	
	var DEFAULT_FORM_STATE = { formSuccess: null, formError: null, isSubmitting: false };
	
	var formState = (0, _redux.handleActions)((_handleActions6 = {}, _defineProperty(_handleActions6, RESET, { next: function next() {
	        return DEFAULT_FORM_STATE;
	    } }), _defineProperty(_handleActions6, CREATE_DATABASE_STARTED, function () {
	    return { isSubmitting: true };
	}), _defineProperty(_handleActions6, CREATE_DATABASE, function () {
	    return { formSuccess: { data: { message: "Successfully created!" } } };
	}), _defineProperty(_handleActions6, VALIDATE_DATABASE_FAILED, function (state, _ref28) {
	    var error = _ref28.payload.error;
	    return { formError: error };
	}), _defineProperty(_handleActions6, CREATE_DATABASE_FAILED, function (state, _ref29) {
	    var error = _ref29.payload.error;
	    return { formError: error };
	}), _defineProperty(_handleActions6, UPDATE_DATABASE_STARTED, function () {
	    return { isSubmitting: true };
	}), _defineProperty(_handleActions6, UPDATE_DATABASE, function () {
	    return { formSuccess: { data: { message: "Successfully saved!" } } };
	}), _defineProperty(_handleActions6, UPDATE_DATABASE_FAILED, function (state, _ref30) {
	    var error = _ref30.payload.error;
	    return { formError: error };
	}), _defineProperty(_handleActions6, CLEAR_FORM_STATE, function () {
	    return DEFAULT_FORM_STATE;
	}), _handleActions6), DEFAULT_FORM_STATE);
	
	exports.default = (0, _redux.combineReducers)({
	    databases: databases,
	    editingDatabase: editingDatabase,
	    deletionError: deletionError,
	    databaseCreationStep: databaseCreationStep,
	    formState: formState,
	    deletes: deletes
	});

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _Toggle = __webpack_require__(1241);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _StepTitle = __webpack_require__(1786);
	
	var _StepTitle2 = _interopRequireDefault(_StepTitle);
	
	var _CollapsedStep = __webpack_require__(1787);
	
	var _CollapsedStep2 = _interopRequireDefault(_CollapsedStep);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PreferencesStep = (_temp = _class = function (_Component) {
	    _inherits(PreferencesStep, _Component);
	
	    function PreferencesStep() {
	        _classCallCheck(this, PreferencesStep);
	
	        return _possibleConstructorReturn(this, (PreferencesStep.__proto__ || Object.getPrototypeOf(PreferencesStep)).apply(this, arguments));
	    }
	
	    _createClass(PreferencesStep, [{
	        key: "toggleTracking",
	        value: function toggleTracking() {
	            var allowTracking = this.props.allowTracking;
	
	
	            this.props.setAllowTracking(!allowTracking);
	        }
	    }, {
	        key: "formSubmitted",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(e) {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                e.preventDefault();
	
	                                // okay, this is the big one.  we actually submit everything to the api now and complete the process.
	                                this.props.submitSetup();
	
	                                _analytics2.default.trackEvent('Setup', 'Preferences Step', this.props.allowTracking);
	
	                            case 3:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function formSubmitted(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return formSubmitted;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                activeStep = _props.activeStep,
	                allowTracking = _props.allowTracking,
	                setupComplete = _props.setupComplete,
	                stepNumber = _props.stepNumber,
	                setActiveStep = _props.setActiveStep;
	
	            var _MetabaseSettings$get = _settings2.default.get('version'),
	                tag = _MetabaseSettings$get.tag;
	
	            var stepText = 'Usage data preferences';
	            if (setupComplete) {
	                stepText = allowTracking ? "Thanks for helping us improve" : "We won't collect any usage events";
	            }
	
	            if (activeStep !== stepNumber || setupComplete) {
	                return _react2.default.createElement(_CollapsedStep2.default, { stepNumber: stepNumber, stepCircleText: "3", stepText: stepText, isCompleted: setupComplete, setActiveStep: setActiveStep });
	            } else {
	                return _react2.default.createElement(
	                    "section",
	                    { className: "SetupStep rounded full relative SetupStep--active" },
	                    _react2.default.createElement(_StepTitle2.default, { title: stepText, circleText: "3" }),
	                    _react2.default.createElement(
	                        "form",
	                        { onSubmit: this.formSubmitted.bind(this), noValidate: true },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Form-field Form-offset" },
	                            "In order to help us improve Metabase, we'd like to collect certain data about usage through Google Analytics.  ",
	                            _react2.default.createElement(
	                                "a",
	                                { className: "link", href: "http://www.metabase.com/docs/" + tag + "/information-collection.html", target: "_blank" },
	                                "Here's a full list of everything we track and why."
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Form-field Form-offset mr4" },
	                            _react2.default.createElement(
	                                "div",
	                                { style: { borderWidth: "2px" }, className: "flex align-center bordered rounded p2" },
	                                _react2.default.createElement(_Toggle2.default, { value: allowTracking, onChange: this.toggleTracking.bind(this), className: "inline-block" }),
	                                _react2.default.createElement(
	                                    "span",
	                                    { className: "ml1" },
	                                    "Allow Metabase to anonymously collect usage events"
	                                )
	                            )
	                        ),
	                        allowTracking ? _react2.default.createElement(
	                            "div",
	                            { className: "Form-field Form-offset" },
	                            _react2.default.createElement(
	                                "ul",
	                                { style: { listStyle: "disc inside", lineHeight: "200%" } },
	                                _react2.default.createElement(
	                                    "li",
	                                    null,
	                                    "Metabase ",
	                                    _react2.default.createElement(
	                                        "span",
	                                        { style: { fontWeight: "bold" } },
	                                        "never"
	                                    ),
	                                    " collects anything about your data or question results."
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    null,
	                                    "All collection is completely anonymous."
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    null,
	                                    "Collection can be turned off at any point in your admin settings."
	                                )
	                            )
	                        ) : null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Form-actions" },
	                            _react2.default.createElement(
	                                "button",
	                                { className: "Button Button--primary" },
	                                "Next"
	                            )
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return PreferencesStep;
	}(_react.Component), _class.propTypes = {
	    stepNumber: _propTypes2.default.number.isRequired,
	    activeStep: _propTypes2.default.number.isRequired,
	    setActiveStep: _propTypes2.default.func.isRequired,
	
	    allowTracking: _propTypes2.default.bool.isRequired,
	    setAllowTracking: _propTypes2.default.func.isRequired,
	    setupComplete: _propTypes2.default.bool.isRequired,
	    submitSetup: _propTypes2.default.func.isRequired
	}, _temp);
	PreferencesStep.displayName = "PreferencesStep";
	exports.default = PreferencesStep;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StepTitle = __webpack_require__(1786);
	
	var _StepTitle2 = _interopRequireDefault(_StepTitle);
	
	var _CollapsedStep = __webpack_require__(1787);
	
	var _CollapsedStep2 = _interopRequireDefault(_CollapsedStep);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _DatabaseSchedulingForm = __webpack_require__(1793);
	
	var _DatabaseSchedulingForm2 = _interopRequireDefault(_DatabaseSchedulingForm);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatabaseSchedulingStep = (_temp = _class = function (_Component) {
	    _inherits(DatabaseSchedulingStep, _Component);
	
	    function DatabaseSchedulingStep(props, context) {
	        var _this2 = this;
	
	        _classCallCheck(this, DatabaseSchedulingStep);
	
	        var _this = _possibleConstructorReturn(this, (DatabaseSchedulingStep.__proto__ || Object.getPrototypeOf(DatabaseSchedulingStep)).call(this, props, context));
	
	        _this.schedulingDetailsCaptured = function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(database) {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _this.props.setDatabaseDetails({
	                                    'nextStep': _this.props.stepNumber + 1,
	                                    'details': database
	                                });
	
	                                _analytics2.default.trackEvent('Setup', 'Database Step', _this.state.engine);
	
	                            case 2:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2);
	            }));
	
	            return function (_x) {
	                return _ref.apply(this, arguments);
	            };
	        }();
	
	        _this.state = { 'engine': "", 'formError': null };
	        return _this;
	    }
	
	    _createClass(DatabaseSchedulingStep, [{
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                activeStep = _props.activeStep,
	                databaseDetails = _props.databaseDetails,
	                setActiveStep = _props.setActiveStep,
	                stepNumber = _props.stepNumber;
	            var formError = this.state.formError;
	
	
	            var stepText = 'Control automatic scans';
	
	            var schedulingIcon = _react2.default.createElement(_Icon2.default, {
	                className: "text-purple-hover cursor-pointer",
	                name: "gear",
	                onClick: function onClick() {
	                    return _this3.setState({ showCalendar: !_this3.state.showCalendar });
	                }
	            });
	
	            if (activeStep !== stepNumber) {
	                return _react2.default.createElement(_CollapsedStep2.default, { stepNumber: stepNumber, stepCircleText: schedulingIcon, stepText: stepText, isCompleted: activeStep > stepNumber, setActiveStep: setActiveStep });
	            } else {
	                return _react2.default.createElement(
	                    "section",
	                    { className: "SetupStep rounded full relative SetupStep--active" },
	                    _react2.default.createElement(_StepTitle2.default, { title: stepText, circleText: schedulingIcon }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "mb4" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "text-default" },
	                            _react2.default.createElement(_DatabaseSchedulingForm2.default, {
	                                database: databaseDetails,
	                                formState: { formError: formError }
	                                // Use saveDatabase both for db creation and updating
	                                , save: this.schedulingDetailsCaptured,
	                                submitButtonText: "Next"
	                            })
	                        )
	                    )
	                );
	            }
	        }
	    }]);
	
	    return DatabaseSchedulingStep;
	}(_react.Component), _class.propTypes = {
	    stepNumber: _propTypes2.default.number.isRequired,
	    activeStep: _propTypes2.default.number.isRequired,
	    setActiveStep: _propTypes2.default.func.isRequired,
	
	    databaseDetails: _propTypes2.default.object,
	    setDatabaseDetails: _propTypes2.default.func.isRequired
	}, _temp);
	DatabaseSchedulingStep.displayName = "DatabaseSchedulingStep";
	exports.default = DatabaseSchedulingStep;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.SyncOption = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	var _FormMessage = __webpack_require__(1573);
	
	var _FormMessage2 = _interopRequireDefault(_FormMessage);
	
	var _SchedulePicker = __webpack_require__(1695);
	
	var _SchedulePicker2 = _interopRequireDefault(_SchedulePicker);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SyncOption = exports.SyncOption = function SyncOption(_ref) {
	    var selected = _ref.selected,
	        name = _ref.name,
	        children = _ref.children,
	        select = _ref.select;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("py3 relative", { "cursor-pointer": !selected }), onClick: function onClick() {
	                return select(name.toLowerCase());
	            } },
	        _react2.default.createElement(
	            "div",
	            {
	                className: (0, _classnames2.default)('circle ml2 flex align-center justify-center absolute'),
	                style: {
	                    width: 18,
	                    height: 18,
	                    borderWidth: 2,
	                    borderColor: selected ? '#509ee3' : '#ddd',
	                    borderStyle: 'solid'
	                }
	            },
	            selected && _react2.default.createElement("div", {
	                className: "circle",
	                style: { width: 8, height: 8, backgroundColor: selected ? '#509ee3' : '#ddd' }
	            })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "Form-offset ml1" },
	            _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)({ 'text-brand': selected }) },
	                _react2.default.createElement(
	                    "h3",
	                    null,
	                    name
	                )
	            ),
	            selected && children && _react2.default.createElement(
	                "div",
	                { className: "mt2" },
	                children
	            )
	        )
	    );
	};
	
	SyncOption.displayName = "SyncOption";
	
	var DatabaseSchedulingForm = function (_Component) {
	    _inherits(DatabaseSchedulingForm, _Component);
	
	    function DatabaseSchedulingForm(props) {
	        _classCallCheck(this, DatabaseSchedulingForm);
	
	        var _this = _possibleConstructorReturn(this, (DatabaseSchedulingForm.__proto__ || Object.getPrototypeOf(DatabaseSchedulingForm)).call(this));
	
	        _this.updateSchemaSyncSchedule = function (newSchedule, changedProp) {
	            _analytics2.default.trackEvent("DatabaseSyncEdit", "SchemaSyncSchedule:" + changedProp.name, changedProp.value);
	
	            _this.setState((0, _icepick.assocIn)(_this.state, ["unsavedDatabase", "schedules", "metadata_sync"], newSchedule));
	        };
	
	        _this.updateFieldScanSchedule = function (newSchedule, changedProp) {
	            _analytics2.default.trackEvent("DatabaseSyncEdit", "FieldScanSchedule:" + changedProp.name, changedProp.value);
	
	            _this.setState((0, _icepick.assocIn)(_this.state, ["unsavedDatabase", "schedules", "cache_field_values"], newSchedule));
	        };
	
	        _this.setIsFullSyncIsOnDemand = function (isFullSync, isOnDemand) {
	            // TODO: Add event tracking
	            var state = (0, _icepick.assocIn)(_this.state, ["unsavedDatabase", "is_full_sync"], isFullSync);
	            state = (0, _icepick.assocIn)(state, ["unsavedDatabase", "is_on_demand"], isOnDemand);
	            _this.setState(state);
	        };
	
	        _this.onSubmitForm = function (event) {
	            event.preventDefault();
	
	            var unsavedDatabase = _this.state.unsavedDatabase;
	
	            _this.props.save(unsavedDatabase, unsavedDatabase.details);
	        };
	
	        _this.state = {
	            unsavedDatabase: props.database
	        };
	        return _this;
	    }
	
	    _createClass(DatabaseSchedulingForm, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                submitButtonText = _props.submitButtonText,
	                _props$formState = _props.formState,
	                formError = _props$formState.formError,
	                formSuccess = _props$formState.formSuccess,
	                isSubmitting = _props$formState.isSubmitting;
	            var unsavedDatabase = this.state.unsavedDatabase;
	
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: !this.props.database, error: null },
	                function () {
	                    return _react2.default.createElement(
	                        "form",
	                        { onSubmit: _this2.onSubmitForm, noValidate: true },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Form-offset mr4 mt4" },
	                            _react2.default.createElement(
	                                "div",
	                                { style: { maxWidth: 600 }, className: "border-bottom pb2" },
	                                _react2.default.createElement(
	                                    "p",
	                                    { className: "text-paragraph text-measure" },
	                                    "To do some of its magic, Metabase needs to scan your database. We will also ",
	                                    _react2.default.createElement(
	                                        "em",
	                                        null,
	                                        "re"
	                                    ),
	                                    "scan it periodically to keep the metadata up-to-date. You can control when the periodic rescans happen below."
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "border-bottom pb4" },
	                                _react2.default.createElement(
	                                    "h4",
	                                    { className: "mt4 text-bold text-uppercase" },
	                                    "Database syncing"
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    { className: "text-paragraph text-measure" },
	                                    "This is a lightweight process that checks for updates to this database\u2019s schema. In most cases, you should be fine leaving this set to sync hourly."
	                                ),
	                                _react2.default.createElement(_SchedulePicker2.default, {
	                                    schedule: !_underscore2.default.isString(unsavedDatabase.schedules && unsavedDatabase.schedules.metadata_sync) ? unsavedDatabase.schedules.metadata_sync : {
	                                        schedule_day: "mon",
	                                        schedule_frame: null,
	                                        schedule_hour: 0,
	                                        schedule_type: "daily"
	                                    },
	                                    scheduleOptions: ["hourly", "daily"],
	                                    onScheduleChange: _this2.updateSchemaSyncSchedule,
	                                    textBeforeInterval: "Scan"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "mt4" },
	                                _react2.default.createElement(
	                                    "h4",
	                                    { className: "text-bold text-default text-uppercase" },
	                                    "Scanning for Filter Values"
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    { className: "text-paragraph text-measure" },
	                                    "Metabase can scan the values present in each field in this database to enable checkbox filters in dashboards and questions. This can be a somewhat resource-intensive process, particularly if you have a very large database."
	                                ),
	                                _react2.default.createElement(
	                                    "h3",
	                                    null,
	                                    "When should Metabase automatically scan and cache field values?"
	                                ),
	                                _react2.default.createElement(
	                                    "ol",
	                                    { className: "bordered shadowed mt3" },
	                                    _react2.default.createElement(
	                                        "li",
	                                        { className: "border-bottom" },
	                                        _react2.default.createElement(
	                                            SyncOption,
	                                            {
	                                                selected: unsavedDatabase.is_full_sync,
	                                                name: "Regularly, on a schedule",
	                                                select: function select() {
	                                                    return _this2.setIsFullSyncIsOnDemand(true, false);
	                                                }
	                                            },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "flex align-center" },
	                                                _react2.default.createElement(_SchedulePicker2.default, {
	                                                    schedule: !_underscore2.default.isString(unsavedDatabase.schedules && unsavedDatabase.schedules.cache_field_values) ? unsavedDatabase.schedules.cache_field_values : {
	                                                        schedule_day: "mon",
	                                                        schedule_frame: null,
	                                                        schedule_hour: 0,
	                                                        schedule_type: "daily"
	                                                    },
	                                                    scheduleOptions: ["daily", "weekly", "monthly"],
	                                                    onScheduleChange: _this2.updateFieldScanSchedule,
	                                                    textBeforeInterval: "Scan"
	                                                })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        { className: "border-bottom pr2" },
	                                        _react2.default.createElement(
	                                            SyncOption,
	                                            {
	                                                selected: !unsavedDatabase.is_full_sync && unsavedDatabase.is_on_demand,
	                                                name: "Only when adding a new filter widget",
	                                                select: function select() {
	                                                    return _this2.setIsFullSyncIsOnDemand(false, true);
	                                                }
	                                            },
	                                            _react2.default.createElement(
	                                                "p",
	                                                { className: "text-paragraph text-measure" },
	                                                "When a user adds a new filter to a dashboard or a SQL question, Metabase will scan the field(s) mapped to that filter in order to show the list of selectable values."
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(SyncOption, {
	                                            selected: !unsavedDatabase.is_full_sync && !unsavedDatabase.is_on_demand,
	                                            name: "Never, I'll do this manually if I need to",
	                                            select: function select() {
	                                                return _this2.setIsFullSyncIsOnDemand(false, false);
	                                            }
	                                        })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Form-actions mt4" },
	                            _react2.default.createElement(
	                                "button",
	                                { className: "Button Button--primary", disabled: isSubmitting },
	                                isSubmitting ? "Saving..." : submitButtonText
	                            ),
	                            _react2.default.createElement(_FormMessage2.default, { formError: formError, formSuccess: formSuccess })
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return DatabaseSchedulingForm;
	}(_react.Component);
	
	DatabaseSchedulingForm.displayName = "DatabaseSchedulingForm";
	exports.default = DatabaseSchedulingForm;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.setupSelectors = undefined;
	
	var _reselect = __webpack_require__(1072);
	
	var activeStepSelector = function activeStepSelector(state) {
		return state.setup.activeStep;
	};
	var userDetailsSelector = function userDetailsSelector(state) {
		return state.setup.userDetails;
	};
	var databaseDetailsSelector = function databaseDetailsSelector(state) {
		return state.setup.databaseDetails;
	};
	var allowTrackingSelector = function allowTrackingSelector(state) {
		return state.setup.allowTracking;
	};
	var setupErrorSelector = function setupErrorSelector(state) {
		return state.setup.setupError;
	};
	var setupCompleteSelector = function setupCompleteSelector(state) {
		return state.setup.setupComplete;
	};
	
	// our master selector which combines all of our partial selectors above
	var setupSelectors = exports.setupSelectors = (0, _reselect.createSelector)([activeStepSelector, userDetailsSelector, databaseDetailsSelector, allowTrackingSelector, setupErrorSelector, setupCompleteSelector], function (activeStep, userDetails, databaseDetails, allowTracking, setupError, setupComplete) {
		return { activeStep: activeStep, userDetails: userDetails, databaseDetails: databaseDetails, allowTracking: allowTracking, setupError: setupError, setupComplete: setupComplete };
	});

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.completeSetup = exports.submitSetup = exports.validatePassword = exports.validateDatabase = exports.setAllowTracking = exports.setDatabaseDetails = exports.setUserDetails = exports.setActiveStep = exports.COMPLETE_SETUP = exports.SUBMIT_SETUP = exports.VALIDATE_PASSWORD = exports.VALIDATE_DATABASE = exports.SET_ALLOW_TRACKING = exports.SET_DATABASE_DETAILS = exports.SET_USER_DETAILS = exports.SET_ACTIVE_STEP = undefined;
	
	var _reduxActions = __webpack_require__(658);
	
	var _redux = __webpack_require__(657);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _cookies = __webpack_require__(1124);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //import _ from "underscore";
	
	
	// action constants
	var SET_ACTIVE_STEP = exports.SET_ACTIVE_STEP = 'SET_ACTIVE_STEP';
	var SET_USER_DETAILS = exports.SET_USER_DETAILS = 'SET_USER_DETAILS';
	var SET_DATABASE_DETAILS = exports.SET_DATABASE_DETAILS = 'SET_DATABASE_DETAILS';
	var SET_ALLOW_TRACKING = exports.SET_ALLOW_TRACKING = 'SET_ALLOW_TRACKING';
	var VALIDATE_DATABASE = exports.VALIDATE_DATABASE = 'VALIDATE_DATABASE';
	var VALIDATE_PASSWORD = exports.VALIDATE_PASSWORD = 'VALIDATE_PASSWORD';
	var SUBMIT_SETUP = exports.SUBMIT_SETUP = 'SUBMIT_SETUP';
	var COMPLETE_SETUP = exports.COMPLETE_SETUP = 'COMPLETE_SETUP';
	
	// action creators
	var setActiveStep = exports.setActiveStep = (0, _reduxActions.createAction)(SET_ACTIVE_STEP);
	var setUserDetails = exports.setUserDetails = (0, _reduxActions.createAction)(SET_USER_DETAILS);
	var setDatabaseDetails = exports.setDatabaseDetails = (0, _reduxActions.createAction)(SET_DATABASE_DETAILS);
	var setAllowTracking = exports.setAllowTracking = (0, _reduxActions.createAction)(SET_ALLOW_TRACKING);
	
	var validateDatabase = exports.validateDatabase = (0, _redux.createThunkAction)(VALIDATE_DATABASE, function (details) {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return _services.SetupApi.validate_db({
	                                'token': _settings2.default.get('setup_token'),
	                                'details': details
	                            });
	
	                        case 2:
	                            return _context.abrupt("return", _context.sent);
	
	                        case 3:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var validatePassword = exports.validatePassword = (0, _redux.createThunkAction)(VALIDATE_PASSWORD, function (password) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.next = 2;
	                            return _services.UtilApi.password_check({
	                                'password': password
	                            });
	
	                        case 2:
	                            return _context2.abrupt("return", _context2.sent);
	
	                        case 3:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	var submitSetup = exports.submitSetup = (0, _redux.createThunkAction)(SUBMIT_SETUP, function () {
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            var _getState, _getState$setup, allowTracking, databaseDetails, userDetails, response;
	
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _getState = getState(), _getState$setup = _getState.setup, allowTracking = _getState$setup.allowTracking, databaseDetails = _getState$setup.databaseDetails, userDetails = _getState$setup.userDetails;
	                            _context3.prev = 1;
	                            _context3.next = 4;
	                            return _services.SetupApi.create({
	                                'token': _settings2.default.get('setup_token'),
	                                'prefs': {
	                                    'site_name': userDetails.site_name,
	                                    'allow_tracking': allowTracking.toString()
	                                },
	                                'database': databaseDetails,
	                                'user': userDetails
	                            });
	
	                        case 4:
	                            response = _context3.sent;
	
	
	                            // setup complete!
	                            dispatch(completeSetup(response));
	
	                            return _context3.abrupt("return", null);
	
	                        case 9:
	                            _context3.prev = 9;
	                            _context3.t0 = _context3["catch"](1);
	
	                            _analytics2.default.trackEvent('Setup', 'Error', 'save');
	
	                            return _context3.abrupt("return", _context3.t0);
	
	                        case 13:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[1, 9]]);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	});
	
	var completeSetup = exports.completeSetup = (0, _reduxActions.createAction)(COMPLETE_SETUP, function (apiResponse) {
	    // setup user session
	    _cookies2.default.setSessionCookie(apiResponse.id);
	
	    // clear setup token from settings
	    _settings2.default.setAll({ 'setup_token': null });
	
	    return true;
	});

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _UserSettings = __webpack_require__(1797);
	
	var _UserSettings2 = _interopRequireDefault(_UserSettings);
	
	var _selectors = __webpack_require__(1800);
	
	var _actions = __webpack_require__(1801);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return _extends({}, (0, _selectors.selectors)(state), {
	        user: state.currentUser
	    });
	};
	
	var mapDispatchToProps = {
	    setTab: _actions.setTab,
	    updatePassword: _actions.updatePassword,
	    updateUser: _actions.updateUser
	};
	
	var UserSettingsApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(UserSettingsApp, _Component);
	
	    function UserSettingsApp() {
	        _classCallCheck(this, UserSettingsApp);
	
	        return _possibleConstructorReturn(this, (UserSettingsApp.__proto__ || Object.getPrototypeOf(UserSettingsApp)).apply(this, arguments));
	    }
	
	    _createClass(UserSettingsApp, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_UserSettings2.default, this.props);
	        }
	    }]);
	
	    return UserSettingsApp;
	}(_react.Component)) || _class);
	UserSettingsApp.displayName = "UserSettingsApp";
	exports.default = UserSettingsApp;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SetUserPassword = __webpack_require__(1798);
	
	var _SetUserPassword2 = _interopRequireDefault(_SetUserPassword);
	
	var _UpdateUserDetails = __webpack_require__(1799);
	
	var _UpdateUserDetails2 = _interopRequireDefault(_UpdateUserDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSettings = (_temp = _class = function (_Component) {
	    _inherits(UserSettings, _Component);
	
	    function UserSettings() {
	        _classCallCheck(this, UserSettings);
	
	        return _possibleConstructorReturn(this, (UserSettings.__proto__ || Object.getPrototypeOf(UserSettings)).apply(this, arguments));
	    }
	
	    _createClass(UserSettings, [{
	        key: "onSetTab",
	        value: function onSetTab(tab) {
	            this.props.setTab(tab);
	        }
	    }, {
	        key: "onUpdatePassword",
	        value: function onUpdatePassword(details) {
	            this.props.updatePassword(details.user_id, details.password, details.old_password);
	        }
	    }, {
	        key: "onUpdateDetails",
	        value: function onUpdateDetails(user) {
	            this.props.updateUser(user);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var tab = this.props.tab;
	
	            var nonSSOManagedAccount = !this.props.user.google_auth && !this.props.user.ldap_auth;
	
	            var allClasses = "Grid-cell md-no-flex md-mt1 text-brand-hover bordered border-brand-hover rounded p1 md-p3 block cursor-pointer text-centered md-text-left",
	                tabClasses = {};
	
	            ['details', 'password'].forEach(function (t) {
	                tabClasses[t] = t === tab ? allClasses + " bg-brand text-white text-white-hover" : allClasses;
	            });
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: "py4 border-bottom" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wrapper wrapper--trim" },
	                        _react2.default.createElement(
	                            "h2",
	                            { className: "text-grey-4" },
	                            "Account settings"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "mt2 md-mt4 wrapper wrapper--trim" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Grid Grid--gutters Grid--full md-Grid--normal md-flex-reverse" },
	                        nonSSOManagedAccount && _react2.default.createElement(
	                            "div",
	                            { className: "Grid-cell Grid Grid--fit md-flex-column md-Cell--1of3" },
	                            _react2.default.createElement(
	                                "a",
	                                { className: (0, _classnames2.default)(tabClasses['details']),
	                                    onClick: this.onSetTab.bind(this, 'details') },
	                                "User Details"
	                            ),
	                            _react2.default.createElement(
	                                "a",
	                                { className: (0, _classnames2.default)(tabClasses['password']),
	                                    onClick: this.onSetTab.bind(this, 'password') },
	                                "Password"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Grid-cell" },
	                            tab === 'details' ? _react2.default.createElement(_UpdateUserDetails2.default, _extends({ submitFn: this.onUpdateDetails.bind(this) }, this.props)) : tab === 'password' ? _react2.default.createElement(_SetUserPassword2.default, _extends({ submitFn: this.onUpdatePassword.bind(this) }, this.props)) : null
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UserSettings;
	}(_react.Component), _class.propTypes = {
	    tab: _propTypes2.default.string.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    setTab: _propTypes2.default.func.isRequired,
	    updateUser: _propTypes2.default.func.isRequired,
	    updatePassword: _propTypes2.default.func.isRequired
	}, _temp);
	UserSettings.displayName = "UserSettings";
	exports.default = UserSettings;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormField = __webpack_require__(1571);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormLabel = __webpack_require__(1572);
	
	var _FormLabel2 = _interopRequireDefault(_FormLabel);
	
	var _FormMessage = __webpack_require__(1573);
	
	var _FormMessage2 = _interopRequireDefault(_FormMessage);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SetUserPassword = (_temp = _class = function (_Component) {
	    _inherits(SetUserPassword, _Component);
	
	    function SetUserPassword(props, context) {
	        _classCallCheck(this, SetUserPassword);
	
	        var _this = _possibleConstructorReturn(this, (SetUserPassword.__proto__ || Object.getPrototypeOf(SetUserPassword)).call(this, props, context));
	
	        _this.state = { formError: null, valid: false };
	        return _this;
	    }
	
	    _createClass(SetUserPassword, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.validateForm();
	        }
	    }, {
	        key: "validateForm",
	        value: function validateForm() {
	            var valid = this.state.valid;
	
	            var isValid = true;
	
	            // required: first_name, last_name, email
	            for (var fieldName in this.refs) {
	                var node = _reactDom2.default.findDOMNode(this.refs[fieldName]);
	                if (node.required && _utils2.default.isEmpty(node.value)) isValid = false;
	            }
	
	            if (isValid !== valid) {
	                this.setState({
	                    'valid': isValid
	                });
	            }
	        }
	    }, {
	        key: "onChange",
	        value: function onChange() {
	            this.validateForm();
	        }
	    }, {
	        key: "formSubmitted",
	        value: function formSubmitted(e) {
	            e.preventDefault();
	
	            this.setState({
	                formError: null
	            });
	
	            var formErrors = { data: { errors: {} } };
	
	            // make sure new passwords match
	            if (_reactDom2.default.findDOMNode(this.refs.password).value !== _reactDom2.default.findDOMNode(this.refs.password2).value) {
	                formErrors.data.errors.password2 = "Passwords do not match";
	            }
	
	            if (_underscore2.default.keys(formErrors.data.errors).length > 0) {
	                this.setState({
	                    formError: formErrors
	                });
	                return;
	            }
	
	            var details = {};
	
	            details.user_id = this.props.user.id;
	            details.old_password = _reactDom2.default.findDOMNode(this.refs.oldPassword).value;
	            details.password = _reactDom2.default.findDOMNode(this.refs.password).value;
	
	            this.props.submitFn(details);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var updatePasswordResult = this.props.updatePasswordResult;
	            var _state = this.state,
	                formError = _state.formError,
	                valid = _state.valid;
	
	            var passwordComplexity = _settings2.default.passwordComplexity(true);
	
	            formError = updatePasswordResult && !formError ? updatePasswordResult : formError;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "form",
	                    { className: "Form-new bordered rounded shadowed", onSubmit: this.formSubmitted.bind(this), noValidate: true },
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { fieldName: "old_password", formError: formError },
	                        _react2.default.createElement(_FormLabel2.default, { title: "Current password", fieldName: "old_password", formError: formError }),
	                        _react2.default.createElement("input", { ref: "oldPassword", type: "password", className: "Form-input Form-offset full", name: "old_password", placeholder: "Shhh...", onChange: this.onChange.bind(this), autoFocus: true, required: true }),
	                        _react2.default.createElement("span", { className: "Form-charm" })
	                    ),
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { fieldName: "password", formError: formError },
	                        _react2.default.createElement(_FormLabel2.default, { title: "New password", fieldName: "password", formError: formError }),
	                        _react2.default.createElement(
	                            "span",
	                            { style: { fontWeight: "400" }, className: "Form-label Form-offset" },
	                            passwordComplexity
	                        ),
	                        _react2.default.createElement("input", { ref: "password", type: "password", className: "Form-input Form-offset full", name: "password", placeholder: "Make sure its secure like the instructions above", onChange: this.onChange.bind(this), required: true }),
	                        _react2.default.createElement("span", { className: "Form-charm" })
	                    ),
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { fieldName: "password2", formError: formError },
	                        _react2.default.createElement(_FormLabel2.default, { title: "Confirm new password", fieldName: "password2", formError: formError }),
	                        _react2.default.createElement("input", { ref: "password2", type: "password", className: "Form-input Form-offset full", name: "password", placeholder: "Make sure it matches the one you just entered", required: true, onChange: this.onChange.bind(this) }),
	                        _react2.default.createElement("span", { className: "Form-charm" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Form-actions" },
	                        _react2.default.createElement(
	                            "button",
	                            { className: (0, _classnames2.default)("Button", { "Button--primary": valid }), disabled: !valid },
	                            "Save"
	                        ),
	                        _react2.default.createElement(_FormMessage2.default, { formError: updatePasswordResult && !updatePasswordResult.success && !formError ? updatePasswordResult : undefined, formSuccess: updatePasswordResult && updatePasswordResult.success ? updatePasswordResult : undefined })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SetUserPassword;
	}(_react.Component), _class.propTypes = {
	    submitFn: _propTypes2.default.func.isRequired,
	    user: _propTypes2.default.object,
	    updatePasswordResult: _propTypes2.default.object.isRequired
	}, _temp);
	SetUserPassword.displayName = "SetUserPassword";
	exports.default = SetUserPassword;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormField = __webpack_require__(1571);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormLabel = __webpack_require__(1572);
	
	var _FormLabel2 = _interopRequireDefault(_FormLabel);
	
	var _FormMessage = __webpack_require__(1573);
	
	var _FormMessage2 = _interopRequireDefault(_FormMessage);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UpdateUserDetails = (_temp = _class = function (_Component) {
	    _inherits(UpdateUserDetails, _Component);
	
	    function UpdateUserDetails(props, context) {
	        _classCallCheck(this, UpdateUserDetails);
	
	        var _this = _possibleConstructorReturn(this, (UpdateUserDetails.__proto__ || Object.getPrototypeOf(UpdateUserDetails)).call(this, props, context));
	
	        _this.state = { formError: null, valid: false };
	        return _this;
	    }
	
	    _createClass(UpdateUserDetails, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.validateForm();
	        }
	    }, {
	        key: "validateForm",
	        value: function validateForm() {
	            var valid = this.state.valid;
	
	            var isValid = true;
	
	            // required: first_name, last_name, email
	            for (var fieldName in this.refs) {
	                var node = _reactDom2.default.findDOMNode(this.refs[fieldName]);
	                if (node.required && _utils2.default.isEmpty(node.value)) isValid = false;
	            }
	
	            if (isValid !== valid) {
	                this.setState({
	                    'valid': isValid
	                });
	            }
	        }
	    }, {
	        key: "onChange",
	        value: function onChange() {
	            this.validateForm();
	        }
	    }, {
	        key: "formSubmitted",
	        value: function formSubmitted(e) {
	            e.preventDefault();
	
	            this.setState({
	                formError: null
	            });
	
	            var formErrors = { data: { errors: {} } };
	
	            // validate email address
	            if (!_utils2.default.validEmail(_reactDom2.default.findDOMNode(this.refs.email).value)) {
	                formErrors.data.errors.email = "Not a valid formatted email address";
	            }
	
	            if (_underscore2.default.keys(formErrors.data.errors).length > 0) {
	                this.setState({
	                    formError: formErrors
	                });
	                return;
	            }
	
	            var user = this.props.user ? _underscore2.default.clone(this.props.user) : {};
	
	            user.first_name = _reactDom2.default.findDOMNode(this.refs.firstName).value;
	            user.last_name = _reactDom2.default.findDOMNode(this.refs.lastName).value;
	            user.email = _reactDom2.default.findDOMNode(this.refs.email).value;
	
	            this.props.submitFn(user);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                updateUserResult = _props.updateUserResult,
	                user = _props.user;
	            var _state = this.state,
	                formError = _state.formError,
	                valid = _state.valid;
	
	            var managed = user.google_auth || user.ldap_auth;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "form",
	                    { className: "Form-new bordered rounded shadowed", onSubmit: this.formSubmitted.bind(this), noValidate: true },
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { fieldName: "first_name", formError: formError },
	                        _react2.default.createElement(_FormLabel2.default, { title: "First name", fieldName: "first_name", formError: formError }),
	                        _react2.default.createElement("input", { ref: "firstName", className: "Form-input Form-offset full", name: "name", defaultValue: user ? user.first_name : null, placeholder: "Johnny", onChange: this.onChange.bind(this) }),
	                        _react2.default.createElement("span", { className: "Form-charm" })
	                    ),
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { fieldName: "last_name", formError: formError },
	                        _react2.default.createElement(_FormLabel2.default, { title: "Last name", fieldName: "last_name", formError: formError }),
	                        _react2.default.createElement("input", { ref: "lastName", className: "Form-input Form-offset full", name: "name", defaultValue: user ? user.last_name : null, placeholder: "Appleseed", required: true, onChange: this.onChange.bind(this) }),
	                        _react2.default.createElement("span", { className: "Form-charm" })
	                    ),
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { fieldName: "email", formError: formError },
	                        _react2.default.createElement(_FormLabel2.default, { title: user.google_auth ? "Sign in with Google Email address" : "Email address", fieldName: "email", formError: formError }),
	                        _react2.default.createElement("input", {
	                            ref: "email",
	                            className: (0, _classnames2.default)("Form-offset full", {
	                                "Form-input": !managed,
	                                "text-grey-2 h1 borderless mt1": managed
	                            }),
	                            name: "email",
	                            defaultValue: user ? user.email : null,
	                            placeholder: "youlooknicetoday@email.com",
	                            required: true,
	                            onChange: this.onChange.bind(this),
	                            disabled: managed
	                        }),
	                        !managed && _react2.default.createElement("span", { className: "Form-charm" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Form-actions" },
	                        _react2.default.createElement(
	                            "button",
	                            { className: (0, _classnames2.default)("Button", { "Button--primary": valid }), disabled: !valid },
	                            "Save"
	                        ),
	                        _react2.default.createElement(_FormMessage2.default, { formError: updateUserResult && !updateUserResult.success ? updateUserResult : undefined, formSuccess: updateUserResult && updateUserResult.success ? updateUserResult : undefined })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UpdateUserDetails;
	}(_react.Component), _class.propTypes = {
	    submitFn: _propTypes2.default.func.isRequired,
	    user: _propTypes2.default.object,
	    updateUserResult: _propTypes2.default.object.isRequired
	}, _temp);
	UpdateUserDetails.displayName = "UpdateUserDetails";
	exports.default = UpdateUserDetails;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.selectors = undefined;
	
	var _reselect = __webpack_require__(1072);
	
	// our master selector which combines all of our partial selectors above
	var selectors = exports.selectors = (0, _reselect.createSelector)([function (state) {
		return state.user.tab;
	}, function (state) {
		return state.user.updatePasswordResult;
	}, function (state) {
		return state.user.updateUserResult;
	}], function (tab, updatePasswordResult, updateUserResult) {
		return { tab: tab, updatePasswordResult: updatePasswordResult, updateUserResult: updateUserResult };
	});

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateUser = exports.updatePassword = exports.setTab = exports.UPDATE_USER = exports.UPDATE_PASSWORD = exports.CHANGE_TAB = undefined;
	
	var _reduxActions = __webpack_require__(658);
	
	var _redux = __webpack_require__(657);
	
	var _services = __webpack_require__(857);
	
	var _user = __webpack_require__(862);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// action constants
	var CHANGE_TAB = exports.CHANGE_TAB = 'CHANGE_TAB';
	var UPDATE_PASSWORD = exports.UPDATE_PASSWORD = 'UPDATE_PASSWORD';
	var UPDATE_USER = exports.UPDATE_USER = 'UPDATE_USER';
	
	// action creators
	
	var setTab = exports.setTab = (0, _reduxActions.createAction)(CHANGE_TAB);
	
	var updatePassword = exports.updatePassword = (0, _redux.createThunkAction)(UPDATE_PASSWORD, function (user_id, new_password, current_password) {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _services.UserApi.update_password({
	                                id: user_id,
	                                password: new_password,
	                                old_password: current_password
	                            });
	
	                        case 3:
	                            return _context.abrupt("return", {
	                                success: true,
	                                data: {
	                                    message: "Password updated successfully!"
	                                }
	                            });
	
	                        case 6:
	                            _context.prev = 6;
	                            _context.t0 = _context["catch"](0);
	                            return _context.abrupt("return", _context.t0);
	
	                        case 9:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[0, 6]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var updateUser = exports.updateUser = (0, _redux.createThunkAction)(UPDATE_USER, function (user) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _services.UserApi.update(user);
	
	                        case 3:
	
	                            dispatch((0, _user.refreshCurrentUser)());
	
	                            return _context2.abrupt("return", {
	                                success: true,
	                                data: {
	                                    message: "Account updated successfully!"
	                                }
	                            });
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2["catch"](0);
	                            return _context2.abrupt("return", _context2.t0);
	
	                        case 10:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[0, 7]]);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NewQuestionMetricSearch = exports.NewQuestionStart = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _dec3, _dec4, _class3;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _Background = __webpack_require__(1594);
	
	var _NewQueryOptions = __webpack_require__(1803);
	
	var _NewQueryOptions2 = _interopRequireDefault(_NewQueryOptions);
	
	var _MetricSearch = __webpack_require__(1807);
	
	var _MetricSearch2 = _interopRequireDefault(_MetricSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewQuestionStart = exports.NewQuestionStart = (_dec = (0, _reactRedux.connect)(null, { onChangeLocation: _reactRouterRedux.push }), _dec2 = (0, _Background.withBackground)('bg-slate-extra-light'), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(NewQuestionStart, _Component);
	
	    function NewQuestionStart() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NewQuestionStart);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewQuestionStart.__proto__ || Object.getPrototypeOf(NewQuestionStart)).call.apply(_ref, [this].concat(args))), _this), _this.getUrlForQuery = function (query) {
	            return query.question().getUrl();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NewQuestionStart, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_NewQueryOptions2.default, {
	                getUrlForQuery: this.getUrlForQuery,
	                metricSearchUrl: "/question/new/metric",
	                segmentSearchUrl: "/question/new/segment"
	            });
	        }
	    }]);
	
	    return NewQuestionStart;
	}(_react.Component)) || _class) || _class);
	NewQuestionStart.displayName = "NewQuestionStart";
	var NewQuestionMetricSearch = exports.NewQuestionMetricSearch = (_dec3 = (0, _reactRedux.connect)(null, { onChangeLocation: _reactRouterRedux.push }), _dec4 = (0, _Background.withBackground)('bg-slate-extra-light'), _dec3(_class3 = _dec4(_class3 = function (_Component2) {
	    _inherits(NewQuestionMetricSearch, _Component2);
	
	    function NewQuestionMetricSearch() {
	        var _ref2;
	
	        var _temp2, _this2, _ret2;
	
	        _classCallCheck(this, NewQuestionMetricSearch);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = NewQuestionMetricSearch.__proto__ || Object.getPrototypeOf(NewQuestionMetricSearch)).call.apply(_ref2, [this].concat(args))), _this2), _this2.getUrlForQuery = function (query) {
	            return query.question().getUrl();
	        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    _createClass(NewQuestionMetricSearch, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_MetricSearch2.default, {
	                getUrlForQuery: this.getUrlForQuery,
	                backButtonUrl: "/question/new"
	            });
	        }
	    }]);
	
	    return NewQuestionMetricSearch;
	}(_react.Component)) || _class3) || _class3);
	NewQuestionMetricSearch.displayName = "NewQuestionMetricSearch";

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NewQueryOptions = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _metadata = __webpack_require__(1110);
	
	var _Background = __webpack_require__(1594);
	
	var _new_query = __webpack_require__(1804);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _metadata2 = __webpack_require__(1073);
	
	var _NewQueryOption = __webpack_require__(1805);
	
	var _NewQueryOption2 = _interopRequireDefault(_NewQueryOption);
	
	var _NativeQuery = __webpack_require__(954);
	
	var _NativeQuery2 = _interopRequireDefault(_NativeQuery);
	
	var _selectors = __webpack_require__(1806);
	
	var _user = __webpack_require__(1127);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        query: (0, _selectors.getCurrentQuery)(state),
	        plainNativeQuery: (0, _selectors.getPlainNativeQuery)(state),
	        metadata: (0, _metadata2.getMetadata)(state),
	        metadataFetched: (0, _metadata2.getMetadataFetched)(state),
	        isAdmin: (0, _user.getUserIsAdmin)(state)
	    };
	};
	
	var mapDispatchToProps = {
	    fetchDatabases: _metadata.fetchDatabases,
	    fetchMetrics: _metadata.fetchMetrics,
	    fetchSegments: _metadata.fetchSegments,
	    resetQuery: _new_query.resetQuery,
	    push: _reactRouterRedux.push
	};
	
	var NewQueryOptions = exports.NewQueryOptions = function (_Component) {
	    _inherits(NewQueryOptions, _Component);
	
	    function NewQueryOptions() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NewQueryOptions);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewQueryOptions.__proto__ || Object.getPrototypeOf(NewQueryOptions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            showMetricOption: false,
	            showSegmentOption: false,
	            showSQLOption: false
	        }, _this.getGuiQueryUrl = function () {
	            return _this.props.getUrlForQuery(_this.props.query);
	        }, _this.getNativeQueryUrl = function () {
	            return _this.props.getUrlForQuery(_this.props.plainNativeQuery);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NewQueryOptions, [{
	        key: 'determinePaths',
	        value: function determinePaths() {
	            var _props = this.props,
	                isAdmin = _props.isAdmin,
	                metadata = _props.metadata,
	                push = _props.push;
	
	            var showMetricOption = isAdmin || metadata.metricsList().length > 0;
	            var showSegmentOption = isAdmin || metadata.segmentsList().length > 0;
	
	            // util to check if the user has write permission to a db
	            var hasSQLPermission = function hasSQLPermission(db) {
	                return db.native_permissions === "write";
	            };
	
	            // to be able to use SQL the user must have write permissions on at least one db
	            var showSQLOption = isAdmin || metadata.databasesList().filter(hasSQLPermission).length > 0;
	
	            // if we can only show one option then we should just redirect
	            if (!showMetricOption && !showSQLOption && !showSegmentOption) {
	                push(this.getGuiQueryUrl());
	            }
	
	            this.setState({
	                showMetricOption: showMetricOption,
	                showSegmentOption: showSegmentOption,
	                showSQLOption: showSQLOption
	            });
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.fetchDatabases();
	
	                            case 2:
	                                _context.next = 4;
	                                return this.props.fetchMetrics();
	
	                            case 4:
	                                _context.next = 6;
	                                return this.props.fetchSegments();
	
	                            case 6:
	                                _context.next = 8;
	                                return this.props.resetQuery();
	
	                            case 8:
	
	                                this.determinePaths();
	
	                            case 9:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                query = _props2.query,
	                metadataFetched = _props2.metadataFetched,
	                isAdmin = _props2.isAdmin,
	                metricSearchUrl = _props2.metricSearchUrl;
	            var _state = this.state,
	                showMetricOption = _state.showMetricOption,
	                showSQLOption = _state.showSQLOption;
	
	            var showCustomInsteadOfNewQuestionText = showMetricOption || isAdmin;
	
	            if (!query || !isAdmin && (!metadataFetched.metrics || !metadataFetched.segments)) {
	                return _react2.default.createElement(_LoadingAndErrorWrapper2.default, { loading: true });
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'full-height flex' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wrapper wrapper--trim lg-wrapper--trim xl-wrapper--trim flex-full px1 mt4 mb2 align-center' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex align-center justify-center', style: { minHeight: "100%" } },
	                        _react2.default.createElement(
	                            'ol',
	                            { className: 'flex-full Grid Grid--guttersXl Grid--full sm-Grid--normal' },
	                            (showMetricOption || isAdmin) && _react2.default.createElement(
	                                'li',
	                                { className: 'Grid-cell' },
	                                _react2.default.createElement(_NewQueryOption2.default, {
	                                    image: '/app/img/questions_illustration',
	                                    title: 'Metrics',
	                                    description: 'See data over time, as a map, or pivoted to help you understand trends or changes.',
	                                    to: metricSearchUrl
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: 'Grid-cell' },
	                                _react2.default.createElement(_NewQueryOption2.default, {
	                                    image: '/app/img/query_builder_illustration',
	                                    title: showCustomInsteadOfNewQuestionText ? "Custom" : "New question",
	                                    description: 'Use the simple query builder to see trends, lists of things, or to create your own metrics.',
	                                    width: 180,
	                                    to: this.getGuiQueryUrl
	                                })
	                            ),
	                            (showSQLOption || isAdmin) && _react2.default.createElement(
	                                'li',
	                                { className: 'Grid-cell' },
	                                _react2.default.createElement(_NewQueryOption2.default, {
	                                    image: '/app/img/sql_illustration',
	                                    title: 'SQL',
	                                    description: 'For more complicated questions, you can write your own SQL.',
	                                    to: this.getNativeQueryUrl
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NewQueryOptions;
	}(_react.Component);
	
	NewQueryOptions.displayName = 'NewQueryOptions';
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _Background.withBackground)('bg-slate-extra-light')(NewQueryOptions));

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RESET_QUERY = undefined;
	exports.resetQuery = resetQuery;
	
	var _redux = __webpack_require__(657);
	
	var _StructuredQuery = __webpack_require__(947);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
	                                                                                                                                                                                                                   * Redux actions and reducers for the new query flow
	                                                                                                                                                                                                                   * (used both for new questions and for adding "ad-hoc metrics" to multi-query questions)
	                                                                                                                                                                                                                   */
	
	/**
	 * Initializes the new query flow for a given question
	 */
	var RESET_QUERY = exports.RESET_QUERY = "metabase/new_query/RESET_QUERY";
	function resetQuery() {
	    return function (dispatch, getState) {
	        dispatch.action(RESET_QUERY, _StructuredQuery.STRUCTURED_QUERY_TEMPLATE);
	    };
	}
	
	/**
	 * The current query that we are creating
	 */
	// something like const query = handleActions<DatasetQuery>({
	var datasetQuery = (0, _redux.handleActions)(_defineProperty({}, RESET_QUERY, function (state, _ref) {
	    var payload = _ref.payload;
	    return payload;
	}), _StructuredQuery.STRUCTURED_QUERY_TEMPLATE);
	
	exports.default = (0, _redux.combineReducers)({
	    datasetQuery: datasetQuery
	});

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(1128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewQueryOption = function (_Component) {
	    _inherits(NewQueryOption, _Component);
	
	    function NewQueryOption() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, NewQueryOption);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewQueryOption.__proto__ || Object.getPrototypeOf(NewQueryOption)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            hover: false
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(NewQueryOption, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                width = _props.width,
	                image = _props.image,
	                title = _props.title,
	                description = _props.description,
	                to = _props.to;
	            var hover = this.state.hover;
	
	
	            return _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                    className: "block no-decoration bg-white px3 pt4 align-center bordered rounded cursor-pointer transition-all text-centered",
	                    style: {
	                        boxSizing: "border-box",
	                        boxShadow: hover ? "0 3px 8px 0 rgba(220,220,220,0.50)" : "0 1px 3px 0 rgba(220,220,220,0.50)",
	                        height: 340
	                    },
	                    onMouseOver: function onMouseOver() {
	                        return _this2.setState({ hover: true });
	                    },
	                    onMouseLeave: function onMouseLeave() {
	                        return _this2.setState({ hover: false });
	                    },
	                    to: to
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center layout-centered", style: { height: "160px" } },
	                    _react2.default.createElement("img", {
	                        src: image + ".png",
	                        style: { width: width ? width + "px" : "210px" },
	                        srcSet: image + "@2x.png 2x"
	                    })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "text-normal mt2 mb2 text-paragraph", style: { lineHeight: "1.25em" } },
	                    _react2.default.createElement(
	                        "h2",
	                        { className: (0, _classnames2.default)("transition-all", { "text-brand": hover }) },
	                        title
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "text-grey-4 text-small" },
	                        description
	                    )
	                )
	            );
	        }
	    }]);
	
	    return NewQueryOption;
	}(_react.Component);
	
	NewQueryOption.displayName = "NewQueryOption";
	exports.default = NewQueryOption;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getPlainNativeQuery = exports.getCurrentQuery = undefined;
	
	var _metadata = __webpack_require__(1073);
	
	var _StructuredQuery = __webpack_require__(947);
	
	var _StructuredQuery2 = _interopRequireDefault(_StructuredQuery);
	
	var _NativeQuery = __webpack_require__(954);
	
	var _NativeQuery2 = _interopRequireDefault(_NativeQuery);
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Redux selectors for the new query flow
	 * (used both for new questions and for adding "ad-hoc metrics" to multi-query questions)
	 */
	
	var getCurrentQuery = exports.getCurrentQuery = function getCurrentQuery(state) {
	    // NOTE Atte Keinänen 8/14/17: This is a useless question that will go away after query lib refactoring
	    var question = _Question2.default.create({ metadata: (0, _metadata.getMetadata)(state) });
	    var datasetQuery = state.new_query.datasetQuery;
	    return new _StructuredQuery2.default(question, datasetQuery);
	};
	
	var getPlainNativeQuery = exports.getPlainNativeQuery = function getPlainNativeQuery(state) {
	    var metadata = (0, _metadata.getMetadata)(state);
	    var question = _Question2.default.create({ metadata: (0, _metadata.getMetadata)(state) });
	    var databases = metadata.databasesList().filter(function (db) {
	        return !db.is_saved_questions && db.native_permissions === "write";
	    });
	
	    // If we only have a single database, then default to that
	    // (native query editor doesn't currently show the db selector if there is only one database available)
	    if (databases.length === 1) {
	        return new _NativeQuery2.default(question).setDatabase(databases[0]);
	    } else {
	        return new _NativeQuery2.default(question);
	    }
	};

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _metadata = __webpack_require__(1110);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _EntitySearch = __webpack_require__(1808);
	
	var _EntitySearch2 = _interopRequireDefault(_EntitySearch);
	
	var _metadata2 = __webpack_require__(1073);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _selectors = __webpack_require__(1806);
	
	var _new_query = __webpack_require__(1804);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        query: (0, _selectors.getCurrentQuery)(state),
	        metadata: (0, _metadata2.getMetadata)(state),
	        metadataFetched: (0, _metadata2.getMetadataFetched)(state)
	    };
	};
	var mapDispatchToProps = {
	    fetchMetrics: _metadata.fetchMetrics,
	    fetchDatabases: _metadata.fetchDatabases,
	    resetQuery: _new_query.resetQuery
	};
	
	var MetricSearch = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(MetricSearch, _Component);
	
	    function MetricSearch() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, MetricSearch);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MetricSearch.__proto__ || Object.getPrototypeOf(MetricSearch)).call.apply(_ref, [this].concat(args))), _this), _this.getUrlForMetric = function (metric) {
	            var updatedQuery = _this.props.query.setDatabase(metric.table.db).setTable(metric.table).addAggregation(metric.aggregationClause());
	
	            return _this.props.getUrlForQuery(updatedQuery);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(MetricSearch, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.fetchDatabases(); // load databases if not loaded yet
	            this.props.fetchMetrics(true); // metrics may change more often so always reload them
	            this.props.resetQuery();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                backButtonUrl = _props.backButtonUrl,
	                metadataFetched = _props.metadataFetched,
	                metadata = _props.metadata;
	
	            var isLoading = !metadataFetched.metrics || !metadataFetched.databases;
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: isLoading },
	                function () {
	                    var sortedActiveMetrics = _underscore2.default.chain(metadata.metricsList())
	                    // Metric shouldn't be retired and it should refer to an existing table
	                    .filter(function (metric) {
	                        return metric.isActive() && metric.table;
	                    }).sortBy(function (_ref2) {
	                        var name = _ref2.name;
	                        return name.toLowerCase();
	                    }).value();
	
	                    if (sortedActiveMetrics.length > 0) {
	                        return _react2.default.createElement(_EntitySearch2.default, {
	                            title: 'Which metric?'
	                            // TODO Atte Keinänen 8/22/17: If you call `/api/table/:id/table_metadata` it returns
	                            // all metrics (also retired ones) and is missing `is_active` prop. Currently this
	                            // filters them out but we should definitely update the endpoints in the upcoming metadata API refactoring.
	                            , entities: sortedActiveMetrics,
	                            getUrlForEntity: _this2.getUrlForMetric,
	                            backButtonUrl: backButtonUrl
	                        });
	                    } else {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'mt2 flex-full flex align-center justify-center' },
	                            _react2.default.createElement(_EmptyState2.default, {
	                                message: _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Defining common metrics for your team makes it even easier to ask questions'
	                                ),
	                                image: '/app/img/metrics_illustration',
	                                action: 'How to create metrics',
	                                link: 'http://www.metabase.com/docs/latest/administration-guide/07-segments-and-metrics.html',
	                                className: 'mt2',
	                                imageClassName: 'mln2'
	                            })
	                        );
	                    }
	                }
	            );
	        }
	    }]);
	
	    return MetricSearch;
	}(_react.Component)) || _class);
	MetricSearch.displayName = 'MetricSearch';
	exports.default = MetricSearch;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SearchResultListItem = exports.SearchResultsGroup = exports.GroupedSearchResultsList = exports.SearchGroupingOption = exports.SearchGroupingOptions = exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _dec2, _class6;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SearchHeader = __webpack_require__(1598);
	
	var _SearchHeader2 = _interopRequireDefault(_SearchHeader);
	
	var _DirectionalButton = __webpack_require__(1498);
	
	var _DirectionalButton2 = _interopRequireDefault(_DirectionalButton);
	
	var _string = __webpack_require__(955);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _keyboard = __webpack_require__(934);
	
	var _index = __webpack_require__(1809);
	
	var _browser = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PAGE_SIZE = 10;
	
	var SEARCH_GROUPINGS = [{
	    id: "name",
	    name: "Name",
	    icon: null,
	    // Name grouping is a no-op grouping so always put all results to same group with identifier `0`
	    groupBy: function groupBy() {
	        return 0;
	    },
	    // Setting name to null hides the group header in SearchResultsGroup component
	    getGroupName: function getGroupName() {
	        return null;
	    }
	}, {
	    id: "table",
	    name: "Table",
	    icon: "table2",
	    groupBy: function groupBy(entity) {
	        return entity.table.id;
	    },
	    getGroupName: function getGroupName(entity) {
	        return entity.table.display_name;
	    }
	}, {
	    id: "database",
	    name: "Database",
	    icon: "database",
	    groupBy: function groupBy(entity) {
	        return entity.table.db.id;
	    },
	    getGroupName: function getGroupName(entity) {
	        return entity.table.db.name;
	    }
	}, {
	    id: "creator",
	    name: "Creator",
	    icon: "mine",
	    groupBy: function groupBy(entity) {
	        return entity.creator.id;
	    },
	    getGroupName: function getGroupName(entity) {
	        return entity.creator.common_name;
	    }
	}];
	var DEFAULT_SEARCH_GROUPING = SEARCH_GROUPINGS[0];
	
	var EntitySearch = (_dec = (0, _reactRedux.connect)(null, { onReplaceLocation: _reactRouterRedux.replace, onChangeLocation: _reactRouterRedux.push }), _dec(_class = (0, _reactRouter.withRouter)(_class = function (_Component) {
	    _inherits(EntitySearch, _Component);
	
	    function EntitySearch(props) {
	        _classCallCheck(this, EntitySearch);
	
	        var _this = _possibleConstructorReturn(this, (EntitySearch.__proto__ || Object.getPrototypeOf(EntitySearch)).call(this, props));
	
	        _this.componentDidMount = function () {
	            _this.parseQueryString();
	        };
	
	        _this.componentWillReceiveProps = function (nextProps) {
	            _this.applyFiltersForEntities(nextProps.entities);
	        };
	
	        _this.parseQueryString = function () {
	            var options = (0, _browser.parseHashOptions)(_this.props.location.search.substring(1));
	            if (Object.keys(options).length > 0) {
	                if (options.search) {
	                    _this.setSearchText(String(options.search));
	                }
	                if (options.grouping) {
	                    var _grouping = SEARCH_GROUPINGS.find(function (grouping) {
	                        return grouping.id === options.grouping;
	                    });
	                    if (_grouping) {
	                        _this.setGrouping(_grouping);
	                    }
	                }
	            }
	        };
	
	        _this.updateUrl = function (queryOptionsUpdater) {
	            var _this$props = _this.props,
	                onReplaceLocation = _this$props.onReplaceLocation,
	                location = _this$props.location;
	
	            onReplaceLocation((0, _browser.updateQueryString)(location, queryOptionsUpdater));
	        };
	
	        _this.setSearchText = function (searchText) {
	            _this.setState({ searchText: searchText }, _this.applyFiltersAfterFilterChange);
	            _this.updateUrl(function (currentOptions) {
	                return searchText !== "" ? _extends({}, currentOptions, { search: searchText }) : _underscore2.default.omit(currentOptions, 'search');
	            });
	        };
	
	        _this.resetSearchText = function () {
	            _this.setSearchText("");
	            _this.searchHeaderInput.focus();
	        };
	
	        _this.applyFiltersAfterFilterChange = function () {
	            return _this.applyFiltersForEntities(_this.props.entities);
	        };
	
	        _this.applyFiltersForEntities = function (entities) {
	            var searchText = _this.state.searchText;
	
	
	            if (searchText !== "") {
	                var filteredEntities = entities.filter(function (_ref) {
	                    var name = _ref.name,
	                        description = _ref.description;
	                    return (0, _string.caseInsensitiveSearch)(name, searchText);
	                });
	
	                _this.setState({ filteredEntities: filteredEntities });
	            } else {
	                _this.setState({ filteredEntities: entities });
	            }
	        };
	
	        _this.setGrouping = function (grouping) {
	            _this.setState({ currentGrouping: grouping });
	            _this.updateUrl(function (currentOptions) {
	                return grouping !== DEFAULT_SEARCH_GROUPING ? _extends({}, currentOptions, { grouping: grouping.id }) : _underscore2.default.omit(currentOptions, 'grouping');
	            });
	            _this.searchHeaderInput.focus();
	        };
	
	        _this.getGroups = function () {
	            var _this$state = _this.state,
	                currentGrouping = _this$state.currentGrouping,
	                filteredEntities = _this$state.filteredEntities;
	
	
	            return _underscore2.default.chain(filteredEntities).groupBy(currentGrouping.groupBy).pairs().map(function (_ref2) {
	                var _ref3 = _slicedToArray(_ref2, 2),
	                    groupId = _ref3[0],
	                    entitiesInGroup = _ref3[1];
	
	                return {
	                    groupName: currentGrouping.getGroupName(entitiesInGroup[0]),
	                    entitiesInGroup: entitiesInGroup
	                };
	            }).sortBy(function (_ref4) {
	                var groupName = _ref4.groupName;
	                return groupName !== null && groupName.toLowerCase();
	            }).value();
	        };
	
	        _this.state = {
	            filteredEntities: props.entities,
	            currentGrouping: DEFAULT_SEARCH_GROUPING,
	            searchText: ""
	        };
	        return _this;
	    }
	
	    // Returns an array of groups based on current grouping. The groups are sorted by their name.
	    // Entities inside each group aren't separately sorted as EntitySearch expects that the `entities`
	    // is already in the desired order.
	
	
	    _createClass(EntitySearch, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                title = _props.title,
	                backButtonUrl = _props.backButtonUrl,
	                getUrlForEntity = _props.getUrlForEntity,
	                onChangeLocation = _props.onChangeLocation;
	            var _state = this.state,
	                searchText = _state.searchText,
	                currentGrouping = _state.currentGrouping,
	                filteredEntities = _state.filteredEntities;
	
	
	            var hasUngroupedResults = currentGrouping === DEFAULT_SEARCH_GROUPING && filteredEntities.length > 0;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'bg-slate-extra-light full Entity-search' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'wrapper wrapper--small pt4 pb4' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex mb4 align-center', style: { height: "50px" } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'Entity-search-back-button mr2', onClick: function onClick() {
	                                    return backButtonUrl ? onChangeLocation(backButtonUrl) : window.history.back();
	                                } },
	                            _react2.default.createElement(_DirectionalButton2.default, { direction: 'back' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'text-centered flex-full' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                title
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(SearchGroupingOptions, {
	                            currentGrouping: currentGrouping,
	                            setGrouping: this.setGrouping
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                className: (0, _classnames2.default)("bg-white bordered", { "rounded": !hasUngroupedResults }, { "rounded-top": hasUngroupedResults }),
	                                style: { padding: "5px 15px" }
	                            },
	                            _react2.default.createElement(_SearchHeader2.default, {
	                                searchText: searchText,
	                                setSearchText: this.setSearchText,
	                                autoFocus: true,
	                                inputRef: function inputRef(el) {
	                                    return _this2.searchHeaderInput = el;
	                                },
	                                resetSearchText: this.resetSearchText
	                            })
	                        ),
	                        filteredEntities.length > 0 && _react2.default.createElement(GroupedSearchResultsList, {
	                            groupingIcon: currentGrouping.icon,
	                            groups: this.getGroups(),
	                            getUrlForEntity: getUrlForEntity
	                        }),
	                        filteredEntities.length === 0 && _react2.default.createElement(
	                            'div',
	                            { className: 'mt4' },
	                            _react2.default.createElement(_EmptyState2.default, {
	                                message: _react2.default.createElement(
	                                    'div',
	                                    { className: 'mt4' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { className: 'text-grey-5' },
	                                        'No results found'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'text-grey-4' },
	                                        'Try adjusting your filter to find what you\u2019re looking for.'
	                                    )
	                                ),
	                                image: '/app/img/empty_question',
	                                imageHeight: '213px',
	                                imageClassName: 'mln2',
	                                smallDescription: true
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EntitySearch;
	}(_react.Component)) || _class) || _class);
	EntitySearch.displayName = 'EntitySearch';
	exports.default = EntitySearch;
	var SearchGroupingOptions = exports.SearchGroupingOptions = function SearchGroupingOptions(_ref5) {
	    var currentGrouping = _ref5.currentGrouping,
	        setGrouping = _ref5.setGrouping;
	    return _react2.default.createElement(
	        'div',
	        { className: 'Entity-search-grouping-options' },
	        _react2.default.createElement(
	            'h3',
	            { className: 'mb3' },
	            'View by'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            SEARCH_GROUPINGS.map(function (groupingOption) {
	                return _react2.default.createElement(SearchGroupingOption, {
	                    key: groupingOption.name,
	                    grouping: groupingOption,
	                    active: currentGrouping === groupingOption,
	                    setGrouping: setGrouping
	                });
	            })
	        )
	    );
	};
	
	SearchGroupingOptions.displayName = 'SearchGroupingOptions';
	
	var SearchGroupingOption = exports.SearchGroupingOption = function (_Component2) {
	    _inherits(SearchGroupingOption, _Component2);
	
	    function SearchGroupingOption() {
	        var _ref6;
	
	        var _temp, _this3, _ret;
	
	        _classCallCheck(this, SearchGroupingOption);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref6 = SearchGroupingOption.__proto__ || Object.getPrototypeOf(SearchGroupingOption)).call.apply(_ref6, [this].concat(args))), _this3), _this3.onSetGrouping = function () {
	            _this3.props.setGrouping(_this3.props.grouping);
	        }, _temp), _possibleConstructorReturn(_this3, _ret);
	    }
	
	    _createClass(SearchGroupingOption, [{
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                grouping = _props2.grouping,
	                active = _props2.active;
	
	
	            return _react2.default.createElement(
	                'li',
	                {
	                    className: (0, _classnames2.default)("my2 cursor-pointer text-uppercase text-small text-green-saturated-hover", { "text-grey-4": !active }, { "text-green-saturated": active }),
	                    onClick: this.onSetGrouping
	                },
	                grouping.name
	            );
	        }
	    }]);
	
	    return SearchGroupingOption;
	}(_react.Component);
	
	SearchGroupingOption.displayName = 'SearchGroupingOption';
	
	var GroupedSearchResultsList = exports.GroupedSearchResultsList = function (_Component3) {
	    _inherits(GroupedSearchResultsList, _Component3);
	
	    function GroupedSearchResultsList() {
	        var _ref7;
	
	        var _temp2, _this4, _ret2;
	
	        _classCallCheck(this, GroupedSearchResultsList);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref7 = GroupedSearchResultsList.__proto__ || Object.getPrototypeOf(GroupedSearchResultsList)).call.apply(_ref7, [this].concat(args))), _this4), _this4.state = {
	            highlightedItemIndex: 0,
	            // `currentPages` is used as a map-like structure for storing the current pagination page for each group.
	            // If a given group has no value in currentPages, then it is assumed to be in the first page (`0`).
	            currentPages: {}
	        }, _this4.onKeyDown = function (e) {
	            var highlightedItemIndex = _this4.state.highlightedItemIndex;
	
	
	            if (e.keyCode === _keyboard.KEYCODE_UP) {
	                _this4.setState({ highlightedItemIndex: Math.max(0, highlightedItemIndex - 1) });
	                e.preventDefault();
	            } else if (e.keyCode === _keyboard.KEYCODE_DOWN) {
	                var visibleEntityCount = _this4.getVisibleEntityCounts().reduce(function (a, b) {
	                    return a + b;
	                });
	                _this4.setState({ highlightedItemIndex: Math.min(highlightedItemIndex + 1, visibleEntityCount - 1) });
	                e.preventDefault();
	            }
	        }, _this4.setCurrentPage = function (entities, page) {
	            var groups = _this4.props.groups;
	            var currentPages = _this4.state.currentPages;
	
	            var groupIndex = groups.findIndex(function (group) {
	                return group.entitiesInGroup === entities;
	            });
	
	            _this4.setState({
	                highlightedItemIndex: 0,
	                currentPages: _extends({}, currentPages, _defineProperty({}, groupIndex, page))
	            });
	        }, _temp2), _possibleConstructorReturn(_this4, _ret2);
	    }
	
	    _createClass(GroupedSearchResultsList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("keydown", this.onKeyDown, true);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("keydown", this.onKeyDown, true);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps() {
	            this.setState({
	                highlightedItemIndex: 0,
	                currentPages: {}
	            });
	        }
	
	        /**
	         * Returns the count of currently visible entities for each result group.
	         */
	
	    }, {
	        key: 'getVisibleEntityCounts',
	        value: function getVisibleEntityCounts() {
	            var groups = this.props.groups;
	            var currentPages = this.state.currentPages;
	
	            return groups.map(function (group, index) {
	                return Math.min(PAGE_SIZE, group.entitiesInGroup.length - (currentPages[index] || 0) * PAGE_SIZE);
	            });
	        }
	    }, {
	        key: 'getHighlightPosition',
	
	
	        /**
	         * Returns `{ groupIndex, itemIndex }` which describes that which item in which group is currently highlighted.
	         * Calculates it based on current visible entities (as pagination affects which entities are visible on given time)
	         * and the current highlight index that is modified with up and down arrow keys
	         */
	        value: function getHighlightPosition() {
	            var highlightedItemIndex = this.state.highlightedItemIndex;
	
	            var visibleEntityCounts = this.getVisibleEntityCounts();
	
	            var entitiesInPreviousGroups = 0;
	            for (var groupIndex = 0; groupIndex < visibleEntityCounts.length; groupIndex++) {
	                var visibleEntityCount = visibleEntityCounts[groupIndex];
	                var indexInCurrentGroup = highlightedItemIndex - entitiesInPreviousGroups;
	
	                if (indexInCurrentGroup <= visibleEntityCount - 1) {
	                    return { groupIndex: groupIndex, itemIndex: indexInCurrentGroup };
	                }
	
	                entitiesInPreviousGroups += visibleEntityCount;
	            }
	        }
	
	        /**
	         * Sets the current pagination page by finding the group that match the `entities` list of entities
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            var _props3 = this.props,
	                groupingIcon = _props3.groupingIcon,
	                groups = _props3.groups,
	                getUrlForEntity = _props3.getUrlForEntity;
	            var currentPages = this.state.currentPages;
	
	
	            var highlightPosition = this.getHighlightPosition(groups);
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'full' },
	                groups.map(function (_ref8, groupIndex) {
	                    var groupName = _ref8.groupName,
	                        entitiesInGroup = _ref8.entitiesInGroup;
	                    return _react2.default.createElement(SearchResultsGroup, {
	                        key: groupIndex,
	                        groupName: groupName,
	                        groupIcon: groupingIcon,
	                        entities: entitiesInGroup,
	                        getUrlForEntity: getUrlForEntity,
	                        highlightItemAtIndex: groupIndex === highlightPosition.groupIndex ? highlightPosition.itemIndex : undefined,
	                        currentPage: currentPages[groupIndex] || 0,
	                        setCurrentPage: _this5.setCurrentPage
	                    });
	                })
	            );
	        }
	    }]);
	
	    return GroupedSearchResultsList;
	}(_react.Component);
	
	GroupedSearchResultsList.displayName = 'GroupedSearchResultsList';
	var SearchResultsGroup = exports.SearchResultsGroup = function SearchResultsGroup(_ref9) {
	    var groupName = _ref9.groupName,
	        groupIcon = _ref9.groupIcon,
	        entities = _ref9.entities,
	        getUrlForEntity = _ref9.getUrlForEntity,
	        highlightItemAtIndex = _ref9.highlightItemAtIndex,
	        currentPage = _ref9.currentPage,
	        setCurrentPage = _ref9.setCurrentPage;
	    return _react2.default.createElement(
	        'div',
	        null,
	        groupName !== null && _react2.default.createElement(
	            'div',
	            { className: 'flex align-center bg-slate-almost-extra-light bordered mt3 px3 py2' },
	            _react2.default.createElement(_Icon2.default, { className: 'mr1', style: { color: "#BCC5CA" }, name: groupIcon }),
	            _react2.default.createElement(
	                'h4',
	                null,
	                groupName
	            )
	        ),
	        _react2.default.createElement(SearchResultsList, {
	            entities: entities,
	            getUrlForEntity: getUrlForEntity,
	            highlightItemAtIndex: highlightItemAtIndex,
	            currentPage: currentPage,
	            setCurrentPage: setCurrentPage
	        })
	    );
	};
	
	SearchResultsGroup.displayName = 'SearchResultsGroup';
	
	var SearchResultsList = function (_Component4) {
	    _inherits(SearchResultsList, _Component4);
	
	    function SearchResultsList() {
	        var _ref10;
	
	        var _temp3, _this6, _ret3;
	
	        _classCallCheck(this, SearchResultsList);
	
	        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	            args[_key3] = arguments[_key3];
	        }
	
	        return _ret3 = (_temp3 = (_this6 = _possibleConstructorReturn(this, (_ref10 = SearchResultsList.__proto__ || Object.getPrototypeOf(SearchResultsList)).call.apply(_ref10, [this].concat(args))), _this6), _this6.state = {
	            page: 0
	        }, _this6.getPaginationSection = function (start, end, entityCount) {
	            var _this6$props = _this6.props,
	                entities = _this6$props.entities,
	                currentPage = _this6$props.currentPage,
	                setCurrentPage = _this6$props.setCurrentPage;
	
	
	            var currentEntitiesText = start === end ? '' + (start + 1) : start + 1 + '-' + (end + 1);
	            var isInBeginning = start === 0;
	            var isInEnd = end + 1 >= entityCount;
	
	            return _react2.default.createElement(
	                'li',
	                { className: 'py1 px3 flex justify-end align-center' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'text-bold' },
	                    currentEntitiesText
	                ),
	                '\xA0of\xA0',
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: 'text-bold' },
	                    entityCount
	                ),
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: (0, _classnames2.default)("mx1 flex align-center justify-center rounded", { "cursor-pointer bg-grey-2 text-white": !isInBeginning }, { "bg-grey-0 text-grey-1": isInBeginning }),
	                        style: { width: "22px", height: "22px" },
	                        onClick: function onClick() {
	                            return !isInBeginning && setCurrentPage(entities, currentPage - 1);
	                        } },
	                    _react2.default.createElement(_Icon2.default, { name: 'chevronleft', size: 14 })
	                ),
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: (0, _classnames2.default)("flex align-center justify-center rounded", { "cursor-pointer bg-grey-2 text-white": !isInEnd }, { "bg-grey-0 text-grey-2": isInEnd }),
	                        style: { width: "22px", height: "22px" },
	                        onClick: function onClick() {
	                            return !isInEnd && setCurrentPage(entities, currentPage + 1);
	                        } },
	                    _react2.default.createElement(_Icon2.default, { name: 'chevronright', size: 14 })
	                )
	            );
	        }, _temp3), _possibleConstructorReturn(_this6, _ret3);
	    }
	
	    _createClass(SearchResultsList, [{
	        key: 'render',
	        value: function render() {
	            var _props4 = this.props,
	                currentPage = _props4.currentPage,
	                entities = _props4.entities,
	                getUrlForEntity = _props4.getUrlForEntity,
	                highlightItemAtIndex = _props4.highlightItemAtIndex;
	
	
	            var showPagination = PAGE_SIZE < entities.length;
	
	            var start = PAGE_SIZE * currentPage;
	            var end = Math.min(entities.length - 1, PAGE_SIZE * (currentPage + 1) - 1);
	            var entityCount = entities.length;
	
	            var entitiesInCurrentPage = entities.slice(start, end + 1);
	
	            return _react2.default.createElement(
	                'ol',
	                { className: 'Entity-search-results-list flex-full bg-white border-left border-right border-bottom rounded-bottom' },
	                entitiesInCurrentPage.map(function (entity, index) {
	                    return _react2.default.createElement(SearchResultListItem, { key: index, entity: entity, getUrlForEntity: getUrlForEntity, highlight: highlightItemAtIndex === index });
	                }),
	                showPagination && this.getPaginationSection(start, end, entityCount)
	            );
	        }
	    }]);
	
	    return SearchResultsList;
	}(_react.Component);
	
	SearchResultsList.displayName = 'SearchResultsList';
	var SearchResultListItem = exports.SearchResultListItem = (_dec2 = (0, _reactRedux.connect)(null, { onChangeLocation: _reactRouterRedux.push }), _dec2(_class6 = function (_Component5) {
	    _inherits(SearchResultListItem, _Component5);
	
	    function SearchResultListItem() {
	        var _ref11;
	
	        var _temp4, _this7, _ret4;
	
	        _classCallCheck(this, SearchResultListItem);
	
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	            args[_key4] = arguments[_key4];
	        }
	
	        return _ret4 = (_temp4 = (_this7 = _possibleConstructorReturn(this, (_ref11 = SearchResultListItem.__proto__ || Object.getPrototypeOf(SearchResultListItem)).call.apply(_ref11, [this].concat(args))), _this7), _this7.onKeyDown = function (e) {
	            var _this7$props = _this7.props,
	                highlight = _this7$props.highlight,
	                entity = _this7$props.entity,
	                getUrlForEntity = _this7$props.getUrlForEntity,
	                onChangeLocation = _this7$props.onChangeLocation;
	
	            if (highlight && e.keyCode === _keyboard.KEYCODE_ENTER) {
	                onChangeLocation(getUrlForEntity(entity));
	            }
	        }, _temp4), _possibleConstructorReturn(_this7, _ret4);
	    }
	
	    _createClass(SearchResultListItem, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            window.addEventListener("keydown", this.onKeyDown, true);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            window.removeEventListener("keydown", this.onKeyDown, true);
	        }
	        /**
	         * If the current search result entity is highlighted via arrow keys, then we want to
	         * let the press of Enter to navigate to that entity
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props5 = this.props,
	                entity = _props5.entity,
	                highlight = _props5.highlight,
	                getUrlForEntity = _props5.getUrlForEntity;
	
	
	            return _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    {
	                        className: (0, _classnames2.default)("no-decoration flex py2 px3 cursor-pointer bg-slate-extra-light-hover border-bottom", { "bg-grey-0": highlight }),
	                        to: getUrlForEntity(entity)
	                    },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'text-brand flex-full mr1' },
	                        ' ',
	                        entity.name,
	                        ' '
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SearchResultListItem;
	}(_react.Component)) || _class6);
	SearchResultListItem.displayName = 'SearchResultListItem';

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _LoadingSpinner = __webpack_require__(1281);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _CreatedDatabaseModal = __webpack_require__(1811);
	
	var _CreatedDatabaseModal2 = _interopRequireDefault(_CreatedDatabaseModal);
	
	var _DeleteDatabaseModal = __webpack_require__(1812);
	
	var _DeleteDatabaseModal2 = _interopRequireDefault(_DeleteDatabaseModal);
	
	var _selectors = __webpack_require__(1813);
	
	var _database = __webpack_require__(1790);
	
	var databaseActions = _interopRequireWildcard(_database);
	
	var _FormMessage = __webpack_require__(1573);
	
	var _FormMessage2 = _interopRequireDefault(_FormMessage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        created: props.location.query.created,
	        databases: (0, _selectors.getDatabasesSorted)(state),
	        hasSampleDataset: (0, _selectors.hasSampleDataset)(state),
	        engines: _settings2.default.get('engines'),
	        deletes: (0, _selectors.getDeletes)(state),
	        deletionError: (0, _selectors.getDeletionError)(state)
	    };
	};
	
	var mapDispatchToProps = _extends({}, databaseActions);
	
	var DatabaseList = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(DatabaseList, _Component);
	
	    function DatabaseList() {
	        _classCallCheck(this, DatabaseList);
	
	        return _possibleConstructorReturn(this, (DatabaseList.__proto__ || Object.getPrototypeOf(DatabaseList)).apply(this, arguments));
	    }
	
	    _createClass(DatabaseList, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.fetchDatabases();
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            if (!this.props.created && newProps.created) {
	                this.refs.createdDatabaseModal.open();
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                databases = _props.databases,
	                hasSampleDataset = _props.hasSampleDataset,
	                created = _props.created,
	                engines = _props.engines,
	                deletionError = _props.deletionError;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "wrapper" },
	                _react2.default.createElement(
	                    "section",
	                    { className: "PageHeader px2 clearfix" },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: "/admin/databases/create", className: "Button Button--primary float-right" },
	                        "Add database"
	                    ),
	                    _react2.default.createElement(
	                        "h2",
	                        { className: "PageTitle" },
	                        "Databases"
	                    )
	                ),
	                deletionError && _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(_FormMessage2.default, { formError: deletionError })
	                ),
	                _react2.default.createElement(
	                    "section",
	                    null,
	                    _react2.default.createElement(
	                        "table",
	                        { className: "ContentTable" },
	                        _react2.default.createElement(
	                            "thead",
	                            null,
	                            _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "Name"
	                                ),
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "Engine"
	                                ),
	                                _react2.default.createElement("th", null)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tbody",
	                            null,
	                            databases ? [databases.map(function (database) {
	                                var isDeleting = _this2.props.deletes.indexOf(database.id) !== -1;
	                                return _react2.default.createElement(
	                                    "tr",
	                                    {
	                                        key: database.id,
	                                        className: (0, _classnames2.default)({ 'disabled': isDeleting })
	                                    },
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { to: "/admin/databases/" + database.id, className: "text-bold link" },
	                                            database.name
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        engines && engines[database.engine] ? engines[database.engine]['driver-name'] : database.engine
	                                    ),
	                                    isDeleting ? _react2.default.createElement(
	                                        "td",
	                                        { className: "text-right" },
	                                        "Deleting..."
	                                    ) : _react2.default.createElement(
	                                        "td",
	                                        { className: "Table-actions" },
	                                        _react2.default.createElement(
	                                            _ModalWithTrigger2.default,
	                                            {
	                                                ref: "deleteDatabaseModal_" + database.id,
	                                                triggerClasses: "Button Button--danger",
	                                                triggerElement: "Delete"
	                                            },
	                                            _react2.default.createElement(_DeleteDatabaseModal2.default, {
	                                                database: database,
	                                                onClose: function onClose() {
	                                                    return _this2.refs["deleteDatabaseModal_" + database.id].close();
	                                                },
	                                                onDelete: function onDelete() {
	                                                    return _this2.props.deleteDatabase(database.id);
	                                                }
	                                            })
	                                        )
	                                    )
	                                );
	                            })] : _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                    "td",
	                                    { colSpan: 4 },
	                                    _react2.default.createElement(_LoadingSpinner2.default, null),
	                                    _react2.default.createElement(
	                                        "h3",
	                                        null,
	                                        "Loading ..."
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    !hasSampleDataset ? _react2.default.createElement(
	                        "div",
	                        { className: "pt4" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: (0, _classnames2.default)("p2 text-italic", { "border-top": databases && databases.length > 0 }) },
	                            _react2.default.createElement(
	                                "a",
	                                { className: "text-grey-2 text-brand-hover no-decoration", onClick: function onClick() {
	                                        return _this2.props.addSampleDataset();
	                                    } },
	                                "Bring the sample dataset back"
	                            )
	                        )
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    _ModalWithTrigger2.default,
	                    {
	                        ref: "createdDatabaseModal",
	                        isInitiallyOpen: created
	                    },
	                    _react2.default.createElement(_CreatedDatabaseModal2.default, {
	                        databaseId: parseInt(created),
	                        onDone: function onDone() {
	                            return _this2.refs.createdDatabaseModal.toggle();
	                        },
	                        onClose: function onClose() {
	                            return _this2.refs.createdDatabaseModal.toggle();
	                        }
	                    })
	                )
	            );
	        }
	    }]);
	
	    return DatabaseList;
	}(_react.Component), _class2.propTypes = {
	    databases: _propTypes2.default.array,
	    hasSampleDataset: _propTypes2.default.bool,
	    engines: _propTypes2.default.object,
	    deletes: _propTypes2.default.array,
	    deletionError: _propTypes2.default.object
	}, _temp)) || _class);
	DatabaseList.displayName = "DatabaseList";
	exports.default = DatabaseList;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatedDatabaseModal = (_temp = _class = function (_Component) {
	    _inherits(CreatedDatabaseModal, _Component);
	
	    function CreatedDatabaseModal() {
	        _classCallCheck(this, CreatedDatabaseModal);
	
	        return _possibleConstructorReturn(this, (CreatedDatabaseModal.__proto__ || Object.getPrototypeOf(CreatedDatabaseModal)).apply(this, arguments));
	    }
	
	    _createClass(CreatedDatabaseModal, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                onClose = _props.onClose,
	                onDone = _props.onDone,
	                databaseId = _props.databaseId;
	
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    title: "Your database has been added!",
	                    onClose: onClose
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "Form-inputs mb4" },
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "We're analyzing its schema now to make some educated guesses about its metadata. ",
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/admin/datamodel/database/" + databaseId },
	                            "View this database"
	                        ),
	                        " in the Data Model section to see what we've found and to make edits, or ",
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: Urls.question(null, "?db=" + databaseId) },
	                            "ask a question"
	                        ),
	                        " about this database."
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "Form-actions flex layout-centered" },
	                    _react2.default.createElement(
	                        "button",
	                        { className: "Button Button--primary px3", onClick: onDone },
	                        "Done"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CreatedDatabaseModal;
	}(_react.Component), _class.propTypes = {
	    databaseId: _propTypes2.default.number.isRequired,
	    onClose: _propTypes2.default.func.isRequired,
	    onDone: _propTypes2.default.func.isRequired
	}, _temp);
	CreatedDatabaseModal.displayName = "CreatedDatabaseModal";
	exports.default = CreatedDatabaseModal;

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeleteDatabaseModal = (_temp = _class = function (_Component) {
	    _inherits(DeleteDatabaseModal, _Component);
	
	    function DeleteDatabaseModal(props, context) {
	        _classCallCheck(this, DeleteDatabaseModal);
	
	        var _this = _possibleConstructorReturn(this, (DeleteDatabaseModal.__proto__ || Object.getPrototypeOf(DeleteDatabaseModal)).call(this, props, context));
	
	        _this.state = {
	            confirmValue: "",
	            error: null
	        };
	        return _this;
	    }
	
	    _createClass(DeleteDatabaseModal, [{
	        key: "deleteDatabase",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                try {
	                                    this.props.onDelete(this.props.database);
	                                    // immediately call on close because database deletion should be non blocking
	                                    this.props.onClose();
	                                } catch (error) {
	                                    this.setState({ error: error });
	                                }
	
	                            case 1:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function deleteDatabase() {
	                return _ref.apply(this, arguments);
	            }
	
	            return deleteDatabase;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var database = this.props.database;
	
	
	            var formError;
	            if (this.state.error) {
	                var errorMessage = "Server error encountered";
	                if (this.state.error.data && this.state.error.data.message) {
	                    errorMessage = this.state.error.data.message;
	                } else {
	                    errorMessage = this.state.error.message;
	                }
	
	                // TODO: timeout display?
	                formError = _react2.default.createElement(
	                    "span",
	                    { className: "text-error px2" },
	                    errorMessage
	                );
	            }
	
	            var confirmed = this.state.confirmValue.toUpperCase() === "DELETE";
	
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    title: "Delete this database?",
	                    onClose: this.props.onClose
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "Form-inputs mb4" },
	                    database.is_sample && _react2.default.createElement(
	                        "p",
	                        { className: "text-paragraph" },
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "Just a heads up:"
	                        ),
	                        " without the Sample Dataset, the Query Builder tutorial won't work. You can always restore the Sample Dataset, but any questions you've saved using this data will be lost."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "text-paragraph" },
	                        "All saved questions, metrics, and segments that rely on this database will be lost. ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "This cannot be undone"
	                        ),
	                        "."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "text-paragraph" },
	                        "If you're sure, please type ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "DELETE"
	                        ),
	                        " in this box:"
	                    ),
	                    _react2.default.createElement("input", { className: "Form-input", type: "text", onChange: function onChange(e) {
	                            return _this2.setState({ confirmValue: e.target.value });
	                        }, autoFocus: true })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "Form-actions ml-auto" },
	                    _react2.default.createElement(
	                        "button",
	                        { className: "Button", onClick: this.props.onClose },
	                        "Cancel"
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        { className: (0, _classnames2.default)("Button Button--danger ml2", { "disabled": !confirmed }), onClick: function onClick() {
	                                return _this2.deleteDatabase();
	                            } },
	                        "Delete"
	                    ),
	                    formError
	                )
	            );
	        }
	    }]);
	
	    return DeleteDatabaseModal;
	}(_react.Component), _class.propTypes = {
	    database: _propTypes2.default.object.isRequired,
	    onClose: _propTypes2.default.func,
	    onDelete: _propTypes2.default.func
	}, _temp);
	DeleteDatabaseModal.displayName = "DeleteDatabaseModal";
	exports.default = DeleteDatabaseModal;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getDeletionError = exports.getDeletes = exports.getDatabaseCreationStep = exports.getFormState = exports.getEditingDatabase = exports.hasSampleDataset = exports.getDatabasesSorted = exports.databases = undefined;
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reselect = __webpack_require__(1072);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Database List
	/*  weak */
	
	var databases = exports.databases = function databases(state) {
	    return state.admin.databases.databases;
	};
	
	var getDatabasesSorted = exports.getDatabasesSorted = (0, _reselect.createSelector)([databases], function (databases) {
	    return _underscore2.default.sortBy(databases, 'name');
	});
	
	var hasSampleDataset = exports.hasSampleDataset = (0, _reselect.createSelector)([databases], function (databases) {
	    return _underscore2.default.some(databases, function (d) {
	        return d.is_sample;
	    });
	});
	
	// Database Edit
	var getEditingDatabase = exports.getEditingDatabase = function getEditingDatabase(state) {
	    return state.admin.databases.editingDatabase;
	};
	var getFormState = exports.getFormState = function getFormState(state) {
	    return state.admin.databases.formState;
	};
	var getDatabaseCreationStep = exports.getDatabaseCreationStep = function getDatabaseCreationStep(state) {
	    return state.admin.databases.databaseCreationStep;
	};
	
	var getDeletes = exports.getDeletes = function getDeletes(state) {
	    return state.admin.databases.deletes;
	};
	var getDeletionError = exports.getDeletionError = function getDeletionError(state) {
	    return state.admin.databases.deletionError;
	};

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.Tabs = exports.Tab = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Title = __webpack_require__(1538);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _DeleteDatabaseModal = __webpack_require__(1812);
	
	var _DeleteDatabaseModal2 = _interopRequireDefault(_DeleteDatabaseModal);
	
	var _DatabaseEditForms = __webpack_require__(1815);
	
	var _DatabaseEditForms2 = _interopRequireDefault(_DatabaseEditForms);
	
	var _DatabaseSchedulingForm = __webpack_require__(1793);
	
	var _DatabaseSchedulingForm2 = _interopRequireDefault(_DatabaseSchedulingForm);
	
	var _ActionButton = __webpack_require__(1213);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _selectors = __webpack_require__(1813);
	
	var _database = __webpack_require__(1790);
	
	var _ConfirmContent = __webpack_require__(1264);
	
	var _ConfirmContent2 = _interopRequireDefault(_ConfirmContent);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        database: (0, _selectors.getEditingDatabase)(state),
	        databaseCreationStep: (0, _selectors.getDatabaseCreationStep)(state),
	        formState: (0, _selectors.getFormState)(state)
	    };
	};
	
	var Tab = exports.Tab = function Tab(_ref) {
	    var name = _ref.name,
	        setTab = _ref.setTab,
	        currentTab = _ref.currentTab;
	
	    var isCurrentTab = currentTab === name.toLowerCase();
	
	    return _react2.default.createElement(
	        "div",
	        {
	            className: (0, _classnames2.default)('cursor-pointer py2', { 'text-brand': isCurrentTab })
	            // TODO Use css classes instead?
	            , style: isCurrentTab ? { borderBottom: "3px solid #509EE3" } : {},
	            onClick: function onClick() {
	                return setTab(name);
	            } },
	        _react2.default.createElement(
	            "h3",
	            null,
	            name
	        )
	    );
	};
	
	Tab.displayName = "Tab";
	var Tabs = exports.Tabs = function Tabs(_ref2) {
	    var tabs = _ref2.tabs,
	        currentTab = _ref2.currentTab,
	        setTab = _ref2.setTab;
	    return _react2.default.createElement(
	        "div",
	        { className: "border-bottom" },
	        _react2.default.createElement(
	            "ol",
	            { className: "Form-offset flex align center" },
	            tabs.map(function (tab, index) {
	                return _react2.default.createElement(
	                    "li",
	                    { key: index, className: "mr3" },
	                    _react2.default.createElement(Tab, {
	                        name: tab,
	                        setTab: setTab,
	                        currentTab: currentTab
	                    })
	                );
	            })
	        )
	    );
	};
	
	Tabs.displayName = "Tabs";
	var mapDispatchToProps = {
	    reset: _database.reset,
	    initializeDatabase: _database.initializeDatabase,
	    proceedWithDbCreation: _database.proceedWithDbCreation,
	    saveDatabase: _database.saveDatabase,
	    syncDatabaseSchema: _database.syncDatabaseSchema,
	    rescanDatabaseFields: _database.rescanDatabaseFields,
	    discardSavedFieldValues: _database.discardSavedFieldValues,
	    deleteDatabase: _database.deleteDatabase,
	    selectEngine: _database.selectEngine
	};
	
	var DatabaseEditApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _Title2.default)(function (_ref3) {
	    var database = _ref3.database;
	    return database && database.name;
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    _inherits(DatabaseEditApp, _Component);
	
	    function DatabaseEditApp(props, context) {
	        _classCallCheck(this, DatabaseEditApp);
	
	        var _this = _possibleConstructorReturn(this, (DatabaseEditApp.__proto__ || Object.getPrototypeOf(DatabaseEditApp)).call(this, props, context));
	
	        _this.state = {
	            currentTab: 'connection'
	        };
	        return _this;
	    }
	
	    _createClass(DatabaseEditApp, [{
	        key: "componentWillMount",
	        value: function () {
	            var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.reset();
	
	                            case 2:
	                                _context.next = 4;
	                                return this.props.initializeDatabase(this.props.params.databaseId);
	
	                            case 4:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillMount() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            var addingNewDatabase = !nextProps.database || !nextProps.database.id;
	
	            if (addingNewDatabase) {
	                // Update the current creation step (= active tab) if adding a new database
	                this.setState({ currentTab: nextProps.databaseCreationStep });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                database = _props.database,
	                formState = _props.formState;
	            var currentTab = this.state.currentTab;
	
	
	            var editingExistingDatabase = database && database.id != null;
	            var addingNewDatabase = !editingExistingDatabase;
	
	            var letUserControlScheduling = database && database.details && database.details["let-user-control-scheduling"];
	            var showTabs = editingExistingDatabase && letUserControlScheduling;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "wrapper" },
	                _react2.default.createElement(_Breadcrumbs2.default, { className: "py4", crumbs: [["Databases", "/admin/databases"], [addingNewDatabase ? "Add Database" : database.name]] }),
	                _react2.default.createElement(
	                    "section",
	                    { className: "Grid Grid--gutters Grid--2-of-3" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Grid-cell" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Form-new bordered rounded shadowed pt0" },
	                            showTabs && _react2.default.createElement(Tabs, {
	                                tabs: ['Connection', 'Scheduling'],
	                                currentTab: currentTab,
	                                setTab: function setTab(tab) {
	                                    return _this2.setState({ currentTab: tab.toLowerCase() });
	                                }
	                            }),
	                            _react2.default.createElement(
	                                _LoadingAndErrorWrapper2.default,
	                                { loading: !database, error: null },
	                                function () {
	                                    return _react2.default.createElement(
	                                        "div",
	                                        null,
	                                        currentTab === 'connection' && _react2.default.createElement(_DatabaseEditForms2.default, {
	                                            database: database,
	                                            details: database ? database.details : null,
	                                            engines: _settings2.default.get('engines'),
	                                            hiddenFields: { ssl: true },
	                                            formState: formState,
	                                            selectEngine: _this2.props.selectEngine,
	                                            save: addingNewDatabase ? _this2.props.proceedWithDbCreation : _this2.props.saveDatabase
	                                        }),
	                                        currentTab === 'scheduling' && _react2.default.createElement(_DatabaseSchedulingForm2.default, {
	                                            database: database,
	                                            formState: formState
	                                            // Use saveDatabase both for db creation and updating
	                                            , save: _this2.props.saveDatabase,
	                                            submitButtonText: addingNewDatabase ? "Save" : "Save changes"
	                                        })
	                                    );
	                                }
	                            )
	                        )
	                    ),
	                    editingExistingDatabase && _react2.default.createElement(
	                        "div",
	                        { className: "Grid-cell Cell--1of3" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "Actions bordered rounded shadowed" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "Actions-group" },
	                                _react2.default.createElement(
	                                    "label",
	                                    { className: "Actions-groupLabel block text-bold" },
	                                    "Actions"
	                                ),
	                                _react2.default.createElement(
	                                    "ol",
	                                    null,
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(_ActionButton2.default, {
	                                            actionFn: function actionFn() {
	                                                return _this2.props.syncDatabaseSchema(database.id);
	                                            },
	                                            className: "Button Button--syncDbSchema",
	                                            normalText: "Sync database schema now",
	                                            activeText: "Starting\u2026",
	                                            failedText: "Failed to sync",
	                                            successText: "Sync triggered!"
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        { className: "mt2" },
	                                        _react2.default.createElement(_ActionButton2.default, {
	                                            actionFn: function actionFn() {
	                                                return _this2.props.rescanDatabaseFields(database.id);
	                                            },
	                                            className: "Button Button--rescanFieldValues",
	                                            normalText: "Re-scan field values now",
	                                            activeText: "Starting\u2026",
	                                            failedText: "Failed to start scan",
	                                            successText: "Scan triggered!"
	                                        })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "Actions-group" },
	                                _react2.default.createElement(
	                                    "label",
	                                    { className: "Actions-groupLabel block text-bold" },
	                                    "Danger Zone"
	                                ),
	                                _react2.default.createElement(
	                                    "ol",
	                                    null,
	                                    _react2.default.createElement(
	                                        "li",
	                                        null,
	                                        _react2.default.createElement(
	                                            _ModalWithTrigger2.default,
	                                            {
	                                                ref: "discardSavedFieldValuesModal",
	                                                triggerClasses: "Button Button--danger Button--discardSavedFieldValues",
	                                                triggerElement: "Discard saved field values"
	                                            },
	                                            _react2.default.createElement(_ConfirmContent2.default, {
	                                                title: "Discard saved field values",
	                                                onClose: function onClose() {
	                                                    return _this2.refs.discardSavedFieldValuesModal.toggle();
	                                                },
	                                                onAction: function onAction() {
	                                                    return _this2.props.discardSavedFieldValues(database.id);
	                                                }
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        "li",
	                                        { className: "mt2" },
	                                        _react2.default.createElement(
	                                            _ModalWithTrigger2.default,
	                                            {
	                                                ref: "deleteDatabaseModal",
	                                                triggerClasses: "Button Button--deleteDatabase Button--danger",
	                                                triggerElement: "Remove this database"
	                                            },
	                                            _react2.default.createElement(_DeleteDatabaseModal2.default, {
	                                                database: database,
	                                                onClose: function onClose() {
	                                                    return _this2.refs.deleteDatabaseModal.toggle();
	                                                },
	                                                onDelete: function onDelete() {
	                                                    return _this2.props.deleteDatabase(database.id, true);
	                                                }
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DatabaseEditApp;
	}(_react.Component), _class2.propTypes = {
	    database: _propTypes2.default.object,
	    databaseCreationStep: _propTypes2.default.string,
	    formState: _propTypes2.default.object.isRequired,
	    params: _propTypes2.default.object.isRequired,
	    reset: _propTypes2.default.func.isRequired,
	    initializeDatabase: _propTypes2.default.func.isRequired,
	    syncDatabaseSchema: _propTypes2.default.func.isRequired,
	    rescanDatabaseFields: _propTypes2.default.func.isRequired,
	    discardSavedFieldValues: _propTypes2.default.func.isRequired,
	    proceedWithDbCreation: _propTypes2.default.func.isRequired,
	    deleteDatabase: _propTypes2.default.func.isRequired,
	    saveDatabase: _propTypes2.default.func.isRequired,
	    selectEngine: _propTypes2.default.func.isRequired,
	    location: _propTypes2.default.object
	}, _temp)) || _class) || _class);
	DatabaseEditApp.displayName = "DatabaseEditApp";
	exports.default = DatabaseEditApp;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DatabaseDetailsForm = __webpack_require__(1789);
	
	var _DatabaseDetailsForm2 = _interopRequireDefault(_DatabaseDetailsForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DatabaseEditForms = (_temp = _class = function (_Component) {
	    _inherits(DatabaseEditForms, _Component);
	
	    function DatabaseEditForms() {
	        _classCallCheck(this, DatabaseEditForms);
	
	        return _possibleConstructorReturn(this, (DatabaseEditForms.__proto__ || Object.getPrototypeOf(DatabaseEditForms)).apply(this, arguments));
	    }
	
	    _createClass(DatabaseEditForms, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                database = _props.database,
	                details = _props.details,
	                hiddenFields = _props.hiddenFields,
	                engines = _props.engines,
	                _props$formState = _props.formState,
	                formError = _props$formState.formError,
	                formSuccess = _props$formState.formSuccess,
	                isSubmitting = _props$formState.isSubmitting;
	
	
	            var errors = {};
	            return _react2.default.createElement(
	                "div",
	                { className: "mt4" },
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)("Form-field", { "Form--fieldError": errors["engine"] }) },
	                    _react2.default.createElement(
	                        "label",
	                        { className: "Form-label Form-offset" },
	                        "Database type: ",
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            errors["engine"]
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "label",
	                        { className: "Select Form-offset mt1" },
	                        _react2.default.createElement(
	                            "select",
	                            { className: "Select", defaultValue: database.engine,
	                                onChange: function onChange(e) {
	                                    return _this2.props.selectEngine(e.target.value);
	                                } },
	                            _react2.default.createElement(
	                                "option",
	                                { value: "", disabled: true },
	                                "Select a database type"
	                            ),
	                            Object.keys(engines).sort().map(function (opt) {
	                                return _react2.default.createElement(
	                                    "option",
	                                    { key: opt, value: opt },
	                                    engines[opt]['driver-name']
	                                );
	                            })
	                        )
	                    )
	                ),
	                database.engine ? _react2.default.createElement(_DatabaseDetailsForm2.default, {
	                    details: _extends({}, details, { name: database.name, is_full_sync: database.is_full_sync }),
	                    engine: database.engine,
	                    engines: engines,
	                    formError: formError,
	                    formSuccess: formSuccess,
	                    hiddenFields: hiddenFields,
	                    submitFn: function submitFn(database) {
	                        return _this2.props.save(_extends({}, database, {
	                            id: _this2.props.database.id
	                        }), database.details);
	                    },
	                    isNewDatabase: !database.id,
	                    submitButtonText: 'Save',
	                    submitting: isSubmitting }) : null
	            );
	        }
	    }]);
	
	    return DatabaseEditForms;
	}(_react.Component), _class.propTypes = {
	    database: _propTypes2.default.object,
	    details: _propTypes2.default.object,
	    engines: _propTypes2.default.object.isRequired,
	    hiddenFields: _propTypes2.default.object,
	    selectEngine: _propTypes2.default.func.isRequired,
	    save: _propTypes2.default.func.isRequired,
	    formState: _propTypes2.default.object
	}, _temp);
	DatabaseEditForms.displayName = "DatabaseEditForms";
	exports.default = DatabaseEditForms;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _AdminEmptyText = __webpack_require__(1817);
	
	var _AdminEmptyText2 = _interopRequireDefault(_AdminEmptyText);
	
	var _MetadataHeader = __webpack_require__(1818);
	
	var _MetadataHeader2 = _interopRequireDefault(_MetadataHeader);
	
	var _MetadataTablePicker = __webpack_require__(1820);
	
	var _MetadataTablePicker2 = _interopRequireDefault(_MetadataTablePicker);
	
	var _MetadataTable = __webpack_require__(1824);
	
	var _MetadataTable2 = _interopRequireDefault(_MetadataTable);
	
	var _MetadataSchema = __webpack_require__(1834);
	
	var _MetadataSchema2 = _interopRequireDefault(_MetadataSchema);
	
	var _selectors = __webpack_require__(1835);
	
	var _datamodel = __webpack_require__(1836);
	
	var metadataActions = _interopRequireWildcard(_datamodel);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        databaseId: parseInt(props.params.databaseId),
	        tableId: parseInt(props.params.tableId),
	        databases: (0, _selectors.getDatabases)(state, props),
	        idfields: (0, _selectors.getDatabaseIdfields)(state, props),
	        databaseMetadata: (0, _selectors.getEditingDatabaseWithTableMetadataStrengths)(state, props),
	        editingTable: (0, _selectors.getEditingTable)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions);
	
	var MetadataEditor = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(MetadataEditor, _Component);
	
	    function MetadataEditor(props, context) {
	        _classCallCheck(this, MetadataEditor);
	
	        var _this = _possibleConstructorReturn(this, (MetadataEditor.__proto__ || Object.getPrototypeOf(MetadataEditor)).call(this, props, context));
	
	        _this.toggleShowSchema = _this.toggleShowSchema.bind(_this);
	
	        _this.state = {
	            isShowingSchema: false
	        };
	        return _this;
	    }
	
	    _createClass(MetadataEditor, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            // if we know what database we are initialized with, include that
	            this.props.initializeMetadata(this.props.databaseId, this.props.tableId);
	        }
	    }, {
	        key: "toggleShowSchema",
	        value: function toggleShowSchema() {
	            this.setState({ isShowingSchema: !this.state.isShowingSchema });
	            _analytics2.default.trackEvent("Data Model", "Show OG Schema", !this.state.isShowingSchema);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var tableMetadata = this.props.databaseMetadata ? _underscore2.default.findWhere(this.props.databaseMetadata.tables, { id: this.props.editingTable }) : null;
	            var content;
	            if (tableMetadata) {
	                if (this.state.isShowingSchema) {
	                    content = _react2.default.createElement(_MetadataSchema2.default, { tableMetadata: tableMetadata });
	                } else {
	                    content = _react2.default.createElement(_MetadataTable2.default, {
	                        tableMetadata: tableMetadata,
	                        idfields: this.props.idfields,
	                        updateTable: function updateTable(table) {
	                            return _this2.props.updateTable(table);
	                        },
	                        updateField: function updateField(field) {
	                            return _this2.props.updateField(field);
	                        },
	                        onRetireSegment: this.props.onRetireSegment,
	                        onRetireMetric: this.props.onRetireMetric
	                    });
	                }
	            } else {
	                content = _react2.default.createElement(
	                    "div",
	                    { style: { paddingTop: "10rem" }, className: "full text-centered" },
	                    _react2.default.createElement(_AdminEmptyText2.default, { message: "Select any table to see its schema and add or edit metadata." })
	                );
	            }
	            return _react2.default.createElement(
	                "div",
	                { className: "p3" },
	                _react2.default.createElement(_MetadataHeader2.default, {
	                    ref: "header",
	                    databaseId: this.props.databaseMetadata ? this.props.databaseMetadata.id : null,
	                    databases: this.props.databases,
	                    selectDatabase: this.props.selectDatabase,
	                    isShowingSchema: this.state.isShowingSchema,
	                    toggleShowSchema: this.toggleShowSchema
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { style: { minHeight: "60vh" }, className: "flex flex-row flex-full mt2 full-height" },
	                    _react2.default.createElement(_MetadataTablePicker2.default, {
	                        tableId: this.props.editingTable,
	                        tables: this.props.databaseMetadata ? this.props.databaseMetadata.tables : [],
	                        selectTable: this.props.selectTable
	                    }),
	                    content
	                )
	            );
	        }
	    }]);
	
	    return MetadataEditor;
	}(_react.Component), _class2.propTypes = {
	    databaseId: _propTypes2.default.number,
	    tableId: _propTypes2.default.number,
	    databases: _propTypes2.default.array.isRequired,
	    selectDatabase: _propTypes2.default.func.isRequired,
	    databaseMetadata: _propTypes2.default.object,
	    selectTable: _propTypes2.default.func.isRequired,
	    idfields: _propTypes2.default.array.isRequired,
	    editingTable: _propTypes2.default.number,
	    updateTable: _propTypes2.default.func.isRequired,
	    updateField: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	MetadataEditor.displayName = "MetadataEditor";
	exports.default = MetadataEditor;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminEmptyText = function AdminEmptyText(_ref) {
	    var message = _ref.message;
	    return _react2.default.createElement(
	        "h2",
	        { className: "text-grey-3" },
	        message
	    );
	};
	
	AdminEmptyText.displayName = "AdminEmptyText";
	AdminEmptyText.propTypes = {
	    message: _propTypes2.default.string.isRequired
	};
	
	exports.default = AdminEmptyText;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _SaveStatus = __webpack_require__(1819);
	
	var _SaveStatus2 = _interopRequireDefault(_SaveStatus);
	
	var _Toggle = __webpack_require__(1241);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _ColumnarSelector = __webpack_require__(1058);
	
	var _ColumnarSelector2 = _interopRequireDefault(_ColumnarSelector);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MetadataHeader = (0, _reactRouter.withRouter)(_class = (_temp = _class2 = function (_Component) {
	    _inherits(MetadataHeader, _Component);
	
	    function MetadataHeader() {
	        _classCallCheck(this, MetadataHeader);
	
	        return _possibleConstructorReturn(this, (MetadataHeader.__proto__ || Object.getPrototypeOf(MetadataHeader)).apply(this, arguments));
	    }
	
	    _createClass(MetadataHeader, [{
	        key: "setSaving",
	        value: function setSaving() {
	            this.refs.status.setSaving.apply(this, arguments);
	        }
	    }, {
	        key: "setSaved",
	        value: function setSaved() {
	            this.refs.status.setSaved.apply(this, arguments);
	        }
	    }, {
	        key: "setSaveError",
	        value: function setSaveError() {
	            this.refs.status.setSaveError.apply(this, arguments);
	        }
	    }, {
	        key: "renderDbSelector",
	        value: function renderDbSelector() {
	            var _this2 = this;
	
	            var database = this.props.databases.filter(function (db) {
	                return db.id === _this2.props.databaseId;
	            })[0];
	            if (database) {
	                var columns = [{
	                    selectedItem: database,
	                    items: this.props.databases,
	                    itemTitleFn: function itemTitleFn(db) {
	                        return db.name;
	                    },
	                    itemSelectFn: function itemSelectFn(db) {
	                        _this2.props.selectDatabase(db);
	                        _this2.refs.databasePopover.toggle();
	                    }
	                }];
	                var triggerElement = _react2.default.createElement(
	                    "span",
	                    { className: "text-bold cursor-pointer text-default" },
	                    database.name,
	                    _react2.default.createElement(_Icon2.default, { className: "ml1", name: "chevrondown", size: 8 })
	                );
	                return _react2.default.createElement(
	                    _PopoverWithTrigger2.default,
	                    {
	                        ref: "databasePopover",
	                        triggerElement: triggerElement
	                    },
	                    _react2.default.createElement(_ColumnarSelector2.default, { columns: columns })
	                );
	            }
	        }
	
	        // Show a gear to access Table settings page if we're currently looking at a Table. Otherwise show nothing.
	        // TODO - it would be nicer just to disable the gear so the page doesn't jump around once you select a Table.
	
	    }, {
	        key: "renderTableSettingsButton",
	        value: function renderTableSettingsButton() {
	            var isViewingTable = this.props.location.pathname.match(/table\/\d+\/?$/);
	            if (!isViewingTable) return null;
	
	            return _react2.default.createElement(
	                "span",
	                { className: "ml4 mr3" },
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: this.props.location.pathname + "/settings" },
	                    _react2.default.createElement(_Icon2.default, { name: "gear" })
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "MetadataEditor-header flex align-center flex-no-shrink" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "MetadataEditor-headerSection py2 h2" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "text-grey-4" },
	                        "Current database:"
	                    ),
	                    " ",
	                    this.renderDbSelector()
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "MetadataEditor-headerSection flex flex-align-right align-center flex-no-shrink" },
	                    _react2.default.createElement(_SaveStatus2.default, { ref: "status" }),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "mr1" },
	                        "Show original schema"
	                    ),
	                    _react2.default.createElement(_Toggle2.default, { value: this.props.isShowingSchema, onChange: this.props.toggleShowSchema }),
	                    this.renderTableSettingsButton()
	                )
	            );
	        }
	    }]);
	
	    return MetadataHeader;
	}(_react.Component), _class2.propTypes = {
	    databaseId: _propTypes2.default.number,
	    databases: _propTypes2.default.array.isRequired,
	    selectDatabase: _propTypes2.default.func.isRequired,
	    isShowingSchema: _propTypes2.default.bool.isRequired,
	    toggleShowSchema: _propTypes2.default.func.isRequired
	}, _temp)) || _class;
	
	MetadataHeader.displayName = "MetadataHeader";
	exports.default = MetadataHeader;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoadingSpinner = __webpack_require__(1281);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SaveStatus = function (_Component) {
	    _inherits(SaveStatus, _Component);
	
	    function SaveStatus(props, context) {
	        _classCallCheck(this, SaveStatus);
	
	        var _this = _possibleConstructorReturn(this, (SaveStatus.__proto__ || Object.getPrototypeOf(SaveStatus)).call(this, props, context));
	
	        _this.state = {
	            saving: false,
	            recentlySavedTimeout: null,
	            error: null
	        };
	
	        _underscore2.default.bindAll(_this, "setSaving", "setSaved", "setSaveError");
	        return _this;
	    }
	
	    _createClass(SaveStatus, [{
	        key: "setSaving",
	        value: function setSaving() {
	            clearTimeout(this.state.recentlySavedTimeout);
	            this.setState({ saving: true, recentlySavedTimeout: null, error: null });
	        }
	    }, {
	        key: "setSaved",
	        value: function setSaved() {
	            var _this2 = this;
	
	            clearTimeout(this.state.recentlySavedTimeout);
	            var recentlySavedTimeout = setTimeout(function () {
	                return _this2.setState({ recentlySavedTimeout: null });
	            }, 5000);
	            this.setState({ saving: false, recentlySavedTimeout: recentlySavedTimeout, error: null });
	        }
	    }, {
	        key: "setSaveError",
	        value: function setSaveError(error) {
	            this.setState({ saving: false, recentlySavedTimeout: null, error: error });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            if (this.state.saving) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "SaveStatus mx2 px2 border-right" },
	                    _react2.default.createElement(_LoadingSpinner2.default, { size: 24 })
	                );
	            } else if (this.state.error) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "SaveStatus mx2 px2 border-right text-error" },
	                    "Error: ",
	                    String(this.state.error.message || this.state.error)
	                );
	            } else if (this.state.recentlySavedTimeout != null) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "SaveStatus mx2 px2 border-right flex align-center text-success" },
	                    _react2.default.createElement(_Icon2.default, { name: "check", size: 16 }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "ml1 h3 text-bold" },
	                        "Saved"
	                    )
	                );
	            } else {
	                return null;
	            }
	        }
	    }]);
	
	    return SaveStatus;
	}(_react.Component);
	
	SaveStatus.displayName = "SaveStatus";
	exports.default = SaveStatus;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MetadataTableList = __webpack_require__(1821);
	
	var _MetadataTableList2 = _interopRequireDefault(_MetadataTableList);
	
	var _MetadataSchemaList = __webpack_require__(1823);
	
	var _MetadataSchemaList2 = _interopRequireDefault(_MetadataSchemaList);
	
	var _formatting = __webpack_require__(872);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MetadataTablePicker = (_temp = _class = function (_Component) {
	    _inherits(MetadataTablePicker, _Component);
	
	    function MetadataTablePicker(props, context) {
	        _classCallCheck(this, MetadataTablePicker);
	
	        var _this = _possibleConstructorReturn(this, (MetadataTablePicker.__proto__ || Object.getPrototypeOf(MetadataTablePicker)).call(this, props, context));
	
	        _this.state = {
	            schemas: null,
	            selectedSchema: null,
	            showTablePicker: true
	        };
	        return _this;
	    }
	
	    _createClass(MetadataTablePicker, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.componentWillReceiveProps(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(newProps) {
	            var tables = newProps.tables;
	
	            var schemas = {};
	            var selectedSchema = void 0;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = tables[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var table = _step.value;
	
	                    var name = table.schema || ""; // possibly null
	                    schemas[name] = schemas[name] || {
	                        name: (0, _formatting.titleize)((0, _formatting.humanize)(name)),
	                        tables: []
	                    };
	                    schemas[name].tables.push(table);
	                    if (table.id === newProps.tableId) {
	                        selectedSchema = schemas[name];
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            this.setState({
	                schemas: Object.values(schemas).sort(function (a, b) {
	                    return a.name.localeCompare(b.name);
	                }),
	                selectedSchema: selectedSchema
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var schemas = this.state.schemas;
	
	            if (schemas.length === 1) {
	                return _react2.default.createElement(_MetadataTableList2.default, _extends({}, this.props, { tables: schemas[0].tables }));
	            }
	            if (this.state.selectedSchema && this.state.showTablePicker) {
	                return _react2.default.createElement(_MetadataTableList2.default, _extends({}, this.props, { tables: this.state.selectedSchema.tables, schema: this.state.selectedSchema, onBack: function onBack() {
	                        return _this2.setState({ showTablePicker: false });
	                    } }));
	            }
	            return _react2.default.createElement(_MetadataSchemaList2.default, {
	                schemas: schemas,
	                selectedSchema: this.state.schema,
	                onChangeSchema: function onChangeSchema(schema) {
	                    return _this2.setState({ selectedSchema: schema, showTablePicker: true });
	                }
	            });
	        }
	    }]);
	
	    return MetadataTablePicker;
	}(_react.Component), _class.propTypes = {
	    tableId: _propTypes2.default.number,
	    tables: _propTypes2.default.array.isRequired,
	    selectTable: _propTypes2.default.func.isRequired
	}, _temp);
	MetadataTablePicker.displayName = "MetadataTablePicker";
	exports.default = MetadataTablePicker;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProgressBar = __webpack_require__(1822);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _formatting = __webpack_require__(872);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MetadataTableList = (_temp = _class = function (_Component) {
	    _inherits(MetadataTableList, _Component);
	
	    function MetadataTableList(props, context) {
	        _classCallCheck(this, MetadataTableList);
	
	        var _this = _possibleConstructorReturn(this, (MetadataTableList.__proto__ || Object.getPrototypeOf(MetadataTableList)).call(this, props, context));
	
	        _this.state = {
	            searchText: "",
	            searchRegex: null
	        };
	
	        _underscore2.default.bindAll(_this, "updateSearchText");
	        return _this;
	    }
	
	    _createClass(MetadataTableList, [{
	        key: "updateSearchText",
	        value: function updateSearchText(event) {
	            this.setState({
	                searchText: event.target.value,
	                searchRegex: event.target.value ? new RegExp(RegExp.escape(event.target.value), "i") : null
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var queryableTablesHeader, hiddenTablesHeader;
	            var queryableTables = [];
	            var hiddenTables = [];
	
	            if (this.props.tables) {
	                var tables = _underscore2.default.sortBy(this.props.tables, "display_name");
	                _underscore2.default.each(tables, function (table) {
	                    var row = _react2.default.createElement(
	                        "li",
	                        { key: table.id },
	                        _react2.default.createElement(
	                            "a",
	                            { className: (0, _classnames2.default)("AdminList-item flex align-center no-decoration", { selected: _this2.props.tableId === table.id }), onClick: _this2.props.selectTable.bind(null, table) },
	                            table.display_name,
	                            _react2.default.createElement(_ProgressBar2.default, { className: "ProgressBar ProgressBar--mini flex-align-right", percentage: table.metadataStrength })
	                        )
	                    );
	                    var regex = _this2.state.searchRegex;
	                    if (!regex || regex.test(table.display_name) || regex.test(table.name)) {
	                        if (table.visibility_type) {
	                            hiddenTables.push(row);
	                        } else {
	                            queryableTables.push(row);
	                        }
	                    }
	                });
	            }
	
	            if (queryableTables.length > 0) {
	                queryableTablesHeader = _react2.default.createElement(
	                    "li",
	                    { className: "AdminList-section" },
	                    queryableTables.length,
	                    " Queryable ",
	                    (0, _formatting.inflect)("Table", queryableTables.length)
	                );
	            }
	            if (hiddenTables.length > 0) {
	                hiddenTablesHeader = _react2.default.createElement(
	                    "li",
	                    { className: "AdminList-section" },
	                    hiddenTables.length,
	                    " Hidden ",
	                    (0, _formatting.inflect)("Table", hiddenTables.length)
	                );
	            }
	            if (queryableTables.length === 0 && hiddenTables.length === 0) {
	                queryableTablesHeader = _react2.default.createElement(
	                    "li",
	                    { className: "AdminList-section" },
	                    "0 Tables"
	                );
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "MetadataEditor-table-list AdminList flex-no-shrink" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "AdminList-search" },
	                    _react2.default.createElement(_Icon2.default, { name: "search", size: 16 }),
	                    _react2.default.createElement("input", {
	                        className: "AdminInput pl4 border-bottom",
	                        type: "text",
	                        placeholder: "Find a table",
	                        value: this.state.searchText,
	                        onChange: this.updateSearchText
	                    })
	                ),
	                (this.props.onBack || this.props.schema) && _react2.default.createElement(
	                    "h4",
	                    { className: "p2 border-bottom" },
	                    this.props.onBack && _react2.default.createElement(
	                        "span",
	                        { className: "text-brand cursor-pointer", onClick: this.props.onBack },
	                        _react2.default.createElement(_Icon2.default, { name: "chevronleft", size: 10 }),
	                        " Schemas"
	                    ),
	                    this.props.onBack && this.props.schema && _react2.default.createElement(
	                        "span",
	                        { className: "mx1" },
	                        "-"
	                    ),
	                    this.props.schema && _react2.default.createElement(
	                        "span",
	                        null,
	                        " ",
	                        this.props.schema.name
	                    )
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "AdminList-items" },
	                    queryableTablesHeader,
	                    queryableTables,
	                    hiddenTablesHeader,
	                    hiddenTables
	                )
	            );
	        }
	    }]);
	
	    return MetadataTableList;
	}(_react.Component), _class.propTypes = {
	    tableId: _propTypes2.default.number,
	    tables: _propTypes2.default.array.isRequired,
	    selectTable: _propTypes2.default.func.isRequired
	}, _temp);
	MetadataTableList.displayName = "MetadataTableList";
	exports.default = MetadataTableList;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgressBar = (_temp = _class = function (_Component) {
	    _inherits(ProgressBar, _Component);
	
	    function ProgressBar() {
	        _classCallCheck(this, ProgressBar);
	
	        return _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).apply(this, arguments));
	    }
	
	    _createClass(ProgressBar, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: this.props.className },
	                _react2.default.createElement("div", { className: "ProgressBar-progress", style: { "width": this.props.percentage * 100 + "%" } })
	            );
	        }
	    }]);
	
	    return ProgressBar;
	}(_react.Component), _class.propTypes = {
	    percentage: _propTypes2.default.number.isRequired
	}, _class.defaultProps = {
	    className: "ProgressBar"
	}, _temp);
	ProgressBar.displayName = "ProgressBar";
	exports.default = ProgressBar;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _formatting = __webpack_require__(872);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MetadataSchemaList = function (_Component) {
	    _inherits(MetadataSchemaList, _Component);
	
	    function MetadataSchemaList(props, context) {
	        _classCallCheck(this, MetadataSchemaList);
	
	        var _this = _possibleConstructorReturn(this, (MetadataSchemaList.__proto__ || Object.getPrototypeOf(MetadataSchemaList)).call(this, props, context));
	
	        _this.state = {
	            searchText: "",
	            searchRegex: null
	        };
	
	        _underscore2.default.bindAll(_this, "updateSearchText");
	        return _this;
	    }
	
	    _createClass(MetadataSchemaList, [{
	        key: "updateSearchText",
	        value: function updateSearchText(event) {
	            this.setState({
	                searchText: event.target.value,
	                searchRegex: event.target.value ? new RegExp(RegExp.escape(event.target.value), "i") : null
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                schemas = _props.schemas,
	                selectedSchema = _props.selectedSchema;
	            var searchRegex = this.state.searchRegex;
	
	
	            var filteredSchemas = searchRegex ? schemas.filter(function (s) {
	                return searchRegex.test(s.name);
	            }) : schemas;
	            return _react2.default.createElement(
	                "div",
	                { className: "MetadataEditor-table-list AdminList flex-no-shrink" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "AdminList-search" },
	                    _react2.default.createElement(_Icon2.default, { name: "search", size: 16 }),
	                    _react2.default.createElement("input", {
	                        className: "AdminInput pl4 border-bottom",
	                        type: "text",
	                        placeholder: "Find a schema",
	                        value: this.state.searchText,
	                        onChange: this.updateSearchText
	                    })
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { className: "AdminList-items" },
	                    _react2.default.createElement(
	                        "li",
	                        { className: "AdminList-section" },
	                        filteredSchemas.length,
	                        " ",
	                        (0, _formatting.inflect)("schema", filteredSchemas.length)
	                    ),
	                    filteredSchemas.map(function (schema) {
	                        return _react2.default.createElement(
	                            "li",
	                            { key: schema.name },
	                            _react2.default.createElement(
	                                "a",
	                                { className: (0, _classnames2.default)("AdminList-item flex align-center no-decoration", { selected: selectedSchema && selectedSchema.name === schema.name }), onClick: function onClick() {
	                                        return _this2.props.onChangeSchema(schema);
	                                    } },
	                                schema.name
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return MetadataSchemaList;
	}(_react.Component);
	
	MetadataSchemaList.displayName = "MetadataSchemaList";
	exports.default = MetadataSchemaList;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MetricsList = __webpack_require__(1825);
	
	var _MetricsList2 = _interopRequireDefault(_MetricsList);
	
	var _ColumnsList = __webpack_require__(1829);
	
	var _ColumnsList2 = _interopRequireDefault(_ColumnsList);
	
	var _SegmentsList = __webpack_require__(1832);
	
	var _SegmentsList2 = _interopRequireDefault(_SegmentsList);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _ProgressBar = __webpack_require__(1822);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MetadataTable = (_temp = _class = function (_Component) {
	    _inherits(MetadataTable, _Component);
	
	    function MetadataTable(props, context) {
	        _classCallCheck(this, MetadataTable);
	
	        var _this = _possibleConstructorReturn(this, (MetadataTable.__proto__ || Object.getPrototypeOf(MetadataTable)).call(this, props, context));
	
	        _this.onDescriptionChange = _this.onDescriptionChange.bind(_this);
	        _this.onNameChange = _this.onNameChange.bind(_this);
	        _this.updateProperty = _this.updateProperty.bind(_this);
	        return _this;
	    }
	
	    _createClass(MetadataTable, [{
	        key: "isHidden",
	        value: function isHidden() {
	            return !!this.props.tableMetadata.visibility_type;
	        }
	    }, {
	        key: "updateProperty",
	        value: function updateProperty(name, value) {
	            this.props.tableMetadata[name] = value;
	            this.setState({ saving: true });
	            this.props.updateTable(this.props.tableMetadata);
	        }
	    }, {
	        key: "onNameChange",
	        value: function onNameChange(event) {
	            if (!_underscore2.default.isEmpty(event.target.value)) {
	                this.updateProperty("display_name", event.target.value);
	            } else {
	                // if the user set this to empty then simply reset it because that's not allowed!
	                event.target.value = this.props.tableMetadata.display_name;
	            }
	        }
	    }, {
	        key: "onDescriptionChange",
	        value: function onDescriptionChange(event) {
	            this.updateProperty("description", event.target.value);
	        }
	    }, {
	        key: "renderVisibilityType",
	        value: function renderVisibilityType(text, type, any) {
	            var classes = (0, _classnames2.default)("mx1", "text-bold", "text-brand-hover", "cursor-pointer", "text-default", {
	                "text-brand": this.props.tableMetadata.visibility_type === type || any && this.props.tableMetadata.visibility_type
	            });
	            return _react2.default.createElement(
	                "span",
	                { className: classes, onClick: this.updateProperty.bind(null, "visibility_type", type) },
	                text
	            );
	        }
	    }, {
	        key: "renderVisibilityWidget",
	        value: function renderVisibilityWidget() {
	            var subTypes;
	            if (this.props.tableMetadata.visibility_type) {
	                subTypes = _react2.default.createElement(
	                    "span",
	                    { id: "VisibilitySubTypes", className: "border-left mx2" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "mx2 text-uppercase text-grey-3" },
	                        "Why Hide?"
	                    ),
	                    this.renderVisibilityType("Technical Data", "technical"),
	                    this.renderVisibilityType("Irrelevant/Cruft", "cruft")
	                );
	            }
	            return _react2.default.createElement(
	                "span",
	                { id: "VisibilityTypes" },
	                this.renderVisibilityType("Queryable", null),
	                this.renderVisibilityType("Hidden", "hidden", true),
	                subTypes
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var tableMetadata = this.props.tableMetadata;
	
	            if (!tableMetadata) {
	                return false;
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "MetadataTable px3 flex-full" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "MetadataTable-title flex flex-column bordered rounded" },
	                    _react2.default.createElement(_Input2.default, { className: "AdminInput TableEditor-table-name text-bold border-bottom rounded-top", type: "text", value: tableMetadata.display_name || "", onBlurChange: this.onNameChange }),
	                    _react2.default.createElement(_Input2.default, { className: "AdminInput TableEditor-table-description rounded-bottom", type: "text", value: tableMetadata.description || "", onBlurChange: this.onDescriptionChange, placeholder: "No table description yet" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "MetadataTable-header flex align-center py2 text-grey-3" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "mx1 text-uppercase" },
	                        "Visibility"
	                    ),
	                    this.renderVisibilityWidget(),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "flex-align-right flex align-center" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "text-uppercase mr1" },
	                            "Metadata Strength"
	                        ),
	                        _react2.default.createElement(_ProgressBar2.default, { percentage: tableMetadata.metadataStrength })
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "mt2 " + (this.isHidden() ? "disabled" : "") },
	                    _react2.default.createElement(_SegmentsList2.default, {
	                        tableMetadata: tableMetadata,
	                        onRetire: this.props.onRetireSegment
	                    }),
	                    _react2.default.createElement(_MetricsList2.default, {
	                        tableMetadata: tableMetadata,
	                        onRetire: this.props.onRetireMetric
	                    }),
	                    _react2.default.createElement(_ColumnsList2.default, {
	                        tableMetadata: tableMetadata,
	                        idfields: this.props.idfields,
	                        updateField: this.props.updateField
	                    })
	                )
	            );
	        }
	    }]);
	
	    return MetadataTable;
	}(_react.Component), _class.propTypes = {
	    tableMetadata: _propTypes2.default.object,
	    idfields: _propTypes2.default.array.isRequired,
	    updateTable: _propTypes2.default.func.isRequired,
	    updateField: _propTypes2.default.func.isRequired
	}, _temp);
	MetadataTable.displayName = "MetadataTable";
	exports.default = MetadataTable;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _MetricItem = __webpack_require__(1826);
	
	var _MetricItem2 = _interopRequireDefault(_MetricItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MetricsList = (_temp = _class = function (_Component) {
	    _inherits(MetricsList, _Component);
	
	    function MetricsList() {
	        _classCallCheck(this, MetricsList);
	
	        return _possibleConstructorReturn(this, (MetricsList.__proto__ || Object.getPrototypeOf(MetricsList)).apply(this, arguments));
	    }
	
	    _createClass(MetricsList, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var tableMetadata = this.props.tableMetadata;
	
	
	            tableMetadata.metrics = tableMetadata.metrics || [];
	            tableMetadata.metrics = tableMetadata.metrics.filter(function (mtrc) {
	                return mtrc.is_active === true;
	            });
	
	            return _react2.default.createElement(
	                "div",
	                { id: "MetricsList", className: "my3" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex mb1" },
	                    _react2.default.createElement(
	                        "h2",
	                        { className: "px1 text-green" },
	                        "Metrics"
	                    ),
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: "/admin/datamodel/metric/create?table=" + tableMetadata.id, "data-metabase-event": "Data Model;Add Metric Page", className: "flex-align-right float-right text-bold text-brand no-decoration" },
	                        "+ Add a Metric"
	                    )
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: "AdminTable" },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                { style: { minWidth: "200px" } },
	                                "Name"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                { className: "full" },
	                                "Definition"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Actions"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        tableMetadata.metrics.map(function (metric) {
	                            return _react2.default.createElement(_MetricItem2.default, {
	                                key: metric.id,
	                                metric: metric,
	                                tableMetadata: tableMetadata,
	                                onRetire: _this2.props.onRetire
	                            });
	                        })
	                    )
	                ),
	                tableMetadata.metrics.length === 0 && _react2.default.createElement(
	                    "div",
	                    { className: "flex layout-centered m4 text-grey-3" },
	                    "Create metrics to add them to the View dropdown in the query builder"
	                )
	            );
	        }
	    }]);
	
	    return MetricsList;
	}(_react.Component), _class.propTypes = {
	    tableMetadata: _propTypes2.default.object.isRequired,
	    onRetire: _propTypes2.default.func.isRequired
	}, _temp);
	MetricsList.displayName = "MetricsList";
	exports.default = MetricsList;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ObjectActionSelect = __webpack_require__(1827);
	
	var _ObjectActionSelect2 = _interopRequireDefault(_ObjectActionSelect);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MetricItem = (_temp = _class = function (_Component) {
	    _inherits(MetricItem, _Component);
	
	    function MetricItem() {
	        _classCallCheck(this, MetricItem);
	
	        return _possibleConstructorReturn(this, (MetricItem.__proto__ || Object.getPrototypeOf(MetricItem)).apply(this, arguments));
	    }
	
	    _createClass(MetricItem, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                metric = _props.metric,
	                tableMetadata = _props.tableMetadata;
	
	
	            var description = _query2.default.generateQueryDescription(tableMetadata, metric.definition, { sections: ["aggregation", "filter"], jsx: true });
	
	            return _react2.default.createElement(
	                "tr",
	                { className: "mt1 mb3" },
	                _react2.default.createElement(
	                    "td",
	                    { className: "px1" },
	                    metric.name
	                ),
	                _react2.default.createElement(
	                    "td",
	                    { className: "px1 text-ellipsis" },
	                    description
	                ),
	                _react2.default.createElement(
	                    "td",
	                    { className: "px1 text-centered" },
	                    _react2.default.createElement(_ObjectActionSelect2.default, {
	                        object: metric,
	                        objectType: "metric",
	                        onRetire: this.props.onRetire
	                    })
	                )
	            );
	        }
	    }]);
	
	    return MetricItem;
	}(_react.Component), _class.propTypes = {
	    metric: _propTypes2.default.object.isRequired,
	    onRetire: _propTypes2.default.func.isRequired
	}, _temp);
	MetricItem.displayName = "MetricItem";
	exports.default = MetricItem;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _ObjectRetireModal = __webpack_require__(1828);
	
	var _ObjectRetireModal2 = _interopRequireDefault(_ObjectRetireModal);
	
	var _formatting = __webpack_require__(872);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ObjectActionsSelect = (_temp = _class = function (_Component) {
	    _inherits(ObjectActionsSelect, _Component);
	
	    function ObjectActionsSelect() {
	        _classCallCheck(this, ObjectActionsSelect);
	
	        return _possibleConstructorReturn(this, (ObjectActionsSelect.__proto__ || Object.getPrototypeOf(ObjectActionsSelect)).apply(this, arguments));
	    }
	
	    _createClass(ObjectActionsSelect, [{
	        key: "onRetire",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(object) {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.onRetire(object);
	
	                            case 2:
	                                this.refs.retireModal.close();
	
	                            case 3:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function onRetire(_x) {
	                return _ref.apply(this, arguments);
	            }
	
	            return onRetire;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                object = _props.object,
	                objectType = _props.objectType;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    _PopoverWithTrigger2.default,
	                    {
	                        ref: "popover",
	                        triggerElement: _react2.default.createElement(
	                            "span",
	                            { className: "text-grey-1 text-grey-4-hover" },
	                            _react2.default.createElement(_Icon2.default, { name: 'ellipsis' })
	                        )
	                    },
	                    _react2.default.createElement(
	                        "ul",
	                        { className: "UserActionsSelect" },
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: "/admin/datamodel/" + objectType + "/" + object.id, "data-metabase-event": "Data Model;" + objectType + " Edit Page", className: "py1 px2 block bg-brand-hover text-white-hover no-decoration cursor-pointer" },
	                                "Edit ",
	                                (0, _formatting.capitalize)(objectType)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: "/admin/datamodel/" + objectType + "/" + object.id + "/revisions", "data-metabase-event": "Data Model;" + objectType + " History", className: "py1 px2 block bg-brand-hover text-white-hover no-decoration cursor-pointer" },
	                                "Revision History"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            { className: "mt1 border-top" },
	                            _react2.default.createElement(
	                                _ModalWithTrigger2.default,
	                                {
	                                    ref: "retireModal",
	                                    triggerElement: "Retire " + (0, _formatting.capitalize)(objectType),
	                                    triggerClasses: "block p2 bg-error-hover text-error text-white-hover cursor-pointer"
	                                },
	                                _react2.default.createElement(_ObjectRetireModal2.default, {
	                                    object: object,
	                                    objectType: objectType,
	                                    onRetire: this.onRetire.bind(this),
	                                    onClose: function onClose() {
	                                        return _this2.refs.retireModal.close();
	                                    }
	                                })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ObjectActionsSelect;
	}(_react.Component), _class.propTypes = {
	    object: _propTypes2.default.object.isRequired,
	    objectType: _propTypes2.default.string.isRequired,
	    onRetire: _propTypes2.default.func.isRequired
	}, _temp);
	ObjectActionsSelect.displayName = "ObjectActionsSelect";
	exports.default = ObjectActionsSelect;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ActionButton = __webpack_require__(1213);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ObjectRetireModal = function (_Component) {
	    _inherits(ObjectRetireModal, _Component);
	
	    function ObjectRetireModal(props, context) {
	        _classCallCheck(this, ObjectRetireModal);
	
	        var _this = _possibleConstructorReturn(this, (ObjectRetireModal.__proto__ || Object.getPrototypeOf(ObjectRetireModal)).call(this, props, context));
	
	        _this.state = {
	            valid: false
	        };
	        return _this;
	    }
	
	    _createClass(ObjectRetireModal, [{
	        key: "handleSubmit",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var _props, object, objectType, payload;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _props = this.props, object = _props.object, objectType = _props.objectType;
	                                payload = {
	                                    revision_message: _reactDom2.default.findDOMNode(this.refs.revision_message).value
	                                };
	
	                                payload[objectType + "Id"] = object.id;
	
	                                _context.next = 5;
	                                return this.props.onRetire(payload);
	
	                            case 5:
	                                this.props.onClose();
	
	                            case 6:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function handleSubmit() {
	                return _ref.apply(this, arguments);
	            }
	
	            return handleSubmit;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var objectType = this.props.objectType;
	            var valid = this.state.valid;
	
	            return _react2.default.createElement(
	                _ModalContent2.default,
	                {
	                    title: "Retire this " + objectType + "?",
	                    onClose: this.props.onClose
	                },
	                _react2.default.createElement(
	                    "form",
	                    { className: "flex flex-column flex-full" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Form-inputs pb4" },
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-paragraph" },
	                            "Saved questions and other things that depend on this ",
	                            objectType,
	                            " will continue to work, but this ",
	                            objectType,
	                            " will no longer be selectable from the query builder."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-paragraph" },
	                            "If you're sure you want to retire this ",
	                            objectType,
	                            ", please write a quick explanation of why it's being retired:"
	                        ),
	                        _react2.default.createElement("textarea", {
	                            ref: "revision_message",
	                            className: "input full",
	                            placeholder: "This will show up in the activity feed and in an email that will be sent to anyone on your team who created something that uses this " + objectType + ".",
	                            onChange: function onChange(e) {
	                                return _this2.setState({ valid: !!e.target.value });
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Form-actions ml-auto" },
	                        _react2.default.createElement(
	                            "a",
	                            { className: "Button", onClick: this.props.onClose },
	                            "Cancel"
	                        ),
	                        _react2.default.createElement(_ActionButton2.default, {
	                            actionFn: this.handleSubmit.bind(this),
	                            className: (0, _classnames2.default)("Button ml2", { "Button--danger": valid, "disabled": !valid }),
	                            normalText: "Retire",
	                            activeText: "Retiring\u2026",
	                            failedText: "Failed",
	                            successText: "Success"
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ObjectRetireModal;
	}(_react.Component);
	
	ObjectRetireModal.displayName = "ObjectRetireModal";
	exports.default = ObjectRetireModal;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ColumnItem = __webpack_require__(1830);
	
	var _ColumnItem2 = _interopRequireDefault(_ColumnItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColumnsList = (_temp = _class = function (_Component) {
	    _inherits(ColumnsList, _Component);
	
	    function ColumnsList() {
	        _classCallCheck(this, ColumnsList);
	
	        return _possibleConstructorReturn(this, (ColumnsList.__proto__ || Object.getPrototypeOf(ColumnsList)).apply(this, arguments));
	    }
	
	    _createClass(ColumnsList, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var tableMetadata = this.props.tableMetadata;
	
	            return _react2.default.createElement(
	                "div",
	                { id: "ColumnsList", className: "my3" },
	                _react2.default.createElement(
	                    "h2",
	                    { className: "px1 text-orange" },
	                    "Columns"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "text-uppercase text-grey-3 py1" },
	                    _react2.default.createElement(
	                        "div",
	                        { style: { minWidth: 420 }, className: "float-left px1" },
	                        "Column"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex clearfix" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex-half px1" },
	                            "Visibility"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex-half px1" },
	                            "Type"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "ol",
	                    { className: "border-top border-bottom" },
	                    tableMetadata.fields.map(function (field) {
	                        return _react2.default.createElement(_ColumnItem2.default, {
	                            key: field.id,
	                            field: field,
	                            idfields: _this2.props.idfields,
	                            updateField: _this2.props.updateField
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ColumnsList;
	}(_react.Component), _class.propTypes = {
	    tableMetadata: _propTypes2.default.object,
	    idfields: _propTypes2.default.array,
	    updateField: _propTypes2.default.func.isRequired
	}, _temp);
	ColumnsList.displayName = "ColumnsList";
	exports.default = ColumnsList;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpecialTypeAndTargetPicker = exports.FieldVisibilityPicker = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _core = __webpack_require__(1831);
	
	var MetabaseCore = _interopRequireWildcard(_core);
	
	var _formatting = __webpack_require__(872);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _types = __webpack_require__(868);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Column = (0, _reactRouter.withRouter)(_class = (_temp = _class2 = function (_Component) {
	    _inherits(Column, _Component);
	
	    function Column(props, context) {
	        _classCallCheck(this, Column);
	
	        var _this = _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).call(this, props, context));
	
	        _this.onDescriptionChange = _this.onDescriptionChange.bind(_this);
	        _this.onNameChange = _this.onNameChange.bind(_this);
	        _this.onVisibilityChange = _this.onVisibilityChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(Column, [{
	        key: "updateProperty",
	        value: function updateProperty(name, value) {
	            this.props.field[name] = value;
	            this.props.updateField(this.props.field);
	        }
	    }, {
	        key: "onNameChange",
	        value: function onNameChange(event) {
	            if (!_underscore2.default.isEmpty(event.target.value)) {
	                this.updateProperty("display_name", event.target.value);
	            } else {
	                // if the user set this to empty then simply reset it because that's not allowed!
	                event.target.value = this.props.field.display_name;
	            }
	        }
	    }, {
	        key: "onDescriptionChange",
	        value: function onDescriptionChange(event) {
	            this.updateProperty("description", event.target.value);
	        }
	    }, {
	        key: "onVisibilityChange",
	        value: function onVisibilityChange(type) {
	            this.updateProperty("visibility_type", type.id);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                field = _props.field,
	                idfields = _props.idfields,
	                updateField = _props.updateField;
	
	
	            return _react2.default.createElement(
	                "li",
	                { className: "mt1 mb3 flex" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex flex-column flex-full" },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(_Input2.default, { style: { minWidth: 420 }, className: "AdminInput TableEditor-field-name float-left bordered inline-block rounded text-bold", type: "text", value: this.props.field.display_name || "", onBlurChange: this.onNameChange }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "clearfix" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "flex flex-full" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "flex-full px1" },
	                                    _react2.default.createElement(FieldVisibilityPicker, {
	                                        className: "block",
	                                        field: field,
	                                        updateField: updateField
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "flex-full px1" },
	                                    _react2.default.createElement(SpecialTypeAndTargetPicker, {
	                                        className: "block",
	                                        field: field,
	                                        updateField: updateField,
	                                        idfields: idfields
	                                    })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "MetadataTable-title flex flex-column flex-full bordered rounded mt1 mr1" },
	                        _react2.default.createElement(_Input2.default, { className: "AdminInput TableEditor-field-description", type: "text", value: this.props.field.description || "", onBlurChange: this.onDescriptionChange, placeholder: "No column description yet" })
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: this.props.location.pathname + "/" + this.props.field.id, className: "text-brand-hover mx2 mt1" },
	                    _react2.default.createElement(_Icon2.default, { name: "gear" })
	                )
	            );
	        }
	    }]);
	
	    return Column;
	}(_react.Component), _class2.propTypes = {
	    field: _propTypes2.default.object,
	    idfields: _propTypes2.default.array.isRequired,
	    updateField: _propTypes2.default.func.isRequired
	}, _temp)) || _class;
	
	Column.displayName = "Column";
	exports.default = Column;
	
	// FieldVisibilityPicker and SpecialTypeSelect are also used in FieldApp
	
	var FieldVisibilityPicker = exports.FieldVisibilityPicker = function (_Component2) {
	    _inherits(FieldVisibilityPicker, _Component2);
	
	    function FieldVisibilityPicker() {
	        var _ref;
	
	        var _temp2, _this2, _ret;
	
	        _classCallCheck(this, FieldVisibilityPicker);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref = FieldVisibilityPicker.__proto__ || Object.getPrototypeOf(FieldVisibilityPicker)).call.apply(_ref, [this].concat(args))), _this2), _this2.onVisibilityChange = function (visibilityType) {
	            var field = _this2.props.field;
	
	            field.visibility_type = visibilityType.id;
	            _this2.props.updateField(field);
	        }, _temp2), _possibleConstructorReturn(_this2, _ret);
	    }
	
	    _createClass(FieldVisibilityPicker, [{
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                field = _props2.field,
	                className = _props2.className;
	
	
	            return _react2.default.createElement(_Select2.default, {
	                className: (0, _classnames2.default)("TableEditor-field-visibility block", className),
	                placeholder: "Select a field visibility",
	                value: _underscore2.default.find(MetabaseCore.field_visibility_types, function (type) {
	                    return type.id === field.visibility_type;
	                }),
	                options: MetabaseCore.field_visibility_types,
	                onChange: this.onVisibilityChange,
	                triggerClasses: this.props.triggerClasses
	            });
	        }
	    }]);
	
	    return FieldVisibilityPicker;
	}(_react.Component);
	
	FieldVisibilityPicker.displayName = "FieldVisibilityPicker";
	
	var SpecialTypeAndTargetPicker = exports.SpecialTypeAndTargetPicker = function (_Component3) {
	    _inherits(SpecialTypeAndTargetPicker, _Component3);
	
	    function SpecialTypeAndTargetPicker() {
	        var _ref2,
	            _this4 = this;
	
	        var _temp3, _this3, _ret2;
	
	        _classCallCheck(this, SpecialTypeAndTargetPicker);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref2 = SpecialTypeAndTargetPicker.__proto__ || Object.getPrototypeOf(SpecialTypeAndTargetPicker)).call.apply(_ref2, [this].concat(args))), _this3), _this3.onSpecialTypeChange = function () {
	            var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(special_type) {
	                var _this3$props, field, updateField;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _this3$props = _this3.props, field = _this3$props.field, updateField = _this3$props.updateField;
	
	                                field.special_type = special_type.id;
	
	                                // If we are changing the field from a FK to something else, we should delete any FKs present
	                                if (field.target && field.target.id != null && (0, _types.isFK)(field.special_type)) {
	                                    // we have something that used to be an FK and is now not an FK
	                                    // clean up after ourselves
	                                    field.target = null;
	                                    field.fk_target_field_id = null;
	                                }
	
	                                _context.next = 5;
	                                return updateField(field);
	
	                            case 5:
	
	                                _analytics2.default.trackEvent("Data Model", "Update Field Special-Type", field.special_type);
	
	                            case 6:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this4);
	            }));
	
	            return function (_x) {
	                return _ref3.apply(this, arguments);
	            };
	        }(), _this3.onTargetChange = function () {
	            var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(target_field) {
	                var _this3$props2, field, updateField;
	
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _this3$props2 = _this3.props, field = _this3$props2.field, updateField = _this3$props2.updateField;
	
	                                field.fk_target_field_id = target_field.id;
	
	                                _context2.next = 4;
	                                return updateField(field);
	
	                            case 4:
	
	                                _analytics2.default.trackEvent("Data Model", "Update Field Target");
	
	                            case 5:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, _this4);
	            }));
	
	            return function (_x2) {
	                return _ref4.apply(this, arguments);
	            };
	        }(), _temp3), _possibleConstructorReturn(_this3, _ret2);
	    }
	
	    _createClass(SpecialTypeAndTargetPicker, [{
	        key: "render",
	        value: function render() {
	            var _props3 = this.props,
	                field = _props3.field,
	                idfields = _props3.idfields,
	                className = _props3.className,
	                selectSeparator = _props3.selectSeparator;
	
	
	            var specialTypes = MetabaseCore.field_special_types.slice(0);
	            specialTypes.push({ 'id': null, 'name': 'No special type', 'section': 'Other' });
	            // if we don't have a numeric base-type then prevent the options for unix timestamp conversion (#823)
	            if (!(0, _schema_metadata.isNumericBaseType)(field)) {
	                specialTypes = specialTypes.filter(function (f) {
	                    return !(0, _types.isa)(f.id, _types.TYPE.UNIXTimestamp);
	                });
	            }
	
	            var showFKTargetSelect = (0, _types.isFK)(field.special_type);
	
	            // If all FK target fields are in the same schema (like `PUBLIC` for sample dataset)
	            // or if there are no schemas at all, omit the schema name
	            var includeSchemaName = _underscore2.default.uniq(idfields.map(function (idField) {
	                return idField.table.schema;
	            })).length > 1;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_Select2.default, {
	                    className: (0, _classnames2.default)("TableEditor-field-special-type", className),
	                    placeholder: "Select a special type",
	                    value: _underscore2.default.find(MetabaseCore.field_special_types, function (type) {
	                        return type.id === field.special_type;
	                    }),
	                    options: specialTypes,
	                    onChange: this.onSpecialTypeChange,
	                    triggerClasses: this.props.triggerClasses
	                }),
	                showFKTargetSelect && selectSeparator,
	                showFKTargetSelect && _react2.default.createElement(_Select2.default, {
	                    className: (0, _classnames2.default)("TableEditor-field-target", className),
	                    triggerClasses: this.props.triggerClasses,
	                    placeholder: "Select a target",
	                    value: field.fk_target_field_id && _underscore2.default.find(idfields, function (idField) {
	                        return idField.id === field.fk_target_field_id;
	                    }),
	                    options: idfields,
	                    optionNameFn: function optionNameFn(idField) {
	                        return includeSchemaName ? (0, _formatting.titleize)((0, _formatting.humanize)(idField.table.schema)) + "." + idField.displayName : idField.displayName;
	                    },
	                    onChange: this.onTargetChange
	                })
	            );
	        }
	    }]);
	
	    return SpecialTypeAndTargetPicker;
	}(_react.Component);
	
	SpecialTypeAndTargetPicker.displayName = "SpecialTypeAndTargetPicker";

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.field_visibility_types = exports.field_special_types_map = exports.field_special_types = undefined;
	
	var _types = __webpack_require__(868);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var field_special_types = exports.field_special_types = [{
	    'id': _types.TYPE.PK,
	    'name': 'Entity Key',
	    'section': 'Overall Row',
	    'description': 'The primary key for this table.'
	}, {
	    'id': _types.TYPE.Name,
	    'name': 'Entity Name',
	    'section': 'Overall Row',
	    'description': 'The "name" of each record. Usually a column called "name", "title", etc.'
	}, {
	    'id': _types.TYPE.FK,
	    'name': 'Foreign Key',
	    'section': 'Overall Row',
	    'description': 'Points to another table to make a connection.'
	}, {
	    'id': _types.TYPE.AvatarURL,
	    'name': 'Avatar Image URL',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.Category,
	    'name': 'Category',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.City,
	    'name': 'City',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.Country,
	    'name': 'Country',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.Description,
	    'name': 'Description',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.Email,
	    'name': 'Email',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.Enum,
	    'name': 'Enum',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.ImageURL,
	    'name': 'Image URL',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.SerializedJSON,
	    'name': 'Field containing JSON',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.Latitude,
	    'name': 'Latitude',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.Longitude,
	    'name': 'Longitude',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.Number,
	    'name': 'Number',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.State,
	    'name': 'State',
	    'section': 'Common'
	}, {
	    id: _types.TYPE.UNIXTimestampSeconds,
	    name: 'UNIX Timestamp (Seconds)',
	    'section': 'Common'
	}, {
	    id: _types.TYPE.UNIXTimestampMilliseconds,
	    name: 'UNIX Timestamp (Milliseconds)',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.URL,
	    'name': 'URL',
	    'section': 'Common'
	}, {
	    'id': _types.TYPE.ZipCode,
	    'name': 'Zip Code',
	    'section': 'Common'
	}];
	
	var field_special_types_map = exports.field_special_types_map = field_special_types.reduce(function (map, type) {
	    return Object.assign({}, map, _defineProperty({}, type.id, type));
	}, {});
	
	var field_visibility_types = exports.field_visibility_types = [{
	    'id': 'normal',
	    'name': 'Everywhere',
	    'description': 'The default setting.  This field will be displayed normally in tables and charts.'
	}, {
	    'id': 'details-only',
	    'name': 'Only in Detail Views',
	    'description': "This field will only be displayed when viewing the details of a single record. Use this for information that's lengthy or that isn't useful in a table or chart."
	}, {
	    'id': 'sensitive',
	    'name': 'Do Not Include',
	    'description': 'Metabase will never retrieve this field. Use this for sensitive or irrelevant information.'
	}];

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _SegmentItem = __webpack_require__(1833);
	
	var _SegmentItem2 = _interopRequireDefault(_SegmentItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SegmentsList = (_temp = _class = function (_Component) {
	    _inherits(SegmentsList, _Component);
	
	    function SegmentsList() {
	        _classCallCheck(this, SegmentsList);
	
	        return _possibleConstructorReturn(this, (SegmentsList.__proto__ || Object.getPrototypeOf(SegmentsList)).apply(this, arguments));
	    }
	
	    _createClass(SegmentsList, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var tableMetadata = this.props.tableMetadata;
	
	
	            tableMetadata.segments = tableMetadata.segments || [];
	            tableMetadata.segments = tableMetadata.segments.filter(function (sgmt) {
	                return sgmt.is_active === true;
	            });
	
	            return _react2.default.createElement(
	                "div",
	                { id: "SegmentsList", className: "my3" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex mb1" },
	                    _react2.default.createElement(
	                        "h2",
	                        { className: "px1 text-purple" },
	                        "Segments"
	                    ),
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: "/admin/datamodel/segment/create?table=" + tableMetadata.id, "data-metabase-event": "Data Model;Add Segment Page", className: "flex-align-right float-right text-bold text-brand no-decoration" },
	                        "+ Add a Segment"
	                    )
	                ),
	                _react2.default.createElement(
	                    "table",
	                    { className: "AdminTable" },
	                    _react2.default.createElement(
	                        "thead",
	                        null,
	                        _react2.default.createElement(
	                            "tr",
	                            null,
	                            _react2.default.createElement(
	                                "th",
	                                { style: { minWidth: "200px" } },
	                                "Name"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                { className: "full" },
	                                "Definition"
	                            ),
	                            _react2.default.createElement(
	                                "th",
	                                null,
	                                "Actions"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "tbody",
	                        null,
	                        tableMetadata.segments.map(function (segment) {
	                            return _react2.default.createElement(_SegmentItem2.default, {
	                                key: segment.id,
	                                segment: segment,
	                                tableMetadata: tableMetadata,
	                                onRetire: _this2.props.onRetire
	                            });
	                        })
	                    )
	                ),
	                tableMetadata.segments.length === 0 && _react2.default.createElement(
	                    "div",
	                    { className: "flex layout-centered m4 text-grey-3" },
	                    "Create segments to add them to the Filter dropdown in the query builder"
	                )
	            );
	        }
	    }]);
	
	    return SegmentsList;
	}(_react.Component), _class.propTypes = {
	    tableMetadata: _propTypes2.default.object.isRequired,
	    onRetire: _propTypes2.default.func.isRequired
	}, _temp);
	SegmentsList.displayName = "SegmentsList";
	exports.default = SegmentsList;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ObjectActionSelect = __webpack_require__(1827);
	
	var _ObjectActionSelect2 = _interopRequireDefault(_ObjectActionSelect);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SegmentItem = (_temp = _class = function (_Component) {
	    _inherits(SegmentItem, _Component);
	
	    function SegmentItem() {
	        _classCallCheck(this, SegmentItem);
	
	        return _possibleConstructorReturn(this, (SegmentItem.__proto__ || Object.getPrototypeOf(SegmentItem)).apply(this, arguments));
	    }
	
	    _createClass(SegmentItem, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                segment = _props.segment,
	                tableMetadata = _props.tableMetadata;
	
	
	            var description = _query2.default.generateQueryDescription(tableMetadata, segment.definition, { sections: ["filter"], jsx: true });
	
	            return _react2.default.createElement(
	                "tr",
	                { className: "mt1 mb3" },
	                _react2.default.createElement(
	                    "td",
	                    { className: "px1" },
	                    segment.name
	                ),
	                _react2.default.createElement(
	                    "td",
	                    { className: "px1 text-ellipsis" },
	                    _react2.default.createElement(
	                        "div",
	                        { style: { maxWidth: 400, overflow: 'hidden', textOverflow: 'ellipsis' } },
	                        description
	                    )
	                ),
	                _react2.default.createElement(
	                    "td",
	                    { className: "px1 text-centered" },
	                    _react2.default.createElement(_ObjectActionSelect2.default, {
	                        object: segment,
	                        objectType: "segment",
	                        onRetire: this.props.onRetire
	                    })
	                )
	            );
	        }
	    }]);
	
	    return SegmentItem;
	}(_react.Component), _class.propTypes = {
	    segment: _propTypes2.default.object.isRequired,
	    tableMetadata: _propTypes2.default.object.isRequired,
	    onRetire: _propTypes2.default.func.isRequired
	}, _temp);
	SegmentItem.displayName = "SegmentItem";
	exports.default = SegmentItem;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MetadataSchema = (_temp = _class = function (_Component) {
	    _inherits(MetadataSchema, _Component);
	
	    function MetadataSchema() {
	        _classCallCheck(this, MetadataSchema);
	
	        return _possibleConstructorReturn(this, (MetadataSchema.__proto__ || Object.getPrototypeOf(MetadataSchema)).apply(this, arguments));
	    }
	
	    _createClass(MetadataSchema, [{
	        key: "render",
	        value: function render() {
	            var tableMetadata = this.props.tableMetadata;
	
	            if (!tableMetadata) {
	                return false;
	            }
	
	            var fields = tableMetadata.fields.map(function (field) {
	                return _react2.default.createElement(
	                    "li",
	                    { key: field.id, className: "px1 py2 flex border-bottom" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-full flex flex-column mr1" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "TableEditor-field-name text-bold" },
	                            field.name
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex-half" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "text-bold" },
	                            field.base_type
	                        )
	                    ),
	                    _react2.default.createElement("div", { className: "flex-half" })
	                );
	            });
	
	            return _react2.default.createElement(
	                "div",
	                { className: "MetadataTable px2 flex-full" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex flex-column px1" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "TableEditor-table-name text-bold" },
	                        tableMetadata.name
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "mt2 " },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "text-uppercase text-grey-3 py1 flex" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex-full px1" },
	                            "Column"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex-half px1" },
	                            "Data Type"
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex-half px1" },
	                            "Additional Info"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "ol",
	                        { className: "border-top border-bottom" },
	                        fields
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MetadataSchema;
	}(_react.Component), _class.propTypes = {
	    tableMetadata: _propTypes2.default.object
	}, _temp);
	MetadataSchema.displayName = "MetadataSchema";
	exports.default = MetadataSchema;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getEditingDatabaseWithTableMetadataStrengths = exports.getEditingDatabase = exports.getEditingTable = exports.getDatabaseIdfields = exports.getDatabases = exports.revisionHistorySelectors = exports.metricFormSelectors = exports.metricEditSelectors = exports.segmentFormSelectors = exports.segmentEditSelectors = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__(1072);
	
	var _schema_metadata = __webpack_require__(867);
	
	var segmentsSelector = function segmentsSelector(state, props) {
	    return state.admin.datamodel.segments;
	};
	var metricsSelector = function metricsSelector(state, props) {
	    return state.admin.datamodel.metrics;
	};
	
	var tableMetadataSelector = function tableMetadataSelector(state, props) {
	    return state.admin.datamodel.tableMetadata;
	};
	var previewSummarySelector = function previewSummarySelector(state, props) {
	    return state.admin.datamodel.previewSummary;
	};
	var revisionObjectSelector = function revisionObjectSelector(state, props) {
	    return state.admin.datamodel.revisionObject;
	};
	
	var idSelector = function idSelector(state, props) {
	    return props.params.id == null ? null : parseInt(props.params.id);
	};
	var tableIdSelector = function tableIdSelector(state, props) {
	    return props.location.query.table == null ? null : parseInt(props.location.query.table);
	};
	
	var userSelector = function userSelector(state, props) {
	    return state.currentUser;
	};
	
	var segmentEditSelectors = exports.segmentEditSelectors = (0, _reselect.createSelector)(segmentsSelector, idSelector, tableIdSelector, tableMetadataSelector, function (segments, id, tableId, tableMetadata) {
	    return {
	        segment: id == null ? { id: null, table_id: tableId, definition: { filter: [] } } : segments[id],
	        tableMetadata: tableMetadata
	    };
	});
	
	var segmentFormSelectors = exports.segmentFormSelectors = (0, _reselect.createSelector)(segmentEditSelectors, previewSummarySelector, function (_ref, previewSummary) {
	    var segment = _ref.segment,
	        tableMetadata = _ref.tableMetadata;
	    return {
	        initialValues: segment,
	        tableMetadata: tableMetadata,
	        previewSummary: previewSummary
	    };
	});
	
	var metricEditSelectors = exports.metricEditSelectors = (0, _reselect.createSelector)(metricsSelector, idSelector, tableIdSelector, tableMetadataSelector, function (metrics, id, tableId, tableMetadata) {
	    return {
	        metric: id == null ? { id: null, table_id: tableId, definition: { aggregation: [null] } } : metrics[id],
	        tableMetadata: tableMetadata
	    };
	});
	
	var metricFormSelectors = exports.metricFormSelectors = (0, _reselect.createSelector)(metricEditSelectors, previewSummarySelector, function (_ref2, previewSummary) {
	    var metric = _ref2.metric,
	        tableMetadata = _ref2.tableMetadata;
	    return {
	        initialValues: metric,
	        tableMetadata: tableMetadata,
	        previewSummary: previewSummary
	    };
	});
	
	var revisionHistorySelectors = exports.revisionHistorySelectors = (0, _reselect.createSelector)(revisionObjectSelector, tableMetadataSelector, userSelector, function (revisionObject, tableMetadata, user) {
	    return _extends({}, revisionObject, {
	        tableMetadata: tableMetadata,
	        user: user
	    });
	});
	
	var getDatabases = exports.getDatabases = function getDatabases(state, props) {
	    return state.admin.datamodel.databases;
	};
	var getDatabaseIdfields = exports.getDatabaseIdfields = function getDatabaseIdfields(state, props) {
	    return state.admin.datamodel.idfields;
	};
	var getEditingTable = exports.getEditingTable = function getEditingTable(state, props) {
	    return state.admin.datamodel.editingTable;
	};
	var getEditingDatabase = exports.getEditingDatabase = function getEditingDatabase(state, props) {
	    return state.admin.datamodel.editingDatabase;
	};
	
	var getEditingDatabaseWithTableMetadataStrengths = exports.getEditingDatabaseWithTableMetadataStrengths = (0, _reselect.createSelector)(function (state) {
	    return state.admin.datamodel.editingDatabase;
	}, function (database) {
	    if (!database || !database.tables) {
	        return null;
	    }
	
	    database.tables = database.tables.map(function (table) {
	        table.metadataStrength = (0, _schema_metadata.computeMetadataStrength)(table);
	        return table;
	    });
	
	    return database;
	});

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchRevisions = exports.FETCH_REVISIONS = exports.updatePreviewSummary = exports.loadTableMetadata = exports.UPDATE_PREVIEW_SUMMARY = exports.LOAD_TABLE_METADATA = exports.deleteMetric = exports.updateMetric = exports.createMetric = exports.getMetric = exports.DELETE_METRIC = exports.UPDATE_METRIC = exports.CREATE_METRIC = exports.GET_METRIC = exports.deleteSegment = exports.updateSegment = exports.createSegment = exports.getSegment = exports.DELETE_SEGMENT = exports.UPDATE_SEGMENT = exports.CREATE_SEGMENT = exports.GET_SEGMENT = exports.onRetireMetric = exports.RETIRE_METRIC = exports.onRetireSegment = exports.RETIRE_SEGMENT = exports.updateField = exports.UPDATE_FIELD = exports.updateTable = exports.UPDATE_TABLE = exports.selectTable = exports.SELECT_TABLE = exports.selectDatabase = exports.SELECT_DATABASE = exports.fetchDatabaseIdfields = exports.FETCH_IDFIELDS = exports.initializeMetadata = exports.INITIALIZE_METADATA = undefined;
	
	var _handleActions3, _handleActions4, _handleActions5, _handleActions6;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _redux = __webpack_require__(657);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _table = __webpack_require__(871);
	
	var _services = __webpack_require__(857);
	
	var _selectors = __webpack_require__(1835);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function loadDatabaseMetadata(databaseId) {
	    return _services.MetabaseApi.db_metadata({ 'dbId': databaseId });
	}
	
	// initializeMetadata
	var INITIALIZE_METADATA = exports.INITIALIZE_METADATA = "metabase/admin/datamodel/INITIALIZE_METADATA";
	var initializeMetadata = exports.initializeMetadata = (0, _redux.createThunkAction)(INITIALIZE_METADATA, function (databaseId, tableId) {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var databases, database, db;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            databases = void 0, database = void 0;
	                            _context.prev = 1;
	                            _context.next = 4;
	                            return _services.MetabaseApi.db_list();
	
	                        case 4:
	                            databases = _context.sent;
	                            _context.next = 10;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context["catch"](1);
	
	                            console.log("error fetching databases", _context.t0);
	
	                        case 10:
	                            if (!(databases && !_underscore2.default.isEmpty(databases))) {
	                                _context.next = 15;
	                                break;
	                            }
	
	                            db = databaseId ? _underscore2.default.findWhere(databases, { id: databaseId }) : databases[0];
	                            _context.next = 14;
	                            return loadDatabaseMetadata(db.id);
	
	                        case 14:
	                            database = _context.sent;
	
	                        case 15:
	
	                            if (database) {
	                                dispatch(fetchDatabaseIdfields(database.id));
	                            }
	
	                            return _context.abrupt("return", {
	                                databases: databases,
	                                database: database,
	                                tableId: tableId
	                            });
	
	                        case 17:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[1, 7]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	// fetchDatabaseIdfields
	var FETCH_IDFIELDS = exports.FETCH_IDFIELDS = "metabase/admin/datamodel/FETCH_IDFIELDS";
	var fetchDatabaseIdfields = exports.fetchDatabaseIdfields = (0, _redux.createThunkAction)(FETCH_IDFIELDS, function (databaseId) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var _idfields;
	
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _services.MetabaseApi.db_idfields({ 'dbId': databaseId });
	
	                        case 3:
	                            _idfields = _context2.sent;
	                            return _context2.abrupt("return", _idfields.map(function (field) {
	                                field.displayName = field.table.display_name + " → " + field.display_name;
	                                return field;
	                            }));
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2["catch"](0);
	
	                            console.warn("error getting idfields", databaseId, _context2.t0);
	
	                        case 10:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[0, 7]]);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	// selectDatabase
	var SELECT_DATABASE = exports.SELECT_DATABASE = "metabase/admin/datamodel/SELECT_DATABASE";
	var selectDatabase = exports.selectDatabase = (0, _redux.createThunkAction)(SELECT_DATABASE, function (db) {
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            var database;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            _context3.next = 3;
	                            return loadDatabaseMetadata(db.id);
	
	                        case 3:
	                            database = _context3.sent;
	
	
	                            dispatch(fetchDatabaseIdfields(db.id));
	
	                            // we also want to update our url to match our new state
	                            dispatch((0, _reactRouterRedux.push)('/admin/datamodel/database/' + db.id));
	
	                            return _context3.abrupt("return", database);
	
	                        case 9:
	                            _context3.prev = 9;
	                            _context3.t0 = _context3["catch"](0);
	
	                            console.log("error fetching tables", db.id, _context3.t0);
	
	                        case 12:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[0, 9]]);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	});
	
	// selectTable
	var SELECT_TABLE = exports.SELECT_TABLE = "metabase/admin/datamodel/SELECT_TABLE";
	var selectTable = exports.selectTable = (0, _redux.createThunkAction)(SELECT_TABLE, function (table) {
	    return function (dispatch, getState) {
	        // we also want to update our url to match our new state
	        dispatch((0, _reactRouterRedux.push)('/admin/datamodel/database/' + table.db_id + '/table/' + table.id));
	
	        return table.id;
	    };
	});
	
	// updateTable
	var UPDATE_TABLE = exports.UPDATE_TABLE = "metabase/admin/datamodel/UPDATE_TABLE";
	var updateTable = exports.updateTable = (0, _redux.createThunkAction)(UPDATE_TABLE, function (table) {
	    return function () {
	        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
	            var slimTable, updatedTable;
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            _context4.prev = 0;
	
	                            // make sure we don't send all the computed metadata
	                            slimTable = _extends({}, table);
	
	                            slimTable = _underscore2.default.omit(slimTable, "fields", "fields_lookup", "aggregation_options", "breakout_options", "metrics", "segments");
	
	                            _context4.next = 5;
	                            return _services.MetabaseApi.table_update(slimTable);
	
	                        case 5:
	                            updatedTable = _context4.sent;
	
	                            _underscore2.default.each(updatedTable, function (value, key) {
	                                if (key.charAt(0) !== "$") {
	                                    updatedTable[key] = value;
	                                }
	                            });
	
	                            _analytics2.default.trackEvent("Data Model", "Update Table");
	
	                            // TODO: we are not actually using this because the way the react components works actually mutates the original object :(
	                            return _context4.abrupt("return", updatedTable);
	
	                        case 11:
	                            _context4.prev = 11;
	                            _context4.t0 = _context4["catch"](0);
	
	                            console.log("error updating table", _context4.t0);
	                            //MetabaseAnalytics.trackEvent("Databases", database.id ? "Update Failed" : "Create Failed", database.engine);
	
	                        case 14:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, this, [[0, 11]]);
	        }));
	
	        return function (_x7, _x8) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	});
	
	// updateField
	var UPDATE_FIELD = exports.UPDATE_FIELD = "metabase/admin/datamodel/UPDATE_FIELD";
	var updateField = exports.updateField = (0, _redux.createThunkAction)(UPDATE_FIELD, function (field) {
	    return function () {
	        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
	            var editingDatabase, slimField, updatedField, table;
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            editingDatabase = (0, _selectors.getEditingDatabase)(getState());
	                            _context5.prev = 1;
	
	                            // make sure we don't send all the computed metadata
	                            slimField = _extends({}, field);
	
	                            slimField = _underscore2.default.omit(slimField, "operators_lookup", "operators", "values");
	
	                            // update the field
	                            _context5.next = 6;
	                            return _services.MetabaseApi.field_update(slimField);
	
	                        case 6:
	                            updatedField = _context5.sent;
	
	
	                            // refresh idfields
	                            table = _underscore2.default.findWhere(editingDatabase.tables, { id: updatedField.table_id });
	
	                            dispatch(fetchDatabaseIdfields(table.db_id));
	
	                            _analytics2.default.trackEvent("Data Model", "Update Field");
	
	                            // TODO: we are not actually using this because the way the react components works actually mutates the original object :(
	                            return _context5.abrupt("return", updatedField);
	
	                        case 13:
	                            _context5.prev = 13;
	                            _context5.t0 = _context5["catch"](1);
	
	                            console.log("error updating field", _context5.t0);
	                            //MetabaseAnalytics.trackEvent("Databases", database.id ? "Update Failed" : "Create Failed", database.engine);
	
	                        case 16:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, this, [[1, 13]]);
	        }));
	
	        return function (_x9, _x10) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	});
	
	// retireSegment
	var RETIRE_SEGMENT = exports.RETIRE_SEGMENT = "metabase/admin/datamodel/RETIRE_SEGMENT";
	var onRetireSegment = exports.onRetireSegment = (0, _redux.createThunkAction)(RETIRE_SEGMENT, function (segment) {
	    return function () {
	        var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
	            var editingDatabase;
	            return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            editingDatabase = (0, _selectors.getEditingDatabase)(getState());
	                            _context6.next = 3;
	                            return _services.SegmentApi.delete(segment);
	
	                        case 3:
	                            _analytics2.default.trackEvent("Data Model", "Retire Segment");
	
	                            _context6.next = 6;
	                            return loadDatabaseMetadata(editingDatabase.id);
	
	                        case 6:
	                            return _context6.abrupt("return", _context6.sent);
	
	                        case 7:
	                        case "end":
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, this);
	        }));
	
	        return function (_x11, _x12) {
	            return _ref6.apply(this, arguments);
	        };
	    }();
	});
	
	// retireMetric
	var RETIRE_METRIC = exports.RETIRE_METRIC = "metabase/admin/datamodel/RETIRE_METRIC";
	var onRetireMetric = exports.onRetireMetric = (0, _redux.createThunkAction)(RETIRE_METRIC, function (metric) {
	    return function () {
	        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
	            var editingDatabase;
	            return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            editingDatabase = (0, _selectors.getEditingDatabase)(getState());
	                            _context7.next = 3;
	                            return _services.MetricApi.delete(metric);
	
	                        case 3:
	                            _analytics2.default.trackEvent("Data Model", "Retire Metric");
	
	                            _context7.next = 6;
	                            return loadDatabaseMetadata(editingDatabase.id);
	
	                        case 6:
	                            return _context7.abrupt("return", _context7.sent);
	
	                        case 7:
	                        case "end":
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, this);
	        }));
	
	        return function (_x13, _x14) {
	            return _ref7.apply(this, arguments);
	        };
	    }();
	});
	
	// SEGMENTS
	
	var GET_SEGMENT = exports.GET_SEGMENT = "metabase/admin/datamodel/GET_SEGMENT";
	var CREATE_SEGMENT = exports.CREATE_SEGMENT = "metabase/admin/datamodel/CREATE_SEGMENT";
	var UPDATE_SEGMENT = exports.UPDATE_SEGMENT = "metabase/admin/datamodel/UPDATE_SEGMENT";
	var DELETE_SEGMENT = exports.DELETE_SEGMENT = "metabase/admin/datamodel/DELETE_SEGMENT";
	
	var getSegment = exports.getSegment = (0, _redux.createAction)(GET_SEGMENT, _services.SegmentApi.get);
	var createSegment = exports.createSegment = (0, _redux.createAction)(CREATE_SEGMENT, _services.SegmentApi.create);
	var updateSegment = exports.updateSegment = (0, _redux.createAction)(UPDATE_SEGMENT, _services.SegmentApi.update);
	var deleteSegment = exports.deleteSegment = (0, _redux.createAction)(DELETE_SEGMENT, _services.SegmentApi.delete);
	
	// METRICS
	
	var GET_METRIC = exports.GET_METRIC = "metabase/admin/datamodel/GET_METRIC";
	var CREATE_METRIC = exports.CREATE_METRIC = "metabase/admin/datamodel/CREATE_METRIC";
	var UPDATE_METRIC = exports.UPDATE_METRIC = "metabase/admin/datamodel/UPDATE_METRIC";
	var DELETE_METRIC = exports.DELETE_METRIC = "metabase/admin/datamodel/DELETE_METRIC";
	
	var getMetric = exports.getMetric = (0, _redux.createAction)(GET_METRIC, _services.MetricApi.get);
	var createMetric = exports.createMetric = (0, _redux.createAction)(CREATE_METRIC, _services.MetricApi.create);
	var updateMetric = exports.updateMetric = (0, _redux.createAction)(UPDATE_METRIC, _services.MetricApi.update);
	var deleteMetric = exports.deleteMetric = (0, _redux.createAction)(DELETE_METRIC, _services.MetricApi.delete);
	
	// SEGMENT DETAIL
	
	var LOAD_TABLE_METADATA = exports.LOAD_TABLE_METADATA = "metabase/admin/datamodel/LOAD_TABLE_METADATA";
	var UPDATE_PREVIEW_SUMMARY = exports.UPDATE_PREVIEW_SUMMARY = "metabase/admin/datamodel/UPDATE_PREVIEW_SUMMARY";
	
	var loadTableMetadata = exports.loadTableMetadata = (0, _redux.createAction)(LOAD_TABLE_METADATA, _table.loadTableAndForeignKeys);
	var updatePreviewSummary = exports.updatePreviewSummary = (0, _redux.createAction)(UPDATE_PREVIEW_SUMMARY, function () {
	    var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(query) {
	        var result;
	        return regeneratorRuntime.wrap(function _callee8$(_context8) {
	            while (1) {
	                switch (_context8.prev = _context8.next) {
	                    case 0:
	                        _context8.next = 2;
	                        return _services.MetabaseApi.dataset(query);
	
	                    case 2:
	                        result = _context8.sent;
	                        return _context8.abrupt("return", result.data.rows[0][0]);
	
	                    case 4:
	                    case "end":
	                        return _context8.stop();
	                }
	            }
	        }, _callee8, undefined);
	    }));
	
	    return function (_x15) {
	        return _ref8.apply(this, arguments);
	    };
	}());
	
	// REVISION HISTORY
	
	var FETCH_REVISIONS = exports.FETCH_REVISIONS = "metabase/admin/datamodel/FETCH_REVISIONS";
	
	var fetchRevisions = exports.fetchRevisions = (0, _redux.createThunkAction)(FETCH_REVISIONS, function (_ref9) {
	    var entity = _ref9.entity,
	        id = _ref9.id;
	    return function () {
	        var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState) {
	            var action, _ref11, _ref12, object, revisions;
	
	            return regeneratorRuntime.wrap(function _callee9$(_context9) {
	                while (1) {
	                    switch (_context9.prev = _context9.next) {
	                        case 0:
	                            action = void 0;
	                            _context9.t0 = entity;
	                            _context9.next = _context9.t0 === "segment" ? 4 : _context9.t0 === "metric" ? 6 : 8;
	                            break;
	
	                        case 4:
	                            action = getSegment({ segmentId: id });return _context9.abrupt("break", 8);
	
	                        case 6:
	                            action = getMetric({ metricId: id });return _context9.abrupt("break", 8);
	
	                        case 8:
	                            _context9.next = 10;
	                            return Promise.all([dispatch(action), _services.RevisionsApi.get({ entity: entity, id: id })]);
	
	                        case 10:
	                            _ref11 = _context9.sent;
	                            _ref12 = _slicedToArray(_ref11, 2);
	                            object = _ref12[0];
	                            revisions = _ref12[1];
	                            _context9.next = 16;
	                            return dispatch(loadTableMetadata(object.payload.definition.source_table));
	
	                        case 16:
	                            return _context9.abrupt("return", { object: object.payload, revisions: revisions });
	
	                        case 17:
	                        case "end":
	                            return _context9.stop();
	                    }
	                }
	            }, _callee9, undefined);
	        }));
	
	        return function (_x16, _x17) {
	            return _ref10.apply(this, arguments);
	        };
	    }();
	});
	
	// reducers
	
	var databases = (0, _redux.handleActions)(_defineProperty({}, INITIALIZE_METADATA, { next: function next(state, _ref13) {
	        var payload = _ref13.payload;
	        return payload.databases;
	    } }), []);
	
	var idfields = (0, _redux.handleActions)(_defineProperty({}, FETCH_IDFIELDS, { next: function next(state, _ref14) {
	        var payload = _ref14.payload;
	        return payload ? payload : state;
	    } }), []);
	
	var editingDatabase = (0, _redux.handleActions)((_handleActions3 = {}, _defineProperty(_handleActions3, INITIALIZE_METADATA, { next: function next(state, _ref15) {
	        var payload = _ref15.payload;
	        return payload.database;
	    } }), _defineProperty(_handleActions3, SELECT_DATABASE, { next: function next(state, _ref16) {
	        var payload = _ref16.payload;
	        return payload ? payload : state;
	    } }), _defineProperty(_handleActions3, RETIRE_SEGMENT, { next: function next(state, _ref17) {
	        var payload = _ref17.payload;
	        return payload;
	    } }), _defineProperty(_handleActions3, RETIRE_METRIC, { next: function next(state, _ref18) {
	        var payload = _ref18.payload;
	        return payload;
	    } }), _handleActions3), null);
	
	var editingTable = (0, _redux.handleActions)((_handleActions4 = {}, _defineProperty(_handleActions4, INITIALIZE_METADATA, { next: function next(state, _ref19) {
	        var payload = _ref19.payload;
	        return payload.tableId || null;
	    } }), _defineProperty(_handleActions4, SELECT_TABLE, { next: function next(state, _ref20) {
	        var payload = _ref20.payload;
	        return payload;
	    } }), _handleActions4), null);
	
	var segments = (0, _redux.handleActions)((_handleActions5 = {}, _defineProperty(_handleActions5, GET_SEGMENT, { next: function next(state, _ref21) {
	        var payload = _ref21.payload;
	        return _extends({}, state, _defineProperty({}, payload.id, (0, _redux.momentifyTimestamps)(payload)));
	    } }), _defineProperty(_handleActions5, CREATE_SEGMENT, { next: function next(state, _ref22) {
	        var payload = _ref22.payload;
	        return _extends({}, state, _defineProperty({}, payload.id, (0, _redux.momentifyTimestamps)(payload)));
	    } }), _defineProperty(_handleActions5, UPDATE_SEGMENT, { next: function next(state, _ref23) {
	        var payload = _ref23.payload;
	        return _extends({}, state, _defineProperty({}, payload.id, (0, _redux.momentifyTimestamps)(payload)));
	    } }), _defineProperty(_handleActions5, DELETE_SEGMENT, { next: function next(state, _ref24) {
	        var payload = _ref24.payload;
	        state = _extends({}, state);delete state[payload.id];return state;
	    } }), _handleActions5), {});
	
	var metrics = (0, _redux.handleActions)((_handleActions6 = {}, _defineProperty(_handleActions6, GET_METRIC, { next: function next(state, _ref25) {
	        var payload = _ref25.payload;
	        return _extends({}, state, _defineProperty({}, payload.id, (0, _redux.momentifyTimestamps)(payload)));
	    } }), _defineProperty(_handleActions6, CREATE_METRIC, { next: function next(state, _ref26) {
	        var payload = _ref26.payload;
	        return _extends({}, state, _defineProperty({}, payload.id, (0, _redux.momentifyTimestamps)(payload)));
	    } }), _defineProperty(_handleActions6, UPDATE_METRIC, { next: function next(state, _ref27) {
	        var payload = _ref27.payload;
	        return _extends({}, state, _defineProperty({}, payload.id, (0, _redux.momentifyTimestamps)(payload)));
	    } }), _defineProperty(_handleActions6, DELETE_METRIC, { next: function next(state, _ref28) {
	        var payload = _ref28.payload;
	        state = _extends({}, state);delete state[payload.id];return state;
	    } }), _handleActions6), {});
	
	var tableMetadata = (0, _redux.handleActions)(_defineProperty({}, LOAD_TABLE_METADATA, {
	    next: function next(state, _ref29) {
	        var payload = _ref29.payload;
	        return payload && payload.table ? payload.table : null;
	    },
	    throw: function _throw(state, action) {
	        return null;
	    }
	}), null);
	
	var previewSummary = (0, _redux.handleActions)(_defineProperty({}, UPDATE_PREVIEW_SUMMARY, { next: function next(state, _ref30) {
	        var payload = _ref30.payload;
	        return payload;
	    } }), null);
	
	var revisionObject = (0, _redux.handleActions)(_defineProperty({}, FETCH_REVISIONS, { next: function next(state, _ref31) {
	        var revisionObject = _ref31.payload;
	        return revisionObject;
	    } }), null);
	
	exports.default = (0, _redux.combineReducers)({
	    databases: databases,
	    idfields: idfields,
	    editingDatabase: editingDatabase,
	    editingTable: editingTable,
	    segments: segments,
	    metrics: metrics,
	    tableMetadata: tableMetadata,
	    previewSummary: previewSummary,
	    revisionObject: revisionObject
	});

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _MetricForm = __webpack_require__(1838);
	
	var _MetricForm2 = _interopRequireDefault(_MetricForm);
	
	var _selectors = __webpack_require__(1835);
	
	var _datamodel = __webpack_require__(1836);
	
	var actions = _interopRequireWildcard(_datamodel);
	
	var _requests = __webpack_require__(856);
	
	var _metadata = __webpack_require__(1110);
	
	var _metadata2 = __webpack_require__(1073);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = _extends({}, actions, {
	    fetchTableMetadata: _metadata.fetchTableMetadata,
	    clearRequestState: _requests.clearRequestState,
	    onChangeLocation: _reactRouterRedux.push
	});
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return _extends({}, (0, _selectors.metricEditSelectors)(state, props), {
	        metadata: (0, _metadata2.getMetadata)(state, props)
	    });
	};
	
	var MetricApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(MetricApp, _Component);
	
	    function MetricApp() {
	        _classCallCheck(this, MetricApp);
	
	        return _possibleConstructorReturn(this, (MetricApp.__proto__ || Object.getPrototypeOf(MetricApp)).apply(this, arguments));
	    }
	
	    _createClass(MetricApp, [{
	        key: "componentWillMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var _props, params, location, tableId, metricId, _ref2, metric;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _props = this.props, params = _props.params, location = _props.location;
	                                tableId = void 0;
	
	                                if (!params.id) {
	                                    _context.next = 11;
	                                    break;
	                                }
	
	                                metricId = parseInt(params.id);
	                                _context.next = 6;
	                                return this.props.getMetric({ metricId: metricId });
	
	                            case 6:
	                                _ref2 = _context.sent;
	                                metric = _ref2.payload;
	
	                                tableId = metric.table_id;
	                                _context.next = 12;
	                                break;
	
	                            case 11:
	                                if (location.query.table) {
	                                    tableId = parseInt(location.query.table);
	                                }
	
	                            case 12:
	                                if (tableId != null) {
	                                    // TODO Atte Keinänen 6/8/17: Use only global metadata (`fetchTableMetadata`)
	                                    this.props.loadTableMetadata(tableId);
	                                    this.props.fetchTableMetadata(tableId);
	                                }
	
	                            case 13:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: "onSubmit",
	        value: function () {
	            var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(metric, f) {
	                var tableMetadata;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                tableMetadata = this.props.tableMetadata;
	
	                                if (!(metric.id != null)) {
	                                    _context2.next = 8;
	                                    break;
	                                }
	
	                                _context2.next = 4;
	                                return this.props.updateMetric(metric);
	
	                            case 4:
	                                this.props.clearRequestState({ statePath: ['metadata', 'metrics'] });
	                                _analytics2.default.trackEvent("Data Model", "Metric Updated");
	                                _context2.next = 12;
	                                break;
	
	                            case 8:
	                                _context2.next = 10;
	                                return this.props.createMetric(metric);
	
	                            case 10:
	                                this.props.clearRequestState({ statePath: ['metadata', 'metrics'] });
	                                _analytics2.default.trackEvent("Data Model", "Metric Created");
	
	                            case 12:
	
	                                this.props.onChangeLocation("/admin/datamodel/database/" + tableMetadata.db_id + "/table/" + tableMetadata.id);
	
	                            case 13:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function onSubmit(_x, _x2) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return onSubmit;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_MetricForm2.default, _extends({}, this.props, {
	                    onSubmit: this.onSubmit.bind(this)
	                }))
	            );
	        }
	    }]);
	
	    return MetricApp;
	}(_react.Component)) || _class);
	MetricApp.displayName = "MetricApp";
	exports.default = MetricApp;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _FormLabel = __webpack_require__(1839);
	
	var _FormLabel2 = _interopRequireDefault(_FormLabel);
	
	var _FormInput = __webpack_require__(1840);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormTextArea = __webpack_require__(1841);
	
	var _FormTextArea2 = _interopRequireDefault(_FormTextArea);
	
	var _FieldSet = __webpack_require__(1006);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _PartialQueryBuilder = __webpack_require__(1842);
	
	var _PartialQueryBuilder2 = _interopRequireDefault(_PartialQueryBuilder);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _formatting = __webpack_require__(872);
	
	var _selectors = __webpack_require__(1835);
	
	var _reduxForm = __webpack_require__(589);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MetricForm = (_dec = (0, _reduxForm.reduxForm)({
	    form: "metric",
	    fields: ["id", "name", "description", "table_id", "definition", "revision_message", "show_in_getting_started"],
	    validate: function validate(values) {
	        var errors = {};
	        if (!values.name) {
	            errors.name = "Name is required";
	        }
	        if (!values.description) {
	            errors.description = "Description is required";
	        }
	        if (values.id != null) {
	            if (!values.revision_message) {
	                errors.revision_message = "Revision message is required";
	            }
	        }
	        var aggregations = values.definition && _query2.default.getAggregations(values.definition);
	        if (!aggregations || aggregations.length === 0) {
	            errors.definition = "Aggregation is required";
	        }
	        return errors;
	    }
	}, function (state, props) {
	    return (0, _selectors.metricFormSelectors)(state, props);
	}), _dec(_class = function (_Component) {
	    _inherits(MetricForm, _Component);
	
	    function MetricForm() {
	        _classCallCheck(this, MetricForm);
	
	        return _possibleConstructorReturn(this, (MetricForm.__proto__ || Object.getPrototypeOf(MetricForm)).apply(this, arguments));
	    }
	
	    _createClass(MetricForm, [{
	        key: "updatePreviewSummary",
	        value: function updatePreviewSummary(datasetQuery) {
	            this.props.updatePreviewSummary(_extends({}, datasetQuery, {
	                query: _extends({
	                    aggregation: ["count"]
	                }, datasetQuery.query)
	            }));
	        }
	    }, {
	        key: "renderActionButtons",
	        value: function renderActionButtons() {
	            var _props = this.props,
	                invalid = _props.invalid,
	                handleSubmit = _props.handleSubmit,
	                tableMetadata = _props.tableMetadata;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "button",
	                    { className: (0, _classnames2.default)("Button", { "Button--primary": !invalid, "disabled": invalid }), onClick: handleSubmit },
	                    "Save changes"
	                ),
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: "/admin/datamodel/database/" + tableMetadata.db_id + "/table/" + tableMetadata.id, className: "Button ml2" },
	                    "Cancel"
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                _props2$fields = _props2.fields,
	                id = _props2$fields.id,
	                name = _props2$fields.name,
	                description = _props2$fields.description,
	                definition = _props2$fields.definition,
	                revision_message = _props2$fields.revision_message,
	                metric = _props2.metric,
	                metadata = _props2.metadata,
	                tableMetadata = _props2.tableMetadata,
	                handleSubmit = _props2.handleSubmit,
	                previewSummary = _props2.previewSummary;
	
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: !tableMetadata },
	                function () {
	                    return _react2.default.createElement(
	                        "form",
	                        { className: "full", onSubmit: handleSubmit },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "wrapper py4" },
	                            _react2.default.createElement(
	                                _FormLabel2.default,
	                                {
	                                    title: (metric && metric.id != null ? "Edit" : "Create") + " Your Metric",
	                                    description: metric && metric.id != null ? "Make changes to your metric and leave an explanatory note." : "You can create saved metrics to add a named metric option to this table. Saved metrics include the aggregation type, the aggregated field, and optionally any filter you add. As an example, you might use this to create something like the official way of calculating \"Average Price\" for an Orders table."
	                                },
	                                _react2.default.createElement(_PartialQueryBuilder2.default, _extends({
	                                    features: {
	                                        filter: true,
	                                        aggregation: true
	                                    },
	                                    metadata: metadata && tableMetadata && metadata.tables && metadata.tables[tableMetadata.id].fields && Object.assign(new _Metadata2.default(), metadata, {
	                                        tables: _extends({}, metadata.tables, _defineProperty({}, tableMetadata.id, Object.assign(new _Table2.default(), metadata.tables[tableMetadata.id], {
	                                            aggregation_options: tableMetadata.aggregation_options.filter(function (a) {
	                                                return a.short !== "rows";
	                                            }),
	                                            metrics: []
	                                        })))
	                                    }),
	                                    tableMetadata: tableMetadata,
	                                    previewSummary: previewSummary == null ? "" : "Result: " + (0, _formatting.formatValue)(previewSummary),
	                                    updatePreviewSummary: _this2.updatePreviewSummary.bind(_this2)
	                                }, definition))
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { style: { maxWidth: "575px" } },
	                                _react2.default.createElement(
	                                    _FormLabel2.default,
	                                    {
	                                        title: "Name Your Metric",
	                                        description: "Give your metric a name to help others find it."
	                                    },
	                                    _react2.default.createElement(_FormInput2.default, {
	                                        field: name,
	                                        placeholder: "Something descriptive but not too long"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    _FormLabel2.default,
	                                    {
	                                        title: "Describe Your Metric",
	                                        description: "Give your metric a description to help others understand what it's about."
	                                    },
	                                    _react2.default.createElement(_FormTextArea2.default, {
	                                        field: description,
	                                        placeholder: "This is a good place to be more specific about less obvious metric rules"
	                                    })
	                                ),
	                                id.value != null && _react2.default.createElement(
	                                    _FieldSet2.default,
	                                    { legend: "Reason For Changes" },
	                                    _react2.default.createElement(
	                                        _FormLabel2.default,
	                                        { description: "Leave a note to explain what changes you made and why they were required." },
	                                        _react2.default.createElement(_FormTextArea2.default, {
	                                            field: revision_message,
	                                            placeholder: "This will show up in the revision history for this metric to help everyone remember why things changed"
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "flex align-center" },
	                                        _this2.renderActionButtons()
	                                    )
	                                )
	                            )
	                        ),
	                        id.value == null && _react2.default.createElement(
	                            "div",
	                            { className: "border-top py4" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "wrapper" },
	                                _this2.renderActionButtons()
	                            )
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return MetricForm;
	}(_react.Component)) || _class);
	MetricForm.displayName = "MetricForm";
	exports.default = MetricForm;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormLabel = (_temp = _class = function (_Component) {
	    _inherits(FormLabel, _Component);
	
	    function FormLabel() {
	        _classCallCheck(this, FormLabel);
	
	        return _possibleConstructorReturn(this, (FormLabel.__proto__ || Object.getPrototypeOf(FormLabel)).apply(this, arguments));
	    }
	
	    _createClass(FormLabel, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                description = _props.description,
	                children = _props.children;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "mb3" },
	                _react2.default.createElement(
	                    "div",
	                    { style: { maxWidth: "575px" } },
	                    title && _react2.default.createElement(
	                        "label",
	                        { className: "h5 text-bold text-uppercase" },
	                        title
	                    ),
	                    description && _react2.default.createElement(
	                        "p",
	                        { className: "mt1 mb2" },
	                        description
	                    )
	                ),
	                children
	            );
	        }
	    }]);
	
	    return FormLabel;
	}(_react.Component), _class.propTypes = {
	    title: _propTypes2.default.string,
	    description: _propTypes2.default.string
	}, _class.defaultProps = {
	    title: "",
	    description: ""
	}, _temp);
	FormLabel.displayName = "FormLabel";
	exports.default = FormLabel;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _redux = __webpack_require__(657);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormInput = (_temp = _class = function (_Component) {
	    _inherits(FormInput, _Component);
	
	    function FormInput() {
	        _classCallCheck(this, FormInput);
	
	        return _possibleConstructorReturn(this, (FormInput.__proto__ || Object.getPrototypeOf(FormInput)).apply(this, arguments));
	    }
	
	    _createClass(FormInput, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                field = _props.field,
	                className = _props.className,
	                placeholder = _props.placeholder;
	
	            return _react2.default.createElement("input", _extends({
	                type: "text",
	                placeholder: placeholder,
	                className: (0, _classnames2.default)("input full", { "border-error": !field.active && field.visited && field.invalid }, className)
	            }, (0, _redux.formDomOnlyProps)(field)));
	        }
	    }]);
	
	    return FormInput;
	}(_react.Component), _class.propTypes = {}, _temp);
	FormInput.displayName = "FormInput";
	exports.default = FormInput;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _redux = __webpack_require__(657);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormTextArea = (_temp = _class = function (_Component) {
	    _inherits(FormTextArea, _Component);
	
	    function FormTextArea() {
	        _classCallCheck(this, FormTextArea);
	
	        return _possibleConstructorReturn(this, (FormTextArea.__proto__ || Object.getPrototypeOf(FormTextArea)).apply(this, arguments));
	    }
	
	    _createClass(FormTextArea, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                field = _props.field,
	                className = _props.className,
	                placeholder = _props.placeholder;
	
	            return _react2.default.createElement("textarea", _extends({
	                placeholder: placeholder,
	                className: (0, _classnames2.default)("input full", { "border-error": !field.active && field.visited && field.invalid }, className)
	            }, (0, _redux.formDomOnlyProps)(field)));
	        }
	    }]);
	
	    return FormTextArea;
	}(_react.Component), _class.propTypes = {}, _temp);
	FormTextArea.displayName = "FormTextArea";
	exports.default = FormTextArea;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GuiQueryEditor = __webpack_require__(1728);
	
	var _GuiQueryEditor2 = _interopRequireDefault(_GuiQueryEditor);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _query = __webpack_require__(887);
	
	var Query = _interopRequireWildcard(_query);
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartialQueryBuilder = (_temp2 = _class = function (_Component) {
	    _inherits(PartialQueryBuilder, _Component);
	
	    function PartialQueryBuilder() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PartialQueryBuilder);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PartialQueryBuilder.__proto__ || Object.getPrototypeOf(PartialQueryBuilder)).call.apply(_ref, [this].concat(args))), _this), _this.setDatasetQuery = function (datasetQuery) {
	            _this.props.onChange(datasetQuery.query);
	            _this.props.updatePreviewSummary(datasetQuery);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PartialQueryBuilder, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _props = this.props,
	                value = _props.value,
	                tableMetadata = _props.tableMetadata;
	
	            this.props.updatePreviewSummary({
	                type: "query",
	                database: tableMetadata.db_id,
	                query: _extends({}, value, {
	                    source_table: tableMetadata.id
	                })
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                features = _props2.features,
	                value = _props2.value,
	                metadata = _props2.metadata,
	                tableMetadata = _props2.tableMetadata,
	                previewSummary = _props2.previewSummary;
	
	
	            var datasetQuery = {
	                type: "query",
	                database: tableMetadata.db_id,
	                query: _extends({}, value, {
	                    source_table: tableMetadata.id
	                })
	            };
	
	            var query = new _Question2.default(metadata, { dataset_query: datasetQuery }).query();
	
	            var previewCard = {
	                dataset_query: _extends({}, datasetQuery, {
	                    query: _extends({
	                        aggregation: ["rows"],
	                        breakout: [],
	                        filter: []
	                    }, datasetQuery.query)
	                })
	            };
	            var previewUrl = Urls.question(null, previewCard);
	
	            var onChange = function onChange(query) {
	                _this2.props.onChange(query);
	                _this2.props.updatePreviewSummary(_extends({}, datasetQuery, { query: query }));
	            };
	
	            return _react2.default.createElement(
	                "div",
	                { className: "py1" },
	                _react2.default.createElement(
	                    _GuiQueryEditor2.default,
	                    {
	                        features: features,
	                        query: query,
	                        datasetQuery: datasetQuery,
	                        databases: tableMetadata && [tableMetadata.db],
	                        setDatasetQuery: this.setDatasetQuery,
	                        isShowingDataReference: false,
	                        supportMultipleAggregations: false,
	                        setDatabaseFn: null,
	                        setSourceTableFn: null,
	                        addQueryFilter: function addQueryFilter(filter) {
	                            return onChange(Query.addFilter(datasetQuery.query, filter));
	                        },
	                        updateQueryFilter: function updateQueryFilter(index, filter) {
	                            return onChange(Query.updateFilter(datasetQuery.query, index, filter));
	                        },
	                        removeQueryFilter: function removeQueryFilter(index) {
	                            return onChange(Query.removeFilter(datasetQuery.query, index));
	                        },
	                        addQueryAggregation: function addQueryAggregation(aggregation) {
	                            return onChange(Query.addAggregation(datasetQuery.query, aggregation));
	                        },
	                        updateQueryAggregation: function updateQueryAggregation(index, aggregation) {
	                            return onChange(Query.updateAggregation(datasetQuery.query, index, aggregation));
	                        },
	                        removeQueryAggregation: function removeQueryAggregation(index) {
	                            return onChange(Query.removeAggregation(datasetQuery.query, index));
	                        }
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center mx2 my2" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "text-bold px3" },
	                            previewSummary
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { "data-metabase-event": "Data Model;Preview Click", target: window.OSX ? null : "_blank", className: (0, _classnames2.default)("Button Button--primary"), href: previewUrl },
	                            "Preview"
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PartialQueryBuilder;
	}(_react.Component), _class.propTypes = {
	    onChange: _propTypes2.default.func.isRequired,
	    tableMetadata: _propTypes2.default.object.isRequired,
	    updatePreviewSummary: _propTypes2.default.func.isRequired,
	    previewSummary: _propTypes2.default.string
	}, _temp2);
	PartialQueryBuilder.displayName = "PartialQueryBuilder";
	exports.default = PartialQueryBuilder;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _SegmentForm = __webpack_require__(1844);
	
	var _SegmentForm2 = _interopRequireDefault(_SegmentForm);
	
	var _selectors = __webpack_require__(1835);
	
	var _datamodel = __webpack_require__(1836);
	
	var actions = _interopRequireWildcard(_datamodel);
	
	var _requests = __webpack_require__(856);
	
	var _metadata = __webpack_require__(1073);
	
	var _metadata2 = __webpack_require__(1110);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = _extends({}, actions, {
	    fetchTableMetadata: _metadata2.fetchTableMetadata,
	    clearRequestState: _requests.clearRequestState,
	    onChangeLocation: _reactRouterRedux.push
	});
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return _extends({}, (0, _selectors.segmentEditSelectors)(state, props), {
	        metadata: (0, _metadata.getMetadata)(state, props)
	    });
	};
	
	var SegmentApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(SegmentApp, _Component);
	
	    function SegmentApp() {
	        _classCallCheck(this, SegmentApp);
	
	        return _possibleConstructorReturn(this, (SegmentApp.__proto__ || Object.getPrototypeOf(SegmentApp)).apply(this, arguments));
	    }
	
	    _createClass(SegmentApp, [{
	        key: "componentWillMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var _props, params, location, tableId, segmentId, _ref2, segment;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _props = this.props, params = _props.params, location = _props.location;
	                                tableId = void 0;
	
	                                if (!params.id) {
	                                    _context.next = 11;
	                                    break;
	                                }
	
	                                segmentId = parseInt(params.id);
	                                _context.next = 6;
	                                return this.props.getSegment({ segmentId: segmentId });
	
	                            case 6:
	                                _ref2 = _context.sent;
	                                segment = _ref2.payload;
	
	                                tableId = segment.table_id;
	                                _context.next = 12;
	                                break;
	
	                            case 11:
	                                if (location.query.table) {
	                                    tableId = parseInt(location.query.table);
	                                }
	
	                            case 12:
	                                if (tableId != null) {
	                                    // TODO Atte Keinänen 6/8/17: Use only global metadata (`fetchTableMetadata`)
	                                    this.props.loadTableMetadata(tableId);
	                                    this.props.fetchTableMetadata(tableId);
	                                }
	
	                            case 13:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: "onSubmit",
	        value: function () {
	            var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(segment, f) {
	                var tableMetadata;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                tableMetadata = this.props.tableMetadata;
	
	                                if (!(segment.id != null)) {
	                                    _context2.next = 8;
	                                    break;
	                                }
	
	                                _context2.next = 4;
	                                return this.props.updateSegment(segment);
	
	                            case 4:
	                                this.props.clearRequestState({ statePath: ['metadata', 'segments'] });
	                                _analytics2.default.trackEvent("Data Model", "Segment Updated");
	                                _context2.next = 12;
	                                break;
	
	                            case 8:
	                                _context2.next = 10;
	                                return this.props.createSegment(segment);
	
	                            case 10:
	                                this.props.clearRequestState({ statePath: ['metadata', 'segments'] });
	                                _analytics2.default.trackEvent("Data Model", "Segment Created");
	
	                            case 12:
	
	                                this.props.onChangeLocation("/admin/datamodel/database/" + tableMetadata.db_id + "/table/" + tableMetadata.id);
	
	                            case 13:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function onSubmit(_x, _x2) {
	                return _ref3.apply(this, arguments);
	            }
	
	            return onSubmit;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_SegmentForm2.default, _extends({}, this.props, {
	                    onSubmit: this.onSubmit.bind(this)
	                }))
	            );
	        }
	    }]);
	
	    return SegmentApp;
	}(_react.Component)) || _class);
	SegmentApp.displayName = "SegmentApp";
	exports.default = SegmentApp;

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _FormLabel = __webpack_require__(1839);
	
	var _FormLabel2 = _interopRequireDefault(_FormLabel);
	
	var _FormInput = __webpack_require__(1840);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormTextArea = __webpack_require__(1841);
	
	var _FormTextArea2 = _interopRequireDefault(_FormTextArea);
	
	var _FieldSet = __webpack_require__(1006);
	
	var _FieldSet2 = _interopRequireDefault(_FieldSet);
	
	var _PartialQueryBuilder = __webpack_require__(1842);
	
	var _PartialQueryBuilder2 = _interopRequireDefault(_PartialQueryBuilder);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _formatting = __webpack_require__(872);
	
	var _selectors = __webpack_require__(1835);
	
	var _reduxForm = __webpack_require__(589);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _Table = __webpack_require__(899);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SegmentForm = (_dec = (0, _reduxForm.reduxForm)({
	    form: "segment",
	    fields: ["id", "name", "description", "table_id", "definition", "revision_message"],
	    validate: function validate(values) {
	        var errors = {};
	        if (!values.name) {
	            errors.name = "Name is required";
	        }
	        if (!values.description) {
	            errors.description = "Description is required";
	        }
	        if (values.id != null) {
	            if (!values.revision_message) {
	                errors.revision_message = "Revision message is required";
	            }
	        }
	        if (!values.definition || !values.definition.filter || values.definition.filter.length < 1) {
	            errors.definition = "At least one filter is required";
	        }
	        return errors;
	    },
	    initialValues: { name: "", description: "", table_id: null, definition: { filter: [] }, revision_message: null }
	}, function (state, props) {
	    return (0, _selectors.segmentFormSelectors)(state, props);
	}), _dec(_class = function (_Component) {
	    _inherits(SegmentForm, _Component);
	
	    function SegmentForm() {
	        _classCallCheck(this, SegmentForm);
	
	        return _possibleConstructorReturn(this, (SegmentForm.__proto__ || Object.getPrototypeOf(SegmentForm)).apply(this, arguments));
	    }
	
	    _createClass(SegmentForm, [{
	        key: "updatePreviewSummary",
	        value: function updatePreviewSummary(datasetQuery) {
	            this.props.updatePreviewSummary(_extends({}, datasetQuery, {
	                query: _extends({}, datasetQuery.query, {
	                    aggregation: ["count"]
	                })
	            }));
	        }
	    }, {
	        key: "renderActionButtons",
	        value: function renderActionButtons() {
	            var _props = this.props,
	                invalid = _props.invalid,
	                handleSubmit = _props.handleSubmit,
	                tableMetadata = _props.tableMetadata;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "button",
	                    { className: (0, _classnames2.default)("Button", { "Button--primary": !invalid, "disabled": invalid }), onClick: handleSubmit },
	                    "Save changes"
	                ),
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: "/admin/datamodel/database/" + tableMetadata.db_id + "/table/" + tableMetadata.id, className: "Button ml2" },
	                    "Cancel"
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                _props2$fields = _props2.fields,
	                id = _props2$fields.id,
	                name = _props2$fields.name,
	                description = _props2$fields.description,
	                definition = _props2$fields.definition,
	                revision_message = _props2$fields.revision_message,
	                segment = _props2.segment,
	                metadata = _props2.metadata,
	                tableMetadata = _props2.tableMetadata,
	                handleSubmit = _props2.handleSubmit,
	                previewSummary = _props2.previewSummary;
	
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: !tableMetadata },
	                function () {
	                    return _react2.default.createElement(
	                        "form",
	                        { className: "full", onSubmit: handleSubmit },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "wrapper py4" },
	                            _react2.default.createElement(
	                                _FormLabel2.default,
	                                {
	                                    title: (segment && segment.id != null ? "Edit" : "Create") + " Your Segment",
	                                    description: segment && segment.id != null ? "Make changes to your segment and leave an explanatory note." : "Select and add filters to create your new segment for the " + tableMetadata.display_name + " table"
	                                },
	                                _react2.default.createElement(_PartialQueryBuilder2.default, _extends({
	                                    features: {
	                                        filter: true
	                                    },
	                                    metadata: metadata && tableMetadata && metadata.tables && metadata.tables[tableMetadata.id].fields && Object.assign(new _Metadata2.default(), metadata, {
	                                        tables: _extends({}, metadata.tables, _defineProperty({}, tableMetadata.id, Object.assign(new _Table2.default(), metadata.tables[tableMetadata.id], {
	                                            segments: []
	                                        })))
	                                    }),
	                                    tableMetadata: tableMetadata,
	                                    previewSummary: previewSummary == null ? "" : (0, _formatting.formatValue)(previewSummary) + " rows",
	                                    updatePreviewSummary: _this2.updatePreviewSummary.bind(_this2)
	                                }, definition))
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { style: { maxWidth: "575px" } },
	                                _react2.default.createElement(
	                                    _FormLabel2.default,
	                                    {
	                                        title: "Name Your Segment",
	                                        description: "Give your segment a name to help others find it."
	                                    },
	                                    _react2.default.createElement(_FormInput2.default, {
	                                        field: name,
	                                        placeholder: "Something descriptive but not too long"
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    _FormLabel2.default,
	                                    {
	                                        title: "Describe Your Segment",
	                                        description: "Give your segment a description to help others understand what it's about."
	                                    },
	                                    _react2.default.createElement(_FormTextArea2.default, {
	                                        field: description,
	                                        placeholder: "This is a good place to be more specific about less obvious segment rules"
	                                    })
	                                ),
	                                id.value != null && _react2.default.createElement(
	                                    _FieldSet2.default,
	                                    { legend: "Reason For Changes" },
	                                    _react2.default.createElement(
	                                        _FormLabel2.default,
	                                        { description: "Leave a note to explain what changes you made and why they were required." },
	                                        _react2.default.createElement(_FormTextArea2.default, {
	                                            field: revision_message,
	                                            placeholder: "This will show up in the revision history for this segment to help everyone remember why things changed"
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "flex align-center" },
	                                        _this2.renderActionButtons()
	                                    )
	                                )
	                            )
	                        ),
	                        id.value == null && _react2.default.createElement(
	                            "div",
	                            { className: "border-top py4" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "wrapper" },
	                                _this2.renderActionButtons()
	                            )
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return SegmentForm;
	}(_react.Component)) || _class);
	SegmentForm.displayName = "SegmentForm";
	exports.default = SegmentForm;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _RevisionHistory = __webpack_require__(1846);
	
	var _RevisionHistory2 = _interopRequireDefault(_RevisionHistory);
	
	var _selectors = __webpack_require__(1835);
	
	var _datamodel = __webpack_require__(1836);
	
	var actions = _interopRequireWildcard(_datamodel);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return _extends({}, (0, _selectors.revisionHistorySelectors)(state, props), {
	        entity: props.params.entity,
	        id: props.params.id
	    });
	};
	
	var mapDispatchToProps = _extends({}, actions);
	
	var RevisionHistoryApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(RevisionHistoryApp, _Component);
	
	    function RevisionHistoryApp() {
	        _classCallCheck(this, RevisionHistoryApp);
	
	        return _possibleConstructorReturn(this, (RevisionHistoryApp.__proto__ || Object.getPrototypeOf(RevisionHistoryApp)).apply(this, arguments));
	    }
	
	    _createClass(RevisionHistoryApp, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            var _props = this.props,
	                entity = _props.entity,
	                id = _props.id;
	
	
	            this.props.fetchRevisions({ entity: entity, id: id });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_RevisionHistory2.default, _extends({}, this.props, { objectType: this.props.entity }));
	        }
	    }]);
	
	    return RevisionHistoryApp;
	}(_react.Component)) || _class);
	RevisionHistoryApp.displayName = "RevisionHistoryApp";
	exports.default = RevisionHistoryApp;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Revision = __webpack_require__(1847);
	
	var _Revision2 = _interopRequireDefault(_Revision);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _formatting = __webpack_require__(872);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RevisionHistory = (_temp = _class = function (_Component) {
	    _inherits(RevisionHistory, _Component);
	
	    function RevisionHistory() {
	        _classCallCheck(this, RevisionHistory);
	
	        return _possibleConstructorReturn(this, (RevisionHistory.__proto__ || Object.getPrototypeOf(RevisionHistory)).apply(this, arguments));
	    }
	
	    _createClass(RevisionHistory, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                object = _props.object,
	                revisions = _props.revisions,
	                tableMetadata = _props.tableMetadata,
	                user = _props.user;
	
	
	            var userColorAssignments = {};
	            if (revisions) {
	                userColorAssignments = (0, _formatting.assignUserColors)(revisions.map(function (r) {
	                    return r.user.id;
	                }), user.id);
	            }
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: !object || !revisions },
	                function () {
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "wrapper" },
	                        _react2.default.createElement(_Breadcrumbs2.default, { className: "py4", crumbs: [["Datamodel", "/admin/datamodel/database/" + tableMetadata.db_id + "/table/" + tableMetadata.id], [_this2.props.objectType + " History"]] }),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "wrapper py4", style: { maxWidth: 950 } },
	                            _react2.default.createElement(
	                                "h2",
	                                { className: "mb4" },
	                                "Revision History for \"",
	                                object.name,
	                                "\""
	                            ),
	                            _react2.default.createElement(
	                                "ol",
	                                null,
	                                revisions.map(function (revision) {
	                                    return _react2.default.createElement(_Revision2.default, {
	                                        revision: revision,
	                                        objectName: name,
	                                        currentUser: user,
	                                        tableMetadata: tableMetadata,
	                                        userColor: userColorAssignments[revision.user.id]
	                                    });
	                                })
	                            )
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return RevisionHistory;
	}(_react.Component), _class.propTypes = {
	    object: _propTypes2.default.object,
	    revisions: _propTypes2.default.array,
	    tableMetadata: _propTypes2.default.object
	}, _temp);
	RevisionHistory.displayName = "RevisionHistory";
	exports.default = RevisionHistory;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RevisionDiff = __webpack_require__(1848);
	
	var _RevisionDiff2 = _interopRequireDefault(_RevisionDiff);
	
	var _UserAvatar = __webpack_require__(1556);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO: "you" for current user
	// TODO: show different color avatars for users that aren't me
	
	var Revision = (_temp = _class = function (_Component) {
	    _inherits(Revision, _Component);
	
	    function Revision() {
	        _classCallCheck(this, Revision);
	
	        return _possibleConstructorReturn(this, (Revision.__proto__ || Object.getPrototypeOf(Revision)).apply(this, arguments));
	    }
	
	    _createClass(Revision, [{
	        key: "getAction",
	        value: function getAction() {
	            var _props = this.props,
	                revision = _props.revision,
	                objectName = _props.objectName;
	
	            if (revision.is_creation) {
	                return "created \"" + revision.diff.name.after + "\"";
	            }
	            if (revision.is_reversion) {
	                return "reverted to a previous version";
	            }
	            var changedKeys = Object.keys(revision.diff);
	            if (changedKeys.length === 1) {
	                switch (changedKeys[0]) {
	                    case "name":
	                        return "edited the title";
	                    case "description":
	                        return "edited the description";
	                    case "defintion":
	                        return "edited the " + objectName;
	                }
	            }
	            return "made some changes";
	        }
	    }, {
	        key: "getName",
	        value: function getName() {
	            var _props2 = this.props,
	                user = _props2.revision.user,
	                currentUser = _props2.currentUser;
	
	            if (user.id === currentUser.id) {
	                return "You";
	            } else {
	                return user.first_name;
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props3 = this.props,
	                revision = _props3.revision,
	                tableMetadata = _props3.tableMetadata,
	                userColor = _props3.userColor;
	
	            var message = revision.message;
	            var diffKeys = Object.keys(revision.diff);
	
	            if (revision.is_creation) {
	                // these are included in the
	                message = revision.diff.description.after;
	                diffKeys = diffKeys.filter(function (k) {
	                    return k !== "name" && k !== "description";
	                });
	            }
	
	            return _react2.default.createElement(
	                "li",
	                { className: "flex flex-row" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex flex-column align-center mr2" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "text-white" },
	                        _react2.default.createElement(_UserAvatar2.default, { user: revision.user, background: userColor })
	                    ),
	                    _react2.default.createElement("div", { className: "flex-full my1 border-left", style: { borderWidth: 2 } })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex-full mt1 mb4" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex mb1 text-grey-4" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "" },
	                            _react2.default.createElement(
	                                "strong",
	                                null,
	                                this.getName()
	                            ),
	                            " ",
	                            this.getAction()
	                        ),
	                        _react2.default.createElement(
	                            "span",
	                            { className: "flex-align-right h5" },
	                            (0, _moment2.default)(revision.timestamp).format("MMMM DD, YYYY")
	                        )
	                    ),
	                    message && _react2.default.createElement(
	                        "p",
	                        null,
	                        "\"",
	                        message,
	                        "\""
	                    ),
	                    diffKeys.map(function (key) {
	                        return _react2.default.createElement(_RevisionDiff2.default, {
	                            key: key,
	                            property: key,
	                            diff: revision.diff[key],
	                            tableMetadata: tableMetadata
	                        });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Revision;
	}(_react.Component), _class.propTypes = {
	    objectName: _propTypes2.default.string.isRequired,
	    revision: _propTypes2.default.object.isRequired,
	    currentUser: _propTypes2.default.object.isRequired,
	    tableMetadata: _propTypes2.default.object.isRequired
	}, _temp);
	Revision.displayName = "Revision";
	exports.default = Revision;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextDiff = __webpack_require__(1849);
	
	var _TextDiff2 = _interopRequireDefault(_TextDiff);
	
	var _QueryDiff = __webpack_require__(1866);
	
	var _QueryDiff2 = _interopRequireDefault(_QueryDiff);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RevisionDiff = (_temp = _class = function (_Component) {
	    _inherits(RevisionDiff, _Component);
	
	    function RevisionDiff() {
	        _classCallCheck(this, RevisionDiff);
	
	        return _possibleConstructorReturn(this, (RevisionDiff.__proto__ || Object.getPrototypeOf(RevisionDiff)).apply(this, arguments));
	    }
	
	    _createClass(RevisionDiff, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                _props$diff = _props.diff,
	                before = _props$diff.before,
	                after = _props$diff.after,
	                tableMetadata = _props.tableMetadata;
	
	
	            var icon = void 0;
	            if (before != null && after != null) {
	                icon = _react2.default.createElement(_Icon2.default, { name: "pencil", className: "text-brand", size: 16 });
	            } else if (before != null) {
	                icon = _react2.default.createElement(_Icon2.default, { name: "add", className: "text-error", size: 16 });
	            } else {
	                // TODO: "minus" icon
	                icon = _react2.default.createElement(_Icon2.default, { name: "add", className: "text-green", size: 16 });
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "bordered rounded my2", style: { borderWidth: 2, overflow: 'hidden', maxWidth: 860 } },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center scroll-x scroll-show scroll-show-horizontal" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "m3", style: { lineHeight: 0 } },
	                        icon
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        this.props.property === "definition" ? _react2.default.createElement(_QueryDiff2.default, { diff: this.props.diff, tableMetadata: tableMetadata }) : _react2.default.createElement(_TextDiff2.default, { diff: this.props.diff })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RevisionDiff;
	}(_react.Component), _class.propTypes = {
	    property: _propTypes2.default.string.isRequired,
	    diff: _propTypes2.default.object.isRequired,
	    tableMetadata: _propTypes2.default.object.isRequired
	}, _temp);
	RevisionDiff.displayName = "RevisionDiff";
	exports.default = RevisionDiff;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /*eslint-env node */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _diff = __webpack_require__(1850);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextDiff = (_temp = _class = function (_Component) {
	    _inherits(TextDiff, _Component);
	
	    function TextDiff() {
	        _classCallCheck(this, TextDiff);
	
	        return _possibleConstructorReturn(this, (TextDiff.__proto__ || Object.getPrototypeOf(TextDiff)).apply(this, arguments));
	    }
	
	    _createClass(TextDiff, [{
	        key: "render",
	        value: function render() {
	            var _props$diff = this.props.diff,
	                before = _props$diff.before,
	                after = _props$diff.after;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                "\"",
	                before != null && after != null ? (0, _diff.diffWords)(before, after).map(function (section, index) {
	                    return _react2.default.createElement(
	                        "span",
	                        null,
	                        section.added ? _react2.default.createElement(
	                            "strong",
	                            { key: index },
	                            section.value
	                        ) : section.removed ? _react2.default.createElement(
	                            "span",
	                            { key: index, style: { textDecoration: "line-through" } },
	                            section.value
	                        ) : _react2.default.createElement(
	                            "span",
	                            { key: index },
	                            section.value
	                        ),
	                        " "
	                    );
	                }) : before != null ? _react2.default.createElement(
	                    "span",
	                    { style: { textDecoration: "line-through" } },
	                    before
	                ) : _react2.default.createElement(
	                    "strong",
	                    null,
	                    after
	                ),
	                "\""
	            );
	        }
	    }]);
	
	    return TextDiff;
	}(_react.Component), _class.propTypes = {
	    diff: _propTypes2.default.object.isRequired
	}, _temp);
	TextDiff.displayName = "TextDiff";
	exports.default = TextDiff;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.canonicalize = exports.convertChangesToXML = exports.convertChangesToDMP = exports.parsePatch = exports.applyPatches = exports.applyPatch = exports.createPatch = exports.createTwoFilesPatch = exports.structuredPatch = exports.diffArrays = exports.diffJson = exports.diffCss = exports.diffSentences = exports.diffTrimmedLines = exports.diffLines = exports.diffWordsWithSpace = exports.diffWords = exports.diffChars = exports.Diff = undefined;
	/*istanbul ignore end*/
	var /*istanbul ignore start*/_base = __webpack_require__(1851) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	/*istanbul ignore end*/
	var /*istanbul ignore start*/_character = __webpack_require__(1852) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_word = __webpack_require__(1853) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_line = __webpack_require__(1855) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_sentence = __webpack_require__(1856) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_css = __webpack_require__(1857) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_json = __webpack_require__(1858) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_array = __webpack_require__(1859) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_apply = __webpack_require__(1860) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_parse = __webpack_require__(1861) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_create = __webpack_require__(1863) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_dmp = __webpack_require__(1864) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_xml = __webpack_require__(1865) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports. /*istanbul ignore end*/Diff = _base2['default'];
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffChars = _character.diffChars;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWords = _word.diffWords;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWordsWithSpace = _word.diffWordsWithSpace;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffLines = _line.diffLines;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffTrimmedLines = _line.diffTrimmedLines;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffSentences = _sentence.diffSentences;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffCss = _css.diffCss;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffJson = _json.diffJson;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffArrays = _array.diffArrays;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/structuredPatch = _create.structuredPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createTwoFilesPatch = _create.createTwoFilesPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createPatch = _create.createPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatch = _apply.applyPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatches = _apply.applyPatches;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/parsePatch = _parse.parsePatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/convertChangesToDMP = _dmp.convertChangesToDMP;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/convertChangesToXML = _xml.convertChangesToXML;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/canonicalize = _json.canonicalize; /* See LICENSE file for terms of use */
	
	/*
	 * Text diff implementation.
	 *
	 * This library supports the following APIS:
	 * JsDiff.diffChars: Character by character diff
	 * JsDiff.diffWords: Word (as defined by \b regex) diff which ignores whitespace
	 * JsDiff.diffLines: Line based diff
	 *
	 * JsDiff.diffCss: Diff targeted at CSS content
	 *
	 * These methods are based on the implementation proposed in
	 * "An O(ND) Difference Algorithm and its Variations" (Myers, 1986).
	 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.4.6927
	 */
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 1851 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports['default'] = /*istanbul ignore end*/Diff;
	function Diff() {}
	
	Diff.prototype = { /*istanbul ignore start*/
	  /*istanbul ignore end*/diff: function diff(oldString, newString) {
	    /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    var callback = options.callback;
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    this.options = options;
	
	    var self = this;
	
	    function done(value) {
	      if (callback) {
	        setTimeout(function () {
	          callback(undefined, value);
	        }, 0);
	        return true;
	      } else {
	        return value;
	      }
	    }
	
	    // Allow subclasses to massage the input prior to running
	    oldString = this.castInput(oldString);
	    newString = this.castInput(newString);
	
	    oldString = this.removeEmpty(this.tokenize(oldString));
	    newString = this.removeEmpty(this.tokenize(newString));
	
	    var newLen = newString.length,
	        oldLen = oldString.length;
	    var editLength = 1;
	    var maxEditLength = newLen + oldLen;
	    var bestPath = [{ newPos: -1, components: [] }];
	
	    // Seed editLength = 0, i.e. the content starts with the same values
	    var oldPos = this.extractCommon(bestPath[0], newString, oldString, 0);
	    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	      // Identity per the equality and tokenizer
	      return done([{ value: this.join(newString), count: newString.length }]);
	    }
	
	    // Main worker method. checks all permutations of a given edit length for acceptance.
	    function execEditLength() {
	      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
	        var basePath = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	        var addPath = bestPath[diagonalPath - 1],
	            removePath = bestPath[diagonalPath + 1],
	            _oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
	        if (addPath) {
	          // No one else is going to attempt to use this value, clear it
	          bestPath[diagonalPath - 1] = undefined;
	        }
	
	        var canAdd = addPath && addPath.newPos + 1 < newLen,
	            canRemove = removePath && 0 <= _oldPos && _oldPos < oldLen;
	        if (!canAdd && !canRemove) {
	          // If this path is a terminal then prune
	          bestPath[diagonalPath] = undefined;
	          continue;
	        }
	
	        // Select the diagonal that we want to branch from. We select the prior
	        // path whose position in the new string is the farthest from the origin
	        // and does not pass the bounds of the diff graph
	        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
	          basePath = clonePath(removePath);
	          self.pushComponent(basePath.components, undefined, true);
	        } else {
	          basePath = addPath; // No need to clone, we've pulled it from the list
	          basePath.newPos++;
	          self.pushComponent(basePath.components, true, undefined);
	        }
	
	        _oldPos = self.extractCommon(basePath, newString, oldString, diagonalPath);
	
	        // If we have hit the end of both strings, then we are done
	        if (basePath.newPos + 1 >= newLen && _oldPos + 1 >= oldLen) {
	          return done(buildValues(self, basePath.components, newString, oldString, self.useLongestToken));
	        } else {
	          // Otherwise track this path as a potential candidate and continue.
	          bestPath[diagonalPath] = basePath;
	        }
	      }
	
	      editLength++;
	    }
	
	    // Performs the length of edit iteration. Is a bit fugly as this has to support the
	    // sync and async mode which is never fun. Loops over execEditLength until a value
	    // is produced.
	    if (callback) {
	      (function exec() {
	        setTimeout(function () {
	          // This should not happen, but we want to be safe.
	          /* istanbul ignore next */
	          if (editLength > maxEditLength) {
	            return callback();
	          }
	
	          if (!execEditLength()) {
	            exec();
	          }
	        }, 0);
	      })();
	    } else {
	      while (editLength <= maxEditLength) {
	        var ret = execEditLength();
	        if (ret) {
	          return ret;
	        }
	      }
	    }
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/pushComponent: function pushComponent(components, added, removed) {
	    var last = components[components.length - 1];
	    if (last && last.added === added && last.removed === removed) {
	      // We need to clone here as the component clone operation is just
	      // as shallow array clone
	      components[components.length - 1] = { count: last.count + 1, added: added, removed: removed };
	    } else {
	      components.push({ count: 1, added: added, removed: removed });
	    }
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/extractCommon: function extractCommon(basePath, newString, oldString, diagonalPath) {
	    var newLen = newString.length,
	        oldLen = oldString.length,
	        newPos = basePath.newPos,
	        oldPos = newPos - diagonalPath,
	        commonCount = 0;
	    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newString[newPos + 1], oldString[oldPos + 1])) {
	      newPos++;
	      oldPos++;
	      commonCount++;
	    }
	
	    if (commonCount) {
	      basePath.components.push({ count: commonCount });
	    }
	
	    basePath.newPos = newPos;
	    return oldPos;
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/equals: function equals(left, right) {
	    return left === right;
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/removeEmpty: function removeEmpty(array) {
	    var ret = [];
	    for (var i = 0; i < array.length; i++) {
	      if (array[i]) {
	        ret.push(array[i]);
	      }
	    }
	    return ret;
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/castInput: function castInput(value) {
	    return value;
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/tokenize: function tokenize(value) {
	    return value.split('');
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/join: function join(chars) {
	    return chars.join('');
	  }
	};
	
	function buildValues(diff, components, newString, oldString, useLongestToken) {
	  var componentPos = 0,
	      componentLen = components.length,
	      newPos = 0,
	      oldPos = 0;
	
	  for (; componentPos < componentLen; componentPos++) {
	    var component = components[componentPos];
	    if (!component.removed) {
	      if (!component.added && useLongestToken) {
	        var value = newString.slice(newPos, newPos + component.count);
	        value = value.map(function (value, i) {
	          var oldValue = oldString[oldPos + i];
	          return oldValue.length > value.length ? oldValue : value;
	        });
	
	        component.value = diff.join(value);
	      } else {
	        component.value = diff.join(newString.slice(newPos, newPos + component.count));
	      }
	      newPos += component.count;
	
	      // Common case
	      if (!component.added) {
	        oldPos += component.count;
	      }
	    } else {
	      component.value = diff.join(oldString.slice(oldPos, oldPos + component.count));
	      oldPos += component.count;
	
	      // Reverse add and remove so removes are output first to match common convention
	      // The diffing algorithm is tied to add then remove output and this is the simplest
	      // route to get the desired output with minimal overhead.
	      if (componentPos && components[componentPos - 1].added) {
	        var tmp = components[componentPos - 1];
	        components[componentPos - 1] = components[componentPos];
	        components[componentPos] = tmp;
	      }
	    }
	  }
	
	  // Special case handle for when one terminal is ignored. For this case we merge the
	  // terminal into the prior string and drop the change.
	  var lastComponent = components[componentLen - 1];
	  if (componentLen > 1 && (lastComponent.added || lastComponent.removed) && diff.equals('', lastComponent.value)) {
	    components[componentLen - 2].value += lastComponent.value;
	    components.pop();
	  }
	
	  return components;
	}
	
	function clonePath(path) {
	  return { newPos: path.newPos, components: path.components.slice(0) };
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2Jhc2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OzRDQUF3QixJO0FBQVQsU0FBUyxJQUFULEdBQWdCLENBQUU7O0FBRWpDLEtBQUssU0FBTCxHQUFpQixFO3lCQUNmLElBRGUsZ0JBQ1YsU0FEVSxFQUNDLFNBREQsRUFDMEI7NkJBQUEsSSx1QkFBZCxPQUFjLHlEQUFKLEVBQUk7O0FBQ3ZDLFFBQUksV0FBVyxRQUFRLFFBQXZCO0FBQ0EsUUFBSSxPQUFPLE9BQVAsS0FBbUIsVUFBdkIsRUFBbUM7QUFDakMsaUJBQVcsT0FBWDtBQUNBLGdCQUFVLEVBQVY7QUFDRDtBQUNELFNBQUssT0FBTCxHQUFlLE9BQWY7O0FBRUEsUUFBSSxPQUFPLElBQVg7O0FBRUEsYUFBUyxJQUFULENBQWMsS0FBZCxFQUFxQjtBQUNuQixVQUFJLFFBQUosRUFBYztBQUNaLG1CQUFXLFlBQVc7QUFBRSxtQkFBUyxTQUFULEVBQW9CLEtBQXBCO0FBQTZCLFNBQXJELEVBQXVELENBQXZEO0FBQ0EsZUFBTyxJQUFQO0FBQ0QsT0FIRCxNQUdPO0FBQ0wsZUFBTyxLQUFQO0FBQ0Q7QUFDRjs7O0FBR0QsZ0JBQVksS0FBSyxTQUFMLENBQWUsU0FBZixDQUFaO0FBQ0EsZ0JBQVksS0FBSyxTQUFMLENBQWUsU0FBZixDQUFaOztBQUVBLGdCQUFZLEtBQUssV0FBTCxDQUFpQixLQUFLLFFBQUwsQ0FBYyxTQUFkLENBQWpCLENBQVo7QUFDQSxnQkFBWSxLQUFLLFdBQUwsQ0FBaUIsS0FBSyxRQUFMLENBQWMsU0FBZCxDQUFqQixDQUFaOztBQUVBLFFBQUksU0FBUyxVQUFVLE1BQXZCO0FBQUEsUUFBK0IsU0FBUyxVQUFVLE1BQWxEO0FBQ0EsUUFBSSxhQUFhLENBQWpCO0FBQ0EsUUFBSSxnQkFBZ0IsU0FBUyxNQUE3QjtBQUNBLFFBQUksV0FBVyxDQUFDLEVBQUUsUUFBUSxDQUFDLENBQVgsRUFBYyxZQUFZLEVBQTFCLEVBQUQsQ0FBZjs7O0FBR0EsUUFBSSxTQUFTLEtBQUssYUFBTCxDQUFtQixTQUFTLENBQVQsQ0FBbkIsRUFBZ0MsU0FBaEMsRUFBMkMsU0FBM0MsRUFBc0QsQ0FBdEQsQ0FBYjtBQUNBLFFBQUksU0FBUyxDQUFULEVBQVksTUFBWixHQUFxQixDQUFyQixJQUEwQixNQUExQixJQUFvQyxTQUFTLENBQVQsSUFBYyxNQUF0RCxFQUE4RDs7QUFFNUQsYUFBTyxLQUFLLENBQUMsRUFBQyxPQUFPLEtBQUssSUFBTCxDQUFVLFNBQVYsQ0FBUixFQUE4QixPQUFPLFVBQVUsTUFBL0MsRUFBRCxDQUFMLENBQVA7QUFDRDs7O0FBR0QsYUFBUyxjQUFULEdBQTBCO0FBQ3hCLFdBQUssSUFBSSxlQUFlLENBQUMsQ0FBRCxHQUFLLFVBQTdCLEVBQXlDLGdCQUFnQixVQUF6RCxFQUFxRSxnQkFBZ0IsQ0FBckYsRUFBd0Y7QUFDdEYsWUFBSSxXLHlCQUFBLE0sd0JBQUo7QUFDQSxZQUFJLFVBQVUsU0FBUyxlQUFlLENBQXhCLENBQWQ7QUFBQSxZQUNJLGFBQWEsU0FBUyxlQUFlLENBQXhCLENBRGpCO0FBQUEsWUFFSSxVQUFTLENBQUMsYUFBYSxXQUFXLE1BQXhCLEdBQWlDLENBQWxDLElBQXVDLFlBRnBEO0FBR0EsWUFBSSxPQUFKLEVBQWE7O0FBRVgsbUJBQVMsZUFBZSxDQUF4QixJQUE2QixTQUE3QjtBQUNEOztBQUVELFlBQUksU0FBUyxXQUFXLFFBQVEsTUFBUixHQUFpQixDQUFqQixHQUFxQixNQUE3QztBQUFBLFlBQ0ksWUFBWSxjQUFjLEtBQUssT0FBbkIsSUFBNkIsVUFBUyxNQUR0RDtBQUVBLFlBQUksQ0FBQyxNQUFELElBQVcsQ0FBQyxTQUFoQixFQUEyQjs7QUFFekIsbUJBQVMsWUFBVCxJQUF5QixTQUF6QjtBQUNBO0FBQ0Q7Ozs7O0FBS0QsWUFBSSxDQUFDLE1BQUQsSUFBWSxhQUFhLFFBQVEsTUFBUixHQUFpQixXQUFXLE1BQXpELEVBQWtFO0FBQ2hFLHFCQUFXLFVBQVUsVUFBVixDQUFYO0FBQ0EsZUFBSyxhQUFMLENBQW1CLFNBQVMsVUFBNUIsRUFBd0MsU0FBeEMsRUFBbUQsSUFBbkQ7QUFDRCxTQUhELE1BR087QUFDTCxxQkFBVyxPQUFYLEM7QUFDQSxtQkFBUyxNQUFUO0FBQ0EsZUFBSyxhQUFMLENBQW1CLFNBQVMsVUFBNUIsRUFBd0MsSUFBeEMsRUFBOEMsU0FBOUM7QUFDRDs7QUFFRCxrQkFBUyxLQUFLLGFBQUwsQ0FBbUIsUUFBbkIsRUFBNkIsU0FBN0IsRUFBd0MsU0FBeEMsRUFBbUQsWUFBbkQsQ0FBVDs7O0FBR0EsWUFBSSxTQUFTLE1BQVQsR0FBa0IsQ0FBbEIsSUFBdUIsTUFBdkIsSUFBaUMsVUFBUyxDQUFULElBQWMsTUFBbkQsRUFBMkQ7QUFDekQsaUJBQU8sS0FBSyxZQUFZLElBQVosRUFBa0IsU0FBUyxVQUEzQixFQUF1QyxTQUF2QyxFQUFrRCxTQUFsRCxFQUE2RCxLQUFLLGVBQWxFLENBQUwsQ0FBUDtBQUNELFNBRkQsTUFFTzs7QUFFTCxtQkFBUyxZQUFULElBQXlCLFFBQXpCO0FBQ0Q7QUFDRjs7QUFFRDtBQUNEOzs7OztBQUtELFFBQUksUUFBSixFQUFjO0FBQ1gsZ0JBQVMsSUFBVCxHQUFnQjtBQUNmLG1CQUFXLFlBQVc7OztBQUdwQixjQUFJLGFBQWEsYUFBakIsRUFBZ0M7QUFDOUIsbUJBQU8sVUFBUDtBQUNEOztBQUVELGNBQUksQ0FBQyxnQkFBTCxFQUF1QjtBQUNyQjtBQUNEO0FBQ0YsU0FWRCxFQVVHLENBVkg7QUFXRCxPQVpBLEdBQUQ7QUFhRCxLQWRELE1BY087QUFDTCxhQUFPLGNBQWMsYUFBckIsRUFBb0M7QUFDbEMsWUFBSSxNQUFNLGdCQUFWO0FBQ0EsWUFBSSxHQUFKLEVBQVM7QUFDUCxpQkFBTyxHQUFQO0FBQ0Q7QUFDRjtBQUNGO0FBQ0YsR0E5R2M7bURBZ0hmLGFBaEhlLHlCQWdIRCxVQWhIQyxFQWdIVyxLQWhIWCxFQWdIa0IsT0FoSGxCLEVBZ0gyQjtBQUN4QyxRQUFJLE9BQU8sV0FBVyxXQUFXLE1BQVgsR0FBb0IsQ0FBL0IsQ0FBWDtBQUNBLFFBQUksUUFBUSxLQUFLLEtBQUwsS0FBZSxLQUF2QixJQUFnQyxLQUFLLE9BQUwsS0FBaUIsT0FBckQsRUFBOEQ7OztBQUc1RCxpQkFBVyxXQUFXLE1BQVgsR0FBb0IsQ0FBL0IsSUFBb0MsRUFBQyxPQUFPLEtBQUssS0FBTCxHQUFhLENBQXJCLEVBQXdCLE9BQU8sS0FBL0IsRUFBc0MsU0FBUyxPQUEvQyxFQUFwQztBQUNELEtBSkQsTUFJTztBQUNMLGlCQUFXLElBQVgsQ0FBZ0IsRUFBQyxPQUFPLENBQVIsRUFBVyxPQUFPLEtBQWxCLEVBQXlCLFNBQVMsT0FBbEMsRUFBaEI7QUFDRDtBQUNGLEdBekhjO21EQTBIZixhQTFIZSx5QkEwSEQsUUExSEMsRUEwSFMsU0ExSFQsRUEwSG9CLFNBMUhwQixFQTBIK0IsWUExSC9CLEVBMEg2QztBQUMxRCxRQUFJLFNBQVMsVUFBVSxNQUF2QjtBQUFBLFFBQ0ksU0FBUyxVQUFVLE1BRHZCO0FBQUEsUUFFSSxTQUFTLFNBQVMsTUFGdEI7QUFBQSxRQUdJLFNBQVMsU0FBUyxZQUh0QjtBQUFBLFFBS0ksY0FBYyxDQUxsQjtBQU1BLFdBQU8sU0FBUyxDQUFULEdBQWEsTUFBYixJQUF1QixTQUFTLENBQVQsR0FBYSxNQUFwQyxJQUE4QyxLQUFLLE1BQUwsQ0FBWSxVQUFVLFNBQVMsQ0FBbkIsQ0FBWixFQUFtQyxVQUFVLFNBQVMsQ0FBbkIsQ0FBbkMsQ0FBckQsRUFBZ0g7QUFDOUc7QUFDQTtBQUNBO0FBQ0Q7O0FBRUQsUUFBSSxXQUFKLEVBQWlCO0FBQ2YsZUFBUyxVQUFULENBQW9CLElBQXBCLENBQXlCLEVBQUMsT0FBTyxXQUFSLEVBQXpCO0FBQ0Q7O0FBRUQsYUFBUyxNQUFULEdBQWtCLE1BQWxCO0FBQ0EsV0FBTyxNQUFQO0FBQ0QsR0E3SWM7bURBK0lmLE1BL0llLGtCQStJUixJQS9JUSxFQStJRixLQS9JRSxFQStJSztBQUNsQixXQUFPLFNBQVMsS0FBaEI7QUFDRCxHQWpKYzttREFrSmYsV0FsSmUsdUJBa0pILEtBbEpHLEVBa0pJO0FBQ2pCLFFBQUksTUFBTSxFQUFWO0FBQ0EsU0FBSyxJQUFJLElBQUksQ0FBYixFQUFnQixJQUFJLE1BQU0sTUFBMUIsRUFBa0MsR0FBbEMsRUFBdUM7QUFDckMsVUFBSSxNQUFNLENBQU4sQ0FBSixFQUFjO0FBQ1osWUFBSSxJQUFKLENBQVMsTUFBTSxDQUFOLENBQVQ7QUFDRDtBQUNGO0FBQ0QsV0FBTyxHQUFQO0FBQ0QsR0ExSmM7bURBMkpmLFNBM0plLHFCQTJKTCxLQTNKSyxFQTJKRTtBQUNmLFdBQU8sS0FBUDtBQUNELEdBN0pjO21EQThKZixRQTlKZSxvQkE4Sk4sS0E5Sk0sRUE4SkM7QUFDZCxXQUFPLE1BQU0sS0FBTixDQUFZLEVBQVosQ0FBUDtBQUNELEdBaEtjO21EQWlLZixJQWpLZSxnQkFpS1YsS0FqS1UsRUFpS0g7QUFDVixXQUFPLE1BQU0sSUFBTixDQUFXLEVBQVgsQ0FBUDtBQUNEO0FBbktjLENBQWpCOztBQXNLQSxTQUFTLFdBQVQsQ0FBcUIsSUFBckIsRUFBMkIsVUFBM0IsRUFBdUMsU0FBdkMsRUFBa0QsU0FBbEQsRUFBNkQsZUFBN0QsRUFBOEU7QUFDNUUsTUFBSSxlQUFlLENBQW5CO0FBQUEsTUFDSSxlQUFlLFdBQVcsTUFEOUI7QUFBQSxNQUVJLFNBQVMsQ0FGYjtBQUFBLE1BR0ksU0FBUyxDQUhiOztBQUtBLFNBQU8sZUFBZSxZQUF0QixFQUFvQyxjQUFwQyxFQUFvRDtBQUNsRCxRQUFJLFlBQVksV0FBVyxZQUFYLENBQWhCO0FBQ0EsUUFBSSxDQUFDLFVBQVUsT0FBZixFQUF3QjtBQUN0QixVQUFJLENBQUMsVUFBVSxLQUFYLElBQW9CLGVBQXhCLEVBQXlDO0FBQ3ZDLFlBQUksUUFBUSxVQUFVLEtBQVYsQ0FBZ0IsTUFBaEIsRUFBd0IsU0FBUyxVQUFVLEtBQTNDLENBQVo7QUFDQSxnQkFBUSxNQUFNLEdBQU4sQ0FBVSxVQUFTLEtBQVQsRUFBZ0IsQ0FBaEIsRUFBbUI7QUFDbkMsY0FBSSxXQUFXLFVBQVUsU0FBUyxDQUFuQixDQUFmO0FBQ0EsaUJBQU8sU0FBUyxNQUFULEdBQWtCLE1BQU0sTUFBeEIsR0FBaUMsUUFBakMsR0FBNEMsS0FBbkQ7QUFDRCxTQUhPLENBQVI7O0FBS0Esa0JBQVUsS0FBVixHQUFrQixLQUFLLElBQUwsQ0FBVSxLQUFWLENBQWxCO0FBQ0QsT0FSRCxNQVFPO0FBQ0wsa0JBQVUsS0FBVixHQUFrQixLQUFLLElBQUwsQ0FBVSxVQUFVLEtBQVYsQ0FBZ0IsTUFBaEIsRUFBd0IsU0FBUyxVQUFVLEtBQTNDLENBQVYsQ0FBbEI7QUFDRDtBQUNELGdCQUFVLFVBQVUsS0FBcEI7OztBQUdBLFVBQUksQ0FBQyxVQUFVLEtBQWYsRUFBc0I7QUFDcEIsa0JBQVUsVUFBVSxLQUFwQjtBQUNEO0FBQ0YsS0FsQkQsTUFrQk87QUFDTCxnQkFBVSxLQUFWLEdBQWtCLEtBQUssSUFBTCxDQUFVLFVBQVUsS0FBVixDQUFnQixNQUFoQixFQUF3QixTQUFTLFVBQVUsS0FBM0MsQ0FBVixDQUFsQjtBQUNBLGdCQUFVLFVBQVUsS0FBcEI7Ozs7O0FBS0EsVUFBSSxnQkFBZ0IsV0FBVyxlQUFlLENBQTFCLEVBQTZCLEtBQWpELEVBQXdEO0FBQ3RELFlBQUksTUFBTSxXQUFXLGVBQWUsQ0FBMUIsQ0FBVjtBQUNBLG1CQUFXLGVBQWUsQ0FBMUIsSUFBK0IsV0FBVyxZQUFYLENBQS9CO0FBQ0EsbUJBQVcsWUFBWCxJQUEyQixHQUEzQjtBQUNEO0FBQ0Y7QUFDRjs7OztBQUlELE1BQUksZ0JBQWdCLFdBQVcsZUFBZSxDQUExQixDQUFwQjtBQUNBLE1BQUksZUFBZSxDQUFmLEtBQ0ksY0FBYyxLQUFkLElBQXVCLGNBQWMsT0FEekMsS0FFRyxLQUFLLE1BQUwsQ0FBWSxFQUFaLEVBQWdCLGNBQWMsS0FBOUIsQ0FGUCxFQUU2QztBQUMzQyxlQUFXLGVBQWUsQ0FBMUIsRUFBNkIsS0FBN0IsSUFBc0MsY0FBYyxLQUFwRDtBQUNBLGVBQVcsR0FBWDtBQUNEOztBQUVELFNBQU8sVUFBUDtBQUNEOztBQUVELFNBQVMsU0FBVCxDQUFtQixJQUFuQixFQUF5QjtBQUN2QixTQUFPLEVBQUUsUUFBUSxLQUFLLE1BQWYsRUFBdUIsWUFBWSxLQUFLLFVBQUwsQ0FBZ0IsS0FBaEIsQ0FBc0IsQ0FBdEIsQ0FBbkMsRUFBUDtBQUNEIiwiZmlsZSI6ImJhc2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBEaWZmKCkge31cblxuRGlmZi5wcm90b3R5cGUgPSB7XG4gIGRpZmYob2xkU3RyaW5nLCBuZXdTdHJpbmcsIG9wdGlvbnMgPSB7fSkge1xuICAgIGxldCBjYWxsYmFjayA9IG9wdGlvbnMuY2FsbGJhY2s7XG4gICAgaWYgKHR5cGVvZiBvcHRpb25zID09PSAnZnVuY3Rpb24nKSB7XG4gICAgICBjYWxsYmFjayA9IG9wdGlvbnM7XG4gICAgICBvcHRpb25zID0ge307XG4gICAgfVxuICAgIHRoaXMub3B0aW9ucyA9IG9wdGlvbnM7XG5cbiAgICBsZXQgc2VsZiA9IHRoaXM7XG5cbiAgICBmdW5jdGlvbiBkb25lKHZhbHVlKSB7XG4gICAgICBpZiAoY2FsbGJhY2spIHtcbiAgICAgICAgc2V0VGltZW91dChmdW5jdGlvbigpIHsgY2FsbGJhY2sodW5kZWZpbmVkLCB2YWx1ZSk7IH0sIDApO1xuICAgICAgICByZXR1cm4gdHJ1ZTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHJldHVybiB2YWx1ZTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAvLyBBbGxvdyBzdWJjbGFzc2VzIHRvIG1hc3NhZ2UgdGhlIGlucHV0IHByaW9yIHRvIHJ1bm5pbmdcbiAgICBvbGRTdHJpbmcgPSB0aGlzLmNhc3RJbnB1dChvbGRTdHJpbmcpO1xuICAgIG5ld1N0cmluZyA9IHRoaXMuY2FzdElucHV0KG5ld1N0cmluZyk7XG5cbiAgICBvbGRTdHJpbmcgPSB0aGlzLnJlbW92ZUVtcHR5KHRoaXMudG9rZW5pemUob2xkU3RyaW5nKSk7XG4gICAgbmV3U3RyaW5nID0gdGhpcy5yZW1vdmVFbXB0eSh0aGlzLnRva2VuaXplKG5ld1N0cmluZykpO1xuXG4gICAgbGV0IG5ld0xlbiA9IG5ld1N0cmluZy5sZW5ndGgsIG9sZExlbiA9IG9sZFN0cmluZy5sZW5ndGg7XG4gICAgbGV0IGVkaXRMZW5ndGggPSAxO1xuICAgIGxldCBtYXhFZGl0TGVuZ3RoID0gbmV3TGVuICsgb2xkTGVuO1xuICAgIGxldCBiZXN0UGF0aCA9IFt7IG5ld1BvczogLTEsIGNvbXBvbmVudHM6IFtdIH1dO1xuXG4gICAgLy8gU2VlZCBlZGl0TGVuZ3RoID0gMCwgaS5lLiB0aGUgY29udGVudCBzdGFydHMgd2l0aCB0aGUgc2FtZSB2YWx1ZXNcbiAgICBsZXQgb2xkUG9zID0gdGhpcy5leHRyYWN0Q29tbW9uKGJlc3RQYXRoWzBdLCBuZXdTdHJpbmcsIG9sZFN0cmluZywgMCk7XG4gICAgaWYgKGJlc3RQYXRoWzBdLm5ld1BvcyArIDEgPj0gbmV3TGVuICYmIG9sZFBvcyArIDEgPj0gb2xkTGVuKSB7XG4gICAgICAvLyBJZGVudGl0eSBwZXIgdGhlIGVxdWFsaXR5IGFuZCB0b2tlbml6ZXJcbiAgICAgIHJldHVybiBkb25lKFt7dmFsdWU6IHRoaXMuam9pbihuZXdTdHJpbmcpLCBjb3VudDogbmV3U3RyaW5nLmxlbmd0aH1dKTtcbiAgICB9XG5cbiAgICAvLyBNYWluIHdvcmtlciBtZXRob2QuIGNoZWNrcyBhbGwgcGVybXV0YXRpb25zIG9mIGEgZ2l2ZW4gZWRpdCBsZW5ndGggZm9yIGFjY2VwdGFuY2UuXG4gICAgZnVuY3Rpb24gZXhlY0VkaXRMZW5ndGgoKSB7XG4gICAgICBmb3IgKGxldCBkaWFnb25hbFBhdGggPSAtMSAqIGVkaXRMZW5ndGg7IGRpYWdvbmFsUGF0aCA8PSBlZGl0TGVuZ3RoOyBkaWFnb25hbFBhdGggKz0gMikge1xuICAgICAgICBsZXQgYmFzZVBhdGg7XG4gICAgICAgIGxldCBhZGRQYXRoID0gYmVzdFBhdGhbZGlhZ29uYWxQYXRoIC0gMV0sXG4gICAgICAgICAgICByZW1vdmVQYXRoID0gYmVzdFBhdGhbZGlhZ29uYWxQYXRoICsgMV0sXG4gICAgICAgICAgICBvbGRQb3MgPSAocmVtb3ZlUGF0aCA/IHJlbW92ZVBhdGgubmV3UG9zIDogMCkgLSBkaWFnb25hbFBhdGg7XG4gICAgICAgIGlmIChhZGRQYXRoKSB7XG4gICAgICAgICAgLy8gTm8gb25lIGVsc2UgaXMgZ29pbmcgdG8gYXR0ZW1wdCB0byB1c2UgdGhpcyB2YWx1ZSwgY2xlYXIgaXRcbiAgICAgICAgICBiZXN0UGF0aFtkaWFnb25hbFBhdGggLSAxXSA9IHVuZGVmaW5lZDtcbiAgICAgICAgfVxuXG4gICAgICAgIGxldCBjYW5BZGQgPSBhZGRQYXRoICYmIGFkZFBhdGgubmV3UG9zICsgMSA8IG5ld0xlbixcbiAgICAgICAgICAgIGNhblJlbW92ZSA9IHJlbW92ZVBhdGggJiYgMCA8PSBvbGRQb3MgJiYgb2xkUG9zIDwgb2xkTGVuO1xuICAgICAgICBpZiAoIWNhbkFkZCAmJiAhY2FuUmVtb3ZlKSB7XG4gICAgICAgICAgLy8gSWYgdGhpcyBwYXRoIGlzIGEgdGVybWluYWwgdGhlbiBwcnVuZVxuICAgICAgICAgIGJlc3RQYXRoW2RpYWdvbmFsUGF0aF0gPSB1bmRlZmluZWQ7XG4gICAgICAgICAgY29udGludWU7XG4gICAgICAgIH1cblxuICAgICAgICAvLyBTZWxlY3QgdGhlIGRpYWdvbmFsIHRoYXQgd2Ugd2FudCB0byBicmFuY2ggZnJvbS4gV2Ugc2VsZWN0IHRoZSBwcmlvclxuICAgICAgICAvLyBwYXRoIHdob3NlIHBvc2l0aW9uIGluIHRoZSBuZXcgc3RyaW5nIGlzIHRoZSBmYXJ0aGVzdCBmcm9tIHRoZSBvcmlnaW5cbiAgICAgICAgLy8gYW5kIGRvZXMgbm90IHBhc3MgdGhlIGJvdW5kcyBvZiB0aGUgZGlmZiBncmFwaFxuICAgICAgICBpZiAoIWNhbkFkZCB8fCAoY2FuUmVtb3ZlICYmIGFkZFBhdGgubmV3UG9zIDwgcmVtb3ZlUGF0aC5uZXdQb3MpKSB7XG4gICAgICAgICAgYmFzZVBhdGggPSBjbG9uZVBhdGgocmVtb3ZlUGF0aCk7XG4gICAgICAgICAgc2VsZi5wdXNoQ29tcG9uZW50KGJhc2VQYXRoLmNvbXBvbmVudHMsIHVuZGVmaW5lZCwgdHJ1ZSk7XG4gICAgICAgIH0gZWxzZSB7XG4gICAgICAgICAgYmFzZVBhdGggPSBhZGRQYXRoOyAgIC8vIE5vIG5lZWQgdG8gY2xvbmUsIHdlJ3ZlIHB1bGxlZCBpdCBmcm9tIHRoZSBsaXN0XG4gICAgICAgICAgYmFzZVBhdGgubmV3UG9zKys7XG4gICAgICAgICAgc2VsZi5wdXNoQ29tcG9uZW50KGJhc2VQYXRoLmNvbXBvbmVudHMsIHRydWUsIHVuZGVmaW5lZCk7XG4gICAgICAgIH1cblxuICAgICAgICBvbGRQb3MgPSBzZWxmLmV4dHJhY3RDb21tb24oYmFzZVBhdGgsIG5ld1N0cmluZywgb2xkU3RyaW5nLCBkaWFnb25hbFBhdGgpO1xuXG4gICAgICAgIC8vIElmIHdlIGhhdmUgaGl0IHRoZSBlbmQgb2YgYm90aCBzdHJpbmdzLCB0aGVuIHdlIGFyZSBkb25lXG4gICAgICAgIGlmIChiYXNlUGF0aC5uZXdQb3MgKyAxID49IG5ld0xlbiAmJiBvbGRQb3MgKyAxID49IG9sZExlbikge1xuICAgICAgICAgIHJldHVybiBkb25lKGJ1aWxkVmFsdWVzKHNlbGYsIGJhc2VQYXRoLmNvbXBvbmVudHMsIG5ld1N0cmluZywgb2xkU3RyaW5nLCBzZWxmLnVzZUxvbmdlc3RUb2tlbikpO1xuICAgICAgICB9IGVsc2Uge1xuICAgICAgICAgIC8vIE90aGVyd2lzZSB0cmFjayB0aGlzIHBhdGggYXMgYSBwb3RlbnRpYWwgY2FuZGlkYXRlIGFuZCBjb250aW51ZS5cbiAgICAgICAgICBiZXN0UGF0aFtkaWFnb25hbFBhdGhdID0gYmFzZVBhdGg7XG4gICAgICAgIH1cbiAgICAgIH1cblxuICAgICAgZWRpdExlbmd0aCsrO1xuICAgIH1cblxuICAgIC8vIFBlcmZvcm1zIHRoZSBsZW5ndGggb2YgZWRpdCBpdGVyYXRpb24uIElzIGEgYml0IGZ1Z2x5IGFzIHRoaXMgaGFzIHRvIHN1cHBvcnQgdGhlXG4gICAgLy8gc3luYyBhbmQgYXN5bmMgbW9kZSB3aGljaCBpcyBuZXZlciBmdW4uIExvb3BzIG92ZXIgZXhlY0VkaXRMZW5ndGggdW50aWwgYSB2YWx1ZVxuICAgIC8vIGlzIHByb2R1Y2VkLlxuICAgIGlmIChjYWxsYmFjaykge1xuICAgICAgKGZ1bmN0aW9uIGV4ZWMoKSB7XG4gICAgICAgIHNldFRpbWVvdXQoZnVuY3Rpb24oKSB7XG4gICAgICAgICAgLy8gVGhpcyBzaG91bGQgbm90IGhhcHBlbiwgYnV0IHdlIHdhbnQgdG8gYmUgc2FmZS5cbiAgICAgICAgICAvKiBpc3RhbmJ1bCBpZ25vcmUgbmV4dCAqL1xuICAgICAgICAgIGlmIChlZGl0TGVuZ3RoID4gbWF4RWRpdExlbmd0aCkge1xuICAgICAgICAgICAgcmV0dXJuIGNhbGxiYWNrKCk7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgaWYgKCFleGVjRWRpdExlbmd0aCgpKSB7XG4gICAgICAgICAgICBleGVjKCk7XG4gICAgICAgICAgfVxuICAgICAgICB9LCAwKTtcbiAgICAgIH0oKSk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHdoaWxlIChlZGl0TGVuZ3RoIDw9IG1heEVkaXRMZW5ndGgpIHtcbiAgICAgICAgbGV0IHJldCA9IGV4ZWNFZGl0TGVuZ3RoKCk7XG4gICAgICAgIGlmIChyZXQpIHtcbiAgICAgICAgICByZXR1cm4gcmV0O1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9LFxuXG4gIHB1c2hDb21wb25lbnQoY29tcG9uZW50cywgYWRkZWQsIHJlbW92ZWQpIHtcbiAgICBsZXQgbGFzdCA9IGNvbXBvbmVudHNbY29tcG9uZW50cy5sZW5ndGggLSAxXTtcbiAgICBpZiAobGFzdCAmJiBsYXN0LmFkZGVkID09PSBhZGRlZCAmJiBsYXN0LnJlbW92ZWQgPT09IHJlbW92ZWQpIHtcbiAgICAgIC8vIFdlIG5lZWQgdG8gY2xvbmUgaGVyZSBhcyB0aGUgY29tcG9uZW50IGNsb25lIG9wZXJhdGlvbiBpcyBqdXN0XG4gICAgICAvLyBhcyBzaGFsbG93IGFycmF5IGNsb25lXG4gICAgICBjb21wb25lbnRzW2NvbXBvbmVudHMubGVuZ3RoIC0gMV0gPSB7Y291bnQ6IGxhc3QuY291bnQgKyAxLCBhZGRlZDogYWRkZWQsIHJlbW92ZWQ6IHJlbW92ZWQgfTtcbiAgICB9IGVsc2Uge1xuICAgICAgY29tcG9uZW50cy5wdXNoKHtjb3VudDogMSwgYWRkZWQ6IGFkZGVkLCByZW1vdmVkOiByZW1vdmVkIH0pO1xuICAgIH1cbiAgfSxcbiAgZXh0cmFjdENvbW1vbihiYXNlUGF0aCwgbmV3U3RyaW5nLCBvbGRTdHJpbmcsIGRpYWdvbmFsUGF0aCkge1xuICAgIGxldCBuZXdMZW4gPSBuZXdTdHJpbmcubGVuZ3RoLFxuICAgICAgICBvbGRMZW4gPSBvbGRTdHJpbmcubGVuZ3RoLFxuICAgICAgICBuZXdQb3MgPSBiYXNlUGF0aC5uZXdQb3MsXG4gICAgICAgIG9sZFBvcyA9IG5ld1BvcyAtIGRpYWdvbmFsUGF0aCxcblxuICAgICAgICBjb21tb25Db3VudCA9IDA7XG4gICAgd2hpbGUgKG5ld1BvcyArIDEgPCBuZXdMZW4gJiYgb2xkUG9zICsgMSA8IG9sZExlbiAmJiB0aGlzLmVxdWFscyhuZXdTdHJpbmdbbmV3UG9zICsgMV0sIG9sZFN0cmluZ1tvbGRQb3MgKyAxXSkpIHtcbiAgICAgIG5ld1BvcysrO1xuICAgICAgb2xkUG9zKys7XG4gICAgICBjb21tb25Db3VudCsrO1xuICAgIH1cblxuICAgIGlmIChjb21tb25Db3VudCkge1xuICAgICAgYmFzZVBhdGguY29tcG9uZW50cy5wdXNoKHtjb3VudDogY29tbW9uQ291bnR9KTtcbiAgICB9XG5cbiAgICBiYXNlUGF0aC5uZXdQb3MgPSBuZXdQb3M7XG4gICAgcmV0dXJuIG9sZFBvcztcbiAgfSxcblxuICBlcXVhbHMobGVmdCwgcmlnaHQpIHtcbiAgICByZXR1cm4gbGVmdCA9PT0gcmlnaHQ7XG4gIH0sXG4gIHJlbW92ZUVtcHR5KGFycmF5KSB7XG4gICAgbGV0IHJldCA9IFtdO1xuICAgIGZvciAobGV0IGkgPSAwOyBpIDwgYXJyYXkubGVuZ3RoOyBpKyspIHtcbiAgICAgIGlmIChhcnJheVtpXSkge1xuICAgICAgICByZXQucHVzaChhcnJheVtpXSk7XG4gICAgICB9XG4gICAgfVxuICAgIHJldHVybiByZXQ7XG4gIH0sXG4gIGNhc3RJbnB1dCh2YWx1ZSkge1xuICAgIHJldHVybiB2YWx1ZTtcbiAgfSxcbiAgdG9rZW5pemUodmFsdWUpIHtcbiAgICByZXR1cm4gdmFsdWUuc3BsaXQoJycpO1xuICB9LFxuICBqb2luKGNoYXJzKSB7XG4gICAgcmV0dXJuIGNoYXJzLmpvaW4oJycpO1xuICB9XG59O1xuXG5mdW5jdGlvbiBidWlsZFZhbHVlcyhkaWZmLCBjb21wb25lbnRzLCBuZXdTdHJpbmcsIG9sZFN0cmluZywgdXNlTG9uZ2VzdFRva2VuKSB7XG4gIGxldCBjb21wb25lbnRQb3MgPSAwLFxuICAgICAgY29tcG9uZW50TGVuID0gY29tcG9uZW50cy5sZW5ndGgsXG4gICAgICBuZXdQb3MgPSAwLFxuICAgICAgb2xkUG9zID0gMDtcblxuICBmb3IgKDsgY29tcG9uZW50UG9zIDwgY29tcG9uZW50TGVuOyBjb21wb25lbnRQb3MrKykge1xuICAgIGxldCBjb21wb25lbnQgPSBjb21wb25lbnRzW2NvbXBvbmVudFBvc107XG4gICAgaWYgKCFjb21wb25lbnQucmVtb3ZlZCkge1xuICAgICAgaWYgKCFjb21wb25lbnQuYWRkZWQgJiYgdXNlTG9uZ2VzdFRva2VuKSB7XG4gICAgICAgIGxldCB2YWx1ZSA9IG5ld1N0cmluZy5zbGljZShuZXdQb3MsIG5ld1BvcyArIGNvbXBvbmVudC5jb3VudCk7XG4gICAgICAgIHZhbHVlID0gdmFsdWUubWFwKGZ1bmN0aW9uKHZhbHVlLCBpKSB7XG4gICAgICAgICAgbGV0IG9sZFZhbHVlID0gb2xkU3RyaW5nW29sZFBvcyArIGldO1xuICAgICAgICAgIHJldHVybiBvbGRWYWx1ZS5sZW5ndGggPiB2YWx1ZS5sZW5ndGggPyBvbGRWYWx1ZSA6IHZhbHVlO1xuICAgICAgICB9KTtcblxuICAgICAgICBjb21wb25lbnQudmFsdWUgPSBkaWZmLmpvaW4odmFsdWUpO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgY29tcG9uZW50LnZhbHVlID0gZGlmZi5qb2luKG5ld1N0cmluZy5zbGljZShuZXdQb3MsIG5ld1BvcyArIGNvbXBvbmVudC5jb3VudCkpO1xuICAgICAgfVxuICAgICAgbmV3UG9zICs9IGNvbXBvbmVudC5jb3VudDtcblxuICAgICAgLy8gQ29tbW9uIGNhc2VcbiAgICAgIGlmICghY29tcG9uZW50LmFkZGVkKSB7XG4gICAgICAgIG9sZFBvcyArPSBjb21wb25lbnQuY291bnQ7XG4gICAgICB9XG4gICAgfSBlbHNlIHtcbiAgICAgIGNvbXBvbmVudC52YWx1ZSA9IGRpZmYuam9pbihvbGRTdHJpbmcuc2xpY2Uob2xkUG9zLCBvbGRQb3MgKyBjb21wb25lbnQuY291bnQpKTtcbiAgICAgIG9sZFBvcyArPSBjb21wb25lbnQuY291bnQ7XG5cbiAgICAgIC8vIFJldmVyc2UgYWRkIGFuZCByZW1vdmUgc28gcmVtb3ZlcyBhcmUgb3V0cHV0IGZpcnN0IHRvIG1hdGNoIGNvbW1vbiBjb252ZW50aW9uXG4gICAgICAvLyBUaGUgZGlmZmluZyBhbGdvcml0aG0gaXMgdGllZCB0byBhZGQgdGhlbiByZW1vdmUgb3V0cHV0IGFuZCB0aGlzIGlzIHRoZSBzaW1wbGVzdFxuICAgICAgLy8gcm91dGUgdG8gZ2V0IHRoZSBkZXNpcmVkIG91dHB1dCB3aXRoIG1pbmltYWwgb3ZlcmhlYWQuXG4gICAgICBpZiAoY29tcG9uZW50UG9zICYmIGNvbXBvbmVudHNbY29tcG9uZW50UG9zIC0gMV0uYWRkZWQpIHtcbiAgICAgICAgbGV0IHRtcCA9IGNvbXBvbmVudHNbY29tcG9uZW50UG9zIC0gMV07XG4gICAgICAgIGNvbXBvbmVudHNbY29tcG9uZW50UG9zIC0gMV0gPSBjb21wb25lbnRzW2NvbXBvbmVudFBvc107XG4gICAgICAgIGNvbXBvbmVudHNbY29tcG9uZW50UG9zXSA9IHRtcDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAvLyBTcGVjaWFsIGNhc2UgaGFuZGxlIGZvciB3aGVuIG9uZSB0ZXJtaW5hbCBpcyBpZ25vcmVkLiBGb3IgdGhpcyBjYXNlIHdlIG1lcmdlIHRoZVxuICAvLyB0ZXJtaW5hbCBpbnRvIHRoZSBwcmlvciBzdHJpbmcgYW5kIGRyb3AgdGhlIGNoYW5nZS5cbiAgbGV0IGxhc3RDb21wb25lbnQgPSBjb21wb25lbnRzW2NvbXBvbmVudExlbiAtIDFdO1xuICBpZiAoY29tcG9uZW50TGVuID4gMVxuICAgICAgJiYgKGxhc3RDb21wb25lbnQuYWRkZWQgfHwgbGFzdENvbXBvbmVudC5yZW1vdmVkKVxuICAgICAgJiYgZGlmZi5lcXVhbHMoJycsIGxhc3RDb21wb25lbnQudmFsdWUpKSB7XG4gICAgY29tcG9uZW50c1tjb21wb25lbnRMZW4gLSAyXS52YWx1ZSArPSBsYXN0Q29tcG9uZW50LnZhbHVlO1xuICAgIGNvbXBvbmVudHMucG9wKCk7XG4gIH1cblxuICByZXR1cm4gY29tcG9uZW50cztcbn1cblxuZnVuY3Rpb24gY2xvbmVQYXRoKHBhdGgpIHtcbiAgcmV0dXJuIHsgbmV3UG9zOiBwYXRoLm5ld1BvcywgY29tcG9uZW50czogcGF0aC5jb21wb25lbnRzLnNsaWNlKDApIH07XG59XG4iXX0=


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.characterDiff = undefined;
	exports. /*istanbul ignore end*/diffChars = diffChars;
	
	var /*istanbul ignore start*/_base = __webpack_require__(1851) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/var characterDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/characterDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	function diffChars(oldStr, newStr, callback) {
	  return characterDiff.diff(oldStr, newStr, callback);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2NoYXJhY3Rlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O2dDQUdnQixTLEdBQUEsUzs7QUFIaEIsSSx5QkFBQSx5Qix3QkFBQTs7Ozs7Ozt1QkFFTyxJQUFNLGdCLHlCQUFBLFEsd0JBQUEsZ0JBQWdCLEkseUJBQUEsbUIsd0JBQXRCO0FBQ0EsU0FBUyxTQUFULENBQW1CLE1BQW5CLEVBQTJCLE1BQTNCLEVBQW1DLFFBQW5DLEVBQTZDO0FBQUUsU0FBTyxjQUFjLElBQWQsQ0FBbUIsTUFBbkIsRUFBMkIsTUFBM0IsRUFBbUMsUUFBbkMsQ0FBUDtBQUFzRCIsImZpbGUiOiJjaGFyYWN0ZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgRGlmZiBmcm9tICcuL2Jhc2UnO1xuXG5leHBvcnQgY29uc3QgY2hhcmFjdGVyRGlmZiA9IG5ldyBEaWZmKCk7XG5leHBvcnQgZnVuY3Rpb24gZGlmZkNoYXJzKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjaykgeyByZXR1cm4gY2hhcmFjdGVyRGlmZi5kaWZmKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjayk7IH1cbiJdfQ==


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.wordDiff = undefined;
	exports. /*istanbul ignore end*/diffWords = diffWords;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWordsWithSpace = diffWordsWithSpace;
	
	var /*istanbul ignore start*/_base = __webpack_require__(1851) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	/*istanbul ignore end*/
	var /*istanbul ignore start*/_params = __webpack_require__(1854) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/
	
	// Based on https://en.wikipedia.org/wiki/Latin_script_in_Unicode
	//
	// Ranges and exceptions:
	// Latin-1 Supplement, 0080–00FF
	//  - U+00D7  × Multiplication sign
	//  - U+00F7  ÷ Division sign
	// Latin Extended-A, 0100–017F
	// Latin Extended-B, 0180–024F
	// IPA Extensions, 0250–02AF
	// Spacing Modifier Letters, 02B0–02FF
	//  - U+02C7  ˇ &#711;  Caron
	//  - U+02D8  ˘ &#728;  Breve
	//  - U+02D9  ˙ &#729;  Dot Above
	//  - U+02DA  ˚ &#730;  Ring Above
	//  - U+02DB  ˛ &#731;  Ogonek
	//  - U+02DC  ˜ &#732;  Small Tilde
	//  - U+02DD  ˝ &#733;  Double Acute Accent
	// Latin Extended Additional, 1E00–1EFF
	var extendedWordChars = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/;
	
	var reWhitespace = /\S/;
	
	var wordDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/wordDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	wordDiff.equals = function (left, right) {
	  return left === right || this.options.ignoreWhitespace && !reWhitespace.test(left) && !reWhitespace.test(right);
	};
	wordDiff.tokenize = function (value) {
	  var tokens = value.split(/(\s+|\b)/);
	
	  // Join the boundary splits that we do not consider to be boundaries. This is primarily the extended Latin character set.
	  for (var i = 0; i < tokens.length - 1; i++) {
	    // If we have an empty string in the next field and we have only word chars before and after, merge
	    if (!tokens[i + 1] && tokens[i + 2] && extendedWordChars.test(tokens[i]) && extendedWordChars.test(tokens[i + 2])) {
	      tokens[i] += tokens[i + 2];
	      tokens.splice(i + 1, 2);
	      i--;
	    }
	  }
	
	  return tokens;
	};
	
	function diffWords(oldStr, newStr, callback) {
	  var options = /*istanbul ignore start*/(0, _params.generateOptions) /*istanbul ignore end*/(callback, { ignoreWhitespace: true });
	  return wordDiff.diff(oldStr, newStr, options);
	}
	function diffWordsWithSpace(oldStr, newStr, callback) {
	  return wordDiff.diff(oldStr, newStr, callback);
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 1854 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/generateOptions = generateOptions;
	function generateOptions(options, defaults) {
	  if (typeof options === 'function') {
	    defaults.callback = options;
	  } else if (options) {
	    for (var name in options) {
	      /* istanbul ignore else */
	      if (options.hasOwnProperty(name)) {
	        defaults[name] = options[name];
	      }
	    }
	  }
	  return defaults;
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL3BhcmFtcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Z0NBQWdCLGUsR0FBQSxlO0FBQVQsU0FBUyxlQUFULENBQXlCLE9BQXpCLEVBQWtDLFFBQWxDLEVBQTRDO0FBQ2pELE1BQUksT0FBTyxPQUFQLEtBQW1CLFVBQXZCLEVBQW1DO0FBQ2pDLGFBQVMsUUFBVCxHQUFvQixPQUFwQjtBQUNELEdBRkQsTUFFTyxJQUFJLE9BQUosRUFBYTtBQUNsQixTQUFLLElBQUksSUFBVCxJQUFpQixPQUFqQixFQUEwQjs7QUFFeEIsVUFBSSxRQUFRLGNBQVIsQ0FBdUIsSUFBdkIsQ0FBSixFQUFrQztBQUNoQyxpQkFBUyxJQUFULElBQWlCLFFBQVEsSUFBUixDQUFqQjtBQUNEO0FBQ0Y7QUFDRjtBQUNELFNBQU8sUUFBUDtBQUNEIiwiZmlsZSI6InBhcmFtcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiBnZW5lcmF0ZU9wdGlvbnMob3B0aW9ucywgZGVmYXVsdHMpIHtcbiAgaWYgKHR5cGVvZiBvcHRpb25zID09PSAnZnVuY3Rpb24nKSB7XG4gICAgZGVmYXVsdHMuY2FsbGJhY2sgPSBvcHRpb25zO1xuICB9IGVsc2UgaWYgKG9wdGlvbnMpIHtcbiAgICBmb3IgKGxldCBuYW1lIGluIG9wdGlvbnMpIHtcbiAgICAgIC8qIGlzdGFuYnVsIGlnbm9yZSBlbHNlICovXG4gICAgICBpZiAob3B0aW9ucy5oYXNPd25Qcm9wZXJ0eShuYW1lKSkge1xuICAgICAgICBkZWZhdWx0c1tuYW1lXSA9IG9wdGlvbnNbbmFtZV07XG4gICAgICB9XG4gICAgfVxuICB9XG4gIHJldHVybiBkZWZhdWx0cztcbn1cbiJdfQ==


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.lineDiff = undefined;
	exports. /*istanbul ignore end*/diffLines = diffLines;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffTrimmedLines = diffTrimmedLines;
	
	var /*istanbul ignore start*/_base = __webpack_require__(1851) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	/*istanbul ignore end*/
	var /*istanbul ignore start*/_params = __webpack_require__(1854) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/var lineDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/lineDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	lineDiff.tokenize = function (value) {
	  var retLines = [],
	      linesAndNewlines = value.split(/(\n|\r\n)/);
	
	  // Ignore the final empty token that occurs if the string ends with a new line
	  if (!linesAndNewlines[linesAndNewlines.length - 1]) {
	    linesAndNewlines.pop();
	  }
	
	  // Merge the content and line separators into single tokens
	  for (var i = 0; i < linesAndNewlines.length; i++) {
	    var line = linesAndNewlines[i];
	
	    if (i % 2 && !this.options.newlineIsToken) {
	      retLines[retLines.length - 1] += line;
	    } else {
	      if (this.options.ignoreWhitespace) {
	        line = line.trim();
	      }
	      retLines.push(line);
	    }
	  }
	
	  return retLines;
	};
	
	function diffLines(oldStr, newStr, callback) {
	  return lineDiff.diff(oldStr, newStr, callback);
	}
	function diffTrimmedLines(oldStr, newStr, callback) {
	  var options = /*istanbul ignore start*/(0, _params.generateOptions) /*istanbul ignore end*/(callback, { ignoreWhitespace: true });
	  return lineDiff.diff(oldStr, newStr, options);
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.sentenceDiff = undefined;
	exports. /*istanbul ignore end*/diffSentences = diffSentences;
	
	var /*istanbul ignore start*/_base = __webpack_require__(1851) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/var sentenceDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/sentenceDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	sentenceDiff.tokenize = function (value) {
	  return value.split(/(\S.+?[.!?])(?=\s+|$)/);
	};
	
	function diffSentences(oldStr, newStr, callback) {
	  return sentenceDiff.diff(oldStr, newStr, callback);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL3NlbnRlbmNlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Z0NBUWdCLGEsR0FBQSxhOztBQVJoQixJLHlCQUFBLHlCLHdCQUFBOzs7Ozs7O3VCQUdPLElBQU0sZSx5QkFBQSxRLHdCQUFBLGVBQWUsSSx5QkFBQSxtQix3QkFBckI7QUFDUCxhQUFhLFFBQWIsR0FBd0IsVUFBUyxLQUFULEVBQWdCO0FBQ3RDLFNBQU8sTUFBTSxLQUFOLENBQVksdUJBQVosQ0FBUDtBQUNELENBRkQ7O0FBSU8sU0FBUyxhQUFULENBQXVCLE1BQXZCLEVBQStCLE1BQS9CLEVBQXVDLFFBQXZDLEVBQWlEO0FBQUUsU0FBTyxhQUFhLElBQWIsQ0FBa0IsTUFBbEIsRUFBMEIsTUFBMUIsRUFBa0MsUUFBbEMsQ0FBUDtBQUFxRCIsImZpbGUiOiJzZW50ZW5jZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBEaWZmIGZyb20gJy4vYmFzZSc7XG5cblxuZXhwb3J0IGNvbnN0IHNlbnRlbmNlRGlmZiA9IG5ldyBEaWZmKCk7XG5zZW50ZW5jZURpZmYudG9rZW5pemUgPSBmdW5jdGlvbih2YWx1ZSkge1xuICByZXR1cm4gdmFsdWUuc3BsaXQoLyhcXFMuKz9bLiE/XSkoPz1cXHMrfCQpLyk7XG59O1xuXG5leHBvcnQgZnVuY3Rpb24gZGlmZlNlbnRlbmNlcyhvbGRTdHIsIG5ld1N0ciwgY2FsbGJhY2spIHsgcmV0dXJuIHNlbnRlbmNlRGlmZi5kaWZmKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjayk7IH1cbiJdfQ==


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.cssDiff = undefined;
	exports. /*istanbul ignore end*/diffCss = diffCss;
	
	var /*istanbul ignore start*/_base = __webpack_require__(1851) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/var cssDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/cssDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	cssDiff.tokenize = function (value) {
	  return value.split(/([{}:;,]|\s+)/);
	};
	
	function diffCss(oldStr, newStr, callback) {
	  return cssDiff.diff(oldStr, newStr, callback);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2Nzcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O2dDQU9nQixPLEdBQUEsTzs7QUFQaEIsSSx5QkFBQSx5Qix3QkFBQTs7Ozs7Ozt1QkFFTyxJQUFNLFUseUJBQUEsUSx3QkFBQSxVQUFVLEkseUJBQUEsbUIsd0JBQWhCO0FBQ1AsUUFBUSxRQUFSLEdBQW1CLFVBQVMsS0FBVCxFQUFnQjtBQUNqQyxTQUFPLE1BQU0sS0FBTixDQUFZLGVBQVosQ0FBUDtBQUNELENBRkQ7O0FBSU8sU0FBUyxPQUFULENBQWlCLE1BQWpCLEVBQXlCLE1BQXpCLEVBQWlDLFFBQWpDLEVBQTJDO0FBQUUsU0FBTyxRQUFRLElBQVIsQ0FBYSxNQUFiLEVBQXFCLE1BQXJCLEVBQTZCLFFBQTdCLENBQVA7QUFBZ0QiLCJmaWxlIjoiY3NzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IERpZmYgZnJvbSAnLi9iYXNlJztcblxuZXhwb3J0IGNvbnN0IGNzc0RpZmYgPSBuZXcgRGlmZigpO1xuY3NzRGlmZi50b2tlbml6ZSA9IGZ1bmN0aW9uKHZhbHVlKSB7XG4gIHJldHVybiB2YWx1ZS5zcGxpdCgvKFt7fTo7LF18XFxzKykvKTtcbn07XG5cbmV4cG9ydCBmdW5jdGlvbiBkaWZmQ3NzKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjaykgeyByZXR1cm4gY3NzRGlmZi5kaWZmKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjayk7IH1cbiJdfQ==


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.jsonDiff = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports. /*istanbul ignore end*/diffJson = diffJson;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/canonicalize = canonicalize;
	
	var /*istanbul ignore start*/_base = __webpack_require__(1851) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	/*istanbul ignore end*/
	var /*istanbul ignore start*/_line = __webpack_require__(1855) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/
	
	var objectPrototypeToString = Object.prototype.toString;
	
	var jsonDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/jsonDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	// Discriminate between two lines of pretty-printed, serialized JSON where one of them has a
	// dangling comma and the other doesn't. Turns out including the dangling comma yields the nicest output:
	jsonDiff.useLongestToken = true;
	
	jsonDiff.tokenize = /*istanbul ignore start*/_line.lineDiff. /*istanbul ignore end*/tokenize;
	jsonDiff.castInput = function (value) {
	  /*istanbul ignore start*/var /*istanbul ignore end*/undefinedReplacement = this.options.undefinedReplacement;
	
	
	  return typeof value === 'string' ? value : JSON.stringify(canonicalize(value), function (k, v) {
	    if (typeof v === 'undefined') {
	      return undefinedReplacement;
	    }
	
	    return v;
	  }, '  ');
	};
	jsonDiff.equals = function (left, right) {
	  return (/*istanbul ignore start*/_base2['default']. /*istanbul ignore end*/prototype.equals(left.replace(/,([\r\n])/g, '$1'), right.replace(/,([\r\n])/g, '$1'))
	  );
	};
	
	function diffJson(oldObj, newObj, options) {
	  return jsonDiff.diff(oldObj, newObj, options);
	}
	
	// This function handles the presence of circular references by bailing out when encountering an
	// object that is already on the "stack" of items being processed.
	function canonicalize(obj, stack, replacementStack) {
	  stack = stack || [];
	  replacementStack = replacementStack || [];
	
	  var i = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	
	  for (i = 0; i < stack.length; i += 1) {
	    if (stack[i] === obj) {
	      return replacementStack[i];
	    }
	  }
	
	  var canonicalizedObj = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	
	  if ('[object Array]' === objectPrototypeToString.call(obj)) {
	    stack.push(obj);
	    canonicalizedObj = new Array(obj.length);
	    replacementStack.push(canonicalizedObj);
	    for (i = 0; i < obj.length; i += 1) {
	      canonicalizedObj[i] = canonicalize(obj[i], stack, replacementStack);
	    }
	    stack.pop();
	    replacementStack.pop();
	    return canonicalizedObj;
	  }
	
	  if (obj && obj.toJSON) {
	    obj = obj.toJSON();
	  }
	
	  if ( /*istanbul ignore start*/(typeof /*istanbul ignore end*/obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null) {
	    stack.push(obj);
	    canonicalizedObj = {};
	    replacementStack.push(canonicalizedObj);
	    var sortedKeys = [],
	        key = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	    for (key in obj) {
	      /* istanbul ignore else */
	      if (obj.hasOwnProperty(key)) {
	        sortedKeys.push(key);
	      }
	    }
	    sortedKeys.sort();
	    for (i = 0; i < sortedKeys.length; i += 1) {
	      key = sortedKeys[i];
	      canonicalizedObj[key] = canonicalize(obj[key], stack, replacementStack);
	    }
	    stack.pop();
	    replacementStack.pop();
	  } else {
	    canonicalizedObj = obj;
	  }
	  return canonicalizedObj;
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports.arrayDiff = undefined;
	exports. /*istanbul ignore end*/diffArrays = diffArrays;
	
	var /*istanbul ignore start*/_base = __webpack_require__(1851) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/var arrayDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/arrayDiff = new /*istanbul ignore start*/_base2['default']() /*istanbul ignore end*/;
	arrayDiff.tokenize = arrayDiff.join = function (value) {
	  return value.slice();
	};
	
	function diffArrays(oldArr, newArr, callback) {
	  return arrayDiff.diff(oldArr, newArr, callback);
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2FycmF5LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Z0NBT2dCLFUsR0FBQSxVOztBQVBoQixJLHlCQUFBLHlCLHdCQUFBOzs7Ozs7O3VCQUVPLElBQU0sWSx5QkFBQSxRLHdCQUFBLFlBQVksSSx5QkFBQSxtQix3QkFBbEI7QUFDUCxVQUFVLFFBQVYsR0FBcUIsVUFBVSxJQUFWLEdBQWlCLFVBQVMsS0FBVCxFQUFnQjtBQUNwRCxTQUFPLE1BQU0sS0FBTixFQUFQO0FBQ0QsQ0FGRDs7QUFJTyxTQUFTLFVBQVQsQ0FBb0IsTUFBcEIsRUFBNEIsTUFBNUIsRUFBb0MsUUFBcEMsRUFBOEM7QUFBRSxTQUFPLFVBQVUsSUFBVixDQUFlLE1BQWYsRUFBdUIsTUFBdkIsRUFBK0IsUUFBL0IsQ0FBUDtBQUFrRCIsImZpbGUiOiJhcnJheS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBEaWZmIGZyb20gJy4vYmFzZSc7XG5cbmV4cG9ydCBjb25zdCBhcnJheURpZmYgPSBuZXcgRGlmZigpO1xuYXJyYXlEaWZmLnRva2VuaXplID0gYXJyYXlEaWZmLmpvaW4gPSBmdW5jdGlvbih2YWx1ZSkge1xuICByZXR1cm4gdmFsdWUuc2xpY2UoKTtcbn07XG5cbmV4cG9ydCBmdW5jdGlvbiBkaWZmQXJyYXlzKG9sZEFyciwgbmV3QXJyLCBjYWxsYmFjaykgeyByZXR1cm4gYXJyYXlEaWZmLmRpZmYob2xkQXJyLCBuZXdBcnIsIGNhbGxiYWNrKTsgfVxuIl19


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/applyPatch = applyPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatches = applyPatches;
	
	var /*istanbul ignore start*/_parse = __webpack_require__(1861) /*istanbul ignore end*/;
	
	var /*istanbul ignore start*/_distanceIterator = __webpack_require__(1862) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	var _distanceIterator2 = _interopRequireDefault(_distanceIterator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*istanbul ignore end*/function applyPatch(source, uniDiff) {
	  /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  if (typeof uniDiff === 'string') {
	    uniDiff = /*istanbul ignore start*/(0, _parse.parsePatch) /*istanbul ignore end*/(uniDiff);
	  }
	
	  if (Array.isArray(uniDiff)) {
	    if (uniDiff.length > 1) {
	      throw new Error('applyPatch only works with a single input.');
	    }
	
	    uniDiff = uniDiff[0];
	  }
	
	  // Apply the diff to the input
	  var lines = source.split(/\r\n|[\n\v\f\r\x85]/),
	      delimiters = source.match(/\r\n|[\n\v\f\r\x85]/g) || [],
	      hunks = uniDiff.hunks,
	      compareLine = options.compareLine || function (lineNumber, line, operation, patchContent) /*istanbul ignore start*/{
	    return (/*istanbul ignore end*/line === patchContent
	    );
	  },
	      errorCount = 0,
	      fuzzFactor = options.fuzzFactor || 0,
	      minLine = 0,
	      offset = 0,
	      removeEOFNL = /*istanbul ignore start*/void 0 /*istanbul ignore end*/,
	      addEOFNL = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	
	  /**
	   * Checks if the hunk exactly fits on the provided location
	   */
	  function hunkFits(hunk, toPos) {
	    for (var j = 0; j < hunk.lines.length; j++) {
	      var line = hunk.lines[j],
	          operation = line[0],
	          content = line.substr(1);
	
	      if (operation === ' ' || operation === '-') {
	        // Context sanity check
	        if (!compareLine(toPos + 1, lines[toPos], operation, content)) {
	          errorCount++;
	
	          if (errorCount > fuzzFactor) {
	            return false;
	          }
	        }
	        toPos++;
	      }
	    }
	
	    return true;
	  }
	
	  // Search best fit offsets for each hunk based on the previous ones
	  for (var i = 0; i < hunks.length; i++) {
	    var hunk = hunks[i],
	        maxLine = lines.length - hunk.oldLines,
	        localOffset = 0,
	        toPos = offset + hunk.oldStart - 1;
	
	    var iterator = /*istanbul ignore start*/(0, _distanceIterator2['default']) /*istanbul ignore end*/(toPos, minLine, maxLine);
	
	    for (; localOffset !== undefined; localOffset = iterator()) {
	      if (hunkFits(hunk, toPos + localOffset)) {
	        hunk.offset = offset += localOffset;
	        break;
	      }
	    }
	
	    if (localOffset === undefined) {
	      return false;
	    }
	
	    // Set lower text limit to end of the current hunk, so next ones don't try
	    // to fit over already patched text
	    minLine = hunk.offset + hunk.oldStart + hunk.oldLines;
	  }
	
	  // Apply patch hunks
	  for (var _i = 0; _i < hunks.length; _i++) {
	    var _hunk = hunks[_i],
	        _toPos = _hunk.offset + _hunk.newStart - 1;
	    if (_hunk.newLines == 0) {
	      _toPos++;
	    }
	
	    for (var j = 0; j < _hunk.lines.length; j++) {
	      var line = _hunk.lines[j],
	          operation = line[0],
	          content = line.substr(1),
	          delimiter = _hunk.linedelimiters[j];
	
	      if (operation === ' ') {
	        _toPos++;
	      } else if (operation === '-') {
	        lines.splice(_toPos, 1);
	        delimiters.splice(_toPos, 1);
	        /* istanbul ignore else */
	      } else if (operation === '+') {
	          lines.splice(_toPos, 0, content);
	          delimiters.splice(_toPos, 0, delimiter);
	          _toPos++;
	        } else if (operation === '\\') {
	          var previousOperation = _hunk.lines[j - 1] ? _hunk.lines[j - 1][0] : null;
	          if (previousOperation === '+') {
	            removeEOFNL = true;
	          } else if (previousOperation === '-') {
	            addEOFNL = true;
	          }
	        }
	    }
	  }
	
	  // Handle EOFNL insertion/removal
	  if (removeEOFNL) {
	    while (!lines[lines.length - 1]) {
	      lines.pop();
	      delimiters.pop();
	    }
	  } else if (addEOFNL) {
	    lines.push('');
	    delimiters.push('\n');
	  }
	  for (var _k = 0; _k < lines.length - 1; _k++) {
	    lines[_k] = lines[_k] + delimiters[_k];
	  }
	  return lines.join('');
	}
	
	// Wrapper that supports multiple file patches via callbacks.
	function applyPatches(uniDiff, options) {
	  if (typeof uniDiff === 'string') {
	    uniDiff = /*istanbul ignore start*/(0, _parse.parsePatch) /*istanbul ignore end*/(uniDiff);
	  }
	
	  var currentIndex = 0;
	  function processIndex() {
	    var index = uniDiff[currentIndex++];
	    if (!index) {
	      return options.complete();
	    }
	
	    options.loadFile(index, function (err, data) {
	      if (err) {
	        return options.complete(err);
	      }
	
	      var updatedContent = applyPatch(data, index, options);
	      options.patched(index, updatedContent, function (err) {
	        if (err) {
	          return options.complete(err);
	        }
	
	        processIndex();
	      });
	    });
	  }
	  processIndex();
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 1861 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/parsePatch = parsePatch;
	function parsePatch(uniDiff) {
	  /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var diffstr = uniDiff.split(/\r\n|[\n\v\f\r\x85]/),
	      delimiters = uniDiff.match(/\r\n|[\n\v\f\r\x85]/g) || [],
	      list = [],
	      i = 0;
	
	  function parseIndex() {
	    var index = {};
	    list.push(index);
	
	    // Parse diff metadata
	    while (i < diffstr.length) {
	      var line = diffstr[i];
	
	      // File header found, end parsing diff metadata
	      if (/^(\-\-\-|\+\+\+|@@)\s/.test(line)) {
	        break;
	      }
	
	      // Diff index
	      var header = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(line);
	      if (header) {
	        index.index = header[1];
	      }
	
	      i++;
	    }
	
	    // Parse file headers if they are defined. Unified diff requires them, but
	    // there's no technical issues to have an isolated hunk without file header
	    parseFileHeader(index);
	    parseFileHeader(index);
	
	    // Parse hunks
	    index.hunks = [];
	
	    while (i < diffstr.length) {
	      var _line = diffstr[i];
	
	      if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(_line)) {
	        break;
	      } else if (/^@@/.test(_line)) {
	        index.hunks.push(parseHunk());
	      } else if (_line && options.strict) {
	        // Ignore unexpected content unless in strict mode
	        throw new Error('Unknown line ' + (i + 1) + ' ' + JSON.stringify(_line));
	      } else {
	        i++;
	      }
	    }
	  }
	
	  // Parses the --- and +++ headers, if none are found, no lines
	  // are consumed.
	  function parseFileHeader(index) {
	    var headerPattern = /^(---|\+\+\+)\s+([\S ]*)(?:\t(.*?)\s*)?$/;
	    var fileHeader = headerPattern.exec(diffstr[i]);
	    if (fileHeader) {
	      var keyPrefix = fileHeader[1] === '---' ? 'old' : 'new';
	      index[keyPrefix + 'FileName'] = fileHeader[2];
	      index[keyPrefix + 'Header'] = fileHeader[3];
	
	      i++;
	    }
	  }
	
	  // Parses a hunk
	  // This assumes that we are at the start of a hunk.
	  function parseHunk() {
	    var chunkHeaderIndex = i,
	        chunkHeaderLine = diffstr[i++],
	        chunkHeader = chunkHeaderLine.split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/);
	
	    var hunk = {
	      oldStart: +chunkHeader[1],
	      oldLines: +chunkHeader[2] || 1,
	      newStart: +chunkHeader[3],
	      newLines: +chunkHeader[4] || 1,
	      lines: [],
	      linedelimiters: []
	    };
	
	    var addCount = 0,
	        removeCount = 0;
	    for (; i < diffstr.length; i++) {
	      // Lines starting with '---' could be mistaken for the "remove line" operation
	      // But they could be the header for the next file. Therefore prune such cases out.
	      if (diffstr[i].indexOf('--- ') === 0 && i + 2 < diffstr.length && diffstr[i + 1].indexOf('+++ ') === 0 && diffstr[i + 2].indexOf('@@') === 0) {
	        break;
	      }
	      var operation = diffstr[i][0];
	
	      if (operation === '+' || operation === '-' || operation === ' ' || operation === '\\') {
	        hunk.lines.push(diffstr[i]);
	        hunk.linedelimiters.push(delimiters[i] || '\n');
	
	        if (operation === '+') {
	          addCount++;
	        } else if (operation === '-') {
	          removeCount++;
	        } else if (operation === ' ') {
	          addCount++;
	          removeCount++;
	        }
	      } else {
	        break;
	      }
	    }
	
	    // Handle the empty block count case
	    if (!addCount && hunk.newLines === 1) {
	      hunk.newLines = 0;
	    }
	    if (!removeCount && hunk.oldLines === 1) {
	      hunk.oldLines = 0;
	    }
	
	    // Perform optional sanity checking
	    if (options.strict) {
	      if (addCount !== hunk.newLines) {
	        throw new Error('Added line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
	      }
	      if (removeCount !== hunk.oldLines) {
	        throw new Error('Removed line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
	      }
	    }
	
	    return hunk;
	  }
	
	  while (i < diffstr.length) {
	    parseIndex();
	  }
	
	  return list;
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wYXRjaC9wYXJzZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Z0NBQWdCLFUsR0FBQSxVO0FBQVQsU0FBUyxVQUFULENBQW9CLE9BQXBCLEVBQTJDOzJCQUFBLEksdUJBQWQsT0FBYyx5REFBSixFQUFJOztBQUNoRCxNQUFJLFVBQVUsUUFBUSxLQUFSLENBQWMscUJBQWQsQ0FBZDtBQUFBLE1BQ0ksYUFBYSxRQUFRLEtBQVIsQ0FBYyxzQkFBZCxLQUF5QyxFQUQxRDtBQUFBLE1BRUksT0FBTyxFQUZYO0FBQUEsTUFHSSxJQUFJLENBSFI7O0FBS0EsV0FBUyxVQUFULEdBQXNCO0FBQ3BCLFFBQUksUUFBUSxFQUFaO0FBQ0EsU0FBSyxJQUFMLENBQVUsS0FBVjs7O0FBR0EsV0FBTyxJQUFJLFFBQVEsTUFBbkIsRUFBMkI7QUFDekIsVUFBSSxPQUFPLFFBQVEsQ0FBUixDQUFYOzs7QUFHQSxVQUFJLHdCQUF3QixJQUF4QixDQUE2QixJQUE3QixDQUFKLEVBQXdDO0FBQ3RDO0FBQ0Q7OztBQUdELFVBQUksU0FBVSwwQ0FBRCxDQUE2QyxJQUE3QyxDQUFrRCxJQUFsRCxDQUFiO0FBQ0EsVUFBSSxNQUFKLEVBQVk7QUFDVixjQUFNLEtBQU4sR0FBYyxPQUFPLENBQVAsQ0FBZDtBQUNEOztBQUVEO0FBQ0Q7Ozs7QUFJRCxvQkFBZ0IsS0FBaEI7QUFDQSxvQkFBZ0IsS0FBaEI7OztBQUdBLFVBQU0sS0FBTixHQUFjLEVBQWQ7O0FBRUEsV0FBTyxJQUFJLFFBQVEsTUFBbkIsRUFBMkI7QUFDekIsVUFBSSxRQUFPLFFBQVEsQ0FBUixDQUFYOztBQUVBLFVBQUksaUNBQWlDLElBQWpDLENBQXNDLEtBQXRDLENBQUosRUFBaUQ7QUFDL0M7QUFDRCxPQUZELE1BRU8sSUFBSSxNQUFNLElBQU4sQ0FBVyxLQUFYLENBQUosRUFBc0I7QUFDM0IsY0FBTSxLQUFOLENBQVksSUFBWixDQUFpQixXQUFqQjtBQUNELE9BRk0sTUFFQSxJQUFJLFNBQVEsUUFBUSxNQUFwQixFQUE0Qjs7QUFFakMsY0FBTSxJQUFJLEtBQUosQ0FBVSxtQkFBbUIsSUFBSSxDQUF2QixJQUE0QixHQUE1QixHQUFrQyxLQUFLLFNBQUwsQ0FBZSxLQUFmLENBQTVDLENBQU47QUFDRCxPQUhNLE1BR0E7QUFDTDtBQUNEO0FBQ0Y7QUFDRjs7OztBQUlELFdBQVMsZUFBVCxDQUF5QixLQUF6QixFQUFnQztBQUM5QixRQUFNLGdCQUFnQiwwQ0FBdEI7QUFDQSxRQUFNLGFBQWEsY0FBYyxJQUFkLENBQW1CLFFBQVEsQ0FBUixDQUFuQixDQUFuQjtBQUNBLFFBQUksVUFBSixFQUFnQjtBQUNkLFVBQUksWUFBWSxXQUFXLENBQVgsTUFBa0IsS0FBbEIsR0FBMEIsS0FBMUIsR0FBa0MsS0FBbEQ7QUFDQSxZQUFNLFlBQVksVUFBbEIsSUFBZ0MsV0FBVyxDQUFYLENBQWhDO0FBQ0EsWUFBTSxZQUFZLFFBQWxCLElBQThCLFdBQVcsQ0FBWCxDQUE5Qjs7QUFFQTtBQUNEO0FBQ0Y7Ozs7QUFJRCxXQUFTLFNBQVQsR0FBcUI7QUFDbkIsUUFBSSxtQkFBbUIsQ0FBdkI7QUFBQSxRQUNJLGtCQUFrQixRQUFRLEdBQVIsQ0FEdEI7QUFBQSxRQUVJLGNBQWMsZ0JBQWdCLEtBQWhCLENBQXNCLDRDQUF0QixDQUZsQjs7QUFJQSxRQUFJLE9BQU87QUFDVCxnQkFBVSxDQUFDLFlBQVksQ0FBWixDQURGO0FBRVQsZ0JBQVUsQ0FBQyxZQUFZLENBQVosQ0FBRCxJQUFtQixDQUZwQjtBQUdULGdCQUFVLENBQUMsWUFBWSxDQUFaLENBSEY7QUFJVCxnQkFBVSxDQUFDLFlBQVksQ0FBWixDQUFELElBQW1CLENBSnBCO0FBS1QsYUFBTyxFQUxFO0FBTVQsc0JBQWdCO0FBTlAsS0FBWDs7QUFTQSxRQUFJLFdBQVcsQ0FBZjtBQUFBLFFBQ0ksY0FBYyxDQURsQjtBQUVBLFdBQU8sSUFBSSxRQUFRLE1BQW5CLEVBQTJCLEdBQTNCLEVBQWdDOzs7QUFHOUIsVUFBSSxRQUFRLENBQVIsRUFBVyxPQUFYLENBQW1CLE1BQW5CLE1BQStCLENBQS9CLElBQ00sSUFBSSxDQUFKLEdBQVEsUUFBUSxNQUR0QixJQUVLLFFBQVEsSUFBSSxDQUFaLEVBQWUsT0FBZixDQUF1QixNQUF2QixNQUFtQyxDQUZ4QyxJQUdLLFFBQVEsSUFBSSxDQUFaLEVBQWUsT0FBZixDQUF1QixJQUF2QixNQUFpQyxDQUgxQyxFQUc2QztBQUN6QztBQUNIO0FBQ0QsVUFBSSxZQUFZLFFBQVEsQ0FBUixFQUFXLENBQVgsQ0FBaEI7O0FBRUEsVUFBSSxjQUFjLEdBQWQsSUFBcUIsY0FBYyxHQUFuQyxJQUEwQyxjQUFjLEdBQXhELElBQStELGNBQWMsSUFBakYsRUFBdUY7QUFDckYsYUFBSyxLQUFMLENBQVcsSUFBWCxDQUFnQixRQUFRLENBQVIsQ0FBaEI7QUFDQSxhQUFLLGNBQUwsQ0FBb0IsSUFBcEIsQ0FBeUIsV0FBVyxDQUFYLEtBQWlCLElBQTFDOztBQUVBLFlBQUksY0FBYyxHQUFsQixFQUF1QjtBQUNyQjtBQUNELFNBRkQsTUFFTyxJQUFJLGNBQWMsR0FBbEIsRUFBdUI7QUFDNUI7QUFDRCxTQUZNLE1BRUEsSUFBSSxjQUFjLEdBQWxCLEVBQXVCO0FBQzVCO0FBQ0E7QUFDRDtBQUNGLE9BWkQsTUFZTztBQUNMO0FBQ0Q7QUFDRjs7O0FBR0QsUUFBSSxDQUFDLFFBQUQsSUFBYSxLQUFLLFFBQUwsS0FBa0IsQ0FBbkMsRUFBc0M7QUFDcEMsV0FBSyxRQUFMLEdBQWdCLENBQWhCO0FBQ0Q7QUFDRCxRQUFJLENBQUMsV0FBRCxJQUFnQixLQUFLLFFBQUwsS0FBa0IsQ0FBdEMsRUFBeUM7QUFDdkMsV0FBSyxRQUFMLEdBQWdCLENBQWhCO0FBQ0Q7OztBQUdELFFBQUksUUFBUSxNQUFaLEVBQW9CO0FBQ2xCLFVBQUksYUFBYSxLQUFLLFFBQXRCLEVBQWdDO0FBQzlCLGNBQU0sSUFBSSxLQUFKLENBQVUsc0RBQXNELG1CQUFtQixDQUF6RSxDQUFWLENBQU47QUFDRDtBQUNELFVBQUksZ0JBQWdCLEtBQUssUUFBekIsRUFBbUM7QUFDakMsY0FBTSxJQUFJLEtBQUosQ0FBVSx3REFBd0QsbUJBQW1CLENBQTNFLENBQVYsQ0FBTjtBQUNEO0FBQ0Y7O0FBRUQsV0FBTyxJQUFQO0FBQ0Q7O0FBRUQsU0FBTyxJQUFJLFFBQVEsTUFBbkIsRUFBMkI7QUFDekI7QUFDRDs7QUFFRCxTQUFPLElBQVA7QUFDRCIsImZpbGUiOiJwYXJzZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiBwYXJzZVBhdGNoKHVuaURpZmYsIG9wdGlvbnMgPSB7fSkge1xuICBsZXQgZGlmZnN0ciA9IHVuaURpZmYuc3BsaXQoL1xcclxcbnxbXFxuXFx2XFxmXFxyXFx4ODVdLyksXG4gICAgICBkZWxpbWl0ZXJzID0gdW5pRGlmZi5tYXRjaCgvXFxyXFxufFtcXG5cXHZcXGZcXHJcXHg4NV0vZykgfHwgW10sXG4gICAgICBsaXN0ID0gW10sXG4gICAgICBpID0gMDtcblxuICBmdW5jdGlvbiBwYXJzZUluZGV4KCkge1xuICAgIGxldCBpbmRleCA9IHt9O1xuICAgIGxpc3QucHVzaChpbmRleCk7XG5cbiAgICAvLyBQYXJzZSBkaWZmIG1ldGFkYXRhXG4gICAgd2hpbGUgKGkgPCBkaWZmc3RyLmxlbmd0aCkge1xuICAgICAgbGV0IGxpbmUgPSBkaWZmc3RyW2ldO1xuXG4gICAgICAvLyBGaWxlIGhlYWRlciBmb3VuZCwgZW5kIHBhcnNpbmcgZGlmZiBtZXRhZGF0YVxuICAgICAgaWYgKC9eKFxcLVxcLVxcLXxcXCtcXCtcXCt8QEApXFxzLy50ZXN0KGxpbmUpKSB7XG4gICAgICAgIGJyZWFrO1xuICAgICAgfVxuXG4gICAgICAvLyBEaWZmIGluZGV4XG4gICAgICBsZXQgaGVhZGVyID0gKC9eKD86SW5kZXg6fGRpZmYoPzogLXIgXFx3KykrKVxccysoLis/KVxccyokLykuZXhlYyhsaW5lKTtcbiAgICAgIGlmIChoZWFkZXIpIHtcbiAgICAgICAgaW5kZXguaW5kZXggPSBoZWFkZXJbMV07XG4gICAgICB9XG5cbiAgICAgIGkrKztcbiAgICB9XG5cbiAgICAvLyBQYXJzZSBmaWxlIGhlYWRlcnMgaWYgdGhleSBhcmUgZGVmaW5lZC4gVW5pZmllZCBkaWZmIHJlcXVpcmVzIHRoZW0sIGJ1dFxuICAgIC8vIHRoZXJlJ3Mgbm8gdGVjaG5pY2FsIGlzc3VlcyB0byBoYXZlIGFuIGlzb2xhdGVkIGh1bmsgd2l0aG91dCBmaWxlIGhlYWRlclxuICAgIHBhcnNlRmlsZUhlYWRlcihpbmRleCk7XG4gICAgcGFyc2VGaWxlSGVhZGVyKGluZGV4KTtcblxuICAgIC8vIFBhcnNlIGh1bmtzXG4gICAgaW5kZXguaHVua3MgPSBbXTtcblxuICAgIHdoaWxlIChpIDwgZGlmZnN0ci5sZW5ndGgpIHtcbiAgICAgIGxldCBsaW5lID0gZGlmZnN0cltpXTtcblxuICAgICAgaWYgKC9eKEluZGV4OnxkaWZmfFxcLVxcLVxcLXxcXCtcXCtcXCspXFxzLy50ZXN0KGxpbmUpKSB7XG4gICAgICAgIGJyZWFrO1xuICAgICAgfSBlbHNlIGlmICgvXkBALy50ZXN0KGxpbmUpKSB7XG4gICAgICAgIGluZGV4Lmh1bmtzLnB1c2gocGFyc2VIdW5rKCkpO1xuICAgICAgfSBlbHNlIGlmIChsaW5lICYmIG9wdGlvbnMuc3RyaWN0KSB7XG4gICAgICAgIC8vIElnbm9yZSB1bmV4cGVjdGVkIGNvbnRlbnQgdW5sZXNzIGluIHN0cmljdCBtb2RlXG4gICAgICAgIHRocm93IG5ldyBFcnJvcignVW5rbm93biBsaW5lICcgKyAoaSArIDEpICsgJyAnICsgSlNPTi5zdHJpbmdpZnkobGluZSkpO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgaSsrO1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIC8vIFBhcnNlcyB0aGUgLS0tIGFuZCArKysgaGVhZGVycywgaWYgbm9uZSBhcmUgZm91bmQsIG5vIGxpbmVzXG4gIC8vIGFyZSBjb25zdW1lZC5cbiAgZnVuY3Rpb24gcGFyc2VGaWxlSGVhZGVyKGluZGV4KSB7XG4gICAgY29uc3QgaGVhZGVyUGF0dGVybiA9IC9eKC0tLXxcXCtcXCtcXCspXFxzKyhbXFxTIF0qKSg/OlxcdCguKj8pXFxzKik/JC87XG4gICAgY29uc3QgZmlsZUhlYWRlciA9IGhlYWRlclBhdHRlcm4uZXhlYyhkaWZmc3RyW2ldKTtcbiAgICBpZiAoZmlsZUhlYWRlcikge1xuICAgICAgbGV0IGtleVByZWZpeCA9IGZpbGVIZWFkZXJbMV0gPT09ICctLS0nID8gJ29sZCcgOiAnbmV3JztcbiAgICAgIGluZGV4W2tleVByZWZpeCArICdGaWxlTmFtZSddID0gZmlsZUhlYWRlclsyXTtcbiAgICAgIGluZGV4W2tleVByZWZpeCArICdIZWFkZXInXSA9IGZpbGVIZWFkZXJbM107XG5cbiAgICAgIGkrKztcbiAgICB9XG4gIH1cblxuICAvLyBQYXJzZXMgYSBodW5rXG4gIC8vIFRoaXMgYXNzdW1lcyB0aGF0IHdlIGFyZSBhdCB0aGUgc3RhcnQgb2YgYSBodW5rLlxuICBmdW5jdGlvbiBwYXJzZUh1bmsoKSB7XG4gICAgbGV0IGNodW5rSGVhZGVySW5kZXggPSBpLFxuICAgICAgICBjaHVua0hlYWRlckxpbmUgPSBkaWZmc3RyW2krK10sXG4gICAgICAgIGNodW5rSGVhZGVyID0gY2h1bmtIZWFkZXJMaW5lLnNwbGl0KC9AQCAtKFxcZCspKD86LChcXGQrKSk/IFxcKyhcXGQrKSg/OiwoXFxkKykpPyBAQC8pO1xuXG4gICAgbGV0IGh1bmsgPSB7XG4gICAgICBvbGRTdGFydDogK2NodW5rSGVhZGVyWzFdLFxuICAgICAgb2xkTGluZXM6ICtjaHVua0hlYWRlclsyXSB8fCAxLFxuICAgICAgbmV3U3RhcnQ6ICtjaHVua0hlYWRlclszXSxcbiAgICAgIG5ld0xpbmVzOiArY2h1bmtIZWFkZXJbNF0gfHwgMSxcbiAgICAgIGxpbmVzOiBbXSxcbiAgICAgIGxpbmVkZWxpbWl0ZXJzOiBbXVxuICAgIH07XG5cbiAgICBsZXQgYWRkQ291bnQgPSAwLFxuICAgICAgICByZW1vdmVDb3VudCA9IDA7XG4gICAgZm9yICg7IGkgPCBkaWZmc3RyLmxlbmd0aDsgaSsrKSB7XG4gICAgICAvLyBMaW5lcyBzdGFydGluZyB3aXRoICctLS0nIGNvdWxkIGJlIG1pc3Rha2VuIGZvciB0aGUgXCJyZW1vdmUgbGluZVwiIG9wZXJhdGlvblxuICAgICAgLy8gQnV0IHRoZXkgY291bGQgYmUgdGhlIGhlYWRlciBmb3IgdGhlIG5leHQgZmlsZS4gVGhlcmVmb3JlIHBydW5lIHN1Y2ggY2FzZXMgb3V0LlxuICAgICAgaWYgKGRpZmZzdHJbaV0uaW5kZXhPZignLS0tICcpID09PSAwXG4gICAgICAgICAgICAmJiAoaSArIDIgPCBkaWZmc3RyLmxlbmd0aClcbiAgICAgICAgICAgICYmIGRpZmZzdHJbaSArIDFdLmluZGV4T2YoJysrKyAnKSA9PT0gMFxuICAgICAgICAgICAgJiYgZGlmZnN0cltpICsgMl0uaW5kZXhPZignQEAnKSA9PT0gMCkge1xuICAgICAgICAgIGJyZWFrO1xuICAgICAgfVxuICAgICAgbGV0IG9wZXJhdGlvbiA9IGRpZmZzdHJbaV1bMF07XG5cbiAgICAgIGlmIChvcGVyYXRpb24gPT09ICcrJyB8fCBvcGVyYXRpb24gPT09ICctJyB8fCBvcGVyYXRpb24gPT09ICcgJyB8fCBvcGVyYXRpb24gPT09ICdcXFxcJykge1xuICAgICAgICBodW5rLmxpbmVzLnB1c2goZGlmZnN0cltpXSk7XG4gICAgICAgIGh1bmsubGluZWRlbGltaXRlcnMucHVzaChkZWxpbWl0ZXJzW2ldIHx8ICdcXG4nKTtcblxuICAgICAgICBpZiAob3BlcmF0aW9uID09PSAnKycpIHtcbiAgICAgICAgICBhZGRDb3VudCsrO1xuICAgICAgICB9IGVsc2UgaWYgKG9wZXJhdGlvbiA9PT0gJy0nKSB7XG4gICAgICAgICAgcmVtb3ZlQ291bnQrKztcbiAgICAgICAgfSBlbHNlIGlmIChvcGVyYXRpb24gPT09ICcgJykge1xuICAgICAgICAgIGFkZENvdW50Kys7XG4gICAgICAgICAgcmVtb3ZlQ291bnQrKztcbiAgICAgICAgfVxuICAgICAgfSBlbHNlIHtcbiAgICAgICAgYnJlYWs7XG4gICAgICB9XG4gICAgfVxuXG4gICAgLy8gSGFuZGxlIHRoZSBlbXB0eSBibG9jayBjb3VudCBjYXNlXG4gICAgaWYgKCFhZGRDb3VudCAmJiBodW5rLm5ld0xpbmVzID09PSAxKSB7XG4gICAgICBodW5rLm5ld0xpbmVzID0gMDtcbiAgICB9XG4gICAgaWYgKCFyZW1vdmVDb3VudCAmJiBodW5rLm9sZExpbmVzID09PSAxKSB7XG4gICAgICBodW5rLm9sZExpbmVzID0gMDtcbiAgICB9XG5cbiAgICAvLyBQZXJmb3JtIG9wdGlvbmFsIHNhbml0eSBjaGVja2luZ1xuICAgIGlmIChvcHRpb25zLnN0cmljdCkge1xuICAgICAgaWYgKGFkZENvdW50ICE9PSBodW5rLm5ld0xpbmVzKSB7XG4gICAgICAgIHRocm93IG5ldyBFcnJvcignQWRkZWQgbGluZSBjb3VudCBkaWQgbm90IG1hdGNoIGZvciBodW5rIGF0IGxpbmUgJyArIChjaHVua0hlYWRlckluZGV4ICsgMSkpO1xuICAgICAgfVxuICAgICAgaWYgKHJlbW92ZUNvdW50ICE9PSBodW5rLm9sZExpbmVzKSB7XG4gICAgICAgIHRocm93IG5ldyBFcnJvcignUmVtb3ZlZCBsaW5lIGNvdW50IGRpZCBub3QgbWF0Y2ggZm9yIGh1bmsgYXQgbGluZSAnICsgKGNodW5rSGVhZGVySW5kZXggKyAxKSk7XG4gICAgICB9XG4gICAgfVxuXG4gICAgcmV0dXJuIGh1bms7XG4gIH1cblxuICB3aGlsZSAoaSA8IGRpZmZzdHIubGVuZ3RoKSB7XG4gICAgcGFyc2VJbmRleCgpO1xuICB9XG5cbiAgcmV0dXJuIGxpc3Q7XG59XG4iXX0=


/***/ }),
/* 1862 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/"use strict";
	
	exports.__esModule = true;
	
	exports["default"] = /*istanbul ignore end*/function (start, minLine, maxLine) {
	  var wantForward = true,
	      backwardExhausted = false,
	      forwardExhausted = false,
	      localOffset = 1;
	
	  return function iterator() {
	    if (wantForward && !forwardExhausted) {
	      if (backwardExhausted) {
	        localOffset++;
	      } else {
	        wantForward = false;
	      }
	
	      // Check if trying to fit beyond text length, and if not, check it fits
	      // after offset location (or desired location on first iteration)
	      if (start + localOffset <= maxLine) {
	        return localOffset;
	      }
	
	      forwardExhausted = true;
	    }
	
	    if (!backwardExhausted) {
	      if (!forwardExhausted) {
	        wantForward = true;
	      }
	
	      // Check if trying to fit before text beginning, and if not, check it fits
	      // before offset location
	      if (minLine <= start - localOffset) {
	        return -localOffset++;
	      }
	
	      backwardExhausted = true;
	      return iterator();
	    }
	
	    // We tried to fit hunk before text beginning and beyond text lenght, then
	    // hunk can't fit on the text. Return undefined
	  };
	};
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/structuredPatch = structuredPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createTwoFilesPatch = createTwoFilesPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createPatch = createPatch;
	
	var /*istanbul ignore start*/_line = __webpack_require__(1855) /*istanbul ignore end*/;
	
	/*istanbul ignore start*/
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/*istanbul ignore end*/function structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
	  if (!options) {
	    options = {};
	  }
	  if (typeof options.context === 'undefined') {
	    options.context = 4;
	  }
	
	  var diff = /*istanbul ignore start*/(0, _line.diffLines) /*istanbul ignore end*/(oldStr, newStr, options);
	  diff.push({ value: '', lines: [] }); // Append an empty value to make cleanup easier
	
	  function contextLines(lines) {
	    return lines.map(function (entry) {
	      return ' ' + entry;
	    });
	  }
	
	  var hunks = [];
	  var oldRangeStart = 0,
	      newRangeStart = 0,
	      curRange = [],
	      oldLine = 1,
	      newLine = 1;
	  /*istanbul ignore start*/
	  var _loop = function _loop( /*istanbul ignore end*/i) {
	    var current = diff[i],
	        lines = current.lines || current.value.replace(/\n$/, '').split('\n');
	    current.lines = lines;
	
	    if (current.added || current.removed) {
	      /*istanbul ignore start*/
	      var _curRange;
	
	      /*istanbul ignore end*/
	      // If we have previous context, start with that
	      if (!oldRangeStart) {
	        var prev = diff[i - 1];
	        oldRangeStart = oldLine;
	        newRangeStart = newLine;
	
	        if (prev) {
	          curRange = options.context > 0 ? contextLines(prev.lines.slice(-options.context)) : [];
	          oldRangeStart -= curRange.length;
	          newRangeStart -= curRange.length;
	        }
	      }
	
	      // Output our changes
	      /*istanbul ignore start*/(_curRange = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/lines.map(function (entry) {
	        return (current.added ? '+' : '-') + entry;
	      })));
	
	      // Track the updated file position
	      if (current.added) {
	        newLine += lines.length;
	      } else {
	        oldLine += lines.length;
	      }
	    } else {
	      // Identical context lines. Track line changes
	      if (oldRangeStart) {
	        // Close out any changes that have been output (or join overlapping)
	        if (lines.length <= options.context * 2 && i < diff.length - 2) {
	          /*istanbul ignore start*/
	          var _curRange2;
	
	          /*istanbul ignore end*/
	          // Overlapping
	          /*istanbul ignore start*/(_curRange2 = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange2 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/contextLines(lines)));
	        } else {
	          /*istanbul ignore start*/
	          var _curRange3;
	
	          /*istanbul ignore end*/
	          // end the range and output
	          var contextSize = Math.min(lines.length, options.context);
	          /*istanbul ignore start*/(_curRange3 = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange3 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/contextLines(lines.slice(0, contextSize))));
	
	          var hunk = {
	            oldStart: oldRangeStart,
	            oldLines: oldLine - oldRangeStart + contextSize,
	            newStart: newRangeStart,
	            newLines: newLine - newRangeStart + contextSize,
	            lines: curRange
	          };
	          if (i >= diff.length - 2 && lines.length <= options.context) {
	            // EOF is inside this hunk
	            var oldEOFNewline = /\n$/.test(oldStr);
	            var newEOFNewline = /\n$/.test(newStr);
	            if (lines.length == 0 && !oldEOFNewline) {
	              // special case: old has no eol and no trailing context; no-nl can end up before adds
	              curRange.splice(hunk.oldLines, 0, '\\ No newline at end of file');
	            } else if (!oldEOFNewline || !newEOFNewline) {
	              curRange.push('\\ No newline at end of file');
	            }
	          }
	          hunks.push(hunk);
	
	          oldRangeStart = 0;
	          newRangeStart = 0;
	          curRange = [];
	        }
	      }
	      oldLine += lines.length;
	      newLine += lines.length;
	    }
	  };
	
	  for (var i = 0; i < diff.length; i++) {
	    /*istanbul ignore start*/
	    _loop( /*istanbul ignore end*/i);
	  }
	
	  return {
	    oldFileName: oldFileName, newFileName: newFileName,
	    oldHeader: oldHeader, newHeader: newHeader,
	    hunks: hunks
	  };
	}
	
	function createTwoFilesPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
	  var diff = structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options);
	
	  var ret = [];
	  if (oldFileName == newFileName) {
	    ret.push('Index: ' + oldFileName);
	  }
	  ret.push('===================================================================');
	  ret.push('--- ' + diff.oldFileName + (typeof diff.oldHeader === 'undefined' ? '' : '\t' + diff.oldHeader));
	  ret.push('+++ ' + diff.newFileName + (typeof diff.newHeader === 'undefined' ? '' : '\t' + diff.newHeader));
	
	  for (var i = 0; i < diff.hunks.length; i++) {
	    var hunk = diff.hunks[i];
	    ret.push('@@ -' + hunk.oldStart + ',' + hunk.oldLines + ' +' + hunk.newStart + ',' + hunk.newLines + ' @@');
	    ret.push.apply(ret, hunk.lines);
	  }
	
	  return ret.join('\n') + '\n';
	}
	
	function createPatch(fileName, oldStr, newStr, oldHeader, newHeader, options) {
	  return createTwoFilesPatch(fileName, fileName, oldStr, newStr, oldHeader, newHeader, options);
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 1864 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/"use strict";
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/convertChangesToDMP = convertChangesToDMP;
	// See: http://code.google.com/p/google-diff-match-patch/wiki/API
	function convertChangesToDMP(changes) {
	  var ret = [],
	      change = /*istanbul ignore start*/void 0 /*istanbul ignore end*/,
	      operation = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	  for (var i = 0; i < changes.length; i++) {
	    change = changes[i];
	    if (change.added) {
	      operation = 1;
	    } else if (change.removed) {
	      operation = -1;
	    } else {
	      operation = 0;
	    }
	
	    ret.push([operation, change.value]);
	  }
	  return ret;
	}
	//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb252ZXJ0L2RtcC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Z0NBQ2dCLG1CLEdBQUEsbUI7O0FBQVQsU0FBUyxtQkFBVCxDQUE2QixPQUE3QixFQUFzQztBQUMzQyxNQUFJLE1BQU0sRUFBVjtBQUFBLE1BQ0ksUyx5QkFBQSxNLHdCQURKO0FBQUEsTUFFSSxZLHlCQUFBLE0sd0JBRko7QUFHQSxPQUFLLElBQUksSUFBSSxDQUFiLEVBQWdCLElBQUksUUFBUSxNQUE1QixFQUFvQyxHQUFwQyxFQUF5QztBQUN2QyxhQUFTLFFBQVEsQ0FBUixDQUFUO0FBQ0EsUUFBSSxPQUFPLEtBQVgsRUFBa0I7QUFDaEIsa0JBQVksQ0FBWjtBQUNELEtBRkQsTUFFTyxJQUFJLE9BQU8sT0FBWCxFQUFvQjtBQUN6QixrQkFBWSxDQUFDLENBQWI7QUFDRCxLQUZNLE1BRUE7QUFDTCxrQkFBWSxDQUFaO0FBQ0Q7O0FBRUQsUUFBSSxJQUFKLENBQVMsQ0FBQyxTQUFELEVBQVksT0FBTyxLQUFuQixDQUFUO0FBQ0Q7QUFDRCxTQUFPLEdBQVA7QUFDRCIsImZpbGUiOiJkbXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBTZWU6IGh0dHA6Ly9jb2RlLmdvb2dsZS5jb20vcC9nb29nbGUtZGlmZi1tYXRjaC1wYXRjaC93aWtpL0FQSVxuZXhwb3J0IGZ1bmN0aW9uIGNvbnZlcnRDaGFuZ2VzVG9ETVAoY2hhbmdlcykge1xuICBsZXQgcmV0ID0gW10sXG4gICAgICBjaGFuZ2UsXG4gICAgICBvcGVyYXRpb247XG4gIGZvciAobGV0IGkgPSAwOyBpIDwgY2hhbmdlcy5sZW5ndGg7IGkrKykge1xuICAgIGNoYW5nZSA9IGNoYW5nZXNbaV07XG4gICAgaWYgKGNoYW5nZS5hZGRlZCkge1xuICAgICAgb3BlcmF0aW9uID0gMTtcbiAgICB9IGVsc2UgaWYgKGNoYW5nZS5yZW1vdmVkKSB7XG4gICAgICBvcGVyYXRpb24gPSAtMTtcbiAgICB9IGVsc2Uge1xuICAgICAgb3BlcmF0aW9uID0gMDtcbiAgICB9XG5cbiAgICByZXQucHVzaChbb3BlcmF0aW9uLCBjaGFuZ2UudmFsdWVdKTtcbiAgfVxuICByZXR1cm4gcmV0O1xufVxuIl19


/***/ }),
/* 1865 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/'use strict';
	
	exports.__esModule = true;
	exports. /*istanbul ignore end*/convertChangesToXML = convertChangesToXML;
	function convertChangesToXML(changes) {
	  var ret = [];
	  for (var i = 0; i < changes.length; i++) {
	    var change = changes[i];
	    if (change.added) {
	      ret.push('<ins>');
	    } else if (change.removed) {
	      ret.push('<del>');
	    }
	
	    ret.push(escapeHTML(change.value));
	
	    if (change.added) {
	      ret.push('</ins>');
	    } else if (change.removed) {
	      ret.push('</del>');
	    }
	  }
	  return ret.join('');
	}
	
	function escapeHTML(s) {
	  var n = s;
	  n = n.replace(/&/g, '&amp;');
	  n = n.replace(/</g, '&lt;');
	  n = n.replace(/>/g, '&gt;');
	  n = n.replace(/"/g, '&quot;');
	
	  return n;
	}
	//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _FilterList = __webpack_require__(983);
	
	var _FilterList2 = _interopRequireDefault(_FilterList);
	
	var _AggregationWidget = __webpack_require__(1005);
	
	var _AggregationWidget2 = _interopRequireDefault(_AggregationWidget);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QueryDiff = (_temp = _class = function (_Component) {
	    _inherits(QueryDiff, _Component);
	
	    function QueryDiff() {
	        _classCallCheck(this, QueryDiff);
	
	        return _possibleConstructorReturn(this, (QueryDiff.__proto__ || Object.getPrototypeOf(QueryDiff)).apply(this, arguments));
	    }
	
	    _createClass(QueryDiff, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                _props$diff = _props.diff,
	                before = _props$diff.before,
	                after = _props$diff.after,
	                tableMetadata = _props.tableMetadata;
	
	            var defintion = after || before;
	
	            var filters = _query2.default.getFilters(defintion);
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: !tableMetadata },
	                function () {
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "my1", style: { pointerEvents: "none" } },
	                        defintion.aggregation && _react2.default.createElement(_AggregationWidget2.default, {
	                            aggregation: defintion.aggregation,
	                            tableMetadata: tableMetadata
	                        }),
	                        filters.length > 0 && _react2.default.createElement(_FilterList2.default, {
	                            filters: filters,
	                            tableMetadata: tableMetadata,
	                            maxDisplayValues: Infinity
	                        })
	                    );
	                }
	            );
	        }
	    }]);
	
	    return QueryDiff;
	}(_react.Component), _class.propTypes = {
	    diff: _propTypes2.default.object.isRequired,
	    tableMetadata: _propTypes2.default.object.isRequired
	}, _temp);
	QueryDiff.displayName = "QueryDiff";
	exports.default = QueryDiff;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LeftNavPane = __webpack_require__(1868);
	
	var _AdminLayout = __webpack_require__(1869);
	
	var _AdminLayout2 = _interopRequireDefault(_AdminLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminPeopleApp = (_temp = _class = function (_Component) {
	    _inherits(AdminPeopleApp, _Component);
	
	    function AdminPeopleApp() {
	        _classCallCheck(this, AdminPeopleApp);
	
	        return _possibleConstructorReturn(this, (AdminPeopleApp.__proto__ || Object.getPrototypeOf(AdminPeopleApp)).apply(this, arguments));
	    }
	
	    _createClass(AdminPeopleApp, [{
	        key: "render",
	        value: function render() {
	            var children = this.props.children;
	
	            return _react2.default.createElement(
	                _AdminLayout2.default,
	                {
	                    sidebar: _react2.default.createElement(
	                        _LeftNavPane.LeftNavPane,
	                        null,
	                        _react2.default.createElement(_LeftNavPane.LeftNavPaneItem, { name: "People", path: "/admin/people", index: true }),
	                        _react2.default.createElement(_LeftNavPane.LeftNavPaneItem, { name: "Groups", path: "/admin/people/groups" })
	                    )
	                },
	                children
	            );
	        }
	    }]);
	
	    return AdminPeopleApp;
	}(_react.Component), _class.propTypes = {
	    children: _propTypes2.default.any
	}, _temp);
	AdminPeopleApp.displayName = "AdminPeopleApp";
	exports.default = AdminPeopleApp;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LeftNavPaneItem = LeftNavPaneItem;
	exports.LeftNavPaneItemBack = LeftNavPaneItemBack;
	exports.LeftNavPane = LeftNavPane;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LeftNavPaneItem(_ref) {
	    var name = _ref.name,
	        path = _ref.path,
	        _ref$index = _ref.index,
	        index = _ref$index === undefined ? false : _ref$index;
	
	    return _react2.default.createElement(
	        "li",
	        null,
	        index ? _react2.default.createElement(
	            _reactRouter.IndexLink,
	            { to: path, className: "AdminList-item flex align-center justify-between no-decoration", activeClassName: "selected" },
	            name
	        ) : _react2.default.createElement(
	            _reactRouter.Link,
	            { to: path, className: "AdminList-item flex align-center justify-between no-decoration", activeClassName: "selected" },
	            name
	        )
	    );
	}
	
	LeftNavPaneItem.displayName = "LeftNavPaneItem";
	function LeftNavPaneItemBack(_ref2) {
	    var path = _ref2.path;
	
	    return _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	            _reactRouter.Link,
	            { to: path, className: "AdminList-item flex align-center justify-between no-decoration link text-bold" },
	            "< Back"
	        )
	    );
	}
	
	LeftNavPaneItemBack.displayName = "LeftNavPaneItemBack";
	function LeftNavPane(_ref3) {
	    var children = _ref3.children;
	
	    return _react2.default.createElement(
	        "div",
	        { className: "MetadataEditor-table-list AdminList flex-no-shrink full-height" },
	        _react2.default.createElement(
	            "ul",
	            { className: "AdminList-items pt1" },
	            children
	        )
	    );
	}
	LeftNavPane.displayName = "LeftNavPane";

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdminHeader = __webpack_require__(1870);
	
	var _AdminHeader2 = _interopRequireDefault(_AdminHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminLayout = function (_Component) {
	    _inherits(AdminLayout, _Component);
	
	    function AdminLayout() {
	        _classCallCheck(this, AdminLayout);
	
	        return _possibleConstructorReturn(this, (AdminLayout.__proto__ || Object.getPrototypeOf(AdminLayout)).apply(this, arguments));
	    }
	
	    _createClass(AdminLayout, [{
	        key: "setSaving",
	        value: function setSaving() {
	            this.refs.header.refs.status.setSaving();
	        }
	    }, {
	        key: "setSaved",
	        value: function setSaved() {
	            this.refs.header.refs.status.setSaved();
	        }
	    }, {
	        key: "setSaveError",
	        value: function setSaveError(error) {
	            this.refs.header.refs.status.setSaveError(error);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                title = _props.title,
	                sidebar = _props.sidebar,
	                children = _props.children;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "MetadataEditor full-height flex flex-column flex-full p4" },
	                _react2.default.createElement(_AdminHeader2.default, { ref: "header", title: title }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "MetadataEditor-main flex flex-row flex-full mt2" },
	                    sidebar,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "px2 flex-full" },
	                        children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AdminLayout;
	}(_react.Component);
	
	AdminLayout.displayName = "AdminLayout";
	exports.default = AdminLayout;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SaveStatus = __webpack_require__(1819);
	
	var _SaveStatus2 = _interopRequireDefault(_SaveStatus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminHeader = function (_Component) {
	    _inherits(AdminHeader, _Component);
	
	    function AdminHeader() {
	        _classCallCheck(this, AdminHeader);
	
	        return _possibleConstructorReturn(this, (AdminHeader.__proto__ || Object.getPrototypeOf(AdminHeader)).apply(this, arguments));
	    }
	
	    _createClass(AdminHeader, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "MetadataEditor-header clearfix relative flex-no-shrink" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "MetadataEditor-headerSection float-left h2 text-grey-4" },
	                    this.props.title
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "MetadataEditor-headerSection absolute right float-right top bottom flex layout-centered" },
	                    _react2.default.createElement(_SaveStatus2.default, { ref: "status" })
	                )
	            );
	        }
	    }]);
	
	    return AdminHeader;
	}(_react.Component);
	
	AdminHeader.displayName = "AdminHeader";
	exports.default = AdminHeader;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Title = __webpack_require__(1538);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _formatting = __webpack_require__(872);
	
	var _AdminLayout = __webpack_require__(1869);
	
	var _AdminLayout2 = _interopRequireDefault(_AdminLayout);
	
	var _SettingsSetting = __webpack_require__(1872);
	
	var _SettingsSetting2 = _interopRequireDefault(_SettingsSetting);
	
	var _SettingsEmailForm = __webpack_require__(1880);
	
	var _SettingsEmailForm2 = _interopRequireDefault(_SettingsEmailForm);
	
	var _SettingsSlackForm = __webpack_require__(1881);
	
	var _SettingsSlackForm2 = _interopRequireDefault(_SettingsSlackForm);
	
	var _SettingsLdapForm = __webpack_require__(1882);
	
	var _SettingsLdapForm2 = _interopRequireDefault(_SettingsLdapForm);
	
	var _SettingsSetupList = __webpack_require__(1890);
	
	var _SettingsSetupList2 = _interopRequireDefault(_SettingsSetupList);
	
	var _SettingsUpdatesForm = __webpack_require__(1891);
	
	var _SettingsUpdatesForm2 = _interopRequireDefault(_SettingsUpdatesForm);
	
	var _SettingsSingleSignOnForm = __webpack_require__(1892);
	
	var _SettingsSingleSignOnForm2 = _interopRequireDefault(_SettingsSingleSignOnForm);
	
	var _SettingsAuthenticationOptions = __webpack_require__(1893);
	
	var _SettingsAuthenticationOptions2 = _interopRequireDefault(_SettingsAuthenticationOptions);
	
	var _SettingsXrayForm = __webpack_require__(1894);
	
	var _SettingsXrayForm2 = _interopRequireDefault(_SettingsXrayForm);
	
	var _utils = __webpack_require__(1896);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _selectors = __webpack_require__(1897);
	
	var _settings = __webpack_require__(1906);
	
	var settingsActions = _interopRequireWildcard(_settings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        settings: (0, _selectors.getSettings)(state, props),
	        settingValues: (0, _selectors.getSettingValues)(state, props),
	        sections: (0, _selectors.getSections)(state, props),
	        activeSection: (0, _selectors.getActiveSection)(state, props),
	        newVersionAvailable: (0, _selectors.getNewVersionAvailable)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, settingsActions);
	
	var SettingsEditorApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _Title2.default)(function (_ref) {
	    var activeSection = _ref.activeSection;
	    return activeSection && activeSection.name;
	}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	    _inherits(SettingsEditorApp, _Component);
	
	    function SettingsEditorApp() {
	        var _ref2,
	            _this2 = this;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SettingsEditorApp);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SettingsEditorApp.__proto__ || Object.getPrototypeOf(SettingsEditorApp)).call.apply(_ref2, [this].concat(args))), _this), _this.updateSetting = function () {
	            var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(setting, newValue) {
	                var _this$props, settings, settingValues, updateSetting, oldValue, value, message;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _this$props = _this.props, settings = _this$props.settings, settingValues = _this$props.settingValues, updateSetting = _this$props.updateSetting;
	
	
	                                _this.refs.layout.setSaving();
	
	                                oldValue = setting.value;
	
	                                // TODO: mutation bad!
	
	                                setting.value = newValue;
	                                _context.prev = 4;
	                                _context.next = 7;
	                                return updateSetting(setting);
	
	                            case 7:
	                                if (!setting.onChanged) {
	                                    _context.next = 10;
	                                    break;
	                                }
	
	                                _context.next = 10;
	                                return setting.onChanged(oldValue, newValue, settingValues, function (key, value) {
	                                    var setting = _underscore2.default.findWhere(settings, { key: key });
	                                    if (!setting) {
	                                        throw new Error("Unknown setting " + key);
	                                    }
	                                    setting.value = value;
	                                    return updateSetting(setting);
	                                });
	
	                            case 10:
	
	                                _this.refs.layout.setSaved();
	
	                                value = (0, _utils.prepareAnalyticsValue)(setting);
	
	
	                                _analytics2.default.trackEvent("General Settings", setting.display_name || setting.key, value,
	                                // pass the actual value if it's a number
	                                typeof value === 'number' && value);
	                                _context.next = 20;
	                                break;
	
	                            case 15:
	                                _context.prev = 15;
	                                _context.t0 = _context["catch"](4);
	                                message = _context.t0 && (_context.t0.message || _context.t0.data && _context.t0.data.message);
	
	                                _this.refs.layout.setSaveError(message);
	                                _analytics2.default.trackEvent("General Settings", setting.display_name, "error");
	
	                            case 20:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2, [[4, 15]]);
	            }));
	
	            return function (_x, _x2) {
	                return _ref3.apply(this, arguments);
	            };
	        }(), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SettingsEditorApp, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.initializeSettings();
	        }
	    }, {
	        key: "renderSettingsPane",
	        value: function renderSettingsPane() {
	            var _this3 = this;
	
	            var _props = this.props,
	                activeSection = _props.activeSection,
	                settingValues = _props.settingValues;
	
	
	            if (!activeSection) {
	                return null;
	            }
	
	            if (activeSection.name === "Email") {
	                return _react2.default.createElement(_SettingsEmailForm2.default, {
	                    ref: "emailForm",
	                    elements: activeSection.settings,
	                    updateEmailSettings: this.props.updateEmailSettings,
	                    sendTestEmail: this.props.sendTestEmail
	                });
	            } else if (activeSection.name === "Setup") {
	                return _react2.default.createElement(_SettingsSetupList2.default, {
	                    ref: "settingsForm"
	                });
	            } else if (activeSection.name === "Slack") {
	                return _react2.default.createElement(_SettingsSlackForm2.default, {
	                    ref: "slackForm",
	                    elements: activeSection.settings,
	                    updateSlackSettings: this.props.updateSlackSettings
	                });
	            } else if (activeSection.name === "Updates") {
	                return _react2.default.createElement(_SettingsUpdatesForm2.default, {
	                    settings: this.props.settings,
	                    elements: activeSection.settings,
	                    updateSetting: this.updateSetting
	                });
	            } else if (activeSection.name === "Authentication") {
	                // HACK - the presence of this param is a way for us to tell if
	                // a user is looking at a sub section of the autentication section
	                // since allowing for multi page settings more broadly would require
	                // a fairly significant refactor of how settings does its routing logic
	                if (this.props.params.authType) {
	                    if (this.props.params.authType === 'ldap') {
	                        return _react2.default.createElement(_SettingsLdapForm2.default, {
	                            elements: _underscore2.default.findWhere(this.props.sections, { slug: 'ldap' }).settings,
	                            updateLdapSettings: this.props.updateLdapSettings
	                        });
	                    } else if (this.props.params.authType === 'google') {
	                        return _react2.default.createElement(_SettingsSingleSignOnForm2.default, {
	                            elements: _underscore2.default.findWhere(this.props.sections, { slug: (0, _formatting.slugify)('Single Sign-On') }).settings,
	                            updateSetting: this.updateSetting
	                        });
	                    }
	                } else {
	                    return _react2.default.createElement(_SettingsAuthenticationOptions2.default, null);
	                }
	            } else if (activeSection.name === "X-Rays") {
	                return _react2.default.createElement(_SettingsXrayForm2.default, {
	                    settings: this.props.settings,
	                    elements: activeSection.settings,
	                    updateSetting: this.updateSetting.bind(this)
	                });
	            } else {
	                return _react2.default.createElement(
	                    "ul",
	                    null,
	                    activeSection.settings.filter(function (setting) {
	                        return setting.getHidden ? !setting.getHidden(settingValues) : true;
	                    }).map(function (setting, index) {
	                        return _react2.default.createElement(_SettingsSetting2.default, {
	                            key: setting.key,
	                            setting: setting,
	                            updateSetting: _this3.updateSetting.bind(_this3, setting),
	                            reloadSettings: _this3.props.reloadSettings,
	                            autoFocus: index === 0,
	                            settingValues: settingValues
	                        });
	                    })
	                );
	            }
	        }
	    }, {
	        key: "renderSettingsSections",
	        value: function renderSettingsSections() {
	            var _props2 = this.props,
	                sections = _props2.sections,
	                activeSection = _props2.activeSection,
	                newVersionAvailable = _props2.newVersionAvailable;
	
	
	            var renderedSections = _underscore2.default.map(sections, function (section, idx) {
	
	                // HACK - This is used to hide specific items in the sidebar and is currently
	                // only used as a way to fake the multi page auth settings pages without
	                // requiring a larger refactor.
	                if (section.sidebar === false) {
	                    return false;
	                }
	                var classes = (0, _classnames2.default)("AdminList-item", "flex", "align-center", "justify-between", "no-decoration", {
	                    "selected": activeSection && section.name === activeSection.name // this.state.currentSection === idx
	                });
	
	                // if this is the Updates section && there is a new version then lets add a little indicator
	                var newVersionIndicator = void 0;
	                if (section.name === "Updates" && newVersionAvailable) {
	                    newVersionIndicator = _react2.default.createElement(
	                        "span",
	                        { style: { padding: "4px 8px 4px 8px" }, className: "bg-brand rounded text-white text-bold h6" },
	                        "1"
	                    );
	                }
	
	                return _react2.default.createElement(
	                    "li",
	                    { key: section.name },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: "/admin/settings/" + section.slug, className: classes },
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            section.name
	                        ),
	                        newVersionIndicator
	                    )
	                );
	            });
	
	            return _react2.default.createElement(
	                "div",
	                { className: "MetadataEditor-table-list AdminList flex-no-shrink" },
	                _react2.default.createElement(
	                    "ul",
	                    { className: "AdminList-items pt1" },
	                    renderedSections
	                )
	            );
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _AdminLayout2.default,
	                {
	                    ref: "layout",
	                    title: "Settings",
	                    sidebar: this.renderSettingsSections()
	                },
	                this.renderSettingsPane()
	            );
	        }
	    }]);
	
	    return SettingsEditorApp;
	}(_react.Component), _class2.propTypes = {
	    sections: _propTypes2.default.array.isRequired,
	    activeSection: _propTypes2.default.object,
	    updateSetting: _propTypes2.default.func.isRequired,
	    updateEmailSettings: _propTypes2.default.func.isRequired,
	    updateSlackSettings: _propTypes2.default.func.isRequired,
	    updateLdapSettings: _propTypes2.default.func.isRequired,
	    sendTestEmail: _propTypes2.default.func.isRequired
	}, _temp2)) || _class) || _class);
	SettingsEditorApp.displayName = "SettingsEditorApp";
	exports.default = SettingsEditorApp;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _icepick = __webpack_require__(855);
	
	var _SettingHeader = __webpack_require__(1873);
	
	var _SettingHeader2 = _interopRequireDefault(_SettingHeader);
	
	var _SettingInput = __webpack_require__(1874);
	
	var _SettingInput2 = _interopRequireDefault(_SettingInput);
	
	var _SettingNumber = __webpack_require__(1875);
	
	var _SettingNumber2 = _interopRequireDefault(_SettingNumber);
	
	var _SettingPassword = __webpack_require__(1876);
	
	var _SettingPassword2 = _interopRequireDefault(_SettingPassword);
	
	var _SettingRadio = __webpack_require__(1877);
	
	var _SettingRadio2 = _interopRequireDefault(_SettingRadio);
	
	var _SettingToggle = __webpack_require__(1878);
	
	var _SettingToggle2 = _interopRequireDefault(_SettingToggle);
	
	var _SettingSelect = __webpack_require__(1879);
	
	var _SettingSelect2 = _interopRequireDefault(_SettingSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SETTING_WIDGET_MAP = {
	    "string": _SettingInput2.default,
	    "number": _SettingNumber2.default,
	    "password": _SettingPassword2.default,
	    "select": _SettingSelect2.default,
	    "radio": _SettingRadio2.default,
	    "boolean": _SettingToggle2.default
	};
	
	var updatePlaceholderForEnvironmentVars = function updatePlaceholderForEnvironmentVars(props) {
	    if (props && props.setting && props.setting.is_env_setting) {
	        return (0, _icepick.assocIn)(props, ["setting", "placeholder"], "Using " + props.setting.env_name);
	    }
	    return props;
	};
	
	var SettingsSetting = (_temp = _class = function (_Component) {
	    _inherits(SettingsSetting, _Component);
	
	    function SettingsSetting() {
	        _classCallCheck(this, SettingsSetting);
	
	        return _possibleConstructorReturn(this, (SettingsSetting.__proto__ || Object.getPrototypeOf(SettingsSetting)).apply(this, arguments));
	    }
	
	    _createClass(SettingsSetting, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                setting = _props.setting,
	                errorMessage = _props.errorMessage;
	
	            var Widget = setting.widget || SETTING_WIDGET_MAP[setting.type];
	            if (!Widget) {
	                console.warn("No render method for setting type " + setting.type + ", defaulting to string input.");
	                Widget = _SettingInput2.default;
	            }
	            return _react2.default.createElement(
	                "li",
	                { className: "m2 mb4" },
	                !setting.noHeader && _react2.default.createElement(_SettingHeader2.default, { setting: setting }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex" },
	                    _react2.default.createElement(Widget, updatePlaceholderForEnvironmentVars(this.props))
	                ),
	                errorMessage && _react2.default.createElement(
	                    "div",
	                    { className: "text-error text-bold pt1" },
	                    errorMessage
	                ),
	                setting.warning && _react2.default.createElement(
	                    "div",
	                    { className: "text-gold text-bold pt1" },
	                    setting.warning
	                )
	            );
	        }
	    }]);
	
	    return SettingsSetting;
	}(_react.Component), _class.propTypes = {
	    setting: _propTypes2.default.object.isRequired,
	    updateSetting: _propTypes2.default.func.isRequired,
	    autoFocus: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool
	}, _temp);
	SettingsSetting.displayName = "SettingsSetting";
	exports.default = SettingsSetting;

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingHeader = function SettingHeader(_ref) {
	    var setting = _ref.setting;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "text-grey-4 text-bold text-uppercase" },
	            setting.display_name
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "text-grey-4 my1" },
	            setting.description,
	            setting.note && _react2.default.createElement(
	                "div",
	                null,
	                setting.note
	            )
	        )
	    );
	};
	
	SettingHeader.displayName = "SettingHeader";
	exports.default = SettingHeader;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingInput = function SettingInput(_ref) {
	    var setting = _ref.setting,
	        updateSetting = _ref.updateSetting,
	        disabled = _ref.disabled,
	        autoFocus = _ref.autoFocus,
	        errorMessage = _ref.errorMessage,
	        fireOnChange = _ref.fireOnChange,
	        _ref$type = _ref.type,
	        type = _ref$type === undefined ? "text" : _ref$type;
	    return _react2.default.createElement(_Input2.default, {
	        className: (0, _classnames2.default)(" AdminInput bordered rounded h3", {
	            "SettingsInput": type !== "password",
	            "SettingsPassword": type === "password",
	            "border-error bg-error-input": errorMessage
	        }),
	        type: type,
	        value: setting.value || "",
	        placeholder: setting.placeholder,
	        onChange: fireOnChange ? function (e) {
	            return updateSetting(e.target.value);
	        } : null,
	        onBlurChange: !fireOnChange ? function (e) {
	            return updateSetting(e.target.value);
	        } : null,
	        autoFocus: autoFocus
	    });
	};
	
	SettingInput.displayName = "SettingInput";
	exports.default = SettingInput;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingInput = __webpack_require__(1874);
	
	var _SettingInput2 = _interopRequireDefault(_SettingInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SettingNumber = function SettingNumber(_ref) {
	    var _ref$type = _ref.type,
	        type = _ref$type === undefined ? "number" : _ref$type,
	        props = _objectWithoutProperties(_ref, ["type"]);
	
	    return _react2.default.createElement(_SettingInput2.default, _extends({}, props, { type: "number" }));
	};
	
	SettingNumber.displayName = "SettingNumber";
	exports.default = SettingNumber;

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingInput = __webpack_require__(1874);
	
	var _SettingInput2 = _interopRequireDefault(_SettingInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingPassword = function SettingPassword(props) {
	    return _react2.default.createElement(_SettingInput2.default, _extends({}, props, { type: "password" }));
	};
	
	SettingPassword.displayName = "SettingPassword";
	exports.default = SettingPassword;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Radio = __webpack_require__(1380);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingRadio = function SettingRadio(_ref) {
	    var setting = _ref.setting,
	        updateSetting = _ref.updateSetting,
	        disabled = _ref.disabled;
	    return _react2.default.createElement(_Radio2.default, {
	        className: (0, _classnames2.default)({ "disabled": disabled }),
	        value: setting.value,
	        onChange: function onChange(value) {
	            return updateSetting(value);
	        },
	        options: Object.entries(setting.options).map(function (_ref2) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                value = _ref3[0],
	                name = _ref3[1];
	
	            return { name: name, value: value };
	        })
	    });
	};
	
	SettingRadio.displayName = "SettingRadio";
	exports.default = SettingRadio;

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Toggle = __webpack_require__(1241);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingToggle = function SettingToggle(_ref) {
	    var setting = _ref.setting,
	        updateSetting = _ref.updateSetting,
	        disabled = _ref.disabled;
	
	    var value = setting.value == null ? setting.default : setting.value;
	    var on = value === true || value === "true";
	    return _react2.default.createElement(
	        "div",
	        { className: "flex align-center pt1" },
	        _react2.default.createElement(_Toggle2.default, { value: on, onChange: !disabled ? function () {
	                return updateSetting(!on);
	            } : null }),
	        _react2.default.createElement(
	            "span",
	            { className: "text-bold mx1" },
	            on ? "Enabled" : "Disabled"
	        )
	    );
	};
	
	SettingToggle.displayName = "SettingToggle";
	exports.default = SettingToggle;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SettingSelect = function SettingSelect(_ref) {
	    var setting = _ref.setting,
	        updateSetting = _ref.updateSetting,
	        disabled = _ref.disabled;
	    return _react2.default.createElement(_Select2.default, {
	        className: "full-width",
	        placeholder: setting.placeholder,
	        value: setting.value,
	        options: setting.options,
	        onChange: updateSetting,
	        optionNameFn: function optionNameFn(option) {
	            return (typeof option === "undefined" ? "undefined" : _typeof(option)) === "object" ? option.name : option;
	        },
	        optionValueFn: function optionValueFn(option) {
	            return (typeof option === "undefined" ? "undefined" : _typeof(option)) === "object" ? option.value : option;
	        }
	    });
	};
	
	SettingSelect.displayName = "SettingSelect";
	exports.default = SettingSelect;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _SettingsSetting = __webpack_require__(1872);
	
	var _SettingsSetting2 = _interopRequireDefault(_SettingsSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsEmailForm = (_temp = _class = function (_Component) {
	    _inherits(SettingsEmailForm, _Component);
	
	    function SettingsEmailForm(props, context) {
	        _classCallCheck(this, SettingsEmailForm);
	
	        var _this = _possibleConstructorReturn(this, (SettingsEmailForm.__proto__ || Object.getPrototypeOf(SettingsEmailForm)).call(this, props, context));
	
	        _this.state = {
	            dirty: false,
	            formData: {},
	            sendingEmail: "default",
	            submitting: "default",
	            valid: false,
	            validationErrors: {}
	        };
	        return _this;
	    }
	
	    _createClass(SettingsEmailForm, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            // this gives us an opportunity to load up our formData with any existing values for elements
	            this.updateFormData(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            this.updateFormData(nextProps);
	        }
	    }, {
	        key: "updateFormData",
	        value: function updateFormData(props) {
	            var formData = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = props.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var element = _step.value;
	
	                    formData[element.key] = element.value;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            this.setState({ formData: formData });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.validateForm();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this.validateForm();
	        }
	    }, {
	        key: "setSubmitting",
	        value: function setSubmitting(submitting) {
	            this.setState({ submitting: submitting });
	        }
	    }, {
	        key: "setSendingEmail",
	        value: function setSendingEmail(sendingEmail) {
	            this.setState({ sendingEmail: sendingEmail });
	        }
	    }, {
	        key: "setFormErrors",
	        value: function setFormErrors(formErrors) {
	            this.setState({ formErrors: formErrors });
	        }
	
	        // return null if element passes validation, otherwise return an error message
	
	    }, {
	        key: "validateElement",
	        value: function validateElement(_ref, value, element) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                validationType = _ref2[0],
	                validationMessage = _ref2[1];
	
	            if (_utils2.default.isEmpty(value)) return;
	
	            switch (validationType) {
	                case "email":
	                    return !_utils2.default.validEmail(value) ? validationMessage || "That's not a valid email address" : null;
	                case "integer":
	                    return isNaN(parseInt(value)) ? validationMessage || "That's not a valid integer" : null;
	            }
	        }
	    }, {
	        key: "validateForm",
	        value: function validateForm() {
	            var elements = this.props.elements;
	            var formData = this.state.formData;
	
	
	            var valid = true,
	                validationErrors = {};
	
	            elements.forEach(function (element) {
	                // test for required elements
	                if (element.required && _utils2.default.isEmpty(formData[element.key])) {
	                    valid = false;
	                }
	
	                if (element.validations) {
	                    element.validations.forEach(function (validation) {
	                        validationErrors[element.key] = this.validateElement(validation, formData[element.key], element);
	                        if (validationErrors[element.key]) valid = false;
	                    }, this);
	                }
	            }, this);
	
	            if (this.state.valid !== valid || !_underscore2.default.isEqual(this.state.validationErrors, validationErrors)) {
	                this.setState({ valid: valid, validationErrors: validationErrors });
	            }
	        }
	    }, {
	        key: "handleChangeEvent",
	        value: function handleChangeEvent(element, value, event) {
	            this.setState({
	                dirty: true,
	                formData: _extends({}, this.state.formData, _defineProperty({}, element.key, _utils2.default.isEmpty(value) ? null : value))
	            });
	        }
	    }, {
	        key: "handleFormErrors",
	        value: function handleFormErrors(error) {
	            // parse and format
	            var formErrors = {};
	            if (error.data && error.data.message) {
	                formErrors.message = error.data.message;
	            } else {
	                formErrors.message = "Looks like we ran into some problems";
	            }
	
	            if (error.data && error.data.errors) {
	                formErrors.elements = error.data.errors;
	            }
	
	            return formErrors;
	        }
	    }, {
	        key: "sendTestEmail",
	        value: function sendTestEmail(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            this.setState({
	                formErrors: null,
	                sendingEmail: "working"
	            });
	
	            this.props.sendTestEmail().then(function () {
	                _this2.setState({ sendingEmail: "success" });
	                _analytics2.default.trackEvent("Email Settings", "Test Email", "success");
	
	                // show a confirmation for 3 seconds, then return to normal
	                setTimeout(function () {
	                    return _this2.setState({ sendingEmail: "default" });
	                }, 3000);
	            }, function (error) {
	                _this2.setState({
	                    sendingEmail: "default",
	                    formErrors: _this2.handleFormErrors(error)
	                });
	                _analytics2.default.trackEvent("Email Settings", "Test Email", "error");
	            });
	        }
	    }, {
	        key: "updateEmailSettings",
	        value: function updateEmailSettings(e) {
	            var _this3 = this;
	
	            e.preventDefault();
	
	            this.setState({
	                formErrors: null,
	                submitting: "working"
	            });
	
	            var _state = this.state,
	                formData = _state.formData,
	                valid = _state.valid;
	
	
	            if (valid) {
	                this.props.updateEmailSettings(formData).then(function () {
	                    _this3.setState({
	                        dirty: false,
	                        submitting: "success"
	                    });
	
	                    _analytics2.default.trackEvent("Email Settings", "Update", "success");
	
	                    // show a confirmation for 3 seconds, then return to normal
	                    setTimeout(function () {
	                        return _this3.setState({ submitting: "default" });
	                    }, 3000);
	                }, function (error) {
	                    _this3.setState({
	                        submitting: "default",
	                        formErrors: _this3.handleFormErrors(error)
	                    });
	
	                    _analytics2.default.trackEvent("Email Settings", "Update", "error");
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var elements = this.props.elements;
	            var _state2 = this.state,
	                dirty = _state2.dirty,
	                formData = _state2.formData,
	                formErrors = _state2.formErrors,
	                sendingEmail = _state2.sendingEmail,
	                submitting = _state2.submitting,
	                valid = _state2.valid,
	                validationErrors = _state2.validationErrors;
	
	
	            var settings = elements.map(function (element, index) {
	                // merge together data from a couple places to provide a complete view of the Element state
	                var errorMessage = formErrors && formErrors.elements ? formErrors.elements[element.key] : validationErrors[element.key];
	                var value = formData[element.key] == null ? element.defaultValue : formData[element.key];
	
	                return _react2.default.createElement(_SettingsSetting2.default, {
	                    key: element.key,
	                    setting: _extends({}, element, { value: value }),
	                    updateSetting: _this4.handleChangeEvent.bind(_this4, element),
	                    errorMessage: errorMessage
	                });
	            });
	
	            var sendTestButtonStates = {
	                default: "Send test email",
	                working: "Sending...",
	                success: "Sent!"
	            };
	
	            var saveSettingsButtonStates = {
	                default: "Save changes",
	                working: "Saving...",
	                success: "Changes saved!"
	            };
	
	            var disabled = !valid || submitting !== "default" || sendingEmail !== "default",
	                emailButtonText = sendTestButtonStates[sendingEmail],
	                saveButtonText = saveSettingsButtonStates[submitting];
	
	            return _react2.default.createElement(
	                "form",
	                { noValidate: true },
	                _react2.default.createElement(
	                    "ul",
	                    null,
	                    settings,
	                    _react2.default.createElement(
	                        "li",
	                        { className: "m2 mb4" },
	                        _react2.default.createElement(
	                            "button",
	                            { className: (0, _classnames2.default)("Button mr2", { "Button--primary": !disabled }, { "Button--success-new": submitting === "success" }), disabled: disabled, onClick: this.updateEmailSettings.bind(this) },
	                            saveButtonText
	                        ),
	                        valid && !dirty && submitting === "default" ? _react2.default.createElement(
	                            "button",
	                            { className: (0, _classnames2.default)("Button", { "Button--success-new": sendingEmail === "success" }), disabled: disabled, onClick: this.sendTestEmail.bind(this) },
	                            emailButtonText
	                        ) : null,
	                        formErrors && formErrors.message ? _react2.default.createElement(
	                            "span",
	                            { className: "pl2 text-error text-bold" },
	                            formErrors.message
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SettingsEmailForm;
	}(_react.Component), _class.propTypes = {
	    elements: _propTypes2.default.array.isRequired,
	    formErrors: _propTypes2.default.object,
	    sendTestEmail: _propTypes2.default.func.isRequired,
	    updateEmailSettings: _propTypes2.default.func.isRequired
	}, _temp);
	SettingsEmailForm.displayName = "SettingsEmailForm";
	exports.default = SettingsEmailForm;

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _SettingsSetting = __webpack_require__(1872);
	
	var _SettingsSetting2 = _interopRequireDefault(_SettingsSetting);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _reactRetinaImage = __webpack_require__(903);
	
	var _reactRetinaImage2 = _interopRequireDefault(_reactRetinaImage);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsSlackForm = (_temp = _class = function (_Component) {
	    _inherits(SettingsSlackForm, _Component);
	
	    function SettingsSlackForm(props, context) {
	        _classCallCheck(this, SettingsSlackForm);
	
	        var _this = _possibleConstructorReturn(this, (SettingsSlackForm.__proto__ || Object.getPrototypeOf(SettingsSlackForm)).call(this, props, context));
	
	        _this.state = {
	            formData: {},
	            submitting: "default",
	            valid: false,
	            validationErrors: {}
	        };
	        return _this;
	    }
	
	    _createClass(SettingsSlackForm, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            // this gives us an opportunity to load up our formData with any existing values for elements
	            var formData = {};
	            this.props.elements.forEach(function (element) {
	                formData[element.key] = element.value == null ? element.defaultValue : element.value;
	            });
	
	            this.setState({ formData: formData });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.validateForm();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this.validateForm();
	        }
	    }, {
	        key: "setSubmitting",
	        value: function setSubmitting(submitting) {
	            this.setState({ submitting: submitting });
	        }
	    }, {
	        key: "setFormErrors",
	        value: function setFormErrors(formErrors) {
	            this.setState({ formErrors: formErrors });
	        }
	
	        // return null if element passes validation, otherwise return an error message
	
	    }, {
	        key: "validateElement",
	        value: function validateElement(_ref, value, element) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                validationType = _ref2[0],
	                validationMessage = _ref2[1];
	
	            if (_utils2.default.isEmpty(value)) return;
	
	            switch (validationType) {
	                case "email":
	                    return !_utils2.default.validEmail(value) ? validationMessage || "That's not a valid email address" : null;
	                case "integer":
	                    return isNaN(parseInt(value)) ? validationMessage || "That's not a valid integer" : null;
	            }
	        }
	    }, {
	        key: "validateForm",
	        value: function validateForm() {
	            var elements = this.props.elements;
	            var formData = this.state.formData;
	
	
	            var valid = true,
	                validationErrors = {};
	
	            elements.forEach(function (element) {
	                // test for required elements
	                if (element.required && _utils2.default.isEmpty(formData[element.key])) {
	                    valid = false;
	                }
	
	                if (element.validations) {
	                    element.validations.forEach(function (validation) {
	                        validationErrors[element.key] = this.validateElement(validation, formData[element.key], element);
	                        if (validationErrors[element.key]) valid = false;
	                    }, this);
	                }
	            }, this);
	
	            if (this.state.valid !== valid || !_underscore2.default.isEqual(this.state.validationErrors, validationErrors)) {
	                this.setState({ valid: valid, validationErrors: validationErrors });
	            }
	        }
	    }, {
	        key: "handleChangeEvent",
	        value: function handleChangeEvent(element, value, event) {
	            this.setState({
	                formData: _extends({}, this.state.formData, _defineProperty({}, element.key, _utils2.default.isEmpty(value) ? null : value))
	            });
	
	            if (element.key === "metabot-enabled") {
	                _analytics2.default.trackEvent("Slack Settings", "Toggle Metabot", value);
	            }
	        }
	    }, {
	        key: "handleFormErrors",
	        value: function handleFormErrors(error) {
	            // parse and format
	            var formErrors = {};
	            if (error.data && error.data.message) {
	                formErrors.message = error.data.message;
	            } else {
	                formErrors.message = "Looks like we ran into some problems";
	            }
	
	            if (error.data && error.data.errors) {
	                formErrors.elements = error.data.errors;
	            }
	
	            return formErrors;
	        }
	    }, {
	        key: "updateSlackSettings",
	        value: function updateSlackSettings(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            this.setState({
	                formErrors: null,
	                submitting: "working"
	            });
	
	            var _state = this.state,
	                formData = _state.formData,
	                valid = _state.valid;
	
	
	            if (valid) {
	                this.props.updateSlackSettings(formData).then(function () {
	                    _this2.setState({
	                        submitting: "success"
	                    });
	
	                    _analytics2.default.trackEvent("Slack Settings", "Update", "success");
	
	                    // show a confirmation for 3 seconds, then return to normal
	                    setTimeout(function () {
	                        return _this2.setState({ submitting: "default" });
	                    }, 3000);
	                }, function (error) {
	                    _this2.setState({
	                        submitting: "default",
	                        formErrors: _this2.handleFormErrors(error)
	                    });
	
	                    _analytics2.default.trackEvent("Slack Settings", "Update", "error");
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var elements = this.props.elements;
	            var _state2 = this.state,
	                formData = _state2.formData,
	                formErrors = _state2.formErrors,
	                submitting = _state2.submitting,
	                valid = _state2.valid,
	                validationErrors = _state2.validationErrors;
	
	
	            var settings = elements.map(function (element, index) {
	                // merge together data from a couple places to provide a complete view of the Element state
	                var errorMessage = formErrors && formErrors.elements ? formErrors.elements[element.key] : validationErrors[element.key];
	                var value = formData[element.key] == null ? element.defaultValue : formData[element.key];
	
	                if (element.key === "slack-token") {
	                    return _react2.default.createElement(_SettingsSetting2.default, {
	                        key: element.key,
	                        setting: _extends({}, element, { value: value }),
	                        updateSetting: function updateSetting(value) {
	                            return _this3.handleChangeEvent(element, value);
	                        },
	                        errorMessage: errorMessage,
	                        fireOnChange: true
	                    });
	                } else if (element.key === "metabot-enabled") {
	                    return _react2.default.createElement(_SettingsSetting2.default, {
	                        key: element.key,
	                        setting: _extends({}, element, { value: value }),
	                        updateSetting: function updateSetting(value) {
	                            return _this3.handleChangeEvent(element, value);
	                        },
	                        errorMessage: errorMessage,
	                        disabled: !_this3.state.formData["slack-token"]
	                    });
	                }
	            });
	
	            var saveSettingsButtonStates = {
	                default: "Save changes",
	                working: "Saving...",
	                success: "Changes saved!"
	            };
	
	            var disabled = !valid || submitting !== "default",
	                saveButtonText = saveSettingsButtonStates[submitting];
	
	            return _react2.default.createElement(
	                "form",
	                { noValidate: true },
	                _react2.default.createElement(
	                    "div",
	                    { className: "px2", style: { maxWidth: "585px" } },
	                    _react2.default.createElement(
	                        "h1",
	                        null,
	                        "Metabase",
	                        _react2.default.createElement(_reactRetinaImage2.default, {
	                            className: "mx1",
	                            src: "app/assets/img/slack_emoji.png",
	                            width: 79,
	                            forceOriginalDimensions: false /* broken in React v0.13 */
	                        }),
	                        "Slack"
	                    ),
	                    _react2.default.createElement(
	                        "h3",
	                        { className: "text-grey-1" },
	                        "Answers sent right to your Slack #channels"
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "pt3" },
	                        _react2.default.createElement(
	                            "a",
	                            { href: "https://my.slack.com/services/new/bot", target: "_blank", className: "Button Button--primary", style: { padding: 0 } },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "float-left py2 pl2" },
	                                "Create a Slack Bot User for MetaBot"
	                            ),
	                            _react2.default.createElement(_Icon2.default, { className: "float-right p2 text-white cursor-pointer", style: { opacity: 0.6 }, name: "external", size: 18 })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "py2" },
	                        "Once you're there, give it a name and click ",
	                        _react2.default.createElement(
	                            "strong",
	                            null,
	                            "\"Add bot integration\""
	                        ),
	                        ". Then copy and paste the Bot API Token into the field below. Once you are done, create a \"metabase_files\" channel in Slack. Metabase needs this to upload graphs."
	                    )
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    null,
	                    settings,
	                    _react2.default.createElement(
	                        "li",
	                        { className: "m2 mb4" },
	                        _react2.default.createElement(
	                            "button",
	                            { className: (0, _classnames2.default)("Button mr2", { "Button--primary": !disabled }, { "Button--success-new": submitting === "success" }), disabled: disabled, onClick: this.updateSlackSettings.bind(this) },
	                            saveButtonText
	                        ),
	                        formErrors && formErrors.message ? _react2.default.createElement(
	                            "span",
	                            { className: "pl2 text-error text-bold" },
	                            formErrors.message
	                        ) : null
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SettingsSlackForm;
	}(_react.Component), _class.propTypes = {
	    elements: _propTypes2.default.array,
	    formErrors: _propTypes2.default.object,
	    updateSlackSettings: _propTypes2.default.func.isRequired
	}, _temp);
	SettingsSlackForm.displayName = "SettingsSlackForm";
	exports.default = SettingsSlackForm;

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCollapse = __webpack_require__(1883);
	
	var _reactCollapse2 = _interopRequireDefault(_reactCollapse);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _DisclosureTriangle = __webpack_require__(1889);
	
	var _DisclosureTriangle2 = _interopRequireDefault(_DisclosureTriangle);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _SettingsSetting = __webpack_require__(1872);
	
	var _SettingsSetting2 = _interopRequireDefault(_SettingsSetting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsLdapForm = (_temp = _class = function (_Component) {
	    _inherits(SettingsLdapForm, _Component);
	
	    function SettingsLdapForm(props, context) {
	        _classCallCheck(this, SettingsLdapForm);
	
	        var _this = _possibleConstructorReturn(this, (SettingsLdapForm.__proto__ || Object.getPrototypeOf(SettingsLdapForm)).call(this, props, context));
	
	        _this.state = {
	            formData: {},
	            showAttributes: false,
	            submitting: "default",
	            valid: false,
	            validationErrors: {}
	        };
	        return _this;
	    }
	
	    _createClass(SettingsLdapForm, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            // this gives us an opportunity to load up our formData with any existing values for elements
	            this.updateFormData(this.props);
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            this.updateFormData(nextProps);
	        }
	    }, {
	        key: "updateFormData",
	        value: function updateFormData(props) {
	            var formData = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = props.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var element = _step.value;
	
	                    formData[element.key] = element.value;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            this.setState({ formData: formData });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.validateForm();
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            this.validateForm();
	        }
	    }, {
	        key: "setSubmitting",
	        value: function setSubmitting(submitting) {
	            this.setState({ submitting: submitting });
	        }
	    }, {
	        key: "setFormErrors",
	        value: function setFormErrors(formErrors) {
	            this.setState({ formErrors: formErrors });
	        }
	
	        // return null if element passes validation, otherwise return an error message
	
	    }, {
	        key: "validateElement",
	        value: function validateElement(_ref, value, element) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                validationType = _ref2[0],
	                validationMessage = _ref2[1];
	
	            if (_utils2.default.isEmpty(value)) return;
	
	            switch (validationType) {
	                case "email":
	                    return !_utils2.default.validEmail(value) ? validationMessage || "That's not a valid email address" : null;
	                case "integer":
	                    return isNaN(parseInt(value)) ? validationMessage || "That's not a valid integer" : null;
	                case "ldap_filter":
	                    return (value.match(/\(/g) || []).length !== (value.match(/\)/g) || []).length ? validationMessage || "Check your parentheses" : null;
	            }
	        }
	    }, {
	        key: "validateForm",
	        value: function validateForm() {
	            var elements = this.props.elements;
	            var formData = this.state.formData;
	
	
	            var valid = true,
	                validationErrors = {};
	
	            // Validate form only if LDAP is enabled
	            if (formData['ldap-enabled']) {
	                elements.forEach(function (element) {
	                    // test for required elements
	                    if (element.required && _utils2.default.isEmpty(formData[element.key])) {
	                        valid = false;
	                    }
	
	                    if (element.validations) {
	                        element.validations.forEach(function (validation) {
	                            validationErrors[element.key] = this.validateElement(validation, formData[element.key], element);
	                            if (validationErrors[element.key]) valid = false;
	                        }, this);
	                    }
	                }, this);
	            }
	
	            if (this.state.valid !== valid || !_underscore2.default.isEqual(this.state.validationErrors, validationErrors)) {
	                this.setState({ valid: valid, validationErrors: validationErrors });
	            }
	        }
	    }, {
	        key: "handleChangeEvent",
	        value: function handleChangeEvent(element, value, event) {
	            this.setState(function (previousState) {
	                return { formData: _extends({}, previousState.formData, _defineProperty({}, element.key, _utils2.default.isEmpty(value) ? null : value)) };
	            });
	        }
	    }, {
	        key: "handleFormErrors",
	        value: function handleFormErrors(error) {
	            // parse and format
	            var formErrors = {};
	            if (error.data && error.data.message) {
	                formErrors.message = error.data.message;
	            } else {
	                formErrors.message = "Looks like we ran into some problems";
	            }
	
	            if (error.data && error.data.errors) {
	                formErrors.elements = error.data.errors;
	            }
	
	            return formErrors;
	        }
	    }, {
	        key: "handleAttributeToggle",
	        value: function handleAttributeToggle() {
	            this.setState(function (previousState) {
	                return { showAttributes: !previousState['showAttributes'] };
	            });
	        }
	    }, {
	        key: "updateLdapSettings",
	        value: function updateLdapSettings(e) {
	            var _this2 = this;
	
	            e.preventDefault();
	
	            var _state = this.state,
	                formData = _state.formData,
	                valid = _state.valid;
	
	
	            if (valid) {
	                this.setState({
	                    formErrors: null,
	                    submitting: "working"
	                });
	
	                this.props.updateLdapSettings(formData).then(function () {
	                    _this2.setState({ submitting: "success" });
	
	                    // show a confirmation for 3 seconds, then return to normal
	                    setTimeout(function () {
	                        return _this2.setState({ submitting: "default" });
	                    }, 3000);
	                }, function (error) {
	                    _this2.setState({
	                        submitting: "default",
	                        formErrors: _this2.handleFormErrors(error)
	                    });
	                });
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var elements = this.props.elements;
	            var _state2 = this.state,
	                formData = _state2.formData,
	                formErrors = _state2.formErrors,
	                showAttributes = _state2.showAttributes,
	                submitting = _state2.submitting,
	                valid = _state2.valid,
	                validationErrors = _state2.validationErrors;
	
	
	            var sections = {
	                'ldap-enabled': 'server',
	                'ldap-host': 'server',
	                'ldap-port': 'server',
	                'ldap-security': 'server',
	                'ldap-bind-dn': 'server',
	                'ldap-password': 'server',
	                'ldap-user-base': 'user',
	                'ldap-user-filter': 'user',
	                'ldap-attribute-email': 'attribute',
	                'ldap-attribute-firstname': 'attribute',
	                'ldap-attribute-lastname': 'attribute',
	                'ldap-group-sync': 'group',
	                'ldap-group-base': 'group'
	            };
	
	            var toElement = function toElement(element) {
	                // merge together data from a couple places to provide a complete view of the Element state
	                var errorMessage = formErrors && formErrors.elements ? formErrors.elements[element.key] : validationErrors[element.key];
	                var value = formData[element.key] == null ? element.defaultValue : formData[element.key];
	
	                if (element.key === 'ldap-group-sync') {
	                    return _react2.default.createElement(_SettingsSetting2.default, {
	                        key: element.key,
	                        setting: _extends({}, element, { value: value }),
	                        updateSetting: _this3.handleChangeEvent.bind(_this3, element),
	                        mappings: formData['ldap-group-mappings'],
	                        updateMappings: _this3.handleChangeEvent.bind(_this3, { key: 'ldap-group-mappings' }),
	                        errorMessage: errorMessage
	                    });
	                }
	
	                return _react2.default.createElement(_SettingsSetting2.default, {
	                    key: element.key,
	                    setting: _extends({}, element, { value: value }),
	                    updateSetting: _this3.handleChangeEvent.bind(_this3, element),
	                    errorMessage: errorMessage
	                });
	            };
	
	            var serverSettings = elements.filter(function (e) {
	                return sections[e.key] === 'server';
	            }).map(toElement);
	            var userSettings = elements.filter(function (e) {
	                return sections[e.key] === 'user';
	            }).map(toElement);
	            var attributeSettings = elements.filter(function (e) {
	                return sections[e.key] === 'attribute';
	            }).map(toElement);
	            var groupSettings = elements.filter(function (e) {
	                return sections[e.key] === 'group';
	            }).map(toElement);
	
	            var saveSettingsButtonStates = {
	                default: "Save changes",
	                working: "Saving...",
	                success: "Changes saved!"
	            };
	
	            var disabled = !valid || submitting !== "default";
	            var saveButtonText = saveSettingsButtonStates[submitting];
	
	            return _react2.default.createElement(
	                "form",
	                { noValidate: true },
	                _react2.default.createElement(_Breadcrumbs2.default, {
	                    crumbs: [["Authentication", "/admin/settings/authentication"], ["LDAP"]],
	                    className: "ml2 mb3"
	                }),
	                _react2.default.createElement(
	                    "h2",
	                    { className: "mx2" },
	                    "Server Settings"
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    null,
	                    serverSettings
	                ),
	                _react2.default.createElement(
	                    "h2",
	                    { className: "mx2" },
	                    "User Schema"
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    null,
	                    userSettings
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "mb4" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "inline-block ml1 cursor-pointer text-brand-hover", onClick: this.handleAttributeToggle.bind(this) },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex align-center" },
	                            _react2.default.createElement(_DisclosureTriangle2.default, { open: showAttributes }),
	                            _react2.default.createElement(
	                                "h3",
	                                null,
	                                "Attributes"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactCollapse2.default,
	                        { isOpened: showAttributes, keepCollapsedContent: true },
	                        _react2.default.createElement(
	                            "ul",
	                            null,
	                            attributeSettings
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "h2",
	                    { className: "mx2" },
	                    "Group Schema"
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    null,
	                    groupSettings
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "m2 mb4" },
	                    _react2.default.createElement(
	                        "button",
	                        { className: (0, _classnames2.default)("Button mr2", { "Button--primary": !disabled }, { "Button--success-new": submitting === "success" }), disabled: disabled, onClick: this.updateLdapSettings.bind(this) },
	                        saveButtonText
	                    ),
	                    formErrors && formErrors.message ? _react2.default.createElement(
	                        "span",
	                        { className: "pl2 text-error text-bold" },
	                        formErrors.message
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return SettingsLdapForm;
	}(_react.Component), _class.propTypes = {
	    elements: _react.PropTypes.array.isRequired,
	    formErrors: _react.PropTypes.object,
	    updateLdapSettings: _react.PropTypes.func.isRequired
	}, _temp);
	SettingsLdapForm.displayName = "SettingsLdapForm";
	exports.default = SettingsLdapForm;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Babel6 does not hack the default behaviour of ES Modules anymore, so we should export
	
	var Collapse = __webpack_require__(1884).default;
	
	module.exports = Collapse;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactComponentWithPureRenderMixin = __webpack_require__(1885);
	
	var _reactMotion = __webpack_require__(1248);
	
	var _reactHeight = __webpack_require__(1887);
	
	var _reactHeight2 = _interopRequireDefault(_reactHeight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PRECISION = 0.5;
	
	var stringHeight = function stringHeight(height) {
	  return Math.max(0, parseFloat(height)).toFixed(1);
	};
	
	var Collapse = _react2.default.createClass({
	  displayName: 'Collapse',
	
	  propTypes: {
	    isOpened: _react2.default.PropTypes.bool.isRequired,
	    children: _react2.default.PropTypes.node.isRequired,
	    fixedHeight: _react2.default.PropTypes.number,
	    style: _react2.default.PropTypes.object, // eslint-disable-line react/forbid-prop-types
	    springConfig: _react2.default.PropTypes.objectOf(_react2.default.PropTypes.number),
	    keepCollapsedContent: _react2.default.PropTypes.bool,
	    onRest: _react2.default.PropTypes.func,
	    onHeightReady: _react2.default.PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      fixedHeight: -1,
	      style: {},
	      keepCollapsedContent: false,
	      onHeightReady: function onHeightReady() {} // eslint-disable-line no-empty-function
	    };
	  },
	  getInitialState: function getInitialState() {
	    return { height: -1, isOpenedChanged: false };
	  },
	  componentWillMount: function componentWillMount() {
	    this.height = stringHeight(0);
	    this.renderStatic = true;
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
	    var isOpened = _ref.isOpened;
	
	    this.setState({ isOpenedChanged: isOpened !== this.props.isOpened });
	  },
	
	
	  shouldComponentUpdate: _ReactComponentWithPureRenderMixin.shouldComponentUpdate,
	
	  componentDidUpdate: function componentDidUpdate(_ref2) {
	    var isOpened = _ref2.isOpened;
	
	    if (isOpened !== this.props.isOpened) {
	      var report = this.props.isOpened ? this.state.height : 0;
	
	      this.props.onHeightReady(report);
	    }
	  },
	  onHeightReady: function onHeightReady(height) {
	    var _props = this.props;
	    var isOpened = _props.isOpened;
	    var onHeightReady = _props.onHeightReady;
	
	
	    if (this.renderStatic && isOpened) {
	      this.height = stringHeight(height);
	    }
	
	    this.setState({ height: isOpened || !this.renderStatic ? height : 0 });
	
	    var reportHeight = isOpened ? height : 0;
	
	    if (this.state.height !== reportHeight) {
	      onHeightReady(reportHeight);
	    }
	  },
	  getMotionHeight: function getMotionHeight(height) {
	    var _props2 = this.props;
	    var isOpened = _props2.isOpened;
	    var springConfig = _props2.springConfig;
	    var fixedHeight = _props2.fixedHeight;
	    var isOpenedChanged = this.state.isOpenedChanged;
	
	
	    var newHeight = isOpened ? Math.max(0, parseFloat(height)).toFixed(1) : stringHeight(0);
	
	    // No need to animate if content is closed and it was closed previously
	    // Also no need to animate if height did not change
	    var skipAnimation = !isOpenedChanged && !isOpened || this.height === newHeight && fixedHeight === -1;
	
	    var springHeight = (0, _reactMotion.spring)(isOpened ? Math.max(0, height) : 0, _extends({
	      precision: PRECISION
	    }, springConfig));
	    var instantHeight = isOpened ? Math.max(0, height) : 0;
	
	    return skipAnimation ? instantHeight : springHeight;
	  },
	  renderFixed: function renderFixed() {
	    var _this = this;
	
	    var _props3 = this.props;
	    var _springConfig = _props3.springConfig;
	    var _onHeightReady = _props3.onHeightReady;
	    var _onRest = _props3.onRest;
	    var isOpened = _props3.isOpened;
	    var style = _props3.style;
	    var children = _props3.children;
	    var fixedHeight = _props3.fixedHeight;
	    var keepCollapsedContent = _props3.keepCollapsedContent;
	
	    var props = _objectWithoutProperties(_props3, ['springConfig', 'onHeightReady', 'onRest', 'isOpened', 'style', 'children', 'fixedHeight', 'keepCollapsedContent']);
	
	    if (this.renderStatic) {
	      this.renderStatic = false;
	      var newStyle = { overflow: 'hidden', height: isOpened ? fixedHeight : 0 };
	
	      if (!keepCollapsedContent && !isOpened) {
	        return null;
	      }
	      this.height = stringHeight(fixedHeight);
	      return _react2.default.createElement(
	        'div',
	        _extends({ style: _extends({}, newStyle, style) }, props),
	        children
	      );
	    }
	
	    return _react2.default.createElement(
	      _reactMotion.Motion,
	      {
	        defaultStyle: { height: isOpened ? 0 : fixedHeight },
	        style: { height: this.getMotionHeight(fixedHeight) } },
	      function (_ref3) {
	        var height = _ref3.height;
	
	        _this.height = stringHeight(height);
	
	        // TODO: this should be done using onEnd from ReactMotion, which is not yet implemented
	        // See https://github.com/chenglou/react-motion/issues/235
	        if (!keepCollapsedContent && !isOpened && _this.height === stringHeight(0)) {
	          return null;
	        }
	
	        var newStyle = { overflow: 'hidden', height: height };
	
	        return _react2.default.createElement(
	          'div',
	          _extends({ style: _extends({}, newStyle, style) }, props),
	          children
	        );
	      }
	    );
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _props4 = this.props;
	    var _springConfig = _props4.springConfig;
	    var _onHeightReady = _props4.onHeightReady;
	    var isOpened = _props4.isOpened;
	    var style = _props4.style;
	    var children = _props4.children;
	    var fixedHeight = _props4.fixedHeight;
	    var keepCollapsedContent = _props4.keepCollapsedContent;
	    var onRest = _props4.onRest;
	
	    var props = _objectWithoutProperties(_props4, ['springConfig', 'onHeightReady', 'isOpened', 'style', 'children', 'fixedHeight', 'keepCollapsedContent', 'onRest']);
	
	    if (fixedHeight > -1) {
	      return this.renderFixed();
	    }
	
	    var renderStatic = this.renderStatic;
	    var height = this.state.height;
	
	    var currentStringHeight = parseFloat(height).toFixed(1);
	
	    if (height > -1 && renderStatic) {
	      this.renderStatic = false;
	    }
	
	    // Cache Content so it is not re-rendered on each animation step
	    var content = _react2.default.createElement(
	      _reactHeight2.default,
	      { onHeightReady: this.onHeightReady },
	      children
	    );
	
	    if (renderStatic) {
	      var _ret = function () {
	        var newStyle = isOpened ? { height: 'auto' } : { overflow: 'hidden', height: 0 };
	
	        if (!isOpened && height > -1) {
	          if (!keepCollapsedContent) {
	            return {
	              v: null
	            };
	          }
	
	          return {
	            v: _react2.default.createElement(
	              'div',
	              _extends({ style: _extends({ height: 0, overflow: 'hidden' }, style) }, props),
	              content
	            )
	          };
	        }
	
	        // <Motion> to prevent loosing input after causing this component to rerender
	        return {
	          v: _react2.default.createElement(
	            _reactMotion.Motion,
	            {
	              defaultStyle: { height: Math.max(0, height) },
	              style: { height: Math.max(0, height) },
	              onRest: onRest },
	            function () {
	              return _react2.default.createElement(
	                'div',
	                _extends({ style: _extends({}, newStyle, style) }, props),
	                content
	              );
	            }
	          )
	        };
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    }
	
	    return _react2.default.createElement(
	      _reactMotion.Motion,
	      {
	        defaultStyle: { height: Math.max(0, height) },
	        onRest: onRest,
	        style: { height: this.getMotionHeight(height) } },
	      function (st) {
	        _this2.height = stringHeight(st.height);
	
	        // TODO: this should be done using onEnd from ReactMotion, which is not yet implemented
	        // See https://github.com/chenglou/react-motion/issues/235
	        if (!isOpened && _this2.height === '0.0') {
	          if (!keepCollapsedContent) {
	            return null;
	          }
	          return _react2.default.createElement(
	            'div',
	            _extends({ style: _extends({ height: 0, overflow: 'hidden' }, style) }, props),
	            content
	          );
	        }
	
	        var newStyle = isOpened && _this2.height === currentStringHeight ? { height: 'auto' } : {
	          height: st.height, overflow: 'hidden'
	        };
	
	        return _react2.default.createElement(
	          'div',
	          _extends({ style: _extends({}, newStyle, style) }, props),
	          content
	        );
	      }
	    );
	  }
	});
	
	exports.default = Collapse;
	//# sourceMappingURL=Collapse.js.map

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var shallowCompare = __webpack_require__(1886);
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 *
	 * See https://facebook.github.io/react/docs/pure-render-mixin.html
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function (nextProps, nextState) {
	    return shallowCompare(this, nextProps, nextState);
	  }
	};
	
	module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(414);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	module.exports = shallowCompare;

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Babel6 does not hack the default behaviour of ES Modules anymore, so we should export
	
	var ReactHeight = __webpack_require__(1888).default;
	
	module.exports = ReactHeight;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactComponentWithPureRenderMixin = __webpack_require__(1885);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint "react/no-did-mount-set-state":0 */
	/* eslint "react/no-did-update-set-state":0 */
	
	var getElementHeight = function getElementHeight(el) {
	  return el.clientHeight;
	};
	
	var ReactHeight = _react2.default.createClass({
	  displayName: 'ReactHeight',
	
	  propTypes: {
	    children: _react2.default.PropTypes.node.isRequired,
	    onHeightReady: _react2.default.PropTypes.func.isRequired,
	    hidden: _react2.default.PropTypes.bool,
	    dirty: _react2.default.PropTypes.bool,
	    getElementHeight: _react2.default.PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hidden: false,
	      dirty: true,
	      getElementHeight: getElementHeight
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      height: 0, dirty: this.props.dirty
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var height = this.props.getElementHeight(this.wrapper);
	    var dirty = false;
	
	    this.setState({ height: height, dirty: dirty }, function () {
	      return _this.props.onHeightReady(_this.state.height);
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
	    var children = _ref.children,
	        dirty = _ref.dirty;
	
	    if (children !== this.props.children || dirty) {
	      this.setState({ dirty: true });
	    }
	  },
	
	
	  shouldComponentUpdate: _ReactComponentWithPureRenderMixin.shouldComponentUpdate,
	
	  componentDidUpdate: function componentDidUpdate() {
	    var _this2 = this;
	
	    var height = this.props.getElementHeight(this.wrapper);
	    var dirty = false;
	
	    if (height === this.state.height) {
	      this.setState({ dirty: dirty });
	    } else {
	      this.setState({ height: height, dirty: dirty }, function () {
	        return _this2.props.onHeightReady(_this2.state.height);
	      });
	    }
	  },
	  setWrapperRef: function setWrapperRef(el) {
	    this.wrapper = el;
	  },
	  render: function render() {
	    var _props = this.props,
	        _onHeightReady = _props.onHeightReady,
	        _getElementHeight = _props.getElementHeight,
	        _dirty = _props.dirty,
	        hidden = _props.hidden,
	        children = _props.children,
	        props = _objectWithoutProperties(_props, ['onHeightReady', 'getElementHeight', 'dirty', 'hidden', 'children']);
	
	    var dirty = this.state.dirty;
	
	
	    if (hidden && !dirty) {
	      return null;
	    }
	
	    if (hidden) {
	      return _react2.default.createElement(
	        'div',
	        { style: { height: 0, overflow: 'hidden' } },
	        _react2.default.createElement(
	          'div',
	          _extends({ ref: this.setWrapperRef }, props),
	          children
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      _extends({ ref: this.setWrapperRef }, props),
	      children
	    );
	  }
	});
	
	exports.default = ReactHeight;
	//# sourceMappingURL=ReactHeight.js.map

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(1248);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DisclosureTriangle = function DisclosureTriangle(_ref) {
	    var open = _ref.open;
	    return _react2.default.createElement(
	        _reactMotion.Motion,
	        { defaultStyle: { deg: 0 }, style: { deg: open ? (0, _reactMotion.spring)(0, _reactMotion.presets.gentle) : (0, _reactMotion.spring)(-90, _reactMotion.presets.gentle) } },
	        function (motionStyle) {
	            return _react2.default.createElement(_Icon2.default, {
	                className: "ml1 mr1",
	                name: "expandarrow",
	                style: {
	                    transform: "rotate(" + motionStyle.deg + "deg)"
	                }
	            });
	        }
	    );
	};
	
	DisclosureTriangle.displayName = "DisclosureTriangle";
	exports.default = DisclosureTriangle;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.Task = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TaskList = function TaskList(_ref) {
	    var tasks = _ref.tasks;
	    return _react2.default.createElement(
	        "ol",
	        null,
	        tasks.map(function (task, index) {
	            return _react2.default.createElement(
	                "li",
	                { className: "mb2", key: index },
	                _react2.default.createElement(Task, task)
	            );
	        })
	    );
	};
	
	TaskList.displayName = "TaskList";
	var TaskSectionHeader = function TaskSectionHeader(_ref2) {
	    var name = _ref2.name;
	    return _react2.default.createElement(
	        "h4",
	        { className: "text-grey-4 text-bold text-uppercase pb2" },
	        name
	    );
	};
	
	TaskSectionHeader.displayName = "TaskSectionHeader";
	var TaskSection = function TaskSection(_ref3) {
	    var name = _ref3.name,
	        tasks = _ref3.tasks;
	    return _react2.default.createElement(
	        "div",
	        { className: "mb4" },
	        _react2.default.createElement(TaskSectionHeader, { name: name }),
	        _react2.default.createElement(TaskList, { tasks: tasks })
	    );
	};
	
	TaskSection.displayName = "TaskSection";
	var TaskTitle = function TaskTitle(_ref4) {
	    var title = _ref4.title,
	        titleClassName = _ref4.titleClassName;
	    return _react2.default.createElement(
	        "h3",
	        { className: titleClassName },
	        title
	    );
	};
	
	TaskTitle.displayName = "TaskTitle";
	var TaskDescription = function TaskDescription(_ref5) {
	    var description = _ref5.description;
	    return _react2.default.createElement(
	        "p",
	        { className: "m0 mt1" },
	        description
	    );
	};
	
	TaskDescription.displayName = "TaskDescription";
	var CompletionBadge = function CompletionBadge(_ref6) {
	    var completed = _ref6.completed;
	    return _react2.default.createElement(
	        "div",
	        { className: "mr2 flex align-center justify-center flex-no-shrink", style: {
	                borderWidth: 1,
	                borderStyle: 'solid',
	                borderColor: completed ? '#9CC177' : '#DCE9EA',
	                backgroundColor: completed ? '#9CC177' : '#fff',
	                width: 32,
	                height: 32,
	                borderRadius: 99
	            } },
	        completed && _react2.default.createElement(_Icon2.default, { name: "check", color: '#fff' })
	    );
	};
	
	CompletionBadge.displayName = "CompletionBadge";
	var Task = exports.Task = function Task(_ref7) {
	    var title = _ref7.title,
	        description = _ref7.description,
	        completed = _ref7.completed,
	        link = _ref7.link;
	    return _react2.default.createElement(
	        _reactRouter.Link,
	        { to: link, className: "bordered border-brand-hover rounded transition-border flex align-center p2 no-decoration" },
	        _react2.default.createElement(CompletionBadge, { completed: completed }),
	        _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(TaskTitle, { title: title, titleClassName: completed ? 'text-success' : 'text-brand' }),
	            !completed ? _react2.default.createElement(TaskDescription, { description: description }) : null
	        )
	    );
	};
	
	Task.displayName = "Task";
	
	var SettingsSetupList = function (_Component) {
	    _inherits(SettingsSetupList, _Component);
	
	    function SettingsSetupList(props, context) {
	        _classCallCheck(this, SettingsSetupList);
	
	        var _this = _possibleConstructorReturn(this, (SettingsSetupList.__proto__ || Object.getPrototypeOf(SettingsSetupList)).call(this, props, context));
	
	        _this.state = {
	            tasks: null,
	            error: null
	        };
	        return _this;
	    }
	
	    _createClass(SettingsSetupList, [{
	        key: "componentWillMount",
	        value: function () {
	            var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var tasks;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return _services.SetupApi.admin_checklist();
	
	                            case 3:
	                                tasks = _context.sent;
	
	                                this.setState({ tasks: tasks });
	                                _context.next = 10;
	                                break;
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context["catch"](0);
	
	                                this.setState({ error: _context.t0 });
	
	                            case 10:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 7]]);
	            }));
	
	            function componentWillMount() {
	                return _ref8.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var tasks = void 0,
	                nextTask = void 0;
	            if (this.state.tasks) {
	                tasks = this.state.tasks.map(function (section) {
	                    return _extends({}, section, {
	                        tasks: section.tasks.filter(function (task) {
	                            if (task.is_next_step) {
	                                nextTask = task;
	                            }
	                            return !task.is_next_step;
	                        })
	                    });
	                });
	            }
	
	            return _react2.default.createElement(
	                "div",
	                { className: "px2" },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Getting set up"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: "mt1" },
	                    "A few things you can do to get the most out of Metabase."
	                ),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !this.state.tasks, error: this.state.error },
	                    function () {
	                        return _react2.default.createElement(
	                            "div",
	                            { style: { maxWidth: 468 } },
	                            nextTask && _react2.default.createElement(TaskSection, { name: "Recommended next step", tasks: [nextTask] }),
	                            tasks.map(function (section, index) {
	                                return _react2.default.createElement(TaskSection, _extends({}, section, { key: index }));
	                            })
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return SettingsSetupList;
	}(_react.Component);
	
	SettingsSetupList.displayName = "SettingsSetupList";
	exports.default = SettingsSetupList;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _SettingsSetting = __webpack_require__(1872);
	
	var _SettingsSetting2 = _interopRequireDefault(_SettingsSetting);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsUpdatesForm = (_temp = _class = function (_Component) {
	    _inherits(SettingsUpdatesForm, _Component);
	
	    function SettingsUpdatesForm() {
	        _classCallCheck(this, SettingsUpdatesForm);
	
	        return _possibleConstructorReturn(this, (SettingsUpdatesForm.__proto__ || Object.getPrototypeOf(SettingsUpdatesForm)).apply(this, arguments));
	    }
	
	    _createClass(SettingsUpdatesForm, [{
	        key: "removeVersionPrefixIfNeeded",
	        value: function removeVersionPrefixIfNeeded(versionLabel) {
	            return versionLabel.startsWith("v") ? versionLabel.substring(1) : versionLabel;
	        }
	    }, {
	        key: "renderVersion",
	        value: function renderVersion(version) {
	            return _react2.default.createElement(
	                "div",
	                { className: "pb3" },
	                _react2.default.createElement(
	                    "h3",
	                    { className: "text-grey-4" },
	                    this.removeVersionPrefixIfNeeded(version.version),
	                    " ",
	                    version.patch ? "(patch release)" : null
	                ),
	                _react2.default.createElement(
	                    "ul",
	                    { style: { listStyleType: "disc", listStylePosition: "inside" } },
	                    version.highlights && version.highlights.map(function (highlight) {
	                        return _react2.default.createElement(
	                            "li",
	                            { style: { lineHeight: "1.5" }, className: "pl1" },
	                            highlight
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: "renderVersionUpdateNotice",
	        value: function renderVersionUpdateNotice() {
	            var versionInfo = _underscore2.default.findWhere(this.props.settings, { key: "version-info" }),
	                currentVersion = _settings2.default.get("version").tag;
	
	            if (versionInfo) versionInfo = versionInfo.value;
	
	            /*
	                We expect the versionInfo to take on the JSON structure detailed below.
	                The 'older' section should contain only the last 5 previous versions, we don't need to go on forever.
	                The highlights for a version should just be text and should be limited to 5 items tops.
	                 {
	                    "latest": {
	                        "version": "v0.17.1",
	                        "released": "2016-05-04T21:09:36.358Z",
	                        "patch": true,
	                        "highlights":[
	                            "some stuff happened",
	                            "another great thing"
	                        ]
	                    },
	                    "older": [
	                        {
	                            "version": "v0.17.0",
	                            "released": "2016-05-04T21:09:36.358Z",
	                            "patch": false,
	                            "highlights": []
	                        },
	                        {
	                            "version": "v0.16.1",
	                            "released": "2016-05-04T21:09:36.358Z",
	                            "patch": true,
	                            "highlights": []
	                        }
	                    ]
	                }
	             */
	
	            if (!versionInfo || _utils2.default.compareVersions(currentVersion, versionInfo.latest.version) >= 0) {
	                return _react2.default.createElement(
	                    "div",
	                    { className: "p2 bg-brand bordered rounded border-brand text-white text-bold" },
	                    "You're running Metabase ",
	                    this.removeVersionPrefixIfNeeded(currentVersion),
	                    " which is the latest and greatest!"
	                );
	            } else {
	                return _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        { className: "p2 bg-green bordered rounded border-green flex flex-row align-center justify-between" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "text-white text-bold" },
	                            "Metabase ",
	                            this.removeVersionPrefixIfNeeded(versionInfo.latest.version),
	                            " is available.  You're running ",
	                            this.removeVersionPrefixIfNeeded(currentVersion)
	                        ),
	                        _react2.default.createElement(
	                            "a",
	                            { "data-metabase-event": "Updates Settings; Update link clicked; " + versionInfo.latest.version, className: "Button Button--white Button--medium borderless", href: "http://www.metabase.com/start", target: "_blank" },
	                            "Update"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "text-grey-3" },
	                        _react2.default.createElement(
	                            "h3",
	                            { className: "py3 text-uppercase" },
	                            "What's Changed:"
	                        ),
	                        this.renderVersion(versionInfo.latest),
	                        versionInfo.older && versionInfo.older.map(this.renderVersion.bind(this))
	                    )
	                );
	            }
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                elements = _props.elements,
	                _updateSetting = _props.updateSetting;
	
	
	            var settings = elements.map(function (setting, index) {
	                return _react2.default.createElement(_SettingsSetting2.default, {
	                    key: setting.key,
	                    setting: setting,
	                    updateSetting: function updateSetting(value) {
	                        return _updateSetting(setting, value);
	                    },
	                    autoFocus: index === 0
	                });
	            });
	
	            return _react2.default.createElement(
	                "div",
	                { style: { width: "585px" } },
	                _react2.default.createElement(
	                    "ul",
	                    null,
	                    settings
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "px2" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "pt3 border-top" },
	                        this.renderVersionUpdateNotice()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SettingsUpdatesForm;
	}(_react.Component), _class.propTypes = {
	    elements: _propTypes2.default.array
	}, _temp);
	SettingsUpdatesForm.displayName = "SettingsUpdatesForm";
	exports.default = SettingsUpdatesForm;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsSingleSignOnForm = (_temp = _class = function (_Component) {
	    _inherits(SettingsSingleSignOnForm, _Component);
	
	    function SettingsSingleSignOnForm(props, context) {
	        _classCallCheck(this, SettingsSingleSignOnForm);
	
	        var _this = _possibleConstructorReturn(this, (SettingsSingleSignOnForm.__proto__ || Object.getPrototypeOf(SettingsSingleSignOnForm)).call(this, props, context));
	
	        _this.updateClientID = _this.updateClientID.bind(_this);
	        _this.updateDomain = _this.updateDomain.bind(_this);
	        _this.onCheckboxClicked = _this.onCheckboxClicked.bind(_this), _this.saveChanges = _this.saveChanges.bind(_this), _this.clientIDChanged = _this.clientIDChanged.bind(_this), _this.domainChanged = _this.domainChanged.bind(_this);
	        return _this;
	    }
	
	    _createClass(SettingsSingleSignOnForm, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            var elements = this.props.elements,
	                clientID = _underscore2.default.findWhere(elements, { key: 'google-auth-client-id' }),
	                domain = _underscore2.default.findWhere(elements, { key: 'google-auth-auto-create-accounts-domain' });
	
	
	            this.setState({
	                clientID: clientID,
	                domain: domain,
	                clientIDValue: clientID.value,
	                domainValue: domain.value,
	                recentlySaved: false
	            });
	        }
	    }, {
	        key: "updateClientID",
	        value: function updateClientID(newValue) {
	            if (newValue === this.state.clientIDValue) return;
	
	            this.setState({
	                clientIDValue: newValue && newValue.length ? newValue : null,
	                recentlySaved: false
	            });
	        }
	    }, {
	        key: "updateDomain",
	        value: function updateDomain(newValue) {
	            if (newValue === this.state.domain.value) return;
	
	            this.setState({
	                domainValue: newValue && newValue.length ? newValue : null,
	                recentlySaved: false
	            });
	        }
	    }, {
	        key: "clientIDChanged",
	        value: function clientIDChanged() {
	            return this.state.clientID.value !== this.state.clientIDValue;
	        }
	    }, {
	        key: "domainChanged",
	        value: function domainChanged() {
	            return this.state.domain.value !== this.state.domainValue;
	        }
	    }, {
	        key: "saveChanges",
	        value: function saveChanges() {
	            var _state = this.state,
	                clientID = _state.clientID,
	                clientIDValue = _state.clientIDValue,
	                domain = _state.domain,
	                domainValue = _state.domainValue;
	
	
	            if (this.clientIDChanged()) {
	                this.props.updateSetting(clientID, clientIDValue);
	                this.setState({
	                    clientID: {
	                        value: clientIDValue
	                    },
	                    recentlySaved: true
	                });
	            }
	
	            if (this.domainChanged()) {
	                this.props.updateSetting(domain, domainValue);
	                this.setState({
	                    domain: {
	                        value: domainValue
	                    },
	                    recentlySaved: true
	                });
	            }
	        }
	    }, {
	        key: "onCheckboxClicked",
	        value: function onCheckboxClicked() {
	            // if domain is present, clear it out; otherwise if there's no domain try to set it back to what it was
	            this.setState({
	                domainValue: this.state.domainValue ? null : this.state.domain.value,
	                recentlySaved: false
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var hasChanges = this.domainChanged() || this.clientIDChanged(),
	                hasClientID = this.state.clientIDValue;
	
	            return _react2.default.createElement(
	                "form",
	                { noValidate: true },
	                _react2.default.createElement(
	                    "div",
	                    {
	                        className: "px2",
	                        style: { maxWidth: "585px" }
	                    },
	                    _react2.default.createElement(_Breadcrumbs2.default, {
	                        crumbs: [["Authentication", "/admin/settings/authentication"], ["Google Sign-In"]],
	                        className: "mb2"
	                    }),
	                    _react2.default.createElement(
	                        "h2",
	                        null,
	                        "Sign in with Google"
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "text-grey-4" },
	                        "Allows users with existing Metabase accounts to login with a Google account that matches their email address in addition to their Metabase username and password."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        { className: "text-grey-4" },
	                        "To allow users to sign in with Google you'll need to give Metabase a Google Developers console application client ID. It only takes a few steps and instructions on how to create a key can be found ",
	                        _react2.default.createElement(
	                            "a",
	                            { className: "link", href: "https://developers.google.com/identity/sign-in/web/devconsole-project", target: "_blank" },
	                            "here."
	                        )
	                    ),
	                    _react2.default.createElement(_Input2.default, {
	                        className: "SettingsInput AdminInput bordered rounded h3",
	                        type: "text",
	                        value: this.state.clientIDValue,
	                        placeholder: "Your Google client ID",
	                        onChange: function onChange(event) {
	                            return _this2.updateClientID(event.target.value);
	                        }
	                    }),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "py3" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex align-center" },
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-grey-4" },
	                                "Allow users to sign up on their own if their Google account email address is from:"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "mt1 bordered rounded inline-block" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "inline-block px2 h2" },
	                                "@"
	                            ),
	                            _react2.default.createElement(_Input2.default, {
	                                className: "SettingsInput inline-block AdminInput h3 border-left",
	                                type: "text",
	                                value: this.state.domainValue,
	                                onChange: function onChange(event) {
	                                    return _this2.updateDomain(event.target.value);
	                                },
	                                disabled: !hasClientID
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "button",
	                        { className: (0, _classnames2.default)("Button mr2", { "Button--primary": hasChanges }),
	                            disabled: !hasChanges,
	                            onClick: this.saveChanges },
	                        this.state.recentlySaved ? "Changes saved!" : "Save Changes"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SettingsSingleSignOnForm;
	}(_react.Component), _class.propTypes = {
	    elements: _propTypes2.default.array,
	    updateSetting: _propTypes2.default.func.isRequired
	}, _temp);
	SettingsSingleSignOnForm.displayName = "SettingsSingleSignOnForm";
	exports.default = SettingsSingleSignOnForm;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsAuthenticationOptions = function (_Component) {
	    _inherits(SettingsAuthenticationOptions, _Component);
	
	    function SettingsAuthenticationOptions() {
	        _classCallCheck(this, SettingsAuthenticationOptions);
	
	        return _possibleConstructorReturn(this, (SettingsAuthenticationOptions.__proto__ || Object.getPrototypeOf(SettingsAuthenticationOptions)).apply(this, arguments));
	    }
	
	    _createClass(SettingsAuthenticationOptions, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'ul',
	                { className: 'text-measure' },
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'bordered rounded shadowed bg-white p4' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Sign in with Google'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Allows users with existing Metabase accounts to login with a Google account that matches their email address in addition to their Metabase username and password.'
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { className: 'Button', to: '/admin/settings/authentication/google' },
	                            'Configure'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: 'mt2' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'bordered rounded shadowed bg-white p4' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'LDAP'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Allows users within your LDAP directory to log in to Metabase with their LDAP credentials, and allows automatic mapping of LDAP groups to Metabase groups.'
	                        ),
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { className: 'Button', to: '/admin/settings/authentication/ldap' },
	                            'Configure'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SettingsAuthenticationOptions;
	}(_react.Component);
	
	SettingsAuthenticationOptions.displayName = 'SettingsAuthenticationOptions';
	exports.default = SettingsAuthenticationOptions;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingsSetting = __webpack_require__(1872);
	
	var _SettingsSetting2 = _interopRequireDefault(_SettingsSetting);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _costs = __webpack_require__(1895);
	
	var _costs2 = _interopRequireDefault(_costs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var SettingsXrayForm = function SettingsXrayForm(_ref) {
	    var settings = _ref.settings,
	        elements = _ref.elements,
	        _updateSetting = _ref.updateSetting;
	
	    var maxCost = Object.assign.apply(Object, [{}].concat(_toConsumableArray(elements.filter(function (e) {
	        return e.key === 'xray-max-cost';
	    }))));
	    var enabled = Object.assign.apply(Object, [{}].concat(_toConsumableArray(elements.filter(function (e) {
	        return e.key === 'enable-xrays';
	    }))));
	
	    // handle the current behavior of the default
	    if (maxCost.value == null) {
	        maxCost.value = 'extended';
	    }
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'mx2' },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'X-Rays and Comparisons'
	            )
	        ),
	        _react2.default.createElement(
	            'ol',
	            { className: 'mt4' },
	            _react2.default.createElement(_SettingsSetting2.default, {
	                key: enabled.key,
	                setting: enabled,
	                updateSetting: function updateSetting(value) {
	                    return _updateSetting(enabled, value);
	                }
	            })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'mx2 text-measure' },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'Maximum Cost'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'm0 text-paragraph' },
	                'If you\'re having performance issues related to x-ray usage you can cap how expensive x-rays are allowed to be.'
	            ),
	            _react2.default.createElement(
	                'p',
	                { className: 'text-paragraph' },
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Note:'
	                    ),
	                    ' "Extended" is required for viewing time series x-rays.'
	                )
	            ),
	            _react2.default.createElement(
	                'ol',
	                { className: 'mt4' },
	                Object.keys(_costs2.default).map(function (key) {
	                    var cost = _costs2.default[key];
	                    return _react2.default.createElement(
	                        'li',
	                        {
	                            className: (0, _classnames2.default)('flex align-center mb2 cursor-pointer text-brand-hover', { 'text-brand': maxCost.value === key }),
	                            key: key,
	                            onClick: function onClick() {
	                                return _updateSetting(maxCost, key);
	                            }
	                        },
	                        _react2.default.createElement(_Icon2.default, {
	                            className: 'flex-no-shrink',
	                            name: cost.icon,
	                            size: 24
	                        }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'ml2' },
	                            _react2.default.createElement(
	                                'h4',
	                                null,
	                                cost.display_name
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'm0 text-paragraph' },
	                                cost.description
	                            )
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	SettingsXrayForm.displayName = 'SettingsXrayForm';
	exports.default = SettingsXrayForm;

/***/ }),
/* 1895 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* Combinations of MaxQueryCost and MaxComputationCost values combined into
	 * human understandable groupings.
	 * for more info on the actual values see src/metabase/fingerprints/costs.clj
	 */
	
	var approximate = {
	    display_name: "Approximate",
	    description: '\n        Get a sense for this data by looking at a sample.\n        This is faster but less precise.\n    ',
	    method: {
	        max_query_cost: 'sample',
	        max_computation_cost: 'linear'
	    },
	    icon: 'costapproximate'
	};
	
	var exact = {
	    display_name: "Exact",
	    description: '\n        Go deeper into this data by performing a full scan.\n        This is more precise but slower.\n    ',
	    method: {
	        max_query_cost: 'full-scan',
	        max_computation_cost: 'unbounded'
	    },
	    icon: 'costexact'
	};
	
	var extended = {
	    display_name: "Extended",
	    description: '\n        Adds additional info about this entity by including related objects.\n        This is the slowest but highest fidelity method.\n    ',
	    method: {
	        max_query_cost: 'joins',
	        max_computation_cost: 'unbounded'
	    },
	    icon: 'costextended'
	};
	
	exports.default = {
	    approximate: approximate,
	    exact: exact,
	    extended: extended
	};

/***/ }),
/* 1896 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// in order to prevent collection of identifying information only fields
	// that are explicitly marked as collectable or booleans should show the true value
	var prepareAnalyticsValue = exports.prepareAnalyticsValue = function prepareAnalyticsValue(setting) {
	    return setting.allowValueCollection || setting.type === "boolean" ? setting.value : "success";
	};

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getActiveSection = exports.getActiveSectionName = exports.getSections = exports.getNewVersionAvailable = exports.getSettingValues = exports.getSettings = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reselect = __webpack_require__(1072);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _formatting = __webpack_require__(872);
	
	var _CustomGeoJSONWidget = __webpack_require__(1898);
	
	var _CustomGeoJSONWidget2 = _interopRequireDefault(_CustomGeoJSONWidget);
	
	var _PublicLinksListing = __webpack_require__(1899);
	
	var _SecretKeyWidget = __webpack_require__(1900);
	
	var _SecretKeyWidget2 = _interopRequireDefault(_SecretKeyWidget);
	
	var _EmbeddingLegalese = __webpack_require__(1901);
	
	var _EmbeddingLegalese2 = _interopRequireDefault(_EmbeddingLegalese);
	
	var _LdapGroupMappingsWidget = __webpack_require__(1902);
	
	var _LdapGroupMappingsWidget2 = _interopRequireDefault(_LdapGroupMappingsWidget);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var SECTIONS = [{
	    name: "Setup",
	    settings: []
	}, {
	    name: "General",
	    settings: [{
	        key: "site-name",
	        display_name: "Site Name",
	        type: "string"
	    }, {
	        key: "site-url",
	        display_name: "Site URL",
	        type: "string"
	    }, {
	        key: "admin-email",
	        display_name: "Email Address for Help Requests",
	        type: "string"
	    }, {
	        key: "report-timezone",
	        display_name: "Report Timezone",
	        type: "select",
	        options: [{ name: "Database Default", value: "" }].concat(_toConsumableArray(_settings2.default.get('timezones'))),
	        placeholder: "Select a timezone",
	        note: "Not all databases support timezones, in which case this setting won't take effect.",
	        allowValueCollection: true
	    }, {
	        key: "anon-tracking-enabled",
	        display_name: "Anonymous Tracking",
	        type: "boolean"
	    }, {
	        key: "enable-advanced-humanization",
	        display_name: "Friendly Table and Field Names",
	        type: "boolean"
	    }, {
	        key: "enable-nested-queries",
	        display_name: "Enable Nested Queries",
	        type: "boolean"
	    }]
	}, {
	    name: "Updates",
	    settings: [{
	        key: "check-for-updates",
	        display_name: "Check for updates",
	        type: "boolean"
	    }]
	}, {
	    name: "Email",
	    settings: [{
	        key: "email-smtp-host",
	        display_name: "SMTP Host",
	        placeholder: "smtp.yourservice.com",
	        type: "string",
	        required: true,
	        autoFocus: true
	    }, {
	        key: "email-smtp-port",
	        display_name: "SMTP Port",
	        placeholder: "587",
	        type: "number",
	        required: true,
	        validations: [["integer", "That's not a valid port number"]]
	    }, {
	        key: "email-smtp-security",
	        display_name: "SMTP Security",
	        description: null,
	        type: "radio",
	        options: { none: "None", ssl: "SSL", tls: "TLS", starttls: "STARTTLS" },
	        defaultValue: 'none'
	    }, {
	        key: "email-smtp-username",
	        display_name: "SMTP Username",
	        description: null,
	        placeholder: "youlooknicetoday",
	        type: "string"
	    }, {
	        key: "email-smtp-password",
	        display_name: "SMTP Password",
	        description: null,
	        placeholder: "Shh...",
	        type: "password"
	    }, {
	        key: "email-from-address",
	        display_name: "From Address",
	        placeholder: "metabase@yourcompany.com",
	        type: "string",
	        required: true,
	        validations: [["email", "That's not a valid email address"]]
	    }]
	}, {
	    name: "Slack",
	    settings: [{
	        key: "slack-token",
	        display_name: "Slack API Token",
	        description: "",
	        placeholder: "Enter the token you received from Slack",
	        type: "string",
	        required: false,
	        autoFocus: true
	    }, {
	        key: "metabot-enabled",
	        display_name: "MetaBot",
	        type: "boolean",
	        // TODO: why do we have "defaultValue" in addition to "default" in the backend?
	        defaultValue: false,
	        required: true,
	        autoFocus: false
	    }]
	}, {
	    name: "Single Sign-On",
	    sidebar: false,
	    settings: [{
	        key: "google-auth-client-id"
	    }, {
	        key: "google-auth-auto-create-accounts-domain"
	    }]
	}, {
	    name: "Authentication",
	    settings: []
	}, {
	    name: "LDAP",
	    sidebar: false,
	    settings: [{
	        key: "ldap-enabled",
	        display_name: "LDAP Authentication",
	        description: null,
	        type: "boolean"
	    }, {
	        key: "ldap-host",
	        display_name: "LDAP Host",
	        placeholder: "ldap.yourdomain.org",
	        type: "string",
	        required: true,
	        autoFocus: true
	    }, {
	        key: "ldap-port",
	        display_name: "LDAP Port",
	        placeholder: "389",
	        type: "string",
	        validations: [["integer", "That's not a valid port number"]]
	    }, {
	        key: "ldap-security",
	        display_name: "LDAP Security",
	        description: null,
	        type: "radio",
	        options: { none: "None", ssl: "SSL", starttls: "StartTLS" },
	        defaultValue: "none"
	    }, {
	        key: "ldap-bind-dn",
	        display_name: "Username or DN",
	        type: "string"
	    }, {
	        key: "ldap-password",
	        display_name: "Password",
	        type: "password"
	    }, {
	        key: "ldap-user-base",
	        display_name: "User search base",
	        type: "string",
	        required: true
	    }, {
	        key: "ldap-user-filter",
	        display_name: "User filter",
	        type: "string",
	        validations: [["ldap_filter", "Check your parentheses"]]
	    }, {
	        key: "ldap-attribute-email",
	        display_name: "Email attribute",
	        type: "string"
	    }, {
	        key: "ldap-attribute-firstname",
	        display_name: "First name attribute",
	        type: "string"
	    }, {
	        key: "ldap-attribute-lastname",
	        display_name: "Last name attribute",
	        type: "string"
	    }, {
	        key: "ldap-group-sync",
	        display_name: "Synchronize group memberships",
	        description: null,
	        widget: _LdapGroupMappingsWidget2.default
	    }, {
	        key: "ldap-group-base",
	        display_name: "Group search base",
	        type: "string"
	    }, {
	        key: "ldap-group-mappings"
	    }]
	}, {
	    name: "Maps",
	    settings: [{
	        key: "map-tile-server-url",
	        display_name: "Map tile server URL",
	        note: "Metabase uses OpenStreetMaps by default.",
	        type: "string"
	    }, {
	        key: "custom-geojson",
	        display_name: "Custom Maps",
	        description: "Add your own GeoJSON files to enable different region map visualizations",
	        widget: _CustomGeoJSONWidget2.default,
	        noHeader: true
	    }]
	}, {
	    name: "Public Sharing",
	    settings: [{
	        key: "enable-public-sharing",
	        display_name: "Enable Public Sharing",
	        type: "boolean"
	    }, {
	        key: "-public-sharing-dashboards",
	        display_name: "Shared Dashboards",
	        widget: _PublicLinksListing.PublicLinksDashboardListing,
	        getHidden: function getHidden(settings) {
	            return !settings["enable-public-sharing"];
	        }
	    }, {
	        key: "-public-sharing-questions",
	        display_name: "Shared Questions",
	        widget: _PublicLinksListing.PublicLinksQuestionListing,
	        getHidden: function getHidden(settings) {
	            return !settings["enable-public-sharing"];
	        }
	    }]
	}, {
	    name: "Embedding in other Applications",
	    settings: [{
	        key: "enable-embedding",
	        description: null,
	        widget: _EmbeddingLegalese2.default,
	        getHidden: function getHidden(settings) {
	            return settings["enable-embedding"];
	        },
	        onChanged: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(oldValue, newValue, settingsValues, onChange) {
	                var result;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                if (!(!oldValue && newValue && !settingsValues["embedding-secret-key"])) {
	                                    _context.next = 6;
	                                    break;
	                                }
	
	                                _context.next = 3;
	                                return _services.UtilApi.random_token();
	
	                            case 3:
	                                result = _context.sent;
	                                _context.next = 6;
	                                return onChange("embedding-secret-key", result.token);
	
	                            case 6:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, undefined);
	            }));
	
	            return function onChanged(_x, _x2, _x3, _x4) {
	                return _ref.apply(this, arguments);
	            };
	        }()
	    }, {
	        key: "enable-embedding",
	        display_name: "Enable Embedding Metabase in other Applications",
	        type: "boolean",
	        getHidden: function getHidden(settings) {
	            return !settings["enable-embedding"];
	        }
	    }, {
	        key: "embedding-secret-key",
	        display_name: "Embedding secret key",
	        widget: _SecretKeyWidget2.default,
	        getHidden: function getHidden(settings) {
	            return !settings["enable-embedding"];
	        }
	    }, {
	        key: "-embedded-dashboards",
	        display_name: "Embedded Dashboards",
	        widget: _PublicLinksListing.EmbeddedDashboardListing,
	        getHidden: function getHidden(settings) {
	            return !settings["enable-embedding"];
	        }
	    }, {
	        key: "-embedded-questions",
	        display_name: "Embedded Questions",
	        widget: _PublicLinksListing.EmbeddedQuestionListing,
	        getHidden: function getHidden(settings) {
	            return !settings["enable-embedding"];
	        }
	    }]
	}, {
	    name: "Caching",
	    settings: [{
	        key: "enable-query-caching",
	        display_name: "Enable Caching",
	        type: "boolean"
	    }, {
	        key: "query-caching-min-ttl",
	        display_name: "Minimum Query Duration",
	        type: "number",
	        getHidden: function getHidden(settings) {
	            return !settings["enable-query-caching"];
	        },
	        allowValueCollection: true
	    }, {
	        key: "query-caching-ttl-ratio",
	        display_name: "Cache Time-To-Live (TTL) multiplier",
	        type: "number",
	        getHidden: function getHidden(settings) {
	            return !settings["enable-query-caching"];
	        },
	        allowValueCollection: true
	    }, {
	        key: "query-caching-max-kb",
	        display_name: "Max Cache Entry Size",
	        type: "number",
	        getHidden: function getHidden(settings) {
	            return !settings["enable-query-caching"];
	        },
	        allowValueCollection: true
	    }]
	}, {
	    name: "X-Rays",
	    settings: [{
	        key: "enable-xrays",
	        display_name: "Enable X-Rays",
	        type: "boolean",
	        allowValueCollection: true
	    }, {
	        key: "xray-max-cost",
	        type: "string",
	        allowValueCollection: true
	
	    }]
	}];
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;
	
	try {
	    for (var _iterator = SECTIONS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var section = _step.value;
	
	        section.slug = (0, _formatting.slugify)(section.name);
	    }
	} catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	} finally {
	    try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	        }
	    } finally {
	        if (_didIteratorError) {
	            throw _iteratorError;
	        }
	    }
	}
	
	var getSettings = exports.getSettings = (0, _reselect.createSelector)(function (state) {
	    return state.settings.settings;
	}, function (state) {
	    return state.admin.settings.warnings;
	}, function (settings, warnings) {
	    return settings.map(function (setting) {
	        return warnings[setting.key] ? _extends({}, setting, { warning: warnings[setting.key] }) : setting;
	    });
	});
	
	var getSettingValues = exports.getSettingValues = (0, _reselect.createSelector)(getSettings, function (settings) {
	    var settingValues = {};
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	        for (var _iterator2 = settings[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var setting = _step2.value;
	
	            settingValues[setting.key] = setting.value;
	        }
	    } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	            }
	        } finally {
	            if (_didIteratorError2) {
	                throw _iteratorError2;
	            }
	        }
	    }
	
	    return settingValues;
	});
	
	var getNewVersionAvailable = exports.getNewVersionAvailable = (0, _reselect.createSelector)(getSettings, function (settings) {
	    return _settings2.default.newVersionAvailable(settings);
	});
	
	var getSections = exports.getSections = (0, _reselect.createSelector)(getSettings, function (settings) {
	    if (!settings || _underscore2.default.isEmpty(settings)) {
	        return [];
	    }
	
	    var settingsByKey = _underscore2.default.groupBy(settings, 'key');
	    return SECTIONS.map(function (section) {
	        var sectionSettings = section.settings.map(function (setting) {
	            var apiSetting = settingsByKey[setting.key] && settingsByKey[setting.key][0];
	            if (apiSetting) {
	                return _extends({
	                    placeholder: apiSetting.default
	                }, apiSetting, setting);
	            } else {
	                return setting;
	            }
	        });
	        return _extends({}, section, {
	            settings: sectionSettings
	        });
	    });
	});
	
	var getActiveSectionName = exports.getActiveSectionName = function getActiveSectionName(state, props) {
	    return props.params.section;
	};
	
	var getActiveSection = exports.getActiveSection = (0, _reselect.createSelector)(getActiveSectionName, getSections, function () {
	    var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "setup";
	    var sections = arguments[1];
	
	    if (sections) {
	        return _underscore2.default.findWhere(sections, { slug: section });
	    } else {
	        return null;
	    }
	});

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Confirm = __webpack_require__(1245);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Ellipsified = __webpack_require__(1277);
	
	var _Ellipsified2 = _interopRequireDefault(_Ellipsified);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _SettingHeader = __webpack_require__(1873);
	
	var _SettingHeader2 = _interopRequireDefault(_SettingHeader);
	
	var _services = __webpack_require__(857);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LeafletChoropleth = __webpack_require__(1409);
	
	var _LeafletChoropleth2 = _interopRequireDefault(_LeafletChoropleth);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomGeoJSONWidget = (_temp = _class = function (_Component) {
	    _inherits(CustomGeoJSONWidget, _Component);
	
	    function CustomGeoJSONWidget(props, context) {
	        var _this2 = this;
	
	        _classCallCheck(this, CustomGeoJSONWidget);
	
	        var _this = _possibleConstructorReturn(this, (CustomGeoJSONWidget.__proto__ || Object.getPrototypeOf(CustomGeoJSONWidget)).call(this, props, context));
	
	        _this._saveMap = function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(id, map) {
	                var setting, value, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step$value, existingId, existingMap;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                setting = _this.props.setting;
	                                value = {};
	                                _iteratorNormalCompletion = true;
	                                _didIteratorError = false;
	                                _iteratorError = undefined;
	                                _context.prev = 5;
	
	                                for (_iterator = Object.entries(setting.value)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                    _step$value = _slicedToArray(_step.value, 2), existingId = _step$value[0], existingMap = _step$value[1];
	
	                                    if (!existingMap.builtin) {
	                                        value[existingId] = _extends({}, existingMap, { id: undefined });
	                                    }
	                                }
	                                _context.next = 13;
	                                break;
	
	                            case 9:
	                                _context.prev = 9;
	                                _context.t0 = _context["catch"](5);
	                                _didIteratorError = true;
	                                _iteratorError = _context.t0;
	
	                            case 13:
	                                _context.prev = 13;
	                                _context.prev = 14;
	
	                                if (!_iteratorNormalCompletion && _iterator.return) {
	                                    _iterator.return();
	                                }
	
	                            case 16:
	                                _context.prev = 16;
	
	                                if (!_didIteratorError) {
	                                    _context.next = 19;
	                                    break;
	                                }
	
	                                throw _iteratorError;
	
	                            case 19:
	                                return _context.finish(16);
	
	                            case 20:
	                                return _context.finish(13);
	
	                            case 21:
	                                if (map) {
	                                    value[id] = _extends({}, map, { id: undefined });
	                                } else {
	                                    delete value[id];
	                                }
	
	                                _context.next = 24;
	                                return _services.SettingsApi.put({
	                                    key: "custom-geojson",
	                                    value: value
	                                });
	
	                            case 24:
	                                _context.next = 26;
	                                return _this.props.reloadSettings();
	
	                            case 26:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, _this2, [[5, 9, 13, 21], [14,, 16, 20]]);
	            }));
	
	            return function (_x, _x2) {
	                return _ref.apply(this, arguments);
	            };
	        }();
	
	        _this._save = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	            var map;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            map = _this.state.map;
	                            _context2.next = 3;
	                            return _this._saveMap(map.id, map);
	
	                        case 3:
	                            _this.setState({ map: null, originalMap: null });
	
	                        case 4:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, _this2);
	        }));
	        _this._cancel = _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
	            var _this$state, map, originalMap;
	
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _this$state = _this.state, map = _this$state.map, originalMap = _this$state.originalMap;
	                            _context3.next = 3;
	                            return _this._saveMap(map.id, originalMap);
	
	                        case 3:
	                            _this.setState({ map: null, originalMap: null });
	
	                        case 4:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, _this2);
	        }));
	
	        _this._delete = function () {
	            var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(map) {
	                return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                _context4.next = 2;
	                                return _this._saveMap(map.id, null);
	
	                            case 2:
	                            case "end":
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, _this2);
	            }));
	
	            return function (_x3) {
	                return _ref4.apply(this, arguments);
	            };
	        }();
	
	        _this._loadGeoJson = _asyncToGenerator(regeneratorRuntime.mark(function _callee5() {
	            var map, geoJson;
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            _context5.prev = 0;
	                            map = _this.state.map;
	
	                            _this.setState({
	                                geoJson: null,
	                                geoJsonLoading: true,
	                                geoJsonError: null
	                            });
	                            _context5.next = 5;
	                            return _this._saveMap(map.id, map);
	
	                        case 5:
	                            _context5.next = 7;
	                            return _services.GeoJSONApi.get({ id: map.id });
	
	                        case 7:
	                            geoJson = _context5.sent;
	
	                            _this.setState({
	                                geoJson: geoJson,
	                                geoJsonLoading: false,
	                                geoJsonError: null
	                            });
	                            _context5.next = 15;
	                            break;
	
	                        case 11:
	                            _context5.prev = 11;
	                            _context5.t0 = _context5["catch"](0);
	
	                            _this.setState({
	                                geoJson: null,
	                                geoJsonLoading: false,
	                                geoJsonError: _context5.t0
	                            });
	                            console.warn("map fetch failed", _context5.t0);
	
	                        case 15:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, _this2, [[0, 11]]);
	        }));
	
	        _this.state = {
	            map: null,
	            originalMap: null,
	            geoJson: null,
	            geoJsonLoading: false,
	            geoJsonError: null
	        };
	        return _this;
	    }
	
	    // This is a bit of a hack, but the /api/geojson endpoint only works if the map is saved in the custom-geojson setting
	
	
	    _createClass(CustomGeoJSONWidget, [{
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var setting = this.props.setting;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex-full" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex" },
	                    _react2.default.createElement(_SettingHeader2.default, { setting: setting }),
	                    !this.state.map && _react2.default.createElement(
	                        "button",
	                        {
	                            className: "Button Button--primary flex-align-right",
	                            onClick: function onClick() {
	                                return _this3.setState({
	                                    map: {
	                                        id: _utils2.default.uuid(),
	                                        name: "",
	                                        url: "",
	                                        region_key: null,
	                                        region_name: null
	                                    },
	                                    originalMap: null,
	                                    geoJson: null,
	                                    geoJsonLoading: false,
	                                    geoJsonError: null
	                                });
	                            }
	                        },
	                        "Add a map"
	                    )
	                ),
	                _react2.default.createElement(ListMaps, {
	                    maps: Object.entries(setting.value).map(function (_ref6) {
	                        var _ref7 = _slicedToArray(_ref6, 2),
	                            key = _ref7[0],
	                            value = _ref7[1];
	
	                        return _extends({}, value, { id: key });
	                    }),
	                    onEditMap: function onEditMap(map) {
	                        return _this3.setState({
	                            map: _extends({}, map),
	                            originalMap: map,
	                            geoJson: null,
	                            geoJsonLoading: false,
	                            geoJsonError: null
	                        }, _this3._loadGeoJson);
	                    },
	                    onDeleteMap: this._delete
	                }),
	                this.state.map ? _react2.default.createElement(
	                    _Modal2.default,
	                    { wide: true },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "p4" },
	                        _react2.default.createElement(EditMap, {
	                            map: this.state.map,
	                            originalMap: this.state.originalMap,
	                            onMapChange: function onMapChange(map) {
	                                return _this3.setState({ map: map });
	                            },
	                            geoJson: this.state.geoJson,
	                            geoJsonLoading: this.state.geoJsonLoading,
	                            geoJsonError: this.state.geoJsonError,
	                            onLoadGeoJson: this._loadGeoJson,
	                            onCancel: this._cancel,
	                            onSave: this._save
	                        })
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return CustomGeoJSONWidget;
	}(_react.Component), _class.propTypes = {
	    setting: _propTypes2.default.object.isRequired,
	    updateSetting: _propTypes2.default.func.isRequired,
	    reloadSettings: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {}, _temp);
	CustomGeoJSONWidget.displayName = "CustomGeoJSONWidget";
	exports.default = CustomGeoJSONWidget;
	
	
	var ListMaps = function ListMaps(_ref8) {
	    var maps = _ref8.maps,
	        onEditMap = _ref8.onEditMap,
	        onDeleteMap = _ref8.onDeleteMap;
	    return _react2.default.createElement(
	        "section",
	        null,
	        _react2.default.createElement(
	            "table",
	            { className: "ContentTable" },
	            _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                    "tr",
	                    null,
	                    _react2.default.createElement(
	                        "th",
	                        null,
	                        "Name"
	                    ),
	                    _react2.default.createElement(
	                        "th",
	                        null,
	                        "URL"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "tbody",
	                null,
	                maps.filter(function (map) {
	                    return !map.builtin;
	                }).map(function (map) {
	                    return _react2.default.createElement(
	                        "tr",
	                        { key: map.id },
	                        _react2.default.createElement(
	                            "td",
	                            { className: "cursor-pointer", onClick: function onClick() {
	                                    return onEditMap(map);
	                                } },
	                            map.name
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            { className: "cursor-pointer", onClick: function onClick() {
	                                    return onEditMap(map);
	                                } },
	                            _react2.default.createElement(
	                                _Ellipsified2.default,
	                                { style: { maxWidth: 600 } },
	                                map.url
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "td",
	                            { className: "Table-actions" },
	                            _react2.default.createElement(
	                                _Confirm2.default,
	                                { action: function action() {
	                                        return onDeleteMap(map);
	                                    }, title: "Delete custom map" },
	                                _react2.default.createElement(
	                                    "button",
	                                    { className: "Button Button--danger" },
	                                    "Remove"
	                                )
	                            )
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	ListMaps.displayName = "ListMaps";
	var GeoJsonPropertySelect = function GeoJsonPropertySelect(_ref9) {
	    var value = _ref9.value,
	        _onChange = _ref9.onChange,
	        geoJson = _ref9.geoJson;
	
	    var options = {};
	    if (geoJson) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = geoJson.features[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var feature = _step2.value;
	
	                for (var property in feature.properties) {
	                    options[property] = options[property] || [];
	                    options[property].push(feature.properties[property]);
	                }
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	    }
	
	    return _react2.default.createElement(
	        _Select2.default,
	        {
	            value: value,
	            onChange: function onChange(e) {
	                return _onChange(e.target.value);
	            },
	            placeholder: "Select\u2026"
	        },
	        Object.entries(options).map(function (_ref10) {
	            var _ref11 = _slicedToArray(_ref10, 2),
	                name = _ref11[0],
	                values = _ref11[1];
	
	            return _react2.default.createElement(
	                _Select.Option,
	                { key: name, value: name },
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        name
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "mt1 h6", style: { maxWidth: 250, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } },
	                        "Sample values: ",
	                        values.join(", ")
	                    )
	                )
	            );
	        })
	    );
	};
	
	GeoJsonPropertySelect.displayName = "GeoJsonPropertySelect";
	var SettingContainer = function SettingContainer(_ref12) {
	    var name = _ref12.name,
	        description = _ref12.description,
	        _ref12$className = _ref12.className,
	        className = _ref12$className === undefined ? "py1" : _ref12$className,
	        children = _ref12.children;
	    return _react2.default.createElement(
	        "div",
	        { className: className },
	        name && _react2.default.createElement(
	            "div",
	            { className: "text-grey-4 text-bold text-uppercase my1" },
	            name
	        ),
	        description && _react2.default.createElement(
	            "div",
	            { className: "text-grey-4 my1" },
	            description
	        ),
	        children
	    );
	};
	
	SettingContainer.displayName = "SettingContainer";
	var EditMap = function EditMap(_ref13) {
	    var map = _ref13.map,
	        onMapChange = _ref13.onMapChange,
	        originalMap = _ref13.originalMap,
	        geoJson = _ref13.geoJson,
	        geoJsonLoading = _ref13.geoJsonLoading,
	        geoJsonError = _ref13.geoJsonError,
	        onLoadGeoJson = _ref13.onLoadGeoJson,
	        onCancel = _ref13.onCancel,
	        onSave = _ref13.onSave;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "flex" },
	            _react2.default.createElement(
	                "div",
	                { className: "flex-no-shrink" },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    !originalMap ? "Add a new map" : "Edit map"
	                ),
	                _react2.default.createElement(
	                    SettingContainer,
	                    { description: "What do you want to call this map?" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex" },
	                        _react2.default.createElement("input", {
	                            type: "text",
	                            className: "SettingsInput AdminInput bordered rounded h3",
	                            placeholder: "e.g. United Kingdom, Brazil, Mars",
	                            value: map.name,
	                            onChange: function onChange(e) {
	                                return onMapChange(_extends({}, map, { "name": e.target.value }));
	                            }
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    SettingContainer,
	                    { description: "URL for the GeoJSON file you want to use" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "flex" },
	                        _react2.default.createElement("input", {
	                            type: "text",
	                            className: "SettingsInput AdminInput bordered rounded h3",
	                            placeholder: "Like https://my-mb-server.com/maps/my-map.json",
	                            value: map.url,
	                            onChange: function onChange(e) {
	                                return onMapChange(_extends({}, map, { "url": e.target.value }));
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "button",
	                            { className: (0, _classnames2.default)("Button ml1", { "Button--primary": !geoJson, disabled: !map.url }), onClick: onLoadGeoJson },
	                            geoJson ? "Refresh" : "Load"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)({ "disabled": !geoJson }) },
	                    _react2.default.createElement(
	                        SettingContainer,
	                        { description: "Which property specifies the region\u2019s identifier?" },
	                        _react2.default.createElement(GeoJsonPropertySelect, {
	                            value: map.region_key,
	                            onChange: function onChange(value) {
	                                return onMapChange(_extends({}, map, { "region_key": value }));
	                            },
	                            geoJson: geoJson
	                        })
	                    ),
	                    _react2.default.createElement(
	                        SettingContainer,
	                        { description: "Which property specifies the region\u2019s display name?" },
	                        _react2.default.createElement(GeoJsonPropertySelect, {
	                            value: map.region_name,
	                            onChange: function onChange(value) {
	                                return onMapChange(_extends({}, map, { "region_name": value }));
	                            },
	                            geoJson: geoJson
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "flex-full ml4 relative bordered rounded flex my4" },
	                geoJson || geoJsonLoading || geoJsonError ? _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: geoJsonLoading, error: geoJsonError },
	                    function () {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: "m4 spread relative" },
	                            _react2.default.createElement(ChoroplethPreview, { geoJson: geoJson })
	                        );
	                    }
	                ) : _react2.default.createElement(
	                    "div",
	                    { className: "flex-full flex layout-centered text-bold text-grey-1 text-centered" },
	                    "Load a GeoJSON file to see a preview"
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "py1 flex" },
	            _react2.default.createElement(
	                "div",
	                { className: "ml-auto" },
	                _react2.default.createElement(
	                    "button",
	                    { className: (0, _classnames2.default)("Button Button"), onClick: onCancel },
	                    "Cancel"
	                ),
	                _react2.default.createElement(
	                    "button",
	                    { className: (0, _classnames2.default)("Button Button--primary ml1", { "disabled": !map.name || !map.url || !map.region_name || !map.region_key }), onClick: onSave },
	                    originalMap ? "Save map" : "Add map"
	                )
	            )
	        )
	    );
	};
	
	EditMap.displayName = "EditMap";
	var ChoroplethPreview = (0, _pure2.default)(function (_ref14) {
	    var geoJson = _ref14.geoJson;
	    return _react2.default.createElement(_LeafletChoropleth2.default, { geoJson: geoJson });
	});

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EmbeddedQuestionListing = exports.EmbeddedDashboardListing = exports.PublicLinksQuestionListing = exports.PublicLinksDashboardListing = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Link = __webpack_require__(1567);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ExternalLink = __webpack_require__(875);
	
	var _ExternalLink2 = _interopRequireDefault(_ExternalLink);
	
	var _Confirm = __webpack_require__(1245);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _services = __webpack_require__(857);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PublicLinksListing = function (_Component) {
	    _inherits(PublicLinksListing, _Component);
	
	    function PublicLinksListing(props) {
	        _classCallCheck(this, PublicLinksListing);
	
	        var _this = _possibleConstructorReturn(this, (PublicLinksListing.__proto__ || Object.getPrototypeOf(PublicLinksListing)).call(this, props));
	
	        _this.state = {
	            list: null,
	            error: null
	        };
	        return _this;
	    }
	
	    _createClass(PublicLinksListing, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.load();
	        }
	    }, {
	        key: "load",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var _list;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return this.props.load();
	
	                            case 3:
	                                _list = _context.sent;
	
	                                this.setState({ list: _list });
	                                _context.next = 10;
	                                break;
	
	                            case 7:
	                                _context.prev = 7;
	                                _context.t0 = _context["catch"](0);
	
	                                this.setState({ error: _context.t0 });
	
	                            case 10:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 7]]);
	            }));
	
	            function load() {
	                return _ref.apply(this, arguments);
	            }
	
	            return load;
	        }()
	    }, {
	        key: "revoke",
	        value: function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(link) {
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                if (this.props.revoke) {
	                                    _context2.next = 2;
	                                    break;
	                                }
	
	                                return _context2.abrupt("return");
	
	                            case 2:
	                                _context2.prev = 2;
	                                _context2.next = 5;
	                                return this.props.revoke(link);
	
	                            case 5:
	                                this.load();
	                                _context2.next = 11;
	                                break;
	
	                            case 8:
	                                _context2.prev = 8;
	                                _context2.t0 = _context2["catch"](2);
	
	                                alert(_context2.t0);
	
	                            case 11:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this, [[2, 8]]);
	            }));
	
	            function revoke(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return revoke;
	        }()
	    }, {
	        key: "trackEvent",
	        value: function trackEvent(label) {
	            _analytics2.default.trackEvent("Admin " + this.props.type, label);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                getUrl = _props.getUrl,
	                getPublicUrl = _props.getPublicUrl,
	                revoke = _props.revoke,
	                noLinksMessage = _props.noLinksMessage;
	            var _state = this.state,
	                list = _state.list,
	                error = _state.error;
	
	
	            if (list && list.length === 0) {
	                error = new Error(noLinksMessage);
	            }
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: !list, error: error },
	                function () {
	                    return _react2.default.createElement(
	                        "table",
	                        { className: "ContentTable" },
	                        _react2.default.createElement(
	                            "thead",
	                            null,
	                            _react2.default.createElement(
	                                "tr",
	                                null,
	                                _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "Name"
	                                ),
	                                getPublicUrl && _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "Public Link"
	                                ),
	                                revoke && _react2.default.createElement(
	                                    "th",
	                                    null,
	                                    "Revoke Link"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "tbody",
	                            null,
	                            list && list.map(function (link) {
	                                return _react2.default.createElement(
	                                    "tr",
	                                    null,
	                                    _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _react2.default.createElement(
	                                            _Link2.default,
	                                            {
	                                                to: getUrl(link),
	                                                onClick: function onClick() {
	                                                    return _this2.trackEvent('Entity Link Clicked');
	                                                }
	                                            },
	                                            link.name
	                                        )
	                                    ),
	                                    getPublicUrl && _react2.default.createElement(
	                                        "td",
	                                        null,
	                                        _react2.default.createElement(
	                                            _ExternalLink2.default,
	                                            {
	                                                href: getPublicUrl(link),
	                                                onClick: function onClick() {
	                                                    return _this2.trackEvent('Public Link Clicked');
	                                                }
	                                            },
	                                            getPublicUrl(link)
	                                        )
	                                    ),
	                                    revoke && _react2.default.createElement(
	                                        "td",
	                                        { className: "flex layout-centered" },
	                                        _react2.default.createElement(
	                                            _Confirm2.default,
	                                            {
	                                                title: "Disable this link?",
	                                                content: "They won't work any more, and can't be restored, but you can create new links.",
	                                                action: function action() {
	                                                    _this2.revoke(link);
	                                                    _this2.trackEvent('Revoked link');
	                                                }
	                                            },
	                                            _react2.default.createElement(_Icon2.default, {
	                                                name: "close",
	                                                className: "text-grey-2 text-grey-4-hover cursor-pointer"
	                                            })
	                                        )
	                                    )
	                                );
	                            })
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return PublicLinksListing;
	}(_react.Component);
	
	PublicLinksListing.displayName = "PublicLinksListing";
	exports.default = PublicLinksListing;
	var PublicLinksDashboardListing = exports.PublicLinksDashboardListing = function PublicLinksDashboardListing() {
	    return _react2.default.createElement(PublicLinksListing, {
	        load: _services.DashboardApi.listPublic,
	        revoke: _services.DashboardApi.deletePublicLink,
	        type: "Public Dashboard Listing",
	        getUrl: function getUrl(_ref3) {
	            var id = _ref3.id;
	            return Urls.dashboard(id);
	        },
	        getPublicUrl: function getPublicUrl(_ref4) {
	            var public_uuid = _ref4.public_uuid;
	            return Urls.publicDashboard(public_uuid);
	        },
	        noLinksMessage: "No dashboards have been publicly shared yet."
	    });
	};
	
	PublicLinksDashboardListing.displayName = "PublicLinksDashboardListing";
	var PublicLinksQuestionListing = exports.PublicLinksQuestionListing = function PublicLinksQuestionListing() {
	    return _react2.default.createElement(PublicLinksListing, {
	        load: _services.CardApi.listPublic,
	        revoke: _services.CardApi.deletePublicLink,
	        type: "Public Card Listing",
	        getUrl: function getUrl(_ref5) {
	            var id = _ref5.id;
	            return Urls.question(id);
	        },
	        getPublicUrl: function getPublicUrl(_ref6) {
	            var public_uuid = _ref6.public_uuid;
	            return Urls.publicCard(public_uuid);
	        },
	        noLinksMessage: "No questions have been publicly shared yet."
	    });
	};
	
	PublicLinksQuestionListing.displayName = "PublicLinksQuestionListing";
	var EmbeddedDashboardListing = exports.EmbeddedDashboardListing = function EmbeddedDashboardListing() {
	    return _react2.default.createElement(PublicLinksListing, {
	        load: _services.DashboardApi.listEmbeddable,
	        getUrl: function getUrl(_ref7) {
	            var id = _ref7.id;
	            return Urls.dashboard(id);
	        },
	        type: "Embedded Dashboard Listing",
	        noLinksMessage: "No dashboards have been embedded yet."
	    });
	};
	
	EmbeddedDashboardListing.displayName = "EmbeddedDashboardListing";
	var EmbeddedQuestionListing = exports.EmbeddedQuestionListing = function EmbeddedQuestionListing() {
	    return _react2.default.createElement(PublicLinksListing, {
	        load: _services.CardApi.listEmbeddable,
	        getUrl: function getUrl(_ref8) {
	            var id = _ref8.id;
	            return Urls.question(id);
	        },
	        type: "Embedded Card Listing",
	        noLinksMessage: "No questions have been embedded yet."
	    });
	};
	EmbeddedQuestionListing.displayName = "EmbeddedQuestionListing";

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingInput = __webpack_require__(1874);
	
	var _SettingInput2 = _interopRequireDefault(_SettingInput);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Confirm = __webpack_require__(1245);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SecretKeyWidget = function (_Component) {
	    _inherits(SecretKeyWidget, _Component);
	
	    function SecretKeyWidget() {
	        var _ref,
	            _this2 = this;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SecretKeyWidget);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SecretKeyWidget.__proto__ || Object.getPrototypeOf(SecretKeyWidget)).call.apply(_ref, [this].concat(args))), _this), _this._generateToken = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	            var updateSetting, result;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            updateSetting = _this.props.updateSetting;
	                            _context.next = 3;
	                            return _services.UtilApi.random_token();
	
	                        case 3:
	                            result = _context.sent;
	
	                            updateSetting(result.token);
	
	                        case 5:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2);
	        })), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SecretKeyWidget, [{
	        key: "render",
	        value: function render() {
	            var setting = this.props.setting;
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex align-center" },
	                _react2.default.createElement(_SettingInput2.default, this.props),
	                setting.value ? _react2.default.createElement(
	                    _Confirm2.default,
	                    {
	                        title: "Regenerate embedding key?",
	                        content: "This will cause existing embeds to stop working until they are updated with the new key.",
	                        action: this._generateToken
	                    },
	                    _react2.default.createElement(
	                        _Button2.default,
	                        { className: "ml1", primary: true, medium: true },
	                        "Regenerate key"
	                    )
	                ) : _react2.default.createElement(
	                    _Button2.default,
	                    { className: "ml1", primary: true, medium: true, onClick: this._generateToken },
	                    "Generate Key"
	                )
	            );
	        }
	    }]);
	
	    return SecretKeyWidget;
	}(_react.Component);
	
	SecretKeyWidget.displayName = "SecretKeyWidget";
	exports.default = SecretKeyWidget;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmbeddingLegalese = function EmbeddingLegalese(_ref) {
	    var updateSetting = _ref.updateSetting;
	    return _react2.default.createElement(
	        'div',
	        { className: 'bordered rounded text-measure p4' },
	        _react2.default.createElement(
	            'h3',
	            { className: 'text-brand' },
	            'Using embedding'
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'text-grey-4', style: { lineHeight: 1.48 } },
	            'By enabling embedding you\'re agreeing to the embedding license located at ',
	            _react2.default.createElement(
	                'a',
	                { className: 'link', href: 'http://www.metabase.com/license/embedding', target: '_blank' },
	                'metabase.com/license/embedding'
	            ),
	            '.'
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'text-grey-4', style: { lineHeight: 1.48 } },
	            '            In plain english, when you embed charts or dashboards from Metabase in your own application, that application isn\'t subject to the Affero General Public License that covers the rest of Metabase, provided you keep the Metabase logo and the "Powered by Metabase" visible on those embeds. You should however, read the license text linked above as that is the actual license that you will be agreeing to by enabling this feature.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'flex layout-centered mt4' },
	            _react2.default.createElement(
	                'button',
	                {
	                    className: 'Button Button--primary',
	                    onClick: function onClick() {
	                        _analytics2.default.trackEvent("Admin Embed Settings", "Embedding Enable Click");
	                        updateSetting(true);
	                    }
	                },
	                'Enable'
	            )
	        )
	    );
	};
	
	EmbeddingLegalese.displayName = 'EmbeddingLegalese';
	exports.default = EmbeddingLegalese;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _AdminContentTable = __webpack_require__(1903);
	
	var _AdminContentTable2 = _interopRequireDefault(_AdminContentTable);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _GroupSelect = __webpack_require__(1904);
	
	var _GroupSelect2 = _interopRequireDefault(_GroupSelect);
	
	var _GroupSummary = __webpack_require__(1905);
	
	var _GroupSummary2 = _interopRequireDefault(_GroupSummary);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoadingSpinner = __webpack_require__(1281);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _services = __webpack_require__(857);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _SettingToggle = __webpack_require__(1878);
	
	var _SettingToggle2 = _interopRequireDefault(_SettingToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LdapGroupMappingsWidget = function (_React$Component) {
	    _inherits(LdapGroupMappingsWidget, _React$Component);
	
	    function LdapGroupMappingsWidget(props, context) {
	        _classCallCheck(this, LdapGroupMappingsWidget);
	
	        var _this = _possibleConstructorReturn(this, (LdapGroupMappingsWidget.__proto__ || Object.getPrototypeOf(LdapGroupMappingsWidget)).call(this, props, context));
	
	        _this._showEditModal = function (e) {
	            e.preventDefault();
	            _this.setState({ mappings: _this.props.mappings || {}, showEditModal: true });
	            _services.PermissionsApi.groups().then(function (groups) {
	                return _this.setState({ groups: groups });
	            });
	        };
	
	        _this._showAddRow = function (e) {
	            e.preventDefault();
	            _this.setState({ showAddRow: true });
	        };
	
	        _this._hideAddRow = function () {
	            _this.setState({ showAddRow: false });
	        };
	
	        _this._addMapping = function (dn) {
	            _this.setState(function (prevState) {
	                return { mappings: _extends({}, prevState.mappings, _defineProperty({}, dn, [])), showAddRow: false };
	            });
	        };
	
	        _this._changeMapping = function (dn) {
	            return function (group, selected) {
	                if (selected) {
	                    _this.setState(function (prevState) {
	                        return {
	                            mappings: _extends({}, prevState.mappings, _defineProperty({}, dn, [].concat(_toConsumableArray(prevState.mappings[dn]), [group.id])))
	                        };
	                    });
	                } else {
	                    _this.setState(function (prevState) {
	                        return {
	                            mappings: _extends({}, prevState.mappings, _defineProperty({}, dn, prevState.mappings[dn].filter(function (id) {
	                                return id !== group.id;
	                            })))
	                        };
	                    });
	                }
	            };
	        };
	
	        _this._deleteMapping = function (dn) {
	            return function (e) {
	                e.preventDefault();
	                _this.setState(function (prevState) {
	                    return { mappings: _underscore2.default.omit(prevState.mappings, dn) };
	                });
	            };
	        };
	
	        _this._cancelClick = function (e) {
	            e.preventDefault();
	            _this.setState({ showEditModal: false, showAddRow: false });
	        };
	
	        _this._saveClick = function (e) {
	            e.preventDefault();
	            var mappings = _this.state.mappings,
	                updateMappings = _this.props.updateMappings;
	
	            _services.SettingsApi.put({ key: "ldap-group-mappings", value: mappings }).then(function () {
	                updateMappings && updateMappings(mappings);
	                _this.setState({ showEditModal: false, showAddRow: false });
	            });
	        };
	
	        _this.state = {
	            showEditModal: false,
	            showAddRow: false,
	            groups: [],
	            mappings: {}
	        };
	        return _this;
	    }
	
	    _createClass(LdapGroupMappingsWidget, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                showEditModal = _state.showEditModal,
	                showAddRow = _state.showAddRow,
	                groups = _state.groups,
	                mappings = _state.mappings;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "flex align-center" },
	                _react2.default.createElement(_SettingToggle2.default, this.props),
	                _react2.default.createElement(
	                    "div",
	                    { className: "flex align-center pt1" },
	                    _react2.default.createElement(
	                        _Button2.default,
	                        { type: "button", className: "ml1", medium: true, onClick: this._showEditModal },
	                        "Edit Mappings"
	                    )
	                ),
	                showEditModal ? _react2.default.createElement(
	                    _Modal2.default,
	                    { wide: true },
	                    _react2.default.createElement(
	                        "div",
	                        null,
	                        _react2.default.createElement(
	                            "div",
	                            { className: "pt4 px4" },
	                            _react2.default.createElement(
	                                "h2",
	                                null,
	                                "Group Mappings"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "px4" },
	                            _react2.default.createElement(
	                                _Button2.default,
	                                { className: "float-right", primary: true, onClick: this._showAddRow },
	                                "Create a mapping"
	                            ),
	                            _react2.default.createElement(
	                                "p",
	                                { className: "text-measure" },
	                                "Mappings allow Metabase to automatically add and remove users from groups based on the membership information provided by the directory server. Membership to the Admin group can be granted through mappings, but will not be automatically removed as a failsafe measure."
	                            ),
	                            _react2.default.createElement(
	                                _AdminContentTable2.default,
	                                { columnTitles: ['Distinguished Name', 'Groups', ''] },
	                                showAddRow ? _react2.default.createElement(AddMappingRow, { mappings: mappings, onCancel: this._hideAddRow, onAdd: this._addMapping }) : null,
	                                Object.entries(mappings).map(function (_ref) {
	                                    var _ref2 = _slicedToArray(_ref, 2),
	                                        dn = _ref2[0],
	                                        ids = _ref2[1];
	
	                                    return _react2.default.createElement(MappingRow, {
	                                        key: dn,
	                                        dn: dn,
	                                        groups: groups,
	                                        selectedGroups: ids,
	                                        onChange: _this2._changeMapping(dn),
	                                        onDelete: _this2._deleteMapping(dn)
	                                    });
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            _ModalContent.ModalFooter,
	                            null,
	                            _react2.default.createElement(
	                                _Button2.default,
	                                { type: "button", onClick: this._cancelClick },
	                                "Cancel"
	                            ),
	                            _react2.default.createElement(
	                                _Button2.default,
	                                { primary: true, onClick: this._saveClick },
	                                "Save"
	                            )
	                        )
	                    )
	                ) : null
	            );
	        }
	    }]);
	
	    return LdapGroupMappingsWidget;
	}(_react2.default.Component);
	
	LdapGroupMappingsWidget.displayName = "LdapGroupMappingsWidget";
	exports.default = LdapGroupMappingsWidget;
	
	var AddMappingRow = function (_React$Component2) {
	    _inherits(AddMappingRow, _React$Component2);
	
	    function AddMappingRow(props, context) {
	        _classCallCheck(this, AddMappingRow);
	
	        var _this3 = _possibleConstructorReturn(this, (AddMappingRow.__proto__ || Object.getPrototypeOf(AddMappingRow)).call(this, props, context));
	
	        _this3._handleCancelClick = function (e) {
	            e.preventDefault();
	            var onCancel = _this3.props.onCancel;
	
	            onCancel && onCancel();
	            _this3.setState({ value: '' });
	        };
	
	        _this3._handleAddClick = function (e) {
	            e.preventDefault();
	            var onAdd = _this3.props.onAdd;
	
	            onAdd && onAdd(_this3.state.value);
	            _this3.setState({ value: '' });
	        };
	
	        _this3.state = {
	            value: ''
	        };
	        return _this3;
	    }
	
	    _createClass(AddMappingRow, [{
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            var value = this.state.value;
	
	
	            var isValid = value && this.props.mappings[value] === undefined;
	
	            return _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "td",
	                    { colSpan: "3", style: { padding: 0 } },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "my2 pl1 p1 bordered border-brand rounded relative flex align-center" },
	                        _react2.default.createElement("input", {
	                            className: "input--borderless h3 ml1 flex-full",
	                            type: "text",
	                            value: value,
	                            placeholder: "cn=People,ou=Groups,dc=metabase,dc=com",
	                            autoFocus: true,
	                            onChange: function onChange(e) {
	                                return _this4.setState({ value: e.target.value });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "span",
	                            { className: "link no-decoration cursor-pointer", onClick: this._handleCancelClick },
	                            "Cancel"
	                        ),
	                        _react2.default.createElement(
	                            _Button2.default,
	                            { className: "ml2", primary: !!isValid, disabled: !isValid, onClick: this._handleAddClick },
	                            "Add"
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddMappingRow;
	}(_react2.default.Component);
	
	AddMappingRow.displayName = "AddMappingRow";
	
	var MappingGroupSelect = function (_React$Component3) {
	    _inherits(MappingGroupSelect, _React$Component3);
	
	    function MappingGroupSelect() {
	        _classCallCheck(this, MappingGroupSelect);
	
	        return _possibleConstructorReturn(this, (MappingGroupSelect.__proto__ || Object.getPrototypeOf(MappingGroupSelect)).apply(this, arguments));
	    }
	
	    _createClass(MappingGroupSelect, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                groups = _props.groups,
	                selectedGroups = _props.selectedGroups,
	                onGroupChange = _props.onGroupChange;
	
	
	            if (!groups || groups.length === 0) {
	                return _react2.default.createElement(_LoadingSpinner2.default, null);
	            }
	
	            var selected = selectedGroups.reduce(function (g, id) {
	                return _extends({}, g, _defineProperty({}, id, true));
	            }, {});
	
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                {
	                    ref: "popover",
	                    triggerElement: _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "mr1 text-grey-4" },
	                            _react2.default.createElement(_GroupSummary2.default, { groups: groups, selectedGroups: selected })
	                        ),
	                        _react2.default.createElement(_Icon2.default, { className: "text-grey-2", name: "chevrondown", size: 10 })
	                    ),
	                    triggerClasses: "AdminSelectBorderless py1",
	                    sizeToFit: true
	                },
	                _react2.default.createElement(_GroupSelect2.default, { groups: groups, selectedGroups: selected, onGroupChange: onGroupChange })
	            );
	        }
	    }]);
	
	    return MappingGroupSelect;
	}(_react2.default.Component);
	
	MappingGroupSelect.displayName = "MappingGroupSelect";
	
	var MappingRow = function (_React$Component4) {
	    _inherits(MappingRow, _React$Component4);
	
	    function MappingRow() {
	        _classCallCheck(this, MappingRow);
	
	        return _possibleConstructorReturn(this, (MappingRow.__proto__ || Object.getPrototypeOf(MappingRow)).apply(this, arguments));
	    }
	
	    _createClass(MappingRow, [{
	        key: "render",
	        value: function render() {
	            var _props2 = this.props,
	                dn = _props2.dn,
	                groups = _props2.groups,
	                selectedGroups = _props2.selectedGroups,
	                onChange = _props2.onChange,
	                onDelete = _props2.onDelete;
	
	
	            return _react2.default.createElement(
	                "tr",
	                null,
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    dn
	                ),
	                _react2.default.createElement(
	                    "td",
	                    null,
	                    _react2.default.createElement(MappingGroupSelect, {
	                        groups: groups,
	                        selectedGroups: selectedGroups,
	                        onGroupChange: onChange
	                    })
	                ),
	                _react2.default.createElement(
	                    "td",
	                    { className: "Table-actions" },
	                    _react2.default.createElement(
	                        _Button2.default,
	                        { warning: true, onClick: onDelete },
	                        "Remove"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return MappingRow;
	}(_react2.default.Component);
	
	MappingRow.displayName = "MappingRow";

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminContentTable = function AdminContentTable(_ref) {
	    var columnTitles = _ref.columnTitles,
	        children = _ref.children;
	    return _react2.default.createElement(
	        "table",
	        { className: "ContentTable" },
	        _react2.default.createElement(
	            "thead",
	            null,
	            _react2.default.createElement(
	                "tr",
	                null,
	                columnTitles && columnTitles.map(function (title, index) {
	                    return _react2.default.createElement(
	                        "th",
	                        { key: index },
	                        title
	                    );
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "tbody",
	            null,
	            children
	        )
	    );
	};
	
	AdminContentTable.displayName = "AdminContentTable";
	exports.default = AdminContentTable;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GroupSelect = exports.GroupOption = undefined;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CheckBox = __webpack_require__(1004);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _groups = __webpack_require__(1683);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupOption = exports.GroupOption = function GroupOption(_ref) {
	    var group = _ref.group,
	        _ref$selectedGroups = _ref.selectedGroups,
	        selectedGroups = _ref$selectedGroups === undefined ? {} : _ref$selectedGroups,
	        onGroupChange = _ref.onGroupChange;
	
	    var disabled = !(0, _groups.canEditMembership)(group);
	    var selected = (0, _groups.isDefaultGroup)(group) || selectedGroups[group.id];
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("GroupOption flex align-center p1 px2", { "cursor-pointer": !disabled }), onClick: function onClick() {
	                return !disabled && onGroupChange(group, !selected);
	            } },
	        _react2.default.createElement(
	            "span",
	            { className: (0, _classnames2.default)("pr1", (0, _groups.getGroupColor)(group), { disabled: disabled }) },
	            _react2.default.createElement(_CheckBox2.default, {
	                checked: selected,
	                size: 18
	            })
	        ),
	        group.name
	    );
	};
	
	GroupOption.displayName = "GroupOption";
	var GroupSelect = exports.GroupSelect = function GroupSelect(_ref2) {
	    var groups = _ref2.groups,
	        selectedGroups = _ref2.selectedGroups,
	        onGroupChange = _ref2.onGroupChange;
	
	    var other = groups.filter(function (g) {
	        return !(0, _groups.isAdminGroup)(g) && !(0, _groups.isDefaultGroup)(g);
	    });
	    return _react2.default.createElement(
	        "div",
	        { className: "GroupSelect py1" },
	        _react2.default.createElement(GroupOption, { group: _underscore2.default.find(groups, _groups.isAdminGroup), selectedGroups: selectedGroups, onGroupChange: onGroupChange }),
	        _react2.default.createElement(GroupOption, { group: _underscore2.default.find(groups, _groups.isDefaultGroup), selectedGroups: selectedGroups, onGroupChange: onGroupChange }),
	        other.length > 0 && _react2.default.createElement("div", { key: "divider", className: "border-bottom pb1 mb1" }),
	        other.map(function (group) {
	            return _react2.default.createElement(GroupOption, { group: group, selectedGroups: selectedGroups, onGroupChange: onGroupChange });
	        })
	    );
	};
	
	GroupSelect.displayName = "GroupSelect";
	exports.default = GroupSelect;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _formatting = __webpack_require__(872);
	
	var _groups = __webpack_require__(1683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupSummary = function GroupSummary(_ref) {
	    var groups = _ref.groups,
	        selectedGroups = _ref.selectedGroups;
	
	    var adminGroup = _underscore2.default.find(groups, _groups.isAdminGroup);
	    var otherGroups = groups.filter(function (g) {
	        return selectedGroups[g.id] && !(0, _groups.isAdminGroup)(g) && !(0, _groups.isDefaultGroup)(g);
	    });
	    if (selectedGroups[adminGroup.id]) {
	        return _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement(
	                "span",
	                { className: "text-purple" },
	                "Admin"
	            ),
	            otherGroups.length > 0 && " and ",
	            otherGroups.length > 0 && _react2.default.createElement(
	                "span",
	                { className: "text-brand" },
	                otherGroups.length + " other " + (0, _formatting.inflect)("group", otherGroups.length)
	            )
	        );
	    } else if (otherGroups.length === 1) {
	        return _react2.default.createElement(
	            "span",
	            { className: "text-brand" },
	            otherGroups[0].name
	        );
	    } else if (otherGroups.length > 1) {
	        return _react2.default.createElement(
	            "span",
	            { className: "text-brand" },
	            otherGroups.length + " " + (0, _formatting.inflect)("group", otherGroups.length)
	        );
	    } else {
	        return _react2.default.createElement(
	            "span",
	            null,
	            "Default"
	        );
	    }
	};
	
	exports.default = GroupSummary;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.warnings = exports.reloadSettings = exports.RELOAD_SETTINGS = exports.updateLdapSettings = exports.UPDATE_LDAP_SETTINGS = exports.updateSlackSettings = exports.UPDATE_SLACK_SETTINGS = exports.sendTestEmail = exports.SEND_TEST_EMAIL = exports.updateEmailSettings = exports.UPDATE_EMAIL_SETTINGS = exports.updateSetting = exports.UPDATE_SETTING = exports.initializeSettings = exports.INITIALIZE_SETTINGS = undefined;
	
	var _redux = __webpack_require__(657);
	
	var _services = __webpack_require__(857);
	
	var _settings = __webpack_require__(656);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// ACITON TYPES AND ACTION CREATORS
	
	var INITIALIZE_SETTINGS = exports.INITIALIZE_SETTINGS = "metabase/admin/settings/INITIALIZE_SETTINGS";
	var initializeSettings = exports.initializeSettings = (0, _redux.createThunkAction)(INITIALIZE_SETTINGS, function () {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return dispatch((0, _settings.refreshSiteSettings)());
	
	                        case 3:
	                            _context.next = 9;
	                            break;
	
	                        case 5:
	                            _context.prev = 5;
	                            _context.t0 = _context["catch"](0);
	
	                            console.log("error fetching settings", _context.t0);
	                            throw _context.t0;
	
	                        case 9:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[0, 5]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var UPDATE_SETTING = exports.UPDATE_SETTING = "metabase/admin/settings/UPDATE_SETTING";
	var updateSetting = exports.updateSetting = (0, _redux.createThunkAction)(UPDATE_SETTING, function (setting) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _services.SettingsApi.put(setting);
	
	                        case 3:
	                            _context2.next = 5;
	                            return dispatch((0, _settings.refreshSiteSettings)());
	
	                        case 5:
	                            _context2.next = 11;
	                            break;
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t0 = _context2["catch"](0);
	
	                            console.log("error updating setting", setting, _context2.t0);
	                            throw _context2.t0;
	
	                        case 11:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[0, 7]]);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	var UPDATE_EMAIL_SETTINGS = exports.UPDATE_EMAIL_SETTINGS = "metabase/admin/settings/UPDATE_EMAIL_SETTINGS";
	var updateEmailSettings = exports.updateEmailSettings = (0, _redux.createThunkAction)(UPDATE_EMAIL_SETTINGS, function (settings) {
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	            var result;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            _context3.prev = 0;
	                            _context3.next = 3;
	                            return _services.EmailApi.updateSettings(settings);
	
	                        case 3:
	                            result = _context3.sent;
	                            _context3.next = 6;
	                            return dispatch((0, _settings.refreshSiteSettings)());
	
	                        case 6:
	                            return _context3.abrupt("return", result);
	
	                        case 9:
	                            _context3.prev = 9;
	                            _context3.t0 = _context3["catch"](0);
	
	                            console.log("error updating email settings", settings, _context3.t0);
	                            throw _context3.t0;
	
	                        case 13:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this, [[0, 9]]);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	});
	
	var SEND_TEST_EMAIL = exports.SEND_TEST_EMAIL = "metabase/admin/settings/SEND_TEST_EMAIL";
	var sendTestEmail = exports.sendTestEmail = (0, _redux.createThunkAction)(SEND_TEST_EMAIL, function () {
	    return function () {
	        var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            _context4.prev = 0;
	                            _context4.next = 3;
	                            return _services.EmailApi.sendTest();
	
	                        case 3:
	                            _context4.next = 9;
	                            break;
	
	                        case 5:
	                            _context4.prev = 5;
	                            _context4.t0 = _context4["catch"](0);
	
	                            console.log("error sending test email", _context4.t0);
	                            throw _context4.t0;
	
	                        case 9:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, this, [[0, 5]]);
	        }));
	
	        return function (_x7, _x8) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	});
	
	var UPDATE_SLACK_SETTINGS = exports.UPDATE_SLACK_SETTINGS = "metabase/admin/settings/UPDATE_SLACK_SETTINGS";
	var updateSlackSettings = exports.updateSlackSettings = (0, _redux.createThunkAction)(UPDATE_SLACK_SETTINGS, function (settings) {
	    return function () {
	        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            _context5.prev = 0;
	                            _context5.next = 3;
	                            return _services.SlackApi.updateSettings(settings);
	
	                        case 3:
	                            _context5.next = 5;
	                            return dispatch((0, _settings.refreshSiteSettings)());
	
	                        case 5:
	                            _context5.next = 11;
	                            break;
	
	                        case 7:
	                            _context5.prev = 7;
	                            _context5.t0 = _context5["catch"](0);
	
	                            console.log("error updating slack settings", settings, _context5.t0);
	                            throw _context5.t0;
	
	                        case 11:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, this, [[0, 7]]);
	        }));
	
	        return function (_x9, _x10) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	}, {});
	
	var UPDATE_LDAP_SETTINGS = exports.UPDATE_LDAP_SETTINGS = "metabase/admin/settings/UPDATE_LDAP_SETTINGS";
	var updateLdapSettings = exports.updateLdapSettings = (0, _redux.createThunkAction)(UPDATE_LDAP_SETTINGS, function (settings) {
	    return function () {
	        var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            _context6.prev = 0;
	                            _context6.next = 3;
	                            return _services.LdapApi.updateSettings(settings);
	
	                        case 3:
	                            _context6.next = 5;
	                            return dispatch((0, _settings.refreshSiteSettings)());
	
	                        case 5:
	                            _context6.next = 11;
	                            break;
	
	                        case 7:
	                            _context6.prev = 7;
	                            _context6.t0 = _context6["catch"](0);
	
	                            console.log("error updating LDAP settings", settings, _context6.t0);
	                            throw _context6.t0;
	
	                        case 11:
	                        case "end":
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, this, [[0, 7]]);
	        }));
	
	        return function (_x11, _x12) {
	            return _ref6.apply(this, arguments);
	        };
	    }();
	});
	
	var RELOAD_SETTINGS = exports.RELOAD_SETTINGS = "metabase/admin/settings/RELOAD_SETTINGS";
	var reloadSettings = exports.reloadSettings = (0, _redux.createThunkAction)(RELOAD_SETTINGS, function () {
	    return function () {
	        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            _context7.next = 2;
	                            return dispatch((0, _settings.refreshSiteSettings)());
	
	                        case 2:
	                        case "end":
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, this);
	        }));
	
	        return function (_x13, _x14) {
	            return _ref7.apply(this, arguments);
	        };
	    }();
	});
	
	// REDUCERS
	
	var warnings = exports.warnings = (0, _redux.handleActions)(_defineProperty({}, UPDATE_EMAIL_SETTINGS, { next: function next(state, _ref8) {
	        var payload = _ref8.payload;
	        return payload["with-corrections"];
	    } }), {});
	
	exports.default = (0, _redux.combineReducers)({
	    warnings: warnings
	});

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UpdateCachedFieldValues = exports.RemappingNamingTip = exports.FieldRemapping = exports.SectionHeader = exports.Section = exports.FieldValueMapping = exports.ValueRemappings = exports.FieldHeader = exports.BackButton = exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class; /**
	                   * Settings editor for a single database field. Lets you change field type, visibility and display values / remappings.
	                   *
	                   * TODO Atte Keinänen 7/6/17: This uses the standard metadata API; we should migrate also other parts of admin section
	                   */
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _reactRedux = __webpack_require__(467);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _SaveStatus = __webpack_require__(1819);
	
	var _SaveStatus2 = _interopRequireDefault(_SaveStatus);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _ButtonWithStatus = __webpack_require__(1908);
	
	var _ButtonWithStatus2 = _interopRequireDefault(_ButtonWithStatus);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _metadata = __webpack_require__(1073);
	
	var _metadata2 = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata2);
	
	var _datamodel = __webpack_require__(1836);
	
	var datamodelActions = _interopRequireWildcard(_datamodel);
	
	var _ActionButton = __webpack_require__(1213);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _SelectButton = __webpack_require__(1909);
	
	var _SelectButton2 = _interopRequireDefault(_SelectButton);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _FieldList = __webpack_require__(979);
	
	var _FieldList2 = _interopRequireDefault(_FieldList);
	
	var _ColumnItem = __webpack_require__(1830);
	
	var _selectors = __webpack_require__(1835);
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _Question = __webpack_require__(895);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _Dimension = __webpack_require__(901);
	
	var _field = __webpack_require__(1910);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectClasses = 'h3 bordered border-dark shadowed p2 inline-block flex align-center rounded text-bold';
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        databaseId: parseInt(props.params.databaseId),
	        tableId: parseInt(props.params.tableId),
	        fieldId: parseInt(props.params.fieldId),
	        metadata: (0, _metadata.getMetadata)(state),
	        idfields: (0, _selectors.getDatabaseIdfields)(state)
	    };
	};
	
	var mapDispatchToProps = {
	    fetchDatabaseMetadata: metadataActions.fetchDatabaseMetadata,
	    fetchTableMetadata: metadataActions.fetchTableMetadata,
	    updateField: metadataActions.updateField,
	    updateFieldValues: metadataActions.updateFieldValues,
	    updateFieldDimension: metadataActions.updateFieldDimension,
	    deleteFieldDimension: metadataActions.deleteFieldDimension,
	    fetchDatabaseIdfields: datamodelActions.fetchDatabaseIdfields,
	    rescanFieldValues: _field.rescanFieldValues,
	    discardFieldValues: _field.discardFieldValues
	};
	
	var FieldApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(FieldApp, _Component);
	
	    function FieldApp() {
	        var _ref,
	            _this2 = this;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, FieldApp);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FieldApp.__proto__ || Object.getPrototypeOf(FieldApp)).call.apply(_ref, [this].concat(args))), _this), _this.linkWithSaveStatus = function (saveMethod) {
	            var self = _this;
	            return function () {
	                var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                    var _args = arguments;
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    self.saveStatus && self.saveStatus.setSaving();
	                                    _context.next = 3;
	                                    return saveMethod.apply(undefined, _args);
	
	                                case 3:
	                                    self.saveStatus && self.saveStatus.setSaved();
	
	                                case 4:
	                                case 'end':
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this2);
	                }));
	
	                return function () {
	                    return _ref2.apply(this, arguments);
	                };
	            }();
	        }, _this.onUpdateField = _this.linkWithSaveStatus(_this.props.updateField), _this.onUpdateFieldProperties = _this.linkWithSaveStatus(function () {
	            var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(fieldProps) {
	                var _this$props, metadata, fieldId, field;
	
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _this$props = _this.props, metadata = _this$props.metadata, fieldId = _this$props.fieldId;
	                                field = metadata.fields[fieldId];
	
	                                if (!field) {
	                                    _context2.next = 7;
	                                    break;
	                                }
	
	                                _context2.next = 5;
	                                return _this.props.updateField(_extends({}, field.getPlainObject(), fieldProps));
	
	                            case 5:
	                                _context2.next = 8;
	                                break;
	
	                            case 7:
	                                console.warn("Updating field properties in fields settings failed because of missing field metadata");
	
	                            case 8:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, _this2);
	            }));
	
	            return function (_x) {
	                return _ref3.apply(this, arguments);
	            };
	        }()), _this.onUpdateFieldValues = _this.linkWithSaveStatus(_this.props.updateFieldValues), _this.onUpdateFieldDimension = _this.linkWithSaveStatus(_this.props.updateFieldDimension), _this.onDeleteFieldDimension = _this.linkWithSaveStatus(_this.props.deleteFieldDimension), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(FieldApp, [{
	        key: 'componentWillMount',
	        value: function () {
	            var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
	                var _props, databaseId, tableId, fetchDatabaseMetadata, fetchTableMetadata, fetchDatabaseIdfields;
	
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _props = this.props, databaseId = _props.databaseId, tableId = _props.tableId, fetchDatabaseMetadata = _props.fetchDatabaseMetadata, fetchTableMetadata = _props.fetchTableMetadata, fetchDatabaseIdfields = _props.fetchDatabaseIdfields;
	
	                                // A complete database metadata is needed in case that foreign key is changed
	                                // and then we need to show FK remapping options for a new table
	
	                                _context3.next = 3;
	                                return fetchDatabaseMetadata(databaseId);
	
	                            case 3:
	                                _context3.next = 5;
	                                return fetchTableMetadata(tableId, true);
	
	                            case 5:
	                                _context3.next = 7;
	                                return fetchDatabaseIdfields(databaseId);
	
	                            case 7:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function componentWillMount() {
	                return _ref4.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                metadata = _props2.metadata,
	                fieldId = _props2.fieldId,
	                databaseId = _props2.databaseId,
	                tableId = _props2.tableId,
	                idfields = _props2.idfields,
	                fetchTableMetadata = _props2.fetchTableMetadata;
	
	
	            var db = metadata.databases[databaseId];
	            var field = metadata.fields[fieldId];
	            var table = metadata.tables[tableId];
	
	            var isLoading = !field || !table || !idfields;
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: isLoading, error: null, noWrapper: true },
	                function () {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'relative' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'wrapper wrapper--trim' },
	                            _react2.default.createElement(BackButton, { databaseId: databaseId, tableId: tableId }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'my4 py1 ml-auto mr-auto' },
	                                _react2.default.createElement(_Breadcrumbs2.default, {
	                                    crumbs: [[db.name, '/admin/datamodel/database/' + db.id], [table.display_name, '/admin/datamodel/database/' + db.id + '/table/' + table.id], field.display_name + ' \u2013 Field Settings']
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'absolute top right mt4 mr4' },
	                                _react2.default.createElement(_SaveStatus2.default, { ref: function ref(_ref5) {
	                                        return _this3.saveStatus = _ref5;
	                                    } })
	                            ),
	                            _react2.default.createElement(
	                                Section,
	                                null,
	                                _react2.default.createElement(FieldHeader, {
	                                    field: field,
	                                    updateFieldProperties: _this3.onUpdateFieldProperties,
	                                    updateFieldDimension: _this3.onUpdateFieldDimension
	                                })
	                            ),
	                            _react2.default.createElement(
	                                Section,
	                                null,
	                                _react2.default.createElement(SectionHeader, { title: 'Visibility',
	                                    description: 'Where this field will appear throughout Metabase' }),
	                                _react2.default.createElement(_ColumnItem.FieldVisibilityPicker, {
	                                    triggerClasses: SelectClasses,
	                                    field: field.getPlainObject(),
	                                    updateField: _this3.onUpdateField
	                                })
	                            ),
	                            _react2.default.createElement(
	                                Section,
	                                null,
	                                _react2.default.createElement(SectionHeader, { title: 'Type' }),
	                                _react2.default.createElement(_ColumnItem.SpecialTypeAndTargetPicker, {
	                                    triggerClasses: SelectClasses,
	                                    field: field.getPlainObject(),
	                                    updateField: _this3.onUpdateField,
	                                    idfields: idfields,
	                                    selectSeparator: _react2.default.createElement(SelectSeparator, null)
	                                })
	                            ),
	                            _react2.default.createElement(
	                                Section,
	                                null,
	                                _react2.default.createElement(FieldRemapping, {
	                                    field: field,
	                                    table: table,
	                                    fields: metadata.fields,
	                                    updateFieldProperties: _this3.onUpdateFieldProperties,
	                                    updateFieldValues: _this3.onUpdateFieldValues,
	                                    updateFieldDimension: _this3.onUpdateFieldDimension,
	                                    deleteFieldDimension: _this3.onDeleteFieldDimension,
	                                    fetchTableMetadata: fetchTableMetadata
	                                })
	                            ),
	                            _react2.default.createElement(
	                                Section,
	                                null,
	                                _react2.default.createElement(UpdateCachedFieldValues, {
	                                    rescanFieldValues: function rescanFieldValues() {
	                                        return _this3.props.rescanFieldValues(field.id);
	                                    },
	                                    discardFieldValues: function discardFieldValues() {
	                                        return _this3.props.discardFieldValues(field.id);
	                                    }
	                                })
	                            )
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return FieldApp;
	}(_react.Component)) || _class);
	FieldApp.displayName = 'FieldApp';
	exports.default = FieldApp;
	
	
	// TODO: Should this invoke goBack() instead?
	// not sure if it's possible to do that neatly with Link component
	var BackButton = exports.BackButton = function BackButton(_ref6) {
	    var databaseId = _ref6.databaseId,
	        tableId = _ref6.tableId;
	    return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	            to: '/admin/datamodel/database/' + databaseId + '/table/' + tableId,
	            className: 'circle text-white p2 mt3 ml3 flex align-center justify-center  absolute top left',
	            style: { backgroundColor: '#8091AB' }
	        },
	        _react2.default.createElement(_Icon2.default, { name: 'backArrow' })
	    );
	};
	
	BackButton.displayName = 'BackButton';
	var SelectSeparator = function SelectSeparator() {
	    return _react2.default.createElement(_Icon2.default, {
	        name: 'chevronright',
	        size: 12,
	        className: 'mx2 text-grey-3'
	    });
	};
	
	SelectSeparator.displayName = 'SelectSeparator';
	
	var FieldHeader = exports.FieldHeader = function (_Component2) {
	    _inherits(FieldHeader, _Component2);
	
	    function FieldHeader() {
	        var _ref7,
	            _this5 = this;
	
	        var _temp2, _this4, _ret2;
	
	        _classCallCheck(this, FieldHeader);
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref7 = FieldHeader.__proto__ || Object.getPrototypeOf(FieldHeader)).call.apply(_ref7, [this].concat(args))), _this4), _this4.onNameChange = function (e) {
	            _this4.updateNameDebounced(e.target.value);
	        }, _this4.onDescriptionChange = function (e) {
	            _this4.updateDescriptionDebounced(e.target.value);
	        }, _this4.updateNameDebounced = _underscore2.default.debounce(function () {
	            var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(name) {
	                var _this4$props, field, updateFieldProperties, updateFieldDimension;
	
	                return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                _this4$props = _this4.props, field = _this4$props.field, updateFieldProperties = _this4$props.updateFieldProperties, updateFieldDimension = _this4$props.updateFieldDimension;
	
	                                // Update the dimension name if it exists
	                                // TODO: Have a separate input field for the dimension name?
	
	                                if (_underscore2.default.isEmpty(field.dimensions)) {
	                                    _context4.next = 4;
	                                    break;
	                                }
	
	                                _context4.next = 4;
	                                return updateFieldDimension(field.id, {
	                                    type: field.dimensions.type,
	                                    human_readable_field_id: field.dimensions.human_readable_field_id,
	                                    name: name
	                                });
	
	                            case 4:
	
	                                // todo: how to treat empty / too long strings? see how this is done in Column
	                                updateFieldProperties({ display_name: name });
	
	                            case 5:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, _this5);
	            }));
	
	            return function (_x2) {
	                return _ref8.apply(this, arguments);
	            };
	        }(), 300), _this4.updateDescriptionDebounced = _underscore2.default.debounce(function (description) {
	            var updateFieldProperties = _this4.props.updateFieldProperties;
	
	            updateFieldProperties({ description: description });
	        }, 300), _temp2), _possibleConstructorReturn(_this4, _ret2);
	    }
	
	    // Separate update methods because of throttling the input
	
	
	    _createClass(FieldHeader, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_Input2.default, {
	                    className: 'h1 AdminInput bordered rounded border-dark block mb1',
	                    value: this.props.field.display_name,
	                    onChange: this.onNameChange,
	                    placeholder: this.props.field.name
	                }),
	                _react2.default.createElement(_Input2.default, {
	                    className: 'text AdminInput bordered input text-measure block full',
	                    value: this.props.field.description,
	                    onChange: this.onDescriptionChange,
	                    placeholder: 'No description for this field yet'
	                })
	            );
	        }
	    }]);
	
	    return FieldHeader;
	}(_react.Component);
	
	FieldHeader.displayName = 'FieldHeader';
	
	// consider renaming this component to something more descriptive
	var ValueRemappings = exports.ValueRemappings = function (_Component3) {
	    _inherits(ValueRemappings, _Component3);
	
	    function ValueRemappings(props, context) {
	        _classCallCheck(this, ValueRemappings);
	
	        var _this6 = _possibleConstructorReturn(this, (ValueRemappings.__proto__ || Object.getPrototypeOf(ValueRemappings)).call(this, props, context));
	
	        _this6.onSaveClick = function () {
	            _analytics2.default.trackEvent("Data Model", "Update Custom Remappings");
	            // Returns the promise so that ButtonWithStatus can show the saving status
	            return _this6.props.updateRemappings(_this6.state.editingRemappings);
	        };
	
	        _this6.customValuesAreNonEmpty = function () {
	            return Array.from(_this6.state.editingRemappings.values()).every(function (value) {
	                return value !== "";
	            });
	        };
	
	        var editingRemappings = new Map([].concat(_toConsumableArray(props.remappings)).map(function (_ref9) {
	            var _ref10 = _slicedToArray(_ref9, 2),
	                original = _ref10[0],
	                mappedOrUndefined = _ref10[1];
	
	            // Use currently the original value as the "default custom mapping" as the current backend implementation
	            // requires that all original values must have corresponding mappings
	
	            // Additionally, the defensive `.toString` ensures that the mapped value definitely will be string
	            var mappedString = mappedOrUndefined !== undefined ? mappedOrUndefined.toString() : original.toString();
	
	            return [original, mappedString];
	        }));
	
	        var containsUnsetMappings = [].concat(_toConsumableArray(props.remappings)).some(function (_ref11) {
	            var _ref12 = _slicedToArray(_ref11, 2),
	                _ = _ref12[0],
	                mappedOrUndefined = _ref12[1];
	
	            return mappedOrUndefined === undefined;
	        });
	        if (containsUnsetMappings) {
	            // Save the initial values to make sure that we aren't left in a potentially broken state where
	            // the dimension type is "internal" but we don't have any values in metabase_fieldvalues
	            _this6.props.updateRemappings(editingRemappings);
	        }
	
	        _this6.state = {
	            editingRemappings: editingRemappings
	        };
	        return _this6;
	    }
	
	    _createClass(ValueRemappings, [{
	        key: 'onSetRemapping',
	        value: function onSetRemapping(original, newMapped) {
	            this.setState({
	                editingRemappings: new Map([].concat(_toConsumableArray(this.state.editingRemappings), [[original, newMapped]]))
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this7 = this;
	
	            var editingRemappings = this.state.editingRemappings;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'bordered rounded py2 px4 border-dark' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex align-center my1 pb2 border-bottom' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Original value'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'ml-auto' },
	                        'Mapped value'
	                    )
	                ),
	                _react2.default.createElement(
	                    'ol',
	                    null,
	                    [].concat(_toConsumableArray(editingRemappings)).map(function (_ref13) {
	                        var _ref14 = _slicedToArray(_ref13, 2),
	                            original = _ref14[0],
	                            mapped = _ref14[1];
	
	                        return _react2.default.createElement(
	                            'li',
	                            { className: 'mb1' },
	                            _react2.default.createElement(FieldValueMapping, {
	                                original: original,
	                                mapped: mapped,
	                                setMapping: function setMapping(newMapped) {
	                                    return _this7.onSetRemapping(original, newMapped);
	                                }
	                            })
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex align-center' },
	                    _react2.default.createElement(
	                        _ButtonWithStatus2.default,
	                        {
	                            className: 'ml-auto',
	                            disabled: !this.customValuesAreNonEmpty(),
	                            onClickOperation: this.onSaveClick
	                        },
	                        'Save'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ValueRemappings;
	}(_react.Component);
	
	ValueRemappings.displayName = 'ValueRemappings';
	
	var FieldValueMapping = exports.FieldValueMapping = function (_Component4) {
	    _inherits(FieldValueMapping, _Component4);
	
	    function FieldValueMapping() {
	        var _ref15;
	
	        var _temp3, _this8, _ret3;
	
	        _classCallCheck(this, FieldValueMapping);
	
	        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	            args[_key3] = arguments[_key3];
	        }
	
	        return _ret3 = (_temp3 = (_this8 = _possibleConstructorReturn(this, (_ref15 = FieldValueMapping.__proto__ || Object.getPrototypeOf(FieldValueMapping)).call.apply(_ref15, [this].concat(args))), _this8), _this8.onInputChange = function (e) {
	            _this8.props.setMapping(e.target.value);
	        }, _temp3), _possibleConstructorReturn(_this8, _ret3);
	    }
	
	    _createClass(FieldValueMapping, [{
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                original = _props3.original,
	                mapped = _props3.mapped;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'flex align-center' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    original
	                ),
	                _react2.default.createElement(_Input2.default, {
	                    className: 'AdminInput input ml-auto',
	                    value: mapped,
	                    onChange: this.onInputChange,
	                    placeholder: "Enter value"
	                })
	            );
	        }
	    }]);
	
	    return FieldValueMapping;
	}(_react.Component);
	
	FieldValueMapping.displayName = 'FieldValueMapping';
	var Section = exports.Section = function Section(_ref16) {
	    var children = _ref16.children;
	    return _react2.default.createElement(
	        'section',
	        { className: 'my3' },
	        children
	    );
	};
	
	Section.displayName = 'Section';
	var SectionHeader = exports.SectionHeader = function SectionHeader(_ref17) {
	    var title = _ref17.title,
	        description = _ref17.description;
	    return _react2.default.createElement(
	        'div',
	        { className: 'border-bottom py2 mb2' },
	        _react2.default.createElement(
	            'h2',
	            { className: 'text-italic' },
	            title
	        ),
	        description && _react2.default.createElement(
	            'p',
	            { className: 'mb0 text-grey-4 mt1 text-paragraph text-measure' },
	            description
	        )
	    );
	};
	
	SectionHeader.displayName = 'SectionHeader';
	var MAP_OPTIONS = {
	    original: { type: "original", name: 'Use original value' },
	    foreign: { type: "foreign", name: 'Use foreign key' },
	    custom: { type: "custom", name: 'Custom mapping' }
	};
	
	var FieldRemapping = exports.FieldRemapping = function (_Component5) {
	    _inherits(FieldRemapping, _Component5);
	
	    function FieldRemapping(props, context) {
	        var _this10 = this;
	
	        _classCallCheck(this, FieldRemapping);
	
	        var _this9 = _possibleConstructorReturn(this, (FieldRemapping.__proto__ || Object.getPrototypeOf(FieldRemapping)).call(this, props, context));
	
	        _this9.state = {
	            isChoosingInitialFkTarget: false,
	            dismissedInitialFkTargetPopover: false
	        };
	
	        _this9.getMappingTypeForField = function (field) {
	            if (_this9.state.isChoosingInitialFkTarget) return MAP_OPTIONS.foreign;
	
	            if (_underscore2.default.isEmpty(field.dimensions)) return MAP_OPTIONS.original;
	            if (field.dimensions.type === "external") return MAP_OPTIONS.foreign;
	            if (field.dimensions.type === "internal") return MAP_OPTIONS.custom;
	
	            throw new Error("Unrecognized mapping type");
	        };
	
	        _this9.getAvailableMappingTypes = function () {
	            var field = _this9.props.field;
	
	
	            var hasForeignKeys = field.special_type === "type/FK" && _this9.getForeignKeys().length > 0;
	
	            // Only show the "custom" option if we have some values that can be mapped to user-defined custom values
	            // (for a field without user-defined remappings, every key of `field.remappings` has value `undefined`)
	            var hasMappableNumeralValues = field.remapping.size > 0 && [].concat(_toConsumableArray(field.remapping.keys())).every(function (key) {
	                return typeof key === "number";
	            });
	
	            return [MAP_OPTIONS.original].concat(_toConsumableArray(hasForeignKeys ? [MAP_OPTIONS.foreign] : []), _toConsumableArray(hasMappableNumeralValues > 0 ? [MAP_OPTIONS.custom] : []));
	        };
	
	        _this9.getFKTargetTableEntityNameOrNull = function () {
	            var fks = _this9.getForeignKeys();
	            var fkTargetFields = fks[0] && fks[0].dimensions.map(function (dim) {
	                return dim.field();
	            });
	
	            if (fkTargetFields) {
	                // TODO Atte Keinänen 7/11/17: Should there be `isName(field)` in Field.js?
	                var nameField = fkTargetFields.find(function (field) {
	                    return field.special_type === "type/Name";
	                });
	                return nameField ? nameField.id : null;
	            } else {
	                throw new Error("Current field isn't a foreign key or FK target table metadata is missing");
	            }
	        };
	
	        _this9.clearEditingStates = function () {
	            _this9.setState({ isChoosingInitialFkTarget: false, dismissedInitialFkTargetPopover: false });
	        };
	
	        _this9.onSetMappingType = function () {
	            var _ref18 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(mappingType) {
	                var _this9$props, table, field, fetchTableMetadata, updateFieldDimension, deleteFieldDimension, entityNameFieldId;
	
	                return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                _this9$props = _this9.props, table = _this9$props.table, field = _this9$props.field, fetchTableMetadata = _this9$props.fetchTableMetadata, updateFieldDimension = _this9$props.updateFieldDimension, deleteFieldDimension = _this9$props.deleteFieldDimension;
	
	
	                                _this9.clearEditingStates();
	
	                                if (!(mappingType.type === "original")) {
	                                    _context5.next = 9;
	                                    break;
	                                }
	
	                                _analytics2.default.trackEvent("Data Model", "Change Remapping Type", "No Remapping");
	                                _context5.next = 6;
	                                return deleteFieldDimension(field.id);
	
	                            case 6:
	                                _this9.setState({ hasChanged: false });
	                                _context5.next = 28;
	                                break;
	
	                            case 9:
	                                if (!(mappingType.type === "foreign")) {
	                                    _context5.next = 20;
	                                    break;
	                                }
	
	                                // Try to find a entity name field from target table and choose it as remapping target field if it exists
	                                entityNameFieldId = _this9.getFKTargetTableEntityNameOrNull();
	
	                                if (!entityNameFieldId) {
	                                    _context5.next = 17;
	                                    break;
	                                }
	
	                                _analytics2.default.trackEvent("Data Model", "Change Remapping Type", "Foreign Key");
	                                _context5.next = 15;
	                                return updateFieldDimension(field.id, {
	                                    type: "external",
	                                    name: field.display_name,
	                                    human_readable_field_id: entityNameFieldId
	                                });
	
	                            case 15:
	                                _context5.next = 18;
	                                break;
	
	                            case 17:
	                                // Enter a special state where we are choosing an initial value for FK target
	                                _this9.setState({
	                                    hasChanged: true,
	                                    isChoosingInitialFkTarget: true
	                                });
	
	                            case 18:
	                                _context5.next = 28;
	                                break;
	
	                            case 20:
	                                if (!(mappingType.type === "custom")) {
	                                    _context5.next = 27;
	                                    break;
	                                }
	
	                                _analytics2.default.trackEvent("Data Model", "Change Remapping Type", "Custom Remappings");
	                                _context5.next = 24;
	                                return updateFieldDimension(field.id, {
	                                    type: "internal",
	                                    name: field.display_name,
	                                    human_readable_field_id: null
	                                });
	
	                            case 24:
	                                _this9.setState({ hasChanged: true });
	                                _context5.next = 28;
	                                break;
	
	                            case 27:
	                                throw new Error("Unrecognized mapping type");
	
	                            case 28:
	                                _context5.next = 30;
	                                return fetchTableMetadata(table.id, true);
	
	                            case 30:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, _this10);
	            }));
	
	            return function (_x3) {
	                return _ref18.apply(this, arguments);
	            };
	        }();
	
	        _this9.onForeignKeyFieldChange = function () {
	            var _ref19 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(foreignKeyClause) {
	                var _this9$props2, table, field, fetchTableMetadata, updateFieldDimension;
	
	                return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                    while (1) {
	                        switch (_context6.prev = _context6.next) {
	                            case 0:
	                                _this9$props2 = _this9.props, table = _this9$props2.table, field = _this9$props2.field, fetchTableMetadata = _this9$props2.fetchTableMetadata, updateFieldDimension = _this9$props2.updateFieldDimension;
	
	
	                                _this9.clearEditingStates();
	
	                                // TODO Atte Keinänen 7/10/17: Use Dimension class when migrating to metabase-lib
	
	                                if (!(foreignKeyClause.length === 3 && foreignKeyClause[0] === "fk->")) {
	                                    _context6.next = 11;
	                                    break;
	                                }
	
	                                _analytics2.default.trackEvent("Data Model", "Update FK Remapping Target");
	                                _context6.next = 6;
	                                return updateFieldDimension(field.id, {
	                                    type: "external",
	                                    name: field.display_name,
	                                    human_readable_field_id: foreignKeyClause[2]
	                                });
	
	                            case 6:
	                                _context6.next = 8;
	                                return fetchTableMetadata(table.id, true);
	
	                            case 8:
	
	                                _this9.refs.fkPopover.close();
	                                _context6.next = 12;
	                                break;
	
	                            case 11:
	                                throw new Error("The selected field isn't a foreign key");
	
	                            case 12:
	                            case 'end':
	                                return _context6.stop();
	                        }
	                    }
	                }, _callee6, _this10);
	            }));
	
	            return function (_x4) {
	                return _ref19.apply(this, arguments);
	            };
	        }();
	
	        _this9.onUpdateRemappings = function (remappings) {
	            var _this9$props3 = _this9.props,
	                field = _this9$props3.field,
	                updateFieldValues = _this9$props3.updateFieldValues;
	
	            return updateFieldValues(field.id, Array.from(remappings));
	        };
	
	        _this9.isValidFKRemappingTarget = function (dimension) {
	            return !(dimension.defaultDimension() instanceof _Dimension.DatetimeFieldDimension);
	        };
	
	        _this9.getForeignKeys = function () {
	            var _this9$props4 = _this9.props,
	                table = _this9$props4.table,
	                field = _this9$props4.field;
	
	            // this method has a little odd structure due to using fieldOptions(); basically filteredFKs should
	            // always be an array with a single value
	
	            var metadata = table.metadata;
	            var fieldOptions = _Question2.default.create({ metadata: metadata, databaseId: table.db.id, tableId: table.id }).query().fieldOptions();
	            var unfilteredFks = fieldOptions.fks;
	            var filteredFKs = unfilteredFks.filter(function (fk) {
	                return fk.field.id === field.id;
	            });
	
	            return filteredFKs.map(function (filteredFK) {
	                return {
	                    field: filteredFK.field,
	                    dimension: filteredFK.dimension,
	                    dimensions: filteredFK.dimensions.filter(_this9.isValidFKRemappingTarget)
	                };
	            });
	        };
	
	        _this9.onFkPopoverDismiss = function () {
	            var isChoosingInitialFkTarget = _this9.state.isChoosingInitialFkTarget;
	
	
	            if (isChoosingInitialFkTarget) {
	                _this9.setState({ dismissedInitialFkTargetPopover: true });
	            }
	        };
	
	        return _this9;
	    }
	
	    // TODO Atte Keinänen 7/11/17: Should we have stricter criteria for valid remapping targets?
	
	
	    _createClass(FieldRemapping, [{
	        key: 'render',
	        value: function render() {
	            var _props4 = this.props,
	                field = _props4.field,
	                table = _props4.table,
	                fields = _props4.fields;
	            var _state = this.state,
	                isChoosingInitialFkTarget = _state.isChoosingInitialFkTarget,
	                hasChanged = _state.hasChanged,
	                dismissedInitialFkTargetPopover = _state.dismissedInitialFkTargetPopover;
	
	
	            var mappingType = this.getMappingTypeForField(field);
	            var isFKMapping = mappingType === MAP_OPTIONS.foreign;
	            var hasFKMappingValue = isFKMapping && field.dimensions.human_readable_field_id !== null;
	            var fkMappingField = hasFKMappingValue && fields[field.dimensions.human_readable_field_id];
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(SectionHeader, {
	                    title: 'Display values',
	                    description: 'Choose to show the original value from the database, or have this field display associated or custom information.'
	                }),
	                _react2.default.createElement(_Select2.default, {
	                    triggerClasses: SelectClasses,
	                    value: mappingType,
	                    onChange: this.onSetMappingType,
	                    options: this.getAvailableMappingTypes()
	                }),
	                mappingType === MAP_OPTIONS.foreign && [_react2.default.createElement(SelectSeparator, { key: 'foreignKeySeparator' }), _react2.default.createElement(
	                    _PopoverWithTrigger2.default,
	                    {
	                        ref: 'fkPopover',
	                        triggerElement: _react2.default.createElement(
	                            _SelectButton2.default,
	                            {
	                                hasValue: hasFKMappingValue,
	                                className: (0, _classnames2.default)("flex inline-block no-decoration h3 p2 shadowed", {
	                                    "border-error": dismissedInitialFkTargetPopover,
	                                    "border-dark": !dismissedInitialFkTargetPopover
	                                })
	                            },
	                            fkMappingField ? fkMappingField.display_name : _react2.default.createElement(
	                                'span',
	                                { className: 'text-grey-1' },
	                                'Choose a field'
	                            )
	                        ),
	                        isInitiallyOpen: isChoosingInitialFkTarget,
	                        onClose: this.onFkPopoverDismiss
	                    },
	                    _react2.default.createElement(_FieldList2.default, {
	                        className: 'text-purple',
	                        field: fkMappingField,
	                        fieldOptions: { count: 0, dimensions: [], fks: this.getForeignKeys() },
	                        tableMetadata: table,
	                        onFieldChange: this.onForeignKeyFieldChange,
	                        hideSectionHeader: true
	                    })
	                ), dismissedInitialFkTargetPopover && _react2.default.createElement(
	                    'div',
	                    { className: 'text-danger my2' },
	                    'Please select a column to use for display.'
	                ), hasChanged && hasFKMappingValue && _react2.default.createElement(RemappingNamingTip, null)],
	                mappingType === MAP_OPTIONS.custom && _react2.default.createElement(
	                    'div',
	                    { className: 'mt3' },
	                    hasChanged && _react2.default.createElement(RemappingNamingTip, null),
	                    _react2.default.createElement(ValueRemappings, {
	                        remappings: field && field.remapping,
	                        updateRemappings: this.onUpdateRemappings
	                    })
	                )
	            );
	        }
	    }]);
	
	    return FieldRemapping;
	}(_react.Component);
	
	FieldRemapping.displayName = 'FieldRemapping';
	var RemappingNamingTip = exports.RemappingNamingTip = function RemappingNamingTip() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'bordered rounded p1 mt1 mb2 border-brand' },
	        _react2.default.createElement(
	            'span',
	            { className: 'text-brand text-bold' },
	            'Tip:'
	        ),
	        'You might want to update the field name to make sure it still makes sense based on your remapping choices.'
	    );
	};
	
	RemappingNamingTip.displayName = 'RemappingNamingTip';
	
	var UpdateCachedFieldValues = exports.UpdateCachedFieldValues = function (_Component6) {
	    _inherits(UpdateCachedFieldValues, _Component6);
	
	    function UpdateCachedFieldValues() {
	        _classCallCheck(this, UpdateCachedFieldValues);
	
	        return _possibleConstructorReturn(this, (UpdateCachedFieldValues.__proto__ || Object.getPrototypeOf(UpdateCachedFieldValues)).apply(this, arguments));
	    }
	
	    _createClass(UpdateCachedFieldValues, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(SectionHeader, {
	                    title: 'Cached field values',
	                    description: 'Metabase can scan the values for this field to enable checkbox filters in dashboards and questions.'
	                }),
	                _react2.default.createElement(_ActionButton2.default, {
	                    className: 'Button mr2',
	                    actionFn: this.props.rescanFieldValues,
	                    normalText: 'Re-scan this field',
	                    activeText: 'Starting\u2026',
	                    failedText: 'Failed to start scan',
	                    successText: 'Scan triggered!'
	                }),
	                _react2.default.createElement(_ActionButton2.default, {
	                    className: 'Button Button--danger',
	                    actionFn: this.props.discardFieldValues,
	                    normalText: 'Discard cached field values',
	                    activeText: 'Starting\u2026',
	                    failedText: 'Failed to discard values',
	                    successText: 'Discard triggered!'
	                })
	            );
	        }
	    }]);
	
	    return UpdateCachedFieldValues;
	}(_react.Component);
	
	UpdateCachedFieldValues.displayName = 'UpdateCachedFieldValues';

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultTitleForState = {
	    default: "Save",
	    inProgress: "Saving...",
	    completed: "Saved!",
	    failed: "Saving failed."
	};
	
	// TODO Atte Keinänen 7/14/17: This could use Button component underneath and pass parameters to it
	// (Didn't want to generalize too much for the first version of this component
	
	/**
	 * Renders a button that triggers a promise-returning `onClickOperation` when user clicks the button.
	 * When the button is clicked, `inProgress` text is shown, and when the promise resolves, `completed` text is shown.
	 */
	
	var ButtonWithStatus = function (_Component) {
	    _inherits(ButtonWithStatus, _Component);
	
	    function ButtonWithStatus() {
	        var _ref,
	            _this2 = this;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ButtonWithStatus);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ButtonWithStatus.__proto__ || Object.getPrototypeOf(ButtonWithStatus)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            progressState: "default"
	        }, _this.onClick = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _this.setState({ progressState: "inProgress" });
	                            _context.prev = 1;
	                            _context.next = 4;
	                            return _this.props.onClickOperation();
	
	                        case 4:
	                            _this.setState({ progressState: "completed" });
	                            _context.next = 12;
	                            break;
	
	                        case 7:
	                            _context.prev = 7;
	                            _context.t0 = _context["catch"](1);
	
	                            console.warn('The operation triggered by click in `ButtonWithStatus` failed');
	                            _this.setState({ progressState: "failed" });
	                            throw _context.t0;
	
	                        case 12:
	                            _context.prev = 12;
	
	                            setTimeout(function () {
	                                return _this.setState({ progressState: "default" });
	                            }, 3000);
	                            return _context.finish(12);
	
	                        case 15:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2, [[1, 7, 12, 15]]);
	        })), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ButtonWithStatus, [{
	        key: "render",
	        value: function render() {
	            var progressState = this.state.progressState;
	
	            var titleForState = this.props.titleForState || defaultTitleForState;
	            var title = titleForState[progressState];
	            var disabled = this.props.disabled || progressState !== "default";
	
	            return _react2.default.createElement(
	                "button",
	                {
	                    className: (0, _classnames2.default)("Button", { "Button--primary": !disabled }, { "Button--success-new": progressState === "completed" }, this.props.className),
	                    disabled: disabled, onClick: this.onClick
	                },
	                title
	            );
	        }
	    }]);
	
	    return ButtonWithStatus;
	}(_react.Component);
	
	ButtonWithStatus.displayName = "ButtonWithStatus";
	exports.default = ButtonWithStatus;

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint "react/prop-types": "warn" */
	var SelectButton = function SelectButton(_ref) {
	    var className = _ref.className,
	        children = _ref.children,
	        _ref$hasValue = _ref.hasValue,
	        hasValue = _ref$hasValue === undefined ? true : _ref$hasValue;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(className, "AdminSelect flex align-center", { "text-grey-3": !hasValue }) },
	        _react2.default.createElement(
	            "span",
	            { className: "AdminSelect-content mr1" },
	            children
	        ),
	        _react2.default.createElement(_Icon2.default, { className: "AdminSelect-chevron flex-align-right", name: "chevrondown", size: 12 })
	    );
	};
	
	SelectButton.displayName = "SelectButton";
	SelectButton.propTypes = {
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.any,
	    hasValue: _propTypes2.default.any
	};
	
	exports.default = SelectButton;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.discardFieldValues = exports.rescanFieldValues = exports.DISCARD_FIELD_VALUES = exports.RESCAN_FIELD_VALUES = undefined;
	
	var _redux = __webpack_require__(657);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var RESCAN_FIELD_VALUES = exports.RESCAN_FIELD_VALUES = "metabase/admin/fields/RESCAN_FIELD_VALUES";
	var DISCARD_FIELD_VALUES = exports.DISCARD_FIELD_VALUES = "metabase/admin/fields/DISCARD_FIELD_VALUES";
	
	var rescanFieldValues = exports.rescanFieldValues = (0, _redux.createThunkAction)(RESCAN_FIELD_VALUES, function (fieldId) {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var call;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _services.MetabaseApi.field_rescan_values({ fieldId: fieldId });
	
	                        case 3:
	                            call = _context.sent;
	
	                            _analytics2.default.trackEvent("Data Model", "Manual Re-scan Field Values");
	                            return _context.abrupt("return", call);
	
	                        case 8:
	                            _context.prev = 8;
	                            _context.t0 = _context["catch"](0);
	
	                            console.log('error manually re-scanning field values', _context.t0);
	
	                        case 11:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[0, 8]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var discardFieldValues = exports.discardFieldValues = (0, _redux.createThunkAction)(DISCARD_FIELD_VALUES, function (fieldId) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var call;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _services.MetabaseApi.field_discard_values({ fieldId: fieldId });
	
	                        case 3:
	                            call = _context2.sent;
	
	                            _analytics2.default.trackEvent("Data Model", "Manual Discard Field Values");
	                            return _context2.abrupt("return", call);
	
	                        case 8:
	                            _context2.prev = 8;
	                            _context2.t0 = _context2["catch"](0);
	
	                            console.log('error discarding field values', _context2.t0);
	
	                        case 11:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[0, 8]]);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _metadata2 = __webpack_require__(1073);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _FieldApp = __webpack_require__(1907);
	
	var _ActionButton = __webpack_require__(1213);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _table = __webpack_require__(1912);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        databaseId: parseInt(props.params.databaseId),
	        tableId: parseInt(props.params.tableId),
	        metadata: (0, _metadata2.getMetadata)(state)
	    };
	};
	
	var mapDispatchToProps = {
	    fetchDatabaseMetadata: metadataActions.fetchDatabaseMetadata,
	    fetchTableMetadata: metadataActions.fetchTableMetadata,
	    rescanTableFieldValues: _table.rescanTableFieldValues,
	    discardTableFieldValues: _table.discardTableFieldValues
	};
	
	var TableSettingsApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(TableSettingsApp, _Component);
	
	    function TableSettingsApp() {
	        _classCallCheck(this, TableSettingsApp);
	
	        return _possibleConstructorReturn(this, (TableSettingsApp.__proto__ || Object.getPrototypeOf(TableSettingsApp)).apply(this, arguments));
	    }
	
	    _createClass(TableSettingsApp, [{
	        key: "componentWillMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                var _props, databaseId, tableId, fetchDatabaseMetadata, fetchTableMetadata;
	
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _props = this.props, databaseId = _props.databaseId, tableId = _props.tableId, fetchDatabaseMetadata = _props.fetchDatabaseMetadata, fetchTableMetadata = _props.fetchTableMetadata;
	                                _context.next = 3;
	                                return fetchDatabaseMetadata(databaseId);
	
	                            case 3:
	                                _context.next = 5;
	                                return fetchTableMetadata(tableId, true);
	
	                            case 5:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props2 = this.props,
	                metadata = _props2.metadata,
	                databaseId = _props2.databaseId,
	                tableId = _props2.tableId;
	
	
	            var db = metadata && metadata.databases[databaseId];
	            var table = metadata && metadata.tables[tableId];
	            var isLoading = !table;
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: isLoading, error: null, noWrapper: true },
	                function () {
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "relative" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(Nav, { db: db, table: table }),
	                            _react2.default.createElement(UpdateFieldValues, {
	                                rescanTableFieldValues: function rescanTableFieldValues() {
	                                    return _this2.props.rescanTableFieldValues(table.id);
	                                },
	                                discardTableFieldValues: function discardTableFieldValues() {
	                                    return _this2.props.discardTableFieldValues(table.id);
	                                }
	                            })
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return TableSettingsApp;
	}(_react.Component)) || _class);
	TableSettingsApp.displayName = "TableSettingsApp";
	exports.default = TableSettingsApp;
	
	var Nav = function (_Component2) {
	    _inherits(Nav, _Component2);
	
	    function Nav() {
	        _classCallCheck(this, Nav);
	
	        return _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).apply(this, arguments));
	    }
	
	    _createClass(Nav, [{
	        key: "render",
	        value: function render() {
	            var _props3 = this.props,
	                db = _props3.db,
	                table = _props3.table;
	
	            return _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_FieldApp.BackButton, { databaseId: db.id, tableId: table.id }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "my4 py1 ml-auto mr-auto" },
	                    _react2.default.createElement(_Breadcrumbs2.default, {
	                        crumbs: [db && [db.name, "/admin/datamodel/database/" + db.id], table && [table.display_name, "/admin/datamodel/database/" + db.id + "/table/" + table.id], "Settings"]
	                    })
	                )
	            );
	        }
	    }]);
	
	    return Nav;
	}(_react.Component);
	
	Nav.displayName = "Nav";
	
	var UpdateFieldValues = function (_Component3) {
	    _inherits(UpdateFieldValues, _Component3);
	
	    function UpdateFieldValues() {
	        _classCallCheck(this, UpdateFieldValues);
	
	        return _possibleConstructorReturn(this, (UpdateFieldValues.__proto__ || Object.getPrototypeOf(UpdateFieldValues)).apply(this, arguments));
	    }
	
	    _createClass(UpdateFieldValues, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _FieldApp.Section,
	                null,
	                _react2.default.createElement(_FieldApp.SectionHeader, {
	                    title: "Cached field values",
	                    description: "Metabase can scan the values in this table to enable checkbox filters in dashboards and questions."
	                }),
	                _react2.default.createElement(_ActionButton2.default, {
	                    className: "Button mr2",
	                    actionFn: this.props.rescanTableFieldValues,
	                    normalText: "Re-scan this table",
	                    activeText: "Starting\u2026",
	                    failedText: "Failed to start scan",
	                    successText: "Scan triggered!"
	                }),
	                _react2.default.createElement(_ActionButton2.default, {
	                    className: "Button Button--danger",
	                    actionFn: this.props.discardTableFieldValues,
	                    normalText: "Discard cached field values",
	                    activeText: "Starting\u2026",
	                    failedText: "Failed to discard values",
	                    successText: "Discard triggered!"
	                })
	            );
	        }
	    }]);
	
	    return UpdateFieldValues;
	}(_react.Component);
	
	UpdateFieldValues.displayName = "UpdateFieldValues";

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.discardTableFieldValues = exports.rescanTableFieldValues = exports.DISCARD_TABLE_VALUES = exports.RESCAN_TABLE_VALUES = undefined;
	
	var _redux = __webpack_require__(657);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var RESCAN_TABLE_VALUES = exports.RESCAN_TABLE_VALUES = "metabase/admin/tables/RESCAN_TABLE_VALUES";
	var DISCARD_TABLE_VALUES = exports.DISCARD_TABLE_VALUES = "metabase/admin/tables/DISCARD_TABLE_VALUES";
	
	var rescanTableFieldValues = exports.rescanTableFieldValues = (0, _redux.createThunkAction)(RESCAN_TABLE_VALUES, function (tableId) {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
	            var call;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return _services.MetabaseApi.table_rescan_values({ tableId: tableId });
	
	                        case 3:
	                            call = _context.sent;
	
	                            _analytics2.default.trackEvent("Data Model", "Manual Re-scan Field Values for Table");
	                            return _context.abrupt("return", call);
	
	                        case 8:
	                            _context.prev = 8;
	                            _context.t0 = _context["catch"](0);
	
	                            console.log('error manually re-scanning field values', _context.t0);
	
	                        case 11:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, this, [[0, 8]]);
	        }));
	
	        return function (_x, _x2) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var discardTableFieldValues = exports.discardTableFieldValues = (0, _redux.createThunkAction)(DISCARD_TABLE_VALUES, function (tableId) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var call;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            _context2.next = 3;
	                            return _services.MetabaseApi.table_discard_values({ tableId: tableId });
	
	                        case 3:
	                            call = _context2.sent;
	
	                            _analytics2.default.trackEvent("Data Model", "Manual Discard Field Values for Table");
	                            return _context2.abrupt("return", call);
	
	                        case 8:
	                            _context2.prev = 8;
	                            _context2.t0 = _context2["catch"](0);
	
	                            console.log('error discarding field values', _context2.t0);
	
	                        case 11:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this, [[0, 8]]);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _GettingStartedGuide = __webpack_require__(1914);
	
	var _GettingStartedGuide2 = _interopRequireDefault(_GettingStartedGuide);
	
	var _GettingStartedGuideEditForm = __webpack_require__(1923);
	
	var _GettingStartedGuideEditForm2 = _interopRequireDefault(_GettingStartedGuideEditForm);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	var _dashboards = __webpack_require__(1521);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({
	    fetchDashboards: _dashboards.fetchDashboards
	}, metadataActions, actions);
	
	var GettingStartedGuideContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(GettingStartedGuideContainer, _Component);
	
	    function GettingStartedGuideContainer() {
	        _classCallCheck(this, GettingStartedGuideContainer);
	
	        return _possibleConstructorReturn(this, (GettingStartedGuideContainer.__proto__ || Object.getPrototypeOf(GettingStartedGuideContainer)).apply(this, arguments));
	    }
	
	    _createClass(GettingStartedGuideContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchGuide(this.props);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                this.props.isEditing ? _react2.default.createElement(_GettingStartedGuideEditForm2.default, this.props) : _react2.default.createElement(_GettingStartedGuide2.default, this.props)
	            );
	        }
	    }]);
	
	    return GettingStartedGuideContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	GettingStartedGuideContainer.displayName = 'GettingStartedGuideContainer';
	exports.default = GettingStartedGuideContainer;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _reactRedux = __webpack_require__(467);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _GuideHeader = __webpack_require__(1915);
	
	var _GuideHeader2 = _interopRequireDefault(_GuideHeader);
	
	var _GuideDetail = __webpack_require__(1919);
	
	var _GuideDetail2 = _interopRequireDefault(_GuideDetail);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _requests = __webpack_require__(856);
	
	var _dashboards = __webpack_require__(1521);
	
	var _settings = __webpack_require__(1906);
	
	var _selectors = __webpack_require__(1922);
	
	var _utils = __webpack_require__(1920);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isGuideEmpty = function isGuideEmpty() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        things_to_know = _ref.things_to_know,
	        contact = _ref.contact,
	        most_important_dashboard = _ref.most_important_dashboard,
	        important_metrics = _ref.important_metrics,
	        important_segments = _ref.important_segments,
	        important_tables = _ref.important_tables;
	
	    return things_to_know ? false : contact && contact.name ? false : contact && contact.email ? false : most_important_dashboard ? false : important_metrics && important_metrics.length !== 0 ? false : important_segments && important_segments.length !== 0 ? false : important_tables && important_tables.length !== 0 ? false : true;
	};
	
	// This function generates a link for each important field of a Metric.
	// The link goes to a question comprised of this Metric broken out by 
	// That important field.
	var exploreLinksForMetric = function exploreLinksForMetric(metricId, guide, metadataFields, tables) {
	    if (guide.metric_important_fields[metricId]) {
	        return guide.metric_important_fields[metricId].map(function (fieldId) {
	            return metadataFields[fieldId];
	        }).map(function (field) {
	            return {
	                name: field.display_name || field.name,
	                url: (0, _utils.getQuestionUrl)({
	                    dbId: tables[field.table_id] && tables[field.table_id].db_id,
	                    tableId: field.table_id,
	                    fieldId: field.id,
	                    metricId: metricId
	                })
	            };
	        });
	    }
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        guide: (0, _selectors.getGuide)(state, props),
	        user: (0, _selectors.getUser)(state, props),
	        dashboards: (0, _selectors.getDashboards)(state, props),
	        metrics: (0, _selectors.getMetrics)(state, props),
	        segments: (0, _selectors.getSegments)(state, props),
	        tables: (0, _selectors.getTables)(state, props),
	        // FIXME: avoids naming conflict, tried using the propNamespace option
	        // version but couldn't quite get it to work together with passing in
	        // dynamic initialValues
	        metadataFields: (0, _selectors.getFields)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        // naming this 'error' will conflict with redux form
	        loadingError: (0, _selectors.getError)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({
	    updateDashboard: _dashboards.updateDashboard,
	    createDashboard: _dashboards.createDashboard,
	    updateSetting: _settings.updateSetting,
	    clearRequestState: _requests.clearRequestState
	}, metadataActions, actions);
	
	var GettingStartedGuide = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(GettingStartedGuide, _Component);
	
	    function GettingStartedGuide() {
	        _classCallCheck(this, GettingStartedGuide);
	
	        return _possibleConstructorReturn(this, (GettingStartedGuide.__proto__ || Object.getPrototypeOf(GettingStartedGuide)).apply(this, arguments));
	    }
	
	    _createClass(GettingStartedGuide, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                style = _props.style,
	                guide = _props.guide,
	                user = _props.user,
	                dashboards = _props.dashboards,
	                metrics = _props.metrics,
	                segments = _props.segments,
	                tables = _props.tables,
	                metadataFields = _props.metadataFields,
	                loadingError = _props.loadingError,
	                loading = _props.loading,
	                startEditing = _props.startEditing;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: "full relative py4", style: style },
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { className: "full", style: style, loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return _react2.default.createElement(
	                            "div",
	                            null,
	                            _react2.default.createElement(_GuideHeader2.default, {
	                                startEditing: startEditing,
	                                isSuperuser: user && user.is_superuser
	                            }),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "wrapper wrapper--trim" },
	                                (!guide || isGuideEmpty(guide)) && user && user.is_superuser && _react2.default.createElement(
	                                    AdminInstructions,
	                                    null,
	                                    _react2.default.createElement(
	                                        "h2",
	                                        { className: "py2" },
	                                        "Help your team get started with your data."
	                                    ),
	                                    _react2.default.createElement(
	                                        GuideText,
	                                        null,
	                                        "Show your team what\u2019s most important by choosing your top dashboard, metrics, and segments."
	                                    ),
	                                    _react2.default.createElement(
	                                        "button",
	                                        {
	                                            className: "Button Button--primary",
	                                            onClick: startEditing
	                                        },
	                                        "Get started"
	                                    )
	                                ),
	                                guide.most_important_dashboard !== null && [_react2.default.createElement(
	                                    "div",
	                                    { className: "my2" },
	                                    _react2.default.createElement(
	                                        SectionHeader,
	                                        { key: 'dashboardTitle' },
	                                        "Our most important dashboard"
	                                    ),
	                                    _react2.default.createElement(_GuideDetail2.default, {
	                                        key: 'dashboardDetail',
	                                        type: "dashboard",
	                                        entity: dashboards[guide.most_important_dashboard],
	                                        tables: tables
	                                    })
	                                )],
	                                Object.keys(metrics).length > 0 && _react2.default.createElement(
	                                    "div",
	                                    { className: "my4 pt4" },
	                                    _react2.default.createElement(
	                                        SectionHeader,
	                                        { trim: guide.important_metrics.length === 0 },
	                                        guide.important_metrics && guide.important_metrics.length > 0 ? 'Numbers that we pay attention to' : 'Metrics'
	                                    ),
	                                    guide.important_metrics && guide.important_metrics.length > 0 ? [_react2.default.createElement(
	                                        "div",
	                                        { className: "my2" },
	                                        guide.important_metrics.map(function (metricId) {
	                                            return _react2.default.createElement(_GuideDetail2.default, {
	                                                key: metricId,
	                                                type: "metric",
	                                                entity: metrics[metricId],
	                                                tables: tables,
	                                                exploreLinks: exploreLinksForMetric(metricId, guide, metadataFields, tables)
	                                            });
	                                        })
	                                    )] : _react2.default.createElement(
	                                        GuideText,
	                                        null,
	                                        "Metrics are important numbers your company cares about. They often represent a core indicator of how the business is performing."
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        null,
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { className: "Button Button--primary", to: '/reference/metrics' },
	                                            "See all metrics"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "mt4 pt4" },
	                                    _react2.default.createElement(
	                                        SectionHeader,
	                                        { trim: !(0, _utils.has)(guide.important_segments) && !(0, _utils.has)(guide.important_tables) },
	                                        Object.keys(segments).length > 0 ? 'Segments and tables' : 'Tables'
	                                    ),
	                                    (0, _utils.has)(guide.important_segments) || (0, _utils.has)(guide.important_tables) ? _react2.default.createElement(
	                                        "div",
	                                        { className: "my2" },
	                                        guide.important_segments.map(function (segmentId) {
	                                            return _react2.default.createElement(_GuideDetail2.default, {
	                                                key: segmentId,
	                                                type: "segment",
	                                                entity: segments[segmentId],
	                                                tables: tables
	                                            });
	                                        }),
	                                        guide.important_tables.map(function (tableId) {
	                                            return _react2.default.createElement(_GuideDetail2.default, {
	                                                key: tableId,
	                                                type: "table",
	                                                entity: tables[tableId],
	                                                tables: tables
	                                            });
	                                        })
	                                    ) : _react2.default.createElement(
	                                        GuideText,
	                                        null,
	                                        Object.keys(segments).length > 0 ? _react2.default.createElement(
	                                            "span",
	                                            null,
	                                            "Segments and tables are the building blocks of your company's data. Tables are collections of the raw information while segments are specific slices with specific meanings, like ",
	                                            _react2.default.createElement(
	                                                "b",
	                                                null,
	                                                "\"Recent orders.\""
	                                            )
	                                        ) : "Tables are the building blocks of your company's data."
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        null,
	                                        Object.keys(segments).length > 0 && _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            { className: "Button Button--purple mr2", to: '/reference/segments' },
	                                            "See all segments"
	                                        ),
	                                        _react2.default.createElement(
	                                            _reactRouter.Link,
	                                            {
	                                                className: (0, _classnames2.default)({ 'text-purple text-bold no-decoration text-underline-hover': Object.keys(segments).length > 0 }, { 'Button Button--purple': Object.keys(segments).length === 0 }),
	                                                to: '/reference/databases'
	                                            },
	                                            "See all tables"
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "mt4 pt4" },
	                                    _react2.default.createElement(
	                                        SectionHeader,
	                                        { trim: !guide.things_to_know },
	                                        guide.things_to_know ? 'Other things to know about our data' : 'Find out more'
	                                    ),
	                                    _react2.default.createElement(
	                                        GuideText,
	                                        null,
	                                        guide.things_to_know ? guide.things_to_know : "A good way to get to know your data is by spending a bit of time exploring the different tables and other info available to you. It may take a while, but you'll start to recognize names and meanings over time."
	                                    ),
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { className: "Button link text-bold", to: '/reference/databases' },
	                                        "Explore our data"
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "mt4" },
	                                    guide.contact && (guide.contact.name || guide.contact.email) && [_react2.default.createElement(
	                                        SectionHeader,
	                                        { key: 'contactTitle' },
	                                        "Have questions?"
	                                    ), _react2.default.createElement(
	                                        "div",
	                                        { className: "mb4 pb4", key: 'contactDetails' },
	                                        guide.contact.name && _react2.default.createElement(
	                                            "span",
	                                            { className: "text-dark mr3" },
	                                            "Contact " + guide.contact.name
	                                        ),
	                                        guide.contact.email && _react2.default.createElement(
	                                            "a",
	                                            { className: "text-brand text-bold no-decoration", href: "mailto:" + guide.contact.email },
	                                            guide.contact.email
	                                        )
	                                    )]
	                                )
	                            )
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return GettingStartedGuide;
	}(_react.Component), _class2.propTypes = {
	    fields: _propTypes2.default.object,
	    style: _propTypes2.default.object,
	    guide: _propTypes2.default.object,
	    user: _propTypes2.default.object,
	    dashboards: _propTypes2.default.object,
	    metrics: _propTypes2.default.object,
	    segments: _propTypes2.default.object,
	    tables: _propTypes2.default.object,
	    metadataFields: _propTypes2.default.object,
	    loadingError: _propTypes2.default.any,
	    loading: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func
	}, _temp)) || _class);
	GettingStartedGuide.displayName = "GettingStartedGuide";
	exports.default = GettingStartedGuide;
	
	
	var GuideText = function GuideText(_ref2) {
	    var children = _ref2.children;
	    return (// eslint-disable-line react/prop-types
	        _react2.default.createElement(
	            "p",
	            { className: "text-paragraph text-measure" },
	            children
	        )
	    );
	};
	
	GuideText.displayName = "GuideText";
	var AdminInstructions = function AdminInstructions(_ref3) {
	    var children = _ref3.children;
	    return (// eslint-disable-line react/prop-types
	        _react2.default.createElement(
	            "div",
	            { className: "bordered border-brand rounded p3 text-brand text-measure text-centered bg-light-blue" },
	            children
	        )
	    );
	};
	
	AdminInstructions.displayName = "AdminInstructions";
	var SectionHeader = function SectionHeader(_ref4) {
	    var trim = _ref4.trim,
	        children = _ref4.children;
	    return (// eslint-disable-line react/prop-types
	        _react2.default.createElement(
	            "h2",
	            { className: (0, _classnames2.default)('text-dark text-measure', { "mb0": trim }, { "mb4": !trim }) },
	            children
	        )
	    );
	};
	SectionHeader.displayName = "SectionHeader";

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _EditButton = __webpack_require__(1916);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GuideHeader = function GuideHeader(_ref) {
	    var startEditing = _ref.startEditing,
	        isSuperuser = _ref.isSuperuser;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "wrapper wrapper--trim py4 my3" },
	            _react2.default.createElement(
	                "div",
	                { className: "flex align-center" },
	                _react2.default.createElement(
	                    "h1",
	                    { className: "text-dark", style: { fontWeight: 700 } },
	                    "Start here."
	                ),
	                isSuperuser && _react2.default.createElement(
	                    "span",
	                    { className: "ml-auto" },
	                    _react2.default.createElement(_EditButton2.default, { startEditing: startEditing })
	                )
	            ),
	            _react2.default.createElement(
	                "p",
	                { className: "text-paragraph", style: { maxWidth: 620 } },
	                "This is the perfect place to start if you\u2019re new to your company\u2019s data, or if you just want to check in on what\u2019s going on."
	            )
	        )
	    );
	};
	
	GuideHeader.displayName = "GuideHeader";
	GuideHeader.propTypes = {
	    startEditing: _propTypes2.default.func.isRequired,
	    isSuperuser: _propTypes2.default.bool
	};
	
	exports.default = (0, _pure2.default)(GuideHeader);

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _EditButton = __webpack_require__(1917);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditButton = function EditButton(_ref) {
	    var className = _ref.className,
	        startEditing = _ref.startEditing;
	    return _react2.default.createElement(
	        "button",
	        {
	            className: (0, _classnames2.default)("Button", "Button--borderless", _EditButton2.default.editButton, className),
	            type: "button",
	            onClick: startEditing
	        },
	        _react2.default.createElement(
	            "div",
	            { className: _EditButton2.default.editButtonBody },
	            _react2.default.createElement(_Icon2.default, { name: "pencil", size: 16 }),
	            _react2.default.createElement(
	                "span",
	                { className: "ml1" },
	                "Edit"
	            )
	        )
	    );
	};
	
	EditButton.displayName = "EditButton";
	EditButton.propTypes = {
	    className: _propTypes2.default.string,
	    startEditing: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _pure2.default)(EditButton);

/***/ }),
/* 1917 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"editButton":"_3We6t _38618 _3Dqep _17S31 CtsqB _1ZhAK","editButtonBody":"ob3VY _38618 _3Dqep _18-EI"};

/***/ }),
/* 1918 */,
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _utils = __webpack_require__(1920);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GuideDetail = function GuideDetail(_ref) {
	    var _ref$entity = _ref.entity,
	        entity = _ref$entity === undefined ? {} : _ref$entity,
	        tables = _ref.tables,
	        type = _ref.type,
	        exploreLinks = _ref.exploreLinks,
	        detailLabelClasses = _ref.detailLabelClasses;
	
	    var title = entity.display_name || entity.name;
	    var caveats = entity.caveats,
	        points_of_interest = entity.points_of_interest;
	
	    var typeToLink = {
	        dashboard: Urls.dashboard(entity.id),
	        metric: (0, _utils.getQuestionUrl)({
	            dbId: tables[entity.table_id] && tables[entity.table_id].db_id,
	            tableId: entity.table_id,
	            metricId: entity.id
	        }),
	        segment: (0, _utils.getQuestionUrl)({
	            dbId: tables[entity.table_id] && tables[entity.table_id].db_id,
	            tableId: entity.table_id,
	            segmentId: entity.id
	        }),
	        table: (0, _utils.getQuestionUrl)({
	            dbId: entity.db_id,
	            tableId: entity.id
	        })
	    };
	    var link = typeToLink[type];
	    var typeToLearnMoreLink = {
	        metric: "/reference/metrics/" + entity.id,
	        segment: "/reference/segments/" + entity.id,
	        table: "/reference/databases/" + entity.db_id + "/tables/" + entity.id
	    };
	    var learnMoreLink = typeToLearnMoreLink[type];
	
	    var linkClass = _utils.typeToLinkClass[type];
	    var linkHoverClass = _utils.typeToLinkClass[type] + "-hover";
	    var bgClass = _utils.typeToBgClass[type];
	    var hasLearnMore = type === 'metric' || type === 'segment' || type === 'table';
	    var interestingOrImportant = type === 'dashboard' ? 'important' : 'interesting';
	
	    return _react2.default.createElement(
	        "div",
	        { className: "relative mt2 pb3" },
	        _react2.default.createElement(
	            "div",
	            { className: "flex align-center" },
	            _react2.default.createElement(
	                "div",
	                { style: {
	                        width: 40,
	                        height: 40,
	                        left: -60
	                    },
	                    className: (0, _classnames2.default)('absolute text-white flex align-center justify-center', bgClass)
	                },
	                _react2.default.createElement(_Icon2.default, { name: type === 'metric' ? 'ruler' : type })
	            ),
	            title && _react2.default.createElement(ItemTitle, { link: link, title: title, linkColorClass: linkClass, linkHoverClass: linkHoverClass })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "mt2" },
	            _react2.default.createElement(
	                ContextHeading,
	                null,
	                "Why this " + type + " is " + interestingOrImportant
	            ),
	            _react2.default.createElement(
	                ContextContent,
	                { empty: !points_of_interest },
	                points_of_interest || "Nothing " + interestingOrImportant + " yet"
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "mt2" },
	                _react2.default.createElement(
	                    ContextHeading,
	                    null,
	                    "Things to be aware of about this " + type
	                ),
	                _react2.default.createElement(
	                    ContextContent,
	                    { empty: !caveats },
	                    caveats || 'Nothing to be aware of yet'
	                )
	            ),
	            (0, _utils.has)(exploreLinks) && [_react2.default.createElement(
	                "div",
	                { className: "mt2" },
	                _react2.default.createElement(
	                    ContextHeading,
	                    { key: "detailLabel" },
	                    "Explore this metric"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { key: "detailLinks" },
	                    _react2.default.createElement(
	                        "h4",
	                        { className: "inline-block mr2 link text-bold" },
	                        "View this metric"
	                    ),
	                    exploreLinks.map(function (link) {
	                        return _react2.default.createElement(
	                            _reactRouter.Link,
	                            {
	                                className: "inline-block text-bold text-brand mr2 link",
	                                key: link.url,
	                                to: link.url
	                            },
	                            "By " + link.name
	                        );
	                    })
	                )
	            )],
	            hasLearnMore && _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                    className: (0, _classnames2.default)('block mt3 no-decoration text-underline-hover text-bold', linkClass),
	                    to: learnMoreLink
	                },
	                "Learn more"
	            )
	        )
	    );
	};
	
	GuideDetail.displayName = "GuideDetail";
	GuideDetail.propTypes = {
	    entity: _propTypes2.default.object,
	    type: _propTypes2.default.string,
	    exploreLinks: _propTypes2.default.array
	};
	
	var ItemTitle = function ItemTitle(_ref2) {
	    var title = _ref2.title,
	        link = _ref2.link,
	        linkColorClass = _ref2.linkColorClass,
	        linkHoverClass = _ref2.linkHoverClass;
	    return _react2.default.createElement(
	        "h2",
	        null,
	        _react2.default.createElement(
	            _reactRouter.Link,
	            {
	                className: (0, _classnames2.default)(linkColorClass, linkHoverClass),
	                style: { textDecoration: 'none' },
	                to: link
	            },
	            title
	        )
	    );
	};
	
	ItemTitle.displayName = "ItemTitle";
	var ContextHeading = function ContextHeading(_ref3) {
	    var children = _ref3.children;
	    return _react2.default.createElement(
	        "h3",
	        { className: "my2 text-grey-4" },
	        children
	    );
	};
	
	ContextHeading.displayName = "ContextHeading";
	var ContextContent = function ContextContent(_ref4) {
	    var empty = _ref4.empty,
	        children = _ref4.children;
	    return _react2.default.createElement(
	        "p",
	        { className: (0, _classnames2.default)('m0 text-paragraph text-measure text-pre-wrap', { 'text-grey-3': empty }) },
	        children
	    );
	};
	
	ContextContent.displayName = "ContextContent";
	exports.default = (0, _pure2.default)(GuideDetail);

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.has = exports.typeToBgClass = exports.typeToLinkClass = exports.getQuestionUrl = exports.getQuestion = exports.fieldsToFormFields = exports.databaseToForeignKeys = exports.isEmptyObject = exports.filterUntouchedFields = exports.idsToObjectMap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _icepick = __webpack_require__(855);
	
	var _formatting = __webpack_require__(872);
	
	var _card = __webpack_require__(865);
	
	var _types = __webpack_require__(868);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var idsToObjectMap = exports.idsToObjectMap = function idsToObjectMap(ids, objects) {
	    return ids.map(function (id) {
	        return objects[id];
	    }).reduce(function (map, object) {
	        return _extends({}, map, _defineProperty({}, object.id, object));
	    }, {});
	};
	// recursive freezing done by assoc here is too expensive
	// hangs browser for large databases
	// .reduce((map, object) => assoc(map, object.id, object), {});
	
	var filterUntouchedFields = exports.filterUntouchedFields = function filterUntouchedFields(fields) {
	    var entity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return Object.keys(fields).filter(function (key) {
	        return fields[key] !== undefined && entity[key] !== fields[key];
	    }).reduce(function (map, key) {
	        return _extends({}, map, _defineProperty({}, key, fields[key]));
	    }, {});
	};
	
	var isEmptyObject = exports.isEmptyObject = function isEmptyObject(object) {
	    return Object.keys(object).length === 0;
	};
	
	var databaseToForeignKeys = exports.databaseToForeignKeys = function databaseToForeignKeys(database) {
	    return database && database.tables_lookup ? Object.values(database.tables_lookup)
	    // ignore tables without primary key
	    .filter(function (table) {
	        return table && table.fields.find(function (field) {
	            return (0, _types.isPK)(field.special_type);
	        });
	    }).map(function (table) {
	        return {
	            table: table,
	            field: table && table.fields.find(function (field) {
	                return (0, _types.isPK)(field.special_type);
	            })
	        };
	    }).map(function (_ref) {
	        var table = _ref.table,
	            field = _ref.field;
	        return {
	            id: field.id,
	            name: table.schema && table.schema !== "public" ? (0, _formatting.titleize)((0, _formatting.humanize)(table.schema)) + "." + table.display_name + " \u2192 " + field.display_name : table.display_name + " \u2192 " + field.display_name,
	            description: field.description
	        };
	    }).reduce(function (map, foreignKey) {
	        return (0, _icepick.assoc)(map, foreignKey.id, foreignKey);
	    }, {}) : {};
	};
	
	var fieldsToFormFields = exports.fieldsToFormFields = function fieldsToFormFields(fields) {
	    return Object.keys(fields).map(function (key) {
	        return [key + ".display_name", key + ".special_type", key + ".fk_target_field_id"];
	    }).reduce(function (array, keys) {
	        return array.concat(keys);
	    }, []);
	};
	
	// TODO Atte Keinänen 7/3/17: Construct question with Question of metabase-lib instead of this using function
	var getQuestion = exports.getQuestion = function getQuestion(_ref2) {
	    var dbId = _ref2.dbId,
	        tableId = _ref2.tableId,
	        fieldId = _ref2.fieldId,
	        metricId = _ref2.metricId,
	        segmentId = _ref2.segmentId,
	        getCount = _ref2.getCount,
	        visualization = _ref2.visualization,
	        metadata = _ref2.metadata;
	
	    var newQuestion = (0, _card.startNewCard)('query', dbId, tableId);
	
	    // consider taking a look at Ramda as a possible underscore alternative?
	    // http://ramdajs.com/0.21.0/index.html
	    var question = (0, _icepick.chain)(newQuestion).updateIn(['dataset_query', 'query', 'aggregation'], function (aggregation) {
	        return getCount ? ['count'] : aggregation;
	    }).updateIn(['display'], function (display) {
	        return visualization || display;
	    }).updateIn(['dataset_query', 'query', 'breakout'], function (oldBreakout) {
	        if (fieldId && metadata && metadata.fields[fieldId]) return [metadata.fields[fieldId].getDefaultBreakout()];
	        if (fieldId) return [fieldId];
	        return oldBreakout;
	    }).value();
	
	    if (metricId) {
	        return (0, _icepick.assocIn)(question, ['dataset_query', 'query', 'aggregation'], ['METRIC', metricId]);
	    }
	
	    if (segmentId) {
	        return (0, _icepick.assocIn)(question, ['dataset_query', 'query', 'filter'], ['AND', ['SEGMENT', segmentId]]);
	    }
	
	    return question;
	};
	
	var getQuestionUrl = exports.getQuestionUrl = function getQuestionUrl(getQuestionArgs) {
	    return Urls.question(null, getQuestion(getQuestionArgs));
	};
	
	var typeToLinkClass = exports.typeToLinkClass = {
	    dashboard: 'text-green',
	    metric: 'text-brand',
	    segment: 'text-purple',
	    table: 'text-purple'
	};
	
	var typeToBgClass = exports.typeToBgClass = {
	    dashboard: 'bg-green',
	    metric: 'bg-brand',
	    segment: 'bg-purple',
	    table: 'bg-purple'
	};
	
	// little utility function to determine if we 'has' things, useful
	// for handling entity empty states
	var has = exports.has = function has(entity) {
	    return entity && entity.length > 0;
	};

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.tryUpdateGuide = exports.rUpdateFields = exports.rUpdateMetricDetail = exports.rUpdateFieldDetail = exports.rUpdateTableDetail = exports.rUpdateDatabaseDetail = exports.rUpdateSegmentFieldDetail = exports.rUpdateSegmentDetail = exports.clearState = exports.wrappedFetchSegmentFields = exports.wrappedFetchSegmentRevisions = exports.wrappedFetchSegmentQuestions = exports.wrappedFetchSegmentDetail = exports.wrappedFetchSegments = exports.wrappedFetchMetrics = exports.wrappedFetchDatabases = exports.wrappedFetchMetricRevisions = exports.wrappedFetchMetricQuestions = exports.wrappedFetchMetricDetail = exports.wrappedFetchDatabaseMetadataAndQuestion = exports.wrappedFetchDatabaseMetadata = exports.wrappedFetchGuide = exports.hideDashboardModal = exports.showDashboardModal = exports.collapseFormula = exports.expandFormula = exports.endEditing = exports.startEditing = exports.endLoading = exports.startLoading = exports.clearError = exports.setError = exports.fetchGuide = exports.HIDE_DASHBOARD_MODAL = exports.SHOW_DASHBOARD_MODAL = exports.COLLAPSE_FORMULA = exports.EXPAND_FORMULA = exports.END_EDITING = exports.START_EDITING = exports.END_LOADING = exports.START_LOADING = exports.CLEAR_ERROR = exports.SET_ERROR = exports.FETCH_GUIDE = undefined;
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _icepick = __webpack_require__(855);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _redux = __webpack_require__(657);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _services = __webpack_require__(857);
	
	var _utils = __webpack_require__(1920);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var FETCH_GUIDE = exports.FETCH_GUIDE = "metabase/reference/FETCH_GUIDE";
	var SET_ERROR = exports.SET_ERROR = "metabase/reference/SET_ERROR";
	var CLEAR_ERROR = exports.CLEAR_ERROR = "metabase/reference/CLEAR_ERROR";
	var START_LOADING = exports.START_LOADING = "metabase/reference/START_LOADING";
	var END_LOADING = exports.END_LOADING = "metabase/reference/END_LOADING";
	var START_EDITING = exports.START_EDITING = "metabase/reference/START_EDITING";
	var END_EDITING = exports.END_EDITING = "metabase/reference/END_EDITING";
	var EXPAND_FORMULA = exports.EXPAND_FORMULA = "metabase/reference/EXPAND_FORMULA";
	var COLLAPSE_FORMULA = exports.COLLAPSE_FORMULA = "metabase/reference/COLLAPSE_FORMULA";
	var SHOW_DASHBOARD_MODAL = exports.SHOW_DASHBOARD_MODAL = "metabase/reference/SHOW_DASHBOARD_MODAL";
	var HIDE_DASHBOARD_MODAL = exports.HIDE_DASHBOARD_MODAL = "metabase/reference/HIDE_DASHBOARD_MODAL";
	
	var fetchGuide = exports.fetchGuide = (0, _redux.createThunkAction)(FETCH_GUIDE, function () {
	    var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	            var requestStatePath, existingStatePath, getData;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            requestStatePath = ["reference", 'guide'];
	                            existingStatePath = requestStatePath;
	
	                            getData = function () {
	                                var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                                        while (1) {
	                                            switch (_context.prev = _context.next) {
	                                                case 0:
	                                                    _context.next = 2;
	                                                    return _services.GettingStartedApi.get();
	
	                                                case 2:
	                                                    return _context.abrupt('return', _context.sent);
	
	                                                case 3:
	                                                case 'end':
	                                                    return _context.stop();
	                                            }
	                                        }
	                                    }, _callee, undefined);
	                                }));
	
	                                return function getData() {
	                                    return _ref2.apply(this, arguments);
	                                };
	                            }();
	
	                            _context2.next = 5;
	                            return (0, _redux.fetchData)({
	                                dispatch: dispatch,
	                                getState: getState,
	                                requestStatePath: requestStatePath,
	                                existingStatePath: existingStatePath,
	                                getData: getData,
	                                reload: reload
	                            });
	
	                        case 5:
	                            return _context2.abrupt('return', _context2.sent);
	
	                        case 6:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined);
	        }));
	
	        return function (_x2, _x3) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var setError = exports.setError = (0, _redux.createAction)(SET_ERROR);
	
	var clearError = exports.clearError = (0, _redux.createAction)(CLEAR_ERROR);
	
	var startLoading = exports.startLoading = (0, _redux.createAction)(START_LOADING);
	
	var endLoading = exports.endLoading = (0, _redux.createAction)(END_LOADING);
	
	var startEditing = exports.startEditing = (0, _redux.createAction)(START_EDITING, function () {
	    _analytics2.default.trackEvent('Data Reference', 'Started Editing');
	});
	
	var endEditing = exports.endEditing = (0, _redux.createAction)(END_EDITING, function () {
	    _analytics2.default.trackEvent('Data Reference', 'Ended Editing');
	});
	
	var expandFormula = exports.expandFormula = (0, _redux.createAction)(EXPAND_FORMULA);
	
	var collapseFormula = exports.collapseFormula = (0, _redux.createAction)(COLLAPSE_FORMULA);
	
	//TODO: consider making an app-wide modal state reducer and related actions
	var showDashboardModal = exports.showDashboardModal = (0, _redux.createAction)(SHOW_DASHBOARD_MODAL);
	
	var hideDashboardModal = exports.hideDashboardModal = (0, _redux.createAction)(HIDE_DASHBOARD_MODAL);
	
	// Helper functions. This is meant to be a transitional state to get things out of tryFetchData() and friends
	
	var fetchDataWrapper = function fetchDataWrapper(props, fn) {
	
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(argument) {
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            props.clearError();
	                            props.startLoading();
	                            _context3.prev = 2;
	                            _context3.next = 5;
	                            return fn(argument);
	
	                        case 5:
	                            _context3.next = 11;
	                            break;
	
	                        case 7:
	                            _context3.prev = 7;
	                            _context3.t0 = _context3['catch'](2);
	
	                            console.error(_context3.t0);
	                            props.setError(_context3.t0);
	
	                        case 11:
	
	                            props.endLoading();
	
	                        case 12:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[2, 7]]);
	        }));
	
	        return function (_x4) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	};
	var wrappedFetchGuide = exports.wrappedFetchGuide = function () {
	    var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(props) {
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	            while (1) {
	                switch (_context5.prev = _context5.next) {
	                    case 0:
	
	                        fetchDataWrapper(props, _asyncToGenerator(regeneratorRuntime.mark(function _callee4() {
	                            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                                while (1) {
	                                    switch (_context4.prev = _context4.next) {
	                                        case 0:
	                                            _context4.next = 2;
	                                            return Promise.all([props.fetchGuide(), props.fetchDashboards(), props.fetchMetrics(), props.fetchSegments(), props.fetchDatabasesWithMetadata()]);
	
	                                        case 2:
	                                        case 'end':
	                                            return _context4.stop();
	                                    }
	                                }
	                            }, _callee4, undefined);
	                        })))();
	
	                    case 1:
	                    case 'end':
	                        return _context5.stop();
	                }
	            }
	        }, _callee5, undefined);
	    }));
	
	    return function wrappedFetchGuide(_x5) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	var wrappedFetchDatabaseMetadata = exports.wrappedFetchDatabaseMetadata = function wrappedFetchDatabaseMetadata(props, databaseID) {
	    fetchDataWrapper(props, props.fetchDatabaseMetadata)(databaseID);
	};
	
	var wrappedFetchDatabaseMetadataAndQuestion = exports.wrappedFetchDatabaseMetadataAndQuestion = function () {
	    var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(props, databaseID) {
	        return regeneratorRuntime.wrap(function _callee7$(_context7) {
	            while (1) {
	                switch (_context7.prev = _context7.next) {
	                    case 0:
	
	                        fetchDataWrapper(props, function () {
	                            var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dbID) {
	                                return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                                    while (1) {
	                                        switch (_context6.prev = _context6.next) {
	                                            case 0:
	                                                _context6.next = 2;
	                                                return Promise.all([props.fetchDatabaseMetadata(dbID), props.fetchQuestions()]);
	
	                                            case 2:
	                                            case 'end':
	                                                return _context6.stop();
	                                        }
	                                    }
	                                }, _callee6, undefined);
	                            }));
	
	                            return function (_x8) {
	                                return _ref7.apply(this, arguments);
	                            };
	                        }())(databaseID);
	
	                    case 1:
	                    case 'end':
	                        return _context7.stop();
	                }
	            }
	        }, _callee7, undefined);
	    }));
	
	    return function wrappedFetchDatabaseMetadataAndQuestion(_x6, _x7) {
	        return _ref6.apply(this, arguments);
	    };
	}();
	var wrappedFetchMetricDetail = exports.wrappedFetchMetricDetail = function () {
	    var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(props, metricID) {
	        return regeneratorRuntime.wrap(function _callee9$(_context9) {
	            while (1) {
	                switch (_context9.prev = _context9.next) {
	                    case 0:
	
	                        fetchDataWrapper(props, function () {
	                            var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(mID) {
	                                return regeneratorRuntime.wrap(function _callee8$(_context8) {
	                                    while (1) {
	                                        switch (_context8.prev = _context8.next) {
	                                            case 0:
	                                                _context8.next = 2;
	                                                return Promise.all([props.fetchMetricTable(mID), props.fetchMetrics(), props.fetchGuide()]);
	
	                                            case 2:
	                                            case 'end':
	                                                return _context8.stop();
	                                        }
	                                    }
	                                }, _callee8, undefined);
	                            }));
	
	                            return function (_x11) {
	                                return _ref9.apply(this, arguments);
	                            };
	                        }())(metricID);
	
	                    case 1:
	                    case 'end':
	                        return _context9.stop();
	                }
	            }
	        }, _callee9, undefined);
	    }));
	
	    return function wrappedFetchMetricDetail(_x9, _x10) {
	        return _ref8.apply(this, arguments);
	    };
	}();
	var wrappedFetchMetricQuestions = exports.wrappedFetchMetricQuestions = function () {
	    var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(props, metricID) {
	        return regeneratorRuntime.wrap(function _callee11$(_context11) {
	            while (1) {
	                switch (_context11.prev = _context11.next) {
	                    case 0:
	
	                        fetchDataWrapper(props, function () {
	                            var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(mID) {
	                                return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                                    while (1) {
	                                        switch (_context10.prev = _context10.next) {
	                                            case 0:
	                                                _context10.next = 2;
	                                                return Promise.all([props.fetchMetricTable(mID), props.fetchMetrics(), props.fetchQuestions()]);
	
	                                            case 2:
	                                            case 'end':
	                                                return _context10.stop();
	                                        }
	                                    }
	                                }, _callee10, undefined);
	                            }));
	
	                            return function (_x14) {
	                                return _ref11.apply(this, arguments);
	                            };
	                        }())(metricID);
	
	                    case 1:
	                    case 'end':
	                        return _context11.stop();
	                }
	            }
	        }, _callee11, undefined);
	    }));
	
	    return function wrappedFetchMetricQuestions(_x12, _x13) {
	        return _ref10.apply(this, arguments);
	    };
	}();
	var wrappedFetchMetricRevisions = exports.wrappedFetchMetricRevisions = function () {
	    var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee13(props, metricID) {
	        return regeneratorRuntime.wrap(function _callee13$(_context13) {
	            while (1) {
	                switch (_context13.prev = _context13.next) {
	                    case 0:
	
	                        fetchDataWrapper(props, function () {
	                            var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee12(mID) {
	                                return regeneratorRuntime.wrap(function _callee12$(_context12) {
	                                    while (1) {
	                                        switch (_context12.prev = _context12.next) {
	                                            case 0:
	                                                _context12.next = 2;
	                                                return Promise.all([props.fetchMetricRevisions(mID), props.fetchMetrics()]);
	
	                                            case 2:
	                                            case 'end':
	                                                return _context12.stop();
	                                        }
	                                    }
	                                }, _callee12, undefined);
	                            }));
	
	                            return function (_x17) {
	                                return _ref13.apply(this, arguments);
	                            };
	                        }())(metricID);
	
	                    case 1:
	                    case 'end':
	                        return _context13.stop();
	                }
	            }
	        }, _callee13, undefined);
	    }));
	
	    return function wrappedFetchMetricRevisions(_x15, _x16) {
	        return _ref12.apply(this, arguments);
	    };
	}();
	
	// export const wrappedFetchDatabaseMetadataAndQuestion = async (props, databaseID) => {
	//         clearError();
	//         startLoading();
	//         try {
	//             await Promise.all(
	//                     [props.fetchDatabaseMetadata(databaseID),
	//                      props.fetchQuestions()]
	//                 )
	//         }
	//         catch(error) {
	//             console.error(error);
	//             setError(error);
	//         }
	
	//         endLoading();
	// }
	
	var wrappedFetchDatabases = exports.wrappedFetchDatabases = function wrappedFetchDatabases(props) {
	    fetchDataWrapper(props, props.fetchRealDatabases)({});
	};
	var wrappedFetchMetrics = exports.wrappedFetchMetrics = function wrappedFetchMetrics(props) {
	    fetchDataWrapper(props, props.fetchMetrics)({});
	};
	
	var wrappedFetchSegments = exports.wrappedFetchSegments = function wrappedFetchSegments(props) {
	    fetchDataWrapper(props, props.fetchSegments)({});
	};
	
	var wrappedFetchSegmentDetail = exports.wrappedFetchSegmentDetail = function wrappedFetchSegmentDetail(props, segmentID) {
	    fetchDataWrapper(props, props.fetchSegmentTable)(segmentID);
	};
	
	var wrappedFetchSegmentQuestions = exports.wrappedFetchSegmentQuestions = function () {
	    var _ref14 = _asyncToGenerator(regeneratorRuntime.mark(function _callee15(props, segmentID) {
	        return regeneratorRuntime.wrap(function _callee15$(_context15) {
	            while (1) {
	                switch (_context15.prev = _context15.next) {
	                    case 0:
	
	                        fetchDataWrapper(props, function () {
	                            var _ref15 = _asyncToGenerator(regeneratorRuntime.mark(function _callee14(sID) {
	                                return regeneratorRuntime.wrap(function _callee14$(_context14) {
	                                    while (1) {
	                                        switch (_context14.prev = _context14.next) {
	                                            case 0:
	                                                _context14.next = 2;
	                                                return props.fetchSegments(sID);
	
	                                            case 2:
	                                                _context14.next = 4;
	                                                return Promise.all([props.fetchSegmentTable(sID), props.fetchQuestions()]);
	
	                                            case 4:
	                                            case 'end':
	                                                return _context14.stop();
	                                        }
	                                    }
	                                }, _callee14, undefined);
	                            }));
	
	                            return function (_x20) {
	                                return _ref15.apply(this, arguments);
	                            };
	                        }())(segmentID);
	
	                    case 1:
	                    case 'end':
	                        return _context15.stop();
	                }
	            }
	        }, _callee15, undefined);
	    }));
	
	    return function wrappedFetchSegmentQuestions(_x18, _x19) {
	        return _ref14.apply(this, arguments);
	    };
	}();
	var wrappedFetchSegmentRevisions = exports.wrappedFetchSegmentRevisions = function () {
	    var _ref16 = _asyncToGenerator(regeneratorRuntime.mark(function _callee17(props, segmentID) {
	        return regeneratorRuntime.wrap(function _callee17$(_context17) {
	            while (1) {
	                switch (_context17.prev = _context17.next) {
	                    case 0:
	
	                        fetchDataWrapper(props, function () {
	                            var _ref17 = _asyncToGenerator(regeneratorRuntime.mark(function _callee16(sID) {
	                                return regeneratorRuntime.wrap(function _callee16$(_context16) {
	                                    while (1) {
	                                        switch (_context16.prev = _context16.next) {
	                                            case 0:
	                                                _context16.next = 2;
	                                                return props.fetchSegments(sID);
	
	                                            case 2:
	                                                _context16.next = 4;
	                                                return Promise.all([props.fetchSegmentRevisions(sID), props.fetchSegmentTable(sID)]);
	
	                                            case 4:
	                                            case 'end':
	                                                return _context16.stop();
	                                        }
	                                    }
	                                }, _callee16, undefined);
	                            }));
	
	                            return function (_x23) {
	                                return _ref17.apply(this, arguments);
	                            };
	                        }())(segmentID);
	
	                    case 1:
	                    case 'end':
	                        return _context17.stop();
	                }
	            }
	        }, _callee17, undefined);
	    }));
	
	    return function wrappedFetchSegmentRevisions(_x21, _x22) {
	        return _ref16.apply(this, arguments);
	    };
	}();
	var wrappedFetchSegmentFields = exports.wrappedFetchSegmentFields = function () {
	    var _ref18 = _asyncToGenerator(regeneratorRuntime.mark(function _callee19(props, segmentID) {
	        return regeneratorRuntime.wrap(function _callee19$(_context19) {
	            while (1) {
	                switch (_context19.prev = _context19.next) {
	                    case 0:
	
	                        fetchDataWrapper(props, function () {
	                            var _ref19 = _asyncToGenerator(regeneratorRuntime.mark(function _callee18(sID) {
	                                return regeneratorRuntime.wrap(function _callee18$(_context18) {
	                                    while (1) {
	                                        switch (_context18.prev = _context18.next) {
	                                            case 0:
	                                                _context18.next = 2;
	                                                return props.fetchSegments(sID);
	
	                                            case 2:
	                                                _context18.next = 4;
	                                                return Promise.all([props.fetchSegmentFields(sID), props.fetchSegmentTable(sID)]);
	
	                                            case 4:
	                                            case 'end':
	                                                return _context18.stop();
	                                        }
	                                    }
	                                }, _callee18, undefined);
	                            }));
	
	                            return function (_x26) {
	                                return _ref19.apply(this, arguments);
	                            };
	                        }())(segmentID);
	
	                    case 1:
	                    case 'end':
	                        return _context19.stop();
	                }
	            }
	        }, _callee19, undefined);
	    }));
	
	    return function wrappedFetchSegmentFields(_x24, _x25) {
	        return _ref18.apply(this, arguments);
	    };
	}();
	
	// This is called when a component gets a new set of props.
	// I *think* this is un-necessary in all cases as we're using multiple
	// components where the old code re-used the same component
	var clearState = exports.clearState = function clearState(props) {
	    props.endEditing();
	    props.endLoading();
	    props.clearError();
	    props.collapseFormula();
	};
	
	// This is called on the success or failure of a form triggered update
	var resetForm = function resetForm(props) {
	    props.resetForm();
	    props.endLoading();
	    props.endEditing();
	};
	
	// Update actions
	// these use the "fetchDataWrapper" for now. It should probably be renamed.
	// Using props to fire off actions, which imo should be refactored to
	// dispatch directly, since there is no actual dependence with the props
	// of that component
	
	var updateDataWrapper = function updateDataWrapper(props, fn) {
	
	    return function () {
	        var _ref20 = _asyncToGenerator(regeneratorRuntime.mark(function _callee20(fields) {
	            var editedFields, newEntity;
	            return regeneratorRuntime.wrap(function _callee20$(_context20) {
	                while (1) {
	                    switch (_context20.prev = _context20.next) {
	                        case 0:
	                            props.clearError();
	                            props.startLoading();
	                            _context20.prev = 2;
	                            editedFields = (0, _utils.filterUntouchedFields)(fields, props.entity);
	
	                            if ((0, _utils.isEmptyObject)(editedFields)) {
	                                _context20.next = 8;
	                                break;
	                            }
	
	                            newEntity = _extends({}, props.entity, editedFields);
	                            _context20.next = 8;
	                            return fn(newEntity);
	
	                        case 8:
	                            _context20.next = 14;
	                            break;
	
	                        case 10:
	                            _context20.prev = 10;
	                            _context20.t0 = _context20['catch'](2);
	
	                            console.error(_context20.t0);
	                            props.setError(_context20.t0);
	
	                        case 14:
	                            resetForm(props);
	
	                        case 15:
	                        case 'end':
	                            return _context20.stop();
	                    }
	                }
	            }, _callee20, undefined, [[2, 10]]);
	        }));
	
	        return function (_x27) {
	            return _ref20.apply(this, arguments);
	        };
	    }();
	};
	
	var rUpdateSegmentDetail = exports.rUpdateSegmentDetail = function rUpdateSegmentDetail(formFields, props) {
	    updateDataWrapper(props, props.updateSegment)(formFields);
	};
	var rUpdateSegmentFieldDetail = exports.rUpdateSegmentFieldDetail = function rUpdateSegmentFieldDetail(formFields, props) {
	    updateDataWrapper(props, props.updateField)(formFields);
	};
	var rUpdateDatabaseDetail = exports.rUpdateDatabaseDetail = function rUpdateDatabaseDetail(formFields, props) {
	    updateDataWrapper(props, props.updateDatabase)(formFields);
	};
	var rUpdateTableDetail = exports.rUpdateTableDetail = function rUpdateTableDetail(formFields, props) {
	    updateDataWrapper(props, props.updateTable)(formFields);
	};
	var rUpdateFieldDetail = exports.rUpdateFieldDetail = function rUpdateFieldDetail(formFields, props) {
	    updateDataWrapper(props, props.updateField)(formFields);
	};
	
	var rUpdateMetricDetail = exports.rUpdateMetricDetail = function () {
	    var _ref21 = _asyncToGenerator(regeneratorRuntime.mark(function _callee21(metric, guide, formFields, props) {
	        var editedFields, newMetric, importantFieldIds, existingImportantFieldIds, areFieldIdsIdentitical;
	        return regeneratorRuntime.wrap(function _callee21$(_context21) {
	            while (1) {
	                switch (_context21.prev = _context21.next) {
	                    case 0:
	                        props.startLoading();
	                        _context21.prev = 1;
	                        editedFields = (0, _utils.filterUntouchedFields)(formFields, metric);
	
	                        if ((0, _utils.isEmptyObject)(editedFields)) {
	                            _context21.next = 14;
	                            break;
	                        }
	
	                        newMetric = _extends({}, metric, editedFields);
	                        _context21.next = 7;
	                        return props.updateMetric(newMetric);
	
	                    case 7:
	                        importantFieldIds = formFields.important_fields.map(function (field) {
	                            return field.id;
	                        });
	                        existingImportantFieldIds = guide.metric_important_fields && guide.metric_important_fields[metric.id];
	                        areFieldIdsIdentitical = existingImportantFieldIds && existingImportantFieldIds.length === importantFieldIds.length && existingImportantFieldIds.every(function (id) {
	                            return importantFieldIds.includes(id);
	                        });
	
	                        if (areFieldIdsIdentitical) {
	                            _context21.next = 14;
	                            break;
	                        }
	
	                        _context21.next = 13;
	                        return props.updateMetricImportantFields(metric.id, importantFieldIds);
	
	                    case 13:
	                        wrappedFetchMetricDetail(props, metric.id);
	
	                    case 14:
	                        _context21.next = 20;
	                        break;
	
	                    case 16:
	                        _context21.prev = 16;
	                        _context21.t0 = _context21['catch'](1);
	
	                        props.setError(_context21.t0);
	                        console.error(_context21.t0);
	
	                    case 20:
	
	                        resetForm(props);
	
	                    case 21:
	                    case 'end':
	                        return _context21.stop();
	                }
	            }
	        }, _callee21, undefined, [[1, 16]]);
	    }));
	
	    return function rUpdateMetricDetail(_x28, _x29, _x30, _x31) {
	        return _ref21.apply(this, arguments);
	    };
	}();
	
	var rUpdateFields = exports.rUpdateFields = function () {
	    var _ref22 = _asyncToGenerator(regeneratorRuntime.mark(function _callee22(fields, formFields, props) {
	        var updatedFields;
	        return regeneratorRuntime.wrap(function _callee22$(_context22) {
	            while (1) {
	                switch (_context22.prev = _context22.next) {
	                    case 0:
	                        props.startLoading();
	                        _context22.prev = 1;
	                        updatedFields = Object.keys(formFields).map(function (fieldId) {
	                            return {
	                                field: fields[fieldId],
	                                formField: (0, _utils.filterUntouchedFields)(formFields[fieldId], fields[fieldId])
	                            };
	                        }).filter(function (_ref23) {
	                            var field = _ref23.field,
	                                formField = _ref23.formField;
	                            return !(0, _utils.isEmptyObject)(formField);
	                        }).map(function (_ref24) {
	                            var field = _ref24.field,
	                                formField = _ref24.formField;
	                            return _extends({}, field, formField);
	                        });
	                        _context22.next = 5;
	                        return Promise.all(updatedFields.map(props.updateField));
	
	                    case 5:
	                        _context22.next = 11;
	                        break;
	
	                    case 7:
	                        _context22.prev = 7;
	                        _context22.t0 = _context22['catch'](1);
	
	                        props.setError(_context22.t0);
	                        console.error(_context22.t0);
	
	                    case 11:
	
	                        resetForm(props);
	
	                    case 12:
	                    case 'end':
	                        return _context22.stop();
	                }
	            }
	        }, _callee22, undefined, [[1, 7]]);
	    }));
	
	    return function rUpdateFields(_x32, _x33, _x34) {
	        return _ref22.apply(this, arguments);
	    };
	}();
	
	var tryUpdateGuide = exports.tryUpdateGuide = function () {
	    var _ref25 = _asyncToGenerator(regeneratorRuntime.mark(function _callee23(formFields, props) {
	        var guide, dashboards, metrics, segments, tables, startLoading, endLoading, endEditing, setError, resetForm, updateDashboard, updateMetric, updateSegment, updateTable, updateMetricImportantFields, updateSetting, fetchGuide, clearRequestState, updateNewEntities, updateOldEntities, updateWithRevisionMessage, updatingDashboards, updatingMetrics, updatingMetricImportantFields, segmentFields, updatingSegments, tableFields, updatingTables, updatingThingsToKnow, updatingContactName, updatingContactEmail, updatingData;
	        return regeneratorRuntime.wrap(function _callee23$(_context23) {
	            while (1) {
	                switch (_context23.prev = _context23.next) {
	                    case 0:
	                        guide = props.guide, dashboards = props.dashboards, metrics = props.metrics, segments = props.segments, tables = props.tables, startLoading = props.startLoading, endLoading = props.endLoading, endEditing = props.endEditing, setError = props.setError, resetForm = props.resetForm, updateDashboard = props.updateDashboard, updateMetric = props.updateMetric, updateSegment = props.updateSegment, updateTable = props.updateTable, updateMetricImportantFields = props.updateMetricImportantFields, updateSetting = props.updateSetting, fetchGuide = props.fetchGuide, clearRequestState = props.clearRequestState;
	
	
	                        startLoading();
	                        _context23.prev = 2;
	
	                        updateNewEntities = function updateNewEntities(_ref26) {
	                            var entities = _ref26.entities,
	                                formFields = _ref26.formFields,
	                                updateEntity = _ref26.updateEntity;
	                            return formFields.map(function (formField) {
	                                if (!formField.id) {
	                                    return [];
	                                }
	
	                                var editedEntity = (0, _utils.filterUntouchedFields)((0, _icepick.assoc)(formField, 'show_in_getting_started', true), entities[formField.id]);
	
	                                if ((0, _utils.isEmptyObject)(editedEntity)) {
	                                    return [];
	                                }
	
	                                var newEntity = entities[formField.id];
	                                var updatedNewEntity = _extends({}, newEntity, editedEntity);
	
	                                var updatingNewEntity = updateEntity(updatedNewEntity);
	
	                                return [updatingNewEntity];
	                            });
	                        };
	
	                        updateOldEntities = function updateOldEntities(_ref27) {
	                            var newEntityIds = _ref27.newEntityIds,
	                                oldEntityIds = _ref27.oldEntityIds,
	                                entities = _ref27.entities,
	                                updateEntity = _ref27.updateEntity;
	                            return oldEntityIds.filter(function (oldEntityId) {
	                                return !newEntityIds.includes(oldEntityId);
	                            }).map(function (oldEntityId) {
	                                var oldEntity = entities[oldEntityId];
	
	                                var updatedOldEntity = (0, _icepick.assoc)(oldEntity, 'show_in_getting_started', false);
	
	                                var updatingOldEntity = updateEntity(updatedOldEntity);
	
	                                return [updatingOldEntity];
	                            });
	                        };
	                        //FIXME: necessary because revision_message is a mandatory field
	                        // even though we don't actually keep track of changes to caveats/points_of_interest yet
	
	
	                        updateWithRevisionMessage = function updateWithRevisionMessage(updateEntity) {
	                            return function (entity) {
	                                return updateEntity((0, _icepick.assoc)(entity, 'revision_message', 'Updated in Getting Started guide.'));
	                            };
	                        };
	
	                        updatingDashboards = updateNewEntities({
	                            entities: dashboards,
	                            formFields: [formFields.most_important_dashboard],
	                            updateEntity: updateDashboard
	                        }).concat(updateOldEntities({
	                            newEntityIds: formFields.most_important_dashboard ? [formFields.most_important_dashboard.id] : [],
	                            oldEntityIds: guide.most_important_dashboard ? [guide.most_important_dashboard] : [],
	                            entities: dashboards,
	                            updateEntity: updateDashboard
	                        }));
	                        updatingMetrics = updateNewEntities({
	                            entities: metrics,
	                            formFields: formFields.important_metrics,
	                            updateEntity: updateWithRevisionMessage(updateMetric)
	                        }).concat(updateOldEntities({
	                            newEntityIds: formFields.important_metrics.map(function (formField) {
	                                return formField.id;
	                            }),
	                            oldEntityIds: guide.important_metrics,
	                            entities: metrics,
	                            updateEntity: updateWithRevisionMessage(updateMetric)
	                        }));
	                        updatingMetricImportantFields = formFields.important_metrics.map(function (metricFormField) {
	                            if (!metricFormField.id || !metricFormField.important_fields) {
	                                return [];
	                            }
	                            var importantFieldIds = metricFormField.important_fields.map(function (field) {
	                                return field.id;
	                            });
	                            var existingImportantFieldIds = guide.metric_important_fields[metricFormField.id];
	
	                            var areFieldIdsIdentitical = existingImportantFieldIds && existingImportantFieldIds.length === importantFieldIds.length && existingImportantFieldIds.every(function (id) {
	                                return importantFieldIds.includes(id);
	                            });
	                            if (areFieldIdsIdentitical) {
	                                return [];
	                            }
	
	                            return [updateMetricImportantFields(metricFormField.id, importantFieldIds)];
	                        });
	                        segmentFields = formFields.important_segments_and_tables.filter(function (field) {
	                            return field.type === 'segment';
	                        });
	                        updatingSegments = updateNewEntities({
	                            entities: segments,
	                            formFields: segmentFields,
	                            updateEntity: updateWithRevisionMessage(updateSegment)
	                        }).concat(updateOldEntities({
	                            newEntityIds: segmentFields.map(function (formField) {
	                                return formField.id;
	                            }),
	                            oldEntityIds: guide.important_segments,
	                            entities: segments,
	                            updateEntity: updateWithRevisionMessage(updateSegment)
	                        }));
	                        tableFields = formFields.important_segments_and_tables.filter(function (field) {
	                            return field.type === 'table';
	                        });
	                        updatingTables = updateNewEntities({
	                            entities: tables,
	                            formFields: tableFields,
	                            updateEntity: updateTable
	                        }).concat(updateOldEntities({
	                            newEntityIds: tableFields.map(function (formField) {
	                                return formField.id;
	                            }),
	                            oldEntityIds: guide.important_tables,
	                            entities: tables,
	                            updateEntity: updateTable
	                        }));
	                        updatingThingsToKnow = guide.things_to_know !== formFields.things_to_know ? [updateSetting({ key: 'getting-started-things-to-know', value: formFields.things_to_know })] : [];
	                        updatingContactName = guide.contact && formFields.contact && guide.contact.name !== formFields.contact.name ? [updateSetting({ key: 'getting-started-contact-name', value: formFields.contact.name })] : [];
	                        updatingContactEmail = guide.contact && formFields.contact && guide.contact.email !== formFields.contact.email ? [updateSetting({ key: 'getting-started-contact-email', value: formFields.contact.email })] : [];
	                        updatingData = _underscore2.default.flatten([updatingDashboards, updatingMetrics, updatingMetricImportantFields, updatingSegments, updatingTables, updatingThingsToKnow, updatingContactName, updatingContactEmail]);
	
	                        if (!(updatingData.length > 0)) {
	                            _context23.next = 23;
	                            break;
	                        }
	
	                        _context23.next = 20;
	                        return Promise.all(updatingData);
	
	                    case 20:
	
	                        clearRequestState({ statePath: ['reference', 'guide'] });
	
	                        _context23.next = 23;
	                        return fetchGuide();
	
	                    case 23:
	                        _context23.next = 29;
	                        break;
	
	                    case 25:
	                        _context23.prev = 25;
	                        _context23.t0 = _context23['catch'](2);
	
	                        setError(_context23.t0);
	                        console.error(_context23.t0);
	
	                    case 29:
	
	                        resetForm();
	                        endLoading();
	                        endEditing();
	
	                    case 32:
	                    case 'end':
	                        return _context23.stop();
	                }
	            }
	        }, _callee23, undefined, [[2, 25]]);
	    }));
	
	    return function tryUpdateGuide(_x35, _x36) {
	        return _ref25.apply(this, arguments);
	    };
	}();
	
	var initialState = {
	    error: null,
	    isLoading: false,
	    isEditing: false,
	    isFormulaExpanded: false,
	    isDashboardModalOpen: false
	};
	exports.default = (0, _redux.handleActions)((_handleActions = {}, _defineProperty(_handleActions, FETCH_GUIDE, {
	    next: function next(state, _ref28) {
	        var payload = _ref28.payload;
	        return (0, _icepick.assoc)(state, 'guide', payload);
	    }
	}), _defineProperty(_handleActions, SET_ERROR, {
	    throw: function _throw(state, _ref29) {
	        var payload = _ref29.payload;
	        return (0, _icepick.assoc)(state, 'error', payload);
	    }
	}), _defineProperty(_handleActions, CLEAR_ERROR, {
	    next: function next(state) {
	        return (0, _icepick.assoc)(state, 'error', null);
	    }
	}), _defineProperty(_handleActions, START_LOADING, {
	    next: function next(state) {
	        return (0, _icepick.assoc)(state, 'isLoading', true);
	    }
	}), _defineProperty(_handleActions, END_LOADING, {
	    next: function next(state) {
	        return (0, _icepick.assoc)(state, 'isLoading', false);
	    }
	}), _defineProperty(_handleActions, START_EDITING, {
	    next: function next(state) {
	        return (0, _icepick.assoc)(state, 'isEditing', true);
	    }
	}), _defineProperty(_handleActions, END_EDITING, {
	    next: function next(state) {
	        return (0, _icepick.assoc)(state, 'isEditing', false);
	    }
	}), _defineProperty(_handleActions, EXPAND_FORMULA, {
	    next: function next(state) {
	        return (0, _icepick.assoc)(state, 'isFormulaExpanded', true);
	    }
	}), _defineProperty(_handleActions, COLLAPSE_FORMULA, {
	    next: function next(state) {
	        return (0, _icepick.assoc)(state, 'isFormulaExpanded', false);
	    }
	}), _defineProperty(_handleActions, SHOW_DASHBOARD_MODAL, {
	    next: function next(state) {
	        return (0, _icepick.assoc)(state, 'isDashboardModalOpen', true);
	    }
	}), _defineProperty(_handleActions, HIDE_DASHBOARD_MODAL, {
	    next: function next(state) {
	        return (0, _icepick.assoc)(state, 'isDashboardModalOpen', false);
	    }
	}), _handleActions), initialState);

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getIsDashboardModalOpen = exports.getDashboards = exports.getGuide = exports.getIsFormulaExpanded = exports.getIsEditing = exports.getHasSingleSchema = exports.getError = exports.getLoading = exports.getForeignKeys = exports.getTableQuestions = exports.getSegmentQuestions = exports.getSegmentRevisions = exports.getMetricRevisions = exports.getMetricQuestions = exports.getFieldBySegment = exports.getField = exports.getFieldsBySegment = exports.getFieldsByTable = exports.getFieldId = exports.getTable = exports.getTableBySegment = exports.getTablesByDatabase = exports.getTableId = exports.getDatabase = exports.getDatabaseId = exports.getSegment = exports.getSegmentId = exports.getMetric = exports.getMetricId = exports.getUser = exports.getSegments = exports.getMetrics = exports.getFields = exports.getTables = exports.getDatabases = undefined;
	
	var _metadata = __webpack_require__(1073);
	
	Object.defineProperty(exports, "getDatabases", {
	    enumerable: true,
	    get: function get() {
	        return _metadata.getShallowDatabases;
	    }
	});
	Object.defineProperty(exports, "getTables", {
	    enumerable: true,
	    get: function get() {
	        return _metadata.getShallowTables;
	    }
	});
	Object.defineProperty(exports, "getFields", {
	    enumerable: true,
	    get: function get() {
	        return _metadata.getShallowFields;
	    }
	});
	Object.defineProperty(exports, "getMetrics", {
	    enumerable: true,
	    get: function get() {
	        return _metadata.getShallowMetrics;
	    }
	});
	Object.defineProperty(exports, "getSegments", {
	    enumerable: true,
	    get: function get() {
	        return _metadata.getShallowSegments;
	    }
	});
	
	var _reselect = __webpack_require__(1072);
	
	var _icepick = __webpack_require__(855);
	
	var _selectors = __webpack_require__(1602);
	
	var _query = __webpack_require__(866);
	
	var _query2 = _interopRequireDefault(_query);
	
	var _redux = __webpack_require__(657);
	
	var _utils = __webpack_require__(1920);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getUser = exports.getUser = function getUser(state, props) {
	    return state.currentUser;
	};
	
	var getMetricId = exports.getMetricId = function getMetricId(state, props) {
	    return Number.parseInt(props.params.metricId);
	};
	var getMetric = exports.getMetric = (0, _reselect.createSelector)([getMetricId, _metadata.getShallowMetrics], function (metricId, metrics) {
	    return metrics[metricId] || { id: metricId };
	});
	
	var getSegmentId = exports.getSegmentId = function getSegmentId(state, props) {
	    return Number.parseInt(props.params.segmentId);
	};
	var getSegment = exports.getSegment = (0, _reselect.createSelector)([getSegmentId, _metadata.getShallowSegments], function (segmentId, segments) {
	    return segments[segmentId] || { id: segmentId };
	});
	
	var getDatabaseId = exports.getDatabaseId = function getDatabaseId(state, props) {
	    return Number.parseInt(props.params.databaseId);
	};
	
	var getDatabase = exports.getDatabase = (0, _reselect.createSelector)([getDatabaseId, _metadata.getShallowDatabases], function (databaseId, databases) {
	    return databases[databaseId] || { id: databaseId };
	});
	
	var getTableId = exports.getTableId = function getTableId(state, props) {
	    return Number.parseInt(props.params.tableId);
	};
	// export const getTableId = (state, props) => Number.parseInt(props.params.tableId);
	var getTablesByDatabase = exports.getTablesByDatabase = (0, _reselect.createSelector)([_metadata.getShallowTables, getDatabase], function (tables, database) {
	    return tables && database && database.tables ? (0, _utils.idsToObjectMap)(database.tables, tables) : {};
	});
	var getTableBySegment = exports.getTableBySegment = (0, _reselect.createSelector)([getSegment, _metadata.getShallowTables], function (segment, tables) {
	    return segment && segment.table_id ? tables[segment.table_id] : {};
	});
	var getTableByMetric = (0, _reselect.createSelector)([getMetric, _metadata.getShallowTables], function (metric, tables) {
	    return metric && metric.table_id ? tables[metric.table_id] : {};
	});
	var getTable = exports.getTable = (0, _reselect.createSelector)([getTableId, _metadata.getShallowTables, getMetricId, getTableByMetric, getSegmentId, getTableBySegment], function (tableId, tables, metricId, tableByMetric, segmentId, tableBySegment) {
	    return tableId ? tables[tableId] || { id: tableId } : metricId ? tableByMetric : segmentId ? tableBySegment : {};
	});
	
	var getFieldId = exports.getFieldId = function getFieldId(state, props) {
	    return Number.parseInt(props.params.fieldId);
	};
	var getFieldsByTable = exports.getFieldsByTable = (0, _reselect.createSelector)([getTable, _metadata.getShallowFields], function (table, fields) {
	    return table && table.fields ? (0, _utils.idsToObjectMap)(table.fields, fields) : {};
	});
	var getFieldsBySegment = exports.getFieldsBySegment = (0, _reselect.createSelector)([getTableBySegment, _metadata.getShallowFields], function (table, fields) {
	    return table && table.fields ? (0, _utils.idsToObjectMap)(table.fields, fields) : {};
	});
	var getField = exports.getField = (0, _reselect.createSelector)([getFieldId, _metadata.getShallowFields], function (fieldId, fields) {
	    return fields[fieldId] || { id: fieldId };
	});
	var getFieldBySegment = exports.getFieldBySegment = (0, _reselect.createSelector)([getFieldId, getFieldsBySegment], function (fieldId, fields) {
	    return fields[fieldId] || { id: fieldId };
	});
	
	var getQuestions = function getQuestions(state, props) {
	    return (0, _icepick.getIn)(state, ['questions', 'entities', 'cards']) || {};
	};
	
	var getMetricQuestions = exports.getMetricQuestions = (0, _reselect.createSelector)([getMetricId, getQuestions], function (metricId, questions) {
	    return Object.values(questions).filter(function (question) {
	        return question.dataset_query.type === "query" && _underscore2.default.any(_query2.default.getAggregations(question.dataset_query.query), function (aggregation) {
	            return _query.AggregationClause.getMetric(aggregation) === metricId;
	        });
	    }).reduce(function (map, question) {
	        return (0, _icepick.assoc)(map, question.id, question);
	    }, {});
	});
	
	var getRevisions = function getRevisions(state, props) {
	    return state.metadata.revisions;
	};
	
	var getMetricRevisions = exports.getMetricRevisions = (0, _reselect.createSelector)([getMetricId, getRevisions], function (metricId, revisions) {
	    return (0, _icepick.getIn)(revisions, ['metric', metricId]) || {};
	});
	
	var getSegmentRevisions = exports.getSegmentRevisions = (0, _reselect.createSelector)([getSegmentId, getRevisions], function (segmentId, revisions) {
	    return (0, _icepick.getIn)(revisions, ['segment', segmentId]) || {};
	});
	
	var getSegmentQuestions = exports.getSegmentQuestions = (0, _reselect.createSelector)([getSegmentId, getQuestions], function (segmentId, questions) {
	    return Object.values(questions).filter(function (question) {
	        return question.dataset_query.type === "query" && _query2.default.getFilters(question.dataset_query.query).some(function (filter) {
	            return _query2.default.isSegmentFilter(filter) && filter[1] === segmentId;
	        });
	    }).reduce(function (map, question) {
	        return (0, _icepick.assoc)(map, question.id, question);
	    }, {});
	});
	
	var getTableQuestions = exports.getTableQuestions = (0, _reselect.createSelector)([getTable, getQuestions], function (table, questions) {
	    return Object.values(questions).filter(function (question) {
	        return question.table_id === table.id;
	    });
	});
	
	var getDatabaseBySegment = (0, _reselect.createSelector)([getSegment, _metadata.getShallowTables, _metadata.getShallowDatabases], function (segment, tables, databases) {
	    return segment && segment.table_id && tables[segment.table_id] && databases[tables[segment.table_id].db_id] || {};
	});
	
	var getForeignKeysBySegment = (0, _reselect.createSelector)([getDatabaseBySegment], _utils.databaseToForeignKeys);
	
	var getForeignKeysByDatabase = (0, _reselect.createSelector)([getDatabase], _utils.databaseToForeignKeys);
	
	var getForeignKeys = exports.getForeignKeys = (0, _reselect.createSelector)([getSegmentId, getForeignKeysBySegment, getForeignKeysByDatabase], function (segmentId, foreignKeysBySegment, foreignKeysByDatabase) {
	    return segmentId ? foreignKeysBySegment : foreignKeysByDatabase;
	});
	
	var getLoading = exports.getLoading = function getLoading(state, props) {
	    return state.reference.isLoading;
	};
	
	var getError = exports.getError = function getError(state, props) {
	    return state.reference.error;
	};
	
	var getHasSingleSchema = exports.getHasSingleSchema = (0, _reselect.createSelector)([getTablesByDatabase], function (tables) {
	    return tables && Object.keys(tables).length > 0 ? Object.values(tables).every(function (table, index, tables) {
	        return table.schema === tables[0].schema;
	    }) : true;
	});
	
	var getIsEditing = exports.getIsEditing = function getIsEditing(state, props) {
	    return state.reference.isEditing;
	};
	
	var getIsFormulaExpanded = exports.getIsFormulaExpanded = function getIsFormulaExpanded(state, props) {
	    return state.reference.isFormulaExpanded;
	};
	
	var getGuide = exports.getGuide = function getGuide(state, props) {
	    return state.reference.guide;
	};
	
	var getDashboards = exports.getDashboards = function getDashboards(state, props) {
	    return (0, _selectors.getDashboardListing)(state) && (0, _redux.resourceListToMap)((0, _selectors.getDashboardListing)(state));
	};
	
	var getIsDashboardModalOpen = exports.getIsDashboardModalOpen = function getIsDashboardModalOpen(state, props) {
	    return state.reference.isDashboardModalOpen;
	};

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reduxForm = __webpack_require__(589);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _CreateDashboardModal = __webpack_require__(1596);
	
	var _CreateDashboardModal2 = _interopRequireDefault(_CreateDashboardModal);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _EditHeader = __webpack_require__(1924);
	
	var _EditHeader2 = _interopRequireDefault(_EditHeader);
	
	var _GuideEditSection = __webpack_require__(1930);
	
	var _GuideEditSection2 = _interopRequireDefault(_GuideEditSection);
	
	var _GuideDetailEditor = __webpack_require__(1933);
	
	var _GuideDetailEditor2 = _interopRequireDefault(_GuideDetailEditor);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _requests = __webpack_require__(856);
	
	var _dashboards = __webpack_require__(1521);
	
	var _settings = __webpack_require__(1906);
	
	var _GuideDetailEditor3 = __webpack_require__(1934);
	
	var _GuideDetailEditor4 = _interopRequireDefault(_GuideDetailEditor3);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var guide = (0, _selectors.getGuide)(state, props);
	    var dashboards = (0, _selectors.getDashboards)(state, props);
	    var metrics = (0, _selectors.getMetrics)(state, props);
	    var segments = (0, _selectors.getSegments)(state, props);
	    var tables = (0, _selectors.getTables)(state, props);
	    var fields = (0, _selectors.getFields)(state, props);
	    var databases = (0, _selectors.getDatabases)(state, props);
	
	    // redux-form populates fields with stale values after update
	    // if we dont specify nulls here
	    // could use a lot of refactoring
	    var initialValues = guide && {
	        things_to_know: guide.things_to_know || null,
	        contact: guide.contact || { name: null, email: null },
	        most_important_dashboard: dashboards !== null && guide.most_important_dashboard !== null ? dashboards[guide.most_important_dashboard] : {},
	        important_metrics: guide.important_metrics && guide.important_metrics.length > 0 ? guide.important_metrics.map(function (metricId) {
	            return metrics[metricId] && _extends({}, metrics[metricId], {
	                important_fields: guide.metric_important_fields[metricId] && guide.metric_important_fields[metricId].map(function (fieldId) {
	                    return fields[fieldId];
	                })
	            });
	        }) : [],
	        important_segments_and_tables: guide.important_segments && guide.important_segments.length > 0 || guide.important_tables && guide.important_tables.length > 0 ? guide.important_segments.map(function (segmentId) {
	            return segments[segmentId] && _extends({}, segments[segmentId], { type: 'segment' });
	        }).concat(guide.important_tables.map(function (tableId) {
	            return tables[tableId] && _extends({}, tables[tableId], { type: 'table' });
	        })) : []
	    };
	
	    return {
	        guide: guide,
	        dashboards: dashboards,
	        metrics: metrics,
	        segments: segments,
	        tables: tables,
	        databases: databases,
	        // FIXME: avoids naming conflict, tried using the propNamespace option
	        // version but couldn't quite get it to work together with passing in
	        // dynamic initialValues
	        metadataFields: fields,
	        loading: (0, _selectors.getLoading)(state, props),
	        // naming this 'error' will conflict with redux form
	        loadingError: (0, _selectors.getError)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        isDashboardModalOpen: (0, _selectors.getIsDashboardModalOpen)(state, props),
	        // redux form doesn't pass this through to component
	        // need to use to reset form field arrays
	        initialValues: initialValues,
	        initialFormValues: initialValues
	    };
	};
	
	var mapDispatchToProps = _extends({
	    updateDashboard: _dashboards.updateDashboard,
	    createDashboard: _dashboards.createDashboard,
	    updateSetting: _settings.updateSetting,
	    clearRequestState: _requests.clearRequestState
	}, metadataActions, actions);
	
	var GettingStartedGuideEditForm = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reduxForm.reduxForm)({
	    form: 'guide',
	    fields: ['things_to_know', 'contact.name', 'contact.email', 'most_important_dashboard.id', 'most_important_dashboard.caveats', 'most_important_dashboard.points_of_interest', 'important_metrics[].id', 'important_metrics[].caveats', 'important_metrics[].points_of_interest', 'important_metrics[].important_fields', 'important_segments_and_tables[].id', 'important_segments_and_tables[].type', 'important_segments_and_tables[].caveats', 'important_segments_and_tables[].points_of_interest']
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    _inherits(GettingStartedGuideEditForm, _Component);
	
	    function GettingStartedGuideEditForm() {
	        _classCallCheck(this, GettingStartedGuideEditForm);
	
	        return _possibleConstructorReturn(this, (GettingStartedGuideEditForm.__proto__ || Object.getPrototypeOf(GettingStartedGuideEditForm)).apply(this, arguments));
	    }
	
	    _createClass(GettingStartedGuideEditForm, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$fields = _props.fields,
	                things_to_know = _props$fields.things_to_know,
	                contact = _props$fields.contact,
	                most_important_dashboard = _props$fields.most_important_dashboard,
	                important_metrics = _props$fields.important_metrics,
	                important_segments_and_tables = _props$fields.important_segments_and_tables,
	                style = _props.style,
	                guide = _props.guide,
	                dashboards = _props.dashboards,
	                metrics = _props.metrics,
	                segments = _props.segments,
	                tables = _props.tables,
	                databases = _props.databases,
	                metadataFields = _props.metadataFields,
	                loadingError = _props.loadingError,
	                loading = _props.loading,
	                isEditing = _props.isEditing,
	                endEditing = _props.endEditing,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting,
	                initialFormValues = _props.initialFormValues,
	                initializeForm = _props.initializeForm,
	                createDashboard = _props.createDashboard,
	                isDashboardModalOpen = _props.isDashboardModalOpen,
	                showDashboardModal = _props.showDashboardModal,
	                hideDashboardModal = _props.hideDashboardModal;
	
	
	            var onSubmit = handleSubmit(function () {
	                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(fields) {
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    _context.next = 2;
	                                    return actions.tryUpdateGuide(fields, _this2.props);
	
	                                case 2:
	                                    return _context.abrupt("return", _context.sent);
	
	                                case 3:
	                                case "end":
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                    return _ref.apply(this, arguments);
	                };
	            }());
	
	            var getSelectedIds = function getSelectedIds(fields) {
	                return fields.map(function (field) {
	                    return field.id.value;
	                }).filter(function (id) {
	                    return id !== null;
	                });
	            };
	
	            var getSelectedIdTypePairs = function getSelectedIdTypePairs(fields) {
	                return fields.map(function (field) {
	                    return [field.id.value, field.type.value];
	                }).filter(function (idTypePair) {
	                    return idTypePair[0] !== null;
	                });
	            };
	
	            return _react2.default.createElement(
	                "form",
	                { className: "full relative py4", style: style, onSubmit: onSubmit },
	                isDashboardModalOpen && _react2.default.createElement(
	                    _Modal2.default,
	                    null,
	                    _react2.default.createElement(_CreateDashboardModal2.default, {
	                        createDashboardFn: function () {
	                            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(newDashboard) {
	                                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                                    while (1) {
	                                        switch (_context2.prev = _context2.next) {
	                                            case 0:
	                                                _context2.prev = 0;
	                                                _context2.next = 3;
	                                                return createDashboard(newDashboard, { redirect: true });
	
	                                            case 3:
	                                                _context2.next = 8;
	                                                break;
	
	                                            case 5:
	                                                _context2.prev = 5;
	                                                _context2.t0 = _context2["catch"](0);
	
	                                                console.error(_context2.t0);
	
	                                            case 8:
	                                            case "end":
	                                                return _context2.stop();
	                                        }
	                                    }
	                                }, _callee2, _this2, [[0, 5]]);
	                            }));
	
	                            return function (_x2) {
	                                return _ref2.apply(this, arguments);
	                            };
	                        }(),
	                        onClose: hideDashboardModal
	                    })
	                ),
	                isEditing && _react2.default.createElement(_EditHeader2.default, {
	                    endEditing: endEditing
	                    // resetForm doesn't reset field arrays
	                    , reinitializeForm: function reinitializeForm() {
	                        return initializeForm(initialFormValues);
	                    },
	                    submitting: submitting
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { className: "full", style: style, loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "mt4 py2" },
	                                _react2.default.createElement(
	                                    "h1",
	                                    { className: "my3 text-dark" },
	                                    "Help new Metabase users find their way around."
	                                ),
	                                _react2.default.createElement(
	                                    "p",
	                                    { className: "text-paragraph text-measure" },
	                                    "The Getting Started guide highlights the dashboard, metrics, segments, and tables that matter most, and informs your users of important things they should know before digging into the data."
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _GuideEditSection2.default,
	                                {
	                                    isCollapsed: most_important_dashboard.id.value === undefined,
	                                    isDisabled: !dashboards || Object.keys(dashboards).length === 0,
	                                    collapsedTitle: "Is there an important dashboard for your team?",
	                                    collapsedIcon: "dashboard",
	                                    linkMessage: "Create a dashboard now",
	                                    action: showDashboardModal,
	                                    expand: function expand() {
	                                        return most_important_dashboard.id.onChange(null);
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        SectionHeader,
	                                        null,
	                                        "What is your most important dashboard?"
	                                    ),
	                                    _react2.default.createElement(_GuideDetailEditor2.default, {
	                                        type: "dashboard",
	                                        entities: dashboards,
	                                        selectedIds: [most_important_dashboard.id.value],
	                                        formField: most_important_dashboard,
	                                        removeField: function removeField() {
	                                            most_important_dashboard.id.onChange(null);
	                                            most_important_dashboard.points_of_interest.onChange('');
	                                            most_important_dashboard.caveats.onChange('');
	                                        }
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _GuideEditSection2.default,
	                                {
	                                    isCollapsed: important_metrics.length === 0,
	                                    isDisabled: !metrics || Object.keys(metrics).length === 0,
	                                    collapsedTitle: "Do you have any commonly referenced metrics?",
	                                    collapsedIcon: "ruler",
	                                    linkMessage: "Learn how to define a metric",
	                                    link: "http://www.metabase.com/docs/latest/administration-guide/07-segments-and-metrics.html#creating-a-metric",
	                                    expand: function expand() {
	                                        return important_metrics.addField({ id: null, caveats: null, points_of_interest: null, important_fields: null });
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "my2" },
	                                    _react2.default.createElement(
	                                        SectionHeader,
	                                        null,
	                                        "What are your 3-5 most commonly referenced metrics?"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        null,
	                                        important_metrics.map(function (metricField, index, metricFields) {
	                                            return _react2.default.createElement(_GuideDetailEditor2.default, {
	                                                key: index,
	                                                type: "metric",
	                                                metadata: {
	                                                    tables: tables,
	                                                    metrics: metrics,
	                                                    fields: metadataFields,
	                                                    metricImportantFields: guide.metric_important_fields
	                                                },
	                                                entities: metrics,
	                                                formField: metricField,
	                                                selectedIds: getSelectedIds(metricFields),
	                                                removeField: function removeField() {
	                                                    if (metricFields.length > 1) {
	                                                        return metricFields.removeField(index);
	                                                    }
	                                                    metricField.id.onChange(null);
	                                                    metricField.points_of_interest.onChange('');
	                                                    metricField.caveats.onChange('');
	                                                    metricField.important_fields.onChange(null);
	                                                }
	                                            });
	                                        })
	                                    ),
	                                    important_metrics.length < 5 && important_metrics.length < Object.keys(metrics).length && _react2.default.createElement(
	                                        "button",
	                                        {
	                                            className: "Button Button--primary Button--large",
	                                            type: "button",
	                                            onClick: function onClick() {
	                                                return important_metrics.addField({ id: null, caveats: null, points_of_interest: null });
	                                            }
	                                        },
	                                        "Add another metric"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _GuideEditSection2.default,
	                                {
	                                    isCollapsed: important_segments_and_tables.length === 0,
	                                    isDisabled: (!segments || Object.keys(segments).length === 0) && (!tables || Object.keys(tables).length === 0),
	                                    showLink: !segments || Object.keys(segments).length === 0,
	                                    collapsedTitle: "Do you have any commonly referenced segments or tables?",
	                                    collapsedIcon: "table2",
	                                    linkMessage: "Learn how to create a segment",
	                                    link: "http://www.metabase.com/docs/latest/administration-guide/07-segments-and-metrics.html#creating-a-segment",
	                                    expand: function expand() {
	                                        return important_segments_and_tables.addField({ id: null, type: null, caveats: null, points_of_interest: null });
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        "h2",
	                                        { className: "text-measure text-dark" },
	                                        "What are 3-5 commonly referenced segments or tables that would be useful for this audience?"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "mb2" },
	                                        important_segments_and_tables.map(function (segmentOrTableField, index, segmentOrTableFields) {
	                                            return _react2.default.createElement(_GuideDetailEditor2.default, {
	                                                key: index,
	                                                type: "segment",
	                                                metadata: {
	                                                    databases: databases,
	                                                    tables: tables,
	                                                    segments: segments
	                                                },
	                                                formField: segmentOrTableField,
	                                                selectedIdTypePairs: getSelectedIdTypePairs(segmentOrTableFields),
	                                                removeField: function removeField() {
	                                                    if (segmentOrTableFields.length > 1) {
	                                                        return segmentOrTableFields.removeField(index);
	                                                    }
	                                                    segmentOrTableField.id.onChange(null);
	                                                    segmentOrTableField.type.onChange(null);
	                                                    segmentOrTableField.points_of_interest.onChange('');
	                                                    segmentOrTableField.caveats.onChange('');
	                                                }
	                                            });
	                                        })
	                                    ),
	                                    important_segments_and_tables.length < 5 && important_segments_and_tables.length < Object.keys(tables).concat(Object.keys.segments).length && _react2.default.createElement(
	                                        "button",
	                                        {
	                                            className: "Button Button--primary Button--large",
	                                            type: "button",
	                                            onClick: function onClick() {
	                                                return important_segments_and_tables.addField({ id: null, type: null, caveats: null, points_of_interest: null });
	                                            }
	                                        },
	                                        "Add another segment or table"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _GuideEditSection2.default,
	                                {
	                                    isCollapsed: things_to_know.value === null,
	                                    isDisabled: false,
	                                    collapsedTitle: "Is there anything your users should understand or know before they start accessing the data?",
	                                    collapsedIcon: "reference",
	                                    expand: function expand() {
	                                        return things_to_know.onChange('');
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "text-measure" },
	                                    _react2.default.createElement(
	                                        SectionHeader,
	                                        null,
	                                        "What should a user of this data know before they start accessing it?"
	                                    ),
	                                    _react2.default.createElement("textarea", _extends({
	                                        className: _GuideDetailEditor4.default.guideDetailEditorTextarea,
	                                        placeholder: "E.g., expectations around data privacy and use, common pitfalls or misunderstandings, information about data warehouse performance, legal notices, etc."
	                                    }, things_to_know))
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _GuideEditSection2.default,
	                                {
	                                    isCollapsed: contact.name.value === null && contact.email.value === null,
	                                    isDisabled: false,
	                                    collapsedTitle: "Is there someone your users could contact for help if they're confused about this guide?",
	                                    collapsedIcon: "mail",
	                                    expand: function expand() {
	                                        contact.name.onChange('');
	                                        contact.email.onChange('');
	                                    }
	                                },
	                                _react2.default.createElement(
	                                    "div",
	                                    null,
	                                    _react2.default.createElement(
	                                        SectionHeader,
	                                        null,
	                                        "Who should users contact for help if they're confused about this data?"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "flex" },
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "flex-full" },
	                                            _react2.default.createElement(
	                                                "h3",
	                                                { className: "mb1" },
	                                                "Name"
	                                            ),
	                                            _react2.default.createElement("input", _extends({
	                                                className: "input text-paragraph",
	                                                placeholder: "Julie McHelpfulson",
	                                                type: "text"
	                                            }, contact.name))
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "flex-full" },
	                                            _react2.default.createElement(
	                                                "h3",
	                                                { className: "mb1" },
	                                                "Email address"
	                                            ),
	                                            _react2.default.createElement("input", _extends({
	                                                className: "input text-paragraph",
	                                                placeholder: "julie.mchelpfulson@acme.com",
	                                                type: "text"
	                                            }, contact.email))
	                                        )
	                                    )
	                                )
	                            )
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return GettingStartedGuideEditForm;
	}(_react.Component), _class2.propTypes = {
	    fields: _propTypes2.default.object,
	    style: _propTypes2.default.object,
	    guide: _propTypes2.default.object,
	    dashboards: _propTypes2.default.object,
	    metrics: _propTypes2.default.object,
	    segments: _propTypes2.default.object,
	    tables: _propTypes2.default.object,
	    databases: _propTypes2.default.object,
	    metadataFields: _propTypes2.default.object,
	    loadingError: _propTypes2.default.any,
	    loading: _propTypes2.default.bool,
	    isEditing: _propTypes2.default.bool,
	    endEditing: _propTypes2.default.func,
	    handleSubmit: _propTypes2.default.func,
	    submitting: _propTypes2.default.bool,
	    initialFormValues: _propTypes2.default.object,
	    initializeForm: _propTypes2.default.func,
	    createDashboard: _propTypes2.default.func,
	    isDashboardModalOpen: _propTypes2.default.bool,
	    showDashboardModal: _propTypes2.default.func,
	    hideDashboardModal: _propTypes2.default.func
	}, _temp)) || _class) || _class);
	GettingStartedGuideEditForm.displayName = "GettingStartedGuideEditForm";
	exports.default = GettingStartedGuideEditForm;
	
	
	var SectionHeader = function SectionHeader(_ref3) {
	    var trim = _ref3.trim,
	        children = _ref3.children;
	    return (// eslint-disable-line react/prop-types
	        _react2.default.createElement(
	            "h2",
	            { className: (0, _classnames2.default)('text-dark text-measure', { "mb0": trim }, { "mb4": !trim }) },
	            children
	        )
	    );
	};
	SectionHeader.displayName = "SectionHeader";

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _EditHeader = __webpack_require__(1925);
	
	var _EditHeader2 = _interopRequireDefault(_EditHeader);
	
	var _RevisionMessageModal = __webpack_require__(1927);
	
	var _RevisionMessageModal2 = _interopRequireDefault(_RevisionMessageModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditHeader = function EditHeader(_ref) {
	    var hasRevisionHistory = _ref.hasRevisionHistory,
	        endEditing = _ref.endEditing,
	        _ref$reinitializeForm = _ref.reinitializeForm,
	        reinitializeForm = _ref$reinitializeForm === undefined ? function () {
	        return undefined;
	    } : _ref$reinitializeForm,
	        submitting = _ref.submitting,
	        onSubmit = _ref.onSubmit,
	        revisionMessageFormField = _ref.revisionMessageFormField;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("EditHeader wrapper py1", _EditHeader2.default.editHeader) },
	        _react2.default.createElement(
	            "div",
	            null,
	            "You are editing this page"
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _EditHeader2.default.editHeaderButtons },
	            _react2.default.createElement(
	                "button",
	                {
	                    type: "button",
	                    className: (0, _classnames2.default)("Button", "Button--white", "Button--small", _EditHeader2.default.cancelButton),
	                    onClick: function onClick() {
	                        endEditing();
	                        reinitializeForm();
	                    }
	                },
	                "Cancel"
	            ),
	            hasRevisionHistory ? _react2.default.createElement(
	                _RevisionMessageModal2.default,
	                {
	                    action: function action() {
	                        return onSubmit();
	                    },
	                    field: revisionMessageFormField,
	                    submitting: submitting
	                },
	                _react2.default.createElement(
	                    "button",
	                    {
	                        className: (0, _classnames2.default)("Button", "Button--primary", "Button--white", "Button--small", _EditHeader2.default.saveButton),
	                        type: "button",
	                        disabled: submitting
	                    },
	                    "Save"
	                )
	            ) : _react2.default.createElement(
	                "button",
	                {
	                    className: (0, _classnames2.default)("Button", "Button--primary", "Button--white", "Button--small", _EditHeader2.default.saveButton),
	                    type: "submit",
	                    disabled: submitting
	                },
	                "Save"
	            )
	        )
	    );
	};
	EditHeader.displayName = "EditHeader";
	EditHeader.propTypes = {
	    hasRevisionHistory: _propTypes2.default.bool,
	    endEditing: _propTypes2.default.func.isRequired,
	    reinitializeForm: _propTypes2.default.func,
	    submitting: _propTypes2.default.bool.isRequired,
	    onSubmit: _propTypes2.default.func,
	    revisionMessageFormField: _propTypes2.default.object
	};
	
	exports.default = (0, _pure2.default)(EditHeader);

/***/ }),
/* 1925 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"editHeader":"_2EsTk JmZU_ _38618 _3Dqep","editHeaderButtons":"_3xwd3 VW9bs","editHeaderButton":"_34R76","saveButton":"_2jdvQ _34R76","cancelButton":"_1swfk _34R76"};

/***/ }),
/* 1926 */,
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _RevisionMessageModal = __webpack_require__(1928);
	
	var _RevisionMessageModal2 = _interopRequireDefault(_RevisionMessageModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RevisionMessageModal = (_temp = _class = function (_Component) {
	    _inherits(RevisionMessageModal, _Component);
	
	    function RevisionMessageModal() {
	        _classCallCheck(this, RevisionMessageModal);
	
	        return _possibleConstructorReturn(this, (RevisionMessageModal.__proto__ || Object.getPrototypeOf(RevisionMessageModal)).apply(this, arguments));
	    }
	
	    _createClass(RevisionMessageModal, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                action = _props.action,
	                children = _props.children,
	                field = _props.field,
	                submitting = _props.submitting;
	
	
	            var onClose = function onClose() {
	                _this2.refs.modal.close();
	            };
	
	            var onAction = function onAction() {
	                onClose();
	                action();
	            };
	
	            return _react2.default.createElement(
	                _ModalWithTrigger2.default,
	                { ref: "modal", triggerElement: children },
	                _react2.default.createElement(
	                    _ModalContent2.default,
	                    {
	                        title: "Reason for changes",
	                        onClose: onClose
	                    },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _RevisionMessageModal2.default.modalBody },
	                        _react2.default.createElement("textarea", _extends({
	                            className: _RevisionMessageModal2.default.modalTextArea,
	                            placeholder: "Leave a note to explain what changes you made and why they were required"
	                        }, field))
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "Form-actions" },
	                        _react2.default.createElement(
	                            "button",
	                            { type: "button", className: "Button Button--primary", onClick: onAction, disabled: submitting || field.error },
	                            "Save changes"
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { type: "button", className: "Button ml1", onClick: onClose },
	                            "Cancel"
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RevisionMessageModal;
	}(_react.Component), _class.propTypes = {
	    action: _propTypes2.default.func.isRequired,
	    field: _propTypes2.default.object.isRequired,
	    submitting: _propTypes2.default.bool,
	    children: _propTypes2.default.any
	}, _temp);
	RevisionMessageModal.displayName = "RevisionMessageModal";
	exports.default = RevisionMessageModal;

/***/ }),
/* 1928 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"modalBody":"_2ffFt _38618 _1X7sA _3Dqep","modalTextArea":"_10mBH _2kZNz _17S31 _2hwsw _2z9kb"};

/***/ }),
/* 1929 */,
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _GuideEditSection = __webpack_require__(1931);
	
	var _GuideEditSection2 = _interopRequireDefault(_GuideEditSection);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var GuideEditSection = function GuideEditSection(_ref) {
	    var children = _ref.children,
	        isCollapsed = _ref.isCollapsed,
	        isDisabled = _ref.isDisabled,
	        showLink = _ref.showLink,
	        collapsedIcon = _ref.collapsedIcon,
	        collapsedTitle = _ref.collapsedTitle,
	        linkMessage = _ref.linkMessage,
	        link = _ref.link,
	        action = _ref.action,
	        expand = _ref.expand;
	    return isCollapsed ? _react2.default.createElement(
	        "div",
	        {
	            className: (0, _classnames2.default)('text-measure', _GuideEditSection2.default.guideEditSectionCollapsed, _defineProperty({
	                'cursor-pointer border-brand-hover': !isDisabled
	            }, _GuideEditSection2.default.guideEditSectionDisabled, isDisabled)),
	            onClick: !isDisabled && expand
	        },
	        _react2.default.createElement(_Icon2.default, { className: _GuideEditSection2.default.guideEditSectionCollapsedIcon, name: collapsedIcon, size: 24 }),
	        _react2.default.createElement(
	            "span",
	            { className: _GuideEditSection2.default.guideEditSectionCollapsedTitle },
	            collapsedTitle
	        ),
	        (showLink || isDisabled) && (link ? link.startsWith('http') ? _react2.default.createElement(
	            "a",
	            {
	                className: _GuideEditSection2.default.guideEditSectionCollapsedLink,
	                href: link,
	                target: "_blank"
	            },
	            linkMessage
	        ) : _react2.default.createElement(
	            _reactRouter.Link,
	            {
	                className: _GuideEditSection2.default.guideEditSectionCollapsedLink,
	                to: link
	            },
	            linkMessage
	        ) : action && _react2.default.createElement(
	            "a",
	            {
	                className: _GuideEditSection2.default.guideEditSectionCollapsedLink,
	                onClick: action
	            },
	            linkMessage
	        ))
	    ) : _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)('my4', _GuideEditSection2.default.guideEditSection) },
	        children
	    );
	};
	GuideEditSection.propTypes = {
	    isCollapsed: _propTypes2.default.bool.isRequired
	};
	
	exports.default = (0, _pure2.default)(GuideEditSection);

/***/ }),
/* 1931 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"guideEditSectionCollapsed":"_3ptc3 _38618 _2kZNz _3Dqep _37W4X _1GX2b _2hwsw _20SLo _3TD8R","guideEditSectionDisabled":"_2uiuf _1fEsB","guideEditSectionCollapsedIcon":"Ofb-4 raIhq","guideEditSectionCollapsedTitle":"_2Qa0O _2kZNz raIhq","guideEditSectionCollapsedLink":"_1K96C _20SLo qXm3b"};

/***/ }),
/* 1932 */,
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// FIXME: using pure seems to mess with redux form updates
	// import pure from "recompose/pure";
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _GuideDetailEditor = __webpack_require__(1934);
	
	var _GuideDetailEditor2 = _interopRequireDefault(_GuideDetailEditor);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DataSelector = __webpack_require__(1730);
	
	var _DataSelector2 = _interopRequireDefault(_DataSelector);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _utils = __webpack_require__(1920);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GuideDetailEditor = function GuideDetailEditor(_ref) {
	    var className = _ref.className,
	        type = _ref.type,
	        entities = _ref.entities,
	        _ref$metadata = _ref.metadata,
	        metadata = _ref$metadata === undefined ? {} : _ref$metadata,
	        _ref$selectedIds = _ref.selectedIds,
	        selectedIds = _ref$selectedIds === undefined ? [] : _ref$selectedIds,
	        _ref$selectedIdTypePa = _ref.selectedIdTypePairs,
	        selectedIdTypePairs = _ref$selectedIdTypePa === undefined ? [] : _ref$selectedIdTypePa,
	        formField = _ref.formField,
	        removeField = _ref.removeField,
	        editLabelClasses = _ref.editLabelClasses;
	    var databases = metadata.databases,
	        tables = metadata.tables,
	        segments = metadata.segments,
	        metrics = metadata.metrics,
	        fields = metadata.fields,
	        metricImportantFields = metadata.metricImportantFields;
	
	
	    var bgClass = _utils.typeToBgClass[type];
	    var entityId = formField.id.value;
	    var disabled = formField.id.value === null || formField.id.value === undefined;
	    var tableId = metrics && metrics[entityId] && metrics[entityId].table_id;
	    var tableFields = tables && tables[tableId] && tables[tableId].fields || [];
	    var fieldsByMetric = type === 'metric' ? tableFields.map(function (fieldId) {
	        return fields[fieldId];
	    }) : [];
	
	    var selectClasses = 'input h3 px2 py1';
	
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)('mb2 border-bottom pb4 text-measure', className) },
	        _react2.default.createElement(
	            "div",
	            { className: "relative mt2 flex align-center" },
	            _react2.default.createElement(
	                "div",
	                {
	                    style: {
	                        width: 40,
	                        height: 40,
	                        left: -60
	                    },
	                    className: (0, _classnames2.default)('absolute text-white flex align-center justify-center', bgClass)
	                },
	                _react2.default.createElement(_Icon2.default, { name: type === 'metric' ? 'ruler' : type })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "py2" },
	                entities ? _react2.default.createElement(_Select2.default, {
	                    value: entities[formField.id.value],
	                    options: Object.values(entities),
	                    disabledOptionIds: selectedIds,
	                    optionNameFn: function optionNameFn(option) {
	                        return option.display_name || option.name;
	                    },
	                    onChange: function onChange(entity) {
	                        //TODO: refactor into function
	                        formField.id.onChange(entity.id);
	                        formField.points_of_interest.onChange(entity.points_of_interest || '');
	                        formField.caveats.onChange(entity.caveats || '');
	                        if (type === 'metric') {
	                            formField.important_fields.onChange(metricImportantFields[entity.id] && metricImportantFields[entity.id].map(function (fieldId) {
	                                return fields[fieldId];
	                            }));
	                        }
	                    },
	                    placeholder: 'Select...'
	                }) : _react2.default.createElement(_DataSelector2.default, {
	                    className: (0, _classnames2.default)(selectClasses, 'inline-block', 'rounded', 'text-bold'),
	                    triggerIconSize: 12,
	                    includeTables: true,
	                    datasetQuery: {
	                        query: {
	                            source_table: formField.type.value === 'table' && Number.parseInt(formField.id.value)
	                        },
	                        database: formField.type.value === 'table' && tables[formField.id.value] && tables[formField.id.value].db_id || Number.parseInt(Object.keys(databases)[0]),
	                        segment: formField.type.value === 'segment' && Number.parseInt(formField.id.value)
	                    },
	                    databases: Object.values(databases).map(function (database) {
	                        return _extends({}, database, {
	                            tables: database.tables.map(function (tableId) {
	                                return tables[tableId];
	                            })
	                        });
	                    }),
	                    setDatabaseFn: function setDatabaseFn() {
	                        return null;
	                    },
	                    tables: Object.values(tables),
	                    disabledTableIds: selectedIdTypePairs.filter(function (idTypePair) {
	                        return idTypePair[1] === 'table';
	                    }).map(function (idTypePair) {
	                        return idTypePair[0];
	                    }),
	                    setSourceTableFn: function setSourceTableFn(tableId) {
	                        var table = tables[tableId];
	                        formField.id.onChange(table.id);
	                        formField.type.onChange('table');
	                        formField.points_of_interest.onChange(table.points_of_interest || '');
	                        formField.caveats.onChange(table.caveats || '');
	                    },
	                    segments: Object.values(segments),
	                    disabledSegmentIds: selectedIdTypePairs.filter(function (idTypePair) {
	                        return idTypePair[1] === 'segment';
	                    }).map(function (idTypePair) {
	                        return idTypePair[0];
	                    }),
	                    setSourceSegmentFn: function setSourceSegmentFn(segmentId) {
	                        var segment = segments[segmentId];
	                        formField.id.onChange(segment.id);
	                        formField.type.onChange('segment');
	                        formField.points_of_interest.onChange(segment.points_of_interest || '');
	                        formField.caveats.onChange(segment.caveats || '');
	                    }
	                })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "ml-auto cursor-pointer text-grey-2" },
	                _react2.default.createElement(
	                    _Tooltip2.default,
	                    { tooltip: "Remove item" },
	                    _react2.default.createElement(_Icon2.default, {
	                        name: "close",
	                        width: 16,
	                        height: 16,
	                        onClick: removeField
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "mt2 text-measure" },
	            _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)('mb2', { 'disabled': disabled }) },
	                _react2.default.createElement(
	                    EditLabel,
	                    null,
	                    type === 'dashboard' ? "Why is this dashboard the most important?" : "What is useful or interesting about this " + type + "?"
	                ),
	                _react2.default.createElement("textarea", _extends({
	                    className: _GuideDetailEditor2.default.guideDetailEditorTextarea,
	                    placeholder: "Write something helpful here"
	                }, formField.points_of_interest, {
	                    disabled: disabled
	                }))
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)('mb2', { 'disabled': disabled }) },
	                _react2.default.createElement(
	                    EditLabel,
	                    null,
	                    type === 'dashboard' ? "Is there anything users of this dashboard should be aware of?" : "Anything users should be aware of about this " + type + "?"
	                ),
	                _react2.default.createElement("textarea", _extends({
	                    className: _GuideDetailEditor2.default.guideDetailEditorTextarea,
	                    placeholder: "Write something helpful here"
	                }, formField.caveats, {
	                    disabled: disabled
	                }))
	            ),
	            type === 'metric' && _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)('mb2', { 'disabled': disabled }) },
	                _react2.default.createElement(
	                    EditLabel,
	                    { key: "metricFieldsLabel" },
	                    "Which 2-3 fields do you usually group this metric by?"
	                ),
	                _react2.default.createElement(_Select2.default, {
	                    options: fieldsByMetric,
	                    optionNameFn: function optionNameFn(option) {
	                        return option.display_name || option.name;
	                    },
	                    placeholder: "Select...",
	                    values: formField.important_fields.value || [],
	                    disabledOptionIds: formField.important_fields.value && formField.important_fields.value.length === 3 ? fieldsByMetric.filter(function (field) {
	                        return !formField.important_fields.value.includes(field);
	                    }).map(function (field) {
	                        return field.id;
	                    }) : [],
	                    onChange: function onChange(field) {
	                        var importantFields = formField.important_fields.value || [];
	                        return importantFields.includes(field) ? formField.important_fields.onChange(importantFields.filter(function (importantField) {
	                            return importantField !== field;
	                        })) : importantFields.length < 3 && formField.important_fields.onChange(importantFields.concat(field));
	                    },
	                    disabled: formField.id.value === null || formField.id.value === undefined
	                })
	            )
	        )
	    );
	};
	
	GuideDetailEditor.displayName = "GuideDetailEditor";
	var EditLabel = function EditLabel(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	        "h3",
	        { className: "mb1" },
	        children
	    );
	};
	
	EditLabel.displayName = "EditLabel";
	GuideDetailEditor.propTypes = {
	    className: _propTypes2.default.string,
	    type: _propTypes2.default.string.isRequired,
	    entities: _propTypes2.default.object,
	    metadata: _propTypes2.default.object,
	    selectedIds: _propTypes2.default.array,
	    selectedIdTypePairs: _propTypes2.default.array,
	    formField: _propTypes2.default.object.isRequired,
	    removeField: _propTypes2.default.func.isRequired
	};
	
	exports.default = GuideDetailEditor;

/***/ }),
/* 1934 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"guideDetailEditor":"oOYV9","guideDetailEditorTextarea":"_2K-XC _17S31 _2hwsw _2z9kb A5BYb"};

/***/ }),
/* 1935 */,
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _BaseSidebar = __webpack_require__(1937);
	
	var _BaseSidebar2 = _interopRequireDefault(_BaseSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _MetricList = __webpack_require__(1942);
	
	var _MetricList2 = _interopRequireDefault(_MetricList);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var MetricListContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(MetricListContainer, _Component);
	
	    function MetricListContainer() {
	        _classCallCheck(this, MetricListContainer);
	
	        return _possibleConstructorReturn(this, (MetricListContainer.__proto__ || Object.getPrototypeOf(MetricListContainer)).apply(this, arguments));
	    }
	
	    _createClass(MetricListContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchMetrics(this.props);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var isEditing = this.props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_BaseSidebar2.default, null)
	                },
	                _react2.default.createElement(_MetricList2.default, this.props)
	            );
	        }
	    }]);
	
	    return MetricListContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	MetricListContainer.displayName = 'MetricListContainer';
	exports.default = MetricListContainer;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Sidebar = __webpack_require__(1938);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _SidebarItem = __webpack_require__(1940);
	
	var _SidebarItem2 = _interopRequireDefault(_SidebarItem);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseSidebar = function BaseSidebar(_ref) {
	    var style = _ref.style,
	        className = _ref.className;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_Sidebar2.default.sidebar, className), style: style },
	        _react2.default.createElement(
	            "div",
	            { className: _Sidebar2.default.breadcrumbs },
	            _react2.default.createElement(_Breadcrumbs2.default, {
	                className: "py4",
	                crumbs: [["Data Reference"]],
	                inSidebar: true,
	                placeholder: "Data Reference"
	            })
	        ),
	        _react2.default.createElement(
	            "ol",
	            null,
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/guide",
	                href: "/reference/guide",
	                icon: "reference",
	                name: "Start here" }),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/metrics",
	                href: "/reference/metrics",
	                icon: "ruler",
	                name: "Metrics" }),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/segments",
	                href: "/reference/segments",
	                icon: "segment",
	                name: "Segments" }),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/databases",
	                href: "/reference/databases",
	                icon: "database",
	                name: "Databases and tables" })
	        )
	    );
	}; /* eslint "react/prop-types": "warn" */
	BaseSidebar.displayName = "BaseSidebar";
	
	
	BaseSidebar.propTypes = {
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object
	};
	
	exports.default = (0, _pure2.default)(BaseSidebar);

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sidebar-padding":"_2-ZZC","sidebar-margin":"L8K64","sidebar":"_1-jio _1s_jv","breadcrumbs":"_2YdM- _2-ZZC","item":"_1qQzv _38618 _3Dqep _1s_jv _2-ZZC _2rmlO _18Xrq","sectionTitle":"_143k8 _38618 _3Dqep _1s_jv _2-ZZC _2FnGH _3TD8R","icon":"saWAj _9DUFn","selected":"_1CO2D","divider":"_2A40N _1ocN4 GjCgU L8K64","name":"_1IN-G _1Wqf2 _3TD8R","noLabelsMessage":"_2zt9Q _18-EI rTQr- _2z9kb _14leg Pvqsl L8K64"};

/***/ }),
/* 1939 */,
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _Sidebar = __webpack_require__(1938);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _LabelIcon = __webpack_require__(1638);
	
	var _LabelIcon2 = _interopRequireDefault(_LabelIcon);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint "react/prop-types": "warn" */
	var SidebarItem = function SidebarItem(_ref) {
	    var name = _ref.name,
	        sidebar = _ref.sidebar,
	        icon = _ref.icon,
	        href = _ref.href;
	    return _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	            _reactRouter.Link,
	            { to: href, className: _Sidebar2.default.item, activeClassName: _Sidebar2.default.selected },
	            _react2.default.createElement(_LabelIcon2.default, { className: _Sidebar2.default.icon, icon: icon }),
	            _react2.default.createElement(
	                "span",
	                { className: _Sidebar2.default.name },
	                sidebar || name
	            )
	        )
	    );
	};
	
	SidebarItem.displayName = "SidebarItem";
	SidebarItem.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    sidebar: _propTypes2.default.string,
	    icon: _propTypes2.default.string.isRequired,
	    href: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _pure2.default)(SidebarItem);

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SidebarLayout = function SidebarLayout(_ref) {
	    var className = _ref.className,
	        style = _ref.style,
	        sidebar = _ref.sidebar,
	        children = _ref.children;
	    return _react2.default.createElement(
	        "div",
	        { className: className, style: _extends({}, style, { display: "flex", flexDirection: "row" }) },
	        _react2.default.cloneElement(sidebar, { style: { flexShrink: 0 },
	            className: 'scroll-y scroll-show scroll--light scroll-show--hover'
	        }, sidebar.props.children),
	        children && _react2.default.cloneElement(_react2.default.Children.only(children), { style: { flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', height: '100%' } }, _react2.default.Children.only(children).props.children)
	    );
	};
	
	SidebarLayout.displayName = "SidebarLayout";
	SidebarLayout.propTypes = {
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    sidebar: _propTypes2.default.element.isRequired,
	    children: _propTypes2.default.element.isRequired
	};
	
	exports.default = SidebarLayout;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _table = __webpack_require__(871);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _List3 = __webpack_require__(1945);
	
	var _List4 = _interopRequireDefault(_List3);
	
	var _ListItem = __webpack_require__(1946);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _AdminAwareEmptyState = __webpack_require__(1947);
	
	var _AdminAwareEmptyState2 = _interopRequireDefault(_AdminAwareEmptyState);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _ReferenceHeader = __webpack_require__(1948);
	
	var _ReferenceHeader2 = _interopRequireDefault(_ReferenceHeader);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyStateData = {
	    title: "Metrics are the official numbers that your team cares about",
	    adminMessage: "Defining common metrics for your team makes it even easier to ask questions",
	    message: "Metrics will appear here once your admins have created some",
	    image: "app/assets/img/metrics-list",
	    adminAction: "Learn how to create metrics",
	    adminLink: "http://www.metabase.com/docs/latest/administration-guide/06-segments-and-metrics.html"
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        entities: (0, _selectors.getMetrics)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        loadingError: (0, _selectors.getError)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions);
	
	var MetricList = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(MetricList, _Component);
	
	    function MetricList() {
	        _classCallCheck(this, MetricList);
	
	        return _possibleConstructorReturn(this, (MetricList.__proto__ || Object.getPrototypeOf(MetricList)).apply(this, arguments));
	    }
	
	    _createClass(MetricList, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                entities = _props.entities,
	                style = _props.style,
	                loadingError = _props.loadingError,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                "div",
	                { style: style, className: "full" },
	                _react2.default.createElement(_ReferenceHeader2.default, {
	                    name: "Metrics"
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return Object.keys(entities).length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List4.default,
	                                null,
	                                Object.values(entities).filter(_table.isQueryable).map(function (entity, index) {
	                                    return entity && entity.id && entity.name && _react2.default.createElement(
	                                        "li",
	                                        { className: "relative", key: entity.id },
	                                        _react2.default.createElement(_ListItem2.default, {
	                                            id: entity.id,
	                                            index: index,
	                                            name: entity.display_name || entity.name,
	                                            description: entity.description,
	                                            url: "/reference/metrics/" + entity.id,
	                                            icon: "ruler"
	                                        })
	                                    );
	                                })
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_AdminAwareEmptyState2.default, emptyStateData)
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return MetricList;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entities: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object
	}, _temp)) || _class);
	MetricList.displayName = "MetricList";
	exports.default = MetricList;

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"OrJnq OPZ6L xdpBZ","list-wrapper":"_22-Fp OPZ6L xdpBZ","header":"_2Q0dA _38618 _1BJhh _37W4X _2AJrG","headerBody":"_3PuT1 _38618 _2kZNz _2UDhs GjCgU","headerLink":"_3jMbI _20SLo _1Wqf2 _9DUFn","headerButton":"_1Xizi _38618 BcFLh _3Dqep","empty":"_35R0S _1b0Gt _38618 _1X7sA","item":"_3TXsO _38618 _3Dqep _18-EI","itemBody":"_1xlpf _2Hk-A _2kZNz","itemTitle":"_18GKE _3TD8R CO6xt","itemName":"DgBui _3K4no CO6xt","itemSubtitle":"S4xyd","itemSubtitleLight":"_3eIll","itemSubtitleBold":"_2XUgV","icons":"_3A7d2 _38618 _1BJhh _3Dqep","leftIcons":"lVe5d _9DUFn _38618 _3-Ogs _2VkQ1 _3A7d2 _38618 _1BJhh _3Dqep","rightIcons":"_36T_3 _3A7d2 _38618 _1BJhh _3Dqep","extraIcons":"_3dGxg _3A7d2 _38618 _1BJhh _3Dqep _1MD7G _3fyc4 _2Cz_3 _3A7d2 _38618 _1BJhh _3Dqep","icon":"_3wr12 _18-EI","itemCheckbox":"_3hW74 _3wr12 _18-EI","selected":"_1yGSm","itemIcon":"_2ied7 _3wr12 _18-EI _18-EI","chartIcon":"_1UrM0 _3wr12 _18-EI _18-EI","tagIcon":"_3xPxp _3wr12 _18-EI _1ZhAK","favoriteIcon":"_3Nsel _3wr12 _18-EI _1ZhAK","archiveIcon":"bPQA9 _3wr12 _18-EI _1ZhAK","open":"_3DoUO","favorite":"_1iENE","archived":"_3e35b","trigger":"_1oUEe"};

/***/ }),
/* 1944 */,
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint "react/prop-types": "warn" */
	var List = function List(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        "ul",
	        { className: _List2.default.list },
	        children
	    );
	};
	
	List.displayName = "List";
	List.propTypes = {
	    children: _propTypes2.default.any.isRequired
	};
	
	exports.default = (0, _pure2.default)(List);

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Ellipsified = __webpack_require__(1277);
	
	var _Ellipsified2 = _interopRequireDefault(_Ellipsified);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//TODO: extend this to support functionality required for questions
	/* eslint "react/prop-types": "warn" */
	var ListItem = function ListItem(_ref) {
	    var index = _ref.index,
	        name = _ref.name,
	        description = _ref.description,
	        placeholder = _ref.placeholder,
	        url = _ref.url,
	        icon = _ref.icon;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_List2.default.item) },
	        _react2.default.createElement(
	            "div",
	            { className: _List2.default.leftIcons },
	            icon && _react2.default.createElement(_Icon2.default, { className: _List2.default.chartIcon, name: icon, size: 20 })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _List2.default.itemBody, style: index === 0 ? { borderTop: 'none' } : {} },
	            _react2.default.createElement(
	                "div",
	                { className: _List2.default.itemTitle },
	                _react2.default.createElement(
	                    _Ellipsified2.default,
	                    { className: _List2.default.itemName, tooltip: name, tooltipMaxWidth: "100%" },
	                    url ? _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: url },
	                        name
	                    ) : { name: name }
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(description ? _List2.default.itemSubtitle : _List2.default.itemSubtitleLight, { "mt1": true }) },
	                description || placeholder || 'No description yet'
	            )
	        )
	    );
	};
	
	ListItem.displayName = "ListItem";
	ListItem.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    index: _propTypes2.default.number.isRequired,
	    url: _propTypes2.default.string,
	    description: _propTypes2.default.string,
	    placeholder: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    isEditing: _propTypes2.default.bool,
	    field: _propTypes2.default.object
	};
	
	exports.default = (0, _pure2.default)(ListItem);

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * AdminAwareEmptyState is a component that can
	 *  1) Produce a custom message for admins in empty results
	 */
	
	var AdminAwareEmptyState = function AdminAwareEmptyState(_ref) {
	    var user = _ref.user,
	        title = _ref.title,
	        message = _ref.message,
	        adminMessage = _ref.adminMessage,
	        icon = _ref.icon,
	        image = _ref.image,
	        imageHeight = _ref.imageHeight,
	        imageClassName = _ref.imageClassName,
	        action = _ref.action,
	        adminAction = _ref.adminAction,
	        link = _ref.link,
	        adminLink = _ref.adminLink,
	        onActionClick = _ref.onActionClick,
	        _ref$smallDescription = _ref.smallDescription,
	        smallDescription = _ref$smallDescription === undefined ? false : _ref$smallDescription;
	    return _react2.default.createElement(_EmptyState2.default, {
	        title: title,
	        message: user && user.is_superuser ? adminMessage || message : message,
	        icon: icon,
	        image: image,
	        action: user && user.is_superuser ? adminAction || action : action,
	        link: user && user.is_superuser ? adminLink || link : link,
	        imageHeight: imageHeight,
	        imageClassName: imageClassName,
	        onActionClick: onActionClick,
	        smallDescription: smallDescription
	    });
	};
	
	AdminAwareEmptyState.displayName = "AdminAwareEmptyState";
	exports.default = AdminAwareEmptyState;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _ReferenceHeader = __webpack_require__(1949);
	
	var _ReferenceHeader2 = _interopRequireDefault(_ReferenceHeader);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _EditButton = __webpack_require__(1917);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _IconBorder = __webpack_require__(1289);
	
	var _IconBorder2 = _interopRequireDefault(_IconBorder);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Ellipsified = __webpack_require__(1277);
	
	var _Ellipsified2 = _interopRequireDefault(_Ellipsified);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReferenceHeader = function ReferenceHeader(_ref) {
	    var name = _ref.name,
	        type = _ref.type,
	        headerIcon = _ref.headerIcon,
	        headerBody = _ref.headerBody,
	        headerLink = _ref.headerLink;
	    return _react2.default.createElement(
	        "div",
	        { className: "wrapper wrapper--trim" },
	        _react2.default.createElement(
	            "div",
	            { className: (0, _classnames2.default)("relative", _List2.default.header) },
	            _react2.default.createElement(
	                "div",
	                { className: _List2.default.leftIcons },
	                headerIcon && _react2.default.createElement(
	                    _IconBorder2.default,
	                    {
	                        borderWidth: "0",
	                        style: { backgroundColor: "#E9F4F8" }
	                    },
	                    _react2.default.createElement(_Icon2.default, {
	                        className: "text-brand",
	                        name: headerIcon,
	                        width: 24,
	                        height: 24
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                {
	                    className: _ReferenceHeader2.default.headerBody
	                },
	                _react2.default.createElement(
	                    _Ellipsified2.default,
	                    {
	                        key: "1",
	                        className: !headerLink && "flex-full",
	                        tooltipMaxWidth: "100%"
	                    },
	                    name
	                ),
	                headerLink && _react2.default.createElement(
	                    "div",
	                    { key: "2", className: (0, _classnames2.default)("flex-full", _ReferenceHeader2.default.headerButton) },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        {
	                            to: headerLink,
	                            className: (0, _classnames2.default)("Button", "Button--borderless", "ml3", _EditButton2.default.editButton),
	                            "data-metabase-event": "Data Reference;Entity -> QB click;" + type
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex align-center relative" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "mr1 flex-no-shrink" },
	                                "See this ",
	                                type
	                            ),
	                            _react2.default.createElement(_Icon2.default, { name: "chevronright", size: 16 })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	ReferenceHeader.displayName = "ReferenceHeader";
	ReferenceHeader.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    type: _propTypes2.default.string,
	    headerIcon: _propTypes2.default.string,
	    headerBody: _propTypes2.default.string,
	    headerLink: _propTypes2.default.string
	
	};
	
	exports.default = (0, _pure2.default)(ReferenceHeader);

/***/ }),
/* 1949 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerBody":"_3hqM3 _38618 _2kZNz GjCgU _17S31 _3TD8R","headerTextInput":"_3RsBq _2hwsw _1FLRv _4GzCU _342no","subheader":"_2iZsI _38YTw _2AJrG","subheaderBody":"jgTY3 _17S31","subheaderLink":"_1usD6","headerSchema":"QplMQ _2SVp9 _1MD7G"};

/***/ }),
/* 1950 */,
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _MetricSidebar = __webpack_require__(1952);
	
	var _MetricSidebar2 = _interopRequireDefault(_MetricSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _MetricDetail = __webpack_require__(1953);
	
	var _MetricDetail2 = _interopRequireDefault(_MetricDetail);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        user: (0, _selectors.getUser)(state, props),
	        metric: (0, _selectors.getMetric)(state, props),
	        metricId: (0, _selectors.getMetricId)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var MetricDetailContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(MetricDetailContainer, _Component);
	
	    function MetricDetailContainer() {
	        _classCallCheck(this, MetricDetailContainer);
	
	        return _possibleConstructorReturn(this, (MetricDetailContainer.__proto__ || Object.getPrototypeOf(MetricDetailContainer)).apply(this, arguments));
	    }
	
	    _createClass(MetricDetailContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchMetricDetail(this.props, this.props.metricId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                isEditing = _props.isEditing,
	                user = _props.user,
	                metric = _props.metric;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_MetricSidebar2.default, { metric: metric, user: user })
	                },
	                _react2.default.createElement(_MetricDetail2.default, this.props)
	            );
	        }
	    }]);
	
	    return MetricDetailContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    metric: _propTypes2.default.object.isRequired,
	    metricId: _propTypes2.default.number.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	MetricDetailContainer.displayName = 'MetricDetailContainer';
	exports.default = MetricDetailContainer;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Sidebar = __webpack_require__(1938);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _SidebarItem = __webpack_require__(1940);
	
	var _SidebarItem2 = _interopRequireDefault(_SidebarItem);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MetricSidebar = function MetricSidebar(_ref) {
	    var metric = _ref.metric,
	        user = _ref.user,
	        style = _ref.style,
	        className = _ref.className;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_Sidebar2.default.sidebar, className), style: style },
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: _Sidebar2.default.breadcrumbs },
	                _react2.default.createElement(_Breadcrumbs2.default, {
	                    className: "py4",
	                    crumbs: [["Metrics", "/reference/metrics"], [metric.name]],
	                    inSidebar: true,
	                    placeholder: "Data Reference"
	                })
	            ),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/metrics/" + metric.id,
	                href: "/reference/metrics/" + metric.id,
	                icon: "document",
	                name: "Details" }),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/metrics/" + metric.id + "/questions",
	                href: "/reference/metrics/" + metric.id + "/questions",
	                icon: "all",
	                name: "Questions about " + metric.name }),
	            user && user.is_superuser && _react2.default.createElement(_SidebarItem2.default, { key: "/reference/metrics/" + metric.id + "/revisions",
	                href: "/reference/metrics/" + metric.id + "/revisions",
	                icon: "history",
	                name: "Revision history for " + metric.name })
	        )
	    );
	}; /* eslint "react/prop-types": "warn" */
	MetricSidebar.displayName = "MetricSidebar";
	
	
	MetricSidebar.propTypes = {
	    metric: _propTypes2.default.object,
	    user: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object
	};
	
	exports.default = (0, _pure2.default)(MetricSidebar);

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reduxForm = __webpack_require__(589);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _List = __webpack_require__(1945);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _EditHeader = __webpack_require__(1924);
	
	var _EditHeader2 = _interopRequireDefault(_EditHeader);
	
	var _EditableReferenceHeader = __webpack_require__(1954);
	
	var _EditableReferenceHeader2 = _interopRequireDefault(_EditableReferenceHeader);
	
	var _Detail = __webpack_require__(1955);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _FieldsToGroupBy = __webpack_require__(1958);
	
	var _FieldsToGroupBy2 = _interopRequireDefault(_FieldsToGroupBy);
	
	var _Formula = __webpack_require__(1964);
	
	var _Formula2 = _interopRequireDefault(_Formula);
	
	var _MetricImportantFieldsDetail = __webpack_require__(1967);
	
	var _MetricImportantFieldsDetail2 = _interopRequireDefault(_MetricImportantFieldsDetail);
	
	var _utils = __webpack_require__(1920);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var entity = (0, _selectors.getMetric)(state, props) || {};
	    var guide = (0, _selectors.getGuide)(state, props);
	    var fields = (0, _selectors.getFields)(state, props);
	
	    var initialValues = {
	        important_fields: guide && guide.metric_important_fields && guide.metric_important_fields[entity.id] && guide.metric_important_fields[entity.id].map(function (fieldId) {
	            return fields[fieldId];
	        }) || []
	    };
	
	    return {
	        entity: entity,
	        table: (0, _selectors.getTable)(state, props),
	        metadataFields: fields,
	        guide: guide,
	        loading: (0, _selectors.getLoading)(state, props),
	        // naming this 'error' will conflict with redux form
	        loadingError: (0, _selectors.getError)(state, props),
	        user: (0, _selectors.getUser)(state, props),
	        foreignKeys: (0, _selectors.getForeignKeys)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        isFormulaExpanded: (0, _selectors.getIsFormulaExpanded)(state, props),
	        initialValues: initialValues
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions, {
	    onChangeLocation: _reactRouterRedux.push
	});
	
	var validate = function validate(values, props) {
	    return !values.revision_message ? { revision_message: "Please enter a revision message" } : {};
	};
	
	var MetricDetail = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reduxForm.reduxForm)({
	    form: 'details',
	    fields: ['name', 'display_name', 'description', 'revision_message', 'points_of_interest', 'caveats', 'how_is_this_calculated', 'important_fields'],
	    validate: validate
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    _inherits(MetricDetail, _Component);
	
	    function MetricDetail() {
	        _classCallCheck(this, MetricDetail);
	
	        return _possibleConstructorReturn(this, (MetricDetail.__proto__ || Object.getPrototypeOf(MetricDetail)).apply(this, arguments));
	    }
	
	    _createClass(MetricDetail, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$fields = _props.fields,
	                name = _props$fields.name,
	                display_name = _props$fields.display_name,
	                description = _props$fields.description,
	                revision_message = _props$fields.revision_message,
	                points_of_interest = _props$fields.points_of_interest,
	                caveats = _props$fields.caveats,
	                how_is_this_calculated = _props$fields.how_is_this_calculated,
	                important_fields = _props$fields.important_fields,
	                style = _props.style,
	                entity = _props.entity,
	                table = _props.table,
	                metadataFields = _props.metadataFields,
	                guide = _props.guide,
	                loadingError = _props.loadingError,
	                loading = _props.loading,
	                user = _props.user,
	                isEditing = _props.isEditing,
	                startEditing = _props.startEditing,
	                endEditing = _props.endEditing,
	                expandFormula = _props.expandFormula,
	                collapseFormula = _props.collapseFormula,
	                isFormulaExpanded = _props.isFormulaExpanded,
	                handleSubmit = _props.handleSubmit,
	                resetForm = _props.resetForm,
	                submitting = _props.submitting,
	                onChangeLocation = _props.onChangeLocation;
	
	
	            var onSubmit = handleSubmit(function () {
	                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(fields) {
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    _context.next = 2;
	                                    return actions.rUpdateMetricDetail(_this2.props.entity, _this2.props.guide, fields, _this2.props);
	
	                                case 2:
	                                    return _context.abrupt("return", _context.sent);
	
	                                case 3:
	                                case "end":
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                    return _ref.apply(this, arguments);
	                };
	            }());
	
	            return _react2.default.createElement(
	                "form",
	                { style: style, className: "full",
	                    onSubmit: onSubmit
	                },
	                isEditing && _react2.default.createElement(_EditHeader2.default, {
	                    hasRevisionHistory: true,
	                    onSubmit: onSubmit,
	                    endEditing: endEditing,
	                    reinitializeForm: resetForm,
	                    submitting: submitting,
	                    revisionMessageFormField: revision_message
	                }),
	                _react2.default.createElement(_EditableReferenceHeader2.default, {
	                    entity: entity,
	                    table: table,
	                    type: "metric",
	                    headerIcon: "ruler",
	                    headerLink: (0, _utils.getQuestionUrl)({ dbId: table && table.db_id, tableId: entity.table_id, metricId: entity.id }),
	                    name: "Details",
	                    user: user,
	                    isEditing: isEditing,
	                    hasSingleSchema: false,
	                    hasDisplayName: false,
	                    startEditing: startEditing,
	                    displayNameFormField: display_name,
	                    nameFormField: name
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List2.default,
	                                null,
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "description",
	                                        name: "Description",
	                                        description: entity.description,
	                                        placeholder: "No description yet",
	                                        isEditing: isEditing,
	                                        field: description
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "points_of_interest",
	                                        name: "Why this Metric is interesting",
	                                        description: entity.points_of_interest,
	                                        placeholder: "Nothing interesting yet",
	                                        isEditing: isEditing,
	                                        field: points_of_interest
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "caveats",
	                                        name: "Things to be aware of about this Metric",
	                                        description: entity.caveats,
	                                        placeholder: "Nothing to be aware of yet",
	                                        isEditing: isEditing,
	                                        field: caveats
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "how_is_this_calculated",
	                                        name: "How this Metric is calculated",
	                                        description: entity.how_is_this_calculated,
	                                        placeholder: "Nothing on how it's calculated yet",
	                                        isEditing: isEditing,
	                                        field: how_is_this_calculated
	                                    })
	                                ),
	                                table && !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Formula2.default, {
	                                        type: "metric",
	                                        entity: entity,
	                                        isExpanded: isFormulaExpanded,
	                                        expandFormula: expandFormula,
	                                        collapseFormula: collapseFormula
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_MetricImportantFieldsDetail2.default, {
	                                        fields: guide && guide.metric_important_fields[entity.id] && Object.values(guide.metric_important_fields[entity.id]).map(function (fieldId) {
	                                            return metadataFields[fieldId];
	                                        }).reduce(function (map, field) {
	                                            return _extends({}, map, _defineProperty({}, field.id, field));
	                                        }, {}),
	                                        table: table,
	                                        allFields: metadataFields,
	                                        metric: entity,
	                                        onChangeLocation: onChangeLocation,
	                                        isEditing: isEditing,
	                                        formField: important_fields
	                                    })
	                                ),
	                                !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_FieldsToGroupBy2.default, {
	                                        fields: table.fields.filter(function (fieldId) {
	                                            return !guide || !guide.metric_important_fields[entity.id] || !guide.metric_important_fields[entity.id].includes(fieldId);
	                                        }).map(function (fieldId) {
	                                            return metadataFields[fieldId];
	                                        }).reduce(function (map, field) {
	                                            return _extends({}, map, _defineProperty({}, field.id, field));
	                                        }, {}),
	                                        databaseId: table && table.db_id,
	                                        metric: entity,
	                                        title: guide && guide.metric_important_fields[entity.id] ? "Other fields you can group this metric by" : "Fields you can group this metric by",
	                                        onChangeLocation: onChangeLocation
	                                    })
	                                )
	                            )
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return MetricDetail;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entity: _propTypes2.default.object.isRequired,
	    table: _propTypes2.default.object,
	    metadataFields: _propTypes2.default.object,
	    guide: _propTypes2.default.object,
	    user: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func.isRequired,
	    endEditing: _propTypes2.default.func.isRequired,
	    startLoading: _propTypes2.default.func.isRequired,
	    endLoading: _propTypes2.default.func.isRequired,
	    expandFormula: _propTypes2.default.func.isRequired,
	    collapseFormula: _propTypes2.default.func.isRequired,
	    setError: _propTypes2.default.func.isRequired,
	    updateField: _propTypes2.default.func.isRequired,
	    handleSubmit: _propTypes2.default.func.isRequired,
	    resetForm: _propTypes2.default.func.isRequired,
	    fields: _propTypes2.default.object.isRequired,
	    isFormulaExpanded: _propTypes2.default.bool,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool,
	    onChangeLocation: _propTypes2.default.func.isRequired
	}, _temp)) || _class) || _class);
	MetricDetail.displayName = "MetricDetail";
	exports.default = MetricDetail;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _ReferenceHeader = __webpack_require__(1949);
	
	var _ReferenceHeader2 = _interopRequireDefault(_ReferenceHeader);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _EditButton = __webpack_require__(1917);
	
	var _EditButton2 = _interopRequireDefault(_EditButton);
	
	var _IconBorder = __webpack_require__(1289);
	
	var _IconBorder2 = _interopRequireDefault(_IconBorder);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Ellipsified = __webpack_require__(1277);
	
	var _Ellipsified2 = _interopRequireDefault(_Ellipsified);
	
	var _EditButton3 = __webpack_require__(1916);
	
	var _EditButton4 = _interopRequireDefault(_EditButton3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditableReferenceHeader = function EditableReferenceHeader(_ref) {
	    var _ref$entity = _ref.entity,
	        entity = _ref$entity === undefined ? {} : _ref$entity,
	        table = _ref.table,
	        type = _ref.type,
	        headerIcon = _ref.headerIcon,
	        headerLink = _ref.headerLink,
	        name = _ref.name,
	        user = _ref.user,
	        isEditing = _ref.isEditing,
	        hasSingleSchema = _ref.hasSingleSchema,
	        hasDisplayName = _ref.hasDisplayName,
	        startEditing = _ref.startEditing,
	        displayNameFormField = _ref.displayNameFormField,
	        nameFormField = _ref.nameFormField;
	    return _react2.default.createElement(
	        "div",
	        { className: "wrapper wrapper--trim" },
	        _react2.default.createElement(
	            "div",
	            { className: (0, _classnames2.default)("relative", _List2.default.header), style: type === 'segment' ? { marginBottom: 0 } : {} },
	            _react2.default.createElement(
	                "div",
	                { className: _List2.default.leftIcons },
	                headerIcon && _react2.default.createElement(
	                    _IconBorder2.default,
	                    {
	                        borderWidth: "0",
	                        style: { backgroundColor: "#E9F4F8" }
	                    },
	                    _react2.default.createElement(_Icon2.default, {
	                        className: "text-brand",
	                        name: headerIcon,
	                        width: 24,
	                        height: 24
	                    })
	                )
	            ),
	            type === 'table' && !hasSingleSchema && !isEditing && _react2.default.createElement(
	                "div",
	                { className: _ReferenceHeader2.default.headerSchema },
	                entity.schema
	            ),
	            _react2.default.createElement(
	                "div",
	                {
	                    className: _ReferenceHeader2.default.headerBody,
	                    style: isEditing && name === 'Details' ? { alignItems: "flex-start" } : {}
	                },
	                isEditing && name === 'Details' ? _react2.default.createElement(_Input2.default, {
	                    className: _ReferenceHeader2.default.headerTextInput,
	                    type: "text",
	                    placeholder: entity.name,
	                    onChange: hasDisplayName ? displayNameFormField.onChange : nameFormField.onChange,
	                    defaultValue: hasDisplayName ? entity.display_name : entity.name
	
	                }) : [_react2.default.createElement(
	                    _Ellipsified2.default,
	                    {
	                        key: "1",
	                        className: !headerLink && "flex-full",
	                        tooltipMaxWidth: "100%"
	                    },
	                    name === 'Details' ? hasDisplayName ? entity.display_name || entity.name : entity.name : name
	                ), headerLink && _react2.default.createElement(
	                    "div",
	                    { key: "2", className: (0, _classnames2.default)("flex-full", _ReferenceHeader2.default.headerButton) },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        {
	                            to: headerLink,
	                            className: (0, _classnames2.default)("Button", "Button--borderless", "ml3", _EditButton2.default.editButton),
	                            "data-metabase-event": "Data Reference;Entity -> QB click;" + type
	                        },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "flex align-center relative" },
	                            _react2.default.createElement(
	                                "span",
	                                { className: "mr1 flex-no-shrink" },
	                                "See this ",
	                                type
	                            ),
	                            _react2.default.createElement(_Icon2.default, { name: "chevronright", size: 16 })
	                        )
	                    )
	                )],
	                user && user.is_superuser && !isEditing && _react2.default.createElement(_EditButton4.default, { className: "ml1", startEditing: startEditing })
	            )
	        ),
	        type === 'segment' && table && _react2.default.createElement(
	            "div",
	            { className: _ReferenceHeader2.default.subheader },
	            _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(_ReferenceHeader2.default.subheaderBody) },
	                "A subset of ",
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    {
	                        className: _ReferenceHeader2.default.subheaderLink,
	                        to: "/reference/databases/" + table.db_id + "/tables/" + table.id
	                    },
	                    table.display_name
	                )
	            )
	        )
	    );
	};
	EditableReferenceHeader.displayName = "EditableReferenceHeader";
	EditableReferenceHeader.propTypes = {
	    entity: _propTypes2.default.object,
	    table: _propTypes2.default.object,
	    type: _propTypes2.default.string,
	    headerIcon: _propTypes2.default.string,
	    headerLink: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    user: _propTypes2.default.object,
	    isEditing: _propTypes2.default.bool,
	    hasSingleSchema: _propTypes2.default.bool,
	    hasDisplayName: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func,
	    displayNameFormField: _propTypes2.default.object,
	    nameFormField: _propTypes2.default.object
	};
	
	exports.default = (0, _pure2.default)(EditableReferenceHeader);

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _Detail = __webpack_require__(1956);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint "react/prop-types": "warn" */
	var Detail = function Detail(_ref) {
	    var name = _ref.name,
	        description = _ref.description,
	        placeholder = _ref.placeholder,
	        subtitleClass = _ref.subtitleClass,
	        url = _ref.url,
	        icon = _ref.icon,
	        isEditing = _ref.isEditing,
	        field = _ref.field;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_Detail2.default.detail) },
	        _react2.default.createElement(
	            "div",
	            { className: _Detail2.default.detailBody },
	            _react2.default.createElement(
	                "div",
	                { className: _Detail2.default.detailTitle },
	                url ? _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: url, className: _Detail2.default.detailName },
	                    name
	                ) : _react2.default.createElement(
	                    "span",
	                    { className: _Detail2.default.detailName },
	                    name
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(description ? _Detail2.default.detailSubtitle : _Detail2.default.detailSubtitleLight, { "mt1": true }) },
	                isEditing ? _react2.default.createElement("textarea", {
	                    className: _Detail2.default.detailTextarea,
	                    placeholder: placeholder,
	                    onChange: field.onChange
	                    //FIXME: use initialValues from redux forms instead of default value
	                    // to allow for reinitializing on cancel (see GettingStartedGuide.jsx)
	                    , defaultValue: description
	                }) : _react2.default.createElement(
	                    "span",
	                    { className: subtitleClass },
	                    description || placeholder || 'No description yet'
	                ),
	                isEditing && field.error && field.touched && _react2.default.createElement(
	                    "span",
	                    { className: "text-error" },
	                    field.error
	                )
	            )
	        )
	    );
	};
	
	Detail.displayName = "Detail";
	Detail.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    url: _propTypes2.default.string,
	    description: _propTypes2.default.string,
	    placeholder: _propTypes2.default.string,
	    subtitleClass: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    isEditing: _propTypes2.default.bool,
	    field: _propTypes2.default.object
	};
	
	exports.default = (0, _pure2.default)(Detail);

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"detail":"mZTuB _38618 _3Dqep _18-EI","detailBody":"_1GT7O _2kZNz","detailTitle":"cDEmX _3TD8R CO6xt","detailSubtitle":"_3XQ7b _17S31 _17V2F Tgxr2","detailSubtitleLight":"_18EFR _17V2F Tgxr2","detailTextarea":"_2ttuh _17S31 _2hwsw _2z9kb"};

/***/ }),
/* 1957 */,
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(467);
	
	var _UsefulQuestions = __webpack_require__(1959);
	
	var _UsefulQuestions2 = _interopRequireDefault(_UsefulQuestions);
	
	var _Detail = __webpack_require__(1956);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _utils = __webpack_require__(1920);
	
	var _FieldToGroupBy = __webpack_require__(1961);
	
	var _FieldToGroupBy2 = _interopRequireDefault(_FieldToGroupBy);
	
	var _metadata = __webpack_require__(1110);
	
	var _metadata2 = __webpack_require__(1073);
	
	var _Metadata = __webpack_require__(941);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = {
	    fetchTableMetadata: _metadata.fetchTableMetadata
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        metadata: (0, _metadata2.getMetadata)(state, props)
	    };
	};
	
	var FieldsToGroupBy = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(FieldsToGroupBy, _Component);
	
	    function FieldsToGroupBy() {
	        _classCallCheck(this, FieldsToGroupBy);
	
	        return _possibleConstructorReturn(this, (FieldsToGroupBy.__proto__ || Object.getPrototypeOf(FieldsToGroupBy)).apply(this, arguments));
	    }
	
	    _createClass(FieldsToGroupBy, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                fields = _props.fields,
	                databaseId = _props.databaseId,
	                metric = _props.metric,
	                title = _props.title,
	                onChangeLocation = _props.onChangeLocation,
	                metadata = _props.metadata;
	
	
	            return _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(_Detail2.default.detail) },
	                _react2.default.createElement(
	                    "div",
	                    { className: _Detail2.default.detailBody },
	                    _react2.default.createElement(
	                        "div",
	                        { className: _Detail2.default.detailTitle },
	                        _react2.default.createElement(
	                            "span",
	                            { className: _Detail2.default.detailName },
	                            title
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: _UsefulQuestions2.default.usefulQuestions },
	                        fields && Object.values(fields).map(function (field, index, fields) {
	                            return _react2.default.createElement(_FieldToGroupBy2.default, {
	                                key: field.id,
	                                className: (0, _classnames2.default)("border-bottom", "pt1", "pb1"),
	                                iconClass: _List2.default.icon,
	                                field: field,
	                                metric: metric,
	                                onClick: function onClick() {
	                                    return onChangeLocation((0, _utils.getQuestionUrl)({
	                                        dbId: databaseId,
	                                        tableId: field.table_id,
	                                        fieldId: field.id,
	                                        metricId: metric.id,
	                                        metadata: metadata
	                                    }));
	                                },
	                                secondaryOnClick: function secondaryOnClick(event) {
	                                    event.stopPropagation();
	                                    onChangeLocation("/reference/databases/" + databaseId + "/tables/" + field.table_id + "/fields/" + field.id);
	                                }
	                            });
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return FieldsToGroupBy;
	}(_react.Component)) || _class);
	FieldsToGroupBy.displayName = "FieldsToGroupBy";
	exports.default = FieldsToGroupBy;

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"usefulQuestions":"POIhF _20SLo _38YTw"};

/***/ }),
/* 1960 */,
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _FieldToGroupBy = __webpack_require__(1962);
	
	var _FieldToGroupBy2 = _interopRequireDefault(_FieldToGroupBy);
	
	var _QueryButton = __webpack_require__(1767);
	
	var _QueryButton2 = _interopRequireDefault(_QueryButton);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldToGroupBy = function FieldToGroupBy(_ref) {
	    var className = _ref.className,
	        metric = _ref.metric,
	        field = _ref.field,
	        icon = _ref.icon,
	        iconClass = _ref.iconClass,
	        onClick = _ref.onClick,
	        secondaryOnClick = _ref.secondaryOnClick;
	    return _react2.default.createElement(
	        "div",
	        { className: className },
	        _react2.default.createElement(
	            "a",
	            { className: _QueryButton2.default.queryButton, onClick: onClick },
	            _react2.default.createElement(
	                "span",
	                { className: _FieldToGroupBy2.default.fieldToGroupByText },
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    metric.name + " by "
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: "ml1 text-brand" },
	                    field.display_name
	                )
	            ),
	            _react2.default.createElement(_Icon2.default, {
	                className: iconClass,
	                size: 20,
	                name: "reference",
	                onClick: secondaryOnClick
	            })
	        )
	    );
	};
	FieldToGroupBy.displayName = "FieldToGroupBy";
	FieldToGroupBy.propTypes = {
	    className: _propTypes2.default.string,
	    metric: _propTypes2.default.object.isRequired,
	    field: _propTypes2.default.object.isRequired,
	    iconClass: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    secondaryOnClick: _propTypes2.default.func
	};
	
	exports.default = (0, _pure2.default)(FieldToGroupBy);

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fieldToGroupByText":"_190pI _2kZNz"};

/***/ }),
/* 1963 */,
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(924);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _Formula = __webpack_require__(1965);
	
	var _Formula2 = _interopRequireDefault(_Formula);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _QueryDefinition = __webpack_require__(1774);
	
	var _QueryDefinition2 = _interopRequireDefault(_QueryDefinition);
	
	var _metadata = __webpack_require__(1110);
	
	var _metadata2 = __webpack_require__(1073);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapDispatchToProps = {
	    fetchTableMetadata: _metadata.fetchTableMetadata
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        metadata: (0, _metadata2.getMetadata)(state, props)
	    };
	};
	
	var Formula = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(Formula, _Component);
	
	    function Formula() {
	        _classCallCheck(this, Formula);
	
	        return _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).apply(this, arguments));
	    }
	
	    _createClass(Formula, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                type = _props.type,
	                entity = _props.entity,
	                isExpanded = _props.isExpanded,
	                expandFormula = _props.expandFormula,
	                collapseFormula = _props.collapseFormula,
	                metadata = _props.metadata;
	
	
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: (0, _classnames2.default)(_Formula2.default.formula),
	                    onClick: isExpanded ? collapseFormula : expandFormula
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: _Formula2.default.formulaHeader },
	                    _react2.default.createElement(_Icon2.default, { name: "beaker", size: 24 }),
	                    _react2.default.createElement(
	                        "span",
	                        { className: _Formula2.default.formulaTitle },
	                        "View the ",
	                        type,
	                        " formula"
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactAddonsCssTransitionGroup2.default,
	                    {
	                        transitionName: "formulaDefinition",
	                        transitionEnterTimeout: 300,
	                        transitionLeaveTimeout: 300
	                    },
	                    isExpanded && _react2.default.createElement(
	                        "div",
	                        { key: "formulaDefinition", className: "formulaDefinition" },
	                        _react2.default.createElement(_QueryDefinition2.default, {
	                            className: _Formula2.default.formulaDefinitionInner,
	                            object: entity,
	                            tableMetadata: metadata.tables[entity.table_id]
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Formula;
	}(_react.Component)) || _class);
	Formula.displayName = "Formula";
	exports.default = Formula;

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"formula":"_2Hhl3 _2zlem Wr_al _1ocN4","formulaHeader":"_3CI1f _38618 _3Dqep _20SLo _2XN97 _1aL0S","formulaTitle":"kp0FY _1Wqf2","formulaDefinitionInner":"_1kWrk _2z9kb"};

/***/ }),
/* 1966 */,
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _FieldsToGroupBy = __webpack_require__(1958);
	
	var _FieldsToGroupBy2 = _interopRequireDefault(_FieldsToGroupBy);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Detail = __webpack_require__(1956);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MetricImportantFieldsDetail = function MetricImportantFieldsDetail(_ref) {
	    var fields = _ref.fields,
	        metric = _ref.metric,
	        table = _ref.table,
	        allFields = _ref.allFields,
	        isEditing = _ref.isEditing,
	        onChangeLocation = _ref.onChangeLocation,
	        formField = _ref.formField;
	    return isEditing ? _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_Detail2.default.detail) },
	        _react2.default.createElement(
	            "div",
	            { className: _Detail2.default.detailBody },
	            _react2.default.createElement(
	                "div",
	                { className: _Detail2.default.detailTitle },
	                _react2.default.createElement(
	                    "span",
	                    { className: _Detail2.default.detailName },
	                    "Which 2-3 fields do you usually group this metric by?"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(_Detail2.default.detailSubtitle, { "mt1": true }) },
	                _react2.default.createElement(_Select2.default, {
	                    key: "metricFieldsSelect",
	                    triggerClasses: "input p1 block",
	                    options: table.fields.map(function (fieldId) {
	                        return allFields[fieldId];
	                    }),
	                    optionNameFn: function optionNameFn(option) {
	                        return option.display_name || option.name;
	                    },
	                    placeholder: "Select...",
	                    values: formField.value || [],
	                    disabledOptionIds: formField.value && formField.value.length === 3 ? table.fields.map(function (fieldId) {
	                        return allFields[fieldId];
	                    }).filter(function (field) {
	                        return !formField.value.includes(field);
	                    }).map(function (field) {
	                        return field.id;
	                    }) : [],
	                    onChange: function onChange(field) {
	                        var importantFields = formField.value || [];
	                        return importantFields.includes(field) ? formField.onChange(importantFields.filter(function (importantField) {
	                            return importantField !== field;
	                        })) : importantFields.length < 3 && formField.onChange(importantFields.concat(field));
	                    }
	                })
	            )
	        )
	    ) : fields ? _react2.default.createElement(_FieldsToGroupBy2.default, {
	        fields: fields,
	        databaseId: table.db_id,
	        metric: metric,
	        title: "Most useful fields to group this metric by",
	        onChangeLocation: onChangeLocation
	    }) : null;
	};
	MetricImportantFieldsDetail.propTypes = {
	    fields: _propTypes2.default.object,
	    metric: _propTypes2.default.object.isRequired,
	    table: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool.isRequired,
	    onChangeLocation: _propTypes2.default.func.isRequired,
	    formField: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _pure2.default)(MetricImportantFieldsDetail);

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _MetricSidebar = __webpack_require__(1952);
	
	var _MetricSidebar2 = _interopRequireDefault(_MetricSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _MetricQuestions = __webpack_require__(1969);
	
	var _MetricQuestions2 = _interopRequireDefault(_MetricQuestions);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	var _questions = __webpack_require__(1622);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        user: (0, _selectors.getUser)(state, props),
	        metric: (0, _selectors.getMetric)(state, props),
	        metricId: (0, _selectors.getMetricId)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({
	    fetchQuestions: function fetchQuestions() {
	        return (0, _questions.loadEntities)("cards", {});
	    }
	}, metadataActions, actions);
	
	var MetricQuestionsContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(MetricQuestionsContainer, _Component);
	
	    function MetricQuestionsContainer() {
	        _classCallCheck(this, MetricQuestionsContainer);
	
	        return _possibleConstructorReturn(this, (MetricQuestionsContainer.__proto__ || Object.getPrototypeOf(MetricQuestionsContainer)).apply(this, arguments));
	    }
	
	    _createClass(MetricQuestionsContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchMetricQuestions(this.props, this.props.metricId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                metric = _props.metric,
	                isEditing = _props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_MetricSidebar2.default, { metric: metric, user: user })
	                },
	                _react2.default.createElement(_MetricQuestions2.default, this.props)
	            );
	        }
	    }]);
	
	    return MetricQuestionsContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    metric: _propTypes2.default.object.isRequired,
	    metricId: _propTypes2.default.number.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	MetricQuestionsContainer.displayName = 'MetricQuestionsContainer';
	exports.default = MetricQuestionsContainer;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _visualizations = __webpack_require__(1284);
	
	var _visualizations2 = _interopRequireDefault(_visualizations);
	
	var _table = __webpack_require__(871);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _List3 = __webpack_require__(1945);
	
	var _List4 = _interopRequireDefault(_List3);
	
	var _ListItem = __webpack_require__(1946);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _AdminAwareEmptyState = __webpack_require__(1947);
	
	var _AdminAwareEmptyState2 = _interopRequireDefault(_AdminAwareEmptyState);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _ReferenceHeader = __webpack_require__(1948);
	
	var _ReferenceHeader2 = _interopRequireDefault(_ReferenceHeader);
	
	var _utils = __webpack_require__(1920);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyStateData = function emptyStateData(table, metric) {
	    return {
	        message: "Questions about this metric will appear here as they're added",
	        icon: "all",
	        action: "Ask a question",
	        link: (0, _utils.getQuestionUrl)({
	            dbId: table && table.db_id,
	            tableId: metric.table_id,
	            metricId: metric.id
	        })
	    };
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        metric: (0, _selectors.getMetric)(state, props),
	        table: (0, _selectors.getTable)(state, props),
	        entities: (0, _selectors.getMetricQuestions)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        loadingError: (0, _selectors.getError)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions);
	
	var MetricQuestions = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(MetricQuestions, _Component);
	
	    function MetricQuestions() {
	        _classCallCheck(this, MetricQuestions);
	
	        return _possibleConstructorReturn(this, (MetricQuestions.__proto__ || Object.getPrototypeOf(MetricQuestions)).apply(this, arguments));
	    }
	
	    _createClass(MetricQuestions, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                entities = _props.entities,
	                style = _props.style,
	                loadingError = _props.loadingError,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                "div",
	                { style: style, className: "full" },
	                _react2.default.createElement(_ReferenceHeader2.default, {
	                    name: "Questions about " + this.props.metric.name,
	                    type: "questions",
	                    headerIcon: "ruler"
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return Object.keys(entities).length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List4.default,
	                                null,
	                                Object.values(entities).filter(_table.isQueryable).map(function (entity, index) {
	                                    return entity && entity.id && entity.name && _react2.default.createElement(
	                                        "li",
	                                        { className: "relative", key: entity.id },
	                                        _react2.default.createElement(_ListItem2.default, {
	                                            id: entity.id,
	                                            index: index,
	                                            name: entity.display_name || entity.name,
	                                            description: "Created " + (0, _moment2.default)(entity.created_at).fromNow() + " by " + entity.creator.common_name,
	                                            url: Urls.question(entity.id),
	                                            icon: _visualizations2.default.get(entity.display).iconName
	                                        })
	                                    );
	                                })
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_AdminAwareEmptyState2.default, emptyStateData(_this2.props.table, _this2.props.metric))
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return MetricQuestions;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entities: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object,
	    metric: _propTypes2.default.object,
	    table: _propTypes2.default.object
	}, _temp)) || _class);
	MetricQuestions.displayName = "MetricQuestions";
	exports.default = MetricQuestions;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _MetricSidebar = __webpack_require__(1952);
	
	var _MetricSidebar2 = _interopRequireDefault(_MetricSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _MetricRevisions = __webpack_require__(1971);
	
	var _MetricRevisions2 = _interopRequireDefault(_MetricRevisions);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        user: (0, _selectors.getUser)(state, props),
	        metric: (0, _selectors.getMetric)(state, props),
	        metricId: (0, _selectors.getMetricId)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var MetricRevisionsContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(MetricRevisionsContainer, _Component);
	
	    function MetricRevisionsContainer() {
	        _classCallCheck(this, MetricRevisionsContainer);
	
	        return _possibleConstructorReturn(this, (MetricRevisionsContainer.__proto__ || Object.getPrototypeOf(MetricRevisionsContainer)).apply(this, arguments));
	    }
	
	    _createClass(MetricRevisionsContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchMetricRevisions(this.props, this.props.metricId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                metric = _props.metric,
	                isEditing = _props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_MetricSidebar2.default, { metric: metric, user: user })
	                },
	                _react2.default.createElement(_MetricRevisions2.default, this.props)
	            );
	        }
	    }]);
	
	    return MetricRevisionsContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    metric: _propTypes2.default.object.isRequired,
	    metricId: _propTypes2.default.number.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	MetricRevisionsContainer.displayName = 'MetricRevisionsContainer';
	exports.default = MetricRevisionsContainer;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _icepick = __webpack_require__(855);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Reference = __webpack_require__(1972);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _formatting = __webpack_require__(872);
	
	var _selectors = __webpack_require__(1922);
	
	var _Revision = __webpack_require__(1847);
	
	var _Revision2 = _interopRequireDefault(_Revision);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _ReferenceHeader = __webpack_require__(1948);
	
	var _ReferenceHeader2 = _interopRequireDefault(_ReferenceHeader);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyStateData = {
	    message: "There are no revisions for this metric"
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        revisions: (0, _selectors.getMetricRevisions)(state, props),
	        metric: (0, _selectors.getMetric)(state, props),
	        segment: (0, _selectors.getSegment)(state, props),
	        tables: (0, _selectors.getTables)(state, props),
	        user: (0, _selectors.getUser)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        loadingError: (0, _selectors.getError)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions);
	
	var MetricRevisions = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(MetricRevisions, _Component);
	
	    function MetricRevisions() {
	        _classCallCheck(this, MetricRevisions);
	
	        return _possibleConstructorReturn(this, (MetricRevisions.__proto__ || Object.getPrototypeOf(MetricRevisions)).apply(this, arguments));
	    }
	
	    _createClass(MetricRevisions, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                style = _props.style,
	                revisions = _props.revisions,
	                metric = _props.metric,
	                segment = _props.segment,
	                tables = _props.tables,
	                user = _props.user,
	                loading = _props.loading,
	                loadingError = _props.loadingError;
	
	
	            var entity = metric.id ? metric : segment;
	
	            var userColorAssignments = user && Object.keys(revisions).length > 0 ? (0, _formatting.assignUserColors)(Object.values(revisions).map(function (revision) {
	                return (0, _icepick.getIn)(revision, ['user', 'id']);
	            }), user.id) : {};
	
	            return _react2.default.createElement(
	                "div",
	                { style: style, className: "full" },
	                _react2.default.createElement(_ReferenceHeader2.default, {
	                    name: "Revision history for " + this.props.metric.name,
	                    headerIcon: "ruler"
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return Object.keys(revisions).length > 0 && tables[entity.table_id] ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _Reference2.default.revisionsWrapper },
	                                Object.values(revisions).map(function (revision) {
	                                    return revision && revision.diff ? _react2.default.createElement(_Revision2.default, {
	                                        key: revision.id,
	                                        revision: revision || {},
	                                        tableMetadata: tables[entity.table_id] || {},
	                                        objectName: entity.name,
	                                        currentUser: user || {},
	                                        userColor: userColorAssignments[(0, _icepick.getIn)(revision, ['user', 'id'])]
	                                    }) : null;
	                                }).reverse()
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_EmptyState2.default, emptyStateData)
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return MetricRevisions;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    revisions: _propTypes2.default.object.isRequired,
	    metric: _propTypes2.default.object.isRequired,
	    segment: _propTypes2.default.object.isRequired,
	    tables: _propTypes2.default.object.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object
	}, _temp)) || _class);
	MetricRevisions.displayName = "MetricRevisions";
	exports.default = MetricRevisions;

/***/ }),
/* 1972 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"guideEmpty":"_3lkOe _38618 _1b0Gt _1X7sA","guideEmptyBody":"_12lXO rTQr-","guideEmptyMessage":"_2Nc8g _17S31 Tgxr2 rTQr- _1TQQY","columnHeader":"_1nDeh _38618 _2kZNz","revisionsWrapper":"_3eHg-","schemaSeparator":"bdjv2 _2SVp9 _17V2F","tableActualName":"_3JG6m","guideLeftPadded":"_3h8aH _38618 _1b0Gt _1X7sA","guideLeftPaddedBody":"_2kKIm","guideWrapper":"_1ssXs","guideTitle":"_16TLB _3h8aH _38618 _1b0Gt _1X7sA","guideTitleBody":"_3t1qJ _1b0Gt _17S31 _3TD8R _2kKIm","guideSeeAll":"_3cYiX _3h8aH _38618 _1b0Gt _1X7sA","guideSeeAllBody":"_3eu5P _38618 _1b0Gt _17S31 _3TD8R _37W4X _2kKIm","guideSeeAllLink":"_27TXd _2kZNz DsjBV qXm3b _2XN97 _2Hk-A","guideContact":"_2d-Io _37W4X _3h8aH _38618 _1b0Gt _1X7sA","guideContactBody":"_1MaeR _1b0Gt _2kKIm","guideEditHeader":"_3TJNb _1b0Gt _3CT2E _1dBmn","guideEditHeaderTitle":"_1MXor _3TD8R _2AJrG","guideEditCards":"_38Ah_ _17V2F A5BYb","guideEditCard":"_2kwIW _2hwsw _1iwVX","guideEditLabel":"_2hn2X DsjBV _3TD8R _2AJrG","guideEditHeaderDescription":"_3fnbu","guideEditTitle":"_1Ysza DsjBV _3CT2E _3TD8R","guideEditSubtitle":"_28W2g _3CT2E","guideEditAddButton":"JxqTW _38618 _1b0Gt _1ocN4 odbte","guideEditAddButtonBody":"_2RVkP","guideEditTextarea":"_2JkPZ _17S31 _2hwsw _2z9kb","guideEditContact":"_15kU1 _38618","guideEditContactName":"_1zQbQ","guideEditContactEmail":"_3P-xH","guideEditInput":"_3a5pX _1b0Gt _17S31 _2hwsw _2z9kb"};

/***/ }),
/* 1973 */,
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _BaseSidebar = __webpack_require__(1937);
	
	var _BaseSidebar2 = _interopRequireDefault(_BaseSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _SegmentList = __webpack_require__(1975);
	
	var _SegmentList2 = _interopRequireDefault(_SegmentList);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var SegmentListContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentListContainer, _Component);
	
	    function SegmentListContainer() {
	        _classCallCheck(this, SegmentListContainer);
	
	        return _possibleConstructorReturn(this, (SegmentListContainer.__proto__ || Object.getPrototypeOf(SegmentListContainer)).apply(this, arguments));
	    }
	
	    _createClass(SegmentListContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchSegments(this.props);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var isEditing = this.props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_BaseSidebar2.default, null)
	                },
	                _react2.default.createElement(_SegmentList2.default, this.props)
	            );
	        }
	    }]);
	
	    return SegmentListContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	SegmentListContainer.displayName = 'SegmentListContainer';
	exports.default = SegmentListContainer;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _table = __webpack_require__(871);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _List3 = __webpack_require__(1945);
	
	var _List4 = _interopRequireDefault(_List3);
	
	var _ListItem = __webpack_require__(1946);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _AdminAwareEmptyState = __webpack_require__(1947);
	
	var _AdminAwareEmptyState2 = _interopRequireDefault(_AdminAwareEmptyState);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _ReferenceHeader = __webpack_require__(1948);
	
	var _ReferenceHeader2 = _interopRequireDefault(_ReferenceHeader);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyStateData = {
	    title: "Segments are interesting subsets of tables",
	    adminMessage: "Defining common segments for your team makes it even easier to ask questions",
	    message: "Segments will appear here once your admins have created some",
	    image: "app/assets/img/segments-list",
	    adminAction: "Learn how to create segments",
	    adminLink: "http://www.metabase.com/docs/latest/administration-guide/06-segments-and-metrics.html"
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        entities: (0, _selectors.getSegments)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        loadingError: (0, _selectors.getError)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions);
	
	var SegmentList = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentList, _Component);
	
	    function SegmentList() {
	        _classCallCheck(this, SegmentList);
	
	        return _possibleConstructorReturn(this, (SegmentList.__proto__ || Object.getPrototypeOf(SegmentList)).apply(this, arguments));
	    }
	
	    _createClass(SegmentList, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                entities = _props.entities,
	                style = _props.style,
	                loadingError = _props.loadingError,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                "div",
	                { style: style, className: "full" },
	                _react2.default.createElement(_ReferenceHeader2.default, {
	                    name: "Segments"
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return Object.keys(entities).length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List4.default,
	                                null,
	                                Object.values(entities).filter(_table.isQueryable).map(function (entity, index) {
	                                    return entity && entity.id && entity.name && _react2.default.createElement(
	                                        "li",
	                                        { className: "relative", key: entity.id },
	                                        _react2.default.createElement(_ListItem2.default, {
	                                            id: entity.id,
	                                            index: index,
	                                            name: entity.display_name || entity.name,
	                                            description: entity.description,
	                                            url: "/reference/segments/" + entity.id,
	                                            icon: "segment"
	                                        })
	                                    );
	                                })
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_AdminAwareEmptyState2.default, emptyStateData)
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return SegmentList;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entities: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object
	}, _temp)) || _class);
	SegmentList.displayName = "SegmentList";
	exports.default = SegmentList;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _SegmentSidebar = __webpack_require__(1977);
	
	var _SegmentSidebar2 = _interopRequireDefault(_SegmentSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _SegmentDetail = __webpack_require__(1978);
	
	var _SegmentDetail2 = _interopRequireDefault(_SegmentDetail);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        user: (0, _selectors.getUser)(state, props),
	        segment: (0, _selectors.getSegment)(state, props),
	        segmentId: (0, _selectors.getSegmentId)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var SegmentDetailContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentDetailContainer, _Component);
	
	    function SegmentDetailContainer() {
	        _classCallCheck(this, SegmentDetailContainer);
	
	        return _possibleConstructorReturn(this, (SegmentDetailContainer.__proto__ || Object.getPrototypeOf(SegmentDetailContainer)).apply(this, arguments));
	    }
	
	    _createClass(SegmentDetailContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchSegmentDetail(this.props, this.props.segmentId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                segment = _props.segment,
	                isEditing = _props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_SegmentSidebar2.default, { segment: segment, user: user })
	                },
	                _react2.default.createElement(_SegmentDetail2.default, this.props)
	            );
	        }
	    }]);
	
	    return SegmentDetailContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    segment: _propTypes2.default.object.isRequired,
	    segmentId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	SegmentDetailContainer.displayName = 'SegmentDetailContainer';
	exports.default = SegmentDetailContainer;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Sidebar = __webpack_require__(1938);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _SidebarItem = __webpack_require__(1940);
	
	var _SidebarItem2 = _interopRequireDefault(_SidebarItem);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SegmentSidebar = function SegmentSidebar(_ref) {
	    var segment = _ref.segment,
	        user = _ref.user,
	        style = _ref.style,
	        className = _ref.className;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_Sidebar2.default.sidebar, className), style: style },
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: _Sidebar2.default.breadcrumbs },
	                _react2.default.createElement(_Breadcrumbs2.default, {
	                    className: "py4",
	                    crumbs: [["Segments", "/reference/segments"], [segment.name]],
	                    inSidebar: true,
	                    placeholder: "Data Reference"
	                })
	            ),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/segments/" + segment.id,
	                href: "/reference/segments/" + segment.id,
	                icon: "document",
	                name: "Details" }),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/segments/" + segment.id + "/fields",
	                href: "/reference/segments/" + segment.id + "/fields",
	                icon: "fields",
	                name: "Fields in this segment" }),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/segments/" + segment.id + "/questions",
	                href: "/reference/segments/" + segment.id + "/questions",
	                icon: "all",
	                name: "Questions about this segment" }),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/xray/segment/" + segment.id + "/approximate",
	                href: "/xray/segment/" + segment.id + "/approximate",
	                icon: "all",
	                name: "X-ray this segment" }),
	            user && user.is_superuser && _react2.default.createElement(_SidebarItem2.default, { key: "/reference/segments/" + segment.id + "/revisions",
	                href: "/reference/segments/" + segment.id + "/revisions",
	                icon: "history",
	                name: "Revision history" })
	        )
	    );
	}; /* eslint "react/prop-types": "warn" */
	SegmentSidebar.displayName = "SegmentSidebar";
	
	
	SegmentSidebar.propTypes = {
	    segment: _propTypes2.default.object,
	    user: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object
	};
	
	exports.default = (0, _pure2.default)(SegmentSidebar);

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reduxForm = __webpack_require__(589);
	
	var _List = __webpack_require__(1945);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _EditHeader = __webpack_require__(1924);
	
	var _EditHeader2 = _interopRequireDefault(_EditHeader);
	
	var _EditableReferenceHeader = __webpack_require__(1954);
	
	var _EditableReferenceHeader2 = _interopRequireDefault(_EditableReferenceHeader);
	
	var _Detail = __webpack_require__(1955);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _UsefulQuestions = __webpack_require__(1979);
	
	var _UsefulQuestions2 = _interopRequireDefault(_UsefulQuestions);
	
	var _Formula = __webpack_require__(1964);
	
	var _Formula2 = _interopRequireDefault(_Formula);
	
	var _utils = __webpack_require__(1920);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var interestingQuestions = function interestingQuestions(table, segment) {
	    return [{
	        text: "Number of " + segment.name,
	        icon: { name: "number", scale: 1, viewBox: "8 8 16 16" },
	        link: (0, _utils.getQuestionUrl)({
	            dbId: table && table.db_id,
	            tableId: table.id,
	            segmentId: segment.id,
	            getCount: true
	        })
	    }, {
	        text: "See all " + segment.name,
	        icon: "table2",
	        link: (0, _utils.getQuestionUrl)({
	            dbId: table && table.db_id,
	            tableId: table.id,
	            segmentId: segment.id
	        })
	    }];
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var entity = (0, _selectors.getSegment)(state, props) || {};
	    var guide = (0, _selectors.getGuide)(state, props);
	    var fields = (0, _selectors.getFields)(state, props);
	
	    var initialValues = {
	        important_fields: guide && guide.metric_important_fields && guide.metric_important_fields[entity.id] && guide.metric_important_fields[entity.id].map(function (fieldId) {
	            return fields[fieldId];
	        }) || []
	    };
	
	    return {
	        entity: entity,
	        table: (0, _selectors.getTable)(state, props),
	        metadataFields: fields,
	        guide: guide,
	        loading: (0, _selectors.getLoading)(state, props),
	        // naming this 'error' will conflict with redux form
	        loadingError: (0, _selectors.getError)(state, props),
	        user: (0, _selectors.getUser)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        isFormulaExpanded: (0, _selectors.getIsFormulaExpanded)(state, props),
	        initialValues: initialValues
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var validate = function validate(values, props) {
	    return !values.revision_message ? { revision_message: "Please enter a revision message" } : {};
	};
	
	var SegmentDetail = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reduxForm.reduxForm)({
	    form: 'details',
	    fields: ['name', 'display_name', 'description', 'revision_message', 'points_of_interest', 'caveats'],
	    validate: validate
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentDetail, _Component);
	
	    function SegmentDetail() {
	        _classCallCheck(this, SegmentDetail);
	
	        return _possibleConstructorReturn(this, (SegmentDetail.__proto__ || Object.getPrototypeOf(SegmentDetail)).apply(this, arguments));
	    }
	
	    _createClass(SegmentDetail, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$fields = _props.fields,
	                name = _props$fields.name,
	                display_name = _props$fields.display_name,
	                description = _props$fields.description,
	                revision_message = _props$fields.revision_message,
	                points_of_interest = _props$fields.points_of_interest,
	                caveats = _props$fields.caveats,
	                style = _props.style,
	                entity = _props.entity,
	                table = _props.table,
	                loadingError = _props.loadingError,
	                loading = _props.loading,
	                user = _props.user,
	                isEditing = _props.isEditing,
	                startEditing = _props.startEditing,
	                endEditing = _props.endEditing,
	                expandFormula = _props.expandFormula,
	                collapseFormula = _props.collapseFormula,
	                isFormulaExpanded = _props.isFormulaExpanded,
	                handleSubmit = _props.handleSubmit,
	                resetForm = _props.resetForm,
	                submitting = _props.submitting;
	
	
	            var onSubmit = handleSubmit(function () {
	                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(fields) {
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    _context.next = 2;
	                                    return actions.rUpdateSegmentDetail(fields, _this2.props);
	
	                                case 2:
	                                    return _context.abrupt("return", _context.sent);
	
	                                case 3:
	                                case "end":
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                    return _ref.apply(this, arguments);
	                };
	            }());
	
	            return _react2.default.createElement(
	                "form",
	                { style: style, className: "full",
	                    onSubmit: onSubmit
	                },
	                isEditing && _react2.default.createElement(_EditHeader2.default, {
	                    hasRevisionHistory: true,
	                    onSubmit: onSubmit,
	                    endEditing: endEditing,
	                    reinitializeForm: resetForm,
	                    submitting: submitting,
	                    revisionMessageFormField: revision_message
	                }),
	                _react2.default.createElement(_EditableReferenceHeader2.default, {
	                    entity: entity,
	                    table: table,
	                    type: "segment",
	                    headerIcon: "segment",
	                    headerLink: (0, _utils.getQuestionUrl)({ dbId: table && table.db_id, tableId: entity.table_id, segmentId: entity.id }),
	                    name: "Details",
	                    user: user,
	                    isEditing: isEditing,
	                    hasSingleSchema: false,
	                    hasDisplayName: false,
	                    startEditing: startEditing,
	                    displayNameFormField: display_name,
	                    nameFormField: name
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List2.default,
	                                null,
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "description",
	                                        name: "Description",
	                                        description: entity.description,
	                                        placeholder: "No description yet",
	                                        isEditing: isEditing,
	                                        field: description
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "points_of_interest",
	                                        name: "Why this Segment is interesting",
	                                        description: entity.points_of_interest,
	                                        placeholder: "Nothing interesting yet",
	                                        isEditing: isEditing,
	                                        field: points_of_interest
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "caveats",
	                                        name: "Things to be aware of about this Segment",
	                                        description: entity.caveats,
	                                        placeholder: "Nothing to be aware of yet",
	                                        isEditing: isEditing,
	                                        field: caveats
	                                    })
	                                ),
	                                table && !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Formula2.default, {
	                                        type: "segment",
	                                        entity: entity,
	                                        table: table,
	                                        isExpanded: isFormulaExpanded,
	                                        expandFormula: expandFormula,
	                                        collapseFormula: collapseFormula
	                                    })
	                                ),
	                                !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_UsefulQuestions2.default, { questions: interestingQuestions(_this2.props.table, _this2.props.entity) })
	                                )
	                            )
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return SegmentDetail;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entity: _propTypes2.default.object.isRequired,
	    table: _propTypes2.default.object,
	    user: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func.isRequired,
	    endEditing: _propTypes2.default.func.isRequired,
	    startLoading: _propTypes2.default.func.isRequired,
	    endLoading: _propTypes2.default.func.isRequired,
	    expandFormula: _propTypes2.default.func.isRequired,
	    collapseFormula: _propTypes2.default.func.isRequired,
	    setError: _propTypes2.default.func.isRequired,
	    updateField: _propTypes2.default.func.isRequired,
	    handleSubmit: _propTypes2.default.func.isRequired,
	    resetForm: _propTypes2.default.func.isRequired,
	    fields: _propTypes2.default.object.isRequired,
	    isFormulaExpanded: _propTypes2.default.bool,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool
	}, _temp)) || _class) || _class);
	SegmentDetail.displayName = "SegmentDetail";
	exports.default = SegmentDetail;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _UsefulQuestions = __webpack_require__(1959);
	
	var _UsefulQuestions2 = _interopRequireDefault(_UsefulQuestions);
	
	var _Detail = __webpack_require__(1956);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _QueryButton = __webpack_require__(1766);
	
	var _QueryButton2 = _interopRequireDefault(_QueryButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsefulQuestions = function UsefulQuestions(_ref) {
	    var questions = _ref.questions;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_Detail2.default.detail) },
	        _react2.default.createElement(
	            "div",
	            { className: _Detail2.default.detailBody },
	            _react2.default.createElement(
	                "div",
	                { className: _Detail2.default.detailTitle },
	                _react2.default.createElement(
	                    "span",
	                    { className: _Detail2.default.detailName },
	                    "Potentially useful questions"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: _UsefulQuestions2.default.usefulQuestions },
	                questions.map(function (question, index, questions) {
	                    return _react2.default.createElement(_QueryButton2.default, _extends({
	                        key: index,
	                        className: (0, _classnames2.default)("border-bottom", "pt1", "pb1"),
	                        iconClass: _List2.default.icon
	                    }, question));
	                })
	            )
	        )
	    );
	};
	UsefulQuestions.displayName = "UsefulQuestions";
	UsefulQuestions.propTypes = {
	    questions: _propTypes2.default.array.isRequired
	};
	
	exports.default = (0, _pure2.default)(UsefulQuestions);

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _SegmentSidebar = __webpack_require__(1977);
	
	var _SegmentSidebar2 = _interopRequireDefault(_SegmentSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _SegmentQuestions = __webpack_require__(1981);
	
	var _SegmentQuestions2 = _interopRequireDefault(_SegmentQuestions);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	var _questions = __webpack_require__(1622);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        user: (0, _selectors.getUser)(state, props),
	        segment: (0, _selectors.getSegment)(state, props),
	        segmentId: (0, _selectors.getSegmentId)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({
	    fetchQuestions: function fetchQuestions() {
	        return (0, _questions.loadEntities)("cards", {});
	    }
	}, metadataActions, actions);
	
	var SegmentQuestionsContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentQuestionsContainer, _Component);
	
	    function SegmentQuestionsContainer() {
	        _classCallCheck(this, SegmentQuestionsContainer);
	
	        return _possibleConstructorReturn(this, (SegmentQuestionsContainer.__proto__ || Object.getPrototypeOf(SegmentQuestionsContainer)).apply(this, arguments));
	    }
	
	    _createClass(SegmentQuestionsContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchSegmentQuestions(this.props, this.props.segmentId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                segment = _props.segment,
	                isEditing = _props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_SegmentSidebar2.default, { segment: segment, user: user })
	                },
	                _react2.default.createElement(_SegmentQuestions2.default, this.props)
	            );
	        }
	    }]);
	
	    return SegmentQuestionsContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    segment: _propTypes2.default.object.isRequired,
	    segmentId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	SegmentQuestionsContainer.displayName = 'SegmentQuestionsContainer';
	exports.default = SegmentQuestionsContainer;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _visualizations = __webpack_require__(1284);
	
	var _visualizations2 = _interopRequireDefault(_visualizations);
	
	var _table = __webpack_require__(871);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _List3 = __webpack_require__(1945);
	
	var _List4 = _interopRequireDefault(_List3);
	
	var _ListItem = __webpack_require__(1946);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _AdminAwareEmptyState = __webpack_require__(1947);
	
	var _AdminAwareEmptyState2 = _interopRequireDefault(_AdminAwareEmptyState);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _ReferenceHeader = __webpack_require__(1948);
	
	var _ReferenceHeader2 = _interopRequireDefault(_ReferenceHeader);
	
	var _utils = __webpack_require__(1920);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyStateData = function emptyStateData(table, segment) {
	    return {
	        message: "Questions about this segment will appear here as they're added",
	        icon: "all",
	        action: "Ask a question",
	        link: (0, _utils.getQuestionUrl)({
	            dbId: table && table.db_id,
	            tableId: segment.table_id,
	            segmentId: segment.id
	        })
	    };
	};
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        segment: (0, _selectors.getSegment)(state, props),
	        table: (0, _selectors.getTableBySegment)(state, props),
	        entities: (0, _selectors.getSegmentQuestions)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        loadingError: (0, _selectors.getError)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions);
	
	var SegmentQuestions = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentQuestions, _Component);
	
	    function SegmentQuestions() {
	        _classCallCheck(this, SegmentQuestions);
	
	        return _possibleConstructorReturn(this, (SegmentQuestions.__proto__ || Object.getPrototypeOf(SegmentQuestions)).apply(this, arguments));
	    }
	
	    _createClass(SegmentQuestions, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                entities = _props.entities,
	                style = _props.style,
	                loadingError = _props.loadingError,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                "div",
	                { style: style, className: "full" },
	                _react2.default.createElement(_ReferenceHeader2.default, {
	                    name: "Questions about " + this.props.segment.name,
	                    type: "questions",
	                    headerIcon: "segment"
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return Object.keys(entities).length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List4.default,
	                                null,
	                                Object.values(entities).filter(_table.isQueryable).map(function (entity, index) {
	                                    return entity && entity.id && entity.name && _react2.default.createElement(
	                                        "li",
	                                        { className: "relative", key: entity.id },
	                                        _react2.default.createElement(_ListItem2.default, {
	                                            id: entity.id,
	                                            index: index,
	                                            name: entity.display_name || entity.name,
	                                            description: "Created " + (0, _moment2.default)(entity.created_at).fromNow() + " by " + entity.creator.common_name,
	                                            url: Urls.question(entity.id),
	                                            icon: _visualizations2.default.get(entity.display).iconName
	                                        })
	                                    );
	                                })
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_AdminAwareEmptyState2.default, emptyStateData(_this2.props.table, _this2.props.segment))
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return SegmentQuestions;
	}(_react.Component), _class2.propTypes = {
	    table: _propTypes2.default.object.isRequired,
	    segment: _propTypes2.default.object.isRequired,
	    style: _propTypes2.default.object.isRequired,
	    entities: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object
	}, _temp)) || _class);
	SegmentQuestions.displayName = "SegmentQuestions";
	exports.default = SegmentQuestions;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _SegmentSidebar = __webpack_require__(1977);
	
	var _SegmentSidebar2 = _interopRequireDefault(_SegmentSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _SegmentRevisions = __webpack_require__(1983);
	
	var _SegmentRevisions2 = _interopRequireDefault(_SegmentRevisions);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        user: (0, _selectors.getUser)(state, props),
	        segment: (0, _selectors.getSegment)(state, props),
	        segmentId: (0, _selectors.getSegmentId)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var SegmentRevisionsContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentRevisionsContainer, _Component);
	
	    function SegmentRevisionsContainer() {
	        _classCallCheck(this, SegmentRevisionsContainer);
	
	        return _possibleConstructorReturn(this, (SegmentRevisionsContainer.__proto__ || Object.getPrototypeOf(SegmentRevisionsContainer)).apply(this, arguments));
	    }
	
	    _createClass(SegmentRevisionsContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchSegmentRevisions(this.props, this.props.segmentId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                segment = _props.segment,
	                isEditing = _props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_SegmentSidebar2.default, { segment: segment, user: user })
	                },
	                _react2.default.createElement(_SegmentRevisions2.default, this.props)
	            );
	        }
	    }]);
	
	    return SegmentRevisionsContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    segment: _propTypes2.default.object.isRequired,
	    segmentId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	SegmentRevisionsContainer.displayName = 'SegmentRevisionsContainer';
	exports.default = SegmentRevisionsContainer;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _icepick = __webpack_require__(855);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Reference = __webpack_require__(1972);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _formatting = __webpack_require__(872);
	
	var _selectors = __webpack_require__(1922);
	
	var _Revision = __webpack_require__(1847);
	
	var _Revision2 = _interopRequireDefault(_Revision);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _ReferenceHeader = __webpack_require__(1948);
	
	var _ReferenceHeader2 = _interopRequireDefault(_ReferenceHeader);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyStateData = {
	    message: "There are no revisions for this segment"
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        revisions: (0, _selectors.getSegmentRevisions)(state, props),
	        metric: (0, _selectors.getMetric)(state, props),
	        segment: (0, _selectors.getSegment)(state, props),
	        tables: (0, _selectors.getTables)(state, props),
	        user: (0, _selectors.getUser)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        loadingError: (0, _selectors.getError)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions);
	
	var SegmentRevisions = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentRevisions, _Component);
	
	    function SegmentRevisions() {
	        _classCallCheck(this, SegmentRevisions);
	
	        return _possibleConstructorReturn(this, (SegmentRevisions.__proto__ || Object.getPrototypeOf(SegmentRevisions)).apply(this, arguments));
	    }
	
	    _createClass(SegmentRevisions, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                style = _props.style,
	                revisions = _props.revisions,
	                metric = _props.metric,
	                segment = _props.segment,
	                tables = _props.tables,
	                user = _props.user,
	                loading = _props.loading,
	                loadingError = _props.loadingError;
	
	
	            var entity = metric.id ? metric : segment;
	
	            var userColorAssignments = user && Object.keys(revisions).length > 0 ? (0, _formatting.assignUserColors)(Object.values(revisions).map(function (revision) {
	                return (0, _icepick.getIn)(revision, ['user', 'id']);
	            }), user.id) : {};
	
	            return _react2.default.createElement(
	                "div",
	                { style: style, className: "full" },
	                _react2.default.createElement(_ReferenceHeader2.default, {
	                    name: "Revision history for " + this.props.segment.name,
	                    headerIcon: "segment"
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return Object.keys(revisions).length > 0 && tables[entity.table_id] ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _Reference2.default.revisionsWrapper },
	                                Object.values(revisions).map(function (revision) {
	                                    return revision && revision.diff ? _react2.default.createElement(_Revision2.default, {
	                                        key: revision.id,
	                                        revision: revision || {},
	                                        tableMetadata: tables[entity.table_id] || {},
	                                        objectName: entity.name,
	                                        currentUser: user || {},
	                                        userColor: userColorAssignments[(0, _icepick.getIn)(revision, ['user', 'id'])]
	                                    }) : null;
	                                }).reverse()
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_EmptyState2.default, emptyStateData)
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return SegmentRevisions;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    revisions: _propTypes2.default.object.isRequired,
	    metric: _propTypes2.default.object.isRequired,
	    segment: _propTypes2.default.object.isRequired,
	    tables: _propTypes2.default.object.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object
	}, _temp)) || _class);
	SegmentRevisions.displayName = "SegmentRevisions";
	exports.default = SegmentRevisions;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _SegmentSidebar = __webpack_require__(1977);
	
	var _SegmentSidebar2 = _interopRequireDefault(_SegmentSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _SegmentFieldList = __webpack_require__(1985);
	
	var _SegmentFieldList2 = _interopRequireDefault(_SegmentFieldList);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        user: (0, _selectors.getUser)(state, props),
	        segment: (0, _selectors.getSegment)(state, props),
	        segmentId: (0, _selectors.getSegmentId)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var SegmentFieldListContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentFieldListContainer, _Component);
	
	    function SegmentFieldListContainer() {
	        _classCallCheck(this, SegmentFieldListContainer);
	
	        return _possibleConstructorReturn(this, (SegmentFieldListContainer.__proto__ || Object.getPrototypeOf(SegmentFieldListContainer)).apply(this, arguments));
	    }
	
	    _createClass(SegmentFieldListContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchSegmentFields(this.props, this.props.segmentId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                segment = _props.segment,
	                isEditing = _props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_SegmentSidebar2.default, { segment: segment, user: user })
	                },
	                _react2.default.createElement(_SegmentFieldList2.default, this.props)
	            );
	        }
	    }]);
	
	    return SegmentFieldListContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    segment: _propTypes2.default.object.isRequired,
	    segmentId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	SegmentFieldListContainer.displayName = 'SegmentFieldListContainer';
	exports.default = SegmentFieldListContainer;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reduxForm = __webpack_require__(589);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Reference = __webpack_require__(1972);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	var _Field = __webpack_require__(1986);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Field3 = __webpack_require__(1988);
	
	var _Field4 = _interopRequireDefault(_Field3);
	
	var _List3 = __webpack_require__(1945);
	
	var _List4 = _interopRequireDefault(_List3);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _EditHeader = __webpack_require__(1924);
	
	var _EditHeader2 = _interopRequireDefault(_EditHeader);
	
	var _EditableReferenceHeader = __webpack_require__(1954);
	
	var _EditableReferenceHeader2 = _interopRequireDefault(_EditableReferenceHeader);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _selectors = __webpack_require__(1922);
	
	var _utils = __webpack_require__(1920);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyStateData = {
	    message: "Fields in this table will appear here as they're added",
	    icon: "fields"
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var data = (0, _selectors.getFieldsBySegment)(state, props);
	    return {
	        segment: (0, _selectors.getSegment)(state, props),
	        entities: data,
	        foreignKeys: (0, _selectors.getForeignKeys)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        loadingError: (0, _selectors.getError)(state, props),
	        user: (0, _selectors.getUser)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        fields: (0, _utils.fieldsToFormFields)(data)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var validate = function validate(values, props) {
	    return {};
	};
	
	var SegmentFieldList = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reduxForm.reduxForm)({
	    form: 'fields',
	    validate: validate
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentFieldList, _Component);
	
	    function SegmentFieldList() {
	        _classCallCheck(this, SegmentFieldList);
	
	        return _possibleConstructorReturn(this, (SegmentFieldList.__proto__ || Object.getPrototypeOf(SegmentFieldList)).apply(this, arguments));
	    }
	
	    _createClass(SegmentFieldList, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                segment = _props.segment,
	                style = _props.style,
	                entities = _props.entities,
	                fields = _props.fields,
	                foreignKeys = _props.foreignKeys,
	                loadingError = _props.loadingError,
	                loading = _props.loading,
	                user = _props.user,
	                isEditing = _props.isEditing,
	                startEditing = _props.startEditing,
	                endEditing = _props.endEditing,
	                resetForm = _props.resetForm,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting;
	
	
	            return _react2.default.createElement(
	                "form",
	                { style: style, className: "full",
	                    onSubmit: handleSubmit(function () {
	                        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(formFields) {
	                            return regeneratorRuntime.wrap(function _callee$(_context) {
	                                while (1) {
	                                    switch (_context.prev = _context.next) {
	                                        case 0:
	                                            _context.next = 2;
	                                            return actions.rUpdateFields(_this2.props.entities, formFields, _this2.props);
	
	                                        case 2:
	                                            return _context.abrupt("return", _context.sent);
	
	                                        case 3:
	                                        case "end":
	                                            return _context.stop();
	                                    }
	                                }
	                            }, _callee, _this2);
	                        }));
	
	                        return function (_x) {
	                            return _ref.apply(this, arguments);
	                        };
	                    }())
	                },
	                isEditing && _react2.default.createElement(_EditHeader2.default, {
	                    hasRevisionHistory: false,
	                    reinitializeForm: resetForm,
	                    endEditing: endEditing,
	                    submitting: submitting
	                }),
	                _react2.default.createElement(_EditableReferenceHeader2.default, {
	                    type: "segment",
	                    headerIcon: "segment",
	                    name: "Fields in " + segment.name,
	                    user: user,
	                    isEditing: isEditing,
	                    startEditing: startEditing
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return Object.keys(entities).length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _List2.default.item },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _Reference2.default.columnHeader },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: (0, _classnames2.default)(_List2.default.itemTitle, _Field2.default.fieldNameTitle) },
	                                        "Field name"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: (0, _classnames2.default)(_List2.default.itemTitle, _Field2.default.fieldType) },
	                                        "Field type"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: (0, _classnames2.default)(_List2.default.itemTitle, _Field2.default.fieldDataType) },
	                                        "Data type"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _List4.default,
	                                null,
	                                Object.values(entities).map(function (entity) {
	                                    return entity && entity.id && entity.name && _react2.default.createElement(
	                                        "li",
	                                        { className: "relative", key: entity.id },
	                                        _react2.default.createElement(_Field4.default, {
	                                            field: entity,
	                                            foreignKeys: foreignKeys,
	                                            url: "/reference/segments/" + segment.id + "/fields/" + entity.id,
	                                            icon: (0, _schema_metadata.getIconForField)(entity),
	                                            isEditing: isEditing,
	                                            formField: fields[entity.id]
	                                        })
	                                    );
	                                })
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_EmptyState2.default, emptyStateData)
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return SegmentFieldList;
	}(_react.Component), _class2.propTypes = {
	    segment: _propTypes2.default.object.isRequired,
	    style: _propTypes2.default.object.isRequired,
	    entities: _propTypes2.default.object.isRequired,
	    foreignKeys: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func.isRequired,
	    endEditing: _propTypes2.default.func.isRequired,
	    startLoading: _propTypes2.default.func.isRequired,
	    endLoading: _propTypes2.default.func.isRequired,
	    setError: _propTypes2.default.func.isRequired,
	    updateField: _propTypes2.default.func.isRequired,
	    handleSubmit: _propTypes2.default.func.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    fields: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool,
	    resetForm: _propTypes2.default.func
	}, _temp)) || _class) || _class);
	SegmentFieldList.displayName = "SegmentFieldList";
	exports.default = SegmentFieldList;

/***/ }),
/* 1986 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"field":"_3J87J _38618 _3Dqep","fieldNameTitle":"_3hiLw _2kZNz _342no","fieldName":"_3jtS4 _3hiLw _2kZNz _342no","fieldNameTextInput":"_3MrIp _2hwsw _1FLRv","fieldSelect":"_1uQ7X _2hwsw _1FLRv DsjBV","fieldType":"_12hYh _1vRAn _342no","fieldDataType":"_3FxLA _1vRAn","fieldSecondary":"Nf7Hp _3J87J _38618 _3Dqep","fieldActualName":"_1NnDR _3hiLw _2kZNz _342no _1UYVa","fieldForeignKey":"_4KwNG _12hYh _1vRAn _342no","fieldOther":"_1ujEJ _3FxLA _1vRAn"};

/***/ }),
/* 1987 */,
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _core = __webpack_require__(1831);
	
	var MetabaseCore = _interopRequireWildcard(_core);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _types = __webpack_require__(868);
	
	var _icepick = __webpack_require__(855);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Field = __webpack_require__(1986);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Field = function Field(_ref) {
	    var field = _ref.field,
	        foreignKeys = _ref.foreignKeys,
	        url = _ref.url,
	        icon = _ref.icon,
	        isEditing = _ref.isEditing,
	        formField = _ref.formField;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_List2.default.item) },
	        _react2.default.createElement(
	            "div",
	            { className: _List2.default.leftIcons },
	            icon && _react2.default.createElement(_Icon2.default, { className: _List2.default.chartIcon, name: icon, size: 20 })
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: _List2.default.itemBody, style: { maxWidth: "100%", borderTop: "none" } },
	            _react2.default.createElement(
	                "div",
	                { className: _Field2.default.field },
	                _react2.default.createElement(
	                    "div",
	                    { className: (0, _classnames2.default)(_List2.default.itemTitle, _Field2.default.fieldName) },
	                    isEditing ? _react2.default.createElement("input", _extends({
	                        className: _Field2.default.fieldNameTextInput,
	                        type: "text",
	                        placeholder: field.name
	                    }, formField.display_name, {
	                        defaultValue: field.display_name
	                    })) : _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: url, className: _List2.default.itemName },
	                        field.display_name
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _Field2.default.fieldType },
	                    isEditing ? _react2.default.createElement(_Select2.default, {
	                        triggerClasses: _Field2.default.fieldSelect,
	                        placeholder: "Select a field type",
	                        value: MetabaseCore.field_special_types_map[formField.special_type.value] || MetabaseCore.field_special_types_map[field.special_type],
	                        options: MetabaseCore.field_special_types.concat({
	                            'id': null,
	                            'name': 'No field type',
	                            'section': 'Other'
	                        }).filter(function (type) {
	                            return (0, _schema_metadata.isNumericBaseType)(field) || !(0, _types.isa)(type && type.id, _types.TYPE.UNIXTimestamp);
	                        }),
	                        onChange: function onChange(type) {
	                            return formField.special_type.onChange(type.id);
	                        }
	                    }) : _react2.default.createElement(
	                        "span",
	                        null,
	                        (0, _icepick.getIn)(MetabaseCore.field_special_types_map, [field.special_type, 'name']) || 'No field type'
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _Field2.default.fieldDataType },
	                    field.base_type
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(_List2.default.itemSubtitle, _Field2.default.fieldSecondary, { "mt1": true }) },
	                _react2.default.createElement(
	                    "div",
	                    { className: _Field2.default.fieldActualName },
	                    field.name
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: _Field2.default.fieldForeignKey },
	                    isEditing ? ((0, _types.isFK)(formField.special_type.value) || (0, _types.isFK)(field.special_type) && formField.special_type.value === undefined) && _react2.default.createElement(_Select2.default, {
	                        triggerClasses: _Field2.default.fieldSelect,
	                        placeholder: "Select a field type",
	                        value: foreignKeys[formField.fk_target_field_id.value] || foreignKeys[field.fk_target_field_id] || {},
	                        options: Object.values(foreignKeys),
	                        onChange: function onChange(foreignKey) {
	                            return formField.fk_target_field_id.onChange(foreignKey.id);
	                        },
	                        optionNameFn: function optionNameFn(foreignKey) {
	                            return foreignKey.name;
	                        }
	                    }) : (0, _types.isFK)(field.special_type) && _react2.default.createElement(
	                        "span",
	                        null,
	                        (0, _icepick.getIn)(foreignKeys, [field.fk_target_field_id, "name"])
	                    )
	                ),
	                _react2.default.createElement("div", { className: _Field2.default.fieldOther })
	            )
	        )
	    );
	};
	Field.displayName = "Field";
	Field.propTypes = {
	    field: _propTypes2.default.object.isRequired,
	    foreignKeys: _propTypes2.default.object.isRequired,
	    url: _propTypes2.default.string.isRequired,
	    placeholder: _propTypes2.default.string,
	    icon: _propTypes2.default.string,
	    isEditing: _propTypes2.default.bool,
	    formField: _propTypes2.default.object
	};
	
	exports.default = (0, _pure2.default)(Field);

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _SegmentFieldSidebar = __webpack_require__(1990);
	
	var _SegmentFieldSidebar2 = _interopRequireDefault(_SegmentFieldSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _SegmentFieldDetail = __webpack_require__(1991);
	
	var _SegmentFieldDetail2 = _interopRequireDefault(_SegmentFieldDetail);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        segment: (0, _selectors.getSegment)(state, props),
	        segmentId: (0, _selectors.getSegmentId)(state, props),
	        field: (0, _selectors.getField)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var SegmentFieldDetailContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentFieldDetailContainer, _Component);
	
	    function SegmentFieldDetailContainer() {
	        _classCallCheck(this, SegmentFieldDetailContainer);
	
	        return _possibleConstructorReturn(this, (SegmentFieldDetailContainer.__proto__ || Object.getPrototypeOf(SegmentFieldDetailContainer)).apply(this, arguments));
	    }
	
	    _createClass(SegmentFieldDetailContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchSegmentFields(this.props, this.props.segmentId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                segment = _props.segment,
	                field = _props.field,
	                isEditing = _props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_SegmentFieldSidebar2.default, { segment: segment, field: field })
	                },
	                _react2.default.createElement(_SegmentFieldDetail2.default, this.props)
	            );
	        }
	    }]);
	
	    return SegmentFieldDetailContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    segment: _propTypes2.default.object.isRequired,
	    segmentId: _propTypes2.default.number.isRequired,
	    field: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	SegmentFieldDetailContainer.displayName = 'SegmentFieldDetailContainer';
	exports.default = SegmentFieldDetailContainer;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Sidebar = __webpack_require__(1938);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _SidebarItem = __webpack_require__(1940);
	
	var _SidebarItem2 = _interopRequireDefault(_SidebarItem);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SegmentFieldSidebar = function SegmentFieldSidebar(_ref) {
	    var segment = _ref.segment,
	        field = _ref.field,
	        style = _ref.style,
	        className = _ref.className;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_Sidebar2.default.sidebar, className), style: style },
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: _Sidebar2.default.breadcrumbs },
	                _react2.default.createElement(_Breadcrumbs2.default, {
	                    className: "py4",
	                    crumbs: [["Segments", "/reference/segments"], [segment.name, "/reference/segments/" + segment.id], [field.name]],
	                    inSidebar: true,
	                    placeholder: "Data Reference"
	                })
	            ),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/segments/" + segment.id + "/fields/" + field.id,
	                href: "/reference/segments/" + segment.id + "/fields/" + field.id,
	                icon: "document",
	                name: "Details" })
	        )
	    );
	}; /* eslint "react/prop-types": "warn" */
	SegmentFieldSidebar.displayName = "SegmentFieldSidebar";
	
	
	SegmentFieldSidebar.propTypes = {
	    segment: _propTypes2.default.object,
	    field: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object
	};
	
	exports.default = (0, _pure2.default)(SegmentFieldSidebar);

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reduxForm = __webpack_require__(589);
	
	var _Reference = __webpack_require__(1972);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	var _List = __webpack_require__(1945);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _EditHeader = __webpack_require__(1924);
	
	var _EditHeader2 = _interopRequireDefault(_EditHeader);
	
	var _EditableReferenceHeader = __webpack_require__(1954);
	
	var _EditableReferenceHeader2 = _interopRequireDefault(_EditableReferenceHeader);
	
	var _Detail = __webpack_require__(1955);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _FieldTypeDetail = __webpack_require__(1992);
	
	var _FieldTypeDetail2 = _interopRequireDefault(_FieldTypeDetail);
	
	var _UsefulQuestions = __webpack_require__(1979);
	
	var _UsefulQuestions2 = _interopRequireDefault(_UsefulQuestions);
	
	var _utils = __webpack_require__(1920);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var interestingQuestions = function interestingQuestions(table, field) {
	    return [{
	        text: "Number of " + (table && table.display_name) + " grouped by " + field.display_name,
	        icon: { name: "number", scale: 1, viewBox: "8 8 16 16" },
	        link: (0, _utils.getQuestionUrl)({
	            dbId: table && table.db_id,
	            tableId: table.id,
	            fieldId: field.id,
	            getCount: true
	        })
	    }, {
	        text: "All distinct values of " + field.display_name,
	        icon: "table2",
	        link: (0, _utils.getQuestionUrl)({
	            dbId: table && table.db_id,
	            tableId: table.id,
	            fieldId: field.id
	        })
	    }];
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var entity = (0, _selectors.getFieldBySegment)(state, props) || {};
	    var guide = (0, _selectors.getGuide)(state, props);
	    var fields = (0, _selectors.getFields)(state, props);
	
	    var initialValues = {
	        important_fields: guide && guide.metric_important_fields && guide.metric_important_fields[entity.id] && guide.metric_important_fields[entity.id].map(function (fieldId) {
	            return fields[fieldId];
	        }) || []
	    };
	
	    return {
	        entity: entity,
	        table: (0, _selectors.getTable)(state, props),
	        guide: guide,
	        loading: (0, _selectors.getLoading)(state, props),
	        // naming this 'error' will conflict with redux form
	        loadingError: (0, _selectors.getError)(state, props),
	        user: (0, _selectors.getUser)(state, props),
	        foreignKeys: (0, _selectors.getForeignKeys)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        isFormulaExpanded: (0, _selectors.getIsFormulaExpanded)(state, props),
	        initialValues: initialValues
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var validate = function validate(values, props) {
	    return {};
	};
	
	var SegmentFieldDetail = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reduxForm.reduxForm)({
	    form: 'details',
	    fields: ['name', 'display_name', 'description', 'revision_message', 'points_of_interest', 'caveats', 'special_type', 'fk_target_field_id'],
	    validate: validate
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    _inherits(SegmentFieldDetail, _Component);
	
	    function SegmentFieldDetail() {
	        _classCallCheck(this, SegmentFieldDetail);
	
	        return _possibleConstructorReturn(this, (SegmentFieldDetail.__proto__ || Object.getPrototypeOf(SegmentFieldDetail)).apply(this, arguments));
	    }
	
	    _createClass(SegmentFieldDetail, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$fields = _props.fields,
	                name = _props$fields.name,
	                display_name = _props$fields.display_name,
	                description = _props$fields.description,
	                revision_message = _props$fields.revision_message,
	                points_of_interest = _props$fields.points_of_interest,
	                caveats = _props$fields.caveats,
	                special_type = _props$fields.special_type,
	                fk_target_field_id = _props$fields.fk_target_field_id,
	                style = _props.style,
	                entity = _props.entity,
	                table = _props.table,
	                loadingError = _props.loadingError,
	                loading = _props.loading,
	                user = _props.user,
	                foreignKeys = _props.foreignKeys,
	                isEditing = _props.isEditing,
	                startEditing = _props.startEditing,
	                endEditing = _props.endEditing,
	                handleSubmit = _props.handleSubmit,
	                resetForm = _props.resetForm,
	                submitting = _props.submitting;
	
	
	            var onSubmit = handleSubmit(function () {
	                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(fields) {
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    _context.next = 2;
	                                    return actions.rUpdateSegmentFieldDetail(fields, _this2.props);
	
	                                case 2:
	                                    return _context.abrupt("return", _context.sent);
	
	                                case 3:
	                                case "end":
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                    return _ref.apply(this, arguments);
	                };
	            }());
	
	            return _react2.default.createElement(
	                "form",
	                { style: style, className: "full",
	                    onSubmit: onSubmit
	                },
	                isEditing && _react2.default.createElement(_EditHeader2.default, {
	                    hasRevisionHistory: false,
	                    onSubmit: onSubmit,
	                    endEditing: endEditing,
	                    reinitializeForm: resetForm,
	                    submitting: submitting,
	                    revisionMessageFormField: revision_message
	                }),
	                _react2.default.createElement(_EditableReferenceHeader2.default, {
	                    entity: entity,
	                    table: table,
	                    headerIcon: "field",
	                    name: "Details",
	                    type: "field",
	                    user: user,
	                    isEditing: isEditing,
	                    hasSingleSchema: false,
	                    hasDisplayName: true,
	                    startEditing: startEditing,
	                    displayNameFormField: display_name,
	                    nameFormField: name
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List2.default,
	                                null,
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "description",
	                                        name: "Description",
	                                        description: entity.description,
	                                        placeholder: "No description yet",
	                                        isEditing: isEditing,
	                                        field: description
	                                    })
	                                ),
	                                !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "name",
	                                        name: "Actual name in database",
	                                        description: entity.name,
	                                        subtitleClass: _Reference2.default.tableActualName
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "points_of_interest",
	                                        name: "Why this field is interesting",
	                                        description: entity.points_of_interest,
	                                        placeholder: "Nothing interesting yet",
	                                        isEditing: isEditing,
	                                        field: points_of_interest
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "caveats",
	                                        name: "Things to be aware of about this field",
	                                        description: entity.caveats,
	                                        placeholder: "Nothing to be aware of yet",
	                                        isEditing: isEditing,
	                                        field: caveats
	                                    })
	                                ),
	                                !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "base_type",
	                                        name: "Data type",
	                                        description: entity.base_type
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_FieldTypeDetail2.default, {
	                                        field: entity,
	                                        foreignKeys: foreignKeys,
	                                        fieldTypeFormField: special_type,
	                                        foreignKeyFormField: fk_target_field_id,
	                                        isEditing: isEditing
	                                    })
	                                ),
	                                !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_UsefulQuestions2.default, { questions: interestingQuestions(_this2.props.table, _this2.props.entity) })
	                                )
	                            )
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return SegmentFieldDetail;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entity: _propTypes2.default.object.isRequired,
	    table: _propTypes2.default.object,
	    user: _propTypes2.default.object.isRequired,
	    foreignKeys: _propTypes2.default.object,
	    isEditing: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func.isRequired,
	    endEditing: _propTypes2.default.func.isRequired,
	    startLoading: _propTypes2.default.func.isRequired,
	    endLoading: _propTypes2.default.func.isRequired,
	    setError: _propTypes2.default.func.isRequired,
	    updateField: _propTypes2.default.func.isRequired,
	    handleSubmit: _propTypes2.default.func.isRequired,
	    resetForm: _propTypes2.default.func.isRequired,
	    fields: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool
	}, _temp)) || _class) || _class);
	SegmentFieldDetail.displayName = "SegmentFieldDetail";
	exports.default = SegmentFieldDetail;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icepick = __webpack_require__(855);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _core = __webpack_require__(1831);
	
	var MetabaseCore = _interopRequireWildcard(_core);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _types = __webpack_require__(868);
	
	var _Select = __webpack_require__(1057);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Detail = __webpack_require__(1956);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldTypeDetail = function FieldTypeDetail(_ref) {
	    var field = _ref.field,
	        foreignKeys = _ref.foreignKeys,
	        fieldTypeFormField = _ref.fieldTypeFormField,
	        foreignKeyFormField = _ref.foreignKeyFormField,
	        isEditing = _ref.isEditing;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_Detail2.default.detail) },
	        _react2.default.createElement(
	            "div",
	            { className: _Detail2.default.detailBody },
	            _react2.default.createElement(
	                "div",
	                { className: _Detail2.default.detailTitle },
	                _react2.default.createElement(
	                    "span",
	                    { className: _Detail2.default.detailName },
	                    "Field type"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: (0, _classnames2.default)(_Detail2.default.detailSubtitle, { "mt1": true }) },
	                _react2.default.createElement(
	                    "span",
	                    null,
	                    isEditing ? _react2.default.createElement(_Select2.default, {
	                        triggerClasses: "rounded bordered p1 inline-block",
	                        placeholder: "Select a field type",
	                        value: MetabaseCore.field_special_types_map[fieldTypeFormField.value] || MetabaseCore.field_special_types_map[field.special_type],
	                        options: MetabaseCore.field_special_types.concat({
	                            'id': null,
	                            'name': 'No field type',
	                            'section': 'Other'
	                        }).filter(function (type) {
	                            return !(0, _schema_metadata.isNumericBaseType)(field) ? !(type.id && type.id.startsWith("timestamp_")) : true;
	                        }),
	                        onChange: function onChange(type) {
	                            return fieldTypeFormField.onChange(type.id);
	                        }
	                    }) : _react2.default.createElement(
	                        "span",
	                        null,
	                        (0, _icepick.getIn)(MetabaseCore.field_special_types_map, [field.special_type, 'name']) || 'No field type'
	                    )
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: "ml4" },
	                    isEditing ? ((0, _types.isFK)(fieldTypeFormField.value) || (0, _types.isFK)(field.special_type) && fieldTypeFormField.value === undefined) && _react2.default.createElement(_Select2.default, {
	                        triggerClasses: "rounded bordered p1 inline-block",
	                        placeholder: "Select a field type",
	                        value: foreignKeys[foreignKeyFormField.value] || foreignKeys[field.fk_target_field_id] || { name: "Select a Foreign Key" },
	                        options: Object.values(foreignKeys),
	                        onChange: function onChange(foreignKey) {
	                            return foreignKeyFormField.onChange(foreignKey.id);
	                        },
	                        optionNameFn: function optionNameFn(foreignKey) {
	                            return foreignKey.name;
	                        }
	                    }) : (0, _types.isFK)(field.special_type) && _react2.default.createElement(
	                        "span",
	                        null,
	                        (0, _icepick.getIn)(foreignKeys, [field.fk_target_field_id, "name"])
	                    )
	                )
	            )
	        )
	    );
	};
	FieldTypeDetail.displayName = "FieldTypeDetail";
	FieldTypeDetail.propTypes = {
	    field: _propTypes2.default.object.isRequired,
	    foreignKeys: _propTypes2.default.object.isRequired,
	    fieldTypeFormField: _propTypes2.default.object.isRequired,
	    foreignKeyFormField: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool.isRequired
	};
	
	exports.default = (0, _pure2.default)(FieldTypeDetail);

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _BaseSidebar = __webpack_require__(1937);
	
	var _BaseSidebar2 = _interopRequireDefault(_BaseSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _DatabaseList = __webpack_require__(1994);
	
	var _DatabaseList2 = _interopRequireDefault(_DatabaseList);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var DatabaseListContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(DatabaseListContainer, _Component);
	
	    function DatabaseListContainer() {
	        _classCallCheck(this, DatabaseListContainer);
	
	        return _possibleConstructorReturn(this, (DatabaseListContainer.__proto__ || Object.getPrototypeOf(DatabaseListContainer)).apply(this, arguments));
	    }
	
	    _createClass(DatabaseListContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchDatabases(this.props);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var isEditing = this.props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_BaseSidebar2.default, null)
	                },
	                _react2.default.createElement(_DatabaseList2.default, this.props)
	            );
	        }
	    }]);
	
	    return DatabaseListContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	DatabaseListContainer.displayName = 'DatabaseListContainer';
	exports.default = DatabaseListContainer;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _table = __webpack_require__(871);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _List3 = __webpack_require__(1945);
	
	var _List4 = _interopRequireDefault(_List3);
	
	var _ListItem = __webpack_require__(1946);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _AdminAwareEmptyState = __webpack_require__(1947);
	
	var _AdminAwareEmptyState2 = _interopRequireDefault(_AdminAwareEmptyState);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _ReferenceHeader = __webpack_require__(1948);
	
	var _ReferenceHeader2 = _interopRequireDefault(_ReferenceHeader);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyStateData = {
	    title: "Metabase is no fun without any data",
	    adminMessage: "Your databases will appear here once you connect one",
	    message: "Databases will appear here once your admins have added some",
	    image: "app/assets/img/databases-list",
	    adminAction: "Connect a database",
	    adminLink: "/admin/databases/create"
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        entities: (0, _selectors.getDatabases)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        loadingError: (0, _selectors.getError)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions);
	
	var DatabaseList = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(DatabaseList, _Component);
	
	    function DatabaseList() {
	        _classCallCheck(this, DatabaseList);
	
	        return _possibleConstructorReturn(this, (DatabaseList.__proto__ || Object.getPrototypeOf(DatabaseList)).apply(this, arguments));
	    }
	
	    _createClass(DatabaseList, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                entities = _props.entities,
	                style = _props.style,
	                loadingError = _props.loadingError,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                "div",
	                { style: style, className: "full" },
	                _react2.default.createElement(_ReferenceHeader2.default, {
	                    name: "Databases and tables"
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return Object.keys(entities).length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List4.default,
	                                null,
	                                Object.values(entities).filter(_table.isQueryable).map(function (entity, index) {
	                                    return entity && entity.id && entity.name && _react2.default.createElement(
	                                        "li",
	                                        { className: "relative", key: entity.id },
	                                        _react2.default.createElement(_ListItem2.default, {
	                                            id: entity.id,
	                                            index: index,
	                                            name: entity.display_name || entity.name,
	                                            description: entity.description,
	                                            url: "/reference/databases/" + entity.id,
	                                            icon: "database"
	                                        })
	                                    );
	                                })
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_AdminAwareEmptyState2.default, emptyStateData)
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return DatabaseList;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entities: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object
	}, _temp)) || _class);
	DatabaseList.displayName = "DatabaseList";
	exports.default = DatabaseList;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _DatabaseSidebar = __webpack_require__(1996);
	
	var _DatabaseSidebar2 = _interopRequireDefault(_DatabaseSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _DatabaseDetail = __webpack_require__(1997);
	
	var _DatabaseDetail2 = _interopRequireDefault(_DatabaseDetail);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        database: (0, _selectors.getDatabase)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var DatabaseDetailContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(DatabaseDetailContainer, _Component);
	
	    function DatabaseDetailContainer() {
	        _classCallCheck(this, DatabaseDetailContainer);
	
	        return _possibleConstructorReturn(this, (DatabaseDetailContainer.__proto__ || Object.getPrototypeOf(DatabaseDetailContainer)).apply(this, arguments));
	    }
	
	    _createClass(DatabaseDetailContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchDatabaseMetadata(this.props, this.props.databaseId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                database = _props.database,
	                isEditing = _props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_DatabaseSidebar2.default, { database: database })
	                },
	                _react2.default.createElement(_DatabaseDetail2.default, this.props)
	            );
	        }
	    }]);
	
	    return DatabaseDetailContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    database: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	DatabaseDetailContainer.displayName = 'DatabaseDetailContainer';
	exports.default = DatabaseDetailContainer;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Sidebar = __webpack_require__(1938);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _SidebarItem = __webpack_require__(1940);
	
	var _SidebarItem2 = _interopRequireDefault(_SidebarItem);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatabaseSidebar = function DatabaseSidebar(_ref) {
	    var database = _ref.database,
	        style = _ref.style,
	        className = _ref.className;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_Sidebar2.default.sidebar, className), style: style },
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: _Sidebar2.default.breadcrumbs },
	                _react2.default.createElement(_Breadcrumbs2.default, {
	                    className: "py4",
	                    crumbs: [["Databases", "/reference/databases"], [database.name]],
	                    inSidebar: true,
	                    placeholder: "Data Reference"
	                })
	            ),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/databases/" + database.id,
	                href: "/reference/databases/" + database.id,
	                icon: "document",
	                name: "Details" }),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/databases/" + database.id + "/tables",
	                href: "/reference/databases/" + database.id + "/tables",
	                icon: "table2",
	                name: "Tables in " + database.name })
	        )
	    );
	}; /* eslint "react/prop-types": "warn" */
	DatabaseSidebar.displayName = "DatabaseSidebar";
	
	DatabaseSidebar.propTypes = {
	    database: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object
	};
	
	exports.default = (0, _pure2.default)(DatabaseSidebar);

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reduxForm = __webpack_require__(589);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _List = __webpack_require__(1945);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _EditHeader = __webpack_require__(1924);
	
	var _EditHeader2 = _interopRequireDefault(_EditHeader);
	
	var _EditableReferenceHeader = __webpack_require__(1954);
	
	var _EditableReferenceHeader2 = _interopRequireDefault(_EditableReferenceHeader);
	
	var _Detail = __webpack_require__(1955);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var entity = (0, _selectors.getDatabase)(state, props) || {};
	    var fields = (0, _selectors.getFields)(state, props);
	
	    return {
	        entity: entity,
	        table: (0, _selectors.getTable)(state, props),
	        metadataFields: fields,
	        loading: (0, _selectors.getLoading)(state, props),
	        // naming this 'error' will conflict with redux form
	        loadingError: (0, _selectors.getError)(state, props),
	        user: (0, _selectors.getUser)(state, props),
	        foreignKeys: (0, _selectors.getForeignKeys)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        isFormulaExpanded: (0, _selectors.getIsFormulaExpanded)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions, {
	    onChangeLocation: _reactRouterRedux.push
	});
	
	var validate = function validate(values, props) {
	    return {};
	};
	
	var DatabaseDetail = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reduxForm.reduxForm)({
	    form: 'details',
	    fields: ['name', 'display_name', 'description', 'revision_message', 'points_of_interest', 'caveats'],
	    validate: validate
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    _inherits(DatabaseDetail, _Component);
	
	    function DatabaseDetail() {
	        _classCallCheck(this, DatabaseDetail);
	
	        return _possibleConstructorReturn(this, (DatabaseDetail.__proto__ || Object.getPrototypeOf(DatabaseDetail)).apply(this, arguments));
	    }
	
	    _createClass(DatabaseDetail, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$fields = _props.fields,
	                name = _props$fields.name,
	                display_name = _props$fields.display_name,
	                description = _props$fields.description,
	                revision_message = _props$fields.revision_message,
	                points_of_interest = _props$fields.points_of_interest,
	                caveats = _props$fields.caveats,
	                style = _props.style,
	                entity = _props.entity,
	                table = _props.table,
	                loadingError = _props.loadingError,
	                loading = _props.loading,
	                user = _props.user,
	                isEditing = _props.isEditing,
	                startEditing = _props.startEditing,
	                endEditing = _props.endEditing,
	                handleSubmit = _props.handleSubmit,
	                resetForm = _props.resetForm,
	                submitting = _props.submitting;
	
	
	            var onSubmit = handleSubmit(function () {
	                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(fields) {
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    _context.next = 2;
	                                    return actions.rUpdateDatabaseDetail(fields, _this2.props);
	
	                                case 2:
	                                    return _context.abrupt("return", _context.sent);
	
	                                case 3:
	                                case "end":
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                    return _ref.apply(this, arguments);
	                };
	            }());
	
	            return _react2.default.createElement(
	                "form",
	                { style: style, className: "full",
	                    onSubmit: onSubmit
	                },
	                isEditing && _react2.default.createElement(_EditHeader2.default, {
	                    hasRevisionHistory: false,
	                    onSubmit: onSubmit,
	                    endEditing: endEditing,
	                    reinitializeForm: resetForm,
	                    submitting: submitting,
	                    revisionMessageFormField: revision_message
	                }),
	                _react2.default.createElement(_EditableReferenceHeader2.default, {
	                    entity: entity,
	                    table: table,
	                    type: "database",
	                    headerIcon: "database",
	                    name: "Details",
	                    user: user,
	                    isEditing: isEditing,
	                    hasSingleSchema: false,
	                    hasDisplayName: false,
	                    startEditing: startEditing,
	                    displayNameFormField: display_name,
	                    nameFormField: name
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List2.default,
	                                null,
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "description",
	                                        name: "Description",
	                                        description: entity.description,
	                                        placeholder: "No description yet",
	                                        isEditing: isEditing,
	                                        field: description
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "points_of_interest",
	                                        name: "Why this database is interesting",
	                                        description: entity.points_of_interest,
	                                        placeholder: "Nothing interesting yet",
	                                        isEditing: isEditing,
	                                        field: points_of_interest
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "caveats",
	                                        name: "Things to be aware of about this database",
	                                        description: entity.caveats,
	                                        placeholder: "Nothing to be aware of yet",
	                                        isEditing: isEditing,
	                                        field: caveats
	                                    })
	                                )
	                            )
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return DatabaseDetail;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entity: _propTypes2.default.object.isRequired,
	    table: _propTypes2.default.object,
	    user: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func.isRequired,
	    endEditing: _propTypes2.default.func.isRequired,
	    startLoading: _propTypes2.default.func.isRequired,
	    endLoading: _propTypes2.default.func.isRequired,
	    setError: _propTypes2.default.func.isRequired,
	    updateField: _propTypes2.default.func.isRequired,
	    handleSubmit: _propTypes2.default.func.isRequired,
	    resetForm: _propTypes2.default.func.isRequired,
	    fields: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool
	}, _temp)) || _class) || _class);
	DatabaseDetail.displayName = "DatabaseDetail";
	exports.default = DatabaseDetail;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _DatabaseSidebar = __webpack_require__(1996);
	
	var _DatabaseSidebar2 = _interopRequireDefault(_DatabaseSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _TableList = __webpack_require__(1999);
	
	var _TableList2 = _interopRequireDefault(_TableList);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        database: (0, _selectors.getDatabase)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var TableListContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(TableListContainer, _Component);
	
	    function TableListContainer() {
	        _classCallCheck(this, TableListContainer);
	
	        return _possibleConstructorReturn(this, (TableListContainer.__proto__ || Object.getPrototypeOf(TableListContainer)).apply(this, arguments));
	    }
	
	    _createClass(TableListContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchDatabaseMetadata(this.props, this.props.databaseId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                database = _props.database,
	                isEditing = _props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_DatabaseSidebar2.default, { database: database })
	                },
	                _react2.default.createElement(_TableList2.default, this.props)
	            );
	        }
	    }]);
	
	    return TableListContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    database: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	TableListContainer.displayName = 'TableListContainer';
	exports.default = TableListContainer;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.separateTablesBySchema = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _table = __webpack_require__(871);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Reference = __webpack_require__(1972);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	var _List3 = __webpack_require__(1945);
	
	var _List4 = _interopRequireDefault(_List3);
	
	var _ListItem = __webpack_require__(1946);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _ReferenceHeader = __webpack_require__(1948);
	
	var _ReferenceHeader2 = _interopRequireDefault(_ReferenceHeader);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyStateData = {
	    message: "Tables in this database will appear here as they're added",
	    icon: "table2"
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        database: (0, _selectors.getDatabase)(state, props),
	        entities: (0, _selectors.getTablesByDatabase)(state, props),
	        hasSingleSchema: (0, _selectors.getHasSingleSchema)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        loadingError: (0, _selectors.getError)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions);
	
	var createListItem = function createListItem(entity, index) {
	    return _react2.default.createElement(
	        "li",
	        { className: "relative", key: entity.id },
	        _react2.default.createElement(_ListItem2.default, {
	            id: entity.id,
	            index: index,
	            name: entity.display_name || entity.name,
	            description: entity.description,
	            url: "/reference/databases/" + entity.db_id + "/tables/" + entity.id,
	            icon: "table2"
	        })
	    );
	};
	
	createListItem.displayName = "createListItem";
	var createSchemaSeparator = function createSchemaSeparator(entity) {
	    return _react2.default.createElement(
	        "li",
	        { className: _Reference2.default.schemaSeparator },
	        entity.schema
	    );
	};
	
	createSchemaSeparator.displayName = "createSchemaSeparator";
	var separateTablesBySchema = exports.separateTablesBySchema = function separateTablesBySchema(tables, createSchemaSeparator, createListItem) {
	    return Object.values(tables).sort(function (table1, table2) {
	        return table1.schema > table2.schema ? 1 : table1.schema === table2.schema ? 0 : -1;
	    }).map(function (table, index, sortedTables) {
	        if (!table || !table.id || !table.name) {
	            return;
	        }
	        // add schema header for first element and if schema is different from previous
	        var previousTableId = Object.keys(sortedTables)[index - 1];
	        return index === 0 || sortedTables[previousTableId].schema !== table.schema ? [createSchemaSeparator(table), createListItem(table, index)] : createListItem(table, index);
	    });
	};
	
	var TableList = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(TableList, _Component);
	
	    function TableList() {
	        _classCallCheck(this, TableList);
	
	        return _possibleConstructorReturn(this, (TableList.__proto__ || Object.getPrototypeOf(TableList)).apply(this, arguments));
	    }
	
	    _createClass(TableList, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                entities = _props.entities,
	                style = _props.style,
	                database = _props.database,
	                hasSingleSchema = _props.hasSingleSchema,
	                loadingError = _props.loadingError,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                "div",
	                { style: style, className: "full" },
	                _react2.default.createElement(_ReferenceHeader2.default, {
	                    name: "Tables in " + database.name,
	                    type: "tables",
	                    headerIcon: "database"
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return Object.keys(entities).length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List4.default,
	                                null,
	                                !hasSingleSchema ? separateTablesBySchema(entities, createSchemaSeparator, createListItem) : Object.values(entities).filter(_table.isQueryable).map(function (entity, index) {
	                                    return entity && entity.id && entity.name && createListItem(entity, index);
	                                })
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_EmptyState2.default, emptyStateData)
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TableList;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entities: _propTypes2.default.object.isRequired,
	    database: _propTypes2.default.object.isRequired,
	    hasSingleSchema: _propTypes2.default.bool,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object
	}, _temp)) || _class);
	TableList.displayName = "TableList";
	exports.default = TableList;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _TableSidebar = __webpack_require__(2001);
	
	var _TableSidebar2 = _interopRequireDefault(_TableSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _TableDetail = __webpack_require__(2002);
	
	var _TableDetail2 = _interopRequireDefault(_TableDetail);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	var _selectors2 = __webpack_require__(2003);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        database: (0, _selectors.getDatabase)(state, props),
	        table: (0, _selectors.getTable)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        showXray: (0, _selectors2.getXrayEnabled)(state)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var TableDetailContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(TableDetailContainer, _Component);
	
	    function TableDetailContainer() {
	        _classCallCheck(this, TableDetailContainer);
	
	        return _possibleConstructorReturn(this, (TableDetailContainer.__proto__ || Object.getPrototypeOf(TableDetailContainer)).apply(this, arguments));
	    }
	
	    _createClass(TableDetailContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchDatabaseMetadata(this.props, this.props.databaseId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                database = _props.database,
	                table = _props.table,
	                isEditing = _props.isEditing,
	                showXray = _props.showXray;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	
	                    sidebar: _react2.default.createElement(_TableSidebar2.default, { database: database, table: table, showXray: showXray })
	                },
	                _react2.default.createElement(_TableDetail2.default, this.props)
	            );
	        }
	    }]);
	
	    return TableDetailContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    database: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    table: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool,
	    showXray: _propTypes2.default.bool
	}, _temp)) || _class);
	TableDetailContainer.displayName = 'TableDetailContainer';
	exports.default = TableDetailContainer;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Sidebar = __webpack_require__(1938);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _SidebarItem = __webpack_require__(1940);
	
	var _SidebarItem2 = _interopRequireDefault(_SidebarItem);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableSidebar = function TableSidebar(_ref) {
	    var database = _ref.database,
	        table = _ref.table,
	        style = _ref.style,
	        className = _ref.className,
	        showXray = _ref.showXray;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_Sidebar2.default.sidebar, className), style: style },
	        _react2.default.createElement(
	            "div",
	            { className: _Sidebar2.default.breadcrumbs },
	            _react2.default.createElement(_Breadcrumbs2.default, {
	                className: "py4",
	                crumbs: [["Databases", "/reference/databases"], [database.name, "/reference/databases/" + database.id], [table.name]],
	                inSidebar: true,
	                placeholder: "Data Reference"
	            })
	        ),
	        _react2.default.createElement(
	            "ol",
	            null,
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/databases/" + database.id + "/tables/" + table.id,
	                href: "/reference/databases/" + database.id + "/tables/" + table.id,
	                icon: "document",
	                name: "Details" }),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/databases/" + database.id + "/tables/" + table.id + "/fields",
	                href: "/reference/databases/" + database.id + "/tables/" + table.id + "/fields",
	                icon: "fields",
	                name: "Fields in this table" }),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/databases/" + database.id + "/tables/" + table.id + "/questions",
	                href: "/reference/databases/" + database.id + "/tables/" + table.id + "/questions",
	                icon: "all",
	                name: "Questions about this table" }),
	            showXray && _react2.default.createElement(_SidebarItem2.default, { key: "/xray/table/" + table.id + "/approximate",
	                href: "/xray/table/" + table.id + "/approximate",
	                icon: "beaker",
	                name: "X-ray this table" })
	        )
	    );
	}; /* eslint "react/prop-types": "warn" */
	TableSidebar.displayName = "TableSidebar";
	
	
	TableSidebar.propTypes = {
	    database: _propTypes2.default.object,
	    table: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    showXray: _propTypes2.default.bool
	};
	
	exports.default = (0, _pure2.default)(TableSidebar);

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reduxForm = __webpack_require__(589);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _Reference = __webpack_require__(1972);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	var _List = __webpack_require__(1945);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _EditHeader = __webpack_require__(1924);
	
	var _EditHeader2 = _interopRequireDefault(_EditHeader);
	
	var _EditableReferenceHeader = __webpack_require__(1954);
	
	var _EditableReferenceHeader2 = _interopRequireDefault(_EditableReferenceHeader);
	
	var _Detail = __webpack_require__(1955);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _UsefulQuestions = __webpack_require__(1979);
	
	var _UsefulQuestions2 = _interopRequireDefault(_UsefulQuestions);
	
	var _utils = __webpack_require__(1920);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var interestingQuestions = function interestingQuestions(table) {
	    return [{
	        text: "Count of " + table.display_name,
	        icon: { name: "number", scale: 1, viewBox: "8 8 16 16" },
	        link: (0, _utils.getQuestionUrl)({
	            dbId: table.db_id,
	            tableId: table.id,
	            getCount: true
	        })
	    }, {
	        text: "See raw data for " + table.display_name,
	        icon: "table2",
	        link: (0, _utils.getQuestionUrl)({
	            dbId: table.db_id,
	            tableId: table.id
	        })
	    }];
	};
	var mapStateToProps = function mapStateToProps(state, props) {
	    var entity = (0, _selectors.getTable)(state, props) || {};
	    var fields = (0, _selectors.getFields)(state, props);
	
	    return {
	        entity: entity,
	        table: (0, _selectors.getTable)(state, props),
	        metadataFields: fields,
	        loading: (0, _selectors.getLoading)(state, props),
	        // naming this 'error' will conflict with redux form
	        loadingError: (0, _selectors.getError)(state, props),
	        user: (0, _selectors.getUser)(state, props),
	        foreignKeys: (0, _selectors.getForeignKeys)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        hasSingleSchema: (0, _selectors.getHasSingleSchema)(state, props),
	        isFormulaExpanded: (0, _selectors.getIsFormulaExpanded)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions, {
	    onChangeLocation: _reactRouterRedux.push
	});
	
	var validate = function validate(values, props) {
	    return {};
	};
	
	var TableDetail = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reduxForm.reduxForm)({
	    form: 'details',
	    fields: ['name', 'display_name', 'description', 'revision_message', 'points_of_interest', 'caveats'],
	    validate: validate
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    _inherits(TableDetail, _Component);
	
	    function TableDetail() {
	        _classCallCheck(this, TableDetail);
	
	        return _possibleConstructorReturn(this, (TableDetail.__proto__ || Object.getPrototypeOf(TableDetail)).apply(this, arguments));
	    }
	
	    _createClass(TableDetail, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$fields = _props.fields,
	                name = _props$fields.name,
	                display_name = _props$fields.display_name,
	                description = _props$fields.description,
	                revision_message = _props$fields.revision_message,
	                points_of_interest = _props$fields.points_of_interest,
	                caveats = _props$fields.caveats,
	                style = _props.style,
	                entity = _props.entity,
	                table = _props.table,
	                loadingError = _props.loadingError,
	                loading = _props.loading,
	                user = _props.user,
	                isEditing = _props.isEditing,
	                startEditing = _props.startEditing,
	                endEditing = _props.endEditing,
	                hasSingleSchema = _props.hasSingleSchema,
	                handleSubmit = _props.handleSubmit,
	                resetForm = _props.resetForm,
	                submitting = _props.submitting;
	
	
	            var onSubmit = handleSubmit(function () {
	                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(fields) {
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    _context.next = 2;
	                                    return actions.rUpdateTableDetail(fields, _this2.props);
	
	                                case 2:
	                                    return _context.abrupt("return", _context.sent);
	
	                                case 3:
	                                case "end":
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                    return _ref.apply(this, arguments);
	                };
	            }());
	
	            return _react2.default.createElement(
	                "form",
	                { style: style, className: "full",
	                    onSubmit: onSubmit
	                },
	                isEditing && _react2.default.createElement(_EditHeader2.default, {
	                    hasRevisionHistory: false,
	                    onSubmit: onSubmit,
	                    endEditing: endEditing,
	                    reinitializeForm: resetForm,
	                    submitting: submitting,
	                    revisionMessageFormField: revision_message
	                }),
	                _react2.default.createElement(_EditableReferenceHeader2.default, {
	                    entity: entity,
	                    table: table,
	                    type: "table",
	                    headerIcon: "table2",
	                    headerLink: (0, _utils.getQuestionUrl)({ dbId: entity.db_id, tableId: entity.id }),
	                    name: "Details",
	                    user: user,
	                    isEditing: isEditing,
	                    hasSingleSchema: hasSingleSchema,
	                    hasDisplayName: true,
	                    startEditing: startEditing,
	                    displayNameFormField: display_name,
	                    nameFormField: name
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List2.default,
	                                null,
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "description",
	                                        name: "Description",
	                                        description: entity.description,
	                                        placeholder: "No description yet",
	                                        isEditing: isEditing,
	                                        field: description
	                                    })
	                                ),
	                                !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "name",
	                                        name: "Actual name in database",
	                                        description: entity.name,
	                                        subtitleClass: _Reference2.default.tableActualName
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "points_of_interest",
	                                        name: "Why this table is interesting",
	                                        description: entity.points_of_interest,
	                                        placeholder: "Nothing interesting yet",
	                                        isEditing: isEditing,
	                                        field: points_of_interest
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "caveats",
	                                        name: "Things to be aware of about this table",
	                                        description: entity.caveats,
	                                        placeholder: "Nothing to be aware of yet",
	                                        isEditing: isEditing,
	                                        field: caveats
	                                    })
	                                ),
	                                !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_UsefulQuestions2.default, { questions: interestingQuestions(_this2.props.table) })
	                                )
	                            )
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TableDetail;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entity: _propTypes2.default.object.isRequired,
	    table: _propTypes2.default.object,
	    user: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func.isRequired,
	    endEditing: _propTypes2.default.func.isRequired,
	    startLoading: _propTypes2.default.func.isRequired,
	    endLoading: _propTypes2.default.func.isRequired,
	    setError: _propTypes2.default.func.isRequired,
	    updateField: _propTypes2.default.func.isRequired,
	    handleSubmit: _propTypes2.default.func.isRequired,
	    resetForm: _propTypes2.default.func.isRequired,
	    fields: _propTypes2.default.object.isRequired,
	    hasSingleSchema: _propTypes2.default.bool,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool
	}, _temp)) || _class) || _class);
	TableDetail.displayName = "TableDetail";
	exports.default = TableDetail;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getMaxCost = exports.getXrayEnabled = exports.getTableItem = exports.getSegmentItem = exports.getTitle = exports.getComparisonContributors = exports.getComparisonFields = exports.getComparison = exports.getConstituents = exports.getFeatures = exports.getXray = exports.getError = exports.getLoadingStatus = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__(1072);
	
	var _colors = __webpack_require__(881);
	
	var getLoadingStatus = exports.getLoadingStatus = function getLoadingStatus(state) {
	    return state.xray.loading;
	};
	
	var getError = exports.getError = function getError(state) {
	    return state.xray.error;
	};
	
	var getXray = exports.getXray = function getXray(state) {
	    return state.xray.xray;
	};
	
	var getFeatures = exports.getFeatures = function getFeatures(state) {
	    return state.xray.xray && state.xray.xray.features;
	};
	
	var getConstituents = exports.getConstituents = (0, _reselect.createSelector)([getXray], function (xray) {
	    return xray && Object.values(xray.constituents);
	});
	
	var getComparison = exports.getComparison = function getComparison(state) {
	    return state.xray.comparison;
	};
	
	var getComparisonFields = exports.getComparisonFields = (0, _reselect.createSelector)([getComparison], function (comparison) {
	    if (comparison) {
	        return Object.keys(comparison.constituents[0].constituents).map(function (key) {
	            return _extends({}, comparison.constituents[0].constituents[key].field, {
	                distance: comparison.comparison[key].distance
	            });
	        });
	    }
	});
	
	var getComparisonContributors = exports.getComparisonContributors = (0, _reselect.createSelector)([getComparison], function (comparison) {
	    if (comparison) {
	
	        var getValue = function getValue(constituent, _ref) {
	            var field = _ref.field,
	                feature = _ref.feature;
	
	            return constituent.constituents[field][feature].value;
	        };
	
	        var genContributor = function genContributor(_ref2) {
	            var field = _ref2.field,
	                feature = _ref2.feature;
	            return {
	                field: comparison.constituents[0].constituents[field],
	                feature: _extends({}, comparison.constituents[0].constituents[field][feature], {
	                    value: {
	                        a: getValue(comparison.constituents[0], { field: field, feature: feature }),
	                        b: getValue(comparison.constituents[1], { field: field, feature: feature })
	                    },
	                    type: feature
	                })
	            };
	        };
	
	        var top = comparison['top-contributors'];
	
	        return top && top.map(genContributor);
	    }
	});
	
	var getTitle = exports.getTitle = function getTitle(_ref3) {
	    var comparison = _ref3.comparison,
	        itemA = _ref3.itemA,
	        itemB = _ref3.itemB;
	    return comparison && itemA.name + ' / ' + itemB.name;
	};
	
	var getItemColor = function getItemColor(index) {
	    return {
	        main: index === 0 ? _colors.normal.teal : _colors.normal.purple,
	        text: index === 0 ? '#57C5DA' : _colors.normal.purple
	    };
	};
	
	var genItem = function genItem(item, itemType, index) {
	    return {
	        name: item.name,
	        id: item.id,
	        itemType: itemType,
	        color: getItemColor(index)
	    };
	};
	
	var getSegmentItem = exports.getSegmentItem = function getSegmentItem(state) {
	    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return (0, _reselect.createSelector)([getComparison], function (comparison) {
	        if (comparison) {
	            var item = comparison.constituents[index].features.segment;
	            return _extends({}, genItem(item, 'segment', index), {
	                constituents: comparison.constituents[index].constituents
	            });
	        }
	    })(state);
	};
	
	var getTableItem = exports.getTableItem = function getTableItem(state) {
	    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	    return (0, _reselect.createSelector)([getComparison], function (comparison) {
	        if (comparison) {
	            var item = comparison.constituents[index].features.table;
	            return _extends({}, genItem(item, 'table', index), {
	                name: item.display_name,
	                constituents: comparison.constituents[index].constituents
	
	            });
	        }
	    })(state);
	};
	
	// see if xrays are enabled. unfortunately enabled can equal null so its enabled if its not false
	var getXrayEnabled = exports.getXrayEnabled = function getXrayEnabled(state) {
	    var enabled = state.settings.values && state.settings.values['enable_xrays'];
	    if (enabled == null || enabled == true) {
	        return true;
	    }
	    return false;
	};
	
	var getMaxCost = exports.getMaxCost = function getMaxCost(state) {
	    return state.settings.values['xray_max_cost'];
	};

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _TableSidebar = __webpack_require__(2001);
	
	var _TableSidebar2 = _interopRequireDefault(_TableSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _TableQuestions = __webpack_require__(2005);
	
	var _TableQuestions2 = _interopRequireDefault(_TableQuestions);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	var _questions = __webpack_require__(1622);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        database: (0, _selectors.getDatabase)(state, props),
	        table: (0, _selectors.getTable)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({
	    fetchQuestions: function fetchQuestions() {
	        return (0, _questions.loadEntities)("cards", {});
	    }
	}, metadataActions, actions);
	
	var TableQuestionsContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(TableQuestionsContainer, _Component);
	
	    function TableQuestionsContainer() {
	        _classCallCheck(this, TableQuestionsContainer);
	
	        return _possibleConstructorReturn(this, (TableQuestionsContainer.__proto__ || Object.getPrototypeOf(TableQuestionsContainer)).apply(this, arguments));
	    }
	
	    _createClass(TableQuestionsContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchDatabaseMetadataAndQuestion(this.props, this.props.databaseId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                database = _props.database,
	                table = _props.table,
	                isEditing = _props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_TableSidebar2.default, { database: database, table: table })
	                },
	                _react2.default.createElement(_TableQuestions2.default, this.props)
	            );
	        }
	    }]);
	
	    return TableQuestionsContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    database: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    table: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	TableQuestionsContainer.displayName = 'TableQuestionsContainer';
	exports.default = TableQuestionsContainer;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _visualizations = __webpack_require__(1284);
	
	var _visualizations2 = _interopRequireDefault(_visualizations);
	
	var _table = __webpack_require__(871);
	
	var _urls = __webpack_require__(894);
	
	var Urls = _interopRequireWildcard(_urls);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _List3 = __webpack_require__(1945);
	
	var _List4 = _interopRequireDefault(_List3);
	
	var _ListItem = __webpack_require__(1946);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _AdminAwareEmptyState = __webpack_require__(1947);
	
	var _AdminAwareEmptyState2 = _interopRequireDefault(_AdminAwareEmptyState);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _ReferenceHeader = __webpack_require__(1948);
	
	var _ReferenceHeader2 = _interopRequireDefault(_ReferenceHeader);
	
	var _utils = __webpack_require__(1920);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyStateData = function emptyStateData(table) {
	    return {
	        message: "Questions about this table will appear here as they're added",
	        icon: "all",
	        action: "Ask a question",
	        link: (0, _utils.getQuestionUrl)({
	            dbId: table.db_id,
	            tableId: table.id
	        })
	    };
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        table: (0, _selectors.getTable)(state, props),
	        entities: (0, _selectors.getTableQuestions)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        loadingError: (0, _selectors.getError)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions);
	
	var TableQuestions = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(TableQuestions, _Component);
	
	    function TableQuestions() {
	        _classCallCheck(this, TableQuestions);
	
	        return _possibleConstructorReturn(this, (TableQuestions.__proto__ || Object.getPrototypeOf(TableQuestions)).apply(this, arguments));
	    }
	
	    _createClass(TableQuestions, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                entities = _props.entities,
	                style = _props.style,
	                loadingError = _props.loadingError,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                "div",
	                { style: style, className: "full" },
	                _react2.default.createElement(_ReferenceHeader2.default, {
	                    name: "Questions about " + this.props.table.display_name,
	                    type: "questions",
	                    headerIcon: "table2"
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return Object.keys(entities).length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List4.default,
	                                null,
	                                Object.values(entities).filter(_table.isQueryable).map(function (entity, index) {
	                                    return entity && entity.id && entity.name && _react2.default.createElement(
	                                        "li",
	                                        { className: "relative", key: entity.id },
	                                        _react2.default.createElement(_ListItem2.default, {
	                                            id: entity.id,
	                                            index: index,
	                                            name: entity.display_name || entity.name,
	                                            description: "Created " + (0, _moment2.default)(entity.created_at).fromNow() + " by " + entity.creator.common_name,
	                                            url: Urls.question(entity.id),
	                                            icon: _visualizations2.default.get(entity.display).iconName
	                                        })
	                                    );
	                                })
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_AdminAwareEmptyState2.default, emptyStateData(_this2.props.table))
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return TableQuestions;
	}(_react.Component), _class2.propTypes = {
	    table: _propTypes2.default.object.isRequired,
	    style: _propTypes2.default.object.isRequired,
	    entities: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object
	}, _temp)) || _class);
	TableQuestions.displayName = "TableQuestions";
	exports.default = TableQuestions;

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _TableSidebar = __webpack_require__(2001);
	
	var _TableSidebar2 = _interopRequireDefault(_TableSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _FieldList = __webpack_require__(2007);
	
	var _FieldList2 = _interopRequireDefault(_FieldList);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _selectors = __webpack_require__(1922);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        database: (0, _selectors.getDatabase)(state, props),
	        table: (0, _selectors.getTable)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var FieldListContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(FieldListContainer, _Component);
	
	    function FieldListContainer() {
	        _classCallCheck(this, FieldListContainer);
	
	        return _possibleConstructorReturn(this, (FieldListContainer.__proto__ || Object.getPrototypeOf(FieldListContainer)).apply(this, arguments));
	    }
	
	    _createClass(FieldListContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchDatabaseMetadata(this.props, this.props.databaseId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                database = _props.database,
	                table = _props.table,
	                isEditing = _props.isEditing;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_TableSidebar2.default, { database: database, table: table })
	                },
	                _react2.default.createElement(_FieldList2.default, this.props)
	            );
	        }
	    }]);
	
	    return FieldListContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    database: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    table: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool
	}, _temp)) || _class);
	FieldListContainer.displayName = 'FieldListContainer';
	exports.default = FieldListContainer;

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reduxForm = __webpack_require__(589);
	
	var _List = __webpack_require__(1943);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _Reference = __webpack_require__(1972);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	var _Field = __webpack_require__(1986);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Field3 = __webpack_require__(1988);
	
	var _Field4 = _interopRequireDefault(_Field3);
	
	var _List3 = __webpack_require__(1945);
	
	var _List4 = _interopRequireDefault(_List3);
	
	var _EmptyState = __webpack_require__(1566);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _EditHeader = __webpack_require__(1924);
	
	var _EditHeader2 = _interopRequireDefault(_EditHeader);
	
	var _EditableReferenceHeader = __webpack_require__(1954);
	
	var _EditableReferenceHeader2 = _interopRequireDefault(_EditableReferenceHeader);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _selectors = __webpack_require__(1922);
	
	var _utils = __webpack_require__(1920);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyStateData = {
	    message: "Fields in this table will appear here as they're added",
	    icon: "fields"
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var data = (0, _selectors.getFieldsByTable)(state, props);
	    return {
	        table: (0, _selectors.getTable)(state, props),
	        entities: data,
	        foreignKeys: (0, _selectors.getForeignKeys)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        loadingError: (0, _selectors.getError)(state, props),
	        user: (0, _selectors.getUser)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        fields: (0, _utils.fieldsToFormFields)(data)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var validate = function validate(values, props) {
	    return {};
	};
	
	var FieldList = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reduxForm.reduxForm)({
	    form: 'fields',
	    validate: validate
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    _inherits(FieldList, _Component);
	
	    function FieldList() {
	        _classCallCheck(this, FieldList);
	
	        return _possibleConstructorReturn(this, (FieldList.__proto__ || Object.getPrototypeOf(FieldList)).apply(this, arguments));
	    }
	
	    _createClass(FieldList, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                style = _props.style,
	                entities = _props.entities,
	                fields = _props.fields,
	                foreignKeys = _props.foreignKeys,
	                table = _props.table,
	                loadingError = _props.loadingError,
	                loading = _props.loading,
	                user = _props.user,
	                isEditing = _props.isEditing,
	                startEditing = _props.startEditing,
	                endEditing = _props.endEditing,
	                resetForm = _props.resetForm,
	                handleSubmit = _props.handleSubmit,
	                submitting = _props.submitting;
	
	
	            return _react2.default.createElement(
	                "form",
	                { style: style, className: "full",
	                    onSubmit: handleSubmit(function () {
	                        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(formFields) {
	                            return regeneratorRuntime.wrap(function _callee$(_context) {
	                                while (1) {
	                                    switch (_context.prev = _context.next) {
	                                        case 0:
	                                            _context.next = 2;
	                                            return actions.rUpdateFields(_this2.props.entities, formFields, _this2.props);
	
	                                        case 2:
	                                            return _context.abrupt("return", _context.sent);
	
	                                        case 3:
	                                        case "end":
	                                            return _context.stop();
	                                    }
	                                }
	                            }, _callee, _this2);
	                        }));
	
	                        return function (_x) {
	                            return _ref.apply(this, arguments);
	                        };
	                    }())
	                },
	                isEditing && _react2.default.createElement(_EditHeader2.default, {
	                    hasRevisionHistory: false,
	                    reinitializeForm: resetForm,
	                    endEditing: endEditing,
	                    submitting: submitting
	                }),
	                _react2.default.createElement(_EditableReferenceHeader2.default, {
	                    headerIcon: "table2",
	                    name: "Fields in " + table.display_name,
	                    user: user,
	                    isEditing: isEditing,
	                    startEditing: startEditing
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return Object.keys(entities).length > 0 ? _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: _List2.default.item },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: _Reference2.default.columnHeader },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: (0, _classnames2.default)(_List2.default.itemTitle, _Field2.default.fieldNameTitle) },
	                                        "Field name"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: (0, _classnames2.default)(_List2.default.itemTitle, _Field2.default.fieldType) },
	                                        "Field type"
	                                    ),
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: (0, _classnames2.default)(_List2.default.itemTitle, _Field2.default.fieldDataType) },
	                                        "Data type"
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _List4.default,
	                                null,
	                                Object.values(entities).map(function (entity) {
	                                    return entity && entity.id && entity.name && _react2.default.createElement(
	                                        "li",
	                                        { className: "relative", key: entity.id },
	                                        _react2.default.createElement(_Field4.default, {
	                                            field: entity,
	                                            foreignKeys: foreignKeys,
	                                            url: "/reference/databases/" + table.db_id + "/tables/" + table.id + "/fields/" + entity.id,
	                                            icon: (0, _schema_metadata.getIconForField)(entity),
	                                            isEditing: isEditing,
	                                            formField: fields[entity.id]
	                                        })
	                                    );
	                                })
	                            )
	                        ) : _react2.default.createElement(
	                            "div",
	                            { className: _List2.default.empty },
	                            _react2.default.createElement(_EmptyState2.default, emptyStateData)
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return FieldList;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entities: _propTypes2.default.object.isRequired,
	    foreignKeys: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func.isRequired,
	    endEditing: _propTypes2.default.func.isRequired,
	    startLoading: _propTypes2.default.func.isRequired,
	    endLoading: _propTypes2.default.func.isRequired,
	    setError: _propTypes2.default.func.isRequired,
	    updateField: _propTypes2.default.func.isRequired,
	    handleSubmit: _propTypes2.default.func.isRequired,
	    user: _propTypes2.default.object.isRequired,
	    fields: _propTypes2.default.object.isRequired,
	    table: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool,
	    resetForm: _propTypes2.default.func
	}, _temp)) || _class) || _class);
	FieldList.displayName = "FieldList";
	exports.default = FieldList;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _FieldSidebar = __webpack_require__(2009);
	
	var _FieldSidebar2 = _interopRequireDefault(_FieldSidebar);
	
	var _SidebarLayout = __webpack_require__(1941);
	
	var _SidebarLayout2 = _interopRequireDefault(_SidebarLayout);
	
	var _FieldDetail = __webpack_require__(2010);
	
	var _FieldDetail2 = _interopRequireDefault(_FieldDetail);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	var _metadata2 = __webpack_require__(1073);
	
	var _selectors = __webpack_require__(1922);
	
	var _selectors2 = __webpack_require__(2003);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        database: (0, _selectors.getDatabase)(state, props),
	        table: (0, _selectors.getTable)(state, props),
	        field: (0, _selectors.getField)(state, props),
	        databaseId: (0, _selectors.getDatabaseId)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        metadata: (0, _metadata2.getMetadata)(state, props),
	        showXray: (0, _selectors2.getXrayEnabled)(state)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions);
	
	var FieldDetailContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(FieldDetailContainer, _Component);
	
	    function FieldDetailContainer() {
	        _classCallCheck(this, FieldDetailContainer);
	
	        return _possibleConstructorReturn(this, (FieldDetailContainer.__proto__ || Object.getPrototypeOf(FieldDetailContainer)).apply(this, arguments));
	    }
	
	    _createClass(FieldDetailContainer, [{
	        key: 'fetchContainerData',
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return actions.wrappedFetchDatabaseMetadata(this.props, this.props.databaseId);
	
	                            case 2:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function fetchContainerData() {
	                return _ref.apply(this, arguments);
	            }
	
	            return fetchContainerData;
	        }()
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchContainerData();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(newProps) {
	            if (this.props.location.pathname === newProps.location.pathname) {
	                return;
	            }
	
	            actions.clearState(newProps);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                database = _props.database,
	                table = _props.table,
	                field = _props.field,
	                isEditing = _props.isEditing,
	                showXray = _props.showXray;
	
	
	            return _react2.default.createElement(
	                _SidebarLayout2.default,
	                {
	                    className: 'flex-full relative',
	                    style: isEditing ? { paddingTop: '43px' } : {},
	                    sidebar: _react2.default.createElement(_FieldSidebar2.default, { database: database, table: table, field: field, showXray: showXray })
	                },
	                _react2.default.createElement(_FieldDetail2.default, this.props)
	            );
	        }
	    }]);
	
	    return FieldDetailContainer;
	}(_react.Component), _class2.propTypes = {
	    params: _propTypes2.default.object.isRequired,
	    location: _propTypes2.default.object.isRequired,
	    database: _propTypes2.default.object.isRequired,
	    databaseId: _propTypes2.default.number.isRequired,
	    table: _propTypes2.default.object.isRequired,
	    field: _propTypes2.default.object.isRequired,
	    isEditing: _propTypes2.default.bool,
	    metadata: _propTypes2.default.object,
	    showXray: _propTypes2.default.bool
	}, _temp)) || _class);
	FieldDetailContainer.displayName = 'FieldDetailContainer';
	exports.default = FieldDetailContainer;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Sidebar = __webpack_require__(1938);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Breadcrumbs = __webpack_require__(1678);
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _SidebarItem = __webpack_require__(1940);
	
	var _SidebarItem2 = _interopRequireDefault(_SidebarItem);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pure = __webpack_require__(913);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldSidebar = function FieldSidebar(_ref) {
	    var database = _ref.database,
	        table = _ref.table,
	        field = _ref.field,
	        style = _ref.style,
	        className = _ref.className,
	        showXray = _ref.showXray;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)(_Sidebar2.default.sidebar, className), style: style },
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "div",
	                { className: _Sidebar2.default.breadcrumbs },
	                _react2.default.createElement(_Breadcrumbs2.default, {
	                    className: "py4",
	                    crumbs: [[database.name, "/reference/databases/" + database.id], [table.name, "/reference/databases/" + database.id + "/tables/" + table.id], [field.name]],
	                    inSidebar: true,
	                    placeholder: "Data Reference"
	                })
	            ),
	            _react2.default.createElement(_SidebarItem2.default, { key: "/reference/databases/" + database.id + "/tables/" + table.id + "/fields/" + field.id,
	                href: "/reference/databases/" + database.id + "/tables/" + table.id + "/fields/" + field.id,
	                icon: "document",
	                name: "Details" }),
	            showXray && _react2.default.createElement(_SidebarItem2.default, {
	                key: "/xray/field/" + field.id + "/approximate",
	                href: "/xray/field/" + field.id + "/approximate",
	                icon: "beaker",
	                name: "X-ray this Field" })
	        )
	    );
	}; /* eslint "react/prop-types": "warn" */
	FieldSidebar.displayName = "FieldSidebar";
	
	
	FieldSidebar.propTypes = {
	    database: _propTypes2.default.object,
	    table: _propTypes2.default.object,
	    field: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    showXray: _propTypes2.default.bool
	};
	
	exports.default = (0, _pure2.default)(FieldSidebar);

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(467);
	
	var _reduxForm = __webpack_require__(589);
	
	var _reactRouterRedux = __webpack_require__(638);
	
	var _Reference = __webpack_require__(1972);
	
	var _Reference2 = _interopRequireDefault(_Reference);
	
	var _List = __webpack_require__(1945);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _EditHeader = __webpack_require__(1924);
	
	var _EditHeader2 = _interopRequireDefault(_EditHeader);
	
	var _EditableReferenceHeader = __webpack_require__(1954);
	
	var _EditableReferenceHeader2 = _interopRequireDefault(_EditableReferenceHeader);
	
	var _Detail = __webpack_require__(1955);
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _FieldTypeDetail = __webpack_require__(1992);
	
	var _FieldTypeDetail2 = _interopRequireDefault(_FieldTypeDetail);
	
	var _UsefulQuestions = __webpack_require__(1979);
	
	var _UsefulQuestions2 = _interopRequireDefault(_UsefulQuestions);
	
	var _utils = __webpack_require__(1920);
	
	var _selectors = __webpack_require__(1922);
	
	var _metadata = __webpack_require__(1110);
	
	var metadataActions = _interopRequireWildcard(_metadata);
	
	var _reference = __webpack_require__(1921);
	
	var actions = _interopRequireWildcard(_reference);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var interestingQuestions = function interestingQuestions(database, table, field, metadata) {
	    return [{
	        text: "Number of " + table.display_name + " grouped by " + field.display_name,
	        icon: { name: "bar", scale: 1, viewBox: "8 8 16 16" },
	        link: (0, _utils.getQuestionUrl)({
	            dbId: database.id,
	            tableId: table.id,
	            fieldId: field.id,
	            getCount: true,
	            visualization: 'bar',
	            metadata: metadata
	        })
	    }, {
	        text: "Number of " + table.display_name + " grouped by " + field.display_name,
	        icon: { name: "pie", scale: 1, viewBox: "8 8 16 16" },
	        link: (0, _utils.getQuestionUrl)({
	            dbId: database.id,
	            tableId: table.id,
	            fieldId: field.id,
	            getCount: true,
	            visualization: 'pie',
	            metadata: metadata
	        })
	    }, {
	        text: "All distinct values of " + field.display_name,
	        icon: "table2",
	        link: (0, _utils.getQuestionUrl)({
	            dbId: database.id,
	            tableId: table.id,
	            fieldId: field.id,
	            metadata: metadata
	        })
	    }];
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    var entity = (0, _selectors.getField)(state, props) || {};
	
	    return {
	        entity: entity,
	        field: entity,
	        table: (0, _selectors.getTable)(state, props),
	        database: (0, _selectors.getDatabase)(state, props),
	        loading: (0, _selectors.getLoading)(state, props),
	        // naming this 'error' will conflict with redux form
	        loadingError: (0, _selectors.getError)(state, props),
	        user: (0, _selectors.getUser)(state, props),
	        foreignKeys: (0, _selectors.getForeignKeys)(state, props),
	        isEditing: (0, _selectors.getIsEditing)(state, props),
	        isFormulaExpanded: (0, _selectors.getIsFormulaExpanded)(state, props)
	    };
	};
	
	var mapDispatchToProps = _extends({}, metadataActions, actions, {
	    onChangeLocation: _reactRouterRedux.push
	});
	
	var validate = function validate(values, props) {
	    return {};
	};
	
	var FieldDetail = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reduxForm.reduxForm)({
	    form: 'details',
	    fields: ['name', 'display_name', 'description', 'revision_message', 'points_of_interest', 'caveats', 'special_type', 'fk_target_field_id'],
	    validate: validate
	}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
	    _inherits(FieldDetail, _Component);
	
	    function FieldDetail() {
	        _classCallCheck(this, FieldDetail);
	
	        return _possibleConstructorReturn(this, (FieldDetail.__proto__ || Object.getPrototypeOf(FieldDetail)).apply(this, arguments));
	    }
	
	    _createClass(FieldDetail, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$fields = _props.fields,
	                name = _props$fields.name,
	                display_name = _props$fields.display_name,
	                description = _props$fields.description,
	                revision_message = _props$fields.revision_message,
	                points_of_interest = _props$fields.points_of_interest,
	                caveats = _props$fields.caveats,
	                special_type = _props$fields.special_type,
	                fk_target_field_id = _props$fields.fk_target_field_id,
	                style = _props.style,
	                entity = _props.entity,
	                table = _props.table,
	                loadingError = _props.loadingError,
	                loading = _props.loading,
	                user = _props.user,
	                foreignKeys = _props.foreignKeys,
	                isEditing = _props.isEditing,
	                startEditing = _props.startEditing,
	                endEditing = _props.endEditing,
	                handleSubmit = _props.handleSubmit,
	                resetForm = _props.resetForm,
	                submitting = _props.submitting,
	                metadata = _props.metadata;
	
	
	            var onSubmit = handleSubmit(function () {
	                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(fields) {
	                    return regeneratorRuntime.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    _context.next = 2;
	                                    return actions.rUpdateFieldDetail(fields, _this2.props);
	
	                                case 2:
	                                    return _context.abrupt("return", _context.sent);
	
	                                case 3:
	                                case "end":
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, _this2);
	                }));
	
	                return function (_x) {
	                    return _ref.apply(this, arguments);
	                };
	            }());
	
	            return _react2.default.createElement(
	                "form",
	                { style: style, className: "full",
	                    onSubmit: onSubmit
	                },
	                isEditing && _react2.default.createElement(_EditHeader2.default, {
	                    hasRevisionHistory: false,
	                    onSubmit: onSubmit,
	                    endEditing: endEditing,
	                    reinitializeForm: resetForm,
	                    submitting: submitting,
	                    revisionMessageFormField: revision_message
	                }),
	                _react2.default.createElement(_EditableReferenceHeader2.default, {
	                    entity: entity,
	                    table: table,
	                    type: "field",
	                    headerIcon: "field",
	                    name: "Details",
	                    user: user,
	                    isEditing: isEditing,
	                    hasSingleSchema: false,
	                    hasDisplayName: true,
	                    startEditing: startEditing,
	                    displayNameFormField: display_name,
	                    nameFormField: name
	                }),
	                _react2.default.createElement(
	                    _LoadingAndErrorWrapper2.default,
	                    { loading: !loadingError && loading, error: loadingError },
	                    function () {
	                        return _react2.default.createElement(
	                            "div",
	                            { className: "wrapper wrapper--trim" },
	                            _react2.default.createElement(
	                                _List2.default,
	                                null,
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "description",
	                                        name: "Description",
	                                        description: entity.description,
	                                        placeholder: "No description yet",
	                                        isEditing: isEditing,
	                                        field: description
	                                    })
	                                ),
	                                !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "name",
	                                        name: "Actual name in database",
	                                        description: entity.name,
	                                        subtitleClass: _Reference2.default.tableActualName
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "points_of_interest",
	                                        name: "Why this field is interesting",
	                                        description: entity.points_of_interest,
	                                        placeholder: "Nothing interesting yet",
	                                        isEditing: isEditing,
	                                        field: points_of_interest
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "caveats",
	                                        name: "Things to be aware of about this field",
	                                        description: entity.caveats,
	                                        placeholder: "Nothing to be aware of yet",
	                                        isEditing: isEditing,
	                                        field: caveats
	                                    })
	                                ),
	                                !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_Detail2.default, {
	                                        id: "base_type",
	                                        name: "Data type",
	                                        description: entity.base_type
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_FieldTypeDetail2.default, {
	                                        field: entity,
	                                        foreignKeys: foreignKeys,
	                                        fieldTypeFormField: special_type,
	                                        foreignKeyFormField: fk_target_field_id,
	                                        isEditing: isEditing
	                                    })
	                                ),
	                                !isEditing && _react2.default.createElement(
	                                    "li",
	                                    { className: "relative" },
	                                    _react2.default.createElement(_UsefulQuestions2.default, {
	                                        questions: interestingQuestions(_this2.props.database, _this2.props.table, _this2.props.field, metadata)
	                                    })
	                                )
	                            )
	                        );
	                    }
	                )
	            );
	        }
	    }]);
	
	    return FieldDetail;
	}(_react.Component), _class2.propTypes = {
	    style: _propTypes2.default.object.isRequired,
	    entity: _propTypes2.default.object.isRequired,
	    field: _propTypes2.default.object.isRequired,
	    table: _propTypes2.default.object,
	    user: _propTypes2.default.object.isRequired,
	    database: _propTypes2.default.object.isRequired,
	    foreignKeys: _propTypes2.default.object,
	    isEditing: _propTypes2.default.bool,
	    startEditing: _propTypes2.default.func.isRequired,
	    endEditing: _propTypes2.default.func.isRequired,
	    startLoading: _propTypes2.default.func.isRequired,
	    endLoading: _propTypes2.default.func.isRequired,
	    setError: _propTypes2.default.func.isRequired,
	    updateField: _propTypes2.default.func.isRequired,
	    handleSubmit: _propTypes2.default.func.isRequired,
	    resetForm: _propTypes2.default.func.isRequired,
	    fields: _propTypes2.default.object.isRequired,
	    loading: _propTypes2.default.bool,
	    loadingError: _propTypes2.default.object,
	    submitting: _propTypes2.default.bool,
	    metadata: _propTypes2.default.object
	}, _temp)) || _class) || _class);
	FieldDetail.displayName = "FieldDetail";
	exports.default = FieldDetail;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Title = __webpack_require__(1538);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _xray = __webpack_require__(2012);
	
	var _selectors = __webpack_require__(2003);
	
	var _stats = __webpack_require__(2013);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _CostSelect = __webpack_require__(2014);
	
	var _CostSelect2 = _interopRequireDefault(_CostSelect);
	
	var _StatGroup = __webpack_require__(2015);
	
	var _StatGroup2 = _interopRequireDefault(_StatGroup);
	
	var _Histogram = __webpack_require__(2019);
	
	var _Histogram2 = _interopRequireDefault(_Histogram);
	
	var _XRayLayout = __webpack_require__(2016);
	
	var _utils = __webpack_require__(2020);
	
	var _Periodicity = __webpack_require__(2021);
	
	var _Periodicity2 = _interopRequireDefault(_Periodicity);
	
	var _LoadingAnimation = __webpack_require__(2022);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        xray: (0, _selectors.getFeatures)(state),
	        isLoading: (0, _selectors.getLoadingStatus)(state),
	        error: (0, _selectors.getError)(state)
	    };
	};
	
	var mapDispatchToProps = {
	    initialize: _xray.initialize,
	    fetchXray: _xray.fetchXray
	};
	
	var FieldXRay = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _Title2.default)(function (_ref) {
	    var xray = _ref.xray;
	    return xray && xray.field.display_name || "Field";
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(FieldXRay, _Component);
	
	    function FieldXRay() {
	        _classCallCheck(this, FieldXRay);
	
	        return _possibleConstructorReturn(this, (FieldXRay.__proto__ || Object.getPrototypeOf(FieldXRay)).apply(this, arguments));
	    }
	
	    _createClass(FieldXRay, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.initialize();
	            this.fetch();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // HACK Atte Keinänen 9/20/17: We need this for now because the structure of `state.xray.xray` isn't same
	            // for all xray types and if switching to different kind of xray (= rendering different React container)
	            // without resetting the state fails because `state.xray.xray` subproperty lookups fail
	            this.props.initialize();
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch() {
	            var _props = this.props,
	                params = _props.params,
	                fetchXray = _props.fetchXray;
	
	            fetchXray('field', params.fieldId, params.cost);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.params.cost !== this.props.params.cost) {
	                this.fetch();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                xray = _props2.xray,
	                params = _props2.params,
	                isLoading = _props2.isLoading,
	                error = _props2.error;
	
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                {
	                    loading: isLoading || !(0, _utils.hasXray)(xray),
	                    error: error,
	                    noBackground: true,
	                    loadingMessages: _utils.xrayLoadingMessages,
	                    loadingScenes: [_react2.default.createElement(_LoadingAnimation2.default, null)]
	                },
	                function () {
	                    return _react2.default.createElement(
	                        _XRayLayout.XRayPageWrapper,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'full' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'my3 flex align-center' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'full' },
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        {
	                                            className: 'my2 px2 text-bold text-brand-hover inline-block bordered bg-white p1 h4 no-decoration rounded shadowed',
	                                            to: '/xray/table/' + xray.table.id + '/approximate'
	                                        },
	                                        xray.table.display_name
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'mt2 flex align-center' },
	                                        _react2.default.createElement(
	                                            'h1',
	                                            { className: 'flex align-center' },
	                                            xray.field.display_name,
	                                            _react2.default.createElement(_Icon2.default, { name: 'chevronright', className: 'mx1 text-grey-3', size: 16 }),
	                                            _react2.default.createElement(
	                                                'span',
	                                                { className: 'text-grey-3' },
	                                                'X-ray'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'ml-auto flex align-center' },
	                                            _react2.default.createElement(
	                                                'h3',
	                                                { className: 'mr2 text-grey-3' },
	                                                'Fidelity'
	                                            ),
	                                            _react2.default.createElement(_CostSelect2.default, {
	                                                xrayType: 'field',
	                                                id: xray.field.id,
	                                                currentCost: params.cost
	                                            })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'mt1 text-paragraph text-measure' },
	                                        xray.field.description
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'mt4' },
	                                _react2.default.createElement(_XRayLayout.Heading, { heading: 'Distribution' }),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'bg-white bordered shadowed' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'lg-p4' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { style: { height: 300 } },
	                                            xray.histogram.value && _react2.default.createElement(_Histogram2.default, { histogram: xray.histogram.value })
	                                        )
	                                    )
	                                )
	                            ),
	                            (0, _schema_metadata.isDate)(xray.field) && _react2.default.createElement(_Periodicity2.default, { xray: xray }),
	                            _react2.default.createElement(_StatGroup2.default, {
	                                heading: 'Values overview',
	                                xray: xray,
	                                stats: _stats.VALUES_OVERVIEW
	                            }),
	                            _react2.default.createElement(_StatGroup2.default, {
	                                heading: 'Statistical overview',
	                                xray: xray,
	                                showDescriptions: true,
	                                stats: _stats.STATS_OVERVIEW
	                            }),
	                            _react2.default.createElement(_StatGroup2.default, {
	                                heading: 'Robots',
	                                xray: xray,
	                                showDescriptions: true,
	                                stats: _stats.ROBOTS
	                            })
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return FieldXRay;
	}(_react.Component)) || _class) || _class);
	FieldXRay.displayName = 'FieldXRay';
	exports.default = FieldXRay;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.xrayError = exports.XRAY_ERROR = exports.loadComparison = exports.LOAD_COMPARISON = exports.loadXray = exports.LOAD_XRAY = exports.startLoad = exports.START_LOAD = exports.fetchSegmentTableComparison = exports.FETCH_SEGMENT_TABLE_COMPARISON = exports.fetchSegmentComparison = exports.FETCH_SEGMENT_COMPARISON = exports.fetchXray = exports.FETCH_XRAY = exports.initialize = exports.INITIALIZE = undefined;
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _costs = __webpack_require__(1895);
	
	var _costs2 = _interopRequireDefault(_costs);
	
	var _redux = __webpack_require__(657);
	
	var _services = __webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var INITIALIZE = exports.INITIALIZE = 'metabase/xray/INITIALIZE';
	var initialize = exports.initialize = (0, _redux.createAction)(INITIALIZE);
	
	var FETCH_XRAY = exports.FETCH_XRAY = 'metabase/xray/FETCH_XRAY';
	var fetchXray = exports.fetchXray = (0, _redux.createThunkAction)(FETCH_XRAY, function (type, id, cost) {
	    return function () {
	        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
	            var c, xray;
	            return regeneratorRuntime.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            dispatch(startLoad());
	                            _context.prev = 1;
	                            c = _costs2.default[cost];
	                            _context.next = 5;
	                            return _services.XRayApi[type + '_xray'](_extends(_defineProperty({}, type + 'Id', id), c.method));
	
	                        case 5:
	                            xray = _context.sent;
	
	                            dispatch(loadXray(xray));
	                            _context.next = 13;
	                            break;
	
	                        case 9:
	                            _context.prev = 9;
	                            _context.t0 = _context['catch'](1);
	
	                            console.error(_context.t0);
	                            dispatch(xrayError(_context.t0));
	
	                        case 13:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[1, 9]]);
	        }));
	
	        return function (_x) {
	            return _ref.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_SEGMENT_COMPARISON = exports.FETCH_SEGMENT_COMPARISON = 'metabase/xray/FETCH_SEGMENT_COMPARISON';
	var fetchSegmentComparison = exports.fetchSegmentComparison = (0, _redux.createThunkAction)(FETCH_SEGMENT_COMPARISON, function (segmentId1, segmentId2, cost) {
	    return function () {
	        var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch) {
	            var c, comparison;
	            return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            c = _costs2.default[cost];
	
	                            dispatch(startLoad());
	                            _context2.prev = 2;
	                            _context2.next = 5;
	                            return _services.XRayApi.segment_compare(_extends({ segmentId1: segmentId1, segmentId2: segmentId2 }, c.method));
	
	                        case 5:
	                            comparison = _context2.sent;
	                            return _context2.abrupt('return', dispatch(loadComparison(comparison)));
	
	                        case 9:
	                            _context2.prev = 9;
	                            _context2.t0 = _context2['catch'](2);
	
	                            console.error(_context2.t0);
	                            return _context2.abrupt('return', dispatch(xrayError(_context2.t0)));
	
	                        case 13:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[2, 9]]);
	        }));
	
	        return function (_x2) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	});
	
	var FETCH_SEGMENT_TABLE_COMPARISON = exports.FETCH_SEGMENT_TABLE_COMPARISON = 'metabase/xray/FETCH_SEGMENT_COMPARISON';
	var fetchSegmentTableComparison = exports.fetchSegmentTableComparison = (0, _redux.createThunkAction)(FETCH_SEGMENT_TABLE_COMPARISON, function (segmentId, tableId, cost) {
	    return function () {
	        var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch) {
	            var c, comparison;
	            return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            c = _costs2.default[cost];
	
	                            dispatch(startLoad());
	                            _context3.prev = 2;
	                            _context3.next = 5;
	                            return _services.XRayApi.segment_table_compare(_extends({ segmentId: segmentId, tableId: tableId }, c.method));
	
	                        case 5:
	                            comparison = _context3.sent;
	                            return _context3.abrupt('return', dispatch(loadComparison(comparison)));
	
	                        case 9:
	                            _context3.prev = 9;
	                            _context3.t0 = _context3['catch'](2);
	
	                            console.error(_context3.t0);
	                            return _context3.abrupt('return', dispatch(xrayError(_context3.t0)));
	
	                        case 13:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined, [[2, 9]]);
	        }));
	
	        return function (_x3) {
	            return _ref3.apply(this, arguments);
	        };
	    }();
	});
	
	var START_LOAD = exports.START_LOAD = 'metabase/xray/START_LOAD';
	var startLoad = exports.startLoad = (0, _redux.createAction)(START_LOAD);
	
	var LOAD_XRAY = exports.LOAD_XRAY = 'metabase/xray/LOAD_XRAY';
	var loadXray = exports.loadXray = (0, _redux.createAction)(LOAD_XRAY);
	
	var LOAD_COMPARISON = exports.LOAD_COMPARISON = 'metabase/xray/LOAD_COMPARISON';
	var loadComparison = exports.loadComparison = (0, _redux.createAction)(LOAD_COMPARISON);
	
	var XRAY_ERROR = exports.XRAY_ERROR = 'metabase/xray/XRAY_ERROR';
	var xrayError = exports.xrayError = (0, _redux.createAction)(XRAY_ERROR);
	
	var CLEAN_STATE = {
	    loading: false,
	    error: null
	};
	
	exports.default = (0, _redux.handleActions)((_handleActions = {}, _defineProperty(_handleActions, INITIALIZE, function () {
	    return CLEAN_STATE;
	}), _defineProperty(_handleActions, START_LOAD, {
	    next: function next(state, _ref4) {
	        var payload = _ref4.payload;
	        return _extends({}, state, {
	            loading: true
	        });
	    }
	}), _defineProperty(_handleActions, LOAD_XRAY, {
	    next: function next(state, _ref5) {
	        var payload = _ref5.payload;
	        return _extends({}, state, {
	            xray: payload,
	            loading: false
	        });
	    }
	}), _defineProperty(_handleActions, LOAD_COMPARISON, {
	    next: function next(state, _ref6) {
	        var payload = _ref6.payload;
	        return _extends({}, state, {
	            comparison: payload,
	            loading: false
	        });
	    }
	}), _defineProperty(_handleActions, XRAY_ERROR, {
	    next: function next(state, _ref7) {
	        var payload = _ref7.payload;
	        return _extends({}, state, {
	            loading: false,
	            error: payload
	        });
	    }
	}), _handleActions), CLEAN_STATE);

/***/ }),
/* 2013 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// keys for common values interesting for most folks
	var VALUES_OVERVIEW = exports.VALUES_OVERVIEW = ['min', 'earliest', // date field min is expressed as earliest
	'max', 'latest', // date field max is expressed as latest
	'count', 'sum', 'cardinality', 'sd', 'nil%', 'mean', 'median', 'mean-median-spread'];
	
	// keys for common values interesting for stat folks
	var STATS_OVERVIEW = exports.STATS_OVERVIEW = ['kurtosis', 'skewness', 'entropy', 'var', 'sum-of-square'];
	
	var ROBOTS = exports.ROBOTS = ['cardinality-vs-count', 'positive-definite?', 'has-nils?', 'all-distinct?'];
	
	// periods we care about for showing periodicity
	var PERIODICITY = exports.PERIODICITY = ['day', 'week', 'month', 'hour', 'quarter'];

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _reactRedux = __webpack_require__(467);
	
	var _selectors = __webpack_require__(2003);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _costs = __webpack_require__(1895);
	
	var _costs2 = _interopRequireDefault(_costs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        maxCost: (0, _selectors.getMaxCost)(state)
	    };
	};
	
	var getDisabled = function getDisabled(maxCost) {
	    if (maxCost === 'approximate') {
	        return ['extended', 'exact'];
	    } else if (maxCost === 'exact') {
	        return ['extended'];
	    }
	    return [];
	};
	
	var CostSelect = function CostSelect(_ref) {
	    var currentCost = _ref.currentCost,
	        location = _ref.location,
	        maxCost = _ref.maxCost;
	
	    var urlWithoutCost = location.pathname.substr(0, location.pathname.lastIndexOf('/'));
	    return _react2.default.createElement(
	        'ol',
	        { className: 'bordered rounded shadowed bg-white flex align-center overflow-hidden' },
	        Object.keys(_costs2.default).map(function (cost) {
	            var c = _costs2.default[cost];
	            return _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                    to: urlWithoutCost + '/' + cost,
	                    className: (0, _classnames2.default)('no-decoration', { 'disabled': getDisabled(maxCost).indexOf(cost) >= 0 }),
	                    key: cost
	                },
	                _react2.default.createElement(
	                    'li',
	                    {
	                        key: cost,
	                        className: (0, _classnames2.default)("flex align-center justify-center cursor-pointer bg-brand-hover text-white-hover transition-background transition-text text-grey-2", { 'bg-brand text-white': currentCost === cost })
	                    },
	                    _react2.default.createElement(
	                        _Tooltip2.default,
	                        {
	                            tooltip: c.description
	                        },
	                        _react2.default.createElement(_Icon2.default, {
	                            size: 22,
	                            name: c.icon,
	                            className: 'p1 border-right'
	                        })
	                    )
	                )
	            );
	        })
	    );
	};
	
	CostSelect.displayName = 'CostSelect';
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(CostSelect));

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _XRayLayout = __webpack_require__(2016);
	
	var _SimpleStat = __webpack_require__(2018);
	
	var _SimpleStat2 = _interopRequireDefault(_SimpleStat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var atLeastOneStat = function atLeastOneStat(xray, stats) {
	    return stats.filter(function (s) {
	        return xray[s];
	    }).length > 0;
	};
	
	var StatGroup = function StatGroup(_ref) {
	    var heading = _ref.heading,
	        xray = _ref.xray,
	        stats = _ref.stats,
	        showDescriptions = _ref.showDescriptions;
	    return atLeastOneStat(xray, stats) && _react2.default.createElement(
	        'div',
	        { className: 'my4' },
	        _react2.default.createElement(_XRayLayout.Heading, { heading: heading }),
	        _react2.default.createElement(
	            'div',
	            { className: 'bordered rounded shadowed bg-white' },
	            _react2.default.createElement(
	                'ol',
	                { className: 'Grid Grid--1of4' },
	                stats.map(function (stat) {
	                    return !!xray[stat] && xray[stat].value && _react2.default.createElement(
	                        'li',
	                        { className: 'Grid-cell p1 px2 md-p2 md-px3 lg-p3 lg-px4 border-right border-bottom', key: stat },
	                        _react2.default.createElement(_SimpleStat2.default, {
	                            stat: xray[stat],
	                            showDescription: showDescriptions
	                        })
	                    );
	                })
	            )
	        )
	    );
	};
	
	exports.default = StatGroup;

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Heading = exports.XRayPageWrapper = undefined;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Background = __webpack_require__(1594);
	
	var _PreviewBanner = __webpack_require__(2017);
	
	var _PreviewBanner2 = _interopRequireDefault(_PreviewBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// A small wrapper to get consistent page structure
	var XRayPageWrapper = exports.XRayPageWrapper = (0, _Background.withBackground)('bg-slate-extra-light')(function (_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { className: 'full-height full' },
	        _react2.default.createElement(_PreviewBanner2.default, null),
	        _react2.default.createElement(
	            'div',
	            { className: 'XRayPageWrapper wrapper pb4 full-height' },
	            children
	        )
	    );
	});
	
	// A unified heading for XRay pages
	var Heading = exports.Heading = function Heading(_ref2) {
	    var heading = _ref2.heading;
	    return _react2.default.createElement(
	        'h2',
	        { className: 'py3', style: { color: '#93A1AB' } },
	        heading
	    );
	};
	Heading.displayName = 'Heading';

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SURVEY_LINK = 'https://docs.google.com/forms/d/e/1FAIpQLSc92WzF76ViiT8l4646lvFSWejNUhh4lhCSMXdZECILVwJG2A/viewform?usp=sf_link';
	
	var PreviewBanner = function PreviewBanner() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'full py2 flex align-center justify-center full md-py3 text-centered text-slate text-paragraph bg-white border-bottom' },
	        _react2.default.createElement(_Icon2.default, { name: 'beaker', size: 28, className: 'mr1 text-brand', style: { marginTop: -5 } }),
	        _react2.default.createElement(
	            'span',
	            null,
	            'Welcome to the x-ray preview! We\'d love ',
	            _react2.default.createElement(
	                'a',
	                { className: 'link', href: SURVEY_LINK, target: '_blank' },
	                'your feedback.'
	            )
	        )
	    );
	};
	
	PreviewBanner.displayName = 'PreviewBanner';
	exports.default = PreviewBanner;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SimpleStat = function SimpleStat(_ref) {
	    var stat = _ref.stat,
	        showDescription = _ref.showDescription;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'flex align-center' },
	            _react2.default.createElement(
	                'h3',
	                { className: 'mr4 text-grey-4' },
	                stat.label
	            ),
	            showDescription && _react2.default.createElement(
	                _Tooltip2.default,
	                { tooltip: stat.description },
	                _react2.default.createElement(_Icon2.default, { name: 'infooutlined' })
	            )
	        ),
	        _react2.default.createElement(
	            'h1',
	            { className: 'my1' },
	            stat.value.toString()
	        )
	    );
	};
	
	SimpleStat.displayName = 'SimpleStat';
	exports.default = SimpleStat;

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Visualization = __webpack_require__(1270);
	
	var _Visualization2 = _interopRequireDefault(_Visualization);
	
	var _colors = __webpack_require__(881);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Histogram = function Histogram(_ref) {
	    var histogram = _ref.histogram,
	        color = _ref.color,
	        showAxis = _ref.showAxis;
	    return _react2.default.createElement(_Visualization2.default, {
	        className: 'full-height',
	        series: [{
	            card: {
	                display: "bar",
	                visualization_settings: {
	                    "graph.colors": color,
	                    "graph.x_axis.axis_enabled": showAxis,
	                    "graph.x_axis.labels_enabled": showAxis,
	                    "graph.y_axis.axis_enabled": showAxis,
	                    "graph.y_axis.labels_enabled": showAxis
	                }
	            },
	            data: _extends({}, histogram, {
	                rows: histogram.rows.map(function (row) {
	                    return [row[0], row[1] * 100];
	                })
	            })
	        }],
	        showTitle: false
	    });
	};
	
	Histogram.displayName = 'Histogram';
	Histogram.defaultProps = {
	    color: [_colors.normal.blue],
	    showAxis: true
	};
	
	exports.default = Histogram;

/***/ }),
/* 2020 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// takes a distance float and uses it to return a human readable phrase
	// indicating how similar two items in a comparison are
	
	var distanceToPhrase = exports.distanceToPhrase = function distanceToPhrase(distance) {
	    if (distance >= 0.75) {
	        return 'Very different';
	    } else if (distance < 0.75 && distance >= 0.5) {
	        return 'Somewhat different';
	    } else if (distance < 0.5 && distance >= 0.25) {
	        return 'Somewhat similar';
	    } else {
	        return 'Very similar';
	    }
	};
	
	// Small utilities to determine whether we have an entity yet or not,
	// used for loading status
	function has(entity) {
	    return typeof entity !== 'undefined' ? true : false;
	}
	
	var hasXray = exports.hasXray = has;
	var hasComparison = exports.hasComparison = has;
	
	var xrayLoadingMessages = exports.xrayLoadingMessages = ['Generating your x-ray...', 'Still working...'];
	
	var comparisonLoadingMessages = exports.comparisonLoadingMessages = ['Generating your comparison...', 'Still working...'];

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stats = __webpack_require__(2013);
	
	var _XRayLayout = __webpack_require__(2016);
	
	var _Histogram = __webpack_require__(2019);
	
	var _Histogram2 = _interopRequireDefault(_Histogram);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Periodicity = function Periodicity(_ref) {
	    var xray = _ref.xray;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_XRayLayout.Heading, { heading: 'Time breakdown' }),
	        ',',
	        _react2.default.createElement(
	            'div',
	            { className: 'bg-white bordered rounded shadowed' },
	            _react2.default.createElement(
	                'div',
	                { className: 'Grid Grid--gutters Grid--1of4' },
	                _stats.PERIODICITY.map(function (period) {
	                    return xray['histogram-' + period] && xray['histogram-' + period].value && _react2.default.createElement(
	                        'div',
	                        { className: 'Grid-cell' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'p4 border-right border-bottom' },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { height: 120 } },
	                                _react2.default.createElement(
	                                    'h4',
	                                    null,
	                                    xray['histogram-' + period].label
	                                ),
	                                _react2.default.createElement(_Histogram2.default, {
	                                    histogram: xray['histogram-' + period].value,
	                                    axis: false
	                                })
	                            )
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	Periodicity.displayName = 'Periodicity';
	exports.default = Periodicity;

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RotatingGear = function RotatingGear(_ref) {
	    var name = _ref.name,
	        speed = _ref.speed,
	        size = _ref.size,
	        delay = _ref.delay;
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                animation: name + ' ' + speed + 'ms linear ' + delay + 'ms infinite'
	            } },
	        _react2.default.createElement(_Icon2.default, { name: 'gear', size: size })
	    );
	};
	
	RotatingGear.displayName = 'RotatingGear';
	RotatingGear.defaultProps = {
	    name: 'spin',
	    delay: 0,
	    speed: 5000
	};
	
	var LoadingAnimation = function LoadingAnimation() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'relative', style: { width: 300, height: 180 } },
	        _react2.default.createElement(
	            'div',
	            { className: 'absolute', style: { top: 20, left: 135 } },
	            _react2.default.createElement(RotatingGear, { size: 90 })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'absolute', style: { top: 60, left: 80 } },
	            _react2.default.createElement(RotatingGear, { name: 'spin-reverse', size: 60, speed: 6000 })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'absolute', style: { top: 110, left: 125 } },
	            _react2.default.createElement(RotatingGear, { speed: 7000, size: 45 })
	        )
	    );
	};
	
	LoadingAnimation.displayName = 'LoadingAnimation';
	exports.default = LoadingAnimation;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Title = __webpack_require__(1538);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _xray = __webpack_require__(2012);
	
	var _XRayLayout = __webpack_require__(2016);
	
	var _CostSelect = __webpack_require__(2014);
	
	var _CostSelect2 = _interopRequireDefault(_CostSelect);
	
	var _Constituent = __webpack_require__(2024);
	
	var _Constituent2 = _interopRequireDefault(_Constituent);
	
	var _selectors = __webpack_require__(2003);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _LoadingAnimation = __webpack_require__(2022);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _utils = __webpack_require__(2020);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        xray: (0, _selectors.getFeatures)(state),
	        constituents: (0, _selectors.getConstituents)(state),
	        isLoading: (0, _selectors.getLoadingStatus)(state),
	        error: (0, _selectors.getError)(state)
	    };
	};
	
	var mapDispatchToProps = {
	    initialize: _xray.initialize,
	    fetchXray: _xray.fetchXray
	};
	
	var TableXRay = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _Title2.default)(function (_ref) {
	    var xray = _ref.xray;
	    return xray && xray.table.display_name || "Table";
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(TableXRay, _Component);
	
	    function TableXRay() {
	        _classCallCheck(this, TableXRay);
	
	        return _possibleConstructorReturn(this, (TableXRay.__proto__ || Object.getPrototypeOf(TableXRay)).apply(this, arguments));
	    }
	
	    _createClass(TableXRay, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.initialize();
	            this.fetch();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // HACK Atte Keinänen 9/20/17: We need this for now because the structure of `state.xray.xray` isn't same
	            // for all xray types and if switching to different kind of xray (= rendering different React container)
	            // without resetting the state fails because `state.xray.xray` subproperty lookups fail
	            this.props.initialize();
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch() {
	            var _props = this.props,
	                params = _props.params,
	                fetchXray = _props.fetchXray;
	            // TODO this should happen at the action level
	
	            fetchXray('table', params.tableId, params.cost);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.params.cost !== this.props.params.cost) {
	                this.fetch();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                constituents = _props2.constituents,
	                xray = _props2.xray,
	                params = _props2.params,
	                isLoading = _props2.isLoading,
	                error = _props2.error;
	
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                {
	                    loading: isLoading || !(0, _utils.hasXray)(xray),
	                    error: error,
	                    noBackground: true,
	                    loadingMessages: _utils.xrayLoadingMessages,
	                    loadingScenes: [_react2.default.createElement(_LoadingAnimation2.default, null)]
	                },
	                function () {
	                    return _react2.default.createElement(
	                        _XRayLayout.XRayPageWrapper,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'full' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'my4 flex align-center py2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        'h1',
	                                        { className: 'mt2 flex align-center' },
	                                        xray.table.display_name,
	                                        _react2.default.createElement(_Icon2.default, { name: 'chevronright', className: 'mx1 text-grey-3', size: 16 }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: 'text-grey-3' },
	                                            'XRay'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'm0 text-paragraph text-measure' },
	                                        xray.table.description
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'ml-auto flex align-center' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { className: 'mr2' },
	                                        'Fidelity:'
	                                    ),
	                                    _react2.default.createElement(_CostSelect2.default, {
	                                        xrayType: 'table',
	                                        currentCost: params.cost,
	                                        id: xray.table.id
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'ol',
	                                null,
	                                constituents.map(function (constituent, index) {
	                                    return _react2.default.createElement(
	                                        'li',
	                                        { key: index },
	                                        _react2.default.createElement(_Constituent2.default, {
	                                            constituent: constituent
	                                        })
	                                    );
	                                })
	                            )
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return TableXRay;
	}(_react.Component)) || _class) || _class);
	TableXRay.displayName = 'TableXRay';
	exports.default = TableXRay;

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _Histogram = __webpack_require__(2019);
	
	var _Histogram2 = _interopRequireDefault(_Histogram);
	
	var _SimpleStat = __webpack_require__(2018);
	
	var _SimpleStat2 = _interopRequireDefault(_SimpleStat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Constituent = function Constituent(_ref) {
	    var constituent = _ref.constituent;
	    return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	            to: 'xray/field/' + constituent.field.id + '/approximate',
	            className: 'no-decoration'
	        },
	        _react2.default.createElement(
	            'div',
	            { className: 'Grid my3 bg-white bordered rounded shadowed shadow-hover no-decoration' },
	            _react2.default.createElement(
	                'div',
	                { className: 'Grid-cell Cell--1of3 border-right' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'p4' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'text-bold text-brand' },
	                        constituent.field.display_name
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'text-measure text-paragraph' },
	                        constituent.field.description
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flex align-center' },
	                        constituent.min && _react2.default.createElement(_SimpleStat2.default, {
	                            stat: constituent.min
	                        }),
	                        constituent.max && _react2.default.createElement(_SimpleStat2.default, {
	                            stat: constituent.max
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'Grid-cell p3' },
	                _react2.default.createElement(
	                    'div',
	                    { style: { height: 220 } },
	                    constituent.histogram && _react2.default.createElement(_Histogram2.default, { histogram: constituent.histogram.value })
	                )
	            )
	        )
	    );
	};
	
	Constituent.displayName = 'Constituent';
	exports.default = Constituent;

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _Title = __webpack_require__(1538);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _XRayLayout = __webpack_require__(2016);
	
	var _xray = __webpack_require__(2012);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _CostSelect = __webpack_require__(2014);
	
	var _CostSelect2 = _interopRequireDefault(_CostSelect);
	
	var _selectors = __webpack_require__(2003);
	
	var _Constituent = __webpack_require__(2024);
	
	var _Constituent2 = _interopRequireDefault(_Constituent);
	
	var _LoadingAnimation = __webpack_require__(2022);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _utils = __webpack_require__(2020);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        xray: (0, _selectors.getFeatures)(state),
	        constituents: (0, _selectors.getConstituents)(state),
	        isLoading: (0, _selectors.getLoadingStatus)(state),
	        error: (0, _selectors.getError)(state)
	    };
	};
	
	var mapDispatchToProps = {
	    initialize: _xray.initialize,
	    fetchXray: _xray.fetchXray
	};
	
	var SegmentXRay = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _Title2.default)(function (_ref) {
	    var xray = _ref.xray;
	    return xray && xray.segment.name || "Segment";
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(SegmentXRay, _Component);
	
	    function SegmentXRay() {
	        _classCallCheck(this, SegmentXRay);
	
	        return _possibleConstructorReturn(this, (SegmentXRay.__proto__ || Object.getPrototypeOf(SegmentXRay)).apply(this, arguments));
	    }
	
	    _createClass(SegmentXRay, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.initialize();
	            this.fetch();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // HACK Atte Keinänen 9/20/17: We need this for now because the structure of `state.xray.xray` isn't same
	            // for all xray types and if switching to different kind of xray (= rendering different React container)
	            // without resetting the state fails because `state.xray.xray` subproperty lookups fail
	            this.props.initialize();
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch() {
	            var _props = this.props,
	                params = _props.params,
	                fetchXray = _props.fetchXray;
	
	            fetchXray('segment', params.segmentId, params.cost);
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (prevProps.params.cost !== this.props.params.cost) {
	                this.fetch();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                constituents = _props2.constituents,
	                xray = _props2.xray,
	                params = _props2.params,
	                isLoading = _props2.isLoading,
	                error = _props2.error;
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                {
	                    loading: isLoading || !(0, _utils.hasXray)(xray),
	                    error: error,
	                    loadingMessages: _utils.xrayLoadingMessages,
	                    loadingScenes: [_react2.default.createElement(_LoadingAnimation2.default, null)],
	                    noBackground: true
	                },
	                function () {
	                    return _react2.default.createElement(
	                        _XRayLayout.XRayPageWrapper,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'full' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'mt4 mb2 flex align-center py2' },
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        {
	                                            className: 'my2 px2 text-bold text-brand-hover inline-block bordered bg-white p1 h4 no-decoration shadowed rounded',
	                                            to: '/xray/table/' + xray.table.id + '/approximate'
	                                        },
	                                        xray.table.display_name
	                                    ),
	                                    _react2.default.createElement(
	                                        'h1',
	                                        { className: 'mt2 flex align-center' },
	                                        xray.segment.name,
	                                        _react2.default.createElement(_Icon2.default, { name: 'chevronright', className: 'mx1 text-grey-3', size: 16 }),
	                                        _react2.default.createElement(
	                                            'span',
	                                            { className: 'text-grey-3' },
	                                            'X-ray'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'mt1 text-paragraph text-measure' },
	                                        xray.segment.description
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'ml-auto flex align-center' },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { className: 'mr2 text-grey-3' },
	                                        'Fidelity'
	                                    ),
	                                    _react2.default.createElement(_CostSelect2.default, {
	                                        currentCost: params.cost,
	                                        xrayType: 'segment',
	                                        id: xray.segment.id
	                                    })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    {
	                                        to: '/xray/compare/segment/' + xray.segment.id + '/table/' + xray.table.id + '/approximate',
	                                        className: 'Button bg-white text-brand-hover no-decoration'
	                                    },
	                                    _react2.default.createElement(_Icon2.default, { name: 'compare', className: 'mr1' }),
	                                    'Compare with all ' + xray.table.display_name
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'mt2' },
	                                _react2.default.createElement(_XRayLayout.Heading, { heading: 'Fields in this segment' }),
	                                _react2.default.createElement(
	                                    'ol',
	                                    null,
	                                    constituents.map(function (c, i) {
	                                        return _react2.default.createElement(
	                                            'li',
	                                            { key: i },
	                                            _react2.default.createElement(_Constituent2.default, {
	                                                constituent: c
	                                            })
	                                        );
	                                    })
	                                )
	                            )
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return SegmentXRay;
	}(_react.Component)) || _class) || _class);
	SegmentXRay.displayName = 'SegmentXRay';
	exports.default = SegmentXRay;

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cxs = __webpack_require__(2027);
	
	var _cxs2 = _interopRequireDefault(_cxs);
	
	var _reactRedux = __webpack_require__(467);
	
	var _colors = __webpack_require__(881);
	
	var _xray = __webpack_require__(2012);
	
	var _selectors = __webpack_require__(2003);
	
	var _utils = __webpack_require__(2020);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _Visualization = __webpack_require__(1270);
	
	var _Visualization2 = _interopRequireDefault(_Visualization);
	
	var _XRayLayout = __webpack_require__(2016);
	
	var _Periodicity = __webpack_require__(2021);
	
	var _Periodicity2 = _interopRequireDefault(_Periodicity);
	
	var _LoadingAnimation = __webpack_require__(2022);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        xray: (0, _selectors.getXray)(state),
	        isLoading: (0, _selectors.getLoadingStatus)(state),
	        error: (0, _selectors.getError)(state)
	    };
	};
	
	var mapDispatchToProps = {
	    initialize: _xray.initialize,
	    fetchXray: _xray.fetchXray
	};
	
	var GrowthRateDisplay = function GrowthRateDisplay(_ref) {
	    var period = _ref.period;
	    return _react2.default.createElement(
	        'div',
	        { className: 'Grid-cell' },
	        _react2.default.createElement(
	            'div',
	            { className: 'p4 border-right' },
	            _react2.default.createElement(
	                'h4',
	                { className: 'flex align-center' },
	                period.label,
	                period.description && _react2.default.createElement(
	                    _Tooltip2.default,
	                    { tooltip: period.description },
	                    _react2.default.createElement(_Icon2.default, { name: 'infooutlined', style: { marginLeft: 8 }, size: 14 })
	                )
	            ),
	            _react2.default.createElement(
	                'h1',
	                {
	                    className: (0, _cxs2.default)({
	                        color: period.value > 0 ? _colors.saturated.green : _colors.saturated.red
	                    })
	                },
	                period.value && (period.value * 100).toFixed(2),
	                '%'
	            )
	        )
	    );
	};
	
	GrowthRateDisplay.displayName = 'GrowthRateDisplay';
	
	var CardXRay = function (_Component) {
	    _inherits(CardXRay, _Component);
	
	    function CardXRay() {
	        _classCallCheck(this, CardXRay);
	
	        return _possibleConstructorReturn(this, (CardXRay.__proto__ || Object.getPrototypeOf(CardXRay)).apply(this, arguments));
	    }
	
	    _createClass(CardXRay, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props$params = this.props.params,
	                cardId = _props$params.cardId,
	                cost = _props$params.cost;
	
	            this.props.initialize();
	            this.props.fetchXray('card', cardId, cost);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // HACK Atte Keinänen 9/20/17: We need this for now because the structure of `state.xray.xray` isn't same
	            // for all xray types and if switching to different kind of xray (= rendering different React container)
	            // without resetting the state fails because `state.xray.xray` subproperty lookups fail
	            this.props.initialize();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                xray = _props.xray,
	                isLoading = _props.isLoading,
	                error = _props.error;
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                {
	                    loading: isLoading || !(0, _utils.hasXray)(xray),
	                    error: error,
	                    noBackground: true,
	                    loadingMessages: _utils.xrayLoadingMessages,
	                    loadingScenes: [_react2.default.createElement(_LoadingAnimation2.default, null)]
	                },
	                function () {
	                    return _react2.default.createElement(
	                        _XRayLayout.XRayPageWrapper,
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'mt4 mb2' },
	                            _react2.default.createElement(
	                                'h1',
	                                { className: 'my3' },
	                                xray.features.card.name,
	                                ' X-ray'
	                            )
	                        ),
	                        _react2.default.createElement(_XRayLayout.Heading, { heading: 'Growth rate' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'bg-white bordered rounded shadowed' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'Grid Grid--1of4 border-bottom' },
	                                xray.features.DoD.value && _react2.default.createElement(GrowthRateDisplay, { period: xray.features.DoD }),
	                                xray.features.WoW.value && _react2.default.createElement(GrowthRateDisplay, { period: xray.features.WoW }),
	                                xray.features.MoM.value && _react2.default.createElement(GrowthRateDisplay, { period: xray.features.MoM }),
	                                xray.features.YoY.value && _react2.default.createElement(GrowthRateDisplay, { period: xray.features.YoY })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'full' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'py1 px2', style: { height: 320 } },
	                                    _react2.default.createElement(_Visualization2.default, {
	                                        series: [{
	                                            card: xray.features.card,
	                                            data: xray.dataset
	                                        }, {
	                                            card: {
	                                                display: 'line',
	                                                name: 'Growth Trend',
	                                                visualization_settings: {}
	                                            },
	                                            data: xray.features['linear-regression'].value
	                                        }],
	                                        className: 'full-height'
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_XRayLayout.Heading, { heading: xray.features['growth-series'].label }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'full' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bg-white bordered rounded shadowed', style: { height: 220 } },
	                                _react2.default.createElement(_Visualization2.default, {
	                                    series: [{
	                                        card: {
	                                            display: 'line',
	                                            name: 'Trend',
	                                            visualization_settings: {}
	                                        },
	                                        data: _extends({}, xray.features['growth-series'].value, {
	                                            // multiple row value by 100 to display as a %
	                                            rows: xray.features['growth-series'].value.rows.map(function (row) {
	                                                return [row[0], row[1] * 100];
	                                            })
	                                        })
	                                    }],
	                                    className: 'full-height'
	                                })
	                            )
	                        ),
	                        xray.constituents[0] && _react2.default.createElement(_Periodicity2.default, { xray: Object.values(xray.constituents)[0] }),
	                        _react2.default.createElement(_XRayLayout.Heading, { heading: xray.features['seasonal-decomposition'].label }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'full' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'bg-white bordered rounded shadowed', style: { height: 220 } },
	                                _react2.default.createElement(_Visualization2.default, {
	                                    series: [{
	                                        card: {
	                                            display: 'line',
	                                            name: 'Trend',
	                                            visualization_settings: {}
	                                        },
	                                        data: xray.features['seasonal-decomposition'].value.trend
	                                    }, {
	                                        card: {
	                                            display: 'line',
	                                            name: 'Seasonal',
	                                            visualization_settings: {}
	                                        },
	                                        data: xray.features['seasonal-decomposition'].value.seasonal
	                                    }, {
	                                        card: {
	                                            display: 'line',
	                                            name: 'Residual',
	                                            visualization_settings: {}
	                                        },
	                                        data: xray.features['seasonal-decomposition'].value.residual
	                                    }],
	                                    className: 'full-height'
	                                })
	                            )
	                        )
	                    );
	                }
	            );
	        }
	    }]);
	
	    return CardXRay;
	}(_react.Component);
	
	CardXRay.displayName = 'CardXRay';
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CardXRay);

/***/ }),
/* 2027 */
/***/ (function(module, exports) {

	'use strict';
	
	var cache = {};
	var rules = [];
	var insert = function insert(rule) {
	  return rules.push(rule);
	};
	var hyph = function hyph(s) {
	  return s.replace(/[A-Z]|^ms/g, '-$&').toLowerCase();
	};
	var px = function px(n) {
	  return typeof n === 'number' ? n + 'px' : n;
	};
	var mx = function mx(rule, media) {
	  return media ? media + '{' + rule + '}' : rule;
	};
	var rx = function rx(cn, prop, val) {
	  return '.' + cn + '{' + hyph(prop) + ':' + px(val) + '}';
	};
	var noAnd = function noAnd(s) {
	  return s.replace(/&/g, '');
	};
	
	var parse = function parse(obj) {
	  var child = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var media = arguments[2];
	  return Object.keys(obj).map(function (key) {
	    var val = obj[key];
	    if (val === null) return '';
	    if (typeof val === 'object') {
	      var m2 = /^@/.test(key) ? key : null;
	      var c2 = m2 ? child : child + key;
	      return parse(val, c2, m2 || media);
	    }
	    var _key = key + val + child + media;
	    if (cache[_key]) return cache[_key];
	    var className = 'x' + rules.length.toString(36);
	    insert(mx(rx(className + noAnd(child), key, val), media));
	    cache[_key] = className;
	    return className;
	  }).join(' ');
	};
	
	module.exports = function () {
	  for (var _len = arguments.length, styles = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    styles[_key2] = arguments[_key2];
	  }
	
	  return styles.map(function (style) {
	    return parse(style);
	  }).join(' ').trim();
	};
	
	module.exports.css = function () {
	  return rules.sort().join('');
	};
	
	module.exports.reset = function () {
	  cache = {};
	  while (rules.length) {
	    rules.pop();
	  }
	};
	
	if (typeof document !== 'undefined') {
	  var sheet = document.head.appendChild(document.createElement('style')).sheet;
	  insert = function insert(rule) {
	    rules.push(rule);
	    sheet.insertRule(rule, sheet.cssRules.length);
	  };
	}

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Title = __webpack_require__(1538);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _xray = __webpack_require__(2012);
	
	var _selectors = __webpack_require__(2003);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _XRayComparison = __webpack_require__(2029);
	
	var _XRayComparison2 = _interopRequireDefault(_XRayComparison);
	
	var _LoadingAnimation = __webpack_require__(2022);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	var _utils = __webpack_require__(2020);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        comparison: (0, _selectors.getComparison)(state),
	        fields: (0, _selectors.getComparisonFields)(state),
	        contributors: (0, _selectors.getComparisonContributors)(state),
	        itemA: (0, _selectors.getSegmentItem)(state, 0),
	        itemB: (0, _selectors.getSegmentItem)(state, 1),
	        isLoading: (0, _selectors.getLoadingStatus)(state),
	        error: (0, _selectors.getError)(state)
	    };
	};
	
	var mapDispatchToProps = {
	    initialize: _xray.initialize,
	    fetchSegmentComparison: _xray.fetchSegmentComparison
	};
	
	var SegmentComparison = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _Title2.default)(function (props) {
	    return (0, _selectors.getTitle)(props);
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(SegmentComparison, _Component);
	
	    function SegmentComparison() {
	        _classCallCheck(this, SegmentComparison);
	
	        return _possibleConstructorReturn(this, (SegmentComparison.__proto__ || Object.getPrototypeOf(SegmentComparison)).apply(this, arguments));
	    }
	
	    _createClass(SegmentComparison, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props$params = this.props.params,
	                cost = _props$params.cost,
	                segmentId1 = _props$params.segmentId1,
	                segmentId2 = _props$params.segmentId2;
	
	            this.props.initialize();
	            this.props.fetchSegmentComparison(segmentId1, segmentId2, cost);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // HACK Atte Keinänen 9/20/17: We need this for now because the structure of `state.xray.xray` isn't same
	            // for all xray types and if switching to different kind of xray (= rendering different React container)
	            // without resetting the state fails because `state.xray.xray` subproperty lookups fail
	            this.props.initialize();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                comparison = _props.comparison,
	                contributors = _props.contributors,
	                error = _props.error,
	                fields = _props.fields,
	                isLoading = _props.isLoading,
	                itemA = _props.itemA,
	                itemB = _props.itemB,
	                params = _props.params;
	
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                {
	                    loading: isLoading || !(0, _utils.hasComparison)(comparison),
	                    error: error,
	                    noBackground: true,
	                    loadingMessages: _utils.comparisonLoadingMessages,
	                    loadingScenes: [_react2.default.createElement(_LoadingAnimation2.default, null)]
	                },
	                function () {
	                    return _react2.default.createElement(_XRayComparison2.default, {
	                        cost: params.cost,
	                        fields: _underscore2.default.sortBy(fields, 'distance').reverse(),
	                        comparisonFields: ['Difference', 'Entropy', 'Histogram', 'Nil%'],
	                        contributors: contributors,
	                        comparison: comparison.comparison,
	                        itemA: itemA,
	                        itemB: itemB
	                    });
	                }
	            );
	        }
	    }]);
	
	    return SegmentComparison;
	}(_react.Component)) || _class) || _class);
	SegmentComparison.displayName = 'SegmentComparison';
	exports.default = SegmentComparison;

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _color = __webpack_require__(1290);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _Visualization = __webpack_require__(1270);
	
	var _Visualization2 = _interopRequireDefault(_Visualization);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _XRayLayout = __webpack_require__(2016);
	
	var _ItemLink = __webpack_require__(2030);
	
	var _ItemLink2 = _interopRequireDefault(_ItemLink);
	
	var _ComparisonHeader = __webpack_require__(2031);
	
	var _ComparisonHeader2 = _interopRequireDefault(_ComparisonHeader);
	
	var _schema_metadata = __webpack_require__(867);
	
	var _utils = __webpack_require__(2020);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// right now we rely on knowing that itemB is the only one that
	// can contain a table
	/*
	const fieldLinkUrl = (itemA, itemB, fieldName) => {
	    let url = `segments/${itemA.id}/${itemB.id}`
	    if(itemB.itemType === 'table') {
	        url = `segment/${itemA.id}/table/${itemB.id}`
	    }
	    return `/xray/compare/${url}/field/${fieldName}/approximate`
	}
	*/
	
	var itemLinkUrl = function itemLinkUrl(item) {
	    return '/xray/' + item.itemType + '/' + item.id + '/approximate';
	};
	
	var CompareInts = function CompareInts(_ref) {
	    var itemA = _ref.itemA,
	        itemAColor = _ref.itemAColor,
	        itemB = _ref.itemB,
	        itemBColor = _ref.itemBColor;
	    return _react2.default.createElement(
	        'div',
	        { className: 'flex' },
	        _react2.default.createElement(
	            'div',
	            {
	                className: 'p2 text-align-center flex-full',
	                style: {
	                    color: itemAColor.text,
	                    backgroundColor: (0, _color2.default)(itemAColor.main).lighten(0.1)
	                }
	            },
	            _react2.default.createElement(
	                'h3',
	                null,
	                itemA
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            {
	                className: 'p2 text-align-center flex-full',
	                style: {
	                    color: itemBColor.text,
	                    backgroundColor: (0, _color2.default)(itemBColor.main).lighten(0.4)
	                }
	            },
	            _react2.default.createElement(
	                'h3',
	                null,
	                itemB
	            )
	        )
	    );
	};
	
	CompareInts.displayName = 'CompareInts';
	var Contributor = function Contributor(_ref2) {
	    var contributor = _ref2.contributor,
	        itemA = _ref2.itemA,
	        itemB = _ref2.itemB;
	    return _react2.default.createElement(
	        'div',
	        { className: 'full-height' },
	        _react2.default.createElement(
	            'h3',
	            { className: 'mb2' },
	            contributor.field.display_name
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'ComparisonContributor bg-white shadowed rounded bordered full-height' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'p2 flex align-center' },
	                    _react2.default.createElement(
	                        'h4',
	                        null,
	                        contributor.feature.label
	                    ),
	                    _react2.default.createElement(
	                        _Tooltip2.default,
	                        { tooltip: contributor.feature.description },
	                        _react2.default.createElement(_Icon2.default, {
	                            name: 'infooutlined',
	                            className: 'ml1 text-grey-4',
	                            size: 14
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'py1' },
	                    contributor.feature.type === 'histogram' ? _react2.default.createElement(CompareHistograms, {
	                        itemA: contributor.feature.value.a,
	                        itemB: contributor.feature.value.b,
	                        itemAColor: itemA.color.main,
	                        itemBColor: itemB.color.main,
	                        showAxis: true,
	                        height: 120
	                    }) : _react2.default.createElement(
	                        'div',
	                        { className: 'flex align-center px2 py3' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'p2 lg-p3', style: { color: itemA.color.text } },
	                            contributor.feature.value.a
	                        ),
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'p2 lg-p3', style: { color: itemB.color.text } },
	                            contributor.feature.value.b
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement('div', { className: 'flex' })
	        )
	    );
	};
	
	Contributor.displayName = 'Contributor';
	var CompareHistograms = function CompareHistograms(_ref3) {
	    var itemA = _ref3.itemA,
	        itemAColor = _ref3.itemAColor,
	        itemB = _ref3.itemB,
	        itemBColor = _ref3.itemBColor,
	        _ref3$showAxis = _ref3.showAxis,
	        showAxis = _ref3$showAxis === undefined ? false : _ref3$showAxis,
	        _ref3$height = _ref3.height,
	        height = _ref3$height === undefined ? 60 : _ref3$height;
	    return _react2.default.createElement(
	        'div',
	        { className: 'flex', style: { height: height } },
	        _react2.default.createElement(
	            'div',
	            { className: 'flex-full' },
	            _react2.default.createElement(_Visualization2.default, {
	                className: 'full-height',
	                series: [{
	                    card: {
	                        display: "bar",
	                        visualization_settings: {
	                            "graph.colors": [itemAColor, itemBColor],
	                            "graph.x_axis.axis_enabled": showAxis,
	                            "graph.x_axis.labels_enabled": showAxis,
	                            "graph.y_axis.axis_enabled": showAxis,
	                            "graph.y_axis.labels_enabled": showAxis
	                        }
	                    },
	                    data: itemA
	                }, {
	                    card: {
	                        display: "bar",
	                        visualization_settings: {
	                            "graph.colors": [itemAColor, itemBColor],
	                            "graph.x_axis.axis_enabled": showAxis,
	                            "graph.x_axis.labels_enabled": showAxis,
	                            "graph.y_axis.axis_enabled": showAxis,
	                            "graph.y_axis.labels_enabled": showAxis
	                        }
	                    },
	                    data: itemB
	                }]
	            })
	        )
	    );
	};
	
	CompareHistograms.displayName = 'CompareHistograms';
	var XRayComparison = function XRayComparison(_ref4) {
	    var contributors = _ref4.contributors,
	        comparison = _ref4.comparison,
	        comparisonFields = _ref4.comparisonFields,
	        itemA = _ref4.itemA,
	        itemB = _ref4.itemB,
	        fields = _ref4.fields,
	        cost = _ref4.cost;
	    return _react2.default.createElement(
	        _XRayLayout.XRayPageWrapper,
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_ComparisonHeader2.default, {
	                cost: cost
	            }),
	            _react2.default.createElement(
	                'div',
	                { className: 'flex' },
	                _react2.default.createElement(_ItemLink2.default, {
	                    link: itemLinkUrl(itemA),
	                    item: itemA
	                }),
	                _react2.default.createElement(_ItemLink2.default, {
	                    link: itemLinkUrl(itemB),
	                    item: itemB
	                })
	            )
	        ),
	        _react2.default.createElement(_XRayLayout.Heading, { heading: 'Overview' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'bordered rounded bg-white shadowed p4' },
	            _react2.default.createElement(
	                'h3',
	                { className: 'text-grey-3' },
	                'Count'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'flex my1' },
	                _react2.default.createElement(
	                    'h1',
	                    {
	                        className: 'mr1',
	                        style: { color: itemA.color.text }
	                    },
	                    itemA.constituents[fields[0].name].count.value
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'h1 text-grey-1 mr1' },
	                    '/'
	                ),
	                _react2.default.createElement(
	                    'h1',
	                    { style: { color: itemB.color.text } },
	                    itemB.constituents[fields[1].name].count.value
	                )
	            )
	        ),
	        contributors && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_XRayLayout.Heading, { heading: 'Potentially interesting differences' }),
	            _react2.default.createElement(
	                'ol',
	                { className: 'Grid Grid--gutters Grid--1of3' },
	                contributors.map(function (contributor) {
	                    return _react2.default.createElement(
	                        'li',
	                        { className: 'Grid-cell', key: contributor.field.id },
	                        _react2.default.createElement(Contributor, {
	                            contributor: contributor,
	                            itemA: itemA,
	                            itemB: itemB
	                        })
	                    );
	                })
	            )
	        ),
	        _react2.default.createElement(_XRayLayout.Heading, { heading: 'Full breakdown' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'bordered rounded bg-white shadowed' },
	            _react2.default.createElement(
	                'div',
	                { className: 'flex p2' },
	                _react2.default.createElement(
	                    'h4',
	                    { className: 'mr1', style: { color: itemA.color.text } },
	                    itemA.name
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    { style: { color: itemB.color.text } },
	                    itemB.name
	                )
	            ),
	            _react2.default.createElement(
	                'table',
	                { className: 'ComparisonTable full' },
	                _react2.default.createElement(
	                    'thead',
	                    { className: 'full border-bottom' },
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'px2' },
	                            'Field'
	                        ),
	                        comparisonFields.map(function (c) {
	                            return _react2.default.createElement(
	                                'th',
	                                {
	                                    key: c,
	                                    className: 'px2 py2'
	                                },
	                                c
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    { className: 'full' },
	                    fields.map(function (field) {
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: field.id },
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'border-right' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    {
	                                        to: '/xray/field/' + field.id + '/approximate',
	                                        className: 'px2 no-decoration text-brand flex align-center'
	                                    },
	                                    _react2.default.createElement(_Icon2.default, { name: (0, _schema_metadata.getIconForField)(field), className: 'text-grey-2 mr1' }),
	                                    _react2.default.createElement(
	                                        'h3',
	                                        null,
	                                        field.display_name
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'border-right px2' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    (0, _utils.distanceToPhrase)(comparison[field.name].distance)
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'border-right' },
	                                itemA.constituents[field.name]['entropy'] && _react2.default.createElement(CompareInts, {
	                                    itemA: itemA.constituents[field.name]['entropy']['value'],
	                                    itemAColor: itemA.color,
	                                    itemB: itemB.constituents[field.name]['entropy']['value'],
	                                    itemBColor: itemB.color
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                {
	                                    className: 'px2 border-right',
	                                    style: { maxWidth: 200, minHeight: 120 }
	                                },
	                                itemA.constituents[field.name]['histogram'] && _react2.default.createElement(CompareHistograms, {
	                                    itemA: itemA.constituents[field.name]['histogram'].value,
	                                    itemAColor: itemA.color.main,
	                                    itemB: itemB.constituents[field.name]['histogram'].value,
	                                    itemBColor: itemB.color.main
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'px2 h3' },
	                                itemA.constituents[field.name]['nil%'] && _react2.default.createElement(CompareInts, {
	                                    itemA: itemA.constituents[field.name]['nil%']['value'],
	                                    itemAColor: itemA.color,
	                                    itemB: itemB.constituents[field.name]['nil%']['value'],
	                                    itemBColor: itemB.color
	                                })
	                            )
	                        );
	                    })
	                )
	            )
	        )
	    );
	};
	
	XRayComparison.displayName = 'XRayComparison';
	exports.default = XRayComparison;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ItemLink = function ItemLink(_ref) {
	    var link = _ref.link,
	        item = _ref.item;
	    return _react2.default.createElement(
	        _reactRouter.Link,
	        {
	            to: link,
	            className: 'no-decoration flex align-center bordered shadowed bg-white p1 px2 rounded mr1'
	        },
	        _react2.default.createElement('div', { style: {
	                width: 12,
	                height: 12,
	                backgroundColor: item.color.main,
	                borderRadius: 99,
	                display: 'block'
	            } }),
	        _react2.default.createElement(
	            'h2',
	            { className: 'ml1' },
	            item.name
	        )
	    );
	};
	
	ItemLink.displayName = 'ItemLink';
	exports.default = ItemLink;

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _CostSelect = __webpack_require__(2014);
	
	var _CostSelect2 = _interopRequireDefault(_CostSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComparisonHeader = function ComparisonHeader(_ref) {
	    var cost = _ref.cost;
	    return _react2.default.createElement(
	        'div',
	        { className: 'my4 flex align-center' },
	        _react2.default.createElement(
	            'h1',
	            { className: 'flex align-center' },
	            _react2.default.createElement(_Icon2.default, { name: 'compare', className: 'mr1', size: 32 }),
	            'Comparing'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'ml-auto flex align-center' },
	            _react2.default.createElement(
	                'h3',
	                { className: 'text-grey-3 mr1' },
	                'Fidelity'
	            ),
	            _react2.default.createElement(_CostSelect2.default, {
	                currentCost: cost
	            })
	        )
	    );
	};
	
	ComparisonHeader.displayName = 'ComparisonHeader';
	exports.default = ComparisonHeader;

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _Title = __webpack_require__(1538);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _xray = __webpack_require__(2012);
	
	var _selectors = __webpack_require__(2003);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _XRayComparison = __webpack_require__(2029);
	
	var _XRayComparison2 = _interopRequireDefault(_XRayComparison);
	
	var _utils = __webpack_require__(2020);
	
	var _LoadingAnimation = __webpack_require__(2022);
	
	var _LoadingAnimation2 = _interopRequireDefault(_LoadingAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        comparison: (0, _selectors.getComparison)(state),
	        fields: (0, _selectors.getComparisonFields)(state),
	        itemA: (0, _selectors.getSegmentItem)(state),
	        itemB: (0, _selectors.getTableItem)(state),
	        isLoading: (0, _selectors.getLoadingStatus)(state),
	        error: (0, _selectors.getError)(state)
	    };
	};
	
	var mapDispatchToProps = {
	    initialize: _xray.initialize,
	    fetchSegmentTableComparison: _xray.fetchSegmentTableComparison
	};
	
	var SegmentTableComparison = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _Title2.default)(function (props) {
	    return (0, _selectors.getTitle)(props);
	}), _dec(_class = _dec2(_class = function (_Component) {
	    _inherits(SegmentTableComparison, _Component);
	
	    function SegmentTableComparison() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, SegmentTableComparison);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SegmentTableComparison.__proto__ || Object.getPrototypeOf(SegmentTableComparison)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	            error: null
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SegmentTableComparison, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var _props$params = this.props.params,
	                cost = _props$params.cost,
	                segmentId = _props$params.segmentId,
	                tableId = _props$params.tableId;
	
	            this.props.initialize();
	            this.props.fetchSegmentTableComparison(segmentId, tableId, cost);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            // HACK Atte Keinänen 9/20/17: We need this for now because the structure of `state.xray.xray` isn't same
	            // for all xray types and if switching to different kind of xray (= rendering different React container)
	            // without resetting the state fails because `state.xray.xray` subproperty lookups fail
	            this.props.initialize();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                params = _props.params,
	                fields = _props.fields,
	                comparison = _props.comparison,
	                itemA = _props.itemA,
	                itemB = _props.itemB,
	                isLoading = _props.isLoading,
	                error = _props.error;
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                {
	                    loading: isLoading || !(0, _utils.hasComparison)(comparison),
	                    error: error,
	                    noBackground: true,
	                    loadingMessages: _utils.comparisonLoadingMessages,
	                    loadingScenes: [_react2.default.createElement(_LoadingAnimation2.default, null)]
	                },
	                function () {
	                    return _react2.default.createElement(_XRayComparison2.default, {
	                        cost: params.cost,
	                        fields: _underscore2.default.sortBy(fields, 'distance').reverse(),
	                        comparisonFields: ['Difference', 'Entropy', 'Histogram', 'Nil%'],
	                        comparison: comparison.comparison,
	                        itemA: itemA,
	                        itemB: itemB
	                    });
	                }
	            );
	        }
	    }]);
	
	    return SegmentTableComparison;
	}(_react.Component)) || _class) || _class);
	SegmentTableComparison.displayName = 'SegmentTableComparison';
	exports.default = SegmentTableComparison;

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Title = __webpack_require__(1538);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _DataPermissionsApp = __webpack_require__(2034);
	
	var _DataPermissionsApp2 = _interopRequireDefault(_DataPermissionsApp);
	
	var _DatabasesPermissionsApp = __webpack_require__(2035);
	
	var _DatabasesPermissionsApp2 = _interopRequireDefault(_DatabasesPermissionsApp);
	
	var _SchemasPermissionsApp = __webpack_require__(2036);
	
	var _SchemasPermissionsApp2 = _interopRequireDefault(_SchemasPermissionsApp);
	
	var _TablesPermissionsApp = __webpack_require__(2037);
	
	var _TablesPermissionsApp2 = _interopRequireDefault(_TablesPermissionsApp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getRoutes = function getRoutes(store) {
	    return _react2.default.createElement(
	        _Title.Route,
	        { title: "Permissions", path: "permissions", component: _DataPermissionsApp2.default },
	        _react2.default.createElement(_reactRouter.IndexRedirect, { to: "databases" }),
	        _react2.default.createElement(_Title.Route, { path: "databases", component: _DatabasesPermissionsApp2.default }),
	        _react2.default.createElement(_Title.Route, { path: "databases/:databaseId/schemas", component: _SchemasPermissionsApp2.default }),
	        _react2.default.createElement(_Title.Route, { path: "databases/:databaseId/schemas/:schemaName/tables", component: _TablesPermissionsApp2.default }),
	        _react2.default.createElement(_Title.Route, { path: "databases/:databaseId/tables", component: function component(props) {
	                return (// eslint-disable-line react/display-name
	                    _react2.default.createElement(_TablesPermissionsApp2.default, _extends({}, props, { params: _extends({}, props.params, { schemaName: "" }) }))
	                );
	            } })
	    );
	};
	
	getRoutes.displayName = "getRoutes";
	exports.default = getRoutes;

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _PermissionsApp = __webpack_require__(1681);
	
	var _PermissionsApp2 = _interopRequireDefault(_PermissionsApp);
	
	var _services = __webpack_require__(857);
	
	var _metadata = __webpack_require__(1110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataPermissionsApp = (_dec = (0, _reactRedux.connect)(null, { fetchRealDatabases: _metadata.fetchRealDatabases }), _dec(_class = function (_Component) {
	    _inherits(DataPermissionsApp, _Component);
	
	    function DataPermissionsApp() {
	        _classCallCheck(this, DataPermissionsApp);
	
	        return _possibleConstructorReturn(this, (DataPermissionsApp.__proto__ || Object.getPrototypeOf(DataPermissionsApp)).apply(this, arguments));
	    }
	
	    _createClass(DataPermissionsApp, [{
	        key: "componentWillMount",
	        value: function componentWillMount() {
	            this.props.fetchRealDatabases(true);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_PermissionsApp2.default, _extends({}, this.props, {
	                load: _services.PermissionsApi.graph,
	                save: _services.PermissionsApi.updateGraph
	            }));
	        }
	    }]);
	
	    return DataPermissionsApp;
	}(_react.Component)) || _class);
	DataPermissionsApp.displayName = "DataPermissionsApp";
	exports.default = DataPermissionsApp;

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(467);
	
	var _PermissionsEditor = __webpack_require__(1672);
	
	var _PermissionsEditor2 = _interopRequireDefault(_PermissionsEditor);
	
	var _selectors = __webpack_require__(1684);
	
	var _permissions = __webpack_require__(1682);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        grid: (0, _selectors.getDatabasesPermissionsGrid)(state, props),
	        isDirty: (0, _selectors.getIsDirty)(state, props),
	        saveError: (0, _selectors.getSaveError)(state, props),
	        diff: (0, _selectors.getDiff)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    onUpdatePermission: _permissions.updatePermission,
	    onSave: _permissions.savePermissions,
	    onCancel: _permissions.loadPermissions
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PermissionsEditor2.default);

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(467);
	
	var _PermissionsEditor = __webpack_require__(1672);
	
	var _PermissionsEditor2 = _interopRequireDefault(_PermissionsEditor);
	
	var _selectors = __webpack_require__(1684);
	
	var _permissions = __webpack_require__(1682);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        grid: (0, _selectors.getSchemasPermissionsGrid)(state, props),
	        isDirty: (0, _selectors.getIsDirty)(state, props),
	        saveError: (0, _selectors.getSaveError)(state, props),
	        diff: (0, _selectors.getDiff)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    onUpdatePermission: _permissions.updatePermission,
	    onSave: _permissions.savePermissions,
	    onCancel: _permissions.loadPermissions
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PermissionsEditor2.default);

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRedux = __webpack_require__(467);
	
	var _PermissionsEditor = __webpack_require__(1672);
	
	var _PermissionsEditor2 = _interopRequireDefault(_PermissionsEditor);
	
	var _selectors = __webpack_require__(1684);
	
	var _permissions = __webpack_require__(1682);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        grid: (0, _selectors.getTablesPermissionsGrid)(state, props),
	        isDirty: (0, _selectors.getIsDirty)(state, props),
	        saveError: (0, _selectors.getSaveError)(state, props),
	        diff: (0, _selectors.getDiff)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    onUpdatePermission: _permissions.updatePermission,
	    onSave: _permissions.savePermissions,
	    onCancel: _permissions.loadPermissions
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PermissionsEditor2.default);

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = exports.MODAL_USER_ADDED_WITH_PASSWORD = exports.MODAL_USER_ADDED_WITH_INVITE = exports.MODAL_RESET_PASSWORD_EMAIL = exports.MODAL_RESET_PASSWORD_MANUAL = exports.MODAL_RESET_PASSWORD = exports.MODAL_REMOVE_USER = exports.MODAL_INVITE_RESENT = exports.MODAL_EDIT_DETAILS = exports.MODAL_ADD_PERSON = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _reactRedux = __webpack_require__(467);
	
	var _LoadingAndErrorWrapper = __webpack_require__(1502);
	
	var _LoadingAndErrorWrapper2 = _interopRequireDefault(_LoadingAndErrorWrapper);
	
	var _AdminPaneLayout = __webpack_require__(2039);
	
	var _AdminPaneLayout2 = _interopRequireDefault(_AdminPaneLayout);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _PasswordReveal = __webpack_require__(2040);
	
	var _PasswordReveal2 = _interopRequireDefault(_PasswordReveal);
	
	var _UserAvatar = __webpack_require__(1556);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Tooltip = __webpack_require__(911);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _EditUserForm = __webpack_require__(2041);
	
	var _EditUserForm2 = _interopRequireDefault(_EditUserForm);
	
	var _UserActionsSelect = __webpack_require__(2042);
	
	var _UserActionsSelect2 = _interopRequireDefault(_UserActionsSelect);
	
	var _UserGroupSelect = __webpack_require__(2043);
	
	var _UserGroupSelect2 = _interopRequireDefault(_UserGroupSelect);
	
	var _selectors = __webpack_require__(2044);
	
	var _people = __webpack_require__(2045);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MODAL_ADD_PERSON = exports.MODAL_ADD_PERSON = 'MODAL_ADD_PERSON';
	var MODAL_EDIT_DETAILS = exports.MODAL_EDIT_DETAILS = 'MODAL_EDIT_DETAILS';
	var MODAL_INVITE_RESENT = exports.MODAL_INVITE_RESENT = 'MODAL_INVITE_RESENT';
	var MODAL_REMOVE_USER = exports.MODAL_REMOVE_USER = 'MODAL_REMOVE_USER';
	var MODAL_RESET_PASSWORD = exports.MODAL_RESET_PASSWORD = 'MODAL_RESET_PASSWORD';
	var MODAL_RESET_PASSWORD_MANUAL = exports.MODAL_RESET_PASSWORD_MANUAL = 'MODAL_RESET_PASSWORD_MANUAL';
	var MODAL_RESET_PASSWORD_EMAIL = exports.MODAL_RESET_PASSWORD_EMAIL = 'MODAL_RESET_PASSWORD_EMAIL';
	var MODAL_USER_ADDED_WITH_INVITE = exports.MODAL_USER_ADDED_WITH_INVITE = 'MODAL_USER_ADDED_WITH_INVITE';
	var MODAL_USER_ADDED_WITH_PASSWORD = exports.MODAL_USER_ADDED_WITH_PASSWORD = 'MODAL_USER_ADDED_WITH_PASSWORD';
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        users: (0, _selectors.getUsers)(state, props),
	        modal: (0, _selectors.getModal)(state, props),
	        user: state.currentUser,
	        groups: (0, _selectors.getGroups)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    createUser: _people.createUser,
	    deleteUser: _people.deleteUser,
	    fetchUsers: _people.fetchUsers,
	    resetPasswordManually: _people.resetPasswordManually,
	    resetPasswordViaEmail: _people.resetPasswordViaEmail,
	    showModal: _people.showModal,
	    updateUser: _people.updateUser,
	    resendInvite: _people.resendInvite,
	    loadGroups: _people.loadGroups,
	    loadMemberships: _people.loadMemberships,
	    createMembership: _people.createMembership,
	    deleteMembership: _people.deleteMembership
	};
	
	var PeopleListingApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
	    _inherits(PeopleListingApp, _Component);
	
	    function PeopleListingApp(props, context) {
	        _classCallCheck(this, PeopleListingApp);
	
	        var _this = _possibleConstructorReturn(this, (PeopleListingApp.__proto__ || Object.getPrototypeOf(PeopleListingApp)).call(this, props, context));
	
	        _this.onCloseModal = function () {
	            _this.props.showModal(null);
	        };
	
	        _this.state = { error: null };
	        return _this;
	    }
	
	    _createClass(PeopleListingApp, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.prev = 0;
	                                _context.next = 3;
	                                return Promise.all([this.props.fetchUsers(), this.props.loadGroups(), this.props.loadMemberships()]);
	
	                            case 3:
	                                _context.next = 8;
	                                break;
	
	                            case 5:
	                                _context.prev = 5;
	                                _context.t0 = _context["catch"](0);
	
	                                this.setState({ error: _context.t0 });
	
	                            case 8:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this, [[0, 5]]);
	            }));
	
	            function componentDidMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	    }, {
	        key: "onAddPerson",
	        value: function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(user) {
	                var modal;
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                // close the modal no matter what
	                                this.props.showModal(null);
	
	                                if (user) {
	                                    modal = MODAL_USER_ADDED_WITH_INVITE;
	
	                                    // we assume invite style creation and tweak as needed if email not available
	
	                                    if (!_settings2.default.isEmailConfigured()) {
	                                        modal = MODAL_USER_ADDED_WITH_PASSWORD;
	                                        user.password = _utils2.default.generatePassword();
	                                    }
	
	                                    // create the user
	                                    this.props.createUser(user);
	
	                                    // carry on
	                                    this.props.showModal({
	                                        type: modal,
	                                        details: {
	                                            user: user
	                                        }
	                                    });
	                                }
	
	                            case 2:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function onAddPerson(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return onAddPerson;
	        }()
	    }, {
	        key: "onEditDetails",
	        value: function onEditDetails(user) {
	            // close the modal no matter what
	            this.props.showModal(null);
	
	            if (user) {
	                this.props.updateUser(user);
	            }
	        }
	    }, {
	        key: "onPasswordResetConfirm",
	        value: function onPasswordResetConfirm(user) {
	            if (_settings2.default.isEmailConfigured()) {
	                // trigger password reset email
	                this.props.resetPasswordViaEmail(user);
	
	                // show confirmation modal
	                this.props.showModal({
	                    type: MODAL_RESET_PASSWORD_EMAIL,
	                    details: { user: user }
	                });
	            } else {
	                // generate a password
	                var password = _utils2.default.generatePassword(14, _settings2.default.get('password_complexity'));
	
	                // trigger the reset
	                this.props.resetPasswordManually(user, password);
	
	                // show confirmation modal
	                this.props.showModal({
	                    type: MODAL_RESET_PASSWORD_MANUAL,
	                    details: { password: password, user: user }
	                });
	            }
	        }
	    }, {
	        key: "onRemoveUserConfirm",
	        value: function onRemoveUserConfirm(user) {
	            this.props.showModal(null);
	            this.props.deleteUser(user);
	        }
	    }, {
	        key: "renderAddPersonModal",
	        value: function renderAddPersonModal(modalDetails) {
	            return _react2.default.createElement(
	                _Modal2.default,
	                { title: "Who do you want to add?", onClose: this.onCloseModal },
	                _react2.default.createElement(_EditUserForm2.default, {
	                    buttonText: "Add",
	                    submitFn: this.onAddPerson.bind(this),
	                    groups: this.props.groups
	                })
	            );
	        }
	    }, {
	        key: "renderEditDetailsModal",
	        value: function renderEditDetailsModal(modalDetails) {
	            var user = modalDetails.user;
	
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { full: true, form: true, title: "Edit " + user.first_name + "'s details", onClose: this.onCloseModal },
	                _react2.default.createElement(_EditUserForm2.default, {
	                    user: user,
	                    submitFn: this.onEditDetails.bind(this)
	                })
	            );
	        }
	    }, {
	        key: "renderUserAddedWithPasswordModal",
	        value: function renderUserAddedWithPasswordModal(modalDetails) {
	            var _this2 = this;
	
	            var user = modalDetails.user;
	
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { small: true,
	                    title: user.first_name + " has been added",
	                    footer: [_react2.default.createElement(
	                        _Button2.default,
	                        { onClick: function onClick() {
	                                return _this2.props.showModal({ type: MODAL_ADD_PERSON });
	                            } },
	                        "Add another person"
	                    ), _react2.default.createElement(
	                        _Button2.default,
	                        { primary: true, onClick: this.onCloseModal },
	                        "Done"
	                    )],
	                    onClose: this.onCloseModal
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "px4 pb4" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "pb4" },
	                        "We couldn\u2019t send them an email invitation, so make sure to tell them to log in using ",
	                        _react2.default.createElement(
	                            "span",
	                            { className: "text-bold" },
	                            user.email,
	                            " "
	                        ),
	                        "and this password we\u2019ve generated for them:"
	                    ),
	                    _react2.default.createElement(_PasswordReveal2.default, { password: user.password }),
	                    _react2.default.createElement(
	                        "div",
	                        { style: { paddingLeft: "5em", paddingRight: "5em" }, className: "pt4 text-centered" },
	                        "If you want to be able to send email invites, just go to the ",
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: "/admin/settings/email", className: "link text-bold" },
	                            "Email Settings"
	                        ),
	                        " page."
	                    )
	                )
	            );
	        }
	    }, {
	        key: "renderUserAddedWithInviteModal",
	        value: function renderUserAddedWithInviteModal(modalDetails) {
	            var _this3 = this;
	
	            var user = modalDetails.user;
	
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { small: true,
	                    title: user.first_name + " has been added",
	                    footer: [_react2.default.createElement(
	                        _Button2.default,
	                        { onClick: function onClick() {
	                                return _this3.props.showModal({ type: MODAL_ADD_PERSON });
	                            } },
	                        "Add another person"
	                    ), _react2.default.createElement(
	                        _Button2.default,
	                        { primary: true, onClick: this.onCloseModal },
	                        "Done"
	                    )],
	                    onClose: this.onCloseModal
	                },
	                _react2.default.createElement(
	                    "div",
	                    { style: { paddingLeft: "5em", paddingRight: "5em" }, className: "pb4" },
	                    "We\u2019ve sent an invite to ",
	                    _react2.default.createElement(
	                        "span",
	                        { className: "text-bold" },
	                        user.email
	                    ),
	                    " with instructions to set their password."
	                )
	            );
	        }
	    }, {
	        key: "renderInviteResentModal",
	        value: function renderInviteResentModal(modalDetails) {
	            var user = modalDetails.user;
	
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { small: true, form: true,
	                    title: "We've re-sent " + user.first_name + "'s invite",
	                    footer: [_react2.default.createElement(
	                        _Button2.default,
	                        { primary: true, onClick: this.onCloseModal },
	                        "Okay"
	                    )],
	                    onClose: this.onCloseModal
	                },
	                _react2.default.createElement(
	                    "p",
	                    { className: "text-paragraph pb2" },
	                    "Any previous email invites they have will no longer work."
	                )
	            );
	        }
	    }, {
	        key: "renderRemoveUserModal",
	        value: function renderRemoveUserModal(modalDetails) {
	            var _this4 = this;
	
	            var user = modalDetails.user;
	
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { small: true,
	                    title: "Remove " + user.common_name + "?",
	                    footer: [_react2.default.createElement(
	                        _Button2.default,
	                        { onClick: this.onCloseModal },
	                        "Cancel"
	                    ), _react2.default.createElement(
	                        _Button2.default,
	                        { className: "Button--danger", onClick: function onClick() {
	                                return _this4.onRemoveUserConfirm(user);
	                            } },
	                        "Remove"
	                    )],
	                    onClose: this.onCloseModal
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "px4 pb4" },
	                    user.first_name,
	                    " won't be able to log in anymore.  This can't be undone."
	                )
	            );
	        }
	    }, {
	        key: "renderResetPasswordModal",
	        value: function renderResetPasswordModal(modalDetails) {
	            var _this5 = this;
	
	            var user = modalDetails.user;
	
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { small: true,
	                    title: "Reset " + user.first_name + "'s password?",
	                    footer: [_react2.default.createElement(
	                        _Button2.default,
	                        { onClick: this.onCloseModal },
	                        "Cancel"
	                    ), _react2.default.createElement(
	                        _Button2.default,
	                        { warning: true, onClick: function onClick() {
	                                return _this5.onPasswordResetConfirm(user);
	                            } },
	                        "Reset"
	                    )],
	                    onClose: this.onCloseModal
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "px4 pb4" },
	                    "Are you sure you want to do this?"
	                )
	            );
	        }
	    }, {
	        key: "renderPasswordResetManuallyModal",
	        value: function renderPasswordResetManuallyModal(modalDetails) {
	            var user = modalDetails.user,
	                password = modalDetails.password;
	
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                { small: true,
	                    title: user.first_name + "'s Password Has Been Reset",
	                    footer: _react2.default.createElement(
	                        "button",
	                        { className: "Button Button--primary mr2", onClick: this.onCloseModal },
	                        "Done"
	                    ),
	                    onClose: this.onCloseModal
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "px4 pb4" },
	                    _react2.default.createElement(
	                        "span",
	                        { className: "pb3 block" },
	                        "Here\u2019s a temporary password they can use to log in and then change their password."
	                    ),
	                    _react2.default.createElement(_PasswordReveal2.default, { password: password })
	                )
	            );
	        }
	    }, {
	        key: "renderPasswordResetViaEmailModal",
	        value: function renderPasswordResetViaEmailModal(modalDetails) {
	            var user = modalDetails.user;
	
	
	            return _react2.default.createElement(
	                _Modal2.default,
	                {
	                    small: true,
	                    title: user.first_name + "'s Password Has Been Reset",
	                    footer: _react2.default.createElement(
	                        _Button2.default,
	                        { primary: true, onClick: this.onCloseModal },
	                        "Done"
	                    ),
	                    onClose: this.onCloseModal
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "px4 pb4" },
	                    "We've sent them an email with instructions for creating a new password."
	                )
	            );
	        }
	    }, {
	        key: "renderModal",
	        value: function renderModal(modalType, modalDetails) {
	
	            switch (modalType) {
	                case MODAL_ADD_PERSON:
	                    return this.renderAddPersonModal(modalDetails);
	                case MODAL_EDIT_DETAILS:
	                    return this.renderEditDetailsModal(modalDetails);
	                case MODAL_USER_ADDED_WITH_PASSWORD:
	                    return this.renderUserAddedWithPasswordModal(modalDetails);
	                case MODAL_USER_ADDED_WITH_INVITE:
	                    return this.renderUserAddedWithInviteModal(modalDetails);
	                case MODAL_INVITE_RESENT:
	                    return this.renderInviteResentModal(modalDetails);
	                case MODAL_REMOVE_USER:
	                    return this.renderRemoveUserModal(modalDetails);
	                case MODAL_RESET_PASSWORD:
	                    return this.renderResetPasswordModal(modalDetails);
	                case MODAL_RESET_PASSWORD_MANUAL:
	                    return this.renderPasswordResetManuallyModal(modalDetails);
	                case MODAL_RESET_PASSWORD_EMAIL:
	                    return this.renderPasswordResetViaEmailModal(modalDetails);
	            }
	
	            return null;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this6 = this;
	
	            var _props = this.props,
	                modal = _props.modal,
	                users = _props.users,
	                groups = _props.groups;
	            var error = this.state.error;
	
	
	            users = _underscore2.default.values(users).sort(function (a, b) {
	                return b.date_joined - a.date_joined;
	            });
	
	            return _react2.default.createElement(
	                _LoadingAndErrorWrapper2.default,
	                { loading: !users, error: error },
	                function () {
	                    return _react2.default.createElement(
	                        _AdminPaneLayout2.default,
	                        {
	                            title: "People",
	                            buttonText: "Add someone",
	                            buttonAction: function buttonAction() {
	                                return _this6.props.showModal({ type: MODAL_ADD_PERSON });
	                            }
	                        },
	                        _react2.default.createElement(
	                            "section",
	                            { className: "pb4" },
	                            _react2.default.createElement(
	                                "table",
	                                { className: "ContentTable" },
	                                _react2.default.createElement(
	                                    "thead",
	                                    null,
	                                    _react2.default.createElement(
	                                        "tr",
	                                        null,
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "Name"
	                                        ),
	                                        _react2.default.createElement("th", null),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "Email"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "Groups"
	                                        ),
	                                        _react2.default.createElement(
	                                            "th",
	                                            null,
	                                            "Last Login"
	                                        ),
	                                        _react2.default.createElement("th", null)
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "tbody",
	                                    null,
	                                    users.map(function (user) {
	                                        return _react2.default.createElement(
	                                            "tr",
	                                            { key: user.id },
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(
	                                                    "span",
	                                                    { className: "text-white inline-block" },
	                                                    _react2.default.createElement(_UserAvatar2.default, { background: user.is_superuser ? "bg-purple" : "bg-brand", user: user })
	                                                ),
	                                                " ",
	                                                _react2.default.createElement(
	                                                    "span",
	                                                    { className: "ml2 text-bold" },
	                                                    user.common_name
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                user.google_auth ? _react2.default.createElement(
	                                                    _Tooltip2.default,
	                                                    { tooltip: "Signed up via Google" },
	                                                    _react2.default.createElement(_Icon2.default, { name: "google" })
	                                                ) : null,
	                                                user.ldap_auth ? _react2.default.createElement(
	                                                    _Tooltip2.default,
	                                                    { tooltip: "Signed up via LDAP" },
	                                                    _react2.default.createElement(_Icon2.default, { name: "ldap" })
	                                                ) : null
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                user.email
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                _react2.default.createElement(_UserGroupSelect2.default, {
	                                                    user: user,
	                                                    groups: groups,
	                                                    createMembership: _this6.props.createMembership,
	                                                    deleteMembership: _this6.props.deleteMembership
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                null,
	                                                user.last_login ? user.last_login.fromNow() : "Never"
	                                            ),
	                                            _react2.default.createElement(
	                                                "td",
	                                                { className: "text-right" },
	                                                _react2.default.createElement(_UserActionsSelect2.default, { user: user, showModal: _this6.props.showModal, resendInvite: _this6.props.resendInvite, isActiveUser: _this6.props.user.id === user.id })
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        modal ? _this6.renderModal(modal.type, modal.details) : null
	                    );
	                }
	            );
	        }
	    }]);
	
	    return PeopleListingApp;
	}(_react.Component), _class2.propTypes = {
	    user: _propTypes2.default.object.isRequired,
	    users: _propTypes2.default.object,
	    groups: _propTypes2.default.array,
	    modal: _propTypes2.default.object,
	    createUser: _propTypes2.default.func.isRequired,
	    deleteUser: _propTypes2.default.func.isRequired,
	    fetchUsers: _propTypes2.default.func.isRequired,
	    resetPasswordManually: _propTypes2.default.func.isRequired,
	    resetPasswordViaEmail: _propTypes2.default.func.isRequired,
	    showModal: _propTypes2.default.func.isRequired,
	    updateUser: _propTypes2.default.func.isRequired,
	    resendInvite: _propTypes2.default.func.isRequired,
	    loadGroups: _propTypes2.default.func.isRequired,
	    loadMemberships: _propTypes2.default.func.isRequired,
	    createMembership: _propTypes2.default.func.isRequired,
	    deleteMembership: _propTypes2.default.func.isRequired
	}, _temp)) || _class);
	PeopleListingApp.displayName = "PeopleListingApp";
	exports.default = PeopleListingApp;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminPaneTitle = function AdminPaneTitle(_ref) {
	    var title = _ref.title,
	        description = _ref.description,
	        buttonText = _ref.buttonText,
	        buttonAction = _ref.buttonAction,
	        buttonDisabled = _ref.buttonDisabled;
	    return _react2.default.createElement(
	        "section",
	        { className: "clearfix px2" },
	        buttonText && buttonAction ? _react2.default.createElement(
	            "button",
	            {
	                className: (0, _classnames2.default)("Button float-right", { "Button--primary": !buttonDisabled }),
	                disabled: buttonDisabled,
	                onClick: buttonAction
	            },
	            buttonText
	        ) : null,
	        _react2.default.createElement(
	            "h2",
	            { className: "PageTitle" },
	            title
	        ),
	        description && _react2.default.createElement(
	            "p",
	            { className: "text-measure" },
	            description
	        )
	    );
	};
	
	AdminPaneTitle.displayName = "AdminPaneTitle";
	var AdminPaneLayout = function AdminPaneLayout(_ref2) {
	    var title = _ref2.title,
	        description = _ref2.description,
	        buttonText = _ref2.buttonText,
	        buttonAction = _ref2.buttonAction,
	        buttonDisabled = _ref2.buttonDisabled,
	        children = _ref2.children;
	    return _react2.default.createElement(
	        "div",
	        { className: "wrapper" },
	        _react2.default.createElement(AdminPaneTitle, {
	            title: title,
	            description: description,
	            buttonText: buttonText,
	            buttonAction: buttonAction,
	            buttonDisabled: buttonDisabled
	        }),
	        children
	    );
	};
	
	AdminPaneLayout.displayName = "AdminPaneLayout";
	exports.default = AdminPaneLayout;

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CopyButton = __webpack_require__(1220);
	
	var _CopyButton2 = _interopRequireDefault(_CopyButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* flow */
	
	
	var styles = {
	    input: {
	        fontSize: '1.2rem',
	        letterSpacing: '2',
	        color: '#676C72',
	        outline: "none"
	    }
	};
	
	var Label = function Label() {
	    return _react2.default.createElement(
	        'div',
	        { style: { top: -12 }, className: 'absolute text-centered left right' },
	        _react2.default.createElement(
	            'span',
	            { className: 'px1 bg-white h6 text-bold text-grey-3 text-uppercase' },
	            'Temporary Password'
	        )
	    );
	};
	
	Label.displayName = 'Label';
	
	var PasswordReveal = function (_Component) {
	    _inherits(PasswordReveal, _Component);
	
	    function PasswordReveal() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, PasswordReveal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PasswordReveal.__proto__ || Object.getPrototypeOf(PasswordReveal)).call.apply(_ref, [this].concat(args))), _this), _this.state = { visible: false }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(PasswordReveal, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var password = this.props.password;
	            var visible = this.state.visible;
	
	
	            return _react2.default.createElement(
	                'div',
	                { style: { borderWidth: 2 }, className: 'bordered rounded flex align-center  p3 relative' },
	                _react2.default.createElement(Label, null),
	                visible ? _react2.default.createElement('input', {
	                    ref: 'input',
	                    style: styles.input,
	                    className: 'text-grey-2 text-normal mr3 borderless',
	                    value: password,
	                    onClick: function onClick(_ref2) {
	                        var target = _ref2.target;
	                        return target.setSelectionRange(0, target.value.length);
	                    }
	                }) : _react2.default.createElement(
	                    'span',
	                    { style: styles.input, className: 'mr3' },
	                    '\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'ml-auto flex align-center' },
	                    _react2.default.createElement(
	                        'a',
	                        {
	                            className: 'link text-bold mr2',
	                            onClick: function onClick() {
	                                return _this2.setState({ visible: !visible });
	                            }
	                        },
	                        visible ? 'Hide' : 'Show'
	                    ),
	                    _react2.default.createElement(_CopyButton2.default, {
	                        className: 'text-brand-hover cursor-pointer',
	                        value: password
	                    })
	                )
	            );
	        }
	    }]);
	
	    return PasswordReveal;
	}(_react.Component);
	
	PasswordReveal.displayName = 'PasswordReveal';
	exports.default = PasswordReveal;

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(330);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FormField = __webpack_require__(1571);
	
	var _FormField2 = _interopRequireDefault(_FormField);
	
	var _FormLabel = __webpack_require__(1572);
	
	var _FormLabel2 = _interopRequireDefault(_FormLabel);
	
	var _GroupSelect = __webpack_require__(1904);
	
	var _GroupSelect2 = _interopRequireDefault(_GroupSelect);
	
	var _GroupSummary = __webpack_require__(1905);
	
	var _GroupSummary2 = _interopRequireDefault(_GroupSummary);
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _SelectButton = __webpack_require__(1909);
	
	var _SelectButton2 = _interopRequireDefault(_SelectButton);
	
	var _Toggle = __webpack_require__(1241);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _Button = __webpack_require__(1007);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _groups = __webpack_require__(1683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditUserForm = (_temp = _class = function (_Component) {
	    _inherits(EditUserForm, _Component);
	
	    function EditUserForm(props, context) {
	        _classCallCheck(this, EditUserForm);
	
	        var _this = _possibleConstructorReturn(this, (EditUserForm.__proto__ || Object.getPrototypeOf(EditUserForm)).call(this, props, context));
	
	        _this.onChange = function (e) {
	            _this.validateForm();
	        };
	
	        var user = props.user;
	
	        _this.state = {
	            formError: null,
	            valid: false,
	            selectedGroups: {},
	            firstName: user ? user.first_name : null,
	            lastName: user ? user.last_name : null,
	            email: user ? user.email : null
	        };
	        return _this;
	    }
	
	    _createClass(EditUserForm, [{
	        key: "validateForm",
	        value: function validateForm() {
	            var _this2 = this;
	
	            var valid = this.state.valid;
	
	            var isValid = true;
	
	            ["firstName", "lastName", "email"].forEach(function (fieldName) {
	                if (_utils2.default.isEmpty(_this2.state[fieldName])) isValid = false;
	            });
	
	            if (isValid !== valid) {
	                this.setState({
	                    'valid': isValid
	                });
	            }
	        }
	    }, {
	        key: "formSubmitted",
	        value: function formSubmitted(e) {
	            e.preventDefault();
	
	            this.setState({
	                formError: null
	            });
	
	            var formErrors = { data: { errors: {} } };
	
	            // validate email address
	            var email = _reactDom2.default.findDOMNode(this.refs.email).value ? _reactDom2.default.findDOMNode(this.refs.email).value.trim() : null;
	            if (!_utils2.default.validEmail(email)) {
	                formErrors.data.errors.email = "Not a valid formatted email address";
	            }
	
	            if (_underscore2.default.keys(formErrors.data.errors).length > 0) {
	                this.setState({
	                    formError: formErrors
	                });
	                return;
	            }
	
	            this.props.submitFn(_extends({}, this.props.user || {}, {
	                first_name: _reactDom2.default.findDOMNode(this.refs.firstName).value,
	                last_name: _reactDom2.default.findDOMNode(this.refs.lastName).value,
	                email: email,
	                groups: this.props.groups && this.state.selectedGroups ? Object.entries(this.state.selectedGroups).filter(function (_ref) {
	                    var _ref2 = _slicedToArray(_ref, 2),
	                        key = _ref2[0],
	                        value = _ref2[1];
	
	                    return value;
	                }).map(function (_ref3) {
	                    var _ref4 = _slicedToArray(_ref3, 2),
	                        key = _ref4[0],
	                        value = _ref4[1];
	
	                    return parseInt(key, 10);
	                }) : null
	            }));
	        }
	    }, {
	        key: "cancel",
	        value: function cancel() {
	            this.props.submitFn(null);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                buttonText = _props.buttonText,
	                groups = _props.groups;
	            var _state = this.state,
	                formError = _state.formError,
	                valid = _state.valid,
	                selectedGroups = _state.selectedGroups,
	                firstName = _state.firstName,
	                lastName = _state.lastName,
	                email = _state.email;
	
	
	            var adminGroup = _underscore2.default.find(groups, _groups.isAdminGroup);
	
	            return _react2.default.createElement(
	                "form",
	                { onSubmit: this.formSubmitted.bind(this), noValidate: true },
	                _react2.default.createElement(
	                    "div",
	                    { className: "px4 pb2" },
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { fieldName: "first_name", formError: formError },
	                        _react2.default.createElement(_FormLabel2.default, { title: "First name", fieldName: "first_name", formError: formError, offset: false }),
	                        _react2.default.createElement("input", {
	                            ref: "firstName",
	                            className: "Form-input full",
	                            name: "firstName",
	                            placeholder: "Johnny",
	                            value: firstName,
	                            onChange: function onChange(e) {
	                                _this3.setState({ firstName: e.target.value }, function () {
	                                    return _this3.onChange(e);
	                                });
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { fieldName: "last_name", formError: formError },
	                        _react2.default.createElement(_FormLabel2.default, { title: "Last name", fieldName: "last_name", formError: formError, offset: false }),
	                        _react2.default.createElement("input", {
	                            ref: "lastName",
	                            className: "Form-input full",
	                            name: "lastName",
	                            placeholder: "Appleseed",
	                            required: true,
	                            value: lastName,
	                            onChange: function onChange(e) {
	                                _this3.setState({ lastName: e.target.value }, function () {
	                                    return _this3.onChange(e);
	                                });
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _FormField2.default,
	                        { fieldName: "email", formError: formError },
	                        _react2.default.createElement(_FormLabel2.default, { title: "Email address", fieldName: "email", formError: formError, offset: false }),
	                        _react2.default.createElement("input", {
	                            ref: "email",
	                            className: "Form-input full",
	                            name: "email",
	                            placeholder: "youlooknicetoday@email.com",
	                            required: true,
	                            value: email,
	                            onChange: function onChange(e) {
	                                _this3.setState({ email: e.target.value }, function () {
	                                    return _this3.onChange(e);
	                                });
	                            }
	                        })
	                    ),
	                    groups && groups.filter(function (g) {
	                        return (0, _groups.canEditMembership)(g) && !(0, _groups.isAdminGroup)(g);
	                    }).length > 0 ? _react2.default.createElement(
	                        _FormField2.default,
	                        null,
	                        _react2.default.createElement(_FormLabel2.default, { title: "Permission Groups", offset: false }),
	                        _react2.default.createElement(
	                            _PopoverWithTrigger2.default,
	                            {
	                                sizeToFit: true,
	                                triggerElement: _react2.default.createElement(
	                                    _SelectButton2.default,
	                                    null,
	                                    _react2.default.createElement(_GroupSummary2.default, { groups: groups, selectedGroups: selectedGroups })
	                                )
	                            },
	                            _react2.default.createElement(_GroupSelect2.default, {
	                                groups: groups,
	                                selectedGroups: selectedGroups,
	                                onGroupChange: function onGroupChange(group, selected) {
	                                    _this3.setState({ selectedGroups: _extends({}, selectedGroups, _defineProperty({}, group.id, selected)) });
	                                }
	                            })
	                        )
	                    ) : adminGroup ? _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center" },
	                        _react2.default.createElement(_Toggle2.default, {
	                            value: selectedGroups[adminGroup.id],
	                            onChange: function onChange(isAdmin) {
	                                _this3.setState({ selectedGroups: isAdmin ? _defineProperty({}, adminGroup.id, true) : {} });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            "span",
	                            { className: "ml2" },
	                            "Make this user an admin"
	                        )
	                    ) : null
	                ),
	                _react2.default.createElement(
	                    _ModalContent.ModalFooter,
	                    null,
	                    _react2.default.createElement(
	                        _Button2.default,
	                        { type: "button", onClick: this.cancel.bind(this) },
	                        "Cancel"
	                    ),
	                    _react2.default.createElement(
	                        _Button2.default,
	                        { primary: true, disabled: !valid },
	                        buttonText ? buttonText : "Save changes"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return EditUserForm;
	}(_react.Component), _class.propTypes = {
	    buttonText: _propTypes2.default.string,
	    submitFn: _propTypes2.default.func.isRequired,
	    user: _propTypes2.default.object,
	    groups: _propTypes2.default.array
	}, _temp);
	EditUserForm.displayName = "EditUserForm";
	exports.default = EditUserForm;

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _settings = __webpack_require__(518);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _PeopleListingApp = __webpack_require__(2038);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserActionsSelect = (_temp = _class = function (_Component) {
	    _inherits(UserActionsSelect, _Component);
	
	    function UserActionsSelect() {
	        _classCallCheck(this, UserActionsSelect);
	
	        return _possibleConstructorReturn(this, (UserActionsSelect.__proto__ || Object.getPrototypeOf(UserActionsSelect)).apply(this, arguments));
	    }
	
	    _createClass(UserActionsSelect, [{
	        key: "onEditDetails",
	        value: function onEditDetails() {
	            this.props.showModal({ type: _PeopleListingApp.MODAL_EDIT_DETAILS, details: { user: this.props.user } });
	            this.refs.popover.toggle();
	        }
	    }, {
	        key: "onResendInvite",
	        value: function onResendInvite() {
	            this.props.resendInvite(this.props.user);
	            this.props.showModal({ type: _PeopleListingApp.MODAL_INVITE_RESENT, details: { user: this.props.user } });
	            this.refs.popover.toggle();
	        }
	    }, {
	        key: "onResetPassword",
	        value: function onResetPassword() {
	            if (window.OSX) {
	                window.OSX.resetPassword();
	                return;
	            }
	
	            this.props.showModal({ type: _PeopleListingApp.MODAL_RESET_PASSWORD, details: { user: this.props.user } });
	            this.refs.popover.toggle();
	        }
	    }, {
	        key: "onRemoveUser",
	        value: function onRemoveUser() {
	            this.props.showModal({ type: _PeopleListingApp.MODAL_REMOVE_USER, details: { user: this.props.user } });
	            this.refs.popover.toggle();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                isActiveUser = _props.isActiveUser,
	                user = _props.user;
	
	
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                { ref: "popover",
	                    className: "block",
	                    triggerElement: _react2.default.createElement(
	                        "span",
	                        { className: "text-grey-1" },
	                        _react2.default.createElement(_Icon2.default, { name: 'ellipsis' })
	                    ) },
	                _react2.default.createElement(
	                    "ul",
	                    { className: "UserActionsSelect" },
	                    _react2.default.createElement(
	                        "li",
	                        { className: "py1 px2 bg-brand-hover text-white-hover cursor-pointer", onClick: this.onEditDetails.bind(this) },
	                        "Edit Details"
	                    ),
	                    user.last_login === null && _settings2.default.isEmailConfigured() ? _react2.default.createElement(
	                        "li",
	                        { className: "pt1 pb2 px2 bg-brand-hover text-white-hover cursor-pointer", onClick: this.onResendInvite.bind(this) },
	                        "Re-send Invite"
	                    ) : _react2.default.createElement(
	                        "li",
	                        { className: "pt1 pb2 px2 bg-brand-hover text-white-hover cursor-pointer", onClick: this.onResetPassword.bind(this) },
	                        "Reset Password"
	                    ),
	                    !isActiveUser && _react2.default.createElement(
	                        "li",
	                        { className: "p2 border-top bg-error-hover text-error text-white-hover cursor-pointer", onClick: this.onRemoveUser.bind(this) },
	                        "Remove"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UserActionsSelect;
	}(_react.Component), _class.propTypes = {
	    user: _propTypes2.default.object.isRequired,
	    isActiveUser: _propTypes2.default.bool.isRequired,
	    showModal: _propTypes2.default.func.isRequired,
	    resendInvite: _propTypes2.default.func.isRequired
	}, _temp);
	UserActionsSelect.displayName = "UserActionsSelect";
	exports.default = UserActionsSelect;

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /* eslint "react/prop-types": "warn" */
	
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _CheckBox = __webpack_require__(1004);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _LoadingSpinner = __webpack_require__(1281);
	
	var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);
	
	var _GroupSelect = __webpack_require__(1904);
	
	var _GroupSelect2 = _interopRequireDefault(_GroupSelect);
	
	var _GroupSummary = __webpack_require__(1905);
	
	var _GroupSummary2 = _interopRequireDefault(_GroupSummary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupOption = function GroupOption(_ref) {
	    var name = _ref.name,
	        color = _ref.color,
	        selected = _ref.selected,
	        disabled = _ref.disabled,
	        onChange = _ref.onChange;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("flex align-center p1 px2", { "cursor-pointer": !disabled }), onClick: function onClick() {
	                return !disabled && onChange(!selected);
	            } },
	        _react2.default.createElement(
	            "span",
	            { className: (0, _classnames2.default)("pr1", color, { disabled: disabled }) },
	            _react2.default.createElement(_CheckBox2.default, {
	                checked: selected,
	                size: 18
	            })
	        ),
	        name
	    );
	};
	
	GroupOption.displayName = "GroupOption";
	GroupOption.propTypes = {
	    name: _propTypes2.default.string,
	    color: _propTypes2.default.string,
	    selected: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func
	};
	
	var UserGroupSelect = (_temp = _class = function (_Component) {
	    _inherits(UserGroupSelect, _Component);
	
	    function UserGroupSelect() {
	        _classCallCheck(this, UserGroupSelect);
	
	        return _possibleConstructorReturn(this, (UserGroupSelect.__proto__ || Object.getPrototypeOf(UserGroupSelect)).apply(this, arguments));
	    }
	
	    _createClass(UserGroupSelect, [{
	        key: "toggle",
	        value: function toggle() {
	            this.refs.popover.toggle();
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                user = _props.user,
	                groups = _props.groups,
	                createMembership = _props.createMembership,
	                deleteMembership = _props.deleteMembership;
	
	
	            if (!groups || groups.length === 0 || !user.memberships) {
	                return _react2.default.createElement(_LoadingSpinner2.default, null);
	            }
	
	            var changeMembership = function changeMembership(group, member) {
	                if (member) {
	                    createMembership({ groupId: group.id, userId: user.id });
	                } else {
	                    deleteMembership({ membershipId: user.memberships[group.id].membership_id });
	                }
	            };
	
	            return _react2.default.createElement(
	                _PopoverWithTrigger2.default,
	                {
	                    ref: "popover",
	                    triggerElement: _react2.default.createElement(
	                        "div",
	                        { className: "flex align-center" },
	                        _react2.default.createElement(
	                            "span",
	                            { className: "mr1 text-grey-4" },
	                            _react2.default.createElement(_GroupSummary2.default, { groups: groups, selectedGroups: user.memberships })
	                        ),
	                        _react2.default.createElement(_Icon2.default, { className: "text-grey-2", name: "chevrondown", size: 10 })
	                    ),
	                    triggerClasses: "AdminSelectBorderless py1",
	                    sizeToFit: true
	                },
	                _react2.default.createElement(_GroupSelect2.default, {
	                    groups: groups,
	                    selectedGroups: user.memberships,
	                    onGroupChange: changeMembership
	                })
	            );
	        }
	    }]);
	
	    return UserGroupSelect;
	}(_react.Component), _class.propTypes = {
	    user: _propTypes2.default.object.isRequired,
	    groups: _propTypes2.default.array,
	    createMembership: _propTypes2.default.func.isRequired,
	    deleteMembership: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
	    isInitiallyOpen: false
	}, _temp);
	UserGroupSelect.displayName = "UserGroupSelect";
	exports.default = UserGroupSelect;

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getUsers = exports.getMemberships = exports.getModal = exports.getGroup = exports.getGroups = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__(1072);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getGroups = exports.getGroups = function getGroups(state) {
	    return state.admin.people.groups;
	};
	var getGroup = exports.getGroup = function getGroup(state) {
	    return state.admin.people.group;
	};
	var getModal = exports.getModal = function getModal(state) {
	    return state.admin.people.modal;
	};
	var getMemberships = exports.getMemberships = function getMemberships(state) {
	    return state.admin.people.memberships;
	};
	
	var getUsers = exports.getUsers = (0, _reselect.createSelector)(function (state) {
	    return state.admin.people.users;
	}, function (state) {
	    return state.admin.people.memberships;
	}, function (users, memberships) {
	    return users && _underscore2.default.mapObject(users, function (user) {
	        return _extends({}, user, {
	            memberships: memberships && _underscore2.default.chain(memberships).values().filter(function (m) {
	                return m.user_id === user.id;
	            }).map(function (m) {
	                return [m.group_id, m];
	            }).object().value()
	        });
	    });
	});

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateUser = exports.resetPasswordViaEmail = exports.resetPasswordManually = exports.resendInvite = exports.fetchUsers = exports.deleteUser = exports.createUser = exports.deleteMembership = exports.createMembership = exports.loadMemberships = exports.loadGroupDetails = exports.loadGroups = exports.showModal = exports.DELETE_MEMBERSHIP = exports.CREATE_MEMBERSHIP = exports.LOAD_GROUP_DETAILS = exports.LOAD_MEMBERSHIPS = exports.LOAD_GROUPS = exports.UPDATE_USER = exports.SHOW_MODAL = exports.RESET_PASSWORD_MANUAL = exports.RESET_PASSWORD_EMAIL = exports.RESEND_INVITE = exports.FETCH_USERS = exports.DELETE_USER = exports.CREATE_USER = undefined;
	
	var _handleActions2, _handleActions4;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(657);
	
	var _normalizr = __webpack_require__(1111);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _services = __webpack_require__(857);
	
	var _moment = __webpack_require__(752);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _icepick = __webpack_require__(855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var user = new _normalizr.schema.Entity('user');
	
	// action constants
	var CREATE_USER = exports.CREATE_USER = 'metabase/admin/people/CREATE_USER';
	var DELETE_USER = exports.DELETE_USER = 'metabase/admin/people/DELETE_USER';
	var FETCH_USERS = exports.FETCH_USERS = 'metabase/admin/people/FETCH_USERS';
	var RESEND_INVITE = exports.RESEND_INVITE = 'metabase/admin/people/RESEND_INVITE';
	var RESET_PASSWORD_EMAIL = exports.RESET_PASSWORD_EMAIL = 'metabase/admin/people/RESET_PASSWORD_EMAIL';
	var RESET_PASSWORD_MANUAL = exports.RESET_PASSWORD_MANUAL = 'metabase/admin/people/RESET_PASSWORD_MANUAL';
	var SHOW_MODAL = exports.SHOW_MODAL = 'metabase/admin/people/SHOW_MODAL';
	var UPDATE_USER = exports.UPDATE_USER = 'metabase/admin/people/UPDATE_USER';
	var LOAD_GROUPS = exports.LOAD_GROUPS = 'metabase/admin/people/LOAD_GROUPS';
	var LOAD_MEMBERSHIPS = exports.LOAD_MEMBERSHIPS = 'metabase/admin/people/LOAD_MEMBERSHIPS';
	var LOAD_GROUP_DETAILS = exports.LOAD_GROUP_DETAILS = 'metabase/admin/people/LOAD_GROUP_DETAILS';
	
	var CREATE_MEMBERSHIP = exports.CREATE_MEMBERSHIP = 'metabase/admin/people/CREATE_MEMBERSHIP';
	var DELETE_MEMBERSHIP = exports.DELETE_MEMBERSHIP = 'metabase/admin/people/DELETE_MEMBERSHIP';
	
	// action creators
	
	var showModal = exports.showModal = (0, _redux.createAction)(SHOW_MODAL);
	
	var loadGroups = exports.loadGroups = (0, _redux.createAction)(LOAD_GROUPS, function () {
	    return _services.PermissionsApi.groups();
	});
	
	var loadGroupDetails = exports.loadGroupDetails = (0, _redux.createAction)(LOAD_GROUP_DETAILS, function (id) {
	    return _services.PermissionsApi.groupDetails({ id: id });
	});
	
	var loadMemberships = exports.loadMemberships = (0, _redux.createAction)(LOAD_MEMBERSHIPS, _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	            switch (_context.prev = _context.next) {
	                case 0:
	                    _context.t0 = _underscore2.default;
	                    _context.next = 3;
	                    return _services.PermissionsApi.memberships();
	
	                case 3:
	                    _context.t1 = _context.sent;
	
	                    _context.t2 = function (m) {
	                        return [m.membership_id, m];
	                    };
	
	                    return _context.abrupt("return", _context.t0.chain.call(_context.t0, _context.t1).values().flatten().map(_context.t2).object().value());
	
	                case 6:
	                case "end":
	                    return _context.stop();
	            }
	        }
	    }, _callee, undefined);
	})));
	var createMembership = exports.createMembership = (0, _redux.createAction)(CREATE_MEMBERSHIP, function () {
	    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(_ref3) {
	        var userId = _ref3.userId,
	            groupId = _ref3.groupId;
	        var groupMemberships;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return _services.PermissionsApi.createMembership({ user_id: userId, group_id: groupId });
	
	                    case 2:
	                        groupMemberships = _context2.sent;
	
	                        _analytics2.default.trackEvent("People Groups", "Membership Added");
	                        return _context2.abrupt("return", {
	                            user_id: userId,
	                            group_id: groupId,
	                            membership_id: _underscore2.default.findWhere(groupMemberships, { user_id: userId }).membership_id
	                        });
	
	                    case 5:
	                    case "end":
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, undefined);
	    }));
	
	    return function (_x) {
	        return _ref2.apply(this, arguments);
	    };
	}());
	var deleteMembership = exports.deleteMembership = (0, _redux.createAction)(DELETE_MEMBERSHIP, function () {
	    var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(_ref5) {
	        var membershipId = _ref5.membershipId;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        _context3.next = 2;
	                        return _services.PermissionsApi.deleteMembership({ id: membershipId });
	
	                    case 2:
	                        _analytics2.default.trackEvent("People Groups", "Membership Deleted");
	                        return _context3.abrupt("return", membershipId);
	
	                    case 4:
	                    case "end":
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, undefined);
	    }));
	
	    return function (_x2) {
	        return _ref4.apply(this, arguments);
	    };
	}());
	
	var createUser = exports.createUser = (0, _redux.createThunkAction)(CREATE_USER, function (user) {
	    return function () {
	        var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(dispatch, getState) {
	            var newUser;
	            return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            // apply any user defaults here
	                            user.is_superuser = false;
	
	                            _context4.next = 3;
	                            return _services.UserApi.create(user);
	
	                        case 3:
	                            newUser = _context4.sent;
	
	                            newUser.date_joined = newUser.date_joined ? (0, _moment2.default)(newUser.date_joined) : null;
	                            newUser.last_login = newUser.last_login ? (0, _moment2.default)(newUser.last_login) : null;
	
	                            if (!user.groups) {
	                                _context4.next = 9;
	                                break;
	                            }
	
	                            _context4.next = 9;
	                            return Promise.all(user.groups.map(function (groupId) {
	                                return dispatch(createMembership({ userId: newUser.id, groupId: groupId }));
	                            }));
	
	                        case 9:
	
	                            _analytics2.default.trackEvent("People Admin", "User Added", user.password !== null ? "password" : "email");
	
	                            return _context4.abrupt("return", newUser);
	
	                        case 11:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, this);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref6.apply(this, arguments);
	        };
	    }();
	});
	
	var deleteUser = exports.deleteUser = (0, _redux.createThunkAction)(DELETE_USER, function (user) {
	    return function () {
	        var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            _context5.next = 2;
	                            return _services.UserApi.delete({
	                                userId: user.id
	                            });
	
	                        case 2:
	
	                            _analytics2.default.trackEvent("People Admin", "User Removed");
	                            return _context5.abrupt("return", user);
	
	                        case 4:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, this);
	        }));
	
	        return function (_x5, _x6) {
	            return _ref7.apply(this, arguments);
	        };
	    }();
	});
	
	var fetchUsers = exports.fetchUsers = (0, _redux.createThunkAction)(FETCH_USERS, function () {
	    return function () {
	        var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(dispatch, getState) {
	            var users, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, u;
	
	            return regeneratorRuntime.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            _context6.next = 2;
	                            return _services.UserApi.list();
	
	                        case 2:
	                            users = _context6.sent;
	                            _iteratorNormalCompletion = true;
	                            _didIteratorError = false;
	                            _iteratorError = undefined;
	                            _context6.prev = 6;
	
	
	                            for (_iterator = users[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                u = _step.value;
	
	                                u.date_joined = u.date_joined ? (0, _moment2.default)(u.date_joined) : null;
	                                u.last_login = u.last_login ? (0, _moment2.default)(u.last_login) : null;
	                            }
	
	                            _context6.next = 14;
	                            break;
	
	                        case 10:
	                            _context6.prev = 10;
	                            _context6.t0 = _context6["catch"](6);
	                            _didIteratorError = true;
	                            _iteratorError = _context6.t0;
	
	                        case 14:
	                            _context6.prev = 14;
	                            _context6.prev = 15;
	
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	
	                        case 17:
	                            _context6.prev = 17;
	
	                            if (!_didIteratorError) {
	                                _context6.next = 20;
	                                break;
	                            }
	
	                            throw _iteratorError;
	
	                        case 20:
	                            return _context6.finish(17);
	
	                        case 21:
	                            return _context6.finish(14);
	
	                        case 22:
	                            return _context6.abrupt("return", (0, _normalizr.normalize)(users, [user]));
	
	                        case 23:
	                        case "end":
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, this, [[6, 10, 14, 22], [15,, 17, 21]]);
	        }));
	
	        return function (_x7, _x8) {
	            return _ref8.apply(this, arguments);
	        };
	    }();
	});
	
	var resendInvite = exports.resendInvite = (0, _redux.createThunkAction)(RESEND_INVITE, function (user) {
	    return function () {
	        var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            _analytics2.default.trackEvent("People Admin", "Resent Invite");
	                            _context7.next = 3;
	                            return _services.UserApi.send_invite({ id: user.id });
	
	                        case 3:
	                            return _context7.abrupt("return", _context7.sent);
	
	                        case 4:
	                        case "end":
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, this);
	        }));
	
	        return function (_x9, _x10) {
	            return _ref9.apply(this, arguments);
	        };
	    }();
	});
	
	var resetPasswordManually = exports.resetPasswordManually = (0, _redux.createThunkAction)(RESET_PASSWORD_MANUAL, function (user, password) {
	    return function () {
	        var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee8$(_context8) {
	                while (1) {
	                    switch (_context8.prev = _context8.next) {
	                        case 0:
	                            _analytics2.default.trackEvent("People Admin", "Manual Password Reset");
	                            _context8.next = 3;
	                            return _services.UserApi.update_password({ id: user.id, password: password });
	
	                        case 3:
	                            return _context8.abrupt("return", _context8.sent);
	
	                        case 4:
	                        case "end":
	                            return _context8.stop();
	                    }
	                }
	            }, _callee8, this);
	        }));
	
	        return function (_x11, _x12) {
	            return _ref10.apply(this, arguments);
	        };
	    }();
	});
	
	var resetPasswordViaEmail = exports.resetPasswordViaEmail = (0, _redux.createThunkAction)(RESET_PASSWORD_EMAIL, function (user) {
	    return function () {
	        var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(dispatch, getState) {
	            return regeneratorRuntime.wrap(function _callee9$(_context9) {
	                while (1) {
	                    switch (_context9.prev = _context9.next) {
	                        case 0:
	                            _analytics2.default.trackEvent("People Admin", "Trigger User Password Reset");
	                            _context9.next = 3;
	                            return _services.SessionApi.forgot_password({ email: user.email });
	
	                        case 3:
	                            return _context9.abrupt("return", _context9.sent);
	
	                        case 4:
	                        case "end":
	                            return _context9.stop();
	                    }
	                }
	            }, _callee9, this);
	        }));
	
	        return function (_x13, _x14) {
	            return _ref11.apply(this, arguments);
	        };
	    }();
	});
	
	var updateUser = exports.updateUser = (0, _redux.createThunkAction)(UPDATE_USER, function (user) {
	    return function () {
	        var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(dispatch, getState) {
	            var updatedUser;
	            return regeneratorRuntime.wrap(function _callee10$(_context10) {
	                while (1) {
	                    switch (_context10.prev = _context10.next) {
	                        case 0:
	                            _context10.next = 2;
	                            return _services.UserApi.update(user);
	
	                        case 2:
	                            updatedUser = _context10.sent;
	
	
	                            updatedUser.date_joined = updatedUser.date_joined ? (0, _moment2.default)(updatedUser.date_joined) : null;
	                            updatedUser.last_login = updatedUser.last_login ? (0, _moment2.default)(updatedUser.last_login) : null;
	
	                            _analytics2.default.trackEvent("People Admin", "Update Updated");
	
	                            return _context10.abrupt("return", updatedUser);
	
	                        case 7:
	                        case "end":
	                            return _context10.stop();
	                    }
	                }
	            }, _callee10, this);
	        }));
	
	        return function (_x15, _x16) {
	            return _ref12.apply(this, arguments);
	        };
	    }();
	});
	
	var modal = (0, _redux.handleActions)(_defineProperty({}, SHOW_MODAL, { next: function next(state, _ref13) {
	        var payload = _ref13.payload;
	        return payload;
	    } }), null);
	
	var users = (0, _redux.handleActions)((_handleActions2 = {}, _defineProperty(_handleActions2, FETCH_USERS, { next: function next(state, _ref14) {
	        var payload = _ref14.payload;
	        return _extends({}, payload.entities.user);
	    } }), _defineProperty(_handleActions2, CREATE_USER, { next: function next(state, _ref15) {
	        var user = _ref15.payload;
	        return _extends({}, state, _defineProperty({}, user.id, user));
	    } }), _defineProperty(_handleActions2, DELETE_USER, { next: function next(state, _ref16) {
	        var user = _ref16.payload;
	        return _underscore2.default.omit(state, user.id);
	    } }), _defineProperty(_handleActions2, UPDATE_USER, { next: function next(state, _ref17) {
	        var user = _ref17.payload;
	        return _extends({}, state, _defineProperty({}, user.id, user));
	    } }), _handleActions2), null);
	
	var groups = (0, _redux.handleActions)(_defineProperty({}, LOAD_GROUPS, { next: function next(state, _ref18) {
	        var payload = _ref18.payload;
	        return payload && payload.filter(function (group) {
	            return group.name !== "MetaBot";
	        });
	    }
	}), null);
	
	var memberships = (0, _redux.handleActions)((_handleActions4 = {}, _defineProperty(_handleActions4, LOAD_MEMBERSHIPS, { next: function next(state, _ref19) {
	        var memberships = _ref19.payload;
	        return memberships;
	    }
	}), _defineProperty(_handleActions4, CREATE_MEMBERSHIP, { next: function next(state, _ref20) {
	        var membership = _ref20.payload;
	        return (0, _icepick.assoc)(state, membership.membership_id, membership);
	    }
	}), _defineProperty(_handleActions4, DELETE_MEMBERSHIP, { next: function next(state, _ref21) {
	        var membershipId = _ref21.payload;
	        return (0, _icepick.dissoc)(state, membershipId);
	    }
	}), _handleActions4), {});
	
	var group = (0, _redux.handleActions)(_defineProperty({}, LOAD_GROUP_DETAILS, { next: function next(state, _ref22) {
	        var payload = _ref22.payload;
	        return payload;
	    } }), null);
	
	exports.default = (0, _redux.combineReducers)({
	    modal: modal,
	    users: users,
	    groups: groups,
	    group: group,
	    memberships: memberships
	});

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _selectors = __webpack_require__(2044);
	
	var _people = __webpack_require__(2045);
	
	var _GroupsListing = __webpack_require__(2047);
	
	var _GroupsListing2 = _interopRequireDefault(_GroupsListing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        groups: (0, _selectors.getGroups)(state, props)
	    };
	};
	
	var mapDispatchToProps = {
	    loadGroups: _people.loadGroups
	};
	
	var GroupsListingApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(GroupsListingApp, _Component);
	
	    function GroupsListingApp() {
	        _classCallCheck(this, GroupsListingApp);
	
	        return _possibleConstructorReturn(this, (GroupsListingApp.__proto__ || Object.getPrototypeOf(GroupsListingApp)).apply(this, arguments));
	    }
	
	    _createClass(GroupsListingApp, [{
	        key: "componentWillMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return this.props.loadGroups();
	
	                            case 2:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_GroupsListing2.default, this.props);
	        }
	    }]);
	
	    return GroupsListingApp;
	}(_react.Component)) || _class);
	GroupsListingApp.displayName = "GroupsListingApp";
	exports.default = GroupsListingApp;

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(1128);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _analytics = __webpack_require__(517);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _groups = __webpack_require__(1683);
	
	var _keyboard = __webpack_require__(934);
	
	var _services = __webpack_require__(857);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Input = __webpack_require__(994);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _ModalContent = __webpack_require__(1262);
	
	var _ModalContent2 = _interopRequireDefault(_ModalContent);
	
	var _Alert = __webpack_require__(2048);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _ModalWithTrigger = __webpack_require__(1246);
	
	var _ModalWithTrigger2 = _interopRequireDefault(_ModalWithTrigger);
	
	var _PopoverWithTrigger = __webpack_require__(980);
	
	var _PopoverWithTrigger2 = _interopRequireDefault(_PopoverWithTrigger);
	
	var _UserAvatar = __webpack_require__(1556);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _AdminContentTable = __webpack_require__(1903);
	
	var _AdminContentTable2 = _interopRequireDefault(_AdminContentTable);
	
	var _AdminPaneLayout = __webpack_require__(2039);
	
	var _AdminPaneLayout2 = _interopRequireDefault(_AdminPaneLayout);
	
	var _AddRow = __webpack_require__(2049);
	
	var _AddRow2 = _interopRequireDefault(_AddRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// ------------------------------------------------------------ Add Group ------------------------------------------------------------
	
	function AddGroupRow(_ref) {
	    var text = _ref.text,
	        onCancelClicked = _ref.onCancelClicked,
	        onCreateClicked = _ref.onCreateClicked,
	        onTextChange = _ref.onTextChange;
	
	    var textIsValid = text && text.length;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            { colSpan: "3", style: { padding: 0 } },
	            _react2.default.createElement(_AddRow2.default, {
	                value: text,
	                isValid: textIsValid,
	                placeholder: "Something like \"Marketing\"",
	                onChange: function onChange(e) {
	                    return onTextChange(e.target.value);
	                },
	                onKeyDown: function onKeyDown(e) {
	                    if (e.keyCode === _keyboard.KEYCODE_ENTER) {
	                        onCreateClicked();
	                    }
	                },
	                onDone: onCreateClicked,
	                onCancel: onCancelClicked
	            })
	        )
	    );
	}
	
	AddGroupRow.displayName = "AddGroupRow";
	// ------------------------------------------------------------ Groups Table: editing ------------------------------------------------------------
	
	function DeleteGroupModal(_ref2) {
	    var group = _ref2.group,
	        _ref2$onConfirm = _ref2.onConfirm,
	        onConfirm = _ref2$onConfirm === undefined ? function () {} : _ref2$onConfirm,
	        _ref2$onClose = _ref2.onClose,
	        onClose = _ref2$onClose === undefined ? function () {} : _ref2$onClose;
	
	    return _react2.default.createElement(
	        _ModalContent2.default,
	        { title: "Remove this group?", onClose: onClose },
	        _react2.default.createElement(
	            "p",
	            { className: "px4 pb4" },
	            "Are you sure? All members of this group will lose any permissions settings the have based on this group. This can't be undone."
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "Form-actions" },
	            _react2.default.createElement(
	                "button",
	                { className: "Button Button--danger", onClick: function onClick() {
	                        onClose();onConfirm(group);
	                    } },
	                "Yes"
	            ),
	            _react2.default.createElement(
	                "button",
	                { className: "Button ml1", onClick: onClose },
	                "No"
	            )
	        )
	    );
	}
	
	DeleteGroupModal.displayName = "DeleteGroupModal";
	function ActionsPopover(_ref3) {
	    var group = _ref3.group,
	        onEditGroupClicked = _ref3.onEditGroupClicked,
	        onDeleteGroupClicked = _ref3.onDeleteGroupClicked;
	
	    return _react2.default.createElement(
	        _PopoverWithTrigger2.default,
	        { className: "block", triggerElement: _react2.default.createElement(_Icon2.default, { className: "text-grey-1", name: "ellipsis" }) },
	        _react2.default.createElement(
	            "ul",
	            { className: "UserActionsSelect" },
	            _react2.default.createElement(
	                "li",
	                { className: "pt1 pb2 px2 bg-brand-hover text-white-hover cursor-pointer", onClick: onEditGroupClicked.bind(null, group) },
	                "Edit Name"
	            ),
	            _react2.default.createElement(
	                "li",
	                { className: "pt1 pb2 px2 bg-brand-hover text-white-hover cursor-pointer text-error" },
	                _react2.default.createElement(
	                    _ModalWithTrigger2.default,
	                    { triggerElement: "Remove Group" },
	                    _react2.default.createElement(DeleteGroupModal, { group: group, onConfirm: onDeleteGroupClicked })
	                )
	            )
	        )
	    );
	}
	
	ActionsPopover.displayName = "ActionsPopover";
	function EditingGroupRow(_ref4) {
	    var group = _ref4.group,
	        textHasChanged = _ref4.textHasChanged,
	        onTextChange = _ref4.onTextChange,
	        onCancelClicked = _ref4.onCancelClicked,
	        onDoneClicked = _ref4.onDoneClicked;
	
	    var textIsValid = group.name && group.name.length;
	    return _react2.default.createElement(
	        "tr",
	        { className: "bordered border-brand rounded" },
	        _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(_Input2.default, { className: "AdminInput h3", type: "text", autoFocus: true, value: group.name,
	                onChange: function onChange(e) {
	                    return onTextChange(e.target.value);
	                }
	            })
	        ),
	        _react2.default.createElement("td", null),
	        _react2.default.createElement(
	            "td",
	            { className: "text-right" },
	            _react2.default.createElement(
	                "span",
	                { className: "link no-decoration cursor-pointer", onClick: onCancelClicked },
	                "Cancel"
	            ),
	            _react2.default.createElement(
	                "button",
	                { className: (0, _classnames2.default)("Button ml2", { "Button--primary": textIsValid && textHasChanged }), disabled: !textIsValid || !textHasChanged, onClick: onDoneClicked },
	                "Done"
	            )
	        )
	    );
	}
	
	EditingGroupRow.displayName = "EditingGroupRow";
	// ------------------------------------------------------------ Groups Table: not editing ------------------------------------------------------------
	
	var COLORS = ['bg-error', 'bg-purple', 'bg-brand', 'bg-gold', 'bg-green'];
	
	function GroupRow(_ref5) {
	    var group = _ref5.group,
	        groupBeingEdited = _ref5.groupBeingEdited,
	        index = _ref5.index,
	        showGroupDetail = _ref5.showGroupDetail,
	        showAddGroupRow = _ref5.showAddGroupRow,
	        onEditGroupClicked = _ref5.onEditGroupClicked,
	        onDeleteGroupClicked = _ref5.onDeleteGroupClicked,
	        onEditGroupTextChange = _ref5.onEditGroupTextChange,
	        onEditGroupCancelClicked = _ref5.onEditGroupCancelClicked,
	        onEditGroupDoneClicked = _ref5.onEditGroupDoneClicked;
	
	    var color = COLORS[index % COLORS.length];
	    var showActionsButton = !(0, _groups.isDefaultGroup)(group) && !(0, _groups.isAdminGroup)(group);
	    var editing = groupBeingEdited && groupBeingEdited.id === group.id;
	
	    return editing ? _react2.default.createElement(EditingGroupRow, { group: groupBeingEdited, textHasChanged: group.name !== groupBeingEdited.name, onTextChange: onEditGroupTextChange,
	        onCancelClicked: onEditGroupCancelClicked, onDoneClicked: onEditGroupDoneClicked
	    }) : _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	                _reactRouter.Link,
	                { to: "/admin/people/groups/" + group.id, className: "link no-decoration" },
	                _react2.default.createElement(
	                    "span",
	                    { className: "text-white inline-block" },
	                    _react2.default.createElement(_UserAvatar2.default, { background: color, user: { first_name: group.name } })
	                ),
	                _react2.default.createElement(
	                    "span",
	                    { className: "ml2 text-bold" },
	                    group.name
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            group.members || 0
	        ),
	        _react2.default.createElement(
	            "td",
	            { className: "text-right" },
	            showActionsButton ? _react2.default.createElement(ActionsPopover, { group: group, onEditGroupClicked: onEditGroupClicked, onDeleteGroupClicked: onDeleteGroupClicked }) : null
	        )
	    );
	}
	
	function GroupsTable(_ref6) {
	    var groups = _ref6.groups,
	        text = _ref6.text,
	        groupBeingEdited = _ref6.groupBeingEdited,
	        showAddGroupRow = _ref6.showAddGroupRow,
	        onAddGroupCanceled = _ref6.onAddGroupCanceled,
	        onAddGroupCreateButtonClicked = _ref6.onAddGroupCreateButtonClicked,
	        onAddGroupTextChanged = _ref6.onAddGroupTextChanged,
	        onEditGroupClicked = _ref6.onEditGroupClicked,
	        onDeleteGroupClicked = _ref6.onDeleteGroupClicked,
	        onEditGroupTextChange = _ref6.onEditGroupTextChange,
	        onEditGroupCancelClicked = _ref6.onEditGroupCancelClicked,
	        onEditGroupDoneClicked = _ref6.onEditGroupDoneClicked;
	
	
	    return _react2.default.createElement(
	        _AdminContentTable2.default,
	        { columnTitles: ["Group name", "Members"] },
	        showAddGroupRow ? _react2.default.createElement(AddGroupRow, { text: text, onCancelClicked: onAddGroupCanceled, onCreateClicked: onAddGroupCreateButtonClicked, onTextChange: onAddGroupTextChanged }) : null,
	        groups && groups.map(function (group, index) {
	            return _react2.default.createElement(GroupRow, { key: group.id, group: group, index: index, groupBeingEdited: groupBeingEdited,
	                onEditGroupClicked: onEditGroupClicked,
	                onDeleteGroupClicked: onDeleteGroupClicked,
	                onEditGroupTextChange: onEditGroupTextChange,
	                onEditGroupCancelClicked: onEditGroupCancelClicked,
	                onEditGroupDoneClicked: onEditGroupDoneClicked
	            });
	        })
	    );
	}
	
	GroupsTable.displayName = "GroupsTable";
	// ------------------------------------------------------------ Logic ------------------------------------------------------------
	
	function sortGroups(groups) {
	    return _underscore2.default.sortBy(groups, function (group) {
	        return group.name && group.name.toLowerCase();
	    });
	}
	
	var GroupsListing = function (_Component) {
	    _inherits(GroupsListing, _Component);
	
	    function GroupsListing(props, context) {
	        _classCallCheck(this, GroupsListing);
	
	        var _this = _possibleConstructorReturn(this, (GroupsListing.__proto__ || Object.getPrototypeOf(GroupsListing)).call(this, props, context));
	
	        _this.state = {
	            text: "",
	            showAddGroupRow: false,
	            groups: null,
	            groupBeingEdited: null,
	            alertMessage: null
	        };
	        return _this;
	    }
	
	    _createClass(GroupsListing, [{
	        key: "alert",
	        value: function alert(alertMessage) {
	            this.setState({ alertMessage: alertMessage });
	        }
	    }, {
	        key: "onAddGroupCanceled",
	        value: function onAddGroupCanceled() {
	            this.setState({
	                showAddGroupRow: false
	            });
	        }
	
	        // TODO: move this to Redux
	
	    }, {
	        key: "onAddGroupCreateButtonClicked",
	        value: function onAddGroupCreateButtonClicked() {
	            var _this2 = this;
	
	            _analytics2.default.trackEvent("People Groups", "Group Added");
	            _services.PermissionsApi.createGroup({ name: this.state.text }).then(function (newGroup) {
	                var groups = _this2.state.groups || _this2.props.groups || [];
	                var newGroups = sortGroups(_underscore2.default.union(groups, [newGroup]));
	
	                _this2.setState({
	                    groups: newGroups,
	                    showAddGroupRow: false,
	                    text: ""
	                });
	            }, function (error) {
	                console.error('Error creating group:', error);
	                if (error.data && typeof error.data === "string") _this2.alert(error.data);
	            });
	        }
	    }, {
	        key: "onAddGroupTextChanged",
	        value: function onAddGroupTextChanged(newText) {
	            this.setState({
	                text: newText
	            });
	        }
	    }, {
	        key: "onCreateAGroupButtonClicked",
	        value: function onCreateAGroupButtonClicked() {
	            this.setState({
	                text: "",
	                showAddGroupRow: true,
	                groupBeingEdited: null
	            });
	        }
	    }, {
	        key: "onEditGroupClicked",
	        value: function onEditGroupClicked(group) {
	            this.setState({
	                groupBeingEdited: _underscore2.default.clone(group),
	                text: "",
	                showAddGroupRow: false
	            });
	        }
	    }, {
	        key: "onEditGroupTextChange",
	        value: function onEditGroupTextChange(newText) {
	            var groupBeingEdited = this.state.groupBeingEdited;
	            groupBeingEdited.name = newText;
	
	            this.setState({
	                groupBeingEdited: groupBeingEdited
	            });
	        }
	    }, {
	        key: "onEditGroupCancelClicked",
	        value: function onEditGroupCancelClicked() {
	            this.setState({
	                groupBeingEdited: null
	            });
	        }
	
	        // TODO: move this to Redux
	
	    }, {
	        key: "onEditGroupDoneClicked",
	        value: function onEditGroupDoneClicked() {
	            var _this3 = this;
	
	            var groups = this.state.groups || this.props.groups || [];
	            var originalGroup = _underscore2.default.findWhere(groups, { id: this.state.groupBeingEdited.id });
	            var group = this.state.groupBeingEdited;
	
	            // if name hasn't changed there is nothing to do
	            if (originalGroup.name === group.name) {
	                this.setState({
	                    groupBeingEdited: null
	                });
	                return;
	            }
	
	            // ok, fire off API call to change the group
	            _analytics2.default.trackEvent("People Groups", "Group Updated");
	            _services.PermissionsApi.updateGroup({ id: group.id, name: group.name }).then(function (newGroup) {
	                // now replace the original group with the new group and update state
	                var newGroups = _underscore2.default.reject(groups, function (g) {
	                    return g.id === group.id;
	                });
	                newGroups = sortGroups(_underscore2.default.union(newGroups, [newGroup]));
	
	                _this3.setState({
	                    groups: newGroups,
	                    groupBeingEdited: null
	                });
	            }, function (error) {
	                console.error("Error updating group name:", error);
	                if (error.data && typeof error.data === "string") _this3.alert(error.data);
	            });
	        }
	
	        // TODO: move this to Redux
	
	    }, {
	        key: "onDeleteGroupClicked",
	        value: function () {
	            var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(group) {
	                var _this4 = this;
	
	                var groups;
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                groups = this.state.groups || this.props.groups || [];
	
	                                _analytics2.default.trackEvent("People Groups", "Group Deleted");
	                                _services.PermissionsApi.deleteGroup({ id: group.id }).then(function () {
	                                    var newGroups = sortGroups(_underscore2.default.reject(groups, function (g) {
	                                        return g.id === group.id;
	                                    }));
	                                    _this4.setState({
	                                        groups: newGroups
	                                    });
	                                }, function (error) {
	                                    console.error("Error deleting group: ", error);
	                                    if (error.data && typeof error.data === "string") _this4.alert(error.data);
	                                });
	
	                            case 3:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function onDeleteGroupClicked(_x) {
	                return _ref7.apply(this, arguments);
	            }
	
	            return onDeleteGroupClicked;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            var _this5 = this;
	
	            var alertMessage = this.state.alertMessage;
	            var groups = this.props.groups;
	
	            groups = this.state.groups || groups || [];
	
	            return _react2.default.createElement(
	                _AdminPaneLayout2.default,
	                {
	                    title: "Groups",
	                    buttonText: "Create a group",
	                    buttonAction: this.state.showAddGroupRow ? null : this.onCreateAGroupButtonClicked.bind(this),
	                    description: "You can use groups to control your users' access to your data. Put users in groups and then go to the Permissions section to control each group's access. The Administrators and All Users groups are special default groups that can't be removed."
	                },
	                _react2.default.createElement(GroupsTable, {
	                    groups: groups,
	                    text: this.state.text,
	                    showAddGroupRow: this.state.showAddGroupRow,
	                    groupBeingEdited: this.state.groupBeingEdited,
	                    onAddGroupCanceled: this.onAddGroupCanceled.bind(this),
	                    onAddGroupCreateButtonClicked: this.onAddGroupCreateButtonClicked.bind(this),
	                    onAddGroupTextChanged: this.onAddGroupTextChanged.bind(this),
	                    onEditGroupClicked: this.onEditGroupClicked.bind(this),
	                    onEditGroupTextChange: this.onEditGroupTextChange.bind(this),
	                    onEditGroupCancelClicked: this.onEditGroupCancelClicked.bind(this),
	                    onEditGroupDoneClicked: this.onEditGroupDoneClicked.bind(this),
	                    onDeleteGroupClicked: this.onDeleteGroupClicked.bind(this)
	                }),
	                _react2.default.createElement(_Alert2.default, { message: alertMessage, onClose: function onClose() {
	                        return _this5.setState({ alertMessage: null });
	                    } })
	            );
	        }
	    }]);
	
	    return GroupsListing;
	}(_react.Component);
	
	GroupsListing.displayName = "GroupsListing";
	exports.default = GroupsListing;

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(1247);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Alert = function Alert(_ref) {
	    var message = _ref.message,
	        onClose = _ref.onClose;
	    return _react2.default.createElement(
	        _Modal2.default,
	        { small: true, isOpen: !!message },
	        _react2.default.createElement(
	            "div",
	            { className: "flex flex-column layout-centered p4" },
	            _react2.default.createElement(
	                "h3",
	                { className: "mb4" },
	                message
	            ),
	            _react2.default.createElement(
	                "button",
	                { className: "Button Button--primary", onClick: onClose },
	                "Ok"
	            )
	        )
	    );
	};
	
	Alert.displayName = "Alert";
	exports.default = Alert;

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddRow = function AddRow(_ref) {
	    var value = _ref.value,
	        isValid = _ref.isValid,
	        placeholder = _ref.placeholder,
	        onKeyDown = _ref.onKeyDown,
	        onChange = _ref.onChange,
	        onDone = _ref.onDone,
	        onCancel = _ref.onCancel,
	        children = _ref.children;
	    return _react2.default.createElement(
	        "div",
	        { className: "my2 pl1 p1 bordered border-brand rounded relative flex align-center" },
	        children,
	        _react2.default.createElement("input", {
	            className: "input--borderless h3 ml1 flex-full",
	            type: "text",
	            value: value,
	            placeholder: placeholder,
	            autoFocus: true,
	            onKeyDown: onKeyDown,
	            onChange: onChange
	        }),
	        _react2.default.createElement(
	            "span",
	            { className: "link no-decoration cursor-pointer", onClick: onCancel },
	            "Cancel"
	        ),
	        _react2.default.createElement(
	            "button",
	            { className: (0, _classnames2.default)("Button ml2", { "Button--primary": !!isValid }), disabled: !isValid, onClick: onDone },
	            "Add"
	        )
	    );
	};
	
	AddRow.displayName = "AddRow";
	exports.default = AddRow;

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class;
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(467);
	
	var _selectors = __webpack_require__(2044);
	
	var _people = __webpack_require__(2045);
	
	var _GroupDetail = __webpack_require__(2051);
	
	var _GroupDetail2 = _interopRequireDefault(_GroupDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function mapStateToProps(state, props) {
	    return {
	        group: (0, _selectors.getGroup)(state, props),
	        groups: (0, _selectors.getGroups)(state, props),
	        users: (0, _selectors.getUsers)(state, props)
	    };
	}
	
	var mapDispatchToProps = {
	    loadGroups: _people.loadGroups,
	    loadGroupDetails: _people.loadGroupDetails,
	    fetchUsers: _people.fetchUsers
	};
	
	var GroupDetailApp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_Component) {
	    _inherits(GroupDetailApp, _Component);
	
	    function GroupDetailApp() {
	        _classCallCheck(this, GroupDetailApp);
	
	        return _possibleConstructorReturn(this, (GroupDetailApp.__proto__ || Object.getPrototypeOf(GroupDetailApp)).apply(this, arguments));
	    }
	
	    _createClass(GroupDetailApp, [{
	        key: "componentWillMount",
	        value: function () {
	            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	                return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                this.props.loadGroups();
	                                this.props.fetchUsers();
	                                this.props.loadGroupDetails(this.props.params.groupId);
	
	                            case 3:
	                            case "end":
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function componentWillMount() {
	                return _ref.apply(this, arguments);
	            }
	
	            return componentWillMount;
	        }()
	    }, {
	        key: "componentWillReceiveProps",
	        value: function () {
	            var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(nextProps) {
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                if (nextProps.params.groupId !== this.props.params.groupId) {
	                                    this.props.loadGroupDetails(nextProps.params.groupId);
	                                }
	
	                            case 1:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function componentWillReceiveProps(_x) {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentWillReceiveProps;
	        }()
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(_GroupDetail2.default, this.props);
	        }
	    }]);
	
	    return GroupDetailApp;
	}(_react.Component)) || _class);
	GroupDetailApp.displayName = "GroupDetailApp";
	exports.default = GroupDetailApp;

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _classnames = __webpack_require__(908);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _groups = __webpack_require__(1683);
	
	var _services = __webpack_require__(857);
	
	var _Icon = __webpack_require__(902);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Popover = __webpack_require__(923);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _UserAvatar = __webpack_require__(1556);
	
	var _UserAvatar2 = _interopRequireDefault(_UserAvatar);
	
	var _AdminEmptyText = __webpack_require__(1817);
	
	var _AdminEmptyText2 = _interopRequireDefault(_AdminEmptyText);
	
	var _Alert = __webpack_require__(2048);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _AdminContentTable = __webpack_require__(1903);
	
	var _AdminContentTable2 = _interopRequireDefault(_AdminContentTable);
	
	var _AdminPaneLayout = __webpack_require__(2039);
	
	var _AdminPaneLayout2 = _interopRequireDefault(_AdminPaneLayout);
	
	var _Typeahead = __webpack_require__(2052);
	
	var _Typeahead2 = _interopRequireDefault(_Typeahead);
	
	var _AddRow = __webpack_require__(2049);
	
	var _AddRow2 = _interopRequireDefault(_AddRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupDescription = function GroupDescription(_ref) {
	    var group = _ref.group;
	    return (0, _groups.isDefaultGroup)(group) ? _react2.default.createElement(
	        "div",
	        { className: "px2 text-measure" },
	        _react2.default.createElement(
	            "p",
	            null,
	            "All users belong to the ",
	            group.name,
	            " group and can't be removed from it. Setting permissions for this group is a great way to make sure you know what new Metabase users will be able to see."
	        )
	    ) : (0, _groups.isAdminGroup)(group) ? _react2.default.createElement(
	        "div",
	        { className: "px2 text-measure" },
	        _react2.default.createElement(
	            "p",
	            null,
	            "This is a special group whose members can see everything in the Metabase instance, and who can access and make changes to the settings in the Admin Panel, including changing permissions! So, add people to this group with care."
	        ),
	        _react2.default.createElement(
	            "p",
	            null,
	            "To make sure you don't get locked out of Metabase, there always has to be at least one user in this group."
	        )
	    ) : null;
	};
	
	// ------------------------------------------------------------ Add User Row / Autocomplete ------------------------------------------------------------
	
	var AddMemberAutocompleteSuggestion = function AddMemberAutocompleteSuggestion(_ref2) {
	    var user = _ref2.user,
	        color = _ref2.color,
	        selected = _ref2.selected,
	        onClick = _ref2.onClick;
	    return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("px2 py1 cursor-pointer", { "bg-brand": selected }), onClick: onClick },
	        _react2.default.createElement(
	            "span",
	            { className: "inline-block text-white mr2" },
	            _react2.default.createElement(_UserAvatar2.default, { background: color, user: user })
	        ),
	        _react2.default.createElement(
	            "span",
	            { className: (0, _classnames2.default)("h3", { "text-white": selected }) },
	            user.common_name
	        )
	    );
	};
	
	AddMemberAutocompleteSuggestion.displayName = "AddMemberAutocompleteSuggestion";
	var COLORS = ['bg-error', 'bg-purple', 'bg-brand', 'bg-gold', 'bg-green'];
	
	var AddMemberTypeahead = (0, _Typeahead2.default)({
	    optionFilter: function optionFilter(text, user) {
	        return (user.common_name || "").toLowerCase().includes(text.toLowerCase());
	    },
	    optionIsEqual: function optionIsEqual(userA, userB) {
	        return userA.id === userB.id;
	    }
	})(function (_ref3) {
	    var suggestions = _ref3.suggestions,
	        selectedSuggestion = _ref3.selectedSuggestion,
	        onSuggestionAccepted = _ref3.onSuggestionAccepted;
	    return _react2.default.createElement(
	        _Popover2.default,
	        { className: "bordered", hasArrow: false, targetOffsetY: 2, targetOffsetX: 0, horizontalAttachments: ["left"] },
	        suggestions && suggestions.map(function (user, index) {
	            return _react2.default.createElement(AddMemberAutocompleteSuggestion, {
	                key: index,
	                user: user,
	                color: COLORS[index % COLORS.length],
	                selected: selectedSuggestion && user.id === selectedSuggestion.id,
	                onClick: onSuggestionAccepted.bind(null, user)
	            });
	        })
	    );
	});
	
	var AddUserRow = function AddUserRow(_ref4) {
	    var users = _ref4.users,
	        text = _ref4.text,
	        selectedUsers = _ref4.selectedUsers,
	        onCancel = _ref4.onCancel,
	        onDone = _ref4.onDone,
	        onTextChange = _ref4.onTextChange,
	        onSuggestionAccepted = _ref4.onSuggestionAccepted,
	        onRemoveUserFromSelection = _ref4.onRemoveUserFromSelection;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            { colSpan: "3", style: { padding: 0 } },
	            _react2.default.createElement(
	                _AddRow2.default,
	                {
	                    value: text,
	                    isValid: selectedUsers.length,
	                    placeholder: "Julie McMemberson",
	                    onChange: function onChange(e) {
	                        return onTextChange(e.target.value);
	                    },
	                    onDone: onDone,
	                    onCancel: onCancel
	                },
	                selectedUsers.map(function (user) {
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "bg-slate-light p1 px2 mr1 rounded flex align-center" },
	                        user.common_name,
	                        _react2.default.createElement(_Icon2.default, { className: "pl1 cursor-pointer text-slate text-grey-4-hover", name: "close", onClick: function onClick() {
	                                return onRemoveUserFromSelection(user);
	                            } })
	                    );
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "absolute bottom left" },
	                    _react2.default.createElement(AddMemberTypeahead, {
	                        value: text,
	                        options: Object.values(users),
	                        onSuggestionAccepted: onSuggestionAccepted
	                    })
	                )
	            )
	        )
	    );
	};
	
	AddUserRow.displayName = "AddUserRow";
	// ------------------------------------------------------------ Users Table ------------------------------------------------------------
	
	var UserRow = function UserRow(_ref5) {
	    var user = _ref5.user,
	        showRemoveButton = _ref5.showRemoveButton,
	        onRemoveUserClicked = _ref5.onRemoveUserClicked;
	    return _react2.default.createElement(
	        "tr",
	        null,
	        _react2.default.createElement(
	            "td",
	            null,
	            user.first_name + " " + user.last_name
	        ),
	        _react2.default.createElement(
	            "td",
	            null,
	            user.email
	        ),
	        showRemoveButton ? _react2.default.createElement(
	            "td",
	            { className: "text-right cursor-pointer", onClick: onRemoveUserClicked.bind(null, user) },
	            _react2.default.createElement(_Icon2.default, { name: "close", className: "text-grey-1", size: 16 })
	        ) : null
	    );
	};
	
	UserRow.displayName = "UserRow";
	var MembersTable = function MembersTable(_ref6) {
	    var group = _ref6.group,
	        members = _ref6.members,
	        users = _ref6.users,
	        showAddUser = _ref6.showAddUser,
	        text = _ref6.text,
	        selectedUsers = _ref6.selectedUsers,
	        onAddUserCancel = _ref6.onAddUserCancel,
	        onAddUserDone = _ref6.onAddUserDone,
	        onAddUserTextChange = _ref6.onAddUserTextChange,
	        onUserSuggestionAccepted = _ref6.onUserSuggestionAccepted,
	        onRemoveUserClicked = _ref6.onRemoveUserClicked,
	        onRemoveUserFromSelection = _ref6.onRemoveUserFromSelection;
	
	    // you can't remove people from Default and you can't remove the last user from Admin
	    var showRemoveMemeberButton = !(0, _groups.isDefaultGroup)(group) && (!(0, _groups.isAdminGroup)(group) || members.length > 1);
	
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            _AdminContentTable2.default,
	            { columnTitles: ["Members", "Email"] },
	            showAddUser && _react2.default.createElement(AddUserRow, {
	                users: users,
	                text: text,
	                selectedUsers: selectedUsers,
	                onCancel: onAddUserCancel,
	                onDone: onAddUserDone,
	                onTextChange: onAddUserTextChange,
	                onSuggestionAccepted: onUserSuggestionAccepted,
	                onRemoveUserFromSelection: onRemoveUserFromSelection
	            }),
	            members && members.map(function (user, index) {
	                return _react2.default.createElement(UserRow, { key: index, user: user, showRemoveButton: showRemoveMemeberButton, onRemoveUserClicked: onRemoveUserClicked });
	            })
	        ),
	        members.length === 0 && _react2.default.createElement(
	            "div",
	            { className: "mt4 pt4 flex layout-centered" },
	            _react2.default.createElement(_AdminEmptyText2.default, { message: "A group is only as good as its members." })
	        )
	    );
	};
	
	MembersTable.displayName = "MembersTable";
	
	// ------------------------------------------------------------ Logic ------------------------------------------------------------
	
	
	var GroupDetail = function (_Component) {
	    _inherits(GroupDetail, _Component);
	
	    function GroupDetail(props, context) {
	        _classCallCheck(this, GroupDetail);
	
	        var _this = _possibleConstructorReturn(this, (GroupDetail.__proto__ || Object.getPrototypeOf(GroupDetail)).call(this, props, context));
	
	        _this.state = {
	            addUserVisible: false,
	            text: "",
	            selectedUsers: [],
	            members: null,
	            alertMessage: null
	        };
	        return _this;
	    }
	
	    _createClass(GroupDetail, [{
	        key: "alert",
	        value: function alert(alertMessage) {
	            this.setState({ alertMessage: alertMessage });
	        }
	    }, {
	        key: "onAddUsersClicked",
	        value: function onAddUsersClicked() {
	            this.setState({
	                addUserVisible: true
	            });
	        }
	    }, {
	        key: "onAddUserCanceled",
	        value: function onAddUserCanceled() {
	            this.setState({
	                addUserVisible: false,
	                text: "",
	                selectedUsers: []
	            });
	        }
	    }, {
	        key: "onAddUserDone",
	        value: function () {
	            var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	                var _this2 = this;
	
	                return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                this.setState({
	                                    addUserVisible: false,
	                                    text: "",
	                                    selectedUsers: []
	                                });
	                                _context2.prev = 1;
	                                _context2.next = 4;
	                                return Promise.all(this.state.selectedUsers.map(function () {
	                                    var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(user) {
	                                        var members;
	                                        return regeneratorRuntime.wrap(function _callee$(_context) {
	                                            while (1) {
	                                                switch (_context.prev = _context.next) {
	                                                    case 0:
	                                                        _context.next = 2;
	                                                        return _services.PermissionsApi.createMembership({ group_id: _this2.props.group.id, user_id: user.id });
	
	                                                    case 2:
	                                                        members = _context.sent;
	
	                                                        _this2.setState({ members: members });
	
	                                                    case 4:
	                                                    case "end":
	                                                        return _context.stop();
	                                                }
	                                            }
	                                        }, _callee, _this2);
	                                    }));
	
	                                    return function (_x) {
	                                        return _ref8.apply(this, arguments);
	                                    };
	                                }()));
	
	                            case 4:
	                                _context2.next = 9;
	                                break;
	
	                            case 6:
	                                _context2.prev = 6;
	                                _context2.t0 = _context2["catch"](1);
	
	                                this.alert(_context2.t0 && _typeof(_context2.t0.data) ? _context2.t0.data : _context2.t0);
	
	                            case 9:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this, [[1, 6]]);
	            }));
	
	            function onAddUserDone() {
	                return _ref7.apply(this, arguments);
	            }
	
	            return onAddUserDone;
	        }()
	    }, {
	        key: "onAddUserTextChange",
	        value: function onAddUserTextChange(newText) {
	            this.setState({
	                text: newText
	            });
	        }
	    }, {
	        key: "onUserSuggestionAccepted",
	        value: function onUserSuggestionAccepted(user) {
	            this.setState({
	                selectedUsers: this.state.selectedUsers.concat(user),
	                text: ""
	            });
	        }
	    }, {
	        key: "onRemoveUserFromSelection",
	        value: function onRemoveUserFromSelection(user) {
	            this.setState({
	                selectedUsers: this.state.selectedUsers.filter(function (u) {
	                    return u.id !== user.id;
	                })
	            });
	        }
	    }, {
	        key: "onRemoveUserClicked",
	        value: function () {
	            var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(membership) {
	                var newMembers;
	                return regeneratorRuntime.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                _context3.prev = 0;
	                                _context3.next = 3;
	                                return _services.PermissionsApi.deleteMembership({ id: membership.membership_id });
	
	                            case 3:
	                                newMembers = _underscore2.default.reject(this.getMembers(), function (m) {
	                                    return m.user_id === membership.user_id;
	                                });
	
	                                this.setState({ members: newMembers });
	                                _context3.next = 11;
	                                break;
	
	                            case 7:
	                                _context3.prev = 7;
	                                _context3.t0 = _context3["catch"](0);
	
	                                console.error("Error deleting PermissionsMembership:", _context3.t0);
	                                this.alert(_context3.t0 && _typeof(_context3.t0.data) ? _context3.t0.data : _context3.t0);
	
	                            case 11:
	                            case "end":
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this, [[0, 7]]);
	            }));
	
	            function onRemoveUserClicked(_x2) {
	                return _ref9.apply(this, arguments);
	            }
	
	            return onRemoveUserClicked;
	        }()
	
	        // TODO - bad!
	        // TODO - this totally breaks if you edit members and then switch groups !
	
	    }, {
	        key: "getMembers",
	        value: function getMembers() {
	            return this.state.members || this.props.group && this.props.group.members || [];
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            // users = array of all users for purposes of adding new users to group
	            // [group.]members = array of users currently in the group
	            var _props = this.props,
	                group = _props.group,
	                users = _props.users;
	            var _state = this.state,
	                text = _state.text,
	                selectedUsers = _state.selectedUsers,
	                addUserVisible = _state.addUserVisible,
	                alertMessage = _state.alertMessage;
	
	            var members = this.getMembers();
	
	            group = group || {};
	            users = users || {};
	
	            var usedUsers = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = members[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var user = _step.value;
	                    usedUsers[user.user_id] = true;
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = selectedUsers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _user = _step2.value;
	                    usedUsers[_user.id] = true;
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            var filteredUsers = Object.values(users).filter(function (user) {
	                return !usedUsers[user.id];
	            });
	
	            return _react2.default.createElement(
	                _AdminPaneLayout2.default,
	                {
	                    title: group.name,
	                    buttonText: "Add members",
	                    buttonAction: (0, _groups.canEditMembership)(group) ? this.onAddUsersClicked.bind(this) : null,
	                    buttonDisabled: addUserVisible
	                },
	                _react2.default.createElement(GroupDescription, { group: group }),
	                _react2.default.createElement(MembersTable, {
	                    group: group,
	                    members: members,
	                    users: filteredUsers,
	                    showAddUser: addUserVisible,
	                    text: text || "",
	                    selectedUsers: selectedUsers,
	                    onAddUserCancel: this.onAddUserCanceled.bind(this),
	                    onAddUserDone: this.onAddUserDone.bind(this),
	                    onAddUserTextChange: this.onAddUserTextChange.bind(this),
	                    onUserSuggestionAccepted: this.onUserSuggestionAccepted.bind(this),
	                    onRemoveUserFromSelection: this.onRemoveUserFromSelection.bind(this),
	                    onRemoveUserClicked: this.onRemoveUserClicked.bind(this)
	                }),
	                _react2.default.createElement(_Alert2.default, { message: alertMessage, onClose: function onClose() {
	                        return _this3.setState({ alertMessage: null });
	                    } })
	            );
	        }
	    }]);
	
	    return GroupDetail;
	}(_react.Component);
	
	GroupDetail.displayName = "GroupDetail";
	exports.default = GroupDetail;

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(300);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(469);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _underscore = __webpack_require__(519);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _keyboard = __webpack_require__(934);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_FILTER_OPTIONS = function DEFAULT_FILTER_OPTIONS(value, option) {
	    try {
	        return JSON.stringify(option).includes(value);
	    } catch (e) {
	        return false;
	    }
	};
	
	var DEFAULT_OPTION_IS_EQUAL = function DEFAULT_OPTION_IS_EQUAL(a, b) {
	    return a === b;
	};
	
	exports.default = function (_ref) {
	    var _ref$optionFilter = _ref.optionFilter,
	        optionFilter = _ref$optionFilter === undefined ? DEFAULT_FILTER_OPTIONS : _ref$optionFilter,
	        _ref$optionIsEqual = _ref.optionIsEqual,
	        optionIsEqual = _ref$optionIsEqual === undefined ? DEFAULT_OPTION_IS_EQUAL : _ref$optionIsEqual;
	    return function (ComposedComponent) {
	        var _class, _temp;
	
	        return _temp = _class = function (_Component) {
	            _inherits(_class, _Component);
	
	            function _class(props, context) {
	                _classCallCheck(this, _class);
	
	                var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));
	
	                _this.onKeyDown = function (e) {
	                    if (e.keyCode === _keyboard.KEYCODE_UP) {
	                        e.preventDefault();
	                        _this.onPressUp();
	                    } else if (e.keyCode === _keyboard.KEYCODE_DOWN) {
	                        e.preventDefault();
	                        _this.onPressDown();
	                    } else if (e.keyCode === _keyboard.KEYCODE_ENTER) {
	                        e.preventDefault();
	                        _this.onSuggestionAccepted(_this.state.selectedSuggestion);
	                    }
	                };
	
	                _this.onSuggestionAccepted = function (suggestion) {
	                    _this.props.onSuggestionAccepted(suggestion);
	                };
	
	                _this.onPressUp = function () {
	                    var _this$state = _this.state,
	                        suggestions = _this$state.suggestions,
	                        selectedSuggestion = _this$state.selectedSuggestion;
	
	                    if (suggestions.length === 0) {
	                        return;
	                    } else if (!selectedSuggestion) {
	                        _this.setState({ selectedSuggestion: suggestions[suggestions.length - 1] });
	                    } else {
	                        _this.setSelectedIndex(_this.indexOfSelectedSuggestion() - 1);
	                    }
	                };
	
	                _this.onPressDown = function () {
	                    var _this$state2 = _this.state,
	                        suggestions = _this$state2.suggestions,
	                        selectedSuggestion = _this$state2.selectedSuggestion;
	
	                    if (suggestions.length === 0) {
	                        return;
	                    } else if (!selectedSuggestion) {
	                        _this.setState({ selectedSuggestion: suggestions[0] });
	                    } else {
	                        _this.setSelectedIndex(_this.indexOfSelectedSuggestion() + 1);
	                    }
	                };
	
	                _this.state = {
	                    suggestions: [],
	                    selectedSuggestion: null
	                };
	                return _this;
	            }
	
	            _createClass(_class, [{
	                key: "componentDidMount",
	                value: function componentDidMount() {
	                    window.addEventListener("keydown", this.onKeyDown, true);
	                }
	            }, {
	                key: "componentWillUnmount",
	                value: function componentWillUnmount() {
	                    window.removeEventListener("keydown", this.onKeyDown, true);
	                }
	            }, {
	                key: "componentWillReceiveProps",
	                value: function componentWillReceiveProps(_ref2) {
	                    var options = _ref2.options,
	                        value = _ref2.value;
	
	                    var filtered = value ? options.filter(optionFilter.bind(null, value)) : [];
	                    this.setState({
	                        suggestions: filtered,
	                        isOpen: filtered.length > 0
	                    });
	                }
	            }, {
	                key: "indexOfSelectedSuggestion",
	                value: function indexOfSelectedSuggestion() {
	                    var _this2 = this;
	
	                    return _underscore2.default.findIndex(this.state.suggestions, function (suggestion) {
	                        return optionIsEqual(suggestion, _this2.state.selectedSuggestion);
	                    });
	                }
	            }, {
	                key: "setSelectedIndex",
	                value: function setSelectedIndex(newIndex) {
	                    var index = Math.max(Math.min(newIndex, this.state.suggestions.length - 1), 0);
	                    this.setState({
	                        selectedSuggestion: this.state.suggestions[index]
	                    });
	                }
	            }, {
	                key: "render",
	                value: function render() {
	                    var _state = this.state,
	                        suggestions = _state.suggestions,
	                        selectedSuggestion = _state.selectedSuggestion;
	
	                    if (suggestions.length === 0) {
	                        return null;
	                    }
	                    return _react2.default.createElement(ComposedComponent, _extends({}, this.props, {
	                        suggestions: suggestions,
	                        selectedSuggestion: selectedSuggestion,
	                        onSuggestionAccepted: this.onSuggestionAccepted
	                    }));
	                }
	            }]);
	
	            return _class;
	        }(_react.Component), _class.displayName = "Typeahead[" + (ComposedComponent.displayName || ComposedComponent.name) + "]", _class.propTypes = {
	            value: _propTypes2.default.string,
	            options: _propTypes2.default.array
	        }, _temp;
	    };
	};

/***/ }),
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	// Reducers needed for main application
	
	/* admin */
	
	
	/* setup */
	
	
	/* user settings */
	
	
	/* dashboards */
	
	
	/* questions / query builder */
	
	
	/* data reference */
	
	
	/* pulses */
	
	
	/* xrays */
	
	
	var _redux = __webpack_require__(480);
	
	var _reducersCommon = __webpack_require__(1536);
	
	var _reducersCommon2 = _interopRequireDefault(_reducersCommon);
	
	var _admin = __webpack_require__(2098);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _reducers = __webpack_require__(2099);
	
	var setup = _interopRequireWildcard(_reducers);
	
	var _reducers2 = __webpack_require__(2100);
	
	var user = _interopRequireWildcard(_reducers2);
	
	var _dashboards = __webpack_require__(1521);
	
	var _dashboards2 = _interopRequireDefault(_dashboards);
	
	var _dashboard = __webpack_require__(1520);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _reducers3 = __webpack_require__(2101);
	
	var home = _interopRequireWildcard(_reducers3);
	
	var _new_query = __webpack_require__(1804);
	
	var _new_query2 = _interopRequireDefault(_new_query);
	
	var _questions = __webpack_require__(1622);
	
	var _questions2 = _interopRequireDefault(_questions);
	
	var _labels = __webpack_require__(1641);
	
	var _labels2 = _interopRequireDefault(_labels);
	
	var _collections = __webpack_require__(1613);
	
	var _collections2 = _interopRequireDefault(_collections);
	
	var _reducers4 = __webpack_require__(2102);
	
	var qb = _interopRequireWildcard(_reducers4);
	
	var _reference = __webpack_require__(1921);
	
	var _reference2 = _interopRequireDefault(_reference);
	
	var _reducers5 = __webpack_require__(2103);
	
	var pulse = _interopRequireWildcard(_reducers5);
	
	var _xray = __webpack_require__(2012);
	
	var _xray2 = _interopRequireDefault(_xray);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({}, _reducersCommon2.default, {
	
	    // main app reducers
	    dashboards: _dashboards2.default,
	    dashboard: _dashboard2.default,
	    home: (0, _redux.combineReducers)(home),
	    new_query: _new_query2.default,
	    pulse: (0, _redux.combineReducers)(pulse),
	    qb: (0, _redux.combineReducers)(qb),
	    questions: _questions2.default,
	    collections: _collections2.default,
	    labels: _labels2.default,
	    reference: _reference2.default,
	    xray: _xray2.default,
	    setup: (0, _redux.combineReducers)(setup),
	    user: (0, _redux.combineReducers)(user),
	    admin: _admin2.default
	});

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _people = __webpack_require__(2045);
	
	var _people2 = _interopRequireDefault(_people);
	
	var _database = __webpack_require__(1790);
	
	var _database2 = _interopRequireDefault(_database);
	
	var _datamodel = __webpack_require__(1836);
	
	var _datamodel2 = _interopRequireDefault(_datamodel);
	
	var _permissions = __webpack_require__(1682);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _settings = __webpack_require__(1906);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _redux = __webpack_require__(657);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Reducers needed for admin section (only used in "main" app)
	
	exports.default = (0, _redux.combineReducers)({
	    databases: _database2.default,
	    datamodel: _datamodel2.default,
	    people: _people2.default,
	    permissions: _permissions2.default,
	    settings: _settings2.default
	});

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setupComplete = exports.setupError = exports.allowTracking = exports.databaseDetails = exports.userDetails = exports.activeStep = undefined;
	
	var _handleActions;
	
	var _reduxActions = __webpack_require__(658);
	
	var _actions = __webpack_require__(1795);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var activeStep = exports.activeStep = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _actions.SET_ACTIVE_STEP, { next: function next(state, _ref) {
	        var payload = _ref.payload;
	        return payload;
	    } }), _defineProperty(_handleActions, _actions.SET_USER_DETAILS, { next: function next(state, _ref2) {
	        var payload = _ref2.payload;
	        return payload.nextStep;
	    } }), _defineProperty(_handleActions, _actions.SET_DATABASE_DETAILS, { next: function next(state, _ref3) {
	        var payload = _ref3.payload;
	        return payload.nextStep;
	    } }), _handleActions), 0);
	
	var userDetails = exports.userDetails = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.SET_USER_DETAILS, { next: function next(state, _ref4) {
	        var payload = _ref4.payload;
	        return payload.details;
	    } }), null);
	
	var databaseDetails = exports.databaseDetails = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.SET_DATABASE_DETAILS, { next: function next(state, _ref5) {
	        var payload = _ref5.payload;
	        return payload.details;
	    } }), null);
	
	var allowTracking = exports.allowTracking = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.SET_ALLOW_TRACKING, { next: function next(state, _ref6) {
	        var payload = _ref6.payload;
	        return payload;
	    } }), true);
	
	var setupError = exports.setupError = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.SUBMIT_SETUP, { next: function next(state, _ref7) {
	        var payload = _ref7.payload;
	        return payload;
	    } }), null);
	
	var setupComplete = exports.setupComplete = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.COMPLETE_SETUP, { next: function next(state, _ref8) {
	        var payload = _ref8.payload;
	        return true;
	    } }), false);

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.updateUserResult = exports.updatePasswordResult = exports.tab = undefined;
	
	var _handleActions2, _handleActions3;
	
	var _reduxActions = __webpack_require__(658);
	
	var _actions = __webpack_require__(1801);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var tab = exports.tab = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.CHANGE_TAB, { next: function next(state, _ref) {
	        var payload = _ref.payload;
	        return payload;
	    } }), 'details');
	
	var updatePasswordResult = exports.updatePasswordResult = (0, _reduxActions.handleActions)((_handleActions2 = {}, _defineProperty(_handleActions2, _actions.CHANGE_TAB, { next: function next(state, _ref2) {
	        var payload = _ref2.payload;
	        return null;
	    } }), _defineProperty(_handleActions2, _actions.UPDATE_PASSWORD, { next: function next(state, _ref3) {
	        var payload = _ref3.payload;
	        return payload;
	    } }), _handleActions2), null);
	
	var updateUserResult = exports.updateUserResult = (0, _reduxActions.handleActions)((_handleActions3 = {}, _defineProperty(_handleActions3, _actions.CHANGE_TAB, { next: function next(state, _ref4) {
	        var payload = _ref4.payload;
	        return null;
	    } }), _defineProperty(_handleActions3, _actions.UPDATE_USER, { next: function next(state, _ref5) {
	        var payload = _ref5.payload;
	        return payload;
	    } }), _handleActions3), null);

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.recentViews = exports.activity = undefined;
	
	var _reduxActions = __webpack_require__(658);
	
	var _actions = __webpack_require__(1590);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var activity = exports.activity = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.FETCH_ACTIVITY, { next: function next(state, _ref) {
	        var payload = _ref.payload;
	        return payload;
	    } }), null);
	
	var recentViews = exports.recentViews = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.FETCH_RECENT_VIEWS, { next: function next(state, _ref2) {
	        var payload = _ref2.payload;
	        return payload;
	    } }), []);

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.currentState = exports.parameterValues = exports.cancelQueryDeferred = exports.queryResults = exports.queryResult = exports.lastRunCard = exports.tableForeignKeyReferences = exports.databaseFields = exports.tableForeignKeys = exports.originalCard = exports.card = exports.uiControls = undefined;
	
	var _handleActions, _handleActions2, _handleActions3, _handleActions4, _handleActions7, _handleActions8, _handleActions9, _handleActions10;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(521);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _reduxActions = __webpack_require__(658);
	
	var _icepick = __webpack_require__(855);
	
	var _actions = __webpack_require__(863);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// various ui state options
	var uiControls = exports.uiControls = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _actions.INITIALIZE_QB, { next: function next(state, _ref) {
	        var payload = _ref.payload;
	        return _extends({}, state, payload.uiControls);
	    } }), _defineProperty(_handleActions, _actions.TOGGLE_DATA_REFERENCE, { next: function next(state, _ref2) {
	        var payload = _ref2.payload;
	        return _extends({}, state, { isShowingDataReference: !state.isShowingDataReference, isShowingTemplateTagsEditor: false });
	    } }), _defineProperty(_handleActions, _actions.TOGGLE_TEMPLATE_TAGS_EDITOR, { next: function next(state, _ref3) {
	        var payload = _ref3.payload;
	        return _extends({}, state, { isShowingTemplateTagsEditor: !state.isShowingTemplateTagsEditor, isShowingDataReference: false });
	    } }), _defineProperty(_handleActions, _actions.SET_IS_SHOWING_TEMPLATE_TAGS_EDITOR, { next: function next(state, _ref4) {
	        var isShowingTemplateTagsEditor = _ref4.isShowingTemplateTagsEditor;
	        return _extends({}, state, { isShowingTemplateTagsEditor: isShowingTemplateTagsEditor, isShowingDataReference: false });
	    } }), _defineProperty(_handleActions, _actions.SET_DATASET_QUERY, { next: function next(state, _ref5) {
	        var payload = _ref5.payload;
	        return _extends({}, state, { isShowingTemplateTagsEditor: payload.openTemplateTagsEditor });
	    } }), _defineProperty(_handleActions, _actions.CLOSE_QB_TUTORIAL, { next: function next(state, _ref6) {
	        var payload = _ref6.payload;
	        return _extends({}, state, { isShowingTutorial: false });
	    } }), _defineProperty(_handleActions, _actions.CLOSE_QB_NEWB_MODAL, { next: function next(state, _ref7) {
	        var payload = _ref7.payload;
	        return _extends({}, state, { isShowingNewbModal: false });
	    } }), _defineProperty(_handleActions, _actions.BEGIN_EDITING, { next: function next(state, _ref8) {
	        var payload = _ref8.payload;
	        return _extends({}, state, { isEditing: true });
	    } }), _defineProperty(_handleActions, _actions.CANCEL_EDITING, { next: function next(state, _ref9) {
	        var payload = _ref9.payload;
	        return _extends({}, state, { isEditing: false });
	    } }), _defineProperty(_handleActions, _actions.NOTIFY_CARD_UPDATED, { next: function next(state, _ref10) {
	        var payload = _ref10.payload;
	        return _extends({}, state, { isEditing: false });
	    } }), _defineProperty(_handleActions, _actions.RELOAD_CARD, { next: function next(state, _ref11) {
	        var payload = _ref11.payload;
	        return _extends({}, state, { isEditing: false });
	    } }), _defineProperty(_handleActions, _actions.RUN_QUERY, function (state) {
	    return _extends({}, state, { isRunning: true });
	}), _defineProperty(_handleActions, _actions.CANCEL_QUERY, { next: function next(state, _ref12) {
	        var payload = _ref12.payload;
	        return _extends({}, state, { isRunning: false });
	    } }), _defineProperty(_handleActions, _actions.QUERY_COMPLETED, { next: function next(state, _ref13) {
	        var payload = _ref13.payload;
	        return _extends({}, state, { isRunning: false });
	    } }), _defineProperty(_handleActions, _actions.QUERY_ERRORED, { next: function next(state, _ref14) {
	        var payload = _ref14.payload;
	        return _extends({}, state, { isRunning: false });
	    } }), _handleActions), {
	    isShowingDataReference: false,
	    isShowingTemplateTagsEditor: false,
	    isShowingTutorial: false,
	    isShowingNewbModal: false,
	    isEditing: false,
	    isRunning: false
	});
	
	// the card that is actively being worked on
	var card = exports.card = (0, _reduxActions.handleActions)((_handleActions2 = {}, _defineProperty(_handleActions2, _actions.RESET_QB, { next: function next(state, _ref15) {
	        var payload = _ref15.payload;
	        return null;
	    } }), _defineProperty(_handleActions2, _actions.INITIALIZE_QB, { next: function next(state, _ref16) {
	        var payload = _ref16.payload;
	        return payload ? payload.card : null;
	    } }), _defineProperty(_handleActions2, _actions.RELOAD_CARD, { next: function next(state, _ref17) {
	        var payload = _ref17.payload;
	        return payload;
	    } }), _defineProperty(_handleActions2, _actions.CANCEL_EDITING, { next: function next(state, _ref18) {
	        var payload = _ref18.payload;
	        return payload;
	    } }), _defineProperty(_handleActions2, _actions.SET_CARD_AND_RUN, { next: function next(state, _ref19) {
	        var payload = _ref19.payload;
	        return payload.card;
	    } }), _defineProperty(_handleActions2, _actions.NOTIFY_CARD_CREATED, { next: function next(state, _ref20) {
	        var payload = _ref20.payload;
	        return payload;
	    } }), _defineProperty(_handleActions2, _actions.NOTIFY_CARD_UPDATED, { next: function next(state, _ref21) {
	        var payload = _ref21.payload;
	        return payload;
	    } }), _defineProperty(_handleActions2, _actions.SET_CARD_ATTRIBUTE, { next: function next(state, _ref22) {
	        var payload = _ref22.payload;
	        return _extends({}, state, _defineProperty({}, payload.attr, payload.value));
	    } }), _defineProperty(_handleActions2, _actions.SET_CARD_VISUALIZATION, { next: function next(state, _ref23) {
	        var payload = _ref23.payload;
	        return payload;
	    } }), _defineProperty(_handleActions2, _actions.UPDATE_CARD_VISUALIZATION_SETTINGS, { next: function next(state, _ref24) {
	        var payload = _ref24.payload;
	        return payload;
	    } }), _defineProperty(_handleActions2, _actions.REPLACE_ALL_CARD_VISUALIZATION_SETTINGS, { next: function next(state, _ref25) {
	        var payload = _ref25.payload;
	        return payload;
	    } }), _defineProperty(_handleActions2, _actions.UPDATE_TEMPLATE_TAG, { next: function next(state, _ref26) {
	        var payload = _ref26.payload;
	        return payload;
	    } }), _defineProperty(_handleActions2, _actions.SET_QUERY_MODE, { next: function next(state, _ref27) {
	        var payload = _ref27.payload;
	        return payload;
	    } }), _defineProperty(_handleActions2, _actions.SET_QUERY_DATABASE, { next: function next(state, _ref28) {
	        var payload = _ref28.payload;
	        return payload;
	    } }), _defineProperty(_handleActions2, _actions.SET_QUERY_SOURCE_TABLE, { next: function next(state, _ref29) {
	        var payload = _ref29.payload;
	        return payload;
	    } }), _defineProperty(_handleActions2, _actions.SET_DATASET_QUERY, { next: function next(state, _ref30) {
	        var payload = _ref30.payload;
	        return payload.card;
	    } }), _defineProperty(_handleActions2, _actions.UPDATE_QUESTION, function (state, _ref31) {
	    var card = _ref31.payload.card;
	    return card;
	}), _defineProperty(_handleActions2, _actions.QUERY_COMPLETED, { next: function next(state, _ref32) {
	        var payload = _ref32.payload;
	        return _extends({}, state, { display: payload.cardDisplay });
	    } }), _defineProperty(_handleActions2, _actions.CREATE_PUBLIC_LINK, { next: function next(state, _ref33) {
	        var payload = _ref33.payload;
	        return _extends({}, state, { public_uuid: payload.uuid });
	    } }), _defineProperty(_handleActions2, _actions.DELETE_PUBLIC_LINK, { next: function next(state, _ref34) {
	        var payload = _ref34.payload;
	        return _extends({}, state, { public_uuid: null });
	    } }), _defineProperty(_handleActions2, _actions.UPDATE_ENABLE_EMBEDDING, { next: function next(state, _ref35) {
	        var payload = _ref35.payload;
	        return _extends({}, state, { enable_embedding: payload.enable_embedding });
	    } }), _defineProperty(_handleActions2, _actions.UPDATE_EMBEDDING_PARAMS, { next: function next(state, _ref36) {
	        var payload = _ref36.payload;
	        return _extends({}, state, { embedding_params: payload.embedding_params });
	    } }), _handleActions2), null);
	
	// a copy of the card being worked on at it's last known saved state.  if the card is NEW then this should be null.
	// NOTE: we use JSON serialization/deserialization to ensure a deep clone of the object which is required
	//       because we can't have any links between the active card being modified and the "originalCard" for testing dirtiness
	// ALSO: we consistently check for payload.id because an unsaved card has no "originalCard"
	var originalCard = exports.originalCard = (0, _reduxActions.handleActions)((_handleActions3 = {}, _defineProperty(_handleActions3, _actions.INITIALIZE_QB, { next: function next(state, _ref37) {
	        var payload = _ref37.payload;
	        return payload.originalCard ? _utils2.default.copy(payload.originalCard) : null;
	    } }), _defineProperty(_handleActions3, _actions.RELOAD_CARD, { next: function next(state, _ref38) {
	        var payload = _ref38.payload;
	        return payload.id ? _utils2.default.copy(payload) : null;
	    } }), _defineProperty(_handleActions3, _actions.CANCEL_EDITING, { next: function next(state, _ref39) {
	        var payload = _ref39.payload;
	        return payload.id ? _utils2.default.copy(payload) : null;
	    } }), _defineProperty(_handleActions3, _actions.SET_CARD_AND_RUN, { next: function next(state, _ref40) {
	        var payload = _ref40.payload;
	        return payload.originalCard ? _utils2.default.copy(payload.originalCard) : null;
	    } }), _defineProperty(_handleActions3, _actions.NOTIFY_CARD_CREATED, { next: function next(state, _ref41) {
	        var payload = _ref41.payload;
	        return _utils2.default.copy(payload);
	    } }), _defineProperty(_handleActions3, _actions.NOTIFY_CARD_UPDATED, { next: function next(state, _ref42) {
	        var payload = _ref42.payload;
	        return _utils2.default.copy(payload);
	    } }), _handleActions3), null);
	
	var tableForeignKeys = exports.tableForeignKeys = (0, _reduxActions.handleActions)((_handleActions4 = {}, _defineProperty(_handleActions4, _actions.RESET_QB, { next: function next(state, _ref43) {
	        var payload = _ref43.payload;
	        return null;
	    } }), _defineProperty(_handleActions4, _actions.LOAD_TABLE_METADATA, { next: function next(state, _ref44) {
	        var payload = _ref44.payload;
	        return payload && payload.foreignKeys ? payload.foreignKeys : state;
	    } }), _handleActions4), null);
	
	var databaseFields = exports.databaseFields = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.LOAD_DATABASE_FIELDS, { next: function next(state, _ref45) {
	        var payload = _ref45.payload;
	        return _defineProperty({}, payload.id, payload.fields);
	    } }), {});
	
	// references to FK tables specifically used on the ObjectDetail page.
	var tableForeignKeyReferences = exports.tableForeignKeyReferences = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.LOAD_OBJECT_DETAIL_FK_REFERENCES, { next: function next(state, _ref47) {
	        var payload = _ref47.payload;
	        return payload;
	    } }), null);
	
	var lastRunCard = exports.lastRunCard = (0, _reduxActions.handleActions)((_handleActions7 = {}, _defineProperty(_handleActions7, _actions.RESET_QB, { next: function next(state, _ref48) {
	        var payload = _ref48.payload;
	        return null;
	    } }), _defineProperty(_handleActions7, _actions.QUERY_COMPLETED, { next: function next(state, _ref49) {
	        var payload = _ref49.payload;
	        return payload.card;
	    } }), _defineProperty(_handleActions7, _actions.QUERY_ERRORED, { next: function next(state, _ref50) {
	        var payload = _ref50.payload;
	        return null;
	    } }), _handleActions7), null);
	
	// NOTE Atte Keinänen 6/1/17: DEPRECATED, you should use queryResults instead
	var queryResult = exports.queryResult = (0, _reduxActions.handleActions)((_handleActions8 = {}, _defineProperty(_handleActions8, _actions.RESET_QB, { next: function next(state, _ref51) {
	        var payload = _ref51.payload;
	        return null;
	    } }), _defineProperty(_handleActions8, _actions.QUERY_COMPLETED, { next: function next(state, _ref52) {
	        var payload = _ref52.payload;
	        return payload.queryResults[0];
	    } }), _defineProperty(_handleActions8, _actions.QUERY_ERRORED, { next: function next(state, _ref53) {
	        var payload = _ref53.payload;
	        return payload ? payload : state;
	    } }), _handleActions8), null);
	
	// The results of a query execution.  optionally an error if the query fails to complete successfully.
	var queryResults = exports.queryResults = (0, _reduxActions.handleActions)((_handleActions9 = {}, _defineProperty(_handleActions9, _actions.RESET_QB, { next: function next(state, _ref54) {
	        var payload = _ref54.payload;
	        return null;
	    } }), _defineProperty(_handleActions9, _actions.QUERY_COMPLETED, { next: function next(state, _ref55) {
	        var payload = _ref55.payload;
	        return payload.queryResults;
	    } }), _defineProperty(_handleActions9, _actions.QUERY_ERRORED, { next: function next(state, _ref56) {
	        var payload = _ref56.payload;
	        return payload ? payload : state;
	    } }), _handleActions9), null);
	
	// promise used for tracking a query execution in progress.  when a query is started we capture this.
	var cancelQueryDeferred = exports.cancelQueryDeferred = (0, _reduxActions.handleActions)((_handleActions10 = {}, _defineProperty(_handleActions10, _actions.RUN_QUERY, { next: function next(state, _ref57) {
	        var cancelQueryDeferred = _ref57.payload.cancelQueryDeferred;
	        return cancelQueryDeferred;
	    } }), _defineProperty(_handleActions10, _actions.CANCEL_QUERY, { next: function next(state, _ref58) {
	        var payload = _ref58.payload;
	        return null;
	    } }), _defineProperty(_handleActions10, _actions.QUERY_COMPLETED, { next: function next(state, _ref59) {
	        var payload = _ref59.payload;
	        return null;
	    } }), _defineProperty(_handleActions10, _actions.QUERY_ERRORED, { next: function next(state, _ref60) {
	        var payload = _ref60.payload;
	        return null;
	    } }), _handleActions10), null);
	
	var parameterValues = exports.parameterValues = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.SET_PARAMETER_VALUE, { next: function next(state, _ref61) {
	        var _ref61$payload = _ref61.payload,
	            id = _ref61$payload.id,
	            value = _ref61$payload.value;
	        return value == null ? (0, _icepick.dissoc)(state, id) : (0, _icepick.assoc)(state, id, value);
	    } }), {});
	
	var currentState = exports.currentState = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.SET_CURRENT_STATE, { next: function next(state, _ref62) {
	        var payload = _ref62.payload;
	        return payload;
	    } }), null);

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.cardPreviews = exports.formInput = exports.users = exports.cardList = exports.cards = exports.editingPulse = exports.pulseList = exports.pulses = undefined;
	
	var _handleActions, _handleActions3;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(658);
	
	var _redux = __webpack_require__(657);
	
	var _actions = __webpack_require__(1701);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var pulses = exports.pulses = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _actions.FETCH_PULSES, { next: function next(state, _ref) {
	        var payload = _ref.payload;
	        return _extends({}, (0, _redux.momentifyObjectsTimestamps)(payload.entities.pulse));
	    } }), _defineProperty(_handleActions, _actions.SAVE_PULSE, { next: function next(state, _ref2) {
	        var payload = _ref2.payload;
	        return _extends({}, state, _defineProperty({}, payload.id, (0, _redux.momentifyTimestamps)(payload)));
	    } }), _defineProperty(_handleActions, _actions.SAVE_EDITING_PULSE, { next: function next(state, _ref3) {
	        var payload = _ref3.payload;
	        return _extends({}, state, _defineProperty({}, payload.id, (0, _redux.momentifyTimestamps)(payload)));
	    } }), _handleActions), {});
	
	var pulseList = exports.pulseList = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.FETCH_PULSES, { next: function next(state, _ref4) {
	        var payload = _ref4.payload;
	        return payload.result;
	    } }), null);
	
	var editingPulse = exports.editingPulse = (0, _reduxActions.handleActions)((_handleActions3 = {}, _defineProperty(_handleActions3, _actions.SET_EDITING_PULSE, { next: function next(state, _ref5) {
	        var payload = _ref5.payload;
	        return payload;
	    } }), _defineProperty(_handleActions3, _actions.UPDATE_EDITING_PULSE, { next: function next(state, _ref6) {
	        var payload = _ref6.payload;
	        return payload;
	    } }), _defineProperty(_handleActions3, _actions.SAVE_EDITING_PULSE, { next: function next(state, _ref7) {
	        var payload = _ref7.payload;
	        return payload;
	    } }), _handleActions3), { name: null, cards: [], channels: [] });
	
	// NOTE: duplicated from dashboards/reducers.js
	var cards = exports.cards = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.FETCH_CARDS, { next: function next(state, _ref8) {
	        var payload = _ref8.payload;
	        return _extends({}, (0, _redux.momentifyObjectsTimestamps)(payload.entities.card));
	    } }), {});
	var cardList = exports.cardList = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.FETCH_CARDS, { next: function next(state, _ref9) {
	        var payload = _ref9.payload;
	        return payload.result;
	    } }), []);
	
	// NOTE: duplicated from admin/people/reducers.js
	var users = exports.users = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.FETCH_USERS, { next: function next(state, _ref10) {
	        var payload = _ref10.payload;
	        return _extends({}, (0, _redux.momentifyObjectsTimestamps)(payload.entities.user));
	    } }), []);
	
	var formInput = exports.formInput = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.FETCH_PULSE_FORM_INPUT, { next: function next(state, _ref11) {
	        var payload = _ref11.payload;
	        return payload;
	    } }), {});
	
	var cardPreviews = exports.cardPreviews = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.FETCH_PULSE_CARD_PREVIEW, { next: function next(state, _ref12) {
	        var payload = _ref12.payload;
	        return _extends({}, state, _defineProperty({}, payload.id, payload));
	    } }), {});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app-main.bundle.js?5515a08466bd22608a65